var YAHOO;(YAHOO=void 0!==YAHOO&&YAHOO?YAHOO:{}).namespace=function(){for(var e,n,t=arguments,r=null,i=0;i<t.length;i+=1)for(n=(""+t[i]).split("."),r=YAHOO,e="YAHOO"==n[0]?1:0;e<n.length;e+=1)r[n[e]]=r[n[e]]||{},r=r[n[e]];return r},YAHOO.log=function(e,n,t){var r=YAHOO.widget.Logger;return!(!r||!r.log)&&r.log(e,n,t)},YAHOO.register=function(e,n,t){var r,i,o,s=YAHOO.env.modules;for(s[e]||(s[e]={versions:[],builds:[]}),r=s[e],s=t.version,t=t.build,i=YAHOO.env.listeners,r.name=e,r.version=s,r.build=t,r.versions.push(s),r.builds.push(t),r.mainClass=n,o=0;o<i.length;o+=1)i[o](r);n?(n.VERSION=s,n.BUILD=t):YAHOO.log("mainClass is undefined for module "+e,"warn")},YAHOO.env=YAHOO.env||{modules:[],listeners:[]},YAHOO.env.getVersion=function(e){return YAHOO.env.modules[e]||null},YAHOO.env.parseUA=function(e){var n=function(e){var n=0;return parseFloat(e.replace(/\./g,function(){return 1==n++?"":"."}))},t=navigator,t={ie:0,opera:0,gecko:0,webkit:0,chrome:0,mobile:null,air:0,ipad:0,iphone:0,ipod:0,ios:null,android:0,webos:0,caja:t&&t.cajaVersion,secure:!1,os:null},e=e||navigator&&navigator.userAgent,r=window&&window.location,r=r&&r.href;return t.secure=r&&0===r.toLowerCase().indexOf("https"),e&&(/windows|win32/i.test(e)?t.os="windows":/macintosh/i.test(e)?t.os="macintosh":/rhino/i.test(e)&&(t.os="rhino"),/KHTML/.test(e)&&(t.webkit=1),(r=e.match(/AppleWebKit\/([^\s]*)/))&&r[1]&&(t.webkit=n(r[1]),/ Mobile\//.test(e)?(t.mobile="Apple",(r=e.match(/OS ([^\s]*)/))&&r[1]&&(r=n(r[1].replace("_","."))),t.ios=r,t.ipad=t.ipod=t.iphone=0,(r=e.match(/iPad|iPod|iPhone/))&&r[0]&&(t[r[0].toLowerCase()]=t.ios)):((r=e.match(/NokiaN[^\/]*|Android \d\.\d|webOS\/\d\.\d/))&&(t.mobile=r[0]),/webOS/.test(e)&&(t.mobile="WebOS",r=e.match(/webOS\/([^\s]*);/))&&r[1]&&(t.webos=n(r[1])),/ Android/.test(e)&&(t.mobile="Android",r=e.match(/Android ([^\s]*);/))&&r[1]&&(t.android=n(r[1]))),(r=e.match(/Chrome\/([^\s]*)/))&&r[1]?t.chrome=n(r[1]):(r=e.match(/AdobeAIR\/([^\s]*)/))&&(t.air=r[0])),t.webkit||((r=e.match(/Opera[\s\/]([^\s]*)/))&&r[1]?(t.opera=n(r[1]),(r=e.match(/Version\/([^\s]*)/))&&r[1]&&(t.opera=n(r[1])),(r=e.match(/Opera Mini[^;]*/))&&(t.mobile=r[0])):(r=e.match(/MSIE\s([^;]*)/))&&r[1]?t.ie=n(r[1]):(r=e.match(/Gecko\/([^\s]*)/))&&(t.gecko=1,r=e.match(/rv:([^\s\)]*)/))&&r[1]&&(t.gecko=n(r[1])))),t},YAHOO.env.ua=YAHOO.env.parseUA(),function(){if(YAHOO.namespace("util","widget","example"),"undefined"!=typeof YAHOO_config){var e,n=YAHOO_config.listener,t=YAHOO.env.listeners,r=!0;if(n){for(e=0;e<t.length;e++)if(t[e]==n){r=!1;break}r&&t.push(n)}}}(),YAHOO.lang=YAHOO.lang||{},function(){var f=YAHOO.lang,o=Object.prototype,a=[],n={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;","/":"&#x2F;","`":"&#x60;"},s=["toString","valueOf"],e={isArray:function(e){return"[object Array]"===o.toString.apply(e)},isBoolean:function(e){return"boolean"==typeof e},isFunction:function(e){return"function"==typeof e||"[object Function]"===o.toString.apply(e)},isNull:function(e){return null===e},isNumber:function(e){return"number"==typeof e&&isFinite(e)},isObject:function(e){return e&&("object"==typeof e||f.isFunction(e))||!1},isString:function(e){return"string"==typeof e},isUndefined:function(e){return void 0===e},_IEEnumFix:YAHOO.env.ua.ie?function(e,n){for(var t,r,i=0;i<s.length;i+=1)r=n[t=s[i]],f.isFunction(r)&&r!=o[t]&&(e[t]=r)}:function(){},escapeHTML:function(e){return e.replace(/[&<>"'\/`]/g,function(e){return n[e]})},extend:function(e,n,t){if(!n||!e)throw new Error("extend failed, please check that all dependencies are included.");var r,i=function(){};if(i.prototype=n.prototype,e.prototype=new i,(e.prototype.constructor=e).superclass=n.prototype,n.prototype.constructor==o.constructor&&(n.prototype.constructor=n),t){for(r in t)f.hasOwnProperty(t,r)&&(e.prototype[r]=t[r]);f._IEEnumFix(e.prototype,t)}},augmentObject:function(e,n){if(!n||!e)throw new Error("Absorb failed, verify dependencies.");var t,r,i=arguments,o=i[2];if(o&&!0!==o)for(t=2;t<i.length;t+=1)e[i[t]]=n[i[t]];else{for(r in n)!o&&r in e||(e[r]=n[r]);f._IEEnumFix(e,n)}return e},augmentProto:function(e,n){if(!n||!e)throw new Error("Augment failed, verify dependencies.");for(var t=[e.prototype,n.prototype],r=2;r<arguments.length;r+=1)t.push(arguments[r]);return f.augmentObject.apply(this,t),e},dump:function(e,n){var t,r,i=[];if(!f.isObject(e))return e+"";if(e instanceof Date||"nodeType"in e&&"tagName"in e)return e;if(f.isFunction(e))return"f(){...}";if(n=f.isNumber(n)?n:3,f.isArray(e)){for(i.push("["),t=0,r=e.length;t<r;t+=1)f.isObject(e[t])?i.push(0<n?f.dump(e[t],n-1):"{...}"):i.push(e[t]),i.push(", ");1<i.length&&i.pop(),i.push("]")}else{for(t in i.push("{"),e)f.hasOwnProperty(e,t)&&(i.push(t+" => "),f.isObject(e[t])?i.push(0<n?f.dump(e[t],n-1):"{...}"):i.push(e[t]),i.push(", "));1<i.length&&i.pop(),i.push("}")}return i.join("")},substitute:function(e,n,t,r){for(var i,o,s,u,a,c,p,l=[],O=e.length;!((i=e.lastIndexOf("{",O))<0||(o=e.indexOf("}",i))<i+1);)u=null,-1<(s=(c=a=e.substring(i+1,o)).indexOf(" "))&&(u=c.substring(s+1),c=c.substring(0,s)),s=n[c],t&&(s=t(c,s,u)),f.isObject(s)?s=f.isArray(s)||(-1<(c=(u=u||"").indexOf("dump"))&&(u=u.substring(4)),"[object Object]"===(p=s.toString()))||-1<c?f.dump(s,parseInt(u,10)):p:f.isString(s)||f.isNumber(s)||(s="~-"+l.length+"-~",l[l.length]=a),e=e.substring(0,i)+s+e.substring(o+1),!1===r&&(O=i-1);for(i=l.length-1;0<=i;i-=1)e=e.replace(new RegExp("~-"+i+"-~"),"{"+l[i]+"}","g");return e},trim:function(e){try{return e.replace(/^\s+|\s+$/g,"")}catch(n){return e}},merge:function(){for(var e={},n=arguments,t=n.length,r=0;r<t;r+=1)f.augmentObject(e,n[r],!0);return e},later:function(e,n,t,r,i){e=e||0,n=n||{};var o,s=t,u=r;if(s=f.isString(t)?n[t]:s)return f.isUndefined(r)||f.isArray(u)||(u=[r]),t=function(){s.apply(n,u||a)},o=(i?setInterval:setTimeout)(t,e),{interval:i,cancel:function(){(this.interval?clearInterval:clearTimeout)(o)}};throw new TypeError("method undefined")},isValue:function(e){return f.isObject(e)||f.isString(e)||f.isNumber(e)||f.isBoolean(e)}};f.hasOwnProperty=o.hasOwnProperty?function(e,n){return e&&e.hasOwnProperty&&e.hasOwnProperty(n)}:function(e,n){return!f.isUndefined(e[n])&&e.constructor.prototype[n]!==e[n]},e.augmentObject(f,e,!0),(YAHOO.util.Lang=f).augment=f.augmentProto,YAHOO.augment=f.augmentProto,YAHOO.extend=f.extend}(),YAHOO.register("yahoo",YAHOO,{version:"2.9.0",build:"2800"});
//# sourceMappingURL=yahoo.js.map;
!function(){YAHOO.env._id_counter=YAHOO.env._id_counter||0;var g=YAHOO.util,r=YAHOO.lang,t=YAHOO.env.ua,l=YAHOO.lang.trim,o={},n={},i=/^t(?:able|d|h)$/i,u=/color$/i,c=window.document,a=c.documentElement,s="ownerDocument",m="defaultView",f="documentElement",h="compatMode",D="parentNode",d="nodeType",p="tagName",b="getComputedStyle",y="currentStyle",C="CSS1Compat",_="class",A="className",O="",v=" ",S="position",B="relative",T="left",R="top",x=t.opera,e=t.webkit,Y=t.gecko,E=t.ie,H=(g.Dom={CUSTOM_ATTRIBUTES:a.hasAttribute?{htmlFor:"for",className:_}:{"for":"htmlFor","class":A},DOT_ATTRIBUTES:{checked:!0},get:function(t){var e,o,n,r,i,l,u=null;if(t){if("string"==typeof t||"number"==typeof t){if(e=t+"",l=(t=c.getElementById(t))?t.attributes:null,t&&l&&l.id&&l.id.value===e)return t;if(t&&c.all&&(t=null,o=c.all[e])&&o.length)for(r=0,i=o.length;r<i;++r)if(o[r].id===e)return o[r]}else if(g.Element&&t instanceof g.Element)t=t.get("element");else if(!t.nodeType&&"length"in t){for(n=[],r=0,i=t.length;r<i;++r)n[n.length]=g.Dom.get(t[r]);t=n}u=t}return u},getComputedStyle:function(t,e){return window[b]?t[s][m][b](t,null)[e]:t[y]?g.Dom.IE_ComputedStyle.get(t,e):void 0},getStyle:function(t,e){return g.Dom.batch(t,g.Dom._getStyle,e)},_getStyle:window[b]?function(t,e){e="float"===e?"cssFloat":g.Dom._toCamel(e);var o=t.style[e];return o||(t=t[s][m][b](t,null))&&(o=t[e]),o}:a[y]?function(t,e){var o;switch(e){case"opacity":o=100;try{o=t.filters["DXImageTransform.Microsoft.Alpha"].opacity}catch(n){try{o=t.filters("alpha").opacity}catch(r){}}return o/100;case"float":e="styleFloat";default:return e=g.Dom._toCamel(e),o=t[y]?t[y][e]:null,t.style[e]||o}}:void 0,setStyle:function(t,e,o){g.Dom.batch(t,g.Dom._setStyle,{prop:e,val:o})},_setStyle:!window.getComputedStyle&&c.documentElement.currentStyle?function(t,e){var o=g.Dom._toCamel(e.prop),n=e.val;if(t)switch(o){case"opacity":""===n||null===n||1===n?t.style.removeAttribute("filter"):r.isString(t.style.filter)&&(t.style.filter="alpha(opacity="+100*n+")",t[y]&&t[y].hasLayout||(t.style.zoom=1));break;case"float":o="styleFloat";default:t.style[o]=n}}:function(t,e){var o=g.Dom._toCamel(e.prop),e=e.val;t&&(t.style[o="float"==o?"cssFloat":o]=e)},getXY:function(t){return g.Dom.batch(t,g.Dom._getXY)},_canPosition:function(t){return"none"!==g.Dom._getStyle(t,"display")&&g.Dom._inDoc(t)},_getXY:function(t){var e,o,n=Math.round,r=!1;return g.Dom._canPosition(t)&&(o=t.getBoundingClientRect(),t=t[s],e=g.Dom.getDocumentScrollLeft(t),t=g.Dom.getDocumentScrollTop(t),r=[o[T],o[R]],(t||e)&&(r[0]+=e,r[1]+=t),r[0]=n(r[0]),r[1]=n(r[1])),r},getX:function(t){return g.Dom.batch(t,function(t){return g.Dom.getXY(t)[0]},g.Dom,!0)},getY:function(t){return g.Dom.batch(t,function(t){return g.Dom.getXY(t)[1]},g.Dom,!0)},setXY:function(t,e,o){g.Dom.batch(t,g.Dom._setXY,{pos:e,noRetry:o})},_setXY:function(t,e){var o=g.Dom._getStyle(t,S),n=g.Dom.setStyle,r=e.pos,e=e.noRetry,i=[parseInt(g.Dom.getComputedStyle(t,T),10),parseInt(g.Dom.getComputedStyle(t,R),10)],l=g.Dom._getXY(t);if(!r||!1===l)return!1;"static"==o&&n(t,S,o=B),isNaN(i[0])&&(i[0]=o==B?0:t.offsetLeft),isNaN(i[1])&&(i[1]=o==B?0:t.offsetTop),null!==r[0]&&n(t,T,r[0]-l[0]+i[0]+"px"),null!==r[1]&&n(t,R,r[1]-l[1]+i[1]+"px"),!e&&(o=g.Dom._getXY(t),null!==r[0]&&o[0]!=r[0]||null!==r[1]&&o[1]!=r[1])&&g.Dom._setXY(t,{pos:r,noRetry:!0})},setX:function(t,e){g.Dom.setXY(t,[e,null])},setY:function(t,e){g.Dom.setXY(t,[null,e])},getRegion:function(t){return g.Dom.batch(t,function(t){var e=!1;return e=g.Dom._canPosition(t)?g.Region.getRegion(t):e},g.Dom,!0)},getClientWidth:function(){return g.Dom.getViewportWidth()},getClientHeight:function(){return g.Dom.getViewportHeight()},getElementsByClassName:function(t,e,o,n,r,i){if(e=e||"*",!(o=o?g.Dom.get(o):c))return[];for(var l=[],u=o.getElementsByTagName(e),a=g.Dom.hasClass,s=0,m=u.length;s<m;++s)a(u[s],t)&&(l[l.length]=u[s]);return n&&g.Dom.batch(l,n,r,i),l},hasClass:function(t,e){return g.Dom.batch(t,g.Dom._hasClass,e)},_hasClass:function(t,e){var o=!1;return t&&e&&(t=(t=g.Dom._getAttribute(t,A)||O)&&t.replace(/\s+/g,v),o=e.exec?e.test(t):e&&-1<(v+t+v).indexOf(v+e+v)),o},addClass:function(t,e){return g.Dom.batch(t,g.Dom._addClass,e)},_addClass:function(t,e){var o,n=!1;return t&&e&&(o=g.Dom._getAttribute(t,A)||O,g.Dom._hasClass(t,e)||(g.Dom.setAttribute(t,A,l(o+v+e)),n=!0)),n},removeClass:function(t,e){return g.Dom.batch(t,g.Dom._removeClass,e)},_removeClass:function(t,e){var o,n=!1;return t&&e&&(o=g.Dom._getAttribute(t,A)||O,g.Dom.setAttribute(t,A,o.replace(g.Dom._getClassRegex(e),O)),o!==(e=g.Dom._getAttribute(t,A)))&&(g.Dom.setAttribute(t,A,l(e)),n=!0,""===g.Dom._getAttribute(t,A))&&(o=t.hasAttribute&&t.hasAttribute(_)?_:A,t.removeAttribute(o)),n},replaceClass:function(t,e,o){return g.Dom.batch(t,g.Dom._replaceClass,{from:e,to:o})},_replaceClass:function(t,e){var o,n,r,i=!1;return t&&e&&(o=e.from,(n=e.to)?o?o!==n&&(r=g.Dom._getAttribute(t,A)||O,(o=(v+r.replace(g.Dom._getClassRegex(o),v+n).replace(/\s+/g,v)).split(g.Dom._getClassRegex(n))).splice(1,0,v+n),g.Dom.setAttribute(t,A,l(o.join(O))),i=!0):i=g.Dom._addClass(t,e.to):i=!1),i},generateId:function(t,o){o=o||"yui-gen";var e=function(t){if(t&&t.id)return t.id;var e=o+YAHOO.env._id_counter++;if(t){if(t[s]&&t[s].getElementById(e))return g.Dom.generateId(t,e+o);t.id=e}return e};return g.Dom.batch(t,e,g.Dom,!0)||e.apply(g.Dom,arguments)},isAncestor:function(t,e){t=g.Dom.get(t),e=g.Dom.get(e);var o=!1;return t&&e&&t[d]&&e[d]&&(t.contains&&t!==e?o=t.contains(e):t.compareDocumentPosition&&(o=!!(16&t.compareDocumentPosition(e)))),o},inDocument:function(t,e){return g.Dom._inDoc(g.Dom.get(t),e)},_inDoc:function(t,e){var o=!1;return t&&t[p]&&(e=e||t[s],o=g.Dom.isAncestor(e[f],t)),o},getElementsBy:function(t,e,o,n,r,i,l){e=e||"*";var u=l?null:[];if(o=o?g.Dom.get(o):c){for(var a,s=0,m=(a=o.getElementsByTagName(e)).length;s<m;++s)if(t(a[s])){if(l){u=a[s];break}u[u.length]=a[s]}n&&g.Dom.batch(u,n,r,i)}return u},getElementBy:function(t,e,o){return g.Dom.getElementsBy(t,e,o,null,null,null,!0)},batch:function(t,e,o,n){var r=[],i=n?o:null;if(!(t=t&&(t[p]||t.item)?t:g.Dom.get(t))||!e)return!1;if(t[p]||t.length===undefined)return e.call(i,t,o);for(var l=0;l<t.length;++l)r[r.length]=e.call(i||t[l],t[l],o);return r},getDocumentHeight:function(){var t=(c[h]!=C||e?c.body:a).scrollHeight;return Math.max(t,g.Dom.getViewportHeight())},getDocumentWidth:function(){var t=(c[h]!=C||e?c.body:a).scrollWidth;return Math.max(t,g.Dom.getViewportWidth())},getViewportHeight:function(){var t=self.innerHeight,e=c[h];return t=!e&&!E||x?t:(e==C?a:c.body).clientHeight},getViewportWidth:function(){var t=self.innerWidth,e=c[h];return t=e||E?(e==C?a:c.body).clientWidth:t},getAncestorBy:function(t,e){for(;t=t[D];)if(g.Dom._testElement(t,e))return t;return null},getAncestorByClassName:function(t,e){return(t=g.Dom.get(t))?g.Dom.getAncestorBy(t,function(t){return g.Dom.hasClass(t,e)}):null},getAncestorByTagName:function(t,e){return(t=g.Dom.get(t))?g.Dom.getAncestorBy(t,function(t){return t[p]&&t[p].toUpperCase()==e.toUpperCase()}):null},getPreviousSiblingBy:function(t,e){for(;t;)if(t=t.previousSibling,g.Dom._testElement(t,e))return t;return null},getPreviousSibling:function(t){return(t=g.Dom.get(t))?g.Dom.getPreviousSiblingBy(t):null},getNextSiblingBy:function(t,e){for(;t;)if(t=t.nextSibling,g.Dom._testElement(t,e))return t;return null},getNextSibling:function(t){return(t=g.Dom.get(t))?g.Dom.getNextSiblingBy(t):null},getFirstChildBy:function(t,e){return(g.Dom._testElement(t.firstChild,e)?t.firstChild:null)||g.Dom.getNextSiblingBy(t.firstChild,e)},getFirstChild:function(t,e){return(t=g.Dom.get(t))?g.Dom.getFirstChildBy(t):null},getLastChildBy:function(t,e){return t?(g.Dom._testElement(t.lastChild,e)?t.lastChild:null)||g.Dom.getPreviousSiblingBy(t.lastChild,e):null},getLastChild:function(t){return t=g.Dom.get(t),g.Dom.getLastChildBy(t)},getChildrenBy:function(t,e){var t=g.Dom.getFirstChildBy(t,e),o=t?[t]:[];return g.Dom.getNextSiblingBy(t,function(t){return e&&!e(t)||(o[o.length]=t),!1}),o},getChildren:function(t){return t=g.Dom.get(t),g.Dom.getChildrenBy(t)},getDocumentScrollLeft:function(t){return t=t||c,Math.max(t[f].scrollLeft,t.body.scrollLeft)},getDocumentScrollTop:function(t){return t=t||c,Math.max(t[f].scrollTop,t.body.scrollTop)},insertBefore:function(t,e){return t=g.Dom.get(t),e=g.Dom.get(e),t&&e&&e[D]?e[D].insertBefore(t,e):null},insertAfter:function(t,e){return t=g.Dom.get(t),e=g.Dom.get(e),t&&e&&e[D]?e.nextSibling?e[D].insertBefore(t,e.nextSibling):e[D].appendChild(t):null},getClientRegion:function(){var t=g.Dom.getDocumentScrollTop(),e=g.Dom.getDocumentScrollLeft(),o=g.Dom.getViewportWidth()+e,n=g.Dom.getViewportHeight()+t;return new g.Region(t,o,n,e)},setAttribute:function(t,e,o){g.Dom.batch(t,g.Dom._setAttribute,{attr:e,val:o})},_setAttribute:function(t,e){var o=g.Dom._toCamel(e.attr),e=e.val;t&&t.setAttribute&&(g.Dom.DOT_ATTRIBUTES[o]&&t.tagName&&"BUTTON"!=t.tagName?t[o]=e:(o=g.Dom.CUSTOM_ATTRIBUTES[o]||o,t.setAttribute(o,e)))},getAttribute:function(t,e){return g.Dom.batch(t,g.Dom._getAttribute,e)},_getAttribute:function(t,e){var o;return e=g.Dom.CUSTOM_ATTRIBUTES[e]||e,g.Dom.DOT_ATTRIBUTES[e]?o=t[e]:t&&"getAttribute"in t&&(o=/^(?:href|src)$/.test(e)?t.getAttribute(e,2):t.getAttribute(e)),o},_toCamel:function(t){var e=o;return e[t]||(e[t]=-1===t.indexOf("-")?t:t.replace(/-([a-z])/gi,function(t,e){return e.toUpperCase()}))},_getClassRegex:function(t){var e;return t!==undefined&&(t.exec?e=t:(e=n[t])||(t=(t=t.replace(g.Dom._patterns.CLASS_RE_TOKENS,"\\$1")).replace(/\s+/g,v),e=n[t]=new RegExp("(?:^|\\s)"+t+"(?= |$)","g"))),e},_patterns:{ROOT_TAG:/^body|html$/i,CLASS_RE_TOKENS:/([\.\(\)\^\$\*\+\?\|\[\]\{\}\\])/g},_testElement:function(t,e){return t&&1==t[d]&&(!e||e(t))},_calcBorders:function(t,e){var o=parseInt(g.Dom[b](t,"borderTopWidth"),10)||0,n=parseInt(g.Dom[b](t,"borderLeftWidth"),10)||0;return Y&&i.test(t[p])&&(n=o=0),e[0]+=n,e[1]+=o,e}},g.Dom[b]);t.opera&&(g.Dom[b]=function(t,e){t=H(t,e);return t=u.test(e)?g.Dom.Color.toRGB(t):t}),t.webkit&&(g.Dom[b]=function(t,e){t=H(t,e);return t="rgba(0, 0, 0, 0)"===t?"transparent":t}),t.ie&&8<=t.ie&&(g.Dom.DOT_ATTRIBUTES.type=!0)}(),YAHOO.util.Region=function(t,e,o,n){this.top=t,this.y=t,this[1]=t,this.right=e,this.bottom=o,this.left=n,this.x=n,this[0]=n,this.width=this.right-this.left,this.height=this.bottom-this.top},YAHOO.util.Region.prototype.contains=function(t){return t.left>=this.left&&t.right<=this.right&&t.top>=this.top&&t.bottom<=this.bottom},YAHOO.util.Region.prototype.getArea=function(){return(this.bottom-this.top)*(this.right-this.left)},YAHOO.util.Region.prototype.intersect=function(t){var e=Math.max(this.top,t.top),o=Math.min(this.right,t.right),n=Math.min(this.bottom,t.bottom),t=Math.max(this.left,t.left);return e<=n&&t<=o?new YAHOO.util.Region(e,o,n,t):null},YAHOO.util.Region.prototype.union=function(t){var e=Math.min(this.top,t.top),o=Math.max(this.right,t.right),n=Math.max(this.bottom,t.bottom),t=Math.min(this.left,t.left);return new YAHOO.util.Region(e,o,n,t)},YAHOO.util.Region.prototype.toString=function(){return"Region {top: "+this.top+", right: "+this.right+", bottom: "+this.bottom+", left: "+this.left+", height: "+this.height+", width: "+this.width+"}"},YAHOO.util.Region.getRegion=function(t){var e=YAHOO.util.Dom.getXY(t),o=e[1],n=e[0]+t.offsetWidth,t=e[1]+t.offsetHeight,e=e[0];return new YAHOO.util.Region(o,n,t,e)},YAHOO.util.Point=function(t,e){YAHOO.lang.isArray(t)&&(e=t[1],t=t[0]),YAHOO.util.Point.superclass.constructor.call(this,e,t,e,t)},YAHOO.extend(YAHOO.util.Point,YAHOO.util.Region),function(){var n=YAHOO.util,r="clientTop",i="clientLeft",l="right",u="px",a="opacity",s="auto",m="borderLeftWidth",g="borderTopWidth",c="borderRightWidth",f="borderBottomWidth",h="style",D="currentStyle",d=/^width|height$/,p=/^(\d[.\d]*)+(em|ex|px|gd|rem|vw|vh|vm|ch|mm|cm|in|pt|pc|deg|rad|ms|s|hz|khz|%){1}?/i,t={get:function(t,e){var o=t[D][e];return e===a?n.Dom.getStyle(t,a):!o||o.indexOf&&-1<o.indexOf(u)?o:n.Dom.IE_COMPUTED[e]?n.Dom.IE_COMPUTED[e](t,e):p.test(o)?n.Dom.IE.ComputedStyle.getPixel(t,e):o},getOffset:function(t,e){var o,n=t[D][e],r=e.charAt(0).toUpperCase()+e.substr(1),i="offset"+r,r="pixel"+r,l="";return n==s?((o=t[i])===undefined&&(l=0),l=o,d.test(e)&&(t[h][e]=o,t[i]>o&&(l=o-(t[i]-o)),t[h][e]=s)):(t[h][r]||t[h][e]||(t[h][e]=n),l=t[h][r]),l+u},getBorderWidth:function(t,e){var o=null;switch(t[D].hasLayout||(t[h].zoom=1),e){case g:o=t[r];break;case f:o=t.offsetHeight-t.clientHeight-t[r];break;case m:o=t[i];break;case c:o=t.offsetWidth-t.clientWidth-t[i]}return o+u},getPixel:function(t,e){var o=t[D][l],e=t[D][e];return t[h][l]=e,e=t[h].pixelRight,t[h][l]=o,e+u},getMargin:function(t,e){t=t[D][e]==s?0+u:n.Dom.IE.ComputedStyle.getPixel(t,e);return t},getVisibility:function(t,e){for(var o;(o=t[D])&&"inherit"==o[e];)t=t.parentNode;return o?o[e]:"visible"},getColor:function(t,e){return n.Dom.Color.toRGB(t[D][e])||"transparent"},getBorderColor:function(t,e){t=t[D],e=t[e]||t.color;return n.Dom.Color.toRGB(n.Dom.Color.toHex(e))}},e={};e.top=e.right=e.bottom=e.left=e.width=e.height=t.getOffset,e.color=t.getColor,e[g]=e[c]=e[f]=e[m]=t.getBorderWidth,e.marginTop=e.marginRight=e.marginBottom=e.marginLeft=t.getMargin,e.visibility=t.getVisibility,e.borderColor=e.borderTopColor=e.borderRightColor=e.borderBottomColor=e.borderLeftColor=t.getBorderColor,n.Dom.IE_COMPUTED=e,n.Dom.IE_ComputedStyle=t}(),function(){var e=parseInt,o=RegExp,n=YAHOO.util;n.Dom.Color={KEYWORDS:{black:"000",silver:"c0c0c0",gray:"808080",white:"fff",maroon:"800000",red:"f00",purple:"800080",fuchsia:"f0f",green:"008000",lime:"0f0",olive:"808000",yellow:"ff0",navy:"000080",blue:"00f",teal:"008080",aqua:"0ff"},re_RGB:/^rgb\(([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\)$/i,re_hex:/^#?([0-9A-F]{2})([0-9A-F]{2})([0-9A-F]{2})$/i,re_hex3:/([0-9A-F])/gi,toRGB:function(t){return n.Dom.Color.re_RGB.test(t)||(t=n.Dom.Color.toHex(t)),t=n.Dom.Color.re_hex.exec(t)?"rgb("+[e(o.$1,16),e(o.$2,16),e(o.$3,16)].join(", ")+")":t},toHex:function(t){if(t=n.Dom.Color.KEYWORDS[t]||t,n.Dom.Color.re_RGB.exec(t)){t=[Number(o.$1).toString(16),Number(o.$2).toString(16),Number(o.$3).toString(16)];for(var e=0;e<t.length;e++)t[e].length<2&&(t[e]="0"+t[e]);t=t.join("")}return(t="transparent"!==(t=t.length<6?t.replace(n.Dom.Color.re_hex3,"$1$1"):t)&&t.indexOf("#")<0?"#"+t:t).toUpperCase()}}}(),YAHOO.register("dom",YAHOO.util.Dom,{version:"2.9.0",build:"2800"});
//# sourceMappingURL=dom.js.map;
YAHOO.util.CustomEvent=function(t,e,i,n,r){this.type=t,this.scope=e||window,this.silent=i,this.fireOnce=r,this.fired=!1,this.firedWith=null,this.signature=n||YAHOO.util.CustomEvent.LIST,this.subscribers=[],this.silent;e="_YUICEOnSubscribe";t!==e&&(this.subscribeEvent=new YAHOO.util.CustomEvent(e,this,!0)),this.lastError=null},YAHOO.util.CustomEvent.LIST=0,YAHOO.util.CustomEvent.FLAT=1,YAHOO.util.CustomEvent.prototype={subscribe:function(t,e,i){if(!t)throw new Error("Invalid callback for subscriber to '"+this.type+"'");this.subscribeEvent&&this.subscribeEvent.fire(t,e,i);i=new YAHOO.util.Subscriber(t,e,i);return this.fireOnce&&this.fired?this.notify(i,this.firedWith):this.subscribers.push(i),this.unsubscribe.bind(this,t,e)},unsubscribe:function(t,e){if(!t)return this.unsubscribeAll();for(var i=!1,n=0,r=this.subscribers.length;n<r;++n){var s=this.subscribers[n];s&&s.contains(t,e)&&(this._delete(n),i=!0)}return i},fire:function(){this.lastError=null;var t=this.subscribers.length,e=[].slice.call(arguments,0),i=!0;if(this.fireOnce){if(this.fired)return!0;this.firedWith=e}if(this.fired=!0,!t&&this.silent)return!0;this.silent;for(var n=this.subscribers.slice(),r=0;r<t;++r){var s=n[r];if(s&&s.fn&&!1===(i=this.notify(s,e))){this.silent;break}}return!1!==i},notify:function(t,e){var i,n=null,r=t.getScope(this.scope),s=YAHOO.util.Event.throwErrors;if(this.silent,this.signature==YAHOO.util.CustomEvent.FLAT){0<e.length&&(n=e[0]);try{i=t.fn.call(r,n,t.obj)}catch(o){if(this.lastError=o,s)throw o}}else try{i=t.fn.call(r,this.type,e,t.obj)}catch(u){if(this.lastError=u,s)throw u}return i},unsubscribeAll:function(){for(var t=this.subscribers.length,e=t-1;-1<e;e--)this._delete(e);return this.subscribers=[],t},_delete:function(t){var e=this.subscribers[t];e&&(delete e.fn,delete e.obj),this.subscribers.splice(t,1)},toString:function(){return"CustomEvent: '"+this.type+"', context: "+this.scope}},YAHOO.util.Subscriber=function(t,e,i){this.fn=t,this.obj=YAHOO.lang.isUndefined(e)?null:e,this.overrideContext=i},YAHOO.util.Subscriber.prototype.getScope=function(t){return this.overrideContext?!0===this.overrideContext?this.obj:this.overrideContext:t},YAHOO.util.Subscriber.prototype.contains=function(t,e){return e?this.fn==t&&this.obj==e:this.fn==t},YAHOO.util.Subscriber.prototype.toString=function(){return"Subscriber { obj: "+this.obj+", overrideContext: "+(this.overrideContext||"no")+" }"},YAHOO.util.Event||(YAHOO.util.Event=function(){var l=!1,f=[],v=[],a=0,c=[],i=0,e={63232:38,63233:40,63234:37,63235:39,63276:33,63277:34,25:9},t=YAHOO.env.ua.ie,o="focusin",u="focusout";return{POLL_RETRYS:500,POLL_INTERVAL:40,EL:0,TYPE:1,FN:2,WFN:3,UNLOAD_OBJ:3,ADJ_SCOPE:4,OBJ:5,OVERRIDE:6,CAPTURE:7,lastError:null,isSafari:YAHOO.env.ua.webkit,webkit:YAHOO.env.ua.webkit,isIE:t,_interval:null,_dri:null,_specialTypes:{focusin:t?"focusin":"focus",focusout:t?"focusout":"blur"},DOMReady:!1,throwErrors:!1,startInterval:function(){this._interval||(this._interval=YAHOO.lang.later(this.POLL_INTERVAL,this,this._tryPreloadAttach,null,!0))},onAvailable:function(t,e,i,n,r){for(var s=YAHOO.lang.isString(t)?[t]:t,o=0;o<s.length;o+=1)c.push({id:s[o],fn:e,obj:i,overrideContext:n,checkReady:r});a=this.POLL_RETRYS,this.startInterval()},onContentReady:function(t,e,i,n){this.onAvailable(t,e,i,n,!0)},onDOMReady:function(){this.DOMReadyEvent.subscribe.apply(this.DOMReadyEvent,arguments)},_addListener:function(e,t,i,n,r,s){if(!i||!i.call)return!1;if(this._isValidCollection(e)){for(var o=!0,u=0,l=e.length;u<l;++u)o=this.on(e[u],t,i,n,r)&&o;return o}if(YAHOO.lang.isString(e)){var a=this.getEl(e);if(!a)return this.onAvailable(e,function(){YAHOO.util.Event._addListener(e,t,i,n,r,s)}),!0;e=a}if(!e)return!1;if("unload"==t&&n!==this)v[v.length]=[e,t,i,n,r];else{var c=e,a=function(t){return i.call(c,YAHOO.util.Event.getEvent(t,e),n)},h=[e,t,i,a,c=r?!0===r?n:r:c,n,r,s];f[f.length]=h;try{this._simpleAdd(e,t,a,s)}catch(d){return this.lastError=d,this.removeListener(e,t,i),!1}}return!0},_getType:function(t){return this._specialTypes[t]||t},addListener:function(t,e,i,n,r){var s=!(e!=o&&e!=u||YAHOO.env.ua.ie);return this._addListener(t,this._getType(e),i,n,r,s)},addFocusListener:function(t,e,i,n){return this.on(t,o,e,i,n)},removeFocusListener:function(t,e){return this.removeListener(t,o,e)},addBlurListener:function(t,e,i,n){return this.on(t,u,e,i,n)},removeBlurListener:function(t,e){return this.removeListener(t,u,e)},removeListener:function(t,e,i){var n;if(e=this._getType(e),"string"==typeof t)t=this.getEl(t);else if(this._isValidCollection(t)){for(var r=!0,s=t.length-1;-1<s;s--)r=this.removeListener(t[s],e,i)&&r;return r}if(!i||!i.call)return this.purgeElement(t,!1,e);if("unload"==e){for(s=v.length-1;-1<s;s--)if((n=v[s])&&n[0]==t&&n[1]==e&&n[2]==i)return v.splice(s,1),!0;return!1}var o=null,u=arguments[3];if(0<=(u=void 0===u?this._getCacheIndex(f,t,e,i):u)&&(o=f[u]),!t||!o)return!1;var l=!0===o[this.CAPTURE];try{this._simpleRemove(t,e,o[this.WFN],l)}catch(a){return this.lastError=a,!1}return delete f[u][this.WFN],delete f[u][this.FN],f.splice(u,1),!0},getTarget:function(t,e){t=t.target||t.srcElement;return this.resolveTextNode(t)},resolveTextNode:function(t){try{if(t&&3==t.nodeType)return t.parentNode}catch(e){return null}return t},getPageX:function(t){var e=t.pageX;return e||0===e||(e=t.clientX||0,this.isIE&&(e+=this._getScrollLeft())),e},getPageY:function(t){var e=t.pageY;return e||0===e||(e=t.clientY||0,this.isIE&&(e+=this._getScrollTop())),e},getXY:function(t){return[this.getPageX(t),this.getPageY(t)]},getRelatedTarget:function(t){var e=t.relatedTarget;return e||("mouseout"==t.type?e=t.toElement:"mouseover"==t.type&&(e=t.fromElement)),this.resolveTextNode(e)},getTime:function(t){if(!t.time){var e=(new Date).getTime();try{t.time=e}catch(i){return this.lastError=i,e}}return t.time},stopEvent:function(t){this.stopPropagation(t),this.preventDefault(t)},stopPropagation:function(t){t.stopPropagation?t.stopPropagation():t.cancelBubble=!0},preventDefault:function(t){t.preventDefault?t.preventDefault():t.returnValue=!1},getEvent:function(t,e){var i=t||window.event;if(!i)for(var n=this.getEvent.caller;n&&(!(i=n.arguments[0])||Event!=i.constructor);)n=n.caller;return i},getCharCode:function(t){t=t.keyCode||t.charCode||0;return t=YAHOO.env.ua.webkit&&t in e?e[t]:t},_getCacheIndex:function(t,e,i,n){for(var r=0,s=t.length;r<s;r+=1){var o=t[r];if(o&&o[this.FN]==n&&o[this.EL]==e&&o[this.TYPE]==i)return r}return-1},generateId:function(t){var e=t.id;return e||(e="yuievtautoid-"+i,++i,t.id=e),e},_isValidCollection:function(t){try{return t&&"string"!=typeof t&&t.length&&!t.tagName&&!t.alert&&"undefined"!=typeof t[0]}catch(e){return!1}},elCache:{},getEl:function(t){return"string"==typeof t?document.getElementById(t):t},clearCache:function(){},DOMReadyEvent:new YAHOO.util.CustomEvent("DOMReady",YAHOO,0,0,1),_load:function(t){var e;l||(l=!0,(e=YAHOO.util.Event)._ready(),e._tryPreloadAttach())},_ready:function(t){var e=YAHOO.util.Event;e.DOMReady||(e.DOMReady=!0,e.DOMReadyEvent.fire(),e._simpleRemove(document,"DOMContentLoaded",e._ready))},_tryPreloadAttach:function(){if(0===c.length)a=0,this._interval&&(this._interval.cancel(),this._interval=null);else if(!this.locked)if(this.isIE&&!this.DOMReady)this.startInterval();else{this.locked=!0;for(var t,e,i=(i=!l)||0<a&&0<c.length,n=[],r=function(t,e){e.overrideContext&&(t=!0===e.overrideContext?e.obj:e.overrideContext),e.fn.call(t,e.obj)},s=[],o=0,u=c.length;o<u;o+=1)(t=c[o])&&((e=this.getEl(t.id))?t.checkReady?!l&&!e.nextSibling&&i||(s.push(t),c[o]=null):(r(e,t),c[o]=null):n.push(t));for(o=0,u=s.length;o<u;o+=1)r(this.getEl((t=s[o]).id),t);if(a--,i){for(o=c.length-1;-1<o;o--)(t=c[o])&&t.id||c.splice(o,1);this.startInterval()}else this._interval&&(this._interval.cancel(),this._interval=null);this.locked=!1}},purgeElement:function(t,e,i){var n,r,s=YAHOO.lang.isString(t)?this.getEl(t):t,o=this.getListeners(s,i);if(o)for(n=o.length-1;-1<n;n--){var u=o[n];this.removeListener(s,u.type,u.fn)}if(e&&s&&s.childNodes)for(n=0,r=s.childNodes.length;n<r;++n)this.purgeElement(s.childNodes[n],e,i)},getListeners:function(t,e){for(var i=[],n=e?"unload"===e?[v]:(e=this._getType(e),[f]):[f,v],r=YAHOO.lang.isString(t)?this.getEl(t):t,s=0;s<n.length;s+=1){var o=n[s];if(o)for(var u=0,l=o.length;u<l;++u){var a=o[u];!a||a[this.EL]!==r||e&&e!==a[this.TYPE]||i.push({type:a[this.TYPE],fn:a[this.FN],obj:a[this.OBJ],adjust:a[this.OVERRIDE],scope:a[this.ADJ_SCOPE],index:u})}}return i.length?i:null},_unload:function(t){for(var e,i,n,r=YAHOO.util.Event,s=v.slice(),o=0,u=v.length;o<u;++o)if(i=s[o]){try{n=window,i[r.ADJ_SCOPE]&&(n=!0===i[r.ADJ_SCOPE]?i[r.UNLOAD_OBJ]:i[r.ADJ_SCOPE]),i[r.FN].call(n,r.getEvent(t,i[r.EL]),i[r.UNLOAD_OBJ])}catch(l){}s[o]=null}if(v=n=i=null,f){for(e=f.length-1;-1<e;e--)if(i=f[e])try{r.removeListener(i[r.EL],i[r.TYPE],i[r.FN],e)}catch(a){}i=null}try{r._simpleRemove(window,"unload",r._unload),r._simpleRemove(window,"load",r._load)}catch(c){}},_getScrollLeft:function(){return this._getScroll()[1]},_getScrollTop:function(){return this._getScroll()[0]},_getScroll:function(){var t=document.documentElement,e=document.body;return t&&(t.scrollTop||t.scrollLeft)?[t.scrollTop,t.scrollLeft]:e?[e.scrollTop,e.scrollLeft]:[0,0]},regCE:function(){},_simpleAdd:window.addEventListener?function(t,e,i,n){t.addEventListener(e,i,n)}:window.attachEvent?function(t,e,i,n){t.attachEvent("on"+e,i)}:function(){},_simpleRemove:window.removeEventListener?function(t,e,i,n){t.removeEventListener(e,i,n)}:window.detachEvent?function(t,e,i){t.detachEvent("on"+e,i)}:function(){}}}(),function(){var e=YAHOO.util.Event;e.on=e.addListener,e.onFocus=e.addFocusListener,e.onBlur=e.addBlurListener,e.isIE?self!==self.top?document.onreadystatechange=function(){"complete"==document.readyState&&(document.onreadystatechange=null,e._ready())}:(YAHOO.util.Event.onDOMReady(YAHOO.util.Event._tryPreloadAttach,YAHOO.util.Event,!0),document.onreadystatechange=function(){"complete"==document.readyState&&(document.onreadystatechange=null,e._dri=setInterval(function(){try{document.documentElement.doScroll("left"),clearInterval(e._dri),e._dri=null,e._ready()}catch(t){}},e.POLL_INTERVAL))}):e.webkit&&e.webkit<525?e._dri=setInterval(function(){var t=document.readyState;"loaded"!=t&&"complete"!=t||(clearInterval(e._dri),e._dri=null,e._ready())},e.POLL_INTERVAL):e._simpleAdd(document,"DOMContentLoaded",e._ready),e._simpleAdd(window,"load",e._load),e._simpleAdd(window,"unload",e._unload),e._tryPreloadAttach()}()),YAHOO.util.EventProvider=function(){},YAHOO.util.EventProvider.prototype={__yui_events:null,__yui_subscribers:null,subscribe:function(t,e,i,n){this.__yui_events=this.__yui_events||{};var r=this.__yui_events[t];r?r.subscribe(e,i,n):(this.__yui_subscribers=this.__yui_subscribers||{},(r=this.__yui_subscribers)[t]||(r[t]=[]),r[t].push({fn:e,obj:i,overrideContext:n}))},unsubscribe:function(t,e,i){this.__yui_events=this.__yui_events||{};var n=this.__yui_events;if(t)return!!(t=n[t])&&t.unsubscribe(e,i);var r,s=!0;for(r in n)YAHOO.lang.hasOwnProperty(n,r)&&(s=s&&n[r].unsubscribe(e,i));return s},unsubscribeAll:function(t){return this.unsubscribe(t)},createEvent:function(t,e){this.__yui_events=this.__yui_events||{};var i,e=e||{},n=this.__yui_events;if(!n[t]){i=new YAHOO.util.CustomEvent(t,e.scope||this,e.silent,YAHOO.util.CustomEvent.FLAT,e.fireOnce),n[t]=i,e.onSubscribeCallback&&i.subscribeEvent.subscribe(e.onSubscribeCallback),this.__yui_subscribers=this.__yui_subscribers||{};var r=this.__yui_subscribers[t];if(r)for(var s=0;s<r.length;++s)i.subscribe(r[s].fn,r[s].obj,r[s].overrideContext)}return n[t]},fireEvent:function(t){this.__yui_events=this.__yui_events||{};var e=this.__yui_events[t];if(!e)return null;for(var i=[],n=1;n<arguments.length;++n)i.push(arguments[n]);return e.fire.apply(e,i)},hasEvent:function(t){return!(!this.__yui_events||!this.__yui_events[t])}},function(){var u=YAHOO.util.Event,r=YAHOO.lang,t=(YAHOO.util.KeyListener=function(t,s,e,i){i=i||YAHOO.util.KeyListener.KEYDOWN;var o=new YAHOO.util.CustomEvent("keyPressed");function n(t,e){if(s.shift||(s.shift=!1),s.alt||(s.alt=!1),s.ctrl||(s.ctrl=!1),t.shiftKey==s.shift&&t.altKey==s.alt&&t.ctrlKey==s.ctrl){var i,n=s.keys;if(YAHOO.lang.isArray(n)){for(var r=0;r<n.length;r++)if(n[r]==(i=u.getCharCode(t))){o.fire(i,t);break}}else n==(i=u.getCharCode(t))&&o.fire(i,t)}}this.enabledEvent=new YAHOO.util.CustomEvent("enabled"),this.disabledEvent=new YAHOO.util.CustomEvent("disabled"),r.isString(t)&&(t=document.getElementById(t)),r.isFunction(e)?o.subscribe(e):o.subscribe(e.fn,e.scope,e.correctScope),this.enable=function(){this.enabled||(u.on(t,i,n),this.enabledEvent.fire(s)),this.enabled=!0},this.disable=function(){this.enabled&&(u.removeListener(t,i,n),this.disabledEvent.fire(s)),this.enabled=!1},this.toString=function(){return"KeyListener ["+s.keys+"] "+t.tagName+(t.id?"["+t.id+"]":"")}},YAHOO.util.KeyListener);t.KEYDOWN="keydown",t.KEYUP="keyup",t.KEY={ALT:18,BACK_SPACE:8,CAPS_LOCK:20,CONTROL:17,DELETE:46,DOWN:40,END:35,ENTER:13,ESCAPE:27,HOME:36,LEFT:37,META:224,NUM_LOCK:144,PAGE_DOWN:34,PAGE_UP:33,PAUSE:19,PRINTSCREEN:44,RIGHT:39,SCROLL_LOCK:145,SHIFT:16,SPACE:32,TAB:9,UP:38}}(),YAHOO.register("event",YAHOO.util.Event,{version:"2.9.0",build:"2800"});
//# sourceMappingURL=event-patch.js.map;
!function(){var g=YAHOO.util.Event,s=YAHOO.lang,o=[],O=function(e,t,r){e=!(!e||e===r)&&(YAHOO.util.Selector.test(e,t)?e:O(e.parentNode,t,r));return e};s.augmentObject(g,{_createDelegate:function(u,a,c,o){return function(e){var t,r=this,n=g.getTarget(e),i=a,l=9===r.nodeType;if(s.isFunction(a)?t=a(n):s.isString(a)&&(l||(i=((l="#"+(r.id||g.generateId(r))+" ")+a).replace(/,/gi,","+l)),YAHOO.util.Selector.test(n,i)?t=n:YAHOO.util.Selector.test(n,i.replace(/,/gi," *,")+" *")&&(t=O(n,i,r))),t)return u.call(o?!0===o?c:o:t,e,t,r,c)}},delegate:function(e,t,r,n,i,l){var u,a,c=t;if(s.isString(n)&&!YAHOO.util.Selector)return!1;if("mouseenter"==t||"mouseleave"==t){if(!g._createMouseDelegate)return!1;c=g._getType(t),u=g._createMouseDelegate(r,i,l),a=g._createDelegate(function(e,t,r){return u.call(t,e,r)},n,i,l)}else a=g._createDelegate(r,n,i,l);return o.push([e,c,r,a]),g.on(e,c,a)},removeDelegate:function(e,t,r){var n,i=t,l=!1;return"mouseenter"!=t&&"mouseleave"!=t||(i=g._getType(t)),0<=(t=g._getCacheIndex(o,e,i,r))&&(n=o[t]),e&&n&&(l=g.removeListener(n[0],n[1],n[3]))&&(delete o[t][2],delete o[t][3],o.splice(t,1)),l}})}(),YAHOO.register("event-delegate",YAHOO.util.Event,{version:"2.9.0",build:"2800"});
//# sourceMappingURL=event-delegate.js.map;
!function(){var i=YAHOO.util.Event,e=YAHOO.lang,l=i.addListener,s=i.removeListener,o=i.getListeners,a=[],c={mouseenter:"mouseover",mouseleave:"mouseout"};e.augmentObject(i._specialTypes,c),e.augmentObject(i,{_createMouseDelegate:function(u,s,l){return function(e,t){var n=this,r=i.getRelatedTarget(e);if(n!=r&&!YAHOO.util.Dom.isAncestor(n,r))return r=l?!0===l?s:l:n,e=[e,s],t&&e.splice(1,0,n,t),u.apply(r,e)}},addListener:function(e,t,n,r,u){var s=c[t]?((s=i._createMouseDelegate(n,r,u)).mouseDelegate=!0,a.push([e,t,n,s]),l.call(i,e,t,s)):l.apply(i,arguments);return s},removeListener:function(e,t,n){var r=(c[t]?function(e,t,n){var r,u,n=i._getCacheIndex(a,e,t,n);return 0<=n&&(r=a[n]),e&&r&&(u=s.call(i,r[0],t,r[3]))&&(delete a[n][2],delete a[n][3],a.splice(n,1)),u}:s).apply(i,arguments);return r},getListeners:function(e,t){var n,r,u,s,l=[],a="mouseover"===t||"mouseout"===t;if(t&&(a||c[t])){if(n=o.call(i,e,this._getType(t)))for(u=n.length-1;-1<u;u--)r=(s=n[u]).fn.mouseDelegate,(c[t]&&r||a&&!r)&&l.push(s)}else l=o.apply(i,arguments);return l&&l.length?l:null}},!0),i.on=i.addListener}(),YAHOO.register("event-mouseenter",YAHOO.util.Event,{version:"2.9.0",build:"2800"});
//# sourceMappingURL=event-mouseenter.js.map;
YAHOO.util.Attribute=function(t,e){e&&(this.owner=e,this.configure(t,!0))},YAHOO.util.Attribute.INVALID_VALUE={},YAHOO.util.Attribute.prototype={name:undefined,value:null,owner:null,readOnly:!1,writeOnce:!1,_initialConfig:null,_written:!1,method:null,setter:null,getter:null,validator:null,getValue:function(){var t=this.value;return t=this.getter?this.getter.call(this.owner,this.name,t):t},setValue:function(t,e){var i=this.owner,n=this.name,s=YAHOO.util.Attribute.INVALID_VALUE,r={type:n,prevValue:this.getValue(),newValue:t};return!(this.readOnly||this.writeOnce&&this._written||this.validator&&!this.validator.call(i,t)||!e&&!1===i.fireBeforeChangeEvent(r)||this.setter&&(t=this.setter.call(i,t,this.name),undefined,t===s)||this.method&&this.method.call(i,t,this.name)===s||(this.value=t,this._written=!0,r.type=n,e||this.owner.fireChangeEvent(r),0))},configure:function(t,e){for(var i in t=t||{},e&&(this._written=!1),this._initialConfig=this._initialConfig||{},t)t.hasOwnProperty(i)&&(this[i]=t[i],e)&&(this._initialConfig[i]=t[i])},resetValue:function(){return this.setValue(this._initialConfig.value)},resetConfig:function(){this.configure(this._initialConfig,!0)},refresh:function(t){this.setValue(this.value,t)}},function(){var r=YAHOO.util.Lang;YAHOO.util.AttributeProvider=function(){},YAHOO.util.AttributeProvider.prototype={_configs:null,get:function(t){this._configs=this._configs||{};var e=this._configs[t];return e&&this._configs.hasOwnProperty(t)?e.getValue():null},set:function(t,e,i){this._configs=this._configs||{};t=this._configs[t];return!!t&&t.setValue(e,i)},getAttributeKeys:function(){this._configs=this._configs;var t,e=[];for(t in this._configs)r.hasOwnProperty(this._configs,t)&&!r.isUndefined(this._configs[t])&&(e[e.length]=t);return e},setAttributes:function(t,e){for(var i in t)r.hasOwnProperty(t,i)&&this.set(i,t[i],e)},resetValue:function(t,e){return this._configs=this._configs||{},!!this._configs[t]&&(this.set(t,this._configs[t]._initialConfig.value,e),!0)},refresh:function(t,e){this._configs=this._configs||{};for(var i=this._configs,n=0,s=(t=(r.isString(t)?[t]:t)||this.getAttributeKeys()).length;n<s;++n)i.hasOwnProperty(t[n])&&this._configs[t[n]].refresh(e)},register:function(t,e){this.setAttributeConfig(t,e)},getAttributeConfig:function(t){this._configs=this._configs||{};var e=this._configs[t]||{},i={};for(t in e)r.hasOwnProperty(e,t)&&(i[t]=e[t]);return i},setAttributeConfig:function(t,e,i){this._configs=this._configs||{},e=e||{},this._configs[t]?this._configs[t].configure(e,i):(e.name=t,this._configs[t]=this.createAttribute(e))},configureAttribute:function(t,e,i){this.setAttributeConfig(t,e,i)},resetAttributeConfig:function(t){this._configs=this._configs||{},this._configs[t].resetConfig()},subscribe:function(t,e){this._events=this._events||{},t in this._events||(this._events[t]=this.createEvent(t)),YAHOO.util.EventProvider.prototype.subscribe.apply(this,arguments)},on:function(){this.subscribe.apply(this,arguments)},addListener:function(){this.subscribe.apply(this,arguments)},fireBeforeChangeEvent:function(t){var e="before";return e+=t.type.charAt(0).toUpperCase()+t.type.substr(1)+"Change",t.type=e,this.fireEvent(t.type,t)},fireChangeEvent:function(t){return t.type+="Change",this.fireEvent(t.type,t)},createAttribute:function(t){return new YAHOO.util.Attribute(t,this)}},YAHOO.augment(YAHOO.util.AttributeProvider,YAHOO.util.EventProvider)}(),function(){var r=YAHOO.util.Dom,s=YAHOO.util.AttributeProvider,u={mouseenter:!0,mouseleave:!0},o=function(t,e){this.init.apply(this,arguments)};o.DOM_EVENTS={click:!0,dblclick:!0,keydown:!0,keypress:!0,keyup:!0,mousedown:!0,mousemove:!0,mouseout:!0,mouseover:!0,mouseup:!0,mouseenter:!0,mouseleave:!0,focus:!0,blur:!0,submit:!0,change:!0},o.prototype={DOM_EVENTS:null,DEFAULT_HTML_SETTER:function(t,e){var i=this.get("element");return i&&(i[e]=t),t},DEFAULT_HTML_GETTER:function(t){var e,i=this.get("element");return e=i?i[t]:e},appendChild:function(t){return t=t.get?t.get("element"):t,this.get("element").appendChild(t)},getElementsByTagName:function(t){return this.get("element").getElementsByTagName(t)},hasChildNodes:function(){return this.get("element").hasChildNodes()},insertBefore:function(t,e){return t=t.get?t.get("element"):t,e=e&&e.get?e.get("element"):e,this.get("element").insertBefore(t,e)},removeChild:function(t){return t=t.get?t.get("element"):t,this.get("element").removeChild(t)},replaceChild:function(t,e){return t=t.get?t.get("element"):t,e=e.get?e.get("element"):e,this.get("element").replaceChild(t,e)},initAttributes:function(t){},addListener:function(i,t,e,n){n=n||this;var s=YAHOO.util.Event,r=this.get("element")||this.get("id"),o=this;return!(u[i]&&!s._createMouseDelegate)&&(this._events[i]||(r&&this.DOM_EVENTS[i]&&s.on(r,i,function(t,e){t.srcElement&&!t.target&&(t.target=t.srcElement),(t.toElement&&!t.relatedTarget||t.fromElement&&!t.relatedTarget)&&(t.relatedTarget=s.getRelatedTarget(t)),t.currentTarget||(t.currentTarget=r),o.fireEvent(i,t,e)},e,n),this.createEvent(i,{scope:this})),YAHOO.util.EventProvider.prototype.subscribe.apply(this,arguments))},on:function(){return this.addListener.apply(this,arguments)},subscribe:function(){return this.addListener.apply(this,arguments)},removeListener:function(t,e){return this.unsubscribe.apply(this,arguments)},addClass:function(t){r.addClass(this.get("element"),t)},getElementsByClassName:function(t,e){return r.getElementsByClassName(t,e,this.get("element"))},hasClass:function(t){return r.hasClass(this.get("element"),t)},removeClass:function(t){return r.removeClass(this.get("element"),t)},replaceClass:function(t,e){return r.replaceClass(this.get("element"),t,e)},setStyle:function(t,e){return r.setStyle(this.get("element"),t,e)},getStyle:function(t){return r.getStyle(this.get("element"),t)},fireQueue:function(){for(var t=this._queue,e=0,i=t.length;e<i;++e)this[t[e][0]].apply(this,t[e][1])},appendTo:function(t,e){t=t.get?t.get("element"):r.get(t),this.fireEvent("beforeAppendTo",{type:"beforeAppendTo",target:t}),e=e&&e.get?e.get("element"):r.get(e);var i=this.get("element");return!!i&&!!t&&(i.parent!=t&&(e?t.insertBefore(i,e):t.appendChild(i)),this.fireEvent("appendTo",{type:"appendTo",target:t}),i)},get:function(t){var e=this._configs||{},i=e.element;return!i||e[t]||YAHOO.lang.isUndefined(i.value[t])||this._setHTMLAttrConfig(t),s.prototype.get.call(this,t)},setAttributes:function(t,e){for(var i,n={},s=this._configOrder,r=0,o=s.length;r<o;++r)t[s[r]]!==undefined&&(n[s[r]]=!0,this.set(s[r],t[s[r]],e));for(i in t)t.hasOwnProperty(i)&&!n[i]&&this.set(i,t[i],e)},set:function(t,e,i){var n=this.get("element");if(n)return this._configs[t]||YAHOO.lang.isUndefined(n[t])||this._setHTMLAttrConfig(t),s.prototype.set.apply(this,arguments);this._queue[this._queue.length]=["set",arguments],this._configs[t]&&(this._configs[t].value=e)},setAttributeConfig:function(t,e,i){this._configOrder.push(t),s.prototype.setAttributeConfig.apply(this,arguments)},createEvent:function(t,e){return this._events[t]=!0,s.prototype.createEvent.apply(this,arguments)},init:function(t,e){this._initElement(t,e)},destroy:function(){var t=this.get("element");YAHOO.util.Event.purgeElement(t,!0),this.unsubscribeAll(),t&&t.parentNode&&t.parentNode.removeChild(t),this._queue=[],this._events={},this._configs={},this._configOrder=[]},_initElement:function(t,e){this._queue=this._queue||[],this._events=this._events||{},this._configs=this._configs||{},this._configOrder=[],(e=e||{}).element=e.element||t||null;var i,n=!1,s=o.DOM_EVENTS;for(i in this.DOM_EVENTS=this.DOM_EVENTS||{},s)s.hasOwnProperty(i)&&(this.DOM_EVENTS[i]=s[i]);"string"==typeof e.element&&this._setHTMLAttrConfig("id",{value:e.element}),r.get(e.element)&&(n=!0,this._initHTMLElement(e),this._initContent(e)),YAHOO.util.Event.onAvailable(e.element,function(){n||this._initHTMLElement(e),this.fireEvent("available",{type:"available",target:r.get(e.element)})},this,!0),YAHOO.util.Event.onContentReady(e.element,function(){n||this._initContent(e),this.fireEvent("contentReady",{type:"contentReady",target:r.get(e.element)})},this,!0)},_initHTMLElement:function(t){this.setAttributeConfig("element",{value:r.get(t.element),readOnly:!0})},_initContent:function(t){this.initAttributes(t),this.setAttributes(t,!0),this.fireQueue()},_setHTMLAttrConfig:function(t,e){var i=this.get("element");(e=e||{}).name=t,e.setter=e.setter||this.DEFAULT_HTML_SETTER,e.getter=e.getter||this.DEFAULT_HTML_GETTER,e.value=e.value||i[t],this._configs[t]=new YAHOO.util.Attribute(e,this)}},YAHOO.augment(o,s),YAHOO.util.Element=o}(),YAHOO.register("element",YAHOO.util.Element,{version:"2.9.0",build:"2800"});
//# sourceMappingURL=element.js.map;
var Y=YAHOO,Y_DOM=YAHOO.util.Dom,EMPTY_ARRAY=[],Y_UA=Y.env.ua,Y_Lang=Y.lang,Y_DOC=document,Y_DOCUMENT_ELEMENT=Y_DOC.documentElement,Y_DOM_inDoc=Y_DOM.inDocument,Y_mix=Y_Lang.augmentObject,Y_guid=Y_DOM.generateId,Y_getDoc=function(e){var t=Y_DOC;return t=e?9===e.nodeType?e:e.ownerDocument||e.document||Y_DOC:t},Y_Array=function(e,t){var r,n,o=t||0;try{return Array.prototype.slice.call(e,o)}catch(l){for(n=[],r=e.length;o<r;o++)n.push(e[o]);return n}},Y_DOM_allById=function(e,t){var r,n,o=[],l=[];if((t=t||Y_DOC).querySelectorAll)l=t.querySelectorAll('[id="'+e+'"]');else if(t.all){if((o=t.all(e))&&(o=o.nodeName?o.id===e?(l.push(o),EMPTY_ARRAY):[o]:o).length)for(r=0;n=o[r++];)(n.id===e||n.attributes&&n.attributes.id&&n.attributes.id.value===e)&&l.push(n)}else l=[Y_getDoc(t).getElementById(e)];return l},COMPARE_DOCUMENT_POSITION="compareDocumentPosition",OWNER_DOCUMENT="ownerDocument",Selector={_foundCache:[],useNative:!0,_compare:"sourceIndex"in Y_DOCUMENT_ELEMENT?function(e,t){e=e.sourceIndex,t=t.sourceIndex;return e===t?0:t<e?1:-1}:Y_DOCUMENT_ELEMENT[COMPARE_DOCUMENT_POSITION]?function(e,t){return 4&e[COMPARE_DOCUMENT_POSITION](t)?-1:1}:function(e,t){var r;return e&&t&&((r=e[OWNER_DOCUMENT].createRange()).setStart(e,0),(e=t[OWNER_DOCUMENT].createRange()).setStart(t,0),r=r.compareBoundaryPoints(1,e)),r},_sort:function(e){return e&&(e=Y_Array(e,0,!0)).sort&&e.sort(Selector._compare),e},_deDupe:function(e){for(var t,r=[],n=0;t=e[n++];)t._found||((r[r.length]=t)._found=!0);for(n=0;t=r[n++];)t._found=null,t.removeAttribute("_found");return r},query:function(e,t,r,n){if(t&&"string"==typeof t){if(!(t=Y_DOM.get(t)))return r?null:[]}else t=t||Y_DOC;var o,l,a=[],i=Selector.useNative&&Y_DOC.querySelector&&!n,c=[[e,t]],u=i?Selector._nativeQuery:Selector._bruteQuery;if(e&&u){for(n||i&&!t.tagName||(c=Selector._splitQueries(e,t)),l=0;o=c[l++];)o=u(o[0],o[1],r),(o=r?o:Y_Array(o,0,!0))&&(a=a.concat(o));1<c.length&&(a=Selector._sort(Selector._deDupe(a)))}return r?a[0]||null:a},_splitQueries:function(e,t){var r,n,o=e.split(","),l=[],a="";if(t)for(t.tagName&&(t.id=t.id||Y_guid(),a='[id="'+t.id+'"] '),r=0,n=o.length;r<n;++r)e=a+o[r],l.push([e,t]);return l},_nativeQuery:function(e,t,r){if(Y_UA.webkit&&-1<e.indexOf(":checked")&&Selector.pseudos&&Selector.pseudos.checked)return Selector.query(e,t,r,!0);try{return t["querySelector"+(r?"":"All")](e)}catch(n){return Selector.query(e,t,r,!0)}},filter:function(e,t){var r,n,o=[];if(e&&t)for(r=0;n=e[r++];)Selector.test(n,t)&&(o[o.length]=n);return o},test:function(e,t,r){var n,o,l,a,i,c,u,s=!1,f=t.split(","),t=!1;if(e&&e.tagName){for(r||Y_DOM_inDoc(e)||((n=e.parentNode)?r=n:((a=e[OWNER_DOCUMENT].createDocumentFragment()).appendChild(e),r=a,t=!0)),r=r||e[OWNER_DOCUMENT],e.id||(e.id=Y_guid()),i=0;u=f[i++];){for(u+='[id="'+e.id+'"]',l=Selector.query(u,r),c=0;o=l[c++];)if(o===e){s=!0;break}if(s)break}t&&a.removeChild(e)}return s}},PARENT_NODE=(YAHOO.util.Selector=Selector,"parentNode"),TAG_NAME="tagName",ATTRIBUTES="attributes",COMBINATOR="combinator",PSEUDOS="pseudos",SelectorCSS2={_reRegExpTokens:/([\^\$\?\[\]\*\+\-\.\(\)\|\\])/,SORT_RESULTS:!0,_children:function(e,t){var r,n,o,l=e.children;if(e.children&&t&&e.children.tags)e.children.tags(t);else if(!l&&e[TAG_NAME]||l&&t)for(n=l||e.childNodes,l=[],r=0;o=n[r++];)!o.tagName||t&&t!==o.tagName||l.push(o);return l||[]},_re:{attr:/(\[[^\]]*\])/g,esc:/\\[:\[\]\(\)#\.\'\>+~"]/gi,pseudos:/(\([^\)]*\))/g},shorthand:{"\\#(-?[_a-z]+[-\\w\\uE000]*)":"[id=$1]","\\.(-?[_a-z]+[-\\w\\uE000]*)":"[className~=$1]"},operators:{"":function(e,t){return!!e.getAttribute(t)},"~=":"(?:^|\\s+){val}(?:\\s+|$)","|=":"^{val}(?:-|$)"},pseudos:{"first-child":function(e){return Selector._children(e[PARENT_NODE])[0]===e}},_bruteQuery:function(e,t,r){var n,o,l,a=[],i=[],e=Selector._tokenize(e),c=e[e.length-1];Y_getDoc(t);if(c){if(o=c.id,l=c.className,c=c.tagName||"*",t.getElementsByTagName)i=o&&(t.all||9===t.nodeType||Y_DOM_inDoc(t))?Y_DOM_allById(o,t):l?t.getElementsByClassName(l):t.getElementsByTagName(c);else for(n=t.firstChild;n;)n.tagName&&i.push(n),n=n.nextSilbing||n.firstChild;i.length&&(a=Selector._filterNodes(i,e,r))}return a},_filterNodes:function(e,t,r){for(var n,o,l,a,i,c,u,s,f=0,_=t.length,d=_-1,g=[],p=e[0],h=p,N=Selector.getters,f=0;h=p=e[f++];){d=_-1,i=null;e:for(;h&&h.tagName;){if(n=(u=(a=t[d]).tests).length)for(;s=u[--n];)if(o=s[1],N[s[0]]?c=N[s[0]](h,s[0]):(c=h[s[0]])===undefined&&h.getAttribute&&(c=h.getAttribute(s[0])),"="===o&&c!==s[2]||"string"!=typeof o&&o.test&&!o.test(c)||!o.test&&"function"==typeof o&&!o(h,s[0],s[2])){if(h=h[i])for(;h&&(!h.tagName||a.tagName&&a.tagName!==h.tagName);)h=h[i];continue e}if(d--,!(l=a.combinator)){if(g.push(p),r)return g;break}for(h=h[i=l.axis];h&&!h.tagName;)h=h[i];l.direct&&(i=null)}}return p=h=null,g},combinators:{" ":{axis:"parentNode"},">":{axis:"parentNode",direct:!0},"+":{axis:"previousSibling",direct:!0}},_parsers:[{name:ATTRIBUTES,re:/^\uE003(-?[a-z]+[\w\-]*)+([~\|\^\$\*!=]=?)?['"]?([^\uE004'"]*)['"]?\uE004/i,fn:function(e,t){var r=e[2]||"",n=Selector.operators,o=e[3]?e[3].replace(/\\/g,""):"";if(("id"===e[1]&&"="===r||"className"===e[1]&&Y_DOCUMENT_ELEMENT.getElementsByClassName&&("~="===r||"="===r))&&(t.prefilter=e[1],e[3]=o,t[e[1]]="id"===e[1]?e[3]:o),r in n&&("string"==typeof(r=n[r])&&(e[3]=o.replace(Selector._reRegExpTokens,"\\$1"),r=new RegExp(r.replace("{val}",e[3]))),e[2]=r),!t.last||t.prefilter!==e[1])return e.slice(1)}},{name:TAG_NAME,re:/^((?:-?[_a-z]+[\w-]*)|\*)/i,fn:function(e,t){e=e[1].toUpperCase();if("*"!==(t.tagName=e)&&(!t.last||t.prefilter))return[TAG_NAME,"=",e];t.prefilter||(t.prefilter="tagName")}},{name:COMBINATOR,re:/^\s*([>+~]|\s)\s*/,fn:function(e,t){}},{name:PSEUDOS,re:/^:([\-\w]+)(?:\uE005['"]?([^\uE005]*)['"]?\uE006)*/i,fn:function(e,t){var r=Selector[PSEUDOS][e[1]];return!!r&&(e[2]&&(e[2]=e[2].replace(/\\/g,"")),[e[2],r])}}],_getToken:function(e){return{tagName:null,id:null,className:null,attributes:{},combinator:null,tests:[]}},_tokenize:function(e){e=Selector._replaceShorthand(Y_Lang.trim(e=e||""));var t,r,n,o,l=Selector._getToken(),a=[],i=!1;e:do{for(i=!1,n=0;o=Selector._parsers[n++];)if(t=o.re.exec(e)){if(o.name!==COMBINATOR&&(l.selector=e),(e=e.replace(t[0],"")).length||(l.last=!0),Selector._attrFilters[t[1]]&&(t[1]=Selector._attrFilters[t[1]]),!1===(r=o.fn(t,l))){i=!1;break e}r&&l.tests.push(r),e.length&&o.name!==COMBINATOR||(a.push(l),l=Selector._getToken(l),o.name===COMBINATOR&&(l.combinator=Selector.combinators[t[1]])),i=!0}}while(i&&e.length);return a=i&&!e.length?a:[]},_replaceShorthand:function(e){var t,r,n,o=Selector.shorthand,l=e.match(Selector._re.esc),a=(e=l?e.replace(Selector._re.esc,""):e).match(Selector._re.attr),i=e.match(Selector._re.pseudos);for(t in a&&(e=e.replace(Selector._re.attr,"")),i&&(e=e.replace(Selector._re.pseudos,"")),o)o.hasOwnProperty(t)&&(e=e.replace(new RegExp(t,"gi"),o[t]));if(a)for(r=0,n=a.length;r<n;++r)e=e.replace(/\uE001/,a[r]);if(i)for(r=0,n=i.length;r<n;++r)e=e.replace(/\uE002/,i[r]);if(e=(e=(e=(e=e.replace(/\[/g,"")).replace(/\]/g,"")).replace(/\(/g,"")).replace(/\)/g,""),l)for(r=0,n=l.length;r<n;++r)e=e.replace("",l[r]);return e},_attrFilters:{"class":"className","for":"htmlFor"},getters:{href:function(e,t){return Y_DOM.getAttribute(e,t)}}};Y_mix(Selector,SelectorCSS2,!0),Selector.getters.src=Selector.getters.rel=Selector.getters.href,Selector.useNative&&Y_DOC.querySelector&&(Selector.shorthand["\\.([^\\s\\\\(\\[:]*)"]="[class~=$1]"),Selector._reNth=/^(?:([\-]?\d*)(n){1}|(odd|even)$)*([\-+]?\d*)$/,Selector._getNth=function(e,t,r,n){Selector._reNth.test(t);var o=parseInt(RegExp.$1,10),t=RegExp.$2,l=RegExp.$3,a=parseInt(RegExp.$4,10)||0,i=Selector._children(e.parentNode,r);if(l?(o=2,t="n",a="odd"===l?1:0):isNaN(o)&&(o=t?1:0),0===o)return i[(a=n?i.length-a+1:a)-1]===e;if(o<0&&(n=!!n,o=Math.abs(o)),n){for(c=i.length-a,u=i.length;0<=c;c-=o)if(c<u&&i[c]===e)return!0}else for(var c=a-1,u=i.length;c<u;c+=o)if(0<=c&&i[c]===e)return!0;return!1},Y_mix(Selector.pseudos,{root:function(e){return e===e.ownerDocument.documentElement},"nth-child":function(e,t){return Selector._getNth(e,t)},"nth-last-child":function(e,t){return Selector._getNth(e,t,null,!0)},"nth-of-type":function(e,t){return Selector._getNth(e,t,e.tagName)},"nth-last-of-type":function(e,t){return Selector._getNth(e,t,e.tagName,!0)},"last-child":function(e){var t=Selector._children(e.parentNode);return t[t.length-1]===e},"first-of-type":function(e){return Selector._children(e.parentNode,e.tagName)[0]===e},"last-of-type":function(e){var t=Selector._children(e.parentNode,e.tagName);return t[t.length-1]===e},"only-child":function(e){var t=Selector._children(e.parentNode);return 1===t.length&&t[0]===e},"only-of-type":function(e){var t=Selector._children(e.parentNode,e.tagName);return 1===t.length&&t[0]===e},empty:function(e){return 0===e.childNodes.length},not:function(e,t){return!Selector.test(e,t)},contains:function(e,t){return-1<(e.innerText||e.textContent||"").indexOf(t)},checked:function(e){return!0===e.checked||!0===e.selected},enabled:function(e){return e.disabled!==undefined&&!e.disabled},disabled:function(e){return e.disabled}}),Y_mix(Selector.operators,{"^=":"^{val}","!=":function(e,t,r){return e[t]!==r},"$=":"{val}$","*=":"{val}"}),Selector.combinators["~"]={axis:"previousSibling"},YAHOO.register("selector",YAHOO.util.Selector,{version:"2.9.0",build:"2800"});
//# sourceMappingURL=selector.js.map;
!function(){var d=YAHOO.util.Dom,l=YAHOO.util.Event,c=YAHOO.lang,m=YAHOO.env.ua,g=YAHOO.widget.Overlay,p=YAHOO.widget.Menu,_={},v=null,h=null,i=null;function r(t,e,i,n){var s;return c.isString(t)&&c.isString(e)&&(m.ie&&m.ie<9?(s='<input type="'+t+'" name="'+e+'"',n&&(s+=" checked"),s+=">",(s=document.createElement(s)).value=i):((s=document.createElement("input")).name=e,s.type=t,s.value=i,n&&(s.checked=!0))),s}function o(e,i){var n,t,s=e.nodeName.toUpperCase(),o=this.CLASS_NAME_PREFIX+this.CSS_CLASS_NAME;function a(t){t in i||(n=e.getAttributeNode(t))&&"value"in n&&(i[t]=n.value)}function u(){a("type"),"button"==i.type&&(i.type="push"),"disabled"in i||(i.disabled=e.disabled),a("name"),a("value"),a("title")}switch(s){case"A":i.type="link",a("href"),a("target");break;case"INPUT":u(),"checked"in i||(i.checked=e.checked);break;case"BUTTON":u(),t=e.parentNode.parentNode,d.hasClass(t,o+"-checked")&&(i.checked=!0),d.hasClass(t,o+"-disabled")&&(i.disabled=!0),e.removeAttribute("value"),e.setAttribute("type","button")}e.removeAttribute("id"),e.removeAttribute("name"),"tabindex"in i||(i.tabindex=e.tabIndex),"label"in i||(s="INPUT"==s?e.value:e.innerHTML)&&0<s.length&&(i.label=s)}function a(t){var e=t.attributes,i=e.srcelement,n=i.nodeName.toUpperCase(),s=this;if(n==this.NODE_NAME)t.element=i,t.id=i.id,d.getElementsBy(function(t){switch(t.nodeName.toUpperCase()){case"BUTTON":case"A":case"INPUT":o.call(s,t,e)}},"*",i);else switch(n){case"BUTTON":case"A":case"INPUT":o.call(this,i,e)}}YAHOO.widget.Button=function(t,e){!g&&YAHOO.widget.Overlay&&(g=YAHOO.widget.Overlay),!p&&YAHOO.widget.Menu&&(p=YAHOO.widget.Menu);var i,n,s=YAHOO.widget.Button.superclass.constructor;1!=arguments.length||c.isString(t)||t.nodeName?(i={element:null,attributes:e||{}},c.isString(t)?(n=d.get(t))&&(i.attributes.id||(i.attributes.id=t),i.attributes.srcelement=n,a.call(this,i),i.element||(i.element=this.createButtonElement(i.attributes.type)),s.call(this,i.element,i.attributes)):t.nodeName&&(i.attributes.id||(t.id?i.attributes.id=t.id:i.attributes.id=d.generateId()),i.attributes.srcelement=t,a.call(this,i),i.element||(i.element=this.createButtonElement(i.attributes.type)),s.call(this,i.element,i.attributes))):(t.id||(t.id=d.generateId()),s.call(this,this.createButtonElement(t.type),t))},YAHOO.extend(YAHOO.widget.Button,YAHOO.util.Element,{_button:null,_menu:null,_hiddenFields:null,_onclickAttributeValue:null,_activationKeyPressed:!1,_activationButtonPressed:!1,_hasKeyEventHandlers:!1,_hasMouseEventHandlers:!1,_nOptionRegionX:0,CLASS_NAME_PREFIX:"yui-",NODE_NAME:"SPAN",CHECK_ACTIVATION_KEYS:[32],ACTIVATION_KEYS:[13,32],OPTION_AREA_WIDTH:20,CSS_CLASS_NAME:"button",_setType:function(t){"split"==t&&this.on("option",this._onOption)},_setLabel:function(t){this._button.innerHTML=t;var t=m.gecko;t&&t<1.9&&d.inDocument(this.get("element"))&&(t=this.CLASS_NAME_PREFIX+this.CSS_CLASS_NAME,this.removeClass(t),c.later(0,this,this.addClass,t))},_setTabIndex:function(t){this._button.tabIndex=t},_setTitle:function(t){"link"!=this.get("type")&&(this._button.title=t)},_setDisabled:function(t){"link"!=this.get("type")&&(t?(this._menu&&this._menu.hide(),this.hasFocus()&&this.blur(),this._button.setAttribute("disabled","disabled"),this.addStateCSSClasses("disabled"),this.removeStateCSSClasses("hover"),this.removeStateCSSClasses("active"),this.removeStateCSSClasses("focus")):(this._button.removeAttribute("disabled"),this.removeStateCSSClasses("disabled")))},_setHref:function(t){"link"==this.get("type")&&(this._button.href=t)},_setTarget:function(t){"link"==this.get("type")&&this._button.setAttribute("target",t)},_setChecked:function(t){var e=this.get("type");"checkbox"!=e&&"radio"!=e||(t?this.addStateCSSClasses("checked"):this.removeStateCSSClasses("checked"))},_setMenu:function(t){var e,i,n,s,o=this.get("lazyloadmenu"),a=this.get("element"),u=!1;function h(){i.render(a.parentNode),this.removeListener("appendTo",h)}function r(){i.cfg.queueProperty("container",a.parentNode),this.removeListener("appendTo",r)}function l(){var t;i&&(d.addClass(i.element,this.get("menuclassname")),d.addClass(i.element,this.CLASS_NAME_PREFIX+this.get("type")+"-button-menu"),i.showEvent.subscribe(this._onMenuShow,null,this),i.hideEvent.subscribe(this._onMenuHide,null,this),i.renderEvent.subscribe(this._onMenuRender,null,this),p&&i instanceof p?(o&&((t=this.get("container"))?i.cfg.queueProperty("container",t):this.on("appendTo",r)),i.cfg.queueProperty("clicktohide",!1),i.keyDownEvent.subscribe(this._onMenuKeyDown,this,!0),i.subscribe("click",this._onMenuClick,this,!0),this.on("selectedMenuItemChange",this._onSelectedMenuItemChange),(s=i.srcElement)&&"SELECT"==s.nodeName.toUpperCase()&&(s.style.display="none",s.parentNode.removeChild(s))):g&&i instanceof g&&(v=v||new YAHOO.widget.OverlayManager).register(i),this._menu=i,u||o||(d.inDocument(a)?i.render(a.parentNode):this.on("appendTo",h)))}g&&(p&&(e=p.prototype.CSS_CLASS_NAME),t&&p&&t instanceof p?(i=t,u=!0,l.call(this)):g&&t&&t instanceof g?(u=!0,(i=t).cfg.queueProperty("visible",!1),l.call(this)):p&&c.isArray(t)?(i=new p(d.generateId(),{lazyload:o,itemdata:t}),this._menu=i,this.on("appendTo",l)):c.isString(t)?(n=d.get(t))&&(p&&d.hasClass(n,e)||"SELECT"==n.nodeName.toUpperCase()?(i=new p(t,{lazyload:o}),l.call(this)):g&&(i=new g(t,{visible:!1}),l.call(this))):t&&t.nodeName&&(p&&d.hasClass(t,e)||"SELECT"==t.nodeName.toUpperCase()?(i=new p(t,{lazyload:o}),l.call(this)):g&&(t.id||d.generateId(t),i=new g(t,{visible:!1}),l.call(this))))},_setOnClick:function(t){this._onclickAttributeValue&&this._onclickAttributeValue!=t&&(this.removeListener("click",this._onclickAttributeValue.fn),this._onclickAttributeValue=null),!this._onclickAttributeValue&&c.isObject(t)&&c.isFunction(t.fn)&&(this.on("click",t.fn,t.obj,t.scope),this._onclickAttributeValue=t)},_isActivationKey:function(t){var e,i=this.get("type"),n="checkbox"==i||"radio"==i?this.CHECK_ACTIVATION_KEYS:this.ACTIVATION_KEYS,i=n.length,s=!1;if(0<i){e=i-1;do{if(t==n[e]){s=!0;break}}while(e--)}return s},_isSplitButtonOptionKey:function(t){var e=40==l.getCharCode(t),i=function(t){l.preventDefault(t),this.removeListener("keypress",i)};return e&&(m.opera&&this.on("keypress",i),l.preventDefault(t)),e},_addListenersToForm:function(){var t,e,i,n,s,o=this.getForm(),a=YAHOO.widget.Button.onFormKeyPress;if(o&&(l.on(o,"reset",this._onFormReset,null,this),l.on(o,"submit",this._onFormSubmit,null,this),e=this.get("srcelement"),"submit"==this.get("type")||e&&"submit"==e.type)){if(t=!1,(i=l.getListeners(o,"keypress"))&&0<(n=i.length)){s=n-1;do{if(i[s].fn==a){t=!0;break}}while(s--)}t||l.on(o,"keypress",a)}},_showMenu:function(t){YAHOO.widget.MenuManager&&YAHOO.widget.MenuManager.hideVisible(),v&&v.hideAll();var e=this._menu,i=this.get("menualignment"),n=this.get("focusmenu");this._renderedMenu?(e.cfg.setProperty("context",[this.get("element"),i[0],i[1]]),e.cfg.setProperty("preventcontextoverlap",!0),e.cfg.setProperty("constraintoviewport",!0)):(e.cfg.queueProperty("context",[this.get("element"),i[0],i[1]]),e.cfg.queueProperty("preventcontextoverlap",!0),e.cfg.queueProperty("constraintoviewport",!0)),this.focus(),p&&e&&e instanceof p?(i=e.focus,e.focus=function(){},this._renderedMenu?(e.cfg.setProperty("minscrollheight",this.get("menuminscrollheight")),e.cfg.setProperty("maxheight",this.get("menumaxheight"))):(e.cfg.queueProperty("minscrollheight",this.get("menuminscrollheight")),e.cfg.queueProperty("maxheight",this.get("menumaxheight"))),e.show(),e.focus=i,e.align(),"mousedown"==t.type&&l.stopPropagation(t),n&&e.focus()):g&&e&&e instanceof g&&(this._renderedMenu||e.render(this.get("element").parentNode),e.show(),e.align())},_hideMenu:function(){var t=this._menu;t&&t.hide()},_onMouseOver:function(t){var e,i=this.get("type");"split"===i&&(e=this.get("element"),e=d.getX(e)+(e.offsetWidth-this.OPTION_AREA_WIDTH),this._nOptionRegionX=e),this._hasMouseEventHandlers||("split"===i&&this.on("mousemove",this._onMouseMove),this.on("mouseout",this._onMouseOut),this._hasMouseEventHandlers=!0),this.addStateCSSClasses("hover"),"split"===i&&l.getPageX(t)>e&&this.addStateCSSClasses("hoveroption"),this._activationButtonPressed&&this.addStateCSSClasses("active"),this._bOptionPressed&&this.addStateCSSClasses("activeoption"),(this._activationButtonPressed||this._bOptionPressed)&&l.removeListener(document,"mouseup",this._onDocumentMouseUp)},_onMouseMove:function(t){var e=this._nOptionRegionX;e&&(l.getPageX(t)>e?this.addStateCSSClasses("hoveroption"):this.removeStateCSSClasses("hoveroption"))},_onMouseOut:function(t){var e=this.get("type");this.removeStateCSSClasses("hover"),"menu"!=e&&this.removeStateCSSClasses("active"),(this._activationButtonPressed||this._bOptionPressed)&&l.on(document,"mouseup",this._onDocumentMouseUp,null,this),"split"===e&&l.getPageX(t)>this._nOptionRegionX&&this.removeStateCSSClasses("hoveroption")},_onDocumentMouseUp:function(t){this._activationButtonPressed=!1,this._bOptionPressed=!1;var e,i=this.get("type");"menu"!=i&&"split"!=i||(t=l.getTarget(t))==(e=this._menu.element)||d.isAncestor(e,t)||(this.removeStateCSSClasses("menu"==i?"active":"activeoption"),this._hideMenu()),l.removeListener(document,"mouseup",this._onDocumentMouseUp)},_onMouseDown:function(t){var e,i=!0;return 1==(t.which||t.button)&&(this.hasFocus()||c.later(0,this,this.focus),"split"==(e=this.get("type"))?l.getPageX(t)>this._nOptionRegionX?(this.fireEvent("option",t),i=!1):(this.addStateCSSClasses("active"),this._activationButtonPressed=!0):"menu"==e?this.isActive()?(this._hideMenu(),this._activationButtonPressed=!1):(this._showMenu(t),this._activationButtonPressed=!0):(this.addStateCSSClasses("active"),this._activationButtonPressed=!0),"split"!=e&&"menu"!=e||(this._hideMenuTimer=c.later(250,this,this.on,["mouseup",function n(){this._hideMenu(),this.removeListener("mouseup",n)}]))),i},_onMouseUp:function(t){this.inMouseDown=!1;var e=this.get("type"),i=this._hideMenuTimer,n=!0;if(i&&i.cancel(),"checkbox"==e||"radio"==e){if(1!=(t.which||t.button))return;this.set("checked",!this.get("checked"))}return this._activationButtonPressed=!1,"menu"!=e&&this.removeStateCSSClasses("active"),n="split"==e&&l.getPageX(t)>this._nOptionRegionX?!1:n},_onFocus:function(t){var e;this.addStateCSSClasses("focus"),this._activationKeyPressed&&this.addStateCSSClasses("active"),(i=this)._hasKeyEventHandlers||(e=this._button,l.on(e,"blur",this._onBlur,null,this),l.on(e,"keydown",this._onKeyDown,null,this),l.on(e,"keyup",this._onKeyUp,null,this),this._hasKeyEventHandlers=!0),this.fireEvent("focus",t)},_onBlur:function(t){this.removeStateCSSClasses("focus"),"menu"!=this.get("type")&&this.removeStateCSSClasses("active"),this._activationKeyPressed&&l.on(document,"keyup",this._onDocumentKeyUp,null,this),i=null,this.fireEvent("blur",t)},_onDocumentKeyUp:function(t){this._isActivationKey(l.getCharCode(t))&&(this._activationKeyPressed=!1,l.removeListener(document,"keyup",this._onDocumentKeyUp))},_onKeyDown:function(t){var e=this._menu;"split"==this.get("type")&&this._isSplitButtonOptionKey(t)?this.fireEvent("option",t):this._isActivationKey(l.getCharCode(t))&&("menu"==this.get("type")?this._showMenu(t):(this._activationKeyPressed=!0,this.addStateCSSClasses("active"))),e&&e.cfg.getProperty("visible")&&27==l.getCharCode(t)&&(e.hide(),this.focus())},_onKeyUp:function(t){this._isActivationKey(l.getCharCode(t))&&("checkbox"!=(t=this.get("type"))&&"radio"!=t||this.set("checked",!this.get("checked")),this._activationKeyPressed=!1,"menu"!=this.get("type"))&&this.removeStateCSSClasses("active")},_onClick:function(t){var e,i;switch(this.get("type")){case"submit":!1!==t.returnValue&&this.submitForm();break;case"reset":(e=this.getForm())&&e.reset();break;case"split":0<this._nOptionRegionX&&l.getPageX(t)>this._nOptionRegionX?i=!1:(this._hideMenu(),(e=this.get("srcelement"))&&"submit"==e.type&&!1!==t.returnValue&&this.submitForm())}return i},_onDblClick:function(t){var e=!0;return e="split"==this.get("type")&&l.getPageX(t)>this._nOptionRegionX?!1:e},_onAppendTo:function(t){c.later(0,this,this._addListenersToForm)},_onFormReset:function(t){var e=this.get("type"),i=this._menu;"checkbox"!=e&&"radio"!=e||this.resetValue("checked"),p&&i&&i instanceof p&&this.resetValue("selectedMenuItem")},_onFormSubmit:function(t){this.createHiddenFields()},_onDocumentMouseDown:function(t){var s=l.getTarget(t),t=this.get("element"),e=this._menu.element;s==t||d.isAncestor(t,s)||s==e||d.isAncestor(e,s)||this._menu&&this._menu.getSubmenus&&!function o(t){var e,i,n;if(!t)return 1;for(e=0,i=t.length;e<i;e++){if(n=t[e].element,s==n||d.isAncestor(n,s))return 1;if(t[e]&&t[e].getSubmenus&&o(t[e].getSubmenus()))return 1}}(this._menu.getSubmenus())||(this._hideMenu(),m.ie&&m.ie<9&&s.focus&&s.setActive(),l.removeListener(document,"mousedown",this._onDocumentMouseDown))},_onOption:function(t){this.hasClass(this.CLASS_NAME_PREFIX+"split-button-activeoption")?(this._hideMenu(),this._bOptionPressed=!1):(this._showMenu(t),this._bOptionPressed=!0)},_onMenuShow:function(t){l.on(document,"mousedown",this._onDocumentMouseDown,null,this);var e="split"==this.get("type")?"activeoption":"active";this.addStateCSSClasses(e)},_onMenuHide:function(t){var e="split"==this.get("type")?"activeoption":"active";this.removeStateCSSClasses(e),"split"==this.get("type")&&(this._bOptionPressed=!1)},_onMenuKeyDown:function(t,e){e=e[0];27==l.getCharCode(e)&&(this.focus(),"split"==this.get("type"))&&(this._bOptionPressed=!1)},_onMenuRender:function(t){var e=this.get("element").parentNode,i=this._menu,n=i.element,s=i.srcElement;e!=n.parentNode&&e.appendChild(n),this._renderedMenu=!0,s&&"select"===s.nodeName.toLowerCase()&&s.value&&(n=i.getItem(s.selectedIndex),this.set("selectedMenuItem",n,!0),this._onSelectedMenuItemChange({newValue:n}))},_onMenuClick:function(t,e){var e=e[1];e&&(this.set("selectedMenuItem",e),(e=this.get("srcelement"))&&"submit"==e.type&&this.submitForm(),this._hideMenu())},_onSelectedMenuItemChange:function(t){var e=t.prevValue,t=t.newValue,i=this.CLASS_NAME_PREFIX;e&&d.removeClass(e.element,i+"button-selectedmenuitem"),t&&d.addClass(t.element,i+"button-selectedmenuitem")},_onLabelClick:function(t){this.focus();var e=this.get("type");"radio"!=e&&"checkbox"!=e||this.set("checked",!this.get("checked"))},createButtonElement:function(t){var e=this.NODE_NAME,i=document.createElement(e);return i.innerHTML="<"+e+' class="first-child">'+("link"==t?"<a></a>":'<button type="button"></button>')+"</"+e+">",i},addStateCSSClasses:function(t){var e=this.get("type"),i=this.CLASS_NAME_PREFIX;c.isString(t)&&("activeoption"!=t&&"hoveroption"!=t&&this.addClass(i+this.CSS_CLASS_NAME+"-"+t),this.addClass(i+e+"-button-"+t))},removeStateCSSClasses:function(t){var e=this.get("type"),i=this.CLASS_NAME_PREFIX;c.isString(t)&&(this.removeClass(i+this.CSS_CLASS_NAME+"-"+t),this.removeClass(i+e+"-button-"+t))},createHiddenFields:function(){this.removeHiddenFields();var t,e,i,n,s,o,a,u=this.getForm();return u&&!this.get("disabled")&&(((e="checkbox"==(o=this.get("type"))||"radio"==o)&&this.get("checked")||h==this)&&(t=r(e?o:"hidden",this.get("name"),this.get("value"),this.get("checked")))&&(e&&(t.style.display="none"),u.appendChild(t)),o=this._menu,p&&o&&o instanceof p&&(e=this.get("selectedMenuItem"),a=(o=o.srcElement)&&"SELECT"==o.nodeName.toUpperCase(),e?(e=null===e.value||""===e.value?e.cfg.getProperty("text"):e.value,n=this.get("name"),a?s=o.name:n&&(s=n+"_options"),e&&s&&(i=r("hidden",s,e),u.appendChild(i))):a&&(i=u.appendChild(o))),t&&i?this._hiddenFields=[t,i]:!t&&i?this._hiddenFields=i:t&&!i&&(this._hiddenFields=t),n=this._hiddenFields),n},removeHiddenFields:function(){var t,e,i=this._hiddenFields;function n(t){d.inDocument(t)&&t.parentNode.removeChild(t)}if(i){if(c.isArray(i)){if(0<(t=i.length))for(e=t-1;n(i[e]),e--;);}else n(i);this._hiddenFields=null}},submitForm:function(){var t=this.getForm(),e=this.get("srcelement"),i=!1;return t&&(("submit"==this.get("type")||e&&"submit"==e.type)&&(h=this),i=m.ie&&m.ie<9?t.fireEvent("onsubmit"):((e=document.createEvent("HTMLEvents")).initEvent("submit",!0,!0),t.dispatchEvent(e)),m.ie||m.webkit)&&i&&t.submit(),i},init:function(t,e){var i,n,s="link"==e.type?"a":"button",o=e.srcelement,s=t.getElementsByTagName(s)[0],a=(s||(r=t.getElementsByTagName("input")[0])&&((s=document.createElement("button")).setAttribute("type","button"),r.parentNode.replaceChild(s,r)),this._button=s,YAHOO.widget.Button.superclass.init.call(this,t,e),this.get("id")),u=a+"-button",t=(s.id=u,o&&"link"!=this.get("type")&&(r=d.getElementsBy(function(t){return t.htmlFor===a},"label"),c.isArray(r))&&0<r.length&&(i=r[0]),(_[a]=this).CLASS_NAME_PREFIX),e=(this.addClass(t+this.CSS_CLASS_NAME),this.addClass(t+this.get("type")+"-button"),l.on(this._button,"focus",this._onFocus,null,this),this.on("mouseover",this._onMouseOver),this.on("mousedown",this._onMouseDown),this.on("mouseup",this._onMouseUp),this.on("click",this._onClick),this.get("onclick")),h=(this.set("onclick",null),this.set("onclick",e),this.on("dblclick",this._onDblClick),i&&(this.get("replaceLabel")?(this.set("label",i.innerHTML),(n=i.parentNode).removeChild(i)):(this.on("appendTo",function(){i.setAttribute(m.ie?"htmlFor":"for",u)}),l.on(i,"click",this._onLabelClick,null,this),this._label=i)),this.on("appendTo",this._onAppendTo),this.get("container")),s=this.get("element"),r=d.inDocument(s);h?(o&&o!=s&&(n=o.parentNode)&&n.removeChild(o),c.isString(h)?l.onContentReady(h,this.appendTo,h,this):this.on("init",function(){c.later(0,this,this.appendTo,h)})):!r&&o&&o!=s?(n=o.parentNode)&&(this.fireEvent("beforeAppendTo",{type:"beforeAppendTo",target:n}),n.replaceChild(s,o),this.fireEvent("appendTo",{type:"appendTo",target:n})):"link"!=this.get("type")&&r&&o&&o==s&&this._addListenersToForm(),this.fireEvent("init",{type:"init",target:this})},initAttributes:function(t){t=t||{};YAHOO.widget.Button.superclass.initAttributes.call(this,t),this.setAttributeConfig("type",{value:t.type||"push",validator:c.isString,writeOnce:!0,method:this._setType}),this.setAttributeConfig("label",{value:t.label,validator:c.isString,method:this._setLabel}),this.setAttributeConfig("value",{value:t.value}),this.setAttributeConfig("name",{value:t.name,validator:c.isString}),this.setAttributeConfig("tabindex",{value:t.tabindex,validator:c.isNumber,method:this._setTabIndex}),this.configureAttribute("title",{value:t.title,validator:c.isString,method:this._setTitle}),this.setAttributeConfig("disabled",{value:t.disabled||!1,validator:c.isBoolean,method:this._setDisabled}),this.setAttributeConfig("href",{value:t.href,validator:c.isString,method:this._setHref}),this.setAttributeConfig("target",{value:t.target,validator:c.isString,method:this._setTarget}),this.setAttributeConfig("checked",{value:t.checked||!1,validator:c.isBoolean,method:this._setChecked}),this.setAttributeConfig("container",{value:t.container,writeOnce:!0}),this.setAttributeConfig("srcelement",{value:t.srcelement,writeOnce:!0}),this.setAttributeConfig("menu",{value:null,method:this._setMenu,writeOnce:!0}),this.setAttributeConfig("lazyloadmenu",{value:!1!==t.lazyloadmenu,validator:c.isBoolean,writeOnce:!0}),this.setAttributeConfig("menuclassname",{value:t.menuclassname||this.CLASS_NAME_PREFIX+"button-menu",validator:c.isString,method:this._setMenuClassName,writeOnce:!0}),this.setAttributeConfig("menuminscrollheight",{value:t.menuminscrollheight||90,validator:c.isNumber}),this.setAttributeConfig("menumaxheight",{value:t.menumaxheight||0,validator:c.isNumber}),this.setAttributeConfig("menualignment",{value:t.menualignment||["tl","bl"],validator:c.isArray}),this.setAttributeConfig("selectedMenuItem",{value:null}),this.setAttributeConfig("onclick",{value:t.onclick,method:this._setOnClick}),this.setAttributeConfig("focusmenu",{value:!1!==t.focusmenu,validator:c.isBoolean}),this.setAttributeConfig("replaceLabel",{value:!1,validator:c.isBoolean,writeOnce:!0})},focus:function(){if(!this.get("disabled"))try{this._button.focus()}catch(t){}},blur:function(){if(!this.get("disabled"))try{this._button.blur()}catch(t){}},hasFocus:function(){return i==this},isActive:function(){return this.hasClass(this.CLASS_NAME_PREFIX+this.CSS_CLASS_NAME+"-active")},getMenu:function(){return this._menu},getForm:function(){var t,e=this._button;return t=e?e.form:t},getHiddenFields:function(){return this._hiddenFields},destroy:function(){var t,e=this.get("element"),i=this._menu,n=this._label,i=(i&&(v&&v.find(i)&&v.remove(i),i.destroy()),l.purgeElement(e),l.purgeElement(this._button),l.removeListener(document,"mouseup",this._onDocumentMouseUp),l.removeListener(document,"keyup",this._onDocumentKeyUp),l.removeListener(document,"mousedown",this._onDocumentMouseDown),n&&(l.removeListener(n,"click",this._onLabelClick),(t=n.parentNode).removeChild(n)),this.getForm()),n=(i&&(l.removeListener(i,"reset",this._onFormReset),l.removeListener(i,"submit",this._onFormSubmit)),this.unsubscribeAll(),(t=e.parentNode)&&t.removeChild(e),delete _[this.get("id")],this.CLASS_NAME_PREFIX+this.CSS_CLASS_NAME),e=d.getElementsByClassName(n,this.NODE_NAME,i);c.isArray(e)&&0===e.length&&l.removeListener(i,"keypress",YAHOO.widget.Button.onFormKeyPress)},fireEvent:function(t,e){return(!this.DOM_EVENTS[t]||!this.get("disabled"))&&YAHOO.widget.Button.superclass.fireEvent.apply(this,arguments)},toString:function(){return"Button "+this.get("id")}}),YAHOO.widget.Button.onFormKeyPress=function(t){var i,n,s,e=l.getTarget(t),o=l.getCharCode(t),a=e.nodeName&&e.nodeName.toUpperCase(),e=e.type,u=!1;13!=o||("INPUT"!=a||"text"!=e&&"password"!=e&&"checkbox"!=e&&"radio"!=e&&"file"!=e)&&"SELECT"!=a||(d.getElementsBy(function(t){var e;switch(t.nodeName.toUpperCase()){case"INPUT":case"BUTTON":"submit"!=t.type||t.disabled||u||(s=s||t);break;default:(e=t.id)&&(i=_[e])&&(u=!0,i.get("disabled")||(e=i.get("srcelement"),!n&&("submit"==i.get("type")||e&&"submit"==e.type)&&(n=i)))}},"*",this),s?s.focus():!s&&n&&(l.preventDefault(t),m.ie&&m.ie<9?n.get("element").fireEvent("onclick"):((o=document.createEvent("HTMLEvents")).initEvent("click",!0,!0),m.gecko<1.9?n.fireEvent("click",o):n.get("element").dispatchEvent(o))))},YAHOO.widget.Button.addHiddenFieldsToForm=function(t){var e,i,n=YAHOO.widget.Button.prototype,s=d.getElementsByClassName(n.CLASS_NAME_PREFIX+n.CSS_CLASS_NAME,"*",t),o=s.length;if(0<o)for(i=0;i<o;i++)(e=s[i].id)&&(e=_[e])&&e.createHiddenFields()},YAHOO.widget.Button.getButton=function(t){return _[t]}}(),function(){var s=YAHOO.util.Dom,o=YAHOO.util.Event,a=YAHOO.lang,u=YAHOO.widget.Button,h={};YAHOO.widget.ButtonGroup=function(t,e){var i,n=YAHOO.widget.ButtonGroup.superclass.constructor;1!=arguments.length||a.isString(t)||t.nodeName?a.isString(t)?(i=s.get(t))&&i.nodeName.toUpperCase()==this.NODE_NAME&&n.call(this,i,e):(i=t.nodeName.toUpperCase())&&i==this.NODE_NAME&&(t.id||(t.id=s.generateId()),n.call(this,t,e)):(t.id||(i=s.generateId(),t.id=i),n.call(this,this._createGroupElement(),t))},YAHOO.extend(YAHOO.widget.ButtonGroup,YAHOO.util.Element,{_buttons:null,NODE_NAME:"DIV",CLASS_NAME_PREFIX:"yui-",CSS_CLASS_NAME:"buttongroup",_createGroupElement:function(){return document.createElement(this.NODE_NAME)},_setDisabled:function(t){var e,i=this.getCount();if(0<i)for(e=i-1;this._buttons[e].set("disabled",t),e--;);},_onKeyDown:function(t){var e=o.getTarget(t),t=o.getCharCode(t),e=e.parentNode.parentNode.id,e=h[e],i=-1;37==t||38==t?i=0===e.index?this._buttons.length-1:e.index-1:39!=t&&40!=t||(i=e.index===this._buttons.length-1?0:e.index+1),-1<i&&(this.check(i),this.getButton(i).focus())},_onAppendTo:function(t){for(var e=this._buttons,i=e.length,n=0;n<i;n++)e[n].appendTo(this.get("element"))},_onButtonCheckedChange:function(t,e){var t=t.newValue,i=this.get("checkedButton");t&&i!=e?(i&&i.set("checked",!1,!0),this.set("checkedButton",e),this.set("value",e.get("value"))):i&&!i.set("checked")&&i.set("checked",!0,!0)},init:function(t,e){this._buttons=[],YAHOO.widget.ButtonGroup.superclass.init.call(this,t,e),this.addClass(this.CLASS_NAME_PREFIX+this.CSS_CLASS_NAME);t=YAHOO.widget.Button.prototype.CLASS_NAME_PREFIX+"radio-button",e=this.getElementsByClassName(t);0<e.length&&this.addButtons(e),0<(e=s.getElementsBy(function(t){return"radio"==t.type},"input",this.get("element"))).length&&this.addButtons(e),this.on("keydown",this._onKeyDown),this.on("appendTo",this._onAppendTo);var i=this.get("container");i&&(a.isString(i)?o.onContentReady(i,function(){this.appendTo(i)},null,this):this.appendTo(i))},initAttributes:function(t){t=t||{};YAHOO.widget.ButtonGroup.superclass.initAttributes.call(this,t),this.setAttributeConfig("name",{value:t.name,validator:a.isString}),this.setAttributeConfig("disabled",{value:t.disabled||!1,validator:a.isBoolean,method:this._setDisabled}),this.setAttributeConfig("value",{value:t.value}),this.setAttributeConfig("container",{value:t.container,writeOnce:!0}),this.setAttributeConfig("checkedButton",{value:null})},addButton:function(t){var e,i,n,t=t instanceof u&&"radio"==t.get("type")?t:a.isString(t)||t.nodeName?new u(t,{type:"radio"}):(t.type="radio",new u(t));return t&&(e=this._buttons.length,i=t.get("name"),n=this.get("name"),t.index=e,this._buttons[e]=t,h[t.get("id")]=t,i!=n&&t.set("name",n),this.get("disabled")&&t.set("disabled",!0),t.get("checked")&&this.set("checkedButton",t),e=t.get("element"),i=this.get("element"),e.parentNode!=i&&i.appendChild(e),t.on("checkedChange",this._onButtonCheckedChange,t,this)),t},addButtons:function(t){var e,i,n,s;if(a.isArray(t)&&(n=[],0<(e=t.length)))for(s=0;s<e;s++)(i=this.addButton(t[s]))&&(n[n.length]=i);return n},removeButton:function(t){var e,i=this.getButton(t);if(i&&(this._buttons.splice(t,1),delete h[i.get("id")],i.removeListener("checkedChange",this._onButtonCheckedChange),i.destroy(),0<this._buttons.length))for(e=this._buttons.length-1;this._buttons[e].index=e,e--;);},getButton:function(t){return this._buttons[t]},getButtons:function(){return this._buttons},getCount:function(){return this._buttons.length},focus:function(t){var e,i,n;if(a.isNumber(t))(e=this._buttons[t])&&e.focus();else for(i=this.getCount(),n=0;n<i;n++)if(!(e=this._buttons[n]).get("disabled")){e.focus();break}},check:function(t){t=this.getButton(t);t&&t.set("checked",!0)},destroy:function(){var t,e=this._buttons.length,i=this.get("element"),n=i.parentNode;if(0<e)for(t=this._buttons.length-1;this._buttons[t].destroy(),t--;);o.purgeElement(i),n.removeChild(i)},toString:function(){return"ButtonGroup "+this.get("id")}})}(),YAHOO.register("button",YAHOO.widget.Button,{version:"2.9.0",build:"2800"});
//# sourceMappingURL=button-patch.js.map;
YAHOO.util.DragDropMgr||(YAHOO.util.DragDropMgr=function(){var i=YAHOO.util.Event,e=YAHOO.util.Dom;return{useShim:!1,_shimActive:!1,_shimState:!1,_debugShim:!1,_createShim:function(){var t=document.createElement("div");t.id="yui-ddm-shim",document.body.firstChild?document.body.insertBefore(t,document.body.firstChild):document.body.appendChild(t),t.style.display="none",t.style.backgroundColor="red",t.style.position="absolute",t.style.zIndex="99999",e.setStyle(t,"opacity","0"),this._shim=t,i.on(t,"mouseup",this.handleMouseUp,this,!0),i.on(t,"mousemove",this.handleMouseMove,this,!0),i.on(window,"scroll",this._sizeShim,this,!0)},_sizeShim:function(){var t;this._shimActive&&((t=this._shim).style.height=e.getDocumentHeight()+"px",t.style.width=e.getDocumentWidth()+"px",t.style.top="0",t.style.left="0")},_activateShim:function(){var t,i;this.useShim&&(this._shim||this._createShim(),this._shimActive=!0,t=this._shim,i="0",this._debugShim&&(i=".5"),e.setStyle(t,"opacity",i),this._sizeShim(),t.style.display="block")},_deactivateShim:function(){this._shim.style.display="none",this._shimActive=!1},_shim:null,ids:{},handleIds:{},dragCurrent:null,dragOvers:{},deltaX:0,deltaY:0,preventDefault:!0,stopPropagation:!0,initialized:!1,locked:!1,interactionInfo:null,init:function(){this.initialized=!0},POINT:0,INTERSECT:1,STRICT_INTERSECT:2,mode:0,_execOnAll:function(t,i){for(var e in this.ids)for(var s in this.ids[e]){s=this.ids[e][s];this.isTypeOfDD(s)&&s[t].apply(s,i)}},_onLoad:function(){this.init(),i.on(document,"mouseup",this.handleMouseUp,this,!0),i.on(document,"mouseleave",this.handleMouseUp,this,!0),i.on(document,"mousemove",this.handleMouseMove,this,!0),i.on(window,"unload",this._onUnload,this,!0),i.on(window,"resize",this._onResize,this,!0)},_onResize:function(t){this._execOnAll("resetConstraints",[])},lock:function(){this.locked=!0},unlock:function(){this.locked=!1},isLocked:function(){return this.locked},locationCache:{},useCache:!0,clickPixelThresh:3,clickTimeThresh:1e3,dragThreshMet:!1,clickTimeout:null,startX:0,startY:0,fromTimeout:!1,regDragDrop:function(t,i){this.initialized||this.init(),this.ids[i]||(this.ids[i]={}),this.ids[i][t.id]=t},removeDDFromGroup:function(t,i){this.ids[i]||(this.ids[i]={});i=this.ids[i];i&&i[t.id]&&delete i[t.id]},_remove:function(t){for(var i in t.groups)i&&(i=this.ids[i])&&i[t.id]&&delete i[t.id];delete this.handleIds[t.id]},regHandle:function(t,i){this.handleIds[t]||(this.handleIds[t]={}),this.handleIds[t][i]=i},isDragDrop:function(t){return!!this.getDDById(t)},getRelated:function(t,i){var e,s=[];for(e in t.groups)for(var n in this.ids[e]){n=this.ids[e][n];!this.isTypeOfDD(n)||i&&!n.isTarget||(s[s.length]=n)}return s},isLegalTarget:function(t,i){for(var e=this.getRelated(t,!0),s=0,n=e.length;s<n;++s)if(e[s].id==i.id)return!0;return!1},isTypeOfDD:function(t){return t&&t.__ygDragDrop},isHandle:function(t,i){return this.handleIds[t]&&this.handleIds[t][i]},getDDById:function(t){for(var i in this.ids)if(this.ids[i][t])return this.ids[i][t];return null},handleMouseDown:function(t,i){this.currentTarget=YAHOO.util.Event.getTarget(t);i=(this.dragCurrent=i).getEl();this.startX=YAHOO.util.Event.getPageX(t),this.startY=YAHOO.util.Event.getPageY(t),this.deltaX=this.startX-i.offsetLeft,this.deltaY=this.startY-i.offsetTop,this.dragThreshMet=!1,this.clickTimeout=setTimeout(function(){var t=YAHOO.util.DDM;t.startDrag(t.startX,t.startY),t.fromTimeout=!0},this.clickTimeThresh)},startDrag:function(t,i){this.dragCurrent&&this.dragCurrent.useShim&&(this._shimState=this.useShim,this.useShim=!0),this._activateShim(),clearTimeout(this.clickTimeout);var e=this.dragCurrent;e&&e.events.b4StartDrag&&(e.b4StartDrag(t,i),e.fireEvent("b4StartDragEvent",{x:t,y:i})),e&&e.events.startDrag&&(e.startDrag(t,i),e.fireEvent("startDragEvent",{x:t,y:i})),this.dragThreshMet=!0},handleMouseUp:function(t){this.dragCurrent&&(clearTimeout(this.clickTimeout),this.dragThreshMet&&(this.fromTimeout&&(this.fromTimeout=!1,this.handleMouseMove(t)),this.fromTimeout=!1,this.fireEvents(t,!0)),this.stopDrag(t),this.stopEvent(t))},stopEvent:function(t){this.stopPropagation&&YAHOO.util.Event.stopPropagation(t),this.preventDefault&&YAHOO.util.Event.preventDefault(t)},stopDrag:function(t,i){var e=this.dragCurrent;e&&!i&&(this.dragThreshMet&&(e.events.b4EndDrag&&(e.b4EndDrag(t),e.fireEvent("b4EndDragEvent",{e:t})),e.events.endDrag)&&(e.endDrag(t),e.fireEvent("endDragEvent",{e:t})),e.events.mouseUp)&&(e.onMouseUp(t),e.fireEvent("mouseUpEvent",{e:t})),this._shimActive&&(this._deactivateShim(),this.dragCurrent)&&this.dragCurrent.useShim&&(this.useShim=this._shimState,this._shimState=!1),this.dragCurrent=null,this.dragOvers={}},handleMouseMove:function(t){var i,e,s=this.dragCurrent;if(s){if(YAHOO.env.ua.ie&&YAHOO.env.ua.ie<9&&!t.button)return this.stopEvent(t),this.handleMouseUp(t);t.clientX<0||t.clientY,!this.dragThreshMet&&(i=Math.abs(this.startX-YAHOO.util.Event.getPageX(t)),e=Math.abs(this.startY-YAHOO.util.Event.getPageY(t)),i>this.clickPixelThresh||e>this.clickPixelThresh)&&this.startDrag(this.startX,this.startY),this.dragThreshMet&&(s&&s.events.b4Drag&&(s.b4Drag(t),s.fireEvent("b4DragEvent",{e:t})),s&&s.events.drag&&(s.onDrag(t),s.fireEvent("dragEvent",{e:t})),s)&&this.fireEvents(t,!1),this.stopEvent(t)}},fireEvents:function(t,i){var e=this.dragCurrent;if(e&&!e.isLocked()&&!e.dragOnly){var s,n,r,o=YAHOO.util.Event.getPageX(t),a=YAHOO.util.Event.getPageY(t),h=new YAHOO.util.Point(o,a),o=e.getTargetCoord(h.x,h.y),a=e.getDragEl(),l=["out","over","drop","enter"],u=new YAHOO.util.Region(o.y,o.x+a.offsetWidth,o.y+a.offsetHeight,o.x),d=[],g={},c={},f=[],v={outEvts:[],overEvts:[],dropEvts:[],enterEvts:[]};for(s in this.dragOvers){var D=this.dragOvers[s];this.isTypeOfDD(D)&&(this.isOverTarget(h,D,this.mode,u)||v.outEvts.push(D),d[s]=!0,delete this.dragOvers[s])}for(n in e.groups)if("string"==typeof n)for(s in this.ids[n]){var O=this.ids[n][s];this.isTypeOfDD(O)&&O.isTarget&&!O.isLocked()&&O!=e&&this.isOverTarget(h,O,this.mode,u)&&(g[n]=!0,i?v.dropEvts.push(O):((d[O.id]?v.overEvts:v.enterEvts).push(O),this.dragOvers[O.id]=O))}for(r in this.interactionInfo={out:v.outEvts,enter:v.enterEvts,over:v.overEvts,drop:v.dropEvts,point:h,draggedRegion:u,sourceRegion:this.locationCache[e.id],validDrop:i},g)f.push(r);for(i&&!v.dropEvts.length&&(this.interactionInfo.validDrop=!1,e.events.invalidDrop)&&(e.onInvalidDrop(t),e.fireEvent("invalidDropEvent",{e:t})),s=0;s<l.length;s++){var p=v[l[s]+"Evts"]?v[l[s]+"Evts"]:null;if(p&&p.length){var m=l[s].charAt(0).toUpperCase()+l[s].substr(1),Y="onDrag"+m,y="b4Drag"+m,E="drag"+m+"Event",H="drag"+m;if(this.mode)e.events[y]&&(e[y](t,p,f),c[Y]=e.fireEvent(y+"Event",{event:t,info:p,group:f})),e.events[H]&&!1!==c[Y]&&(e[Y](t,p,f),e.fireEvent(E,{event:t,info:p,group:f}));else for(var T=0,A=p.length;T<A;++T)e.events[y]&&(e[y](t,p[T].id,f[0]),c[Y]=e.fireEvent(y+"Event",{event:t,info:p[T].id,group:f[0]})),e.events[H]&&!1!==c[Y]&&(e[Y](t,p[T].id,f[0]),e.fireEvent(E,{event:t,info:p[T].id,group:f[0]}))}}}},getBestMatch:function(t){var i=null,e=t.length;if(1==e)i=t[0];else for(var s=0;s<e;++s){var n=t[s];if(this.mode==this.INTERSECT&&n.cursorIsOver){i=n;break}i&&i.overlap&&!(n.overlap&&i.overlap.getArea()<n.overlap.getArea())||(i=n)}return i},refreshCache:function(t){for(var i in t||this.ids)if("string"==typeof i)for(var e in this.ids[i]){var s,e=this.ids[i][e];this.isTypeOfDD(e)&&((s=this.getLocation(e))?this.locationCache[e.id]=s:delete this.locationCache[e.id])}},verifyEl:function(t){try{if(t)if(t.offsetParent)return!0}catch(i){}return!1},getLocation:function(t){if(!this.isTypeOfDD(t))return null;var i,e,s,n=t.getEl();try{i=YAHOO.util.Dom.getXY(n)}catch(r){}return i?(e=(s=i[0])+n.offsetWidth,n=(i=i[1])+n.offsetHeight,i=i-t.padding[0],e=e+t.padding[1],n=n+t.padding[2],s=s-t.padding[3],new YAHOO.util.Region(i,e,n,s)):null},isOverTarget:function(t,i,e,s){var n=this.locationCache[i.id];if(n&&this.useCache||(n=this.getLocation(i),this.locationCache[i.id]=n),!n)return!1;i.cursorIsOver=n.contains(t);var r=this.dragCurrent;if(!r||!e&&!r.constrainX&&!r.constrainY)return i.cursorIsOver;i.overlap=null,s||(t=r.getTargetCoord(t.x,t.y),r=r.getDragEl(),s=new YAHOO.util.Region(t.y,t.x+r.offsetWidth,t.y+r.offsetHeight,t.x));r=s.intersect(n);return!!r&&(i.overlap=r,!!e||i.cursorIsOver)},_onUnload:function(t,i){this.unregAll()},unregAll:function(){this.dragCurrent&&(this.stopDrag(),this.dragCurrent=null),this._execOnAll("unreg",[]),this.ids={}},elementCache:{},getElWrapper:function(t){var i=this.elementCache[t];return i=i&&i.el?i:this.elementCache[t]=new this.ElementWrapper(YAHOO.util.Dom.get(t))},getElement:function(t){return YAHOO.util.Dom.get(t)},getCss:function(t){t=YAHOO.util.Dom.get(t);return t?t.style:null},ElementWrapper:function(t){this.el=t||null,this.id=this.el&&t.id,this.css=this.el&&t.style},getPosX:function(t){return YAHOO.util.Dom.getX(t)},getPosY:function(t){return YAHOO.util.Dom.getY(t)},swapNode:function(t,i){var e,s;t.swapNode?t.swapNode(i):(e=i.parentNode,(s=i.nextSibling)==t?e.insertBefore(t,i):i==t.nextSibling?e.insertBefore(i,t):(t.parentNode.replaceChild(i,t),e.insertBefore(t,s)))},getScroll:function(){var t,i,e=document.documentElement,s=document.body;return e&&(e.scrollTop||e.scrollLeft)?(t=e.scrollTop,i=e.scrollLeft):s&&(t=s.scrollTop,i=s.scrollLeft),{top:t,left:i}},getStyle:function(t,i){return YAHOO.util.Dom.getStyle(t,i)},getScrollTop:function(){return this.getScroll().top},getScrollLeft:function(){return this.getScroll().left},moveToEl:function(t,i){i=YAHOO.util.Dom.getXY(i);YAHOO.util.Dom.setXY(t,i)},getClientHeight:function(){return YAHOO.util.Dom.getViewportHeight()},getClientWidth:function(){return YAHOO.util.Dom.getViewportWidth()},numericSort:function(t,i){return t-i},_timeoutCount:0,_addListeners:function(){var t=YAHOO.util.DDM;YAHOO.util.Event&&document?t._onLoad():2e3<t._timeoutCount||(setTimeout(t._addListeners,10),document&&document.body&&(t._timeoutCount+=1))},handleWasClicked:function(t,i){if(this.isHandle(i,t.id))return!0;for(var e=t.parentNode;e;){if(this.isHandle(i,e.id))return!0;e=e.parentNode}return!1}}}(),YAHOO.util.DDM=YAHOO.util.DragDropMgr,YAHOO.util.DDM._addListeners()),function(){var o=YAHOO.util.Event,a=YAHOO.util.Dom;YAHOO.util.DragDrop=function(t,i,e){t&&this.init(t,i,e)},YAHOO.util.DragDrop.prototype={events:null,on:function(){this.subscribe.apply(this,arguments)},id:null,config:null,dragElId:null,handleElId:null,invalidHandleTypes:null,invalidHandleIds:null,invalidHandleClasses:null,startPageX:0,startPageY:0,groups:null,locked:!1,lock:function(){this.locked=!0},unlock:function(){this.locked=!1},isTarget:!0,padding:null,dragOnly:!1,useShim:!1,_domRef:null,__ygDragDrop:!0,constrainX:!1,constrainY:!1,minX:0,maxX:0,minY:0,maxY:0,deltaX:0,deltaY:0,maintainOffset:!1,xTicks:null,yTicks:null,primaryButtonOnly:!0,available:!1,hasOuterHandles:!1,cursorIsOver:!1,overlap:null,b4StartDrag:function(t,i){},startDrag:function(t,i){},b4Drag:function(t){},onDrag:function(t){},onDragEnter:function(t,i){},b4DragOver:function(t){},onDragOver:function(t,i){},b4DragOut:function(t){},onDragOut:function(t,i){},b4DragDrop:function(t){},onDragDrop:function(t,i){},onInvalidDrop:function(t){},b4EndDrag:function(t){},endDrag:function(t){},b4MouseDown:function(t){},onMouseDown:function(t){},onMouseUp:function(t){},onAvailable:function(){},getEl:function(){return this._domRef||(this._domRef=a.get(this.id)),this._domRef},getDragEl:function(){return a.get(this.dragElId)},init:function(t,i,e){for(var s in this.initTarget(t,i,e),o.on(this._domRef||this.id,"mousedown",this.handleMouseDown,this,!0),this.events)this.createEvent(s+"Event")},initTarget:function(t,i,e){this.config=e||{},this.events={},this.DDM=YAHOO.util.DDM,this.groups={},"string"!=typeof t&&(this._domRef=t,t=a.generateId(t)),this.id=t,this.addToGroup(i||"default"),this.handleElId=t,o.onAvailable(t,this.handleOnAvailable,this,!0),this.setDragElId(t),this.invalidHandleTypes={A:"A"},this.invalidHandleIds={},this.invalidHandleClasses=[],this.applyConfig()},applyConfig:function(){if(this.events={mouseDown:!0,b4MouseDown:!0,mouseUp:!0,b4StartDrag:!0,startDrag:!0,b4EndDrag:!0,endDrag:!0,drag:!0,b4Drag:!0,invalidDrop:!0,b4DragOut:!0,dragOut:!0,dragEnter:!0,b4DragOver:!0,dragOver:!0,b4DragDrop:!0,dragDrop:!0},this.config.events)for(var t in this.config.events)!1===this.config.events[t]&&(this.events[t]=!1);this.padding=this.config.padding||[0,0,0,0],this.isTarget=!1!==this.config.isTarget,this.maintainOffset=this.config.maintainOffset,this.primaryButtonOnly=!1!==this.config.primaryButtonOnly,this.dragOnly=!0===this.config.dragOnly,this.useShim=!0===this.config.useShim},handleOnAvailable:function(){this.available=!0,this.resetConstraints(),this.onAvailable()},setPadding:function(t,i,e,s){this.padding=i||0===i?e||0===e?[t,i,e,s]:[t,i,t,i]:[t,t,t,t]},setInitPosition:function(t,i){var e,s=this.getEl();this.DDM.verifyEl(s)?(t=t||0,i=i||0,e=a.getXY(s),this.initPageX=e[0]-t,this.initPageY=e[1]-i,this.lastPageX=e[0],this.lastPageY=e[1],this.setStartPosition(e)):s&&s.style&&s.style.display},setStartPosition:function(t){t=t||a.getXY(this.getEl());this.deltaSetXY=null,this.startPageX=t[0],this.startPageY=t[1]},addToGroup:function(t){this.groups[t]=!0,this.DDM.regDragDrop(this,t)},removeFromGroup:function(t){this.groups[t]&&delete this.groups[t],this.DDM.removeDDFromGroup(this,t)},setDragElId:function(t){this.dragElId=t},setHandleElId:function(t){"string"!=typeof t&&(t=a.generateId(t)),this.handleElId=t,this.DDM.regHandle(this.id,t)},setOuterHandleElId:function(t){"string"!=typeof t&&(t=a.generateId(t)),o.on(t,"mousedown",this.handleMouseDown,this,!0),this.setHandleElId(t),this.hasOuterHandles=!0},unreg:function(){o.removeListener(this.id,"mousedown",this.handleMouseDown),this._domRef=null,this.DDM._remove(this)},isLocked:function(){return this.DDM.isLocked()||this.locked},handleMouseDown:function(t,i){var e,s,n,r=t.which||t.button;this.primaryButtonOnly&&1<r||this.isLocked()||(r=this.b4MouseDown(t),e=!0,this.events.b4MouseDown&&(e=this.fireEvent("b4MouseDownEvent",t)),s=this.onMouseDown(t),n=!0,this.events.mouseDown&&(n=!1!==s&&this.fireEvent("mouseDownEvent",t)),!1!==r&&!1!==s&&!1!==e&&!1!==n&&(this.DDM.refreshCache(this.groups),r=new YAHOO.util.Point(o.getPageX(t),o.getPageY(t)),this.hasOuterHandles||this.DDM.isOverTarget(r,this))&&this.clickValidator(t)&&(this.setStartPosition(),this.DDM.handleMouseDown(t,this),this.DDM.stopEvent(t)))},clickValidator:function(t){t=YAHOO.util.Event.getTarget(t);return this.isValidHandleChild(t)&&(this.id==this.handleElId||this.DDM.handleWasClicked(t,this.id))},getTargetCoord:function(t,i){t-=this.deltaX,i-=this.deltaY;return this.constrainX&&(t=t<this.minX?this.minX:t)>this.maxX&&(t=this.maxX),this.constrainY&&(i=i<this.minY?this.minY:i)>this.maxY&&(i=this.maxY),{x:t=this.getTick(t,this.xTicks),y:i=this.getTick(i,this.yTicks)}},addInvalidHandleType:function(t){t=t.toUpperCase();this.invalidHandleTypes[t]=t},addInvalidHandleId:function(t){"string"!=typeof t&&(t=a.generateId(t)),this.invalidHandleIds[t]=t},addInvalidHandleClass:function(t){this.invalidHandleClasses.push(t)},removeInvalidHandleType:function(t){t=t.toUpperCase();delete this.invalidHandleTypes[t]},removeInvalidHandleId:function(t){"string"!=typeof t&&(t=a.generateId(t)),delete this.invalidHandleIds[t]},removeInvalidHandleClass:function(t){for(var i=0,e=this.invalidHandleClasses.length;i<e;++i)this.invalidHandleClasses[i]==t&&delete this.invalidHandleClasses[i]},isValidHandleChild:function(t){var i,e=!0;try{i=t.nodeName.toUpperCase()}catch(r){i=t.nodeName}for(var e=(e=e&&!this.invalidHandleTypes[i])&&!this.invalidHandleIds[t.id],s=0,n=this.invalidHandleClasses.length;e&&s<n;++s)e=!a.hasClass(t,this.invalidHandleClasses[s]);return e},setXTicks:function(t,i){this.xTicks=[],this.xTickSize=i;for(var e={},s=this.initPageX;s>=this.minX;s-=i)e[s]||(e[this.xTicks[this.xTicks.length]=s]=!0);for(s=this.initPageX;s<=this.maxX;s+=i)e[s]||(e[this.xTicks[this.xTicks.length]=s]=!0);this.xTicks.sort(this.DDM.numericSort)},setYTicks:function(t,i){this.yTicks=[],this.yTickSize=i;for(var e={},s=this.initPageY;s>=this.minY;s-=i)e[s]||(e[this.yTicks[this.yTicks.length]=s]=!0);for(s=this.initPageY;s<=this.maxY;s+=i)e[s]||(e[this.yTicks[this.yTicks.length]=s]=!0);this.yTicks.sort(this.DDM.numericSort)},setXConstraint:function(t,i,e){this.leftConstraint=parseInt(t,10),this.rightConstraint=parseInt(i,10),this.minX=this.initPageX-this.leftConstraint,this.maxX=this.initPageX+this.rightConstraint,e&&this.setXTicks(this.initPageX,e),this.constrainX=!0},clearConstraints:function(){this.constrainX=!1,this.constrainY=!1,this.clearTicks()},clearTicks:function(){this.xTicks=null,this.yTicks=null,this.xTickSize=0,this.yTickSize=0},setYConstraint:function(t,i,e){this.topConstraint=parseInt(t,10),this.bottomConstraint=parseInt(i,10),this.minY=this.initPageY-this.topConstraint,this.maxY=this.initPageY+this.bottomConstraint,e&&this.setYTicks(this.initPageY,e),this.constrainY=!0},resetConstraints:function(){var t,i;this.initPageX||0===this.initPageX?(t=this.maintainOffset?this.lastPageX-this.initPageX:0,i=this.maintainOffset?this.lastPageY-this.initPageY:0,this.setInitPosition(t,i)):this.setInitPosition(),this.constrainX&&this.setXConstraint(this.leftConstraint,this.rightConstraint,this.xTickSize),this.constrainY&&this.setYConstraint(this.topConstraint,this.bottomConstraint,this.yTickSize)},getTick:function(t,i){if(i){if(i[0]>=t)return i[0];for(var e=0,s=i.length;e<s;++e){var n=e+1;if(i[n]&&i[n]>=t)return t-i[e]<i[n]-t?i[e]:i[n]}return i[i.length-1]}return t},toString:function(){return"DragDrop "+this.id}},YAHOO.augment(YAHOO.util.DragDrop,YAHOO.util.EventProvider)}(),YAHOO.util.DD=function(t,i,e){t&&this.init(t,i,e)},YAHOO.extend(YAHOO.util.DD,YAHOO.util.DragDrop,{scroll:!0,autoOffset:function(t,i){t-=this.startPageX,i-=this.startPageY;this.setDelta(t,i)},setDelta:function(t,i){this.deltaX=t,this.deltaY=i},setDragElPos:function(t,i){var e=this.getDragEl();this.alignElWithMouse(e,t,i)},alignElWithMouse:function(t,i,e){var s=this.getTargetCoord(i,e),n=(this.deltaSetXY?(YAHOO.util.Dom.setStyle(t,"left",s.x+this.deltaSetXY[0]+"px"),YAHOO.util.Dom.setStyle(t,"top",s.y+this.deltaSetXY[1]+"px")):(i=[s.x,s.y],YAHOO.util.Dom.setXY(t,i),e=parseInt(YAHOO.util.Dom.getStyle(t,"left"),10),i=parseInt(YAHOO.util.Dom.getStyle(t,"top"),10),this.deltaSetXY=[e-s.x,i-s.y]),this.cachePosition(s.x,s.y),this);setTimeout(function(){n.autoScroll.call(n,s.x,s.y,t.offsetHeight,t.offsetWidth)},0)},cachePosition:function(t,i){t?(this.lastPageX=t,this.lastPageY=i):(t=YAHOO.util.Dom.getXY(this.getEl()),this.lastPageX=t[0],this.lastPageY=t[1])},autoScroll:function(t,i,e,s){var n,r,o,a,h,l,u;this.scroll&&(n=this.DDM.getClientHeight(),r=this.DDM.getClientWidth(),o=this.DDM.getScrollTop(),a=this.DDM.getScrollLeft(),s=s+t,h=n+o-i-this.deltaY,l=r+a-t-this.deltaX,u=document.all?80:30,n<e+i&&h<40&&window.scrollTo(a,o+u),i<o&&0<o&&i-o<40&&window.scrollTo(a,o-u),r<s&&l<40&&window.scrollTo(a+u,o),t<a)&&0<a&&t-a<40&&window.scrollTo(a-u,o)},applyConfig:function(){YAHOO.util.DD.superclass.applyConfig.call(this),this.scroll=!1!==this.config.scroll},b4MouseDown:function(t){this.setStartPosition(),this.autoOffset(YAHOO.util.Event.getPageX(t),YAHOO.util.Event.getPageY(t))},b4Drag:function(t){this.setDragElPos(YAHOO.util.Event.getPageX(t),YAHOO.util.Event.getPageY(t))},toString:function(){return"DD "+this.id}}),YAHOO.util.DDProxy=function(t,i,e){t&&(this.init(t,i,e),this.initFrame())},YAHOO.util.DDProxy.dragElId="ygddfdiv",YAHOO.extend(YAHOO.util.DDProxy,YAHOO.util.DD,{resizeFrame:!0,centerFrame:!1,createFrame:function(){var t,i,e,s=this,n=document.body;n&&n.firstChild?(t=this.getDragEl(),i=YAHOO.util.Dom,t||((t=document.createElement("div")).id=this.dragElId,(e=t.style).position="absolute",e.visibility="hidden",e.cursor="move",e.border="2px solid #aaa",e.zIndex=999,e.height="25px",e.width="25px",e=document.createElement("div"),i.setStyle(e,"height","100%"),i.setStyle(e,"width","100%"),i.setStyle(e,"background-color","#ccc"),i.setStyle(e,"opacity","0"),t.appendChild(e),n.insertBefore(t,n.firstChild))):setTimeout(function(){s.createFrame()},50)},initFrame:function(){this.createFrame()},applyConfig:function(){YAHOO.util.DDProxy.superclass.applyConfig.call(this),this.resizeFrame=!1!==this.config.resizeFrame,this.centerFrame=this.config.centerFrame,this.setDragElId(this.config.dragElId||YAHOO.util.DDProxy.dragElId)},showFrame:function(t,i){this.getEl();var e=this.getDragEl(),s=e.style;this._resizeProxy(),this.centerFrame&&this.setDelta(Math.round(parseInt(s.width,10)/2),Math.round(parseInt(s.height,10)/2)),this.setDragElPos(t,i),YAHOO.util.Dom.setStyle(e,"visibility","visible")},_resizeProxy:function(){var t,i,e,s,n,r,o;this.resizeFrame&&(t=YAHOO.util.Dom,i=this.getEl(),e=this.getDragEl(),s=parseInt(t.getStyle(e,"borderTopWidth"),10),r=parseInt(t.getStyle(e,"borderRightWidth"),10),n=parseInt(t.getStyle(e,"borderBottomWidth"),10),o=parseInt(t.getStyle(e,"borderLeftWidth"),10),isNaN(s)&&(s=0),isNaN(r)&&(r=0),isNaN(n)&&(n=0),isNaN(o)&&(o=0),r=Math.max(0,i.offsetWidth-r-o),o=Math.max(0,i.offsetHeight-s-n),t.setStyle(e,"width",r+"px"),t.setStyle(e,"height",o+"px"))},b4MouseDown:function(t){this.setStartPosition();var i=YAHOO.util.Event.getPageX(t),t=YAHOO.util.Event.getPageY(t);this.autoOffset(i,t)},b4StartDrag:function(t,i){this.showFrame(t,i)},b4EndDrag:function(t){YAHOO.util.Dom.setStyle(this.getDragEl(),"visibility","hidden")},endDrag:function(t){var i=YAHOO.util.Dom,e=this.getEl(),s=this.getDragEl();i.setStyle(s,"visibility",""),i.setStyle(e,"visibility","hidden"),YAHOO.util.DDM.moveToEl(e,s),i.setStyle(s,"visibility","hidden"),i.setStyle(e,"visibility","")},toString:function(){return"DDProxy "+this.id}}),YAHOO.util.DDTarget=function(t,i,e){t&&this.initTarget(t,i,e)},YAHOO.extend(YAHOO.util.DDTarget,YAHOO.util.DragDrop,{toString:function(){return"DDTarget "+this.id}}),YAHOO.register("dragdrop",YAHOO.util.DragDropMgr,{version:"2.9.0",build:"2800"});
//# sourceMappingURL=dragdrop.js.map;
YAHOO.util.History=function(){var s=null,d=null,c=!1,g=[];function O(){var t=self.location.href,e=t.indexOf("#");return 0<=e?t.substr(e+1):null}function h(){var t,e,n=[],r=[];for(t in g)YAHOO.lang.hasOwnProperty(g,t)&&(e=g[t],n.push(t+"="+e.initialState),r.push(t+"="+e.currentState));d.value=n.join("&")+"|"+r.join("&")}function p(t){var e,n,r,i,o,a,l,u;if(t){for(o=[],e=0,n=(a=t.split("&")).length;e<n;e++)2===(l=a[e].split("=")).length&&(r=l[0],u=l[1],o[r]=u);for(r in g)YAHOO.lang.hasOwnProperty(g,r)&&(i=g[r],(u=o[r])&&i.currentState===u||(i.currentState=void 0===u?i.initialState:u,i.onStateChange(y(i.currentState))))}else for(r in g)YAHOO.lang.hasOwnProperty(g,r)&&((i=g[r]).currentState=i.initialState,i.onStateChange(y(i.currentState)))}function f(t){var e,t='<html><body><div id="state">'+YAHOO.lang.escapeHTML(t)+"</div></body></html>";try{return(e=s.contentWindow.document).open(),e.write(t),e.close(),!0}catch(n){return!1}}function m(){var o,a,l,u;s.contentWindow&&s.contentWindow.document?(o=s.contentWindow.document,a=o.getElementById("state"),l=a?a.innerText:null,u=O(),setInterval(function(){var t,e,n,r,i;if(o=s.contentWindow.document,t=(a=o.getElementById("state"))?a.innerText:null,i=O(),t!==l){if(p(l=t),l)i=l;else{for(n in e=[],g)YAHOO.lang.hasOwnProperty(g,n)&&(r=g[n],e.push(n+"="+r.initialState));i=e.join("&")}self.location.hash=i,u=i,h()}else i!==u&&f(u=i)},50),c=!0,YAHOO.util.History.onLoadEvent.fire()):setTimeout(m,10)}function n(){var t,e,n,r,i,o,a,l,u,s,f=d.value.split("|");if(1<f.length){for(e=(o=f[t=0].split("&")).length;t<e;t++)2===(n=o[t].split("=")).length&&(r=n[0],a=n[1],i=YAHOO.lang.hasOwnProperty(g,r)&&g[r])&&(i.initialState=a);for(t=0,e=(l=f[1].split("&")).length;t<e;t++)2<=(n=l[t].split("=")).length&&(r=n[0],u=n[1],i=YAHOO.lang.hasOwnProperty(g,r)&&g[r])&&(i.currentState=u)}2<f.length&&f[2].split(","),YAHOO.env.ua.ie?"undefined"==typeof document.documentMode||document.documentMode<8?m():(YAHOO.util.Event.on(top,"hashchange",function(){p(O()),h()}),c=!0,YAHOO.util.History.onLoadEvent.fire()):(s=O(),setInterval(function(){var t=O();t!==s&&(p(s=t),h())},50),c=!0,YAHOO.util.History.onLoadEvent.fire())}function y(t){return decodeURIComponent(t.replace(/\+/g," "))}function a(t){return encodeURIComponent(t).replace(/%20/g,"+")}return{onLoadEvent:new YAHOO.util.CustomEvent("onLoad"),onReady:function(e,n,r){c?setTimeout(function(){var t=window;e.call(t=r?!0===r?n:r:t,"onLoad",[],n)},0):YAHOO.util.History.onLoadEvent.subscribe(e,n,r)},register:function(t,e,n,r,i){var o;if("string"!=typeof t||""===YAHOO.lang.trim(t)||"string"!=typeof e||"function"!=typeof n)throw new Error("Missing or invalid argument");if(!YAHOO.lang.hasOwnProperty(g,t)){if(c)throw new Error("All modules must be registered before calling YAHOO.util.History.initialize");t=a(t),e=a(e),o=!(o=null)===i?r:i,g[t]={name:t,initialState:e,currentState:e,onStateChange:function(t){return n.call(o,t,r)}}}},initialize:function(t,e){if(!c){if(YAHOO.env.ua.opera&&"undefined"!=typeof history.navigationMode&&(history.navigationMode="compatible"),!(t="string"==typeof t?document.getElementById(t):t)||"TEXTAREA"!==t.tagName.toUpperCase()&&("INPUT"!==t.tagName.toUpperCase()||"hidden"!==t.type&&"text"!==t.type))throw new Error("Missing or invalid argument");if(d=t,YAHOO.env.ua.ie&&("undefined"==typeof document.documentMode||document.documentMode<8)){if(!(e="string"==typeof e?document.getElementById(e):e)||"IFRAME"!==e.tagName.toUpperCase())throw new Error("Missing or invalid argument");s=e}YAHOO.util.Event.onDOMReady(n)}},navigate:function(t,e){var n;if("string"!=typeof t||"string"!=typeof e)throw new Error("Missing or invalid argument");return(n={})[t]=e,YAHOO.util.History.multiNavigate(n)},multiNavigate:function(t){var e,n,r,i;if("object"!=typeof t)throw new Error("Missing or invalid argument");if(!c)throw new Error("The Browser History Manager is not initialized");for(n in t)if(!YAHOO.lang.hasOwnProperty(g,a(n)))throw new Error("The following module has not been registered: "+n);for(n in e=[],g)YAHOO.lang.hasOwnProperty(g,n)&&(r=g[n],r=YAHOO.lang.hasOwnProperty(t,n)?t[y(n)]:y(r.currentState),n=a(n),r=a(r),e.push(n+"="+r));return i=e.join("&"),YAHOO.env.ua.ie&&("undefined"==typeof document.documentMode||document.documentMode<8)?f(i):(self.location.hash=i,!0)},getCurrentState:function(t){var e;if("string"!=typeof t)throw new Error("Missing or invalid argument");if(!c)throw new Error("The Browser History Manager is not initialized");if(e=YAHOO.lang.hasOwnProperty(g,t)&&g[t])return y(e.currentState);throw new Error("No such registered module: "+t)},getBookmarkedState:function(t){var e,n,r,i,o;if("string"!=typeof t)throw new Error("Missing or invalid argument");if(0<=(r=self.location.href.indexOf("#")))for(e=0,n=(i=self.location.href.substr(r+1).split("&")).length;e<n;e++)if(2===(o=i[e].split("=")).length&&o[0]===t)return y(o[1]);return null},getQueryStringParameter:function(t,e){for(var n,r,i,o=0,a=(r=(e=0<=(n=(e=0<=(n=(e=e||self.location.href).indexOf("?"))?e.substr(n+1):e).lastIndexOf("#"))?e.substr(0,n):e).split("&")).length;o<a;o++)if(2<=(i=r[o].split("=")).length&&i[0]===t)return y(i[1]);return null}}}(),YAHOO.register("history",YAHOO.util.History,{version:"2.9.0",build:"2800"});
//# sourceMappingURL=history.js.map;
!function(){YAHOO.util.Config=function(e){e&&this.init(e)};var g=YAHOO.lang,i=YAHOO.util.CustomEvent,n=YAHOO.util.Config;n.CONFIG_CHANGED_EVENT="configChanged",n.BOOLEAN_TYPE="boolean",n.prototype={owner:null,queueInProgress:!1,config:null,initialConfig:null,eventQueue:null,configChangedEvent:null,init:function(e){this.owner=e,this.configChangedEvent=this.createEvent(n.CONFIG_CHANGED_EVENT),this.configChangedEvent.signature=i.LIST,this.queueInProgress=!1,this.config={},this.initialConfig={},this.eventQueue=[]},checkBoolean:function(e){return typeof e==n.BOOLEAN_TYPE},checkNumber:function(e){return!isNaN(e)},fireEvent:function(e,t){e=this.config[e];e&&e.event&&e.event.fire(t)},addProperty:function(e,t){e=e.toLowerCase(),(this.config[e]=t).event=this.createEvent(e,{scope:this.owner}),t.event.signature=i.LIST,t.key=e,t.handler&&t.event.subscribe(t.handler,this.owner),this.setProperty(e,t.value,!0),t.suppressEvent||this.queueProperty(e,t.value)},getConfig:function(){var e,t,i={},s=this.config;for(e in s)g.hasOwnProperty(s,e)&&(t=s[e])&&t.event&&(i[e]=t.value);return i},getProperty:function(e){e=this.config[e.toLowerCase()];return e&&e.event?e.value:undefined},resetProperty:function(e){e=e.toLowerCase();var t=this.config[e];return!(!t||!t.event)&&(e in this.initialConfig?(this.setProperty(e,this.initialConfig[e]),!0):void 0)},setProperty:function(e,t,i){var s;return e=e.toLowerCase(),this.queueInProgress&&!i?(this.queueProperty(e,t),!0):!(!(s=this.config[e])||!s.event||s.validator&&!s.validator(t)||(s.value=t,i||(this.fireEvent(e,t),this.configChangedEvent.fire([e,t])),0))},queueProperty:function(e,t){e=e.toLowerCase();var i,s,n,r,o,a,h,l,u,c,d,f=this.config[e],v=!1;if(f&&f.event){if(!g.isUndefined(t)&&f.validator&&!f.validator(t))return!1;for(g.isUndefined(t)?t=f.value:f.value=t,v=!1,i=this.eventQueue.length,u=0;u<i;u++)if((n=this.eventQueue[u])&&(s=n[0],n=n[1],s==e)){this.eventQueue[u]=null,this.eventQueue.push([e,g.isUndefined(t)?n:t]),v=!0;break}if(v||g.isUndefined(t)||this.eventQueue.push([e,t]),f.supercedes)for(r=f.supercedes.length,c=0;c<r;c++)for(o=f.supercedes[c],a=this.eventQueue.length,d=0;d<a;d++)if((l=this.eventQueue[d])&&(h=l[0],l=l[1],h==o.toLowerCase())){this.eventQueue.push([h,l]),this.eventQueue[d]=null;break}return!0}return!1},refireEvent:function(e){e=e.toLowerCase();var t=this.config[e];t&&t.event&&!g.isUndefined(t.value)&&(this.queueInProgress?this.queueProperty(e):this.fireEvent(e,t.value))},applyConfig:function(e,t){var i,s;if(t){for(i in s={},e)g.hasOwnProperty(e,i)&&(s[i.toLowerCase()]=e[i]);this.initialConfig=s}for(i in e)g.hasOwnProperty(e,i)&&this.queueProperty(i,e[i])},refresh:function(){for(var e in this.config)g.hasOwnProperty(this.config,e)&&this.refireEvent(e)},fireQueue:function(){var e,t,i;for(this.queueInProgress=!0,e=0;e<this.eventQueue.length;e++)(i=this.eventQueue[e])&&(t=i[0],i=i[1],this.config[t].value=i,this.eventQueue[e]=null,this.fireEvent(t,i));this.queueInProgress=!1,this.eventQueue=[]},subscribeToConfigEvent:function(e,t,i,s){e=this.config[e.toLowerCase()];return!(!e||!e.event||(n.alreadySubscribed(e.event,t,i)||e.event.subscribe(t,i,s),0))},unsubscribeFromConfigEvent:function(e,t,i){e=this.config[e.toLowerCase()];return!(!e||!e.event)&&e.event.unsubscribe(t,i)},toString:function(){var e="Config";return this.owner&&(e+=" ["+this.owner.toString()+"]"),e},outputEventQueue:function(){for(var e,t="",i=this.eventQueue.length,s=0;s<i;s++)(e=this.eventQueue[s])&&(t+=e[0]+"="+e[1]+", ");return t},destroy:function(){var e,t,i=this.config;for(e in i)g.hasOwnProperty(i,e)&&((t=i[e]).event.unsubscribeAll(),t.event=null);this.configChangedEvent.unsubscribeAll(),this.configChangedEvent=null,this.owner=null,this.config=null,this.initialConfig=null,this.eventQueue=null}},n.alreadySubscribed=function(e,t,i){var s,n,r=e.subscribers.length;if(0<r){n=r-1;do{if((s=e.subscribers[n])&&s.obj==i&&s.fn==t)return!0}while(n--)}return!1},YAHOO.lang.augmentProto(n,YAHOO.util.EventProvider)}(),function(){YAHOO.widget.Module=function(e,t){e&&this.init(e,t)};var e,t,i,s,n,a=YAHOO.util.Dom,h=YAHOO.util.Config,r=YAHOO.util.Event,o=YAHOO.util.CustomEvent,l=YAHOO.widget.Module,u=YAHOO.env.ua,c="beforeInit",d="init",f="append",v="beforeRender",g="render",m="changeHeader",E="changeBody",p="changeFooter",y="changeContent",b="destroy",O="beforeShow",_="show",C="beforeHide",T="hide",S={VISIBLE:{key:"visible",value:!0,validator:YAHOO.lang.isBoolean},EFFECT:{key:"effect",suppressEvent:!0,supercedes:["visible"]},MONITOR_RESIZE:{key:"monitorresize",value:!0},APPEND_TO_DOCUMENT_BODY:{key:"appendtodocumentbody",value:!1}};function w(){return e||((e=document.createElement("div")).innerHTML='<div class="'+l.CSS_HEADER+'"></div><div class="'+l.CSS_BODY+'"></div><div class="'+l.CSS_FOOTER+'"></div>',t=e.firstChild,i=t.nextSibling,s=i.nextSibling),e}function I(){return t||w(),t.cloneNode(!1)}function A(){return i||w(),i.cloneNode(!1)}function P(){return s||w(),s.cloneNode(!1)}l.IMG_ROOT=null,l.IMG_ROOT_SSL=null,l.CSS_MODULE="yui-module",l.CSS_HEADER="hd",l.CSS_BODY="bd",l.CSS_FOOTER="ft",l.RESIZE_MONITOR_SECURE_URL="javascript:false;",l.RESIZE_MONITOR_BUFFER=1,l.textResizeEvent=new o("textResize"),l.forceDocumentRedraw=function(){var e=document.documentElement;e&&(e.className+=" ",e.className=YAHOO.lang.trim(e.className))},l.prototype={constructor:l,element:null,header:null,body:null,footer:null,id:null,imageRoot:l.IMG_ROOT,initEvents:function(){var e=o.LIST;this.beforeInitEvent=this.createEvent(c),this.beforeInitEvent.signature=e,this.initEvent=this.createEvent(d),this.initEvent.signature=e,this.appendEvent=this.createEvent(f),this.appendEvent.signature=e,this.beforeRenderEvent=this.createEvent(v),this.beforeRenderEvent.signature=e,this.renderEvent=this.createEvent(g),this.renderEvent.signature=e,this.changeHeaderEvent=this.createEvent(m),this.changeHeaderEvent.signature=e,this.changeBodyEvent=this.createEvent(E),this.changeBodyEvent.signature=e,this.changeFooterEvent=this.createEvent(p),this.changeFooterEvent.signature=e,this.changeContentEvent=this.createEvent(y),this.changeContentEvent.signature=e,this.destroyEvent=this.createEvent(b),this.destroyEvent.signature=e,this.beforeShowEvent=this.createEvent(O),this.beforeShowEvent.signature=e,this.showEvent=this.createEvent(_),this.showEvent.signature=e,this.beforeHideEvent=this.createEvent(C),this.beforeHideEvent.signature=e,this.hideEvent=this.createEvent(T),this.hideEvent.signature=e},platform:-1!=(n=navigator.userAgent.toLowerCase()).indexOf("windows")||-1!=n.indexOf("win32")?"windows":-1!=n.indexOf("macintosh")&&"mac",browser:-1!=(n=navigator.userAgent.toLowerCase()).indexOf("opera")?"opera":-1!=n.indexOf("msie 7")?"ie7":-1!=n.indexOf("msie")?"ie":-1!=n.indexOf("safari")?"safari":-1!=n.indexOf("gecko")&&"gecko",isSecure:0===window.location.href.toLowerCase().indexOf("https"),initDefaultConfig:function(){this.cfg.addProperty(S.VISIBLE.key,{handler:this.configVisible,value:S.VISIBLE.value,validator:S.VISIBLE.validator}),this.cfg.addProperty(S.EFFECT.key,{handler:this.configEffect,suppressEvent:S.EFFECT.suppressEvent,supercedes:S.EFFECT.supercedes}),this.cfg.addProperty(S.MONITOR_RESIZE.key,{handler:this.configMonitorResize,value:S.MONITOR_RESIZE.value}),this.cfg.addProperty(S.APPEND_TO_DOCUMENT_BODY.key,{value:S.APPEND_TO_DOCUMENT_BODY.value})},init:function(e,t){var i,s;if(this.initEvents(),this.beforeInitEvent.fire(l),this.cfg=new h(this),this.isSecure&&(this.imageRoot=l.IMG_ROOT_SSL),"string"!=typeof e||(i=e,e=document.getElementById(e))||((e=w().cloneNode(!1)).id=i),this.id=a.generateId(e),this.element=e,s=this.element.firstChild)for(var n=!1,r=!1,o=!1;1==s.nodeType&&(!n&&a.hasClass(s,l.CSS_HEADER)?(this.header=s,n=!0):!r&&a.hasClass(s,l.CSS_BODY)?(this.body=s,r=!0):!o&&a.hasClass(s,l.CSS_FOOTER)&&(this.footer=s,o=!0)),s=s.nextSibling;);this.initDefaultConfig(),a.addClass(this.element,l.CSS_MODULE),t&&this.cfg.applyConfig(t,!0),h.alreadySubscribed(this.renderEvent,this.cfg.fireQueue,this.cfg)||this.renderEvent.subscribe(this.cfg.fireQueue,this.cfg,!0),this.initEvent.fire(l)},initResizeMonitor:function(){var e;u.gecko&&"windows"==this.platform?(e=this,setTimeout(function(){e._initResizeMonitor()},0)):this._initResizeMonitor()},_initResizeMonitor:function(){var e,t,i,s;function n(){l.textResizeEvent.fire()}u.opera||(e=a.get("_yuiResizeMonitor"),t=this._supportsCWResize(),e||(e=document.createElement("iframe"),this.isSecure&&l.RESIZE_MONITOR_SECURE_URL&&u.ie&&(e.src=l.RESIZE_MONITOR_SECURE_URL),t||(i=["<html><head><script ",'type="text/javascript">',"window.onresize=function(){window.parent.","YAHOO.widget.Module.textResizeEvent.","fire();};<","/script></head>","<body></body></html>"].join(""),e.src="data:text/html;charset=utf-8,"+encodeURIComponent(i)),e.id="_yuiResizeMonitor",e.title="Text Resize Monitor",e.tabIndex=-1,e.setAttribute("role","presentation"),e.style.position="absolute",e.style.visibility="hidden",(s=(i=document.body).firstChild)?i.insertBefore(e,s):i.appendChild(e),e.style.backgroundColor="transparent",e.style.borderWidth="0",e.style.width="2em",e.style.height="2em",e.style.left="0",e.style.top=-1*(e.offsetHeight+l.RESIZE_MONITOR_BUFFER)+"px",e.style.visibility="visible",u.webkit&&((s=e.contentWindow.document).open(),s.close())),e&&e.contentWindow&&(l.textResizeEvent.subscribe(this.onDomResize,this,!0),l.textResizeInitialized||(t&&!r.on(e.contentWindow,"resize",n)&&r.on(e,"resize",n),l.textResizeInitialized=!0),this.resizeMonitor=e))},_supportsCWResize:function(){var e=!0;return e=u.gecko&&u.gecko<=1.8?!1:e},onDomResize:function(e,t){var i=-1*(this.resizeMonitor.offsetHeight+l.RESIZE_MONITOR_BUFFER);this.resizeMonitor.style.top=i+"px",this.resizeMonitor.style.left="0"},setHeader:function(e){var t=this.header||(this.header=I());e.nodeName?(t.innerHTML="",t.appendChild(e)):t.innerHTML=e,this._rendered&&this._renderHeader(),this.changeHeaderEvent.fire(e),this.changeContentEvent.fire()},appendToHeader:function(e){(this.header||(this.header=I())).appendChild(e),this.changeHeaderEvent.fire(e),this.changeContentEvent.fire()},setBody:function(e){var t=this.body||(this.body=A());e.nodeName?(t.innerHTML="",t.appendChild(e)):t.innerHTML=e,this._rendered&&this._renderBody(),this.changeBodyEvent.fire(e),this.changeContentEvent.fire()},appendToBody:function(e){(this.body||(this.body=A())).appendChild(e),this.changeBodyEvent.fire(e),this.changeContentEvent.fire()},setFooter:function(e){var t=this.footer||(this.footer=P());e.nodeName?(t.innerHTML="",t.appendChild(e)):t.innerHTML=e,this._rendered&&this._renderFooter(),this.changeFooterEvent.fire(e),this.changeContentEvent.fire()},appendToFooter:function(e){(this.footer||(this.footer=P())).appendChild(e),this.changeFooterEvent.fire(e),this.changeContentEvent.fire()},render:function(e,t){var i=this;if(this.beforeRenderEvent.fire(),t=t||this.element,e)(e="string"==typeof(e=e)?document.getElementById(e):e)&&(i._addToParent(e,i.element),i.appendEvent.fire());else if(!a.inDocument(this.element))return!1;return this._renderHeader(t),this._renderBody(t),this._renderFooter(t),this._rendered=!0,this.renderEvent.fire(),!0},_renderHeader:function(e){var t;e=e||this.element,this.header&&!a.inDocument(this.header)&&((t=e.firstChild)?e.insertBefore(this.header,t):e.appendChild(this.header))},_renderBody:function(e){e=e||this.element,this.body&&!a.inDocument(this.body)&&(this.footer&&a.isAncestor(e,this.footer)?e.insertBefore(this.body,this.footer):e.appendChild(this.body))},_renderFooter:function(e){e=e||this.element,this.footer&&!a.inDocument(this.footer)&&e.appendChild(this.footer)},destroy:function(e){var t;this.element&&(r.purgeElement(this.element,!e),t=this.element.parentNode),t&&t.removeChild(this.element),this.element=null,this.header=null,this.body=null,this.footer=null,l.textResizeEvent.unsubscribe(this.onDomResize,this),this.cfg.destroy(),this.cfg=null,this.destroyEvent.fire()},show:function(){this.cfg.setProperty("visible",!0)},hide:function(){this.cfg.setProperty("visible",!1)},configVisible:function(e,t,i){t[0]?this.beforeShowEvent.fire()&&(a.setStyle(this.element,"display","block"),this.showEvent.fire()):this.beforeHideEvent.fire()&&(a.setStyle(this.element,"display","none"),this.hideEvent.fire())},configEffect:function(e,t,i){this._cachedEffects=this.cacheEffects?this._createEffects(t[0]):null},cacheEffects:!0,_createEffects:function(e){var t,i,s,n=null;if(e)if(e instanceof Array)for(n=[],t=e.length,i=0;i<t;i++)(s=e[i]).effect&&(n[n.length]=s.effect(this,s.duration));else e.effect&&(n=[e.effect(this,e.duration)]);return n},configMonitorResize:function(e,t,i){t[0]?this.initResizeMonitor():(l.textResizeEvent.unsubscribe(this.onDomResize,this,!0),this.resizeMonitor=null)},_addToParent:function(e,t){!this.cfg.getProperty("appendtodocumentbody")&&e===document.body&&e.firstChild?e.insertBefore(t,e.firstChild):e.appendChild(t)},toString:function(){return"Module "+this.id}},YAHOO.lang.augmentProto(l,YAHOO.util.EventProvider)}(),function(){YAHOO.widget.Overlay=function(e,t){YAHOO.widget.Overlay.superclass.constructor.call(this,e,t)};var r,h=YAHOO.lang,i=YAHOO.util.CustomEvent,l=YAHOO.widget.Module,t=YAHOO.util.Event,g=YAHOO.util.Dom,f=YAHOO.util.Config,v=YAHOO.env.ua,m=YAHOO.widget.Overlay,u="unsubscribe",s="beforeMove",n="move",o={X:{key:"x",validator:h.isNumber,suppressEvent:!0,supercedes:["iframe"]},Y:{key:"y",validator:h.isNumber,suppressEvent:!0,supercedes:["iframe"]},XY:{key:"xy",suppressEvent:!0,supercedes:["iframe"]},CONTEXT:{key:"context",suppressEvent:!0,supercedes:["iframe"]},FIXED_CENTER:{key:"fixedcenter",value:!1,supercedes:["iframe","visible"]},WIDTH:{key:"width",suppressEvent:!0,supercedes:["context","fixedcenter","iframe"]},HEIGHT:{key:"height",suppressEvent:!0,supercedes:["context","fixedcenter","iframe"]},AUTO_FILL_HEIGHT:{key:"autofillheight",supercedes:["height"],value:"body"},ZINDEX:{key:"zindex",value:null},CONSTRAIN_TO_VIEWPORT:{key:"constraintoviewport",value:!1,validator:h.isBoolean,supercedes:["iframe","x","y","xy"]},IFRAME:{key:"iframe",value:6==v.ie,validator:h.isBoolean,supercedes:["zindex"]},PREVENT_CONTEXT_OVERLAP:{key:"preventcontextoverlap",value:!1,validator:h.isBoolean,supercedes:["constraintoviewport"]}};m.IFRAME_SRC="javascript:false;",m.IFRAME_OFFSET=3,m.VIEWPORT_OFFSET=10,m.TOP_LEFT="tl",m.TOP_RIGHT="tr",m.BOTTOM_LEFT="bl",m.BOTTOM_RIGHT="br",m.PREVENT_OVERLAP_X={tltr:!0,blbr:!0,brbl:!0,trtl:!0},m.PREVENT_OVERLAP_Y={trbr:!0,tlbl:!0,bltl:!0,brtr:!0},m.CSS_OVERLAY="yui-overlay",m.CSS_HIDDEN="yui-overlay-hidden",m.CSS_IFRAME="yui-overlay-iframe",m.STD_MOD_RE=/^\s*?(body|footer|header)\s*?$/i,m.windowScrollEvent=new i("windowScroll"),m.windowResizeEvent=new i("windowResize"),m.windowScrollHandler=function(e){e=t.getTarget(e);e&&e!==window&&e!==window.document||(v.ie?(window.scrollEnd||(window.scrollEnd=-1),clearTimeout(window.scrollEnd),window.scrollEnd=setTimeout(function(){m.windowScrollEvent.fire()},1)):m.windowScrollEvent.fire())},m.windowResizeHandler=function(e){v.ie?(window.resizeEnd||(window.resizeEnd=-1),clearTimeout(window.resizeEnd),window.resizeEnd=setTimeout(function(){m.windowResizeEvent.fire()},100)):m.windowResizeEvent.fire()},(m._initialized=null)===m._initialized&&(t.on(window,"scroll",m.windowScrollHandler),t.on(window,"resize",m.windowResizeHandler),m._initialized=!0),m._TRIGGER_MAP={windowScroll:m.windowScrollEvent,windowResize:m.windowResizeEvent,textResize:l.textResizeEvent},YAHOO.extend(m,l,{CONTEXT_TRIGGERS:[],init:function(e,t){m.superclass.init.call(this,e),this.beforeInitEvent.fire(m),g.addClass(this.element,m.CSS_OVERLAY),t&&this.cfg.applyConfig(t,!0),"mac"==this.platform&&v.gecko&&(f.alreadySubscribed(this.showEvent,this.showMacGeckoScrollbars,this)||this.showEvent.subscribe(this.showMacGeckoScrollbars,this,!0),f.alreadySubscribed(this.hideEvent,this.hideMacGeckoScrollbars,this)||this.hideEvent.subscribe(this.hideMacGeckoScrollbars,this,!0)),this.initEvent.fire(m)},initEvents:function(){m.superclass.initEvents.call(this);var e=i.LIST;this.beforeMoveEvent=this.createEvent(s),this.beforeMoveEvent.signature=e,this.moveEvent=this.createEvent(n),this.moveEvent.signature=e},initDefaultConfig:function(){m.superclass.initDefaultConfig.call(this);var e=this.cfg;e.addProperty(o.X.key,{handler:this.configX,validator:o.X.validator,suppressEvent:o.X.suppressEvent,supercedes:o.X.supercedes}),e.addProperty(o.Y.key,{handler:this.configY,validator:o.Y.validator,suppressEvent:o.Y.suppressEvent,supercedes:o.Y.supercedes}),e.addProperty(o.XY.key,{handler:this.configXY,suppressEvent:o.XY.suppressEvent,supercedes:o.XY.supercedes}),e.addProperty(o.CONTEXT.key,{handler:this.configContext,suppressEvent:o.CONTEXT.suppressEvent,supercedes:o.CONTEXT.supercedes}),e.addProperty(o.FIXED_CENTER.key,{handler:this.configFixedCenter,value:o.FIXED_CENTER.value,validator:o.FIXED_CENTER.validator,supercedes:o.FIXED_CENTER.supercedes}),e.addProperty(o.WIDTH.key,{handler:this.configWidth,suppressEvent:o.WIDTH.suppressEvent,supercedes:o.WIDTH.supercedes}),e.addProperty(o.HEIGHT.key,{handler:this.configHeight,suppressEvent:o.HEIGHT.suppressEvent,supercedes:o.HEIGHT.supercedes}),e.addProperty(o.AUTO_FILL_HEIGHT.key,{handler:this.configAutoFillHeight,value:o.AUTO_FILL_HEIGHT.value,validator:this._validateAutoFill,supercedes:o.AUTO_FILL_HEIGHT.supercedes}),e.addProperty(o.ZINDEX.key,{handler:this.configzIndex,value:o.ZINDEX.value}),e.addProperty(o.CONSTRAIN_TO_VIEWPORT.key,{handler:this.configConstrainToViewport,value:o.CONSTRAIN_TO_VIEWPORT.value,validator:o.CONSTRAIN_TO_VIEWPORT.validator,supercedes:o.CONSTRAIN_TO_VIEWPORT.supercedes}),e.addProperty(o.IFRAME.key,{handler:this.configIframe,value:o.IFRAME.value,validator:o.IFRAME.validator,supercedes:o.IFRAME.supercedes}),e.addProperty(o.PREVENT_CONTEXT_OVERLAP.key,{value:o.PREVENT_CONTEXT_OVERLAP.value,validator:o.PREVENT_CONTEXT_OVERLAP.validator,supercedes:o.PREVENT_CONTEXT_OVERLAP.supercedes})},moveTo:function(e,t){this.cfg.setProperty("xy",[e,t])},hideMacGeckoScrollbars:function(){g.replaceClass(this.element,"show-scrollbars","hide-scrollbars")},showMacGeckoScrollbars:function(){g.replaceClass(this.element,"hide-scrollbars","show-scrollbars")},_setDomVisibility:function(e){g.setStyle(this.element,"visibility",e?"visible":"hidden");var t=m.CSS_HIDDEN;e?g.removeClass(this.element,t):g.addClass(this.element,t)},configVisible:function(e,t,i){var s,n,r,o,a,h,t=t[0],l=g.getStyle(this.element,"visibility"),u=this._cachedEffects||this._createEffects(this.cfg.getProperty("effect")),c="mac"==this.platform&&v.gecko,d=f.alreadySubscribed;if("inherit"==l){for(n=this.element.parentNode;9!=n.nodeType&&11!=n.nodeType&&"inherit"==(l=g.getStyle(n,"visibility"));)n=n.parentNode;"inherit"==l&&(l="visible")}if(t)if(c&&this.showMacGeckoScrollbars(),u){if(t&&("visible"!=l||""===l||this._fadingOut)&&this.beforeShowEvent.fire())for(h=u.length,r=0;r<h;r++)s=u[r],0!==r||d(s.animateInCompleteEvent,this.showEvent.fire,this.showEvent)||s.animateInCompleteEvent.subscribe(this.showEvent.fire,this.showEvent,!0),s.animateIn()}else"visible"!=l||""===l?this.beforeShowEvent.fire()&&(this._setDomVisibility(!0),this.cfg.refireEvent("iframe"),this.showEvent.fire()):this._setDomVisibility(!0);else if(c&&this.hideMacGeckoScrollbars(),u)if("visible"==l||this._fadingIn){if(this.beforeHideEvent.fire())for(h=u.length,o=0;o<h;o++)a=u[o],0!==o||d(a.animateOutCompleteEvent,this.hideEvent.fire,this.hideEvent)||a.animateOutCompleteEvent.subscribe(this.hideEvent.fire,this.hideEvent,!0),a.animateOut()}else""===l&&this._setDomVisibility(!1);else"visible"==l||""===l?this.beforeHideEvent.fire()&&(this._setDomVisibility(!1),this.hideEvent.fire()):this._setDomVisibility(!1)},doCenterOnDOMEvent:function(){var e=this.cfg,t=e.getProperty("fixedcenter");e.getProperty("visible")&&t&&("contained"!==t||this.fitsInViewport())&&this.center()},fitsInViewport:function(){var e=m.VIEWPORT_OFFSET,t=this.element,i=t.offsetWidth,t=t.offsetHeight,s=g.getViewportWidth(),n=g.getViewportHeight();return i+e<s&&t+e<n},configFixedCenter:function(e,t,i){var t=t[0],s=f.alreadySubscribed,n=m.windowResizeEvent,r=m.windowScrollEvent;t?(this.center(),s(this.beforeShowEvent,this.center)||this.beforeShowEvent.subscribe(this.center),s(n,this.doCenterOnDOMEvent,this)||n.subscribe(this.doCenterOnDOMEvent,this,!0),s(r,this.doCenterOnDOMEvent,this)||r.subscribe(this.doCenterOnDOMEvent,this,!0)):(this.beforeShowEvent.unsubscribe(this.center),n.unsubscribe(this.doCenterOnDOMEvent,this),r.unsubscribe(this.doCenterOnDOMEvent,this))},configHeight:function(e,t,i){var t=t[0],s=this.element;g.setStyle(s,"height",t),this.cfg.refireEvent("iframe")},configAutoFillHeight:function(e,t,i){var t=t[0],s=this.cfg,n="autofillheight",r="height",o=s.getProperty(n),a=this._autoFillOnHeightChange;s.unsubscribeFromConfigEvent(r,a),l.textResizeEvent.unsubscribe(a),this.changeContentEvent.unsubscribe(a),o&&t!==o&&this[o]&&g.setStyle(this[o],r,""),t&&(t=h.trim(t.toLowerCase()),s.subscribeToConfigEvent(r,a,this[t],this),l.textResizeEvent.subscribe(a,this[t],this),this.changeContentEvent.subscribe(a,this[t],this),s.setProperty(n,t,!0))},configWidth:function(e,t,i){var t=t[0],s=this.element;g.setStyle(s,"width",t),this.cfg.refireEvent("iframe")},configzIndex:function(e,t,i){var t=t[0],s=this.element;t||(t=g.getStyle(s,"zIndex"))&&!isNaN(t)||(t=0),(this.iframe||!0===this.cfg.getProperty("iframe"))&&t<=0&&(t=1),g.setStyle(s,"zIndex",t),this.cfg.setProperty("zIndex",t,!0),this.iframe&&this.stackIframe()},configXY:function(e,t,i){var t=t[0],s=t[0],t=t[1];this.cfg.setProperty("x",s),this.cfg.setProperty("y",t),this.beforeMoveEvent.fire([s,t]),s=this.cfg.getProperty("x"),t=this.cfg.getProperty("y"),this.cfg.refireEvent("iframe"),this.moveEvent.fire([s,t])},configX:function(e,t,i){var t=t[0],s=this.cfg.getProperty("y");this.cfg.setProperty("x",t,!0),this.cfg.setProperty("y",s,!0),this.beforeMoveEvent.fire([t,s]),t=this.cfg.getProperty("x"),s=this.cfg.getProperty("y"),g.setX(this.element,t,!0),this.cfg.setProperty("xy",[t,s],!0),this.cfg.refireEvent("iframe"),this.moveEvent.fire([t,s])},configY:function(e,t,i){var s=this.cfg.getProperty("x"),t=t[0];this.cfg.setProperty("x",s,!0),this.cfg.setProperty("y",t,!0),this.beforeMoveEvent.fire([s,t]),s=this.cfg.getProperty("x"),t=this.cfg.getProperty("y"),g.setY(this.element,t,!0),this.cfg.setProperty("xy",[s,t],!0),this.cfg.refireEvent("iframe"),this.moveEvent.fire([s,t])},showIframe:function(){var e,t=this.iframe;t&&((e=this.element.parentNode)!=t.parentNode&&this._addToParent(e,t),t.style.display="block")},hideIframe:function(){this.iframe&&(this.iframe.style.display="none")},syncIframe:function(){var e=this.iframe,t=this.element,i=m.IFRAME_OFFSET,s=2*i;e&&(e.style.width=t.offsetWidth+s+"px",e.style.height=t.offsetHeight+s+"px",t=this.cfg.getProperty("xy"),h.isArray(t)&&!isNaN(t[0])&&!isNaN(t[1])||(this.syncPosition(),t=this.cfg.getProperty("xy")),g.setXY(e,[t[0]-i,t[1]-i]))},stackIframe:function(){var e;this.iframe&&(e=g.getStyle(this.element,"zIndex"),YAHOO.lang.isUndefined(e)||isNaN(e)||g.setStyle(this.iframe,"zIndex",e-1))},configIframe:function(e,t,i){function s(){var e=this.iframe,t=this.element;e||(r||(r=document.createElement("iframe"),this.isSecure&&(r.src=m.IFRAME_SRC),v.ie?(r.style.filter="alpha(opacity=0)",r.frameBorder=0):r.style.opacity="0",r.style.position="absolute",r.style.border="none",r.style.margin="0",r.style.padding="0",r.style.display="none",r.tabIndex=-1,r.className=m.CSS_IFRAME),(e=r.cloneNode(!1)).id=this.id+"_f",t=t.parentNode||document.body,this._addToParent(t,e),this.iframe=e),this.showIframe(),this.syncIframe(),this.stackIframe(),this._hasIframeEventListeners||(this.showEvent.subscribe(this.showIframe),this.hideEvent.subscribe(this.hideIframe),this.changeContentEvent.subscribe(this.syncIframe),this._hasIframeEventListeners=!0)}t[0]?this.cfg.getProperty("visible")?s.call(this):this._iframeDeferred||(this.beforeShowEvent.subscribe(function n(){s.call(this),this.beforeShowEvent.unsubscribe(n),this._iframeDeferred=!1}),this._iframeDeferred=!0):(this.hideIframe(),this._hasIframeEventListeners&&(this.showEvent.unsubscribe(this.showIframe),this.hideEvent.unsubscribe(this.hideIframe),this.changeContentEvent.unsubscribe(this.syncIframe),this._hasIframeEventListeners=!1))},_primeXYFromDOM:function(){YAHOO.lang.isUndefined(this.cfg.getProperty("xy"))&&(this.syncPosition(),this.cfg.refireEvent("xy"),this.beforeShowEvent.unsubscribe(this._primeXYFromDOM))},configConstrainToViewport:function(e,t,i){t[0]?(f.alreadySubscribed(this.beforeMoveEvent,this.enforceConstraints,this)||this.beforeMoveEvent.subscribe(this.enforceConstraints,this,!0),f.alreadySubscribed(this.beforeShowEvent,this._primeXYFromDOM)||this.beforeShowEvent.subscribe(this._primeXYFromDOM)):(this.beforeShowEvent.unsubscribe(this._primeXYFromDOM),this.beforeMoveEvent.unsubscribe(this.enforceConstraints,this))},configContext:function(e,t,i){var s,n,r,o,t=t[0],a=this.CONTEXT_TRIGGERS;t&&(s=t[0],n=t[1],r=t[2],o=t[3],t=t[4],a&&0<a.length&&(o=(o||[]).concat(a)),s)&&("string"==typeof s&&this.cfg.setProperty("context",[document.getElementById(s),n,r,o,t],!0),n&&r&&this.align(n,r,t),this._contextTriggers&&this._processTriggers(this._contextTriggers,u,this._alignOnTrigger),o)&&(this._processTriggers(o,"subscribe",this._alignOnTrigger),this._contextTriggers=o)},_alignOnTrigger:function(e,t){this.align()},_findTriggerCE:function(e){var t=null;return e instanceof i?t=e:m._TRIGGER_MAP[e]&&(t=m._TRIGGER_MAP[e]),t},_processTriggers:function(e,t,i){for(var s,n,r=0,o=e.length;r<o;++r)s=e[r],(n=this._findTriggerCE(s))?n[t](i,this,!0):this[t](s,i)},align:function(n,e,r){var t,o,i,s=this.cfg.getProperty("context"),a=this;function h(e,t){var i=null,s=null;switch(n){case m.TOP_LEFT:i=t,s=e;break;case m.TOP_RIGHT:i=t-o.offsetWidth,s=e;break;case m.BOTTOM_LEFT:i=t,s=e-o.offsetHeight;break;case m.BOTTOM_RIGHT:i=t-o.offsetWidth,s=e-o.offsetHeight}null!==i&&null!==s&&(r&&(i+=r[0],s+=r[1]),a.moveTo(i,s))}if(s&&(t=s[0],o=this.element,a=this,n=n||s[1],e=e||s[2],!r&&s[4]&&(r=s[4]),o)&&t)switch(i=g.getRegion(t),e){case m.TOP_LEFT:h(i.top,i.left);break;case m.TOP_RIGHT:h(i.top,i.right);break;case m.BOTTOM_LEFT:h(i.bottom,i.left);break;case m.BOTTOM_RIGHT:h(i.bottom,i.right)}},enforceConstraints:function(e,t,i){t=t[0],t=this.getConstrainedXY(t[0],t[1]);this.cfg.setProperty("x",t[0],!0),this.cfg.setProperty("y",t[1],!0),this.cfg.setProperty("xy",t,!0)},_getConstrainedPos:function(e,t){var i=this.element,s=m.VIEWPORT_OFFSET,n="x"==e,i=n?i.offsetWidth:i.offsetHeight,r=n?g.getViewportWidth():g.getViewportHeight(),o=n?g.getDocumentScrollLeft():g.getDocumentScrollTop(),n=n?m.PREVENT_OVERLAP_X:m.PREVENT_OVERLAP_Y,a=this.cfg.getProperty("context"),h=i+s<r,n=this.cfg.getProperty("preventcontextoverlap")&&a&&n[a[1]+a[2]],l=o+s,s=o+r-i-s,u=t;return(t<l||s<t)&&(n?u=this._preventOverlap(e,a[0],i,r,o):!h||t<l?u=l:s<t&&(u=s)),u},_preventOverlap:function(t,e,i,s,n){var r="x"==t,o=m.VIEWPORT_OFFSET,a=this,h=(r?g.getX(e):g.getY(e))-n,l=r?e.offsetWidth:e.offsetHeight,u=h-o,c=s-(h+l)-o,d=!1,f=function(){var e=a.cfg.getProperty(t)-n>h?h-i:h+l;return a.cfg.setProperty(t,e+n,!0),e},v=function(){var e;return(a.cfg.getProperty(t)-n>h?c:u)<i&&(d?f():(f(),d=!0,e=v())),e};return v(),this.cfg.getProperty(t)},getConstrainedX:function(e){return this._getConstrainedPos("x",e)},getConstrainedY:function(e){return this._getConstrainedPos("y",e)},getConstrainedXY:function(e,t){return[this.getConstrainedX(e),this.getConstrainedY(t)]},center:function(){var e=m.VIEWPORT_OFFSET,t=this.element.offsetWidth,i=this.element.offsetHeight,s=g.getViewportWidth(),n=g.getViewportHeight(),s=t<s?s/2-t/2+g.getDocumentScrollLeft():e+g.getDocumentScrollLeft(),t=i<n?n/2-i/2+g.getDocumentScrollTop():e+g.getDocumentScrollTop();this.cfg.setProperty("xy",[parseInt(s,10),parseInt(t,10)]),this.cfg.refireEvent("iframe"),v.webkit&&this.forceContainerRedraw()},syncPosition:function(){var e=g.getXY(this.element);this.cfg.setProperty("x",e[0],!0),this.cfg.setProperty("y",e[1],!0),this.cfg.setProperty("xy",e,!0)},onDomResize:function(e,t){var i=this;m.superclass.onDomResize.call(this,e,t),setTimeout(function(){i.syncPosition(),i.cfg.refireEvent("iframe"),i.cfg.refireEvent("context")},0)},_getComputedHeight:document.defaultView&&document.defaultView.getComputedStyle?function(e){var t=null;return e.ownerDocument&&e.ownerDocument.defaultView&&(e=e.ownerDocument.defaultView.getComputedStyle(e,""))&&(t=parseInt(e.height,10)),h.isNumber(t)?t:null}:function(e){var t=null;return e.style.pixelHeight&&(t=e.style.pixelHeight),h.isNumber(t)?t:null},_validateAutoFillHeight:function(e){return!e||h.isString(e)&&m.STD_MOD_RE.test(e)},_autoFillOnHeightChange:function(e,t,i){var s=this.cfg.getProperty("height");(s&&"auto"!==s||0===s)&&this.fillHeight(i)},_getPreciseHeight:function(e){var t=e.offsetHeight;return t=e.getBoundingClientRect?(e=e.getBoundingClientRect()).bottom-e.top:t},fillHeight:function(e){if(e){for(var t,i=this.innerElement||this.element,s=[this.header,this.body,this.footer],n=0,r=0,o=0,a=!1,h=0,l=s.length;h<l;h++)(t=s[h])&&(e!==t?r+=this._getPreciseHeight(t):a=!0);a&&((v.ie||v.opera)&&g.setStyle(e,"height","0px"),null===(n=this._getComputedHeight(i))&&(g.addClass(i,"yui-override-padding"),n=i.clientHeight,g.removeClass(i,"yui-override-padding")),o=Math.max(n-r,0),g.setStyle(e,"height",o+"px"),e.offsetHeight!=o&&(o=Math.max(o-(e.offsetHeight-o),0)),g.setStyle(e,"height",o+"px"))}},bringToTop:function(){var s=[],n=this.element;g.getElementsBy(function(e){var t=g.hasClass(e,m.CSS_OVERLAY),i=YAHOO.widget.Panel;t&&!g.isAncestor(n,e)&&(i&&g.hasClass(e,i.CSS_PANEL)?s[s.length]=e.parentNode:s[s.length]=e)},"div",document.body),s.sort(function(e,t){return e=g.getStyle(e,"zIndex"),t=g.getStyle(t,"zIndex"),e=!e||isNaN(e)?0:parseInt(e,10),(t=!t||isNaN(t)?0:parseInt(t,10))<e?-1:e<t?1:0});var e,t,i=s[0];i&&(t=g.getStyle(i,"zIndex"),isNaN(t)||(e=!1,i!=n?e=!0:1<s.length&&(i=g.getStyle(s[1],"zIndex"),isNaN(i)||t!=i||(e=!0)),e&&this.cfg.setProperty("zindex",parseInt(t,10)+2)))},destroy:function(e){this.iframe&&this.iframe.parentNode.removeChild(this.iframe),this.iframe=null,m.windowResizeEvent.unsubscribe(this.doCenterOnDOMEvent,this),m.windowScrollEvent.unsubscribe(this.doCenterOnDOMEvent,this),l.textResizeEvent.unsubscribe(this._autoFillOnHeightChange),this._contextTriggers&&this._processTriggers(this._contextTriggers,u,this._alignOnTrigger),m.superclass.destroy.call(this,e)},forceContainerRedraw:function(){var e=this;g.addClass(e.element,"yui-force-redraw"),setTimeout(function(){g.removeClass(e.element,"yui-force-redraw")},0)},toString:function(){return"Overlay "+this.id}})}(),function(){YAHOO.widget.OverlayManager=function(e){this.init(e)};var a=YAHOO.widget.Overlay,n=YAHOO.util.Event,r=YAHOO.util.Dom,t=YAHOO.util.Config,i=YAHOO.util.CustomEvent,o=YAHOO.widget.OverlayManager;o.CSS_FOCUSED="focused",o.prototype={constructor:o,overlays:null,initDefaultConfig:function(){this.cfg.addProperty("overlays",{suppressEvent:!0}),this.cfg.addProperty("focusevent",{value:"mousedown"})},init:function(e){this.cfg=new t(this),this.initDefaultConfig(),e&&this.cfg.applyConfig(e,!0),this.cfg.fireQueue();var s=null,e=(this.getActive=function(){return s},this.focus=function(e){e=this.find(e);e&&e.focus()},this.remove=function(e){var t,i,e=this.find(e);e&&(s==e&&(s=null),(i=null===e.element&&null===e.cfg)||(t=r.getStyle(e.element,"zIndex"),e.cfg.setProperty("zIndex",-1e3,!0)),this.overlays.sort(this.compareZIndexDesc),this.overlays=this.overlays.slice(0,this.overlays.length-1),e.hideEvent.unsubscribe(e.blur),e.destroyEvent.unsubscribe(this._onOverlayDestroy,e),e.focusEvent.unsubscribe(this._onOverlayFocusHandler,e),e.blurEvent.unsubscribe(this._onOverlayBlurHandler,e),i||(n.removeListener(e.element,this.cfg.getProperty("focusevent"),this._onOverlayElementFocus),e.cfg.setProperty("zIndex",t,!0),e.cfg.setProperty("manager",null)),e.focusEvent._managed&&(e.focusEvent=null),e.blurEvent._managed&&(e.blurEvent=null),e.focus._managed&&(e.focus=null),e.blur._managed)&&(e.blur=null)},this.blurAll=function(){var e,t=this.overlays.length;if(0<t)for(e=t-1;this.overlays[e].blur(),e--;);},this._manageBlur=function(e){var t=!1;return s==e&&(r.removeClass(s.element,o.CSS_FOCUSED),t=!(s=null)),t},this._manageFocus=function(e){var t=!1;return s!=e&&(s&&s.blur(),s=e,this.bringToTop(s),r.addClass(s.element,o.CSS_FOCUSED),t=!0),t},this.cfg.getProperty("overlays"));this.overlays||(this.overlays=[]),e&&(this.register(e),this.overlays.sort(this.compareZIndexDesc))},_onOverlayElementFocus:function(e){var e=n.getTarget(e),t=this.close;t&&(e==t||r.isAncestor(t,e))?this.blur():this.focus()},_onOverlayDestroy:function(e,t,i){this.remove(i)},_onOverlayFocusHandler:function(e,t,i){this._manageFocus(i)},_onOverlayBlurHandler:function(e,t,i){this._manageBlur(i)},_bindFocus:function(e){var t=this;e.focusEvent?e.focusEvent.subscribe(t._onOverlayFocusHandler,e,t):(e.focusEvent=e.createEvent("focus"),e.focusEvent.signature=i.LIST,e.focusEvent._managed=!0),e.focus||(n.on(e.element,t.cfg.getProperty("focusevent"),t._onOverlayElementFocus,null,e),e.focus=function(){t._manageFocus(this)&&(this.cfg.getProperty("visible")&&this.focusFirst&&this.focusFirst(),this.focusEvent.fire())},e.focus._managed=!0)},_bindBlur:function(e){var t=this;e.blurEvent?e.blurEvent.subscribe(t._onOverlayBlurHandler,e,t):(e.blurEvent=e.createEvent("blur"),e.blurEvent.signature=i.LIST,e.focusEvent._managed=!0),e.blur||(e.blur=function(){t._manageBlur(this)&&this.blurEvent.fire()},e.blur._managed=!0),e.hideEvent.subscribe(e.blur)},_bindDestroy:function(e){e.destroyEvent.subscribe(this._onOverlayDestroy,e,this)},_syncZIndex:function(e){var t=r.getStyle(e.element,"zIndex");isNaN(t)?e.cfg.setProperty("zIndex",0):e.cfg.setProperty("zIndex",parseInt(t,10))},register:function(e){var t,i,s=!1;if(e instanceof a)e.cfg.addProperty("manager",{value:this}),this._bindFocus(e),this._bindBlur(e),this._bindDestroy(e),this._syncZIndex(e),this.overlays.push(e),this.bringToTop(e),s=!0;else if(e instanceof Array)for(t=0,i=e.length;t<i;t++)s=this.register(e[t])||s;return s},bringToTop:function(e){var t,i,s,n,e=this.find(e);e&&((n=this.overlays).sort(this.compareZIndexDesc),i=n[0])&&(s=r.getStyle(i.element,"zIndex"),isNaN(s)||(t=!1,i!==e?t=!0:1<n.length&&(i=r.getStyle(n[1].element,"zIndex"),isNaN(i)||s!=i||(t=!0)),t&&e.cfg.setProperty("zindex",parseInt(s,10)+2)),n.sort(this.compareZIndexDesc))},find:function(e){var t,i,s=e instanceof a,n=this.overlays,r=n.length,o=null;if(s||"string"==typeof e)for(i=r-1;0<=i;i--)if(t=n[i],s&&t===e||t.id==e){o=t;break}return o},compareZIndexDesc:function(e,t){e=e.cfg?e.cfg.getProperty("zIndex"):null,t=t.cfg?t.cfg.getProperty("zIndex"):null;return null===e&&null===t?0:null===e?1:null===t||t<e?-1:e<t?1:0},showAll:function(){for(var e=this.overlays,t=e.length-1;0<=t;t--)e[t].show()},hideAll:function(){for(var e=this.overlays,t=e.length-1;0<=t;t--)e[t].hide()},toString:function(){return"OverlayManager"}}}(),function(){YAHOO.widget.Tooltip=function(e,t){YAHOO.widget.Tooltip.superclass.constructor.call(this,e,t)};var a,e=YAHOO.lang,o=YAHOO.util.Event,t=YAHOO.util.CustomEvent,h=YAHOO.util.Dom,i=YAHOO.widget.Tooltip,l=YAHOO.env.ua,u=l.ie&&(l.ie<=6||"BackCompat"==document.compatMode),s={PREVENT_OVERLAP:{key:"preventoverlap",value:!0,validator:e.isBoolean,supercedes:["x","y","xy"]},SHOW_DELAY:{key:"showdelay",value:200,validator:e.isNumber},AUTO_DISMISS_DELAY:{key:"autodismissdelay",value:5e3,validator:e.isNumber},HIDE_DELAY:{key:"hidedelay",value:250,validator:e.isNumber},TEXT:{key:"text",suppressEvent:!0},CONTAINER:{key:"container"},DISABLED:{key:"disabled",value:!1,suppressEvent:!0},XY_OFFSET:{key:"xyoffset",value:[0,25],suppressEvent:!0}},n="contextMouseOver",r="contextMouseOut",c="contextTrigger";function d(e,t){"_originalWidth"in this&&!function(e,t){var i=this.cfg;i.getProperty("width")==t&&i.setProperty("width",e)}.call(this,this._originalWidth,this._forcedWidth);var i,s,n=document.body,r=this.cfg,o=r.getProperty("width");o&&"auto"!=o||!(r.getProperty("container")!=n||r.getProperty("x")>=h.getViewportWidth()||r.getProperty("y")>=h.getViewportHeight())||((s=this.element.cloneNode(!0)).style.visibility="hidden",s.style.top="0px",s.style.left="0px",n.appendChild(s),i=s.offsetWidth+"px",n.removeChild(s),s=null,r.setProperty("width",i),r.refireEvent("xy"),this._originalWidth=o||"",this._forcedWidth=i)}function f(e,t,i){this.render(i)}function v(){o.onDOMReady(f,this.cfg.getProperty("container"),this)}i.CSS_TOOLTIP="yui-tt",YAHOO.extend(i,YAHOO.widget.Overlay,{init:function(e,t){i.superclass.init.call(this,e),this.beforeInitEvent.fire(i),h.addClass(this.element,i.CSS_TOOLTIP),t&&this.cfg.applyConfig(t,!0),this.cfg.queueProperty("visible",!1),this.cfg.queueProperty("constraintoviewport",!0),this.setBody(""),this.subscribe("changeContent",d),this.subscribe("init",v),this.subscribe("render",this.onRender),this.initEvent.fire(i)},initEvents:function(){i.superclass.initEvents.call(this);var e=t.LIST;this.contextMouseOverEvent=this.createEvent(n),this.contextMouseOverEvent.signature=e,this.contextMouseOutEvent=this.createEvent(r),this.contextMouseOutEvent.signature=e,this.contextTriggerEvent=this.createEvent(c),this.contextTriggerEvent.signature=e},initDefaultConfig:function(){i.superclass.initDefaultConfig.call(this),this.cfg.addProperty(s.PREVENT_OVERLAP.key,{value:s.PREVENT_OVERLAP.value,validator:s.PREVENT_OVERLAP.validator,supercedes:s.PREVENT_OVERLAP.supercedes}),this.cfg.addProperty(s.SHOW_DELAY.key,{handler:this.configShowDelay,value:200,validator:s.SHOW_DELAY.validator}),this.cfg.addProperty(s.AUTO_DISMISS_DELAY.key,{handler:this.configAutoDismissDelay,value:s.AUTO_DISMISS_DELAY.value,validator:s.AUTO_DISMISS_DELAY.validator}),this.cfg.addProperty(s.HIDE_DELAY.key,{handler:this.configHideDelay,value:s.HIDE_DELAY.value,validator:s.HIDE_DELAY.validator}),this.cfg.addProperty(s.TEXT.key,{handler:this.configText,suppressEvent:s.TEXT.suppressEvent}),this.cfg.addProperty(s.CONTAINER.key,{handler:this.configContainer,value:document.body}),this.cfg.addProperty(s.DISABLED.key,{handler:this.configContainer,value:s.DISABLED.value,supressEvent:s.DISABLED.suppressEvent}),this.cfg.addProperty(s.XY_OFFSET.key,{value:s.XY_OFFSET.value.concat(),supressEvent:s.XY_OFFSET.suppressEvent})},configText:function(e,t,i){t=t[0];t&&this.setBody(t)},configContainer:function(e,t,i){t=t[0];"string"==typeof t&&this.cfg.setProperty("container",document.getElementById(t),!0)},_removeEventListeners:function(){var e,t,i,s=this._context;if(s&&0<(e=s.length))for(i=e-1;t=s[i],o.removeListener(t,"mouseover",this.onContextMouseOver),o.removeListener(t,"mousemove",this.onContextMouseMove),o.removeListener(t,"mouseout",this.onContextMouseOut),i--;);},configContext:function(e,t,i){var s,n,r,t=t[0];if(t&&(t instanceof Array||("string"==typeof t?this.cfg.setProperty("context",[document.getElementById(t)],!0):this.cfg.setProperty("context",[t],!0),t=this.cfg.getProperty("context")),this._removeEventListeners(),this._context=t,s=this._context)&&0<(t=s.length))for(r=t-1;n=s[r],o.on(n,"mouseover",this.onContextMouseOver,this),o.on(n,"mousemove",this.onContextMouseMove,this),o.on(n,"mouseout",this.onContextMouseOut,this),r--;);},onContextMouseMove:function(e,t){t.pageX=o.getPageX(e),t.pageY=o.getPageY(e)},onContextMouseOver:function(e,t){var i=this;i.title&&(t._tempTitle=i.title,i.title=""),!1===t.fireEvent("contextMouseOver",i,e)||t.cfg.getProperty("disabled")||(t.hideProcId&&(clearTimeout(t.hideProcId),t.hideProcId=null),o.on(i,"mousemove",t.onContextMouseMove,t),t.showProcId=t.doShow(e,i))},onContextMouseOut:function(e,t){t._tempTitle&&(this.title=t._tempTitle,t._tempTitle=null),t.showProcId&&(clearTimeout(t.showProcId),t.showProcId=null),t.hideProcId&&(clearTimeout(t.hideProcId),t.hideProcId=null),t.fireEvent("contextMouseOut",this,e),t.hideProcId=setTimeout(function(){t.hide()},t.cfg.getProperty("hidedelay"))},doShow:function(e,t){var i=this.cfg.getProperty("xyoffset"),s=i[0],n=i[1],r=this;return l.opera&&t.tagName&&"A"==t.tagName.toUpperCase()&&(n+=12),setTimeout(function(){var e=r.cfg.getProperty("text");r._tempTitle&&(""===e||YAHOO.lang.isUndefined(e)||YAHOO.lang.isNull(e))?r.setBody(r._tempTitle):r.cfg.refireEvent("text"),r.moveTo(r.pageX+s,r.pageY+n),r.cfg.getProperty("preventoverlap")&&r.preventOverlap(r.pageX,r.pageY),o.removeListener(t,"mousemove",r.onContextMouseMove),r.contextTriggerEvent.fire(t),r.show(),r.hideProcId=r.doHide()},this.cfg.getProperty("showdelay"))},doHide:function(){var e=this;return setTimeout(function(){e.hide()},this.cfg.getProperty("autodismissdelay"))},preventOverlap:function(e,t){var i=this.element.offsetHeight,e=new YAHOO.util.Point(e,t),s=h.getRegion(this.element);s.top-=5,s.left-=5,s.right+=5,s.bottom+=5,s.contains(e)&&this.cfg.setProperty("y",t-i-5)},onRender:function(e,t){function n(){var e=this.element,t=this.underlay;t&&(t.style.width=e.offsetWidth+6+"px",t.style.height=e.offsetHeight+1+"px")}function r(){h.addClass(this.underlay,"yui-tt-shadow-visible"),l.ie&&this.forceUnderlayRedraw()}function o(){h.removeClass(this.underlay,"yui-tt-shadow-visible")}function i(){var e,t,i,s;this.underlay||(t=this.element,i=YAHOO.widget.Module,l.ie,s=this,a||((a=document.createElement("div")).className="yui-tt-shadow"),e=a.cloneNode(!1),t.appendChild(e),this.underlay=e,this._shadow=this.underlay,r.call(this),this.subscribe("beforeShow",r),this.subscribe("hide",o),u&&(window.setTimeout(function(){n.call(s)},0),this.cfg.subscribeToConfigEvent("width",n),this.cfg.subscribeToConfigEvent("height",n),this.subscribe("changeContent",n),i.textResizeEvent.subscribe(n,this,!0),this.subscribe("destroy",function(){i.textResizeEvent.unsubscribe(n,this)})))}this.cfg.getProperty("visible")?i.call(this):this.subscribe("beforeShow",function s(){i.call(this),this.unsubscribe("beforeShow",s)})},forceUnderlayRedraw:function(){var e=this;h.addClass(e.underlay,"yui-force-redraw"),setTimeout(function(){h.removeClass(e.underlay,"yui-force-redraw")},0)},destroy:function(){this._removeEventListeners(),i.superclass.destroy.call(this)},toString:function(){return"Tooltip "+this.id}})}(),function(){YAHOO.widget.Panel=function(e,t){YAHOO.widget.Panel.superclass.constructor.call(this,e,t)};var t,l,r,n=null,s=YAHOO.lang,o=YAHOO.util,u=o.Dom,a=o.Event,i=o.CustomEvent,h=YAHOO.util.KeyListener,c=o.Config,d=YAHOO.widget.Overlay,f=YAHOO.widget.Panel,v=YAHOO.env.ua,g=v.ie&&(v.ie<=6||"BackCompat"==document.compatMode),m="beforeShowMask",E="beforeHideMask",p="showMask",y="hideMask",b="drag",O={CLOSE:{key:"close",value:!0,validator:s.isBoolean,supercedes:["visible"]},DRAGGABLE:{key:"draggable",value:!!o.DD,validator:s.isBoolean,supercedes:["visible"]},DRAG_ONLY:{key:"dragonly",value:!1,validator:s.isBoolean,supercedes:["draggable"]},UNDERLAY:{key:"underlay",value:"shadow",supercedes:["visible"]},MODAL:{key:"modal",value:!1,validator:s.isBoolean,supercedes:["visible","zindex"]},KEY_LISTENERS:{key:"keylisteners",suppressEvent:!0,supercedes:["visible"]},STRINGS:{key:"strings",supercedes:["close"],validator:s.isObject,value:{close:"Close"}}};function _(e,t){!this.header&&this.cfg.getProperty("draggable")&&this.setHeader("&#160;")}function C(e,t,i){var s=i[0],n=i[1],r=this.cfg;r.getProperty("width")==n&&r.setProperty("width",s),this.unsubscribe("hide",C,i)}function T(e,t){var i,s,n;!g||(s=(i=this.cfg).getProperty("width"))&&"auto"!=s||(n=this.element.offsetWidth+"px",i.setProperty("width",n),this.subscribe("hide",C,[s||"",n]))}f.CSS_PANEL="yui-panel",f.CSS_PANEL_CONTAINER="yui-panel-container",f.FOCUSABLE=["a","button","select","textarea","input","iframe"],YAHOO.extend(f,d,{init:function(e,t){f.superclass.init.call(this,e),this.beforeInitEvent.fire(f),u.addClass(this.element,f.CSS_PANEL),this.buildWrapper(),t&&this.cfg.applyConfig(t,!0),this.subscribe("showMask",this._addFocusHandlers),this.subscribe("hideMask",this._removeFocusHandlers),this.subscribe("beforeRender",_),this.subscribe("render",function(){this.setFirstLastFocusable(),this.subscribe("changeContent",this.setFirstLastFocusable)}),this.subscribe("show",this._focusOnShow),this.initEvent.fire(f)},_onElementFocus:function(e){if(n===this){var e=a.getTarget(e),t=e!==document.documentElement&&e!==window;if(t&&e!==this.element&&e!==this.mask&&!u.isAncestor(this.element,e))try{this._focusFirstModal()}catch(i){try{t&&e!==document.body&&e.blur()}catch(s){}}}},_focusFirstModal:function(){var e=this.firstElement;(e||this._modalFocus||this.innerElement).focus()},_addFocusHandlers:function(e,t){this.firstElement||(v.webkit||v.opera?this._modalFocus||this._createHiddenFocusElement():this.innerElement.tabIndex=0),this._setTabLoop(this.firstElement,this.lastElement),a.onFocus(document.documentElement,this._onElementFocus,this,!0),n=this},_createHiddenFocusElement:function(){var e=document.createElement("button");e.style.height="1px",e.style.width="1px",e.style.position="absolute",e.style.left="-10000em",e.style.opacity=0,e.tabIndex=-1,this.innerElement.appendChild(e),this._modalFocus=e},_removeFocusHandlers:function(e,t){a.removeFocusListener(document.documentElement,this._onElementFocus,this),n==this&&(n=null)},_focusOnShow:function(e,t,i){t&&t[1]&&a.stopEvent(t[1]),this.focusFirst(e,t,i)||this.cfg.getProperty("modal")&&this._focusFirstModal()},focusFirst:function(e,t,i){var s=this.firstElement,n=!1;if(t&&t[1]&&a.stopEvent(t[1]),s)try{s.focus(),n=!0}catch(r){}return n},focusLast:function(e,t,i){var s=this.lastElement,n=!1;if(t&&t[1]&&a.stopEvent(t[1]),s)try{s.focus(),n=!0}catch(r){}return n},_setTabLoop:function(e,t){this.setTabLoop(e,t)},setTabLoop:function(e,t){var i=this.preventBackTab,s=this.preventTabOut,n=this.showEvent,r=this.hideEvent;i&&(i.disable(),n.unsubscribe(i.enable,i),r.unsubscribe(i.disable,i),i=this.preventBackTab=null),s&&(s.disable(),n.unsubscribe(s.enable,s),r.unsubscribe(s.disable,s),s=this.preventTabOut=null),e&&(this.preventBackTab=new h(e,{shift:!0,keys:9},{fn:this.focusLast,scope:this,correctScope:!0}),i=this.preventBackTab,n.subscribe(i.enable,i,!0),r.subscribe(i.disable,i,!0)),t&&(this.preventTabOut=new h(t,{shift:!1,keys:9},{fn:this.focusFirst,scope:this,correctScope:!0}),s=this.preventTabOut,n.subscribe(s.enable,s,!0),r.subscribe(s.disable,s,!0))},getFocusableElements:function(e){e=e||this.innerElement;for(var t={},i=this,s=0;s<f.FOCUSABLE.length;s++)t[f.FOCUSABLE[s]]=!0;return u.getElementsBy(function(e){return i._testIfFocusable(e,t)},null,e)},_testIfFocusable:function(e,t){return!(!e.focus||"hidden"===e.type||e.disabled||!t[e.tagName.toLowerCase()])},setFirstLastFocusable:function(){this.firstElement=null,this.lastElement=null;var e=this.getFocusableElements();0<(this.focusableElements=e).length&&(this.firstElement=e[0],this.lastElement=e[e.length-1]),this.cfg.getProperty("modal")&&this._setTabLoop(this.firstElement,this.lastElement)},initEvents:function(){f.superclass.initEvents.call(this);var e=i.LIST;this.showMaskEvent=this.createEvent(p),this.showMaskEvent.signature=e,this.beforeShowMaskEvent=this.createEvent(m),this.beforeShowMaskEvent.signature=e,this.hideMaskEvent=this.createEvent(y),this.hideMaskEvent.signature=e,this.beforeHideMaskEvent=this.createEvent(E),this.beforeHideMaskEvent.signature=e,this.dragEvent=this.createEvent(b),this.dragEvent.signature=e},initDefaultConfig:function(){f.superclass.initDefaultConfig.call(this),this.cfg.addProperty(O.CLOSE.key,{handler:this.configClose,value:O.CLOSE.value,validator:O.CLOSE.validator,supercedes:O.CLOSE.supercedes}),this.cfg.addProperty(O.DRAGGABLE.key,{handler:this.configDraggable,value:!!o.DD,validator:O.DRAGGABLE.validator,supercedes:O.DRAGGABLE.supercedes}),this.cfg.addProperty(O.DRAG_ONLY.key,{value:O.DRAG_ONLY.value,validator:O.DRAG_ONLY.validator,supercedes:O.DRAG_ONLY.supercedes}),this.cfg.addProperty(O.UNDERLAY.key,{handler:this.configUnderlay,value:O.UNDERLAY.value,supercedes:O.UNDERLAY.supercedes}),this.cfg.addProperty(O.MODAL.key,{handler:this.configModal,value:O.MODAL.value,validator:O.MODAL.validator,supercedes:O.MODAL.supercedes}),this.cfg.addProperty(O.KEY_LISTENERS.key,{handler:this.configKeyListeners,suppressEvent:O.KEY_LISTENERS.suppressEvent,supercedes:O.KEY_LISTENERS.supercedes}),this.cfg.addProperty(O.STRINGS.key,{value:O.STRINGS.value,handler:this.configStrings,validator:O.STRINGS.validator,supercedes:O.STRINGS.supercedes})},configClose:function(e,t,i){var t=t[0],s=this.close,n=this.cfg.getProperty("strings");t?s?s.style.display="block":(r||((r=document.createElement("button")).className="container-close icon",r.setAttribute("title",window.getMessage("txt.button.close.panel"))),s=r.cloneNode(!0),(t=this.innerElement.firstChild)?this.innerElement.insertBefore(s,t):this.innerElement.appendChild(s),s.innerHTML=n&&n.close?n.close:"&#160;",a.on(s,"click",this._doClose,this,!0),this.close=s):s&&(s.style.display="none")},_doClose:function(e){a.preventDefault(e),this.hide()},configDraggable:function(e,t,i){t[0]?o.DD?(this.header&&(u.setStyle(this.header,"cursor","move"),this.registerDragDrop()),this.subscribe("beforeShow",T)):this.cfg.setProperty("draggable",!1):(this.dd&&this.dd.unreg(),this.header&&u.setStyle(this.header,"cursor","auto"),this.unsubscribe("beforeShow",T))},configUnderlay:function(e,t,i){var s="mac"==this.platform&&v.gecko,t=t[0].toLowerCase(),n=this.underlay,r=this.element;function o(){n||(l||((l=document.createElement("div")).className="underlay"),n=l.cloneNode(!1),this.element.appendChild(n),this.underlay=n,g&&(this.sizeUnderlay(),this.cfg.subscribeToConfigEvent("width",this.sizeUnderlay),this.cfg.subscribeToConfigEvent("height",this.sizeUnderlay),this.changeContentEvent.subscribe(this.sizeUnderlay),YAHOO.widget.Module.textResizeEvent.subscribe(this.sizeUnderlay,this,!0)),v.webkit&&v.webkit<420&&this.changeContentEvent.subscribe(this.forceUnderlayRedraw))}function a(){!o.call(this)&&g&&this.sizeUnderlay(),this._underlayDeferred=!1,this.beforeShowEvent.unsubscribe(a)}function h(){this._underlayDeferred&&(this.beforeShowEvent.unsubscribe(a),this._underlayDeferred=!1),n&&(this.cfg.unsubscribeFromConfigEvent("width",this.sizeUnderlay),this.cfg.unsubscribeFromConfigEvent("height",this.sizeUnderlay),this.changeContentEvent.unsubscribe(this.sizeUnderlay),this.changeContentEvent.unsubscribe(this.forceUnderlayRedraw),YAHOO.widget.Module.textResizeEvent.unsubscribe(this.sizeUnderlay,this,!0),this.element.removeChild(n),this.underlay=null)}switch(t){case"shadow":u.removeClass(r,"matte"),u.addClass(r,"shadow");break;case"matte":s||h.call(this),u.removeClass(r,"shadow"),u.addClass(r,"matte");break;default:s||h.call(this),u.removeClass(r,"shadow"),u.removeClass(r,"matte")}("shadow"==t||s&&!n)&&(this.cfg.getProperty("visible")?!o.call(this)&&g&&this.sizeUnderlay():this._underlayDeferred||(this.beforeShowEvent.subscribe(a),this._underlayDeferred=!0))},configModal:function(e,t,i){t[0]?this._hasModalityEventListeners||(this.subscribe("beforeShow",this.buildMask),this.subscribe("beforeShow",this.bringToTop),this.subscribe("beforeShow",this.showMask),this.subscribe("hide",this.hideMask),d.windowResizeEvent.subscribe(this.sizeMask,this,!0),this._hasModalityEventListeners=!0):this._hasModalityEventListeners&&(this.cfg.getProperty("visible")&&(this.hideMask(),this.removeMask()),this.unsubscribe("beforeShow",this.buildMask),this.unsubscribe("beforeShow",this.bringToTop),this.unsubscribe("beforeShow",this.showMask),this.unsubscribe("hide",this.hideMask),d.windowResizeEvent.unsubscribe(this.sizeMask,this),this._hasModalityEventListeners=!1)},removeMask:function(){var e,t=this.mask;t&&(this.hideMask(),(e=t.parentNode)&&e.removeChild(t),this.mask=null)},configKeyListeners:function(e,t,i){var s,n,r,o=t[0];if(o)if(o instanceof Array)for(n=o.length,r=0;r<n;r++)s=o[r],c.alreadySubscribed(this.showEvent,s.enable,s)||this.showEvent.subscribe(s.enable,s,!0),c.alreadySubscribed(this.hideEvent,s.disable,s)||(this.hideEvent.subscribe(s.disable,s,!0),this.destroyEvent.subscribe(s.disable,s,!0));else c.alreadySubscribed(this.showEvent,o.enable,o)||this.showEvent.subscribe(o.enable,o,!0),c.alreadySubscribed(this.hideEvent,o.disable,o)||(this.hideEvent.subscribe(o.disable,o,!0),this.destroyEvent.subscribe(o.disable,o,!0))},configStrings:function(e,t,i){t=s.merge(O.STRINGS.value,t[0]);this.cfg.setProperty(O.STRINGS.key,t,!0)},configHeight:function(e,t,i){var t=t[0],s=this.innerElement;u.setStyle(s,"height",t),this.cfg.refireEvent("iframe")},_autoFillOnHeightChange:function(e,t,i){var s;f.superclass._autoFillOnHeightChange.apply(this,arguments),g&&(s=this,setTimeout(function(){s.sizeUnderlay()},0))},configWidth:function(e,t,i){var t=t[0],s=this.innerElement;u.setStyle(s,"width",t),this.cfg.refireEvent("iframe")},configzIndex:function(e,t,i){f.superclass.configzIndex.call(this,e,t,i),!this.mask&&!0!==this.cfg.getProperty("modal")||(0===(e=(e=u.getStyle(this.element,"zIndex"))&&!isNaN(e)?e:0)?this.cfg.setProperty("zIndex",1):this.stackMask())},buildWrapper:function(){var e=this.element.parentNode,t=this.element,i=document.createElement("div");i.className=f.CSS_PANEL_CONTAINER,i.id=t.id+"_c",e&&e.insertBefore(i,t),i.appendChild(t),this.element=i,this.innerElement=t,u.setStyle(this.innerElement,"visibility","inherit")},sizeUnderlay:function(){var e,t=this.underlay;t&&(e=this.element,t.style.width=e.offsetWidth+"px",t.style.height=e.offsetHeight+"px")},registerDragDrop:function(){var e,a=this;this.header&&o.DD&&(e=!0===this.cfg.getProperty("dragonly"),this.dd=new o.DD(this.element.id,this.id,{dragOnly:e}),this.header.id||(this.header.id=this.id+"_h"),this.dd.startDrag=function(){var e,t,i,s,n,r,o;6==YAHOO.env.ua.ie&&u.addClass(a.element,"drag"),a.cfg.getProperty("constraintoviewport")?(e=d.VIEWPORT_OFFSET,t=a.element.offsetHeight,i=a.element.offsetWidth,s=u.getViewportWidth(),n=u.getViewportHeight(),r=u.getDocumentScrollLeft(),o=u.getDocumentScrollTop(),t+e<n?(this.minY=o+e,this.maxY=o+n-t-e):(this.minY=o+e,this.maxY=o+e),i+e<s?(this.minX=r+e,this.maxX=r+s-i-e):(this.minX=r+e,this.maxX=r+e),this.constrainX=!0,this.constrainY=!0):(this.constrainX=!1,this.constrainY=!1),a.dragEvent.fire("startDrag",arguments)},this.dd.onDrag=function(){a.syncPosition(),a.cfg.refireEvent("iframe"),"mac"==this.platform&&YAHOO.env.ua.gecko&&this.showMacGeckoScrollbars(),a.dragEvent.fire("onDrag",arguments)},this.dd.endDrag=function(){6==YAHOO.env.ua.ie&&u.removeClass(a.element,"drag"),a.dragEvent.fire("endDrag",arguments),a.moveEvent.fire(a.cfg.getProperty("xy"))},this.dd.setHandleElId(this.header.id),this.dd.addInvalidHandleType("INPUT"),this.dd.addInvalidHandleType("SELECT"),this.dd.addInvalidHandleType("TEXTAREA"))},buildMask:function(){var e=this.mask;e||(t||((t=document.createElement("div")).className="mask",t.innerHTML="&#160;"),(e=t.cloneNode(!0)).id=this.id+"_mask",document.body.insertBefore(e,document.body.firstChild),this.mask=e,YAHOO.env.ua.gecko&&"mac"==this.platform&&u.addClass(this.mask,"block-scrollbars"),this.stackMask())},hideMask:function(){this.cfg.getProperty("modal")&&this.mask&&this.beforeHideMaskEvent.fire()&&(this.mask.style.display="none",u.removeClass(document.body,"masked"),this.hideMaskEvent.fire())},showMask:function(){this.cfg.getProperty("modal")&&this.mask&&this.beforeShowMaskEvent.fire()&&(u.addClass(document.body,"masked"),this.sizeMask(),this.mask.style.display="block",this.showMaskEvent.fire())},sizeMask:function(){var e,t,i;this.mask&&(e=this.mask,t=u.getViewportWidth(),i=u.getViewportHeight(),e.offsetHeight>i&&(e.style.height=i+"px"),e.offsetWidth>t&&(e.style.width=t+"px"),e.style.height=u.getDocumentHeight()+"px",e.style.width=u.getDocumentWidth()+"px")},stackMask:function(){var e;this.mask&&(e=u.getStyle(this.element,"zIndex"),YAHOO.lang.isUndefined(e)||isNaN(e)||u.setStyle(this.mask,"zIndex",e-1))},render:function(e){return f.superclass.render.call(this,e,this.innerElement)},_renderHeader:function(e){e=e||this.innerElement,f.superclass._renderHeader.call(this,e)},_renderBody:function(e){e=e||this.innerElement,f.superclass._renderBody.call(this,e)},_renderFooter:function(e){e=e||this.innerElement,f.superclass._renderFooter.call(this,e)},destroy:function(e){d.windowResizeEvent.unsubscribe(this.sizeMask,this),this.removeMask(),this.close&&a.purgeElement(this.close),f.superclass.destroy.call(this,e)},forceUnderlayRedraw:function(){var e=this.underlay;u.addClass(e,"yui-force-redraw"),setTimeout(function(){u.removeClass(e,"yui-force-redraw")},0)},toString:function(){return"Panel "+this.id}})}(),function(){YAHOO.widget.Dialog=function(e,t){YAHOO.widget.Dialog.superclass.constructor.call(this,e,t)};var d=YAHOO.util.Event,t=YAHOO.util.CustomEvent,p=YAHOO.util.Dom,n=YAHOO.widget.Dialog,f=YAHOO.lang,i="beforeSubmit",s="submit",r="manualSubmit",o="asyncSubmit",a="formSubmit",h="cancel",e={POST_METHOD:{key:"postmethod",value:"async"},POST_DATA:{key:"postdata",value:null},BUTTONS:{key:"buttons",value:"none",supercedes:["visible"]},HIDEAFTERSUBMIT:{key:"hideaftersubmit",value:!0}};function v(){var e,t,i,s=this._aButtons;if(f.isArray(s)&&0<(e=s.length))for(i=e-1;t=s[i],YAHOO.widget.Button&&t instanceof YAHOO.widget.Button?t.destroy():"BUTTON"==t.tagName.toUpperCase()&&(d.purgeElement(t),d.purgeElement(t,!1)),i--;);}n.CSS_DIALOG="yui-dialog",YAHOO.extend(n,YAHOO.widget.Panel,{form:null,initDefaultConfig:function(){n.superclass.initDefaultConfig.call(this),this.callback={success:null,failure:null,argument:null},this.cfg.addProperty(e.POST_METHOD.key,{handler:this.configPostMethod,value:e.POST_METHOD.value,validator:function(e){return"form"==e||"async"==e||"none"==e||"manual"==e}}),this.cfg.addProperty(e.POST_DATA.key,{value:e.POST_DATA.value}),this.cfg.addProperty(e.HIDEAFTERSUBMIT.key,{value:e.HIDEAFTERSUBMIT.value}),this.cfg.addProperty(e.BUTTONS.key,{handler:this.configButtons,value:e.BUTTONS.value,supercedes:e.BUTTONS.supercedes})},initEvents:function(){n.superclass.initEvents.call(this);var e=t.LIST;this.beforeSubmitEvent=this.createEvent(i),this.beforeSubmitEvent.signature=e,this.submitEvent=this.createEvent(s),this.submitEvent.signature=e,this.manualSubmitEvent=this.createEvent(r),this.manualSubmitEvent.signature=e,this.asyncSubmitEvent=this.createEvent(o),this.asyncSubmitEvent.signature=e,this.formSubmitEvent=this.createEvent(a),this.formSubmitEvent.signature=e,this.cancelEvent=this.createEvent(h),this.cancelEvent.signature=e},init:function(e,t){n.superclass.init.call(this,e),this.beforeInitEvent.fire(n),p.addClass(this.element,n.CSS_DIALOG),this.cfg.setProperty("visible",!1),t&&this.cfg.applyConfig(t,!0),this.beforeHideEvent.subscribe(this.blurButtons,this,!0),this.subscribe("changeBody",this.registerForm),this.initEvent.fire(n)},doSubmit:function(){var e,t,i=YAHOO.util.Connect,s=this.form,n=!1,r=!1;switch(this.cfg.getProperty("postmethod")){case"async":if(0<(a=(e=s.elements).length)){t=a-1;do{if("file"==e[t].type){n=!0;break}}while(t--)}n&&YAHOO.env.ua.ie&&this.isSecure&&(r=!0),a=this._getFormAttributes(s),i.setForm(s,n,r);var o=this.cfg.getProperty("postdata"),a=i.asyncRequest(a.method,a.action,this.callback,o);this.asyncSubmitEvent.fire(a);break;case"form":s.submit(),this.formSubmitEvent.fire();break;case"none":case"manual":this.manualSubmitEvent.fire()}},_getFormAttributes:function(e){var t,i,s={method:null,action:null};return e&&(e.getAttributeNode?(t=e.getAttributeNode("action"),i=e.getAttributeNode("method"),t&&(s.action=t.value),i&&(s.method=i.value)):(s.action=e.getAttribute("action"),s.method=e.getAttribute("method"))),s.method=(f.isString(s.method)?s.method:"POST").toUpperCase(),s.action=f.isString(s.action)?s.action:"",s},registerForm:function(){var e=this.element.getElementsByTagName("form")[0];if(this.form){if(this.form==e&&p.isAncestor(this.element,this.form))return;d.purgeElement(this.form),this.form=null}e||((e=document.createElement("form")).name="frm_"+this.id,this.body.appendChild(e)),e&&(this.form=e,d.on(e,"submit",this._submitHandler,this,!0))},_submitHandler:function(e){d.stopEvent(e),this.submit(),this.form.blur()},setTabLoop:function(e,t){e=e||this.firstButton,t=t||this.lastButton,n.superclass.setTabLoop.call(this,e,t)},_setTabLoop:function(e,t){e=e||this.firstButton,t=this.lastButton||t,this.setTabLoop(e,t)},setFirstLastFocusable:function(){n.superclass.setFirstLastFocusable.call(this);var e,t,i,s=this.focusableElements;if(this.firstFormElement=null,this.lastFormElement=null,this.form&&s&&0<s.length){for(t=s.length,e=0;e<t;++e)if(i=s[e],this.form===i.form){this.firstFormElement=i;break}for(e=t-1;0<=e;--e)if(i=s[e],this.form===i.form){this.lastFormElement=i;break}}},configClose:function(e,t,i){n.superclass.configClose.apply(this,arguments)},_doClose:function(e){d.preventDefault(e),this.cancel()},configButtons:function(e,t,i){var s,n,r,o,a,h,l,u=YAHOO.widget.Button,c=t[0],t=this.innerElement;if(v.call(this),this._aButtons=null,f.isArray(c)){for((a=document.createElement("span")).className="button-group",o=c.length,this._aButtons=[],this.defaultHtmlButton=null,l=0;l<o;l++)s=c[l],u?((r=new u({label:s.text,type:s.type})).appendTo(a),n=r.get("element"),s.isDefault&&(r.addClass("default"),this.defaultHtmlButton=n),f.isFunction(s.handler)?r.set("onclick",{fn:s.handler,obj:this,scope:this}):f.isObject(s.handler)&&f.isFunction(s.handler.fn)&&r.set("onclick",{fn:s.handler.fn,obj:f.isUndefined(s.handler.obj)?this:s.handler.obj,scope:s.handler.scope||this}),this._aButtons[this._aButtons.length]=r):((n=document.createElement("button")).setAttribute("type","button"),s.isDefault&&(n.className="default",this.defaultHtmlButton=n),n.innerHTML=s.text,f.isFunction(s.handler)?d.on(n,"click",s.handler,this,!0):f.isObject(s.handler)&&f.isFunction(s.handler.fn)&&d.on(n,"click",s.handler.fn,f.isUndefined(s.handler.obj)?this:s.handler.obj,s.handler.scope||this),a.appendChild(n),this._aButtons[this._aButtons.length]=n),s.htmlButton=n,0===l&&(this.firstButton=n),l==o-1&&(this.lastButton=n);this.setFooter(a),h=this.footer,p.inDocument(this.element)&&!p.isAncestor(t,h)&&t.appendChild(h),this.buttonSpan=a}else a=this.buttonSpan,h=this.footer,a&&h&&(h.removeChild(a),this.buttonSpan=null,this.firstButton=null,this.lastButton=null,this.defaultHtmlButton=null);this.changeContentEvent.fire()},getButtons:function(){return this._aButtons||null},focusFirst:function(e,t,i){var s=this.firstFormElement,n=!1;if(s=t&&t[1]&&(d.stopEvent(t[1]),9===t[0])&&this.firstElement?this.firstElement:s)try{s.focus(),n=!0}catch(r){}else n=this.defaultHtmlButton?this.focusDefaultButton():this.focusFirstButton();return n},focusLast:function(e,t,i){var s=this.cfg.getProperty("buttons"),n=this.lastFormElement,r=!1;if(t&&t[1]&&(d.stopEvent(t[1]),9===t[0])&&this.lastElement&&(n=this.lastElement),s&&f.isArray(s))r=this.focusLastButton();else if(n)try{n.focus(),r=!0}catch(o){}return r},_getButton:function(e){var t=YAHOO.widget.Button;return e=t&&e&&e.nodeName&&e.id?t.getButton(e.id)||e:e},focusDefaultButton:function(){var e=this._getButton(this.defaultHtmlButton),t=!1;if(e)try{e.focus(),t=!0}catch(i){}return t},blurButtons:function(){var e,t,i,s=this.cfg.getProperty("buttons");if(s&&f.isArray(s)&&0<(e=s.length)){i=e-1;do{if((t=s[i])&&(t=this._getButton(t.htmlButton)))try{t.blur()}catch(n){}}while(i--)}},focusFirstButton:function(){var e=this.cfg.getProperty("buttons"),t=!1;if(e&&f.isArray(e)&&(e=e[0])&&(e=this._getButton(e.htmlButton)))try{e.focus(),t=!0}catch(i){}return t},focusLastButton:function(){var e,t=this.cfg.getProperty("buttons"),i=!1;if(t&&f.isArray(t)&&0<(e=t.length)&&(e=t[e-1])&&(t=this._getButton(e.htmlButton)))try{t.focus(),i=!0}catch(s){}return i},configPostMethod:function(e,t,i){this.registerForm()},validate:function(){return!0},submit:function(){return!!this.validate()&&!!this.beforeSubmitEvent.fire()&&(this.doSubmit(),this.submitEvent.fire(),this.cfg.getProperty("hideaftersubmit")&&this.hide(),!0)},cancel:function(){this.cancelEvent.fire(),this.hide()},getData:function(){var e,t,i,s,n,r,o,a,h,l,u,c,d,f,v,g,m=this.form;function E(e){var t=e.tagName.toUpperCase();return("INPUT"==t||"TEXTAREA"==t||"SELECT"==t)&&e.name==s}if(m)for(t=(e=m.elements).length,i={},v=0;v<t;v++)if(s=e[v].name,0<(r=(n=p.getElementsBy(E,"*",m)).length))if(1==r)switch(o=(n=n[0]).type,n.tagName.toUpperCase()){case"INPUT":"checkbox"==o?i[s]=n.checked:"radio"!=o&&(i[s]=n.value);break;case"TEXTAREA":i[s]=n.value;break;case"SELECT":for(h=(a=n.options).length,l=[],g=0;g<h;g++)(u=a[g]).selected&&(f=u.attributes.value,l[l.length]=f&&f.specified?u.value:u.text);i[s]=l}else switch(o=n[0].type){case"radio":for(g=0;g<r;g++)if((c=n[g]).checked){i[s]=c.value;break}break;case"checkbox":for(l=[],g=0;g<r;g++)(d=n[g]).checked&&(l[l.length]=d.value);i[s]=l}return i},destroy:function(e){v.call(this),this._aButtons=null;var t=this.element.getElementsByTagName("form");0<t.length&&(t=t[0])&&(d.purgeElement(t),t.parentNode&&t.parentNode.removeChild(t),this.form=null),n.superclass.destroy.call(this,e)},toString:function(){return"Dialog "+this.id}})}(),function(){YAHOO.widget.SimpleDialog=function(e,t){YAHOO.widget.SimpleDialog.superclass.constructor.call(this,e,t)};var a=YAHOO.util.Dom,h=YAHOO.widget.SimpleDialog,e={ICON:{key:"icon",value:"none",suppressEvent:!0},TEXT:{key:"text",value:"",suppressEvent:!0,supercedes:["icon"]}};h.ICON_BLOCK="blckicon",h.ICON_ALARM="alrticon",h.ICON_HELP="hlpicon",h.ICON_INFO="infoicon",h.ICON_WARN="warnicon",h.ICON_TIP="tipicon",h.ICON_CSS_CLASSNAME="yui-icon",h.CSS_SIMPLEDIALOG="yui-simple-dialog",YAHOO.extend(h,YAHOO.widget.Dialog,{initDefaultConfig:function(){h.superclass.initDefaultConfig.call(this),this.cfg.addProperty(e.ICON.key,{handler:this.configIcon,value:e.ICON.value,suppressEvent:e.ICON.suppressEvent}),this.cfg.addProperty(e.TEXT.key,{handler:this.configText,value:e.TEXT.value,suppressEvent:e.TEXT.suppressEvent,supercedes:e.TEXT.supercedes})},init:function(e,t){h.superclass.init.call(this,e),this.beforeInitEvent.fire(h),a.addClass(this.element,h.CSS_SIMPLEDIALOG),this.cfg.queueProperty("postmethod","manual"),t&&this.cfg.applyConfig(t,!0),this.beforeRenderEvent.subscribe(function(){this.body||this.setBody("")},this,!0),this.initEvent.fire(h)},registerForm:function(){h.superclass.registerForm.call(this);var e=this.form.ownerDocument.createElement("input");e.type="hidden",e.name=this.id,e.value="",this.form.appendChild(e)},configIcon:function(e,t,i){var s,n,t=t[0],r=this.body,o=h.ICON_CSS_CLASSNAME;t&&"none"!=t&&(1===(n=a.getElementsByClassName(o,"*",r)).length&&(n=(s=n[0]).parentNode)&&(n.removeChild(s),s=null),-1==t.indexOf(".")?((s=document.createElement("span")).className=o+" "+t,s.innerHTML="&#160;"):((s=document.createElement("img")).src=this.imageRoot+t,s.className=o),s)&&r.insertBefore(s,r.firstChild)},configText:function(e,t,i){t=t[0];t&&(this.setBody(t),this.cfg.refireEvent("icon"))},toString:function(){return"SimpleDialog "+this.id}})}(),function(){YAHOO.widget.ContainerEffect=function(e,t,i,s,n){n=n||YAHOO.util.Anim,this.overlay=e,this.attrIn=t,this.attrOut=i,this.targetElement=s||e.element,this.animClass=n};var h=YAHOO.util.Dom,e=YAHOO.util.CustomEvent,l=YAHOO.widget.ContainerEffect;l.FADE=function(t,e){var i=YAHOO.util.Easing,s={attributes:{opacity:{from:0,to:1}},duration:e,method:i.easeIn},e={attributes:{opacity:{to:0}},duration:e,method:i.easeOut},i=new l(t,s,e,t.element);return i.handleUnderlayStart=function(){var e=this.overlay.underlay;e&&YAHOO.env.ua.ie&&e.filters&&0<e.filters.length&&h.addClass(t.element,"yui-effect-fade")},i.handleUnderlayComplete=function(){this.overlay.underlay&&YAHOO.env.ua.ie&&h.removeClass(t.element,"yui-effect-fade")},i.handleStartAnimateIn=function(e,t,i){i.overlay._fadingIn=!0,h.addClass(i.overlay.element,"hide-select"),i.overlay.underlay||i.overlay.cfg.refireEvent("underlay"),i.handleUnderlayStart(),i.overlay._setDomVisibility(!0),h.setStyle(i.overlay.element,"opacity",0)},i.handleCompleteAnimateIn=function(e,t,i){i.overlay._fadingIn=!1,h.removeClass(i.overlay.element,"hide-select"),i.overlay.element.style.filter&&(i.overlay.element.style.filter=null),i.handleUnderlayComplete(),i.overlay.cfg.refireEvent("iframe"),i.animateInCompleteEvent.fire()},i.handleStartAnimateOut=function(e,t,i){i.overlay._fadingOut=!0,h.addClass(i.overlay.element,"hide-select"),i.handleUnderlayStart()},i.handleCompleteAnimateOut=function(e,t,i){i.overlay._fadingOut=!1,h.removeClass(i.overlay.element,"hide-select"),i.overlay.element.style.filter&&(i.overlay.element.style.filter=null),i.overlay._setDomVisibility(!1),h.setStyle(i.overlay.element,"opacity",1),i.handleUnderlayComplete(),i.overlay.cfg.refireEvent("iframe"),i.animateOutCompleteEvent.fire()},i.init(),i},l.SLIDE=function(e,t){var i=YAHOO.util.Easing,r=e.cfg.getProperty("x")||h.getX(e.element),s=e.cfg.getProperty("y")||h.getY(e.element),n=h.getClientWidth(),o=e.element.offsetWidth,a={attributes:{points:{to:[r,s]}},duration:t,method:i.easeIn},n={attributes:{points:{to:[n+25,s]}},duration:t,method:i.easeOut},t=new l(e,a,n,e.element,YAHOO.util.Motion);return t.handleStartAnimateIn=function(e,t,i){i.overlay.element.style.left=-25-o+"px",i.overlay.element.style.top=s+"px"},t.handleTweenAnimateIn=function(e,t,i){var s=h.getXY(i.overlay.element),n=s[0],s=s[1];"hidden"==h.getStyle(i.overlay.element,"visibility")&&n<r&&i.overlay._setDomVisibility(!0),i.overlay.cfg.setProperty("xy",[n,s],!0),i.overlay.cfg.refireEvent("iframe")},t.handleCompleteAnimateIn=function(e,t,i){i.overlay.cfg.setProperty("xy",[r,s],!0),i.startX=r,i.startY=s,i.overlay.cfg.refireEvent("iframe"),i.animateInCompleteEvent.fire()},t.handleStartAnimateOut=function(e,t,i){var s=h.getViewportWidth(),n=h.getXY(i.overlay.element)[1];i.animOut.attributes.points.to=[s+25,n]},t.handleTweenAnimateOut=function(e,t,i){var s=h.getXY(i.overlay.element),n=s[0],s=s[1];i.overlay.cfg.setProperty("xy",[n,s],!0),i.overlay.cfg.refireEvent("iframe")},t.handleCompleteAnimateOut=function(e,t,i){i.overlay._setDomVisibility(!1),i.overlay.cfg.setProperty("xy",[r,s]),i.animateOutCompleteEvent.fire()},t.init(),t},l.prototype={init:function(){this.beforeAnimateInEvent=this.createEvent("beforeAnimateIn"),this.beforeAnimateInEvent.signature=e.LIST,this.beforeAnimateOutEvent=this.createEvent("beforeAnimateOut"),this.beforeAnimateOutEvent.signature=e.LIST,this.animateInCompleteEvent=this.createEvent("animateInComplete"),this.animateInCompleteEvent.signature=e.LIST,this.animateOutCompleteEvent=this.createEvent("animateOutComplete"),this.animateOutCompleteEvent.signature=e.LIST,this.animIn=new this.animClass(this.targetElement,this.attrIn.attributes,this.attrIn.duration,this.attrIn.method),this.animIn.onStart.subscribe(this.handleStartAnimateIn,this),this.animIn.onTween.subscribe(this.handleTweenAnimateIn,this),this.animIn.onComplete.subscribe(this.handleCompleteAnimateIn,this),this.animOut=new this.animClass(this.targetElement,this.attrOut.attributes,this.attrOut.duration,this.attrOut.method),this.animOut.onStart.subscribe(this.handleStartAnimateOut,this),this.animOut.onTween.subscribe(this.handleTweenAnimateOut,this),this.animOut.onComplete.subscribe(this.handleCompleteAnimateOut,this)},animateIn:function(){this._stopAnims(this.lastFrameOnStop),this.beforeAnimateInEvent.fire(),this.animIn.animate()},animateOut:function(){this._stopAnims(this.lastFrameOnStop),this.beforeAnimateOutEvent.fire(),this.animOut.animate()},lastFrameOnStop:!0,_stopAnims:function(e){this.animOut&&this.animOut.isAnimated()&&this.animOut.stop(e),this.animIn&&this.animIn.isAnimated()&&this.animIn.stop(e)},handleStartAnimateIn:function(e,t,i){},handleTweenAnimateIn:function(e,t,i){},handleCompleteAnimateIn:function(e,t,i){},handleStartAnimateOut:function(e,t,i){},handleTweenAnimateOut:function(e,t,i){},handleCompleteAnimateOut:function(e,t,i){},toString:function(){var e="ContainerEffect";return this.overlay&&(e+=" ["+this.overlay.toString()+"]"),e}},YAHOO.lang.augmentProto(l,YAHOO.util.EventProvider)}(),YAHOO.register("container",YAHOO.widget.Module,{version:"2.9.0",build:"2800"});
//# sourceMappingURL=container.js.map;
!function(){var s,h,d,g,p,i,f=YAHOO.env.ua,v=YAHOO.util.Dom,m=YAHOO.util.Event,b=YAHOO.lang,y="DIV",_="hd",E="bd",S="ft",P="LI",C="mousedown",O="position",I="dynamic",r="visible";function n(e){var t,s,i,r,n=m.getTarget(e),o=function c(e){var t,s;if(e&&e.tagName)switch(e.tagName.toUpperCase()){case y:t=e.parentNode,s=(v.hasClass(e,_)||v.hasClass(e,E)||v.hasClass(e,S))&&t&&t.tagName&&t.tagName.toUpperCase()==y?t:e;break;case P:s=e;break;default:(t=e.parentNode)&&(s=c(t))}return s}(n),a=!0,l=e.type;if(o&&((t=o.tagName.toUpperCase())==P?(s=o.id)&&g[s]&&(r=(i=g[s]).parent):t==y&&o.id&&(r=h[o.id])),r)s=p[l],(a="click"==l&&f.gecko&&"mac"!=r.platform&&0<e.button?!1:a)&&i&&!i.cfg.getProperty("disabled")&&i[s].fire(e),a&&r[s].fire(e,i);else if(l==C)for(var u in d)b.hasOwnProperty(d,u)&&(!(r=d[u]).cfg.getProperty("clicktohide")||r instanceof YAHOO.widget.MenuBar||r.cfg.getProperty(O)!=I?(0<r.cfg.getProperty("showdelay")&&r._cancelShowDelay(),r.activeItem&&(r.activeItem.blur(),r.activeItem.cfg.setProperty("selected",!1),r.activeItem=null)):(r.hide(),f.ie&&n.focus&&f.ie<9&&n.setActive()))}function o(e,t,s){h[s.id]&&this.removeMenu(s)}function a(e,t){t=t[1];t&&(i=t)}function l(e,t){i=null}function u(e,t){var t=t[0],s=this.id;t?d[s]=this:d[s]&&delete d[s]}function c(e,t){w(this)}function w(e){var t=e.id;t&&g[t]&&(i==e&&(i=null),delete g[t],e.destroyEvent.unsubscribe(c))}function M(e,t){var s,t=t[0];t instanceof YAHOO.widget.MenuItem&&(s=t.id,g[s]||(g[s]=t).destroyEvent.subscribe(c))}YAHOO.widget.MenuManager=(s=!1,h={},d={},g={},p={click:"clickEvent",mousedown:"mouseDownEvent",mouseup:"mouseUpEvent",mouseover:"mouseOverEvent",mouseout:"mouseOutEvent",keydown:"keyDownEvent",keyup:"keyUpEvent",keypress:"keyPressEvent",focus:"focusEvent",focusin:"focusEvent",blur:"blurEvent",focusout:"blurEvent"},i=null,{addMenu:function(e){var t;e instanceof YAHOO.widget.Menu&&e.id&&!h[e.id]&&(h[e.id]=e,s||(t=document,m.on(t,"mouseover",n,this,!0),m.on(t,"mouseout",n,this,!0),m.on(t,C,n,this,!0),m.on(t,"mouseup",n,this,!0),m.on(t,"click",n,this,!0),m.on(t,"keydown",n,this,!0),m.on(t,"keyup",n,this,!0),m.on(t,"keypress",n,this,!0),m.onFocus(t,n,this,!0),m.onBlur(t,n,this,!0),s=!0),e.cfg.subscribeToConfigEvent(r,u),e.destroyEvent.subscribe(o,e,this),e.itemAddedEvent.subscribe(M),e.focusEvent.subscribe(a),e.blurEvent.subscribe(l))},removeMenu:function(e){var t,s,i;if(e&&(t=e.id)in h&&h[t]==e){if((s=e.getItems())&&0<s.length)for(i=s.length-1;w(s[i]),i--;);delete h[t],t in d&&d[t]==e&&delete d[t],e.cfg&&e.cfg.unsubscribeFromConfigEvent(r,u),e.destroyEvent.unsubscribe(o,e),e.itemAddedEvent.unsubscribe(M),e.focusEvent.unsubscribe(a),e.blurEvent.unsubscribe(l)}},hideVisible:function(){var e,t;for(t in d)!b.hasOwnProperty(d,t)||(e=d[t])instanceof YAHOO.widget.MenuBar||e.cfg.getProperty(O)!=I||e.hide()},getVisible:function(){return d},getMenus:function(){return h},getMenu:function(e){var t;return t=e in h?h[e]:t},getMenuItem:function(e){var t;return t=e in g?g[e]:t},getMenuItemGroup:function(e){var t,s,i,r,e=v.get(e);if(e&&e.tagName&&"UL"==e.tagName.toUpperCase()&&(s=e.firstChild)){for(t=[];(i=s.id)&&(i=this.getMenuItem(i))&&(t[t.length]=i),s=s.nextSibling;);0<t.length&&(r=t)}return r},getFocusedMenuItem:function(){return i},getFocusedMenu:function(){var e;return e=i?i.parent.getRoot():e},toString:function(){return"MenuManager"}})}(),function(){var l=YAHOO.lang,u="SELECT",O="y",c="first-of-type",f="disabled",v="selected",x="groupindex",m="submenu",b="visible",o="hidedelay",y="position",_="dynamic",h="static",F=_+","+h,I="maxheight",B="topscrollbar",G="bottomscrollbar",e=B+"_"+f,U=G+"_"+f,R="mousemove",d="showdelay",g="submenuhidedelay",a="iframe",p="constraintoviewport",w="preventcontextoverlap",E="submenualignment",S="autosubmenudisplay",z="clicktohide",V="container",P="scrollincrement",M="minscrollheight",K="classname",C="shadow",H="keepopen",X="context",A="mousedown",W="keydown",j="height",T="width",k="px",q="monitorresize",Q="display",J="block",Z="visibility",$="absolute",ee="yui-menu-body-scrolled",r="mouseover",n="mouseout",te="itemAdded",se="yui-menu-shadow",ie=se+"-visible";YAHOO.widget.Menu=function(e,t){t&&(this.parent=t.parent,this.lazyLoad=t.lazyLoad||t.lazyload,this.itemData=t.itemData||t.itemdata),YAHOO.widget.Menu.superclass.constructor.call(this,e,t)};var re,ne,N=YAHOO.util.Dom,L=YAHOO.util.Event,oe=YAHOO.widget.Module,ae=YAHOO.widget.Overlay,D=YAHOO.widget.Menu,le=YAHOO.widget.MenuManager,ue=YAHOO.util.CustomEvent,Y=YAHOO.env.ua,ce=!1,he=[["mouseOverEvent",r],["mouseOutEvent",n],["mouseDownEvent",A],["mouseUpEvent","mouseup"],["clickEvent","click"],["keyPressEvent","keypress"],["keyDownEvent",W],["keyUpEvent","keyup"],["focusEvent","focus"],["blurEvent","blur"],["itemAddedEvent",te],["itemRemovedEvent","itemRemoved"]],de={key:b,value:!1,validator:l.isBoolean},ge={key:p,value:!0,validator:l.isBoolean,supercedes:[a,"x",O,"xy"]},pe={key:w,value:!0,validator:l.isBoolean,supercedes:[p]},fe={key:y,value:_,validator:function(e){var t=!1;return t=l.isString(e)?-1!=F.indexOf(e.toLowerCase()):t},supercedes:[b,a]},ve={key:E,value:["tl","tr"]},me={key:S,value:!0,validator:l.isBoolean,suppressEvent:!0},be={key:d,value:250,validator:l.isNumber,suppressEvent:!0},ye={key:o,value:0,validator:l.isNumber,suppressEvent:!0},_e={key:g,value:250,validator:l.isNumber,suppressEvent:!0},Ee={key:z,value:!0,validator:l.isBoolean,suppressEvent:!0},Se=V,Pe=!0,t={key:P,value:1,validator:l.isNumber,supercedes:[I],suppressEvent:!0},s={key:M,value:90,validator:l.isNumber,supercedes:[I],suppressEvent:!0},i={key:I,value:0,validator:l.isNumber,supercedes:[a],suppressEvent:!0},Ce={key:K,value:null,validator:l.isString,suppressEvent:!0},Oe={key:f,value:!1,validator:l.isBoolean,suppressEvent:!0},Ie={key:C,value:!0,validator:l.isBoolean,suppressEvent:!0,supercedes:[b]},we={key:H,value:!1,validator:l.isBoolean};function Me(e){ne=L.getTarget(e)}YAHOO.lang.extend(D,ae,{CSS_CLASS_NAME:"yuimenu",ITEM_TYPE:null,GROUP_TITLE_TAG_NAME:"h6",OFF_SCREEN_POSITION:"-999em",_useHideDelay:!1,_bHandledMouseOverEvent:!1,_bHandledMouseOutEvent:!1,_aGroupTitleElements:null,_aItemGroups:null,_aListElements:null,_nCurrentMouseX:0,_bStopMouseEventHandlers:!1,_sClassName:null,lazyLoad:!1,itemData:null,activeItem:null,parent:null,srcElement:null,init:function(e,t){var s;if(this._aItemGroups=[],this._aListElements=[],this._aGroupTitleElements=[],this.ITEM_TYPE||(this.ITEM_TYPE=YAHOO.widget.MenuItem),l.isString(e)?s=N.get(e):e.tagName&&(s=e),s&&s.tagName)switch(s.tagName.toUpperCase()){case"DIV":(this.srcElement=s).id||s.setAttribute("id",N.generateId()),D.superclass.init.call(this,s),this.beforeInitEvent.fire(D);break;case u:this.srcElement=s,D.superclass.init.call(this,N.generateId()),this.beforeInitEvent.fire(D)}else D.superclass.init.call(this,e),this.beforeInitEvent.fire(D);this.element&&(N.addClass(this.element,this.CSS_CLASS_NAME),this.initEvent.subscribe(this._onInit),this.beforeRenderEvent.subscribe(this._onBeforeRender),this.renderEvent.subscribe(this._onRender),this.beforeShowEvent.subscribe(this._onBeforeShow),this.hideEvent.subscribe(this._onHide),this.showEvent.subscribe(this._onShow),this.beforeHideEvent.subscribe(this._onBeforeHide),this.mouseOverEvent.subscribe(this._onMouseOver),this.mouseOutEvent.subscribe(this._onMouseOut),this.clickEvent.subscribe(this._onClick),this.keyDownEvent.subscribe(this._onKeyDown),this.keyPressEvent.subscribe(this._onKeyPress),this.blurEvent.subscribe(this._onBlur),ce||(L.onFocus(document,Me),ce=!0),(Y.gecko&&Y.gecko<1.9||Y.webkit&&Y.webkit<523)&&this.cfg.subscribeToConfigEvent(O,this._onYChange),t&&this.cfg.applyConfig(t,!0),le.addMenu(this),this.initEvent.fire(D))},_initSubTree:function(){var e,t,s,i,r,n,o,a=this.srcElement;if(a){if("DIV"==(e=a.tagName&&a.tagName.toUpperCase())&&(i=this.body.firstChild)){t=0,s=this.GROUP_TITLE_TAG_NAME.toUpperCase();do{if(i&&i.tagName)switch(i.tagName.toUpperCase()){case s:this._aGroupTitleElements[t]=i;break;case"UL":this._aListElements[t]=i,this._aItemGroups[t]=[],t++}}while(i=i.nextSibling);this._aListElements[0]&&N.addClass(this._aListElements[0],c)}if(i=null,e)switch(e){case"DIV":if(0<(n=(r=this._aListElements).length)){o=n-1;do{if(i=r[o].firstChild)for(;i&&i.tagName&&"LI"==i.tagName.toUpperCase()&&this.addItem(new this.ITEM_TYPE(i,{parent:this}),o),i=i.nextSibling;);}while(o--)}break;case u:i=a.firstChild;do{if(i&&i.tagName)switch(i.tagName.toUpperCase()){case"OPTGROUP":case"OPTION":this.addItem(new this.ITEM_TYPE(i,{parent:this}))}}while(i=i.nextSibling)}}},_getFirstEnabledItem:function(){for(var e,t,s=this.getItems(),i=s.length,r=0;r<i;r++)if((e=s[r])&&!e.cfg.getProperty(f)&&"none"!=e.element.style.display){t=e;break}return t},_addItemToGroup:function(e,t,s){var i,r,n,o;return t instanceof this.ITEM_TYPE?(i=t).parent=this:l.isString(t)?i=new this.ITEM_TYPE(t,{parent:this}):l.isObject(t)&&(i=new(t.parent=this).ITEM_TYPE(t.text,t)),i&&(i.cfg.getProperty(v)&&(this.activeItem=i),t=l.isNumber(e)?e:0,e=(e=this._getItemGroup(t))||this._createItemGroup(t),l.isNumber(s)?(n=s>=e.length,e[s]?e.splice(s,0,i):e[s]=i,(r=e[s])&&(!n||r.element.parentNode&&11!=r.element.parentNode.nodeType?!(n=function a(e,t){return e[t]||a(e,t+1)}(e,s+1))||r.element.parentNode&&11!=r.element.parentNode.nodeType||this._aListElements[t].insertBefore(r.element,n.element):this._aListElements[t].appendChild(r.element),(r.parent=this)._subscribeToItemEvents(r),this._configureSubmenu(r),this._updateItemProperties(t),this.itemAddedEvent.fire(r),this.changeContentEvent.fire(),o=r)):(e[s=e.length]=i,(r=e[s])&&(N.isAncestor(this._aListElements[t],r.element)||this._aListElements[t].appendChild(r.element),r.element.setAttribute(x,t),r.element.setAttribute("index",s),r.parent=this,r.index=s,r.groupIndex=t,this._subscribeToItemEvents(r),this._configureSubmenu(r),0===s&&N.addClass(r.element,c),this.itemAddedEvent.fire(r),this.changeContentEvent.fire(),o=r))),o},_removeItemFromGroupByIndex:function(e,t){var s,e=l.isNumber(e)?e:0,i=this._getItemGroup(e);return i&&(s=i.splice(t,1)[0])&&(this._updateItemProperties(e),0===i.length&&((t=this._aListElements[e])&&t.parentNode&&t.parentNode.removeChild(t),this._aItemGroups.splice(e,1),this._aListElements.splice(e,1),t=this._aListElements[0])&&N.addClass(t,c),this.itemRemovedEvent.fire(s),this.changeContentEvent.fire()),s},_removeItemFromGroupByValue:function(e,t){var s,i,r,n,o=this._getItemGroup(e);if(o&&(i=-1,0<(s=o.length))){n=s-1;do{if(o[n]==t){i=n;break}}while(n--);-1<i&&(r=this._removeItemFromGroupByIndex(e,i))}return r},_updateItemProperties:function(e){var t,s,i,r=this._getItemGroup(e),n=r.length;if(0<n){for(i=n-1;(t=r[i])&&(s=t.element,t.index=i,t.groupIndex=e,s.setAttribute(x,e),s.setAttribute("index",i),N.removeClass(s,c)),i--;);s&&N.addClass(s,c)}},_createItemGroup:function(e){var t;return this._aItemGroups[e]||(this._aItemGroups[e]=[],t=document.createElement("ul"),this._aListElements[e]=t,t=this._aItemGroups[e]),t},_getItemGroup:function(e){var t,e=l.isNumber(e)?e:0,s=this._aItemGroups;return t=e in s?s[e]:t},_configureSubmenu:function(e){e=e.cfg.getProperty(m);e&&(this.cfg.configChangedEvent.subscribe(this._onParentMenuConfigChange,e,!0),this.renderEvent.subscribe(this._onParentMenuRender,e,!0))},_subscribeToItemEvents:function(e){e.destroyEvent.subscribe(this._onMenuItemDestroy,e,this),e.cfg.configChangedEvent.subscribe(this._onMenuItemConfigChange,e,this)},_onVisibleChange:function(e,t){t[0]?N.addClass(this.element,b):N.removeClass(this.element,b)},_cancelHideDelay:function(){var e=this.getRoot()._hideDelayTimer;e&&e.cancel()},_execHideDelay:function(){this._cancelHideDelay();var e=this.getRoot();e._hideDelayTimer=l.later(e.cfg.getProperty(o),this,function(){e.activeItem&&(e.hasFocus()&&e.activeItem.focus(),e.clearActiveItem()),e!=this||this instanceof YAHOO.widget.MenuBar||this.cfg.getProperty(y)!=_||this.hide()})},_cancelShowDelay:function(){var e=this.getRoot()._showDelayTimer;e&&e.cancel()},_execSubmenuHideDelay:function(e,t,s){e._submenuHideDelayTimer=l.later(50,this,function(){this._nCurrentMouseX>t+10?e._submenuHideDelayTimer=l.later(s,e,function(){this.hide()}):e.hide()})},_disableScrollHeader:function(){this._bHeaderDisabled||(N.addClass(this.header,e),this._bHeaderDisabled=!0)},_disableScrollFooter:function(){this._bFooterDisabled||(N.addClass(this.footer,U),this._bFooterDisabled=!0)},_enableScrollHeader:function(){this._bHeaderDisabled&&(N.removeClass(this.header,e),this._bHeaderDisabled=!1)},_enableScrollFooter:function(){this._bFooterDisabled&&(N.removeClass(this.footer,U),this._bFooterDisabled=!1)},_onMouseOver:function(e,t){var s=t[0],t=t[1],i=L.getTarget(s),r=this.getRoot(),n=this._submenuHideDelayTimer;this._bStopMouseEventHandlers||(this._bHandledMouseOverEvent||i!=this.element&&!N.isAncestor(this.element,i)||(this._useHideDelay&&this._cancelHideDelay(),this._nCurrentMouseX=0,L.on(this.element,R,this._onMouseMove,this,!0),t&&N.isAncestor(t.element,L.getRelatedTarget(s))||this.clearActiveItem(),this.parent&&n&&(n.cancel(),this.parent.cfg.setProperty(v,!0),(s=this.parent.parent)._bHandledMouseOutEvent=!0,s._bHandledMouseOverEvent=!1),this._bHandledMouseOverEvent=!0,this._bHandledMouseOutEvent=!1),!t)||t.handledMouseOverEvent||t.cfg.getProperty(f)||i!=t.element&&!N.isAncestor(t.element,i)||((n=0<this.cfg.getProperty(d))&&this._cancelShowDelay(),(s=this.activeItem)&&s.cfg.setProperty(v,!1),(i=t.cfg).setProperty(v,!0),(this.hasFocus()||r._hasFocus)&&(t.focus(),r._hasFocus=!1),this.cfg.getProperty(S)&&(s=i.getProperty(m))&&(n?r._showDelayTimer=l.later(r.cfg.getProperty(d),s,function(){this.parent.cfg.getProperty(v)&&this.show()}):s.show()),t.handledMouseOverEvent=!0,t.handledMouseOutEvent=!1)},_onMouseOut:function(e,t){var s,i,r,n=t[0],t=t[1],o=L.getRelatedTarget(n),a=!1;this._bStopMouseEventHandlers||(t&&!t.cfg.getProperty(f)&&((s=t.cfg.getProperty(m))&&(o==s.element||N.isAncestor(s.element,o))&&(a=!0),t.handledMouseOutEvent||(o==t.element||N.isAncestor(t.element,o))&&!a||(a||(t.cfg.setProperty(v,!1),s&&(i=this.cfg.getProperty(g),r=this.cfg.getProperty(d),!(this instanceof YAHOO.widget.MenuBar)&&0<i&&r<=i?this._execSubmenuHideDelay(s,L.getPageX(n),i):s.hide())),t.handledMouseOutEvent=!0,t.handledMouseOverEvent=!1)),this._bHandledMouseOutEvent)||(this._didMouseLeave(o)||a)&&(this._useHideDelay&&this._execHideDelay(),L.removeListener(this.element,R,this._onMouseMove),this._nCurrentMouseX=L.getPageX(n),this._bHandledMouseOutEvent=!0,this._bHandledMouseOverEvent=!1)},_didMouseLeave:function(e){return e===this._shadow||e!=this.element&&!N.isAncestor(this.element,e)},_onMouseMove:function(e,t){this._bStopMouseEventHandlers||(this._nCurrentMouseX=L.getPageX(e))},_onClick:function(e,t){var s,i,r,n,o,a=t[0],t=t[1],l=!1,u=function(){(i=this.getRoot())instanceof YAHOO.widget.MenuBar||i.cfg.getProperty(y)==h?i.clearActiveItem():i.hide()};t&&(t.cfg.getProperty(f)?(L.preventDefault(a),u.call(this)):(s=t.cfg.getProperty(m),(r=t.cfg.getProperty("url"))&&(n=r.indexOf("#"),o=r.length,-1!=n)&&(1<(o=(r=r.substr(n,o)).length)?(n=r.substr(1,o),(r=YAHOO.widget.MenuManager.getMenu(n))&&(l=this.getRoot()===r.getRoot())):1===o&&(l=!0)),l&&!t.cfg.getProperty("target")&&(L.preventDefault(a),Y.webkit?t.focus():t.focusEvent.fire()),s&&!t.value||this.cfg.getProperty(H)||u.call(this)))},_stopMouseEventHandlers:function(){this._bStopMouseEventHandlers=!0,l.later(10,this,function(){this._bStopMouseEventHandlers=!1})},_onKeyDown:function(e,t){var s,i,r,n,o,a,l,u,c,h,d=t[0],g=t[1];if(this._useHideDelay&&this._cancelHideDelay(),g&&!g.cfg.getProperty(f))switch(i=g.cfg,r=this.parent,d.keyCode){case 38:case 40:(n=38==d.keyCode?g.getPreviousEnabledSibling():g.getNextEnabledSibling())&&(this.clearActiveItem(),n.cfg.setProperty(v,!0),n.focus(),0<this.cfg.getProperty(I)||N.hasClass(this.body,ee))&&(a=(o=this.body).scrollTop,l=o.offsetHeight,c=(u=this.getItems()).length-1,h=n.element.offsetTop,40==d.keyCode?(l+a<=h?o.scrollTop=h-l:h<=a&&(o.scrollTop=0),n==u[c]&&(o.scrollTop=n.element.offsetTop)):(h<=a?o.scrollTop=h-n.element.offsetHeight:a+l<=h&&(o.scrollTop=h),n==u[0]&&(o.scrollTop=0)),a=o.scrollTop,c=o.scrollHeight-o.offsetHeight,0===a?(this._disableScrollHeader(),this._enableScrollFooter()):a==c?(this._enableScrollHeader(),this._disableScrollFooter()):(this._enableScrollHeader(),this._enableScrollFooter())),L.preventDefault(d),this._stopMouseEventHandlers();break;case 39:(s=i.getProperty(m))?(i.getProperty(v)||i.setProperty(v,!0),s.show(),s.setInitialFocus(),s.setInitialSelection()):(l=this.getRoot())instanceof YAHOO.widget.MenuBar&&(n=l.activeItem.getNextEnabledSibling())&&(l.clearActiveItem(),n.cfg.setProperty(v,!0),(s=n.cfg.getProperty(m))?(s.show(),s.setInitialFocus()):n.focus()),L.preventDefault(d),this._stopMouseEventHandlers();break;case 37:r&&((h=r.parent)instanceof YAHOO.widget.MenuBar?(n=h.activeItem.getPreviousEnabledSibling())&&(h.clearActiveItem(),n.cfg.setProperty(v,!0),(s=n.cfg.getProperty(m))?(s.show(),s.setInitialFocus()):n.focus()):(this.hide(),r.focus())),L.preventDefault(d),this._stopMouseEventHandlers()}if(27==d.keyCode){if(this.cfg.getProperty(y)==_){if(this.hide(),this.parent)this.parent.focus();else if((t=this._focusedElement)&&t.focus)try{t.focus()}catch(p){}}else this.activeItem&&((s=this.activeItem.cfg.getProperty(m))&&s.cfg.getProperty(b)?(s.hide(),this.activeItem.focus()):(this.activeItem.blur(),this.activeItem.cfg.setProperty(v,!1)));L.preventDefault(d)}},_onKeyPress:function(e,t){t=t[0];40!=t.keyCode&&38!=t.keyCode||L.preventDefault(t)},_onBlur:function(e,t){this._hasFocus&&(this._hasFocus=!1)},_onYChange:function(e,t){var s,i=this.parent;i&&0<(i=i.parent.body.scrollTop)&&(i=this.cfg.getProperty(O)-i,N.setY(this.element,i),(s=this.iframe)&&N.setY(s,i),this.cfg.setProperty(O,i,!0))},_onScrollTargetMouseOver:function(e,t){var s,i=this._bodyScrollTimer,i=(i&&i.cancel(),this._cancelHideDelay(),L.getTarget(e)),r=this.body,n=this.cfg.getProperty(P);e=N.hasClass(i,"hd")?function(){var e=r.scrollTop;0<e?(r.scrollTop=e-n,this._enableScrollFooter()):(r.scrollTop=0,this._bodyScrollTimer.cancel(),this._disableScrollHeader())}:(s=r.scrollHeight-r.offsetHeight,function(){var e=r.scrollTop;e<s?(r.scrollTop=e+n,this._enableScrollHeader()):(r.scrollTop=s,this._bodyScrollTimer.cancel(),this._disableScrollFooter())}),this._bodyScrollTimer=l.later(10,this,e,null,!0)},_onScrollTargetMouseOut:function(e,t){var s=this._bodyScrollTimer;s&&s.cancel(),this._cancelHideDelay()},_onInit:function(e,t){this.cfg.subscribeToConfigEvent(b,this._onVisibleChange);var s=!this.parent,i=this.lazyLoad;(s&&!i||s&&(this.cfg.getProperty(b)||this.cfg.getProperty(y)==h)||!s&&!i)&&0===this.getItemGroups().length?(this.srcElement&&this._initSubTree(),this.itemData&&this.addItems(this.itemData)):i&&this.cfg.fireQueue()},_onBeforeRender:function(e,t){var s,i,r=this.element,n=this._aListElements.length,o=!0,a=0;if(0<n)for(;(s=this._aListElements[a])&&(o&&(N.addClass(s,c),o=!1),N.isAncestor(r,s)||this.appendToBody(s),i=this._aGroupTitleElements[a])&&(N.isAncestor(r,i)||s.parentNode.insertBefore(i,s),N.addClass(s,"hastitle")),++a<n;);},_onRender:function(e,t){this.cfg.getProperty(y)!=_||this.cfg.getProperty(b)||this.positionOffScreen()},_onBeforeShow:function(e,t){var s,i,r=this.cfg.getProperty(V);if(this.lazyLoad&&0===this.getItemGroups().length){if(this.srcElement&&this._initSubTree(),this.itemData)if(this.parent&&this.parent.parent&&this.parent.parent.srcElement&&this.parent.parent.srcElement.tagName.toUpperCase()==u)for(s=this.itemData.length,i=0;i<s;i++)this.itemData[i].tagName&&this.addItem(new this.ITEM_TYPE(this.itemData[i]));else this.addItems(this.itemData);(n=this.srcElement)?n.tagName.toUpperCase()==u?N.inDocument(n)?this.render(n.parentNode):this.render(r):this.render():this.parent?this.render(this.parent.element):this.render(r)}var n=this.parent;n||this.cfg.getProperty(y)!=_||this.cfg.refireEvent("xy"),n&&(r=n.parent.cfg.getProperty(E),this.cfg.setProperty(X,[n.element,r[0],r[1]]),this.align())},getConstrainedY:function(e){var r,t,s,i,n,o=this,a=o.cfg.getProperty(X),l=o.cfg.getProperty(I),u=a&&{trbr:!0,tlbl:!0,bltl:!0,brtr:!0}[a[1]+a[2]],c=o.element,h=c.offsetHeight,d=ae.VIEWPORT_OFFSET,g=N.getViewportHeight(),p=N.getDocumentScrollTop(),f=o.cfg.getProperty(M)+d<g,v=!1,m=p+d,b=p+g-h-d,y=e,_=function(){var e=o.cfg.getProperty(O)-p>t?t-h:t+s;return o.cfg.setProperty(O,e+p,!0),e},E=function(){return o.cfg.getProperty(O)-p>t?n-d:i-d},S=function(){var e=o.cfg.getProperty(O)-p>t?t+s:t-c.offsetHeight;o.cfg.setProperty(O,e+p,!0)},P=function(){o._setScrollHeight(this.cfg.getProperty(I)),o.hideEvent.unsubscribe(P)},C=function(){var e,t,s=E(),i=0<o.getItems().length;return s<h?(e=i?o.cfg.getProperty(M):h,r=e<s&&i?s:l,o._setScrollHeight(r),o.hideEvent.subscribe(P),S(),s<e&&(v?_():(_(),v=!0,t=C()))):r&&r!==l&&(o._setScrollHeight(l),o.hideEvent.subscribe(P),S()),t};return(e<m||b<e)&&(f?o.cfg.getProperty(w)&&u?(f=a[0],s=f.offsetHeight,t=N.getY(f)-p,n=g-((i=t)+s),C(),y=o.cfg.getProperty(O)):!(o instanceof YAHOO.widget.MenuBar)&&g<=h?(u=g-2*d)>o.cfg.getProperty(M)&&(o._setScrollHeight(u),o.hideEvent.subscribe(P),S(),y=o.cfg.getProperty(O)):e<m?y=m:b<e&&(y=b):y=d+p),y},_onHide:function(e,t){this.cfg.getProperty(y)===_&&this.positionOffScreen()},_onShow:function(e,t){var s,i,r=this.parent;function n(e){e.type!=A&&(e.type!=W||27!=e.keyCode)||(e=L.getTarget(e))==s.element&&N.isAncestor(s.element,e)||(s.cfg.setProperty(S,!1),L.removeListener(document,A,n),L.removeListener(document,W,n))}r&&(!(s=r.parent).cfg.getProperty(S)&&(s instanceof YAHOO.widget.MenuBar||s.cfg.getProperty(y)==h)&&(s.cfg.setProperty(S,!0),L.on(document,A,n),L.on(document,W,n)),this.cfg.getProperty("x")<s.cfg.getProperty("x"))&&Y.gecko&&Y.gecko<1.9&&!this.cfg.getProperty(T)&&(i=(r=this.element).offsetWidth,r.style.width=i+k,r=i-(r.offsetWidth-i)+k,this.cfg.setProperty(T,r),this.hideEvent.subscribe(function o(e,t,s){this.cfg.setProperty(T,""),this.hideEvent.unsubscribe(o,s)},r)),this===this.getRoot()&&this.cfg.getProperty(y)===_&&(this._focusedElement=ne,this.focus())},_onBeforeHide:function(e,t){var s=this.activeItem,i=this.getRoot();s&&((s=s.cfg).setProperty(v,!1),s=s.getProperty(m))&&s.hide(),Y.ie&&this.cfg.getProperty(y)===_&&this.parent&&(i._hasFocus=this.hasFocus()),i==this&&i.blur()},_onParentMenuConfigChange:function(e,t,s){var i=t[0][0],r=t[0][1];switch(i){case a:case p:case o:case d:case g:case z:case"effect":case K:case P:case I:case M:case q:case C:case w:case H:s.cfg.setProperty(i,r);break;case E:this.parent.parent instanceof YAHOO.widget.MenuBar||s.cfg.setProperty(i,r)}},_onParentMenuRender:function(e,t,s){var i=s.parent.parent,r=i.cfg,n={constraintoviewport:r.getProperty(p),xy:[0,0],clicktohide:r.getProperty(z),effect:r.getProperty("effect"),showdelay:r.getProperty(d),hidedelay:r.getProperty(o),submenuhidedelay:r.getProperty(g),classname:r.getProperty(K),scrollincrement:r.getProperty(P),maxheight:r.getProperty(I),minscrollheight:r.getProperty(M),iframe:r.getProperty(a),shadow:r.getProperty(C),preventcontextoverlap:r.getProperty(w),monitorresize:r.getProperty(q),keepopen:r.getProperty(H)};i instanceof YAHOO.widget.MenuBar||(n[E]=r.getProperty(E)),s.cfg.applyConfig(n),this.lazyLoad||(i=this.parent.element,this.element.parentNode==i?this.render():this.render(i))},_onMenuItemDestroy:function(e,t,s){this._removeItemFromGroupByValue(s.groupIndex,s)},_onMenuItemConfigChange:function(e,t,s){var i=t[0][0],r=t[0][1];switch(i){case v:!0===r&&(this.activeItem=s);break;case m:t[0][1]&&this._configureSubmenu(s)}},configVisible:function(e,t,s){this.cfg.getProperty(y)==_?D.superclass.configVisible.call(this,e,t,s):(e=t[0],s=N.getStyle(this.element,Q),N.setStyle(this.element,Z,b),e?s!=J&&(this.beforeShowEvent.fire(),N.setStyle(this.element,Q,J),this.showEvent.fire()):s==J&&(this.beforeHideEvent.fire(),N.setStyle(this.element,Q,"none"),this.hideEvent.fire()))},configPosition:function(e,t,s){var i=this.element,t=t[0]==h?h:$,r=this.cfg;N.setStyle(i,y,t),t==h?(N.setStyle(i,Q,J),r.setProperty(b,!0)):N.setStyle(i,Z,"hidden"),t!=$||(i=r.getProperty("zindex"))&&0!==i||r.setProperty("zindex",1)},configIframe:function(e,t,s){this.cfg.getProperty(y)==_&&D.superclass.configIframe.call(this,e,t,s)},configHideDelay:function(e,t,s){t=t[0];this._useHideDelay=0<t},configContainer:function(e,t,s){t=t[0];l.isString(t)&&this.cfg.setProperty(V,N.get(t),!0)},_clearSetWidthFlag:function(){this._widthSetForScroll=!1,this.cfg.unsubscribeFromConfigEvent(T,this._clearSetWidthFlag)},_subscribeScrollHandlers:function(e,t){var s=this._onScrollTargetMouseOver,i=this._onScrollTargetMouseOut;L.on(e,r,s,this,!0),L.on(e,n,i,this,!0),L.on(t,r,s,this,!0),L.on(t,n,i,this,!0)},_unsubscribeScrollHandlers:function(e,t){var s=this._onScrollTargetMouseOver,i=this._onScrollTargetMouseOut;L.removeListener(e,r,s),L.removeListener(e,n,i),L.removeListener(t,r,s),L.removeListener(t,n,i)},_setScrollHeight:function(e){var t,s,i,r,n,o=!1;0<this.getItems().length&&(t=this.element,s=this.body,i=this.header,r=this.footer,n=this.cfg.getProperty(M),0<e&&e<n&&(e=n),N.setStyle(s,j,""),N.removeClass(s,ee),s.scrollTop=0,n=Y.gecko&&Y.gecko<1.9||Y.ie,0<e&&n&&!this.cfg.getProperty(T)&&(n=t.offsetWidth,t.style.width=n+k,n=n-(t.offsetWidth-n)+k,this.cfg.unsubscribeFromConfigEvent(T,this._clearSetWidthFlag),this.cfg.setProperty(T,n),this._widthSetForScroll=!0,this.cfg.subscribeToConfigEvent(T,this._clearSetWidthFlag)),0<e&&!i&&!r&&(this.setHeader("&#32;"),this.setFooter("&#32;"),i=this.header,r=this.footer,N.addClass(i,B),N.addClass(r,G),t.insertBefore(i,s),t.appendChild(r)),n=e,i&&r&&(n-=i.offsetHeight+r.offsetHeight),0<n&&s.offsetHeight>e?(N.addClass(s,ee),N.setStyle(s,j,n+k),this._hasScrollEventHandlers||(this._subscribeScrollHandlers(i,r),this._hasScrollEventHandlers=!0),this._disableScrollHeader(),this._enableScrollFooter(),o=!0):i&&r&&(this._widthSetForScroll&&(this._widthSetForScroll=!1,this.cfg.unsubscribeFromConfigEvent(T,this._clearSetWidthFlag),this.cfg.setProperty(T,"")),this._enableScrollHeader(),this._enableScrollFooter(),this._hasScrollEventHandlers&&(this._unsubscribeScrollHandlers(i,r),this._hasScrollEventHandlers=!1),t.removeChild(i),t.removeChild(r),this.header=null,o=!(this.footer=null)),o)&&(this.cfg.refireEvent(a),this.cfg.refireEvent(C))},_setMaxHeight:function(e,t,s){this._setScrollHeight(s),this.renderEvent.unsubscribe(this._setMaxHeight)},configMaxHeight:function(e,t,s){t=t[0];this.lazyLoad&&!this.body&&0<t?this.renderEvent.subscribe(this._setMaxHeight,t,this):this._setScrollHeight(t)},configClassName:function(e,t,s){t=t[0];this._sClassName&&N.removeClass(this.element,this._sClassName),N.addClass(this.element,t),this._sClassName=t},_onItemAdded:function(e,t){t=t[0];t&&t.cfg.setProperty(f,!0)},configDisabled:function(e,t,s){var i,r=t[0],n=this.getItems();if(l.isArray(n)){if(0<(t=n.length))for(i=t-1;n[i].cfg.setProperty(f,r),i--;);r?(this.clearActiveItem(!0),N.addClass(this.element,f),this.itemAddedEvent.subscribe(this._onItemAdded)):(N.removeClass(this.element,f),this.itemAddedEvent.unsubscribe(this._onItemAdded))}},_sizeShadow:function(){var e=this.element,t=this._shadow;t&&e&&(t.style.width&&t.style.height&&(t.style.width="",t.style.height=""),t.style.width=e.offsetWidth+6+k,t.style.height=e.offsetHeight+1+k)},_replaceShadow:function(){this.element.appendChild(this._shadow)},_addShadowVisibleClass:function(){N.addClass(this._shadow,ie)},_removeShadowVisibleClass:function(){N.removeClass(this._shadow,ie)},_removeShadow:function(){var e=this._shadow&&this._shadow.parentNode;e&&e.removeChild(this._shadow),this.beforeShowEvent.unsubscribe(this._addShadowVisibleClass),this.beforeHideEvent.unsubscribe(this._removeShadowVisibleClass),this.cfg.unsubscribeFromConfigEvent(T,this._sizeShadow),this.cfg.unsubscribeFromConfigEvent(j,this._sizeShadow),this.cfg.unsubscribeFromConfigEvent(I,this._sizeShadow),this.cfg.unsubscribeFromConfigEvent(I,this._replaceShadow),this.changeContentEvent.unsubscribe(this._sizeShadow),oe.textResizeEvent.unsubscribe(this._sizeShadow)},_createShadow:function(){var e,t;this._shadow||(t=this.element,re||((re=document.createElement("div")).className="yui-menu-shadow yui-menu-shadow-visible"),e=re.cloneNode(!1),t.appendChild(e),this._shadow=e,this.beforeShowEvent.subscribe(this._addShadowVisibleClass),this.beforeHideEvent.subscribe(this._removeShadowVisibleClass),Y.ie&&(l.later(0,this,function(){this._sizeShadow(),this.syncIframe()}),this.cfg.subscribeToConfigEvent(T,this._sizeShadow),this.cfg.subscribeToConfigEvent(j,this._sizeShadow),this.cfg.subscribeToConfigEvent(I,this._sizeShadow),this.changeContentEvent.subscribe(this._sizeShadow),oe.textResizeEvent.subscribe(this._sizeShadow,this,!0),this.destroyEvent.subscribe(function(){oe.textResizeEvent.unsubscribe(this._sizeShadow,this)})),this.cfg.subscribeToConfigEvent(I,this._replaceShadow))},_shadowBeforeShow:function(){this._shadow?(this._replaceShadow(),Y.ie&&this._sizeShadow()):this._createShadow(),this.beforeShowEvent.unsubscribe(this._shadowBeforeShow)},configShadow:function(e,t,s){t=t[0];t&&this.cfg.getProperty(y)==_?this.cfg.getProperty(b)?this._shadow?(this._replaceShadow(),Y.ie&&this._sizeShadow()):this._createShadow():this.beforeShowEvent.subscribe(this._shadowBeforeShow):t||(this.beforeShowEvent.unsubscribe(this._shadowBeforeShow),this._removeShadow())},initEvents:function(){D.superclass.initEvents.call(this);for(var e,t,s=he.length-1;(t=this.createEvent((e=he[s])[1])).signature=ue.LIST,this[e[0]]=t,s--;);},positionOffScreen:function(){var e=this.iframe,t=this.element,s=this.OFF_SCREEN_POSITION;t.style.top="",t.style.left="",e&&(e.style.top=s,e.style.left=s)},getRoot:function(){var e=this.parent,e=e&&(e=e.parent)?e.getRoot():this;return e},toString:function(){var e="Menu",t=this.id;return t&&(e+=" "+t),e},setItemGroupTitle:function(e,t){var s,i,r;if(l.isString(e)&&0<e.length){for(t=l.isNumber(t)?t:0,(s=this._aGroupTitleElements[t])?s.innerHTML=e:((s=document.createElement(this.GROUP_TITLE_TAG_NAME)).innerHTML=e,this._aGroupTitleElements[t]=s),i=this._aGroupTitleElements.length-1;this._aGroupTitleElements[i]&&(N.removeClass(this._aGroupTitleElements[i],c),r=i),i--;);null!==r&&N.addClass(this._aGroupTitleElements[r],c),this.changeContentEvent.fire()}},addItem:function(e,t){return this._addItemToGroup(t,e)},addItems:function(e,t){var s,i,r,n,o;if(l.isArray(e)){for(s=e.length,i=[],n=0;n<s;n++)(r=e[n])&&(l.isArray(r)?i[i.length]=this.addItems(r,n):i[i.length]=this._addItemToGroup(t,r));i.length&&(o=i)}return o},insertItem:function(e,t,s){return this._addItemToGroup(s,e,t)},removeItem:function(e,t){var s,i;return l.isUndefined(e)||(e instanceof YAHOO.widget.MenuItem?s=this._removeItemFromGroupByValue(t,e):l.isNumber(e)&&(s=this._removeItemFromGroupByIndex(t,e)),s&&(s.destroy(),i=s)),i},getItems:function(){var e,t=this._aItemGroups;return e=l.isArray(t)?1==t.length?t[0]:Array.prototype.concat.apply([],t):e},getItemGroups:function(){return this._aItemGroups},getItem:function(e,t){var s;return s=l.isNumber(e)&&(t=this._getItemGroup(t))?t[e]:s},getSubmenus:function(){var e,t,s,i=this.getItems(),r=i.length;if(0<r)for(e=[],s=0;s<r;s++)(t=i[s])&&(t=t.cfg.getProperty(m))&&(e[e.length]=t);return e},clearContent:function(){var e,t,s,i=this.getItems(),r=i.length,n=this.element,o=this.body,a=this.header,l=this.footer;if(0<r)for(s=r-1;(e=i[s])&&((t=e.cfg.getProperty(m))&&(this.cfg.configChangedEvent.unsubscribe(this._onParentMenuConfigChange,t),this.renderEvent.unsubscribe(this._onParentMenuRender,t)),this.removeItem(e,e.groupIndex)),s--;);a&&(L.purgeElement(a),n.removeChild(a)),l&&(L.purgeElement(l),n.removeChild(l)),o&&(L.purgeElement(o),o.innerHTML=""),this.activeItem=null,this._aItemGroups=[],this._aListElements=[],this._aGroupTitleElements=[],this.cfg.setProperty(T,null)},destroy:function(e){this.clearContent(),this._aItemGroups=null,this._aListElements=null,this._aGroupTitleElements=null,D.superclass.destroy.call(this,e)},setInitialFocus:function(){var e=this._getFirstEnabledItem();e&&e.focus()},setInitialSelection:function(){var e=this._getFirstEnabledItem();e&&e.cfg.setProperty(v,!0)},clearActiveItem:function(e){0<this.cfg.getProperty(d)&&this._cancelShowDelay();var t,s=this.activeItem;s&&(t=s.cfg,e&&(s.blur(),this.getRoot()._hasFocus=!0),t.setProperty(v,!1),(e=t.getProperty(m))&&e.hide(),this.activeItem=null)},focus:function(){this.hasFocus()||this.setInitialFocus()},blur:function(){var e;this.hasFocus()&&(e=le.getFocusedMenuItem())&&e.blur()},hasFocus:function(){return le.getFocusedMenu()==this.getRoot()},_doItemSubmenuSubscribe:function(e,t,s){t=t[0].cfg.getProperty(m);t&&t.subscribe.apply(t,s)},_doSubmenuSubscribe:function(e,t,s){var i=this.cfg.getProperty(m);i&&i.subscribe.apply(i,s)},subscribe:function(){D.superclass.subscribe.apply(this,arguments),D.superclass.subscribe.call(this,te,this._doItemSubmenuSubscribe,arguments);var e,t,s,i,r=this.getItems();if(r&&0<(e=r.length))for(i=e-1;(s=(t=r[i]).cfg.getProperty(m))?s.subscribe.apply(s,arguments):t.cfg.subscribeToConfigEvent(m,this._doSubmenuSubscribe,arguments),i--;);},unsubscribe:function(){D.superclass.unsubscribe.apply(this,arguments),D.superclass.unsubscribe.call(this,te,this._doItemSubmenuSubscribe,arguments);var e,t,s,i,r=this.getItems();if(r&&0<(e=r.length))for(i=e-1;(s=(t=r[i]).cfg.getProperty(m))?s.unsubscribe.apply(s,arguments):t.cfg.unsubscribeFromConfigEvent(m,this._doSubmenuSubscribe,arguments),i--;);},initDefaultConfig:function(){D.superclass.initDefaultConfig.call(this);var e=this.cfg;e.addProperty(de.key,{handler:this.configVisible,value:de.value,validator:de.validator}),e.addProperty(ge.key,{handler:this.configConstrainToViewport,value:ge.value,validator:ge.validator,supercedes:ge.supercedes}),e.addProperty(pe.key,{value:pe.value,validator:pe.validator,supercedes:pe.supercedes}),e.addProperty(fe.key,{handler:this.configPosition,value:fe.value,validator:fe.validator,supercedes:fe.supercedes}),e.addProperty(ve.key,{value:ve.value,suppressEvent:ve.suppressEvent}),e.addProperty(me.key,{value:me.value,validator:me.validator,suppressEvent:me.suppressEvent}),e.addProperty(be.key,{value:be.value,validator:be.validator,suppressEvent:be.suppressEvent}),e.addProperty(ye.key,{handler:this.configHideDelay,value:ye.value,validator:ye.validator,suppressEvent:ye.suppressEvent}),e.addProperty(_e.key,{value:_e.value,validator:_e.validator,suppressEvent:_e.suppressEvent}),e.addProperty(Ee.key,{value:Ee.value,validator:Ee.validator,suppressEvent:Ee.suppressEvent}),e.addProperty(Se,{handler:this.configContainer,value:document.body,suppressEvent:Pe}),e.addProperty(t.key,{value:t.value,validator:t.validator,supercedes:t.supercedes,suppressEvent:t.suppressEvent}),e.addProperty(s.key,{value:s.value,validator:s.validator,supercedes:s.supercedes,suppressEvent:s.suppressEvent}),e.addProperty(i.key,{handler:this.configMaxHeight,value:i.value,validator:i.validator,suppressEvent:i.suppressEvent,supercedes:i.supercedes}),e.addProperty(Ce.key,{handler:this.configClassName,value:Ce.value,validator:Ce.validator,supercedes:Ce.supercedes}),e.addProperty(Oe.key,{handler:this.configDisabled,value:Oe.value,validator:Oe.validator,suppressEvent:Oe.suppressEvent}),e.addProperty(Ie.key,{handler:this.configShadow,value:Ie.value,validator:Ie.validator}),e.addProperty(we.key,{value:we.value,validator:we.validator})}})}(),function(){YAHOO.widget.MenuItem=function(e,t){e&&(t&&(this.parent=t.parent,this.value=t.value,this.id=t.id),this.init(e,t))};var h=YAHOO.util.Dom,Y=YAHOO.widget.Module,d=YAHOO.widget.Menu,e=YAHOO.widget.MenuItem,x=YAHOO.util.CustomEvent,l=YAHOO.env.ua,g=YAHOO.lang,p="text",F="-",u="helptext",f="url",v="target",c="emphasis",m="strongemphasis",a="checked",b="submenu",y="disabled",_="selected",E="hassubmenu",B="checked-disabled",G="hassubmenu-disabled",U="hassubmenu-selected",R="checked-selected",z="onclick",S="href",i="none",o="visible",s="click",P="show",C=[["mouseOverEvent","mouseover"],["mouseOutEvent","mouseout"],["mouseDownEvent","mousedown"],["mouseUpEvent","mouseup"],["clickEvent",s],["keyPressEvent","keypress"],["keyDownEvent","keydown"],["keyUpEvent","keyup"],["focusEvent","focus"],["blurEvent","blur"],["destroyEvent","destroy"]],t={key:p,value:"",validator:g.isString,suppressEvent:!0},r={key:u,supercedes:[p],suppressEvent:!0},V=f,K="#",X=!0,W=v,j=!0,n={key:c,value:!1,validator:g.isBoolean,suppressEvent:!0,supercedes:[p]},O={key:m,value:!1,validator:g.isBoolean,suppressEvent:!0,supercedes:[p]},I={key:a,value:!1,validator:g.isBoolean,suppressEvent:!0,supercedes:[y,_]},w={key:b,suppressEvent:!0,supercedes:[y,_]},M={key:y,value:!1,validator:g.isBoolean,suppressEvent:!0,supercedes:[p,_]},H={key:_,value:!1,validator:g.isBoolean,suppressEvent:!0},q=z,Q=!0,A={key:"classname",value:null,validator:g.isString,suppressEvent:!0},J="keylistener",Z=null,$=!0,T=null,k={},N=function(e,t){var s=k[e],i=(s||(k[e]={},s=k[e]),s[t]);return i||(s[t]=i=e+F+t),i},L=function(e){h.addClass(this.element,N(this.CSS_CLASS_NAME,e)),h.addClass(this._oAnchor,N(this.CSS_LABEL_CLASS_NAME,e))},D=function(e){h.removeClass(this.element,N(this.CSS_CLASS_NAME,e)),h.removeClass(this._oAnchor,N(this.CSS_LABEL_CLASS_NAME,e))};e.prototype={CSS_CLASS_NAME:"yuimenuitem",CSS_LABEL_CLASS_NAME:"yuimenuitemlabel",SUBMENU_TYPE:null,_oAnchor:null,_oHelpTextEM:null,_oSubmenu:null,_oOnclickAttributeValue:null,_sClassName:null,constructor:e,index:null,groupIndex:null,parent:null,element:null,srcElement:null,value:null,browser:Y.prototype.browser,id:null,init:function(e,t){this.SUBMENU_TYPE||(this.SUBMENU_TYPE=d),this.cfg=new YAHOO.util.Config(this),this.initDefaultConfig();var s,i,r,n,o,a,l,u=this.cfg,c="#";if(g.isString(e))this._createRootNodeStructure(),u.queueProperty(p,e);else if(e&&e.tagName)switch(e.tagName.toUpperCase()){case"OPTION":this._createRootNodeStructure(),u.queueProperty(p,e.text),u.queueProperty(y,e.disabled),this.value=e.value,this.srcElement=e;break;case"OPTGROUP":this._createRootNodeStructure(),u.queueProperty(p,e.label),u.queueProperty(y,e.disabled),this.srcElement=e,this._initSubTree();break;case"LI":(r=h.getFirstChild(e))&&(c=r.getAttribute(S,2),n=r.getAttribute(v),o=r.innerHTML),this.srcElement=e,this.element=e,this._oAnchor=r,u.setProperty(p,o,!0),u.setProperty(f,c,!0),u.setProperty(v,n,!0),this._initSubTree()}if(this.element){for((a=(this.srcElement||this.element).id)||(a=this.id||h.generateId(),this.element.id=a),this.id=a,h.addClass(this.element,this.CSS_CLASS_NAME),h.addClass(this._oAnchor,this.CSS_LABEL_CLASS_NAME),l=C.length-1;(s=this.createEvent((i=C[l])[1])).signature=x.LIST,this[i[0]]=s,l--;);t&&u.applyConfig(t),u.fireQueue()}},_createRootNodeStructure:function(){var e,t;T||((T=document.createElement("li")).innerHTML='<a href="#"></a>'),(e=T.cloneNode(!0)).className=this.CSS_CLASS_NAME,(t=e.firstChild).className=this.CSS_LABEL_CLASS_NAME,this.element=e,this._oAnchor=t},_initSubTree:function(){var e,t,s,i,r,n=this.srcElement,o=this.cfg;if(0<n.childNodes.length)if(this.parent.lazyLoad&&this.parent.srcElement&&"SELECT"==this.parent.srcElement.tagName.toUpperCase())o.setProperty(b,{id:h.generateId(),itemdata:n.childNodes});else{e=n.firstChild,t=[];do{if(e&&e.tagName)switch(e.tagName.toUpperCase()){case"DIV":o.setProperty(b,e);break;case"OPTION":t[t.length]=e}}while(e=e.nextSibling);if(0<(s=t.length))for(i=new this.SUBMENU_TYPE(h.generateId()),o.setProperty(b,i),r=0;r<s;r++)i.addItem(new i.ITEM_TYPE(t[r]))}},configText:function(e,t,s){var t=t[0],i=this.cfg,r=this._oAnchor,n=i.getProperty(u),o="",a="",l="";t&&(n&&(o='<em class="helptext">'+n+"</em>"),i.getProperty(c)&&(a="<em>",l="</em>"),i.getProperty(m)&&(a="<strong>",l="</strong>"),r.innerHTML=a+t+l+o)},configHelpText:function(e,t,s){this.cfg.refireEvent(p)},configURL:function(e,t,s){var t=(t=t[0])||"#",i=this._oAnchor;l.opera&&i.removeAttribute(S),i.setAttribute(S,t)},configTarget:function(e,t,s){var t=t[0],i=this._oAnchor;t&&0<t.length?i.setAttribute(v,t):i.removeAttribute(v)},configEmphasis:function(e,t,s){var t=t[0],i=this.cfg;t&&i.getProperty(m)&&i.setProperty(m,!1),i.refireEvent(p)},configStrongEmphasis:function(e,t,s){var t=t[0],i=this.cfg;t&&i.getProperty(c)&&i.setProperty(c,!1),i.refireEvent(p)},configChecked:function(e,t,s){var t=t[0],i=this.cfg;(t?L:D).call(this,a),i.refireEvent(p),i.getProperty(y)&&i.refireEvent(y),i.getProperty(_)&&i.refireEvent(_)},configDisabled:function(e,t,s){var t=t[0],i=this.cfg,r=i.getProperty(b),n=i.getProperty(a);t?(i.getProperty(_)&&i.setProperty(_,!1),L.call(this,y),r&&L.call(this,G),n&&L.call(this,B)):(D.call(this,y),r&&D.call(this,G),n&&D.call(this,B))},configSelected:function(e,t,s){var i=this.cfg,r=this._oAnchor,t=t[0],n=i.getProperty(a),o=i.getProperty(b);l.opera&&r.blur(),t&&!i.getProperty(y)?(L.call(this,_),o&&L.call(this,U),n&&L.call(this,R)):(D.call(this,_),o&&D.call(this,U),n&&D.call(this,R)),this.hasFocus()&&l.opera&&r.focus()},_onSubmenuBeforeHide:function(e,t){var s,i=this.parent;i.hasFocus()&&(s=i.parent).beforeHideEvent.subscribe(function r(){i._oAnchor.blur(),s.beforeHideEvent.unsubscribe(r)})},configSubmenu:function(e,t,s){var i,r,n,t=t[0],o=this.cfg,a=this.parent&&this.parent.lazyLoad;t?(t instanceof d?((i=t).parent=this,i.lazyLoad=a):(i=g.isObject(t)&&t.id&&!t.nodeType?(r=t.id,(n=t).lazyload=a,new(n.parent=this).SUBMENU_TYPE(r,n)):new this.SUBMENU_TYPE(t,{lazyload:a,parent:this}),o.setProperty(b,i,!0)),i&&(i.cfg.setProperty("preventcontextoverlap",!0),L.call(this,E),"#"===o.getProperty(f)&&o.setProperty(f,"#"+i.id),this._oSubmenu=i,l.opera)&&i.beforeHideEvent.subscribe(this._onSubmenuBeforeHide)):(D.call(this,E),this._oSubmenu&&this._oSubmenu.destroy()),o.getProperty(y)&&o.refireEvent(y),o.getProperty(_)&&o.refireEvent(_)},configOnClick:function(e,t,s){t=t[0];this._oOnclickAttributeValue&&this._oOnclickAttributeValue!=t&&(this.clickEvent.unsubscribe(this._oOnclickAttributeValue.fn,this._oOnclickAttributeValue.obj),this._oOnclickAttributeValue=null),!this._oOnclickAttributeValue&&g.isObject(t)&&g.isFunction(t.fn)&&(this.clickEvent.subscribe(t.fn,"obj"in t?t.obj:this,"scope"in t?t.scope:null),this._oOnclickAttributeValue=t)},configClassName:function(e,t,s){t=t[0];this._sClassName&&h.removeClass(this.element,this._sClassName),h.addClass(this.element,t),this._sClassName=t},_dispatchClickEvent:function(){var e;this.cfg.getProperty(y)||(e=h.getFirstChild(this.element),this._dispatchDOMClick(e))},_dispatchDOMClick:function(e){var t;l.ie&&l.ie<9?e.fireEvent(z):(l.gecko&&1.9<=l.gecko||l.opera||l.webkit?(t=document.createEvent("HTMLEvents")).initEvent(s,!0,!0):(t=document.createEvent("MouseEvents")).initMouseEvent(s,!0,!0,window,0,0,0,0,0,!1,!1,!1,!1,0,null),e.dispatchEvent(t))},_createKeyListener:function(e,t,s){var i=this,r=i.parent,n=new YAHOO.util.KeyListener(r.element.ownerDocument,s,{fn:i._dispatchClickEvent,scope:i,correctScope:!0});r.cfg.getProperty(o)&&n.enable(),r.subscribe(P,n.enable,null,n),r.subscribe("hide",n.disable,null,n),i._keyListener=n,r.unsubscribe(P,i._createKeyListener,s)},configKeyListener:function(e,t){var t=t[0],s=this,i=s.parent;s._keyData&&(i.unsubscribe(P,s._createKeyListener,s._keyData),s._keyData=null),s._keyListener&&(i.unsubscribe(P,s._keyListener.enable),i.unsubscribe("hide",s._keyListener.disable),s._keyListener.disable(),s._keyListener=null),t&&(s._keyData=t,i.subscribe(P,s._createKeyListener,t,s))},initDefaultConfig:function(){var e=this.cfg;e.addProperty(t.key,{handler:this.configText,value:t.value,validator:t.validator,suppressEvent:t.suppressEvent}),e.addProperty(r.key,{handler:this.configHelpText,supercedes:r.supercedes,suppressEvent:r.suppressEvent}),e.addProperty(V,{handler:this.configURL,value:K,suppressEvent:X}),e.addProperty(W,{handler:this.configTarget,suppressEvent:j}),e.addProperty(n.key,{handler:this.configEmphasis,value:n.value,validator:n.validator,suppressEvent:n.suppressEvent,supercedes:n.supercedes}),e.addProperty(O.key,{handler:this.configStrongEmphasis,value:O.value,validator:O.validator,suppressEvent:O.suppressEvent,supercedes:O.supercedes}),e.addProperty(I.key,{handler:this.configChecked,value:I.value,validator:I.validator,suppressEvent:I.suppressEvent,supercedes:I.supercedes}),e.addProperty(M.key,{handler:this.configDisabled,value:M.value,validator:M.validator,suppressEvent:M.suppressEvent}),e.addProperty(H.key,{handler:this.configSelected,value:H.value,validator:H.validator,suppressEvent:H.suppressEvent}),e.addProperty(w.key,{handler:this.configSubmenu,supercedes:w.supercedes,suppressEvent:w.suppressEvent}),e.addProperty(q,{handler:this.configOnClick,suppressEvent:Q}),e.addProperty(A.key,{handler:this.configClassName,value:A.value,validator:A.validator,suppressEvent:A.suppressEvent}),e.addProperty(J,{handler:this.configKeyListener,value:Z,suppressEvent:$})},getNextSibling:function(){var e=function(e){return"ul"===e.nodeName.toLowerCase()},t=this.element,s=h.getNextSibling(t);return s||(t=t.parentNode,t=h.getNextSiblingBy(t,e)||h.getFirstChildBy(t.parentNode,e),s=h.getFirstChild(t)),YAHOO.widget.MenuManager.getMenuItem(s.id)},getNextEnabledSibling:function(){var e=this.getNextSibling();return e.cfg.getProperty(y)||e.element.style.display==i?e.getNextEnabledSibling():e},getPreviousSibling:function(){var e=function(e){return"ul"===e.nodeName.toLowerCase()},t=this.element,s=h.getPreviousSibling(t);return s||(t=t.parentNode,t=h.getPreviousSiblingBy(t,e)||h.getLastChildBy(t.parentNode,e),s=h.getLastChild(t)),YAHOO.widget.MenuManager.getMenuItem(s.id)},getPreviousEnabledSibling:function(){var e=this.getPreviousSibling();return e.cfg.getProperty(y)||e.element.style.display==i?e.getPreviousEnabledSibling():e},focus:function(){var e=this.parent,t=this._oAnchor,s=e.activeItem;!this.cfg.getProperty(y)&&e&&e.cfg.getProperty(o)&&this.element.style.display!=i&&g.later(0,this,function(){try{l.ie&&!document.hasFocus()||(s&&s.blurEvent.fire(),t.focus(),this.focusEvent.fire())}catch(e){}})},blur:function(){var e=this.parent;!this.cfg.getProperty(y)&&e&&e.cfg.getProperty(o)&&g.later(0,this,function(){try{this._oAnchor.blur(),this.blurEvent.fire()}catch(e){}},0)},hasFocus:function(){return YAHOO.widget.MenuManager.getFocusedMenuItem()==this},destroy:function(){var e,t,s=this.element;if(s){for((e=this.cfg.getProperty(b))&&e.destroy(),(e=s.parentNode)&&(e.removeChild(s),this.destroyEvent.fire()),t=C.length-1;this[C[t][0]].unsubscribeAll(),t--;);this.cfg.configChangedEvent.unsubscribeAll()}},toString:function(){var e="MenuItem",t=this.id;return t&&(e+=" "+t),e}},g.augmentProto(e,YAHOO.util.EventProvider)}(),function(){var s="mousedown",i=(YAHOO.widget.ContextMenu=function(e,t){YAHOO.widget.ContextMenu.superclass.constructor.call(this,e,t)},YAHOO.util.Event),r=YAHOO.env.ua,n=YAHOO.widget.ContextMenu,o={TRIGGER_CONTEXT_MENU:"triggerContextMenu",CONTEXT_MENU:r.opera?s:"contextmenu",CLICK:"click"},e="trigger",t=!0;function a(e,t,s){this.cfg.setProperty("xy",s),this.beforeShowEvent.unsubscribe(a,s)}YAHOO.lang.extend(n,YAHOO.widget.Menu,{_oTrigger:null,_bCancelled:!1,contextEventTarget:null,triggerContextMenuEvent:null,init:function(e,t){n.superclass.init.call(this,e),this.beforeInitEvent.fire(n),t&&this.cfg.applyConfig(t,!0),this.initEvent.fire(n)},initEvents:function(){n.superclass.initEvents.call(this),this.triggerContextMenuEvent=this.createEvent(o.TRIGGER_CONTEXT_MENU),this.triggerContextMenuEvent.signature=YAHOO.util.CustomEvent.LIST},cancel:function(){this._bCancelled=!0},_removeEventHandlers:function(){var e=this._oTrigger;e&&(i.removeListener(e,o.CONTEXT_MENU,this._onTriggerContextMenu),r.opera)&&i.removeListener(e,o.CLICK,this._onTriggerClick)},_onTriggerClick:function(e,t){e.ctrlKey&&i.stopEvent(e)},_onTriggerContextMenu:function(e,t){e.type==s&&!e.ctrlKey||(this.contextEventTarget=i.getTarget(e),this.triggerContextMenuEvent.fire(e),this._bCancelled||(i.stopEvent(e),YAHOO.widget.MenuManager.hideVisible(),e=i.getXY(e),YAHOO.util.Dom.inDocument(this.element)?this.cfg.setProperty("xy",e):this.beforeShowEvent.subscribe(a,e),this.show()),this._bCancelled=!1)},toString:function(){var e="ContextMenu",t=this.id;return t&&(e+=" "+t),e},initDefaultConfig:function(){n.superclass.initDefaultConfig.call(this),this.cfg.addProperty(e,{handler:this.configTrigger,suppressEvent:t})},destroy:function(e){this._removeEventHandlers(),n.superclass.destroy.call(this,e)},configTrigger:function(e,t,s){t=t[0];t?(this._oTrigger&&this._removeEventHandlers(),this._oTrigger=t,i.on(t,o.CONTEXT_MENU,this._onTriggerContextMenu,this,!0),r.opera&&i.on(t,o.CLICK,this._onTriggerClick,this,!0)):this._removeEventHandlers()}})}(),YAHOO.widget.ContextMenuItem=YAHOO.widget.MenuItem,function(){var s=YAHOO.lang,l="disabled",u="selected",i="autosubmenudisplay",c="submenu",h="visible",a="submenutoggleregion";YAHOO.widget.MenuBar=function(e,t){YAHOO.widget.MenuBar.superclass.constructor.call(this,e,t)};var d=YAHOO.util.Event,g=YAHOO.widget.MenuBar,t={key:"position",value:"static",validator:function(e){var t=!1;return t=s.isString(e)?-1!="dynamic,static".indexOf(e.toLowerCase()):t},supercedes:[h]},r={key:"submenualignment",value:["tl","bl"]},n={key:i,value:!1,validator:s.isBoolean,suppressEvent:!0},o={key:a,value:!1,validator:s.isBoolean};s.extend(g,YAHOO.widget.Menu,{init:function(e,t){this.ITEM_TYPE||(this.ITEM_TYPE=YAHOO.widget.MenuBarItem),g.superclass.init.call(this,e),this.beforeInitEvent.fire(g),t&&this.cfg.applyConfig(t,!0),this.initEvent.fire(g)},CSS_CLASS_NAME:"yuimenubar",SUBMENU_TOGGLE_REGION_WIDTH:20,_onKeyDown:function(e,t,s){var i,r,n,o=t[0],a=t[1];if(a&&!a.cfg.getProperty(l))switch(r=a.cfg,o.keyCode){case 37:case 39:a!=this.activeItem||r.getProperty(u)?(n=37==o.keyCode?a.getPreviousEnabledSibling():a.getNextEnabledSibling())&&(this.clearActiveItem(),n.cfg.setProperty(u,!0),(i=n.cfg.getProperty(c))?(i.show(),i.setInitialFocus()):n.focus()):r.setProperty(u,!0),d.preventDefault(o);break;case 40:this.activeItem!=a&&(this.clearActiveItem(),r.setProperty(u,!0),a.focus()),(i=r.getProperty(c))&&(i.cfg.getProperty(h)?i.setInitialSelection():i.show(),i.setInitialFocus()),d.preventDefault(o)}27==o.keyCode&&this.activeItem&&((i=this.activeItem.cfg.getProperty(c))&&i.cfg.getProperty(h)?(i.hide(),this.activeItem.focus()):(this.activeItem.cfg.setProperty(u,!1),this.activeItem.blur()),d.preventDefault(o))},_onClick:function(e,t,s){g.superclass._onClick.call(this,e,t,s);var i,r,n,e=t[1],s=!0,o=function(){n.cfg.getProperty(h)?n.hide():n.show()};return e&&!e.cfg.getProperty(l)&&(t=t[0],d.getTarget(t),i=this.activeItem,r=this.cfg,i&&i!=e&&this.clearActiveItem(),e.cfg.setProperty(u,!0),n=e.cfg.getProperty(c))&&(i=e.element,e=YAHOO.util.Dom.getX(i)+(i.offsetWidth-this.SUBMENU_TOGGLE_REGION_WIDTH),r.getProperty(a)?d.getPageX(t)>e&&(o(),d.preventDefault(t),s=!1):o()),s},configSubmenuToggle:function(e,t){t[0]&&this.cfg.setProperty(i,!1)},toString:function(){var e="MenuBar",t=this.id;return t&&(e+=" "+t),e},initDefaultConfig:function(){g.superclass.initDefaultConfig.call(this);var e=this.cfg;e.addProperty(t.key,{handler:this.configPosition,value:t.value,validator:t.validator,supercedes:t.supercedes}),e.addProperty(r.key,{value:r.value,suppressEvent:r.suppressEvent}),e.addProperty(n.key,{value:n.value,validator:n.validator,suppressEvent:n.suppressEvent}),e.addProperty(o.key,{value:o.value,validator:o.validator,handler:this.configSubmenuToggle})}})}(),YAHOO.widget.MenuBarItem=function(e,t){YAHOO.widget.MenuBarItem.superclass.constructor.call(this,e,t)},YAHOO.lang.extend(YAHOO.widget.MenuBarItem,YAHOO.widget.MenuItem,{init:function(e,t){this.SUBMENU_TYPE||(this.SUBMENU_TYPE=YAHOO.widget.Menu),YAHOO.widget.MenuBarItem.superclass.init.call(this,e);e=this.cfg;t&&e.applyConfig(t,!0),e.fireQueue()},CSS_CLASS_NAME:"yuimenubaritem",CSS_LABEL_CLASS_NAME:"yuimenubaritemlabel",toString:function(){var e="MenuBarItem";return this.cfg&&this.cfg.getProperty("text")&&(e+=": "+this.cfg.getProperty("text")),e}}),YAHOO.register("menu",YAHOO.widget.Menu,{version:"2.9.0",build:"2800"});
//# sourceMappingURL=menu.js.map;
!function(){var o=YAHOO.util.Dom,h=YAHOO.util.Event,d=YAHOO.lang,c=YAHOO.widget,i=(YAHOO.widget.TreeView=function(e,t){e&&this.init(e),t?this.buildTreeFromObject(t):d.trim(this._el.innerHTML)&&this.buildTreeFromMarkup(e)},c.TreeView),e=(i.prototype={id:null,_el:null,_nodes:null,locked:!1,_expandAnim:null,_collapseAnim:null,_animCount:0,maxAnim:2,_hasDblClickSubscriber:!1,_dblClickTimer:null,currentFocus:null,singleNodeHighlight:!1,_currentlyHighlighted:null,setExpandAnim:function(e){this._expandAnim=c.TVAnim.isValid(e)?e:null},setCollapseAnim:function(e){this._collapseAnim=c.TVAnim.isValid(e)?e:null},animateExpand:function(e,t){var i;return!!(this._expandAnim&&this._animCount<this.maxAnim)&&((e=c.TVAnim.getAnim((i=this)._expandAnim,e,function(){i.expandComplete(t)}))&&(++this._animCount,this.fireEvent("animStart",{node:t,type:"expand"}),e.animate()),!0)},animateCollapse:function(e,t){var i;return!!(this._collapseAnim&&this._animCount<this.maxAnim)&&((e=c.TVAnim.getAnim((i=this)._collapseAnim,e,function(){i.collapseComplete(t)}))&&(++this._animCount,this.fireEvent("animStart",{node:t,type:"collapse"}),e.animate()),!0)},expandComplete:function(e){--this._animCount,this.fireEvent("animComplete",{node:e,type:"expand"})},collapseComplete:function(e){--this._animCount,this.fireEvent("animComplete",{node:e,type:"collapse"})},init:function(e){this._el=o.get(e),this.id=o.generateId(this._el,"yui-tv-auto-id-"),this.createEvent("animStart",this),this.createEvent("animComplete",this),this.createEvent("collapse",this),this.createEvent("collapseComplete",this),this.createEvent("expand",this),this.createEvent("expandComplete",this),this.createEvent("enterKeyPressed",this),this.createEvent("clickEvent",this),this.createEvent("focusChanged",this);var t=this;this.createEvent("dblClickEvent",{scope:this,onSubscribeCallback:function(){t._hasDblClickSubscriber=!0}}),this.createEvent("labelClick",this),this.createEvent("highlightEvent",this),this._nodes=[],(i.trees[this.id]=this).root=new c.RootNode(this),c.LogWriter;this._initEditor&&this._initEditor()},buildTreeFromObject:function(e){var a=function(e,t){for(var i,n,l,s,r,o,h=0;h<t.length;h++)if(i=t[h],d.isString(i))n=new c.TextNode(i,e);else if(d.isObject(i)){switch(l=i.children,delete i.children,s=i.type||"text",delete i.type,d.isString(s)&&s.toLowerCase()){case"text":n=new c.TextNode(i,e);break;case"menu":n=new c.MenuNode(i,e);break;case"html":n=new c.HTMLNode(i,e);break;default:if(r=d.isString(s)?c[s]:s,d.isObject(r)){for(o=r;o&&o!==c.Node;o=o.superclass.constructor);o&&(n=new r(i,e))}}l&&a(n,l)}};d.isArray(e)||(e=[e]),a(this.root,e)},buildTreeFromMarkup:function(e){var r=function(e){for(var t=[],i={},n=o.getFirstChild(e);n;n=o.getNextSibling(n))switch(n.tagName.toUpperCase()){case"LI":var l,s="",i={expanded:o.hasClass(n,"expanded"),title:n.title||n.alt||null,className:d.trim(n.className.replace(/\bexpanded\b/,""))||null};switch(3==(l=n.firstChild).nodeType&&((s=d.trim(l.nodeValue.replace(/[\n\t\r]*/g,"")))?(i.type="text",i.label=s):l=o.getNextSibling(l)),s||("A"==l.tagName.toUpperCase()?(i.type="text",i.label=l.innerHTML,i.href=l.href,i.target=l.target,i.title=l.title||l.alt||i.title):(i.type="html",(s=document.createElement("div")).appendChild(l.cloneNode(!0)),i.html=s.innerHTML,i.hasIcon=!0)),(l=o.getNextSibling(l))&&l.tagName.toUpperCase()){case"UL":case"OL":i.children=r(l)}YAHOO.lang.JSON&&(s=n.getAttribute("yuiConfig"))&&(s=YAHOO.lang.JSON.parse(s),i=YAHOO.lang.merge(i,s)),t.push(i);break;case"UL":case"OL":i={type:"text",label:"",children:r(l)},t.push(i)}return t},e=o.getChildrenBy(o.get(e),function(e){e=e.tagName.toUpperCase();return"UL"==e||"OL"==e});e.length&&this.buildTreeFromObject(r(e[0]))},_getEventTargetTdEl:function(e){for(var t=h.getTarget(e);t&&("TD"!=t.tagName.toUpperCase()||!o.hasClass(t.parentNode,"ygtvrow"));)t=o.getAncestorByTagName(t,"td");if(!d.isNull(t)&&!/\bygtv(blank)?depthcell/.test(t.className)&&t.id){e=t.id.match(/\bygtv([^\d]*)(.*)/);if(e&&e[2]&&this._nodes[e[2]])return t}return null},_onClickEvent:function(i){var n,e,t=this,l=this._getEventTargetTdEl(i),s=function(e){if(n.focus(),e||!n.href){n.toggle();try{h.preventDefault(i)}catch(t){}}};l&&(n=this.getNodeByElement(l))&&(e=h.getTarget(i),(o.hasClass(e,n.labelStyle)||o.getAncestorByClassName(e,n.labelStyle))&&this.fireEvent("labelClick",n),this._closeEditor&&this._closeEditor(!1),/\bygtv[tl][mp]h?h?/.test(l.className)?s(!0):this._dblClickTimer?(window.clearTimeout(this._dblClickTimer),this._dblClickTimer=null):this._hasDblClickSubscriber?this._dblClickTimer=window.setTimeout(function(){t._dblClickTimer=null,!1!==t.fireEvent("clickEvent",{event:i,node:n})&&s()},200):!1!==t.fireEvent("clickEvent",{event:i,node:n})&&s())},_onDblClickEvent:function(e){var t;this._hasDblClickSubscriber&&(t=this._getEventTargetTdEl(e))&&!/\bygtv[tl][mp]h?h?/.test(t.className)&&(this.fireEvent("dblClickEvent",{event:e,node:this.getNodeByElement(t)}),this._dblClickTimer)&&(window.clearTimeout(this._dblClickTimer),this._dblClickTimer=null)},_onMouseOverEvent:function(e){(e=(e=(e=this._getEventTargetTdEl(e))&&this.getNodeByElement(e))&&e.getToggleEl())&&(e.className=e.className.replace(/\bygtv([lt])([mp])\b/gi,"ygtv$1$2h"))},_onMouseOutEvent:function(e){(e=(e=(e=this._getEventTargetTdEl(e))&&this.getNodeByElement(e))&&e.getToggleEl())&&(e.className=e.className.replace(/\bygtv([lt])([mp])h\b/gi,"ygtv$1$2"))},_onKeyDownEvent:function(e){var t=h.getTarget(e),i=this.getNodeByElement(t),n=i,t=YAHOO.util.KeyListener.KEY;switch(e.keyCode){case t.UP:for(;(n=n.previousSibling||n.parent)&&!n._canHaveFocus(););n&&n.focus(),h.preventDefault(e);break;case t.DOWN:for(;(n=n.nextSibling||(n.expand(),n.children.length?n.children[0]:null))&&!n._canHaveFocus;);n&&n.focus(),h.preventDefault(e);break;case t.LEFT:for(;(n=n.parent||n.previousSibling)&&!n._canHaveFocus(););n&&n.focus(),h.preventDefault(e);break;case t.RIGHT:var l=this,s=function(e){l.unsubscribe("expandComplete",s),r(e)},r=function(e){do{if(e.isDynamic()&&!e.childrenRendered){l.subscribe("expandComplete",s),e.expand(),e=null;break}}while(e.expand(),(e=e.children.length?e.children[0]:e.nextSibling)&&!e._canHaveFocus());e&&e.focus()};r(n),h.preventDefault(e);break;case t.ENTER:i.href?i.target?window.open(i.href,i.target):window.location(i.href):i.toggle(),this.fireEvent("enterKeyPressed",i),h.preventDefault(e);break;case t.HOME:(n=(n=this.getRoot()).children.length?n.children[0]:n)._canHaveFocus()&&n.focus(),h.preventDefault(e);break;case t.END:(n=(n=n.parent.children)[n.length-1])._canHaveFocus()&&n.focus(),h.preventDefault(e);break;case 107:case 187:e.shiftKey?i.parent.expandAll():i.expand();break;case 109:case 189:e.shiftKey?i.parent.collapseAll():i.collapse()}},render:function(){var e=this.root.getHtml(),t=this.getEl();t.innerHTML=e,this._hasEvents||(h.on(t,"click",this._onClickEvent,this,!0),h.on(t,"dblclick",this._onDblClickEvent,this,!0),h.on(t,"mouseover",this._onMouseOverEvent,this,!0),h.on(t,"mouseout",this._onMouseOutEvent,this,!0),h.on(t,"keydown",this._onKeyDownEvent,this,!0)),this._hasEvents=!0},getEl:function(){return this._el||(this._el=o.get(this.id)),this._el},regNode:function(e){this._nodes[e.index]=e},getRoot:function(){return this.root},setDynamicLoad:function(e,t){this.root.setDynamicLoad(e,t)},expandAll:function(){this.locked||this.root.expandAll()},collapseAll:function(){this.locked||this.root.collapseAll()},getNodeByIndex:function(e){e=this._nodes[e];return e||null},getNodeByProperty:function(e,t){for(var i in this._nodes)if(this._nodes.hasOwnProperty(i)){i=this._nodes[i];if(e in i&&i[e]==t||i.data&&t==i.data[e])return i}return null},getNodesByProperty:function(e,t){var i,n,l=[];for(i in this._nodes)this._nodes.hasOwnProperty(i)&&(e in(n=this._nodes[i])&&n[e]==t||n.data&&t==n.data[e])&&l.push(n);return l.length?l:null},getNodesBy:function(e){var t,i,n=[];for(t in this._nodes)this._nodes.hasOwnProperty(t)&&e(i=this._nodes[t])&&n.push(i);return n.length?n:null},getNodeByElement:function(e){var t,i=e,n=/ygtv([^\d]*)(.*)/;do{if(i&&i.id&&(t=i.id.match(n))&&t[2])return this.getNodeByIndex(t[2])}while((i=i.parentNode)&&i.tagName&&(i.id!==this.id&&"body"!==i.tagName.toLowerCase()));return null},getHighlightedNode:function(){return this._currentlyHighlighted},removeNode:function(e,t){var i;return!e.isRoot()&&((i=e.parent).parent&&(i=i.parent),this._deleteNode(e),t&&i&&i.childrenRendered&&i.refresh(),!0)},_removeChildren_animComplete:function(e){this.unsubscribe(this._removeChildren_animComplete),this.removeChildren(e.node)},removeChildren:function(e){if(e.expanded){if(this._collapseAnim)return this.subscribe("animComplete",this._removeChildren_animComplete,this,!0),void c.Node.prototype.collapse.call(e);e.collapse()}for(;e.children.length;)this._deleteNode(e.children[0]);e.isRoot()&&c.Node.prototype.expand.call(e),e.childrenRendered=!1,e.dynamicLoadComplete=!1,e.updateIcon()},_deleteNode:function(e){this.removeChildren(e),this.popNode(e)},popNode:function(e){for(var t=e.parent,i=[],n=0,l=t.children.length;n<l;++n)t.children[n]!=e&&(i[i.length]=t.children[n]);t.children=i,t.childrenRendered=!1,e.previousSibling&&(e.previousSibling.nextSibling=e.nextSibling),e.nextSibling&&(e.nextSibling.previousSibling=e.previousSibling),this.currentFocus==e&&(this.currentFocus=null),this._currentlyHighlighted==e&&(this._currentlyHighlighted=null),e.parent=null,e.previousSibling=null,e.nextSibling=null,e.tree=null,delete this._nodes[e.index]},destroy:function(){this._destroyEditor&&this._destroyEditor();var e=this.getEl();h.removeListener(e,"click"),h.removeListener(e,"dblclick"),h.removeListener(e,"mouseover"),h.removeListener(e,"mouseout"),h.removeListener(e,"keydown");for(var t=0;t<this._nodes.length;t++){var i=this._nodes[t];i&&i.destroy&&i.destroy()}e.innerHTML="",this._hasEvents=!1},toString:function(){return"TreeView "+this.id},getNodeCount:function(){return this.getRoot().getNodeCount()},getTreeDefinition:function(){return this.getRoot().getNodeDefinition()},onExpand:function(e){},onCollapse:function(e){},setNodesProperty:function(e,t,i){this.root.setNodesProperty(e,t),i&&this.root.refresh()},onEventToggleHighlight:function(e){var t;if("node"in e&&e.node instanceof c.Node)t=e.node;else{if(!(e instanceof c.Node))return!1;t=e}return t.toggleHighlight(),!1}},i.prototype);e.draw=e.render,YAHOO.augment(i,YAHOO.util.EventProvider),i.nodeCount=0,i.trees=[],i.getTree=function(e){e=i.trees[e];return e||null},i.getNode=function(e,t){e=i.getTree(e);return e?e.getNodeByIndex(t):null},i.FOCUS_CLASS_NAME="ygtvfocus"}(),function(){var l=YAHOO.util.Dom,s=YAHOO.lang,r=YAHOO.util.Event;YAHOO.widget.Node=function(e,t,i){e&&this.init(e,t,i)},YAHOO.widget.Node.prototype={index:0,children:null,tree:null,data:null,parent:null,depth:-1,expanded:!1,multiExpand:!0,renderHidden:!1,childrenRendered:!1,dynamicLoadComplete:!1,previousSibling:null,nextSibling:null,_dynLoad:!1,dataLoader:null,isLoading:!1,hasIcon:!0,iconMode:0,nowrap:!1,isLeaf:!1,contentStyle:"",contentElId:null,enableHighlight:!0,highlightState:0,propagateHighlightUp:!1,propagateHighlightDown:!1,className:null,_type:"Node",init:function(e,t,i){if(this.data={},this.children=[],this.index=YAHOO.widget.TreeView.nodeCount,++YAHOO.widget.TreeView.nodeCount,this.contentElId="ygtvcontentel"+this.index,s.isObject(e))for(var n in e)e.hasOwnProperty(n)&&("_"==n.charAt(0)||s.isUndefined(this[n])||s.isFunction(this[n])?this.data[n]=e[n]:this[n]=e[n]);s.isUndefined(i)||(this.expanded=i),this.createEvent("parentChange",this),t&&t.appendChild(this)},applyParent:function(e){if(!e)return!1;this.tree=e.tree,this.parent=e,this.depth=e.depth+1,this.tree.regNode(this),e.childrenRendered=!1;for(var t=0,i=this.children.length;t<i;++t)this.children[t].applyParent(this);return this.fireEvent("parentChange"),!0},appendChild:function(e){var t;return this.hasChildren()&&(((t=this.children[this.children.length-1]).nextSibling=e).previousSibling=t),(this.children[this.children.length]=e).applyParent(this),this.childrenRendered&&this.expanded&&(this.getChildrenEl().style.display=""),e},appendTo:function(e){return e.appendChild(this)},insertBefore:function(e){var t,i=e.parent;return i&&(this.tree&&this.tree.popNode(this),t=e.isChildOf(i),i.children.splice(t,0,this),e.previousSibling&&(e.previousSibling.nextSibling=this),this.previousSibling=e.previousSibling,((this.nextSibling=e).previousSibling=this).applyParent(i)),this},insertAfter:function(e){var t=e.parent;if(t){this.tree&&this.tree.popNode(this);var i=e.isChildOf(t);if(!e.nextSibling)return this.nextSibling=null,this.appendTo(t);t.children.splice(i+1,0,this),(e.nextSibling.previousSibling=this).previousSibling=e,this.nextSibling=e.nextSibling,(e.nextSibling=this).applyParent(t)}return this},isChildOf:function(e){if(e&&e.children)for(var t=0,i=e.children.length;t<i;++t)if(e.children[t]===this)return t;return-1},getSiblings:function(){for(var e=this.parent.children.slice(0),t=0;t<e.length&&e[t]!=this;t++);return e.splice(t,1),e.length?e:null},showChildren:function(){this.tree.animateExpand(this.getChildrenEl(),this)||this.hasChildren()&&(this.getChildrenEl().style.display="")},hideChildren:function(){this.tree.animateCollapse(this.getChildrenEl(),this)||(this.getChildrenEl().style.display="none")},getElId:function(){return"ygtv"+this.index},getChildrenElId:function(){return"ygtvc"+this.index},getToggleElId:function(){return"ygtvt"+this.index},getEl:function(){return l.get(this.getElId())},getChildrenEl:function(){return l.get(this.getChildrenElId())},getToggleEl:function(){return l.get(this.getToggleElId())},getContentEl:function(){return l.get(this.contentElId)},collapse:function(){this.expanded&&!1!==this.tree.onCollapse(this)&&!1!==this.tree.fireEvent("collapse",this)&&(this.getEl()?(this.hideChildren(),this.expanded=!1,this.updateIcon()):this.expanded=!1,this.tree.fireEvent("collapseComplete",this))},expand:function(e){if(!(this.isLoading||this.expanded&&!e)){var t=!0;if(!e){if(!1===(t=this.tree.onExpand(this)))return;t=this.tree.fireEvent("expand",this)}if(!1!==t)if(this.getEl())if(this.childrenRendered||(this.getChildrenEl().innerHTML=this.renderChildren()),this.expanded=!0,this.updateIcon(),this.isLoading)this.expanded=!1;else{if(!this.multiExpand)for(var i=this.getSiblings(),n=0;i&&n<i.length;++n)i[n]!=this&&i[n].expanded&&i[n].collapse();this.showChildren(),this.tree.fireEvent("expandComplete",this)}else this.expanded=!0}},updateIcon:function(){var e;this.hasIcon&&(e=this.getToggleEl())&&(e.className=e.className.replace(/\bygtv(([tl][pmn]h?)|(loading))\b/gi,this.getStyle())),(e=l.get("ygtvtableel"+this.index))&&(this.expanded?l.replaceClass(e,"ygtv-collapsed","ygtv-expanded"):l.replaceClass(e,"ygtv-expanded","ygtv-collapsed"))},getStyle:function(){var e;return this.isLoading?"ygtvloading":(e="n","ygtv"+(this.nextSibling?"t":"l")+(e=this.hasChildren(!0)||this.isDynamic()&&!this.getIconMode()?this.expanded?"m":"p":e))},getHoverStyle:function(){var e=this.getStyle();return this.hasChildren(!0)&&!this.isLoading&&(e+="h"),e},expandAll:function(){for(var e=this.children.length,t=0;t<e;++t){var i=this.children[t];if(i.isDynamic())break;if(!i.multiExpand)break;i.expand(),i.expandAll()}},collapseAll:function(){for(var e=0;e<this.children.length;++e)this.children[e].collapse(),this.children[e].collapseAll()},setDynamicLoad:function(e,t){e?(this.dataLoader=e,this._dynLoad=!0):(this.dataLoader=null,this._dynLoad=!1),t&&(this.iconMode=t)},isRoot:function(){return this==this.tree.root},isDynamic:function(){return!this.isLeaf&&!this.isRoot()&&(this._dynLoad||this.tree.root._dynLoad)},getIconMode:function(){return this.iconMode||this.tree.root.iconMode},hasChildren:function(e){return!this.isLeaf&&(0<this.children.length||e&&this.isDynamic()&&!this.dynamicLoadComplete)},toggle:function(){this.tree.locked||!this.hasChildren(!0)&&!this.isDynamic()||(this.expanded?this.collapse():this.expand())},getHtml:function(){return this.childrenRendered=!1,['<div class="ygtvitem" id="',this.getElId(),'">',this.getNodeHtml(),this.getChildrenHtml(),"</div>"].join("")},getChildrenHtml:function(){var e=[];return e[e.length]='<div class="ygtvchildren" id="'+this.getChildrenElId()+'"',this.expanded&&this.hasChildren()||(e[e.length]=' style="display:none;"'),e[e.length]=">",(this.hasChildren(!0)&&this.expanded||this.renderHidden&&!this.isDynamic())&&(e[e.length]=this.renderChildren()),e[e.length]="</div>",e.join("")},renderChildren:function(){var e=this;if(!this.isDynamic()||this.dynamicLoadComplete)return this.completeRender();if(this.isLoading=!0,this.tree.locked=!0,this.dataLoader)setTimeout(function(){e.dataLoader(e,function(){e.loadComplete()})},10);else{if(!this.tree.root.dataLoader)return"Error: data loader not found or not specified.";setTimeout(function(){e.tree.root.dataLoader(e,function(){e.loadComplete()})},10)}return""},completeRender:function(){for(var e=[],t=0;t<this.children.length;++t)e[e.length]=this.children[t].getHtml();return this.childrenRendered=!0,e.join("")},loadComplete:function(){if(this.getChildrenEl().innerHTML=this.completeRender(),this.propagateHighlightDown)if(1!==this.highlightState||this.tree.singleNodeHighlight){if(0===this.highlightState||this.tree.singleNodeHighlight)for(e=0;e<this.children.length;e++)this.children[e].unhighlight(!0)}else for(var e=0;e<this.children.length;e++)this.children[e].highlight(!0);this.dynamicLoadComplete=!0,this.isLoading=!1,this.expand(!0),this.tree.locked=!1},getAncestor:function(e){if(e>=this.depth||e<0)return null;for(var t=this.parent;t.depth>e;)t=t.parent;return t},getDepthStyle:function(e){return this.getAncestor(e).nextSibling?"ygtvdepthcell":"ygtvblankdepthcell"},getNodeHtml:function(){var e=[];e[e.length]='<table id="ygtvtableel'+this.index+'" border="0" cellpadding="0" cellspacing="0" class="ygtvtable ygtvdepth'+this.depth,e[e.length]=" ygtv-"+(this.expanded?"expanded":"collapsed"),this.enableHighlight&&(e[e.length]=" ygtv-highlight"+this.highlightState),this.className&&(e[e.length]=" "+this.className),e[e.length]='"><tr class="ygtvrow">';for(var t=0;t<this.depth;++t)e[e.length]='<td class="ygtvcell '+this.getDepthStyle(t)+'"><div class="ygtvspacer"></div></td>';return this.hasIcon&&(e[e.length]='<td id="'+this.getToggleElId(),e[e.length]='" class="ygtvcell ',e[e.length]=this.getStyle(),e[e.length]='"><a href="#" class="ygtvspacer">&#160;</a></td>'),e[e.length]='<td id="'+this.contentElId,e[e.length]='" class="ygtvcell ',e[e.length]=this.contentStyle+' ygtvcontent" ',e[e.length]=this.nowrap?' nowrap="nowrap" ':"",e[e.length]=" >",e[e.length]=this.getContentHtml(),e[e.length]="</td></tr></table>",e.join("")},getContentHtml:function(){return""},refresh:function(){var e;this.getChildrenEl().innerHTML=this.completeRender(),this.hasIcon&&(e=this.getToggleEl())&&(e.className=e.className.replace(/\bygtv[lt][nmp]h*\b/gi,this.getStyle()))},toString:function(){return this._type+" ("+this.index+")"},_focusHighlightedItems:[],_focusedItem:null,_canHaveFocus:function(){return 0<this.getEl().getElementsByTagName("a").length},_removeFocus:function(){var e;for(this._focusedItem&&(r.removeListener(this._focusedItem,"blur"),this._focusedItem=null);e=this._focusHighlightedItems.shift();)l.removeClass(e,YAHOO.widget.TreeView.FOCUS_CLASS_NAME)},focus:function(){var i=!1,n=this,t=(this.tree.currentFocus&&this.tree.currentFocus._removeFocus(),function(e){e.parent&&(t(e.parent),e.parent.expand())});return t(this),l.getElementsBy(function(e){return/ygtv(([tl][pmn]h?)|(content))/.test(e.className)},"td",n.getEl().firstChild,function(e){var t;l.addClass(e,YAHOO.widget.TreeView.FOCUS_CLASS_NAME),i||(t=e.getElementsByTagName("a")).length&&((t=t[0]).focus(),n._focusedItem=t,r.on(t,"blur",function(){n.tree.fireEvent("focusChanged",{oldNode:n.tree.currentFocus,newNode:null}),n.tree.currentFocus=null,n._removeFocus()}),i=!0),n._focusHighlightedItems.push(e)}),i?(this.tree.fireEvent("focusChanged",{oldNode:this.tree.currentFocus,newNode:this}),this.tree.currentFocus=this):(this.tree.fireEvent("focusChanged",{oldNode:n.tree.currentFocus,newNode:null}),this.tree.currentFocus=null,this._removeFocus()),i},getNodeCount:function(){for(var e=0,t=0;e<this.children.length;e++)t+=this.children[e].getNodeCount();return t+1},getNodeDefinition:function(){if(this.isDynamic())return!1;var e,t=s.merge(this.data),i=[];this.expanded&&(t.expanded=this.expanded),this.multiExpand||(t.multiExpand=this.multiExpand),this.renderHidden&&(t.renderHidden=this.renderHidden),this.hasIcon||(t.hasIcon=this.hasIcon),this.nowrap&&(t.nowrap=this.nowrap),this.className&&(t.className=this.className),this.editable&&(t.editable=this.editable),this.enableHighlight||(t.enableHighlight=this.enableHighlight),this.highlightState&&(t.highlightState=this.highlightState),this.propagateHighlightUp&&(t.propagateHighlightUp=this.propagateHighlightUp),this.propagateHighlightDown&&(t.propagateHighlightDown=this.propagateHighlightDown),t.type=this._type;for(var n=0;n<this.children.length;n++){if(!1===(e=this.children[n].getNodeDefinition()))return!1;i.push(e)}return i.length&&(t.children=i),t},getToggleLink:function(){return"return false;"},setNodesProperty:function(e,t,i){"_"==e.charAt(0)||s.isUndefined(this[e])||s.isFunction(this[e])?this.data[e]=t:this[e]=t;for(var n=0;n<this.children.length;n++)this.children[n].setNodesProperty(e,t);i&&this.refresh()},toggleHighlight:function(){this.enableHighlight&&(1==this.highlightState?this.unhighlight():this.highlight())},highlight:function(e){if(this.enableHighlight){if(this.tree.singleNodeHighlight&&(this.tree._currentlyHighlighted&&this.tree._currentlyHighlighted.unhighlight(e),this.tree._currentlyHighlighted=this),this.highlightState=1,this._setHighlightClassName(),!this.tree.singleNodeHighlight){if(this.propagateHighlightDown)for(var t=0;t<this.children.length;t++)this.children[t].highlight(!0);this.propagateHighlightUp&&this.parent&&this.parent._childrenHighlighted()}e||this.tree.fireEvent("highlightEvent",this)}},unhighlight:function(e){if(this.enableHighlight){if(this.tree._currentlyHighlighted=null,this.highlightState=0,this._setHighlightClassName(),!this.tree.singleNodeHighlight){if(this.propagateHighlightDown)for(var t=0;t<this.children.length;t++)this.children[t].unhighlight(!0);this.propagateHighlightUp&&this.parent&&this.parent._childrenHighlighted()}e||this.tree.fireEvent("highlightEvent",this)}},_childrenHighlighted:function(){var e=!1,t=!1;if(this.enableHighlight){for(var i=0;i<this.children.length;i++)switch(this.children[i].highlightState){case 0:t=!0;break;case 1:e=!0;break;case 2:e=t=!0}this.highlightState=e&&t?2:e?1:0,this._setHighlightClassName(),this.propagateHighlightUp&&this.parent&&this.parent._childrenHighlighted()}},_setHighlightClassName:function(){var e=l.get("ygtvtableel"+this.index);e&&(e.className=e.className.replace(/\bygtv-highlight\d\b/gi,"ygtv-highlight"+this.highlightState))}},YAHOO.augment(YAHOO.widget.Node,YAHOO.util.EventProvider)}(),YAHOO.widget.RootNode=function(e){this.init(null,null,!0),this.tree=e},YAHOO.extend(YAHOO.widget.RootNode,YAHOO.widget.Node,{_type:"RootNode",getNodeHtml:function(){return""},toString:function(){return this._type},loadComplete:function(){this.tree.draw()},getNodeCount:function(){for(var e=0,t=0;e<this.children.length;e++)t+=this.children[e].getNodeCount();return t},getNodeDefinition:function(){for(var e,t=[],i=0;i<this.children.length;i++){if(!1===(e=this.children[i].getNodeDefinition()))return!1;t.push(e)}return t},collapse:function(){},expand:function(){},getSiblings:function(){return null},focus:function(){}}),function(){var e=YAHOO.util.Dom,n=YAHOO.lang;YAHOO.util.Event;YAHOO.widget.TextNode=function(e,t,i){e&&(n.isString(e)&&(e={label:e}),this.init(e,t,i),this.setUpLabel(e))},YAHOO.extend(YAHOO.widget.TextNode,YAHOO.widget.Node,{labelStyle:"ygtvlabel",labelElId:null,label:null,title:null,href:null,target:"_self",_type:"TextNode",setUpLabel:function(e){n.isString(e)?e={label:e}:e.style&&(this.labelStyle=e.style),this.label=e.label,this.labelElId="ygtvlabelel"+this.index},getLabelEl:function(){return e.get(this.labelElId)},getContentHtml:function(){var e=[];return e[e.length]=this.href?"<a":"<span",e[e.length]=' id="'+n.escapeHTML(this.labelElId)+'"',e[e.length]=' class="'+n.escapeHTML(this.labelStyle)+'"',this.href&&(e[e.length]=' href="'+n.escapeHTML(this.href)+'"',e[e.length]=' target="'+n.escapeHTML(this.target)+'"'),this.title&&(e[e.length]=' title="'+n.escapeHTML(this.title)+'"'),e[e.length]=" >",e[e.length]=n.escapeHTML(this.label),e[e.length]=this.href?"</a>":"</span>",e.join("")},getNodeDefinition:function(){var e=YAHOO.widget.TextNode.superclass.getNodeDefinition.call(this);return!1!==e&&(e.label=this.label,"ygtvlabel"!=this.labelStyle&&(e.style=this.labelStyle),this.title&&(e.title=this.title),this.href&&(e.href=this.href),"_self"!=this.target&&(e.target=this.target),e)},toString:function(){return YAHOO.widget.TextNode.superclass.toString.call(this)+": "+this.label},onLabelClick:function(){return!1},refresh:function(){YAHOO.widget.TextNode.superclass.refresh.call(this);var e=this.getLabelEl();e.innerHTML=this.label,"A"==e.tagName.toUpperCase()&&(e.href=this.href,e.target=this.target)}})}(),YAHOO.widget.MenuNode=function(e,t,i){YAHOO.widget.MenuNode.superclass.constructor.call(this,e,t,i),this.multiExpand=!1},YAHOO.extend(YAHOO.widget.MenuNode,YAHOO.widget.TextNode,{_type:"MenuNode"}),function(){YAHOO.util.Dom;var i=YAHOO.lang,t=(YAHOO.util.Event,function(e,t,i,n){e&&(this.init(e,t,i),this.initContent(e,n))});YAHOO.widget.HTMLNode=t,YAHOO.extend(t,YAHOO.widget.Node,{contentStyle:"ygtvhtml",html:null,_type:"HTMLNode",initContent:function(e,t){this.setHtml(e),this.contentElId="ygtvcontentel"+this.index,i.isUndefined(t)||(this.hasIcon=t)},setHtml:function(e){this.html=i.isObject(e)&&"html"in e?e.html:e;var t=this.getContentEl();t&&(e.nodeType&&1==e.nodeType&&e.tagName?t.innerHTML="":t.innerHTML=this.html)},getContentHtml:function(){return"string"==typeof this.html?this.html:(t._deferredNodes.push(this),t._timer||(t._timer=window.setTimeout(function(){for(var e;e=t._deferredNodes.pop();)e.getContentEl().appendChild(e.html);t._timer=null},0)),"")},getNodeDefinition:function(){var e=t.superclass.getNodeDefinition.call(this);return!1!==e&&(e.html=this.html,e)}}),t._deferredNodes=[],t._timer=null}(),function(){var n=YAHOO.util.Dom,l=YAHOO.lang,s=(YAHOO.util.Event,YAHOO.widget.Calendar);YAHOO.widget.DateNode=function(e,t,i){YAHOO.widget.DateNode.superclass.constructor.call(this,e,t,i)},YAHOO.extend(YAHOO.widget.DateNode,YAHOO.widget.TextNode,{_type:"DateNode",calendarConfig:null,fillEditorContainer:function(e){var t,i=e.inputContainer;l.isUndefined(s)?(n.replaceClass(e.editorPanel,"ygtv-edit-DateNode","ygtv-edit-TextNode"),YAHOO.widget.DateNode.superclass.fillEditorContainer.call(this,e)):(e.nodeType!=this._type?(e.nodeType=this._type,e.saveOnEnter=!1,e.node.destroyEditorContents(e),e.inputObject=t=new s(i.appendChild(document.createElement("div"))),this.calendarConfig&&(t.cfg.applyConfig(this.calendarConfig,!0),t.cfg.fireQueue()),t.selectEvent.subscribe(function(){this.tree._closeEditor(!0)},this,!0)):t=e.inputObject,e.oldValue=this.label,t.cfg.setProperty("selected",this.label,!1),i=t.cfg.getProperty("DATE_FIELD_DELIMITER"),e=this.label.split(i),t.cfg.setProperty("pagedate",e[t.cfg.getProperty("MDY_MONTH_POSITION")-1]+i+e[t.cfg.getProperty("MDY_YEAR_POSITION")-1]),t.cfg.fireQueue(),t.render(),t.oDomContainer.focus())},getEditorValue:function(e){var t,i;return l.isUndefined(s)?e.inputElement.value:(t=(e=e.inputObject).getSelectedDates()[0],(i=[])[e.cfg.getProperty("MDY_DAY_POSITION")-1]=t.getDate(),i[e.cfg.getProperty("MDY_MONTH_POSITION")-1]=t.getMonth()+1,i[e.cfg.getProperty("MDY_YEAR_POSITION")-1]=t.getFullYear(),i.join(e.cfg.getProperty("DATE_FIELD_DELIMITER")))},displayEditedValue:function(e,t){t=t.node;t.label=e,t.getLabelEl().innerHTML=e},getNodeDefinition:function(){var e=YAHOO.widget.DateNode.superclass.getNodeDefinition.call(this);return!1!==e&&(this.calendarConfig&&(e.calendarConfig=this.calendarConfig),e)}})}(),function(){var s=YAHOO.util.Dom,l=YAHOO.lang,r=YAHOO.util.Event,o=YAHOO.widget.TreeView,e=o.prototype,e=(o.editorData={active:!1,whoHasIt:null,nodeType:null,editorPanel:null,inputContainer:null,buttonsContainer:null,node:null,saveOnEnter:!0,oldValue:undefined},e.validator=null,e._initEditor=function(){this.createEvent("editorSaveEvent",this),this.createEvent("editorCancelEvent",this)},e._nodeEditing=function(e){var t,i,n,l;if(e.fillEditorContainer&&e.editable)return(l=o.editorData).active=!0,l.whoHasIt=this,l.nodeType?t=l.editorPanel:(l.editorPanel=t=this.getEl().appendChild(document.createElement("div")),s.addClass(t,"ygtv-label-editor"),t.tabIndex=0,i=l.buttonsContainer=t.appendChild(document.createElement("div")),s.addClass(i,"ygtv-button-container"),n=i.appendChild(document.createElement("button")),s.addClass(n,"ygtvok"),n.innerHTML=" ",n=i.appendChild(document.createElement("button")),s.addClass(n,"ygtvcancel"),n.innerHTML=" ",r.on(i,"click",function(e){var t=r.getTarget(e),i=o.editorData,i=(i.node,i.whoHasIt);s.hasClass(t,"ygtvok")&&(r.stopEvent(e),i._closeEditor(!0)),s.hasClass(t,"ygtvcancel")&&(r.stopEvent(e),i._closeEditor(!1))}),l.inputContainer=t.appendChild(document.createElement("div")),s.addClass(l.inputContainer,"ygtv-input"),r.on(t,"keydown",function(e){var t=o.editorData,i=YAHOO.util.KeyListener.KEY,n=t.whoHasIt;switch(e.keyCode){case i.ENTER:r.stopEvent(e),t.saveOnEnter&&n._closeEditor(!0);break;case i.ESCAPE:r.stopEvent(e),n._closeEditor(!1)}})),l.node=e,l.nodeType&&s.removeClass(t,"ygtv-edit-"+l.nodeType),s.addClass(t," ygtv-edit-"+e._type),s.setStyle(t,"display","block"),s.setXY(t,s.getXY(e.getContentEl())),t.focus(),e.fillEditorContainer(l),!0},e.onEventEditNode=function(e){return e instanceof YAHOO.widget.Node?e.editNode():e.node instanceof YAHOO.widget.Node&&e.node.editNode(),!1},e._closeEditor=function(e){var t=o.editorData,i=t.node,n=!0;i&&t.active&&(e?n=!1!==t.node.saveEditorValue(t):this.fireEvent("editorCancelEvent",i),n)&&(s.setStyle(t.editorPanel,"display","none"),t.active=!1,i.focus())},e._destroyEditor=function(){var e=o.editorData;!e||!e.nodeType||e.active&&e.whoHasIt!==this||(r.removeListener(e.editorPanel,"keydown"),r.removeListener(e.buttonContainer,"click"),e.node.destroyEditorContents(e),document.body.removeChild(e.editorPanel),e.nodeType=e.editorPanel=e.inputContainer=e.buttonsContainer=e.whoHasIt=e.node=null,e.active=!1)},YAHOO.widget.Node.prototype),e=(e.editable=!1,e.editNode=function(){this.tree._nodeEditing(this)},e.fillEditorContainer=null,e.destroyEditorContents=function(e){r.purgeElement(e.inputContainer,!0),e.inputContainer.innerHTML=""},e.saveEditorValue=function(e){var t=e.node,i=t.tree.validator,n=this.getEditorValue(e);if(l.isFunction(i)&&(n=i(n,e.oldValue,t),l.isUndefined(n)))return!1;!1!==this.tree.fireEvent("editorSaveEvent",{newValue:n,oldValue:e.oldValue,node:t})&&this.displayEditedValue(n,e)},e.getEditorValue=function(e){},e.displayEditedValue=function(e,t){},YAHOO.widget.TextNode.prototype);e.fillEditorContainer=function(e){var t;e.nodeType!=this._type?(e.nodeType=this._type,e.saveOnEnter=!0,e.node.destroyEditorContents(e),e.inputElement=t=e.inputContainer.appendChild(document.createElement("input"))):t=e.inputElement,e.oldValue=this.label,t.value=this.label,t.focus(),t.select()},e.getEditorValue=function(e){return e.inputElement.value},e.displayEditedValue=function(e,t){t=t.node;t.label=e,t.getLabelEl().innerHTML=e},e.destroyEditorContents=function(e){e.inputContainer.innerHTML=""}}(),YAHOO.widget.TVAnim={FADE_IN:"TVFadeIn",FADE_OUT:"TVFadeOut",getAnim:function(e,t,i){return YAHOO.widget[e]?new YAHOO.widget[e](t,i):null},isValid:function(e){return YAHOO.widget[e]}},YAHOO.widget.TVFadeIn=function(e,t){this.el=e,this.callback=t},YAHOO.widget.TVFadeIn.prototype={animate:function(){var e=this,t=this.el.style,t=(t.opacity=.1,t.filter="alpha(opacity=10)",t.display="",new YAHOO.util.Anim(this.el,{opacity:{from:.1,to:1,unit:""}},.4));t.onComplete.subscribe(function(){e.onComplete()}),t.animate()},onComplete:function(){this.callback()},toString:function(){return"TVFadeIn"}},YAHOO.widget.TVFadeOut=function(e,t){this.el=e,this.callback=t},YAHOO.widget.TVFadeOut.prototype={animate:function(){var e=this,t=new YAHOO.util.Anim(this.el,{opacity:{from:1,to:.1,unit:""}},.4);t.onComplete.subscribe(function(){e.onComplete()}),t.animate()},onComplete:function(){var e=this.el.style;e.display="none",e.opacity=1,e.filter="alpha(opacity=100)",this.callback()},toString:function(){return"TVFadeOut"}},YAHOO.register("treeview",YAHOO.widget.TreeView,{version:"2.9.0",build:"2800"});
//# sourceMappingURL=treeview.js.map;
!function(){YAHOO.util.Config=function(e){e&&this.init(e)};var g=YAHOO.lang,n=YAHOO.util.CustomEvent,r=YAHOO.util.Config;r.CONFIG_CHANGED_EVENT="configChanged",r.BOOLEAN_TYPE="boolean",r.prototype={owner:null,queueInProgress:!1,config:null,initialConfig:null,eventQueue:null,configChangedEvent:null,init:function(e){this.owner=e,this.configChangedEvent=this.createEvent(r.CONFIG_CHANGED_EVENT),this.configChangedEvent.signature=n.LIST,this.queueInProgress=!1,this.config={},this.initialConfig={},this.eventQueue=[]},checkBoolean:function(e){return typeof e==r.BOOLEAN_TYPE},checkNumber:function(e){return!isNaN(e)},fireEvent:function(e,t){e=this.config[e];e&&e.event&&e.event.fire(t)},addProperty:function(e,t){e=e.toLowerCase(),(this.config[e]=t).event=this.createEvent(e,{scope:this.owner}),t.event.signature=n.LIST,t.key=e,t.handler&&t.event.subscribe(t.handler,this.owner),this.setProperty(e,t.value,!0),t.suppressEvent||this.queueProperty(e,t.value)},getConfig:function(){var e,t,n={},i=this.config;for(e in i)g.hasOwnProperty(i,e)&&(t=i[e])&&t.event&&(n[e]=t.value);return n},getProperty:function(e){e=this.config[e.toLowerCase()];return e&&e.event?e.value:undefined},resetProperty:function(e){e=e.toLowerCase();var t=this.config[e];return!(!t||!t.event)&&(e in this.initialConfig?(this.setProperty(e,this.initialConfig[e]),!0):void 0)},setProperty:function(e,t,n){var i;return e=e.toLowerCase(),this.queueInProgress&&!n?(this.queueProperty(e,t),!0):!(!(i=this.config[e])||!i.event||i.validator&&!i.validator(t)||(i.value=t,n||(this.fireEvent(e,t),this.configChangedEvent.fire([e,t])),0))},queueProperty:function(e,t){e=e.toLowerCase();var n,i,r,a,s,l,o,h,E,d,c,u=this.config[e],_=!1;if(u&&u.event){if(!g.isUndefined(t)&&u.validator&&!u.validator(t))return!1;for(g.isUndefined(t)?t=u.value:u.value=t,_=!1,n=this.eventQueue.length,E=0;E<n;E++)if((r=this.eventQueue[E])&&(i=r[0],r=r[1],i==e)){this.eventQueue[E]=null,this.eventQueue.push([e,g.isUndefined(t)?r:t]),_=!0;break}if(_||g.isUndefined(t)||this.eventQueue.push([e,t]),u.supercedes)for(a=u.supercedes.length,d=0;d<a;d++)for(s=u.supercedes[d],l=this.eventQueue.length,c=0;c<l;c++)if((h=this.eventQueue[c])&&(o=h[0],h=h[1],o==s.toLowerCase())){this.eventQueue.push([o,h]),this.eventQueue[c]=null;break}return!0}return!1},refireEvent:function(e){e=e.toLowerCase();var t=this.config[e];t&&t.event&&!g.isUndefined(t.value)&&(this.queueInProgress?this.queueProperty(e):this.fireEvent(e,t.value))},applyConfig:function(e,t){var n,i;if(t){for(n in i={},e)g.hasOwnProperty(e,n)&&(i[n.toLowerCase()]=e[n]);this.initialConfig=i}for(n in e)g.hasOwnProperty(e,n)&&this.queueProperty(n,e[n])},refresh:function(){for(var e in this.config)g.hasOwnProperty(this.config,e)&&this.refireEvent(e)},fireQueue:function(){var e,t,n;for(this.queueInProgress=!0,e=0;e<this.eventQueue.length;e++)(n=this.eventQueue[e])&&(t=n[0],n=n[1],this.config[t].value=n,this.eventQueue[e]=null,this.fireEvent(t,n));this.queueInProgress=!1,this.eventQueue=[]},subscribeToConfigEvent:function(e,t,n,i){e=this.config[e.toLowerCase()];return!(!e||!e.event||(r.alreadySubscribed(e.event,t,n)||e.event.subscribe(t,n,i),0))},unsubscribeFromConfigEvent:function(e,t,n){e=this.config[e.toLowerCase()];return!(!e||!e.event)&&e.event.unsubscribe(t,n)},toString:function(){var e="Config";return this.owner&&(e+=" ["+this.owner.toString()+"]"),e},outputEventQueue:function(){for(var e,t="",n=this.eventQueue.length,i=0;i<n;i++)(e=this.eventQueue[i])&&(t+=e[0]+"="+e[1]+", ");return t},destroy:function(){var e,t,n=this.config;for(e in n)g.hasOwnProperty(n,e)&&((t=n[e]).event.unsubscribeAll(),t.event=null);this.configChangedEvent.unsubscribeAll(),this.configChangedEvent=null,this.owner=null,this.config=null,this.initialConfig=null,this.eventQueue=null}},r.alreadySubscribed=function(e,t,n){var i,r,a=e.subscribers.length;if(0<a){r=a-1;do{if((i=e.subscribers[r])&&i.obj==n&&i.fn==t)return!0}while(r--)}return!1},YAHOO.lang.augmentProto(r,YAHOO.util.EventProvider)}(),YAHOO.widget.DateMath={DAY:"D",WEEK:"W",YEAR:"Y",MONTH:"M",ONE_DAY_MS:864e5,WEEK_ONE_JAN_DATE:1,add:function(e,t,n){var i=new Date(e.getTime());switch(t){case this.MONTH:var r=e.getMonth()+n,a=0;if(r<0)for(;r<0;)r+=12,--a;else if(11<r)for(;11<r;)r-=12,a+=1;i.setMonth(r),i.setFullYear(e.getFullYear()+a);break;case this.DAY:this._addDays(i,n);break;case this.YEAR:i.setFullYear(e.getFullYear()+n);break;case this.WEEK:this._addDays(i,7*n)}return i},_addDays:function(e,t){if(YAHOO.env.ua.webkit&&YAHOO.env.ua.webkit<420)if(t<0)for(;t<-128;t-=-128)e.setDate(e.getDate()+-128);else for(;96<t;t-=96)e.setDate(e.getDate()+96);e.setDate(e.getDate()+t)},subtract:function(e,t,n){return this.add(e,t,-1*n)},before:function(e,t){t=t.getTime();return e.getTime()<t},after:function(e,t){t=t.getTime();return e.getTime()>t},between:function(e,t,n){return!(!this.after(e,t)||!this.before(e,n))},getJan1:function(e){return this.getDate(e,0,1)},getDayOffset:function(e,t){t=this.getJan1(t);return Math.ceil((e.getTime()-t.getTime())/this.ONE_DAY_MS)},getWeekNumber:function(e,t,n){t=t||0,n=n||this.WEEK_ONE_JAN_DATE;var e=this.clearTime(e),i=e.getDay()===t?e:this.getFirstDayOfWeek(e,t),r=i.getFullYear(),i=new Date(i.getTime()+6*this.ONE_DAY_MS);return r!==i.getFullYear()&&i.getDate()>=n?1:(i=this.clearTime(this.getDate(r,0,n)),r=this.getFirstDayOfWeek(i,t),1+((n=Math.round((e.getTime()-r.getTime())/this.ONE_DAY_MS))-n%7)/7)},getFirstDayOfWeek:function(e,t){t=t||0;var n=e.getDay();return this.subtract(e,this.DAY,(n-t+7)%7)},isYearOverlapWeek:function(e){var t=!1;return t=this.add(e,this.DAY,6).getFullYear()!=e.getFullYear()?!0:t},isMonthOverlapWeek:function(e){var t=!1;return t=this.add(e,this.DAY,6).getMonth()!=e.getMonth()?!0:t},findMonthStart:function(e){return this.getDate(e.getFullYear(),e.getMonth(),1)},findMonthEnd:function(e){e=this.findMonthStart(e),e=this.add(e,this.MONTH,1);return this.subtract(e,this.DAY,1)},clearTime:function(e){return e.setHours(12,0,0,0),e},getDate:function(e,t,n){var i=null;return YAHOO.lang.isUndefined(n)&&(n=1),100<=e?i=new Date(e,t,n):((i=new Date).setFullYear(e),i.setMonth(t),i.setDate(n),i.setHours(0,0,0,0)),i}},function(){var K=YAHOO.util.Dom,E=YAHOO.util.Event,d=YAHOO.lang,U=YAHOO.widget.DateMath;function V(e,t,n){this.init.apply(this,arguments)}V.IMG_ROOT=null,V.DATE="D",V.MONTH_DAY="MD",V.WEEKDAY="WD",V.RANGE="R",V.MONTH="M",V.DISPLAY_DAYS=42,V.STOP_RENDER="S",V.SHORT="short",V.LONG="long",V.MEDIUM="medium",V.ONE_CHAR="1char",V.DEFAULT_CONFIG={YEAR_OFFSET:{key:"year_offset",value:0,supercedes:["pagedate","selected","mindate","maxdate"]},TODAY:{key:"today",value:new Date,supercedes:["pagedate"]},PAGEDATE:{key:"pagedate",value:null},SELECTED:{key:"selected",value:[]},TITLE:{key:"title",value:""},CLOSE:{key:"close",value:!1},IFRAME:{key:"iframe",value:!!(YAHOO.env.ua.ie&&YAHOO.env.ua.ie<=6)},MINDATE:{key:"mindate",value:null},MAXDATE:{key:"maxdate",value:null},MULTI_SELECT:{key:"multi_select",value:!1},OOM_SELECT:{key:"oom_select",value:!1},START_WEEKDAY:{key:"start_weekday",value:0},SHOW_WEEKDAYS:{key:"show_weekdays",value:!0},SHOW_WEEK_HEADER:{key:"show_week_header",value:!1},SHOW_WEEK_FOOTER:{key:"show_week_footer",value:!1},HIDE_BLANK_WEEKS:{key:"hide_blank_weeks",value:!1},NAV_ARROW_LEFT:{key:"nav_arrow_left",value:null},NAV_ARROW_RIGHT:{key:"nav_arrow_right",value:null},MONTHS_SHORT:{key:"months_short",value:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"]},MONTHS_LONG:{key:"months_long",value:["January","February","March","April","May","June","July","August","September","October","November","December"]},WEEKDAYS_1CHAR:{key:"weekdays_1char",value:["S","M","T","W","T","F","S"]},WEEKDAYS_SHORT:{key:"weekdays_short",value:["Su","Mo","Tu","We","Th","Fr","Sa"]},WEEKDAYS_MEDIUM:{key:"weekdays_medium",value:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"]},WEEKDAYS_LONG:{key:"weekdays_long",value:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},LOCALE_MONTHS:{key:"locale_months",value:"long"},LOCALE_WEEKDAYS:{key:"locale_weekdays",value:"short"},DATE_DELIMITER:{key:"date_delimiter",value:","},DATE_FIELD_DELIMITER:{key:"date_field_delimiter",value:"/"},DATE_RANGE_DELIMITER:{key:"date_range_delimiter",value:"-"},MY_MONTH_POSITION:{key:"my_month_position",value:1},MY_YEAR_POSITION:{key:"my_year_position",value:2},MD_MONTH_POSITION:{key:"md_month_position",value:1},MD_DAY_POSITION:{key:"md_day_position",value:2},MDY_MONTH_POSITION:{key:"mdy_month_position",value:1},MDY_DAY_POSITION:{key:"mdy_day_position",value:2},MDY_YEAR_POSITION:{key:"mdy_year_position",value:3},MY_LABEL_MONTH_POSITION:{key:"my_label_month_position",value:1},MY_LABEL_YEAR_POSITION:{key:"my_label_year_position",value:2},MY_LABEL_MONTH_SUFFIX:{key:"my_label_month_suffix",value:" "},MY_LABEL_YEAR_SUFFIX:{key:"my_label_year_suffix",value:""},NAV:{key:"navigator",value:null},STRINGS:{key:"strings",value:{previousMonth:"Previous Month",nextMonth:"Next Month",close:"Close"},supercedes:["close","title"]}},V._DEFAULT_CONFIG=V.DEFAULT_CONFIG;var e,x=V.DEFAULT_CONFIG;V._EVENT_TYPES={BEFORE_SELECT:"beforeSelect",SELECT:"select",BEFORE_DESELECT:"beforeDeselect",DESELECT:"deselect",CHANGE_PAGE:"changePage",BEFORE_RENDER:"beforeRender",RENDER:"render",BEFORE_DESTROY:"beforeDestroy",DESTROY:"destroy",RESET:"reset",CLEAR:"clear",BEFORE_HIDE:"beforeHide",HIDE:"hide",BEFORE_SHOW:"beforeShow",SHOW:"show",BEFORE_HIDE_NAV:"beforeHideNav",HIDE_NAV:"hideNav",BEFORE_SHOW_NAV:"beforeShowNav",SHOW_NAV:"showNav",BEFORE_RENDER_NAV:"beforeRenderNav",RENDER_NAV:"renderNav"},V._STYLES=V.STYLES={CSS_ROW_HEADER:"calrowhead",CSS_ROW_FOOTER:"calrowfoot",CSS_CELL:"calcell",CSS_CELL_SELECTOR:"selector",CSS_CELL_SELECTED:"selected",CSS_CELL_SELECTABLE:"selectable",CSS_CELL_RESTRICTED:"restricted",CSS_CELL_TODAY:"today",CSS_CELL_OOM:"oom",CSS_CELL_OOB:"previous",CSS_HEADER:"calheader",CSS_HEADER_TEXT:"calhead",CSS_BODY:"calbody",CSS_WEEKDAY_CELL:"calweekdaycell",CSS_WEEKDAY_ROW:"calweekdayrow",CSS_FOOTER:"calfoot",CSS_CALENDAR:"yui-calendar",CSS_SINGLE:"single",CSS_CONTAINER:"yui-calcontainer",CSS_NAV_LEFT:"calnavleft",CSS_NAV_RIGHT:"calnavright",CSS_NAV:"calnav",CSS_CLOSE:"calclose",CSS_CELL_TOP:"calcelltop",CSS_CELL_LEFT:"calcellleft",CSS_CELL_RIGHT:"calcellright",CSS_CELL_BOTTOM:"calcellbottom",CSS_CELL_HOVER:"calcellhover",CSS_CELL_HIGHLIGHT1:"highlight1",CSS_CELL_HIGHLIGHT2:"highlight2",CSS_CELL_HIGHLIGHT3:"highlight3",CSS_CELL_HIGHLIGHT4:"highlight4",CSS_WITH_TITLE:"withtitle",CSS_FIXED_SIZE:"fixedsize",CSS_LINK_CLOSE:"link-close"},V.prototype={Config:null,parent:null,index:-1,cells:null,cellDates:null,id:null,containerId:null,oDomContainer:null,today:null,renderStack:null,_renderStack:null,oNavigator:null,_selectedDates:null,domEventMap:null,_parseArgs:function(e){var t={id:null,container:null,config:null};if(e&&e.length&&0<e.length)switch(e.length){case 1:t.id=null,t.container=e[0],t.config=null;break;case 2:!d.isObject(e[1])||e[1].tagName||e[1]instanceof String?(t.id=e[0],t.container=e[1],t.config=null):(t.id=null,t.container=e[0],t.config=e[1]);break;default:t.id=e[0],t.container=e[1],t.config=e[2]}return t},init:function(e,t,n){var i=this._parseArgs(arguments);e=i.id,t=i.container,n=i.config,this.oDomContainer=K.get(t),this._oDoc=this.oDomContainer.ownerDocument,this.oDomContainer.id||(this.oDomContainer.id=K.generateId()),e=e||this.oDomContainer.id+"_t",this.id=e,this.containerId=this.oDomContainer.id,this.initEvents(),this.cfg=new YAHOO.util.Config(this),this.Options={},this.Locale={},this.initStyles(),K.addClass(this.oDomContainer,this.Style.CSS_CONTAINER),K.addClass(this.oDomContainer,this.Style.CSS_SINGLE),this.cellDates=[],this.cells=[],this.renderStack=[],this._renderStack=[],this.setupConfig(),n&&this.cfg.applyConfig(n,!0),this.cfg.fireQueue(),this.today=this.cfg.getProperty("today")},configIframe:function(e,t,n){var t=t[0];this.parent||K.inDocument(this.oDomContainer)&&(t?"absolute"!=(t=K.getStyle(this.oDomContainer,"position"))&&"relative"!=t||K.inDocument(this.iframe)||(this.iframe=document.createElement("iframe"),this.iframe.src="javascript:false;",K.setStyle(this.iframe,"opacity","0"),YAHOO.env.ua.ie&&YAHOO.env.ua.ie<=6&&K.addClass(this.iframe,this.Style.CSS_FIXED_SIZE),this.oDomContainer.insertBefore(this.iframe,this.oDomContainer.firstChild)):this.iframe&&(this.iframe.parentNode&&this.iframe.parentNode.removeChild(this.iframe),this.iframe=null))},configTitle:function(e,t,n){t=t[0];t?this.createTitleBar(t):this.cfg.getProperty(x.CLOSE.key)?this.createTitleBar("&#160;"):this.removeTitleBar()},configClose:function(e,t,n){var t=t[0],i=this.cfg.getProperty(x.TITLE.key);t?(i||this.createTitleBar("&#160;"),this.createCloseButton()):(this.removeCloseButton(),i||this.removeTitleBar())},initEvents:function(){var e=V._EVENT_TYPES,t=YAHOO.util.CustomEvent,n=this;n.beforeSelectEvent=new t(e.BEFORE_SELECT),n.selectEvent=new t(e.SELECT),n.beforeDeselectEvent=new t(e.BEFORE_DESELECT),n.deselectEvent=new t(e.DESELECT),n.changePageEvent=new t(e.CHANGE_PAGE),n.beforeRenderEvent=new t(e.BEFORE_RENDER),n.renderEvent=new t(e.RENDER),n.beforeDestroyEvent=new t(e.BEFORE_DESTROY),n.destroyEvent=new t(e.DESTROY),n.resetEvent=new t(e.RESET),n.clearEvent=new t(e.CLEAR),n.beforeShowEvent=new t(e.BEFORE_SHOW),n.showEvent=new t(e.SHOW),n.beforeHideEvent=new t(e.BEFORE_HIDE),n.hideEvent=new t(e.HIDE),n.beforeShowNavEvent=new t(e.BEFORE_SHOW_NAV),n.showNavEvent=new t(e.SHOW_NAV),n.beforeHideNavEvent=new t(e.BEFORE_HIDE_NAV),n.hideNavEvent=new t(e.HIDE_NAV),n.beforeRenderNavEvent=new t(e.BEFORE_RENDER_NAV),n.renderNavEvent=new t(e.RENDER_NAV),n.beforeSelectEvent.subscribe(n.onBeforeSelect,this,!0),n.selectEvent.subscribe(n.onSelect,this,!0),n.beforeDeselectEvent.subscribe(n.onBeforeDeselect,this,!0),n.deselectEvent.subscribe(n.onDeselect,this,!0),n.changePageEvent.subscribe(n.onChangePage,this,!0),n.renderEvent.subscribe(n.onRender,this,!0),n.resetEvent.subscribe(n.onReset,this,!0),n.clearEvent.subscribe(n.onClear,this,!0)},doPreviousMonthNav:function(e,n){E.preventDefault(e),setTimeout(function(){n.previousMonth();var e=K.getElementsByClassName(n.Style.CSS_NAV_LEFT,"a",n.oDomContainer);if(e&&e[0])try{e[0].focus()}catch(t){}},0)},doNextMonthNav:function(e,n){E.preventDefault(e),setTimeout(function(){n.nextMonth();var e=K.getElementsByClassName(n.Style.CSS_NAV_RIGHT,"a",n.oDomContainer);if(e&&e[0])try{e[0].focus()}catch(t){}},0)},doSelectCell:function(e,t){for(var n,i,r,a=E.getTarget(e),s=a.tagName.toLowerCase(),l=!1;"td"!=s&&!K.hasClass(a,t.Style.CSS_CELL_SELECTABLE);)if(!l&&"a"==s&&K.hasClass(a,t.Style.CSS_CELL_SELECTOR)&&(l=!0),s=(a=a.parentNode).tagName.toLowerCase(),a==this.oDomContainer||"html"==s)return;l&&E.preventDefault(e),e=a,K.hasClass(e,t.Style.CSS_CELL_SELECTABLE)&&-1<(r=t.getIndexFromId(e.id))&&(i=t.cellDates[r])&&(U.getDate(i[0],i[1]-1,i[2]),t.Options.MULTI_SELECT?((n=e.getElementsByTagName("a")[0])&&n.blur(),i=t.cellDates[r],-1<t._indexOfSelectedFieldArray(i)?t.deselectCell(r):t.selectCell(r)):((n=e.getElementsByTagName("a")[0])&&n.blur(),t.selectCell(r)))},doCellMouseOver:function(e,t){for(var n=e?E.getTarget(e):this;n.tagName&&"td"!=n.tagName.toLowerCase();)if(!(n=n.parentNode).tagName||"html"==n.tagName.toLowerCase())return;K.hasClass(n,t.Style.CSS_CELL_SELECTABLE)&&K.addClass(n,t.Style.CSS_CELL_HOVER)},doCellMouseOut:function(e,t){for(var n=e?E.getTarget(e):this;n.tagName&&"td"!=n.tagName.toLowerCase();)if(!(n=n.parentNode).tagName||"html"==n.tagName.toLowerCase())return;K.hasClass(n,t.Style.CSS_CELL_SELECTABLE)&&K.removeClass(n,t.Style.CSS_CELL_HOVER)},setupConfig:function(){var e=this.cfg,t=(e.addProperty(x.TODAY.key,{value:new Date(x.TODAY.value.getTime()),supercedes:x.TODAY.supercedes,handler:this.configToday,suppressEvent:!0}),e.addProperty(x.PAGEDATE.key,{value:x.PAGEDATE.value||new Date(x.TODAY.value.getTime()),handler:this.configPageDate}),e.addProperty(x.SELECTED.key,{value:x.SELECTED.value.concat(),handler:this.configSelected}),e.addProperty(x.TITLE.key,{value:x.TITLE.value,handler:this.configTitle}),e.addProperty(x.CLOSE.key,{value:x.CLOSE.value,handler:this.configClose}),e.addProperty(x.IFRAME.key,{value:x.IFRAME.value,handler:this.configIframe,validator:e.checkBoolean}),e.addProperty(x.MINDATE.key,{value:x.MINDATE.value,handler:this.configMinDate}),e.addProperty(x.MAXDATE.key,{value:x.MAXDATE.value,handler:this.configMaxDate}),e.addProperty(x.MULTI_SELECT.key,{value:x.MULTI_SELECT.value,handler:this.configOptions,validator:e.checkBoolean}),e.addProperty(x.OOM_SELECT.key,{value:x.OOM_SELECT.value,handler:this.configOptions,validator:e.checkBoolean}),e.addProperty(x.START_WEEKDAY.key,{value:x.START_WEEKDAY.value,handler:this.configOptions,validator:e.checkNumber}),e.addProperty(x.SHOW_WEEKDAYS.key,{value:x.SHOW_WEEKDAYS.value,handler:this.configOptions,validator:e.checkBoolean}),e.addProperty(x.SHOW_WEEK_HEADER.key,{value:x.SHOW_WEEK_HEADER.value,handler:this.configOptions,validator:e.checkBoolean}),e.addProperty(x.SHOW_WEEK_FOOTER.key,{value:x.SHOW_WEEK_FOOTER.value,handler:this.configOptions,validator:e.checkBoolean}),e.addProperty(x.HIDE_BLANK_WEEKS.key,{value:x.HIDE_BLANK_WEEKS.value,handler:this.configOptions,validator:e.checkBoolean}),e.addProperty(x.NAV_ARROW_LEFT.key,{value:x.NAV_ARROW_LEFT.value,handler:this.configOptions}),e.addProperty(x.NAV_ARROW_RIGHT.key,{value:x.NAV_ARROW_RIGHT.value,handler:this.configOptions}),e.addProperty(x.MONTHS_SHORT.key,{value:x.MONTHS_SHORT.value,handler:this.configLocale}),e.addProperty(x.MONTHS_LONG.key,{value:x.MONTHS_LONG.value,handler:this.configLocale}),e.addProperty(x.WEEKDAYS_1CHAR.key,{value:x.WEEKDAYS_1CHAR.value,handler:this.configLocale}),e.addProperty(x.WEEKDAYS_SHORT.key,{value:x.WEEKDAYS_SHORT.value,handler:this.configLocale}),e.addProperty(x.WEEKDAYS_MEDIUM.key,{value:x.WEEKDAYS_MEDIUM.value,handler:this.configLocale}),e.addProperty(x.WEEKDAYS_LONG.key,{value:x.WEEKDAYS_LONG.value,handler:this.configLocale}),function(){e.refireEvent(x.LOCALE_MONTHS.key),e.refireEvent(x.LOCALE_WEEKDAYS.key)});e.subscribeToConfigEvent(x.START_WEEKDAY.key,t,this,!0),e.subscribeToConfigEvent(x.MONTHS_SHORT.key,t,this,!0),e.subscribeToConfigEvent(x.MONTHS_LONG.key,t,this,!0),e.subscribeToConfigEvent(x.WEEKDAYS_1CHAR.key,t,this,!0),e.subscribeToConfigEvent(x.WEEKDAYS_SHORT.key,t,this,!0),e.subscribeToConfigEvent(x.WEEKDAYS_MEDIUM.key,t,this,!0),e.subscribeToConfigEvent(x.WEEKDAYS_LONG.key,t,this,!0),e.addProperty(x.LOCALE_MONTHS.key,{value:x.LOCALE_MONTHS.value,handler:this.configLocaleValues}),e.addProperty(x.LOCALE_WEEKDAYS.key,{value:x.LOCALE_WEEKDAYS.value,handler:this.configLocaleValues}),e.addProperty(x.YEAR_OFFSET.key,{value:x.YEAR_OFFSET.value,supercedes:x.YEAR_OFFSET.supercedes,handler:this.configLocale}),e.addProperty(x.DATE_DELIMITER.key,{value:x.DATE_DELIMITER.value,handler:this.configLocale}),e.addProperty(x.DATE_FIELD_DELIMITER.key,{value:x.DATE_FIELD_DELIMITER.value,handler:this.configLocale}),e.addProperty(x.DATE_RANGE_DELIMITER.key,{value:x.DATE_RANGE_DELIMITER.value,handler:this.configLocale}),e.addProperty(x.MY_MONTH_POSITION.key,{value:x.MY_MONTH_POSITION.value,handler:this.configLocale,validator:e.checkNumber}),e.addProperty(x.MY_YEAR_POSITION.key,{value:x.MY_YEAR_POSITION.value,handler:this.configLocale,validator:e.checkNumber}),e.addProperty(x.MD_MONTH_POSITION.key,{value:x.MD_MONTH_POSITION.value,handler:this.configLocale,validator:e.checkNumber}),e.addProperty(x.MD_DAY_POSITION.key,{value:x.MD_DAY_POSITION.value,handler:this.configLocale,validator:e.checkNumber}),e.addProperty(x.MDY_MONTH_POSITION.key,{value:x.MDY_MONTH_POSITION.value,handler:this.configLocale,validator:e.checkNumber}),e.addProperty(x.MDY_DAY_POSITION.key,{value:x.MDY_DAY_POSITION.value,handler:this.configLocale,validator:e.checkNumber}),e.addProperty(x.MDY_YEAR_POSITION.key,{value:x.MDY_YEAR_POSITION.value,handler:this.configLocale,validator:e.checkNumber}),e.addProperty(x.MY_LABEL_MONTH_POSITION.key,{value:x.MY_LABEL_MONTH_POSITION.value,handler:this.configLocale,validator:e.checkNumber}),e.addProperty(x.MY_LABEL_YEAR_POSITION.key,{value:x.MY_LABEL_YEAR_POSITION.value,handler:this.configLocale,validator:e.checkNumber}),e.addProperty(x.MY_LABEL_MONTH_SUFFIX.key,{value:x.MY_LABEL_MONTH_SUFFIX.value,handler:this.configLocale}),e.addProperty(x.MY_LABEL_YEAR_SUFFIX.key,{value:x.MY_LABEL_YEAR_SUFFIX.value,handler:this.configLocale}),e.addProperty(x.NAV.key,{value:x.NAV.value,handler:this.configNavigator}),e.addProperty(x.STRINGS.key,{value:x.STRINGS.value,handler:this.configStrings,validator:function(e){return d.isObject(e)},supercedes:x.STRINGS.supercedes})},configStrings:function(e,t,n){t=d.merge(x.STRINGS.value,t[0]);this.cfg.setProperty(x.STRINGS.key,t,!0)},configPageDate:function(e,t,n){this.cfg.setProperty(x.PAGEDATE.key,this._parsePageDate(t[0]),!0)},configMinDate:function(e,t,n){t=t[0];d.isString(t)&&(t=this._parseDate(t),this.cfg.setProperty(x.MINDATE.key,U.getDate(t[0],t[1]-1,t[2])))},configMaxDate:function(e,t,n){t=t[0];d.isString(t)&&(t=this._parseDate(t),this.cfg.setProperty(x.MAXDATE.key,U.getDate(t[0],t[1]-1,t[2])))},configToday:function(e,t,n){t=t[0],d.isString(t)&&(t=this._parseDate(t)),t=U.clearTime(t);this.cfg.initialConfig[x.PAGEDATE.key]||this.cfg.setProperty(x.PAGEDATE.key,t),this.today=t,this.cfg.setProperty(x.TODAY.key,t,!0)},configSelected:function(e,t,n){var t=t[0],i=x.SELECTED.key;t&&d.isString(t)&&this.cfg.setProperty(i,this._parseDates(t),!0),this._selectedDates||(this._selectedDates=this.cfg.getProperty(i))},configOptions:function(e,t,n){this.Options[e.toUpperCase()]=t[0]},configLocale:function(e,t,n){this.Locale[e.toUpperCase()]=t[0],this.cfg.refireEvent(x.LOCALE_MONTHS.key),this.cfg.refireEvent(x.LOCALE_WEEKDAYS.key)},configLocaleValues:function(e,t,n){e=e.toLowerCase();var i=t[0],r=this.cfg,a=this.Locale;switch(e){case x.LOCALE_MONTHS.key:switch(i){case V.SHORT:a.LOCALE_MONTHS=r.getProperty(x.MONTHS_SHORT.key).concat();break;case V.LONG:a.LOCALE_MONTHS=r.getProperty(x.MONTHS_LONG.key).concat()}break;case x.LOCALE_WEEKDAYS.key:switch(i){case V.ONE_CHAR:a.LOCALE_WEEKDAYS=r.getProperty(x.WEEKDAYS_1CHAR.key).concat();break;case V.SHORT:a.LOCALE_WEEKDAYS=r.getProperty(x.WEEKDAYS_SHORT.key).concat();break;case V.MEDIUM:a.LOCALE_WEEKDAYS=r.getProperty(x.WEEKDAYS_MEDIUM.key).concat();break;case V.LONG:a.LOCALE_WEEKDAYS=r.getProperty(x.WEEKDAYS_LONG.key).concat()}var s=r.getProperty(x.START_WEEKDAY.key);if(0<s)for(var l=0;l<s;++l)a.LOCALE_WEEKDAYS.push(a.LOCALE_WEEKDAYS.shift())}},configNavigator:function(e,t,n){t=t[0];YAHOO.widget.CalendarNavigator&&(!0===t||d.isObject(t))?this.oNavigator||(this.oNavigator=new YAHOO.widget.CalendarNavigator(this),this.beforeRenderEvent.subscribe(function(){this.pages||this.oNavigator.erase()},this,!0)):this.oNavigator&&(this.oNavigator.destroy(),this.oNavigator=null)},initStyles:function(){var e=V.STYLES;this.Style={CSS_ROW_HEADER:e.CSS_ROW_HEADER,CSS_ROW_FOOTER:e.CSS_ROW_FOOTER,CSS_CELL:e.CSS_CELL,CSS_CELL_SELECTOR:e.CSS_CELL_SELECTOR,CSS_CELL_SELECTED:e.CSS_CELL_SELECTED,CSS_CELL_SELECTABLE:e.CSS_CELL_SELECTABLE,CSS_CELL_RESTRICTED:e.CSS_CELL_RESTRICTED,CSS_CELL_TODAY:e.CSS_CELL_TODAY,CSS_CELL_OOM:e.CSS_CELL_OOM,CSS_CELL_OOB:e.CSS_CELL_OOB,CSS_HEADER:e.CSS_HEADER,CSS_HEADER_TEXT:e.CSS_HEADER_TEXT,CSS_BODY:e.CSS_BODY,CSS_WEEKDAY_CELL:e.CSS_WEEKDAY_CELL,CSS_WEEKDAY_ROW:e.CSS_WEEKDAY_ROW,CSS_FOOTER:e.CSS_FOOTER,CSS_CALENDAR:e.CSS_CALENDAR,CSS_SINGLE:e.CSS_SINGLE,CSS_CONTAINER:e.CSS_CONTAINER,CSS_NAV_LEFT:e.CSS_NAV_LEFT,CSS_NAV_RIGHT:e.CSS_NAV_RIGHT,CSS_NAV:e.CSS_NAV,CSS_CLOSE:e.CSS_CLOSE,CSS_CELL_TOP:e.CSS_CELL_TOP,CSS_CELL_LEFT:e.CSS_CELL_LEFT,CSS_CELL_RIGHT:e.CSS_CELL_RIGHT,CSS_CELL_BOTTOM:e.CSS_CELL_BOTTOM,CSS_CELL_HOVER:e.CSS_CELL_HOVER,CSS_CELL_HIGHLIGHT1:e.CSS_CELL_HIGHLIGHT1,CSS_CELL_HIGHLIGHT2:e.CSS_CELL_HIGHLIGHT2,CSS_CELL_HIGHLIGHT3:e.CSS_CELL_HIGHLIGHT3,CSS_CELL_HIGHLIGHT4:e.CSS_CELL_HIGHLIGHT4,CSS_WITH_TITLE:e.CSS_WITH_TITLE,CSS_FIXED_SIZE:e.CSS_FIXED_SIZE,CSS_LINK_CLOSE:e.CSS_LINK_CLOSE}},buildMonthLabel:function(){return this._buildMonthLabel(this.cfg.getProperty(x.PAGEDATE.key))},_buildMonthLabel:function(e){var t=this.Locale.LOCALE_MONTHS[e.getMonth()]+this.Locale.MY_LABEL_MONTH_SUFFIX,e=e.getFullYear()+this.Locale.YEAR_OFFSET+this.Locale.MY_LABEL_YEAR_SUFFIX;return 2==this.Locale.MY_LABEL_MONTH_POSITION||1==this.Locale.MY_LABEL_YEAR_POSITION?e+t:t+e},buildDayLabel:function(e){return e.getDate()},createTitleBar:function(e){var t=K.getElementsByClassName(YAHOO.widget.CalendarGroup.CSS_2UPTITLE,"div",this.oDomContainer)[0]||document.createElement("div");return t.className=YAHOO.widget.CalendarGroup.CSS_2UPTITLE,t.innerHTML=e,this.oDomContainer.insertBefore(t,this.oDomContainer.firstChild),K.addClass(this.oDomContainer,this.Style.CSS_WITH_TITLE),t},removeTitleBar:function(){var e=K.getElementsByClassName(YAHOO.widget.CalendarGroup.CSS_2UPTITLE,"div",this.oDomContainer)[0]||null;e&&(E.purgeElement(e),this.oDomContainer.removeChild(e)),K.removeClass(this.oDomContainer,this.Style.CSS_WITH_TITLE)},createCloseButton:function(){var e=YAHOO.widget.CalendarGroup.CSS_2UPCLOSE,t=this.Style.CSS_LINK_CLOSE,n=K.getElementsByClassName(t,"a",this.oDomContainer)[0],i=this.cfg.getProperty(x.STRINGS.key),i=i&&i.close?i.close:"";return n||(n=document.createElement("a"),E.addListener(n,"click",function(e,t){t.hide(),E.preventDefault(e)},this)),n.href="#",n.className=t,null!==V.IMG_ROOT?((t=K.getElementsByClassName(e,"img",n)[0]||document.createElement("img")).src=V.IMG_ROOT+"us/my/bn/x_d.gif",t.className=e,n.appendChild(t)):n.innerHTML='<span class="'+e+" "+this.Style.CSS_CLOSE+'">'+i+"</span>",this.oDomContainer.appendChild(n),n},removeCloseButton:function(){var e=K.getElementsByClassName(this.Style.CSS_LINK_CLOSE,"a",this.oDomContainer)[0]||null;e&&(E.purgeElement(e),this.oDomContainer.removeChild(e))},renderHeader:function(e){var t=7,n=this.cfg,i=n.getProperty(x.PAGEDATE.key),r=n.getProperty(x.STRINGS.key),a=r&&r.previousMonth?r.previousMonth:"",r=r&&r.nextMonth?r.nextMonth:"";n.getProperty(x.SHOW_WEEK_HEADER.key)&&(t+=1),n.getProperty(x.SHOW_WEEK_FOOTER.key)&&(t+=1),e[e.length]="<thead>",e[e.length]="<tr>",e[e.length]='<th colspan="'+t+'" class="'+this.Style.CSS_HEADER_TEXT+'">',e[e.length]='<div class="'+this.Style.CSS_HEADER+'">';var s,t=!1,l=(this.parent?(0===this.index&&(l=!0),this.index==this.parent.cfg.getProperty("pages")-1&&(t=!0)):t=l=!0,l&&(s=this._buildMonthLabel(U.subtract(i,U.MONTH,1)),l=null===(l=null===(l=n.getProperty(x.NAV_ARROW_LEFT.key))&&null!==V.IMG_ROOT?V.IMG_ROOT+"us/tr/callt.gif":l)?"":' style="background-image:url('+l+')"',e[e.length]='<a class="'+this.Style.CSS_NAV_LEFT+'"'+l+' href="#">'+a+" ("+s+")</a>"),this.buildMonthLabel());return(this.parent||this).cfg.getProperty("navigator")&&(l='<a class="'+this.Style.CSS_NAV+'" href="#">'+l+"</a>"),e[e.length]=l,t&&(s=this._buildMonthLabel(U.add(i,U.MONTH,1)),l=null===(a=null===(a=n.getProperty(x.NAV_ARROW_RIGHT.key))&&null!==V.IMG_ROOT?V.IMG_ROOT+"us/tr/calrt.gif":a)?"":' style="background-image:url('+a+')"',e[e.length]='<a class="'+this.Style.CSS_NAV_RIGHT+'"'+l+' href="#">'+r+" ("+s+")</a>"),e[e.length]="</div>\n</th>\n</tr>",(e=n.getProperty(x.SHOW_WEEKDAYS.key)?this.buildWeekdays(e):e)[e.length]="</thead>",e},buildWeekdays:function(e){e[e.length]='<tr class="'+this.Style.CSS_WEEKDAY_ROW+'">',this.cfg.getProperty(x.SHOW_WEEK_HEADER.key)&&(e[e.length]="<th>&#160;</th>");for(var t=0;t<this.Locale.LOCALE_WEEKDAYS.length;++t)e[e.length]='<th class="'+this.Style.CSS_WEEKDAY_CELL+'">'+this.Locale.LOCALE_WEEKDAYS[t]+"</th>";return this.cfg.getProperty(x.SHOW_WEEK_FOOTER.key)&&(e[e.length]="<th>&#160;</th>"),e[e.length]="</tr>",e},renderBody:function(e,t){var n=this.cfg.getProperty(x.START_WEEKDAY.key);this.preMonthDays=e.getDay(),0<n&&(this.preMonthDays-=n),this.preMonthDays<0&&(this.preMonthDays+=7),this.monthDays=U.findMonthEnd(e).getDate(),this.postMonthDays=V.DISPLAY_DAYS-this.preMonthDays-this.monthDays,e=U.subtract(e,U.DAY,this.preMonthDays);var i,r,a,s,l=this.today,o=this.cfg,h=l.getFullYear(),E=l.getMonth(),b=l.getDate(),d=o.getProperty(x.PAGEDATE.key),c=o.getProperty(x.HIDE_BLANK_WEEKS.key),F=o.getProperty(x.SHOW_WEEK_FOOTER.key),w=o.getProperty(x.SHOW_WEEK_HEADER.key),W=o.getProperty(x.OOM_SELECT.key),u=o.getProperty(x.MINDATE.key),_=o.getProperty(x.MAXDATE.key),u=(this.Locale.YEAR_OFFSET,u&&U.clearTime(u)),_=_&&U.clearTime(_);t[t.length]='<tbody class="m'+(d.getMonth()+1)+" "+this.Style.CSS_BODY+'">';for(var g=0,S=document.createElement("div"),f=document.createElement("td"),v=(S.appendChild(f),this.parent||this),C=0;C<6&&(r="w"+(i=U.getWeekNumber(e,n)),0===C||!0!==c||e.getMonth()==d.getMonth());C++){t[t.length]='<tr class="'+r+'">',w&&(t=this.renderRowHeader(i,t));for(var O=0;O<7;O++){a=[],this.clearElement(f),f.className=this.Style.CSS_CELL,f.id=this.id+"_cell"+g,e.getDate()==b&&e.getMonth()==E&&e.getFullYear()==h&&(a[a.length]=v.renderCellStyleToday);var y=[e.getFullYear(),e.getMonth()+1,e.getDate()];if(this.cellDates[this.cellDates.length]=y,(s=e.getMonth()!=d.getMonth())&&!W)a[a.length]=v.renderCellNotThisMonth;else{K.addClass(f,"wd"+e.getDay()),K.addClass(f,"d"+e.getDate());for(var T=this.renderStack.concat(),A=0,B=T.length;A<B;++A){var D,L,p=null,N=T[A];switch(N[0]){case V.DATE:D=N[1][1],L=N[1][2],I=N[1][0],e.getMonth()+1==D&&e.getDate()==L&&e.getFullYear()==I&&(p=N[2],this.renderStack.splice(A,1));break;case V.MONTH_DAY:D=N[1][0],L=N[1][1],e.getMonth()+1==D&&e.getDate()==L&&(p=N[2],this.renderStack.splice(A,1));break;case V.RANGE:var I=N[1][0],M=N[1][1],Y=I[1],m=I[2],R=I[0],R=U.getDate(R,Y-1,m),Y=M[1],m=M[2],M=M[0],M=U.getDate(M,Y-1,m);e.getTime()>=R.getTime()&&e.getTime()<=M.getTime()&&(p=N[2],e.getTime()==M.getTime())&&this.renderStack.splice(A,1);break;case V.WEEKDAY:Y=N[1][0];e.getDay()+1==Y&&(p=N[2]);break;case V.MONTH:D=N[1][0],e.getMonth()+1==D&&(p=N[2])}p&&(a[a.length]=p)}}-1<this._indexOfSelectedFieldArray(y)&&(a[a.length]=v.renderCellStyleSelected),s&&(a[a.length]=v.styleCellNotThisMonth),u&&e.getTime()<u.getTime()||_&&e.getTime()>_.getTime()?a[a.length]=v.renderOutOfBoundsDate:(a[a.length]=v.styleCellDefault,a[a.length]=v.renderCellDefault);for(var H=0;H<a.length&&a[H].call(v,e,f)!=V.STOP_RENDER;++H);e.setTime(e.getTime()+U.ONE_DAY_MS),e=U.clearTime(e),0<=g&&g<=6&&K.addClass(f,this.Style.CSS_CELL_TOP),g%7==0&&K.addClass(f,this.Style.CSS_CELL_LEFT),(g+1)%7==0&&K.addClass(f,this.Style.CSS_CELL_RIGHT);var k=this.postMonthDays;if(c&&7<=k)for(var G=Math.floor(k/7),P=0;P<G;++P)k-=7;g>=this.preMonthDays+k+this.monthDays-7&&K.addClass(f,this.Style.CSS_CELL_BOTTOM),t[t.length]=S.innerHTML,g++}(t=F?this.renderRowFooter(i,t):t)[t.length]="</tr>"}return t[t.length]="</tbody>",t},renderFooter:function(e){return e},render:function(){this.beforeRenderEvent.fire();var e=U.findMonthStart(this.cfg.getProperty(x.PAGEDATE.key)),t=(this.resetRenderers(),this.cellDates.length=0,E.purgeElement(this.oDomContainer,!0),[]);t[t.length]='<table cellSpacing="0" class="'+this.Style.CSS_CALENDAR+" y"+(e.getFullYear()+this.Locale.YEAR_OFFSET)+'" id="'+this.id+'">',t=this.renderHeader(t),t=this.renderBody(e,t),(t=this.renderFooter(t))[t.length]="</table>",this.oDomContainer.innerHTML=t.join("\n"),this.applyListeners(),e=this._oDoc&&this._oDoc.getElementById(this.id)||this.id,this.cells=K.getElementsByClassName(this.Style.CSS_CELL,"td",e),this.cfg.refireEvent(x.TITLE.key),this.cfg.refireEvent(x.CLOSE.key),this.cfg.refireEvent(x.IFRAME.key),this.renderEvent.fire()},applyListeners:function(){var e,t,n=this.oDomContainer,i=this.parent||this,r=K.getElementsByClassName(this.Style.CSS_NAV_LEFT,"a",n),n=K.getElementsByClassName(this.Style.CSS_NAV_RIGHT,"a",n);if(r&&0<r.length&&(this.linkLeft=r[0],E.addListener(this.linkLeft,"click",this.doPreviousMonthNav,i,!0)),n&&0<n.length&&(this.linkRight=n[0],E.addListener(this.linkRight,"click",this.doNextMonthNav,i,!0)),null!==i.cfg.getProperty("navigator")&&this.applyNavListeners(),this.domEventMap)for(t in this.domEventMap)if(d.hasOwnProperty(this.domEventMap,t)){var a=this.domEventMap[t];a instanceof Array||(a=[a]);for(var s=0;s<a.length;s++)for(var l=a[s],o=K.getElementsByClassName(t,l.tag,this.oDomContainer),h=0;h<o.length;h++)e=o[h],E.addListener(e,l.event,l.handler,l.scope,l.correct)}E.addListener(this.oDomContainer,"click",this.doSelectCell,this),E.addListener(this.oDomContainer,"mouseover",this.doCellMouseOver,this),E.addListener(this.oDomContainer,"mouseout",this.doCellMouseOut,this)},applyNavListeners:function(){var i=this.parent||this,r=this,e=K.getElementsByClassName(this.Style.CSS_NAV,"a",this.oDomContainer);0<e.length&&E.addListener(e,"click",function(e,t){var n=E.getTarget(e),n=(this!==n&&!K.isAncestor(this,n)||E.preventDefault(e),i.oNavigator);n&&(e=r.cfg.getProperty("pagedate"),n.setYear(e.getFullYear()+r.Locale.YEAR_OFFSET),n.setMonth(e.getMonth()),n.show())})},getDateByCellId:function(e){e=this.getDateFieldsByCellId(e);return e?U.getDate(e[0],e[1]-1,e[2]):null},getDateFieldsByCellId:function(e){return-1<(e=this.getIndexFromId(e))?this.cellDates[e]:null},getCellIndex:function(e){var t=-1;if(e)for(var n=e.getMonth(),i=e.getFullYear(),r=e.getDate(),a=this.cellDates,s=0;s<a.length;++s){var l=a[s];if(l[0]===i&&l[1]===n+1&&l[2]===r){t=s;break}}return t},getIndexFromId:function(e){var t=-1,n=e.lastIndexOf("_cell");return t=-1<n?parseInt(e.substring(n+5),10):t},renderOutOfBoundsDate:function(e,t){return K.addClass(t,this.Style.CSS_CELL_OOB),t.innerHTML=e.getDate(),V.STOP_RENDER},renderRowHeader:function(e,t){return t[t.length]='<th class="'+this.Style.CSS_ROW_HEADER+'">'+e+"</th>",t},renderRowFooter:function(e,t){return t[t.length]='<th class="'+this.Style.CSS_ROW_FOOTER+'">'+e+"</th>",t},renderCellDefault:function(e,t){t.innerHTML='<a href="#" class="'+this.Style.CSS_CELL_SELECTOR+'">'+this.buildDayLabel(e)+"</a>"},styleCellDefault:function(e,t){K.addClass(t,this.Style.CSS_CELL_SELECTABLE)},renderCellStyleHighlight1:function(e,t){K.addClass(t,this.Style.CSS_CELL_HIGHLIGHT1)},renderCellStyleHighlight2:function(e,t){K.addClass(t,this.Style.CSS_CELL_HIGHLIGHT2)},renderCellStyleHighlight3:function(e,t){K.addClass(t,this.Style.CSS_CELL_HIGHLIGHT3)},renderCellStyleHighlight4:function(e,t){K.addClass(t,this.Style.CSS_CELL_HIGHLIGHT4)},renderCellStyleToday:function(e,t){K.addClass(t,this.Style.CSS_CELL_TODAY)},renderCellStyleSelected:function(e,t){K.addClass(t,this.Style.CSS_CELL_SELECTED)},renderCellNotThisMonth:function(e,t){return this.styleCellNotThisMonth(e,t),t.innerHTML=e.getDate(),V.STOP_RENDER},styleCellNotThisMonth:function(e,t){YAHOO.util.Dom.addClass(t,this.Style.CSS_CELL_OOM)},renderBodyCellRestricted:function(e,t){return K.addClass(t,this.Style.CSS_CELL),K.addClass(t,this.Style.CSS_CELL_RESTRICTED),t.innerHTML=e.getDate(),V.STOP_RENDER},addMonths:function(e){var t=x.PAGEDATE.key,n=this.cfg.getProperty(t),e=U.add(n,U.MONTH,e);this.cfg.setProperty(t,e),this.resetRenderers(),this.changePageEvent.fire(n,e)},subtractMonths:function(e){this.addMonths(-1*e)},addYears:function(e){var t=x.PAGEDATE.key,n=this.cfg.getProperty(t),e=U.add(n,U.YEAR,e);this.cfg.setProperty(t,e),this.resetRenderers(),this.changePageEvent.fire(n,e)},subtractYears:function(e){this.addYears(-1*e)},nextMonth:function(){this.addMonths(1)},previousMonth:function(){this.addMonths(-1)},nextYear:function(){this.addYears(1)},previousYear:function(){this.addYears(-1)},reset:function(){this.cfg.resetProperty(x.SELECTED.key),this.cfg.resetProperty(x.PAGEDATE.key),this.resetEvent.fire()},clear:function(){this.cfg.setProperty(x.SELECTED.key,[]),this.cfg.setProperty(x.PAGEDATE.key,new Date(this.today.getTime())),this.clearEvent.fire()},select:function(e){for(var t=this._toFieldArray(e),n=[],i=[],r=x.SELECTED.key,a=0;a<t.length;++a){var s=t[a];this.isDateOOB(this._toDate(s))||(0===n.length&&(this.beforeSelectEvent.fire(),i=this.cfg.getProperty(r)),n.push(s),-1==this._indexOfSelectedFieldArray(s)&&(i[i.length]=s))}return 0<n.length&&((this.parent||this).cfg.setProperty(r,i),this.selectEvent.fire(n)),this.getSelectedDates()},selectCell:function(e){var t,n,i=this.cells[e],e=this.cellDates[e],r=this._toDate(e);return K.hasClass(i,this.Style.CSS_CELL_SELECTABLE)&&(this.beforeSelectEvent.fire(),t=x.SELECTED.key,n=this.cfg.getProperty(t),e=e.concat(),-1==this._indexOfSelectedFieldArray(e)&&(n[n.length]=e),(this.parent||this).cfg.setProperty(t,n),this.renderCellStyleSelected(r,i),this.selectEvent.fire([e]),this.doCellMouseOut.call(i,null,this)),this.getSelectedDates()},deselect:function(e){for(var t=this._toFieldArray(e),n=[],i=[],r=x.SELECTED.key,a=0;a<t.length;++a){var s=t[a];this.isDateOOB(this._toDate(s))||(0===n.length&&(this.beforeDeselectEvent.fire(),i=this.cfg.getProperty(r)),n.push(s),-1!=(s=this._indexOfSelectedFieldArray(s))&&i.splice(s,1))}return 0<n.length&&((this.parent||this).cfg.setProperty(r,i),this.deselectEvent.fire(n)),this.getSelectedDates()},deselectCell:function(e){var t,n,i=this.cells[e],e=this.cellDates[e],r=this._indexOfSelectedFieldArray(e);return K.hasClass(i,this.Style.CSS_CELL_SELECTABLE)&&(this.beforeDeselectEvent.fire(),t=this.cfg.getProperty(x.SELECTED.key),n=this._toDate(e),e=e.concat(),-1<r&&((this.cfg.getProperty(x.PAGEDATE.key).getMonth()==n.getMonth()&&this.cfg.getProperty(x.PAGEDATE.key).getFullYear()==n.getFullYear()||this.cfg.getProperty(x.OOM_SELECT.key))&&K.removeClass(i,this.Style.CSS_CELL_SELECTED),t.splice(r,1)),(this.parent||this).cfg.setProperty(x.SELECTED.key,t),this.deselectEvent.fire([e])),this.getSelectedDates()},deselectAll:function(){this.beforeDeselectEvent.fire();var e=x.SELECTED.key,t=this.cfg.getProperty(e),n=t.length,t=t.concat();return(this.parent||this).cfg.setProperty(e,[]),0<n&&this.deselectEvent.fire(t),this.getSelectedDates()},_toFieldArray:function(e){var t=[];if(e instanceof Date)t=[[e.getFullYear(),e.getMonth()+1,e.getDate()]];else if(d.isString(e))t=this._parseDates(e);else if(d.isArray(e))for(var n=0;n<e.length;++n){var i=e[n];t[t.length]=[i.getFullYear(),i.getMonth()+1,i.getDate()]}return t},toDate:function(e){return this._toDate(e)},_toDate:function(e){return e instanceof Date?e:U.getDate(e[0],e[1]-1,e[2])},_fieldArraysAreEqual:function(e,t){var n=!1;return n=e[0]==t[0]&&e[1]==t[1]&&e[2]==t[2]?!0:n},_indexOfSelectedFieldArray:function(e){for(var t=-1,n=this.cfg.getProperty(x.SELECTED.key),i=0;i<n.length;++i){var r=n[i];if(e[0]==r[0]&&e[1]==r[1]&&e[2]==r[2]){t=i;break}}return t},isDateOOM:function(e){return e.getMonth()!=this.cfg.getProperty(x.PAGEDATE.key).getMonth()},isDateOOB:function(e){var t=this.cfg.getProperty(x.MINDATE.key),n=this.cfg.getProperty(x.MAXDATE.key),i=U,t=t&&i.clearTime(t),n=n&&i.clearTime(n),e=new Date(e.getTime()),e=i.clearTime(e);return t&&e.getTime()<t.getTime()||n&&e.getTime()>n.getTime()},_parsePageDate:function(e){var t;return e?e instanceof Date?U.findMonthStart(e):(e=e.split(this.cfg.getProperty(x.DATE_FIELD_DELIMITER.key)),t=parseInt(e[this.cfg.getProperty(x.MY_MONTH_POSITION.key)-1],10)-1,e=parseInt(e[this.cfg.getProperty(x.MY_YEAR_POSITION.key)-1],10)-this.Locale.YEAR_OFFSET,U.getDate(e,t,1)):U.getDate(this.today.getFullYear(),this.today.getMonth(),1)},onBeforeSelect:function(){!1===this.cfg.getProperty(x.MULTI_SELECT.key)&&(this.parent?(this.parent.callChildFunction("clearAllBodyCellStyles",this.Style.CSS_CELL_SELECTED),this.parent):(this.clearAllBodyCellStyles(this.Style.CSS_CELL_SELECTED),this)).deselectAll()},onSelect:function(e){},onBeforeDeselect:function(){},onDeselect:function(e){},onChangePage:function(){this.render()},onRender:function(){},onReset:function(){this.render()},onClear:function(){this.render()},validate:function(){return!0},_parseDate:function(e){var t,e=e.split(this.Locale.DATE_FIELD_DELIMITER);2==e.length?(t=[e[this.Locale.MD_MONTH_POSITION-1],e[this.Locale.MD_DAY_POSITION-1]]).type=V.MONTH_DAY:(t=[e[this.Locale.MDY_YEAR_POSITION-1]-this.Locale.YEAR_OFFSET,e[this.Locale.MDY_MONTH_POSITION-1],e[this.Locale.MDY_DAY_POSITION-1]]).type=V.DATE;for(var n=0;n<t.length;n++)t[n]=parseInt(t[n],10);return t},_parseDates:function(e){for(var t=[],n=e.split(this.Locale.DATE_DELIMITER),i=0;i<n.length;++i){var r,a,s=n[i];-1!=s.indexOf(this.Locale.DATE_RANGE_DELIMITER)?(a=s.split(this.Locale.DATE_RANGE_DELIMITER),r=this._parseDate(a[0]),a=this._parseDate(a[1]),r=this._parseRange(r,a),t=t.concat(r)):(a=this._parseDate(s),t.push(a))}return t},_parseRange:function(e,t){var n=U.add(U.getDate(e[0],e[1]-1,e[2]),U.DAY,1),i=U.getDate(t[0],t[1]-1,t[2]),r=[];for(r.push(e);n.getTime()<=i.getTime();)r.push([n.getFullYear(),n.getMonth()+1,n.getDate()]),n=U.add(n,U.DAY,1);return r},resetRenderers:function(){this.renderStack=this._renderStack.concat()},removeRenderers:function(){this._renderStack=[],this.renderStack=[]},clearElement:function(e){e.innerHTML="&#160;",e.className=""},addRenderer:function(e,t){for(var n=this._parseDates(e),i=0;i<n.length;++i){var r=n[i];2==r.length?r[0]instanceof Array?this._addRenderer(V.RANGE,r,t):this._addRenderer(V.MONTH_DAY,r,t):3==r.length&&this._addRenderer(V.DATE,r,t)}},_addRenderer:function(e,t,n){this.renderStack.unshift([e,t,n]),this._renderStack=this.renderStack.concat()},addMonthRenderer:function(e,t){this._addRenderer(V.MONTH,[e],t)},addWeekdayRenderer:function(e,t){this._addRenderer(V.WEEKDAY,[e],t)},clearAllBodyCellStyles:function(e){for(var t=0;t<this.cells.length;++t)K.removeClass(this.cells[t],e)},setMonth:function(e){var t=x.PAGEDATE.key,n=this.cfg.getProperty(t);n.setMonth(parseInt(e,10)),this.cfg.setProperty(t,n)},setYear:function(e){var t=x.PAGEDATE.key,n=this.cfg.getProperty(t);n.setFullYear(parseInt(e,10)-this.Locale.YEAR_OFFSET),this.cfg.setProperty(t,n)},getSelectedDates:function(){for(var e=[],t=this.cfg.getProperty(x.SELECTED.key),n=0;n<t.length;++n){var i=t[n],i=U.getDate(i[0],i[1]-1,i[2]);e.push(i)}return e.sort(function(e,t){return e-t}),e},hide:function(){this.beforeHideEvent.fire()&&(this.oDomContainer.style.display="none",this.hideEvent.fire())},show:function(){this.beforeShowEvent.fire()&&(this.oDomContainer.style.display="block",this.showEvent.fire())},browser:-1!=(e=navigator.userAgent.toLowerCase()).indexOf("opera")?"opera":-1!=e.indexOf("msie 7")?"ie7":-1!=e.indexOf("msie")?"ie":-1!=e.indexOf("safari")?"safari":-1!=e.indexOf("gecko")&&"gecko",toString:function(){return"Calendar "+this.id},destroy:function(){var e;this.beforeDestroyEvent.fire()&&((e=this).navigator&&e.navigator.destroy(),e.cfg&&e.cfg.destroy(),E.purgeElement(e.oDomContainer,!0),K.removeClass(e.oDomContainer,e.Style.CSS_WITH_TITLE),K.removeClass(e.oDomContainer,e.Style.CSS_CONTAINER),K.removeClass(e.oDomContainer,e.Style.CSS_SINGLE),e.oDomContainer.innerHTML="",e.oDomContainer=null,e.cells=null,this.destroyEvent.fire())}},YAHOO.widget.Calendar=V,YAHOO.widget.Calendar_Core=YAHOO.widget.Calendar,YAHOO.widget.Cal_Core=YAHOO.widget.Calendar}(),function(){var d=YAHOO.util.Dom,r=YAHOO.widget.DateMath,i=YAHOO.util.Event,t=YAHOO.lang,s=YAHOO.widget.Calendar;function a(e,t,n){0<arguments.length&&this.init.apply(this,arguments)}(a.DEFAULT_CONFIG=a._DEFAULT_CONFIG=s.DEFAULT_CONFIG).PAGES={key:"pages",value:2};var c=a.DEFAULT_CONFIG;a.prototype={init:function(e,t,n){var i=this._parseArgs(arguments);e=i.id,t=i.container,n=i.config,this.oDomContainer=d.get(t),this.oDomContainer.id||(this.oDomContainer.id=d.generateId()),e=e||this.oDomContainer.id+"_t",this.id=e,this.containerId=this.oDomContainer.id,this.initEvents(),this.initStyles(),this.pages=[],d.addClass(this.oDomContainer,a.CSS_CONTAINER),d.addClass(this.oDomContainer,a.CSS_MULTI_UP),this.cfg=new YAHOO.util.Config(this),this.Options={},this.Locale={},this.setupConfig(),n&&this.cfg.applyConfig(n,!0),this.cfg.fireQueue()},setupConfig:function(){var e=this.cfg;e.addProperty(c.PAGES.key,{value:c.PAGES.value,validator:e.checkNumber,handler:this.configPages}),e.addProperty(c.YEAR_OFFSET.key,{value:c.YEAR_OFFSET.value,handler:this.delegateConfig,supercedes:c.YEAR_OFFSET.supercedes,suppressEvent:!0}),e.addProperty(c.TODAY.key,{value:new Date(c.TODAY.value.getTime()),supercedes:c.TODAY.supercedes,handler:this.configToday,suppressEvent:!1}),e.addProperty(c.PAGEDATE.key,{value:c.PAGEDATE.value||new Date(c.TODAY.value.getTime()),handler:this.configPageDate}),e.addProperty(c.SELECTED.key,{value:[],handler:this.configSelected}),e.addProperty(c.TITLE.key,{value:c.TITLE.value,handler:this.configTitle}),e.addProperty(c.CLOSE.key,{value:c.CLOSE.value,handler:this.configClose}),e.addProperty(c.IFRAME.key,{value:c.IFRAME.value,handler:this.configIframe,validator:e.checkBoolean}),e.addProperty(c.MINDATE.key,{value:c.MINDATE.value,handler:this.delegateConfig}),e.addProperty(c.MAXDATE.key,{value:c.MAXDATE.value,handler:this.delegateConfig}),e.addProperty(c.MULTI_SELECT.key,{value:c.MULTI_SELECT.value,handler:this.delegateConfig,validator:e.checkBoolean}),e.addProperty(c.OOM_SELECT.key,{value:c.OOM_SELECT.value,handler:this.delegateConfig,validator:e.checkBoolean}),e.addProperty(c.START_WEEKDAY.key,{value:c.START_WEEKDAY.value,handler:this.delegateConfig,validator:e.checkNumber}),e.addProperty(c.SHOW_WEEKDAYS.key,{value:c.SHOW_WEEKDAYS.value,handler:this.delegateConfig,validator:e.checkBoolean}),e.addProperty(c.SHOW_WEEK_HEADER.key,{value:c.SHOW_WEEK_HEADER.value,handler:this.delegateConfig,validator:e.checkBoolean}),e.addProperty(c.SHOW_WEEK_FOOTER.key,{value:c.SHOW_WEEK_FOOTER.value,handler:this.delegateConfig,validator:e.checkBoolean}),e.addProperty(c.HIDE_BLANK_WEEKS.key,{value:c.HIDE_BLANK_WEEKS.value,handler:this.delegateConfig,validator:e.checkBoolean}),e.addProperty(c.NAV_ARROW_LEFT.key,{value:c.NAV_ARROW_LEFT.value,handler:this.delegateConfig}),e.addProperty(c.NAV_ARROW_RIGHT.key,{value:c.NAV_ARROW_RIGHT.value,handler:this.delegateConfig}),e.addProperty(c.MONTHS_SHORT.key,{value:c.MONTHS_SHORT.value,handler:this.delegateConfig}),e.addProperty(c.MONTHS_LONG.key,{value:c.MONTHS_LONG.value,handler:this.delegateConfig}),e.addProperty(c.WEEKDAYS_1CHAR.key,{value:c.WEEKDAYS_1CHAR.value,handler:this.delegateConfig}),e.addProperty(c.WEEKDAYS_SHORT.key,{value:c.WEEKDAYS_SHORT.value,handler:this.delegateConfig}),e.addProperty(c.WEEKDAYS_MEDIUM.key,{value:c.WEEKDAYS_MEDIUM.value,handler:this.delegateConfig}),e.addProperty(c.WEEKDAYS_LONG.key,{value:c.WEEKDAYS_LONG.value,handler:this.delegateConfig}),e.addProperty(c.LOCALE_MONTHS.key,{value:c.LOCALE_MONTHS.value,handler:this.delegateConfig}),e.addProperty(c.LOCALE_WEEKDAYS.key,{value:c.LOCALE_WEEKDAYS.value,handler:this.delegateConfig}),e.addProperty(c.DATE_DELIMITER.key,{value:c.DATE_DELIMITER.value,handler:this.delegateConfig}),e.addProperty(c.DATE_FIELD_DELIMITER.key,{value:c.DATE_FIELD_DELIMITER.value,handler:this.delegateConfig}),e.addProperty(c.DATE_RANGE_DELIMITER.key,{value:c.DATE_RANGE_DELIMITER.value,handler:this.delegateConfig}),e.addProperty(c.MY_MONTH_POSITION.key,{value:c.MY_MONTH_POSITION.value,handler:this.delegateConfig,validator:e.checkNumber}),e.addProperty(c.MY_YEAR_POSITION.key,{value:c.MY_YEAR_POSITION.value,handler:this.delegateConfig,validator:e.checkNumber}),e.addProperty(c.MD_MONTH_POSITION.key,{value:c.MD_MONTH_POSITION.value,handler:this.delegateConfig,validator:e.checkNumber}),e.addProperty(c.MD_DAY_POSITION.key,{value:c.MD_DAY_POSITION.value,handler:this.delegateConfig,validator:e.checkNumber}),e.addProperty(c.MDY_MONTH_POSITION.key,{value:c.MDY_MONTH_POSITION.value,handler:this.delegateConfig,validator:e.checkNumber}),e.addProperty(c.MDY_DAY_POSITION.key,{value:c.MDY_DAY_POSITION.value,handler:this.delegateConfig,validator:e.checkNumber}),e.addProperty(c.MDY_YEAR_POSITION.key,{value:c.MDY_YEAR_POSITION.value,handler:this.delegateConfig,validator:e.checkNumber}),e.addProperty(c.MY_LABEL_MONTH_POSITION.key,{value:c.MY_LABEL_MONTH_POSITION.value,handler:this.delegateConfig,validator:e.checkNumber}),e.addProperty(c.MY_LABEL_YEAR_POSITION.key,{value:c.MY_LABEL_YEAR_POSITION.value,handler:this.delegateConfig,validator:e.checkNumber}),e.addProperty(c.MY_LABEL_MONTH_SUFFIX.key,{value:c.MY_LABEL_MONTH_SUFFIX.value,handler:this.delegateConfig}),e.addProperty(c.MY_LABEL_YEAR_SUFFIX.key,{value:c.MY_LABEL_YEAR_SUFFIX.value,handler:this.delegateConfig}),e.addProperty(c.NAV.key,{value:c.NAV.value,handler:this.configNavigator}),e.addProperty(c.STRINGS.key,{value:c.STRINGS.value,handler:this.configStrings,validator:function(e){return t.isObject(e)},supercedes:c.STRINGS.supercedes})},initEvents:function(){var r=this,a="Event",e=YAHOO.util.CustomEvent,t=function(e,t,n){for(var i=0;i<r.pages.length;++i)r.pages[i][this.type+a].subscribe(e,t,n)},n=function(e,t){for(var n=0;n<r.pages.length;++n)r.pages[n][this.type+a].unsubscribe(e,t)},i=s._EVENT_TYPES;r.beforeSelectEvent=new e(i.BEFORE_SELECT),r.beforeSelectEvent.subscribe=t,r.beforeSelectEvent.unsubscribe=n,r.selectEvent=new e(i.SELECT),r.selectEvent.subscribe=t,r.selectEvent.unsubscribe=n,r.beforeDeselectEvent=new e(i.BEFORE_DESELECT),r.beforeDeselectEvent.subscribe=t,r.beforeDeselectEvent.unsubscribe=n,r.deselectEvent=new e(i.DESELECT),r.deselectEvent.subscribe=t,r.deselectEvent.unsubscribe=n,r.changePageEvent=new e(i.CHANGE_PAGE),r.changePageEvent.subscribe=t,r.changePageEvent.unsubscribe=n,r.beforeRenderEvent=new e(i.BEFORE_RENDER),r.beforeRenderEvent.subscribe=t,r.beforeRenderEvent.unsubscribe=n,r.renderEvent=new e(i.RENDER),r.renderEvent.subscribe=t,r.renderEvent.unsubscribe=n,r.resetEvent=new e(i.RESET),r.resetEvent.subscribe=t,r.resetEvent.unsubscribe=n,r.clearEvent=new e(i.CLEAR),r.clearEvent.subscribe=t,r.clearEvent.unsubscribe=n,r.beforeShowEvent=new e(i.BEFORE_SHOW),r.showEvent=new e(i.SHOW),r.beforeHideEvent=new e(i.BEFORE_HIDE),r.hideEvent=new e(i.HIDE),r.beforeShowNavEvent=new e(i.BEFORE_SHOW_NAV),r.showNavEvent=new e(i.SHOW_NAV),r.beforeHideNavEvent=new e(i.BEFORE_HIDE_NAV),r.hideNavEvent=new e(i.HIDE_NAV),r.beforeRenderNavEvent=new e(i.BEFORE_RENDER_NAV),r.renderNavEvent=new e(i.RENDER_NAV),r.beforeDestroyEvent=new e(i.BEFORE_DESTROY),r.destroyEvent=new e(i.DESTROY)},configPages:function(e,t,n){for(var i=t[0],r=c.PAGEDATE.key,a=null,s=0;s<i;++s){var l=this.id+"_"+s,o=this.containerId+"_"+s,h=this.cfg.getConfig(),E=(h.close=!1,h.title=!1,h.navigator=null,0<s&&(E=new Date(a),this._setMonthOnDate(E,E.getMonth()+s),h.pageDate=E),this.constructChild(l,o,h));d.removeClass(E.oDomContainer,this.Style.CSS_SINGLE),d.addClass(E.oDomContainer,"groupcal"),0===s&&(a=E.cfg.getProperty(r),d.addClass(E.oDomContainer,"first-of-type")),s==i-1&&d.addClass(E.oDomContainer,"last-of-type"),E.parent=this,E.index=s,this.pages[this.pages.length]=E}},configPageDate:function(e,t,n){for(var i,r=t[0],a=c.PAGEDATE.key,s=0;s<this.pages.length;++s){var l,o=this.pages[s];0===s?(i=o._parsePageDate(r),o.cfg.setProperty(a,i)):(l=new Date(i),this._setMonthOnDate(l,l.getMonth()+s),o.cfg.setProperty(a,l))}},configSelected:function(e,t,n){var i=c.SELECTED.key,e=(this.delegateConfig(e,t,n),0<this.pages.length?this.pages[0].cfg.getProperty(i):[]);this.cfg.setProperty(i,e,!0)},delegateConfig:function(e,t,n){for(var i=t[0],r=0;r<this.pages.length;r++)this.pages[r].cfg.setProperty(e,i)},setChildFunction:function(e,t){for(var n=this.cfg.getProperty(c.PAGES.key),i=0;i<n;++i)this.pages[i][e]=t},callChildFunction:function(e,t){for(var n=this.cfg.getProperty(c.PAGES.key),i=0;i<n;++i){var r=this.pages[i];r[e]&&r[e].call(r,t)}},constructChild:function(e,t,n){var i=document.getElementById(t);return i||((i=document.createElement("div")).id=t,this.oDomContainer.appendChild(i)),new s(e,t,n)},setMonth:function(e){e=parseInt(e,10);for(var t,n=c.PAGEDATE.key,i=0;i<this.pages.length;++i){var r=this.pages[i],a=r.cfg.getProperty(n);0===i?t=a.getFullYear():a.setFullYear(t),this._setMonthOnDate(a,e+i),r.cfg.setProperty(n,a)}},setYear:function(e){var t=c.PAGEDATE.key;e=parseInt(e,10);for(var n=0;n<this.pages.length;++n){var i=this.pages[n];i.cfg.getProperty(t).getMonth()+1==1&&0<n&&(e+=1),i.setYear(e)}},render:function(){this.renderHeader();for(var e=0;e<this.pages.length;++e)this.pages[e].render();this.renderFooter()},select:function(e){for(var t=0;t<this.pages.length;++t)this.pages[t].select(e);return this.getSelectedDates()},selectCell:function(e){for(var t=0;t<this.pages.length;++t)this.pages[t].selectCell(e);return this.getSelectedDates()},deselect:function(e){for(var t=0;t<this.pages.length;++t)this.pages[t].deselect(e);return this.getSelectedDates()},deselectAll:function(){for(var e=0;e<this.pages.length;++e)this.pages[e].deselectAll();return this.getSelectedDates()},deselectCell:function(e){for(var t=0;t<this.pages.length;++t)this.pages[t].deselectCell(e);return this.getSelectedDates()},reset:function(){for(var e=0;e<this.pages.length;++e)this.pages[e].reset()},clear:function(){for(var e=0;e<this.pages.length;++e)this.pages[e].clear();this.cfg.setProperty(c.SELECTED.key,[]),this.cfg.setProperty(c.PAGEDATE.key,new Date(this.pages[0].today.getTime())),this.render()},nextMonth:function(){for(var e=0;e<this.pages.length;++e)this.pages[e].nextMonth()},previousMonth:function(){for(var e=this.pages.length-1;0<=e;--e)this.pages[e].previousMonth()},nextYear:function(){for(var e=0;e<this.pages.length;++e)this.pages[e].nextYear()},previousYear:function(){for(var e=0;e<this.pages.length;++e)this.pages[e].previousYear()},getSelectedDates:function(){for(var e=[],t=this.cfg.getProperty(c.SELECTED.key),n=0;n<t.length;++n){var i=t[n],i=r.getDate(i[0],i[1]-1,i[2]);e.push(i)}return e.sort(function(e,t){return e-t}),e},addRenderer:function(e,t){for(var n=0;n<this.pages.length;++n)this.pages[n].addRenderer(e,t)},addMonthRenderer:function(e,t){for(var n=0;n<this.pages.length;++n)this.pages[n].addMonthRenderer(e,t)},addWeekdayRenderer:function(e,t){for(var n=0;n<this.pages.length;++n)this.pages[n].addWeekdayRenderer(e,t)},removeRenderers:function(){this.callChildFunction("removeRenderers")},renderHeader:function(){},renderFooter:function(){},addMonths:function(e){this.callChildFunction("addMonths",e)},subtractMonths:function(e){this.callChildFunction("subtractMonths",e)},addYears:function(e){this.callChildFunction("addYears",e)},subtractYears:function(e){this.callChildFunction("subtractYears",e)},getCalendarPage:function(e){var t=null;if(e)for(var n=e.getFullYear(),i=e.getMonth(),r=this.pages,a=0;a<r.length;++a){var s=r[a].cfg.getProperty("pagedate");if(s.getFullYear()===n&&s.getMonth()===i){t=r[a];break}}return t},_setMonthOnDate:function(e,t){var n;YAHOO.env.ua.webkit&&YAHOO.env.ua.webkit<420&&(t<0||11<t)?(n=r.add(e,r.MONTH,t-e.getMonth()),e.setTime(n.getTime())):e.setMonth(t)},_fixWidth:function(){for(var e=0,t=0;t<this.pages.length;++t)e+=this.pages[t].oDomContainer.offsetWidth;0<e&&(this.oDomContainer.style.width=e+"px")},toString:function(){return"CalendarGroup "+this.id},destroy:function(){if(this.beforeDestroyEvent.fire()){var e=this;e.navigator&&e.navigator.destroy(),e.cfg&&e.cfg.destroy(),i.purgeElement(e.oDomContainer,!0),d.removeClass(e.oDomContainer,a.CSS_CONTAINER),d.removeClass(e.oDomContainer,a.CSS_MULTI_UP);for(var t=0,n=e.pages.length;t<n;t++)e.pages[t].destroy(),e.pages[t]=null;e.oDomContainer.innerHTML="",e.oDomContainer=null,this.destroyEvent.fire()}}},a.CSS_CONTAINER="yui-calcontainer",a.CSS_MULTI_UP="multi",a.CSS_2UPTITLE="title",a.CSS_2UPCLOSE="close-icon",YAHOO.lang.augmentProto(a,s,"buildDayLabel","buildMonthLabel","renderOutOfBoundsDate","renderRowHeader","renderRowFooter","renderCellDefault","styleCellDefault","renderCellStyleHighlight1","renderCellStyleHighlight2","renderCellStyleHighlight3","renderCellStyleHighlight4","renderCellStyleToday","renderCellStyleSelected","renderCellNotThisMonth","styleCellNotThisMonth","renderBodyCellRestricted","initStyles","configTitle","configClose","configIframe","configStrings","configToday","configNavigator","createTitleBar","createCloseButton","removeTitleBar","removeCloseButton","hide","show","toDate","_toDate","_parseArgs","browser"),YAHOO.widget.CalGrp=a,YAHOO.widget.CalendarGroup=a,YAHOO.widget.Calendar2up=function(e,t,n){this.init(e,t,n)},YAHOO.extend(YAHOO.widget.Calendar2up,a),YAHOO.widget.Cal2up=YAHOO.widget.Calendar2up}(),YAHOO.widget.CalendarNavigator=function(e){this.init(e)},function(){var e=YAHOO.widget.CalendarNavigator;e.CLASSES={NAV:"yui-cal-nav",NAV_VISIBLE:"yui-cal-nav-visible",MASK:"yui-cal-nav-mask",YEAR:"yui-cal-nav-y",MONTH:"yui-cal-nav-m",BUTTONS:"yui-cal-nav-b",BUTTON:"yui-cal-nav-btn",ERROR:"yui-cal-nav-e",YEAR_CTRL:"yui-cal-nav-yc",MONTH_CTRL:"yui-cal-nav-mc",INVALID:"yui-invalid",DEFAULT:"yui-default"},e.DEFAULT_CONFIG={strings:{month:"Month",year:"Year",submit:"Okay",cancel:"Cancel",invalidYear:"Year needs to be a number"},monthFormat:YAHOO.widget.Calendar.LONG,initialFocus:"year"},e._DEFAULT_CFG=e.DEFAULT_CONFIG,e.ID_SUFFIX="_nav",e.MONTH_SUFFIX="_month",e.YEAR_SUFFIX="_year",e.ERROR_SUFFIX="_error",e.CANCEL_SUFFIX="_cancel",e.SUBMIT_SUFFIX="_submit",e.YR_MAX_DIGITS=4,e.YR_MINOR_INC=1,e.YR_MAJOR_INC=10,e.UPDATE_DELAY=50,e.YR_PATTERN=/^\d+$/,e.TRIM=/^\s*(.*?)\s*$/}(),YAHOO.widget.CalendarNavigator.prototype={id:null,cal:null,navEl:null,maskEl:null,yearEl:null,monthEl:null,errorEl:null,submitEl:null,cancelEl:null,firstCtrl:null,lastCtrl:null,_doc:null,_year:null,_month:0,__rendered:!1,init:function(e){var t=e.oDomContainer,e=(this.cal=e,this.id=t.id+YAHOO.widget.CalendarNavigator.ID_SUFFIX,this._doc=t.ownerDocument,YAHOO.env.ua.ie);this.__isIEQuirks=e&&(e<=6||"BackCompat"==this._doc.compatMode)},show:function(){var e=YAHOO.widget.CalendarNavigator.CLASSES;this.cal.beforeShowNavEvent.fire()&&(this.__rendered||this.render(),this.clearErrors(),this._updateMonthUI(),this._updateYearUI(),this._show(this.navEl,!0),this.setInitialFocus(),this.showMask(),YAHOO.util.Dom.addClass(this.cal.oDomContainer,e.NAV_VISIBLE),this.cal.showNavEvent.fire())},hide:function(){var e=YAHOO.widget.CalendarNavigator.CLASSES;this.cal.beforeHideNavEvent.fire()&&(this._show(this.navEl,!1),this.hideMask(),YAHOO.util.Dom.removeClass(this.cal.oDomContainer,e.NAV_VISIBLE),this.cal.hideNavEvent.fire())},showMask:function(){this._show(this.maskEl,!0),this.__isIEQuirks&&this._syncMask()},hideMask:function(){this._show(this.maskEl,!1)},getMonth:function(){return this._month},getYear:function(){return this._year},setMonth:function(e){0<=e&&e<12&&(this._month=e),this._updateMonthUI()},setYear:function(e){var t=YAHOO.widget.CalendarNavigator.YR_PATTERN;YAHOO.lang.isNumber(e)&&t.test(e+"")&&(this._year=e),this._updateYearUI()},render:function(){this.cal.beforeRenderNavEvent.fire(),this.__rendered||(this.createNav(),this.createMask(),this.applyListeners(),this.__rendered=!0),this.cal.renderNavEvent.fire()},createNav:function(){var e=YAHOO.widget.CalendarNavigator,t=this._doc,n=t.createElement("div"),i=(n.className=e.CLASSES.NAV,this.renderNavContents([]));n.innerHTML=i.join(""),this.cal.oDomContainer.appendChild(n),this.navEl=n,this.yearEl=t.getElementById(this.id+e.YEAR_SUFFIX),this.monthEl=t.getElementById(this.id+e.MONTH_SUFFIX),this.errorEl=t.getElementById(this.id+e.ERROR_SUFFIX),this.submitEl=t.getElementById(this.id+e.SUBMIT_SUFFIX),this.cancelEl=t.getElementById(this.id+e.CANCEL_SUFFIX),YAHOO.env.ua.gecko&&this.yearEl&&"text"==this.yearEl.type&&this.yearEl.setAttribute("autocomplete","off"),this._setFirstLastElements()},createMask:function(){var e=YAHOO.widget.CalendarNavigator.CLASSES,t=this._doc.createElement("div");t.className=e.MASK,this.cal.oDomContainer.appendChild(t),this.maskEl=t},_syncMask:function(){var e=this.cal.oDomContainer;e&&this.maskEl&&(e=YAHOO.util.Dom.getRegion(e),YAHOO.util.Dom.setStyle(this.maskEl,"width",e.right-e.left+"px"),YAHOO.util.Dom.setStyle(this.maskEl,"height",e.bottom-e.top+"px"))},renderNavContents:function(e){var t=YAHOO.widget.CalendarNavigator,n=t.CLASSES;return e[e.length]='<div class="'+n.MONTH+'">',this.renderMonth(e),e[e.length]="</div>",e[e.length]='<div class="'+n.YEAR+'">',this.renderYear(e),e[e.length]="</div>",e[e.length]='<div class="'+n.BUTTONS+'">',this.renderButtons(e),e[e.length]="</div>",e[e.length]='<div class="'+n.ERROR+'" id="'+this.id+t.ERROR_SUFFIX+'"></div>',e},renderMonth:function(e){var t=YAHOO.widget.CalendarNavigator,n=t.CLASSES,t=this.id+t.MONTH_SUFFIX,i=this.__getCfg("monthFormat"),r=this.cal.cfg.getProperty(i==YAHOO.widget.Calendar.SHORT?"MONTHS_SHORT":"MONTHS_LONG"),a=e;if(r&&0<r.length){a[a.length]='<label for="'+t+'">',a[a.length]=this.__getCfg("month",!0),a[a.length]="</label>",a[a.length]='<select name="'+t+'" id="'+t+'" class="'+n.MONTH_CTRL+'">';for(var s=0;s<r.length;s++)a[a.length]='<option value="'+s+'">',a[a.length]=r[s],a[a.length]="</option>";a[a.length]="</select>"}return a},renderYear:function(e){var t=YAHOO.widget.CalendarNavigator,n=t.CLASSES,i=this.id+t.YEAR_SUFFIX,t=t.YR_MAX_DIGITS;return e[e.length]='<label for="'+i+'">',e[e.length]=this.__getCfg("year",!0),e[e.length]="</label>",e[e.length]='<input type="text" name="'+i+'" id="'+i+'" class="'+n.YEAR_CTRL+'" maxlength="'+t+'"/>',e},renderButtons:function(e){var t=YAHOO.widget.CalendarNavigator.CLASSES;return e[e.length]='<span class="'+t.BUTTON+" "+t.DEFAULT+'">',e[e.length]='<button type="button" id="'+this.id+'_submit">',e[e.length]=this.__getCfg("submit",!0),e[e.length]="</button>",e[e.length]="</span>",e[e.length]='<span class="'+t.BUTTON+'">',e[e.length]='<button type="button" id="'+this.id+'_cancel">',e[e.length]=this.__getCfg("cancel",!0),e[e.length]="</button>",e[e.length]="</span>",e},applyListeners:function(){var e=YAHOO.util.Event;e.on(this.submitEl,"click",this.submit,this,!0),e.on(this.cancelEl,"click",this.cancel,this,!0),e.on(this.yearEl,"blur",function(){this.validate()&&this.setYear(this._getYearFromUI())},this,!0),e.on(this.monthEl,"change",function(){this.setMonth(this._getMonthFromUI())},this,!0),this.__isIEQuirks&&YAHOO.util.Event.on(this.cal.oDomContainer,"resize",this._syncMask,this,!0),this.applyKeyListeners()},purgeListeners:function(){var e=YAHOO.util.Event;e.removeListener(this.submitEl,"click",this.submit),e.removeListener(this.cancelEl,"click",this.cancel),e.removeListener(this.yearEl,"blur"),e.removeListener(this.monthEl,"change"),this.__isIEQuirks&&e.removeListener(this.cal.oDomContainer,"resize",this._syncMask),this.purgeKeyListeners()},applyKeyListeners:function(){var e=YAHOO.util.Event,t=YAHOO.env.ua,n=t.ie||t.webkit?"keydown":"keypress",t=t.ie||t.opera||t.webkit?"keydown":"keypress";e.on(this.yearEl,"keypress",this._handleEnterKey,this,!0),e.on(this.yearEl,n,this._handleDirectionKeys,this,!0),e.on(this.lastCtrl,t,this._handleTabKey,this,!0),e.on(this.firstCtrl,t,this._handleShiftTabKey,this,!0)},purgeKeyListeners:function(){var e=YAHOO.util.Event,t=YAHOO.env.ua,n=t.ie||t.webkit?"keydown":"keypress",t=t.ie||t.opera||t.webkit?"keydown":"keypress";e.removeListener(this.yearEl,"keypress",this._handleEnterKey),e.removeListener(this.yearEl,n,this._handleDirectionKeys),e.removeListener(this.lastCtrl,t,this._handleTabKey),e.removeListener(this.firstCtrl,t,this._handleShiftTabKey)},submit:function(){var e,t,n;this.validate()&&(this.hide(),this.setMonth(this._getMonthFromUI()),this.setYear(this._getYearFromUI()),e=this.cal,0<(t=YAHOO.widget.CalendarNavigator.UPDATE_DELAY)?(n=this,window.setTimeout(function(){n._update(e)},t)):this._update(e))},_update:function(e){var t=YAHOO.widget.DateMath.getDate(this.getYear()-e.cfg.getProperty("YEAR_OFFSET"),this.getMonth(),1);e.cfg.setProperty("pagedate",t),e.render()},cancel:function(){this.hide()},validate:function(){return null!==this._getYearFromUI()?(this.clearErrors(),!0):(this.setYearError(),this.setError(this.__getCfg("invalidYear",!0)),!1)},setError:function(e){this.errorEl&&(this.errorEl.innerHTML=e,this._show(this.errorEl,!0))},clearError:function(){this.errorEl&&(this.errorEl.innerHTML="",this._show(this.errorEl,!1))},setYearError:function(){YAHOO.util.Dom.addClass(this.yearEl,YAHOO.widget.CalendarNavigator.CLASSES.INVALID)},clearYearError:function(){YAHOO.util.Dom.removeClass(this.yearEl,YAHOO.widget.CalendarNavigator.CLASSES.INVALID)},clearErrors:function(){this.clearError(),this.clearYearError()},setInitialFocus:function(){var e=this.submitEl,t=this.__getCfg("initialFocus");if(t&&t.toLowerCase)if("year"==(t=t.toLowerCase())){e=this.yearEl;try{this.yearEl.select()}catch(n){}}else"month"==t&&(e=this.monthEl);if(e&&YAHOO.lang.isFunction(e.focus))try{e.focus()}catch(i){}},erase:function(){var e;this.__rendered&&(this.purgeListeners(),this.yearEl=null,this.monthEl=null,this.errorEl=null,this.submitEl=null,this.cancelEl=null,this.firstCtrl=null,this.lastCtrl=null,this.navEl&&(this.navEl.innerHTML=""),(e=this.navEl.parentNode)&&e.removeChild(this.navEl),this.navEl=null,(e=this.maskEl.parentNode)&&e.removeChild(this.maskEl),this.maskEl=null,this.__rendered=!1)},destroy:function(){this.erase(),this._doc=null,this.cal=null,this.id=null},_show:function(e,t){e&&YAHOO.util.Dom.setStyle(e,"display",t?"block":"none")},_getMonthFromUI:function(){return this.monthEl?this.monthEl.selectedIndex:0},_getYearFromUI:function(){var e,t=YAHOO.widget.CalendarNavigator,n=null;return n=this.yearEl&&(e=(e=this.yearEl.value).replace(t.TRIM,"$1"),t.YR_PATTERN.test(e))?parseInt(e,10):n},_updateYearUI:function(){this.yearEl&&null!==this._year&&(this.yearEl.value=this._year)},_updateMonthUI:function(){this.monthEl&&(this.monthEl.selectedIndex=this._month)},_setFirstLastElements:function(){this.firstCtrl=this.monthEl,this.lastCtrl=this.cancelEl,this.__isMac&&(YAHOO.env.ua.webkit&&YAHOO.env.ua.webkit<420&&(this.firstCtrl=this.monthEl,this.lastCtrl=this.yearEl),YAHOO.env.ua.gecko)&&(this.firstCtrl=this.yearEl,this.lastCtrl=this.yearEl)},_handleEnterKey:function(e){var t=YAHOO.util.KeyListener.KEY;YAHOO.util.Event.getCharCode(e)==t.ENTER&&(YAHOO.util.Event.preventDefault(e),this.submit())},_handleDirectionKeys:function(e){var t=YAHOO.util.Event,n=YAHOO.util.KeyListener.KEY,i=YAHOO.widget.CalendarNavigator,r=this.yearEl.value?parseInt(this.yearEl.value,10):null;if(isFinite(r)){var a=!1;switch(t.getCharCode(e)){case n.UP:this.yearEl.value=r+i.YR_MINOR_INC,a=!0;break;case n.DOWN:this.yearEl.value=Math.max(r-i.YR_MINOR_INC,0),a=!0;break;case n.PAGE_UP:this.yearEl.value=r+i.YR_MAJOR_INC,a=!0;break;case n.PAGE_DOWN:this.yearEl.value=Math.max(r-i.YR_MAJOR_INC,0),a=!0}if(a){t.preventDefault(e);try{this.yearEl.select()}catch(s){}}}},_handleTabKey:function(e){var t=YAHOO.util.Event,n=YAHOO.util.KeyListener.KEY;if(t.getCharCode(e)==n.TAB&&!e.shiftKey)try{t.preventDefault(e),this.firstCtrl.focus()}catch(i){}},_handleShiftTabKey:function(e){var t=YAHOO.util.Event,n=YAHOO.util.KeyListener.KEY;if(e.shiftKey&&t.getCharCode(e)==n.TAB)try{t.preventDefault(e),this.lastCtrl.focus()}catch(i){}},__getCfg:function(e,t){var n=YAHOO.widget.CalendarNavigator.DEFAULT_CONFIG,i=this.cal.cfg.getProperty("navigator");return(t?(!0!==i&&i.strings&&i.strings[e]?i:n).strings:!0!==i&&i[e]?i:n)[e]},__isMac:-1!=navigator.userAgent.toLowerCase().indexOf("macintosh")},YAHOO.register("calendar",YAHOO.widget.Calendar,{version:"2.9.0",build:"2800"});
//# sourceMappingURL=calendar.js.map;
YAHOO.namespace("util"),YAHOO.util.Cookie={_createCookieString:function(e,n,o,t){var i=YAHOO.lang,e=encodeURIComponent(e)+"="+(o?encodeURIComponent(n):n);return i.isObject(t)&&(t.expires instanceof Date&&(e+="; expires="+t.expires.toUTCString()),i.isString(t.path)&&""!==t.path&&(e+="; path="+t.path),i.isString(t.domain)&&""!==t.domain&&(e+="; domain="+t.domain),!0===t.secure)&&(e+="; secure"),e},_createCookieHashString:function(e){var n=YAHOO.lang;if(!n.isObject(e))throw new TypeError("Cookie._createCookieHashString(): Argument must be an object.");var o,t=[];for(o in e)!n.hasOwnProperty(e,o)||n.isFunction(e[o])||n.isUndefined(e[o])||t.push(encodeURIComponent(o)+"="+encodeURIComponent(String(e[o])));return t.join("&")},_parseCookieHash:function(e){var n,o=e.split("&"),t={};if(0<e.length)for(var i=0,r=o.length;i<r;i++)n=o[i].split("="),t[decodeURIComponent(n[0])]=decodeURIComponent(n[1]);return t},_parseCookieString:function(e,n){var o={};if(YAHOO.lang.isString(e)&&0<e.length)for(var t,i=!1===n?function(e){return e}:decodeURIComponent,r=e.split(/;\s/g),s=null,u=null,a=0,g=r.length;a<g;a++){if((t=r[a].match(/([^=]+)=/i))instanceof Array)try{s=decodeURIComponent(t[1]),u=i(r[a].substring(t[1].length+1))}catch(c){}else s=decodeURIComponent(r[a]),u="";o[s]=u}return o},exists:function(e){if(YAHOO.lang.isString(e)&&""!==e)return this._parseCookieString(document.cookie,!0).hasOwnProperty(e);throw new TypeError("Cookie.exists(): Cookie name must be a non-empty string.")},get:function(e,n){var o,t=YAHOO.lang,n=(t.isFunction(n)?(o=n,n={}):t.isObject(n)?o=n.converter:n={},this._parseCookieString(document.cookie,!n.raw));if(t.isString(e)&&""!==e)return t.isUndefined(n[e])?null:t.isFunction(o)?o(n[e]):n[e];throw new TypeError("Cookie.get(): Cookie name must be a non-empty string.")},getSub:function(e,n,o){var t=YAHOO.lang,e=this.getSubs(e);if(null===e)return null;if(t.isString(n)&&""!==n)return t.isUndefined(e[n])?null:t.isFunction(o)?o(e[n]):e[n];throw new TypeError("Cookie.getSub(): Subcookie name must be a non-empty string.")},getSubs:function(e){var n,o=YAHOO.lang.isString;if(o(e)&&""!==e)return o((n=this._parseCookieString(document.cookie,!1))[e])?this._parseCookieHash(n[e]):null;throw new TypeError("Cookie.getSubs(): Cookie name must be a non-empty string.")},remove:function(e,n){if(YAHOO.lang.isString(e)&&""!==e)return n=YAHOO.lang.merge(n||{},{expires:new Date(0)}),this.set(e,"",n);throw new TypeError("Cookie.remove(): Cookie name must be a non-empty string.")},removeSub:function(e,n,o){var t=YAHOO.lang;if(o=o||{},!t.isString(e)||""===e)throw new TypeError("Cookie.removeSub(): Cookie name must be a non-empty string.");if(!t.isString(n)||""===n)throw new TypeError("Cookie.removeSub(): Subcookie name must be a non-empty string.");var i=this.getSubs(e);if(t.isObject(i)&&t.hasOwnProperty(i,n)){if(delete i[n],o.removeIfEmpty){for(var r in i)if(t.hasOwnProperty(i,r)&&!t.isFunction(i[r])&&!t.isUndefined(i[r]))return this.setSubs(e,i,o);return this.remove(e,o)}return this.setSubs(e,i,o)}return""},set:function(e,n,o){var t=YAHOO.lang;if(o=o||{},!t.isString(e))throw new TypeError("Cookie.set(): Cookie name must be a string.");if(t.isUndefined(n))throw new TypeError("Cookie.set(): Value cannot be undefined.");t=this._createCookieString(e,n,!o.raw,o);return document.cookie=t},setSub:function(e,n,o,t){var i=YAHOO.lang;if(!i.isString(e)||""===e)throw new TypeError("Cookie.setSub(): Cookie name must be a non-empty string.");if(!i.isString(n)||""===n)throw new TypeError("Cookie.setSub(): Subcookie name must be a non-empty string.");if(i.isUndefined(o))throw new TypeError("Cookie.setSub(): Subcookie value cannot be undefined.");var r=this.getSubs(e);return(r=i.isObject(r)?r:{})[n]=o,this.setSubs(e,r,t)},setSubs:function(e,n,o){var t=YAHOO.lang;if(!t.isString(e))throw new TypeError("Cookie.setSubs(): Cookie name must be a string.");if(t.isObject(n))return t=this._createCookieString(e,this._createCookieHashString(n),!1,o),document.cookie=t;throw new TypeError("Cookie.setSubs(): Cookie value must be an object.")}},YAHOO.register("cookie",YAHOO.util.Cookie,{version:"2.9.0",build:"2800"});
//# sourceMappingURL=cookie.js.map;
YAHOO.util.Connect={_msxml_progid:["Microsoft.XMLHTTP","MSXML2.XMLHTTP.3.0","MSXML2.XMLHTTP"],_http_headers:{},_has_http_headers:!1,_use_default_post_header:!0,_default_post_header:"application/x-www-form-urlencoded; charset=UTF-8",_default_form_header:"application/x-www-form-urlencoded",_use_default_xhr_header:!0,_default_xhr_header:"XMLHttpRequest",_has_default_headers:!0,_isFormSubmit:!1,_default_headers:{},_poll:{},_timeOut:{},_polling_interval:50,_transaction_id:0,startEvent:new YAHOO.util.CustomEvent("start"),completeEvent:new YAHOO.util.CustomEvent("complete"),successEvent:new YAHOO.util.CustomEvent("success"),failureEvent:new YAHOO.util.CustomEvent("failure"),abortEvent:new YAHOO.util.CustomEvent("abort"),_customEvents:{onStart:["startEvent","start"],onComplete:["completeEvent","complete"],onSuccess:["successEvent","success"],onFailure:["failureEvent","failure"],onUpload:["uploadEvent","upload"],onAbort:["abortEvent","abort"]},setProgId:function(e){this._msxml_progid.unshift(e)},setDefaultPostHeader:function(e){"string"==typeof e?(this._default_post_header=e,this._use_default_post_header=!0):"boolean"==typeof e&&(this._use_default_post_header=e)},setDefaultXhrHeader:function(e){"string"==typeof e?this._default_xhr_header=e:this._use_default_xhr_header=e},setPollingInterval:function(e){"number"==typeof e&&isFinite(e)&&(this._polling_interval=e)},createXhrObject:function(e){var t,n;try{t={conn:new XMLHttpRequest,tId:e,xhr:!0}}catch(s){for(n=0;n<this._msxml_progid.length;++n)try{t={conn:new ActiveXObject(this._msxml_progid[n]),tId:e,xhr:!0};break}catch(o){}}finally{return t}},getConnectionObject:function(e){var t,n=this._transaction_id;try{e?(t={tId:n},"xdr"===e?(t.conn=this._transport,t.xdr=!0):"upload"===e&&(t.upload=!0)):t=this.createXhrObject(n),t&&this._transaction_id++}catch(s){}return t},asyncRequest:function(e,t,n,s){var o,a,i=n&&n.argument?n.argument:null,r=this;if(this._isFileUpload?a="upload":n&&n.xdr&&(a="xdr"),o=this.getConnectionObject(a)){if(n&&n.customevents&&this.initCustomEvents(o,n),this._isFormSubmit){if(this._isFileUpload)return window.setTimeout(function(){r.uploadFile(o,n,t,s)},10),o;"GET"==e.toUpperCase()?0!==this._sFormData.length&&(t+=(-1==t.indexOf("?")?"?":"&")+this._sFormData):"POST"==e.toUpperCase()&&(s=s?this._sFormData+"&"+s:this._sFormData)}return"GET"==e.toUpperCase()&&n&&!1===n.cache&&(t+=(-1==t.indexOf("?")?"?":"&")+"rnd="+(new Date).valueOf().toString()),this._use_default_xhr_header&&!this._default_headers["X-Requested-With"]&&this.initHeader("X-Requested-With",this._default_xhr_header,!0),"POST"===e.toUpperCase()&&this._use_default_post_header&&!1===this._isFormSubmit&&this.initHeader("Content-Type",this._default_post_header),o.xdr?this.xdr(o,e,t,n,s):(o.conn.open(e,t,!0),(this._has_default_headers||this._has_http_headers)&&this.setHeader(o),this.handleReadyState(o,n),o.conn.send(s||""),!0===this._isFormSubmit&&this.resetFormState(),this.startEvent.fire(o,i),o.startEvent&&o.startEvent.fire(o,i)),o}return null},initCustomEvents:function(e,t){for(var n in t.customevents)this._customEvents[n][0]&&(e[this._customEvents[n][0]]=new YAHOO.util.CustomEvent(this._customEvents[n][1],t.scope||null),e[this._customEvents[n][0]].subscribe(t.customevents[n]))},handleReadyState:function(e,t){var n=this,s=t&&t.argument?t.argument:null;t&&t.timeout&&(this._timeOut[e.tId]=window.setTimeout(function(){n.abort(e,t,!0)},t.timeout)),this._poll[e.tId]=window.setInterval(function(){e.conn&&4===e.conn.readyState&&(window.clearInterval(n._poll[e.tId]),delete n._poll[e.tId],t&&t.timeout&&(window.clearTimeout(n._timeOut[e.tId]),delete n._timeOut[e.tId]),n.completeEvent.fire(e,s),e.completeEvent&&e.completeEvent.fire(e,s),n.handleTransactionResponse(e,t))},this._polling_interval)},handleTransactionResponse:function(e,t,n){var s,o,a=t&&t.argument?t.argument:null,i=!(!e.r||"xdr:success"!==e.r.statusText),r=!(!e.r||"xdr:failure"!==e.r.statusText),u=n;try{s=e.conn.status!==undefined&&0!==e.conn.status||i?e.conn.status:r&&!u?0:13030}catch(d){s=13030}if(200<=s&&s<300||1223===s||i)o=e.xdr?e.r:this.createResponseObject(e,a),t&&t.success&&(t.scope?t.success.apply(t.scope,[o]):t.success(o)),this.successEvent.fire(o),e.successEvent&&e.successEvent.fire(o);else{switch(s){case 12002:case 12029:case 12030:case 12031:case 12152:case 13030:o=this.createExceptionObject(e.tId,a,n||!1),t&&t.failure&&(t.scope?t.failure.apply(t.scope,[o]):t.failure(o));break;default:o=e.xdr?e.response:this.createResponseObject(e,a),t&&t.failure&&(t.scope?t.failure.apply(t.scope,[o]):t.failure(o))}this.failureEvent.fire(o),e.failureEvent&&e.failureEvent.fire(o)}this.releaseObject(e)},createResponseObject:function(e,t){var n,s,o,a,i={},r={};try{for(o=(s=e.conn.getAllResponseHeaders()).split("\n"),n=0;n<o.length;n++)-1!=(a=o[n].indexOf(":"))&&(r[o[n].substring(0,a)]=YAHOO.lang.trim(o[n].substring(a+2)))}catch(u){}return i.tId=e.tId,i.status=1223==e.conn.status?204:e.conn.status,i.statusText=1223==e.conn.status?"No Content":e.conn.statusText,i.getResponseHeader=r,i.getAllResponseHeaders=s,i.responseText=e.conn.responseText,i.responseXML=e.conn.responseXML,t&&(i.argument=t),i},createExceptionObject:function(e,t,n){var s={};return s.tId=e,n?(s.status=-1,s.statusText="transaction aborted"):(s.status=0,s.statusText="communication failure"),t&&(s.argument=t),s},initHeader:function(e,t,n){(n?this._default_headers:this._http_headers)[e]=t,n?this._has_default_headers=!0:this._has_http_headers=!0},setHeader:function(e){if(this._has_default_headers)for(var t in this._default_headers)YAHOO.lang.hasOwnProperty(this._default_headers,t)&&e.conn.setRequestHeader(t,this._default_headers[t]);if(this._has_http_headers){for(t in this._http_headers)YAHOO.lang.hasOwnProperty(this._http_headers,t)&&e.conn.setRequestHeader(t,this._http_headers[t]);this._http_headers={},this._has_http_headers=!1}},resetDefaultHeaders:function(){this._default_headers={},this._has_default_headers=!1},abort:function(e,t,n){var s,o,a=t&&t.argument?t.argument:null;return(e=e||{}).conn?e.xhr?this.isCallInProgress(e)&&(e.conn.abort(),window.clearInterval(this._poll[e.tId]),delete this._poll[e.tId],n&&(window.clearTimeout(this._timeOut[e.tId]),delete this._timeOut[e.tId]),s=!0):e.xdr&&(e.conn.abort(e.tId),s=!0):e.upload?(o="yuiIO"+e.tId,(o=document.getElementById(o))&&(YAHOO.util.Event.removeListener(o,"load"),document.body.removeChild(o),n&&(window.clearTimeout(this._timeOut[e.tId]),delete this._timeOut[e.tId]),s=!0)):s=!1,!0===s&&(this.abortEvent.fire(e,a),e.abortEvent&&e.abortEvent.fire(e,a),this.handleTransactionResponse(e,t,!0)),s},isCallInProgress:function(e){return(e=e||{}).xhr&&e.conn?4!==e.conn.readyState&&0!==e.conn.readyState:e.xdr&&e.conn?e.conn.isCallInProgress(e.tId):!0===e.upload&&!!document.getElementById("yuiIO"+e.tId)},releaseObject:function(e){e&&e.conn&&(e.conn=null)}},function(){var a=YAHOO.util.Connect,i={};function t(e){var e='<object id="YUIConnectionSwf" type="application/x-shockwave-flash" data="'+e+'" width="0" height="0"><param name="movie" value="'+e+'"><param name="allowScriptAccess" value="always"></object>',t=document.createElement("div");document.body.appendChild(t),t.innerHTML=e}a.xdr=function(e,t,n,s,o){i[parseInt(e.tId)]={o:e,c:s},o&&(s.method=t,s.data=o),e.conn.send(n,s,e.tId)},a.swf=t,a.transport=function(e){t(e),a._transport=document.getElementById("YUIConnectionSwf")},a.xdrReadyEvent=new YAHOO.util.CustomEvent("xdrReady"),a.xdrReady=function(){a.xdrReadyEvent.fire()},a.handleXdrResponse=function(e){var t,n,s=i[e.tId].o,o=i[e.tId].c;"xdr:start"===e.statusText?(n=o,(t=s)&&(a.startEvent.fire(t,n.argument),t.startEvent)&&t.startEvent.fire(t,n.argument)):(e.responseText=decodeURI(e.responseText),s.r=e,o.argument&&(s.r.argument=o.argument),this.handleTransactionResponse(s,o,"xdr:abort"===e.statusText),delete i[e.tId])}}(),function(){var n=YAHOO.util.Connect,f=YAHOO.util.Event,v=document.documentMode||!1;n._isFileUpload=!1,n._formNode=null,n._sFormData=null,n._submitElementValue=null,n.uploadEvent=new YAHOO.util.CustomEvent("upload"),n._hasSubmitListener=!!f&&(f.addListener(document,"click",function(e){var e=f.getTarget(e),t=e.nodeName.toLowerCase();"input"!==t&&"button"!==t||!e.type||"submit"!=e.type.toLowerCase()||(n._submitElementValue=encodeURIComponent(e.name)+"="+encodeURIComponent(e.value))}),!0),n.setForm=function(e,t,n){var s,o,a,i,r,u,d,l,c,h,m=!1,_=[],p=0;if(this.resetFormState(),"string"==typeof e)s=document.getElementById(e)||document.forms[e];else{if("object"!=typeof e)return;s=e}if(!t){for(u=0,d=s.elements.length;u<d;++u)if(r=(o=s.elements[u]).disabled,a=o.name,!r&&a)switch(a=encodeURIComponent(a)+"=",i=encodeURIComponent(o.value),o.type){case"select-one":-1<o.selectedIndex&&(h=o.options[o.selectedIndex],_[p++]=a+encodeURIComponent(h.attributes.value&&h.attributes.value.specified?h.value:h.text));break;case"select-multiple":if(-1<o.selectedIndex)for(l=o.selectedIndex,c=o.options.length;l<c;++l)(h=o.options[l]).selected&&(_[p++]=a+encodeURIComponent(h.attributes.value&&h.attributes.value.specified?h.value:h.text));break;case"radio":case"checkbox":o.checked&&(_[p++]=a+i);break;case"file":case undefined:case"reset":case"button":break;case"submit":!1===m&&(this._hasSubmitListener&&this._submitElementValue&&(_[p++]=this._submitElementValue),m=!0);break;default:_[p++]=a+i}return this._isFormSubmit=!0,this._sFormData=_.join("&"),this.initHeader("Content-Type",this._default_form_header),this._sFormData}this.createFrame(n||null),this._isFormSubmit=!0,this._isFileUpload=!0,this._formNode=s},n.resetFormState=function(){this._isFormSubmit=!1,this._isFileUpload=!1,this._formNode=null,this._sFormData=""},n.createFrame=function(e){var t,n="yuiIO"+this._transaction_id;YAHOO.env.ua.ie&&!(9===v)?(t=document.createElement('<iframe id="'+n+'" name="'+n+'" />'),"boolean"==typeof e&&(t.src="javascript:false")):((t=document.createElement("iframe")).id=n,t.name=n),t.style.position="absolute",t.style.top="-1000px",t.style.left="-1000px",document.body.appendChild(t)},n.appendPostData=function(e){for(var t,n=[],s=e.split("&"),o=0;o<s.length;o++)-1!=(t=s[o].indexOf("="))&&(n[o]=document.createElement("input"),n[o].type="hidden",n[o].name=decodeURIComponent(s[o].substring(0,t)),n[o].value=decodeURIComponent(s[o].substring(t+1)),this._formNode.appendChild(n[o]));return n},n.uploadFile=function(o,a,e,t){var n,s,i,r,u,d="yuiIO"+o.tId,l="multipart/form-data",c=document.getElementById(d),h=8<=v,m=this,_=a&&a.argument?a.argument:null,p={action:this._formNode.getAttribute("action"),method:this._formNode.getAttribute("method"),target:this._formNode.getAttribute("target")};if(this._formNode.setAttribute("action",e),this._formNode.setAttribute("method","POST"),this._formNode.setAttribute("target",d),YAHOO.env.ua.ie&&!h?this._formNode.setAttribute("encoding",l):this._formNode.setAttribute("enctype",l),t&&(n=this.appendPostData(t)),this._formNode.submit(),this.startEvent.fire(o,_),o.startEvent&&o.startEvent.fire(o,_),a&&a.timeout&&(this._timeOut[o.tId]=window.setTimeout(function(){m.abort(o,a,!0)},a.timeout)),n&&0<n.length)for(s=0;s<n.length;s++)this._formNode.removeChild(n[s]);for(i in p)YAHOO.lang.hasOwnProperty(p,i)&&(p[i]?this._formNode.setAttribute(i,p[i]):this._formNode.removeAttribute(i));this.resetFormState(),u=function(){var e,t,n;a&&a.timeout&&(window.clearTimeout(m._timeOut[o.tId]),delete m._timeOut[o.tId]),m.completeEvent.fire(o,_),o.completeEvent&&o.completeEvent.fire(o,_),r={tId:o.tId,argument:_};try{e=c.contentWindow.document.getElementsByTagName("body")[0],t=c.contentWindow.document.getElementsByTagName("pre")[0],e&&(n=t?t.textContent||t.innerText:e.textContent||e.innerText),r.responseText=n,r.responseXML=c.contentWindow.document.XMLDocument||c.contentWindow.document}catch(s){}a&&a.upload&&(a.scope?a.upload.apply(a.scope,[r]):a.upload(r)),m.uploadEvent.fire(r),o.uploadEvent&&o.uploadEvent.fire(r),f.removeListener(c,"load",u),setTimeout(function(){document.body.removeChild(c),m.releaseObject(o)},100)},f.addListener(c,"load",u)}}(),YAHOO.register("connection",YAHOO.util.Connect,{version:"2.9.0",build:"2800"});
//# sourceMappingURL=connection.js.map;
!function(){var lang=YAHOO.lang,util=YAHOO.util,Ev=util.Event,DS=(util.DataSourceBase=function(e,t){if(null!==e&&e!==undefined){if(this.liveData=e,this._oQueue={interval:null,conn:null,requests:[]},this.responseSchema={},t&&t.constructor==Object)for(var n in t)n&&(this[n]=t[n]);e=this.maxCacheEntries,e=(lang.isNumber(e),this._aIntervals=[],this.createEvent("cacheRequestEvent"),this.createEvent("cacheResponseEvent"),this.createEvent("requestEvent"),this.createEvent("responseEvent"),this.createEvent("responseParseEvent"),this.createEvent("responseCacheEvent"),this.createEvent("dataErrorEvent"),this.createEvent("cacheFlushEvent"),util.DataSourceBase);this._sName="DataSource instance"+e._nIndex,e._nIndex++}},util.DataSourceBase);lang.augmentObject(DS,{TYPE_UNKNOWN:-1,TYPE_JSARRAY:0,TYPE_JSFUNCTION:1,TYPE_XHR:2,TYPE_JSON:3,TYPE_XML:4,TYPE_TEXT:5,TYPE_HTMLTABLE:6,TYPE_SCRIPTNODE:7,TYPE_LOCAL:8,ERROR_DATAINVALID:"Invalid data",ERROR_DATANULL:"Null data",_nIndex:0,_nTransactionId:0,_cloneObject:function(e){if(!lang.isValue(e))return e;var t={};if("[object RegExp]"===Object.prototype.toString.apply(e))t=e;else if(lang.isFunction(e))t=e;else if(lang.isArray(e)){for(var n=[],s=0,a=e.length;s<a;s++)n[s]=DS._cloneObject(e[s]);t=n}else if(lang.isObject(e))for(var r in e)lang.hasOwnProperty(e,r)&&(lang.isValue(e[r])&&lang.isObject(e[r])||lang.isArray(e[r])?t[r]=DS._cloneObject(e[r]):t[r]=e[r]);else t=e;return t},_getLocationValue:function(e,t){var n,s,e=e.locator||e.key||e,a=t.ownerDocument||t,r=null;try{if(lang.isUndefined(a.evaluate))a.setProperty("SelectionLanguage","XPath"),r=(n=t.selectNodes(e)[0]).value||n.text||null;else for(n=a.evaluate(e,t,a.createNSResolver((t.ownerDocument||t).documentElement),0,null);s=n.iterateNext();)r=s.textContent;return r}catch(o){}},issueCallback:function(e,t,n,s){var a;lang.isFunction(e)?e.apply(s,t):lang.isObject(e)&&(s=e.scope||s||window,a=e.success,a=n?e.failure:a)&&a.apply(s,t.concat([e.argument]))},parseString:function(e){return lang.isValue(e)&&lang.isString(e=e+"")?e:null},parseNumber:function(e){return lang.isValue(e)&&""!==e&&lang.isNumber(e=+e)?e:null},convertNumber:function(e){return DS.parseNumber(e)},parseDate:function(e){var t=null;return!lang.isValue(e)||e instanceof Date?e:(t=new Date(e))instanceof Date?t:null},convertDate:function(e){return DS.parseDate(e)}}),DS.Parser={string:DS.parseString,number:DS.parseNumber,date:DS.parseDate},DS.prototype={_sName:null,_aCache:null,_oQueue:null,_aIntervals:null,maxCacheEntries:0,liveData:null,dataType:DS.TYPE_UNKNOWN,responseType:DS.TYPE_UNKNOWN,responseSchema:null,useXPath:!1,cloneBeforeCaching:!1,toString:function(){return this._sName},getCachedResponse:function(e,t,n){var s=this._aCache;if(0<this.maxCacheEntries)if(s){var a=s.length;if(0<a){var r=null;this.fireEvent("cacheRequestEvent",{request:e,callback:t,caller:n});for(var o=a-1;0<=o;o--){var l=s[o];if(this.isCacheHit(e,l.request)){r=l.response,this.fireEvent("cacheResponseEvent",{request:e,response:r,callback:t,caller:n}),o<a-1&&(s.splice(o,1),this.addToCache(e,r)),r.cached=!0;break}}return r}}else this._aCache=[];else s&&(this._aCache=null);return null},isCacheHit:function(e,t){return e===t},addToCache:function(e,t){var n=this._aCache;if(n){for(;n.length>=this.maxCacheEntries;)n.shift();t=this.cloneBeforeCaching?DS._cloneObject(t):t,n[n.length]={request:e,response:t},this.fireEvent("responseCacheEvent",{request:e,response:t})}},flushCache:function(){this._aCache&&(this._aCache=[],this.fireEvent("cacheFlushEvent"))},setInterval:function(e,t,n,s){var a;if(lang.isNumber(e)&&0<=e)return a=this,e=setInterval(function(){a.makeConnection(t,n,s)},e),this._aIntervals.push(e),e},clearInterval:function(e){for(var t=this._aIntervals||[],n=t.length-1;-1<n;n--)t[n]===e&&(t.splice(n,1),clearInterval(e))},clearAllIntervals:function(){for(var e=this._aIntervals||[],t=e.length-1;-1<t;t--)clearInterval(e[t])},sendRequest:function(e,t,n){var s=this.getCachedResponse(e,t,n);return s?(DS.issueCallback(t,[e,s],!1,n),null):this.makeConnection(e,t,n)},makeConnection:function(e,t,n){var s=DS._nTransactionId++,a=(this.fireEvent("requestEvent",{tId:s,request:e,callback:t,caller:n}),this.liveData);return this.handleResponse(e,a,t,n,s),s},handleResponse:function(oRequest,oRawResponse,oCallback,oCaller,tId){this.fireEvent("responseEvent",{tId:tId,request:oRequest,response:oRawResponse,callback:oCallback,caller:oCaller});var xhr=this.dataType==DS.TYPE_XHR,oParsedResponse=null,oFullResponse=oRawResponse,ctype,el;switch(this.responseType===DS.TYPE_UNKNOWN&&(ctype=oRawResponse&&oRawResponse.getResponseHeader?oRawResponse.getResponseHeader["Content-Type"]:null,ctype?-1<ctype.indexOf("text/xml")?this.responseType=DS.TYPE_XML:-1<ctype.indexOf("application/json")?this.responseType=DS.TYPE_JSON:-1<ctype.indexOf("text/plain")&&(this.responseType=DS.TYPE_TEXT):YAHOO.lang.isArray(oRawResponse)?this.responseType=DS.TYPE_JSARRAY:oRawResponse&&oRawResponse.nodeType&&(9===oRawResponse.nodeType||1===oRawResponse.nodeType||11===oRawResponse.nodeType)?this.responseType=DS.TYPE_XML:oRawResponse&&oRawResponse.nodeName&&"table"==oRawResponse.nodeName.toLowerCase()?this.responseType=DS.TYPE_HTMLTABLE:YAHOO.lang.isObject(oRawResponse)?this.responseType=DS.TYPE_JSON:YAHOO.lang.isString(oRawResponse)&&(this.responseType=DS.TYPE_TEXT)),this.responseType){case DS.TYPE_JSARRAY:xhr&&oRawResponse&&oRawResponse.responseText&&(oFullResponse=oRawResponse.responseText);try{if(lang.isString(oFullResponse)){var parseArgs=[oFullResponse].concat(this.parseJSONArgs),arrayEnd,oFullResponse;if(lang.JSON)oFullResponse=lang.JSON.parse.apply(lang.JSON,parseArgs);else if(window.JSON&&JSON.parse)oFullResponse=JSON.parse.apply(JSON,parseArgs);else if(oFullResponse.parseJSON)oFullResponse=oFullResponse.parseJSON.apply(oFullResponse,parseArgs.slice(1));else{for(;0<oFullResponse.length&&"{"!=oFullResponse.charAt(0)&&"["!=oFullResponse.charAt(0);)oFullResponse=oFullResponse.substring(1,oFullResponse.length);0<oFullResponse.length&&(arrayEnd=Math.max(oFullResponse.lastIndexOf("]"),oFullResponse.lastIndexOf("}")),oFullResponse=oFullResponse.substring(0,arrayEnd+1),oFullResponse=eval("("+oFullResponse+")"))}}}catch(e1){}oFullResponse=this.doBeforeParseData(oRequest,oFullResponse,oCallback),oParsedResponse=this.parseArrayData(oRequest,oFullResponse);break;case DS.TYPE_JSON:xhr&&oRawResponse&&oRawResponse.responseText&&(oFullResponse=oRawResponse.responseText);try{if(lang.isString(oFullResponse)){var parseArgs=[oFullResponse].concat(this.parseJSONArgs),objEnd;if(lang.JSON)oFullResponse=lang.JSON.parse.apply(lang.JSON,parseArgs);else if(window.JSON&&JSON.parse)oFullResponse=JSON.parse.apply(JSON,parseArgs);else if(oFullResponse.parseJSON)oFullResponse=oFullResponse.parseJSON.apply(oFullResponse,parseArgs.slice(1));else{for(;0<oFullResponse.length&&"{"!=oFullResponse.charAt(0)&&"["!=oFullResponse.charAt(0);)oFullResponse=oFullResponse.substring(1,oFullResponse.length);0<oFullResponse.length&&(objEnd=Math.max(oFullResponse.lastIndexOf("]"),oFullResponse.lastIndexOf("}")),oFullResponse=oFullResponse.substring(0,objEnd+1),oFullResponse=eval("("+oFullResponse+")"))}}}catch(e){}oFullResponse=this.doBeforeParseData(oRequest,oFullResponse,oCallback),oParsedResponse=this.parseJSONData(oRequest,oFullResponse);break;case DS.TYPE_HTMLTABLE:xhr&&oRawResponse.responseText&&(el=document.createElement("div"),el.innerHTML=oRawResponse.responseText,oFullResponse=el.getElementsByTagName("table")[0]),oFullResponse=this.doBeforeParseData(oRequest,oFullResponse,oCallback),oParsedResponse=this.parseHTMLTableData(oRequest,oFullResponse);break;case DS.TYPE_XML:xhr&&oRawResponse.responseXML&&(oFullResponse=oRawResponse.responseXML),oFullResponse=this.doBeforeParseData(oRequest,oFullResponse,oCallback),oParsedResponse=this.parseXMLData(oRequest,oFullResponse);break;case DS.TYPE_TEXT:xhr&&lang.isString(oRawResponse.responseText)&&(oFullResponse=oRawResponse.responseText),oFullResponse=this.doBeforeParseData(oRequest,oFullResponse,oCallback),oParsedResponse=this.parseTextData(oRequest,oFullResponse);break;default:oFullResponse=this.doBeforeParseData(oRequest,oFullResponse,oCallback),oParsedResponse=this.parseData(oRequest,oFullResponse)}oParsedResponse=oParsedResponse||{},oParsedResponse.results||(oParsedResponse.results=[]),oParsedResponse.meta||(oParsedResponse.meta={}),oParsedResponse.error?(oParsedResponse.error=!0,this.fireEvent("dataErrorEvent",{request:oRequest,response:oRawResponse,callback:oCallback,caller:oCaller,message:DS.ERROR_DATANULL})):(oParsedResponse=this.doBeforeCallback(oRequest,oFullResponse,oParsedResponse,oCallback),this.fireEvent("responseParseEvent",{request:oRequest,response:oParsedResponse,callback:oCallback,caller:oCaller}),this.addToCache(oRequest,oParsedResponse)),oParsedResponse.tId=tId,DS.issueCallback(oCallback,[oRequest,oParsedResponse],oParsedResponse.error,oCaller)},doBeforeParseData:function(e,t,n){return t},doBeforeCallback:function(e,t,n,s){return n},parseData:function(e,t){return lang.isValue(t)?{results:t,meta:{}}:null},parseArrayData:function(e,t){if(lang.isArray(t)){var n,s,a,r=[];if(lang.isArray(this.responseSchema.fields)){for(var o=this.responseSchema.fields,l=o.length-1;0<=l;--l)"object"!=typeof o[l]&&(o[l]={key:o[l]});var i,u={};for(l=o.length-1;0<=l;--l)(i=("function"==typeof o[l].parser?o[l].parser:DS.Parser[o[l].parser+""])||o[l].converter)&&(u[o[l].key]=i);var c=lang.isArray(t[0]);for(l=t.length-1;-1<l;l--){var p,h={};if("object"==typeof(p=t[l]))for(n=o.length-1;-1<n;n--)s=o[n],a=c?p[n]:p[s.key],(a=u[s.key]?u[s.key].call(this,a):a)===undefined&&(a=null),h[s.key]=a;else if(lang.isString(p))for(n=o.length-1;-1<n;n--)a=p,(a=u[(s=o[n]).key]?u[s.key].call(this,a):a)===undefined&&(a=null),h[s.key]=a;r[l]=h}}else r=t;return{results:r}}return null},parseTextData:function(e,t){if(lang.isString(t)&&lang.isString(this.responseSchema.recordDelim)&&lang.isString(this.responseSchema.fieldDelim)){var n={results:[]},s=this.responseSchema.recordDelim,a=this.responseSchema.fieldDelim;if(0<t.length){var r=t.length-s.length;if(0<(t=t.substr(r)==s?t.substr(0,r):t).length)for(var o=t.split(s),l=0,i=o.length,u=0;l<i;++l){var c=!1,p=o[l];if(lang.isString(p)&&0<p.length){var h=o[l].split(a),g={};if(lang.isArray(this.responseSchema.fields))for(var f=this.responseSchema.fields,d=f.length-1;-1<d;d--)try{var S,R,D,T=h[d];lang.isString(T)?('"'==(T='"'==T.charAt(0)?T.substr(1):T).charAt(T.length-1)&&(T=T.substr(0,T.length-1)),S=f[d],R=lang.isValue(S.key)?S.key:S,!S.parser&&S.converter&&(S.parser=S.converter),(T=(D="function"==typeof S.parser?S.parser:DS.Parser[S.parser+""])?D.call(this,T):T)===undefined&&(T=null),g[R]=T):c=!0}catch(O){c=!0}else g=h;c||(n.results[u++]=g)}}}return n}return null},parseXMLResult:function(e){var t={},n=this.responseSchema;try{for(var s=n.fields.length-1;0<=s;s--){var a=n.fields[s],r=lang.isValue(a.key)?a.key:a,o=null;if(this.useXPath)o=YAHOO.util.DataSource._getLocationValue(a,e);else{var l=e.attributes.getNamedItem(r);if(l)o=l.value;else{var i=e.getElementsByTagName(r);if(i&&i.item(0)){var u=i.item(0);if(!(o=u&&(u.text||u.textContent)||null)){for(var c=[],p=0,h=u.childNodes.length;p<h;p++)u.childNodes[p].nodeValue&&(c[c.length]=u.childNodes[p].nodeValue);0<c.length&&(o=c.join(""))}}}}null===o&&(o=""),!a.parser&&a.converter&&(a.parser=a.converter);var g="function"==typeof a.parser?a.parser:DS.Parser[a.parser+""];(o=g?g.call(this,o):o)===undefined&&(o=null),t[r]=o}}catch(f){}return t},parseXMLData:function(e,t){var n,s,a,r,o=!1,l=this.responseSchema,i={meta:{}},u=null,c=l.metaNode,p=l.metaFields||{};try{if(this.useXPath)for(s in p)i.meta[s]=YAHOO.util.DataSource._getLocationValue(p[s],t);else if(c=c?t.getElementsByTagName(c)[0]:t)for(s in p)lang.hasOwnProperty(p,s)&&(a=p[s],r=(r=c.getElementsByTagName(a)[0])?r.firstChild.nodeValue:(r=c.attributes.getNamedItem(a))&&r.value,lang.isValue(r))&&(i.meta[s]=r);u=l.resultNode?t.getElementsByTagName(l.resultNode):null}catch(g){}if(u&&lang.isArray(l.fields))for(i.results=[],n=u.length-1;0<=n;--n){var h=this.parseXMLResult(u.item(n));i.results[n]=h}else o=!0;return o&&(i.error=!0),i},parseJSONData:function(e,t){var n={results:[],meta:{}};if(lang.isObject(t)&&this.responseSchema.resultsList){var s,a,r,o=this.responseSchema,l=o.fields,i=t,u=[],c=o.metaFields||{},p=[],h=[],g=[],f=!1,d=function(e){var t=null,s=[],a=0;if(e&&(e=e.replace(/\[(['"])(.*?)\1\]/g,function(e,t,n){return s[a]=n,".@"+a++}).replace(/\[(\d+)\]/g,function(e,t){return s[a]=0|parseInt(t,10),".@"+a++}).replace(/^\./,""),!/[^\w\.\$@]/.test(e)))for(t=e.split("."),a=t.length-1;0<=a;--a)"@"===t[a].charAt(0)&&(t[a]=s[parseInt(t[a].substr(1),10)]);return t},S=function(e,t){for(var n=t,s=0,a=e.length;s<a&&n;++s)n=n[e[s]];return n},R=d(o.resultsList);if((!R||(i=S(R,t))===undefined)&&(f=!0),lang.isArray(i=i||[])||(i=[i]),f)n.error=!0;else{if(o.fields){for(var D,T=0,O=l.length;T<O;T++)r=(D=l[T]).key||D,D=("function"==typeof D.parser?D.parser:DS.Parser[D.parser+""])||D.converter,R=d(r),D&&(p[p.length]={key:r,parser:D}),R&&(1<R.length?h[h.length]={key:r,path:R}:g[g.length]={key:r,path:R[0]});for(T=i.length-1;0<=T;--T){var v=i[T],m={};if(v){for(s=g.length-1;0<=s;--s)m[g[s].key]=v[g[s].path]!==undefined?v[g[s].path]:v[s];for(s=h.length-1;0<=s;--s)m[h[s].key]=S(h[s].path,v);for(s=p.length-1;0<=s;--s){var y=p[s].key;m[y]=p[s].parser.call(this,m[y]),m[y]===undefined&&(m[y]=null)}}u[T]=m}}else u=i;for(r in c)lang.hasOwnProperty(c,r)&&(R=d(c[r]))&&(a=S(R,t),n.meta[r]=a)}n.results=u}else n.error=!0;return n},parseHTMLTableData:function(e,t){var n=!1,s=t,a=this.responseSchema.fields,r={results:[]};if(lang.isArray(a))for(var o=0;o<s.tBodies.length;o++)for(var l=s.tBodies[o],i=l.rows.length-1;-1<i;i--){for(var u=l.rows[i],c={},p=a.length-1;-1<p;p--){var h=a[p],g=lang.isValue(h.key)?h.key:h,f=u.cells[p].innerHTML,h=(!h.parser&&h.converter&&(h.parser=h.converter),"function"==typeof h.parser?h.parser:DS.Parser[h.parser+""]);(f=h?h.call(this,f):f)===undefined&&(f=null),c[g]=f}r.results[i]=c}else n=!0;return n&&(r.error=!0),r}},lang.augmentProto(DS,util.EventProvider),util.LocalDataSource=function(e,t){this.dataType=DS.TYPE_LOCAL,e?YAHOO.lang.isArray(e)?this.responseType=DS.TYPE_JSARRAY:e.nodeType&&9==e.nodeType?this.responseType=DS.TYPE_XML:e.nodeName&&"table"==e.nodeName.toLowerCase()?(this.responseType=DS.TYPE_HTMLTABLE,e=e.cloneNode(!0)):YAHOO.lang.isString(e)?this.responseType=DS.TYPE_TEXT:YAHOO.lang.isObject(e)&&(this.responseType=DS.TYPE_JSON):(e=[],this.responseType=DS.TYPE_JSARRAY),util.LocalDataSource.superclass.constructor.call(this,e,t)},lang.extend(util.LocalDataSource,DS),lang.augmentObject(util.LocalDataSource,DS),util.FunctionDataSource=function(e,t){this.dataType=DS.TYPE_JSFUNCTION,util.FunctionDataSource.superclass.constructor.call(this,e=e||function(){},t)},lang.extend(util.FunctionDataSource,DS,{scope:null,makeConnection:function(e,t,n){var s=DS._nTransactionId++,a=(this.fireEvent("requestEvent",{tId:s,request:e,callback:t,caller:n}),this.scope?this.liveData.call(this.scope,e,this,t):this.liveData(e,t));return this.responseType===DS.TYPE_UNKNOWN&&(YAHOO.lang.isArray(a)?this.responseType=DS.TYPE_JSARRAY:a&&a.nodeType&&9==a.nodeType?this.responseType=DS.TYPE_XML:a&&a.nodeName&&"table"==a.nodeName.toLowerCase()?this.responseType=DS.TYPE_HTMLTABLE:YAHOO.lang.isObject(a)?this.responseType=DS.TYPE_JSON:YAHOO.lang.isString(a)&&(this.responseType=DS.TYPE_TEXT)),this.handleResponse(e,a,t,n,s),s}}),lang.augmentObject(util.FunctionDataSource,DS),util.ScriptNodeDataSource=function(e,t){this.dataType=DS.TYPE_SCRIPTNODE,util.ScriptNodeDataSource.superclass.constructor.call(this,e=e||"",t)},lang.extend(util.ScriptNodeDataSource,DS,{getUtility:util.Get,asyncMode:"allowAll",scriptCallbackParam:"callback",generateRequestCallback:function(e){return"&"+this.scriptCallbackParam+"=YAHOO.util.ScriptNodeDataSource.callbacks["+e+"]"},doBeforeGetScriptNode:function(e){return e},makeConnection:function(t,n,s){var a=DS._nTransactionId++,r=(this.fireEvent("requestEvent",{tId:a,request:t,callback:n,caller:s}),0===util.ScriptNodeDataSource._nPending&&(util.ScriptNodeDataSource.callbacks=[],util.ScriptNodeDataSource._nId=0),util.ScriptNodeDataSource._nId),o=(util.ScriptNodeDataSource._nId++,this),e=(util.ScriptNodeDataSource.callbacks[r]=function(e){"ignoreStaleResponses"===o.asyncMode&&r!==util.ScriptNodeDataSource.callbacks.length-1||(o.responseType===DS.TYPE_UNKNOWN&&(YAHOO.lang.isArray(e)?o.responseType=DS.TYPE_JSARRAY:e.nodeType&&9==e.nodeType?o.responseType=DS.TYPE_XML:e.nodeName&&"table"==e.nodeName.toLowerCase()?o.responseType=DS.TYPE_HTMLTABLE:YAHOO.lang.isObject(e)?o.responseType=DS.TYPE_JSON:YAHOO.lang.isString(e)&&(o.responseType=DS.TYPE_TEXT)),o.handleResponse(t,e,n,s,a)),delete util.ScriptNodeDataSource.callbacks[r]},util.ScriptNodeDataSource._nPending++,this.liveData+t+this.generateRequestCallback(r)),e=this.doBeforeGetScriptNode(e);return this.getUtility.script(e,{autopurge:!0,onsuccess:util.ScriptNodeDataSource._bumpPendingDown,onfail:util.ScriptNodeDataSource._bumpPendingDown}),a}}),lang.augmentObject(util.ScriptNodeDataSource,DS),lang.augmentObject(util.ScriptNodeDataSource,{_nId:0,_nPending:0,callbacks:[]}),util.XHRDataSource=function(e,t){this.dataType=DS.TYPE_XHR,this.connMgr=this.connMgr||util.Connect,util.XHRDataSource.superclass.constructor.call(this,e=e||"",t)},lang.extend(util.XHRDataSource,DS,{connMgr:null,connXhrMode:"allowAll",connMethodPost:!1,connTimeout:0,makeConnection:function(n,s,a){var e,t,r,o,l,i,u=DS._nTransactionId++,c=(this.fireEvent("requestEvent",{tId:u,request:n,callback:s,caller:a}),this.connMgr),p=this._oQueue,h={success:function(e){var t;return e&&"ignoreStaleResponses"==this.connXhrMode&&e.tId!=p.conn.tId?null:e?(this.responseType===DS.TYPE_UNKNOWN&&(t=e.getResponseHeader?e.getResponseHeader["Content-Type"]:null)&&(-1<t.indexOf("text/xml")?this.responseType=DS.TYPE_XML:-1<t.indexOf("application/json")?this.responseType=DS.TYPE_JSON:-1<t.indexOf("text/plain")&&(this.responseType=DS.TYPE_TEXT)),void this.handleResponse(n,e,s,a,u)):(this.fireEvent("dataErrorEvent",{request:n,response:null,callback:s,caller:a,message:DS.ERROR_DATANULL}),DS.issueCallback(s,[n,{error:!0}],!0,a),null)},failure:function(e){return this.fireEvent("dataErrorEvent",{request:n,response:e,callback:s,caller:a,message:DS.ERROR_DATAINVALID}),lang.isString(this.liveData)&&lang.isString(n)&&this.liveData.lastIndexOf("?")!==this.liveData.length-1&&n.indexOf("?"),(e=e||{}).error=!0,DS.issueCallback(s,[n,e],!0,a),null},scope:this};return lang.isNumber(this.connTimeout)&&(h.timeout=this.connTimeout),"cancelStaleRequests"==this.connXhrMode&&p.conn&&c.abort&&(c.abort(p.conn),p.conn=null),c&&c.asyncRequest?(e=this.liveData,t=this.connMethodPost,r=t?"POST":"GET",o=t||!lang.isValue(n)?e:e+n,l=t?n:null,"queueRequests"==this.connXhrMode&&p.conn?((i=p.requests).push({request:n,callback:h}),p.interval||(p.interval=setInterval(function(){c.isCallInProgress(p.conn)||(0<i.length?(o=t||!lang.isValue(i[0].request)?e:e+i[0].request,l=t?i[0].request:null,p.conn=c.asyncRequest(r,o,i[0].callback,l),i.shift()):(clearInterval(p.interval),p.interval=null))},50))):p.conn=c.asyncRequest(r,o,h,l)):DS.issueCallback(s,[n,{error:!0}],!0,a),u}}),lang.augmentObject(util.XHRDataSource,DS),util.DataSource=function(e,t){var n=(t=t||{}).dataType;if(n){if(n==DS.TYPE_LOCAL)return new util.LocalDataSource(e,t);if(n==DS.TYPE_XHR)return new util.XHRDataSource(e,t);if(n==DS.TYPE_SCRIPTNODE)return new util.ScriptNodeDataSource(e,t);if(n==DS.TYPE_JSFUNCTION)return new util.FunctionDataSource(e,t)}return new(YAHOO.lang.isString(e)?util.XHRDataSource:YAHOO.lang.isFunction(e)?util.FunctionDataSource:util.LocalDataSource)(e,t)},lang.augmentObject(util.DataSource,DS)}(),YAHOO.util.Number={format:function(e,t){if(""===e||null===e||!isFinite(e))return"";e=+e,t=YAHOO.lang.merge(YAHOO.util.Number.format.defaults,t||{});var n,s,a,r,o,l=Math.abs(e),i=t.decimalPlaces||0,u=t.thousandsSeparator,c=t.negativeFormat||"-"+t.format;return-1<c.indexOf("#")&&(c=c.replace(/#/,t.format)),i<0?s=0<(n=(s=l-l%1+"").length+i)?Number("."+s).toFixed(n).slice(2)+new Array(s.length-n+1).join("0"):"0":0<i||0<(l+"").indexOf(".")?(a=Math.pow(10,i),(a=(s=Math.round(l*a)/a+"").indexOf("."))<0?(r=i,o=(Math.pow(10,r)+"").substring(1),0<i&&(s=s+"."+o)):(r=i-(s.length-a-1),s+=o=(Math.pow(10,r)+"").substring(1))):s=l.toFixed(i)+"",a=s.split(/\D/),1e3<=l&&(n=a[0].length%3||3,a[0]=a[0].slice(0,n)+a[0].slice(n).replace(/(\d{3})/g,u+"$1")),YAHOO.util.Number.format._applyFormat(e<0?c:t.format,a.join(t.decimalSeparator),t)}},YAHOO.util.Number.format.defaults={format:"{prefix}{number}{suffix}",negativeFormat:null,decimalSeparator:".",decimalPlaces:null,thousandsSeparator:""},YAHOO.util.Number.format._applyFormat=function(e,n,s){return e.replace(/\{(\w+)\}/g,function(e,t){return"number"===t?n:t in s?s[t]:""})},!function(){var o=function(e,t,n){for(void 0===n&&(n=10);parseInt(e,10)<n&&1<n;n/=10)e=t.toString()+e;return e.toString()},l={formats:{a:function(e,t){return t.a[e.getDay()]},A:function(e,t){return t.A[e.getDay()]},b:function(e,t){return t.b[e.getMonth()]},B:function(e,t){return t.B[e.getMonth()]},C:function(e){return o(parseInt(e.getFullYear()/100,10),0)},d:["getDate","0"],e:["getDate"," "],g:function(e){return o(parseInt(l.formats.G(e)%100,10),0)},G:function(e){var t=e.getFullYear(),n=parseInt(l.formats.V(e),10),e=parseInt(l.formats.W(e),10);return n<e?t++:0===e&&52<=n&&t--,t},H:["getHours","0"],I:function(e){e=e.getHours()%12;return o(0==e?12:e,0)},j:function(e){var t=new Date(e.getFullYear()+"/1/1 GMT"),e=new Date(e.getFullYear()+"/"+(e.getMonth()+1)+"/"+e.getDate()+" GMT"),e=parseInt((e-t)/6e4/60/24,10)+1;return o(e,0,100)},k:["getHours"," "],l:function(e){e=e.getHours()%12;return o(0==e?12:e," ")},m:function(e){return o(e.getMonth()+1,0)},M:["getMinutes","0"],p:function(e,t){return t.p[12<=e.getHours()?1:0]},P:function(e,t){return t.P[12<=e.getHours()?1:0]},s:function(e,t){return parseInt(e.getTime()/1e3,10)},S:["getSeconds","0"],u:function(e){e=e.getDay();return 0===e?7:e},U:function(e){var t=parseInt(l.formats.j(e),10),e=6-e.getDay(),t=parseInt((t+e)/7,10);return o(t,0)},V:function(e){var t=parseInt(l.formats.W(e),10),n=new Date(e.getFullYear()+"/1/1").getDay(),t=t+(4<n||n<=1?0:1);return 53===t&&new Date(e.getFullYear()+"/12/31").getDay()<4?t=1:0===t&&(t=l.formats.V(new Date(e.getFullYear()-1+"/12/31"))),o(t,0)},w:"getDay",W:function(e){var t=parseInt(l.formats.j(e),10),e=7-l.formats.u(e),t=parseInt((t+e)/7,10);return o(t,0,10)},y:function(e){return o(e.getFullYear()%100,0)},Y:"getFullYear",z:function(e){e=e.getTimezoneOffset();return(0<e?"-":"+")+o(parseInt(Math.abs(e/60),10),0)+o(Math.abs(e%60),0)},Z:function(e){var t=e.toString().replace(/^.*:\d\d( GMT[+-]\d+)? \(?([A-Za-z ]+)\)?\d*$/,"$2").replace(/[a-z ]/g,"");return t=4<t.length?l.formats.z(e):t},"%":function(e){return"%"}},aggregates:{c:"locale",D:"%m/%d/%y",F:"%Y-%m-%d",h:"%b",n:"\n",r:"locale",R:"%H:%M",t:"\t",T:"%H:%M:%S",x:"locale",X:"locale"},format:function(s,e,t){if(e=e||{},!(s instanceof Date))return YAHOO.lang.isValue(s)?s:"";for(var n=e.format||"%m/%d/%Y",a=("YYYY/MM/DD"===n?n="%Y/%m/%d":"DD/MM/YYYY"===n?n="%d/%m/%Y":"MM/DD/YYYY"===n&&(n="%m/%d/%Y"),(t=t||"en")in YAHOO.util.DateLocale||(t=t.replace(/-[a-zA-Z]+$/,"")in YAHOO.util.DateLocale?t.replace(/-[a-zA-Z]+$/,""):"en"),YAHOO.util.DateLocale[t]),r=function(e,t){var n=l.aggregates[t];return"locale"===n?a[t]:n};n.match(/%[cDFhnrRtTxX]/);)n=n.replace(/%([cDFhnrRtTxX])/g,r);e=n.replace(/%([aAbBCdegGHIjklmMpPsSuUVwWyYzZ%])/g,function(e,t){var n=l.formats[t];return"string"==typeof n?s[n]():"function"==typeof n?n.call(s,s,a):"object"==typeof n&&"string"==typeof n[0]?o(s[n[0]](),n[1]):t}),r=undefined;return e}};YAHOO.namespace("YAHOO.util"),YAHOO.util.Date=l,YAHOO.util.DateLocale={a:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],A:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],b:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],B:["January","February","March","April","May","June","July","August","September","October","November","December"],c:"%a %d %b %Y %T %Z",p:["AM","PM"],P:["am","pm"],r:"%I:%M:%S %p",x:"%d/%m/%y",X:"%T"},YAHOO.util.DateLocale.en=YAHOO.lang.merge(YAHOO.util.DateLocale,{}),YAHOO.util.DateLocale["en-US"]=YAHOO.lang.merge(YAHOO.util.DateLocale.en,{c:"%a %d %b %Y %I:%M:%S %p %Z",x:"%m/%d/%Y",X:"%I:%M:%S %p"}),YAHOO.util.DateLocale["en-GB"]=YAHOO.lang.merge(YAHOO.util.DateLocale.en,{r:"%l:%M:%S %P %Z"}),YAHOO.util.DateLocale["en-AU"]=YAHOO.lang.merge(YAHOO.util.DateLocale.en)}(),YAHOO.register("datasource",YAHOO.util.DataSource,{version:"2.9.0",build:"2800"});
//# sourceMappingURL=datasource.js.map;
YAHOO.widget.DS_JSArray=YAHOO.util.LocalDataSource,YAHOO.widget.DS_JSFunction=YAHOO.util.FunctionDataSource,YAHOO.widget.DS_XHR=function(e,t,o){e=new YAHOO.util.XHRDataSource(e,o);return e._aDeprecatedSchema=t,e},YAHOO.widget.DS_ScriptNode=function(e,t,o){e=new YAHOO.util.ScriptNodeDataSource(e,o);return e._aDeprecatedSchema=t,e},YAHOO.widget.DS_XHR.TYPE_JSON=YAHOO.util.DataSourceBase.TYPE_JSON,YAHOO.widget.DS_XHR.TYPE_XML=YAHOO.util.DataSourceBase.TYPE_XML,YAHOO.widget.DS_XHR.TYPE_FLAT=YAHOO.util.DataSourceBase.TYPE_TEXT,YAHOO.widget.AutoComplete=function(e,t,o,i){if(e&&t&&o&&YAHOO.lang.isFunction(o.sendRequest)){this.dataSource=o,this.key=0;var n=o.responseSchema;if(o._aDeprecatedSchema&&(s=o._aDeprecatedSchema,YAHOO.lang.isArray(s))&&(o.responseType===YAHOO.util.DataSourceBase.TYPE_JSON||o.responseType===YAHOO.util.DataSourceBase.TYPE_UNKNOWN?(n.resultsList=s[0],this.key=s[1],n.fields=s.length<3?null:s.slice(1)):o.responseType===YAHOO.util.DataSourceBase.TYPE_XML?(n.resultNode=s[0],this.key=s[1],n.fields=s.slice(1)):o.responseType===YAHOO.util.DataSourceBase.TYPE_TEXT&&(n.recordDelim=s[0],n.fieldDelim=s[1]),o.responseSchema=n),YAHOO.util.Dom.inDocument(e)&&(YAHOO.lang.isString(e)?(this._sName="instance"+YAHOO.widget.AutoComplete._nIndex+" "+e,this._elTextbox=document.getElementById(e)):(this._sName=e.id?"instance"+YAHOO.widget.AutoComplete._nIndex+" "+e.id:"instance"+YAHOO.widget.AutoComplete._nIndex,this._elTextbox=e),YAHOO.util.Dom.addClass(this._elTextbox,"yui-ac-input"),YAHOO.util.Dom.inDocument(t))){YAHOO.lang.isString(t)?this._elContainer=document.getElementById(t):this._elContainer=t,this._elContainer.style.display;var s=this._elContainer.parentNode;if("div"==s.tagName.toLowerCase()&&YAHOO.util.Dom.addClass(s,"yui-ac"),this.dataSource.dataType===YAHOO.util.DataSourceBase.TYPE_LOCAL&&(this.applyLocalFilter=!0),i&&i.constructor==Object)for(var l in i)l&&(this[l]=i[l]);this._initContainerEl(),this._initProps(),this._initListEl(),this._initContainerHelperEls();o=this,n=this._elTextbox;YAHOO.util.Event.addListener(n,"keyup",o._onTextboxKeyUp,o),YAHOO.util.Event.addListener(n,"keydown",o._onTextboxKeyDown,o),YAHOO.util.Event.addListener(n,"focus",o._onTextboxFocus,o),YAHOO.util.Event.addListener(n,"blur",o._onTextboxBlur,o),YAHOO.util.Event.addListener(t,"mouseover",o._onContainerMouseover,o),YAHOO.util.Event.addListener(t,"mouseout",o._onContainerMouseout,o),YAHOO.util.Event.addListener(t,"click",o._onContainerClick,o),YAHOO.util.Event.addListener(t,"scroll",o._onContainerScroll,o),YAHOO.util.Event.addListener(t,"resize",o._onContainerResize,o),YAHOO.util.Event.addListener(n,"keypress",o._onTextboxKeyPress,o),YAHOO.util.Event.addListener(window,"unload",o._onWindowUnload,o),this.textboxFocusEvent=new YAHOO.util.CustomEvent("textboxFocus",this),this.textboxKeyEvent=new YAHOO.util.CustomEvent("textboxKey",this),this.dataRequestEvent=new YAHOO.util.CustomEvent("dataRequest",this),this.dataRequestCancelEvent=new YAHOO.util.CustomEvent("dataRequestCancel",this),this.dataReturnEvent=new YAHOO.util.CustomEvent("dataReturn",this),this.dataErrorEvent=new YAHOO.util.CustomEvent("dataError",this),this.containerPopulateEvent=new YAHOO.util.CustomEvent("containerPopulate",this),this.containerExpandEvent=new YAHOO.util.CustomEvent("containerExpand",this),this.typeAheadEvent=new YAHOO.util.CustomEvent("typeAhead",this),this.itemMouseOverEvent=new YAHOO.util.CustomEvent("itemMouseOver",this),this.itemMouseOutEvent=new YAHOO.util.CustomEvent("itemMouseOut",this),this.itemArrowToEvent=new YAHOO.util.CustomEvent("itemArrowTo",this),this.itemArrowFromEvent=new YAHOO.util.CustomEvent("itemArrowFrom",this),this.itemSelectEvent=new YAHOO.util.CustomEvent("itemSelect",this),this.unmatchedItemSelectEvent=new YAHOO.util.CustomEvent("unmatchedItemSelect",this),this.selectionEnforceEvent=new YAHOO.util.CustomEvent("selectionEnforce",this),this.containerCollapseEvent=new YAHOO.util.CustomEvent("containerCollapse",this),this.textboxBlurEvent=new YAHOO.util.CustomEvent("textboxBlur",this),this.textboxChangeEvent=new YAHOO.util.CustomEvent("textboxChange",this),n.setAttribute("autocomplete","off"),YAHOO.widget.AutoComplete._nIndex++}}},YAHOO.widget.AutoComplete.prototype.dataSource=null,YAHOO.widget.AutoComplete.prototype.applyLocalFilter=null,YAHOO.widget.AutoComplete.prototype.queryMatchCase=!1,YAHOO.widget.AutoComplete.prototype.queryMatchContains=!1,YAHOO.widget.AutoComplete.prototype.queryMatchSubset=!1,YAHOO.widget.AutoComplete.prototype.minQueryLength=1,YAHOO.widget.AutoComplete.prototype.maxResultsDisplayed=10,YAHOO.widget.AutoComplete.prototype.queryDelay=.2,YAHOO.widget.AutoComplete.prototype.typeAheadDelay=.5,YAHOO.widget.AutoComplete.prototype.queryInterval=500,YAHOO.widget.AutoComplete.prototype.highlightClassName="yui-ac-highlight",YAHOO.widget.AutoComplete.prototype.prehighlightClassName=null,YAHOO.widget.AutoComplete.prototype.delimChar=null,YAHOO.widget.AutoComplete.prototype.autoHighlight=!0,YAHOO.widget.AutoComplete.prototype.typeAhead=!1,YAHOO.widget.AutoComplete.prototype.animHoriz=!1,YAHOO.widget.AutoComplete.prototype.animVert=!0,YAHOO.widget.AutoComplete.prototype.animSpeed=.3,YAHOO.widget.AutoComplete.prototype.forceSelection=!1,YAHOO.widget.AutoComplete.prototype.allowBrowserAutocomplete=!0,YAHOO.widget.AutoComplete.prototype.alwaysShowContainer=!1,YAHOO.widget.AutoComplete.prototype.useIFrame=!1,YAHOO.widget.AutoComplete.prototype.useShadow=!1,YAHOO.widget.AutoComplete.prototype.suppressInputUpdate=!1,YAHOO.widget.AutoComplete.prototype.resultTypeList=!0,YAHOO.widget.AutoComplete.prototype.queryQuestionMark=!0,YAHOO.widget.AutoComplete.prototype.autoSnapContainer=!0,YAHOO.widget.AutoComplete.prototype.toString=function(){return"AutoComplete "+this._sName},YAHOO.widget.AutoComplete.prototype.getInputEl=function(){return this._elTextbox},YAHOO.widget.AutoComplete.prototype.getContainerEl=function(){return this._elContainer},YAHOO.widget.AutoComplete.prototype.isFocused=function(){return this._bFocused},YAHOO.widget.AutoComplete.prototype.isContainerOpen=function(){return this._bContainerOpen},YAHOO.widget.AutoComplete.prototype.getListEl=function(){return this._elList},YAHOO.widget.AutoComplete.prototype.getListItemMatch=function(e){return e._sResultMatch||null},YAHOO.widget.AutoComplete.prototype.getListItemData=function(e){return e._oResultData||null},YAHOO.widget.AutoComplete.prototype.getListItemIndex=function(e){return YAHOO.lang.isNumber(e._nItemIndex)?e._nItemIndex:null},YAHOO.widget.AutoComplete.prototype.setHeader=function(e){var t;this._elHeader&&(t=this._elHeader,e?(t.innerHTML=e,t.style.display=""):(t.innerHTML="",t.style.display="none"))},YAHOO.widget.AutoComplete.prototype.setFooter=function(e){var t;this._elFooter&&(t=this._elFooter,e?(t.innerHTML=e,t.style.display=""):(t.innerHTML="",t.style.display="none"))},YAHOO.widget.AutoComplete.prototype.setBody=function(e){var t;this._elBody&&(t=this._elBody,YAHOO.util.Event.purgeElement(t,!0),e?(t.innerHTML=e,t.style.display=""):(t.innerHTML="",t.style.display="none"),this._elList=null)},YAHOO.widget.AutoComplete.prototype.generateRequest=function(e){var t=this.dataSource.dataType;return t===YAHOO.util.DataSourceBase.TYPE_XHR?e=this.dataSource.connMethodPost?(this.dataSource.scriptQueryParam||"query")+"="+e+(this.dataSource.scriptQueryAppend?"&"+this.dataSource.scriptQueryAppend:""):(this.queryQuestionMark?"?":"")+(this.dataSource.scriptQueryParam||"query")+"="+e+(this.dataSource.scriptQueryAppend?"&"+this.dataSource.scriptQueryAppend:""):t===YAHOO.util.DataSourceBase.TYPE_SCRIPTNODE&&(e="&"+(this.dataSource.scriptQueryParam||"query")+"="+e+(this.dataSource.scriptQueryAppend?"&"+this.dataSource.scriptQueryAppend:"")),e},YAHOO.widget.AutoComplete.prototype.sendQuery=function(e){this._bFocused=!0;e=this.delimChar?this._elTextbox.value+e:e;this._sendQuery(e)},YAHOO.widget.AutoComplete.prototype.snapContainer=function(){var e=this._elTextbox,t=YAHOO.util.Dom.getXY(e);t[1]+=YAHOO.util.Dom.get(e).offsetHeight+2,YAHOO.util.Dom.setXY(this._elContainer,t)},YAHOO.widget.AutoComplete.prototype.expandContainer=function(){this._toggleContainer(!0)},YAHOO.widget.AutoComplete.prototype.collapseContainer=function(){this._toggleContainer(!1)},YAHOO.widget.AutoComplete.prototype.clearList=function(){for(var e=this._elList.childNodes,t=e.length-1;-1<t;t--)e[t].style.display="none"},YAHOO.widget.AutoComplete.prototype.getSubsetMatches=function(e){for(var t,o=e.length;o>=this.minQueryLength;o--)if(t=this.generateRequest(e.substr(0,o)),this.dataRequestEvent.fire(this,void 0,t),t=this.dataSource.getCachedResponse(t))return this.filterResults.apply(this.dataSource,[e,t,t,{scope:this}]);return null},YAHOO.widget.AutoComplete.prototype.preparseRawResponse=function(e,t,o){var i=""!==this.responseStripAfter&&t.indexOf?t.indexOf(this.responseStripAfter):-1;return t=-1!=i?t.substring(0,i):t},YAHOO.widget.AutoComplete.prototype.filterResults=function(e,t,o,i){if((e=i&&i.argument&&YAHOO.lang.isValue(i.argument.query)?i.argument.query:e)&&""!==e){o=YAHOO.widget.AutoComplete._cloneObject(o);for(var i=i.scope,n=o.results,s=[],l=i.maxResultsDisplayed,r=this.queryMatchCase||i.queryMatchCase,a=this.queryMatchContains||i.queryMatchContains,u=0,p=n.length;u<p;u++){var h=n[u],O=null;if(YAHOO.lang.isString(h)?O=h:YAHOO.lang.isArray(h)?O=h[0]:this.responseSchema.fields?O=h[this.responseSchema.fields[0].key||this.responseSchema.fields[0]]:this.key&&(O=h[this.key]),YAHOO.lang.isString(O)&&(O=r?O.indexOf(decodeURIComponent(e)):O.toLowerCase().indexOf(decodeURIComponent(e).toLowerCase()),!a&&0===O||a&&-1<O)&&s.push(h),l<p&&s.length===l)break}o.results=s}return o},YAHOO.widget.AutoComplete.prototype.handleResponse=function(e,t,o){this instanceof YAHOO.widget.AutoComplete&&this._sName&&this._populateList(e,t,o)},YAHOO.widget.AutoComplete.prototype.doBeforeLoadData=function(e,t,o){return!0},YAHOO.widget.AutoComplete.prototype.formatResult=function(e,t,o){return o||""},YAHOO.widget.AutoComplete.prototype.formatEscapedResult=function(e,t,o){return YAHOO.lang.escapeHTML(o||"")},YAHOO.widget.AutoComplete.prototype.doBeforeExpandContainer=function(e,t,o,i){return!0},YAHOO.widget.AutoComplete.prototype.destroy=function(){this.toString();var e,t=this._elTextbox,o=this._elContainer;for(e in this.textboxFocusEvent.unsubscribeAll(),this.textboxKeyEvent.unsubscribeAll(),this.dataRequestEvent.unsubscribeAll(),this.dataReturnEvent.unsubscribeAll(),this.dataErrorEvent.unsubscribeAll(),this.containerPopulateEvent.unsubscribeAll(),this.containerExpandEvent.unsubscribeAll(),this.typeAheadEvent.unsubscribeAll(),this.itemMouseOverEvent.unsubscribeAll(),this.itemMouseOutEvent.unsubscribeAll(),this.itemArrowToEvent.unsubscribeAll(),this.itemArrowFromEvent.unsubscribeAll(),this.itemSelectEvent.unsubscribeAll(),this.unmatchedItemSelectEvent.unsubscribeAll(),this.selectionEnforceEvent.unsubscribeAll(),this.containerCollapseEvent.unsubscribeAll(),this.textboxBlurEvent.unsubscribeAll(),this.textboxChangeEvent.unsubscribeAll(),YAHOO.util.Event.purgeElement(t,!0),YAHOO.util.Event.purgeElement(o,!0),o.innerHTML="",this)YAHOO.lang.hasOwnProperty(this,e)&&(this[e]=null)},YAHOO.widget.AutoComplete.prototype.textboxFocusEvent=null,YAHOO.widget.AutoComplete.prototype.textboxKeyEvent=null,YAHOO.widget.AutoComplete.prototype.dataRequestEvent=null,YAHOO.widget.AutoComplete.prototype.dataRequestCancelEvent=null,YAHOO.widget.AutoComplete.prototype.dataReturnEvent=null,YAHOO.widget.AutoComplete.prototype.dataErrorEvent=null,YAHOO.widget.AutoComplete.prototype.containerPopulateEvent=null,YAHOO.widget.AutoComplete.prototype.containerExpandEvent=null,YAHOO.widget.AutoComplete.prototype.typeAheadEvent=null,YAHOO.widget.AutoComplete.prototype.itemMouseOverEvent=null,YAHOO.widget.AutoComplete.prototype.itemMouseOutEvent=null,YAHOO.widget.AutoComplete.prototype.itemArrowToEvent=null,YAHOO.widget.AutoComplete.prototype.itemArrowFromEvent=null,YAHOO.widget.AutoComplete.prototype.itemSelectEvent=null,YAHOO.widget.AutoComplete.prototype.unmatchedItemSelectEvent=null,YAHOO.widget.AutoComplete.prototype.selectionEnforceEvent=null,YAHOO.widget.AutoComplete.prototype.containerCollapseEvent=null,YAHOO.widget.AutoComplete.prototype.textboxBlurEvent=null,YAHOO.widget.AutoComplete.prototype.textboxChangeEvent=null,YAHOO.widget.AutoComplete._nIndex=0,YAHOO.widget.AutoComplete.prototype._sName=null,YAHOO.widget.AutoComplete.prototype._elTextbox=null,YAHOO.widget.AutoComplete.prototype._elContainer=null,YAHOO.widget.AutoComplete.prototype._elContent=null,YAHOO.widget.AutoComplete.prototype._elHeader=null,YAHOO.widget.AutoComplete.prototype._elBody=null,YAHOO.widget.AutoComplete.prototype._elFooter=null,YAHOO.widget.AutoComplete.prototype._elShadow=null,YAHOO.widget.AutoComplete.prototype._elIFrame=null,YAHOO.widget.AutoComplete.prototype._bFocused=!1,YAHOO.widget.AutoComplete.prototype._oAnim=null,YAHOO.widget.AutoComplete.prototype._bContainerOpen=!1,YAHOO.widget.AutoComplete.prototype._bOverContainer=!1,YAHOO.widget.AutoComplete.prototype._elList=null,YAHOO.widget.AutoComplete.prototype._nDisplayedItems=0,YAHOO.widget.AutoComplete.prototype._sCurQuery=null,YAHOO.widget.AutoComplete.prototype._sPastSelections="",YAHOO.widget.AutoComplete.prototype._sInitInputValue=null,YAHOO.widget.AutoComplete.prototype._elCurListItem=null,YAHOO.widget.AutoComplete.prototype._elCurPrehighlightItem=null,YAHOO.widget.AutoComplete.prototype._bItemSelected=!1,YAHOO.widget.AutoComplete.prototype._nKeyCode=null,YAHOO.widget.AutoComplete.prototype._nDelayID=-1,YAHOO.widget.AutoComplete.prototype._nTypeAheadDelayID=-1,YAHOO.widget.AutoComplete.prototype._iFrameSrc="javascript:false;",YAHOO.widget.AutoComplete.prototype._queryInterval=null,YAHOO.widget.AutoComplete.prototype._sLastTextboxValue=null,YAHOO.widget.AutoComplete.prototype._initProps=function(){var e=this.minQueryLength,e=(YAHOO.lang.isNumber(e)||(this.minQueryLength=1),this.maxResultsDisplayed),e=((!YAHOO.lang.isNumber(e)||e<1)&&(this.maxResultsDisplayed=10),this.queryDelay),e=((!YAHOO.lang.isNumber(e)||e<0)&&(this.queryDelay=.2),this.typeAheadDelay),e=((!YAHOO.lang.isNumber(e)||e<0)&&(this.typeAheadDelay=.2),this.delimChar),e=(YAHOO.lang.isString(e)&&0<e.length?this.delimChar=[e]:YAHOO.lang.isArray(e)||(this.delimChar=null),this.animSpeed);(this.animHoriz||this.animVert)&&YAHOO.util.Anim&&((!YAHOO.lang.isNumber(e)||e<0)&&(this.animSpeed=.3),this._oAnim?this._oAnim.duration=this.animSpeed:this._oAnim=new YAHOO.util.Anim(this._elContent,{},this.animSpeed)),this.forceSelection},YAHOO.widget.AutoComplete.prototype._initContainerHelperEls=function(){var e;this.useShadow&&!this._elShadow&&((e=document.createElement("div")).className="yui-ac-shadow",e.style.width=0,e.style.height=0,this._elShadow=this._elContainer.appendChild(e)),this.useIFrame&&!this._elIFrame&&((e=document.createElement("iframe")).src=this._iFrameSrc,e.frameBorder=0,e.scrolling="no",e.style.position="absolute",e.style.width=0,e.style.height=0,e.style.padding=0,e.tabIndex=-1,e.role="presentation",e.title="Presentational iframe shim",this._elIFrame=this._elContainer.appendChild(e))},YAHOO.widget.AutoComplete.prototype._initContainerEl=function(){var e;YAHOO.util.Dom.addClass(this._elContainer,"yui-ac-container"),this._elContent||((e=document.createElement("div")).className="yui-ac-content",e.style.display="none",this._elContent=this._elContainer.appendChild(e),(e=document.createElement("div")).className="yui-ac-hd",e.style.display="none",this._elHeader=this._elContent.appendChild(e),(e=document.createElement("div")).className="yui-ac-bd",this._elBody=this._elContent.appendChild(e),(e=document.createElement("div")).className="yui-ac-ft",e.style.display="none",this._elFooter=this._elContent.appendChild(e))},YAHOO.widget.AutoComplete.prototype._initListEl=function(){for(var e,t,o=this.maxResultsDisplayed,i=this._elList||document.createElement("ul");i.childNodes.length<o;)(e=document.createElement("li")).style.display="none",e._nItemIndex=i.childNodes.length,i.appendChild(e);this._elList||(t=this._elBody,YAHOO.util.Event.purgeElement(t,!0),t.innerHTML="",this._elList=t.appendChild(i)),this._elBody.style.display=""},YAHOO.widget.AutoComplete.prototype._focus=function(){var t=this;setTimeout(function(){try{t._elTextbox.focus()}catch(e){}},0)},YAHOO.widget.AutoComplete.prototype._enableIntervalDetection=function(){var e=this;!e._queryInterval&&e.queryInterval&&(e._queryInterval=setInterval(function(){e._onInterval()},e.queryInterval))},YAHOO.widget.AutoComplete.prototype.enableIntervalDetection=YAHOO.widget.AutoComplete.prototype._enableIntervalDetection,YAHOO.widget.AutoComplete.prototype._onInterval=function(){var e=this._elTextbox.value;e!=this._sLastTextboxValue&&(this._sLastTextboxValue=e,this._sendQuery(e))},YAHOO.widget.AutoComplete.prototype._clearInterval=function(){this._queryInterval&&(clearInterval(this._queryInterval),this._queryInterval=null)},YAHOO.widget.AutoComplete.prototype._isIgnoreKey=function(e){return 9==e||13==e||16==e||17==e||18<=e&&e<=20||27==e||33<=e&&e<=35||36<=e&&e<=40||44<=e&&e<=45||229==e},YAHOO.widget.AutoComplete.prototype._sendQuery=function(e){if(this.minQueryLength<0)this._toggleContainer(!1);else if(this.delimChar&&(e=(t=this._extractQuery(e)).query,this._sPastSelections=t.previous),e&&e.length<this.minQueryLength||!e&&0<this.minQueryLength)-1!=this._nDelayID&&clearTimeout(this._nDelayID),this._toggleContainer(!1);else{if(e=encodeURIComponent(e),this._nDelayID=-1,this.dataSource.queryMatchSubset||this.queryMatchSubset){var t=this.getSubsetMatches(e);if(t)return void this.handleResponse(e,t,{query:e})}this.dataSource.responseStripAfter&&(this.dataSource.doBeforeParseData=this.preparseRawResponse),this.applyLocalFilter&&(this.dataSource.doBeforeCallback=this.filterResults);t=this.generateRequest(e);t!==undefined?(this.dataRequestEvent.fire(this,e,t),this.dataSource.sendRequest(t,{success:this.handleResponse,failure:this.handleResponse,scope:this,argument:{query:e}})):this.dataRequestCancelEvent.fire(this,e)}},YAHOO.widget.AutoComplete.prototype._populateListItem=function(e,t,o){e.innerHTML=this.formatResult(t,o,e._sResultMatch)},YAHOO.widget.AutoComplete.prototype._populateList=function(e,t,o){if(-1!=this._nTypeAheadDelayID&&clearTimeout(this._nTypeAheadDelayID),e=o&&o.query?o.query:e,this.doBeforeLoadData(e,t,o)&&!t.error){if(this.dataReturnEvent.fire(this,e,t.results),this._bFocused){var i=decodeURIComponent(e),n=(this._sCurQuery=i,this._bItemSelected=!1,t.results),s=Math.min(n.length,this.maxResultsDisplayed),l=this.dataSource.responseSchema.fields?this.dataSource.responseSchema.fields[0].key||this.dataSource.responseSchema.fields[0]:0;if(0<s){(!this._elList||this._elList.childNodes.length<s)&&this._initListEl(),this._initContainerHelperEls();for(var r=this._elList.childNodes,a=s-1;0<=a;a--){var u=r[a],p=n[a];if(this.resultTypeList){var h=[],O=(h[0]=YAHOO.lang.isString(p)?p:p[l]||p[this.key],this.dataSource.responseSchema.fields);if(YAHOO.lang.isArray(O)&&1<O.length)for(var d=1,A=O.length;d<A;d++)h[h.length]=p[O[d].key||O[d]];else YAHOO.lang.isArray(p)?h=p:YAHOO.lang.isString(p)?h=[p]:h[1]=p;p=h}u._sResultMatch=YAHOO.lang.isString(p)?p:YAHOO.lang.isArray(p)?p[0]:p[l]||"",u._oResultData=p,this._populateListItem(u,p,i),u.style.display=""}if(s<r.length)for(var m=r.length-1;s<=m;m--)r[m].style.display="none";this._nDisplayedItems=s,this.containerPopulateEvent.fire(this,e,n),this.autoHighlight?(o=this._elList.firstChild,this._toggleHighlight(o,"to"),this.itemArrowToEvent.fire(this,o),this._typeAhead(o,e)):this._toggleHighlight(this._elCurListItem,"from"),o=this._doBeforeExpandContainer(this._elTextbox,this._elContainer,e,n),this._toggleContainer(o)}else this._toggleContainer(!1)}}else this.dataErrorEvent.fire(this,e,t)},YAHOO.widget.AutoComplete.prototype._doBeforeExpandContainer=function(e,t,o,i){return this.autoSnapContainer&&this.snapContainer(),this.doBeforeExpandContainer(e,t,o,i)},YAHOO.widget.AutoComplete.prototype._clearSelection=function(){var e=this.delimChar?this._extractQuery(this._elTextbox.value):{previous:"",query:this._elTextbox.value};this._elTextbox.value=e.previous,this.selectionEnforceEvent.fire(this,e.query)},YAHOO.widget.AutoComplete.prototype._textMatchesOption=function(){for(var e=null,t=0;t<this._nDisplayedItems;t++){var o=this._elList.childNodes[t];if((""+o._sResultMatch).toLowerCase()==this._sCurQuery.toLowerCase()){e=o;break}}return e},YAHOO.widget.AutoComplete.prototype._typeAhead=function(o,i){var n,s;this.typeAhead&&8!=this._nKeyCode&&((s=(n=this)._elTextbox).setSelectionRange||s.createTextRange)&&(this._nTypeAheadDelayID=setTimeout(function(){var e=s.value.length,t=(n._updateValue(o),s.value.length),e=(n._selectText(s,e,t),s.value.substr(e,t));n._sCurQuery=o._sResultMatch,n.typeAheadEvent.fire(n,i,e)},1e3*this.typeAheadDelay))},YAHOO.widget.AutoComplete.prototype._selectText=function(e,t,o){var i;e.setSelectionRange?e.setSelectionRange(t,o):(e.createTextRange?((i=e.createTextRange()).moveStart("character",t),i.moveEnd("character",o-e.value.length),i):e).select()},YAHOO.widget.AutoComplete.prototype._extractQuery=function(e){for(var t,o,i,n=this.delimChar,s=-1,l=n.length-1;0<=l;l--)s<(t=e.lastIndexOf(n[l]))&&(s=t);if(" "==n[l])for(var r=n.length-1;0<=r;r--)if(e[s-1]==n[r]){s--;break}if(-1<s){for(o=s+1;" "==e.charAt(o);)o+=1;i=e.substring(0,o),e=e.substr(o)}else i="";return{previous:i,query:e}},YAHOO.widget.AutoComplete.prototype._toggleContainerHelpers=function(e){var t,o=this._elContent.offsetWidth+"px",i=this._elContent.offsetHeight+"px";this.useIFrame&&this._elIFrame&&(t=this._elIFrame,e?(t.style.width=o,t.style.height=i,t.style.padding=""):(t.style.width=0,t.style.height=0,t.style.padding=0)),this.useShadow&&this._elShadow&&(t=this._elShadow,e?(t.style.width=o,t.style.height=i):(t.style.width=0,t.style.height=0))},YAHOO.widget.AutoComplete.prototype._toggleContainer=function(e){var t,o,i,n,s,l,r,a=this._elContainer;this.alwaysShowContainer&&this._bContainerOpen||!e&&(this._toggleHighlight(this._elCurListItem,"from"),this._nDisplayedItems=0,this._sCurQuery=null,"none"==this._elContent.style.display)||((t=this._oAnim)&&t.getEl()&&(this.animHoriz||this.animVert)?(t.isAnimated()&&t.stop(!0),o=this._elContent.cloneNode(!0),a.appendChild(o),o.style.top="-9000px",o.style.width="",o.style.height="",o.style.display="",i=o.offsetWidth,n=o.offsetHeight,s=this.animHoriz?0:i,l=this.animVert?0:n,t.attributes=e?{width:{to:i},height:{to:n}}:{width:{to:s},height:{to:l}},e&&!this._bContainerOpen?(this._elContent.style.width=s+"px",this._elContent.style.height=l+"px"):(this._elContent.style.width=i+"px",this._elContent.style.height=n+"px"),a.removeChild(o),o=null,(r=this)._toggleContainerHelpers(!1),this._elContent.style.display="",t.onComplete.subscribe(function(){t.onComplete.unsubscribeAll(),(e?(r._toggleContainerHelpers(!0),r._bContainerOpen=e,r.containerExpandEvent):(r._elContent.style.display="none",r._bContainerOpen=e,r.containerCollapseEvent)).fire(r)}),t.animate()):(e?(this._elContent.style.display="",this._toggleContainerHelpers(!0),this._bContainerOpen=e,this.containerExpandEvent):(this._toggleContainerHelpers(!1),this._elContent.style.display="none",this._bContainerOpen=e,this.containerCollapseEvent)).fire(this))},YAHOO.widget.AutoComplete.prototype._toggleHighlight=function(e,t){var o;e&&(o=this.highlightClassName,this._elCurListItem&&(YAHOO.util.Dom.removeClass(this._elCurListItem,o),this._elCurListItem=null),"to"==t)&&o&&(YAHOO.util.Dom.addClass(e,o),this._elCurListItem=e)},YAHOO.widget.AutoComplete.prototype._togglePrehighlight=function(e,t){var o=this.prehighlightClassName;this._elCurPrehighlightItem&&YAHOO.util.Dom.removeClass(this._elCurPrehighlightItem,o),e!=this._elCurListItem&&("mouseover"==t&&o?(YAHOO.util.Dom.addClass(e,o),this._elCurPrehighlightItem=e):YAHOO.util.Dom.removeClass(e,o))},YAHOO.widget.AutoComplete.prototype._updateValue=function(e){var t,o,i,n;this.suppressInputUpdate||(t=this._elTextbox,n=this.delimChar?this.delimChar[0]||this.delimChar:null,o=e._sResultMatch,i="",n?(i=this._sPastSelections,i+=o+n," "!=n&&(i+=" ")):i=o,t.value=i,"textarea"==t.type&&(t.scrollTop=t.scrollHeight),n=t.value.length,this._selectText(t,n,n),this._elCurListItem=e)},YAHOO.widget.AutoComplete.prototype._selectItem=function(e){this._bItemSelected=!0,this._updateValue(e),this._sPastSelections=this._elTextbox.value,this._clearInterval(),this.itemSelectEvent.fire(this,e,e._oResultData),this._toggleContainer(!1)},YAHOO.widget.AutoComplete.prototype._jumpSelection=function(){this._elCurListItem?this._selectItem(this._elCurListItem):this._toggleContainer(!1)},YAHOO.widget.AutoComplete.prototype._moveSelection=function(e){var t,o,i,n,s;this._bContainerOpen&&(t=-1,(o=this._elCurListItem)&&(t=o._nItemIndex),(t=40==e?t+1:t-1)<-2||t>=this._nDisplayedItems||(o&&(this._toggleHighlight(o,"from"),this.itemArrowFromEvent.fire(this,o)),-1==t?this.delimChar?this._elTextbox.value=this._sPastSelections+this._sCurQuery:this._elTextbox.value=this._sCurQuery:-2==t?this._toggleContainer(!1):(o=this._elList.childNodes[t],i=this._elContent,n=YAHOO.util.Dom.getStyle(i,"overflow"),s=YAHOO.util.Dom.getStyle(i,"overflowY"),("auto"==n||"scroll"==n||"auto"==s||"scroll"==s)&&-1<t&&t<this._nDisplayedItems&&(40==e?o.offsetTop+o.offsetHeight>i.scrollTop+i.offsetHeight?i.scrollTop=o.offsetTop+o.offsetHeight-i.offsetHeight:o.offsetTop+o.offsetHeight<i.scrollTop&&(i.scrollTop=o.offsetTop):o.offsetTop<i.scrollTop?this._elContent.scrollTop=o.offsetTop:o.offsetTop>i.scrollTop+i.offsetHeight&&(this._elContent.scrollTop=o.offsetTop+o.offsetHeight-i.offsetHeight)),this._toggleHighlight(o,"to"),this.itemArrowToEvent.fire(this,o),this.typeAhead&&(this._updateValue(o),this._sCurQuery=o._sResultMatch))))},YAHOO.widget.AutoComplete.prototype._onContainerMouseover=function(e,t){for(var o=YAHOO.util.Event.getTarget(e),i=o.nodeName.toLowerCase();o&&"table"!=i;){switch(i){case"body":return;case"li":t.prehighlightClassName?t._togglePrehighlight(o,"mouseover"):t._toggleHighlight(o,"to"),t.itemMouseOverEvent.fire(t,o);break;case"div":if(YAHOO.util.Dom.hasClass(o,"yui-ac-container"))return void(t._bOverContainer=!0)}(o=o.parentNode)&&(i=o.nodeName.toLowerCase())}},YAHOO.widget.AutoComplete.prototype._onContainerMouseout=function(e,t){for(var o=YAHOO.util.Event.getTarget(e),i=o.nodeName.toLowerCase();o&&"table"!=i;){switch(i){case"body":return;case"li":t.prehighlightClassName?t._togglePrehighlight(o,"mouseout"):t._toggleHighlight(o,"from"),t.itemMouseOutEvent.fire(t,o);break;case"ul":t._toggleHighlight(t._elCurListItem,"to");break;case"div":if(YAHOO.util.Dom.hasClass(o,"yui-ac-container"))return void(t._bOverContainer=!1)}(o=o.parentNode)&&(i=o.nodeName.toLowerCase())}},YAHOO.widget.AutoComplete.prototype._onContainerClick=function(e,t){for(var o=YAHOO.util.Event.getTarget(e),i=o.nodeName.toLowerCase();o&&"table"!=i;){switch(i){case"body":return;case"li":return t._toggleHighlight(o,"to"),void t._selectItem(o)}(o=o.parentNode)&&(i=o.nodeName.toLowerCase())}},YAHOO.widget.AutoComplete.prototype._onContainerScroll=function(e,t){t._focus()},YAHOO.widget.AutoComplete.prototype._onContainerResize=function(e,t){t._toggleContainerHelpers(t._bContainerOpen)},YAHOO.widget.AutoComplete.prototype._onTextboxKeyDown=function(e,t){var o=e.keyCode;switch(-1!=t._nTypeAheadDelayID&&clearTimeout(t._nTypeAheadDelayID),o){case 9:(!YAHOO.env.ua.opera&&-1==navigator.userAgent.toLowerCase().indexOf("mac")||420<YAHOO.env.ua.webkit)&&(t._elCurListItem?(t.delimChar&&t._nKeyCode!=o&&t._bContainerOpen&&YAHOO.util.Event.stopEvent(e),t._selectItem(t._elCurListItem)):t._toggleContainer(!1));break;case 13:(!YAHOO.env.ua.opera&&-1==navigator.userAgent.toLowerCase().indexOf("mac")||420<YAHOO.env.ua.webkit)&&(t._elCurListItem?(t._nKeyCode!=o&&t._bContainerOpen&&YAHOO.util.Event.stopEvent(e),t._selectItem(t._elCurListItem)):t._toggleContainer(!1));break;case 27:return void t._toggleContainer(!1);case 39:t._jumpSelection();break;case 38:case 40:t._bContainerOpen&&(YAHOO.util.Event.stopEvent(e),t._moveSelection(o));break;default:t._bItemSelected=!1,t._toggleHighlight(t._elCurListItem,"from"),t.textboxKeyEvent.fire(t,o)}18===o&&t._enableIntervalDetection(),t._nKeyCode=o},YAHOO.widget.AutoComplete.prototype._onTextboxKeyPress=function(e,t){var o=e.keyCode;if(YAHOO.env.ua.opera||-1!=navigator.userAgent.toLowerCase().indexOf("mac")&&YAHOO.env.ua.webkit<420)switch(o){case 9:t._bContainerOpen&&(t.delimChar&&YAHOO.util.Event.stopEvent(e),t._elCurListItem?t._selectItem(t._elCurListItem):t._toggleContainer(!1));break;case 13:t._bContainerOpen&&(YAHOO.util.Event.stopEvent(e),t._elCurListItem?t._selectItem(t._elCurListItem):t._toggleContainer(!1))}else 229==o&&t._enableIntervalDetection()},YAHOO.widget.AutoComplete.prototype._onTextboxKeyUp=function(e,t){var o=this.value,e=(t._initProps(),e.keyCode);t._isIgnoreKey(e)||(-1!=t._nDelayID&&clearTimeout(t._nDelayID),t._nDelayID=setTimeout(function(){t._sendQuery(o)},1e3*t.queryDelay))},YAHOO.widget.AutoComplete.prototype._onTextboxFocus=function(e,t){t._bFocused||(t._elTextbox.setAttribute("autocomplete","off"),t._bFocused=!0,t._sInitInputValue=t._elTextbox.value,t.textboxFocusEvent.fire(t))},YAHOO.widget.AutoComplete.prototype._onTextboxBlur=function(e,t){var o;t._bOverContainer&&9!=t._nKeyCode?t._focus():(t._bItemSelected||(o=t._textMatchesOption(),!t._bContainerOpen||t._bContainerOpen&&null===o?t.forceSelection?t._clearSelection():t.unmatchedItemSelectEvent.fire(t,t._sCurQuery):t.forceSelection&&t._selectItem(o)),t._clearInterval(),t._bFocused=!1,t._sInitInputValue!==t._elTextbox.value&&t.textboxChangeEvent.fire(t),t.textboxBlurEvent.fire(t),t._toggleContainer(!1))},YAHOO.widget.AutoComplete.prototype._onWindowUnload=function(e,t){t&&t._elTextbox&&t.allowBrowserAutocomplete&&t._elTextbox.setAttribute("autocomplete","on")},YAHOO.widget.AutoComplete.prototype.doBeforeSendQuery=function(e){return this.generateRequest(e)},YAHOO.widget.AutoComplete.prototype.getListItems=function(){for(var e=[],t=this._elList.childNodes,o=t.length-1;0<=o;o--)e[o]=t[o];return e},YAHOO.widget.AutoComplete._cloneObject=function(e){if(!YAHOO.lang.isValue(e))return e;var t={};if(YAHOO.lang.isFunction(e))t=e;else if(YAHOO.lang.isArray(e)){for(var o=[],i=0,n=e.length;i<n;i++)o[i]=YAHOO.widget.AutoComplete._cloneObject(e[i]);t=o}else if(YAHOO.lang.isObject(e))for(var s in e)YAHOO.lang.hasOwnProperty(e,s)&&(YAHOO.lang.isValue(e[s])&&YAHOO.lang.isObject(e[s])||YAHOO.lang.isArray(e[s])?t[s]=YAHOO.widget.AutoComplete._cloneObject(e[s]):t[s]=e[s]);else t=e;return t},YAHOO.register("autocomplete",YAHOO.widget.AutoComplete,{version:"2.9.0",build:"2800"});
//# sourceMappingURL=autocomplete.js.map;
!function(){var u=YAHOO.util,t=function(t,e,i,n){this.init(t,e,i,n)};t.NAME="Anim",t.prototype={toString:function(){var t=this.getEl()||{},t=t.id||t.tagName;return this.constructor.NAME+": "+t},patterns:{noNegatives:/width|height|opacity|padding/i,offsetAttribute:/^((width|height)|(top|left))$/,defaultUnit:/width|height|top$|bottom$|left$|right$/i,offsetUnit:/\d+(em|%|en|ex|pt|in|cm|mm|pc)$/i},doMethod:function(t,e,i){return this.method(this.currentFrame,e,i-e,this.totalFrames)},setAttribute:function(t,e,i){var n=this.getEl();this.patterns.noNegatives.test(t)&&(e=0<e?e:0),t in n&&!("style"in n&&t in n.style)?n[t]=e:u.Dom.setStyle(n,t,e+i)},getAttribute:function(t){var e,i,n,r=this.getEl(),s=u.Dom.getStyle(r,t);return"auto"===s||this.patterns.offsetUnit.test(s)?(i=!!(e=this.patterns.offsetAttribute.exec(t)||[])[3],n=!!e[2],"style"in r?s=n||"absolute"==u.Dom.getStyle(r,"position")&&i?r["offset"+e[0].charAt(0).toUpperCase()+e[0].substr(1)]:0:t in r&&(s=r[t]),s):parseFloat(s)},getDefaultUnit:function(t){return this.patterns.defaultUnit.test(t)?"px":""},setRuntimeAttribute:function(t){var e,i=this.attributes,n=(this.runtimeAttributes[t]={},function(t){return void 0!==t});if(!n(i[t].to)&&!n(i[t].by))return!1;if(e=n(i[t].from)?i[t].from:this.getAttribute(t),n(i[t].to))r=i[t].to;else if(n(i[t].by))if(e.constructor==Array)for(var r=[],s=0,o=e.length;s<o;++s)r[s]=e[s]+ +i[t].by[s];else r=e+ +i[t].by;return this.runtimeAttributes[t].start=e,this.runtimeAttributes[t].end=r,this.runtimeAttributes[t].unit=n(i[t].unit)?i[t].unit:this.getDefaultUnit(t),!0},init:function(e,t,i,n){var r=!1,s=null,o=0;e=u.Dom.get(e),this.attributes=t||{},this.duration=YAHOO.lang.isUndefined(i)?1:i,this.method=n||u.Easing.easeNone,this.useSeconds=!0,this.currentFrame=0,this.totalFrames=u.AnimMgr.fps,this.setEl=function(t){e=u.Dom.get(t)},this.getEl=function(){return e},this.isAnimated=function(){return r},this.getStartTime=function(){return s},this.runtimeAttributes={},this.animate=function(){return!this.isAnimated()&&(this.currentFrame=0,this.totalFrames=this.useSeconds?Math.ceil(u.AnimMgr.fps*this.duration):this.duration,0===this.duration&&this.useSeconds&&(this.totalFrames=1),u.AnimMgr.registerElement(this),!0)},this.stop=function(t){if(!this.isAnimated())return!1;t&&(this.currentFrame=this.totalFrames,this._onTween.fire()),u.AnimMgr.stop(this)},this._handleStart=function(){for(var t in this.onStart.fire(),this.runtimeAttributes={},this.attributes)this.attributes.hasOwnProperty(t)&&this.setRuntimeAttribute(t);r=!0,o=0,s=new Date},this._handleTween=function(){var t,e={duration:new Date-this.getStartTime(),currentFrame:this.currentFrame,toString:function(){return"duration: "+e.duration+", currentFrame: "+e.currentFrame}},i=(this.onTween.fire(e),this.runtimeAttributes);for(t in i)i.hasOwnProperty(t)&&this.setAttribute(t,this.doMethod(t,i[t].start,i[t].end),i[t].unit);this.afterTween.fire(e),o+=1},this._handleComplete=function(){var t=(new Date-s)/1e3,e={duration:t,frames:o,fps:o/t,toString:function(){return"duration: "+e.duration+", frames: "+e.frames+", fps: "+e.fps}};r=!1,o=0,this.onComplete.fire(e)},this._onStart=new u.CustomEvent("_start",this,!0),this.onStart=new u.CustomEvent("start",this),this.onTween=new u.CustomEvent("tween",this),this.afterTween=new u.CustomEvent("afterTween",this),this._onTween=new u.CustomEvent("_tween",this,!0),this.onComplete=new u.CustomEvent("complete",this),this._onComplete=new u.CustomEvent("_complete",this,!0),this._onStart.subscribe(this._handleStart),this._onTween.subscribe(this._handleTween),this._onComplete.subscribe(this._handleComplete)}},u.Anim=t}(),YAHOO.util.AnimMgr=new function(){var n=null,r=[],s=0,e=(this.fps=1e3,this.delay=20,this.registerElement=function(t){r[r.length]=t,s+=1,t._onStart.fire(),this.start()},[]),t=!1,i=function(){var t=e.shift();!function(t,e){if(e=e||o(t),!t.isAnimated()||e===-1)return false;if(t._onComplete.fire(),r.splice(e,1),(s-=1)<=0)this.stop();return true}.apply(YAHOO.util.AnimMgr,t),e.length&&arguments.callee()},o=(this.unRegister=function(){e.push(arguments),t||(t=!0,i(),t=!1)},this.start=function(){null===n&&(n=setInterval(this.run,this.delay))},this.stop=function(t){if(t)this.unRegister(t);else{clearInterval(n);for(var e=0,i=r.length;e<i;++e)this.unRegister(r[0],0);r=[],n=null,s=0}},this.run=function(){for(var t=0,e=r.length;t<e;++t){var i=r[t];i&&i.isAnimated()&&(i.currentFrame<i.totalFrames||null===i.totalFrames?(i.currentFrame+=1,i.useSeconds&&u(i),i._onTween.fire()):YAHOO.util.AnimMgr.stop(i,t))}},function(t){for(var e=0,i=r.length;e<i;++e)if(r[e]===t)return e;return-1}),u=function(t){var e=t.totalFrames,i=t.currentFrame,n=t.currentFrame*t.duration*1e3/t.totalFrames,r=new Date-t.getStartTime(),s=0;0<(s=r<1e3*t.duration?Math.round((r/n-1)*t.currentFrame):e-(i+1))&&isFinite(s)&&(t.currentFrame+s>=e&&(s=e-(i+1)),t.currentFrame+=s)};this._queue=r,this._getIndex=o},YAHOO.util.Bezier=new function(){this.getPosition=function(t,e){for(var i=t.length,n=[],r=0;r<i;++r)n[r]=[t[r][0],t[r][1]];for(var s=1;s<i;++s)for(r=0;r<i-s;++r)n[r][0]=(1-e)*n[r][0]+e*n[parseInt(r+1,10)][0],n[r][1]=(1-e)*n[r][1]+e*n[parseInt(r+1,10)][1];return[n[0][0],n[0][1]]}},function(){var r=function(t,e,i,n){r.superclass.constructor.call(this,t,e,i,n)},s=(r.NAME="ColorAnim",r.DEFAULT_BGCOLOR="#fff",YAHOO.util),o=(YAHOO.extend(r,s.Anim),r.superclass),t=r.prototype;t.patterns.color=/color$/i,t.patterns.rgb=/^rgb\(([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\)$/i,t.patterns.hex=/^#?([0-9A-F]{2})([0-9A-F]{2})([0-9A-F]{2})$/i,t.patterns.hex3=/^#?([0-9A-F]{1})([0-9A-F]{1})([0-9A-F]{1})$/i,t.patterns.transparent=/^transparent|rgba\(0, 0, 0, 0\)$/,t.parseColor=function(t){var e;return 3==t.length?t:(e=this.patterns.hex.exec(t))&&4==e.length?[parseInt(e[1],16),parseInt(e[2],16),parseInt(e[3],16)]:(e=this.patterns.rgb.exec(t))&&4==e.length?[parseInt(e[1],10),parseInt(e[2],10),parseInt(e[3],10)]:(e=this.patterns.hex3.exec(t))&&4==e.length?[parseInt(e[1]+e[1],16),parseInt(e[2]+e[2],16),parseInt(e[3]+e[3],16)]:null},t.getAttribute=function(t){var e,i,n=this.getEl();return this.patterns.color.test(t)?(i=YAHOO.util.Dom.getStyle(n,t),(e=this).patterns.transparent.test(i)&&(n=YAHOO.util.Dom.getAncestorBy(n,function(t){return!e.patterns.transparent.test(i)}),i=n?s.Dom.getStyle(n,t):r.DEFAULT_BGCOLOR)):i=o.getAttribute.call(this,t),i},t.doMethod=function(t,e,i){if(this.patterns.color.test(t)){for(var n=[],r=0,s=e.length;r<s;++r)n[r]=o.doMethod.call(this,t,e[r],i[r]);n="rgb("+Math.floor(n[0])+","+Math.floor(n[1])+","+Math.floor(n[2])+")"}else n=o.doMethod.call(this,t,e,i);return n},t.setRuntimeAttribute=function(t){if(o.setRuntimeAttribute.call(this,t),this.patterns.color.test(t)){var e=this.attributes,i=this.parseColor(this.runtimeAttributes[t].start),n=this.parseColor(this.runtimeAttributes[t].end);if("undefined"==typeof e[t].to&&"undefined"!=typeof e[t].by)for(var n=this.parseColor(e[t].by),r=0,s=i.length;r<s;++r)n[r]=i[r]+n[r];this.runtimeAttributes[t].start=i,this.runtimeAttributes[t].end=n}},s.ColorAnim=r}(),YAHOO.util.Easing={easeNone:function(t,e,i,n){return i*t/n+e},easeIn:function(t,e,i,n){return i*(t/=n)*t+e},easeOut:function(t,e,i,n){return-i*(t/=n)*(t-2)+e},easeBoth:function(t,e,i,n){return(t/=n/2)<1?i/2*t*t+e:-i/2*(--t*(t-2)-1)+e},easeInStrong:function(t,e,i,n){return i*(t/=n)*t*t*t+e},easeOutStrong:function(t,e,i,n){return-i*((t=t/n-1)*t*t*t-1)+e},easeBothStrong:function(t,e,i,n){return(t/=n/2)<1?i/2*t*t*t*t+e:-i/2*((t-=2)*t*t*t-2)+e},elasticIn:function(t,e,i,n,r,s){return 0==t?e:1==(t/=n)?e+i:(s=s||.3*n,i=!r||r<Math.abs(i)?(r=i,s/4):s/(2*Math.PI)*Math.asin(i/r),-(r*Math.pow(2,10*--t)*Math.sin((t*n-i)*(2*Math.PI)/s))+e)},elasticOut:function(t,e,i,n,r,s){var o;return 0==t?e:1==(t/=n)?e+i:(s=s||.3*n,o=!r||r<Math.abs(i)?(r=i,s/4):s/(2*Math.PI)*Math.asin(i/r),r*Math.pow(2,-10*t)*Math.sin((t*n-o)*(2*Math.PI)/s)+i+e)},elasticBoth:function(t,e,i,n,r,s){var o;return 0==t?e:2==(t/=n/2)?e+i:(s=s||n*(.3*1.5),o=!r||r<Math.abs(i)?(r=i,s/4):s/(2*Math.PI)*Math.asin(i/r),t<1?r*Math.pow(2,10*--t)*Math.sin((t*n-o)*(2*Math.PI)/s)*-.5+e:r*Math.pow(2,-10*--t)*Math.sin((t*n-o)*(2*Math.PI)/s)*.5+i+e)},backIn:function(t,e,i,n,r){return i*(t/=n)*t*(((r=void 0===r?1.70158:r)+1)*t-r)+e},backOut:function(t,e,i,n,r){return i*((t=t/n-1)*t*(((r=void 0===r?1.70158:r)+1)*t+r)+1)+e},backBoth:function(t,e,i,n,r){return void 0===r&&(r=1.70158),(t/=n/2)<1?i/2*(t*t*((1+(r*=1.525))*t-r))+e:i/2*((t-=2)*t*((1+(r*=1.525))*t+r)+2)+e},bounceIn:function(t,e,i,n){return i-YAHOO.util.Easing.bounceOut(n-t,0,i,n)+e},bounceOut:function(t,e,i,n){return(t/=n)<1/2.75?i*(7.5625*t*t)+e:t<2/2.75?i*(7.5625*(t-=1.5/2.75)*t+.75)+e:t<2.5/2.75?i*(7.5625*(t-=2.25/2.75)*t+.9375)+e:i*(7.5625*(t-=2.625/2.75)*t+.984375)+e},bounceBoth:function(t,e,i,n){return t<n/2?.5*YAHOO.util.Easing.bounceIn(2*t,0,i,n)+e:.5*YAHOO.util.Easing.bounceOut(2*t-n,0,i,n)+.5*i+e}},function(){var r=function(t,e,i,n){t&&r.superclass.constructor.call(this,t,e,i,n)},h=(r.NAME="Motion",YAHOO.util),l=(YAHOO.extend(r,h.ColorAnim),r.superclass),t=r.prototype,c=(t.patterns.points=/^points$/i,t.setAttribute=function(t,e,i){this.patterns.points.test(t)?(l.setAttribute.call(this,"left",e[0],i=i||"px"),l.setAttribute.call(this,"top",e[1],i)):l.setAttribute.call(this,t,e,i)},t.getAttribute=function(t){t=this.patterns.points.test(t)?[l.getAttribute.call(this,"left"),l.getAttribute.call(this,"top")]:l.getAttribute.call(this,t);return t},t.doMethod=function(t,e,i){var n;return this.patterns.points.test(t)?(n=this.method(this.currentFrame,0,100,this.totalFrames)/100,h.Bezier.getPosition(this.runtimeAttributes[t],n)):l.doMethod.call(this,t,e,i)},t.setRuntimeAttribute=function(t){if(this.patterns.points.test(t)){var e,i=this.getEl(),n=this.attributes,r=n.points.control||[];if(0<r.length&&!(r[0]instanceof Array))r=[r];else{for(var s=[],o=0,u=r.length;o<u;++o)s[o]=r[o];r=s}if("static"==h.Dom.getStyle(i,"position")&&h.Dom.setStyle(i,"position","relative"),f(n.points.from)?h.Dom.setXY(i,n.points.from):h.Dom.setXY(i,h.Dom.getXY(i)),e=this.getAttribute("points"),f(n.points.to)){var a=c.call(this,n.points.to,e);h.Dom.getXY(this.getEl());for(o=0,u=r.length;o<u;++o)r[o]=c.call(this,r[o],e)}else if(f(n.points.by))for(a=[e[0]+n.points.by[0],e[1]+n.points.by[1]],o=0,u=r.length;o<u;++o)r[o]=[e[0]+r[o][0],e[1]+r[o][1]];this.runtimeAttributes[t]=[e],0<r.length&&(this.runtimeAttributes[t]=this.runtimeAttributes[t].concat(r)),this.runtimeAttributes[t][this.runtimeAttributes[t].length]=a}else l.setRuntimeAttribute.call(this,t)},function(t,e){var i=h.Dom.getXY(this.getEl());return t=[t[0]-i[0]+e[0],t[1]-i[1]+e[1]]}),f=function(t){return void 0!==t};h.Motion=r}(),function(){var r=function(t,e,i,n){t&&r.superclass.constructor.call(this,t,e,i,n)},t=(r.NAME="Scroll",YAHOO.util),s=(YAHOO.extend(r,t.ColorAnim),r.superclass),e=r.prototype;e.doMethod=function(t,e,i){return"scroll"==t?[this.method(this.currentFrame,e[0],i[0]-e[0],this.totalFrames),this.method(this.currentFrame,e[1],i[1]-e[1],this.totalFrames)]:s.doMethod.call(this,t,e,i)},e.getAttribute=function(t){var e=this.getEl();return"scroll"==t?[e.scrollLeft,e.scrollTop]:s.getAttribute.call(this,t)},e.setAttribute=function(t,e,i){var n=this.getEl();"scroll"==t?(n.scrollLeft=e[0],n.scrollTop=e[1]):s.setAttribute.call(this,t,e,i)},t.Scroll=r}(),YAHOO.register("animation",YAHOO.util.Anim,{version:"2.9.0",build:"2800"});
//# sourceMappingURL=animation.js.map;
YAHOO.util.Get=function(){var m={},s=0,r=0,u=!1,h=YAHOO.env.ua,g=YAHOO.lang,i=function(t,e,n){var r,i=(n||window).document.createElement(t);for(r in e)e.hasOwnProperty(r)&&i.setAttribute(r,e[r]);return i},o=function(t,e,n){t={id:"yui__dyn_"+r++,type:"text/css",rel:"stylesheet",href:t};return n&&g.augmentObject(t,n),i("link",t,e)},c=function(t,e,n){t={id:"yui__dyn_"+r++,type:"text/javascript",src:t};return n&&g.augmentObject(t,n),i("script",t,e)},a=function(t,e){return{tId:t.tId,win:t.win,data:t.data,nodes:t.nodes,msg:e,purge:function(){w(this.tId)}}},l=function(t,e){var n=m[e],n=g.isString(t)?n.win.document.getElementById(t):t;return n||v(e,"target node not found: "+t),n},d=function(t){var e=m[t];e.finished=!0,e.aborted?v(t,"transaction "+t+" was aborted"):e.onSuccess&&(t=e.scope||e.win,e.onSuccess.call(t,a(e)))},f=function(t){var e,t=m[t];t.onTimeout&&(e=t.scope||t,t.onTimeout.call(e,a(t)))},O=function(t,e){var n,r=m[t],i=r.win,a=i.document.getElementsByTagName("head")[0];if(r.timer&&r.timer.cancel(),r.aborted)v(t,"transaction "+t+" was aborted");else if(e?(r.url.shift(),r.varName&&r.varName.shift()):(r.url=g.isString(r.url)?[r.url]:r.url,r.varName&&(r.varName=g.isString(r.varName)?[r.varName]:r.varName)),0===r.url.length)"script"===r.type&&h.webkit&&h.webkit<420&&!r.finalpass&&!r.varName?((e=c(null,r.win,r.attributes)).innerHTML='YAHOO.util.Get._finalize("'+t+'");',r.nodes.push(e),a.appendChild(e)):d(t);else{if(!(e=r.url[0]))return r.url.shift(),O(t);r.timeout&&(r.timer=g.later(r.timeout,r,f,t)),n=("script"===r.type?c:o)(e,i,r.attributes),p(r.type,n,t,e,i,r.url.length),r.nodes.push(n),r.insertBefore?(i=l(r.insertBefore,t))&&i.parentNode.insertBefore(n,i):a.appendChild(n),(h.webkit||h.gecko)&&"css"===r.type&&O(t,e)}},n=function(t,e,n){var r,i,a="q"+s++;if(n=n||{},s%YAHOO.util.Get.PURGE_THRESH==0&&!u){for(r in u=!0,m)m.hasOwnProperty(r)&&(i=m[r]).autopurge&&i.finished&&(w(i.tId),delete m[r]);u=!1}return m[a]=g.merge(n,{tId:a,type:t,url:e,finished:!1,aborted:!1,nodes:[]}),(e=m[a]).win=e.win||window,e.scope=e.scope||e.win,e.autopurge="autopurge"in e?e.autopurge:"script"===t,e.attributes=e.attributes||{},e.attributes.charset=n.charset||e.attributes.charset||"utf-8",g.later(0,e,O,a),{tId:a}},p=function(t,e,n,r,i,a,s){var u,o,c,l,d,f,p=s||O;h.ie?e.onreadystatechange=function(){"loaded"!==(u=this.readyState)&&"complete"!==u||(e.onreadystatechange=null,p(n,r))}:h.webkit?"script"===t&&(420<=h.webkit?e.addEventListener("load",function(){p(n,r)}):(o=m[n]).varName?(s=YAHOO.util.Get.POLL_FREQ,o.maxattempts=YAHOO.util.Get.TIMEOUT/s,o.attempts=0,o._cache=o.varName[0].split("."),o.timer=g.later(s,o,function(t){for(c=this._cache,d=c.length,l=this.win,f=0;f<d;f+=1)if(!(l=l[c[f]]))return this.attempts++,void(this.attempts++>this.maxattempts&&(o.timer.cancel(),v(n,"Over retry limit, giving up")));o.timer.cancel(),p(n,r)},null,!0)):g.later(YAHOO.util.Get.POLL_FREQ,null,p,[n,r])):e.onload=function(){p(n,r)}},v=function(t,e){var n,t=m[t];t.onFailure&&(n=t.scope||t.win,t.onFailure.call(n,a(t,e)))},w=function(t){if(m[t]){var e,n,r,i=m[t],a=i.nodes,s=a.length,u=i.win.document.getElementsByTagName("head")[0];for(i.insertBefore&&(t=l(i.insertBefore,t))&&(u=t.parentNode),e=0;e<s;e+=1){if((n=a[e]).clearAttributes)n.clearAttributes();else for(r in n)n.hasOwnProperty(r)&&delete n[r];u.removeChild(n)}i.nodes=[]}};return{POLL_FREQ:10,PURGE_THRESH:20,TIMEOUT:2e3,_finalize:function(t){g.later(0,null,d,t)},abort:function(t){t=g.isString(t)?t:t.tId,t=m[t];t&&(t.aborted=!0)},script:function(t,e){return n("script",t,e)},css:function(t,e){return n("css",t,e)}}}(),YAHOO.register("get",YAHOO.util.Get,{version:"2.9.0",build:"2800"});
//# sourceMappingURL=get.js.map;
!function(){var o=YAHOO.util.Dom.getXY,h=YAHOO.util.Event,i=Array.prototype.slice;function l(t,i,e,n){l.ANIM_AVAIL=!YAHOO.lang.isUndefined(YAHOO.util.Anim),t&&(this.init(t,i,!0),this.initSlider(n),this.initThumb(e))}YAHOO.lang.augmentObject(l,{getHorizSlider:function(t,i,e,n,s){return new l(t,t,new YAHOO.widget.SliderThumb(i,t,e,n,0,0,s),"horiz")},getVertSlider:function(t,i,e,n,s){return new l(t,t,new YAHOO.widget.SliderThumb(i,t,0,0,e,n,s),"vert")},getSliderRegion:function(t,i,e,n,s,a,h){return new l(t,t,new YAHOO.widget.SliderThumb(i,t,e,n,s,a,h),"region")},SOURCE_UI_EVENT:1,SOURCE_SET_VALUE:2,SOURCE_KEY_EVENT:3,ANIM_AVAIL:!1},!0),YAHOO.extend(l,YAHOO.util.DragDrop,{_mouseDown:!1,dragOnly:!0,initSlider:function(t){this.type=t,this.createEvent("change",this),this.createEvent("slideStart",this),this.createEvent("slideEnd",this),this.isTarget=!1,this.animate=l.ANIM_AVAIL,this.backgroundEnabled=!0,this.tickPause=40,this.enableKeys=!0,this.keyIncrement=20,this.moveComplete=!0,this.animationDuration=.2,this.SOURCE_UI_EVENT=1,this.SOURCE_SET_VALUE=2,this.valueChangeSource=0,this._silent=!1,this.lastOffset=[0,0]},initThumb:function(t){var i=this;(this.thumb=t).cacheBetweenDrags=!0,t._isHoriz&&t.xTicks&&t.xTicks.length?this.tickPause=Math.round(360/t.xTicks.length):t.yTicks&&t.yTicks.length&&(this.tickPause=Math.round(360/t.yTicks.length)),t.onAvailable=function(){return i.setStartSliderState()},t.onMouseDown=function(){return i._mouseDown=!0,i.focus()},t.startDrag=function(){i._slideStart()},t.onDrag=function(){i.fireEvents(!0)},t.onMouseUp=function(){i.thumbMouseUp()}},onAvailable:function(){this._bindKeyEvents()},_bindKeyEvents:function(){h.on(this.id,"keydown",this.handleKeyDown,this,!0),h.on(this.id,"keypress",this.handleKeyPress,this,!0)},handleKeyPress:function(t){if(this.enableKeys)switch(h.getCharCode(t)){case 37:case 38:case 39:case 40:case 36:case 35:h.preventDefault(t)}},handleKeyDown:function(t){if(this.enableKeys){var i=h.getCharCode(t),e=this.thumb,n=this.getXValue(),s=this.getYValue(),a=!0;switch(i){case 37:n-=this.keyIncrement;break;case 38:s-=this.keyIncrement;break;case 39:n+=this.keyIncrement;break;case 40:s+=this.keyIncrement;break;case 36:n=e.leftConstraint,s=e.topConstraint;break;case 35:n=e.rightConstraint,s=e.bottomConstraint;break;default:a=!1}a&&(e._isRegion?this._setRegionValue(l.SOURCE_KEY_EVENT,n,s,!0):this._setValue(l.SOURCE_KEY_EVENT,e._isHoriz?n:s,!0),h.stopEvent(t))}},setStartSliderState:function(){this.setThumbCenterPoint(),this.baselinePos=o(this.getEl()),this.thumb.startOffset=this.thumb.getOffsetFromParent(this.baselinePos),this.thumb._isRegion?this.deferredSetRegionValue?(this._setRegionValue.apply(this,this.deferredSetRegionValue),this.deferredSetRegionValue=null):this.setRegionValue(0,0,!0,!0,!0):this.deferredSetValue?(this._setValue.apply(this,this.deferredSetValue),this.deferredSetValue=null):this.setValue(0,!0,!0,!0)},setThumbCenterPoint:function(){var t=this.thumb.getEl();t&&(this.thumbCenterPoint={x:parseInt(t.offsetWidth/2,10),y:parseInt(t.offsetHeight/2,10)})},lock:function(){this.thumb.lock(),this.locked=!0},unlock:function(){this.thumb.unlock(),this.locked=!1},thumbMouseUp:function(){this._mouseDown=!1,this.isLocked()||this.endMove()},onMouseUp:function(){this._mouseDown=!1,this.backgroundEnabled&&!this.isLocked()&&this.endMove()},getThumb:function(){return this.thumb},focus:function(){this.valueChangeSource=l.SOURCE_UI_EVENT;var t=this.getEl();if(t.focus)try{t.focus()}catch(i){}return this.verifyOffset(),!this.isLocked()},onChange:function(t,i){},onSlideStart:function(){},onSlideEnd:function(){},getValue:function(){return this.thumb.getValue()},getXValue:function(){return this.thumb.getXValue()},getYValue:function(){return this.thumb.getYValue()},setValue:function(){var t=i.call(arguments);return t.unshift(l.SOURCE_SET_VALUE),this._setValue.apply(this,t)},_setValue:function(t,i,e,n,s){var a,h=this.thumb;return h.available?!(this.isLocked()&&!n||isNaN(i)||h._isRegion||(this._silent=s,this.valueChangeSource=t||l.SOURCE_SET_VALUE,h.lastOffset=[i,i],this.verifyOffset(),this._slideStart(),h._isHoriz?(a=h.initPageX+i+this.thumbCenterPoint.x,this.moveThumb(a,h.initPageY,e)):(a=h.initPageY+i+this.thumbCenterPoint.y,this.moveThumb(h.initPageX,a,e)),0)):(this.deferredSetValue=arguments,!1)},setRegionValue:function(){var t=i.call(arguments);return t.unshift(l.SOURCE_SET_VALUE),this._setRegionValue.apply(this,t)},_setRegionValue:function(t,i,e,n,s,a){var h,r=this.thumb;return r.available?!(this.isLocked()&&!s||isNaN(i)||!r._isRegion||(this._silent=a,this.valueChangeSource=t||l.SOURCE_SET_VALUE,r.lastOffset=[i,e],this.verifyOffset(),this._slideStart(),h=r.initPageX+i+this.thumbCenterPoint.x,r=r.initPageY+e+this.thumbCenterPoint.y,this.moveThumb(h,r,n),0)):(this.deferredSetRegionValue=arguments,!1)},verifyOffset:function(){var t=o(this.getEl()),i=this.thumb;return this.thumbCenterPoint&&this.thumbCenterPoint.x||this.setThumbCenterPoint(),!t||t[0]==this.baselinePos[0]&&t[1]==this.baselinePos[1]||(this.setInitPosition(),this.baselinePos=t,i.initPageX=this.initPageX+i.startOffset[0],i.initPageY=this.initPageY+i.startOffset[1],i.deltaSetXY=null,this.resetThumbConstraints(),!1)},moveThumb:function(t,i,e,n){var s,a,h=this.thumb,r=this;h.available&&(h.setDelta(this.thumbCenterPoint.x,this.thumbCenterPoint.y),a=h.getTargetCoord(t,i),s=[Math.round(a.x),Math.round(a.y)],this.animate&&h._graduated&&!e?(this.lock(),this.curCoord=o(this.thumb.getEl()),this.curCoord=[Math.round(this.curCoord[0]),Math.round(this.curCoord[1])],setTimeout(function(){r.moveOneTick(s)},this.tickPause)):this.animate&&l.ANIM_AVAIL&&!e?(this.lock(),(a=new YAHOO.util.Motion(h.id,{points:{to:s}},this.animationDuration,YAHOO.util.Easing.easeOut)).onComplete.subscribe(function(){r.unlock(),r._mouseDown||r.endMove()}),a.animate()):(h.setDragElPos(t,i),n||this._mouseDown||this.endMove()))},_slideStart:function(){this._sliding||(this._silent||(this.onSlideStart(),this.fireEvent("slideStart")),this._sliding=!0,this.moveComplete=!1)},_slideEnd:function(){var t;this._sliding&&(t=this._silent,this._sliding=!1,this.moveComplete=!0,this._silent=!1,t||(this.onSlideEnd(),this.fireEvent("slideEnd")))},moveOneTick:function(t){var i,e,n=this.thumb,s=this,a=null;(a=n._isRegion?(i=(null!==(a=this._getNextX(this.curCoord,t))?a:this.curCoord)[0],e=(null!==(a=this._getNextY(this.curCoord,t))?a:this.curCoord)[1],i!==this.curCoord[0]||e!==this.curCoord[1]?[i,e]:null):n._isHoriz?this._getNextX(this.curCoord,t):this._getNextY(this.curCoord,t))&&(this.curCoord=a,this.thumb.alignElWithMouse(n.getEl(),a[0]+this.thumbCenterPoint.x,a[1]+this.thumbCenterPoint.y),a[0]!=t[0]||a[1]!=t[1])?setTimeout(function(){s.moveOneTick(t)},this.tickPause):(this.unlock(),this._mouseDown||this.endMove())},_getNextX:function(t,i){var e,n=this.thumb,s=[],a=null;return t[0]>i[0]?(e=n.tickSize-this.thumbCenterPoint.x,a=[(s=n.getTargetCoord(t[0]-e,t[1])).x,s.y]):t[0]<i[0]&&(e=n.tickSize+this.thumbCenterPoint.x,a=[(s=n.getTargetCoord(t[0]+e,t[1])).x,s.y]),a},_getNextY:function(t,i){var e,n=this.thumb,s=[],a=null;return t[1]>i[1]?(e=n.tickSize-this.thumbCenterPoint.y,a=[(s=n.getTargetCoord(t[0],t[1]-e)).x,s.y]):t[1]<i[1]&&(e=n.tickSize+this.thumbCenterPoint.y,a=[(s=n.getTargetCoord(t[0],t[1]+e)).x,s.y]),a},b4MouseDown:function(t){if(!this.backgroundEnabled)return!1;this.thumb.autoOffset(),this.baselinePos=[]},onMouseDown:function(t){if(!this.backgroundEnabled||this.isLocked())return!1;this._mouseDown=!0;var i=h.getPageX(t),t=h.getPageY(t);this.focus(),this._slideStart(),this.moveThumb(i,t)},onDrag:function(t){var i;this.backgroundEnabled&&!this.isLocked()&&(i=h.getPageX(t),t=h.getPageY(t),this.moveThumb(i,t,!0,!0),this.fireEvents())},endMove:function(){this.unlock(),this.fireEvents(),this._slideEnd()},resetThumbConstraints:function(){var t=this.thumb;t.setXConstraint(t.leftConstraint,t.rightConstraint,t.xTickSize),t.setYConstraint(t.topConstraint,t.bottomConstraint,t.xTickSize)},fireEvents:function(t){var i,e=this.thumb;t||e.cachePosition(),this.isLocked()||(e._isRegion?(t=e.getXValue(),i=e.getYValue(),t==this.previousX&&i==this.previousY||this._silent||(this.onChange(t,i),this.fireEvent("change",{x:t,y:i})),this.previousX=t,this.previousY=i):((t=e.getValue())==this.previousVal||this._silent||(this.onChange(t),this.fireEvent("change",t)),this.previousVal=t))},toString:function(){return"Slider ("+this.type+") "+this.id}}),YAHOO.lang.augmentProto(l,YAHOO.util.EventProvider),YAHOO.widget.Slider=l}(),YAHOO.widget.SliderThumb=function(t,i,e,n,s,a,h){t&&(YAHOO.widget.SliderThumb.superclass.constructor.call(this,t,i),this.parentElId=i),this.isTarget=!1,this.tickSize=h,this.maintainOffset=!0,this.initSlider(e,n,s,a,h),this.scroll=!1},YAHOO.extend(YAHOO.widget.SliderThumb,YAHOO.util.DD,{startOffset:null,dragOnly:!0,_isHoriz:!1,_prevVal:0,_graduated:!1,getOffsetFromParent0:function(t){var i=YAHOO.util.Dom.getXY(this.getEl()),t=t||YAHOO.util.Dom.getXY(this.parentElId);return[i[0]-t[0],i[1]-t[1]]},getOffsetFromParent:function(t){var i,e,n=this.getEl();return this.deltaOffset?(i=parseInt(YAHOO.util.Dom.getStyle(n,"left"),10),e=parseInt(YAHOO.util.Dom.getStyle(n,"top"),10),i=[i+this.deltaOffset[0],e+this.deltaOffset[1]]):(e=YAHOO.util.Dom.getXY(n),t=t||YAHOO.util.Dom.getXY(this.parentElId),i=[e[0]-t[0],e[1]-t[1]],e=parseInt(YAHOO.util.Dom.getStyle(n,"left"),10),t=parseInt(YAHOO.util.Dom.getStyle(n,"top"),10),n=e-i[0],e=t-i[1],isNaN(n)||isNaN(e)||(this.deltaOffset=[n,e])),i},initSlider:function(t,i,e,n,s){this.initLeft=t,this.initRight=i,this.initUp=e,this.initDown=n,this.setXConstraint(t,i,s),this.setYConstraint(e,n,s),s&&1<s&&(this._graduated=!0),this._isHoriz=t||i,this._isVert=e||n,this._isRegion=this._isHoriz&&this._isVert},clearTicks:function(){YAHOO.widget.SliderThumb.superclass.clearTicks.call(this),this.tickSize=0,this._graduated=!1},getValue:function(){return this._isHoriz?this.getXValue():this.getYValue()},getXValue:function(){var t;return this.available?(t=this.getOffsetFromParent(),YAHOO.lang.isNumber(t[0])?(this.lastOffset=t)[0]-this.startOffset[0]:this.lastOffset[0]-this.startOffset[0]):0},getYValue:function(){var t;return this.available?(t=this.getOffsetFromParent(),YAHOO.lang.isNumber(t[1])?(this.lastOffset=t)[1]-this.startOffset[1]:this.lastOffset[1]-this.startOffset[1]):0},toString:function(){return"SliderThumb "+this.id},onChange:function(t,i){}}),function(){var i=YAHOO.util.Event,h=YAHOO.widget;function r(t,i,e,n){var s,a,h=this,r={min:!1,max:!1};this.minSlider=t,this.maxSlider=i,this.activeSlider=t,this.isHoriz=t.thumb._isHoriz,s=this.minSlider.thumb.onMouseDown,a=this.maxSlider.thumb.onMouseDown,this.minSlider.thumb.onMouseDown=function(){h.activeSlider=h.minSlider,s.apply(this,arguments)},this.maxSlider.thumb.onMouseDown=function(){h.activeSlider=h.maxSlider,a.apply(this,arguments)},this.minSlider.thumb.onAvailable=function(){t.setStartSliderState(),r.min=!0,r.max&&h.fireEvent("ready",h)},this.maxSlider.thumb.onAvailable=function(){i.setStartSliderState(),r.max=!0,r.min&&h.fireEvent("ready",h)},t.onMouseDown=i.onMouseDown=function(t){return this.backgroundEnabled&&h._handleMouseDown(t)},t.onDrag=i.onDrag=function(t){h._handleDrag(t)},t.onMouseUp=i.onMouseUp=function(t){h._handleMouseUp(t)},t._bindKeyEvents=function(){h._bindKeyEvents(this)},i._bindKeyEvents=function(){},t.subscribe("change",this._handleMinChange,t,this),t.subscribe("slideStart",this._handleSlideStart,t,this),t.subscribe("slideEnd",this._handleSlideEnd,t,this),i.subscribe("change",this._handleMaxChange,i,this),i.subscribe("slideStart",this._handleSlideStart,i,this),i.subscribe("slideEnd",this._handleSlideEnd,i,this),this.createEvent("ready",this),this.createEvent("change",this),this.createEvent("slideStart",this),this.createEvent("slideEnd",this),(n=YAHOO.lang.isArray(n)?n:[0,e])[0]=Math.min(Math.max(0|parseInt(n[0],10),0),e),n[1]=Math.max(Math.min(0|parseInt(n[1],10),e),0),n[0]>n[1]&&n.splice(0,2,n[1],n[0]),this.minVal=n[0],this.maxVal=n[1],this.minSlider.setValue(this.minVal,!0,!0,!0),this.maxSlider.setValue(this.maxVal,!0,!0,!0)}r.prototype={minVal:-1,maxVal:-1,minRange:0,_handleSlideStart:function(t,i){this.fireEvent("slideStart",i)},_handleSlideEnd:function(t,i){this.fireEvent("slideEnd",i)},_handleDrag:function(t){h.Slider.prototype.onDrag.call(this.activeSlider,t)},_handleMinChange:function(){this.activeSlider=this.minSlider,this.updateValue()},_handleMaxChange:function(){this.activeSlider=this.maxSlider,this.updateValue()},_bindKeyEvents:function(t){i.on(t.id,"keydown",this._handleKeyDown,this,!0),i.on(t.id,"keypress",this._handleKeyPress,this,!0)},_handleKeyDown:function(t){this.activeSlider.handleKeyDown.apply(this.activeSlider,arguments)},_handleKeyPress:function(t){this.activeSlider.handleKeyPress.apply(this.activeSlider,arguments)},setValues:function(t,i,e,n,s){var a=this.minSlider,h=this.maxSlider,r=a.thumb,o=h.thumb,l=this,u={min:!1,max:!1};r._isHoriz?(r.setXConstraint(r.leftConstraint,o.rightConstraint,r.tickSize),o.setXConstraint(r.leftConstraint,o.rightConstraint,o.tickSize)):(r.setYConstraint(r.topConstraint,o.bottomConstraint,r.tickSize),o.setYConstraint(r.topConstraint,o.bottomConstraint,o.tickSize)),this._oneTimeCallback(a,"slideEnd",function(){u.min=!0,u.max&&(l.updateValue(s),setTimeout(function(){l._cleanEvent(a,"slideEnd"),l._cleanEvent(h,"slideEnd")},0))}),this._oneTimeCallback(h,"slideEnd",function(){u.max=!0,u.min&&(l.updateValue(s),setTimeout(function(){l._cleanEvent(a,"slideEnd"),l._cleanEvent(h,"slideEnd")},0))}),a.setValue(t,e,n,!1),h.setValue(i,e,n,!1)},setMinValue:function(t,i,e,n){var s,a=this.minSlider;this.activeSlider=a,(s=this)._oneTimeCallback(a,"slideEnd",function(){s.updateValue(n),setTimeout(function(){s._cleanEvent(a,"slideEnd")},0)}),a.setValue(t,i,e)},setMaxValue:function(t,i,e,n){var s=this.maxSlider,a=this;this.activeSlider=s,this._oneTimeCallback(s,"slideEnd",function(){a.updateValue(n),setTimeout(function(){a._cleanEvent(s,"slideEnd")},0)}),s.setValue(t,i,e)},updateValue:function(t){var i,e,n,s,a=this.minSlider.getValue(),h=this.maxSlider.getValue(),r=!1;a==this.minVal&&h==this.maxVal||(r=!0,i=this.minSlider.thumb,e=this.maxSlider.thumb,s=this.isHoriz?"x":"y",s=this.minSlider.thumbCenterPoint[s]+this.maxSlider.thumbCenterPoint[s],n=Math.max(h-s-this.minRange,0),s=Math.min(-a-s-this.minRange,0),this.isHoriz?(n=Math.min(n,e.rightConstraint),i.setXConstraint(i.leftConstraint,n,i.tickSize),e.setXConstraint(s,e.rightConstraint,e.tickSize)):(n=Math.min(n,e.bottomConstraint),i.setYConstraint(i.leftConstraint,n,i.tickSize),e.setYConstraint(s,e.bottomConstraint,e.tickSize))),this.minVal=a,this.maxVal=h,r&&!t&&this.fireEvent("change",this)},selectActiveSlider:function(t){var i=this.minSlider,e=this.maxSlider,n=i.isLocked()||!i.backgroundEnabled,s=e.isLocked()||!i.backgroundEnabled,a=YAHOO.util.Event;n||s?this.activeSlider=n?e:i:(s=this.isHoriz?a.getPageX(t)-i.thumb.initPageX-i.thumbCenterPoint.x:a.getPageY(t)-i.thumb.initPageY-i.thumbCenterPoint.y,this.activeSlider=2*s>e.getValue()+i.getValue()?e:i)},_handleMouseDown:function(t){return!(t._handled||this.minSlider._sliding||this.maxSlider._sliding)&&(t._handled=!0,this.selectActiveSlider(t),h.Slider.prototype.onMouseDown.call(this.activeSlider,t))},_handleMouseUp:function(t){h.Slider.prototype.onMouseUp.apply(this.activeSlider,arguments)},_oneTimeCallback:function(t,i,e){var n=function(){t.unsubscribe(i,n),e.apply({},arguments)};t.subscribe(i,n)},_cleanEvent:function(t,i){var e,n,s,a,h,r;if(t.__yui_events&&t.events[i]){for(n=t.__yui_events.length;0<=n;--n)if(t.__yui_events[n].type===i){e=t.__yui_events[n];break}if(e){for(r=[],n=a=0,s=(h=e.subscribers).length;n<s;++n)h[n]&&(r[a++]=h[n]);e.subscribers=r}}}},YAHOO.lang.augmentProto(r,YAHOO.util.EventProvider),h.Slider.getHorizDualSlider=function(t,i,e,n,s,a){i=new h.SliderThumb(i,t,0,n,0,0,s),e=new h.SliderThumb(e,t,0,n,0,0,s);return new r(new h.Slider(t,t,i,"horiz"),new h.Slider(t,t,e,"horiz"),n,a)},h.Slider.getVertDualSlider=function(t,i,e,n,s,a){i=new h.SliderThumb(i,t,0,0,0,n,s),e=new h.SliderThumb(e,t,0,0,0,n,s);return new h.DualSlider(new h.Slider(t,t,i,"vert"),new h.Slider(t,t,e,"vert"),n,a)},YAHOO.widget.DualSlider=r}(),YAHOO.register("slider",YAHOO.widget.Slider,{version:"2.9.0",build:"2800"});
//# sourceMappingURL=slider.js.map;
!function(){var u=YAHOO.util.Dom,l=YAHOO.lang,r=l.isObject,n=l.isFunction,h=l.isArray,s=l.isString;function g(t){var e,i,s,n,a=g.VALUE_UNLIMITED;for(e in t=r(t)?t:{},this.initConfig(),this.initEvents(),this.set("rowsPerPage",t.rowsPerPage,!0),g.isNumeric(t.totalRecords)&&this.set("totalRecords",t.totalRecords,!0),this.initUIComponents(),t)t.hasOwnProperty(e)&&this.set(e,t[e],!0);n=this.get("initialPage"),i=this.get("totalRecords"),s=this.get("rowsPerPage"),1<n&&s!==a&&(n=(n-1)*s,i===a||n<i)&&this.set("recordOffset",n,!0)}l.augmentObject(g,{id:0,ID_BASE:"yui-pg",VALUE_UNLIMITED:-1,TEMPLATE_DEFAULT:"{FirstPageLink} {PreviousPageLink} {PageLinks} {NextPageLink} {LastPageLink}",TEMPLATE_ROWS_PER_PAGE:"{FirstPageLink} {PreviousPageLink} {PageLinks} {NextPageLink} {LastPageLink} {RowsPerPageDropdown}",ui:{},isNumeric:function(t){return isFinite(+t)},toNumber:function(t){return isFinite(+t)?+t:null}},!0),g.prototype={_containers:[],_batch:!1,_pageChanged:!1,_state:null,initConfig:function(){var i=g.VALUE_UNLIMITED;this.setAttributeConfig("rowsPerPage",{value:0,validator:g.isNumeric,setter:g.toNumber}),this.setAttributeConfig("containers",{value:null,validator:function(t){for(var e=0,i=(t=h(t)?t:[t]).length;e<i;++e)if(!(s(t[e])||r(t[e])&&1===t[e].nodeType))return!1;return!0},method:function(t){t=u.get(t),h(t)||(t=[t]),this._containers=t}}),this.setAttributeConfig("totalRecords",{value:0,validator:g.isNumeric,setter:g.toNumber}),this.setAttributeConfig("recordOffset",{value:0,validator:function(t){var e=this.get("totalRecords");return!!g.isNumeric(t)&&(t=+t,e===i||t<e||0===e&&0===t)},setter:g.toNumber}),this.setAttributeConfig("initialPage",{value:1,validator:g.isNumeric,setter:g.toNumber}),this.setAttributeConfig("template",{value:g.TEMPLATE_DEFAULT,validator:s}),this.setAttributeConfig("containerClass",{value:"yui-pg-container",validator:s}),this.setAttributeConfig("alwaysVisible",{value:!0,validator:l.isBoolean}),this.setAttributeConfig("updateOnChange",{value:!1,validator:l.isBoolean}),this.setAttributeConfig("id",{value:g.id++,readOnly:!0}),this.setAttributeConfig("rendered",{value:!1,readOnly:!0})},initUIComponents:function(){var t,e,i=g.ui;for(t in i)i.hasOwnProperty(t)&&(e=i[t],r(e))&&n(e.init)&&e.init(this)},initEvents:function(){this.createEvent("render"),this.createEvent("rendered"),this.createEvent("changeRequest"),this.createEvent("pageChange"),this.createEvent("beforeDestroy"),this.createEvent("destroy"),this._selfSubscribe()},_selfSubscribe:function(){this.subscribe("totalRecordsChange",this.updateVisibility,this,!0),this.subscribe("alwaysVisibleChange",this.updateVisibility,this,!0),this.subscribe("totalRecordsChange",this._handleStateChange,this,!0),this.subscribe("recordOffsetChange",this._handleStateChange,this,!0),this.subscribe("rowsPerPageChange",this._handleStateChange,this,!0),this.subscribe("totalRecordsChange",this._syncRecordOffset,this,!0)},_syncRecordOffset:function(t){var e=t.newValue;t.prevValue!==e&&e!==g.VALUE_UNLIMITED&&this.get("rowsPerPage")&&this.get("recordOffset")>=e&&(e=this.getState({totalRecords:t.prevValue,recordOffset:this.get("recordOffset")}),this.set("recordOffset",e.before.recordOffset),this._firePageChange(e))},_handleStateChange:function(t){var e;t.prevValue!==t.newValue&&((e=this._state||{})[t.type.replace(/Change$/,"")]=t.prevValue,(t=this.getState(e)).page!==t.before.page)&&(this._batch?this._pageChanged=!0:this._firePageChange(t))},_firePageChange:function(t){var e;r(t)&&(e=t.before,delete t.before,this.fireEvent("pageChange",{type:"pageChange",prevValue:t.page,newValue:e.page,prevState:t,newState:e}))},render:function(){if(!this.get("rendered")){for(var t=this.get("template"),e=this.getState(),i=g.ID_BASE+this.get("id")+"-",s=0,n=this._containers.length;s<n;++s)this._renderTemplate(this._containers[s],t,i+s,!0);this.updateVisibility(),this._containers.length&&(this.setAttributeConfig("rendered",{value:!0}),this.fireEvent("render",e),this.fireEvent("rendered",e))}return this},_renderTemplate:function(t,e,i,s){var n,a,r,o=this.get("containerClass");if(t){for(u.setStyle(t,"display","none"),u.addClass(t,o),t.innerHTML=e.replace(/\{([a-z0-9_ \-]+)\}/gi,'<span class="yui-pg-ui yui-pg-ui-$1"></span>'),a=0,r=(n=u.getElementsByClassName("yui-pg-ui","span",t)).length;a<r;++a)this.renderUIComponent(n[a],i);s||u.setStyle(t,"display","")}},renderUIComponent:function(t,e){var i=t.parentNode,s=/yui-pg-ui-(\w+)/.exec(t.className),s=s&&g.ui[s[1]];return n(s)&&(s=new s(this),n(s.render))&&i.replaceChild(s.render(e),t),this},destroy:function(){this.fireEvent("beforeDestroy"),this.fireEvent("destroy"),this.setAttributeConfig("rendered",{value:!1}),this.unsubscribeAll()},updateVisibility:function(t){var e,i,s,n,a,r,o=this.get("alwaysVisible");if(!t||"alwaysVisibleChange"===t.type||!o){if(t=this.get("totalRecords"),e=!0,i=this.get("rowsPerPage"),s=this.get("rowsPerPageOptions"),h(s))for(n=0,a=s.length;n<a;++n)r=s[n],l.isNumber(r||r.value)&&(i=Math.min(i,r.value||r));for(e=(e=t!==g.VALUE_UNLIMITED&&t<=i?!1:e)||o,n=0,a=this._containers.length;n<a;++n)u.setStyle(this._containers[n],"display",e?"":"none")}},getContainerNodes:function(){return this._containers},getTotalPages:function(){var t=this.get("totalRecords"),e=this.get("rowsPerPage");return e?t===g.VALUE_UNLIMITED?g.VALUE_UNLIMITED:Math.ceil(t/e):null},hasPage:function(t){var e;return!(!l.isNumber(t)||t<1)&&((e=this.getTotalPages())===g.VALUE_UNLIMITED||t<=e)},getCurrentPage:function(){var t=this.get("rowsPerPage");return t&&this.get("totalRecords")?Math.floor(this.get("recordOffset")/t)+1:0},hasNextPage:function(){var t=this.getCurrentPage(),e=this.getTotalPages();return t&&(e===g.VALUE_UNLIMITED||t<e)},getNextPage:function(){return this.hasNextPage()?this.getCurrentPage()+1:null},hasPreviousPage:function(){return 1<this.getCurrentPage()},getPreviousPage:function(){return this.hasPreviousPage()?this.getCurrentPage()-1:1},getPageRecords:function(t){l.isNumber(t)||(t=this.getCurrentPage());var e,i=this.get("rowsPerPage"),s=this.get("totalRecords");if(!t||!i)return null;if(t=(t-1)*i,s!==g.VALUE_UNLIMITED){if(s<=t)return null;e=Math.min(t+i,s)-1}else e=t+i-1;return[t,e]},setPage:function(t,e){this.hasPage(t)&&t!==this.getCurrentPage()&&(this.get("updateOnChange")||e?this.set("recordOffset",(t-1)*this.get("rowsPerPage")):this.fireEvent("changeRequest",this.getState({page:t})))},getRowsPerPage:function(){return this.get("rowsPerPage")},setRowsPerPage:function(t,e){g.isNumeric(t)&&0<+t&&+t!==this.get("rowsPerPage")&&(this.get("updateOnChange")||e?this.set("rowsPerPage",t):this.fireEvent("changeRequest",this.getState({rowsPerPage:+t})))},getTotalRecords:function(){return this.get("totalRecords")},setTotalRecords:function(t,e){g.isNumeric(t)&&0<=+t&&+t!==this.get("totalRecords")&&(this.get("updateOnChange")||e?this.set("totalRecords",t):this.fireEvent("changeRequest",this.getState({totalRecords:+t})))},getStartIndex:function(){return this.get("recordOffset")},setStartIndex:function(t,e){g.isNumeric(t)&&0<=+t&&+t!==this.get("recordOffset")&&(this.get("updateOnChange")||e?this.set("recordOffset",t):this.fireEvent("changeRequest",this.getState({recordOffset:+t})))},getState:function(t){var e,s=g.VALUE_UNLIMITED,i=Math,n=i.max,i=i.ceil;function a(t,e,i){return t<=0||0===e?0:e===s||t<e?t-t%i:e-(e%i||i)}return(e={paginator:this,totalRecords:this.get("totalRecords"),rowsPerPage:this.get("rowsPerPage"),records:this.getPageRecords()}).recordOffset=a(this.get("recordOffset"),e.totalRecords,e.rowsPerPage),e.page=i(e.recordOffset/e.rowsPerPage)+1,t?(0===(n={paginator:this,before:e,rowsPerPage:t.rowsPerPage||e.rowsPerPage,totalRecords:g.isNumeric(t.totalRecords)?n(t.totalRecords,s):+e.totalRecords}).totalRecords?n.recordOffset=n.page=0:(t=g.isNumeric(t.page)?(t.page-1)*n.rowsPerPage:g.isNumeric(t.recordOffset)?+t.recordOffset:e.recordOffset,n.recordOffset=a(t,n.totalRecords,n.rowsPerPage),n.page=i(n.recordOffset/n.rowsPerPage)+1),n.records=[n.recordOffset,n.recordOffset+n.rowsPerPage-1],n.totalRecords!==s&&n.recordOffset<n.totalRecords&&n.records&&n.records[1]>n.totalRecords-1&&(n.records[1]=n.totalRecords-1),n):e},setState:function(t){if(r(t)){for(var e in this._state=this.getState({}),(t={page:t.page,rowsPerPage:t.rowsPerPage,totalRecords:t.totalRecords,recordOffset:t.recordOffset}).page&&t.recordOffset===undefined&&(t.recordOffset=(t.page-1)*(t.rowsPerPage||this.get("rowsPerPage"))),this._batch=!0,this._pageChanged=!1,t)t.hasOwnProperty(e)&&this._configs.hasOwnProperty(e)&&this.set(e,t[e]);this._batch=!1,this._pageChanged&&(this._pageChanged=!1,this._firePageChange(this.getState(this._state)))}}},l.augmentProto(g,YAHOO.util.AttributeProvider),YAHOO.widget.Paginator=g}(),function(){var e=YAHOO.widget.Paginator,i=YAHOO.lang,s=YAHOO.util.Dom.generateId;e.ui.CurrentPageReport=function(t){(this.paginator=t).subscribe("recordOffsetChange",this.update,this,!0),t.subscribe("rowsPerPageChange",this.update,this,!0),t.subscribe("totalRecordsChange",this.update,this,!0),t.subscribe("pageReportTemplateChange",this.update,this,!0),t.subscribe("destroy",this.destroy,this,!0),t.subscribe("pageReportClassChange",this.update,this,!0)},e.ui.CurrentPageReport.init=function(t){t.setAttributeConfig("pageReportClass",{value:"yui-pg-current",validator:i.isString}),t.setAttributeConfig("pageReportTemplate",{value:"({currentPage} of {totalPages})",validator:i.isString}),t.setAttributeConfig("pageReportValueGenerator",{value:function(t){var e=t.getCurrentPage(),i=t.getPageRecords();return{currentPage:i?e:0,totalPages:t.getTotalPages(),startIndex:i?i[0]:0,endIndex:i?i[1]:0,startRecord:i?i[0]+1:0,endRecord:i?i[1]+1:0,totalRecords:t.get("totalRecords")}},validator:i.isFunction})},e.ui.CurrentPageReport.sprintf=function(t,i){return t.replace(/\{([\w\s\-]+)\}/g,function(t,e){return e in i?i[e]:""})},e.ui.CurrentPageReport.prototype={span:null,render:function(t){return this.span=document.createElement("span"),this.span.className=this.paginator.get("pageReportClass"),s(this.span,t+"-page-report"),this.update(),this.span},update:function(t){t&&t.prevValue===t.newValue||(this.span.innerHTML=e.ui.CurrentPageReport.sprintf(this.paginator.get("pageReportTemplate"),this.paginator.get("pageReportValueGenerator")(this.paginator)))},destroy:function(){this.span.parentNode.removeChild(this.span),this.span=null}}}(),function(){var l=YAHOO.widget.Paginator,h=YAHOO.lang,i=YAHOO.util.Dom.generateId;l.ui.PageLinks=function(t){(this.paginator=t).subscribe("recordOffsetChange",this.update,this,!0),t.subscribe("rowsPerPageChange",this.update,this,!0),t.subscribe("totalRecordsChange",this.update,this,!0),t.subscribe("pageLinksChange",this.rebuild,this,!0),t.subscribe("pageLinkClassChange",this.rebuild,this,!0),t.subscribe("currentPageClassChange",this.rebuild,this,!0),t.subscribe("destroy",this.destroy,this,!0),t.subscribe("pageLinksContainerClassChange",this.rebuild,this,!0)},l.ui.PageLinks.init=function(t){t.setAttributeConfig("pageLinkClass",{value:"yui-pg-page",validator:h.isString}),t.setAttributeConfig("currentPageClass",{value:"yui-pg-current-page",validator:h.isString}),t.setAttributeConfig("pageLinksContainerClass",{value:"yui-pg-pages",validator:h.isString}),t.setAttributeConfig("pageLinks",{value:10,validator:l.isNumeric}),t.setAttributeConfig("pageLabelBuilder",{value:function(t,e){return t},validator:h.isFunction}),t.setAttributeConfig("pageTitleBuilder",{value:function(t,e){return"Page "+t},validator:h.isFunction})},l.ui.PageLinks.calculateRange=function(t,e,i){var s=l.VALUE_UNLIMITED;return!t||0===i||0===e||e===s&&i===s?[0,-1]:(e!==s&&(i=i===s?e:Math.min(i,e)),t=Math.max(1,Math.ceil(t-i/2)),s=e===s?t+i-1:Math.min(e,t+i-1),[Math.max(1,t-(i-(s-t+1))),s])},l.ui.PageLinks.prototype={current:0,container:null,render:function(t){var e=this.paginator;return this.container=document.createElement("span"),i(this.container,t+"-pages"),this.container.className=e.get("pageLinksContainerClass"),YAHOO.util.Event.on(this.container,"click",this.onClick,this,!0),this.update({newValue:null,rebuild:!0}),this.container},update:function(t){if(!t||t.prevValue!==t.newValue){var e=this.paginator,i=e.getCurrentPage();if(this.current!==i||!i||t.rebuild){for(var s=e.get("pageLabelBuilder"),n=e.get("pageTitleBuilder"),t=l.ui.PageLinks.calculateRange(i,e.getTotalPages(),e.get("pageLinks")),a=t[0],r=t[1],o="",u=a;u<=r;++u)o+=u===i?h.substitute('<span class="{class}">{label}</span>',{"class":e.get("currentPageClass")+" "+e.get("pageLinkClass"),label:s(u,e)}):h.substitute('<a href="#" class="{class}" page="{page}" title="{title}">{label}</a>',{"class":e.get("pageLinkClass"),page:u,label:s(u,e),title:n(u,e)});this.container.innerHTML=o}}},rebuild:function(t){t.rebuild=!0,this.update(t)},destroy:function(){YAHOO.util.Event.purgeElement(this.container,!0),this.container.parentNode.removeChild(this.container),this.container=null},onClick:function(t){var e=YAHOO.util.Event.getTarget(t);e&&YAHOO.util.Dom.hasClass(e,this.paginator.get("pageLinkClass"))&&(YAHOO.util.Event.stopEvent(t),this.paginator.setPage(parseInt(e.getAttribute("page"),10)))}}}(),function(){var t=YAHOO.widget.Paginator,e=YAHOO.lang,a=YAHOO.util.Dom.generateId;t.ui.FirstPageLink=function(t){(this.paginator=t).subscribe("recordOffsetChange",this.update,this,!0),t.subscribe("rowsPerPageChange",this.update,this,!0),t.subscribe("totalRecordsChange",this.update,this,!0),t.subscribe("destroy",this.destroy,this,!0),t.subscribe("firstPageLinkLabelChange",this.update,this,!0),t.subscribe("firstPageLinkClassChange",this.update,this,!0)},t.ui.FirstPageLink.init=function(t){t.setAttributeConfig("firstPageLinkLabel",{value:"&lt;&lt; first",validator:e.isString}),t.setAttributeConfig("firstPageLinkClass",{value:"yui-pg-first",validator:e.isString}),t.setAttributeConfig("firstPageLinkTitle",{value:"First Page",validator:e.isString})},t.ui.FirstPageLink.prototype={current:null,link:null,span:null,render:function(t){var e=this.paginator,i=e.get("firstPageLinkClass"),s=e.get("firstPageLinkLabel"),n=e.get("firstPageLinkTitle");return this.link=document.createElement("a"),this.span=document.createElement("span"),a(this.link,t+"-first-link"),this.link.href="#",this.link.className=i,this.link.innerHTML=s,this.link.title=n,YAHOO.util.Event.on(this.link,"click",this.onClick,this,!0),a(this.span,t+"-first-span"),this.span.className=i,this.span.innerHTML=s,this.current=1<e.getCurrentPage()?this.link:this.span,this.current},update:function(t){t&&t.prevValue===t.newValue||(t=this.current?this.current.parentNode:null,1<this.paginator.getCurrentPage()?t&&this.current===this.span&&(t.replaceChild(this.link,this.current),this.current=this.link):t&&this.current===this.link&&(t.replaceChild(this.span,this.current),this.current=this.span))},destroy:function(){YAHOO.util.Event.purgeElement(this.link),this.current.parentNode.removeChild(this.current),this.link=this.span=null},onClick:function(t){YAHOO.util.Event.stopEvent(t),this.paginator.setPage(1)}}}(),function(){var r=YAHOO.widget.Paginator,e=YAHOO.lang,o=YAHOO.util.Dom.generateId;r.ui.LastPageLink=function(t){(this.paginator=t).subscribe("recordOffsetChange",this.update,this,!0),t.subscribe("rowsPerPageChange",this.update,this,!0),t.subscribe("totalRecordsChange",this.update,this,!0),t.subscribe("destroy",this.destroy,this,!0),t.subscribe("lastPageLinkLabelChange",this.update,this,!0),t.subscribe("lastPageLinkClassChange",this.update,this,!0)},r.ui.LastPageLink.init=function(t){t.setAttributeConfig("lastPageLinkLabel",{value:"last &gt;&gt;",validator:e.isString}),t.setAttributeConfig("lastPageLinkClass",{value:"yui-pg-last",validator:e.isString}),t.setAttributeConfig("lastPageLinkTitle",{value:"Last Page",validator:e.isString})},r.ui.LastPageLink.prototype={current:null,link:null,span:null,na:null,render:function(t){var e=this.paginator,i=e.get("lastPageLinkClass"),s=e.get("lastPageLinkLabel"),n=e.getTotalPages(),a=e.get("lastPageLinkTitle");switch(this.link=document.createElement("a"),this.span=document.createElement("span"),this.na=this.span.cloneNode(!1),o(this.link,t+"-last-link"),this.link.href="#",this.link.className=i,this.link.innerHTML=s,this.link.title=a,YAHOO.util.Event.on(this.link,"click",this.onClick,this,!0),o(this.span,t+"-last-span"),this.span.className=i,this.span.innerHTML=s,o(this.na,t+"-last-na"),n){case r.VALUE_UNLIMITED:this.current=this.na;break;case e.getCurrentPage():this.current=this.span;break;default:this.current=this.link}return this.current},update:function(t){if(!t||t.prevValue!==t.newValue){var t=this.current?this.current.parentNode:null,e=this.link;if(t){switch(this.paginator.getTotalPages()){case r.VALUE_UNLIMITED:e=this.na;break;case this.paginator.getCurrentPage():e=this.span}this.current!==e&&(t.replaceChild(e,this.current),this.current=e)}}},destroy:function(){YAHOO.util.Event.purgeElement(this.link),this.current.parentNode.removeChild(this.current),this.link=this.span=null},onClick:function(t){YAHOO.util.Event.stopEvent(t),this.paginator.setPage(this.paginator.getTotalPages())}}}(),function(){var t=YAHOO.widget.Paginator,e=YAHOO.lang,r=YAHOO.util.Dom.generateId;t.ui.NextPageLink=function(t){(this.paginator=t).subscribe("recordOffsetChange",this.update,this,!0),t.subscribe("rowsPerPageChange",this.update,this,!0),t.subscribe("totalRecordsChange",this.update,this,!0),t.subscribe("destroy",this.destroy,this,!0),t.subscribe("nextPageLinkLabelChange",this.update,this,!0),t.subscribe("nextPageLinkClassChange",this.update,this,!0)},t.ui.NextPageLink.init=function(t){t.setAttributeConfig("nextPageLinkLabel",{value:"next &gt;",validator:e.isString}),t.setAttributeConfig("nextPageLinkClass",{value:"yui-pg-next",validator:e.isString}),t.setAttributeConfig("nextPageLinkTitle",{value:"Next Page",validator:e.isString})},t.ui.NextPageLink.prototype={current:null,link:null,span:null,render:function(t){var e=this.paginator,i=e.get("nextPageLinkClass"),s=e.get("nextPageLinkLabel"),n=e.getTotalPages(),a=e.get("nextPageLinkTitle");return this.link=document.createElement("a"),this.span=document.createElement("span"),r(this.link,t+"-next-link"),this.link.href="#",this.link.className=i,this.link.innerHTML=s,this.link.title=a,YAHOO.util.Event.on(this.link,"click",this.onClick,this,!0),r(this.span,t+"-next-span"),this.span.className=i,this.span.innerHTML=s,this.current=e.getCurrentPage()===n?this.span:this.link,this.current},update:function(t){var e;t&&t.prevValue===t.newValue||(t=this.paginator.getTotalPages(),e=this.current?this.current.parentNode:null,this.paginator.getCurrentPage()!==t?e&&this.current===this.span&&(e.replaceChild(this.link,this.current),this.current=this.link):this.current===this.link&&e&&(e.replaceChild(this.span,this.current),this.current=this.span))},destroy:function(){YAHOO.util.Event.purgeElement(this.link),this.current.parentNode.removeChild(this.current),this.link=this.span=null},onClick:function(t){YAHOO.util.Event.stopEvent(t),this.paginator.setPage(this.paginator.getNextPage())}}}(),function(){var t=YAHOO.widget.Paginator,e=YAHOO.lang,a=YAHOO.util.Dom.generateId;t.ui.PreviousPageLink=function(t){(this.paginator=t).subscribe("recordOffsetChange",this.update,this,!0),t.subscribe("rowsPerPageChange",this.update,this,!0),t.subscribe("totalRecordsChange",this.update,this,!0),t.subscribe("destroy",this.destroy,this,!0),t.subscribe("previousPageLinkLabelChange",this.update,this,!0),t.subscribe("previousPageLinkClassChange",this.update,this,!0)},t.ui.PreviousPageLink.init=function(t){t.setAttributeConfig("previousPageLinkLabel",{value:"&lt; prev",validator:e.isString}),t.setAttributeConfig("previousPageLinkClass",{value:"yui-pg-previous",validator:e.isString}),t.setAttributeConfig("previousPageLinkTitle",{value:"Previous Page",validator:e.isString})},t.ui.PreviousPageLink.prototype={current:null,link:null,span:null,render:function(t){var e=this.paginator,i=e.get("previousPageLinkClass"),s=e.get("previousPageLinkLabel"),n=e.get("previousPageLinkTitle");return this.link=document.createElement("a"),this.span=document.createElement("span"),a(this.link,t+"-prev-link"),this.link.href="#",this.link.className=i,this.link.innerHTML=s,this.link.title=n,YAHOO.util.Event.on(this.link,"click",this.onClick,this,!0),a(this.span,t+"-prev-span"),this.span.className=i,this.span.innerHTML=s,this.current=1<e.getCurrentPage()?this.link:this.span,this.current},update:function(t){t&&t.prevValue===t.newValue||(t=this.current?this.current.parentNode:null,1<this.paginator.getCurrentPage()?t&&this.current===this.span&&(t.replaceChild(this.link,this.current),this.current=this.link):t&&this.current===this.link&&(t.replaceChild(this.span,this.current),this.current=this.span))},destroy:function(){YAHOO.util.Event.purgeElement(this.link),this.current.parentNode.removeChild(this.current),this.link=this.span=null},onClick:function(t){YAHOO.util.Event.stopEvent(t),this.paginator.setPage(this.paginator.getPreviousPage())}}}(),function(){var t=YAHOO.widget.Paginator,l=YAHOO.lang,e=YAHOO.util.Dom.generateId;t.ui.RowsPerPageDropdown=function(t){(this.paginator=t).subscribe("rowsPerPageChange",this.update,this,!0),t.subscribe("rowsPerPageOptionsChange",this.rebuild,this,!0),t.subscribe("totalRecordsChange",this._handleTotalRecordsChange,this,!0),t.subscribe("destroy",this.destroy,this,!0),t.subscribe("rowsPerPageDropdownClassChange",this.rebuild,this,!0)},t.ui.RowsPerPageDropdown.init=function(t){t.setAttributeConfig("rowsPerPageOptions",{value:[],validator:l.isArray}),t.setAttributeConfig("rowsPerPageDropdownClass",{value:"yui-pg-rpp-options",validator:l.isString})},t.ui.RowsPerPageDropdown.prototype={select:null,all:null,render:function(t){return this.select=document.createElement("select"),e(this.select,t+"-rpp"),this.select.className=this.paginator.get("rowsPerPageDropdownClass"),this.select.title="Rows per page",YAHOO.util.Event.on(this.select,"change",this.onChange,this,!0),this.rebuild(),this.select},rebuild:function(t){var e,i,s,n,a,r=this.paginator,o=this.select,u=r.get("rowsPerPageOptions");for(this.all=null,n=0,a=u.length;n<a;++n)i=u[n],e=o.options[n]||o.appendChild(document.createElement("option")),s=l.isValue(i.value)?i.value:i,e.text=l.isValue(i.text)?i.text:i,l.isString(s)&&"all"===s.toLowerCase()?(this.all=e).value=r.get("totalRecords"):e.value=s;for(;o.options.length>u.length;)o.removeChild(o.firstChild);this.update()},update:function(t){if(!t||t.prevValue!==t.newValue)for(var e=this.paginator.get("rowsPerPage")+"",i=this.select.options,s=0,n=i.length;s<n;++s)if(i[s].value===e){i[s].selected=!0;break}},onChange:function(t){this.paginator.setRowsPerPage(parseInt(this.select.options[this.select.selectedIndex].value,10))},_handleTotalRecordsChange:function(t){!this.all||t&&t.prevValue===t.newValue||(this.all.value=t.newValue,this.all.selected&&this.paginator.set("rowsPerPage",t.newValue))},destroy:function(){YAHOO.util.Event.purgeElement(this.select),this.select.parentNode.removeChild(this.select),this.select=null}}}(),function(){var t=YAHOO.widget.Paginator,e=YAHOO.lang,i=YAHOO.util.Dom.generateId;t.ui.JumpToPageDropdown=function(t){(this.paginator=t).subscribe("rowsPerPageChange",this.rebuild,this,!0),t.subscribe("rowsPerPageOptionsChange",this.rebuild,this,!0),t.subscribe("pageChange",this.update,this,!0),t.subscribe("totalRecordsChange",this.rebuild,this,!0),t.subscribe("destroy",this.destroy,this,!0)},t.ui.JumpToPageDropdown.init=function(t){t.setAttributeConfig("jumpToPageDropdownClass",{value:"yui-pg-jtp-options",validator:e.isString})},t.ui.JumpToPageDropdown.prototype={select:null,render:function(t){return this.select=document.createElement("select"),i(this.select,t+"-jtp"),this.select.className=this.paginator.get("jumpToPageDropdownClass"),this.select.title="Jump to page",YAHOO.util.Event.on(this.select,"change",this.onChange,this,!0),this.rebuild(),this.select},rebuild:function(t){var e,i,s,n=this.paginator,a=this.select,n=n.getTotalPages();for(this.all=null,i=0,s=n;i<s;++i)(e=a.options[i]||a.appendChild(document.createElement("option"))).innerHTML=i+1,e.value=i+1;for(i=n,s=a.options.length;i<s;i++)a.removeChild(a.lastChild);this.update()},update:function(t){if(!t||t.prevValue!==t.newValue)for(var e=this.paginator.getCurrentPage()+"",i=this.select.options,s=0,n=i.length;s<n;++s)if(i[s].value===e){i[s].selected=!0;break}},onChange:function(t){this.paginator.setPage(parseInt(this.select.options[this.select.selectedIndex].value,!1))},destroy:function(){YAHOO.util.Event.purgeElement(this.select),this.select.parentNode.removeChild(this.select),this.select=null}}}(),YAHOO.register("paginator",YAHOO.widget.Paginator,{version:"2.9.0",build:"2800"});
//# sourceMappingURL=paginator.js.map;
YAHOO.util.Chain=function(){this.q=[].slice.call(arguments),this.createEvent("end")},YAHOO.util.Chain.prototype={id:0,run:function(){var e,t=this.q[0];if(t){if(!this.id&&"function"==typeof(e=t.method||t)){var i=t.scope||{},n=t.argument||[],l=t.timeout||0,o=this;if(n instanceof Array||(n=[n]),l<0){if(this.id=l,t.until)for(;!t.until();)e.apply(i,n);else if(t.iterations)for(;0<t.iterations--;)e.apply(i,n);else e.apply(i,n);return this.q.shift(),this.id=0,this.run()}if(t.until){if(t.until())return this.q.shift(),this.run()}else t.iterations&&--t.iterations||this.q.shift();this.id=setTimeout(function(){e.apply(i,n),o.id&&(o.id=0,o.run())},l)}}else this.fireEvent("end");return this},add:function(e){return this.q.push(e),this},pause:function(){return 0<this.id&&clearTimeout(this.id),this.id=0,this},stop:function(){return this.pause(),this.q=[],this}},YAHOO.lang.augmentProto(YAHOO.util.Chain,YAHOO.util.EventProvider),function(){var h=YAHOO.util.Event,c=YAHOO.lang,d=[],u=function(e,t,i){e=!(!e||e===i)&&(YAHOO.util.Selector.test(e,t)?e:u(e.parentNode,t,i));return e};c.augmentObject(h,{_createDelegate:function(s,r,a,d){return function(e){var t,i=this,n=h.getTarget(e),l=r,o=9===i.nodeType;if(c.isFunction(r)?t=r(n):c.isString(r)&&(o||(l=((o="#"+(i.id||h.generateId(i))+" ")+r).replace(/,/gi,","+o)),YAHOO.util.Selector.test(n,l)?t=n:YAHOO.util.Selector.test(n,l.replace(/,/gi," *,")+" *")&&(t=u(n,l,i))),t)return s.call(d?!0===d?a:d:t,e,t,i,a)}},delegate:function(e,t,i,n,l,o){var s,r,a=t;if(c.isString(n)&&!YAHOO.util.Selector)return!1;if("mouseenter"==t||"mouseleave"==t){if(!h._createMouseDelegate)return!1;a=h._getType(t),s=h._createMouseDelegate(i,l,o),r=h._createDelegate(function(e,t,i){return s.call(t,e,i)},n,l,o)}else r=h._createDelegate(i,n,l,o);return d.push([e,a,i,r]),h.on(e,a,r)},removeDelegate:function(e,t,i){var n,l=t,o=!1;return"mouseenter"!=t&&"mouseleave"!=t||(l=h._getType(t)),0<=(t=h._getCacheIndex(d,e,l,i))&&(n=d[t]),e&&n&&(o=h.removeListener(n[0],n[1],n[3]))&&(delete d[t][2],delete d[t][3],d.splice(t,1)),o}})}(),function(){var a=YAHOO.util.Event,e=YAHOO.lang,s=a.addListener,o=a.removeListener,d=a.getListeners,r=[],h={mouseenter:"mouseover",mouseleave:"mouseout"};e.augmentObject(a._specialTypes,h),e.augmentObject(a,{_createMouseDelegate:function(n,l,o){return function(e,t){var i=a.getRelatedTarget(e);if(this!=i&&!YAHOO.util.Dom.isAncestor(this,i))return i=o?!0===o?l:o:this,e=[e,l],t&&e.splice(1,0,this,t),n.apply(i,e)}},addListener:function(e,t,i,n,l){var o=h[t]?((o=a._createMouseDelegate(i,n,l)).mouseDelegate=!0,r.push([e,t,i,o]),s.call(a,e,t,o)):s.apply(a,arguments);return o},removeListener:function(e,t,i){var n=(h[t]?function(e,t,i){var n,l,i=a._getCacheIndex(r,e,t,i);return 0<=i&&(n=r[i]),e&&n&&(l=o.call(a,n[0],t,n[3]))&&(delete r[i][2],delete r[i][3],r.splice(i,1)),l}:o).apply(a,arguments);return n},getListeners:function(e,t){var i,n,l,o,s=[],r="mouseover"===t||"mouseout"===t;if(t&&(r||h[t])){if(i=d.call(a,e,this._getType(t)))for(l=i.length-1;-1<l;l--)n=(o=i[l]).fn.mouseDelegate,(h[t]&&n||r&&!n)&&s.push(o)}else s=d.apply(a,arguments);return s&&s.length?s:null}},!0),a.on=a.addListener}(),YAHOO.register("event-mouseenter",YAHOO.util.Event,{version:"2.9.0",build:"2800"});var Y=YAHOO,Y_DOM=YAHOO.util.Dom,EMPTY_ARRAY=[],Y_UA=Y.env.ua,Y_Lang=Y.lang,Y_DOC=document,Y_DOCUMENT_ELEMENT=Y_DOC.documentElement,Y_DOM_inDoc=Y_DOM.inDocument,Y_mix=Y_Lang.augmentObject,Y_guid=Y_DOM.generateId,Y_getDoc=function(e){var t=Y_DOC;return t=e?9===e.nodeType?e:e.ownerDocument||e.document||Y_DOC:t},Y_Array=function(e,t){var i,n,l=t||0;try{return Array.prototype.slice.call(e,l)}catch(o){for(n=[],i=e.length;l<i;l++)n.push(e[l]);return n}},Y_DOM_allById=function(e,t){var i,n,l=[],o=[];if((t=t||Y_DOC).querySelectorAll)o=t.querySelectorAll('[id="'+e+'"]');else if(t.all){if((l=t.all(e))&&(l=l.nodeName?l.id===e?(o.push(l),EMPTY_ARRAY):[l]:l).length)for(i=0;n=l[i++];)(n.id===e||n.attributes&&n.attributes.id&&n.attributes.id.value===e)&&o.push(n)}else o=[Y_getDoc(t).getElementById(e)];return o},COMPARE_DOCUMENT_POSITION="compareDocumentPosition",OWNER_DOCUMENT="ownerDocument",Selector={_foundCache:[],useNative:!0,_compare:"sourceIndex"in Y_DOCUMENT_ELEMENT?function(e,t){e=e.sourceIndex,t=t.sourceIndex;return e===t?0:t<e?1:-1}:Y_DOCUMENT_ELEMENT[COMPARE_DOCUMENT_POSITION]?function(e,t){return 4&e[COMPARE_DOCUMENT_POSITION](t)?-1:1}:function(e,t){var i;return e&&t&&((i=e[OWNER_DOCUMENT].createRange()).setStart(e,0),(e=t[OWNER_DOCUMENT].createRange()).setStart(t,0),i=i.compareBoundaryPoints(1,e)),i},_sort:function(e){return e&&(e=Y_Array(e,0,!0)).sort&&e.sort(Selector._compare),e},_deDupe:function(e){for(var t,i=[],n=0;t=e[n++];)t._found||((i[i.length]=t)._found=!0);for(n=0;t=i[n++];)t._found=null,t.removeAttribute("_found");return i},query:function(e,t,i,n){if("string"==typeof t){if(!(t=Y_DOM.get(t)))return i?null:[]}else t=t||Y_DOC;var l,o,s=[],r=Selector.useNative&&Y_DOC.querySelector&&!n,a=[[e,t]],d=r?Selector._nativeQuery:Selector._bruteQuery;if(e&&d){for(n||r&&!t.tagName||(a=Selector._splitQueries(e,t)),o=0;l=a[o++];)l=d(l[0],l[1],i),(l=i?l:Y_Array(l,0,!0))&&(s=s.concat(l));1<a.length&&(s=Selector._sort(Selector._deDupe(s)))}return i?s[0]||null:s},_splitQueries:function(e,t){var i,n,l=e.split(","),o=[],s="";if(t)for(t.tagName&&(t.id=t.id||Y_guid(),s='[id="'+t.id+'"] '),i=0,n=l.length;i<n;++i)e=s+l[i],o.push([e,t]);return o},_nativeQuery:function(e,t,i){if(Y_UA.webkit&&-1<e.indexOf(":checked")&&Selector.pseudos&&Selector.pseudos.checked)return Selector.query(e,t,i,!0);try{return t["querySelector"+(i?"":"All")](e)}catch(n){return Selector.query(e,t,i,!0)}},filter:function(e,t){var i,n,l=[];if(e&&t)for(i=0;n=e[i++];)Selector.test(n,t)&&(l[l.length]=n);else Y.log("invalid filter input (nodes: "+e+", selector: "+t+")","warn","Selector");return l},test:function(e,t,i){var n,l,o,s,r,a,d,h=!1,c=t.split(","),t=!1;if(e&&e.tagName){for(i||Y_DOM_inDoc(e)||((n=e.parentNode)?i=n:((s=e[OWNER_DOCUMENT].createDocumentFragment()).appendChild(e),i=s,t=!0)),i=i||e[OWNER_DOCUMENT],e.id||(e.id=Y_guid()),r=0;d=c[r++];){for(d+='[id="'+e.id+'"]',o=Selector.query(d,i),a=0;l=o[a++];)if(l===e){h=!0;break}if(h)break}t&&s.removeChild(e)}return h}},PARENT_NODE=(YAHOO.util.Selector=Selector,"parentNode"),TAG_NAME="tagName",ATTRIBUTES="attributes",COMBINATOR="combinator",PSEUDOS="pseudos",SelectorCSS2={_reRegExpTokens:/([\^\$\?\[\]\*\+\-\.\(\)\|\\])/,SORT_RESULTS:!0,_children:function(e,t){var i,n,l,o=e.children;if(e.children&&t&&e.children.tags)e.children.tags(t);else if(!o&&e[TAG_NAME]||o&&t)for(n=o||e.childNodes,o=[],i=0;l=n[i++];)!l.tagName||t&&t!==l.tagName||o.push(l);return o||[]},_re:{attr:/(\[[^\]]*\])/g,esc:/\\[:\[\]\(\)#\.\'\>+~"]/gi,pseudos:/(\([^\)]*\))/g},shorthand:{"\\#(-?[_a-z]+[-\\w\\uE000]*)":"[id=$1]","\\.(-?[_a-z]+[-\\w\\uE000]*)":"[className~=$1]"},operators:{"":function(e,t){return!!e.getAttribute(t)},"~=":"(?:^|\\s+){val}(?:\\s+|$)","|=":"^{val}(?:-|$)"},pseudos:{"first-child":function(e){return Selector._children(e[PARENT_NODE])[0]===e}},_bruteQuery:function(e,t,i){var n,l,o,s=[],r=[],e=Selector._tokenize(e),a=e[e.length-1];Y_getDoc(t);if(a){if(l=a.id,o=a.className,a=a.tagName||"*",t.getElementsByTagName)r=l&&(t.all||9===t.nodeType||Y_DOM_inDoc(t))?Y_DOM_allById(l,t):o?t.getElementsByClassName(o):t.getElementsByTagName(a);else for(n=t.firstChild;n;)n.tagName&&r.push(n),n=n.nextSilbing||n.firstChild;r.length&&(s=Selector._filterNodes(r,e,i))}return s},_filterNodes:function(e,t,i){for(var n,l,o,s,r,a,d,h,c=0,u=t.length,g=u-1,f=[],_=e[0],C=_,E=Selector.getters,c=0;C=_=e[c++];){g=u-1,r=null;e:for(;C&&C.tagName;){if(n=(d=(s=t[g]).tests).length)for(;h=d[--n];)if(l=h[1],E[h[0]]?a=E[h[0]](C,h[0]):(a=C[h[0]])===undefined&&C.getAttribute&&(a=C.getAttribute(h[0])),"="===l&&a!==h[2]||"string"!=typeof l&&l.test&&!l.test(a)||!l.test&&"function"==typeof l&&!l(C,h[0],h[2])){if(C=C[r])for(;C&&(!C.tagName||s.tagName&&s.tagName!==C.tagName);)C=C[r];continue e}if(g--,!(o=s.combinator)){if(f.push(_),i)return f;break}for(C=C[r=o.axis];C&&!C.tagName;)C=C[r];o.direct&&(r=null)}}return _=C=null,f},combinators:{" ":{axis:"parentNode"},">":{axis:"parentNode",direct:!0},"+":{axis:"previousSibling",direct:!0}},_parsers:[{name:ATTRIBUTES,re:/^\uE003(-?[a-z]+[\w\-]*)+([~\|\^\$\*!=]=?)?['"]?([^\uE004'"]*)['"]?\uE004/i,fn:function(e,t){var i=e[2]||"",n=Selector.operators,l=e[3]?e[3].replace(/\\/g,""):"";if(("id"===e[1]&&"="===i||"className"===e[1]&&Y_DOCUMENT_ELEMENT.getElementsByClassName&&("~="===i||"="===i))&&(t.prefilter=e[1],e[3]=l,t[e[1]]="id"===e[1]?e[3]:l),i in n&&("string"==typeof(i=n[i])&&(e[3]=l.replace(Selector._reRegExpTokens,"\\$1"),i=new RegExp(i.replace("{val}",e[3]))),e[2]=i),!t.last||t.prefilter!==e[1])return e.slice(1)}},{name:TAG_NAME,re:/^((?:-?[_a-z]+[\w-]*)|\*)/i,fn:function(e,t){e=e[1].toUpperCase();if("*"!==(t.tagName=e)&&(!t.last||t.prefilter))return[TAG_NAME,"=",e];t.prefilter||(t.prefilter="tagName")}},{name:COMBINATOR,re:/^\s*([>+~]|\s)\s*/,fn:function(e,t){}},{name:PSEUDOS,re:/^:([\-\w]+)(?:\uE005['"]?([^\uE005]*)['"]?\uE006)*/i,fn:function(e,t){var i=Selector[PSEUDOS][e[1]];return!!i&&(e[2]&&(e[2]=e[2].replace(/\\/g,"")),[e[2],i])}}],_getToken:function(e){return{tagName:null,id:null,className:null,attributes:{},combinator:null,tests:[]}},_tokenize:function(e){e=Selector._replaceShorthand(Y_Lang.trim(e=e||""));var t,i,n,l,o=Selector._getToken(),s=e,r=[],a=!1;e:do{for(a=!1,n=0;l=Selector._parsers[n++];)if(t=l.re.exec(e)){if(l.name!==COMBINATOR&&(o.selector=e),(e=e.replace(t[0],"")).length||(o.last=!0),Selector._attrFilters[t[1]]&&(t[1]=Selector._attrFilters[t[1]]),!1===(i=l.fn(t,o))){a=!1;break e}i&&o.tests.push(i),e.length&&l.name!==COMBINATOR||(r.push(o),o=Selector._getToken(o),l.name===COMBINATOR&&(o.combinator=Selector.combinators[t[1]])),a=!0}}while(a&&e.length);return a&&!e.length||(Y.log("query: "+s+" contains unsupported token in: "+e,"warn","Selector"),r=[]),r},_replaceShorthand:function(e){var t,i,n,l=Selector.shorthand,o=e.match(Selector._re.esc),s=(e=o?e.replace(Selector._re.esc,""):e).match(Selector._re.attr),r=e.match(Selector._re.pseudos);for(t in s&&(e=e.replace(Selector._re.attr,"")),r&&(e=e.replace(Selector._re.pseudos,"")),l)l.hasOwnProperty(t)&&(e=e.replace(new RegExp(t,"gi"),l[t]));if(s)for(i=0,n=s.length;i<n;++i)e=e.replace(/\uE001/,s[i]);if(r)for(i=0,n=r.length;i<n;++i)e=e.replace(/\uE002/,r[i]);if(e=(e=(e=(e=e.replace(/\[/g,"")).replace(/\]/g,"")).replace(/\(/g,"")).replace(/\)/g,""),o)for(i=0,n=o.length;i<n;++i)e=e.replace("",o[i]);return e},_attrFilters:{"class":"className","for":"htmlFor"},getters:{href:function(e,t){return Y_DOM.getAttribute(e,t)}}},Dom=(Y_mix(Selector,SelectorCSS2,!0),Selector.getters.src=Selector.getters.rel=Selector.getters.href,Selector.useNative&&Y_DOC.querySelector&&(Selector.shorthand["\\.([^\\s\\\\(\\[:]*)"]="[class~=$1]"),Selector._reNth=/^(?:([\-]?\d*)(n){1}|(odd|even)$)*([\-+]?\d*)$/,Selector._getNth=function(e,t,i,n){Selector._reNth.test(t);var l=parseInt(RegExp.$1,10),t=RegExp.$2,o=RegExp.$3,s=parseInt(RegExp.$4,10)||0,r=Selector._children(e.parentNode,i);if(o?(l=2,t="n",s="odd"===o?1:0):isNaN(l)&&(l=t?1:0),0===l)return r[(s=n?r.length-s+1:s)-1]===e;if(l<0&&(n=!!n,l=Math.abs(l)),n){for(a=r.length-s,d=r.length;0<=a;a-=l)if(a<d&&r[a]===e)return!0}else for(var a=s-1,d=r.length;a<d;a+=l)if(0<=a&&r[a]===e)return!0;return!1},Y_mix(Selector.pseudos,{root:function(e){return e===e.ownerDocument.documentElement},"nth-child":function(e,t){return Selector._getNth(e,t)},"nth-last-child":function(e,t){return Selector._getNth(e,t,null,!0)},"nth-of-type":function(e,t){return Selector._getNth(e,t,e.tagName)},"nth-last-of-type":function(e,t){return Selector._getNth(e,t,e.tagName,!0)},"last-child":function(e){var t=Selector._children(e.parentNode);return t[t.length-1]===e},"first-of-type":function(e){return Selector._children(e.parentNode,e.tagName)[0]===e},"last-of-type":function(e){var t=Selector._children(e.parentNode,e.tagName);return t[t.length-1]===e},"only-child":function(e){var t=Selector._children(e.parentNode);return 1===t.length&&t[0]===e},"only-of-type":function(e){var t=Selector._children(e.parentNode,e.tagName);return 1===t.length&&t[0]===e},empty:function(e){return 0===e.childNodes.length},not:function(e,t){return!Selector.test(e,t)},contains:function(e,t){return-1<(e.innerText||e.textContent||"").indexOf(t)},checked:function(e){return!0===e.checked||!0===e.selected},enabled:function(e){return e.disabled!==undefined&&!e.disabled},disabled:function(e){return e.disabled}}),Y_mix(Selector.operators,{"^=":"^{val}","!=":function(e,t,i){return e[t]!==i},"$=":"{val}$","*=":"{val}"}),Selector.combinators["~"]={axis:"previousSibling"},YAHOO.register("selector",YAHOO.util.Selector,{version:"2.9.0",build:"2800"}),YAHOO.util.Dom);YAHOO.widget.ColumnSet=function(e){this._sId=Dom.generateId(null,"yui-cs"),e=YAHOO.widget.DataTable._cloneObject(e),this._init(e),YAHOO.widget.ColumnSet._nCount++},YAHOO.widget.ColumnSet._nCount=0,YAHOO.widget.ColumnSet.prototype={_sId:null,_aDefinitions:null,tree:null,flat:null,keys:null,headers:null,_init:function(e){var h=[],c=[],u=[],i=[],g=-1,f=function(e,t){h[++g]||(h[g]=[]);for(var i=0;i<e.length;i++){var n=e[i],l=new YAHOO.widget.Column(n);if(n.yuiColumnId=l._sId,c.push(l),t&&(l._oParent=t),YAHOO.lang.isArray(n.children)){l.children=n.children;for(var o=0,s=function(e){for(var t=e.children,i=0;i<t.length;i++)YAHOO.lang.isArray(t[i].children)?s(t[i]):o++},r=(s(n),l._nColspan=o,n.children),a=0;a<r.length;a++){var d=r[a];l.className&&d.className===undefined&&(d.className=l.className),l.editor&&d.editor===undefined&&(d.editor=l.editor),l.editorOptions&&d.editorOptions===undefined&&(d.editorOptions=l.editorOptions),l.formatter&&d.formatter===undefined&&(d.formatter=l.formatter),l.resizeable&&d.resizeable===undefined&&(d.resizeable=l.resizeable),l.sortable&&d.sortable===undefined&&(d.sortable=l.sortable),l.hidden&&(d.hidden=!0),l.width&&d.width===undefined&&(d.width=l.width),l.minWidth&&d.minWidth===undefined&&(d.minWidth=l.minWidth),l.maxAutoWidth&&d.maxAutoWidth===undefined&&(d.maxAutoWidth=l.maxAutoWidth),l.type&&d.type===undefined&&(d.type=l.type),l.type&&!l.formatter&&(l.formatter=l.type),l.text&&!YAHOO.lang.isValue(l.label)&&(l.label=l.text),l.parser,!l.sortOptions||l.sortOptions.ascFunction||l.sortOptions.descFunction}h[g+1]||(h[g+1]=[]),f(r,l)}else l._nKeyIndex=u.length,l._nColspan=1,u.push(l);h[g].push(l)}g--};if(!YAHOO.lang.isArray(e))return null;f(e),this._aDefinitions=e;for(var t,n,l=h,o=1,s=function(e,t){t=t||1;for(var i=0;i<e.length;i++){var n=e[i];YAHOO.lang.isArray(n.children)?(t++,s(n.children,t),t--):o<t&&(o=t)}},r=0;r<l.length;r++){t=l[r],s(t);for(var a=0;a<t.length;a++)n=t[a],YAHOO.lang.isArray(n.children)?n._nRowspan=1:n._nRowspan=o;o=1}for(_=0;_<h[0].length;_++)h[0][_]._nTreeIndex=_;for(var d=function(e,t){i[e].push(t.getSanitizedKey()),t._oParent&&d(e,t._oParent)},_=0;_<u.length;_++)i[_]=[],d(_,u[_]),i[_]=i[_].reverse();this.tree=h,this.flat=c,this.keys=u,this.headers=i},getId:function(){return this._sId},toString:function(){return"ColumnSet instance "+this._sId},getDefinitions:function(){var e=this._aDefinitions,r=function(e,t){for(var i=0;i<e.length;i++){var n=e[i],l=t.getColumnById(n.yuiColumnId);if(l){var o,s=l.getDefinition();for(o in s)YAHOO.lang.hasOwnProperty(s,o)&&(n[o]=s[o])}YAHOO.lang.isArray(n.children)&&r(n.children,t)}};return r(e,this),this._aDefinitions=e},getColumnById:function(e){if(YAHOO.lang.isString(e))for(var t=this.flat,i=t.length-1;-1<i;i--)if(t[i]._sId===e)return t[i];return null},getColumn:function(e){if(YAHOO.lang.isNumber(e)&&this.keys[e])return this.keys[e];if(YAHOO.lang.isString(e)){for(var t=this.flat,i=[],n=0;n<t.length;n++)t[n].key===e&&i.push(t[n]);if(1===i.length)return i[0];if(1<i.length)return i}return null},getDescendants:function(e){var t,i=this,n=[],l=function(e){if(n.push(e),e.children)for(t=0;t<e.children.length;t++)l(i.getColumn(e.children[t].key))};return l(e),n}},YAHOO.widget.Column=function(e){if(this._sId=Dom.generateId(null,"yui-col"),e&&YAHOO.lang.isObject(e))for(var t in e)t&&(this[t]=e[t]);YAHOO.lang.isValue(this.key)||(this.key=Dom.generateId(null,"yui-dt-col")),YAHOO.lang.isValue(this.field)||(this.field=this.key),YAHOO.widget.Column._nCount++,this.width&&!YAHOO.lang.isNumber(this.width)&&(this.width=null),this.editor&&YAHOO.lang.isString(this.editor)&&(this.editor=new YAHOO.widget.CellEditor(this.editor,this.editorOptions))},YAHOO.lang.augmentObject(YAHOO.widget.Column,{_nCount:0,formatCheckbox:function(e,t,i,n){YAHOO.widget.DataTable.formatCheckbox(e,t,i,n)},formatCurrency:function(e,t,i,n){YAHOO.widget.DataTable.formatCurrency(e,t,i,n)},formatDate:function(e,t,i,n){YAHOO.widget.DataTable.formatDate(e,t,i,n)},formatEmail:function(e,t,i,n){YAHOO.widget.DataTable.formatEmail(e,t,i,n)},formatLink:function(e,t,i,n){YAHOO.widget.DataTable.formatLink(e,t,i,n)},formatNumber:function(e,t,i,n){YAHOO.widget.DataTable.formatNumber(e,t,i,n)},formatSelect:function(e,t,i,n){YAHOO.widget.DataTable.formatDropdown(e,t,i,n)}}),YAHOO.widget.Column.prototype={_sId:null,_nKeyIndex:null,_nTreeIndex:null,_nColspan:1,_nRowspan:1,_oParent:null,_elTh:null,_elThLiner:null,_elThLabel:null,_elResizer:null,_nWidth:null,_dd:null,_ddResizer:null,key:null,field:null,label:null,abbr:null,children:null,width:null,minWidth:null,maxAutoWidth:null,hidden:!1,selected:!1,className:null,formatter:null,currencyOptions:null,dateOptions:null,dropdownOptions:null,editor:null,resizeable:!1,sortable:!1,sortOptions:null,getId:function(){return this._sId},toString:function(){return"Column instance "+this._sId},getDefinition:function(){var e={};return e.abbr=this.abbr,e.className=this.className,e.editor=this.editor,e.editorOptions=this.editorOptions,e.field=this.field,e.formatter=this.formatter,e.hidden=this.hidden,e.key=this.key,e.label=this.label,e.minWidth=this.minWidth,e.maxAutoWidth=this.maxAutoWidth,e.resizeable=this.resizeable,e.selected=this.selected,e.sortable=this.sortable,e.sortOptions=this.sortOptions,e.width=this.width,e._calculatedWidth=this._calculatedWidth,e},getKey:function(){return this.key},getField:function(){return this.field},getSanitizedKey:function(){return this.getKey().replace(/[^\w\-]/g,"")},getKeyIndex:function(){return this._nKeyIndex},getTreeIndex:function(){return this._nTreeIndex},getParent:function(){return this._oParent},getColspan:function(){return this._nColspan},getColSpan:function(){return this.getColspan()},getRowspan:function(){return this._nRowspan},getThEl:function(){return this._elTh},getThLinerEl:function(){return this._elThLiner},getResizerEl:function(){return this._elResizer},getColEl:function(){return this.getThEl()},getIndex:function(){return this.getKeyIndex()},format:function(){}},YAHOO.util.Sort={compare:function(e,t,i){return null==e?null==t?0:1:null==t?-1:(e=e.constructor==String?e.toLowerCase():e)<(t=t.constructor==String?t.toLowerCase():t)?i?1:-1:t<e?i?-1:1:0}},YAHOO.widget.ColumnDD=function(e,t,i,n){e&&t&&i&&n&&(this.datatable=e,this.table=e.getTableEl(),this.column=t,this.headCell=i,this.pointer=n,this.newIndex=null,this.init(i),this.initFrame(),this.invalidHandleTypes={},this.setPadding(10,0,this.datatable.getTheadEl().offsetHeight+10,0),YAHOO.util.Event.on(window,"resize",function(){this.initConstraints()},this,!0))},YAHOO.util.DDProxy&&YAHOO.extend(YAHOO.widget.ColumnDD,YAHOO.util.DDProxy,{initConstraints:function(){var e=YAHOO.util.Dom.getRegion(this.table),t=this.getEl(),i=YAHOO.util.Dom.getXY(t),n=parseInt(YAHOO.util.Dom.getStyle(t,"width"),10),t=(parseInt(YAHOO.util.Dom.getStyle(t,"height"),10),i[0]-e.left+15),e=e.right-i[0]-n+15;this.setXConstraint(t,e),this.setYConstraint(10,10)},_resizeProxy:function(){YAHOO.widget.ColumnDD.superclass._resizeProxy.apply(this,arguments);var e=this.getDragEl(),t=this.getEl(),t=(YAHOO.util.Dom.setStyle(this.pointer,"height",this.table.parentNode.offsetHeight+10+"px"),YAHOO.util.Dom.setStyle(this.pointer,"display","block"),YAHOO.util.Dom.getXY(t));YAHOO.util.Dom.setXY(this.pointer,[t[0],t[1]-5]),YAHOO.util.Dom.setStyle(e,"height",this.datatable.getContainerEl().offsetHeight+"px"),YAHOO.util.Dom.setStyle(e,"width",parseInt(YAHOO.util.Dom.getStyle(e,"width"),10)+4+"px"),YAHOO.util.Dom.setXY(this.dragEl,t)},onMouseDown:function(){this.initConstraints(),this.resetConstraints()},clickValidator:function(e){if(!this.column.hidden)return e=YAHOO.util.Event.getTarget(e),this.isValidHandleChild(e)&&(this.id==this.handleElId||this.DDM.handleWasClicked(e,this.id))},onDragOver:function(e,t){var i=this.datatable.getColumn(t);if(i){for(var n,l,o,s,r=i.getTreeIndex();null===r&&i.getParent();)r=(i=i.getParent()).getTreeIndex();null!==r&&(t=i.getThEl(),n=r,e=YAHOO.util.Event.getPageX(e),o=(l=YAHOO.util.Dom.getX(t))+YAHOO.util.Dom.get(t).offsetWidth/2,s=this.column.getTreeIndex(),e<o?YAHOO.util.Dom.setX(this.pointer,l):(e=parseInt(t.offsetWidth,10),YAHOO.util.Dom.setX(this.pointer,l+e),n++),s<r&&n--,n<0?n=0:n>this.datatable.getColumnSet().tree[0].length&&(n=this.datatable.getColumnSet().tree[0].length),this.newIndex=n)}},onDragDrop:function(){this.datatable.reorderColumn(this.column,this.newIndex)},endDrag:function(){this.newIndex=null,YAHOO.util.Dom.setStyle(this.pointer,"display","none")}}),YAHOO.util.ColumnResizer=function(e,t,i,n,l){e&&t&&i&&n&&(this.datatable=e,this.column=t,this.headCell=i,this.headCellLiner=t.getThLinerEl(),this.resizerLiner=i.firstChild,this.init(n,n,{dragOnly:!0,dragElId:l.id}),this.initFrame(),this.resetResizerEl(),this.setPadding(0,1,0,0))},YAHOO.util.DD&&YAHOO.extend(YAHOO.util.ColumnResizer,YAHOO.util.DDProxy,{resetResizerEl:function(){var e=YAHOO.util.Dom.get(this.handleElId).style;e.left="auto",e.right=0,e.top="auto",e.bottom=0,e.height=this.headCell.offsetHeight+"px"},onMouseUp:function(e){for(var t,i=this.datatable.getColumnSet().keys,n=0,l=i.length;n<l;n++)(t=i[n])._ddResizer&&t._ddResizer.resetResizerEl();this.resetResizerEl();var o=this.headCellLiner,o=o.offsetWidth-(0|parseInt(YAHOO.util.Dom.getStyle(o,"paddingLeft"),10))-(0|parseInt(YAHOO.util.Dom.getStyle(o,"paddingRight"),10));this.datatable.fireEvent("columnResizeEvent",{column:this.column,target:this.headCell,width:o})},onMouseDown:function(e){this.startWidth=this.headCellLiner.offsetWidth,this.startX=YAHOO.util.Event.getXY(e)[0],this.nLinerPadding=(0|parseInt(YAHOO.util.Dom.getStyle(this.headCellLiner,"paddingLeft"),10))+(0|parseInt(YAHOO.util.Dom.getStyle(this.headCellLiner,"paddingRight"),10))},clickValidator:function(e){if(!this.column.hidden)return e=YAHOO.util.Event.getTarget(e),this.isValidHandleChild(e)&&(this.id==this.handleElId||this.DDM.handleWasClicked(e,this.id))},startDrag:function(){for(var e,t=this.datatable.getColumnSet().keys,i=(this.column.getKeyIndex(),0),n=t.length;i<n;i++)(e=t[i])._ddResizer&&(YAHOO.util.Dom.get(e._ddResizer.handleElId).style.height="1em")},onDrag:function(e){var e=YAHOO.util.Event.getXY(e)[0];e>YAHOO.util.Dom.getX(this.headCellLiner)&&(e=e-this.startX,0<(e=this.startWidth+e-this.nLinerPadding))&&this.datatable.setColumnWidth(this.column,e)}}),function(){var a=YAHOO.lang,e=YAHOO.util,d=YAHOO.widget,i=e.Dom,t=(e.Event,d.DataTable,YAHOO.widget.RecordSet=function(e){this._init(e)},d.RecordSet);t._nCount=0,t.prototype={_sId:null,_init:function(e){this._sId=i.generateId(null,"yui-rs"),d.RecordSet._nCount++,this._records=[],this._initEvents(),e&&(a.isArray(e)?this.addRecords(e):a.isObject(e)&&this.addRecord(e))},_initEvents:function(){this.createEvent("recordAddEvent"),this.createEvent("recordsAddEvent"),this.createEvent("recordSetEvent"),this.createEvent("recordsSetEvent"),this.createEvent("recordUpdateEvent"),this.createEvent("recordDeleteEvent"),this.createEvent("recordsDeleteEvent"),this.createEvent("resetEvent"),this.createEvent("recordValueUpdateEvent")},_addRecord:function(e,t){e=new YAHOO.widget.Record(e);return YAHOO.lang.isNumber(t)&&-1<t?this._records.splice(t,0,e):this._records[this._records.length]=e,e},_setRecord:function(e,t){return(!a.isNumber(t)||t<0)&&(t=this._records.length),this._records[t]=new d.Record(e)},_deleteRecord:function(e,t){(!a.isNumber(t)||t<0)&&(t=1),this._records.splice(e,t)},getId:function(){return this._sId},toString:function(){return"RecordSet instance "+this._sId},getLength:function(){return this._records.length},getRecord:function(e){var t;if(e instanceof d.Record){for(t=0;t<this._records.length;t++)if(this._records[t]&&this._records[t]._sId===e._sId)return e}else if(a.isNumber(e)){if(-1<e&&e<this.getLength())return this._records[e]}else if(a.isString(e))for(t=0;t<this._records.length;t++)if(this._records[t]&&this._records[t]._sId===e)return this._records[t];return null},getRecords:function(e,t){return a.isNumber(e)?a.isNumber(t)?this._records.slice(e,e+t):this._records.slice(e):this._records},hasRecords:function(e,t){for(var i=this.getRecords(e,t),n=0;n<t;++n)if("undefined"==typeof i[n])return!1;return!0},getRecordIndex:function(e){if(e)for(var t=this._records.length-1;-1<t;t--)if(this._records[t]&&e.getId()===this._records[t].getId())return t;return null},addRecord:function(e,t){return a.isObject(e)?(t=this._addRecord(e,t),this.fireEvent("recordAddEvent",{record:t,data:e}),t):null},addRecords:function(e,t){if(a.isArray(e)){for(var i,n=[],l=t=a.isNumber(t)?t:this._records.length,o=0,s=e.length;o<s;++o)a.isObject(e[o])&&(i=this._addRecord(e[o],l++),n.push(i));return this.fireEvent("recordsAddEvent",{records:n,data:e}),n}return a.isObject(e)?(t=this._addRecord(e),this.fireEvent("recordsAddEvent",{records:[t],data:e}),t):null},setRecord:function(e,t){return a.isObject(e)?(t=this._setRecord(e,t),this.fireEvent("recordSetEvent",{record:t,data:e}),t):null},setRecords:function(e,t){var i=d.Record,n=a.isArray(e)?e:[e],l=[],o=0,s=n.length,r=0;for(t=0|parseInt(t,10);o<s;++o)"object"==typeof n[o]&&n[o]&&(l[r++]=this._records[t+o]=new i(n[o]));return this.fireEvent("recordsSetEvent",{records:l,data:e}),this.fireEvent("recordsSet",{records:l,data:e}),n.length,l},updateRecord:function(e,t){var i=this.getRecord(e);if(i&&a.isObject(t)){var n,l={};for(n in i._oData)a.hasOwnProperty(i._oData,n)&&(l[n]=i._oData[n]);return i._oData=t,this.fireEvent("recordUpdateEvent",{record:i,newData:t,oldData:l}),i}return null},updateKey:function(e,t,i){this.updateRecordValue(e,t,i)},updateRecordValue:function(e,t,i){e=this.getRecord(e);if(e){var n=null,l=e._oData[t];if(l&&a.isObject(l))for(var o in n={},l)a.hasOwnProperty(l,o)&&(n[o]=l[o]);else n=l;e._oData[t]=i,this.fireEvent("keyUpdateEvent",{record:e,key:t,newData:i,oldData:n}),this.fireEvent("recordValueUpdateEvent",{record:e,key:t,newData:i,oldData:n})}},replaceRecords:function(e){return this.reset(),this.addRecords(e)},sortRecords:function(i,n,l){return this._records.sort(function(e,t){return i(e,t,n,l)})},reverseRecords:function(){return this._records.reverse()},deleteRecord:function(e){var t;return a.isNumber(e)&&-1<e&&e<this.getLength()?(t=this.getRecord(e).getData(),this._deleteRecord(e),this.fireEvent("recordDeleteEvent",{data:t,index:e}),t):null},deleteRecords:function(e,t){if(a.isNumber(t)||(t=1),a.isNumber(e)&&-1<e&&e<this.getLength()){for(var i=this.getRecords(e,t),n=[],l=[],o=0;o<i.length;o++)n[n.length]=i[o],l[l.length]=i[o].getData();return this._deleteRecord(e,t),this.fireEvent("recordsDeleteEvent",{data:n,deletedData:l,index:e}),n}return null},reset:function(){this._records=[],this.fireEvent("resetEvent")}},a.augmentProto(t,e.EventProvider),YAHOO.widget.Record=function(e){if(this._nCount=d.Record._nCount,this._sId=i.generateId(null,"yui-rec"),d.Record._nCount++,this._oData={},a.isObject(e))for(var t in e)a.hasOwnProperty(e,t)&&(this._oData[t]=e[t])},YAHOO.widget.Record._nCount=0,YAHOO.widget.Record.prototype={_nCount:null,_sId:null,_oData:null,getCount:function(){return this._nCount},getId:function(){return this._sId},getData:function(e){return a.isString(e)?this._oData[e]:this._oData},setData:function(e,t){this._oData[e]=t}}}(),function(){var v=YAHOO.lang,s=YAHOO.util,g=YAHOO.widget,h=YAHOO.env.ua,c=s.Dom,u=s.Event,o=s.DataSourceBase,m=(YAHOO.widget.DataTable=function(e,t,i,n){var l=g.DataTable;if(n&&n.scrollable)return new YAHOO.widget.ScrollingDataTable(e,t,i,n);this._nIndex=l._nCount,this._sId=c.generateId(null,"yui-dt"),this._oChainRender=new YAHOO.util.Chain,this._oChainRender.subscribe("end",this._onRenderChainEnd,this,!0),this._initConfigs(n),this._initDataSource(i),this._oDataSource&&(this._initColumnSet(t),this._oColumnSet)&&(this._initRecordSet(),this._oRecordSet,l.superclass.constructor.call(this,e,this.configs),this._initDomElements(e))&&(this.showTableMessage(this.get("MSG_LOADING"),l.CLASS_LOADING),this._initEvents(),l._nCount++,l._nCurrentCount++,n={success:this.onDataReturnSetRows,failure:this.onDataReturnSetRows,scope:this,argument:this.getState()},!0===(i=this.get("initialLoad"))?this._oDataSource.sendRequest(this.get("initialRequest"),n):!1===i?this.showTableMessage(this.get("MSG_EMPTY"),l.CLASS_EMPTY):(n.argument=(t=i||{}).argument||{},this._oDataSource.sendRequest(t.request,n)))},g.DataTable);v.augmentObject(m,{CLASS_DATATABLE:"yui-dt",CLASS_LINER:"yui-dt-liner",CLASS_LABEL:"yui-dt-label",CLASS_MESSAGE:"yui-dt-message",CLASS_MASK:"yui-dt-mask",CLASS_DATA:"yui-dt-data",CLASS_COLTARGET:"yui-dt-coltarget",CLASS_RESIZER:"yui-dt-resizer",CLASS_RESIZERLINER:"yui-dt-resizerliner",CLASS_RESIZERPROXY:"yui-dt-resizerproxy",CLASS_EDITOR:"yui-dt-editor",CLASS_EDITOR_SHIM:"yui-dt-editor-shim",CLASS_PAGINATOR:"yui-dt-paginator",CLASS_PAGE:"yui-dt-page",CLASS_DEFAULT:"yui-dt-default",CLASS_PREVIOUS:"yui-dt-previous",CLASS_NEXT:"yui-dt-next",CLASS_FIRST:"yui-dt-first",CLASS_LAST:"yui-dt-last",CLASS_REC:"yui-dt-rec",CLASS_EVEN:"yui-dt-even",CLASS_ODD:"yui-dt-odd",CLASS_SELECTED:"yui-dt-selected",CLASS_HIGHLIGHTED:"yui-dt-highlighted",CLASS_HIDDEN:"yui-dt-hidden",CLASS_DISABLED:"yui-dt-disabled",CLASS_EMPTY:"yui-dt-empty",CLASS_LOADING:"yui-dt-loading",CLASS_ERROR:"yui-dt-error",CLASS_EDITABLE:"yui-dt-editable",CLASS_DRAGGABLE:"yui-dt-draggable",CLASS_RESIZEABLE:"yui-dt-resizeable",CLASS_SCROLLABLE:"yui-dt-scrollable",CLASS_SORTABLE:"yui-dt-sortable",CLASS_ASC:"yui-dt-asc",CLASS_DESC:"yui-dt-desc",CLASS_BUTTON:"yui-dt-button",CLASS_CHECKBOX:"yui-dt-checkbox",CLASS_DROPDOWN:"yui-dt-dropdown",CLASS_RADIO:"yui-dt-radio",_nCount:0,_nCurrentCount:0,_elDynStyleNode:null,_bDynStylesFallback:!!h.ie,_oDynStyles:{},_cloneObject:function(e){if(!v.isValue(e))return e;var t={};if(e instanceof YAHOO.widget.BaseCellEditor)t=e;else if("[object RegExp]"===Object.prototype.toString.apply(e))t=e;else if(v.isFunction(e))t=e;else if(v.isArray(e)){for(var i=[],n=0,l=e.length;n<l;n++)i[n]=m._cloneObject(e[n]);t=i}else if(v.isObject(e))for(var o in e)v.hasOwnProperty(e,o)&&(v.isValue(e[o])&&v.isObject(e[o])||v.isArray(e[o])?t[o]=m._cloneObject(e[o]):t[o]=e[o]);else t=e;return t},formatButton:function(e,t,i,n,l){n=v.isValue(n)?n:"Click";e.innerHTML='<button type="button" class="'+m.CLASS_BUTTON+'">'+n+"</button>"},formatCheckbox:function(e,t,i,n,l){e.innerHTML='<input type="checkbox"'+(n?' checked="checked"':"")+' class="'+m.CLASS_CHECKBOX+'" />'},formatCurrency:function(e,t,i,n,l){l=l||this;e.innerHTML=s.Number.format(n,i.currencyOptions||l.get("currencyOptions"))},formatDate:function(e,t,i,n,l){l=l||this,i=i.dateOptions||l.get("dateOptions");e.innerHTML=s.Date.format(n,i,i.locale)},formatDropdown:function(e,t,i,n,l){var o,l=l||this,s=v.isValue(n)?n:t.getData(i.field),r=v.isArray(i.dropdownOptions)?i.dropdownOptions:null,t=e.getElementsByTagName("select");if(0===t.length&&((o=document.createElement("select")).className=m.CLASS_DROPDOWN,o=e.appendChild(o),u.addListener(o,"change",l._onDropdownChange,l)),o=t[0])if(o.innerHTML="",r)for(var a=0;a<r.length;a++){var d=r[a],h=document.createElement("option");h.value=v.isValue(d.value)?d.value:d,h.innerHTML=v.isValue(d.text)?d.text:v.isValue(d.label)?d.label:d,(h=o.appendChild(h)).value==s&&(h.selected=!0)}else o.innerHTML='<option selected value="'+s+'">'+s+"</option>";else e.innerHTML=v.isValue(n)?n:""},formatEmail:function(e,t,i,n,l){v.isString(n)?(n=v.escapeHTML(n),e.innerHTML='<a href="mailto:'+n+'">'+n+"</a>"):e.innerHTML=v.isValue(n)?v.escapeHTML(n.toString()):""},formatLink:function(e,t,i,n,l){v.isString(n)?(n=v.escapeHTML(n),e.innerHTML='<a href="'+n+'">'+n+"</a>"):e.innerHTML=v.isValue(n)?v.escapeHTML(n.toString()):""},formatNumber:function(e,t,i,n,l){l=l||this;e.innerHTML=s.Number.format(n,i.numberOptions||l.get("numberOptions"))},formatRadio:function(e,t,i,n,l){l=l||this;e.innerHTML='<input type="radio"'+(n?' checked="checked"':"")+' name="'+l.getId()+"-col-"+i.getSanitizedKey()+'" class="'+m.CLASS_RADIO+'" />'},formatText:function(e,t,i,n,l){n=v.isValue(n)?n:"";e.innerHTML=v.escapeHTML(n.toString())},formatTextarea:function(e,t,i,n,l){n=v.isValue(n)?v.escapeHTML(n.toString()):"";e.innerHTML="<textarea>"+n+"</textarea>"},formatTextbox:function(e,t,i,n,l){n=v.isValue(n)?v.escapeHTML(n.toString()):"";e.innerHTML='<input type="text" value="'+n+'" />'},formatDefault:function(e,t,i,n,l){e.innerHTML=v.isValue(n)&&""!==n?n.toString():"&#160;"},validateNumber:function(e){e=+e;return v.isNumber(e)?e:undefined}}),m.Formatter={button:m.formatButton,checkbox:m.formatCheckbox,currency:m.formatCurrency,date:m.formatDate,dropdown:m.formatDropdown,email:m.formatEmail,link:m.formatLink,number:m.formatNumber,radio:m.formatRadio,text:m.formatText,textarea:m.formatTextarea,textbox:m.formatTextbox,defaultFormatter:m.formatDefault},v.extend(m,s.Element,{initAttributes:function(e){m.superclass.initAttributes.call(this,e=e||{}),this.setAttributeConfig("summary",{value:"",validator:v.isString,method:function(e){this._elTable&&(this._elTable.summary=e)}}),this.setAttributeConfig("selectionMode",{value:"standard",validator:v.isString}),this.setAttributeConfig("sortedBy",{value:null,validator:function(e){return e?v.isObject(e)&&e.key:null===e},method:function(e){var t,i,n,l,o,s=this.get("sortedBy");if(this._configs.sortedBy.value=e,this._elThead&&(s&&s.key&&s.dir&&(t=(l=this._oColumnSet.getColumn(s.key)).getKeyIndex(),i=l.getThEl(),c.removeClass(i,s.dir),this.formatTheadCell(l.getThLinerEl().firstChild,l,e)),e)&&(n=(i=e.column||this._oColumnSet.getColumn(e.key)).getKeyIndex(),l=i.getThEl(),!e.dir||"asc"!=e.dir&&"desc"!=e.dir?(o=e.dir||m.CLASS_ASC,c.addClass(l,o)):(o="desc"==e.dir?m.CLASS_DESC:m.CLASS_ASC,c.addClass(l,o)),this.formatTheadCell(i.getThLinerEl().firstChild,i,e)),this._elTbody){this._elTbody.style.display="none";for(var r,a=this._elTbody.rows,d=a.length-1;-1<d;d--)(r=a[d].childNodes)[t]&&c.removeClass(r[t],s.dir),r[n]&&c.addClass(r[n],e.dir);this._elTbody.style.display=""}this._clearTrTemplateEl()}}),this.setAttributeConfig("paginator",{value:null,validator:function(e){return null===e||e instanceof g.Paginator},method:function(){this._updatePaginator.apply(this,arguments)}}),this.setAttributeConfig("caption",{value:null,validator:v.isString,method:function(e){this._initCaptionEl(e)}}),this.setAttributeConfig("draggableColumns",{value:!1,validator:v.isBoolean,method:function(e){this._elThead&&(e?this._initDraggableColumns():this._destroyDraggableColumns())}}),this.setAttributeConfig("renderLoopSize",{value:0,validator:v.isNumber}),this.setAttributeConfig("sortFunction",{value:function(e,t,i,n){var l=YAHOO.util.Sort.compare,n=l(e.getData(n),t.getData(n),i);return 0===n?l(e.getCount(),t.getCount(),i):n}}),this.setAttributeConfig("formatRow",{value:null,validator:v.isFunction}),this.setAttributeConfig("generateRequest",{value:function(e,t){e=e||{pagination:null,sortedBy:null};var t=encodeURIComponent(e.sortedBy?e.sortedBy.key:t.getColumnSet().keys[0].getKey()),i=e.sortedBy&&e.sortedBy.dir===YAHOO.widget.DataTable.CLASS_DESC?"desc":"asc",n=e.pagination?e.pagination.recordOffset:0,e=e.pagination?e.pagination.rowsPerPage:null;return"sort="+t+"&dir="+i+"&startIndex="+n+(null!==e?"&results="+e:"")},validator:v.isFunction}),this.setAttributeConfig("initialRequest",{value:null}),this.setAttributeConfig("initialLoad",{value:!0}),this.setAttributeConfig("dynamicData",{value:!1,validator:v.isBoolean}),this.setAttributeConfig("MSG_EMPTY",{value:"No records found.",validator:v.isString}),this.setAttributeConfig("MSG_LOADING",{value:"Loading...",validator:v.isString}),this.setAttributeConfig("MSG_ERROR",{value:"Data error.",validator:v.isString}),this.setAttributeConfig("MSG_SORTASC",{value:"Click to sort ascending",validator:v.isString,method:function(e){if(this._elThead)for(var t=0,i=this.getColumnSet().keys,n=i.length;t<n;t++)i[t].sortable&&this.getColumnSortDir(i[t])===m.CLASS_ASC&&(i[t]._elThLabel.firstChild.title=e)}}),this.setAttributeConfig("MSG_SORTDESC",{value:"Click to sort descending",validator:v.isString,method:function(e){if(this._elThead)for(var t=0,i=this.getColumnSet().keys,n=i.length;t<n;t++)i[t].sortable&&this.getColumnSortDir(i[t])===m.CLASS_DESC&&(i[t]._elThLabel.firstChild.title=e)}}),this.setAttributeConfig("currencySymbol",{value:"$",validator:v.isString}),this.setAttributeConfig("currencyOptions",{value:{prefix:this.get("currencySymbol"),decimalPlaces:2,decimalSeparator:".",thousandsSeparator:","}}),this.setAttributeConfig("dateOptions",{value:{format:"%m/%d/%Y",locale:"en"}}),this.setAttributeConfig("numberOptions",{value:{decimalPlaces:0,thousandsSeparator:","}})},_bInit:!0,_nIndex:null,_nTrCount:0,_nTdCount:0,_sId:null,_oChainRender:null,_elContainer:null,_elMask:null,_elTable:null,_elCaption:null,_elColgroup:null,_elThead:null,_elTbody:null,_elMsgTbody:null,_elMsgTr:null,_elMsgTd:null,_elColumnDragTarget:null,_elColumnResizerProxy:null,_oDataSource:null,_oColumnSet:null,_oRecordSet:null,_oCellEditor:null,_sFirstTrId:null,_sLastTrId:null,_elTrTemplate:null,_aDynFunctions:[],_disabled:!1,clearTextSelection:function(){var e;window.getSelection?e=window.getSelection():document.getSelection?e=document.getSelection():document.selection&&(e=document.selection),e&&(e.empty?e.empty():e.removeAllRanges?e.removeAllRanges():e.collapse&&e.collapse())},_focusEl:function(t){t=t||this._elTbody,setTimeout(function(){try{t.focus()}catch(e){}},0)},_repaintGecko:h.gecko?function(e){var t=(e=e||this._elContainer).parentNode,i=e.nextSibling;t.insertBefore(t.removeChild(e),i)}:function(){},_repaintOpera:h.opera?function(){h.opera&&(document.documentElement.className+=" ",document.documentElement.className=YAHOO.lang.trim(document.documentElement.className))}:function(){},_repaintWebkit:h.webkit?function(e){var t=(e=e||this._elContainer).parentNode,i=e.nextSibling;t.insertBefore(t.removeChild(e),i)}:function(){},_initConfigs:function(e){e&&v.isObject(e)||(e={}),this.configs=e},_initColumnSet:function(e){var t;if(this._oColumnSet){for(n=0,l=this._oColumnSet.keys.length;n<l;n++)t=this._oColumnSet.keys[n],m._oDynStyles["."+this.getId()+"-col-"+t.getSanitizedKey()+" ."+m.CLASS_LINER]=undefined,t.editor&&t.editor.unsubscribeAll&&t.editor.unsubscribeAll();this._oColumnSet=null,this._clearTrTemplateEl()}v.isArray(e)?this._oColumnSet=new YAHOO.widget.ColumnSet(e):e instanceof YAHOO.widget.ColumnSet&&(this._oColumnSet=e);for(var i=this._oColumnSet.keys,n=0,l=i.length;n<l;n++)(t=i[n]).editor&&t.editor.subscribe&&(t.editor.subscribe("showEvent",this._onEditorShowEvent,this,!0),t.editor.subscribe("keydownEvent",this._onEditorKeydownEvent,this,!0),t.editor.subscribe("revertEvent",this._onEditorRevertEvent,this,!0),t.editor.subscribe("saveEvent",this._onEditorSaveEvent,this,!0),t.editor.subscribe("cancelEvent",this._onEditorCancelEvent,this,!0),t.editor.subscribe("blurEvent",this._onEditorBlurEvent,this,!0),t.editor.subscribe("blockEvent",this._onEditorBlockEvent,this,!0),t.editor.subscribe("unblockEvent",this._onEditorUnblockEvent,this,!0))},_initDataSource:function(e){if(this._oDataSource=null,e&&v.isFunction(e.sendRequest))this._oDataSource=e;else{var t=null,e=this._elContainer,i=0;if(e.hasChildNodes()){for(var n=e.childNodes,i=0;i<n.length;i++)if(n[i].nodeName&&"table"==n[i].nodeName.toLowerCase()){t=n[i];break}if(t){for(var l=[];i<this._oColumnSet.keys.length;i++)l.push({key:this._oColumnSet.keys[i].key});this._oDataSource=new o(t),this._oDataSource.responseType=o.TYPE_HTMLTABLE,this._oDataSource.responseSchema={fields:l}}}}},_initRecordSet:function(){this._oRecordSet?this._oRecordSet.reset():this._oRecordSet=new YAHOO.widget.RecordSet},_initDomElements:function(e){return this._initContainerEl(e),this._initTableEl(this._elContainer),this._initColgroupEl(this._elTable),this._initTheadEl(this._elTable),this._initMsgTbodyEl(this._elTable),this._initTbodyEl(this._elTable),!!(this._elContainer&&this._elTable&&this._elColgroup&&this._elThead&&this._elTbody&&this._elMsgTbody)},_destroyContainerEl:function(e){var t,i,n=this._oColumnSet.keys;for(c.removeClass(e,m.CLASS_DATATABLE),u.purgeElement(e),u.purgeElement(this._elThead,!0),u.purgeElement(this._elTbody),u.purgeElement(this._elMsgTbody),(t=e.getElementsByTagName("select")).length&&u.detachListener(t,"change"),i=n.length-1;0<=i;--i)n[i].editor&&u.purgeElement(n[i].editor._elContainer);e.innerHTML="",this._elContainer=null,this._elColgroup=null,this._elThead=null,this._elTbody=null},_initContainerEl:function(e){var t;(e=c.get(e))&&e.nodeName&&"div"==e.nodeName.toLowerCase()&&(this._destroyContainerEl(e),c.addClass(e,m.CLASS_DATATABLE),u.addListener(e,"focus",this._onTableFocus,this),u.addListener(e,"dblclick",this._onTableDblclick,this),this._elContainer=e,(t=document.createElement("div")).className=m.CLASS_MASK,t.style.display="none",this._elMask=e.appendChild(t))},_destroyTableEl:function(){var e=this._elTable;e&&(u.purgeElement(e,!0),e.parentNode.removeChild(e),this._elCaption=null,this._elColgroup=null,this._elThead=null,this._elTbody=null)},_initCaptionEl:function(e){this._elTable&&e?(this._elCaption||(this._elCaption=this._elTable.createCaption()),this._elCaption.innerHTML=e):this._elCaption&&this._elCaption.parentNode.removeChild(this._elCaption)},_initTableEl:function(e){e&&(this._destroyTableEl(),this._elTable=e.appendChild(document.createElement("table")),this._elTable.summary=this.get("summary"),this.get("caption")&&this._initCaptionEl(this.get("caption")),u.delegate(this._elTable,"mouseenter",this._onTableMouseover,"thead ."+m.CLASS_LABEL,this),u.delegate(this._elTable,"mouseleave",this._onTableMouseout,"thead ."+m.CLASS_LABEL,this),u.delegate(this._elTable,"mouseenter",this._onTableMouseover,"tbody.yui-dt-data>tr>td",this),u.delegate(this._elTable,"mouseleave",this._onTableMouseout,"tbody.yui-dt-data>tr>td",this),u.delegate(this._elTable,"mouseenter",this._onTableMouseover,"tbody.yui-dt-message>tr>td",this),u.delegate(this._elTable,"mouseleave",this._onTableMouseout,"tbody.yui-dt-message>tr>td",this))},_destroyColgroupEl:function(){var e,t=this._elColgroup;t&&(e=t.parentNode,u.purgeElement(t,!0),e.removeChild(t),this._elColgroup=null)},_initColgroupEl:function(e){if(e){this._destroyColgroupEl();for(var t=this._aColIds||[],i=this._oColumnSet.keys,n=0,l=(t.length,document.createDocumentFragment()),o=document.createElement("col"),n=0,s=i.length;n<s;n++)i[n],l.appendChild(o.cloneNode(!1));t=e.insertBefore(document.createElement("colgroup"),e.firstChild);t.appendChild(l),this._elColgroup=t}},_insertColgroupColEl:function(e){v.isNumber(e)&&this._elColgroup&&(e=this._elColgroup.childNodes[e]||null,this._elColgroup.insertBefore(document.createElement("col"),e))},_removeColgroupColEl:function(e){v.isNumber(e)&&this._elColgroup&&this._elColgroup.childNodes[e]&&this._elColgroup.removeChild(this._elColgroup.childNodes[e])},_reorderColgroupColEl:function(e,t){if(v.isArray(e)&&v.isNumber(t)&&this._elColgroup&&this._elColgroup.childNodes.length>e[e.length-1]){for(var i=[],n=e.length-1;-1<n;n--)i.push(this._elColgroup.removeChild(this._elColgroup.childNodes[e[n]]));var l=this._elColgroup.childNodes[t]||null;for(n=i.length-1;-1<n;n--)this._elColgroup.insertBefore(i[n],l)}},_destroyTheadEl:function(){var e,t=this._elThead;t&&(e=t.parentNode,u.purgeElement(t,!0),this._destroyColumnHelpers(),e.removeChild(t),this._elThead=null)},_initTheadEl:function(e){if(e=e||this._elTable){this._destroyTheadEl();for(var t,i,n=this._elColgroup?e.insertBefore(document.createElement("thead"),this._elColgroup.nextSibling):e.appendChild(document.createElement("thead")),e=(u.addListener(n,"focus",this._onTheadFocus,this),u.addListener(n,"keydown",this._onTheadKeydown,this),u.addListener(n,"mousedown",this._onTableMousedown,this),u.addListener(n,"mouseup",this._onTableMouseup,this),u.addListener(n,"click",this._onTheadClick,this),this._oColumnSet),l=e.tree,o=0;o<l.length;o++){for(var s=n.appendChild(document.createElement("tr")),r=0;r<l[o].length;r++)t=l[o][r],i=s.appendChild(document.createElement("th")),this._initThEl(i,t);0===o&&c.addClass(s,m.CLASS_FIRST),o===l.length-1&&c.addClass(s,m.CLASS_LAST)}var a=e.headers[0]||[];for(o=0;o<a.length;o++)c.addClass(c.get(this.getId()+"-th-"+a[o]),m.CLASS_FIRST);var d=e.headers[e.headers.length-1]||[];for(o=0;o<d.length;o++)c.addClass(c.get(this.getId()+"-th-"+d[o]),m.CLASS_LAST);h.webkit&&h.webkit<420&&(setTimeout(function(){n.style.display=""},0),n.style.display="none"),this._elThead=n,this._initColumnHelpers()}},_initThEl:function(e,t){e.id=this.getId()+"-th-"+t.getSanitizedKey(),e.innerHTML="",e.rowSpan=t.getRowspan(),e.colSpan=t.getColspan();var i,n=(t._elTh=e).appendChild(document.createElement("div")),n=(n.id=e.id+"-liner",n.className=m.CLASS_LINER,(t._elThLiner=n).appendChild(document.createElement("span")));n.className=m.CLASS_LABEL,t.abbr&&(e.abbr=t.abbr),t.hidden&&this._clearMinWidth(t),e.className=this._getColumnClassNames(t),t.width&&(i=t.minWidth&&t.width<t.minWidth?t.minWidth:t.width,m._bDynStylesFallback?(e.firstChild.style.overflow="hidden",e.firstChild.style.width=i+"px"):this._setColumnWidthDynStyles(t,i+"px","hidden")),this.formatTheadCell(n,t,this.get("sortedBy")),t._elThLabel=n},formatTheadCell:function(e,t,i){var n,l=t.getKey(),l=v.isValue(t.label)?t.label:l;t.sortable?(n=this.getColumnSortDir(t,i)===m.CLASS_DESC,i&&t.key===i.key&&(n=!(i.dir===m.CLASS_DESC)),i=this.getId()+"-href-"+t.getSanitizedKey(),t=n?this.get("MSG_SORTDESC"):this.get("MSG_SORTASC"),e.innerHTML='<a href="'+i+'" title="'+t+'" class="'+m.CLASS_SORTABLE+'">'+l+"</a>"):e.innerHTML=l},_destroyDraggableColumns:function(){for(var e,t=0,i=this._oColumnSet.tree[0].length;t<i;t++)(e=this._oColumnSet.tree[0][t])._dd&&(e._dd=e._dd.unreg(),c.removeClass(e.getThEl(),m.CLASS_DRAGGABLE));this._destroyColumnDragTargetEl()},_initDraggableColumns:function(){if(this._destroyDraggableColumns(),s.DD)for(var e,t,i,n=0,l=this._oColumnSet.tree[0].length;n<l;n++)t=(e=this._oColumnSet.tree[0][n]).getThEl(),c.addClass(t,m.CLASS_DRAGGABLE),i=this._initColumnDragTargetEl(),e._dd=new YAHOO.widget.ColumnDD(this,e,t,i)},_destroyColumnDragTargetEl:function(){var e;this._elColumnDragTarget&&(e=this._elColumnDragTarget,YAHOO.util.Event.purgeElement(e),e.parentNode.removeChild(e),this._elColumnDragTarget=null)},_initColumnDragTargetEl:function(){var e;return this._elColumnDragTarget||((e=document.createElement("div")).id=this.getId()+"-coltarget",e.className=m.CLASS_COLTARGET,e.style.display="none",document.body.insertBefore(e,document.body.firstChild),this._elColumnDragTarget=e),this._elColumnDragTarget},_destroyResizeableColumns:function(){for(var e=this._oColumnSet.keys,t=0,i=e.length;t<i;t++)e[t]._ddResizer&&(e[t]._ddResizer=e[t]._ddResizer.unreg(),c.removeClass(e[t].getThEl(),m.CLASS_RESIZEABLE));this._destroyColumnResizerProxyEl()},_initResizeableColumns:function(){if(this._destroyResizeableColumns(),s.DD)for(var e,t,i,n,l=0,o=this._oColumnSet.keys.length;l<o;l++)(e=this._oColumnSet.keys[l]).resizeable&&(t=e.getThEl(),c.addClass(t,m.CLASS_RESIZEABLE),i=e.getThLinerEl(),(n=t.appendChild(document.createElement("div"))).className=m.CLASS_RESIZERLINER,n.appendChild(i),(i=n.appendChild(document.createElement("div"))).id=t.id+"-resizer",i.className=m.CLASS_RESIZER,e._elResizer=i,n=this._initColumnResizerProxyEl(),e._ddResizer=new YAHOO.util.ColumnResizer(this,e,t,i,n),u.addListener(i,"click",function(e){u.stopPropagation(e)}))},_destroyColumnResizerProxyEl:function(){var e;this._elColumnResizerProxy&&(e=this._elColumnResizerProxy,YAHOO.util.Event.purgeElement(e),e.parentNode.removeChild(e),this._elColumnResizerProxy=null)},_initColumnResizerProxyEl:function(){var e;return this._elColumnResizerProxy||((e=document.createElement("div")).id=this.getId()+"-colresizerproxy",e.className=m.CLASS_RESIZERPROXY,document.body.insertBefore(e,document.body.firstChild),this._elColumnResizerProxy=e),this._elColumnResizerProxy},_destroyColumnHelpers:function(){this._destroyDraggableColumns(),this._destroyResizeableColumns()},_initColumnHelpers:function(){this.get("draggableColumns")&&this._initDraggableColumns(),this._initResizeableColumns()},_destroyTbodyEl:function(){var e,t=this._elTbody;t&&(e=t.parentNode,u.purgeElement(t,!0),e.removeChild(t),this._elTbody=null)},_initTbodyEl:function(e){e&&(this._destroyTbodyEl(),(e=e.appendChild(document.createElement("tbody"))).tabIndex=0,e.className=m.CLASS_DATA,u.addListener(e,"focus",this._onTbodyFocus,this),u.addListener(e,"mousedown",this._onTableMousedown,this),u.addListener(e,"mouseup",this._onTableMouseup,this),u.addListener(e,"keydown",this._onTbodyKeydown,this),u.addListener(e,"click",this._onTbodyClick,this),h.ie&&(e.hideFocus=!0),this._elTbody=e)},_destroyMsgTbodyEl:function(){var e,t=this._elMsgTbody;t&&(e=t.parentNode,u.purgeElement(t,!0),e.removeChild(t),this._elTbody=null)},_initMsgTbodyEl:function(e){var t,i;e&&((t=document.createElement("tbody")).className=m.CLASS_MESSAGE,(i=t.appendChild(document.createElement("tr"))).className=m.CLASS_FIRST+" "+m.CLASS_LAST,(i=(this._elMsgTr=i).appendChild(document.createElement("td"))).colSpan=this._oColumnSet.keys.length||1,i.className=m.CLASS_FIRST+" "+m.CLASS_LAST,this._elMsgTd=i,t=e.insertBefore(t,this._elTbody),i.appendChild(document.createElement("div")).className=m.CLASS_LINER,this._elMsgTbody=t,u.addListener(t,"focus",this._onTbodyFocus,this),u.addListener(t,"mousedown",this._onTableMousedown,this),u.addListener(t,"mouseup",this._onTableMouseup,this),u.addListener(t,"keydown",this._onTbodyKeydown,this),u.addListener(t,"click",this._onTbodyClick,this))},_initEvents:function(){this._initColumnSort(),YAHOO.util.Event.addListener(document,"click",this._onDocumentClick,this),this.subscribe("paginatorChange",function(){this._handlePaginatorChange.apply(this,arguments)}),this.subscribe("initEvent",function(){this.renderPaginator()}),this._initCellEditing()},_initColumnSort:function(){this.subscribe("theadCellClickEvent",this.onEventSortColumn);var e=this.get("sortedBy");e&&("desc"==e.dir?this._configs.sortedBy.value.dir=m.CLASS_DESC:"asc"==e.dir&&(this._configs.sortedBy.value.dir=m.CLASS_ASC))},_initCellEditing:function(){this.subscribe("editorBlurEvent",function(){this.onEditorBlurEvent.apply(this,arguments)}),this.subscribe("editorBlockEvent",function(){this.onEditorBlockEvent.apply(this,arguments)}),this.subscribe("editorUnblockEvent",function(){this.onEditorUnblockEvent.apply(this,arguments)})},_getColumnClassNames:function(e,t){var i=v.isString(e.className)?[e.className]:v.isArray(e.className)?e.className:[],n=(i[i.length]=this.getId()+"-col-"+e.getSanitizedKey(),i[i.length]="yui-dt-col-"+e.getSanitizedKey(),this.get("sortedBy")||{});return e.key===n.key&&(i[i.length]=n.dir||""),e.hidden&&(i[i.length]=m.CLASS_HIDDEN),e.selected&&(i[i.length]=m.CLASS_SELECTED),e.sortable&&(i[i.length]=m.CLASS_SORTABLE),e.resizeable&&(i[i.length]=m.CLASS_RESIZEABLE),e.editor&&(i[i.length]=m.CLASS_EDITABLE),(i=t?i.concat(t):i).join(" ")},_clearTrTemplateEl:function(){this._elTrTemplate=null},_getTrTemplateEl:function(e,t){if(this._elTrTemplate)return this._elTrTemplate;for(var i,n=document,l=n.createElement("tr"),o=n.createElement("td"),n=n.createElement("div"),s=(o.appendChild(n),document.createDocumentFragment()),r=this._oColumnSet.keys,a=0,d=r.length;a<d;a++)i=o.cloneNode(!0),i=this._formatTdEl(r[a],i,a,a===d-1),s.appendChild(i);return l.appendChild(s),l.className=m.CLASS_REC,this._elTrTemplate=l},_formatTdEl:function(e,t,i,n){for(var l=this._oColumnSet.headers[i],o="",s=0,r=l.length;s<r;s++)o+=this._sId+"-th-"+l[s]+" ";t.headers=o;var a=[];return 0===i&&(a[a.length]=m.CLASS_FIRST),n&&(a[a.length]=m.CLASS_LAST),t.className=this._getColumnClassNames(e,a),t.firstChild.className=m.CLASS_LINER,e.width&&m._bDynStylesFallback&&(i=e.minWidth&&e.width<e.minWidth?e.minWidth:e.width,t.firstChild.style.overflow="hidden",t.firstChild.style.width=i+"px"),t},_addTrEl:function(e){var t=this._getTrTemplateEl().cloneNode(!0);return this._updateTrEl(t,e)},_updateTrEl:function(e,t){if(!this.get("formatRow")||this.get("formatRow").call(this,e,t)){e.style.display="none";for(var i=e.childNodes,n=0,l=i.length;n<l;++n)i[n],this.formatCell(i[n].firstChild,t,this._oColumnSet.keys[n]);e.style.display=""}var o=e.id,s=t.getId();return this._sFirstTrId===o&&(this._sFirstTrId=s),this._sLastTrId===o&&(this._sLastTrId=s),e.id=s,e},_deleteTrEl:function(e){var t=v.isNumber(e)?e:c.get(e).sectionRowIndex;return v.isNumber(t)&&-2<t&&t<this._elTbody.rows.length?this._elTbody.removeChild(this._elTbody.rows[e]):null},_unsetFirstRow:function(){this._sFirstTrId&&(c.removeClass(this._sFirstTrId,m.CLASS_FIRST),this._sFirstTrId=null)},_setFirstRow:function(){this._unsetFirstRow();var e=this.getFirstTrEl();e&&(c.addClass(e,m.CLASS_FIRST),this._sFirstTrId=e.id)},_unsetLastRow:function(){this._sLastTrId&&(c.removeClass(this._sLastTrId,m.CLASS_LAST),this._sLastTrId=null)},_setLastRow:function(){this._unsetLastRow();var e=this.getLastTrEl();e&&(c.addClass(e,m.CLASS_LAST),this._sLastTrId=e.id)},_setRowStripes:function(e,t){var i=this._elTbody.rows,n=0,l=i.length,o=[],s=0,r=[],a=0;null!==e&&e!==undefined&&(e=this.getTrEl(e))&&(n=e.sectionRowIndex,v.isNumber(t))&&1<t&&(l=n+t);for(var d=n;d<l;d++)d%2?o[s++]=i[d]:r[a++]=i[d];o.length&&c.replaceClass(o,m.CLASS_EVEN,m.CLASS_ODD),r.length&&c.replaceClass(r,m.CLASS_ODD,m.CLASS_EVEN)},_setSelections:function(){var e=this.getSelectedRows(),t=this.getSelectedCells();if(0<e.length||0<t.length){for(var i,n=this._oColumnSet,l=0;l<e.length;l++)(i=c.get(e[l]))&&c.addClass(i,m.CLASS_SELECTED);for(l=0;l<t.length;l++)(i=c.get(t[l].recordId))&&c.addClass(i.childNodes[n.getColumn(t[l].columnKey).getKeyIndex()],m.CLASS_SELECTED)}},_onRenderChainEnd:function(){this.hideTableMessage(),0===this._elTbody.rows.length&&this.showTableMessage(this.get("MSG_EMPTY"),m.CLASS_EMPTY);var e=this;setTimeout(function(){e instanceof m&&e._sId&&(e._bInit&&(e._bInit=!1,e.fireEvent("initEvent")),e.fireEvent("renderEvent"),e.fireEvent("refreshEvent"),e.validateColumnWidths(),e.fireEvent("postRenderEvent"))},0)},_onDocumentClick:function(e,t){var i,e=u.getTarget(e);e.nodeName.toLowerCase();c.isAncestor(t._elContainer,e)||(t.fireEvent("tableBlurEvent"),t._oCellEditor&&(t._oCellEditor.getContainerEl?(i=t._oCellEditor.getContainerEl(),c.isAncestor(i,e)||i.id===e.id||t._oCellEditor.fireEvent("blurEvent",{editor:t._oCellEditor})):t._oCellEditor.isActive&&!c.isAncestor(t._oCellEditor.container,e)&&t._oCellEditor.container.id!==e.id&&t.fireEvent("editorBlurEvent",{editor:t._oCellEditor})))},_onTableFocus:function(e,t){t.fireEvent("tableFocusEvent")},_onTheadFocus:function(e,t){t.fireEvent("theadFocusEvent"),t.fireEvent("tableFocusEvent")},_onTbodyFocus:function(e,t){t.fireEvent("tbodyFocusEvent"),t.fireEvent("tableFocusEvent")},_onTableMouseover:function(e,t,i,n){for(var l=t,o=l.nodeName&&l.nodeName.toLowerCase(),s=!0;l&&"table"!=o;){switch(o){case"body":return;case"a":break;case"td":s=n.fireEvent("cellMouseoverEvent",{target:l,event:e});break;case"span":c.hasClass(l,m.CLASS_LABEL)&&(s=n.fireEvent("theadLabelMouseoverEvent",{target:l,event:e}),s=n.fireEvent("headerLabelMouseoverEvent",{target:l,event:e}));break;case"th":s=n.fireEvent("theadCellMouseoverEvent",{target:l,event:e}),s=n.fireEvent("headerCellMouseoverEvent",{target:l,event:e});break;case"tr":s="thead"==l.parentNode.nodeName.toLowerCase()?(s=n.fireEvent("theadRowMouseoverEvent",{target:l,event:e}),n.fireEvent("headerRowMouseoverEvent",{target:l,event:e})):n.fireEvent("rowMouseoverEvent",{target:l,event:e})}if(!1===s)return;(l=l.parentNode)&&(o=l.nodeName.toLowerCase())}n.fireEvent("tableMouseoverEvent",{target:l||n._elContainer,event:e})},_onTableMouseout:function(e,t,i,n){for(var l=t,o=l.nodeName&&l.nodeName.toLowerCase(),s=!0;l&&"table"!=o;){switch(o){case"body":return;case"a":break;case"td":s=n.fireEvent("cellMouseoutEvent",{target:l,event:e});break;case"span":c.hasClass(l,m.CLASS_LABEL)&&(s=n.fireEvent("theadLabelMouseoutEvent",{target:l,event:e}),s=n.fireEvent("headerLabelMouseoutEvent",{target:l,event:e}));break;case"th":s=n.fireEvent("theadCellMouseoutEvent",{target:l,event:e}),s=n.fireEvent("headerCellMouseoutEvent",{target:l,event:e});break;case"tr":s="thead"==l.parentNode.nodeName.toLowerCase()?(s=n.fireEvent("theadRowMouseoutEvent",{target:l,event:e}),n.fireEvent("headerRowMouseoutEvent",{target:l,event:e})):n.fireEvent("rowMouseoutEvent",{target:l,event:e})}if(!1===s)return;(l=l.parentNode)&&(o=l.nodeName.toLowerCase())}n.fireEvent("tableMouseoutEvent",{target:l||n._elContainer,event:e})},_onTableMousedown:function(e,t){for(var i=u.getTarget(e),n=i.nodeName&&i.nodeName.toLowerCase(),l=!0;i&&"table"!=n;){switch(n){case"body":return;case"a":break;case"td":l=t.fireEvent("cellMousedownEvent",{target:i,event:e});break;case"span":c.hasClass(i,m.CLASS_LABEL)&&(l=t.fireEvent("theadLabelMousedownEvent",{target:i,event:e}),l=t.fireEvent("headerLabelMousedownEvent",{target:i,event:e}));break;case"th":l=t.fireEvent("theadCellMousedownEvent",{target:i,event:e}),l=t.fireEvent("headerCellMousedownEvent",{target:i,event:e});break;case"tr":l="thead"==i.parentNode.nodeName.toLowerCase()?(l=t.fireEvent("theadRowMousedownEvent",{target:i,event:e}),t.fireEvent("headerRowMousedownEvent",{target:i,event:e})):t.fireEvent("rowMousedownEvent",{target:i,event:e})}if(!1===l)return;(i=i.parentNode)&&(n=i.nodeName.toLowerCase())}t.fireEvent("tableMousedownEvent",{target:i||t._elContainer,event:e})},_onTableMouseup:function(e,t){for(var i=u.getTarget(e),n=i.nodeName&&i.nodeName.toLowerCase(),l=!0;i&&"table"!=n;){switch(n){case"body":return;case"a":break;case"td":l=t.fireEvent("cellMouseupEvent",{target:i,event:e});break;case"span":c.hasClass(i,m.CLASS_LABEL)&&(l=t.fireEvent("theadLabelMouseupEvent",{target:i,event:e}),l=t.fireEvent("headerLabelMouseupEvent",{target:i,event:e}));break;case"th":l=t.fireEvent("theadCellMouseupEvent",{target:i,event:e}),l=t.fireEvent("headerCellMouseupEvent",{target:i,event:e});break;case"tr":l="thead"==i.parentNode.nodeName.toLowerCase()?(l=t.fireEvent("theadRowMouseupEvent",{target:i,event:e}),t.fireEvent("headerRowMouseupEvent",{target:i,event:e})):t.fireEvent("rowMouseupEvent",{target:i,event:e})}if(!1===l)return;(i=i.parentNode)&&(n=i.nodeName.toLowerCase())}t.fireEvent("tableMouseupEvent",{target:i||t._elContainer,event:e})},_onTableDblclick:function(e,t){for(var i=u.getTarget(e),n=i.nodeName&&i.nodeName.toLowerCase(),l=!0;i&&"table"!=n;){switch(n){case"body":return;case"td":l=t.fireEvent("cellDblclickEvent",{target:i,event:e});break;case"span":c.hasClass(i,m.CLASS_LABEL)&&(l=t.fireEvent("theadLabelDblclickEvent",{target:i,event:e}),l=t.fireEvent("headerLabelDblclickEvent",{target:i,event:e}));break;case"th":l=t.fireEvent("theadCellDblclickEvent",{target:i,event:e}),l=t.fireEvent("headerCellDblclickEvent",{target:i,event:e});break;case"tr":l="thead"==i.parentNode.nodeName.toLowerCase()?(l=t.fireEvent("theadRowDblclickEvent",{target:i,event:e}),t.fireEvent("headerRowDblclickEvent",{target:i,event:e})):t.fireEvent("rowDblclickEvent",{target:i,event:e})}if(!1===l)return;(i=i.parentNode)&&(n=i.nodeName.toLowerCase())}t.fireEvent("tableDblclickEvent",{target:i||t._elContainer,event:e})},_onTheadKeydown:function(e,t){for(var i=u.getTarget(e),n=i.nodeName&&i.nodeName.toLowerCase(),l=!0;i&&"table"!=n;){switch(n){case"body":return;case"input":case"textarea":break;case"thead":l=t.fireEvent("theadKeyEvent",{target:i,event:e})}if(!1===l)return;(i=i.parentNode)&&(n=i.nodeName.toLowerCase())}t.fireEvent("tableKeyEvent",{target:i||t._elContainer,event:e})},_onTbodyKeydown:function(e,t){for(var i=t.get("selectionMode"),n=("standard"==i?t._handleStandardSelectionByKey(e):"single"==i?t._handleSingleSelectionByKey(e):"cellblock"==i?t._handleCellBlockSelectionByKey(e):"cellrange"==i?t._handleCellRangeSelectionByKey(e):"singlecell"==i&&t._handleSingleCellSelectionByKey(e),t._oCellEditor&&(t._oCellEditor.fireEvent?t._oCellEditor.fireEvent("blurEvent",{editor:t._oCellEditor}):t._oCellEditor.isActive&&t.fireEvent("editorBlurEvent",{editor:t._oCellEditor})),u.getTarget(e)),l=n.nodeName&&n.nodeName.toLowerCase(),o=!0;n&&"table"!=l;){switch(l){case"body":return;case"tbody":o=t.fireEvent("tbodyKeyEvent",{target:n,event:e})}if(!1===o)return;(n=n.parentNode)&&(l=n.nodeName.toLowerCase())}t.fireEvent("tableKeyEvent",{target:n||t._elContainer,event:e})},_onTheadClick:function(e,t){t._oCellEditor&&(t._oCellEditor.fireEvent?t._oCellEditor.fireEvent("blurEvent",{editor:t._oCellEditor}):t._oCellEditor.isActive&&t.fireEvent("editorBlurEvent",{editor:t._oCellEditor}));for(var i=u.getTarget(e),n=i.nodeName&&i.nodeName.toLowerCase(),l=!0;i&&"table"!=n;){switch(n){case"body":return;case"input":var o=i.type.toLowerCase();"checkbox"==o?l=t.fireEvent("theadCheckboxClickEvent",{target:i,event:e}):"radio"==o?l=t.fireEvent("theadRadioClickEvent",{target:i,event:e}):"button"==o||"image"==o||"submit"==o||"reset"==o?l=!i.disabled&&t.fireEvent("theadButtonClickEvent",{target:i,event:e}):i.disabled&&(l=!1);break;case"a":l=t.fireEvent("theadLinkClickEvent",{target:i,event:e});break;case"button":l=!i.disabled&&t.fireEvent("theadButtonClickEvent",{target:i,event:e});break;case"span":c.hasClass(i,m.CLASS_LABEL)&&(l=t.fireEvent("theadLabelClickEvent",{target:i,event:e}),l=t.fireEvent("headerLabelClickEvent",{target:i,event:e}));break;case"th":l=t.fireEvent("theadCellClickEvent",{target:i,event:e}),l=t.fireEvent("headerCellClickEvent",{target:i,event:e});break;case"tr":l=t.fireEvent("theadRowClickEvent",{target:i,event:e}),l=t.fireEvent("headerRowClickEvent",{target:i,event:e})}if(!1===l)return;(i=i.parentNode)&&(n=i.nodeName.toLowerCase())}t.fireEvent("tableClickEvent",{target:i||t._elContainer,event:e})},_onTbodyClick:function(e,t){t._oCellEditor&&(t._oCellEditor.fireEvent?t._oCellEditor.fireEvent("blurEvent",{editor:t._oCellEditor}):t._oCellEditor.isActive&&t.fireEvent("editorBlurEvent",{editor:t._oCellEditor}));for(var i=u.getTarget(e),n=i.nodeName&&i.nodeName.toLowerCase(),l=!0;i&&"table"!=n;){switch(n){case"body":return;case"input":var o=i.type.toLowerCase();"checkbox"==o?l=t.fireEvent("checkboxClickEvent",{target:i,event:e}):"radio"==o?l=t.fireEvent("radioClickEvent",{target:i,event:e}):"button"==o||"image"==o||"submit"==o||"reset"==o?l=!i.disabled&&t.fireEvent("buttonClickEvent",{target:i,event:e}):i.disabled&&(l=!1);break;case"a":l=t.fireEvent("linkClickEvent",{target:i,event:e});break;case"button":l=!i.disabled&&t.fireEvent("buttonClickEvent",{target:i,event:e});break;case"td":l=t.fireEvent("cellClickEvent",{target:i,event:e});break;case"tr":l=t.fireEvent("rowClickEvent",{target:i,event:e})}if(!1===l)return;(i=i.parentNode)&&(n=i.nodeName.toLowerCase())}t.fireEvent("tableClickEvent",{target:i||t._elContainer,event:e})},_onDropdownChange:function(e,t){var i=u.getTarget(e);t.fireEvent("dropdownChangeEvent",{event:e,target:i})},configs:null,getId:function(){return this._sId},toString:function(){return"DataTable instance "+this._sId},getDataSource:function(){return this._oDataSource},getColumnSet:function(){return this._oColumnSet},getRecordSet:function(){return this._oRecordSet},getState:function(){return{totalRecords:this.get("paginator")?this.get("paginator").get("totalRecords"):this._oRecordSet.getLength(),pagination:this.get("paginator")?this.get("paginator").getState():null,sortedBy:this.get("sortedBy"),selectedRows:this.getSelectedRows(),selectedCells:this.getSelectedCells()}},getContainerEl:function(){return this._elContainer},getTableEl:function(){return this._elTable},getTheadEl:function(){return this._elThead},getTbodyEl:function(){return this._elTbody},getMsgTbodyEl:function(){return this._elMsgTbody},getMsgTdEl:function(){return this._elMsgTd},getTrEl:function(e){if(e instanceof YAHOO.widget.Record)return document.getElementById(e.getId());if(v.isNumber(e))return(t=c.getElementsByClassName(m.CLASS_REC,"tr",this._elTbody))&&t[e]?t[e]:null;if(e){var t=v.isString(e)?document.getElementById(e):e;if(t&&t.ownerDocument==document)return t="tr"!=t.nodeName.toLowerCase()?c.getAncestorByTagName(t,"tr"):t}return null},getFirstTrEl:function(){for(var e=this._elTbody.rows,t=0;e[t];){if(this.getRecord(e[t]))return e[t];t++}return null},getLastTrEl:function(){for(var e=this._elTbody.rows,t=e.length-1;-1<t;){if(this.getRecord(e[t]))return e[t];t--}return null},getNextTrEl:function(e,t){var i=this.getTrIndex(e);if(null!==i){var n=this._elTbody.rows;if(t)for(;i<n.length-1;){if(e=n[i+1],this.getRecord(e))return e;i++}else if(i<n.length-1)return n[i+1]}return null},getPreviousTrEl:function(e,t){var i=this.getTrIndex(e);if(null!==i){var n=this._elTbody.rows;if(t)for(;0<i;){if(e=n[i-1],this.getRecord(e))return e;i--}else if(0<i)return n[i-1]}return null},getCellIndex:function(e){if(e=this.getTdEl(e)){if(!(0<h.ie))return e.cellIndex;for(var t=0,i=e.parentNode.childNodes,n=i.length;t<n;t++)if(i[t]==e)return t}},getTdLinerEl:function(e){return this.getTdEl(e).firstChild||null},getTdEl:function(e){var t=c.get(e);if(t&&t.ownerDocument==document){if((t="td"!=t.nodeName.toLowerCase()?c.getAncestorByTagName(t,"td"):t)&&(t.parentNode.parentNode==this._elTbody||null===t.parentNode.parentNode||11===t.parentNode.parentNode.nodeType))return t}else if(e){v.isString(e.columnKey)&&v.isString(e.recordId)&&(n=this.getRecord(e.recordId),t=this.getColumn(e.columnKey))&&(i=t.getKeyIndex()),e.record&&e.column&&e.column.getKeyIndex&&(n=e.record,i=e.column.getKeyIndex());var i,n,t=this.getTrEl(n);if(null!==i&&t&&t.cells&&0<t.cells.length)return t.cells[i]||null}return null},getFirstTdEl:function(e){e=v.isValue(e)?this.getTrEl(e):this.getFirstTrEl();if(e){if(e.cells&&0<e.cells.length)return e.cells[0];if(e.childNodes&&0<e.childNodes.length)return e.childNodes[0]}return null},getLastTdEl:function(e){e=v.isValue(e)?this.getTrEl(e):this.getLastTrEl();if(e){if(e.cells&&0<e.cells.length)return e.cells[e.cells.length-1];if(e.childNodes&&0<e.childNodes.length)return e.childNodes[e.childNodes.length-1]}return null},getNextTdEl:function(e){e=this.getTdEl(e);if(e){var t=this.getCellIndex(e),e=this.getTrEl(e);if(e.cells&&0<e.cells.length&&t<e.cells.length-1)return e.cells[t+1];if(e.childNodes&&0<e.childNodes.length&&t<e.childNodes.length-1)return e.childNodes[t+1];t=this.getNextTrEl(e);if(t)return t.cells[0]}return null},getPreviousTdEl:function(e){e=this.getTdEl(e);if(e){var t=this.getCellIndex(e),e=this.getTrEl(e);if(0<t){if(e.cells&&0<e.cells.length)return e.cells[t-1];if(e.childNodes&&0<e.childNodes.length)return e.childNodes[t-1]}else{t=this.getPreviousTrEl(e);if(t)return this.getLastTdEl(t)}}return null},getAboveTdEl:function(e,t){e=this.getTdEl(e);if(e){t=this.getPreviousTrEl(e,t);if(t){e=this.getCellIndex(e);if(t.cells&&0<t.cells.length)return t.cells[e]||null;if(t.childNodes&&0<t.childNodes.length)return t.childNodes[e]||null}}return null},getBelowTdEl:function(e,t){e=this.getTdEl(e);if(e){t=this.getNextTrEl(e,t);if(t){e=this.getCellIndex(e);if(t.cells&&0<t.cells.length)return t.cells[e]||null;if(t.childNodes&&0<t.childNodes.length)return t.childNodes[e]||null}}return null},getThLinerEl:function(e){e=this.getColumn(e);return e?e.getThLinerEl():null},getThEl:function(e){var t;if(e instanceof YAHOO.widget.Column){if(t=e.getThEl())return t}else{e=c.get(e);if(e&&e.ownerDocument==document)return t="th"!=e.nodeName.toLowerCase()?c.getAncestorByTagName(e,"th"):e}return null},getTrIndex:function(e){var e=this.getRecord(e),t=this.getRecordIndex(e);return e?(e=this.getTrEl(e))?e.sectionRowIndex:(e=this.get("paginator"))?e.get("recordOffset")+t:t:null},load:function(e){((e=e||{}).datasource||this._oDataSource).sendRequest(e.request||this.get("initialRequest"),e.callback||{success:this.onDataReturnInitializeTable,failure:this.onDataReturnInitializeTable,scope:this,argument:this.getState()})},initializeTable:function(){this._bInit=!0,this._oRecordSet.reset();var e=this.get("paginator");e&&e.set("totalRecords",0),this._unselectAllTrEls(),this._unselectAllTdEls(),this._aSelections=null,this._oAnchorRecord=null,this._oAnchorCell=null,this.set("sortedBy",null)},_runRenderChain:function(){this._oChainRender.run()},_getViewRecords:function(){var e=this.get("paginator");return e?this._oRecordSet.getRecords(e.getStartIndex(),e.getRowsPerPage()):this._oRecordSet.getRecords()},render:function(){this._oChainRender.stop(),this.fireEvent("beforeRenderEvent");var o=this._getViewRecords(),s=this._elTbody,e=this.get("renderLoopSize"),r=o.length;if(0<r){for(s.style.display="none";s.lastChild;)s.removeChild(s.lastChild);s.style.display="",this._oChainRender.add({method:function(e){if(this instanceof m&&this._sId){var t,i,n=e.nCurrentRecord,l=e.nCurrentRecord+e.nLoopLength>r?r:e.nCurrentRecord+e.nLoopLength;for(s.style.display="none";n<l;n++)t=c.get(o[n].getId())||this._addTrEl(o[n]),i=s.childNodes[n]||null,s.insertBefore(t,i);s.style.display="",e.nCurrentRecord=n}},scope:this,iterations:0<e?Math.ceil(r/e):1,argument:{nCurrentRecord:0,nLoopLength:0<e?e:r},timeout:0<e?0:-1}),this._oChainRender.add({method:function(e){if(this instanceof m&&this._sId){for(;s.rows.length>r;)s.removeChild(s.lastChild);this._setFirstRow(),this._setLastRow(),this._setRowStripes(),this._setSelections()}},scope:this,timeout:0<e?0:-1})}else{var t=s.rows.length;0<t&&this._oChainRender.add({method:function(e){if(this instanceof m&&this._sId){var t=e.nCurrent,i=e.nLoopLength,n=t-i<0?0:t-i;for(s.style.display="none";n<t;t--)s.deleteRow(-1);s.style.display="",e.nCurrent=t}},scope:this,iterations:0<e?Math.ceil(t/e):1,argument:{nCurrent:t,nLoopLength:0<e?e:t},timeout:0<e?0:-1})}this._runRenderChain()},disable:function(){this._disabled=!0;var e=this._elTable,t=this._elMask;t.style.width=e.offsetWidth+"px",t.style.height=e.offsetHeight+"px",t.style.left=e.offsetLeft+"px",t.style.display="",this.fireEvent("disableEvent")},undisable:function(){this._disabled=!1,this._elMask.style.display="none",this.fireEvent("undisableEvent")},isDisabled:function(){return this._disabled},destroy:function(){var e;this.toString();this._oChainRender.stop(),this._destroyColumnHelpers();for(var t,i=0,n=this._oColumnSet.flat.length;i<n;i++)(e=this._oColumnSet.flat[i].editor)&&e.destroy&&(e.destroy(),this._oColumnSet.flat[i].editor=null);for(t in this._destroyPaginator(),this._oRecordSet.unsubscribeAll(),this.unsubscribeAll(),u.removeListener(document,"click",this._onDocumentClick),this._destroyContainerEl(this._elContainer),this)v.hasOwnProperty(this,t)&&(this[t]=null);m._nCurrentCount--,m._nCurrentCount<1&&m._elDynStyleNode&&(document.getElementsByTagName("head")[0].removeChild(m._elDynStyleNode),m._elDynStyleNode=null)},showTableMessage:function(e,t){var i=this._elMsgTd;v.isString(e)&&(i.firstChild.innerHTML=e),v.isString(t)&&(i.className=t),this._elMsgTbody.style.display="",this.fireEvent("tableMsgShowEvent",{html:e,className:t})},hideTableMessage:function(){"none"!=this._elMsgTbody.style.display&&(this._elMsgTbody.style.display="none",this._elMsgTbody.parentNode.style.width="",this.fireEvent("tableMsgHideEvent"))},focus:function(){this.focusTbodyEl()},focusTheadEl:function(){this._focusEl(this._elThead)},focusTbodyEl:function(){this._focusEl(this._elTbody)},onShow:function(){this.validateColumnWidths();for(var e,t=this._oColumnSet.keys,i=0,n=t.length;i<n;i++)(e=t[i])._ddResizer&&e._ddResizer.resetResizerEl()},getRecordIndex:function(e){var t;if(v.isNumber(e))t=e;else{if(e instanceof YAHOO.widget.Record)return this._oRecordSet.getRecordIndex(e);var e=this.getTrEl(e);e&&(t=e.sectionRowIndex)}return v.isNumber(t)?(e=this.get("paginator"))?e.get("recordOffset")+t:t:null},getRecord:function(e){var t=this._oRecordSet.getRecord(e);return t||(e=this.getTrEl(e))&&(t=this._oRecordSet.getRecord(e.id)),t instanceof YAHOO.widget.Record?this._oRecordSet.getRecord(t):null},getColumn:function(e){var t=this._oColumnSet.getColumn(e);if(!t){var i=this.getTdEl(e);if(i)t=this._oColumnSet.getColumn(this.getCellIndex(i));else if(i=this.getThEl(e))for(var n=this._oColumnSet.flat,l=0,o=n.length;l<o;l++)n[l].getThEl().id===i.id&&(t=n[l])}return t},getColumnById:function(e){return this._oColumnSet.getColumnById(e)},getColumnSortDir:function(e,t){e.sortOptions&&e.sortOptions.defaultDir&&("asc"==e.sortOptions.defaultDir?e.sortOptions.defaultDir=m.CLASS_ASC:"desc"==e.sortOptions.defaultDir&&(e.sortOptions.defaultDir=m.CLASS_DESC));var i=e.sortOptions&&e.sortOptions.defaultDir?e.sortOptions.defaultDir:m.CLASS_ASC;return i=(t=t||this.get("sortedBy"))&&t.key===e.key?t.dir?t.dir===m.CLASS_ASC?m.CLASS_DESC:m.CLASS_ASC:i===m.CLASS_ASC?m.CLASS_DESC:m.CLASS_ASC:i},doBeforeSortColumn:function(e,t){return this.showTableMessage(this.get("MSG_LOADING"),m.CLASS_LOADING),!0},sortColumn:function(e,t){var i,n,l,o;e&&e instanceof YAHOO.widget.Column&&(e.sortable||c.addClass(this.getThEl(e),m.CLASS_SORTABLE),i=(t=t&&t!==m.CLASS_ASC&&t!==m.CLASS_DESC?null:t)||this.getColumnSortDir(e),o=(this.get("sortedBy")||{}).key===e.key,this.doBeforeSortColumn(e,i))&&(this.get("dynamicData")?((l=this.getState()).pagination&&(l.pagination.recordOffset=0),l.sortedBy={key:e.key,dir:i},n=this.get("generateRequest")(l,this),this.unselectAllRows(),this.unselectAllCells(),l={success:this.onDataReturnSetRows,failure:this.onDataReturnSetRows,argument:l,scope:this},this._oDataSource.sendRequest(n,l)):(n=e.sortOptions&&v.isFunction(e.sortOptions.sortFunction)?e.sortOptions.sortFunction:null,!o||t||n?(n=n||this.get("sortFunction"),l=(e.sortOptions&&e.sortOptions.field?e.sortOptions:e).field,this._oRecordSet.sortRecords(n,i==m.CLASS_DESC,l)):this._oRecordSet.reverseRecords(),(o=this.get("paginator"))&&o.setPage(1,!0),this.render(),this.set("sortedBy",{key:e.key,dir:i,column:e})),this.fireEvent("columnSortEvent",{column:e,dir:i}))},setColumnWidth:function(e,t){(e=e instanceof YAHOO.widget.Column?e:this.getColumn(e))&&(v.isNumber(t)?(t=t>e.minWidth?t:e.minWidth,e.width=t,this._setColumnWidth(e,t+"px"),this.fireEvent("columnSetWidthEvent",{column:e,width:t})):null===t&&(e.width=t,this._setColumnWidth(e,"auto"),this.validateColumnWidths(e),this.fireEvent("columnUnsetWidthEvent",{column:e})),this._clearTrTemplateEl())},_setColumnWidth:function(e,t,i){e&&null!==e.getKeyIndex()&&(i=i||(""===t||"auto"===t?"visible":"hidden"),m._bDynStylesFallback?this._setColumnWidthDynFunction(e,t,i):this._setColumnWidthDynStyles(e,t,i))},_setColumnWidthDynStyles:function(e,t,i){var n,l,o=m._elDynStyleNode;o||((o=document.createElement("style")).type="text/css",o=document.getElementsByTagName("head").item(0).appendChild(o),m._elDynStyleNode=o),o&&(l="."+this.getId()+"-col-"+e.getSanitizedKey()+" ."+m.CLASS_LINER,this._elTbody&&(this._elTbody.style.display="none"),(n=m._oDynStyles[l])?(n.style.overflow=i,n.style.width=t):o.styleSheet&&o.styleSheet.addRule?(o.styleSheet.addRule(l,"overflow:"+i),o.styleSheet.addRule(l,"width:"+t),n=o.styleSheet.rules[o.styleSheet.rules.length-1],m._oDynStyles[l]=n):o.sheet&&o.sheet.insertRule&&(o.sheet.insertRule(l+" {overflow:"+i+";width:"+t+";}",o.sheet.cssRules.length),n=o.sheet.cssRules[o.sheet.cssRules.length-1],m._oDynStyles[l]=n),this._elTbody)&&(this._elTbody.style.display=""),n||(m._bDynStylesFallback=!0,this._setColumnWidthDynFunction(e,t))},_setColumnWidthDynFunction:function(e,t,i){"auto"==t&&(t="");var n=this._elTbody?this._elTbody.rows.length:0;if(!this._aDynFunctions[n]){for(var l,o=["var colIdx=oColumn.getKeyIndex();","oColumn.getThLinerEl().style.overflow="],s=n-1,r=2;0<=s;--s)o[r++]="this._elTbody.rows[",o[r++]=s,o[r++]="].cells[colIdx].firstChild.style.overflow=";for(o[r]="sOverflow;",o[r+1]="oColumn.getThLinerEl().style.width=",s=n-1,l=r+2;0<=s;--s)o[l++]="this._elTbody.rows[",o[l++]=s,o[l++]="].cells[colIdx].firstChild.style.width=";o[l]="sWidth;",this._aDynFunctions[n]=new Function("oColumn","sWidth","sOverflow",o.join(""))}n=this._aDynFunctions[n];n&&n.call(this,e,t,i)},validateColumnWidths:function(e){var t,i=this._elColgroup,n=i.cloneNode(!0),l=!1,o=this._oColumnSet.keys;if(!e||e.hidden||e.width||null===e.getKeyIndex())for(var s=0,r=o.length;s<r;s++)(e=o[s]).hidden||e.width||(t=e.getThLinerEl(),0<e.minWidth&&t.offsetWidth<e.minWidth?(n.childNodes[s].style.width=e.minWidth+(0|parseInt(c.getStyle(t,"paddingLeft"),10))+(0|parseInt(c.getStyle(t,"paddingRight"),10))+"px",l=!0):0<e.maxAutoWidth&&t.offsetWidth>e.maxAutoWidth&&this._setColumnWidth(e,e.maxAutoWidth+"px","hidden"));else t=e.getThLinerEl(),0<e.minWidth&&t.offsetWidth<e.minWidth?(n.childNodes[e.getKeyIndex()].style.width=e.minWidth+(0|parseInt(c.getStyle(t,"paddingLeft"),10))+(0|parseInt(c.getStyle(t,"paddingRight"),10))+"px",l=!0):0<e.maxAutoWidth&&t.offsetWidth>e.maxAutoWidth&&this._setColumnWidth(e,e.maxAutoWidth+"px","hidden");l&&(i.parentNode.replaceChild(n,i),this._elColgroup=n)},_clearMinWidth:function(e){null!==e.getKeyIndex()&&(this._elColgroup.childNodes[e.getKeyIndex()].style.width="")},_restoreMinWidth:function(e){e.minWidth&&null!==e.getKeyIndex()&&(this._elColgroup.childNodes[e.getKeyIndex()].style.width=e.minWidth+"px")},hideColumn:function(e){if((e=e instanceof YAHOO.widget.Column?e:this.getColumn(e))&&!e.hidden&&null!==e.getTreeIndex()){for(var t=this.getTbodyEl().rows,i=t.length,n=this._oColumnSet.getDescendants(e),l=0,o=n.length;l<o;l++){var s=n[l],r=(s.hidden=!0,c.addClass(s.getThEl(),m.CLASS_HIDDEN),s.getKeyIndex());if(null!==r){this._clearMinWidth(e);for(var a=0;a<i;a++)c.addClass(t[a].cells[r],m.CLASS_HIDDEN)}this.fireEvent("columnHideEvent",{column:s})}this._repaintOpera(),this._clearTrTemplateEl()}},showColumn:function(e){if((e=e instanceof YAHOO.widget.Column?e:this.getColumn(e))&&e.hidden&&null!==e.getTreeIndex()){for(var t=this.getTbodyEl().rows,i=t.length,n=this._oColumnSet.getDescendants(e),l=0,o=n.length;l<o;l++){var s=n[l],r=(s.hidden=!1,c.removeClass(s.getThEl(),m.CLASS_HIDDEN),s.getKeyIndex());if(null!==r){this._restoreMinWidth(e);for(var a=0;a<i;a++)c.removeClass(t[a].cells[r],m.CLASS_HIDDEN)}this.fireEvent("columnShowEvent",{column:s})}this._clearTrTemplateEl()}},removeColumn:function(e){if(e=e instanceof YAHOO.widget.Column?e:this.getColumn(e)){var t=e.getTreeIndex();if(null!==t){var i=e.getKeyIndex();if(null===i){for(var n=[],l=this._oColumnSet.getDescendants(e),o=0,s=l.length;o<s;o++){var r=l[o].getKeyIndex();null!==r&&(n[n.length]=r)}0<n.length&&(i=n)}else i=[i];if(null!==i){i.sort(function(e,t){return YAHOO.util.Sort.compare(e,t)}),this._destroyTheadEl();var a=this._oColumnSet.getDefinitions();for(e=a.splice(t,1)[0],this._initColumnSet(a),this._initTheadEl(),o=i.length-1;-1<o;o--)this._removeColgroupColEl(i[o]);var d,h=this._elTbody.rows;return 0<h.length&&(d=this.get("renderLoopSize"),t=h.length,this._oChainRender.add({method:function(e){if(this instanceof m&&this._sId){for(var t,i=e.nCurrentRow,n=0<d?Math.min(i+d,h.length):h.length,l=e.aIndexes;i<n;++i)for(t=l.length-1;-1<t;t--)h[i].removeChild(h[i].childNodes[l[t]]);e.nCurrentRow=i}},iterations:0<d?Math.ceil(t/d):1,argument:{nCurrentRow:0,aIndexes:i},scope:this,timeout:0<d?0:-1}),this._runRenderChain()),this.fireEvent("columnRemoveEvent",{column:e}),e}}}},insertColumn:function(e,t){if(e instanceof YAHOO.widget.Column)e=e.getDefinition();else if(e.constructor!==Object)return;var i=this._oColumnSet,n=(v.isValue(t)&&v.isNumber(t)||(t=i.tree[0].length),this._destroyTheadEl(),this._oColumnSet.getDefinitions()),n=(n.splice(t,0,e),this._initColumnSet(n),this._initTheadEl(),(i=this._oColumnSet).tree[0][t]),l=[],o=i.getDescendants(n);for(c=0,u=o.length;c<u;c++){var s=o[c].getKeyIndex();null!==s&&(l[l.length]=s)}if(0<l.length){var r=l.sort(function(e,t){return YAHOO.util.Sort.compare(e,t)})[0];for(c=l.length-1;-1<c;c--)this._insertColgroupColEl(l[c]);var a=this._elTbody.rows;if(0<a.length){for(var d=this.get("renderLoopSize"),i=a.length,h=[],c=0,u=l.length;c<u;c++){var g=l[c],f=this._getTrTemplateEl().childNodes[c].cloneNode(!0);f=this._formatTdEl(this._oColumnSet.keys[g],f,g,g===this._oColumnSet.keys.length-1),h[g]=f}this._oChainRender.add({method:function(e){if(this instanceof m&&this._sId){for(var t,i,n=e.nCurrentRow,l=e.descKeyIndexes,o=0<d?Math.min(n+d,a.length):a.length;n<o;++n)for(i=a[n].childNodes[r]||null,t=l.length-1;-1<t;t--)a[n].insertBefore(e.aTdTemplates[l[t]].cloneNode(!0),i);e.nCurrentRow=n}},iterations:0<d?Math.ceil(i/d):1,argument:{nCurrentRow:0,aTdTemplates:h,descKeyIndexes:l},scope:this,timeout:0<d?0:-1}),this._runRenderChain()}return this.fireEvent("columnInsertEvent",{column:e,index:t}),n}},reorderColumn:function(e,t){if((e=e instanceof YAHOO.widget.Column?e:this.getColumn(e))&&YAHOO.lang.isNumber(t)){var i=e.getTreeIndex();if(null!==i&&i!==t){var n,l,o,s,r=e.getKeyIndex(),a=[];if(null===r){for(n=0,l=(o=this._oColumnSet.getDescendants(e)).length;n<l;n++)null!==(s=o[n].getKeyIndex())&&(a[a.length]=s);0<a.length&&(r=a)}else r=[r];if(null!==r){r.sort(function(e,t){return YAHOO.util.Sort.compare(e,t)}),this._destroyTheadEl();var e=this._oColumnSet.getDefinitions(),d=e.splice(i,1)[0],d=(e.splice(t,0,d),this._initColumnSet(e),this._initTheadEl(),this._oColumnSet.tree[0][t]),e=d.getKeyIndex();if(null===e){for(a=[],n=0,l=(o=this._oColumnSet.getDescendants(d)).length;n<l;n++)null!==(s=o[n].getKeyIndex())&&(a[a.length]=s);0<a.length&&(e=a)}else e=[e];var h,c=e.sort(function(e,t){return YAHOO.util.Sort.compare(e,t)})[0],u=(this._reorderColgroupColEl(r,c),this._elTbody.rows);return 0<u.length&&(h=this.get("renderLoopSize"),t=u.length,this._oChainRender.add({method:function(e){if(this instanceof m&&this._sId){for(var t,i,n,l,o=e.nCurrentRow,s=0<h?Math.min(o+h,u.length):u.length,r=e.aIndexes;o<s;++o){for(i=[],l=u[o],t=r.length-1;-1<t;t--)i.push(l.removeChild(l.childNodes[r[t]]));for(n=l.childNodes[c]||null,t=i.length-1;-1<t;t--)l.insertBefore(i[t],n)}e.nCurrentRow=o}},iterations:0<h?Math.ceil(t/h):1,argument:{nCurrentRow:0,aIndexes:r},scope:this,timeout:0<h?0:-1}),this._runRenderChain()),this.fireEvent("columnReorderEvent",{column:d,oldIndex:i}),d}}}},selectColumn:function(e){var t,i;(e=this.getColumn(e))&&!e.selected&&null!==e.getKeyIndex()&&(e.selected=!0,t=e.getThEl(),c.addClass(t,m.CLASS_SELECTED),i=this.getTbodyEl().rows,this._oChainRender.add({method:function(e){this instanceof m&&this._sId&&i[e.rowIndex]&&i[e.rowIndex].cells[e.cellIndex]&&c.addClass(i[e.rowIndex].cells[e.cellIndex],m.CLASS_SELECTED),e.rowIndex++},scope:this,iterations:i.length,argument:{rowIndex:0,cellIndex:e.getKeyIndex()}}),this._clearTrTemplateEl(),this._elTbody.style.display="none",this._runRenderChain(),this._elTbody.style.display="",this.fireEvent("columnSelectEvent",{column:e}))},unselectColumn:function(e){var t,i;(e=this.getColumn(e))&&e.selected&&null!==e.getKeyIndex()&&(e.selected=!1,t=e.getThEl(),c.removeClass(t,m.CLASS_SELECTED),i=this.getTbodyEl().rows,this._oChainRender.add({method:function(e){this instanceof m&&this._sId&&i[e.rowIndex]&&i[e.rowIndex].cells[e.cellIndex]&&c.removeClass(i[e.rowIndex].cells[e.cellIndex],m.CLASS_SELECTED),e.rowIndex++},scope:this,iterations:i.length,argument:{rowIndex:0,cellIndex:e.getKeyIndex()}}),this._clearTrTemplateEl(),this._elTbody.style.display="none",this._runRenderChain(),this._elTbody.style.display="",this.fireEvent("columnUnselectEvent",{column:e}))},getSelectedColumns:function(e){for(var t=[],i=this._oColumnSet.keys,n=0,l=i.length;n<l;n++)i[n].selected&&(t[t.length]=i[n]);return t},highlightColumn:function(e){var t,i,e=this.getColumn(e);e&&null!==e.getKeyIndex()&&(t=e.getThEl(),c.addClass(t,m.CLASS_HIGHLIGHTED),i=this.getTbodyEl().rows,this._oChainRender.add({method:function(e){this instanceof m&&this._sId&&i[e.rowIndex]&&i[e.rowIndex].cells[e.cellIndex]&&c.addClass(i[e.rowIndex].cells[e.cellIndex],m.CLASS_HIGHLIGHTED),e.rowIndex++},scope:this,iterations:i.length,argument:{rowIndex:0,cellIndex:e.getKeyIndex()},timeout:-1}),this._elTbody.style.display="none",this._runRenderChain(),this._elTbody.style.display="",this.fireEvent("columnHighlightEvent",{column:e}))},unhighlightColumn:function(e){var t,i,e=this.getColumn(e);e&&null!==e.getKeyIndex()&&(t=e.getThEl(),c.removeClass(t,m.CLASS_HIGHLIGHTED),i=this.getTbodyEl().rows,this._oChainRender.add({method:function(e){this instanceof m&&this._sId&&i[e.rowIndex]&&i[e.rowIndex].cells[e.cellIndex]&&c.removeClass(i[e.rowIndex].cells[e.cellIndex],m.CLASS_HIGHLIGHTED),e.rowIndex++},scope:this,iterations:i.length,argument:{rowIndex:0,cellIndex:e.getKeyIndex()},timeout:-1}),this._elTbody.style.display="none",this._runRenderChain(),this._elTbody.style.display="",this.fireEvent("columnUnhighlightEvent",{column:e}))},addRow:function(e,t){var i;v.isNumber(t)&&(t<0||t>this._oRecordSet.getLength())||e&&v.isObject(e)&&(e=this._oRecordSet.addRecord(e,t))&&((t=this.get("paginator"))?((i=t.get("totalRecords"))!==g.Paginator.VALUE_UNLIMITED&&t.set("totalRecords",i+1),(i=this.getRecordIndex(e))<=t.getPageRecords()[1]&&this.render(),this.fireEvent("rowAddEvent",{record:e})):(i=this.getRecordIndex(e),v.isNumber(i)&&(this._oChainRender.add({method:function(e){var t,i,n;this instanceof m&&this._sId&&(t=e.record,e=e.recIndex,i=this._addTrEl(t))&&(n=this._elTbody.rows[e]||null,this._elTbody.insertBefore(i,n),0===e&&this._setFirstRow(),null===n&&this._setLastRow(),this._setRowStripes(),this.hideTableMessage(),this.fireEvent("rowAddEvent",{record:t}))},argument:{record:e,recIndex:i},scope:this,timeout:0<this.get("renderLoopSize")?0:-1}),this._runRenderChain())))},addRows:function(e,t){var i,n,r,a,l;v.isNumber(t)&&(t<0||t>this._oRecordSet.getLength())||v.isArray(e)&&(i=this._oRecordSet.addRecords(e,t))&&(t=this.getRecordIndex(i[0]),(n=this.get("paginator"))?((l=n.get("totalRecords"))!==g.Paginator.VALUE_UNLIMITED&&n.set("totalRecords",l+i.length),t<=n.getPageRecords()[1]&&this.render(),this.fireEvent("rowsAddEvent",{records:i})):(r=this.get("renderLoopSize"),a=t+e.length,l=t>=this._elTbody.rows.length,this._oChainRender.add({method:function(e){if(this instanceof m&&this._sId){for(var t=e.aRecords,i=e.nCurrentRow,n=e.nCurrentRecord,l=0<r?Math.min(i+r,a):a,o=document.createDocumentFragment(),s=this._elTbody.rows[i]||null;i<l;i++,n++)o.appendChild(this._addTrEl(t[n]));this._elTbody.insertBefore(o,s),e.nCurrentRow=i,e.nCurrentRecord=n}},iterations:0<r?Math.ceil(a/r):1,argument:{nCurrentRow:t,nCurrentRecord:0,aRecords:i},scope:this,timeout:0<r?0:-1}),this._oChainRender.add({method:function(e){0===e.recIndex&&this._setFirstRow(),e.isLast&&this._setLastRow(),this._setRowStripes(),this.fireEvent("rowsAddEvent",{records:i})},argument:{recIndex:t,isLast:l},scope:this,timeout:-1}),this._runRenderChain(),this.hideTableMessage()))},updateRow:function(e,t){var i=e;if(v.isNumber(i)||(i=this.getRecordIndex(e)),v.isNumber(i)&&0<=i){e=this._oRecordSet.getRecord(i);if(e){var n=this._oRecordSet.setRecord(t,i),l=this.getTrEl(e),o=e?e.getData():null;if(n){for(var s=this._aSelections||[],r=0,a=e.getId(),d=n.getId();r<s.length;r++)s[r]===a?s[r]=d:s[r].recordId===a&&(s[r].recordId=d);return this._oAnchorRecord&&this._oAnchorRecord.getId()===a&&(this._oAnchorRecord=n),this._oAnchorCell&&this._oAnchorCell.record.getId()===a&&(this._oAnchorCell.record=n),this._oChainRender.add({method:function(){var e,t;this instanceof m&&this._sId&&((t=this.get("paginator"))?(e=t.getPageRecords()[0],t=t.getPageRecords()[1],(e<=i||i<=t)&&this.render()):l?this._updateTrEl(l,n):this.getTbodyEl().appendChild(this._addTrEl(n)),this.fireEvent("rowUpdateEvent",{record:n,oldData:o}))},scope:this,timeout:0<this.get("renderLoopSize")?0:-1}),void this._runRenderChain()}}}},updateRows:function(e,t){if(v.isArray(t)){var o=e,i=this._oRecordSet,s=i.getLength();if(v.isNumber(e)||(o=this.getRecordIndex(e)),v.isNumber(o)&&0<=o&&o<i.getLength()){var e=o+t.length,n=i.getRecords(o,t.length),l=i.setRecords(t,o);if(l){for(var r,a,d,h,c=this._aSelections||[],u=0,g=this._oAnchorRecord?this._oAnchorRecord.getId():null,f=this._oAnchorCell?this._oAnchorCell.record.getId():null;u<n.length;u++){for(h=n[u].getId(),d=(a=l[u]).getId(),r=0;r<c.length;r++)c[r]===h?c[r]=d:c[r].recordId===h&&(c[r].recordId=d);g&&g===h&&(this._oAnchorRecord=a),f&&f===h&&(this._oAnchorCell.record=a)}var _,C,E,i=this.get("paginator");i?(C=i.getPageRecords()[0],i=i.getPageRecords()[1],(C<=o||e<=i)&&this.render(),this.fireEvent("rowsAddEvent",{newRecords:l,oldRecords:n})):(_=this.get("renderLoopSize"),C=t.length,i=s<=e,E=s<e,this._oChainRender.add({method:function(e){if(this instanceof m&&this._sId){for(var t=e.aRecords,i=e.nCurrentRow,n=e.nDataPointer,l=0<_?Math.min(i+_,o+t.length):o+t.length;i<l;i++,n++)E&&s<=i?this._elTbody.appendChild(this._addTrEl(t[n])):this._updateTrEl(this._elTbody.rows[i],t[n]);e.nCurrentRow=i,e.nDataPointer=n}},iterations:0<_?Math.ceil(C/_):1,argument:{nCurrentRow:o,aRecords:l,nDataPointer:0,isAdding:E},scope:this,timeout:0<_?0:-1}),this._oChainRender.add({method:function(e){0===e.recIndex&&this._setFirstRow(),e.isLast&&this._setLastRow(),this._setRowStripes(),this.fireEvent("rowsAddEvent",{newRecords:l,oldRecords:n})},argument:{recIndex:o,isLast:i},scope:this,timeout:-1}),this._runRenderChain(),this.hideTableMessage())}}}},deleteRow:function(e){var t=v.isNumber(e)?e:this.getRecordIndex(e);if(v.isNumber(t)){e=this.getRecord(t);if(e){for(var i=this.getTrIndex(t),n=e.getId(),l=this._aSelections||[],o=l.length-1;-1<o;o--)(v.isString(l[o])&&l[o]===n||v.isObject(l[o])&&l[o].recordId===n)&&l.splice(o,1);var s=this._oRecordSet.deleteRecord(t);if(s){e=this.get("paginator");if(e){var r=e.get("totalRecords"),a=e.getPageRecords();r!==g.Paginator.VALUE_UNLIMITED&&e.set("totalRecords",r-1),(!a||t<=a[1])&&this.render(),this._oChainRender.add({method:function(){this instanceof m&&this._sId&&this.fireEvent("rowDeleteEvent",{recordIndex:t,oldData:s,trElIndex:i})},scope:this,timeout:0<this.get("renderLoopSize")?0:-1}),this._runRenderChain()}else if(v.isNumber(i))return this._oChainRender.add({method:function(){var e;this instanceof m&&this._sId&&(e=t===this._oRecordSet.getLength(),this._deleteTrEl(i),0<this._elTbody.rows.length&&(0===i&&this._setFirstRow(),e&&this._setLastRow(),i!=this._elTbody.rows.length)&&this._setRowStripes(i),this.fireEvent("rowDeleteEvent",{recordIndex:t,oldData:s,trElIndex:i}))},scope:this,timeout:0<this.get("renderLoopSize")?0:-1}),void this._runRenderChain()}}}return null},deleteRows:function(e,t){e=v.isNumber(e)?e:this.getRecordIndex(e);if(v.isNumber(e)){var i=this.getRecord(e);if(i){for(var n=this.getTrIndex(e),l=i.getId(),o=this._aSelections||[],s=o.length-1;-1<s;s--)(v.isString(o[s])&&o[s]===l||v.isObject(o[s])&&o[s].recordId===l)&&o.splice(s,1);var i=e,r=e,a=(t&&v.isNumber(t)?(i=0<t?e+t-1:e,r=0<t?e:e+t+1,t=0<t?t:-1*t,r<0&&(t=i-(r=0)+1)):t=1,this._oRecordSet.deleteRecords(r,t));if(a){var d,h,c,e=this.get("paginator"),u=this.get("renderLoopSize");if(e)return d=e.get("totalRecords"),h=e.getPageRecords(),d!==g.Paginator.VALUE_UNLIMITED&&e.set("totalRecords",d-a.length),(!h||r<=h[1])&&this.render(),this._oChainRender.add({method:function(e){this instanceof m&&this._sId&&this.fireEvent("rowsDeleteEvent",{recordIndex:r,oldData:a,count:t})},scope:this,timeout:0<u?0:-1}),void this._runRenderChain();if(v.isNumber(n))return c=r,this._oChainRender.add({method:function(e){if(this instanceof m&&this._sId){for(var t=e.nCurrentRow,i=0<u?Math.max(t-u,c)-1:c-1;i<t;--t)this._deleteTrEl(t);e.nCurrentRow=t}},iterations:0<u?Math.ceil(t/u):1,argument:{nCurrentRow:i},scope:this,timeout:0<u?0:-1}),this._oChainRender.add({method:function(){0<this._elTbody.rows.length&&(this._setFirstRow(),this._setLastRow(),this._setRowStripes()),this.fireEvent("rowsDeleteEvent",{recordIndex:r,oldData:a,count:t})},scope:this,timeout:-1}),void this._runRenderChain()}}}return null},formatCell:function(e,t,i){var n,l;t=t||this.getRecord(e),i=i||this.getColumn(this.getCellIndex(e.parentNode)),t&&i&&(n=i.field,n=t.getData(n),(l="function"==typeof i.formatter?i.formatter:m.Formatter[i.formatter+""]||m.Formatter.defaultFormatter)?l.call(this,e,t,i,n):e.innerHTML=n,this.fireEvent("cellFormatEvent",{record:t,column:i,key:i.key,el:e}))},updateCell:function(e,t,i,n){var l,o,s;(t=t instanceof YAHOO.widget.Column?t:this.getColumn(t))&&t.getField()&&e instanceof YAHOO.widget.Record&&(l=t.getField(),o=e.getData(l),this._oRecordSet.updateRecordValue(e,l,i),(s=this.getTdEl({record:e,column:t}))?(this._oChainRender.add({method:function(){this instanceof m&&this._sId&&(this.formatCell(s.firstChild,e,t),this.fireEvent("cellUpdateEvent",{record:e,column:t,oldData:o}))},scope:this,timeout:0<this.get("renderLoopSize")?0:-1}),n||this._runRenderChain()):this.fireEvent("cellUpdateEvent",{record:e,column:t,oldData:o}))},_updatePaginator:function(e){var t=this.get("paginator");t&&e!==t&&t.unsubscribe("changeRequest",this.onPaginatorChangeRequest,this,!0),e&&e.subscribe("changeRequest",this.onPaginatorChangeRequest,this,!0)},_handlePaginatorChange:function(e){if(e.prevValue!==e.newValue){var t=e.newValue,e=e.prevValue,i=this._defaultPaginatorContainers();if(e&&(e.getContainerNodes()[0]==i[0]&&e.set("containers",[]),e.destroy(),i[0]))if(t&&!t.getContainerNodes().length)t.set("containers",i);else for(var n=i.length-1;0<=n;--n)i[n]&&i[n].parentNode.removeChild(i[n]);this._bInit||this.render(),t&&this.renderPaginator()}},_defaultPaginatorContainers:function(e){var t=this._sId+"-paginator0",i=this._sId+"-paginator1",n=c.get(t),l=c.get(i);return!e||n&&l||(n||((n=document.createElement("div")).id=t,c.addClass(n,m.CLASS_PAGINATOR),this._elContainer.insertBefore(n,this._elContainer.firstChild)),l)||((l=document.createElement("div")).id=i,c.addClass(l,m.CLASS_PAGINATOR),this._elContainer.appendChild(l)),[n,l]},_destroyPaginator:function(){var e=this.get("paginator");e&&e.destroy()},renderPaginator:function(){var e=this.get("paginator");e&&(e.getContainerNodes().length||e.set("containers",this._defaultPaginatorContainers(!0)),e.render())},doBeforePaginatorChange:function(e){return this.showTableMessage(this.get("MSG_LOADING"),m.CLASS_LOADING),!0},onPaginatorChangeRequest:function(e){var t,i;this.doBeforePaginatorChange(e)&&(this.get("dynamicData")?((i=this.getState()).pagination=e,t=this.get("generateRequest")(i,this),this.unselectAllRows(),this.unselectAllCells(),i={success:this.onDataReturnSetRows,failure:this.onDataReturnSetRows,argument:i,scope:this},this._oDataSource.sendRequest(t,i)):(e.paginator.setStartIndex(e.recordOffset,!0),e.paginator.setRowsPerPage(e.rowsPerPage,!0),this.render()))},_elLastHighlightedTd:null,_aSelections:null,_oAnchorRecord:null,_oAnchorCell:null,_unselectAllTrEls:function(){var e=c.getElementsByClassName(m.CLASS_SELECTED,"tr",this._elTbody);c.removeClass(e,m.CLASS_SELECTED)},_getSelectionTrigger:function(){var e,t,i,n,l=this.get("selectionMode"),o={};return"cellblock"==l||"cellrange"==l||"singlecell"==l?!(l=this.getLastSelectedCell())||(e=this.getRecord(l.recordId),t=this.getRecordIndex(e),i=this.getTrEl(e),null===(n=this.getTrIndex(i)))?null:(o.record=e,o.recordIndex=t,o.el=this.getTdEl(l),o.trIndex=n,o.column=this.getColumn(l.columnKey),o.colKeyIndex=o.column.getKeyIndex(),o.cell=l,o):!(e=this.getLastSelectedRecord())||(e=this.getRecord(e),t=this.getRecordIndex(e),i=this.getTrEl(e),null===(n=this.getTrIndex(i)))?null:(o.record=e,o.recordIndex=t,o.el=i,o.trIndex=n,o)},_getSelectionAnchor:function(e){var t,i,n,l=this.get("selectionMode"),o={};if("cellblock"==l||"cellrange"==l||"singlecell"==l){l=this._oAnchorCell;if(!l){if(!e)return null;l=this._oAnchorCell=e.cell}t=this._oAnchorCell.record,i=this._oRecordSet.getRecordIndex(t),null===(n=this.getTrIndex(t))&&(n=i<this.getRecordIndex(this.getFirstTrEl())?0:this.getRecordIndex(this.getLastTrEl())),o.record=t,o.recordIndex=i,o.trIndex=n,o.column=this._oAnchorCell.column,o.colKeyIndex=o.column.getKeyIndex(),o.cell=l}else{if(!(t=this._oAnchorRecord)){if(!e)return null;t=this._oAnchorRecord=e.record}i=this.getRecordIndex(t),null===(n=this.getTrIndex(t))&&(n=i<this.getRecordIndex(this.getFirstTrEl())?0:this.getRecordIndex(this.getLastTrEl())),o.record=t,o.recordIndex=i,o.trIndex=n}return o},_handleStandardSelectionByMouse:function(e){var t=e.target,t=this.getTrEl(t);if(t){var i,n=e.event,l=n.shiftKey,n=n.ctrlKey||-1!=navigator.userAgent.toLowerCase().indexOf("mac")&&n.metaKey,t=this.getRecord(t),o=this._oRecordSet.getRecordIndex(t),s=this._getSelectionAnchor();if(l&&n)if(s)if(this.isSelected(s.record))if(s.recordIndex<o)for(i=s.recordIndex+1;i<=o;i++)this.isSelected(i)||this.selectRow(i);else for(i=s.recordIndex-1;o<=i;i--)this.isSelected(i)||this.selectRow(i);else{if(s.recordIndex<o)for(i=s.recordIndex+1;i<=o-1;i++)this.isSelected(i)&&this.unselectRow(i);else for(i=o+1;i<=s.recordIndex-1;i++)this.isSelected(i)&&this.unselectRow(i);this.selectRow(t)}else this._oAnchorRecord=t,this.isSelected(t)?this.unselectRow(t):this.selectRow(t);else if(l)if(this.unselectAllRows(),s)if(s.recordIndex<o)for(i=s.recordIndex;i<=o;i++)this.selectRow(i);else for(i=s.recordIndex;o<=i;i--)this.selectRow(i);else this._oAnchorRecord=t,this.selectRow(t);else n?(this._oAnchorRecord=t,this.isSelected(t)?this.unselectRow(t):this.selectRow(t)):this._handleSingleSelectionByMouse(e)}},_handleStandardSelectionByKey:function(e){var t=u.getCharCode(e);if(38==t||40==t){var i=e.shiftKey,n=this._getSelectionTrigger();if(!n)return null;u.stopEvent(e);var l=this._getSelectionAnchor(n);i?40==t&&l.recordIndex<=n.trIndex?this.selectRow(this.getNextTrEl(n.el)):38==t&&l.recordIndex>=n.trIndex?this.selectRow(this.getPreviousTrEl(n.el)):this.unselectRow(n.el):this._handleSingleSelectionByKey(e)}},_handleSingleSelectionByMouse:function(e){var e=e.target,e=this.getTrEl(e);e&&(e=this.getRecord(e),this._oAnchorRecord=e,this.unselectAllRows(),this.selectRow(e))},_handleSingleSelectionByKey:function(e){var t=u.getCharCode(e);if(38==t||40==t){var i,n=this._getSelectionTrigger();if(!n)return null;u.stopEvent(e),38==t?null===(i=this.getPreviousTrEl(n.el))&&(i=this.getFirstTrEl()):40==t&&null===(i=this.getNextTrEl(n.el))&&(i=this.getLastTrEl()),this.unselectAllRows(),this.selectRow(i),this._oAnchorRecord=this.getRecord(i)}},_handleCellBlockSelectionByMouse:function(e){var t=e.target,t=this.getTdEl(t);if(t){var i,n,l,o,s,r=e.event,a=r.shiftKey,r=r.ctrlKey||-1!=navigator.userAgent.toLowerCase().indexOf("mac")&&r.metaKey,d=this.getTrEl(t),h=this.getTrIndex(d),c=this.getColumn(t),u=c.getKeyIndex(),g=this.getRecord(d),f=this._oRecordSet.getRecordIndex(g),g={record:g,column:c},_=this._getSelectionAnchor(),C=this.getTbodyEl().rows;if(a&&r)if(_)if(this.isSelected(_.cell))if(_.recordIndex===f){if(_.colKeyIndex<u)for(o=_.colKeyIndex+1;o<=u;o++)this.selectCell(d.cells[o]);else if(u<_.colKeyIndex)for(o=u;o<_.colKeyIndex;o++)this.selectCell(d.cells[o])}else if(_.recordIndex<f)for(i=Math.min(_.colKeyIndex,u),n=Math.max(_.colKeyIndex,u),o=_.trIndex;o<=h;o++)for(s=i;s<=n;s++)this.selectCell(C[o].cells[s]);else for(i=Math.min(_.trIndex,u),n=Math.max(_.trIndex,u),o=_.trIndex;h<=o;o--)for(s=n;i<=s;s--)this.selectCell(C[o].cells[s]);else{if(_.recordIndex===f)if(_.colKeyIndex<u)for(o=_.colKeyIndex+1;o<u;o++)this.unselectCell(d.cells[o]);else if(u<_.colKeyIndex)for(o=u+1;o<_.colKeyIndex;o++)this.unselectCell(d.cells[o]);if(_.recordIndex<f)for(o=_.trIndex;o<=h;o++)for(l=C[o],s=0;s<l.cells.length;s++)l.sectionRowIndex===_.trIndex?s>_.colKeyIndex&&this.unselectCell(l.cells[s]):(l.sectionRowIndex!==h||s<u)&&this.unselectCell(l.cells[s]);else for(o=h;o<=_.trIndex;o++)for(l=C[o],s=0;s<l.cells.length;s++)l.sectionRowIndex==h?u<s&&this.unselectCell(l.cells[s]):(l.sectionRowIndex!=_.trIndex||s<_.colKeyIndex)&&this.unselectCell(l.cells[s]);this.selectCell(t)}else this._oAnchorCell=g,this.isSelected(g)?this.unselectCell(g):this.selectCell(g);else if(a)if(this.unselectAllCells(),_)if(_.recordIndex===f){if(_.colKeyIndex<u)for(o=_.colKeyIndex;o<=u;o++)this.selectCell(d.cells[o]);else if(u<_.colKeyIndex)for(o=u;o<=_.colKeyIndex;o++)this.selectCell(d.cells[o])}else if(_.recordIndex<f)for(i=Math.min(_.colKeyIndex,u),n=Math.max(_.colKeyIndex,u),o=_.trIndex;o<=h;o++)for(s=i;s<=n;s++)this.selectCell(C[o].cells[s]);else for(i=Math.min(_.colKeyIndex,u),n=Math.max(_.colKeyIndex,u),o=h;o<=_.trIndex;o++)for(s=i;s<=n;s++)this.selectCell(C[o].cells[s]);else this._oAnchorCell=g,this.selectCell(g);else r?(this._oAnchorCell=g,this.isSelected(g)?this.unselectCell(g):this.selectCell(g)):this._handleSingleCellSelectionByMouse(e)}},_handleCellBlockSelectionByKey:function(e){var t=u.getCharCode(e),i=e.shiftKey;if(9!=t&&i){if(36<t&&t<41){var n=this._getSelectionTrigger();if(!n)return null;u.stopEvent(e);var l,o,s,r,a,i=this._getSelectionAnchor(n),d=this.getTbodyEl().rows,h=n.el.parentNode;if(40==t)if(i.recordIndex<=n.recordIndex){if(a=this.getNextTrEl(n.el))if(o=i.colKeyIndex,(s=n.colKeyIndex)<o)for(l=o;s<=l;l--)r=a.cells[l],this.selectCell(r);else for(l=o;l<=s;l++)r=a.cells[l],this.selectCell(r)}else for(o=Math.min(i.colKeyIndex,n.colKeyIndex),s=Math.max(i.colKeyIndex,n.colKeyIndex),l=o;l<=s;l++)this.unselectCell(h.cells[l]);else if(38==t)if(i.recordIndex>=n.recordIndex){if(a=this.getPreviousTrEl(n.el))if(o=i.colKeyIndex,(s=n.colKeyIndex)<o)for(l=o;s<=l;l--)r=a.cells[l],this.selectCell(r);else for(l=o;l<=s;l++)r=a.cells[l],this.selectCell(r)}else for(o=Math.min(i.colKeyIndex,n.colKeyIndex),s=Math.max(i.colKeyIndex,n.colKeyIndex),l=o;l<=s;l++)this.unselectCell(h.cells[l]);else if(39==t)if(i.colKeyIndex<=n.colKeyIndex){if(n.colKeyIndex<h.cells.length-1)if(o=i.trIndex,(s=n.trIndex)<o)for(l=o;s<=l;l--)r=d[l].cells[n.colKeyIndex+1],this.selectCell(r);else for(l=o;l<=s;l++)r=d[l].cells[n.colKeyIndex+1],this.selectCell(r)}else for(o=Math.min(i.trIndex,n.trIndex),s=Math.max(i.trIndex,n.trIndex),l=o;l<=s;l++)this.unselectCell(d[l].cells[n.colKeyIndex]);else if(37==t)if(i.colKeyIndex>=n.colKeyIndex){if(0<n.colKeyIndex)if(o=i.trIndex,(s=n.trIndex)<o)for(l=o;s<=l;l--)r=d[l].cells[n.colKeyIndex-1],this.selectCell(r);else for(l=o;l<=s;l++)r=d[l].cells[n.colKeyIndex-1],this.selectCell(r)}else for(o=Math.min(i.trIndex,n.trIndex),s=Math.max(i.trIndex,n.trIndex),l=o;l<=s;l++)this.unselectCell(d[l].cells[n.colKeyIndex])}}else this._handleSingleCellSelectionByKey(e)},_handleCellRangeSelectionByMouse:function(e){var t=e.target,t=this.getTdEl(t);if(t){var i,n,l,o=e.event,s=o.shiftKey,o=o.ctrlKey||-1!=navigator.userAgent.toLowerCase().indexOf("mac")&&o.metaKey,r=this.getTrEl(t),a=this.getTrIndex(r),d=this.getColumn(t),h=d.getKeyIndex(),c=this.getRecord(r),u=this._oRecordSet.getRecordIndex(c),c={record:c,column:d},g=this._getSelectionAnchor(),f=this.getTbodyEl().rows;if(s&&o)if(g)if(this.isSelected(g.cell))if(g.recordIndex===u){if(g.colKeyIndex<h)for(n=g.colKeyIndex+1;n<=h;n++)this.selectCell(r.cells[n]);else if(h<g.colKeyIndex)for(n=h;n<g.colKeyIndex;n++)this.selectCell(r.cells[n])}else if(g.recordIndex<u){for(n=g.colKeyIndex+1;n<r.cells.length;n++)this.selectCell(r.cells[n]);for(n=g.trIndex+1;n<a;n++)for(l=0;l<f[n].cells.length;l++)this.selectCell(f[n].cells[l]);for(n=0;n<=h;n++)this.selectCell(r.cells[n])}else{for(n=h;n<r.cells.length;n++)this.selectCell(r.cells[n]);for(n=a+1;n<g.trIndex;n++)for(l=0;l<f[n].cells.length;l++)this.selectCell(f[n].cells[l]);for(n=0;n<g.colKeyIndex;n++)this.selectCell(r.cells[n])}else{if(g.recordIndex===u)if(g.colKeyIndex<h)for(n=g.colKeyIndex+1;n<h;n++)this.unselectCell(r.cells[n]);else if(h<g.colKeyIndex)for(n=h+1;n<g.colKeyIndex;n++)this.unselectCell(r.cells[n]);if(g.recordIndex<u)for(n=g.trIndex;n<=a;n++)for(i=f[n],l=0;l<i.cells.length;l++)i.sectionRowIndex===g.trIndex?l>g.colKeyIndex&&this.unselectCell(i.cells[l]):(i.sectionRowIndex!==a||l<h)&&this.unselectCell(i.cells[l]);else for(n=a;n<=g.trIndex;n++)for(i=f[n],l=0;l<i.cells.length;l++)i.sectionRowIndex==a?h<l&&this.unselectCell(i.cells[l]):(i.sectionRowIndex!=g.trIndex||l<g.colKeyIndex)&&this.unselectCell(i.cells[l]);this.selectCell(t)}else this._oAnchorCell=c,this.isSelected(c)?this.unselectCell(c):this.selectCell(c);else if(s)if(this.unselectAllCells(),g)if(g.recordIndex===u){if(g.colKeyIndex<h)for(n=g.colKeyIndex;n<=h;n++)this.selectCell(r.cells[n]);else if(h<g.colKeyIndex)for(n=h;n<=g.colKeyIndex;n++)this.selectCell(r.cells[n])}else if(g.recordIndex<u)for(n=g.trIndex;n<=a;n++)for(i=f[n],l=0;l<i.cells.length;l++)i.sectionRowIndex==g.trIndex?l>=g.colKeyIndex&&this.selectCell(i.cells[l]):(i.sectionRowIndex!=a||l<=h)&&this.selectCell(i.cells[l]);else for(n=a;n<=g.trIndex;n++)for(i=f[n],l=0;l<i.cells.length;l++)i.sectionRowIndex==a?h<=l&&this.selectCell(i.cells[l]):(i.sectionRowIndex!=g.trIndex||l<=g.colKeyIndex)&&this.selectCell(i.cells[l]);else this._oAnchorCell=c,this.selectCell(c);else o?(this._oAnchorCell=c,this.isSelected(c)?this.unselectCell(c):this.selectCell(c)):this._handleSingleCellSelectionByMouse(e)}},_handleCellRangeSelectionByKey:function(e){var t=u.getCharCode(e),i=e.shiftKey;if(9!=t&&i){if(36<t&&t<41){var n=this._getSelectionTrigger();if(!n)return null;u.stopEvent(e);var l,o,s,i=this._getSelectionAnchor(n),r=this.getTbodyEl().rows,a=n.el.parentNode;if(40==t)if(o=this.getNextTrEl(n.el),i.recordIndex<=n.recordIndex){for(l=n.colKeyIndex+1;l<a.cells.length;l++)s=a.cells[l],this.selectCell(s);if(o)for(l=0;l<=n.colKeyIndex;l++)s=o.cells[l],this.selectCell(s)}else{for(l=n.colKeyIndex;l<a.cells.length;l++)this.unselectCell(a.cells[l]);if(o)for(l=0;l<n.colKeyIndex;l++)this.unselectCell(o.cells[l])}else if(38==t)if(o=this.getPreviousTrEl(n.el),i.recordIndex>=n.recordIndex){for(l=n.colKeyIndex-1;-1<l;l--)s=a.cells[l],this.selectCell(s);if(o)for(l=a.cells.length-1;l>=n.colKeyIndex;l--)s=o.cells[l],this.selectCell(s)}else{for(l=n.colKeyIndex;-1<l;l--)this.unselectCell(a.cells[l]);if(o)for(l=a.cells.length-1;l>n.colKeyIndex;l--)this.unselectCell(o.cells[l])}else 39==t?(o=this.getNextTrEl(n.el),i.recordIndex<n.recordIndex?n.colKeyIndex<a.cells.length-1?(s=a.cells[n.colKeyIndex+1],this.selectCell(s)):o&&(s=o.cells[0],this.selectCell(s)):i.recordIndex>n.recordIndex?(this.unselectCell(a.cells[n.colKeyIndex]),n.colKeyIndex,a.cells.length):i.colKeyIndex<=n.colKeyIndex?n.colKeyIndex<a.cells.length-1?(s=a.cells[n.colKeyIndex+1],this.selectCell(s)):n.trIndex<r.length-1&&(s=o.cells[0],this.selectCell(s)):this.unselectCell(a.cells[n.colKeyIndex])):37==t&&(o=this.getPreviousTrEl(n.el),!(i.recordIndex<n.recordIndex)&&(i.recordIndex>n.recordIndex||i.colKeyIndex>=n.colKeyIndex)?0<n.colKeyIndex?(s=a.cells[n.colKeyIndex-1],this.selectCell(s)):0<n.trIndex&&(s=o.cells[o.cells.length-1],this.selectCell(s)):(this.unselectCell(a.cells[n.colKeyIndex]),n.colKeyIndex))}}else this._handleSingleCellSelectionByKey(e)},_handleSingleCellSelectionByMouse:function(e){var t,e=e.target,e=this.getTdEl(e);e&&(t=this.getTrEl(e),t={record:this.getRecord(t),column:this.getColumn(e)},this._oAnchorCell=t,this.unselectAllCells(),this.selectCell(t))},_handleSingleCellSelectionByKey:function(e){var t=u.getCharCode(e);if(9==t||36<t&&t<41){var i,n=e.shiftKey,l=this._getSelectionTrigger();if(!l)return null;if(40==t)null===(i=this.getBelowTdEl(l.el))&&(i=l.el);else if(38==t)null===(i=this.getAboveTdEl(l.el))&&(i=l.el);else if(39==t||!n&&9==t){if(null===(i=this.getNextTdEl(l.el)))return}else if((37==t||n&&9==t)&&null===(i=this.getPreviousTdEl(l.el)))return;u.stopEvent(e),this.unselectAllCells(),this.selectCell(i),this._oAnchorCell={record:this.getRecord(i),column:this.getColumn(i)}}},getSelectedTrEls:function(){return c.getElementsByClassName(m.CLASS_SELECTED,"tr",this._elTbody)},selectRow:function(e){var t,i;if(e instanceof YAHOO.widget.Record?(t=this._oRecordSet.getRecord(e),i=this.getTrEl(t)):v.isNumber(e)?(t=this.getRecord(e),i=this.getTrEl(t)):(i=this.getTrEl(e),t=this.getRecord(i)),t){var n=this._aSelections||[],l=t.getId(),o=-1;if(n.indexOf)o=n.indexOf(l);else for(var s=n.length-1;-1<s;s--)if(n[s]===l){o=s;break}-1<o&&n.splice(o,1),n.push(l),this._aSelections=n,this._oAnchorRecord||(this._oAnchorRecord=t),i&&c.addClass(i,m.CLASS_SELECTED),this.fireEvent("rowSelectEvent",{record:t,el:i})}},unselectRow:function(e){var t=this.getTrEl(e),e=e instanceof YAHOO.widget.Record?this._oRecordSet.getRecord(e):v.isNumber(e)?this.getRecord(e):this.getRecord(t);if(e){var i=this._aSelections||[],n=e.getId(),l=-1;if(i.indexOf)l=i.indexOf(n);else for(var o=i.length-1;-1<o;o--)if(i[o]===n){l=o;break}-1<l&&(i.splice(l,1),this._aSelections=i,c.removeClass(t,m.CLASS_SELECTED),this.fireEvent("rowUnselectEvent",{record:e,el:t}))}},unselectAllRows:function(){for(var e,t=this._aSelections||[],i=[],n=t.length-1;-1<n;n--)v.isString(t[n])&&(e=t.splice(n,1),i[i.length]=this.getRecord(v.isArray(e)?e[0]:e));this._aSelections=t,this._unselectAllTrEls(),this.fireEvent("unselectAllRowsEvent",{records:i})},_unselectAllTdEls:function(){var e=c.getElementsByClassName(m.CLASS_SELECTED,"td",this._elTbody);c.removeClass(e,m.CLASS_SELECTED)},getSelectedTdEls:function(){return c.getElementsByClassName(m.CLASS_SELECTED,"td",this._elTbody)},selectCell:function(e){e=this.getTdEl(e);if(e){var t=this.getRecord(e),i=this.getColumn(this.getCellIndex(e)),n=i.getKey();if(t&&n){for(var l=this._aSelections||[],o=t.getId(),s=l.length-1;-1<s;s--)if(l[s].recordId===o&&l[s].columnKey===n){l.splice(s,1);break}l.push({recordId:o,columnKey:n}),this._aSelections=l,this._oAnchorCell||(this._oAnchorCell={record:t,column:i}),c.addClass(e,m.CLASS_SELECTED),this.fireEvent("cellSelectEvent",{record:t,column:i,key:n,el:e})}}},unselectCell:function(e){var t=this.getTdEl(e);if(t){var i=this.getRecord(t),n=this.getColumn(this.getCellIndex(t)),l=n.getKey();if(i&&l)for(var o=this._aSelections||[],s=i.getId(),r=o.length-1;-1<r;r--)if(o[r].recordId===s&&o[r].columnKey===l)return o.splice(r,1),this._aSelections=o,c.removeClass(t,m.CLASS_SELECTED),void this.fireEvent("cellUnselectEvent",{record:i,column:n,key:l,el:t})}},unselectAllCells:function(){for(var e=this._aSelections||[],t=e.length-1;-1<t;t--)v.isObject(e[t])&&e.splice(t,1);this._aSelections=e,this._unselectAllTdEls(),this.fireEvent("unselectAllCellsEvent")},isSelected:function(e){if(e&&e.ownerDocument==document)return c.hasClass(this.getTdEl(e),m.CLASS_SELECTED)||c.hasClass(this.getTrEl(e),m.CLASS_SELECTED);var t,i=this._aSelections;if(i&&0<i.length)if(e instanceof YAHOO.widget.Record?t=e:v.isNumber(e)&&(t=this.getRecord(e)),t){if(n=t.getId(),i.indexOf){if(-1<i.indexOf(n))return!0}else for(o=i.length-1;-1<o;o--)if(i[o]===n)return!0}else if(e.record&&e.column)for(var n=e.record.getId(),l=e.column.getKey(),o=i.length-1;-1<o;o--)if(i[o].recordId===n&&i[o].columnKey===l)return!0;return!1},getSelectedRows:function(){for(var e=[],t=this._aSelections||[],i=0;i<t.length;i++)v.isString(t[i])&&e.push(t[i]);return e},getSelectedCells:function(){for(var e=[],t=this._aSelections||[],i=0;i<t.length;i++)t[i]&&v.isObject(t[i])&&e.push(t[i]);return e},getLastSelectedRecord:function(){var e=this._aSelections;if(e&&0<e.length)for(var t=e.length-1;-1<t;t--)if(v.isString(e[t]))return e[t]},getLastSelectedCell:function(){var e=this._aSelections;if(e&&0<e.length)for(var t=e.length-1;-1<t;t--)if(e[t].recordId&&e[t].columnKey)return e[t]},highlightRow:function(e){var t,e=this.getTrEl(e);e&&(t=this.getRecord(e),c.addClass(e,m.CLASS_HIGHLIGHTED),this.fireEvent("rowHighlightEvent",{record:t,el:e}))},unhighlightRow:function(e){var t,e=this.getTrEl(e);e&&(t=this.getRecord(e),c.removeClass(e,m.CLASS_HIGHLIGHTED),this.fireEvent("rowUnhighlightEvent",{record:t,el:e}))},highlightCell:function(e){var t,i,n,e=this.getTdEl(e);e&&(this._elLastHighlightedTd&&this.unhighlightCell(this._elLastHighlightedTd),t=this.getRecord(e),n=(i=this.getColumn(this.getCellIndex(e))).getKey(),c.addClass(e,m.CLASS_HIGHLIGHTED),this._elLastHighlightedTd=e,this.fireEvent("cellHighlightEvent",{record:t,column:i,key:n,el:e}))},unhighlightCell:function(e){var t,e=this.getTdEl(e);e&&(t=this.getRecord(e),c.removeClass(e,m.CLASS_HIGHLIGHTED),this._elLastHighlightedTd=null,this.fireEvent("cellUnhighlightEvent",{record:t,column:this.getColumn(this.getCellIndex(e)),key:this.getColumn(this.getCellIndex(e)).getKey(),el:e}))},addCellEditor:function(e,t){e.editor=t,e.editor.subscribe("showEvent",this._onEditorShowEvent,this,!0),e.editor.subscribe("keydownEvent",this._onEditorKeydownEvent,this,!0),e.editor.subscribe("revertEvent",this._onEditorRevertEvent,this,!0),e.editor.subscribe("saveEvent",this._onEditorSaveEvent,this,!0),e.editor.subscribe("cancelEvent",this._onEditorCancelEvent,this,!0),e.editor.subscribe("blurEvent",this._onEditorBlurEvent,this,!0),e.editor.subscribe("blockEvent",this._onEditorBlockEvent,this,!0),e.editor.subscribe("unblockEvent",this._onEditorUnblockEvent,this,!0)},getCellEditor:function(){return this._oCellEditor},showCellEditor:function(e,t,i){if((e=this.getTdEl(e))&&(i=this.getColumn(e))&&i.editor){var n=this._oCellEditor;if(n&&(this._oCellEditor.cancel?this._oCellEditor.cancel():n.isActive&&this.cancelCellEditor()),i.editor instanceof YAHOO.widget.BaseCellEditor)(n=i.editor).attach(this,e)&&(n.render(),n.move(),this.doBeforeShowCellEditor(n))&&(n.show(),this._oCellEditor=n);else if(t&&t instanceof YAHOO.widget.Record||(t=this.getRecord(e)),i&&i instanceof YAHOO.widget.Column||(i=this.getColumn(e)),t&&i){this._oCellEditor&&!this._oCellEditor.container||this._initCellEditorEl(),(n=this._oCellEditor).cell=e,n.record=t,n.column=i,n.validator=i.editorOptions&&v.isFunction(i.editorOptions.validator)?i.editorOptions.validator:null,n.value=t.getData(i.key),n.defaultValue=null;var l,t=n.container,o=c.getX(e),s=c.getY(e);if((isNaN(o)||isNaN(s))&&(o=e.offsetLeft+c.getX(this._elTbody.parentNode)-this._elTbody.scrollLeft,s=e.offsetTop+c.getY(this._elTbody.parentNode)-this._elTbody.scrollTop+this._elThead.offsetHeight),t.style.left=o+"px",t.style.top=s+"px",this.doBeforeShowCellEditor(this._oCellEditor),t.style.display="",u.addListener(t,"keydown",function(e,t){27==e.keyCode?(t.cancelCellEditor(),t.focusTbodyEl()):t.fireEvent("editorKeydownEvent",{editor:t._oCellEditor,event:e})},this),v.isString(i.editor))switch(i.editor){case"checkbox":l=m.editCheckbox;break;case"date":l=m.editDate;break;case"dropdown":l=m.editDropdown;break;case"radio":l=m.editRadio;break;case"textarea":l=m.editTextarea;break;case"textbox":l=m.editTextbox;break;default:l=null}else v.isFunction(i.editor)&&(l=i.editor);l&&(l(this._oCellEditor,this),i.editorOptions&&i.editorOptions.disableBtns||this.showCellEditorBtns(t),n.isActive=!0,this.fireEvent("editorShowEvent",{editor:n}))}}},_initCellEditorEl:function(){(t=document.createElement("div")).id=this._sId+"-celleditor",t.style.display="none",t.tabIndex=0,c.addClass(t,m.CLASS_EDITOR);var e=c.getFirstChild(document.body),t=e?c.insertBefore(t,e):document.body.appendChild(t),e={};e.container=t,e.value=null,e.isActive=!1,this._oCellEditor=e},doBeforeShowCellEditor:function(e){return!0},saveCellEditor:function(){var e,t;this._oCellEditor&&(this._oCellEditor.save?this._oCellEditor.save():this._oCellEditor.isActive&&(e=this._oCellEditor.value,t=this._oCellEditor.record.getData(this._oCellEditor.column.key),this._oCellEditor.validator&&null===(e=this._oCellEditor.value=this._oCellEditor.validator.call(this,e,t,this._oCellEditor))?(this.resetCellEditor(),this.fireEvent("editorRevertEvent",{editor:this._oCellEditor,oldData:t,newData:e})):(this._oRecordSet.updateRecordValue(this._oCellEditor.record,this._oCellEditor.column.key,this._oCellEditor.value),this.formatCell(this._oCellEditor.cell.firstChild,this._oCellEditor.record,this._oCellEditor.column),this._oChainRender.add({method:function(){this.validateColumnWidths()},scope:this}),this._oChainRender.run(),this.resetCellEditor(),this.fireEvent("editorSaveEvent",{editor:this._oCellEditor,oldData:t,newData:e}))))},cancelCellEditor:function(){this._oCellEditor&&(this._oCellEditor.cancel?this._oCellEditor.cancel():this._oCellEditor.isActive&&(this.resetCellEditor(),this.fireEvent("editorCancelEvent",{editor:this._oCellEditor})))},destroyCellEditor:function(){this._oCellEditor&&(this._oCellEditor.destroy(),this._oCellEditor=null)},_onEditorShowEvent:function(e){this.fireEvent("editorShowEvent",e)},_onEditorKeydownEvent:function(e){this.fireEvent("editorKeydownEvent",e)},_onEditorRevertEvent:function(e){this.fireEvent("editorRevertEvent",e)},_onEditorSaveEvent:function(e){this.fireEvent("editorSaveEvent",e)},_onEditorCancelEvent:function(e){this.fireEvent("editorCancelEvent",e)},_onEditorBlurEvent:function(e){this.fireEvent("editorBlurEvent",e)},_onEditorBlockEvent:function(e){this.fireEvent("editorBlockEvent",e)},_onEditorUnblockEvent:function(e){this.fireEvent("editorUnblockEvent",e)},onEditorBlurEvent:function(e){e.editor.disableBtns?e.editor.save&&e.editor.save():e.editor.cancel&&e.editor.cancel()},onEditorBlockEvent:function(e){this.disable()},onEditorUnblockEvent:function(e){this.undisable()},doBeforeLoadData:function(e,t,i){return!0},onEventSortColumn:function(e){var t=e.event,e=e.target,e=this.getThEl(e)||this.getTdEl(e);e&&(e=this.getColumn(e)).sortable&&(u.stopEvent(t),this.sortColumn(e))},onEventSelectColumn:function(e){this.selectColumn(e.target)},onEventHighlightColumn:function(e){this.highlightColumn(e.target)},onEventUnhighlightColumn:function(e){this.unhighlightColumn(e.target)},onEventSelectRow:function(e){"single"==this.get("selectionMode")?this._handleSingleSelectionByMouse(e):this._handleStandardSelectionByMouse(e)},onEventSelectCell:function(e){var t=this.get("selectionMode");"cellblock"==t?this._handleCellBlockSelectionByMouse(e):"cellrange"==t?this._handleCellRangeSelectionByMouse(e):this._handleSingleCellSelectionByMouse(e)},onEventHighlightRow:function(e){this.highlightRow(e.target)},onEventUnhighlightRow:function(e){this.unhighlightRow(e.target)},onEventHighlightCell:function(e){this.highlightCell(e.target)},onEventUnhighlightCell:function(e){this.unhighlightCell(e.target)},onEventFormatCell:function(e){var t,e=e.target,e=this.getTdEl(e);e&&(t=this.getColumn(this.getCellIndex(e)),this.formatCell(e.firstChild,this.getRecord(e),t))},onEventShowCellEditor:function(e){this.isDisabled()||this.showCellEditor(e.target)},onEventSaveCellEditor:function(e){this._oCellEditor&&(this._oCellEditor.save?this._oCellEditor.save():this.saveCellEditor())},onEventCancelCellEditor:function(e){this._oCellEditor&&(this._oCellEditor.cancel?this._oCellEditor.cancel():this.cancelCellEditor())},onDataReturnInitializeTable:function(e,t,i){this instanceof m&&this._sId&&(this.initializeTable(),this.onDataReturnSetRows(e,t,i))},onDataReturnReplaceRows:function(e,t,i){var n,l,o;this instanceof m&&this._sId&&(this.fireEvent("dataReturnEvent",{request:e,response:t,payload:i}),n=this.doBeforeLoadData(e,t,i),l=this.get("paginator"),o=0,n&&t&&!t.error&&v.isArray(t.results)?(this._oRecordSet.reset(),this.get("dynamicData")&&(i&&i.pagination&&v.isNumber(i.pagination.recordOffset)?o=i.pagination.recordOffset:l&&(o=l.getStartIndex())),this._oRecordSet.setRecords(t.results,0|o),this._handleDataReturnPayload(e,t,i),this.render()):n&&t.error&&this.showTableMessage(this.get("MSG_ERROR"),m.CLASS_ERROR))},onDataReturnAppendRows:function(e,t,i){var n;this instanceof m&&this._sId&&(this.fireEvent("dataReturnEvent",{request:e,response:t,payload:i}),(n=this.doBeforeLoadData(e,t,i))&&t&&!t.error&&v.isArray(t.results)?(this.addRows(t.results),this._handleDataReturnPayload(e,t,i)):n&&t.error&&this.showTableMessage(this.get("MSG_ERROR"),m.CLASS_ERROR))},onDataReturnInsertRows:function(e,t,i){var n;this instanceof m&&this._sId&&(this.fireEvent("dataReturnEvent",{request:e,response:t,payload:i}),(n=this.doBeforeLoadData(e,t,i))&&t&&!t.error&&v.isArray(t.results)?(this.addRows(t.results,i?i.insertIndex:0),this._handleDataReturnPayload(e,t,i)):n&&t.error&&this.showTableMessage(this.get("MSG_ERROR"),m.CLASS_ERROR))},onDataReturnUpdateRows:function(e,t,i){var n;this instanceof m&&this._sId&&(this.fireEvent("dataReturnEvent",{request:e,response:t,payload:i}),(n=this.doBeforeLoadData(e,t,i))&&t&&!t.error&&v.isArray(t.results)?(this.updateRows(i?i.updateIndex:0,t.results),this._handleDataReturnPayload(e,t,i)):n&&t.error&&this.showTableMessage(this.get("MSG_ERROR"),m.CLASS_ERROR))},onDataReturnSetRows:function(e,t,i){var n,l,o;this instanceof m&&this._sId&&(this.fireEvent("dataReturnEvent",{request:e,response:t,payload:i}),n=this.doBeforeLoadData(e,t,i),l=this.get("paginator"),o=0,n&&t&&!t.error&&v.isArray(t.results)?(this.get("dynamicData")&&(i&&i.pagination&&v.isNumber(i.pagination.recordOffset)?o=i.pagination.recordOffset:l&&(o=l.getStartIndex()),this._oRecordSet.reset()),this._oRecordSet.setRecords(t.results,0|o),this._handleDataReturnPayload(e,t,i),this.render()):n&&t.error&&this.showTableMessage(this.get("MSG_ERROR"),m.CLASS_ERROR))},handleDataReturnPayload:function(e,t,i){return i||{}},_handleDataReturnPayload:function(e,t,i){(i=this.handleDataReturnPayload(e,t,i))&&((e=this.get("paginator"))&&(this.get("dynamicData")?g.Paginator.isNumeric(i.totalRecords)&&e.set("totalRecords",i.totalRecords):e.set("totalRecords",this._oRecordSet.getLength()),v.isObject(i.pagination))&&(e.set("rowsPerPage",i.pagination.rowsPerPage),e.set("recordOffset",i.pagination.recordOffset)),i.sortedBy?this.set("sortedBy",i.sortedBy):i.sorting&&this.set("sortedBy",i.sorting))},showCellEditorBtns:function(e){var e=e.appendChild(document.createElement("div")),t=(c.addClass(e,m.CLASS_BUTTON),e.appendChild(document.createElement("button"))),t=(c.addClass(t,m.CLASS_DEFAULT),t.innerHTML="OK",u.addListener(t,"click",function(e,t){t.onEventSaveCellEditor(e,t),t.focusTbodyEl()},this,!0),e.appendChild(document.createElement("button")));t.innerHTML="Cancel",u.addListener(t,"click",function(e,t){t.onEventCancelCellEditor(e,t),t.focusTbodyEl()},this,!0)},resetCellEditor:function(){var e=this._oCellEditor.container;e.style.display="none",u.purgeElement(e,!0),e.innerHTML="",this._oCellEditor.value=null,this._oCellEditor.isActive=!1},getBody:function(){return this.getTbodyEl()},getCell:function(e){return this.getTdEl(e)},getRow:function(e){return this.getTrEl(e)},refreshView:function(){this.render()},select:function(e){v.isArray(e)||(e=[e]);for(var t=0;t<e.length;t++)this.selectRow(e[t])},onEventEditCell:function(e){this.onEventShowCellEditor(e)},_syncColWidths:function(){this.validateColumnWidths()}}),m.prototype.onDataReturnSetRecords=m.prototype.onDataReturnSetRows,m.prototype.onPaginatorChange=m.prototype.onPaginatorChangeRequest,m.editCheckbox=function(){},m.editDate=function(){},m.editDropdown=function(){},m.editRadio=function(){},m.editTextarea=function(){},m.editTextbox=function(){}}(),function(){var c=YAHOO.lang,e=YAHOO.util,l=YAHOO.widget,u=YAHOO.env.ua,g=e.Dom,o=e.Event,i=(e.DataSourceBase,l.DataTable),s=(l.Paginator,l.ScrollingDataTable=function(e,t,i,n){(n=n||{}).scrollable&&(n.scrollable=!1),this._init(),l.ScrollingDataTable.superclass.constructor.call(this,e,t,i,n),this.subscribe("columnShowEvent",this._onColumnChange)},l.ScrollingDataTable);c.augmentObject(s,{CLASS_HEADER:"yui-dt-hd",CLASS_BODY:"yui-dt-bd"}),c.extend(s,i,{_elHdContainer:null,_elHdTable:null,_elBdContainer:null,_elBdThead:null,_elTmpContainer:null,_elTmpTable:null,_bScrollbarX:null,initAttributes:function(e){s.superclass.initAttributes.call(this,e=e||{}),this.setAttributeConfig("width",{value:null,validator:c.isString,method:function(e){this._elHdContainer&&this._elBdContainer&&(this._elHdContainer.style.width=e,this._elBdContainer.style.width=e,this._syncScrollX(),this._syncScrollOverhang())}}),this.setAttributeConfig("height",{value:null,validator:c.isString,method:function(e){this._elHdContainer&&this._elBdContainer&&(this._elBdContainer.style.height=e,this._syncScrollX(),this._syncScrollY(),this._syncScrollOverhang())}}),this.setAttributeConfig("COLOR_COLUMNFILLER",{value:"#F2F2F2",validator:c.isString,method:function(e){this._elHdContainer&&(this._elHdContainer.style.backgroundColor=e)}})},_init:function(){this._elHdContainer=null,this._elHdTable=null,this._elBdContainer=null,this._elBdThead=null,this._elTmpContainer=null,this._elTmpTable=null},_initDomElements:function(e){return this._initContainerEl(e),this._elContainer&&this._elHdContainer&&this._elBdContainer&&(this._initTableEl(),this._elHdTable)&&this._elTable&&(this._initColgroupEl(this._elHdTable),this._initTheadEl(this._elHdTable,this._elTable),this._initTbodyEl(this._elTable),this._initMsgTbodyEl(this._elTable)),!!(this._elContainer&&this._elTable&&this._elColgroup&&this._elThead&&this._elTbody&&this._elMsgTbody&&this._elHdTable&&this._elBdThead)},_destroyContainerEl:function(e){g.removeClass(e,i.CLASS_SCROLLABLE),s.superclass._destroyContainerEl.call(this,e),this._elHdContainer=null,this._elBdContainer=null},_initContainerEl:function(e){var t;s.superclass._initContainerEl.call(this,e),this._elContainer&&(e=this._elContainer,g.addClass(e,i.CLASS_SCROLLABLE),(t=document.createElement("div")).style.width=this.get("width")||"",t.style.backgroundColor=this.get("COLOR_COLUMNFILLER"),g.addClass(t,s.CLASS_HEADER),this._elHdContainer=t,e.appendChild(t),(t=document.createElement("div")).style.width=this.get("width")||"",t.style.height=this.get("height")||"",g.addClass(t,s.CLASS_BODY),o.addListener(t,"scroll",this._onScroll,this),this._elBdContainer=t,e.appendChild(t))},_initCaptionEl:function(e){},_destroyHdTableEl:function(){var e=this._elHdTable;e&&(o.purgeElement(e,!0),e.parentNode.removeChild(e),this._elBdThead=null)},_initTableEl:function(){this._elHdContainer&&(this._destroyHdTableEl(),this._elHdTable=this._elHdContainer.appendChild(document.createElement("table")),o.delegate(this._elHdTable,"mouseenter",this._onTableMouseover,"thead ."+i.CLASS_LABEL,this),o.delegate(this._elHdTable,"mouseleave",this._onTableMouseout,"thead ."+i.CLASS_LABEL,this)),s.superclass._initTableEl.call(this,this._elBdContainer)},_initTheadEl:function(e,t){e=e||this._elHdTable,t=t||this._elTable,this._initBdTheadEl(t),s.superclass._initTheadEl.call(this,e)},_initThEl:function(e,t){s.superclass._initThEl.call(this,e,t),e.id=this.getId()+"-fixedth-"+t.getSanitizedKey()},_destroyBdTheadEl:function(){var e,t=this._elBdThead;t&&(e=t.parentNode,o.purgeElement(t,!0),e.removeChild(t),this._elBdThead=null,this._destroyColumnHelpers())},_initBdTheadEl:function(e){if(e){this._destroyBdTheadEl();for(var t,i,n,l,o,s=e.insertBefore(document.createElement("thead"),e.firstChild),r=this._oColumnSet.tree,a=0,d=r.length;a<d;a++)for(i=s.appendChild(document.createElement("tr")),l=0,o=r[a].length;l<o;l++)n=r[a][l],t=i.appendChild(document.createElement("th")),this._initBdThEl(t,n,a,l);this._elBdThead=s}},_initBdThEl:function(e,t){e.id=this.getId()+"-th-"+t.getSanitizedKey(),e.rowSpan=t.getRowspan(),e.colSpan=t.getColspan(),t.abbr&&(e.abbr=t.abbr);var i=t.getKey(),t=c.isValue(t.label)?t.label:i;e.innerHTML=t},_initTbodyEl:function(e){s.superclass._initTbodyEl.call(this,e),e.style.marginTop=0<this._elTbody.offsetTop?"-"+this._elTbody.offsetTop+"px":0},_focusEl:function(t){t=t||this._elTbody;var i=this;this._storeScrollPositions(),setTimeout(function(){setTimeout(function(){try{t.focus(),i._restoreScrollPositions()}catch(e){}},0)},0)},_runRenderChain:function(){this._storeScrollPositions(),this._oChainRender.run()},_storeScrollPositions:function(){this._nScrollTop=this._elBdContainer.scrollTop,this._nScrollLeft=this._elBdContainer.scrollLeft},clearScrollPositions:function(){this._nScrollTop=0,this._nScrollLeft=0},_restoreScrollPositions:function(){this._nScrollTop&&(this._elBdContainer.scrollTop=this._nScrollTop,this._nScrollTop=null),this._nScrollLeft&&(this._elBdContainer.scrollLeft=this._nScrollLeft,this._elHdContainer.scrollLeft=this._nScrollLeft,this._nScrollLeft=null)},_validateColumnWidth:function(e,t){var i;e.width||e.hidden||(i=e.getThEl(),e._calculatedWidth&&this._setColumnWidth(e,"auto","visible"),i.offsetWidth!==t.offsetWidth&&(i=i.offsetWidth>t.offsetWidth?e.getThLinerEl():t.firstChild,t=Math.max(0,i.offsetWidth-(0|parseInt(g.getStyle(i,"paddingLeft"),10))-(0|parseInt(g.getStyle(i,"paddingRight"),10)),e.minWidth),i="visible",0<e.maxAutoWidth&&t>e.maxAutoWidth&&(t=e.maxAutoWidth,i="hidden"),this._elTbody.style.display="none",this._setColumnWidth(e,t+"px",i),e._calculatedWidth=t,this._elTbody.style.display=""))},validateColumnWidths:function(e){var t=this._oColumnSet.keys,i=t.length,n=this.getFirstTrEl();if(u.ie&&this._setOverhangValue(1),t&&n&&n.childNodes.length===i){var l=this.get("width");if(l&&(this._elHdContainer.style.width="",this._elBdContainer.style.width=""),this._elContainer.style.width="",e&&c.isNumber(e.getKeyIndex()))this._validateColumnWidth(e,n.childNodes[e.getKeyIndex()]);else{for(var o,s,r,a,d=[],h=0;h<i;h++)(e=t[h]).width||e.hidden||!e._calculatedWidth||(d[d.length]=e);for(this._elTbody.style.display="none",h=0,s=d.length;h<s;h++)this._setColumnWidth(d[h],"auto","visible");for(this._elTbody.style.display="",d=[],h=0;h<i;h++)e=t[h],r=n.childNodes[h],e.width||e.hidden||(a=e.getThEl()).offsetWidth!==r.offsetWidth&&(a=a.offsetWidth>r.offsetWidth?e.getThLinerEl():r.firstChild,r=Math.max(0,a.offsetWidth-(0|parseInt(g.getStyle(a,"paddingLeft"),10))-(0|parseInt(g.getStyle(a,"paddingRight"),10)),e.minWidth),a="visible",0<e.maxAutoWidth&&r>e.maxAutoWidth&&(r=e.maxAutoWidth,a="hidden"),d[d.length]=[e,r,a]);for(this._elTbody.style.display="none",h=0,s=d.length;h<s;h++)o=d[h],this._setColumnWidth(o[0],o[1]+"px",o[2]),o[0]._calculatedWidth=o[1];this._elTbody.style.display=""}l&&(this._elHdContainer.style.width=l,this._elBdContainer.style.width=l)}this._syncScroll(),this._restoreScrollPositions()},_syncScroll:function(){this._syncScrollX(),this._syncScrollY(),this._syncScrollOverhang(),u.opera&&(this._elHdContainer.scrollLeft=this._elBdContainer.scrollLeft,this.get("width")||(document.body.style+=""))},_syncScrollY:function(){var e=this._elTbody,t=this._elBdContainer;this.get("width")||(this._elContainer.style.width=t.scrollHeight>t.clientHeight?e.parentNode.clientWidth+19+"px":e.parentNode.clientWidth+2+"px")},_syncScrollX:function(){var e=this._elTbody,t=this._elBdContainer;!this.get("height")&&u.ie&&(t.style.height=t.scrollWidth>t.offsetWidth?e.parentNode.offsetHeight+18+"px":e.parentNode.offsetHeight+"px"),0===this._elTbody.rows.length?this._elMsgTbody.parentNode.style.width=this.getTheadEl().parentNode.offsetWidth+"px":this._elMsgTbody.parentNode.style.width=""},_syncScrollOverhang:function(){var e=this._elBdContainer,t=1;e.scrollHeight>e.clientHeight&&e.scrollWidth>e.clientWidth&&(t=18),this._setOverhangValue(t)},_setOverhangValue:function(e){var t=this._oColumnSet.headers[this._oColumnSet.headers.length-1]||[],i=t.length,n=this._sId+"-fixedth-",l=e+"px solid "+this.get("COLOR_COLUMNFILLER");this._elThead.style.display="none";for(var o=0;o<i;o++)g.get(n+t[o]).style.borderRight=l;this._elThead.style.display=""},getHdContainerEl:function(){return this._elHdContainer},getBdContainerEl:function(){return this._elBdContainer},getHdTableEl:function(){return this._elHdTable},getBdTableEl:function(){return this._elTable},disable:function(){var e=this._elMask;e.style.width=this._elBdContainer.offsetWidth+"px",e.style.height=this._elHdContainer.offsetHeight+this._elBdContainer.offsetHeight+"px",e.style.display="",this.fireEvent("disableEvent")},removeColumn:function(e){var t=this._elHdContainer.scrollLeft,i=this._elBdContainer.scrollLeft;return e=s.superclass.removeColumn.call(this,e),this._elHdContainer.scrollLeft=t,this._elBdContainer.scrollLeft=i,e},insertColumn:function(e,t){var i=this._elHdContainer.scrollLeft,n=this._elBdContainer.scrollLeft,e=s.superclass.insertColumn.call(this,e,t);return this._elHdContainer.scrollLeft=i,this._elBdContainer.scrollLeft=n,e},reorderColumn:function(e,t){var i=this._elHdContainer.scrollLeft,n=this._elBdContainer.scrollLeft,e=s.superclass.reorderColumn.call(this,e,t);return this._elHdContainer.scrollLeft=i,this._elBdContainer.scrollLeft=n,e},setColumnWidth:function(e,t){(e=this.getColumn(e))&&(this._storeScrollPositions(),c.isNumber(t)?(t=t>e.minWidth?t:e.minWidth,e.width=t,this._setColumnWidth(e,t+"px"),this._syncScroll(),this.fireEvent("columnSetWidthEvent",{column:e,width:t})):null===t&&(e.width=t,this._setColumnWidth(e,"auto"),this.validateColumnWidths(e),this.fireEvent("columnUnsetWidthEvent",{column:e})),this._clearTrTemplateEl())},scrollTo:function(e){var t=this.getTdEl(e);t?(this.clearScrollPositions(),this.getBdContainerEl().scrollLeft=t.offsetLeft,this.getBdContainerEl().scrollTop=t.parentNode.offsetTop):(t=this.getTrEl(e))&&(this.clearScrollPositions(),this.getBdContainerEl().scrollTop=t.offsetTop)},showTableMessage:function(e,t){var i=this._elMsgTd;c.isString(e)&&(i.firstChild.innerHTML=e),c.isString(t)&&g.addClass(i.firstChild,t);this.getTheadEl().parentNode.offsetWidth;this._elMsgTbody.parentNode.style.width=this.getTheadEl().parentNode.offsetWidth+"px",this._elMsgTbody.style.display="",this.fireEvent("tableMsgShowEvent",{html:e,className:t})},_onColumnChange:function(e){e=e.column||(e.editor?e.editor.column:null);this._storeScrollPositions(),this.validateColumnWidths(e)},_onScroll:function(e,t){t._elHdContainer.scrollLeft=t._elBdContainer.scrollLeft,t._oCellEditor&&t._oCellEditor.isActive&&(t.fireEvent("editorBlurEvent",{editor:t._oCellEditor}),t.cancelCellEditor());var i=o.getTarget(e);i.nodeName.toLowerCase();t.fireEvent("tableScrollEvent",{event:e,target:i})},_onTheadKeydown:function(e,t){9===o.getCharCode(e)&&setTimeout(function(){t instanceof s&&t._sId&&(t._elBdContainer.scrollLeft=t._elHdContainer.scrollLeft)},0);for(var i=o.getTarget(e),n=i.nodeName.toLowerCase(),l=!0;i&&"table"!=n;){switch(n){case"body":return;case"input":case"textarea":break;case"thead":l=t.fireEvent("theadKeyEvent",{target:i,event:e})}if(!1===l)return;(i=i.parentNode)&&(n=i.nodeName.toLowerCase())}t.fireEvent("tableKeyEvent",{target:i||t._elContainer,event:e})}})}(),function(){var a=YAHOO.lang,e=YAHOO.util,t=YAHOO.widget,i=YAHOO.env.ua,o=e.Dom,n=e.Event,l=t.DataTable,s=(t.BaseCellEditor=function(e,t){this._sId=this._sId||o.generateId(null,"yui-ceditor"),YAHOO.widget.BaseCellEditor._nCount++,this._sType=e,this._initConfigs(t),this._initEvents(),this._needsRender=!0},t.BaseCellEditor),e=(a.augmentObject(s,{_nCount:0,CLASS_CELLEDITOR:"yui-ceditor"}),s.prototype={_sId:null,_sType:null,_oDataTable:null,_oColumn:null,_oRecord:null,_elTd:null,_elContainer:null,_elCancelBtn:null,_elSaveBtn:null,_initConfigs:function(e){if(e&&YAHOO.lang.isObject(e))for(var t in e)t&&(this[t]=e[t])},_initEvents:function(){this.createEvent("showEvent"),this.createEvent("keydownEvent"),this.createEvent("invalidDataEvent"),this.createEvent("revertEvent"),this.createEvent("saveEvent"),this.createEvent("cancelEvent"),this.createEvent("blurEvent"),this.createEvent("blockEvent"),this.createEvent("unblockEvent")},_initContainerEl:function(){this._elContainer&&(YAHOO.util.Event.purgeElement(this._elContainer,!0),this._elContainer.innerHTML="");var e=document.createElement("div");e.id=this.getId()+"-container",e.style.display="none",e.tabIndex=0,this.className=a.isArray(this.className)?this.className:this.className?[this.className]:[],this.className[this.className.length]=l.CLASS_EDITOR,e.className=this.className.join(" "),document.body.insertBefore(e,document.body.firstChild),this._elContainer=e},_initShimEl:function(){var e;this.useIFrame&&!this._elIFrame&&((e=document.createElement("iframe")).src="javascript:false",e.frameBorder=0,e.scrolling="no",e.style.display="none",e.className=l.CLASS_EDITOR_SHIM,e.tabIndex=-1,e.role="presentation",e.title="Presentational iframe shim",document.body.insertBefore(e,document.body.firstChild),this._elIFrame=e)},_hide:function(){this.getContainerEl().style.display="none",this._elIFrame&&(this._elIFrame.style.display="none"),this.isActive=!1,this.getDataTable()._oCellEditor=null},asyncSubmitter:null,value:null,defaultValue:null,validator:null,resetInvalidData:!0,isActive:!1,LABEL_SAVE:"Save",LABEL_CANCEL:"Cancel",disableBtns:!1,useIFrame:!1,className:null,toString:function(){return"CellEditor instance "+this._sId},getId:function(){return this._sId},getDataTable:function(){return this._oDataTable},getColumn:function(){return this._oColumn},getRecord:function(){return this._oRecord},getTdEl:function(){return this._elTd},getContainerEl:function(){return this._elContainer},destroy:function(){this.unsubscribeAll();var e=this.getColumn(),e=(e&&(e.editor=null),this.getContainerEl());e&&(n.purgeElement(e,!0),e.parentNode.removeChild(e))},render:function(){this._needsRender&&(this._initContainerEl(),this._initShimEl(),n.addListener(this.getContainerEl(),"keydown",function(e,t){var i;27==e.keyCode&&((i=n.getTarget(e)).nodeName&&"select"===i.nodeName.toLowerCase()&&i.blur(),t.cancel()),t.fireEvent("keydownEvent",{editor:t,event:e})},this),this.renderForm(),this.disableBtns||this.renderBtns(),this.doAfterRender(),this._needsRender=!1)},renderBtns:function(){var e=this.getContainerEl().appendChild(document.createElement("div")),t=(e.className=l.CLASS_BUTTON,e.appendChild(document.createElement("button"))),t=(t.className=l.CLASS_DEFAULT,t.innerHTML=this.LABEL_SAVE,n.addListener(t,"click",function(e){this.save()},this,!0),this._elSaveBtn=t,e.appendChild(document.createElement("button")));t.innerHTML=this.LABEL_CANCEL,n.addListener(t,"click",function(e){this.cancel()},this,!0),this._elCancelBtn=t},attach:function(e,t){if(e instanceof YAHOO.widget.DataTable&&(t=(this._oDataTable=e).getTdEl(t))){this._elTd=t;var i=e.getColumn(t);if(i){this._oColumn=i;i=e.getRecord(t);if(i)return t=(this._oRecord=i).getData(this.getColumn().getField()),this.value=t!==undefined?t:this.defaultValue,!0}}return!1},move:function(){var e,t=this.getContainerEl(),i=this.getTdEl(),n=o.getX(i),l=o.getY(i);(isNaN(n)||isNaN(l))&&(e=this.getDataTable().getTbodyEl(),n=i.offsetLeft+o.getX(e.parentNode)-e.scrollLeft,l=i.offsetTop+o.getY(e.parentNode)-e.scrollTop+this.getDataTable().getTheadEl().offsetHeight),t.style.left=n+"px",t.style.top=l+"px",this._elIFrame&&(this._elIFrame.style.left=n+"px",this._elIFrame.style.top=l+"px")},show:function(){var e=this.getContainerEl(),t=this._elIFrame;this.resetForm(),this.isActive=!0,e.style.display="",t&&(t.style.width=e.offsetWidth+"px",t.style.height=e.offsetHeight+"px",t.style.display=""),this.focus(),this.fireEvent("showEvent",{editor:this})},block:function(){this.fireEvent("blockEvent",{editor:this})},unblock:function(){this.fireEvent("unblockEvent",{editor:this})},save:function(){var n,e=this.getInputValue(),t=e;this.validator&&(t=this.validator.call(this.getDataTable(),e,this.value,this))===undefined?(this.resetInvalidData&&this.resetForm(),this.fireEvent("invalidDataEvent",{editor:this,oldData:this.value,newData:e})):(e=function(e,t){var i=n.value;e?(n.value=t,n.getDataTable().updateCell(n.getRecord(),n.getColumn(),t),n._hide(),n.fireEvent("saveEvent",{editor:n,oldData:i,newData:n.value})):(n.resetForm(),n.fireEvent("revertEvent",{editor:n,oldData:i,newData:t})),n.unblock()},(n=this).block(),a.isFunction(this.asyncSubmitter)?this.asyncSubmitter.call(this,e,t):e(!0,t))},cancel:function(){this.isActive&&(this._hide(),this.fireEvent("cancelEvent",{editor:this}))},renderForm:function(){},doAfterRender:function(){},handleDisabledBtns:function(){},resetForm:function(){},focus:function(){},getInputValue:function(){}},a.augmentProto(s,e.EventProvider),t.CheckboxCellEditor=function(e){e=e||{},this._sId=this._sId||o.generateId(null,"yui-checkboxceditor"),YAHOO.widget.BaseCellEditor._nCount++,t.CheckboxCellEditor.superclass.constructor.call(this,e.type||"checkbox",e)},a.extend(t.CheckboxCellEditor,s,{checkboxOptions:null,checkboxes:null,value:null,renderForm:function(){if(a.isArray(this.checkboxOptions)){for(var e,t,i,n=0,l=this.checkboxOptions.length;n<l;n++)e=this.checkboxOptions[n],i=a.isValue(e.value)?e.value:e,t=this.getId()+"-chk"+n,this.getContainerEl().innerHTML+='<input type="checkbox" id="'+t+'" value="'+i+'" />',(i=this.getContainerEl().appendChild(document.createElement("label"))).htmlFor=t,i.innerHTML=a.isValue(e.label)?e.label:e;var o=[];for(n=0;n<l;n++)o[o.length]=this.getContainerEl().childNodes[2*n];this.checkboxes=o,this.disableBtns&&this.handleDisabledBtns()}},handleDisabledBtns:function(){n.addListener(this.getContainerEl(),"click",function(e){"input"===n.getTarget(e).tagName.toLowerCase()&&this.save()},this,!0)},resetForm:function(){for(var e=a.isArray(this.value)?this.value:[this.value],t=0,i=this.checkboxes.length;t<i;t++){this.checkboxes[t].checked=!1;for(var n=0,l=e.length;n<l;n++)this.checkboxes[t].value==e[n]&&(this.checkboxes[t].checked=!0)}},focus:function(){this.checkboxes[0].focus()},getInputValue:function(){for(var e=[],t=0,i=this.checkboxes.length;t<i;t++)this.checkboxes[t].checked&&(e[e.length]=this.checkboxes[t].value);return e}}),a.augmentObject(t.CheckboxCellEditor,s),t.DateCellEditor=function(e){e=e||{},this._sId=this._sId||o.generateId(null,"yui-dateceditor"),YAHOO.widget.BaseCellEditor._nCount++,t.DateCellEditor.superclass.constructor.call(this,e.type||"date",e)},a.extend(t.DateCellEditor,s,{calendar:null,calendarOptions:null,defaultValue:new Date,renderForm:function(){var e,t;YAHOO.widget.Calendar&&((e=this.getContainerEl().appendChild(document.createElement("div"))).id=this.getId()+"-dateContainer",(t=new YAHOO.widget.Calendar(this.getId()+"-date",e.id,this.calendarOptions)).render(),e.style.cssFloat="none",t.hideEvent.subscribe(function(){this.cancel()},this,!0),i.ie&&(this.getContainerEl().appendChild(document.createElement("div")).style.clear="both"),this.calendar=t,this.disableBtns)&&this.handleDisabledBtns()},handleDisabledBtns:function(){this.calendar.selectEvent.subscribe(function(e){this.save()},this,!0)},resetForm:function(){var e=this.value||new Date;this.calendar.select(e),this.calendar.cfg.setProperty("pagedate",e,!1),this.calendar.render(),this.calendar.show()},focus:function(){},getInputValue:function(){return this.calendar.getSelectedDates()[0]}}),a.augmentObject(t.DateCellEditor,s),t.DropdownCellEditor=function(e){e=e||{},this._sId=this._sId||o.generateId(null,"yui-dropdownceditor"),YAHOO.widget.BaseCellEditor._nCount++,t.DropdownCellEditor.superclass.constructor.call(this,e.type||"dropdown",e)},a.extend(t.DropdownCellEditor,s,{dropdownOptions:null,dropdown:null,multiple:!1,size:null,renderForm:function(){var e=this.getContainerEl().appendChild(document.createElement("select"));if(e.style.zoom=1,this.multiple&&(e.multiple="multiple"),a.isNumber(this.size)&&(e.size=this.size),this.dropdown=e,a.isArray(this.dropdownOptions)){for(var t,i,n=0,l=this.dropdownOptions.length;n<l;n++)t=this.dropdownOptions[n],(i=document.createElement("option")).value=a.isValue(t.value)?t.value:t,i.innerHTML=a.isValue(t.label)?t.label:t,i=e.appendChild(i);this.disableBtns&&this.handleDisabledBtns()}},handleDisabledBtns:function(){this.multiple?n.addListener(this.dropdown,"blur",function(e){this.save()},this,!0):i.ie?(n.addListener(this.dropdown,"blur",function(e){this.save()},this,!0),n.addListener(this.dropdown,"click",function(e){this.save()},this,!0)):n.addListener(this.dropdown,"change",function(e){this.save()},this,!0)},resetForm:function(){var e=this.dropdown.options,t=0,i=e.length;if(a.isArray(this.value)){for(var n=this.value,l=0,o=n.length,s={};t<i;t++)e[t].selected=!1,s[e[t].value]=e[t];for(;l<o;l++)s[n[l]]&&(s[n[l]].selected=!0)}else for(;t<i;t++)this.value==e[t].value&&(e[t].selected=!0)},focus:function(){this.getDataTable()._focusEl(this.dropdown)},getInputValue:function(){var e=this.dropdown.options;if(this.multiple){for(var t=[],i=0,n=e.length;i<n;i++)e[i].selected&&t.push(e[i].value);return t}return e[e.selectedIndex].value}}),a.augmentObject(t.DropdownCellEditor,s),t.RadioCellEditor=function(e){e=e||{},this._sId=this._sId||o.generateId(null,"yui-radioceditor"),YAHOO.widget.BaseCellEditor._nCount++,t.RadioCellEditor.superclass.constructor.call(this,e.type||"radio",e)},a.extend(t.RadioCellEditor,s,{radios:null,radioOptions:null,renderForm:function(){if(a.isArray(this.radioOptions)){for(var e,t,i,n=0,l=this.radioOptions.length;n<l;n++)e=this.radioOptions[n],i=a.isValue(e.value)?e.value:e,t=this.getId()+"-radio"+n,this.getContainerEl().innerHTML+='<input type="radio" name="'+this.getId()+'" value="'+i+'" id="'+t+'" />',(i=this.getContainerEl().appendChild(document.createElement("label"))).htmlFor=t,i.innerHTML=a.isValue(e.label)?e.label:e;for(var o,s=[],r=0;r<l;r++)o=this.getContainerEl().childNodes[2*r],s[s.length]=o;this.radios=s,this.disableBtns&&this.handleDisabledBtns()}},handleDisabledBtns:function(){n.addListener(this.getContainerEl(),"click",function(e){"input"===n.getTarget(e).tagName.toLowerCase()&&this.save()},this,!0)},resetForm:function(){for(var e=0,t=this.radios.length;e<t;e++){var i=this.radios[e];if(this.value==i.value)return void(i.checked=!0)}},focus:function(){for(var e=0,t=this.radios.length;e<t;e++)if(this.radios[e].checked)return void this.radios[e].focus()},getInputValue:function(){for(var e=0,t=this.radios.length;e<t;e++)if(this.radios[e].checked)return this.radios[e].value}}),a.augmentObject(t.RadioCellEditor,s),t.TextareaCellEditor=function(e){e=e||{},this._sId=this._sId||o.generateId(null,"yui-textareaceditor"),YAHOO.widget.BaseCellEditor._nCount++,t.TextareaCellEditor.superclass.constructor.call(this,e.type||"textarea",e)},a.extend(t.TextareaCellEditor,s,{textarea:null,renderForm:function(){var e=this.getContainerEl().appendChild(document.createElement("textarea"));this.textarea=e,this.disableBtns&&this.handleDisabledBtns()},handleDisabledBtns:function(){n.addListener(this.textarea,"blur",function(e){this.save()},this,!0)},move:function(){this.textarea.style.width=this.getTdEl().offsetWidth+"px",this.textarea.style.height="3em",YAHOO.widget.TextareaCellEditor.superclass.move.call(this)},resetForm:function(){this.textarea.value=this.value},focus:function(){this.getDataTable()._focusEl(this.textarea),this.textarea.select()},getInputValue:function(){return this.textarea.value}}),a.augmentObject(t.TextareaCellEditor,s),t.TextboxCellEditor=function(e){e=e||{},this._sId=this._sId||o.generateId(null,"yui-textboxceditor"),YAHOO.widget.BaseCellEditor._nCount++,t.TextboxCellEditor.superclass.constructor.call(this,e.type||"textbox",e)},a.extend(t.TextboxCellEditor,s,{textbox:null,renderForm:function(){var e=(420<i.webkit?this.getContainerEl().appendChild(document.createElement("form")):this.getContainerEl()).appendChild(document.createElement("input"));e.type="text",this.textbox=e,n.addListener(e,"keypress",function(e){13===e.keyCode&&(YAHOO.util.Event.preventDefault(e),this.save())},this,!0),this.disableBtns&&this.handleDisabledBtns()},move:function(){this.textbox.style.width=this.getTdEl().offsetWidth+"px",t.TextboxCellEditor.superclass.move.call(this)},resetForm:function(){this.textbox.value=a.isValue(this.value)?this.value.toString():""},focus:function(){this.getDataTable()._focusEl(this.textbox),this.textbox.select()},getInputValue:function(){return this.textbox.value}}),a.augmentObject(t.TextboxCellEditor,s),l.Editors={checkbox:t.CheckboxCellEditor,date:t.DateCellEditor,dropdown:t.DropdownCellEditor,radio:t.RadioCellEditor,textarea:t.TextareaCellEditor,textbox:t.TextboxCellEditor},t.CellEditor=function(e,t){return e&&l.Editors[e]?(a.augmentObject(s,l.Editors[e]),new l.Editors[e](t)):new s(null,t)},t.CellEditor);a.augmentObject(e,s)}(),YAHOO.register("datatable",YAHOO.widget.DataTable,{version:"2.9.0",build:"2800"});
//# sourceMappingURL=datatable.js.map;
(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerMessages = exports.getMessage = exports.addMessage = void 0;
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/** @module messages/messageHandler */

//use an object in window as cache, in order to prevent multiple instances of the cache
window.__messagesCache = window.__messagesCache || {};
var messages = window.__messagesCache;

/**
 * adds a message object with key value pairs for translation
 * @param {Object} msg
 */
var registerMessages = exports.registerMessages = function registerMessages(msg) {
  Object.assign(messages, msg);
};

/**
 * adds a message to the global message cache for translation
 * @param {string} key
 * @param {string} value
 */
var addMessage = exports.addMessage = function addMessage(key, value) {
  messages[key] = value;
};

/**
 * translates a given key and replaces {0}..{n} with the respective replacements
 * @param {string} key
 * @param {...string} replacements
 * @returns {string}
 * @example
 * addMessage('example', 'example {0} of {1}')
 * getMessage('example', '4', 'many');
 * // --> 'example 4 of many'
 * getMessage('example', ['2', '6']);
 * // --> 'example 2 of 6'
 */
var getMessage = exports.getMessage = function getMessage(key) {
  var _ref;
  for (var _len = arguments.length, replacements = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    replacements[_key - 1] = arguments[_key];
  }
  replacements = (_ref = []).concat.apply(_ref, _toConsumableArray(replacements));
  var message = messages[key] || key.split('.').reduce(function (all, a) {
    return a;
  }, '');
  message = message.replace(/\{(\d)\}/g, function (match, id) {
    return replacements[+id] != null ? replacements[+id] : match;
  });
  return message;
};
window.registerMessages = registerMessages;
window.getMessage = getMessage;
window.addMessage = addMessage;

},{}]},{},[1]);
;
YAHOO.widget.Button.prototype.SUBMIT_TITLE="",YAHOO.widget.Menu.prototype.OFF_SCREEN_POSITION=[-5e4,-5e4];
//# sourceMappingURL=yuiSettings.js.map;
!function(e,t){"use strict";"object"==typeof module&&"object"==typeof module.exports?module.exports=e.document?t(e,!0):function(e){if(e.document)return t(e);throw new Error("jQuery requires a window with a document")}:t(e)}("undefined"!=typeof window?window:this,function(T,R){"use strict";var t=[],M=Object.getPrototypeOf,s=t.slice,I=t.flat?function(e){return t.flat.call(e)}:function(e){return t.concat.apply([],e)},W=t.push,F=t.indexOf,B={},$=B.toString,_=B.hasOwnProperty,z=_.toString,U=z.call(Object),g={},v=function v(e){return"function"==typeof e&&"number"!=typeof e.nodeType&&"function"!=typeof e.item},y=function y(e){return null!=e&&e===e.window},C=T.document,X={type:!0,src:!0,nonce:!0,noModule:!0};function V(e,t,n){var r,i,o=(n=n||C).createElement("script");if(o.text=e,t)for(r in X)(i=t[r]||t.getAttribute&&t.getAttribute(r))&&o.setAttribute(r,i);n.head.appendChild(o).parentNode.removeChild(o)}function h(e){return null==e?e+"":"object"==typeof e||"function"==typeof e?B[$.call(e)]||"object":typeof e}var e="3.6.0",E=function(e,t){return new E.fn.init(e,t)};function G(e){var t=!!e&&"length"in e&&e.length,n=h(e);return!v(e)&&!y(e)&&("array"===n||0===t||"number"==typeof t&&0<t&&t-1 in e)}E.fn=E.prototype={jquery:e,constructor:E,length:0,toArray:function(){return s.call(this)},get:function(e){return null==e?s.call(this):e<0?this[e+this.length]:this[e]},pushStack:function(e){e=E.merge(this.constructor(),e);return e.prevObject=this,e},each:function(e){return E.each(this,e)},map:function(n){return this.pushStack(E.map(this,function(e,t){return n.call(e,t,e)}))},slice:function(){return this.pushStack(s.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},even:function(){return this.pushStack(E.grep(this,function(e,t){return(t+1)%2}))},odd:function(){return this.pushStack(E.grep(this,function(e,t){return t%2}))},eq:function(e){var t=this.length,e=+e+(e<0?t:0);return this.pushStack(0<=e&&e<t?[this[e]]:[])},end:function(){return this.prevObject||this.constructor()},push:W,sort:t.sort,splice:t.splice},E.extend=E.fn.extend=function(){var e,t,n,r,i,o=arguments[0]||{},a=1,s=arguments.length,u=!1;for("boolean"==typeof o&&(u=o,o=arguments[a]||{},a++),"object"==typeof o||v(o)||(o={}),a===s&&(o=this,a--);a<s;a++)if(null!=(e=arguments[a]))for(t in e)n=e[t],"__proto__"!==t&&o!==n&&(u&&n&&(E.isPlainObject(n)||(r=Array.isArray(n)))?(i=o[t],i=r&&!Array.isArray(i)?[]:r||E.isPlainObject(i)?i:{},r=!1,o[t]=E.extend(u,i,n)):n!==undefined&&(o[t]=n));return o},E.extend({expando:"jQuery"+(e+Math.random()).replace(/\D/g,""),isReady:!0,error:function(e){throw new Error(e)},noop:function(){},isPlainObject:function(e){return!(!e||"[object Object]"!==$.call(e)||(e=M(e))&&("function"!=typeof(e=_.call(e,"constructor")&&e.constructor)||z.call(e)!==U))},isEmptyObject:function(e){for(var t in e)return!1;return!0},globalEval:function(e,t,n){V(e,{nonce:t&&t.nonce},n)},each:function(e,t){var n,r=0;if(G(e))for(n=e.length;r<n&&!1!==t.call(e[r],r,e[r]);r++);else for(r in e)if(!1===t.call(e[r],r,e[r]))break;return e},makeArray:function(e,t){t=t||[];return null!=e&&(G(Object(e))?E.merge(t,"string"==typeof e?[e]:e):W.call(t,e)),t},inArray:function(e,t,n){return null==t?-1:F.call(t,e,n)},merge:function(e,t){for(var n=+t.length,r=0,i=e.length;r<n;r++)e[i++]=t[r];return e.length=i,e},grep:function(e,t,n){for(var r=[],i=0,o=e.length,a=!n;i<o;i++)!t(e[i],i)!=a&&r.push(e[i]);return r},map:function(e,t,n){var r,i,o=0,a=[];if(G(e))for(r=e.length;o<r;o++)null!=(i=t(e[o],o,n))&&a.push(i);else for(o in e)null!=(i=t(e[o],o,n))&&a.push(i);return I(a)},guid:1,support:g}),"function"==typeof Symbol&&(E.fn[Symbol.iterator]=t[Symbol.iterator]),E.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(e,t){B["[object "+t+"]"]=t.toLowerCase()});var e=function(R){var e,p,b,o,M,h,I,W,w,u,l,T,C,n,E,g,r,i,y,S="sizzle"+ +new Date,c=R.document,k=0,F=0,B=q(),$=q(),_=q(),m=q(),z=function(e,t){return e===t&&(l=!0),0},U={}.hasOwnProperty,t=[],X=t.pop,V=t.push,A=t.push,G=t.slice,N=function(e,t){for(var n=0,r=e.length;n<r;n++)if(e[n]===t)return n;return-1},Y="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",a="[\\x20\\t\\r\\n\\f]",s="(?:\\\\[\\da-fA-F]{1,6}"+a+"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",Q="\\["+a+"*("+s+")(?:"+a+"*([*^$|!~]?=)"+a+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+s+"))|)"+a+"*\\]",J=":("+s+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+Q+")*)|.*)\\)|)",K=new RegExp(a+"+","g"),j=new RegExp("^"+a+"+|((?:^|[^\\\\])(?:\\\\.)*)"+a+"+$","g"),Z=new RegExp("^"+a+"*,"+a+"*"),ee=new RegExp("^"+a+"*([>+~]|"+a+")"+a+"*"),te=new RegExp(a+"|>"),ne=new RegExp(J),re=new RegExp("^"+s+"$"),f={ID:new RegExp("^#("+s+")"),CLASS:new RegExp("^\\.("+s+")"),TAG:new RegExp("^("+s+"|[*])"),ATTR:new RegExp("^"+Q),PSEUDO:new RegExp("^"+J),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+a+"*(even|odd|(([+-]|)(\\d*)n|)"+a+"*(?:([+-]|)"+a+"*(\\d+)|))"+a+"*\\)|)","i"),bool:new RegExp("^(?:"+Y+")$","i"),needsContext:new RegExp("^"+a+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+a+"*((?:-\\d)?\\d*)"+a+"*\\)|)(?=[^-]|$)","i")},ie=/HTML$/i,oe=/^(?:input|select|textarea|button)$/i,ae=/^h\d$/i,d=/^[^{]+\{\s*\[native \w/,se=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,ue=/[+~]/,v=new RegExp("\\\\[\\da-fA-F]{1,6}"+a+"?|\\\\([^\\r\\n\\f])","g"),x=function(e,t){e="0x"+e.slice(1)-65536;return t||(e<0?String.fromCharCode(65536+e):String.fromCharCode(e>>10|55296,1023&e|56320))},le=/([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,ce=function(e,t){return t?"\0"===e?"�":e.slice(0,-1)+"\\"+e.charCodeAt(e.length-1).toString(16)+" ":"\\"+e},fe=function(){T()},de=xe(function(e){return!0===e.disabled&&"fieldset"===e.nodeName.toLowerCase()},{dir:"parentNode",next:"legend"});try{A.apply(t=G.call(c.childNodes),c.childNodes),t[c.childNodes.length].nodeType}catch(P){A={apply:t.length?function(e,t){V.apply(e,G.call(t))}:function(e,t){for(var n=e.length,r=0;e[n++]=t[r++];);e.length=n-1}}}function D(e,t,n,r){var i,o,a,s,u,l,c=t&&t.ownerDocument,f=t?t.nodeType:9;if(n=n||[],"string"!=typeof e||!e||1!==f&&9!==f&&11!==f)return n;if(!r&&(T(t),t=t||C,E)){if(11!==f&&(s=se.exec(e)))if(i=s[1]){if(9===f){if(!(l=t.getElementById(i)))return n;if(l.id===i)return n.push(l),n}else if(c&&(l=c.getElementById(i))&&y(t,l)&&l.id===i)return n.push(l),n}else{if(s[2])return A.apply(n,t.getElementsByTagName(e)),n;if((i=s[3])&&p.getElementsByClassName&&t.getElementsByClassName)return A.apply(n,t.getElementsByClassName(i)),n}if(p.qsa&&!m[e+" "]&&(!g||!g.test(e))&&(1!==f||"object"!==t.nodeName.toLowerCase())){if(l=e,c=t,1===f&&(te.test(e)||ee.test(e))){for((c=ue.test(e)&&ye(t.parentNode)||t)===t&&p.scope||((a=t.getAttribute("id"))?a=a.replace(le,ce):t.setAttribute("id",a=S)),o=(u=h(e)).length;o--;)u[o]=(a?"#"+a:":scope")+" "+ve(u[o]);l=u.join(",")}try{return A.apply(n,c.querySelectorAll(l)),n}catch(d){m(e,!0)}finally{a===S&&t.removeAttribute("id")}}}return W(e.replace(j,"$1"),t,n,r)}function q(){var n=[];function r(e,t){return n.push(e+" ")>b.cacheLength&&delete r[n.shift()],r[e+" "]=t}return r}function L(e){return e[S]=!0,e}function H(e){var t=C.createElement("fieldset");try{return!!e(t)}catch(P){return!1}finally{t.parentNode&&t.parentNode.removeChild(t)}}function pe(e,t){for(var n=e.split("|"),r=n.length;r--;)b.attrHandle[n[r]]=t}function he(e,t){var n=t&&e,r=n&&1===e.nodeType&&1===t.nodeType&&e.sourceIndex-t.sourceIndex;if(r)return r;if(n)for(;n=n.nextSibling;)if(n===t)return-1;return e?1:-1}function ge(t){return function(e){return"form"in e?e.parentNode&&!1===e.disabled?"label"in e?"label"in e.parentNode?e.parentNode.disabled===t:e.disabled===t:e.isDisabled===t||e.isDisabled!==!t&&de(e)===t:e.disabled===t:"label"in e&&e.disabled===t}}function O(a){return L(function(o){return o=+o,L(function(e,t){for(var n,r=a([],e.length,o),i=r.length;i--;)e[n=r[i]]&&(e[n]=!(t[n]=e[n]))})})}function ye(e){return e&&"undefined"!=typeof e.getElementsByTagName&&e}for(e in p=D.support={},M=D.isXML=function(e){var t=e&&e.namespaceURI,e=e&&(e.ownerDocument||e).documentElement;return!ie.test(t||e&&e.nodeName||"HTML")},T=D.setDocument=function(e){var e=e?e.ownerDocument||e:c;return e!=C&&9===e.nodeType&&e.documentElement&&(n=(C=e).documentElement,E=!M(C),c!=C&&(e=C.defaultView)&&e.top!==e&&(e.addEventListener?e.addEventListener("unload",fe,!1):e.attachEvent&&e.attachEvent("onunload",fe)),p.scope=H(function(e){return n.appendChild(e).appendChild(C.createElement("div")),"undefined"!=typeof e.querySelectorAll&&!e.querySelectorAll(":scope fieldset div").length}),p.attributes=H(function(e){return e.className="i",!e.getAttribute("className")}),p.getElementsByTagName=H(function(e){return e.appendChild(C.createComment("")),!e.getElementsByTagName("*").length}),p.getElementsByClassName=d.test(C.getElementsByClassName),p.getById=H(function(e){return n.appendChild(e).id=S,!C.getElementsByName||!C.getElementsByName(S).length}),p.getById?(b.filter.ID=function(e){var t=e.replace(v,x);return function(e){return e.getAttribute("id")===t}},b.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&E)return(e=t.getElementById(e))?[e]:[]}):(b.filter.ID=function(e){var t=e.replace(v,x);return function(e){e="undefined"!=typeof e.getAttributeNode&&e.getAttributeNode("id");return e&&e.value===t}},b.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&E){var n,r,i,o=t.getElementById(e);if(o){if((n=o.getAttributeNode("id"))&&n.value===e)return[o];for(i=t.getElementsByName(e),r=0;o=i[r++];)if((n=o.getAttributeNode("id"))&&n.value===e)return[o]}return[]}}),b.find.TAG=p.getElementsByTagName?function(e,t){return"undefined"!=typeof t.getElementsByTagName?t.getElementsByTagName(e):p.qsa?t.querySelectorAll(e):void 0}:function(e,t){var n,r=[],i=0,o=t.getElementsByTagName(e);if("*"!==e)return o;for(;n=o[i++];)1===n.nodeType&&r.push(n);return r},b.find.CLASS=p.getElementsByClassName&&function(e,t){if("undefined"!=typeof t.getElementsByClassName&&E)return t.getElementsByClassName(e)},r=[],g=[],(p.qsa=d.test(C.querySelectorAll))&&(H(function(e){var t;n.appendChild(e).innerHTML="<a id='"+S+"'></a><select id='"+S+"-\r\\' msallowcapture=''><option selected=''></option></select>",e.querySelectorAll("[msallowcapture^='']").length&&g.push("[*^$]="+a+"*(?:''|\"\")"),e.querySelectorAll("[selected]").length||g.push("\\["+a+"*(?:value|"+Y+")"),e.querySelectorAll("[id~="+S+"-]").length||g.push("~="),(t=C.createElement("input")).setAttribute("name",""),e.appendChild(t),e.querySelectorAll("[name='']").length||g.push("\\["+a+"*name"+a+"*="+a+"*(?:''|\"\")"),e.querySelectorAll(":checked").length||g.push(":checked"),e.querySelectorAll("a#"+S+"+*").length||g.push(".#.+[+~]"),e.querySelectorAll("\\\f"),g.push("[\\r\\n\\f]")}),H(function(e){e.innerHTML="<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";var t=C.createElement("input");t.setAttribute("type","hidden"),e.appendChild(t).setAttribute("name","D"),e.querySelectorAll("[name=d]").length&&g.push("name"+a+"*[*^$|!~]?="),2!==e.querySelectorAll(":enabled").length&&g.push(":enabled",":disabled"),n.appendChild(e).disabled=!0,2!==e.querySelectorAll(":disabled").length&&g.push(":enabled",":disabled"),e.querySelectorAll("*,:x"),g.push(",.*:")})),(p.matchesSelector=d.test(i=n.matches||n.webkitMatchesSelector||n.mozMatchesSelector||n.oMatchesSelector||n.msMatchesSelector))&&H(function(e){p.disconnectedMatch=i.call(e,"*"),i.call(e,"[s!='']:x"),r.push("!=",J)}),g=g.length&&new RegExp(g.join("|")),r=r.length&&new RegExp(r.join("|")),e=d.test(n.compareDocumentPosition),y=e||d.test(n.contains)?function(e,t){var n=9===e.nodeType?e.documentElement:e,t=t&&t.parentNode;return e===t||!(!t||1!==t.nodeType||!(n.contains?n.contains(t):e.compareDocumentPosition&&16&e.compareDocumentPosition(t)))}:function(e,t){if(t)for(;t=t.parentNode;)if(t===e)return!0;return!1},z=e?function(e,t){var n;return e===t?(l=!0,0):(n=!e.compareDocumentPosition-!t.compareDocumentPosition)||(1&(n=(e.ownerDocument||e)==(t.ownerDocument||t)?e.compareDocumentPosition(t):1)||!p.sortDetached&&t.compareDocumentPosition(e)===n?e==C||e.ownerDocument==c&&y(c,e)?-1:t==C||t.ownerDocument==c&&y(c,t)?1:u?N(u,e)-N(u,t):0:4&n?-1:1)}:function(e,t){if(e===t)return l=!0,0;var n,r=0,i=e.parentNode,o=t.parentNode,a=[e],s=[t];if(!i||!o)return e==C?-1:t==C?1:i?-1:o?1:u?N(u,e)-N(u,t):0;if(i===o)return he(e,t);for(n=e;n=n.parentNode;)a.unshift(n);for(n=t;n=n.parentNode;)s.unshift(n);for(;a[r]===s[r];)r++;return r?he(a[r],s[r]):a[r]==c?-1:s[r]==c?1:0}),C},D.matches=function(e,t){return D(e,null,null,t)},D.matchesSelector=function(e,t){if(T(e),p.matchesSelector&&E&&!m[t+" "]&&(!r||!r.test(t))&&(!g||!g.test(t)))try{var n=i.call(e,t);if(n||p.disconnectedMatch||e.document&&11!==e.document.nodeType)return n}catch(P){m(t,!0)}return 0<D(t,C,null,[e]).length},D.contains=function(e,t){return(e.ownerDocument||e)!=C&&T(e),y(e,t)},D.attr=function(e,t){(e.ownerDocument||e)!=C&&T(e);var n=b.attrHandle[t.toLowerCase()],n=n&&U.call(b.attrHandle,t.toLowerCase())?n(e,t,!E):undefined;return n!==undefined?n:p.attributes||!E?e.getAttribute(t):(n=e.getAttributeNode(t))&&n.specified?n.value:null},D.escape=function(e){return(e+"").replace(le,ce)},D.error=function(e){throw new Error("Syntax error, unrecognized expression: "+e)},D.uniqueSort=function(e){var t,n=[],r=0,i=0;if(l=!p.detectDuplicates,u=!p.sortStable&&e.slice(0),e.sort(z),l){for(;t=e[i++];)t===e[i]&&(r=n.push(i));for(;r--;)e.splice(n[r],1)}return u=null,e},o=D.getText=function(e){var t,n="",r=0,i=e.nodeType;if(i){if(1===i||9===i||11===i){if("string"==typeof e.textContent)return e.textContent;for(e=e.firstChild;e;e=e.nextSibling)n+=o(e)}else if(3===i||4===i)return e.nodeValue}else for(;t=e[r++];)n+=o(t);return n},(b=D.selectors={cacheLength:50,createPseudo:L,match:f,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(e){return e[1]=e[1].replace(v,x),e[3]=(e[3]||e[4]||e[5]||"").replace(v,x),"~="===e[2]&&(e[3]=" "+e[3]+" "),e.slice(0,4)},CHILD:function(e){return e[1]=e[1].toLowerCase(),"nth"===e[1].slice(0,3)?(e[3]||D.error(e[0]),e[4]=+(e[4]?e[5]+(e[6]||1):2*("even"===e[3]||"odd"===e[3])),e[5]=+(e[7]+e[8]||"odd"===e[3])):e[3]&&D.error(e[0]),e},PSEUDO:function(e){var t,n=!e[6]&&e[2];return f.CHILD.test(e[0])?null:(e[3]?e[2]=e[4]||e[5]||"":n&&ne.test(n)&&(t=(t=h(n,!0))&&n.indexOf(")",n.length-t)-n.length)&&(e[0]=e[0].slice(0,t),e[2]=n.slice(0,t)),e.slice(0,3))}},filter:{TAG:function(e){var t=e.replace(v,x).toLowerCase();return"*"===e?function(){return!0}:function(e){return e.nodeName&&e.nodeName.toLowerCase()===t}},CLASS:function(e){var t=B[e+" "];return t||(t=new RegExp("(^|"+a+")"+e+"("+a+"|$)"))&&B(e,function(e){return t.test("string"==typeof e.className&&e.className||"undefined"!=typeof e.getAttribute&&e.getAttribute("class")||"")})},ATTR:function(t,n,r){return function(e){e=D.attr(e,t);return null==e?"!="===n:!n||(e+="","="===n?e===r:"!="===n?e!==r:"^="===n?r&&0===e.indexOf(r):"*="===n?r&&-1<e.indexOf(r):"$="===n?r&&e.slice(-r.length)===r:"~="===n?-1<(" "+e.replace(K," ")+" ").indexOf(r):"|="===n&&(e===r||e.slice(0,r.length+1)===r+"-"))}},CHILD:function(h,e,t,g,y){var m="nth"!==h.slice(0,3),v="last"!==h.slice(-4),x="of-type"===e;return 1===g&&0===y?function(e){return!!e.parentNode}:function(e,t,n){var r,i,o,a,s,u,l=m!=v?"nextSibling":"previousSibling",c=e.parentNode,f=x&&e.nodeName.toLowerCase(),d=!n&&!x,p=!1;if(c){if(m){for(;l;){for(a=e;a=a[l];)if(x?a.nodeName.toLowerCase()===f:1===a.nodeType)return!1;u=l="only"===h&&!u&&"nextSibling"}return!0}if(u=[v?c.firstChild:c.lastChild],v&&d){for(p=(s=(r=(i=(o=(a=c)[S]||(a[S]={}))[a.uniqueID]||(o[a.uniqueID]={}))[h]||[])[0]===k&&r[1])&&r[2],a=s&&c.childNodes[s];a=++s&&a&&a[l]||(p=s=0,u.pop());)if(1===a.nodeType&&++p&&a===e){i[h]=[k,s,p];break}}else if(!1===(p=d?s=(r=(i=(o=(a=e)[S]||(a[S]={}))[a.uniqueID]||(o[a.uniqueID]={}))[h]||[])[0]===k&&r[1]:p))for(;(a=++s&&a&&a[l]||(p=s=0,u.pop()))&&((x?a.nodeName.toLowerCase()!==f:1!==a.nodeType)||!++p||(d&&((i=(o=a[S]||(a[S]={}))[a.uniqueID]||(o[a.uniqueID]={}))[h]=[k,p]),a!==e)););return(p-=y)===g||p%g==0&&0<=p/g}}},PSEUDO:function(e,o){var t,a=b.pseudos[e]||b.setFilters[e.toLowerCase()]||D.error("unsupported pseudo: "+e);return a[S]?a(o):1<a.length?(t=[e,e,"",o],b.setFilters.hasOwnProperty(e.toLowerCase())?L(function(e,t){for(var n,r=a(e,o),i=r.length;i--;)e[n=N(e,r[i])]=!(t[n]=r[i])}):function(e){return a(e,0,t)}):a}},pseudos:{not:L(function(e){var r=[],i=[],s=I(e.replace(j,"$1"));return s[S]?L(function(e,t,n,r){for(var i,o=s(e,null,r,[]),a=e.length;a--;)(i=o[a])&&(e[a]=!(t[a]=i))}):function(e,t,n){return r[0]=e,s(r,null,n,i),r[0]=null,!i.pop()}}),has:L(function(t){return function(e){return 0<D(t,e).length}}),contains:L(function(t){return t=t.replace(v,x),function(e){return-1<(e.textContent||o(e)).indexOf(t)}}),lang:L(function(n){return re.test(n||"")||D.error("unsupported lang: "+n),n=n.replace(v,x).toLowerCase(),function(e){var t;do{if(t=E?e.lang:e.getAttribute("xml:lang")||e.getAttribute("lang"))return(t=t.toLowerCase())===n||0===t.indexOf(n+"-")}while((e=e.parentNode)&&1===e.nodeType);return!1}}),target:function(e){var t=R.location&&R.location.hash;return t&&t.slice(1)===e.id},root:function(e){return e===n},focus:function(e){return e===C.activeElement&&(!C.hasFocus||C.hasFocus())&&!!(e.type||e.href||~e.tabIndex)},enabled:ge(!1),disabled:ge(!0),checked:function(e){var t=e.nodeName.toLowerCase();return"input"===t&&!!e.checked||"option"===t&&!!e.selected},selected:function(e){return e.parentNode&&e.parentNode.selectedIndex,!0===e.selected},empty:function(e){for(e=e.firstChild;e;e=e.nextSibling)if(e.nodeType<6)return!1;return!0},parent:function(e){return!b.pseudos.empty(e)},header:function(e){return ae.test(e.nodeName)},input:function(e){return oe.test(e.nodeName)},button:function(e){var t=e.nodeName.toLowerCase();return"input"===t&&"button"===e.type||"button"===t},text:function(e){return"input"===e.nodeName.toLowerCase()&&"text"===e.type&&(null==(e=e.getAttribute("type"))||"text"===e.toLowerCase())},first:O(function(){return[0]}),last:O(function(e,t){return[t-1]}),eq:O(function(e,t,n){return[n<0?n+t:n]}),even:O(function(e,t){for(var n=0;n<t;n+=2)e.push(n);return e}),odd:O(function(e,t){for(var n=1;n<t;n+=2)e.push(n);return e}),lt:O(function(e,t,n){for(var r=n<0?n+t:t<n?t:n;0<=--r;)e.push(r);return e}),gt:O(function(e,t,n){for(var r=n<0?n+t:n;++r<t;)e.push(r);return e})}}).pseudos.nth=b.pseudos.eq,{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})b.pseudos[e]=function(t){return function(e){return"input"===e.nodeName.toLowerCase()&&e.type===t}}(e);for(e in{submit:!0,reset:!0})b.pseudos[e]=function(n){return function(e){var t=e.nodeName.toLowerCase();return("input"===t||"button"===t)&&e.type===n}}(e);function me(){}function ve(e){for(var t=0,n=e.length,r="";t<n;t++)r+=e[t].value;return r}function xe(a,e,t){var s=e.dir,u=e.next,l=u||s,c=t&&"parentNode"===l,f=F++;return e.first?function(e,t,n){for(;e=e[s];)if(1===e.nodeType||c)return a(e,t,n);return!1}:function(e,t,n){var r,i,o=[k,f];if(n){for(;e=e[s];)if((1===e.nodeType||c)&&a(e,t,n))return!0}else for(;e=e[s];)if(1===e.nodeType||c)if(i=(i=e[S]||(e[S]={}))[e.uniqueID]||(i[e.uniqueID]={}),u&&u===e.nodeName.toLowerCase())e=e[s]||e;else{if((r=i[l])&&r[0]===k&&r[1]===f)return o[2]=r[2];if((i[l]=o)[2]=a(e,t,n))return!0}return!1}}function be(i){return 1<i.length?function(e,t,n){for(var r=i.length;r--;)if(!i[r](e,t,n))return!1;return!0}:i[0]}function we(e,t,n,r,i){for(var o,a=[],s=0,u=e.length,l=null!=t;s<u;s++)!(o=e[s])||n&&!n(o,r,i)||(a.push(o),l&&t.push(s));return a}function Te(p,h,g,y,m,e){return y&&!y[S]&&(y=Te(y)),m&&!m[S]&&(m=Te(m,e)),L(function(e,t,n,r){var i,o,a,s=[],u=[],l=t.length,c=e||function(e,t,n){for(var r=0,i=t.length;r<i;r++)D(e,t[r],n);return n}(h||"*",n.nodeType?[n]:n,[]),f=!p||!e&&h?c:we(c,s,p,n,r),d=g?m||(e?p:l||y)?[]:t:f;if(g&&g(f,d,n,r),y)for(i=we(d,u),y(i,[],n,r),o=i.length;o--;)(a=i[o])&&(d[u[o]]=!(f[u[o]]=a));if(e){if(m||p){if(m){for(i=[],o=d.length;o--;)(a=d[o])&&i.push(f[o]=a);m(null,d=[],i,r)}for(o=d.length;o--;)(a=d[o])&&-1<(i=m?N(e,a):s[o])&&(e[i]=!(t[i]=a))}}else d=we(d===t?d.splice(l,d.length):d),m?m(null,t,d,r):A.apply(t,d)})}return me.prototype=b.filters=b.pseudos,b.setFilters=new me,h=D.tokenize=function(e,t){var n,r,i,o,a,s,u,l=$[e+" "];if(l)return t?0:l.slice(0);for(a=e,s=[],u=b.preFilter;a;){for(o in n&&!(r=Z.exec(a))||(r&&(a=a.slice(r[0].length)||a),s.push(i=[])),n=!1,(r=ee.exec(a))&&(n=r.shift(),i.push({value:n,type:r[0].replace(j," ")}),a=a.slice(n.length)),b.filter)!(r=f[o].exec(a))||u[o]&&!(r=u[o](r))||(n=r.shift(),i.push({value:n,type:o,matches:r}),a=a.slice(n.length));if(!n)break}return t?a.length:a?D.error(e):$(e,s).slice(0)},I=D.compile=function(e,t){var n,y,m,v,x,r,i=[],o=[],a=_[e+" "];if(!a){for(n=(t=t||h(e)).length;n--;)((a=function f(e){for(var r,t,n,i=e.length,o=b.relative[e[0].type],a=o||b.relative[" "],s=o?1:0,u=xe(function(e){return e===r},a,!0),l=xe(function(e){return-1<N(r,e)},a,!0),c=[function(e,t,n){return e=!o&&(n||t!==w)||((r=t).nodeType?u:l)(e,t,n),r=null,e}];s<i;s++)if(t=b.relative[e[s].type])c=[xe(be(c),t)];else{if((t=b.filter[e[s].type].apply(null,e[s].matches))[S]){for(n=++s;n<i&&!b.relative[e[n].type];n++);return Te(1<s&&be(c),1<s&&ve(e.slice(0,s-1).concat({value:" "===e[s-2].type?"*":""})).replace(j,"$1"),t,s<n&&f(e.slice(s,n)),n<i&&f(e=e.slice(n)),n<i&&ve(e))}c.push(t)}return be(c)}(t[n]))[S]?i:o).push(a);(a=_(e,(y=o,v=0<(m=i).length,x=0<y.length,r=function(e,t,n,r,i){var o,a,s,u=0,l="0",c=e&&[],f=[],d=w,p=e||x&&b.find.TAG("*",i),h=k+=null==d?1:Math.random()||.1,g=p.length;for(i&&(w=t==C||t||i);l!==g&&null!=(o=p[l]);l++){if(x&&o){for(a=0,t||o.ownerDocument==C||(T(o),n=!E);s=y[a++];)if(s(o,t||C,n)){r.push(o);break}i&&(k=h)}v&&((o=!s&&o)&&u--,e)&&c.push(o)}if(u+=l,v&&l!==u){for(a=0;s=m[a++];)s(c,f,t,n);if(e){if(0<u)for(;l--;)c[l]||f[l]||(f[l]=X.call(r));f=we(f)}A.apply(r,f),i&&!e&&0<f.length&&1<u+m.length&&D.uniqueSort(r)}return i&&(k=h,w=d),c},v?L(r):r))).selector=e}return a},W=D.select=function(e,t,n,r){var i,o,a,s,u,l="function"==typeof e&&e,c=!r&&h(e=l.selector||e);if(n=n||[],1===c.length){if(2<(o=c[0]=c[0].slice(0)).length&&"ID"===(a=o[0]).type&&9===t.nodeType&&E&&b.relative[o[1].type]){if(!(t=(b.find.ID(a.matches[0].replace(v,x),t)||[])[0]))return n;l&&(t=t.parentNode),e=e.slice(o.shift().value.length)}for(i=f.needsContext.test(e)?0:o.length;i--&&(a=o[i],!b.relative[s=a.type]);)if((u=b.find[s])&&(r=u(a.matches[0].replace(v,x),ue.test(o[0].type)&&ye(t.parentNode)||t))){if(o.splice(i,1),e=r.length&&ve(o))break;return A.apply(n,r),n}}return(l||I(e,c))(r,t,!E,n,!t||ue.test(e)&&ye(t.parentNode)||t),n},p.sortStable=S.split("").sort(z).join("")===S,p.detectDuplicates=!!l,T(),p.sortDetached=H(function(e){return 1&e.compareDocumentPosition(C.createElement("fieldset"))}),H(function(e){return e.innerHTML="<a href='#'></a>","#"===e.firstChild.getAttribute("href")})||pe("type|href|height|width",function(e,t,n){if(!n)return e.getAttribute(t,"type"===t.toLowerCase()?1:2)}),p.attributes&&H(function(e){return e.innerHTML="<input/>",e.firstChild.setAttribute("value",""),""===e.firstChild.getAttribute("value")})||pe("value",function(e,t,n){if(!n&&"input"===e.nodeName.toLowerCase())return e.defaultValue}),H(function(e){return null==e.getAttribute("disabled")})||pe(Y,function(e,t,n){if(!n)return!0===e[t]?t.toLowerCase():(n=e.getAttributeNode(t))&&n.specified?n.value:null}),D}(T),r=(E.find=e,E.expr=e.selectors,E.expr[":"]=E.expr.pseudos,E.uniqueSort=E.unique=e.uniqueSort,E.text=e.getText,E.isXMLDoc=e.isXML,E.contains=e.contains,E.escapeSelector=e.escape,function(e,t,n){for(var r=[],i=n!==undefined;(e=e[t])&&9!==e.nodeType;)if(1===e.nodeType){if(i&&E(e).is(n))break;r.push(e)}return r}),Y=function(e,t){for(var n=[];e;e=e.nextSibling)1===e.nodeType&&e!==t&&n.push(e);return n},Q=E.expr.match.needsContext;function u(e,t){return e.nodeName&&e.nodeName.toLowerCase()===t.toLowerCase()}var J=/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;function K(e,n,r){return v(n)?E.grep(e,function(e,t){return!!n.call(e,t,e)!==r}):n.nodeType?E.grep(e,function(e){return e===n!==r}):"string"!=typeof n?E.grep(e,function(e){return-1<F.call(n,e)!==r}):E.filter(n,e,r)}E.filter=function(e,t,n){var r=t[0];return n&&(e=":not("+e+")"),1===t.length&&1===r.nodeType?E.find.matchesSelector(r,e)?[r]:[]:E.find.matches(e,E.grep(t,function(e){return 1===e.nodeType}))},E.fn.extend({find:function(e){var t,n,r=this.length,i=this;if("string"!=typeof e)return this.pushStack(E(e).filter(function(){for(t=0;t<r;t++)if(E.contains(i[t],this))return!0}));for(n=this.pushStack([]),t=0;t<r;t++)E.find(e,i[t],n);return 1<r?E.uniqueSort(n):n},filter:function(e){return this.pushStack(K(this,e||[],!1))},not:function(e){return this.pushStack(K(this,e||[],!0))},is:function(e){return!!K(this,"string"==typeof e&&Q.test(e)?E(e):e||[],!1).length}});var Z,ee=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,te=((E.fn.init=function(e,t,n){if(e){if(n=n||Z,"string"!=typeof e)return e.nodeType?(this[0]=e,this.length=1,this):v(e)?n.ready!==undefined?n.ready(e):e(E):E.makeArray(e,this);if(!(r="<"===e[0]&&">"===e[e.length-1]&&3<=e.length?[null,e,null]:ee.exec(e))||!r[1]&&t)return(!t||t.jquery?t||n:this.constructor(t)).find(e);if(r[1]){if(t=t instanceof E?t[0]:t,E.merge(this,E.parseHTML(r[1],t&&t.nodeType?t.ownerDocument||t:C,!0)),J.test(r[1])&&E.isPlainObject(t))for(var r in t)v(this[r])?this[r](t[r]):this.attr(r,t[r])}else(n=C.getElementById(r[2]))&&(this[0]=n,this.length=1)}return this}).prototype=E.fn,Z=E(C),/^(?:parents|prev(?:Until|All))/),ne={children:!0,contents:!0,next:!0,prev:!0};function re(e,t){for(;(e=e[t])&&1!==e.nodeType;);return e}E.fn.extend({has:function(e){var t=E(e,this),n=t.length;return this.filter(function(){for(var e=0;e<n;e++)if(E.contains(this,t[e]))return!0})},closest:function(e,t){var n,r=0,i=this.length,o=[],a="string"!=typeof e&&E(e);if(!Q.test(e))for(;r<i;r++)for(n=this[r];n&&n!==t;n=n.parentNode)if(n.nodeType<11&&(a?-1<a.index(n):1===n.nodeType&&E.find.matchesSelector(n,e))){o.push(n);break}return this.pushStack(1<o.length?E.uniqueSort(o):o)},index:function(e){return e?"string"==typeof e?F.call(E(e),this[0]):F.call(this,e.jquery?e[0]:e):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(e,t){return this.pushStack(E.uniqueSort(E.merge(this.get(),E(e,t))))},addBack:function(e){return this.add(null==e?this.prevObject:this.prevObject.filter(e))}}),E.each({parent:function(e){e=e.parentNode;return e&&11!==e.nodeType?e:null},parents:function(e){return r(e,"parentNode")},parentsUntil:function(e,t,n){return r(e,"parentNode",n)},next:function(e){return re(e,"nextSibling")},prev:function(e){return re(e,"previousSibling")},nextAll:function(e){return r(e,"nextSibling")},prevAll:function(e){return r(e,"previousSibling")},nextUntil:function(e,t,n){return r(e,"nextSibling",n)},prevUntil:function(e,t,n){return r(e,"previousSibling",n)},siblings:function(e){return Y((e.parentNode||{}).firstChild,e)},children:function(e){return Y(e.firstChild)},contents:function(e){return null!=e.contentDocument&&M(e.contentDocument)?e.contentDocument:(u(e,"template")&&(e=e.content||e),E.merge([],e.childNodes))}},function(r,i){E.fn[r]=function(e,t){var n=E.map(this,i,e);return(t="Until"!==r.slice(-5)?e:t)&&"string"==typeof t&&(n=E.filter(t,n)),1<this.length&&(ne[r]||E.uniqueSort(n),te.test(r))&&n.reverse(),this.pushStack(n)}});var S=/[^\x20\t\r\n\f]+/g;function f(e){return e}function ie(e){throw e}function oe(e,t,n,r){var i;try{e&&v(i=e.promise)?i.call(e).done(t).fail(n):e&&v(i=e.then)?i.call(e,t,n):t.apply(undefined,[e].slice(r))}catch(e){n.apply(undefined,[e])}}E.Callbacks=function(r){var e,n;r="string"==typeof r?(e=r,n={},E.each(e.match(S)||[],function(e,t){n[t]=!0}),n):E.extend({},r);var i,t,o,a,s=[],u=[],l=-1,c=function(){for(a=a||r.once,o=i=!0;u.length;l=-1)for(t=u.shift();++l<s.length;)!1===s[l].apply(t[0],t[1])&&r.stopOnFalse&&(l=s.length,t=!1);r.memory||(t=!1),i=!1,a&&(s=t?[]:"")},f={add:function(){return s&&(t&&!i&&(l=s.length-1,u.push(t)),function n(e){E.each(e,function(e,t){v(t)?r.unique&&f.has(t)||s.push(t):t&&t.length&&"string"!==h(t)&&n(t)})}(arguments),t)&&!i&&c(),this},remove:function(){return E.each(arguments,function(e,t){for(var n;-1<(n=E.inArray(t,s,n));)s.splice(n,1),n<=l&&l--}),this},has:function(e){return e?-1<E.inArray(e,s):0<s.length},empty:function(){return s=s&&[],this},disable:function(){return a=u=[],s=t="",this},disabled:function(){return!s},lock:function(){return a=u=[],t||i||(s=t=""),this},locked:function(){return!!a},fireWith:function(e,t){return a||(t=[e,(t=t||[]).slice?t.slice():t],u.push(t),i)||c(),this},fire:function(){return f.fireWith(this,arguments),this},fired:function(){return!!o}};return f},E.extend({Deferred:function(e){var o=[["notify","progress",E.Callbacks("memory"),E.Callbacks("memory"),2],["resolve","done",E.Callbacks("once memory"),E.Callbacks("once memory"),0,"resolved"],["reject","fail",E.Callbacks("once memory"),E.Callbacks("once memory"),1,"rejected"]],i="pending",a={state:function(){return i},always:function(){return s.done(arguments).fail(arguments),this},"catch":function(e){return a.then(null,e)},pipe:function(){var i=arguments;return E.Deferred(function(r){E.each(o,function(e,t){var n=v(i[t[4]])&&i[t[4]];s[t[1]](function(){var e=n&&n.apply(this,arguments);e&&v(e.promise)?e.promise().progress(r.notify).done(r.resolve).fail(r.reject):r[t[0]+"With"](this,n?[e]:arguments)})}),i=null}).promise()},then:function(t,n,r){var l=0;function c(o,a,s,u){return function(){var n=this,r=arguments,t=function(){var e,t;if(!(o<l)){if((e=s.apply(n,r))===a.promise())throw new TypeError("Thenable self-resolution");t=e&&("object"==typeof e||"function"==typeof e)&&e.then,v(t)?u?t.call(e,c(l,a,f,u),c(l,a,ie,u)):(l++,t.call(e,c(l,a,f,u),c(l,a,ie,u),c(l,a,f,a.notifyWith))):(s!==f&&(n=undefined,r=[e]),(u||a.resolveWith)(n,r))}},i=u?t:function(){try{t()}catch(e){E.Deferred.exceptionHook&&E.Deferred.exceptionHook(e,i.stackTrace),l<=o+1&&(s!==ie&&(n=undefined,r=[e]),a.rejectWith(n,r))}};o?i():(E.Deferred.getStackHook&&(i.stackTrace=E.Deferred.getStackHook()),T.setTimeout(i))}}return E.Deferred(function(e){o[0][3].add(c(0,e,v(r)?r:f,e.notifyWith)),o[1][3].add(c(0,e,v(t)?t:f)),o[2][3].add(c(0,e,v(n)?n:ie))}).promise()},promise:function(e){return null!=e?E.extend(e,a):a}},s={};return E.each(o,function(e,t){var n=t[2],r=t[5];a[t[1]]=n.add,r&&n.add(function(){i=r},o[3-e][2].disable,o[3-e][3].disable,o[0][2].lock,o[0][3].lock),n.add(t[3].fire),s[t[0]]=function(){return s[t[0]+"With"](this===s?undefined:this,arguments),this},s[t[0]+"With"]=n.fireWith}),a.promise(s),e&&e.call(s,s),s},when:function(e){var n=arguments.length,t=n,r=Array(t),i=s.call(arguments),o=E.Deferred(),a=function(t){return function(e){r[t]=this,i[t]=1<arguments.length?s.call(arguments):e,--n||o.resolveWith(r,i)}};if(n<=1&&(oe(e,o.done(a(t)).resolve,o.reject,!n),"pending"===o.state()||v(i[t]&&i[t].then)))return o.then();for(;t--;)oe(i[t],a(t),o.reject);return o.promise()}});var ae=/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/,se=(E.Deferred.exceptionHook=function(e,t){T.console&&T.console.warn&&e&&ae.test(e.name)&&T.console.warn("jQuery.Deferred exception: "+e.message,e.stack,t)},E.readyException=function(e){T.setTimeout(function(){throw e})},E.Deferred());function ue(){C.removeEventListener("DOMContentLoaded",ue),T.removeEventListener("load",ue),E.ready()}E.fn.ready=function(e){return se.then(e)["catch"](function(e){E.readyException(e)}),this},E.extend({isReady:!1,readyWait:1,ready:function(e){(!0===e?--E.readyWait:E.isReady)||(E.isReady=!0)!==e&&0<--E.readyWait||se.resolveWith(C,[E])}}),E.ready.then=se.then,"complete"===C.readyState||"loading"!==C.readyState&&!C.documentElement.doScroll?T.setTimeout(E.ready):(C.addEventListener("DOMContentLoaded",ue),T.addEventListener("load",ue));var c=function(e,t,n,r,i,o,a){var s=0,u=e.length,l=null==n;if("object"===h(n))for(s in i=!0,n)c(e,t,s,n[s],!0,o,a);else if(r!==undefined&&(i=!0,v(r)||(a=!0),t=l?a?(t.call(e,r),null):(l=t,function(e,t,n){return l.call(E(e),n)}):t))for(;s<u;s++)t(e[s],n,a?r:r.call(e[s],s,t(e[s],n)));return i?e:l?t.call(e):u?t(e[0],n):o},le=/^-ms-/,ce=/-([a-z])/g;function fe(e,t){return t.toUpperCase()}function x(e){return e.replace(le,"ms-").replace(ce,fe)}var m=function(e){return 1===e.nodeType||9===e.nodeType||!+e.nodeType};function de(){this.expando=E.expando+de.uid++}de.uid=1,de.prototype={cache:function(e){var t=e[this.expando];return t||(t={},m(e)&&(e.nodeType?e[this.expando]=t:Object.defineProperty(e,this.expando,{value:t,configurable:!0}))),t},set:function(e,t,n){var r,i=this.cache(e);if("string"==typeof t)i[x(t)]=n;else for(r in t)i[x(r)]=t[r];return i},get:function(e,t){return t===undefined?this.cache(e):e[this.expando]&&e[this.expando][x(t)]},access:function(e,t,n){return t===undefined||t&&"string"==typeof t&&n===undefined?this.get(e,t):(this.set(e,t,n),n!==undefined?n:t)},remove:function(e,t){var n,r=e[this.expando];if(r!==undefined){if(t!==undefined){n=(t=Array.isArray(t)?t.map(x):(t=x(t))in r?[t]:t.match(S)||[]).length;for(;n--;)delete r[t[n]]}t!==undefined&&!E.isEmptyObject(r)||(e.nodeType?e[this.expando]=undefined:delete e[this.expando])}},hasData:function(e){e=e[this.expando];return e!==undefined&&!E.isEmptyObject(e)}};var b=new de,l=new de,pe=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,he=/[A-Z]/g;function ge(e,t,n){var r,i;if(n===undefined&&1===e.nodeType)if(r="data-"+t.replace(he,"-$&").toLowerCase(),"string"==typeof(n=e.getAttribute(r))){try{n="true"===(i=n)||"false"!==i&&("null"===i?null:i===+i+""?+i:pe.test(i)?JSON.parse(i):i)}catch(o){}l.set(e,t,n)}else n=undefined;return n}E.extend({hasData:function(e){return l.hasData(e)||b.hasData(e)},data:function(e,t,n){return l.access(e,t,n)},removeData:function(e,t){l.remove(e,t)},_data:function(e,t,n){return b.access(e,t,n)},_removeData:function(e,t){b.remove(e,t)}}),E.fn.extend({data:function(n,e){var t,r,i,o=this[0],a=o&&o.attributes;if(n!==undefined)return"object"==typeof n?this.each(function(){l.set(this,n)}):c(this,function(e){var t;if(o&&e===undefined)return(t=l.get(o,n))!==undefined||(t=ge(o,n))!==undefined?t:void 0;this.each(function(){l.set(this,n,e)})},null,e,1<arguments.length,null,!0);if(this.length&&(i=l.get(o),1===o.nodeType)&&!b.get(o,"hasDataAttrs")){for(t=a.length;t--;)a[t]&&0===(r=a[t].name).indexOf("data-")&&(r=x(r.slice(5)),ge(o,r,i[r]));b.set(o,"hasDataAttrs",!0)}return i},removeData:function(e){return this.each(function(){l.remove(this,e)})}}),E.extend({queue:function(e,t,n){var r;if(e)return r=b.get(e,t=(t||"fx")+"queue"),n&&(!r||Array.isArray(n)?r=b.access(e,t,E.makeArray(n)):r.push(n)),r||[]},dequeue:function(e,t){t=t||"fx";var n=E.queue(e,t),r=n.length,i=n.shift(),o=E._queueHooks(e,t);"inprogress"===i&&(i=n.shift(),r--),i&&("fx"===t&&n.unshift("inprogress"),delete o.stop,i.call(e,function(){E.dequeue(e,t)},o)),!r&&o&&o.empty.fire()},_queueHooks:function(e,t){var n=t+"queueHooks";return b.get(e,n)||b.access(e,n,{empty:E.Callbacks("once memory").add(function(){b.remove(e,[t+"queue",n])})})}}),E.fn.extend({queue:function(t,n){var e=2;return"string"!=typeof t&&(n=t,t="fx",e--),arguments.length<e?E.queue(this[0],t):n===undefined?this:this.each(function(){var e=E.queue(this,t,n);E._queueHooks(this,t),"fx"===t&&"inprogress"!==e[0]&&E.dequeue(this,t)})},dequeue:function(e){return this.each(function(){E.dequeue(this,e)})},clearQueue:function(e){return this.queue(e||"fx",[])},promise:function(e,t){var n,r=1,i=E.Deferred(),o=this,a=this.length,s=function(){--r||i.resolveWith(o,[o])};for("string"!=typeof e&&(t=e,e=undefined),e=e||"fx";a--;)(n=b.get(o[a],e+"queueHooks"))&&n.empty&&(r++,n.empty.add(s));return s(),i.promise(t)}});var e=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,ye=new RegExp("^(?:([+-])=|)("+e+")([a-z%]*)$","i"),d=["Top","Right","Bottom","Left"],w=C.documentElement,k=function(e){return E.contains(e.ownerDocument,e)},me={composed:!0},ve=(w.getRootNode&&(k=function(e){return E.contains(e.ownerDocument,e)||e.getRootNode(me)===e.ownerDocument}),function(e,t){return"none"===(e=t||e).style.display||""===e.style.display&&k(e)&&"none"===E.css(e,"display")});function xe(e,t,n,r){var i,o,a=20,s=r?function(){return r.cur()}:function(){return E.css(e,t,"")},u=s(),l=n&&n[3]||(E.cssNumber[t]?"":"px"),c=e.nodeType&&(E.cssNumber[t]||"px"!==l&&+u)&&ye.exec(E.css(e,t));if(c&&c[3]!==l){for(l=l||c[3],c=+(u/=2)||1;a--;)E.style(e,t,c+l),(1-o)*(1-(o=s()/u||.5))<=0&&(a=0),c/=o;E.style(e,t,(c*=2)+l),n=n||[]}return n&&(c=+c||+u||0,i=n[1]?c+(n[1]+1)*n[2]:+n[2],r)&&(r.unit=l,r.start=c,r.end=i),i}var be={};function A(e,t){for(var n,r,i,o,a,s=[],u=0,l=e.length;u<l;u++)(r=e[u]).style&&(n=r.style.display,t?("none"===n&&(s[u]=b.get(r,"display")||null,s[u]||(r.style.display="")),""===r.style.display&&ve(r)&&(s[u]=(a=o=void 0,o=(i=r).ownerDocument,i=i.nodeName,(a=be[i])||(o=o.body.appendChild(o.createElement(i)),a=E.css(o,"display"),o.parentNode.removeChild(o),be[i]=a="none"===a?"block":a),a))):"none"!==n&&(s[u]="none",b.set(r,"display",n)));for(u=0;u<l;u++)null!=s[u]&&(e[u].style.display=s[u]);return e}E.fn.extend({show:function(){return A(this,!0)},hide:function(){return A(this)},toggle:function(e){return"boolean"==typeof e?e?this.show():this.hide():this.each(function(){ve(this)?E(this).show():E(this).hide()})}});var we=/^(?:checkbox|radio)$/i,Te=/<([a-z][^\/\0>\x20\t\r\n\f]*)/i,Ce=/^$|^module$|\/(?:java|ecma)script/i,N=(L=C.createDocumentFragment().appendChild(C.createElement("div")),(a=C.createElement("input")).setAttribute("type","radio"),a.setAttribute("checked","checked"),a.setAttribute("name","t"),L.appendChild(a),g.checkClone=L.cloneNode(!0).cloneNode(!0).lastChild.checked,L.innerHTML="<textarea>x</textarea>",g.noCloneChecked=!!L.cloneNode(!0).lastChild.defaultValue,L.innerHTML="<option></option>",g.option=!!L.lastChild,{thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]});function j(e,t){var n="undefined"!=typeof e.getElementsByTagName?e.getElementsByTagName(t||"*"):"undefined"!=typeof e.querySelectorAll?e.querySelectorAll(t||"*"):[];return t===undefined||t&&u(e,t)?E.merge([e],n):n}function Ee(e,t){for(var n=0,r=e.length;n<r;n++)b.set(e[n],"globalEval",!t||b.get(t[n],"globalEval"))}N.tbody=N.tfoot=N.colgroup=N.caption=N.thead,N.th=N.td,g.option||(N.optgroup=N.option=[1,"<select multiple='multiple'>","</select>"]);var Se=/<|&#?\w+;/;function ke(e,t,n,r,i){for(var o,a,s,u,l,c=t.createDocumentFragment(),f=[],d=0,p=e.length;d<p;d++)if((o=e[d])||0===o)if("object"===h(o))E.merge(f,o.nodeType?[o]:o);else if(Se.test(o)){for(a=a||c.appendChild(t.createElement("div")),s=(Te.exec(o)||["",""])[1].toLowerCase(),s=N[s]||N._default,a.innerHTML=s[1]+E.htmlPrefilter(o)+s[2],l=s[0];l--;)a=a.lastChild;E.merge(f,a.childNodes),(a=c.firstChild).textContent=""}else f.push(t.createTextNode(o));for(c.textContent="",d=0;o=f[d++];)if(r&&-1<E.inArray(o,r))i&&i.push(o);else if(u=k(o),a=j(c.appendChild(o),"script"),u&&Ee(a),n)for(l=0;o=a[l++];)Ce.test(o.type||"")&&n.push(o);return c}var Ae=/^([^.]*)(?:\.(.+)|)/;function n(){return!0}function p(){return!1}function Ne(e,t){return e===function(){try{return C.activeElement}catch(e){}}()==("focus"===t)}function je(e,t,n,r,i,o){var a,s;if("object"==typeof t){for(s in"string"!=typeof n&&(r=r||n,n=undefined),t)je(e,s,n,r,t[s],o);return e}if(null==r&&null==i?(i=n,r=n=undefined):null==i&&("string"==typeof n?(i=r,r=undefined):(i=r,r=n,n=undefined)),!1===i)i=p;else if(!i)return e;return 1===o&&(a=i,(i=function(e){return E().off(e),a.apply(this,arguments)}).guid=a.guid||(a.guid=E.guid++)),e.each(function(){E.event.add(this,t,i,r,n)})}function De(e,i,o){o?(b.set(e,i,!1),E.event.add(e,i,{namespace:!1,handler:function(e){var t,n,r=b.get(this,i);if(1&e.isTrigger&&this[i]){if(r.length)(E.event.special[i]||{}).delegateType&&e.stopPropagation();else if(r=s.call(arguments),b.set(this,i,r),t=o(this,i),this[i](),r!==(n=b.get(this,i))||t?b.set(this,i,!1):n={},r!==n)return e.stopImmediatePropagation(),e.preventDefault(),n&&n.value}else r.length&&(b.set(this,i,{value:E.event.trigger(E.extend(r[0],E.Event.prototype),r.slice(1),this)}),e.stopImmediatePropagation())}})):b.get(e,i)===undefined&&E.event.add(e,i,n)}E.event={global:{},add:function(t,e,n,r,i){var o,a,s,u,l,c,f,d,p,h=b.get(t);if(m(t))for(n.handler&&(n=(o=n).handler,i=o.selector),i&&E.find.matchesSelector(w,i),n.guid||(n.guid=E.guid++),s=(s=h.events)||(h.events=Object.create(null)),a=(a=h.handle)||(h.handle=function(e){return void 0!==E&&E.event.triggered!==e.type?E.event.dispatch.apply(t,arguments):undefined}),u=(e=(e||"").match(S)||[""]).length;u--;)f=p=(d=Ae.exec(e[u])||[])[1],d=(d[2]||"").split(".").sort(),f&&(l=E.event.special[f]||{},f=(i?l.delegateType:l.bindType)||f,l=E.event.special[f]||{},p=E.extend({type:f,origType:p,data:r,handler:n,guid:n.guid,selector:i,needsContext:i&&E.expr.match.needsContext.test(i),namespace:d.join(".")},o),(c=s[f])||((c=s[f]=[]).delegateCount=0,l.setup&&!1!==l.setup.call(t,r,d,a))||t.addEventListener&&t.addEventListener(f,a),l.add&&(l.add.call(t,p),p.handler.guid||(p.handler.guid=n.guid)),i?c.splice(c.delegateCount++,0,p):c.push(p),E.event.global[f]=!0)},remove:function(e,t,n,r,i){var o,a,s,u,l,c,f,d,p,h,g,y=b.hasData(e)&&b.get(e);if(y&&(u=y.events)){for(l=(t=(t||"").match(S)||[""]).length;l--;)if(p=g=(s=Ae.exec(t[l])||[])[1],h=(s[2]||"").split(".").sort(),p){for(f=E.event.special[p]||{},d=u[p=(r?f.delegateType:f.bindType)||p]||[],s=s[2]&&new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"),a=o=d.length;o--;)c=d[o],!i&&g!==c.origType||n&&n.guid!==c.guid||s&&!s.test(c.namespace)||r&&r!==c.selector&&("**"!==r||!c.selector)||(d.splice(o,1),c.selector&&d.delegateCount--,f.remove&&f.remove.call(e,c));a&&!d.length&&(f.teardown&&!1!==f.teardown.call(e,h,y.handle)||E.removeEvent(e,p,y.handle),delete u[p])}else for(p in u)E.event.remove(e,p+t[l],n,r,!0);E.isEmptyObject(u)&&b.remove(e,"handle events")}},dispatch:function(e){var t,n,r,i,o,a=new Array(arguments.length),s=E.event.fix(e),e=(b.get(this,"events")||Object.create(null))[s.type]||[],u=E.event.special[s.type]||{};for(a[0]=s,t=1;t<arguments.length;t++)a[t]=arguments[t];if(s.delegateTarget=this,!u.preDispatch||!1!==u.preDispatch.call(this,s)){for(o=E.event.handlers.call(this,s,e),t=0;(r=o[t++])&&!s.isPropagationStopped();)for(s.currentTarget=r.elem,n=0;(i=r.handlers[n++])&&!s.isImmediatePropagationStopped();)s.rnamespace&&!1!==i.namespace&&!s.rnamespace.test(i.namespace)||(s.handleObj=i,s.data=i.data,(i=((E.event.special[i.origType]||{}).handle||i.handler).apply(r.elem,a))!==undefined&&!1===(s.result=i)&&(s.preventDefault(),s.stopPropagation()));return u.postDispatch&&u.postDispatch.call(this,s),s.result}},handlers:function(e,t){var n,r,i,o,a,s=[],u=t.delegateCount,l=e.target;if(u&&l.nodeType&&!("click"===e.type&&1<=e.button))for(;l!==this;l=l.parentNode||this)if(1===l.nodeType&&("click"!==e.type||!0!==l.disabled)){for(o=[],a={},n=0;n<u;n++)a[i=(r=t[n]).selector+" "]===undefined&&(a[i]=r.needsContext?-1<E(i,this).index(l):E.find(i,this,null,[l]).length),a[i]&&o.push(r);o.length&&s.push({elem:l,handlers:o})}return l=this,u<t.length&&s.push({elem:l,handlers:t.slice(u)}),s},addProp:function(t,e){Object.defineProperty(E.Event.prototype,t,{enumerable:!0,configurable:!0,get:v(e)?function(){if(this.originalEvent)return e(this.originalEvent)}:function(){if(this.originalEvent)return this.originalEvent[t]},set:function(e){Object.defineProperty(this,t,{enumerable:!0,configurable:!0,writable:!0,value:e})}})},fix:function(e){return e[E.expando]?e:new E.Event(e)},special:{load:{noBubble:!0},click:{setup:function(e){e=this||e;return we.test(e.type)&&e.click&&u(e,"input")&&De(e,"click",n),!1},trigger:function(e){e=this||e;return we.test(e.type)&&e.click&&u(e,"input")&&De(e,"click"),!0},_default:function(e){e=e.target;return we.test(e.type)&&e.click&&u(e,"input")&&b.get(e,"click")||u(e,"a")}},beforeunload:{postDispatch:function(e){e.result!==undefined&&e.originalEvent&&(e.originalEvent.returnValue=e.result)}}}},E.removeEvent=function(e,t,n){e.removeEventListener&&e.removeEventListener(t,n)},E.Event=function(e,t){if(!(this instanceof E.Event))return new E.Event(e,t);e&&e.type?(this.originalEvent=e,this.type=e.type,this.isDefaultPrevented=e.defaultPrevented||e.defaultPrevented===undefined&&!1===e.returnValue?n:p,this.target=e.target&&3===e.target.nodeType?e.target.parentNode:e.target,this.currentTarget=e.currentTarget,this.relatedTarget=e.relatedTarget):this.type=e,t&&E.extend(this,t),this.timeStamp=e&&e.timeStamp||Date.now(),this[E.expando]=!0},E.Event.prototype={constructor:E.Event,isDefaultPrevented:p,isPropagationStopped:p,isImmediatePropagationStopped:p,isSimulated:!1,preventDefault:function(){var e=this.originalEvent;this.isDefaultPrevented=n,e&&!this.isSimulated&&e.preventDefault()},stopPropagation:function(){var e=this.originalEvent;this.isPropagationStopped=n,e&&!this.isSimulated&&e.stopPropagation()},stopImmediatePropagation:function(){var e=this.originalEvent;this.isImmediatePropagationStopped=n,e&&!this.isSimulated&&e.stopImmediatePropagation(),this.stopPropagation()}},E.each({altKey:!0,bubbles:!0,cancelable:!0,changedTouches:!0,ctrlKey:!0,detail:!0,eventPhase:!0,metaKey:!0,pageX:!0,pageY:!0,shiftKey:!0,view:!0,"char":!0,code:!0,charCode:!0,key:!0,keyCode:!0,button:!0,buttons:!0,clientX:!0,clientY:!0,offsetX:!0,offsetY:!0,pointerId:!0,pointerType:!0,screenX:!0,screenY:!0,targetTouches:!0,toElement:!0,touches:!0,which:!0},E.event.addProp),E.each({focus:"focusin",blur:"focusout"},function(e,t){E.event.special[e]={setup:function(){return De(this,e,Ne),!1},trigger:function(){return De(this,e),!0},_default:function(){return!0},delegateType:t}}),E.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(e,i){E.event.special[e]={delegateType:i,bindType:i,handle:function(e){var t,n=e.relatedTarget,r=e.handleObj;return n&&(n===this||E.contains(this,n))||(e.type=r.origType,t=r.handler.apply(this,arguments),e.type=i),t}}}),E.fn.extend({on:function(e,t,n,r){return je(this,e,t,n,r)},one:function(e,t,n,r){return je(this,e,t,n,r,1)},off:function(e,t,n){var r,i;if(e&&e.preventDefault&&e.handleObj)r=e.handleObj,E(e.delegateTarget).off(r.namespace?r.origType+"."+r.namespace:r.origType,r.selector,r.handler);else{if("object"!=typeof e)return!1!==t&&"function"!=typeof t||(n=t,t=undefined),!1===n&&(n=p),this.each(function(){E.event.remove(this,e,n,t)});for(i in e)this.off(i,t,e[i])}return this}});var qe=/<script|<style|<link/i,Le=/checked\s*(?:[^=]|=\s*.checked.)/i,He=/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;function Oe(e,t){return u(e,"table")&&u(11!==t.nodeType?t:t.firstChild,"tr")&&E(e).children("tbody")[0]||e}function Pe(e){return e.type=(null!==e.getAttribute("type"))+"/"+e.type,e}function Re(e){return"true/"===(e.type||"").slice(0,5)?e.type=e.type.slice(5):e.removeAttribute("type"),e}function Me(e,t){var n,r,i,o;if(1===t.nodeType){if(b.hasData(e)&&(o=b.get(e).events))for(i in b.remove(t,"handle events"),o)for(n=0,r=o[i].length;n<r;n++)E.event.add(t,i,o[i][n]);l.hasData(e)&&(e=l.access(e),e=E.extend({},e),l.set(t,e))}}function D(n,r,i,o){r=I(r);var e,t,a,s,u,l,c=0,f=n.length,d=f-1,p=r[0],h=v(p);if(h||1<f&&"string"==typeof p&&!g.checkClone&&Le.test(p))return n.each(function(e){var t=n.eq(e);h&&(r[0]=p.call(this,e,t.html())),D(t,r,i,o)});if(f&&(t=(e=ke(r,n[0].ownerDocument,!1,n,o)).firstChild,1===e.childNodes.length&&(e=t),t||o)){for(s=(a=E.map(j(e,"script"),Pe)).length;c<f;c++)u=e,c!==d&&(u=E.clone(u,!0,!0),s)&&E.merge(a,j(u,"script")),i.call(n[c],u,c);if(s)for(l=a[a.length-1].ownerDocument,E.map(a,Re),c=0;c<s;c++)u=a[c],Ce.test(u.type||"")&&!b.access(u,"globalEval")&&E.contains(l,u)&&(u.src&&"module"!==(u.type||"").toLowerCase()?E._evalUrl&&!u.noModule&&E._evalUrl(u.src,{nonce:u.nonce||u.getAttribute("nonce")},l):V(u.textContent.replace(He,""),u,l))}return n}function Ie(e,t,n){for(var r,i=t?E.filter(t,e):e,o=0;null!=(r=i[o]);o++)n||1!==r.nodeType||E.cleanData(j(r)),r.parentNode&&(n&&k(r)&&Ee(j(r,"script")),r.parentNode.removeChild(r));return e}E.extend({htmlPrefilter:function(e){return e},clone:function(e,t,n){var r,i,o,a,s,u,l,c=e.cloneNode(!0),f=k(e);if(!(g.noCloneChecked||1!==e.nodeType&&11!==e.nodeType||E.isXMLDoc(e)))for(a=j(c),r=0,i=(o=j(e)).length;r<i;r++)s=o[r],u=a[r],l=void 0,"input"===(l=u.nodeName.toLowerCase())&&we.test(s.type)?u.checked=s.checked:"input"!==l&&"textarea"!==l||(u.defaultValue=s.defaultValue);if(t)if(n)for(o=o||j(e),a=a||j(c),r=0,i=o.length;r<i;r++)Me(o[r],a[r]);else Me(e,c);return 0<(a=j(c,"script")).length&&Ee(a,!f&&j(e,"script")),c},cleanData:function(e){for(var t,n,r,i=E.event.special,o=0;(n=e[o])!==undefined;o++)if(m(n)){if(t=n[b.expando]){if(t.events)for(r in t.events)i[r]?E.event.remove(n,r):E.removeEvent(n,r,t.handle);n[b.expando]=undefined}n[l.expando]&&(n[l.expando]=undefined)}}}),E.fn.extend({detach:function(e){return Ie(this,e,!0)},remove:function(e){return Ie(this,e)},text:function(e){return c(this,function(e){return e===undefined?E.text(this):this.empty().each(function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=e)})},null,e,arguments.length)},append:function(){return D(this,arguments,function(e){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||Oe(this,e).appendChild(e)})},prepend:function(){return D(this,arguments,function(e){var t;1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(t=Oe(this,e)).insertBefore(e,t.firstChild)})},before:function(){return D(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this)})},after:function(){return D(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this.nextSibling)})},empty:function(){for(var e,t=0;null!=(e=this[t]);t++)1===e.nodeType&&(E.cleanData(j(e,!1)),e.textContent="");return this},clone:function(e,t){return e=null!=e&&e,t=null==t?e:t,this.map(function(){return E.clone(this,e,t)})},html:function(e){return c(this,function(e){var t=this[0]||{},n=0,r=this.length;if(e===undefined&&1===t.nodeType)return t.innerHTML;if("string"==typeof e&&!qe.test(e)&&!N[(Te.exec(e)||["",""])[1].toLowerCase()]){e=E.htmlPrefilter(e);try{for(;n<r;n++)1===(t=this[n]||{}).nodeType&&(E.cleanData(j(t,!1)),t.innerHTML=e);t=0}catch(i){}}t&&this.empty().append(e)},null,e,arguments.length)},replaceWith:function(){var n=[];return D(this,arguments,function(e){var t=this.parentNode;E.inArray(this,n)<0&&(E.cleanData(j(this)),t)&&t.replaceChild(e,this)},n)}}),E.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(e,a){E.fn[e]=function(e){for(var t,n=[],r=E(e),i=r.length-1,o=0;o<=i;o++)t=o===i?this:this.clone(!0),E(r[o])[a](t),W.apply(n,t.get());return this.pushStack(n)}});var We,Fe,Be,$e,_e,ze,Ue,i,Xe=new RegExp("^("+e+")(?!px)[a-z%]+$","i"),Ve=function(e){var t=e.ownerDocument.defaultView;return(t=t&&t.opener?t:T).getComputedStyle(e)},Ge=function(e,t,n){var r,i={};for(r in t)i[r]=e.style[r],e.style[r]=t[r];for(r in n=n.call(e),t)e.style[r]=i[r];return n},Ye=new RegExp(d.join("|"),"i");function Qe(){var e;i&&(Ue.style.cssText="position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0",i.style.cssText="position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%",w.appendChild(Ue).appendChild(i),e=T.getComputedStyle(i),We="1%"!==e.top,ze=12===Je(e.marginLeft),i.style.right="60%",$e=36===Je(e.right),Fe=36===Je(e.width),i.style.position="absolute",Be=12===Je(i.offsetWidth/3),w.removeChild(Ue),i=null)}function Je(e){return Math.round(parseFloat(e))}function Ke(e,t,n){var r,i,o=e.style;return(n=n||Ve(e))&&(""!==(i=n.getPropertyValue(t)||n[t])||k(e)||(i=E.style(e,t)),!g.pixelBoxStyles())&&Xe.test(i)&&Ye.test(t)&&(e=o.width,t=o.minWidth,r=o.maxWidth,o.minWidth=o.maxWidth=o.width=i,i=n.width,o.width=e,o.minWidth=t,o.maxWidth=r),i!==undefined?i+"":i}function Ze(e,t){return{get:function(){if(!e())return(this.get=t).apply(this,arguments);delete this.get}}}Ue=C.createElement("div"),(i=C.createElement("div")).style&&(i.style.backgroundClip="content-box",i.cloneNode(!0).style.backgroundClip="",g.clearCloneStyle="content-box"===i.style.backgroundClip,E.extend(g,{boxSizingReliable:function(){return Qe(),Fe},pixelBoxStyles:function(){return Qe(),$e},pixelPosition:function(){return Qe(),We},reliableMarginLeft:function(){return Qe(),ze},scrollboxSize:function(){return Qe(),Be},reliableTrDimensions:function(){var e,t,n;return null==_e&&(e=C.createElement("table"),t=C.createElement("tr"),n=C.createElement("div"),e.style.cssText="position:absolute;left:-11111px;border-collapse:separate",t.style.cssText="border:1px solid",t.style.height="1px",n.style.height="9px",n.style.display="block",w.appendChild(e).appendChild(t).appendChild(n),n=T.getComputedStyle(t),_e=parseInt(n.height,10)+parseInt(n.borderTopWidth,10)+parseInt(n.borderBottomWidth,10)===t.offsetHeight,w.removeChild(e)),_e}}));var et=["Webkit","Moz","ms"],tt=C.createElement("div").style,nt={};function rt(e){var t=E.cssProps[e]||nt[e];return t||(e in tt?e:nt[e]=function(e){for(var t=e[0].toUpperCase()+e.slice(1),n=et.length;n--;)if((e=et[n]+t)in tt)return e}(e)||e)}var it=/^(none|table(?!-c[ea]).+)/,ot=/^--/,at={position:"absolute",visibility:"hidden",display:"block"},st={letterSpacing:"0",fontWeight:"400"};function ut(e,t,n){var r=ye.exec(t);return r?Math.max(0,r[2]-(n||0))+(r[3]||"px"):t}function lt(e,t,n,r,i,o){var a="width"===t?1:0,s=0,u=0;if(n===(r?"border":"content"))return 0;for(;a<4;a+=2)"margin"===n&&(u+=E.css(e,n+d[a],!0,i)),r?("content"===n&&(u-=E.css(e,"padding"+d[a],!0,i)),"margin"!==n&&(u-=E.css(e,"border"+d[a]+"Width",!0,i))):(u+=E.css(e,"padding"+d[a],!0,i),"padding"!==n?u+=E.css(e,"border"+d[a]+"Width",!0,i):s+=E.css(e,"border"+d[a]+"Width",!0,i));return!r&&0<=o&&(u+=Math.max(0,Math.ceil(e["offset"+t[0].toUpperCase()+t.slice(1)]-o-u-s-.5))||0),u}function ct(e,t,n){var r=Ve(e),i=(!g.boxSizingReliable()||n)&&"border-box"===E.css(e,"boxSizing",!1,r),o=i,a=Ke(e,t,r),s="offset"+t[0].toUpperCase()+t.slice(1);if(Xe.test(a)){if(!n)return a;a="auto"}return(!g.boxSizingReliable()&&i||!g.reliableTrDimensions()&&u(e,"tr")||"auto"===a||!parseFloat(a)&&"inline"===E.css(e,"display",!1,r))&&e.getClientRects().length&&(i="border-box"===E.css(e,"boxSizing",!1,r),o=s in e)&&(a=e[s]),(a=parseFloat(a)||0)+lt(e,t,n||(i?"border":"content"),o,r,a)+"px"}function o(e,t,n,r,i){return new o.prototype.init(e,t,n,r,i)}E.extend({cssHooks:{opacity:{get:function(e,t){if(t)return""===(t=Ke(e,"opacity"))?"1":t}}},cssNumber:{animationIterationCount:!0,columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,gridArea:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnStart:!0,gridRow:!0,gridRowEnd:!0,gridRowStart:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{},style:function(e,t,n,r){if(e&&3!==e.nodeType&&8!==e.nodeType&&e.style){var i,o,a,s=x(t),u=ot.test(t),l=e.style;if(u||(t=rt(s)),a=E.cssHooks[t]||E.cssHooks[s],n===undefined)return a&&"get"in a&&(i=a.get(e,!1,r))!==undefined?i:l[t];"string"===(o=typeof n)&&(i=ye.exec(n))&&i[1]&&(n=xe(e,t,i),o="number"),null==n||n!=n||("number"!==o||u||(n+=i&&i[3]||(E.cssNumber[s]?"":"px")),g.clearCloneStyle||""!==n||0!==t.indexOf("background")||(l[t]="inherit"),a&&"set"in a&&(n=a.set(e,n,r))===undefined)||(u?l.setProperty(t,n):l[t]=n)}},css:function(e,t,n,r){var i,o=x(t);return ot.test(t)||(t=rt(o)),"normal"===(i=(i=(o=E.cssHooks[t]||E.cssHooks[o])&&"get"in o?o.get(e,!0,n):i)===undefined?Ke(e,t,r):i)&&t in st&&(i=st[t]),(""===n||n)&&(o=parseFloat(i),!0===n||isFinite(o))?o||0:i}}),E.each(["height","width"],function(e,a){E.cssHooks[a]={get:function(e,t,n){if(t)return!it.test(E.css(e,"display"))||e.getClientRects().length&&e.getBoundingClientRect().width?ct(e,a,n):Ge(e,at,function(){return ct(e,a,n)})},set:function(e,t,n){var r=Ve(e),i=!g.scrollboxSize()&&"absolute"===r.position,o=(i||n)&&"border-box"===E.css(e,"boxSizing",!1,r),n=n?lt(e,a,n,o,r):0;return o&&i&&(n-=Math.ceil(e["offset"+a[0].toUpperCase()+a.slice(1)]-parseFloat(r[a])-lt(e,a,"border",!1,r)-.5)),n&&(o=ye.exec(t))&&"px"!==(o[3]||"px")&&(e.style[a]=t,t=E.css(e,a)),ut(0,t,n)}}}),E.cssHooks.marginLeft=Ze(g.reliableMarginLeft,function(e,t){if(t)return(parseFloat(Ke(e,"marginLeft"))||e.getBoundingClientRect().left-Ge(e,{marginLeft:0},function(){return e.getBoundingClientRect().left}))+"px"}),E.each({margin:"",padding:"",border:"Width"},function(i,o){E.cssHooks[i+o]={expand:function(e){for(var t=0,n={},r="string"==typeof e?e.split(" "):[e];t<4;t++)n[i+d[t]+o]=r[t]||r[t-2]||r[0];return n}},"margin"!==i&&(E.cssHooks[i+o].set=ut)}),E.fn.extend({css:function(e,t){return c(this,function(e,t,n){var r,i,o={},a=0;if(Array.isArray(t)){for(r=Ve(e),i=t.length;a<i;a++)o[t[a]]=E.css(e,t[a],!1,r);return o}return n!==undefined?E.style(e,t,n):E.css(e,t)},e,t,1<arguments.length)}}),((E.Tween=o).prototype={constructor:o,init:function(e,t,n,r,i,o){this.elem=e,this.prop=n,this.easing=i||E.easing._default,this.options=t,this.start=this.now=this.cur(),this.end=r,this.unit=o||(E.cssNumber[n]?"":"px")},cur:function(){var e=o.propHooks[this.prop];return(e&&e.get?e:o.propHooks._default).get(this)},run:function(e){var t,n=o.propHooks[this.prop];return this.options.duration?this.pos=t=E.easing[this.easing](e,this.options.duration*e,0,1,this.options.duration):this.pos=t=e,this.now=(this.end-this.start)*t+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),(n&&n.set?n:o.propHooks._default).set(this),this}}).init.prototype=o.prototype,(o.propHooks={_default:{get:function(e){return 1!==e.elem.nodeType||null!=e.elem[e.prop]&&null==e.elem.style[e.prop]?e.elem[e.prop]:(e=E.css(e.elem,e.prop,""))&&"auto"!==e?e:0},set:function(e){E.fx.step[e.prop]?E.fx.step[e.prop](e):1!==e.elem.nodeType||!E.cssHooks[e.prop]&&null==e.elem.style[rt(e.prop)]?e.elem[e.prop]=e.now:E.style(e.elem,e.prop,e.now+e.unit)}}}).scrollTop=o.propHooks.scrollLeft={set:function(e){e.elem.nodeType&&e.elem.parentNode&&(e.elem[e.prop]=e.now)}},E.easing={linear:function(e){return e},swing:function(e){return.5-Math.cos(e*Math.PI)/2},_default:"swing"},E.fx=o.prototype.init,E.fx.step={};var q,ft,a,L,dt=/^(?:toggle|show|hide)$/,pt=/queueHooks$/;function ht(){ft&&(!1===C.hidden&&T.requestAnimationFrame?T.requestAnimationFrame(ht):T.setTimeout(ht,E.fx.interval),E.fx.tick())}function gt(){return T.setTimeout(function(){q=undefined}),q=Date.now()}function yt(e,t){var n,r=0,i={height:e};for(t=t?1:0;r<4;r+=2-t)i["margin"+(n=d[r])]=i["padding"+n]=e;return t&&(i.opacity=i.width=e),i}function mt(e,t,n){for(var r,i=(H.tweeners[t]||[]).concat(H.tweeners["*"]),o=0,a=i.length;o<a;o++)if(r=i[o].call(n,t,e))return r}function H(i,e,t){var n,o,r,a,s,u,l,c=0,f=H.prefilters.length,d=E.Deferred().always(function(){delete p.elem}),p=function(){if(!o){for(var e=q||gt(),e=Math.max(0,h.startTime+h.duration-e),t=1-(e/h.duration||0),n=0,r=h.tweens.length;n<r;n++)h.tweens[n].run(t);if(d.notifyWith(i,[h,t,e]),t<1&&r)return e;r||d.notifyWith(i,[h,1,0]),d.resolveWith(i,[h])}return!1},h=d.promise({elem:i,props:E.extend({},e),opts:E.extend(!0,{specialEasing:{},easing:E.easing._default},t),originalProperties:e,originalOptions:t,startTime:q||gt(),duration:t.duration,tweens:[],createTween:function(e,t){t=E.Tween(i,h.opts,e,t,h.opts.specialEasing[e]||h.opts.easing);return h.tweens.push(t),t},stop:function(e){var t=0,n=e?h.tweens.length:0;if(!o){for(o=!0;t<n;t++)h.tweens[t].run(1);e?(d.notifyWith(i,[h,1,0]),d.resolveWith(i,[h,e])):d.rejectWith(i,[h,e])}return this}}),g=h.props,y=g,m=h.opts.specialEasing;for(r in y)if(s=m[a=x(r)],u=y[r],Array.isArray(u)&&(s=u[1],u=y[r]=u[0]),r!==a&&(y[a]=u,delete y[r]),(l=E.cssHooks[a])&&"expand"in l)for(r in u=l.expand(u),delete y[a],u)r in y||(y[r]=u[r],m[r]=s);else m[a]=s;for(;c<f;c++)if(n=H.prefilters[c].call(h,i,g,h.opts))return v(n.stop)&&(E._queueHooks(h.elem,h.opts.queue).stop=n.stop.bind(n)),n;return E.map(g,mt,h),v(h.opts.start)&&h.opts.start.call(i,h),h.progress(h.opts.progress).done(h.opts.done,h.opts.complete).fail(h.opts.fail).always(h.opts.always),E.fx.timer(E.extend(p,{elem:i,anim:h,queue:h.opts.queue})),h}E.Animation=E.extend(H,{tweeners:{"*":[function(e,t){var n=this.createTween(e,t);return xe(n.elem,e,ye.exec(t),n),n}]},tweener:function(e,t){for(var n,r=0,i=(e=v(e)?(t=e,["*"]):e.match(S)).length;r<i;r++)n=e[r],H.tweeners[n]=H.tweeners[n]||[],H.tweeners[n].unshift(t)},prefilters:[function(e,t,n){var r,i,o,a,s,u,l,c="width"in t||"height"in t,f=this,d={},p=e.style,h=e.nodeType&&ve(e),g=b.get(e,"fxshow");for(r in n.queue||(null==(a=E._queueHooks(e,"fx")).unqueued&&(a.unqueued=0,s=a.empty.fire,a.empty.fire=function(){a.unqueued||s()}),a.unqueued++,f.always(function(){f.always(function(){a.unqueued--,E.queue(e,"fx").length||a.empty.fire()})})),t)if(i=t[r],dt.test(i)){if(delete t[r],o=o||"toggle"===i,i===(h?"hide":"show")){if("show"!==i||!g||g[r]===undefined)continue;h=!0}d[r]=g&&g[r]||E.style(e,r)}if((u=!E.isEmptyObject(t))||!E.isEmptyObject(d))for(r in c&&1===e.nodeType&&(n.overflow=[p.overflow,p.overflowX,p.overflowY],null==(l=g&&g.display)&&(l=b.get(e,"display")),"none"===(c=E.css(e,"display"))&&(l?c=l:(A([e],!0),l=e.style.display||l,c=E.css(e,"display"),A([e]))),"inline"===c||"inline-block"===c&&null!=l)&&"none"===E.css(e,"float")&&(u||(f.done(function(){p.display=l}),null==l&&(c=p.display,l="none"===c?"":c)),p.display="inline-block"),n.overflow&&(p.overflow="hidden",f.always(function(){p.overflow=n.overflow[0],p.overflowX=n.overflow[1],p.overflowY=n.overflow[2]})),u=!1,d)u||(g?"hidden"in g&&(h=g.hidden):g=b.access(e,"fxshow",{display:l}),o&&(g.hidden=!h),h&&A([e],!0),f.done(function(){for(r in h||A([e]),b.remove(e,"fxshow"),d)E.style(e,r,d[r])})),u=mt(h?g[r]:0,r,f),r in g||(g[r]=u.start,h&&(u.end=u.start,u.start=0))}],prefilter:function(e,t){t?H.prefilters.unshift(e):H.prefilters.push(e)}}),E.speed=function(e,t,n){var r=e&&"object"==typeof e?E.extend({},e):{complete:n||!n&&t||v(e)&&e,duration:e,easing:n&&t||t&&!v(t)&&t};return E.fx.off?r.duration=0:"number"!=typeof r.duration&&(r.duration in E.fx.speeds?r.duration=E.fx.speeds[r.duration]:r.duration=E.fx.speeds._default),null!=r.queue&&!0!==r.queue||(r.queue="fx"),r.old=r.complete,r.complete=function(){v(r.old)&&r.old.call(this),r.queue&&E.dequeue(this,r.queue)},r},E.fn.extend({fadeTo:function(e,t,n,r){return this.filter(ve).css("opacity",0).show().end().animate({opacity:t},e,n,r)},animate:function(t,e,n,r){var i=E.isEmptyObject(t),o=E.speed(e,n,r),e=function(){var e=H(this,E.extend({},t),o);(i||b.get(this,"finish"))&&e.stop(!0)};return e.finish=e,i||!1===o.queue?this.each(e):this.queue(o.queue,e)},stop:function(i,e,o){var a=function(e){var t=e.stop;delete e.stop,t(o)};return"string"!=typeof i&&(o=e,e=i,i=undefined),e&&this.queue(i||"fx",[]),this.each(function(){var e=!0,t=null!=i&&i+"queueHooks",n=E.timers,r=b.get(this);if(t)r[t]&&r[t].stop&&a(r[t]);else for(t in r)r[t]&&r[t].stop&&pt.test(t)&&a(r[t]);for(t=n.length;t--;)n[t].elem!==this||null!=i&&n[t].queue!==i||(n[t].anim.stop(o),e=!1,n.splice(t,1));!e&&o||E.dequeue(this,i)})},finish:function(a){return!1!==a&&(a=a||"fx"),this.each(function(){var e,t=b.get(this),n=t[a+"queue"],r=t[a+"queueHooks"],i=E.timers,o=n?n.length:0;for(t.finish=!0,E.queue(this,a,[]),r&&r.stop&&r.stop.call(this,!0),e=i.length;e--;)i[e].elem===this&&i[e].queue===a&&(i[e].anim.stop(!0),i.splice(e,1));for(e=0;e<o;e++)n[e]&&n[e].finish&&n[e].finish.call(this);delete t.finish})}}),E.each(["toggle","show","hide"],function(e,r){var i=E.fn[r];E.fn[r]=function(e,t,n){return null==e||"boolean"==typeof e?i.apply(this,arguments):this.animate(yt(r,!0),e,t,n)}}),E.each({slideDown:yt("show"),slideUp:yt("hide"),slideToggle:yt("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(e,r){E.fn[e]=function(e,t,n){return this.animate(r,e,t,n)}}),E.timers=[],E.fx.tick=function(){var e,t=0,n=E.timers;for(q=Date.now();t<n.length;t++)(e=n[t])()||n[t]!==e||n.splice(t--,1);n.length||E.fx.stop(),q=undefined},E.fx.timer=function(e){E.timers.push(e),E.fx.start()},E.fx.interval=13,E.fx.start=function(){ft||(ft=!0,ht())},E.fx.stop=function(){ft=null},E.fx.speeds={slow:600,fast:200,_default:400},E.fn.delay=function(r,e){return r=E.fx&&E.fx.speeds[r]||r,this.queue(e=e||"fx",function(e,t){var n=T.setTimeout(e,r);t.stop=function(){T.clearTimeout(n)}})},a=C.createElement("input"),L=C.createElement("select").appendChild(C.createElement("option")),a.type="checkbox",g.checkOn=""!==a.value,g.optSelected=L.selected,(a=C.createElement("input")).value="t",a.type="radio",g.radioValue="t"===a.value;var vt,xt=E.expr.attrHandle,bt=(E.fn.extend({attr:function(e,t){return c(this,E.attr,e,t,1<arguments.length)},removeAttr:function(e){return this.each(function(){E.removeAttr(this,e)})}}),E.extend({attr:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return"undefined"==typeof e.getAttribute?E.prop(e,t,n):(1===o&&E.isXMLDoc(e)||(i=E.attrHooks[t.toLowerCase()]||(E.expr.match.bool.test(t)?vt:undefined)),n!==undefined?null===n?void E.removeAttr(e,t):i&&"set"in i&&(r=i.set(e,n,t))!==undefined?r:(e.setAttribute(t,n+""),n):!(i&&"get"in i&&null!==(r=i.get(e,t)))&&null==(r=E.find.attr(e,t))?undefined:r)},attrHooks:{type:{set:function(e,t){var n;if(!g.radioValue&&"radio"===t&&u(e,"input"))return n=e.value,e.setAttribute("type",t),n&&(e.value=n),t}}},removeAttr:function(e,t){var n,r=0,i=t&&t.match(S);if(i&&1===e.nodeType)for(;n=i[r++];)e.removeAttribute(n)}}),vt={set:function(e,t,n){return!1===t?E.removeAttr(e,n):e.setAttribute(n,n),n}},E.each(E.expr.match.bool.source.match(/\w+/g),function(e,t){var a=xt[t]||E.find.attr;xt[t]=function(e,t,n){var r,i,o=t.toLowerCase();return n||(i=xt[o],xt[o]=r,r=null!=a(e,t,n)?o:null,xt[o]=i),r}}),/^(?:input|select|textarea|button)$/i),wt=/^(?:a|area)$/i;function O(e){return(e.match(S)||[]).join(" ")}function P(e){return e.getAttribute&&e.getAttribute("class")||""}function Tt(e){return Array.isArray(e)?e:"string"==typeof e&&e.match(S)||[]}E.fn.extend({prop:function(e,t){return c(this,E.prop,e,t,1<arguments.length)},removeProp:function(e){return this.each(function(){delete this[E.propFix[e]||e]})}}),E.extend({prop:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return 1===o&&E.isXMLDoc(e)||(t=E.propFix[t]||t,i=E.propHooks[t]),n!==undefined?i&&"set"in i&&(r=i.set(e,n,t))!==undefined?r:e[t]=n:i&&"get"in i&&null!==(r=i.get(e,t))?r:e[t]},propHooks:{tabIndex:{get:function(e){var t=E.find.attr(e,"tabindex");return t?parseInt(t,10):bt.test(e.nodeName)||wt.test(e.nodeName)&&e.href?0:-1}}},propFix:{"for":"htmlFor","class":"className"}}),g.optSelected||(E.propHooks.selected={get:function(e){e=e.parentNode;return e&&e.parentNode&&e.parentNode.selectedIndex,null},set:function(e){e=e.parentNode;e&&(e.selectedIndex,e.parentNode)&&e.parentNode.selectedIndex}}),E.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){E.propFix[this.toLowerCase()]=this}),E.fn.extend({addClass:function(t){var e,n,r,i,o,a,s=0;if(v(t))return this.each(function(e){E(this).addClass(t.call(this,e,P(this)))});if((e=Tt(t)).length)for(;n=this[s++];)if(a=P(n),r=1===n.nodeType&&" "+O(a)+" "){for(o=0;i=e[o++];)r.indexOf(" "+i+" ")<0&&(r+=i+" ");a!==(a=O(r))&&n.setAttribute("class",a)}return this},removeClass:function(t){var e,n,r,i,o,a,s=0;if(v(t))return this.each(function(e){E(this).removeClass(t.call(this,e,P(this)))});if(!arguments.length)return this.attr("class","");if((e=Tt(t)).length)for(;n=this[s++];)if(a=P(n),r=1===n.nodeType&&" "+O(a)+" "){for(o=0;i=e[o++];)for(;-1<r.indexOf(" "+i+" ");)r=r.replace(" "+i+" "," ");a!==(a=O(r))&&n.setAttribute("class",a)}return this},toggleClass:function(i,t){var o=typeof i,a="string"==o||Array.isArray(i);return"boolean"==typeof t&&a?t?this.addClass(i):this.removeClass(i):v(i)?this.each(function(e){E(this).toggleClass(i.call(this,e,P(this),t),t)}):this.each(function(){var e,t,n,r;if(a)for(t=0,n=E(this),r=Tt(i);e=r[t++];)n.hasClass(e)?n.removeClass(e):n.addClass(e);else i!==undefined&&"boolean"!=o||((e=P(this))&&b.set(this,"__className__",e),this.setAttribute&&this.setAttribute("class",!e&&!1!==i&&b.get(this,"__className__")||""))})},hasClass:function(e){for(var t,n=0,r=" "+e+" ";t=this[n++];)if(1===t.nodeType&&-1<(" "+O(P(t))+" ").indexOf(r))return!0;return!1}});var Ct=/\r/g,Et=(E.fn.extend({val:function(t){var n,e,r,i=this[0];return arguments.length?(r=v(t),this.each(function(e){1!==this.nodeType||(null==(e=r?t.call(this,e,E(this).val()):t)?e="":"number"==typeof e?e+="":Array.isArray(e)&&(e=E.map(e,function(e){return null==e?"":e+""})),(n=E.valHooks[this.type]||E.valHooks[this.nodeName.toLowerCase()])&&"set"in n&&n.set(this,e,"value")!==undefined)||(this.value=e)})):i?(n=E.valHooks[i.type]||E.valHooks[i.nodeName.toLowerCase()])&&"get"in n&&(e=n.get(i,"value"))!==undefined?e:"string"==typeof(e=i.value)?e.replace(Ct,""):null==e?"":e:void 0}}),E.extend({valHooks:{option:{get:function(e){var t=E.find.attr(e,"value");return null!=t?t:O(E.text(e))}},select:{get:function(e){for(var t,n=e.options,r=e.selectedIndex,i="select-one"===e.type,o=i?null:[],a=i?r+1:n.length,s=r<0?a:i?r:0;s<a;s++)if(((t=n[s]).selected||s===r)&&!t.disabled&&(!t.parentNode.disabled||!u(t.parentNode,"optgroup"))){if(t=E(t).val(),i)return t;o.push(t)}return o},set:function(e,t){for(var n,r,i=e.options,o=E.makeArray(t),a=i.length;a--;)((r=i[a]).selected=-1<E.inArray(E.valHooks.option.get(r),o))&&(n=!0);return n||(e.selectedIndex=-1),o}}}}),E.each(["radio","checkbox"],function(){E.valHooks[this]={set:function(e,t){if(Array.isArray(t))return e.checked=-1<E.inArray(E(e).val(),t)}},g.checkOn||(E.valHooks[this].get=function(e){return null===e.getAttribute("value")?"on":e.value})}),g.focusin="onfocusin"in T,/^(?:focusinfocus|focusoutblur)$/),St=function(e){e.stopPropagation()},kt=(E.extend(E.event,{trigger:function(e,t,n,r){var i,o,a,s,u,l,c,f=[n||C],d=_.call(e,"type")?e.type:e,p=_.call(e,"namespace")?e.namespace.split("."):[],h=c=o=n=n||C;if(3!==n.nodeType&&8!==n.nodeType&&!Et.test(d+E.event.triggered)&&(-1<d.indexOf(".")&&(d=(p=d.split(".")).shift(),p.sort()),s=d.indexOf(":")<0&&"on"+d,(e=e[E.expando]?e:new E.Event(d,"object"==typeof e&&e)).isTrigger=r?2:3,e.namespace=p.join("."),e.rnamespace=e.namespace?new RegExp("(^|\\.)"+p.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,e.result=undefined,e.target||(e.target=n),t=null==t?[e]:E.makeArray(t,[e]),l=E.event.special[d]||{},r||!l.trigger||!1!==l.trigger.apply(n,t))){if(!r&&!l.noBubble&&!y(n)){for(a=l.delegateType||d,Et.test(a+d)||(h=h.parentNode);h;h=h.parentNode)f.push(h),o=h;o===(n.ownerDocument||C)&&f.push(o.defaultView||o.parentWindow||T)}for(i=0;(h=f[i++])&&!e.isPropagationStopped();)c=h,e.type=1<i?a:l.bindType||d,(u=(b.get(h,"events")||Object.create(null))[e.type]&&b.get(h,"handle"))&&u.apply(h,t),(u=s&&h[s])&&u.apply&&m(h)&&(e.result=u.apply(h,t),!1===e.result)&&e.preventDefault();return e.type=d,r||e.isDefaultPrevented()||l._default&&!1!==l._default.apply(f.pop(),t)||!m(n)||s&&v(n[d])&&!y(n)&&((o=n[s])&&(n[s]=null),E.event.triggered=d,e.isPropagationStopped()&&c.addEventListener(d,St),n[d](),e.isPropagationStopped()&&c.removeEventListener(d,St),E.event.triggered=undefined,o)&&(n[s]=o),e.result}},simulate:function(e,t,n){n=E.extend(new E.Event,n,{type:e,isSimulated:!0});E.event.trigger(n,null,t)}}),E.fn.extend({trigger:function(e,t){return this.each(function(){E.event.trigger(e,t,this)})},triggerHandler:function(e,t){var n=this[0];if(n)return E.event.trigger(e,t,n,!0)}}),g.focusin||E.each({focus:"focusin",blur:"focusout"},function(n,r){var i=function(e){E.event.simulate(r,e.target,E.event.fix(e))};E.event.special[r]={setup:function(){var e=this.ownerDocument||this.document||this,t=b.access(e,r);t||e.addEventListener(n,i,!0),b.access(e,r,(t||0)+1)},teardown:function(){var e=this.ownerDocument||this.document||this,t=b.access(e,r)-1;t?b.access(e,r,t):(e.removeEventListener(n,i,!0),b.remove(e,r))}}}),T.location),At={guid:Date.now()},Nt=/\?/,jt=(E.parseXML=function(e){var t,n;if(!e||"string"!=typeof e)return null;try{t=(new T.DOMParser).parseFromString(e,"text/xml")}catch(r){}return n=t&&t.getElementsByTagName("parsererror")[0],t&&!n||E.error("Invalid XML: "+(n?E.map(n.childNodes,function(e){return e.textContent}).join("\n"):e)),t},/\[\]$/),Dt=/\r?\n/g,qt=/^(?:submit|button|image|reset|file)$/i,Lt=/^(?:input|select|textarea|keygen)/i;E.param=function(e,t){var n,r=[],i=function(e,t){t=v(t)?t():t;r[r.length]=encodeURIComponent(e)+"="+encodeURIComponent(null==t?"":t)};if(null==e)return"";if(Array.isArray(e)||e.jquery&&!E.isPlainObject(e))E.each(e,function(){i(this.name,this.value)});else for(n in e)!function o(n,e,r,i){if(Array.isArray(e))E.each(e,function(e,t){r||jt.test(n)?i(n,t):o(n+"["+("object"==typeof t&&null!=t?e:"")+"]",t,r,i)});else if(r||"object"!==h(e))i(n,e);else for(var t in e)o(n+"["+t+"]",e[t],r,i)}(n,e[n],t,i);return r.join("&")},E.fn.extend({serialize:function(){return E.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var e=E.prop(this,"elements");return e?E.makeArray(e):this}).filter(function(){var e=this.type;return this.name&&!E(this).is(":disabled")&&Lt.test(this.nodeName)&&!qt.test(e)&&(this.checked||!we.test(e))}).map(function(e,t){var n=E(this).val();return null==n?null:Array.isArray(n)?E.map(n,function(e){return{name:t.name,value:e.replace(Dt,"\r\n")}}):{name:t.name,value:n.replace(Dt,"\r\n")}}).get()}});var Ht=/%20/g,Ot=/#.*$/,Pt=/([?&])_=[^&]*/,Rt=/^(.*?):[ \t]*([^\r\n]*)$/gm,Mt=/^(?:GET|HEAD)$/,It=/^\/\//,Wt={},Ft={},Bt="*/".concat("*"),$t=C.createElement("a");function _t(o){return function(e,t){"string"!=typeof e&&(t=e,e="*");var n,r=0,i=e.toLowerCase().match(S)||[];if(v(t))for(;n=i[r++];)"+"===n[0]?(n=n.slice(1)||"*",(o[n]=o[n]||[]).unshift(t)):(o[n]=o[n]||[]).push(t)}}function zt(t,r,i,o){var a={},s=t===Ft;function u(e){var n;return a[e]=!0,E.each(t[e]||[],function(e,t){t=t(r,i,o);return"string"!=typeof t||s||a[t]?s?!(n=t):void 0:(r.dataTypes.unshift(t),u(t),!1)}),n}return u(r.dataTypes[0])||!a["*"]&&u("*")}function Ut(e,t){var n,r,i=E.ajaxSettings.flatOptions||{};for(n in t)t[n]!==undefined&&((i[n]?e:r=r||{})[n]=t[n]);return r&&E.extend(!0,e,r),e}function Xt(e,t,n,r){var i,o,a,s,u,l={},c=e.dataTypes.slice();if(c[1])for(a in e.converters)l[a.toLowerCase()]=e.converters[a];for(o=c.shift();o;)if(e.responseFields[o]&&(n[e.responseFields[o]]=t),!u&&r&&e.dataFilter&&(t=e.dataFilter(t,e.dataType)),u=o,o=c.shift())if("*"===o)o=u;else if("*"!==u&&u!==o){if(!(a=l[u+" "+o]||l["* "+o]))for(i in l)if((s=i.split(" "))[1]===o&&(a=l[u+" "+s[0]]||l["* "+s[0]])){!0===a?a=l[i]:!0!==l[i]&&(o=s[0],c.unshift(s[1]));break}if(!0!==a)if(a&&e["throws"])t=a(t);else try{t=a(t)}catch(f){return{state:"parsererror",error:a?f:"No conversion from "+u+" to "+o}}}return{state:"success",data:t}}$t.href=kt.href,E.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:kt.href,type:"GET",isLocal:/^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(kt.protocol),global:!0,processData:!0,"async":!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":Bt,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":JSON.parse,"text xml":E.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(e,t){return t?Ut(Ut(e,E.ajaxSettings),t):Ut(E.ajaxSettings,e)},ajaxPrefilter:_t(Wt),ajaxTransport:_t(Ft),ajax:function(e,t){"object"==typeof e&&(t=e,e=undefined);var u,l,c,n,f,d,p,r,h=E.ajaxSetup({},t=t||{}),g=h.context||h,y=h.context&&(g.nodeType||g.jquery)?E(g):E.event,m=E.Deferred(),v=E.Callbacks("once memory"),x=h.statusCode||{},i={},o={},a="canceled",b={readyState:0,getResponseHeader:function(e){var t;if(d){if(!n)for(n={};t=Rt.exec(c);)n[t[1].toLowerCase()+" "]=(n[t[1].toLowerCase()+" "]||[]).concat(t[2]);t=n[e.toLowerCase()+" "]}return null==t?null:t.join(", ")},getAllResponseHeaders:function(){return d?c:null},setRequestHeader:function(e,t){return null==d&&(e=o[e.toLowerCase()]=o[e.toLowerCase()]||e,i[e]=t),this},overrideMimeType:function(e){return null==d&&(h.mimeType=e),this},statusCode:function(e){if(e)if(d)b.always(e[b.status]);else for(var t in e)x[t]=[x[t],e[t]];return this},abort:function(e){e=e||a;return u&&u.abort(e),s(0,e),this}};if(m.promise(b),h.url=((e||h.url||kt.href)+"").replace(It,kt.protocol+"//"),h.type=t.method||t.type||h.method||h.type,h.dataTypes=(h.dataType||"*").toLowerCase().match(S)||[""],null==h.crossDomain){e=C.createElement("a");try{e.href=h.url,e.href=e.href,h.crossDomain=$t.protocol+"//"+$t.host!=e.protocol+"//"+e.host}catch(w){h.crossDomain=!0}}if(h.data&&h.processData&&"string"!=typeof h.data&&(h.data=E.param(h.data,h.traditional)),zt(Wt,h,t,b),!d){for(r in(p=E.event&&h.global)&&0==E.active++&&E.event.trigger("ajaxStart"),h.type=h.type.toUpperCase(),h.hasContent=!Mt.test(h.type),l=h.url.replace(Ot,""),h.hasContent?h.data&&h.processData&&0===(h.contentType||"").indexOf("application/x-www-form-urlencoded")&&(h.data=h.data.replace(Ht,"+")):(e=h.url.slice(l.length),h.data&&(h.processData||"string"==typeof h.data)&&(l+=(Nt.test(l)?"&":"?")+h.data,delete h.data),!1===h.cache&&(l=l.replace(Pt,"$1"),e=(Nt.test(l)?"&":"?")+"_="+At.guid+++e),h.url=l+e),h.ifModified&&(E.lastModified[l]&&b.setRequestHeader("If-Modified-Since",E.lastModified[l]),E.etag[l])&&b.setRequestHeader("If-None-Match",E.etag[l]),(h.data&&h.hasContent&&!1!==h.contentType||t.contentType)&&b.setRequestHeader("Content-Type",h.contentType),b.setRequestHeader("Accept",h.dataTypes[0]&&h.accepts[h.dataTypes[0]]?h.accepts[h.dataTypes[0]]+("*"!==h.dataTypes[0]?", "+Bt+"; q=0.01":""):h.accepts["*"]),h.headers)b.setRequestHeader(r,h.headers[r]);if(h.beforeSend&&(!1===h.beforeSend.call(g,b,h)||d))return b.abort();if(a="abort",v.add(h.complete),b.done(h.success),b.fail(h.error),u=zt(Ft,h,t,b)){if(b.readyState=1,p&&y.trigger("ajaxSend",[b,h]),d)return b;h["async"]&&0<h.timeout&&(f=T.setTimeout(function(){b.abort("timeout")},h.timeout));try{d=!1,u.send(i,s)}catch(w){if(d)throw w;s(-1,w)}}else s(-1,"No Transport")}return b;function s(e,t,n,r){var i,o,a,s=t;d||(d=!0,f&&T.clearTimeout(f),u=undefined,c=r||"",b.readyState=0<e?4:0,r=200<=e&&e<300||304===e,n&&(a=function(e,t,n){for(var r,i,o,a,s=e.contents,u=e.dataTypes;"*"===u[0];)u.shift(),r===undefined&&(r=e.mimeType||t.getResponseHeader("Content-Type"));if(r)for(i in s)if(s[i]&&s[i].test(r)){u.unshift(i);break}if(u[0]in n)o=u[0];else{for(i in n){if(!u[0]||e.converters[i+" "+u[0]]){o=i;break}a=a||i}o=o||a}if(o)return o!==u[0]&&u.unshift(o),n[o]}(h,b,n)),!r&&-1<E.inArray("script",h.dataTypes)&&E.inArray("json",h.dataTypes)<0&&(h.converters["text script"]=function(){}),a=Xt(h,a,b,r),r?(h.ifModified&&((n=b.getResponseHeader("Last-Modified"))&&(E.lastModified[l]=n),n=b.getResponseHeader("etag"))&&(E.etag[l]=n),204===e||"HEAD"===h.type?s="nocontent":304===e?s="notmodified":(s=a.state,i=a.data,r=!(o=a.error))):(o=s,!e&&s||(s="error",e<0&&(e=0))),b.status=e,b.statusText=(t||s)+"",r?m.resolveWith(g,[i,s,b]):m.rejectWith(g,[b,s,o]),b.statusCode(x),x=undefined,p&&y.trigger(r?"ajaxSuccess":"ajaxError",[b,h,r?i:o]),v.fireWith(g,[b,s]),p&&(y.trigger("ajaxComplete",[b,h]),--E.active||E.event.trigger("ajaxStop")))}},getJSON:function(e,t,n){return E.get(e,t,n,"json")},getScript:function(e,t){return E.get(e,undefined,t,"script")}}),E.each(["get","post"],function(e,i){E[i]=function(e,t,n,r){return v(t)&&(r=r||n,n=t,t=undefined),E.ajax(E.extend({url:e,type:i,dataType:r,data:t,success:n},E.isPlainObject(e)&&e))}}),E.ajaxPrefilter(function(e){for(var t in e.headers)"content-type"===t.toLowerCase()&&(e.contentType=e.headers[t]||"")}),E._evalUrl=function(e,t,n){return E.ajax({url:e,type:"GET",dataType:"script",cache:!0,"async":!1,global:!1,converters:{"text script":function(){}},dataFilter:function(e){E.globalEval(e,t,n)}})},E.fn.extend({wrapAll:function(e){return this[0]&&(v(e)&&(e=e.call(this[0])),e=E(e,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&e.insertBefore(this[0]),e.map(function(){for(var e=this;e.firstElementChild;)e=e.firstElementChild;return e}).append(this)),this},wrapInner:function(n){return v(n)?this.each(function(e){E(this).wrapInner(n.call(this,e))}):this.each(function(){var e=E(this),t=e.contents();t.length?t.wrapAll(n):e.append(n)})},wrap:function(t){var n=v(t);return this.each(function(e){E(this).wrapAll(n?t.call(this,e):t)})},unwrap:function(e){return this.parent(e).not("body").each(function(){E(this).replaceWith(this.childNodes)}),this}}),E.expr.pseudos.hidden=function(e){return!E.expr.pseudos.visible(e)},E.expr.pseudos.visible=function(e){return!!(e.offsetWidth||e.offsetHeight||e.getClientRects().length)},E.ajaxSettings.xhr=function(){try{return new T.XMLHttpRequest}catch(e){}};var Vt={0:200,1223:204},Gt=E.ajaxSettings.xhr(),Yt=(g.cors=!!Gt&&"withCredentials"in Gt,g.ajax=Gt=!!Gt,E.ajaxTransport(function(o){var a,s;if(g.cors||Gt&&!o.crossDomain)return{send:function(e,t){var n,r=o.xhr();if(r.open(o.type,o.url,o["async"],o.username,o.password),o.xhrFields)for(n in o.xhrFields)r[n]=o.xhrFields[n];for(n in o.mimeType&&r.overrideMimeType&&r.overrideMimeType(o.mimeType),o.crossDomain||e["X-Requested-With"]||(e["X-Requested-With"]="XMLHttpRequest"),e)r.setRequestHeader(n,e[n]);a=function(e){return function(){a&&(a=s=r.onload=r.onerror=r.onabort=r.ontimeout=r.onreadystatechange=null,"abort"===e?r.abort():"error"===e?"number"!=typeof r.status?t(0,"error"):t(r.status,r.statusText):t(Vt[r.status]||r.status,r.statusText,"text"!==(r.responseType||"text")||"string"!=typeof r.responseText?{binary:r.response}:{text:r.responseText},r.getAllResponseHeaders()))}},r.onload=a(),s=r.onerror=r.ontimeout=a("error"),r.onabort!==undefined?r.onabort=s:r.onreadystatechange=function(){4===r.readyState&&T.setTimeout(function(){a&&s()})},a=a("abort");try{r.send(o.hasContent&&o.data||null)}catch(i){if(a)throw i}},abort:function(){a&&a()}}}),E.ajaxPrefilter(function(e){e.crossDomain&&(e.contents.script=!1)}),E.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(e){return E.globalEval(e),e}}}),E.ajaxPrefilter("script",function(e){e.cache===undefined&&(e.cache=!1),e.crossDomain&&(e.type="GET")}),E.ajaxTransport("script",function(n){var r,i;if(n.crossDomain||n.scriptAttrs)return{send:function(e,t){r=E("<script>").attr(n.scriptAttrs||{}).prop({charset:n.scriptCharset,src:n.url}).on("load error",i=function(e){r.remove(),i=null,e&&t("error"===e.type?404:200,e.type)}),C.head.appendChild(r[0])},abort:function(){i&&i()}}}),[]),Qt=/(=)\?(?=&|$)|\?\?/,Jt=(E.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var e=Yt.pop()||E.expando+"_"+At.guid++;return this[e]=!0,e}}),E.ajaxPrefilter("json jsonp",function(e,t,n){var r,i,o,a=!1!==e.jsonp&&(Qt.test(e.url)?"url":"string"==typeof e.data&&0===(e.contentType||"").indexOf("application/x-www-form-urlencoded")&&Qt.test(e.data)&&"data");if(a||"jsonp"===e.dataTypes[0])return r=e.jsonpCallback=v(e.jsonpCallback)?e.jsonpCallback():e.jsonpCallback,a?e[a]=e[a].replace(Qt,"$1"+r):!1!==e.jsonp&&(e.url+=(Nt.test(e.url)?"&":"?")+e.jsonp+"="+r),e.converters["script json"]=function(){return o||E.error(r+" was not called"),o[0]},e.dataTypes[0]="json",i=T[r],T[r]=function(){o=arguments},n.always(function(){i===undefined?E(T).removeProp(r):T[r]=i,e[r]&&(e.jsonpCallback=t.jsonpCallback,Yt.push(r)),o&&v(i)&&i(o[0]),o=i=undefined}),"script"}),g.createHTMLDocument=((e=C.implementation.createHTMLDocument("").body).innerHTML="<form></form><form></form>",2===e.childNodes.length),E.parseHTML=function(e,t,n){var r;return"string"!=typeof e?[]:("boolean"==typeof t&&(n=t,t=!1),t||(g.createHTMLDocument?((r=(t=C.implementation.createHTMLDocument("")).createElement("base")).href=C.location.href,t.head.appendChild(r)):t=C),r=!n&&[],(n=J.exec(e))?[t.createElement(n[1])]:(n=ke([e],t,r),r&&r.length&&E(r).remove(),E.merge([],n.childNodes)))},E.fn.load=function(e,t,n){var r,i,o,a=this,s=e.indexOf(" ");return-1<s&&(r=O(e.slice(s)),e=e.slice(0,s)),v(t)?(n=t,t=undefined):t&&"object"==typeof t&&(i="POST"),0<a.length&&E.ajax({url:e,type:i||"GET",dataType:"html",data:t}).done(function(e){o=arguments,a.html(r?E("<div>").append(E.parseHTML(e)).find(r):e)}).always(n&&function(e,t){a.each(function(){n.apply(this,o||[e.responseText,t,e])})}),this},E.expr.pseudos.animated=function(t){return E.grep(E.timers,function(e){return t===e.elem}).length},E.offset={setOffset:function(e,t,n){var r,i,o,a,s=E.css(e,"position"),u=E(e),l={};"static"===s&&(e.style.position="relative"),o=u.offset(),r=E.css(e,"top"),a=E.css(e,"left"),s=("absolute"===s||"fixed"===s)&&-1<(r+a).indexOf("auto")?(i=(s=u.position()).top,s.left):(i=parseFloat(r)||0,parseFloat(a)||0),null!=(t=v(t)?t.call(e,n,E.extend({},o)):t).top&&(l.top=t.top-o.top+i),null!=t.left&&(l.left=t.left-o.left+s),"using"in t?t.using.call(e,l):u.css(l)}},E.fn.extend({offset:function(t){var e,n;return arguments.length?t===undefined?this:this.each(function(e){E.offset.setOffset(this,t,e)}):(n=this[0])?n.getClientRects().length?(e=n.getBoundingClientRect(),n=n.ownerDocument.defaultView,{top:e.top+n.pageYOffset,left:e.left+n.pageXOffset}):{top:0,left:0}:void 0},position:function(){if(this[0]){var e,t,n,r=this[0],i={top:0,left:0};if("fixed"===E.css(r,"position"))t=r.getBoundingClientRect();else{for(t=this.offset(),n=r.ownerDocument,e=r.offsetParent||n.documentElement;e&&(e===n.body||e===n.documentElement)&&"static"===E.css(e,"position");)e=e.parentNode;e&&e!==r&&1===e.nodeType&&((i=E(e).offset()).top+=E.css(e,"borderTopWidth",!0),i.left+=E.css(e,"borderLeftWidth",!0))}return{top:t.top-i.top-E.css(r,"marginTop",!0),left:t.left-i.left-E.css(r,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){for(var e=this.offsetParent;e&&"static"===E.css(e,"position");)e=e.offsetParent;return e||w})}}),E.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(t,i){var o="pageYOffset"===i;E.fn[t]=function(e){return c(this,function(e,t,n){var r;if(y(e)?r=e:9===e.nodeType&&(r=e.defaultView),n===undefined)return r?r[i]:e[t];r?r.scrollTo(o?r.pageXOffset:n,o?n:r.pageYOffset):e[t]=n},t,e,arguments.length)}}),E.each(["top","left"],function(e,n){E.cssHooks[n]=Ze(g.pixelPosition,function(e,t){if(t)return t=Ke(e,n),Xe.test(t)?E(e).position()[n]+"px":t})}),E.each({Height:"height",Width:"width"},function(a,s){E.each({padding:"inner"+a,content:s,"":"outer"+a},function(r,o){E.fn[o]=function(e,t){var n=arguments.length&&(r||"boolean"!=typeof e),i=r||(!0===e||!0===t?"margin":"border");return c(this,function(e,t,n){var r;return y(e)?0===o.indexOf("outer")?e["inner"+a]:e.document.documentElement["client"+a]:9===e.nodeType?(r=e.documentElement,Math.max(e.body["scroll"+a],r["scroll"+a],e.body["offset"+a],r["offset"+a],r["client"+a])):n===undefined?E.css(e,t,i):E.style(e,t,n,i)},s,n?e:undefined,n)}})}),E.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(e,t){E.fn[t]=function(e){return this.on(t,e)}}),E.fn.extend({bind:function(e,t,n){return this.on(e,null,t,n)},unbind:function(e,t){return this.off(e,null,t)},delegate:function(e,t,n,r){return this.on(t,e,n,r)},undelegate:function(e,t,n){return 1===arguments.length?this.off(e,"**"):this.off(t,e||"**",n)},hover:function(e,t){return this.mouseenter(e).mouseleave(t||e)}}),E.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),function(e,n){E.fn[n]=function(e,t){return 0<arguments.length?this.on(n,null,e,t):this.trigger(n)}}),/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g),Kt=(E.proxy=function(e,t){var n,r;return"string"==typeof t&&(r=e[t],t=e,e=r),v(e)?(n=s.call(arguments,2),(r=function(){return e.apply(t||this,n.concat(s.call(arguments)))}).guid=e.guid=e.guid||E.guid++,r):undefined},E.holdReady=function(e){e?E.readyWait++:E.ready(!0)},E.isArray=Array.isArray,E.parseJSON=JSON.parse,E.nodeName=u,E.isFunction=v,E.isWindow=y,E.camelCase=x,E.type=h,E.now=Date.now,E.isNumeric=function(e){var t=E.type(e);return("number"===t||"string"===t)&&!isNaN(e-parseFloat(e))},E.trim=function(e){return null==e?"":(e+"").replace(Jt,"")},"function"==typeof define&&define.amd&&define("jquery",[],function(){return E}),T.jQuery),Zt=T.$;return E.noConflict=function(e){return T.$===E&&(T.$=Zt),e&&T.jQuery===E&&(T.jQuery=Kt),E},void 0===R&&(T.jQuery=T.$=E),E});
//# sourceMappingURL=jquery.js.map;
!function(n){"function"==typeof define&&define.amd?define(["jquery"],n):"object"==typeof module&&module.exports?module.exports=function(e,t){return t===undefined&&(t="undefined"!=typeof window?require("jquery"):require("jquery")(e)),n(t),t}:n(jQuery)}(function(t){(u=t&&t.fn&&t.fn.select2&&t.fn.select2.amd?t.fn.select2.amd:u)&&u.requirejs||(u?e=u:u={},g={},m={},y={},v={},n=Object.prototype.hasOwnProperty,i=[].slice,_=/\.js$/,h=function(e,t){var n,i,o=c(e),s=o[0],t=t[1];return e=o[1],s&&(n=A(s=l(s,t))),s?e=n&&n.normalize?n.normalize(e,(i=t,function(e){return l(e,i)})):l(e,t):(s=(o=c(e=l(e,t)))[0],e=o[1],s&&(n=A(s))),{f:s?s+"!"+e:e,n:e,pr:s,p:n}},f={require:function(e){return b(e)},exports:function(e){var t=g[e];return void 0!==t?t:g[e]={}},module:function(e){return{id:e,uri:"",exports:g[e],config:(t=e,function(){return y&&y.config&&y.config[t]||{}})};var t}},s=function(e,t,n,i){var o,s,r,a,l,c=[],u=typeof n,d=x(i=i||e);if("undefined"==u||"function"==u){for(t=!t.length&&n.length?["require","exports","module"]:t,a=0;a<t.length;a+=1)if("require"===(s=(r=h(t[a],d)).f))c[a]=f.require(e);else if("exports"===s)c[a]=f.exports(e),l=!0;else if("module"===s)o=c[a]=f.module(e);else if(w(g,s)||w(m,s)||w(v,s))c[a]=A(s);else{if(!r.p)throw new Error(e+" missing "+s);r.p.load(r.n,b(i,!0),function(t){return function(e){g[t]=e}}(s),{}),c[a]=g[s]}u=n?n.apply(g[e],c):undefined,e&&(o&&o.exports!==p&&o.exports!==g[e]?g[e]=o.exports:u===p&&l||(g[e]=u))}else e&&(g[e]=n)},o=e=r=function(e,t,n,i,o){if("string"==typeof e)return f[e]?f[e](t):A(h(e,x(t)).f);if(!e.splice){if((y=e).deps&&r(y.deps,y.callback),!t)return;t.splice?(e=t,t=n,n=null):e=p}return t=t||function(){},"function"==typeof n&&(n=i,i=o),i?s(p,e,t,n):setTimeout(function(){s(p,e,t,n)},4),r},r.config=function(e){return r(e)},o._defined=g,(a=function(e,t,n){if("string"!=typeof e)throw new Error("See almond README: incorrect module build, no module name");t.splice||(n=t,t=[]),w(g,e)||w(m,e)||(m[e]=[e,t,n])}).amd={jQuery:!0},u.requirejs=o,u.require=e,u.define=a),u.define("almond",function(){}),u.define("jquery",[],function(){var e=t||$;return null==e&&console&&console.error&&console.error("Select2: An instance of jQuery or a jQuery-compatible library was not found. Make sure that you are including jQuery before Select2 on your web page."),e}),u.define("select2/utils",["jquery"],function(s){var i={};function c(e){var t,n=e.prototype,i=[];for(t in n)"function"==typeof n[t]&&"constructor"!==t&&i.push(t);return i}i.Extend=function(e,t){var n,i={}.hasOwnProperty;function o(){this.constructor=e}for(n in t)i.call(t,n)&&(e[n]=t[n]);return o.prototype=t.prototype,e.prototype=new o,e.__super__=t.prototype,e},i.Decorate=function(i,o){var e=c(o),t=c(i);function s(){var e=Array.prototype.unshift,t=o.prototype.constructor.length,n=i.prototype.constructor;0<t&&(e.call(arguments,i.prototype.constructor),n=o.prototype.constructor),n.apply(this,arguments)}o.displayName=i.displayName,s.prototype=new function(){this.constructor=s};for(var n=0;n<t.length;n++){var r=t[n];s.prototype[r]=i.prototype[r]}for(var a=0;a<e.length;a++){var l=e[a];s.prototype[l]=function(e){var t=function(){},n=(e in s.prototype&&(t=s.prototype[e]),o.prototype[e]);return function(){return Array.prototype.unshift.call(arguments,t),n.apply(this,arguments)}}(l)}return s};var e=function(){this.listeners={}},n=(e.prototype.on=function(e,t){this.listeners=this.listeners||{},e in this.listeners?this.listeners[e].push(t):this.listeners[e]=[t]},e.prototype.trigger=function(e){var t=Array.prototype.slice,n=t.call(arguments,1);this.listeners=this.listeners||{},0===(n=null==n?[]:n).length&&n.push({}),(n[0]._type=e)in this.listeners&&this.invoke(this.listeners[e],t.call(arguments,1)),"*"in this.listeners&&this.invoke(this.listeners["*"],arguments)},e.prototype.invoke=function(e,t){for(var n=0,i=e.length;n<i;n++)e[n].apply(this,t)},i.Observable=e,i.generateChars=function(e){for(var t="",n=0;n<e;n++)t+=Math.floor(36*Math.random()).toString(36);return t},i.bind=function(e,t){return function(){e.apply(t,arguments)}},i._convertData=function(e){for(var t in e){var n=t.split("-"),i=e;if(1!==n.length){for(var o=0;o<n.length;o++){var s=n[o];(s=s.substring(0,1).toLowerCase()+s.substring(1))in i||(i[s]={}),o==n.length-1&&(i[s]=e[t]),i=i[s]}delete e[t]}}return e},i.hasScroll=function(e,t){var n=s(t),i=t.style.overflowX,o=t.style.overflowY;return(i!==o||"hidden"!==o&&"visible"!==o)&&("scroll"===i||"scroll"===o||n.innerHeight()<t.scrollHeight||n.innerWidth()<t.scrollWidth)},i.escapeMarkup=function(e){var t={"\\":"&#92;","&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;","/":"&#47;"};return"string"!=typeof e?e:String(e).replace(/[&<>"'\/\\]/g,function(e){return t[e]})},i.appendMany=function(e,t){var n;"1.7"===s.fn.jquery.substr(0,3)&&(n=s(),s.map(t,function(e){n=n.add(e)}),t=n),e.append(t)},i.__cache={},0);return i.GetUniqueElementId=function(e){var t=e.getAttribute("data-select2-id");return null==t&&(e.id?(t=e.id,e.setAttribute("data-select2-id",t)):(e.setAttribute("data-select2-id",++n),t=n.toString())),t},i.StoreData=function(e,t,n){e=i.GetUniqueElementId(e);i.__cache[e]||(i.__cache[e]={}),i.__cache[e][t]=n},i.GetData=function(e,t){var n=i.GetUniqueElementId(e);return t?i.__cache[n]&&null!=i.__cache[n][t]?i.__cache[n][t]:s(e).data(t):i.__cache[n]},i.RemoveData=function(e){var t=i.GetUniqueElementId(e);null!=i.__cache[t]&&delete i.__cache[t],e.removeAttribute("data-select2-id")},i}),u.define("select2/results",["jquery","./utils"],function(u,d){function i(e,t,n){this.$element=e,this.data=n,this.options=t,i.__super__.constructor.call(this)}return d.Extend(i,d.Observable),i.prototype.render=function(){var e=u('<ul class="select2-results__options" role="listbox"></ul>');return this.options.get("multiple")&&e.attr("aria-multiselectable","true"),this.$results=e},i.prototype.clear=function(){this.$results.empty()},i.prototype.displayMessage=function(e){var t=this.options.get("escapeMarkup"),n=(this.clear(),this.hideLoading(),u('<li role="alert" aria-live="assertive" class="select2-results__option"></li>')),i=this.options.get("translations").get(e.message);n.append(t(i(e.args))),n[0].className+=" select2-results__message",this.$results.append(n)},i.prototype.hideMessages=function(){this.$results.find(".select2-results__message").remove()},i.prototype.append=function(e){this.hideLoading();var t=[];if(null==e.results||0===e.results.length)0===this.$results.children().length&&this.trigger("results:message",{message:"noResults"});else{e.results=this.sort(e.results);for(var n=0;n<e.results.length;n++){var i=e.results[n],i=this.option(i);t.push(i)}this.$results.append(t)}},i.prototype.position=function(e,t){t.find(".select2-results").append(e)},i.prototype.sort=function(e){return this.options.get("sorter")(e)},i.prototype.highlightFirstItem=function(){var e=this.$results.find(".select2-results__option[aria-selected]"),t=e.filter("[aria-selected=true]");(0<t.length?t:e).first().trigger("mouseenter"),this.ensureHighlightVisible()},i.prototype.setClasses=function(){var t=this;this.data.current(function(e){var i=u.map(e,function(e){return e.id.toString()});t.$results.find(".select2-results__option[aria-selected]").each(function(){var e=u(this),t=d.GetData(this,"data"),n=""+t.id;null!=t.element&&t.element.selected||null==t.element&&-1<u.inArray(n,i)?e.attr("aria-selected","true"):e.attr("aria-selected","false")})})},i.prototype.showLoading=function(e){this.hideLoading();e={disabled:!0,loading:!0,text:this.options.get("translations").get("searching")(e)},e=this.option(e);e.className+=" loading-results",this.$results.prepend(e)},i.prototype.hideLoading=function(){this.$results.find(".loading-results").remove()},i.prototype.option=function(e){var t,n=document.createElement("li"),i=(n.className="select2-results__option",{role:"option","aria-selected":"false"}),o=window.Element.prototype.matches||window.Element.prototype.msMatchesSelector||window.Element.prototype.webkitMatchesSelector;for(t in(null!=e.element&&o.call(e.element,":disabled")||null==e.element&&e.disabled)&&(delete i["aria-selected"],i["aria-disabled"]="true"),null==e.id&&delete i["aria-selected"],null!=e._resultId&&(n.id=e._resultId),e.title&&(n.title=e.title),e.children&&(i.role="group",i["aria-label"]=e.text,delete i["aria-selected"]),i)n.setAttribute(t,i[t]);if(e.children){for(var o=u(n),s=document.createElement("strong"),r=(s.className="select2-results__group",u(s),this.template(e,s),[]),a=0;a<e.children.length;a++){var l=e.children[a],l=this.option(l);r.push(l)}var c=u("<ul></ul>",{"class":"select2-results__options select2-results__options--nested"});c.append(r),o.append(s),o.append(c)}else this.template(e,n);return d.StoreData(n,"data",e),n},i.prototype.bind=function(t,e){var o=this,n=t.id+"-results";this.$results.attr("id",n),t.on("results:all",function(e){o.clear(),o.append(e.data),t.isOpen()&&(o.setClasses(),o.highlightFirstItem())}),t.on("results:append",function(e){o.append(e.data),t.isOpen()&&o.setClasses()}),t.on("query",function(e){o.hideMessages(),o.showLoading(e)}),t.on("select",function(){t.isOpen()&&(o.setClasses(),o.options.get("scrollAfterSelect"))&&o.highlightFirstItem()}),t.on("unselect",function(){t.isOpen()&&(o.setClasses(),o.options.get("scrollAfterSelect"))&&o.highlightFirstItem()}),t.on("open",function(){o.$results.attr("aria-expanded","true"),o.$results.attr("aria-hidden","false"),o.setClasses(),o.ensureHighlightVisible()}),t.on("close",function(){o.$results.attr("aria-expanded","false"),o.$results.attr("aria-hidden","true"),o.$results.removeAttr("aria-activedescendant")}),t.on("results:toggle",function(){var e=o.getHighlightedResults();0!==e.length&&e.trigger("mouseup")}),t.on("results:select",function(){var e,t=o.getHighlightedResults();0!==t.length&&(e=d.GetData(t[0],"data"),"true"==t.attr("aria-selected")?o.trigger("close",{}):o.trigger("select",{data:e}))}),t.on("results:previous",function(){var e,t=o.getHighlightedResults(),n=o.$results.find("[aria-selected]"),i=n.index(t);i<=0||(i=i-1,0===t.length&&(i=0),(t=n.eq(i)).trigger("mouseenter"),n=o.$results.offset().top,t=t.offset().top,e=o.$results.scrollTop()+(t-n),0===i?o.$results.scrollTop(0):t-n<0&&o.$results.scrollTop(e))}),t.on("results:next",function(){var e,t,n=o.getHighlightedResults(),i=o.$results.find("[aria-selected]"),n=i.index(n)+1;n>=i.length||((i=i.eq(n)).trigger("mouseenter"),e=o.$results.offset().top+o.$results.outerHeight(!1),i=i.offset().top+i.outerHeight(!1),t=o.$results.scrollTop()+i-e,0===n?o.$results.scrollTop(0):e<i&&o.$results.scrollTop(t))}),t.on("results:focus",function(e){e.element.addClass("select2-results__option--highlighted")}),t.on("results:message",function(e){o.displayMessage(e)}),u.fn.mousewheel&&this.$results.on("mousewheel",function(e){var t=o.$results.scrollTop(),n=o.$results.get(0).scrollHeight-t+e.deltaY,t=0<e.deltaY&&t-e.deltaY<=0,n=e.deltaY<0&&n<=o.$results.height();t?(o.$results.scrollTop(0),e.preventDefault(),e.stopPropagation()):n&&(o.$results.scrollTop(o.$results.get(0).scrollHeight-o.$results.height()),e.preventDefault(),e.stopPropagation())}),this.$results.on("mouseup",".select2-results__option[aria-selected]",function(e){var t=u(this),n=d.GetData(this,"data");"true"===t.attr("aria-selected")?o.options.get("multiple")?o.trigger("unselect",{originalEvent:e,data:n}):o.trigger("close",{}):o.trigger("select",{originalEvent:e,data:n})}),this.$results.on("mouseenter",".select2-results__option[aria-selected]",function(e){var t=d.GetData(this,"data");o.getHighlightedResults().removeClass("select2-results__option--highlighted"),o.trigger("results:focus",{data:t,element:u(this)})})},i.prototype.getHighlightedResults=function(){return this.$results.find(".select2-results__option--highlighted")},i.prototype.destroy=function(){this.$results.remove()},i.prototype.ensureHighlightVisible=function(){var e,t,n,i,o=this.getHighlightedResults();0!==o.length&&(e=this.$results.find("[aria-selected]").index(o),t=this.$results.offset().top,i=o.offset().top,n=this.$results.scrollTop()+(i-t),i=i-t,n-=2*o.outerHeight(!1),e<=2?this.$results.scrollTop(0):(i>this.$results.outerHeight()||i<0)&&this.$results.scrollTop(n))},i.prototype.template=function(e,t){var n=this.options.get("templateResult"),i=this.options.get("escapeMarkup"),e=n(e,t);null==e?t.style.display="none":"string"==typeof e?t.innerHTML=i(e):u(t).append(e)},i}),u.define("select2/keys",[],function(){return{BACKSPACE:8,TAB:9,ENTER:13,SHIFT:16,CTRL:17,ALT:18,ESC:27,SPACE:32,PAGE_UP:33,PAGE_DOWN:34,END:35,HOME:36,LEFT:37,UP:38,RIGHT:39,DOWN:40,DELETE:46}}),u.define("select2/selection/base",["jquery","../utils","../keys"],function(n,i,o){function s(e,t){this.$element=e,this.options=t,s.__super__.constructor.call(this)}return i.Extend(s,i.Observable),s.prototype.render=function(){var e=n('<span class="select2-selection" role="combobox"  aria-haspopup="true" aria-expanded="false"></span>');return this._tabindex=0,null!=i.GetData(this.$element[0],"old-tabindex")?this._tabindex=i.GetData(this.$element[0],"old-tabindex"):null!=this.$element.attr("tabindex")&&(this._tabindex=this.$element.attr("tabindex")),e.attr("title",this.$element.attr("title")),e.attr("tabindex",this._tabindex),e.attr("aria-disabled","false"),this.$selection=e},s.prototype.bind=function(e,t){var n=this,i=e.id+"-results";this.container=e,this.$selection.on("focus",function(e){n.trigger("focus",e)}),this.$selection.on("blur",function(e){n._handleBlur(e)}),this.$selection.on("keydown",function(e){n.trigger("keypress",e),e.which===o.SPACE&&e.preventDefault()}),e.on("results:focus",function(e){n.$selection.attr("aria-activedescendant",e.data._resultId)}),e.on("selection:update",function(e){n.update(e.data)}),e.on("open",function(){n.$selection.attr("aria-expanded","true"),n.$selection.attr("aria-owns",i),n._attachCloseHandler(e)}),e.on("close",function(){n.$selection.attr("aria-expanded","false"),n.$selection.removeAttr("aria-activedescendant"),n.$selection.removeAttr("aria-owns"),n.$selection.trigger("focus"),n._detachCloseHandler(e)}),e.on("enable",function(){n.$selection.attr("tabindex",n._tabindex),n.$selection.attr("aria-disabled","false")}),e.on("disable",function(){n.$selection.attr("tabindex","-1"),n.$selection.attr("aria-disabled","true")})},s.prototype._handleBlur=function(e){var t=this;window.setTimeout(function(){document.activeElement==t.$selection[0]||n.contains(t.$selection[0],document.activeElement)||t.trigger("blur",e)},1)},s.prototype._attachCloseHandler=function(e){n(document.body).on("mousedown.select2."+e.id,function(e){var t=n(e.target).closest(".select2");n(".select2.select2-container--open").each(function(){this!=t[0]&&i.GetData(this,"element").select2("close")})})},s.prototype._detachCloseHandler=function(e){n(document.body).off("mousedown.select2."+e.id)},s.prototype.position=function(e,t){t.find(".selection").append(e)},s.prototype.destroy=function(){this._detachCloseHandler(this.container)},s.prototype.update=function(e){throw new Error("The `update` method must be defined in child classes.")},s.prototype.isEnabled=function(){return!this.isDisabled()},s.prototype.isDisabled=function(){return this.options.get("disabled")},s}),u.define("select2/selection/single",["jquery","./base","../utils","../keys"],function(e,t,n,i){function o(){o.__super__.constructor.apply(this,arguments)}return n.Extend(o,t),o.prototype.render=function(){var e=o.__super__.render.call(this);return e.addClass("select2-selection--single"),e.html('<span class="select2-selection__rendered"></span><span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span>'),e},o.prototype.bind=function(t,e){var n=this,i=(o.__super__.bind.apply(this,arguments),t.id+"-container");this.$selection.find(".select2-selection__rendered").attr("id",i).attr("role","textbox").attr("aria-readonly","true"),this.$selection.attr("aria-labelledby",i),this.$selection.on("mousedown",function(e){1===e.which&&n.trigger("toggle",{originalEvent:e})}),this.$selection.on("focus",function(e){}),this.$selection.on("blur",function(e){}),t.on("focus",function(e){t.isOpen()||n.$selection.trigger("focus")})},o.prototype.clear=function(){var e=this.$selection.find(".select2-selection__rendered");e.empty(),e.removeAttr("title")},o.prototype.display=function(e,t){var n=this.options.get("templateSelection");return this.options.get("escapeMarkup")(n(e,t))},o.prototype.selectionContainer=function(){return e("<span></span>")},o.prototype.update=function(e){var t,n;0===e.length?this.clear():(e=e[0],t=this.$selection.find(".select2-selection__rendered"),n=this.display(e,t),t.empty().append(n),(n=e.title||e.text)?t.attr("title",n):t.removeAttr("title"))},o}),u.define("select2/selection/multiple",["jquery","./base","../utils"],function(i,e,a){function o(e,t){o.__super__.constructor.apply(this,arguments)}return a.Extend(o,e),o.prototype.render=function(){var e=o.__super__.render.call(this);return e.addClass("select2-selection--multiple"),e.html('<ul class="select2-selection__rendered"></ul>'),e},o.prototype.bind=function(e,t){var n=this;o.__super__.bind.apply(this,arguments),this.$selection.on("click",function(e){n.trigger("toggle",{originalEvent:e})}),this.$selection.on("click",".select2-selection__choice__remove",function(e){var t;n.isDisabled()||(t=i(this).parent(),t=a.GetData(t[0],"data"),n.trigger("unselect",{originalEvent:e,data:t}))})},o.prototype.clear=function(){var e=this.$selection.find(".select2-selection__rendered");e.empty(),e.removeAttr("title")},o.prototype.display=function(e,t){var n=this.options.get("templateSelection");return this.options.get("escapeMarkup")(n(e,t))},o.prototype.selectionContainer=function(){return i('<li class="select2-selection__choice"><span class="select2-selection__choice__remove" role="presentation">&times;</span></li>')},o.prototype.update=function(e){if(this.clear(),0!==e.length){for(var t=[],n=0;n<e.length;n++){var i=e[n],o=this.selectionContainer(),s=this.display(i,o),s=(o.append(s),i.title||i.text);s&&o.attr("title",s),a.StoreData(o[0],"data",i),t.push(o)}var r=this.$selection.find(".select2-selection__rendered");a.appendMany(r,t)}},o}),u.define("select2/selection/placeholder",["../utils"],function(e){function t(e,t,n){this.placeholder=this.normalizePlaceholder(n.get("placeholder")),e.call(this,t,n)}return t.prototype.normalizePlaceholder=function(e,t){return t="string"==typeof t?{id:"",text:t}:t},t.prototype.createPlaceholder=function(e,t){var n=this.selectionContainer();return n.html(this.display(t)),n.addClass("select2-selection__placeholder").removeClass("select2-selection__choice"),n},t.prototype.update=function(e,t){var n=1==t.length&&t[0].id!=this.placeholder.id;if(1<t.length||n)return e.call(this,t);this.clear();n=this.createPlaceholder(this.placeholder);this.$selection.find(".select2-selection__rendered").append(n)},t}),u.define("select2/selection/allowClear",["jquery","../keys","../utils"],function(n,i,a){function e(){}return e.prototype.bind=function(e,t,n){var i=this;e.call(this,t,n),null==this.placeholder&&this.options.get("debug")&&window.console&&console.error&&console.error("Select2: The `allowClear` option should be used in combination with the `placeholder` option."),this.$selection.on("mousedown",".select2-selection__clear",function(e){i._handleClear(e)}),t.on("keypress",function(e){i._handleKeyboardClear(e,t)})},e.prototype._handleClear=function(e,t){if(!this.isDisabled()){var n=this.$selection.find(".select2-selection__clear");if(0!==n.length){t.stopPropagation();var i=a.GetData(n[0],"data"),o=this.$element.val(),s=(this.$element.val(this.placeholder.id),{data:i});if(this.trigger("clear",s),s.prevented)this.$element.val(o);else{for(var r=0;r<i.length;r++)if(s={data:i[r]},this.trigger("unselect",s),s.prevented)return void this.$element.val(o);this.$element.trigger("input").trigger("change"),this.trigger("toggle",{})}}}},e.prototype._handleKeyboardClear=function(e,t,n){n.isOpen()||t.which!=i.DELETE&&t.which!=i.BACKSPACE||this._handleClear(t)},e.prototype.update=function(e,t){e.call(this,t),0<this.$selection.find(".select2-selection__placeholder").length||0===t.length||(e=this.options.get("translations").get("removeAllItems"),e=n('<span class="select2-selection__clear" title="'+e()+'">&times;</span>'),a.StoreData(e[0],"data",t),this.$selection.find(".select2-selection__rendered").prepend(e))},e}),u.define("select2/selection/search",["jquery","../utils","../keys"],function(n,r,a){function e(e,t,n){e.call(this,t,n)}return e.prototype.render=function(e){var t=n('<li class="select2-search select2-search--inline"><input class="select2-search__field" type="search" tabindex="-1" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" role="searchbox" aria-autocomplete="list" /></li>'),t=(this.$searchContainer=t,this.$search=t.find("input"),e.call(this));return this._transferTabIndex(),t},e.prototype.bind=function(e,t,n){var i=this,o=t.id+"-results",n=(e.call(this,t,n),t.on("open",function(){i.$search.attr("aria-controls",o),i.$search.trigger("focus")}),t.on("close",function(){i.$search.val(""),i.$search.removeAttr("aria-controls"),i.$search.removeAttr("aria-activedescendant"),i.$search.trigger("focus")}),t.on("enable",function(){i.$search.prop("disabled",!1),i._transferTabIndex()}),t.on("disable",function(){i.$search.prop("disabled",!0)}),t.on("focus",function(e){i.$search.trigger("focus")}),t.on("results:focus",function(e){e.data._resultId?i.$search.attr("aria-activedescendant",e.data._resultId):i.$search.removeAttr("aria-activedescendant")}),this.$selection.on("focusin",".select2-search--inline",function(e){i.trigger("focus",e)}),this.$selection.on("focusout",".select2-search--inline",function(e){i._handleBlur(e)}),this.$selection.on("keydown",".select2-search--inline",function(e){var t;e.stopPropagation(),i.trigger("keypress",e),i._keyUpPrevented=e.isDefaultPrevented(),e.which===a.BACKSPACE&&""===i.$search.val()&&0<(t=i.$searchContainer.prev(".select2-selection__choice")).length&&(t=r.GetData(t[0],"data"),i.searchRemoveChoice(t),e.preventDefault())}),this.$selection.on("click",".select2-search--inline",function(e){i.$search.val()&&e.stopPropagation()}),document.documentMode),s=n&&n<=11;this.$selection.on("input.searchcheck",".select2-search--inline",function(e){s?i.$selection.off("input.search input.searchcheck"):i.$selection.off("keyup.search")}),this.$selection.on("keyup.search input.search",".select2-search--inline",function(e){var t;s&&"input"===e.type?i.$selection.off("input.search input.searchcheck"):(t=e.which)!=a.SHIFT&&t!=a.CTRL&&t!=a.ALT&&t!=a.TAB&&i.handleSearch(e)})},e.prototype._transferTabIndex=function(e){this.$search.attr("tabindex",this.$selection.attr("tabindex")),this.$selection.attr("tabindex","-1")},e.prototype.createPlaceholder=function(e,t){this.$search.attr("placeholder",t.text)},e.prototype.update=function(e,t){var n=this.$search[0]==document.activeElement;this.$search.attr("placeholder",""),e.call(this,t),this.$selection.find(".select2-selection__rendered").append(this.$searchContainer),this.resizeSearch(),n&&this.$search.trigger("focus")},e.prototype.handleSearch=function(){var e;this.resizeSearch(),this._keyUpPrevented||(e=this.$search.val(),this.trigger("query",{term:e})),this._keyUpPrevented=!1},e.prototype.searchRemoveChoice=function(e,t){this.trigger("unselect",{data:t}),this.$search.val(t.text),this.handleSearch()},e.prototype.resizeSearch=function(){this.$search.css("width","25px");var e="";e=""!==this.$search.attr("placeholder")?this.$selection.find(".select2-selection__rendered").width():.75*(this.$search.val().length+1)+"em",this.$search.css("width",e)},e}),u.define("select2/selection/eventRelay",["jquery"],function(r){function e(){}return e.prototype.bind=function(e,t,n){var i=this,o=["open","opening","close","closing","select","selecting","unselect","unselecting","clear","clearing"],s=["opening","closing","selecting","unselecting","clearing"];e.call(this,t,n),t.on("*",function(e,t){var n;-1!==r.inArray(e,o)&&(n=r.Event("select2:"+e,{params:t=t||{}}),i.$element.trigger(n),-1!==r.inArray(e,s))&&(t.prevented=n.isDefaultPrevented())})},e}),u.define("select2/translation",["jquery","require"],function(t,n){function i(e){this.dict=e||{}}return i.prototype.all=function(){return this.dict},i.prototype.get=function(e){return this.dict[e]},i.prototype.extend=function(e){this.dict=t.extend({},e.all(),this.dict)},i._cache={},i.loadPath=function(e){var t;return e in i._cache||(t=n(e),i._cache[e]=t),new i(i._cache[e])},i}),u.define("select2/diacritics",[],function(){return{"Ⓐ":"A","Ａ":"A","À":"A","Á":"A","Â":"A","Ầ":"A","Ấ":"A","Ẫ":"A","Ẩ":"A","Ã":"A","Ā":"A","Ă":"A","Ằ":"A","Ắ":"A","Ẵ":"A","Ẳ":"A","Ȧ":"A","Ǡ":"A","Ä":"A","Ǟ":"A","Ả":"A","Å":"A","Ǻ":"A","Ǎ":"A","Ȁ":"A","Ȃ":"A","Ạ":"A","Ậ":"A","Ặ":"A","Ḁ":"A","Ą":"A","Ⱥ":"A","Ɐ":"A","Ꜳ":"AA","Æ":"AE","Ǽ":"AE","Ǣ":"AE","Ꜵ":"AO","Ꜷ":"AU","Ꜹ":"AV","Ꜻ":"AV","Ꜽ":"AY","Ⓑ":"B","Ｂ":"B","Ḃ":"B","Ḅ":"B","Ḇ":"B","Ƀ":"B","Ƃ":"B","Ɓ":"B","Ⓒ":"C","Ｃ":"C","Ć":"C","Ĉ":"C","Ċ":"C","Č":"C","Ç":"C","Ḉ":"C","Ƈ":"C","Ȼ":"C","Ꜿ":"C","Ⓓ":"D","Ｄ":"D","Ḋ":"D","Ď":"D","Ḍ":"D","Ḑ":"D","Ḓ":"D","Ḏ":"D","Đ":"D","Ƌ":"D","Ɗ":"D","Ɖ":"D","Ꝺ":"D","Ǳ":"DZ","Ǆ":"DZ","ǲ":"Dz","ǅ":"Dz","Ⓔ":"E","Ｅ":"E","È":"E","É":"E","Ê":"E","Ề":"E","Ế":"E","Ễ":"E","Ể":"E","Ẽ":"E","Ē":"E","Ḕ":"E","Ḗ":"E","Ĕ":"E","Ė":"E","Ë":"E","Ẻ":"E","Ě":"E","Ȅ":"E","Ȇ":"E","Ẹ":"E","Ệ":"E","Ȩ":"E","Ḝ":"E","Ę":"E","Ḙ":"E","Ḛ":"E","Ɛ":"E","Ǝ":"E","Ⓕ":"F","Ｆ":"F","Ḟ":"F","Ƒ":"F","Ꝼ":"F","Ⓖ":"G","Ｇ":"G","Ǵ":"G","Ĝ":"G","Ḡ":"G","Ğ":"G","Ġ":"G","Ǧ":"G","Ģ":"G","Ǥ":"G","Ɠ":"G","Ꞡ":"G","Ᵹ":"G","Ꝿ":"G","Ⓗ":"H","Ｈ":"H","Ĥ":"H","Ḣ":"H","Ḧ":"H","Ȟ":"H","Ḥ":"H","Ḩ":"H","Ḫ":"H","Ħ":"H","Ⱨ":"H","Ⱶ":"H","Ɥ":"H","Ⓘ":"I","Ｉ":"I","Ì":"I","Í":"I","Î":"I","Ĩ":"I","Ī":"I","Ĭ":"I","İ":"I","Ï":"I","Ḯ":"I","Ỉ":"I","Ǐ":"I","Ȉ":"I","Ȋ":"I","Ị":"I","Į":"I","Ḭ":"I","Ɨ":"I","Ⓙ":"J","Ｊ":"J","Ĵ":"J","Ɉ":"J","Ⓚ":"K","Ｋ":"K","Ḱ":"K","Ǩ":"K","Ḳ":"K","Ķ":"K","Ḵ":"K","Ƙ":"K","Ⱪ":"K","Ꝁ":"K","Ꝃ":"K","Ꝅ":"K","Ꞣ":"K","Ⓛ":"L","Ｌ":"L","Ŀ":"L","Ĺ":"L","Ľ":"L","Ḷ":"L","Ḹ":"L","Ļ":"L","Ḽ":"L","Ḻ":"L","Ł":"L","Ƚ":"L","Ɫ":"L","Ⱡ":"L","Ꝉ":"L","Ꝇ":"L","Ꞁ":"L","Ǉ":"LJ","ǈ":"Lj","Ⓜ":"M","Ｍ":"M","Ḿ":"M","Ṁ":"M","Ṃ":"M","Ɱ":"M","Ɯ":"M","Ⓝ":"N","Ｎ":"N","Ǹ":"N","Ń":"N","Ñ":"N","Ṅ":"N","Ň":"N","Ṇ":"N","Ņ":"N","Ṋ":"N","Ṉ":"N","Ƞ":"N","Ɲ":"N","Ꞑ":"N","Ꞥ":"N","Ǌ":"NJ","ǋ":"Nj","Ⓞ":"O","Ｏ":"O","Ò":"O","Ó":"O","Ô":"O","Ồ":"O","Ố":"O","Ỗ":"O","Ổ":"O","Õ":"O","Ṍ":"O","Ȭ":"O","Ṏ":"O","Ō":"O","Ṑ":"O","Ṓ":"O","Ŏ":"O","Ȯ":"O","Ȱ":"O","Ö":"O","Ȫ":"O","Ỏ":"O","Ő":"O","Ǒ":"O","Ȍ":"O","Ȏ":"O","Ơ":"O","Ờ":"O","Ớ":"O","Ỡ":"O","Ở":"O","Ợ":"O","Ọ":"O","Ộ":"O","Ǫ":"O","Ǭ":"O","Ø":"O","Ǿ":"O","Ɔ":"O","Ɵ":"O","Ꝋ":"O","Ꝍ":"O","Œ":"OE","Ƣ":"OI","Ꝏ":"OO","Ȣ":"OU","Ⓟ":"P","Ｐ":"P","Ṕ":"P","Ṗ":"P","Ƥ":"P","Ᵽ":"P","Ꝑ":"P","Ꝓ":"P","Ꝕ":"P","Ⓠ":"Q","Ｑ":"Q","Ꝗ":"Q","Ꝙ":"Q","Ɋ":"Q","Ⓡ":"R","Ｒ":"R","Ŕ":"R","Ṙ":"R","Ř":"R","Ȑ":"R","Ȓ":"R","Ṛ":"R","Ṝ":"R","Ŗ":"R","Ṟ":"R","Ɍ":"R","Ɽ":"R","Ꝛ":"R","Ꞧ":"R","Ꞃ":"R","Ⓢ":"S","Ｓ":"S","ẞ":"S","Ś":"S","Ṥ":"S","Ŝ":"S","Ṡ":"S","Š":"S","Ṧ":"S","Ṣ":"S","Ṩ":"S","Ș":"S","Ş":"S","Ȿ":"S","Ꞩ":"S","Ꞅ":"S","Ⓣ":"T","Ｔ":"T","Ṫ":"T","Ť":"T","Ṭ":"T","Ț":"T","Ţ":"T","Ṱ":"T","Ṯ":"T","Ŧ":"T","Ƭ":"T","Ʈ":"T","Ⱦ":"T","Ꞇ":"T","Ꜩ":"TZ","Ⓤ":"U","Ｕ":"U","Ù":"U","Ú":"U","Û":"U","Ũ":"U","Ṹ":"U","Ū":"U","Ṻ":"U","Ŭ":"U","Ü":"U","Ǜ":"U","Ǘ":"U","Ǖ":"U","Ǚ":"U","Ủ":"U","Ů":"U","Ű":"U","Ǔ":"U","Ȕ":"U","Ȗ":"U","Ư":"U","Ừ":"U","Ứ":"U","Ữ":"U","Ử":"U","Ự":"U","Ụ":"U","Ṳ":"U","Ų":"U","Ṷ":"U","Ṵ":"U","Ʉ":"U","Ⓥ":"V","Ｖ":"V","Ṽ":"V","Ṿ":"V","Ʋ":"V","Ꝟ":"V","Ʌ":"V","Ꝡ":"VY","Ⓦ":"W","Ｗ":"W","Ẁ":"W","Ẃ":"W","Ŵ":"W","Ẇ":"W","Ẅ":"W","Ẉ":"W","Ⱳ":"W","Ⓧ":"X","Ｘ":"X","Ẋ":"X","Ẍ":"X","Ⓨ":"Y","Ｙ":"Y","Ỳ":"Y","Ý":"Y","Ŷ":"Y","Ỹ":"Y","Ȳ":"Y","Ẏ":"Y","Ÿ":"Y","Ỷ":"Y","Ỵ":"Y","Ƴ":"Y","Ɏ":"Y","Ỿ":"Y","Ⓩ":"Z","Ｚ":"Z","Ź":"Z","Ẑ":"Z","Ż":"Z","Ž":"Z","Ẓ":"Z","Ẕ":"Z","Ƶ":"Z","Ȥ":"Z","Ɀ":"Z","Ⱬ":"Z","Ꝣ":"Z","ⓐ":"a","ａ":"a","ẚ":"a","à":"a","á":"a","â":"a","ầ":"a","ấ":"a","ẫ":"a","ẩ":"a","ã":"a","ā":"a","ă":"a","ằ":"a","ắ":"a","ẵ":"a","ẳ":"a","ȧ":"a","ǡ":"a","ä":"a","ǟ":"a","ả":"a","å":"a","ǻ":"a","ǎ":"a","ȁ":"a","ȃ":"a","ạ":"a","ậ":"a","ặ":"a","ḁ":"a","ą":"a","ⱥ":"a","ɐ":"a","ꜳ":"aa","æ":"ae","ǽ":"ae","ǣ":"ae","ꜵ":"ao","ꜷ":"au","ꜹ":"av","ꜻ":"av","ꜽ":"ay","ⓑ":"b","ｂ":"b","ḃ":"b","ḅ":"b","ḇ":"b","ƀ":"b","ƃ":"b","ɓ":"b","ⓒ":"c","ｃ":"c","ć":"c","ĉ":"c","ċ":"c","č":"c","ç":"c","ḉ":"c","ƈ":"c","ȼ":"c","ꜿ":"c","ↄ":"c","ⓓ":"d","ｄ":"d","ḋ":"d","ď":"d","ḍ":"d","ḑ":"d","ḓ":"d","ḏ":"d","đ":"d","ƌ":"d","ɖ":"d","ɗ":"d","ꝺ":"d","ǳ":"dz","ǆ":"dz","ⓔ":"e","ｅ":"e","è":"e","é":"e","ê":"e","ề":"e","ế":"e","ễ":"e","ể":"e","ẽ":"e","ē":"e","ḕ":"e","ḗ":"e","ĕ":"e","ė":"e","ë":"e","ẻ":"e","ě":"e","ȅ":"e","ȇ":"e","ẹ":"e","ệ":"e","ȩ":"e","ḝ":"e","ę":"e","ḙ":"e","ḛ":"e","ɇ":"e","ɛ":"e","ǝ":"e","ⓕ":"f","ｆ":"f","ḟ":"f","ƒ":"f","ꝼ":"f","ⓖ":"g","ｇ":"g","ǵ":"g","ĝ":"g","ḡ":"g","ğ":"g","ġ":"g","ǧ":"g","ģ":"g","ǥ":"g","ɠ":"g","ꞡ":"g","ᵹ":"g","ꝿ":"g","ⓗ":"h","ｈ":"h","ĥ":"h","ḣ":"h","ḧ":"h","ȟ":"h","ḥ":"h","ḩ":"h","ḫ":"h","ẖ":"h","ħ":"h","ⱨ":"h","ⱶ":"h","ɥ":"h","ƕ":"hv","ⓘ":"i","ｉ":"i","ì":"i","í":"i","î":"i","ĩ":"i","ī":"i","ĭ":"i","ï":"i","ḯ":"i","ỉ":"i","ǐ":"i","ȉ":"i","ȋ":"i","ị":"i","į":"i","ḭ":"i","ɨ":"i","ı":"i","ⓙ":"j","ｊ":"j","ĵ":"j","ǰ":"j","ɉ":"j","ⓚ":"k","ｋ":"k","ḱ":"k","ǩ":"k","ḳ":"k","ķ":"k","ḵ":"k","ƙ":"k","ⱪ":"k","ꝁ":"k","ꝃ":"k","ꝅ":"k","ꞣ":"k","ⓛ":"l","ｌ":"l","ŀ":"l","ĺ":"l","ľ":"l","ḷ":"l","ḹ":"l","ļ":"l","ḽ":"l","ḻ":"l","ſ":"l","ł":"l","ƚ":"l","ɫ":"l","ⱡ":"l","ꝉ":"l","ꞁ":"l","ꝇ":"l","ǉ":"lj","ⓜ":"m","ｍ":"m","ḿ":"m","ṁ":"m","ṃ":"m","ɱ":"m","ɯ":"m","ⓝ":"n","ｎ":"n","ǹ":"n","ń":"n","ñ":"n","ṅ":"n","ň":"n","ṇ":"n","ņ":"n","ṋ":"n","ṉ":"n","ƞ":"n","ɲ":"n","ŉ":"n","ꞑ":"n","ꞥ":"n","ǌ":"nj","ⓞ":"o","ｏ":"o","ò":"o","ó":"o","ô":"o","ồ":"o","ố":"o","ỗ":"o","ổ":"o","õ":"o","ṍ":"o","ȭ":"o","ṏ":"o","ō":"o","ṑ":"o","ṓ":"o","ŏ":"o","ȯ":"o","ȱ":"o","ö":"o","ȫ":"o","ỏ":"o","ő":"o","ǒ":"o","ȍ":"o","ȏ":"o","ơ":"o","ờ":"o","ớ":"o","ỡ":"o","ở":"o","ợ":"o","ọ":"o","ộ":"o","ǫ":"o","ǭ":"o","ø":"o","ǿ":"o","ɔ":"o","ꝋ":"o","ꝍ":"o","ɵ":"o","œ":"oe","ƣ":"oi","ȣ":"ou","ꝏ":"oo","ⓟ":"p","ｐ":"p","ṕ":"p","ṗ":"p","ƥ":"p","ᵽ":"p","ꝑ":"p","ꝓ":"p","ꝕ":"p","ⓠ":"q","ｑ":"q","ɋ":"q","ꝗ":"q","ꝙ":"q","ⓡ":"r","ｒ":"r","ŕ":"r","ṙ":"r","ř":"r","ȑ":"r","ȓ":"r","ṛ":"r","ṝ":"r","ŗ":"r","ṟ":"r","ɍ":"r","ɽ":"r","ꝛ":"r","ꞧ":"r","ꞃ":"r","ⓢ":"s","ｓ":"s","ß":"s","ś":"s","ṥ":"s","ŝ":"s","ṡ":"s","š":"s","ṧ":"s","ṣ":"s","ṩ":"s","ș":"s","ş":"s","ȿ":"s","ꞩ":"s","ꞅ":"s","ẛ":"s","ⓣ":"t","ｔ":"t","ṫ":"t","ẗ":"t","ť":"t","ṭ":"t","ț":"t","ţ":"t","ṱ":"t","ṯ":"t","ŧ":"t","ƭ":"t","ʈ":"t","ⱦ":"t","ꞇ":"t","ꜩ":"tz","ⓤ":"u","ｕ":"u","ù":"u","ú":"u","û":"u","ũ":"u","ṹ":"u","ū":"u","ṻ":"u","ŭ":"u","ü":"u","ǜ":"u","ǘ":"u","ǖ":"u","ǚ":"u","ủ":"u","ů":"u","ű":"u","ǔ":"u","ȕ":"u","ȗ":"u","ư":"u","ừ":"u","ứ":"u","ữ":"u","ử":"u","ự":"u","ụ":"u","ṳ":"u","ų":"u","ṷ":"u","ṵ":"u","ʉ":"u","ⓥ":"v","ｖ":"v","ṽ":"v","ṿ":"v","ʋ":"v","ꝟ":"v","ʌ":"v","ꝡ":"vy","ⓦ":"w","ｗ":"w","ẁ":"w","ẃ":"w","ŵ":"w","ẇ":"w","ẅ":"w","ẘ":"w","ẉ":"w","ⱳ":"w","ⓧ":"x","ｘ":"x","ẋ":"x","ẍ":"x","ⓨ":"y","ｙ":"y","ỳ":"y","ý":"y","ŷ":"y","ỹ":"y","ȳ":"y","ẏ":"y","ÿ":"y","ỷ":"y","ẙ":"y","ỵ":"y","ƴ":"y","ɏ":"y","ỿ":"y","ⓩ":"z","ｚ":"z","ź":"z","ẑ":"z","ż":"z","ž":"z","ẓ":"z","ẕ":"z","ƶ":"z","ȥ":"z","ɀ":"z","ⱬ":"z","ꝣ":"z","Ά":"Α","Έ":"Ε","Ή":"Η","Ί":"Ι","Ϊ":"Ι","Ό":"Ο","Ύ":"Υ","Ϋ":"Υ","Ώ":"Ω","ά":"α","έ":"ε","ή":"η","ί":"ι","ϊ":"ι","ΐ":"ι","ό":"ο","ύ":"υ","ϋ":"υ","ΰ":"υ","ώ":"ω","ς":"σ","’":"'"}}),u.define("select2/data/base",["../utils"],function(n){function i(e,t){i.__super__.constructor.call(this)}return n.Extend(i,n.Observable),i.prototype.current=function(e){throw new Error("The `current` method must be defined in child classes.")},i.prototype.query=function(e,t){throw new Error("The `query` method must be defined in child classes.")},i.prototype.bind=function(e,t){},i.prototype.destroy=function(){},i.prototype.generateResultId=function(e,t){e=e.id+"-result-";return e+=n.generateChars(4),null!=t.id?e+="-"+t.id.toString():e+="-"+n.generateChars(4),e},i}),u.define("select2/data/select",["./base","../utils","jquery"],function(e,r,a){function n(e,t){this.$element=e,this.options=t,n.__super__.constructor.call(this)}return r.Extend(n,e),n.prototype.current=function(e){var t=[],n=this;this.$element.find(":selected").each(function(){var e=a(this),e=n.item(e);t.push(e)}),e(t)},n.prototype.select=function(o){var e,s=this;o.selected=!0,a(o.element).is("option")?(o.element.selected=!0,this.$element.trigger("input").trigger("change")):this.$element.prop("multiple")?this.current(function(e){var t=[];(o=[o]).push.apply(o,e);for(var n=0;n<o.length;n++){var i=o[n].id;-1===a.inArray(i,t)&&t.push(i)}s.$element.val(t),s.$element.trigger("input").trigger("change")}):(e=o.id,this.$element.val(e),this.$element.trigger("input").trigger("change"))},n.prototype.unselect=function(o){var s=this;this.$element.prop("multiple")&&(o.selected=!1,a(o.element).is("option")?(o.element.selected=!1,this.$element.trigger("input").trigger("change")):this.current(function(e){for(var t=[],n=0;n<e.length;n++){var i=e[n].id;i!==o.id&&-1===a.inArray(i,t)&&t.push(i)}s.$element.val(t),s.$element.trigger("input").trigger("change")}))},n.prototype.bind=function(e,t){var n=this;(this.container=e).on("select",function(e){n.select(e.data)}),e.on("unselect",function(e){n.unselect(e.data)})},n.prototype.destroy=function(){this.$element.find("*").each(function(){r.RemoveData(this)})},n.prototype.query=function(t,e){var n=[],i=this;this.$element.children().each(function(){var e=a(this);(e.is("option")||e.is("optgroup"))&&(e=i.item(e),null!==(e=i.matches(t,e)))&&n.push(e)}),e({results:n})},n.prototype.addOptions=function(e){r.appendMany(this.$element,e)},n.prototype.option=function(e){e.children?(t=document.createElement("optgroup")).label=e.text:(t=document.createElement("option")).textContent!==undefined?t.textContent=e.text:t.innerText=e.text,e.id!==undefined&&(t.value=e.id),e.disabled&&(t.disabled=!0),e.selected&&(t.selected=!0),e.title&&(t.title=e.title);var t,n=a(t),e=this._normalizeItem(e);return e.element=t,r.StoreData(t,"data",e),n},n.prototype.item=function(e){var t={};if(null==(t=r.GetData(e[0],"data"))){if(e.is("option"))t={id:e.val(),text:e.text(),disabled:e.prop("disabled"),selected:e.prop("selected"),title:e.prop("title")};else if(e.is("optgroup")){for(var t={text:e.prop("label"),children:[],title:e.prop("title")},n=e.children("option"),i=[],o=0;o<n.length;o++){var s=a(n[o]),s=this.item(s);i.push(s)}t.children=i}(t=this._normalizeItem(t)).element=e[0],r.StoreData(e[0],"data",t)}return t},n.prototype._normalizeItem=function(e){e!==Object(e)&&(e={id:e,text:e});return null!=(e=a.extend({},{text:""},e)).id&&(e.id=e.id.toString()),null!=e.text&&(e.text=e.text.toString()),null==e._resultId&&e.id&&null!=this.container&&(e._resultId=this.generateResultId(this.container,e)),a.extend({},{selected:!1,disabled:!1},e)},n.prototype.matches=function(e,t){return this.options.get("matcher")(e,t)},n}),u.define("select2/data/array",["./select","../utils","jquery"],function(e,c,u){function i(e,t){this._dataToConvert=t.get("data")||[],i.__super__.constructor.call(this,e,t)}return c.Extend(i,e),i.prototype.bind=function(e,t){i.__super__.bind.call(this,e,t),this.addOptions(this.convertToOptions(this._dataToConvert))},i.prototype.select=function(n){var e;0===this.$element.find("option").filter(function(e,t){return t.value==n.id.toString()}).length&&(e=this.option(n),this.addOptions(e)),i.__super__.select.call(this,n)},i.prototype.convertToOptions=function(e){var t=this,n=this.$element.find("option"),i=n.map(function(){return t.item(u(this)).id}).get(),o=[];for(var s=0;s<e.length;s++){var r,a,l=this._normalizeItem(e[s]);0<=u.inArray(l.id,i)?(a=n.filter(function(e){return function(){return u(this).val()==e.id}}(l)),r=this.item(a),r=u.extend(!0,{},l,r),r=this.option(r),a.replaceWith(r)):(r=this.option(l),l.children&&(a=this.convertToOptions(l.children),c.appendMany(r,a)),o.push(r))}return o},i}),u.define("select2/data/ajax",["./array","../utils","jquery"],function(e,t,s){function n(e,t){this.ajaxOptions=this._applyDefaults(t.get("ajax")),null!=this.ajaxOptions.processResults&&(this.processResults=this.ajaxOptions.processResults),n.__super__.constructor.call(this,e,t)}return t.Extend(n,e),n.prototype._applyDefaults=function(e){return s.extend({},{data:function(e){return s.extend({},e,{q:e.term})},transport:function(e,t,n){e=s.ajax(e);return e.then(t),e.fail(n),e}},e,!0)},n.prototype.processResults=function(e){return e},n.prototype.query=function(t,n){var i=this,o=(null!=this._request&&(s.isFunction(this._request.abort)&&this._request.abort(),this._request=null),s.extend({type:"GET"},this.ajaxOptions));function e(){var e=o.transport(o,function(e){e=i.processResults(e,t);i.options.get("debug")&&window.console&&console.error&&(e&&e.results&&s.isArray(e.results)||console.error("Select2: The AJAX results did not return an array in the `results` key of the response.")),n(e)},function(){"status"in e&&(0===e.status||"0"===e.status)||i.trigger("results:message",{message:"errorLoading"})});i._request=e}"function"==typeof o.url&&(o.url=o.url.call(this.$element,t)),"function"==typeof o.data&&(o.data=o.data.call(this.$element,t)),this.ajaxOptions.delay&&null!=t.term?(this._queryTimeout&&window.clearTimeout(this._queryTimeout),this._queryTimeout=window.setTimeout(e,this.ajaxOptions.delay)):e()},n}),u.define("select2/data/tags",["jquery"],function(a){function e(e,t,n){var i=n.get("tags"),o=n.get("createTag"),o=(o!==undefined&&(this.createTag=o),n.get("insertTag"));if(o!==undefined&&(this.insertTag=o),e.call(this,t,n),a.isArray(i))for(var s=0;s<i.length;s++){var r=i[s],r=this._normalizeItem(r),r=this.option(r);this.$element.append(r)}}return e.prototype.query=function(e,l,c){var u=this;this._removeOldTags(),null==l.term||null!=l.page?e.call(this,l,c):e.call(this,l,function d(e,t){for(var n=e.results,i=0;i<n.length;i++){var o=n[i],s=null!=o.children&&!d({results:o.children},!0);if((o.text||"").toUpperCase()===(l.term||"").toUpperCase()||s)return!t&&(e.data=n,void c(e))}if(t)return!0;var r,a=u.createTag(l);null!=a&&((r=u.option(a)).attr("data-select2-tag",!0),u.addOptions([r]),u.insertTag(n,a)),e.results=n,c(e)})},e.prototype.createTag=function(e,t){t=a.trim(t.term);return""===t?null:{id:t,text:t}},e.prototype.insertTag=function(e,t,n){t.unshift(n)},e.prototype._removeOldTags=function(e){this.$element.find("option[data-select2-tag]").each(function(){this.selected||a(this).remove()})},e}),u.define("select2/data/tokenizer",["jquery"],function(c){function e(e,t,n){var i=n.get("tokenizer");i!==undefined&&(this.tokenizer=i),e.call(this,t,n)}return e.prototype.bind=function(e,t,n){e.call(this,t,n),this.$search=t.dropdown.$search||t.selection.$search||n.find(".select2-search__field")},e.prototype.query=function(e,t,n){var i=this;t.term=t.term||"";var o=this.tokenizer(t,this.options,function(e){var t=i._normalizeItem(e);i.$element.find("option").filter(function(){return c(this).val()===t.id}).length||((e=i.option(t)).attr("data-select2-tag",!0),i._removeOldTags(),i.addOptions([e])),i.trigger("select",{data:t})});o.term!==t.term&&(this.$search.length&&(this.$search.val(o.term),this.$search.trigger("focus")),t.term=o.term),e.call(this,t,n)},e.prototype.tokenizer=function(e,t,n,i){for(var o=n.get("tokenSeparators")||[],s=t.term,r=0,a=this.createTag||function(e){return{id:e.term,text:e.term}};r<s.length;){var l=s[r];-1===c.inArray(l,o)?r++:(l=s.substr(0,r),null==(l=a(c.extend({},t,{term:l})))?r++:(i(l),s=s.substr(r+1)||"",r=0))}return{term:s}},e}),u.define("select2/data/minimumInputLength",[],function(){function e(e,t,n){this.minimumInputLength=n.get("minimumInputLength"),e.call(this,t,n)}return e.prototype.query=function(e,t,n){t.term=t.term||"",t.term.length<this.minimumInputLength?this.trigger("results:message",{message:"inputTooShort",args:{minimum:this.minimumInputLength,input:t.term,params:t}}):e.call(this,t,n)},e}),u.define("select2/data/maximumInputLength",[],function(){function e(e,t,n){this.maximumInputLength=n.get("maximumInputLength"),e.call(this,t,n)}return e.prototype.query=function(e,t,n){t.term=t.term||"",0<this.maximumInputLength&&t.term.length>this.maximumInputLength?this.trigger("results:message",{message:"inputTooLong",args:{maximum:this.maximumInputLength,input:t.term,params:t}}):e.call(this,t,n)},e}),u.define("select2/data/maximumSelectionLength",[],function(){function e(e,t,n){this.maximumSelectionLength=n.get("maximumSelectionLength"),e.call(this,t,n)}return e.prototype.bind=function(e,t,n){var i=this;e.call(this,t,n),t.on("select",function(){i._checkIfMaximumSelected()})},e.prototype.query=function(e,t,n){var i=this;this._checkIfMaximumSelected(function(){e.call(i,t,n)})},e.prototype._checkIfMaximumSelected=function(e,t){var n=this;this.current(function(e){e=null!=e?e.length:0;0<n.maximumSelectionLength&&e>=n.maximumSelectionLength?n.trigger("results:message",{message:"maximumSelected",args:{maximum:n.maximumSelectionLength}}):t&&t()})},e}),u.define("select2/dropdown",["jquery","./utils"],function(t,e){function n(e,t){this.$element=e,this.options=t,n.__super__.constructor.call(this)}return e.Extend(n,e.Observable),n.prototype.render=function(){var e=t('<span class="select2-dropdown"><span class="select2-results"></span></span>');return e.attr("dir",this.options.get("dir")),this.$dropdown=e},n.prototype.bind=function(){},n.prototype.position=function(e,t){},n.prototype.destroy=function(){this.$dropdown.remove()},n}),u.define("select2/dropdown/search",["jquery","../utils"],function(s,e){function t(){}return t.prototype.render=function(e){var e=e.call(this),t=s('<span class="select2-search select2-search--dropdown"><input class="select2-search__field" type="search" tabindex="-1" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" role="searchbox" aria-autocomplete="list" /></span>');return this.$searchContainer=t,this.$search=t.find("input"),e.prepend(t),e},t.prototype.bind=function(e,t,n){var i=this,o=t.id+"-results";e.call(this,t,n),this.$search.on("keydown",function(e){i.trigger("keypress",e),i._keyUpPrevented=e.isDefaultPrevented()}),this.$search.on("input",function(e){s(this).off("keyup")}),this.$search.on("keyup input",function(e){i.handleSearch(e)}),t.on("open",function(){i.$search.attr("tabindex",0),i.$search.attr("aria-controls",o),i.$search.trigger("focus"),window.setTimeout(function(){i.$search.trigger("focus")},0)}),t.on("close",function(){i.$search.attr("tabindex",-1),i.$search.removeAttr("aria-controls"),i.$search.removeAttr("aria-activedescendant"),i.$search.val(""),i.$search.trigger("blur")}),t.on("focus",function(){t.isOpen()||i.$search.trigger("focus")}),t.on("results:all",function(e){null!=e.query.term&&""!==e.query.term||(i.showSearch(e)?i.$searchContainer.removeClass("select2-search--hide"):i.$searchContainer.addClass("select2-search--hide"))}),t.on("results:focus",function(e){e.data._resultId?i.$search.attr("aria-activedescendant",e.data._resultId):i.$search.removeAttr("aria-activedescendant")})},t.prototype.handleSearch=function(e){var t;this._keyUpPrevented||(t=this.$search.val(),this.trigger("query",{term:t})),this._keyUpPrevented=!1},t.prototype.showSearch=function(e,t){return!0},t}),u.define("select2/dropdown/hidePlaceholder",[],function(){function e(e,t,n,i){this.placeholder=this.normalizePlaceholder(n.get("placeholder")),e.call(this,t,n,i)}return e.prototype.append=function(e,t){t.results=this.removePlaceholder(t.results),e.call(this,t)},e.prototype.normalizePlaceholder=function(e,t){return t="string"==typeof t?{id:"",text:t}:t},e.prototype.removePlaceholder=function(e,t){for(var n=t.slice(0),i=t.length-1;0<=i;i--){var o=t[i];this.placeholder.id===o.id&&n.splice(i,1)}return n},e}),u.define("select2/dropdown/infiniteScroll",["jquery"],function(n){function e(e,t,n,i){this.lastParams={},e.call(this,t,n,i),this.$loadingMore=this.createLoadingMore(),this.loading=!1}return e.prototype.append=function(e,t){this.$loadingMore.remove(),this.loading=!1,e.call(this,t),this.showLoadingMore(t)&&(this.$results.append(this.$loadingMore),this.loadMoreIfNeeded())},e.prototype.bind=function(e,t,n){var i=this;e.call(this,t,n),t.on("query",function(e){i.lastParams=e,i.loading=!0}),t.on("query:append",function(e){i.lastParams=e,i.loading=!0}),this.$results.on("scroll",this.loadMoreIfNeeded.bind(this))},e.prototype.loadMoreIfNeeded=function(){var e=n.contains(document.documentElement,this.$loadingMore[0]);!this.loading&&e&&(e=this.$results.offset().top+this.$results.outerHeight(!1),this.$loadingMore.offset().top+this.$loadingMore.outerHeight(!1)<=e+50)&&this.loadMore()},e.prototype.loadMore=function(){this.loading=!0;var e=n.extend({},{page:1},this.lastParams);e.page++,this.trigger("query:append",e)},e.prototype.showLoadingMore=function(e,t){return t.pagination&&t.pagination.more},e.prototype.createLoadingMore=function(){var e=n('<li class="select2-results__option select2-results__option--load-more"role="option" aria-disabled="true"></li>'),t=this.options.get("translations").get("loadingMore");return e.html(t(this.lastParams)),e},e}),u.define("select2/dropdown/attachBody",["jquery","../utils"],function(u,r){function e(e,t,n){this.$dropdownParent=u(n.get("dropdownParent")||document.body),e.call(this,t,n)}return e.prototype.bind=function(e,t,n){var i=this;e.call(this,t,n),t.on("open",function(){i._showDropdown(),i._attachPositioningHandler(t),i._bindContainerResultHandlers(t)}),t.on("close",function(){i._hideDropdown(),i._detachPositioningHandler(t)}),this.$dropdownContainer.on("mousedown",function(e){e.stopPropagation()})},e.prototype.destroy=function(e){e.call(this),this.$dropdownContainer.remove()},e.prototype.position=function(e,t,n){t.attr("class",n.attr("class")),t.removeClass("select2"),t.addClass("select2-container--open"),t.css({position:"absolute",top:-999999}),this.$container=n},e.prototype.render=function(e){var t=u("<span></span>"),e=e.call(this);return t.append(e),this.$dropdownContainer=t},e.prototype._hideDropdown=function(e){this.$dropdownContainer.detach()},e.prototype._bindContainerResultHandlers=function(e,t){var n;this._containerResultsHandlersBound||(n=this,t.on("results:all",function(){n._positionDropdown(),n._resizeDropdown()}),t.on("results:append",function(){n._positionDropdown(),n._resizeDropdown()}),t.on("results:message",function(){n._positionDropdown(),n._resizeDropdown()}),t.on("select",function(){n._positionDropdown(),n._resizeDropdown()}),t.on("unselect",function(){n._positionDropdown(),n._resizeDropdown()}),this._containerResultsHandlersBound=!0)},e.prototype._attachPositioningHandler=function(e,t){var n=this,i="scroll.select2."+t.id,o="resize.select2."+t.id,t="orientationchange.select2."+t.id,s=this.$container.parents().filter(r.hasScroll);s.each(function(){r.StoreData(this,"select2-scroll-position",{x:u(this).scrollLeft(),y:u(this).scrollTop()})}),s.on(i,function(e){var t=r.GetData(this,"select2-scroll-position");u(this).scrollTop(t.y)}),u(window).on(i+" "+o+" "+t,function(e){n._positionDropdown(),n._resizeDropdown()})},e.prototype._detachPositioningHandler=function(e,t){var n="scroll.select2."+t.id,i="resize.select2."+t.id,t="orientationchange.select2."+t.id;this.$container.parents().filter(r.hasScroll).off(n),u(window).off(n+" "+i+" "+t)},e.prototype._positionDropdown=function(){var e=u(window),t=this.$dropdown.hasClass("select2-dropdown--above"),n=this.$dropdown.hasClass("select2-dropdown--below"),i=null,o=this.$container.offset(),s=(o.bottom=o.top+this.$container.outerHeight(!1),{height:this.$container.outerHeight(!1)});s.top=o.top,s.bottom=o.top+s.height;var r=this.$dropdown.outerHeight(!1),a=e.scrollTop(),e=e.scrollTop()+e.height(),a=a<o.top-r,e=e>o.bottom+r,o={left:o.left,top:s.bottom},l=this.$dropdownParent,c=("static"===l.css("position")&&(l=l.offsetParent()),{top:0,left:0});(u.contains(document.body,l[0])||l[0].isConnected)&&(c=l.offset()),o.top-=c.top,o.left-=c.left,t||n||(i="below"),e||!a||t?!a&&e&&t&&(i="below"):i="above",("above"==i||t&&"below"!==i)&&(o.top=s.top-c.top-r),null!=i&&(this.$dropdown.removeClass("select2-dropdown--below select2-dropdown--above").addClass("select2-dropdown--"+i),this.$container.removeClass("select2-container--below select2-container--above").addClass("select2-container--"+i)),this.$dropdownContainer.css(o)},e.prototype._resizeDropdown=function(){var e={width:this.$container.outerWidth(!1)+"px"};this.options.get("dropdownAutoWidth")&&(e.minWidth=e.width,e.position="relative",e.width="auto"),this.$dropdown.css(e)},e.prototype._showDropdown=function(e){this.$dropdownContainer.appendTo(this.$dropdownParent),this._positionDropdown(),this._resizeDropdown()},e}),u.define("select2/dropdown/minimumResultsForSearch",[],function(){function e(e,t,n,i){this.minimumResultsForSearch=n.get("minimumResultsForSearch"),this.minimumResultsForSearch<0&&(this.minimumResultsForSearch=Infinity),e.call(this,t,n,i)}return e.prototype.showSearch=function(e,t){return!(function o(e){for(var t=0,n=0;n<e.length;n++){var i=e[n];i.children?t+=o(i.children):t++}return t}(t.data.results)<this.minimumResultsForSearch)&&e.call(this,t)},e}),u.define("select2/dropdown/selectOnClose",["../utils"],function(n){function e(){}return e.prototype.bind=function(e,t,n){var i=this;e.call(this,t,n),t.on("close",function(e){i._handleSelectOnClose(e)})},e.prototype._handleSelectOnClose=function(e,t){if(t&&null!=t.originalSelect2Event){t=t.originalSelect2Event;if("select"===t._type||"unselect"===t._type)return}var t=this.getHighlightedResults();t.length<1||null!=(t=n.GetData(t[0],"data")).element&&t.element.selected||null==t.element&&t.selected||this.trigger("select",{data:t})},e}),u.define("select2/dropdown/closeOnSelect",[],function(){function e(){}return e.prototype.bind=function(e,t,n){var i=this;e.call(this,t,n),t.on("select",function(e){i._selectTriggered(e)}),t.on("unselect",function(e){i._selectTriggered(e)})},e.prototype._selectTriggered=function(e,t){var n=t.originalEvent;n&&(n.ctrlKey||n.metaKey)||this.trigger("close",{originalEvent:n,originalSelect2Event:t})},e}),u.define("select2/i18n/en",[],function(){return{errorLoading:function(){return"The results could not be loaded."},inputTooLong:function(e){var e=e.input.length-e.maximum,t="Please delete "+e+" character";return 1!=e&&(t+="s"),t},inputTooShort:function(e){return"Please enter "+(e.minimum-e.input.length)+" or more characters"},loadingMore:function(){return"Loading more results…"},maximumSelected:function(e){var t="You can only select "+e.maximum+" item";return 1!=e.maximum&&(t+="s"),t},noResults:function(){return"No results found"},searching:function(){return"Searching…"},removeAllItems:function(){return"Remove all items"}}}),u.define("select2/defaults",["jquery","require","./results","./selection/single","./selection/multiple","./selection/placeholder","./selection/allowClear","./selection/search","./selection/eventRelay","./utils","./translation","./diacritics","./data/select","./data/array","./data/ajax","./data/tags","./data/tokenizer","./data/minimumInputLength","./data/maximumInputLength","./data/maximumSelectionLength","./dropdown","./dropdown/search","./dropdown/hidePlaceholder","./dropdown/infiniteScroll","./dropdown/attachBody","./dropdown/minimumResultsForSearch","./dropdown/selectOnClose","./dropdown/closeOnSelect","./i18n/en"],function(l,s,r,a,c,u,d,p,h,f,g,t,m,y,v,_,w,$,b,A,x,D,S,C,E,O,T,q,e){function n(){this.reset()}return n.prototype.apply=function(e){null==(e=l.extend(!0,{},this.defaults,e)).dataAdapter&&(null!=e.ajax?e.dataAdapter=v:null!=e.data?e.dataAdapter=y:e.dataAdapter=m,0<e.minimumInputLength&&(e.dataAdapter=f.Decorate(e.dataAdapter,$)),0<e.maximumInputLength&&(e.dataAdapter=f.Decorate(e.dataAdapter,b)),0<e.maximumSelectionLength&&(e.dataAdapter=f.Decorate(e.dataAdapter,A)),e.tags&&(e.dataAdapter=f.Decorate(e.dataAdapter,_)),null==e.tokenSeparators&&null==e.tokenizer||(e.dataAdapter=f.Decorate(e.dataAdapter,w)),null!=e.query&&(t=s(e.amdBase+"compat/query"),e.dataAdapter=f.Decorate(e.dataAdapter,t)),null!=e.initSelection)&&(t=s(e.amdBase+"compat/initSelection"),e.dataAdapter=f.Decorate(e.dataAdapter,t)),null==e.resultsAdapter&&(e.resultsAdapter=r,null!=e.ajax&&(e.resultsAdapter=f.Decorate(e.resultsAdapter,C)),null!=e.placeholder&&(e.resultsAdapter=f.Decorate(e.resultsAdapter,S)),e.selectOnClose)&&(e.resultsAdapter=f.Decorate(e.resultsAdapter,T)),null==e.dropdownAdapter&&(e.multiple?e.dropdownAdapter=x:(t=f.Decorate(x,D),e.dropdownAdapter=t),0!==e.minimumResultsForSearch&&(e.dropdownAdapter=f.Decorate(e.dropdownAdapter,O)),e.closeOnSelect&&(e.dropdownAdapter=f.Decorate(e.dropdownAdapter,q)),null==e.dropdownCssClass&&null==e.dropdownCss&&null==e.adaptDropdownCssClass||(t=s(e.amdBase+"compat/dropdownCss"),e.dropdownAdapter=f.Decorate(e.dropdownAdapter,t)),e.dropdownAdapter=f.Decorate(e.dropdownAdapter,E)),null==e.selectionAdapter&&(e.multiple?e.selectionAdapter=c:e.selectionAdapter=a,null!=e.placeholder&&(e.selectionAdapter=f.Decorate(e.selectionAdapter,u)),e.allowClear&&(e.selectionAdapter=f.Decorate(e.selectionAdapter,d)),e.multiple&&(e.selectionAdapter=f.Decorate(e.selectionAdapter,p)),null==e.containerCssClass&&null==e.containerCss&&null==e.adaptContainerCssClass||(t=s(e.amdBase+"compat/containerCss"),e.selectionAdapter=f.Decorate(e.selectionAdapter,t)),e.selectionAdapter=f.Decorate(e.selectionAdapter,h)),e.language=this._resolveLanguage(e.language),e.language.push("en");for(var t,n=[],i=0;i<e.language.length;i++){var o=e.language[i];-1===n.indexOf(o)&&n.push(o)}return e.language=n,e.translations=this._processTranslations(e.language,e.debug),e},n.prototype.reset=function(){function r(e){return e.replace(/[^\u0000-\u007E]/g,function(e){return t[e]||e})}this.defaults={amdBase:"./",amdLanguageBase:"./i18n/",closeOnSelect:!0,debug:!1,dropdownAutoWidth:!1,escapeMarkup:f.escapeMarkup,language:{},matcher:function a(e,t){if(""===l.trim(e.term))return t;if(t.children&&0<t.children.length){for(var n=l.extend(!0,{},t),i=t.children.length-1;0<=i;i--)null==a(e,t.children[i])&&n.children.splice(i,1);return 0<n.children.length?n:a(e,n)}var o=r(t.text).toUpperCase(),s=r(e.term).toUpperCase();return-1<o.indexOf(s)?t:null},minimumInputLength:0,maximumInputLength:0,maximumSelectionLength:0,minimumResultsForSearch:0,selectOnClose:!1,scrollAfterSelect:!1,sorter:function(e){return e},templateResult:function(e){return e.text},templateSelection:function(e){return e.text},theme:"default",width:"resolve"}},n.prototype.applyFromElement=function(e,t){var n=e.language,i=this.defaults.language,o=t.prop("lang"),t=t.closest("[lang]").prop("lang"),o=Array.prototype.concat.call(this._resolveLanguage(o),this._resolveLanguage(n),this._resolveLanguage(i),this._resolveLanguage(t));return e.language=o,e},n.prototype._resolveLanguage=function(e){if(!e)return[];if(l.isEmptyObject(e))return[];if(l.isPlainObject(e))return[e];for(var t,n=l.isArray(e)?e:[e],i=[],o=0;o<n.length;o++)i.push(n[o]),"string"==typeof n[o]&&0<n[o].indexOf("-")&&(t=n[o].split("-")[0],i.push(t));return i},n.prototype._processTranslations=function(e,t){for(var n=new g,i=0;i<e.length;i++){var o=new g,s=e[i];if("string"==typeof s)try{o=g.loadPath(s)}catch(r){try{s=this.defaults.amdLanguageBase+s,o=g.loadPath(s)}catch(a){t&&window.console&&console.warn&&console.warn('Select2: The language file for "'+s+'" could not be automatically loaded. A fallback will be used instead.')}}else o=l.isPlainObject(s)?new g(s):s;n.extend(o)}return n},n.prototype.set=function(e,t){var n={},e=(n[l.camelCase(e)]=t,f._convertData(n));l.extend(!0,this.defaults,e)},new n}),u.define("select2/options",["require","jquery","./defaults","./utils"],function(n,c,i,u){function e(e,t){this.options=e,null!=t&&this.fromElement(t),null!=t&&(this.options=i.applyFromElement(this.options,t)),this.options=i.apply(this.options),t&&t.is("input")&&(e=n(this.get("amdBase")+"compat/inputData"),this.options.dataAdapter=u.Decorate(this.options.dataAdapter,e))}return e.prototype.fromElement=function(e){var t=["select2"],n=(null==this.options.multiple&&(this.options.multiple=e.prop("multiple")),null==this.options.disabled&&(this.options.disabled=e.prop("disabled")),null==this.options.dir&&(e.prop("dir")?this.options.dir=e.prop("dir"):e.closest("[dir]").prop("dir")?this.options.dir=e.closest("[dir]").prop("dir"):this.options.dir="ltr"),e.prop("disabled",this.options.disabled),e.prop("multiple",this.options.multiple),u.GetData(e[0],"select2Tags")&&(this.options.debug&&window.console&&console.warn&&console.warn('Select2: The `data-select2-tags` attribute has been changed to use the `data-data` and `data-tags="true"` attributes and will be removed in future versions of Select2.'),u.StoreData(e[0],"data",u.GetData(e[0],"select2Tags")),u.StoreData(e[0],"tags",!0)),u.GetData(e[0],"ajaxUrl")&&(this.options.debug&&window.console&&console.warn&&console.warn("Select2: The `data-ajax-url` attribute has been changed to `data-ajax--url` and support for the old attribute will be removed in future versions of Select2."),e.attr("ajax--url",u.GetData(e[0],"ajaxUrl")),u.StoreData(e[0],"ajax-Url",u.GetData(e[0],"ajaxUrl"))),{});function i(e,t){return t.toUpperCase()}for(var o=0;o<e[0].attributes.length;o++){var s=e[0].attributes[o].name,r="data-";s.substr(0,r.length)==r&&(r=s.substring(r.length),s=u.GetData(e[0],r),n[r.replace(/-([a-z])/g,i)]=s)}c.fn.jquery&&"1."==c.fn.jquery.substr(0,2)&&e[0].dataset&&(n=c.extend(!0,{},e[0].dataset,n));var a,l=c.extend(!0,{},u.GetData(e[0]),n);for(a in l=u._convertData(l))-1<c.inArray(a,t)||(c.isPlainObject(this.options[a])?c.extend(this.options[a],l[a]):this.options[a]=l[a]);return this},e.prototype.get=function(e){return this.options[e]},e.prototype.set=function(e,t){this.options[e]=t},e}),u.define("select2/core",["jquery","./options","./utils","./keys"],function(s,o,r,i){var a=function(e,t){null!=r.GetData(e[0],"select2")&&r.GetData(e[0],"select2").destroy(),this.$element=e,this.id=this._generateId(e),this.options=new o(t=t||{},e),a.__super__.constructor.call(this);var t=e.attr("tabindex")||0,t=(r.StoreData(e[0],"old-tabindex",t),e.attr("tabindex","-1"),this.options.get("dataAdapter")),t=(this.dataAdapter=new t(e,this.options),this.render()),n=(this._placeContainer(t),this.options.get("selectionAdapter")),n=(this.selection=new n(e,this.options),this.$selection=this.selection.render(),this.selection.position(this.$selection,t),this.options.get("dropdownAdapter")),n=(this.dropdown=new n(e,this.options),this.$dropdown=this.dropdown.render(),this.dropdown.position(this.$dropdown,t),this.options.get("resultsAdapter")),i=(this.results=new n(e,this.options,this.dataAdapter),this.$results=this.results.render(),this.results.position(this.$results,this.$dropdown),this);this._bindAdapters(),this._registerDomEvents(),this._registerDataEvents(),this._registerSelectionEvents(),this._registerDropdownEvents(),this._registerResultsEvents(),this._registerEvents(),this.dataAdapter.current(function(e){i.trigger("selection:update",{data:e})}),e.addClass("select2-hidden-accessible"),e.attr("aria-hidden","true"),this._syncAttributes(),r.StoreData(e[0],"select2",this),e.data("select2",this)};return r.Extend(a,r.Observable),a.prototype._generateId=function(e){return"select2-"+(null!=e.attr("id")?e.attr("id"):null!=e.attr("name")?e.attr("name")+"-"+r.generateChars(2):r.generateChars(4)).replace(/(:|\.|\[|\]|,)/g,"")},a.prototype._placeContainer=function(e){e.insertAfter(this.$element);var t=this._resolveWidth(this.$element,this.options.get("width"));null!=t&&e.css("width",t)},a.prototype._resolveWidth=function(e,t){var n=/^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i;if("resolve"==t)return null!=(i=this._resolveWidth(e,"style"))?i:this._resolveWidth(e,"element");if("element"==t)return(i=e.outerWidth(!1))<=0?"auto":i+"px";if("style"!=t)return"computedstyle"==t?window.getComputedStyle(e[0]).width:t;var i=e.attr("style");if("string"==typeof i)for(var o=i.split(";"),s=0,r=o.length;s<r;s+=1){var a=o[s].replace(/\s/g,"").match(n);if(null!==a&&1<=a.length)return a[1]}return null},a.prototype._bindAdapters=function(){this.dataAdapter.bind(this,this.$container),this.selection.bind(this,this.$container),this.dropdown.bind(this,this.$container),this.results.bind(this,this.$container)},a.prototype._registerDomEvents=function(){var t=this,e=(this.$element.on("change.select2",function(){t.dataAdapter.current(function(e){t.trigger("selection:update",{data:e})})}),this.$element.on("focus.select2",function(e){t.trigger("focus",e)}),this._syncA=r.bind(this._syncAttributes,this),this._syncS=r.bind(this._syncSubtree,this),this.$element[0].attachEvent&&this.$element[0].attachEvent("onpropertychange",this._syncA),window.MutationObserver||window.WebKitMutationObserver||window.MozMutationObserver);null!=e?(this._observer=new e(function(e){t._syncA(),t._syncS(null,e)}),this._observer.observe(this.$element[0],{attributes:!0,childList:!0,subtree:!1})):this.$element[0].addEventListener&&(this.$element[0].addEventListener("DOMAttrModified",t._syncA,!1),this.$element[0].addEventListener("DOMNodeInserted",t._syncS,!1),this.$element[0].addEventListener("DOMNodeRemoved",t._syncS,!1))},a.prototype._registerDataEvents=function(){var n=this;this.dataAdapter.on("*",function(e,t){n.trigger(e,t)})},a.prototype._registerSelectionEvents=function(){var n=this,i=["toggle","focus"];this.selection.on("toggle",function(){n.toggleDropdown()}),this.selection.on("focus",function(e){n.focus(e)}),this.selection.on("*",function(e,t){-1===s.inArray(e,i)&&n.trigger(e,t)})},a.prototype._registerDropdownEvents=function(){var n=this;this.dropdown.on("*",function(e,t){n.trigger(e,t)})},a.prototype._registerResultsEvents=function(){var n=this;this.results.on("*",function(e,t){n.trigger(e,t)})},a.prototype._registerEvents=function(){var n=this;this.on("open",function(){n.$container.addClass("select2-container--open")}),this.on("close",function(){n.$container.removeClass("select2-container--open")}),this.on("enable",function(){n.$container.removeClass("select2-container--disabled")}),this.on("disable",function(){n.$container.addClass("select2-container--disabled")}),this.on("blur",function(){n.$container.removeClass("select2-container--focus")}),this.on("query",function(t){n.isOpen()||n.trigger("open",{}),this.dataAdapter.query(t,function(e){n.trigger("results:all",{data:e,query:t})})}),this.on("query:append",function(t){this.dataAdapter.query(t,function(e){n.trigger("results:append",{data:e,query:t})})}),this.on("keypress",function(e){var t=e.which;n.isOpen()?t===i.ESC||t===i.TAB||t===i.UP&&e.altKey?(n.close(e),e.preventDefault()):t===i.ENTER?(n.trigger("results:select",{}),e.preventDefault()):t===i.SPACE&&e.ctrlKey?(n.trigger("results:toggle",{}),e.preventDefault()):t===i.UP?(n.trigger("results:previous",{}),e.preventDefault()):t===i.DOWN&&(n.trigger("results:next",{}),e.preventDefault()):(t===i.ENTER||t===i.SPACE||t===i.DOWN&&e.altKey)&&(n.open(),e.preventDefault())})},a.prototype._syncAttributes=function(){this.options.set("disabled",this.$element.prop("disabled")),this.isDisabled()?(this.isOpen()&&this.close(),this.trigger("disable",{})):this.trigger("enable",{})},a.prototype._isChangeMutation=function(e,t){var n=!1,i=this;if(!e||!e.target||"OPTION"===e.target.nodeName||"OPTGROUP"===e.target.nodeName){if(t)if(t.addedNodes&&0<t.addedNodes.length)for(var o=0;o<t.addedNodes.length;o++)t.addedNodes[o].selected&&(n=!0);else t.removedNodes&&0<t.removedNodes.length?n=!0:s.isArray(t)&&s.each(t,function(e,t){if(i._isChangeMutation(e,t))return!(n=!0)});else n=!0;return n}},a.prototype._syncSubtree=function(e,t){var e=this._isChangeMutation(e,t),n=this;e&&this.dataAdapter.current(function(e){n.trigger("selection:update",{data:e})})},a.prototype.trigger=function(e,t){var n=a.__super__.trigger,i={open:"opening",close:"closing",select:"selecting",unselect:"unselecting",clear:"clearing"};if(t===undefined&&(t={}),e in i){var o={prevented:!1,name:e,args:t};if(n.call(this,i[e],o),o.prevented)return void(t.prevented=!0)}n.call(this,e,t)},a.prototype.toggleDropdown=function(){this.isDisabled()||(this.isOpen()?this.close():this.open())},a.prototype.open=function(){this.isOpen()||this.isDisabled()||this.trigger("query",{})},a.prototype.close=function(e){this.isOpen()&&this.trigger("close",{originalEvent:e})},a.prototype.isEnabled=function(){return!this.isDisabled()},a.prototype.isDisabled=function(){return this.options.get("disabled")},a.prototype.isOpen=function(){return this.$container.hasClass("select2-container--open")},a.prototype.hasFocus=function(){return this.$container.hasClass("select2-container--focus")},a.prototype.focus=function(e){this.hasFocus()||(this.$container.addClass("select2-container--focus"),this.trigger("focus",{}))},a.prototype.enable=function(e){this.options.get("debug")&&window.console&&console.warn&&console.warn('Select2: The `select2("enable")` method has been deprecated and will be removed in later Select2 versions. Use $element.prop("disabled") instead.');e=!(e=null!=e&&0!==e.length?e:[!0])[0];this.$element.prop("disabled",e)},a.prototype.data=function(){this.options.get("debug")&&0<arguments.length&&window.console&&console.warn&&console.warn('Select2: Data can no longer be set using `select2("data")`. You should consider setting the value instead using `$element.val()`.');var t=[];return this.dataAdapter.current(function(e){t=e}),t},a.prototype.val=function(e){if(this.options.get("debug")&&window.console&&console.warn&&console.warn('Select2: The `select2("val")` method has been deprecated and will be removed in later Select2 versions. Use $element.val() instead.'),null==e||0===e.length)return this.$element.val();e=e[0];s.isArray(e)&&(e=s.map(e,function(e){return e.toString()})),this.$element.val(e).trigger("input").trigger("change")},a.prototype.destroy=function(){this.$container.remove(),this.$element[0].detachEvent&&this.$element[0].detachEvent("onpropertychange",this._syncA),null!=this._observer?(this._observer.disconnect(),this._observer=null):this.$element[0].removeEventListener&&(this.$element[0].removeEventListener("DOMAttrModified",this._syncA,!1),this.$element[0].removeEventListener("DOMNodeInserted",this._syncS,!1),this.$element[0].removeEventListener("DOMNodeRemoved",this._syncS,!1)),this._syncA=null,this._syncS=null,this.$element.off(".select2"),this.$element.attr("tabindex",r.GetData(this.$element[0],"old-tabindex")),this.$element.removeClass("select2-hidden-accessible"),this.$element.attr("aria-hidden","false"),r.RemoveData(this.$element[0]),this.$element.removeData("select2"),this.dataAdapter.destroy(),this.selection.destroy(),this.dropdown.destroy(),this.results.destroy(),this.dataAdapter=null,this.selection=null,this.dropdown=null,this.results=null},a.prototype.render=function(){var e=s('<span class="select2 select2-container"><span class="selection"></span><span class="dropdown-wrapper" aria-hidden="true"></span></span>');return e.attr("dir",this.options.get("dir")),this.$container=e,this.$container.addClass("select2-container--"+this.options.get("theme")),r.StoreData(e[0],"element",this.$element),e},a}),u.define("select2/compat/utils",["jquery"],function(r){return{syncCssClasses:function(e,t,n){var i,o=[],s=r.trim(e.attr("class"));s&&r((s=""+s).split(/\s+/)).each(function(){0===this.indexOf("select2-")&&o.push(this)}),(s=r.trim(t.attr("class")))&&r((s=""+s).split(/\s+/)).each(function(){0!==this.indexOf("select2-")&&null!=(i=n(this))&&o.push(i)}),e.attr("class",o.join(" "))}}}),u.define("select2/compat/containerCss",["jquery","./utils"],function(s,r){function a(e){return null}function e(){}return e.prototype.render=function(e){var n,e=e.call(this),t=this.options.get("containerCssClass")||"",i=(s.isFunction(t)&&(t=t(this.$element)),this.options.get("adaptContainerCssClass")),o=(i=i||a,-1!==t.indexOf(":all:")&&(t=t.replace(":all:",""),n=i,i=function(e){var t=n(e);return null!=t?t+" "+e:e}),this.options.get("containerCss")||{});return s.isFunction(o)&&(o=o(this.$element)),r.syncCssClasses(e,this.$element,i),e.css(o),e.addClass(t),e},e}),u.define("select2/compat/dropdownCss",["jquery","./utils"],function(s,r){function a(e){return null}function e(){}return e.prototype.render=function(e){var n,e=e.call(this),t=this.options.get("dropdownCssClass")||"",i=(s.isFunction(t)&&(t=t(this.$element)),this.options.get("adaptDropdownCssClass")),o=(i=i||a,-1!==t.indexOf(":all:")&&(t=t.replace(":all:",""),n=i,i=function(e){var t=n(e);return null!=t?t+" "+e:e}),this.options.get("dropdownCss")||{});return s.isFunction(o)&&(o=o(this.$element)),r.syncCssClasses(e,this.$element,i),e.css(o),e.addClass(t),e},e}),u.define("select2/compat/initSelection",["jquery"],function(i){function e(e,t,n){n.get("debug")&&window.console&&console.warn&&console.warn("Select2: The `initSelection` option has been deprecated in favor of a custom data adapter that overrides the `current` method. This method is now called multiple times instead of a single time when the instance is initialized. Support will be removed for the `initSelection` option in future versions of Select2"),this.initSelection=n.get("initSelection"),this._isInitialized=!1,e.call(this,t,n)}return e.prototype.current=function(e,t){var n=this;this._isInitialized?e.call(this,t):this.initSelection.call(null,this.$element,function(e){n._isInitialized=!0,i.isArray(e)||(e=[e]),t(e)})},e}),u.define("select2/compat/inputData",["jquery","../utils"],function(r,n){function e(e,t,n){this._currentData=[],this._valueSeparator=n.get("valueSeparator")||",","hidden"===t.prop("type")&&n.get("debug")&&console&&console.warn&&console.warn("Select2: Using a hidden input with Select2 is no longer supported and may stop working in the future. It is recommended to use a `<select>` element instead."),e.call(this,t,n)}return e.prototype.current=function(e,t){for(var n=[],i=0;i<this._currentData.length;i++){var o=this._currentData[i];n.push.apply(n,function s(e,t){var n=[];return e.selected||-1!==r.inArray(e.id,t)?(e.selected=!0,n.push(e)):e.selected=!1,e.children&&n.push.apply(n,s(e.children,t)),n}(o,this.$element.val().split(this._valueSeparator)))}t(n)},e.prototype.select=function(e,t){var n;this.options.get("multiple")?(n=this.$element.val(),n+=this._valueSeparator+t.id,this.$element.val(n)):(this.current(function(e){r.map(e,function(e){e.selected=!1})}),this.$element.val(t.id)),this.$element.trigger("input").trigger("change")},e.prototype.unselect=function(e,o){var s=this;o.selected=!1,this.current(function(e){for(var t=[],n=0;n<e.length;n++){var i=e[n];o.id!=i.id&&t.push(i.id)}s.$element.val(t.join(s._valueSeparator)),s.$element.trigger("input").trigger("change")})},e.prototype.query=function(e,t,n){for(var i=[],o=0;o<this._currentData.length;o++){var s=this._currentData[o],s=this.matches(t,s);null!==s&&i.push(s)}n({results:i})},e.prototype.addOptions=function(e,t){t=r.map(t,function(e){return n.GetData(e[0],"data")});this._currentData.push.apply(this._currentData,t)},e}),u.define("select2/compat/matcher",["jquery"],function(r){return function(s){return function(e,t){var n=r.extend(!0,{},t);if(null==e.term||""===r.trim(e.term))return n;if(t.children){for(var i=t.children.length-1;0<=i;i--){var o=t.children[i];s(e.term,o.text,o)||n.children.splice(i,1)}if(0<n.children.length)return n}return s(e.term,t.text,t)?n:null}}}),u.define("select2/compat/query",[],function(){function e(e,t,n){n.get("debug")&&window.console&&console.warn&&console.warn("Select2: The `query` option has been deprecated in favor of a custom data adapter that overrides the `query` method. Support will be removed for the `query` option in future versions of Select2."),e.call(this,t,n)}return e.prototype.query=function(e,t,n){t.callback=n,this.options.get("query").call(null,t)},e}),u.define("select2/dropdown/attachContainer",[],function(){function e(e,t,n){e.call(this,t,n)}return e.prototype.position=function(e,t,n){n.find(".dropdown-wrapper").append(t),t.addClass("select2-dropdown--below"),n.addClass("select2-container--below")},e}),u.define("select2/dropdown/stopPropagation",[],function(){function e(){}return e.prototype.bind=function(e,t,n){e.call(this,t,n);this.$dropdown.on(["blur","change","click","dblclick","focus","focusin","focusout","input","keydown","keyup","keypress","mousedown","mouseenter","mouseleave","mousemove","mouseover","mouseup","search","touchend","touchstart"].join(" "),function(e){e.stopPropagation()})},e}),u.define("select2/selection/stopPropagation",[],function(){function e(){}return e.prototype.bind=function(e,t,n){e.call(this,t,n);this.$selection.on(["blur","change","click","dblclick","focus","focusin","focusout","input","keydown","keyup","keypress","mousedown","mouseenter","mouseleave","mousemove","mouseover","mouseup","search","touchend","touchstart"].join(" "),function(e){e.stopPropagation()})},e}),o=function(c){var u,d,e=["wheel","mousewheel","DOMMouseScroll","MozMousePixelScroll"],t="onwheel"in document||9<=document.documentMode?["wheel"]:["mousewheel","DomMouseScroll","MozMousePixelScroll"],p=Array.prototype.slice;if(c.event.fixHooks)for(var n=e.length;n;)c.event.fixHooks[e[--n]]=c.event.mouseHooks;var h=c.event.special.mousewheel={version:"3.1.12",setup:function(){if(this.addEventListener)for(var e=t.length;e;)this.addEventListener(t[--e],i,!1);else this.onmousewheel=i;c.data(this,"mousewheel-line-height",h.getLineHeight(this)),c.data(this,"mousewheel-page-height",h.getPageHeight(this))},teardown:function(){if(this.removeEventListener)for(var e=t.length;e;)this.removeEventListener(t[--e],i,!1);else this.onmousewheel=null;c.removeData(this,"mousewheel-line-height"),c.removeData(this,"mousewheel-page-height")},getLineHeight:function(e){var e=c(e),t=e["offsetParent"in c.fn?"offsetParent":"parent"]();return t.length||(t=c("body")),parseInt(t.css("fontSize"),10)||parseInt(e.css("fontSize"),10)||16},getPageHeight:function(e){return c(e).height()},settings:{adjustOldDeltas:!0,normalizeOffset:!0}};function i(e){var t,n=e||window.event,i=p.call(arguments,1),o=0,s=0,r=0,a=0,l=0;if((e=c.event.fix(n)).type="mousewheel","detail"in n&&(r=-1*n.detail),"wheelDelta"in n&&(r=n.wheelDelta),"wheelDeltaY"in n&&(r=n.wheelDeltaY),"wheelDeltaX"in n&&(s=-1*n.wheelDeltaX),"axis"in n&&n.axis===n.HORIZONTAL_AXIS&&(s=-1*r,r=0),o=0===r?s:r,"deltaY"in n&&(o=r=-1*n.deltaY),"deltaX"in n&&(s=n.deltaX,0===r)&&(o=-1*s),0!==r||0!==s)return 1===n.deltaMode?(o*=t=c.data(this,"mousewheel-line-height"),r*=t,s*=t):2===n.deltaMode&&(o*=t=c.data(this,"mousewheel-page-height"),r*=t,s*=t),t=Math.max(Math.abs(r),Math.abs(s)),(!d||t<d)&&g(n,d=t)&&(d/=40),g(n,t)&&(o/=40,s/=40,r/=40),o=Math[1<=o?"floor":"ceil"](o/d),s=Math[1<=s?"floor":"ceil"](s/d),r=Math[1<=r?"floor":"ceil"](r/d),h.settings.normalizeOffset&&this.getBoundingClientRect&&(n=this.getBoundingClientRect(),a=e.clientX-n.left,l=e.clientY-n.top),e.deltaX=s,e.deltaY=r,e.deltaFactor=d,e.offsetX=a,e.offsetY=l,e.deltaMode=0,i.unshift(e,o,s,r),u&&clearTimeout(u),u=setTimeout(f,200),(c.event.dispatch||c.event.handle).apply(this,i)}function f(){d=null}function g(e,t){return h.settings.adjustOldDeltas&&"mousewheel"===e.type&&t%120==0}c.fn.extend({mousewheel:function(e){return e?this.bind("mousewheel",e):this.trigger("mousewheel")},unmousewheel:function(e){return this.unbind("mousewheel",e)}})},"function"==typeof u.define&&u.define.amd?u.define("jquery-mousewheel",["jquery"],o):"object"==typeof exports?module.exports=o:o(t),u.define("jquery.select2",["jquery","jquery-mousewheel","./select2/core","./select2/defaults","./select2/utils"],function(o,e,s,t,r){var a;return null==o.fn.select2&&(a=["open","close","destroy"],o.fn.select2=function(t){if("object"==typeof(t=t||{}))return this.each(function(){var e=o.extend(!0,{},t);new s(o(this),e)}),this;var n,i;if("string"==typeof t)return i=Array.prototype.slice.call(arguments,1),this.each(function(){var e=r.GetData(this,"select2");null==e&&window.console&&console.error&&console.error("The select2('"+t+"') method was called on an element that is not using Select2."),n=e[t].apply(e,i)}),-1<o.inArray(t,a)?this:n;throw new Error("Invalid arguments for Select2: "+t)}),null==o.fn.select2.defaults&&(o.fn.select2.defaults=t),s});var e,p,s,r,h,f,g,m,y,v,n,i,_,o,a={define:u.define,require:u.require};function w(e,t){return n.call(e,t)}function l(e,t){var n,i,o,s,r,a,l,c,u,d,p=t&&t.split("/"),h=y.map,f=h&&h["*"]||{};if(e){for(t=(e=e.split("/")).length-1,y.nodeIdCompat&&_.test(e[t])&&(e[t]=e[t].replace(_,"")),"."===e[0].charAt(0)&&p&&(e=p.slice(0,p.length-1).concat(e)),c=0;c<e.length;c++)"."===(d=e[c])?(e.splice(c,1),--c):".."!==d||0===c||1===c&&".."===e[2]||".."===e[c-1]||0<c&&(e.splice(c-1,2),c-=2);e=e.join("/")}if((p||f)&&h){for(c=(n=e.split("/")).length;0<c;--c){if(i=n.slice(0,c).join("/"),p)for(u=p.length;0<u;--u)if(o=(o=h[p.slice(0,u).join("/")])&&o[i]){s=o,r=c;break}if(s)break;!a&&f&&f[i]&&(a=f[i],l=c)}!s&&a&&(s=a,r=l),s&&(n.splice(0,r,s),e=n.join("/"))}return e}function b(t,n){return function(){var e=i.call(arguments,0);return"string"!=typeof e[0]&&1===e.length&&e.push(null),r.apply(p,e.concat([t,n]))}}function A(e){var t;if(w(m,e)&&(t=m[e],delete m[e],v[e]=!0,s.apply(p,t)),w(g,e)||w(v,e))return g[e];throw new Error("No "+e)}function c(e){var t,n=e?e.indexOf("!"):-1;return-1<n&&(t=e.substring(0,n),e=e.substring(n+1,e.length)),[t,e]}function x(e){return e?c(e):[]}var u=a.require("jquery.select2");return t.fn.select2.amd=a,u});
//# sourceMappingURL=select2.js.map;
!function(){var e;(e=jQuery&&jQuery.fn&&jQuery.fn.select2&&jQuery.fn.select2.amd?jQuery.fn.select2.amd:e).define("select2/i18n/en",[],function(){return{errorLoading:function(){return"The results could not be loaded."},inputTooLong:function(e){var e=e.input.length-e.maximum,n="Please delete "+e+" character";return 1!=e&&(n+="s"),n},inputTooShort:function(e){return"Please enter "+(e.minimum-e.input.length)+" or more characters"},loadingMore:function(){return"Loading more results…"},maximumSelected:function(e){var n="You can only select "+e.maximum+" item";return 1!=e.maximum&&(n+="s"),n},noResults:function(){return"No results found"},searching:function(){return"Searching…"},removeAllItems:function(){return"Remove all items"}}}),e.define,e.require}();
//# sourceMappingURL=en.js.map;
!function(){var e;(e=jQuery&&jQuery.fn&&jQuery.fn.select2&&jQuery.fn.select2.amd?jQuery.fn.select2.amd:e).define("select2/i18n/de",[],function(){return{errorLoading:function(){return"Die Ergebnisse konnten nicht geladen werden."},inputTooLong:function(e){return"Bitte "+(e.input.length-e.maximum)+" Zeichen weniger eingeben"},inputTooShort:function(e){return"Bitte "+(e.minimum-e.input.length)+" Zeichen mehr eingeben"},loadingMore:function(){return"Lade mehr Ergebnisse…"},maximumSelected:function(e){var n="Sie können nur "+e.maximum+" Element";return 1!=e.maximum&&(n+="e"),n+" auswählen"},noResults:function(){return"Keine Übereinstimmungen gefunden"},searching:function(){return"Suche…"},removeAllItems:function(){return"Entferne alle Elemente"}}}),e.define,e.require}();
//# sourceMappingURL=de.js.map;
!function(){var e;(e=jQuery&&jQuery.fn&&jQuery.fn.select2&&jQuery.fn.select2.amd?jQuery.fn.select2.amd:e).define("select2/i18n/es",[],function(){return{errorLoading:function(){return"No se pudieron cargar los resultados"},inputTooLong:function(e){e=e.input.length-e.maximum;return"Por favor, elimine "+e+" car"+(1==e?"ácter":"acteres")},inputTooShort:function(e){e=e.minimum-e.input.length;return"Por favor, introduzca "+e+" car"+(1==e?"ácter":"acteres")},loadingMore:function(){return"Cargando más resultados…"},maximumSelected:function(e){var n="Sólo puede seleccionar "+e.maximum+" elemento";return 1!=e.maximum&&(n+="s"),n},noResults:function(){return"No se encontraron resultados"},searching:function(){return"Buscando…"},removeAllItems:function(){return"Eliminar todos los elementos"}}}),e.define,e.require}();
//# sourceMappingURL=es.js.map;
!function(){var e;(e=jQuery&&jQuery.fn&&jQuery.fn.select2&&jQuery.fn.select2.amd?jQuery.fn.select2.amd:e).define("select2/i18n/fr",[],function(){return{errorLoading:function(){return"Les résultats ne peuvent pas être chargés."},inputTooLong:function(e){e=e.input.length-e.maximum;return"Supprimez "+e+" caractère"+(1<e?"s":"")},inputTooShort:function(e){e=e.minimum-e.input.length;return"Saisissez au moins "+e+" caractère"+(1<e?"s":"")},loadingMore:function(){return"Chargement de résultats supplémentaires…"},maximumSelected:function(e){return"Vous pouvez seulement sélectionner "+e.maximum+" élément"+(1<e.maximum?"s":"")},noResults:function(){return"Aucun résultat trouvé"},searching:function(){return"Recherche en cours…"},removeAllItems:function(){return"Supprimer tous les éléments"}}}),e.define,e.require}();
//# sourceMappingURL=fr.js.map;
!function(){var e;(e=jQuery&&jQuery.fn&&jQuery.fn.select2&&jQuery.fn.select2.amd?jQuery.fn.select2.amd:e).define("select2/i18n/pt",[],function(){return{errorLoading:function(){return"Os resultados não puderam ser carregados."},inputTooLong:function(e){e=e.input.length-e.maximum;return"Por favor apague "+e+" "+(1!=e?"caracteres":"caractere")},inputTooShort:function(e){return"Introduza "+(e.minimum-e.input.length)+" ou mais caracteres"},loadingMore:function(){return"A carregar mais resultados…"},maximumSelected:function(e){return"Apenas pode seleccionar "+e.maximum+" "+(1!=e.maximum?"itens":"item")},noResults:function(){return"Sem resultados"},searching:function(){return"A procurar…"},removeAllItems:function(){return"Remover todos os itens"}}}),e.define,e.require}();
//# sourceMappingURL=pt.js.map;
!function(){var e;(e=jQuery&&jQuery.fn&&jQuery.fn.select2&&jQuery.fn.select2.amd?jQuery.fn.select2.amd:e).define("select2/i18n/it",[],function(){return{errorLoading:function(){return"I risultati non possono essere caricati."},inputTooLong:function(e){e=e.input.length-e.maximum;return"Per favore cancella "+e+" caratter"+(1!=e?"i":"e")},inputTooShort:function(e){return"Per favore inserisci "+(e.minimum-e.input.length)+" o più caratteri"},loadingMore:function(){return"Caricando più risultati…"},maximumSelected:function(e){var n="Puoi selezionare solo "+e.maximum+" element";return 1!==e.maximum?n+="i":n+="o",n},noResults:function(){return"Nessun risultato trovato"},searching:function(){return"Sto cercando…"},removeAllItems:function(){return"Rimuovi tutti gli oggetti"}}}),e.define,e.require}();
//# sourceMappingURL=it.js.map;
!function(){var n;(n=jQuery&&jQuery.fn&&jQuery.fn.select2&&jQuery.fn.select2.amd?jQuery.fn.select2.amd:n).define("select2/i18n/ja",[],function(){return{errorLoading:function(){return"結果が読み込まれませんでした"},inputTooLong:function(n){return n.input.length-n.maximum+" 文字を削除してください"},inputTooShort:function(n){return"少なくとも "+(n.minimum-n.input.length)+" 文字を入力してください"},loadingMore:function(){return"読み込み中…"},maximumSelected:function(n){return n.maximum+" 件しか選択できません"},noResults:function(){return"対象が見つかりません"},searching:function(){return"検索しています…"},removeAllItems:function(){return"すべてのアイテムを削除"}}}),n.define,n.require}();
//# sourceMappingURL=ja.js.map;
!function(){var n;(n=jQuery&&jQuery.fn&&jQuery.fn.select2&&jQuery.fn.select2.amd?jQuery.fn.select2.amd:n).define("select2/i18n/zh-CN",[],function(){return{errorLoading:function(){return"无法载入结果。"},inputTooLong:function(n){return"请删除"+(n.input.length-n.maximum)+"个字符"},inputTooShort:function(n){return"请再输入至少"+(n.minimum-n.input.length)+"个字符"},loadingMore:function(){return"载入更多结果…"},maximumSelected:function(n){return"最多只能选择"+n.maximum+"个项目"},noResults:function(){return"未找到结果"},searching:function(){return"搜索中…"},removeAllItems:function(){return"删除所有项目"}}}),n.define,n.require}();
//# sourceMappingURL=zh-CN.js.map;
!function(t,e){"object"==typeof module&&module.exports?(e["default"]=e,module.exports=t&&t.document?e(t):e):"function"==typeof define&&define.amd?define("highcharts/highstock",function(){return e(t)}):(t.Highcharts&&t.Highcharts.error(16,!0),t.Highcharts=e(t))}("undefined"!=typeof window?window:this,function(d){"use strict";var t={};function e(t,e,i,s){t.hasOwnProperty(e)||(t[e]=s.apply(null,i),"function"==typeof CustomEvent&&d.dispatchEvent(new CustomEvent("HighchartsModuleLoaded",{detail:{path:e,module:t[e]}})))}return e(t,"Core/Globals.js",[],function(){var t,i;return(i=t=t||{}).SVG_NS="http://www.w3.org/2000/svg",i.product="Highcharts",i.version="11.3.0",i.win=void 0!==d?d:{},i.doc=i.win.document,i.svg=i.doc&&i.doc.createElementNS&&!!i.doc.createElementNS(i.SVG_NS,"svg").createSVGRect,i.userAgent=i.win.navigator&&i.win.navigator.userAgent||"",i.isChrome=-1!==i.userAgent.indexOf("Chrome"),i.isFirefox=-1!==i.userAgent.indexOf("Firefox"),i.isMS=/(edge|msie|trident)/i.test(i.userAgent)&&!i.win.opera,i.isSafari=!i.isChrome&&-1!==i.userAgent.indexOf("Safari"),i.isTouchDevice=/(Mobile|Android|Windows Phone)/.test(i.userAgent),i.isWebKit=-1!==i.userAgent.indexOf("AppleWebKit"),i.deg2rad=2*Math.PI/360,i.hasBidiBug=i.isFirefox&&parseInt(i.userAgent.split("Firefox/")[1],10)<4,i.hasTouch=!!i.win.TouchEvent,i.marginNames=["plotTop","marginRight","marginBottom","plotLeft"],i.noop=function(){},i.supportsPassiveEvents=function(){let t=!1;var e;return i.isMS||(e=Object.defineProperty({},"passive",{get:function(){t=!0}}),i.win.addEventListener&&i.win.removeEventListener&&(i.win.addEventListener("testPassive",i.noop,e),i.win.removeEventListener("testPassive",i.noop,e))),t}(),i.charts=[],i.composed=[],i.dateFormats={},i.seriesTypes={},i.symbolSizes={},i.chartCount=0,t}),e(t,"Core/Utilities.js",[t["Core/Globals.js"]],function(n){const{charts:e,doc:a,win:l}=n;function h(t,e,i,s){var o=e?"Highcharts error":"Highcharts warning";const r=f(t=32===t?o+": Deprecated member":t);let a=r?o+` #${t}: www.highcharts.com/errors/${t}/`:t.toString();if(void 0!==s){let i="";r&&(a+="?"),k(s,function(t,e){i+=`
 - ${e}: `+t,r&&(a+=encodeURI(e)+"="+encodeURI(t))}),a+=i}A(n,"displayError",{chart:i,code:t,message:a,params:s},function(){if(e)throw new Error(a);l.console&&-1===h.messages.indexOf(a)&&console.warn(a)}),h.messages.push(a)}function r(t,e){return parseInt(t,e||10)}function d(t){return"string"==typeof t}function c(t){t=Object.prototype.toString.call(t);return"[object Array]"===t||"[object Array Iterator]"===t}function p(t,e){return!(!t||"object"!=typeof t||e&&c(t))}function u(t){return p(t)&&"number"==typeof t.nodeType}function g(t){var e=t&&t.constructor;return!(!p(t,!0)||u(t)||!e||!e.name||"Object"===e.name)}function f(t){return"number"==typeof t&&!isNaN(t)&&t<Infinity&&t>-Infinity}function m(t){return null!=t}function i(i,t,e){const s=d(t)&&!m(e);let o;var r=(t,e)=>{m(t)?i.setAttribute(e,t):s?(o=i.getAttribute(e))||"class"!==e||(o=i.getAttribute(e+"Name")):i.removeAttribute(e)};return d(t)?r(e,t):k(t,r),o}function x(t){return c(t)?t:[t]}function v(t,e){let i;for(i in t=t||{},e)t[i]=e[i];return t}function y(){var e=arguments,i=e.length;for(let t=0;t<i;t++){var s=e[t];if(null!=s)return s}}function b(t,e){n.isMS&&!n.svg&&e&&m(e.opacity)&&(e.filter=`alpha(opacity=${100*e.opacity})`),v(t.style,e)}function M(t){return Math.pow(10,Math.floor(Math.log(t)/Math.LN10))}function S(t,e){return 1e14<t?t:parseFloat(t.toPrecision(e||14))}(h=h||{}).messages=[];Math.easeInOutSine=function(t){return-.5*(Math.cos(Math.PI*t)-1)};var t=Array.prototype.find?function(t,e){return t.find(e)}:function(t,e){let i;var s=t.length;for(i=0;i<s;i++)if(e(t[i],i))return t[i]};function k(t,e,i){for(const s in t)Object.hasOwnProperty.call(t,s)&&e.call(i||t[s],t[s],s,t)}function C(o,e,i){function r(t,e){var i=o.removeEventListener;i&&i.call(o,t,e,!1)}function t(i){let t,s;o.nodeName&&(e?(t={})[e]=!0:t=i,k(t,function(t,e){if(i[e])for(s=i[e].length;s--;)r(e,i[e][s].fn)}))}var s,a,n="function"==typeof o&&o.prototype||o;Object.hasOwnProperty.call(n,"hcEvents")&&(s=n.hcEvents,e?(a=s[e]||[],i?(s[e]=a.filter(function(t){return i!==t.fn}),r(e,i)):(t(s),s[e]=[])):(t(s),delete n.hcEvents))}function A(i,s,o,t){var e;if(o=o||{},a.createEvent&&(i.dispatchEvent||i.fireEvent&&i!==n))(e=a.createEvent("Events")).initEvent(s,!0,!0),o=v(e,o),i.dispatchEvent?i.dispatchEvent(o):i.fireEvent(s,o);else if(i.hcEvents){o.target||v(o,{preventDefault:function(){o.defaultPrevented=!0},target:i,type:s});var r=[];let t=i,e=!1;for(;t.hcEvents;)Object.hasOwnProperty.call(t,"hcEvents")&&t.hcEvents[s]&&(r.length&&(e=!0),r.unshift.apply(r,t.hcEvents[s])),t=Object.getPrototypeOf(t);e&&r.sort((t,e)=>t.order-e.order),r.forEach(t=>{!1===t.fn.call(i,o)&&o.preventDefault()})}t&&!o.defaultPrevented&&t.call(i,o)}k({map:"map",each:"forEach",grep:"filter",reduce:"reduce",some:"some"},function(e,i){n[i]=function(t){return h(32,!1,void 0,{["Highcharts."+i]:"use Array."+e}),Array.prototype[e].apply(t,[].slice.call(arguments,1))}});let s;var o=function(){const t=Math.random().toString(36).substring(2,9)+"-";let e=0;return function(){return"highcharts-"+(s?"":t)+e++}}();return l.jQuery&&(l.jQuery.fn.highcharts=function(){var t=[].slice.call(arguments);if(this[0])return t[0]?(new n[d(t[0])?t.shift():"Chart"](this[0],t[0],t[1]),this):e[i(this[0],"data-highcharts-chart")]}),{addEvent:function(t,e,i,s={}){var o="function"==typeof t&&t.prototype||t,o=(Object.hasOwnProperty.call(o,"hcEvents")||(o.hcEvents={}),o.hcEvents);n.Point&&t instanceof n.Point&&t.series&&t.series.chart&&(t.series.chart.runTrackerClick=!0);(r=t.addEventListener)&&r.call(t,e,i,!!n.supportsPassiveEvents&&{passive:void 0===s.passive?-1!==e.indexOf("touch"):s.passive,capture:!1}),o[e]||(o[e]=[]);var r={fn:i,order:"number"==typeof s.order?s.order:Infinity};return o[e].push(r),o[e].sort((t,e)=>t.order-e.order),function(){C(t,e,i)}},arrayMax:function(t){let e=t.length,i=t[0];for(;e--;)t[e]>i&&(i=t[e]);return i},arrayMin:function(t){let e=t.length,i=t[0];for(;e--;)t[e]<i&&(i=t[e]);return i},attr:i,clamp:function(t,e,i){return e<t?t<i?t:i:e},clearTimeout:function(t){m(t)&&clearTimeout(t)},correctFloat:S,createElement:function(t,e,i,s,o){return t=a.createElement(t),e&&v(t,e),o&&b(t,{padding:"0",border:"none",margin:"0"}),i&&b(t,i),s&&s.appendChild(t),t},css:b,defined:m,destroyObjectProperties:function(i,s){k(i,function(t,e){t&&t!==s&&t.destroy&&t.destroy(),delete i[e]})},diffObjects:function(t,e,i,n){var s={};return function l(t,s,o,r){const a=i?s:t;k(t,function(e,i){if(!r&&n&&-1<n.indexOf(i)&&s[i]){e=x(e),o[i]=[];for(let t=0;t<Math.max(e.length,s[i].length);t++)s[i][t]&&(void 0===e[t]?o[i][t]=s[i][t]:(o[i][t]={},l(e[t],s[i][t],o[i][t],r+1)))}else p(e,!0)&&!e.nodeType?(o[i]=c(e)?[]:{},l(e,s[i]||{},o[i],r+1),0!==Object.keys(o[i]).length||"colorAxis"===i&&0===r||delete o[i]):(t[i]!==s[i]||i in t&&!(i in s))&&(o[i]=a[i])})}(t,e,s,0),s},discardElement:function(t){t&&t.parentElement&&t.parentElement.removeChild(t)},erase:function(t,e){let i=t.length;for(;i--;)if(t[i]===e){t.splice(i,1);break}},error:h,extend:v,extendClass:function(t,e){var i=function(){};return v(i.prototype=new t,e),i},find:t,fireEvent:A,getClosestDistance:function(t,e){const i=!e;let s,o,r,a;return t.forEach(t=>{if(1<t.length)for(o=t.length-1,a=o;0<a;a--)(r=t[a]-t[a-1])<0&&!i?(e?.(),e=void 0):r&&(void 0===s||r<s)&&(s=r)}),s},getMagnitude:M,getNestedProperty:function(t,e){for(var i=t.split(".");i.length&&m(e);){var s=i.shift();if(void 0===s||"__proto__"===s)return;if("this"===s){let t;return(t=p(e)?e["@this"]:t)??e}s=e[s];if(!m(s)||"function"==typeof s||"number"==typeof s.nodeType||s===l)return;e=s}return e},getStyle:function w(e,t,i){let s;if("width"===t){let t=Math.min(e.offsetWidth,e.scrollWidth);var o=e.getBoundingClientRect&&e.getBoundingClientRect().width;return o<t&&o>=t-1&&(t=Math.floor(o)),Math.max(0,t-(w(e,"padding-left",!0)||0)-(w(e,"padding-right",!0)||0))}return"height"===t?Math.max(0,Math.min(e.offsetHeight,e.scrollHeight)-(w(e,"padding-top",!0)||0)-(w(e,"padding-bottom",!0)||0)):(o=l.getComputedStyle(e,void 0),s=o&&(s=o.getPropertyValue(t),y(i,"opacity"!==t))?r(s):s)},inArray:function(t,e,i){return h(32,!1,void 0,{"Highcharts.inArray":"use Array.indexOf"}),e.indexOf(t,i)},insertItem:function(t,e){var i=t.options.index,s=e.length;let o;for(o=t.options.isInternal?s:0;o<s+1;o++)if(!e[o]||f(i)&&i<y(e[o].options.index,e[o]._i)||e[o].options.isInternal){e.splice(o,0,t);break}return o},isArray:c,isClass:g,isDOMElement:u,isFunction:function(t){return"function"==typeof t},isNumber:f,isObject:p,isString:d,keys:function(t){return h(32,!1,void 0,{"Highcharts.keys":"use Object.keys"}),Object.keys(t)},merge:function(){let t,e=arguments,i={};const o=function(i,s){return"object"!=typeof i&&(i={}),k(s,function(t,e){"__proto__"!==e&&"constructor"!==e&&(!p(t,!0)||g(t)||u(t)?i[e]=s[e]:i[e]=o(i[e]||{},t))}),i};!0===e[0]&&(i=e[1],e=Array.prototype.slice.call(e,2));var s=e.length;for(t=0;t<s;t++)i=o(i,e[t]);return i},normalizeTickInterval:function(t,e,i,s,o){let r,a=t;var n=t/(i=y(i,M(t)));for(e||(e=o?[1,1.2,1.5,2,2.5,3,4,5,6,8,10]:[1,2,2.5,5,10],!1===s&&(1===i?e=e.filter(function(t){return t%1==0}):i<=.1&&(e=[1/i]))),r=0;r<e.length&&(a=e[r],!(o&&a*i>=t||!o&&n<=(e[r]+(e[r+1]||e[r]))/2));r++);return a=S(a*i,-Math.round(Math.log(.001)/Math.LN10))},objectEach:k,offset:function(t){var e=a.documentElement;return{top:(t=t.parentElement||t.parentNode?t.getBoundingClientRect():{top:0,left:0,width:0,height:0}).top+(l.pageYOffset||e.scrollTop)-(e.clientTop||0),left:t.left+(l.pageXOffset||e.scrollLeft)-(e.clientLeft||0),width:t.width,height:t.height}},pad:function(t,e,i){return new Array((e||2)+1-String(t).replace("-","").length).join(i||"0")+t},pick:y,pInt:r,pushUnique:function(t,e){return t.indexOf(e)<0&&!!t.push(e)},relativeLength:function(t,e,i){return/%$/.test(t)?e*parseFloat(t)/100+(i||0):parseFloat(t)},removeEvent:C,splat:x,stableSort:function(t,i){var e=t.length;let s,o;for(o=0;o<e;o++)t[o].safeI=o;for(t.sort(function(t,e){return 0===(s=i(t,e))?t.safeI-e.safeI:s}),o=0;o<e;o++)delete t[o].safeI},syncTimeout:function(t,e,i){return 0<e?setTimeout(t,e,i):(t.call(0,i),-1)},timeUnits:{millisecond:1,second:1e3,minute:6e4,hour:36e5,day:864e5,week:6048e5,month:24192e5,year:314496e5},uniqueKey:o,useSerialIds:function(t){return s=y(t,s)},wrap:function(t,e,i){const s=t[e];t[e]=function(){const t=arguments,e=this;return i.apply(this,[function(){return s.apply(e,arguments.length?arguments:t)}].concat([].slice.call(arguments)))}}}}),e(t,"Core/Chart/ChartDefaults.js",[],function(){return{alignThresholds:!1,panning:{enabled:!1,type:"x"},styledMode:!1,borderRadius:0,colorCount:10,allowMutatingData:!0,ignoreHiddenSeries:!0,spacing:[10,10,15,10],resetZoomButton:{theme:{},position:{}},reflow:!0,type:"line",zooming:{singleTouch:!1,resetButton:{theme:{zIndex:6},position:{align:"right",x:-10,y:10}}},width:null,height:null,borderColor:"#334eff",backgroundColor:"#ffffff",plotBorderColor:"#cccccc"}}),e(t,"Core/Color/Palettes.js",[],function(){return{colors:["#2caffe","#544fc5","#00e272","#fe6a35","#6b8abc","#d568fb","#2ee0ca","#fa4b42","#feb56a","#91e8e1"]}}),e(t,"Core/Time.js",[t["Core/Globals.js"],t["Core/Utilities.js"]],function(g,t){const i=g["win"],{defined:v,error:a,extend:y,isNumber:n,isObject:e,merge:s,objectEach:f,pad:m,pick:b,splat:o,timeUnits:M}=t,r=g.isSafari&&i.Intl&&i.Intl.DateTimeFormat.prototype.formatRange,h=g.isSafari&&i.Intl&&!i.Intl.DateTimeFormat.prototype.formatRange;class l{constructor(t){this.options={},this.useUTC=!1,this.variableTimezone=!1,this.Date=i.Date,this.getTimezoneOffset=this.timezoneOffsetFunction(),this.update(t)}get(t,e){var i,s;return this.variableTimezone||this.timezoneOffset?(s=(i=e.getTime())-this.getTimezoneOffset(e),e.setTime(s),s=e["getUTC"+t](),e.setTime(i),s):this.useUTC?e["getUTC"+t]():e["get"+t]()}set(t,e,i){var s,o;return this.variableTimezone||this.timezoneOffset?"Milliseconds"===t||"Seconds"===t||"Minutes"===t&&this.getTimezoneOffset(e)%36e5==0?e["setUTC"+t](i):(o=this.getTimezoneOffset(e),o=e.getTime()-o,e.setTime(o),e["setUTC"+t](i),s=this.getTimezoneOffset(e),o=e.getTime()+s,e.setTime(o)):this.useUTC||r&&"FullYear"===t?e["setUTC"+t](i):e["set"+t](i)}update(t={}){var e=b(t.useUTC,!0);this.options=t=s(!0,this.options,t),this.Date=t.Date||i.Date||Date,this.useUTC=e,this.timezoneOffset=e&&t.timezoneOffset||void 0,this.getTimezoneOffset=this.timezoneOffsetFunction(),this.variableTimezone=e&&!(!t.getTimezoneOffset&&!t.timezone)}makeTime(t,e,i,s,o,r){let a,n,l;return this.useUTC?(a=this.Date.UTC.apply(0,arguments),n=this.getTimezoneOffset(a),a+=n,n!==(l=this.getTimezoneOffset(a))?a+=l-n:n-36e5!==this.getTimezoneOffset(a-36e5)||h||(a-=36e5)):a=new this.Date(t,e,b(i,1),b(s,0),b(o,0),b(r,0)).getTime(),a}timezoneOffsetFunction(){const t=this,r=this.options,e=r.getTimezoneOffset;return this.useUTC?r.timezone?t=>{try{var[,,e,,i=0]=Intl.DateTimeFormat("en",{timeZone:r.timezone,timeZoneName:"shortOffset"}).format(t).split(/(GMT|:)/).map(Number),s=60*-(e+i/60)*6e4;if(n(s))return s}catch(o){a(34)}return 0}:this.useUTC&&e?t=>6e4*e(t.valueOf()):()=>6e4*(t.timezoneOffset||0):t=>6e4*new Date(t.toString()).getTimezoneOffset()}dateFormat(i,s,t){if(!v(s)||isNaN(s))return g.defaultOptions.lang&&g.defaultOptions.lang.invalidDate||"";i=b(i,"%Y-%m-%d %H:%M:%S");const o=this,e=new this.Date(s),r=this.get("Hours",e),a=this.get("Day",e),n=this.get("Date",e),l=this.get("Month",e),h=this.get("FullYear",e),d=g.defaultOptions.lang,c=d&&d.weekdays,p=d&&d.shortWeekdays,u=y({a:p?p[a]:c[a].substr(0,3),A:c[a],d:m(n),e:m(n,2," "),w:a,b:d.shortMonths[l],B:d.months[l],m:m(l+1),o:l+1,y:h.toString().substr(2,2),Y:h,H:m(r),k:r,I:m(r%12||12),l:r%12||12,M:m(this.get("Minutes",e)),p:r<12?"AM":"PM",P:r<12?"am":"pm",S:m(this.get("Seconds",e)),L:m(Math.floor(s%1e3),3)},g.dateFormats);return f(u,function(t,e){for(;-1!==i.indexOf("%"+e);)i=i.replace("%"+e,"function"==typeof t?t.call(o,s):t)}),t?i.substr(0,1).toUpperCase()+i.substr(1):i}resolveDTLFormat(t){return e(t,!0)?t:{main:(t=o(t))[0],from:t[1],to:t[2]}}getTimeTicks(t,e,i,s){const o=this,r=o.Date,a=[],n={},l=new r(e),h=t.unitRange,d=t.count||1;let c,p,u,g;if(s=b(s,1),v(e)){o.set("Milliseconds",l,h>=M.second?0:d*Math.floor(o.get("Milliseconds",l)/d)),h>=M.second&&o.set("Seconds",l,h>=M.minute?0:d*Math.floor(o.get("Seconds",l)/d)),h>=M.minute&&o.set("Minutes",l,h>=M.hour?0:d*Math.floor(o.get("Minutes",l)/d)),h>=M.hour&&o.set("Hours",l,h>=M.day?0:d*Math.floor(o.get("Hours",l)/d)),h>=M.day&&o.set("Date",l,h>=M.month?1:Math.max(1,d*Math.floor(o.get("Date",l)/d))),h>=M.month&&(o.set("Month",l,h>=M.year?0:d*Math.floor(o.get("Month",l)/d)),p=o.get("FullYear",l)),h>=M.year&&(p-=p%d,o.set("FullYear",l,p)),h===M.week&&(g=o.get("Day",l),o.set("Date",l,o.get("Date",l)-g+s+(g<s?-7:0))),p=o.get("FullYear",l);var f=o.get("Month",l),m=o.get("Date",l),x=o.get("Hours",l);e=l.getTime(),!o.variableTimezone&&o.useUTC||!v(i)||(u=i-e>4*M.month||o.getTimezoneOffset(e)!==o.getTimezoneOffset(i));let t=l.getTime();for(c=1;t<i;)a.push(t),h===M.year?t=o.makeTime(p+c*d,0):h===M.month?t=o.makeTime(p,f+c*d):!u||h!==M.day&&h!==M.week?u&&h===M.hour&&1<d?t=o.makeTime(p,f,m,x+c*d):t+=h*d:t=o.makeTime(p,f,m+c*d*(h===M.day?1:7)),c++;a.push(t),h<=M.hour&&a.length<1e4&&a.forEach(function(t){t%18e5==0&&"000000000"===o.dateFormat("%H%M%S%L",t)&&(n[t]="day")})}return a.info=y(t,{higherRanks:n,totalRange:h*d}),a}getDateFormat(t,e,i,s){var o=this.dateFormat("%m-%d %H:%M:%S.%L",e),r="01-01 00:00:00.000",a={millisecond:15,second:12,minute:9,hour:6,day:3};let n="millisecond",l=n;for(n in M){if(t===M.week&&+this.dateFormat("%w",e)===i&&o.substr(6)===r.substr(6)){n="week";break}if(M[n]>t){n=l;break}if(a[n]&&o.substr(a[n])!==r.substr(a[n]))break;"week"!==n&&(l=n)}return this.resolveDTLFormat(s[n]).main}}return l}),e(t,"Core/Defaults.js",[t["Core/Chart/ChartDefaults.js"],t["Core/Globals.js"],t["Core/Color/Palettes.js"],t["Core/Time.js"],t["Core/Utilities.js"]],function(t,e,i,s,o){var{isTouchDevice:r,svg:a}=e;const n=o["merge"],l={colors:i.colors,symbols:["circle","diamond","square","triangle","triangle-down"],lang:{loading:"Loading...",months:["January","February","March","April","May","June","July","August","September","October","November","December"],shortMonths:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],weekdays:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],decimalPoint:".",numericSymbols:["k","M","G","T","P","E"],resetZoom:"Reset zoom",resetZoomTitle:"Reset zoom level 1:1",thousandsSep:" "},global:{},time:{Date:void 0,getTimezoneOffset:void 0,timezone:void 0,timezoneOffset:0,useUTC:!0},chart:t,title:{style:{color:"#333333",fontWeight:"bold"},text:"Chart title",align:"center",margin:15,widthAdjust:-44},subtitle:{style:{color:"#666666",fontSize:"0.8em"},text:"",align:"center",widthAdjust:-44},caption:{margin:15,style:{color:"#666666",fontSize:"0.8em"},text:"",align:"left",verticalAlign:"bottom"},plotOptions:{},legend:{enabled:!0,align:"center",alignColumns:!0,className:"highcharts-no-tooltip",layout:"horizontal",itemMarginBottom:2,itemMarginTop:2,labelFormatter:function(){return this.name},borderColor:"#999999",borderRadius:0,navigation:{style:{fontSize:"0.8em"},activeColor:"#0022ff",inactiveColor:"#cccccc"},itemStyle:{color:"#333333",cursor:"pointer",fontSize:"0.8em",textDecoration:"none",textOverflow:"ellipsis"},itemHoverStyle:{color:"#000000"},itemHiddenStyle:{color:"#666666",textDecoration:"line-through"},shadow:!1,itemCheckboxStyle:{position:"absolute",width:"13px",height:"13px"},squareSymbol:!0,symbolPadding:5,verticalAlign:"bottom",x:0,y:0,title:{style:{fontSize:"0.8em",fontWeight:"bold"}}},loading:{labelStyle:{fontWeight:"bold",position:"relative",top:"45%"},style:{position:"absolute",backgroundColor:"#ffffff",opacity:.5,textAlign:"center"}},tooltip:{enabled:!0,animation:a,borderRadius:3,dateTimeLabelFormats:{millisecond:"%A, %e %b, %H:%M:%S.%L",second:"%A, %e %b, %H:%M:%S",minute:"%A, %e %b, %H:%M",hour:"%A, %e %b, %H:%M",day:"%A, %e %b %Y",week:"Week from %A, %e %b %Y",month:"%B %Y",year:"%Y"},footerFormat:"",headerShape:"callout",hideDelay:500,padding:8,shape:"callout",shared:!1,snap:r?25:10,headerFormat:'<span style="font-size: 0.8em">{point.key}</span><br/>',pointFormat:'<span style="color:{point.color}">●</span> {series.name}: <b>{point.y}</b><br/>',backgroundColor:"#ffffff",borderWidth:void 0,shadow:!0,stickOnContact:!1,style:{color:"#333333",cursor:"default",fontSize:"0.8em"},useHTML:!1},credits:{enabled:!0,href:"https://www.highcharts.com?credits",position:{align:"right",x:-10,verticalAlign:"bottom",y:-5},style:{cursor:"pointer",color:"#999999",fontSize:"0.6em"},text:"Highcharts.com"}},h=(l.chart.styledMode=!1,new s(l.time));return{defaultOptions:l,defaultTime:h,getOptions:function(){return l},setOptions:function(t){return n(!0,l,t),(t.time||t.global)&&(e.time?e.time.update(n(l.global,l.time,t.global,t.time)):e.time=h),l}}}),e(t,"Core/Color/Color.js",[t["Core/Globals.js"],t["Core/Utilities.js"]],function(n,t){const{isNumber:r,merge:o,pInt:s}=t;class l{static parse(t){return t?new l(t):l.None}constructor(t){this.rgba=[NaN,NaN,NaN,NaN],this.input=t;var e,i=n.Color;if(i&&i!==l)return new i(t);let s,o,r,a;if("object"==typeof t&&"undefined"!=typeof t.stops)this.stops=t.stops.map(t=>new l(t[1]));else if("string"==typeof t)if(this.input=t=l.names[t.toLowerCase()]||t,"#"===t.charAt(0)&&(i=t.length,e=parseInt(t.substr(1),16),7===i?o=[(16711680&e)>>16,(65280&e)>>8,255&e,1]:4===i&&(o=[(3840&e)>>4|(3840&e)>>8,(240&e)>>4|240&e,(15&e)<<4|15&e,1])),!o)for(r=l.parsers.length;r--&&!o;)(s=(a=l.parsers[r]).regex.exec(t))&&(o=a.parse(s));o&&(this.rgba=o)}get(i){var t=this.input,e=this.rgba;if("object"!=typeof t||"undefined"==typeof this.stops)return e&&r(e[0])?"rgb"===i||!i&&1===e[3]?"rgb("+e[0]+","+e[1]+","+e[2]+")":"a"===i?""+e[3]:"rgba("+e.join(",")+")":t;{const s=o(t);return s.stops=[].slice.call(s.stops),this.stops.forEach((t,e)=>{s.stops[e]=[s.stops[e][0],t.get(i)]}),s}}brighten(e){var i=this.rgba;if(this.stops)this.stops.forEach(function(t){t.brighten(e)});else if(r(e)&&0!==e)for(let t=0;t<3;t++)i[t]+=s(255*e),i[t]<0&&(i[t]=0),255<i[t]&&(i[t]=255);return this}setOpacity(t){return this.rgba[3]=t,this}tweenTo(t,e){var i,s=this.rgba,o=t.rgba;return r(s[0])&&r(o[0])?((i=1!==o[3]||1!==s[3])?"rgba(":"rgb(")+Math.round(o[0]+(s[0]-o[0])*(1-e))+","+Math.round(o[1]+(s[1]-o[1])*(1-e))+","+Math.round(o[2]+(s[2]-o[2])*(1-e))+(i?","+(o[3]+(s[3]-o[3])*(1-e)):"")+")":t.input||"none"}}return l.names={white:"#ffffff",black:"#000000"},l.parsers=[{regex:/rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/,parse:function(t){return[s(t[1]),s(t[2]),s(t[3]),parseFloat(t[4],10)]}},{regex:/rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/,parse:function(t){return[s(t[1]),s(t[2]),s(t[3]),1]}}],l.None=new l(""),l}),e(t,"Core/Animation/Fx.js",[t["Core/Color/Color.js"],t["Core/Globals.js"],t["Core/Utilities.js"]],function(t,e,i){const s=t["parse"],l=e["win"],{isNumber:f,objectEach:h}=i;class d{constructor(t,e,i){this.pos=NaN,this.options=e,this.elem=t,this.prop=i}dSetter(){var t=this.paths,e=t&&t[0],i=t&&t[1],s=this.now||0;let o=[];if(1!==s&&e&&i)if(e.length===i.length&&s<1)for(let t=0;t<i.length;t++){var r=e[t],a=i[t],n=[];for(let t=0;t<a.length;t++){var l=r[t],h=a[t];f(l)&&f(h)&&("A"!==a[0]||4!==t&&5!==t)?n[t]=l+s*(h-l):n[t]=h}o.push(n)}else o=i;else o=this.toD||[];this.elem.attr("d",o,void 0,!0)}update(){var t=this.elem,e=this.prop,i=this.now,s=this.options.step;this[e+"Setter"]?this[e+"Setter"]():t.attr?t.element&&t.attr(e,i,null,!0):t.style[e]=i+this.unit,s&&s.call(t,i,this)}run(t,e,i){const s=this,o=s.options,r=function(t){return!r.stopped&&s.step(t)},a=l.requestAnimationFrame||function(t){setTimeout(t,13)},n=function(){for(let t=0;t<d.timers.length;t++)d.timers[t]()||d.timers.splice(t--,1);d.timers.length&&a(n)};t!==e||this.elem["forceAnimate:"+this.prop]?(this.startTime=+new Date,this.start=t,this.end=e,this.unit=i,this.now=this.start,this.pos=0,r.elem=this.elem,r.prop=this.prop,r()&&1===d.timers.push(r)&&a(n)):(delete o.curAnim[this.prop],o.complete&&0===Object.keys(o.curAnim).length&&o.complete.call(this.elem))}step(t){var e=+new Date,i=this.options,s=this.elem,o=i.complete,r=i.duration,a=i.curAnim;let n,l;return n=!(s.attr&&!s.element||(t||e>=r+this.startTime?(this.now=this.end,this.pos=1,this.update(),a[this.prop]=!0,l=!0,h(a,function(t){!0!==t&&(l=!1)}),l&&o&&o.call(s),1):(this.pos=i.easing((e-this.startTime)/r),this.now=this.start+(this.end-this.start)*this.pos,this.update(),0)))}initPath(t,e,i){const s=t.startX,o=t.endX,r=i.slice(),a=t.isArea,n=a?2:1;let l,h,d,c,p=e&&e.slice();if(!p)return[r,r];function u(t,e){for(;t.length<h;){var i=t[0],s=e[h-t.length];s&&"M"===i[0]&&("C"===s[0]?t[0]=["C",i[1],i[2],i[1],i[2],i[1],i[2]]:t[0]=["L",i[1],i[2]]),t.unshift(i),a&&(s=t.pop(),t.push(t[t.length-1],s))}}function g(t){for(;t.length<h;){var e,i=t[Math.floor(t.length/n)-1].slice();"C"===i[0]&&(i[1]=i[5],i[2]=i[6]),a?(e=t[Math.floor(t.length/n)].slice(),t.splice(t.length/2,0,i,e)):t.push(i)}}if(s&&o&&o.length){for(d=0;d<s.length;d++){if(s[d]===o[0]){l=d;break}if(s[0]===o[o.length-s.length+d]){l=d,c=!0;break}if(s[s.length-1]===o[o.length-s.length+d]){l=s.length-d;break}}void 0===l&&(p=[])}return p.length&&f(l)&&(h=r.length+l*n,c?(u(p,r),g(r,p)):(u(r,p),g(p))),[p,r]}fillSetter(){d.prototype.strokeSetter.apply(this,arguments)}strokeSetter(){this.elem.attr(this.prop,s(this.start).tweenTo(s(this.end),this.pos),void 0,!0)}}return d.timers=[],d}),e(t,"Core/Animation/AnimationUtilities.js",[t["Core/Animation/Fx.js"],t["Core/Utilities.js"]],function(h,t){const{defined:n,getStyle:d,isArray:c,isNumber:e,isObject:p,merge:u,objectEach:g,pick:i}=t;function l(t){return p(t)?u({duration:500,defer:0},t):{duration:t?500:0,defer:0}}function f(t,e){let i=h.timers.length;for(;i--;)h.timers[i].elem!==t||e&&e!==h.timers[i].prop||(h.timers[i].stopped=!0)}return{animate:function(i,s,o){let r,a="",n,l,t;p(o)||(o={duration:(t=arguments)[2],easing:t[3],complete:t[4]}),e(o.duration)||(o.duration=400),o.easing="function"==typeof o.easing?o.easing:Math[o.easing]||Math.easeInOutSine,o.curAnim=u(s),g(s,function(t,e){f(i,e),l=new h(i,o,e),n=void 0,"d"===e&&c(s.d)?(l.paths=l.initPath(i,i.pathArray,s.d),l.toD=s.d,r=0,n=1):i.attr?r=i.attr(e):(r=parseFloat(d(i,e))||0,"opacity"!==e&&(a="px")),"string"==typeof(n=n||t)&&n.match("px")&&(n=n.replace(/px/g,"")),l.run(r,n,a)})},animObject:l,getDeferredAnimation:function(t,e,i){const s=l(e),o=i?[i]:t.series;let r=0,a=0;return o.forEach(t=>{t=l(t.options.animation);r=p(e)&&n(e.defer)?s.defer:Math.max(r,t.duration+t.defer),a=Math.min(s.duration,t.duration)}),t.renderer.forExport&&(r=0),{defer:Math.max(0,r-a),duration:Math.min(r,a)}},setAnimation:function(t,e){e.renderer.globalAnimation=i(t,e.options.chart.animation,!0)},stop:f}}),e(t,"Core/Renderer/HTML/AST.js",[t["Core/Globals.js"],t["Core/Utilities.js"]],function(d,t){const{SVG_NS:c,win:e}=d,{attr:p,createElement:o,css:u,error:g,isFunction:i,isString:r,objectEach:f,splat:s}=t;t=e.trustedTypes;const n=t&&i(t.createPolicy)&&t.createPolicy("highcharts",{createHTML:t=>t}),a=n?n.createHTML(""):"",l=function(){try{return Boolean((new DOMParser).parseFromString(a,"text/html"))}catch(t){return!1}}();class m{static filterUserAttributes(s){return f(s,(e,t)=>{let i=!0;-1===m.allowedAttributes.indexOf(t)&&(i=!1),(i=-1!==["background","dynsrc","href","lowsrc","src"].indexOf(t)?r(e)&&m.allowedReferences.some(t=>0===e.indexOf(t)):i)||(g(33,!1,void 0,{"Invalid attribute in config":""+t}),delete s[t]),r(e)&&s[t]&&(s[t]=e.replace(/</g,"&lt;"))}),s}static parseStyle(t){return t.split(";").reduce((t,e)=>{var e=e.split(":").map(t=>t.trim()),i=e.shift();return i&&e.length&&(t[i.replace(/-([a-z])/g,t=>t[1].toUpperCase())]=e.join(":")),t},{})}static setElementHTML(t,e){t.innerHTML=m.emptyHTML,e&&new m(e).addToDOM(t)}constructor(t){this.nodes="string"==typeof t?this.parseMarkup(t):t}addToDOM(t){return function h(t,n){let l;return s(t).forEach(function(t){var e=t.tagName,i=t.textContent?d.doc.createTextNode(t.textContent):void 0,s=m.bypassHTMLFiltering;let o;if(e)if("#text"===e)o=i;else if(-1!==m.allowedTags.indexOf(e)||s){var r="svg"!==e&&n.namespaceURI||c,r=d.doc.createElementNS(r,e);const a=t.attributes||{};f(t,function(t,e){"tagName"!==e&&"attributes"!==e&&"children"!==e&&"style"!==e&&"textContent"!==e&&(a[e]=t)}),p(r,s?a:m.filterUserAttributes(a)),t.style&&u(r,t.style),i&&r.appendChild(i),h(t.children||[],r),o=r}else g(33,!1,void 0,{"Invalid tagName in config":e});o&&n.appendChild(o),l=o}),l}(this.nodes,t)}parseMarkup(t){const e=[];t=t.trim().replace(/ style=(["'])/g," data-style=$1");let i;var s;i=l?(new DOMParser).parseFromString(n?n.createHTML(t):t,"text/html"):((s=o("div")).innerHTML=t,{body:s});const a=(t,e)=>{var i=t.nodeName.toLowerCase();const s={tagName:i};"#text"===i&&(s.textContent=t.textContent||"");i=t.attributes;if(i){const o={};[].forEach.call(i,t=>{"data-style"===t.name?s.style=m.parseStyle(t.value):o[t.name]=t.value}),s.attributes=o}if(t.childNodes.length){const r=[];[].forEach.call(t.childNodes,t=>{a(t,r)}),r.length&&(s.children=r)}e.push(s)};return[].forEach.call(i.body.childNodes,t=>a(t,e)),e}}return m.allowedAttributes=["alt","aria-controls","aria-describedby","aria-expanded","aria-haspopup","aria-hidden","aria-label","aria-labelledby","aria-live","aria-pressed","aria-readonly","aria-roledescription","aria-selected","class","clip-path","color","colspan","cx","cy","d","dx","dy","disabled","fill","filterUnits","flood-color","flood-opacity","height","href","id","in","markerHeight","markerWidth","offset","opacity","orient","padding","paddingLeft","paddingRight","patternUnits","r","refX","refY","role","scope","slope","src","startOffset","stdDeviation","stroke","stroke-linecap","stroke-width","style","tableValues","result","rowspan","summary","target","tabindex","text-align","text-anchor","textAnchor","textLength","title","type","valign","width","x","x1","x2","xlink:href","y","y1","y2","zIndex"],m.allowedReferences=["https://","http://","mailto:","/","../","./","#"],m.allowedTags=["a","abbr","b","br","button","caption","circle","clipPath","code","dd","defs","div","dl","dt","em","feComponentTransfer","feDropShadow","feFuncA","feFuncB","feFuncG","feFuncR","feGaussianBlur","feOffset","feMerge","feMergeNode","filter","h1","h2","h3","h4","h5","h6","hr","i","img","li","linearGradient","marker","ol","p","path","pattern","pre","rect","small","span","stop","strong","style","sub","sup","svg","table","text","textPath","thead","title","tbody","tspan","td","th","tr","u","ul","#text"],m.emptyHTML=a,m.bypassHTMLFiltering=!1,m}),e(t,"Core/Templating.js",[t["Core/Defaults.js"],t["Core/Utilities.js"]],function(t,e){const{defaultOptions:y,defaultTime:b}=t,{extend:o,getNestedProperty:M,isArray:r,isNumber:p,isObject:a,pick:S,pInt:u}=e,k={add:(t,e)=>t+e,divide:(t,e)=>0!==e?t/e:"",eq:(t,e)=>t==e,each:function(i){const s=arguments[arguments.length-1];return!!r(i)&&i.map((t,e)=>C(s.body,o(a(t)?t:{"@this":t},{"@index":e,"@first":0===e,"@last":e===i.length-1}))).join("")},ge:(t,e)=>e<=t,gt:(t,e)=>e<t,"if":t=>!!t,le:(t,e)=>t<=e,lt:(t,e)=>t<e,multiply:(t,e)=>t*e,ne:(t,e)=>t!=e,subtract:(t,e)=>t-e,unless:t=>!t};function C(h="",d,t){const e=/\{([a-zA-Z0-9\:\.\,;\-\/<>%_@"'= #\(\)]+)\}/g,i=/\(([a-zA-Z0-9\:\.\,;\-\/<>%_@"'= ]+)\)/g,s=[],c=/f$/,p=/\.([0-9])/,u=y.lang,g=t&&t.time||b,f=t&&t.numberFormatter||A,m=(t="")=>{var e;return"true"===t||"false"!==t&&((e=Number(t)).toString()===t?e:M(t,d))};let o,r,a=0,n;for(;null!==(o=e.exec(h));){var l,x=i.exec(o[1]),v=(x&&(o=x,n=!0),r&&r.isBlock||(r={ctx:d,expression:o[1],find:o[0],isBlock:"#"===o[1].charAt(0),start:o.index,startInner:o.index+o[0].length,length:o[0].length}),o[1].split(" ")[0].replace("#","")),v=(k[v]&&(r.isBlock&&v===r.fn&&a++,r.fn||(r.fn=v)),"else"===o[1]);if(r.isBlock&&r.fn&&(o[1]==="/"+r.fn||v)?a?v||a--:(l=r.startInner,l=h.substr(l,o.index-l),void 0===r.body?(r.body=l,r.startInner=o.index+o[0].length):r.elseBody=l,r.find+=l+o[0],v||(s.push(r),r=void 0)):r.isBlock||s.push(r),x&&!r?.isBlock)break}return s.forEach(t=>{var{body:e,elseBody:i,expression:s,fn:o}=t;let r,a;if(o){var n=[t],l=s.split(" ");for(a=k[o].length;a--;)n.unshift(m(l[a+1]));r=k[o].apply(d,n),t.isBlock&&"boolean"==typeof r&&(r=C(r?e:i,d))}else{o=s.split(":");r=m(o.shift()||""),o.length&&"number"==typeof r&&(e=o.join(":"),c.test(e)?(i=parseInt((e.match(p)||["","-1"])[1],10),null!==r&&(r=f(r,i,u.decimalPoint,-1<e.indexOf(",")?u.thousandsSep:""))):r=g.dateFormat(e,r))}h=h.replace(t.find,S(r,""))}),n?C(h,d,t):h}function A(t,e,i,s){t=+t||0,e=+e;let o,r;var a=y.lang,n=(t.toString().split(".")[1]||"").split("e")[0].length,l=t.toString().split("e"),h=e,n=(-1===e?e=Math.min(n,20):p(e)?e&&l[1]&&l[1]<0&&(0<=(r=e+ +l[1])?(l[0]=(+l[0]).toExponential(r).split("e")[0],e=r):(l[0]=l[0].split(".")[0]||0,t=e<20?(l[0]*Math.pow(10,l[1])).toFixed(e):0,l[1]=0)):e=2,(Math.abs(l[1]?l[0]:t)+Math.pow(10,-Math.max(e,n)-1)).toFixed(e)),d=String(u(n)),c=3<d.length?d.length%3:0;return i=S(i,a.decimalPoint),s=S(s,a.thousandsSep),o=t<0?"-":"",o+=c?d.substr(0,c)+s:"",+l[1]<0&&!h?o="0":o+=d.substr(c).replace(/(\d{3})(?=\d)/g,"$1"+s),e&&(o+=i+n.slice(-e)),l[1]&&0!=+o&&(o+="e"+l[1]),o}return{dateFormat:function(t,e,i){return b.dateFormat(t,e,i)},format:C,helpers:k,numberFormat:A}}),e(t,"Core/Renderer/RendererUtilities.js",[t["Core/Utilities.js"]],function(t){const{clamp:v,pick:y,pushUnique:b,stableSort:M}=t;var e;return(e||(e={})).distribute=function S(e,i,s){const o=e,t=o.reducedLen||i,r=(t,e)=>t.target-e.target,a=[],n=e.length,l=[],h=a.push;let d,c,p,u=!0,g,f,m=0,x;for(d=n;d--;)m+=e[d].size;if(m>t){for(M(e,(t,e)=>(e.rank||0)-(t.rank||0)),x=e[0].rank===e[e.length-1].rank,p=x?n/2:-1,c=x?p:n-1;p&&m>t;)d=Math.floor(c),g=e[d],b(l,d)&&(m-=g.size),c+=p,x&&c>=e.length&&(p/=2,c=p);l.sort((t,e)=>e-t).forEach(t=>h.apply(a,e.splice(t,1)))}for(M(e,r),e=e.map(t=>({size:t.size,targets:[t.target],align:y(t.align,.5)}));u;){for(d=e.length;d--;)g=e[d],f=(Math.min.apply(0,g.targets)+Math.max.apply(0,g.targets))/2,g.pos=v(f-g.size*g.align,0,i-g.size);for(d=e.length,u=!1;d--;)0<d&&e[d-1].pos+e[d-1].size>e[d].pos&&(e[d-1].size+=e[d].size,e[d-1].targets=e[d-1].targets.concat(e[d].targets),e[d-1].align=.5,e[d-1].pos+e[d-1].size>i&&(e[d-1].pos=i-e[d-1].size),e.splice(d,1),u=!0)}return h.apply(o,a),d=0,e.some(t=>{let e=0;return(t.targets||[]).some(()=>(o[d].pos=t.pos+e,void 0!==s&&Math.abs(o[d].pos-o[d].target)>s?(o.slice(0,d+1).forEach(t=>delete t.pos),o.reducedLen=(o.reducedLen||i)-.1*i,o.reducedLen>.1*i&&S(o,i,s),!0):(e+=o[d].size,d++,!1)))}),M(o,r),o},e}),e(t,"Core/Renderer/SVG/SVGElement.js",[t["Core/Animation/AnimationUtilities.js"],t["Core/Color/Color.js"],t["Core/Globals.js"],t["Core/Utilities.js"]],function(t,x,e,i){const{animate:r,animObject:a,stop:c}=t,{deg2rad:A,doc:n,svg:l,SVG_NS:h,win:s}=e,{addEvent:d,attr:p,createElement:o,css:w,defined:T,erase:u,extend:P,fireEvent:v,isArray:y,isFunction:O,isObject:g,isString:f,merge:b,objectEach:M,pick:L,pInt:m,syncTimeout:S,uniqueKey:k}=i;class E{_defaultGetter(t){let e=L(this[t+"Value"],this[t],this.element?this.element.getAttribute(t):null,0);return e=/^[\-0-9\.]+$/.test(e)?parseFloat(e):e}_defaultSetter(t,e,i){i.setAttribute(e,t)}add(t){var e=this.renderer,i=this.element;let s;return t&&(this.parentGroup=t),"undefined"!=typeof this.textStr&&"text"===this.element.nodeName&&e.buildText(this),this.added=!0,(s=t&&!t.handleZ&&!this.zIndex?s:this.zIndexSetter())||(t?t.element:e.box).appendChild(i),this.onAdd&&this.onAdd(),this}addClass(t,e){const i=!e&&this.attr("class")||"";return(t=(t||"").split(/ /g).reduce(function(t,e){return-1===i.indexOf(e)&&t.push(e),t},i?[i]:[]).join(" "))!==i&&this.attr("class",t),this}afterSetters(){this.doTransform&&(this.updateTransform(),this.doTransform=!1)}align(t,e,i){var s={},o=this.renderer,r=o.alignedObjects;let a,n,l,h,d;t?(this.alignOptions=t,this.alignByTranslate=e,i&&!f(i)||(this.alignTo=l=i||"renderer",u(r,this),r.push(this),i=void 0)):(t=this.alignOptions,e=this.alignByTranslate,l=this.alignTo),i=L(i,o[l],"scrollablePlotBox"===l?o.plotBox:void 0,o);r=t.align,o=t.verticalAlign;return a=(i.x||0)+(t.x||0),n=(i.y||0)+(t.y||0),"right"===r?h=1:"center"===r&&(h=2),h&&(a+=(i.width-(t.width||0))/h),s[e?"translateX":"x"]=Math.round(a),"bottom"===o?d=1:"middle"===o&&(d=2),d&&(n+=(i.height-(t.height||0))/d),s[e?"translateY":"y"]=Math.round(n),this[this.placed?"animate":"attr"](s),this.placed=!0,this.alignAttr=s,this}alignSetter(t){var e={left:"start",center:"middle",right:"end"};e[t]&&(this.alignValue=t,this.element.setAttribute("text-anchor",e[t]))}animate(t,e,i){const s=a(L(e,this.renderer.globalAnimation,!0)),o=s.defer;return n.hidden&&(s.duration=0),0!==s.duration?(i&&(s.complete=i),S(()=>{this.element&&r(this,t,s)},o)):(this.attr(t,void 0,i||s.complete),M(t,function(t,e){s.step&&s.step.call(this,t,{prop:e,pos:1,elem:this})},this)),this}applyTextOutline(t){var i=this.element,t=(t=-1!==t.indexOf("contrast")?t.replace(/contrast/g,this.renderer.getContrast(i.style.fill)):t).split(" "),s=t[t.length-1];let o=t[0];if(o&&"none"!==o&&e.svg){this.fakeTS=!0,o=o.replace(/(^[\d\.]+)(.*?)$/g,function(t,e,i){return 2*Number(e)+i}),this.removeTextOutline();const r=n.createElementNS(h,"tspan");p(r,{"class":"highcharts-text-outline",fill:s,stroke:s,"stroke-width":o,"stroke-linejoin":"round"});t=i.querySelector("textPath")||i;[].forEach.call(t.childNodes,t=>{const e=t.cloneNode(!0);e.removeAttribute&&["fill","stroke","stroke-width","stroke"].forEach(t=>e.removeAttribute(t)),r.appendChild(e)});let e=0;[].forEach.call(t.querySelectorAll("text tspan"),t=>{e+=Number(t.getAttribute("dy"))});s=n.createElementNS(h,"tspan");s.textContent="​",p(s,{x:Number(i.getAttribute("x")),dy:-e}),r.appendChild(s),t.insertBefore(r,t.firstChild)}}attr(i,t,e,s){const o=this.element,r=E.symbolCustomAttribs;let a,n,l=this,h,d;return"string"==typeof i&&void 0!==t&&(a=i,(i={})[a]=t),"string"==typeof i?l=(this[i+"Getter"]||this._defaultGetter).call(this,i,o):(M(i,function(t,e){h=!1,s||c(this,e),this.symbolName&&-1!==r.indexOf(e)&&(n||(this.symbolAttr(i),n=!0),h=!0),!this.rotation||"x"!==e&&"y"!==e||(this.doTransform=!0),h||(d=this[e+"Setter"]||this._defaultSetter).call(this,t,e,o)},this),this.afterSetters()),e&&e.call(this),l}clip(t){var e,i;return t&&!t.clipPath&&(e=k()+"-",i=this.renderer.createElement("clipPath").attr({id:e}).add(this.renderer.defs),P(t,{clipPath:i,id:e,count:0}),t.add(i)),this.attr("clip-path",t?`url(${this.renderer.url}#${t.id})`:"none")}crisp(t,e){e=e||t.strokeWidth||0;var i=Math.round(e)%2/2;return t.x=Math.floor(t.x||this.x||0)+i,t.y=Math.floor(t.y||this.y||0)+i,t.width=Math.floor((t.width||this.width||0)-2*i),t.height=Math.floor((t.height||this.height||0)-2*i),T(t.strokeWidth)&&(t.strokeWidth=e),t}complexColor(t,i,s){const o=this.renderer;let r,a,n,l,h,d,c,p,u,g,f=[],m;v(this.renderer,"complexColor",{args:arguments},function(){if(t.radialGradient?a="radialGradient":t.linearGradient&&(a="linearGradient"),a){if(n=t[a],h=o.gradients,d=t.stops,u=s.radialReference,y(n)&&(t[a]=n={x1:n[0],y1:n[1],x2:n[2],y2:n[3],gradientUnits:"userSpaceOnUse"}),"radialGradient"===a&&u&&!T(n.gradientUnits)&&(l=n,n=b(n,o.getRadialAttr(u,l),{gradientUnits:"userSpaceOnUse"})),M(n,function(t,e){"id"!==e&&f.push(e,t)}),M(d,function(t){f.push(t)}),f=f.join(","),h[f])g=h[f].attr("id");else{n.id=g=k();const e=h[f]=o.createElement(a).attr(n).add(o.defs);e.radAttr=l,e.stops=[],d.forEach(function(t){p=0===t[1].indexOf("rgba")?(r=x.parse(t[1]),c=r.get("rgb"),r.get("a")):(c=t[1],1);t=o.createElement("stop").attr({offset:t[0],"stop-color":c,"stop-opacity":p}).add(e);e.stops.push(t)})}m="url("+o.url+"#"+g+")",s.setAttribute(i,m),s.gradient=f,t.toString=function(){return m}}})}css(t){const i=this.styles,s={},e=this.element;let o,r=!i;if(i&&M(t,function(t,e){i&&i[e]!==t&&(s[e]=t,r=!0)}),r){null===(t=i?P(i,s):t).width||"auto"===t.width?delete this.textWidth:"text"===e.nodeName.toLowerCase()&&t.width&&(o=this.textWidth=m(t.width)),this.styles=t,o&&!l&&this.renderer.forExport&&delete t.width;const a=b(t);e.namespaceURI===this.SVG_NS&&(["textOutline","textOverflow","width"].forEach(t=>a&&delete a[t]),a.color)&&(a.fill=a.color),w(e,a)}return this.added&&("text"===this.element.nodeName&&this.renderer.buildText(this),t.textOutline)&&this.applyTextOutline(t.textOutline),this}dashstyleSetter(t){let e,i=this["stroke-width"];if("inherit"===i&&(i=1),t=t&&t.toLowerCase()){var s=t.replace("shortdashdotdot","3,1,1,1,1,1,").replace("shortdashdot","3,1,1,1").replace("shortdot","1,1,").replace("shortdash","3,1,").replace("longdash","8,3,").replace(/dot/g,"1,3,").replace("dash","4,3,").replace(/,$/,"").split(",");for(e=s.length;e--;)s[e]=""+m(s[e])*L(i,NaN);t=s.join(",").replace(/NaN/g,"none"),this.element.setAttribute("stroke-dasharray",t)}}destroy(){const i=this,t=i.element||{},e=i.renderer,s=t.ownerSVGElement;let o="SPAN"===t.nodeName&&i.parentGroup||void 0,r,a;if(t.onclick=t.onmouseout=t.onmouseover=t.onmousemove=t.point=null,c(i),i.clipPath&&s){const n=i.clipPath;[].forEach.call(s.querySelectorAll("[clip-path],[CLIP-PATH]"),function(t){-1<t.getAttribute("clip-path").indexOf(n.element.id)&&t.removeAttribute("clip-path")}),i.clipPath=n.destroy()}if(i.connector=i.connector?.destroy(),i.stops){for(a=0;a<i.stops.length;a++)i.stops[a].destroy();i.stops.length=0,i.stops=void 0}for(i.safeRemoveChild(t);o&&o.div&&0===o.div.childNodes.length;)r=o.parentGroup,i.safeRemoveChild(o.div),delete o.div,o=r;i.alignTo&&u(e.alignedObjects,i),M(i,function(t,e){i[e]&&i[e].parentGroup===i&&i[e].destroy&&i[e].destroy(),delete i[e]})}dSetter(t,e,i){y(t)&&("string"==typeof t[0]&&(t=this.renderer.pathToSegments(t)),t=(this.pathArray=t).reduce((t,e,i)=>e&&e.join?(i?t+" ":"")+e.join(" "):(e||"").toString(),"")),/(NaN| {2}|^$)/.test(t)&&(t="M 0 0"),this[e]!==t&&(i.setAttribute(e,t),this[e]=t)}fillSetter(t,e,i){"string"==typeof t?i.setAttribute(e,t):t&&this.complexColor(t,e,i)}hrefSetter(t,e,i){i.setAttributeNS("http://www.w3.org/1999/xlink",e,t)}getBBox(t,e){const i=this,{alignValue:s,element:o,renderer:r,styles:a,textStr:n}=i,{cache:l,cacheKeys:h}=r,d=o.namespaceURI===i.SVG_NS,c=L(e,i.rotation,0),p=r.styledMode?o&&E.prototype.getStyle.call(o,"font-size"):a&&a.fontSize;let u,g,f,m,x;if(T(n)&&(-1===(x=n.toString()).indexOf("<")&&(x=x.replace(/[0-9]/g,"0")),x+=["",r.rootFontSize,p,c,i.textWidth,s,a&&a.textOverflow,a&&a.fontWeight].join(",")),!(u=x&&!t?l[x]:u)){if(d||r.forExport){try{m=this.fakeTS&&function(t){var e=o.querySelector(".highcharts-text-outline");e&&w(e,{display:t})},O(m)&&m("none"),u=o.getBBox?P({},o.getBBox()):{width:o.offsetWidth,height:o.offsetHeight,x:0,y:0},O(m)&&m("")}catch(C){}(!u||u.width<0)&&(u={x:0,y:0,width:0,height:0})}else u=i.htmlGetBBox();var v,y,b,M,S,k;g=u.width,f=u.height,d&&(u.height=f={"11px,17":14,"13px,20":16}[`${p||""},`+Math.round(f)]||f),c&&(e=Number(o.getAttribute("y")||0)-u.y,t={right:1,center:.5}[s||0]||0,k=c*A,S=(c-90)*A,M=g*Math.cos(k),k=g*Math.sin(k),b=Math.cos(S),S=Math.sin(S),v=u.x+t*(g-M),t=u.y+e-t*k,M=(b=(y=(v=v+e*b)+M)-f*b)-M,k=(S=(e=(t=t+e*S)+k)-f*S)-k,u.x=Math.min(v,y,b,M),u.y=Math.min(t,e,S,k),u.width=Math.max(v,y,b,M)-u.x,u.height=Math.max(t,e,S,k)-u.y)}if(x&&(""===n||0<u.height)){for(;250<h.length;)delete l[h.shift()];l[x]||h.push(x),l[x]=u}return u}getStyle(t){return s.getComputedStyle(this.element||this,"").getPropertyValue(t)}hasClass(t){return-1!==(""+this.attr("class")).split(" ").indexOf(t)}hide(){return this.attr({visibility:"hidden"})}htmlGetBBox(){return{height:0,width:0,x:0,y:0}}constructor(t,e){this.onEvents={},this.opacity=1,this.SVG_NS=h,this.element="span"===e?o(e):n.createElementNS(this.SVG_NS,e),this.renderer=t,v(this,"afterInit")}on(t,e){var i=this["onEvents"];return i[t]&&i[t](),i[t]=d(this.element,t,e),this}opacitySetter(t,e,i){t=Number(Number(t).toFixed(3));this.opacity=t,i.setAttribute(e,t)}removeClass(t){return this.attr("class",(""+this.attr("class")).replace(f(t)?new RegExp(`(^| )${t}( |$)`):t," ").replace(/ +/g," ").trim())}removeTextOutline(){var t=this.element.querySelector("tspan.highcharts-text-outline");t&&this.safeRemoveChild(t)}safeRemoveChild(t){var e=t.parentNode;e&&e.removeChild(t)}setRadialReference(t){var e=this.element.gradient&&this.renderer.gradients[this.element.gradient];return this.element.radialReference=t,e&&e.radAttr&&e.animate(this.renderer.getRadialAttr(t,e.radAttr)),this}setTextPath(s,t){t=b(!0,{enabled:!0,attributes:{dy:-5,startOffset:"50%",textAnchor:"middle"}},t);const o=this.renderer.url,r=this.text||this,e=r.textPath,{attributes:a,enabled:n}=t;return s=s||e&&e.path,e&&e.undo(),s&&n?(t=d(r,"afterModifyTree",e=>{if(s&&n){let t=s.attr("id");t||s.attr("id",t=k());var i={x:0,y:0},i=(T(a.dx)&&(i.dx=a.dx,delete a.dx),T(a.dy)&&(i.dy=a.dy,delete a.dy),r.attr(i),this.attr({transform:""}),this.box&&(this.box=this.box.destroy()),e.nodes.slice(0));e.nodes.length=0,e.nodes[0]={tagName:"textPath",attributes:P(a,{"text-anchor":a.textAnchor,href:o+"#"+t}),children:i}}}),r.textPath={path:s,undo:t}):(r.attr({dx:0,dy:0}),delete r.textPath),this.added&&(r.textCache="",this.renderer.buildText(r)),this}shadow(t){var e=this["renderer"],i=b(90===this.parentGroup?.rotation?{offsetX:-1,offsetY:-1}:{},g(t)?t:{}),i=e.shadowDefinition(i);return this.attr({filter:t?`url(${e.url}#${i})`:"none"})}show(t=!0){return this.attr({visibility:t?"inherit":"visible"})}"stroke-widthSetter"(t,e,i){this[e]=t,i.setAttribute(e,t)}strokeWidth(){if(!this.renderer.styledMode)return this["stroke-width"]||0;var t=this.getStyle("stroke-width");let e=0,i;return t.indexOf("px")===t.length-2?e=m(t):""!==t&&(i=n.createElementNS(h,"rect"),p(i,{width:t,"stroke-width":0}),this.element.parentNode.appendChild(i),e=i.getBBox().width,i.parentNode.removeChild(i)),e}symbolAttr(e){const i=this;E.symbolCustomAttribs.forEach(function(t){i[t]=L(e[t],i[t])}),i.attr({d:i.renderer.symbols[i.symbolName](i.x,i.y,i.width,i.height,i)})}textSetter(t){t!==this.textStr&&(delete this.textPxLength,this.textStr=t,this.added)&&this.renderer.buildText(this)}titleSetter(t){var e=this.element,i=e.getElementsByTagName("title")[0]||n.createElementNS(this.SVG_NS,"title");e.insertBefore?e.insertBefore(i,e.firstChild):e.appendChild(i),i.textContent=String(L(t,"")).replace(/<[^>]*>/g,"").replace(/&lt;/g,"<").replace(/&gt;/g,">")}toFront(){var t=this.element;return t.parentNode.appendChild(t),this}translate(t,e){return this.attr({translateX:t,translateY:e})}updateTransform(t="transform"){var{element:e,matrix:i,rotation:s=0,scaleX:o,scaleY:r,translateX:a=0,translateY:n=0}=this,a=["translate("+a+","+n+")"];T(i)&&a.push("matrix("+i.join(",")+")"),s&&a.push("rotate("+s+" "+L(this.rotationOriginX,e.getAttribute("x"),0)+" "+L(this.rotationOriginY,e.getAttribute("y")||0)+")"),(T(o)||T(r))&&a.push("scale("+L(o,1)+" "+L(r,1)+")"),a.length&&!(this.text||this).textPath&&e.setAttribute(t,a.join(" "))}visibilitySetter(t,e,i){"inherit"===t?i.removeAttribute(e):this[e]!==t&&i.setAttribute(e,t),this[e]=t}xGetter(t){return"circle"===this.element.nodeName&&("x"===t?t="cx":"y"===t&&(t="cy")),this._defaultGetter(t)}zIndexSetter(t,e){var i=this.renderer,s=this.parentGroup,o=(s||i).element||i.box,r=this.element,a=o===i.box;let n,l,h,d=!1,c,p=this.added,u;if(T(t)?(r.setAttribute("data-z-index",t),this[e]===(t=+t)&&(p=!1)):T(this[e])&&r.removeAttribute("data-z-index"),this[e]=t,p){for((t=this.zIndex)&&s&&(s.handleZ=!0),n=o.childNodes,u=n.length-1;0<=u&&!d;u--)h=(l=n[u]).getAttribute("data-z-index"),c=!T(h),l!==r&&(t<0&&c&&!a&&!u?(o.insertBefore(r,n[u]),d=!0):(m(h)<=t||c&&(!T(t)||0<=t))&&(o.insertBefore(r,n[u+1]),d=!0));d||(o.insertBefore(r,n[a?3:0]),d=!0)}return d}}return E.symbolCustomAttribs=["anchorX","anchorY","clockwise","end","height","innerR","r","start","width","x","y"],E.prototype.strokeSetter=E.prototype.fillSetter,E.prototype.yGetter=E.prototype.xGetter,E.prototype.matrixSetter=E.prototype.rotationOriginXSetter=E.prototype.rotationOriginYSetter=E.prototype.rotationSetter=E.prototype.scaleXSetter=E.prototype.scaleYSetter=E.prototype.translateXSetter=E.prototype.translateYSetter=E.prototype.verticalAlignSetter=function(t,e){this[e]=t,this.doTransform=!0},E}),e(t,"Core/Renderer/RendererRegistry.js",[t["Core/Globals.js"]],function(o){var t;{var r=t=t||{};r.rendererTypes={};let s;r.getRendererType=function(t=s){return r.rendererTypes[t]||r.rendererTypes[s]},r.registerRendererType=function(t,e,i){r.rendererTypes[t]=e,s&&!i||(s=t,o.Renderer=e)}}return t}),e(t,"Core/Renderer/SVG/SVGLabel.js",[t["Core/Renderer/SVG/SVGElement.js"],t["Core/Utilities.js"]],function(t,e){const{defined:r,extend:a,isNumber:n,merge:s,pick:o,removeEvent:i}=e;class c extends t{constructor(t,e,i,s,o,r,a,n,l,h){super(t,"g"),this.paddingLeftSetter=this.paddingSetter,this.paddingRightSetter=this.paddingSetter,this.textStr=e,this.x=i,this.y=s,this.anchorX=r,this.anchorY=a,this.baseline=l,this.className=h,this.addClass("button"===h?"highcharts-no-tooltip":"highcharts-label"),h&&this.addClass("highcharts-"+h),this.text=t.text(void 0,0,0,n).attr({zIndex:1});let d;"string"==typeof o&&((d=/^url\((.*?)\)$/.test(o))||this.renderer.symbols[o])&&(this.symbolKey=o),this.bBox=c.emptyBBox,this.padding=3,this.baselineOffset=0,this.needsBox=t.styledMode||d,this.deferredAttr={},this.alignFactor=0}alignSetter(t){t={left:0,center:.5,right:1}[t];t!==this.alignFactor&&(this.alignFactor=t,this.bBox)&&n(this.xSetting)&&this.attr({x:this.xSetting})}anchorXSetter(t,e){this.anchorX=t,this.boxAttr(e,Math.round(t)-this.getCrispAdjust()-this.xSetting)}anchorYSetter(t,e){this.anchorY=t,this.boxAttr(e,t-this.ySetting)}boxAttr(t,e){this.box?this.box.attr(t,e):this.deferredAttr[t]=e}css(e){if(e){const i={};e=s(e),c.textProps.forEach(t=>{"undefined"!=typeof e[t]&&(i[t]=e[t],delete e[t])}),this.text.css(i),"fontSize"in i||"fontWeight"in i?this.updateTextPadding():("width"in i||"textOverflow"in i)&&this.updateBoxSize()}return t.prototype.css.call(this,e)}destroy(){i(this.element,"mouseenter"),i(this.element,"mouseleave"),this.text&&this.text.destroy(),this.box&&(this.box=this.box.destroy()),t.prototype.destroy.call(this)}fillSetter(t,e){t&&(this.needsBox=!0),this.fill=t,this.boxAttr(e,t)}getBBox(){this.textStr&&0===this.bBox.width&&0===this.bBox.height&&this.updateBoxSize();var t=this.padding,e=o(this.paddingLeft,t);return{width:this.width||0,height:this.height||0,x:this.bBox.x-e,y:this.bBox.y-t}}getCrispAdjust(){return this.renderer.styledMode&&this.box?this.box.strokeWidth()%2/2:(this["stroke-width"]?parseInt(this["stroke-width"],10):0)%2/2}heightSetter(t){this.heightSetting=t}onAdd(){this.text.add(this),this.attr({text:o(this.textStr,""),x:this.x||0,y:this.y||0}),this.box&&r(this.anchorX)&&this.attr({anchorX:this.anchorX,anchorY:this.anchorY})}paddingSetter(t,e){n(t)?t!==this[e]&&(this[e]=t,this.updateTextPadding()):this[e]=void 0}rSetter(t,e){this.boxAttr(e,t)}strokeSetter(t,e){this.stroke=t,this.boxAttr(e,t)}"stroke-widthSetter"(t,e){t&&(this.needsBox=!0),this["stroke-width"]=t,this.boxAttr(e,t)}"text-alignSetter"(t){this.textAlign=t}textSetter(t){void 0!==t&&this.text.attr({text:t}),this.updateTextPadding()}updateBoxSize(){var t=this.text,e={},i=this.padding,s=this.bBox=n(this.widthSetting)&&n(this.heightSetting)&&!this.textAlign||!r(t.textStr)?c.emptyBBox:t.getBBox(),o=(this.width=this.getPaddedWidth(),this.height=(this.heightSetting||s.height||0)+2*i,this.renderer.fontMetrics(t));this.baselineOffset=i+Math.min((this.text.firstLineMetrics||o).b,s.height||Infinity),this.heightSetting&&(this.baselineOffset+=(this.heightSetting-o.h)/2),this.needsBox&&!t.textPath&&(this.box||((i=this.box=this.symbolKey?this.renderer.symbol(this.symbolKey):this.renderer.rect()).addClass(("button"===this.className?"":"highcharts-label-box")+(this.className?" highcharts-"+this.className+"-box":"")),i.add(this)),s=this.getCrispAdjust(),e.x=s,e.y=(this.baseline?-this.baselineOffset:0)+s,e.width=Math.round(this.width),e.height=Math.round(this.height),this.box.attr(a(e,this.deferredAttr)),this.deferredAttr={})}updateTextPadding(){var e=this.text;if(!e.textPath){this.updateBoxSize();var i=this.baseline?0:this.baselineOffset;let t=o(this.paddingLeft,this.padding);r(this.widthSetting)&&this.bBox&&("center"===this.textAlign||"right"===this.textAlign)&&(t+={center:.5,right:1}[this.textAlign]*(this.widthSetting-this.bBox.width)),t===e.x&&i===e.y||(e.attr("x",t),e.hasBoxWidthChanged&&(this.bBox=e.getBBox(!0)),void 0!==i&&e.attr("y",i)),e.x=t,e.y=i}}widthSetter(t){this.widthSetting=n(t)?t:void 0}getPaddedWidth(){var t=this.padding,e=o(this.paddingLeft,t),t=o(this.paddingRight,t);return(this.widthSetting||this.bBox.width||0)+e+t}xSetter(t){this.x=t,this.alignFactor&&(t-=this.alignFactor*this.getPaddedWidth(),this["forceAnimate:x"]=!0),this.xSetting=Math.round(t),this.attr("translateX",this.xSetting)}ySetter(t){this.ySetting=this.y=Math.round(t),this.attr("translateY",this.ySetting)}}return c.emptyBBox={width:0,height:0,x:0,y:0},c.textProps=["color","direction","fontFamily","fontSize","fontStyle","fontWeight","lineHeight","textAlign","textDecoration","textOutline","textOverflow","whiteSpace","width"],c}),e(t,"Core/Renderer/SVG/Symbols.js",[t["Core/Utilities.js"]],function(t){const{defined:m,isNumber:d,pick:x}=t;function o(e,i,s,o,r){var a=[];if(r){var n=r.start||0,l=x(r.r,s),o=x(r.r,o||s),s=Math.abs((r.end||0)-n-2*Math.PI)<.001,h=(r.end||0)-.001,d=r.innerR,s=x(r.open,s),c=Math.cos(n),p=Math.sin(n),u=Math.cos(h),g=Math.sin(h),f=x(r.longArc,h-n-Math.PI<.001?0:1);let t=["A",l,o,0,f,x(r.clockwise,1),e+l*u,i+o*g];t.params={start:n,end:h,cx:e,cy:i},a.push(["M",e+l*c,i+o*p],t),m(d)&&((t=["A",d,d,0,f,m(r.clockwise)?1-r.clockwise:0,e+d*c,i+d*p]).params={start:h,end:n,cx:e,cy:i},a.push(s?["M",e+d*u,i+d*g]:["L",e+d*u,i+d*g],t)),s||a.push(["Z"])}return a}function e(t,e,i,s,o){return o&&o.r?c(t,e,i,s,o):[["M",t,e],["L",t+i,e],["L",t+i,e+s],["L",t,e+s],["Z"]]}function c(t,e,i,s,o){o=o?.r||0;return[["M",t+o,e],["L",t+i-o,e],["A",o,o,0,0,1,t+i,e+o],["L",t+i,e+s-o],["A",o,o,0,0,1,t+i-o,e+s],["L",t+o,e+s],["A",o,o,0,0,1,t,e+s-o],["L",t,e+o],["A",o,o,0,0,1,t+o,e],["Z"]]}return{arc:o,callout:function(t,e,i,s,o){var r,a=Math.min(o&&o.r||0,i,s),n=a+6,l=o&&o.anchorX,o=o&&o.anchorY||0,h=c(t,e,i,s,{r:a});return!d(l)||l<i&&0<l&&o<s&&0<o||(i-n<t+l?e+n<o&&o<e+s-n?h.splice(3,1,["L",t+i,o-6],["L",t+i+6,o],["L",t+i,o+6],["L",t+i,e+s-a]):l<i?h.splice((r=o<e+n)?2:5,0,["L",l,o],["L",t+i-a,r?e:e+s]):h.splice(3,1,["L",t+i,s/2],["L",l,o],["L",t+i,s/2],["L",t+i,e+s-a]):t+l<n?e+n<o&&o<e+s-n?h.splice(7,1,["L",t,o+6],["L",t-6,o],["L",t,o-6],["L",t,e+a]):0<l?h.splice((r=o<e+n)?1:6,0,["L",l,o],["L",t+a,r?e:e+s]):h.splice(7,1,["L",t,s/2],["L",l,o],["L",t,s/2],["L",t,e+a]):s<o&&l<i-n?h.splice(5,1,["L",l+6,e+s],["L",l,e+s+6],["L",l-6,e+s],["L",t+a,e+s]):o<0&&n<l&&h.splice(1,1,["L",l-6,e],["L",l,e-6],["L",l+6,e],["L",i-a,e])),h},circle:function(t,e,i,s){return o(t+i/2,e+s/2,i/2,s/2,{start:.5*Math.PI,end:2.5*Math.PI,open:!1})},diamond:function(t,e,i,s){return[["M",t+i/2,e],["L",t+i,e+s/2],["L",t+i/2,e+s],["L",t,e+s/2],["Z"]]},rect:e,roundedRect:c,square:e,triangle:function(t,e,i,s){return[["M",t+i/2,e],["L",t+i,e+s],["L",t,e+s],["Z"]]},"triangle-down":function(t,e,i,s){return[["M",t,e],["L",t+i,e],["L",t+i/2,e+s],["Z"]]}}}),e(t,"Core/Renderer/SVG/TextBuilder.js",[t["Core/Renderer/HTML/AST.js"],t["Core/Globals.js"],t["Core/Utilities.js"]],function(n,t,e){const{doc:u,SVG_NS:g,win:o}=t,{attr:f,extend:h,fireEvent:i,isString:l,objectEach:r,pick:d}=e;class s{constructor(t){var e=t.styles;this.renderer=t.renderer,this.svgElement=t,this.width=t.textWidth,this.textLineHeight=e&&e.lineHeight,this.textOutline=e&&e.textOutline,this.ellipsis=Boolean(e&&"ellipsis"===e.textOverflow),this.noWrap=Boolean(e&&"nowrap"===e.whiteSpace)}buildSVG(){var t=this.svgElement,e=t.element,i=t.renderer,s=d(t.textStr,"").toString(),o=-1!==s.indexOf("<"),r=e.childNodes,i=!t.added&&i.box,a=[s,this.ellipsis,this.noWrap,this.textLineHeight,this.textOutline,t.getStyle("font-size"),this.width].join(",");if(a!==t.textCache){t.textCache=a,delete t.actualWidth;for(let t=r.length;t--;)e.removeChild(r[t]);o||this.ellipsis||this.width||t.textPath||-1!==s.indexOf(" ")&&(!this.noWrap||/<br.*?>/g.test(s))?""!==s&&(i&&i.appendChild(e),a=new n(s),this.modifyTree(a.nodes),a.addToDOM(e),this.modifyDOM(),this.ellipsis&&-1!==(e.textContent||"").indexOf("…")&&t.attr("title",this.unescapeEntities(t.textStr||"",["&lt;","&gt;"])),i)&&i.removeChild(e):e.appendChild(u.createTextNode(this.unescapeEntities(s))),l(this.textOutline)&&t.applyTextOutline&&t.applyTextOutline(this.textOutline)}}modifyDOM(){const d=this.svgElement,c=f(d.element,"x");var t;for(d.firstLineMetrics=void 0;(t=d.element.firstChild)&&/^[\s\u200B]*$/.test(t.textContent||" ");)d.element.removeChild(t);[].forEach.call(d.element.querySelectorAll("tspan.highcharts-br"),(t,e)=>{t.nextSibling&&t.previousSibling&&(0===e&&1===t.previousSibling.nodeType&&(d.firstLineMetrics=d.renderer.fontMetrics(t.previousSibling)),f(t,{dy:this.getLineHeight(t.nextSibling),x:c}))});const p=this.width||0;if(p){const i=(e,i)=>{var t=e.textContent||"";const s=t.replace(/([^\^])-/g,"$1- ").split(" ");var o=!this.noWrap&&(1<s.length||1<d.element.childNodes.length);const r=this.getLineHeight(i);let a=0,n=d.actualWidth;if(this.ellipsis)t&&this.truncate(e,t,void 0,0,Math.max(0,p-.8*r),(t,e)=>t.substring(0,e)+"…");else if(o){for(var l=[],h=[];i.firstChild&&i.firstChild!==e;)h.push(i.firstChild),i.removeChild(i.firstChild);for(;s.length;)s.length&&!this.noWrap&&0<a&&(l.push(e.textContent||""),e.textContent=s.join(" ").replace(/- /g,"-")),this.truncate(e,void 0,s,0===a&&n||0,p,(t,e)=>s.slice(0,e).join(" ").replace(/- /g,"-")),n=d.actualWidth,a++;h.forEach(t=>{i.insertBefore(t,e)}),l.forEach(t=>{i.insertBefore(u.createTextNode(t),e);t=u.createElementNS(g,"tspan");t.textContent="​",f(t,{dy:r,x:c}),i.insertBefore(t,e)})}},s=e=>{[].slice.call(e.childNodes).forEach(t=>{t.nodeType===o.Node.TEXT_NODE?i(t,e):(-1!==t.className.baseVal.indexOf("highcharts-br")&&(d.actualWidth=0),s(t))})};s(d.element)}}getLineHeight(t){t=t.nodeType===o.Node.TEXT_NODE?t.parentElement:t;return this.textLineHeight?parseInt(this.textLineHeight.toString(),10):this.renderer.fontMetrics(t||this.svgElement.element).h}modifyTree(n){const l=(t,e)=>{var{attributes:i={},children:s,style:o={},tagName:r}=t,a=this.renderer.styledMode;"b"===r||"strong"===r?a?i["class"]="highcharts-strong":o.fontWeight="bold":"i"!==r&&"em"!==r||(a?i["class"]="highcharts-emphasized":o.fontStyle="italic"),o&&o.color&&(o.fill=o.color),"br"===r?(i["class"]="highcharts-br",t.textContent="​",(a=n[e+1])&&a.textContent&&(a.textContent=a.textContent.replace(/^ +/gm,""))):"a"===r&&s&&s.some(t=>"#text"===t.tagName)&&(t.children=[{children:s,tagName:"tspan"}]),"#text"!==r&&"a"!==r&&(t.tagName="tspan"),h(t,{attributes:i,style:o}),s&&s.filter(t=>"#text"!==t.tagName).forEach(l)};n.forEach(l),i(this.svgElement,"afterModifyTree",{nodes:n})}truncate(s,t,o,r,e,i){var a=this.svgElement,n=a["rotation"];const l=[];let h=o?1:0,d=(t||o||"").length,c=d,p,u;var g=function(t,e){e=e||t,t=s.parentNode;if(t&&"undefined"==typeof l[e]&&t.getSubStringLength)try{l[e]=r+t.getSubStringLength(0,o?e+1:e)}catch(i){}return l[e]};if(a.rotation=0,u=g(s.textContent.length),r+u>e){for(;h<=d;)c=Math.ceil((h+d)/2),o&&(p=i(o,c)),u=g(c,p&&p.length-1),h===d?h=d+1:u>e?d=c-1:h=c;0===d?s.textContent="":t&&d===t.length-1||(s.textContent=p||i(t||o,c))}o&&o.splice(0,c),a.actualWidth=u,a.rotation=n}unescapeEntities(i,s){return r(this.renderer.escapes,function(t,e){s&&-1!==s.indexOf(t)||(i=i.toString().replace(new RegExp(t,"g"),e))}),i}}return s}),e(t,"Core/Renderer/SVG/SVGRenderer.js",[t["Core/Renderer/HTML/AST.js"],t["Core/Color/Color.js"],t["Core/Globals.js"],t["Core/Renderer/RendererRegistry.js"],t["Core/Renderer/SVG/SVGElement.js"],t["Core/Renderer/SVG/SVGLabel.js"],t["Core/Renderer/SVG/Symbols.js"],t["Core/Renderer/SVG/TextBuilder.js"],t["Core/Utilities.js"]],function(y,e,t,i,s,h,o,r,a){const{charts:m,deg2rad:n,doc:x,isFirefox:c,isMS:b,isWebKit:l,noop:d,SVG_NS:p,symbolSizes:v,win:u}=t,{addEvent:M,attr:S,createElement:k,css:C,defined:A,destroyObjectProperties:g,extend:w,isArray:f,isNumber:T,isObject:P,isString:O,merge:L,pick:E,pInt:D,uniqueKey:B}=a;let j;class I{constructor(t,e,i,s,o,r,a){var n=this.createElement("svg").attr({version:"1.1","class":"highcharts-root"}),l=n.element;a||n.css(this.getStyle(s||{})),t.appendChild(l),S(t,"dir","ltr"),-1===t.innerHTML.indexOf("xmlns")&&S(l,"xmlns",this.SVG_NS),this.box=l,this.boxWrapper=n,this.alignedObjects=[],this.url=this.getReferenceURL(),this.createElement("desc").add().element.appendChild(x.createTextNode("Created with Highcharts 11.3.0")),this.defs=this.createElement("defs").add(),this.allowHTML=r,this.forExport=o,this.styledMode=a,this.gradients={},this.cache={},this.cacheKeys=[],this.imgCount=0,this.rootFontSize=n.getStyle("font-size"),this.setSize(e,i,!1);let h,d;c&&t.getBoundingClientRect&&((h=function(){C(t,{left:0,top:0}),d=t.getBoundingClientRect(),C(t,{left:Math.ceil(d.left)-d.left+"px",top:Math.ceil(d.top)-d.top+"px"})})(),this.unSubPixelFix=M(u,"resize",h))}definition(t){return new y([t]).addToDOM(this.defs.element)}getReferenceURL(){var t,e;if((c||l)&&x.getElementsByTagName("base").length&&(A(j)||(t=B(),t=new y([{tagName:"svg",attributes:{width:8,height:8},children:[{tagName:"defs",children:[{tagName:"clipPath",attributes:{id:t},children:[{tagName:"rect",attributes:{width:4,height:4}}]}]},{tagName:"rect",attributes:{id:"hitme",width:8,height:8,"clip-path":`url(#${t})`,fill:"rgba(0,0,0,0.001)"}}]}]).addToDOM(x.body),C(t,{position:"fixed",top:0,left:0,zIndex:9e5}),e=x.elementFromPoint(6,6),j="hitme"===(e&&e.id),x.body.removeChild(t)),j))return u.location.href.split("#")[0].replace(/<[^>]*>/g,"").replace(/([\('\)])/g,"\\$1").replace(/ /g,"%20");return""}getStyle(t){return this.style=w({fontFamily:"Helvetica, Arial, sans-serif",fontSize:"1rem"},t),this.style}setStyle(t){this.boxWrapper.css(this.getStyle(t))}isHidden(){return!this.boxWrapper.getBBox().width}destroy(){var t=this,e=t.defs;return t.box=null,t.boxWrapper=t.boxWrapper.destroy(),g(t.gradients||{}),t.gradients=null,t.defs=e.destroy(),t.unSubPixelFix&&t.unSubPixelFix(),t.alignedObjects=null}createElement(t){return new this.Element(this,t)}getRadialAttr(t,e){return{cx:t[0]-t[2]/2+(e.cx||0)*t[2],cy:t[1]-t[2]/2+(e.cy||0)*t[2],r:(e.r||0)*t[2]}}shadowDefinition(e){var t=["highcharts-drop-shadow-"+this.chartIndex,...Object.keys(e).map(t=>t+"-"+e[t])].join("-").toLowerCase().replace(/[^a-z0-9\-]/g,""),i=L({color:"#000000",offsetX:1,offsetY:1,opacity:.15,width:5},e);return this.defs.element.querySelector("#"+t)||this.definition({tagName:"filter",attributes:{id:t,filterUnits:i.filterUnits},children:[{tagName:"feDropShadow",attributes:{dx:i.offsetX,dy:i.offsetY,"flood-color":i.color,"flood-opacity":Math.min(5*i.opacity,1),stdDeviation:i.width/2}}]}),t}buildText(t){new r(t).buildSVG()}getContrast(t){t=e.parse(t).rgba.map(t=>{t/=255;return t<=.03928?t/12.92:Math.pow((.055+t)/1.055,2.4)}),t=.2126*t[0]+.7152*t[1]+.0722*t[2];return(.05+t)/.05<1.05/(.05+t)?"#FFFFFF":"#000000"}button(t,e,i,s,o={},r,a,n,l,h){const d=this.label(t,e,i,l,void 0,void 0,h,void 0,"button"),c=this.styledMode,p=o.states||{};let u=0;delete(o=L(o)).states;const g=L({color:"#333333",cursor:"pointer",fontSize:"0.8em",fontWeight:"normal"},o.style);delete o.style;let f=y.filterUserAttributes(o);d.attr(L({padding:8,r:2},f));let m,x,v;return c||(f=L({fill:"#f7f7f7",stroke:"#cccccc","stroke-width":1},f),r=L(f,{fill:"#e6e6e6"},y.filterUserAttributes(r||p.hover||{})),m=r.style,delete r.style,a=L(f,{fill:"#e6e9ff",style:{color:"#000000",fontWeight:"bold"}},y.filterUserAttributes(a||p.select||{})),x=a.style,delete a.style,n=L(f,{style:{color:"#cccccc"}},y.filterUserAttributes(n||p.disabled||{})),v=n.style,delete n.style),M(d.element,b?"mouseover":"mouseenter",function(){3!==u&&d.setState(1)}),M(d.element,b?"mouseout":"mouseleave",function(){3!==u&&d.setState(u)}),d.setState=function(t){1!==t&&(d.state=u=t),d.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-"+["normal","hover","pressed","disabled"][t||0]),c||(d.attr([f,r,a,n][t||0]),t=[g,m,x,v][t||0],P(t)&&d.css(t))},c||(d.attr(f).css(w({cursor:"default"},g)),h&&d.text.css({pointerEvents:"none"})),d.on("touchstart",t=>t.stopPropagation()).on("click",function(t){3!==u&&s.call(d,t)})}crispLine(t,e,i="round"){var s=t[0],o=t[1];return A(s[1])&&s[1]===o[1]&&(s[1]=o[1]=Math[i](s[1])-e%2/2),A(s[2])&&s[2]===o[2]&&(s[2]=o[2]=Math[i](s[2])+e%2/2),t}path(t){var e=this.styledMode?{}:{fill:"none"};return f(t)?e.d=t:P(t)&&w(e,t),this.createElement("path").attr(e)}circle(t,e,i){t=P(t)?t:void 0===t?{}:{x:t,y:e,r:i},e=this.createElement("circle");return e.xSetter=e.ySetter=function(t,e,i){i.setAttribute("c"+e,t)},e.attr(t)}arc(t,e,i,s,o,r){let a;P(t)?(e=(a=t).y,i=a.r,s=a.innerR,o=a.start,r=a.end,t=a.x):a={innerR:s,start:o,end:r};s=this.symbol("arc",t,e,i,i,a);return s.r=i,s}rect(t,e,i,s,o,r){const a=P(t)?t:void 0===t?{}:{x:t,y:e,r:o,width:Math.max(i||0,0),height:Math.max(s||0,0)},n=this.createElement("rect");return this.styledMode||(void 0!==r&&(a["stroke-width"]=r,w(a,n.crisp(a))),a.fill="none"),n.rSetter=function(t,e,i){n.r=t,S(i,{rx:t,ry:t})},n.rGetter=function(){return n.r||0},n.attr(a)}roundedRect(t){return this.symbol("roundedRect").attr(t)}setSize(t,e,i){this.width=t,this.height=e,this.boxWrapper.animate({width:t,height:e},{step:function(){this.attr({viewBox:"0 0 "+this.attr("width")+" "+this.attr("height")})},duration:E(i,!0)?void 0:0}),this.alignElements()}g(t){var e=this.createElement("g");return t?e.attr({"class":"highcharts-"+t}):e}image(e,t,i,s,o,r){var a={preserveAspectRatio:"none"};T(t)&&(a.x=t),T(i)&&(a.y=i),T(s)&&(a.width=s),T(o)&&(a.height=o);const n=this.createElement("image").attr(a),l=function(t){n.attr({href:e}),r.call(n,t)};return r?(n.attr({href:"data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="}),t=new u.Image,M(t,"load",l),t.src=e,t.complete&&l({})):n.attr({href:e}),n}symbol(t,e,i,s,o,h){const r=this,a=/^url\((.*?)\)$/,n=a.test(t),l=!n&&(this.symbols[t]?t:"circle"),d=l&&this.symbols[l];let c,p,u,g;if(d)"number"==typeof e&&(p=d.call(this.symbols,Math.round(e||0),Math.round(i||0),s||0,o||0,h)),c=this.path(p),r.styledMode||c.attr("fill","none"),w(c,{symbolName:l||void 0,x:e,y:i,width:s,height:o}),h&&w(c,h);else if(n){u=t.match(a)[1];const f=c=this.image(u);f.imgwidth=E(h&&h.width,v[u]&&v[u].width),f.imgheight=E(h&&h.height,v[u]&&v[u].height),g=t=>t.attr({width:t.width,height:t.height}),["width","height"].forEach(t=>{f[t+"Setter"]=function(t,e){this[e]=t;var{alignByTranslate:t,element:i,width:s,height:o,imgwidth:r,imgheight:a}=this,n="width"===e?r:a;let l=1;h&&"within"===h.backgroundSize&&s&&o&&r&&a?(l=Math.min(s/r,o/a),S(i,{width:Math.round(r*l),height:Math.round(a*l)})):i&&n&&i.setAttribute(e,n),!t&&r&&a&&this.translate(((s||0)-r*l)/2,((o||0)-a*l)/2)}}),A(e)&&f.attr({x:e,y:i}),f.isImg=!0,A(f.imgwidth)&&A(f.imgheight)?g(f):(f.attr({width:0,height:0}),k("img",{onload:function(){var t=m[r.chartIndex];0===this.width&&(C(this,{position:"absolute",top:"-999em"}),x.body.appendChild(this)),v[u]={width:this.width,height:this.height},f.imgwidth=this.width,f.imgheight=this.height,f.element&&g(f),this.parentNode&&this.parentNode.removeChild(this),r.imgCount--,r.imgCount||!t||t.hasLoaded||t.onload()},src:u}),this.imgCount++)}return c}clipRect(t,e,i,s){return this.rect(t,e,i,s,0)}text(t,e,i,s){var o=this,r={};if(s&&(o.allowHTML||!o.forExport))return o.html(t,e,i);r.x=Math.round(e||0),i&&(r.y=Math.round(i)),A(t)&&(r.text=t);e=o.createElement("text").attr(r);return s&&(!o.forExport||o.allowHTML)||(e.xSetter=function(i,s,t){var o=t.getElementsByTagName("tspan"),r=t.getAttribute(s);for(let t=0,e;t<o.length;t++)(e=o[t]).getAttribute(s)===r&&e.setAttribute(s,i);t.setAttribute(s,i)}),e}fontMetrics(t){var t=D(s.prototype.getStyle.call(t,"font-size")||0),e=t<24?t+3:Math.round(1.2*t);return{h:e,b:Math.round(.8*e),f:t}}rotCorr(t,e,i){let s=t;return e&&i&&(s=Math.max(s*Math.cos(e*n),4)),{x:-t/3*Math.sin(e*n),y:s}}pathToSegments(e){var i=[],s=[],o={A:8,C:7,H:2,L:3,M:3,Q:5,S:5,T:3,V:2};for(let t=0;t<e.length;t++)O(s[0])&&T(e[t])&&s.length===o[s[0].toUpperCase()]&&e.splice(t,0,s[0].replace("M","L").replace("m","l")),"string"==typeof e[t]&&(s.length&&i.push(s.slice(0)),s.length=0),s.push(e[t]);return i.push(s.slice(0)),i}label(t,e,i,s,o,r,a,n,l){return new h(this,t,e,i,s,o,r,a,n,l)}alignElements(){this.alignedObjects.forEach(t=>t.align())}}return w(I.prototype,{Element:s,SVG_NS:p,escapes:{"&":"&amp;","<":"&lt;",">":"&gt;","'":"&#39;",'"':"&quot;"},symbols:o,draw:d}),i.registerRendererType("svg",I,!0),I}),e(t,"Core/Renderer/HTML/HTMLElement.js",[t["Core/Globals.js"],t["Core/Renderer/SVG/SVGElement.js"],t["Core/Utilities.js"]],function(t,e,i){const s=t["composed"],{css:f,defined:m,extend:r,pushUnique:o,pInt:a}=i;class n extends e{static compose(t){var e,i;return o(s,this.compose)&&(e=n.prototype,(i=t.prototype).getSpanCorrection=e.getSpanCorrection,i.htmlCss=e.htmlCss,i.htmlGetBBox=e.htmlGetBBox,i.htmlUpdateTransform=e.htmlUpdateTransform,i.setSpanRotation=e.setSpanRotation),t}getSpanCorrection(t,e,i){this.xCorr=-t*i,this.yCorr=-e}htmlCss(t){var e=this["element"],i="SPAN"===e.tagName&&t&&"width"in t,s=i&&t.width;let o;return i&&(delete t.width,this.textWidth=a(s)||void 0,o=!0),"ellipsis"===t?.textOverflow&&(t.whiteSpace="nowrap",t.overflow="hidden"),r(this.styles,t),f(e,t),o&&this.htmlUpdateTransform(),this}htmlGetBBox(){var t=this["element"];return{x:t.offsetLeft,y:t.offsetTop,width:t.offsetWidth,height:t.offsetHeight}}htmlUpdateTransform(){if(!this.added)return void(this.alignOnAdd=!0);const{element:i,renderer:s,rotation:o,styles:t,textAlign:r="left",textWidth:a,translateX:e=0,translateY:n=0,x:l=0,y:h=0}=this,d={left:0,center:.5,right:1}[r],c=t?.whiteSpace;var p=()=>this.textPxLength||(f(i,{width:"",whiteSpace:c||"nowrap"}),i.offsetWidth);if(f(i,{marginLeft:e+"px",marginTop:n+"px"}),"SPAN"===i.tagName){var u,g=[o,r,i.innerHTML,a,this.textAlign].join(",");let t,e=!1;a!==this.oldTextWidth&&(p=p(),(u=a||0)>this.oldTextWidth||u<p)&&(/[ \-]/.test(i.textContent||i.innerText)||"ellipsis"===i.style.textOverflow)&&(f(i,{width:u<p||o?a+"px":"auto",display:"block",whiteSpace:c||"normal"}),this.oldTextWidth=a,e=!0),this.hasBoxWidthChanged=e,g!==this.cTT&&(t=s.fontMetrics(i).b,!m(o)||o===(this.oldRotation||0)&&r===this.oldAlign||this.setSpanRotation(o,d,t),this.getSpanCorrection(!m(o)&&this.textPxLength||i.offsetWidth,t,d)),f(i,{left:l+(this.xCorr||0)+"px",top:h+(this.yCorr||0)+"px"}),this.cTT=g,this.oldRotation=o,this.oldAlign=r}}setSpanRotation(t,e,i){f(this.element,{transform:`rotate(${t}deg)`,transformOrigin:100*e+`% ${i}px`})}}return n}),e(t,"Core/Renderer/HTML/HTMLRenderer.js",[t["Core/Renderer/HTML/AST.js"],t["Core/Globals.js"],t["Core/Renderer/SVG/SVGElement.js"],t["Core/Renderer/SVG/SVGRenderer.js"],t["Core/Utilities.js"]],function(r,t,n,e,i){const s=t["composed"],{attr:p,createElement:u,extend:g,pick:a,pushUnique:o}=i;class l extends e{static compose(t){var e;return o(s,this.compose)&&(e=l.prototype,t.prototype.html=e.html),t}html(t,e,i){const d=this.createElement("span"),s=d.element,o=d.renderer,c=function(r,a){["opacity","visibility"].forEach(function(o){r[o+"Setter"]=function(t,e,i){var s=r.div?r.div.style:a;n.prototype[o+"Setter"].call(this,t,e,i),s&&(s[e]=t)}}),r.addedSetters=!0};return d.textSetter=function(t){t!==this.textStr&&(delete this.bBox,delete this.oldTextWidth,r.setElementHTML(this.element,a(t,"")),this.textStr=t,d.doTransform=!0)},c(d,d.element.style),d.xSetter=d.ySetter=d.alignSetter=d.rotationSetter=function(t,e){"align"===e?d.alignValue=d.textAlign=t:d[e]=t,d.doTransform=!0},d.afterSetters=function(){this.doTransform&&(this.htmlUpdateTransform(),this.doTransform=!1)},d.attr({text:t,x:Math.round(e),y:Math.round(i)}).css({position:"absolute"}),o.styledMode||d.css({fontFamily:this.style.fontFamily,fontSize:this.style.fontSize}),s.style.whiteSpace="nowrap",d.css=d.htmlCss,d.add=function(t){const n=o.box.parentNode,l=[];let h,e;if(this.parentGroup=t){if(!(h=t.div)){for(e=t;e;)l.push(e),e=e.parentGroup;l.reverse().forEach(function(i){const t=p(i.element,"class"),s=i.css;function e(t,e){i[e]=t,"translateX"===e?a.left=t+"px":a.top=t+"px",i.doTransform=!0}var o,r=i.styles||{};const a=(h=i.div=i.div||u("div",t?{className:t}:void 0,{position:"absolute",left:(i.translateX||0)+"px",top:(i.translateY||0)+"px",display:i.display,opacity:i.opacity,visibility:i.visibility},h||n)).style;g(i,{classSetter:(o=h,function(t){this.element.setAttribute("class",t),o.className=t}),css:function(e){return s.call(i,e),["cursor","pointerEvents"].forEach(t=>{e[t]&&(a[t]=e[t])}),i},on:function(){return l[0].div&&d.on.apply({element:l[0].div,onEvents:i.onEvents},arguments),i},translateXSetter:e,translateYSetter:e}),i.addedSetters||c(i),i.css(r)})}}else h=n;return h.appendChild(s),d.added=!0,d.alignOnAdd&&d.htmlUpdateTransform(),d},d}}return l}),e(t,"Core/Axis/AxisDefaults.js",[],function(){var t,e;return(e=t=t||{}).xAxis={alignTicks:!0,allowDecimals:void 0,panningEnabled:!0,zIndex:2,zoomEnabled:!0,dateTimeLabelFormats:{millisecond:{main:"%H:%M:%S.%L",range:!1},second:{main:"%H:%M:%S",range:!1},minute:{main:"%H:%M",range:!1},hour:{main:"%H:%M",range:!1},day:{main:"%e %b"},week:{main:"%e %b"},month:{main:"%b '%y"},year:{main:"%Y"}},endOnTick:!1,gridLineDashStyle:"Solid",gridZIndex:1,labels:{autoRotationLimit:80,distance:15,enabled:!0,indentation:10,overflow:"justify",padding:5,reserveSpace:void 0,rotation:void 0,staggerLines:0,step:0,useHTML:!1,zIndex:7,style:{color:"#333333",cursor:"default",fontSize:"0.8em"}},maxPadding:.01,minorGridLineDashStyle:"Solid",minorTickLength:2,minorTickPosition:"outside",minorTicksPerMajor:5,minPadding:.01,offset:void 0,reversed:void 0,reversedStacks:!1,showEmpty:!0,showFirstLabel:!0,showLastLabel:!0,startOfWeek:1,startOnTick:!1,tickLength:10,tickPixelInterval:100,tickmarkPlacement:"between",tickPosition:"outside",title:{align:"middle",useHTML:!1,x:0,y:0,style:{color:"#666666",fontSize:"0.8em"}},type:"linear",uniqueNames:!0,visible:!0,minorGridLineColor:"#f2f2f2",minorGridLineWidth:1,minorTickColor:"#999999",lineColor:"#333333",lineWidth:1,gridLineColor:"#e6e6e6",gridLineWidth:void 0,tickColor:"#333333"},e.yAxis={reversedStacks:!0,endOnTick:!0,maxPadding:.05,minPadding:.05,tickPixelInterval:72,showLastLabel:!0,labels:{x:void 0},startOnTick:!0,title:{text:"Values"},stackLabels:{animation:{},allowOverlap:!1,enabled:!1,crop:!0,overflow:"justify",formatter:function(){var t=this.axis.chart["numberFormatter"];return t(this.total||0,-1)},style:{color:"#000000",fontSize:"0.7em",fontWeight:"bold",textOutline:"1px contrast"}},gridLineWidth:1,lineWidth:0},t}),e(t,"Core/Foundation.js",[t["Core/Utilities.js"]],function(t){const{addEvent:s,isFunction:o,objectEach:e,removeEvent:r}=t;var i;return(i||(i={})).registerEventOptions=function(i,t){i.eventOptions=i.eventOptions||{},e(t.events,function(t,e){i.eventOptions[e]!==t&&(i.eventOptions[e]&&(r(i,e,i.eventOptions[e]),delete i.eventOptions[e]),o(t))&&(i.eventOptions[e]=t,s(i,e,t,{order:0}))})},i}),e(t,"Core/Axis/Tick.js",[t["Core/Templating.js"],t["Core/Globals.js"],t["Core/Utilities.js"]],function(k,t,e){const v=t["deg2rad"],{clamp:n,correctFloat:C,defined:A,destroyObjectProperties:i,extend:w,fireEvent:T,isNumber:P,merge:r,objectEach:l,pick:O}=e;class s{constructor(t,e,i,s,o){this.isNew=!0,this.isNewLabel=!0,this.axis=t,this.pos=e,this.type=i||"",this.parameters=o||{},this.tickmarkOffset=this.parameters.tickmarkOffset,this.options=this.parameters.options,T(this,"init"),i||s||this.addLabel()}addLabel(){const t=this,e=t.axis,i=e.options,s=e.chart,o=e.categories,r=e.logarithmic,a=e.names,n=t.pos,l=O(t.options&&t.options.labels,i.labels),h=e.tickPositions,d=n===h[0],c=n===h[h.length-1],p=(!l.step||1===l.step)&&1===e.tickInterval,u=h.info;let g=t.label,f,m,x,v=this.parameters.category||(o?O(o[n],a[n],n):n);r&&P(v)&&(v=C(r.lin2log(v))),e.dateTime&&(u?(m=s.time.resolveDTLFormat(i.dateTimeLabelFormats[!i.grid&&u.higherRanks[n]||u.unitName]),f=m.main):P(v)&&(f=e.dateTime.getXDateFormat(v,i.dateTimeLabelFormats||{}))),t.isFirst=d,t.isLast=c;const y={axis:e,chart:s,dateTimeLabelFormat:f,isFirst:d,isLast:c,pos:n,tick:t,tickPositionInfo:u,value:v},b=(T(this,"labelFormat",y),t=>l.formatter?l.formatter.call(t,t):l.format?(t.text=e.defaultLabelFormatter.call(t,t),k.format(l.format,t,s)):e.defaultLabelFormatter.call(t,t));var M=b.call(y,y);const S=m&&m.list;S?t.shortenLabel=function(){for(x=0;x<S.length;x++)if(w(y,{dateTimeLabelFormat:S[x]}),g.attr({text:b.call(y,y)}),g.getBBox().width<e.getSlotWidth(t)-2*l.padding)return;g.attr({text:""})}:t.shortenLabel=void 0,p&&e._addedPlotLB&&t.moveLabel(M,l),A(g)||t.movedLabel?g&&g.textStr!==M&&!p&&(!g.textWidth||l.style.width||g.styles.width||g.css({width:null}),g.attr({text:M}),g.textPxLength=g.getBBox().width):(t.label=g=t.createLabel(M,l),t.rotation=0)}createLabel(t,e,i){var s=this.axis,o=s.chart,t=A(t)&&e.enabled?o.renderer.text(t,i?.x,i?.y,e.useHTML).add(s.labelGroup):void 0;return t&&(o.styledMode||t.css(r(e.style)),t.textPxLength=t.getBBox().width),t}destroy(){i(this,this.axis)}getPosition(t,e,i,s){var o=this.axis,r=o.chart,a=s&&r.oldChartHeight||r.chartHeight,r={x:t?C(o.translate(e+i,void 0,void 0,s)+o.transB):o.left+o.offset+(o.opposite?(s&&r.oldChartWidth||r.chartWidth)-o.right-o.left:0),y:t?a-o.bottom+o.offset-(o.opposite?o.height:0):C(a-o.translate(e+i,void 0,void 0,s)-o.transB)};return r.y=n(r.y,-1e5,1e5),T(this,"afterGetPosition",{pos:r}),r}getLabelPosition(t,e,i,s,o,r,a,n){var l=this.axis,h=l.transA,d=(l.isLinked&&l.linkedParent?l.linkedParent:l).reversed,c=l.staggerLines,p=l.tickRotCorr||{x:0,y:0},u=s||l.reserveSpaceDefault?0:-l.labelOffset*("center"===l.labelAlign?.5:1),g=o.distance,f={};let m,x;return m=0===l.side?i.rotation?-g:-i.getBBox().height:2===l.side?p.y+g:Math.cos(i.rotation*v)*(p.y-i.getBBox(!1,0).height/2),A(o.y)&&(m=0===l.side&&l.horiz?o.y+m:o.y),t=t+O(o.x,[0,1,0,-1][l.side]*g)+u+p.x-(r&&s?r*h*(d?-1:1):0),e=e+m-(r&&!s?r*h*(d?1:-1):0),c&&(x=a/(n||1)%c,e+=(x=l.opposite?c-x-1:x)*(l.labelOffset/c)),f.x=t,f.y=Math.round(e),T(this,"afterGetLabelPosition",{pos:f,tickmarkOffset:r,index:a}),f}getLabelSize(){return this.label?this.label.getBBox()[this.axis.horiz?"height":"width"]:0}getMarkPath(t,e,i,s,o,r){return r.crispLine([["M",t,e],["L",t+(o?0:-i),e+(o?i:0)]],s)}handleOverflow(t){var e=this.axis,i=e.options.labels,s=t.x,o=e.chart.chartWidth,r=e.chart.spacing,a=O(e.labelLeft,Math.min(e.pos,r[3])),r=O(e.labelRight,Math.max(e.isRadial?0:e.pos+e.len,o-r[1])),n=this.label,l=this.rotation,h={left:0,center:.5,right:1}[e.labelAlign||n.attr("align")],d=n.getBBox().width,c=e.getSlotWidth(this),p=h,u={};let g=c,f=1,m;l||"justify"!==i.overflow?l<0&&s-h*d<a?m=Math.round(s/Math.cos(l*v)-a):0<l&&r<s+h*d&&(m=Math.round((o-s)/Math.cos(l*v))):(s-h*d<a?g=t.x+g*(1-h)-a:r<s+(1-h)*d&&(g=r-t.x+g*h,f=-1),(g=Math.min(c,g))<c&&"center"===e.labelAlign&&(t.x+=f*(c-g-p*(c-Math.min(d,g)))),(d>g||e.autoRotation&&(n.styles||{}).width)&&(m=g)),m&&(this.shortenLabel?this.shortenLabel():(u.width=Math.floor(m)+"px",(i.style||{}).textOverflow||(u.textOverflow="ellipsis"),n.css(u)))}moveLabel(e,t){const i=this,s=i.label,o=i.axis;let r=!1,a;s&&s.textStr===e?(i.movedLabel=s,r=!0,delete i.label):l(o.ticks,function(t){r||t.isNew||t===i||!t.label||t.label.textStr!==e||(i.movedLabel=t.label,r=!0,t.labelPos=i.movedLabel.xy,delete t.label)}),r||!i.labelPos&&!s||(a=i.labelPos||s.xy,i.movedLabel=i.createLabel(e,t,a),i.movedLabel&&i.movedLabel.attr({opacity:0}))}render(t,e,i){var s=this,o=s.axis,r=o.horiz,a=s.pos,n=O(s.tickmarkOffset,o.tickmarkOffset),a=s.getPosition(r,a,n,e),n=a.x,l=a.y,n=r&&n===o.pos+o.len||!r&&l===o.pos?-1:1,r=O(i,s.label&&s.label.newOpacity,1);i=O(i,1),this.isActive=!0,this.renderGridLine(e,i,n),this.renderMark(a,i,n),this.renderLabel(a,e,r,t),s.isNew=!1,T(this,"afterRender")}renderGridLine(t,e,i){var s=this,o=s.axis,r=o.options,a={},n=s.pos,l=s.type,h=O(s.tickmarkOffset,o.tickmarkOffset),d=o.chart.renderer;let c=s.gridLine,p,u=r.gridLineWidth,g=r.gridLineColor,f=r.gridLineDashStyle;"minor"===s.type&&(u=r.minorGridLineWidth,g=r.minorGridLineColor,f=r.minorGridLineDashStyle),c||(o.chart.styledMode||(a.stroke=g,a["stroke-width"]=u||0,a.dashstyle=f),l||(a.zIndex=1),t&&(e=0),s.gridLine=c=d.path().attr(a).addClass("highcharts-"+(l?l+"-":"")+"grid-line").add(o.gridGroup)),c&&(p=o.getPlotLinePath({value:n+h,lineWidth:c.strokeWidth()*i,force:"pass",old:t,acrossPanes:!1}))&&c[t||s.isNew?"attr":"animate"]({d:p,opacity:e})}renderMark(t,e,i){var s=this,o=s.axis,r=o.options,a=o.chart.renderer,n=s.type,l=o.tickSize(n?n+"Tick":"tick"),h=t.x,t=t.y,d=O(r["minor"!==n?"tickWidth":"minorTickWidth"],!n&&o.isXAxis?1:0),r=r["minor"!==n?"tickColor":"minorTickColor"];let c=s.mark;var p=!c;l&&(o.opposite&&(l[0]=-l[0]),c||(s.mark=c=a.path().addClass("highcharts-"+(n?n+"-":"")+"tick").add(o.axisGroup),o.chart.styledMode)||c.attr({stroke:r,"stroke-width":d}),c[p?"attr":"animate"]({d:s.getMarkPath(h,t,l[0],c.strokeWidth()*i,o.horiz,a),opacity:e}))}renderLabel(t,e,i,s){var o=this,r=o.axis,a=r.horiz,n=r.options,l=o.label,h=n.labels,d=h.step,r=O(o.tickmarkOffset,r.tickmarkOffset),c=t.x,p=t.y;let u=!0;l&&P(c)&&(l.xy=t=o.getLabelPosition(c,p,l,a,h,r,s,d),o.isFirst&&!o.isLast&&!n.showFirstLabel||o.isLast&&!o.isFirst&&!n.showLastLabel?u=!1:!a||h.step||h.rotation||e||0===i||o.handleOverflow(t),(u=d&&s%d?!1:u)&&P(t.y)?(t.opacity=i,l[o.isNewLabel?"attr":"animate"](t).show(!0),o.isNewLabel=!1):(l.hide(),o.isNewLabel=!0))}replaceMovedLabel(){var t=this,e=t.label,i=t.axis;e&&!t.isNew&&(e.animate({opacity:0},void 0,e.destroy),delete t.label),i.isDirty=!0,t.label=t.movedLabel,delete t.movedLabel}}return s}),e(t,"Core/Axis/Axis.js",[t["Core/Animation/AnimationUtilities.js"],t["Core/Axis/AxisDefaults.js"],t["Core/Color/Color.js"],t["Core/Defaults.js"],t["Core/Foundation.js"],t["Core/Globals.js"],t["Core/Axis/Tick.js"],t["Core/Utilities.js"]],function(t,e,d,i,s,k,C,o){const A=t["animObject"];var{xAxis:t,yAxis:e}=e;const g=i["defaultOptions"],n=s["registerEventOptions"],f=k["deg2rad"],{arrayMax:c,arrayMin:p,clamp:y,correctFloat:O,defined:L,destroyObjectProperties:r,erase:a,error:E,extend:u,fireEvent:D,getClosestDistance:m,insertItem:l,isArray:h,isNumber:B,isString:v,merge:x,normalizeTickInterval:b,objectEach:w,pick:j,relativeLength:M,removeEvent:S,splat:T,syncTimeout:R}=o,I=(t,e)=>b(e,void 0,void 0,j(t.options.allowDecimals,e<.5||void 0!==t.tickAmount),!!t.tickAmount);u(g,{xAxis:t,yAxis:x(t,e)});class P{constructor(t,e,i){this.init(t,e,i)}init(t,e,i=this.coll){var s="xAxis"===i,o=this,r=o.isZAxis||(t.inverted?!s:s),i=(o.chart=t,o.horiz=r,o.isXAxis=s,o.coll=i,D(this,"init",{userOptions:e}),o.opposite=j(e.opposite,o.opposite),o.side=j(e.side,o.side,r?o.opposite?0:2:o.opposite?1:3),o.setOptions(e),this.options),r=i.labels,a=i.type,e=(o.userOptions=e,o.minPixelPadding=0,o.reversed=j(i.reversed,o.reversed),o.visible=i.visible,o.zoomEnabled=i.zoomEnabled,o.hasNames="category"===a||!0===i.categories,o.categories=h(i.categories)&&i.categories||(o.hasNames?[]:void 0),o.names||(o.names=[],o.names.keys={}),o.plotLinesAndBandsGroups={},o.positiveValuesOnly=!!o.logarithmic,o.isLinked=L(i.linkedTo),o.ticks={},o.labelEdge=[],o.minorTicks={},o.plotLinesAndBands=[],o.alternateBands={},o.len=0,o.minRange=o.userMinRange=i.minRange||i.maxZoom,o.range=i.range,o.offset=i.offset||0,o.max=void 0,o.min=void 0,j(i.crosshair,T(t.options.tooltip.crosshairs)[s?0:1]));o.crosshair=!0===e?{}:e,-1===t.axes.indexOf(o)&&(s?t.axes.splice(t.xAxis.length,0,o):t.axes.push(o),l(this,t[this.coll])),t.orderItems(o.coll),o.series=o.series||[],t.inverted&&!o.isZAxis&&s&&!L(o.reversed)&&(o.reversed=!0),o.labelRotation=B(r.rotation)?r.rotation:void 0,n(o,i),D(this,"afterInit")}setOptions(t){var e=this.horiz?{labels:{autoRotation:[-45]},margin:15}:{title:{rotation:90*this.side}};this.options=x(e,g[this.coll],t),D(this,"afterSetOptions",{userOptions:t})}defaultLabelFormatter(t){var e=this.axis,i=this.chart["numberFormatter"],s=B(this.value)?this.value:NaN,o=e.chart.time,r=e.categories,a=this.dateTimeLabelFormat,n=g.lang,l=n.numericSymbols,h=n.numericSymbolMagnitude||1e3,d=e.logarithmic?Math.abs(s):e.tickInterval;let c=l&&l.length,p,u;if(r)u=""+this.value;else if(a)u=o.dateFormat(a,s);else if(c&&l&&1e3<=d)for(;c--&&void 0===u;)(p=Math.pow(h,c+1))<=d&&10*s%p==0&&null!==l[c]&&0!==s&&(u=i(s/p,-1)+l[c]);return u=void 0===u?1e4<=Math.abs(s)?i(s,-1):i(s,-1,void 0,""):u}getSeriesExtremes(){const a=this;let n;D(this,"getSeriesExtremes",null,function(){a.hasVisibleSeries=!1,a.dataMin=a.dataMax=a.threshold=void 0,a.softThreshold=!a.isXAxis,a.series.forEach(o=>{if(o.reserveSpace()){var r=o.options;let t,e=r.threshold,i,s;a.hasVisibleSeries=!0,a.positiveValuesOnly&&(e||0)<=0&&(e=void 0),a.isXAxis?(t=o.xData)&&t.length&&(t=a.logarithmic?t.filter(t=>0<t):t,n=o.getXExtremes(t),i=n.min,s=n.max,B(i)||i instanceof Date||(t=t.filter(B),n=o.getXExtremes(t),i=n.min,s=n.max),t.length)&&(a.dataMin=Math.min(j(a.dataMin,i),i),a.dataMax=Math.max(j(a.dataMax,s),s)):(o=o.applyExtremes(),B(o.dataMin)&&(i=o.dataMin,a.dataMin=Math.min(j(a.dataMin,i),i)),B(o.dataMax)&&(s=o.dataMax,a.dataMax=Math.max(j(a.dataMax,s),s)),L(e)&&(a.threshold=e),r.softThreshold&&!a.positiveValuesOnly||(a.softThreshold=!1))}})}),D(this,"afterGetSeriesExtremes")}translate(t,e,i,s,o,r){var a=this.linkedParent||this,n=(s&&a.old?a.old:a).min;if(!B(n))return NaN;var l=a.minPixelPadding,o=(a.isOrdinal||a.brokenAxis?.hasBreaks||a.logarithmic&&o)&&a.lin2val;let h=1,d=0,c=(s&&a.old?a.old:a).transA,p=0;return c=c||a.transA,i&&(h*=-1,d=a.len),a.reversed&&(h*=-1,d-=h*(a.sector||a.len)),e?(t=t*h+d,t-=l,p=t/c+n,o&&(p=a.lin2val(p))):(o&&(t=a.val2lin(t)),s=h*(t-n)*c,p=(a.isRadial?s:O(s))+d+h*l+(B(r)?c*r:0)),p}toPixels(t,e){return this.translate(t,!1,!this.horiz,void 0,!0)+(e?0:this.pos)}toValue(t,e){return this.translate(t-(e?0:this.pos),!0,!this.horiz,void 0,!0)}getPlotLinePath(t){const e=this,i=e.chart,s=e.left,o=e.top,r=t.old,a=t.value,n=t.lineWidth,l=r&&i.oldChartHeight||i.chartHeight,h=r&&i.oldChartWidth||i.chartWidth,d=e.transB;let c=t.translatedValue,p=t.force,u,g,f,m,x;function v(t,e,i){return"pass"!==p&&(t<e||i<t)&&(p?t=y(t,e,i):x=!0),t}t={value:a,lineWidth:n,old:r,force:p,acrossPanes:t.acrossPanes,translatedValue:c};return D(this,"getPlotLinePath",t,function(t){c=j(c,e.translate(a,void 0,void 0,r)),c=y(c,-1e5,1e5),u=f=Math.round(c+d),g=m=Math.round(l-c-d),B(c)?e.horiz?(g=o,m=l-e.bottom,u=f=v(u,s,s+e.width)):(u=s,f=h-e.right,g=m=v(g,o,o+e.height)):(x=!0,p=!1),t.path=x&&!p?void 0:i.renderer.crispLine([["M",u,g],["L",f,m]],n||1)}),t.path}getLinearTickPositions(t,e,i){var s=O(Math.floor(e/t)*t),o=O(Math.ceil(i/t)*t),r=[];let a,n,l;if(O(s+t)===s&&(l=20),this.single)return[e];for(a=s;a<=o&&(r.push(a),(a=O(a+t,l))!==n);)n=a;return r}getMinorTickInterval(){var{minorTicks:t,minorTickInterval:e}=this.options;return!0===t?j(e,"auto"):!1!==t?e:void 0}getMinorTickPositions(){const t=this,e=t.options,i=t.tickPositions,s=t.minorTickInterval,o=t.pointRangePadding||0,r=(t.min||0)-o,a=(t.max||0)+o,n=a-r;let l=[],h;if(n&&n/s<t.len/3){const d=t.logarithmic;if(d)this.paddedTicks.forEach(function(t,e,i){e&&l.push.apply(l,d.getLogTickPositions(s,i[e-1],i[e],!0))});else if(t.dateTime&&"auto"===this.getMinorTickInterval())l=l.concat(t.getTimeTicks(t.dateTime.normalizeTimeTickInterval(s),r,a,e.startOfWeek));else for(h=r+(i[0]-r)%s;h<=a&&h!==l[0];h+=s)l.push(h)}return 0!==l.length&&t.trimTicks(l),l}adjustForMinRange(){var t=this,e=t.options,i=t.logarithmic;let{max:s,min:o,minRange:r}=t,a,n,l,h,d;t.isXAxis&&void 0===r&&!i&&(r=L(e.min)||L(e.max)||L(e.floor)||L(e.ceiling)?null:(l=m(t.series.map(t=>(t.xIncrement?t.xData?.slice(0,2):t.xData)||[]))||0,Math.min(5*l,t.dataMax-t.dataMin))),B(s)&&B(o)&&B(r)&&s-o<r&&(n=t.dataMax-t.dataMin>=r,a=(r-s+o)/2,h=[o-a,j(e.min,o-a)],n&&(h[2]=i?i.log2lin(t.dataMin):t.dataMin),o=c(h),d=[o+r,j(e.max,o+r)],n&&(d[2]=i?i.log2lin(t.dataMax):t.dataMax),(s=p(d))-o<r)&&(h[0]=s-r,h[1]=j(e.min,s-r),o=c(h)),t.minRange=r,t.min=o,t.max=s}getClosest(){let t,i;if(this.categories)i=1;else{const s=[];this.series.forEach(function(t){var e=t.closestPointRange;1===t.xData?.length?s.push(t.xData[0]):!t.noSharedTooltip&&L(e)&&t.reserveSpace()&&(i=L(i)?Math.min(i,e):e)}),s.length&&(s.sort((t,e)=>t-e),t=m([s]))}return t&&i?Math.min(t,i):t||i}nameToX(t){var e=h(this.options.categories),i=e?this.categories:this.names;let s=t.options.x,o;return t.series.requireSorting=!1,-1===(s=L(s)?s:this.options.uniqueNames&&i?e?i.indexOf(t.name):j(i.keys[t.name],-1):t.series.autoIncrement())?!e&&i&&(o=i.length):o=s,void 0!==o?(this.names[o]=t.name,this.names.keys[t.name]=o):t.x&&(o=t.x),o}updateNames(){const o=this,e=this.names,t=e.length;0<t&&(Object.keys(e.keys).forEach(function(t){delete e.keys[t]}),e.length=0,this.minRange=this.userMinRange,(this.series||[]).forEach(s=>{s.xIncrement=null,s.points&&!s.isDirtyData||(o.max=Math.max(o.max,s.xData.length-1),s.processData(),s.generatePoints()),s.data.forEach(function(t,e){var i;t?.options&&"undefined"!=typeof t.name&&void 0!==(i=o.nameToX(t))&&i!==t.x&&(t.x=i,s.xData[e]=i)})}))}setAxisTranslation(){const s=this,t=s.max-s.min,e=s.linkedParent,o=!!s.categories,r=s.isXAxis;let a=s.axisPointRange||0,n,l=0,h=0,i,d=void s.transA;(r||o||a)&&(n=s.getClosest(),e?(l=e.minPointOffset,h=e.pointRangePadding):s.series.forEach(function(t){var e=o?1:r?j(t.options.pointRange,n,0):s.axisPointRange||0,i=t.options.pointPlacement;a=Math.max(a,e),s.single&&!o||(t=t.is("xrange")?!r:r,l=Math.max(l,t&&v(i)?0:e/2),h=Math.max(h,t&&"on"===i?0:e))}),i=s.ordinal&&s.ordinal.slope&&n?s.ordinal.slope/n:1,s.minPointOffset=l*=i,s.pointRangePadding=h*=i,s.pointRange=Math.min(a,s.single&&o?1:t),r)&&n&&(s.closestPointRange=n),s.translationSlope=s.transA=d=s.staticScale||s.len/(t+h||1),s.transB=s.horiz?s.left:s.bottom,s.minPixelPadding=d*l,D(this,"afterSetAxisTranslation")}minFromRange(){var{max:t,min:e}=this;return B(t)&&B(e)&&t-e||void 0}setTickInterval(t){var e=this,{categories:i,chart:s,dataMax:o,dataMin:r,dateTime:a,isXAxis:n,logarithmic:l,options:h,softThreshold:d}=e,c=B(e.threshold)?e.threshold:void 0,p=e.minRange||0,{ceiling:u,floor:g,linkedTo:f,softMax:m,softMin:x}=h,f=B(f)&&s[e.coll]?.[f],v=h.tickPixelInterval;let y=h.maxPadding,b=h.minPadding,M=0,S,k=B(h.tickInterval)&&0<=h.tickInterval?h.tickInterval:void 0,C,A,w,T;if(a||i||f||this.getTickAmount(),w=j(e.userMin,h.min),T=j(e.userMax,h.max),f?(S=(e.linkedParent=f).getExtremes(),e.min=j(S.min,S.dataMin),e.max=j(S.max,S.dataMax),h.type!==f.options.type&&E(11,!0,s)):(d&&L(c)&&B(o)&&B(r)&&(c<=r?(C=c,b=0):o<=c&&(A=c,y=0)),e.min=j(w,C,r),e.max=j(T,A,o)),B(e.max)&&B(e.min)&&(l&&(e.positiveValuesOnly&&!t&&Math.min(e.min,j(r,e.min))<=0&&E(10,!0,s),e.min=O(l.log2lin(e.min),16),e.max=O(l.log2lin(e.max),16)),e.range)&&B(r)&&(e.userMin=e.min=w=Math.max(r,e.minFromRange()||0),e.userMax=T=e.max,e.range=void 0),D(e,"foundExtremes"),e.adjustForMinRange(),B(e.min)&&B(e.max)&&(!B(e.userMin)&&B(x)&&x<e.min&&(e.min=w=x),!B(e.userMax)&&B(m)&&m>e.max&&(e.max=T=m),i||e.axisPointRange||e.stacking?.usePercentage||f||(M=e.max-e.min)&&(!L(w)&&b&&(e.min-=M*b),!L(T))&&y&&(e.max+=M*y),!B(e.userMin)&&B(g)&&(e.min=Math.max(e.min,g)),!B(e.userMax)&&B(u)&&(e.max=Math.min(e.max,u)),d&&B(r)&&B(o)&&(x=c||0,!L(w)&&e.min<x&&x<=r?e.min=h.minRange?Math.min(x,e.max-p):x:!L(T)&&e.max>x&&o<=x&&(e.max=h.minRange?Math.max(x,e.min+p):x)),!s.polar&&e.min>e.max&&(L(h.min)?e.max=e.min:L(h.max)&&(e.min=e.max)),M=e.max-e.min),e.min!==e.max&&B(e.min)&&B(e.max)?f&&!k&&v===f.options.tickPixelInterval?e.tickInterval=k=f.tickInterval:e.tickInterval=j(k,this.tickAmount?M/Math.max(this.tickAmount-1,1):void 0,i?1:M*v/Math.max(e.len,v)):e.tickInterval=1,n&&!t){const P=e.min!==e.old?.min||e.max!==e.old?.max;e.series.forEach(function(t){t.forceCrop=t.forceCropping?.(),t.processData(P)}),D(this,"postProcessData",{hasExtremesChanged:P})}e.setAxisTranslation(),D(this,"initialAxisTranslation"),e.pointRange&&!k&&(e.tickInterval=Math.max(e.pointRange,e.tickInterval));m=j(h.minTickInterval,a&&!e.series.some(t=>t.noSharedTooltip)?e.closestPointRange:0);!k&&e.tickInterval<m&&(e.tickInterval=m),a||l||k||(e.tickInterval=I(e,e.tickInterval)),this.tickAmount||(e.tickInterval=e.unsquish()),this.setTickPositions()}setTickPositions(){var t=this,e=this.options,i=e.tickPositions,s=e.tickPositioner,o=this.getMinorTickInterval(),r=this.hasVerticalPanning(),a="colorAxis"===this.coll,n=(a||!r)&&e.startOnTick,a=(a||!r)&&e.endOnTick;let l=[],h;if(this.tickmarkOffset=this.categories&&"between"===e.tickmarkPlacement&&1===this.tickInterval?.5:0,this.minorTickInterval="auto"===o&&this.tickInterval?this.tickInterval/e.minorTicksPerMajor:o,this.single=this.min===this.max&&L(this.min)&&!this.tickAmount&&(this.min%1==0||!1!==e.allowDecimals),i)l=i.slice();else if(B(this.min)&&B(this.max)){if(!t.ordinal?.positions&&(this.max-this.min)/this.tickInterval>Math.max(2*this.len,200))l=[this.min,this.max],E(19,!1,this.chart);else if(t.dateTime)l=t.getTimeTicks(t.dateTime.normalizeTimeTickInterval(this.tickInterval,e.units),this.min,this.max,e.startOfWeek,t.ordinal?.positions,this.closestPointRange,!0);else if(t.logarithmic)l=t.logarithmic.getLogTickPositions(this.tickInterval,this.min,this.max);else{var d=this.tickInterval;let t=d;for(;t<=2*d&&(l=this.getLinearTickPositions(this.tickInterval,this.min,this.max),this.tickAmount)&&l.length>this.tickAmount;)this.tickInterval=I(this,t*=1.1)}l.length>this.len&&(l=[l[0],l[l.length-1]])[0]===l[1]&&(l.length=1),s&&(this.tickPositions=l,h=s.apply(t,[this.min,this.max]))&&(l=h)}this.tickPositions=l,this.paddedTicks=l.slice(0),this.trimTicks(l,n,a),!this.isLinked&&B(this.min)&&B(this.max)&&(this.single&&l.length<2&&!this.categories&&!this.series.some(t=>t.is("heatmap")&&"between"===t.options.pointPlacement)&&(this.min-=.5,this.max+=.5),i||h||this.adjustTickAmount()),D(this,"afterSetTickPositions")}trimTicks(t,e,i){var s=t[0],o=t[t.length-1],r=!this.isOrdinal&&this.minPointOffset||0;if(D(this,"trimTicks"),!this.isLinked){if(e&&s!==-Infinity)this.min=s;else for(;this.min-r>t[0];)t.shift();if(i)this.max=o;else for(;this.max+r<t[t.length-1];)t.pop();0===t.length&&L(s)&&!this.options.tickPositions&&t.push((o+s)/2)}}alignToOthers(){const i=this,s=[this],t=i.options,e=this.chart.options.chart,o="yAxis"===this.coll&&e.alignThresholds,r=[];let a;if(i.thresholdAlignment=void 0,(!1!==e.alignTicks&&t.alignTicks||o)&&!1!==t.startOnTick&&!1!==t.endOnTick&&!i.logarithmic){const n=t=>{var{horiz:t,options:e}=t;return[t?e.left:e.top,e.width,e.height,e.pane].join(",")},l=n(this);this.chart[this.coll].forEach(function(t){var e=t["series"];e.length&&e.some(t=>t.visible)&&t!==i&&n(t)===l&&(a=!0,s.push(t))})}if(a&&o){s.forEach(t=>{t=t.getThresholdAlignment(i);B(t)&&r.push(t)});const h=1<r.length?r.reduce((t,e)=>t+e,0)/r.length:void 0;s.forEach(t=>{t.thresholdAlignment=h})}return a}getThresholdAlignment(t){if((!B(this.dataMin)||this!==t&&this.series.some(t=>t.isDirty||t.isDirtyData))&&this.getSeriesExtremes(),B(this.threshold)){let t=y((this.threshold-(this.dataMin||0))/((this.dataMax||0)-(this.dataMin||0)),0,1);return t=this.options.reversed?1-t:t}}getTickAmount(){var t=this.options,e=t.tickPixelInterval;let i=t.tickAmount;(i=!(i=!L(t.tickInterval)&&!i&&this.len<e&&!this.isRadial&&!this.logarithmic&&t.startOnTick&&t.endOnTick?2:i)&&this.alignToOthers()?Math.ceil(this.len/e)+1:i)<4&&(this.finalTickAmt=i,i=5),this.tickAmount=i}adjustTickAmount(){const t=this,{finalTickAmt:e,max:i,min:s,options:o,tickPositions:r,tickAmount:a,thresholdAlignment:n}=t,l=r?.length,h=j(t.threshold,t.softThreshold?0:null);let d,c,p=t.tickInterval,u;var g=()=>r.push(O(r[r.length-1]+p)),f=()=>r.unshift(O(r[0]-p));if(B(n)&&(u=n<.5?Math.ceil(n*(a-1)):Math.floor(n*(a-1)),o.reversed)&&(u=a-1-u),t.hasData()&&B(s)&&B(i)){var m=()=>{t.transA*=(l-1)/(a-1),t.min=o.startOnTick?r[0]:Math.min(s,r[0]),t.max=o.endOnTick?r[r.length-1]:Math.max(i,r[r.length-1])};if(B(u)&&B(t.threshold)){for(;r[u]!==h||r.length!==a||r[0]>s||r[r.length-1]<i;){for(r.length=0,r.push(t.threshold);r.length<a;)(void 0===r[u]||r[u]>t.threshold?f:g)();if(p>8*t.tickInterval)break;p*=2}m()}else if(l<a){for(;r.length<a;)(r.length%2||s===h?g:f)();m()}if(L(e)){for(c=d=r.length;c--;)(3===e&&c%2==1||e<=2&&0<c&&c<d-1)&&r.splice(c,1);t.finalTickAmt=void 0}}}setScale(){var t=this,{coll:e,stacking:i}=t;let s=!1,o=!1;t.series.forEach(t=>{s=s||t.isDirtyData||t.isDirty,o=o||t.xAxis&&t.xAxis.isDirty||!1}),t.setAxisSize();var r=t.len!==(t.old&&t.old.len);r||s||o||t.isLinked||t.forceRedraw||t.userMin!==(t.old&&t.old.userMin)||t.userMax!==(t.old&&t.old.userMax)||t.alignToOthers()?(i&&"yAxis"===e&&i.buildStacks(),t.forceRedraw=!1,t.userMinRange||(t.minRange=void 0),t.getSeriesExtremes(),t.setTickInterval(),i&&"xAxis"===e&&i.buildStacks(),t.isDirty||(t.isDirty=r||t.min!==t.old?.min||t.max!==t.old?.max)):i&&i.cleanStacks(),s&&t.panningState&&(t.panningState.isDirty=!0),D(this,"afterSetScale")}setExtremes(t,e,i=!0,s,o){const r=this,a=r.chart;r.series.forEach(t=>{delete t.kdTree}),o=u(o,{min:t,max:e}),D(r,"setExtremes",o,()=>{r.userMin=t,r.userMax=e,r.eventArgs=o,i&&a.redraw(s)})}zoom(t,e){const s=this,o=this.dataMin,r=this.dataMax,i=this.options,a=Math.min(o,j(i.min,o)),n=Math.max(r,j(i.max,r)),l={newMin:t,newMax:e};return D(this,"zoom",l,function(t){let e=t.newMin,i=t.newMax;e===s.min&&i===s.max||(s.allowZoomOutside||(L(o)&&(e=e<a?a:e)>n&&(e=n),L(r)&&(i=i<a?a:i)>n&&(i=n)),s.displayBtn=void 0!==e||void 0!==i,s.setExtremes(e,i,!1,void 0,{trigger:"zoom"})),t.zoomed=!0}),l.zoomed}setAxisSize(){var t=this.chart,e=this.options,i=e.offsets||[0,0,0,0],s=this.horiz,o=this.width=Math.round(M(j(e.width,t.plotWidth-i[3]+i[1]),t.plotWidth)),r=this.height=Math.round(M(j(e.height,t.plotHeight-i[0]+i[2]),t.plotHeight)),a=this.top=Math.round(M(j(e.top,t.plotTop+i[0]),t.plotHeight,t.plotTop)),e=this.left=Math.round(M(j(e.left,t.plotLeft+i[3]),t.plotWidth,t.plotLeft));this.bottom=t.chartHeight-r-a,this.right=t.chartWidth-o-e,this.len=Math.max(s?o:r,0),this.pos=s?e:a}getExtremes(){var t=this,e=t.logarithmic;return{min:e?O(e.lin2log(t.min)):t.min,max:e?O(e.lin2log(t.max)):t.max,dataMin:t.dataMin,dataMax:t.dataMax,userMin:t.userMin,userMax:t.userMax}}getThreshold(t){var e=this,i=e.logarithmic,s=i?i.lin2log(e.min):e.min,i=i?i.lin2log(e.max):e.max;return null===t||t===-Infinity?t=s:t===Infinity?t=i:t<s?t=s:i<t&&(t=i),e.translate(t,0,1,0,1)}autoLabelAlign(t){const e=(j(t,0)-90*this.side+720)%360,i={align:"center"};return D(this,"autoLabelAlign",i,function(t){15<e&&e<165?t.align="right":195<e&&e<345&&(t.align="left")}),i.align}tickSize(t){var e=this.options,i=j(e["tick"===t?"tickWidth":"minorTickWidth"],"tick"===t&&this.isXAxis&&!this.categories?1:0);let s=e["tick"===t?"tickLength":"minorTickLength"],o;i&&s&&("inside"===e[t+"Position"]&&(s=-s),o=[s,i]);t={tickSize:o};return D(this,"afterTickSize",t),t.tickSize}labelMetrics(){var t=this.chart.renderer,e=this.ticks,e=e[Object.keys(e)[0]]||{};return this.chart.renderer.fontMetrics(e.label||e.movedLabel||t.box)}unsquish(){const t=this.options.labels,e=this.horiz,i=this.tickInterval,s=this.len/(((this.categories?1:0)+this.max-this.min)/i),o=t.rotation,r=this.labelMetrics().h,a=Math.max(this.max-this.min,0),n=function(t){let e=t/(s||1);return(e=1<e?Math.ceil(e):1)*i>a&&t!==Infinity&&s!==Infinity&&a&&(e=Math.ceil(a/i)),O(e*i)};let l=i,h,d=Number.MAX_VALUE,c;var p,u;if(e){if(t.staggerLines||(B(o)?c=[o]:s<t.autoRotationLimit&&(c=t.autoRotation)),c)for(const g of c)(g===o||g&&-90<=g&&g<=90)&&(u=(p=n(Math.abs(r/Math.sin(f*g))))+Math.abs(g/360))<d&&(d=u,h=g,l=p)}else l=n(.75*r);return this.autoRotation=c,this.labelRotation=j(h,B(o)?o:0),t.step?i:l}getSlotWidth(t){var e=this.chart,i=this.horiz,s=this.options.labels,o=Math.max(this.tickPositions.length-(this.categories?0:1),1),r=e.margin[3];if(t&&B(t.slotWidth))return t.slotWidth;if(i&&s.step<2)return s.rotation?0:(this.staggerLines||1)*this.len/o;if(!i){t=s.style.width;if(void 0!==t)return parseInt(String(t),10);if(r)return r-e.spacing[3]}return.33*e.chartWidth}renderUnsquish(){const t=this.chart,e=t.renderer,i=this.tickPositions,o=this.ticks,s=this.options.labels,r=s.style,a=this.horiz,n=this.getSlotWidth(),l=Math.max(1,Math.round(n-2*s.padding)),h={},d=this.labelMetrics(),c=r.textOverflow;let p,u,g=0,f,m,x;if(v(s.rotation)||(h.rotation=s.rotation||0),i.forEach(function(t){t=o[t];t.movedLabel&&t.replaceMovedLabel(),t&&t.label&&t.label.textPxLength>g&&(g=t.label.textPxLength)}),this.maxLabelLength=g,this.autoRotation)g>l&&g>d.h?h.rotation=this.labelRotation:this.labelRotation=0;else if(n&&(p=l,!c))for(u="clip",m=i.length;!a&&m--;)x=i[m],(f=o[x].label)&&(f.styles&&"ellipsis"===f.styles.textOverflow?f.css({textOverflow:"clip"}):f.textPxLength>n&&f.css({width:n+"px"}),f.getBBox().height>this.len/i.length-(d.h-d.f))&&(f.specificTextOverflow="ellipsis");h.rotation&&(p=g>.5*t.chartHeight?.33*t.chartHeight:g,c||(u="ellipsis")),this.labelAlign=s.align||this.autoLabelAlign(this.labelRotation),this.labelAlign&&(h.align=this.labelAlign),i.forEach(function(t){var t=o[t],e=t&&t.label,i=r.width,s={};e&&(e.attr(h),t.shortenLabel?t.shortenLabel():p&&!i&&"nowrap"!==r.whiteSpace&&(p<e.textPxLength||"SPAN"===e.element.tagName)?(s.width=p+"px",c||(s.textOverflow=e.specificTextOverflow||u),e.css(s)):e.styles&&e.styles.width&&!s.width&&!i&&e.css({width:null}),delete e.specificTextOverflow,t.rotation=h.rotation)},this),this.tickRotCorr=e.rotCorr(d.b,this.labelRotation||0,0!==this.side)}hasData(){return this.series.some(function(t){return t.hasData()})||this.options.showEmpty&&L(this.min)&&L(this.max)}addTitle(t){var e=this,i=e.chart.renderer,s=e.horiz,o=e.opposite,r=e.options.title,a=e.chart.styledMode;let n;e.axisTitle||(n=(n=r.textAlign)||(s?{low:"left",middle:"center",high:"right"}:{low:o?"right":"left",middle:"center",high:o?"left":"right"})[r.align],e.axisTitle=i.text(r.text||"",0,0,r.useHTML).attr({zIndex:7,rotation:r.rotation||0,align:n}).addClass("highcharts-axis-title"),a||e.axisTitle.css(x(r.style)),e.axisTitle.add(e.axisGroup),e.axisTitle.isNew=!0),a||r.style.width||e.isRadial||e.axisTitle.css({width:e.len+"px"}),e.axisTitle[t?"show":"hide"](t)}generateTick(t){var e=this.ticks;e[t]?e[t].addLabel():e[t]=new C(this,t)}createGroups(){const{axisParent:s,chart:t,coll:o,options:r}=this,a=t.renderer;var e=(t,e,i)=>a.g(t).attr({zIndex:i}).addClass(`highcharts-${o.toLowerCase()}${e} `+(this.isRadial?`highcharts-radial-axis${e} `:"")+(r.className||"")).add(s);this.axisGroup||(this.gridGroup=e("grid","-grid",r.gridZIndex),this.axisGroup=e("axis","",r.zIndex),this.labelGroup=e("axis-labels","-labels",r.labels.zIndex))}getOffset(){const e=this,{chart:t,horiz:i,options:s,side:o,ticks:r,tickPositions:a,coll:n}=e,l=t.inverted&&!e.isZAxis?[1,0,3,2][o]:o,h=e.hasData(),d=s.title,c=s.labels,p=B(s.crossing),u=t.axisOffset,g=t.clipOffset,f=[-1,1,1,-1][o];let m,x=0,v,y=0,b=0,M,S;var k;e.showAxis=m=h||s.showEmpty,e.staggerLines=e.horiz&&c.staggerLines||void 0,e.createGroups(),h||e.isLinked?(a.forEach(function(t){e.generateTick(t)}),e.renderUnsquish(),e.reserveSpaceDefault=0===o||2===o||{1:"left",3:"right"}[o]===e.labelAlign,j(c.reserveSpace,!p&&null,"center"===e.labelAlign||null,e.reserveSpaceDefault)&&a.forEach(function(t){b=Math.max(r[t].getLabelSize(),b)}),e.staggerLines&&(b*=e.staggerLines),e.labelOffset=b*(e.opposite?-1:1)):w(r,function(t,e){t.destroy(),delete r[e]}),d?.text&&!1!==d.enabled&&(e.addTitle(m),m)&&!p&&!1!==d.reserveSpace&&(e.titleOffset=x=e.axisTitle.getBBox()[i?"height":"width"],v=d.offset,y=L(v)?0:j(d.margin,i?5:10)),e.renderLine(),e.offset=f*j(s.offset,u[o]?u[o]+(s.margin||0):0),e.tickRotCorr=e.tickRotCorr||{x:0,y:0},S=0===o?-e.labelMetrics().h:2===o?e.tickRotCorr.y:0,M=Math.abs(b)+y,b&&(M=(M-=S)+f*(i?j(c.y,e.tickRotCorr.y+f*c.distance):j(c.x,f*c.distance))),e.axisTitleMargin=j(v,M),e.getMaxLabelDimensions&&(e.maxLabelDimensions=e.getMaxLabelDimensions(r,a)),"colorAxis"!==n&&(k=this.tickSize("tick"),u[o]=Math.max(u[o],(e.axisTitleMargin||0)+x+f*e.offset,M,a&&a.length&&k?k[0]+f*e.offset:0),k=!e.axisLine||s.offset?0:2*Math.floor(e.axisLine.strokeWidth()/2),g[l]=Math.max(g[l],k)),D(this,"afterGetOffset")}getLinePath(t){var e=this.chart,i=this.opposite,s=this.offset,o=this.horiz,r=this.left+(i?this.width:0)+s,s=e.chartHeight-this.bottom-(i?this.height:0)+s;return i&&(t*=-1),e.renderer.crispLine([["M",o?this.left:r,o?s:this.top],["L",o?e.chartWidth-this.right:r,o?s:e.chartHeight-this.bottom]],t)}renderLine(){this.axisLine||(this.axisLine=this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup),this.chart.styledMode)||this.axisLine.attr({stroke:this.options.lineColor,"stroke-width":this.options.lineWidth,zIndex:7})}getTitlePosition(t){var e=this.horiz,i=this.left,s=this.top,o=this.len,r=this.options.title,a=e?i:s,n=this.opposite,l=this.offset,h=r.x,d=r.y,c=this.chart.renderer.fontMetrics(t),t=t?Math.max(t.getBBox(!1,0).height-c.h-1,0):0,a={low:a+(e?0:o),middle:a+o/2,high:a+(e?o:0)}[r.align],o=(e?s+this.height:i)+(e?1:-1)*(n?-1:1)*(this.axisTitleMargin||0)+[-t,t,c.f,-t][this.side],r={x:e?a+h:o+(n?this.width:0)+l+h,y:e?o+d-(n?this.height:0)+l:a+d};return D(this,"afterGetTitlePosition",{titlePosition:r}),r}renderMinorTick(t,e){var i=this.minorTicks;i[t]||(i[t]=new C(this,t,"minor")),e&&i[t].isNew&&i[t].render(null,!0),i[t].render(null,!1,1)}renderTick(t,e,i){var s=this,o=s.isLinked,r=s.ticks;(!o||t>=s.min&&t<=s.max||s.grid&&s.grid.isColumn)&&(r[t]||(r[t]=new C(s,t)),i&&r[t].isNew&&r[t].render(e,!0,-1),r[t].render(e))}render(){const i=this,s=i.chart,o=i.logarithmic,t=s.renderer,e=i.options,r=i.isLinked,a=i.tickPositions,n=i.axisTitle,l=i.ticks,h=i.minorTicks,d=i.alternateBands,c=e.stackLabels,p=e.alternateGridColor,u=e.crossing,g=i.tickmarkOffset,f=i.axisLine,m=i.showAxis,x=A(t.globalAnimation);let v,y;if(i.labelEdge.length=0,i.overlap=!1,[l,h,d].forEach(function(t){w(t,function(t){t.isActive=!1})}),B(u)){var b=(this.isXAxis?s.yAxis:s.xAxis)[0],M=[1,-1,-1,1][this.side];if(b){let t=b.toPixels(u,!0);i.horiz&&(t=b.len-t),i.offset=M*t}}if(i.hasData()||r){const S=i.chart.hasRendered&&i.old&&B(i.old.min);i.minorTickInterval&&!i.categories&&i.getMinorTickPositions().forEach(function(t){i.renderMinorTick(t,S)}),a.length&&(a.forEach(function(t,e){i.renderTick(t,e,S)}),g)&&(0===i.min||i.single)&&(l[-1]||(l[-1]=new C(i,-1,null,!0)),l[-1].render(-1)),p&&a.forEach(function(t,e){y="undefined"!=typeof a[e+1]?a[e+1]+g:i.max-g,e%2==0&&t<i.max&&y<=i.max+(s.polar?-g:g)&&(d[t]||(d[t]=new k.PlotLineOrBand(i,{})),v=t+g,d[t].options={from:o?o.lin2log(v):v,to:o?o.lin2log(y):y,color:p,className:"highcharts-alternate-grid"},d[t].render(),d[t].isActive=!0)}),i._addedPlotLB||(i._addedPlotLB=!0,(e.plotLines||[]).concat(e.plotBands||[]).forEach(function(t){i.addPlotBandOrLine(t)}))}[l,h,d].forEach(function(e){const i=[],t=x.duration;w(e,function(t,e){t.isActive||(t.render(e,!1,0),t.isActive=!1,i.push(e))}),R(function(){let t=i.length;for(;t--;)e[i[t]]&&!e[i[t]].isActive&&(e[i[t]].destroy(),delete e[i[t]])},e!==d&&s.hasRendered&&t?t:0)}),f&&(f[f.isPlaced?"animate":"attr"]({d:this.getLinePath(f.strokeWidth())}),f.isPlaced=!0,f[m?"show":"hide"](m)),n&&m&&(n[n.isNew?"attr":"animate"](i.getTitlePosition(n)),n.isNew=!1),c&&c.enabled&&i.stacking&&i.stacking.renderStackTotals(),i.old={len:i.len,max:i.max,min:i.min,transA:i.transA,userMax:i.userMax,userMin:i.userMin},i.isDirty=!1,D(this,"afterRender")}redraw(){this.visible&&(this.render(),this.plotLinesAndBands.forEach(function(t){t.render()})),this.series.forEach(function(t){t.isDirty=!0})}getKeepProps(){return this.keepProps||P.keepProps}destroy(t){const i=this,e=i.plotLinesAndBands,s=this.eventOptions;if(D(this,"destroy",{keepEvents:t}),t||S(i),[i.ticks,i.minorTicks,i.alternateBands].forEach(function(t){r(t)}),e){let t=e.length;for(;t--;)e[t].destroy()}["axisLine","axisTitle","axisGroup","gridGroup","labelGroup","cross","scrollbar"].forEach(function(t){i[t]&&(i[t]=i[t].destroy())});for(const o in i.plotLinesAndBandsGroups)i.plotLinesAndBandsGroups[o]=i.plotLinesAndBandsGroups[o].destroy();w(i,function(t,e){-1===i.getKeepProps().indexOf(e)&&delete i[e]}),this.eventOptions=s}drawCrosshair(t,e){var i=this.crosshair,s=j(i&&i.snap,!0),o=this.chart;let r,a,n,l=this.cross,h;if(D(this,"drawCrosshair",{e:t,point:e}),t=t||this.cross&&this.cross.e,i&&!1!==(L(e)||!s)){if(s?L(e)&&(a=j("colorAxis"!==this.coll?e.crosshairPos:null,this.isXAxis?e.plotX:this.len-e.plotY)):a=t&&(this.horiz?t.chartX-this.pos:this.len-t.chartY+this.pos),L(a)&&(h={value:e&&(this.isXAxis?e.x:j(e.stackY,e.y)),translatedValue:a},o.polar&&u(h,{isCrosshair:!0,chartX:t&&t.chartX,chartY:t&&t.chartY,point:e}),r=this.getPlotLinePath(h)||null),!L(r))return void this.hideCrosshair();n=this.categories&&!this.isRadial,l||(this.cross=l=o.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-"+(n?"category ":"thin ")+(i.className||"")).attr({zIndex:j(i.zIndex,2)}).add(),o.styledMode)||(l.attr({stroke:i.color||(n?d.parse("#ccd3ff").setOpacity(.25).get():"#cccccc"),"stroke-width":j(i.width,1)}).css({"pointer-events":"none"}),i.dashStyle&&l.attr({dashstyle:i.dashStyle})),l.show().attr({d:r}),n&&!i.width&&l.attr({"stroke-width":this.transA}),this.cross.e=t}else this.hideCrosshair();D(this,"afterDrawCrosshair",{e:t,point:e})}hideCrosshair(){this.cross&&this.cross.hide(),D(this,"afterHideCrosshair")}hasVerticalPanning(){var t=this.chart.options.chart.panning;return Boolean(t&&t.enabled&&/y/.test(t.type))}update(t,e){var i=this.chart;t=x(this.userOptions,t),this.destroy(!0),this.init(i,t),i.isDirtyBox=!0,j(e,!0)&&i.redraw()}remove(t){var e=this.chart,i=this.coll,s=this.series;let o=s.length;for(;o--;)s[o]&&s[o].remove(!1);a(e.axes,this),a(e[i]||[],this),e.orderItems(i),this.destroy(),e.isDirtyBox=!0,j(t,!0)&&e.redraw()}setTitle(t,e){this.update({title:t},e)}setCategories(t,e){this.update({categories:t},e)}}return P.keepProps=["coll","extKey","hcEvents","names","series","userMax","userMin"],P}),e(t,"Core/Axis/DateTimeAxis.js",[t["Core/Globals.js"],t["Core/Utilities.js"]],function(t,e){const i=t["composed"],{addEvent:s,getMagnitude:n,normalizeTickInterval:l,pushUnique:o,timeUnits:h}=e;var r;{function a(){return this.chart.time.getTimeTicks.apply(this.chart.time,arguments)}function d(){"datetime"!==this.options.type?this.dateTime=void 0:this.dateTime||(this.dateTime=new p(this))}(t=r=r||{}).compose=function c(t){return o(i,c)&&(t.keepProps.push("dateTime"),t.prototype.getTimeTicks=a,s(t,"afterSetOptions",d)),t};class p{constructor(t){this.axis=t}normalizeTimeTickInterval(t,e){var i=e||[["millisecond",[1,2,5,10,20,25,50,100,200,500]],["second",[1,2,5,10,15,30]],["minute",[1,2,5,10,15,30]],["hour",[1,2,3,4,6,8,12]],["day",[1,2]],["week",[1,2]],["month",[1,2,3,4,6]],["year",null]];let s=i[i.length-1],o=h[s[0]],r=s[1],a;for(a=0;a<i.length;a++)if(s=i[a],o=h[s[0]],r=s[1],i[a+1])if(t<=(o*r[r.length-1]+h[i[a+1][0]])/2)break;o===h.year&&t<5*o&&(r=[1,2,5]);e=l(t/o,r,"year"===s[0]?Math.max(n(t/o),1):1);return{unitRange:o,count:e,unitName:s[0]}}getXDateFormat(t,e){var i=this["axis"],s=i.chart.time;return i.closestPointRange?s.getDateFormat(i.closestPointRange,t,i.options.startOfWeek,e)||s.resolveDTLFormat(e.year).main:s.resolveDTLFormat(e.day).main}}t.Additions=p}return r}),e(t,"Core/Axis/LogarithmicAxis.js",[t["Core/Globals.js"],t["Core/Utilities.js"]],function(t,e){const i=t["composed"],{addEvent:s,normalizeTickInterval:r,pick:a,pushUnique:o}=e;var n;{function l(t){var t=t.userOptions,e=this.logarithmic;"logarithmic"!==t.type?this.logarithmic=void 0:e||(this.logarithmic=new c(this))}function h(){const e=this.logarithmic;e&&(this.lin2val=function(t){return e.lin2log(t)},this.val2lin=function(t){return e.log2lin(t)})}(t=n=n||{}).compose=function d(t){return o(i,d)&&(t.keepProps.push("logarithmic"),s(t,"init",l),s(t,"afterInit",h)),t};class c{constructor(t){this.axis=t}getLogTickPositions(n,l,h,d){var c=this,t=c.axis,e=t.len,i=t.options;let p=[];if(d||(c.minorAutoInterval=void 0),.5<=n)n=Math.round(n),p=t.getLinearTickPositions(n,l,h);else if(.08<=n){var u=Math.floor(l);let t,e,i,s,o,r,a;for(t=.3<n?[1,2,4]:.15<n?[1,2,4,6,8]:[1,2,3,4,5,6,7,8,9],e=u;e<h+1&&!a;e++)for(s=t.length,i=0;i<s&&!a;i++)l<(o=c.log2lin(c.lin2log(e)*t[i]))&&(!d||r<=h)&&void 0!==r&&p.push(r),r>h&&(a=!0),r=o}else{var u=c.lin2log(l),s=c.lin2log(h),o=d?t.getMinorTickInterval():i.tickInterval,o="auto"===o?null:o,i=i.tickPixelInterval/(d?5:1),e=d?e/t.tickPositions.length:e;n=a(o,c.minorAutoInterval,(s-u)*i/(e||1)),n=r(n),p=t.getLinearTickPositions(n,u,s).map(c.log2lin),d||(c.minorAutoInterval=n/5)}return d||(t.tickInterval=n),p}lin2log(t){return Math.pow(10,t)}log2lin(t){return Math.log(t)/Math.LN10}}t.Additions=c}return n}),e(t,"Core/Axis/PlotLineOrBand/PlotLineOrBandAxis.js",[t["Core/Globals.js"],t["Core/Utilities.js"]],function(t,e){const i=t["composed"],{erase:a,extend:s,isNumber:g,pushUnique:o}=e;var n;{t=n=n||{};let r;function l(t){return this.addPlotBandOrLine(t,"plotBands")}function h(t,e){var i,s=this.userOptions;let o=new r(this,t);return(o=this.visible?o.render():o)&&(this._addedPlotLB||(this._addedPlotLB=!0,(s.plotLines||[]).concat(s.plotBands||[]).forEach(t=>{this.addPlotBandOrLine(t)})),e&&((i=s[e]||[]).push(t),s[e]=i),this.plotLinesAndBands.push(o)),o}function d(t){return this.addPlotBandOrLine(t,"plotLines")}function c(t,e,i){i=i||this.options;var s=this.getPlotLinePath({value:e,force:!0,acrossPanes:i.acrossPanes}),o=[],r=this.horiz,e=!g(this.min)||!g(this.max)||t<this.min&&e<this.min||t>this.max&&e>this.max,a=this.getPlotLinePath({value:t,force:!0,acrossPanes:i.acrossPanes});let n,l=1,h;if(a&&s)for(e&&(h=a.toString()===s.toString(),l=0),n=0;n<a.length;n+=2){var d=a[n],c=a[n+1],p=s[n],u=s[n+1];"M"!==d[0]&&"L"!==d[0]||"M"!==c[0]&&"L"!==c[0]||"M"!==p[0]&&"L"!==p[0]||"M"!==u[0]&&"L"!==u[0]||(r&&p[1]===d[1]?(p[1]+=l,u[1]+=l):r||p[2]!==d[2]||(p[2]+=l,u[2]+=l),o.push(["M",d[1],d[2]],["L",c[1],c[2]],["L",u[1],u[2]],["L",p[1],p[2]],["Z"])),o.isFlat=h}return o}function p(t){this.removePlotBandOrLine(t)}function u(i){var t=this.plotLinesAndBands,s=this.options,o=this.userOptions;if(t){let e=t.length;for(;e--;)t[e].id===i&&t[e].destroy();[s.plotLines||[],o.plotLines||[],s.plotBands||[],o.plotBands||[]].forEach(function(t){for(e=t.length;e--;)(t[e]||{}).id===i&&a(t,t[e])})}}function f(t){this.removePlotBandOrLine(t)}t.compose=function m(t,e){return o(i,m)&&(r=t,s(e.prototype,{addPlotBand:l,addPlotLine:d,addPlotBandOrLine:h,getPlotBandPath:c,removePlotBand:p,removePlotLine:f,removePlotBandOrLine:u})),e}}return n}),e(t,"Core/Axis/PlotLineOrBand/PlotLineOrBand.js",[t["Core/Axis/PlotLineOrBand/PlotLineOrBandAxis.js"],t["Core/Utilities.js"]],function(e,t){const{arrayMax:n,arrayMin:l,defined:k,destroyObjectProperties:i,erase:s,fireEvent:C,merge:A,objectEach:w,pick:T}=t;class o{static compose(t){return e.compose(o,t)}constructor(t,e){this.axis=t,this.options=e,this.id=e.id}render(){C(this,"render");const{axis:t,options:e}=this,{horiz:i,logarithmic:s}=t,{color:o,events:r,zIndex:a=0}=e,n={},l=t.chart.renderer,h=e.to,d=e.from,c=e.value,p=e.borderWidth;let u=e.label,{label:g,svgElem:f}=this,m=[],x;var v=k(d)&&k(h),y=k(c),b=!f,M={"class":"highcharts-plot-"+(v?"band ":"line ")+(e.className||"")},S=v?"bands":"lines";if(t.chart.styledMode||(y?(M.stroke=o||"#999999",M["stroke-width"]=T(e.width,1),e.dashStyle&&(M.dashstyle=e.dashStyle)):v&&(M.fill=o||"#e6e9ff",p)&&(M.stroke=e.borderColor,M["stroke-width"]=p)),S+="-"+(n.zIndex=a),(x=t.plotLinesAndBandsGroups[S])||(t.plotLinesAndBandsGroups[S]=x=l.g("plot-"+S).attr(n).add()),f||(this.svgElem=f=l.path().attr(M).add(x)),k(c))m=t.getPlotLinePath({value:s?.log2lin(c)??c,lineWidth:f.strokeWidth(),acrossPanes:e.acrossPanes});else{if(!k(d)||!k(h))return;m=t.getPlotBandPath(s?.log2lin(d)??d,s?.log2lin(h)??h,e)}return!this.eventsAdded&&r&&(w(r,(t,e)=>{f?.on(e,function(t){r[e].apply(this,[t])})}),this.eventsAdded=!0),!b&&f.d||!m?.length?f&&(m?(f.show(),f.animate({d:m})):f.d&&(f.hide(),g)&&(this.label=g=g.destroy())):f.attr({d:m}),u&&(k(u.text)||k(u.formatter))&&m?.length&&0<t.width&&0<t.height&&!m.isFlat?(u=A({align:i&&v&&"center",x:i?!v&&4:10,verticalAlign:!i&&v&&"middle",y:i?v?16:10:v?6:-4,rotation:i&&!v&&90},u),this.renderLabel(u,m,v,a)):g&&g.hide(),this}renderLabel(t,e,i,s){var o=this.axis,r=o.chart.renderer;let a=this.label;a||(this.label=a=r.text(this.getLabelText(t),0,0,t.useHTML).attr({align:t.textAlign||t.align,rotation:t.rotation,"class":"highcharts-plot-"+(i?"band":"line")+"-label"+(t.className||""),zIndex:s}),o.chart.styledMode||a.css(A({fontSize:"0.8em",textOverflow:"ellipsis"},t.style)),a.add());var r=e.xBounds||[e[0][1],e[1][1],(i?e[2]:e[0])[1]],s=e.yBounds||[e[0][2],e[1][2],(i?e[2]:e[0])[2]],i=l(r),e=l(s);a.align(t,!1,{x:i,y:e,width:n(r)-i,height:n(s)-e}),a.alignValue&&"left"!==a.alignValue||(r=t.clip?o.width:o.chart.chartWidth,a.css({width:(90===a.rotation?o.height-(a.alignAttr.y-o.top):r-(a.alignAttr.x-o.left))+"px"})),a.show(!0)}getLabelText(t){return k(t.formatter)?t.formatter.call(this):t.text}destroy(){s(this.axis.plotLinesAndBands,this),delete this.axis,i(this)}}return o}),e(t,"Core/Tooltip.js",[t["Core/Templating.js"],t["Core/Globals.js"],t["Core/Renderer/RendererUtilities.js"],t["Core/Renderer/RendererRegistry.js"],t["Core/Utilities.js"]],function(t,c,e,p,v){const y=t["format"],{composed:i,doc:I,isSafari:R}=c,z=e["distribute"],{addEvent:s,clamp:G,css:m,discardElement:o,extend:N,fireEvent:b,isArray:M,isNumber:h,isString:W,merge:r,pick:X,pushUnique:a,splat:S,syncTimeout:n}=v;class l{constructor(t,e){this.allowShared=!0,this.crosshairs=[],this.distance=0,this.isHidden=!0,this.isSticky=!1,this.now={},this.options={},this.outside=!1,this.chart=t,this.init(t,e)}bodyFormatter(t){return t.map(function(t){var e=t.series.tooltipOptions;return(e[(t.point.formatPrefix||"point")+"Formatter"]||t.point.tooltipFormatter).call(t.point,e[(t.point.formatPrefix||"point")+"Format"]||"")})}cleanSplit(i){this.chart.series.forEach(function(t){var e=t&&t.tt;e&&(!e.isActive||i?t.tt=e.destroy():e.isActive=!1)})}defaultFormatter(t){var e=this.points||S(this);let i;return(i=(i=[t.tooltipFooterHeaderFormatter(e[0])]).concat(t.bodyFormatter(e))).push(t.tooltipFooterHeaderFormatter(e[0],!0)),i}destroy(){this.label&&(this.label=this.label.destroy()),this.split&&(this.cleanSplit(!0),this.tt)&&(this.tt=this.tt.destroy()),this.renderer&&(this.renderer=this.renderer.destroy(),o(this.container)),v.clearTimeout(this.hideTimer),v.clearTimeout(this.tooltipTimeout)}getAnchor(t,s){var o=this.chart,e=o.pointer,r=o.inverted,a=o.plotTop,o=o.plotLeft;let n;if((t=S(t))[0].series&&t[0].series.yAxis&&!t[0].series.yAxis.options.reversedStacks&&(t=t.slice().reverse()),this.followPointer&&s)"undefined"==typeof s.chartX&&(s=e.normalize(s)),n=[s.chartX-o,s.chartY-a];else if(t[0].tooltipPos)n=t[0].tooltipPos;else{let e=0,i=0;t.forEach(function(t){t=t.pos(!0);t&&(e+=t[0],i+=t[1])}),e/=t.length,i/=t.length,this.shared&&1<t.length&&s&&(r?e=s.chartX:i=s.chartY),n=[e-o,i-a]}return n.map(Math.round)}getClassName(t,e,i){var s=this.options,o=t.series,r=o.options;return[s.className,"highcharts-label",i&&"highcharts-tooltip-header",e?"highcharts-tooltip-box":"highcharts-tooltip",!i&&"highcharts-color-"+X(t.colorIndex,o.colorIndex),r&&r.className].filter(W).join(" ")}getLabel(){const e=this,t=this.chart.styledMode,i=this.options,s=this.split&&this.allowShared;let o=this.container,r=this.chart.renderer;var a,n;if(this.label&&(a=!this.label.hasClass("highcharts-label"),!s&&a||s&&!a)&&this.destroy(),!this.label){if(this.outside&&(a=this.chart.options.chart.style,n=p.getRendererType(),this.container=o=c.doc.createElement("div"),o.className="highcharts-tooltip-container",m(o,{position:"absolute",top:"1px",pointerEvents:"none",zIndex:Math.max(this.options.style.zIndex||0,(a&&a.zIndex||0)+3)}),this.renderer=r=new n(o,0,0,a,void 0,void 0,r.styledMode)),s?this.label=r.g("tooltip"):(this.label=r.label("",0,0,i.shape,void 0,void 0,i.useHTML,void 0,"tooltip").attr({padding:i.padding,r:i.borderRadius}),t||this.label.attr({fill:i.backgroundColor,"stroke-width":i.borderWidth||0}).css(i.style).css({pointerEvents:i.style.pointerEvents||(this.shouldStickOnContact()?"auto":"none")})),e.outside){const l=this.label,{xSetter:h,ySetter:d}=l;l.xSetter=function(t){h.call(l,e.distance),o&&(o.style.left=t+"px")},l.ySetter=function(t){d.call(l,e.distance),o&&(o.style.top=t+"px")}}this.label.attr({zIndex:8}).shadow(i.shadow).add()}return o&&!o.parentElement&&c.doc.body.appendChild(o),this.label}getPlayingField(){var{body:t,documentElement:e}=I,{chart:i,distance:s,outside:o}=this;return{width:o?Math.max(t.scrollWidth,e.scrollWidth,t.offsetWidth,e.offsetWidth,e.clientWidth)-2*s:i.chartWidth,height:o?Math.max(t.scrollHeight,e.scrollHeight,t.offsetHeight,e.offsetHeight,e.clientHeight):i.chartHeight}}getPosition(i,s,t){const{distance:p,chart:o,outside:u}=this,{inverted:e,plotLeft:r,plotTop:a,polar:n}=o,{plotX:l=0,plotY:h=0}=t,g={},f=e&&t.h||0,{height:d,width:c}=this.getPlayingField(),m=o.pointer.getChartPosition(),x=t=>t*m.scaleX,v=t=>t*m.scaleY,y=t=>{var e="x"===t;return[t,e?c:d,e?i:s].concat(u?[e?x(i):v(s),e?m.left-p+x(l+r):m.top-p+v(h+a),0,e?c:d]:[e?i:s,e?l+r:h+a,e?r:a,e?r+o.plotWidth:a+o.plotHeight])};let b=y("y"),M=y("x"),S,k=!!t.negative;!n&&o.hoverSeries?.yAxis?.reversed&&(k=!k);const C=!this.followPointer&&X(t.ttBelow,!n&&!e===k),A=function(t,e,i,s,o,r,a){var n=u?("y"===t?v:x)(p):p,l=(i-s)/2,h=s<o-p,d=o+p+s<e,c=o-n-i+l,o=o+n-l;if(C&&d)g[t]=o;else if(!C&&h)g[t]=c;else if(h)g[t]=Math.min(a-s,c-f<0?c:c-f);else{if(!d)return!1;g[t]=Math.max(r,o+f+i>e?o:o+f)}},w=function(t,e,i,s,o){if(o<p||o>e-p)return!1;g[t]=o<i/2?1:e-s/2<o?e-s-2:o-i/2},T=function(t){[b,M]=[M,b],S=t},P=()=>{!1!==A.apply(0,b)?!1!==w.apply(0,M)||S||(T(!0),P()):S?g.x=g.y=0:(T(!0),P())};return(e&&!n||1<this.len)&&T(),P(),g}hide(e){const i=this;v.clearTimeout(this.hideTimer),e=X(e,this.options.hideDelay),this.isHidden||(this.hideTimer=n(function(){const t=i.getLabel();i.getLabel().animate({opacity:0},{duration:e&&150,complete:()=>{t.hide(),i.container&&i.container.remove()}}),i.isHidden=!0},e))}init(t,e){this.chart=t,this.options=e,this.crosshairs=[],this.now={x:0,y:0},this.isHidden=!0,this.split=e.split&&!t.inverted&&!t.polar,this.shared=e.shared||this.split,this.outside=X(e.outside,Boolean(t.scrollablePixelsX||t.scrollablePixelsY))}shouldStickOnContact(t){return!(this.followPointer||!this.options.stickOnContact||t&&!this.chart.pointer.inClass(t.target,"highcharts-tooltip"))}move(t,e,i,s){const o=this,r=o.now,a=!1!==o.options.animation&&!o.isHidden&&(1<Math.abs(t-r.x)||1<Math.abs(e-r.y)),n=o.followPointer||1<o.len;N(r,{x:a?(2*r.x+t)/3:t,y:a?(r.y+e)/2:e,anchorX:n?void 0:a?(2*r.anchorX+i)/3:i,anchorY:n?void 0:a?(r.anchorY+s)/2:s}),o.getLabel().attr(r),o.drawTracker(),a&&(v.clearTimeout(this.tooltipTimeout),this.tooltipTimeout=setTimeout(function(){o&&o.move(t,e,i,s)},32))}refresh(t,s){const o=this,r=this.chart,a=o.options,n=r.pointer,l=S(t),h=l[0],e=[],i=a.format,d=a.formatter||o.defaultFormatter,c=o.shared,p=r.styledMode;let u={};if(a.enabled&&h.series){v.clearTimeout(this.hideTimer),o.allowShared=!(!M(t)&&t.series&&t.series.noSharedTooltip),o.followPointer=!o.split&&h.series.tooltipOptions.followPointer;var t=o.getAnchor(t,s),g=t[0],f=t[1],m=(c&&o.allowShared?(n.applyInactiveState(l),l.forEach(function(t){t.setState("hover"),e.push(t.getLabelConfig())}),(u=h.getLabelConfig()).points=e):u=h.getLabelConfig(),this.len=e.length,W(i)?y(i,u,r):d.call(u,o)),x=h.series;if(this.distance=X(x.tooltipOptions.distance,16),!1===m)this.hide();else{if(o.split&&o.allowShared)this.renderSplit(m,l);else{let e=g,i=f;if(s&&n.isDirectTouch&&(e=s.chartX-r.plotLeft,i=s.chartY-r.plotTop),!r.polar&&!1!==x.options.clip&&!l.some(t=>n.isDirectTouch||t.series.shouldShowTooltip(e,i)))return void o.hide();s=o.getLabel();a.style.width&&!p||s.css({width:(this.outside?this.getPlayingField():r.spacingBox).width+"px"}),s.attr({text:m&&m.join?m.join(""):m}),s.addClass(o.getClassName(h),!0),p||s.attr({stroke:a.borderColor||h.color||x.color||"#666666"}),o.updatePosition({plotX:g,plotY:f,negative:h.negative,ttBelow:h.ttBelow,h:t[2]||0})}o.isHidden&&o.label&&o.label.attr({opacity:1}).show(),o.isHidden=!1}b(this,"refresh")}}renderSplit(t,h){const d=this,{chart:e,chart:{chartWidth:i,chartHeight:s,plotHeight:c,plotLeft:p,plotTop:u,pointer:o,scrollablePixelsY:r=0,scrollablePixelsX:a,scrollingContainer:{scrollLeft:n,scrollTop:l}={scrollLeft:0,scrollTop:0},styledMode:g},distance:f,options:m,options:{positioner:x}}=d,v=d.outside&&"number"!=typeof a?I.documentElement.getBoundingClientRect():{left:n,right:n+i,top:l,bottom:l+s},y=d.getLabel(),b=this.renderer||e.renderer,M=Boolean(e.xAxis[0]&&e.xAxis[0].opposite),{left:S,top:k}=o.getChartPosition();let C=u+l,A,w=c-r;function T(t,e,i,s,o=!0){let r,a;return{x:a=i?(r=M?0:w,G(t-s/2,v.left,v.right-s-(d.outside?S:0))):(r=e-C,a=o?t-s-f:t+f,G(a,o?a:v.left,v.right)),y:r}}let P=(t=W(t)?[!1,t]:t).slice(0,h.length+1).reduce(function(t,e,i){var s,o,r,a,n,l;return!1!==e&&""!==e&&(r=(e=(o=(o=(s=(i=h[i-1]||{isHeader:!0,plotX:h[0].plotX,plotY:c,series:{}}).isHeader)?d:i.series).tt=function(t,e,i){let s=t;var o,{isHeader:t,series:r}=e;return s||(o={padding:m.padding,r:m.borderRadius},g||(o.fill=m.backgroundColor,o["stroke-width"]=m.borderWidth??1),s=b.label("",0,0,m[t?"headerShape":"shape"],void 0,void 0,m.useHTML).addClass(d.getClassName(e,!0,t)).attr(o).add(y)),s.isActive=!0,s.attr({text:i}),g||s.css(m.style).attr({stroke:m.borderColor||e.color||r.color||"#333333"}),s}(o.tt,i,e.toString())).getBBox()).width+o.strokeWidth(),{anchorX:a,anchorY:n}=(s&&(A=e.height,w+=A,M)&&(C-=A),function(t){var e,{isHeader:t,plotX:i=0,plotY:s=0,series:o}=t;let r,a;return t?(r=Math.max(p+i,p),a=u+c/2):({xAxis:t,yAxis:e}=o,r=t.pos+G(i,-f,t.len+f),o.shouldShowTooltip(0,e.pos-u+s,{ignoreX:!0})&&(a=e.pos+s)),{anchorX:r=G(r,v.left-f,v.right+f),anchorY:a}}(i)),"number"==typeof n?(e=e.height+1,l=x?x.call(d,r,e,i):T(a,n,s,r),t.push({align:x?0:void 0,anchorX:a,anchorY:n,boxWidth:r,point:i,rank:X(l.rank,s?1:0),size:e,target:l.y,tt:o,x:l.x})):o.isActive=!1),t},[]);!x&&P.some(t=>{var e=d["outside"],e=(e?S:0)+t.anchorX;return e<v.left&&e+t.boxWidth<v.right||e<S-v.left+t.boxWidth&&v.right-e>e})&&(P=P.map(t=>{var{x:e,y:i}=T(t.anchorX,t.anchorY,t.point.isHeader,t.boxWidth,!1);return N(t,{target:i,x:e})})),d.cleanSplit(),z(P,w);const O={left:S,right:S};P.forEach(function(t){var{x:t,boxWidth:e,isHeader:i}=t;i||(d.outside&&S+t<O.left&&(O.left=S+t),!i&&d.outside&&O.left+e>O.right&&(O.right=S+t))}),P.forEach(function(t){var{x:e,anchorX:i,anchorY:s,pos:o,point:{isHeader:r}}=t,o={visibility:void 0===o?"hidden":"inherit",x:e,y:(o||0)+C,anchorX:i,anchorY:s};d.outside&&e<i&&0<(s=S-O.left)&&(r||(o.x=e+s,o.anchorX=i+s),r)&&(o.x=(O.right-O.left)/2,o.anchorX=i+s),t.tt.attr(o)});var L,E,D,{container:t,outside:B,renderer:j}=d;B&&t&&j&&({width:B,height:L,x:E,y:D}=y.getBBox(),j.setSize(B+E,L+D,!1),t.style.left=O.left+"px",t.style.top=k+"px"),R&&y.attr({opacity:1===y.opacity?.999:1})}drawTracker(){var t,e,i,s,o,r=this;this.shouldStickOnContact()?(t=r.chart,e=r.label,s=r.shared?t.hoverPoints:t.hoverPoint,e&&s&&(i={x:0,y:0,width:0,height:0},s=this.getAnchor(s),o=e.getBBox(),s[0]+=t.plotLeft-(e.translateX||0),s[1]+=t.plotTop-(e.translateY||0),i.x=Math.min(0,s[0]),i.y=Math.min(0,s[1]),i.width=s[0]<0?Math.max(Math.abs(s[0]),o.width-s[0]):Math.max(Math.abs(s[0]),o.width),i.height=s[1]<0?Math.max(Math.abs(s[1]),o.height-Math.abs(s[1])):Math.max(Math.abs(s[1]),o.height),r.tracker?r.tracker.attr(i):(r.tracker=e.renderer.rect(i).addClass("highcharts-tracker").add(e),t.styledMode||r.tracker.attr({fill:"rgba(0,0,0,0)"})))):r.tracker&&(r.tracker=r.tracker.destroy())}styledModeFormat(t){return t.replace('style="font-size: 0.8em"','class="highcharts-header"').replace(/style="color:{(point|series)\.color}"/g,'class="highcharts-color-{$1.colorIndex} {series.options.className} {point.options.className}"')}tooltipFooterHeaderFormatter(e,t){const i=e.series,s=i.tooltipOptions,o=i.xAxis,r=o&&o.dateTime,a={isFooter:t,labelConfig:e};let n=s.xDateFormat,l=s[t?"footerFormat":"headerFormat"];return b(this,"headerFormatter",a,function(t){r&&!n&&h(e.key)&&(n=r.getXDateFormat(e.key,s.dateTimeLabelFormats)),r&&n&&(e.point&&e.point.tooltipDateKeys||["key"]).forEach(function(t){l=l.replace("{point."+t+"}","{point."+t+":"+n+"}")}),i.chart.styledMode&&(l=this.styledModeFormat(l)),t.text=y(l,{point:e,series:i},this.chart)}),a.text}update(t){this.destroy(),this.init(this.chart,r(!0,this.options,t))}updatePosition(t){var{chart:e,container:i,distance:s,options:o,renderer:r}=this,{height:a=0,width:n=0}=this.getLabel(),{left:l,top:h,scaleX:d,scaleY:c}=e.pointer.getChartPosition(),p=(o.positioner||this.getPosition).call(this,n,a,t);let u=(t.plotX||0)+e.plotLeft,g=(t.plotY||0)+e.plotTop,f;r&&i&&(o.positioner&&(p.x+=l-s,p.y+=h-s),f=(o.borderWidth||0)+2*s+2,r.setSize(n+f,a+f,!1),1===d&&1===c||(m(i,{transform:`scale(${d}, ${c})`}),u*=d,g*=c),u+=l-p.x,g+=h-p.y),this.move(Math.round(p.x),Math.round(p.y||0),u,g)}}var d;return(d=l=l||{}).compose=function u(t){a(i,u)&&s(t,"afterInit",function(){var t=this.chart;t.options.tooltip&&(t.tooltip=new d(t,t.options.tooltip))})},l}),e(t,"Core/Series/Point.js",[t["Core/Renderer/HTML/AST.js"],t["Core/Animation/AnimationUtilities.js"],t["Core/Defaults.js"],t["Core/Templating.js"],t["Core/Utilities.js"]],function(b,t,e,i,s){const l=t["animObject"],M=e["defaultOptions"],a=i["format"],{addEvent:o,erase:h,extend:S,fireEvent:k,getNestedProperty:r,isArray:d,isFunction:n,isNumber:C,isObject:c,merge:p,objectEach:u,pick:A,syncTimeout:g,removeEvent:f,uniqueKey:m}=s;class x{animateBeforeDestroy(){const i=this,s={x:i.startXPos,opacity:0},t=i.getGraphicalProps();t.singular.forEach(function(t){var e="dataLabel"===t;i[t]=i[t].animate(e?{x:i[t].startXPos,y:i[t].startYPos,opacity:0}:s)}),t.plural.forEach(function(t){i[t].forEach(function(t){t.element&&t.animate(S({x:i.startXPos},t.startYPos?{x:t.startXPos,y:t.startYPos}:{}))})})}applyOptions(t,e){var i=this,s=i.series,o=s.options.pointValKey||s.pointValKey;return t=x.prototype.optionsToObject.call(this,t),S(i,t),i.options=i.options?S(i.options,t):t,t.group&&delete i.group,t.dataLabels&&delete i.dataLabels,o&&(i.y=x.prototype.getNestedProperty.call(i,o)),i.selected&&(i.state="select"),"name"in i&&void 0===e&&s.xAxis&&s.xAxis.hasNames&&(i.x=s.xAxis.nameToX(i)),"undefined"==typeof i.x&&s?i.x=void 0===e?s.autoIncrement():e:C(t.x)&&s.options.relativeXValue&&(i.x=s.autoIncrement(t.x)),i.isNull=this.isValid&&!this.isValid(),i.formatPrefix=i.isNull?"null":"point",i}destroy(){if(!this.destroyed){const e=this,i=e.series,s=i.chart,o=i.options.dataSorting,r=s.hoverPoints,a=e.series.chart.renderer.globalAnimation,n=l(a);var t=()=>{(e.graphic||e.graphics||e.dataLabel||e.dataLabels)&&(f(e),e.destroyElements());for(const t in e)delete e[t]};e.legendItem&&s.legend.destroyItem(e),r&&(e.setState(),h(r,e),r.length||(s.hoverPoints=null)),e===s.hoverPoint&&e.onMouseOut(),o&&o.enabled?(this.animateBeforeDestroy(),g(t,n.duration)):t(),s.pointCount--}this.destroyed=!0}destroyElements(t){const e=this,i=e.getGraphicalProps(t);i.singular.forEach(function(t){e[t]=e[t].destroy()}),i.plural.forEach(function(t){e[t].forEach(function(t){t&&t.element&&t.destroy()}),delete e[t]})}firePointEvent(t,e,i){const s=this,o=this.series,r=o.options;(r.point.events[t]||s.options&&s.options.events&&s.options.events[t])&&s.importEvents(),"click"===t&&r.allowPointSelect&&(i=function(t){!s.destroyed&&s.select&&s.select(null,t.ctrlKey||t.metaKey||t.shiftKey)}),k(s,t,e,i)}getClassName(){var t=this;return"highcharts-point"+(t.selected?" highcharts-point-select":"")+(t.negative?" highcharts-negative":"")+(t.isNull?" highcharts-null-point":"")+("undefined"!=typeof t.colorIndex?" highcharts-color-"+t.colorIndex:"")+(t.options.className?" "+t.options.className:"")+(t.zone&&t.zone.className?" "+t.zone.className.replace("highcharts-negative",""):"")}getGraphicalProps(i){const s=this,t=[],o={singular:[],plural:[]};let e,r;for((i=i||{graphic:1,dataLabel:1}).graphic&&t.push("graphic","connector"),i.dataLabel&&t.push("dataLabel","dataLabelPath","dataLabelUpper"),r=t.length;r--;)e=t[r],s[e]&&o.singular.push(e);return["graphic","dataLabel"].forEach(function(t){var e=t+"s";i[t]&&s[e]&&o.plural.push(e)}),o}getLabelConfig(){return{x:this.category,y:this.y,color:this.color,colorIndex:this.colorIndex,key:this.name||this.category,series:this.series,point:this,percentage:this.percentage,total:this.total||this.stackTotal}}getNestedProperty(t){if(t)return 0===t.indexOf("custom.")?r(t,this.options):this[t]}getZone(){var t=this.series,e=t.zones,i=t.zoneAxis||"y";let s,o=0;for(s=e[o];this[i]>=s.value;)s=e[++o];return this.nonZonedColor||(this.nonZonedColor=this.color),s&&s.color&&!this.options.color?this.color=s.color:this.color=this.nonZonedColor,s}hasNewShapeType(){return(this.graphic&&(this.graphic.symbolName||this.graphic.element.nodeName))!==this.shapeType}constructor(t,e,i){this.formatPrefix="point",this.visible=!0,this.series=t,this.applyOptions(e,i),this.id??(this.id=m()),this.resolveColor(),t.chart.pointCount++,k(this,"afterInit")}isValid(){return(C(this.x)||this.x instanceof Date)&&C(this.y)}optionsToObject(t){var e=this.series,i=e.options.keys,s=i||e.pointArrayMap||["y"],o=s.length;let r={},a,n=0,l=0;if(C(t)||null===t)r[s[0]]=t;else if(d(t))for(!i&&t.length>o&&("string"==(a=typeof t[0])?r.name=t[0]:"number"==a&&(r.x=t[0]),n++);l<o;)i&&"undefined"==typeof t[n]||(0<s[l].indexOf(".")?x.prototype.setNestedProperty(r,t[n],s[l]):r[s[l]]=t[n]),n++,l++;else"object"==typeof t&&((r=t).dataLabels&&(e.hasDataLabels=()=>!0),t.marker)&&(e._hasPointMarkers=!0);return r}pos(i,s=this.plotY){if(!this.destroyed){var{plotX:o,series:r}=this,{chart:r,xAxis:a,yAxis:n}=r;let t=0,e=0;if(C(o)&&C(s))return i&&(t=a?a.pos:r.plotLeft,e=n?n.pos:r.plotTop),r.inverted&&a&&n?[n.len-s+e,a.len-o+t]:[o+t,s+e]}}resolveColor(){var t=this.series,e=t.chart.options.chart,i=t.chart.styledMode;let s,o,r=e.colorCount,a;delete this.nonZonedColor,t.options.colorByPoint?(i||(o=t.options.colors||t.chart.options.colors,s=o[t.colorCounter],r=o.length),a=t.colorCounter,t.colorCounter++,t.colorCounter===r&&(t.colorCounter=0)):(i||(s=t.color),a=t.colorIndex),this.colorIndex=A(this.options.colorIndex,a),this.color=A(this.options.color,s)}setNestedProperty(t,o,e){return e.split(".").reduce(function(t,e,i,s){s=s.length-1===i;return t[e]=s?o:c(t[e],!0)?t[e]:{},t[e]},t),t}shouldDraw(){return!this.isNull}tooltipFormatter(e){const t=this.series,i=t.tooltipOptions,s=A(i.valueDecimals,""),o=i.valuePrefix||"",r=i.valueSuffix||"";return t.chart.styledMode&&(e=t.chart.tooltip.styledModeFormat(e)),(t.pointArrayMap||["y"]).forEach(function(t){t="{point."+t,e=(e=o||r?e.replace(RegExp(t+"}","g"),o+t+"}"+r):e).replace(RegExp(t+"}","g"),t+":,."+s+"f}")}),a(e,{point:this,series:this.series},t.chart)}update(e,i,s,t){const o=this,r=o.series,a=o.graphic,n=r.chart,l=r.options;let h;function d(){o.applyOptions(e);var t=a&&o.hasMockGraphic,t=null===o.y?!t:t;a&&t&&(o.graphic=a.destroy(),delete o.hasMockGraphic),c(e,!0)&&(a&&a.element&&e&&e.marker&&"undefined"!=typeof e.marker.symbol&&(o.graphic=a.destroy()),e?.dataLabels)&&o.dataLabel&&(o.dataLabel=o.dataLabel.destroy()),h=o.index,r.updateParallelArrays(o,h),l.data[h]=c(l.data[h],!0)||c(e,!0)?o.options:A(e,l.data[h]),r.isDirty=r.isDirtyData=!0,!r.fixedBox&&r.hasCartesianSeries&&(n.isDirtyBox=!0),"point"===l.legendType&&(n.isDirtyLegend=!0),i&&n.redraw(s)}i=A(i,!0),!1===t?d():o.firePointEvent("update",{options:e},d)}remove(t,e){this.series.removePoint(this.series.data.indexOf(this),t,e)}select(t,e){const i=this,s=i.series,o=s.chart;t=A(t,!i.selected),this.selectedStaging=t,i.firePointEvent(t?"select":"unselect",{accumulate:e},function(){i.selected=i.options.selected=t,s.options.data[s.data.indexOf(i)]=i.options,i.setState(t&&"select"),e||o.getSelectedPoints().forEach(function(t){var e=t.series;t.selected&&t!==i&&(t.selected=t.options.selected=!1,e.options.data[e.data.indexOf(t)]=t.options,t.setState(o.hoverPoints&&e.options.inactiveOtherPoints?"inactive":""),t.firePointEvent("unselect"))})}),delete this.selectedStaging}onMouseOver(t){var e=this.series.chart,i=e.pointer;t=t?i.normalize(t):i.getChartCoordinatesFromPoint(this,e.inverted),i.runPointActions(t,this)}onMouseOut(){var t=this.series.chart;this.firePointEvent("mouseOut"),this.series.options.inactiveOtherPoints||(t.hoverPoints||[]).forEach(function(t){t.setState()}),t.hoverPoints=t.hoverPoint=null}importEvents(){if(!this.hasImportedEvents){const i=this,t=p(i.series.options.point,i.options),e=t.events;i.events=e,u(e,function(t,e){n(t)&&o(i,e,t)}),this.hasImportedEvents=!0}}setState(t,e){var i=this,s=i.series,o=i.state,r=s.options.states[t||"normal"]||{},a=M.plotOptions[s.type].marker&&s.options.marker,n=a&&!1===a.enabled,l=a&&a.states&&a.states[t||"normal"]||{},h=!1===l.enabled,d=i.marker||{},c=s.chart,p=a&&s.markerAttribs;let u=s.halo,g,f,m,x=s.stateMarkerGraphic,v;if(!((t=t||"")===i.state&&!e||i.selected&&"select"!==t||!1===r.enabled||t&&(h||n&&!1===l.enabled)||t&&d.states&&d.states[t]&&!1===d.states[t].enabled)){if(i.state=t,p&&(g=s.markerAttribs(i,t)),i.graphic&&!i.hasMockGraphic){if(o&&i.graphic.removeClass("highcharts-point-"+o),t&&i.graphic.addClass("highcharts-point-"+t),!c.styledMode){f=s.pointAttribs(i,t),m=A(c.options.chart.animation,r.animation);const y=f.opacity;s.options.inactiveOtherPoints&&C(y)&&(i.dataLabels||[]).forEach(function(t){t&&!t.hasClass("highcharts-data-label-hidden")&&(t.animate({opacity:y},m),t.connector)&&t.connector.animate({opacity:y},m)}),i.graphic.animate(f,m)}g&&i.graphic.animate(g,A(c.options.chart.animation,l.animation,a.animation)),x&&x.hide()}else t&&l&&(v=d.symbol||s.symbol,x&&x.currentSymbol!==v&&(x=x.destroy()),g&&(x?x[e?"animate":"attr"]({x:g.x,y:g.y}):v&&(s.stateMarkerGraphic=x=c.renderer.symbol(v,g.x,g.y,g.width,g.height).add(s.markerGroup),x.currentSymbol=v)),!c.styledMode)&&x&&"inactive"!==i.state&&x.attr(s.pointAttribs(i,t)),x&&(x[t&&i.isInside?"show":"hide"](),x.element.point=i,x.addClass(i.getClassName(),!0));h=r.halo,n=i.graphic||x,p=n&&n.visibility||"inherit";h&&h.size&&n&&"hidden"!==p&&!i.isCluster?(u||(s.halo=u=c.renderer.path().add(n.parentGroup)),u.show()[e?"animate":"attr"]({d:i.haloPath(h.size)}),u.attr({"class":"highcharts-halo highcharts-color-"+A(i.colorIndex,s.colorIndex)+(i.className?" "+i.className:""),visibility:p,zIndex:-1}),u.point=i,c.styledMode||u.attr(S({fill:i.color||s.color,"fill-opacity":h.opacity},b.filterUserAttributes(h.attributes||{})))):u&&u.point&&u.point.haloPath&&u.animate({d:u.point.haloPath(0)},null,u.hide),k(i,"afterSetState",{state:t})}}haloPath(t){var e=this.pos();return e?this.series.chart.renderer.symbols.circle(Math.floor(e[0])-t,e[1]-t,2*t,2*t):[]}}return x}),e(t,"Core/Pointer.js",[t["Core/Color/Color.js"],t["Core/Globals.js"],t["Core/Utilities.js"]],function(t,s,e){const f=t["parse"],{charts:u,composed:i,noop:g}=s,{addEvent:m,attr:o,css:x,defined:v,extend:y,find:b,fireEvent:M,isNumber:S,isObject:k,objectEach:r,offset:a,pick:C,pushUnique:n,splat:h}=e;class A{applyInactiveState(t){let e=[],i;(t||[]).forEach(function(t){i=t.series,e.push(i),i.linkedParent&&e.push(i.linkedParent),i.linkedSeries&&(e=e.concat(i.linkedSeries)),i.navigatorSeries&&e.push(i.navigatorSeries)}),this.chart.series.forEach(function(t){-1===e.indexOf(t)?t.setState("inactive",!0):t.options.inactiveOtherPoints&&t.setAllPointsToState("inactive")})}destroy(){const i=this;this.eventsToUnbind.forEach(t=>t()),this.eventsToUnbind=[],s.chartCount||(A.unbindDocumentMouseUp&&(A.unbindDocumentMouseUp=A.unbindDocumentMouseUp()),A.unbindDocumentTouchEnd&&(A.unbindDocumentTouchEnd=A.unbindDocumentTouchEnd())),clearInterval(i.tooltipTimeout),r(i,function(t,e){i[e]=void 0})}getSelectionMarkerAttrs(n,l){var t={args:{chartX:n,chartY:l},attrs:{},shapeType:"rect"};return M(this,"getSelectionMarkerAttrs",t,t=>{var{chart:e,mouseDownX:i=0,mouseDownY:s=0,zoomHor:o,zoomVert:r}=this,t=t.attrs;let a;t.x=e.plotLeft,t.y=e.plotTop,t.width=o?1:e.plotWidth,t.height=r?1:e.plotHeight,o&&(a=n-i,t.width=Math.abs(a),t.x=(0<a?0:a)+i),r&&(a=l-s,t.height=Math.abs(a),t.y=(0<a?0:a)+s)}),t}drag(t){var e=this.chart,i=e.options.chart,s=e.plotLeft,o=e.plotTop,r=e.plotWidth,a=e.plotHeight,n=this.mouseDownX||0,l=this.mouseDownY||0,h=k(i.panning)?i.panning&&i.panning.enabled:i.panning,d=i.panKey&&t[i.panKey+"Key"];let c=t.chartX,p=t.chartY,u,g=this.selectionMarker;g&&g.touch||(c<s?c=s:c>s+r&&(c=s+r),p<o?p=o:p>o+a&&(p=o+a),this.hasDragged=Math.sqrt(Math.pow(n-c,2)+Math.pow(l-p,2)),10<this.hasDragged&&(u=e.isInsidePlot(n-s,l-o,{visiblePlotOnly:!0}),{shapeType:r,attrs:a}=this.getSelectionMarkerAttrs(c,p),!e.hasCartesianSeries&&!e.mapView||!this.zoomX&&!this.zoomY||!u||d||g||(this.selectionMarker=g=e.renderer[r](),g.attr({"class":"highcharts-selection-marker",zIndex:7}).add(),e.styledMode)||g.attr({fill:i.selectionMarkerFill||f("#334eff").setOpacity(.25).get()}),g&&g.attr(a),u)&&!g&&h&&e.pan(t,i.panning))}dragStart(t){var e=this.chart;e.mouseIsDown=t.type,e.cancelClick=!1,e.mouseDownX=this.mouseDownX=t.chartX,e.mouseDownY=this.mouseDownY=t.chartY}getSelectionBox(e){var t={args:{marker:e},result:{}};return M(this,"getSelectionBox",t,t=>{t.result={x:e.attr?+e.attr("x"):e.x,y:e.attr?+e.attr("y"):e.y,width:e.attr?e.attr("width"):e.width,height:e.attr?e.attr("height"):e.height}}),t.result}drop(r){const a=this,e=this.chart,n=this.hasPinched;if(this.selectionMarker){const{x:l,y:h,width:d,height:c}=this.getSelectionBox(this.selectionMarker),p={originalEvent:r,xAxis:[],yAxis:[],x:l,y:h,width:d,height:c};let o=Boolean(e.mapView);(this.hasDragged||n)&&(e.axes.forEach(function(t){var e,i,s;t.zoomEnabled&&v(t.min)&&(n||a[{xAxis:"zoomX",yAxis:"zoomY"}[t.coll]])&&S(l)&&S(h)&&S(d)&&S(c)&&(s=t.horiz,e="touchend"===r.type?t.minPixelPadding:0,i=t.toValue((s?l:h)+e),s=t.toValue((s?l+d:h+c)-e),p[t.coll].push({axis:t,min:Math.min(i,s),max:Math.max(i,s)}),o=!0)}),o)&&M(e,"selection",p,function(t){e.zoom(y(t,n?{animation:!1}:null))}),S(e.index)&&(this.selectionMarker=this.selectionMarker.destroy()),n&&this.scaleGroups()}e&&S(e.index)&&(x(e.container,{cursor:e._cursor}),e.cancelClick=10<+this.hasDragged,e.mouseIsDown=this.hasDragged=this.hasPinched=!1,this.pinchDown=[])}findNearestKDPoint(t,a,i){let s;return t.forEach(function(t){var e=!(t.noSharedTooltip&&a)&&t.options.findNearestPointBy.indexOf("y")<0,e=t.searchPoint(i,e);k(e,!0)&&e.series&&(!k(s,!0)||0<function(t,e){var i=t.distX-e.distX,s=t.dist-e.dist,o=(e.series.group&&e.series.group.zIndex)-(t.series.group&&t.series.group.zIndex);let r;return r=0!=i&&a?i:0!=s?s:0!=o?o:t.series.index>e.series.index?-1:1}(s,e))&&(s=e)}),s}getChartCoordinatesFromPoint(i,s){var o=i.series,r=o.xAxis,o=o.yAxis,a=i.shapeArgs;if(r&&o){let t=C(i.clientX,i.plotX),e=i.plotY||0;return i.isNode&&a&&S(a.x)&&S(a.y)&&(t=a.x,e=a.y),s?{chartX:o.len+o.pos-e,chartY:r.len+r.pos-t}:{chartX:t+r.pos,chartY:e+o.pos}}if(a&&a.x&&a.y)return{chartX:a.x,chartY:a.y}}getChartPosition(){var t,e,i;return this.chartPosition||(i=this.chart["container"],t=a(i),this.chartPosition={left:t.left,top:t.top,scaleX:1,scaleY:1},e=i.offsetWidth,i=i.offsetHeight,2<e&&2<i&&(this.chartPosition.scaleX=t.width/e,this.chartPosition.scaleY=t.height/i)),this.chartPosition}getCoordinates(e){const i={xAxis:[],yAxis:[]};return this.chart.axes.forEach(function(t){i[t.isXAxis?"xAxis":"yAxis"].push({axis:t,value:t.toValue(e[t.horiz?"chartX":"chartY"])})}),i}getHoverData(t,e,i,s,o,r){const a=[],n=!(!s||!t),l=function(t){return t.visible&&!(!o&&t.directTouch)&&C(t.options.enableMouseTracking,!0)};let h=e,d,c={chartX:r?r.chartX:void 0,chartY:r?r.chartY:void 0,shared:o};M(this,"beforeGetHoverData",c);s=h&&!h.stickyTracking;d=s?[h]:i.filter(t=>t.stickyTracking&&(c.filter||l)(t));const p=n||!r?t:this.findNearestKDPoint(d,o,r);return h=p&&p.series,p&&(o&&!h.noSharedTooltip?(d=i.filter(function(t){return c.filter?c.filter(t):l(t)&&!t.noSharedTooltip})).forEach(function(t){let e=b(t.points,function(t){return t.x===p.x&&!t.isNull});k(e)&&(t.boosted&&t.boost&&(e=t.boost.getPoint(e)),a.push(e))}):a.push(p)),c={hoverPoint:p},M(this,"afterGetHoverData",c),{hoverPoint:c.hoverPoint,hoverSeries:h,hoverPoints:a}}getPointFromEvent(t){let e=t.target,i;for(;e&&!i;)i=e.point,e=e.parentNode;return i}onTrackerMouseOut(t){var e=this.chart,t=t.relatedTarget,e=e.hoverSeries;this.isDirectTouch=!1,!e||!t||e.stickyTracking||this.inClass(t,"highcharts-tooltip")||this.inClass(t,"highcharts-series-"+e.index)&&this.inClass(t,"highcharts-tracker")||e.onMouseOut()}inClass(t,e){let i=t,s;for(;i;){if(s=o(i,"class")){if(-1!==s.indexOf(e))return!0;if(-1!==s.indexOf("highcharts-container"))return!1}i=i.parentElement}}constructor(t,e){this.hasDragged=!1,this.lastValidTouch={},this.pinchDown=[],this.eventsToUnbind=[],this.options=e,this.chart=t,this.runChartClick=Boolean(e.chart.events?.click),this.pinchDown=[],this.lastValidTouch={},this.setDOMEvents(),M(this,"afterInit")}normalize(t,e){var i=t.touches,i=i?i.length?i.item(0):C(i.changedTouches,t.changedTouches)[0]:t,s=(e=e||this.getChartPosition(),i.pageX-e.left),i=i.pageY-e.top;return s/=e.scaleX,i/=e.scaleY,y(t,{chartX:Math.round(s),chartY:Math.round(i)})}onContainerClick(t){var e=this.chart,i=e.hoverPoint,t=this.normalize(t),s=e.plotLeft,o=e.plotTop;e.cancelClick||(i&&this.inClass(t.target,"highcharts-tracker")?(M(i.series,"click",y(t,{point:i})),e.hoverPoint&&i.firePointEvent("click",t)):(y(t,this.getCoordinates(t)),e.isInsidePlot(t.chartX-s,t.chartY-o,{visiblePlotOnly:!0})&&M(e,"click",t)))}onContainerMouseDown(t){var e=1==(1&(t.buttons||t.button));t=this.normalize(t),s.isFirefox&&0!==t.button&&this.onContainerMouseMove(t),"undefined"!=typeof t.button&&!e||(this.zoomOption(t),e&&t.preventDefault&&t.preventDefault(),this.dragStart(t))}onContainerMouseLeave(t){var e=u[C(A.hoverChartIndex,-1)];t=this.normalize(t),this.onContainerMouseMove(t),e&&t.relatedTarget&&!this.inClass(t.relatedTarget,"highcharts-tooltip")&&(e.pointer.reset(),e.pointer.chartPosition=void 0)}onContainerMouseEnter(t){delete this.chartPosition}onContainerMouseMove(t){var e=this.chart,i=e.tooltip,s=this.normalize(t);this.setHoverChartIndex(t),"mousedown"!==e.mouseIsDown&&!this.touchSelect(s)||this.drag(s),e.openMenu||!this.inClass(s.target,"highcharts-tracker")&&!e.isInsidePlot(s.chartX-e.plotLeft,s.chartY-e.plotTop,{visiblePlotOnly:!0})||i&&i.shouldStickOnContact(s)||(this.inClass(s.target,"highcharts-no-tooltip")?this.reset(!1,0):this.runPointActions(s))}onDocumentTouchEnd(t){var e=u[C(A.hoverChartIndex,-1)];e&&e.pointer.drop(t)}onContainerTouchMove(t){this.touchSelect(t)?this.onContainerMouseMove(t):this.touch(t)}onContainerTouchStart(t){this.touchSelect(t)?this.onContainerMouseDown(t):(this.zoomOption(t),this.touch(t,!0))}onDocumentMouseMove(t){var e=this.chart,i=e.tooltip,s=this.chartPosition,t=this.normalize(t,s);!s||e.isInsidePlot(t.chartX-e.plotLeft,t.chartY-e.plotTop,{visiblePlotOnly:!0})||i&&i.shouldStickOnContact(t)||this.inClass(t.target,"highcharts-tracker")||this.reset()}onDocumentMouseUp(t){var e=u[C(A.hoverChartIndex,-1)];e&&e.pointer.drop(t)}pinch(t){const e=this,a=e.chart,i=e.pinchDown,s=t.touches||[],o=s.length,r=e.lastValidTouch,n=e.hasZoom,l={},h=1===o&&(e.inClass(t.target,"highcharts-tracker")&&a.runTrackerClick||e.runChartClick),d={},c=e.chart.tooltip,p=1===o&&C(c&&c.options.followTouchMove,!0);let u=e.selectionMarker;1<o?e.initiated=!0:p&&(e.initiated=!1),n&&e.initiated&&!h&&!1!==t.cancelable&&t.preventDefault(),[].map.call(s,function(t){return e.normalize(t)}),"touchstart"===t.type?([].forEach.call(s,function(t,e){i[e]={chartX:t.chartX,chartY:t.chartY}}),r.x=[i[0].chartX,i[1]&&i[1].chartX],r.y=[i[0].chartY,i[1]&&i[1].chartY],a.axes.forEach(function(t){var e,i,s,o,r;t.zoomEnabled&&(e=a.bounds[t.horiz?"h":"v"],i=t.minPixelPadding,r=t.toPixels(Math.min(C(t.options.min,t.dataMin),t.dataMin)),s=t.toPixels(Math.max(C(t.options.max,t.dataMax),t.dataMax)),o=Math.min(r,s),r=Math.max(r,s),e.min=Math.min(t.pos,o-i),e.max=Math.max(t.pos+t.len,r+i))}),e.res=!0):p?this.runPointActions(e.normalize(t)):i.length&&(M(a,"touchpan",{originalEvent:t},()=>{u||(e.selectionMarker=u=y({destroy:g,touch:!0},a.plotBox)),e.pinchTranslate(i,s,l,u,d,r),e.hasPinched=n,e.scaleGroups(l,d)}),e.res)&&(e.res=!1,this.reset(!1,0))}pinchTranslate(t,e,i,s,o,r){this.zoomHor&&this.pinchTranslateDirection(!0,t,e,i,s,o,r),this.zoomVert&&this.pinchTranslateDirection(!1,t,e,i,s,o,r)}pinchTranslateDirection(t,e,i,s,o,r,a,n){const l=this.chart,h=t?"x":"y",d=t?"X":"Y",c="chart"+d,p=t?"width":"height",u=l["plot"+(t?"Left":"Top")],g=l.inverted,f=l.bounds[t?"h":"v"],m=1===e.length,x=e[0][c],v=!m&&e[1][c],y=function(){"number"==typeof A&&20<Math.abs(x-v)&&(k=n||Math.abs(C-A)/Math.abs(x-v)),S=(u-C)/k+x,b=l["plot"+(t?"Width":"Height")]/k};let b,M,S,k=n||1,C=i[0][c],A=!m&&i[1][c],w;y(),(M=S)<f.min?(M=f.min,w=!0):M+b>f.max&&(M=f.max-b,w=!0),w?(C-=.8*(C-a[h][0]),"number"==typeof A&&(A-=.8*(A-a[h][1])),y()):a[h]=[C,A],g||(r[h]=S-u,r[p]=b);e=g?t?"scaleY":"scaleX":"scale"+d,i=g?1/k:k;o[p]=b,o[h]=M,s[e]=k*(g&&!t?-1:1),s["translate"+d]=i*u+(C-i*x)}reset(e,t){const i=this,s=i.chart,o=s.hoverSeries,r=s.hoverPoint,a=s.hoverPoints,n=s.tooltip,l=n&&n.shared?a:r;e&&l&&h(l).forEach(function(t){t.series.isCartesian&&"undefined"==typeof t.plotX&&(e=!1)}),e?n&&l&&h(l).length&&(n.refresh(l),n.shared&&a?a.forEach(function(t){t.setState(t.state,!0),t.series.isCartesian&&(t.series.xAxis.crosshair&&t.series.xAxis.drawCrosshair(null,t),t.series.yAxis.crosshair)&&t.series.yAxis.drawCrosshair(null,t)}):r&&(r.setState(r.state,!0),s.axes.forEach(function(t){t.crosshair&&r.series[t.coll]===t&&t.drawCrosshair(null,r)}))):(r&&r.onMouseOut(),a&&a.forEach(function(t){t.setState()}),o&&o.onMouseOut(),n&&n.hide(t),i.unDocMouseMove&&(i.unDocMouseMove=i.unDocMouseMove()),s.axes.forEach(function(t){t.hideCrosshair()}),i.hoverX=s.hoverPoints=s.hoverPoint=null)}runPointActions(s,t,e){const i=this,o=i.chart,r=o.series,a=o.tooltip&&o.tooltip.options.enabled?o.tooltip:void 0,n=!!a&&a.shared;let l=t||o.hoverPoint,h=l&&l.series||o.hoverSeries;var t=(!s||"touchmove"!==s.type)&&(!!t||h&&h.directTouch&&i.isDirectTouch),t=this.getHoverData(l,h,r,t,n,s);l=t.hoverPoint,h=t.hoverSeries;const d=t.hoverPoints,c=h&&h.tooltipOptions.followPointer&&!h.tooltipOptions.split,p=n&&h&&!h.noSharedTooltip;if(l&&(e||l!==o.hoverPoint||a&&a.isHidden)){if((o.hoverPoints||[]).forEach(function(t){-1===d.indexOf(t)&&t.setState()}),o.hoverSeries!==h&&h.onMouseOver(),i.applyInactiveState(d),(d||[]).forEach(function(t){t.setState("hover")}),o.hoverPoint&&o.hoverPoint.firePointEvent("mouseOut"),!l.series)return;o.hoverPoints=d,(o.hoverPoint=l).firePointEvent("mouseOver",void 0,()=>{a&&l&&a.refresh(p?d:l,s)})}else c&&a&&!a.isHidden&&(t=a.getAnchor([{}],s),o.isInsidePlot(t[0],t[1],{visiblePlotOnly:!0}))&&a.updatePosition({plotX:t[0],plotY:t[1]});i.unDocMouseMove||(i.unDocMouseMove=m(o.container.ownerDocument,"mousemove",function(t){var e=u[A.hoverChartIndex];e&&e.pointer.onDocumentMouseMove(t)}),i.eventsToUnbind.push(i.unDocMouseMove)),o.axes.forEach(function(e){var t=C((e.crosshair||{}).snap,!0);let i;(i=!t||(i=o.hoverPoint)&&i.series[e.coll]===e?i:b(d,t=>t.series&&t.series[e.coll]===e))||!t?e.drawCrosshair(s,i):e.hideCrosshair()})}scaleGroups(i,s){const o=this.chart;o.series.forEach(function(t){var e=i||t.getPlotBox("series");t.group&&(t.xAxis&&t.xAxis.zoomEnabled||o.mapView)&&(t.group.attr(e),t.markerGroup&&(t.markerGroup.attr(i||t.getPlotBox("marker")),t.markerGroup.clip(s?o.clipRect:null)),t.dataLabelsGroup)&&t.dataLabelsGroup.attr(e)}),o.clipRect.attr(s||o.clipBox)}setDOMEvents(){var t=this.chart.container,e=t.ownerDocument;t.onmousedown=this.onContainerMouseDown.bind(this),t.onmousemove=this.onContainerMouseMove.bind(this),t.onclick=this.onContainerClick.bind(this),this.eventsToUnbind.push(m(t,"mouseenter",this.onContainerMouseEnter.bind(this))),this.eventsToUnbind.push(m(t,"mouseleave",this.onContainerMouseLeave.bind(this))),A.unbindDocumentMouseUp||(A.unbindDocumentMouseUp=m(e,"mouseup",this.onDocumentMouseUp.bind(this)));let i=this.chart.renderTo.parentElement;for(;i&&"BODY"!==i.tagName;)this.eventsToUnbind.push(m(i,"scroll",()=>{delete this.chartPosition})),i=i.parentElement;s.hasTouch&&(this.eventsToUnbind.push(m(t,"touchstart",this.onContainerTouchStart.bind(this),{passive:!1})),this.eventsToUnbind.push(m(t,"touchmove",this.onContainerTouchMove.bind(this),{passive:!1})),A.unbindDocumentTouchEnd||(A.unbindDocumentTouchEnd=m(e,"touchend",this.onDocumentTouchEnd.bind(this),{passive:!1})))}setHoverChartIndex(t){var e=this.chart,i=s.charts[C(A.hoverChartIndex,-1)];i&&i!==e&&i.pointer.onContainerMouseLeave(t||{relatedTarget:e.container}),i&&i.mouseIsDown||(A.hoverChartIndex=e.index)}touch(t,e){var i=this.chart;let s,o;this.setHoverChartIndex(),1===t.touches.length?(t=this.normalize(t),i.isInsidePlot(t.chartX-i.plotLeft,t.chartY-i.plotTop,{visiblePlotOnly:!0})&&!i.openMenu?(e&&this.runPointActions(t),"touchmove"===t.type&&(o=this.pinchDown,s=!!o[0]&&4<=Math.sqrt(Math.pow(o[0].chartX-t.chartX,2)+Math.pow(o[0].chartY-t.chartY,2))),C(s,!0)&&this.pinch(t)):e&&this.reset()):2===t.touches.length&&this.pinch(t)}touchSelect(t){return Boolean(this.chart.zooming.singleTouch&&t.touches&&1===t.touches.length)}zoomOption(t){var e=this.chart,i=(e.options.chart,e.inverted);let s=e.zooming.type||"",o,r;/touch/.test(t.type)&&(s=C(e.zooming.pinchType,s)),this.zoomX=o=/x/.test(s),this.zoomY=r=/y/.test(s),this.zoomHor=o&&!i||r&&i,this.zoomVert=r&&!i||o&&i,this.hasZoom=o||r}}var l;return(l=A=A||{}).compose=function d(t){n(i,d)&&m(t,"beforeRender",function(){this.pointer=new l(this,this.options)})},A}),e(t,"Core/Legend/Legend.js",[t["Core/Animation/AnimationUtilities.js"],t["Core/Templating.js"],t["Core/Globals.js"],t["Core/Series/Point.js"],t["Core/Renderer/RendererUtilities.js"],t["Core/Utilities.js"]],function(t,e,i,p,s,o){const{animObject:d,setAnimation:c}=t,r=e["format"],{composed:a,marginNames:n}=i,h=s["distribute"],{addEvent:l,createElement:u,css:g,defined:f,discardElement:m,find:x,fireEvent:v,isNumber:y,merge:b,pick:S,pushUnique:M,relativeLength:k,stableSort:C,syncTimeout:A}=o;class w{constructor(t,e){this.allItems=[],this.initialItemY=0,this.itemHeight=0,this.itemMarginBottom=0,this.itemMarginTop=0,this.itemX=0,this.itemY=0,this.lastItemY=0,this.lastLineHeight=0,this.legendHeight=0,this.legendWidth=0,this.maxItemWidth=0,this.maxLegendWidth=0,this.offsetWidth=0,this.padding=0,this.pages=[],this.symbolHeight=0,this.symbolWidth=0,this.titleHeight=0,this.totalItemWidth=0,this.widthOption=0,this.chart=t,this.setOptions(e),e.enabled&&(this.render(),l(this.chart,"endResize",function(){this.legend.positionCheckboxes()})),l(this.chart,"render",()=>{this.options.enabled&&this.proximate&&(this.proximatePositions(),this.positionItems())})}setOptions(t){var e=S(t.padding,8);this.options=t,this.chart.styledMode||(this.itemStyle=t.itemStyle,this.itemHiddenStyle=b(this.itemStyle,t.itemHiddenStyle)),this.itemMarginTop=t.itemMarginTop,this.itemMarginBottom=t.itemMarginBottom,this.padding=e,this.initialItemY=e-5,this.symbolWidth=S(t.symbolWidth,16),this.pages=[],this.proximate="proximate"===t.layout&&!this.chart.inverted,this.baseline=void 0}update(t,e){var i=this.chart;this.setOptions(b(!0,this.options,t)),this.destroy(),i.isDirtyLegend=i.isDirtyBox=!0,S(e,!0)&&i.redraw(),v(this,"afterUpdate",{redraw:e})}colorizeItem(t,e){var{area:i,group:s,label:o,line:r,symbol:a}=t.legendItem||{};if(s?.[e?"removeClass":"addClass"]("highcharts-legend-item-hidden"),!this.chart.styledMode){const{itemHiddenStyle:n={}}=this,l=n.color,{fillColor:h,fillOpacity:d,lineColor:c,marker:p}=t.options,u=t=>(e||(t.fill&&(t.fill=l),t.stroke&&(t.stroke=l)),t);o?.css(b(e?this.itemStyle:n)),r?.attr(u({stroke:c||t.color})),a&&a.attr(u(p&&a.isMarker?t.pointAttribs():{fill:t.color})),i?.attr(u({fill:h||t.color,"fill-opacity":h?1:d??.75}))}v(this,"afterColorizeItem",{item:t,visible:e})}positionItems(){this.allItems.forEach(this.positionItem,this),this.chart.isResizing||this.positionCheckboxes()}positionItem(t){var{group:e,x:i=0,y:s=0}=t.legendItem||{},o=this.options,r=o.symbolPadding,o=!o.rtl,a=t.checkbox;e&&e.element&&(o={translateX:o?i:this.legendWidth-i-2*r-4,translateY:s},e[f(e.translateY)?"animate":"attr"](o,void 0,()=>{v(this,"afterPositionItem",{item:t})})),a&&(a.x=i,a.y=s)}destroyItem(t){var e=t.checkbox,i=t.legendItem||{};for(const s of["group","label","line","symbol"])i[s]&&(i[s]=i[s].destroy());e&&m(e),t.legendItem=void 0}destroy(){for(const t of this.getAllItems())this.destroyItem(t);for(const e of["clipRect","up","down","pager","nav","box","title","group"])this[e]&&(this[e]=this[e].destroy());this.display=null}positionCheckboxes(){const s=this.group&&this.group.alignAttr,o=this.clipHeight||this.legendHeight,r=this.titleHeight;let a;s&&(a=s.translateY,this.allItems.forEach(function(t){var e,i=t.checkbox;i&&(e=a+r+i.y+(this.scrollOffset||0)+3,g(i,{left:s.translateX+t.checkboxOffset+i.x-20+"px",top:e+"px",display:this.proximate||e>a-6&&e<a+o-6?"":"none"}))},this))}renderTitle(){var t=this.options,e=this.padding,i=t.title;let s,o=0;i.text&&(this.title||(this.title=this.chart.renderer.label(i.text,e-3,e-4,void 0,void 0,void 0,t.useHTML,void 0,"legend-title").attr({zIndex:1}),this.chart.styledMode||this.title.css(i.style),this.title.add(this.group)),i.width||this.title.css({width:this.maxLegendWidth+"px"}),s=this.title.getBBox(),o=s.height,this.offsetWidth=s.width,this.contentGroup.attr({translateY:o})),this.titleHeight=o}setText(t){var e=this.options;t.legendItem.label.attr({text:e.labelFormat?r(e.labelFormat,t,this.chart):e.labelFormatter.call(t)})}renderItem(t){var e=this,i=t.legendItem=t.legendItem||{},s=e.chart,o=s.renderer,r=e.options,a="horizontal"===r.layout,n=e.symbolWidth,l=r.symbolPadding||0,h=e.itemStyle,d=e.itemHiddenStyle,a=a?S(r.itemDistance,20):0,c=!r.rtl,p=!t.series,u=!p&&t.series.drawLegendSymbol?t.series:t,g=u.options,g=!!e.createCheckboxForItem&&g&&g.showCheckbox,f=r.useHTML,m=t.options.className;let x=i.label,v=n+l+a+(g?20:0);x||(i.group=o.g("legend-item").addClass("highcharts-"+u.type+"-series highcharts-color-"+t.colorIndex+(m?" "+m:"")+(p?" highcharts-series-"+t.index:"")).attr({zIndex:1}).add(e.scrollGroup),i.label=x=o.text("",c?n+l:-l,e.baseline||0,f),s.styledMode||x.css(b(t.visible?h:d)),x.attr({align:c?"left":"right",zIndex:2}).add(i.group),e.baseline||(e.fontMetrics=o.fontMetrics(x),e.baseline=e.fontMetrics.f+3+e.itemMarginTop,x.attr("y",e.baseline),e.symbolHeight=S(r.symbolHeight,e.fontMetrics.f),r.squareSymbol&&(e.symbolWidth=S(r.symbolWidth,Math.max(e.symbolHeight,16)),v=e.symbolWidth+l+a+(g?20:0),c)&&x.attr("x",e.symbolWidth+l)),u.drawLegendSymbol(e,t),e.setItemEvents&&e.setItemEvents(t,x,f)),g&&!t.checkbox&&e.createCheckboxForItem&&e.createCheckboxForItem(t),e.colorizeItem(t,t.visible),!s.styledMode&&h.width||x.css({width:(r.itemWidth||e.widthOption||s.spacingBox.width)-v+"px"}),e.setText(t);m=x.getBBox(),p=e.fontMetrics&&e.fontMetrics.h||0;t.itemWidth=t.checkboxOffset=r.itemWidth||i.labelWidth||m.width+v,e.maxItemWidth=Math.max(e.maxItemWidth,t.itemWidth),e.totalItemWidth+=t.itemWidth,e.itemHeight=t.itemHeight=Math.round(i.labelHeight||(m.height>1.5*p?m.height:p))}layoutItem(t){var e=this.options,i=this.padding,s="horizontal"===e.layout,o=t.itemHeight,r=this.itemMarginBottom,a=this.itemMarginTop,n=s?S(e.itemDistance,20):0,l=this.maxLegendWidth,e=e.alignColumns&&this.totalItemWidth>l?this.maxItemWidth:t.itemWidth,h=t.legendItem||{};s&&this.itemX-i+e>l&&(this.itemX=i,this.lastLineHeight&&(this.itemY+=a+this.lastLineHeight+r),this.lastLineHeight=0),this.lastItemY=a+this.itemY+r,this.lastLineHeight=Math.max(o,this.lastLineHeight),h.x=this.itemX,h.y=this.itemY,s?this.itemX+=e:(this.itemY+=a+o+r,this.lastLineHeight=o),this.offsetWidth=this.widthOption||Math.max((s?this.itemX-i-(t.checkbox?0:n):e)+i,this.offsetWidth)}getAllItems(){let i=[];return this.chart.series.forEach(function(t){var e=t&&t.options;t&&S(e.showInLegend,!f(e.linkedTo)&&void 0,!0)&&(i=i.concat((t.legendItem||{}).labels||("point"===e.legendType?t.data:t)))}),v(this,"afterGetAllItems",{allItems:i}),i}getAlignment(){var t=this.options;return this.proximate?t.align.charAt(0)+"tv":t.floating?"":t.align.charAt(0)+t.verticalAlign.charAt(0)+t.layout.charAt(0)}adjustMargins(i,s){const o=this.chart,r=this.options,a=this.getAlignment();a&&[/(lth|ct|rth)/,/(rtv|rm|rbv)/,/(rbh|cb|lbh)/,/(lbv|lm|ltv)/].forEach(function(t,e){t.test(a)&&!f(i[e])&&(o[n[e]]=Math.max(o[n[e]],o.legend[(e+1)%2?"legendHeight":"legendWidth"]+[1,-1,-1,1][e]*r[e%2?"x":"y"]+S(r.margin,12)+s[e]+(o.titleOffset[e]||0)))})}proximatePositions(){const a=this.chart,n=[],l="left"===this.options.align;var t;this.allItems.forEach(function(t){let e,i,s=l,o,r;t.yAxis&&(t.xAxis.options.reversed&&(s=!s),t.points&&(e=x(s?t.points:t.points.slice(0).reverse(),function(t){return y(t.plotY)})),i=this.itemMarginTop+t.legendItem.label.getBBox().height+this.itemMarginBottom,r=t.yAxis.top-a.plotTop,t.visible?(o=e?e.plotY:t.yAxis.height,o+=r-.3*i):o=r+t.yAxis.height,n.push({target:o,size:i,item:t}))},this);for(const e of h(n,a.plotHeight))t=e.item.legendItem||{},y(e.pos)&&(t.y=a.plotTop-a.spacing[0]+e.pos)}render(){var t=this,e=t.chart,i=e.renderer,s=t.options,o=t.padding,r=t.getAllItems();let a,n,l,h=t.group,d,c=t.box;t.itemX=o,t.itemY=t.initialItemY,t.offsetWidth=0,t.lastItemY=0,t.widthOption=k(s.width,e.spacingBox.width-o),d=e.spacingBox.width-2*o-s.x,-1<["rm","lm"].indexOf(t.getAlignment().substring(0,2))&&(d/=2),t.maxLegendWidth=t.widthOption||d,h||(t.group=h=i.g("legend").addClass(s.className||"").attr({zIndex:7}).add(),t.contentGroup=i.g().attr({zIndex:1}).add(h),t.scrollGroup=i.g().add(t.contentGroup)),t.renderTitle(),C(r,(t,e)=>(t.options&&t.options.legendIndex||0)-(e.options&&e.options.legendIndex||0)),s.reversed&&r.reverse(),t.allItems=r,t.display=a=!!r.length,t.lastLineHeight=0,t.maxItemWidth=0,t.totalItemWidth=0,t.itemHeight=0,r.forEach(t.renderItem,t),r.forEach(t.layoutItem,t),n=(t.widthOption||t.offsetWidth)+o,l=t.lastItemY+t.lastLineHeight+t.titleHeight,l=t.handleOverflow(l),l+=o,c||(t.box=c=i.rect().addClass("highcharts-legend-box").attr({r:s.borderRadius}).add(h)),e.styledMode||c.attr({stroke:s.borderColor,"stroke-width":s.borderWidth||0,fill:s.backgroundColor||"none"}).shadow(s.shadow),0<n&&0<l&&c[c.placed?"animate":"attr"](c.crisp.call({},{x:0,y:0,width:n,height:l},c.strokeWidth())),h[a?"show":"hide"](),e.styledMode&&"none"===h.getStyle("display")&&(n=l=0),t.legendWidth=n,t.legendHeight=l,a&&t.align(),this.proximate||this.positionItems(),v(this,"afterRender")}align(t=this.chart.spacingBox){var e=this.chart,i=this.options;let s=t.y;/(lth|ct|rth)/.test(this.getAlignment())&&0<e.titleOffset[0]?s+=e.titleOffset[0]:/(lbh|cb|rbh)/.test(this.getAlignment())&&0<e.titleOffset[2]&&(s-=e.titleOffset[2]),s!==t.y&&(t=b(t,{y:s})),e.hasRendered||(this.group.placed=!1),this.group.align(b(i,{width:this.legendWidth,height:this.legendHeight,verticalAlign:this.proximate?"top":i.verticalAlign}),!0,t)}handleOverflow(t){const e=this,i=this.chart,s=i.renderer,o=this.options,r=o.y,a="top"===o.verticalAlign,n=this.padding,l=o.maxHeight,h=o.navigation,d=S(h.animation,!0),c=h.arrowSize||12,p=this.pages,u=this.allItems,g=function(t){"number"==typeof t?M.attr({height:t}):M&&(e.clipRect=M.destroy(),e.contentGroup.clip()),e.contentGroup.div&&(e.contentGroup.div.style.clip=t?"rect("+n+"px,9999px,"+(n+t)+"px,0)":"auto")},f=function(t){return e[t]=s.circle(0,0,1.3*c).translate(c/2,c/2).add(b),i.styledMode||e[t].attr("fill","rgba(0,0,0,0.0001)"),e[t]};let m,x,v,y=i.spacingBox.height+(a?-r:r)-n,b=this.nav,M=this.clipRect;return"horizontal"!==o.layout||"middle"===o.verticalAlign||o.floating||(y/=2),l&&(y=Math.min(y,l)),p.length=0,t&&0<y&&t>y&&!1!==h.enabled?(this.clipHeight=m=Math.max(y-20-this.titleHeight-n,0),this.currentPage=S(this.currentPage,1),this.fullHeight=t,u.forEach((t,e)=>{var t=(v=t.legendItem||{}).y||0,i=Math.round(v.label.getBBox().height);let s=p.length;(!s||t-p[s-1]>m&&(x||t)!==p[s-1])&&(p.push(x||t),s++),v.pageIx=s-1,x&&((u[e-1].legendItem||{}).pageIx=s-1),e===u.length-1&&t+i-p[s-1]>m&&t>p[s-1]&&(p.push(t),v.pageIx=s),t!==x&&(x=t)}),M||(M=e.clipRect=s.clipRect(0,n-2,9999,0),e.contentGroup.clip(M)),g(m),b||(this.nav=b=s.g().attr({zIndex:1}).add(this.group),this.up=s.symbol("triangle",0,0,c,c).add(b),f("upTracker").on("click",function(){e.scroll(-1,d)}),this.pager=s.text("",15,10).addClass("highcharts-legend-navigation"),!i.styledMode&&h.style&&this.pager.css(h.style),this.pager.add(b),this.down=s.symbol("triangle-down",0,0,c,c).add(b),f("downTracker").on("click",function(){e.scroll(1,d)})),e.scroll(0),t=y):b&&(g(),this.nav=b.destroy(),this.scrollGroup.attr({translateY:1}),this.clipHeight=0),t}scroll(t,e){const i=this.chart,s=this.pages,o=s.length,r=this.clipHeight,a=this.options.navigation,n=this.pager,l=this.padding;let h=this.currentPage+t;0<(h=h>o?o:h)&&(void 0!==e&&c(e,i),this.nav.attr({translateX:l,translateY:r+this.padding+7+this.titleHeight,visibility:"inherit"}),[this.up,this.upTracker].forEach(function(t){t.attr({"class":1===h?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"})}),n.attr({text:h+"/"+o}),[this.down,this.downTracker].forEach(function(t){t.attr({x:18+this.pager.getBBox().width,"class":h===o?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"})},this),i.styledMode||(this.up.attr({fill:1===h?a.inactiveColor:a.activeColor}),this.upTracker.css({cursor:1===h?"default":"pointer"}),this.down.attr({fill:h===o?a.inactiveColor:a.activeColor}),this.downTracker.css({cursor:h===o?"default":"pointer"})),this.scrollOffset=-s[h-1]+this.initialItemY,this.scrollGroup.animate({translateY:this.scrollOffset}),this.currentPage=h,this.positionCheckboxes(),t=d(S(e,i.renderer.globalAnimation,!0)),A(()=>{v(this,"afterScroll",{currentPage:h})},t.duration))}setItemEvents(s,t,e){const i=this,o=s.legendItem||{},r=i.chart.renderer.boxWrapper,a=s instanceof p,n="highcharts-legend-"+(a?"point":"series")+"-active",l=i.chart.styledMode,h=e?[t,o.symbol]:[o.group],d=e=>{i.allItems.forEach(t=>{s!==t&&[t].concat(t.linkedSeries||[]).forEach(t=>{t.setState(e,!a)})})};for(const c of h)c&&c.on("mouseover",function(){s.visible&&d("inactive"),s.setState("hover"),s.visible&&r.addClass(n),l||t.css(i.options.itemHoverStyle)}).on("mouseout",function(){i.chart.styledMode||t.css(b(s.visible?i.itemStyle:i.itemHiddenStyle)),d(""),r.removeClass(n),s.setState()}).on("click",function(t){var e="legendItemClick",i=function(){s.setVisible&&s.setVisible(),d(s.visible?"inactive":"")};r.removeClass(n),t={browserEvent:t},s.firePointEvent?s.firePointEvent(e,t,i):v(s,e,t,i)})}createCheckboxForItem(e){e.checkbox=u("input",{type:"checkbox",className:"highcharts-legend-checkbox",checked:e.selected,defaultChecked:e.selected},this.options.itemCheckboxStyle,this.chart.container),l(e.checkbox,"click",function(t){t=t.target;v(e.series||e,"checkboxClick",{checked:t.checked,item:e},function(){e.select()})})}}var T;return(T=w=w||{}).compose=function P(t){M(a,P)&&l(t,"beforeMargins",function(){this.legend=new T(this,this.options.legend)})},w}),e(t,"Core/Legend/LegendSymbol.js",[t["Core/Utilities.js"]],function(t){const{extend:x,merge:v,pick:y}=t;var e;function i(t,e,i){var s=this.legendItem=this.legendItem||{},{chart:o,options:r}=this,{baseline:t=0,symbolWidth:a,symbolHeight:n}=t,l=this.symbol||"circle",h=n/2,d=o.renderer,c=s.group,p=t-Math.round(n*(i?.4:.3)),u={};let g,f=r.marker,m=0;if(o.styledMode||(u["stroke-width"]=Math.min(r.lineWidth||0,24),r.dashStyle?u.dashstyle=r.dashStyle:"square"!==r.linecap&&(u["stroke-linecap"]="round")),s.line=d.path().addClass("highcharts-graph").attr(u).add(c),i&&(s.area=d.path().addClass("highcharts-area").add(c)),u["stroke-linecap"]&&(m=Math.min(s.line.strokeWidth(),a)/2),a&&(o=[["M",m,p],["L",a-m,p]],s.line.attr({d:o}),s.area?.attr({d:[...o,["L",a-m,t],["L",m,t]]})),f&&!1!==f.enabled&&a){let t=Math.min(y(f.radius,h),h);0===l.indexOf("url")&&(f=v(f,{width:n,height:n}),t=0),s.symbol=g=d.symbol(l,a/2-t,p-t,2*t,2*t,x({context:"legend"},f)).addClass("highcharts-point").add(c),g.isMarker=!0}}return(t=e=e||{}).areaMarker=function(t,e){i.call(this,t,e,!0)},t.lineMarker=i,t.rectangle=function(t,e){var e=e.legendItem||{},i=t.options,s=t.symbolHeight,o=(i=i.squareSymbol)?s:t.symbolWidth;e.symbol=this.chart.renderer.rect(i?(t.symbolWidth-s)/2:0,t.baseline-s+1,o,s,y(t.options.symbolRadius,s/2)).addClass("highcharts-point").attr({zIndex:3}).add(e.group)},e}),e(t,"Core/Series/SeriesDefaults.js",[],function(){return{lineWidth:2,allowPointSelect:!1,crisp:!0,showCheckbox:!1,animation:{duration:1e3},enableMouseTracking:!0,events:{},marker:{enabledThreshold:2,lineColor:"#ffffff",lineWidth:0,radius:4,states:{normal:{animation:!0},hover:{animation:{duration:150},enabled:!0,radiusPlus:2,lineWidthPlus:1},select:{fillColor:"#cccccc",lineColor:"#000000",lineWidth:2}}},point:{events:{}},dataLabels:{animation:{},align:"center",borderWidth:0,defer:!0,formatter:function(){var t=this.series.chart["numberFormatter"];return"number"!=typeof this.y?"":t(this.y,-1)},padding:5,style:{fontSize:"0.7em",fontWeight:"bold",color:"contrast",textOutline:"1px contrast"},verticalAlign:"bottom",x:0,y:0},cropThreshold:300,opacity:1,pointRange:0,softThreshold:!0,states:{normal:{animation:!0},hover:{animation:{duration:150},lineWidthPlus:1,marker:{},halo:{size:10,opacity:.25}},select:{animation:{duration:0}},inactive:{animation:{duration:150},opacity:.2}},stickyTracking:!0,turboThreshold:1e3,findNearestPointBy:"x"}}),e(t,"Core/Series/SeriesRegistry.js",[t["Core/Globals.js"],t["Core/Defaults.js"],t["Core/Series/Point.js"],t["Core/Utilities.js"]],function(t,e,a,i){const n=e["defaultOptions"],{extendClass:l,merge:h}=i;var s,d;function c(t,e){var i=n.plotOptions||{},s=e.defaultOptions,o=e.prototype;o.type=t,o.pointClass||(o.pointClass=a),s&&(i[t]=s),d.seriesTypes[t]=e}return(d=s=s||{}).seriesTypes=t.seriesTypes,d.registerSeriesType=c,d.seriesType=function(t,e,i,s,o){var r=n.plotOptions||{};return e=e||"",r[t]=h(r[e],i),c(t,l(d.seriesTypes[e]||function(){},s)),d.seriesTypes[t].prototype.type=t,o&&(d.seriesTypes[t].prototype.pointClass=l(a,o)),d.seriesTypes[t]},s}),e(t,"Core/Series/Series.js",[t["Core/Animation/AnimationUtilities.js"],t["Core/Defaults.js"],t["Core/Foundation.js"],t["Core/Globals.js"],t["Core/Legend/LegendSymbol.js"],t["Core/Series/Point.js"],t["Core/Series/SeriesDefaults.js"],t["Core/Series/SeriesRegistry.js"],t["Core/Renderer/SVG/SVGElement.js"],t["Core/Utilities.js"]],function(t,e,i,s,o,h,r,a,d,c){const{animObject:p,setAnimation:u}=t,g=e["defaultOptions"],n=i["registerEventOptions"],{hasTouch:f,svg:m,win:x}=s,v=a["seriesTypes"],{arrayMax:y,arrayMin:b,clamp:A,correctFloat:w,defined:T,destroyObjectProperties:R,diffObjects:z,erase:M,error:P,extend:S,find:G,fireEvent:O,getClosestDistance:N,getNestedProperty:l,insertItem:k,isArray:L,isNumber:E,isString:W,merge:D,objectEach:C,pick:B,removeEvent:X,splat:H,syncTimeout:j}=c;class I{constructor(){this.zoneAxis="y"}init(t,e){O(this,"init",{options:e});const i=this,s=t.series;this.eventsToUnbind=[],i.chart=t,i.options=i.setOptions(e);var e=i.options,o=!1!==e.visible,o=(i.linkedSeries=[],i.bindAxes(),S(i,{name:e.name,state:"",visible:o,selected:!0===e.selected}),n(this,e),e.events);(o&&o.click||e.point&&e.point.events&&e.point.events.click||e.allowPointSelect)&&(t.runTrackerClick=!0),i.getColor(),i.getSymbol(),i.parallelArrays.forEach(function(t){i[t+"Data"]||(i[t+"Data"]=[])}),i.isCartesian&&(t.hasCartesianSeries=!0);let r;s.length&&(r=s[s.length-1]),i._i=B(r&&r._i,-1)+1,i.opacity=i.options.opacity,t.orderItems("series",k(this,s)),e.dataSorting&&e.dataSorting.enabled?i.setDataSortingOptions():i.points||i.data||i.setData(e.data,!1),O(this,"afterInit")}is(t){return v[t]&&this instanceof v[t]}bindAxes(){const i=this,s=i.options,t=i.chart;let o;O(this,"bindAxes",null,function(){(i.axisTypes||[]).forEach(function(e){t[e].forEach(function(t){o=t.options,(B(s[e],0)===t.index||"undefined"!=typeof s[e]&&s[e]===o.id)&&(k(i,t.series),(i[e]=t).isDirty=!0)}),i[e]||i.optionalAxis===e||P(18,!0,t)})}),O(this,"afterBindAxes")}updateParallelArrays(i,s,e){const o=i.series,t=E(s)?function(t){var e="y"===t&&o.toYData?o.toYData(i):i[t];o[t+"Data"][s]=e}:function(t){Array.prototype[s].apply(o[t+"Data"],e)};o.parallelArrays.forEach(t)}hasData(){return this.visible&&"undefined"!=typeof this.dataMax&&"undefined"!=typeof this.dataMin||this.visible&&this.yData&&0<this.yData.length}hasMarkerChanged(t,e){t=t.marker,e=e.marker||{};return t&&(e.enabled&&!t.enabled||e.symbol!==t.symbol||e.height!==t.height||e.width!==t.width)}autoIncrement(t){var e=this.options,i=e.pointIntervalUnit,s=e.relativeXValue,o=this.chart.time;let r=this.xIncrement,a,n;return r=B(r,e.pointStart,0),this.pointInterval=n=B(this.pointInterval,e.pointInterval,1),s&&E(t)&&(n*=t),i&&(a=new o.Date(r),"day"===i?o.set("Date",a,o.get("Date",a)+n):"month"===i?o.set("Month",a,o.get("Month",a)+n):"year"===i&&o.set("FullYear",a,o.get("FullYear",a)+n),n=a.getTime()-r),s&&E(t)?r+n:(this.xIncrement=r+n,r)}setDataSortingOptions(){var t=this.options;S(this,{requireSorting:!1,sorted:!1,enabledDataSorting:!0,allowDG:!1}),T(t.pointRange)||(t.pointRange=1)}setOptions(t){var e=this.chart,i=e.options.plotOptions,s=e.userOptions||{},t=D(t),o=e.styledMode,r={plotOptions:i,userOptions:t},a=(O(this,"setOptions",r),r.plotOptions[this.type]),s=s.plotOptions||{},n=s.series||{},l=g.plotOptions[this.type]||{},h=s[this.type]||{},r=(this.userOptions=r.userOptions,D(a,i.series,h,t)),i=(this.tooltipOptions=D(g.tooltip,g.plotOptions.series?.tooltip,l?.tooltip,e.userOptions.tooltip,s.series?.tooltip,h.tooltip,t.tooltip),this.stickyTracking=B(t.stickyTracking,h.stickyTracking,n.stickyTracking,!(!this.tooltipOptions.shared||this.noSharedTooltip)||r.stickyTracking),null===a.marker&&delete r.marker,this.zoneAxis=r.zoneAxis||"y",this.zones=(r.zones||[]).slice());return!r.negativeColor&&!r.negativeFillColor||r.zones||(l={value:r[this.zoneAxis+"Threshold"]||r.threshold||0,className:"highcharts-negative"},o||(l.color=r.negativeColor,l.fillColor=r.negativeFillColor),i.push(l)),i.length&&T(i[i.length-1].value)&&i.push(o?{}:{color:this.color,fillColor:this.fillColor}),O(this,"afterSetOptions",{options:r}),r}getName(){return B(this.options.name,"Series "+(this.index+1))}getCyclic(t,e,i){var s=this.chart,o=t+"Index",r=t+"Counter",a=i?.length||s.options.chart.colorCount;let n,l;e||(l=B("color"===t?this.options.colorIndex:void 0,this[o]),T(l)?n=l:(s.series.length||(s[r]=0),n=s[r]%a,s[r]+=1),i&&(e=i[n])),void 0!==n&&(this[o]=n),this[t]=e}getColor(){this.chart.styledMode?this.getCyclic("color"):this.options.colorByPoint?this.color="#cccccc":this.getCyclic("color",this.options.color||g.plotOptions[this.type].color,this.chart.options.colors)}getPointsCollection(){return(this.hasGroupedData?this.points:this.data)||[]}getSymbol(){var t=this.options.marker;this.getCyclic("symbol",t.symbol,this.chart.options.symbols)}findPointIndex(e,t){var i=e.id,s=e.x,o=this.points,r=this.options.dataSorting;let a,n,l;if(i){i=this.chart.get(i);i instanceof h&&(a=i)}else if(this.linkedParent||this.enabledDataSorting||this.options.relativeXValue){let t=t=>!t.touched&&t.index===e.index;if(r&&r.matchByName?t=t=>!t.touched&&t.name===e.name:this.options.relativeXValue&&(t=t=>!t.touched&&t.options.x===e.x),!(a=G(o,t)))return}return a&&void 0!==(l=a&&a.index)&&(n=!0),-1!==(l=void 0===l&&E(s)?this.xData.indexOf(s,t):l)&&void 0!==l&&this.cropped&&(l=l>=this.cropStart?l-this.cropStart:l),l=!n&&E(l)&&o[l]&&o[l].touched?void 0:l}updateData(t,e){const o=this.options,r=o.dataSorting,a=this.points,n=[],l=this.requireSorting,h=t.length===a.length;let d,i,s,c,p=!0;if(this.xIncrement=null,t.forEach(function(t,e){var i=T(t)&&this.pointClass.prototype.optionsToObject.call({series:this},t)||{},s=i.x;i.id||E(s)?(-1===(s=this.findPointIndex(i,c))||void 0===s?n.push(t):a[s]&&t!==o.data[s]?(a[s].update(t,!1,null,!1),a[s].touched=!0,l&&(c=s+1)):a[s]&&(a[s].touched=!0),(!h||e!==s||r&&r.enabled||this.hasDerivedData)&&(d=!0)):n.push(t)},this),d)for(i=a.length;i--;)(s=a[i])&&!s.touched&&s.remove&&s.remove(!1,e);else!h||r&&r.enabled?p=!1:(t.forEach(function(t,e){t===a[e].y||a[e].destroyed||a[e].update(t,!1,null,!1)}),n.length=0);return a.forEach(function(t){t&&(t.touched=!1)}),!!p&&(n.forEach(function(t){this.addPoint(t,!1,null,null,!1)},this),null===this.xIncrement&&this.xData&&this.xData.length&&(this.xIncrement=y(this.xData),this.autoIncrement()),!0)}setData(t,e=!0,i,s){const o=this,r=o.points,a=r&&r.length||0,n=o.options,l=o.chart,h=n.dataSorting,d=o.xAxis,c=n.turboThreshold,p=this.xData,u=this.yData,g=o.pointArrayMap,f=g&&g.length,m=n.keys;let x,v,y,b=0,M=1,S,k;l.options.chart.allowMutatingData||(n.data&&delete o.options.data,o.userOptions.data&&delete o.userOptions.data,k=D(!0,t));var C=(t=k||t||[]).length;if(h&&h.enabled&&(t=this.sortData(t)),!(y=l.options.chart.allowMutatingData&&!1!==s&&C&&a&&!o.cropped&&!o.hasGroupedData&&o.visible&&!o.boosted?this.updateData(t,i):y)){if(o.xIncrement=null,o.colorCounter=0,this.parallelArrays.forEach(function(t){o[t+"Data"].length=0}),c&&c<C)if(S=o.getFirstValidPoint(t),E(S))for(x=0;x<C;x++)p[x]=this.autoIncrement(),u[x]=t[x];else if(L(S))if(f)if(S.length===f)for(x=0;x<C;x++)p[x]=this.autoIncrement(),u[x]=t[x];else for(x=0;x<C;x++)v=t[x],p[x]=v[0],u[x]=v.slice(1,f+1);else if(m&&(b=m.indexOf("x"),M=m.indexOf("y"),b=0<=b?b:0,M=0<=M?M:1),1===S.length&&(M=0),b===M)for(x=0;x<C;x++)p[x]=this.autoIncrement(),u[x]=t[x][M];else for(x=0;x<C;x++)v=t[x],p[x]=v[b],u[x]=v[M];else P(12,!1,l);else for(x=0;x<C;x++)v={series:o},o.pointClass.prototype.applyOptions.apply(v,[t[x]]),o.updateParallelArrays(v,x);for(u&&W(u[0])&&P(14,!0,l),o.data=[],o.options.data=o.userOptions.data=t,x=a;x--;)r[x]?.destroy();d&&(d.minRange=d.userMinRange),o.isDirty=l.isDirtyBox=!0,o.isDirtyData=!!r,i=!1}"point"===n.legendType&&(this.processData(),this.generatePoints()),e&&l.redraw(i)}sortData(o){const i=this,t=i.options,e=t.dataSorting,s=e.sortKey||"y",r=function(t,e){return T(e)&&t.pointClass.prototype.optionsToObject.call({series:t},e)||{}};return o.forEach(function(t,e){o[e]=r(i,t),o[e].index=e},this),o.concat().sort((t,e)=>{t=l(s,t),e=l(s,e);return e<t?-1:t<e?1:0}).forEach(function(t,e){t.x=e},this),i.linkedSeries&&i.linkedSeries.forEach(function(i){const t=i.options,s=t.data;t.dataSorting&&t.dataSorting.enabled||!s||(s.forEach(function(t,e){s[e]=r(i,t),o[e]&&(s[e].x=o[e].x,s[e].index=e)}),i.setData(s,!1))}),o}getProcessedData(t){const e=this,i=e.xAxis,s=e.options,o=s.cropThreshold,r=t||e.getExtremesFromAll||s.getExtremesFromAll,a=i?.logarithmic,n=e.isCartesian;let l,h,d=0,c,p,u,g=e.xData,f=e.yData,m=!1;t=g.length,i&&(c=i.getExtremes(),p=c.min,u=c.max,m=!(!i.categories||i.names.length)),n&&e.sorted&&!r&&(!o||o<t||e.forceCrop)&&(g[t-1]<p||g[0]>u?(g=[],f=[]):e.yData&&(g[0]<p||g[t-1]>u)&&(l=this.cropData(e.xData,e.yData,p,u),g=l.xData,f=l.yData,d=l.start,h=!0)),t=N([a?g.map(a.log2lin):g],()=>e.requireSorting&&!m&&P(15,!1,e.chart));return{xData:g,yData:f,cropped:h,cropStart:d,closestPointRange:t}}processData(t){var e=this,i=e.xAxis;if(e.isCartesian&&!e.isDirty&&!i.isDirty&&!e.yAxis.isDirty&&!t)return!1;i=e.getProcessedData();e.cropped=i.cropped,e.cropStart=i.cropStart,e.processedXData=i.xData,e.processedYData=i.yData,e.closestPointRange=e.basePointRange=i.closestPointRange,O(e,"afterProcessData")}cropData(t,e,i,s){var o=t.length;let r,a,n=0,l=o;for(r=0;r<o;r++)if(t[r]>=i){n=Math.max(0,r-1);break}for(a=r;a<o;a++)if(t[a]>s){l=a+1;break}return{xData:t.slice(n,l),yData:e.slice(n,l),start:n,end:l}}generatePoints(){var t=this,e=t.options,i=t.processedData||e.data,s=t.processedXData,o=t.processedYData,r=t.pointClass,a=s.length,n=t.cropStart||0,l=t.hasGroupedData,h=e.keys,d=[],c=e.dataGrouping&&e.dataGrouping.groupAll?n:0;let p,u,g,f,m=t.data;for(m||l||((e=[]).length=i.length,m=t.data=e),h&&l&&(t.options.keys=!1),f=0;f<a;f++)u=n+f,l?((g=new r(t,[s[f]].concat(H(o[f])))).dataGroup=t.groupMap[c+f],g.dataGroup.options&&(g.options=g.dataGroup.options,S(g,g.dataGroup.options),delete g.dataLabels)):(g=m[u])||"undefined"==typeof i[u]||(m[u]=g=new r(t,i[u],s[f])),g&&(g.index=l?c+f:u,d[f]=g);if(t.options.keys=h,m&&(a!==(p=m.length)||l))for(f=0;f<p;f++)f!==n||l||(f+=a),m[f]&&(m[f].destroyElements(),m[f].plotX=void 0);t.data=m,t.points=d,O(this,"afterGeneratePoints")}getXExtremes(t){return{min:b(t),max:y(t)}}getExtremes(t,e){var i=this.xAxis,s=this.yAxis,o=this.processedXData||this.xData,r=[],a=this.requireSorting&&!this.is("column")?1:0,n=!!s&&s.positiveValuesOnly;let l,h,d,c,p,u,g,f=0,m=0,x=0;var v=(t=t||this.stackedYData||this.processedYData||[]).length;for(i&&(l=i.getExtremes(),f=l.min,m=l.max),u=0;u<v;u++)if(c=o[u],p=t[u],h=(E(p)||L(p))&&((E(p)?0<p:p.length)||!n),d=e||this.getExtremesFromAll||this.options.getExtremesFromAll||this.cropped||!i||(o[u+a]||c)>=f&&(o[u-a]||c)<=m,h&&d)if(g=p.length)for(;g--;)E(p[g])&&(r[x++]=p[g]);else r[x++]=p;s={activeYData:r,dataMin:b(r),dataMax:y(r)};return O(this,"afterGetExtremes",{dataExtremes:s}),s}applyExtremes(){var t=this.getExtremes();return this.dataMin=t.dataMin,this.dataMax=t.dataMax,t}getFirstValidPoint(t){var e=t.length;let i=0,s=null;for(;null===s&&i<e;)s=t[i],i++;return s}translate(){this.processedXData||this.processData(),this.generatePoints();var r=this,t=r.options,a=t.stacking,n=r.xAxis,l=n.categories,h=r.enabledDataSorting,d=r.yAxis,c=r.points,e=c.length,p=r.pointPlacementToXValue(),u=Boolean(p),g=t.threshold,f=t.startFromThreshold?g:0;let m,x,v,y,b=Number.MAX_VALUE;function M(t){return A(t,-1e5,1e5)}for(m=0;m<e;m++){var S=c[m],k=S.x;let t,e,i=S.y,s=S.low;var C=a&&d.stacking?.stacks[(r.negStacks&&i<(f?0:g)?"-":"")+r.stackKey];x=n.translate(k,!1,!1,!1,!0,p),S.plotX=E(x)?w(M(x)):void 0,a&&r.visible&&C&&C[k]&&(y=r.getStackIndicator(y,k,r.index),!S.isNull&&y.key&&(t=C[k],e=t.points[y.key]),t)&&L(e)&&(s=e[0],i=e[1],s===f&&y.key===C[k].base&&(s=B(E(g)?g:d.min)),d.positiveValuesOnly&&T(s)&&s<=0&&(s=void 0),S.total=S.stackTotal=B(t.total),S.percentage=T(S.y)&&t.total?S.y/t.total*100:void 0,S.stackY=i,r.irregularWidths||t.setOffset(r.pointXOffset||0,r.barW||0,void 0,void 0,void 0,r.xAxis)),S.yBottom=T(s)?M(d.translate(s,!1,!0,!1,!0)):void 0,r.dataModify&&(i=r.dataModify.modifyValue(i,m));let o;E(i)&&void 0!==S.plotX&&(o=d.translate(i,!1,!0,!1,!0),o=E(o)?M(o):void 0),S.plotY=o,S.isInside=this.isPointInside(S),S.clientX=u?w(n.translate(k,!1,!1,!1,!0,p)):x,S.negative=(S.y||0)<(g||0),S.category=B(l&&l[S.x],S.x),S.isNull||!1===S.visible||(void 0!==v&&(b=Math.min(b,Math.abs(x-v))),v=x),S.zone=this.zones.length?S.getZone():void 0,!S.graphic&&r.group&&h&&(S.isNew=!0)}r.closestPointRangePx=b,O(this,"afterTranslate")}getValidPoints(t,s,o){const r=this.chart;return(t||this.points||[]).filter(function(t){var{plotX:e,plotY:i}=t;return!(!(o||!t.isNull&&E(i))||s&&!r.isInsidePlot(e,i,{inverted:r.inverted}))&&!1!==t.visible})}getClipBox(){var{chart:t,xAxis:e,yAxis:i}=this,s=D(t.clipBox);return e&&e.len!==t.plotSizeX&&(s.width=e.len),i&&i.len!==t.plotSizeY&&(s.height=i.len),s}getSharedClipKey(){return this.sharedClipKey=(this.options.xAxis||0)+","+(this.options.yAxis||0),this.sharedClipKey}setClip(){var{chart:t,group:e,markerGroup:i}=this,s=t.sharedClips,t=t.renderer,o=this.getClipBox(),r=this.getSharedClipKey();let a=s[r];a?a.animate(o):s[r]=a=t.clipRect(o),e&&e.clip(!1===this.options.clip?void 0:a),i&&i.clip()}animate(t){const{chart:e,group:i,markerGroup:s}=this,o=e.inverted,r=p(this.options.animation),a=[this.getSharedClipKey(),r.duration,r.easing,r.defer].join(",");let n=e.sharedClips[a],l=e.sharedClips[a+"m"];if(t&&i){var t=this.getClipBox();n?n.attr("height",t.height):(t.width=0,o&&(t.x=e.plotHeight),n=e.renderer.clipRect(t),e.sharedClips[a]=n,t={x:(o,-99),y:(o,-99),width:o?e.plotWidth+199:99,height:o?99:e.plotHeight+199},l=e.renderer.clipRect(t),e.sharedClips[a+"m"]=l),i.clip(n),s&&s.clip(l)}else if(n&&!n.hasClass("highcharts-animating")){const h=this.getClipBox(),d=r.step;s&&s.element.childNodes.length&&(r.step=function(t,e){d&&d.apply(e,arguments),"width"===e.prop&&l&&l.element&&l.attr(o?"height":"width",t+99)}),n.addClass("highcharts-animating").animate(h,r)}}afterAnimate(){this.setClip(),C(this.chart.sharedClips,(t,e,i)=>{t&&!this.chart.container.querySelector(`[clip-path="url(#${t.id})"]`)&&(t.destroy(),delete i[e])}),this.finishedAnimating=!0,O(this,"afterAnimate")}drawPoints(t=this.points){var e,i,s=this,o=s.chart,r=o.styledMode,{colorAxis:a,options:n}=s,l=n.marker,h=s[s.specialGroup||"markerGroup"],d=s.xAxis,c=B(l.enabled,!(d&&!d.isRadial)||null,s.closestPointRangePx>=l.enabledThreshold*l.radius);let p,u,g,f,m,x,v;if(!1!==l.enabled||s._hasPointMarkers)for(p=0;p<t.length;p++)u=t[p],g=u.graphic,f=g?"animate":"attr",m=u.marker||{},x=!!u.marker,(c&&"undefined"==typeof m.enabled||m.enabled)&&!u.isNull&&!1!==u.visible?(i=B(m.symbol,s.symbol,"rect"),v=s.markerAttribs(u,u.selected&&"select"),s.enabledDataSorting&&(u.startXPos=d.reversed?-(v.width||0):d.width),e=!1!==u.isInside,!g&&e&&(0<(v.width||0)||u.hasImage)&&(u.graphic=g=o.renderer.symbol(i,v.x,v.y,v.width,v.height,x?m:l).add(h),s.enabledDataSorting)&&o.hasRendered&&(g.attr({x:u.startXPos}),f="animate"),g&&"animate"===f&&g[e?"show":"hide"](e).animate(v),g&&(i=s.pointAttribs(u,r||!u.selected?void 0:"select"),r?a&&g.css({fill:i.fill}):g[f](i)),g&&g.addClass(u.getClassName(),!0)):g&&(u.graphic=g.destroy())}markerAttribs(t,e){var i=this.options,s=i.marker,o=t.marker||{},r=o.symbol||s.symbol,a={};let n,l,h=B(o.radius,s&&s.radius);e&&(n=s.states[e],l=o.states&&o.states[e],h=B(l&&l.radius,n&&n.radius,h&&h+(n&&n.radiusPlus||0))),t.hasImage=r&&0===r.indexOf("url"),t.hasImage&&(h=0);s=t.pos();return E(h)&&s&&(a.x=s[0]-h,a.y=s[1]-h,i.crisp)&&(a.x=Math.floor(a.x)),h&&(a.width=a.height=2*h),a}pointAttribs(t,e){var i=this.options.marker,s=t&&t.options,o=s&&s.marker||{},s=s&&s.color,r=t&&t.color,t=t&&t.zone&&t.zone.color;let a,n,l=this.color,h,d,c=B(o.lineWidth,i.lineWidth),p=1;return l=s||t||r||l,h=o.fillColor||i.fillColor||l,d=o.lineColor||i.lineColor||l,(e=e||"normal")&&(a=i.states[e]||{},n=o.states&&o.states[e]||{},c=B(n.lineWidth,a.lineWidth,c+B(n.lineWidthPlus,a.lineWidthPlus,0)),h=n.fillColor||a.fillColor||h,d=n.lineColor||a.lineColor||d,p=B(n.opacity,a.opacity,p)),{stroke:d,"stroke-width":c,fill:h,opacity:p}}destroy(i){const s=this,t=s.chart,o=/AppleWebKit\/533/.test(x.navigator.userAgent),e=s.data||[];let r,a,n,l;for(O(s,"destroy",{keepEventsForUpdate:i}),this.removeEvents(i),(s.axisTypes||[]).forEach(function(t){(l=s[t])&&l.series&&(M(l.series,s),l.isDirty=l.forceRedraw=!0)}),s.legendItem&&s.chart.legend.destroyItem(s),a=e.length;a--;)(n=e[a])&&n.destroy&&n.destroy();s.zones.forEach(R),c.clearTimeout(s.animationTimeout),C(s,function(t,e){t instanceof d&&!t.survive&&t[r=o&&"group"===e?"hide":"destroy"]()}),t.hoverSeries===s&&(t.hoverSeries=void 0),M(t.series,s),t.orderItems("series"),C(s,function(t,e){i&&"hcEvents"===e||delete s[e]})}applyZones(){const{area:u,chart:t,graph:g,zones:e,points:i,xAxis:f,yAxis:m,zoneAxis:s}=this,{inverted:x,renderer:v}=t,o=this[s+"Axis"],{isXAxis:y,len:r=0}=o||{},a=(g?.strokeWidth()||0)/2+1,n=(t,e=0,i=0)=>{var{translated:t=0,lineClip:s}=t,o=(i=x?r-i:i)-t;s?.push(["L",e,Math.abs(o)<a?i-a*(o<=0?-1:1):t])};if(e.length&&(g||u)&&o&&E(o.min)){const M=o.getExtremes().max,S=i=>{i.forEach((t,e)=>{"M"!==t[0]&&"L"!==t[0]||(i[e]=[t[0],y?r-t[1]:t[1],y?t[2]:r-t[2]])})};if(e.forEach((t,e)=>{t.lineClip=[],t.translated=A(o.toPixels(B(t.value,M),!0)||0,0,r)}),g&&!this.showLine&&g.hide(),u&&u.hide(),"y"===s&&i.length<f.len)for(const k of i){var{plotX:l,plotY:h,zone:d}=k,b=d&&e[e.indexOf(d)-1];d&&n(d,l,h),b&&n(b,l,h)}let c=[],p=o.toPixels(o.getExtremes().min,!0);e.forEach(t=>{var e=t.lineClip||[],i=Math.round(t.translated||0);f.reversed&&e.reverse();let{clip:s,simpleClip:o}=t,r=0,a=0,n=f.len,l=m.len;y?(r=i,n=p):(a=i,l=p);var h=[["M",r,a],["L",n,a],["L",n,l],["L",r,l],["Z"]],d=[h[0],...e,h[1],h[2],...c,h[3],h[4]];c=e.reverse(),p=i,x&&(S(d),u)&&S(h),s?(s.animate({d:d}),o?.animate({d:h})):(s=t.clip=v.path(d),u&&(o=t.simpleClip=v.path(h))),g&&t.graph?.clip(s),u&&t.area?.clip(o)})}else this.visible&&(g&&g.show(),u)&&u.show()}plotGroup(t,e,i,s,o){let r=this[t];var a=!r,i={visibility:i,zIndex:s||.1};return T(this.opacity)&&!this.chart.styledMode&&"inactive"!==this.state&&(i.opacity=this.opacity),r||(this[t]=r=this.chart.renderer.g().add(o)),r.addClass("highcharts-"+e+" highcharts-series-"+this.index+" highcharts-"+this.type+"-series "+(T(this.colorIndex)?"highcharts-color-"+this.colorIndex+" ":"")+(this.options.className||"")+(r.hasClass("highcharts-tracker")?" highcharts-tracker":""),!0),r.attr(i)[a?"attr":"animate"](this.getPlotBox(e)),r}getPlotBox(t){let e=this.xAxis,i=this.yAxis;var s=this.chart,t=s.inverted&&!s.polar&&e&&!1!==this.invertible&&"series"===t;return s.inverted&&(e=i,i=this.xAxis),{translateX:e?e.left:s.plotLeft,translateY:i?i.top:s.plotTop,rotation:t?90:0,rotationOriginX:t?(e.len-i.len)/2:0,rotationOriginY:t?(e.len+i.len)/2:0,scaleX:t?-1:1,scaleY:1}}removeEvents(t){var e=this["eventsToUnbind"];t||X(this),e.length&&(e.forEach(t=>{t()}),e.length=0)}render(){const t=this,{chart:e,options:i,hasRendered:s}=t,o=p(i.animation),r=t.visible?"inherit":"hidden",a=i.zIndex,n=e.seriesGroup;let l=t.finishedAnimating?0:o.duration;O(this,"render"),t.plotGroup("group","series",r,a,n),t.markerGroup=t.plotGroup("markerGroup","markers",r,a,n),!1!==i.clip&&t.setClip(),l&&t.animate?.(!0),t.drawGraph&&(t.drawGraph(),t.applyZones()),t.visible&&t.drawPoints(),t.drawDataLabels?.(),t.redrawPoints?.(),i.enableMouseTracking&&t.drawTracker?.(),l&&t.animate?.(),s||(l&&o.defer&&(l+=o.defer),t.animationTimeout=j(()=>{t.afterAnimate()},l||0)),t.isDirty=!1,t.hasRendered=!0,O(t,"afterRender")}redraw(){var t=this.isDirty||this.isDirtyData;this.translate(),this.render(),t&&delete this.kdTree}reserveSpace(){return this.visible||!this.chart.options.chart.ignoreHiddenSeries}searchPoint(t,e){var{xAxis:i,yAxis:s}=this,o=this.chart.inverted;return this.searchKDTree({clientX:o?i.len-t.chartY+i.pos:t.chartX-i.pos,plotY:o?s.len-t.chartX+s.pos:t.chartY-s.pos},e,t)}buildKDTree(t){this.buildingKdTree=!0;const n=this,e=-1<n.options.findNearestPointBy.indexOf("y")?2:1;delete n.kdTree,j(function(){n.kdTree=function a(t,e,i){var s=t?.length;let o,r;if(s)return o=n.kdAxisArray[e%i],t.sort((t,e)=>(t[o]||0)-(e[o]||0)),{point:t[r=Math.floor(s/2)],left:a(t.slice(0,r),e+1,i),right:a(t.slice(r+1),e+1,i)}}(n.getValidPoints(void 0,!n.directTouch),e,e),n.buildingKdTree=!1},n.options.kdNow||"touchstart"===t?.type?0:1)}searchKDTree(t,e,i){const u=this,[g,f]=this.kdAxisArray,m=e?"distX":"dist",s=-1<(u.options.findNearestPointBy||"").indexOf("y")?2:1,x=!!u.isBubble;function v(t,e,i,s){var o,r=e.point,a=u.kdAxisArray[i%s];let n,l,h=r;c=r,p=(o=t)[g],d=c[g],p=T(p)&&T(d)?p-d:null,d=o[f],o=c[f],d=T(d)&&T(o)?d-o:0,o=x&&c.marker?.radius||0,c.dist=Math.sqrt((p&&p*p||0)+d*d)-o,c.distX=T(p)?Math.abs(p)-o:Number.MAX_VALUE;var d=(t[a]||0)-(r[a]||0)+(x&&r.marker?.radius||0),c=d<0?"left":"right",p=d<0?"right":"left";return e[c]&&(n=v(t,e[c],i+1,s),h=n[m]<h[m]?n:r),e[p]&&Math.sqrt(d*d)<h[m]&&(l=v(t,e[p],i+1,s),h=l[m]<h[m]?l:h),h}if(this.kdTree||this.buildingKdTree||this.buildKDTree(i),this.kdTree)return v(t,this.kdTree,s,s)}pointPlacementToXValue(){var{options:t,xAxis:e}=this;let i=t.pointPlacement;return"between"===i&&(i=e.reversed?-.5:.5),E(i)?i*(t.pointRange||e.pointRange):0}isPointInside(t){var{chart:e,xAxis:i,yAxis:s}=this,{plotX:t=-1,plotY:o=-1}=t;return 0<=o&&o<=(s?s.len:e.plotHeight)&&0<=t&&t<=(i?i.len:e.plotWidth)}drawTracker(){const t=this,e=t.options,i=e.trackByArea,s=[].concat((i?t.areaPath:t.graphPath)||[]),o=t.chart,r=o.pointer,a=o.renderer,n=o.options.tooltip?.snap||0,l=()=>{e.enableMouseTracking&&o.hoverSeries!==t&&t.onMouseOver()},h="rgba(192,192,192,"+(m?1e-4:.002)+")";let d=t.tracker;d?d.attr({d:s}):t.graph&&(t.tracker=d=a.path(s).attr({visibility:t.visible?"inherit":"hidden",zIndex:2}).addClass(i?"highcharts-tracker-area":"highcharts-tracker-line").add(t.group),o.styledMode||d.attr({"stroke-linecap":"round","stroke-linejoin":"round",stroke:h,fill:i?h:"none","stroke-width":t.graph.strokeWidth()+(i?0:2*n)}),[t.tracker,t.markerGroup,t.dataLabelsGroup].forEach(t=>{t&&(t.addClass("highcharts-tracker").on("mouseover",l).on("mouseout",t=>{r.onTrackerMouseOut(t)}),e.cursor&&!o.styledMode&&t.css({cursor:e.cursor}),f)&&t.on("touchstart",l)})),O(this,"afterDrawTracker")}addPoint(t,e,i,s,o){var r=this,a=r.options,n=r.data,l=r.chart,h=r.xAxis,h=h&&h.hasNames&&h.names,d=a.data,c=r.xData;let p,u;e=B(e,!0);var g={series:r},f=(r.pointClass.prototype.applyOptions.apply(g,[t]),g.x);if(u=c.length,r.requireSorting&&f<c[u-1])for(p=!0;u&&c[u-1]>f;)u--;r.updateParallelArrays(g,"splice",[u,0,0]),r.updateParallelArrays(g,u),h&&g.name&&(h[f]=g.name),d.splice(u,0,t),(p||r.processedData)&&(r.data.splice(u,0,null),r.processData()),"point"===a.legendType&&r.generatePoints(),i&&(n[0]&&n[0].remove?n[0].remove(!1):(n.shift(),r.updateParallelArrays(g,"shift"),d.shift())),!1!==o&&O(r,"addPoint",{point:g}),r.isDirty=!0,r.isDirtyData=!0,e&&l.redraw(s)}removePoint(t,e,i){const s=this,o=s.data,r=o[t],a=s.points,n=s.chart,l=function(){a&&a.length===o.length&&a.splice(t,1),o.splice(t,1),s.options.data.splice(t,1),s.updateParallelArrays(r||{series:s},"splice",[t,1]),r&&r.destroy(),s.isDirty=!0,s.isDirtyData=!0,e&&n.redraw()};u(i,n),e=B(e,!0),r?r.firePointEvent("remove",null,l):l()}remove(t,e,i,s){const o=this,r=o.chart;function a(){o.destroy(s),r.isDirtyLegend=r.isDirtyBox=!0,r.linkSeries(s),B(t,!0)&&r.redraw(e)}!1!==i?O(o,"remove",null,a):a()}update(t,e){t=z(t,this.userOptions),O(this,"update",{options:t});const i=this,s=i.chart,o=i.userOptions,r=i.initialType||i.type,a=s.options.plotOptions,n=v[r].prototype,l=i.finishedAnimating&&{animation:!1},h={};let d,c,p=["colorIndex","eventOptions","navigatorSeries","symbolIndex","baseSeries"],u=t.type||o.type||s.options.chart.type;var g=!(this.hasDerivedData||u&&u!==this.type||"undefined"!=typeof t.pointStart||"undefined"!=typeof t.pointInterval||"undefined"!=typeof t.relativeXValue||t.joinBy||t.mapData||["dataGrouping","pointStart","pointInterval","pointIntervalUnit","keys"].some(t=>i.hasOptionChanged(t)));u=u||r,g&&(p.push("data","isDirtyData","isDirtyCanvas","points","processedData","processedXData","processedYData","xIncrement","cropped","_hasPointMarkers","hasDataLabels","nodes","layout","level","mapMap","mapData","minY","maxY","minX","maxX"),!1!==t.visible&&p.push("area","graph"),i.parallelArrays.forEach(function(t){p.push(t+"Data")}),t.data)&&(t.dataSorting&&S(i.options.dataSorting,t.dataSorting),this.setData(t.data,!1)),t=D(o,{index:(void 0===o.index?i:o).index,pointStart:a?.series?.pointStart??o.pointStart??i.xData?.[0]},!g&&{data:i.options.data},t,l),g&&t.data&&(t.data=i.options.data),(p=["group","markerGroup","dataLabelsGroup","transformGroup"].concat(p)).forEach(function(t){p[t]=i[t],delete i[t]});let f=!1;if(v[u]){if(f=u!==i.type,i.remove(!1,!1,!1,!0),f)if(Object.setPrototypeOf)Object.setPrototypeOf(i,v[u].prototype);else{var m=Object.hasOwnProperty.call(i,"hcEvents")&&i.hcEvents;for(c in n)i[c]=void 0;S(i,v[u].prototype),m?i.hcEvents=m:delete i.hcEvents}}else P(17,!0,s,{missingModuleFor:u});if(p.forEach(function(t){i[t]=p[t]}),i.init(s,t),g&&this.points){!1===(d=i.options).visible?(h.graphic=1,h.dataLabel=1):(this.hasMarkerChanged(d,o)&&(h.graphic=1),i.hasDataLabels?.()||(h.dataLabel=1));for(const x of this.points)x&&x.series&&(x.resolveColor(),Object.keys(h).length&&x.destroyElements(h),!1===d.showInLegend)&&x.legendItem&&s.legend.destroyItem(x)}i.initialType=r,s.linkSeries(),s.setSortedData(),f&&i.linkedSeries.length&&(i.isDirtyData=!0),O(this,"afterUpdate"),B(e,!0)&&s.redraw(g&&void 0)}setName(t){this.name=this.options.name=this.userOptions.name=t,this.chart.isDirtyLegend=!0}hasOptionChanged(t){var e=this.chart,i=this.options[t],e=e.options.plotOptions,s=this.userOptions[t],t=B(e?.[this.type]?.[t],e?.series?.[t]);return s&&!T(t)?i!==s:i!==B(t,i)}onMouseOver(){var t=this.chart,e=t.hoverSeries;t.pointer.setHoverChartIndex(),e&&e!==this&&e.onMouseOut(),this.options.events.mouseOver&&O(this,"mouseOver"),this.setState("hover"),t.hoverSeries=this}onMouseOut(){var t=this.options,e=this.chart,i=e.tooltip,s=e.hoverPoint;e.hoverSeries=null,s&&s.onMouseOut(),this&&t.events.mouseOut&&O(this,"mouseOut"),!i||this.stickyTracking||i.shared&&!this.noSharedTooltip||i.hide(),e.series.forEach(function(t){t.setState("",!0)})}setState(e,t){const i=this,s=i.options,o=i.graph,r=s.inactiveOtherPoints,a=s.states,n=B(a[e||"normal"]&&a[e||"normal"].animation,i.chart.options.chart.animation);let l=s.lineWidth,h=s.opacity;if(e=e||"",i.state!==e&&([i.group,i.markerGroup,i.dataLabelsGroup].forEach(function(t){t&&(i.state&&t.removeClass("highcharts-series-"+i.state),e)&&t.addClass("highcharts-series-"+e)}),i.state=e,!i.chart.styledMode)){if(a[e]&&!1===a[e].enabled)return;if(e&&(l=a[e].lineWidth||l+(a[e].lineWidthPlus||0),h=B(a[e].opacity,h)),o&&!o.dashstyle&&E(l))for(const d of[o,...this.zones.map(t=>t.graph)])d?.animate({"stroke-width":l},n);r||[i.group,i.markerGroup,i.dataLabelsGroup,i.labelBySeries].forEach(function(t){t&&t.animate({opacity:h},n)})}t&&r&&i.points&&i.setAllPointsToState(e||void 0)}setAllPointsToState(e){this.points.forEach(function(t){t.setState&&t.setState(e)})}setVisible(e,t){const i=this,s=i.chart,o=s.options.chart.ignoreHiddenSeries,r=i.visible,a=(i.visible=e=i.options.visible=i.userOptions.visible=void 0===e?!r:e,e?"show":"hide");["group","dataLabelsGroup","markerGroup","tracker","tt"].forEach(t=>{i[t]?.[a]()}),s.hoverSeries!==i&&s.hoverPoint?.series!==i||i.onMouseOut(),i.legendItem&&s.legend.colorizeItem(i,e),i.isDirty=!0,i.options.stacking&&s.series.forEach(t=>{t.options.stacking&&t.visible&&(t.isDirty=!0)}),i.linkedSeries.forEach(t=>{t.setVisible(e,!1)}),o&&(s.isDirtyBox=!0),O(i,a),!1!==t&&s.redraw()}show(){this.setVisible(!0)}hide(){this.setVisible(!1)}select(t){this.selected=t=this.options.selected=void 0===t?!this.selected:t,this.checkbox&&(this.checkbox.checked=t),O(this,t?"select":"unselect")}shouldShowTooltip(t,e,i={}){return i.series=this,i.visiblePlotOnly=!0,this.chart.isInsidePlot(t,e,i)}drawLegendSymbol(t,e){o[this.options.legendSymbol||"rectangle"]?.call(this,t,e)}}return I.defaultOptions=r,I.types=a.seriesTypes,I.registerType=a.registerSeriesType,S(I.prototype,{axisTypes:["xAxis","yAxis"],coll:"series",colorCounter:0,directTouch:!1,isCartesian:!0,kdAxisArray:["clientX","plotY"],parallelArrays:["x","y"],pointClass:h,requireSorting:!0,sorted:!0}),a.series=I}),e(t,"Core/Chart/Chart.js",[t["Core/Animation/AnimationUtilities.js"],t["Core/Axis/Axis.js"],t["Core/Defaults.js"],t["Core/Templating.js"],t["Core/Foundation.js"],t["Core/Globals.js"],t["Core/Renderer/RendererRegistry.js"],t["Core/Series/Series.js"],t["Core/Series/SeriesRegistry.js"],t["Core/Renderer/SVG/SVGRenderer.js"],t["Core/Time.js"],t["Core/Utilities.js"],t["Core/Renderer/HTML/AST.js"],t["Core/Axis/Tick.js"]],function(t,s,e,i,G,a,N,W,X,H,u,o,d,Y){const{animate:n,animObject:U,setAnimation:m}=t,{defaultOptions:l,defaultTime:F}=e,V=i["numberFormat"],g=G["registerEventOptions"],{charts:c,doc:p,marginNames:h,svg:_,win:r}=a,f=X["seriesTypes"],{addEvent:x,attr:v,createElement:y,css:b,defined:M,diffObjects:S,discardElement:q,erase:Z,error:k,extend:C,find:A,fireEvent:w,getStyle:T,isArray:K,isNumber:P,isObject:O,isString:L,merge:E,objectEach:D,pick:B,pInt:$,relativeLength:j,removeEvent:I,splat:R,syncTimeout:J,uniqueKey:Q}=o;class z{static chart(t,e,i){return new z(t,e,i)}constructor(t,e,i){this.sharedClips={};var s=[...arguments];(L(t)||t.nodeName)&&(this.renderTo=s.shift()),this.init(s[0],s[1])}setZoomOptions(){var t=this.options.chart,e=t.zooming;this.zooming={...e,type:B(t.zoomType,e.type),key:B(t.zoomKey,e.key),pinchType:B(t.pinchType,e.pinchType),singleTouch:B(t.zoomBySingleTouch,e.singleTouch,!1),resetButton:E(e.resetButton,t.resetZoomButton)}}init(i,s){w(this,"init",{args:arguments},function(){var t=E(l,i),e=t.chart;this.userOptions=C({},i),this.margin=[],this.spacing=[],this.bounds={h:{},v:{}},this.labelCollectors=[],this.callback=s,this.isResizing=0,this.options=t,this.axes=[],this.series=[],this.time=i.time&&Object.keys(i.time).length?new u(i.time):a.time,this.numberFormatter=e.numberFormatter||V,this.styledMode=e.styledMode,this.hasCartesianSeries=e.showAxes;this.index=c.length,c.push(this),a.chartCount++,g(this,e),this.xAxis=[],this.yAxis=[],this.pointCount=this.colorCounter=this.symbolCounter=0,this.setZoomOptions(),w(this,"afterInit"),this.firstRender()})}initSeries(t){var e=this.options.chart,e=t.type||e.type,i=f[e],e=(i||k(17,!0,this,{missingModuleFor:e}),new i);return"function"==typeof e.init&&e.init(this,t),e}setSortedData(){this.getSeriesOrderByLinks().forEach(function(t){t.points||t.data||!t.enabledDataSorting||t.setData(t.options.data,!1)})}getSeriesOrderByLinks(){return this.series.concat().sort(function(t,e){return t.linkedSeries.length||e.linkedSeries.length?e.linkedSeries.length-t.linkedSeries.length:0})}orderItems(t,i=0){var s=this[t],o=this.options[t]=R(this.options[t]).slice(),r=this.userOptions[t]=this.userOptions[t]?R(this.userOptions[t]).slice():[];if(this.hasRendered&&(o.splice(i),r.splice(i)),s)for(let t=i,e=s.length;t<e;++t){var a=s[t];a&&(a.index=t,a instanceof W&&(a.name=a.getName()),a.options.isInternal||(o[t]=a.options,r[t]=a.userOptions))}}isInsidePlot(t,e,i={}){var{inverted:s,plotBox:o,plotLeft:r,plotTop:a,scrollablePlotBox:n}=this;let l=0,h=0;i.visiblePlotOnly&&this.scrollingContainer&&({scrollLeft:l,scrollTop:h}=this.scrollingContainer);var d,c=i.series,n=i.visiblePlotOnly&&n||o,o=i.inverted?e:t,t=i.inverted?t:e,e={x:o,y:t,isInsidePlot:!0,options:i};return i.ignoreX||(d=c&&(s&&!this.polar?c.yAxis:c.xAxis)||{pos:r,len:Infinity},(o=i.paneCoordinates?d.pos+o:r+o)>=Math.max(l+r,d.pos)&&o<=Math.min(l+r+n.width,d.pos+d.len))||(e.isInsidePlot=!1),!i.ignoreY&&e.isInsidePlot&&(o=!s&&i.axis&&!i.axis.isXAxis&&i.axis||c&&(s?c.xAxis:c.yAxis)||{pos:a,len:Infinity},(r=i.paneCoordinates?o.pos+t:a+t)>=Math.max(h+a,o.pos)&&r<=Math.min(h+a+n.height,o.pos+o.len)||(e.isInsidePlot=!1)),w(this,"afterIsInsidePlot",e),e.isInsidePlot}redraw(t){w(this,"beforeRedraw");const e=this,i=e.hasCartesianSeries?e.axes:e.colorAxis||[],s=e.series,o=e.pointer,r=e.legend,a=e.userOptions.legend,n=e.renderer,l=n.isHidden(),h=[];let d,c,p,u=e.isDirtyBox,g=e.isDirtyLegend,f;for(n.rootFontSize=n.boxWrapper.getStyle("font-size"),e.setResponsive&&e.setResponsive(!1),m(!!e.hasRendered&&t,e),l&&e.temporaryDisplay(),e.layOutTitles(!1),p=s.length;p--;)if(((f=s[p]).options.stacking||f.options.centerInCategory)&&(c=!0,f.isDirty)){d=!0;break}if(d)for(p=s.length;p--;)(f=s[p]).options.stacking&&(f.isDirty=!0);s.forEach(function(t){t.isDirty&&("point"===t.options.legendType?("function"==typeof t.updateTotals&&t.updateTotals(),g=!0):a&&(a.labelFormatter||a.labelFormat)&&(g=!0)),t.isDirtyData&&w(t,"updatedData")}),g&&r&&r.options.enabled&&(r.render(),e.isDirtyLegend=!1),c&&e.getStacks(),i.forEach(function(t){t.updateNames(),t.setScale()}),e.getMargins(),i.forEach(function(t){t.isDirty&&(u=!0)}),i.forEach(function(t){var e=t.min+","+t.max;t.extKey!==e&&(t.extKey=e,h.push(function(){w(t,"afterSetExtremes",C(t.eventArgs,t.getExtremes())),delete t.eventArgs})),(u||c)&&t.redraw()}),u&&e.drawChartBox(),w(e,"predraw"),s.forEach(function(t){(u||t.isDirty)&&t.visible&&t.redraw(),t.isDirtyData=!1}),o&&o.reset(!0),n.draw(),w(e,"redraw"),w(e,"render"),l&&e.temporaryDisplay(!0),h.forEach(function(t){t.call()})}get(e){var i=this.series;function s(t){return t.id===e||t.options&&t.options.id===e}let o=A(this.axes,s)||A(this.series,s);for(let t=0;!o&&t<i.length;t++)o=A(i[t].points||[],s);return o}getAxes(){var t=this.userOptions;w(this,"getAxes");for(const e of["xAxis","yAxis"])for(const i of t[e]=R(t[e]||{}))new s(this,i,e);w(this,"afterGetAxes")}getSelectedPoints(){return this.series.reduce((e,t)=>(t.getPointsCollection().forEach(t=>{B(t.selectedStaging,t.selected)&&e.push(t)}),e),[])}getSelectedSeries(){return this.series.filter(function(t){return t.selected})}setTitle(t,e,i){this.applyDescription("title",t),this.applyDescription("subtitle",e),this.applyDescription("caption",void 0),this.layOutTitles(i)}applyDescription(i,t){const s=this;var e=this.options[i]=E(this.options[i],t);let o=this[i];o&&t&&(this[i]=o=o.destroy()),e&&!o&&((o=this.renderer.text(e.text,0,0,e.useHTML).attr({align:e.align,"class":"highcharts-"+i,zIndex:e.zIndex||4}).add()).update=function(t,e){s.applyDescription(i,t),s.layOutTitles(e)},this.styledMode||o.css(C("title"===i?{fontSize:this.options.isStock?"1em":"1.2em"}:{},e.style)),this[i]=o)}layOutTitles(t=!0){const a=[0,0,0],n=this.renderer,l=this.spacingBox;["title","subtitle","caption"].forEach(function(t){var e,i,s=this[t],o=this.options[t],r=o.verticalAlign||"top",t="title"===t?"top"===r?-3:0:"top"===r?a[0]+2:0;s&&(s.css({width:(o.width||l.width+(o.widthAdjust||0))+"px"}),e=n.fontMetrics(s).b,i=Math.round(s.getBBox(o.useHTML).height),s.align(C({y:"bottom"===r?e:t+e,height:i},o),!1,"spacingBox"),o.floating||("top"===r?a[0]=Math.ceil(a[0]+i):"bottom"===r&&(a[2]=Math.ceil(a[2]+i))))},this),a[0]&&"top"===(this.options.title.verticalAlign||"top")&&(a[0]+=this.options.title.margin),a[2]&&"bottom"===this.options.caption.verticalAlign&&(a[2]+=this.options.caption.margin);var e=!this.titleOffset||this.titleOffset.join(",")!==a.join(",");this.titleOffset=a,w(this,"afterLayOutTitles"),!this.isDirtyBox&&e&&(this.isDirtyBox=this.isDirtyLegend=e,this.hasRendered)&&t&&this.isDirtyBox&&this.redraw()}getContainerBox(){return{width:T(this.renderTo,"width",!0)||0,height:T(this.renderTo,"height",!0)||0}}getChartSize(){var t=this.options.chart,e=t.width,t=t.height,i=this.getContainerBox();this.chartWidth=Math.max(0,e||i.width||600),this.chartHeight=Math.max(0,j(t,this.chartWidth)||(1<i.height?i.height:400)),this.containerBox=i}temporaryDisplay(t){let e=this.renderTo,i;if(t)for(;e&&e.style;)e.hcOrigStyle&&(b(e,e.hcOrigStyle),delete e.hcOrigStyle),e.hcOrigDetached&&(p.body.removeChild(e),e.hcOrigDetached=!1),e=e.parentNode;else for(;e&&e.style&&(p.body.contains(e)||e.parentNode||(e.hcOrigDetached=!0,p.body.appendChild(e)),"none"!==T(e,"display",!1)&&!e.hcOricDetached||(e.hcOrigStyle={display:e.style.display,height:e.style.height,overflow:e.style.overflow},i={display:"block",overflow:"hidden"},e!==this.renderTo&&(i.height=0),b(e,i),e.offsetWidth)||e.style.setProperty("display","block","important"),(e=e.parentNode)!==p.body););}setClassName(t){this.container.className="highcharts-container "+(t||"")}getContainer(){var t=this,e=t.options,i=e.chart,s="data-highcharts-chart",o=Q();let r,a=t.renderTo;a||(t.renderTo=a=i.renderTo),L(a)&&(t.renderTo=a=p.getElementById(a)),a||k(13,!0,t);var n=$(v(a,s)),n=(P(n)&&c[n]&&c[n].hasRendered&&c[n].destroy(),v(a,s,t.index),a.innerHTML=d.emptyHTML,i.skipClone||a.offsetWidth||t.temporaryDisplay(),t.getChartSize(),t.chartWidth),s=t.chartHeight,o=(b(a,{overflow:"hidden"}),t.styledMode||(r=C({position:"relative",overflow:"hidden",width:n+"px",height:s+"px",textAlign:"left",lineHeight:"normal",zIndex:0,"-webkit-tap-highlight-color":"rgba(0,0,0,0)",userSelect:"none","touch-action":"manipulation",outline:"none"},i.style||{})),y("div",{id:o},r,a)),l=(t.container=o,t._cursor=o.style.cursor,i.renderer||!_?N.getRendererType(i.renderer):H);if(t.renderer=new l(o,n,s,void 0,i.forExport,e.exporting&&e.exporting.allowHTML,t.styledMode),t.containerBox=t.getContainerBox(),m(void 0,t),t.setClassName(i.className),t.styledMode)for(const h in e.defs)this.renderer.definition(e.defs[h]);else t.renderer.setStyle(i.style);t.renderer.chartIndex=t.index,w(this,"afterGetContainer")}getMargins(t){var{spacing:e,margin:i,titleOffset:s}=this;this.resetMargins(),s[0]&&!M(i[0])&&(this.plotTop=Math.max(this.plotTop,s[0]+e[0])),s[2]&&!M(i[2])&&(this.marginBottom=Math.max(this.marginBottom,s[2]+e[2])),this.legend&&this.legend.display&&this.legend.adjustMargins(i,e),w(this,"getMargins"),t||this.getAxisMargins()}getAxisMargins(){const i=this,s=i.axisOffset=[0,0,0,0],t=i.colorAxis,o=i.margin,e=function(t){t.forEach(function(t){t.visible&&t.getOffset()})};i.hasCartesianSeries?e(i.axes):t&&t.length&&e(t),h.forEach(function(t,e){M(o[e])||(i[t]+=s[e])}),i.setChartSize()}getOptions(){return S(this.userOptions,l)}reflow(t){const e=this,i=e.containerBox,s=e.getContainerBox();delete e.pointer.chartPosition,!e.isPrinting&&!e.isResizing&&i&&s.width&&(s.width===i.width&&s.height===i.height||(o.clearTimeout(e.reflowTimeout),e.reflowTimeout=J(function(){e.container&&e.setSize(void 0,void 0,!1)},t?100:0)),e.containerBox=s)}setReflow(){const e=this;var t=t=>{e.options?.chart.reflow&&e.hasLoaded&&e.reflow(t)};"function"==typeof ResizeObserver?new ResizeObserver(t).observe(e.renderTo):(t=x(r,"resize",t),x(this,"destroy",t))}setSize(t,e,i){const s=this,o=s.renderer;s.isResizing+=1,m(i,s);var i=o.globalAnimation,{chartWidth:t,chartHeight:e,scrollablePixelsX:r=0,scrollablePixelsY:a=0}=(s.oldChartHeight=s.chartHeight,s.oldChartWidth=s.chartWidth,void 0!==t&&(s.options.chart.width=t),void 0!==e&&(s.options.chart.height=e),s.getChartSize(),s);!s.isDirtyBox&&t===s.oldChartWidth&&e===s.oldChartHeight||(s.styledMode||(i?n:b)(s.container,{width:t+r+"px",height:e+a+"px"},i),s.setChartSize(!0),o.setSize(t,e,i),s.axes.forEach(function(t){t.isDirty=!0,t.setScale()}),s.isDirtyLegend=!0,s.isDirtyBox=!0,s.layOutTitles(),s.getMargins(),s.redraw(i),s.oldChartHeight=void 0,w(s,"resize"),setTimeout(()=>{s&&w(s,"endResize",void 0,()=>{--s.isResizing})},U(i).duration))}setChartSize(t){var e,i,s,o,r=this,a=r.inverted,n=r.renderer,l=r.chartWidth,h=r.chartHeight,d=r.options.chart,c=r.spacing,p=r.clipOffset,a=(r.plotLeft=e=Math.round(r.plotLeft),r.plotTop=i=Math.round(r.plotTop),r.plotWidth=s=Math.max(0,Math.round(l-e-r.marginRight)),r.plotHeight=o=Math.max(0,Math.round(h-i-r.marginBottom)),r.plotSizeX=a?o:s,r.plotSizeY=a?s:o,r.plotBorderWidth=d.plotBorderWidth||0,r.spacingBox=n.spacingBox={x:c[3],y:c[0],width:l-c[3]-c[1],height:h-c[0]-c[2]},r.plotBox=n.plotBox={x:e,y:i,width:s,height:o},2*Math.floor(r.plotBorderWidth/2)),d=Math.ceil(Math.max(a,p[3])/2),l=Math.ceil(Math.max(a,p[0])/2);r.clipBox={x:d,y:l,width:Math.floor(r.plotSizeX-Math.max(a,p[1])/2-d),height:Math.max(0,Math.floor(r.plotSizeY-Math.max(a,p[2])/2-l))},t||(r.axes.forEach(function(t){t.setAxisSize(),t.setAxisTranslation()}),n.alignElements()),w(r,"afterSetChartSize",{skipAxes:t})}resetMargins(){w(this,"resetMargins");const o=this,r=o.options.chart;["margin","spacing"].forEach(function(i){const t=r[i],s=O(t)?t:[t,t,t,t];["Top","Right","Bottom","Left"].forEach(function(t,e){o[i][e]=B(r[i+t],s[e])})}),h.forEach(function(t,e){o[t]=B(o.margin[e],o.spacing[e])}),o.axisOffset=[0,0,0,0],o.clipOffset=[0,0,0,0]}drawChartBox(){var t=this,e=t.options.chart,i=t.renderer,s=t.chartWidth,o=t.chartHeight,r=t.styledMode,a=t.plotBGImage,n=e.backgroundColor,l=e.plotBackgroundColor,h=e.plotBackgroundImage,d=t.plotLeft,c=t.plotTop,p=t.plotWidth,u=t.plotHeight,g=t.plotBox,f=t.clipRect,m=t.clipBox;let x=t.chartBackground,v=t.plotBackground,y=t.plotBorder,b,M,S,k="animate";x||(t.chartBackground=x=i.rect().addClass("highcharts-background").add(),k="attr"),r?b=M=x.strokeWidth():(b=e.borderWidth||0,M=b+(e.shadow?8:0),S={fill:n||"none"},(b||x["stroke-width"])&&(S.stroke=e.borderColor,S["stroke-width"]=b),x.attr(S).shadow(e.shadow)),x[k]({x:M/2,y:M/2,width:s-M-b%2,height:o-M-b%2,r:e.borderRadius}),k="animate",v||(k="attr",t.plotBackground=v=i.rect().addClass("highcharts-plot-background").add()),v[k](g),r||(v.attr({fill:l||"none"}).shadow(e.plotShadow),h&&(a?(h!==a.attr("href")&&a.attr("href",h),a.animate(g)):t.plotBGImage=i.image(h,d,c,p,u).add())),f?f.animate({width:m.width,height:m.height}):t.clipRect=i.clipRect(m),k="animate",y||(k="attr",t.plotBorder=y=i.rect().addClass("highcharts-plot-border").attr({zIndex:1}).add()),r||y.attr({stroke:e.plotBorderColor,"stroke-width":e.plotBorderWidth||0,fill:"none"}),y[k](y.crisp({x:d,y:c,width:p,height:u},-y.strokeWidth())),t.isDirtyBox=!1,w(this,"afterDrawChartBox")}propFromSeries(){const e=this,i=e.options.chart,s=e.options.series;let o,r,a;["inverted","angular","polar"].forEach(function(t){for(r=f[i.type],a=i[t]||r&&r.prototype[t],o=s&&s.length;!a&&o--;)(r=f[s[o].type])&&r.prototype[t]&&(a=!0);e[t]=a})}linkSeries(t){const s=this,e=s.series;e.forEach(function(t){t.linkedSeries.length=0}),e.forEach(function(e){var i=e.options["linkedTo"];if(L(i)){let t;(t=":previous"===i?s.series[e.index-1]:s.get(i))&&t.linkedParent!==e&&(t.linkedSeries.push(e),(e.linkedParent=t).enabledDataSorting&&e.setDataSortingOptions(),e.visible=B(e.options.visible,t.options.visible,e.visible))}}),w(this,"afterLinkSeries",{isUpdating:t})}renderSeries(){this.series.forEach(function(t){t.translate(),t.render()})}render(){var t=this,e=t.axes,i=t.colorAxis,s=t.renderer,o=t.options.chart.axisLayoutRuns||2,r=t=>{t.forEach(t=>{t.visible&&t.render()})};let a=0,n=!0,l,h=0;t.setTitle(),w(t,"beforeMargins"),t.getStacks?.(),t.getMargins(!0),t.setChartSize();for(const m of e){var d=m["options"],c=d["labels"];if(m.horiz&&m.visible&&c.enabled&&m.series.length&&"colorAxis"!==m.coll&&!t.polar){a=d.tickLength,m.createGroups();var p=new Y(m,0,"",!0),u=p.createLabel("x",c);if(p.destroy(),a=u&&B(c.reserveSpace,!P(d.crossing))?u.getBBox().height+c.distance+Math.max(d.offset||0,0):a){u?.destroy();break}}}for(t.plotHeight=Math.max(t.plotHeight-a,0);(n||l||1<o)&&h<o;){var g=t.plotWidth,f=t.plotHeight;for(const x of e)0===h?x.setScale():(x.horiz&&n||!x.horiz&&l)&&x.setTickInterval(!0);0===h?t.getAxisMargins():t.getMargins(),n=g/t.plotWidth>(h?1:1.1),l=f/t.plotHeight>(h?1:1.05),h++}t.drawChartBox(),t.hasCartesianSeries?r(e):i&&i.length&&r(i),t.seriesGroup||(t.seriesGroup=s.g("series-group").attr({zIndex:3}).shadow(t.options.chart.seriesGroupShadow).add()),t.renderSeries(),t.addCredits(),t.setResponsive&&t.setResponsive(),t.hasRendered=!0}addCredits(t){const e=this,i=E(!0,this.options.credits,t);i.enabled&&!this.credits&&(this.credits=this.renderer.text(i.text+(this.mapCredits||""),0,0).addClass("highcharts-credits").on("click",function(){i.href&&(r.location.href=i.href)}).attr({align:i.position.align,zIndex:8}),e.styledMode||this.credits.css(i.style),this.credits.add().align(i.position),this.credits.update=function(t){e.credits=e.credits.destroy(),e.addCredits(t)})}destroy(){const i=this,t=i.axes,e=i.series,s=i.container,o=s&&s.parentNode;let r;for(w(i,"destroy"),i.renderer.forExport?Z(c,i):c[i.index]=void 0,a.chartCount--,i.renderTo.removeAttribute("data-highcharts-chart"),I(i),r=t.length;r--;)t[r]=t[r].destroy();for(this.scroller&&this.scroller.destroy&&this.scroller.destroy(),r=e.length;r--;)e[r]=e[r].destroy();["title","subtitle","chartBackground","plotBackground","plotBGImage","plotBorder","seriesGroup","clipRect","credits","pointer","rangeSelector","legend","resetZoomButton","tooltip","renderer"].forEach(function(t){var e=i[t];e&&e.destroy&&(i[t]=e.destroy())}),s&&(s.innerHTML=d.emptyHTML,I(s),o)&&q(s),D(i,function(t,e){delete i[e]})}firstRender(){const e=this,t=e.options;e.getContainer(),e.resetMargins(),e.setChartSize(),e.propFromSeries(),e.getAxes();var i=K(t.series)?t.series:[];t.series=[],i.forEach(function(t){e.initSeries(t)}),e.linkSeries(),e.setSortedData(),w(e,"beforeRender"),e.render(),e.pointer.getChartPosition(),e.renderer.imgCount||e.hasLoaded||e.onload(),e.temporaryDisplay(!0)}onload(){this.callbacks.concat([this.callback]).forEach(function(t){t&&"undefined"!=typeof this.index&&t.apply(this,[this])},this),w(this,"load"),w(this,"render"),M(this.index)&&this.setReflow(),this.warnIfA11yModuleNotLoaded(),this.hasLoaded=!0}warnIfA11yModuleNotLoaded(){var{options:t,title:e}=this;t&&!this.accessibility&&(this.renderer.boxWrapper.attr({role:"img","aria-label":(e&&e.element.textContent||"").replace(/</g,"&lt;")}),t.accessibility&&!1===t.accessibility.enabled||k('Highcharts warning: Consider including the "accessibility.js" module to make your chart more usable for people with disabilities. Set the "accessibility.enabled" option to false to remove this warning. See https://www.highcharts.com/docs/accessibility/accessibility-module.',!1,this))}addSeries(t,e,i){const s=this;let o;return t&&(e=B(e,!0),w(s,"addSeries",{options:t},function(){o=s.initSeries(t),s.isDirtyLegend=!0,s.linkSeries(),o.enabledDataSorting&&o.setData(t.data,!1),w(s,"afterAddSeries",{series:o}),e&&s.redraw(i)})),o}addAxis(t,e,i,s){return this.createAxis(e?"xAxis":"yAxis",{axis:t,redraw:i,animation:s})}addColorAxis(t,e,i){return this.createAxis("colorAxis",{axis:t,redraw:e,animation:i})}createAxis(t,e){t=new s(this,e.axis,t);return B(e.redraw,!0)&&this.redraw(e.animation),t}showLoading(t){const e=this,i=e.options,s=i.loading,o=function(){r&&b(r,{left:e.plotLeft+"px",top:e.plotTop+"px",width:e.plotWidth+"px",height:e.plotHeight+"px"})};let r=e.loadingDiv,a=e.loadingSpan;r||(e.loadingDiv=r=y("div",{className:"highcharts-loading highcharts-loading-hidden"},null,e.container)),a||(e.loadingSpan=a=y("span",{className:"highcharts-loading-inner"},null,r),x(e,"redraw",o)),r.className="highcharts-loading",d.setElementHTML(a,B(t,i.lang.loading,"")),e.styledMode||(b(r,C(s.style,{zIndex:10})),b(a,s.labelStyle),e.loadingShown)||(b(r,{opacity:0,display:""}),n(r,{opacity:s.style.opacity||.5},{duration:s.showDuration||0})),e.loadingShown=!0,o()}hideLoading(){const t=this.options,e=this.loadingDiv;e&&(e.className="highcharts-loading highcharts-loading-hidden",this.styledMode||n(e,{opacity:0},{duration:t.loading.hideDuration||100,complete:function(){b(e,{display:"none"})}})),this.loadingShown=!1}update(i,t,r,e){const a=this,s={credits:"addCredits",title:"setTitle",subtitle:"setSubtitle",caption:"setCaption"},o=i.isResponsiveOptions,n=[];let l,h,d;w(a,"update",{options:i}),o||a.setResponsive(!1,!0),i=S(i,a.options),a.userOptions=E(a.userOptions,i);var c=i.chart,p=(c&&(E(!0,a.options.chart,c),this.setZoomOptions(),"className"in c&&a.setClassName(c.className),("inverted"in c||"polar"in c||"type"in c)&&(a.propFromSeries(),l=!0),"alignTicks"in c&&(l=!0),"events"in c&&g(this,c),D(c,function(t,e){-1!==a.propsRequireUpdateSeries.indexOf("chart."+e)&&(h=!0),-1!==a.propsRequireDirtyBox.indexOf(e)&&(a.isDirtyBox=!0),-1!==a.propsRequireReflow.indexOf(e)&&(a.isDirtyBox=!0,o||(d=!0))}),!a.styledMode)&&c.style&&a.renderer.setStyle(a.options.chart.style||{}),!a.styledMode&&i.colors&&(this.options.colors=i.colors),i.time&&(this.time===F&&(this.time=new u(i.time)),E(!0,a.options.time,i.time)),D(i,function(t,e){a[e]&&"function"==typeof a[e].update?a[e].update(t,!1):"function"==typeof a[s[e]]?a[s[e]](t):"colors"!==e&&-1===a.collectionsWithUpdate.indexOf(e)&&E(!0,a.options[e],i[e]),"chart"!==e&&-1!==a.propsRequireUpdateSeries.indexOf(e)&&(h=!0)}),this.collectionsWithUpdate.forEach(function(o){i[o]&&(R(i[o]).forEach(function(t,e){var i=M(t.id);let s;(s=!(s=i?a.get(t.id):s)&&a[o]&&(s=a[o][B(t.index,e)])&&(i&&M(s.options.id)||s.options.isInternal)?void 0:s)&&s.coll===o&&(s.update(t,!1),r)&&(s.touched=!0),!s&&r&&a.collectionsWithInit[o]&&(a.collectionsWithInit[o][0].apply(a,[t].concat(a.collectionsWithInit[o][1]||[]).concat([!1])).touched=!0)}),r)&&a[o].forEach(function(t){t.touched||t.options.isInternal?delete t.touched:n.push(t)})}),n.forEach(function(t){t.chart&&t.remove&&t.remove(!1)}),l&&a.axes.forEach(function(t){t.update({},!1)}),h&&a.getSeriesOrderByLinks().forEach(function(t){t.chart&&t.update({},!1)},this),c&&c.width),c=c&&(L(c.height)?j(c.height,p||a.chartWidth):c.height);d||P(p)&&p!==a.chartWidth||P(c)&&c!==a.chartHeight?a.setSize(p,c,e):B(t,!0)&&a.redraw(e),w(a,"afterUpdate",{options:i,redraw:t,animation:e})}setSubtitle(t,e){this.applyDescription("subtitle",t),this.layOutTitles(e)}setCaption(t,e){this.applyDescription("caption",t),this.layOutTitles(e)}showResetZoom(){const t=this,e=l.lang,i=t.zooming.resetButton,s=i.theme,o="chart"===i.relativeTo||"spacingBox"===i.relativeTo?null:"scrollablePlotBox";function r(){t.zoomOut()}w(this,"beforeShowResetZoom",null,function(){t.resetZoomButton=t.renderer.button(e.resetZoom,null,null,r,s).attr({align:i.position.align,title:e.resetZoomTitle}).addClass("highcharts-reset-zoom").add().align(i.position,!1,o)}),w(this,"afterShowResetZoom")}zoomOut(){w(this,"selection",{resetSelection:!0},this.zoom)}zoom(t){const a=this,n=a.pointer;let l=!1,h;!t||t.resetSelection?(a.axes.forEach(function(t){h=t.zoom()}),n.initiated=!1):t.xAxis.concat(t.yAxis).forEach(function(t){var e=t.axis,i=e.isXAxis,{hasPinched:s,mouseDownX:o,mouseDownY:r}=n;(n[i?"zoomX":"zoomY"]&&M(o)&&M(r)&&a.isInsidePlot(o-a.plotLeft,r-a.plotTop,{axis:e,ignoreX:s,ignoreY:s})||!M(a.inverted?o:r))&&(h=e.zoom(t.min,t.max),e.displayBtn)&&(l=!0)});var e=a.resetZoomButton;l&&!e?a.showResetZoom():!l&&O(e)&&(a.resetZoomButton=e.destroy()),h&&a.redraw(B(a.options.chart.animation,t&&t.animation,a.pointCount<100))}pan(g,t){const f=this,e=f.hoverPoints,i="object"==typeof t?t:{enabled:t,type:"x"},s=f.options.chart,m=(s&&s.panning&&(s.panning=i),i.type);let x;w(this,"pan",{originalEvent:g},function(){e&&e.forEach(function(t){t.setState()});let t=f.xAxis;"xy"===m?t=t.concat(f.yAxis):"y"===m&&(t=f.yAxis);const u={};t.forEach(function(o){if(o.options.panningEnabled&&!o.options.isInternal){var r=o.horiz,a=g[r?"chartX":"chartY"],r=r?"mouseDownX":"mouseDownY",n=f[r],l=o.minPointOffset||0,h=o.reversed&&!f.inverted||!o.reversed&&f.inverted?-1:1,d=o.getExtremes(),c=o.toValue(n-a,!0)+l*h,n=o.toValue(n+o.len-a,!0)-(l*h||o.isXAxis&&o.pointRangePadding||0),h=n<c,p=o.hasVerticalPanning();let t=h?n:c,e=h?c:n,i=o.panningState,s;!p||o.isXAxis||i&&!i.isDirty||o.series.forEach(function(t){var e=t.getProcessedData(!0),e=t.getExtremes(e.yData,!0);i=i||{startMin:Number.MAX_VALUE,startMax:-Number.MAX_VALUE},P(e.dataMin)&&P(e.dataMax)&&(i.startMin=Math.min(B(t.options.threshold,Infinity),e.dataMin,i.startMin),i.startMax=Math.max(B(t.options.threshold,-Infinity),e.dataMax,i.startMax))});h=Math.min(B(i&&i.startMin,d.dataMin),l?d.min:o.toValue(o.toPixels(d.min)-o.minPixelPadding)),c=Math.max(B(i&&i.startMax,d.dataMax),l?d.max:o.toValue(o.toPixels(d.max)+o.minPixelPadding));o.panningState=i,o.isOrdinal||(0<(s=h-t)&&(e+=s,t=h),0<(s=e-c)&&(e=c,t-=s),o.series.length&&t!==d.min&&e!==d.max&&t>=h&&e<=c&&(o.setExtremes(t,e,!1,!1,{trigger:"pan"}),!f.resetZoomButton&&t!==h&&e!==c&&m.match("y")&&(f.showResetZoom(),o.displayBtn=!1),x=!0),u[r]=a)}}),D(u,(t,e)=>{f[e]=t}),x&&f.redraw(!1),b(f.container,{cursor:"move"})})}}return C(z.prototype,{callbacks:[],collectionsWithInit:{xAxis:[z.prototype.addAxis,[!0]],yAxis:[z.prototype.addAxis,[!1]],series:[z.prototype.addSeries]},collectionsWithUpdate:["xAxis","yAxis","series"],propsRequireDirtyBox:["backgroundColor","borderColor","borderWidth","borderRadius","plotBackgroundColor","plotBackgroundImage","plotBorderColor","plotBorderWidth","plotShadow","shadow"],propsRequireReflow:["margin","marginTop","marginRight","marginBottom","marginLeft","spacing","spacingTop","spacingRight","spacingBottom","spacingLeft"],propsRequireUpdateSeries:["chart.inverted","chart.polar","chart.ignoreHiddenSeries","chart.type","colors","plotOptions","time","tooltip"]}),z}),e(t,"Extensions/ScrollablePlotArea.js",[t["Core/Animation/AnimationUtilities.js"],t["Core/Globals.js"],t["Core/Renderer/RendererRegistry.js"],t["Core/Utilities.js"]],function(t,e,y,i){const b=t["stop"],s=e["composed"],{addEvent:M,createElement:S,css:k,defined:l,extend:o,merge:h,pick:C,pushUnique:r}=i;function a(){var{axisOffset:t,chartWidth:e,chartHeight:i,container:s,plotHeight:o,plotLeft:r,plotTop:a,plotWidth:n,scrollablePixelsX:l=0,scrollablePixelsY:h=0,scrollingContainer:d}=this,c=!this.fixedDiv,p=this.options.chart,u=p.scrollablePlotArea,{scrollPositionX:g,scrollPositionY:f}=u,m=y.getRendererType();let x=this["fixedRenderer"];x?x.setSize(e,i):(this.fixedDiv=S("div",{className:"highcharts-fixed"},{position:"absolute",overflow:"hidden",pointerEvents:"none",zIndex:(p.style?.zIndex||0)+2,top:0},void 0,!0),d?.parentNode.insertBefore(this.fixedDiv,d),k(this.renderTo,{overflow:"visible"}),this.fixedRenderer=x=new m(this.fixedDiv,e,i,p.style),this.scrollableMask=x.path().attr({fill:p.backgroundColor||"#fff","fill-opacity":C(u.opacity,.85),zIndex:-1}).addClass("highcharts-scrollable-mask").add(),M(this,"afterShowResetZoom",this.moveFixedElements),M(this,"afterApplyDrilldown",this.moveFixedElements),M(this,"afterLayOutTitles",this.moveFixedElements)),(this.scrollableDirty||c)&&(this.scrollableDirty=!1,this.moveFixedElements());m=e+l,p=i+h,b(this.container),k(s,{width:m+"px",height:p+"px"}),this.renderer.boxWrapper.attr({width:m,height:p,viewBox:[0,0,m,p].join(" ")}),this.chartBackground?.attr({width:m,height:p}),d&&(k(d,{width:this.chartWidth+"px",height:this.chartHeight+"px"}),c)&&(g&&(d.scrollLeft=l*g),f)&&(d.scrollTop=h*f),u=a-t[0]-1,s=r-t[3]-1,m=a+o+t[2]+1,p=r+n+t[1]+1,c=r+n-l,g=a+o-h;let v;v=l?[["M",0,u],["L",r-1,u],["L",r-1,m],["L",0,m],["Z"],["M",c,u],["L",e,u],["L",e,m],["L",c,m],["Z"]]:h?[["M",s,0],["L",s,a-1],["L",p,a-1],["L",p,0],["Z"],["M",s,g],["L",s,i],["L",p,i],["L",p,g],["Z"]]:[["M",0,0]],"adjustHeight"!==this.redrawTrigger&&this.scrollableMask?.attr({d:v})}function n(){const t=this.container,e=this.fixedRenderer,i=[".highcharts-breadcrumbs-group",".highcharts-contextbutton",".highcharts-caption",".highcharts-credits",".highcharts-legend",".highcharts-legend-checkbox",".highcharts-navigator-series",".highcharts-navigator-xaxis",".highcharts-navigator-yaxis",".highcharts-navigator",".highcharts-reset-zoom",".highcharts-drillup-button",".highcharts-scrollbar",".highcharts-subtitle",".highcharts-title"];let s;this.scrollablePixelsX&&!this.inverted?s=".highcharts-yaxis":this.scrollablePixelsX&&this.inverted||this.scrollablePixelsY&&!this.inverted?s=".highcharts-xaxis":this.scrollablePixelsY&&this.inverted&&(s=".highcharts-yaxis"),s&&i.push(s+":not(.highcharts-radial-axis)",s+"-labels:not(.highcharts-radial-axis-labels)");for(const o of i)[].forEach.call(t.querySelectorAll(o),t=>{(t.namespaceURI===e.SVG_NS?e.box:e.box.parentNode).appendChild(t),t.style.pointerEvents="auto"})}function d(){var t={WebkitOverflowScrolling:"touch",overflowX:"hidden",overflowY:"hidden"};this.scrollablePixelsX&&(t.overflowX="auto"),this.scrollablePixelsY&&(t.overflowY="auto"),this.scrollingParent=S("div",{className:"highcharts-scrolling-parent"},{position:"relative"},this.renderTo),this.scrollingContainer=S("div",{className:"highcharts-scrolling"},t,this.scrollingParent);let e;M(this.scrollingContainer,"scroll",()=>{this.pointer&&(delete this.pointer.chartPosition,this.hoverPoint&&(e=this.hoverPoint),this.pointer.runPointActions(void 0,e,!0))}),this.innerContainer=S("div",{className:"highcharts-inner-container"},null,this.scrollingContainer),this.innerContainer.appendChild(this.container),this.setUpScrolling=null}function c(){this.chart.scrollableDirty=!0}function p(t){var e=this.options.chart.scrollablePlotArea,i=e&&e.minWidth,e=e&&e.minHeight;let s,o,r;if(!this.renderer.forExport&&(i?(this.scrollablePixelsX=s=Math.max(0,i-this.chartWidth),s&&(this.scrollablePlotBox=this.renderer.scrollablePlotBox=h(this.plotBox),this.plotBox.width=this.plotWidth+=s,this.inverted?this.clipBox.height+=s:this.clipBox.width+=s,r={1:{name:"right",value:s}})):e&&(this.scrollablePixelsY=o=Math.max(0,e-this.chartHeight),l(o))&&(this.scrollablePlotBox=this.renderer.scrollablePlotBox=h(this.plotBox),this.plotBox.height=this.plotHeight+=o,this.inverted?this.clipBox.width+=o:this.clipBox.height+=o,r={2:{name:"bottom",value:o}}),r)&&!t.skipAxes)for(const a of this.axes)if(r[a.side]){const n=a.getPlotLinePath;a.getPlotLinePath=function(){var t=r[a.side].name,e=r[a.side].value,i=this[t],e=(this[t]=i-e,n.apply(this,arguments));return this[t]=i,e}}else a.setAxisSize(),a.setAxisTranslation()}function u(){this.scrollablePixelsX||this.scrollablePixelsY?(this.setUpScrolling&&this.setUpScrolling(),this.applyFixed()):this.fixedDiv&&this.applyFixed()}function g(){this.chart.scrollableDirty=!0}return{compose:function f(t,e,i){r(s,f)&&(M(t,"afterInit",c),o(e.prototype,{applyFixed:a,moveFixedElements:n,setUpScrolling:d}),M(e,"afterSetChartSize",p),M(e,"render",u),M(i,"show",g))}}}),e(t,"Core/Axis/Stacking/StackItem.js",[t["Core/Templating.js"],t["Core/Series/SeriesRegistry.js"],t["Core/Utilities.js"]],function(t,e,i){const o=t["format"],p=e["series"],{destroyObjectProperties:s,fireEvent:u,isNumber:g,pick:f}=i;class r{constructor(t,e,i,s,o){var r=t.chart.inverted,a=t.reversed,t=(this.axis=t,this.isNegative=!!i!=!!a);this.options=e=e||{},this.x=s,this.total=null,this.cumulative=null,this.points={},this.hasValidPoints=!1,this.stack=o,this.leftCliff=0,this.rightCliff=0,this.alignOptions={align:e.align||(r?t?"left":"right":"center"),verticalAlign:e.verticalAlign||(r?"middle":t?"bottom":"top"),y:e.y,x:e.x},this.textAlign=e.textAlign||(r?t?"right":"left":"center")}destroy(){s(this,this.axis)}render(t){var e=this.axis.chart,i=this.options,s=i.format,s=s?o(s,this,e):i.formatter.call(this);this.label?this.label.attr({text:s,visibility:"hidden"}):(this.label=e.renderer.label(s,null,void 0,i.shape,void 0,void 0,i.useHTML,!1,"stack-labels"),s={r:i.borderRadius||0,text:s,padding:f(i.padding,5),visibility:"hidden"},e.styledMode||(s.fill=i.backgroundColor,s.stroke=i.borderColor,s["stroke-width"]=i.borderWidth,this.label.css(i.style||{})),this.label.attr(s),this.label.added||this.label.add(t)),this.label.labelrank=e.plotSizeY,u(this,"afterRender")}setOffset(t,e,i,s,o,r){var{alignOptions:a,axis:n,label:l,options:h,textAlign:d}=this,c=n.chart,i=this.getStackBox({xOffset:t,width:e,boxBottom:i,boxTop:s,defaultX:o,xAxis:r}),s=a["verticalAlign"];if(l&&i){o=l.getBBox(),r=l.padding;let t="justify"===f(h.overflow,"justify"),e;a.x=h.x||0,a.y=h.y||0;var{x:s,y:d}=this.adjustStackPosition({labelBox:o,verticalAlign:s,textAlign:d});i.x-=s,i.y-=d,l.align(a,!1,i),e=c.isInsidePlot(l.alignAttr.x+a.x+s,l.alignAttr.y+a.y+d),(t=e?t:!1)&&p.prototype.justifyDataLabel.call(n,l,a,l.alignAttr,o,i),l.attr({x:l.alignAttr.x,y:l.alignAttr.y,rotation:h.rotation,rotationOriginX:o.width/2,rotationOriginY:o.height/2}),l[(e=f(!t&&h.crop,!0)?g(l.x)&&g(l.y)&&c.isInsidePlot(l.x-r+(l.width||0),l.y)&&c.isInsidePlot(l.x+r,l.y):e)?"show":"hide"]()}u(this,"afterSetOffset",{xOffset:t,width:e})}adjustStackPosition({labelBox:t,verticalAlign:e,textAlign:i}){var s={bottom:0,middle:1,top:2,right:1,center:0,left:-1};return{x:t.width/2+t.width/2*s[i],y:t.height/2*s[e]}}getStackBox(t){var e=this.axis,i=e.chart,{boxTop:s,defaultX:o,xOffset:r,width:a,boxBottom:n}=t,s=e.stacking.usePercentage?100:f(s,this.total,0),s=e.toPixels(s),t=t.xAxis||i.xAxis[0],o=f(o,t.translate(this.x))+r,r=e.toPixels(n||g(e.min)&&e.logarithmic&&e.logarithmic.lin2log(e.min)||0),n=Math.abs(s-r),e=i.inverted,r=this.isNegative;return e?{x:(r?s:s-n)-i.plotLeft,y:t.height-o-a,width:n,height:a}:{x:o+t.transB-i.plotLeft,y:(r?s-n:s)-i.plotTop,width:a,height:n}}}return r}),e(t,"Core/Axis/Stacking/StackingAxis.js",[t["Core/Animation/AnimationUtilities.js"],t["Core/Axis/Axis.js"],t["Core/Globals.js"],t["Core/Series/SeriesRegistry.js"],t["Core/Axis/Stacking/StackItem.js"],t["Core/Utilities.js"]],function(t,e,i,s,T,o){const n=t["getDeferredAnimation"],r=i["composed"],{prototype:a}=s["series"],{addEvent:l,correctFloat:P,defined:O,destroyObjectProperties:h,fireEvent:d,isArray:L,isNumber:c,objectEach:p,pick:E,pushUnique:u}=o;function g(){const i=this.inverted;this.axes.forEach(t=>{t.stacking&&t.stacking.stacks&&t.hasVisibleSeries&&(t.stacking.oldStacks=t.stacking.stacks)}),this.series.forEach(t=>{var e=t.xAxis&&t.xAxis.options||{};t.options.stacking&&t.reserveSpace()&&(t.stackKey=[t.type,E(t.options.stack,""),i?e.top:e.left,i?e.height:e.width].join(","))})}function f(){var t=this.stacking;if(t){const i=t.stacks;p(i,(t,e)=>{h(t),delete i[e]}),t.stackTotalGroup?.destroy()}}function m(){this.stacking||(this.stacking=new S(this))}function x(t,e,i,s){return!O(t)||t.x!==e||s&&t.stackKey!==s?t={x:e,index:0,key:s,stackKey:s}:t.index++,t.key=[i,e,t.index].join(","),t}function v(){const r=this,t=r.yAxis,e=r.stackKey||"",a=t.stacking.stacks,n=r.processedXData,i=r.options.stacking,l=r[i+"Stacker"];let h;l&&[e,"-"+e].forEach(t=>{let e=n.length,i,s,o;for(;e--;)i=n[e],h=r.getStackIndicator(h,i,r.index,t),(o=(s=a[t]?.[i])?.points[h.key||""])&&l.call(r,o,s,e)})}function y(t,e,i){e=e.total?100/e.total:0;t[0]=P(t[0]*e),t[1]=P(t[1]*e),this.stackedYData[i]=t[1]}function b(t){(this.is("column")||this.is("columnrange"))&&(this.options.centerInCategory&&!this.options.stacking&&1<this.chart.series.length?a.setStackedPoints.call(this,t,"group"):t.stacking.resetStacks())}function M(d,t){var c=t||this.options.stacking;if(c&&this.reserveSpace()&&({group:"xAxis"}[c]||"yAxis")===d.coll){var p=this,u=p.processedXData,g=p.processedYData,f=[],m=g.length,x=p.options,v=x.threshold||0,y=x.startFromThreshold?v:0,b=x.stack,M=t?p.type+","+c:p.stackKey||"",S="-"+M,k=p.negStacks,C=d.stacking,A=C.stacks,w=C.oldStacks;let e,i,s,o,r,a,n,l,h;for(C.stacksTouched+=1,n=0;n<m;n++){l=u[n],h=g[n],a=(e=p.getStackIndicator(e,l,p.index)).key||"",A[r=(i=k&&h<(y?0:v))?S:M]||(A[r]={}),A[r][l]||(w[r]?.[l]?(A[r][l]=w[r][l],A[r][l].total=null):A[r][l]=new T(d,d.options.stackLabels,!!i,l,b)),s=A[r][l],null!==h?(s.points[a]=s.points[p.index]=[E(s.cumulative,y)],O(s.cumulative)||(s.base=a),s.touched=C.stacksTouched,0<e.index&&!1===p.singleStacks&&(s.points[a][0]=s.points[p.index+","+l+",0"][0])):(delete s.points[a],delete s.points[p.index]);let t=s.total||0;"percent"===c?(o=i?M:S,t=k&&A[o]?.[l]?(o=A[o][l]).total=Math.max(o.total||0,t)+Math.abs(h)||0:P(t+(Math.abs(h)||0))):"group"===c?null!==(h=L(h)?h[0]:h)&&t++:t=P(t+(h||0)),s.cumulative="group"===c?(t||1)-1:P(E(s.cumulative,y)+(h||0)),s.total=t,null!==h&&(s.points[a].push(s.cumulative),f[n]=s.cumulative,s.hasValidPoints=!0)}"percent"===c&&(C.usePercentage=!0),"group"!==c&&(this.stackedYData=f),C.oldStacks={}}}class S{constructor(t){this.oldStacks={},this.stacks={},this.stacksTouched=0,this.axis=t}buildStacks(){var t=this.axis,e=t.series,i="xAxis"===t.coll,s=t.options.reversedStacks,o=e.length;let r,a;for(this.resetStacks(),this.usePercentage=!1,a=o;a--;)r=e[s?a:o-a-1],i&&r.setGroupedPoints(t),r.setStackedPoints(t);if(!i)for(a=0;a<o;a++)e[a].modifyStacks();d(t,"afterBuildStacks")}cleanStacks(){this.oldStacks&&(this.stacks=this.oldStacks,p(this.stacks,t=>{p(t,t=>{t.cumulative=t.total})}))}resetStacks(){p(this.stacks,i=>{p(i,(t,e)=>{c(t.touched)&&t.touched<this.stacksTouched?(t.destroy(),delete i[e]):(t.total=null,t.cumulative=null)})})}renderStackTotals(){const t=this.axis,e=t.chart,i=e.renderer,s=this.stacks,o=t.options.stackLabels?.animation,r=n(e,o||!1),a=this.stackTotalGroup=this.stackTotalGroup||i.g("stack-labels").attr({zIndex:6,opacity:0}).add();a.translate(e.plotLeft,e.plotTop),p(s,t=>{p(t,t=>{t.render(a)})}),a.animate({opacity:1},r)}}var k;return(k||(k={})).compose=function C(t,e,i){u(r,C)&&(e=e.prototype,i=i.prototype,l(t,"init",m),l(t,"destroy",f),e.getStacks=g,i.getStackIndicator=x,i.modifyStacks=v,i.percentStacker=y,i.setGroupedPoints=b,i.setStackedPoints=M)},k}),e(t,"Series/Line/LineSeries.js",[t["Core/Series/Series.js"],t["Core/Series/SeriesRegistry.js"],t["Core/Utilities.js"]],function(t,e,i){const{defined:m,merge:h,isObject:d}=i;class s extends t{drawGraph(){const a=this.options,n=(this.gappedPath||this.getGraphPath).call(this),l=this.chart.styledMode;[this,...this.zones].forEach((t,e)=>{let i,s=t.graph;var o=s?"animate":"attr",r=t.dashStyle||a.dashStyle;s?(s.endX=this.preventGraphAnimation?null:n.xMap,s.animate({d:n})):n.length&&(t.graph=s=this.chart.renderer.path(n).addClass("highcharts-graph"+(e?` highcharts-zone-graph-${e-1} `:" ")+(e&&t.className||"")).attr({zIndex:1}).add(this.group)),s&&!l&&(i={stroke:!e&&a.lineColor||t.color||this.color||"#cccccc","stroke-width":a.lineWidth||0,fill:this.fillGraph&&this.color||"none"},r?i.dashstyle=r:"square"!==a.linecap&&(i["stroke-linecap"]=i["stroke-linejoin"]="round"),s[o](i).shadow(e<2&&a.shadow&&h({filterUnits:"userSpaceOnUse"},d(a.shadow)?a.shadow:{}))),s&&(s.startX=n.xMap,s.isArea=n.isArea)})}getGraphPath(n,l,h){const d=this,c=d.options,p=[],u=[];let g,f=c.step;var t=(n=n||d.points).reversed;return t&&n.reverse(),(f={right:1,center:2}[f]||f&&3)&&t&&(f=4-f),(n=this.getValidPoints(n,!1,!(c.connectNulls&&!l&&!h))).forEach(function(t,e){var i=t.plotX,s=t.plotY,o=n[e-1],r=t.isNull||"number"!=typeof s;let a;(t.leftCliff||o&&o.rightCliff)&&!h&&(g=!0),g=r&&!m(l)&&0<e?!c.connectNulls:!(!r||l)||(0===e||g?a=[["M",t.plotX,t.plotY]]:d.getPointSpline?a=[d.getPointSpline(n,t,e)]:f?(a=1===f?[["L",o.plotX,s]]:2===f?[["L",(o.plotX+i)/2,o.plotY],["L",(o.plotX+i)/2,s]]:[["L",i,o.plotY]]).push(["L",i,s]):a=[["L",i,s]],u.push(t.x),f&&(u.push(t.x),2===f)&&u.push(t.x),p.push.apply(p,a),!1)}),p.xMap=u,d.graphPath=p}}return s.defaultOptions=h(t.defaultOptions,{legendSymbol:"lineMarker"}),e.registerSeriesType("line",s),s}),e(t,"Series/Area/AreaSeries.js",[t["Core/Color/Color.js"],t["Core/Series/SeriesRegistry.js"],t["Core/Utilities.js"]],function(t,e,i){var{}=t;const{line:y}=e["seriesTypes"],{extend:s,merge:o,objectEach:a,pick:b}=i;class r extends y{drawGraph(){this.areaPath=[],super.drawGraph.apply(this);const{areaPath:a,options:n}=this;[this,...this.zones].forEach((t,e)=>{var i={},s=t.fillColor||n.fillColor;let o=t.area;var r=o?"animate":"attr";o?(o.endX=this.preventGraphAnimation?null:a.xMap,o.animate({d:a})):(i.zIndex=0,(o=t.area=this.chart.renderer.path(a).addClass("highcharts-area"+(e?` highcharts-zone-area-${e-1} `:" ")+(e&&t.className||"")).add(this.group)).isArea=!0),this.chart.styledMode||(i.fill=s||t.color||this.color,i["fill-opacity"]=s?1:n.fillOpacity??.75,o.css({pointerEvents:this.stickyTracking?"none":"auto"})),o[r](i),o.startX=a.xMap,o.shiftUnit=n.step?2:1})}getGraphPath(l){const t=y.prototype.getGraphPath,e=this.options,h=e.stacking,d=this.yAxis,c=[],p=[],u=this.index,g=d.stacking.stacks[this.stackKey],f=e.threshold,m=Math.round(d.getThreshold(e.threshold)),i=b(e.connectNulls,"percent"===h),s=function(t,e,i){var t=l[t],s=h&&g[t.x].points[u],o=t[i+"Null"]||0,i=t[i+"Cliff"]||0;let r,a,n=!0;i||o?(r=(o?s[0]:s[1])+i,a=s[0]+i,n=!!o):!h&&l[e]&&l[e].isNull&&(r=a=f),void 0!==r&&(p.push({plotX:x,plotY:null===r?m:d.getThreshold(r),isNull:n,isCliff:!0}),c.push({plotX:x,plotY:null===a?m:d.getThreshold(a),doCurve:!1}))};let x,o,r;l=l||this.points;for(let t=0,e=(l=h?this.getStackPoints(l):l).length;t<e;++t)h||(l[t].leftCliff=l[t].rightCliff=l[t].leftNull=l[t].rightNull=void 0),o=l[t].isNull,x=b(l[t].rectPlotX,l[t].plotX),r=h?b(l[t].yBottom,m):m,o&&!i||(i||s(t,t-1,"left"),o&&!h&&i||(p.push(l[t]),c.push({x:t,plotX:x,plotY:r})),i)||s(t,t+1,"right");var a=t.call(this,p,!0,!0),n=(c.reversed=!0,t.call(this,c,!0,!0)),v=n[0],v=(v&&"M"===v[0]&&(n[0]=["L",v[1],v[2]]),a.concat(n)),n=(v.length&&v.push(["Z"]),t.call(this,p,!1,i));return v.xMap=a.xMap,this.areaPath=v,n}getStackPoints(e){const d=this,s=[],c=[],o=this.xAxis,r=this.yAxis,p=r.stacking.stacks[this.stackKey],u={},g=r.series,f=g.length,m=r.options.reversedStacks?1:-1,x=g.indexOf(d);if(e=e||this.points,this.options.stacking){for(let t=0;t<e.length;t++)e[t].leftNull=e[t].rightNull=void 0,u[e[t].x]=e[t];a(p,function(t,e){null!==t.total&&c.push(e)}),c.sort(function(t,e){return t-e});const v=g.map(t=>t.visible);c.forEach(function(a,n){let e=0,l,h;if(u[a]&&!u[a].isNull)s.push(u[a]),[-1,1].forEach(function(t){var e=1===t?"rightNull":"leftNull",i=1===t?"rightCliff":"leftCliff",s=p[c[n+t]];let o=0;if(s){let t=x;for(;0<=t&&t<f;){var r=g[t].index;(l=s.points[r])||(r===d.index?u[a][e]=!0:v[t]&&(h=p[a].points[r])&&(o-=h[1]-h[0])),t+=m}}u[a][i]=o});else{let t=x;for(;0<=t&&t<f;){var i=g[t].index;if(l=p[a].points[i]){e=l[1];break}t+=m}e=b(e,0),e=r.translate(e,0,1,0,1),s.push({isNull:!0,plotX:o.translate(a,0,0,0,1),x:a,plotY:e,yBottom:e})}})}return s}}return r.defaultOptions=o(y.defaultOptions,{threshold:0,legendSymbol:"areaMarker"}),s(r.prototype,{singleStacks:!1}),e.registerSeriesType("area",r),r}),e(t,"Series/Spline/SplineSeries.js",[t["Core/Series/SeriesRegistry.js"],t["Core/Utilities.js"]],function(t,e){var i=t.seriesTypes["line"];const{merge:s,pick:u}=e;class o extends i{getPointSpline(e,i,s){var o=i.plotX||0,r=i.plotY||0,a=e[s-1],s=e[s+1];let n,l,h,d;function t(t){return t&&!t.isNull&&!1!==t.doCurve&&!i.isCliff}if(t(a)&&t(s)){var e=a.plotX||0,c=a.plotY||0,p=s.plotX||0,s=s.plotY||0;let t=0;n=(1.5*o+e)/2.5,l=(1.5*r+c)/2.5,h=(1.5*o+p)/2.5,d=(1.5*r+s)/2.5,h!==n&&(t=(d-l)*(h-o)/(h-n)+r-d),l+=t,d+=t,l>c&&l>r?(l=Math.max(c,r),d=2*r-l):l<c&&l<r&&(l=Math.min(c,r),d=2*r-l),d>s&&d>r?(d=Math.max(s,r),l=2*r-d):d<s&&d<r&&(d=Math.min(s,r),l=2*r-d),i.rightContX=h,i.rightContY=d,i.controlPoints={low:[n,l],high:[h,d]}}e=["C",u(a.rightContX,a.plotX,0),u(a.rightContY,a.plotY,0),u(n,o,0),u(l,r,0),o,r];return a.rightContX=a.rightContY=void 0,e}}return o.defaultOptions=s(i.defaultOptions),t.registerSeriesType("spline",o),o}),e(t,"Series/AreaSpline/AreaSplineSeries.js",[t["Series/Spline/SplineSeries.js"],t["Core/Series/SeriesRegistry.js"],t["Core/Utilities.js"]],function(t,e,i){var{area:s,area:{prototype:o}}=e.seriesTypes,{extend:i,merge:r}=i;class a extends t{}return a.defaultOptions=r(t.defaultOptions,s.defaultOptions),i(a.prototype,{getGraphPath:o.getGraphPath,getStackPoints:o.getStackPoints,drawGraph:o.drawGraph}),e.registerSeriesType("areaspline",a),a}),e(t,"Series/Column/ColumnSeriesDefaults.js",[],function(){return{borderRadius:3,centerInCategory:!1,groupPadding:.2,marker:null,pointPadding:.1,minPointLength:0,cropThreshold:50,pointRange:null,states:{hover:{halo:!1,brightness:.1},select:{color:"#cccccc",borderColor:"#000000"}},dataLabels:{align:void 0,verticalAlign:void 0,y:void 0},startFromThreshold:!0,stickyTracking:!1,tooltip:{distance:6},threshold:0,borderColor:"#ffffff"}}),e(t,"Series/Column/ColumnSeries.js",[t["Core/Animation/AnimationUtilities.js"],t["Core/Color/Color.js"],t["Series/Column/ColumnSeriesDefaults.js"],t["Core/Globals.js"],t["Core/Series/Series.js"],t["Core/Series/SeriesRegistry.js"],t["Core/Utilities.js"]],function(t,e,i,s,o,r,a){const d=t["animObject"],u=e["parse"],{hasTouch:n,noop:l}=s,{clamp:C,defined:A,extend:c,fireEvent:h,isArray:p,isNumber:w,merge:g,pick:T,objectEach:f}=a;class m extends o{animate(t){const i=this,e=this.yAxis,s=e.pos,o=i.options,r=this.chart.inverted,a={},n=r?"translateX":"translateY";let l,h;t?(a.scaleY=.001,h=C(e.toPixels(o.threshold),s,s+e.len),r?a.translateX=h-e.len:a.translateY=h,i.clipBox&&i.setClip(),i.group.attr(a)):(l=Number(i.group.attr(n)),i.group.animate({scaleY:1},c(d(i.options.animation),{step:function(t,e){i.group&&(a[n]=l+e.pos*(s-l),i.group.attr(a))}})))}init(t,e){super.init.apply(this,arguments);const i=this;(t=i.chart).hasRendered&&t.series.forEach(function(t){t.type===i.type&&(t.isDirty=!0)})}getColumnMetrics(){const o=this,t=o.options,e=o.xAxis,r=o.yAxis,i=e.options.reversedStacks,s=e.reversed&&!i||!e.reversed&&i,a={};let n,l=0;!1===t.grouping?l=1:o.chart.series.forEach(function(t){var e=t.yAxis,i=t.options;let s;t.type===o.type&&t.reserveSpace()&&r.len===e.len&&r.pos===e.pos&&(i.stacking&&"group"!==i.stacking?(n=t.stackKey,"undefined"==typeof a[n]&&(a[n]=l++),s=a[n]):!1!==i.grouping&&(s=l++),t.columnIndex=s)});var h=Math.min(Math.abs(e.transA)*(!e.brokenAxis?.hasBreaks&&e.ordinal?.slope||t.pointRange||e.closestPointRange||e.tickInterval||1),e.len),d=h*t.groupPadding,c=(h-2*d)/(l||1),p=Math.min(t.maxPointWidth||e.len,T(t.pointWidth,c*(1-2*t.pointPadding))),u=(o.columnIndex||0)+(s?1:0);return o.columnMetrics={width:p,offset:(c-p)/2+(d+u*c-h/2)*(s?-1:1),paddedWidth:c,columnCount:l},o.columnMetrics}crispCol(t,e,i,s){this.chart;var o=this.borderWidth,r=-(o%2?.5:0),o=o%2?.5:1,r=(this.options.crisp&&(i=Math.round(t+i)+r-(t=Math.round(t)+r)),Math.round(e+s)+o),a=Math.abs(e)<=.5&&.5<r;return s=r-(e=Math.round(e)+o),a&&s&&(--e,s+=1),{x:t,y:e,width:i,height:s}}adjustForMissingColumns(t,e,o,r){if(!o.isNull&&1<r.columnCount){const n=this.xAxis.series.filter(t=>t.visible).map(t=>t.index);let i=0,s=0;f(this.xAxis.stacking?.stacks,t=>{if("number"==typeof o.x){const e=t[o.x.toString()];e&&(t=e.points[this.index],p(t))&&(t=Object.keys(e.points).filter(t=>!t.match(",")&&e.points[t]&&1<e.points[t].length).map(parseFloat).filter(t=>-1!==n.indexOf(t)).sort((t,e)=>e-t),i=t.indexOf(this.index),s=t.length)}});var a=(s-1)*r.paddedWidth+e;t=(o.plotX||0)+a/2-e-i*r.paddedWidth}return t}translate(){const d=this,c=d.chart,p=d.options,t=d.dense=d.closestPointRange*d.xAxis.transA<2,e=d.borderWidth=T(p.borderWidth,t?0:1),u=d.xAxis,g=d.yAxis,f=p.threshold,m=T(p.minPointLength,5),x=d.getColumnMetrics(),v=x.width,y=d.pointXOffset=x.offset,b=d.dataMin,M=d.dataMax;let S=d.barW=Math.max(v,1+2*e),k=d.translatedThreshold=g.getThreshold(f);c.inverted&&(k-=.5),p.pointPadding&&(S=Math.ceil(S)),o.prototype.translate.apply(d),d.points.forEach(function(t){var e=T(t.yBottom,k),i=999+Math.abs(e),s=t.plotX||0,i=C(t.plotY,-i,g.len+i);t.stackBox;let o,r=Math.min(i,e),a=Math.max(i,e)-r,n=v,l=s+y,h=S;m&&Math.abs(a)<m&&(a=m,o=!g.reversed&&!t.negative||g.reversed&&t.negative,w(f)&&w(M)&&t.y===f&&M<=f&&(g.min||0)<f&&(b!==M||(g.max||0)<=f)&&(o=!o,t.negative=!t.negative),r=Math.abs(r-k)>m?e-m:k-(o?m:0)),A(t.options.pointWidth)&&(n=h=Math.ceil(t.options.pointWidth),l-=Math.round((n-v)/2)),p.centerInCategory&&!p.stacking&&(l=d.adjustForMissingColumns(l,n,t,x)),t.barX=l,t.pointWidth=n,t.tooltipPos=c.inverted?[C(g.len+g.pos-c.plotLeft-i,g.pos-c.plotLeft,g.len+g.pos-c.plotLeft),u.len+u.pos-c.plotTop-l-h/2,a]:[u.left-c.plotLeft+l+h/2,C(i+g.pos-c.plotTop,g.pos-c.plotTop,g.len+g.pos-c.plotTop),a],t.shapeType=d.pointClass.prototype.shapeType||"roundedRect",t.shapeArgs=d.crispCol(l,t.isNull?k:r,h,t.isNull?0:a)}),h(this,"afterColumnTranslate")}drawGraph(){this.group[this.dense?"addClass":"removeClass"]("highcharts-dense-data")}pointAttribs(t,e){var i=this.options,s=this.pointAttrToOptions||{},o=s.stroke||"borderColor",s=s["stroke-width"]||"borderWidth";let r,a,n,l=t&&t.color||this.color,h=t&&t[o]||i[o]||l,d=t&&t.options.dashStyle||i.dashStyle,c=t&&t[s]||i[s]||this[s]||0,p=T(t&&t.opacity,i.opacity,1);t&&this.zones.length&&(a=t.getZone(),l=t.options.color||a&&(a.color||t.nonZonedColor)||this.color,a)&&(h=a.borderColor||h,d=a.dashStyle||d,c=a.borderWidth||c),e&&t&&(n=(r=g(i.states[e],t.options.states&&t.options.states[e]||{})).brightness,l=r.color||void 0!==n&&u(l).brighten(r.brightness).get()||l,h=r[o]||h,c=r[s]||c,d=r.dashStyle||d,p=T(r.opacity,p));i={fill:l,stroke:h,"stroke-width":c,opacity:p};return d&&(i.dashstyle=d),i}drawPoints(t=this.points){const r=this,a=this.chart,n=r.options,l=a.renderer,h=n.animationLimit||250;let d;t.forEach(function(t){var e=t.plotY;let i=t.graphic,s=!!i,o=i&&a.pointCount<h?"animate":"attr";w(e)&&null!==t.y?(d=t.shapeArgs,i&&t.hasNewShapeType()&&(i=i.destroy()),r.enabledDataSorting&&(t.startXPos=r.xAxis.reversed?-(d&&d.width||0):r.xAxis.width),i||(t.graphic=i=l[t.shapeType](d).add(t.group||r.group),i&&r.enabledDataSorting&&a.hasRendered&&a.pointCount<h&&(i.attr({x:t.startXPos}),s=!0,o="animate")),i&&s&&i[o](g(d)),a.styledMode||i[o](r.pointAttribs(t,t.selected&&"select")).shadow(!1!==t.allowShadow&&n.shadow),i&&(i.addClass(t.getClassName(),!0),i.attr({visibility:t.visible?"inherit":"hidden"}))):i&&(t.graphic=i.destroy())})}drawTracker(t=this.points){const i=this,e=i.chart,s=e.pointer,o=function(t){var e=s.getPointFromEvent(t);void 0!==e&&i.options.enableMouseTracking&&(s.isDirectTouch=!0,e.onMouseOver(t))};let r;t.forEach(function(e){r=p(e.dataLabels)?e.dataLabels:e.dataLabel?[e.dataLabel]:[],e.graphic&&(e.graphic.element.point=e),r.forEach(function(t){t.div?t.div.point=e:t.element.point=e})}),i._hasTracking||(i.trackerGroups.forEach(function(t){i[t]&&(i[t].addClass("highcharts-tracker").on("mouseover",o).on("mouseout",function(t){s.onTrackerMouseOut(t)}),n&&i[t].on("touchstart",o),!e.styledMode)&&i.options.cursor&&i[t].css({cursor:i.options.cursor})}),i._hasTracking=!0),h(this,"afterDrawTracker")}remove(){const e=this,t=e.chart;t.hasRendered&&t.series.forEach(function(t){t.type===e.type&&(t.isDirty=!0)}),o.prototype.remove.apply(e,arguments)}}return m.defaultOptions=g(o.defaultOptions,i),c(m.prototype,{directTouch:!0,getSymbol:l,negStacks:!0,trackerGroups:["group","dataLabelsGroup"]}),r.registerSeriesType("column",m),m}),e(t,"Core/Series/DataLabel.js",[t["Core/Animation/AnimationUtilities.js"],t["Core/Templating.js"],t["Core/Globals.js"],t["Core/Utilities.js"]],function(t,e,i,s){const n=t["getDeferredAnimation"],k=e["format"],o=i["composed"],{defined:C,extend:S,fireEvent:l,isArray:r,isString:A,merge:a,objectEach:w,pick:T,pInt:P,pushUnique:h,splat:d}=s;var c;function p(){return L(this).some(t=>t?.enabled)}function u(e,i,s,o,r){const a=this,n=this.chart,t=this.isCartesian&&n.inverted,l=this.enabledDataSorting,h=e.plotX,d=e.plotY,c=s.rotation,p=s.align,u=C(h)&&C(d)&&n.isInsidePlot(h,Math.round(d),{inverted:t,paneCoordinates:!0,series:a}),g=t=>{l&&a.xAxis&&!v&&a.setDataLabelStartPos(e,i,r,u,t)};let f,m,x,v="justify"===T(s.overflow,l?"none":"justify"),y=this.visible&&!1!==e.visible&&C(h)&&(e.series.forceDL||l&&!v||u||T(s.inside,!!this.options.stacking)&&o&&n.isInsidePlot(h,t?o.x+1:o.y+o.height-1,{inverted:t,paneCoordinates:!0,series:a}));var b,M=e.pos();if(y&&M){c&&i.attr({align:p});let t=i.getBBox(!0),e=[0,0];f=n.renderer.fontMetrics(i).b,o=S({x:M[0],y:Math.round(M[1]),width:0,height:0},o),S(s,{width:t.width,height:t.height}),c?(v=!1,m=n.renderer.rotCorr(f,c),x={x:o.x+(s.x||0)+o.width/2+m.x,y:o.y+(s.y||0)+{top:0,middle:.5,bottom:1}[s.verticalAlign]*o.height},e=[t.x-Number(i.attr("x")),t.y-Number(i.attr("y"))],g(x),i[r?"attr":"animate"](x)):(g(o),i.align(s,void 0,o),x=i.alignAttr),v&&0<=o.height?this.justifyDataLabel(i,s,x,t,o,r):T(s.crop,!0)&&({x:o,y:b}=x,o+=e[0],b+=e[1],y=n.isInsidePlot(o,b,{paneCoordinates:!0,series:a})&&n.isInsidePlot(o+t.width,b+t.height,{paneCoordinates:!0,series:a})),s.shape&&!c&&i[r?"attr":"animate"]({anchorX:M[0],anchorY:M[1]})}r&&l&&(i.placed=!1),y||l&&!v?i.show():(i.hide(),i.placed=!1)}function g(){return this.plotGroup("dataLabelsGroup","data-labels",this.hasRendered?"inherit":"hidden",this.options.dataLabels.zIndex||6)}function f(t){var e=this.hasRendered||0,i=this.initDataLabelsGroup().attr({opacity:+e});return!e&&i&&(this.visible&&i.show(),this.options.animation?i.animate({opacity:1},t):i.attr({opacity:1})),i}function m(t){t=t||this.points;const x=this,v=x.chart,y=x.options,b=v.renderer,{backgroundColor:e,plotBackgroundColor:i}=v.options.chart,M=b.getContrast(A(i)&&i||A(e)&&e||"#000000"),s=L(x);let o,S;var{animation:r,defer:a}=s[0],a=a?n(v,r,x):{defer:0,duration:0};l(this,"drawDataLabels"),x.hasDataLabels?.()&&(S=this.initDataLabels(a),t.forEach(f=>{const m=f.dataLabels||[];(o=d(O(s,f.dlOptions||f.options?.dataLabels))).forEach((t,e)=>{var i=t.enabled&&f.visible&&(!f.isNull||f.dataLabelOnNull)&&(s=f,!(o=(o=t).filter)||(i=o.operator,s=s[o.property],o=o.value,">"===i&&o<s)||"<"===i&&s<o||">="===i&&o<=s||"<="===i&&s<=o||"=="===i&&s==o||"==="===i&&s===o||"!="===i&&s!=o||"!=="===i&&s!==o),{backgroundColor:s,borderColor:o,distance:r,style:a={}}=t;let n,l,h,d,c={},p=m[e],u=!p,g;i&&(l=T(t[f.formatPrefix+"Format"],t.format),n=f.getLabelConfig(),h=C(l)?k(l,n,v):(t[f.formatPrefix+"Formatter"]||t.formatter).call(n,t),d=t.rotation,v.styledMode||(a.color=T(t.color,a.color,A(x.color)?x.color:void 0,"#000000"),"contrast"===a.color?("none"!==s&&(g=s),f.contrastColor=b.getContrast("auto"!==g&&g||f.color||x.color),a.color=g||!C(r)&&t.inside||P(r||0)<0||y.stacking?f.contrastColor:M):delete f.contrastColor,y.cursor&&(a.cursor=y.cursor)),c={r:t.borderRadius||0,rotation:d,padding:t.padding,zIndex:1},v.styledMode||(c.fill="auto"===s?f.color:s,c.stroke="auto"===o?f.color:o,c["stroke-width"]=t.borderWidth),w(c,(t,e)=>{void 0===t&&delete c[e]})),!p||i&&C(h)&&!!p.div==!!t.useHTML&&(p.rotation&&t.rotation||p.rotation===t.rotation)||(p=void 0,u=!0),i&&C(h)&&(p?c.text=h:(p=d?b.text(h,0,0,t.useHTML).addClass("highcharts-data-label"):b.label(h,0,0,t.shape,void 0,void 0,t.useHTML,void 0,"data-label"))&&p.addClass(" highcharts-data-label-color-"+f.colorIndex+" "+(t.className||"")+(t.useHTML?" highcharts-tracker":"")),p)&&(p.options=t,p.attr(c),v.styledMode||p.css(a).shadow(t.shadow),(r=t[f.formatPrefix+"TextPath"]||t.textPath)&&!t.useHTML&&(p.setTextPath(f.getDataLabelPath?.(p)||f.graphic,r),f.dataLabelPath)&&!r.enabled&&(f.dataLabelPath=f.dataLabelPath.destroy()),p.added||p.add(S),x.alignDataLabel(f,p,t,void 0,u),p.isActive=!0,m[e]&&m[e]!==p&&m[e].destroy(),m[e]=p)});let t=m.length;for(;t--;)m[t]&&m[t].isActive?m[t].isActive=!1:(m[t]?.destroy(),m.splice(t,1));f.dataLabel=m[0],f.dataLabels=m})),l(this,"afterDrawDataLabels")}function x(t,e,i,s,o,r){var a=this.chart,n=e.align,l=e.verticalAlign,h=!t.box&&t.padding||0;let{x:d=0,y:c=0}=e,p,u;return(p=(i.x||0)+h)<0&&("right"===n&&0<=d?(e.align="left",e.inside=!0):d-=p,u=!0),(p=(i.x||0)+s.width-h)>a.plotWidth&&("left"===n&&d<=0?(e.align="right",e.inside=!0):d+=a.plotWidth-p,u=!0),(p=i.y+h)<0&&("bottom"===l&&0<=c?(e.verticalAlign="top",e.inside=!0):c-=p,u=!0),(p=(i.y||0)+s.height-h)>a.plotHeight&&("top"===l&&c<=0?(e.verticalAlign="bottom",e.inside=!0):c+=a.plotHeight-p,u=!0),u&&(e.x=d,e.y=c,t.placed=!r,t.align(e,void 0,o)),u}function O(e,i){let t=[],s;if(r(e)&&!r(i))t=e.map(function(t){return a(t,i)});else if(r(i)&&!r(e))t=i.map(function(t){return a(e,t)});else if(r(e)||r(i)){if(r(e)&&r(i))for(s=Math.max(e.length,i.length);s--;)t[s]=a(e[s],i[s])}else t=a(e,i);return t}function L(t){var e=t.chart.options.plotOptions;return d(O(O(e?.series?.dataLabels,e?.[t.type]?.dataLabels),t.options.dataLabels))}function v(t,e,i,s,o){var r=this.chart,a=r.inverted,n=this.xAxis,l=n.reversed,h=((a?e.height:e.width)||0)/2,t=t.pointWidth,t=t?t/2:0;e.startXPos=a?o.x:l?-h-t:n.width-h+t,e.startYPos=a?l?this.yAxis.height-h+t:-h-t:o.y,s?"hidden"===e.visibility&&(e.show(),e.attr({opacity:0}).animate({opacity:1})):e.attr({opacity:1}).animate({opacity:0},void 0,e.hide),r.hasRendered&&(i&&e.attr({x:e.startXPos,y:e.startYPos}),e.placed=!0)}return(c||(c={})).compose=function y(t){h(o,y)&&((t=t.prototype).initDataLabelsGroup=g,t.initDataLabels=f,t.alignDataLabel=u,t.drawDataLabels=m,t.justifyDataLabel=x,t.setDataLabelStartPos=v,t.hasDataLabels=p)},c}),e(t,"Series/Column/ColumnDataLabel.js",[t["Core/Series/DataLabel.js"],t["Core/Globals.js"],t["Core/Series/SeriesRegistry.js"],t["Core/Utilities.js"]],function(e,t,i,s){const o=t["composed"],c=i["series"],{merge:p,pick:u,pushUnique:r}=s;var a;function n(t,e,i,s,o){var r=this.chart.inverted,a=t.series,n=(a.xAxis?a.xAxis.len:this.chart.plotSizeX)||0,a=(a.yAxis?a.yAxis.len:this.chart.plotSizeY)||0,l=t.dlBox||t.shapeArgs,h=u(t.below,t.plotY>u(this.translatedThreshold,a)),d=u(i.inside,!!this.options.stacking);l&&(s=p(l),"allow"===i.overflow&&!1===i.crop||(s.y<0&&(s.height+=s.y,s.y=0),0<(l=s.y+s.height-a)&&l<s.height&&(s.height-=l)),r&&(s={x:a-s.y-s.height,y:n-s.x-s.width,width:s.height,height:s.width}),d||(r?(s.x+=h?0:s.width,s.width=0):(s.y+=h?s.height:0,s.height=0))),i.align=u(i.align,!r||d?"center":h?"right":"left"),i.verticalAlign=u(i.verticalAlign,r||d?"middle":h?"top":"bottom"),c.prototype.alignDataLabel.call(this,t,e,i,s,o),i.inside&&t.contrastColor&&e.css({color:t.contrastColor})}return(a||(a={})).compose=function l(t){e.compose(c),r(o,l)&&(t.prototype.alignDataLabel=n)},a}),e(t,"Series/Bar/BarSeries.js",[t["Series/Column/ColumnSeries.js"],t["Core/Series/SeriesRegistry.js"],t["Core/Utilities.js"]],function(t,e,i){var{extend:i,merge:s}=i;class o extends t{}return o.defaultOptions=s(t.defaultOptions,{}),i(o.prototype,{inverted:!0}),e.registerSeriesType("bar",o),o}),e(t,"Series/Scatter/ScatterSeriesDefaults.js",[],function(){return{lineWidth:0,findNearestPointBy:"xy",jitter:{x:0,y:0},marker:{enabled:!0},tooltip:{headerFormat:'<span style="color:{point.color}">●</span> <span style="font-size: 0.8em"> {series.name}</span><br/>',pointFormat:"x: <b>{point.x}</b><br/>y: <b>{point.y}</b><br/>"}}}),e(t,"Series/Scatter/ScatterSeries.js",[t["Series/Scatter/ScatterSeriesDefaults.js"],t["Core/Series/SeriesRegistry.js"],t["Core/Utilities.js"]],function(t,e,i){var{column:s,line:o}=e.seriesTypes,{addEvent:i,extend:r,merge:a}=i;class n extends o{applyJitter(){const l=this,h=this.options.jitter,d=this.points.length;h&&this.points.forEach(function(a,n){["x","y"].forEach(function(t,e){var i,s,o,r="plot"+t.toUpperCase();h[t]&&!a.isNull&&(s=l[t+"Axis"],o=h[t]*s.transA,s)&&!s.isLog&&(i=Math.max(0,a[r]-o),s=Math.min(s.len,a[r]+o),a[r]=i+(s-i)*(o=n+e*d,(o=1e4*Math.sin(o))-Math.floor(o)),"x"===t)&&(a.clientX=a.plotX)})})}drawGraph(){this.options.lineWidth?super.drawGraph():this.graph&&(this.graph=this.graph.destroy())}}return n.defaultOptions=a(o.defaultOptions,t),r(n.prototype,{drawTracker:s.prototype.drawTracker,sorted:!1,requireSorting:!1,noSharedTooltip:!0,trackerGroups:["group","markerGroup","dataLabelsGroup"]}),i(n,"afterTranslate",function(){this.applyJitter()}),e.registerSeriesType("scatter",n),n}),e(t,"Series/CenteredUtilities.js",[t["Core/Globals.js"],t["Core/Series/Series.js"],t["Core/Utilities.js"]],function(t,g,e){const i=t["deg2rad"],{fireEvent:f,isNumber:m,pick:x,relativeLength:v}=e;var s;return(t=s=s||{}).getCenter=function(){var t=this.options,e=this.chart,i=2*(t.slicedOffset||0),s=e.plotWidth-2*i,o=e.plotHeight-2*i,r=t.center,a=Math.min(s,o),n=t.thickness;let l,h=t.size,d=t.innerSize||0,c,p;"string"==typeof h&&(h=parseFloat(h)),"string"==typeof d&&(d=parseFloat(d));var u=[x(r[0],"50%"),x(r[1],"50%"),x(h&&h<0?void 0:t.size,"100%"),x(d&&d<0?void 0:t.innerSize||0,"0%")];for(!e.angular||this instanceof g||(u[3]=0),c=0;c<4;++c)p=u[c],l=c<2||2===c&&/%$/.test(p),u[c]=v(p,[s,o,a,u[2]][c])+(l?i:0);return u[2]<u[3]&&(u[3]=u[2]),m(n)&&2*n<u[2]&&0<n&&(u[3]=u[2]-2*n),f(this,"afterGetCenter",{positions:u}),u},t.getStartAndEndRadians=function(t,e){return t=m(t)?t:0,e=m(e)&&t<e&&e-t<360?e:t+360,{start:i*(t+-90),end:i*(e+-90)}},s}),e(t,"Series/Pie/PiePoint.js",[t["Core/Animation/AnimationUtilities.js"],t["Core/Series/Point.js"],t["Core/Utilities.js"]],function(t,e,i){const r=t["setAnimation"],{addEvent:s,defined:a,extend:o,isNumber:n,pick:l,relativeLength:p}=i;class h extends e{getConnectorPath(t){var e=t.dataLabelPosition,t=t.options||{},i=t.connectorShape,i=this.connectorShapes[i]||i;return e&&i.call(this,{...e.computed,alignment:e.alignment},e.connectorPosition,t)||[]}getTranslate(){return this.sliced&&this.slicedTranslation||{translateX:0,translateY:0}}haloPath(t){var e=this.shapeArgs;return this.sliced||!this.visible?[]:this.series.chart.renderer.symbols.arc(e.x,e.y,e.r+t,e.r+t,{innerR:e.r-1,start:e.start,end:e.end,borderRadius:e.borderRadius})}constructor(t,e,i){super(t,e,i),this.half=0,this.name??(this.name="Slice");t=t=>{this.slice("select"===t.type)};s(this,"select",t),s(this,"unselect",t)}isValid(){return n(this.y)&&0<=this.y}setVisible(t,e=!0){t!==this.visible&&this.update({visible:t??!this.visible},e,void 0,!1)}slice(t,e,i){var s=this.series,o=s.chart;r(i,o),e=l(e,!0),this.sliced=this.options.sliced=t=a(t)?t:!this.sliced,s.options.data[s.data.indexOf(this)]=this.options,this.graphic&&this.graphic.animate(this.getTranslate())}}return o(h.prototype,{connectorShapes:{fixedOffset:function(t,e,i){var s=e.breakAt,e=e.touchingSliceAt,i=i.softConnector?["C",t.x+("left"===t.alignment?-5:5),t.y,2*s.x-e.x,2*s.y-e.y,s.x,s.y]:["L",s.x,s.y];return[["M",t.x,t.y],i,["L",e.x,e.y]]},straight:function(t,e){e=e.touchingSliceAt;return[["M",t.x,t.y],["L",e.x,e.y]]},crookedLine:function(t,e,i){var{breakAt:e,touchingSliceAt:s}=e,o=this["series"],[r,a,n]=o.center,n=n/2,{plotLeft:o,plotWidth:l}=o.chart,h="left"===t.alignment,{x:t,y:d}=t;let c=e.x;c=i.crookDistance?(i=p(i.crookDistance,1),h?r+n+(l+o-r-n)*(1-i):o+(r-n)*i):r+(a-d)*Math.tan((this.angle||0)-Math.PI/2);l=[["M",t,d]];return(h?c<=t&&c>=e.x:c>=t&&c<=e.x)&&l.push(["L",c,d]),l.push(["L",e.x,e.y],["L",s.x,s.y]),l}}}),h}),e(t,"Series/Pie/PieSeriesDefaults.js",[],function(){return{borderRadius:3,center:[null,null],clip:!1,colorByPoint:!0,dataLabels:{connectorPadding:5,connectorShape:"crookedLine",crookDistance:void 0,distance:30,enabled:!0,formatter:function(){return this.point.isNull?void 0:this.point.name},softConnector:!0,x:0},fillColor:void 0,ignoreHiddenPoint:!0,inactiveOtherPoints:!0,legendType:"point",marker:null,size:null,showInLegend:!1,slicedOffset:10,stickyTracking:!1,tooltip:{followPointer:!0},borderColor:"#ffffff",borderWidth:1,lineWidth:void 0,states:{hover:{brightness:.1}}}}),e(t,"Series/Pie/PieSeries.js",[t["Series/CenteredUtilities.js"],t["Series/Column/ColumnSeries.js"],t["Core/Globals.js"],t["Series/Pie/PiePoint.js"],t["Series/Pie/PieSeriesDefaults.js"],t["Core/Series/Series.js"],t["Core/Series/SeriesRegistry.js"],t["Core/Renderer/SVG/Symbols.js"],t["Core/Utilities.js"]],function(t,e,i,s,o,r,a,n,l){const v=t["getStartAndEndRadians"];i=i.noop;const{clamp:h,extend:d,fireEvent:y,merge:c,pick:p}=l;class u extends r{animate(t){const s=this,e=s.points,o=s.startAngleRad;t||e.forEach(function(t){var e=t.graphic,i=t.shapeArgs;e&&i&&(e.attr({r:p(t.startR,s.center&&s.center[3]/2),start:o,end:o}),e.animate({r:i.r,start:i.start,end:i.end},s.options.animation))})}drawEmpty(){var t,e,i=this.startAngleRad,s=this.endAngleRad,o=this.options;0===this.total&&this.center?(t=this.center[0],e=this.center[1],this.graph||(this.graph=this.chart.renderer.arc(t,e,this.center[1]/2,0,i,s).addClass("highcharts-empty-series").add(this.group)),this.graph.attr({d:n.arc(t,e,this.center[2]/2,0,{start:i,end:s,innerR:this.center[3]/2})}),this.chart.styledMode||this.graph.attr({"stroke-width":o.borderWidth,fill:o.fillColor||"none",stroke:o.color||"#cccccc"})):this.graph&&(this.graph=this.graph.destroy())}drawPoints(){const e=this.chart.renderer;this.points.forEach(function(t){t.graphic&&t.hasNewShapeType()&&(t.graphic=t.graphic.destroy()),t.graphic||(t.graphic=e[t.shapeType](t.shapeArgs).add(t.series.group),t.delayedRendering=!0)})}generatePoints(){super.generatePoints(),this.updateTotals()}getX(t,e,i,s){var o=this.center,i=this.radii?this.radii[i.index]||0:o[2]/2,r=s.dataLabelPosition?.distance||0,t=Math.asin(h((t-o[1])/(i+r),-1,1));return o[0]+(e?-1:1)*(Math.cos(t)*(i+r))+(0<r?(e?-1:1)*(s.padding||0):0)}hasData(){return!!this.processedXData.length}redrawPoints(){const i=this,s=i.chart;let o,r,a,n;this.drawEmpty(),i.group&&!s.styledMode&&i.group.shadow(i.options.shadow),i.points.forEach(function(t){var e={};r=t.graphic,!t.isNull&&r?(n=t.shapeArgs,o=t.getTranslate(),s.styledMode||(a=i.pointAttribs(t,t.selected&&"select")),t.delayedRendering?(r.setRadialReference(i.center).attr(n).attr(o),s.styledMode||r.attr(a).attr({"stroke-linejoin":"round"}),t.delayedRendering=!1):(r.setRadialReference(i.center),s.styledMode||c(!0,e,a),c(!0,e,n,o),r.animate(e)),r.attr({visibility:t.visible?"inherit":"hidden"}),r.addClass(t.getClassName(),!0)):r&&(t.graphic=r.destroy())})}sortByAngle(t,i){t.sort(function(t,e){return"undefined"!=typeof t.angle&&(e.angle-t.angle)*i})}translate(t){y(this,"translate"),this.generatePoints();var e=this.options,i=e.slicedOffset,s=v(e.startAngle,e.endAngle),o=this.startAngleRad=s.start,r=(this.endAngleRad=s.end)-o,a=this.points,n=e.ignoreHiddenPoint,l=a.length;let h,d,c,p,u,g,f,m=0;for(t||(this.center=t=this.getCenter()),g=0;g<l;g++){f=a[g],h=o+m*r,!f.isValid()||n&&!f.visible||(m+=f.percentage/100),d=o+m*r;var x={x:t[0],y:t[1],r:t[2]/2,innerR:t[3]/2,start:Math.round(1e3*h)/1e3,end:Math.round(1e3*d)/1e3};f.shapeType="arc",f.shapeArgs=x,(c=(d+h)/2)>1.5*Math.PI?c-=2*Math.PI:c<-Math.PI/2&&(c+=2*Math.PI),f.slicedTranslation={translateX:Math.round(Math.cos(c)*i),translateY:Math.round(Math.sin(c)*i)},p=Math.cos(c)*t[2]/2,u=Math.sin(c)*t[2]/2,f.tooltipPos=[t[0]+.7*p,t[1]+.7*u],f.half=c<-Math.PI/2||c>Math.PI/2?1:0,f.angle=c}y(this,"afterTranslate")}updateTotals(){var t=this.points,e=t.length,i=this.options.ignoreHiddenPoint;let s,o,r=0;for(s=0;s<e;s++)!(o=t[s]).isValid()||i&&!o.visible||(r+=o.y);for(this.total=r,s=0;s<e;s++)(o=t[s]).percentage=0<r&&(o.visible||!i)?o.y/r*100:0,o.total=r}}return u.defaultOptions=c(r.defaultOptions,o),d(u.prototype,{axisTypes:[],directTouch:!0,drawGraph:void 0,drawTracker:e.prototype.drawTracker,getCenter:t.getCenter,getSymbol:i,isCartesian:!1,noSharedTooltip:!0,pointAttribs:e.prototype.pointAttribs,pointClass:s,requireSorting:!1,searchPoint:i,trackerGroups:["group","dataLabelsGroup"]}),a.registerSeriesType("pie",u),u}),e(t,"Series/Pie/PieDataLabel.js",[t["Core/Series/DataLabel.js"],t["Core/Globals.js"],t["Core/Renderer/RendererUtilities.js"],t["Core/Series/SeriesRegistry.js"],t["Core/Utilities.js"]],function(e,t,i,s,o){const{composed:r,noop:a}=t,C=i["distribute"],d=s["series"],{arrayMax:c,clamp:n,defined:A,pick:w,pushUnique:l,relativeLength:p}=o;var h;{t=h=h||{};const v={radialDistributionY:function(t,e){return(e.dataLabelPosition?.top||0)+t.distributeBox.pos},radialDistributionX:function(t,e,i,s,o){var r=o.dataLabelPosition;return t.getX(i<(r?.top||0)+2||i>(r?.bottom||0)-2?s:i,e.half,e,o)},justify:function(t,e,i,s){return s[0]+(t.half?-1:1)*(i+(e.dataLabelPosition?.distance||0))},alignToPlotEdges:function(t,e,i,s){t=t.getBBox().width;return e?t+s:i-t-s},alignToConnectors:function(t,e,i,s){let o=0,r;return t.forEach(function(t){(r=t.dataLabel.getBBox().width)>o&&(o=r)}),e?o+s:i-o-s}};function u(t,e){var{center:i,options:s}=this,o=i[2]/2,r=t.angle||0,a=Math.cos(r),r=Math.sin(r),n=i[0]+a*o,i=i[1]+r*o,o=Math.min((s.slicedOffset||0)+(s.borderWidth||0),e/5);return{natural:{x:n+a*e,y:i+r*e},computed:{},alignment:e<0?"center":t.half?"right":"left",connectorPosition:{breakAt:{x:n+a*o,y:i+r*o},touchingSliceAt:{x:n,y:i}},distance:e}}function g(){const u=this,t=u.points,a=u.chart,g=a.plotWidth,f=a.plotHeight,m=a.plotLeft,r=Math.round(a.chartWidth/3),x=u.center,v=x[2]/2,n=x[1],l=[[],[]],y=[0,0,0,0],b=u.dataLabelPositioners;let h,M,S,k=0;u.visible&&u.hasDataLabels?.()&&(t.forEach(t=>{(t.dataLabels||[]).forEach(t=>{t.shortened&&(t.attr({width:"auto"}).css({width:"auto",textOverflow:"clip"}),t.shortened=!1)})}),d.prototype.drawDataLabels.apply(u),t.forEach(o=>{(o.dataLabels||[]).forEach((t,e)=>{var i=x[2]/2,s=t.options,i=p(s?.distance||0,i);0===e&&l[o.half].push(o),A(s?.style?.width)||t.getBBox().width>r&&(t.css({width:Math.round(.7*r)+"px"}),t.shortened=!0),t.dataLabelPosition=this.getDataLabelPosition(o,i),k=Math.max(k,i)})}),l.forEach((d,c)=>{const t=d.length,p=[];let e,i,o=0,s;t&&(u.sortByAngle(d,c-.5),0<k&&(e=Math.max(0,n-v-k),i=Math.min(n+v+k,a.plotHeight),d.forEach(s=>{(s.dataLabels||[]).forEach((t,e)=>{var i=t.dataLabelPosition;i&&0<i.distance&&(i.top=Math.max(0,n-v-i.distance),i.bottom=Math.min(n+v+i.distance,a.plotHeight),o=t.getBBox().height||21,s.distributeBox={target:(t.dataLabelPosition?.natural.y||0)-i.top+o/2,size:o,rank:s.y},p.push(s.distributeBox))})}),s=i+o-e,C(p,s,s/5)),d.forEach(h=>{(h.dataLabels||[]).forEach(e=>{var t=e.options||{},i=h.distributeBox,s=e.dataLabelPosition,o=s?.natural.y||0,r=t.connectorPadding||0;let a=0,n=o,l="inherit";if(s){if(p&&A(i)&&0<s.distance&&("undefined"==typeof i.pos?l="hidden":(S=i.size,n=b.radialDistributionY(h,e))),t.justify)a=b.justify(h,e,v,x);else switch(t.alignTo){case"connectors":a=b.alignToConnectors(d,c,g,m);break;case"plotEdges":a=b.alignToPlotEdges(e,c,g,m);break;default:a=b.radialDistributionX(u,h,n,o,e)}if(s.attribs={visibility:l,align:s.alignment},s.posAttribs={x:a+(t.x||0)+({left:r,right:-r}[s.alignment]||0),y:n+(t.y||0)-e.getBBox().height/2},s.computed.x=a,s.computed.y=n,w(t.crop,!0)){M=e.getBBox().width;let t;a-M<r&&1===c?(t=Math.round(M-a+r),y[3]=Math.max(t,y[3])):a+M>g-r&&0===c&&(t=Math.round(a+M-g+r),y[1]=Math.max(t,y[1])),n-S/2<0?y[0]=Math.max(Math.round(-n+S/2),y[0]):n+S/2>f&&(y[2]=Math.max(Math.round(n+S/2-f),y[2])),s.sideOverflow=t}}})}))}),0!==c(y)&&!this.verifyDataLabelOverflow(y)||(this.placeDataLabels(),this.points.forEach(r=>{(r.dataLabels||[]).forEach(t=>{var e,{connectorColor:i,connectorWidth:s=1}=t.options||{},o=t.dataLabelPosition;s&&(h=t.connector,o&&0<o.distance?(e=!h,h||(t.connector=h=a.renderer.path().addClass("highcharts-data-label-connector  highcharts-color-"+r.colorIndex+(r.className?" "+r.className:"")).add(u.dataLabelsGroup)),a.styledMode||h.attr({"stroke-width":s,stroke:i||r.color||"#666666"}),h[e?"attr":"animate"]({d:r.getConnectorPath(t)}),h.attr({visibility:o.attribs?.visibility})):h&&(t.connector=h.destroy()))})})))}function f(){this.points.forEach(t=>{(t.dataLabels||[]).forEach(t=>{var e=t.dataLabelPosition;e?(e.sideOverflow&&(t.css({width:Math.max(t.getBBox().width-e.sideOverflow,0)+"px",textOverflow:(t.options?.style||{}).textOverflow||"ellipsis"}),t.shortened=!0),t.attr(e.attribs),t[t.moved?"animate":"attr"](e.posAttribs),t.moved=!0):t&&t.attr({y:-9999})}),delete t.distributeBox},this)}function m(t){let e=this.center,i=this.options,s=i.center,o=i.minSize||80,r=o,a=null!==i.size;return a||(null!==s[0]?r=Math.max(e[2]-Math.max(t[1],t[3]),o):(r=Math.max(e[2]-t[1]-t[3],o),e[0]+=(t[3]-t[1])/2),null!==s[1]?r=n(r,o,e[2]-Math.max(t[0],t[2])):(r=n(r,o,e[2]-t[0]-t[2]),e[1]+=(t[0]-t[2])/2),r<e[2]?(e[2]=r,e[3]=Math.min(i.thickness?Math.max(0,r-2*i.thickness):Math.max(0,p(i.innerSize||0,r)),r),this.translate(e),this.drawDataLabels&&this.drawDataLabels()):a=!0),a}t.compose=function x(t){e.compose(d),l(r,x)&&((t=t.prototype).dataLabelPositioners=v,t.alignDataLabel=a,t.drawDataLabels=g,t.getDataLabelPosition=u,t.placeDataLabels=f,t.verifyDataLabelOverflow=m)}}return h}),e(t,"Extensions/OverlappingDataLabels.js",[t["Core/Globals.js"],t["Core/Utilities.js"]],function(t,e){const i=t["composed"],{addEvent:s,fireEvent:c,isNumber:p,objectEach:a,pick:n,pushUnique:o}=e;function r(i){const s=i.length,h=this.renderer;let e,o,r,a,n,t=!1;for(let t=0;t<s;t++)(e=i[t])&&(e.oldOpacity=e.opacity,e.newOpacity=1,e.absoluteBox=(t=>{var e=!t.box&&t.padding||0;let i,s,o,r=0,a=0,n,l;if(t&&(!t.alignAttr||t.placed))return i=t.alignAttr||{x:t.attr("x"),y:t.attr("y")},s=t.parentGroup,t.width||(o=t.getBBox(),t.width=o.width,t.height=o.height,r=h.fontMetrics(t.element).h),n=t.width-2*e,(l={left:"0",center:"0.5",right:"1"}[t.alignValue])?a=+l*n:p(t.x)&&Math.round(t.x)!==t.translateX&&(a=t.x-(t.translateX||0)),{x:i.x+(s.translateX||0)+e-(a||0),y:i.y+(s.translateY||0)+e-r,width:t.width-2*e,height:(t.height||0)-2*e}})(e));i.sort((t,e)=>(e.labelrank||0)-(t.labelrank||0));for(let e=0;e<s;++e){a=(o=i[e])&&o.absoluteBox;for(let t=e+1;t<s;++t)r=i[t],n=r&&r.absoluteBox,a&&n&&o!==r&&0!==o.newOpacity&&0!==r.newOpacity&&"hidden"!==o.visibility&&"hidden"!==r.visibility&&(l=a,(d=n).x>=l.x+l.width||d.x+d.width<=l.x||d.y>=l.y+l.height||d.y+d.height<=l.y||((o.labelrank<r.labelrank?o:r).newOpacity=0))}var l,d;for(const e of i)u(e,this)&&(t=!0);t&&c(this,"afterHideAllOverlappingLabels")}function u(t,e){let i,s=!1;return t&&(i=t.newOpacity,t.oldOpacity!==i&&(t.hasClass("highcharts-data-label")?(t[i?"removeClass":"addClass"]("highcharts-data-label-hidden"),s=!0,t[t.isOld?"animate":"attr"]({opacity:i},void 0,function(){e.styledMode||t.css({pointerEvents:i?"auto":"none"})}),c(e,"afterHideOverlappingLabel")):t.attr({opacity:i})),t.isOld=!0),s}function l(){const s=this;let o=[];for(const e of s.labelCollectors||[])o=o.concat(e());for(const i of s.yAxis||[])i.stacking&&i.options.stackLabels&&!i.options.stackLabels.allowOverlap&&a(i.stacking.stacks,t=>{a(t,t=>{t.label&&o.push(t.label)})});for(const r of s.series||[]){var t;r.visible&&r.hasDataLabels?.()&&((t=t=>{for(const i of t)i.visible&&(i.dataLabels||[]).forEach(t=>{var e=t.options||{};t.labelrank=n(e.labelrank,i.labelrank,i.shapeArgs?.height),e.allowOverlap??0<Number(e.distance)?(t.oldOpacity=t.opacity,t.newOpacity=1,u(t,s)):o.push(t)})})(r.nodes||[]),t(r.points))}this.hideOverlappingLabels(o)}return{compose:function h(t){o(i,h)&&(t.prototype.hideOverlappingLabels=r,s(t,"render",l))}}}),e(t,"Extensions/BorderRadius.js",[t["Core/Defaults.js"],t["Core/Globals.js"],t["Core/Utilities.js"]],function(t,e,i){const g=t["defaultOptions"],{composed:o,noop:s}=e,{addEvent:r,extend:f,isObject:m,merge:a,pushUnique:n,relativeLength:M}=i,l={radius:0,scope:"stack",where:void 0};let S=s,y=s;function h(t,e,i,s,r={}){var a=S(t,e,i,s,r),{innerR:t=0,r:e=i,start:s=0,end:i=0}=r;if(!r.open&&r.borderRadius){var i=i-s,s=Math.sin(i/2),n=Math.max(Math.min(M(r.borderRadius||0,e-t),(e-t)/2,e*s/(1+s)),0),l=Math.min(n,i/Math.PI*2*t);let o=a.length-1;for(;o--;){h=void 0;d=void 0;c=void 0;b=void 0;v=void 0;p=void 0;u=void 0;g=void 0;f=void 0;m=void 0;x=void 0;y=void 0;var h=a;var d=o;var c=1<o?l:n;var p,u,g,f,m,x,v,y,b=h[d];let t=h[d+1];"Z"===t[0]&&(t=h[0]);let e,i,s;"M"!==b[0]&&"L"!==b[0]||"A"!==t[0]?"A"!==b[0]||"M"!==t[0]&&"L"!==t[0]||(e=t,i=b):(e=b,i=t,s=!0),e&&i&&i.params&&(b=i[1],v=i[5],{start:u,end:g,cx:f,cy:m}=p=i.params,y=(x=v?b-c:b+c)?Math.asin(c/x):0,v=v?y:-y,y=Math.cos(y)*x,s?(p.start=u+v,e[1]=f+y*Math.cos(u),e[2]=m+y*Math.sin(u),h.splice(d+1,0,["A",c,c,0,0,1,f+b*Math.cos(p.start),m+b*Math.sin(p.start)])):(p.end=g-v,i[6]=f+b*Math.cos(p.end),i[7]=m+b*Math.sin(p.end),h.splice(d+1,0,["A",c,c,0,0,1,f+y*Math.cos(g),m+y*Math.sin(g)])),i[4]=Math.abs(p.end-p.start)<Math.PI?0:1)}}return a}function d(){if(this.options.borderRadius&&(!this.chart.is3d||!this.chart.is3d())){var{options:s,yAxis:o}=this,r="percent"===s.stacking,t=g.plotOptions?.[this.type]?.borderRadius,a=x(s.borderRadius,m(t)?t:{}),n=o.options.reversed;for(const u of this.points){var l=u["shapeArgs"];if("roundedRect"===u.shapeType&&l){var{width:h=0,height:d=0,y:c=0}=l;let t=c,e=d;"stack"===a.scope&&u.stackTotal&&(c=o.translate(r?100:u.stackTotal,!1,!0,!1,!0),p=o.translate(s.threshold||0,!1,!0,!1,!0),c=this.crispCol(0,Math.min(c,p),0,Math.abs(c-p)),t=c.y,e=c.height);var p=(u.negative?-1:1)*(n?-1:1)==-1;let i=a.where;i=(i=!i&&this.is("waterfall")&&Math.abs((u.yBottom||0)-(this.translatedThreshold||0))>this.borderWidth?"all":i)||"end";c=Math.min(M(a.radius,h),h/2,"all"===i?d/2:Infinity)||0;"end"===i&&(p&&(t-=c),e+=c),f(l,{brBoxHeight:e,brBoxY:t,r:c})}}}}function x(t,e){return m(t)||(t={radius:t||0}),a(l,e,t)}function c(){var t=x(this.options.borderRadius);for(const i of this.points){var e=i.shapeArgs;e&&(e.borderRadius=M(t.radius,(e.r||0)-(e.innerR||0)))}}function p(t,e,i,s,o={}){var r,a=y(t,e,i,s,o),{r:o=0,brBoxHeight:n=s,brBoxY:l=e}=o,h=e-l,l=l+n-(e+s),n=-.1<h-o?0:o,o=-.1<l-o?0:o,h=Math.max(n&&h,0),l=Math.max(o&&l,0),d=[t+n,e],c=[t+i-n,e],p=[t+i,e+n],u=[t+i,e+s-o],g=[t+i-o,e+s],f=[t+o,e+s],m=[t,e+s-o],x=[t,e+n],v=(t,e)=>Math.sqrt(Math.pow(t,2)-Math.pow(e,2));return h&&(r=v(n,n-h),d[0]-=r,c[0]+=r,p[1]=x[1]=e+n-h),s<n-h&&(r=v(n,n-h-s),p[0]=u[0]=t+i-n+r,g[0]=Math.min(p[0],g[0]),f[0]=Math.max(u[0],f[0]),m[0]=x[0]=t+n-r,p[1]=x[1]=e+s),l&&(h=v(o,o-l),g[0]+=h,f[0]-=h,u[1]=m[1]=e+s-o+l),s<o-l&&(r=v(o,o-l-s),p[0]=u[0]=t+i-o+r,c[0]=Math.min(p[0],c[0]),d[0]=Math.max(u[0],d[0]),m[0]=x[0]=t+o-r,u[1]=m[1]=e),a.length=0,a.push(["M",...d],["L",...c],["A",n,n,0,0,1,...p],["L",...u],["A",o,o,0,0,1,...g],["L",...f],["A",o,o,0,0,1,...m],["L",...x],["A",n,n,0,0,1,...d],["Z"]),a}return{compose:function u(t,e,i,s){n(o,u)&&(s=s.prototype.symbols,r(t,"afterColumnTranslate",d,{order:9}),r(e,"afterTranslate",c),i.symbolCustomAttribs.push("borderRadius","brBoxHeight","brBoxY"),S=s.arc,y=s.roundedRect,s.arc=h,s.roundedRect=p)},optionsToObject:x}}),e(t,"Core/Responsive.js",[t["Core/Globals.js"],t["Core/Utilities.js"]],function(t,e){const i=t["composed"],{diffObjects:n,extend:s,find:l,merge:h,pick:o,pushUnique:r,uniqueKey:d}=e;var a;function c(t,e){const i=t.condition,s=i.callback||function(){return this.chartWidth<=o(i.maxWidth,Number.MAX_VALUE)&&this.chartHeight<=o(i.maxHeight,Number.MAX_VALUE)&&this.chartWidth>=o(i.minWidth,0)&&this.chartHeight>=o(i.minHeight,0)};s.call(this)&&e.push(t._id)}function p(t,e){const i=this.options.responsive,s=this.currentResponsive;let o=[],r;!e&&i&&i.rules&&i.rules.forEach(t=>{"undefined"==typeof t._id&&(t._id=d()),this.matchResponsiveRule(t,o)},this);var e=h(...o.map(e=>l((i||{}).rules||[],t=>t._id===e)).map(t=>t&&t.chartOptions)),a=(e.isResponsiveOptions=!0,o=o.toString()||void 0,s&&s.ruleIds);o!==a&&(s&&this.update(s.undoOptions,t,!0),o?((r=n(e,this.options,!0,this.collectionsWithUpdate)).isResponsiveOptions=!0,this.currentResponsive={ruleIds:o,mergedOptions:e,undoOptions:r},this.update(e,t,!0)):this.currentResponsive=void 0)}return(a||(a={})).compose=function u(t){return r(i,u)&&s(t.prototype,{matchResponsiveRule:c,setResponsive:p}),t},a}),e(t,"masters/highcharts.src.js",[t["Core/Globals.js"],t["Core/Utilities.js"],t["Core/Defaults.js"],t["Core/Animation/Fx.js"],t["Core/Animation/AnimationUtilities.js"],t["Core/Renderer/HTML/AST.js"],t["Core/Templating.js"],t["Core/Renderer/RendererUtilities.js"],t["Core/Renderer/SVG/SVGElement.js"],t["Core/Renderer/SVG/SVGRenderer.js"],t["Core/Renderer/HTML/HTMLElement.js"],t["Core/Renderer/HTML/HTMLRenderer.js"],t["Core/Axis/Axis.js"],t["Core/Axis/DateTimeAxis.js"],t["Core/Axis/LogarithmicAxis.js"],t["Core/Axis/PlotLineOrBand/PlotLineOrBand.js"],t["Core/Axis/Tick.js"],t["Core/Tooltip.js"],t["Core/Series/Point.js"],t["Core/Pointer.js"],t["Core/Legend/Legend.js"],t["Core/Chart/Chart.js"],t["Extensions/ScrollablePlotArea.js"],t["Core/Axis/Stacking/StackingAxis.js"],t["Core/Axis/Stacking/StackItem.js"],t["Core/Series/Series.js"],t["Core/Series/SeriesRegistry.js"],t["Series/Column/ColumnSeries.js"],t["Series/Column/ColumnDataLabel.js"],t["Series/Pie/PieSeries.js"],t["Series/Pie/PieDataLabel.js"],t["Core/Series/DataLabel.js"],t["Extensions/OverlappingDataLabels.js"],t["Extensions/BorderRadius.js"],t["Core/Responsive.js"],t["Core/Color/Color.js"],t["Core/Time.js"]],function(t,e,i,s,o,r,a,n,l,h,d,c,p,u,g,f,m,x,v,y,b,M,S,k,C,A,w,T,P,O,L,E,D,B,j,I,R){return t.animate=o.animate,t.animObject=o.animObject,t.getDeferredAnimation=o.getDeferredAnimation,t.setAnimation=o.setAnimation,t.stop=o.stop,t.timers=s.timers,t.AST=r,t.Axis=p,t.Chart=M,t.chart=M.chart,t.Fx=s,t.Legend=b,t.PlotLineOrBand=f,t.Point=v,t.Pointer=y,t.Series=A,t.StackItem=C,t.SVGElement=l,t.SVGRenderer=h,t.Templating=a,t.Tick=m,t.Time=R,t.Tooltip=x,t.Color=I,t.color=I.parse,c.compose(h),d.compose(l),y.compose(M),b.compose(M),t.defaultOptions=i.defaultOptions,t.getOptions=i.getOptions,t.time=i.defaultTime,t.setOptions=i.setOptions,t.dateFormat=a.dateFormat,t.format=a.format,t.numberFormat=a.numberFormat,e.extend(t,e),t.distribute=n.distribute,t.seriesType=w.seriesType,P.compose(T),B.compose(A,O,l,h),E.compose(A),u.compose(p),g.compose(p),D.compose(M),L.compose(O),f.compose(p),j.compose(M),S.compose(p,M,A),k.compose(p,M,A),x.compose(y),t}),e(t,"Core/Axis/BrokenAxis.js",[t["Core/Globals.js"],t["Core/Axis/Stacking/StackItem.js"],t["Core/Utilities.js"]],function(t,l,e){const s=t["composed"],{addEvent:o,find:i,fireEvent:u,isArray:r,isNumber:g,pick:f,pushUnique:a}=e;var n;{function h(){"undefined"!=typeof this.brokenAxis&&this.brokenAxis.setBreaks(this.options.breaks,!1)}function d(){this.brokenAxis?.hasBreaks&&(this.options.ordinal=!1)}function c(){var e=this.brokenAxis;if(e?.hasBreaks){var i=this.tickPositions,t=this.tickPositions.info,s=[];for(let t=0;t<i.length;t++)e.isInAnyBreak(i[t])||s.push(i[t]);this.tickPositions=s,this.tickPositions.info=t}}function p(){this.brokenAxis||(this.brokenAxis=new M(this))}function m(){var{isDirty:t,options:{connectNulls:e},points:i,xAxis:s,yAxis:o}=this;if(t){let t=i.length;for(;t--;){var r=i[t],a=!(null===r.y&&!1===e)&&(s?.brokenAxis?.isInAnyBreak(r.x,!0)||o?.brokenAxis?.isInAnyBreak(r.y,!0));r.visible=!a&&!1!==r.options.visible}}}function x(){this.drawBreaks(this.xAxis,["x"]),this.drawBreaks(this.yAxis,f(this.pointArrayMap,["y"]))}function v(s,t){const i=this,o=i.points;let r,a,n;if(s?.brokenAxis?.hasBreaks){const l=s.brokenAxis;t.forEach(function(t){r=l?.breakArray||[],a=s.isXAxis?s.min:f(i.options.threshold,s.min);const e=s?.options?.breaks?.filter(function(e){let i=!0;for(let t=0;t<r.length;t++){var s=r[t];if(s.from===e.from&&s.to===e.to){i=!1;break}}return i});o.forEach(function(i){n=f(i["stack"+t.toUpperCase()],i[t]),r.forEach(function(e){if(g(a)&&g(n)){let t="";a<e.from&&n>e.to||a>e.from&&n<e.from?t="pointBreak":(a<e.from&&n>e.from&&n<e.to||a>e.from&&n>e.to&&n<e.from)&&(t="pointInBreak"),t&&u(s,t,{point:i,brk:e})}}),e?.forEach(function(t){u(s,"pointOutsideOfBreak",{point:i,brk:t})})})})}}function y(){var i,s=this.currentDataGrouping?.gapSize,o=this.points.slice(),r=this.yAxis;let a=this.options.gapSize,n=o.length-1;if(a&&0<n){"value"!==this.options.gapUnit&&(a*=this.basePointRange),s&&s>a&&s>=this.basePointRange&&(a=s);let t,e;for(;n--;)e&&!1!==e.visible||(e=o[n+1]),t=o[n],!1!==e.visible&&!1!==t.visible&&(e.x-t.x>a&&(i=(t.x+e.x)/2,o.splice(n+1,0,{isNull:!0,x:i}),r.stacking)&&this.options.stacking&&((r.stacking.stacks[this.stackKey][i]=new l(r,r.options.stackLabels,!1,i,this.stack)).total=0),e=t)}return this.getGraphPath(o)}(t=n=n||{}).compose=function b(t,e){var i;return a(s,b)&&(t.keepProps.push("brokenAxis"),o(t,"init",p),o(t,"afterInit",h),o(t,"afterSetTickPositions",c),o(t,"afterSetOptions",d),(i=e.prototype).drawBreaks=v,i.gappedPath=y,o(e,"afterGeneratePoints",m),o(e,"afterRender",x)),t};class M{static isInBreak(t,e){var i=t.repeat||Infinity,s=t.from,o=t.to-t.from,s=s<=e?(e-s)%i:i-(s-e)%i;let r;return r=t.inclusive?s<=o:s<o&&0!=s}static lin2Val(t){var e=this.brokenAxis,i=e&&e.breakArray;if(!i||!g(t))return t;let s=t,o,r;for(r=0;r<i.length&&!((o=i[r]).from>=s);r++)(o.to<s||M.isInBreak(o,s))&&(s+=o.len);return s}static val2Lin(t){var e=this.brokenAxis,i=e&&e.breakArray;if(!i||!g(t))return t;let s=t,o,r;for(r=0;r<i.length;r++)if((o=i[r]).to<=t)s-=o.len;else{if(o.from>=t)break;if(M.isInBreak(o,t)){s-=t-o.from;break}}return s}constructor(t){this.hasBreaks=!1,this.axis=t}findBreakAt(e,t){return i(t,function(t){return t.from<e&&e<t.to})}isInAnyBreak(t,e){var i=this.axis,s=i.options.breaks||[];let o=s.length,r,a,n;if(o&&g(t)){for(;o--;)M.isInBreak(s[o],t)&&(r=!0,a=a||f(s[o].showPoints,!i.isXAxis));n=r&&e?r&&!a:r}return n}setBreaks(t,e){const c=this,p=c.axis;var i=r(t)&&!!t.length&&!!Object.keys(t[0]).length;p.isDirty=c.hasBreaks!==i,c.hasBreaks=i,t!==p.options.breaks&&(p.options.breaks=p.userOptions.breaks=t),p.forceRedraw=!0,p.series.forEach(function(t){t.isDirty=!0}),i||p.val2lin!==M.val2Lin||(delete p.val2lin,delete p.lin2val),i&&(p.userOptions.ordinal=!1,p.lin2val=M.lin2Val,p.val2lin=M.val2Lin,p.setExtremes=function(e,i,t,s,o){if(c.hasBreaks){var r=this.options.breaks||[];let t;for(;t=c.findBreakAt(e,r);)e=t.to;for(;t=c.findBreakAt(i,r);)i=t.from;i<e&&(i=e)}p.constructor.prototype.setExtremes.call(this,e,i,t,s,o)},p.setAxisTranslation=function(){if(p.constructor.prototype.setAxisTranslation.call(this),c.unitLength=void 0,c.hasBreaks){const t=p.options.breaks||[],l=[],h=[],d=f(p.pointRangePadding,0);let e=0,i,s,o=p.userMin||p.min,r=p.userMax||p.max,a,n;t.forEach(function(t){s=t.repeat||Infinity,g(o)&&g(r)&&(M.isInBreak(t,o)&&(o+=t.to%s-o%s),M.isInBreak(t,r))&&(r-=r%s-t.from%s)}),t.forEach(function(t){if(a=t.from,s=t.repeat||Infinity,g(o)&&g(r)){for(;a-s>o;)a-=s;for(;a<o;)a+=s;for(n=a;n<r;n+=s)l.push({value:n,move:"in"}),l.push({value:n+t.to-t.from,move:"out",size:t.breakSize})}}),l.sort(function(t,e){return t.value===e.value?("in"===t.move?0:1)-("in"===e.move?0:1):t.value-e.value}),i=0,a=o,l.forEach(function(t){1===(i+="in"===t.move?1:-1)&&"in"===t.move&&(a=t.value),0===i&&g(a)&&(h.push({from:a,to:t.value,len:t.value-a-(t.size||0)}),e+=t.value-a-(t.size||0))}),c.breakArray=h,g(o)&&g(r)&&g(p.min)&&(c.unitLength=r-o-e+d,u(p,"afterBreaks"),p.staticScale?p.transA=p.staticScale:c.unitLength&&(p.transA*=(r-p.min+d)/c.unitLength),d&&(p.minPixelPadding=p.transA*(p.minPointOffset||0)),p.min=o,p.max=r)}}),f(e,!0)&&p.chart.redraw()}}t.Additions=M}return n}),e(t,"masters/modules/broken-axis.src.js",[t["Core/Globals.js"],t["Core/Axis/BrokenAxis.js"]],function(t,e){e.compose(t.Axis,t.Series)}),e(t,"Extensions/DataGrouping/ApproximationRegistry.js",[],function(){return{}}),e(t,"Extensions/DataGrouping/ApproximationDefaults.js",[t["Extensions/DataGrouping/ApproximationRegistry.js"],t["Core/Utilities.js"]],function(o,t){const{arrayMax:e,arrayMin:i,correctFloat:s,extend:r,isNumber:a}=t;function n(t){var e=t.length;let i=l(t);return i=a(i)&&e?s(i/e):i}function l(t){let e=t.length,i;if(!e&&t.hasNulls)i=null;else if(e)for(i=0;e--;)i+=t[e];return i}t={average:n,averages:function(){const e=[];return[].forEach.call(arguments,function(t){e.push(n(t))}),"undefined"==typeof e[0]?void 0:e},close:function(t){return t.length?t[t.length-1]:t.hasNulls?null:void 0},high:function(t){return t.length?e(t):t.hasNulls?null:void 0},hlc:function(t,e,i){if(t=o.high(t),e=o.low(e),i=o.close(i),a(t)||a(e)||a(i))return[t,e,i]},low:function(t){return t.length?i(t):t.hasNulls?null:void 0},ohlc:function(t,e,i,s){if(t=o.open(t),e=o.high(e),i=o.low(i),s=o.close(s),a(t)||a(e)||a(i)||a(s))return[t,e,i,s]},open:function(t){return t.length?t[0]:t.hasNulls?null:void 0},range:function(t,e){return t=o.low(t),e=o.high(e),a(t)||a(e)?[t,e]:null===t&&null===e?null:void 0},sum:l};return r(o,t),t}),e(t,"Extensions/DataGrouping/DataGroupingDefaults.js",[],function(){return{common:{groupPixelWidth:2,dateTimeLabelFormats:{millisecond:["%A, %e %b, %H:%M:%S.%L","%A, %e %b, %H:%M:%S.%L","-%H:%M:%S.%L"],second:["%A, %e %b, %H:%M:%S","%A, %e %b, %H:%M:%S","-%H:%M:%S"],minute:["%A, %e %b, %H:%M","%A, %e %b, %H:%M","-%H:%M"],hour:["%A, %e %b, %H:%M","%A, %e %b, %H:%M","-%H:%M"],day:["%A, %e %b %Y","%A, %e %b","-%A, %e %b %Y"],week:["Week from %A, %e %b %Y","%A, %e %b","-%A, %e %b %Y"],month:["%B %Y","%B","-%B %Y"],year:["%Y","%Y","-%Y"]}},seriesSpecific:{line:{},spline:{},area:{},areaspline:{},arearange:{},column:{groupPixelWidth:10},columnrange:{groupPixelWidth:10},candlestick:{groupPixelWidth:10},ohlc:{groupPixelWidth:5},hlc:{groupPixelWidth:5},heikinashi:{groupPixelWidth:10}},units:[["millisecond",[1,2,5,10,20,25,50,100,200,500]],["second",[1,2,5,10,15,30]],["minute",[1,2,5,10,15,30]],["hour",[1,2,3,4,6,8,12]],["day",[1]],["week",[1]],["month",[1,3,6]],["year",null]]}}),e(t,"Extensions/DataGrouping/DataGroupingAxisComposition.js",[t["Extensions/DataGrouping/DataGroupingDefaults.js"],t["Core/Globals.js"],t["Core/Utilities.js"]],function(a,t,e){const i=t["composed"],{addEvent:s,extend:o,merge:r,pick:n,pushUnique:l}=e;let h;function d(e){const i=this,t=i.series;t.forEach(function(t){t.groupPixelWidth=void 0}),t.forEach(function(t){t.groupPixelWidth=i.getGroupPixelWidth&&i.getGroupPixelWidth(),t.groupPixelWidth&&(t.hasProcessed=!0),t.applyGrouping(!!e.hasExtremesChanged)})}function c(){var t=this.series;let e=t.length,i=0,s=!1,o,r;for(;e--;)(r=t[e].options.dataGrouping)&&(i=Math.max(i,n(r.groupPixelWidth,a.common.groupPixelWidth)),o=(t[e].processedXData||t[e].data).length,t[e].groupPixelWidth||o>this.chart.plotSizeX/i||o&&r.forced)&&(s=!0);return s?i:0}function p(){this.series.forEach(function(t){t.hasProcessed=!1})}function u(e,t){let i;if(t=n(t,!0),e=e||{forced:!1,units:null},this instanceof h)for(i=this.series.length;i--;)this.series[i].update({dataGrouping:e},!1);else this.chart.options.series.forEach(function(t){t.dataGrouping="boolean"==typeof e?e:r(e,t.dataGrouping)});this.ordinal&&(this.ordinal.slope=void 0),t&&this.chart.redraw()}return{compose:function g(t){h=t,l(i,g)&&(s(t,"afterSetScale",p),s(t,"postProcessData",d),o(t.prototype,{applyGrouping:d,getGroupPixelWidth:c,setDataGrouping:u}))}}}),e(t,"Extensions/DataGrouping/DataGroupingSeriesComposition.js",[t["Extensions/DataGrouping/ApproximationRegistry.js"],t["Extensions/DataGrouping/DataGroupingDefaults.js"],t["Core/Axis/DateTimeAxis.js"],t["Core/Defaults.js"],t["Core/Globals.js"],t["Core/Series/SeriesRegistry.js"],t["Core/Utilities.js"]],function(T,k,C,n,t,e,i){const s=t["composed"],{prototype:A}=e["series"],{addEvent:o,defined:P,error:w,extend:r,isNumber:O,merge:L,pick:E,pushUnique:a}=i,l=A.generatePoints;function h(r){var a=this,n=a.chart,l=a.options.dataGrouping,h=!1!==a.allowDG&&l&&E(l.enabled,n.options.isStock),d=a.reserveSpace(),t=this.currentDataGrouping;let c,p,e=!1;h&&!a.requireSorting&&(a.requireSorting=e=!0);var u=!1==(r=r,!((u=a).isCartesian&&!u.isDirty&&!u.xAxis.isDirty&&!u.yAxis.isDirty&&!r))||!h;if(e&&(a.requireSorting=!1),!u){a.destroyGroupedData();var r=l.groupAll?a.xData:a.processedXData,h=l.groupAll?a.yData:a.processedYData,u=n.plotSizeX,g=a.xAxis,f=g.options.ordinal,m=a.groupPixelWidth;let s,o;if(m&&r&&r.length&&u){o=!0,a.isDirty=!0,a.points=null;var x=g.getExtremes(),v=x.min,x=x.max,f=f&&g.ordinal&&g.ordinal.getGroupIntervalFactor(v,x,a)||1,y=g.getTimeTicks(C.Additions.prototype.normalizeTimeTickInterval(m*(x-v)/u*f,l.units||k.units),Math.min(v,r[0]),Math.max(x,r[r.length-1]),g.options.startOfWeek,r,a.closestPointRange),m=A.groupData.apply(a,[r,h,y,l.approximation]);let t=m.groupedXData,e=m.groupedYData,i=0;for(l&&l.smoothed&&t.length&&(l.firstAnchor="firstPoint",l.anchor="middle",l.lastAnchor="lastPoint",w(32,!1,n,{"dataGrouping.smoothed":"use dataGrouping.anchor"})),s=1;s<y.length;s++)y.info.segmentStarts&&-1!==y.info.segmentStarts.indexOf(s)||(i=Math.max(y[s]-y[s-1],i));(c=y.info).gapSize=i,a.closestPointRange=y.info.totalRange,a.groupMap=m.groupMap,a.currentDataGrouping=c;var u=a,b=t,f=x,v=u.options.dataGrouping,r=u.currentDataGrouping&&u.currentDataGrouping.gapSize;if(v&&u.xData&&r&&u.groupMap){h=b.length-1,n=v.anchor,m=v.firstAnchor,v=v.lastAnchor;let t=b.length-1,e=0;if(m&&u.xData[0]>=b[0]){e++;var M=u.groupMap[0].start,x=u.groupMap[0].length;let t;O(M)&&O(x)&&(t=M+(x-1)),b[0]={start:b[0],middle:b[0]+.5*r,end:b[0]+r,firstPoint:u.xData[0],lastPoint:t&&u.xData[t]}[m]}if(0<h&&v&&r&&b[h]>=f-r&&(t--,M=u.groupMap[u.groupMap.length-1].start,b[h]={start:b[h],middle:b[h]+.5*r,end:b[h]+r,firstPoint:M&&u.xData[M],lastPoint:u.xData[u.xData.length-1]}[v]),n&&"start"!==n)for(var S=r*{middle:.5,end:1}[n];t>=e;)b[t]+=S,t--}d&&(x=g,m=t,P(m[0])&&O(x.min)&&O(x.dataMin)&&m[0]<x.min&&((!P(x.options.min)&&x.min<=x.dataMin||x.min===x.dataMin)&&(x.min=Math.min(m[0],x.min)),x.dataMin=Math.min(m[0],x.dataMin)),P(m[m.length-1]))&&O(x.max)&&O(x.dataMax)&&m[m.length-1]>x.max&&((!P(x.options.max)&&O(x.dataMax)&&x.max>=x.dataMax||x.max===x.dataMax)&&(x.max=Math.max(m[m.length-1],x.max)),x.dataMax=Math.max(m[m.length-1],x.dataMax)),l.groupAll&&(a.allGroupedData=e,p=a.cropData(t,e,g.min,g.max),t=p.xData,e=p.yData,a.cropStart=p.start),a.processedXData=t,a.processedYData=e}else a.groupMap=null;a.hasGroupedData=o,a.preventGraphAnimation=(t&&t.totalRange)!==(c&&c.totalRange)}}function d(){this.groupedData&&(this.groupedData.forEach(function(t,e){t&&(this.groupedData[e]=t.destroy?t.destroy():null)},this),this.groupedData.length=0,delete this.allGroupedData)}function c(){l.apply(this),this.destroyGroupedData(),this.groupedData=this.hasGroupedData?this.points:null}function p(){return this.is("arearange")?"range":this.is("ohlc")?"ohlc":this.is("hlc")?"hlc":this.is("column")||this.options.cumulative?"sum":"average"}function u(e,i,s,t){const o=this,r=o.data,a=o.options&&o.options.data,n=[],l=[],h=[],d=e.length,c=!!i,p=[],u=o.pointArrayMap,g=u&&u.length,f=["x"].concat(u||["y"]),m=this.options.dataGrouping&&this.options.dataGrouping.groupAll;let x,v,y,b=0,M=0;var S="function"==typeof t?t:t&&T[t]?T[t]:T[o.getDGApproximation&&o.getDGApproximation()||"average"];if(g){let t=u.length;for(;t--;)p.push([])}else p.push([]);var k=g||1;for(let t=0;t<=d;t++)if(!(e[t]<s[0])){for(;"undefined"!=typeof s[b+1]&&e[t]>=s[b+1]||t===d;){x=s[b],o.dataGroupInfo={start:m?M:o.cropStart+M,length:p[0].length,groupStart:x},y=S.apply(o,p),o.pointClass&&!P(o.dataGroupInfo.options)&&(o.dataGroupInfo.options=L(o.pointClass.prototype.optionsToObject.call({series:o},o.options.data[o.cropStart+M])),f.forEach(function(t){delete o.dataGroupInfo.options[t]})),void 0!==y&&(n.push(x),l.push(y),h.push(o.dataGroupInfo)),M=t;for(let t=0;t<k;t++)p[t].length=0,p[t].hasNulls=!1;if(b+=1,t===d)break}if(t===d)break;if(u){var C,A=o.options.dataGrouping&&o.options.dataGrouping.groupAll?t:o.cropStart+t,w=r&&r[A]||o.pointClass.prototype.applyOptions.apply({series:o},[a[A]]);for(let t=0;t<g;t++)C=w[u[t]],O(C)?p[t].push(C):null===C&&(p[t].hasNulls=!0)}else v=c?i[t]:null,O(v)?p[0].push(v):null===v&&(p[0].hasNulls=!0)}return{groupedXData:n,groupedYData:l,groupMap:h}}function g(t){var e,t=t.options,i=this.type,s=this.chart.options.plotOptions,o=this.useCommonDataGrouping&&k.common,r=k.seriesSpecific;let a=n.defaultOptions.plotOptions[i].dataGrouping;s&&(r[i]||o)&&(e=this.chart.rangeSelector,a=a||L(k.common,r[i]),t.dataGrouping=L(o,a,s.series&&s.series.dataGrouping,s[i].dataGrouping,this.userOptions.dataGrouping,!t.isInternal&&e&&O(e.selected)&&e.buttonOptions[e.selected].dataGrouping))}return{compose:function f(t){var e=t.prototype.pointClass;a(s,f)&&(o(e,"update",function(){if(this.dataGroup)return w(24,!1,this.series.chart),!1}),o(t,"afterSetOptions",g),o(t,"destroy",d),r(t.prototype,{applyGrouping:h,destroyGroupedData:d,generatePoints:c,getDGApproximation:p,groupData:u}))},groupData:u}}),e(t,"Extensions/DataGrouping/DataGrouping.js",[t["Extensions/DataGrouping/DataGroupingAxisComposition.js"],t["Extensions/DataGrouping/DataGroupingDefaults.js"],t["Extensions/DataGrouping/DataGroupingSeriesComposition.js"],t["Core/Templating.js"],t["Core/Globals.js"],t["Core/Utilities.js"]],function(s,m,o,t,e,i){const x=t["format"],r=e["composed"],{addEvent:a,extend:v,isNumber:y,pick:b,pushUnique:n}=i;function l(t){var e=this.chart,i=e.time,s=t.labelConfig,o=s.series,r=s.point,a=o.options,n=o.tooltipOptions,a=a.dataGrouping,l=o.xAxis;let h=n.xDateFormat,d,c,p,u,g,f=n[t.isFooter?"footerFormat":"headerFormat"];l&&"datetime"===l.options.type&&a&&y(s.key)&&(c=o.currentDataGrouping,p=a.dateTimeLabelFormats||m.common.dateTimeLabelFormats,c?(u=p[c.unitName],1===c.count?h=u[0]:(h=u[1],d=u[2])):!h&&p&&l.dateTime&&(h=l.dateTime.getXDateFormat(s.x,n.dateTimeLabelFormats)),n=(a=b(o.groupMap?.[r.index].groupStart,s.key))+c?.totalRange-1,g=i.dateFormat(h,a),d&&(g+=i.dateFormat(d,n)),o.chart.styledMode&&(f=this.styledModeFormat(f)),t.text=x(f,{point:v(s.point,{key:g}),series:o},e),t.preventDefault())}return{compose:function h(t,e,i){s.compose(t),o.compose(e),i&&n(r,h)&&a(i,"headerFormatter",l)},groupData:o.groupData}}),e(t,"masters/modules/datagrouping.src.js",[t["Core/Globals.js"],t["Extensions/DataGrouping/ApproximationDefaults.js"],t["Extensions/DataGrouping/ApproximationRegistry.js"],t["Extensions/DataGrouping/DataGrouping.js"]],function(t,e,i,s){t.dataGrouping={approximationDefaults:e,approximations:i},s.compose(t.Axis,t.Series,t.Tooltip)}),e(t,"Extensions/Annotations/NavigationBindingsUtilities.js",[t["Core/Utilities.js"]],function(t){const{defined:s,isNumber:o,pick:r}=t,a={backgroundColor:"string",borderColor:"string",borderRadius:"string",color:"string",fill:"string",fontSize:"string",labels:"string",name:"string",stroke:"string",title:"string"};return{annotationsFieldsTypes:a,getAssignedAxis:function(t){return t.filter(t=>{var e=t.axis.getExtremes(),i=e.min,e=e.max,s=r(t.axis.minPointOffset,0);return o(i)&&o(e)&&t.value>=i-s&&t.value<=e+s&&!t.axis.options.isInternal})[0]},getFieldType:function(t,e){t=a[t];let i=typeof e;return{string:"text",number:"number","boolean":"checkbox"}[i=s(t)?t:i]}}}),e(t,"Extensions/MouseWheelZoom/MouseWheelZoom.js",[t["Core/Utilities.js"],t["Extensions/Annotations/NavigationBindingsUtilities.js"]],function(t,e){const{addEvent:i,isObject:s,pick:p,defined:u,merge:o,isNumber:g}=t,n=e["getAssignedAxis"],r=[],a={enabled:!0,sensitivity:1.1},l=t=>s(t)?o(a,t):o(a,{enabled:!u(t)||t});let f,m,x;const v=function(t,e,i,s,o){var r,a=e.isXAxis;let n=!1;if(u(e.max)&&u(e.min)&&u(e.dataMax)&&u(e.dataMin)){if(!a){var l=e;const c=l.options;u(f)&&clearTimeout(f),u(m)||(m=c.startOnTick,x=c.endOnTick),(m||x)&&(c.startOnTick=!1,c.endOnTick=!1),f=setTimeout(()=>{var t,e;u(m)&&u(x)&&(c.startOnTick=m,c.endOnTick=x,{min:t,max:e}=l.getExtremes(),l.forceRedraw=!0,l.setExtremes(t,e),m=x=void 0)},400)}var a=e.max-e.min,o=g(o)?o:e.min+a/2,t=(t=t,d=e,i=i,u(i)?(i=(i-d.minPixelPadding-d.pos)/(d.len-2*d.minPixelPadding),(h=d.isXAxis)&&!d.reversed!=!t.inverted||!h&&d.reversed?1-i:i):.5),h=a*s,d=o-h*t,i=p(e.options.max,e.dataMax)-p(e.options.min,e.dataMin),a=e.options.min?0:i*e.options.minPadding,o=e.options.max?0:i*e.options.maxPadding,t=p(e.options.min,e.dataMin)-a,i=i+o+a,o={rangeStart:d=(d=(o=t)+(a=i)<(d=d)+(r=h)?a<r?(r=a,o):o+a-r:d)<o?o:d,rangeWidth:r=a<r?a:r},d=o.rangeStart<p(e.options.min,t)||o.rangeStart===e.min&&i<o.rangeWidth&&o.rangeStart+o.rangeWidth<p(e.options.max,Number.MIN_VALUE)||o.rangeWidth===e.max-e.min;u(s)&&!d?(e.setExtremes(o.rangeStart,o.rangeStart+o.rangeWidth,!1),n=!0):e.setExtremes(void 0,void 0,!1)}return n},h=function(t,e,i,s,o,r,a){var a=p(a.type,t.zooming.type,""),n=/x/.test(a),a=/y/.test(a);let l=i.toValue(o),h=s.toValue(r);t.inverted&&(d=s.pos+s.len,l=i.toValue(r),h=s.toValue(o),c=o,o=r,r=d-c+s.pos);var d=n&&v(t,i,o,e,l),c=a&&v(t,s,r,e,h),n=d||c;return n&&t.redraw(!1),n};function d(){const r=this,a=l(r.zooming.mouseWheel);a.enabled&&i(this.container,"wheel",t=>{t=this.pointer.normalize(t);var e,i,s,o=!r.pointer.inClass(t.target,"highcharts-no-mousewheel");r.isInsidePlot(t.chartX-r.plotLeft,t.chartY-r.plotTop)&&o&&(o=a.sensitivity||1.1,e=t.detail||(t.deltaY||0)/120,i=n(this.pointer.getCoordinates(t).xAxis),s=n(this.pointer.getCoordinates(t).yAxis),h(r,Math.pow(o,e),i?i.axis:r.xAxis[0],s?s.axis:r.yAxis[0],t.chartX,t.chartY,a))&&t.preventDefault&&t.preventDefault()})}return{compose:function(t){-1===r.indexOf(t)&&(r.push(t),i(t,"afterGetContainer",d))}}}),e(t,"masters/modules/mouse-wheel-zoom.src.js",[t["Core/Globals.js"],t["Extensions/MouseWheelZoom/MouseWheelZoom.js"]],function(t,e){e.compose(t.Chart)}),e(t,"Series/DataModifyComposition.js",[t["Core/Axis/Axis.js"],t["Core/Globals.js"],t["Core/Series/Point.js"],t["Core/Series/Series.js"],t["Core/Utilities.js"]],function(t,e,i,s,o){const r=e["composed"],a=i.prototype["tooltipFormatter"],{addEvent:n,arrayMax:l,arrayMin:h,correctFloat:d,defined:c,isArray:p,isNumber:u,isString:g,pick:f,pushUnique:m}=o;var x;{function v(e,i,t){this.isXAxis||(this.series.forEach(function(t){"compare"===e&&"boolean"!=typeof i?t.setCompare(i,!1):"cumulative"!==e||g(i)||t.setCumulative(i,!1)}),f(t,!0)&&this.chart.redraw())}function y(e){const i=this,s=i.series.chart["numberFormatter"],t=function(t){e=e.replace("{point."+t+"}",(0<i[t]&&"change"===t?"+":"")+s(i[t],f(i.series.tooltipOptions.changeDecimals,2)))};return c(i.change)&&t("change"),c(i.cumulativeSum)&&t("cumulativeSum"),a.apply(this,[e])}function b(){var t=this.options.compare;let e;"percent"!==t&&"value"!==t&&!this.options.cumulative||(e=new P(this),"percent"===t||"value"===t?e.initCompare(t):e.initCumulative()),this.dataModify=e}function M(e){var e=e.dataExtremes,i=e.activeYData;if(this.dataModify&&e){let t;this.options.compare?t=[this.dataModify.modifyValue(e.dataMin),this.dataModify.modifyValue(e.dataMax)]:this.options.cumulative&&p(i)&&2<=i.length&&(t=P.getCumulativeExtremes(i)),t&&(e.dataMin=h(t),e.dataMax=l(t))}}function S(t,e){this.options.compare=this.userOptions.compare=t,this.update({},f(e,!0)),!this.dataModify||"value"!==t&&"percent"!==t?this.points.forEach(t=>{delete t.change}):this.dataModify.initCompare(t)}function k(){var i=this;if(i.xAxis&&i.processedYData&&i.dataModify){var s=i.processedXData,o=i.processedYData,r=o.length,a=!0===i.options.compareStart?0:1;let t=-1,e;for(i.pointArrayMap&&(t=i.pointArrayMap.indexOf(i.options.pointValKey||i.pointValKey||"y")),e=0;e<r-a;e++){var n=o[e]&&-1<t?o[e][t]:o[e];if(u(n)&&0!==n&&s[e+a]>=(i.xAxis.min||0)){i.dataModify.compareValue=n;break}}}}function C(t,e){this.setModifier("compare",t,e)}function A(t,e){t=f(t,!1),this.options.cumulative=this.userOptions.cumulative=t,this.update({},f(e,!0)),this.dataModify?this.dataModify.initCumulative():this.points.forEach(t=>{delete t.cumulativeSum})}function w(t,e){this.setModifier("cumulative",t,e)}(e=x=x||{}).compose=function T(t,e,i){var s;return m(r,T)&&(e=e.prototype,i=i.prototype,(s=t.prototype).setCompare=S,s.setCumulative=A,n(t,"afterInit",b),n(t,"afterGetExtremes",M),n(t,"afterProcessData",k),e.setCompare=C,e.setModifier=v,e.setCumulative=w,i.tooltipFormatter=y),t};class P{constructor(t){this.series=t}modifyValue(){return 0}static getCumulativeExtremes(t){let i=Infinity,s=-Infinity;return t.reduce((t,e)=>{e=t+e;return i=Math.min(i,e,t),s=Math.max(s,e,t),e}),[i,s]}initCompare(s){this.modifyValue=function(t,e){var i=this.compareValue;return void 0!==(t=null===t?0:t)&&void 0!==i?("value"===s?t-=i:t=t/i*100-(100===this.series.options.compareBase?0:100),void 0!==e&&(i=this.series.points[e])&&(i.change=t),t):0}}initCumulative(){this.modifyValue=function(t,e){var i;return void 0!==(t=null===t?0:t)&&void 0!==e?((i=0<e?this.series.points[e-1]:null)&&i.cumulativeSum&&(t=d(i.cumulativeSum+t)),(i=this.series.points[e])&&(i.cumulativeSum=t),t):0}}}e.Additions=P}return x}),e(t,"Core/Axis/NavigatorAxisComposition.js",[t["Core/Globals.js"],t["Core/Utilities.js"]],function(t,e){const{composed:i,isTouchDevice:a}=t,{addEvent:s,correctFloat:l,defined:h,isNumber:d,pick:c,pushUnique:o}=e;function r(){this.navigatorAxis||(this.navigatorAxis=new p(this))}function n(t){var e=this.chart,i=e.options,s=i.navigator,o=this.navigatorAxis,r=e.zooming.pinchType,i=i.rangeSelector,e=e.zooming.type;this.isXAxis&&(s&&s.enabled||i&&i.enabled)&&("y"===e?t.zoomed=!1:(!a&&"xy"===e||a&&"xy"===r)&&this.options.range&&(s=o.previousZoom,h(t.newMin)?o.previousZoom=[this.min,this.max]:s&&(t.newMin=s[0],t.newMax=s[1],o.previousZoom=void 0))),"undefined"!=typeof t.zoomed&&t.preventDefault()}class p{static compose(t){o(i,this.compose)&&(t.keepProps.push("navigatorAxis"),s(t,"init",r),s(t,"zoom",n))}constructor(t){this.axis=t}destroy(){this.axis=void 0}toFixedRange(t,e,i,s){var o=this.axis,r=o.chart;let a=c(i,o.translate(t,!0,!o.horiz)),n=c(s,o.translate(e,!0,!o.horiz));t=r&&r.fixedRange,e=(o.pointRange||0)/2;return h(i)||(a=l(a+e)),h(s)||(n=l(n-e)),t&&o.dataMin&&o.dataMax&&(a=n>=o.dataMax?l(o.dataMax-t):a)<=o.dataMin&&(n=l(o.dataMin+t)),{min:a=d(a)&&d(n)?a:n=void 0,max:n}}}return p}),e(t,"Stock/Navigator/NavigatorDefaults.js",[t["Core/Color/Color.js"],t["Core/Series/SeriesRegistry.js"]],function(t,e){t=t.parse,e=e.seriesTypes;return{height:40,margin:25,maskInside:!0,handles:{width:7,height:15,symbols:["navigator-handle","navigator-handle"],enabled:!0,lineWidth:1,backgroundColor:"#f2f2f2",borderColor:"#999999"},maskFill:t("#667aff").setOpacity(.3).get(),outlineColor:"#999999",outlineWidth:1,series:{type:"undefined"==typeof e.areaspline?"line":"areaspline",fillOpacity:.05,lineWidth:1,compare:null,sonification:{enabled:!1},dataGrouping:{approximation:"average",enabled:!0,groupPixelWidth:2,firstAnchor:"firstPoint",anchor:"middle",lastAnchor:"lastPoint",units:[["millisecond",[1,2,5,10,20,25,50,100,200,500]],["second",[1,2,5,10,15,30]],["minute",[1,2,5,10,15,30]],["hour",[1,2,3,4,6,8,12]],["day",[1,2,3,4]],["week",[1,2,3]],["month",[1,3,6]],["year",null]]},dataLabels:{enabled:!1,zIndex:2},id:"highcharts-navigator-series",className:"highcharts-navigator-series",lineColor:null,marker:{enabled:!1},threshold:null},xAxis:{overscroll:0,className:"highcharts-navigator-xaxis",tickLength:0,lineWidth:0,gridLineColor:"#e6e6e6",gridLineWidth:1,tickPixelInterval:200,labels:{align:"left",style:{color:"#000000",fontSize:"0.7em",opacity:.6,textOutline:"2px contrast"},x:3,y:-4},crosshair:!1},yAxis:{className:"highcharts-navigator-yaxis",gridLineWidth:0,startOnTick:!1,endOnTick:!1,minPadding:.1,maxPadding:.1,labels:{enabled:!1},crosshair:!1,title:{text:null},tickLength:0,tickWidth:0}}}),e(t,"Stock/Navigator/NavigatorSymbols.js",[],function(){return{"navigator-handle":function(t,e,i,s,o={}){var i=o.width?o.width/2:i,r=Math.round(i/3)+.5;return[["M",-i-1,.5],["L",i,.5],["L",i,(s=o.height||s)+.5],["L",-i-1,s+.5],["L",-i-1,.5],["M",-r,4],["L",-r,s-3],["M",r-1,4],["L",r-1,s-3]]}}}),e(t,"Stock/Navigator/NavigatorComposition.js",[t["Core/Defaults.js"],t["Core/Globals.js"],t["Core/Axis/NavigatorAxisComposition.js"],t["Stock/Navigator/NavigatorDefaults.js"],t["Stock/Navigator/NavigatorSymbols.js"],t["Core/Renderer/RendererRegistry.js"],t["Core/Utilities.js"]],function(t,e,o,r,a,i,s){const n=t["defaultOptions"],{composed:l,isTouchDevice:h}=e,d=i["getRendererType"],{addEvent:c,extend:p,merge:u,pick:g,pushUnique:f}=s;let m;function x(){this.navigator&&this.navigator.setBaseSeries(null,!1)}function v(){var t,e,i,s,o,r=this.legend,a=this.navigator;a&&(t=r&&r.options,e=a.xAxis,i=a.yAxis,{scrollbarHeight:s,scrollButtonSize:o}=a,this.inverted?(a.left=a.opposite?this.chartWidth-s-a.height:this.spacing[3]+s,a.top=this.plotTop+o):(a.left=g(e.left,this.plotLeft+o),a.top=a.navigatorOptions.top||this.chartHeight-a.height-s-(this.scrollbar?.options.margin||0)-this.spacing[2]-(this.rangeSelector&&this.extraBottomMargin?this.rangeSelector.getHeight():0)-(t&&"bottom"===t.verticalAlign&&"proximate"!==t.layout&&t.enabled&&!t.floating?r.legendHeight+g(t.margin,10):0)-(this.titleOffset?this.titleOffset[2]:0)),e)&&i&&(this.inverted?e.options.left=i.options.left=a.left:e.options.top=i.options.top=a.top,e.setAxisSize(),i.setAxisSize())}function y(t){this.navigator||this.scroller||!this.options.navigator.enabled&&!this.options.scrollbar.enabled||(this.scroller=this.navigator=new m(this),g(t.redraw,!0)&&this.redraw(t.animation))}function b(){var t=this.options;(t.navigator.enabled||t.scrollbar.enabled)&&(this.scroller=this.navigator=new m(this))}function M(){var t=this.options,e=t.navigator,t=t.rangeSelector;if((e&&e.enabled||t&&t.enabled)&&(!h&&"x"===this.zooming.type||h&&"x"===this.zooming.pinchType))return!1}function S(t){var e=t.navigator;e&&t.xAxis[0]&&(t=t.xAxis[0].getExtremes(),e.render(t.min,t.max))}function k(t){var e=t.options.navigator||{},i=t.options.scrollbar||{};this.navigator||this.scroller||!e.enabled&&!i.enabled||(u(!0,this.options.navigator,e),u(!0,this.options.scrollbar,i),delete t.options.navigator,delete t.options.scrollbar)}function C(){this.chart.navigator&&!this.options.isInternal&&this.chart.navigator.setBaseSeries(null,!1)}return{compose:function A(t,e,i,s){o.compose(t),m=i,f(l,A)&&(e.prototype.callbacks.push(S),c(e,"afterAddSeries",x),c(e,"afterSetChartSize",v),c(e,"afterUpdate",y),c(e,"beforeRender",b),c(e,"beforeShowResetZoom",M),c(e,"update",k),c(s,"afterUpdate",C),p(d().prototype.symbols,a),p(n,{navigator:r}))}}}),e(t,"Core/Axis/ScrollbarAxis.js",[t["Core/Globals.js"],t["Core/Utilities.js"]],function(t,e){const s=t["composed"],{addEvent:o,defined:d,pick:r,pushUnique:a}=e;var n;{t=n=n||{};let i;function c(t){var e=r(t.options&&t.options.min,t.min),i=r(t.options&&t.options.max,t.max);return{axisMin:e,axisMax:i,scrollMin:d(t.dataMin)?Math.min(e,t.min,t.dataMin,r(t.threshold,Infinity)):e,scrollMax:d(t.dataMax)?Math.max(i,t.max,t.dataMax,r(t.threshold,-Infinity)):i}}function l(){var t=this.scrollbar,e=t&&!t.options.opposite,e=this.horiz?2:e?3:1;t&&(this.chart.scrollbarsOffsets=[0,0],this.chart.axisOffset[e]+=t.size+(t.options.margin||0))}function h(){const n=this;n.options&&n.options.scrollbar&&n.options.scrollbar.enabled&&(n.options.scrollbar.vertical=!n.horiz,n.options.startOnTick=n.options.endOnTick=!1,n.scrollbar=new i(n.chart.renderer,n.options.scrollbar,n.chart),o(n.scrollbar,"changed",function(t){var{axisMin:e,axisMax:i,scrollMin:s,scrollMax:o}=c(n),o=o-s;let r,a;d(e)&&d(i)&&(a=n.horiz&&!n.reversed||!n.horiz&&n.reversed?(r=s+o*this.to,s+o*this.from):(r=s+o*(1-this.from),s+o*(1-this.to)),this.shouldUpdateExtremes(t.DOMType)?(e="mousemove"!==t.DOMType&&"touchmove"!==t.DOMType&&void 0,n.setExtremes(a,r,!0,e,t)):this.setRange(this.from,this.to))}))}function p(){var e=this,{scrollMin:t,scrollMax:i}=c(e),s=e.scrollbar,o=e.axisTitleMargin+(e.titleOffset||0),r=e.chart.scrollbarsOffsets,a=e.options.margin||0;let n,l,h;if(s&&r){if(e.horiz)e.opposite||(r[1]+=o),s.position(e.left,e.top+e.height+2+r[1]-(e.opposite?a:0),e.width,e.height),e.opposite||(r[1]+=a),n=1;else{e.opposite&&(r[0]+=o);let t;t=s.options.opposite?e.left+e.width+2+r[0]-(e.opposite?0:a):e.opposite?0:a,s.position(t,e.top,e.width,e.height),e.opposite&&(r[0]+=a),n=0}r[n]+=s.size+(s.options.margin||0),isNaN(t)||isNaN(i)||!d(e.min)||!d(e.max)||e.min===e.max?s.setRange(0,1):(l=(e.min-t)/(i-t),h=(e.max-t)/(i-t),e.horiz&&!e.reversed||!e.horiz&&e.reversed?s.setRange(l,h):s.setRange(1-h,1-l))}}t.compose=function u(t,e){a(s,u)&&(i=e,o(t,"afterGetOffset",l),o(t,"afterInit",h),o(t,"afterRender",p))}}return n}),e(t,"Stock/Scrollbar/ScrollbarDefaults.js",[t["Core/Globals.js"]],function(t){var{}=t;return{height:10,barBorderRadius:5,buttonBorderRadius:0,buttonsEnabled:!1,liveRedraw:void 0,margin:void 0,minWidth:6,opposite:!0,step:.2,zIndex:3,barBackgroundColor:"#cccccc",barBorderWidth:0,barBorderColor:"#cccccc",buttonArrowColor:"#333333",buttonBackgroundColor:"#e6e6e6",buttonBorderColor:"#cccccc",buttonBorderWidth:1,rifleColor:"none",trackBackgroundColor:"rgba(255, 255, 255, 0.001)",trackBorderColor:"#cccccc",trackBorderRadius:5,trackBorderWidth:1}}),e(t,"Stock/Scrollbar/Scrollbar.js",[t["Core/Defaults.js"],t["Core/Globals.js"],t["Core/Axis/ScrollbarAxis.js"],t["Stock/Scrollbar/ScrollbarDefaults.js"],t["Core/Utilities.js"]],function(t,n,e,o,i){const r=t["defaultOptions"],{addEvent:l,correctFloat:c,defined:p,destroyObjectProperties:s,fireEvent:a,merge:h,pick:d,removeEvent:u}=i;class g{static compose(t){e.compose(t,g)}static swapXY(t,e){return e&&t.forEach(e=>{var i,s=e.length;for(let t=0;t<s;t+=2)"number"==typeof(i=e[t+1])&&(e[t+1]=e[t+2],e[t+2]=i)}),t}constructor(t,e,i){this._events=[],this.chartX=0,this.chartY=0,this.from=0,this.scrollbarButtons=[],this.scrollbarLeft=0,this.scrollbarStrokeWidth=1,this.scrollbarTop=0,this.size=0,this.to=0,this.trackBorderWidth=1,this.x=0,this.y=0,this.init(t,e,i)}addEvents(){var t=this.options.inverted?[1,0]:[0,1],e=this.scrollbarButtons,i=this.scrollbarGroup.element,s=this.track.element,o=this.mouseDownHandler.bind(this),r=this.mouseMoveHandler.bind(this),a=this.mouseUpHandler.bind(this),t=[[e[t[0]].element,"click",this.buttonToMinClick.bind(this)],[e[t[1]].element,"click",this.buttonToMaxClick.bind(this)],[s,"click",this.trackClick.bind(this)],[i,"mousedown",o],[i.ownerDocument,"mousemove",r],[i.ownerDocument,"mouseup",a]];n.hasTouch&&t.push([i,"touchstart",o],[i.ownerDocument,"touchmove",r],[i.ownerDocument,"touchend",a]),t.forEach(function(t){l.apply(null,t)}),this._events=t}buttonToMaxClick(t){var e=(this.to-this.from)*d(this.options.step,.2);this.updatePosition(this.from+e,this.to+e),a(this,"changed",{from:this.from,to:this.to,trigger:"scrollbar",DOMEvent:t})}buttonToMinClick(t){var e=c(this.to-this.from)*d(this.options.step,.2);this.updatePosition(c(this.from-e),c(this.to-e)),a(this,"changed",{from:this.from,to:this.to,trigger:"scrollbar",DOMEvent:t})}cursorToScrollbarPosition(t){var e=this.options,e=e.minWidth>this.calculatedWidth?e.minWidth:0;return{chartX:(t.chartX-this.x-this.xOffset)/(this.barWidth-e),chartY:(t.chartY-this.y-this.yOffset)/(this.barWidth-e)}}destroy(){const e=this,t=e.chart.scroller;e.removeEvents(),["track","scrollbarRifles","scrollbar","scrollbarGroup","group"].forEach(function(t){e[t]&&e[t].destroy&&(e[t]=e[t].destroy())}),t&&e===t.scrollbar&&(t.scrollbar=null,s(t.scrollbarButtons))}drawScrollbarButton(t){var e=this.renderer,i=this.scrollbarButtons,s=this.options,o=this.size,r=e.g().add(this.group);i.push(r),s.buttonsEnabled&&(r=e.rect().addClass("highcharts-scrollbar-button").add(r),this.chart.styledMode||r.attr({stroke:s.buttonBorderColor,"stroke-width":s.buttonBorderWidth,fill:s.buttonBackgroundColor}),r.attr(r.crisp({x:-.5,y:-.5,width:o+1,height:o+1,r:s.buttonBorderRadius},r.strokeWidth())),r=e.path(g.swapXY([["M",o/2+(t?-1:1),o/2-3],["L",o/2+(t?-1:1),o/2+3],["L",o/2+(t?2:-2),o/2]],s.vertical)).addClass("highcharts-scrollbar-arrow").add(i[t]),this.chart.styledMode||r.attr({fill:s.buttonArrowColor}))}init(t,e,i){var s=this;s.scrollbarButtons=[],s.renderer=t,s.userOptions=e,s.options=h(o,r.scrollbar,e),s.options.margin=d(s.options.margin,10),s.chart=i,s.size=d(s.options.size,s.options.height),e.enabled&&(s.render(),s.addEvents())}mouseDownHandler(t){t=this.chart.pointer.normalize(t),t=this.cursorToScrollbarPosition(t);this.chartX=t.chartX,this.chartY=t.chartY,this.initPositions=[this.from,this.to],this.grabbedCenter=!0}mouseMoveHandler(t){var e=this,i=e.chart.pointer.normalize(t),s=e.options.vertical?"chartY":"chartX",o=e.initPositions||[];!e.grabbedCenter||t.touches&&0===t.touches[0][s]||(i=e.cursorToScrollbarPosition(i)[s]-e[s],e.hasDragged=!0,e.updatePosition(o[0]+i,o[1]+i),e.hasDragged&&a(e,"changed",{from:e.from,to:e.to,trigger:"scrollbar",DOMType:t.type,DOMEvent:t}))}mouseUpHandler(t){this.hasDragged&&a(this,"changed",{from:this.from,to:this.to,trigger:"scrollbar",DOMType:t.type,DOMEvent:t}),this.grabbedCenter=this.hasDragged=this.chartX=this.chartY=null}position(t,e,i,s){var o=this,{buttonsEnabled:r,margin:a=0,vertical:n}=o.options,l=o.rendered?"animate":"attr";let h=s,d=0;o.group.show(),o.x=t,o.y=e+this.trackBorderWidth,o.width=i,o.height=s,o.xOffset=h,o.yOffset=d,n?(o.width=o.yOffset=i=d=o.size,o.xOffset=h=0,o.yOffset=d=r?o.size:0,o.barWidth=s-(r?2*i:0),o.x=t+=a):(o.height=s=o.size,o.xOffset=h=r?o.size:0,o.barWidth=i-(r?2*s:0),o.y=o.y+a),o.group[l]({translateX:t,translateY:o.y}),o.track[l]({width:i,height:s}),o.scrollbarButtons[1][l]({translateX:n?0:i-h,translateY:n?s-d:0})}removeEvents(){this._events.forEach(function(t){u.apply(null,t)}),this._events.length=0}render(){var t=this,e=t.renderer,i=t.options,s=t.size,o=t.chart.styledMode,r=e.g("scrollbar").attr({zIndex:i.zIndex}).hide().add(),a=(t.group=r,t.track=e.rect().addClass("highcharts-scrollbar-track").attr({r:i.trackBorderRadius||0,height:s,width:s}).add(r),o||t.track.attr({fill:i.trackBackgroundColor,stroke:i.trackBorderColor,"stroke-width":i.trackBorderWidth}),t.trackBorderWidth=t.track.strokeWidth());t.track.attr({x:-a%2/2,y:-a%2/2}),t.scrollbarGroup=e.g().add(r),t.scrollbar=e.rect().addClass("highcharts-scrollbar-thumb").attr({height:s-a,width:s-a,r:i.barBorderRadius||0}).add(t.scrollbarGroup),t.scrollbarRifles=e.path(g.swapXY([["M",-3,s/4],["L",-3,2*s/3],["M",0,s/4],["L",0,2*s/3],["M",3,s/4],["L",3,2*s/3]],i.vertical)).addClass("highcharts-scrollbar-rifles").add(t.scrollbarGroup),o||(t.scrollbar.attr({fill:i.barBackgroundColor,stroke:i.barBorderColor,"stroke-width":i.barBorderWidth}),t.scrollbarRifles.attr({stroke:i.rifleColor,"stroke-width":1})),t.scrollbarStrokeWidth=t.scrollbar.strokeWidth(),t.scrollbarGroup.translate(-t.scrollbarStrokeWidth%2/2,-t.scrollbarStrokeWidth%2/2),t.drawScrollbarButton(0),t.drawScrollbarButton(1)}setRange(i,s){var o=this,r=o.options,a=r.vertical,n=r.minWidth,l=o.barWidth,h=!this.rendered||this.hasDragged||this.chart.navigator&&this.chart.navigator.hasDragged?"attr":"animate";if(p(l)){var d=l*Math.min(s,1);let t,e;i=Math.max(i,0),t=Math.ceil(l*i),o.calculatedWidth=e=c(d-t),e<n&&(t=(l-n+e)*i,e=n);d=Math.floor(t+o.xOffset+o.yOffset),l=e/2-.5;o.from=i,o.to=s,a?(o.scrollbarGroup[h]({translateY:d}),o.scrollbar[h]({height:e}),o.scrollbarRifles[h]({translateY:l}),o.scrollbarTop=d,o.scrollbarLeft=0):(o.scrollbarGroup[h]({translateX:d}),o.scrollbar[h]({width:e}),o.scrollbarRifles[h]({translateX:l}),o.scrollbarLeft=d,o.scrollbarTop=0),e<=12?o.scrollbarRifles.hide():o.scrollbarRifles.show(),!1===r.showFull&&(i<=0&&1<=s?o.group.hide():o.group.show()),o.rendered=!0}}shouldUpdateExtremes(t){return d(this.options.liveRedraw,n.svg&&!n.isTouchDevice&&!this.chart.boosted)||"mouseup"===t||"touchend"===t||!p(t)}trackClick(t){var e=this,i=e.chart.pointer.normalize(t),s=e.to-e.from,o=e.y+e.scrollbarTop,r=e.x+e.scrollbarLeft;e.options.vertical&&i.chartY>o||!e.options.vertical&&i.chartX>r?e.updatePosition(e.from+s,e.to+s):e.updatePosition(e.from-s,e.to-s),a(e,"changed",{from:e.from,to:e.to,trigger:"scrollbar",DOMEvent:t})}update(t){this.destroy(),this.init(this.chart.renderer,h(!0,this.options,t),this.chart)}updatePosition(t,e){1<e&&(t=c(1-c(e-t)),e=1),t<0&&(e=c(e-t),t=0),this.from=t,this.to=e}}return g.defaultOptions=o,r.scrollbar=h(!0,g.defaultOptions,r.scrollbar),g}),e(t,"Stock/Navigator/Navigator.js",[t["Core/Axis/Axis.js"],t["Core/Defaults.js"],t["Core/Globals.js"],t["Core/Axis/NavigatorAxisComposition.js"],t["Stock/Navigator/NavigatorComposition.js"],t["Stock/Scrollbar/Scrollbar.js"],t["Core/Utilities.js"]],function(f,t,e,m,s,x,i){const u=t["defaultOptions"],{hasTouch:a,isTouchDevice:h}=e,{addEvent:v,clamp:S,correctFloat:k,defined:C,destroyObjectProperties:o,erase:r,extend:g,find:n,fireEvent:A,isArray:y,isNumber:w,merge:b,pick:T,removeEvent:M,splat:P}=i;function O(t,...e){e=[].filter.call(e,w);if(e.length)return Math[t].apply(0,e)}class l{static compose(t,e,i){s.compose(t,e,l,i)}constructor(t){this.scrollbarHeight=0,this.init(t)}drawHandle(t,e,i,s){var o=this.navigatorOptions.handles.height;this.handles[e][s](i?{translateX:Math.round(this.left+this.height/2),translateY:Math.round(this.top+parseInt(t,10)+.5-o)}:{translateX:Math.round(this.left+parseInt(t,10)),translateY:Math.round(this.top+this.height/2-o/2-1)})}drawOutline(t,e,i,s){var o=this.navigatorOptions.maskInside,r=this.outline.strokeWidth(),a=r/2,r=r%2/2,n=this.scrollButtonSize,l=this.size,h=this.top,d=this.height,c=h-a,p=h+d;let u=this.left,g,f;i?(g=h+e+r,e=h+t+r,f=[["M",u+d,h-n-r],["L",u+d,g],["L",u,g],["M",u,e],["L",u+d,e],["L",u+d,h+l+n]],o&&f.push(["M",u+d,g-a],["L",u+d,e+a])):(t+=(u-=n)+n-r,e+=u+n-r,f=[["M",u,c],["L",t,c],["L",t,p],["M",e,p],["L",e,c],["L",u+l+2*n,h+a]],o&&f.push(["M",t-a,c],["L",e+a,c])),this.outline[s]({d:f})}drawMasks(t,e,i,s){var o=this.left,r=this.top,a=this.height;let n,l,h,d;n=i?(h=[o,o,o],d=[r,r+t,r+e],l=[a,a,a],[t,e-t,this.size-e]):(h=[o,o+t,o+e],d=[r,r,r],l=[t,e-t,this.size-e],[a,a,a]),this.shades.forEach((t,e)=>{t[s]({x:h[e],y:d[e],width:l[e],height:n[e]})})}renderElements(){const s=this,o=s.navigatorOptions,t=o.maskInside,r=s.chart,e=r.inverted,a=r.renderer,n={cursor:e?"ns-resize":"ew-resize"},l=s.navigatorGroup=a.g("navigator").attr({zIndex:8,visibility:"hidden"}).add();if([!t,t,!t].forEach((t,e)=>{var i=a.rect().addClass("highcharts-navigator-mask"+(1===e?"-inside":"-outside")).add(l);r.styledMode||(i.attr({fill:t?o.maskFill:"rgba(0,0,0,0)"}),1===e&&i.css(n)),s.shades[e]=i}),s.outline=a.path().addClass("highcharts-navigator-outline").add(l),r.styledMode||s.outline.attr({"stroke-width":o.outlineWidth,stroke:o.outlineColor}),o.handles&&o.handles.enabled){const i=o.handles,{height:h,width:d}=i;[0,1].forEach(t=>{s.handles[t]=a.symbol(i.symbols[t],-d/2-1,0,d,h,i),r.inverted&&s.handles[t].attr({rotation:90,rotationOriginX:Math.floor(-d/2),rotationOriginY:(h+d)/2}),s.handles[t].attr({zIndex:7-t}).addClass("highcharts-navigator-handle highcharts-navigator-handle-"+["left","right"][t]).add(l),r.styledMode||s.handles[t].attr({fill:i.backgroundColor,stroke:i.borderColor,"stroke-width":i.lineWidth}).css(n)})}}update(t){(this.series||[]).forEach(t=>{t.baseSeries&&delete t.baseSeries.navigatorSeries}),this.destroy();var e=this.chart.options;b(!0,e.navigator,t),this.init(this.chart)}render(t,e,i,s){var o=this,r=o.chart,a=o.xAxis,n=a.pointRange||0,l=a.navigatorAxis.fake?r.xAxis[0]:a,h=o.navigatorEnabled,d=o.rendered,c=r.inverted,p=r.xAxis[0].minRange,u=r.xAxis[0].options.maxRange,g=o.scrollButtonSize;let f,m,x,v=o.scrollbarHeight,y,b;if(!this.hasDragged||C(i)){if(t=k(t-n/2),e=k(e+n/2),!w(t)||!w(e)){if(!d)return;i=0,s=T(a.width,l.width)}o.left=T(a.left,r.plotLeft+g+(c?r.plotWidth:0));var r=o.size=y=T(a.len,(c?r.plotHeight:r.plotWidth)-2*g),t=(f=c?v:y+2*g,i=T(i,a.toPixels(t,!0)),s=T(s,a.toPixels(e,!0)),w(i)&&Math.abs(i)!==Infinity||(i=0,s=f),a.toValue(i,!0)),e=a.toValue(s,!0),M=Math.abs(k(e-t)),p=(M<p?this.grabbedLeft?i=a.toPixels(e-p-n,!0):this.grabbedRight&&(s=a.toPixels(t+p+n,!0)):C(u)&&k(M-n)>u&&(this.grabbedLeft?i=a.toPixels(e-u-n,!0):this.grabbedRight&&(s=a.toPixels(t+u+n,!0))),o.zoomedMax=S(Math.max(i,s),0,r),o.zoomedMin=S(o.fixedWidth?o.zoomedMax-o.fixedWidth:Math.min(i,s),0,r),o.range=o.zoomedMax-o.zoomedMin,r=Math.round(o.zoomedMax),Math.round(o.zoomedMin));h&&(o.navigatorGroup.attr({visibility:"inherit"}),b=d&&!o.hasDragged?"animate":"attr",o.drawMasks(p,r,c,b),o.drawOutline(p,r,c,b),o.navigatorOptions.handles.enabled)&&(o.drawHandle(p,0,c,b),o.drawHandle(r,1,c,b)),o.scrollbar&&(c?(x=o.top-g,m=o.left-v+(h||!l.opposite?0:(l.titleOffset||0)+l.axisTitleMargin),v=y+2*g):(x=o.top+(h?o.height:-v),m=o.left-g),o.scrollbar.position(m,x,f,v),o.scrollbar.setRange(o.zoomedMin/(y||1),o.zoomedMax/(y||1))),o.rendered=!0,A(this,"afterRender")}}addMouseEvents(){const e=this,t=e.chart,i=t.container;var s,o,r=[];e.mouseMoveHandler=s=function(t){e.onMouseMove(t)},e.mouseUpHandler=o=function(t){e.onMouseUp(t)},(r=e.getPartsEvents("mousedown")).push(v(t.renderTo,"mousemove",s),v(i.ownerDocument,"mouseup",o)),a&&(r.push(v(t.renderTo,"touchmove",s),v(i.ownerDocument,"touchend",o)),r.concat(e.getPartsEvents("touchstart"))),e.eventsToUnbind=r,e.series&&e.series[0]&&r.push(v(e.series[0].xAxis,"foundExtremes",function(){t.navigator.modifyNavigatorAxisExtremes()}))}getPartsEvents(s){const o=this,r=[];return["shades","handles"].forEach(function(i){o[i].forEach(function(t,e){r.push(v(t.element,s,function(t){o[i+"Mousedown"](t,e)}))})}),r}shadesMousedown(t,e){t=this.chart.pointer.normalize(t);var i=this,s=i.chart,o=i.xAxis,r=i.zoomedMin,a=i.size,n=i.range;let l=i.left,h=t.chartX,d,c,p,u;s.inverted&&(h=t.chartY,l=i.top),1===e?(i.grabbedCenter=h,i.fixedWidth=n,i.dragOffset=h-r):(u=h-l-n/2,0===e?u=Math.max(0,u):2===e&&u+n>=a&&(u=a-n,i.reversedExtremes?(u-=n,c=i.getUnionExtremes().dataMin):d=i.getUnionExtremes().dataMax),u!==r&&(i.fixedWidth=n,p=o.navigatorAxis.toFixedRange(u,u+n,c,d),C(p.min))&&s.xAxis[0].setExtremes(Math.min(p.min,p.max),Math.max(p.min,p.max),!0,null,{trigger:"navigator"}))}handlesMousedown(t,e){t=this.chart.pointer.normalize(t);var t=this,i=t.chart,s=i.xAxis[0],o=t.reversedExtremes;0===e?(t.grabbedLeft=!0,t.otherHandlePos=t.zoomedMax,t.fixedExtreme=o?s.min:s.max):(t.grabbedRight=!0,t.otherHandlePos=t.zoomedMin,t.fixedExtreme=o?s.max:s.min),i.fixedRange=null}onMouseMove(t){const e=this,i=e.chart,s=e.navigatorSize,o=e.range,r=e.dragOffset,a=i.inverted;let n=e.left,l;t.touches&&0===t.touches[0].pageX||(t=i.pointer.normalize(t),l=t.chartX,a&&(n=e.top,l=t.chartY),e.grabbedLeft?(e.hasDragged=!0,e.render(0,0,l-n,e.otherHandlePos)):e.grabbedRight?(e.hasDragged=!0,e.render(0,0,e.otherHandlePos,l-n)):e.grabbedCenter&&(e.hasDragged=!0,l<r?l=r:l>s+r-o&&(l=s+r-o),e.render(0,0,l-r,l-r+o)),e.hasDragged&&e.scrollbar&&T(e.scrollbar.options.liveRedraw,!h&&!this.chart.boosted)&&(t.DOMType=t.type,setTimeout(function(){e.onMouseUp(t)},0)))}onMouseUp(t){var e=this,i=e.chart,s=e.xAxis,o=e.scrollbar,r=t.DOMEvent||t,a=i.inverted,n=e.rendered&&!e.hasDragged?"animate":"attr";let l,h,d,c,p,u;(!e.hasDragged||o&&o.hasDragged)&&"scrollbar"!==t.trigger||(d=e.getUnionExtremes(),e.zoomedMin===e.otherHandlePos?c=e.fixedExtreme:e.zoomedMax===e.otherHandlePos&&(p=e.fixedExtreme),e.zoomedMax===e.size&&(p=e.reversedExtremes?d.dataMin:d.dataMax),0===e.zoomedMin&&(c=e.reversedExtremes?d.dataMax:d.dataMin),u=s.navigatorAxis.toFixedRange(e.zoomedMin,e.zoomedMax,c,p),C(u.min)&&i.xAxis[0].setExtremes(Math.min(u.min,u.max),Math.max(u.min,u.max),!0,!e.hasDragged&&null,{trigger:"navigator",triggerOp:"navigator-drag",DOMEvent:r})),"mousemove"!==t.DOMType&&"touchmove"!==t.DOMType&&(e.grabbedLeft=e.grabbedRight=e.grabbedCenter=e.fixedWidth=e.fixedExtreme=e.otherHandlePos=e.hasDragged=e.dragOffset=null),e.navigatorEnabled&&w(e.zoomedMin)&&w(e.zoomedMax)&&(h=Math.round(e.zoomedMin),l=Math.round(e.zoomedMax),e.shades&&e.drawMasks(h,l,a,n),e.outline&&e.drawOutline(h,l,a,n),e.navigatorOptions.handles.enabled)&&Object.keys(e.handles).length===e.handles.length&&(e.drawHandle(h,0,a,n),e.drawHandle(l,1,a,n))}removeEvents(){this.eventsToUnbind&&(this.eventsToUnbind.forEach(function(t){t()}),this.eventsToUnbind=void 0),this.removeBaseSeriesEvents()}removeBaseSeriesEvents(){var t=this.baseSeries||[];this.navigatorEnabled&&t[0]&&(!1!==this.navigatorOptions.adaptToUpdatedData&&t.forEach(function(t){M(t,"updatedData",this.updatedDataHandler)},this),t[0].xAxis)&&M(t[0].xAxis,"foundExtremes",this.modifyBaseAxisExtremes)}init(a){const t=a.options,e=t.navigator||{},i=e.enabled,s=t.scrollbar||{},o=s.enabled,r=i&&e.height||0,n=o&&s.height||0,l=s.buttonsEnabled&&n||0,h=(this.handles=[],this.shades=[],this.chart=a,this.setBaseSeries(),this.height=r,this.scrollbarHeight=n,this.scrollButtonSize=l,this.scrollbarEnabled=o,this.navigatorEnabled=i,this.navigatorOptions=e,this.scrollbarOptions=s,this.opposite=T(e.opposite,Boolean(!i&&a.inverted)),this),d=h.baseSeries,c=a.xAxis.length,p=a.yAxis.length,u=d&&d[0]&&d[0].xAxis||a.xAxis[0]||{options:{}};var g;a.isDirtyBox=!0,h.navigatorEnabled?(h.xAxis=new f(a,b({breaks:u.options.breaks,ordinal:u.options.ordinal},e.xAxis,{id:"navigator-x-axis",yAxis:"navigator-y-axis",type:"datetime",index:c,isInternal:!0,offset:0,keepOrdinalPadding:!0,startOnTick:!1,endOnTick:!1,minPadding:0,maxPadding:0,zoomEnabled:!1},a.inverted?{offsets:[l,0,-l,0],width:r}:{offsets:[0,-l,0,l],height:r}),"xAxis"),h.yAxis=new f(a,b(e.yAxis,{id:"navigator-y-axis",alignTicks:!1,offset:0,index:p,isInternal:!0,reversed:T(e.yAxis&&e.yAxis.reversed,a.yAxis[0]&&a.yAxis[0].reversed,!1),zoomEnabled:!1},a.inverted?{width:r}:{height:r}),"yAxis"),d||e.series.data?h.updateNavigatorSeries(!1):0===a.series.length&&(h.unbindRedraw=v(a,"beforeRedraw",function(){0<a.series.length&&!h.series&&(h.setBaseSeries(),h.unbindRedraw())})),h.reversedExtremes=a.inverted&&!h.xAxis.reversed||!a.inverted&&h.xAxis.reversed,h.renderElements(),h.addMouseEvents()):(h.xAxis={chart:a,navigatorAxis:{fake:!0},translate:function(t,e){var i=a.xAxis[0],s=i.getExtremes(),o=i.len-2*l,r=O("min",i.options.min,s.dataMin),i=O("max",i.options.max,s.dataMax)-r;return e?t*i/o+r:o*(t-r)/i},toPixels:function(t){return this.translate(t)},toValue:function(t){return this.translate(t,!0)}},h.xAxis.navigatorAxis.axis=h.xAxis,h.xAxis.navigatorAxis.toFixedRange=m.prototype.toFixedRange.bind(h.xAxis.navigatorAxis)),a.options.scrollbar.enabled&&(g=b(a.options.scrollbar,{vertical:a.inverted}),!w(g.margin)&&h.navigatorEnabled&&(g.margin=a.inverted?-3:3),a.scrollbar=h.scrollbar=new x(a.renderer,g,a),v(h.scrollbar,"changed",function(t){var e=h.size,i=e*this.to,e=e*this.from;h.hasDragged=h.scrollbar.hasDragged,h.render(0,0,e,i),this.shouldUpdateExtremes(t.DOMType)&&setTimeout(function(){h.onMouseUp(t)})})),h.addBaseSeriesEvents(),h.addChartEvents()}getUnionExtremes(t){var e=this.chart.xAxis[0],i=this.xAxis,s=i.options,o=e.options;let r;return r=t&&null===e.dataMin?r:{dataMin:T(s&&s.min,O("min",o.min,e.dataMin,i.dataMin,i.min)),dataMax:T(s&&s.max,O("max",o.max,e.dataMax,i.dataMax,i.max))}}setBaseSeries(i,t){const e=this.chart,s=this.baseSeries=[];i=i||e.options&&e.options.navigator.baseSeries||(e.series.length?n(e.series,t=>!t.options.isInternal).index:0),(e.series||[]).forEach((t,e)=>{t.options.isInternal||!t.options.showInNavigator&&(e!==i&&t.options.id!==i||!1===t.options.showInNavigator)||s.push(t)}),this.xAxis&&!this.xAxis.navigatorAxis.fake&&this.updateNavigatorSeries(!0,t)}updateNavigatorSeries(t,s){const o=this,r=o.chart,a=o.baseSeries,n={enableMouseTracking:!1,index:null,linkedTo:null,group:"nav",padXAxis:!1,xAxis:"navigator-x-axis",yAxis:"navigator-y-axis",showInLegend:!1,stacking:void 0,isInternal:!0,states:{inactive:{opacity:1}}},l=o.series=(o.series||[]).filter(t=>{var e=t.baseSeries;return!(a.indexOf(e)<0&&(e&&(M(e,"updatedData",o.updatedDataHandler),delete e.navigatorSeries),t.chart&&t.destroy(),1))});let h,d,c=o.navigatorOptions.series,p;a&&a.length&&a.forEach(t=>{var e=t.navigatorSeries,i=g({color:t.color,visible:t.visible},y(c)?u.navigator.series:c);e&&!1===o.navigatorOptions.adaptToUpdatedData||(n.name="Navigator "+a.length,h=t.options||{},p=h.navigatorOptions||{},i.dataLabels=P(i.dataLabels),(d=b(h,n,i,p)).pointRange=T(i.pointRange,p.pointRange,u.plotOptions[d.type||"line"].pointRange),i=p.data||i.data,o.hasNavigatorData=o.hasNavigatorData||!!i,d.data=i||h.data&&h.data.slice(0),e&&e.options?e.update(d,s):(t.navigatorSeries=r.initSeries(d),t.navigatorSeries.baseSeries=t,l.push(t.navigatorSeries)))}),(!c.data||a&&a.length)&&!y(c)||(o.hasNavigatorData=!1,(c=P(c)).forEach((t,e)=>{n.name="Navigator "+(l.length+1),(d=b(u.navigator.series,{color:r.series[e]&&!r.series[e].options.isInternal&&r.series[e].color||r.options.colors[e]||r.options.colors[0]},n,t)).data=t.data,d.data&&(o.hasNavigatorData=!0,l.push(r.initSeries(d)))})),t&&this.addBaseSeriesEvents()}addBaseSeriesEvents(){const e=this,t=e.baseSeries||[];t[0]&&t[0].xAxis&&t[0].eventsToUnbind.push(v(t[0].xAxis,"foundExtremes",this.modifyBaseAxisExtremes)),t.forEach(t=>{t.eventsToUnbind.push(v(t,"show",function(){this.navigatorSeries&&this.navigatorSeries.setVisible(!0,!1)})),t.eventsToUnbind.push(v(t,"hide",function(){this.navigatorSeries&&this.navigatorSeries.setVisible(!1,!1)})),!1!==this.navigatorOptions.adaptToUpdatedData&&t.xAxis&&t.eventsToUnbind.push(v(t,"updatedData",this.updatedDataHandler)),t.eventsToUnbind.push(v(t,"remove",function(){this.navigatorSeries&&(r(e.series,this.navigatorSeries),C(this.navigatorSeries.options)&&this.navigatorSeries.remove(!1),delete this.navigatorSeries)}))})}getBaseSeriesMin(t){return this.baseSeries.reduce(function(t,e){return Math.min(t,e.xData&&e.xData.length?e.xData[0]:t)},t)}modifyNavigatorAxisExtremes(){var t,e=this.xAxis;"undefined"==typeof e.getExtremes||!(t=this.getUnionExtremes(!0))||t.dataMin===e.min&&t.dataMax===e.max||(e.min=t.dataMin,e.max=t.dataMax)}modifyBaseAxisExtremes(){var t=this,e=t.chart.navigator,i=t.getExtremes(),s=i.min,o=i.max,r=i.dataMin,i=i.dataMax,o=o-s,s=e.stickToMin,a=e.stickToMax,n=T(t.options.overscroll,0),l=e.series&&e.series[0],h=!!t.setExtremes;let d,c;t.eventArgs&&"rangeSelectorButton"===t.eventArgs.trigger||(s&&(c=r,d=c+o),a&&(d=i+n,s||(c=Math.max(r,d-o,e.getBaseSeriesMin(l&&l.xData?l.xData[0]:-Number.MAX_VALUE)))),h&&(s||a)&&w(c)&&(t.min=t.userMin=c,t.max=t.userMax=d)),e.stickToMin=e.stickToMax=null}updatedDataHandler(){var t=this.chart.navigator,e=this.navigatorSeries,i=t.reversedExtremes?0===Math.round(t.zoomedMin):Math.round(t.zoomedMax)>=Math.round(t.size);t.stickToMax=T(this.chart.options.navigator&&this.chart.options.navigator.stickToMax,i),t.stickToMin=t.shouldStickToMin(this,t),e&&!t.hasNavigatorData&&(e.options.pointStart=this.xData[0],e.setData(this.options.data,!1,null,!1))}shouldStickToMin(t,e){var e=e.getBaseSeriesMin(t.xData[0]),t=t.xAxis,i=t.max,s=t.min,t=t.options.range;let o=!0;return o=!(!w(i)||!w(s))&&(t&&0<i-e?i-e<t:s<=e)}addChartEvents(){this.eventsToUnbind||(this.eventsToUnbind=[]),this.eventsToUnbind.push(v(this.chart,"redraw",function(){var t=this.navigator,e=t&&(t.baseSeries&&t.baseSeries[0]&&t.baseSeries[0].xAxis||this.xAxis[0]);e&&t.render(e.min,e.max)}),v(this.chart,"getMargins",function(){let t=this.navigator,e=t.opposite?"plotTop":"marginBottom";this[e=this.inverted?t.opposite?"marginRight":"plotLeft":e]=(this[e]||0)+(t.navigatorEnabled||!this.inverted?t.height+t.scrollbarHeight:0)+t.navigatorOptions.margin}))}destroy(){this.removeEvents(),this.xAxis&&(r(this.chart.xAxis,this.xAxis),r(this.chart.axes,this.xAxis)),this.yAxis&&(r(this.chart.yAxis,this.yAxis),r(this.chart.axes,this.yAxis)),(this.series||[]).forEach(t=>{t.destroy&&t.destroy()}),["series","xAxis","yAxis","shades","outline","scrollbarTrack","scrollbarRifles","scrollbarGroup","scrollbar","navigatorGroup","rendered"].forEach(t=>{this[t]&&this[t].destroy&&this[t].destroy(),this[t]=null}),[this.handles].forEach(t=>{o(t)})}}return l}),e(t,"Stock/RangeSelector/RangeSelectorDefaults.js",[],function(){return{lang:{rangeSelectorZoom:"Zoom",rangeSelectorFrom:"",rangeSelectorTo:"→"},rangeSelector:{allButtonsEnabled:!1,buttons:void 0,buttonSpacing:5,dropdown:"responsive",enabled:void 0,verticalAlign:"top",buttonTheme:{width:28,height:18,padding:2,zIndex:7},floating:!1,x:0,y:0,height:void 0,inputBoxBorderColor:"none",inputBoxHeight:17,inputBoxWidth:void 0,inputDateFormat:"%e %b %Y",inputDateParser:void 0,inputEditDateFormat:"%Y-%m-%d",inputEnabled:!0,inputPosition:{align:"right",x:0,y:0},inputSpacing:5,selected:void 0,buttonPosition:{align:"left",x:0,y:0},inputStyle:{color:"#334eff",cursor:"pointer",fontSize:"0.8em"},labelStyle:{color:"#666666",fontSize:"0.8em"}}}}),e(t,"Stock/RangeSelector/RangeSelectorComposition.js",[t["Core/Defaults.js"],t["Core/Globals.js"],t["Stock/RangeSelector/RangeSelectorDefaults.js"],t["Core/Utilities.js"]],function(t,e,s,i){const o=t["defaultOptions"],r=e["composed"],{addEvent:n,defined:a,extend:l,find:h,isNumber:d,merge:c,pick:p,pushUnique:u}=i,g=[];let f;function m(){const t=this.range,r=t.type,e=this.max,a=this.chart.time,i=function(t,e){var i="year"===r?"FullYear":"Month",s=new a.Date(t),o=a.get(i,s);return a.set(i,s,o+e),o===a.get(i,s)&&a.set("Date",s,0),s.getTime()-t};let s,o;d(t)?(s=e-t,o=t):t&&(s=e+i(e,-(t.count||1)),this.chart)&&(this.chart.fixedRange=e-s);var n=p(this.dataMin,Number.MIN_VALUE);return(s=d(s)?s:n)<=n&&(s=n,void 0===o&&(o=i(s,t.count)),this.newMax=Math.min(s+o,p(this.dataMax,Number.MAX_VALUE))),d(e)?!d(t)&&t&&t._offsetMin&&(s+=t._offsetMin):s=void 0,s}function x(){this.options.rangeSelector&&this.options.rangeSelector.enabled&&(this.rangeSelector=new f(this))}function v(){var t=this.axes,e=this.rangeSelector;e&&(d(e.deferredYTDClick)&&(e.clickButton(e.deferredYTDClick),delete e.deferredYTDClick),t.forEach(t=>{t.updateNames(),t.setScale()}),this.getAxisMargins(),e.render(),t=e.options.verticalAlign,e.options.floating||("bottom"===t?this.extraBottomMargin=!0:"middle"!==t&&(this.extraTopMargin=!0)))}function y(e){let t,i,s,o;const r=e.rangeSelector,a=()=>{r&&(t=e.xAxis[0].getExtremes(),i=e.legend,o=r&&r.options.verticalAlign,d(t.min)&&r.render(t.min,t.max),i.display)&&"top"===o&&o===i.options.verticalAlign&&(s=c(e.spacingBox),"vertical"===i.options.layout?s.y=e.plotTop:s.y+=r.getHeight(),i.group.placed=!1,i.align(s))};r&&(h(g,t=>t[0]===e)||g.push([e,[n(e.xAxis[0],"afterSetExtremes",function(t){r&&r.render(t.min,t.max)}),n(e,"redraw",a)]]),a())}function b(){for(let t=0,e=g.length;t<e;++t){var i=g[t];if(i[0]===this)return i[1].forEach(t=>t()),void g.splice(t,1)}}function M(){var t=this.rangeSelector;t&&(t=t.getHeight(),this.extraTopMargin&&(this.plotTop+=t),this.extraBottomMargin)&&(this.marginBottom+=t)}function S(){var t=this.rangeSelector;t&&!t.options.floating&&(t.render(),"bottom"===(t=t.options.verticalAlign)?this.extraBottomMargin=!0:"middle"!==t&&(this.extraTopMargin=!0))}function k(t){var t=t.options.rangeSelector,e=this.extraBottomMargin,i=this.extraTopMargin;let s=this.rangeSelector;t&&t.enabled&&!a(s)&&this.options.rangeSelector&&(this.options.rangeSelector.enabled=!0,this.rangeSelector=s=new f(this)),this.extraBottomMargin=!1,this.extraTopMargin=!1,s&&(y(this),t=t&&t.verticalAlign||s.options&&s.options.verticalAlign,s.options.floating||("bottom"===t?this.extraBottomMargin=!0:"middle"!==t&&(this.extraTopMargin=!0)),this.extraBottomMargin===e&&this.extraTopMargin===i||(this.isDirtyBox=!0))}return{compose:function C(t,e,i){f=i,u(r,C)&&(i=e.prototype,t.prototype.minFromRange=m,n(e,"afterGetContainer",x),n(e,"beforeRender",v),n(e,"destroy",b),n(e,"getMargins",M),n(e,"render",S),n(e,"update",k),i.callbacks.push(y),l(o,{rangeSelector:s.rangeSelector}),l(o.lang,s.lang))}}}),e(t,"Stock/RangeSelector/RangeSelector.js",[t["Core/Axis/Axis.js"],t["Core/Defaults.js"],t["Core/Globals.js"],t["Stock/RangeSelector/RangeSelectorComposition.js"],t["Core/Renderer/SVG/SVGElement.js"],t["Core/Utilities.js"]],function(b,t,v,i,s,e){const y=t["defaultOptions"],{addEvent:M,createElement:S,css:k,defined:T,destroyObjectProperties:o,discardElement:r,extend:C,fireEvent:A,isNumber:P,merge:w,objectEach:a,pad:n,pick:O,pInt:l,splat:L}=e;class h{static compose(t,e){i.compose(t,e,h)}constructor(t){this.buttonOptions=h.prototype.defaultButtons,this.initialButtonGroupWidth=0,this.chart=t,this.init(t)}clickButton(t,e){var i=this.chart,s=this.buttonOptions[t],o=i.xAxis[0],r=i.scroller&&i.scroller.getUnionExtremes()||o||{},a=s.type,n=s.dataGrouping;let l=r.dataMin,h=r.dataMax,d,c=o&&Math.round(Math.min(o.max,O(h,o.max))),p,u=s._range,g,f,m,x,v,y=!0;if(null!==l&&null!==h){if(i.fixedRange=u,this.setSelected(t),n&&(this.forcedDataGrouping=!0,b.prototype.setDataGrouping.call(o||{chart:this.chart},n,!1),this.frozenStates=s.preserveDataGrouping),"month"===a||"year"===a)o?(x={range:s,max:c,chart:i,dataMin:l,dataMax:h},d=o.minFromRange.call(x),P(x.newMax)&&(c=x.newMax),y=!1):u=s;else if(u)d=Math.max(c-u,l),c=Math.min(d+u,h),y=!1;else if("ytd"===a){if(!o)return void(this.deferredYTDClick=t);void 0!==h&&void 0!==l||(l=Number.MAX_VALUE,h=Number.MIN_VALUE,i.series.forEach(t=>{t=t.xData;t&&(l=Math.min(t[0],l),h=Math.max(t[t.length-1],h))}),e=!1),v=this.getYTDExtremes(h,l,i.time.useUTC),d=g=v.min,c=v.max}else"all"===a&&o&&(i.navigator&&i.navigator.baseSeries[0]&&(i.navigator.baseSeries[0].xAxis.options.range=void 0),d=l,c=h);y&&s._offsetMin&&T(d)&&(d+=s._offsetMin),s._offsetMax&&T(c)&&(c+=s._offsetMax),this.dropdown&&(this.dropdown.selectedIndex=t+1),o?o.setExtremes(d,c,O(e,!0),void 0,{trigger:"rangeSelectorButton",rangeSelectorButton:s}):(p=L(i.options.xAxis)[0],m=p.range,p.range=u,f=p.min,p.min=g,M(i,"load",function(){p.range=m,p.min=f})),A(this,"afterBtnClick")}}setSelected(t){this.selected=this.options.selected=t}init(e){const i=this,t=e.options.rangeSelector,s=t.buttons||i.defaultButtons.slice(),o=t.selected,r=function(){var t=i.minInput,e=i.maxInput;t&&t.blur&&A(t,"blur"),e&&e.blur&&A(e,"blur")};i.chart=e,i.options=t,i.buttons=[],i.buttonOptions=s,this.eventsToUnbind=[],this.eventsToUnbind.push(M(e.container,"mousedown",r)),this.eventsToUnbind.push(M(e,"resize",r)),s.forEach(i.computeButtonRange),void 0!==o&&s[o]&&this.clickButton(o,!1),this.eventsToUnbind.push(M(e,"load",function(){e.xAxis&&e.xAxis[0]&&M(e.xAxis[0],"setExtremes",function(t){this.max-this.min!==e.fixedRange&&"rangeSelectorButton"!==t.trigger&&"updatedData"!==t.trigger&&i.forcedDataGrouping&&!i.frozenStates&&this.setDataGrouping(!1,!1)})}))}updateButtonStates(){const u=this,t=this.chart,g=this.dropdown,f=t.xAxis[0],m=Math.round(f.max-f.min),x=!f.hasVisibleSeries,e=t.scroller&&t.scroller.getUnionExtremes()||f,v=e.dataMin,y=e.dataMax,i=u.getYTDExtremes(y,v,t.time.useUTC),b=i.min,M=i.max,S=u.selected,k=u.options.allButtonsEnabled,C=u.buttons;let A=P(S),w=!1;u.buttonOptions.forEach((t,e)=>{var i=t._range,s=t.type,o=t.count||1,r=C[e],t=t._offsetMax-t._offsetMin,a=e===S,n=i>y-v,l=i<f.minRange;let h=0,d=!1,c=!1,p=i===m;a&&n&&(w=!0),("month"===s||"year"===s)&&m+36e5>=864e5*{month:28,year:365}[s]*o-t&&m-36e5<=864e5*{month:31,year:366}[s]*o+t?p=!0:"ytd"===s?(p=M-b+t===m,d=!a):"all"===s&&(p=f.max-f.min>=y-v,c=!a&&A&&p);i=!k&&!(w&&"all"===s)&&(n||l||c||x),o=w&&"all"===s||a&&p||p&&!A&&!d||a&&u.frozenStates;i?h=3:o&&(A=!0,h=2),r.state!==h&&(r.setState(h),g&&(g.options[e+1].disabled=i,2===h)&&(g.selectedIndex=e+1),0===h&&S===e?u.setSelected():(2===h&&!T(S)||w)&&u.setSelected(e))})}computeButtonRange(t){var e=t.type,i=t.count||1,s={millisecond:1,second:1e3,minute:6e4,hour:36e5,day:864e5,week:6048e5};s[e]?t._range=s[e]*i:"month"!==e&&"year"!==e||(t._range=24*{month:30,year:365}[e]*36e5*i),t._offsetMin=O(t.offsetMin,0),t._offsetMax=O(t.offsetMax,0),t._range+=t._offsetMax-t._offsetMin}getInputValue(t){var t="min"===t?this.minInput:this.maxInput,e=this.chart.options.rangeSelector,i=this.chart.time;return t?("text"===t.type&&e.inputDateParser||this.defaultInputDateParser)(t.value,i.useUTC,i):0}setInputValue(e,i){var s=this.options,o=this.chart.time,r="min"===e?this.minInput:this.maxInput,e="min"===e?this.minDateBox:this.maxDateBox;if(r){var a=r.getAttribute("data-hc-time");let t=T(a)?Number(a):void 0;T(i)&&(a=t,T(a)&&r.setAttribute("data-hc-time-previous",a),r.setAttribute("data-hc-time",i),t=i),r.value=o.dateFormat(this.inputTypeFormats[r.type]||s.inputEditDateFormat,t),e&&e.attr({text:o.dateFormat(s.inputDateFormat,t)})}}setInputExtremes(t,e,i){var s,o,t="min"===t?this.minInput:this.maxInput;t&&(s=this.inputTypeFormats[t.type],o=this.chart.time,s)&&(e=o.dateFormat(s,e),t.min!==e&&(t.min=e),e=o.dateFormat(s,i),t.max!==e)&&(t.max=e)}showInput(t){var e,i,s,o,r,a,n="min"===t?this.minDateBox:this.maxDateBox,t="min"===t?this.minInput:this.maxInput;t&&n&&this.inputGroup&&(e="text"===t.type,{translateX:i=0,translateY:s=0}=this.inputGroup,{x:n=0,width:o=0,height:r=0}=n,a=this.options["inputBoxWidth"],k(t,{width:e?o+(a?-2:20)+"px":"auto",height:r-2+"px",border:"2px solid silver"}),e&&a?k(t,{left:i+n+"px",top:s+"px"}):k(t,{left:Math.min(Math.round(n+i-(t.offsetWidth-o)/2),this.chart.chartWidth-t.offsetWidth)+"px",top:s-(t.offsetHeight-r)/2+"px"}))}hideInput(t){t="min"===t?this.minInput:this.maxInput;t&&k(t,{top:"-9999em",border:0,width:"1px",height:"1px"})}defaultInputDateParser(t,e,i){var s;let o=t.split("/").join("-").split(" ").join("T"),r=(-1===o.indexOf("T")&&(o+="T00:00"),e?o+="Z":!v.isSafari||6<(s=o).length&&(s.lastIndexOf("-")===s.length-6||s.lastIndexOf("+")===s.length-6)||(s=new Date(o).getTimezoneOffset()/60,o+=s<=0?`+${n(-s)}:00`:`-${n(s)}:00`),Date.parse(o));return P(r)||(s=t.split("-"),r=Date.UTC(l(s[0]),l(s[1])-1,l(s[2]))),i&&e&&P(r)&&(r+=i.getTimezoneOffset(r)),r}drawInput(a){const{chart:n,div:t,inputGroup:e}=this,l=this,i=n.renderer.style||{},s=n.renderer,o=n.options.rangeSelector,r=y.lang,h="min"===a;function d(){var{maxInput:t,minInput:e}=l,i=n.xAxis[0],s=n.scroller&&n.scroller.getUnionExtremes()||i,o=s.dataMin,s=s.dataMax;let r=l.getInputValue(a);r!==Number(m.getAttribute("data-hc-time-previous"))&&P(r)&&(m.setAttribute("data-hc-time-previous",r),h&&t&&P(o)?r>Number(t.getAttribute("data-hc-time"))?r=void 0:r<o&&(r=o):e&&P(s)&&(r<Number(e.getAttribute("data-hc-time"))?r=void 0:r>s&&(r=s)),void 0!==r)&&i.setExtremes(h?r:i.min,h?i.max:r,void 0,void 0,{trigger:"rangeSelectorInput"})}var c,p,u,g=r[h?"rangeSelectorFrom":"rangeSelectorTo"]||"",g=s.label(g,0).addClass("highcharts-range-label").attr({padding:g?2:0,height:g?o.inputBoxHeight:0}).add(e),f=s.label("",0).addClass("highcharts-range-input").attr({padding:2,width:o.inputBoxWidth,height:o.inputBoxHeight,"text-align":"center"}).on("click",function(){l.showInput(a),l[a+"Input"].focus()});n.styledMode||f.attr({stroke:o.inputBoxBorderColor,"stroke-width":1}),f.add(e);const m=S("input",{name:a,className:"highcharts-range-selector"},void 0,t);m.setAttribute("type",-1!==(c=o.inputDateFormat||"%e %b %Y").indexOf("%L")?"text":(p=["a","A","d","e","w","b","B","m","o","y","Y"].some(t=>-1!==c.indexOf("%"+t)),u=["H","k","I","l","M","S"].some(t=>-1!==c.indexOf("%"+t)),p&&u?"datetime-local":p?"date":u?"time":"text")),n.styledMode||(g.css(w(i,o.labelStyle)),f.css(w({color:"#333333"},i,o.inputStyle)),k(m,C({position:"absolute",border:0,boxShadow:"0 0 15px rgba(0,0,0,0.3)",width:"1px",height:"1px",padding:0,textAlign:"center",fontSize:i.fontSize,fontFamily:i.fontFamily,top:"-9999em"},o.inputStyle))),m.onfocus=()=>{l.showInput(a)};let x=!(m.onblur=()=>{m===v.doc.activeElement&&d(),l.hideInput(a),l.setInputValue(a),m.blur()});return m.onchange=()=>{x||(d(),l.hideInput(a),m.blur())},m.onkeypress=t=>{13===t.keyCode&&d()},m.onkeydown=t=>{x=!0,38!==t.keyCode&&40!==t.keyCode||d()},m.onkeyup=()=>{x=!1},{dateBox:f,input:m,label:g}}getPosition(){var t=this.chart,e=t.options.rangeSelector,t="top"===e.verticalAlign?t.plotTop-t.axisOffset[0]:0;return{buttonTop:t+e.buttonPosition.y,inputTop:t+e.inputPosition.y-10}}getYTDExtremes(t,e,i){var s=this.chart.time,o=new s.Date(t),r=s.get("FullYear",o),i=i?s.Date.UTC(r,0,1):+new s.Date(r,0,1),r=Math.max(e,i),s=o.getTime();return{max:Math.min(t||s,s),min:r}}render(t,e){const i=this.chart,s=i.renderer,o=i.container,r=i.options,a=r.rangeSelector,n=O(r.chart.style&&r.chart.style.zIndex,0)+1,l=a.inputEnabled,h=this.rendered;if(!1!==a.enabled){if(h||(this.group=s.g("range-selector-group").attr({zIndex:7}).add(),this.div=S("div",void 0,{position:"relative",height:0,zIndex:n}),this.buttonOptions.length&&this.renderButtons(),o.parentNode&&o.parentNode.insertBefore(this.div,o),l&&(this.inputGroup=s.g("input-group").add(this.group),d=this.drawInput("min"),this.minDateBox=d.dateBox,this.minLabel=d.label,this.minInput=d.input,d=this.drawInput("max"),this.maxDateBox=d.dateBox,this.maxLabel=d.label,this.maxInput=d.input)),l){this.setInputValue("min",t),this.setInputValue("max",e);var d=i.scroller&&i.scroller.getUnionExtremes()||i.xAxis[0]||{};if(T(d.dataMin)&&T(d.dataMax)&&(t=i.xAxis[0].minRange||0,this.setInputExtremes("min",d.dataMin,Math.min(d.dataMax,this.getInputValue("max"))-t),this.setInputExtremes("max",Math.max(d.dataMin,this.getInputValue("min"))+t,d.dataMax)),this.inputGroup){let i=0;[this.minLabel,this.minDateBox,this.maxLabel,this.maxDateBox].forEach(t=>{var e;t&&(e=t.getBBox()["width"],e)&&(t.attr({x:i}),i+=e+a.inputSpacing)})}}this.alignElements(),this.rendered=!0}}renderButtons(){const{buttons:r,chart:t,options:e}=this;var i=y.lang;const a=t.renderer,n=w(e.buttonTheme),l=n&&n.states,h=n.width||28,d=(delete n.width,delete n.states,this.buttonGroup=a.g("range-selector-buttons").add(this.group),this.dropdown=S("select",void 0,{position:"absolute",width:"1px",height:"1px",padding:0,border:0,top:"-9999em",cursor:"pointer",opacity:1e-4},this.div));M(d,"touchstart",()=>{d.style.fontSize="16px"}),[[v.isMS?"mouseover":"mouseenter"],[v.isMS?"mouseout":"mouseleave"],["change","click"]].forEach(([e,i])=>{M(d,e,()=>{var t=r[this.currentButtonIndex()];t&&A(t.element,i||e)})}),this.zoomText=a.label(i&&i.rangeSelectorZoom||"",0).attr({padding:e.buttonTheme.padding,height:e.buttonTheme.height,paddingLeft:0,paddingRight:0}).add(this.buttonGroup),this.chart.styledMode||(this.zoomText.css(e.labelStyle),n["stroke-width"]=O(n["stroke-width"],0)),S("option",{textContent:this.zoomText.textStr,disabled:!0},void 0,d),this.buttonOptions.forEach((s,o)=>{S("option",{textContent:s.title||s.text},void 0,d),r[o]=a.button(s.text,0,0,t=>{var e=s.events&&s.events.click;let i;!1!==(i=e?e.call(s,t):i)&&this.clickButton(o),this.isActive=!0},n,l&&l.hover,l&&l.select,l&&l.disabled).attr({"text-align":"center",width:h}).add(this.buttonGroup),s.title&&r[o].attr("title",s.title)})}alignElements(){const{buttonGroup:o,buttons:r,chart:a,group:n,inputGroup:l,options:h,zoomText:d}=this;var c=a.options;const i=c.exporting&&!1!==c.exporting.enabled&&c.navigation&&c.navigation.buttonOptions,{buttonPosition:p,inputPosition:u,verticalAlign:g}=h;c=(t,e)=>i&&this.titleCollision(a)&&"top"===g&&"right"===e.align&&e.y-t.getBBox().height-12<(i.y||0)+(i.height||0)+a.spacing[0]?-40:0;let f=a.plotLeft;if(n&&p&&u){let t=p.x-a.spacing[3];if(o){if(this.positionButtons(),!this.initialButtonGroupWidth){let i=0;d&&(i+=d.getBBox().width+5),r.forEach((t,e)=>{i+=t.width||0,e!==r.length-1&&(i+=h.buttonSpacing)}),this.initialButtonGroupWidth=i}f-=a.spacing[3],this.updateButtonStates();var m=c(o,p);this.alignButtonGroup(m),n.placed=o.placed=a.hasLoaded}let e=0;l&&(e=c(l,u),"left"===u.align?t=f:"right"===u.align&&(t=-Math.max(a.axisOffset[1],-e)),l.align({y:u.y,width:l.getBBox().width,align:u.align,x:u.x+t-2},!0,a.spacingBox),l.placed=a.hasLoaded),this.handleCollision(e),n.align({verticalAlign:g},!0,a.spacingBox);m=n.alignAttr.translateY;let i=n.getBBox().height+20,s=0;"bottom"===g&&(c=(c=a.legend&&a.legend.options)&&"bottom"===c.verticalAlign&&c.enabled&&!c.floating?a.legend.legendHeight+O(c.margin,10):0,i=i+c-20,s=m-i-(h.floating?0:h.y)-(a.titleOffset?a.titleOffset[2]:0)-10),"top"===g?(h.floating&&(s=0),a.titleOffset&&a.titleOffset[0]&&(s=a.titleOffset[0]),s+=a.margin[0]-a.spacing[0]||0):"middle"===g&&(u.y===p.y?s=m:(u.y||p.y)&&(u.y<0||p.y<0?s-=Math.min(u.y,p.y):s=m-i)),n.translate(h.x,h.y+Math.floor(s));var{minInput:c,maxInput:m,dropdown:x}=this;h.inputEnabled&&c&&m&&(c.style.marginTop=n.translateY+"px",m.style.marginTop=n.translateY+"px"),x&&(x.style.marginTop=n.translateY+"px")}}alignButtonGroup(t,e){var{chart:i,options:s,buttonGroup:o}=this,s=s["buttonPosition"],r=i.plotLeft-i.spacing[3];let a=s.x-i.spacing[3];"right"===s.align?a+=t-r:"center"===s.align&&(a-=r/2),o&&o.align({y:s.y,width:O(e,this.initialButtonGroupWidth),align:s.align,x:a},!0,i.spacingBox)}positionButtons(){var{buttons:i,chart:t,options:s,zoomText:e}=this,o=t.hasLoaded?"animate":"attr",r=s["buttonPosition"],a=t.plotLeft;let n=a;e&&"hidden"!==e.visibility&&(e[o]({x:O(a+r.x,a)}),n+=r.x+e.getBBox().width+5);for(let t=0,e=this.buttonOptions.length;t<e;++t)"hidden"!==i[t].visibility?(i[t][o]({x:n}),n+=(i[t].width||0)+s.buttonSpacing):i[t][o]({x:a})}handleCollision(o){const{chart:t,buttonGroup:r,inputGroup:a}=this,{buttonPosition:n,dropdown:e,inputPosition:l}=this.options;var i=()=>{let e=0;return this.buttons.forEach(t=>{t=t.getBBox();t.width>e&&(e=t.width)}),e},s=t=>{var e,i,s;return!(!a||!r)&&(e=a.alignAttr.translateX+a.alignOptions.x-o+a.getBBox().x+2,i=a.alignOptions.width,e<(s=r.alignAttr.translateX+r.getBBox().x)+t)&&s<e+i&&n.y<l.y+a.getBBox().height},h=()=>{a&&r&&a.attr({translateX:a.alignAttr.translateX+(t.axisOffset[1]>=-o?0:-o),translateY:a.alignAttr.translateY+r.getBBox().height+10})};if(r){if("always"===e)return this.collapseButtons(o),void(s(i())&&h());"never"===e&&this.expandButtons()}a&&r?l.align===n.align||s(this.initialButtonGroupWidth+20)?"responsive"===e&&(this.collapseButtons(o),!s(i()))||h():"responsive"===e&&this.expandButtons():r&&"responsive"===e&&(this.initialButtonGroupWidth>t.plotWidth?this.collapseButtons(o):this.expandButtons())}collapseButtons(t){const{buttons:s,buttonOptions:e,chart:o,dropdown:r,options:a,zoomText:n}=this;if(!0!==this.isCollapsed){this.isCollapsed=!0;const h=o.userOptions.rangeSelector&&o.userOptions.rangeSelector.buttonTheme||{},d=t=>({text:t?t+" ▾":"▾",width:"auto",paddingLeft:O(a.buttonTheme.paddingLeft,h.padding,8),paddingRight:O(a.buttonTheme.paddingRight,h.padding,8)});n&&n.hide();let i=!1;e.forEach((t,e)=>{e=s[e];2!==e.state?e.hide():(e.show(),e.attr(d(t.text)),i=!0)}),i||(r&&(r.selectedIndex=0),s[0].show(),s[0].attr(d(this.zoomText&&this.zoomText.textStr)));var l=a.buttonPosition["align"];this.positionButtons(),"right"!==l&&"center"!==l||this.alignButtonGroup(t,s[this.currentButtonIndex()].getBBox().width),this.showDropdown()}}expandButtons(){const{buttons:i,buttonOptions:t,options:s,zoomText:e}=this;this.hideDropdown(),!1!==this.isCollapsed&&(this.isCollapsed=!1,e&&e.show(),t.forEach((t,e)=>{e=i[e];e.show(),e.attr({text:t.text,width:s.buttonTheme.width||28,paddingLeft:O(s.buttonTheme.paddingLeft,"unset"),paddingRight:O(s.buttonTheme.paddingRight,"unset")}),e.state<2&&e.setState(0)}),this.positionButtons())}currentButtonIndex(){var t=this["dropdown"];return t&&0<t.selectedIndex?t.selectedIndex-1:0}showDropdown(){var t,{buttonGroup:e,buttons:i,chart:s,dropdown:o}=this;e&&o&&({translateX:e=0,translateY:t=0}=e,i=i[this.currentButtonIndex()].getBBox(),k(o,{left:s.plotLeft+e+"px",top:t+.5+"px",width:i.width+"px",height:i.height+"px"}),this.hasVisibleDropdown=!0)}hideDropdown(){var t=this["dropdown"];t&&(k(t,{top:"-9999em",width:"1px",height:"1px"}),this.hasVisibleDropdown=!1)}getHeight(){var t=this.options,e=this.group,i=t.inputPosition,s=t.buttonPosition,o=t.y,s=s.y,i=i.y;let r=0;if(t.height)return t.height;this.alignElements(),r=e?e.getBBox(!0).height+13+o:0;t=Math.min(i,s);return(i<0&&s<0||0<i&&0<s)&&(r+=Math.abs(t)),r}titleCollision(t){return!(t.options.title.text||t.options.subtitle.text)}update(t){var e=this.chart;w(!0,e.options.rangeSelector,t),this.destroy(),this.init(e),this.render()}destroy(){const i=this,t=i.minInput,e=i.maxInput;i.eventsToUnbind&&(i.eventsToUnbind.forEach(t=>t()),i.eventsToUnbind=void 0),o(i.buttons),t&&(t.onfocus=t.onblur=t.onchange=null),e&&(e.onfocus=e.onblur=e.onchange=null),a(i,function(t,e){t&&"chart"!==e&&(t instanceof s?t.destroy():t instanceof d.HTMLElement&&r(t)),t!==h.prototype[e]&&(i[e]=null)},this)}}return C(h.prototype,{defaultButtons:[{type:"month",count:1,text:"1m",title:"View 1 month"},{type:"month",count:3,text:"3m",title:"View 3 months"},{type:"month",count:6,text:"6m",title:"View 6 months"},{type:"ytd",text:"YTD",title:"View year to date"},{type:"year",count:1,text:"1y",title:"View 1 year"},{type:"all",text:"All",title:"View all"}],inputTypeFormats:{"datetime-local":"%Y-%m-%dT%H:%M:%S",date:"%Y-%m-%d",time:"%H:%M:%S"}}),h}),e(t,"Core/Axis/OrdinalAxis.js",[t["Core/Axis/Axis.js"],t["Core/Globals.js"],t["Core/Series/Series.js"],t["Core/Utilities.js"]],function(t,c,p,e){const o=c["composed"],{addEvent:r,correctFloat:a,css:x,defined:S,error:k,pick:y,pushUnique:n,timeUnits:C}=e;var i;{var s=i=i||{};function l(t,e,a,i,s=[],o=0,n){var l={},h=this.options.tickPixelInterval,r=this.chart.time,d=[];let c,p,u,g,f,m=0,x=[],v=-Number.MAX_VALUE;if(!this.options.ordinal&&!this.options.breaks||!s||s.length<3||void 0===e)return r.getTimeTicks.apply(r,arguments);var y=s.length;for(c=0;c<y;c++){if(f=c&&s[c-1]>a,s[c]<e&&(m=c),c===y-1||s[c+1]-s[c]>5*o||f){if(s[c]>v){for(p=r.getTimeTicks(t,s[m],s[c],i);p.length&&p[0]<=v;)p.shift();p.length&&(v=p[p.length-1]),d.push(x.length),x=x.concat(p)}m=c+1}if(f)break}if(p){if(g=p.info,n&&g.unitRange<=C.hour){for(c=x.length-1,m=1;m<c;m++)r.dateFormat("%d",x[m])!==r.dateFormat("%d",x[m-1])&&(l[x[m]]="day",u=!0);u&&(l[x[0]]="day"),g.higherRanks=l}g.segmentStarts=d,x.info=g}else k(12,!1,this.chart);if(n&&S(h)){var n=x.length,b=[],M=[];let t,e,i,s,o,r=n;for(;r--;)e=this.translate(x[r]),i&&(M[r]=i-e),b[r]=i=e;for(M.sort(),(s=M[Math.floor(M.length/2)])<.6*h&&(s=null),r=x[n-1]>a?n-1:n,i=void 0;r--;)e=b[r],o=Math.abs(i-e),i&&o<.8*h&&(null===s||o<.8*s)?(l[x[r]]&&!l[x[r+1]]?(t=r+1,i=e):t=r,x.splice(t,1)):i=e}return x}function h(t){var e=this.ordinal.positions;if(!e)return t;let i=e.length-1,s;return t<0?t=e[0]:t>i?t=e[i]:(i=Math.floor(t),s=t-i),void 0!==s&&"undefined"!=typeof e[i]?e[i]+(s?s*(e[i+1]-e[i]):0):t}function d(t){var e=this.ordinal,i=(this.old||this).min,s=(this.old||this).transA,o=e.getExtendedPositions();if(o.length){i=a((t-i)*s+this.minPixelPadding),s=a(e.getIndexOfPoint(i,o)),i=a(s%1);if(0<=s&&s<=o.length-1)return e=o[Math.floor(s)],e=o[Math.ceil(s)]-e,o[Math.floor(s)]+i*e}return t}function u(t,e){var i=s.Additions.findIndexOf(t,e,!0);return t[i]===e?i:i+(e-t[i])/(t[i+1]-t[i])}function g(){this.ordinal||(this.ordinal=new s.Additions(this))}function f(){var t=this;t.isXAxis&&S(t.options.overscroll)&&t.max===t.dataMax&&(!t.chart.mouseIsDown||t.isInternal)&&(!t.eventArgs||t.eventArgs&&"navigator"!==t.eventArgs.trigger)&&(t.max+=t.options.overscroll,!t.isInternal)&&S(t.userMin)&&(t.min+=t.options.overscroll)}function m(){this.horiz&&!this.isDirty&&(this.isDirty=this.isOrdinal&&this.chart.navigator&&!this.chart.navigator.adaptToUpdatedData)}function v(){this.ordinal&&(this.ordinal.beforeSetTickPositions(),this.tickInterval=this.ordinal.postProcessTickInterval(this.tickInterval))}function b(t){var o=this.xAxis[0],r=o.options.overscroll,a=t.originalEvent.chartX,e=this.options.chart.panning;let n=!1;if(e&&"y"!==e.type&&o.options.ordinal&&o.series.length){var l=this.mouseDownX,h=o.getExtremes(),d=h.dataMax,c=h.min,p=h.max,u=this.hoverPoints,g=o.closestPointRange||o.ordinal&&o.ordinal.overscrollPointsRange,g=o.translationSlope*(o.ordinal.slope||g),l=Math.round((l-a)/g),g=o.ordinal.getExtendedPositions(),g={ordinal:{positions:g,extendedOrdinalPositions:g}},f=o.index2val,m=o.val2lin;let t,e,i,s;g.ordinal.positions?1<Math.abs(l)&&(u&&u.forEach(function(t){t.setState()}),s=l<0?(i=g,o.ordinal.positions?o:g):(i=o.ordinal.positions?o:g,g),d>(e=s.ordinal.positions)[e.length-1]&&e.push(d),this.fixedRange=p-c,(t=o.navigatorAxis.toFixedRange(void 0,void 0,f.apply(i,[m.apply(i,[c,!0])+l]),f.apply(s,[m.apply(s,[p,!0])+l]))).min>=Math.min(h.dataMin,c)&&t.max<=Math.max(d,p)+r&&o.setExtremes(t.min,t.max,!0,!1,{trigger:"pan"}),this.mouseDownX=a,x(this.container,{cursor:"move"})):n=!0}else n=!0;n||e&&/y/.test(e.type)?r&&(o.max=o.dataMax+r):t.preventDefault()}function M(){var t=this.xAxis;t&&t.options.ordinal&&delete t.ordinal.index}function A(t,e){var i=this.ordinal,s=i.positions;let o=i.slope,r;if(!s)return t;var a=s.length;let n;if(s[0]<=t&&s[a-1]>=t)n=u(s,t);else{if(!(r=i.getExtendedPositions&&i.getExtendedPositions())||!r.length)return t;a=r.length,s=(o=o||(r[a-1]-r[0])/a,u(r,s[0]));if(t>=r[0]&&t<=r[a-1])n=u(r,t)-s;else{if(!e)return t;n=t<r[0]?-s-(r[0]-t)/o:(t-r[a-1])/o+a-s}}return e?n:o*(n||0)+i.offset}s.compose=function w(t,e,i){var s;return n(o,w)&&((s=t.prototype).getTimeTicks=l,s.index2val=h,s.lin2val=d,s.val2lin=A,s.ordinal2lin=s.val2lin,r(t,"afterInit",g),r(t,"foundExtremes",f),r(t,"afterSetScale",m),r(t,"initialAxisTranslation",v),r(i,"pan",b),r(e,"updatedData",M)),t};class T{constructor(t){this.index={},this.axis=t}beforeSetTickPositions(){const t=this.axis,e=t.ordinal,i=t.getExtremes(),s=i.min,o=i.max,r=t.brokenAxis?.hasBreaks,a=t.options.ordinal;let n,l,h,d,c,p,u,g=[],f=Number.MAX_VALUE,m=!1,x=!1,v=!1;if(a||r){let i=0;if(t.series.forEach(function(t,e){if(l=[],0<e&&"highcharts-navigator-series"!==t.options.id&&1<t.processedXData.length&&(x=i!==t.processedXData[1]-t.processedXData[0]),i=t.processedXData[1]-t.processedXData[0],t.boosted&&(v=t.boosted),t.reserveSpace()&&(!1!==t.takeOrdinalPosition||r)&&(g=g.concat(t.processedXData),n=g.length,g.sort(function(t,e){return t-e}),f=Math.min(f,y(t.closestPointRange,f)),n)){for(e=0;e<n-1;)g[e]!==g[e+1]&&l.push(g[e+1]),e++;l[0]!==g[0]&&l.unshift(g[0]),g=l}}),x&&v&&(g.pop(),g.shift()),2<(n=g.length)){for(h=g[1]-g[0],u=n-1;u--&&!m;)g[u+1]-g[u]!=h&&(m=!0);!t.options.keepOrdinalPadding&&(g[0]-s>h||o-g[g.length-1]>h)&&(m=!0)}else t.options.overscroll&&(2===n?f=g[1]-g[0]:1===n?(f=t.options.overscroll,g=[g[0],g[0]+f]):f=e.overscrollPointsRange);m||t.forceOrdinal?(t.options.overscroll&&(e.overscrollPointsRange=f,g=g.concat(e.getOverscrollPositions())),e.positions=g,d=t.ordinal2lin(Math.max(s,g[0]),!0),c=Math.max(t.ordinal2lin(Math.min(o,g[g.length-1]),!0),1),e.slope=p=(o-s)/(c-d),e.offset=s-d*p):(e.overscrollPointsRange=y(t.closestPointRange,e.overscrollPointsRange),e.positions=t.ordinal.slope=e.offset=void 0)}t.isOrdinal=a&&m,e.groupIntervalFactor=null}static findIndexOf(t,e,i){let s=0,o=t.length-1,r;for(;s<o;)t[r=Math.ceil((s+o)/2)]<=e?s=r:o=r-1;return t[s]===e||i?s:-1}getExtendedPositions(){const e=this,t=e.axis,i=t.constructor.prototype,s=t.chart,o=t.series[0].currentDataGrouping,r=o?o.count+o.unitName:"raw",a=t.options.overscroll,n=t.getExtremes();let l,h=void 0,d=e.index;return(d=d||(e.index={}))[r]||((l={series:[],chart:s,forceOrdinal:!1,getExtremes:function(){return{min:n.dataMin,max:n.dataMax+a}},applyGrouping:i.applyGrouping,getGroupPixelWidth:i.getGroupPixelWidth,getTimeTicks:i.getTimeTicks,options:{ordinal:!0},ordinal:{getGroupIntervalFactor:this.getGroupIntervalFactor},ordinal2lin:i.ordinal2lin,getIndexOfPoint:i.getIndexOfPoint,val2lin:i.val2lin}).ordinal.axis=l,t.series.forEach(function(t){(h={xAxis:l,xData:t.xData.slice(),chart:s,groupPixelWidth:t.groupPixelWidth,destroyGroupedData:c.noop,getProcessedData:p.prototype.getProcessedData,applyGrouping:p.prototype.applyGrouping,reserveSpace:p.prototype.reserveSpace,visible:t.visible}).xData=h.xData.concat(e.getOverscrollPositions()),h.options={dataGrouping:o?{firstAnchor:"firstPoint",anchor:"middle",lastAnchor:"lastPoint",enabled:!0,forced:!0,approximation:"open",units:[[o.unitName,[o.count]]]}:{enabled:!1}},l.series.push(h),t.processData.apply(h)}),l.applyGrouping({hasExtremesChanged:!0}),h.closestPointRange!==h.basePointRange&&h.currentDataGrouping&&(l.forceOrdinal=!0),t.ordinal.beforeSetTickPositions.apply({axis:l}),d[r]=l.ordinal.positions),d[r]}getGroupIntervalFactor(t,e,i){this.axis;var s=i.processedXData,o=s.length,r=[];let a,n,l=this.groupIntervalFactor;if(!l){for(n=0;n<o-1;n++)r[n]=s[n+1]-s[n];r.sort(function(t,e){return t-e}),a=r[Math.floor(o/2)],t=Math.max(t,s[0]),e=Math.min(e,s[o-1]),this.groupIntervalFactor=l=o*a/(e-t)}return l}getIndexOfPoint(t,e){const s=this.axis;let i=0;let o;s.series.forEach(t=>{var e=t.points?.[0];S(e?.plotX)&&(e.plotX<o||!S(o))&&function(t){const{min:e,max:i}=s;return!(!S(e)||!S(i))&&t.points.some(t=>t.x>=e&&t.x<=i)}(t)&&(o=e.plotX,i=e.x)}),o=o??s.minPixelPadding;var r=s.translationSlope*(this.slope||s.closestPointRange||this.overscrollPointsRange),t=a((t-o)/r);return T.findIndexOf(e,i,!0)+t}getOverscrollPositions(){var t=this.axis,e=t.options.overscroll,i=this.overscrollPointsRange,s=[];let o=t.dataMax;if(S(i))for(;o<=t.dataMax+e;)o+=i,s.push(o);return s}postProcessTickInterval(t){var e=this.axis,i=this.slope;let s;return s=i?e.options.breaks?e.closestPointRange||t:t/(i/e.closestPointRange):t}}s.Additions=T}return i}),e(t,"Series/HLC/HLCPoint.js",[t["Core/Series/SeriesRegistry.js"]],function(t){var{pointClass:t}=t.seriesTypes["column"]["prototype"];class e extends t{}return e}),e(t,"Series/HLC/HLCSeriesDefaults.js",[],function(){return{lineWidth:1,tooltip:{pointFormat:'<span style="color:{point.color}">●</span> <b> {series.name}</b><br/>High: {point.high}<br/>Low: {point.low}<br/>Close: {point.close}<br/>'},threshold:null,states:{hover:{lineWidth:3}},stickyTracking:!0}}),e(t,"Series/HLC/HLCSeries.js",[t["Series/HLC/HLCPoint.js"],t["Series/HLC/HLCSeriesDefaults.js"],t["Core/Series/SeriesRegistry.js"],t["Core/Utilities.js"]],function(t,e,i,s){var o=i.seriesTypes["column"],{extend:s,merge:r}=s;class a extends o{extendStem(t,e,i){var s=t[0],t=t[1];"number"==typeof s[2]&&(s[2]=Math.max(i+e,s[2])),"number"==typeof t[2]&&(t[2]=Math.min(i-e,t[2]))}getPointPath(t,e){var e=e.strokeWidth(),i=t.series,s=e%2/2,o=Math.round(t.plotX)-s,r=Math.round(t.shapeArgs.width/2),a=(t.plotClose,[["M",o,Math.round(t.yBottom)],["L",o,Math.round(t.plotHigh)]]);return null!==t.close&&(t=Math.round(t.plotClose)+s,a.push(["M",o,t],["L",o+r,t]),i.extendStem(a,e/2,t)),a}drawSinglePoint(t){var e=t.series,i=e.chart;let s,o=t.graphic;"undefined"!=typeof t.plotY&&(o||(t.graphic=o=i.renderer.path().add(e.group)),i.styledMode||o.attr(e.pointAttribs(t,t.selected&&"select")),s=e.getPointPath(t,o),o[o?"animate":"attr"]({d:s}).addClass(t.getClassName(),!0))}drawPoints(){this.points.forEach(this.drawSinglePoint)}init(){super.init.apply(this,arguments),this.options.stacking=void 0}pointAttribs(t,e){t=super.pointAttribs.call(this,t,e);return delete t.fill,t}toYData(t){return[t.high,t.low,t.close]}translate(){const o=this,r=o.yAxis,t=this.pointArrayMap&&this.pointArrayMap.slice()||[],a=t.map(t=>"plot"+(t.charAt(0).toUpperCase()+t.slice(1)));a.push("yBottom"),t.push("low"),super.translate.apply(o),o.points.forEach(function(s){t.forEach(function(t,e){let i=s[t];null!==i&&(o.dataModify&&(i=o.dataModify.modifyValue(i)),s[a[e]]=r.toPixels(i,!0))}),s.tooltipPos[1]=s.plotHigh+r.pos-o.chart.plotTop})}}return a.defaultOptions=r(o.defaultOptions,e),s(a.prototype,{pointClass:t,animate:null,directTouch:!1,pointArrayMap:["high","low","close"],pointAttrToOptions:{stroke:"color","stroke-width":"lineWidth"},pointValKey:"close"}),i.registerSeriesType("hlc",a),a}),e(t,"Series/OHLC/OHLCPoint.js",[t["Core/Series/SeriesRegistry.js"]],function(t){var t=t["seriesTypes"]["hlc"];class e extends t.prototype.pointClass{getClassName(){return super.getClassName.call(this)+(this.open<this.close?" highcharts-point-up":" highcharts-point-down")}resolveUpColor(){this.open<this.close&&!this.options.color&&this.series.options.upColor&&(this.color=this.series.options.upColor)}resolveColor(){super.resolveColor(),this.series.is("heikinashi")||this.resolveUpColor()}getZone(){var t=super.getZone();return this.resolveUpColor(),t}applyOptions(){return super.applyOptions.apply(this,arguments),this.resolveColor&&this.resolveColor(),this}}return e}),e(t,"Series/OHLC/OHLCSeriesDefaults.js",[],function(){return{tooltip:{pointFormat:'<span style="color:{point.color}">●</span> <b> {series.name}</b><br/>Open: {point.open}<br/>High: {point.high}<br/>Low: {point.low}<br/>Close: {point.close}<br/>'}}}),e(t,"Series/OHLC/OHLCSeries.js",[t["Core/Globals.js"],t["Series/OHLC/OHLCPoint.js"],t["Series/OHLC/OHLCSeriesDefaults.js"],t["Core/Series/SeriesRegistry.js"],t["Core/Utilities.js"]],function(t,e,i,s,o){const r=t["composed"];t=s.seriesTypes.hlc;const{addEvent:a,extend:n,merge:l,pushUnique:h}=o;function d(t){var t=t.options,e=t.dataGrouping;e&&t.useOhlcData&&"highcharts-navigator-series"!==t.id&&(e.approximation="ohlc")}function c(t){t=t.options;t.useOhlcData&&"highcharts-navigator-series"!==t.id&&n(this,{pointValKey:p.prototype.pointValKey,pointArrayMap:p.prototype.pointArrayMap,toYData:p.prototype.toYData})}class p extends t{static compose(t){h(r,this.compose)&&(a(t,"afterSetOptions",d),a(t,"init",c))}getPointPath(t,e){var i=super.getPointPath(t,e),e=e.strokeWidth(),s=e%2/2,o=Math.round(t.plotX)-s,r=Math.round(t.shapeArgs.width/2);t.plotOpen;return null!==t.open&&(t=Math.round(t.plotOpen)+s,i.push(["M",o,t],["L",o-r,t]),super.extendStem(i,e/2,t)),i}pointAttribs(t,e){var e=super.pointAttribs.call(this,t,e),i=this.options;return delete e.fill,!t.options.color&&i.upColor&&t.open<t.close&&(e.stroke=i.upColor),e}toYData(t){return[t.open,t.high,t.low,t.close]}}return p.defaultOptions=l(t.defaultOptions,i),n(p.prototype,{pointClass:e,pointArrayMap:["open","high","low","close"]}),s.registerSeriesType("ohlc",p),p}),e(t,"Series/Candlestick/CandlestickSeriesDefaults.js",[t["Core/Defaults.js"],t["Core/Utilities.js"]],function(t,e){var{}=t,{}=e;return{states:{hover:{lineWidth:2}},threshold:null,lineColor:"#000000",lineWidth:1,upColor:"#ffffff",stickyTracking:!0}}),e(t,"Series/Candlestick/CandlestickSeries.js",[t["Series/Candlestick/CandlestickSeriesDefaults.js"],t["Core/Defaults.js"],t["Core/Series/SeriesRegistry.js"],t["Core/Utilities.js"]],function(t,e,i,s){e=e.defaultOptions;const{column:n,ohlc:o}=i.seriesTypes;s=s.merge;class r extends o{pointAttribs(t,e){var i=n.prototype.pointAttribs.call(this,t,e),s=this.options,o=t.open<t.close,r=s.lineColor||this.color,a=t.color||this.color;return i["stroke-width"]=s.lineWidth,i.fill=t.options.color||o&&s.upColor||a,i.stroke=t.options.lineColor||o&&s.upLineColor||r,e&&(a=s.states[e],i.fill=a.color||i.fill,i.stroke=a.lineColor||i.stroke,i["stroke-width"]=a.lineWidth||i["stroke-width"]),i}drawPoints(){var t=this.points,c=this.chart,p=this.yAxis.reversed;for(const g of t){let t=g.graphic,e,i,s,o,r,a,n,l,h,d;var u=!t;"undefined"!=typeof g.plotY&&(t||(g.graphic=t=c.renderer.path().add(this.group)),this.chart.styledMode||t.attr(this.pointAttribs(g,g.selected&&"select")).shadow(this.options.shadow),n=t.strokeWidth()%2/2,l=Math.round(g.plotX)-n,e=g.plotOpen,i=g.plotClose,s=Math.min(e,i),o=Math.max(e,i),d=Math.round(g.shapeArgs.width/2),r=p?o!==g.yBottom:Math.round(s)!==Math.round(g.plotHigh),a=p?Math.round(s)!==Math.round(g.plotHigh):o!==g.yBottom,s=Math.round(s)+n,o=Math.round(o)+n,(h=[]).push(["M",l-d,o],["L",l-d,s],["L",l+d,s],["L",l+d,o],["Z"],["M",l,s],["L",l,r?Math.round(p?g.yBottom:g.plotHigh):s],["M",l,o],["L",l,a?Math.round(p?g.plotHigh:g.yBottom):o]),t[u?"attr":"animate"]({d:h}).addClass(g.getClassName(),!0))}}}return r.defaultOptions=s(o.defaultOptions,e.plotOptions,{tooltip:o.defaultOptions.tooltip},t),i.registerSeriesType("candlestick",r),r}),e(t,"Series/Flags/FlagsPoint.js",[t["Core/Series/SeriesRegistry.js"],t["Core/Utilities.js"]],function(t,e){var{pointClass:t}=t.seriesTypes["column"]["prototype"];const i=e["isNumber"];class s extends t{constructor(){super(...arguments),this.ttBelow=!1}isValid(){return i(this.y)||"undefined"==typeof this.y}hasNewShapeType(){var t=this.options.shape||this.series.options.shape;return this.graphic&&t&&t!==this.graphic.symbolKey}}return s}),e(t,"Series/Flags/FlagsSeriesDefaults.js",[],function(){return{pointRange:0,allowOverlapX:!1,shape:"flag",stackDistance:12,textAlign:"center",tooltip:{pointFormat:"{point.text}"},threshold:null,y:-30,fillColor:"#ffffff",lineWidth:1,states:{hover:{lineColor:"#000000",fillColor:"#ccd3ff"}},style:{fontSize:"0.7em",fontWeight:"bold"}}}),e(t,"Series/Flags/FlagsSymbols.js",[t["Core/Renderer/RendererRegistry.js"]],function(e){var t;{var i=t=t||{};const r=[];function s(t,e,i,s,o){var r=o&&o.anchorX||t,o=o&&o.anchorY||e,a=this.circle(r-1,o-1,2,2);return a.push(["M",r,o],["L",t,e+s],["L",t,e],["L",t+i,e],["L",t+i,e+s],["L",t,e+s],["Z"]),a}function o(l,h){l[h+"pin"]=function(e,i,s,o,r){var a=r&&r.anchorX,r=r&&r.anchorY;let n;if("circle"===h&&s<o&&(e-=Math.round((o-s)/2),s=o),n=l[h](e,i,s,o),a&&r){let t=a;"circle"===h?t=e+s/2:(e=n[0],s=n[1],"M"===e[0]&&"L"===s[0]&&(t=(e[1]+s[1])/2));e=r<i?i:i+o;n.push(["M",t,e],["L",a,r]),n=n.concat(l.circle(a-1,r-1,2,2))}return n}}t.compose=function(t){-1===r.indexOf(t)&&(r.push(t),(t=t.prototype.symbols).flag=s,o(t,"circle"),o(t,"square")),t=e.getRendererType(),r.indexOf(t)&&r.push(t)}}return t}),e(t,"Series/OnSeriesComposition.js",[t["Series/Column/ColumnSeries.js"],t["Core/Globals.js"],t["Core/Series/Series.js"],t["Core/Utilities.js"]],function(t,e,i,s){const o=e["composed"],O=t["prototype"],r=i["prototype"],{defined:L,pushUnique:a,stableSort:E}=s;var n;function l(t){return r.getPlotBox.call(this.options.onSeries&&this.chart.get(this.options.onSeries)||this,t)}function h(){O.translate.apply(this);const s=this,t=s.options,e=s.chart,o=s.points,i=t.onSeries,r=i&&e.get(i),a=r&&r.options.step,n=r&&r.points,l=e.inverted,h=s.xAxis,d=s.yAxis;let c=o.length-1,p,u,g=t.onKey||"y",f=n&&n.length,m=0,x,v,y,b,M;if(r&&r.visible&&f)for(m=(r.pointXOffset||0)+(r.barW||0)/2,b=r.currentDataGrouping,v=n[f-1].x+(b?b.totalRange:0),E(o,(t,e)=>t.x-e.x),g="plot"+g[0].toUpperCase()+g.substr(1);f--&&o[c];)if(x=n[f],(p=o[c]).y=x.y,x.x<=p.x&&"undefined"!=typeof x[g]){if(p.x<=v&&(p.plotY=x[g],x.x<p.x)&&!a&&(y=n[f+1])&&"undefined"!=typeof y[g])if(L(p.plotX)&&r.is("spline")){const C=[x.plotX||0,x.plotY||0],A=[y.plotX||0,y.plotY||0],w=x.controlPoints?.high||C,T=y.controlPoints?.low||A,P=(t,e)=>Math.pow(1-t,3)*C[e]+3*(1-t)*(1-t)*t*w[e]+3*(1-t)*t*t*T[e]+t*t*t*A[e];let e=0,i=1,s;for(let t=0;t<100;t++){var S=(e+i)/2,k=P(S,0);if(null===k)break;if(Math.abs(k-p.plotX)<.25){s=S;break}k<p.plotX?e=S:i=S}L(s)&&(p.plotY=P(s,1),p.y=d.toValue(p.plotY,!0))}else M=(p.x-x.x)/(y.x-x.x),p.plotY+=M*(y[g]-x[g]),p.y+=M*(y.y-x.y);if(c--,f++,c<0)break}o.forEach((t,e)=>{let i;t.plotX+=m,"undefined"!=typeof t.plotY&&!l||(0<=t.plotX&&t.plotX<=h.len?l?(t.plotY=h.translate(t.x,0,1,0,1),t.plotX=L(t.y)?d.translate(t.y,0,0,0,1):0):t.plotY=(h.opposite?0:s.yAxis.len)+h.offset:t.shapeArgs={}),(u=o[e-1])&&u.plotX===t.plotX&&("undefined"==typeof u.stackIndex&&(u.stackIndex=0),i=u.stackIndex+1),t.stackIndex=i}),this.onSeries=r}return(e=n=n||{}).compose=function d(t){var e;return a(o,d)&&((e=t.prototype).getPlotBox=l,e.translate=h),t},e.getPlotBox=l,e.translate=h,n}),e(t,"Series/Flags/FlagsSeries.js",[t["Series/Flags/FlagsPoint.js"],t["Series/Flags/FlagsSeriesDefaults.js"],t["Series/Flags/FlagsSymbols.js"],t["Core/Globals.js"],t["Series/OnSeriesComposition.js"],t["Core/Renderer/RendererUtilities.js"],t["Core/Series/SeriesRegistry.js"],t["Core/Renderer/SVG/SVGElement.js"],t["Core/Utilities.js"]],function(t,e,i,s,o,r,a,M,n){s=s.noop;const S=r["distribute"],{series:l,seriesTypes:{column:h}}=a,{addEvent:d,defined:k,extend:c,merge:C,objectEach:A,wrap:w}=n;class p extends h{animate(t){t&&this.setClip()}drawPoints(){const t=this.points,e=this.chart,i=e.renderer,s=e.inverted,o=this.options,r=o.y,a=this.yAxis,n={},l=[];let h,d,c,p,u,g,f,m,x,v,y;for(p=t.length;p--;)u=t[p],v=(s?u.plotY:u.plotX)>this.xAxis.len,h=u.plotX,f=u.stackIndex,c=u.options.shape||o.shape,void 0!==(d=u.plotY)&&(d=u.plotY+r-(void 0!==f&&f*o.stackDistance)),u.anchorX=f?void 0:u.plotX,m=f?void 0:u.plotY,y="flag"!==c,g=u.graphic,void 0!==d&&0<=h&&!v?((g=g&&u.hasNewShapeType()?g.destroy():g)||(g=u.graphic=i.label("",null,null,c,null,null,o.useHTML).addClass("highcharts-point").add(this.markerGroup),u.graphic.div&&(u.graphic.div.point=u),g.isNew=!0),g.attr({align:y?"center":"left",width:o.width,height:o.height,"text-align":o.textAlign}),e.styledMode||g.attr(this.pointAttribs(u)).css(C(o.style,u.style)).shadow(o.shadow),0<h&&(h-=g.strokeWidth()%2),x={y:d,anchorY:m},o.allowOverlapX&&(x.x=h,x.anchorX=u.anchorX),g.attr({text:u.options.title||o.title||"A"})[g.isNew?"attr":"animate"](x),o.allowOverlapX||(n[u.plotX]?n[u.plotX].size=Math.max(n[u.plotX].size,g.width||0):n[u.plotX]={align:y?.5:0,size:g.width||0,target:h,anchorX:h}),u.tooltipPos=[h,d+a.pos-e.plotTop]):g&&(u.graphic=g.destroy());if(!o.allowOverlapX){let e=100;A(n,function(t){t.plotX=t.anchorX,l.push(t),e=Math.max(t.size,e)}),S(l,(s?a:this.xAxis).len,e);for(const u of t){const h=u.plotX,g=u.graphic,b=g&&n[h];b&&g&&(k(b.pos)?g[g.isNew?"attr":"animate"]({x:b.pos+(b.align||0)*b.size,anchorX:u.anchorX}).show().isNew=!1:g.hide().isNew=!0)}}o.useHTML&&this.markerGroup&&w(this.markerGroup,"on",function(t){return M.prototype.on.apply(t.apply(this,[].slice.call(arguments,1)),[].slice.call(arguments,1))})}drawTracker(){const e=this.points;super.drawTracker();for(const i of e){const s=i.graphic;s&&(i.unbindMouseOver&&i.unbindMouseOver(),i.unbindMouseOver=d(s.element,"mouseover",function(){0<i.stackIndex&&!i.raised&&(i._y=s.y,s.attr({y:i._y-8}),i.raised=!0);for(const t of e)t!==i&&t.raised&&t.graphic&&(t.graphic.attr({y:t._y}),t.raised=!1)}))}}pointAttribs(t,e){var i=this.options,s=t&&t.color||this.color;let o=i.lineColor,r=t&&t.lineWidth,a=t&&t.fillColor||i.fillColor;return e&&(a=i.states[e].fillColor,o=i.states[e].lineColor,r=i.states[e].lineWidth),{fill:a||s,stroke:o||s,"stroke-width":r||i.lineWidth||0}}setClip(){l.prototype.setClip.apply(this,arguments),!1!==this.options.clip&&this.sharedClipKey&&this.markerGroup&&this.markerGroup.clip(this.chart.sharedClips[this.sharedClipKey])}}return p.compose=i.compose,p.defaultOptions=C(h.defaultOptions,e),o.compose(p),c(p.prototype,{allowDG:!1,forceCrop:!0,invertible:!1,noSharedTooltip:!0,pointClass:t,sorted:!1,takeOrdinalPosition:!1,trackerGroups:["markerGroup"],buildKDTree:s,init:l.prototype.init}),a.registerSeriesType("flags",p),p}),e(t,"Core/Chart/StockChart.js",[t["Core/Chart/Chart.js"],t["Core/Templating.js"],t["Core/Defaults.js"],t["Core/Globals.js"],t["Stock/Navigator/NavigatorDefaults.js"],t["Stock/RangeSelector/RangeSelectorDefaults.js"],t["Stock/Scrollbar/ScrollbarDefaults.js"],t["Core/Utilities.js"]],function(t,e,i,s,n,l,h,o){const k=e["format"],d=i["getOptions"],r=s["composed"],{addEvent:a,clamp:C,defined:A,extend:w,find:T,isNumber:P,isString:O,merge:c,pick:L,pushUnique:p,splat:u}=o;function g(t,e,i){return"xAxis"===t?{minPadding:0,maxPadding:0,overscroll:0,ordinal:!0}:"yAxis"===t?{labels:{y:-2},opposite:i.opposite??e.opposite??!0,showLastLabel:!(!e.categories&&"category"!==e.type),title:{text:"Values"!==i.title?.text?i.title?.text:null}}:{}}function f(t,e){return"xAxis"===t?(t={type:"datetime",categories:void 0},L(e.navigator&&e.navigator.enabled,n.enabled,!0)&&(t.startOnTick=!1,t.endOnTick=!1),t):{}}class m extends t{init(i,t){const s=d(),e=i.xAxis,o=i.yAxis,r=L(i.navigator&&i.navigator.enabled,n.enabled,!0);i.xAxis=i.yAxis=void 0;var a=c({chart:{panning:{enabled:!0,type:"x"},zooming:{pinchType:"x",mouseWheel:{type:"x"}}},navigator:{enabled:r},scrollbar:{enabled:L(h.enabled,!0)},rangeSelector:{enabled:L(l.rangeSelector.enabled,!0)},title:{text:null},tooltip:{split:L(s.tooltip&&s.tooltip.split,!0),crosshairs:!0},legend:{enabled:!1}},i,{isStock:!0});i.xAxis=e,i.yAxis=o,a.xAxis=u(i.xAxis||{}).map((t,e)=>c(g("xAxis",t,s.xAxis),t,f("xAxis",i))),a.yAxis=u(i.yAxis||{}).map((t,e)=>c(g("yAxis",t,s.yAxis),t)),super.init(a,t)}createAxis(t,e){return e.axis=c(g(t,e.axis,d()[t]),e.axis,f(t,this.userOptions)),super.createAxis(t,e)}}function x(d){var c=this;if(c.crosshair&&c.crosshair.label&&c.crosshair.label.enabled&&c.cross&&P(c.min)&&P(c.max)){var p=c.chart,u=c.logarithmic,g=c.crosshair.label,f=c.horiz,m=c.opposite,x=c.left,v=c.top,y=c.width,b="inside"===c.options.tickPosition,M=!1!==c.crosshair.snap,S=d.e||c.cross&&c.cross.e,d=d.point;let t=c.crossLabel,e,i,s=g.format,o="",r,a=0,n=c.min,l=c.max;u&&(n=u.lin2log(c.min),l=u.lin2log(c.max));u=f?"center":m?"right"===c.labelAlign?"right":"left":"left"===c.labelAlign?"left":"center",u=(t||(t=c.crossLabel=p.renderer.label("",0,void 0,g.shape||"callout").addClass("highcharts-crosshair-label highcharts-color-"+(d&&d.series?d.series.colorIndex:c.series[0]&&this.series[0].colorIndex)).attr({align:g.align||u,padding:L(g.padding,8),r:L(g.borderRadius,3),zIndex:2}).add(c.labelGroup),p.styledMode)||t.attr({fill:g.backgroundColor||d&&d.series&&d.series.color||"#666666",stroke:g.borderColor||"","stroke-width":g.borderWidth||0}).css(w({color:"#ffffff",fontWeight:"normal",fontSize:"0.7em",textAlign:"center"},g.style||{})),i=f?(e=M?(d.plotX||0)+x:S.chartX,v+(m?0:c.height)):(e=x+c.offset+(m?y:0),M?(d.plotY||0)+v:S.chartY),s||g.formatter||(c.dateTime&&(o="%b %d, %Y"),s="{value"+(o?":"+o:"")+"}"),M?c.isXAxis?d.x:d.y:c.toValue(f?S.chartX:S.chartY)),y=d&&d.series?d.series.isPointInside(d):P(u)&&u>n&&u<l;let h="";s?h=k(s,{value:u},p):g.formatter&&P(u)&&(h=g.formatter.call(c,u)),t.attr({text:h,x:e,y:i,visibility:y?"inherit":"hidden"});v=t.getBBox(),M=(!P(t.x)||f||m||(e=t.x-v.width/2),P(t.y)&&(f?(b&&!m||!b&&m)&&(i=t.y-v.height):i=t.y-v.height/2),r=f?{left:x-v.x,right:x+c.width-v.x}:{left:"left"===c.labelAlign?x:0,right:"right"===c.labelAlign?x+c.width:p.chartWidth},t.translateX||0);M<r.left&&(a=r.left-M),M+v.width>=r.right&&(a=-(M+v.width-r.right)),t.attr({x:e+a,y:i,anchorX:f?e:c.opposite?0:p.chartWidth,anchorY:f?c.opposite?p.chartHeight:0:i+v.height/2})}}function v(){this.crossLabel&&(this.crossLabel=this.crossLabel.hide())}function y(t){var e=this.chart,i=this.options,s=e._labelPanes=e._labelPanes||{},o=i.labels;e.options.isStock&&"yAxis"===this.coll&&!s[e=i.top+","+i.height]&&o.enabled&&(15===o.distance&&1===this.side&&(o.distance=0),"undefined"==typeof o.align&&(o.align="right"),s[e]=this,t.align="right",t.preventDefault())}function b(){var t=this.chart,e=this.options&&this.options.top+","+this.options.height;e&&t._labelPanes&&t._labelPanes[e]===this&&delete t._labelPanes[e]}function M(t){const s=this,o=(s.isLinked&&!s.series&&s.linkedParent?s.linkedParent:s).series,r=s.chart,e=r.renderer,i=s.left,a=s.top,n=[],l=t.translatedValue,h=t.value,d=t.force;let c,p,u,g,f=[],m,x;if(r.options.isStock&&!1!==t.acrossPanes&&"xAxis"===s.coll||"yAxis"===s.coll){t.preventDefault(),f=(t=>{const e="xAxis"===t?"yAxis":"xAxis",i=s.options[e];return P(i)?[r[e][i]]:O(i)?[r.get(i)]:o.map(t=>t[e])})(s.coll);for(const y of s.isXAxis?r.yAxis:r.xAxis){var v;A(y.options.id)&&-1!==y.options.id.indexOf("navigator")||(v=y.isXAxis?"yAxis":"xAxis",v=A(y.options[v])?r[v][y.options[v]]:r[v][0],s===v&&f.push(y))}m=f.length?[]:[(s.isXAxis?r.yAxis:r.xAxis)[0]];for(const b of f)-1!==m.indexOf(b)||T(m,t=>t.pos===b.pos&&t.len===b.len)||m.push(b);if(x=L(l,s.translate(h||0,void 0,void 0,t.old)),P(x))if(s.horiz)for(const M of m){let t;p=M.pos,g=p+M.len,c=u=Math.round(x+s.transB),"pass"!==d&&(c<i||c>i+s.width)&&(d?c=u=C(c,i,i+s.width):t=!0),t||n.push(["M",c,p],["L",u,g])}else for(const S of m){let t;c=S.pos,u=c+S.len,p=g=Math.round(a+s.height-x),"pass"!==d&&(p<a||p>a+s.height)&&(d?p=g=C(p,a,a+s.height):t=!0),t||n.push(["M",c,p],["L",u,g])}t.path=0<n.length?e.crispPolyLine(n,t.lineWidth||1):void 0}}function S(e){if(this.chart.options.isStock){let t;this.is("column")||this.is("columnrange")?t={borderWidth:0,shadow:!1}:this.is("scatter")||this.is("sma")||(t={marker:{enabled:!1,radius:2}}),t&&(e.plotOptions[this.type]=c(e.plotOptions[this.type],t))}}function E(){var t=this.chart,e=this.options.dataGrouping;return!1!==this.allowDG&&e&&L(e.enabled,t.options.isStock)}function D(e,i){for(let t=0;t<e.length;t+=2){var s=e[t],o=e[t+1];s[1]===o[1]&&(s[1]=o[1]=Math.round(s[1])-i%2/2),s[2]===o[2]&&(s[2]=o[2]=Math.round(s[2])+i%2/2)}return e}var B;return a(t,"update",function(t){t=t.options;"scrollbar"in t&&this.navigator&&(c(!0,this.options.scrollbar,t.scrollbar),this.navigator.update({}),delete t.scrollbar)}),(B=m=m||{}).compose=function j(t,e,i){p(r,j)&&(a(t,"afterDrawCrosshair",x),a(t,"afterHideCrosshair",v),a(t,"autoLabelAlign",y),a(t,"destroy",b),a(t,"getPlotLinePath",M),e.prototype.forceCropping=E,a(e,"setOptions",S),i.prototype.crispPolyLine=D)},B.stockChart=function(t,e,i){return new B(t,e,i)},m}),e(t,"masters/modules/stock.src.js",[t["Core/Globals.js"],t["Series/DataModifyComposition.js"],t["Stock/Navigator/Navigator.js"],t["Stock/RangeSelector/RangeSelector.js"],t["Stock/Scrollbar/Scrollbar.js"],t["Core/Axis/OrdinalAxis.js"],t["Series/OHLC/OHLCSeries.js"],t["Series/Flags/FlagsSeries.js"],t["Core/Chart/StockChart.js"]],function(t,e,i,s,o,r,a,n,l){t.Navigator=i,t.RangeSelector=s,t.Scrollbar=o,t.StockChart=t.stockChart=l.stockChart,e.compose(t.Series,t.Axis,t.Point),n.compose(t.Renderer),i.compose(t.Axis,t.Chart,t.Series),a.compose(t.Series),r.compose(t.Axis,t.Series,t.Chart),s.compose(t.Axis,t.Chart),o.compose(t.Axis),l.compose(t.Axis,t.Series,t.SVGRenderer)}),e(t,"masters/highstock.src.js",[t["masters/highcharts.src.js"]],function(t){return t.product="Highstock",t}),(t["masters/highstock.src.js"]._modules=t)["masters/highstock.src.js"]});
//# sourceMappingURL=highstock.js.map;
!function(e){"object"==typeof module&&module.exports?module.exports=e["default"]=e:"function"==typeof define&&define.amd?define("highcharts/highcharts-more",["highcharts"],function(t){return e(t),e.Highcharts=t,e}):e("undefined"!=typeof Highcharts?Highcharts:undefined)}(function(t){"use strict";t=t?t._modules:{};function e(t,e,i,s){t.hasOwnProperty(e)||(t[e]=s.apply(null,i),"function"==typeof CustomEvent&&window.dispatchEvent(new CustomEvent("HighchartsModuleLoaded",{detail:{path:e,module:t[e]}})))}e(t,"Extensions/Pane/PaneComposition.js",[t["Core/Globals.js"],t["Core/Utilities.js"]],function(t,e){const s=t["composed"],{addEvent:o,correctFloat:h,defined:p,pick:a,pushUnique:r}=e;function n(e){const i=this;let s;return e&&i.pane.forEach(t=>{l(e.chartX-i.plotLeft,e.chartY-i.plotTop,t.center)&&(s=t)}),s}function l(t,e,i,s,o){let a=!0;var r=i[0],n=i[1],l=Math.sqrt(Math.pow(t-r,2)+Math.pow(e-n,2));return p(s)&&p(o)&&(e=Math.atan2(h(e-n,8),h(t-r,8)),o!==s)&&(a=o<s?s<=e&&e<=Math.PI||e<=o&&e>=-Math.PI:s<=e&&e<=h(o,8)),l<=Math.ceil(i[2]/2)&&a}function d(e){this.polar&&(e.options.inverted&&([e.x,e.y]=[e.y,e.x]),e.isInsidePlot=this.pane.some(t=>l(e.x,e.y,t.center,t.axis&&t.axis.normalizedStartAngleRad,t.axis&&t.axis.normalizedEndAngleRad)))}function c(t){var e=this.chart;t.hoverPoint&&t.hoverPoint.plotX&&t.hoverPoint.plotY&&e.hoverPane&&!l(t.hoverPoint.plotX,t.hoverPoint.plotY,e.hoverPane.center)&&(t.hoverPoint=void 0)}function u(e){const i=this.chart;i.polar?(i.hoverPane=i.getHoverPane(e),e.filter=function(t){return t.visible&&!(!e.shared&&t.directTouch)&&a(t.options.enableMouseTracking,!0)&&(!i.hoverPane||t.xAxis.pane===i.hoverPane)}):i.hoverPane=void 0}return{compose:function g(t,e){var i;r(s,g)&&((i=t.prototype).collectionsWithUpdate.push("pane"),i.getHoverPane=n,o(t,"afterIsInsidePlot",d),o(e,"afterGetHoverData",c),o(e,"beforeGetHoverData",u))}}}),e(t,"Extensions/Pane/PaneDefaults.js",[],function(){return{pane:{center:["50%","50%"],size:"85%",innerSize:"0%",startAngle:0},background:{shape:"circle",borderWidth:1,borderColor:"#cccccc",backgroundColor:{linearGradient:{x1:0,y1:0,x2:0,y2:1},stops:[[0,"#ffffff"],[1,"#e6e6e6"]]},from:-Number.MAX_VALUE,innerRadius:0,to:Number.MAX_VALUE,outerRadius:"105%"}}}),e(t,"Extensions/Pane/Pane.js",[t["Series/CenteredUtilities.js"],t["Extensions/Pane/PaneComposition.js"],t["Extensions/Pane/PaneDefaults.js"],t["Core/Utilities.js"]],function(e,t,o,i){const{extend:a,merge:r,splat:n}=i;class s{constructor(t,e){this.coll="pane",this.init(t,e)}init(t,e){this.chart=e,this.background=[],e.pane.push(this),this.setOptions(t)}setOptions(t){this.options=t=r(o.pane,this.chart.angular?{background:{}}:void 0,t)}render(){var t=this.options,e=this.chart.renderer;if(this.group||(this.group=e.g("pane-group").attr({zIndex:t.zIndex||0}).add()),this.updateCenter(),i=this.options.background){var i=n(i),s=Math.max(i.length,this.background.length||0);for(let t=0;t<s;t++)i[t]&&this.axis?this.renderBackground(r(o.background,i[t]),t):this.background[t]&&(this.background[t]=this.background[t].destroy(),this.background.splice(t,1))}}renderBackground(t,e){var i={"class":"highcharts-pane "+(t.className||"")};let s="animate";this.chart.styledMode||a(i,{fill:t.backgroundColor,stroke:t.borderColor,"stroke-width":t.borderWidth}),this.background[e]||(this.background[e]=this.chart.renderer.path().add(this.group),s="attr"),this.background[e][s]({d:this.axis.getPlotBandPath(t.from,t.to,t)}).attr(i)}updateCenter(t){this.center=(t||this.axis||{}).center=e.getCenter.call(this)}update(t,e){r(!0,this.options,t),this.setOptions(this.options),this.render(),this.chart.axes.forEach(function(t){t.pane===this&&(t.pane=null,t.update({},e))},this)}}return s.compose=t.compose,s}),e(t,"Series/AreaRange/AreaRangePoint.js",[t["Core/Series/SeriesRegistry.js"],t["Core/Utilities.js"]],function(t,e){const{prototype:{pointClass:i,pointClass:{prototype:s}}}=t.seriesTypes["area"],{defined:o,isNumber:a}=e;class r extends i{setState(){var t=this.state,e=this.series,i=e.chart.polar,t=(e.options.marker,e.symbol,o(this.plotHigh)||(this.plotHigh=e.yAxis.toPixels(this.high,!0)),o(this.plotLow)||(this.plotLow=this.plotY=e.yAxis.toPixels(this.low,!0)),e.lowerStateMarkerGraphic=e.stateMarkerGraphic,e.stateMarkerGraphic=e.upperStateMarkerGraphic,this.graphic=this.graphics&&this.graphics[1],this.plotY=this.plotHigh,i&&a(this.plotHighX)&&(this.plotX=this.plotHighX),s.setState.apply(this,arguments),this.state=t,this.plotY=this.plotLow,this.graphic=this.graphics&&this.graphics[0],i&&a(this.plotLowX)&&(this.plotX=this.plotLowX),e.upperStateMarkerGraphic=e.stateMarkerGraphic,e.stateMarkerGraphic=e.lowerStateMarkerGraphic,e.lowerStateMarkerGraphic=void 0,e.modifyMarkerSettings());s.setState.apply(this,arguments),e.restoreMarkerSettings(t)}haloPath(){var t=this.series.chart.polar;let e=[];return this.plotY=this.plotLow,t&&a(this.plotLowX)&&(this.plotX=this.plotLowX),this.isInside&&(e=s.haloPath.apply(this,arguments)),this.plotY=this.plotHigh,t&&a(this.plotHighX)&&(this.plotX=this.plotHighX),e=this.isTopInside?e.concat(s.haloPath.apply(this,arguments)):e}isValid(){return a(this.low)&&a(this.high)}}return r}),e(t,"Series/AreaRange/AreaRangeSeries.js",[t["Series/AreaRange/AreaRangePoint.js"],t["Core/Globals.js"],t["Core/Series/SeriesRegistry.js"],t["Core/Utilities.js"]],function(t,e,i,s){e=e.noop;const{area:o,area:{prototype:m},column:{prototype:a}}=i.seriesTypes,{addEvent:r,defined:n,extend:g,isArray:b,isNumber:l,pick:f,merge:h}=s;class p extends o{toYData(t){return[t.low,t.high]}highToXY(t){var e=this.chart,i=this.xAxis.postTranslate(t.rectPlotX||0,this.yAxis.len-(t.plotHigh||0));t.plotHighX=i.x-e.plotLeft,t.plotHigh=i.y-e.plotTop,t.plotLowX=t.plotX}getGraphPath(t){var e=[],i=[],s=m.getGraphPath,o=this.options,a=this.chart.polar,r=a&&!1!==o.connectEnds,n=o.connectNulls;let l,h,p,d=o.step;for(t=t||this.points,l=t.length;l--;){h=t[l];var c=a?{plotX:h.rectPlotX,plotY:h.yBottom,doCurve:!1}:{plotX:h.plotX,plotY:h.plotY,doCurve:!1};h.isNull||r||n||t[l+1]&&!t[l+1].isNull||i.push(c),p={polarPlotY:h.polarPlotY,rectPlotX:h.rectPlotX,yBottom:h.yBottom,plotX:f(h.plotHighX,h.plotX),plotY:h.plotHigh,isNull:h.isNull},i.push(p),e.push(p),h.isNull||r||n||t[l-1]&&!t[l-1].isNull||i.push(c)}var u=s.call(this,t),g=(d&&(!0===d&&(d="left"),o.step={left:"right",center:"center",right:"left"}[d]),s.call(this,e)),s=s.call(this,i),o=(o.step=d,[].concat(u,g));return!this.chart.polar&&s[0]&&"M"===s[0][0]&&(s[0]=["L",s[0][1],s[0][2]]),this.graphPath=o,this.areaPath=u.concat(s),o.isArea=!0,o.xMap=u.xMap,this.areaPath.xMap=u.xMap,o}drawDataLabels(){var t,e,i,s,o=this.points,a=o.length,r=[],n=this.options.dataLabels,l=this.chart.inverted;let h,p,d,c,u;if(n){if(b(n)?(c=n[0]||{enabled:!1},u=n[1]||{enabled:!1}):((c=g({},n)).x=n.xHigh,c.y=n.yHigh,(u=g({},n)).x=n.xLow,u.y=n.yLow),c.enabled||this.hasDataLabels?.()){for(h=a;h--;)(p=o[h])&&({plotHigh:t=0,plotLow:e=0}=p,d=c.inside?t<e:e<t,p.y=p.high,p._plotY=p.plotY,p.plotY=t,r[h]=p.dataLabel,p.dataLabel=p.dataLabelUpper,p.below=d,l?c.align||(c.align=d?"right":"left"):c.verticalAlign||(c.verticalAlign=d?"top":"bottom"));for(this.options.dataLabels=c,m.drawDataLabels&&m.drawDataLabels.apply(this,arguments),h=a;h--;)(p=o[h])&&(p.dataLabelUpper=p.dataLabel,p.dataLabel=r[h],delete p.dataLabels,p.y=p.low,p.plotY=p._plotY)}if(u.enabled||this.hasDataLabels?.()){for(h=a;h--;)(p=o[h])&&({plotHigh:i=0,plotLow:s=0}=p,d=u.inside?i<s:s<i,p.below=!d,l?u.align||(u.align=d?"left":"right"):u.verticalAlign||(u.verticalAlign=d?"bottom":"top"));this.options.dataLabels=u,m.drawDataLabels&&m.drawDataLabels.apply(this,arguments)}if(c.enabled)for(h=a;h--;)(p=o[h])&&(p.dataLabels=[p.dataLabelUpper,p.dataLabel].filter(function(t){return!!t}));this.options.dataLabels=n}}alignDataLabel(){a.alignDataLabel.apply(this,arguments)}modifyMarkerSettings(){var t,e,i=this,s={marker:i.options.marker,symbol:i.symbol};return i.options.lowMarker&&({marker:t,lowMarker:e}=i["options"],i.options.marker=h(t,e),e.symbol)&&(i.symbol=e.symbol),s}restoreMarkerSettings(t){this.options.marker=t.marker,this.symbol=t.symbol}drawPoints(){var t=this,e=t.points.length;let i,s;var o=t.modifyMarkerSettings();for(m.drawPoints.apply(t,arguments),t.restoreMarkerSettings(o),i=0;i<e;)(s=t.points[i]).graphics=s.graphics||[],s.origProps={plotY:s.plotY,plotX:s.plotX,isInside:s.isInside,negative:s.negative,zone:s.zone,y:s.y},(s.graphic||s.graphics[0])&&(s.graphics[0]=s.graphic),s.graphic=s.graphics[1],s.plotY=s.plotHigh,n(s.plotHighX)&&(s.plotX=s.plotHighX),s.y=f(s.high,s.origProps.y),s.negative=s.y<(t.options.threshold||0),t.zones.length&&(s.zone=s.getZone()),t.chart.polar||(s.isInside=s.isTopInside="undefined"!=typeof s.plotY&&0<=s.plotY&&s.plotY<=t.yAxis.len&&0<=s.plotX&&s.plotX<=t.xAxis.len),i++;for(m.drawPoints.apply(t,arguments),i=0;i<e;)(s=t.points[i]).graphics=s.graphics||[],(s.graphic||s.graphics[1])&&(s.graphics[1]=s.graphic),s.graphic=s.graphics[0],s.origProps&&(g(s,s.origProps),delete s.origProps),i++}hasMarkerChanged(t,e){var i=t.lowMarker,s=e.lowMarker||{};return i&&(!1===i.enabled||s.symbol!==i.symbol||s.height!==i.height||s.width!==i.width)||super.hasMarkerChanged(t,e)}}return p.defaultOptions=h(o.defaultOptions,{lineWidth:1,threshold:null,tooltip:{pointFormat:'<span style="color:{series.color}">●</span> {series.name}: <b>{point.low}</b> - <b>{point.high}</b><br/>'},trackByArea:!0,dataLabels:{align:void 0,verticalAlign:void 0,xLow:0,xHigh:0,yLow:0,yHigh:0}}),r(p,"afterTranslate",function(){"low,high"===this.pointArrayMap.join(",")&&this.points.forEach(t=>{var e=t.high,i=t.plotY;t.isNull?t.plotY=void 0:(t.plotLow=i,t.plotHigh=l(e)?this.yAxis.translate(this.dataModify?this.dataModify.modifyValue(e):e,!1,!0,void 0,!0):void 0,this.dataModify&&(t.yBottom=t.plotHigh))})},{order:0}),r(p,"afterTranslate",function(){this.chart.inverted;this.points.forEach(t=>{var e,i;this.chart.polar?(this.highToXY(t),t.plotLow=t.plotY,t.tooltipPos=[((t.plotHighX||0)+(t.plotLowX||0))/2,((t.plotHigh||0)+(t.plotLow||0))/2]):(e=t.pos(!1,t.plotLow),i=t.pos(!1,t.plotHigh),e&&i&&(e[0]=(e[0]+i[0])/2,e[1]=(e[1]+i[1])/2),t.tooltipPos=e)})},{order:3}),g(p.prototype,{deferTranslatePolar:!0,pointArrayMap:["low","high"],pointClass:t,pointValKey:"low",setStackedPoints:e}),i.registerSeriesType("arearange",p),p}),e(t,"Series/AreaSplineRange/AreaSplineRangeSeries.js",[t["Series/AreaRange/AreaRangeSeries.js"],t["Core/Series/SeriesRegistry.js"],t["Core/Utilities.js"]],function(t,e,i){var s=e.seriesTypes["spline"]["prototype"],{merge:i,extend:o}=i;class a extends t{}return a.defaultOptions=i(t.defaultOptions),o(a.prototype,{getPointSpline:s.getPointSpline}),e.registerSeriesType("areasplinerange",a),a}),e(t,"Series/BoxPlot/BoxPlotSeriesDefaults.js",[],function(){return{threshold:null,tooltip:{pointFormat:'<span style="color:{point.color}">●</span> <b>{series.name}</b><br/>Maximum: {point.high}<br/>Upper quartile: {point.q3}<br/>Median: {point.median}<br/>Lower quartile: {point.q1}<br/>Minimum: {point.low}<br/>'},whiskerLength:"50%",fillColor:"#ffffff",lineWidth:1,medianWidth:2,whiskerWidth:2}}),e(t,"Series/BoxPlot/BoxPlotSeries.js",[t["Series/BoxPlot/BoxPlotSeriesDefaults.js"],t["Series/Column/ColumnSeries.js"],t["Core/Globals.js"],t["Core/Series/SeriesRegistry.js"],t["Core/Utilities.js"]],function(t,e,i,s,o){i=i.noop;const{extend:a,merge:r,pick:A}=o;class n extends e{pointAttribs(){return{}}translate(){const i=this.yAxis,t=this.pointArrayMap;super.translate.apply(this),this.points.forEach(function(e){t.forEach(function(t){null!==e[t]&&(e[t+"Plot"]=i.translate(e[t],0,1,0,1))}),e.plotHigh=e.highPlot})}drawPoints(){var e=this,t=e.points,i=e.options,s=e.chart,o=s.renderer,a=!1!==e.doQuartiles,r=e.options.whiskerLength;let n,l,h,p,d,c,u,g,m,b,f,y,x;for(const w of t){var v=(g=w.graphic)?"animate":"attr",P=w.shapeArgs,S={},M={},k={},L={},C=w.color||e.color;if("undefined"!=typeof w.plotY){m=Math.round(P.width),b=Math.floor(P.x),f=b+m,y=Math.round(m/2),n=Math.floor(a?w.q1Plot:w.lowPlot),l=Math.floor(a?w.q3Plot:w.lowPlot),h=Math.floor(w.highPlot),p=Math.floor(w.lowPlot),g||(w.graphic=g=o.g("point").add(e.group),w.stem=o.path().addClass("highcharts-boxplot-stem").add(g),r&&(w.whiskers=o.path().addClass("highcharts-boxplot-whisker").add(g)),a&&(w.box=o.path(void 0).addClass("highcharts-boxplot-box").add(g)),w.medianShape=o.path(void 0).addClass("highcharts-boxplot-median").add(g)),s.styledMode||(M.stroke=w.stemColor||i.stemColor||C,M["stroke-width"]=A(w.stemWidth,i.stemWidth,i.lineWidth),M.dashstyle=w.stemDashStyle||i.stemDashStyle||i.dashStyle,w.stem.attr(M),r&&(k.stroke=w.whiskerColor||i.whiskerColor||C,k["stroke-width"]=A(w.whiskerWidth,i.whiskerWidth,i.lineWidth),k.dashstyle=w.whiskerDashStyle||i.whiskerDashStyle||i.dashStyle,w.whiskers.attr(k)),a&&(S.fill=w.fillColor||i.fillColor||C,S.stroke=i.lineColor||C,S["stroke-width"]=i.lineWidth||0,S.dashstyle=w.boxDashStyle||i.boxDashStyle||i.dashStyle,w.box.attr(S)),L.stroke=w.medianColor||i.medianColor||C,L["stroke-width"]=A(w.medianWidth,i.medianWidth,i.lineWidth),L.dashstyle=w.medianDashStyle||i.medianDashStyle||i.dashStyle,w.medianShape.attr(L));let t;c=w.stem.strokeWidth()%2/2,u=b+y+c,t=[["M",u,l],["L",u,h],["M",u,n],["L",u,p]],w.stem[v]({d:t}),a&&(c=w.box.strokeWidth()%2/2,n=Math.floor(n)+c,l=Math.floor(l)+c,b+=c,f+=c,t=[["M",b,l],["L",b,n],["L",f,n],["L",f,l],["L",b,l],["Z"]],w.box[v]({d:t})),r&&(h+=c=w.whiskers.strokeWidth()%2/2,p+=c,x=/%$/.test(r)?y*parseFloat(r)/100:r/2,t=[["M",u-x,h],["L",u+x,h],["M",u-x,p],["L",u+x,p]],w.whiskers[v]({d:t})),d=Math.round(w.medianPlot),d+=c=w.medianShape.strokeWidth()%2/2,t=[["M",b,d],["L",f,d]],w.medianShape[v]({d:t})}}}toYData(t){return[t.low,t.q1,t.median,t.q3,t.high]}}return n.defaultOptions=r(e.defaultOptions,t),a(n.prototype,{pointArrayMap:["low","q1","median","q3","high"],pointValKey:"high",drawDataLabels:i,setStackedPoints:i}),s.registerSeriesType("boxplot",n),n}),e(t,"Series/Bubble/BubbleLegendDefaults.js",[],function(){return{borderColor:void 0,borderWidth:2,className:void 0,color:void 0,connectorClassName:void 0,connectorColor:void 0,connectorDistance:60,connectorWidth:1,enabled:!1,labels:{className:void 0,allowOverlap:!1,format:"",formatter:void 0,align:"right",style:{fontSize:"0.9em",color:"#000000"},x:0,y:0},maxSize:60,minSize:10,legendIndex:0,ranges:{value:void 0,borderColor:void 0,color:void 0,connectorColor:void 0},sizeBy:"area",sizeByAbsoluteValue:!1,zIndex:1,zThreshold:0}}),e(t,"Series/Bubble/BubbleLegendItem.js",[t["Core/Color/Color.js"],t["Core/Templating.js"],t["Core/Globals.js"],t["Core/Utilities.js"]],function(t,o,e,i){const d=t["parse"],s=e["noop"],{arrayMax:n,arrayMin:l,isNumber:h,merge:c,pick:u,stableSort:p}=i;class a{constructor(t,e){this.setState=s,this.init(t,e)}init(t,e){this.options=t,this.visible=!0,this.chart=e.chart,this.legend=e}addToLegend(t){t.splice(this.options.legendIndex,0,this)}drawLegendSymbol(t){this.chart;var e,i,s=u(t.options.itemDistance,20),o=this.legendItem||{},a=this.options,r=a.ranges,n=a.connectorDistance;r&&r.length&&h(r[0].value)?(p(r,function(t,e){return e.value-t.value}),this.ranges=r,this.setOptions(),this.render(),r=this.getMaxLabelSize(),i=2*(e=this.ranges[0].radius),n=0<(n=n-e+r.width)?n:0,this.maxLabel=r,this.movementX="left"===a.labels.align?n:0,o.labelWidth=i+n+s,o.labelHeight=i+r.height/2):t.options.bubbleLegend.autoRanges=!0}setOptions(){const i=this.ranges,s=this.options,o=this.chart.series[s.seriesIndex],a=this.legend.baseline,r={zIndex:s.zIndex,"stroke-width":s.borderWidth},n={zIndex:s.zIndex,"stroke-width":s.connectorWidth},l={align:this.legend.options.rtl||"left"===s.labels.align?"right":"left",zIndex:s.zIndex},h=o.options.marker.fillOpacity,p=this.chart.styledMode;i.forEach(function(t,e){p||(r.stroke=u(t.borderColor,s.borderColor,o.color),r.fill=u(t.color,s.color,1!==h?d(o.color).setOpacity(h).get("rgba"):o.color),n.stroke=u(t.connectorColor,s.connectorColor,o.color)),i[e].radius=this.getRangeRadius(t.value),i[e]=c(i[e],{center:i[0].radius-i[e].radius+a}),p||c(!0,i[e],{bubbleAttribs:c(r),connectorAttribs:c(n),labelAttribs:l})},this)}getRangeRadius(t){var e=this.options,i=this.options.seriesIndex,i=this.chart.series[i],s=e.ranges[0].value,o=e.ranges[e.ranges.length-1].value,a=e.minSize,e=e.maxSize;return i.getRadius.call(this,o,s,a,e,t)}render(){var t=this.legendItem||{},e=this.chart.renderer,i=this.options.zThreshold;this.symbols||(this.symbols={connectors:[],bubbleItems:[],labels:[]}),t.symbol=e.g("bubble-legend"),t.label=e.g("bubble-legend-item").css(this.legend.itemStyle||{}),t.symbol.translateX=0,t.symbol.translateY=0,t.symbol.add(t.label),t.label.add(t.group);for(const s of this.ranges)s.value>=i&&this.renderRange(s);this.hideOverlappingLabels()}renderRange(t){var e=this.ranges[0],i=this.legend,s=this.options,o=s.labels,a=this.chart,r=a.series[s.seriesIndex],a=a.renderer,n=this.symbols,l=n.labels,h=t.center,p=Math.abs(t.radius),d=s.connectorDistance||0,c=o.align,i=i.options.rtl,u=s.borderWidth,g=s.connectorWidth,e=e.radius||0,u=h-p-u/2+g/2,g=(u%1?1:.5)-(g%2?0:.5),m=a.styledMode;let b=i||"left"===c?-d:d;"center"===c&&(b=0,s.connectorDistance=0,t.labelAttribs.align="center"),n.bubbleItems.push(a.circle(e,h+g,p).attr(m?{}:t.bubbleAttribs).addClass((m?"highcharts-color-"+r.colorIndex+" ":"")+"highcharts-bubble-legend-symbol "+(s.className||"")).add(this.legendItem.symbol)),n.connectors.push(a.path(a.crispLine([["M",e,u],["L",e+b,u]],s.connectorWidth)).attr(m?{}:t.connectorAttribs).addClass((m?"highcharts-color-"+this.options.seriesIndex+" ":"")+"highcharts-bubble-legend-connectors "+(s.connectorClassName||"")).add(this.legendItem.symbol));i=a.text(this.formatLabel(t)).attr(m?{}:t.labelAttribs).css(m?{}:o.style).addClass("highcharts-bubble-legend-labels "+(s.labels.className||"")).add(this.legendItem.symbol),d={x:e+b+s.labels.x,y:u+s.labels.y+.4*i.getBBox().height};i.attr(d),l.push(i),i.placed=!0,i.alignAttr=d}getMaxLabelSize(){var t=this.symbols.labels;let e,i;return t.forEach(function(t){i=t.getBBox(!0),e=!e||i.width>e.width?i:e}),e||{}}formatLabel(t){var e=this.options,i=e.labels.formatter,e=e.labels.format,s=this.chart["numberFormatter"];return e?o.format(e,t):i?i.call(t):s(t.value,1)}hideOverlappingLabels(){const t=this.chart,e=this.options.labels.allowOverlap,i=this.symbols;!e&&i&&(t.hideOverlappingLabels(i.labels),i.labels.forEach(function(t,e){t.newOpacity?t.newOpacity!==t.oldOpacity&&i.connectors[e].show():i.connectors[e].hide()}))}getRanges(){const t=this.legend.bubbleLegend,e=t.chart.series,i=t.options.ranges;let s,o,a=Number.MAX_VALUE,r=-Number.MAX_VALUE;return e.forEach(function(t){t.isBubble&&!t.ignoreSeries&&(o=t.zData.filter(h)).length&&(a=u(t.options.zMin,Math.min(a,Math.max(l(o),!1===t.options.displayNegative?t.options.zThreshold:-Number.MAX_VALUE))),r=u(t.options.zMax,Math.max(r,n(o))))}),s=a===r?[{value:r}]:[{value:a},{value:(a+r)/2},{value:r,autoRanges:!0}],i.length&&i[0].radius&&s.reverse(),s.forEach(function(t,e){i&&i[e]&&(s[e]=c(i[e],t))}),s}predictBubbleSizes(){var t=this.chart,e=t.legend.options,i=e.floating,e="horizontal"===e.layout,s=e?t.legend.lastLineHeight:0,o=t.plotSizeX,a=t.plotSizeY,t=t.series[this.options.seriesIndex],r=t.getPxExtremes(),n=Math.ceil(r.minPxSize),r=Math.ceil(r.maxPxSize),l=Math.min(a,o);let h,p=t.options.maxSize;return(i||!/%$/.test(p)||(p=parseFloat(p),h=(l+s)*p/100/(p/100+1),e&&a-h>=o)||!e&&o-h>=a)&&(h=r),[n,Math.ceil(h)]}updateRanges(t,e){var i=this.legend.options.bubbleLegend;i.minSize=t,i.maxSize=e,i.ranges=this.getRanges()}correctSizes(){var t=this.legend,e=this.chart.series[this.options.seriesIndex].getPxExtremes(),i=e.maxPxSize,s=this.options.maxSize;1<Math.abs(Math.ceil(i)-s)&&(this.updateRanges(this.options.minSize,e.maxPxSize),t.render())}}return a}),e(t,"Series/Bubble/BubbleLegendComposition.js",[t["Series/Bubble/BubbleLegendDefaults.js"],t["Series/Bubble/BubbleLegendItem.js"],t["Core/Defaults.js"],t["Core/Globals.js"],t["Core/Utilities.js"]],function(s,r,t,e,i){const o=t["setOptions"],a=e["composed"],{addEvent:n,objectEach:h,pushUnique:l,wrap:p}=i;function d(t,e,i){var s=this,o=s.legend,a=0<=c(s);let r,n,l;o&&o.options.enabled&&o.bubbleLegend&&o.options.bubbleLegend.autoRanges&&a?(r=o.bubbleLegend.options,n=o.bubbleLegend.predictBubbleSizes(),o.bubbleLegend.updateRanges(n[0],n[1]),r.placed||(o.group.placed=!1,o.allItems.forEach(t=>{(l=t.legendItem||{}).group&&(l.group.translateY=void 0)})),o.render(),s.getMargins(),s.axes.forEach(function(t){t.visible&&t.render(),r.placed||(t.setScale(),t.updateNames(),h(t.ticks,function(t){t.isNew=!0,t.isNewLabel=!0}))}),r.placed=!0,s.getMargins(),t.call(s,e,i),o.bubbleLegend.correctSizes(),b(o,u(o))):(t.call(s,e,i),o&&o.options.enabled&&o.bubbleLegend&&(o.render(),b(o,u(o))))}function c(t){var e=t.series;let i=0;for(;i<e.length;){if(e[i]&&e[i].isBubble&&e[i].visible&&e[i].zData.length)return i;i++}return-1}function u(t){var e=t.allItems,i=[],s=e.length;let o,a,r,n=0,l=0;for(n=0;n<s;n++)if(a=e[n].legendItem||{},r=(e[n+1]||{}).legendItem||{},a.labelHeight&&(e[n].itemHeight=a.labelHeight),e[n]===e[s-1]||a.y!==r.y){for(i.push({height:0}),o=i[i.length-1],l;l<=n;l++)e[l].itemHeight>o.height&&(o.height=e[l].itemHeight);o.step=n}return i}function g(t){var e=this,i=e.bubbleLegend,s=e.options,o=s.bubbleLegend,a=c(e.chart);i&&i.ranges&&i.ranges.length&&(o.ranges.length&&(o.autoRanges=!!o.ranges[0].autoRanges),e.destroyItem(i)),0<=a&&s.enabled&&o.enabled&&(o.seriesIndex=a,e.bubbleLegend=new r(o,e),e.bubbleLegend.addToLegend(t.allItems))}function m(t){if(t.defaultPrevented)return!1;var t=this,e=t.chart,i=t.visible,s=t.chart.legend;s&&s.bubbleLegend&&(t.visible=!i,t.ignoreSeries=i,e=0<=c(e),s.bubbleLegend.visible!==e&&(s.update({bubbleLegend:{enabled:e}}),s.bubbleLegend.visible=e),t.visible=i)}function b(t,i){const e=t.allItems,s=t.options.rtl;let o,a,r,n,l=0;e.forEach((t,e)=>{(n=t.legendItem||{}).group&&(o=n.group.translateX||0,a=n.y||0,((r=t.movementX)||s&&t.ranges)&&(r=s?o-t.options.maxSize/2:o+r,n.group.attr({translateX:r})),e>i[l].step&&l++,n.group.attr({translateY:Math.round(a+i[l].height/2)}),n.y=a+i[l].height/2)})}return{compose:function f(t,e,i){l(a,f)&&(o({legend:{bubbleLegend:s}}),p(t.prototype,"drawChartBox",d),n(e,"afterGetAllItems",g),n(i,"legendItemClick",m))}}}),e(t,"Series/Bubble/BubblePoint.js",[t["Core/Series/Point.js"],t["Core/Series/SeriesRegistry.js"],t["Core/Utilities.js"]],function(e,t,i){var{prototype:{pointClass:t}}=t["seriesTypes"]["scatter"],i=i["extend"];class s extends t{haloPath(t){return e.prototype.haloPath.call(this,0===t?0:(this.marker&&this.marker.radius||0)+t)}}return i(s.prototype,{ttBelow:!1}),s}),e(t,"Series/Bubble/BubbleSeries.js",[t["Series/Bubble/BubbleLegendComposition.js"],t["Series/Bubble/BubblePoint.js"],t["Core/Color/Color.js"],t["Core/Globals.js"],t["Core/Series/SeriesRegistry.js"],t["Core/Utilities.js"]],function(o,t,e,i,s,a){const r=e["parse"],{composed:n,noop:l}=i,{series:h,seriesTypes:{column:{prototype:p},scatter:d}}=s,{addEvent:c,arrayMax:u,arrayMin:g,clamp:m,extend:b,isNumber:f,merge:y,pick:x,pushUnique:v}=a;function P(){const t=this.len,{coll:e,isXAxis:o,min:a}=this,r=o?"xData":"yData",n=(this.max||0)-(a||0);let l=0,h=t,p=t/n,d;"xAxis"!==e&&"yAxis"!==e||(this.series.forEach(e=>{if(e.bubblePadding&&e.reserveSpace()){this.allowZoomOutside=!0,d=!0;var i,s=e[r];if(o&&((e.onPoint||e).getRadii(0,0,e),e.onPoint)&&(e.radii=e.onPoint.radii),0<n){let t=s.length;for(;t--;)f(s[t])&&this.dataMin<=s[t]&&s[t]<=this.max&&(i=e.radii&&e.radii[t]||0,l=Math.min((s[t]-a)*p-i,l),h=Math.max((s[t]-a)*p+i,h))}}}),d&&0<n&&!this.logarithmic&&(h-=t,p*=(t+Math.max(0,l)-Math.min(h,t))/t,[["min","userMin",l],["max","userMax",h]].forEach(t=>{void 0===x(this.options[t[0]],this[t[1]])&&(this[t[0]]+=t[2]/p)})))}class S extends d{static compose(t,e,i,s){o.compose(e,i,s),v(n,this.compose)&&c(t,"foundExtremes",P)}animate(t){!t&&this.points.length<this.options.animationLimit&&this.points.forEach(function(t){var e=t["graphic"];e&&e.width&&(this.hasRendered||e.attr({x:t.plotX,y:t.plotY,width:1,height:1}),e.animate(this.markerAttribs(t),this.options.animation))},this)}getRadii(){var t=this.zData,e=this.yData,i=[];let s,o,a,r=this.chart.bubbleZExtremes;var{minPxSize:n,maxPxSize:l}=this.getPxExtremes();if(!r){let e=Number.MAX_VALUE,i=-Number.MAX_VALUE,s;this.chart.series.forEach(t=>{t.bubblePadding&&t.reserveSpace()&&(t=(t.onPoint||t).getZExtremes())&&(e=Math.min(x(e,t.zMin),t.zMin),i=Math.max(x(i,t.zMax),t.zMax),s=!0)}),s?(r={zMin:e,zMax:i},this.chart.bubbleZExtremes=r):r={zMin:0,zMax:0}}for(o=0,s=t.length;o<s;o++)a=t[o],i.push(this.getRadius(r.zMin,r.zMax,n,l,a,e&&e[o]));this.radii=i}getRadius(t,e,i,s,o,a){var r=this.options,n="width"!==r.sizeBy,l=r.zThreshold;let h=e-t,p=.5;if(null===a||null===o)return null;if(f(o)){if(r.sizeByAbsoluteValue&&(o=Math.abs(o-l),e=h=Math.max(e-l,Math.abs(t-l)),t=0),o<t)return i/2-1;0<h&&(p=(o-t)/h)}return n&&0<=p&&(p=Math.sqrt(p)),Math.ceil(i+p*(s-i))/2}hasData(){return!!this.processedXData.length}pointAttribs(t,e){var i=this.options.marker.fillOpacity,t=h.prototype.pointAttribs.call(this,t,e);return 1!==i&&(t.fill=r(t.fill).setOpacity(i).get("rgba")),t}translate(){super.translate.call(this),this.getRadii(),this.translateBubble()}translateBubble(){var{data:t,options:e,radii:i}=this,s=this.getPxExtremes()["minPxSize"];let o=t.length;for(;o--;){var a=t[o],r=i?i[o]:0;"z"===this.zoneAxis&&(a.negative=(a.z||0)<(e.zThreshold||0)),f(r)&&s/2<=r?(a.marker=b(a.marker,{radius:r,width:2*r,height:2*r}),a.dlBox={x:a.plotX-r,y:a.plotY-r,width:2*r,height:2*r}):(a.shapeArgs=a.plotY=a.dlBox=void 0,a.isInside=!1)}}getPxExtremes(){const i=Math.min(this.chart.plotWidth,this.chart.plotHeight);var t=t=>{let e;return"string"==typeof t&&(e=/%$/.test(t),t=parseInt(t,10)),e?i*t/100:t},e=t(x(this.options.minSize,8));return{minPxSize:e,maxPxSize:Math.max(t(x(this.options.maxSize,"20%")),e)}}getZExtremes(){var t=this.options,e=(this.zData||[]).filter(f);if(e.length){var i=x(t.zMin,m(g(e),!1===t.displayNegative?t.zThreshold||0:-Number.MAX_VALUE,Number.MAX_VALUE)),t=x(t.zMax,u(e));if(f(i)&&f(t))return{zMin:i,zMax:t}}}}return S.defaultOptions=y(d.defaultOptions,{dataLabels:{formatter:function(){var t=this.series.chart["numberFormatter"],e=this.point["z"];return f(e)?t(e,-1):""},inside:!0,verticalAlign:"middle"},animationLimit:250,marker:{lineColor:null,lineWidth:1,fillOpacity:.5,radius:null,states:{hover:{radiusPlus:0}},symbol:"circle"},minSize:8,maxSize:"20%",softThreshold:!1,states:{hover:{halo:{size:5}}},tooltip:{pointFormat:"({point.x}, {point.y}), Size: {point.z}"},turboThreshold:0,zThreshold:0,zoneAxis:"z"}),b(S.prototype,{alignDataLabel:p.alignDataLabel,applyZones:l,bubblePadding:!0,isBubble:!0,pointArrayMap:["y","z"],pointClass:t,parallelArrays:["x","y","z"],trackerGroups:["group","dataLabelsGroup"],specialGroup:"group",zoneAxis:"z"}),c(S,"updatedData",t=>{delete t.target.chart.bubbleZExtremes}),c(S,"remove",t=>{delete t.target.chart.bubbleZExtremes}),s.registerSeriesType("bubble",S),S}),e(t,"Series/ColumnRange/ColumnRangePoint.js",[t["Core/Series/SeriesRegistry.js"],t["Core/Utilities.js"]],function(t,e){var{column:{prototype:{pointClass:{prototype:t}}},arearange:{prototype:{pointClass:i}}}=t["seriesTypes"];const{extend:s,isNumber:o}=e;class a extends i{isValid(){return o(this.low)}}return s(a.prototype,{setState:t.setState}),a}),e(t,"Series/ColumnRange/ColumnRangeSeries.js",[t["Series/ColumnRange/ColumnRangePoint.js"],t["Core/Globals.js"],t["Core/Series/SeriesRegistry.js"],t["Core/Utilities.js"]],function(t,e,i,s){e=e.noop;const{arearange:o,column:a,column:{prototype:r}}=i["seriesTypes"],{addEvent:n,clamp:m,extend:l,isNumber:b,merge:f,pick:y}=s;class h extends o{setOptions(){return f(!0,arguments[0],{stacking:void 0}),o.prototype.setOptions.apply(this,arguments)}translate(){return r.translate.apply(this)}pointAttribs(){return r.pointAttribs.apply(this,arguments)}translate3dPoints(){return r.translate3dPoints.apply(this,arguments)}translate3dShapes(){return r.translate3dShapes.apply(this,arguments)}afterColumnTranslate(){const a=this.yAxis,r=this.xAxis,n=r.startAngleRad,l=this.chart,h=this.xAxis.isRadial,e=Math.max(l.chartWidth,l.chartHeight)+999;let p,d,c,u;function g(t){return m(t,-e,e)}this.points.forEach(t=>{var e=t.shapeArgs||{},i=this.options.minPointLength,s=t.plotY,o=a.translate(t.high,0,1,0,1);b(o)&&b(s)&&(t.plotHigh=g(o),t.plotLow=g(s),u=t.plotHigh,p=y(t.rectPlotY,t.plotY)-t.plotHigh,Math.abs(p)<i?(d=i-p,p+=d,u-=d/2):p<0&&(p*=-1,u-=p),h&&this.polar?(c=t.barX+n,t.shapeType="arc",t.shapeArgs=this.polar.arc(u+p,u,c,c+t.pointWidth)):(e.height=p,e.y=u,{x:o=0,width:s=0}=e,t.shapeArgs=f(t.shapeArgs,this.crispCol(o,u,s,p)),t.tooltipPos=l.inverted?[a.len+a.pos-l.plotLeft-u-p/2,r.len+r.pos-l.plotTop-o-s/2,p]:[r.left-l.plotLeft+o+s/2,a.pos-l.plotTop+u+p/2,p]))})}}return h.defaultOptions=f(a.defaultOptions,o.defaultOptions,{borderRadius:{where:"all"},pointRange:null,marker:null,states:{hover:{halo:!1}}}),n(h,"afterColumnTranslate",function(){h.prototype.afterColumnTranslate.apply(this)},{order:5}),l(h.prototype,{directTouch:!0,pointClass:t,trackerGroups:["group","dataLabelsGroup"],adjustForMissingColumns:r.adjustForMissingColumns,animate:r.animate,crispCol:r.crispCol,drawGraph:e,drawPoints:r.drawPoints,getSymbol:e,drawTracker:r.drawTracker,getColumnMetrics:r.getColumnMetrics}),i.registerSeriesType("columnrange",h),h}),e(t,"Series/ColumnPyramid/ColumnPyramidSeriesDefaults.js",[],function(){return{}}),e(t,"Series/ColumnPyramid/ColumnPyramidSeries.js",[t["Series/ColumnPyramid/ColumnPyramidSeriesDefaults.js"],t["Core/Series/SeriesRegistry.js"],t["Core/Utilities.js"]],function(t,e,i){var s=e.seriesTypes["column"];const{clamp:N,merge:o,pick:T}=i;class a extends s{translate(){var u=this,g=u.chart,m=u.options,t=u.dense=u.closestPointRange*u.xAxis.transA<2,t=u.borderWidth=T(m.borderWidth,t?0:1),b=u.yAxis,f=m.threshold,y=T(m.minPointLength,5),x=u.getColumnMetrics(),v=x.width,P=u.pointXOffset=x.offset;let S=u.translatedThreshold=b.getThreshold(f),M=u.barW=Math.max(v,1+2*t);g.inverted&&(S-=.5),m.pointPadding&&(M=Math.ceil(M)),super.translate();for(const A of u.points){var k=T(A.yBottom,S),L=999+Math.abs(k),L=N(A.plotY,-L,b.len+L),C=M/2,w=Math.min(L,k),k=Math.max(L,k)-w;let t=A.plotX+P,e,i,s,o,a,r,n,l,h,p,d,c;m.centerInCategory&&(t=u.adjustForMissingColumns(t,v,A,x)),A.barX=t,A.pointWidth=v,A.tooltipPos=g.inverted?[b.len+b.pos-g.plotLeft-L,u.xAxis.len-t-C,k]:[t+C,L+b.pos-g.plotTop,k],e=f+(A.total||A.y),"percent"===m.stacking&&(e=f+(A.y<0)?-100:100),s=b.toPixels(e,!0),o=(i=g.plotHeight-s-(g.plotHeight-S))?C*(w-s)/i:0,a=i?C*(w+k-s)/i:0,n=t-o+C,l=t+o+C,h=t+a+C,p=t-a+C,d=w-y,c=w+k,A.y<0&&(d=w,c=w+k+y),g.inverted&&(o=C*(s-(r=b.width-w))/(i=s-(b.width-S)),a=C*(s-(r-k))/i,n=t+C+o,l=n-2*o,h=t-a+C,p=t+a+C,d=w,c=w+k-y,A.y<0)&&(c=w+k+y),A.shapeType="path",A.shapeArgs={x:n,y:d,width:l-n,height:k,d:[["M",n,d],["L",l,d],["L",h,c],["L",p,c],["Z"]]}}}}return a.defaultOptions=o(s.defaultOptions,t),e.registerSeriesType("columnpyramid",a),a}),e(t,"Series/ErrorBar/ErrorBarSeriesDefaults.js",[],function(){return{color:"#000000",grouping:!1,linkedTo:":previous",tooltip:{pointFormat:'<span style="color:{point.color}">●</span> {series.name}: <b>{point.low}</b> - <b>{point.high}</b><br/>'},whiskerWidth:null}}),e(t,"Series/ErrorBar/ErrorBarSeries.js",[t["Series/BoxPlot/BoxPlotSeries.js"],t["Series/Column/ColumnSeries.js"],t["Series/ErrorBar/ErrorBarSeriesDefaults.js"],t["Core/Series/SeriesRegistry.js"],t["Core/Utilities.js"]],function(t,e,i,s,o){const a=s.seriesTypes["arearange"];var{addEvent:o,merge:r,extend:n}=o;class l extends t{getColumnMetrics(){return this.linkedParent&&this.linkedParent.columnMetrics||e.prototype.getColumnMetrics.call(this)}drawDataLabels(){var t=this.pointValKey;if(a){a.prototype.drawDataLabels.call(this);for(const e of this.points)e.y=e[t]}}toYData(t){return[t.low,t.high]}}return l.defaultOptions=r(t.defaultOptions,i),o(l,"afterTranslate",function(){for(const t of this.points)t.plotLow=t.plotY},{order:0}),n(l.prototype,{pointArrayMap:["low","high"],pointValKey:"high",doQuartiles:!1}),s.registerSeriesType("errorbar",l),l}),e(t,"Series/Gauge/GaugePoint.js",[t["Core/Series/SeriesRegistry.js"]],function(t){var{pointClass:t}=t["series"]["prototype"];class e extends t{setState(t){this.state=t}}return e}),e(t,"Series/Gauge/GaugeSeries.js",[t["Series/Gauge/GaugePoint.js"],t["Core/Globals.js"],t["Core/Series/SeriesRegistry.js"],t["Core/Utilities.js"]],function(t,e,i,s){e=e.noop;const{series:o,seriesTypes:{column:a}}=i,{clamp:c,isNumber:u,extend:r,merge:g,pick:n,pInt:m,defined:b}=s;class l extends o{translate(){const h=this.yAxis,p=this.options,d=h.center;this.generatePoints(),this.points.forEach(t=>{var e=g(p.dial,t.dial),i=m(e.radius)*d[2]/200,s=m(e.baseLength)*i/100,o=m(e.rearLength)*i/100,a=e.baseWidth,r=e.topWidth;let n=p.overshoot,l=h.startAngleRad+h.translate(t.y,void 0,void 0,void 0,!0);!u(n)&&!1!==p.wrap||(n=u(n)?n/180*Math.PI:0,l=c(l,h.startAngleRad-n,h.endAngleRad+n)),l=180*l/Math.PI,t.shapeType="path";e=e.path||[["M",-o,-a/2],["L",s,-a/2],["L",i,-r/2],["L",i,r/2],["L",s,a/2],["L",-o,a/2],["Z"]];t.shapeArgs={d:e,translateX:d[0],translateY:d[1],rotation:l},t.plotX=d[0],t.plotY=d[1],b(t.y)&&h.max-h.min&&(t.percentage=(t.y-h.min)/(h.max-h.min)*100)})}drawPoints(){const a=this,r=a.chart,t=a.yAxis.center,e=a.pivot,n=a.options,i=n.pivot,l=r.renderer;a.points.forEach(t=>{var e=t.graphic,i=t.shapeArgs,s=i.d,o=g(n.dial,t.dial);e?(e.animate(i),i.d=s):t.graphic=l[t.shapeType](i).addClass("highcharts-dial").add(a.group),r.styledMode||t.graphic[e?"animate":"attr"]({stroke:o.borderColor,"stroke-width":o.borderWidth,fill:o.backgroundColor})}),e?e.animate({translateX:t[0],translateY:t[1]}):i&&(a.pivot=l.circle(0,0,i.radius).attr({zIndex:2}).addClass("highcharts-pivot").translate(t[0],t[1]).add(a.group),r.styledMode||a.pivot.attr({fill:i.backgroundColor,stroke:i.borderColor,"stroke-width":i.borderWidth}))}animate(t){const i=this;t||i.points.forEach(t=>{var e=t.graphic;e&&(e.attr({rotation:180*i.yAxis.startAngleRad/Math.PI}),e.animate({rotation:t.shapeArgs.rotation},i.options.animation))})}render(){this.group=this.plotGroup("group","series",this.visible?"inherit":"hidden",this.options.zIndex,this.chart.seriesGroup),o.prototype.render.call(this),this.group.clip(this.chart.clipRect)}setData(t,e){o.prototype.setData.call(this,t,!1),this.processData(),this.generatePoints(),n(e,!0)&&this.chart.redraw()}hasData(){return!!this.points.length}}return l.defaultOptions=g(o.defaultOptions,{dataLabels:{borderColor:"#cccccc",borderRadius:3,borderWidth:1,crop:!1,defer:!1,enabled:!0,verticalAlign:"top",y:15,zIndex:2},dial:{backgroundColor:"#000000",baseLength:"70%",baseWidth:3,borderColor:"#cccccc",borderWidth:0,radius:"80%",rearLength:"10%",topWidth:1},pivot:{radius:5,borderWidth:0,borderColor:"#cccccc",backgroundColor:"#000000"},tooltip:{headerFormat:""},showInLegend:!1}),r(l.prototype,{angular:!0,directTouch:!0,drawGraph:e,drawTracker:a.prototype.drawTracker,fixedBox:!0,forceDL:!0,noSharedTooltip:!0,pointClass:t,trackerGroups:["group","dataLabelsGroup"]}),i.registerSeriesType("gauge",l),l}),e(t,"Series/DragNodesComposition.js",[t["Core/Globals.js"],t["Core/Utilities.js"]],function(t,e){const i=t["composed"],{addEvent:a,pushUnique:s}=e;function o(){const i=this;let t,s,o;i.container&&(t=a(i.container,"mousedown",t=>{const e=i.hoverPoint;e&&e.series&&e.series.hasDraggableNodes&&e.series.options.draggable&&(e.series.onMouseDown(e,t),s=a(i.container,"mousemove",t=>e&&e.series&&e.series.onMouseMove(e,t)),o=a(i.container.ownerDocument,"mouseup",t=>(s(),o(),e&&e.series&&e.series.onMouseUp(e,t))))})),a(i,"destroy",function(){t()})}return{compose:function r(t){s(i,r)&&a(t,"load",o)},onMouseDown:function(t,e){e=this.chart.pointer.normalize(e),t.fixedPosition={chartX:e.chartX,chartY:e.chartY,plotX:t.plotX,plotY:t.plotY},t.inDragMode=!0},onMouseMove:function(t,e){var i,s,o;t.fixedPosition&&t.inDragMode&&(e=(i=this.chart).pointer.normalize(e),o=t.fixedPosition.chartX-e.chartX,e=t.fixedPosition.chartY-e.chartY,s=i.graphLayoutsLookup,5<Math.abs(o)||5<Math.abs(e))&&(o=t.fixedPosition.plotX-o,e=t.fixedPosition.plotY-e,i.isInsidePlot(o,e))&&(t.plotX=o,t.plotY=e,t.hasDragged=!0,this.redrawHalo(t),s.forEach(t=>{t.restartSimulation()}))},onMouseUp:function(t,e){t.fixedPosition&&(t.hasDragged&&(this.layout.enableSimulation?this.layout.start():this.chart.redraw()),t.inDragMode=t.hasDragged=!1,this.options.fixedDraggable||delete t.fixedPosition)},redrawHalo:function(t){t&&this.halo&&this.halo.attr({d:t.haloPath(this.options.states.hover.halo.size)})}}}),e(t,"Series/GraphLayoutComposition.js",[t["Core/Animation/AnimationUtilities.js"],t["Core/Globals.js"],t["Core/Utilities.js"]],function(t,e,i){const s=t["setAnimation"],o=e["composed"],{addEvent:a,pushUnique:r}=i;function n(){this.graphLayoutsLookup&&(this.graphLayoutsLookup.forEach(t=>{t.updateSimulation()}),this.redraw())}function l(){this.graphLayoutsLookup&&(this.graphLayoutsLookup.forEach(t=>{t.updateSimulation(!1)}),this.redraw())}function h(){this.graphLayoutsLookup&&this.graphLayoutsLookup.forEach(t=>{t.stop()})}function p(){let e,i=!1;var t=t=>{t.maxIterations--&&isFinite(t.temperature)&&!t.isStable()&&!t.enableSimulation&&(t.beforeStep&&t.beforeStep(),t.step(),e=!1,i=!0)};if(this.graphLayoutsLookup){for(s(!1,this),this.graphLayoutsLookup.forEach(t=>t.start());!e;)e=!0,this.graphLayoutsLookup.forEach(t);i&&this.series.forEach(t=>{t&&t.layout&&t.render()})}}return{compose:function d(t){r(o,d)&&(a(t,"afterPrint",n),a(t,"beforePrint",l),a(t,"predraw",h),a(t,"render",p))},integrations:{},layouts:{}}}),e(t,"Series/PackedBubble/PackedBubblePoint.js",[t["Core/Chart/Chart.js"],t["Core/Series/Point.js"],t["Core/Series/SeriesRegistry.js"]],function(e,i,t){var{prototype:{pointClass:t}}=t["seriesTypes"]["bubble"];class s extends t{destroy(){return this.series.layout&&this.series.layout.removeElementFromCollection(this,this.series.layout.nodes),i.prototype.destroy.apply(this,arguments)}firePointEvent(){var t,e=this.series.options;this.isParentNode&&e.parentNode?(t=e.allowPointSelect,e.allowPointSelect=e.parentNode.allowPointSelect,i.prototype.firePointEvent.apply(this,arguments),e.allowPointSelect=t):i.prototype.firePointEvent.apply(this,arguments)}select(){var t=this.series.chart;this.isParentNode?(t.getSelectedPoints=t.getSelectedParentNodes,i.prototype.select.apply(this,arguments),t.getSelectedPoints=e.prototype.getSelectedPoints):i.prototype.select.apply(this,arguments)}}return s}),e(t,"Series/PackedBubble/PackedBubbleSeriesDefaults.js",[t["Core/Utilities.js"]],function(t){const i=t["isNumber"];return{minSize:"10%",maxSize:"50%",sizeBy:"area",zoneAxis:"y",crisp:!1,tooltip:{pointFormat:"Value: {point.value}"},draggable:!0,useSimulation:!0,parentNode:{allowPointSelect:!1},dataLabels:{formatter:function(){var t=this.series.chart["numberFormatter"],e=this.point["value"];return i(e)?t(e,-1):""},parentNodeFormatter:function(){return this.name},parentNodeTextPath:{enabled:!0},padding:0,style:{transition:"opacity 2000ms"}},layoutAlgorithm:{initialPositions:"circle",initialPositionRadius:20,bubblePadding:5,parentNodeLimit:!1,seriesInteraction:!0,dragBetweenSeries:!1,parentNodeOptions:{maxIterations:400,gravitationalConstant:.03,maxSpeed:50,initialPositionRadius:100,seriesInteraction:!0,marker:{fillColor:null,fillOpacity:1,lineWidth:null,lineColor:null,symbol:"circle"}},enableSimulation:!0,type:"packedbubble",integration:"packedbubble",maxIterations:1e3,splitSeries:!1,maxSpeed:5,gravitationalConstant:.01,friction:-.981}}}),e(t,"Series/Networkgraph/VerletIntegration.js",[],function(){return{attractive:function(t,e,i){var s=t.getMass(),o=-i.x*e*this.diffTemperature,i=-i.y*e*this.diffTemperature;t.fromNode.fixedPosition||(t.fromNode.plotX-=o*s.fromNode/t.fromNode.degree,t.fromNode.plotY-=i*s.fromNode/t.fromNode.degree),t.toNode.fixedPosition||(t.toNode.plotX+=o*s.toNode/t.toNode.degree,t.toNode.plotY+=i*s.toNode/t.toNode.degree)},attractiveForceFunction:function(t,e){return(e-t)/t},barycenter:function(){let t=this.options.gravitationalConstant,e=this.barycenter.xFactor,i=this.barycenter.yFactor;e=(e-(this.box.left+this.box.width)/2)*t,i=(i-(this.box.top+this.box.height)/2)*t,this.nodes.forEach(function(t){t.fixedPosition||(t.plotX-=e/t.mass/t.degree,t.plotY-=i/t.mass/t.degree)})},getK:function(t){return Math.pow(t.box.width*t.box.height/t.nodes.length,.5)},integrate:function(t,e){var i=-t.options.friction,s=t.options.maxSpeed,o=e.prevX,a=e.prevY,o=(e.plotX+e.dispX-o)*i,a=(e.plotY+e.dispY-a)*i,r=(i=Math.abs)(o)/(o||1),i=i(a)/(a||1),o=r*Math.min(s,Math.abs(o)),a=i*Math.min(s,Math.abs(a));e.prevX=e.plotX+e.dispX,e.prevY=e.plotY+e.dispY,e.plotX+=o,e.plotY+=a,e.temperature=t.vectorLength({x:o,y:a})},repulsive:function(t,e,i){e=e*this.diffTemperature/t.mass/t.degree,t.fixedPosition||(t.plotX+=i.x*e,t.plotY+=i.y*e)},repulsiveForceFunction:function(t,e){return(e-t)/t*(t<e?1:0)}}}),e(t,"Series/PackedBubble/PackedBubbleIntegration.js",[t["Core/Globals.js"],t["Series/Networkgraph/VerletIntegration.js"]],function(t,e){t=t.noop;return{barycenter:function(){var t=this.options.gravitationalConstant,e=this.box,i=this.nodes;let s,o;for(const a of i)o=this.options.splitSeries&&!a.isParentNode?(s=a.series.parentNode.plotX,a.series.parentNode.plotY):(s=e.width/2,e.height/2),a.fixedPosition||(a.plotX-=(a.plotX-s)*t/(a.mass*Math.sqrt(i.length)),a.plotY-=(a.plotY-o)*t/(a.mass*Math.sqrt(i.length)))},getK:t,integrate:e.integrate,repulsive:function(t,e,i,s){var e=e*this.diffTemperature/t.mass/t.degree,o=i.x*e,i=i.y*e;t.fixedPosition||(t.plotX+=o,t.plotY+=i),s.fixedPosition||(s.plotX-=o,s.plotY-=i)},repulsiveForceFunction:function(t,e,i,s){return Math.min(t,(i.marker.radius+s.marker.radius)/2)}}}),e(t,"Series/Networkgraph/EulerIntegration.js",[],function(){return{attractive:function(t,e,i,s){var o=t.getMass(),a=i.x/s*e,i=i.y/s*e;t.fromNode.fixedPosition||(t.fromNode.dispX-=a*o.fromNode/t.fromNode.degree,t.fromNode.dispY-=i*o.fromNode/t.fromNode.degree),t.toNode.fixedPosition||(t.toNode.dispX+=a*o.toNode/t.toNode.degree,t.toNode.dispY+=i*o.toNode/t.toNode.degree)},attractiveForceFunction:function(t,e){return t*t/e},barycenter:function(){const i=this.options.gravitationalConstant,s=this.barycenter.xFactor,o=this.barycenter.yFactor;this.nodes.forEach(function(t){var e;t.fixedPosition||(e=(e=t.getDegree())*(1+e/2),t.dispX+=(s-t.plotX)*i*e/t.degree,t.dispY+=(o-t.plotY)*i*e/t.degree)})},getK:function(t){return Math.pow(t.box.width*t.box.height/t.nodes.length,.3)},integrate:function(t,e){var i;e.dispX+=e.dispX*t.options.friction,e.dispY+=e.dispY*t.options.friction,0!==(i=e.temperature=t.vectorLength({x:e.dispX,y:e.dispY}))&&(e.plotX+=e.dispX/i*Math.min(Math.abs(e.dispX),t.temperature),e.plotY+=e.dispY/i*Math.min(Math.abs(e.dispY),t.temperature))},repulsive:function(t,e,i,s){t.dispX+=i.x/s*e/t.degree,t.dispY+=i.y/s*e/t.degree},repulsiveForceFunction:function(t,e){return e*e/t}}}),e(t,"Series/Networkgraph/QuadTreeNode.js",[],function(){class i{constructor(t){this.body=!1,this.isEmpty=!1,this.isInternal=!1,this.nodes=[],this.box=t,this.boxSize=Math.min(t.width,t.height)}divideBox(){var t=this.box.width/2,e=this.box.height/2;this.nodes[0]=new i({left:this.box.left,top:this.box.top,width:t,height:e}),this.nodes[1]=new i({left:this.box.left+t,top:this.box.top,width:t,height:e}),this.nodes[2]=new i({left:this.box.left+t,top:this.box.top+e,width:t,height:e}),this.nodes[3]=new i({left:this.box.left,top:this.box.top+e,width:t,height:e})}getBoxPosition(t){var e=t.plotX<this.box.left+this.box.width/2,t=t.plotY<this.box.top+this.box.height/2;let i;return i=e?t?0:3:t?1:2}insert(t,e){this.isInternal?this.nodes[this.getBoxPosition(t)].insert(t,e-1):(this.isEmpty=!1,this.body?e?(this.isInternal=!0,this.divideBox(),!0!==this.body&&(this.nodes[this.getBoxPosition(this.body)].insert(this.body,e-1),this.body=!0),this.nodes[this.getBoxPosition(t)].insert(t,e-1)):((e=new i({top:t.plotX||NaN,left:t.plotY||NaN,width:.1,height:.1})).body=t,e.isInternal=!1,this.nodes.push(e)):(this.isInternal=!1,this.body=t))}updateMassAndCenter(){let t=0,e=0,i=0;if(this.isInternal){for(const s of this.nodes)s.isEmpty||(t+=s.mass,e+=s.plotX*s.mass,i+=s.plotY*s.mass);e/=t,i/=t}else this.body&&(t=this.body.mass,e=this.body.plotX,i=this.body.plotY);this.mass=t,this.plotX=e,this.plotY=i}}return i}),e(t,"Series/Networkgraph/QuadTree.js",[t["Series/Networkgraph/QuadTreeNode.js"]],function(o){class t{constructor(t,e,i,s){this.box={left:t,top:e,width:i,height:s},this.maxDepth=25,this.root=new o(this.box),this.root.isInternal=!0,this.root.isRoot=!0,this.root.divideBox()}calculateMassAndCenter(){this.visitNodeRecursive(null,null,function(t){t.updateMassAndCenter()})}insertNodes(t){for(const e of t)this.root.insert(e,this.maxDepth)}visitNodeRecursive(t,e,i){let s;if(t=t||this.root,!1!==(s=t===this.root&&e?e(t):s)){for(const o of t.nodes){if(o.isInternal){if(!1===(s=e?e(o):s))continue;this.visitNodeRecursive(o,e,i)}else o.body&&e&&e(o.body);i&&i(o)}t===this.root&&i&&i(t)}}}return t}),e(t,"Series/Networkgraph/ReingoldFruchtermanLayout.js",[t["Series/Networkgraph/EulerIntegration.js"],t["Core/Globals.js"],t["Series/GraphLayoutComposition.js"],t["Series/Networkgraph/QuadTree.js"],t["Core/Utilities.js"],t["Series/Networkgraph/VerletIntegration.js"]],function(e,t,i,s,o,a){const r=t["win"],{clamp:n,defined:l,isFunction:h,fireEvent:p,pick:d}=o;class c{constructor(){this.box={},this.currentStep=0,this.initialRendering=!0,this.links=[],this.nodes=[],this.series=[],this.simulation=!1}static compose(t){i.compose(t),i.integrations.euler=e,i.integrations.verlet=a,i.layouts["reingold-fruchterman"]=c}init(t){this.options=t,this.nodes=[],this.links=[],this.series=[],this.box={x:0,y:0,width:0,height:0},this.setInitialRendering(!0),this.integration=i.integrations[t.integration],this.enableSimulation=t.enableSimulation,this.attractiveForce=d(t.attractiveForce,this.integration.attractiveForceFunction),this.repulsiveForce=d(t.repulsiveForce,this.integration.repulsiveForceFunction),this.approximation=t.approximation}updateSimulation(t){this.enableSimulation=d(t,this.options.enableSimulation)}start(){var t=this,e=this.series,i=this.options;t.currentStep=0,t.forces=e[0]&&e[0].forces||[],t.chart=e[0]&&e[0].chart,t.initialRendering&&(t.initPositions(),e.forEach(function(t){t.finishedAnimating=!0,t.render()})),t.setK(),t.resetSimulation(i),t.enableSimulation&&t.step()}step(){var t=this.series;this.currentStep++,"barnes-hut"===this.approximation&&(this.createQuadTree(),this.quadTree.calculateMassAndCenter());for(const e of this.forces||[])this[e+"Forces"](this.temperature);if(this.applyLimits(),this.temperature=this.coolDown(this.startTemperature,this.diffTemperature,this.currentStep),this.prevSystemTemperature=this.systemTemperature,this.systemTemperature=this.getSystemTemperature(),this.enableSimulation){for(const i of t)i.chart&&i.render();this.maxIterations--&&isFinite(this.temperature)&&!this.isStable()?(this.simulation&&r.cancelAnimationFrame(this.simulation),this.simulation=r.requestAnimationFrame(()=>this.step())):(this.simulation=!1,this.series.forEach(t=>{p(t,"afterSimulation")}))}}stop(){this.simulation&&r.cancelAnimationFrame(this.simulation)}setArea(t,e,i,s){this.box={left:t,top:e,width:i,height:s}}setK(){this.k=this.options.linkLength||this.integration.getK(this)}addElementsToCollection(t,e){for(const i of t)-1===e.indexOf(i)&&e.push(i)}removeElementFromCollection(t,e){t=e.indexOf(t);-1!==t&&e.splice(t,1)}clear(){this.nodes.length=0,this.links.length=0,this.series.length=0,this.resetSimulation()}resetSimulation(){this.forcedStop=!1,this.systemTemperature=0,this.setMaxIterations(),this.setTemperature(),this.setDiffTemperature()}restartSimulation(){this.simulation?this.resetSimulation():(this.setInitialRendering(!1),this.enableSimulation?this.start():this.setMaxIterations(1),this.chart&&this.chart.redraw(),this.setInitialRendering(!0))}setMaxIterations(t){this.maxIterations=d(t,this.options.maxIterations)}setTemperature(){this.temperature=this.startTemperature=Math.sqrt(this.nodes.length)}setDiffTemperature(){this.diffTemperature=this.startTemperature/(this.options.maxIterations+1)}setInitialRendering(t){this.initialRendering=t}createQuadTree(){this.quadTree=new s(this.box.left,this.box.top,this.box.width,this.box.height),this.quadTree.insertNodes(this.nodes)}initPositions(){var t=this.options.initialPositions;if(h(t)){t.call(this);for(const e of this.nodes)l(e.prevX)||(e.prevX=e.plotX),l(e.prevY)||(e.prevY=e.plotY),e.dispX=0,e.dispY=0}else"circle"===t?this.setCircularPositions():this.setRandomPositions()}setCircularPositions(){const i=this.box,t=this.nodes,e=t.length+1,s=2*Math.PI/e,o=t.filter(function(t){return 0===t.linksTo.length}),a={},r=this.options.initialPositionRadius,n=t=>{for(const e of t.linksFrom||[])a[e.toNode.id]||(a[e.toNode.id]=!0,l.push(e.toNode),n(e.toNode))};let l=[];for(const p of o)l.push(p),n(p);if(l.length)for(const h of t)-1===l.indexOf(h)&&l.push(h);else l=t;let h;for(let t=0,e=l.length;t<e;++t)(h=l[t]).plotX=h.prevX=d(h.plotX,i.width/2+r*Math.cos(t*s)),h.plotY=h.prevY=d(h.plotY,i.height/2+r*Math.sin(t*s)),h.dispX=0,h.dispY=0}setRandomPositions(){var i,s=this.box,o=this.nodes,a=o.length+1,r=t=>{t=t*t/Math.PI;return t-=Math.floor(t)};for(let t=0,e=o.length;t<e;++t)(i=o[t]).plotX=i.prevX=d(i.plotX,s.width*r(t)),i.plotY=i.prevY=d(i.plotY,s.height*r(a+t)),i.dispX=0,i.dispY=0}force(t,...e){this.integration[t].apply(this,e)}barycenterForces(){this.getBarycenter(),this.force("barycenter")}getBarycenter(){let t=0,e=0,i=0;for(const s of this.nodes)e+=s.plotX*s.mass,i+=s.plotY*s.mass,t+=s.mass;return this.barycenter={x:e,y:i,xFactor:e/t,yFactor:i/t},this.barycenter}barnesHutApproximation(t,e){var i=this.getDistXY(t,e),s=this.vectorLength(i);let o,a;return t!==e&&0!==s&&(e.isInternal?o=!(e.boxSize/s<this.options.theta&&0!==s&&(a=this.repulsiveForce(s,this.k),this.force("repulsive",t,a*e.mass,i,s),1)):(a=this.repulsiveForce(s,this.k),this.force("repulsive",t,a*e.mass,i,s))),o}repulsiveForces(){var t,e,i;if("barnes-hut"===this.approximation)for(const s of this.nodes)this.quadTree.visitNodeRecursive(null,t=>this.barnesHutApproximation(s,t));else for(const o of this.nodes)for(const a of this.nodes)o===a||o.fixedPosition||(i=this.getDistXY(o,a),0!==(e=this.vectorLength(i))&&(t=this.repulsiveForce(e,this.k),this.force("repulsive",o,t*a.mass,i,e)))}attractiveForces(){var t,e,i;for(const s of this.links)s.fromNode&&s.toNode&&(t=this.getDistXY(s.fromNode,s.toNode),0!==(e=this.vectorLength(t)))&&(i=this.attractiveForce(e,this.k),this.force("attractive",s,i,t,e))}applyLimits(){for(const t of this.nodes){if(t.fixedPosition)return;this.integration.integrate(this,t),this.applyLimitBox(t,this.box),t.dispX=0,t.dispY=0}}applyLimitBox(t,e){var i=t.radius;t.plotX=n(t.plotX,e.left+i,e.width-i),t.plotY=n(t.plotY,e.top+i,e.height-i)}coolDown(t,e,i){return t-e*i}isStable(){return Math.abs(this.systemTemperature-this.prevSystemTemperature)<1e-5||this.temperature<=0}getSystemTemperature(){let t=0;for(const e of this.nodes)t+=e.temperature;return t}vectorLength(t){return Math.sqrt(t.x*t.x+t.y*t.y)}getDistR(t,e){t=this.getDistXY(t,e);return this.vectorLength(t)}getDistXY(t,e){var i=t.plotX-e.plotX,t=t.plotY-e.plotY;return{x:i,y:t,absX:Math.abs(i),absY:Math.abs(t)}}}return c}),e(t,"Series/PackedBubble/PackedBubbleLayout.js",[t["Series/GraphLayoutComposition.js"],t["Core/Globals.js"],t["Series/PackedBubble/PackedBubbleIntegration.js"],t["Series/Networkgraph/ReingoldFruchtermanLayout.js"],t["Core/Utilities.js"]],function(e,t,i,s,o){const a=t["composed"],{addEvent:r,pick:h,pushUnique:n}=o;function l(){const t=this.series,e=[];return t.forEach(t=>{t.parentNode&&t.parentNode.selected&&e.push(t.parentNode)}),e}function p(){this.allDataPoints&&delete this.allDataPoints}class d extends s{constructor(){super(...arguments),this.index=NaN,this.nodes=[],this.series=[]}static compose(t){s.compose(t),e.integrations.packedbubble=i,e.layouts.packedbubble=d,n(a,this.compose)&&(r(t,"beforeRedraw",p),t.prototype.getSelectedParentNodes=l)}beforeStep(){this.options.marker&&this.series.forEach(t=>{t&&t.calculateParentRadius()})}isStable(){var t=Math.abs(this.prevSystemTemperature-this.systemTemperature),e=10*this.systemTemperature/Math.sqrt(this.nodes.length);return Math.abs(e)<1&&t<1e-5||this.temperature<=0}setCircularPositions(){var t=this.box,e=this.nodes,i=e.length+1,s=2*Math.PI/i,o=this.options.initialPositionRadius;let a,r,n=0;for(const l of e)r=this.options.splitSeries&&!l.isParentNode?(a=l.series.parentNode.plotX,l.series.parentNode.plotY):(a=t.width/2,t.height/2),l.plotX=l.prevX=h(l.plotX,a+o*Math.cos(l.index||n*s)),l.plotY=l.prevY=h(l.plotY,r+o*Math.sin(l.index||n*s)),l.dispX=0,l.dispY=0,n++}repulsiveForces(){const i=this,s=i.options.bubblePadding;let o,a,r;i.nodes.forEach(e=>{e.degree=e.mass,e.neighbours=0,i.nodes.forEach(t=>{o=0,e===t||e.fixedPosition||!i.options.seriesInteraction&&e.series!==t.series||(r=i.getDistXY(e,t),(a=i.vectorLength(r)-(e.marker.radius+t.marker.radius+s))<0&&(e.degree+=.01,e.neighbours++,o=i.repulsiveForce(-a/Math.sqrt(e.neighbours),i.k,e,t)),i.force("repulsive",e,o*t.mass,r,t,a))})})}applyLimitBox(t,e){var i,s;this.options.splitSeries&&!t.isParentNode&&this.options.parentNodeLimit&&(i=this.getDistXY(t,t.series.parentNode),(s=t.series.parentNodeRadius-t.marker.radius-this.vectorLength(i))<0)&&s>-2*t.marker.radius&&(t.plotX-=.01*i.x,t.plotY-=.01*i.y),super.applyLimitBox(t,e)}}return e.layouts.packedbubble=d}),e(t,"Series/SimulationSeriesUtilities.js",[t["Core/Utilities.js"],t["Core/Animation/AnimationUtilities.js"]],function(t,e){const{merge:s,syncTimeout:i}=t,o=e["animObject"];return{initDataLabels:function(){var t,e=this,i=e.options.dataLabels;return e.dataLabelsGroup?(e.dataLabelsGroup.attr(s({opacity:1},this.getPlotBox("data-labels"))),e.dataLabelsGroup):(t=this.initDataLabelsGroup(),!e.chart.styledMode&&i?.style&&t.css(i.style),t.attr({opacity:0}),e.visible&&t.show(),t)},initDataLabelsDefer:function(){var t=this.options.dataLabels;t?.defer&&this.options.layoutAlgorithm?.enableSimulation?i(()=>{this.deferDataLabels=!1},t?o(t.animation).defer:0):this.deferDataLabels=!1}}}),e(t,"Series/PackedBubble/PackedBubbleSeries.js",[t["Core/Color/Color.js"],t["Series/DragNodesComposition.js"],t["Series/GraphLayoutComposition.js"],t["Core/Globals.js"],t["Series/PackedBubble/PackedBubblePoint.js"],t["Series/PackedBubble/PackedBubbleSeriesDefaults.js"],t["Series/PackedBubble/PackedBubbleLayout.js"],t["Core/Series/SeriesRegistry.js"],t["Series/SimulationSeriesUtilities.js"],t["Core/Utilities.js"]],function(t,r,n,e,i,s,o,a,l,h){const p=t["parse"];t=e.noop;const{series:{prototype:d},seriesTypes:{bubble:c}}=a,{initDataLabels:u,initDataLabelsDefer:g}=l,{addEvent:m,clamp:b,defined:f,extend:y,fireEvent:x,isArray:v,isNumber:P,merge:S,pick:M}=h;class k extends c{constructor(){super(...arguments),this.parentNodeMass=0,this.deferDataLabels=!0}static compose(t,e,i,s){c.compose(t,e,i,s),r.compose(e),o.compose(e)}accumulateAllPoints(){var e,i=[];for(const s of this.chart.series)if(s.is("packedbubble")&&s.reserveSpace()){e=s.yData||[];for(let t=0;t<e.length;t++)i.push([null,null,e[t],s.index,t,{id:t,marker:{radius:0}}])}return i}addLayout(){var t=this.options.layoutAlgorithm=this.options.layoutAlgorithm||{},e=t.type||"packedbubble",i=this.chart.options.chart;let s=this.chart.graphLayoutsStorage,o=this.chart.graphLayoutsLookup,a;s||(this.chart.graphLayoutsStorage=s={},this.chart.graphLayoutsLookup=o=[]),(a=s[e])||(t.enableSimulation=f(i.forExport)?!i.forExport:t.enableSimulation,s[e]=a=new n.layouts[e],a.init(t),o.splice(a.index,0,a)),this.layout=a,this.points.forEach(t=>{t.mass=2,t.degree=1,t.collisionNmb=1}),a.setArea(0,0,this.chart.plotWidth,this.chart.plotHeight),a.addElementsToCollection([this],a.series),a.addElementsToCollection(this.points,a.nodes)}addSeriesLayout(){var t=this.options.layoutAlgorithm=this.options.layoutAlgorithm||{},e=t.type||"packedbubble",i=this.chart.graphLayoutsStorage,s=this.chart.graphLayoutsLookup,t=S(t,t.parentNodeOptions,{enableSimulation:this.layout.options.enableSimulation});let o=i[e+"-series"];o||(i[e+"-series"]=o=new n.layouts[e],o.init(t),s.splice(o.index,0,o)),this.parentNodeLayout=o,this.createParentNodes()}calculateParentRadius(){var t=this.seriesBox();this.parentNodeRadius=b(Math.sqrt(2*this.parentNodeMass/Math.PI)+20,20,t?Math.max(Math.sqrt(Math.pow(t.width,2)+Math.pow(t.height,2))/2+20,20):Math.sqrt(2*this.parentNodeMass/Math.PI)+20),this.parentNode&&(this.parentNode.marker.radius=this.parentNode.radius=this.parentNodeRadius)}calculateZExtremes(){var t=this.chart.series;let e=this.options.zMin,i=this.options.zMax,s=Infinity,o=-Infinity;return e&&i||(t.forEach(t=>{t.yData.forEach(t=>{f(t)&&(t>o&&(o=t),t<s)&&(s=t)})}),e=M(e,s),i=M(i,o)),[e,i]}checkOverlap(t,e){var i=t[0]-e[0],s=t[1]-e[1],t=t[2]+e[2];return Math.sqrt(i*i+s*s)-Math.abs(t)<-.001}createParentNodes(){var t=this.pointClass,e=this.chart,i=this.parentNodeLayout,s=this.layout.options;let o,a=this.parentNode,r={radius:this.parentNodeRadius,lineColor:this.color,fillColor:p(this.color).brighten(.4).get()};s.parentNodeOptions&&(r=S(s.parentNodeOptions.marker||{},r)),this.parentNodeMass=0,this.points.forEach(t=>{this.parentNodeMass+=Math.PI*Math.pow(t.marker.radius,2)}),this.calculateParentRadius(),i.nodes.forEach(t=>{t.seriesIndex===this.index&&(o=!0)}),i.setArea(0,0,e.plotWidth,e.plotHeight),o||(a=a||new t(this,{mass:this.parentNodeRadius/2,marker:r,dataLabels:{inside:!1},states:{normal:{marker:r},hover:{marker:r}},dataLabelOnNull:!0,degree:this.parentNodeRadius,isParentNode:!0,seriesIndex:this.index}),this.parentNode&&(a.plotX=this.parentNode.plotX,a.plotY=this.parentNode.plotY),this.parentNode=a,i.addElementsToCollection([this],i.series),i.addElementsToCollection([a],i.nodes))}deferLayout(){var t=this.options.layoutAlgorithm;this.visible&&(this.addLayout(),t.splitSeries)&&this.addSeriesLayout()}destroy(){this.chart.graphLayoutsLookup&&this.chart.graphLayoutsLookup.forEach(t=>{t.removeElementFromCollection(this,t.series)},this),this.parentNode&&this.parentNodeLayout&&(this.parentNodeLayout.removeElementFromCollection(this.parentNode,this.parentNodeLayout.nodes),this.parentNode.dataLabel)&&(this.parentNode.dataLabel=this.parentNode.dataLabel.destroy()),d.destroy.apply(this,arguments)}drawDataLabels(){this.deferDataLabels||(d.drawDataLabels.call(this,this.points),this.parentNode&&(this.parentNode.formatPrefix="parentNode",d.drawDataLabels.call(this,[this.parentNode])))}drawGraph(){var t,e,i;this.layout&&this.layout.options.splitSeries&&(t=this.chart,e={fill:(e=this.layout.options.parentNodeOptions.marker).fillColor||p(this.color).brighten(.4).get(),opacity:e.fillOpacity,stroke:e.lineColor||this.color,"stroke-width":M(e.lineWidth,this.options.lineWidth)},i={},this.parentNodesGroup=this.plotGroup("parentNodesGroup","parentNode",this.visible?"inherit":"hidden",.1,t.seriesGroup),this.group?.attr({zIndex:2}),this.calculateParentRadius(),this.parentNode)&&f(this.parentNode.plotX)&&f(this.parentNode.plotY)&&f(this.parentNodeRadius)&&(i=S({x:this.parentNode.plotX-this.parentNodeRadius,y:this.parentNode.plotY-this.parentNodeRadius,width:2*this.parentNodeRadius,height:2*this.parentNodeRadius},e),this.parentNode.graphic||(this.graph=this.parentNode.graphic=t.renderer.symbol(e.symbol).add(this.parentNodesGroup)),this.parentNode.graphic.attr(i))}drawTracker(){const e=this.parentNode;var t;super.drawTracker(),e&&(t=v(e.dataLabels)?e.dataLabels:e.dataLabel?[e.dataLabel]:[],e.graphic&&(e.graphic.element.point=e),t.forEach(t=>{t.div?t.div.point=e:t.element.point=e}))}getPointRadius(){const t=this.chart,e=t.plotWidth,i=t.plotHeight,s=this.options,o=s.useSimulation,a=Math.min(e,i),r={},n=[],l=t.allDataPoints||[],h=l.length;let p,d,c,u;["minSize","maxSize"].forEach(t=>{var e=parseInt(s[t],10),i=/%$/.test(s[t]);r[t]=i?a*e/100:e*Math.sqrt(h)}),t.minRadius=p=r.minSize/Math.sqrt(h),t.maxRadius=d=r.maxSize/Math.sqrt(h);const g=o?this.calculateZExtremes():[p,d];l.forEach((t,e)=>{c=o?b(t[2],g[0],g[1]):t[2],0===(u=this.getRadius(g[0],g[1],p,d,c))&&(u=null),l[e][2]=u,n.push(u)}),this.radii=n}init(){return d.init.apply(this,arguments),g.call(this),this.eventsToUnbind.push(m(this,"updatedData",function(){this.chart.series.forEach(t=>{t.type===this.type&&(t.isDirty=!0)},this)})),this}onMouseUp(t){const s=t;if(s.fixedPosition&&!s.removed){const o=this.layout,a=this.parentNodeLayout;let e,i;a&&o.options.dragBetweenSeries&&a.nodes.forEach(t=>{s&&s.marker&&t!==s.series.parentNode&&(e=o.getDistXY(s,t),(i=o.vectorLength(e)-t.marker.radius-s.marker.radius)<0)&&(t.series.addPoint(S(s.options,{plotX:s.plotX,plotY:s.plotY}),!1),o.removeElementFromCollection(s,o.nodes),s.remove())}),r.onMouseUp.apply(this,arguments)}}placeBubbles(t){var e=this.checkOverlap,i=this.positionBubble,s=[];let o=1,a=0,r=0,n,l=[],h;var p=t.sort((t,e)=>e[2]-t[2]);if(p.length){if(s.push([[0,0,p[0][2],p[0][3],p[0][4]]]),1<p.length)for(s.push([[0,0-p[1][2]-p[0][2],p[1][2],p[1][3],p[1][4]]]),h=2;h<p.length;h++)p[h][2]=p[h][2]||1,e(n=i(s[o][a],s[o-1][r],p[h]),s[o][0])?(s.push([]),r=0,s[o+1].push(i(s[o][a],s[o][0],p[h])),o++,a=0):1<o&&s[o-1][r+1]&&e(n,s[o-1][r+1])?(r++,s[o].push(i(s[o][a],s[o-1][r],p[h])),a++):(a++,s[o].push(n));this.chart.stages=s,this.chart.rawPositions=[].concat.apply([],s),this.resizeRadius(),l=this.chart.rawPositions}return l}pointAttribs(t,e){var i=this.options,s=t&&t.isParentNode;let o=i.marker;s=(o=s&&i.layoutAlgorithm&&i.layoutAlgorithm.parentNodeOptions?i.layoutAlgorithm.parentNodeOptions.marker:o).fillOpacity,i=d.pointAttribs.call(this,t,e);return 1!==s&&(i["fill-opacity"]=s),i}positionBubble(t,e,i){var s=Math.sqrt,o=Math.asin,a=Math.acos,r=Math.pow,n=Math.abs,s=s(r(t[0]-e[0],2)+r(t[1]-e[1],2)),r=a((r(s,2)+r(i[2]+e[2],2)-r(i[2]+t[2],2))/(2*(i[2]+e[2])*s)),a=o(n(t[0]-e[0])/s),n=(t[1]-e[1]<0?0:Math.PI)+r+a*((t[0]-e[0])*(t[1]-e[1])<0?1:-1),s=Math.cos(n),o=Math.sin(n);return[e[0]+(e[2]+i[2])*o,e[1]-(e[2]+i[2])*s,i[2],i[3],i[4]]}render(){const e=[];d.render.apply(this,arguments),this.options.dataLabels.allowOverlap||(this.data.forEach(t=>{v(t.dataLabels)&&t.dataLabels.forEach(t=>{e.push(t)})}),this.options.useSimulation&&this.chart.hideOverlappingLabels(e))}resizeRadius(){var t=this.chart,e=t.rawPositions,i=Math.min,s=Math.max,o=t.plotLeft,a=t.plotTop,r=t.plotHeight,n=t.plotWidth;let l,h,p,d,c;l=p=Number.POSITIVE_INFINITY,h=d=Number.NEGATIVE_INFINITY;for(const m of e)c=m[2],l=i(l,m[0]-c),h=s(h,m[0]+c),p=i(p,m[1]-c),d=s(d,m[1]+c);var u=[h-l,d-p],g=i.apply([],[(n-o)/u[0],(r-a)/u[1]]);if(1e-10<Math.abs(g-1)){for(const b of e)b[2]*=g;this.placeBubbles(e)}else t.diffY=r/2+a-p-(d-p)/2,t.diffX=n/2+o-l-(h-l)/2}seriesBox(){const t=this.chart,e=this.data,i=Math.max,s=Math.min,o=[t.plotLeft,t.plotLeft+t.plotWidth,t.plotTop,t.plotTop+t.plotHeight];let a;return e.forEach(t=>{f(t.plotX)&&f(t.plotY)&&t.marker.radius&&(a=t.marker.radius,o[0]=s(o[0],t.plotX-a),o[1]=i(o[1],t.plotX+a),o[2]=s(o[2],t.plotY-a),o[3]=i(o[3],t.plotY+a))}),P(o.width/o.height)?o:null}setVisible(){const e=this;d.setVisible.apply(e,arguments),e.parentNodeLayout&&e.graph?e.visible?(e.graph.show(),e.parentNode.dataLabel&&e.parentNode.dataLabel.show()):(e.graph.hide(),e.parentNodeLayout.removeElementFromCollection(e.parentNode,e.parentNodeLayout.nodes),e.parentNode.dataLabel&&e.parentNode.dataLabel.hide()):e.layout&&(e.visible?e.layout.addElementsToCollection(e.points,e.layout.nodes):e.points.forEach(t=>{e.layout.removeElementFromCollection(t,e.layout.nodes)}))}translate(){var t=this.chart,e=this.data,i=this.index,s=this.options.useSimulation;let o,a,r;this.processedXData=this.xData,this.generatePoints(),f(t.allDataPoints)||(t.allDataPoints=this.accumulateAllPoints(),this.getPointRadius()),s?r=t.allDataPoints:(r=this.placeBubbles(t.allDataPoints),this.options.draggable=!1);for(const n of r)n[3]===i&&(o=e[n[4]],a=M(n[2],void 0),s||(o.plotX=n[0]-t.plotLeft+t.diffX,o.plotY=n[1]-t.plotTop+t.diffY),P(a))&&(o.marker=y(o.marker,{radius:a,width:2*a,height:2*a}),o.radius=a);s&&this.deferLayout(),x(this,"afterTranslate")}}return k.defaultOptions=S(c.defaultOptions,s),y(k.prototype,{pointClass:i,axisTypes:[],directTouch:!0,forces:["barycenter","repulsive"],hasDraggableNodes:!0,isCartesian:!1,noSharedTooltip:!0,pointArrayMap:["value"],pointValKey:"value",requireSorting:!1,trackerGroups:["group","dataLabelsGroup","parentNodesGroup"],initDataLabels:u,alignDataLabel:d.alignDataLabel,indexateNodes:t,onMouseDown:r.onMouseDown,onMouseMove:r.onMouseMove,redrawHalo:r.redrawHalo,searchPoint:t}),a.registerSeriesType("packedbubble",k),k}),e(t,"Series/Polygon/PolygonSeriesDefaults.js",[],function(){return{marker:{enabled:!1,states:{hover:{enabled:!1}}},stickyTracking:!1,tooltip:{followPointer:!0,pointFormat:""},trackByArea:!0,legendSymbol:"rectangle"}}),e(t,"Series/Polygon/PolygonSeries.js",[t["Core/Globals.js"],t["Series/Polygon/PolygonSeriesDefaults.js"],t["Core/Series/SeriesRegistry.js"],t["Core/Utilities.js"]],function(t,e,i,s){t=t.noop;const{area:o,line:a,scatter:r}=i.seriesTypes;var{extend:s,merge:n}=s;class l extends r{getGraphPath(){var t=a.prototype.getGraphPath.call(this);let e=t.length+1;for(;e--;)(e===t.length||"M"===t[e][0])&&0<e&&t.splice(e,0,["Z"]);return this.areaPath=t}drawGraph(){this.options.fillColor=this.color,o.prototype.drawGraph.call(this)}}return l.defaultOptions=n(r.defaultOptions,e),s(l.prototype,{type:"polygon",drawTracker:a.prototype.drawTracker,setStackedPoints:t}),i.registerSeriesType("polygon",l),l}),e(t,"Core/Axis/RadialAxis.js",[t["Core/Defaults.js"],t["Core/Globals.js"],t["Core/Utilities.js"]],function(t,e,i){const r=t["defaultOptions"],{composed:s,noop:l}=e,{addEvent:o,correctFloat:a,defined:f,extend:n,fireEvent:h,isObject:p,merge:d,pick:S,pushUnique:c,relativeLength:L,wrap:u}=i;var g;{t=g=g||{};const R={gridLineWidth:1,labels:{align:void 0,x:0,y:void 0,style:{textOverflow:"none"}},maxPadding:0,minPadding:0,showLastLabel:!1,tickLength:0},j={endOnTick:!1,gridLineWidth:0,labels:{align:"center",distance:-25,x:0,y:void 0},lineWidth:1,minorGridLineWidth:0,minorTickInterval:"auto",minorTickLength:10,minorTickPosition:"inside",minorTickWidth:1,startOnTick:!1,tickLength:10,tickPixelInterval:100,tickPosition:"inside",tickWidth:2,title:{rotation:0,text:""},zIndex:2},I={gridLineInterpolation:"circle",gridLineWidth:1,labels:{align:"right",x:-3,y:-2},showLastLabel:!1,title:{x:4,text:null,rotation:90}};function m(){this.autoConnect=this.isCircular&&void 0===S(this.userMax,this.options.max)&&a(this.endAngleRad-this.startAngleRad)===a(2*Math.PI),!this.isCircular&&this.chart.inverted&&this.max++,this.autoConnect&&(this.max+=(this.categories?1:this.pointRange)||this.closestPointRange||0)}function b(){return()=>{if(this.isRadial&&this.tickPositions&&this.options.labels&&!0!==this.options.labels.allowOverlap)return this.tickPositions.map(t=>this.ticks[t]&&this.ticks[t].label).filter(t=>Boolean(t))}}function y(){return l}function x(t,e,i){var s=this.pane.center;let o=t.value,a,r,n;return this.isCircular?(f(o)?t.point&&(t.point.shapeArgs||{}).start&&(o=this.chart.inverted?this.translate(t.point.rectPlotY,!0):t.point.x):(r=t.chartX||0,n=t.chartY||0,o=this.translate(Math.atan2(n-i,r-e)-this.startAngleRad,!0)),a=this.getPosition(o),r=a.x,n=a.y):(f(o)||(r=t.chartX,n=t.chartY),f(r)&&f(n)&&(i=s[1]+this.chart.plotTop,o=this.translate(Math.min(Math.sqrt(Math.pow(r-e,2)+Math.pow(n-i,2)),s[2]/2)-s[3]/2,!0))),[o,r||0,n||0]}function v(t,e,i){var s=this.pane.center,o=this.chart,a=this.left||0,r=this.top||0;let n,l=S(e,s[2]/2-this.offset),h;return(i=void 0===i?this.horiz?0:this.center&&-this.center[3]/2:i)&&(l+=i),this.isCircular||void 0!==e?((h=this.chart.renderer.symbols.arc(a+s[0],r+s[1],l,l,{start:this.startAngleRad,end:this.endAngleRad,open:!0,innerR:0})).xBounds=[a+s[0]],h.yBounds=[r+s[1]-l]):(n=this.postTranslate(this.angleRad,l),h=[["M",this.center[0]+o.plotLeft,this.center[1]+o.plotTop],["L",n.x,n.y]]),h}function P(){this.constructor.prototype.getOffset.call(this),this.chart.axisOffset[this.side]=0}function M(t,e,i){const s=this.chart,o=e=>{if("string"!=typeof e)return e;{let t=parseInt(e,10);return t=d.test(e)?t*n/100:t}},a=this.center,r=this.startAngleRad,n=a[2]/2,l=Math.min(this.offset,0),h=this.left||0,p=this.top||0,d=/%$/,c=this.isCircular;let u,g,m,b,f,y,x=S(o(i.outerRadius),n),v=o(i.innerRadius),P=S(o(i.thickness),10);return"polygon"===this.options.gridLineInterpolation?y=this.getPlotLinePath({value:t}).concat(this.getPlotLinePath({value:e,reverse:!0})):(t=Math.max(t,this.min),e=Math.min(e,this.max),t=this.translate(t),e=this.translate(e),c||(x=t||0,v=e||0),"circle"!==i.shape&&c?(u=r+(t||0),g=r+(e||0)):(u=-Math.PI/2,g=1.5*Math.PI,f=!0),x-=l,P-=l,y=s.renderer.symbols.arc(h+a[0],p+a[1],x,x,{start:Math.min(u,g),end:Math.max(u,g),innerR:S(v,x-P),open:f}),c&&(m=(g+u)/2,b=h+a[0]+a[2]/2*Math.cos(m),y.xBounds=m>-Math.PI/2&&m<Math.PI/2?[b,s.plotWidth]:[0,b],y.yBounds=[p+a[1]+a[2]/2*Math.sin(m)],y.yBounds[0]+=m>-Math.PI&&m<0||m>Math.PI?-10:10)),y}function k(t){var e=this.pane.center,i=this.chart,s=i.inverted,o=t.reverse,a=this.pane.options.background?this.pane.options.background[0]||this.pane.options.background:{},r=a.innerRadius||"0%",a=a.outerRadius||"100%",n=e[0]+i.plotLeft,l=e[1]+i.plotTop,h=this.height,p=t.isCrosshair,d=e[3]/2;let c=t.value,u,g,m,b,f,y,x,v,P;var S=this.getPosition(c);let M=S.x,k=S.y;if(p&&(v=this.getCrosshairPosition(t,n,l),c=v[0],M=v[1],k=v[2]),this.isCircular)g=Math.sqrt(Math.pow(M-n,2)+Math.pow(k-l,2)),m="string"==typeof r?L(r,1):r/g,b="string"==typeof a?L(a,1):a/g,e&&d&&(u=d/g,m<u&&(m=u),b<u)&&(b=u),P=[["M",n+m*(M-n),l-m*(l-k)],["L",M-(1-b)*(M-n),k+(1-b)*(l-k)]];else if((c=this.translate(c))&&(c<0||c>h)&&(c=0),"circle"===this.options.gridLineInterpolation)P=this.getLinePath(0,c,d);else if(P=[],i[s?"yAxis":"xAxis"].forEach(t=>{t.pane===this.pane&&(f=t)}),f){x=f.tickPositions,f.autoConnect&&(x=x.concat([x[0]])),o&&(x=x.slice().reverse()),c&&(c+=d);for(let t=0;t<x.length;t++)y=f.getPosition(x[t],c),P.push(t?["L",y.x,y.y]:["M",y.x,y.y])}return P}function C(t,e){t=this.translate(t);return this.postTranslate(this.isCircular?t:this.angleRad,S(this.isCircular?e:t<0?0:t,this.center[2]/2)-this.offset)}function w(){var t=this.center,e=this.chart,i=this.options.title;return{x:e.plotLeft+t[0]+(i.x||0),y:e.plotTop+t[1]-{high:.5,middle:.25,low:0}[i.align]*t[2]+(i.y||0)}}function A(t){t.beforeSetTickPositions=m,t.createLabelCollector=b,t.getCrosshairPosition=x,t.getLinePath=v,t.getOffset=P,t.getPlotBandPath=M,t.getPlotLinePath=k,t.getPosition=C,t.getTitlePosition=w,t.postTranslate=W,t.setAxisSize=G,t.setAxisTranslation=F,t.setOptions=H}function N(){var i=this.chart,s=this.options,o=i.angular&&this.isXAxis,a=this.pane,r=a&&a.options;if(!o&&a&&(i.angular||i.polar)){o=2*Math.PI,a=(S(r.startAngle,0)-90)*Math.PI/180,i=(S(r.endAngle,S(r.startAngle,0)+360)-90)*Math.PI/180;this.angleRad=(s.angle||0)*Math.PI/180,this.startAngleRad=a,this.endAngleRad=i,this.offset=s.offset||0;let t=(a%o+o)%o,e=(i%o+o)%o;t>Math.PI&&(t-=o),e>Math.PI&&(e-=o),this.normalizedStartAngleRad=t,this.normalizedEndAngleRad=e}}function T(t){this.isRadial&&(t.align=void 0,t.preventDefault())}function E(){var t;this.chart&&this.chart.labelCollectors&&0<=(t=this.labelCollector?this.chart.labelCollectors.indexOf(this.labelCollector):-1)&&this.chart.labelCollectors.splice(t,1)}function D(t){var e=this.chart,i=(e.inverted,e.angular),s=e.polar,o=this.isXAxis,a=this.coll,r=i&&o,t=t.userOptions.pane||0,t=this.pane=e.pane&&e.pane[t];let n;"colorAxis"===a?this.isRadial=!1:(i?(r?((a=this).isHidden=!0,a.createLabelCollector=y,a.getOffset=l,a.redraw=X,a.render=X,a.setScale=l,a.setCategories=l,a.setTitle=l):A(this),n=!o):s&&(A(this),n=this.horiz),i||s?(this.isRadial=!0,this.labelCollector||(this.labelCollector=this.createLabelCollector()),this.labelCollector&&e.labelCollectors.push(this.labelCollector)):this.isRadial=!1,t&&n&&(t.axis=this),this.isCircular=n)}function B(){this.isRadial&&this.beforeSetTickPositions()}function z(h){var p=this.label;if(p){var d=this.axis,c=p.getBBox(),u=d.options.labels,g=(d.translate(this.pos)+d.startAngleRad+Math.PI/2)/Math.PI*180%360,m=Math.round(g),b=f(u.y)?0:.3*-c.height;let t=u.y,e,i=20,s=u.align,o="end",a=m<0?m+360:m,r=a,n=0,l=0;d.isRadial&&(e=d.getPosition(this.pos,d.center[2]/2+L(S(u.distance,-25),d.center[2]/2,-d.center[2]/2)),"auto"===u.rotation?p.attr({rotation:g}):f(t)||(t=d.chart.renderer.fontMetrics(p).b-c.height/2),f(s)||(s=d.isCircular?g>(i=c.width>d.len*d.tickInterval/(d.max-d.min)?0:i)&&g<180-i?"left":g>180+i&&g<360-i?"right":"center":"center",p.attr({align:s})),"auto"===s&&2===d.tickPositions.length&&d.isCircular&&(90<a&&a<180?a=180-a:270<a&&a<=360&&(a=540-a),180<r&&r<=360&&(r=360-r),d.pane.options.startAngle!==m&&d.pane.options.startAngle!==m+360&&d.pane.options.startAngle!==m-360||(o="start"),s=-90<=m&&m<=90||-360<=m&&m<=-270||270<=m&&m<=360?"start"===o?"right":"left":"start"===o?"left":"right",70<r&&r<110&&(s="center"),a<15||180<=a&&a<195?n=.3*c.height:15<=a&&a<=35?n="start"===o?0:.75*c.height:195<=a&&a<=215?n="start"===o?.75*c.height:0:35<a&&a<=90?n="start"===o?.25*-c.height:c.height:215<a&&a<=270&&(n="start"===o?c.height:.25*-c.height),r<15?l="start"===o?.15*-c.height:.15*c.height:165<r&&r<=180&&(l="start"===o?.15*c.height:.15*-c.height),p.attr({align:s}),p.translate(l,n+b)),h.pos.x=e.x+(u.x||0),h.pos.y=e.y+(t||0))}}function O(t){this.axis.getPosition&&n(t.pos,this.axis.getPosition(this.pos))}function W(t,e){var i=this.chart,s=this.center;return t=this.startAngleRad+t,{x:i.plotLeft+s[0]+Math.cos(t)*e,y:i.plotTop+s[1]+Math.sin(t)*e}}function X(){this.isDirty=!1}function G(){var t,e;this.constructor.prototype.setAxisSize.call(this),this.isRadial&&(this.pane.updateCenter(this),t=this.center=this.pane.center.slice(),this.isCircular?this.sector=this.endAngleRad-this.startAngleRad:(e=this.postTranslate(this.angleRad,t[3]/2),t[0]=e.x-this.chart.plotLeft,t[1]=e.y-this.chart.plotTop),this.len=this.width=this.height=(t[2]-t[3])*S(this.sector,1)/2)}function F(){this.constructor.prototype.setAxisTranslation.call(this),this.center&&(this.isCircular?this.transA=(this.endAngleRad-this.startAngleRad)/(this.max-this.min||1):this.transA=(this.center[2]-this.center[3])/2/(this.max-this.min||1),this.isXAxis?this.minPixelPadding=this.transA*this.minPointOffset:this.minPixelPadding=0)}function H(t){var e=this["coll"],{angular:i,inverted:s,polar:o}=this.chart;let a={};i?this.isXAxis||(a=d(r.yAxis,j)):o&&(a=this.horiz?d(r.xAxis,R):d("xAxis"===e?r.xAxis:r.yAxis,I)),s&&"yAxis"===e&&(a.stackLabels=p(r.yAxis,!0)?r.yAxis.stackLabels:{},a.reversedStacks=!0);i=this.options=d(a,t);i.plotBands||(i.plotBands=[]),h(this,"afterSetOptions")}function U(t,e,i,s,o,a,r){var n=this.axis;let l,h;return h=n.isRadial?["M",e,i,"L",(l=n.getPosition(this.pos,n.center[2]/2+s)).x,l.y]:t.call(this,e,i,s,o,a,r)}t.compose=function Y(t,e){return c(s,Y)&&(o(t,"afterInit",N),o(t,"autoLabelAlign",T),o(t,"destroy",E),o(t,"init",D),o(t,"initialAxisTranslation",B),o(e,"afterGetLabelPosition",z),o(e,"afterGetPosition",O),u(e.prototype,"getMarkPath",U)),t}}return g}),e(t,"Series/PolarComposition.js",[t["Core/Animation/AnimationUtilities.js"],t["Core/Globals.js"],t["Core/Series/Series.js"],t["Extensions/Pane/Pane.js"],t["Core/Axis/RadialAxis.js"],t["Core/Utilities.js"]],function(t,b,h,d,c,A){const f=t["animObject"],u=b["composed"],{addEvent:g,defined:N,find:n,isNumber:T,merge:p,pick:y,pushUnique:m,relativeLength:X,splat:e,uniqueKey:l,wrap:x}=A;function v(){(this.pane||[]).forEach(t=>{t.render()})}function P(t){var e=t.args[0].xAxis,i=t.args[0].yAxis,t=t.args[0].chart;e&&i&&("polygon"===i.gridLineInterpolation?(e.startOnTick=!0,e.endOnTick=!0):"polygon"===e.gridLineInterpolation&&t.inverted&&(i.startOnTick=!0,i.endOnTick=!0))}function S(){this.pane||(this.pane=[]),this.options.pane=e(this.options.pane),this.options.pane.forEach(t=>{new d(t,this)},this)}function M(t){var e,i=t.args.marker,s=this.chart.xAxis[0],o=this.chart.yAxis[0],a=this.chart.inverted,r=a?o:s,a=a?s:o;this.chart.polar&&(t.preventDefault(),s=(i.attr?i.attr("start"):i.start)-r.startAngleRad,o=i.attr?i.attr("r"):i.r,e=(i.attr?i.attr("end"):i.end)-r.startAngleRad,i=i.attr?i.attr("innerR"):i.innerR,t.result.x=s+r.pos,t.result.width=e-s,t.result.y=a.len+a.pos-i,t.result.height=i-o)}function k(t){var o=this.chart;if(o.polar&&o.hoverPane&&o.hoverPane.axis){t.preventDefault();var a=o.hoverPane.center,i=this.mouseDownX||0,r=this.mouseDownY||0,n=t.args.chartY,l=t.args.chartX,h=2*Math.PI,p=o.hoverPane.axis.startAngleRad,d=o.hoverPane.axis.endAngleRad,c=(o.inverted?o.xAxis:o.yAxis)[0],u={};let s="arc";if(u.x=a[0]+o.plotLeft,u.y=a[1]+o.plotTop,this.zoomHor){var g=0<p?d-p:Math.abs(p)+Math.abs(d);let t=Math.atan2(r-o.plotTop-a[1],i-o.plotLeft-a[0])-p,e=Math.atan2(n-o.plotTop-a[1],l-o.plotLeft-a[0])-p;u.r=a[2]/2,u.innerR=a[3]/2,t<=0&&(t+=h),e<=0&&(e+=h),e<t&&(e=[t,t=e][0]),g<h&&p+e>d+(h-g)/2&&(e=t,t=p<=0?p:0);h=u.start=Math.max(t+p,p),g=u.end=Math.min(e+p,d);if("polygon"===c.options.gridLineInterpolation){var m=o.hoverPane.axis,b=(m.tickInterval,h-m.startAngleRad+m.pos),g=g-h;let t=c.getPlotLinePath({value:c.max}),e=m.toValue(b),i=m.toValue(b+g);e<m.getExtremes().min&&({min:h,max:b}=m.getExtremes(),e=b-(h-e)),i<m.getExtremes().min&&({min:g,max:b}=m.getExtremes(),i=b-(g-i)),i<e&&(i=[e,e=i][0]),(t=w(t,e,i,m)).push(["L",a[0]+o.plotLeft,o.plotTop+a[1]]),u.d=t,s="path"}}if(this.zoomVert){h=(o.inverted?o.xAxis:o.yAxis)[0];let t=Math.sqrt(Math.pow(i-o.plotLeft-a[0],2)+Math.pow(r-o.plotTop-a[1],2)),e=Math.sqrt(Math.pow(l-o.plotLeft-a[0],2)+Math.pow(n-o.plotTop-a[1],2));e<t&&(t=[e,e=t][0]),e>a[2]/2&&(e=a[2]/2),t<a[3]/2&&(t=a[3]/2),this.zoomHor||(u.start=p,u.end=d),u.r=e,u.innerR=t,"polygon"===h.options.gridLineInterpolation&&(b=h.toValue(h.len+h.pos-t),g=h.toValue(h.len+h.pos-e),m=h.getPlotLinePath({value:g}).concat(h.getPlotLinePath({value:b,reverse:!0})),u.d=m,s="path")}if(this.zoomHor&&this.zoomVert&&"polygon"===c.options.gridLineInterpolation){i=o.hoverPane.axis,r=u.start||0,l=r-i.startAngleRad+i.pos,n=(u.end||0)-r,a=i.toValue(l),p=i.toValue(l+n);if(u.d instanceof Array){let t=u.d.slice(0,u.d.length/2),e=u.d.slice(u.d.length/2,u.d.length);e=[...e].reverse();d=o.hoverPane.axis;t=w(t,a,p,d),(e=w(e,a,p,d))&&(e[0][0]="L"),e=[...e].reverse(),u.d=t.concat(e),s="path"}}t.attrs=u,t.shapeType=s}}function L(){var t=this.chart;t.polar&&(this.polar=new i(this),t.inverted)&&(this.isRadialSeries=!0,this.is("column"))&&(this.isRadialBar=!0)}function C(){if(this.chart.polar&&this.xAxis){const i=this,{xAxis:s,yAxis:o}=i,n=i.chart;i.kdByAngle=n.tooltip&&n.tooltip.shared,i.kdByAngle||n.inverted?i.searchPoint=a:i.options.findNearestPointBy="xy";var e=i.points;let t=e.length;for(;t--;)i.is("column")||i.is("columnrange")||i.polar.toXY(e[t]),n.hasParallelCoordinates||i.yAxis.reversed||(y(e[t].y,Number.MIN_VALUE)<o.min||e[t].x<s.min||e[t].x>s.max?(e[t].isNull=!0,e[t].plotY=NaN):e[t].isNull=e[t].isValid&&!e[t].isValid());this.hasClipCircleSetter||(this.hasClipCircleSetter=!!i.eventsToUnbind.push(g(i,"afterRender",function(){var t,e,i,s,o,a,r;n.polar&&!1!==this.options.clip&&(o=this.yAxis.pane.center,this.clipCircle?this.clipCircle.animate({x:o[0],y:o[1],r:o[2]/2,innerR:o[3]/2}):this.clipCircle=(t=n.renderer,e=o[0],i=o[1],s=o[2]/2,o=o[3]/2,a=l(),r=t.createElement("clipPath").attr({id:a}).add(t.defs),(o=(o?t.arc(e,i,s,o,0,2*Math.PI):t.circle(e,i,s)).add(r)).id=a,o.clipPath=r,o),this.group.clip(this.clipCircle),this.setClip=b.noop)})))}}function a(t){var e=this.chart,i=this.xAxis,s=this.yAxis,o=i.pane&&i.pane.center,a=t.chartX-(o&&o[0]||0)-e.plotLeft,o=t.chartY-(o&&o[1]||0)-e.plotTop,e=e.inverted?{clientX:t.chartX-s.pos,plotY:t.chartY-i.pos}:{clientX:180+Math.atan2(a,o)*(-180/Math.PI)};return this.searchKDTree(e)}function w(t,e,i,s){var o=s.tickInterval,s=s.tickPositions;let a=n(s,t=>i<=t),r=n([...s].reverse(),t=>t<=e);return N(a)||(a=s[s.length-1]),N(r)||(r=s[0],a+=o,t[0][0]="L",t.unshift(t[t.length-3])),(t=t.slice(s.indexOf(r),s.indexOf(a)+1))[0][0]="M",t}function Y(t,e){return n(this.pane||[],t=>t.options.id===e)||t.call(this,e)}function R(t,e,i,s,o,a){var r,n=this.chart,l=y(s.inside,!!this.options.stacking);n.polar?(r=e.rectPlotX/Math.PI*180,n.inverted?(this.forceDL=n.isInsidePlot(e.plotX,e.plotY),l&&e.shapeArgs?(l=e.shapeArgs,l=this.yAxis.postTranslate(((l.start||0)+(l.end||0))/2-this.xAxis.startAngleRad,e.barX+e.pointWidth/2),o=p(o,{x:l.x-n.plotLeft,y:l.y-n.plotTop})):e.tooltipPos&&(o=p(o,{x:e.tooltipPos[0],y:e.tooltipPos[1]})),s.align=y(s.align,"center"),s.verticalAlign=y(s.verticalAlign,"middle")):s=function(t,e){let i,s;return null===e.align&&(i=20<t&&t<160?"left":200<t&&t<340?"right":"center",e.align=i),null===e.verticalAlign&&(s=t<45||315<t?"bottom":135<t&&t<225?"top":"middle",e.verticalAlign=s),e}(r,s),h.prototype.alignDataLabel.call(this,e,i,s,o,a),this.isRadialBar&&e.shapeArgs&&e.shapeArgs.start===e.shapeArgs.end?i.hide():i.show()):t.call(this,e,i,s,o,a)}function j(){var t,e=this,i=e.options,s=i.stacking,o=e.chart,a=e.xAxis,r=e.yAxis,n=r.reversed,l=r.center,h=a.startAngleRad,p=a.endAngleRad-h;i.threshold;let d,c=0,u,g,m,b,f,y=0,x=0,v,P,S,M,k,L,C,w;if(a.isRadial)for(u=e.points,m=u.length,b=r.translate(r.min),f=r.translate(r.max),d=i.threshold||0,o.inverted&&T(d)&&(c=r.translate(d),N(c))&&(c<0?c=0:c>p&&(c=p),e.translatedThreshold=c+h);m--;)g=u[m],L=g.barX,P=g.x,S=g.y,g.shapeType="arc",o.inverted?(g.plotY=r.translate(S),s&&r.stacking?(k=r.stacking.stacks[(S<0?"-":"")+e.stackKey],e.visible&&k&&k[P]&&(g.isNull||(M=k[P].points[e.getStackIndicator(void 0,P,e.index).key],y=r.translate(M[0]),x=r.translate(M[1]),N(y)&&(y=A.clamp(y,0,p))))):(y=c,x=g.plotY),y>x&&(x=[y,y=x][0]),n?x>b?x=b:y<f?y=f:(y>b||x<f)&&(y=x=p):y<b?y=b:x>f?x=f:(x<b||y>f)&&(y=x=0),r.min>r.max&&(y=x=n?p:0),y+=h,x+=h,l&&(g.barX=L+=l[3]/2),C=Math.max(L,0),w=Math.max(L+g.pointWidth,0),t="object"==typeof(t=i.borderRadius)?t.radius:t,t=X(t||0,w-C),g.shapeArgs={x:l[0],y:l[1],r:w,innerR:C,start:y,end:x,borderRadius:t},g.opacity=y===x?0:void 0,g.plotY=(N(e.translatedThreshold)&&(y<e.translatedThreshold?y:x))-h):(y=L+h,g.shapeArgs=e.polar.arc(g.yBottom,g.plotY,y,y+g.pointWidth),g.shapeArgs.borderRadius=0),e.polar.toXY(g),o.inverted?(v=r.postTranslate(g.rectPlotY,L+g.pointWidth/2),g.tooltipPos=[v.x-o.plotLeft,v.y-o.plotTop]):g.tooltipPos=[g.plotX,g.plotY],l&&(g.ttBelow=g.plotY>l[1])}function I(t,e){const i=this;let s,o;if(this.chart.polar){e=e||this.points;for(let t=0;t<e.length;t++)if(!e[t].isNull){s=t;break}!1!==this.options.connectEnds&&void 0!==s&&(this.connectEnds=!0,e.splice(e.length,0,e[s]),o=!0),e.forEach(t=>{"undefined"==typeof t.polarPlotY&&i.polar.toXY(t)})}t=t.apply(this,[].slice.call(arguments,1));return o&&e.pop(),t}function E(t,o){const a=this.chart;let r={xAxis:[],yAxis:[]};return a.polar?a.axes.forEach(t=>{var e,i,s;"colorAxis"!==t.coll&&(e=t.isXAxis,s=t.center,i=o.chartX-s[0]-a.plotLeft,s=o.chartY-s[1]-a.plotTop,r[e?"xAxis":"yAxis"].push({axis:t,value:t.translate(e?Math.PI-Math.atan2(i,s):Math.sqrt(Math.pow(i,2)+Math.pow(s,2)),!0)}))}):r=t.call(this,o),r}function D(t,e){this.chart.polar||t.call(this,e)}function B(t,e){const i=this,s=this.chart,o=this.group,a=this.markerGroup,r=this.xAxis&&this.xAxis.center,n=s.plotLeft,l=s.plotTop;let h=this.options.animation,p,d,c,u,g,m;s.polar?i.isRadialBar?e||(i.startAngleRad=y(i.translatedThreshold,i.xAxis.startAngleRad),b.seriesTypes.pie.prototype.animate.call(i,e)):(h=f(h),i.is("column")?e||(d=r[3]/2,i.points.forEach(t=>{c=t.graphic,u=t.shapeArgs,g=u&&u.r,m=u&&u.innerR,c&&u&&(c.attr({r:d,innerR:d}),c.animate({r:g,innerR:m},i.options.animation))})):e?(p={translateX:r[0]+n,translateY:r[1]+l,scaleX:.001,scaleY:.001},o.attr(p),a&&a.attr(p)):(p={translateX:n,translateY:l,scaleX:1,scaleY:1},o.animate(p,h),a&&a.animate(p,h))):t.call(this,e)}function z(t,e,i,s){let o,a;var r,n;return o=this.chart.polar?s?(r=(a=function b(t,e,i,s){var o=s?1:0;let a,r,n,l,h,p;var e=(a=0<=e&&e<=t.length-1?e:e<0?t.length-1+e:0)-1<0?t.length-(1+o):a-1,o=a+1>t.length-1?o:a+1,d=t[e],o=t[o],c=d.plotX,d=d.plotY,u=o.plotX,o=o.plotY,g=t[a].plotX,m=t[a].plotY,c=(r=(1.5*g+c)/2.5,n=(1.5*m+d)/2.5,l=(1.5*g+u)/2.5,h=(1.5*m+o)/2.5,Math.sqrt(Math.pow(r-g,2)+Math.pow(n-m,2))),d=Math.sqrt(Math.pow(l-g,2)+Math.pow(h-m,2)),u=Math.atan2(n-m,r-g),o=Math.atan2(h-m,l-g),o=(p=Math.PI/2+(u+o)/2,Math.abs(u-p)>Math.PI/2&&(p-=Math.PI),r=g+Math.cos(p)*c,n=m+Math.sin(p)*c,{rightContX:g+Math.cos(Math.PI+p)*d,rightContY:m+Math.sin(Math.PI+p)*d,leftContX:r,leftContY:n,plotX:g,plotY:m});return i&&(o.prevPointCont=b(t,e,!1,s)),o}(e,s,!0,this.connectEnds)).prevPointCont&&a.prevPointCont.rightContX,n=a.prevPointCont&&a.prevPointCont.rightContY,["C",T(r)?r:a.plotX,T(n)?n:a.plotY,T(a.leftContX)?a.leftContX:a.plotX,T(a.leftContY)?a.leftContY:a.plotY,a.plotX,a.plotY]):["M",i.plotX,i.plotY]:t.call(this,e,i,s)}function O(t,e,i=this.plotY){var{plotX:s,series:o}=this,o=o["chart"];return o.polar&&!this.destroyed&&T(s)&&T(i)?[s+(e?o.plotLeft:0),i+(e?o.plotTop:0)]:t.call(this,e,i)}class i{static compose(t,e,i,s,o,a,r,n,l,h){var p;d.compose(e,i),c.compose(t,o),m(u,this.compose)&&(t=e.prototype,o=a.prototype,a=i.prototype,p=s.prototype,g(e,"afterDrawChartBox",v),g(e,"getAxes",S),g(e,"init",P),x(t,"get",Y),x(a,"getCoordinates",E),x(a,"pinch",D),g(i,"getSelectionMarkerAttrs",k),g(i,"getSelectionBox",M),g(s,"afterInit",L),g(s,"afterTranslate",C,{order:2}),g(s,"afterColumnTranslate",j,{order:4}),x(p,"animate",B),x(o,"pos",O),n&&(e=n.prototype,x(e,"alignDataLabel",R),x(e,"animate",B)),l&&(t=l.prototype,x(t,"getGraphPath",I)),h)&&(a=h.prototype,x(a,"getPointSpline",z),r)&&(r.prototype.getPointSpline=a.getPointSpline)}constructor(t){this.series=t}arc(t,e,i,s){var o=this.series,a=o.xAxis.center,r=o.yAxis.len,n=a[3]/2;let l=r-e+n,h=r-y(t,r)+n;return o.yAxis.reversed&&(l<0&&(l=n),h<0)&&(h=n),{x:a[0],y:a[1],r:l,innerR:h,start:i,end:s}}toXY(t){var e=this.series,i=e.chart,s=e.xAxis,o=e.yAxis,a=t.plotX,r=i.inverted,n=t.y;let l=t.plotY,h=r?a:o.len-l,p;r&&e&&!e.isRadialBar&&(t.plotY=l=T(n)?o.translate(n):0),t.rectPlotX=a,t.rectPlotY=l,o.center&&(h+=o.center[3]/2),T(l)&&(n=r?o.postTranslate(l,h):s.postTranslate(a,h),t.plotX=t.polarPlotX=n.x-i.plotLeft,t.plotY=t.polarPlotY=n.y-i.plotTop),e.kdByAngle?((p=(a/Math.PI*180+s.pane.options.startAngle)%360)<0&&(p+=360),t.clientX=p):t.clientX=t.plotX}}return i}),e(t,"Core/Axis/WaterfallAxis.js",[t["Core/Globals.js"],t["Core/Axis/Stacking/StackItem.js"],t["Core/Utilities.js"]],function(t,o,e){const i=t["composed"],{addEvent:s,objectEach:a,pushUnique:r}=e;var n;{function l(){var t=this.waterfall.stacks;t&&(t.changed=!1,delete t.alreadyChanged)}function h(){var t=this.options.stackLabels;t&&t.enabled&&this.waterfall.stacks&&this.waterfall.renderStackTotals()}function p(){this.waterfall||(this.waterfall=new u(this))}function d(){var t=this.axes;for(const e of this.series)if(e.options.stacking){for(const i of t)i.isXAxis||(i.waterfall.stacks.changed=!0);break}}(t=n=n||{}).compose=function c(t,e){r(i,c)&&(s(t,"init",p),s(t,"afterBuildStacks",l),s(t,"afterRender",h),s(e,"beforeRedraw",d))};class u{constructor(t){this.axis=t,this.stacks={changed:!1}}renderStackTotals(){const t=this.axis,e=t.waterfall.stacks,i=t.stacking&&t.stacking.stackTotalGroup,s=new o(t,t.options.stackLabels||{},!1,0,void 0);this.dummyStackItem=s,i&&a(e,t=>{a(t,(t,e)=>{s.total=t.stackTotal,s.x=+e,t.label&&(s.label=t.label),o.prototype.render.call(s,i),t.label=s.label,delete s.label})}),s.total=null}}t.Composition=u}return n}),e(t,"Series/Waterfall/WaterfallPoint.js",[t["Series/Column/ColumnSeries.js"],t["Core/Series/Point.js"],t["Core/Utilities.js"]],function(t,e,i){const s=i["isNumber"];class o extends t.prototype.pointClass{getClassName(){let t=e.prototype.getClassName.call(this);return this.isSum?t+=" highcharts-sum":this.isIntermediateSum&&(t+=" highcharts-intermediate-sum"),t}isValid(){return s(this.y)||this.isSum||Boolean(this.isIntermediateSum)}}return o}),e(t,"Series/Waterfall/WaterfallSeriesDefaults.js",[],function(){return{dataLabels:{inside:!0},lineWidth:1,lineColor:"#333333",dashStyle:"Dot",borderColor:"#333333",states:{hover:{lineWidthPlus:0}}}}),e(t,"Series/Waterfall/WaterfallSeries.js",[t["Core/Series/SeriesRegistry.js"],t["Core/Utilities.js"],t["Core/Axis/WaterfallAxis.js"],t["Series/Waterfall/WaterfallPoint.js"],t["Series/Waterfall/WaterfallSeriesDefaults.js"]],function(t,e,i,s,o){const{column:a,line:r}=t.seriesTypes,{addEvent:n,arrayMax:l,arrayMin:h,correctFloat:c,extend:P,isNumber:S,merge:M,objectEach:p,pick:k}=e;function L(t,e){return Object.hasOwnProperty.call(t,e)}class d extends a{generatePoints(){a.prototype.generatePoints.apply(this);for(let t=0,e=this.points.length;t<e;t++){var i=this.points[t],s=this.processedYData[t];S(s)&&(i.isIntermediateSum||i.isSum)&&(i.y=c(s))}}processData(t){var e=this.options,i=this.yData,s=e.data,o=i.length,a=e.threshold||0;let r,n,l,h,p,d;for(let t=l=n=h=p=0;t<o;t++)d=i[t],r=s&&s[t]?s[t]:{},"sum"===d||r.isSum?i[t]=c(l):"intermediateSum"===d||r.isIntermediateSum?(i[t]=c(n),n=0):(l+=d,n+=d),h=Math.min(l,h),p=Math.max(l,p);super.processData.call(this,t),e.stacking||(this.dataMin=h+a,this.dataMax=p)}toYData(t){return t.isSum?"sum":t.isIntermediateSum?"intermediateSum":t.y}updateParallelArrays(t,e){super.updateParallelArrays.call(this,t,e),"sum"!==this.yData[0]&&"intermediateSum"!==this.yData[0]||(this.yData[0]=null)}pointAttribs(t,e){var i=this.options.upColor,i=(i&&!t.options.color&&S(t.y)&&(t.color=0<t.y?i:void 0),a.prototype.pointAttribs.call(this,t,e));return delete i.dashstyle,i}getGraphPath(){return[["M",0,0]]}getCrispPath(){var t=this.data.filter(t=>S(t.y)),i=this.yAxis,s=t.length,o=Math.round(this.graph.strokeWidth())%2/2,a=Math.round(this.borderWidth)%2/2,r=this.xAxis.reversed,n=this.yAxis.reversed,l=this.options.stacking,h=[];for(let e=1;e<s;e++)if(this.options.connectNulls||S(this.data[t[e].index-1].y)){var p=t[e].box,d=t[e-1],c=d.y||0,u=t[e-1].box;if(p&&u){var g=i.waterfall.stacks[this.stackKey],m=0<c?-u.height:0;if(g&&u&&p){var g=g[e-1];let t;t=l?(g=g.connectorThreshold,Math.round(i.translate(g,!1,!0,!1,!0)+(n?m:0))-o):u.y+d.minPointLengthOffset+a-o,h.push(["M",(u.x||0)+(!r&&u.width||0),t],["L",(p.x||0)+(r&&p.width||0),t])}u&&h.length&&(!l&&c<0&&!n||0<c&&n)&&((g=h[h.length-2])&&"number"==typeof g[2]&&(g[2]+=u.height||0),m=h[h.length-1])&&"number"==typeof m[2]&&(m[2]+=u.height||0)}}return h}drawGraph(){r.prototype.drawGraph.call(this),this.graph&&this.graph.attr({d:this.getCrispPath()})}setStackedPoints(t){var e=this,i=e.options,s=t.waterfall?.stacks,o=i.threshold||0,a=e.stackKey,r=e.xData,n=r.length;let l=o,h=l,p,d=0,c=0,u=0,g,m,b,f,y,x,v,P;var S=(t,e,i,s)=>{if(p){if(g)for(;i<g;i++)p.stackState[i]+=s;else p.stackState[0]=t,g=p.stackState.length;p.stackState.push(p.stackState[g-1]+e)}};if(t.stacking&&s&&e.reserveSpace()){P=s.changed,(v=s.alreadyChanged)&&v.indexOf(a)<0&&(P=!0),s[a]||(s[a]={});var M=s[a];if(M)for(let t=0;t<n;t++)M[x=r[t]]&&!P||(M[x]={negTotal:0,posTotal:0,stackTotal:0,threshold:0,stateIndex:0,stackState:[],label:P&&M[x]?M[x].label:void 0}),p=M[x],0<=(y=e.yData[t])?p.posTotal+=y:p.negTotal+=y,f=i.data[t],m=p.absolutePos=p.posTotal,b=p.absoluteNeg=p.negTotal,p.stackTotal=m+b,g=p.stackState.length,f&&f.isIntermediateSum?(S(u,c,0,u),u=c,c=o,l^=h,h^=l,l^=h):f&&f.isSum?(S(o,d,g,0),l=o):(S(l,y,0,d),f&&(d+=y,c+=y)),p.stateIndex++,p.threshold=l,l+=p.stackTotal;s.changed=!1,s.alreadyChanged||(s.alreadyChanged=[]),s.alreadyChanged.push(a)}}getExtremes(){var t=this.options.stacking;let e,i,s;return t?(e=this.yAxis.waterfall.stacks,i=this.stackedYNeg=[],s=this.stackedYPos=[],"overlap"===t?p(e[this.stackKey],function(t){i.push(h(t.stackState)),s.push(l(t.stackState))}):p(e[this.stackKey],function(t){i.push(t.negTotal+t.threshold),s.push(t.posTotal+t.threshold)}),{dataMin:h(i),dataMax:l(s)}):{dataMin:this.dataMin,dataMax:this.dataMax}}}return d.defaultOptions=M(a.defaultOptions,o),d.compose=i.compose,P(d.prototype,{pointValKey:"y",showLine:!0,pointClass:s}),n(d,"afterColumnTranslate",function(){var e=this,{options:t,points:i,yAxis:s}=e,o=k(t.minPointLength,5),a=o/2,r=t.threshold||0,n=t.stacking,l=s.waterfall.stacks[e.stackKey];let h=r,p=r,d,c,u,g;for(let t=0;t<i.length;t++){var m=i[t],b=e.processedYData[t],f=m.shapeArgs,f=P({x:0,y:0,width:0,height:0},f||{}),y=(m.box=f,[0,b]),x=m.y||0,v=(n?l&&(v=l[t],"overlap"===n?(c=v.stackState[v.stateIndex--],d=0<=x?c:c-x,L(v,"absolutePos")&&delete v.absolutePos,L(v,"absoluteNeg")&&delete v.absoluteNeg):(d=0<=x?(c=v.threshold+v.posTotal,v.posTotal-=x,c):(c=v.threshold+v.negTotal,v.negTotal-=x,c-x),v.posTotal||S(v.absolutePos)&&L(v,"absolutePos")&&(v.posTotal=v.absolutePos,delete v.absolutePos),v.negTotal||S(v.absoluteNeg)&&L(v,"absoluteNeg")&&(v.negTotal=v.absoluteNeg,delete v.absoluteNeg)),m.isSum||(v.connectorThreshold=v.threshold+v.stackTotal),g=s.reversed?(u=0<=x?d-x:d+x,d):(u=d)-x,m.below=u<=r,f.y=s.translate(u,!1,!0,!1,!0),f.height=Math.abs(f.y-s.translate(g,!1,!0,!1,!0)),v=s.waterfall.dummyStackItem)&&(v.x=t,v.label=l[t].label,v.setOffset(e.pointXOffset||0,e.barW||0,e.stackedYNeg[t],e.stackedYPos[t],void 0,this.xAxis)):(d=Math.max(p,p+x)+y[0],f.y=s.translate(d,!1,!0,!1,!0),m.isSum?(f.y=s.translate(y[1],!1,!0,!1,!0),f.height=Math.min(s.translate(y[0],!1,!0,!1,!0),s.len)-f.y,m.below=y[1]<=r):m.isIntermediateSum?(g=0<=x?(u=y[1]+h,h):(u=h,y[1]+h),s.reversed&&(u^=g,g^=u,u^=g),f.y=s.translate(u,!1,!0,!1,!0),f.height=Math.abs(f.y-Math.min(s.translate(g,!1,!0,!1,!0),s.len)),h+=y[1],m.below=u<=r):(f.height=0<b?s.translate(p,!1,!0,!1,!0)-f.y:s.translate(p,!1,!0,!1,!0)-s.translate(p-b,!1,!0,!1,!0),p+=b,m.below=p<r),f.height<0&&(f.y+=f.height,f.height*=-1)),m.plotY=f.y=Math.round(f.y||0)-e.borderWidth%2/2,f.height=Math.max(Math.round(f.height||0),.001),m.yBottom=f.y+f.height,f.height<=o&&!m.isNull?(f.height=o,f.y-=a,m.plotY=f.y,m.minPointLengthOffset=x<0?-a:a):(m.isNull&&(f.width=0),m.minPointLengthOffset=0),m.plotY+(m.negative?f.height:0));m.below&&(m.plotY+=f.height),m.tooltipPos&&(e.chart.inverted?m.tooltipPos[0]=s.len-v:m.tooltipPos[1]=v),m.isInside=this.isPointInside(m),M(!0,m.shapeArgs,f)}},{order:2}),t.registerSeriesType("waterfall",d),d}),e(t,"masters/highcharts-more.src.js",[t["Core/Globals.js"],t["Core/Series/SeriesRegistry.js"],t["Extensions/Pane/Pane.js"],t["Series/Bubble/BubbleSeries.js"],t["Series/PackedBubble/PackedBubbleSeries.js"],t["Series/PolarComposition.js"],t["Series/Waterfall/WaterfallSeries.js"]],function(t,e,i,s,o,a,r){s.compose(t.Axis,t.Chart,t.Legend,t.Series),o.compose(t.Axis,t.Chart,t.Legend,t.Series),i.compose(t.Chart,t.Pointer),a.compose(t.Axis,t.Chart,t.Pointer,t.Series,t.Tick,t.Point,e.seriesTypes.areasplinerange,e.seriesTypes.column,e.seriesTypes.line,e.seriesTypes.spline),r.compose(t.Axis,t.Chart)})});
//# sourceMappingURL=highcharts.js.map;
!function(e){"function"==typeof define&&define.amd?define(["jquery","../version","../keycode"],e):e(jQuery)}(function(v){var n;function e(){this._curInst=null,this._keyEvent=!1,this._disabledInputs=[],this._datepickerShowing=!1,this._inDialog=!1,this._mainDivId="ui-datepicker-div",this._inlineClass="ui-datepicker-inline",this._appendClass="ui-datepicker-append",this._triggerClass="ui-datepicker-trigger",this._dialogClass="ui-datepicker-dialog",this._disableClass="ui-datepicker-disabled",this._unselectableClass="ui-datepicker-unselectable",this._currentClass="ui-datepicker-current-day",this._dayOverClass="ui-datepicker-days-cell-over",this.regional=[],this.regional[""]={closeText:"Done",prevText:"Prev",nextText:"Next",currentText:"Today",monthNames:["January","February","March","April","May","June","July","August","September","October","November","December"],monthNamesShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],dayNames:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],dayNamesShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],dayNamesMin:["Su","Mo","Tu","We","Th","Fr","Sa"],weekHeader:"Wk",dateFormat:"mm/dd/yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""},this._defaults={showOn:"focus",showAnim:"fadeIn",showOptions:{},defaultDate:null,appendText:"",buttonText:"...",buttonImage:"",buttonImageOnly:!1,hideIfNoPrevNext:!1,navigationAsDateFormat:!1,gotoCurrent:!1,changeMonth:!1,changeYear:!1,yearRange:"c-10:c+10",showOtherMonths:!1,selectOtherMonths:!1,showWeek:!1,calculateWeek:this.iso8601Week,shortYearCutoff:"+10",minDate:null,maxDate:null,duration:"fast",beforeShowDay:null,beforeShow:null,onSelect:null,onChangeMonthYear:null,onClose:null,numberOfMonths:1,showCurrentAtPos:0,stepMonths:1,stepBigMonths:12,altField:"",altFormat:"",constrainInput:!0,showButtonPanel:!1,autoSize:!1,disabled:!1},v.extend(this._defaults,this.regional[""]),this.regional.en=v.extend(!0,{},this.regional[""]),this.regional["en-US"]=v.extend(!0,{},this.regional.en),this.dpDiv=a(v("<div id='"+this._mainDivId+"' class='ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>"))}function a(e){var t="button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a";return e.on("mouseout",t,function(){v(this).removeClass("ui-state-hover"),-1!==this.className.indexOf("ui-datepicker-prev")&&v(this).removeClass("ui-datepicker-prev-hover"),-1!==this.className.indexOf("ui-datepicker-next")&&v(this).removeClass("ui-datepicker-next-hover")}).on("mouseover",t,r)}function r(){v.datepicker._isDisabledDatepicker((n.inline?n.dpDiv.parent():n.input)[0])||(v(this).parents(".ui-datepicker-calendar").find("a").removeClass("ui-state-hover"),v(this).addClass("ui-state-hover"),-1!==this.className.indexOf("ui-datepicker-prev")&&v(this).addClass("ui-datepicker-prev-hover"),-1!==this.className.indexOf("ui-datepicker-next")&&v(this).addClass("ui-datepicker-next-hover"))}function c(e,t){for(var a in v.extend(e,t),t)null==t[a]&&(e[a]=t[a])}return v.extend(v.ui,{datepicker:{version:"1.12.1"}}),v.extend(e.prototype,{markerClassName:"hasDatepicker",maxRows:4,_widgetDatepicker:function(){return this.dpDiv},setDefaults:function(e){return c(this._defaults,e||{}),this},_attachDatepicker:function(e,t){var a,i=e.nodeName.toLowerCase(),s="div"===i||"span"===i;e.id||(this.uuid+=1,e.id="dp"+this.uuid),(a=this._newInst(v(e),s)).settings=v.extend({},t||{}),"input"===i?this._connectDatepicker(e,a):s&&this._inlineDatepicker(e,a)},_newInst:function(e,t){return{id:e[0].id.replace(/([^A-Za-z0-9_\-])/g,"\\\\$1"),input:e,selectedDay:0,selectedMonth:0,selectedYear:0,drawMonth:0,drawYear:0,inline:t,dpDiv:t?a(v("<div class='"+this._inlineClass+" ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>")):this.dpDiv}},_connectDatepicker:function(e,t){var a=v(e);t.append=v([]),t.trigger=v([]),a.hasClass(this.markerClassName)||(this._attachments(a,t),a.addClass(this.markerClassName).on("keydown",this._doKeyDown).on("keypress",this._doKeyPress).on("keyup",this._doKeyUp),this._autoSize(t),v.data(e,"datepicker",t),t.settings.disabled&&this._disableDatepicker(e))},_attachments:function(e,t){var a,i=this._get(t,"appendText"),s=this._get(t,"isRTL");t.append&&t.append.remove(),i&&(t.append=v("<span class='"+this._appendClass+"'>"+i+"</span>"),e[s?"before":"after"](t.append)),e.off("focus",this._showDatepicker),t.trigger&&t.trigger.remove(),"focus"!==(i=this._get(t,"showOn"))&&"both"!==i||e.on("focus",this._showDatepicker),"button"!==i&&"both"!==i||(i=this._get(t,"buttonText"),a=this._get(t,"buttonImage"),t.trigger=v(this._get(t,"buttonImageOnly")?v("<img/>").addClass(this._triggerClass).attr({src:a,alt:i,title:i}):v("<button type='button'></button>").addClass(this._triggerClass).html(a?v("<img/>").attr({src:a,alt:i,title:i}):i)),e[s?"before":"after"](t.trigger),t.trigger.on("click",function(){return v.datepicker._datepickerShowing&&v.datepicker._lastInput===e[0]?v.datepicker._hideDatepicker():(v.datepicker._datepickerShowing&&v.datepicker._lastInput!==e[0]&&v.datepicker._hideDatepicker(),v.datepicker._showDatepicker(e[0])),!1}))},_autoSize:function(e){var t,a,i,s,n,r;this._get(e,"autoSize")&&!e.inline&&(n=new Date(2009,11,20),(r=this._get(e,"dateFormat")).match(/[DM]/)&&(n.setMonth((t=function(e){for(s=i=a=0;s<e.length;s++)e[s].length>a&&(a=e[s].length,i=s);return i})(this._get(e,r.match(/MM/)?"monthNames":"monthNamesShort"))),n.setDate(t(this._get(e,r.match(/DD/)?"dayNames":"dayNamesShort"))+20-n.getDay())),e.input.attr("size",this._formatDate(e,n).length))},_inlineDatepicker:function(e,t){var a=v(e);a.hasClass(this.markerClassName)||(a.addClass(this.markerClassName).append(t.dpDiv),v.data(e,"datepicker",t),this._setDate(t,this._getDefaultDate(t),!0),this._updateDatepicker(t),this._updateAlternate(t),t.settings.disabled&&this._disableDatepicker(e),t.dpDiv.css("display","block"))},_dialogDatepicker:function(e,t,a,i,s){var n,r=this._dialogInst;return r||(this.uuid+=1,n="dp"+this.uuid,this._dialogInput=v("<input type='text' id='"+n+"' style='position: absolute; top: -100px; width: 0px;'/>"),this._dialogInput.on("keydown",this._doKeyDown),v("body").append(this._dialogInput),(r=this._dialogInst=this._newInst(this._dialogInput,!1)).settings={},v.data(this._dialogInput[0],"datepicker",r)),c(r.settings,i||{}),t=t&&t.constructor===Date?this._formatDate(r,t):t,this._dialogInput.val(t),this._pos=s?s.length?s:[s.pageX,s.pageY]:null,this._pos||(n=document.documentElement.clientWidth,i=document.documentElement.clientHeight,t=document.documentElement.scrollLeft||document.body.scrollLeft,s=document.documentElement.scrollTop||document.body.scrollTop,this._pos=[n/2-100+t,i/2-150+s]),this._dialogInput.css("left",this._pos[0]+20+"px").css("top",this._pos[1]+"px"),r.settings.onSelect=a,this._inDialog=!0,this.dpDiv.addClass(this._dialogClass),this._showDatepicker(this._dialogInput[0]),v.blockUI&&v.blockUI(this.dpDiv),v.data(this._dialogInput[0],"datepicker",r),this},_destroyDatepicker:function(e){var t,a=v(e),i=v.data(e,"datepicker");a.hasClass(this.markerClassName)&&(t=e.nodeName.toLowerCase(),v.removeData(e,"datepicker"),"input"===t?(i.append.remove(),i.trigger.remove(),a.removeClass(this.markerClassName).off("focus",this._showDatepicker).off("keydown",this._doKeyDown).off("keypress",this._doKeyPress).off("keyup",this._doKeyUp)):"div"!==t&&"span"!==t||a.removeClass(this.markerClassName).empty(),n===i)&&(n=null)},_enableDatepicker:function(t){var e,a=v(t),i=v.data(t,"datepicker");a.hasClass(this.markerClassName)&&("input"===(e=t.nodeName.toLowerCase())?(t.disabled=!1,i.trigger.filter("button").each(function(){this.disabled=!1}).end().filter("img").css({opacity:"1.0",cursor:""})):"div"!==e&&"span"!==e||((i=a.children("."+this._inlineClass)).children().removeClass("ui-state-disabled"),i.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled",!1)),this._disabledInputs=v.map(this._disabledInputs,function(e){return e===t?null:e}))},_disableDatepicker:function(t){var e,a=v(t),i=v.data(t,"datepicker");a.hasClass(this.markerClassName)&&("input"===(e=t.nodeName.toLowerCase())?(t.disabled=!0,i.trigger.filter("button").each(function(){this.disabled=!0}).end().filter("img").css({opacity:"0.5",cursor:"default"})):"div"!==e&&"span"!==e||((i=a.children("."+this._inlineClass)).children().addClass("ui-state-disabled"),i.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled",!0)),this._disabledInputs=v.map(this._disabledInputs,function(e){return e===t?null:e}),this._disabledInputs[this._disabledInputs.length]=t)},_isDisabledDatepicker:function(e){if(e)for(var t=0;t<this._disabledInputs.length;t++)if(this._disabledInputs[t]===e)return!0;return!1},_getInst:function(e){try{return v.data(e,"datepicker")}catch(t){throw"Missing instance data for this datepicker"}},_optionDatepicker:function(e,t,a){var i,s,n,r,d=this._getInst(e);if(2===arguments.length&&"string"==typeof t)return"defaults"===t?v.extend({},v.datepicker._defaults):d?"all"===t?v.extend({},d.settings):this._get(d,t):null;i=t||{},"string"==typeof t&&((i={})[t]=a),d&&(this._curInst===d&&this._hideDatepicker(),s=this._getDateDatepicker(e,!0),n=this._getMinMaxDate(d,"min"),r=this._getMinMaxDate(d,"max"),c(d.settings,i),null!==n&&i.dateFormat!==undefined&&i.minDate===undefined&&(d.settings.minDate=this._formatDate(d,n)),null!==r&&i.dateFormat!==undefined&&i.maxDate===undefined&&(d.settings.maxDate=this._formatDate(d,r)),"disabled"in i&&(i.disabled?this._disableDatepicker(e):this._enableDatepicker(e)),this._attachments(v(e),d),this._autoSize(d),this._setDate(d,s),this._updateAlternate(d),this._updateDatepicker(d))},_changeDatepicker:function(e,t,a){this._optionDatepicker(e,t,a)},_refreshDatepicker:function(e){e=this._getInst(e);e&&this._updateDatepicker(e)},_setDateDatepicker:function(e,t){e=this._getInst(e);e&&(this._setDate(e,t),this._updateDatepicker(e),this._updateAlternate(e))},_getDateDatepicker:function(e,t){e=this._getInst(e);return e&&!e.inline&&this._setDateFromField(e,t),e?this._getDate(e):null},_doKeyDown:function(e){var t,a,i=v.datepicker._getInst(e.target),s=!0,n=i.dpDiv.is(".ui-datepicker-rtl");if(i._keyEvent=!0,v.datepicker._datepickerShowing)switch(e.keyCode){case 9:v.datepicker._hideDatepicker(),s=!1;break;case 13:return(a=v("td."+v.datepicker._dayOverClass+":not(."+v.datepicker._currentClass+")",i.dpDiv))[0]&&v.datepicker._selectDay(e.target,i.selectedMonth,i.selectedYear,a[0]),(a=v.datepicker._get(i,"onSelect"))?(t=v.datepicker._formatDate(i),a.apply(i.input?i.input[0]:null,[t,i])):v.datepicker._hideDatepicker(),!1;case 27:v.datepicker._hideDatepicker();break;case 33:v.datepicker._adjustDate(e.target,e.ctrlKey?-v.datepicker._get(i,"stepBigMonths"):-v.datepicker._get(i,"stepMonths"),"M");break;case 34:v.datepicker._adjustDate(e.target,e.ctrlKey?+v.datepicker._get(i,"stepBigMonths"):+v.datepicker._get(i,"stepMonths"),"M");break;case 35:(e.ctrlKey||e.metaKey)&&v.datepicker._clearDate(e.target),s=e.ctrlKey||e.metaKey;break;case 36:(e.ctrlKey||e.metaKey)&&v.datepicker._gotoToday(e.target),s=e.ctrlKey||e.metaKey;break;case 37:(e.ctrlKey||e.metaKey)&&v.datepicker._adjustDate(e.target,n?1:-1,"D"),s=e.ctrlKey||e.metaKey,e.originalEvent.altKey&&v.datepicker._adjustDate(e.target,e.ctrlKey?-v.datepicker._get(i,"stepBigMonths"):-v.datepicker._get(i,"stepMonths"),"M");break;case 38:(e.ctrlKey||e.metaKey)&&v.datepicker._adjustDate(e.target,-7,"D"),s=e.ctrlKey||e.metaKey;break;case 39:(e.ctrlKey||e.metaKey)&&v.datepicker._adjustDate(e.target,n?-1:1,"D"),s=e.ctrlKey||e.metaKey,e.originalEvent.altKey&&v.datepicker._adjustDate(e.target,e.ctrlKey?+v.datepicker._get(i,"stepBigMonths"):+v.datepicker._get(i,"stepMonths"),"M");break;case 40:(e.ctrlKey||e.metaKey)&&v.datepicker._adjustDate(e.target,7,"D"),s=e.ctrlKey||e.metaKey;break;default:s=!1}else 36===e.keyCode&&e.ctrlKey?v.datepicker._showDatepicker(this):s=!1;s&&(e.preventDefault(),e.stopPropagation())},_doKeyPress:function(e){var t,a=v.datepicker._getInst(e.target);if(v.datepicker._get(a,"constrainInput"))return a=v.datepicker._possibleChars(v.datepicker._get(a,"dateFormat")),t=String.fromCharCode(null==e.charCode?e.keyCode:e.charCode),e.ctrlKey||e.metaKey||t<" "||!a||-1<a.indexOf(t)},_doKeyUp:function(e){e=v.datepicker._getInst(e.target);if(e.input.val()!==e.lastVal)try{v.datepicker.parseDate(v.datepicker._get(e,"dateFormat"),e.input?e.input.val():null,v.datepicker._getFormatConfig(e))&&(v.datepicker._setDateFromField(e),v.datepicker._updateAlternate(e),v.datepicker._updateDatepicker(e))}catch(t){}return!0},_showDatepicker:function(e){var t,a,i,s;"input"!==(e=e.target||e).nodeName.toLowerCase()&&(e=v("input",e.parentNode)[0]),v.datepicker._isDisabledDatepicker(e)||v.datepicker._lastInput===e||(s=v.datepicker._getInst(e),v.datepicker._curInst&&v.datepicker._curInst!==s&&(v.datepicker._curInst.dpDiv.stop(!0,!0),s)&&v.datepicker._datepickerShowing&&v.datepicker._hideDatepicker(v.datepicker._curInst.input[0]),!1===(a=(a=v.datepicker._get(s,"beforeShow"))?a.apply(e,[e,s]):{}))||(c(s.settings,a),s.lastVal=null,v.datepicker._lastInput=e,v.datepicker._setDateFromField(s),v.datepicker._inDialog&&(e.value=""),v.datepicker._pos||(v.datepicker._pos=v.datepicker._findPos(e),v.datepicker._pos[1]+=e.offsetHeight),t=!1,v(e).parents().each(function(){return!(t|="fixed"===v(this).css("position"))}),a={left:v.datepicker._pos[0],top:v.datepicker._pos[1]},v.datepicker._pos=null,s.dpDiv.empty(),s.dpDiv.css({position:"absolute",display:"block",top:"-1000px"}),v.datepicker._updateDatepicker(s),a=v.datepicker._checkOffset(s,a,t),s.dpDiv.css({position:v.datepicker._inDialog&&v.blockUI?"static":t?"fixed":"absolute",display:"none",left:a.left+"px",top:a.top+"px"}),s.inline)||(a=v.datepicker._get(s,"showAnim"),i=v.datepicker._get(s,"duration"),s.dpDiv.css("z-index",function(e){for(var t;e.length&&e[0]!==document;){if(("absolute"===(t=e.css("position"))||"relative"===t||"fixed"===t)&&(t=parseInt(e.css("zIndex"),10),!isNaN(t))&&0!==t)return t;e=e.parent()}return 0}(v(e))+1),v.datepicker._datepickerShowing=!0,v.effects&&v.effects.effect[a]?s.dpDiv.show(a,v.datepicker._get(s,"showOptions"),i):s.dpDiv[a||"show"](a?i:null),v.datepicker._shouldFocusInput(s)&&s.input.trigger("focus"),v.datepicker._curInst=s)},_updateDatepicker:function(e){this.maxRows=4,(n=e).dpDiv.empty().append(this._generateHTML(e)),this._attachHandlers(e);var t,a=this._getNumberOfMonths(e),i=a[1],s=e.dpDiv.find("."+this._dayOverClass+" a");0<s.length&&r.apply(s.get(0)),e.dpDiv.removeClass("ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4").width(""),1<i&&e.dpDiv.addClass("ui-datepicker-multi-"+i).css("width",17*i+"em"),e.dpDiv[(1!==a[0]||1!==a[1]?"add":"remove")+"Class"]("ui-datepicker-multi"),e.dpDiv[(this._get(e,"isRTL")?"add":"remove")+"Class"]("ui-datepicker-rtl"),e===v.datepicker._curInst&&v.datepicker._datepickerShowing&&v.datepicker._shouldFocusInput(e)&&e.input.trigger("focus"),e.yearshtml&&(t=e.yearshtml,setTimeout(function(){t===e.yearshtml&&e.yearshtml&&e.dpDiv.find("select.ui-datepicker-year:first").replaceWith(e.yearshtml),t=e.yearshtml=null},0))},_shouldFocusInput:function(e){return e.input&&e.input.is(":visible")&&!e.input.is(":disabled")&&!e.input.is(":focus")},_checkOffset:function(e,t,a){var i=e.dpDiv.outerWidth(),s=e.dpDiv.outerHeight(),n=e.input?e.input.outerWidth():0,r=e.input?e.input.outerHeight():0,d=document.documentElement.clientWidth+(a?0:v(document).scrollLeft()),c=document.documentElement.clientHeight+(a?0:v(document).scrollTop());return t.left-=this._get(e,"isRTL")?i-n:0,t.left-=a&&t.left===e.input.offset().left?v(document).scrollLeft():0,t.top-=a&&t.top===e.input.offset().top+r?v(document).scrollTop():0,t.left-=Math.min(t.left,t.left+i>d&&i<d?Math.abs(t.left+i-d):0),t.top-=Math.min(t.top,t.top+s>c&&s<c?Math.abs(s+r):0),t},_findPos:function(e){for(var t=this._getInst(e),a=this._get(t,"isRTL");e&&("hidden"===e.type||1!==e.nodeType||v.expr.filters.hidden(e));)e=e[a?"previousSibling":"nextSibling"];return[(t=v(e).offset()).left,t.top]},_hideDatepicker:function(e){var t,a,i=this._curInst;!i||e&&i!==v.data(e,"datepicker")||this._datepickerShowing&&(e=this._get(i,"showAnim"),a=this._get(i,"duration"),t=function(){v.datepicker._tidyDialog(i)},v.effects&&(v.effects.effect[e]||v.effects[e])?i.dpDiv.hide(e,v.datepicker._get(i,"showOptions"),a,t):i.dpDiv["slideDown"===e?"slideUp":"fadeIn"===e?"fadeOut":"hide"](e?a:null,t),e||t(),this._datepickerShowing=!1,(a=this._get(i,"onClose"))&&a.apply(i.input?i.input[0]:null,[i.input?i.input.val():"",i]),this._lastInput=null,this._inDialog&&(this._dialogInput.css({position:"absolute",left:"0",top:"-100px"}),v.blockUI)&&(v.unblockUI(),v("body").append(this.dpDiv)),this._inDialog=!1)},_tidyDialog:function(e){e.dpDiv.removeClass(this._dialogClass).off(".ui-datepicker-calendar")},_checkExternalClick:function(e){var t;v.datepicker._curInst&&(e=v(e.target),t=v.datepicker._getInst(e[0]),!(e[0].id===v.datepicker._mainDivId||0!==e.parents("#"+v.datepicker._mainDivId).length||e.hasClass(v.datepicker.markerClassName)||e.closest("."+v.datepicker._triggerClass).length||!v.datepicker._datepickerShowing||v.datepicker._inDialog&&v.blockUI)||e.hasClass(v.datepicker.markerClassName)&&v.datepicker._curInst!==t)&&v.datepicker._hideDatepicker()},_adjustDate:function(e,t,a){var e=v(e),i=this._getInst(e[0]);this._isDisabledDatepicker(e[0])||(this._adjustInstDate(i,t+("M"===a?this._get(i,"showCurrentAtPos"):0),a),this._updateDatepicker(i))},_gotoToday:function(e){var t,e=v(e),a=this._getInst(e[0]);this._get(a,"gotoCurrent")&&a.currentDay?(a.selectedDay=a.currentDay,a.drawMonth=a.selectedMonth=a.currentMonth,a.drawYear=a.selectedYear=a.currentYear):(t=new Date,a.selectedDay=t.getDate(),a.drawMonth=a.selectedMonth=t.getMonth(),a.drawYear=a.selectedYear=t.getFullYear()),this._notifyChange(a),this._adjustDate(e)},_selectMonthYear:function(e,t,a){var e=v(e),i=this._getInst(e[0]);i["selected"+("M"===a?"Month":"Year")]=i["draw"+("M"===a?"Month":"Year")]=parseInt(t.options[t.selectedIndex].value,10),this._notifyChange(i),this._adjustDate(e)},_selectDay:function(e,t,a,i){var s=v(e);v(i).hasClass(this._unselectableClass)||this._isDisabledDatepicker(s[0])||((s=this._getInst(s[0])).selectedDay=s.currentDay=v("a",i).html(),s.selectedMonth=s.currentMonth=t,s.selectedYear=s.currentYear=a,this._selectDate(e,this._formatDate(s,s.currentDay,s.currentMonth,s.currentYear)))},_clearDate:function(e){e=v(e);this._selectDate(e,"")},_selectDate:function(e,t){var a,e=v(e),e=this._getInst(e[0]);t=null!=t?t:this._formatDate(e),e.input&&e.input.val(t),this._updateAlternate(e),(a=this._get(e,"onSelect"))?a.apply(e.input?e.input[0]:null,[t,e]):e.input&&e.input.trigger("change"),e.inline?this._updateDatepicker(e):(this._hideDatepicker(),this._lastInput=e.input[0],"object"!=typeof e.input[0]&&e.input.trigger("focus"),this._lastInput=null)},_updateAlternate:function(e){var t,a,i=this._get(e,"altField");i&&(a=this._get(e,"altFormat")||this._get(e,"dateFormat"),t=this._getDate(e),a=this.formatDate(a,t,this._getFormatConfig(e)),v(i).val(a))},noWeekends:function(e){e=e.getDay();return[0<e&&e<6,""]},iso8601Week:function(e){var t,e=new Date(e.getTime());return e.setDate(e.getDate()+4-(e.getDay()||7)),t=e.getTime(),e.setMonth(0),e.setDate(1),Math.floor(Math.round((t-e)/864e5)/7)+1},parseDate:function(t,s,e){if(null==t||null==s)throw"Invalid arguments";if(""===(s="object"==typeof s?s.toString():s+""))return null;for(var a,i,n=0,r=(e?e.shortYearCutoff:null)||this._defaults.shortYearCutoff,r="string"!=typeof r?r:(new Date).getFullYear()%100+parseInt(r,10),d=(e?e.dayNamesShort:null)||this._defaults.dayNamesShort,c=(e?e.dayNames:null)||this._defaults.dayNames,o=(e?e.monthNamesShort:null)||this._defaults.monthNamesShort,l=(e?e.monthNames:null)||this._defaults.monthNames,h=-1,u=-1,p=-1,g=-1,_=!1,f=function(e){e=y+1<t.length&&t.charAt(y+1)===e;return e&&y++,e},k=function(e){var t=f(e),t="@"===e?14:"!"===e?20:"y"===e&&t?4:"o"===e?3:2,e=new RegExp("^\\d{"+("y"===e?t:1)+","+t+"}"),t=s.substring(n).match(e);if(t)return n+=t[0].length,parseInt(t[0],10);throw"Missing number at position "+n},D=function(e,t,a){var i=-1,e=v.map(f(e)?a:t,function(e,t){return[[t,e]]}).sort(function(e,t){return-(e[1].length-t[1].length)});if(v.each(e,function(e,t){var a=t[1];if(s.substr(n,a.length).toLowerCase()===a.toLowerCase())return i=t[0],n+=a.length,!1}),-1!==i)return i+1;throw"Unknown name at position "+n},m=function(){if(s.charAt(n)!==t.charAt(y))throw"Unexpected literal at position "+n;n++},y=0;y<t.length;y++)if(_)"'"!==t.charAt(y)||f("'")?m():_=!1;else switch(t.charAt(y)){case"d":p=k("d");break;case"D":D("D",d,c);break;case"o":g=k("o");break;case"m":u=k("m");break;case"M":u=D("M",o,l);break;case"y":h=k("y");break;case"@":h=(i=new Date(k("@"))).getFullYear(),u=i.getMonth()+1,p=i.getDate();break;case"!":h=(i=new Date((k("!")-this._ticksTo1970)/1e4)).getFullYear(),u=i.getMonth()+1,p=i.getDate();break;case"'":f("'")?m():_=!0;break;default:m()}if(n<s.length&&(e=s.substr(n),!/^\s+/.test(e)))throw"Extra/unparsed characters found in date: "+e;if(-1===h?h=(new Date).getFullYear():h<100&&(h+=(new Date).getFullYear()-(new Date).getFullYear()%100+(h<=r?0:-100)),-1<g)for(u=1,p=g;;){if(p<=(a=this._getDaysInMonth(h,u-1)))break;u++,p-=a}if((i=this._daylightSavingAdjust(new Date(h,u-1,p))).getFullYear()!==h||i.getMonth()+1!==u||i.getDate()!==p)throw"Invalid date";return i},ATOM:"yy-mm-dd",COOKIE:"D, dd M yy",ISO_8601:"yy-mm-dd",RFC_822:"D, d M y",RFC_850:"DD, dd-M-y",RFC_1036:"D, d M y",RFC_1123:"D, d M yy",RFC_2822:"D, d M yy",RSS:"D, d M y",TICKS:"!",TIMESTAMP:"@",W3C:"yy-mm-dd",_ticksTo1970:24*(718685+Math.floor(492.5)-Math.floor(19.7)+Math.floor(4.925))*60*60*1e7,formatDate:function(t,e,a){if(!e)return"";var i,s=(a?a.dayNamesShort:null)||this._defaults.dayNamesShort,n=(a?a.dayNames:null)||this._defaults.dayNames,r=(a?a.monthNamesShort:null)||this._defaults.monthNamesShort,d=(a?a.monthNames:null)||this._defaults.monthNames,c=function(e){e=i+1<t.length&&t.charAt(i+1)===e;return e&&i++,e},o=function(e,t,a){var i=""+t;if(c(e))for(;i.length<a;)i="0"+i;return i},l=function(e,t,a,i){return(c(e)?i:a)[t]},h="",u=!1;if(e)for(i=0;i<t.length;i++)if(u)"'"!==t.charAt(i)||c("'")?h+=t.charAt(i):u=!1;else switch(t.charAt(i)){case"d":h+=o("d",e.getDate(),2);break;case"D":h+=l("D",e.getDay(),s,n);break;case"o":h+=o("o",Math.round((new Date(e.getFullYear(),e.getMonth(),e.getDate()).getTime()-new Date(e.getFullYear(),0,0).getTime())/864e5),3);break;case"m":h+=o("m",e.getMonth()+1,2);break;case"M":h+=l("M",e.getMonth(),r,d);break;case"y":h+=c("y")?e.getFullYear():(e.getFullYear()%100<10?"0":"")+e.getFullYear()%100;break;case"@":h+=e.getTime();break;case"!":h+=1e4*e.getTime()+this._ticksTo1970;break;case"'":c("'")?h+="'":u=!0;break;default:h+=t.charAt(i)}return h},_possibleChars:function(t){for(var e="",a=!1,i=function(e){e=s+1<t.length&&t.charAt(s+1)===e;return e&&s++,e},s=0;s<t.length;s++)if(a)"'"!==t.charAt(s)||i("'")?e+=t.charAt(s):a=!1;else switch(t.charAt(s)){case"d":case"m":case"y":case"@":e+="0123456789";break;case"D":case"M":return null;case"'":i("'")?e+="'":a=!0;break;default:e+=t.charAt(s)}return e},_get:function(e,t){return(e.settings[t]!==undefined?e.settings:this._defaults)[t]},_setDateFromField:function(e,t){if(e.input.val()!==e.lastVal){var a=this._get(e,"dateFormat"),i=e.lastVal=e.input?e.input.val():null,s=this._getDefaultDate(e),n=s,r=this._getFormatConfig(e);try{n=this.parseDate(a,i,r)||s}catch(d){i=t?"":i}e.selectedDay=n.getDate(),e.drawMonth=e.selectedMonth=n.getMonth(),e.drawYear=e.selectedYear=n.getFullYear(),e.currentDay=i?n.getDate():0,e.currentMonth=i?n.getMonth():0,e.currentYear=i?n.getFullYear():0,this._adjustInstDate(e)}},_getDefaultDate:function(e){return this._restrictMinMax(e,this._determineDate(e,this._get(e,"defaultDate"),new Date))},_determineDate:function(c,e,t){var a,i=null==e||""===e?t:"string"==typeof e?function(e){try{return v.datepicker.parseDate(v.datepicker._get(c,"dateFormat"),e,v.datepicker._getFormatConfig(c))}catch(d){}for(var t=(e.toLowerCase().match(/^c/)?v.datepicker._getDate(c):null)||new Date,a=t.getFullYear(),i=t.getMonth(),s=t.getDate(),n=/([+\-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g,r=n.exec(e);r;){switch(r[2]||"d"){case"d":case"D":s+=parseInt(r[1],10);break;case"w":case"W":s+=7*parseInt(r[1],10);break;case"m":case"M":i+=parseInt(r[1],10),s=Math.min(s,v.datepicker._getDaysInMonth(a,i));break;case"y":case"Y":a+=parseInt(r[1],10),s=Math.min(s,v.datepicker._getDaysInMonth(a,i))}r=n.exec(e)}return new Date(a,i,s)}(e):"number"==typeof e?isNaN(e)?t:(i=e,(a=new Date).setDate(a.getDate()+i),a):new Date(e.getTime());return(i=i&&"Invalid Date"===i.toString()?t:i)&&(i.setHours(0),i.setMinutes(0),i.setSeconds(0),i.setMilliseconds(0)),this._daylightSavingAdjust(i)},_daylightSavingAdjust:function(e){return e?(e.setHours(12<e.getHours()?e.getHours()+2:0),e):null},_setDate:function(e,t,a){var i=!t,s=e.selectedMonth,n=e.selectedYear,t=this._restrictMinMax(e,this._determineDate(e,t,new Date));e.selectedDay=e.currentDay=t.getDate(),e.drawMonth=e.selectedMonth=e.currentMonth=t.getMonth(),e.drawYear=e.selectedYear=e.currentYear=t.getFullYear(),s===e.selectedMonth&&n===e.selectedYear||a||this._notifyChange(e),this._adjustInstDate(e),e.input&&e.input.val(i?"":this._formatDate(e))},_getDate:function(e){return!e.currentYear||e.input&&""===e.input.val()?null:this._daylightSavingAdjust(new Date(e.currentYear,e.currentMonth,e.currentDay))},_attachHandlers:function(e){var t=this._get(e,"stepMonths"),a="#"+e.id.replace(/\\\\/g,"\\");e.dpDiv.find("[data-handler]").map(function(){var e={prev:function(){v.datepicker._adjustDate(a,-t,"M")},next:function(){v.datepicker._adjustDate(a,+t,"M")},hide:function(){v.datepicker._hideDatepicker()},today:function(){v.datepicker._gotoToday(a)},selectDay:function(){return v.datepicker._selectDay(a,+this.getAttribute("data-month"),+this.getAttribute("data-year"),this),!1},selectMonth:function(){return v.datepicker._selectMonthYear(a,this,"M"),!1},selectYear:function(){return v.datepicker._selectMonthYear(a,this,"Y"),!1}};v(this).on(this.getAttribute("data-event"),e[this.getAttribute("data-handler")])})},_generateHTML:function(e){var t,a,i,s,n,O,R,L,W,r,d,E,c,o,l,h,u,p,g,_,f,k,H,D,m,y,v,P,U,M,b,w,C=new Date,z=this._daylightSavingAdjust(new Date(C.getFullYear(),C.getMonth(),C.getDate())),I=this._get(e,"isRTL"),C=this._get(e,"showButtonPanel"),x=this._get(e,"hideIfNoPrevNext"),Y=this._get(e,"navigationAsDateFormat"),S=this._getNumberOfMonths(e),F=this._get(e,"showCurrentAtPos"),N=this._get(e,"stepMonths"),B=1!==S[0]||1!==S[1],J=this._daylightSavingAdjust(e.currentDay?new Date(e.currentYear,e.currentMonth,e.currentDay):new Date(9999,9,9)),T=this._getMinMaxDate(e,"min"),A=this._getMinMaxDate(e,"max"),K=e.drawMonth-F,j=e.drawYear;if(K<0&&(K+=12,j--),A)for(t=this._daylightSavingAdjust(new Date(A.getFullYear(),A.getMonth()-S[0]*S[1]+1,A.getDate())),t=T&&t<T?T:t;this._daylightSavingAdjust(new Date(j,K,1))>t;)--K<0&&(K=11,j--);for(e.drawMonth=K,e.drawYear=j,F=this._get(e,"prevText"),F=Y?this.formatDate(F,this._daylightSavingAdjust(new Date(j,K-N,1)),this._getFormatConfig(e)):F,a=this._canAdjustMonth(e,-1,j,K)?"<a class='ui-datepicker-prev ui-corner-all' data-handler='prev' data-event='click' title='"+F+"'><span class='ui-icon ui-icon-circle-triangle-"+(I?"e":"w")+"'>"+F+"</span></a>":x?"":"<a class='ui-datepicker-prev ui-corner-all ui-state-disabled' title='"+F+"'><span class='ui-icon ui-icon-circle-triangle-"+(I?"e":"w")+"'>"+F+"</span></a>",F=this._get(e,"nextText"),F=Y?this.formatDate(F,this._daylightSavingAdjust(new Date(j,K+N,1)),this._getFormatConfig(e)):F,i=this._canAdjustMonth(e,1,j,K)?"<a class='ui-datepicker-next ui-corner-all' data-handler='next' data-event='click' title='"+F+"'><span class='ui-icon ui-icon-circle-triangle-"+(I?"w":"e")+"'>"+F+"</span></a>":x?"":"<a class='ui-datepicker-next ui-corner-all ui-state-disabled' title='"+F+"'><span class='ui-icon ui-icon-circle-triangle-"+(I?"w":"e")+"'>"+F+"</span></a>",N=this._get(e,"currentText"),x=this._get(e,"gotoCurrent")&&e.currentDay?J:z,N=Y?this.formatDate(N,x,this._getFormatConfig(e)):N,F=e.inline?"":"<button type='button' class='ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all' data-handler='hide' data-event='click'>"+this._get(e,"closeText")+"</button>",Y=C?"<div class='ui-datepicker-buttonpane ui-widget-content'>"+(I?F:"")+(this._isInRange(e,x)?"<button type='button' class='ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all' data-handler='today' data-event='click'>"+N+"</button>":"")+(I?"":F)+"</div>":"",s=parseInt(this._get(e,"firstDay"),10),s=isNaN(s)?0:s,n=this._get(e,"showWeek"),O=this._get(e,"dayNames"),R=this._get(e,"dayNamesMin"),L=this._get(e,"monthNames"),W=this._get(e,"monthNamesShort"),r=this._get(e,"beforeShowDay"),d=this._get(e,"showOtherMonths"),E=this._get(e,"selectOtherMonths"),c=this._getDefaultDate(e),o="",h=0;h<S[0];h++){for(u="",this.maxRows=4,p=0;p<S[1];p++){if(g=this._daylightSavingAdjust(new Date(j,K,e.selectedDay)),_=" ui-corner-all",f="",B){if(f+="<div class='ui-datepicker-group",1<S[1])switch(p){case 0:f+=" ui-datepicker-group-first",_=" ui-corner-"+(I?"right":"left");break;case S[1]-1:f+=" ui-datepicker-group-last",_=" ui-corner-"+(I?"left":"right");break;default:f+=" ui-datepicker-group-middle",_=""}f+="'>"}for(f+="<div class='ui-datepicker-header ui-widget-header ui-helper-clearfix"+_+"'>"+(/all|left/.test(_)&&0===h?I?i:a:"")+(/all|right/.test(_)&&0===h?I?a:i:"")+this._generateMonthYearHeader(e,K,j,T,A,0<h||0<p,L,W)+"</div><table class='ui-datepicker-calendar'><thead><tr>",k=n?"<th class='ui-datepicker-week-col'>"+this._get(e,"weekHeader")+"</th>":"",l=0;l<7;l++)k+="<th scope='col'"+(5<=(l+s+6)%7?" class='ui-datepicker-week-end'":"")+"><span title='"+O[H=(l+s)%7]+"'>"+R[H]+"</span></th>";for(f+=k+"</tr></thead><tbody>",m=this._getDaysInMonth(j,K),j===e.selectedYear&&K===e.selectedMonth&&(e.selectedDay=Math.min(e.selectedDay,m)),D=(this._getFirstDayOfMonth(j,K)-s+7)%7,m=Math.ceil((D+m)/7),y=B&&this.maxRows>m?this.maxRows:m,this.maxRows=y,v=this._daylightSavingAdjust(new Date(j,K,1-D)),P=0;P<y;P++){for(f+="<tr>",U=n?"<td class='ui-datepicker-week-col'>"+this._get(e,"calculateWeek")(v)+"</td>":"",l=0;l<7;l++)M=r?r.apply(e.input?e.input[0]:null,[v]):[!0,""],w=(b=v.getMonth()!==K)&&!E||!M[0]||T&&v<T||A&&A<v,U+="<td class='"+(5<=(l+s+6)%7?" ui-datepicker-week-end":"")+(b?" ui-datepicker-other-month":"")+(v.getTime()===g.getTime()&&K===e.selectedMonth&&e._keyEvent||c.getTime()===v.getTime()&&c.getTime()===g.getTime()?" "+this._dayOverClass:"")+(w?" "+this._unselectableClass+" ui-state-disabled":"")+(b&&!d?"":" "+M[1]+(v.getTime()===J.getTime()?" "+this._currentClass:"")+(v.getTime()===z.getTime()?" ui-datepicker-today":""))+"'"+(b&&!d||!M[2]?"":" title='"+M[2].replace(/'/g,"&#39;")+"'")+(w?"":" data-handler='selectDay' data-event='click' data-month='"+v.getMonth()+"' data-year='"+v.getFullYear()+"'")+">"+(b&&!d?"&#xa0;":w?"<span class='ui-state-default'>"+v.getDate()+"</span>":"<a class='ui-state-default"+(v.getTime()===z.getTime()?" ui-state-highlight":"")+(v.getTime()===J.getTime()?" ui-state-active":"")+(b?" ui-priority-secondary":"")+"' href='#'>"+v.getDate()+"</a>")+"</td>",v.setDate(v.getDate()+1),v=this._daylightSavingAdjust(v);f+=U+"</tr>"}11<++K&&(K=0,j++),u+=f+="</tbody></table>"+(B?"</div>"+(0<S[0]&&p===S[1]-1?"<div class='ui-datepicker-row-break'></div>":""):"")}o+=u}return o+=Y,e._keyEvent=!1,o},_generateMonthYearHeader:function(e,t,a,i,s,n,r,d){var c,o,l,h,u,p,g,_=this._get(e,"changeMonth"),f=this._get(e,"changeYear"),k=this._get(e,"showMonthAfterYear"),D="<div class='ui-datepicker-title'>",m="";if(n||!_)m+="<span class='ui-datepicker-month'>"+r[t]+"</span>";else{for(c=i&&i.getFullYear()===a,o=s&&s.getFullYear()===a,m+="<select class='ui-datepicker-month' data-handler='selectMonth' data-event='change'>",l=0;l<12;l++)(!c||l>=i.getMonth())&&(!o||l<=s.getMonth())&&(m+="<option value='"+l+"'"+(l===t?" selected='selected'":"")+">"+d[l]+"</option>");m+="</select>"}if(k||(D+=m+(!n&&_&&f?"":"&#xa0;")),!e.yearshtml)if(e.yearshtml="",n||!f)D+="<span class='ui-datepicker-year'>"+a+"</span>";else{for(r=this._get(e,"yearRange").split(":"),h=(new Date).getFullYear(),p=(u=function(e){e=e.match(/c[+\-].*/)?a+parseInt(e.substring(1),10):e.match(/[+\-].*/)?h+parseInt(e,10):parseInt(e,10);return isNaN(e)?h:e})(r[0]),g=Math.max(p,u(r[1]||"")),p=i?Math.max(p,i.getFullYear()):p,g=s?Math.min(g,s.getFullYear()):g,e.yearshtml+="<select class='ui-datepicker-year' data-handler='selectYear' data-event='change'>";p<=g;p++)e.yearshtml+="<option value='"+p+"'"+(p===a?" selected='selected'":"")+">"+p+"</option>";e.yearshtml+="</select>",D+=e.yearshtml,e.yearshtml=null}return D+=this._get(e,"yearSuffix"),k&&(D+=(!n&&_&&f?"":"&#xa0;")+m),D+="</div>"},_adjustInstDate:function(e,t,a){var i=e.selectedYear+("Y"===a?t:0),s=e.selectedMonth+("M"===a?t:0),t=Math.min(e.selectedDay,this._getDaysInMonth(i,s))+("D"===a?t:0),i=this._restrictMinMax(e,this._daylightSavingAdjust(new Date(i,s,t)));e.selectedDay=i.getDate(),e.drawMonth=e.selectedMonth=i.getMonth(),e.drawYear=e.selectedYear=i.getFullYear(),"M"!==a&&"Y"!==a||this._notifyChange(e)},_restrictMinMax:function(e,t){var a=this._getMinMaxDate(e,"min"),e=this._getMinMaxDate(e,"max"),a=a&&t<a?a:t;return e&&e<a?e:a},_notifyChange:function(e){var t=this._get(e,"onChangeMonthYear");t&&t.apply(e.input?e.input[0]:null,[e.selectedYear,e.selectedMonth+1,e])},_getNumberOfMonths:function(e){e=this._get(e,"numberOfMonths");return null==e?[1,1]:"number"==typeof e?[1,e]:e},_getMinMaxDate:function(e,t){return this._determineDate(e,this._get(e,t+"Date"),null)},_getDaysInMonth:function(e,t){return 32-this._daylightSavingAdjust(new Date(e,t,32)).getDate()},_getFirstDayOfMonth:function(e,t){return new Date(e,t,1).getDay()},_canAdjustMonth:function(e,t,a,i){var s=this._getNumberOfMonths(e),a=this._daylightSavingAdjust(new Date(a,i+(t<0?t:s[0]*s[1]),1));return t<0&&a.setDate(this._getDaysInMonth(a.getFullYear(),a.getMonth())),this._isInRange(e,a)},_isInRange:function(e,t){var a,i=this._getMinMaxDate(e,"min"),s=this._getMinMaxDate(e,"max"),n=null,r=null,e=this._get(e,"yearRange");return e&&(e=e.split(":"),a=(new Date).getFullYear(),n=parseInt(e[0],10),r=parseInt(e[1],10),e[0].match(/[+\-].*/)&&(n+=a),e[1].match(/[+\-].*/))&&(r+=a),(!i||t.getTime()>=i.getTime())&&(!s||t.getTime()<=s.getTime())&&(!n||t.getFullYear()>=n)&&(!r||t.getFullYear()<=r)},_getFormatConfig:function(e){var t=this._get(e,"shortYearCutoff");return{shortYearCutoff:"string"!=typeof t?t:(new Date).getFullYear()%100+parseInt(t,10),dayNamesShort:this._get(e,"dayNamesShort"),dayNames:this._get(e,"dayNames"),monthNamesShort:this._get(e,"monthNamesShort"),monthNames:this._get(e,"monthNames")}},_formatDate:function(e,t,a,i){t||(e.currentDay=e.selectedDay,e.currentMonth=e.selectedMonth,e.currentYear=e.selectedYear);i=t?"object"==typeof t?t:this._daylightSavingAdjust(new Date(i,a,t)):this._daylightSavingAdjust(new Date(e.currentYear,e.currentMonth,e.currentDay));return this.formatDate(this._get(e,"dateFormat"),i,this._getFormatConfig(e))}}),v.fn.datepicker=function(e){if(!this.length)return this;v.datepicker.initialized||(v(document).on("mousedown",v.datepicker._checkExternalClick),v.datepicker.initialized=!0),0===v("#"+v.datepicker._mainDivId).length&&v("body").append(v.datepicker.dpDiv);var t=Array.prototype.slice.call(arguments,1);return"string"==typeof e&&("isDisabled"===e||"getDate"===e||"widget"===e)||"option"===e&&2===arguments.length&&"string"==typeof arguments[1]?v.datepicker["_"+e+"Datepicker"].apply(v.datepicker,[this[0]].concat(t)):this.each(function(){"string"==typeof e?v.datepicker["_"+e+"Datepicker"].apply(v.datepicker,[this].concat(t)):v.datepicker._attachDatepicker(this,e)})},v.datepicker=new e,v.datepicker.initialized=!1,v.datepicker.uuid=(new Date).getTime(),v.datepicker.version="1.12.1",v.datepicker});
//# sourceMappingURL=datepicker.js.map;
!function(s,l){"use strict";var r="stickyTableHeaders",t=0,o={fixedOffset:0,leftOffset:0,marginTop:0,objDocument:document,objHead:"head",objWindow:l,scrollableArea:l,cacheHeaderHeight:!1,zIndex:3};function n(e,i){var a=this;a.$el=s(e),a.el=e,a.id=t++,a.$el.bind("destroyed",s.proxy(a.teardown,a)),a.$clonedHeader=null,a.$originalHeader=null,a.cachedHeaderHeight=null,a.isSticky=!1,a.hasBeenSticky=!1,a.leftOffset=null,a.topOffset=null,a.init=function(){a.setOptions(i),a.$el.each(function(){var e=s(this);e.css("padding",0),a.$originalHeader=s("thead:first",this),a.$clonedHeader=a.$originalHeader.clone(),e.trigger("clonedHeader."+r,[a.$clonedHeader]),a.$clonedHeader.addClass("tableFloatingHeader"),a.$clonedHeader.css({display:"none",opacity:0}),a.$originalHeader.addClass("tableFloatingHeaderOriginal"),a.$originalHeader.after(a.$clonedHeader),a.$printStyle=s('<style type="text/css" media="print">.tableFloatingHeader{display:none !important;}.tableFloatingHeaderOriginal{position:static !important;}</style>'),a.$head.append(a.$printStyle)}),a.$clonedHeader.find("input, select").attr("disabled",!0),a.updateWidth(),a.toggleHeaders(),a.bind()},a.destroy=function(){a.$el.unbind("destroyed",a.teardown),a.teardown()},a.teardown=function(){a.isSticky&&a.$originalHeader.css("position","static"),s.removeData(a.el,"plugin_"+r),a.unbind(),a.$clonedHeader.remove(),a.$originalHeader.removeClass("tableFloatingHeaderOriginal"),a.$originalHeader.css("visibility","visible"),a.$printStyle.remove(),a.el=null,a.$el=null},a.bind=function(){a.$scrollableArea.on("scroll."+r,a.toggleHeaders),a.isWindowScrolling||(a.$window.on("scroll."+r+a.id,a.setPositionValues),a.$window.on("resize."+r+a.id,a.toggleHeaders)),a.$scrollableArea.on("resize."+r,a.toggleHeaders),a.$scrollableArea.on("resize."+r,a.updateWidth)},a.unbind=function(){a.$scrollableArea.off("."+r,a.toggleHeaders),a.isWindowScrolling||(a.$window.off("."+r+a.id,a.setPositionValues),a.$window.off("."+r+a.id,a.toggleHeaders)),a.$scrollableArea.off("."+r,a.updateWidth)},a.debounce=function(t,o){var n=null;return function(){var e=this,i=arguments;clearTimeout(n),n=setTimeout(function(){t.apply(e,i)},o)}},a.toggleHeaders=a.debounce(function(){a.$el&&a.$el.each(function(){var e,i=s(this),t=a.isWindowScrolling?isNaN(a.options.fixedOffset)?a.options.fixedOffset.outerHeight():a.options.fixedOffset:a.$scrollableArea.offset().top+(isNaN(a.options.fixedOffset)?0:a.options.fixedOffset),o=i.offset(),n=a.$scrollableArea.scrollTop()+t,d=a.$scrollableArea.scrollLeft(),l=a.isWindowScrolling?n>o.top:t>o.top;l&&(e=a.options.cacheHeaderHeight?a.cachedHeaderHeight:a.$clonedHeader.height(),e=(a.isWindowScrolling?n:0)<o.top+i.height()-e-(a.isWindowScrolling?0:t)),l&&e?(n=o.left-d+a.options.leftOffset,a.$originalHeader.css({position:"fixed","margin-top":a.options.marginTop,top:0,left:n,"z-index":a.options.zIndex}),a.leftOffset=n,a.topOffset=t,a.$clonedHeader.css("display",""),a.isSticky||(a.isSticky=!0,a.updateWidth(),i.trigger("enabledStickiness."+r)),a.setPositionValues()):a.isSticky&&(a.$originalHeader.css("position","static"),a.$clonedHeader.css("display","none"),a.isSticky=!1,a.resetWidth(s("td,th",a.$clonedHeader),s("td,th",a.$originalHeader)),i.trigger("disabledStickiness."+r))})},0),a.setPositionValues=a.debounce(function(){var e=a.$window.scrollTop(),i=a.$window.scrollLeft();!a.isSticky||e<0||e+a.$window.height()>a.$document.height()||i<0||i+a.$window.width()>a.$document.width()||a.$originalHeader.css({top:a.topOffset-(a.isWindowScrolling?0:e),left:a.leftOffset-(a.isWindowScrolling?0:i)})},0),a.updateWidth=a.debounce(function(){var e;a.isSticky&&(a.$originalHeaderCells||(a.$originalHeaderCells=s("th,td",a.$originalHeader)),a.$clonedHeaderCells||(a.$clonedHeaderCells=s("th,td",a.$clonedHeader)),e=a.getWidth(a.$clonedHeaderCells),a.setWidth(e,a.$clonedHeaderCells,a.$originalHeaderCells),a.$originalHeader.css("width",a.$clonedHeader.width()),a.options.cacheHeaderHeight)&&(a.cachedHeaderHeight=a.$clonedHeader.height())},0),a.getWidth=function(e){var d=[];return e.each(function(e){var i,t,o,n=s(this);i="border-box"===n.css("box-sizing")?(i=n[0].getBoundingClientRect()).width||i.right-i.left:"collapse"===s("th",a.$originalHeader).css("border-collapse")?l.getComputedStyle?parseFloat(l.getComputedStyle(this,null).width):(i=parseFloat(n.css("padding-left")),t=parseFloat(n.css("padding-right")),o=parseFloat(n.css("border-width")),n.outerWidth()-i-t-o):n.width(),d[e]=i}),d},a.setWidth=function(t,e,o){e.each(function(e){var i=t[e];o.eq(e).css({"min-width":i,"max-width":i})})},a.resetWidth=function(e,t){e.each(function(e){var i=s(this);t.eq(e).css({"min-width":i.css("min-width"),"max-width":i.css("max-width")})})},a.setOptions=function(e){a.options=s.extend({},o,e),a.$window=s(a.options.objWindow),a.$head=s(a.options.objHead),a.$document=s(a.options.objDocument),a.$scrollableArea=s(a.options.scrollableArea),a.isWindowScrolling=a.$scrollableArea[0]===a.$window[0]},a.updateOptions=function(e){a.setOptions(e),a.unbind(),a.bind(),a.updateWidth(),a.toggleHeaders()},a.init()}s.fn[r]=function(i){return this.each(function(){var e=s.data(this,"plugin_"+r);e?"string"==typeof i?e[i].apply(e):e.updateOptions(i):"destroy"!==i&&s.data(this,"plugin_"+r,new n(this,i))})}}(jQuery,window);
//# sourceMappingURL=jquery.stickytableheaders.js.map;
"function"!=typeof Object.create&&(Object.create=function(t){function o(){}return o.prototype=t,new o}),function(s,o){"use strict";var i={_positionClasses:["bottom-left","bottom-right","top-right","top-left","bottom-center","top-center","mid-center"],_defaultIcons:["success","error","info","warning"],init:function(t,o){this.prepareOptions(t,s.toast.options),this.process()},prepareOptions:function(t,o){var i={};"string"==typeof t||t instanceof Array?i.text=t:i=t,this.options=s.extend({},o,i)},process:function(){this.setup(),this.addToDom(),this.position(),this.bindToast(),this.animate()},setup:function(){var t="";if(this._toastEl=this._toastEl||s("<div></div>",{"class":"jq-toast-single"}),t+='<span class="jq-toast-loader"></span>',this.options.allowToastClose&&(t+='<span class="close-jq-toast-single">&times;</span>'),this.options.text instanceof Array){this.options.heading&&(t+='<h2 class="jq-toast-heading">'+this.options.heading+"</h2>"),t+='<ul class="jq-toast-ul">';for(var o=0;o<this.options.text.length;o++)t+='<li class="jq-toast-li" id="jq-toast-item-'+o+'">'+this.options.text[o]+"</li>";t+="</ul>"}else this.options.heading&&(t+='<h2 class="jq-toast-heading">'+this.options.heading+"</h2>"),t+=this.options.text;this._toastEl.html(t),!1!==this.options.bgColor&&this._toastEl.css("background-color",this.options.bgColor),!1!==this.options.textColor&&this._toastEl.css("color",this.options.textColor),this.options.textAlign&&this._toastEl.css("text-align",this.options.textAlign),!1!==this.options.icon&&(this._toastEl.addClass("jq-has-icon"),-1!==s.inArray(this.options.icon,this._defaultIcons))&&this._toastEl.addClass("jq-icon-"+this.options.icon),!1!==this.options["class"]&&this._toastEl.addClass(this.options["class"])},position:function(){"string"==typeof this.options.position&&-1!==s.inArray(this.options.position,this._positionClasses)?"bottom-center"===this.options.position?this._container.css({left:s(o).outerWidth()/2-this._container.outerWidth()/2,bottom:20}):"top-center"===this.options.position?this._container.css({left:s(o).outerWidth()/2-this._container.outerWidth()/2,top:20}):"mid-center"===this.options.position?this._container.css({left:s(o).outerWidth()/2-this._container.outerWidth()/2,top:s(o).outerHeight()/2-this._container.outerHeight()/2}):this._container.addClass(this.options.position):"object"==typeof this.options.position?this._container.css({top:this.options.position.top||"auto",bottom:this.options.position.bottom||"auto",left:this.options.position.left||"auto",right:this.options.position.right||"auto"}):this._container.addClass("bottom-left")},bindToast:function(){var o=this;this._toastEl.on("afterShown",function(){o.processLoader()}),this._toastEl.find(".close-jq-toast-single").on("click",function(t){t.preventDefault(),"fade"===o.options.showHideTransition?(o._toastEl.trigger("beforeHide"),o._toastEl.fadeOut(function(){o._toastEl.trigger("afterHidden")})):"slide"===o.options.showHideTransition?(o._toastEl.trigger("beforeHide"),o._toastEl.slideUp(function(){o._toastEl.trigger("afterHidden")})):(o._toastEl.trigger("beforeHide"),o._toastEl.hide(function(){o._toastEl.trigger("afterHidden")}))}),"function"==typeof this.options.beforeShow&&this._toastEl.on("beforeShow",function(){o.options.beforeShow()}),"function"==typeof this.options.afterShown&&this._toastEl.on("afterShown",function(){o.options.afterShown()}),"function"==typeof this.options.beforeHide&&this._toastEl.on("beforeHide",function(){o.options.beforeHide()}),"function"==typeof this.options.afterHidden&&this._toastEl.on("afterHidden",function(){o.options.afterHidden()})},addToDom:function(){var t,o=s(".jq-toast-wrap");0===o.length?(o=s("<div></div>",{"class":"jq-toast-wrap"}),s("body").append(o)):this.options.stack&&!isNaN(parseInt(this.options.stack,10))||o.empty(),o.find(".jq-toast-single:hidden").remove(),o.append(this._toastEl),this.options.stack&&!isNaN(parseInt(this.options.stack),10)&&0<(t=o.find(".jq-toast-single").length-this.options.stack)&&s(".jq-toast-wrap").find(".jq-toast-single").slice(0,t).remove(),this._container=o},canAutoHide:function(){return!1!==this.options.hideAfter&&!isNaN(parseInt(this.options.hideAfter,10))},processLoader:function(){if(!this.canAutoHide()||!1===this.options.loader)return!1;var t=this._toastEl.find(".jq-toast-loader"),o=(this.options.hideAfter-400)/1e3+"s",i=this.options.loaderBg,s=(s=t.attr("style")||"").substring(0,s.indexOf("-webkit-transition"));t.attr("style",s+="-webkit-transition: width "+o+" ease-in;                       -o-transition: width "+o+" ease-in;                       transition: width "+o+" ease-in;                       background-color: "+i+";").addClass("jq-toast-loaded")},animate:function(){var t=this;this._toastEl.hide(),this._toastEl.trigger("beforeShow"),"fade"===this.options.showHideTransition.toLowerCase()?this._toastEl.fadeIn(function(){t._toastEl.trigger("afterShown")}):"slide"===this.options.showHideTransition.toLowerCase()?this._toastEl.slideDown(function(){t._toastEl.trigger("afterShown")}):this._toastEl.show(function(){t._toastEl.trigger("afterShown")}),this.canAutoHide()&&(t=this,o.setTimeout(function(){"fade"===t.options.showHideTransition.toLowerCase()?(t._toastEl.trigger("beforeHide"),t._toastEl.fadeOut(function(){t._toastEl.trigger("afterHidden")})):"slide"===t.options.showHideTransition.toLowerCase()?(t._toastEl.trigger("beforeHide"),t._toastEl.slideUp(function(){t._toastEl.trigger("afterHidden")})):(t._toastEl.trigger("beforeHide"),t._toastEl.hide(function(){t._toastEl.trigger("afterHidden")}))},this.options.hideAfter))},reset:function(t){("all"===t?s(".jq-toast-wrap"):this._toastEl).remove()},update:function(t){this.prepareOptions(t,this.options),this.setup(),this.bindToast()}};s.toast=function(t){var o=Object.create(i);return o.init(t,this),{reset:function(t){o.reset(t)},update:function(t){o.update(t)}}},s.toast.options={text:"",heading:"",showHideTransition:"fade",allowToastClose:!0,hideAfter:3e3,loader:!0,loaderBg:"#9EC600",stack:5,position:"bottom-left",bgColor:!1,textColor:!1,textAlign:"left",icon:!1,beforeShow:function(){},afterShown:function(){},beforeHide:function(){},afterHidden:function(){}}}(jQuery,window,document);
//# sourceMappingURL=jquery.toast.min.js.map;
"use strict";function _toConsumableArray(t){return _arrayWithoutHoles(t)||_iterableToArray(t)||_nonIterableSpread()}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance")}function _iterableToArray(t){if(Symbol.iterator in Object(t)||"[object Arguments]"===Object.prototype.toString.call(t))return Array.from(t)}function _arrayWithoutHoles(t){if(Array.isArray(t)){for(var e=0,r=new Array(t.length);e<t.length;e++)r[e]=t[e];return r}}function _typeof(t){return(_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function _typeof(t){return typeof t}:function _typeof(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}!function(t){"object"===("undefined"==typeof exports?"undefined":_typeof(exports))&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):("undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this).sanitizeHtml=t()}(function(){return function u(n,i,o){function s(e,t){if(!i[e]){if(!n[e]){var r="function"==typeof require&&require;if(!t&&r)return r(e,!0);if(a)return a(e,!0);throw(t=new Error("Cannot find module '"+e+"'")).code="MODULE_NOT_FOUND",t}r=i[e]={exports:{}},n[e][0].call(r.exports,function(t){return s(n[e][1][t]||t)},r,r.exports,u,n,i,o)}return i[e].exports}for(var a="function"==typeof require&&require,t=0;t<o.length;t++)s(o[t]);return s}({1:[function(t,e,r){r.byteLength=function(t){var t=l(t),e=t[0],t=t[1];return 3*(e+t)/4-t},r.toByteArray=function(t){var e,r,n=l(t),i=n[0],n=n[1],o=new c(function(t,e){return 3*(t+e)/4-e}(i,n)),s=0,a=0<n?i-4:i;for(r=0;r<a;r+=4)e=u[t.charCodeAt(r)]<<18|u[t.charCodeAt(r+1)]<<12|u[t.charCodeAt(r+2)]<<6|u[t.charCodeAt(r+3)],o[s++]=e>>16&255,o[s++]=e>>8&255,o[s++]=255&e;2===n&&(e=u[t.charCodeAt(r)]<<2|u[t.charCodeAt(r+1)]>>4,o[s++]=255&e);1===n&&(e=u[t.charCodeAt(r)]<<10|u[t.charCodeAt(r+1)]<<4|u[t.charCodeAt(r+2)]>>2,o[s++]=e>>8&255,o[s++]=255&e);return o},r.fromByteArray=function(t){for(var e,r=t.length,n=r%3,i=[],o=0,s=r-n;o<s;o+=16383)i.push(function(t,e,r){for(var n,i=[],o=e;o<r;o+=3)n=(t[o]<<16&16711680)+(t[o+1]<<8&65280)+(255&t[o+2]),i.push(function(t){return a[t>>18&63]+a[t>>12&63]+a[t>>6&63]+a[63&t]}(n));return i.join("")}(t,o,s<o+16383?s:o+16383));1==n?(e=t[r-1],i.push(a[e>>2]+a[e<<4&63]+"==")):2==n&&(e=(t[r-2]<<8)+t[r-1],i.push(a[e>>10]+a[e>>4&63]+a[e<<2&63]+"="));return i.join("")};for(var a=[],u=[],c="undefined"!=typeof Uint8Array?Uint8Array:Array,n="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",i=0,o=n.length;i<o;++i)a[i]=n[i],u[n.charCodeAt(i)]=i;function l(t){var e=t.length;if(0<e%4)throw new Error("Invalid string. Length must be a multiple of 4");t=t.indexOf("="),e=(t=-1===t?e:t)===e?0:4-t%4;return[t,e]}u["-".charCodeAt(0)]=62,u["_".charCodeAt(0)]=63},{}],2:[function(t,e,r){},{}],3:[function(q,t,N){!function(f){var A=q("base64-js"),o=q("ieee754"),t="function"==typeof Symbol&&"function"==typeof Symbol["for"]?Symbol["for"]("nodejs.util.inspect.custom"):null,e=(N.Buffer=f,N.SlowBuffer=function(t){+t!=t&&(t=0);return f.alloc(+t)},N.INSPECT_MAX_BYTES=50,2147483647);function a(t){if(e<t)throw new RangeError('The value "'+t+'" is invalid for option "size"');t=new Uint8Array(t);return Object.setPrototypeOf(t,f.prototype),t}function f(t,e,r){if("number"!=typeof t)return n(t,e,r);if("string"==typeof e)throw new TypeError('The "string" argument must be of type string. Received type number');return s(t)}function n(t,e,r){if("string"==typeof t){var n,i=t,o=e;if(f.isEncoding(o="string"==typeof o&&""!==o?o:"utf8"))return s=0|h(i,o),n=a(s),n=(i=n.write(i,o))!==s?n.slice(0,i):n;throw new TypeError("Unknown encoding: "+o)}if(ArrayBuffer.isView(t))return u(t);if(null!=t){if(L(t,ArrayBuffer)||t&&L(t.buffer,ArrayBuffer))return c(t,e,r);if("undefined"!=typeof SharedArrayBuffer&&(L(t,SharedArrayBuffer)||t&&L(t.buffer,SharedArrayBuffer)))return c(t,e,r);if("number"==typeof t)throw new TypeError('The "value" argument must not be of type number. Received type number');var s=t.valueOf&&t.valueOf();if(null!=s&&s!==t)return f.from(s,e,r);i=function(t){{var e,r;if(f.isBuffer(t))return e=0|l(t.length),0!==(r=a(e)).length&&t.copy(r,0,0,e),r}if(t.length!==undefined)return"number"!=typeof t.length||M(t.length)?a(0):u(t);if("Buffer"===t.type&&Array.isArray(t.data))return u(t.data)}(t);if(i)return i;if("undefined"!=typeof Symbol&&null!=Symbol.toPrimitive&&"function"==typeof t[Symbol.toPrimitive])return f.from(t[Symbol.toPrimitive]("string"),e,r)}throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type "+_typeof(t))}function i(t){if("number"!=typeof t)throw new TypeError('"size" argument must be of type number');if(t<0)throw new RangeError('The value "'+t+'" is invalid for option "size"')}function s(t){return i(t),a(t<0?0:0|l(t))}function u(t){for(var e=t.length<0?0:0|l(t.length),r=a(e),n=0;n<e;n+=1)r[n]=255&t[n];return r}function c(t,e,r){if(e<0||t.byteLength<e)throw new RangeError('"offset" is outside of buffer bounds');if(t.byteLength<e+(r||0))throw new RangeError('"length" is outside of buffer bounds');t=e===undefined&&r===undefined?new Uint8Array(t):r===undefined?new Uint8Array(t,e):new Uint8Array(t,e,r);return Object.setPrototypeOf(t,f.prototype),t}function l(t){if(e<=t)throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x"+e.toString(16)+" bytes");return 0|t}function h(t,e){if(f.isBuffer(t))return t.length;if(ArrayBuffer.isView(t)||L(t,ArrayBuffer))return t.byteLength;if("string"!=typeof t)throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type '+_typeof(t));var r=t.length,n=2<arguments.length&&!0===arguments[2];if(!n&&0===r)return 0;for(var i=!1;;)switch(e){case"ascii":case"latin1":case"binary":return r;case"utf8":case"utf-8":return E(t).length;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return 2*r;case"hex":return r>>>1;case"base64":return k(t).length;default:if(i)return n?-1:E(t).length;e=(""+e).toLowerCase(),i=!0}}function r(t,e,r){var n,i=!1;if((e=e===undefined||e<0?0:e)>this.length)return"";if((r=r===undefined||r>this.length?this.length:r)<=0)return"";if((r>>>=0)<=(e>>>=0))return"";for(t=t||"utf8";;)switch(t){case"hex":var o=this,s=e,a=r,u=o.length;(!a||a<0||u<a)&&(a=u);for(var c="",l=s=!s||s<0?0:s;l<a;++l)c+=T[o[l]];return c;case"utf8":case"utf-8":return C(this,e,r);case"ascii":var f=this,u=e,h=r,p="";h=Math.min(f.length,h);for(var d=u;d<h;++d)p+=String.fromCharCode(127&f[d]);return p;case"latin1":case"binary":var g=this,s=e,m=r,y="";m=Math.min(g.length,m);for(var _=s;_<m;++_)y+=String.fromCharCode(g[_]);return y;case"base64":return n=this,v=r,0===(b=e)&&v===n.length?A.fromByteArray(n):A.fromByteArray(n.slice(b,v));case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":for(var b=e,v=r,w=this.slice(b,v),x="",S=0;S<w.length;S+=2)x+=String.fromCharCode(w[S]+256*w[S+1]);return x;default:if(i)throw new TypeError("Unknown encoding: "+t);t=(t+"").toLowerCase(),i=!0}}function p(t,e,r){var n=t[e];t[e]=t[r],t[r]=n}function d(t,e,r,n,i){if(0===t.length)return-1;if("string"==typeof r?(n=r,r=0):2147483647<r?r=2147483647:r<-2147483648&&(r=-2147483648),(r=(r=M(r=+r)?i?0:t.length-1:r)<0?t.length+r:r)>=t.length){if(i)return-1;r=t.length-1}else if(r<0){if(!i)return-1;r=0}if("string"==typeof e&&(e=f.from(e,n)),f.isBuffer(e))return 0===e.length?-1:g(t,e,r,n,i);if("number"==typeof e)return e&=255,"function"==typeof Uint8Array.prototype.indexOf?(i?Uint8Array.prototype.indexOf:Uint8Array.prototype.lastIndexOf).call(t,e,r):g(t,[e],r,n,i);throw new TypeError("val must be string, number or Buffer")}function g(t,e,r,n,i){var o=1,s=t.length,a=e.length;if(n!==undefined&&("ucs2"===(n=String(n).toLowerCase())||"ucs-2"===n||"utf16le"===n||"utf-16le"===n)){if(t.length<2||e.length<2)return-1;s/=o=2,a/=2,r/=2}function u(t,e){return 1===o?t[e]:t.readUInt16BE(e*o)}if(i)for(var c=-1,l=r;l<s;l++)if(u(t,l)===u(e,-1===c?0:l-c)){if(l-(c=-1===c?l:c)+1===a)return c*o}else-1!==c&&(l-=l-c),c=-1;else for(l=r=s<r+a?s-a:r;0<=l;l--){for(var f=!0,h=0;h<a;h++)if(u(t,l+h)!==u(e,h)){f=!1;break}if(f)return l}return-1}function m(t,e,r,n){return j(function(t){for(var e=[],r=0;r<t.length;++r)e.push(255&t.charCodeAt(r));return e}(e),t,r,n)}function y(t,e,r,n){return j(function(t,e){for(var r,n,i=[],o=0;o<t.length&&!((e-=2)<0);++o)r=t.charCodeAt(o),n=r>>8,i.push(r%256),i.push(n);return i}(e,t.length-r),t,r,n)}function C(t,e,r){r=Math.min(t.length,r);for(var n=[],i=e;i<r;){var o,s,a,u,c=t[i],l=null,f=239<c?4:223<c?3:191<c?2:1;if(i+f<=r)switch(f){case 1:c<128&&(l=c);break;case 2:128==(192&(o=t[i+1]))&&127<(u=(31&c)<<6|63&o)&&(l=u);break;case 3:o=t[i+1],s=t[i+2],128==(192&o)&&128==(192&s)&&2047<(u=(15&c)<<12|(63&o)<<6|63&s)&&(u<55296||57343<u)&&(l=u);break;case 4:o=t[i+1],s=t[i+2],a=t[i+3],128==(192&o)&&128==(192&s)&&128==(192&a)&&65535<(u=(15&c)<<18|(63&o)<<12|(63&s)<<6|63&a)&&u<1114112&&(l=u)}null===l?(l=65533,f=1):65535<l&&(n.push((l-=65536)>>>10&1023|55296),l=56320|1023&l),n.push(l),i+=f}var h=n,p=h.length;if(p<=_)return String.fromCharCode.apply(String,h);for(var d="",g=0;g<p;)d+=String.fromCharCode.apply(String,h.slice(g,g+=_));return d}N.kMaxLength=e,(f.TYPED_ARRAY_SUPPORT=function(){try{var t=new Uint8Array(1),e={foo:function(){return 42}};return Object.setPrototypeOf(e,Uint8Array.prototype),Object.setPrototypeOf(t,e),42===t.foo()}catch(r){return!1}}())||"undefined"==typeof console||"function"!=typeof console.error||console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."),Object.defineProperty(f.prototype,"parent",{enumerable:!0,get:function(){return f.isBuffer(this)?this.buffer:undefined}}),Object.defineProperty(f.prototype,"offset",{enumerable:!0,get:function(){return f.isBuffer(this)?this.byteOffset:undefined}}),"undefined"!=typeof Symbol&&null!=Symbol.species&&f[Symbol.species]===f&&Object.defineProperty(f,Symbol.species,{value:null,configurable:!0,enumerable:!1,writable:!1}),f.poolSize=8192,f.from=n,Object.setPrototypeOf(f.prototype,Uint8Array.prototype),Object.setPrototypeOf(f,Uint8Array),f.alloc=function(t,e,r){return e=e,r=r,i(t=t),!(t<=0)&&e!==undefined?"string"==typeof r?a(t).fill(e,r):a(t).fill(e):a(t)},f.allocUnsafe=s,f.allocUnsafeSlow=s,f.isBuffer=function(t){return null!=t&&!0===t._isBuffer&&t!==f.prototype},f.compare=function(t,e){if(L(t,Uint8Array)&&(t=f.from(t,t.offset,t.byteLength)),L(e,Uint8Array)&&(e=f.from(e,e.offset,e.byteLength)),!f.isBuffer(t)||!f.isBuffer(e))throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');if(t===e)return 0;for(var r=t.length,n=e.length,i=0,o=Math.min(r,n);i<o;++i)if(t[i]!==e[i]){r=t[i],n=e[i];break}return r<n?-1:n<r?1:0},f.isEncoding=function(t){switch(String(t).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"latin1":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return!0;default:return!1}},f.concat=function(t,e){if(!Array.isArray(t))throw new TypeError('"list" argument must be an Array of Buffers');if(0===t.length)return f.alloc(0);if(e===undefined)for(i=e=0;i<t.length;++i)e+=t[i].length;for(var r=f.allocUnsafe(e),n=0,i=0;i<t.length;++i){var o=t[i];if(L(o,Uint8Array)&&(o=f.from(o)),!f.isBuffer(o))throw new TypeError('"list" argument must be an Array of Buffers');o.copy(r,n),n+=o.length}return r},f.byteLength=h,f.prototype._isBuffer=!0,f.prototype.swap16=function(){var t=this.length;if(t%2!=0)throw new RangeError("Buffer size must be a multiple of 16-bits");for(var e=0;e<t;e+=2)p(this,e,e+1);return this},f.prototype.swap32=function(){var t=this.length;if(t%4!=0)throw new RangeError("Buffer size must be a multiple of 32-bits");for(var e=0;e<t;e+=4)p(this,e,e+3),p(this,e+1,e+2);return this},f.prototype.swap64=function(){var t=this.length;if(t%8!=0)throw new RangeError("Buffer size must be a multiple of 64-bits");for(var e=0;e<t;e+=8)p(this,e,e+7),p(this,e+1,e+6),p(this,e+2,e+5),p(this,e+3,e+4);return this},f.prototype.toLocaleString=f.prototype.toString=function(){var t=this.length;return 0===t?"":0===arguments.length?C(this,0,t):r.apply(this,arguments)},f.prototype.equals=function(t){if(f.isBuffer(t))return this===t||0===f.compare(this,t);throw new TypeError("Argument must be a Buffer")},f.prototype.inspect=function(){var t="",e=N.INSPECT_MAX_BYTES,t=this.toString("hex",0,e).replace(/(.{2})/g,"$1 ").trim();return this.length>e&&(t+=" ... "),"<Buffer "+t+">"},t&&(f.prototype[t]=f.prototype.inspect),f.prototype.compare=function(t,e,r,n,i){if(L(t,Uint8Array)&&(t=f.from(t,t.offset,t.byteLength)),!f.isBuffer(t))throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type '+_typeof(t));if(e===undefined&&(e=0),r===undefined&&(r=t?t.length:0),n===undefined&&(n=0),i===undefined&&(i=this.length),e<0||r>t.length||n<0||i>this.length)throw new RangeError("out of range index");if(i<=n&&r<=e)return 0;if(i<=n)return-1;if(r<=e)return 1;if(this===t)return 0;for(var o=(i>>>=0)-(n>>>=0),s=(r>>>=0)-(e>>>=0),a=Math.min(o,s),u=this.slice(n,i),c=t.slice(e,r),l=0;l<a;++l)if(u[l]!==c[l]){o=u[l],s=c[l];break}return o<s?-1:s<o?1:0},f.prototype.includes=function(t,e,r){return-1!==this.indexOf(t,e,r)},f.prototype.indexOf=function(t,e,r){return d(this,t,e,r,!0)},f.prototype.lastIndexOf=function(t,e,r){return d(this,t,e,r,!1)},f.prototype.write=function(t,e,r,n){if(e===undefined)n="utf8",r=this.length,e=0;else if(r===undefined&&"string"==typeof e)n=e,r=this.length,e=0;else{if(!isFinite(e))throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");e>>>=0,isFinite(r)?(r>>>=0,n===undefined&&(n="utf8")):(n=r,r=undefined)}var i=this.length-e;if((r===undefined||i<r)&&(r=i),0<t.length&&(r<0||e<0)||e>this.length)throw new RangeError("Attempt to write outside buffer bounds");n=n||"utf8";for(var o,s,a,u=!1;;)switch(n){case"hex":var c=this,l=t,f=e,h=r,p=(f=Number(f)||0,c.length-f);(!h||p<(h=Number(h)))&&(h=p),(p=l.length)/2<h&&(h=p/2);for(var d=0;d<h;++d){var g=parseInt(l.substr(2*d,2),16);if(M(g))return d;c[f+d]=g}return d;case"utf8":case"utf-8":return p=e,a=r,j(E(t,(s=this).length-p),s,p,a);case"ascii":return m(this,t,e,r);case"latin1":case"binary":return m(this,t,e,r);case"base64":return s=this,a=e,o=r,j(k(t),s,a,o);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return y(this,t,e,r);default:if(u)throw new TypeError("Unknown encoding: "+n);n=(""+n).toLowerCase(),u=!0}},f.prototype.toJSON=function(){return{type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};var _=4096;function b(t,e,r){if(t%1!=0||t<0)throw new RangeError("offset is not uint");if(r<t+e)throw new RangeError("Trying to access beyond buffer length")}function v(t,e,r,n,i,o){if(!f.isBuffer(t))throw new TypeError('"buffer" argument must be a Buffer instance');if(i<e||e<o)throw new RangeError('"value" argument is out of bounds');if(r+n>t.length)throw new RangeError("Index out of range")}function w(t,e,r,n){if(r+n>t.length)throw new RangeError("Index out of range");if(r<0)throw new RangeError("Index out of range")}function x(t,e,r,n,i){return e=+e,r>>>=0,i||w(t,0,r,4),o.write(t,e,r,n,23,4),r+4}function S(t,e,r,n,i){return e=+e,r>>>=0,i||w(t,0,r,8),o.write(t,e,r,n,52,8),r+8}f.prototype.slice=function(t,e){var r=this.length,r=((t=~~t)<0?(t+=r)<0&&(t=0):r<t&&(t=r),(e=e===undefined?r:~~e)<0?(e+=r)<0&&(e=0):r<e&&(e=r),e<t&&(e=t),this.subarray(t,e));return Object.setPrototypeOf(r,f.prototype),r},f.prototype.readUIntLE=function(t,e,r){t>>>=0,e>>>=0,r||b(t,e,this.length);for(var n=this[t],i=1,o=0;++o<e&&(i*=256);)n+=this[t+o]*i;return n},f.prototype.readUIntBE=function(t,e,r){t>>>=0,e>>>=0,r||b(t,e,this.length);for(var n=this[t+--e],i=1;0<e&&(i*=256);)n+=this[t+--e]*i;return n},f.prototype.readUInt8=function(t,e){return t>>>=0,e||b(t,1,this.length),this[t]},f.prototype.readUInt16LE=function(t,e){return t>>>=0,e||b(t,2,this.length),this[t]|this[t+1]<<8},f.prototype.readUInt16BE=function(t,e){return t>>>=0,e||b(t,2,this.length),this[t]<<8|this[t+1]},f.prototype.readUInt32LE=function(t,e){return t>>>=0,e||b(t,4,this.length),(this[t]|this[t+1]<<8|this[t+2]<<16)+16777216*this[t+3]},f.prototype.readUInt32BE=function(t,e){return t>>>=0,e||b(t,4,this.length),16777216*this[t]+(this[t+1]<<16|this[t+2]<<8|this[t+3])},f.prototype.readIntLE=function(t,e,r){t>>>=0,e>>>=0,r||b(t,e,this.length);for(var n=this[t],i=1,o=0;++o<e&&(i*=256);)n+=this[t+o]*i;return(i*=128)<=n&&(n-=Math.pow(2,8*e)),n},f.prototype.readIntBE=function(t,e,r){t>>>=0,e>>>=0,r||b(t,e,this.length);for(var n=e,i=1,o=this[t+--n];0<n&&(i*=256);)o+=this[t+--n]*i;return(i*=128)<=o&&(o-=Math.pow(2,8*e)),o},f.prototype.readInt8=function(t,e){return t>>>=0,e||b(t,1,this.length),128&this[t]?-1*(255-this[t]+1):this[t]},f.prototype.readInt16LE=function(t,e){t>>>=0,e||b(t,2,this.length);e=this[t]|this[t+1]<<8;return 32768&e?4294901760|e:e},f.prototype.readInt16BE=function(t,e){t>>>=0,e||b(t,2,this.length);e=this[t+1]|this[t]<<8;return 32768&e?4294901760|e:e},f.prototype.readInt32LE=function(t,e){return t>>>=0,e||b(t,4,this.length),this[t]|this[t+1]<<8|this[t+2]<<16|this[t+3]<<24},f.prototype.readInt32BE=function(t,e){return t>>>=0,e||b(t,4,this.length),this[t]<<24|this[t+1]<<16|this[t+2]<<8|this[t+3]},f.prototype.readFloatLE=function(t,e){return t>>>=0,e||b(t,4,this.length),o.read(this,t,!0,23,4)},f.prototype.readFloatBE=function(t,e){return t>>>=0,e||b(t,4,this.length),o.read(this,t,!1,23,4)},f.prototype.readDoubleLE=function(t,e){return t>>>=0,e||b(t,8,this.length),o.read(this,t,!0,52,8)},f.prototype.readDoubleBE=function(t,e){return t>>>=0,e||b(t,8,this.length),o.read(this,t,!1,52,8)},f.prototype.writeUIntLE=function(t,e,r,n){t=+t,e>>>=0,r>>>=0,n||v(this,t,e,r,Math.pow(2,8*r)-1,0);var i=1,o=0;for(this[e]=255&t;++o<r&&(i*=256);)this[e+o]=t/i&255;return e+r},f.prototype.writeUIntBE=function(t,e,r,n){t=+t,e>>>=0,r>>>=0,n||v(this,t,e,r,Math.pow(2,8*r)-1,0);var i=r-1,o=1;for(this[e+i]=255&t;0<=--i&&(o*=256);)this[e+i]=t/o&255;return e+r},f.prototype.writeUInt8=function(t,e,r){return t=+t,e>>>=0,r||v(this,t,e,1,255,0),this[e]=255&t,e+1},f.prototype.writeUInt16LE=function(t,e,r){return t=+t,e>>>=0,r||v(this,t,e,2,65535,0),this[e]=255&t,this[e+1]=t>>>8,e+2},f.prototype.writeUInt16BE=function(t,e,r){return t=+t,e>>>=0,r||v(this,t,e,2,65535,0),this[e]=t>>>8,this[e+1]=255&t,e+2},f.prototype.writeUInt32LE=function(t,e,r){return t=+t,e>>>=0,r||v(this,t,e,4,4294967295,0),this[e+3]=t>>>24,this[e+2]=t>>>16,this[e+1]=t>>>8,this[e]=255&t,e+4},f.prototype.writeUInt32BE=function(t,e,r){return t=+t,e>>>=0,r||v(this,t,e,4,4294967295,0),this[e]=t>>>24,this[e+1]=t>>>16,this[e+2]=t>>>8,this[e+3]=255&t,e+4},f.prototype.writeIntLE=function(t,e,r,n){t=+t,e>>>=0,n||v(this,t,e,r,(n=Math.pow(2,8*r-1))-1,-n);var i=0,o=1,s=0;for(this[e]=255&t;++i<r&&(o*=256);)t<0&&0===s&&0!==this[e+i-1]&&(s=1),this[e+i]=(t/o>>0)-s&255;return e+r},f.prototype.writeIntBE=function(t,e,r,n){t=+t,e>>>=0,n||v(this,t,e,r,(n=Math.pow(2,8*r-1))-1,-n);var i=r-1,o=1,s=0;for(this[e+i]=255&t;0<=--i&&(o*=256);)t<0&&0===s&&0!==this[e+i+1]&&(s=1),this[e+i]=(t/o>>0)-s&255;return e+r},f.prototype.writeInt8=function(t,e,r){return t=+t,e>>>=0,r||v(this,t,e,1,127,-128),this[e]=255&(t=t<0?255+t+1:t),e+1},f.prototype.writeInt16LE=function(t,e,r){return t=+t,e>>>=0,r||v(this,t,e,2,32767,-32768),this[e]=255&t,this[e+1]=t>>>8,e+2},f.prototype.writeInt16BE=function(t,e,r){return t=+t,e>>>=0,r||v(this,t,e,2,32767,-32768),this[e]=t>>>8,this[e+1]=255&t,e+2},f.prototype.writeInt32LE=function(t,e,r){return t=+t,e>>>=0,r||v(this,t,e,4,2147483647,-2147483648),this[e]=255&t,this[e+1]=t>>>8,this[e+2]=t>>>16,this[e+3]=t>>>24,e+4},f.prototype.writeInt32BE=function(t,e,r){return t=+t,e>>>=0,r||v(this,t,e,4,2147483647,-2147483648),this[e]=(t=t<0?4294967295+t+1:t)>>>24,this[e+1]=t>>>16,this[e+2]=t>>>8,this[e+3]=255&t,e+4},f.prototype.writeFloatLE=function(t,e,r){return x(this,t,e,!0,r)},f.prototype.writeFloatBE=function(t,e,r){return x(this,t,e,!1,r)},f.prototype.writeDoubleLE=function(t,e,r){return S(this,t,e,!0,r)},f.prototype.writeDoubleBE=function(t,e,r){return S(this,t,e,!1,r)},f.prototype.copy=function(t,e,r,n){if(!f.isBuffer(t))throw new TypeError("argument should be a Buffer");if(r=r||0,n||0===n||(n=this.length),e>=t.length&&(e=t.length),(n=0<n&&n<r?r:n)===r)return 0;if(0===t.length||0===this.length)return 0;if((e=e||0)<0)throw new RangeError("targetStart out of bounds");if(r<0||r>=this.length)throw new RangeError("Index out of range");if(n<0)throw new RangeError("sourceEnd out of bounds");n>this.length&&(n=this.length);var i=(n=t.length-e<n-r?t.length-e+r:n)-r;if(this===t&&"function"==typeof Uint8Array.prototype.copyWithin)this.copyWithin(e,r,n);else if(this===t&&r<e&&e<n)for(var o=i-1;0<=o;--o)t[o+e]=this[o+r];else Uint8Array.prototype.set.call(t,this.subarray(r,n),e);return i},f.prototype.fill=function(t,e,r,n){if("string"==typeof t){if("string"==typeof e?(n=e,e=0,r=this.length):"string"==typeof r&&(n=r,r=this.length),n!==undefined&&"string"!=typeof n)throw new TypeError("encoding must be a string");if("string"==typeof n&&!f.isEncoding(n))throw new TypeError("Unknown encoding: "+n);var i;1===t.length&&(i=t.charCodeAt(0),"utf8"===n&&i<128||"latin1"===n)&&(t=i)}else"number"==typeof t?t&=255:"boolean"==typeof t&&(t=Number(t));if(e<0||this.length<e||this.length<r)throw new RangeError("Out of range index");var o;if(!(r<=e))if(e>>>=0,r=r===undefined?this.length:r>>>0,"number"==typeof(t=t||0))for(o=e;o<r;++o)this[o]=t;else{var s=f.isBuffer(t)?t:f.from(t,n),a=s.length;if(0===a)throw new TypeError('The value "'+t+'" is invalid for argument "value"');for(o=0;o<r-e;++o)this[o+e]=s[o%a]}return this};var O=/[^+/0-9A-Za-z-_]/g;function E(t,e){e=e||Infinity;for(var r,n=t.length,i=null,o=[],s=0;s<n;++s){if(55295<(r=t.charCodeAt(s))&&r<57344){if(!i){if(56319<r){-1<(e-=3)&&o.push(239,191,189);continue}if(s+1===n){-1<(e-=3)&&o.push(239,191,189);continue}i=r;continue}if(r<56320){-1<(e-=3)&&o.push(239,191,189),i=r;continue}r=65536+(i-55296<<10|r-56320)}else i&&-1<(e-=3)&&o.push(239,191,189);if(i=null,r<128){if(--e<0)break;o.push(r)}else if(r<2048){if((e-=2)<0)break;o.push(r>>6|192,63&r|128)}else if(r<65536){if((e-=3)<0)break;o.push(r>>12|224,r>>6&63|128,63&r|128)}else{if(!(r<1114112))throw new Error("Invalid code point");if((e-=4)<0)break;o.push(r>>18|240,r>>12&63|128,r>>6&63|128,63&r|128)}}return o}function k(t){return A.toByteArray(function(t){if((t=(t=t.split("=")[0]).trim().replace(O,"")).length<2)return"";for(;t.length%4!=0;)t+="=";return t}(t))}function j(t,e,r,n){for(var i=0;i<n&&!(i+r>=e.length||i>=t.length);++i)e[i+r]=t[i];return i}function L(t,e){return t instanceof e||null!=t&&null!=t.constructor&&null!=t.constructor.name&&t.constructor.name===e.name}function M(t){return t!=t}var T=function(){for(var t="0123456789abcdef",e=new Array(256),r=0;r<16;++r)for(var n=16*r,i=0;i<16;++i)e[n+i]=t[r]+t[i];return e}()}.call(this,q("buffer").Buffer)},{"base64-js":1,buffer:3,ieee754:32}],4:[function(t,e,r){e.exports={elementNames:{altglyph:"altGlyph",altglyphdef:"altGlyphDef",altglyphitem:"altGlyphItem",animatecolor:"animateColor",animatemotion:"animateMotion",animatetransform:"animateTransform",clippath:"clipPath",feblend:"feBlend",fecolormatrix:"feColorMatrix",fecomponenttransfer:"feComponentTransfer",fecomposite:"feComposite",feconvolvematrix:"feConvolveMatrix",fediffuselighting:"feDiffuseLighting",fedisplacementmap:"feDisplacementMap",fedistantlight:"feDistantLight",fedropshadow:"feDropShadow",feflood:"feFlood",fefunca:"feFuncA",fefuncb:"feFuncB",fefuncg:"feFuncG",fefuncr:"feFuncR",fegaussianblur:"feGaussianBlur",feimage:"feImage",femerge:"feMerge",femergenode:"feMergeNode",femorphology:"feMorphology",feoffset:"feOffset",fepointlight:"fePointLight",fespecularlighting:"feSpecularLighting",fespotlight:"feSpotLight",fetile:"feTile",feturbulence:"feTurbulence",foreignobject:"foreignObject",glyphref:"glyphRef",lineargradient:"linearGradient",radialgradient:"radialGradient",textpath:"textPath"},attributeNames:{definitionurl:"definitionURL",attributename:"attributeName",attributetype:"attributeType",basefrequency:"baseFrequency",baseprofile:"baseProfile",calcmode:"calcMode",clippathunits:"clipPathUnits",diffuseconstant:"diffuseConstant",edgemode:"edgeMode",filterunits:"filterUnits",glyphref:"glyphRef",gradienttransform:"gradientTransform",gradientunits:"gradientUnits",kernelmatrix:"kernelMatrix",kernelunitlength:"kernelUnitLength",keypoints:"keyPoints",keysplines:"keySplines",keytimes:"keyTimes",lengthadjust:"lengthAdjust",limitingconeangle:"limitingConeAngle",markerheight:"markerHeight",markerunits:"markerUnits",markerwidth:"markerWidth",maskcontentunits:"maskContentUnits",maskunits:"maskUnits",numoctaves:"numOctaves",pathlength:"pathLength",patterncontentunits:"patternContentUnits",patterntransform:"patternTransform",patternunits:"patternUnits",pointsatx:"pointsAtX",pointsaty:"pointsAtY",pointsatz:"pointsAtZ",preservealpha:"preserveAlpha",preserveaspectratio:"preserveAspectRatio",primitiveunits:"primitiveUnits",refx:"refX",refy:"refY",repeatcount:"repeatCount",repeatdur:"repeatDur",requiredextensions:"requiredExtensions",requiredfeatures:"requiredFeatures",specularconstant:"specularConstant",specularexponent:"specularExponent",spreadmethod:"spreadMethod",startoffset:"startOffset",stddeviation:"stdDeviation",stitchtiles:"stitchTiles",surfacescale:"surfaceScale",systemlanguage:"systemLanguage",tablevalues:"tableValues",targetx:"targetX",targety:"targetY",textlength:"textLength",viewbox:"viewBox",viewtarget:"viewTarget",xchannelselector:"xChannelSelector",ychannelselector:"yChannelSelector",zoomandpan:"zoomAndPan"}}},{}],5:[function(t,e,r){var o=t("domelementtype"),s=t("entities"),a=t("./foreignNames.json"),u=(a.elementNames.__proto__=null,{__proto__:a.attributeNames.__proto__=null,style:!0,script:!0,xmp:!0,iframe:!0,noembed:!0,noframes:!0,plaintext:!0,noscript:!0});var c={__proto__:null,area:!0,base:!0,basefont:!0,br:!0,col:!0,command:!0,embed:!0,frame:!0,hr:!0,img:!0,input:!0,isindex:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0},l=e.exports=function(t,e){Array.isArray(t)||t.cheerio||(t=[t]),e=e||{};for(var r="",n=0;n<t.length;n++){var i=t[n];"root"===i.type?r+=l(i.children,e):o.isTag(i)?r+=function(t,e){"foreign"===e.xmlMode&&(t.name=a.elementNames[t.name]||t.name,t.parent)&&0<=f.indexOf(t.parent.name)&&(e=Object.assign({},e,{xmlMode:!1}));!e.xmlMode&&0<=["svg","math"].indexOf(t.name)&&(e=Object.assign({},e,{xmlMode:"foreign"}));var r="<"+t.name,n=function(t,e){if(t){var r,n,i="";for(n in t)r=t[n],i&&(i+=" "),i+=n="foreign"===e.xmlMode?a.attributeNames[n]||n:n,(null!==r&&""!==r||e.xmlMode)&&(i+='="'+(e.decodeEntities?s.encodeXML(r):r.replace(/\"/g,"&quot;"))+'"');return i}}(t.attribs,e);n&&(r+=" "+n);!e.xmlMode||t.children&&0!==t.children.length?(r+=">",t.children&&(r+=l(t.children,e)),c[t.name]&&!e.xmlMode||(r+="</"+t.name+">")):r+="/>";return r}(i,e):i.type===o.Directive?r+="<"+i.data+">":i.type===o.Comment?r+="\x3c!--"+i.data+"--\x3e":i.type===o.CDATA?r+="<![CDATA["+i.children[0].data+"]]>":r+=function(t,e){var r=t.data||"";!e.decodeEntities||t.parent&&t.parent.name in u||(r=s.encodeXML(r));return r}(i,e)}return r},f=["mi","mo","mn","ms","mtext","annotation-xml","foreignObject","desc","title"]},{"./foreignNames.json":4,domelementtype:6,entities:20}],6:[function(t,e,r){Object.defineProperty(r,"__esModule",{value:!0}),r.isTag=function(t){return"tag"===t.type||"script"===t.type||"style"===t.type},r.Text="text",r.Directive="directive",r.Comment="comment",r.Script="script",r.Style="style",r.Tag="tag",r.CDATA="cdata",r.Doctype="doctype"},{}],7:[function(t,e,r){Object.defineProperty(r,"__esModule",{value:!0});var n=t("./node"),i=(r.Node=n.Node,r.Element=n.Element,r.DataNode=n.DataNode,r.NodeWithChildren=n.NodeWithChildren,/\s+/g),o={normalizeWhitespace:!1,withStartIndices:!1,withEndIndices:!1},t=(s.prototype.onparserinit=function(t){this._parser=t},s.prototype.onreset=function(){this.dom=[],this._done=!1,this._tagStack=[],this._lastNode=null,this._parser=this._parser||null},s.prototype.onend=function(){this._done||(this._done=!0,this._parser=null,this.handleCallback(null))},s.prototype.onerror=function(t){this.handleCallback(t)},s.prototype.onclosetag=function(){this._lastNode=null;var t=this._tagStack.pop();t&&this._parser&&(this._options.withEndIndices&&(t.endIndex=this._parser.endIndex),this._elementCB)&&this._elementCB(t)},s.prototype.onopentag=function(t,e){t=new n.Element(t,e);this.addNode(t),this._tagStack.push(t)},s.prototype.ontext=function(t){var e=this._options.normalizeWhitespace,r=this._lastNode;r&&"text"===r.type?e?r.data=(r.data+t).replace(i," "):r.data+=t:(e&&(t=t.replace(i," ")),r=new n.DataNode("text",t),this.addNode(r),this._lastNode=r)},s.prototype.oncomment=function(t){this._lastNode&&"comment"===this._lastNode.type?this._lastNode.data+=t:(t=new n.DataNode("comment",t),this.addNode(t),this._lastNode=t)},s.prototype.oncommentend=function(){this._lastNode=null},s.prototype.oncdatastart=function(){var t=new n.DataNode("text",""),e=new n.NodeWithChildren("cdata",[t]);this.addNode(e),t.parent=e,this._lastNode=t},s.prototype.oncdataend=function(){this._lastNode=null},s.prototype.onprocessinginstruction=function(t,e){t=new n.ProcessingInstruction(t,e);this.addNode(t)},s.prototype.handleCallback=function(t){if("function"==typeof this._callback)this._callback(t,this.dom);else if(t)throw t},s.prototype.addNode=function(t){var e=this._tagStack[this._tagStack.length-1],r=e?e.children:this.dom,n=r[r.length-1];this._parser&&(this._options.withStartIndices&&(t.startIndex=this._parser.startIndex),this._options.withEndIndices)&&(t.endIndex=this._parser.endIndex),r.push(t),n&&((t.prev=n).next=t),e&&(t.parent=e),this._lastNode=null},s.prototype.addDataNode=function(t){this.addNode(t),this._lastNode=t},s);function s(t,e,r){this.dom=[],this._done=!1,this._tagStack=[],this._lastNode=null,this._parser=null,"function"==typeof e&&(r=e,e=o),"object"===_typeof(t)&&(e=t,t=undefined),this._callback=t||null,this._options=e||o,this._elementCB=r||null}r.DomHandler=t,r["default"]=t},{"./node":8}],8:[function(t,e,r){var n,i=this&&this.__extends||(n=function(t,e){return(n=Object.setPrototypeOf||({__proto__:[]}instanceof Array?function(t,e){t.__proto__=e}:function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])}))(t,e)},function(t,e){function r(){this.constructor=t}n(t,e),t.prototype=null===e?Object.create(e):(r.prototype=e.prototype,new r)}),o=(Object.defineProperty(r,"__esModule",{value:!0}),new Map([["tag",1],["script",1],["style",1],["directive",1],["text",3],["cdata",4],["comment",8]])),s=(Object.defineProperty(a.prototype,"nodeType",{get:function(){return o.get(this.type)||1},enumerable:!0,configurable:!0}),Object.defineProperty(a.prototype,"parentNode",{get:function(){return this.parent||null},set:function(t){this.parent=t},enumerable:!0,configurable:!0}),Object.defineProperty(a.prototype,"previousSibling",{get:function(){return this.prev||null},set:function(t){this.prev=t},enumerable:!0,configurable:!0}),Object.defineProperty(a.prototype,"nextSibling",{get:function(){return this.next||null},set:function(t){this.next=t},enumerable:!0,configurable:!0}),a);function a(t){this.type=t,this.parent=null,this.prev=null,this.next=null,this.startIndex=null,this.endIndex=null}r.Node=s;i(l,u=s),Object.defineProperty(l.prototype,"nodeValue",{get:function(){return this.data},set:function(t){this.data=t},enumerable:!0,configurable:!0});var u,c=l;function l(t,e){t=u.call(this,t)||this;return t.data=e,t}r.DataNode=c;i(h,f=c);var f,c=h;function h(t,e){e=f.call(this,"directive",e)||this;return e.name=t,e}r.ProcessingInstruction=c;i(d,p=s),Object.defineProperty(d.prototype,"firstChild",{get:function(){return this.children[0]||null},enumerable:!0,configurable:!0}),Object.defineProperty(d.prototype,"lastChild",{get:function(){return this.children[this.children.length-1]||null},enumerable:!0,configurable:!0}),Object.defineProperty(d.prototype,"childNodes",{get:function(){return this.children},set:function(t){this.children=t},enumerable:!0,configurable:!0});var p,c=d;function d(t,e){t=p.call(this,t)||this;return t.children=e,t}r.NodeWithChildren=c;i(m,g=c),Object.defineProperty(m.prototype,"tagName",{get:function(){return this.name},set:function(t){this.name=t},enumerable:!0,configurable:!0});var g,s=m;function m(t,e){var r=g.call(this,"script"===t?"script":"style"===t?"style":"tag",[])||this;return r.name=t,r.attribs=e,r.attribs=e,r}r.Element=s},{}],9:[function(t,e,r){Object.defineProperty(r,"__esModule",{value:!0});var c=t("./tagtypes");function n(t,e){var r=[],n=[];if(t===e)return 0;for(var i=c.hasChildren(t)?t:t.parent;i;)r.unshift(i),i=i.parent;for(i=c.hasChildren(e)?e:e.parent;i;)n.unshift(i),i=i.parent;for(var o,s,a,u=0;r[u]===n[u];)u++;return 0===u?1:(s=(o=r[u-1]).children,a=n[u],s.indexOf(r[u])>s.indexOf(a)?o===e?20:4:o===t?10:2)}r.removeSubsets=function(t){for(var e=t.length;0<=--e;){var r=t[e];if(0<e&&0<=t.lastIndexOf(r,e-1))t.splice(e,1);else for(var n=r.parent;n;n=n.parent)if(-1<t.indexOf(n)){t.splice(e,1);break}}return t},r.compareDocumentPosition=n,r.uniqueSort=function(t){return(t=t.filter(function(t,e,r){return!r.includes(t,e+1)})).sort(function(t,e){t=n(t,e);return 2&t?-1:4&t?1:0}),t}},{"./tagtypes":15}],10:[function(t,e,r){function n(t){for(var e in t)r.hasOwnProperty(e)||(r[e]=t[e])}Object.defineProperty(r,"__esModule",{value:!0}),n(t("./stringify")),n(t("./traversal")),n(t("./manipulation")),n(t("./querying")),n(t("./legacy")),n(t("./helpers")),n(t("./tagtypes"))},{"./helpers":9,"./legacy":11,"./manipulation":12,"./querying":13,"./stringify":14,"./tagtypes":15,"./traversal":16}],11:[function(t,e,r){Object.defineProperty(r,"__esModule",{value:!0});var i=t("./querying"),n=t("./tagtypes");function o(t){return"text"===t.type}var s={tag_name:function(e){return"function"==typeof e?function(t){return n.isTag(t)&&e(t.name)}:"*"===e?n.isTag:function(t){return n.isTag(t)&&t.name===e}},tag_type:function(e){return"function"==typeof e?function(t){return e(t.type)}:function(t){return t.type===e}},tag_contains:function(e){return"function"==typeof e?function(t){return o(t)&&e(t.data)}:function(t){return o(t)&&t.data===e}}};function a(e,r){return"function"==typeof r?function(t){return n.isTag(t)&&r(t.attribs[e])}:function(t){return n.isTag(t)&&t.attribs[e]===r}}function u(e,r){return function(t){return e(t)||r(t)}}function c(r){var t=Object.keys(r).map(function(t){var e=r[t];return t in s?s[t](e):a(t,e)});return 0===t.length?null:t.reduce(u)}r.testElement=function(t,e){return!(t=c(t))||t(e)},r.getElements=function(t,e,r,n){return void 0===n&&(n=Infinity),(t=c(t))?i.filter(t,e,r,n):[]},r.getElementById=function(t,e,r){return void 0===r&&(r=!0),Array.isArray(e)||(e=[e]),i.findOne(a("id",t),e,r)},r.getElementsByTagName=function(t,e,r,n){return void 0===n&&(n=Infinity),i.filter(s.tag_name(t),e,r,n)},r.getElementsByTagType=function(t,e,r,n){return void 0===r&&(r=!0),void 0===n&&(n=Infinity),i.filter(s.tag_type(t),e,r,n)}},{"./querying":13,"./tagtypes":15}],12:[function(t,e,r){Object.defineProperty(r,"__esModule",{value:!0}),r.removeElement=function(t){var e;t.prev&&(t.prev.next=t.next),t.next&&(t.next.prev=t.prev),t.parent&&(e=t.parent.children).splice(e.lastIndexOf(t),1)},r.replaceElement=function(t,e){var r=e.prev=t.prev;r&&(r.next=e),(r=e.next=t.next)&&(r.prev=e),(r=e.parent=t.parent)&&((r=r.children)[r.lastIndexOf(t)]=e)},r.appendChild=function(t,e){1!==(e.parent=t).children.push(e)&&(((t=t.children[t.children.length-2]).next=e).prev=t,e.next=null)},r.append=function(t,e){var r=t.parent,n=t.next;e.next=n,((e.prev=t).next=e).parent=r,n?(n.prev=e,r&&(t=r.children).splice(t.lastIndexOf(n),0,e)):r&&r.children.push(e)},r.prepend=function(t,e){var r,n=t.parent;n&&(r=n.children).splice(r.lastIndexOf(t),0,e),t.prev&&(t.prev.next=e),e.parent=n,e.prev=t.prev,(e.next=t).prev=e}},{}],13:[function(t,e,r){Object.defineProperty(r,"__esModule",{value:!0});var a=t("./tagtypes");function u(t,e,r,n){for(var i=[],o=0;o<e.length;o++){var s=e[o];if(t(s)&&(i.push(s),--n<=0))break;if(r&&a.hasChildren(s)&&0<s.children.length){s=u(t,s.children,r,n),i=i.concat(s);if((n-=s.length)<=0)break}}return i}r.filter=function(t,e,r,n){return void 0===r&&(r=!0),void 0===n&&(n=Infinity),u(t,e=Array.isArray(e)?e:[e],r,n)},r.find=u,r.findOneChild=function(t,e){for(var r=0;r<e.length;r++)if(t(e[r]))return e[r];return null},r.findOne=function s(t,e,r){void 0===r&&(r=!0);for(var n=null,i=0;i<e.length&&!n;i++){var o=e[i];a.isTag(o)&&(t(o)?n=o:r&&0<o.children.length&&(n=s(t,o.children)))}return n},r.existsOne=function i(t,e){for(var r=0;r<e.length;r++){var n=e[r];if(a.isTag(n)&&(t(n)||0<n.children.length&&i(t,n.children)))return!0}return!1},r.findAll=function(t,e){for(var r=[],n=e.slice();n.length;){var i=n.shift();i&&a.isTag(i)&&(i.children&&0<i.children.length&&n.unshift.apply(n,i.children),t(i))&&r.push(i)}return r}},{"./tagtypes":15}],14:[function(t,e,r){var n=this&&this.__importDefault||function(t){return t&&t.__esModule?t:{"default":t}},i=(Object.defineProperty(r,"__esModule",{value:!0}),t("./tagtypes")),t=n(t("dom-serializer"));r.getOuterHTML=t["default"],r.getInnerHTML=function(t,e){return i.hasChildren(t)?t.children.map(function(t){return r.getOuterHTML(t,e)}).join(""):""},r.getText=function o(t){return Array.isArray(t)?t.map(o).join(""):i.isTag(t)?"br"===t.name?"\n":o(t.children):i.isCDATA(t)?o(t.children):i.isText(t)?t.data:""}},{"./tagtypes":15,"dom-serializer":5}],15:[function(t,e,r){Object.defineProperty(r,"__esModule",{value:!0});var n=t("domelementtype");r.isTag=function(t){return n.isTag(t)},r.isCDATA=function(t){return"cdata"===t.type},r.isText=function(t){return"text"===t.type},r.isComment=function(t){return"comment"===t.type},r.hasChildren=function(t){return Object.prototype.hasOwnProperty.call(t,"children")}},{domelementtype:6}],16:[function(t,e,r){function n(t){return t.children||null}function i(t){return t.parent||null}function o(t,e){return t.attribs&&t.attribs[e]}Object.defineProperty(r,"__esModule",{value:!0}),r.getChildren=n,r.getParent=i,r.getSiblings=function(t){var e=i(t);return e?n(e):[t]},r.getAttributeValue=o,r.hasAttrib=function(t,e){return!!o(t,e)},r.getName=function(t){return t.name}},{}],17:[function(t,e,r){var n=this&&this.__importDefault||function(t){return t&&t.__esModule?t:{"default":t}},a=(Object.defineProperty(r,"__esModule",{value:!0}),n(t("./maps/entities.json"))),u=n(t("./maps/legacy.json")),i=n(t("./maps/xml.json")),o=n(t("./decode_codepoint"));function s(t){var e=Object.keys(t).join("|"),r=l(t),n=(e+="|#[xX][\\da-fA-F]+|#\\d+",new RegExp("&(?:"+e+");","g"));return function(t){return String(t).replace(n,r)}}r.decodeXML=s(i["default"]),r.decodeHTMLStrict=s(a["default"]);var c=function c(t,e){return t<e?1:-1};function l(e){return function(t){return"#"===t.charAt(1)?"X"===t.charAt(2)||"x"===t.charAt(2)?o["default"](parseInt(t.substr(3),16)):o["default"](parseInt(t.substr(2),10)):e[t.slice(1,-1)]}}r.decodeHTML=function(){for(var t=Object.keys(u["default"]).sort(c),e=Object.keys(a["default"]).sort(c),r=0,n=0;r<e.length;r++)t[n]===e[r]?(e[r]+=";?",n++):e[r]+=";";var i=new RegExp("&(?:"+e.join("|")+"|#[xX][\\da-fA-F]+;?|#\\d+;?)","g"),o=l(a["default"]);function s(t){return";"!==t.substr(-1)&&(t+=";"),o(t)}return function(t){return String(t).replace(i,s)}}()},{"./decode_codepoint":18,"./maps/entities.json":22,"./maps/legacy.json":23,"./maps/xml.json":24}],18:[function(t,e,r){var n=this&&this.__importDefault||function(t){return t&&t.__esModule?t:{"default":t}},i=(Object.defineProperty(r,"__esModule",{value:!0}),n(t("./maps/decode.json")));r["default"]=function(t){var e;return 55296<=t&&t<=57343||1114111<t?"�":(e="",65535<(t=t in i["default"]?i["default"][t]:t)&&(t-=65536,e+=String.fromCharCode(t>>>10&1023|55296),t=56320|1023&t),e+String.fromCharCode(t))}},{"./maps/decode.json":21}],19:[function(t,e,r){var n=this&&this.__importDefault||function(t){return t&&t.__esModule?t:{"default":t}};Object.defineProperty(r,"__esModule",{value:!0});var i=s(n(t("./maps/xml.json"))["default"]),o=a(i);r.encodeXML=h(i,o);o=s(n(t("./maps/entities.json"))["default"]),t=a(o);function s(r){return Object.keys(r).sort().reduce(function(t,e){return t[r[e]]="&"+e+";",t},{})}function a(t){var e=[],r=[];return Object.keys(t).forEach(function(t){return 1===t.length?e.push("\\"+t):r.push(t)}),r.unshift("["+e.join("")+"]"),new RegExp(r.join("|"),"g")}r.encodeHTML=h(o,t);var u=/[^\0-\x7F]/g,c=/[\uD800-\uDBFF][\uDC00-\uDFFF]/g;function l(t){return"&#x"+t.charCodeAt(0).toString(16).toUpperCase()+";"}function f(t,e){return"&#x"+(1024*(t.charCodeAt(0)-55296)+t.charCodeAt(1)-56320+65536).toString(16).toUpperCase()+";"}function h(e,r){return function(t){return t.replace(r,function(t){return e[t]}).replace(c,f).replace(u,l)}}var p=a(i);r.escape=function(t){return t.replace(p,l).replace(c,f).replace(u,l)}},{"./maps/entities.json":22,"./maps/xml.json":24}],20:[function(t,e,r){Object.defineProperty(r,"__esModule",{value:!0});var n=t("./decode"),i=t("./encode");r.decode=function(t,e){return(!e||e<=0?n.decodeXML:n.decodeHTML)(t)},r.decodeStrict=function(t,e){return(!e||e<=0?n.decodeXML:n.decodeHTMLStrict)(t)},r.encode=function(t,e){return(!e||e<=0?i.encodeXML:i.encodeHTML)(t)};var o=t("./encode"),o=(r.encodeXML=o.encodeXML,r.encodeHTML=o.encodeHTML,r.escape=o.escape,r.encodeHTML4=o.encodeHTML,r.encodeHTML5=o.encodeHTML,t("./decode"));r.decodeXML=o.decodeXML,r.decodeHTML=o.decodeHTML,r.decodeHTMLStrict=o.decodeHTMLStrict,r.decodeHTML4=o.decodeHTML,r.decodeHTML5=o.decodeHTML,r.decodeHTML4Strict=o.decodeHTMLStrict,r.decodeHTML5Strict=o.decodeHTMLStrict,r.decodeXMLStrict=o.decodeXML},{"./decode":17,"./encode":19}],21:[function(t,e,r){e.exports={0:65533,128:8364,130:8218,131:402,132:8222,133:8230,134:8224,135:8225,136:710,137:8240,138:352,139:8249,140:338,142:381,145:8216,146:8217,147:8220,148:8221,149:8226,150:8211,151:8212,152:732,153:8482,154:353,155:8250,156:339,158:382,159:376}},{}],22:[function(t,e,r){e.exports={Aacute:"Á",aacute:"á",Abreve:"Ă",abreve:"ă",ac:"∾",acd:"∿",acE:"∾̳",Acirc:"Â",acirc:"â",acute:"´",Acy:"А",acy:"а",AElig:"Æ",aelig:"æ",af:"⁡",Afr:"𝔄",afr:"𝔞",Agrave:"À",agrave:"à",alefsym:"ℵ",aleph:"ℵ",Alpha:"Α",alpha:"α",Amacr:"Ā",amacr:"ā",amalg:"⨿",amp:"&",AMP:"&",andand:"⩕",And:"⩓",and:"∧",andd:"⩜",andslope:"⩘",andv:"⩚",ang:"∠",ange:"⦤",angle:"∠",angmsdaa:"⦨",angmsdab:"⦩",angmsdac:"⦪",angmsdad:"⦫",angmsdae:"⦬",angmsdaf:"⦭",angmsdag:"⦮",angmsdah:"⦯",angmsd:"∡",angrt:"∟",angrtvb:"⊾",angrtvbd:"⦝",angsph:"∢",angst:"Å",angzarr:"⍼",Aogon:"Ą",aogon:"ą",Aopf:"𝔸",aopf:"𝕒",apacir:"⩯",ap:"≈",apE:"⩰",ape:"≊",apid:"≋",apos:"'",ApplyFunction:"⁡",approx:"≈",approxeq:"≊",Aring:"Å",aring:"å",Ascr:"𝒜",ascr:"𝒶",Assign:"≔",ast:"*",asymp:"≈",asympeq:"≍",Atilde:"Ã",atilde:"ã",Auml:"Ä",auml:"ä",awconint:"∳",awint:"⨑",backcong:"≌",backepsilon:"϶",backprime:"‵",backsim:"∽",backsimeq:"⋍",Backslash:"∖",Barv:"⫧",barvee:"⊽",barwed:"⌅",Barwed:"⌆",barwedge:"⌅",bbrk:"⎵",bbrktbrk:"⎶",bcong:"≌",Bcy:"Б",bcy:"б",bdquo:"„",becaus:"∵",because:"∵",Because:"∵",bemptyv:"⦰",bepsi:"϶",bernou:"ℬ",Bernoullis:"ℬ",Beta:"Β",beta:"β",beth:"ℶ",between:"≬",Bfr:"𝔅",bfr:"𝔟",bigcap:"⋂",bigcirc:"◯",bigcup:"⋃",bigodot:"⨀",bigoplus:"⨁",bigotimes:"⨂",bigsqcup:"⨆",bigstar:"★",bigtriangledown:"▽",bigtriangleup:"△",biguplus:"⨄",bigvee:"⋁",bigwedge:"⋀",bkarow:"⤍",blacklozenge:"⧫",blacksquare:"▪",blacktriangle:"▴",blacktriangledown:"▾",blacktriangleleft:"◂",blacktriangleright:"▸",blank:"␣",blk12:"▒",blk14:"░",blk34:"▓",block:"█",bne:"=⃥",bnequiv:"≡⃥",bNot:"⫭",bnot:"⌐",Bopf:"𝔹",bopf:"𝕓",bot:"⊥",bottom:"⊥",bowtie:"⋈",boxbox:"⧉",boxdl:"┐",boxdL:"╕",boxDl:"╖",boxDL:"╗",boxdr:"┌",boxdR:"╒",boxDr:"╓",boxDR:"╔",boxh:"─",boxH:"═",boxhd:"┬",boxHd:"╤",boxhD:"╥",boxHD:"╦",boxhu:"┴",boxHu:"╧",boxhU:"╨",boxHU:"╩",boxminus:"⊟",boxplus:"⊞",boxtimes:"⊠",boxul:"┘",boxuL:"╛",boxUl:"╜",boxUL:"╝",boxur:"└",boxuR:"╘",boxUr:"╙",boxUR:"╚",boxv:"│",boxV:"║",boxvh:"┼",boxvH:"╪",boxVh:"╫",boxVH:"╬",boxvl:"┤",boxvL:"╡",boxVl:"╢",boxVL:"╣",boxvr:"├",boxvR:"╞",boxVr:"╟",boxVR:"╠",bprime:"‵",breve:"˘",Breve:"˘",brvbar:"¦",bscr:"𝒷",Bscr:"ℬ",bsemi:"⁏",bsim:"∽",bsime:"⋍",bsolb:"⧅",bsol:"\\",bsolhsub:"⟈",bull:"•",bullet:"•",bump:"≎",bumpE:"⪮",bumpe:"≏",Bumpeq:"≎",bumpeq:"≏",Cacute:"Ć",cacute:"ć",capand:"⩄",capbrcup:"⩉",capcap:"⩋",cap:"∩",Cap:"⋒",capcup:"⩇",capdot:"⩀",CapitalDifferentialD:"ⅅ",caps:"∩︀",caret:"⁁",caron:"ˇ",Cayleys:"ℭ",ccaps:"⩍",Ccaron:"Č",ccaron:"č",Ccedil:"Ç",ccedil:"ç",Ccirc:"Ĉ",ccirc:"ĉ",Cconint:"∰",ccups:"⩌",ccupssm:"⩐",Cdot:"Ċ",cdot:"ċ",cedil:"¸",Cedilla:"¸",cemptyv:"⦲",cent:"¢",centerdot:"·",CenterDot:"·",cfr:"𝔠",Cfr:"ℭ",CHcy:"Ч",chcy:"ч",check:"✓",checkmark:"✓",Chi:"Χ",chi:"χ",circ:"ˆ",circeq:"≗",circlearrowleft:"↺",circlearrowright:"↻",circledast:"⊛",circledcirc:"⊚",circleddash:"⊝",CircleDot:"⊙",circledR:"®",circledS:"Ⓢ",CircleMinus:"⊖",CirclePlus:"⊕",CircleTimes:"⊗",cir:"○",cirE:"⧃",cire:"≗",cirfnint:"⨐",cirmid:"⫯",cirscir:"⧂",ClockwiseContourIntegral:"∲",CloseCurlyDoubleQuote:"”",CloseCurlyQuote:"’",clubs:"♣",clubsuit:"♣",colon:":",Colon:"∷",Colone:"⩴",colone:"≔",coloneq:"≔",comma:",",commat:"@",comp:"∁",compfn:"∘",complement:"∁",complexes:"ℂ",cong:"≅",congdot:"⩭",Congruent:"≡",conint:"∮",Conint:"∯",ContourIntegral:"∮",copf:"𝕔",Copf:"ℂ",coprod:"∐",Coproduct:"∐",copy:"©",COPY:"©",copysr:"℗",CounterClockwiseContourIntegral:"∳",crarr:"↵",cross:"✗",Cross:"⨯",Cscr:"𝒞",cscr:"𝒸",csub:"⫏",csube:"⫑",csup:"⫐",csupe:"⫒",ctdot:"⋯",cudarrl:"⤸",cudarrr:"⤵",cuepr:"⋞",cuesc:"⋟",cularr:"↶",cularrp:"⤽",cupbrcap:"⩈",cupcap:"⩆",CupCap:"≍",cup:"∪",Cup:"⋓",cupcup:"⩊",cupdot:"⊍",cupor:"⩅",cups:"∪︀",curarr:"↷",curarrm:"⤼",curlyeqprec:"⋞",curlyeqsucc:"⋟",curlyvee:"⋎",curlywedge:"⋏",curren:"¤",curvearrowleft:"↶",curvearrowright:"↷",cuvee:"⋎",cuwed:"⋏",cwconint:"∲",cwint:"∱",cylcty:"⌭",dagger:"†",Dagger:"‡",daleth:"ℸ",darr:"↓",Darr:"↡",dArr:"⇓",dash:"‐",Dashv:"⫤",dashv:"⊣",dbkarow:"⤏",dblac:"˝",Dcaron:"Ď",dcaron:"ď",Dcy:"Д",dcy:"д",ddagger:"‡",ddarr:"⇊",DD:"ⅅ",dd:"ⅆ",DDotrahd:"⤑",ddotseq:"⩷",deg:"°",Del:"∇",Delta:"Δ",delta:"δ",demptyv:"⦱",dfisht:"⥿",Dfr:"𝔇",dfr:"𝔡",dHar:"⥥",dharl:"⇃",dharr:"⇂",DiacriticalAcute:"´",DiacriticalDot:"˙",DiacriticalDoubleAcute:"˝",DiacriticalGrave:"`",DiacriticalTilde:"˜",diam:"⋄",diamond:"⋄",Diamond:"⋄",diamondsuit:"♦",diams:"♦",die:"¨",DifferentialD:"ⅆ",digamma:"ϝ",disin:"⋲",div:"÷",divide:"÷",divideontimes:"⋇",divonx:"⋇",DJcy:"Ђ",djcy:"ђ",dlcorn:"⌞",dlcrop:"⌍",dollar:"$",Dopf:"𝔻",dopf:"𝕕",Dot:"¨",dot:"˙",DotDot:"⃜",doteq:"≐",doteqdot:"≑",DotEqual:"≐",dotminus:"∸",dotplus:"∔",dotsquare:"⊡",doublebarwedge:"⌆",DoubleContourIntegral:"∯",DoubleDot:"¨",DoubleDownArrow:"⇓",DoubleLeftArrow:"⇐",DoubleLeftRightArrow:"⇔",DoubleLeftTee:"⫤",DoubleLongLeftArrow:"⟸",DoubleLongLeftRightArrow:"⟺",DoubleLongRightArrow:"⟹",DoubleRightArrow:"⇒",DoubleRightTee:"⊨",DoubleUpArrow:"⇑",DoubleUpDownArrow:"⇕",DoubleVerticalBar:"∥",DownArrowBar:"⤓",downarrow:"↓",DownArrow:"↓",Downarrow:"⇓",DownArrowUpArrow:"⇵",DownBreve:"̑",downdownarrows:"⇊",downharpoonleft:"⇃",downharpoonright:"⇂",DownLeftRightVector:"⥐",DownLeftTeeVector:"⥞",DownLeftVectorBar:"⥖",DownLeftVector:"↽",DownRightTeeVector:"⥟",DownRightVectorBar:"⥗",DownRightVector:"⇁",DownTeeArrow:"↧",DownTee:"⊤",drbkarow:"⤐",drcorn:"⌟",drcrop:"⌌",Dscr:"𝒟",dscr:"𝒹",DScy:"Ѕ",dscy:"ѕ",dsol:"⧶",Dstrok:"Đ",dstrok:"đ",dtdot:"⋱",dtri:"▿",dtrif:"▾",duarr:"⇵",duhar:"⥯",dwangle:"⦦",DZcy:"Џ",dzcy:"џ",dzigrarr:"⟿",Eacute:"É",eacute:"é",easter:"⩮",Ecaron:"Ě",ecaron:"ě",Ecirc:"Ê",ecirc:"ê",ecir:"≖",ecolon:"≕",Ecy:"Э",ecy:"э",eDDot:"⩷",Edot:"Ė",edot:"ė",eDot:"≑",ee:"ⅇ",efDot:"≒",Efr:"𝔈",efr:"𝔢",eg:"⪚",Egrave:"È",egrave:"è",egs:"⪖",egsdot:"⪘",el:"⪙",Element:"∈",elinters:"⏧",ell:"ℓ",els:"⪕",elsdot:"⪗",Emacr:"Ē",emacr:"ē",empty:"∅",emptyset:"∅",EmptySmallSquare:"◻",emptyv:"∅",EmptyVerySmallSquare:"▫",emsp13:" ",emsp14:" ",emsp:" ",ENG:"Ŋ",eng:"ŋ",ensp:" ",Eogon:"Ę",eogon:"ę",Eopf:"𝔼",eopf:"𝕖",epar:"⋕",eparsl:"⧣",eplus:"⩱",epsi:"ε",Epsilon:"Ε",epsilon:"ε",epsiv:"ϵ",eqcirc:"≖",eqcolon:"≕",eqsim:"≂",eqslantgtr:"⪖",eqslantless:"⪕",Equal:"⩵",equals:"=",EqualTilde:"≂",equest:"≟",Equilibrium:"⇌",equiv:"≡",equivDD:"⩸",eqvparsl:"⧥",erarr:"⥱",erDot:"≓",escr:"ℯ",Escr:"ℰ",esdot:"≐",Esim:"⩳",esim:"≂",Eta:"Η",eta:"η",ETH:"Ð",eth:"ð",Euml:"Ë",euml:"ë",euro:"€",excl:"!",exist:"∃",Exists:"∃",expectation:"ℰ",exponentiale:"ⅇ",ExponentialE:"ⅇ",fallingdotseq:"≒",Fcy:"Ф",fcy:"ф",female:"♀",ffilig:"ﬃ",fflig:"ﬀ",ffllig:"ﬄ",Ffr:"𝔉",ffr:"𝔣",filig:"ﬁ",FilledSmallSquare:"◼",FilledVerySmallSquare:"▪",fjlig:"fj",flat:"♭",fllig:"ﬂ",fltns:"▱",fnof:"ƒ",Fopf:"𝔽",fopf:"𝕗",forall:"∀",ForAll:"∀",fork:"⋔",forkv:"⫙",Fouriertrf:"ℱ",fpartint:"⨍",frac12:"½",frac13:"⅓",frac14:"¼",frac15:"⅕",frac16:"⅙",frac18:"⅛",frac23:"⅔",frac25:"⅖",frac34:"¾",frac35:"⅗",frac38:"⅜",frac45:"⅘",frac56:"⅚",frac58:"⅝",frac78:"⅞",frasl:"⁄",frown:"⌢",fscr:"𝒻",Fscr:"ℱ",gacute:"ǵ",Gamma:"Γ",gamma:"γ",Gammad:"Ϝ",gammad:"ϝ",gap:"⪆",Gbreve:"Ğ",gbreve:"ğ",Gcedil:"Ģ",Gcirc:"Ĝ",gcirc:"ĝ",Gcy:"Г",gcy:"г",Gdot:"Ġ",gdot:"ġ",ge:"≥",gE:"≧",gEl:"⪌",gel:"⋛",geq:"≥",geqq:"≧",geqslant:"⩾",gescc:"⪩",ges:"⩾",gesdot:"⪀",gesdoto:"⪂",gesdotol:"⪄",gesl:"⋛︀",gesles:"⪔",Gfr:"𝔊",gfr:"𝔤",gg:"≫",Gg:"⋙",ggg:"⋙",gimel:"ℷ",GJcy:"Ѓ",gjcy:"ѓ",gla:"⪥",gl:"≷",glE:"⪒",glj:"⪤",gnap:"⪊",gnapprox:"⪊",gne:"⪈",gnE:"≩",gneq:"⪈",gneqq:"≩",gnsim:"⋧",Gopf:"𝔾",gopf:"𝕘",grave:"`",GreaterEqual:"≥",GreaterEqualLess:"⋛",GreaterFullEqual:"≧",GreaterGreater:"⪢",GreaterLess:"≷",GreaterSlantEqual:"⩾",GreaterTilde:"≳",Gscr:"𝒢",gscr:"ℊ",gsim:"≳",gsime:"⪎",gsiml:"⪐",gtcc:"⪧",gtcir:"⩺",gt:">",GT:">",Gt:"≫",gtdot:"⋗",gtlPar:"⦕",gtquest:"⩼",gtrapprox:"⪆",gtrarr:"⥸",gtrdot:"⋗",gtreqless:"⋛",gtreqqless:"⪌",gtrless:"≷",gtrsim:"≳",gvertneqq:"≩︀",gvnE:"≩︀",Hacek:"ˇ",hairsp:" ",half:"½",hamilt:"ℋ",HARDcy:"Ъ",hardcy:"ъ",harrcir:"⥈",harr:"↔",hArr:"⇔",harrw:"↭",Hat:"^",hbar:"ℏ",Hcirc:"Ĥ",hcirc:"ĥ",hearts:"♥",heartsuit:"♥",hellip:"…",hercon:"⊹",hfr:"𝔥",Hfr:"ℌ",HilbertSpace:"ℋ",hksearow:"⤥",hkswarow:"⤦",hoarr:"⇿",homtht:"∻",hookleftarrow:"↩",hookrightarrow:"↪",hopf:"𝕙",Hopf:"ℍ",horbar:"―",HorizontalLine:"─",hscr:"𝒽",Hscr:"ℋ",hslash:"ℏ",Hstrok:"Ħ",hstrok:"ħ",HumpDownHump:"≎",HumpEqual:"≏",hybull:"⁃",hyphen:"‐",Iacute:"Í",iacute:"í",ic:"⁣",Icirc:"Î",icirc:"î",Icy:"И",icy:"и",Idot:"İ",IEcy:"Е",iecy:"е",iexcl:"¡",iff:"⇔",ifr:"𝔦",Ifr:"ℑ",Igrave:"Ì",igrave:"ì",ii:"ⅈ",iiiint:"⨌",iiint:"∭",iinfin:"⧜",iiota:"℩",IJlig:"Ĳ",ijlig:"ĳ",Imacr:"Ī",imacr:"ī",image:"ℑ",ImaginaryI:"ⅈ",imagline:"ℐ",imagpart:"ℑ",imath:"ı",Im:"ℑ",imof:"⊷",imped:"Ƶ",Implies:"⇒",incare:"℅","in":"∈",infin:"∞",infintie:"⧝",inodot:"ı",intcal:"⊺","int":"∫",Int:"∬",integers:"ℤ",Integral:"∫",intercal:"⊺",Intersection:"⋂",intlarhk:"⨗",intprod:"⨼",InvisibleComma:"⁣",InvisibleTimes:"⁢",IOcy:"Ё",iocy:"ё",Iogon:"Į",iogon:"į",Iopf:"𝕀",iopf:"𝕚",Iota:"Ι",iota:"ι",iprod:"⨼",iquest:"¿",iscr:"𝒾",Iscr:"ℐ",isin:"∈",isindot:"⋵",isinE:"⋹",isins:"⋴",isinsv:"⋳",isinv:"∈",it:"⁢",Itilde:"Ĩ",itilde:"ĩ",Iukcy:"І",iukcy:"і",Iuml:"Ï",iuml:"ï",Jcirc:"Ĵ",jcirc:"ĵ",Jcy:"Й",jcy:"й",Jfr:"𝔍",jfr:"𝔧",jmath:"ȷ",Jopf:"𝕁",jopf:"𝕛",Jscr:"𝒥",jscr:"𝒿",Jsercy:"Ј",jsercy:"ј",Jukcy:"Є",jukcy:"є",Kappa:"Κ",kappa:"κ",kappav:"ϰ",Kcedil:"Ķ",kcedil:"ķ",Kcy:"К",kcy:"к",Kfr:"𝔎",kfr:"𝔨",kgreen:"ĸ",KHcy:"Х",khcy:"х",KJcy:"Ќ",kjcy:"ќ",Kopf:"𝕂",kopf:"𝕜",Kscr:"𝒦",kscr:"𝓀",lAarr:"⇚",Lacute:"Ĺ",lacute:"ĺ",laemptyv:"⦴",lagran:"ℒ",Lambda:"Λ",lambda:"λ",lang:"⟨",Lang:"⟪",langd:"⦑",langle:"⟨",lap:"⪅",Laplacetrf:"ℒ",laquo:"«",larrb:"⇤",larrbfs:"⤟",larr:"←",Larr:"↞",lArr:"⇐",larrfs:"⤝",larrhk:"↩",larrlp:"↫",larrpl:"⤹",larrsim:"⥳",larrtl:"↢",latail:"⤙",lAtail:"⤛",lat:"⪫",late:"⪭",lates:"⪭︀",lbarr:"⤌",lBarr:"⤎",lbbrk:"❲",lbrace:"{",lbrack:"[",lbrke:"⦋",lbrksld:"⦏",lbrkslu:"⦍",Lcaron:"Ľ",lcaron:"ľ",Lcedil:"Ļ",lcedil:"ļ",lceil:"⌈",lcub:"{",Lcy:"Л",lcy:"л",ldca:"⤶",ldquo:"“",ldquor:"„",ldrdhar:"⥧",ldrushar:"⥋",ldsh:"↲",le:"≤",lE:"≦",LeftAngleBracket:"⟨",LeftArrowBar:"⇤",leftarrow:"←",LeftArrow:"←",Leftarrow:"⇐",LeftArrowRightArrow:"⇆",leftarrowtail:"↢",LeftCeiling:"⌈",LeftDoubleBracket:"⟦",LeftDownTeeVector:"⥡",LeftDownVectorBar:"⥙",LeftDownVector:"⇃",LeftFloor:"⌊",leftharpoondown:"↽",leftharpoonup:"↼",leftleftarrows:"⇇",leftrightarrow:"↔",LeftRightArrow:"↔",Leftrightarrow:"⇔",leftrightarrows:"⇆",leftrightharpoons:"⇋",leftrightsquigarrow:"↭",LeftRightVector:"⥎",LeftTeeArrow:"↤",LeftTee:"⊣",LeftTeeVector:"⥚",leftthreetimes:"⋋",LeftTriangleBar:"⧏",LeftTriangle:"⊲",LeftTriangleEqual:"⊴",LeftUpDownVector:"⥑",LeftUpTeeVector:"⥠",LeftUpVectorBar:"⥘",LeftUpVector:"↿",LeftVectorBar:"⥒",LeftVector:"↼",lEg:"⪋",leg:"⋚",leq:"≤",leqq:"≦",leqslant:"⩽",lescc:"⪨",les:"⩽",lesdot:"⩿",lesdoto:"⪁",lesdotor:"⪃",lesg:"⋚︀",lesges:"⪓",lessapprox:"⪅",lessdot:"⋖",lesseqgtr:"⋚",lesseqqgtr:"⪋",LessEqualGreater:"⋚",LessFullEqual:"≦",LessGreater:"≶",lessgtr:"≶",LessLess:"⪡",lesssim:"≲",LessSlantEqual:"⩽",LessTilde:"≲",lfisht:"⥼",lfloor:"⌊",Lfr:"𝔏",lfr:"𝔩",lg:"≶",lgE:"⪑",lHar:"⥢",lhard:"↽",lharu:"↼",lharul:"⥪",lhblk:"▄",LJcy:"Љ",ljcy:"љ",llarr:"⇇",ll:"≪",Ll:"⋘",llcorner:"⌞",Lleftarrow:"⇚",llhard:"⥫",lltri:"◺",Lmidot:"Ŀ",lmidot:"ŀ",lmoustache:"⎰",lmoust:"⎰",lnap:"⪉",lnapprox:"⪉",lne:"⪇",lnE:"≨",lneq:"⪇",lneqq:"≨",lnsim:"⋦",loang:"⟬",loarr:"⇽",lobrk:"⟦",longleftarrow:"⟵",LongLeftArrow:"⟵",Longleftarrow:"⟸",longleftrightarrow:"⟷",LongLeftRightArrow:"⟷",Longleftrightarrow:"⟺",longmapsto:"⟼",longrightarrow:"⟶",LongRightArrow:"⟶",Longrightarrow:"⟹",looparrowleft:"↫",looparrowright:"↬",lopar:"⦅",Lopf:"𝕃",lopf:"𝕝",loplus:"⨭",lotimes:"⨴",lowast:"∗",lowbar:"_",LowerLeftArrow:"↙",LowerRightArrow:"↘",loz:"◊",lozenge:"◊",lozf:"⧫",lpar:"(",lparlt:"⦓",lrarr:"⇆",lrcorner:"⌟",lrhar:"⇋",lrhard:"⥭",lrm:"‎",lrtri:"⊿",lsaquo:"‹",lscr:"𝓁",Lscr:"ℒ",lsh:"↰",Lsh:"↰",lsim:"≲",lsime:"⪍",lsimg:"⪏",lsqb:"[",lsquo:"‘",lsquor:"‚",Lstrok:"Ł",lstrok:"ł",ltcc:"⪦",ltcir:"⩹",lt:"<",LT:"<",Lt:"≪",ltdot:"⋖",lthree:"⋋",ltimes:"⋉",ltlarr:"⥶",ltquest:"⩻",ltri:"◃",ltrie:"⊴",ltrif:"◂",ltrPar:"⦖",lurdshar:"⥊",luruhar:"⥦",lvertneqq:"≨︀",lvnE:"≨︀",macr:"¯",male:"♂",malt:"✠",maltese:"✠",Map:"⤅",map:"↦",mapsto:"↦",mapstodown:"↧",mapstoleft:"↤",mapstoup:"↥",marker:"▮",mcomma:"⨩",Mcy:"М",mcy:"м",mdash:"—",mDDot:"∺",measuredangle:"∡",MediumSpace:" ",Mellintrf:"ℳ",Mfr:"𝔐",mfr:"𝔪",mho:"℧",micro:"µ",midast:"*",midcir:"⫰",mid:"∣",middot:"·",minusb:"⊟",minus:"−",minusd:"∸",minusdu:"⨪",MinusPlus:"∓",mlcp:"⫛",mldr:"…",mnplus:"∓",models:"⊧",Mopf:"𝕄",mopf:"𝕞",mp:"∓",mscr:"𝓂",Mscr:"ℳ",mstpos:"∾",Mu:"Μ",mu:"μ",multimap:"⊸",mumap:"⊸",nabla:"∇",Nacute:"Ń",nacute:"ń",nang:"∠⃒",nap:"≉",napE:"⩰̸",napid:"≋̸",napos:"ŉ",napprox:"≉",natural:"♮",naturals:"ℕ",natur:"♮",nbsp:" ",nbump:"≎̸",nbumpe:"≏̸",ncap:"⩃",Ncaron:"Ň",ncaron:"ň",Ncedil:"Ņ",ncedil:"ņ",ncong:"≇",ncongdot:"⩭̸",ncup:"⩂",Ncy:"Н",ncy:"н",ndash:"–",nearhk:"⤤",nearr:"↗",neArr:"⇗",nearrow:"↗",ne:"≠",nedot:"≐̸",NegativeMediumSpace:"​",NegativeThickSpace:"​",NegativeThinSpace:"​",NegativeVeryThinSpace:"​",nequiv:"≢",nesear:"⤨",nesim:"≂̸",NestedGreaterGreater:"≫",NestedLessLess:"≪",NewLine:"\n",nexist:"∄",nexists:"∄",Nfr:"𝔑",nfr:"𝔫",ngE:"≧̸",nge:"≱",ngeq:"≱",ngeqq:"≧̸",ngeqslant:"⩾̸",nges:"⩾̸",nGg:"⋙̸",ngsim:"≵",nGt:"≫⃒",ngt:"≯",ngtr:"≯",nGtv:"≫̸",nharr:"↮",nhArr:"⇎",nhpar:"⫲",ni:"∋",nis:"⋼",nisd:"⋺",niv:"∋",NJcy:"Њ",njcy:"њ",nlarr:"↚",nlArr:"⇍",nldr:"‥",nlE:"≦̸",nle:"≰",nleftarrow:"↚",nLeftarrow:"⇍",nleftrightarrow:"↮",nLeftrightarrow:"⇎",nleq:"≰",nleqq:"≦̸",nleqslant:"⩽̸",nles:"⩽̸",nless:"≮",nLl:"⋘̸",nlsim:"≴",nLt:"≪⃒",nlt:"≮",nltri:"⋪",nltrie:"⋬",nLtv:"≪̸",nmid:"∤",NoBreak:"⁠",NonBreakingSpace:" ",nopf:"𝕟",Nopf:"ℕ",Not:"⫬",not:"¬",NotCongruent:"≢",NotCupCap:"≭",NotDoubleVerticalBar:"∦",NotElement:"∉",NotEqual:"≠",NotEqualTilde:"≂̸",NotExists:"∄",NotGreater:"≯",NotGreaterEqual:"≱",NotGreaterFullEqual:"≧̸",NotGreaterGreater:"≫̸",NotGreaterLess:"≹",NotGreaterSlantEqual:"⩾̸",NotGreaterTilde:"≵",NotHumpDownHump:"≎̸",NotHumpEqual:"≏̸",notin:"∉",notindot:"⋵̸",notinE:"⋹̸",notinva:"∉",notinvb:"⋷",notinvc:"⋶",NotLeftTriangleBar:"⧏̸",NotLeftTriangle:"⋪",NotLeftTriangleEqual:"⋬",NotLess:"≮",NotLessEqual:"≰",NotLessGreater:"≸",NotLessLess:"≪̸",NotLessSlantEqual:"⩽̸",NotLessTilde:"≴",NotNestedGreaterGreater:"⪢̸",NotNestedLessLess:"⪡̸",notni:"∌",notniva:"∌",notnivb:"⋾",notnivc:"⋽",NotPrecedes:"⊀",NotPrecedesEqual:"⪯̸",NotPrecedesSlantEqual:"⋠",NotReverseElement:"∌",NotRightTriangleBar:"⧐̸",NotRightTriangle:"⋫",NotRightTriangleEqual:"⋭",NotSquareSubset:"⊏̸",NotSquareSubsetEqual:"⋢",NotSquareSuperset:"⊐̸",NotSquareSupersetEqual:"⋣",NotSubset:"⊂⃒",NotSubsetEqual:"⊈",NotSucceeds:"⊁",NotSucceedsEqual:"⪰̸",NotSucceedsSlantEqual:"⋡",NotSucceedsTilde:"≿̸",NotSuperset:"⊃⃒",NotSupersetEqual:"⊉",NotTilde:"≁",NotTildeEqual:"≄",NotTildeFullEqual:"≇",NotTildeTilde:"≉",NotVerticalBar:"∤",nparallel:"∦",npar:"∦",nparsl:"⫽⃥",npart:"∂̸",npolint:"⨔",npr:"⊀",nprcue:"⋠",nprec:"⊀",npreceq:"⪯̸",npre:"⪯̸",nrarrc:"⤳̸",nrarr:"↛",nrArr:"⇏",nrarrw:"↝̸",nrightarrow:"↛",nRightarrow:"⇏",nrtri:"⋫",nrtrie:"⋭",nsc:"⊁",nsccue:"⋡",nsce:"⪰̸",Nscr:"𝒩",nscr:"𝓃",nshortmid:"∤",nshortparallel:"∦",nsim:"≁",nsime:"≄",nsimeq:"≄",nsmid:"∤",nspar:"∦",nsqsube:"⋢",nsqsupe:"⋣",nsub:"⊄",nsubE:"⫅̸",nsube:"⊈",nsubset:"⊂⃒",nsubseteq:"⊈",nsubseteqq:"⫅̸",nsucc:"⊁",nsucceq:"⪰̸",nsup:"⊅",nsupE:"⫆̸",nsupe:"⊉",nsupset:"⊃⃒",nsupseteq:"⊉",nsupseteqq:"⫆̸",ntgl:"≹",Ntilde:"Ñ",ntilde:"ñ",ntlg:"≸",ntriangleleft:"⋪",ntrianglelefteq:"⋬",ntriangleright:"⋫",ntrianglerighteq:"⋭",Nu:"Ν",nu:"ν",num:"#",numero:"№",numsp:" ",nvap:"≍⃒",nvdash:"⊬",nvDash:"⊭",nVdash:"⊮",nVDash:"⊯",nvge:"≥⃒",nvgt:">⃒",nvHarr:"⤄",nvinfin:"⧞",nvlArr:"⤂",nvle:"≤⃒",nvlt:"<⃒",nvltrie:"⊴⃒",nvrArr:"⤃",nvrtrie:"⊵⃒",nvsim:"∼⃒",nwarhk:"⤣",nwarr:"↖",nwArr:"⇖",nwarrow:"↖",nwnear:"⤧",Oacute:"Ó",oacute:"ó",oast:"⊛",Ocirc:"Ô",ocirc:"ô",ocir:"⊚",Ocy:"О",ocy:"о",odash:"⊝",Odblac:"Ő",odblac:"ő",odiv:"⨸",odot:"⊙",odsold:"⦼",OElig:"Œ",oelig:"œ",ofcir:"⦿",Ofr:"𝔒",ofr:"𝔬",ogon:"˛",Ograve:"Ò",ograve:"ò",ogt:"⧁",ohbar:"⦵",ohm:"Ω",oint:"∮",olarr:"↺",olcir:"⦾",olcross:"⦻",oline:"‾",olt:"⧀",Omacr:"Ō",omacr:"ō",Omega:"Ω",omega:"ω",Omicron:"Ο",omicron:"ο",omid:"⦶",ominus:"⊖",Oopf:"𝕆",oopf:"𝕠",opar:"⦷",OpenCurlyDoubleQuote:"“",OpenCurlyQuote:"‘",operp:"⦹",oplus:"⊕",orarr:"↻",Or:"⩔",or:"∨",ord:"⩝",order:"ℴ",orderof:"ℴ",ordf:"ª",ordm:"º",origof:"⊶",oror:"⩖",orslope:"⩗",orv:"⩛",oS:"Ⓢ",Oscr:"𝒪",oscr:"ℴ",Oslash:"Ø",oslash:"ø",osol:"⊘",Otilde:"Õ",otilde:"õ",otimesas:"⨶",Otimes:"⨷",otimes:"⊗",Ouml:"Ö",ouml:"ö",ovbar:"⌽",OverBar:"‾",OverBrace:"⏞",OverBracket:"⎴",OverParenthesis:"⏜",para:"¶",parallel:"∥",par:"∥",parsim:"⫳",parsl:"⫽",part:"∂",PartialD:"∂",Pcy:"П",pcy:"п",percnt:"%",period:".",permil:"‰",perp:"⊥",pertenk:"‱",Pfr:"𝔓",pfr:"𝔭",Phi:"Φ",phi:"φ",phiv:"ϕ",phmmat:"ℳ",phone:"☎",Pi:"Π",pi:"π",pitchfork:"⋔",piv:"ϖ",planck:"ℏ",planckh:"ℎ",plankv:"ℏ",plusacir:"⨣",plusb:"⊞",pluscir:"⨢",plus:"+",plusdo:"∔",plusdu:"⨥",pluse:"⩲",PlusMinus:"±",plusmn:"±",plussim:"⨦",plustwo:"⨧",pm:"±",Poincareplane:"ℌ",pointint:"⨕",popf:"𝕡",Popf:"ℙ",pound:"£",prap:"⪷",Pr:"⪻",pr:"≺",prcue:"≼",precapprox:"⪷",prec:"≺",preccurlyeq:"≼",Precedes:"≺",PrecedesEqual:"⪯",PrecedesSlantEqual:"≼",PrecedesTilde:"≾",preceq:"⪯",precnapprox:"⪹",precneqq:"⪵",precnsim:"⋨",pre:"⪯",prE:"⪳",precsim:"≾",prime:"′",Prime:"″",primes:"ℙ",prnap:"⪹",prnE:"⪵",prnsim:"⋨",prod:"∏",Product:"∏",profalar:"⌮",profline:"⌒",profsurf:"⌓",prop:"∝",Proportional:"∝",Proportion:"∷",propto:"∝",prsim:"≾",prurel:"⊰",Pscr:"𝒫",pscr:"𝓅",Psi:"Ψ",psi:"ψ",puncsp:" ",Qfr:"𝔔",qfr:"𝔮",qint:"⨌",qopf:"𝕢",Qopf:"ℚ",qprime:"⁗",Qscr:"𝒬",qscr:"𝓆",quaternions:"ℍ",quatint:"⨖",quest:"?",questeq:"≟",quot:'"',QUOT:'"',rAarr:"⇛",race:"∽̱",Racute:"Ŕ",racute:"ŕ",radic:"√",raemptyv:"⦳",rang:"⟩",Rang:"⟫",rangd:"⦒",range:"⦥",rangle:"⟩",raquo:"»",rarrap:"⥵",rarrb:"⇥",rarrbfs:"⤠",rarrc:"⤳",rarr:"→",Rarr:"↠",rArr:"⇒",rarrfs:"⤞",rarrhk:"↪",rarrlp:"↬",rarrpl:"⥅",rarrsim:"⥴",Rarrtl:"⤖",rarrtl:"↣",rarrw:"↝",ratail:"⤚",rAtail:"⤜",ratio:"∶",rationals:"ℚ",rbarr:"⤍",rBarr:"⤏",RBarr:"⤐",rbbrk:"❳",rbrace:"}",rbrack:"]",rbrke:"⦌",rbrksld:"⦎",rbrkslu:"⦐",Rcaron:"Ř",rcaron:"ř",Rcedil:"Ŗ",rcedil:"ŗ",rceil:"⌉",rcub:"}",Rcy:"Р",rcy:"р",rdca:"⤷",rdldhar:"⥩",rdquo:"”",rdquor:"”",rdsh:"↳",real:"ℜ",realine:"ℛ",realpart:"ℜ",reals:"ℝ",Re:"ℜ",rect:"▭",reg:"®",REG:"®",ReverseElement:"∋",ReverseEquilibrium:"⇋",ReverseUpEquilibrium:"⥯",rfisht:"⥽",rfloor:"⌋",rfr:"𝔯",Rfr:"ℜ",rHar:"⥤",rhard:"⇁",rharu:"⇀",rharul:"⥬",Rho:"Ρ",rho:"ρ",rhov:"ϱ",RightAngleBracket:"⟩",RightArrowBar:"⇥",rightarrow:"→",RightArrow:"→",Rightarrow:"⇒",RightArrowLeftArrow:"⇄",rightarrowtail:"↣",RightCeiling:"⌉",RightDoubleBracket:"⟧",RightDownTeeVector:"⥝",RightDownVectorBar:"⥕",RightDownVector:"⇂",RightFloor:"⌋",rightharpoondown:"⇁",rightharpoonup:"⇀",rightleftarrows:"⇄",rightleftharpoons:"⇌",rightrightarrows:"⇉",rightsquigarrow:"↝",RightTeeArrow:"↦",RightTee:"⊢",RightTeeVector:"⥛",rightthreetimes:"⋌",RightTriangleBar:"⧐",RightTriangle:"⊳",RightTriangleEqual:"⊵",RightUpDownVector:"⥏",RightUpTeeVector:"⥜",RightUpVectorBar:"⥔",RightUpVector:"↾",RightVectorBar:"⥓",RightVector:"⇀",ring:"˚",risingdotseq:"≓",rlarr:"⇄",rlhar:"⇌",rlm:"‏",rmoustache:"⎱",rmoust:"⎱",rnmid:"⫮",roang:"⟭",roarr:"⇾",robrk:"⟧",ropar:"⦆",ropf:"𝕣",Ropf:"ℝ",roplus:"⨮",rotimes:"⨵",RoundImplies:"⥰",rpar:")",rpargt:"⦔",rppolint:"⨒",rrarr:"⇉",Rrightarrow:"⇛",rsaquo:"›",rscr:"𝓇",Rscr:"ℛ",rsh:"↱",Rsh:"↱",rsqb:"]",rsquo:"’",rsquor:"’",rthree:"⋌",rtimes:"⋊",rtri:"▹",rtrie:"⊵",rtrif:"▸",rtriltri:"⧎",RuleDelayed:"⧴",ruluhar:"⥨",rx:"℞",Sacute:"Ś",sacute:"ś",sbquo:"‚",scap:"⪸",Scaron:"Š",scaron:"š",Sc:"⪼",sc:"≻",sccue:"≽",sce:"⪰",scE:"⪴",Scedil:"Ş",scedil:"ş",Scirc:"Ŝ",scirc:"ŝ",scnap:"⪺",scnE:"⪶",scnsim:"⋩",scpolint:"⨓",scsim:"≿",Scy:"С",scy:"с",sdotb:"⊡",sdot:"⋅",sdote:"⩦",searhk:"⤥",searr:"↘",seArr:"⇘",searrow:"↘",sect:"§",semi:";",seswar:"⤩",setminus:"∖",setmn:"∖",sext:"✶",Sfr:"𝔖",sfr:"𝔰",sfrown:"⌢",sharp:"♯",SHCHcy:"Щ",shchcy:"щ",SHcy:"Ш",shcy:"ш",ShortDownArrow:"↓",ShortLeftArrow:"←",shortmid:"∣",shortparallel:"∥",ShortRightArrow:"→",ShortUpArrow:"↑",shy:"­",Sigma:"Σ",sigma:"σ",sigmaf:"ς",sigmav:"ς",sim:"∼",simdot:"⩪",sime:"≃",simeq:"≃",simg:"⪞",simgE:"⪠",siml:"⪝",simlE:"⪟",simne:"≆",simplus:"⨤",simrarr:"⥲",slarr:"←",SmallCircle:"∘",smallsetminus:"∖",smashp:"⨳",smeparsl:"⧤",smid:"∣",smile:"⌣",smt:"⪪",smte:"⪬",smtes:"⪬︀",SOFTcy:"Ь",softcy:"ь",solbar:"⌿",solb:"⧄",sol:"/",Sopf:"𝕊",sopf:"𝕤",spades:"♠",spadesuit:"♠",spar:"∥",sqcap:"⊓",sqcaps:"⊓︀",sqcup:"⊔",sqcups:"⊔︀",Sqrt:"√",sqsub:"⊏",sqsube:"⊑",sqsubset:"⊏",sqsubseteq:"⊑",sqsup:"⊐",sqsupe:"⊒",sqsupset:"⊐",sqsupseteq:"⊒",square:"□",Square:"□",SquareIntersection:"⊓",SquareSubset:"⊏",SquareSubsetEqual:"⊑",SquareSuperset:"⊐",SquareSupersetEqual:"⊒",SquareUnion:"⊔",squarf:"▪",squ:"□",squf:"▪",srarr:"→",Sscr:"𝒮",sscr:"𝓈",ssetmn:"∖",ssmile:"⌣",sstarf:"⋆",Star:"⋆",star:"☆",starf:"★",straightepsilon:"ϵ",straightphi:"ϕ",strns:"¯",sub:"⊂",Sub:"⋐",subdot:"⪽",subE:"⫅",sube:"⊆",subedot:"⫃",submult:"⫁",subnE:"⫋",subne:"⊊",subplus:"⪿",subrarr:"⥹",subset:"⊂",Subset:"⋐",subseteq:"⊆",subseteqq:"⫅",SubsetEqual:"⊆",subsetneq:"⊊",subsetneqq:"⫋",subsim:"⫇",subsub:"⫕",subsup:"⫓",succapprox:"⪸",succ:"≻",succcurlyeq:"≽",Succeeds:"≻",SucceedsEqual:"⪰",SucceedsSlantEqual:"≽",SucceedsTilde:"≿",succeq:"⪰",succnapprox:"⪺",succneqq:"⪶",succnsim:"⋩",succsim:"≿",SuchThat:"∋",sum:"∑",Sum:"∑",sung:"♪",sup1:"¹",sup2:"²",sup3:"³",sup:"⊃",Sup:"⋑",supdot:"⪾",supdsub:"⫘",supE:"⫆",supe:"⊇",supedot:"⫄",Superset:"⊃",SupersetEqual:"⊇",suphsol:"⟉",suphsub:"⫗",suplarr:"⥻",supmult:"⫂",supnE:"⫌",supne:"⊋",supplus:"⫀",supset:"⊃",Supset:"⋑",supseteq:"⊇",supseteqq:"⫆",supsetneq:"⊋",supsetneqq:"⫌",supsim:"⫈",supsub:"⫔",supsup:"⫖",swarhk:"⤦",swarr:"↙",swArr:"⇙",swarrow:"↙",swnwar:"⤪",szlig:"ß",Tab:"\t",target:"⌖",Tau:"Τ",tau:"τ",tbrk:"⎴",Tcaron:"Ť",tcaron:"ť",Tcedil:"Ţ",tcedil:"ţ",Tcy:"Т",tcy:"т",tdot:"⃛",telrec:"⌕",Tfr:"𝔗",tfr:"𝔱",there4:"∴",therefore:"∴",Therefore:"∴",Theta:"Θ",theta:"θ",thetasym:"ϑ",thetav:"ϑ",thickapprox:"≈",thicksim:"∼",ThickSpace:"  ",ThinSpace:" ",thinsp:" ",thkap:"≈",thksim:"∼",THORN:"Þ",thorn:"þ",tilde:"˜",Tilde:"∼",TildeEqual:"≃",TildeFullEqual:"≅",TildeTilde:"≈",timesbar:"⨱",timesb:"⊠",times:"×",timesd:"⨰",tint:"∭",toea:"⤨",topbot:"⌶",topcir:"⫱",top:"⊤",Topf:"𝕋",topf:"𝕥",topfork:"⫚",tosa:"⤩",tprime:"‴",trade:"™",TRADE:"™",triangle:"▵",triangledown:"▿",triangleleft:"◃",trianglelefteq:"⊴",triangleq:"≜",triangleright:"▹",trianglerighteq:"⊵",tridot:"◬",trie:"≜",triminus:"⨺",TripleDot:"⃛",triplus:"⨹",trisb:"⧍",tritime:"⨻",trpezium:"⏢",Tscr:"𝒯",tscr:"𝓉",TScy:"Ц",tscy:"ц",TSHcy:"Ћ",tshcy:"ћ",Tstrok:"Ŧ",tstrok:"ŧ",twixt:"≬",twoheadleftarrow:"↞",twoheadrightarrow:"↠",Uacute:"Ú",uacute:"ú",uarr:"↑",Uarr:"↟",uArr:"⇑",Uarrocir:"⥉",Ubrcy:"Ў",ubrcy:"ў",Ubreve:"Ŭ",ubreve:"ŭ",Ucirc:"Û",ucirc:"û",Ucy:"У",ucy:"у",udarr:"⇅",Udblac:"Ű",udblac:"ű",udhar:"⥮",ufisht:"⥾",Ufr:"𝔘",ufr:"𝔲",Ugrave:"Ù",ugrave:"ù",uHar:"⥣",uharl:"↿",uharr:"↾",uhblk:"▀",ulcorn:"⌜",ulcorner:"⌜",ulcrop:"⌏",ultri:"◸",Umacr:"Ū",umacr:"ū",uml:"¨",UnderBar:"_",UnderBrace:"⏟",UnderBracket:"⎵",UnderParenthesis:"⏝",Union:"⋃",UnionPlus:"⊎",Uogon:"Ų",uogon:"ų",Uopf:"𝕌",uopf:"𝕦",UpArrowBar:"⤒",uparrow:"↑",UpArrow:"↑",Uparrow:"⇑",UpArrowDownArrow:"⇅",updownarrow:"↕",UpDownArrow:"↕",Updownarrow:"⇕",UpEquilibrium:"⥮",upharpoonleft:"↿",upharpoonright:"↾",uplus:"⊎",UpperLeftArrow:"↖",UpperRightArrow:"↗",upsi:"υ",Upsi:"ϒ",upsih:"ϒ",Upsilon:"Υ",upsilon:"υ",UpTeeArrow:"↥",UpTee:"⊥",upuparrows:"⇈",urcorn:"⌝",urcorner:"⌝",urcrop:"⌎",Uring:"Ů",uring:"ů",urtri:"◹",Uscr:"𝒰",uscr:"𝓊",utdot:"⋰",Utilde:"Ũ",utilde:"ũ",utri:"▵",utrif:"▴",uuarr:"⇈",Uuml:"Ü",uuml:"ü",uwangle:"⦧",vangrt:"⦜",varepsilon:"ϵ",varkappa:"ϰ",varnothing:"∅",varphi:"ϕ",varpi:"ϖ",varpropto:"∝",varr:"↕",vArr:"⇕",varrho:"ϱ",varsigma:"ς",varsubsetneq:"⊊︀",varsubsetneqq:"⫋︀",varsupsetneq:"⊋︀",varsupsetneqq:"⫌︀",vartheta:"ϑ",vartriangleleft:"⊲",vartriangleright:"⊳",vBar:"⫨",Vbar:"⫫",vBarv:"⫩",Vcy:"В",vcy:"в",vdash:"⊢",vDash:"⊨",Vdash:"⊩",VDash:"⊫",Vdashl:"⫦",veebar:"⊻",vee:"∨",Vee:"⋁",veeeq:"≚",vellip:"⋮",verbar:"|",Verbar:"‖",vert:"|",Vert:"‖",VerticalBar:"∣",VerticalLine:"|",VerticalSeparator:"❘",VerticalTilde:"≀",VeryThinSpace:" ",Vfr:"𝔙",vfr:"𝔳",vltri:"⊲",vnsub:"⊂⃒",vnsup:"⊃⃒",Vopf:"𝕍",vopf:"𝕧",vprop:"∝",vrtri:"⊳",Vscr:"𝒱",vscr:"𝓋",vsubnE:"⫋︀",vsubne:"⊊︀",vsupnE:"⫌︀",vsupne:"⊋︀",Vvdash:"⊪",vzigzag:"⦚",Wcirc:"Ŵ",wcirc:"ŵ",wedbar:"⩟",wedge:"∧",Wedge:"⋀",wedgeq:"≙",weierp:"℘",Wfr:"𝔚",wfr:"𝔴",Wopf:"𝕎",wopf:"𝕨",wp:"℘",wr:"≀",wreath:"≀",Wscr:"𝒲",wscr:"𝓌",xcap:"⋂",xcirc:"◯",xcup:"⋃",xdtri:"▽",Xfr:"𝔛",xfr:"𝔵",xharr:"⟷",xhArr:"⟺",Xi:"Ξ",xi:"ξ",xlarr:"⟵",xlArr:"⟸",xmap:"⟼",xnis:"⋻",xodot:"⨀",Xopf:"𝕏",xopf:"𝕩",xoplus:"⨁",xotime:"⨂",xrarr:"⟶",xrArr:"⟹",Xscr:"𝒳",xscr:"𝓍",xsqcup:"⨆",xuplus:"⨄",xutri:"△",xvee:"⋁",xwedge:"⋀",Yacute:"Ý",yacute:"ý",YAcy:"Я",yacy:"я",Ycirc:"Ŷ",ycirc:"ŷ",Ycy:"Ы",ycy:"ы",yen:"¥",Yfr:"𝔜",yfr:"𝔶",YIcy:"Ї",yicy:"ї",Yopf:"𝕐",yopf:"𝕪",Yscr:"𝒴",yscr:"𝓎",YUcy:"Ю",yucy:"ю",yuml:"ÿ",Yuml:"Ÿ",Zacute:"Ź",zacute:"ź",Zcaron:"Ž",zcaron:"ž",Zcy:"З",zcy:"з",Zdot:"Ż",zdot:"ż",zeetrf:"ℨ",ZeroWidthSpace:"​",Zeta:"Ζ",zeta:"ζ",zfr:"𝔷",Zfr:"ℨ",ZHcy:"Ж",zhcy:"ж",zigrarr:"⇝",zopf:"𝕫",Zopf:"ℤ",Zscr:"𝒵",zscr:"𝓏",zwj:"‍",zwnj:"‌"}},{}],23:[function(t,e,r){e.exports={Aacute:"Á",aacute:"á",Acirc:"Â",acirc:"â",acute:"´",AElig:"Æ",aelig:"æ",Agrave:"À",agrave:"à",amp:"&",AMP:"&",Aring:"Å",aring:"å",Atilde:"Ã",atilde:"ã",Auml:"Ä",auml:"ä",brvbar:"¦",Ccedil:"Ç",ccedil:"ç",cedil:"¸",cent:"¢",copy:"©",COPY:"©",curren:"¤",deg:"°",divide:"÷",Eacute:"É",eacute:"é",Ecirc:"Ê",ecirc:"ê",Egrave:"È",egrave:"è",ETH:"Ð",eth:"ð",Euml:"Ë",euml:"ë",frac12:"½",frac14:"¼",frac34:"¾",gt:">",GT:">",Iacute:"Í",iacute:"í",Icirc:"Î",icirc:"î",iexcl:"¡",Igrave:"Ì",igrave:"ì",iquest:"¿",Iuml:"Ï",iuml:"ï",laquo:"«",lt:"<",LT:"<",macr:"¯",micro:"µ",middot:"·",nbsp:" ",not:"¬",Ntilde:"Ñ",ntilde:"ñ",Oacute:"Ó",oacute:"ó",Ocirc:"Ô",ocirc:"ô",Ograve:"Ò",ograve:"ò",ordf:"ª",ordm:"º",Oslash:"Ø",oslash:"ø",Otilde:"Õ",otilde:"õ",Ouml:"Ö",ouml:"ö",para:"¶",plusmn:"±",pound:"£",quot:'"',QUOT:'"',raquo:"»",reg:"®",REG:"®",sect:"§",shy:"­",sup1:"¹",sup2:"²",sup3:"³",szlig:"ß",THORN:"Þ",thorn:"þ",times:"×",Uacute:"Ú",uacute:"ú",Ucirc:"Û",ucirc:"û",Ugrave:"Ù",ugrave:"ù",uml:"¨",Uuml:"Ü",uuml:"ü",Yacute:"Ý",yacute:"ý",yen:"¥",yuml:"ÿ"}},{}],24:[function(t,e,r){e.exports={amp:"&",apos:"'",gt:">",lt:"<",quot:'"'}},{}],25:[function(t,e,r){var f=Object.create||function(t){var e;return(e=function e(){}).prototype=t,new e},s=Object.keys||function(t){var e,r=[];for(e in t)Object.prototype.hasOwnProperty.call(t,e)&&r.push(e);return e},n=Function.prototype.bind||function(t){var e=this;return function(){return e.apply(t,arguments)}};function i(){this._events&&Object.prototype.hasOwnProperty.call(this,"_events")||(this._events=f(null),this._eventsCount=0),this._maxListeners=this._maxListeners||undefined}((e.exports=i).EventEmitter=i).prototype._events=undefined,i.prototype._maxListeners=undefined;var o,a=10;try{var u={};Object.defineProperty&&Object.defineProperty(u,"x",{value:0}),o=0===u.x}catch(m){o=!1}function c(t){return t._maxListeners===undefined?i.defaultMaxListeners:t._maxListeners}function l(t,e,r,n){var i,o;if("function"!=typeof r)throw new TypeError('"listener" argument must be a function');return(i=t._events)?(i.newListener&&(t.emit("newListener",e,r.listener||r),i=t._events),o=i[e]):(i=t._events=f(null),t._eventsCount=0),o?("function"==typeof o?o=i[e]=n?[r,o]:[o,r]:n?o.unshift(r):o.push(r),o.warned||(n=c(t))&&0<n&&o.length>n&&(o.warned=!0,(n=new Error("Possible EventEmitter memory leak detected. "+o.length+' "'+String(e)+'" listeners added. Use emitter.setMaxListeners() to increase limit.')).name="MaxListenersExceededWarning",n.emitter=t,n.type=e,n.count=o.length,"object"===("undefined"==typeof console?"undefined":_typeof(console)))&&console.warn&&console.warn("%s: %s",n.name,n.message)):(o=i[e]=r,++t._eventsCount),t}function h(){if(!this.fired)switch(this.target.removeListener(this.type,this.wrapFn),this.fired=!0,arguments.length){case 0:return this.listener.call(this.target);case 1:return this.listener.call(this.target,arguments[0]);case 2:return this.listener.call(this.target,arguments[0],arguments[1]);case 3:return this.listener.call(this.target,arguments[0],arguments[1],arguments[2]);default:for(var t=new Array(arguments.length),e=0;e<t.length;++e)t[e]=arguments[e];this.listener.apply(this.target,t)}}function p(t,e,r){t={fired:!1,wrapFn:undefined,target:t,type:e,listener:r},e=n.call(h,t);return e.listener=r,t.wrapFn=e}function d(t,e,r){t=t._events;if(!t)return[];e=t[e];if(!e)return[];if("function"==typeof e)return r?[e.listener||e]:[e];if(r){for(var n=e,i=new Array(n.length),o=0;o<i.length;++o)i[o]=n[o].listener||n[o];return i}return F(e,e.length)}function g(t){var e=this._events;if(e){t=e[t];if("function"==typeof t)return 1;if(t)return t.length}return 0}function F(t,e){for(var r=new Array(e),n=0;n<e;++n)r[n]=t[n];return r}o?Object.defineProperty(i,"defaultMaxListeners",{enumerable:!0,get:function(){return a},set:function(t){if("number"!=typeof t||t<0||t!=t)throw new TypeError('"defaultMaxListeners" must be a positive number');a=t}}):i.defaultMaxListeners=a,i.prototype.setMaxListeners=function(t){if("number"!=typeof t||t<0||isNaN(t))throw new TypeError('"n" argument must be a positive number');return this._maxListeners=t,this},i.prototype.getMaxListeners=function(){return c(this)},i.prototype.emit=function(t){var e,r,n,i,o="error"===t,s=this._events;if(s)o=o&&null==s.error;else if(!o)return!1;if(o)throw(e=1<arguments.length?arguments[1]:e)instanceof Error?e:((o=new Error('Unhandled "error" event. ('+e+")")).context=e,o);if(!(r=s[t]))return!1;var a,u="function"==typeof r;switch(a=arguments.length){case 1:var c=r,l=u,f=this;if(l)c.call(f);else for(var h=c.length,R=F(c,h),p=0;p<h;++p)R[p].call(f);break;case 2:var l=r,c=u,d=this,g=arguments[1];if(c)l.call(d,g);else for(var m=l.length,P=F(l,m),y=0;y<m;++y)P[y].call(d,g);break;case 3:var _=r,b=u,v=this,w=arguments[1],x=arguments[2];if(b)_.call(v,w,x);else for(var S=_.length,I=F(_,S),A=0;A<S;++A)I[A].call(v,w,x);break;case 4:var b=r,_=u,C=this,O=arguments[1],E=arguments[2],k=arguments[3];if(_)b.call(C,O,E,k);else for(var j=b.length,D=F(b,j),L=0;L<j;++L)D[L].call(C,O,E,k);break;default:for(n=new Array(a-1),i=1;i<a;i++)n[i-1]=arguments[i];var M=r,B=u,T=this,q=n;if(B)M.apply(T,q);else for(var U=M.length,z=F(M,U),N=0;N<U;++N)z[N].apply(T,q)}return!0},i.prototype.on=i.prototype.addListener=function(t,e){return l(this,t,e,!1)},i.prototype.prependListener=function(t,e){return l(this,t,e,!0)},i.prototype.once=function(t,e){if("function"!=typeof e)throw new TypeError('"listener" argument must be a function');return this.on(t,p(this,t,e)),this},i.prototype.prependOnceListener=function(t,e){if("function"!=typeof e)throw new TypeError('"listener" argument must be a function');return this.prependListener(t,p(this,t,e)),this},i.prototype.removeListener=function(t,e){var r,n,i,o,s;if("function"!=typeof e)throw new TypeError('"listener" argument must be a function');if((n=this._events)&&(r=n[t]))if(r===e||r.listener===e)0==--this._eventsCount?this._events=f(null):(delete n[t],n.removeListener&&this.emit("removeListener",t,r.listener||e));else if("function"!=typeof r){for(i=-1,o=r.length-1;0<=o;o--)if(r[o]===e||r[o].listener===e){s=r[o].listener,i=o;break}if(i<0)return this;if(0===i)r.shift();else{for(var a=r,u=i,c=u+1,l=a.length;c<l;u+=1,c+=1)a[u]=a[c];a.pop()}1===r.length&&(n[t]=r[0]),n.removeListener&&this.emit("removeListener",t,s||e)}return this},i.prototype.removeAllListeners=function(t){var e,r=this._events;if(r)if(r.removeListener){if(0===arguments.length){for(var n,i=s(r),o=0;o<i.length;++o)"removeListener"!==(n=i[o])&&this.removeAllListeners(n);this.removeAllListeners("removeListener"),this._events=f(null),this._eventsCount=0}else if("function"==typeof(e=r[t]))this.removeListener(t,e);else if(e)for(o=e.length-1;0<=o;o--)this.removeListener(t,e[o])}else 0===arguments.length?(this._events=f(null),this._eventsCount=0):r[t]&&(0==--this._eventsCount?this._events=f(null):delete r[t]);return this},i.prototype.listeners=function(t){return d(this,t,!0)},i.prototype.rawListeners=function(t){return d(this,t,!1)},i.listenerCount=function(t,e){return"function"==typeof t.listenerCount?t.listenerCount(e):g.call(t,e)},i.prototype.listenerCount=g,i.prototype.eventNames=function(){return 0<this._eventsCount?Reflect.ownKeys(this._events):[]}},{}],26:[function(t,e,r){var n,o,i=this&&this.__extends||(n=function(t,e){return(n=Object.setPrototypeOf||({__proto__:[]}instanceof Array?function(t,e){t.__proto__=e}:function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])}))(t,e)},function(t,e){function r(){this.constructor=t}n(t,e),t.prototype=null===e?Object.create(e):(r.prototype=e.prototype,new r)}),s=this&&this.__importDefault||function(t){return t&&t.__esModule?t:{"default":t}},t=(Object.defineProperty(r,"__esModule",{value:!0}),s(t("./MultiplexHandler"))),s=(o=t["default"],i(a,o),a.prototype.onreset=function(){this.events=[],this._cbs.onreset&&this._cbs.onreset()},a.prototype.restart=function(){var t;this._cbs.onreset&&this._cbs.onreset();for(var e=0;e<this.events.length;e++){var r=this.events[e],n=r[0],r=r.slice(1);this._cbs[n]&&(t=this._cbs)[n].apply(t,r)}},a);function a(t){void 0===t&&(t={});var i=o.call(this,function(t){for(var e,r=[],n=1;n<arguments.length;n++)r[n-1]=arguments[n];i.events.push([t].concat(r)),i._cbs[t]&&(e=i._cbs)[t].apply(e,r)})||this;return i._cbs=t,i.events=[],i}r.CollectingHandler=s},{"./MultiplexHandler":28}],27:[function(t,e,r){var n,i,o=this&&this.__extends||(n=function(t,e){return(n=Object.setPrototypeOf||({__proto__:[]}instanceof Array?function(t,e){t.__proto__=e}:function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])}))(t,e)},function(t,e){function r(){this.constructor=t}n(t,e),t.prototype=null===e?Object.create(e):(r.prototype=e.prototype,new r)}),s=this&&this.__importDefault||function(t){return t&&t.__esModule?t:{"default":t}},a=this&&this.__importStar||function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e["default"]=t,e},s=(Object.defineProperty(r,"__esModule",{value:!0}),s(t("domhandler"))),u=a(t("domutils")),c=t("./Parser"),l=(i=s["default"],o(f,i),f.prototype.onend=function(){var t,e,r={},n=p(y,this.dom);n&&("feed"===n.name?(t=n.children,r.type="atom",m(r,"id","id",t),m(r,"title","title",t),(e=g("href",p("link",t)))&&(r.link=e),m(r,"description","subtitle",t),(e=d("updated",t))&&(r.updated=new Date(e)),m(r,"author","email",t,!0),r.items=h("entry",t).map(function(t){var e={},t=t.children,r=(m(e,"id","id",t),m(e,"title","title",t),g("href",p("link",t))),r=(r&&(e.link=r),d("summary",t)||d("content",t)),r=(r&&(e.description=r),d("updated",t));return r&&(e.pubDate=new Date(r)),e})):(t=p("channel",n.children).children,r.type=n.name.substr(0,3),r.id="",m(r,"title","title",t),m(r,"link","link",t),m(r,"description","description",t),(e=d("lastBuildDate",t))&&(r.updated=new Date(e)),m(r,"author","managingEditor",t,!0),r.items=h("item",n.children).map(function(t){var e={},t=t.children,t=(m(e,"id","guid",t),m(e,"title","title",t),m(e,"link","link",t),m(e,"description","description",t),d("pubDate",t));return t&&(e.pubDate=new Date(t)),e}))),this.feed=r,this.handleCallback(n?null:Error("couldn't find root of feed"))},f);function f(t,e){return"object"===_typeof(t)&&null!==t&&(e=t=undefined),i.call(this,t,e)||this}function h(t,e){return u.getElementsByTagName(t,e,!0)}function p(t,e){return u.getElementsByTagName(t,e,!0,1)[0]}function d(t,e,r){return u.getText(u.getElementsByTagName(t,e,r=void 0===r?!1:r,1)).trim()}function g(t,e){return e?e.attribs[t]:null}function m(t,e,r,n,i){r=d(r,n,i=void 0===i?!1:i);r&&(t[e]=r)}function y(t){return"rss"===t||"feed"===t||"rdf:RDF"===t}r.FeedHandler=l;var _={xmlMode:!0};r.parseFeed=function(t,e){var r=new l(e=void 0===e?_:e);return new c.Parser(r,e).end(t),r.feed}},{"./Parser":29,domhandler:7,domutils:10}],28:[function(t,e,r){function n(t){this._func=t}Object.defineProperty(r,"__esModule",{value:!0}),n.prototype.onattribute=function(t,e){this._func("onattribute",t,e)},n.prototype.oncdatastart=function(){this._func("oncdatastart")},n.prototype.oncdataend=function(){this._func("oncdataend")},n.prototype.ontext=function(t){this._func("ontext",t)},n.prototype.onprocessinginstruction=function(t,e){this._func("onprocessinginstruction",t,e)},n.prototype.oncomment=function(t){this._func("oncomment",t)},n.prototype.oncommentend=function(){this._func("oncommentend")},n.prototype.onclosetag=function(t){this._func("onclosetag",t)},n.prototype.onopentag=function(t,e){this._func("onopentag",t,e)},n.prototype.onopentagname=function(t){this._func("onopentagname",t)},n.prototype.onerror=function(t){this._func("onerror",t)},n.prototype.onend=function(){this._func("onend")},n.prototype.onparserinit=function(t){this._func("onparserinit",t)},n.prototype.onreset=function(){this._func("onreset")},r["default"]=n},{}],29:[function(t,e,r){var n,i,o=this&&this.__extends||(n=function(t,e){return(n=Object.setPrototypeOf||({__proto__:[]}instanceof Array?function(t,e){t.__proto__=e}:function(t,e){for(var r in e)e.hasOwnProperty(r)&&(t[r]=e[r])}))(t,e)},function(t,e){function r(){this.constructor=t}n(t,e),t.prototype=null===e?Object.create(e):(r.prototype=e.prototype,new r)}),s=this&&this.__importDefault||function(t){return t&&t.__esModule?t:{"default":t}},a=(Object.defineProperty(r,"__esModule",{value:!0}),s(t("./Tokenizer"))),s=t("events"),t=new Set(["input","option","optgroup","select","button","datalist","textarea"]),u=new Set(["p"]),c={tr:new Set(["tr","th","td"]),th:new Set(["th"]),td:new Set(["thead","th","td"]),body:new Set(["head","link","script"]),li:new Set(["li"]),p:u,h1:u,h2:u,h3:u,h4:u,h5:u,h6:u,select:t,input:t,output:t,button:t,datalist:t,textarea:t,option:new Set(["option"]),optgroup:new Set(["optgroup","option"]),dd:new Set(["dt","dd"]),dt:new Set(["dt","dd"]),address:u,article:u,aside:u,blockquote:u,details:u,div:u,dl:u,fieldset:u,figcaption:u,figure:u,footer:u,form:u,header:u,hr:u,main:u,nav:u,ol:u,pre:u,section:u,table:u,ul:u,rt:new Set(["rt","rp"]),rp:new Set(["rt","rp"]),tbody:new Set(["thead","tbody"]),tfoot:new Set(["thead","tbody"])},l=new Set(["area","base","basefont","br","col","command","embed","frame","hr","img","input","isindex","keygen","link","meta","param","source","track","wbr"]),f=new Set(["math","svg"]),h=new Set(["mi","mo","mn","ms","mtext","annotation-xml","foreignObject","desc","title"]),p=/\s|\//,t=(i=s.EventEmitter,o(d,i),d.prototype._updatePosition=function(t){null===this.endIndex?this._tokenizer._sectionStart<=t?this.startIndex=0:this.startIndex=this._tokenizer._sectionStart-t:this.startIndex=this.endIndex+1,this.endIndex=this._tokenizer.getAbsoluteIndex()},d.prototype.ontext=function(t){this._updatePosition(1),this.endIndex--,this._cbs.ontext&&this._cbs.ontext(t)},d.prototype.onopentagname=function(t){if(this._lowerCaseTagNames&&(t=t.toLowerCase()),this._tagname=t,!this._options.xmlMode&&Object.prototype.hasOwnProperty.call(c,t))for(var e;c[t].has(e=this._stack[this._stack.length-1]);this.onclosetag(e));!this._options.xmlMode&&l.has(t)||(this._stack.push(t),f.has(t)?this._foreignContext.push(!0):h.has(t)&&this._foreignContext.push(!1)),this._cbs.onopentagname&&this._cbs.onopentagname(t),this._cbs.onopentag&&(this._attribs={})},d.prototype.onopentagend=function(){this._updatePosition(1),this._attribs&&(this._cbs.onopentag&&this._cbs.onopentag(this._tagname,this._attribs),this._attribs=null),!this._options.xmlMode&&this._cbs.onclosetag&&l.has(this._tagname)&&this._cbs.onclosetag(this._tagname),this._tagname=""},d.prototype.onclosetag=function(t){if(this._updatePosition(1),this._lowerCaseTagNames&&(t=t.toLowerCase()),(f.has(t)||h.has(t))&&this._foreignContext.pop(),!this._stack.length||!this._options.xmlMode&&l.has(t))this._options.xmlMode||"br"!==t&&"p"!==t||(this.onopentagname(t),this._closeCurrentTag());else{var e=this._stack.lastIndexOf(t);if(-1!==e)if(this._cbs.onclosetag)for(e=this._stack.length-e;e--;)this._cbs.onclosetag(this._stack.pop());else this._stack.length=e;else"p"!==t||this._options.xmlMode||(this.onopentagname(t),this._closeCurrentTag())}},d.prototype.onselfclosingtag=function(){this._options.xmlMode||this._options.recognizeSelfClosing||this._foreignContext[this._foreignContext.length-1]?this._closeCurrentTag():this.onopentagend()},d.prototype._closeCurrentTag=function(){var t=this._tagname;this.onopentagend(),this._stack[this._stack.length-1]===t&&(this._cbs.onclosetag&&this._cbs.onclosetag(t),this._stack.pop())},d.prototype.onattribname=function(t){this._lowerCaseAttributeNames&&(t=t.toLowerCase()),this._attribname=t},d.prototype.onattribdata=function(t){this._attribvalue+=t},d.prototype.onattribend=function(){this._cbs.onattribute&&this._cbs.onattribute(this._attribname,this._attribvalue),this._attribs&&!Object.prototype.hasOwnProperty.call(this._attribs,this._attribname)&&(this._attribs[this._attribname]=this._attribvalue),this._attribname="",this._attribvalue=""},d.prototype._getInstructionName=function(t){var e=t.search(p),e=e<0?t:t.substr(0,e);return e=this._lowerCaseTagNames?e.toLowerCase():e},d.prototype.ondeclaration=function(t){var e;this._cbs.onprocessinginstruction&&(e=this._getInstructionName(t),this._cbs.onprocessinginstruction("!"+e,"!"+t))},d.prototype.onprocessinginstruction=function(t){var e;this._cbs.onprocessinginstruction&&(e=this._getInstructionName(t),this._cbs.onprocessinginstruction("?"+e,"?"+t))},d.prototype.oncomment=function(t){this._updatePosition(4),this._cbs.oncomment&&this._cbs.oncomment(t),this._cbs.oncommentend&&this._cbs.oncommentend()},d.prototype.oncdata=function(t){this._updatePosition(1),this._options.xmlMode||this._options.recognizeCDATA?(this._cbs.oncdatastart&&this._cbs.oncdatastart(),this._cbs.ontext&&this._cbs.ontext(t),this._cbs.oncdataend&&this._cbs.oncdataend()):this.oncomment("[CDATA["+t+"]]")},d.prototype.onerror=function(t){this._cbs.onerror&&this._cbs.onerror(t)},d.prototype.onend=function(){if(this._cbs.onclosetag)for(var t=this._stack.length;0<t;this._cbs.onclosetag(this._stack[--t]));this._cbs.onend&&this._cbs.onend()},d.prototype.reset=function(){this._cbs.onreset&&this._cbs.onreset(),this._tokenizer.reset(),this._tagname="",this._attribname="",this._attribs=null,this._stack=[],this._cbs.onparserinit&&this._cbs.onparserinit(this)},d.prototype.parseComplete=function(t){this.reset(),this.end(t)},d.prototype.write=function(t){this._tokenizer.write(t)},d.prototype.end=function(t){this._tokenizer.end(t)},d.prototype.pause=function(){this._tokenizer.pause()},d.prototype.resume=function(){this._tokenizer.resume()},d);function d(t,e){var r=i.call(this)||this;return r._tagname="",r._attribname="",r._attribvalue="",r._attribs=null,r._stack=[],r._foreignContext=[],r.startIndex=0,r.endIndex=null,r.parseChunk=d.prototype.write,r.done=d.prototype.end,r._options=e||{},r._cbs=t||{},r._tagname="",r._attribname="",r._attribvalue="",r._attribs=null,r._stack=[],r._foreignContext=[],r.startIndex=0,r.endIndex=null,r._lowerCaseTagNames="lowerCaseTags"in r._options?!!r._options.lowerCaseTags:!r._options.xmlMode,r._lowerCaseAttributeNames="lowerCaseAttributeNames"in r._options?!!r._options.lowerCaseAttributeNames:!r._options.xmlMode,r._tokenizer=new(r._options.Tokenizer||a["default"])(r._options,r),r._cbs.onparserinit&&r._cbs.onparserinit(r),r}r.Parser=t},{"./Tokenizer":30,events:25}],30:[function(t,e,r){var n=this&&this.__importDefault||function(t){return t&&t.__esModule?t:{"default":t}},i=(Object.defineProperty(r,"__esModule",{value:!0}),n(t("entities/lib/decode_codepoint"))),o=n(t("entities/lib/maps/entities.json")),s=n(t("entities/lib/maps/legacy.json")),a=n(t("entities/lib/maps/xml.json"));function u(t){return" "===t||"\n"===t||"\t"===t||"\f"===t||"\r"===t}function c(r,n,i){var o=r.toLowerCase();return r===o?function(t,e){e===o?t._state=n:(t._state=i,t._index--)}:function(t,e){e===o||e===r?t._state=n:(t._state=i,t._index--)}}function l(r,n){var i=r.toLowerCase();return function(t,e){e===i||e===r?t._state=n:(t._state=3,t._index--)}}var f=c("C",23,16),h=c("D",24,16),p=c("A",25,16),d=c("T",26,16),g=c("A",27,16),m=l("R",34),y=l("I",35),_=l("P",36),b=l("T",37),v=c("R",39,1),w=c("I",40,1),x=c("P",41,1),S=c("T",42,1),A=l("Y",44),C=l("L",45),O=l("E",46),E=c("Y",48,1),k=c("L",49,1),j=c("E",50,1),L=c("#",52,53),M=c("X",55,54);function T(t,e){this._state=1,this._buffer="",this._sectionStart=0,this._index=0,this._bufferOffset=0,this._baseState=1,this._special=1,this._running=!0,this._ended=!1,this._cbs=e,this._xmlMode=!(!t||!t.xmlMode),this._decodeEntities=!(!t||!t.decodeEntities)}T.prototype.reset=function(){this._state=1,this._buffer="",this._sectionStart=0,this._index=0,this._bufferOffset=0,this._baseState=1,this._special=1,this._running=!0,this._ended=!1},T.prototype._stateText=function(t){"<"===t?(this._index>this._sectionStart&&this._cbs.ontext(this._getSection()),this._state=2,this._sectionStart=this._index):this._decodeEntities&&1===this._special&&"&"===t&&(this._index>this._sectionStart&&this._cbs.ontext(this._getSection()),this._baseState=1,this._state=51,this._sectionStart=this._index)},T.prototype._stateBeforeTagName=function(t){"/"===t?this._state=5:"<"===t?(this._cbs.ontext(this._getSection()),this._sectionStart=this._index):">"===t||1!==this._special||u(t)?this._state=1:"!"===t?(this._state=15,this._sectionStart=this._index+1):"?"===t?(this._state=17,this._sectionStart=this._index+1):(this._state=this._xmlMode||"s"!==t&&"S"!==t?3:31,this._sectionStart=this._index)},T.prototype._stateInTagName=function(t){"/"!==t&&">"!==t&&!u(t)||(this._emitToken("onopentagname"),this._state=8,this._index--)},T.prototype._stateBeforeClosingTagName=function(t){u(t)||(">"===t?this._state=1:1!==this._special?"s"===t||"S"===t?this._state=32:(this._state=1,this._index--):(this._state=6,this._sectionStart=this._index))},T.prototype._stateInClosingTagName=function(t){">"!==t&&!u(t)||(this._emitToken("onclosetag"),this._state=7,this._index--)},T.prototype._stateAfterClosingTagName=function(t){">"===t&&(this._state=1,this._sectionStart=this._index+1)},T.prototype._stateBeforeAttributeName=function(t){">"===t?(this._cbs.onopentagend(),this._state=1,this._sectionStart=this._index+1):"/"===t?this._state=4:u(t)||(this._state=9,this._sectionStart=this._index)},T.prototype._stateInSelfClosingTag=function(t){">"===t?(this._cbs.onselfclosingtag(),this._state=1,this._sectionStart=this._index+1):u(t)||(this._state=8,this._index--)},T.prototype._stateInAttributeName=function(t){"="!==t&&"/"!==t&&">"!==t&&!u(t)||(this._cbs.onattribname(this._getSection()),this._sectionStart=-1,this._state=10,this._index--)},T.prototype._stateAfterAttributeName=function(t){"="===t?this._state=11:"/"===t||">"===t?(this._cbs.onattribend(),this._state=8,this._index--):u(t)||(this._cbs.onattribend(),this._state=9,this._sectionStart=this._index)},T.prototype._stateBeforeAttributeValue=function(t){'"'===t?(this._state=12,this._sectionStart=this._index+1):"'"===t?(this._state=13,this._sectionStart=this._index+1):u(t)||(this._state=14,this._sectionStart=this._index,this._index--)},T.prototype._stateInAttributeValueDoubleQuotes=function(t){'"'===t?(this._emitToken("onattribdata"),this._cbs.onattribend(),this._state=8):this._decodeEntities&&"&"===t&&(this._emitToken("onattribdata"),this._baseState=this._state,this._state=51,this._sectionStart=this._index)},T.prototype._stateInAttributeValueSingleQuotes=function(t){"'"===t?(this._emitToken("onattribdata"),this._cbs.onattribend(),this._state=8):this._decodeEntities&&"&"===t&&(this._emitToken("onattribdata"),this._baseState=this._state,this._state=51,this._sectionStart=this._index)},T.prototype._stateInAttributeValueNoQuotes=function(t){u(t)||">"===t?(this._emitToken("onattribdata"),this._cbs.onattribend(),this._state=8,this._index--):this._decodeEntities&&"&"===t&&(this._emitToken("onattribdata"),this._baseState=this._state,this._state=51,this._sectionStart=this._index)},T.prototype._stateBeforeDeclaration=function(t){this._state="["===t?22:"-"===t?18:16},T.prototype._stateInDeclaration=function(t){">"===t&&(this._cbs.ondeclaration(this._getSection()),this._state=1,this._sectionStart=this._index+1)},T.prototype._stateInProcessingInstruction=function(t){">"===t&&(this._cbs.onprocessinginstruction(this._getSection()),this._state=1,this._sectionStart=this._index+1)},T.prototype._stateBeforeComment=function(t){"-"===t?(this._state=19,this._sectionStart=this._index+1):this._state=16},T.prototype._stateInComment=function(t){"-"===t&&(this._state=20)},T.prototype._stateAfterComment1=function(t){this._state="-"===t?21:19},T.prototype._stateAfterComment2=function(t){">"===t?(this._cbs.oncomment(this._buffer.substring(this._sectionStart,this._index-2)),this._state=1,this._sectionStart=this._index+1):"-"!==t&&(this._state=19)},T.prototype._stateBeforeCdata6=function(t){"["===t?(this._state=28,this._sectionStart=this._index+1):(this._state=16,this._index--)},T.prototype._stateInCdata=function(t){"]"===t&&(this._state=29)},T.prototype._stateAfterCdata1=function(t){this._state="]"===t?30:28},T.prototype._stateAfterCdata2=function(t){">"===t?(this._cbs.oncdata(this._buffer.substring(this._sectionStart,this._index-2)),this._state=1,this._sectionStart=this._index+1):"]"!==t&&(this._state=28)},T.prototype._stateBeforeSpecial=function(t){"c"===t||"C"===t?this._state=33:"t"===t||"T"===t?this._state=43:(this._state=3,this._index--)},T.prototype._stateBeforeSpecialEnd=function(t){2!==this._special||"c"!==t&&"C"!==t?3!==this._special||"t"!==t&&"T"!==t?this._state=1:this._state=47:this._state=38},T.prototype._stateBeforeScript5=function(t){"/"!==t&&">"!==t&&!u(t)||(this._special=2),this._state=3,this._index--},T.prototype._stateAfterScript5=function(t){">"===t||u(t)?(this._special=1,this._state=6,this._sectionStart=this._index-6,this._index--):this._state=1},T.prototype._stateBeforeStyle4=function(t){"/"!==t&&">"!==t&&!u(t)||(this._special=3),this._state=3,this._index--},T.prototype._stateAfterStyle4=function(t){">"===t||u(t)?(this._special=1,this._state=6,this._sectionStart=this._index-5,this._index--):this._state=1},T.prototype._parseNamedEntityStrict=function(){var t,e;this._sectionStart+1<this._index&&(t=this._buffer.substring(this._sectionStart+1,this._index),e=(this._xmlMode?a:o)["default"],Object.prototype.hasOwnProperty.call(e,t))&&(this._emitPartial(e[t]),this._sectionStart=this._index+1)},T.prototype._parseLegacyEntity=function(){var t=this._sectionStart+1,e=this._index-t;for(6<e&&(e=6);2<=e;){var r=this._buffer.substr(t,e);if(Object.prototype.hasOwnProperty.call(s["default"],r))return this._emitPartial(s["default"][r]),void(this._sectionStart+=e+1);e--}},T.prototype._stateInNamedEntity=function(t){";"===t?(this._parseNamedEntityStrict(),this._sectionStart+1<this._index&&!this._xmlMode&&this._parseLegacyEntity(),this._state=this._baseState):(t<"a"||"z"<t)&&(t<"A"||"Z"<t)&&(t<"0"||"9"<t)&&(this._xmlMode||this._sectionStart+1===this._index||(1!==this._baseState?"="!==t&&this._parseNamedEntityStrict():this._parseLegacyEntity()),this._state=this._baseState,this._index--)},T.prototype._decodeNumericEntity=function(t,e){var t=this._sectionStart+t;t!==this._index?(t=this._buffer.substring(t,this._index),t=parseInt(t,e),this._emitPartial(i["default"](t)),this._sectionStart=this._index):this._sectionStart--,this._state=this._baseState},T.prototype._stateInNumericEntity=function(t){";"===t?(this._decodeNumericEntity(2,10),this._sectionStart++):(t<"0"||"9"<t)&&(this._xmlMode?this._state=this._baseState:this._decodeNumericEntity(2,10),this._index--)},T.prototype._stateInHexEntity=function(t){";"===t?(this._decodeNumericEntity(3,16),this._sectionStart++):(t<"a"||"f"<t)&&(t<"A"||"F"<t)&&(t<"0"||"9"<t)&&(this._xmlMode?this._state=this._baseState:this._decodeNumericEntity(3,16),this._index--)},T.prototype._cleanup=function(){this._sectionStart<0?(this._buffer="",this._bufferOffset+=this._index,this._index=0):this._running&&(1===this._state?(this._sectionStart!==this._index&&this._cbs.ontext(this._buffer.substr(this._sectionStart)),this._buffer="",this._bufferOffset+=this._index,this._index=0):this._sectionStart===this._index?(this._buffer="",this._bufferOffset+=this._index,this._index=0):(this._buffer=this._buffer.substr(this._sectionStart),this._index-=this._sectionStart,this._bufferOffset+=this._sectionStart),this._sectionStart=0)},T.prototype.write=function(t){this._ended&&this._cbs.onerror(Error(".write() after done!")),this._buffer+=t,this._parse()},T.prototype._parse=function(){for(;this._index<this._buffer.length&&this._running;){var t=this._buffer.charAt(this._index);1===this._state?this._stateText(t):12===this._state?this._stateInAttributeValueDoubleQuotes(t):9===this._state?this._stateInAttributeName(t):19===this._state?this._stateInComment(t):8===this._state?this._stateBeforeAttributeName(t):3===this._state?this._stateInTagName(t):6===this._state?this._stateInClosingTagName(t):2===this._state?this._stateBeforeTagName(t):10===this._state?this._stateAfterAttributeName(t):13===this._state?this._stateInAttributeValueSingleQuotes(t):11===this._state?this._stateBeforeAttributeValue(t):5===this._state?this._stateBeforeClosingTagName(t):7===this._state?this._stateAfterClosingTagName(t):31===this._state?this._stateBeforeSpecial(t):20===this._state?this._stateAfterComment1(t):14===this._state?this._stateInAttributeValueNoQuotes(t):4===this._state?this._stateInSelfClosingTag(t):16===this._state?this._stateInDeclaration(t):15===this._state?this._stateBeforeDeclaration(t):21===this._state?this._stateAfterComment2(t):18===this._state?this._stateBeforeComment(t):32===this._state?this._stateBeforeSpecialEnd(t):38===this._state?v(this,t):39===this._state?w(this,t):40===this._state?x(this,t):33===this._state?m(this,t):34===this._state?y(this,t):35===this._state?_(this,t):36===this._state?b(this,t):37===this._state?this._stateBeforeScript5(t):41===this._state?S(this,t):42===this._state?this._stateAfterScript5(t):43===this._state?A(this,t):28===this._state?this._stateInCdata(t):44===this._state?C(this,t):45===this._state?O(this,t):46===this._state?this._stateBeforeStyle4(t):47===this._state?E(this,t):48===this._state?k(this,t):49===this._state?j(this,t):50===this._state?this._stateAfterStyle4(t):17===this._state?this._stateInProcessingInstruction(t):53===this._state?this._stateInNamedEntity(t):22===this._state?f(this,t):51===this._state?L(this,t):23===this._state?h(this,t):24===this._state?p(this,t):29===this._state?this._stateAfterCdata1(t):30===this._state?this._stateAfterCdata2(t):25===this._state?d(this,t):26===this._state?g(this,t):27===this._state?this._stateBeforeCdata6(t):55===this._state?this._stateInHexEntity(t):54===this._state?this._stateInNumericEntity(t):52===this._state?M(this,t):this._cbs.onerror(Error("unknown _state"),this._state),this._index++}this._cleanup()},T.prototype.pause=function(){this._running=!1},T.prototype.resume=function(){this._running=!0,this._index<this._buffer.length&&this._parse(),this._ended&&this._finish()},T.prototype.end=function(t){this._ended&&this._cbs.onerror(Error(".end() after done!")),t&&this.write(t),this._ended=!0,this._running&&this._finish()},T.prototype._finish=function(){this._sectionStart<this._index&&this._handleTrailingData(),this._cbs.onend()},T.prototype._handleTrailingData=function(){var t=this._buffer.substr(this._sectionStart);28===this._state||29===this._state||30===this._state?this._cbs.oncdata(t):19===this._state||20===this._state||21===this._state?this._cbs.oncomment(t):53!==this._state||this._xmlMode?54!==this._state||this._xmlMode?55!==this._state||this._xmlMode?3!==this._state&&8!==this._state&&11!==this._state&&10!==this._state&&9!==this._state&&13!==this._state&&12!==this._state&&14!==this._state&&6!==this._state&&this._cbs.ontext(t):(this._decodeNumericEntity(3,16),this._sectionStart<this._index&&(this._state=this._baseState,this._handleTrailingData())):(this._decodeNumericEntity(2,10),this._sectionStart<this._index&&(this._state=this._baseState,this._handleTrailingData())):(this._parseLegacyEntity(),this._sectionStart<this._index&&(this._state=this._baseState,this._handleTrailingData()))},T.prototype.getAbsoluteIndex=function(){return this._bufferOffset+this._index},T.prototype._getSection=function(){return this._buffer.substring(this._sectionStart,this._index)},T.prototype._emitToken=function(t){this._cbs[t](this._getSection()),this._sectionStart=-1},T.prototype._emitPartial=function(t){1!==this._baseState?this._cbs.onattribdata(t):this._cbs.ontext(t)},r["default"]=T},{"entities/lib/decode_codepoint":18,"entities/lib/maps/entities.json":22,"entities/lib/maps/legacy.json":23,"entities/lib/maps/xml.json":24}],31:[function(t,e,r){function n(t){for(var e in t)r.hasOwnProperty(e)||(r[e]=t[e])}var i=this&&this.__importStar||function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e["default"]=t,e},o=(Object.defineProperty(r,"__esModule",{value:!0}),t("./Parser")),s=(r.Parser=o.Parser,t("domhandler"));r.DomHandler=s.DomHandler,r.DefaultHandler=s.DomHandler,r.parseDOM=function(t,e){var r=new s.DomHandler(void 0,e);return new o.Parser(r,e).end(t),r.dom},r.createDomStream=function(t,e,r){return t=new s.DomHandler(t,e,r),new o.Parser(t,e)};var a=t("./Tokenizer"),a=(r.Tokenizer=a["default"],i(t("domelementtype"))),a=(r.ElementType=a,r.EVENTS={attribute:2,cdatastart:0,cdataend:0,text:1,processinginstruction:2,comment:1,commentend:0,closetag:1,opentag:2,opentagname:1,error:1,end:0},n(t("./FeedHandler")),n(t("./WritableStream")),n(t("./CollectingHandler")),i(t("domutils"))),i=(r.DomUtils=a,t("./FeedHandler"));r.RssHandler=i.FeedHandler},{"./CollectingHandler":26,"./FeedHandler":27,"./Parser":29,"./Tokenizer":30,"./WritableStream":2,domelementtype:6,domhandler:7,domutils:10}],32:[function(t,e,r){r.read=function(t,e,r,n,i){var o,s,a=8*i-n-1,u=(1<<a)-1,c=u>>1,l=-7,f=r?i-1:0,h=r?-1:1,i=t[e+f];for(f+=h,o=i&(1<<-l)-1,i>>=-l,l+=a;0<l;o=256*o+t[e+f],f+=h,l-=8);for(s=o&(1<<-l)-1,o>>=-l,l+=n;0<l;s=256*s+t[e+f],f+=h,l-=8);if(0===o)o=1-c;else{if(o===u)return s?NaN:(i?-1:1)*Infinity;s+=Math.pow(2,n),o-=c}return(i?-1:1)*s*Math.pow(2,o-n)},r.write=function(t,e,r,n,i,o){var s,a,u=8*o-i-1,c=(1<<u)-1,l=c>>1,f=23===i?Math.pow(2,-24)-Math.pow(2,-77):0,h=n?0:o-1,p=n?1:-1,o=e<0||0===e&&1/e<0?1:0;for(e=Math.abs(e),isNaN(e)||e===Infinity?(a=isNaN(e)?1:0,s=c):(s=Math.floor(Math.log(e)/Math.LN2),e*(n=Math.pow(2,-s))<1&&(s--,n*=2),2<=(e+=1<=s+l?f/n:f*Math.pow(2,1-l))*n&&(s++,n/=2),c<=s+l?(a=0,s=c):1<=s+l?(a=(e*n-1)*Math.pow(2,i),s+=l):(a=e*Math.pow(2,l-1)*Math.pow(2,i),s=0));8<=i;t[r+h]=255&a,h+=p,a/=256,i-=8);for(s=s<<i|a,u+=i;0<u;t[r+h]=255&s,h+=p,s/=256,u-=8);t[r+h-p]|=128*o}},{}],33:[function(t,Rt,Pt){!function(t){var n="__lodash_hash_undefined__",w=9007199254740991,x="[object Arguments]",I="[object Boolean]",D="[object Date]",S="[object Function]",B="[object GeneratorFunction]",A="[object Map]",U="[object Number]",C="[object Object]",z="[object Promise]",F="[object RegExp]",O="[object Set]",V="[object String]",H="[object Symbol]",r="[object WeakMap]",G="[object ArrayBuffer]",E="[object DataView]",$="[object Float32Array]",W="[object Float64Array]",J="[object Int8Array]",Y="[object Int16Array]",X="[object Int32Array]",Z="[object Uint8Array]",Q="[object Uint8ClampedArray]",K="[object Uint16Array]",tt="[object Uint32Array]",et=/\w*$/,rt=/^\[object .+?Constructor\]$/,nt=/^(?:0|[1-9]\d*)$/,k={},t=(k[x]=k["[object Array]"]=k[G]=k[E]=k[I]=k[D]=k[$]=k[W]=k[J]=k[Y]=k[X]=k[A]=k[U]=k[C]=k[F]=k[O]=k[V]=k[H]=k[Z]=k[Q]=k[K]=k[tt]=!0,k["[object Error]"]=k[S]=k[r]=!1,"object"==_typeof(t)&&t&&t.Object===Object&&t),e="object"==("undefined"==typeof self?"undefined":_typeof(self))&&self&&self.Object===Object&&self,t=t||e||Function("return this")(),e="object"==_typeof(Pt)&&Pt&&!Pt.nodeType&&Pt,i=e&&"object"==_typeof(Rt)&&Rt&&!Rt.nodeType&&Rt,i=i&&i.exports===e;function it(t,e){return t.set(e[0],e[1]),t}function ot(t,e){return t.add(e),t}function st(t,e,r,n){var i=-1,o=t?t.length:0;for(n&&o&&(r=t[++i]);++i<o;)r=e(r,t[i],i,t);return r}function at(t){var e=!1;if(null!=t&&"function"!=typeof t.toString)try{e=!!(t+"")}catch(r){}return e}function ut(t){var r=-1,n=Array(t.size);return t.forEach(function(t,e){n[++r]=[e,t]}),n}function o(e,r){return function(t){return e(r(t))}}function ct(t){var e=-1,r=Array(t.size);return t.forEach(function(t){r[++e]=t}),r}var e=Array.prototype,s=Function.prototype,a=Object.prototype,u=t["__core-js_shared__"],lt=(u=/[^.]+$/.exec(u&&u.keys&&u.keys.IE_PROTO||""))?"Symbol(src)_1."+u:"",ft=s.toString,j=a.hasOwnProperty,c=a.toString,ht=RegExp("^"+ft.call(j).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),u=i?t.Buffer:undefined,s=t.Symbol,pt=t.Uint8Array,dt=o(Object.getPrototypeOf,Object),gt=Object.create,mt=a.propertyIsEnumerable,yt=e.splice,i=Object.getOwnPropertySymbols,e=u?u.isBuffer:undefined,_t=o(Object.keys,Object),u=b(t,"DataView"),l=b(t,"Map"),f=b(t,"Promise"),h=b(t,"Set"),t=b(t,"WeakMap"),p=b(Object,"create"),bt=v(u),vt=v(l),wt=v(f),xt=v(h),St=v(t),s=s?s.prototype:undefined,At=s?s.valueOf:undefined;function d(t){var e=-1,r=t?t.length:0;for(this.clear();++e<r;){var n=t[e];this.set(n[0],n[1])}}function g(t){var e=-1,r=t?t.length:0;for(this.clear();++e<r;){var n=t[e];this.set(n[0],n[1])}}function m(t){var e=-1,r=t?t.length:0;for(this.clear();++e<r;){var n=t[e];this.set(n[0],n[1])}}function L(t){this.__data__=new g(t)}function Ct(t,e){var r,n,i,o,s=N(t)||function(t){return function(t){return t&&"object"==_typeof(t)}(t)&&Tt(t)}(r=t)&&j.call(r,"callee")&&(!mt.call(r,"callee")||c.call(r)==x)?function(t,e){for(var r=-1,n=Array(t);++r<t;)n[r]=e(r);return n}(t.length,String):[],a=s.length,u=!!a;for(n in t)!e&&!j.call(t,n)||u&&("length"==n||(i=n,(o=null==(o=a)?w:o)&&("number"==typeof i||nt.test(i))&&-1<i&&i%1==0&&i<o))||s.push(n);return s}function Ot(t,e,r){var n=t[e];j.call(t,e)&&Mt(n,r)&&(r!==undefined||e in t)||(t[e]=r)}function y(t,e){for(var r=t.length;r--;)if(Mt(t[r][0],e))return r;return-1}function M(r,n,i,o,t,e,s){var a;if((a=o?e?o(r,t,e,s):o(r):a)===undefined){if(!R(r))return r;t=N(r);if(t){if(a=function(t){var e=t.length,r=t.constructor(e);e&&"string"==typeof t[0]&&j.call(t,"index")&&(r.index=t.index,r.input=t.input);return r}(r),!n){var u=r,c=a,l=-1,f=u.length;for(c=c||Array(f);++l<f;)c[l]=u[l];return c}}else{var h,p,d=q(r),g=d==S||d==B;if(qt(r))return h=r,(p=n)?h.slice():(p=new h.constructor(h.length),h.copy(p),p);if(d==C||d==x||g&&!e){if(at(r))return e?r:{};if(a="function"!=typeof(h=g?{}:r).constructor||Lt(h)?{}:function(t){return R(t)?gt(t):{}}(dt(h)),!n)return g=p=r,g=(y=a)&&kt(g,P(g),y),kt(p,jt(p),g)}else{if(!k[d])return e?r:{};a=function(t,e,r,n){var i=t.constructor;switch(e){case G:return T(t);case I:case D:return new i(+t);case E:return function(t,e){e=e?T(t.buffer):t.buffer;return new t.constructor(e,t.byteOffset,t.byteLength)}(t,n);case $:case W:case J:case Y:case X:case Z:case Q:case K:case tt:return function(t,e){e=e?T(t.buffer):t.buffer;return new t.constructor(e,t.byteOffset,t.length)}(t,n);case A:return function(t,e,r){return st(e?r(ut(t),!0):ut(t),it,new t.constructor)}(t,n,r);case U:case V:return new i(t);case F:return function(t){var e=new t.constructor(t.source,et.exec(t));return e.lastIndex=t.lastIndex,e}(t);case O:return function(t,e,r){return st(e?r(ct(t),!0):ct(t),ot,new t.constructor)}(t,n,r);case H:return function(t){return At?Object(At.call(t)):{}}(t)}}(r,d,M,n)}}var m,y=(s=s||new L).get(r);if(y)return y;s.set(r,a);for(var _=(m=t?m:i?function(t,e,r){e=e(t);return N(t)?e:function(t,e){for(var r=-1,n=e.length,i=t.length;++r<n;)t[i+r]=e[r];return t}(e,r(t))}(r,P,jt):P(r))||r,b=function(t,e){m&&(t=r[e=t]),Ot(a,e,M(t,n,i,o,e,r,s))},v=-1,w=_?_.length:0;++v<w&&!1!==b(_[v],v,_););}return a}function Et(t){var e;return R(t)&&(e=t,!(lt&&lt in e))&&(Nt(t)||at(t)?ht:rt).test(v(t))}function T(t){var e=new t.constructor(t.byteLength);return new pt(e).set(new pt(t)),e}function kt(t,e,r,n){r=r||{};for(var i=-1,o=e.length;++i<o;){var s=e[i],a=n?n(r[s],t[s],s,r,t):undefined;Ot(r,s,a===undefined?t[s]:a)}return r}function _(t,e){var r,n,t=t.__data__;return("string"==(n=_typeof(r=e))||"number"==n||"symbol"==n||"boolean"==n?"__proto__"!==r:null===r)?t["string"==typeof e?"string":"hash"]:t.map}function b(t,e){e=e;e=null==(t=t)?undefined:t[e];return Et(e)?e:undefined}d.prototype.clear=function(){this.__data__=p?p(null):{}},d.prototype["delete"]=function(t){return this.has(t)&&delete this.__data__[t]},d.prototype.get=function(t){var e,r=this.__data__;return p?(e=r[t])===n?undefined:e:j.call(r,t)?r[t]:undefined},d.prototype.has=function(t){var e=this.__data__;return p?e[t]!==undefined:j.call(e,t)},d.prototype.set=function(t,e){return this.__data__[t]=p&&e===undefined?n:e,this},g.prototype.clear=function(){this.__data__=[]},g.prototype["delete"]=function(t){var e=this.__data__;return!((t=y(e,t))<0||(t==e.length-1?e.pop():yt.call(e,t,1),0))},g.prototype.get=function(t){var e=this.__data__;return(t=y(e,t))<0?undefined:e[t][1]},g.prototype.has=function(t){return-1<y(this.__data__,t)},g.prototype.set=function(t,e){var r=this.__data__,n=y(r,t);return n<0?r.push([t,e]):r[n][1]=e,this},m.prototype.clear=function(){this.__data__={hash:new d,map:new(l||g),string:new d}},m.prototype["delete"]=function(t){return _(this,t)["delete"](t)},m.prototype.get=function(t){return _(this,t).get(t)},m.prototype.has=function(t){return _(this,t).has(t)},m.prototype.set=function(t,e){return _(this,t).set(t,e),this},L.prototype.clear=function(){this.__data__=new g},L.prototype["delete"]=function(t){return this.__data__["delete"](t)},L.prototype.get=function(t){return this.__data__.get(t)},L.prototype.has=function(t){return this.__data__.has(t)},L.prototype.set=function(t,e){var r=this.__data__;if(r instanceof g){var n=r.__data__;if(!l||n.length<199)return n.push([t,e]),this;r=this.__data__=new m(n)}return r.set(t,e),this};var jt=i?o(i,Object):function(){return[]},q=function(t){return c.call(t)};function Lt(t){var e=t&&t.constructor;return t===("function"==typeof e&&e.prototype||a)}function v(t){if(null!=t){try{return ft.call(t)}catch(e){}try{return t+""}catch(e){}}return""}function Mt(t,e){return t===e||t!=t&&e!=e}(u&&q(new u(new ArrayBuffer(1)))!=E||l&&q(new l)!=A||f&&q(f.resolve())!=z||h&&q(new h)!=O||t&&q(new t)!=r)&&(q=function q(t){var e=c.call(t),t=e==C?t.constructor:undefined,t=t?v(t):undefined;if(t)switch(t){case bt:return E;case vt:return A;case wt:return z;case xt:return O;case St:return r}return e});var N=Array.isArray;function Tt(t){return null!=t&&"number"==typeof(e=t.length)&&-1<e&&e%1==0&&e<=w&&!Nt(t);var e}var qt=e||function(){return!1};function Nt(t){t=R(t)?c.call(t):"";return t==S||t==B}function R(t){var e=_typeof(t);return t&&("object"==e||"function"==e)}function P(t){return(Tt(t)?Ct:function(t){if(!Lt(t))return _t(t);var e,r=[];for(e in Object(t))j.call(t,e)&&"constructor"!=e&&r.push(e);return r})(t)}Rt.exports=function(t){return M(t,!0,!0)}}.call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],34:[function(t,c,e){!function(t){var r=1/0,n="[object Symbol]",i=/[\\^$.*+?()[\]{}|]/g,o=RegExp(i.source),t="object"==_typeof(t)&&t&&t.Object===Object&&t,e="object"==("undefined"==typeof self?"undefined":_typeof(self))&&self&&self.Object===Object&&self,t=t||e||Function("return this")(),s=Object.prototype.toString,e=t.Symbol,t=e?e.prototype:undefined,a=t?t.toString:undefined;function u(t){var e;return"string"==typeof t?t:"symbol"==_typeof(e=t)||function(t){return t&&"object"==_typeof(t)}(e)&&s.call(e)==n?a?a.call(t):"":"0"==(e=t+"")&&1/t==-r?"-0":e}c.exports=function(t){var e;return(t=null==(e=t)?"":u(e))&&o.test(t)?t.replace(i,"\\$&"):t}}.call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],35:[function(t,e,r){var n,i,o=Function.prototype,s=Object.prototype,a=o.toString,u=s.hasOwnProperty,c=a.call(Object),l=s.toString,f=(n=Object.getPrototypeOf,i=Object,function(t){return n(i(t))});e.exports=function(t){var e;return!(!(e=t)||"object"!=_typeof(e)||"[object Object]"!=l.call(t)||function(t){var e=!1;if(null!=t&&"function"!=typeof t.toString)try{e=!!(t+"")}catch(r){}return e}(t))&&(null===(e=f(t))||"function"==typeof(t=u.call(e,"constructor")&&e.constructor)&&t instanceof t&&a.call(t)==c)}},{}],36:[function(t,e,r){var n=Object.prototype.toString,i=Array.isArray;e.exports=function(t){return"string"==typeof t||!i(t)&&!!(e=t)&&"object"==_typeof(e)&&"[object String]"==n.call(t);var e}},{}],37:[function(t,jt,Lt){!function(t){var P="__lodash_hash_undefined__",I=9007199254740991,D="[object Arguments]",B="[object AsyncFunction]",U="[object Function]",z="[object GeneratorFunction]",F="[object Null]",V="[object Object]",H="[object Proxy]",G="[object Undefined]",$=/^\[object .+?Constructor\]$/,W=/^(?:0|[1-9]\d*)$/,e={},t=(e["[object Float32Array]"]=e["[object Float64Array]"]=e["[object Int8Array]"]=e["[object Int16Array]"]=e["[object Int32Array]"]=e["[object Uint8Array]"]=e["[object Uint8ClampedArray]"]=e["[object Uint16Array]"]=e["[object Uint32Array]"]=!0,e[D]=e["[object Array]"]=e["[object ArrayBuffer]"]=e["[object Boolean]"]=e["[object DataView]"]=e["[object Date]"]=e["[object Error]"]=e[U]=e["[object Map]"]=e["[object Number]"]=e[V]=e["[object RegExp]"]=e["[object Set]"]=e["[object String]"]=e["[object WeakMap]"]=!1,"object"==_typeof(t)&&t&&t.Object===Object&&t),r="object"==("undefined"==typeof self?"undefined":_typeof(self))&&self&&self.Object===Object&&self,r=t||r||Function("return this")(),n="object"==_typeof(Lt)&&Lt&&!Lt.nodeType&&Lt,i=n&&"object"==_typeof(jt)&&jt&&!jt.nodeType&&jt,n=i&&i.exports===n,o=n&&t.process,t=function(){try{var t=i&&i.require&&i.require("util").types;return t?t:o&&o.binding&&o.binding("util")}catch(e){}}(),t=t&&t.isTypedArray;var J,Y,X=Array.prototype,s=Function.prototype,a=Object.prototype,u=r["__core-js_shared__"],v=s.toString,w=a.hasOwnProperty,Z=(s=/[^.]+$/.exec(u&&u.keys&&u.keys.IE_PROTO||""))?"Symbol(src)_1."+s:"",Q=a.toString,K=v.call(Object),tt=RegExp("^"+v.call(w).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),u=n?r.Buffer:undefined,s=r.Symbol,et=r.Uint8Array,rt=u?u.allocUnsafe:undefined,nt=(J=Object.getPrototypeOf,Y=Object,function(t){return J(Y(t))}),it=Object.create,ot=a.propertyIsEnumerable,st=X.splice,c=s?s.toStringTag:undefined,l=function(){try{var t=_(Object,"defineProperty");return t({},"",{}),t}catch(e){}}(),n=u?u.isBuffer:undefined,at=Math.max,ut=Date.now,ct=_(r,"Map"),f=_(Object,"create"),lt=function(t){if(!q(t))return{};if(it)return it(t);h.prototype=t;t=new h;return h.prototype=undefined,t};function h(){}function p(t){var e=-1,r=null==t?0:t.length;for(this.clear();++e<r;){var n=t[e];this.set(n[0],n[1])}}function d(t){var e=-1,r=null==t?0:t.length;for(this.clear();++e<r;){var n=t[e];this.set(n[0],n[1])}}function g(t){var e=-1,r=null==t?0:t.length;for(this.clear();++e<r;){var n=t[e];this.set(n[0],n[1])}}function x(t){t=this.__data__=new d(t);this.size=t.size}function ft(t,e){var r,n=L(t),i=!n&&j(t),o=!n&&!i&&St(t),s=!n&&!i&&!o&&Ot(t),a=n||i||o||s,u=a?function(t,e){for(var r=-1,n=Array(t);++r<t;)n[r]=e(r);return n}(t.length,String):[],c=u.length;for(r in t)!e&&!w.call(t,r)||a&&("length"==r||o&&("offset"==r||"parent"==r)||s&&("buffer"==r||"byteLength"==r||"byteOffset"==r)||bt(r,c))||u.push(r);return u}function S(t,e,r){(r===undefined||k(t[e],r))&&(r!==undefined||e in t)||A(t,e,r)}function m(t,e){for(var r=t.length;r--;)if(k(t[r][0],e))return r;return-1}function A(t,e,r){"__proto__"==e&&l?l(t,e,{configurable:!0,enumerable:!0,value:r,writable:!0}):t[e]=r}p.prototype.clear=function(){this.__data__=f?f(null):{},this.size=0},p.prototype["delete"]=function(t){return t=this.has(t)&&delete this.__data__[t],this.size-=t?1:0,t},p.prototype.get=function(t){var e,r=this.__data__;return f?(e=r[t])===P?undefined:e:w.call(r,t)?r[t]:undefined},p.prototype.has=function(t){var e=this.__data__;return f?e[t]!==undefined:w.call(e,t)},p.prototype.set=function(t,e){var r=this.__data__;return this.size+=this.has(t)?0:1,r[t]=f&&e===undefined?P:e,this},d.prototype.clear=function(){this.__data__=[],this.size=0},d.prototype["delete"]=function(t){var e=this.__data__;return!((t=m(e,t))<0||(t==e.length-1?e.pop():st.call(e,t,1),--this.size,0))},d.prototype.get=function(t){var e=this.__data__;return(t=m(e,t))<0?undefined:e[t][1]},d.prototype.has=function(t){return-1<m(this.__data__,t)},d.prototype.set=function(t,e){var r=this.__data__,n=m(r,t);return n<0?(++this.size,r.push([t,e])):r[n][1]=e,this},g.prototype.clear=function(){this.size=0,this.__data__={hash:new p,map:new(ct||d),string:new p}},g.prototype["delete"]=function(t){return t=y(this,t)["delete"](t),this.size-=t?1:0,t},g.prototype.get=function(t){return y(this,t).get(t)},g.prototype.has=function(t){return y(this,t).has(t)},g.prototype.set=function(t,e){var r=y(this,t),n=r.size;return r.set(t,e),this.size+=r.size==n?0:1,this},x.prototype.clear=function(){this.__data__=new d,this.size=0},x.prototype["delete"]=function(t){var e=this.__data__,t=e["delete"](t);return this.size=e.size,t},x.prototype.get=function(t){return this.__data__.get(t)},x.prototype.has=function(t){return this.__data__.has(t)},x.prototype.set=function(t,e){var r=this.__data__;if(r instanceof d){var n=r.__data__;if(!ct||n.length<199)return n.push([t,e]),this.size=++r.size,this;r=this.__data__=new g(n)}return r.set(t,e),this.size=r.size,this};var ht,pt=function(t,e,r){for(var n=-1,i=Object(t),o=r(t),s=o.length;s--;){var a=o[ht?s:++n];if(!1===e(i[a],a,i))break}return t};function C(t){if(null==t)return t===undefined?G:F;if(c&&c in Object(t)){var e=t,r=w.call(e,c),n=e[c];try{e[c]=undefined;var i=!0}catch(s){}var o=Q.call(e);return i&&(r?e[c]=n:delete e[c]),o}return Q.call(t)}function dt(t){return N(t)&&C(t)==D}function gt(t){var e;return q(t)&&(e=t,!(Z&&Z in e))&&(T(t)?tt:$).test(function(t){if(null!=t){try{return v.call(t)}catch(e){}try{return t+""}catch(e){}}return""}(t))}function mt(t){if(!q(t)){var e=t,r=[];if(null!=e)for(var n in Object(e))r.push(n);return r}var i,o=vt(t),s=[];for(i in t)("constructor"!=i||!o&&w.call(t,i))&&s.push(i);return s}function yt(g,m,y,_,b){g!==m&&pt(m,function(t,e){var r,n,i,o,s,a,u,c,l,f,h,p,d;b=b||new x,q(t)?(n=m,o=y,s=yt,a=_,u=b,h=O(r=g,i=e),p=O(n,i),(d=u.get(p))?S(r,i,d):(d=a?a(h,p,i+"",r,n,u):undefined,(n=d===undefined)&&(c=L(p),l=!c&&St(p),f=!c&&!l&&Ot(p),d=p,c||l||f?d=L(h)?h:function(t){return N(t)&&M(t)}(h)?function(t,e){var r=-1,n=t.length;e=e||Array(n);for(;++r<n;)e[r]=t[r];return e}(h):l?function(t,e){if(e)return t.slice();e=t.length,e=rt?rt(e):new t.constructor(e);return t.copy(e),e}(p,!(n=!1)):f?function(t,e){e=e?function(t){var e=new t.constructor(t.byteLength);return new et(e).set(new et(t)),e}(t.buffer):t.buffer;return new t.constructor(e,t.byteOffset,t.length)}(p,!(n=!1)):[]:function(t){if(!N(t)||C(t)!=V)return;t=nt(t);if(null===t)return 1;t=w.call(t,"constructor")&&t.constructor;return"function"==typeof t&&t instanceof t&&v.call(t)==K}(p)||j(p)?j(d=h)?d=function(t){return function(t,e,r,n){var i=!r,o=(r=r||{},-1),s=e.length;for(;++o<s;){var a=e[o],u=n?n(r[a],t[a],a,r,t):undefined;u===undefined&&(u=t[a]),(i?A:function(t,e,r){var n=t[e];w.call(t,e)&&k(n,r)&&(r!==undefined||e in t)||A(t,e,r)})(r,a,u)}return r}(t,Et(t))}(h):q(h)&&!T(h)||(d=function(t){return"function"!=typeof t.constructor||vt(t)?{}:lt(nt(t))}(p)):n=!1),n&&(u.set(p,d),s(d,p,o,a,u),u["delete"](p)),S(r,i,d))):((c=_?_(O(g,e),t,e+"",g,m,b):undefined)===undefined&&(c=t),S(g,e,c))},Et)}function _t(t,e){return xt((u=t,l=kt,c=at((c=e)===undefined?u.length-1:c,0),function(){for(var t=arguments,e=-1,r=at(t.length-c,0),n=Array(r);++e<r;)n[e]=t[c+e];for(var e=-1,i=Array(c+1);++e<c;)i[e]=t[e];i[c]=l(n);var o=u,s=this,a=i;switch(a.length){case 0:return o.call(s);case 1:return o.call(s,a[0]);case 2:return o.call(s,a[0],a[1]);case 3:return o.call(s,a[0],a[1],a[2])}return o.apply(s,a)}),t+"");var u,c,l}function y(t,e){var r,n,t=t.__data__;return("string"==(n=_typeof(r=e))||"number"==n||"symbol"==n||"boolean"==n?"__proto__"!==r:null===r)?t["string"==typeof e?"string":"hash"]:t.map}function _(t,e){e=e;e=null==(t=t)?undefined:t[e];return gt(e)?e:undefined}function bt(t,e){var r=_typeof(t);return(e=null==e?I:e)&&("number"==r||"symbol"!=r&&W.test(t))&&-1<t&&t%1==0&&t<e}function vt(t){var e=t&&t.constructor;return t===("function"==typeof e&&e.prototype||a)}function O(t,e){if(("constructor"!==e||"function"!=typeof t[e])&&"__proto__"!=e)return t[e]}wt=l?function(t,e){return l(t,"toString",{configurable:!0,enumerable:!1,value:(r=e,function(){return r}),writable:!0});var r}:kt,E=b=0;var wt,b,E,xt=function(){var t=ut(),e=16-(t-E);if(E=t,0<e){if(800<=++b)return arguments[0]}else b=0;return wt.apply(undefined,arguments)};function k(t,e){return t===e||t!=t&&e!=e}var j=dt(function(){return arguments}())?dt:function(t){return N(t)&&w.call(t,"callee")&&!ot.call(t,"callee")},L=Array.isArray;function M(t){return null!=t&&At(t.length)&&!T(t)}var St=n||function(){return!1};function T(t){if(q(t))return(t=C(t))==U||t==z||t==B||t==H}function At(t){return"number"==typeof t&&-1<t&&t%1==0&&t<=I}function q(t){var e=_typeof(t);return null!=t&&("object"==e||"function"==e)}function N(t){return null!=t&&"object"==_typeof(t)}var Ct,Ot=t?(Ct=t,function(t){return Ct(t)}):function(t){return N(t)&&At(t.length)&&!!e[C(t)]};function Et(t){return M(t)?ft(t,!0):mt(t)}R=function(t,e,r,n){yt(t,e,r,n)};var R,X=_t(function(t,e){var r=-1,n=e.length,i=1<n?e[n-1]:undefined,o=2<n?e[2]:undefined,i=3<R.length&&"function"==typeof i?(n--,i):undefined;for(o&&function(t,e,r){if(q(r)){var n=_typeof(e);if("number"==n?M(r)&&bt(e,r.length):"string"==n&&e in r)return k(r[e],t)}return}(e[0],e[1],o)&&(i=n<3?undefined:i,n=1),t=Object(t);++r<n;){var s=e[r];s&&R(t,s,r,i)}return t});function kt(t){return t}jt.exports=X}.call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],38:[function(t,e,c){!function(i){function o(t,e){for(var r=0,n=t.length-1;0<=n;n--){var i=t[n];"."===i?t.splice(n,1):".."===i?(t.splice(n,1),r++):r&&(t.splice(n,1),r--)}if(e)for(;r--;)t.unshift("..");return t}function s(t,e){if(t.filter)return t.filter(e);for(var r=[],n=0;n<t.length;n++)e(t[n],n,t)&&r.push(t[n]);return r}c.resolve=function(){for(var t="",e=!1,r=arguments.length-1;-1<=r&&!e;r--){var n=0<=r?arguments[r]:i.cwd();if("string"!=typeof n)throw new TypeError("Arguments to path.resolve must be strings");n&&(t=n+"/"+t,e="/"===n.charAt(0))}return(e?"/":"")+(t=o(s(t.split("/"),function(t){return!!t}),!e).join("/"))||"."},c.normalize=function(t){var e=c.isAbsolute(t),r="/"===n(t,-1);return(t=(t=o(s(t.split("/"),function(t){return!!t}),!e).join("/"))||e?t:".")&&r&&(t+="/"),(e?"/":"")+t},c.isAbsolute=function(t){return"/"===t.charAt(0)},c.join=function(){var t=Array.prototype.slice.call(arguments,0);return c.normalize(s(t,function(t,e){if("string"!=typeof t)throw new TypeError("Arguments to path.join must be strings");return t}).join("/"))},c.relative=function(t,e){function r(t){for(var e=0;e<t.length&&""===t[e];e++);for(var r=t.length-1;0<=r&&""===t[r];r--);return r<e?[]:t.slice(e,r-e+1)}t=c.resolve(t).substr(1),e=c.resolve(e).substr(1);for(var n=r(t.split("/")),i=r(e.split("/")),o=Math.min(n.length,i.length),s=o,a=0;a<o;a++)if(n[a]!==i[a]){s=a;break}for(var u=[],a=s;a<n.length;a++)u.push("..");return(u=u.concat(i.slice(s))).join("/")},c.sep="/",c.delimiter=":",c.dirname=function(t){if("string"!=typeof t&&(t+=""),0===t.length)return".";for(var e=47===t.charCodeAt(0),r=-1,n=!0,i=t.length-1;1<=i;--i)if(47===t.charCodeAt(i)){if(!n){r=i;break}}else n=!1;return-1===r?e?"/":".":e&&1===r?"/":t.slice(0,r)},c.basename=function(t,e){t=function(t){"string"!=typeof t&&(t+="");for(var e=0,r=-1,n=!0,i=t.length-1;0<=i;--i)if(47===t.charCodeAt(i)){if(!n){e=i+1;break}}else-1===r&&(n=!1,r=i+1);return-1===r?"":t.slice(e,r)}(t);return t=e&&t.substr(-1*e.length)===e?t.substr(0,t.length-e.length):t},c.extname=function(t){"string"!=typeof t&&(t+="");for(var e=-1,r=0,n=-1,i=!0,o=0,s=t.length-1;0<=s;--s){var a=t.charCodeAt(s);if(47===a){if(i)continue;r=s+1;break}-1===n&&(i=!1,n=s+1),46===a?-1===e?e=s:1!==o&&(o=1):-1!==e&&(o=-1)}return-1===e||-1===n||0===o||1===o&&e===n-1&&e===r+1?"":t.slice(e,n)};var n="b"==="ab".substr(-1)?function(t,e,r){return t.substr(e,r)}:function(t,e,r){return e<0&&(e=t.length+e),t.substr(e,r)}}.call(this,t("_process"))},{_process:63}],39:[function(t,e,r){r.__esModule=!0,r["default"]=void 0;t=function(i){var t;function e(t){t=i.call(this,t)||this;return t.type="atrule",t}t=i,(r=e).prototype=Object.create(t.prototype),(r.prototype.constructor=r).__proto__=t;var r=e.prototype;return r.append=function(){var t;this.nodes||(this.nodes=[]);for(var e=arguments.length,r=new Array(e),n=0;n<e;n++)r[n]=arguments[n];return(t=i.prototype.append).call.apply(t,[this].concat(r))},r.prepend=function(){var t;this.nodes||(this.nodes=[]);for(var e=arguments.length,r=new Array(e),n=0;n<e;n++)r[n]=arguments[n];return(t=i.prototype.prepend).call.apply(t,[this].concat(r))},e}(((t=t("./container"))&&t.__esModule?t:{"default":t})["default"]);r["default"]=t,e.exports=r["default"]},{"./container":41}],40:[function(t,e,r){r.__esModule=!0,r["default"]=void 0;t=function(e){var t,r;function n(t){t=e.call(this,t)||this;return t.type="comment",t}return r=e,(t=n).prototype=Object.create(r.prototype),(t.prototype.constructor=t).__proto__=r,n}(((t=t("./node"))&&t.__esModule?t:{"default":t})["default"]);r["default"]=t,e.exports=r["default"]},{"./node":48}],41:[function(d,t,e){e.__esModule=!0,e["default"]=void 0;var g=r(d("./declaration")),m=r(d("./comment"));function r(t){return t&&t.__esModule?t:{"default":t}}function i(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}var n=function(o){function t(){return o.apply(this,arguments)||this}e=o,(n=t).prototype=Object.create(e.prototype),(n.prototype.constructor=n).__proto__=e;var e,r,n=t.prototype;return n.push=function(t){return(t.parent=this).nodes.push(t),this},n.each=function(t){this.lastEach||(this.lastEach=0),this.indexes||(this.indexes={}),this.lastEach+=1;var e,r,n=this.lastEach;if(this.indexes[n]=0,!this.nodes)return undefined;for(;this.indexes[n]<this.nodes.length&&(e=this.indexes[n],!1!==(r=t(this.nodes[e],e)));)this.indexes[n]+=1;return delete this.indexes[n],r},n.walk=function(i){return this.each(function(t,e){var r;try{r=i(t,e)}catch(n){throw n.postcssNode=t,n.stack&&t.source&&/\n\s{4}at /.test(n.stack)&&(e=t.source,n.stack=n.stack.replace(/\n\s{4}at /,"$&"+e.input.from+":"+e.start.line+":"+e.start.column+"$&")),n}return r=!1!==r&&t.walk?t.walk(i):r})},n.walkDecls=function(r,n){return n?r instanceof RegExp?this.walk(function(t,e){if("decl"===t.type&&r.test(t.prop))return n(t,e)}):this.walk(function(t,e){if("decl"===t.type&&t.prop===r)return n(t,e)}):(n=r,this.walk(function(t,e){if("decl"===t.type)return n(t,e)}))},n.walkRules=function(r,n){return n?r instanceof RegExp?this.walk(function(t,e){if("rule"===t.type&&r.test(t.selector))return n(t,e)}):this.walk(function(t,e){if("rule"===t.type&&t.selector===r)return n(t,e)}):(n=r,this.walk(function(t,e){if("rule"===t.type)return n(t,e)}))},n.walkAtRules=function(r,n){return n?r instanceof RegExp?this.walk(function(t,e){if("atrule"===t.type&&r.test(t.name))return n(t,e)}):this.walk(function(t,e){if("atrule"===t.type&&t.name===r)return n(t,e)}):(n=r,this.walk(function(t,e){if("atrule"===t.type)return n(t,e)}))},n.walkComments=function(r){return this.walk(function(t,e){if("comment"===t.type)return r(t,e)})},n.append=function(){for(var t=arguments.length,e=new Array(t),r=0;r<t;r++)e[r]=arguments[r];for(var n=0,i=e;n<i.length;n++)for(var o,s=i[n],a=this.normalize(s,this.last),u=Array.isArray(a),c=0,a=u?a:a[Symbol.iterator]();;){if(u){if(c>=a.length)break;o=a[c++]}else{if((c=a.next()).done)break;o=c.value}var l=o;this.nodes.push(l)}return this},n.prepend=function(){for(var t=arguments.length,e=new Array(t),r=0;r<t;r++)e[r]=arguments[r];for(var n,i=e=e.reverse(),o=Array.isArray(i),s=0,i=o?i:i[Symbol.iterator]();;){if(o){if(s>=i.length)break;n=i[s++]}else{if((s=i.next()).done)break;n=s.value}for(var a,u,c=n,l=this.normalize(c,this.first,"prepend").reverse(),f=l,h=Array.isArray(f),p=0,f=h?f:f[Symbol.iterator]();;){if(h){if(p>=f.length)break;a=f[p++]}else{if((p=f.next()).done)break;a=p.value}var d=a;this.nodes.unshift(d)}for(u in this.indexes)this.indexes[u]=this.indexes[u]+l.length}return this},n.cleanRaws=function(t){if(o.prototype.cleanRaws.call(this,t),this.nodes)for(var e,r=this.nodes,n=Array.isArray(r),i=0,r=n?r:r[Symbol.iterator]();;){if(n){if(i>=r.length)break;e=r[i++]}else{if((i=r.next()).done)break;e=i.value}e.cleanRaws(t)}},n.insertBefore=function(t,e){t=this.index(t);for(var r,n,i,o=this.normalize(e,this.nodes[t],0===t&&"prepend").reverse(),s=o,a=Array.isArray(s),u=0,s=a?s:s[Symbol.iterator]();;){if(a){if(u>=s.length)break;r=s[u++]}else{if((u=s.next()).done)break;r=u.value}var c=r;this.nodes.splice(t,0,c)}for(i in this.indexes)t<=(n=this.indexes[i])&&(this.indexes[i]=n+o.length);return this},n.insertAfter=function(t,e){t=this.index(t);for(var r,n,i,o=this.normalize(e,this.nodes[t]).reverse(),s=o,a=Array.isArray(s),u=0,s=a?s:s[Symbol.iterator]();;){if(a){if(u>=s.length)break;r=s[u++]}else{if((u=s.next()).done)break;r=u.value}var c=r;this.nodes.splice(t+1,0,c)}for(i in this.indexes)t<(n=this.indexes[i])&&(this.indexes[i]=n+o.length);return this},n.removeChild=function(t){var e,r;for(r in t=this.index(t),this.nodes[t].parent=undefined,this.nodes.splice(t,1),this.indexes)t<=(e=this.indexes[r])&&(this.indexes[r]=e-1);return this},n.removeAll=function(){for(var t,e=this.nodes,r=Array.isArray(e),n=0,e=r?e:e[Symbol.iterator]();;){if(r){if(n>=e.length)break;t=e[n++]}else{if((n=e.next()).done)break;t=n.value}t.parent=undefined}return this.nodes=[],this},n.replaceValues=function(e,r,n){return n||(n=r,r={}),this.walkDecls(function(t){r.props&&-1===r.props.indexOf(t.prop)||r.fast&&-1===t.value.indexOf(r.fast)||(t.value=t.value.replace(e,n))}),this},n.every=function(t){return this.nodes.every(t)},n.some=function(t){return this.nodes.some(t)},n.index=function(t){return"number"==typeof t?t:this.nodes.indexOf(t)},n.normalize=function(t,e){var r=this;if("string"==typeof t)t=function p(t){return t.map(function(t){return t.nodes&&(t.nodes=p(t.nodes)),delete t.source,t})}(d("./parse")(t).nodes);else if(Array.isArray(t))for(var n,i=t=t.slice(0),o=Array.isArray(i),s=0,i=o?i:i[Symbol.iterator]();;){if(o){if(s>=i.length)break;n=i[s++]}else{if((s=i.next()).done)break;n=s.value}var a=n;a.parent&&a.parent.removeChild(a,"ignore")}else if("root"===t.type)for(var u,c=t=t.nodes.slice(0),l=Array.isArray(c),f=0,c=l?c:c[Symbol.iterator]();;){if(l){if(f>=c.length)break;u=c[f++]}else{if((f=c.next()).done)break;u=f.value}var h=u;h.parent&&h.parent.removeChild(h,"ignore")}else if(t.type)t=[t];else if(t.prop){if("undefined"==typeof t.value)throw new Error("Value field is missed in node creation");"string"!=typeof t.value&&(t.value=String(t.value)),t=[new g["default"](t)]}else if(t.selector)t=[new(d("./rule"))(t)];else if(t.name)t=[new(d("./at-rule"))(t)];else{if(!t.text)throw new Error("Unknown node type in node creation");t=[new m["default"](t)]}return t.map(function(t){return t.parent&&t.parent.removeChild(t),"undefined"==typeof t.raws.before&&e&&"undefined"!=typeof e.raws.before&&(t.raws.before=e.raws.before.replace(/[^\s]/g,"")),t.parent=r,t})},e=t,(n=[{key:"first",get:function(){return this.nodes?this.nodes[0]:undefined}},{key:"last",get:function(){return this.nodes?this.nodes[this.nodes.length-1]:undefined}}])&&i(e.prototype,n),r&&i(e,r),t}(r(d("./node"))["default"]);e["default"]=n,t.exports=e["default"]},{"./at-rule":39,"./comment":40,"./declaration":43,"./node":48,"./parse":49,"./rule":56}],42:[function(t,e,r){r.__esModule=!0,r["default"]=void 0;var c=n(t("supports-color")),l=n(t("chalk")),f=n(t("./terminal-highlight"));function n(t){return t&&t.__esModule?t:{"default":t}}function i(t){var r="function"==typeof Map?new Map:undefined;return(i=function i(t){if(null===t||-1===Function.toString.call(t).indexOf("[native code]"))return t;if("function"!=typeof t)throw new TypeError("Super expression must either be null or a function");if(void 0!==r){if(r.has(t))return r.get(t);r.set(t,e)}function e(){return o(t,arguments,a(this).constructor)}return e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),s(e,t)})(t)}function o(t,e,r){return(o=function(){if("undefined"!=typeof Reflect&&Reflect.construct&&!Reflect.construct.sham){if("function"==typeof Proxy)return 1;try{return Date.prototype.toString.call(Reflect.construct(Date,[],function(){})),1}catch(t){}}}()?Reflect.construct:function o(t,e,r){var n=[null];n.push.apply(n,e);e=new(Function.bind.apply(t,n));return r&&s(e,r.prototype),e}).apply(null,arguments)}function s(t,e){return(s=Object.setPrototypeOf||function s(t,e){return t.__proto__=e,t})(t,e)}function a(t){return(a=Object.setPrototypeOf?Object.getPrototypeOf:function a(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}t=function(a){var t;function u(t,e,r,n,i,o){var s=a.call(this,t)||this;return s.name="CssSyntaxError",s.reason=t,i&&(s.file=i),n&&(s.source=n),o&&(s.plugin=o),void 0!==e&&void 0!==r&&(s.line=e,s.column=r),s.setMessage(),Error.captureStackTrace&&Error.captureStackTrace(function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(s),u),s}t=a,(e=u).prototype=Object.create(t.prototype),(e.prototype.constructor=e).__proto__=t;var e=u.prototype;return e.setMessage=function(){this.message=this.plugin?this.plugin+": ":"",this.message+=this.file||"<css input>","undefined"!=typeof this.line&&(this.message+=":"+this.line+":"+this.column),this.message+=": "+this.reason},e.showSourceCode=function(e){var t,n,r,i,o=this;return this.source?(t=this.source,t=(t=f["default"]&&(e=void 0===e?c["default"].stdout:e)?(0,f["default"])(t):t).split(/\r?\n/),n=Math.max(this.line-3,0),r=Math.min(this.line+2,t.length),i=String(r).length,t.slice(n,r).map(function(t,e){var e=n+1+e,r=" "+(" "+e).slice(-i)+" | ";return e===o.line?(e=a(r.replace(/\d/g," "))+t.slice(0,o.column-1).replace(/[^\t]/g," "),s(">")+a(r)+t+"\n "+e+s("^")):" "+a(r)+t}).join("\n")):"";function s(t){return e&&l["default"].red?l["default"].red.bold(t):t}function a(t){return e&&l["default"].gray?l["default"].gray(t):t}},e.toString=function(){var t=(t=this.showSourceCode())&&"\n\n"+t+"\n";return this.name+": "+this.message+t},u}(i(Error));r["default"]=t,e.exports=r["default"]},{"./terminal-highlight":2,chalk:2,"supports-color":2}],43:[function(t,e,r){r.__esModule=!0,r["default"]=void 0;t=function(e){var t,r;function n(t){t=e.call(this,t)||this;return t.type="decl",t}return r=e,(t=n).prototype=Object.create(r.prototype),(t.prototype.constructor=t).__proto__=r,n}(((t=t("./node"))&&t.__esModule?t:{"default":t})["default"]);r["default"]=t,e.exports=r["default"]},{"./node":48}],44:[function(t,e,r){r.__esModule=!0,r["default"]=void 0;var i=n(t("path")),o=n(t("./css-syntax-error")),s=n(t("./previous-map"));function n(t){return t&&t.__esModule?t:{"default":t}}function a(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}var u=0,t=function(){function t(t,e){if(void 0===e&&(e={}),null===t||"object"===_typeof(t)&&!t.toString)throw new Error("PostCSS received "+t+" instead of CSS string");this.css=t.toString(),"\ufeff"===this.css[0]||"￾"===this.css[0]?(this.hasBOM=!0,this.css=this.css.slice(1)):this.hasBOM=!1,e.from&&(/^\w+:\/\//.test(e.from)||i["default"].isAbsolute(e.from)?this.file=e.from:this.file=i["default"].resolve(e.from));t=new s["default"](this.css,e);t.text&&(e=(this.map=t).consumer().file,!this.file)&&e&&(this.file=this.mapResolve(e)),this.file||(u+=1,this.id="<input css "+u+">"),this.map&&(this.map.file=this.from)}var e,r,n=t.prototype;return n.error=function(t,e,r,n){void 0===n&&(n={});var i=this.origin(e,r),i=i?new o["default"](t,i.line,i.column,i.source,i.file,n.plugin):new o["default"](t,e,r,this.css,this.file,n.plugin);return i.input={line:e,column:r,source:this.css},this.file&&(i.input.file=this.file),i},n.origin=function(t,e){var r;return!!this.map&&!!(t=(r=this.map.consumer()).originalPositionFor({line:t,column:e})).source&&(e={file:this.mapResolve(t.source),line:t.line,column:t.column},(t=r.sourceContentFor(t.source))&&(e.source=t),e)},n.mapResolve=function(t){return/^\w+:\/\//.test(t)?t:i["default"].resolve(this.map.consumer().sourceRoot||".",t)},n=t,(e=[{key:"from",get:function(){return this.file||this.id}}])&&a(n.prototype,e),r&&a(n,r),t}();r["default"]=t,e.exports=r["default"]},{"./css-syntax-error":42,"./previous-map":52,path:38}],45:[function(r,s,h){!function(u){h.__esModule=!0,h["default"]=void 0;var n=t(r("./map-generator")),i=t(r("./stringify")),o=t(r("./warn-once")),a=t(r("./result")),c=t(r("./parse"));function t(t){return t&&t.__esModule?t:{"default":t}}function l(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}function f(t){return"object"===_typeof(t)&&"function"==typeof t.then}var e=function(){function s(t,e,r){var n;if(this.stringified=!1,this.processed=!1,"object"===_typeof(e)&&null!==e&&"root"===e.type)n=e;else if(e instanceof s||e instanceof a["default"])n=e.root,e.map&&("undefined"==typeof r.map&&(r.map={}),r.map.inline||(r.map.inline=!1),r.map.prev=e.map);else{var i=c["default"];r.syntax&&(i=r.syntax.parse),(i=r.parser?r.parser:i).parse&&(i=i.parse);try{n=i(e,r)}catch(o){this.error=o}}this.result=new a["default"](t,n,r)}var t,e,r=s.prototype;return r.warnings=function(){return this.sync().warnings()},r.toString=function(){return this.css},r.then=function(t,e){return"production"===u.env.NODE_ENV||"from"in this.opts||(0,o["default"])("Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."),this["async"]().then(t,e)},r["catch"]=function(t){return this["async"]()["catch"](t)},r["finally"]=function(t){return this["async"]().then(t,t)},r.handleError=function(t,e){try{var r,n,i,o,s;"CssSyntaxError"!==(this.error=t).name||t.plugin?e.postcssVersion&&"production"!==u.env.NODE_ENV&&(r=e.postcssPlugin,n=e.postcssVersion,i=this.result.processor.version,o=n.split("."),s=i.split("."),o[0]!==s[0]||parseInt(o[1])>parseInt(s[1]))&&console.error("Unknown error from PostCSS plugin. Your current PostCSS version is "+i+", but "+r+" uses "+n+". Perhaps this is the source of the error below."):(t.plugin=e.postcssPlugin,t.setMessage())}catch(a){console&&console.error&&console.error(a)}},r.asyncTick=function(t,e){var r=this;if(this.plugin>=this.processor.plugins.length)return this.processed=!0,t();try{var n=this.processor.plugins[this.plugin],i=this.run(n);this.plugin+=1,f(i)?i.then(function(){r.asyncTick(t,e)})["catch"](function(t){r.handleError(t,n),r.processed=!0,e(t)}):this.asyncTick(t,e)}catch(o){this.processed=!0,e(o)}},r["async"]=function(){var r=this;return this.processed?new Promise(function(t,e){r.error?e(r.error):t(r.stringify())}):(this.processing||(this.processing=new Promise(function(t,e){if(r.error)return e(r.error);r.plugin=0,r.asyncTick(t,e)}).then(function(){return r.processed=!0,r.stringify()})),this.processing)},r.sync=function(){if(!this.processed){if(this.processed=!0,this.processing)throw new Error("Use process(css).then(cb) to work with async plugins");if(this.error)throw this.error;for(var t,e=this.result.processor.plugins,r=Array.isArray(e),n=0,e=r?e:e[Symbol.iterator]();;){if(r){if(n>=e.length)break;t=e[n++]}else{if((n=e.next()).done)break;t=n.value}var i=t;if(f(this.run(i)))throw new Error("Use process(css).then(cb) to work with async plugins")}}return this.result},r.run=function(t){this.result.lastPlugin=t;try{return t(this.result.root,this.result)}catch(e){throw this.handleError(e,t),e}},r.stringify=function(){var t,e;return this.stringified||(this.stringified=!0,this.sync(),e=this.result.opts,t=i["default"],e.syntax&&(t=e.syntax.stringify),(t=e.stringifier?e.stringifier:t).stringify&&(t=t.stringify),e=new n["default"](t,this.result.root,this.result.opts).generate(),this.result.css=e[0],this.result.map=e[1]),this.result},r=s,(t=[{key:"processor",get:function(){return this.result.processor}},{key:"opts",get:function(){return this.result.opts}},{key:"css",get:function(){return this.stringify().css}},{key:"content",get:function(){return this.stringify().content}},{key:"map",get:function(){return this.stringify().map}},{key:"root",get:function(){return this.sync().root}},{key:"messages",get:function(){return this.sync().messages}}])&&l(r.prototype,t),e&&l(r,e),s}();h["default"]=e,s.exports=h["default"]}.call(this,r("_process"))},{"./map-generator":47,"./parse":49,"./result":54,"./stringify":58,"./warn-once":61,_process:63}],46:[function(t,e,r){r.__esModule=!0,r["default"]=void 0;var n={split:function l(t,e,r){for(var n=[],i="",l=!1,o=0,s=!1,a=!1,u=0;u<t.length;u++){var c=t[u];s?a?a=!1:"\\"===c?a=!0:c===s&&(s=!1):'"'===c||"'"===c?s=c:"("===c?o+=1:")"===c?0<o&&--o:0===o&&-1!==e.indexOf(c)&&(l=!0),l?(""!==i&&n.push(i.trim()),i="",l=!1):i+=c}return!r&&""===i||n.push(i.trim()),n},space:function(t){return n.split(t,[" ","\n","\t"])},comma:function(t){return n.split(t,[","],!0)}};r["default"]=n,e.exports=r["default"]},{}],47:[function(e,n,i){!function(r){i.__esModule=!0,i["default"]=void 0;var u=t(e("source-map")),c=t(e("path"));function t(t){return t&&t.__esModule?t:{"default":t}}i["default"]=function(){function t(t,e,r){this.stringify=t,this.mapOpts=r.map||{},this.root=e,this.opts=r}var e=t.prototype;return e.isMap=function(){return"undefined"!=typeof this.opts.map?!!this.opts.map:0<this.previous().length},e.previous=function(){var e=this;return this.previousMaps||(this.previousMaps=[],this.root.walk(function(t){t.source&&t.source.input.map&&(t=t.source.input.map,-1===e.previousMaps.indexOf(t))&&e.previousMaps.push(t)})),this.previousMaps},e.isInline=function(){var t;return"undefined"!=typeof this.mapOpts.inline?this.mapOpts.inline:(void 0===(t=this.mapOpts.annotation)||!0===t)&&(!this.previous().length||this.previous().some(function(t){return t.inline}))},e.isSourcesContent=function(){return"undefined"!=typeof this.mapOpts.sourcesContent?this.mapOpts.sourcesContent:!this.previous().length||this.previous().some(function(t){return t.withContent()})},e.clearAnnotation=function(){if(!1!==this.mapOpts.annotation)for(var t,e=this.root.nodes.length-1;0<=e;e--)"comment"===(t=this.root.nodes[e]).type&&0===t.text.indexOf("# sourceMappingURL=")&&this.root.removeChild(e)},e.setSourcesContent=function(){var r=this,n={};this.root.walk(function(t){var e;t.source&&(e=t.source.input.from)&&!n[e]&&(n[e]=!0,e=r.relative(e),r.map.setSourceContent(e,t.source.input.css))})},e.applyPrevMaps=function(){for(var t,e=this.previous(),r=Array.isArray(e),n=0,e=r?e:e[Symbol.iterator]();;){if(r){if(n>=e.length)break;t=e[n++]}else{if((n=e.next()).done)break;t=n.value}var i=t,o=this.relative(i.file),s=i.root||c["default"].dirname(i.file),a=void 0;!1===this.mapOpts.sourcesContent?(a=new u["default"].SourceMapConsumer(i.text)).sourcesContent&&(a.sourcesContent=a.sourcesContent.map(function(){return null})):a=i.consumer(),this.map.applySourceMap(a,o,this.relative(s))}},e.isAnnotation=function(){return!!this.isInline()||("undefined"!=typeof this.mapOpts.annotation?this.mapOpts.annotation:!this.previous().length||this.previous().some(function(t){return t.annotation}))},e.toBase64=function(t){return r?r.from(t).toString("base64"):window.btoa(unescape(encodeURIComponent(t)))},e.addAnnotation=function(){var t=this.isInline()?"data:application/json;base64,"+this.toBase64(this.map.toString()):"string"==typeof this.mapOpts.annotation?this.mapOpts.annotation:this.outputFile()+".map",e="\n";-1!==this.css.indexOf("\r\n")&&(e="\r\n"),this.css+=e+"/*# sourceMappingURL="+t+" */"},e.outputFile=function(){return this.opts.to?this.relative(this.opts.to):this.opts.from?this.relative(this.opts.from):"to.css"},e.generateMap=function(){return this.generateString(),this.isSourcesContent()&&this.setSourcesContent(),0<this.previous().length&&this.applyPrevMaps(),this.isAnnotation()&&this.addAnnotation(),this.isInline()?[this.css]:[this.css,this.map]},e.relative=function(t){var e;return 0!==t.indexOf("<")&&!/^\w+:\/\//.test(t)&&(e=this.opts.to?c["default"].dirname(this.opts.to):".","string"==typeof this.mapOpts.annotation&&(e=c["default"].dirname(c["default"].resolve(e,this.mapOpts.annotation))),t=c["default"].relative(e,t),"\\"===c["default"].sep)?t.replace(/\\/g,"/"):t},e.sourcePath=function(t){return this.mapOpts.from||this.relative(t.source.input.from)},e.generateString=function(){var n,i=this,o=(this.css="",this.map=new u["default"].SourceMapGenerator({file:this.outputFile()}),1),s=1;this.stringify(this.root,function(t,e,r){i.css+=t,e&&"end"!==r&&(e.source&&e.source.start?i.map.addMapping({source:i.sourcePath(e),generated:{line:o,column:s-1},original:{line:e.source.start.line,column:e.source.start.column-1}}):i.map.addMapping({source:"<no source>",original:{line:1,column:0},generated:{line:o,column:s-1}})),(n=t.match(/\n/g))?(o+=n.length,n=t.lastIndexOf("\n"),s=t.length-n):s+=t.length,e&&"start"!==r&&(t=e.parent||{raws:{}},"decl"===e.type&&e===t.last&&!t.raws.semicolon||(e.source&&e.source.end?i.map.addMapping({source:i.sourcePath(e),generated:{line:o,column:s-2},original:{line:e.source.end.line,column:e.source.end.column-1}}):i.map.addMapping({source:"<no source>",original:{line:1,column:0},generated:{line:o,column:s-1}})))})},e.generate=function(){var e;return this.clearAnnotation(),this.isMap()?this.generateMap():(e="",this.stringify(this.root,function(t){e+=t}),[e])},t}(),n.exports=i["default"]}.call(this,e("buffer").Buffer)},{buffer:3,path:38,"source-map":78}],48:[function(s,a,u){!function(r){u.__esModule=!0,u["default"]=void 0;var n=t(s("./css-syntax-error")),i=t(s("./stringifier")),o=t(s("./stringify"));function t(t){return t&&t.__esModule?t:{"default":t}}var e=function(){function t(t){if(void 0===t&&(t={}),this.raws={},"production"!==r.env.NODE_ENV&&"object"!==_typeof(t)&&void 0!==t)throw new Error("PostCSS nodes constructor accepts object, not "+JSON.stringify(t));for(var e in t)this[e]=t[e]}var e=t.prototype;return e.error=function(t,e){var r;return void 0===e&&(e={}),this.source?(r=this.positionBy(e),this.source.input.error(t,r.line,r.column,e)):new n["default"](t)},e.warn=function(t,e,r){var n,i={node:this};for(n in r)i[n]=r[n];return t.warn(e,i)},e.remove=function(){return this.parent&&this.parent.removeChild(this),this.parent=undefined,this},e.toString=function(t){(t=void 0===t?o["default"]:t).stringify&&(t=t.stringify);var e="";return t(this,function(t){e+=t}),e},e.clone=function(t){void 0===t&&(t={});var e,r=function s(t,e){var r,n,i,o=new t.constructor;for(r in t)t.hasOwnProperty(r)&&(n=t[r],i=_typeof(n),"parent"===r&&"object"===i?e&&(o[r]=e):"source"===r?o[r]=n:n instanceof Array?o[r]=n.map(function(t){return s(t,o)}):("object"===i&&null!==n&&(n=s(n)),o[r]=n));return o}(this);for(e in t)r[e]=t[e];return r},e.cloneBefore=function(t){t=this.clone(t=void 0===t?{}:t);return this.parent.insertBefore(this,t),t},e.cloneAfter=function(t){t=this.clone(t=void 0===t?{}:t);return this.parent.insertAfter(this,t),t},e.replaceWith=function(){if(this.parent){for(var t=arguments.length,e=new Array(t),r=0;r<t;r++)e[r]=arguments[r];for(var n=0,i=e;n<i.length;n++){var o=i[n];this.parent.insertBefore(this,o)}this.remove()}return this},e.next=function(){var t;return this.parent?(t=this.parent.index(this),this.parent.nodes[t+1]):undefined},e.prev=function(){var t;return this.parent?(t=this.parent.index(this),this.parent.nodes[t-1]):undefined},e.before=function(t){return this.parent.insertBefore(this,t),this},e.after=function(t){return this.parent.insertAfter(this,t),this},e.toJSON=function(){var t,e,r={};for(t in this)this.hasOwnProperty(t)&&"parent"!==t&&((e=this[t])instanceof Array?r[t]=e.map(function(t){return"object"===_typeof(t)&&t.toJSON?t.toJSON():t}):"object"===_typeof(e)&&e.toJSON?r[t]=e.toJSON():r[t]=e);return r},e.raw=function(t,e){return(new i["default"]).raw(this,t,e)},e.root=function(){for(var t=this;t.parent;)t=t.parent;return t},e.cleanRaws=function(t){delete this.raws.before,delete this.raws.after,t||delete this.raws.between},e.positionInside=function(t){for(var e=this.toString(),r=this.source.start.column,n=this.source.start.line,i=0;i<t;i++)"\n"===e[i]?n+=r=1:r+=1;return{line:n,column:r}},e.positionBy=function(t){var e=this.source.start;return t.index?e=this.positionInside(t.index):t.word&&-1!==(t=this.toString().indexOf(t.word))&&(e=this.positionInside(t)),e},t}();u["default"]=e,a.exports=u["default"]}.call(this,s("_process"))},{"./css-syntax-error":42,"./stringifier":57,"./stringify":58,_process:63}],49:[function(e,r,s){!function(n){s.__esModule=!0,s["default"]=void 0;var i=t(e("./parser")),o=t(e("./input"));function t(t){return t&&t.__esModule?t:{"default":t}}s["default"]=function(t,e){t=new o["default"](t,e),t=new i["default"](t);try{t.parse()}catch(r){throw"production"!==n.env.NODE_ENV&&"CssSyntaxError"===r.name&&e&&e.from&&(/\.scss$/i.test(e.from)?r.message+="\nYou tried to parse SCSS with the standard CSS parser; try again with the postcss-scss parser":/\.sass/i.test(e.from)?r.message+="\nYou tried to parse Sass with the standard CSS parser; try again with the postcss-sass parser":/\.less$/i.test(e.from)&&(r.message+="\nYou tried to parse Less with the standard CSS parser; try again with the postcss-less parser")),r}return t.root},r.exports=s["default"]}.call(this,e("_process"))},{"./input":44,"./parser":50,_process:63}],50:[function(t,e,r){r.__esModule=!0,r["default"]=void 0;var f=u(t("./declaration")),n=u(t("./tokenize")),i=u(t("./comment")),a=u(t("./at-rule")),o=u(t("./root")),s=u(t("./rule"));function u(t){return t&&t.__esModule?t:{"default":t}}t=function(){function t(t){this.input=t,this.root=new o["default"],this.current=this.root,this.spaces="",this.semicolon=!1,this.createTokenizer(),this.root.source={input:t,start:{line:1,column:1}}}var e=t.prototype;return e.createTokenizer=function(){this.tokenizer=(0,n["default"])(this.input)},e.parse=function(){for(var t;!this.tokenizer.endOfFile();)switch((t=this.tokenizer.nextToken())[0]){case"space":this.spaces+=t[1];break;case";":this.freeSemicolon(t);break;case"}":this.end(t);break;case"comment":this.comment(t);break;case"at-word":this.atrule(t);break;case"{":this.emptyRule(t);break;default:this.other(t)}this.endFile()},e.comment=function(t){var e=new i["default"],t=(this.init(e,t[2],t[3]),e.source.end={line:t[4],column:t[5]},t[1].slice(2,-2));/^\s*$/.test(t)?(e.text="",e.raws.left=t,e.raws.right=""):(t=t.match(/^(\s*)([^]*[^\s])(\s*)$/),e.text=t[2],e.raws.left=t[1],e.raws.right=t[3])},e.emptyRule=function(t){var e=new s["default"];this.init(e,t[2],t[3]),e.selector="",e.raws.between="",this.current=e},e.other=function(t){for(var e,r=!1,n=!1,i=null,o=[],s=[],a=t;a;){if(e=a[0],s.push(a),"("===e||"["===e)i=i||a,o.push("("===e?")":"]");else if(0===o.length){if(";"===e){if(n)return void this.decl(s);break}if("{"===e)return void this.rule(s);if("}"===e){this.tokenizer.back(s.pop()),r=!0;break}":"===e&&(n=!0)}else e===o[o.length-1]&&(o.pop(),0===o.length)&&(i=null);a=this.tokenizer.nextToken()}if(this.tokenizer.endOfFile()&&(r=!0),0<o.length&&this.unclosedBracket(i),r&&n){for(;s.length&&("space"===(a=s[s.length-1][0])||"comment"===a);)this.tokenizer.back(s.pop());this.decl(s)}else this.unknownWord(s)},e.rule=function(t){t.pop();var e=new s["default"];this.init(e,t[0][2],t[0][3]),e.raws.between=this.spacesAndCommentsFromEnd(t),this.raw(e,"selector",t),this.current=e},e.decl=function(t){var e,r=new f["default"],n=(this.init(r),t[t.length-1]);for(";"===n[0]&&(this.semicolon=!0,t.pop()),n[4]?r.source.end={line:n[4],column:n[5]}:r.source.end={line:n[2],column:n[3]};"word"!==t[0][0];)1===t.length&&this.unknownWord(t),r.raws.before+=t.shift()[1];for(r.source.start={line:t[0][2],column:t[0][3]},r.prop="";t.length;){var i=t[0][0];if(":"===i||"space"===i||"comment"===i)break;r.prop+=t.shift()[1]}for(r.raws.between="";t.length;){if(":"===(e=t.shift())[0]){r.raws.between+=e[1];break}"word"===e[0]&&/\w/.test(e[1])&&this.unknownWord([e]),r.raws.between+=e[1]}"_"!==r.prop[0]&&"*"!==r.prop[0]||(r.raws.before+=r.prop[0],r.prop=r.prop.slice(1)),r.raws.between+=this.spacesAndCommentsFromStart(t),this.precheckMissedSemicolon(t);for(var o=t.length-1;0<o;o--){if("!important"===(e=t[o])[1].toLowerCase()){r.important=!0;var s=this.stringFrom(t,o);" !important"!==(s=this.spacesFromEnd(t)+s)&&(r.raws.important=s);break}if("important"===e[1].toLowerCase()){for(var a=t.slice(0),u="",c=o;0<c;c--){var l=a[c][0];if(0===u.trim().indexOf("!")&&"space"!==l)break;u=a.pop()[1]+u}0===u.trim().indexOf("!")&&(r.important=!0,r.raws.important=u,t=a)}if("space"!==e[0]&&"comment"!==e[0])break}this.raw(r,"value",t),-1!==r.value.indexOf(":")&&this.checkMissedSemicolon(t)},e.atrule=function(t){for(var e,r,n=new a["default"],i=(n.name=t[1].slice(1),""===n.name&&this.unnamedAtrule(n,t),this.init(n,t[2],t[3]),!1),o=!1,s=[];!this.tokenizer.endOfFile();){if(";"===(t=this.tokenizer.nextToken())[0]){n.source.end={line:t[2],column:t[3]},this.semicolon=!0;break}if("{"===t[0]){o=!0;break}if("}"===t[0]){if(0<s.length){for(e=s[r=s.length-1];e&&"space"===e[0];)e=s[--r];e&&(n.source.end={line:e[4],column:e[5]})}this.end(t);break}if(s.push(t),this.tokenizer.endOfFile()){i=!0;break}}n.raws.between=this.spacesAndCommentsFromEnd(s),s.length?(n.raws.afterName=this.spacesAndCommentsFromStart(s),this.raw(n,"params",s),i&&(t=s[s.length-1],n.source.end={line:t[4],column:t[5]},this.spaces=n.raws.between,n.raws.between="")):(n.raws.afterName="",n.params=""),o&&(n.nodes=[],this.current=n)},e.end=function(t){this.current.nodes&&this.current.nodes.length&&(this.current.raws.semicolon=this.semicolon),this.semicolon=!1,this.current.raws.after=(this.current.raws.after||"")+this.spaces,this.spaces="",this.current.parent?(this.current.source.end={line:t[2],column:t[3]},this.current=this.current.parent):this.unexpectedClose(t)},e.endFile=function(){this.current.parent&&this.unclosedBlock(),this.current.nodes&&this.current.nodes.length&&(this.current.raws.semicolon=this.semicolon),this.current.raws.after=(this.current.raws.after||"")+this.spaces},e.freeSemicolon=function(t){this.spaces+=t[1],this.current.nodes&&(t=this.current.nodes[this.current.nodes.length-1])&&"rule"===t.type&&!t.raws.ownSemicolon&&(t.raws.ownSemicolon=this.spaces,this.spaces="")},e.init=function(t,e,r){this.current.push(t),t.source={start:{line:e,column:r},input:this.input},t.raws.before=this.spaces,this.spaces="","comment"!==t.type&&(this.semicolon=!1)},e.raw=function h(t,e,r){for(var n,i,o,s,h,a=r.length,u="",c=!0,l=/^([.|#])?([\w])+/i,f=0;f<a;f+=1)"comment"===(i=(n=r[f])[0])&&"rule"===t.type?(s=r[f-1],o=r[f+1],"space"!==s[0]&&"space"!==o[0]&&l.test(s[1])&&l.test(o[1])?u+=n[1]:c=!1):"comment"===i||"space"===i&&f===a-1?c=!1:u+=n[1];c||(h=r.reduce(function(t,e){return t+e[1]},""),t.raws[e]={value:u,raw:h}),t[e]=u},e.spacesAndCommentsFromEnd=function(t){for(var e,r="";t.length&&("space"===(e=t[t.length-1][0])||"comment"===e);)r=t.pop()[1]+r;return r},e.spacesAndCommentsFromStart=function(t){for(var e,r="";t.length&&("space"===(e=t[0][0])||"comment"===e);)r+=t.shift()[1];return r},e.spacesFromEnd=function(t){for(var e="";t.length&&"space"===t[t.length-1][0];)e=t.pop()[1]+e;return e},e.stringFrom=function(t,e){for(var r="",n=e;n<t.length;n++)r+=t[n][1];return t.splice(e,t.length-e),r},e.colon=function(t){for(var e,r,n,i=0,o=0;o<t.length;o++){if("("===(r=(e=t[o])[0])&&(i+=1),")"===r&&--i,0===i&&":"===r){if(n){if("word"===n[0]&&"progid"===n[1])continue;return o}this.doubleColon(e)}n=e}return!1},e.unclosedBracket=function(t){throw this.input.error("Unclosed bracket",t[2],t[3])},e.unknownWord=function(t){throw this.input.error("Unknown word",t[0][2],t[0][3])},e.unexpectedClose=function(t){throw this.input.error("Unexpected }",t[2],t[3])},e.unclosedBlock=function(){var t=this.current.source.start;throw this.input.error("Unclosed block",t.line,t.column)},e.doubleColon=function(t){throw this.input.error("Double colon",t[2],t[3])},e.unnamedAtrule=function(t,e){throw this.input.error("At-rule without name",e[2],e[3])},e.precheckMissedSemicolon=function(){},e.checkMissedSemicolon=function(t){var e=this.colon(t);if(!1!==e){for(var r,n=0,i=e-1;0<=i&&("space"===(r=t[i])[0]||2!==(n+=1));i--);throw this.input.error("Missed semicolon",r[2],r[3])}},t}();r["default"]=t,e.exports=r["default"]},{"./at-rule":39,"./comment":40,"./declaration":43,"./root":55,"./rule":56,"./tokenize":59}],51:[function(t,e,r){r.__esModule=!0,r["default"]=void 0;var n=p(t("./declaration")),i=p(t("./processor")),o=p(t("./stringify")),s=p(t("./comment")),a=p(t("./at-rule")),u=p(t("./vendor")),c=p(t("./parse")),l=p(t("./list")),f=p(t("./rule")),h=p(t("./root"));function p(t){return t&&t.__esModule?t:{"default":t}}function d(){for(var t=arguments.length,e=new Array(t),r=0;r<t;r++)e[r]=arguments[r];return 1===e.length&&Array.isArray(e[0])&&(e=e[0]),new i["default"](e)}d.plugin=function(e,r){function n(){var t=r.apply(void 0,arguments);return t.postcssPlugin=e,t.postcssVersion=(new i["default"]).version,t}var t;return Object.defineProperty(n,"postcss",{get:function(){return t=t||n()}}),n.process=function(t,e,r){return d([n(r)]).process(t,e)},n},d.stringify=o["default"],d.parse=c["default"],d.vendor=u["default"],d.list=l["default"],d.comment=function(t){return new s["default"](t)},d.atRule=function(t){return new a["default"](t)},d.decl=function(t){return new n["default"](t)},d.rule=function(t){return new f["default"](t)},d.root=function(t){return new h["default"](t)},r["default"]=d,e.exports=r["default"]},{"./at-rule":39,"./comment":40,"./declaration":43,"./list":46,"./parse":49,"./processor":53,"./root":55,"./rule":56,"./stringify":58,"./vendor":60}],52:[function(s,a,u){!function(r){u.__esModule=!0,u["default"]=void 0;var n=t(s("source-map")),i=t(s("path")),o=t(s("fs"));function t(t){return t&&t.__esModule?t:{"default":t}}var e=function(){function t(t,e){this.loadAnnotation(t),this.inline=this.startWith(this.annotation,"data:");t=e.map?e.map.prev:undefined,e=this.loadMap(e.from,t);e&&(this.text=e)}var e=t.prototype;return e.consumer=function(){return this.consumerCache||(this.consumerCache=new n["default"].SourceMapConsumer(this.text)),this.consumerCache},e.withContent=function(){return!!(this.consumer().sourcesContent&&0<this.consumer().sourcesContent.length)},e.startWith=function(t,e){return!!t&&t.substr(0,e.length)===e},e.loadAnnotation=function(t){t=t.match(/\/\*\s*# sourceMappingURL=(.*)\s*\*\//);t&&(this.annotation=t[1].trim())},e.decodeInline=function(t){var e="data:application/json,";if(this.startWith(t,e))return decodeURIComponent(t.substr(e.length));if(/^data:application\/json;charset=utf-?8;base64,/.test(t)||/^data:application\/json;base64,/.test(t))return e=t.substr(RegExp.lastMatch.length),r?r.from(e,"base64").toString():window.atob(e);e=t.match(/data:application\/json;([^,]+),/)[1];throw new Error("Unsupported source map encoding "+e)},e.loadMap=function(t,e){if(!1===e)return!1;if(e){if("string"==typeof e)return e;if("function"==typeof e){var r=e(t);if(r&&o["default"].existsSync&&o["default"].existsSync(r))return o["default"].readFileSync(r,"utf-8").toString().trim();throw new Error("Unable to load previous source map: "+r.toString())}if(e instanceof n["default"].SourceMapConsumer)return n["default"].SourceMapGenerator.fromSourceMap(e).toString();if(e instanceof n["default"].SourceMapGenerator)return e.toString();if(this.isMap(e))return JSON.stringify(e);throw new Error("Unsupported previous source map format: "+e.toString())}return this.inline?this.decodeInline(this.annotation):this.annotation?(r=this.annotation,t&&(r=i["default"].join(i["default"].dirname(t),r)),this.root=i["default"].dirname(r),!(!o["default"].existsSync||!o["default"].existsSync(r))&&o["default"].readFileSync(r,"utf-8").toString().trim()):void 0},e.isMap=function(t){return"object"===_typeof(t)&&("string"==typeof t.mappings||"string"==typeof t._mappings)},t}();u["default"]=e,a.exports=u["default"]}.call(this,s("buffer").Buffer)},{buffer:3,fs:2,path:38,"source-map":78}],53:[function(e,r,n){!function(a){n.__esModule=!0,n["default"]=void 0;var i=(t=e("./lazy-result"))&&t.__esModule?t:{"default":t};var t=function(){function t(t){void 0===t&&(t=[]),this.version="7.0.27",this.plugins=this.normalize(t)}var e,r=t.prototype;function n(t){return e.apply(this,arguments)}return r.use=function(t){return this.plugins=this.plugins.concat(this.normalize([t])),this},r.process=(e=function(t,e){return void 0===e&&(e={}),0===this.plugins.length&&e.parser===e.stringifier&&"production"!==a.env.NODE_ENV&&"undefined"!=typeof console&&console.warn&&console.warn("You did not set any plugins, parser, or stringifier. Right now, PostCSS does nothing. Pick plugins for your case on https://www.postcss.parts/ and use them in postcss.config.js."),new i["default"](this,t,e)},n.toString=function(){return e.toString()},n),r.normalize=function(t){for(var e,r=[],n=t,i=Array.isArray(n),o=0,n=i?n:n[Symbol.iterator]();;){if(i){if(o>=n.length)break;e=n[o++]}else{if((o=n.next()).done)break;e=o.value}var s=e;if(s.postcss&&(s=s.postcss),"object"===_typeof(s)&&Array.isArray(s.plugins))r=r.concat(s.plugins);else if("function"==typeof s)r.push(s);else{if("object"!==_typeof(s)||!s.parse&&!s.stringify)throw new Error(s+" is not a PostCSS plugin");if("production"!==a.env.NODE_ENV)throw new Error("PostCSS syntaxes cannot be used as plugins. Instead, please use one of the syntax/parser/stringifier options as outlined in your PostCSS runner documentation.")}}return r},t}();n["default"]=t,r.exports=n["default"]}.call(this,e("_process"))},{"./lazy-result":45,_process:63}],54:[function(t,e,r){r.__esModule=!0,r["default"]=void 0;var i=(t=t("./warning"))&&t.__esModule?t:{"default":t};function o(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}t=function(){function t(t,e,r){this.processor=t,this.messages=[],this.root=e,this.opts=r,this.css=undefined,this.map=undefined}var e,r,n=t.prototype;return n.toString=function(){return this.css},n.warn=function(t,e){(e=void 0===e?{}:e).plugin||this.lastPlugin&&this.lastPlugin.postcssPlugin&&(e.plugin=this.lastPlugin.postcssPlugin);t=new i["default"](t,e);return this.messages.push(t),t},n.warnings=function(){return this.messages.filter(function(t){return"warning"===t.type})},n=t,(e=[{key:"content",get:function(){return this.css}}])&&o(n.prototype,e),r&&o(n,r),t}();r["default"]=t,e.exports=r["default"]},{"./warning":62}],55:[function(n,t,e){e.__esModule=!0,e["default"]=void 0;var r=function(a){var t;function e(t){t=a.call(this,t)||this;return t.type="root",t.nodes||(t.nodes=[]),t}t=a,(r=e).prototype=Object.create(t.prototype),(r.prototype.constructor=r).__proto__=t;var r=e.prototype;return r.removeChild=function(t,e){var r=this.index(t);return!e&&0===r&&1<this.nodes.length&&(this.nodes[1].raws.before=this.nodes[r].raws.before),a.prototype.removeChild.call(this,t)},r.normalize=function(t,e,r){t=a.prototype.normalize.call(this,t);if(e)if("prepend"===r)1<this.nodes.length?e.raws.before=this.nodes[1].raws.before:delete e.raws.before;else if(this.first!==e)for(var n,i=t,o=Array.isArray(i),s=0,i=o?i:i[Symbol.iterator]();;){if(o){if(s>=i.length)break;n=i[s++]}else{if((s=i.next()).done)break;n=s.value}n.raws.before=e.raws.before}return t},r.toResult=function(t){return void 0===t&&(t={}),new(n("./lazy-result"))(new(n("./processor")),this,t).stringify()},e}(((r=n("./container"))&&r.__esModule?r:{"default":r})["default"]);e["default"]=r,t.exports=e["default"]},{"./container":41,"./lazy-result":45,"./processor":53}],56:[function(t,e,r){r.__esModule=!0,r["default"]=void 0;var n=i(t("./container")),o=i(t("./list"));function i(t){return t&&t.__esModule?t:{"default":t}}function s(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}t=function(e){var t,r,n;function i(t){t=e.call(this,t)||this;return t.type="rule",t.nodes||(t.nodes=[]),t}return r=e,(t=i).prototype=Object.create(r.prototype),(t.prototype.constructor=t).__proto__=r,t=i,(r=[{key:"selectors",get:function(){return o["default"].comma(this.selector)},set:function(t){var e=this.selector?this.selector.match(/,\s*/):null,e=e?e[0]:","+this.raw("between","beforeOpen");this.selector=t.join(e)}}])&&s(t.prototype,r),n&&s(t,n),i}(n["default"]);r["default"]=t,e.exports=r["default"]},{"./container":41,"./list":46}],57:[function(t,e,r){r.__esModule=!0,r["default"]=void 0;var s={colon:": ",indent:"    ",beforeDecl:"\n",beforeRule:"\n",beforeOpen:" ",beforeClose:"\n",beforeComment:"\n",after:"\n",emptyBody:"",commentLeft:" ",commentRight:" ",semicolon:!1};r["default"]=function(){function t(t){this.builder=t}var e=t.prototype;return e.stringify=function(t,e){this[t.type](t,e)},e.root=function(t){this.body(t),t.raws.after&&this.builder(t.raws.after)},e.comment=function(t){var e=this.raw(t,"left","commentLeft"),r=this.raw(t,"right","commentRight");this.builder("/*"+e+t.text+r+"*/",t)},e.decl=function(t,e){var r=this.raw(t,"between","colon"),r=t.prop+r+this.rawValue(t,"value");t.important&&(r+=t.raws.important||" !important"),e&&(r+=";"),this.builder(r,t)},e.rule=function(t){this.block(t,this.rawValue(t,"selector")),t.raws.ownSemicolon&&this.builder(t.raws.ownSemicolon,t,"end")},e.atrule=function(t,e){var r="@"+t.name,n=t.params?this.rawValue(t,"params"):"";"undefined"!=typeof t.raws.afterName?r+=t.raws.afterName:n&&(r+=" "),t.nodes?this.block(t,r+n):(e=(t.raws.between||"")+(e?";":""),this.builder(r+n+e,t))},e.body=function(t){for(var e=t.nodes.length-1;0<e&&"comment"===t.nodes[e].type;)--e;for(var r=this.raw(t,"semicolon"),n=0;n<t.nodes.length;n++){var i=t.nodes[n],o=this.raw(i,"before");o&&this.builder(o),this.stringify(i,e!==n||r)}},e.block=function(t,e){var r=this.raw(t,"between","beforeOpen");this.builder(e+r+"{",t,"start"),(e=t.nodes&&t.nodes.length?(this.body(t),this.raw(t,"after")):this.raw(t,"after","emptyBody"))&&this.builder(e),this.builder("}",t,"end")},e.raw=function(t,e,r){var n;if(r=r||e,!e||void 0===(n=t.raws[e])){var i=t.parent;if("before"===r&&(!i||"root"===i.type&&i.first===t))return"";if(!i)return s[r];i=t.root();if(i.rawCache||(i.rawCache={}),"undefined"!=typeof i.rawCache[r])return i.rawCache[r];if("before"===r||"after"===r)return this.beforeAfter(t,r);var o="raw"+((o=r)[0].toUpperCase()+o.slice(1));this[o]?n=this[o](i,t):i.walk(function(t){if(void 0!==(n=t.raws[e]))return!1}),void 0===n&&(n=s[r]),i.rawCache[r]=n}return n},e.rawSemicolon=function(t){var e;return t.walk(function(t){if(t.nodes&&t.nodes.length&&"decl"===t.last.type&&void 0!==(e=t.raws.semicolon))return!1}),e},e.rawEmptyBody=function(t){var e;return t.walk(function(t){if(t.nodes&&0===t.nodes.length&&void 0!==(e=t.raws.after))return!1}),e},e.rawIndent=function(r){var n;return r.raws.indent||(r.walk(function(t){var e=t.parent;if(e&&e!==r&&e.parent&&e.parent===r&&"undefined"!=typeof t.raws.before)return e=t.raws.before.split("\n"),n=(n=e[e.length-1]).replace(/[^\s]/g,""),!1}),n)},e.rawBeforeComment=function(t,e){var r;return t.walkComments(function(t){if("undefined"!=typeof t.raws.before)return-1!==(r=t.raws.before).indexOf("\n")&&(r=r.replace(/[^\n]+$/,"")),!1}),r=void 0===r?this.raw(e,null,"beforeDecl"):r&&r.replace(/[^\s]/g,"")},e.rawBeforeDecl=function(t,e){var r;return t.walkDecls(function(t){if("undefined"!=typeof t.raws.before)return-1!==(r=t.raws.before).indexOf("\n")&&(r=r.replace(/[^\n]+$/,"")),!1}),r=void 0===r?this.raw(e,null,"beforeRule"):r&&r.replace(/[^\s]/g,"")},e.rawBeforeRule=function(e){var r;return e.walk(function(t){if(t.nodes&&(t.parent!==e||e.first!==t)&&"undefined"!=typeof t.raws.before)return-1!==(r=t.raws.before).indexOf("\n")&&(r=r.replace(/[^\n]+$/,"")),!1}),r=r&&r.replace(/[^\s]/g,"")},e.rawBeforeClose=function(t){var e;return t.walk(function(t){if(t.nodes&&0<t.nodes.length&&"undefined"!=typeof t.raws.after)return-1!==(e=t.raws.after).indexOf("\n")&&(e=e.replace(/[^\n]+$/,"")),!1}),e=e&&e.replace(/[^\s]/g,"")},e.rawBeforeOpen=function(t){var e;return t.walk(function(t){if("decl"!==t.type&&void 0!==(e=t.raws.between))return!1}),e},e.rawColon=function(t){var e;return t.walkDecls(function(t){if("undefined"!=typeof t.raws.between)return e=t.raws.between.replace(/[^\s:]/g,""),!1}),e},e.beforeAfter=function(t,e){for(var r="decl"===t.type?this.raw(t,null,"beforeDecl"):"comment"===t.type?this.raw(t,null,"beforeComment"):"before"===e?this.raw(t,null,"beforeRule"):this.raw(t,null,"beforeClose"),n=t.parent,i=0;n&&"root"!==n.type;)i+=1,n=n.parent;if(-1!==r.indexOf("\n")){var o=this.raw(t,null,"indent");if(o.length)for(var s=0;s<i;s++)r+=o}return r},e.rawValue=function(t,e){var r=t[e],e=t.raws[e];return e&&e.value===r?e.raw:r},t}(),e.exports=r["default"]},{}],58:[function(t,e,r){r.__esModule=!0,r["default"]=void 0;var n=(t=t("./stringifier"))&&t.__esModule?t:{"default":t};r["default"]=function(t,e){new n["default"](e).stringify(t)},e.exports=r["default"]},{"./stringifier":57}],59:[function(t,e,r){r.__esModule=!0,r["default"]=function(e,t){void 0===t&&(t={});var n,i,o,s,a,u,c,l,f,h,p,d,g,m,y=e.css.valueOf(),_=t.ignoreErrors,b=y.length,v=-1,w=1,x=0,S=[],A=[];function C(t){throw e.error("Unclosed "+t,w,x-v)}return{back:function(t){A.push(t)},nextToken:function(t){if(A.length)return A.pop();if(!(b<=x)){var e=!!t&&t.ignoreUnclosed;switch(((n=y.charCodeAt(x))===L||n===T||n===N&&y.charCodeAt(x+1)!==L)&&(v=x,w+=1),n){case L:case M:case q:case N:case T:for(i=x;i+=1,(n=y.charCodeAt(i))===L&&(v=i,w+=1),n===M||n===L||n===q||n===N||n===T;);m=["space",y.slice(x,i)],x=i-1;break;case R:case P:case B:case U:case V:case z:case D:var r=String.fromCharCode(n);m=[r,r,w,x-v];break;case I:if(d=S.length?S.pop()[1]:"",g=y.charCodeAt(x+1),"url"===d&&g!==O&&g!==E&&g!==M&&g!==L&&g!==q&&g!==T&&g!==N){i=x;do{if(h=!1,-1===(i=y.indexOf(")",i+1))){if(_||e){i=x;break}C("bracket")}for(p=i;y.charCodeAt(p-1)===k;)--p,h=!h}while(h);m=["brackets",y.slice(x,i+1),w,x-v,w,i-v],x=i}else i=y.indexOf(")",x+1),u=y.slice(x,i+1),-1===i||W.test(u)?m=["(","(",w,x-v]:(m=["brackets",u,w,x-v,w,i-v],x=i);break;case O:case E:o=n===O?"'":'"',i=x;do{if(h=!1,-1===(i=y.indexOf(o,i+1))){if(_||e){i=x+1;break}C("string")}for(p=i;y.charCodeAt(p-1)===k;)--p,h=!h}while(h);u=y.slice(x,i+1),s=u.split("\n"),a=s.length-1,f=0<a?(l=w+a,i-s[a].length):(l=w,v),m=["string",y.slice(x,i+1),w,x-v,l,i-f],v=f,w=l,x=i;break;case H:G.lastIndex=x+1,G.test(y),i=0===G.lastIndex?y.length-1:G.lastIndex-2,m=["at-word",y.slice(x,i+1),w,x-v,w,i-v],x=i;break;case k:for(i=x,c=!0;y.charCodeAt(i+1)===k;)i+=1,c=!c;if(n=y.charCodeAt(i+1),c&&n!==j&&n!==M&&n!==L&&n!==q&&n!==N&&n!==T&&(i+=1,J.test(y.charAt(i)))){for(;J.test(y.charAt(i+1));)i+=1;y.charCodeAt(i+1)===M&&(i+=1)}m=["word",y.slice(x,i+1),w,x-v,w,i-v],x=i;break;default:x=(n===j&&y.charCodeAt(x+1)===F?(0===(i=y.indexOf("*/",x+2)+1)&&(_||e?i=y.length:C("comment")),u=y.slice(x,i+1),s=u.split("\n"),a=s.length-1,f=0<a?(l=w+a,i-s[a].length):(l=w,v),m=["comment",u,w,x-v,l,i-f],v=f,w=l):($.lastIndex=x+1,$.test(y),i=0===$.lastIndex?y.length-1:$.lastIndex-2,m=["word",y.slice(x,i+1),w,x-v,w,i-v],S.push(m)),i)}return x++,m}},endOfFile:function(){return 0===A.length&&b<=x},position:function(){return x}}};var O="'".charCodeAt(0),E='"'.charCodeAt(0),k="\\".charCodeAt(0),j="/".charCodeAt(0),L="\n".charCodeAt(0),M=" ".charCodeAt(0),T="\f".charCodeAt(0),q="\t".charCodeAt(0),N="\r".charCodeAt(0),R="[".charCodeAt(0),P="]".charCodeAt(0),I="(".charCodeAt(0),D=")".charCodeAt(0),B="{".charCodeAt(0),U="}".charCodeAt(0),z=";".charCodeAt(0),F="*".charCodeAt(0),V=":".charCodeAt(0),H="@".charCodeAt(0),G=/[ \n\t\r\f{}()'"\\;/[\]#]/g,$=/[ \n\t\r\f(){}:;@!'"\\\][#]|\/(?=\*)/g,W=/.[\\/("'\n]/,J=/[a-f0-9]/i;e.exports=r["default"]},{}],60:[function(t,e,r){r.__esModule=!0,r["default"]=void 0;r["default"]={prefix:function(t){t=t.match(/^(-\w+-)/);return t?t[0]:""},unprefixed:function(t){return t.replace(/^-\w+-/,"")}},e.exports=r["default"]},{}],61:[function(t,e,r){r.__esModule=!0,r["default"]=function(t){n[t]||(n[t]=!0,"undefined"!=typeof console&&console.warn&&console.warn(t))};var n={};e.exports=r["default"]},{}],62:[function(t,e,r){r.__esModule=!0,r["default"]=void 0;var n=function(){function t(t,e){for(var r in void 0===e&&(e={}),this.type="warning",this.text=t,e.node&&e.node.source&&(t=e.node.positionBy(e),this.line=t.line,this.column=t.column),e)this[r]=e[r]}return t.prototype.toString=function(){return this.node?this.node.error(this.text,{plugin:this.plugin,index:this.index,word:this.word}).message:this.plugin?this.plugin+": "+this.text:this.text},t}();r["default"]=n,e.exports=r["default"]},{}],63:[function(t,e,r){var n,i,e=e.exports={};function o(){throw new Error("setTimeout has not been defined")}function s(){throw new Error("clearTimeout has not been defined")}try{n="function"==typeof setTimeout?setTimeout:o}catch(m){n=o}try{i="function"==typeof clearTimeout?clearTimeout:s}catch(m){i=s}function a(t){if(n===setTimeout)return setTimeout(t,0);if((n===o||!n)&&setTimeout)return(n=setTimeout)(t,0);try{return n(t,0)}catch(e){try{return n.call(null,t,0)}catch(e){return n.call(this,t,0)}}}var u,c=[],l=!1,f=-1;function h(){l&&u&&(l=!1,u.length?c=u.concat(c):f=-1,c.length)&&p()}function p(){if(!l){for(var t=a(h),e=(l=!0,c.length);e;){for(u=c,c=[];++f<e;)u&&u[f].run();f=-1,e=c.length}u=null,l=!1,!function(t){if(i===clearTimeout)return clearTimeout(t);if((i===s||!i)&&clearTimeout)return(i=clearTimeout)(t);try{i(t)}catch(e){try{return i.call(null,t)}catch(e){return i.call(this,t)}}}(t)}}function d(t,e){this.fun=t,this.array=e}function g(){}e.nextTick=function(t){var e=new Array(arguments.length-1);if(1<arguments.length)for(var r=1;r<arguments.length;r++)e[r-1]=arguments[r];c.push(new d(t,e)),1!==c.length||l||a(p)},d.prototype.run=function(){this.fun.apply(null,this.array)},e.title="browser",e.browser=!0,e.env={},e.argv=[],e.version="",e.versions={},e.on=g,e.addListener=g,e.once=g,e.off=g,e.removeListener=g,e.removeAllListeners=g,e.emit=g,e.prependListener=g,e.prependOnceListener=g,e.listeners=function(t){return[]},e.binding=function(t){throw new Error("process.binding is not supported")},e.cwd=function(){return"/"},e.chdir=function(t){throw new Error("process.chdir is not supported")},e.umask=function(){return 0}},{}],64:[function(t,E,k){!function(t){var e=this,r="object"==_typeof(k)&&k&&!k.nodeType&&k,n="object"==_typeof(E)&&E&&!E.nodeType&&E,t="object"==_typeof(t)&&t;t.global!==t&&t.window!==t&&t.self!==t||(e=t);var i,o,m=2147483647,y=36,_=26,s=38,a=700,u=/^xn--/,c=/[^\x20-\x7E]/,l=/[\x2E\u3002\uFF0E\uFF61]/g,f={overflow:"Overflow: input needs wider integers to process","not-basic":"Illegal input >= 0x80 (not a basic code point)","invalid-input":"Invalid input"},h=y-1,b=Math.floor,v=String.fromCharCode;function w(t){throw new RangeError(f[t])}function p(t,e){for(var r=t.length,n=[];r--;)n[r]=e(t[r]);return n}function d(t,e){var r=t.split("@"),n="",r=(1<r.length&&(n=r[0]+"@",t=r[1]),(t=t.replace(l,".")).split("."));return n+p(r,e).join(".")}function x(t){for(var e,r,n=[],i=0,o=t.length;i<o;)55296<=(e=t.charCodeAt(i++))&&e<=56319&&i<o?56320==(64512&(r=t.charCodeAt(i++)))?n.push(((1023&e)<<10)+(1023&r)+65536):(n.push(e),i--):n.push(e);return n}function g(t){return p(t,function(t){var e="";return 65535<t&&(e+=v((t-=65536)>>>10&1023|55296),t=56320|1023&t),e+=v(t)}).join("")}function S(t,e){return t+22+75*(t<26)-((0!=e)<<5)}function A(t,e,r){var n=0;for(t=r?b(t/a):t>>1,t+=b(t/e);h*_>>1<t;n+=y)t=b(t/h);return b(n+(h+1)*t/(t+s))}function C(t){var e,r,n,i,o,s,a,u=[],c=t.length,l=0,f=128,h=72,p=t.lastIndexOf("-");for(p<0&&(p=0),r=0;r<p;++r)128<=t.charCodeAt(r)&&w("not-basic"),u.push(t.charCodeAt(r));for(n=0<p?p+1:0;n<c;){for(i=l,o=1,s=y;c<=n&&w("invalid-input"),a=t.charCodeAt(n++),(y<=(a=a-48<10?a-22:a-65<26?a-65:a-97<26?a-97:y)||a>b((m-l)/o))&&w("overflow"),l+=a*o,!(a<(a=s<=h?1:h+_<=s?_:s-h));s+=y)o>b(m/(a=y-a))&&w("overflow"),o*=a;h=A(l-i,e=u.length+1,0==i),b(l/e)>m-f&&w("overflow"),f+=b(l/e),l%=e,u.splice(l++,0,f)}return g(u)}function O(t){for(var e,r,n,i,o,s,a,u,c,l,f=[],h=(t=x(t)).length,p=128,d=72,g=e=0;g<h;++g)(a=t[g])<128&&f.push(v(a));for(r=n=f.length,n&&f.push("-");r<h;){for(i=m,g=0;g<h;++g)p<=(a=t[g])&&a<i&&(i=a);for(i-p>b((m-e)/(u=r+1))&&w("overflow"),e+=(i-p)*u,p=i,g=0;g<h;++g)if((a=t[g])<p&&++e>m&&w("overflow"),a==p){for(o=e,s=y;!(o<(c=s<=d?1:d+_<=s?_:s-d));s+=y)f.push(v(S(c+(l=o-c)%(c=y-c),0))),o=b(l/c);f.push(v(S(o,0))),d=A(e,u,r==n),e=0,++r}++e,++p}return f.join("")}if(i={version:"1.4.1",ucs2:{decode:x,encode:g},decode:C,encode:O,toASCII:function(t){return d(t,function(t){return c.test(t)?"xn--"+O(t):t})},toUnicode:function(t){return d(t,function(t){return u.test(t)?C(t.slice(4).toLowerCase()):t})}},r&&n)if(E.exports==r)n.exports=i;else for(o in i)i.hasOwnProperty(o)&&(r[o]=i[o]);else e.punycode=i}.call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],65:[function(t,e,r){e.exports=function(t,e,r,n){e=e||"&",r=r||"=";var i={};if("string"==typeof t&&0!==t.length){var o=/\+/g,e=(t=t.split(e),1e3),s=(n&&"number"==typeof n.maxKeys&&(e=n.maxKeys),t.length);0<e&&e<s&&(s=e);for(var a=0;a<s;++a){var u,c=t[a].replace(o,"%20"),l=c.indexOf(r),l=0<=l?(u=c.substr(0,l),c.substr(l+1)):(u=c,""),c=decodeURIComponent(u),l=decodeURIComponent(l);Object.prototype.hasOwnProperty.call(i,c)?f(i[c])?i[c].push(l):i[c]=[i[c],l]:i[c]=l}}return i};var f=Array.isArray||function(t){return"[object Array]"===Object.prototype.toString.call(t)}},{}],66:[function(t,e,r){var o=function o(t){switch(_typeof(t)){case"string":return t;case"boolean":return t?"true":"false";case"number":return isFinite(t)?t:"";default:return""}},s=(e.exports=function(r,n,i,t){return n=n||"&",i=i||"=",null===r&&(r=undefined),"object"===_typeof(r)?a(u(r),function(t){var e=encodeURIComponent(o(t))+i;return s(r[t])?a(r[t],function(t){return e+encodeURIComponent(o(t))}).join(n):e+encodeURIComponent(o(r[t]))}).join(n):t?encodeURIComponent(o(t))+i+encodeURIComponent(o(r)):""},Array.isArray||function(t){return"[object Array]"===Object.prototype.toString.call(t)});function a(t,e){if(t.map)return t.map(e);for(var r=[],n=0;n<t.length;n++)r.push(e(t[n],n));return r}var u=Object.keys||function(t){var e,r=[];for(e in t)Object.prototype.hasOwnProperty.call(t,e)&&r.push(e);return r}},{}],67:[function(t,e,r){r.decode=r.parse=t("./decode"),r.encode=r.stringify=t("./encode")},{"./decode":65,"./encode":66}],68:[function(t,e,r){var o=t("./util"),s=Object.prototype.hasOwnProperty,a="undefined"!=typeof Map;function u(){this._array=[],this._set=a?new Map:Object.create(null)}u.fromArray=function(t,e){for(var r=new u,n=0,i=t.length;n<i;n++)r.add(t[n],e);return r},u.prototype.size=function(){return a?this._set.size:Object.getOwnPropertyNames(this._set).length},u.prototype.add=function(t,e){var r=a?t:o.toSetString(t),n=a?this.has(t):s.call(this._set,r),i=this._array.length;n&&!e||this._array.push(t),n||(a?this._set.set(t,i):this._set[r]=i)},u.prototype.has=function(t){return a?this._set.has(t):(t=o.toSetString(t),s.call(this._set,t))},u.prototype.indexOf=function(t){if(a){var e=this._set.get(t);if(0<=e)return e}else{e=o.toSetString(t);if(s.call(this._set,e))return this._set[e]}throw new Error('"'+t+'" is not in the set.')},u.prototype.at=function(t){if(0<=t&&t<this._array.length)return this._array[t];throw new Error("No element indexed by "+t)},u.prototype.toArray=function(){return this._array.slice()},r.ArraySet=u},{"./util":77}],69:[function(t,e,r){var c=t("./base64");r.encode=function(t){for(var e,r="",n=(t=t)<0?1+(-t<<1):t<<1;e=31&n,0<(n>>>=5)&&(e|=32),r+=c.encode(e),0<n;);return r},r.decode=function(t,e,r){var n,i,o,s=t.length,a=0,u=0;do{if(s<=e)throw new Error("Expected more digits in base 64 VLQ value.");if(-1===(i=c.decode(t.charCodeAt(e++))))throw new Error("Invalid base64 digit: "+t.charAt(e-1))}while(n=!!(32&i),a+=(i&=31)<<u,u+=5,n);r.value=(o=a>>1,1==(1&a)?-o:o),r.rest=e}},{"./base64":70}],70:[function(t,e,r){var n="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split("");r.encode=function(t){if(0<=t&&t<n.length)return n[t];throw new TypeError("Must be between 0 and 63: "+t)},r.decode=function(t){return 65<=t&&t<=90?t-65:97<=t&&t<=122?t-97+26:48<=t&&t<=57?t-48+52:43==t?62:47==t?63:-1}},{}],71:[function(t,e,c){c.GREATEST_LOWER_BOUND=1,c.LEAST_UPPER_BOUND=2,c.search=function(t,e,r,n){if(0===e.length)return-1;var i=function u(t,e,r,n,i,o){var s=Math.floor((e-t)/2)+t,a=i(r,n[s],!0);return 0===a?s:0<a?1<e-s?u(s,e,r,n,i,o):o==c.LEAST_UPPER_BOUND?e<n.length?e:-1:s:1<s-t?u(t,s,r,n,i,o):o==c.LEAST_UPPER_BOUND?s:t<0?-1:t}(-1,e.length,t,e,r,n||c.GREATEST_LOWER_BOUND);if(i<0)return-1;for(;0<=i-1&&0===r(e[i],e[i-1],!0);)--i;return i}},{}],72:[function(t,e,r){var a=t("./util");function n(){this._array=[],this._sorted=!0,this._last={generatedLine:-1,generatedColumn:0}}n.prototype.unsortedForEach=function(t,e){this._array.forEach(t,e)},n.prototype.add=function(t){var e,r,n,i,o,s;e=this._last,r=t,n=e.generatedLine,i=r.generatedLine,o=e.generatedColumn,s=r.generatedColumn,n<i||i==n&&o<=s||a.compareByGeneratedPositionsInflated(e,r)<=0?this._last=t:this._sorted=!1,this._array.push(t)},n.prototype.toArray=function(){return this._sorted||(this._array.sort(a.compareByGeneratedPositionsInflated),this._sorted=!0),this._array},r.MappingList=n},{"./util":77}],73:[function(t,e,r){function c(t,e,r){var n=t[e];t[e]=t[r],t[r]=n}function l(t,e,r,n){if(r<n){u=n;for(var i=(a=r)-1,o=(c(t,Math.round(a+Math.random()*(u-a)),n),t[n]),s=r;s<n;s++)e(t[s],o)<=0&&c(t,i+=1,s);c(t,i+1,s);u=i+1;l(t,e,r,u-1),l(t,e,u+1,n)}var a,u}r.quickSort=function(t,e){l(t,e,0,t.length-1)}},{}],74:[function(t,e,r){var _=t("./util"),u=t("./binary-search"),h=t("./array-set").ArraySet,b=t("./base64-vlq"),v=t("./quick-sort").quickSort;function s(t,e){var r=t;return new(null!=(r="string"==typeof t?_.parseSourceMapInput(t):r).sections?n:p)(r,e)}function p(t,e){var r=t,t=("string"==typeof t&&(r=_.parseSourceMapInput(t)),_.getArg(r,"version")),n=_.getArg(r,"sources"),i=_.getArg(r,"names",[]),o=_.getArg(r,"sourceRoot",null),s=_.getArg(r,"sourcesContent",null),a=_.getArg(r,"mappings"),r=_.getArg(r,"file",null);if(t!=this._version)throw new Error("Unsupported version: "+t);o=o&&_.normalize(o),n=n.map(String).map(_.normalize).map(function(t){return o&&_.isAbsolute(o)&&_.isAbsolute(t)?_.relative(o,t):t}),this._names=h.fromArray(i.map(String),!0),this._sources=h.fromArray(n,!0),this._absoluteSources=this._sources.toArray().map(function(t){return _.computeSourceURL(o,t,e)}),this.sourceRoot=o,this.sourcesContent=s,this._mappings=a,this._sourceMapURL=e,this.file=r}function w(){this.generatedLine=0,this.generatedColumn=0,this.source=null,this.originalLine=null,this.originalColumn=null,this.name=null}function n(t,i){var e=t,t=("string"==typeof t&&(e=_.parseSourceMapInput(t)),_.getArg(e,"version")),e=_.getArg(e,"sections");if(t!=this._version)throw new Error("Unsupported version: "+t);this._sources=new h,this._names=new h;var o={line:-1,column:0};this._sections=e.map(function(t){if(t.url)throw new Error("Support for url field in sections not implemented.");var e=_.getArg(t,"offset"),r=_.getArg(e,"line"),n=_.getArg(e,"column");if(r<o.line||r===o.line&&n<o.column)throw new Error("Section offsets must be ordered and non-overlapping.");return o=e,{generatedOffset:{generatedLine:r+1,generatedColumn:n+1},consumer:new s(_.getArg(t,"map"),i)}})}s.fromSourceMap=function(t,e){return p.fromSourceMap(t,e)},s.prototype._version=3,s.prototype.__generatedMappings=null,Object.defineProperty(s.prototype,"_generatedMappings",{configurable:!0,enumerable:!0,get:function(){return this.__generatedMappings||this._parseMappings(this._mappings,this.sourceRoot),this.__generatedMappings}}),s.prototype.__originalMappings=null,Object.defineProperty(s.prototype,"_originalMappings",{configurable:!0,enumerable:!0,get:function(){return this.__originalMappings||this._parseMappings(this._mappings,this.sourceRoot),this.__originalMappings}}),s.prototype._charIsMappingSeparator=function(t,e){e=t.charAt(e);return";"===e||","===e},s.prototype._parseMappings=function(t,e){throw new Error("Subclasses must implement _parseMappings")},s.GENERATED_ORDER=1,s.ORIGINAL_ORDER=2,s.GREATEST_LOWER_BOUND=1,s.LEAST_UPPER_BOUND=2,s.prototype.eachMapping=function(t,e,r){var n,e=e||null;switch(r||s.GENERATED_ORDER){case s.GENERATED_ORDER:n=this._generatedMappings;break;case s.ORIGINAL_ORDER:n=this._originalMappings;break;default:throw new Error("Unknown order of iteration.")}var i=this.sourceRoot;n.map(function(t){var e=null===t.source?null:this._sources.at(t.source);return{source:_.computeSourceURL(i,e,this._sourceMapURL),generatedLine:t.generatedLine,generatedColumn:t.generatedColumn,originalLine:t.originalLine,originalColumn:t.originalColumn,name:null===t.name?null:this._names.at(t.name)}},this).forEach(t,e)},s.prototype.allGeneratedPositionsFor=function(t){var e=_.getArg(t,"line"),r={source:_.getArg(t,"source"),originalLine:e,originalColumn:_.getArg(t,"column",0)};if(r.source=this._findSourceIndex(r.source),r.source<0)return[];var n=[],i=this._findMapping(r,this._originalMappings,"originalLine","originalColumn",_.compareByOriginalPositions,u.LEAST_UPPER_BOUND);if(0<=i){var o=this._originalMappings[i];if(t.column===undefined)for(var s=o.originalLine;o&&o.originalLine===s;)n.push({line:_.getArg(o,"generatedLine",null),column:_.getArg(o,"generatedColumn",null),lastColumn:_.getArg(o,"lastGeneratedColumn",null)}),o=this._originalMappings[++i];else for(var a=o.originalColumn;o&&o.originalLine===e&&o.originalColumn==a;)n.push({line:_.getArg(o,"generatedLine",null),column:_.getArg(o,"generatedColumn",null),lastColumn:_.getArg(o,"lastGeneratedColumn",null)}),o=this._originalMappings[++i]}return n},r.SourceMapConsumer=s,(p.prototype=Object.create(s.prototype)).consumer=s,p.prototype._findSourceIndex=function(t){var e,r=t;if(null!=this.sourceRoot&&(r=_.relative(this.sourceRoot,r)),this._sources.has(r))return this._sources.indexOf(r);for(e=0;e<this._absoluteSources.length;++e)if(this._absoluteSources[e]==t)return e;return-1},p.fromSourceMap=function(t,e){for(var r=Object.create(p.prototype),n=r._names=h.fromArray(t._names.toArray(),!0),i=r._sources=h.fromArray(t._sources.toArray(),!0),o=(r.sourceRoot=t._sourceRoot,r.sourcesContent=t._generateSourcesContent(r._sources.toArray(),r.sourceRoot),r.file=t._file,r._sourceMapURL=e,r._absoluteSources=r._sources.toArray().map(function(t){return _.computeSourceURL(r.sourceRoot,t,e)}),t._mappings.toArray().slice()),s=r.__generatedMappings=[],a=r.__originalMappings=[],u=0,c=o.length;u<c;u++){var l=o[u],f=new w;f.generatedLine=l.generatedLine,f.generatedColumn=l.generatedColumn,l.source&&(f.source=i.indexOf(l.source),f.originalLine=l.originalLine,f.originalColumn=l.originalColumn,l.name&&(f.name=n.indexOf(l.name)),a.push(f)),s.push(f)}return v(r.__originalMappings,_.compareByOriginalPositions),r},p.prototype._version=3,Object.defineProperty(p.prototype,"sources",{get:function(){return this._absoluteSources.slice()}}),p.prototype._parseMappings=function(t,e){for(var r,n,i,o,s=1,a=0,u=0,c=0,l=0,f=0,h=t.length,p=0,d={},g={},m=[],y=[];p<h;)if(";"===t.charAt(p))s++,p++,a=0;else if(","===t.charAt(p))p++;else{for((r=new w).generatedLine=s,o=p;o<h&&!this._charIsMappingSeparator(t,o);o++);if(i=d[n=t.slice(p,o)])p+=n.length;else{for(i=[];p<o;)b.decode(t,p,g),p=g.rest,i.push(g.value);if(2===i.length)throw new Error("Found a source, but no line and column");if(3===i.length)throw new Error("Found a source and line, but no column");d[n]=i}r.generatedColumn=a+i[0],a=r.generatedColumn,1<i.length&&(r.source=l+i[1],l+=i[1],r.originalLine=u+i[2],u=r.originalLine,r.originalLine+=1,r.originalColumn=c+i[3],c=r.originalColumn,4<i.length)&&(r.name=f+i[4],f+=i[4]),y.push(r),"number"==typeof r.originalLine&&m.push(r)}v(y,_.compareByGeneratedPositionsDeflated),this.__generatedMappings=y,v(m,_.compareByOriginalPositions),this.__originalMappings=m},p.prototype._findMapping=function(t,e,r,n,i,o){if(t[r]<=0)throw new TypeError("Line must be greater than or equal to 1, got "+t[r]);if(t[n]<0)throw new TypeError("Column must be greater than or equal to 0, got "+t[n]);return u.search(t,e,i,o)},p.prototype.computeColumnSpans=function(){for(var t=0;t<this._generatedMappings.length;++t){var e=this._generatedMappings[t];if(t+1<this._generatedMappings.length){var r=this._generatedMappings[t+1];if(e.generatedLine===r.generatedLine){e.lastGeneratedColumn=r.generatedColumn-1;continue}}e.lastGeneratedColumn=Infinity}},p.prototype.originalPositionFor=function(t){var e={generatedLine:_.getArg(t,"line"),generatedColumn:_.getArg(t,"column")},t=this._findMapping(e,this._generatedMappings,"generatedLine","generatedColumn",_.compareByGeneratedPositionsDeflated,_.getArg(t,"bias",s.GREATEST_LOWER_BOUND));if(0<=t){var r,t=this._generatedMappings[t];if(t.generatedLine===e.generatedLine)return null!==(e=_.getArg(t,"source",null))&&(e=this._sources.at(e),e=_.computeSourceURL(this.sourceRoot,e,this._sourceMapURL)),null!==(r=_.getArg(t,"name",null))&&(r=this._names.at(r)),{source:e,line:_.getArg(t,"originalLine",null),column:_.getArg(t,"originalColumn",null),name:r}}return{source:null,line:null,column:null,name:null}},p.prototype.hasContentsOfAllSources=function(){return!!this.sourcesContent&&this.sourcesContent.length>=this._sources.size()&&!this.sourcesContent.some(function(t){return null==t})},p.prototype.sourceContentFor=function(t,e){if(!this.sourcesContent)return null;var r=this._findSourceIndex(t);if(0<=r)return this.sourcesContent[r];var n,r=t;if(null!=this.sourceRoot&&(r=_.relative(this.sourceRoot,r)),null!=this.sourceRoot&&(n=_.urlParse(this.sourceRoot))){t=r.replace(/^file:\/\//,"");if("file"==n.scheme&&this._sources.has(t))return this.sourcesContent[this._sources.indexOf(t)];if((!n.path||"/"==n.path)&&this._sources.has("/"+r))return this.sourcesContent[this._sources.indexOf("/"+r)]}if(e)return null;throw new Error('"'+r+'" is not in the SourceMap.')},p.prototype.generatedPositionFor=function(t){var e=_.getArg(t,"source"),e=this._findSourceIndex(e);if(!(e<0)){e={source:e,originalLine:_.getArg(t,"line"),originalColumn:_.getArg(t,"column")},t=this._findMapping(e,this._originalMappings,"originalLine","originalColumn",_.compareByOriginalPositions,_.getArg(t,"bias",s.GREATEST_LOWER_BOUND));if(0<=t){t=this._originalMappings[t];if(t.source===e.source)return{line:_.getArg(t,"generatedLine",null),column:_.getArg(t,"generatedColumn",null),lastColumn:_.getArg(t,"lastGeneratedColumn",null)}}}return{line:null,column:null,lastColumn:null}},r.BasicSourceMapConsumer=p,(n.prototype=Object.create(s.prototype)).constructor=s,n.prototype._version=3,Object.defineProperty(n.prototype,"sources",{get:function(){for(var t=[],e=0;e<this._sections.length;e++)for(var r=0;r<this._sections[e].consumer.sources.length;r++)t.push(this._sections[e].consumer.sources[r]);return t}}),n.prototype.originalPositionFor=function(t){var e={generatedLine:_.getArg(t,"line"),generatedColumn:_.getArg(t,"column")},r=u.search(e,this._sections,function(t,e){var r=t.generatedLine-e.generatedOffset.generatedLine;return r||t.generatedColumn-e.generatedOffset.generatedColumn}),r=this._sections[r];return r?r.consumer.originalPositionFor({line:e.generatedLine-(r.generatedOffset.generatedLine-1),column:e.generatedColumn-(r.generatedOffset.generatedLine===e.generatedLine?r.generatedOffset.generatedColumn-1:0),bias:t.bias}):{source:null,line:null,column:null,name:null}},n.prototype.hasContentsOfAllSources=function(){return this._sections.every(function(t){return t.consumer.hasContentsOfAllSources()})},n.prototype.sourceContentFor=function(t,e){for(var r=0;r<this._sections.length;r++){var n=this._sections[r].consumer.sourceContentFor(t,!0);if(n)return n}if(e)return null;throw new Error('"'+t+'" is not in the SourceMap.')},n.prototype.generatedPositionFor=function(t){for(var e=0;e<this._sections.length;e++){var r=this._sections[e];if(-1!==r.consumer._findSourceIndex(_.getArg(t,"source"))){var n=r.consumer.generatedPositionFor(t);if(n)return{line:n.line+(r.generatedOffset.generatedLine-1),column:n.column+(r.generatedOffset.generatedLine===n.line?r.generatedOffset.generatedColumn-1:0)}}}return{line:null,column:null}},n.prototype._parseMappings=function(t,e){this.__generatedMappings=[],this.__originalMappings=[];for(var r=0;r<this._sections.length;r++)for(var n=this._sections[r],i=n.consumer._generatedMappings,o=0;o<i.length;o++){var s=i[o],a=n.consumer._sources.at(s.source),a=_.computeSourceURL(n.consumer.sourceRoot,a,this._sourceMapURL),u=(this._sources.add(a),a=this._sources.indexOf(a),null),a=(s.name&&(u=n.consumer._names.at(s.name),this._names.add(u),u=this._names.indexOf(u)),{source:a,generatedLine:s.generatedLine+(n.generatedOffset.generatedLine-1),generatedColumn:s.generatedColumn+(n.generatedOffset.generatedLine===s.generatedLine?n.generatedOffset.generatedColumn-1:0),originalLine:s.originalLine,originalColumn:s.originalColumn,name:u});this.__generatedMappings.push(a),"number"==typeof a.originalLine&&this.__originalMappings.push(a)}v(this.__generatedMappings,_.compareByGeneratedPositionsDeflated),v(this.__originalMappings,_.compareByOriginalPositions)},r.IndexedSourceMapConsumer=n},{"./array-set":68,"./base64-vlq":69,"./binary-search":71,"./quick-sort":73,"./util":77}],75:[function(t,e,r){var p=t("./base64-vlq"),d=t("./util"),u=t("./array-set").ArraySet,n=t("./mapping-list").MappingList;function o(t){this._file=d.getArg(t=t||{},"file",null),this._sourceRoot=d.getArg(t,"sourceRoot",null),this._skipValidation=d.getArg(t,"skipValidation",!1),this._sources=new u,this._names=new u,this._mappings=new n,this._sourcesContents=null}o.prototype._version=3,o.fromSourceMap=function(r){var n=r.sourceRoot,i=new o({file:r.file,sourceRoot:n});return r.eachMapping(function(t){var e={generated:{line:t.generatedLine,column:t.generatedColumn}};null!=t.source&&(e.source=t.source,null!=n&&(e.source=d.relative(n,e.source)),e.original={line:t.originalLine,column:t.originalColumn},null!=t.name)&&(e.name=t.name),i.addMapping(e)}),r.sources.forEach(function(t){var e=t,e=(null!==n&&(e=d.relative(n,t)),i._sources.has(e)||i._sources.add(e),r.sourceContentFor(t));null!=e&&i.setSourceContent(t,e)}),i},o.prototype.addMapping=function(t){var e=d.getArg(t,"generated"),r=d.getArg(t,"original",null),n=d.getArg(t,"source",null),t=d.getArg(t,"name",null);this._skipValidation||this._validateMapping(e,r,n,t),null!=n&&(n=String(n),this._sources.has(n)||this._sources.add(n)),null!=t&&(t=String(t),this._names.has(t)||this._names.add(t)),this._mappings.add({generatedLine:e.line,generatedColumn:e.column,originalLine:null!=r&&r.line,originalColumn:null!=r&&r.column,source:n,name:t})},o.prototype.setSourceContent=function(t,e){null!=this._sourceRoot&&(t=d.relative(this._sourceRoot,t)),null!=e?(this._sourcesContents||(this._sourcesContents=Object.create(null)),this._sourcesContents[d.toSetString(t)]=e):this._sourcesContents&&(delete this._sourcesContents[d.toSetString(t)],0===Object.keys(this._sourcesContents).length)&&(this._sourcesContents=null)},o.prototype.applySourceMap=function(r,t,n){var i=t;if(null==t){if(null==r.file)throw new Error('SourceMapGenerator.prototype.applySourceMap requires either an explicit source file, or the source map\'s "file" property. Both were omitted.');i=r.file}var o=this._sourceRoot,s=(null!=o&&(i=d.relative(o,i)),new u),a=new u;this._mappings.unsortedForEach(function(t){t.source===i&&null!=t.originalLine&&null!=(e=r.originalPositionFor({line:t.originalLine,column:t.originalColumn})).source&&(t.source=e.source,null!=n&&(t.source=d.join(n,t.source)),null!=o&&(t.source=d.relative(o,t.source)),t.originalLine=e.line,t.originalColumn=e.column,null!=e.name)&&(t.name=e.name);var e=t.source,e=(null==e||s.has(e)||s.add(e),t.name);null==e||a.has(e)||a.add(e)},this),this._sources=s,this._names=a,r.sources.forEach(function(t){var e=r.sourceContentFor(t);null!=e&&(null!=n&&(t=d.join(n,t)),null!=o&&(t=d.relative(o,t)),this.setSourceContent(t,e))},this)},o.prototype._validateMapping=function(t,e,r,n){if(e&&"number"!=typeof e.line&&"number"!=typeof e.column)throw new Error("original.line and original.column are not numbers -- you probably meant to omit the original mapping entirely and only map the generated position. If so, pass null for the original mapping instead of an object with empty or null values.");if((!(t&&"line"in t&&"column"in t&&0<t.line&&0<=t.column)||e||r||n)&&!(t&&"line"in t&&"column"in t&&e&&"line"in e&&"column"in e&&0<t.line&&0<=t.column&&0<e.line&&0<=e.column&&r))throw new Error("Invalid mapping: "+JSON.stringify({generated:t,source:r,original:e,name:n}))},o.prototype._serializeMappings=function(){for(var t,e,r,n=0,i=1,o=0,s=0,a=0,u=0,c="",l=this._mappings.toArray(),f=0,h=l.length;f<h;f++){if(t="",(e=l[f]).generatedLine!==i)for(n=0;e.generatedLine!==i;)t+=";",i++;else if(0<f){if(!d.compareByGeneratedPositionsInflated(e,l[f-1]))continue;t+=","}t+=p.encode(e.generatedColumn-n),n=e.generatedColumn,null!=e.source&&(r=this._sources.indexOf(e.source),t+=p.encode(r-u),u=r,t+=p.encode(e.originalLine-1-s),s=e.originalLine-1,t+=p.encode(e.originalColumn-o),o=e.originalColumn,null!=e.name)&&(r=this._names.indexOf(e.name),t+=p.encode(r-a),a=r),c+=t}return c},o.prototype._generateSourcesContent=function(t,e){return t.map(function(t){if(!this._sourcesContents)return null;null!=e&&(t=d.relative(e,t));t=d.toSetString(t);return Object.prototype.hasOwnProperty.call(this._sourcesContents,t)?this._sourcesContents[t]:null},this)},o.prototype.toJSON=function(){var t={version:this._version,sources:this._sources.toArray(),names:this._names.toArray(),mappings:this._serializeMappings()};return null!=this._file&&(t.file=this._file),null!=this._sourceRoot&&(t.sourceRoot=this._sourceRoot),this._sourcesContents&&(t.sourcesContent=this._generateSourcesContent(t.sources,t.sourceRoot)),t},o.prototype.toString=function(){return JSON.stringify(this.toJSON())},r.SourceMapGenerator=o},{"./array-set":68,"./base64-vlq":69,"./mapping-list":72,"./util":77}],76:[function(t,e,r){var n=t("./source-map-generator").SourceMapGenerator,h=t("./util"),p=/(\r?\n)/,o="$$$isSourceNode$$$";function d(t,e,r,n,i){this.children=[],this.sourceContents={},this.line=null==t?null:t,this.column=null==e?null:e,this.source=null==r?null:r,this.name=null==i?null:i,this[o]=!0,null!=n&&this.add(n)}d.fromStringWithSourceMap=function(t,r,n){var i=new d,o=t.split(p),s=0,a=function a(){return t()+(t()||"");function t(){return s<o.length?o[s++]:undefined}},u=1,c=0,l=null;return r.eachMapping(function(t){if(null!==l){var e;if(!(u<t.generatedLine))return e=(r=o[s]||"").substr(0,t.generatedColumn-c),o[s]=r.substr(t.generatedColumn-c),c=t.generatedColumn,f(l,e),void(l=t);f(l,a()),u++,c=0}for(;u<t.generatedLine;)i.add(a()),u++;var r;c<t.generatedColumn&&(r=o[s]||"",i.add(r.substr(0,t.generatedColumn)),o[s]=r.substr(t.generatedColumn),c=t.generatedColumn),l=t},this),s<o.length&&(l&&f(l,a()),i.add(o.splice(s).join(""))),r.sources.forEach(function(t){var e=r.sourceContentFor(t);null!=e&&(null!=n&&(t=h.join(n,t)),i.setSourceContent(t,e))}),i;function f(t,e){var r;null===t||t.source===undefined?i.add(e):(r=n?h.join(n,t.source):t.source,i.add(new d(t.originalLine,t.originalColumn,r,e,t.name)))}},d.prototype.add=function(t){if(Array.isArray(t))t.forEach(function(t){this.add(t)},this);else{if(!t[o]&&"string"!=typeof t)throw new TypeError("Expected a SourceNode, string, or an array of SourceNodes and strings. Got "+t);t&&this.children.push(t)}return this},d.prototype.prepend=function(t){if(Array.isArray(t))for(var e=t.length-1;0<=e;e--)this.prepend(t[e]);else{if(!t[o]&&"string"!=typeof t)throw new TypeError("Expected a SourceNode, string, or an array of SourceNodes and strings. Got "+t);this.children.unshift(t)}return this},d.prototype.walk=function(t){for(var e,r=0,n=this.children.length;r<n;r++)(e=this.children[r])[o]?e.walk(t):""!==e&&t(e,{source:this.source,line:this.line,column:this.column,name:this.name})},d.prototype.join=function(t){var e,r,n=this.children.length;if(0<n){for(e=[],r=0;r<n-1;r++)e.push(this.children[r]),e.push(t);e.push(this.children[r]),this.children=e}return this},d.prototype.replaceRight=function(t,e){var r=this.children[this.children.length-1];return r[o]?r.replaceRight(t,e):"string"==typeof r?this.children[this.children.length-1]=r.replace(t,e):this.children.push("".replace(t,e)),this},d.prototype.setSourceContent=function(t,e){this.sourceContents[h.toSetString(t)]=e},d.prototype.walkSourceContents=function(t){for(var e=0,r=this.children.length;e<r;e++)this.children[e][o]&&this.children[e].walkSourceContents(t);for(var n=Object.keys(this.sourceContents),e=0,r=n.length;e<r;e++)t(h.fromSetString(n[e]),this.sourceContents[n[e]])},d.prototype.toString=function(){var e="";return this.walk(function(t){e+=t}),e},d.prototype.toStringWithSourceMap=function(t){var i={code:"",line:1,column:0},o=new n(t),s=!1,a=null,u=null,c=null,l=null;return this.walk(function(t,e){i.code+=t,null!==e.source&&null!==e.line&&null!==e.column?(a===e.source&&u===e.line&&c===e.column&&l===e.name||o.addMapping({source:e.source,original:{line:e.line,column:e.column},generated:{line:i.line,column:i.column},name:e.name}),a=e.source,u=e.line,c=e.column,l=e.name,s=!0):s&&(o.addMapping({generated:{line:i.line,column:i.column}}),a=null,s=!1);for(var r=0,n=t.length;r<n;r++)10===t.charCodeAt(r)?(i.line++,i.column=0,r+1===n?(a=null,s=!1):s&&o.addMapping({source:e.source,original:{line:e.line,column:e.column},generated:{line:i.line,column:i.column},name:e.name})):i.column++}),this.walkSourceContents(function(t,e){o.setSourceContent(t,e)}),{code:i.code,map:o}},r.SourceNode=d},{"./source-map-generator":75,"./util":77}],77:[function(t,e,a){a.getArg=function(t,e,r){if(e in t)return t[e];if(3===arguments.length)return r;throw new Error('"'+e+'" is a required argument.')};var r=/^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.-]*)(?::(\d+))?(.*)$/,i=/^data:.+\,.+$/;function u(t){t=t.match(r);return t?{scheme:t[1],auth:t[2],host:t[3],port:t[4],path:t[5]}:null}function c(t){var e="";return t.scheme&&(e+=t.scheme+":"),e+="//",t.auth&&(e+=t.auth+"@"),t.host&&(e+=t.host),t.port&&(e+=":"+t.port),t.path&&(e+=t.path),e}function o(t){var e=t,r=u(t);if(r){if(!r.path)return t;e=r.path}for(var n,t=a.isAbsolute(e),i=e.split(/\/+/),o=0,s=i.length-1;0<=s;s--)"."===(n=i[s])?i.splice(s,1):".."===n?o++:0<o&&(""===n?(i.splice(s+1,o),o=0):(i.splice(s,2),o--));return""===(e=i.join("/"))&&(e=t?"/":"."),r?(r.path=e,c(r)):e}function n(t,e){""===t&&(t=".");var r=u(e=""===e?".":e),n=u(t);return n&&(t=n.path||"/"),r&&!r.scheme?(n&&(r.scheme=n.scheme),c(r)):r||e.match(i)?e:!n||n.host||n.path?(r="/"===e.charAt(0)?e:o(t.replace(/\/+$/,"")+"/"+e),n?(n.path=r,c(n)):r):(n.host=e,c(n))}a.urlParse=u,a.urlGenerate=c,a.normalize=o,a.join=n,a.isAbsolute=function(t){return"/"===t.charAt(0)||r.test(t)},a.relative=function(t,e){t=(t=""===t?".":t).replace(/\/$/,"");for(var r=0;0!==e.indexOf(t+"/");){var n=t.lastIndexOf("/");if(n<0)return e;if((t=t.slice(0,n)).match(/^([^\/]+:\/)?\/*$/))return e;++r}return Array(r+1).join("../")+e.substr(t.length+1)};var s=!("__proto__"in Object.create(null));function l(t){return t}function f(t){if(t){var e=t.length;if(!(e<9)&&95===t.charCodeAt(e-1)&&95===t.charCodeAt(e-2)&&111===t.charCodeAt(e-3)&&116===t.charCodeAt(e-4)&&111===t.charCodeAt(e-5)&&114===t.charCodeAt(e-6)&&112===t.charCodeAt(e-7)&&95===t.charCodeAt(e-8)&&95===t.charCodeAt(e-9)){for(var r=e-10;0<=r;r--)if(36!==t.charCodeAt(r))return;return 1}}}function h(t,e){return t===e?0:null===t||null!==e&&e<t?1:-1}a.toSetString=s?l:function(t){return f(t)?"$"+t:t},a.fromSetString=s?l:function(t){return f(t)?t.slice(1):t},a.compareByOriginalPositions=function(t,e,r){var n=h(t.source,e.source);return 0!==n||0!=(n=t.originalLine-e.originalLine)||0!=(n=t.originalColumn-e.originalColumn)||r||0!=(n=t.generatedColumn-e.generatedColumn)||0!=(n=t.generatedLine-e.generatedLine)?n:h(t.name,e.name)},a.compareByGeneratedPositionsDeflated=function(t,e,r){var n=t.generatedLine-e.generatedLine;return 0!=n||0!=(n=t.generatedColumn-e.generatedColumn)||r||0!==(n=h(t.source,e.source))||0!=(n=t.originalLine-e.originalLine)||0!=(n=t.originalColumn-e.originalColumn)?n:h(t.name,e.name)},a.compareByGeneratedPositionsInflated=function(t,e){var r=t.generatedLine-e.generatedLine;return 0!=r||0!=(r=t.generatedColumn-e.generatedColumn)||0!==(r=h(t.source,e.source))||0!=(r=t.originalLine-e.originalLine)||0!=(r=t.originalColumn-e.originalColumn)?r:h(t.name,e.name)},a.parseSourceMapInput=function(t){return JSON.parse(t.replace(/^\)]}'[^\n]*\n/,""))},a.computeSourceURL=function(t,e,r){if(e=e||"",t&&("/"!==t[t.length-1]&&"/"!==e[0]&&(t+="/"),e=t+e),r){t=u(r);if(!t)throw new Error("sourceMapURL could not be parsed");t.path&&0<=(r=t.path.lastIndexOf("/"))&&(t.path=t.path.substring(0,r+1)),e=n(c(t),e)}return o(e)}},{}],78:[function(t,e,r){r.SourceMapGenerator=t("./lib/source-map-generator").SourceMapGenerator,r.SourceMapConsumer=t("./lib/source-map-consumer").SourceMapConsumer,r.SourceNode=t("./lib/source-node").SourceNode},{"./lib/source-map-consumer":74,"./lib/source-map-generator":75,"./lib/source-node":76}],79:[function(t,e,r){var s=/^\d+$/;r.parse=function(t){return(r=t.split(",").map(function(t){var o={};return t.trim().split(/\s+/).forEach(function(t,e){if(0===e)o.url=t;else{var e=t.slice(0,t.length-1),r=t[t.length-1],n=parseInt(e,10),i=parseFloat(e);if("w"===r&&s.test(e))o.width=n;else if("h"===r&&s.test(e))o.height=n;else{if("x"!==r||Number.isNaN(i))throw new Error("Invalid srcset descriptor: ".concat(t));o.density=i}}}),o})).sort().filter(function(t,e){return JSON.stringify(t)!==JSON.stringify(r[e-1])});var r},r.stringify=function(t){return _toConsumableArray(new Set(t.map(function(t){var e;if(t.url)return e=[t.url],t.width&&e.push("".concat(t.width,"w")),t.height&&e.push("".concat(t.height,"h")),t.density&&e.push("".concat(t.density,"x")),e.join(" ");throw new Error("URL is required")}))).join(", ")}},{}],80:[function(t,e,r){var S=t("punycode"),A=t("./util");function w(){this.protocol=null,this.slashes=null,this.auth=null,this.host=null,this.port=null,this.hostname=null,this.hash=null,this.search=null,this.query=null,this.pathname=null,this.path=null,this.href=null}r.parse=i,r.resolve=function(t,e){return i(t,!1,!0).resolve(e)},r.resolveObject=function(t,e){return t?i(t,!1,!0).resolveObject(e):e},r.format=function(t){A.isString(t)&&(t=i(t));return t instanceof w?t.format():w.prototype.format.call(t)},r.Url=w;var C=/^([a-z0-9.+-]+:)/i,n=/:[0-9]*$/,O=/^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,r=["{","}","|","\\","^","`"].concat(["<",">",'"',"`"," ","\r","\n","\t"]),E=["'"].concat(r),k=["%","/","?",";","#"].concat(E),j=["/","?","#"],L=/^[+a-z0-9A-Z_-]{0,63}$/,M=/^([+a-z0-9A-Z_-]{0,63})(.*)$/,T={javascript:!0,"javascript:":!0},q={javascript:!0,"javascript:":!0},N={http:!0,https:!0,ftp:!0,gopher:!0,file:!0,"http:":!0,"https:":!0,"ftp:":!0,"gopher:":!0,"file:":!0},R=t("querystring");function i(t,e,r){var n;return t&&A.isObject(t)&&t instanceof w?t:((n=new w).parse(t,e,r),n)}w.prototype.parse=function(t,e,r){if(!A.isString(t))throw new TypeError("Parameter 'url' must be a string, not "+_typeof(t));var n=t.indexOf("?"),n=-1!==n&&n<t.indexOf("#")?"?":"#",i=t.split(n);i[0]=i[0].replace(/\\/g,"/");var o=(o=t=i.join(n)).trim();if(!r&&1===t.split("#").length){n=O.exec(o);if(n)return this.path=o,this.href=o,this.pathname=n[1],n[2]?(this.search=n[2],this.query=e?R.parse(this.search.substr(1)):this.search.substr(1)):e&&(this.search="",this.query={}),this}var s,i=C.exec(o);if(i&&(s=(i=i[0]).toLowerCase(),this.protocol=s,o=o.substr(i.length)),!(r||i||o.match(/^\/\/[^@\/]+@[^@\/]+/))||!(v="//"===o.substr(0,2))||i&&q[i]||(o=o.substr(2),this.slashes=!0),!q[i]&&(v||i&&!N[i])){for(var a=-1,u=0;u<j.length;u++)-1!==(c=o.indexOf(j[u]))&&(-1===a||c<a)&&(a=c);-1!==(t=-1===a?o.lastIndexOf("@"):o.lastIndexOf("@",a))&&(n=o.slice(0,t),o=o.slice(t+1),this.auth=decodeURIComponent(n));for(var c,a=-1,u=0;u<k.length;u++)-1!==(c=o.indexOf(k[u]))&&(-1===a||c<a)&&(a=c);-1===a&&(a=o.length),this.host=o.slice(0,a),o=o.slice(a),this.parseHost(),this.hostname=this.hostname||"";r="["===this.hostname[0]&&"]"===this.hostname[this.hostname.length-1];if(!r)for(var l=this.hostname.split(/\./),u=0,f=l.length;u<f;u++){var h=l[u];if(h&&!h.match(L)){for(var p="",d=0,g=h.length;d<g;d++)127<h.charCodeAt(d)?p+="x":p+=h[d];if(!p.match(L)){var m=l.slice(0,u),y=l.slice(u+1),_=h.match(M);_&&(m.push(_[1]),y.unshift(_[2])),y.length&&(o="/"+y.join(".")+o),this.hostname=m.join(".");break}}}255<this.hostname.length?this.hostname="":this.hostname=this.hostname.toLowerCase(),r||(this.hostname=S.toASCII(this.hostname));var b=this.port?":"+this.port:"",v=this.hostname||"";this.host=v+b,this.href+=this.host,r&&(this.hostname=this.hostname.substr(1,this.hostname.length-2),"/"!==o[0])&&(o="/"+o)}if(!T[s])for(u=0,f=E.length;u<f;u++){var w,x=E[u];-1!==o.indexOf(x)&&((w=encodeURIComponent(x))===x&&(w=escape(x)),o=o.split(x).join(w))}i=o.indexOf("#"),-1!==i&&(this.hash=o.substr(i),o=o.slice(0,i)),t=o.indexOf("?");return-1!==t?(this.search=o.substr(t),this.query=o.substr(t+1),e&&(this.query=R.parse(this.query)),o=o.slice(0,t)):e&&(this.search="",this.query={}),o&&(this.pathname=o),N[s]&&this.hostname&&!this.pathname&&(this.pathname="/"),(this.pathname||this.search)&&(b=this.pathname||"",n=this.search||"",this.path=b+n),this.href=this.format(),this},w.prototype.format=function(){var t=this.auth||"",e=(t&&(t=(t=encodeURIComponent(t)).replace(/%3A/i,":"),t+="@"),this.protocol||""),r=this.pathname||"",n=this.hash||"",i=!1,o="",t=(this.host?i=t+this.host:this.hostname&&(i=t+(-1===this.hostname.indexOf(":")?this.hostname:"["+this.hostname+"]"),this.port)&&(i+=":"+this.port),this.query&&A.isObject(this.query)&&Object.keys(this.query).length&&(o=R.stringify(this.query)),this.search||o&&"?"+o||"");return e&&":"!==e.substr(-1)&&(e+=":"),this.slashes||(!e||N[e])&&!1!==i?(i="//"+(i||""),r&&"/"!==r.charAt(0)&&(r="/"+r)):i=i||"",n&&"#"!==n.charAt(0)&&(n="#"+n),t&&"?"!==t.charAt(0)&&(t="?"+t),e+i+(r=r.replace(/[?#]/g,function(t){return encodeURIComponent(t)}))+(t=t.replace("#","%23"))+n},w.prototype.resolve=function(t){return this.resolveObject(i(t,!1,!0)).format()},w.prototype.resolveObject=function(t){A.isString(t)&&((h=new w).parse(t,!1,!0),t=h);for(var e=new w,r=Object.keys(this),n=0;n<r.length;n++){var i=r[n];e[i]=this[i]}if(e.hash=t.hash,""!==t.href)if(t.slashes&&!t.protocol){for(var o=Object.keys(t),s=0;s<o.length;s++){var a=o[s];"protocol"!==a&&(e[a]=t[a])}N[e.protocol]&&e.hostname&&!e.pathname&&(e.path=e.pathname="/")}else if(t.protocol&&t.protocol!==e.protocol)if(N[t.protocol]){if(e.protocol=t.protocol,t.host||q[t.protocol])e.pathname=t.pathname;else{for(var u=(t.pathname||"").split("/");u.length&&!(t.host=u.shift()););t.host||(t.host=""),t.hostname||(t.hostname=""),""!==u[0]&&u.unshift(""),u.length<2&&u.unshift(""),e.pathname=u.join("/")}e.search=t.search,e.query=t.query,e.host=t.host||"",e.auth=t.auth,e.hostname=t.hostname||t.host,e.port=t.port,(e.pathname||e.search)&&(h=e.pathname||"",p=e.search||"",e.path=h+p),e.slashes=e.slashes||t.slashes}else for(var c=Object.keys(t),l=0;l<c.length;l++){var f=c[l];e[f]=t[f]}else{var h=e.pathname&&"/"===e.pathname.charAt(0),p=t.host||t.pathname&&"/"===t.pathname.charAt(0),h=p||h||e.host&&t.pathname,d=h,g=e.pathname&&e.pathname.split("/")||[],u=t.pathname&&t.pathname.split("/")||[],m=e.protocol&&!N[e.protocol];if(m&&(e.hostname="",e.port=null,e.host&&(""===g[0]?g[0]=e.host:g.unshift(e.host)),e.host="",t.protocol&&(t.hostname=null,t.port=null,t.host&&(""===u[0]?u[0]=t.host:u.unshift(t.host)),t.host=null),h=h&&(""===u[0]||""===g[0])),p)e.host=(t.host||""===t.host?t:e).host,e.hostname=(t.hostname||""===t.hostname?t:e).hostname,e.search=t.search,e.query=t.query,g=u;else if(u.length)(g=g||[]).pop(),g=g.concat(u),e.search=t.search,e.query=t.query;else if(!A.isNullOrUndefined(t.search))return m&&(e.hostname=e.host=g.shift(),v=!!(e.host&&0<e.host.indexOf("@"))&&e.host.split("@"))&&(e.auth=v.shift(),e.host=e.hostname=v.shift()),e.search=t.search,e.query=t.query,A.isNull(e.pathname)&&A.isNull(e.search)||(e.path=(e.pathname||"")+(e.search||"")),e.href=e.format(),e;if(g.length){for(var y=g.slice(-1)[0],p=(e.host||t.host||1<g.length)&&("."===y||".."===y)||""===y,_=0,b=g.length;0<=b;b--)"."===(y=g[b])?g.splice(b,1):".."===y?(g.splice(b,1),_++):_&&(g.splice(b,1),_--);if(!h&&!d)for(;_--;)g.unshift("..");!h||""===g[0]||g[0]&&"/"===g[0].charAt(0)||g.unshift(""),p&&"/"!==g.join("/").substr(-1)&&g.push("");var v,d=""===g[0]||g[0]&&"/"===g[0].charAt(0);m&&(e.hostname=e.host=!d&&g.length?g.shift():"",v=!!(e.host&&0<e.host.indexOf("@"))&&e.host.split("@"))&&(e.auth=v.shift(),e.host=e.hostname=v.shift()),(h=h||e.host&&g.length)&&!d&&g.unshift(""),g.length?e.pathname=g.join("/"):(e.pathname=null,e.path=null),A.isNull(e.pathname)&&A.isNull(e.search)||(e.path=(e.pathname||"")+(e.search||"")),e.auth=t.auth||e.auth,e.slashes=e.slashes||t.slashes}else e.pathname=null,e.search?e.path="/"+e.search:e.path=null}return e.href=e.format(),e},w.prototype.parseHost=function(){var t=this.host,e=n.exec(t);e&&(":"!==(e=e[0])&&(this.port=e.substr(1)),t=t.substr(0,t.length-e.length)),t&&(this.hostname=t)}},{"./util":81,punycode:64,querystring:67}],81:[function(t,e,r){e.exports={isString:function(t){return"string"==typeof t},isObject:function(t){return"object"===_typeof(t)&&null!==t},isNull:function(t){return null===t},isNullOrUndefined:function(t){return null==t}}},{}],82:[function(t,e,r){e.exports=function(){for(var t={},e=0;e<arguments.length;e++){var r,n=arguments[e];for(r in n)i.call(n,r)&&(t[r]=n[r])}return t};var i=Object.prototype.hasOwnProperty},{}],83:[function(t,e,r){var n=t("htmlparser2"),g=t("xtend"),m=t("lodash.escaperegexp"),L=t("lodash.clonedeep"),M=t("lodash.mergewith"),y=t("lodash.isstring"),T=t("lodash.isplainobject"),q=t("srcset"),N=t("postcss"),R=t("url");function P(e,r){e&&Object.keys(e).forEach(function(t){r(e[t],t)})}function I(t,e){return{}.hasOwnProperty.call(t,e)}function D(t,e){var r=[];return P(t,function(t){e(t)&&r.push(t)}),r}e.exports=_;var B=/^[^\0\t\n\f\r /<=>]+$/;function _(t,S,e){var A="",i="";function o(t,e){var r=this;this.tag=t,this.attribs=e||{},this.tagPosition=A.length,this.text="",this.updateParentNodeText=function(){l.length&&(l[l.length-1].text+=r.text)}}S?(S=g(_.defaults,S)).parser?S.parser=g(b,S.parser):S.parser=b:(S=_.defaults).parser=b;var C,O,s,a=S.nonTextTags||["script","style","textarea"],E=(S.allowedAttributes&&(C={},O={},P(S.allowedAttributes,function(t,e){C[e]=[];var r=[];t.forEach(function(t){y(t)&&0<=t.indexOf("*")?r.push(m(t).replace(/\\\*/g,".*")):C[e].push(t)}),O[e]=new RegExp("^("+r.join("|")+")$")})),{}),u=(P(S.allowedClasses,function(t,e){C&&(I(C,e)||(C[e]=[]),C[e].push("class")),E[e]=t}),{}),c=(P(S.transformTags,function(t,e){var r;"function"==typeof t?r=t:"string"==typeof t&&(r=_.simpleTransform(t)),"*"===e?s=r:u[e]=r}),0),l=[],f={},h={},p=!1,d=0,r=new n.Parser({onopentag:function(w,t){if(p)d++;else{var e,x=new o(w,t),r=(l.push(x),!1),n=!!x.text;if(I(u,w)&&(e=u[w](w,t),x.attribs=t=e.attribs,e.text!==undefined&&(x.innerText=e.text),w!==e.tagName)&&(x.name=w=e.tagName,h[c]=e.tagName),s&&(e=s(w,t),x.attribs=t=e.attribs,w!==e.tagName)&&(x.name=w=e.tagName,h[c]=e.tagName),(S.allowedTags&&-1===S.allowedTags.indexOf(w)||"recursiveEscape"===S.disallowedTagsMode&&!function(t){for(var e in t)if(I(t,e))return;return 1}(f))&&(f[c]=r=!0,"discard"===S.disallowedTagsMode&&-1!==a.indexOf(w)&&(p=!0,d=1),f[c]=!0),c++,r){if("discard"===S.disallowedTagsMode)return;i=A,A=""}A+="<"+w,C&&!I(C,w)&&!C["*"]||P(t,function(t,e){if(B.test(e)){var r,n=!1;if(!C||I(C,w)&&-1!==C[w].indexOf(e)||C["*"]&&-1!==C["*"].indexOf(e)||I(O,w)&&O[w].test(e)||O["*"]&&O["*"].test(e))n=!0;else if(C&&C[w]){var i=!0,o=!1,s=undefined;try{for(var a,u=C[w][Symbol.iterator]();!(i=(a=u.next()).done);i=!0){var c=a.value;if(T(c)&&c.name&&c.name===e){var n=!0,l="";if(!0===c.multiple){var f=t.split(" "),h=!0,p=!1,d=undefined;try{for(var g,m=f[Symbol.iterator]();!(h=(g=m.next()).done);h=!0){var y=g.value;-1!==c.values.indexOf(y)&&(""===l?l=y:l+=" "+y)}}catch(b){p=!0,d=b}finally{try{h||null==m["return"]||m["return"]()}finally{if(p)throw d}}}else 0<=c.values.indexOf(t)&&(l=t);t=l}}}catch(b){o=!0,s=b}finally{try{i||null==u["return"]||u["return"]()}finally{if(o)throw s}}}if(n)if(-1!==S.allowedSchemesAppliedToAttributes.indexOf(e)&&j(w,t))delete x.attribs[e];else{if("iframe"===w&&"src"===e){var _,o=!0;try{(_=R.parse(t,!1,!0))&&null===_.host&&null===_.protocol?o=I(S,"allowIframeRelativeUrls")?S.allowIframeRelativeUrls:!S.allowedIframeHostnames:S.allowedIframeHostnames&&(o=S.allowedIframeHostnames.find(function(t){return t===_.hostname}))}catch(v){o=!1}if(!o)return void delete x.attribs[e]}if("srcset"===e)try{if(P(_=q.parse(t),function(t){j("srcset",t.url)&&(t.evil=!0)}),!(_=D(_,function(t){return!t.evil})).length)return void delete x.attribs[e];t=q.stringify(D(_,function(t){return!t.evil})),x.attribs[e]=t}catch(v){return void delete x.attribs[e]}if("class"!==e||(s=t,(t=(r=E[w])?(s=s.split(/\s+/)).filter(function(t){return-1!==r.indexOf(t)}).join(" "):s).length)){if("style"===e)try{if(0===(t=function(t,e){if(!e)return t;var r=L(t),t=t.nodes[0];e=e[t.selector]&&e["*"]?M(L(e[t.selector]),e["*"],function(t,e){if(Array.isArray(t))return t.concat(e)}):e[t.selector]||e["*"];e&&(r.nodes[0].nodes=t.nodes.reduce(function(r){return function(t,e){return r.hasOwnProperty(e.prop)&&r[e.prop].some(function(t){return t.test(e.value)})&&t.push(e),t}}(e),[]));return r}(N.parse(w+" {"+t+"}"),S.allowedStyles).nodes[0].nodes.reduce(function(t,e){return t.push(e.prop+":"+e.value),t},[]).join(";")).length)return void delete x.attribs[e]}catch(v){return void delete x.attribs[e]}A+=" "+e,t&&t.length&&(A+='="'+k(t,!0)+'"')}else delete x.attribs[e]}else delete x.attribs[e]}else delete x.attribs[e]}),-1!==S.selfClosing.indexOf(w)?A+=" />":(A+=">",!x.innerText||n||S.textFilter||(A+=x.innerText)),r&&(A=i+k(A),i="")}},ontext:function(t){var e,r;p||((r=l[l.length-1])&&(e=r.tag,t=r.innerText!==undefined?r.innerText:t),"discard"!==S.disallowedTagsMode||"script"!==e&&"style"!==e?(r=k(t,!1),S.textFilter?A+=S.textFilter(r):A+=r):A+=t,l.length&&(l[l.length-1].text+=t))},onclosetag:function(t){if(p){if(--d)return;p=!1}var e=l.pop();if(e){p=!1;var r=f[--c];if(r){if(delete f[c],"discard"===S.disallowedTagsMode)return void e.updateParentNodeText();i=A,A=""}h[c]&&(t=h[c],delete h[c]),S.exclusiveFilter&&S.exclusiveFilter(e)?A=A.substr(0,e.tagPosition):(e.updateParentNodeText(),-1===S.selfClosing.indexOf(t)&&(A+="</"+t+">",r)&&(A=i+k(A),i=""))}}},S.parser);return r.write(t),r.end(),A;function k(t,e){return"string"!=typeof t&&(t+=""),t=(t=S.parser.decodeEntities&&(t=t.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/\>/g,"&gt;"),e)?t.replace(/\"/g,"&quot;"):t).replace(/&(?![a-zA-Z0-9#]{1,20};)/g,"&amp;").replace(/</g,"&lt;").replace(/\>/g,"&gt;"),t=e?t.replace(/\"/g,"&quot;"):t}function j(t,e){var r=(e=(e=e.replace(/[\x00-\x20]+/g,"")).replace(/<\!\-\-.*?\-\-\>/g,"")).match(/^([a-zA-Z]+)\:/);return r?(r=r[1].toLowerCase(),I(S.allowedSchemesByTag,t)?-1===S.allowedSchemesByTag[t].indexOf(r):!S.allowedSchemes||-1===S.allowedSchemes.indexOf(r)):e.match(/^[\/\\]{2}/)&&!S.allowProtocolRelative}}var b={decodeEntities:!0};_.defaults={allowedTags:["h3","h4","h5","h6","blockquote","p","a","ul","ol","nl","li","b","i","strong","em","strike","code","hr","br","div","table","thead","caption","tbody","tr","th","td","pre","iframe"],disallowedTagsMode:"discard",allowedAttributes:{a:["href","name","target"],img:["src"]},selfClosing:["img","br","hr","area","base","basefont","input","link","meta"],allowedSchemes:["http","https","ftp","mailto"],allowedSchemesByTag:{},allowedSchemesAppliedToAttributes:["href","src","cite"],allowProtocolRelative:!0},_.simpleTransform=function(n,i,o){return o=o===undefined||o,i=i||{},function(t,e){if(o)for(var r in i)e[r]=i[r];else e=i;return{tagName:n,attribs:e}}}},{htmlparser2:31,"lodash.clonedeep":33,"lodash.escaperegexp":34,"lodash.isplainobject":35,"lodash.isstring":36,"lodash.mergewith":37,postcss:51,srcset:79,url:80,xtend:82}]},{},[83])(83)});
//# sourceMappingURL=sanitize-html.js.map;
!function(n,h){"use strict";var i=function(e,t){this.$tableWrapper=n(e).first(),this.options=t||{},this.namespace=this.options.namespace||"freeze-table",this.callback,this.scrollBarHeight,this.shadow,this.fastMode,this.backgroundColor,this.scrollable,this.$table=this.$tableWrapper.children("table"),this.$container="undefined"!=typeof this.options.container&&this.options.container&&n(this.options.container).length?n(this.options.container):n(h),this.$headTableWrap,this.$columnTableWrap,this.$columnHeadTableWrap,this.$scrollBarWrap,this.fixedNavbarHeight,this.isWindowScrollX=!1;e=(new Date).getTime();return this.uniqueHeadWrapClass="clone-head-table-wrap__"+e,this.headWrapClass="clone-head-table-wrap",this.columnWrapClass="clone-column-table-wrap",this.columnHeadWrapClass="clone-column-head-table-wrap",this.scrollBarWrapClass="clone-scroll-bar-wrap",this.init(),this};i.prototype.init=function(){if(!this.$table.length)throw"The element must contain a table dom";if("update"===this.options)this.destroy(),this.options=this.$tableWrapper.data("freeze-table-data");else{if("resize"===this.options)return this.options=this.$tableWrapper.data("freeze-table-data"),this.namespace=this.options.namespace||this.namespace,void this.resize();this.$tableWrapper.data("freeze-table-data",this.options)}var e=this.options,t="undefined"==typeof e.freezeHead||e.freezeHead,i="undefined"==typeof e.freezeColumn||e.freezeColumn,s="undefined"==typeof e.freezeColumnHead||e.freezeColumnHead,a="undefined"!=typeof e.scrollBar&&e.scrollBar,l=e.fixedNavbar||".navbar-fixed-top",o=e.callback||null,r=(this.namespace=this.options.namespace||this.namespace,this.scrollBarHeight=n.isNumeric(e.scrollBarHeight)?e.scrollBarHeight:h.innerWidth-document.documentElement.clientWidth,this.shadow="undefined"!=typeof e.shadow&&e.shadow,this.fastMode="undefined"!=typeof e.fastMode&&e.fastMode,this.backgroundColor="undefined"!=typeof e.backgroundColor?e.backgroundColor:"white",this.scrollable="undefined"!=typeof e.scrollable&&e.scrollable,this.fixedNavbarHeight=l&&n(l).outerHeight()||0,this.isInit()&&this.destroy(),this.scrollable||this.$tableWrapper.css("height","100%").css("min-height","100%").css("max-height","100%"),t&&this.buildHeadTable(),i&&(this.buildColumnTable(),this.$tableWrapper.css("overflow-x","scroll")),s&&t&&i&&this.buildColumnHeadTable(),a&&this.buildScrollBar(),function(){0<this.$container.scrollLeft()?(this.isWindowScrollX=!0,this.$headTableWrap&&this.$headTableWrap.css("visibility","hidden"),this.$columnTableWrap&&this.$columnTableWrap.css("visibility","hidden"),this.$columnHeadTableWrap&&this.$columnHeadTableWrap.css("visibility","hidden"),this.$scrollBarWrap&&this.$scrollBarWrap.css("visibility","hidden")):this.isWindowScrollX=!1}.bind(this));this.$container.on("scroll."+this.namespace,function(){r()}),this.resize(),"function"==typeof o&&o()},i.prototype.buildHeadTable=function(){var e,i=this,t=this.clone(this.$table),s=(this.fastMode&&(t=this.simplifyHead(t)),this.options.headWrapStyles||null);this.$headTableWrap=n('<div class="'+this.uniqueHeadWrapClass+" "+this.headWrapClass+'"></div>').append(t).css("position","fixed").css("overflow","hidden").css("visibility","hidden").css("top",0+this.fixedNavbarHeight).css("z-index",2),this.shadow&&this.$headTableWrap.css("box-shadow","0px 6px 10px -5px rgba(159, 159, 160, 0.8)"),s&&"object"==typeof s&&n.each(s,function(e,t){i.$headTableWrap.css(e,t)}),this.$tableWrapper.append(this.$headTableWrap),this.$tableWrapper.on("scroll."+this.namespace,function(){i.$headTableWrap.scrollLeft(n(this).scrollLeft())}),this.scrollable?(e=function(e,t){var i=t.$tableWrapper.offset().top;0<t.$tableWrapper.scrollTop()&&i>t.fixedNavbarHeight?(t.$headTableWrap.offset({top:i}),t.$headTableWrap.css("visibility","visible")):t.$headTableWrap.css("visibility","hidden")},this.$tableWrapper.on("scroll."+this.namespace,function(){e(0,i)}),this.$container.on("scroll."+this.namespace,function(){e(0,i)})):n.isWindow(i.$container.get(0))?this.$container.on("scroll."+this.namespace,function(){var e=i.$container.scrollTop()+i.fixedNavbarHeight,t=i.$table.offset().top-1;t-1<=e&&t+i.$table.outerHeight()-1>=e?i.$headTableWrap.css("visibility","visible"):i.$headTableWrap.css("visibility","hidden")}):this.$container.on("scroll."+this.namespace,function(){var e=n(h).scrollTop(),t=i.$table.offset().top-1;t<=e&&t+i.$table.outerHeight()-1>=e?(i.$headTableWrap.offset({top:e}),i.$headTableWrap.css("visibility","visible")):i.$headTableWrap.css("visibility","hidden")}),this.$container.on("resize."+this.namespace,function(){var e=0<(e=i.scrollable?i.$tableWrapper.width()-i.scrollBarHeight:i.$tableWrapper.width())?e:i.$tableWrapper.width();i.$headTableWrap.css("width",e),i.$headTableWrap.css("height",i.$table.find("thead").outerHeight())})},i.prototype.buildColumnTable=function(){var s=this,e=this.options.columnWrapStyles||null,a=this.options.columnNum||1,t="undefined"!=typeof this.options.columnKeep&&this.options.columnKeep,i=this.shadow?0:1,l="undefined"!=typeof this.options.columnBorderWidth?this.options.columnBorderWidth:i,o=this.clone(this.$table),r=(this.$columnTableWrap=n('<div class="'+this.columnWrapClass+'"></div>').append(o).css("position","fixed").css("overflow","hidden").css("visibility","hidden").css("z-index",1),this.shadow&&this.$columnTableWrap.css("box-shadow","6px 0px 10px -5px rgba(159, 159, 160, 0.8)"),e&&"object"==typeof e&&n.each(e,function(e,t){s.$columnTableWrap.css(e,t)}),this.scrollable&&(i=0<(i=this.$tableWrapper.height()-this.scrollBarHeight)?i:this.$tableWrapper.height(),this.$columnTableWrap.height(i)),this.$tableWrapper.append(this.$columnTableWrap),function(){s.$columnTableWrap.offset({top:s.$tableWrapper.offset().top})});t?this.$columnTableWrap.css("visibility","visible"):s.scrollable?this.$tableWrapper.on("scroll."+this.namespace,function(){0<n(this).scrollLeft()?(s.$columnTableWrap.scrollTop(s.$tableWrapper.scrollTop()),s.$columnTableWrap.css("visibility","visible")):s.$columnTableWrap.css("visibility","hidden")}):this.$tableWrapper.on("scroll."+this.namespace,function(){s.isWindowScrollX||(0<n(this).scrollLeft()?s.$columnTableWrap.css("visibility","visible"):s.$columnTableWrap.css("visibility","hidden"))}),this.$container.on("resize."+this.namespace,function(){o.width(s.$table.width());for(var e=0+l,t=1;t<=a;t++){var i=s.$table.find("th:nth-child("+t+")").outerWidth();e+=0<i?i:s.$table.find("td:nth-child("+t+")").outerWidth()}s.$columnTableWrap.width(e),r()}),this.$container.on("scroll."+this.namespace,function(){r()})},i.prototype.buildColumnHeadTable=function(){var e,i=this,t=(this.$columnHeadTableWrap=this.clone(this.$headTableWrap),this.fastMode&&(this.$columnHeadTableWrap=this.simplifyHead(this.$columnHeadTableWrap)),this.options.columnHeadWrapStyles||null);this.$columnHeadTableWrap.removeClass(this.namespace).addClass(this.columnHeadWrapClass).css("z-index",3),this.shadow&&this.$columnHeadTableWrap.css("box-shadow","none"),t&&"object"==typeof t&&n.each(t,function(e,t){this.$columnHeadTableWrap.css(e,t)}),this.$tableWrapper.append(this.$columnHeadTableWrap),this.scrollable?(e=function(){var e=i.$tableWrapper.offset().top;0<i.$tableWrapper.scrollTop()&&e>i.fixedNavbarHeight?(i.$columnHeadTableWrap.offset({top:e}),i.$columnHeadTableWrap.css("visibility","visible")):i.$columnHeadTableWrap.css("visibility","hidden")},n(this.$tableWrapper).on("scroll."+this.namespace,function(){e()})):e=n.isWindow(this.$container.get(0))?function(){var e=i.$container.scrollTop()+i.fixedNavbarHeight,t=i.$table.offset().top-1;t-1<=e&&t+i.$table.outerHeight()-1>=e&&0<i.$tableWrapper.scrollLeft()?i.$columnHeadTableWrap.css("visibility","visible"):i.$columnHeadTableWrap.css("visibility","hidden")}:function(){var e=n(h).scrollTop(),t=i.$table.offset().top-1;t<=e&&t+i.$table.outerHeight()-1>=e&&0<i.$tableWrapper.scrollLeft()?(i.$columnHeadTableWrap.offset({top:e}),i.$columnHeadTableWrap.css("visibility","visible")):i.$columnHeadTableWrap.css("visibility","hidden")},this.$container.on("scroll."+this.namespace,function(){e()}),this.$tableWrapper.on("scroll."+this.namespace,function(){i.isWindowScrollX||e()}),this.$container.on("resize."+this.namespace,function(){i.$columnHeadTableWrap.find("> table").css("width",i.$table.width()),i.$columnHeadTableWrap.css("width",i.$columnTableWrap.width()),i.$columnHeadTableWrap.css("height",i.$table.find("thead").outerHeight())})},i.prototype.buildScrollBar=function(){var t=this,i=this.$table.find("thead").outerHeight(),e=n('<div class="'+this.scrollBarWrapClass+'"></div>').css("width",this.$table.width()).css("height",1);this.$scrollBarWrap=n('<div class="'+this.scrollBarWrapClass+'"></div>').css("position","fixed").css("overflow-x","scroll").css("visibility","hidden").css("bottom",0).css("z-index",2).css("width",this.$tableWrapper.width()).css("height",this.scrollBarHeight),this.$scrollBarWrap.append(e),this.$tableWrapper.append(this.$scrollBarWrap),this.$scrollBarWrap.on("scroll."+this.namespace,function(){t.$tableWrapper.scrollLeft(n(this).scrollLeft())}),this.$tableWrapper.on("scroll."+this.namespace,function(){t.$scrollBarWrap.scrollLeft(n(this).scrollLeft())}),this.$container.on("scroll."+this.namespace,function(){var e=t.$container.scrollTop()+t.$container.height()-i+t.fixedNavbarHeight;t.$table.offset().top-1<=e&&t.$table.offset().top+t.$table.outerHeight()-1>=e?t.$scrollBarWrap.css("visibility","visible"):t.$scrollBarWrap.css("visibility","hidden")}),this.$container.on("resize."+this.namespace,function(){e.css("width",t.$table.width()),t.$scrollBarWrap.css("width",t.$tableWrapper.width())})},i.prototype.clone=function(e){e=n(e).clone().removeAttr("id");return this.backgroundColor&&e.css("background-color",this.backgroundColor),e},i.prototype.simplifyHead=function(e){var i=this,e=n(e);return e.find("> tr, > tbody > tr, tfoot > tr").not(":first").remove(),n.each(e.find("> thead > tr:nth-child(1) >"),function(e,t){e=i.$table.find("> thead > tr:nth-child(1) > :nth-child("+parseInt(e+1)+")").outerWidth();n(this).css("width",e)}),e},i.prototype.isInit=function(){return!!(this.$tableWrapper.find("."+this.uniqueHeadWrapClass).length||this.$tableWrapper.find("."+this.columnWrapClass).length||this.$tableWrapper.find("."+this.columnHeadWrapClass).length||this.$tableWrapper.find("."+this.scrollBarWrapClass).length)},i.prototype.unbind=function(){this.$container.off("resize."+this.namespace),this.$container.off("scroll."+this.namespace),this.$tableWrapper.off("scroll."+this.namespace)},i.prototype.destroy=function(){this.unbind(),this.$tableWrapper.find("."+this.uniqueHeadWrapClass).remove(),this.$tableWrapper.find("."+this.columnWrapClass).remove(),this.$tableWrapper.find("."+this.columnHeadWrapClass).remove(),this.$tableWrapper.find("."+this.scrollBarWrapClass).remove()},i.prototype.resize=function(){return this.$container.trigger("resize."+this.namespace),this.$container.trigger("scroll."+this.namespace),this.$tableWrapper.trigger("scroll."+this.namespace),!0},i.prototype.update=function(){return this.options="update",this.init(),this},h.FreezeTable=i,n.fn.freezeTable=function(e){var t;return 1===this.length?new i(this,e):1<this.length&&(t=[],this.each(function(){t.push(new i(this,e))}),t)}}(jQuery,window);
//# sourceMappingURL=freezeTable.js.map;
(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var Highcharts = window.Highcharts;

// check version to avoid this fix to become obsolete
var highchartsTargetVersion = '11.3.0';
if (Highcharts.version !== highchartsTargetVersion) {
  console.error("compareFix active for a Highcharts Version other than ".concat(highchartsTargetVersion, " (currently running ").concat(Highcharts.version, ")- please check this issue"));
}
var UNDEFINED;

// this function overwrites an internal highcharts function to fix percentage compare in negative values
var fixedCompareFunction = function fixedCompareFunction(compare) {
  // Set or unset the modifyValue method
  this.modifyValue = compare === 'value' || compare === 'percent' ? function (value, point) {
    var compareValue = this.compareValue;
    if (value !== UNDEFINED) {
      // #2601
      // get the modified value
      // custom parameter to get compareBase with 100
      if (compare === 'value') {
        value = value - compareValue;
      } else {
        if (this.options.compareEnabled === true) {
          var compareBaseValue = this.options.compareBase === 100 ? 0 : 100;
          var compareValueSecondCoordinate = compareValue || value;
          value = 100 * (value / compareValueSecondCoordinate) - compareBaseValue;
        } else {
          value = 100 * ((value - compareValue) / Math.abs(compareValue)); // compare percent // <--- ONLY THIS LINE WAS CHANGED
        }
      }
      // record for tooltip etc.
      if (point) {
        point.change = value;
      }
    }
    return value;
  } : null;

  // Survive to export, #5485
  this.userOptions.compare = compare;

  // Mark dirty
  if (this.chart.hasRendered) {
    this.isDirty = true;
  }
};

// apply for all series types
for (var seriesType in Highcharts.seriesTypes) {
  Highcharts.seriesTypes[seriesType].prototype.setCompare = fixedCompareFunction;
}

/*
 * Some necessary HighCharts configs to sync chart hovers
 */
Highcharts.Point.prototype.highlight = function (e) {
  if (this.series.chart.options.series.length === 1) {
    this.onMouseOver(); // Show the hover marker
    this.series.chart.tooltip.refresh([this], e); // Show the tooltip
    this.series.chart.xAxis[0].drawCrosshair(e, this); // Show the crosshair
  }
};

/**
 * Extend the Pointer getHoverData method
 * To add synced points for compare chart
 */
Highcharts.wrap(Highcharts.Pointer.prototype, 'getHoverData', function (proceed, existingHoverPoint, existingHoverSeries, series, isDirectTouch, shared, e) {
  if (series.length > 2) {
    var useExisting = !!(isDirectTouch && existingHoverPoint);
    // Use existing hovered point or find the one closest to coordinates.
    var hoverPoint = useExisting || !e ? existingHoverPoint : this.findNearestKDPoint(series, shared, e);
    if (hoverPoint) {
      series.forEach(function (s) {
        var hasPoint = false;
        for (var i = 0; i < s.points.length; i++) {
          var p = s.points[i];
          if (p.x === hoverPoint.x) {
            hasPoint = true;
            break;
          } else if (p.x > hoverPoint.x) {
            break;
          }
        }
        s._sortOrder = 0;
        if (!hasPoint) {
          var newPoint = s.points[Math.max(0, i - 1)];
          newPoint.x = hoverPoint.x;
          s.points.splice(i, 0, newPoint);
          s._sortOrder = 1;
        }
      });
      series.sort(function (a, b) {
        return a._sortOrder - b._sortOrder;
      });
    }
    return proceed.apply(this, [existingHoverPoint, existingHoverSeries, series, isDirectTouch, shared, e]);
  } else {
    // Normal charts work as before.
    // Run the original proceed method
    return proceed.apply(this, Array.prototype.slice.call(arguments, 1));
  }
});

/**
 * Extend the Pointer runPointActions method
 * To add requestAnimationFrame and prevent page freeze
 */
Highcharts.wrap(Highcharts.Pointer.prototype, 'runPointActions', function (proceed, e, p) {
  var _arguments = arguments,
    _this = this;
  window.requestAnimationFrame(function () {
    proceed.apply(_this, Array.prototype.slice.call(_arguments, 1));
  });
});

/**
 * Extend the Tooltip getAnchor function to ignore too far points (eg:ZigZag)
 * when calculating x and y for tooltip
 */
Highcharts.wrap(Highcharts.Tooltip.prototype, 'getAnchor', function (proceed, point, e) {
  point = Highcharts.splat(point);
  var plotX = 0;
  point = point.filter(function (p) {
    var flag = plotX === 0 || Math.abs(plotX - p.plotX) < 20;
    plotX = p.plotX;
    return flag;
  });
  return proceed.apply(this, [point, e]);
});

/**
 * Override the reset function, we don't need to hide the tooltips and crosshairs.
 * NGPII-19827 Detailpage Chart - indicators cause misfunction of chart info(tooltip) window
 */
Highcharts.Pointer.prototype.reset = function () {
  return undefined;
};

},{}]},{},[1]);
;
(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

/*
 * Defines core functions in the global scope. Keep this file free of dependencies.
 * These functions are not defined in global.js as it has too many dependencies.
 */

/*
 * @name fcom
 * @namespace Namespace for custom classes and functions used by ngp
 */

/*
 * @name fcom.util
 * @namespace Namespace for utility classes and functions
 */

/*
 * @name fcom.date
 * @namespace Namespace for custom date classes
 */

/*
 * <p>Creates a namespace. It is good practise to namespace custom classes and objects, to keep the global scope clean and to
 * avoid conflicts with OPC (other people's code). The purpose of a namespace is, to make objects or functions unique.
 * The usage of <tt>ngpNamespace</tt> is similar to creating packages in Java. For performance reasons don't choose a too long namespace,
 * as this results in several property accesses for the namespace object.</p>
 *
 * <p>The first argument for this function contains the identifier of the namespace. The identifier can consist of several parts
 * which are seperated by the '.' character. The namespace is represented by an object tree. The identifier therefore describes
 * a path in the namespace tree. If we talk of a namespace, we usually think of the identifer, i.e. the tree path.<br>
 * An example for a namespace would be: <tt>fcom.util</tt>.</p>
 * <p>The second argument is an optional anonymous function. The function creates a private scope for variables. The return value of the function is a map of properties to add to
 * the defined namespace.<br>
 * Usage of <tt>ngpNamespace</tt>:
 * <pre><code>
 * window.ngpNamespace("fcom.util", function() {
 *     const privateScopedVariable; //only declared inside the function's scope
 *
 * //adds UtilityClass to the namspace "fcom.util"
 * return {
 *     UtilityClass: function() { //constructor }
 * };
 *
 * });
 * new fcom.util.UtilityClass();
 * </code></pre><br>
 * </p>
 *
 * <p>Another possibility is to directly use the returned namespace object:
 * <pre><code>
 * window.ngpNamespace("fcom.util").UtilityClass = function() {
 *     //define constructor here
 * };
 * </code></pre></p>
 *
 * @name ngpNamespace
 * @function
 * @param {String} identifier the namespace's identifier
 * @param {Function} blockFn usually an anonymous function which will create a private scope and returns a map of members to add direclty to the namespace.
 * @return {Object} the namespace object
 */
window.ngpNamespace = function (identifier, blockFn) {
  // check the identifier
  if (!identifier || !identifier.length) {
    throw new TypeError('Empty namespace identifier!');
  }
  var path = identifier.split('.');
  var nspace = window; //first part of the namespace is in global scope
  var id;
  while ((id = path.shift()) != null) {
    if (nspace[id] == null) {
      nspace[id] = {};
    }
    nspace = nspace[id];
  }
  // add members created in the block function
  if (blockFn) {
    var map = blockFn.call(window);
    for (var i in map) {
      if (typeof i != 'undefined') {
        nspace[i] = map[i];
      }
    }
  }
  return nspace;
};

/*
 * <p>Check whether an object is of a certain type. This is used to check for native javascript types such as Array, Function, String...<br>
 * For custom classes use the <tt>instanceof</tt> operator.</p>
 * <p>The code for this function was borrowed from <a href="http://bonsaiden.github.com/JavaScript-Garden/#types.equality">JavaScript Garden</a>.</p>
 * @function
 * @name ngpIsType
 * @param {String} type
 * @param {Object} obj
 * @return {Boolean}
 */
window.ngpIsType = function (type, obj) {
  return obj != null && Object.prototype.toString.call(obj).slice(8, -1) === type;
};

/*
 * <p>
 * Check wether the object is an empty object like <tt>{}</tt>.
 * </p>
 * <p>
 * See <a href="http://api.jquery.com/jQuery.isEmptyObject/">http://api.jquery.com/jQuery.isEmptyObject/</a>
 * </p>
 *
 * @param {} obj
 * @return {Boolean}
 */
window.ngpIsEmptyObject = function (obj) {
  for (var name in obj) {
    return false;
  }
  return true;
};

},{}]},{},[1]);
;
window.ngpNamespace("YAHOO.fcom"),window.KeyEvent=YAHOO.util.KeyListener,window.Lang=YAHOO.lang,window.Dom=YAHOO.util.Dom,YAHOO.fcom.Util={_monthMap:{Jan:"01",Feb:"02",Mar:"03",Apr:"04",May:"05",Jun:"06",Jul:"07",Aug:"08",Sep:"09",Oct:"10",Nov:"11",Dec:"12"},reNumber:new RegExp("(^[-+]?)[0-9]*[.,]?[0-9]+$"),reNoNumber:new RegExp("[^0-9.,]","g"),reMalNumber1:new RegExp("^[.,]*(.*?)[.,]*$","g"),reMalNumber2:new RegExp("([.,]){2,}","g"),reJavaDate:/(^[FMSTW][adehinortu]{2})\s([ADFJMNOS][a-z]{2})\s(\d{2})\s(\d{2})[\:](\d{2})[\:](\d{2})\s([A-Z]+)\s([\d]{4})$/g,pullNumber:function(e){var n=new RegExp("(^[-+]?)[0-9]*[.,]?[0-9]+$"),t=new RegExp("[^0-9.,]","g"),r=new RegExp("^[.,]*(.*?)[.,]*$","g"),a=new RegExp("([.,]){2,}","g"),n=(e=YAHOO.fcom.Util.trim(e),n.exec(e));return e=(e=(e=e.replace(t,"")).replace(r,"$1")).replace(a,"$1"),YAHOO.lang.isNull(n)?e:n[1]+e},_validDate:function(e,n,t){t=new Date(e,n,t);return t.getFullYear()==e&&t.getMonth()==n},deepFind:function(e,n){for(var t=n.split("."),r=e,a=0;a<t.length;++a){if(r[t[a]]===undefined)return null;r=r[t[a]]}return r},getDomPath:function(e,n){var t=[];for(n=n||" ";null!=e.parentNode;){for(var r=0,a=0,i=0;i<e.parentNode.childNodes.length;i++){var o=e.parentNode.childNodes[i];o.nodeName===e.nodeName&&(o===e&&(a=r),r++)}e.hasAttribute("id")&&""!==e.id?t.unshift(e.nodeName.toLowerCase()+"#"+e.id):t.unshift(1<r?e.nodeName.toLowerCase()+":eq("+a+")":e.nodeName.toLowerCase()),e=e.parentNode}return t.slice(1).join(n)},detectInternetExplorer:function(e){var n=window.navigator&&window.navigator.userAgent||"";return new RegExp("("+(0!=e?"edge|":"")+"msie|trident)","i").test(n)&&!window.opera},setValueToObject:function(e,n,t){for(var r=n.split("."),a=e;r.length-1;){var i=r.shift();i in a||(a[i]={}),a=a[i]}a[r[0]]=t},calculateTextWidth:function(e,n){window._textCanvas||(window._textCanvas=document.createElement("canvas"));var t=window._textCanvas.getContext("2d"),n=(t.font=n,t.measureText(e));return n.width},ReadISO8601date:function(e){var n;if(null==(n=/^(\d+)([-\/])(\d\d)(\2)(\d\d)$/.exec(e)))return[-2];for(var t=1;t<=5;t+=2)n[t]=parseInt(n[t],10);return YAHOO.fcom.Util._validDate(n[1],n[3]-1,n[5])?[n[1],n[3],n[5],"yyyy"+n[2]+"MM"+n[2]+"dd"]:[-1]},spiltJavaDate:function(e){var n=/(^[FMSTW][adehinortu]{2})\s([ADFJMNOS][a-z]{2})\s(\d{2})\s(\d{2})[\:](\d{2})[\:](\d{2})\s([A-Z]+)\s([\d]{4})$/g,t=n.exec(e);return YAHOO.lang.isNull(t)?null:e.replace(n,function(e,n,t,r,a,i,o,d,s){return[parseInt(r,10),parseInt(YAHOO.fcom.Util._monthMap[t],10),s,n,a,i,o,d].join(",")}).split(",")},format:function(e,n,t){try{var r="";if(e&&n){for(var a=/(.*?)[@](.*?)[@]/g,i=(a=t?t:a).exec(e),o=0;null!=i;)r+=i[1]+""+n[i[2]],o=(o+=i[1].length)+(i[2].length+2),i=a.exec(e);r+=e.substring(o)}return r}catch(d){return r}},trim:function(e){return fcom.util.StringHelper.trim(e)},ricCorrecion:function(e){return e=(e=YAHOO.fcom.Util.trim(e))===e.toLowerCase()?e.toUpperCase():e},cloneJSObject:function(e){if("object"!=typeof e||null==e)return e;var n,t=e instanceof Array?[]:{};for(n in e){var r=e[n];if("object"==typeof r)if(r instanceof Array){t[n]=[];for(var a=0;a<r.length;a++)"object"!=typeof r[a]?t[n].push(r[a]):t[n].push(YAHOO.fcom.Util.cloneJSObject(r[a]))}else t[n]=YAHOO.fcom.Util.cloneJSObject(r);else t[n]=r}return t},indexOf:function(e,n){for(var t=0;t<n.length;t++)if(n[t]===e)return t;return-1},lastIndexOf:function(e,n,t){var r=n.length,t=Number(n);for(isNaN(t)?t=r-1:(t=t<0?Math.ceil(t):Math.floor(t))<0?t+=r:r<=t&&(t=r-1);-1<t;t--)if(t in n&&n[t]===e)return t;return-1},removeItem:function(e,n){e=YAHOO.fcom.Util.indexOf(e,n);return-1<e&&(n.splice(e,1),!0)},createDelegate:function(e,n){return function(){return e.apply(n,arguments)}},replaceURLParam:function(e,n,t,r){return e=this.removeURLParam(e,n),this.addURLParam(e,t,r)},addURLParam:function(e,n,t){var r;return null!=t&&(-1!=e.indexOf(r="?")&&(r="&"),e+=r,YAHOO.lang.isArray(t)?e+=this.arrayToParam(t,n):e+=n+"="+encodeURIComponent(t)),e},removeURLParam:function(e,n){for(;-1!=e.indexOf(n+"=");){var t=e.indexOf(n+"="),r=e.substring(t-1,t),t=e.substring(t-1,e.length),a=t.substring(1,t.length).indexOf("&"),i=!1;-1==a?(a=t.length,i=!0):a++,t=t.substring(0,a),e="?"!=r||i?e.replace(t,""):e.replace(t+"&","?")}return e},containsURLParam:function(e,n){return-1!=e.indexOf(n+"=")},getURLParams:function(e){var n={};if(-1!=e.indexOf("?")&&e.indexOf("?")+1<e.length)for(var t=e.substring(e.indexOf("?")+1,e.length).split("&"),r=0;r<t.length;r++){var a=t[r].split("=");n[a[0]]=a[1]}return n},setURLParam:function(e,n,t){return this.containsURLParam(e,n)?this.replaceURLParam(e,n,n,t):this.addURLParam(e,n,t)},arrayToParam:function(e,n){return e.map(function(e){return n+"="+encodeURIComponent(null!=e&&"object"==typeof e?JSON.stringify(e):e)}).join("&")},createFormArrayField:function(e,n,t){this.removeFormArrayField(e,n),this.addFormArrayField(e,n,t)},createPostData:function(e,n){var t="";if(window.ngpIsType("String",e))t+=e;else{for(var r in e){var a=e[r];null!=a&&(window.ngpIsType("Array",a)?""!=this.arrayToParam(a,r)&&(t+=this.arrayToParam(a,r)+"&"):window.ngpIsType("Function",a)||(a instanceof fcom.date.DateTime?t+=r+"="+encodeURIComponent(a.toString())+"&":null!=a.value?t+=r+"="+encodeURIComponent(a.value)+"&":t+=r+"="+encodeURIComponent(a)+"&"))}0<t.length&&(t=t.substring(0,t.length-1))}return t=n&&0<n.length?0<t.length?n+"&"+t:n:t},removeFormArrayField:function(e,n){for(var t=YAHOO.util.Dom.getElementsBy(function(e){if(e.name&&e.name==n)return!0},"input",e),r=0;r<t.length;r++)(n=t[r]).parentNode.removeChild(n)},addFormArrayField:function(e,n,t){for(var r=0;r<t.length;r++){var a=document.createElement("input");a.setAttribute("type","hidden"),a.setAttribute("name",n),a.setAttribute("value",t[r]),e.appendChild(a)}},validateTime:function(e){var n,t,e=e.match(/^(\d{2}):(\d{2})(:(\d{2}))?$/);return null!=e&&(n=parseInt(e[1]),t=parseInt(e[2]),e=parseInt(e[4]),!(isNaN(n)||23<n||n<0||isNaN(t)||59<t||t<0||!isNaN(e)&&(59<e||e<0)))},insertIntoArray:function(e,n,t){e.length<n?e.push(t):e.splice(n,0,t)}};var FUtil=YAHOO.fcom.Util,REIPHMode=(YAHOO.fcom.RICEditorInputPostHandlerMode={ALL:1,ON_ENTER:2,EXCEPT_ENTER:4,getBitMapFlag:function(e){var n,t=0;for(n in e)t|=e[n];return t},has:function(e,n){return 0!=(e&n)}},YAHOO.fcom.RICEditorInputPostHandlerMode);function _addRICPerspective(e,n){this.editor.value=FUtil.ricCorrecion(this.editor.value),this._postHandler(e,n)}YAHOO.fcom.RICEditorInput=function(textField,triggerKeys,postHandler){this.editor=Dom.get(textField),(Lang.isUndefined(triggerKeys)||Lang.isNull(triggerKeys))&&(triggerKeys=[9,13]),this.fn=null,this.postHandlerMode=[REIPHMode.ALL],!Lang.isUndefined(postHandler)&&Lang.isObject(postHandler)&&(Lang.isUndefined(postHandler.fn)||(this.fn=postHandler.fn),!Lang.isUndefined(postHandler.mode))&&Lang.isArray(postHandler.mode)&&(this.postHandlerMode=postHandler.mode),this.keyEvent=new window.KeyEvent(this.editor,{keys:triggerKeys},{fn:_addRICPerspective,scope:this,correctScope:!0}),this.keyEvent.enable(),this.setValue=function(e,n){var t=!1;Lang.isUndefined(n)&&Lang.isBoolean(n)&&(t=n),this.editor.value=!0===t?FUtil.ricCorrecion(e):e},this._postHandler=function(eventVar,args){var bmf=REIPHMode.getBitMapFlag(this.postHandlerMode);(REIPHMode.has(bmf,REIPHMode.ALL)||(REIPHMode.has(bmf,REIPHMode.ON_ENTER)&&13===args[0]&&eval(this.fn),REIPHMode.has(bmf,REIPHMode.EXCEPT_ENTER)&&13!=args[0]))&&eval(this.fn)}};
//# sourceMappingURL=util.js.map;
window.ngpNamespace("fcom.util"),fcom.util.StringHelper={leftPad:function(e,r,t){for(e=e||"",window.ngpIsType("String",e)||(e=e.toString());e.length<r;)e=t+e;return e},rightPad:function(e,r,t){for(e=e||"",window.ngpIsType("String",e)||(e=e.toString());e.length<r;)e+=t;return e},formatMessage:function(e,r){r=[].concat(r);var t=new RegExp("(.*?)[{](.*?)[}]","g");return fcom.util.StringHelper.format(e,r,t)},format:function(e,r,t){var n="";try{if(e&&r){for(var g=/(.*?)[@](.*?)[@]/g,a=(g=t?t:g).exec(e),c=0;null!=a;)n+=a[1]+""+r[a[2]],c=(c+=a[1].length)+(a[2].length+2),a=g.exec(e);n+=e.substring(c)}return n}catch(i){return n}},trim:function(e){(r=/^(\s*)([\W\w]*)(\b\s*$)/).test(e)&&(e=e.replace(r,"$2"));var r=/ +/g;return e=" "==(e=e.replace(r," "))?"":e},empty:function(e){return!window.ngpIsType("String",e)||""==fcom.util.StringHelper.trim(e)},escapeRegExp:function(e){var r=new RegExp("[.*+?|()\\[\\]{}\\\\]","g");return e.replace(r,"\\$&")},escapeHTML:function(e){if(window.ngpIsType("String",e))return e.replace(/&/g,"&amp;").replace(/>/g,"&gt;").replace(/</g,"&lt;").replace(/"/g,"&quot;")},unescapeHTML:function(e){if(window.ngpIsType("String",e))return e.replace(/&amp\;/g,"&").replace(/&gt\;/g,">").replace(/&lt;/g,"<").replace(/&quot\;/g,'"')},escapeJavaScript:function(e){return e.replace(/\\/g,"\\\\").replace(/"/g,'\\"').replace(/'/g,"\\'").replace(/\n/g,"\\n").replace(/\r/g,"\\r").replace(/\t/g,"\\t")},startsWith:function(e,r){var t=0;if(e.length>r.length)return!1;for(var n=0;n<r.length;n++)if(" "!=r.charAt(n)||0!=t){if(r.charAt(n)!=e.charAt(t))return!1;if(++t==e.length)break}return!0}};
//# sourceMappingURL=StringHelper.js.map;
window.ngpNamespace("fcom.util"),fcom.util.PersistenceHelper=function(){var u=function(){for(var e={},t=document.cookie.split("; "),i=t.length;i--;){var n,o=t[i],o=/((.*)\d*)=/.exec(o);o&&null!=o[1]&&null!=o[2]&&(n=o[1],null==e[n]&&(e[n]=[]),e[n].push(o[2]))}return e}();return{deleteCookie:function(e){if(window.ngpIsType("Array",u[e]))for(var t=u[e].length;t--;)YAHOO.util.Cookie.remove(u[e][t])},getNumCookies:function(){return 0==document.cookie.length?0:document.cookie.split("; ").length},setCookie:function(e,t){fcom.util.PersistenceHelper.deleteCookie(e);var i=window.base64Encode(JSON.stringify(t)),n=0,o=e;u[e]=[];do{var r=fcom.util.PersistenceHelper.getNumCookies(),l=(u[e].push(o),4096-o.length),i=i.length>l?(YAHOO.util.Cookie.set(o,i.substring(0,l)),i.substring(l)):(YAHOO.util.Cookie.set(o,i),"");if(fcom.util.PersistenceHelper.getNumCookies()==r)return YAHOO.log("Could not create cookie "+e+". Exeeding cookie byte limit.","global","fcom.util.PersistenceHelper.setCookie"),fcom.util.PersistenceHelper.deleteCookie(e),!1}while(o=e+ ++n,0<i.length);return!0},getCookie:function(e,t){if(t=t||null,window.ngpIsType("Array",u[e])){for(var i="",n=0;n<u[e].length;n++){var o=YAHOO.util.Cookie.get(u[e][n]);null!=o&&(i+=o)}if(""!=fcom.util.StringHelper.trim(i))return JSON.parse(window.decodeBase64(i))}return t},filterAttributes:function(e,t){if(window.ngpIsType("Array",e))for(var i=[],n=0,o=e.length;n<o;n++)i.push(fcom.util.PersistenceHelper.filterAttributes(e[n],t));else{if(window.ngpIsType("Number",e)||window.ngpIsType("Boolean",e)||window.ngpIsType("String",e)||window.ngpIsType("Date",e)||window.ngpIsType("Function",e)||e instanceof fcom.date.DateTime)return e;if(null==e)return null;var r,l,i={};for(n in e)void 0!==n&&(r=e[n],l=null==t||0==t.length||-1<YAHOO.fcom.Util.indexOf(n,t),null!=r)&&l&&(i[n]=fcom.util.PersistenceHelper.filterAttributes(r,t))}return i}}}();
//# sourceMappingURL=PersistenceHelper.js.map;
window.ngpNamespace("YAHOO.fcom");var FUtil=YAHOO.fcom.Util;function appendNzeros(e,t){for(e=e||"",t=t||2;0<t;t--)e+="0";return e}YAHOO.fcom.Parse={guessPatterns:[["([0-9]{4}\\-[0-9]{2}-[0-9]{2}\\ [0-9]{2}\\:[0-9]{2}\\:[0-9]{2})","yyyy-MM-dd HH:mm:ss","dateTimeLong"],["([0-9]{4}\\-[0-9]{2}-[0-9]{2}\\ [0-9]{2}\\:[0-9]{2})","yyyy-MM-dd HH:mm","dateTimeShort"],["([0-9]{2}\\ [a-zA-Z]{3}\\ [0-9]{4})","dd MMM yyyy","dateLongReuters"],["([0-9]{2}\\.[0-9]{2}.[0-9]{2}\\ [0-9]{2}\\:[0-9]{2})","dd.MM.yy HH:mm","dateTimeShortDE"],["([0-9]{2}\\.[0-9]{2}. [0-9]{2}\\:[0-9]{2})","dd.MM. HH:mm","dateTimeShorterDE"],["([0-9]{2}\\/[0-9]{2}\\/[0-9]{2}\\ [0-9]{2}\\:[0-9]{2})","MM/dd/yy HH:mm","dateTimeShortEN"],["([0-9]{2}\\/[0-9]{2}\\ [0-9]{2}\\:[0-9]{2})","MM/dd HH:mm","dateTimeShorterEN"],["([0-9]{4}\\-[0-9]{2}-[0-9]{2})","yyyy-MM-dd","dateLong"],["([0-9]{2}\\:[0-9]{2}\\:[0-9]{2})","HH:mm:ss","timeLong"],["([0-9]{2}\\:[0-9]{2})","HH:mm","timeShort"]],machineGuessPattern:[["([0-9]{4}\\-[0-9]{2}-[0-9]{2}\\ [0-9]{2}\\:[0-9]{2}\\:[0-9]{2})","yyyy-MM-dd HH:mm:ss","dateTime"],["([0-9]{4}\\-[0-9]{2}-[0-9]{2}\\ [0-9]{2}\\:[0-9]{2})","yyyy-MM-dd HH:mm","dateTime"],["([0-9]{2}\\ [a-zA-Z]{3}\\ [0-9]{4})","dd MMM yyyy","date"],["([0-9]{4}\\-[0-9]{2}-[0-9]{2})","yyyy-MM-dd","date"],["([0-9]{2}\\:[0-9]{2}\\:[0-9]{2})","HH:mm:ss","time"],["([0-9]{2}\\:[0-9]{2})","HH:mm","time"]],parseNumber:function(e,t){var a={original:e,error:!1};if(e=YAHOO.lang.trim(e),(t=t||{extendedInformation:!1}).extendedInformation&&0!=YAHOO.lang.isBoolean(t.extendedInformation)||(t.extendedInformation=!1),null==e||e.length<1)a.value=parseFloat("-"),a.error=!0;else{var i=new RegExp("([0-9]*)[ ]?([0-9]+)/([0-9]+)","g").exec(e);if(null!=i)a.value=parseInt(i[2])/parseInt(i[3]),i[1]&&0<i[1].length&&(a.value+=parseInt(i[1]));else{for(var n=0,r=!1;n<e.length;){if(45==(o=e.charCodeAt(n))||46==o||47<o&&o<58){r=!0;break}n++}0==r&&(a.error=!0);var o,n=(e=n<e.length?e.substring(n):e).length-1,m=!0;for(a.decimalDigits=0;0==a.error&&0<=n;){if(44==(o=e.charCodeAt(n))&&1==m)a.decimalDigits=e.length-(n+1),m=!1,e=e.substring(0,n)+"."+e.substring(n+1);else if(!(47<o&&o<58||69==o||101==o)){if(0==n&&45==o)break;1==m&&46==o?a.decimalDigits=e.length-(n+1):e=e.substring(0,n)+e.substring(n+1)}n--}a.value=parseFloat(e),1==isNaN(a.value)&&(a.error=!0)}}return 1==t.extendedInformation?a:a.value},parseLocalizedNumber:function(e,t){var a={original:e};if(e=YAHOO.lang.trim(e),t&&0!=YAHOO.lang.isBoolean(t)||(t=!1),!e||null==e||e.length<1)a.value=parseFloat("-"),a.error=!0;else{var i=FUtil.format("([\\@0@\\d]+)([\\@1@\\@2@])",[YAHOO.fcom.Format.localized.minusSign,YAHOO.fcom.Format.localized.decimalPoint,YAHOO.fcom.Format.localized.groupingCharacter]),n=new RegExp(i,"g"),r=0,o=1,m=n.exec(e),s="";if(null!=m){for(;null!=m;)""===s?(s=m[1]).charAt(0)===YAHOO.fcom.Format.localized.minusSign&&(o=-1,s=s.substring(1)):s+=""+m[1],m[2]===YAHOO.fcom.Format.localized.decimalPoint&&(s+="."),r=r+m[1].length+1,m=n.exec(e);s+=e.substring(r)}else s=e.replace(".",YAHOO.fcom.Format.localized.decimalPoint);""===s||isNaN(s)?a.value=parseFloat("-"):a.value=parseFloat(s)*o}return 1==t?a:a.value},parseMachineDate:function(e){var t={};if(!e||null==e||e.length<YAHOO.fcom.Parse.machineGuessPattern[YAHOO.fcom.Parse.machineGuessPattern.length-1][1].length)t.error='No valid date string found, only "'+e+'"';else for(var a=0;a<YAHOO.fcom.Parse.machineGuessPattern.length;a++)if(!(e.length<YAHOO.fcom.Parse.machineGuessPattern[a][1].length)){var i=YAHOO.fcom.Parse.machineGuessPattern[a][0],i=new RegExp(i).exec(e);if(null!=i&&(t.date=new fcom.date.DateTime("utc").parse(e,YAHOO.fcom.Parse.machineGuessPattern[a][1]),t.date))return t.dateStyle=YAHOO.fcom.Parse.machineGuessPattern[a][2],t}return t.date||(t.error='No matching parser found for the given date string "'+e+'"'),t},parseDate:function(e){var t={};if(!e||null==e||e.length<3)t.error='No valid date string found, only "'+e+'"';else for(var a=0;a<YAHOO.fcom.Parse.guessPatterns.length;a++){var i=YAHOO.fcom.Parse.guessPatterns[a][0],i=new RegExp(i).exec(e);if(null!=i&&(t.date=(new fcom.date.DateTime).parse(e,YAHOO.fcom.Parse.guessPatterns[a][1]),t.date))return t.dateStyle=YAHOO.fcom.Parse.guessPatterns[a][2],t}return t.date||(t.error='No matching parser found for the given date string "'+e+'"'),t},guessFormattedFloat:function(e){for(var t,a=-1,i=-1,n="",r=0;r<e.length;r++)if(i<0)"-"==e.charAt(r)?a=r:47<e.charCodeAt(r)&&e.charCodeAt(r)<58&&(i=r,n+=e.charAt(r));else if(e.charAt(r)==YAHOO.fcom.Format.localized.decimalPoint)n+=".";else if(47<e.charCodeAt(r)&&e.charCodeAt(r)<58)n+=e.charAt(r);else if(e.charAt(r)!=YAHOO.fcom.Format.localized.groupingCharacter)break;return i<0?null:(t=parseFloat(n),-1<a&&i-a<3&&(t*=-1),t)}},YAHOO.fcom.Format={DEFAULT_NUMBER_FORMAT_CONFIG:{minFractionDigits:2,maxFractionDigits:4,mio:!1,multiplier:1},MILLIONS_SCALING_DIVISOR:[1,1e6,1e9],MILLIONS_SCALE_FROM:[1,1e6,1e9],MILLIONS_POSTFIX_KEY:[null,"megaString","gigaString"],MIN_FLOAT:1e-9,localized:null,LOG_TEN:Math.log(10),formatNumber:function(e,t){if(null==e||isNaN(e))return"";t=this._checkFormatConfig(t);var a=e,e=(0==YAHOO.lang.isNumber(a)&&null!=e.value&&0==isNaN(e.value)&&(a=e.value),t.multiplier&&1!=t.multiplier&&(a*=t.multiplier),this._isZero(a)),i="",n=Math.floor(this.log10(Math.abs(a))+1),r=t.minFractionDigits,o=t.maxFractionDigits,m=(0==e&&(YAHOO.lang.isNumber(t.minSignificants)&&-1<t.minSignificants?(r=Math.max(t.minFractionDigits,-n+t.minSignificants),o=Math.max(r,o)):(m=a*Math.exp(this.LOG_TEN*o),m=Math.round(m),this._isZero(m)&&(e=!(a=0)))),null);if(0==e&&(YAHOO.lang.isNumber(t.maxSignificants)&&-1<t.maxSignificants&&(o=Math.max(0,Math.min(o,t.maxSignificants-n)),r=Math.min(r,o)),(YAHOO.lang.isNumber(t.minSignificants)&&-1<t.minSignificants||YAHOO.lang.isNumber(t.maxSignificants)&&-1<t.maxSignificants)&&(e=Math.round(a*Math.pow(10,o)),(e=Math.floor(this.log10(Math.abs(e))+1)-o)!=n)&&YAHOO.lang.isNumber(t.maxSignificants)&&-1<t.maxSignificants&&(o=Math.max(0,Math.min(o,t.maxSignificants-e)),r=Math.min(r,o)),t.mio)){for(var s=YAHOO.fcom.Format.MILLIONS_SCALE_FROM.length-1;0<s&&Math.abs(a)<YAHOO.fcom.Format.MILLIONS_SCALE_FROM[s];)s--;a/=YAHOO.fcom.Format.MILLIONS_SCALING_DIVISOR[s],null!=YAHOO.fcom.Format.MILLIONS_POSTFIX_KEY[s]&&(i=" "+YAHOO.fcom.Format.localized[YAHOO.fcom.Format.MILLIONS_POSTFIX_KEY[s]]),m=s<=0&&t.mioIntegerFormat?this.formatNumber(a,{minFractionDigits:0,maxFractionDigits:0}):this.formatNumber(a,{minFractionDigits:"undefined"!=typeof t.minFractionDigits?t.minFractionDigits:0,maxFractionDigits:"undefined"!=typeof t.maxFractionDigits?t.maxFractionDigits:4,minSignificants:"undefined"!=typeof t.minSignificants?t.minSignificants:2,maxSignificants:"undefined"!=typeof t.maxSignificants?t.maxSignificants:5})}return null==m&&(m=this.displayFloatNumber(r,o,a)),(m=YAHOO.lang.isValue(t.showPlusSign)&&!0===t.showPlusSign?YAHOO.fcom.Format.addSign(m,a):m)+i},displayFloatNumber:function(e,t,a){var i=""+a,n=i,r=i.indexOf("."),o=0;if(t<(o=-1<r?i.length-r-1:o)&&(this._isZero(a)||(0<a?a+=(5+this.MIN_FLOAT)*Math.pow(10,-(t+1)):a-=(5+this.MIN_FLOAT)*Math.pow(10,-(t+1))),o=-1<(r=(n=i=""+a).indexOf("."))?i.length-r-1:0),3<(n=-1<r?i.substring(0,r):n).length&&(n=YAHOO.fcom.Format.addGrouping(n)),-1<r&&0<t||0<e)for(n+=YAHOO.fcom.Format.localized.decimalPoint,-1<r?n+=i.substring(r+1):r=i.length,t<o?(n=n.substring(0,n.length-(o-t)),o=t):o<e&&(n=appendNzeros(n,e-o),o=e);e<o&&"0"==n.charAt(n.length-1);)o--,n=n.substring(0,n.length-1);return n},_checkFormatConfig:function(e){return e&&null!=e?(0==YAHOO.lang.isNumber(e.minFractionDigits)&&(e.minFractionDigits=YAHOO.fcom.Format.DEFAULT_NUMBER_FORMAT_CONFIG.minFractionDigits,e.maxFractionDigits)&&1==YAHOO.lang.isNumber(e.maxFractionDigits)&&e.minFractionDigits>e.maxFractionDigits&&(e.minFractionDigits=e.maxFractionDigits),0==YAHOO.lang.isNumber(e.maxFractionDigits)&&(e.maxFractionDigits=YAHOO.fcom.Format.DEFAULT_NUMBER_FORMAT_CONFIG.maxFractionDigits,e.maxFractionDigits<e.minFractionDigits)&&(e.maxFractionDigits=e.minFractionDigits),0==YAHOO.lang.isNumber(e.multiplier)&&(e.multiplier=YAHOO.fcom.Format.DEFAULT_NUMBER_FORMAT_CONFIG.multiplier),0==YAHOO.lang.isBoolean(e.mio)&&(e.mio=YAHOO.fcom.Format.DEFAULT_NUMBER_FORMAT_CONFIG.mio),e):YAHOO.fcom.Format.DEFAULT_NUMBER_FORMAT_CONFIG},_isZero:function(e){return Math.abs(e)<this.MIN_FLOAT},addSign:function(e,t){return(t=null==t?YAHOO.fcom.Parse.parseNumber(e):t)>this.MIN_FLOAT?0==!e.indexOf("+")&&(e="+"+e):this._isZero(t)&&e.indexOf("+")<0&&e.indexOf("-")<0&&(e=String.fromCharCode(177)+e),e},addGrouping:function(e){if(!e||null==e)return e;for(var t="",a=("-"==e.charAt(0)&&(t="-",e=e.substring(1)),e.length%3),i=0;i<a;)t+=e.charAt(i),i++;for(0<a&&(t+=YAHOO.fcom.Format.localized.groupingCharacter);i<e.length;)a<i&&(i-a)%3==0&&(t+=YAHOO.fcom.Format.localized.groupingCharacter),t+=e.charAt(i),i++;return t},formatDateTime:function(e,t){if(null==e)return console.error("Call to date formatter without a valid date!"),"";var a=(t=t&&null!=t?t:{style:"dateTimeLong"}).pattern;if(null==a&&null!=t.style)switch(t.style){case"timeLong":a=YAHOO.fcom.Format.localized.patternTimeLong;break;case"timeShort":a=YAHOO.fcom.Format.localized.patternTimeShort;break;case"dateShort":a=YAHOO.fcom.Format.localized.patternDateShort;break;case"dateLong":a=YAHOO.fcom.Format.localized.patternDateLong;break;case"dateTimeShort":a=YAHOO.fcom.Format.localized.patternDateTimeShort;break;case"dateTimeLong":a=YAHOO.fcom.Format.localized.patternDateTimeLong;break;case"dateForChart":a="yyyy.MM.dd";break;case"isoDate":a="yyyy-MM-dd";break;case"isoDateTime":a="yyyy-MM-dd HH:mm";break;case"isoDateTimeSeconds":a="yyyy-MM-dd HH:mm:ss"}return(!0===t.timezoneConversion||null===t.timezoneConversion||t.timezoneConversion===undefined?e.setTimezone(window.user.timezone):e.setTimezone("GMT")).format(a)},log10:function(e){return Math.log(e)/this.LOG_TEN}},null==YAHOO.fcom.Format.localized&&(YAHOO.fcom.Format.localized={decimalPoint:".",groupingCharacter:",",minusSign:"-",megaString:"mio.",gigaString:"bil.",timeZone:0,monthsShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],monthsLong:["January","February","March","April","May","June","July","August","September","October","November","December"],patternTimeShort:"hh:mm a",patternTimeLong:"hh:mm:ss a",patternDateShort:"MM/dd",patternDateLong:"MM/dd/yy",patternDateTimeShort:"MM/dd hh:mm a",patternDateTimeLong:"MM/dd//yy hh:mm:ss a"});
//# sourceMappingURL=formatNParse.js.map;
(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/** @module date/UTCDate */
window.ngpNamespace('fcom.date');

/**
 * fcom.date.UTCDate is a custom date implementations that only uses UTC time and acts as a proxy to the [native Date Object]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date}.<br/>
 * fcom.date.UTCDate is exported to the global namespace and can thus be instanciated by using <code>new window.fcom.date.UTCDate()</code>
 * @class
 * @param {number|string} [dateSpecifier] allows to possible ways to construct a date:
 *  <ul>
 *  <li>number: will be used as a timestamp</li>
 *  <li>string: will be parsed by [Date.parse]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/parse}</li>
 * </ul>
 * @param {...number} [dateNumbers] creates a date by passing multiple arguments in order for
 * <ul>
 *  <li>year</li>
 *  <li>month (january is 0)</li>
 *  <li>day</li>
 *  <li>hours</li>
 *  <li>minutes</li>
 *  <li>seconds</li>
 *  <li>milliseconds</li>
 * </ul>
 * @example <caption>Constructing without arguments</caption>
 * // returns a new UTC Date set to the current UTC time
 * new window.fcom.date.UTCDate();
 * @example <caption>Constructing with one argument</caption>
 * // returns a new UTC Date set to the first of april 2016
 * new window.fcom.date.UTCDate('2016-04-01');
 * // returns a new UTC Date set to the first of january 2000
 * new window.fcom.date.UTCDate(946681200000);
 * @example <caption>Constructing with multiple arguments</caption>
 * // returns a new UTC Date set to the 11th of april 2019, seven minutes past midnight
 * new window.fcom.date.UTCDate(2019, 3, 11, 0, 7);
 */
var UTCDate = function UTCDate() {
  this.date = new Date();
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var argCount = args.length;
  if (argCount === 1) {
    var firstArg = args[0];
    if (typeof firstArg === 'number') {
      this.date.setTime(firstArg);
    } else if (typeof firstArg === 'string') {
      this.date = Date.parse(firstArg);
    } else {
      throw new TypeError('invalid argument for UTCDate constructor');
    }
  } else if (argCount > 2) {
    var _args$ = args[0],
      year = _args$ === void 0 ? 0 : _args$,
      _args$2 = args[1],
      month = _args$2 === void 0 ? 0 : _args$2,
      _args$3 = args[2],
      day = _args$3 === void 0 ? 0 : _args$3,
      _args$4 = args[3],
      hours = _args$4 === void 0 ? 0 : _args$4,
      _args$5 = args[4],
      minutes = _args$5 === void 0 ? 0 : _args$5,
      _args$6 = args[5],
      seconds = _args$6 === void 0 ? 0 : _args$6,
      _args$7 = args[6],
      millis = _args$7 === void 0 ? 0 : _args$7;
    this.date.setTime(0); //reset the time object to have a month with 31 days
    this.date.setUTCFullYear(year);
    this.date.setUTCMonth(month);
    this.date.setUTCDate(day);
    this.date.setUTCHours(hours);
    this.date.setUTCMinutes(minutes);
    this.date.setUTCSeconds(seconds);
    this.date.setUTCMilliseconds(millis);
  }
};

// Helper functions to create function proxies that pass function arguments along
var simpleProxy = function simpleProxy(fnName) {
  return function () {
    return this[fnName].apply(this, arguments);
  };
};
var dateProxy = function dateProxy(fnName) {
  return function () {
    var _this$date;
    return (_this$date = this.date)[fnName].apply(_this$date, arguments);
  };
};

/**
 * see [Date.prototype.getTimezoneOffset]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/getTimezoneOffset}<br/>
 * will always return 0 due to the nature of a purely UTC based date format.
 * @method
 */
UTCDate.prototype.getTimezoneOffset = function () {
  return 0;
};

/**
 * see [Date.prototype.getDate]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/getDate}
 * @method
 */
UTCDate.prototype.getDate = simpleProxy('getUTCDate');
/**
 * see [Date.prototype.getDay]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/getDay}
 * @method
 */
UTCDate.prototype.getDay = simpleProxy('getUTCDay');
/**
 * see [Date.prototype.getFullYear]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/getFullYear}
 * @method
 */
UTCDate.prototype.getFullYear = simpleProxy('getUTCFullYear');
/**
 * see [Date.prototype.getHours]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/getHours}
 * @method
 */
UTCDate.prototype.getHours = simpleProxy('getUTCHours');
/**
 * see [Date.prototype.getMilliseconds]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/getMilliseconds}
 * @method
 */
UTCDate.prototype.getMilliseconds = simpleProxy('getUTCMilliseconds');
/**
 * see [Date.prototype.getMinutes]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/getMinutes}
 * @method
 */
UTCDate.prototype.getMinutes = simpleProxy('getUTCMinutes');
/**
 * see [Date.prototype.getMonth]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/getMonth}
 * @method
 */
UTCDate.prototype.getMonth = simpleProxy('getUTCMonth');
/**
 * see [Date.prototype.getSeconds]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/getSeconds}
 * @method
 */
UTCDate.prototype.getSeconds = simpleProxy('getUTCSeconds');
/**
 * see [Date.prototype.getUTCDate]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/getUTCDate}
 * @method
 */
UTCDate.prototype.getUTCDate = dateProxy('getUTCDate');
/**
 * see [Date.prototype.getUTCDay]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/getUTCDay}
 * @method
 */
UTCDate.prototype.getUTCDay = dateProxy('getUTCDay');
/**
 * see [Date.prototype.getUTCFullYear]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/getUTCFullYear}
 * @method
 */
UTCDate.prototype.getUTCFullYear = dateProxy('getUTCFullYear');
/**
 * see [Date.prototype.getUTCHours]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/getUTCHours}
 * @method
 */
UTCDate.prototype.getUTCHours = dateProxy('getUTCHours');
/**
 * see [Date.prototype.getUTCMilliseconds]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/getUTCMilliseconds}
 * @method
 */
UTCDate.prototype.getUTCMilliseconds = dateProxy('getUTCMilliseconds');
/**
 * see [Date.prototype.getUTCMinutes]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/getUTCMinutes}
 * @method
 */
UTCDate.prototype.getUTCMinutes = dateProxy('getUTCMinutes');
/**
 * see [Date.prototype.getUTCMonth]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/getUTCMonth}
 * @method
 */
UTCDate.prototype.getUTCMonth = dateProxy('getUTCMonth');
/**
 * see [Date.prototype.getUTCSeconds]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/getUTCSeconds}
 * @method
 */
UTCDate.prototype.getUTCSeconds = dateProxy('getUTCSeconds');
/**
 * see [Date.prototype.getTime]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/getTime}
 * @method
 */
UTCDate.prototype.getTime = dateProxy('getTime');

/**
 * see [Date.prototype.setDate]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/setDate}
 * @method
 */
UTCDate.prototype.setDate = simpleProxy('setUTCDate');
/**
 * see [Date.prototype.setDay]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/setDay}
 * @method
 */
UTCDate.prototype.setDay = simpleProxy('setUTCDay');
/**
 * see [Date.prototype.setFullYear]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/setFullYear}
 * @method
 */
UTCDate.prototype.setFullYear = simpleProxy('setUTCFullYear');
/**
 * see [Date.prototype.setHours]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/setHours}
 * @method
 */
UTCDate.prototype.setHours = simpleProxy('setUTCHours');
/**
 * see [Date.prototype.setMilliseconds]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/setMilliseconds}
 * @method
 */
UTCDate.prototype.setMilliseconds = simpleProxy('setUTCMilliseconds');
/**
 * see [Date.prototype.setMinutes]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/setMinutes}
 * @method
 */
UTCDate.prototype.setMinutes = simpleProxy('setUTCMinutes');
/**
 * see [Date.prototype.setMonth]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/setMonth}
 * @method
 */
UTCDate.prototype.setMonth = simpleProxy('setUTCMonth');
/**
 * see [Date.prototype.setSeconds]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/setSeconds}
 * @method
 */
UTCDate.prototype.setSeconds = simpleProxy('setUTCSeconds');
/**
 * see [Date.prototype.setUTCDate]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/setUTCDate}
 * @method
 */
UTCDate.prototype.setUTCDate = dateProxy('setUTCDate');
/**
 * see [Date.prototype.setUTCDay]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/setUTCDay}
 * @method
 */
UTCDate.prototype.setUTCDay = dateProxy('setUTCDay');
/**
 * see [Date.prototype.setUTCFullYear]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/setUTCFullYear}
 * @method
 */
UTCDate.prototype.setUTCFullYear = dateProxy('setUTCFullYear');
/**
 * see [Date.prototype.setUTCHours]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/setUTCHours}
 * @method
 */
UTCDate.prototype.setUTCHours = dateProxy('setUTCHours');
/**
 * see [Date.prototype.setUTCMilliseconds]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/setUTCMilliseconds}
 * @method
 */
UTCDate.prototype.setUTCMilliseconds = dateProxy('setUTCMilliseconds');
/**
 * see [Date.prototype.setUTCMinutes]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/setUTCMinutes}
 * @method
 */
UTCDate.prototype.setUTCMinutes = dateProxy('setUTCMinutes');
/**
 * see [Date.prototype.setUTCMonth]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/setUTCMonth}
 * @method
 */
UTCDate.prototype.setUTCMonth = dateProxy('setUTCMonth');
/**
 * see [Date.prototype.setUTCSeconds]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/setUTCSeconds}
 * @method
 */
UTCDate.prototype.setUTCSeconds = dateProxy('setUTCSeconds');
/**
 * see [Date.prototype.setTime]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/setTime}
 * @method
 */
UTCDate.prototype.setTime = dateProxy('setTime');

/**
 * see [Date.prototype.toString]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toString}
 * @method
 */
UTCDate.prototype.toString = dateProxy('toUTCString');
/**
 * see [Date.prototype.valueOf]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/valueOf}
 * @method
 */
UTCDate.prototype.valueOf = simpleProxy('getTime');

/**
 * Execute a batch of semantic date commands.<br>
 * @example <caption>to get the last sunday in april of 2011:</caption>
 * // returns 24.04.2011 00:00:00+0000
 * new UTCDate().clearTime().set({year: 2011}).batch("april, final, sunday");
 * @param {String|String[]} commands An array of command names or a comma seperated string of commands.
 * @throws {Error} If steps contains a non-existing function
 */
UTCDate.prototype.batch = function (commands) {
  var _this = this;
  if (window.ngpIsType('String', commands)) {
    commands = commands.split(',');
  }
  commands.map(function (a) {
    return a.trim();
  }).forEach(function (command) {
    if (window.ngpIsType('Function', _this[command])) {
      _this[command]();
    } else {
      throw Error("Syntactical function '".concat(command, "' is not available on the date object."));
    }
  });
  return this;
};
window.fcom.date.UTCDate = UTCDate;
var _default = exports.default = UTCDate;

},{}]},{},[1]);
;
window.ngpNamespace("fcom.date"),fcom.date.DateTime=window.exports.DateTime;
//# sourceMappingURL=DateTime.js.map;
!function(Date){Date.parseFunctions={count:0},Date.parseRegexes=[],Date.formatFunctions={count:0},Date.prototype.dateFormat=function(e){return null==Date.formatFunctions[e]&&Date.createNewFormat(e),this[Date.formatFunctions[e]]()},Date.createNewFormat=function(format){for(var funcName="format"+Date.formatFunctions.count++,code=(Date.formatFunctions[format]=funcName,"Date.prototype."+funcName+" = function(){return "),special=!1,ch="",i=0;i<format.length;++i)ch=format.charAt(i),special||"\\"!=ch?special?(special=!1,code+="'"+String.escape(ch)+"' + "):code+=Date.getFormatCode(ch):special=!0;eval(code.substring(0,code.length-3)+";}")},Date.getFormatCode=function(e){switch(e){case"d":return"String.leftPad(this.getDate(), 2, '0') + ";case"D":return"Date.dayNames[this.getDay()].substring(0, 3) + ";case"j":return"this.getDate() + ";case"l":return"Date.dayNames[this.getDay()] + ";case"S":return"this.getSuffix() + ";case"w":return"this.getDay() + ";case"z":return"this.getDayOfYear() + ";case"W":return"this.getWeekOfYear() + ";case"F":return"Date.monthNames[this.getMonth()] + ";case"m":return"String.leftPad(this.getMonth() + 1, 2, '0') + ";case"M":return"Date.monthNamesShort[this.getMonth()] + ";case"n":return"(this.getMonth() + 1) + ";case"t":return"this.getDaysInMonth() + ";case"L":return"(this.isLeapYear() ? 1 : 0) + ";case"Y":return"this.getFullYear() + ";case"y":return"('' + this.getFullYear()).substring(2, 4) + ";case"a":return"(this.getHours() < 12 ? 'am' : 'pm') + ";case"A":return"(this.getHours() < 12 ? 'AM' : 'PM') + ";case"g":return"((this.getHours() %12) ? this.getHours() % 12 : 12) + ";case"G":return"this.getHours() + ";case"h":return"String.leftPad((this.getHours() %12) ? this.getHours() % 12 : 12, 2, '0') + ";case"H":return"String.leftPad(this.getHours(), 2, '0') + ";case"i":return"String.leftPad(this.getMinutes(), 2, '0') + ";case"s":return"String.leftPad(this.getSeconds(), 2, '0') + ";case"O":return"this.getGMTOffset() + ";case"T":return"'T' + ";case"Z":return"'' + ";default:return"'"+String.escape(e)+"' + "}},Date.parseDate=function(e,t){null==Date.parseFunctions[t]&&Date.createParser(t);t=Date.parseFunctions[t];return Date[t](Date,e)},Date.fromJavaPattern=function(e){if(Date.fromJavaPatternMap||(Date.fromJavaPatternMap={count:0}),(s=Date.fromJavaPatternMap[e])&&null!=s)return s;s=e;for(var t=0;t<Date.fromJavaPatternRegExes.length;t++)for(var a=new RegExp(Date.fromJavaPatternRegExes[t][0]),r=a.exec(s);null!=r;)var n=Date.fromJavaPatternRegExes[t][1].charCodeAt(0),s=s.replace(a,isNaN(n)?"":String.fromCharCode(n+57344)),r=a.exec(s);for(var u="",t=0;t<s.length;t++)57344<=s.charCodeAt(t)&&s.charCodeAt(t)<=57470?u+=String.fromCharCode(s.charCodeAt(t)-57344):u+=s.charAt(t);return Date.fromJavaPatternMap[e]=u},Date.createParser=function(format){for(var funcName="parse"+Date.parseFunctions.count++,regexNum=Date.parseRegexes.length,currentGroup=1,code=(Date.parseFunctions[format]=funcName,"Date."+funcName+" = function(Date, input){\nvar y = -1, m = -1, d = -1, h = -1, i = -1, s = -1;\nvar d = new Date();\ny = d.getFullYear();\nm = d.getMonth();\nd = d.getDate();\nvar results = input.match(Date.parseRegexes["+regexNum+"]);\nif (results && results.length > 0) {"),regex="",special=!1,ch="",i=0;i<format.length;++i){var obj,ch=format.charAt(i);special||"\\"!=ch?special?(special=!1,regex+=String.escape(ch)):(obj=Date.formatCodeToRegex(ch,currentGroup),currentGroup+=obj.g,regex+=obj.s,obj.g&&obj.c&&(code+=obj.c)):special=!0}code+="if (y > 0 && m >= 0 && d > 0 && h >= 0 && i >= 0 && s >= 0)\n{return new Date(y, m, d, h, i, s);}\nelse if (y > 0 && m >= 0 && d > 0 && h >= 0 && i >= 0)\n{return new Date(y, m, d, h, i);}\nelse if (y > 0 && m >= 0 && d > 0 && h >= 0)\n{return new Date(y, m, d, h);}\nelse if (y > 0 && m >= 0 && d > 0)\n{return new Date(y, m, d);}\nelse if (y > 0 && m >= 0)\n{return new Date(y, m);}\nelse if (y > 0)\n{return new Date(y);}\n}return null;}",Date.parseRegexes[regexNum]=new RegExp("^"+regex+"$","i"),eval(code)},Date.formatCodeToRegex=function(e,t){switch(e){case"D":return{g:0,c:null,s:"(?:Sun|Mon|Tue|Wed|Thu|Fri|Sat)"};case"j":case"d":return{g:1,c:"d = parseInt(results["+t+"], 10);\n",s:"(\\d{1,2})"};case"l":return{g:0,c:null,s:"(?:"+Date.dayNames.join("|")+")"};case"S":return{g:0,c:null,s:"(?:st|nd|rd|th)"};case"w":return{g:0,c:null,s:"\\d"};case"z":return{g:0,c:null,s:"(?:\\d{1,3})"};case"W":return{g:0,c:null,s:"(?:\\d{2})"};case"F":return{g:1,c:"m = parseInt(Date.monthNumbers[results["+t+"].substring(0, 3).toLowerCase()], 10);\n",s:"("+Date.monthNames.join("|")+")"};case"M":return{g:1,c:"m = parseInt(Date.monthNumbers[results["+t+"].toLowerCase()], 10);\n",s:"(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)"};case"n":case"m":return{g:1,c:"m = parseInt(results["+t+"], 10) - 1;\n",s:"(\\d{1,2})"};case"t":return{g:0,c:null,s:"\\d{1,2}"};case"L":return{g:0,c:null,s:"(?:1|0)"};case"Y":return{g:1,c:"y = parseInt(results["+t+"], 10);\n",s:"(\\d{4})"};case"y":return{g:1,c:"var ty = parseInt(results["+t+"], 10);\ny = ty > Date.y2kYear ? 1900 + ty : 2000 + ty;\n",s:"(\\d{1,2})"};case"a":return{g:1,c:"if (results["+t+"] == 'am') {\nif (h == 12) { h = 0; }\n} else { if (h < 12) { h += 12; }}",s:"(am|pm)"};case"A":return{g:1,c:"if (results["+t+"] == 'AM') {\nif (h == 12) { h = 0; }\n} else { if (h < 12) { h += 12; }}",s:"(AM|PM)"};case"g":case"G":case"h":case"H":return{g:1,c:"h = parseInt(results["+t+"], 10);\n",s:"(\\d{1,2})"};case"i":return{g:1,c:"i = parseInt(results["+t+"], 10);\n",s:"(\\d{2})"};case"s":return{g:1,c:"s = parseInt(results["+t+"], 10);\n",s:"(\\d{2})"};case"O":return{g:0,c:null,s:"[+-]\\d{4}"};case"T":return{g:0,c:null,s:"[T]{1}"};case"Z":return{g:0,c:null,s:"[+-]\\d{1,5}"};default:return{g:0,c:null,s:String.escape(e)}}},Date.prototype.getTimezone=function(){return this.toString().replace(/^.*? ([A-Z]{3}) [0-9]{4}.*$/,"$1").replace(/^.*?\(([A-Z])[a-z]+ ([A-Z])[a-z]+ ([A-Z])[a-z]+\)$/,"$1$2$3")},Date.prototype.getGMTOffset=function(){return(0<this.getTimezoneOffset()?"-":"+")+String.leftPad(Math.abs(Math.floor(this.getTimezoneOffset()/60)),2,"0")+String.leftPad(this.getTimezoneOffset()%60,2,"0")},Date.prototype.getDayOfYear=function(){var e=0;Date.daysInMonth[1]=this.isLeapYear()?29:28;for(var t=0;t<this.getMonth();++t)e+=Date.daysInMonth[t];return e+this.getDate()-1},Date.prototype.getWeekOfYear=function(){var e=this.getDayOfYear()+(4-this.getDay()),t=7-new Date(this.getFullYear(),0,1).getDay()+4;return document.write(t),String.leftPad((e-t)/7+1,2,"0")},Date.prototype.isLeapYear=function(){var e=this.getFullYear();return 0==(3&e)&&(e%100||e%400==0&&e)},Date.prototype.getFirstDayOfMonth=function(){var e=(this.getDay()-(this.getDate()-1))%7;return e<0?7+e:e},Date.prototype.getLastDayOfMonth=function(){var e=(this.getDay()+(Date.daysInMonth[this.getMonth()]-this.getDate()))%7;return e<0?7+e:e},Date.prototype.getDaysInMonth=function(){return Date.daysInMonth[1]=this.isLeapYear()?29:28,Date.daysInMonth[this.getMonth()]},Date.prototype.getSuffix=function(){switch(this.getDate()){case 1:case 21:case 31:return"st";case 2:case 22:return"nd";case 3:case 23:return"rd";default:return"th"}},String.escape=function(e){return e.replace(/('|\\)/g,"\\$1")},String.leftPad=function(e,t,a){var r=new String(e);for(null==a&&(a=" ");r.length<t;)r=a+r;return r},Date.daysInMonth=[31,28,31,30,31,30,31,31,30,31,30,31],Date.monthNames=["January","February","March","April","May","June","July","August","September","October","November","December"],Date.monthNamesShort=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],Date.dayNames=["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],Date.y2kYear=50,Date.monthNumbers={jan:0,feb:1,mar:2,apr:3,may:4,jun:5,jul:6,aug:7,sep:8,oct:9,nov:10,dec:11},Date.patterns={ISO8601LongPattern:"Y-m-d H:i:s",ISO8601ShortPattern:"Y-m-d",ShortDatePattern:"n/j/Y",LongDatePattern:"l, F d, Y",FullDateTimePattern:"l, F d, Y g:i:s A",MonthDayPattern:"F d",ShortTimePattern:"g:i A",LongTimePattern:"g:i:s A",SortableDateTimePattern:"Y-m-d\\TH:i:s",UniversalSortableDateTimePattern:"Y-m-d H:i:sO",YearMonthPattern:"F, Y"},Date.fromJavaPatternRegExes=[["[y]{4,}","Y"],["[y]{1,3}","y"],["[M]{4,}","F"],["[M]{3}","M"],["[M]{1,2}","m"],["[w]+","W"],["[F]+","w"],["[D]+","z"],["[d]+","d"],["[E]{4,}","l"],["[E]{1,3}","D"],["[a]+","A"],["[H]+","H"],["[h]+","h"],["[m]+","i"],["[s]+","s"],["[Z]{1}",""]]}(fcom.date.UTCDate);
//# sourceMappingURL=date-functions.js.map;
fcom.date.UTCDate.CultureInfo={name:"en-GB",englishName:"English (United Kingdom)",nativeName:"English (United Kingdom)",dayNames:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],abbreviatedDayNames:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],shortestDayNames:["Su","Mo","Tu","We","Th","Fr","Sa"],firstLetterDayNames:["S","M","T","W","T","F","S"],monthNames:["January","February","March","April","May","June","July","August","September","October","November","December"],abbreviatedMonthNames:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],amDesignator:"AM",pmDesignator:"PM",firstDayOfWeek:1,twoDigitYearMax:2029,dateElementOrder:"dmy",formatPatterns:{shortDate:"dd/MM/yyyy",longDate:"dd MMMM yyyy",shortTime:"HH:mm",longTime:"HH:mm:ss",fullDateTime:"dd MMMM yyyy HH:mm:ss",sortableDateTime:"yyyy-MM-ddTHH:mm:ss",universalSortableDateTime:"yyyy-MM-dd HH:mm:ssZ",rfc1123:"ddd, dd MMM yyyy HH:mm:ss GMT",monthDay:"dd MMMM",yearMonth:"MMMM yyyy"},regexPatterns:{jan:/^jan(uary)?/i,feb:/^feb(ruary)?/i,mar:/^mar(ch)?/i,apr:/^apr(il)?/i,may:/^may/i,jun:/^jun(e)?/i,jul:/^jul(y)?/i,aug:/^aug(ust)?/i,sep:/^sep(t(ember)?)?/i,oct:/^oct(ober)?/i,nov:/^nov(ember)?/i,dec:/^dec(ember)?/i,sun:/^su(n(day)?)?/i,mon:/^mo(n(day)?)?/i,tue:/^tu(e(s(day)?)?)?/i,wed:/^we(d(nesday)?)?/i,thu:/^th(u(r(s(day)?)?)?)?/i,fri:/^fr(i(day)?)?/i,sat:/^sa(t(urday)?)?/i,future:/^next/i,past:/^last|past|prev(ious)?/i,add:/^(\+|aft(er)?|from|hence)/i,subtract:/^(\-|bef(ore)?|ago)/i,yesterday:/^yes(terday)?/i,today:/^t(od(ay)?)?/i,tomorrow:/^tom(orrow)?/i,now:/^n(ow)?/i,millisecond:/^ms|milli(second)?s?/i,second:/^sec(ond)?s?/i,minute:/^mn|min(ute)?s?/i,hour:/^h(our)?s?/i,week:/^w(eek)?s?/i,month:/^m(onth)?s?/i,day:/^d(ay)?s?/i,year:/^y(ear)?s?/i,shortMeridian:/^(a|p)/i,longMeridian:/^(a\.?m?\.?|p\.?m?\.?)/i,timezone:/^((e(s|d)t|c(s|d)t|m(s|d)t|p(s|d)t)|((gmt)?\s*(\+|\-)\s*\d\d\d\d?)|gmt|utc)/i,ordinalSuffix:/^\s*(st|nd|rd|th)/i,timeContext:/^\s*(\:|a(?!u|p)|p)/i},timezones:[{name:"UTC",offset:"-000"},{name:"GMT",offset:"-000"},{name:"EST",offset:"-0500"},{name:"EDT",offset:"-0400"},{name:"CST",offset:"-0600"},{name:"CDT",offset:"-0500"},{name:"MST",offset:"-0700"},{name:"MDT",offset:"-0600"},{name:"PST",offset:"-0800"},{name:"PDT",offset:"-0700"}]},function(n){var r,a,o,s=n,e=s.prototype,u=s.CultureInfo,i=function(e,t){return("000"+e).slice(-1*(t=t||2))},h=(e.clearTime=function(){return this.setHours(0),this.setMinutes(0),this.setSeconds(0),this.setMilliseconds(0),this},e.setTimeToNow=function(){var e=new n;return this.setHours(e.getHours()),this.setMinutes(e.getMinutes()),this.setSeconds(e.getSeconds()),this.setMilliseconds(e.getMilliseconds()),this},s.today=function(){return(new n).clearTime()},s.compare=function(e,t){if(isNaN(e)||isNaN(t))throw new Error(e+" - "+t);if(e instanceof n&&t instanceof n)return e<t?-1:t<e?1:0;throw new TypeError(e+" - "+t)},s.equals=function(e,t){return 0===e.compareTo(t)},s.getDayNumberFromName=function(e){for(var t=u.dayNames,n=u.abbreviatedDayNames,s=u.shortestDayNames,i=e.toLowerCase(),r=0;r<t.length;r++)if(t[r].toLowerCase()==i||n[r].toLowerCase()==i||s[r].toLowerCase()==i)return r;return-1},s.getMonthNumberFromName=function(e){for(var t=u.monthNames,n=u.abbreviatedMonthNames,s=e.toLowerCase(),i=0;i<t.length;i++)if(t[i].toLowerCase()==s||n[i].toLowerCase()==s)return i;return-1},s.isLeapYear=function(e){return e%4==0&&e%100!=0||e%400==0},s.getDaysInMonth=function(e,t){return[31,s.isLeapYear(e)?29:28,31,30,31,30,31,31,30,31,30,31][t]},s.getTimezoneAbbreviation=function(e){for(var t=u.timezones,n=0;n<t.length;n++)if(t[n].offset===e)return t[n].name;return null},s.getTimezoneOffset=function(e){for(var t=u.timezones,n=0;n<t.length;n++)if(t[n].name===e.toUpperCase())return t[n].offset;return null},e.clone=function(){return new n(this.getTime())},e.compareTo=function(e){return n.compare(this,e)},e.equals=function(e){return n.equals(this,e||new n)},e.between=function(e,t){return this.getTime()>=e.getTime()&&this.getTime()<=t.getTime()},e.isAfter=function(e){return 1===this.compareTo(e||new n)},e.isBefore=function(e){return-1===this.compareTo(e||new n)},e.isToday=e.isSameDay=function(e){return this.clone().clearTime().equals((e||new n).clone().clearTime())},e.addMilliseconds=function(e){return this.setMilliseconds(this.getMilliseconds()+ +e),this},e.addSeconds=function(e){return this.addMilliseconds(1e3*e)},e.addMinutes=function(e){return this.addMilliseconds(6e4*e)},e.addHours=function(e){return this.addMilliseconds(36e5*e)},e.addDays=function(e){return this.setDate(this.getDate()+ +e),this},e.addWeeks=function(e){return this.addDays(7*e)},e.addMonths=function(e){var t=this.getDate();return this.setDate(1),this.setMonth(this.getMonth()+ +e),this.setDate(Math.min(t,s.getDaysInMonth(this.getFullYear(),this.getMonth()))),this},e.addYears=function(e){return this.addMonths(12*e)},e.add=function(e){return"number"==typeof e?this._orient=e:((e=e).milliseconds&&this.addMilliseconds(e.milliseconds),e.seconds&&this.addSeconds(e.seconds),e.minutes&&this.addMinutes(e.minutes),e.hours&&this.addHours(e.hours),e.weeks&&this.addWeeks(e.weeks),e.months&&this.addMonths(e.months),e.years&&this.addYears(e.years),e.days&&this.addDays(e.days)),this},e.getWeek=function(){var e,t,n,s,i;return r=r||this.getFullYear(),a=a||this.getMonth()+1,o=o||this.getDate(),n=a<=2?(i=(e=((s=r-1)/4|0)-(s/100|0)+(s/400|0))-(((s-1)/4|0)-((s-1)/100|0)+((s-1)/400|0)),t=0,o-1+31*(a-1)):(t=(i=(e=((s=r)/4|0)-(s/100|0)+(s/400|0))-(((s-1)/4|0)-((s-1)/100|0)+((s-1)/400|0)))+1,o+(153*(a-3)+2)/5+58+i),r=a=o=null,(s=n+3-(n+(n=(s+e)%7)-t)%7|0)<0?53-((n-i)/5|0):364+i<s?1:1+(s/7|0)},e.getISOWeek=function(){return r=this.getUTCFullYear(),a=this.getUTCMonth()+1,o=this.getUTCDate(),i(this.getWeek())},e.setWeek=function(e){return this.moveToDayOfWeek(1).addWeeks(e-this.getWeek())},function(e,t,n,s){if(void 0===e)return!1;if("number"!=typeof e)throw new TypeError(e+" is not a Number.");if(e<t||n<e)throw new RangeError(e+" is not a valid value for "+s+".");return!0});s.validateMillisecond=function(e){return h(e,0,999,"millisecond")},s.validateSecond=function(e){return h(e,0,59,"second")},s.validateMinute=function(e){return h(e,0,59,"minute")},s.validateHour=function(e){return h(e,0,23,"hour")},s.validateDay=function(e,t,n){return h(e,1,s.getDaysInMonth(t,n),"day")},s.validateMonth=function(e){return h(e,0,11,"month")},s.validateYear=function(e){return h(e,0,9999,"year")},e.set=function(e){return s.validateMillisecond(e.millisecond)&&this.addMilliseconds(e.millisecond-this.getMilliseconds()),s.validateSecond(e.second)&&this.addSeconds(e.second-this.getSeconds()),s.validateMinute(e.minute)&&this.addMinutes(e.minute-this.getMinutes()),s.validateHour(e.hour)&&this.addHours(e.hour-this.getHours()),s.validateMonth(e.month)&&this.addMonths(e.month-this.getMonth()),s.validateYear(e.year)&&this.addYears(e.year-this.getFullYear()),s.validateDay(e.day,this.getFullYear(),this.getMonth())&&this.addDays(e.day-this.getDate()),e.timezone&&this.setTimezone(e.timezone),e.timezoneOffset&&this.setTimezoneOffset(e.timezoneOffset),e.week&&h(e.week,0,53,"week")&&this.setWeek(e.week),this},e.moveToFirstDayOfMonth=function(){return this.set({day:1})},e.moveToLastDayOfMonth=function(){return this.set({day:s.getDaysInMonth(this.getFullYear(),this.getMonth())})},e.moveToNthOccurrence=function(e,t){var n=0;if(0<t)n=t-1;else if(-1===t)return this.moveToLastDayOfMonth(),this.getDay()!==e&&this.moveToDayOfWeek(e,-1),this;return this.moveToFirstDayOfMonth().addDays(-1).moveToDayOfWeek(e,1).addWeeks(n)},e.moveToDayOfWeek=function(e,t){e=(e-this.getDay()+7*(t||1))%7;return this.addDays(0===e?e+=7*(t||1):e)},e.moveToMonth=function(e,t){e=(e-this.getMonth()+12*(t||1))%12;return this.addMonths(0===e?e+=12*(t||1):e)},e.getOrdinalNumber=function(){return Math.ceil((this.clone().clearTime()-new n(this.getFullYear(),0,1))/864e5)+1},e.getTimezone=function(){return s.getTimezoneAbbreviation(this.getUTCOffset())},e.setTimezoneOffset=function(e){var t=this.getTimezoneOffset(),e=-6*Number(e)/10;return this.addMinutes(e-t)},e.setTimezone=function(e){return this.setTimezoneOffset(s.getTimezoneOffset(e))},e.hasDaylightSavingTime=function(){return n.today().set({month:0,day:1}).getTimezoneOffset()!==n.today().set({month:6,day:1}).getTimezoneOffset()},e.isDaylightSavingTime=function(){return n.today().set({month:0,day:1}).getTimezoneOffset()!=this.getTimezoneOffset()},e.getUTCOffset=function(){var e,t=-10*this.getTimezoneOffset()/6;return t<0?(e=(t-1e4).toString()).charAt(0)+e.substr(2):"+"+(e=(1e4+t).toString()).substr(1)},e.getElapsed=function(e){return(e||new n)-this},e.toISOString||(e.toISOString=function(){function e(e){return e<10?"0"+e:e}return'"'+this.getUTCFullYear()+"-"+e(this.getUTCMonth()+1)+"-"+e(this.getUTCDate())+"T"+e(this.getUTCHours())+":"+e(this.getUTCMinutes())+":"+e(this.getUTCSeconds())+'Z"'}),e._toString=e.toString,e.toString=function(e){var t=this;if(e&&1==e.length){var n=u.formatPatterns;switch(t.t=t.toString,e){case"d":return t.t(n.shortDate);case"D":return t.t(n.longDate);case"F":return t.t(n.fullDateTime);case"m":return t.t(n.monthDay);case"r":return t.t(n.rfc1123);case"s":return t.t(n.sortableDateTime);case"t":return t.t(n.shortTime);case"T":return t.t(n.longTime);case"u":return t.t(n.universalSortableDateTime);case"y":return t.t(n.yearMonth)}}return e?e.replace(/(\\)?(dd?d?d?|MM?M?M?|yy?y?y?|hh?|HH?|mm?|ss?|tt?|S)/g,function(e){if("\\"===e.charAt(0))return e.replace("\\","");switch(t.h=t.getHours,e){case"hh":return i(t.h()<13?0===t.h()?12:t.h():t.h()-12);case"h":return t.h()<13?0===t.h()?12:t.h():t.h()-12;case"HH":return i(t.h());case"H":return t.h();case"mm":return i(t.getMinutes());case"m":return t.getMinutes();case"ss":return i(t.getSeconds());case"s":return t.getSeconds();case"yyyy":return i(t.getFullYear(),4);case"yy":return i(t.getFullYear());case"dddd":return u.dayNames[t.getDay()];case"ddd":return u.abbreviatedDayNames[t.getDay()];case"dd":return i(t.getDate());case"d":return t.getDate();case"MMMM":return u.monthNames[t.getMonth()];case"MMM":return u.abbreviatedMonthNames[t.getMonth()];case"MM":return i(t.getMonth()+1);case"M":return t.getMonth()+1;case"t":return(t.h()<12?u.amDesignator:u.pmDesignator).substring(0,1);case"tt":return t.h()<12?u.amDesignator:u.pmDesignator;case"S":switch(+t.getDate()){case 1:case 21:case 31:return"st";case 2:case 22:return"nd";case 3:case 23:return"rd";default:return"th"}return;default:return e}}):this._toString()}}(fcom.date.UTCDate),function(a){for(var e,s=a,t=s.prototype,i=s.CultureInfo,n=Number.prototype,r=(t._orient=1,t._nth=null,t._is=!1,t._same=!1,t._isSecond=!1,n._dateElement="day",t.next=function(){return this._orient=1,this},s.next=function(){return s.today().next()},t.last=t.prev=t.previous=function(){return this._orient=-1,this},s.last=s.prev=s.previous=function(){return s.today().last()},t.is=function(){return this._is=!0,this},t.same=function(){return this._same=!0,this._isSecond=!1,this},t.today=function(){return this.same().day()},t.weekday=function(){return!!this._is&&(this._is=!1,!this.is().sat())&&!this.is().sun()},t.at=function(e){return"string"==typeof e?s.parse(this.toString("d")+" "+e):this.set(e)},n.fromNow=n.after=function(e){var t={};return t[this._dateElement]=this,(e?e.clone():new a).add(t)},n.ago=n.before=function(e){var t={};return t[this._dateElement]=-1*this,(e?e.clone():new a).add(t)},"sunday monday tuesday wednesday thursday friday saturday".split(/\s/)),o="january february march april may june july august september october november december".split(/\s/),u="Millisecond Second Minute Hour Day Week Month Year".split(/\s/),h="Milliseconds Seconds Minutes Hours Date Week Month FullYear".split(/\s/),d="final first second third fourth fifth".split(/\s/),c=(t.toObject=function(){for(var e={},t=0;t<u.length;t++)e[u[t].toLowerCase()]=this["get"+h[t]]();return e},s.fromObject=function(e){return e.week=null,a.today().set(e)},0);c<r.length;c++)s[r[c].toUpperCase()]=s[r[c].toUpperCase().substring(0,3)]=c,s[r[c]]=s[r[c].substring(0,3)]=function(n){return function(){var e=s.today(),t=n-e.getDay();return 0===n&&1===i.firstDayOfWeek&&0!==e.getDay()&&(t+=7),e.addDays(t)}}(c),t[r[c]]=t[r[c].substring(0,3)]=function(n){return function(){if(this._is)return this._is=!1,this.getDay()==n;if(null===this._nth)return this.moveToDayOfWeek(n,this._orient);this._isSecond&&this.addSeconds(-1*this._orient),this._isSecond=!1;var e=this._nth,t=(this._nth=null,this.clone().moveToLastDayOfMonth());if(this.moveToNthOccurrence(n,e),t<this)throw new RangeError(s.getDayName(n)+" does not occur "+e+" times in the month of "+s.getMonthName(t.getMonth())+" "+t.getFullYear()+".");return this}}(c);for(var f=0;f<o.length;f++)s[o[f].toUpperCase()]=s[o[f].toUpperCase().substring(0,3)]=f,s[o[f]]=s[o[f].substring(0,3)]=function(e){return function(){return s.today().set({month:e,day:1})}}(f),t[o[f]]=t[o[f].substring(0,3)]=function(e){return function(){return this._is?(this._is=!1,this.getMonth()===e):this.moveToMonth(e,this._orient)}}(f);for(var m=function(r){return function(){if(this._isSecond)return this._isSecond=!1,this;if(this._same){this._same=this._is=!1;for(var e,t=this.toObject(),n=(arguments[0]||new a).toObject(),s=r.toLowerCase(),i=u.length-1;-1<i;i--){if(t[e=u[i].toLowerCase()]!=n[e])return!1;if(s==e)break}return!0}return"s"!=r.substring(r.length-1)&&(r+="s"),this["add"+r](this._orient)}},l=0;l<u.length;l++)t[e=u[l].toLowerCase()]=t[e+"s"]=m(u[l]),n[e]=n[e+"s"]=function(e){return function(){return this._dateElement=e,this}}(e);t._ss=m("Second");for(var y=function(t){return function(e){return this._same?this._ss(e):e||0===e?this.moveToNthOccurrence(e,t):2!==(this._nth=t)||e!==undefined&&null!==e?this:(this._isSecond=!0,this.addSeconds(this._orient))}},g=0;g<d.length;g++)t[d[g]]=y(0===g?-1:g)}(fcom.date.UTCDate);
//# sourceMappingURL=datejs.js.map;
window.ngpNamespace("fcom.util"),fcom.util.Converter={CONVERT_TEXT_NUMBER_BACK:function(t){return fcom.util.StringHelper.empty(t)?null:YAHOO.fcom.Parse.parseLocalizedNumber(t)},CONVERT_TEXT_NUMBER_PERCENTAGE_BACK:function(t){return fcom.util.StringHelper.empty(t)?null:YAHOO.fcom.Parse.parseLocalizedNumber(t.replace("%",""))},CONVERT_TEXT_PRICE:function(t){return null===t||isNaN(t)?"":YAHOO.fcom.Format.formatNumber(t,{minFractionDigits:2,maxFractionDigits:4})},CONVERT_TEXT_CURRENCY:function(t){return null===t||isNaN(t)?"":YAHOO.fcom.Format.formatNumber(t,{minFractionDigits:2,maxFractionDigits:2})},CONVERT_TEXT_EXCHANGE_RATE:function(t){return null===t||isNaN(t)?"":YAHOO.fcom.Format.formatNumber(t,{minFractionDigits:2,maxFractionDigits:5,minSignificants:5,maxSignificants:-1})},CONVERT_TEXT_INTEGER:function(t){return null==t||isNaN(t)?"":YAHOO.fcom.Format.formatNumber(t,{minFractionDigits:0,maxFractionDigits:0})},CONVERT_TEXT_INTEGER_BACK:function(t){return fcom.util.Converter.CONVERT_TEXT_NUMBER_BACK(t)},CONVERT_TEXT_DATE_LONG:function(t){t=fcom.util.Converter.CONVERT_DATE(t);return t instanceof fcom.date.DateTime?t.format(YAHOO.fcom.Format.localized.patternDateTimeLong):""},CONVERT_TEXT_DATE_LONG_BACK:function(t){return(new fcom.date.DateTime).parse(t,YAHOO.fcom.Format.localized.patternDateTimeLong)},CONVERT_DATE:function(t){var i=t;return window.ngpIsType("Number",t)?i=(new fcom.date.DateTime).setTimestamp(t):window.ngpIsType("String",t)&&(i=fcom.date.DateTime.deserialize(t))&&i.setTimezone(window.user.timezone),i},CONVERT_ENUM_TEXT:function(t){return t.value},CONVERT_ENUM_TEXT_BACK:function(t){return{name:t,value:t}},CONVERT_CHANGE_TEXT:function(t){return null===t||isNaN(t)?"":YAHOO.fcom.Format.addSign(YAHOO.fcom.Format.formatNumber(t,{minFractionDigits:2,maxFractionDigits:3}))},CONVERT_VOLUME_TEXT:function(t){return null===t||isNaN(t)?"":YAHOO.fcom.Format.formatNumber(t,{minFractionDigits:1,maxFractionDigits:2,mio:!0})},CONVERT_GPS_TEXT:function(t){return null===t||isNaN(t)?"":YAHOO.fcom.Format.formatNumber(t,{minFractionDigits:2,maxFractionDigits:2})}};
//# sourceMappingURL=Converter.js.map;
window.ngpNamespace("fcom.util"),fcom.util.DataBinding=function(t,e){for(var n in this.values={},YAHOO.lang.augmentObject(this.values,e),this.mapping=t){var i;null!=t[n]&&(i=t[n],null!=this.values[n]&&i.adapter.setValue(i.convert.call(this,this.values[n])),this.values[n]=i.convertBack.call(this,i.adapter.getValue()),i.adapter.changeEvent.subscribe(this.valueChanged,i,this))}this.validationError=new YAHOO.util.CustomEvent("validationError"),this.validationSuccess=new YAHOO.util.CustomEvent("validationSuccess"),this.beforeUserInputChanged=new YAHOO.util.CustomEvent("beforeUserInputChanged"),this.userInputChanged=new YAHOO.util.CustomEvent("userInputChanged"),this.initialValues={},YAHOO.lang.augmentObject(this.initialValues,this.values),this.markedFields=[],this.beforeUserInputChanged.subscribe(function(){this.unmarkFields()},this,!0)},fcom.util.DataBinding.prototype={get:function(t){return this.values[t]},set:function(t,e,n){var i;null!=this.mapping[t]?((i=this.mapping[t]).adapter.setValue(i.convert.call(this,e)),this.values[t]=i.convertBack.call(this,i.adapter.getValue()),this.validateField(t,n),!0!==n&&this.markField(t)):this.values[t]=e},setValues:function(t,e){for(var n in t){var i;void 0!==n&&(null==(i=t[n])&&e&&(i=this.initialValues[n]),this.set(n,i,!0))}},resetValues:function(){for(var t in this.unmarkFields(),this.values){var e;void 0!==t&&(e=null==this.initialValues[t]?null:this.initialValues[t],this.set(t,e,!0))}},validate:function(t){var e,n=!0;for(e in this.mapping)void 0===e||this.validateField(e,t)||(n=!1);return n},getElement:function(t){t=this.mapping[t];if(t)return t.adapter.element},getMarkableElement:function(t){t=this.mapping[t];if(t)return t.adapter.getMarkableElement()},validateField:function(t,e){e=e||!1;var n=this.mapping[t];if(n){var i=n.adapter.getValue(),a=n.convertBack.call(this,i),l=null;if(n.validate&&!0!==(l=n.validate.call(this,a,t)))return this.unmarkFields(),e||this.validationError.fire(t,i,l,n.adapter.getMarkableElement()),!1;e||this.validationSuccess.fire(t,n.adapter.getMarkableElement())}return!0},toPostData:function(t){t=fcom.util.PersistenceHelper.filterAttributes(this.values,t);return YAHOO.fcom.Util.createPostData(t)},getValues:function(){return this.values},valueChanged:function(t,e,n){var i;this.validateField(n.name)&&(this.beforeUserInputChanged.fire(n.name),this.values[n.name]=n.convertBack.call(this,n.adapter.getValue()),(i=n.onChange)&&window.ngpIsType("Function",i.fn)&&i.fn.call(i.scope||this,this,i.args,n.name),this.userInputChanged.fire(n.name))},markField:function(t){var e=this.mapping[t];e.markFields&&(null==this.markedFields&&(this.markedFields=[]),this.markedFields.push(t),t=this.getMarkableElement(t),YAHOO.util.Dom.addClass(t,e.markFields))},unmarkFields:function(){if(this.markedFields&&0<this.markedFields.length){for(var t=this.markedFields.length;t--;){var e=this.getMarkableElement(this.markedFields[t]),n=this.mapping[this.markedFields[t]];e&&n&&YAHOO.util.Dom.removeClass(e,n.markFields)}this.markedFields=[]}}},fcom.util.DataBinding.link=function(t,e,n){e=e||{},n=n||{};for(var i={},a=YAHOO.util.Selector.query("select, input, textarea, span.dataLink, div.dataLink",t),l=a.length;l--;){var u=a[l],r=null,o=YAHOO.fcom.Page.getInstance(u.id);null==(r=null!=o?window.ngpIsType("Function",o.getInputAdapter)?o.getInputAdapter():this.adapterForHandler(o):YAHOO.util.Dom.hasClass(u,"dataLink")?new fcom.util.HTMLElementAdapter(u):YAHOO.util.Dom.hasClass(u,"radio")&&YAHOO.util.Dom.hasClass(u,"unformatted")?(o=this.getElementsByElementName(u.name,a),this.adapterForElement(u,o)):this.adapterForElement(u))||fcom.util.StringHelper.empty(r.name)||null!=i[r.name]||(o={name:r.name,adapter:r,convert:function(t){return t},convertBack:function(t){return t}},YAHOO.lang.augmentObject(o,e[r.name]||{},!0),i[r.name]=o)}return new fcom.util.DataBinding(i,n)},fcom.util.DataBinding.adapterForHandler=function(t){return t instanceof YAHOO.fcom.DropMenu?new fcom.util.DropMenuAdapter(t):t instanceof fcom.Select?new fcom.util.SelectAdapter(t):t instanceof YAHOO.fcom.Checkbox?new fcom.util.CheckboxAdapter(t):t instanceof YAHOO.fcom.Radio?new fcom.util.RadioButtonAdapter(t):t instanceof YAHOO.fcom.PopupSearchInput?new fcom.util.PopupSearchInputAdapter(t):t instanceof YAHOO.fcom.DateInput?new fcom.util.DateInputAdapter(t):t instanceof YAHOO.fcom.DateInputHtml5?new fcom.util.DateInputHtml5Adapter(t):t instanceof YAHOO.fcom.Autocomplete?new fcom.util.AutocompleteAdapter(t):void 0},fcom.util.DataBinding.adapterForElement=function(t,e){return $(t).is(":checkbox")&&$(t).hasClass("unformatted")?new fcom.util.CheckboxHtmlAdapter(t):$(t).is(":radio")&&$(t).hasClass("unformatted")?new fcom.util.RadioButtonNativeHtmlAdapter(t,e):new fcom.util.InputAdapter(t)},fcom.util.InputAdapter=function(t){this.changeEvent=new YAHOO.util.CustomEvent("change"),this.element=t,this.name=this.getName(this.element),this.value=this.getValue();var e=this.setValue;this.setValue=function(t){this.value=t,e.call(this,t)},this.attachListeners()},fcom.util.InputAdapter.prototype={setValue:function(t){this.element.value=t=null==t?"":t},getValue:function(){return this.element.value},attachListeners:function(){YAHOO.util.Event.addListener(this.element,"keyup",this.changed,this,!0),YAHOO.util.Event.addListener(this.element,"change",this.changed,this,!0),YAHOO.util.Event.addListener(this.element,"blur",this.changed,this,!0),new YAHOO.util.KeyListener(this.element,{keys:YAHOO.util.KeyListener.KEY.ENTER},{fn:function(){this.value=null,this.changed()},scope:this,correctScope:!0}).enable()},toString:function(){return"fcom.util.InputAdapter"},changed:function(){this.getValue()!==this.value&&(this.value=this.getValue(),this.changeEvent.fire())},getName:function(t){return t.name},getMarkableElement:function(){return this.element}},fcom.util.DropMenuAdapter=function(t){fcom.util.DropMenuAdapter.superclass.constructor.call(this,t)},fcom.util.DropMenuAdapter.prototype={setValue:function(t){this.element.isMultipleSelection?(this.element.deselectAll(),this.element.selectByValues(t)):this.element.selectByValue(t)},getValue:function(){return this.element.isMultipleSelection?this.element.getSelectedValues():this.element.getSelectedValue()},changed:function(){this.element.isMultipleSelection?this.changeEvent.fire():this.getValue()!=this.value&&(this.value=this.getValue(),this.changeEvent.fire())},attachListeners:function(){this.element.changeEvent.subscribe(this.changed,this,!0)},toString:function(){return"fcom.util.DropMenuAdapter"},getMarkableElement:function(){return this.element.inputField}},YAHOO.extend(fcom.util.DropMenuAdapter,fcom.util.InputAdapter,fcom.util.DropMenuAdapter.prototype),fcom.util.SelectAdapter=function(t){fcom.util.SelectAdapter.superclass.constructor.call(this,t)},fcom.util.SelectAdapter.prototype={setValue:function(t){this.element.isMultipleSelection?(this.element.deselectAll(),this.element.selectByValues(t)):this.element.selectByValue(t)},getValue:function(){return this.element.isMultipleSelection?this.element.getSelectedValues():this.element.getSelectedValue()},changed:function(){this.changeEvent.fire()},attachListeners:function(){this.element.$element.on("change",this.changed.bind(this))},toString:function(){return"fcom.util.SelectAdapter"},getName:function(){return this.element.$element.attr("name")},getMarkableElement:function(){return null}},YAHOO.extend(fcom.util.SelectAdapter,fcom.util.InputAdapter,fcom.util.SelectAdapter.prototype),fcom.util.CheckboxAdapter=function(t){fcom.util.CheckboxAdapter.superclass.constructor.call(this,t)},fcom.util.CheckboxAdapter.prototype={setValue:function(t){this.element.toggle(t,!0)},getValue:function(){return this.element.isSelected()},attachListeners:function(){YAHOO.util.Event.addListener(this.element.domNode,"change",this.changed,this,!0)},toString:function(){return"fcom.util.CheckboxAdapter"},getName:function(t){return t.domNode.name}},YAHOO.extend(fcom.util.CheckboxAdapter,fcom.util.InputAdapter,fcom.util.CheckboxAdapter.prototype),fcom.util.RadioButtonAdapter=function(t){fcom.util.RadioButtonAdapter.superclass.constructor.call(this,t)},fcom.util.RadioButtonAdapter.prototype={setValue:function(t){for(var e=this.element,n=e.groupArray.length;n--;){var i=e.groupArray[n];if(i.domNode.value==t)return void i.setChecked(!0)}},getValue:function(){for(var t=this.element,e=t.groupArray.length;e--;){var n=t.groupArray[e];if(n.isSelected())return n.domNode.value}},attachListeners:function(){for(var t=this.element.groupArray.length;t--;)YAHOO.util.Event.addListener(this.element.groupArray[t].domNode,"change",this.changed,this,!0)},getName:function(t){return t.domNode.name},toString:function(){return"fcom.util.RadioButtonAdapter"}},YAHOO.extend(fcom.util.RadioButtonAdapter,fcom.util.InputAdapter,fcom.util.RadioButtonAdapter.prototype),fcom.util.PopupSearchInputAdapter=function(t){fcom.util.PopupSearchInputAdapter.superclass.constructor.call(this,t)},fcom.util.PopupSearchInputAdapter.prototype={setValue:function(t){var e=this.element;e.setText(t),e.setValue(t),null!=t&&""!=t||e.reset()},getValue:function(){return this.element.getValue()},attachListeners:function(){var t=this.element;t.itemFoundEvent.subscribe(this.changed,this,!0),t.itemRemovedEvent.subscribe(this.changed,this,!0)},getName:function(t){return t.valueField.name},toString:function(){return"fcom.util.PopupSearchInputAdapter"},getMarkableElement:function(){return this.element.textField}},YAHOO.extend(fcom.util.PopupSearchInputAdapter,fcom.util.InputAdapter,fcom.util.PopupSearchInputAdapter.prototype),fcom.util.HTMLElementAdapter=function(t){fcom.util.HTMLElementAdapter.superclass.constructor.call(this,t)},fcom.util.HTMLElementAdapter.prototype={setValue:function(t){t=null==t?"":t,this.element.innerHTML=fcom.util.StringHelper.escapeHTML(""+t)},getValue:function(){return fcom.util.StringHelper.unescapeHTML(this.element.innerHTML)},attachListeners:function(){},getName:function(t){return t.getAttribute("name")},toString:function(){return"fcom.util.HTMLElementAdapter"},getMarkableElement:function(){return null}},YAHOO.extend(fcom.util.HTMLElementAdapter,fcom.util.InputAdapter,fcom.util.HTMLElementAdapter.prototype),fcom.util.DateInputAdapter=function(t){fcom.util.DateInputAdapter.superclass.constructor.call(this,t)},fcom.util.DateInputAdapter.prototype={setValue:function(t){this.element.setDate(t)},getValue:function(){return this.element.getDate()},changed:function(){this.getValue().equals(this.value)||(this.value=this.getValue(),this.changeEvent.fire())},attachListeners:function(){this.element.dateChanged.subscribe(this.changed,this,!0)},getName:function(t){return t.hiddenField.name},toString:function(){return"fcom.util.DateInputAdapter"},getMarkableElement:function(){return null}},YAHOO.extend(fcom.util.DateInputAdapter,fcom.util.InputAdapter,fcom.util.DateInputAdapter.prototype),fcom.util.DateInputHtml5Adapter=function(t){fcom.util.DateInputHtml5Adapter.superclass.constructor.call(this,t)},fcom.util.DateInputHtml5Adapter.prototype={setValue:function(t){this.element.setDate(t)},getValue:function(){return this.element.getDate()},changed:function(){this.getValue().equals(this.value)||(this.value=this.getValue(),this.changeEvent.fire())},attachListeners:function(){this.element.dateChanged.subscribe(this.changed,this,!0)},getName:function(t){return t.hiddenField.name},toString:function(){return"fcom.util.DateInputHtml5Adapter"},getMarkableElement:function(){return null}},YAHOO.extend(fcom.util.DateInputHtml5Adapter,fcom.util.InputAdapter,fcom.util.DateInputHtml5Adapter.prototype),fcom.util.AutocompleteAdapter=function(t){fcom.util.AutocompleteAdapter.superclass.constructor.call(this,t)},fcom.util.AutocompleteAdapter.prototype={setValue:function(t){this.element.selectByValue(t)},getValue:function(){return this.element.getSelectedValue()},attachListeners:function(){this.element.changeEvent.subscribe(this.changed,this,!0)},toString:function(){return"fcom.util.AutocompleteAdapter"}},YAHOO.extend(fcom.util.AutocompleteAdapter,fcom.util.InputAdapter,fcom.util.AutocompleteAdapter.prototype),fcom.util.CheckboxHtmlAdapter=function(t){fcom.util.CheckboxHtmlAdapter.superclass.constructor.call(this,t)},fcom.util.CheckboxHtmlAdapter.prototype={attachListeners:function(){YAHOO.util.Event.addListener(this.element,"change",this.changed,this,!0)},setValue:function(t){this.element.checked=t=null==t?"":t},getValue:function(){return this.element.checked},getName:function(t){return this.element.name},toString:function(){return"fcom.util.SimpleHtmlAdapter"}},YAHOO.extend(fcom.util.CheckboxHtmlAdapter,fcom.util.InputAdapter,fcom.util.CheckboxHtmlAdapter.prototype),fcom.util.RadioButtonNativeHtmlAdapter=function(t,e){this.radioElements=e,fcom.util.RadioButtonNativeHtmlAdapter.superclass.constructor.call(this,t)},fcom.util.RadioButtonNativeHtmlAdapter.prototype={attachListeners:function(){this.radioElements.forEach(function(t){YAHOO.util.Event.addListener(t,"change",this.changed,this,!0)}.bind(this))},setValue:function(t){for(var e=0;e<this.radioElements.length;e++)this.radioElements[e].value.toLowerCase()===t.toLowerCase()?this.radioElements[e].checked=!0:this.radioElements[e].checked=!1},getValue:function(){for(var t=0;t<this.radioElements.length;t++)if(!0===this.radioElements[t].checked)return this.radioElements[t].value;return null},getName:function(t){return t.name},toString:function(){return"fcom.util.RadioButtonNativeHtmlAdapter"}},YAHOO.extend(fcom.util.RadioButtonNativeHtmlAdapter,fcom.util.InputAdapter,fcom.util.RadioButtonNativeHtmlAdapter.prototype),fcom.util.DataBinding.getElementsByElementName=function(t,e){for(var n=[],i=e.length;i--;)t===e[i].name&&n.push(e[i]);return n};
//# sourceMappingURL=DataBinding.js.map;
(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/*
 * Utility class to optimize the column widths of tables. TableOptimizer uses table-layout:auto to
 * find the minimum width for columns to fit their content. Based on the minimum widths the columns
 * are adjusted to fit the available table width again. Fixed size columns can be marked with the
 * css class "fixed_X". The column will have the width "X". Assign the class to the cell in the
 * designated column of the first row. Tables with the same amount of columns can be synchronized in
 * column width. Synced tables must be located under the same parent element and are marked with the
 * css class "colSync". <br>
 * Some IE pitholes:
 * <ul>
 * <li>box model differences for col element (width attribute doesn't include padding and border)
 * <li>no mixing of absolute and relative width in col elements
 * <li>use of absolute values on columns causes white-space:nowrap to fail (text-overflow: ellipsis
 * seems to fix this)
 * </ul>
 *
 *
 */
fcom.util.TableOptimizer = function () {
  var TRUE = function TRUE() {
    return true;
  };
  var throttleMap = {};
  var FIXED_CLS = new RegExp('fixed_(\\d+)');
  var COLUMN_SYNC_CLS = 'colSync';
  var MINIMUM_COLUMN_WIDTH = 60;
  function maxPositions(_ref, row, fixedCols) {
    var _ref2 = _toArray(_ref),
      array = _ref2.slice(0);
    var pos = [];
    var max = 0;
    for (var i = array.length; i--;) {
      // skip fixed columns or too small columns
      if (YAHOO.fcom.Util.indexOf(i, fixedCols) > -1 || array[i] <= 0) {
        continue;
      }
      if (array[i] > max) {
        max = array[i];
        pos = [i];
      } else if (array[i] == max) {
        pos.push(i);
      }
    }
    var max2nd = array.sort(function (a, b) {
      return b - a;
    }).find(function (a) {
      return a !== max;
    }) || max;
    return {
      pos: pos,
      max: max,
      max2nd: max2nd
    };
  }
  ;
  var getFixedColumns = function getFixedColumns(row) {
    var fixedCols = [];
    var cols = YAHOO.util.Selector.query('td, th', row);
    for (var i = 0; i < cols.length; i++) {
      if (isFixedColumn(cols[i])) {
        fixedCols.push(i);
      }
    }
    return fixedCols;
  };
  function sum(arr) {
    return arr.reduce(function (sum, width) {
      return sum + width;
    }, 0);
  }
  function adjustColumnWidth(table, colWidthArray) {
    var firstRow = getFirstRow(table);
    var actualWidth = sum(colWidthArray);
    var containerWidth = table.parentElement.clientWidth;
    var width = "100%";
    var colWidth = colWidthArray;
    var optimised = false;
    var hasOverFlow = false;
    var fixedCols = getFixedColumns(firstRow);
    var delta = actualWidth - containerWidth;
    var _cols = colWidthArray.slice();
    while (delta > 0) {
      var info = maxPositions(_cols, firstRow, fixedCols);
      var numberCols = info.pos.length;
      if (numberCols < 1) {
        break;
      }
      var available = Math.min(delta, info.max - info.max2nd);
      var offset = Math.floor(available / numberCols);
      var rest = available % numberCols;
      // no more space available - can be caused due to fixed columns
      if (available <= 0) {
        break;
      }
      for (var i = 0; i < numberCols; i++) {
        _cols[info.pos[i]] -= offset;
        if (rest-- > 0) {
          _cols[info.pos[i]]--;
        }
        if (_cols[info.pos[i]] < MINIMUM_COLUMN_WIDTH) {
          _cols[info.pos[i]] = MINIMUM_COLUMN_WIDTH;
          delta = -1;
        }
      }
      delta -= available;
    }
    if (actualWidth > containerWidth) {
      var cols = YAHOO.util.Selector.query('td, th', firstRow);
      colWidth = _cols.map(function (col, index) {
        return $(cols[index]).hasClass('trim') && !isFixedColumn(col) ? col : colWidthArray[index];
      });
      var newTableWidth = sum(colWidth);
      if (newTableWidth > containerWidth) {
        var widthDiff = newTableWidth - containerWidth;
        var minimumDiff = 3;
        if (widthDiff > minimumDiff) {
          width = newTableWidth;
          hasOverFlow = true;
        }
      }
      optimised = true;
    }
    if (table.classList.contains(COLUMN_SYNC_CLS)) {
      optimised = true;
    }
    return {
      colWidthArray: colWidth,
      tableWidth: width,
      optimised: optimised,
      hasOverFlow: hasOverFlow,
      fixedCols: fixedCols
    };
  }

  /*
      * Set the cell widths of a table row. If the first row of the table is passed, the whole column
      * will receive the width of a cell. Setting the cell width is prefered over setting the width
      * attribute in the &lt;col&gt; element (no mixing of relative and absolute values in IE,
      * obsolete in HTML5). When widths of columns are to measured, make sure all columns are set
      * first and do not modify columns while collecting widths. The clientWidth of an element
      * includes the padding, but not the border. When setting the css property width, padding and
      * border have to be subtracted.
      *
      * @param {HTMLElement} row
      * @param {Number[]} colWidth
      * @method
      * @private
      */

  var setColumnWidth = function setColumnWidth(row, colWidth, autoWidth) {
    var fixedCols = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var cols = YAHOO.util.Selector.query('td, th', row);
    for (var i = colWidth.length; i--;) {
      var widthUnit = $(cols[i]).attr('data-width-unit');
      var width = autoWidth && fixedCols.indexOf(i) < 0 ? 'auto' : "".concat(colWidth[i]).concat(widthUnit || 'px');
      YAHOO.util.Dom.setStyle(cols[i], "width", width);
    }
  };
  /*
      * Reset the width style attributes of each cell in a row. Fixed columns are not affected.
      *
      * @method
      * @private
      * @param {HTMLElement} row
      */

  var resetColumnWidth = function resetColumnWidth(row) {
    var cols = YAHOO.util.Selector.query('td, th', row);
    for (var i = cols.length; i--;) {
      var el = cols[i];
      var widthUnit = $(el).attr('data-width-unit');
      if (!isFixedColumn(el)) {
        YAHOO.util.Dom.setStyle(el, 'width', 'auto');
      } else {
        YAHOO.util.Dom.setStyle(el, 'width', getFixedColumnWidth(el) + (widthUnit || 'px'));
      }
    }
  };
  /*
      * Returns an array of column widths. The column widths are including border. If a
      * column has the class "fixed_x", the width will be "x".
      *
      * @param {HTMLElement} row
      * @method
      * @private
      * @return {Number[]} clientWidth of each column
      */

  var getColumnWidth = function getColumnWidth(row) {
    var colWidths = [];
    var cols = YAHOO.util.Selector.query('td, th', row);
    for (var i = 0; i < cols.length; i++) {
      var border = styleInPx(cols[i], 'border-left-width') + styleInPx(cols[i], 'border-right-width');
      if (isFixedColumn(cols[i])) {
        colWidths.push(getFixedColumnWidth(cols[i]) + border);
      } else {
        colWidths.push(cols[i].clientWidth + border);
      }
    }
    return colWidths;
  };
  /*
      * test whether the element has a fixed column width
      *
      * @method
      * @private
      * @param {HTMLElement} el
      * @return {Boolean}
      */

  var isFixedColumn = function isFixedColumn(el) {
    return FIXED_CLS.test(el.className);
  };

  /*
      * @method
      * @private
      * @param {HTMLElement} el
      */

  var getFixedColumnWidth = function getFixedColumnWidth(el) {
    var matches = FIXED_CLS.exec(el.className);
    if (matches[1]) {
      return +matches[1];
    }
    return 0;
  };
  var styleInPx = function styleInPx() {
    return YAHOO.fcom.Dom.styleInPx.apply(YAHOO.fcom.Dom, arguments);
  };
  /*
      * Returns the first row of a table (can be header or datarow).
      *
      * @method
      * @private
      * @param {HTMLElement} table
      * @retun {HTMLElement} null -> table has no rows
      */

  var getFirstRow = function getFirstRow(table) {
    if (table == null) {
      return null;
    }
    return YAHOO.util.Selector.query('tr', table, true);
  };
  /*
      * Find all table elements under a given root node, that can be optimized
      *
      * @method
      * @private
      * @param {HTMLElement} root
      * @return {HTMLElement[]}
      */

  var findTables = function findTables() {
    var root = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
    return YAHOO.util.Selector.query('table.autocolumnwidth', root);
  };
  /*
      * For synchronized tables, find the widest columns of all tables.
      *
      * @method
      * @private
      * @param {Number[][]} colWidths an array of column widths for every table
      * @return Number[] array of maximum column widths
      */

  var maxColumns = function maxColumns(colWidths) {
    var result = [];
    for (var i = colWidths.length; i--;) {
      var colWidthPerTable = colWidths[i];
      var j = 0;
      var l = colWidthPerTable.length;
      for (; j < l; j++) {
        if (typeof result[j] === 'undefined' || result[j] < colWidthPerTable[j]) {
          result[j] = colWidthPerTable[j];
        }
      }
    }
    return result;
  };
  return {
    toString: function toString() {
      return 'fcom.util.TableOptimizer';
    },
    /*
           * optimize the column widths of a table according to its contents.
           *
           * @param {HTMLTableElement|HTMLTableElement[]} table or an array of tables
           */
    optimizeColumns: function optimizeColumns(tables) {
      if (tables == null) {
        return;
      }
      if (!(tables instanceof Array)) {
        tables = [tables];
      }
      var colWidths = [];
      for (var i = tables.length; i--;) {
        var t = tables[i];
        var r = getFirstRow(tables[i]);
        if (r) {
          YAHOO.util.Dom.setStyle(t, 'table-layout', 'auto');
          colWidths.push(getColumnWidth(r));
          YAHOO.util.Dom.setStyle(t, 'table-layout', 'fixed');
        }
      }
      var colWidth = maxColumns(colWidths);
      var table = tables[0];
      var displayed = YAHOO.util.Dom.getAncestorBy(table, function (node) {
        return YAHOO.util.Dom.getStyle(node, 'display') === 'none';
      }) == null;
      var row = getFirstRow(table);
      if (displayed && row) {
        var _adjustColumnWidth = adjustColumnWidth(table, colWidth),
          colWidthArray = _adjustColumnWidth.colWidthArray,
          tableWidth = _adjustColumnWidth.tableWidth,
          optimised = _adjustColumnWidth.optimised,
          hasOverFlow = _adjustColumnWidth.hasOverFlow,
          fixedCols = _adjustColumnWidth.fixedCols;
        for (var j = tables.length; j--;) {
          var tableElm = $(tables[j]);
          if (optimised) {
            tableElm.width(tableWidth);
            setColumnWidth(getFirstRow(tables[j]), colWidthArray, false);
          } else {
            setColumnWidth(getFirstRow(tables[j]), colWidthArray, true, fixedCols);
            tableElm.css({
              'table-layout': 'auto'
            });
            tableElm.width('100%');
          }
          tableElm.parent().css({
            'overflow-x': hasOverFlow ? 'auto' : 'hidden'
          });
        }
      }
    },
    /*
           * Optimize the columns of all data tables on the page
           *
           * @param {HTMLElement} root The root node
           * @param {Boolean} relative use relative widths instead of pixel precision. Only
           *        recommended for print view.
           */
    optimizeTables: function optimizeTables() {
      var _this = this;
      var root = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
      var relative = arguments.length > 1 ? arguments[1] : undefined;
      if (window.disableTableOptimizer) {
        return false;
      }
      var throttledCall = throttleMap[YAHOO.util.Dom.generateId(root)];
      if (throttledCall) {
        window.clearTimeout(throttledCall);
      }

      // this.resetTables(root, false);
      throttleMap[root.id] = window.setTimeout(function () {
        _this._actuallyOptimizeTables(root, relative);
        throttleMap[root.id] = "last".concat(Date.now());
      }, 5); // delay execution to prevent multiple runs for the same dom node due to event dependencies
    },

    _actuallyOptimizeTables: function _actuallyOptimizeTables(root, relative) {
      relative = true || YAHOO.util.Dom.hasClass(document.body, 'print');
      var tables = this.resetTables(root, false); // find sync'ed tables

      var syncTables = YAHOO.util.Selector.query("table.".concat(COLUMN_SYNC_CLS), root);
      while (syncTables.length > 0) {
        var table = syncTables.pop();
        var siblings = [table];
        YAHOO.fcom.Util.removeItem(table, tables);
        for (var i = 0; i < syncTables.length; i++) {
          var t = syncTables[i];
          if (t.parentNode == table.parentNode) {
            siblings.push(t);
            YAHOO.fcom.Util.removeItem(t, syncTables);
            YAHOO.fcom.Util.removeItem(t, tables);
          }
        }
        this.optimizeColumns(siblings, relative);
      }
      for (var _i = 0; _i < tables.length; _i++) {
        this.optimizeColumns(tables[_i], relative);
      }
    },
    /*
           * Reset tables under a root node.
           *
           * @param {HTMLElement} root
           * @return {HTMLElement[]} list of tables affected
           */
    resetTables: function resetTables(root, resetCols) {
      var tables = findTables(root);
      for (var i = 0; i < tables.length; i++) {
        var table = tables[i];
        window.YAHOO.util.Dom.getElementsBy(TRUE, 'colgroup', table, function (node) {
          node.parentNode.removeChild(node);
        });
        if (resetCols) {
          resetColumnWidth(getFirstRow(table));
        }
      }
      return tables;
    },
    fitWindowToTableContent: function fitWindowToTableContent() {
      var tables = this.resetTables($('body')[0], true); // the ones with class autocolumnwidth
      if (tables.length < 1) {
        // nothing to do
        return;
      }
      var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      var originalTableWidths = new Array();
      var minWidthReduction = document.documentElement.clientWidth; // init compare variable with large value

      for (var _i2 = 0; _i2 < tables.length; _i2++) {
        // remember the original width of all tables
        var _tableRegion = window.YAHOO.util.Dom.getRegion(tables[_i2]);
        originalTableWidths.push(_tableRegion.right - _tableRegion.left);
      }
      YAHOO.util.Dom.setStyle(window.document.body, 'width', screen.width + 'px'); // widen body to stop table cells from wrapping
      for (var i = 0; i < tables.length; i++) {
        // shrink all tables to possible minimum size, by removing width constraints
        var table = tables[i];
        table.removeAttribute('width'); // remove width attributes to allow table to shrink to size
        window.YAHOO.util.Dom.setStyle(table, 'width', 'auto');
        window.YAHOO.util.Dom.setStyle(table, 'table-layout', 'auto');
        tableRegion = window.YAHOO.util.Dom.getRegion(table);
        var reducedTableWidth = tableRegion.right - tableRegion.left;
        if (originalTableWidths[i] - reducedTableWidth < minWidthReduction) {
          minWidthReduction = originalTableWidths[i] - reducedTableWidth;
        }
      }
      YAHOO.util.Dom.setStyle(window.document.body, 'width', 'auto'); // remove width from body tag again

      // first check if window is to small and increases the window until there are no scrollbars no more (if possible on current screen)
      var newHeight = window.outerHeight;
      if (window.document.body.scrollHeight > document.documentElement.clientHeight && window.outerHeight < window.screen.height) {
        // vertical scrollbar?
        var windowHeightOffset = window.outerHeight - window.innerHeight;
        newHeight = Math.min(window.screen.height, window.document.body.scrollHeight + windowHeightOffset);
      }
      if (scrollbarWidth > 0 && newHeight < window.screen.height) {
        // give some extra space for scrollbar
        minWidthReduction -= scrollbarWidth;
      }
      var newWidth = window.outerWidth - minWidthReduction;
      var windowWidthOffset = window.outerWidth - window.innerWidth; // boders and possible sidebar...
      var minDocumentWidthStyle = window.YAHOO.util.Dom.getStyle(document.body, 'min-width');
      if (minDocumentWidthStyle && minDocumentWidthStyle.indexOf('px') > -1) {
        var minDocumentPx = parseInt(minDocumentWidthStyle.substring(0, minDocumentWidthStyle.indexOf('px')));
        newWidth = Math.max(newWidth, minDocumentPx + scrollbarWidth + windowWidthOffset);
      }
      window.resizeTo(newWidth, newHeight);
      for (var i = 0; i < tables.length; i++) {
        // reset shrink all tables to possible minimum size
        var table = tables[i];
        window.YAHOO.util.Dom.setStyle(table, 'table-layout', 'fixed');
        window.YAHOO.util.Dom.setStyle(table, 'width', '100%');
      }
      window.forceResizeEvent.fire();
      // fcom.util.TableOptimizer.fitWindowToTableContent() string to call the optimization from console
    }
  };
}();

},{}]},{},[1]);
;
window.ngpNamespace("fcom.util"),fcom.util.Iterator=function(t){if(this.iterable=[],window.ngpIsType("Array",t))this.iterable=t;else if(this.keys=[],null!=t)for(var e in t)t.hasOwnProperty(e)&&(this.keys.push(e),this.iterable.push(t[e]));this.index=0},fcom.util.Iterator.prototype={process:function(i,n,s){s=s||{},YAHOO.lang.augmentObject(s,{size:10,interval:10,arguments:[]});var l=this;window.setTimeout(function(){var t,e=l.nextChunk(s.size);!1!==i.call(n,e,s.arguments)&&l.hasNext()?window.setTimeout(arguments.callee,s.interval):s.callback&&(e=s.callback.scope||null,t=s.callback.arguments||[],s.callback.fn.call(e,t))},s.interval)},next:function(){var t=null;return this.index<this.iterable.length?(t=this.keys?[this.keys[this.index],this.iterable[this.index]]:this.iterable[this.index],this.index++):t=null,t},nextChunk:function(t){var e=this.iterable.length;if(this.index>=e)return null;for(var i=this.index+(t=+t),n=(e<i&&(i=e),[]);this.index<i;this.index++)this.keys?n.push([this.keys[this.index],this.iterable[this.index]]):n.push(this.iterable[this.index]);return n},hasNext:function(){return this.index<this.iterable.length}};
//# sourceMappingURL=Iterator.js.map;
window.ngpNamespace("fcom.util"),fcom.util.helper={compare:function(r,n){return n<r?1:r<n?-1:r==n?0:void 0},delta:function(r,n){return Math.abs(r-n)},binSearch:function(){function l(r,n,e,t,u){var i=n.length;return!(e<0||i<=e)&&(t<0||i<=t||u(r,n[e])<u(r,n[t]))?e:t}return function(r,n,e,t){return function c(r,n,e,t,u,i){if(null==n||0==n.length)return i?0:-1;var f=~~((t+u)/2),o=e(r,n[f]);if(t<=u){if(1===o)return c(r,n,e,1+f,u,i);if(-1===o)return c(r,n,e,t,f-1,i);if(0===o)return f}else if(i){if(1===o)return l(r,n,f,1+f,i);if(i&&-1===o)return l(r,n,f,f-1,i)}return-1}(r,n,e||fcom.util.helper.compare,0,n.length-1,t)}}(),forKeys:function(r,n,e){var t,u,i=[];for(t in r)void 0!==t&&r.hasOwnProperty(t)&&void 0!==(u=n.call(e,t,r[t]))&&i.push(u);return i}};
//# sourceMappingURL=helper.js.map;
(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var themeHandler = window.ngpNamespace('fcom.themeHandler');
var callCache = {};

// TODO: move this to the module definitions
var templates = {
  _theme: {
    chartColors: {
      neutral: 'color',
      up: 'color',
      down: 'color',
      marker: 'color',
      histogram: 'color',
      lines: 'color',
      labels: 'color',
      grid: 'color',
      background: 'color',
      legendBackground: 'color',
      additionals: ['color'],
      indicators: ['color'],
      seriesColors: ['color'],
      tooltipBackground: 'color'
    },
    colorRangeRel: ['color'],
    colorRangeAbs: ['color'],
    colorRangeVola: ['color'],
    colorRangeFund: ['color'],
    colorRangeCategories: ['color'],
    sigDevColors: {
      colors: {
        color1: 'color',
        color2: 'color',
        color3: 'color',
        color4: 'color',
        color5: 'color',
        color6: 'color',
        color7: 'color',
        color8: 'color',
        color9: 'color',
        color10: 'color',
        color11: 'color',
        color12: 'color'
      }
    }
  },
  DynamicWorldmapModule: {
    colors: {
      ocean: 'color',
      continents: 'color',
      continentBorder: 'color'
    }
  },
  OwnershipBreakdown: {
    colors: {
      colors1: ['color'],
      colors2: ['color'],
      colors3: ['color'],
      colors4: ['color'],
      colors5: ['color'],
      colors6: ['color'],
      colors7: ['color']
    }
  },
  TradingViewChart: {
    chartBackground: 'color',
    tvToolBarBackground: 'color',
    tvSettingsBackground: 'color',
    tvChartBorderColor: 'color',
    tvToolbarFontColor: 'color',
    neutralLighten1: 'color',
    neutralLighten2: 'color',
    upLighten1: 'color',
    downLighten1: 'color',
    upLighten2: 'color',
    downLighten2: 'color',
    primaryColor: 'color'
  }
};
var recursiveReduce = function recursiveReduce($baseItem, object) {
  return Object.keys(object).reduce(function (colors, colorKey) {
    var value = object[colorKey];
    var $item = $('<div />').addClass(colorKey);
    $baseItem.append($item);
    if (Array.isArray(value)) {
      var $subItem = $('<div />').addClass("numItems");
      $item.append($subItem);
      var num = $subItem.css('width');
      num = Number(num.substr(0, num.length - 2));
      colors[colorKey] = [];
      for (var i = 1; i < num + 1; i++) {
        var _$subItem = $('<div />').addClass("item".concat(i));
        $item.append(_$subItem);
        colors[colorKey].push(_$subItem.css(value[0]));
      }
    } else if (_typeof(value) === 'object') {
      colors[colorKey] = recursiveReduce($item, value);
    } else if (typeof value === 'string') {
      colors[colorKey] = $item.css(value);
    }
    return colors;
  }, {});
};
var getJsonFromCSS = function getJsonFromCSS(key, jsonTemplate) {
  var $container = $('<div class="theme" style="display:none" />');
  var $keySpace = $('<div/>').addClass(key);
  $container.append($keySpace);
  $('body').append($container);
  var colors = recursiveReduce($keySpace, jsonTemplate);
  $container.remove();
  return colors;
};
themeHandler.loadThemeConfig = function (key) {
  if (!callCache[key]) {
    if (templates[key]) {
      callCache[key] = Promise.resolve(getJsonFromCSS(key, templates[key]));
    } else {
      callCache[key] = window.ajaxGetJson("/resources/jsConfig/".concat(key, ".json")).catch(function () {
        return {};
      }); //return empty object when nothing is returned (for example when no config was found)
    }
  }

  return callCache[key];
};
var _default = exports.default = themeHandler;

},{}]},{},[1]);
;
(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var channelNames = ['channel-1', 'channel-2', 'channel-3', 'channel-4'];
// #. Ref element is using to keep the menu opener element
var $menuOpenElement = null;
var moduleChannelMenuCheckboxes = {};
var getModuleChannelMenu = function getModuleChannelMenu() {
  var menuId = 'channelmenu';
  var $menu = $("#".concat(menuId));
  if (!$menu.length) {
    $menu = $('<div/>').attr('id', menuId).attr('class', menuId).html('<form>' + "<div class=\"channelmenu-title\">".concat(window.getMessage('module.header.channelconfig.header'), "</div>") + "<div class=\"channelmenu-channels\">".concat(channelNames.map(getSingleChannelMenu).join(''), "</div>") + '<div class="channelmenu-buttonbar">' + "<button id=\"channelmenu_cancelbutton\">".concat(window.getMessage('txt.button.cancel'), "</button>") + "<button id=\"channelmenu_savebutton\">".concat(window.getMessage('txt.button.save'), "</button>") + '</div>' + '</form>');
    $('body').append($menu);
    $menu.find('.channelmenu-channels .checkbox').each(function (i, checkboxElement) {
      var checkbox = new window.YAHOO.fcom.Checkbox(checkboxElement);
      moduleChannelMenuCheckboxes[checkboxElement.name] = checkbox;
      $(checkboxElement).parent().click(function () {
        checkbox.toggle();
      });
      $(checkboxElement).click(function (event) {
        event.stopPropagation();
      });
    });
    window.initButtons($('.channelmenu-buttonbar').get(0));
  }
  $menu.find('.channelmenu-channels input[type="checkbox"]:enabled:visible').first().off('keydown').on('keydown', function (e) {
    if (e.which === 9 && e.shiftKey) {
      e.preventDefault();
      $('#channelmenu_savebutton-button').focus();
    }
  });
  channelPanelFocus();
  return $menu.get(0);
};
var getSingleChannelMenu = function getSingleChannelMenu(channel) {
  return "<div>\n        <div class=\"channelmenu-channel channelmenu-".concat(channel, "\"><div></div></div>\n        <label id=\"channel_label_").concat(channel, "\">").concat(window.getMessage("module.header.channelconfig.".concat(channel, ".name")), "</label>\n         <span class=\"channel\">") + "<span class=\"send\"><input type=\"checkbox\" class=\"checkbox unformatted\" name=\"send_@".concat(channel, "\" aria-labelledby=\"channel_label_").concat(channel, " send_@").concat(channel, "\" value=\"1\" tabindex=\"0\" />\n                <label class=\"checkbox\" id=\"send_@").concat(channel, "\">").concat(window.getMessage('module.header.channelconfig.send'), "</label>\n             </span>") + "<span class=\"receive\"><input type=\"checkbox\" class=\"checkbox unformatted\" name=\"receive_@".concat(channel, "\" aria-labelledby=\"channel_label_").concat(channel, " receive_@").concat(channel, "\" value=\"1\" tabindex=\"0\" />\n                <label class=\"checkbox\" id=\"receive_@").concat(channel, "\">").concat(window.getMessage('module.header.channelconfig.receive'), "</label>\n             </span>\n         </span>\n     </div>");
};
var channelMenuClickHandler = function channelMenuClickHandler(moduleInfo, moduleChannelMenu, moduleChannelOverlay, $menuOpenElement) {
  // setup initial state
  var sendChannels = (moduleInfo.config.senderChannel || '').split(',').filter(function (f) {
    return f.length;
  });
  var receiveChannels = (moduleInfo.config.receiverChannel || '').split(',').filter(function (f) {
    return f.length;
  });
  $(moduleChannelMenu).toggleClass('channelmenu-receiveonly', moduleInfo.config.senderChannel === null);
  $(moduleChannelMenu).toggleClass('channelmenu-sendonly', moduleInfo.config.receiverChannel === null);
  $('#channelmenu_savebutton-button').off('keydown').on('keydown', function (e) {
    if (e.which === 9) {
      e.preventDefault();
      if (e.shiftKey) {
        $('#channelmenu_cancelbutton-button').focus();
      } else {
        channelPanelFocus();
      }
    }
  });
  channelNames.forEach(function (channel) {
    moduleChannelMenuCheckboxes["send_@".concat(channel)].toggle(sendChannels.indexOf("@".concat(channel)) > -1);
    moduleChannelMenuCheckboxes["receive_@".concat(channel)].toggle(receiveChannels.indexOf("@".concat(channel)) > -1);
  });
  var menuOpenElementOffset = $menuOpenElement.offset();
  var elementAlign = menuOpenElementOffset.left - $(moduleChannelMenu).width() > 5 ? 'tr' : 'tl';

  // align and show the overlay as well as setup click handlers
  moduleChannelOverlay.align(elementAlign, 'tl', [24, 0]);
  moduleChannelOverlay.show();
  $('#channelmenu_savebutton-button').unbind('click').one('click', function () {
    var formValues = $(this).parents('form').serializeArray().filter(function (f) {
      return f.value === '1';
    }).reduce(function (all, a) {
      var _a$name$split = a.name.split('_'),
        _a$name$split2 = _slicedToArray(_a$name$split, 2),
        sendReceive = _a$name$split2[0],
        channel = _a$name$split2[1];
      all[sendReceive].push(channel.trim());
      return all;
    }, {
      send: [],
      receive: []
    });
    var senderChannel = !formValues.send.length ? '' : formValues.send.join(',');
    var receiverChannel = !formValues.receive.length ? '' : formValues.receive.join(',');
    window.YAHOO.fcom.modules.Tools.updateConfigurationForModule(moduleInfo.id, {
      receiverChannel: receiverChannel,
      senderChannel: senderChannel
    }).then(function () {
      var moduleContainer = window.YAHOO.fcom.Page.getInstance('moduleContainer');
      if (moduleContainer && moduleContainer.config.adminData != null && moduleContainer.config.isAdmin === true) {
        location.reload();
      } else {
        var moduleId = moduleInfo.id;
        var viewId = window.YAHOO.fcom.viewInfo.name;
        var itemElement = window.Dom.get(moduleId);
        var url = "/view.action?method=getModule&moduleId=".concat(moduleId, "&viewId=").concat(viewId);
        var params = {
          replaceContainer: true,
          callback: function callback() {
            var columnContainer = window.YAHOO.fcom.Page.getInstance('moduleContainer');
            columnContainer.updateItem(moduleId);
          }
        };
        window.replaceAsync(url, itemElement, params, true, true);
      }
    });
    moduleChannelOverlay.hide();
  });
};
var setupChannelsForModule = function setupChannelsForModule(moduleNode, moduleInfo, instancePromise) {
  var moduleChannelOverlay = null;
  var $channelEl = $(moduleNode).find('[data-module-action="channelMenu"]');
  $channelEl.on('keydown', function (event) {
    if (event.keyCode === 13 || event.keyCode === 32) {
      event.preventDefault();
      $channelEl.click();
    }
  });

  // #. Update the WCAG attributes of channel element
  updateChannelTitle($channelEl);
  $channelEl.click(function (event) {
    $menuOpenElement = $(event.target);
    var moduleChannelMenu = getModuleChannelMenu();
    moduleChannelOverlay = new window.YAHOO.widget.Overlay(moduleChannelMenu, {
      constraintoviewport: true,
      context: ["".concat(moduleInfo.id, "_channelmenu"), 'tr', 'tl', [24, 0]]
    });
    channelMenuClickHandler(moduleInfo, moduleChannelMenu, moduleChannelOverlay, $menuOpenElement);
    $('#channelmenu_cancelbutton-button').on('click', function () {
      moduleChannelOverlay.hide();
    });
    // hide the channelMenu when body is clicked outside of #channelmenu
    var clickFunction = function clickFunction(e) {
      var $target = $(e.target);
      if (!$target.parents('#channelmenu').length) {
        $('body').unbind('click', clickFunction);
        moduleChannelOverlay.hide();
        // #. Set focus to the menu opener
        setFocusToMenuOpenElement();
        return true;
      }

      // #. Handle menu opener focus after save/cancel click
      if ($target.is('button#channelmenu_savebutton-button') || $target.is('button#channelmenu_cancelbutton-button')) {
        setFocusToMenuOpenElement();
      }
    };
    // #. Unbind the body click
    $('body').off('click');

    // #. Assign the body click
    $('body').on('click', clickFunction);

    // hide the channelMenu when clicked on Escape Key
    var keyupFunction = function keyupFunction(e) {
      if (e.keyCode === _keyCodes.default.ESCAPE) {
        $('body').unbind('keyup', keyupFunction);
        moduleChannelOverlay.hide();
        // #. Set focus to the menu opener
        setFocusToMenuOpenElement();
      }
    };
    // #. Unbind the body keyup
    $('body').off('keyup', keyupFunction);

    // #. Assign the body keyup
    $('body').on('keyup', keyupFunction);
    return false; // cancel event
  });

  //add context menu handler
  $(moduleNode).find('[data-module-action="contextMenu"]').click(function (event) {
    var _this = this;
    if (moduleChannelOverlay) {
      moduleChannelOverlay.hide();
    }
    instancePromise.then(function (instance) {
      var contextConfig = window.getConfigForModule(moduleInfo.id);
      if (typeof contextConfig.instrumentListMethod === 'string') {
        // rewrite as reference to the method itself
        contextConfig.instrumentListMethod = instance[contextConfig.instrumentListMethod].bind(instance);
      }
      window.YAHOO.fcom.Context.openMenu(event, contextConfig, _this);
    });
  });
};
var channelPanelFocus = function channelPanelFocus() {
  var menuId = 'channelmenu';
  var $menu = $("#".concat(menuId));
  window.setTimeout(function () {
    $menu.find('.channelmenu-channels input[type="checkbox"]:enabled:visible').first().focus();
  }, 50);
};

/**
 * @method setFocusToMenuOpenElement
 * @param timeout - number value to set the menu opener focus
 * @description To set the focus back to menu open element
 */
var setFocusToMenuOpenElement = function setFocusToMenuOpenElement() {
  if ($menuOpenElement) {
    // #. Check whether the target is child element of the menu open element
    if (!$menuOpenElement.is('.channeldisplay')) {
      $menuOpenElement = $menuOpenElement.closest('.channeldisplay');
    }
    $menuOpenElement.focus();
  }
};

/**
 * @method updateChannelTitle
 * @param {HTMLElement} - $element expect the channel config open button object
 * @description To set the title of the element with the module name
 */
var updateChannelTitle = function updateChannelTitle($element) {
  var intId = window.setInterval(function () {
    var instrumentName = $element.closest('.headerContent').find('.title .content').text();
    if (instrumentName !== window.getMessage('txt.genericUI.waitLoadingBanner')) {
      updateAriaLabel(instrumentName, $element);
      clearInterval(intId);
    }
  }, 50);
};

/**
 * @method updateAriaLabel
 * @param {HTMLElement} - $element expect the channel config open button object
 * @param {String} - expecting the instrument name
 * @description To set the aria-label attr with the module instrument name
 */
var updateAriaLabel = function updateAriaLabel(instrumentName, $element) {
  $element.attr({
    'aria-label': window.getMessage('module.header.channelconfig.moduleHeader', instrumentName)
  });
};
var _default = exports.default = setupChannelsForModule;

},{"util/enums/keyCodes":3}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _channelHandler = _interopRequireDefault(require("modules/channelHandler"));
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var moduleHandler = window.ngpNamespace('fcom.moduleHandler');
var moduleTypes = {};
var modules = {};
var popoutModules = {};
moduleHandler.registerModuleType = function (moduleType, initFunction, avoidJsConfigRequest) {
  if (!moduleTypes[moduleType]) {
    moduleTypes[moduleType] = {
      type: moduleType,
      init: initFunction,
      avoidJsConfigRequest: avoidJsConfigRequest | false,
      instanceCount: 0
    };
  }
};
var getModuleIdFromNode = function getModuleIdFromNode(moduleNode) {
  return $(moduleNode).data('module-id');
};
var getModuleInfoFromNode = function getModuleInfoFromNode(moduleNode, forceType) {
  var configNode = $(moduleNode).find('[data-module-jsconfig]:not([data-ignore-for-parent])');
  if (!configNode.length) {
    configNode = $(moduleNode);
  }
  // #. Get jsConfig data attr
  var jsConfig = configNode.data('module-jsconfig');
  // #. Parse if the value is string
  // #. Note** - Expected JSON string
  if (jsConfig && typeof jsConfig === 'string') {
    jsConfig = JSON.parse(jsConfig);
  }
  var config = jsConfig || {};
  config.senderChannel = $(moduleNode).data('module-senderchannel') != null ? "".concat($(moduleNode).data('module-senderchannel')) : null;
  config.receiverChannel = $(moduleNode).data('module-receiverchannel') != null ? "".concat($(moduleNode).data('module-receiverchannel')) : null;
  var moduleType = forceType || $(moduleNode).data('module-type') || 'unknown';
  var contextConfig = $(moduleNode).data('module-contextconfig') || {};
  return {
    id: getModuleIdFromNode(moduleNode),
    type: moduleType,
    config: config,
    contextConfig: contextConfig
  };
};
moduleHandler.initBroadcasting = function (node) {
  //find the parent node that contains information about broadcasting
  var moduleNode = $(node).data('module-id') ? node : $(node).parents('[data-module-id]').get(0);
  if (moduleNode) {
    var moduleInfo = getModuleInfoFromNode(moduleNode);
    if (moduleInfo.config.senderChannel) {
      window.YAHOO.fcom.Broadcaster.initBroadcastLinks(moduleInfo.config.senderChannel, moduleInfo.id);
    }
  }
};
var onPopout = function onPopout(node) {
  if (allowModulePopout()) {
    var viewObj = $(node).closest('[data-modulecontainer]');
    var viewID = $(viewObj).attr('id');
    var moduleID = getModuleIdFromNode(node).replace("".concat(viewID, "_"), '');
    var popupWinUrl = "".concat(window.ctx, "/popout/").concat(viewID, ".view?module=").concat(moduleID);
    var popoutWinW = window.themeProperties['module.popout.initialWindowWidth'] || window.Dom.getViewportWidth();
    var popoutWinH = window.themeProperties['module.popout.initialWindowHeight'] || $(node).outerHeight();
    var popoutWinLeft = window.themeProperties['module.popout.initialWindowHorizontalCenter'] === true ? window.screenLeft + window.screen.width / 2 - (popoutWinW / 2 + 10) : 0;
    var popoutWinTop = window.themeProperties['module.popout.initialWindowVerticalCenter'] === true ? window.screenTop + window.screen.height / 2 - (popoutWinH / 2 + 50) : 0;
    var winVariable = window.open(popupWinUrl, "popoutview".concat(moduleID), "width=".concat(popoutWinW, ",height=").concat(popoutWinH, ",resizable=yes,menubar=no,status=no,scrollbars=yes,left=").concat(popoutWinLeft, ",top=").concat(popoutWinTop));
    winVariable.focus();
    popoutModules["popoutview".concat(moduleID)] = 1;
    window.localStorage.setItem('popoutModules', JSON.stringify(popoutModules));
    $(node).trigger('popout.onload');
  }
};
var allowModulePopout = function allowModulePopout() {
  var popoutLimit = window.themeProperties['module.popout.parallel.popouts.limit'];
  return Object.keys(popoutModules).length < popoutLimit;
};

/**
 * check whether the module has a popout icon and if it has install a click handler
 */
moduleHandler.initPopout = function (node) {
  var moduleId = node.id;
  $("#".concat(moduleId, "_popout")).click(function () {
    return onPopout(node);
  });
};

/**
 * check whether the module has a shrinkToFit icon and if it has install a
 * call to the corresponding function in the table optimizer
 */
moduleHandler.initShrinkToFit = function (node) {
  var moduleId = node.id;
  var tables = window.fcom.util.TableOptimizer.resetTables($('body')[0]);
  var $element = $("#".concat(moduleId, "_shrinkToFit"));
  if (tables.length < 1) {
    $element.hide();
  } else {
    $element.click(function () {
      return window.fcom.util.TableOptimizer.fitWindowToTableContent();
    });
    // #. Handle keyDown
    $element.on('keydown', function (event) {
      var keyCode = event.keyCode;
      if (keyCode === _keyCodes.default.ENTER || keyCode === _keyCodes.default.SPACE) {
        $(this).trigger('click');
      }
    });
  }
};
moduleHandler.destroyModule = function (moduleNode) {
  var moduleId = getModuleIdFromNode(moduleNode);
  if (modules[moduleId]) {
    modules[moduleId].onDestroy.forEach(function (fn) {
      return fn();
    });
    delete modules[moduleId];
  }
};
moduleHandler.hideContextMenuIfInvalid = function (moduleNode, moduleId) {
  $(document.body).on('contextMenuEntriesRegistered', function () {
    window.YAHOO.fcom.Context.configObject = window.getConfigForModule(moduleId);
    window.YAHOO.fcom.Context.checkNeededItems();
    var menuCount = window.YAHOO.fcom.Context.availableItems.filter(function (m) {
      return m.isNeeded(window.YAHOO.fcom.Context.configObject) === true;
    }).length;
    if (!menuCount) {
      $(moduleNode).find('.moduleHeader .headerContent .controls').hide();
    }
  });
};
moduleHandler.initModule = function (moduleNode, forceType) {
  var moduleInfo = getModuleInfoFromNode(moduleNode, forceType);
  var promise;
  window.setConfigForModule(moduleInfo.id, moduleInfo.contextConfig);
  if (modules[moduleInfo.id]) {
    moduleHandler.destroyModule(moduleNode);
  }

  //try to init module with the registered init function for this module type
  if (moduleTypes[moduleInfo.type]) {
    if (!moduleTypes[moduleInfo.type].avoidJsConfigRequest) {
      promise = Promise.all([window.fcom.themeHandler.loadThemeConfig('_theme'), window.fcom.themeHandler.loadThemeConfig(moduleInfo.type)]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          generalTheme = _ref2[0],
          moduleTheme = _ref2[1];
        var themeConfig = JSON.parse(JSON.stringify(Object.assign({}, generalTheme, moduleTheme))); // JSON parse/stringify in order to make a deep copy without any references
        moduleTypes[moduleInfo.type].instanceCount++;
        return moduleTypes[moduleInfo.type].init(moduleNode, moduleInfo.config, themeConfig);
      }).catch(function (e) {
        console.error(e);
        $(moduleNode).find('.moduleContent').html('').append("<div class=\"hint\">".concat(window.getMessage('CREATE_MODULE_ERROR'), "</div>"));
        return null;
      });
    } else {
      promise = window.fcom.themeHandler.loadThemeConfig('_theme').then(function (themeConfig) {
        moduleTypes[moduleInfo.type].instanceCount++;
        return moduleTypes[moduleInfo.type].init(moduleNode, moduleInfo.config, themeConfig);
      }).catch(function (e) {
        console.error(e);
        $(moduleNode).find('.moduleContent').html('').append("<div class=\"hint\">".concat(window.getMessage('CREATE_MODULE_ERROR'), "</div>"));
        return null;
      });
    }
  } else {
    promise = Promise.resolve(null);
  }

  // check instance for lifecycle methods
  promise.then(function (moduleInstance) {
    if (!moduleInstance) {
      // nothing to do
      return;
    }
    modules[moduleInfo.id] = {
      instance: moduleInstance,
      onDestroy: []
    };
    if (moduleInstance['@destroy']) {
      modules[moduleInfo.id].onDestroy.push(moduleInstance['@destroy']);
    }
    if (moduleInstance['@broadcast']) {
      Object.keys(moduleInstance['@broadcast']).forEach(function (channel) {
        var broadcastFunction = function broadcastFunction(arg, _ref3) {
          var _ref4 = _slicedToArray(_ref3, 1),
            message = _ref4[0];
          if (message.senderId !== moduleInfo.id) {
            moduleInstance['@broadcast'][channel](message);
          }
        };
        var unsubscribe = window.YAHOO.fcom.Broadcaster.subscribe(channel, broadcastFunction);
        modules[moduleInfo.id].onDestroy.push(unsubscribe);
      });
    }
    if (moduleInstance['@resize']) {
      // debounced resize function that automatically checks for real size changes of the container
      var timer;
      var oldWidth = moduleNode.clientWidth;
      var resizeFunction = function resizeFunction(e, _ref5) {
        var _ref6 = _slicedToArray(_ref5, 1),
          element = _ref6[0];
        if (element === moduleNode) {
          if (timer) {
            window.clearTimeout(timer);
          }
          timer = window.setTimeout(function () {
            if (moduleNode.clientWidth !== oldWidth) {
              oldWidth = moduleNode.clientWidth;
              moduleInstance['@resize']();
            }
          }, 100);
        }
      };
      window.onElementResize.subscribe(resizeFunction);
      var unsubscribe = window.onElementResize.unsubscribe.bind(window.onElementResize, resizeFunction);
      modules[moduleInfo.id].onDestroy.push(unsubscribe);
    }
    if (moduleInstance['@reload']) {
      var reloadFunction = function reloadFunction(e) {
        if (!document.hidden) {
          moduleInstance['@reload']();
        }
      };
      window.pageVisibilityChanged.subscribe(function () {
        reloadFunction();
      });
      var _unsubscribe = window.pageVisibilityChanged.unsubscribe.bind(window.pageVisibilityChanged, reloadFunction);
      modules[moduleInfo.id].onDestroy.push(_unsubscribe);
    }
    if (moduleInstance['@dropped']) {
      var _reloadFunction = function _reloadFunction(data) {
        if (!document.hidden) {
          moduleInstance['@dropped'](data);
        }
      };
      window.moduleDropped.subscribe(function (e, data) {
        _reloadFunction(data);
      });
      var _unsubscribe2 = window.moduleDropped.unsubscribe.bind(window.moduleDropped, _reloadFunction);
      modules[moduleInfo.id].onDestroy.push(_unsubscribe2);
    }
  });

  //add channel menu handler
  (0, _channelHandler.default)(moduleNode, moduleInfo, promise);

  //init channel if a channel name has been set
  moduleHandler.initBroadcasting(moduleNode);
  moduleHandler.initPopout(moduleNode);
  moduleHandler.initShrinkToFit(moduleNode);
  if (window.name && window.name.startsWith('popoutview')) {
    moduleHandler.hideContextMenuIfInvalid(moduleNode, moduleInfo.id);
  }
  return promise;
};
$(function () {
  var popoutModulesStored = JSON.parse(window.localStorage.getItem('popoutModules'));
  if (popoutModulesStored) {
    popoutModules = popoutModulesStored;
  }
  window.addEventListener('beforeunload', function (e) {
    if (window.name && popoutModules[window.name]) {
      delete popoutModules[window.name];
      window.localStorage.setItem('popoutModules', JSON.stringify(popoutModules));
    }
  });
  window.addEventListener('storage', function (e) {
    if (e.key === 'popoutModules') {
      popoutModules = JSON.parse(window.localStorage.getItem('popoutModules'));
    }
  });
  if (window.name && window.name.startsWith('popoutview')) {
    popoutModules[window.name] = 1;
    window.localStorage.setItem('popoutModules', JSON.stringify(popoutModules));
  }
});
moduleHandler.debug = function () {
  console.table(moduleTypes);
};
var _default = exports.default = moduleHandler;

},{"modules/channelHandler":1,"util/enums/keyCodes":3}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var KEYCODE = {
  ENTER: 13,
  SPACE: 32,
  ESCAPE: 27,
  ARROW_LEFT: 37,
  ARROW_UP: 38,
  ARROW_RIGHT: 39,
  ARROW_DOWN: 40,
  TAB: 9,
  KeyA: 65,
  KeyD: 68,
  DELETE: 46
};
var _default = exports.default = KEYCODE;

},{}]},{},[2]);
;
(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * Create a new ReadyEvent.
 * @class Event that tracks a ready state. A subscribed listener function will only be called once.
 * If the internal state is ready before a listener is subscribed, the listener function will
 * be called immidiately.
 * @extends YAHOO.util.CustomEvent
 */
var ReadyEvent = function ReadyEvent() {
  ReadyEvent.superclass.constructor.call(this, 'ready', null, false, window.YAHOO.util.CustomEvent.FLAT);

  /*
   * Ready state. Read-only access.
   * @property
   * @type Boolean
   */
  this.ready = false;
};

/*
 * The handler function is unsubscribed after it has been called once.
 * The handler function fires immidately on subscribe when the ready flag is true.
 * @method
 * @param {Function} fn Handler function that has the following signature:<pre>function(customObj)</pre>
 * @param {Object} customObj Optional custom object passed to the handler
 * @param {Boolean|Object} override If this optional parameter has the value true, customObj is the execution scope of the handler function.
 * Else the passed object is the scope.
 */
ReadyEvent.prototype.subscribe = function (fn, customObj, override) {
  var subscribeFunction = function subscribeFunction(arg, handler) {
    this.unsubscribe(subscribeFunction);
    var scope = handler.override === true ? handler.customObj : handler.override || null;
    try {
      handler.fn.call(scope, handler.customObj);
    } catch (e) {
      console.error("YAHOO.fcom.ReadyEvent: Exception in ready event handler.\n".concat(window.YAHOO.lang.dump(e)));
      throw e;
    }
  };
  ReadyEvent.superclass.subscribe.call(this, subscribeFunction, {
    fn: fn,
    customObj: customObj,
    override: override
  }, this);
  if (this.ready) {
    this.fire();
  }
};

/*
 * Fires the ready event.
 * @method
 */
ReadyEvent.prototype.fire = function () {
  var _ReadyEvent$superclas;
  this.ready = true;
  for (var _len = arguments.length, eventArguments = new Array(_len), _key = 0; _key < _len; _key++) {
    eventArguments[_key] = arguments[_key];
  }
  (_ReadyEvent$superclas = ReadyEvent.superclass.fire).call.apply(_ReadyEvent$superclas, [this].concat(eventArguments));
};
window.YAHOO.extend(ReadyEvent, window.YAHOO.util.CustomEvent, ReadyEvent.prototype);
window.YAHOO.fcom.ReadyEvent = ReadyEvent;
var _default = exports.default = ReadyEvent;

},{}],2:[function(require,module,exports){
"use strict";

var _ReadyEvent = _interopRequireDefault(require("page/ReadyEvent"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
window.ngpNamespace('window.YAHOO.fcom');

/*
 * separator string used to separate the element id from the part name.
 * @type String
 * @constant
 * @private
 */
var ID_SEPARATOR = '__';

/*
 * flag keeps track of init state
 * @type Boolean
 * @private
 */
var isInit = false;

/*
 * map storing all gui elements on the page
 * @private
 */
var map = {};

/*
 * map containing listeners subscribing to the ready event of single gui elements.
 * @private
 */
var listeners = {};
var pageUnloaded = false;

/*
 * Map for page event listeners.
 * The keys of this map resemble the event ids.
 * The values are arrays containing objects with the following structure:
 * <ul>
 *     <li>{Function} fn handler function
 *     <li>{Array} [args] optional arguments
 *     <li>{Object} [scope] optional execution scope
 * </ul>
 * @private
 */
var pageListeners = {};

/*
 * Flag that determines whether the page is currently worked on.
 * @property
 * @type Boolean
 * @private
 */
var busyPage = false;

/*
 * ready event
 * @property
 * @type window.YAHOO.fcom.ReadyEvent
 * @private
 */
var readyEvent = new _ReadyEvent.default();

/*
 * resize event
 * @property
 * @type window.YAHOO.util.CustomEvent
 * @private
 */
var resizeEvent = new window.YAHOO.util.CustomEvent('pageResize');
var width = 0;
var height = 0;
window.YAHOO.widget.Overlay.windowResizeEvent.subscribe(function () {
  var viewportWidth = window.YAHOO.fcom.Page.getViewportSize().width; // check for viewport width (mostly resize) as pages don't grow in width
  var pageHeight = window.YAHOO.fcom.Page.getPageSize().height; // check for page height
  if ((width !== viewportWidth || height !== pageHeight) && !busyPage) {
    width = viewportWidth;
    height = pageHeight;
    resizeEvent.fire();
  }
});
window.YAHOO.util.Event.addListener(window, 'resize', function () {
  var windowWidth = window.YAHOO.util.Dom.getViewportWidth();
  if (windowWidth <= 1000) {
    window.YAHOO.util.Dom.setStyle('mainFrame', 'width', '1020px');
  } else {
    window.YAHOO.util.Dom.setStyle('mainFrame', 'width', '');
  }
}, null, null);
YAHOO.util.Event.onAvailable('mainFrame', function () {
  var windowWidth = window.YAHOO.util.Dom.getViewportWidth();
  if (windowWidth <= 1000) {
    window.YAHOO.util.Dom.setStyle('mainFrame', 'width', '1020px');
  }
});
window.YAHOO.util.Event.addListener(window, 'unload', function () {
  window.YAHOO.fcom.Page.setPageUnloaded();
}, void 0, true);

/*
 * The page's config
 * @property
 * @private
 */
var cfg = {};

/*
 * Execute an operation that keeps the page busy. No page events should be
 * fired.
 *
 * @method
 * @private
 * @param {Function}
 *            fn operation to execute
 * @param {Object}
 *            scope
 * @param {Array}
 *            args function argument list
 */
function pageOperation(fn, scope, args) {
  args = [].concat(args);
  busyPage = true;
  fn.apply(scope, args);
  busyPage = false;
}
/*
 * Checks whether all registered elements are ready
 * @method
 * @private
 */
function checkReady() {
  //wait for init
  if (!isInit) {
    return;
  }
  for (var i in map) {
    if (typeof i == 'string') {
      var conf = map[i];
      if (!conf.ready) {
        console.debug("window.YAHOO.fcom.Page: waiting for element \"".concat(i, "\""));
        return;
      }
    }
  }
  console.debug('window.YAHOO.fcom.Page: page is ready');
  readyEvent.fire();
}

/*
 * Extract a the pageId of a gui element from dom element id.
 * If a gui element consists of several dom elements, the pageId can be extracted from a single node's dom id.
 * @method
 * @private
 * @param {String} domId id of a dom element
 * @return {String} pageId
 *
 */
function extractPageId(domId) {
  var i = domId.indexOf(ID_SEPARATOR);
  return i > -1 ? domId.substring(0, i) : domId;
}

/*
 * Runs a script using eval.
 * Eval is used, because script nodes inserted with innerHTML are not executed.
 * This is potentially unsafe, so only eval scripts that are from a trusted source.
 * @method
 * @private
 * @param {Node[]|Node} scriptNodes
 * @param {Node} parentNode optional node object above the script nodes to ensure the functionality when working in other frames
 */
function evalScript(scriptNodes, parentNode) {
  scriptNodes = [].concat(scriptNodes);
  for (var i = 0, len = scriptNodes.length; i < len; i++) {
    var node = scriptNodes[i];
    var windowObject = window;
    if (parentNode && parentNode.ownerDocument !== window.document) {
      windowObject = parentNode.ownerDocument.defaultView;
    }
    if (window.execScript) {
      windowObject.execScript(node.text); // special treatment for IE to eval script in global scope
    } else {
      eval.call(windowObject, node.text); // use global scope
    }
  }
}

/*
 * Initialize single nodes
 * @method
 * @private
 * @param {HTMLElement|HTMLElement[]} nodes
 */
function initNodes(nodes, suppressPageEvents) {
  nodes = [].concat(nodes);
  for (var i = 0, l = nodes.length; i < l; i++) {
    var node = nodes[i];
    if (window.YAHOO.fcom.Dom.isTextNode(node)) {
      continue; // text nodes don't need to be initialized
    }

    window.initDocument(node, true);
  }
  if (!suppressPageEvents) {
    if (nodes.length > 1 && nodes[0].parentNode) {
      pageOperation(window.fcom.util.TableOptimizer.optimizeTables, window.fcom.util.TableOptimizer, nodes[0].parentNode);
    } else if (nodes.length > 0) {
      pageOperation(window.fcom.util.TableOptimizer.optimizeTables, window.fcom.util.TableOptimizer, nodes[0]);
    }
  }
}

/*
 * Call a event listener in yui style.
 * @param {Object} arg First argument passed to the listener function.
 * @param {Object} listener A listener object containing the following properties
 * <ul>
 *     <li> {Function} fn
 *  <li> {Object} object
 *  <li> {Boolean} override
 * </ul>
 */
function callHandler(arg, handler) {
  if (handler.fn) {
    var scope = handler.override || null;
    if (handler.override === true) {
      scope = handler.object;
    }
    handler.fn.call(scope, arg, handler.object);
  }
}

/*
 * Removes all script nodes found under a target node.
 * The found script nodes are collected in an array.
 * @param {String|HTMLElement} target
 * @return {target:String|HTMLElement, scriptNodes:Node[]} cleaned target and script nodes that have been removed from the target node
 */
function cleanScriptNodes(target) {
  var scriptNodes = [];
  var regEx = /<script\b[^>]*>([\s\S]*?)<\/script>/gim;
  if (window.ngpIsType('String', target)) {
    var scripts;
    while ((scripts = regEx.exec(target)) != null) {
      if (scripts && scripts[1]) {
        var node = document.createElement('script');
        node.text = scripts[1];
        scriptNodes.push(node);
      }
    }
    target = target.replace(regEx, '');
  } else {
    scriptNodes = window.YAHOO.util.Dom.getElementsBy(function () {
      return true;
    }, 'script', target);
    for (var len = scriptNodes.length; len--;) {
      var scriptNode = scriptNodes[len];
      if (scriptNode.parentNode) {
        scriptNode.parentNode.removeChild(scriptNode);
      }
    }
  }
  return {
    target: target,
    scriptNodes: scriptNodes
  };
}

/*
 * Call table optimizer and setup listeners
 */
function optimizeTables() {
  window.fcom.util.TableOptimizer.optimizeTables();

  // page resize
  window.YAHOO.fcom.Page.onResize(function () {
    pageOperation(window.fcom.util.TableOptimizer.optimizeTables, window.fcom.util.TableOptimizer);
  }, this, true);

  // module resize
  window.onElementResize.subscribe(function (evt, _ref) {
    var _ref2 = _slicedToArray(_ref, 1),
      module = _ref2[0];
    pageOperation(window.fcom.util.TableOptimizer.optimizeTables, window.fcom.util.TableOptimizer, module);
  });

  // module is dragged for resize
  window.onElementResizeDrag.subscribe(function (evt, _ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      module = _ref4[0],
      proxy = _ref4[1];
    pageOperation(window.fcom.util.TableOptimizer.resetTables, window.fcom.util.TableOptimizer, module);
    pageOperation(window.fcom.util.TableOptimizer.resetTables, window.fcom.util.TableOptimizer, proxy);
  });
}
function checkHeader() {
  if (window.themeProperties['pageHeader.fixed'] === true) {
    var mainFrame = window.YAHOO.util.Dom.get('mainFrame');
    if (mainFrame) {
      var elements = window.YAHOO.util.Dom.getElementsByClassName('menus', 'div', mainFrame);
      window.YAHOO.util.Dom.addClass(elements, 'fixed');
      var region = window.YAHOO.util.Dom.getRegion(elements[0]);
      if (region) {
        window.YAHOO.util.Dom.setStyle(mainFrame, 'padding-top', "".concat(region.height.toString(), "px"));
        var oldRegionHeight = region.height;
        // page resize
        window.YAHOO.fcom.Page.onResize(function () {
          window.YAHOO.lang.later(5, this, function () {
            var region = window.YAHOO.util.Dom.getRegion(elements[0]);
            if (region.height !== oldRegionHeight) {
              window.YAHOO.util.Dom.setStyle(mainFrame, 'padding-top', "".concat(region.height.toString(), "px"));
            }
          });
        }, this, true);
      }
    }
  }
}
function pauseReadyState() {
  isInit = false;
  readyEvent.ready = false;
}

/*
 * This class cannot be instantiated.
 *
 * @class Page The page singleton provides access to all gui elements on a page.
 * The onReady hook provides an application entry point. When scripting with gui elements, start your own code inside
 * the handler function passed to onReady.
 * <pre><code>
 * window.YAHOO.fcom.Page.onReady(function() {
 *    //start scripting here
 * });
 * </code></pre>
 * The page also provides detailed log messages about gui components. Check the javascript log when developing and testing.
 * @singleton
 *
 */

var Page = function Page() {
  // nothing to do in constructor for now
};
Page.prototype.toString = function () {
  return 'window.YAHOO.fcom.Page';
};

/*
 * Initialize the page.
 * This function does not have to be called manually.
 * @internal
 */
Page.prototype.init = function () {
  if (!isInit) {
    window.initDocument(document.body);
    optimizeTables();
    checkHeader();
    isInit = true;
    checkReady();
  }
};

/*
 * Executes the supplied callback function when the page is ready and all gui elements
 * are available for scripting. The handler function receives the page configuration object as first argument.
 * @methodOf window.YAHOO.fcom.Page
 * @param {Function} fn
 * handler function called with the arguments (pageConfig, customObj)
 * @param {Object} customObj
 * custom object passed to the function as first argument
 * @param {Boolean|Object} override
 * if scope has the value of true, the parameter object will become the execution scope of the handler
 */
Page.prototype.onReady = function (fn, customObj, override) {
  readyEvent.subscribe(function () {
    var scope = override || null;
    if (override === true) {
      scope = customObj;
    }
    fn.call(scope, window.YAHOO.fcom.Page.getConfig(), customObj);
  }, this, true);
};

/*
 * Executes the supplied callback function when an instance of a certain gui element is ready.
 * This can happen before the complete page is ready (window.YAHOO.fcom.Page.onReady())!
 * Do not try to access any other gui elements as they might not be ready yet.
 * @methodOf window.YAHOO.fcom.Page
 * @param {String} id
 * @param {Function} fn
 * handler function will be called with the gui element instance as first argument
 * @param {Object} object
 * custom object passed to the function as first argument
 * @param {Boolean|Object} override
 * if scope has the value of true, the parameter object will become the execution scope of the handler
 */
Page.prototype.onInstanceReady = function (id, fn, object, override) {
  var conf = map[id];
  if (conf && conf.ready) {
    // gui element is ready
    callHandler(conf.instance, {
      fn: fn,
      object: object,
      override: override
    });
  } else {
    if (listeners[id] == null) {
      listeners[id] = [];
    }
    listeners[id].push({
      fn: fn,
      object: object,
      override: override
    });
  }
};

/*
 * Executes the supplied callback function on page resize.<br>
 * A page resize event will be fired when the viewport width changed (resize) or the page's height changed.
 * The idea is, that pages in NGP will not grow in width when the window is not resized. But expanders and
 * AJAX replacements can change the page's height.
 * @methodOf window.YAHOO.fcom.Page
 * @param {Function} fn
 * handler function will be called with the gui element instance as first argument
 * @param {Object} object
 * custom object passed to the function as first argument
 * @param {Boolean|Object} override
 * if scope has the value of true, the parameter object will become the execution scope of the handler
 * @param {Boolean} executeOnce
 * true -> handler will only be executed once
 */
Page.prototype.onResize = function (fn, object, override, executeOnce) {
  var subscribeFunction = function subscribeFunction(evt, arg, handler) {
    var scope = handler.override || null;
    if (handler.override === true) {
      scope = handler.customObj;
    }
    handler.fn.call(scope, handler.customObj);
    if (handler.executeOnce) {
      resizeEvent.unsubscribe(subscribeFunction);
    }
  };
  resizeEvent.subscribe(subscribeFunction, {
    fn: fn,
    customObj: object,
    override: override,
    executeOnce: executeOnce
  }, this);
};

/*
 * Register a gui element to the page by its ID. The page will wait until the element is ready.
 * A registered gui element has to call the method ready when it is fully operational.
 * To keep dependecies between classes low, never call register from a gui element constructor.
 * Registering should be in the responsibility of the developer.
 * @methodOf window.YAHOO.fcom.Page
 * @param {String} id Unique identifier for the gui element on the page
 */
Page.prototype.register = function (id) {
  if (map[id] != null) {
    var msg = "window.YAHOO.fcom.Page: Tried to register duplicate ID: ".concat(id);
    console.error(msg);
    throw msg;
  }
  map[id] = {
    ready: false
  };
};

/*
 * Add a gui element instance to the page.
 * @methodOf window.YAHOO.fcom.Page
 * @param {String} id
 * @param {Object} instance
 */
Page.prototype.ready = function (id, instance) {
  var existingElement = map[id] && map[id].ready;
  if (existingElement) {
    var msg = "window.YAHOO.fcom.Page: Tried to register element with duplicate id: ".concat(id);
    console.info(msg);
  }
  console.debug("window.YAHOO.fcom.Page: element ".concat(id, " is ready."));
  if (existingElement) {
    map[id].ready = true;
  } else {
    map[id] = {
      ready: true,
      instance: instance
    };
  }
  if (listeners[id]) {
    listeners[id].forEach(function (listener) {
      return callHandler(instance, listener);
    });
  }
  delete listeners[id];
  checkReady();
};

/*
 * Returns a registered gui element instance for the supplied parameter.
 * The type of the instance should be known to the calling instance.
 * This method should only be used when the page is ready.
 * @methodOf window.YAHOO.fcom.Page
 * @param {String} element ID that belongs to a gui element
 * @return {} a gui element instance
 */
Page.prototype.getInstance = function (element) {
  if (typeof element !== 'string') {
    return null;
  }
  var id = extractPageId(element);
  var el = map[id];
  if (el == null) {
    if (this.ngpOverlayFrameAvailable() && window.parent.frames.ngpOverlayFrame === window) {
      // currently running in overlay frame
      // check originframe for that instance handler:
      return window.parent.frames.ngpOverlayFrame.ngpIFrameHandler.originFrame.YAHOO.fcom.Page.getInstance(element);
    }
    return null;
  }
  if (!el.ready) {
    console.warn("window.YAHOO.fcom.Page: tried to access element \"".concat(id, "\" which is not ready!"));
    return null;
  }
  return el.instance;
};

/*
 * Collect all gui element instances that are located under a certain dom node.
 * @param {HTMLElement|String} node or id of the node
 */
Page.prototype.collect = function (node) {
  node = window.YAHOO.util.Dom.get(node);
  var elementNodes = window.YAHOO.util.Dom.getElementsBy(function (element) {
    return !!element.id;
  }, null, node);
  var instances = {};
  for (var len = elementNodes.length; len--;) {
    var elementNode = elementNodes[len];
    var id = extractPageId(elementNode.id);
    if (map[id]) {
      var instance = map[id].instance;
      if (instance != null) {
        instances[elementNode.id] = instance;
      }
    }
  }
  return instances;
};

/*
 * Unregister all gui elements that are located under a target node.
 * @methodOf window.YAHOO.fcom.Page
 * @param {HTMLElement|String} node Target node or its id
 */
Page.prototype.unregisterAll = function (node) {
  node = window.YAHOO.util.Dom.get(node);
  if (window.YAHOO.fcom.Dom.isTextNode(node)) {
    // text nodes will never contain gui elements
    return;
  }
  // unregister resize
  if (node.id) {
    window.onElementResize.subscribers.forEach(function (element) {
      if (element.obj && element.obj === node.id) {
        window.onElementResize.unsubscribe(element.fn, element.obj);
      }
    });
  }
  // check for gui elements
  var instances = window.YAHOO.fcom.Page.collect(node);
  for (var i in instances) {
    if (!window.YAHOO.lang.isUndefined(i)) {
      this.unregister(instances[i]);
    }
  }
};

/*
 * Unregister a gui element instance
 * @methodOf window.YAHOO.fcom.Page
 * @param {String|Object} element A gui element instance or its id
 */
Page.prototype.unregister = function (element) {
  if (typeof element == 'string') {
    var id = extractPageId(element);
    element = map[id];
  }
  // find map entry
  for (var i in map) {
    if (!window.YAHOO.lang.isUndefined(i)) {
      if (map[i] && map[i].instance === element) {
        console.debug("window.YAHOO.fcom.Page: unregistering element ".concat(i));
        // call destroy if supported
        if (window.YAHOO.lang.isFunction(element.destroy)) {
          try {
            element.destroy();
          } catch (e) {
            console.error("window.YAHOO.fcom.Page: exception on destroying element ".concat(i, "\n").concat(e));
          }
        }
        delete map[i];
        return;
      }
    }
  }
};

/*
 * Replace the contents of a target node. More sophisticated replace operations can be achieved by providing css selectors
 * and a corresponding apply function. Every selector match in the target node will be replaced with the contents that match the same selector.
 * A selector can contain grouped css selectors. If a selector matches more than one node, the order of the elements affects the replacements.
 * <br>Additionally a function can be provided for each selector that will apply the replacement. The function has the following signature:
 * <pre>
 *     function apply(selector:String, target:HTMLElement, node:HTMLElement):HTMLElement[]
 * </pre>
 * Where "selector" contains the active css selector, "target" is the node to be replaced and "node" is the content node.
 * The apply function returns the nodes that have been changed (including newly created nodes).
 * <br>
 * <br>Replace takes care of initializing and cleaning nodes, as well as executing inserted javascript.
 *
 * @methodOf window.YAHOO.fcom.Page
 * @param {HTMLElement|String} target Target node or its id.
 * @param {HTMLElement|String} content The content in form of a html fragment string or as dom element
 * @param {Object} config optional config object with a list of known attributes:
 *
 * {Array|Object} selectorConfig Optional parameter providing selectors that match nodes to replace.
 * Selectors can be given as String or as anonymous object with an apply function:
 * <pre>
 *     { selector: "div.class", apply: function(selector, target, node) { // do replacement } }
 * </pre>
 *
 * {Boolean} [strict] optional, if set to <tt>true</tt>, method will throw an exception if the selectors do not match target or replacement node
 *
 * {Boolean} [suppressPageEvents] optional, if set true no resize events or other visual actions will be performed after the replace.
 */
Page.prototype.replace = function (target, content, config) {
  config = config || {};
  target = window.YAHOO.util.Dom.get(target);
  pauseReadyState();
  var selectors = config.selectorConfig || '';
  selectors = [].concat(selectors);
  var scriptNodes = [];
  var modeCreateElement = false;
  // TODO: solve over some kind of event instead of direct call. But for now call is important otherwise memory in streaming is rising till browser crash
  if (window.YAHOO.fcom.Streaming != null && window.YAHOO.fcom.Streaming.removeStreamingNodes) {
    window.YAHOO.fcom.Streaming.removeStreamingNodes(target);
  }
  if (window.ngpIsType('String', content)) {
    var cleanResult = cleanScriptNodes(content);
    modeCreateElement = true;
    content = document.createElement('div');
    content.innerHTML = cleanResult.target;
    scriptNodes = cleanResult.scriptNodes;
  } else {
    // collect and then remove script nodes from the content
    scriptNodes = cleanScriptNodes(content).scriptNodes;
  }
  // clean the script nodes from the target
  cleanScriptNodes(target);

  // simple default replace
  var replace = function replace(selector, target, node) {
    target.innerHTML = node.innerHTML;
    return target;
  };
  for (var i = 0, len = selectors.length; i < len; i++) {
    var selector = selectors[i];
    if (typeof selector == 'string') {
      selector = {
        selector: selector,
        apply: replace
      };
    }

    //find the right replacement nodes for the targets using the selector
    var nodes = [];
    var targets = [];
    if (!selector.selector) {
      targets = [target];
      nodes = [content];
    } else {
      targets = window.YAHOO.util.Selector.query(selector.selector, target);
      nodes = window.YAHOO.util.Selector.query(selector.selector, content);
    }
    if (!targets.length) {
      var msg = "window.YAHOO.fcom.Page.replace() found no target for selector '".concat(selector.selector, "'");
      console.warn(msg);
      if (config.strict) {
        throw new Error(msg);
      }
    }

    // apply replacements
    for (var j = 0, l = targets.length; j < l; j++) {
      if (nodes[j]) {
        this.unregisterAll(targets[j]);
        var changedNodes = selector.apply(selector.selector, targets[j], nodes[j]);
        initNodes(changedNodes, config.suppressPageEvents);
      } else {
        var _msg = "window.YAHOO.fcom.Page.replace() found no replacement for selector '".concat(selector.selector, "'");
        console.warn(_msg);
        if (config.strict) {
          throw new Error(_msg);
        }
      }
    }
  }
  evalScript(scriptNodes, target);
  isInit = true;
  checkReady();
  if (!config.suppressPageEvents) {
    resizeEvent.fire(); // fire resize, because replaced content might have changed the document height
  }

  //re-initialise possible broadcasting channels
  target = target.id ? window.document.getElementById(target.id) : target; //refresh selection when the node was completely replaced
  window.fcom.moduleHandler.initBroadcasting(target);
  if (modeCreateElement) {
    content = null;
  }
};

/*
 * Insert content to a element. The content can either be a html string or a node.
 *
 * @param {HTMLElement|String} element
 * @param {HTMLElement|String} content
 */
Page.prototype.insert = function (element, content) {
  pauseReadyState();
  var scriptNodes;
  if (window.ngpIsType('String', content)) {
    var cleanResult = cleanScriptNodes(content);
    var node = document.createElement('div');
    node.innerHTML = cleanResult.target;
    content = node;
    scriptNodes = cleanResult.scriptNodes;
  } else {
    scriptNodes = cleanScriptNodes(content).scriptNodes;
  }
  var nodes = window.YAHOO.util.Dom.getChildren(content);
  nodes.forEach(function (node) {
    return element.appendChild(node);
  });
  initNodes(nodes);
  evalScript(scriptNodes);
  isInit = true;
  checkReady();
};

/*
 * This function will set the given element disabled. Therefore the css class
 * "disabled" will be set to the element node and if it is an image, the image source
 * will be updated to use the "disabled" image. When the parameter isDisabled is given
 * as false, the opposite is done. The css class "disabled" will be removed and in case of image,
 * the image source will be updated to use the normal image.
 * The element parameter can either be of the following types:
 * <ul>
 *  <li>id
 *  <li>dom node reference
 *  <li>element instance
 * </ul>
 * Supported element types are
 * <ul>
 *  <li>images
 *     <li>buttons
 *     <li>input fields
 *  <li>single checkboxes and radioboxes
 *     <li>YUI style drop down menus (element must be the javascript menu instance, not any DOM node)
 * </ul>
 * When a full group of radio boxes or checkboxes should be disabled, use the setElementGroupDisabled(element, isDisabled)
 * function.
 * @methodOf window.YAHOO.fcom.Page
 * @param {HTMLElement|String|Object} element
 * @param {Boolean} isDisabled default is true
 */
Page.prototype.setElementDisabled = function (element, isDisabled) {
  if (isDisabled !== false) {
    isDisabled = true;
  }
  if (!element || element == null) {
    return;
  }

  // registered element?
  var el = this.getInstance(element.id);
  if (el) {
    // supports setDisabled function?
    if (typeof el.setDisabled == 'function') {
      el.setDisabled(isDisabled);
      return;
    } else if (el instanceof window.YAHOO.widget.Button) {
      el.set('disabled', isDisabled);
      return;
    } else if (element.cfg && element.cfg != null && element.cfg.setProperty) {
      // looks like a general yui handler?
      element.cfg.setProperty('disabled', isDisabled);
      return;
    }
  }

  // dom element?
  el = window.YAHOO.util.Dom.get(element);
  if (el == null) {
    return;
  }
  if (isDisabled) {
    window.YAHOO.util.Dom.addClass(el, 'disabled');
    el.setAttribute('disabled', 'disabled');
  } else {
    window.YAHOO.util.Dom.removeClass(el, 'disabled');
    el.removeAttribute('disabled');
  }
  if (el.nodeName.toLowerCase() === 'img') {
    el.src = isDisabled ? window.getImageSource(el.src, null, '-disabled') : window.getImageSource(el.src, '-disabled', null);
  } else if (el.nodeName.toLowerCase() === 'input') {
    if (window.YAHOO.util.Dom.hasClass(el, 'checkbox') || window.YAHOO.util.Dom.hasClass(el, 'radio') || window.YAHOO.util.Dom.hasClass(el, 'radiobutton')) {
      var imgNode = window.YAHOO.util.Dom.getPreviousSiblingBy(el, function (node) {
        return node.nodeName === 'IMG' && (window.YAHOO.util.Dom.hasClass(node, 'checkbox') || window.YAHOO.util.Dom.hasClass(node, 'radio') || window.YAHOO.util.Dom.hasClass(node, 'radiobutton'));
      });
      if (imgNode && imgNode != null) {
        if (isDisabled) {
          window.YAHOO.util.Dom.addClass(imgNode, 'disabled');
          imgNode.src = window.getImageSource(imgNode.src, null, ['-disabled']);
        } else {
          window.YAHOO.util.Dom.removeClass(imgNode, 'disabled');
          imgNode.src = window.getImageSource(imgNode.src, ['-disabled'], null);
        }
      }
    }
    (window.YAHOO.util.Dom.getElementsBy(function (node) {
      return node.htmlFor && node.htmlFor === el.id;
    }, 'label', document.body) || []).forEach(function (label) {
      return $(label).toggleClass('disabled', isDisabled);
    });
  }
};

/*
 * Returns the current page size.
 * The page size the size of the document and can be wider and higher than the actual visible area.
 * @return {width:Number, height:Number}
 */
Page.prototype.getPageSize = function () {
  // code from http://stevenbenner.com/2010/04/calculate-page-size-and-view-port-position-in-javascript/
  var width;
  var height;
  if (window.innerHeight && window.scrollMaxY) {
    width = document.body.scrollWidth;
    height = window.innerHeight + window.scrollMaxY;
  } else if (document.body.scrollHeight > document.body.offsetHeight) {
    // all but explorer mac
    width = document.body.scrollWidth;
    height = document.body.scrollHeight;
  } else {
    // explorer mac...would also work in explorer 6 strict, mozilla and safari
    width = document.body.offsetWidth;
    height = document.body.offsetHeight;
  }
  return {
    width: width,
    height: height
  };
};

/*
 * Returns the current viewport size, which is the visible area of a document.
 * The x,y coordinate is the current scroll position.
 * @return {x:Number, y:Number, width:Number, height:Number}
 */
Page.prototype.getViewportSize = function () {
  return {
    x: window.YAHOO.util.Dom.getDocumentScrollLeft(),
    y: window.YAHOO.util.Dom.getDocumentScrollTop(),
    width: window.YAHOO.util.Dom.getViewportWidth(),
    height: window.YAHOO.util.Dom.getViewportHeight()
  };
};

/*
 * Set the page's config object.
 * Method can be called multiple times, as the config objects will be merged.
 * Attention is required when using identical properties in different config objects, which might lead to unexpected results!
 * @param {Object} config
 * @param {String} name
 */
Page.prototype.setConfig = function (config, name) {
  config = config || {};
  if (!window.fcom.util.StringHelper.empty(name)) {
    cfg[name] = config;
  } else {
    Object.assign(cfg, config);
  }
};

/*
 * Returns the page's config object
 */
Page.prototype.getConfig = function () {
  return cfg;
};

/*
 * enable overlays in another iframe. This is required when modules are used on a customer page inside iframes and
 * therefore the available space in the current frame is not enough for overlays.
 */
Page.prototype.setOverlayIframeRequired = function (iframeRequired) {
  cfg.overlayIframeRequired = iframeRequired;
};

/*
 * whether all overlays need to be placed into a seperate iframe because the ngp is displayed inside small iframes that do not have enough
 * place for overlays
 */
Page.prototype.isOverlayIframeRequired = function () {
  if (cfg.overlayIframeRequired === true || this.ngpOverlayFrameAvailable() && window.parent.frames.ngpOverlayFrame === window) {
    // in the overlay iframe itself cfg is not set)
    return true;
  }
  return cfg.overlayIframeRequired === 'popup' ? 'popup' : false;
};
Page.prototype.checkIframeOverlayNeeded = function (elementNode) {
  if (this.isOverlayIframeRequired() && this.ngpOverlayFrameAvailable() && !this.isInOverlayFrame(elementNode)) {
    if (!this.iFrameHandler) {
      this.iFrameHandler = window.parent.frames.ngpOverlayFrame.ngpIFrameHandler;
      if (!this.iFrameHandler) {
        // mainFrame could not be loaded propably the session was not valid yet
        window.parent.postMessage(JSON.stringify({
          action: 'reload_frame'
        }), '*'); // send command to reload the iframe
        return false; // skip overlays for this try
      }
    }

    this.iFrameHandler.externalizeElement(elementNode);
    this.iFrameHandler.originFrame = window;
    this.activateOverlayFrame();
    return true;
  }
  return false;
};
Page.prototype.activateOverlayFrame = function () {
  window.parent.postMessage(JSON.stringify({
    action: 'activate_frame'
  }), '*'); // send command to bring iframe into the foreground
};

/*
 * get a dom node that is possibly already in the overlay iframe but is accessed from the original widget frame
 */
Page.prototype.getOverlayDOMNode = function (elementId, noAutoCreate) {
  var elementNode = window.YAHOO.util.Dom.get(elementId);
  if (elementNode == null && this.isOverlayIframeRequired() && this.ngpOverlayFrameAvailable()) {
    elementNode = window.parent.frames.ngpOverlayFrame.document.getElementById(elementId);
  }
  var documentObject = this.documentToUseForOverlays();
  if (elementNode == null && !noAutoCreate) {
    // dom node not yet available and auto create
    elementNode = documentObject.createElement('div');
    elementNode.id = elementId;
    documentObject.body.insertBefore(elementNode, documentObject.body.firstChild);
  }
  return elementNode;
};

/*
 * return an array with x and y coordinates of the current iframe offset in the full page.
 * This is needed to position overlays in the full page overlay iframe.
 */
Page.prototype.getIframeOffset = function () {
  return [500, 50];
};
Page.prototype.documentToUseForOverlays = function () {
  return this.windowToUseForOverlays().document;
};
Page.prototype.windowToUseForOverlays = function () {
  if (this.isOverlayIframeRequired() && this.ngpOverlayFrameAvailable() && window.parent.frames.ngpOverlayFrame.document) {
    return window.parent.frames.ngpOverlayFrame;
  }
  return window;
};

/*
 * whether the given dom node is already externalized into the overlay iframe.
 */
Page.prototype.isInOverlayFrame = function (elementNode) {
  return elementNode && this.ngpOverlayFrameAvailable() && window.YAHOO.util.Dom.getAncestorByTagName(elementNode, 'body') === window.parent.ngpOverlayFrame.document.body;
};
Page.prototype.ngpOverlayFrameAvailable = function () {
  try {
    if (window.parent.frames.ngpOverlayFrame) {
      return true;
    }
  } catch (e) {
    // do nothing
  }
  return false;
};
Page.prototype.getIFrameHandler = function () {
  if (!this.iFrameHandler && this.ngpOverlayFrameAvailable()) {
    this.iFrameHandler = window.parent.frames.ngpOverlayFrame.ngpIFrameHandler;
  }
  return this.iFrameHandler;
};

/*
 * Register a listener for a certain event id.
 * If the event is fired the handler function will be called.
 * The handler function receives the event id as first argument.
 * For each member of the optional arguments parameter, the function will be called with an additional argument.<br>
 *
 * Example:
 * <code>
 * window.YAHOO.fcom.Page.addListener("myEvent",
 *     function(event, args, custom) {
 *         custom.property1 == 0; // true
 *         custom.property2 == 1; // true
 *    },
 * {property1: 0, property2: 1});
 * </code>
 *
 * @param {String} event id of the event.
 * @param {Function} fn handler function
 * @param {Object} [custom] a custom object to pass to the handler function
 * @param {Object|Boolean} [scope] the execution scope or if the value is <tt>true</tt>, the parameter custom becomes the execution scope.
 */
Page.prototype.addListener = function (event, fn, custom, scope) {
  if (pageListeners[event] == null) {
    pageListeners[event] = [];
  }
  pageListeners[event].push({
    fn: fn,
    custom: custom,
    scope: scope
  });
};

/*
 * Removes a listener with the given event id and handler function.
 *
 * @param {String} event
 * @param {Function} fn
 */
Page.prototype.removeListener = function (event, fn) {
  if (Array.isArray(pageListeners[event])) {
    var e = pageListeners[event];
    for (var i = e.length; i--;) {
      var listener = e[i];
      if (fn === listener.fn) {
        e.splice(i, 1);
      }
    }
  }
};

/*
 * Fire a page event with the given event id.
 * Listeners should be independent from each other, so do not assume any order for listeners being called!
 * <br>
 * The handler function should have the following signature:
 * <tt>function(event, args, custom) {}</tt>
 * Where <tt>args</tt> is the array passed to fire.
 *
 * @param {String} event the id of the event
 * @param {Array} args An array of arguments that will be passed to the handler function.
 */
Page.prototype.fire = function (event, args) {
  if (window.ngpIsType('Array', pageListeners[event])) {
    pageListeners[event].forEach(function (listener) {
      var scope = listener.scope === true ? listener.custom : listener.scope;
      args = args || [];
      if (window.ngpIsType('Function', listener.fn)) {
        listener.fn.call(scope, event, args, listener.custom);
      }
    });
  }
};

/*
 * check whether the page onunload event was already fired. This can be useful to supress error alerts and similar, e.g.
 * when ajax connections are broken. As the page is anyhow stopped, the user does not need to be informed any more.
 */
Page.prototype.isPageUnloaded = function () {
  return pageUnloaded;
};

/*
 * set the unloaded flag.
 */
Page.prototype.setPageUnloaded = function () {
  pageUnloaded = true;
};
window.YAHOO.fcom.Page = new Page();

// initialize
window.YAHOO.util.Event.onDOMReady(function () {
  window.YAHOO.fcom.OnRicHover = new window.YAHOO.util.CustomEvent('onRicHover');
  window.YAHOO.fcom.OnRicClick = new window.YAHOO.util.CustomEvent('onRicClick');
  window.YAHOO.fcom.Page.init();
});

},{"page/ReadyEvent":1}]},{},[2]);
;
YAHOO.fcom.Treeview=function(e,t,n,i){var l=this;this.inputField=Dom.get(e+"__text"),this.toggleButton=Dom.get(e+"__toggle"),this.viewContainer=Dom.get(e+"__container"),this.backgroundDiv=Dom.get(e+"__background"),this.selAllButton=Dom.get(e+"__chooseall"),this.selNoneButton=Dom.get(e+"__choosenone"),this.outerDiv=Dom.get(e+"__outer"),this.selectAllText="",n&&null!=n&&this._checkGivenConfig(n),YAHOO.fcom.Treeview.superclass.constructor.call(this,e+"__treeview"),YAHOO.util.Event.addListener(this.toggleButton,"click",this.toggleView,this,!0),YAHOO.util.Event.addListener(this.selAllButton,"click",this.checkAll,this,!0),YAHOO.util.Event.addListener(this.selNoneButton,"click",this.checkNone,this,!0),YAHOO.util.Event.addListener(this.inputField,"click",this.toggleView,this,!0),this.inputField.onkeypress=function(e){if(13!=(e=(e=e||window.event).which||e.keyCode)&&40!=e&&9!=e)return!1},this.changeEvent=new YAHOO.util.CustomEvent("change"),this.textChangeEvent=new YAHOO.util.CustomEvent("textChange"),this.selectionChangeEvent=new YAHOO.util.CustomEvent("selectionChange"),1==this.isMultipleSelection?this.hiddenFields={}:this._createHiddenField(),this.cfg={getProperty:function(e){return l[e]},setProperty:function(e,t){l[e]=t}},YAHOO.lang.later(1,null,function(e){var t=e[0];t.addNodes(t.getRoot(),e[1]),t.draw(),t.readyLoaded=!0,YAHOO.fcom.Page.ready(e[2].pageId,t)},[[this,i,n]])},YAHOO.extend(YAHOO.fcom.Treeview,YAHOO.widget.TreeView,{isTreeview:!0,_checkGivenConfig:function(e){e.context&&null!=e.context||(e.context=new Array(this.inputField.id,"tl","bl")),e.isCombo&&(this.isCombo=e.isCombo),0==YAHOO.lang.isBoolean(this.isCombo)&&(this.isCombo=!1),e.isMultipleSelection&&(this.isMultipleSelection=e.isMultipleSelection),0==YAHOO.lang.isBoolean(this.isMultipleSelection)&&(this.isMultipleSelection=!1),e.onChangeString?this.onChangeString=e.onChangeString:this.onChangeString=null,e.onTextChangeString?this.onTextChangeString=e.onTextChangeString:this.onTextChangeString=null,e.onSelectionChangeString?this.onSelectionChangeString=e.onSelectionChangeString:this.onSelectionChangeString=null,e.showValuesInInput?this.showValuesInInput=e.showValuesInInput:this.showValuesInInput=!1,null!=e.maxLength&&(this.maxLength=e.maxLength),null!=e.pageId&&(this.pageId=e.pageId),e.position="dynamic"},checkAll:function(){for(var e=1;e<this._nodes.length;e++)this._nodes[e].check();this.onNodeChecked()},checkNone:function(){this.deselectAll(),this.onNodeChecked()},_onDocumentClick:function(e){var t,e=YAHOO.util.Event.getTarget(e);e!=this.outerDiv&&(t=this,null==YAHOO.util.Dom.getAncestorBy(e,function(e){return e==t.outerDiv}))&&this.toggleView()},toggleView:function(){"none"==this.viewContainer.style.display?(this.viewContainer.style.display="block",YAHOO.util.Event.addListener(document,"click",this._onDocumentClick,this,!0)):(this.viewContainer.style.display="none",YAHOO.util.Event.removeListener(document,"click",this._onDocumentClick))},deselectAll:function(){for(var e=1;e<this._nodes.length;e++)this._nodes[e].uncheck();this._updateTextFieldMultiple()},_getSelectedNodeLabels:function(e){var t=[];if(2==e.checkState)t.push(e.label);else if(e.children&&0!==e.checkState)for(var n=0;n<e.children.length;n++)t=t.concat(this._getSelectedNodeLabels(e.children[n]));return t},_updateTextFieldMultiple:function(){if(1==this.isMultipleSelection){for(var e=!0,t=1;t<this._nodes.length;t++)if(!this._nodes[t].checked){e=!1;break}if(e&&this.selectAllText)this.inputField.value=this.selectAllText,this.inputField.title=this.selectAllText;else{var n=this._getSelectedNodeLabels(this.getRoot());if(n.length<1)this.inputField.value=this.selectAllText,this.inputField.title=this.selectAllText;else{for(var i="",t=0;t<n.length;t++){var l=(0<t?", ":"")+n[t];if((i+l).length>this.getMaxLength()){i+=0<t?", ...":n[t];break}i+=l}this.inputField.value=fcom.util.StringHelper.unescapeHTML(i),this.inputField.title=n.join(", ")}}}},getMaxLength:function(){var e;return null==this.maxLength&&(e=Dom.getRegion(this.inputField),this.maxLength=Math.ceil((e.right-e.left)/6.5)),this.maxLength},hasUncommitedTextChange:function(){return!1},reset:function(){console.log("[IMPLEMENT] reset was called")},getAllItemsBy:function(){console.log("[IMPLEMENT] getAllItemsBy was called")},getValueForTheText:function(){console.log("[IMPLEMENT] getValueForTheText was called")},hide:function(){console.log("[IMPLEMENT] hide was called")},removeBy:function(){console.log("[IMPLEMENT] removeBy was called")},addSelectionVerifier:function(){console.log("[IMPLEMENT] addSelectionVerifier was called")},removeItem:function(){console.log("[IMPLEMENT] removeItem was called")},removeAll:function(){console.log("[IMPLEMENT] removeAll was called")},addItemsByValueAndText:function(){console.log("[IMPLEMENT] addItemsByValueAndText was called")},addItem:function(){console.log("[IMPLEMENT] addItem was called")},addItems:function(){console.log("[IMPLEMENT] addItems was called")},forAllItems:function(){console.log("[IMPLEMENT] forAllItems was called")},isAnItemValue:function(){console.log("[IMPLEMENT] isAnItemValue was called")},isAListedItemValue:function(){console.log("[IMPLEMENT] isAListedItemValue was called")},focus:function(){console.log("[IMPLEMENT] focus was called")},selectByValue:function(e){console.log("[IMPLEMENT] selectByValue was called ",e),this.selectByValues([e])},selectItemByIndex:function(){console.log("[IMPLEMENT] selectItemByIndex was called")},getSelectedIndex:function(){console.log("[IMPLEMENT] getSelectedIndex was called")},setComboValueAndText:function(){console.log("[IMPLEMENT] setComboValueAndText was called")},setManualInputCorrectionHandler:function(){console.log("[IMPLEMENT] setManualInputCorrectionHandler was called")},getSelectedText:function(){console.log("[IMPLEMENT] getSelectedText was called")},saveState:function(){console.log("[IMPLEMENT] saveState was called")},getItems:function(){return this._nodes.slice(1)},getSelectedValue:function(){var e=this.getSelectedValues();return this.isMultipleSelection?e:e.shift()},clearActiveItem:function(){console.log("[IMPLEMENT] clearActiveItem")},handleFinishedUserInput:function(){console.log("[IMPLEMENT] handleFinishedUserInput")},configDisabled:function(){console.log("[IMPLEMENT] configDisabled")},selectByValues:function(e){if(e&&null!=e&&0!=YAHOO.lang.isArray(e)&&0!=this.isMultipleSelection){for(var t={},n=0;n<e.length;n++)t[e[n]]=e[n];for(var i=!1,n=this._nodes.length-1;0<n;n--)t[this._nodes[n].value]==this._nodes[n].value&&(this._nodes[n].checked||(this._nodes[n].check(),i=!0),t[this._nodes[n].value]=null);1==i&&this._updateTextFieldMultiple()}},getSelectedValues:function(){for(var e=[],t=1;t<this._nodes.length;t++)this._nodes[t].checked&&e.push(this._nodes[t].value);return e},getSelectedLeafValues:function(){for(var e=[],t=1;t<this._nodes.length;t++)2==this._nodes[t].checkState&&0==this._nodes[t].children.length&&e.push(this._nodes[t].value);return e},onNodeChecked:function(){this.onChangeString&&eval(this.onChangeString),this._updateTextFieldMultiple()},addNodes:function(e,t){for(var n=0;n<t.length;n++)for(var i,l=t[n],s=0;s<l.length;s++)l[s].exclusive?this.selectAllText=l[s].text:((i=new YAHOO.widget.TaskNode(l[s].text,e,!1)).value=l[s].value,l[s].submenu&&this.addNodes(i,l[s].submenu.itemdata))},hasValue:function(e){for(var t=this.getItemData(),n=0;n<t.length;n++)if(t[n].value==e)return!0;return!1},getItemData:function(){var e=[];if(null!=this.itemData)e=e.concat.apply(e,this.itemData);else for(var t=this.getItems(),n=0,i=t.length;n<i;n++){var l=t[n];e.push({text:l.cfg.getProperty("text"),value:l.value})}return e},setVisible:function(e){var t=YAHOO.util.Dom.getAncestorByClassName(this.inputField,"select");YAHOO.util.Dom.setStyle(t,"display",e?"":"none")}}),YAHOO.augment(YAHOO.fcom.Treeview,YAHOO.widget.TreeView),YAHOO.widget.TaskNode=function(e,t,n,i){var l=this;YAHOO.widget.LogWriter?this.logger=new YAHOO.widget.LogWriter(this.toString()):this.logger=YAHOO,e&&(this.init(e,t,n),this.setUpLabel(e),this.setUpCheck(i)),this.cfg={getProperty:function(e){return l[e]},setProperty:function(e,t){l[e]=t}}},YAHOO.extend(YAHOO.widget.TaskNode,YAHOO.widget.TextNode,{checked:!1,checkState:0,taskNodeParentChange:function(){},setUpCheck:function(e){e&&!0===e?this.check():this.parent&&2==this.parent.checkState&&this.updateParent(),this.tree&&!this.tree.hasEvent("checkClick")&&this.tree.createEvent("checkClick",this.tree),this.subscribe("parentChange",this.taskNodeParentChange)},getCheckElId:function(){return"ygtvcheck"+this.index},getCheckEl:function(){return document.getElementById(this.getCheckElId())},getCheckStyle:function(){return"ygtvcheck"+this.checkState},getCheckLink:function(){return"YAHOO.widget.TreeView.getNode('"+this.tree.id+"',"+this.index+").checkClick()"},checkClick:function(){this.logger.log("previous checkstate: "+this.checkState),0===this.checkState?this.check():this.uncheck(),this.onCheckClick(this),this.tree.fireEvent("checkClick",this),this.tree.onNodeChecked()},onCheckClick:function(){this.logger.log("onCheckClick: "+this)},updateParent:function(){var e=this.parent;if(e&&e.updateParent){for(var t=!1,n=!1,i=0;i<e.children.length;++i)(!e.children[i].checked||(t=!0,1==e.children[i].checkState))&&(n=!0);t?e.setCheckState(n?1:2):e.setCheckState(0),e.updateCheckHtml(),e.updateParent()}else this.logger.log("Abort udpate parent: "+this.index)},updateCheckHtml:function(){this.parent&&this.parent.childrenRendered&&(this.getCheckEl().className=this.getCheckStyle())},setCheckState:function(e){this.checkState=e,this.checked=0<e},check:function(){this.logger.log("check"),this.setCheckState(2);for(var e=0;e<this.children.length;++e)this.children[e].check();this.updateCheckHtml(),this.updateParent()},uncheck:function(){this.setCheckState(0);for(var e=0;e<this.children.length;++e)this.children[e].uncheck();this.updateCheckHtml(),this.updateParent()},getNodeHtml:function(){var e=[],t="YAHOO.widget.TreeView.getNode('"+this.tree.id+"',"+this.index+")";e[e.length]='<table border="0" cellpadding="0" cellspacing="0">',e[e.length]="<tr>";for(var n=0;n<this.depth;++n)e[e.length]='<td class="'+this.getDepthStyle(n)+'"><div class="ygtvspacer"></div></td>';return e[e.length]="<td",e[e.length]=' id="'+this.getToggleElId()+'"',e[e.length]=' class="'+this.getStyle()+'"',this.hasChildren(!0)&&(e[e.length]=' onmouseover="this.className=',e[e.length]="YAHOO.widget.TreeView.getNode('",e[e.length]=this.tree.id+"',"+this.index+').getHoverStyle()"',e[e.length]=' onmouseout="this.className=',e[e.length]="YAHOO.widget.TreeView.getNode('",e[e.length]=this.tree.id+"',"+this.index+').getStyle()"'),e[e.length]=" onclick=\"YAHOO.widget.TreeView.getNode('"+this.tree.id+"',"+this.index+').toggle()">&#160;',e[e.length]='<div class="ygtvspacer"></div></td>',e[e.length]="<td",e[e.length]=' id="'+this.getCheckElId()+'"',e[e.length]=' class="'+this.getCheckStyle()+'"',e[e.length]=' onclick="javascript:'+this.getCheckLink()+'">',e[e.length]='<div class="ygtvspacer"></div></td>',e[e.length]="<td>",e[e.length]="<a",e[e.length]=' id="'+this.labelElId+'"',e[e.length]=' class="'+this.labelStyle+'"',e[e.length]=' href="'+this.href+'"',e[e.length]=' target="'+this.target+'"',e[e.length]=' onclick="return '+t+".onLabelClick("+t+')"',this.hasChildren(!0)&&(e[e.length]=" onmouseover=\"document.getElementById('",e[e.length]=this.getToggleElId()+"').className=",e[e.length]="YAHOO.widget.TreeView.getNode('",e[e.length]=this.tree.id+"',"+this.index+').getHoverStyle()"',e[e.length]=" onmouseout=\"document.getElementById('",e[e.length]=this.getToggleElId()+"').className=",e[e.length]="YAHOO.widget.TreeView.getNode('",e[e.length]=this.tree.id+"',"+this.index+').getStyle()"'),e[e.length]=this.nowrap?' nowrap="nowrap" ':"",e[e.length]=" >",e[e.length]=this.label,e[e.length]="</a>",e[e.length]="</td>",e[e.length]="</tr>",e[e.length]="</table>",e.join("")},toString:function(){return"TaskNode ("+this.index+") "+this.label}}),YAHOO.widget.CheckNode=function(e,t,n,i){YAHOO.widget.CheckNode.superclass.constructor.call(this,e,t,n,i)},YAHOO.extend(YAHOO.widget.CheckNode,YAHOO.widget.TaskNode,{setLabelTitle:function(e){var t=this.getTextId(),t=YAHOO.util.Dom.get(t);null!==t&&t.setAttribute("title",e,0)},getTextId:function(){return"ygtvlabelel"+this.index},getTextElement:function(){var e=this.getTextId();return document.getElementById(e)},uncheck:function(e){if(this.setCheckState(0),this.updateCheckHtml(),e)for(var t=0;t<this.children.length;t++)this.children[t].uncheck(!0)},check:function(e){if(this.setCheckState(2),this.updateCheckHtml(),e)for(var t=0;t<this.children.length;t++)this.children[t].check(!0)},disable:function(e){if(this.disabled=!0,this.checked?this.setCheckState(3):this.setCheckState(4),this.updateCheckHtml(),e)for(var t=0;t<this.children.length;t++)this.children[t].disable(!0)},enable:function(e){if(this.disabled=!1,this.checked?this.setCheckState(2):this.setCheckState(0),this.updateCheckHtml(),e)for(var t=0;t<this.children.length;t++)this.children[t].enable(!0)},checkClick:function(){this.disabled||(0===this.checkState?this.check():this.uncheck(),this.onCheckClick(this),this.tree.fireEvent("checkClick",this))},getNodeHtml:function(){var e=[];e[e.length]='<table border="0" cellpadding="0" cellspacing="0">',e[e.length]='<tr class="ygtvrow">';for(var t=0;t<this.depth;++t)e[e.length]='<td class="ygtvcell '+this.getDepthStyle(t)+'"><div class="ygtvspacer"></div></td>';return e[e.length]="<td",e[e.length]=' id="'+this.getToggleElId()+'"',e[e.length]=' class="'+this.getStyle()+'"',e[e.length]='">&#160;',e[e.length]='<div class="ygtvspacer"></div></td>',e[e.length]="<td",e[e.length]=' id="'+this.getCheckElId()+'"',e[e.length]=' class="'+this.getCheckStyle()+'"',e[e.length]=' onclick="javascript:'+this.getCheckLink()+'">',e[e.length]='<div class="ygtvspacer"></div></td>',e[e.length]="<td",e[e.length]=' id="'+this.labelElId+'"',e[e.length]=">",e[e.length]="<span",e[e.length]=' class="unselectable '+this.labelStyle+'"',e[e.length]=this.nowrap?' nowrap="nowrap" ':"",e[e.length]=' unselectable="on"',e[e.length]=" >",e[e.length]=this.label,e[e.length]="</span>",e[e.length]="</td>",e[e.length]="</tr>",e[e.length]="</table>",e.join("")}}),YAHOO.widget.ExtendedTextNode=function(e,t,n,i){YAHOO.widget.ExtendedTextNode.superclass.constructor.call(this,e,t,n,i)},YAHOO.extend(YAHOO.widget.ExtendedTextNode,YAHOO.widget.TextNode,{uncheck:function(){},check:function(){},disable:function(){},enable:function(){}}),YAHOO.widget.UnclickableTextNode=function(e,t,n,i){YAHOO.widget.UnclickableTextNode.superclass.constructor.call(this,e,t,n,i)},YAHOO.extend(YAHOO.widget.UnclickableTextNode,YAHOO.widget.TextNode,{unclickableLabelStyle:"ygtvunclickablelabel",uncheck:function(){},check:function(){},disable:function(){},enable:function(){},getContentHtml:function(){var e=[];return e[e.length]=this.href?"<a":"<span",e[e.length]=' id="'+Lang.escapeHTML(this.labelElId)+'"',e[e.length]=' class="'+Lang.escapeHTML(this.unclickableLabelStyle)+'"',this.href&&(e[e.length]=' href="'+Lang.escapeHTML(this.href)+'"',e[e.length]=' target="'+Lang.escapeHTML(this.target)+'"'),this.title&&(e[e.length]=' title="'+Lang.escapeHTML(this.title)+'"'),e[e.length]=" >",e[e.length]=Lang.escapeHTML(this.label),e[e.length]=this.href?"</a>":"</span>",e.join("")}});
//# sourceMappingURL=treeview.js.map;
window.LargeChartParametersClass=function(t){this.baseUrl="",this.typesNotForYield="tsr, performance, log, boll, env, sar, zz, sma1, sma2, ema1, ema2, b0, b1, b2, b3, bu, n0, n1, n2, n3, n4",this.RIC="",this.type="line",this.n=1,this.sd=null,this.ed=null,this.p="m",this.hist=!1,this.ind=null,this.c0=null,this.c1=null,this.c2=null,this.c3=null,this.c4=null,this.noLogo=null,this.noLegend=null,this.perc=null,this.log=null,this.isYield=null,this.boll=null,this.env=null,this.sar=null,this.zz=null,this.sma1=null,this.sma2=null,this.ema1=null,this.ema2=null,this.histClose=null,this.b0=null,this.b1=null,this.b2=null,this.b3=null,this.bu=null,this.n0=null,this.n1=null,this.n2=null,this.n3=null,this.n4=null,this.w=100,this.h=100,this.tsr=null,this.performance=null,this.ptype=null,this.pfid=null,this.setParameters(t)},window.LargeChartParametersClass.prototype={setParameters:function(t){t&&YAHOO.lang.augmentObject(this,t,!0)},getUrlParameters:function(t){var e,i="";for(e in this)"n"!=e&&"baseUrl"!=e&&"useFilter"!=e&&"function"!=typeof this[e]&&null!=this[e]&&this.checkFilter(t,e)&&(this[e]instanceof fcom.date.DateTime?i+="&"+e+"="+encodeURIComponent(this[e].toString()):i+="&"+e+"="+encodeURIComponent(this[e]));return i},getUrl:function(t){t=this.baseUrl+this.getUrlParameters(t);return(null==this.p||-1<this.p.indexOf("m"))&&(t+="&ts="+window.getRefreshTimestamp(60)),t},getYieldUrl:function(){return this.getUrl(this.typesNotForYield)},checkFilter:function(t,e){return!t||!t.length||-1===t.indexOf(e)},recalculateDimensionsFromPage:function(t){t=YAHOO.util.Dom.getRegion(t);return!(!t||t.right-t.left<1||(this.w=""+(t.right-t.left),this.h=""+(t.bottom-t.top),0))}},window.MiniChartParametersClass=function(){this.imgObjRef=null,this.baseUrl="",this.RIC="",this.dateString=null,this.n=1,this.hist=!1,this.scale=null,this.isYield=null,this.histClose=!0,this.bidask=null,this.b0=null,this.b1=null,this.b2=null,this.w=100,this.h=100,this.p="D",this.alwaysHist=!1},window.MiniChartParametersClass.prototype={getUrl:function(){var t,e=this.baseUrl;for(t in this.n<=1?this.p="m":this.n<=14?this.p="5m":this.n<=740?this.p="D":this.n<=1830?this.p="W":this.p="M",this)"baseUrl"!=t&&"imgObjRef"!=t&&"function"!=typeof this[t]&&this[t]&&(e+="&"+t+"="+encodeURIComponent(this[t]));return e+="&ts="+window.getRefreshTimestamp(60)},setChartImageUrl:function(){this.hist=1==this.alwaysHist||7<this.n,this.imgObjRef.src=this.getUrl()},recalculateDimensionsFromPage:function(t){t=YAHOO.util.Dom.getRegion(t);return!(!t||t.right-t.left<1||(this.w=""+(t.right-t.left),this.h=""+(t.bottom-t.top),0))}},window.chartPeriodicityMapping=["m","5m","15m","60m","D","W","M"],window.mappingIntraday={minDays:["0","0","0","2","7","-1","-1"],maxDays:["1","14","30","30","100000","-1","-1"],notFoundMapping:"m"},window.mappingNoIntraday={minDays:["-1","-1","-1","-1","0","15","101"],maxDays:["-1","-1","-1","-1","730","1825","100000"],notFoundMapping:"D"},window.getPeriodicityFromDates=function(t,e,i,s){var r=((new fcom.date.DateTime).getTimestamp()-t.getTimestamp())/864e5,e=(e.getTimestamp()-t.getTimestamp())/864e5,t=s||14<r,a=t?window.mappingNoIntraday:window.mappingIntraday,n=t?e:r;if(i!=undefined){for(var h=0;h<window.chartPeriodicityMapping.length&&window.chartPeriodicityMapping[h]!=i;h++);if(n<=a.maxDays[h]&&n>=a.minDays[h])return i}for(h=window.chartPeriodicityMapping.length-1;0<=h;h--)if(n>a.maxDays[h]&&0<=a.maxDays[h])return h==window.chartPeriodicityMapping.length-1?window.chartPeriodicityMapping[h]:window.chartPeriodicityMapping[h+1];return a.notFoundMapping},window.loadChartImage=function(t,e,i){var s=i[1],r=i[0],r=YAHOO.util.Dom.getRegion(r),a=r.right-r.left,s=s.replace(/&w=[^&]*/,"&w="+a),a=r.bottom-r.top;s=s.replace(/&h=[^&]*/,"&h="+a),i[0].src=s},window.setChartDatesFromDays=function(t,e){e.ed=new fcom.date.DateTime;t=e.ed.getTimestamp()-1e3*(parseInt(t)-1)*60*60*24;e.sd=(new fcom.date.DateTime).setTimestamp(t)},window.getRefreshTimestamp=function(t){var e=(new Date).getTime()-12084419e5;return(e=parseInt(e/(1e3*t))).toString(36)},window.ngpNamespace("YAHOO.fcom.chart"),YAHOO.fcom.chart.ChartModule=function(t,e,i,s,r,a){var n;this.prefix=t,this.chartParams=new window.MiniChartParametersClass,this.chartParams.imgObjRef=YAHOO.util.Dom.get(this.prefix+"chartImageTag"),this.chartParams.baseUrl=window.ctx+"/a.chart?method=mini"+(window.YAHOO.fcom.viewInfo.isMobile?"&print=true":""),this.chartParams.RIC=i,this.chartParams.n=r,this.instrumentType=s,this.chartParams.alwaysHist=a,(/=RR$/.test(i)||/=XX$/.test(i))&&(this.chartParams.isYield=!0),this.chartParams.recalculateDimensionsFromPage(this.chartParams.imgObjRef)?this.chartParams.setChartImageUrl():0<=window.navigator.userAgent.toLowerCase().indexOf("blackberry")&&(n=this.chartParams,window.setTimeout(function(){n.recalculateDimensionsFromPage(n.imgObjRef)&&n.setChartImageUrl()},5e3)),e&&""!=e&&(this.moduleId=e,this.setTimePeriodMarker(),null==(t=YAHOO.util.Dom.get(e))&&(t=YAHOO.util.Dom.get(e+"_moduleContent")),null!=window.onElementResize&&(this.onElementResizeHandler=function(t,e,i){var s;i[0].id==e[0].id&&(i[1].recalculateDimensionsFromPage(i[1].imgObjRef)?i[1].setChartImageUrl():(s=i[1],window.setTimeout(function(){s.recalculateDimensionsFromPage(s.imgObjRef)&&s.setChartImageUrl()},500)))},window.onElementResize.subscribe(this.onElementResizeHandler,[t,this.chartParams])),this.resizeHandler=function(t,e){null!=e.imgObjRef?(e.recalculateDimensionsFromPage(e.imgObjRef),e.setChartImageUrl()):YAHOO.util.Event.removeListener(window,"resize",arguments.callee)},YAHOO.util.Event.addListener(window,"resize",this.resizeHandler,this.chartParams,null),null!=YAHOO.util.Dom.get(this.prefix+"chartImageBox"))&&window.onChildrenChange&&1==window.onChildrenChange.registerNodeInterest(YAHOO.util.Dom.get(this.prefix+"chartImageBox"))&&window.onChildrenChange.subscribe(function(t,e,i){i[0]==e[0]&&i[2]+6e4<(new Date).getTime()&&(i[2]=(new Date).getTime(),i[1].checkChartReloadNecessary())},[YAHOO.util.Dom.get(this.prefix+"chartImageBox"),this,(new Date).getTime()]),YAHOO.util.Event.addListener(YAHOO.util.Dom.get(this.prefix+"tagesverlaufDiv"),"click",this.timePeriodClicked,[this.chartParams,0],this),YAHOO.util.Event.addListener(YAHOO.util.Dom.get(this.prefix+"wochenverlaufDiv"),"click",this.timePeriodClicked,[this.chartParams,1],this),YAHOO.util.Event.addListener(YAHOO.util.Dom.get(this.prefix+"monatsverlaufDiv"),"click",this.timePeriodClicked,[this.chartParams,2],this),YAHOO.util.Event.addListener(YAHOO.util.Dom.get(this.prefix+"dreimonatsverlaufDiv"),"click",this.timePeriodClicked,[this.chartParams,3],this),YAHOO.util.Event.addListener(YAHOO.util.Dom.get(this.prefix+"jahresverlaufDiv"),"click",this.timePeriodClicked,[this.chartParams,4],this),YAHOO.util.Event.addListener(YAHOO.util.Dom.get(this.prefix+"zweijahresverlaufDiv"),"click",this.timePeriodClicked,[this.chartParams,5],this),YAHOO.util.Event.addListener(YAHOO.util.Dom.get(this.prefix+"zehnjahresverlaufDiv"),"click",this.timePeriodClicked,[this.chartParams,6],this),YAHOO.util.Event.addListener(YAHOO.util.Dom.get(this.prefix+"wochenverlaufHistDiv"),"click",this.timePeriodClicked,[this.chartParams,7],this),YAHOO.util.Event.addListener(YAHOO.util.Dom.get(this.prefix+"zweiwochenverlaufHistDiv"),"click",this.timePeriodClicked,[this.chartParams,8],this)},YAHOO.fcom.chart.ChartModule.TIME_PERIOD_DAYS=new Array(1,7,30,90,365,740,3650,8,15),YAHOO.fcom.chart.ChartModule.prototype={setMarkerStatus:function(t,e){this.chartParams.n==YAHOO.fcom.chart.ChartModule.TIME_PERIOD_DAYS[e]?YAHOO.util.Dom.addClass(t,"on"):YAHOO.util.Dom.removeClass(t,"on")},destroy:function(){for(var t in YAHOO.util.Event.removeListener(YAHOO.util.Dom.get(this.prefix+"tagesverlaufDiv"),"click"),YAHOO.util.Event.removeListener(YAHOO.util.Dom.get(this.prefix+"wochenverlaufDiv"),"click"),YAHOO.util.Event.removeListener(YAHOO.util.Dom.get(this.prefix+"monatsverlaufDiv"),"click"),YAHOO.util.Event.removeListener(YAHOO.util.Dom.get(this.prefix+"dreimonatsverlaufDiv"),"click"),YAHOO.util.Event.removeListener(YAHOO.util.Dom.get(this.prefix+"jahresverlaufDiv"),"click"),YAHOO.util.Event.removeListener(YAHOO.util.Dom.get(this.prefix+"zweijahresverlaufDiv"),"click"),YAHOO.util.Event.removeListener(YAHOO.util.Dom.get(this.prefix+"zehnjahresverlaufDiv"),"click"),YAHOO.util.Event.removeListener(YAHOO.util.Dom.get(this.prefix+"wochenverlaufHistDiv"),"click"),YAHOO.util.Event.removeListener(YAHOO.util.Dom.get(this.prefix+"zweiwochenverlaufHistDiv"),"click"),this.resizeHandler&&YAHOO.util.Event.removeListener(window,"resize",this.resizeHandler),null!=window.onElementResize&&window.onElementResize.unsubscribe(this.onElementResizeHandler),this.chartParams)delete this.chartParams[t],this.chartParams[t]=null;for(t in this)delete this[t],this[t]=null},setTimePeriodMarker:function(){this.setMarkerStatus(YAHOO.util.Dom.get(this.prefix+"tagesverlaufDiv"),0),this.setMarkerStatus(YAHOO.util.Dom.get(this.prefix+"wochenverlaufDiv"),1),this.setMarkerStatus(YAHOO.util.Dom.get(this.prefix+"monatsverlaufDiv"),2),this.setMarkerStatus(YAHOO.util.Dom.get(this.prefix+"dreimonatsverlaufDiv"),3),this.setMarkerStatus(YAHOO.util.Dom.get(this.prefix+"jahresverlaufDiv"),4),this.setMarkerStatus(YAHOO.util.Dom.get(this.prefix+"zweijahresverlaufDiv"),5),this.setMarkerStatus(YAHOO.util.Dom.get(this.prefix+"zehnjahresverlaufDiv"),6),this.setMarkerStatus(YAHOO.util.Dom.get(this.prefix+"wochenverlaufHistDiv"),7),this.setMarkerStatus(YAHOO.util.Dom.get(this.prefix+"zweiwochenverlaufHistDiv"),8)},timePeriodClicked:function(t,e){var i=e[0],e=e[1];i.n=YAHOO.fcom.chart.ChartModule.TIME_PERIOD_DAYS[e],"quickviewChart"==this.prefix&&window.chartModuleOptions&&(window.chartModuleOptions[this.instrumentType]={period:i.n},window.savePageSettings("chartModule",window.chartModuleOptions,!1)),window.user&&window.user.isPageViewCounting&&window.logPageView(),i.setChartImageUrl(),this.setTimePeriodMarker(i)},checkChartReloadNecessary:function(){null!=this.chartParams.hist&&0!=this.chartParams.hist||this.chartParams.setChartImageUrl()}},YAHOO.fcom.chart.ChartMap=function(t){t=YAHOO.util.Dom.get(t),this.image=t,this.map=null,this.mouseOverEvent=new YAHOO.util.CustomEvent("mouseover",this,!1,YAHOO.util.CustomEvent.LIST),this.mouseOutEvent=new YAHOO.util.CustomEvent("mouseout",this,!0,YAHOO.util.CustomEvent.LIST)},YAHOO.fcom.chart.ChartMap.counter=0,YAHOO.fcom.chart.ChartMap.prototype={requestMap:function(t){t=t.getUrlParameters();"&"==t.charAt(0)&&(t=t.substring(1,t.length)),window.ngpAsyncRequest("POST","a.chart?method=largeMouseoverInfos",{success:this.updateMap,scope:this,silent:!0},t)},updateMap:function(t){t=JSON.parse(t.responseText);this.createMap(t)},addArea:function(t){var e=document.createElement("area");e.setAttribute("href","#"),e.setAttribute("shape","rect"),e.setAttribute("coords",[t.x,t.y-t.height,t.x+t.width,t.y].join(",")),this.map.appendChild(e),YAHOO.util.Event.addListener(e,"mouseover",function(t,e){this.mouseOverEvent.fire(t,e)},t,this),YAHOO.util.Event.addListener(e,"mouseout",function(){this.mouseOutEvent.fire()},this,!0)},createMap:function(t){this.map&&(YAHOO.util.Dom.getElementsBy(function(){return!0},"area",this.map,function(t){YAHOO.util.Event.purgeElement(t)}),this.map.parentNode)&&this.map.parentNode.removeChild(this.map);var e="chartMap"+YAHOO.fcom.chart.ChartMap.counter++;this.map=document.createElement("map"),this.map.setAttribute("name",e),this.map.setAttribute("id",e);for(var i=t.length;i--;)this.addArea(t[i]);YAHOO.util.Dom.insertAfter(this.map,this.image),this.image.setAttribute("useMap","#"+e)}};
//# sourceMappingURL=chart.js.map;
(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tabmenuAccessibility = require("aria/tabmenuAccessibility");
var _navigationAccessibility = require("aria/navigationAccessibility");
var _default = exports.default = function _default() {
  (0, _navigationAccessibility.setAriaAttributesToTargetLinks)();
  (0, _navigationAccessibility.setAriaAttributeHaspopupToLinks)();
  (0, _navigationAccessibility.setAriaAttributesToPageNavigation)();
  (0, _navigationAccessibility.setAriaAttributesToDetailPageNavigation)();
  (0, _tabmenuAccessibility.setAriaAttributesToModuleTabMenu)();
};

},{"aria/navigationAccessibility":2,"aria/tabmenuAccessibility":3}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAriaAttributesToTargetLinks = exports.setAriaAttributesToPageNavigation = exports.setAriaAttributesToDetailPageNavigation = exports.setAriaAttributeHaspopupToLinks = void 0;
var _messageHandler = require("../messages/messageHandler");
var matchedCssClasses = ['mainMenu', 'firstMenu', 'secondMenu', 'thirdMenu', 'footer'];
var matchedPopupLinks = [{
  'mainMenu': 'menu.item.settings'
}];

/**
 * set aria attributes to page navigation
 */
var setAriaAttributesToPageNavigation = exports.setAriaAttributesToPageNavigation = function setAriaAttributesToPageNavigation() {
  //
  var lastMenuRow = $('div.menus').children().last();
  setAriaCurrentAttributeToMenu($(lastMenuRow).find('div.menu'), 'page');
  //
  var rows = $('div.menus').children();
  //
  rows.push($('.footer'));
  //
  $(rows).each(function (i, menuEle) {
    setAriaAttributesForNavigationByElement(menuEle);
  });
  //
  setAriaAttributesForNavigationByClassName($('.login .header').find('div.menu'), 'language');
};

/**
 * set aria attributes to detail page navigation
 */
var setAriaAttributesToDetailPageNavigation = exports.setAriaAttributesToDetailPageNavigation = function setAriaAttributesToDetailPageNavigation() {
  var detailPageMenuElement = $('.pageContentMenu').find('div.menu');
  setAriaAttributesForNavigationByClassName(detailPageMenuElement, 'pageContentMenu');
  setAriaCurrentAttributeToMenu(detailPageMenuElement, 'location');
};

/**
 * set aria attributes for navigation
 * @param menuEle
 */
var setAriaAttributesForNavigationByElement = function setAriaAttributesForNavigationByElement(menuEle) {
  var cssClass = getMatchedCssClass(menuEle);
  if (cssClass) {
    setAriaAttributesForNavigationByClassName($(menuEle).find('div.menu'), cssClass);
  }
};

/**
 * set aria attributes for navigation to given menu
 * @param menu
 * @param className
 */
var setAriaAttributesForNavigationByClassName = function setAriaAttributesForNavigationByClassName(menu, className) {
  $(menu).attr('role', 'navigation');
  $(menu).attr('aria-label', (0, _messageHandler.getMessage)("navigation.type.".concat(className)));
};

/**
 * set aria-current attribute to given menu
 * @param menu
 * @param value
 */
var setAriaCurrentAttributeToMenu = function setAriaCurrentAttributeToMenu(menu, value) {
  $(menu).children().each(function (i, el) {
    if ($(el).hasClass('on')) {
      $(el).find('a').attr('aria-current', value);
      return false;
    }
  });
};

/**
 * set aria attribute haspopup
 */
var setAriaAttributeHaspopupToLinks = exports.setAriaAttributeHaspopupToLinks = function setAriaAttributeHaspopupToLinks() {
  matchedPopupLinks.forEach(function (obj) {
    for (var menuCssClass in obj) {
      var linkElement = getLinkElement(menuCssClass, obj[menuCssClass]);
      setAriaAttributeHaspopupByLink(linkElement);
    }
  });
  // thomson reuters footer link hardcoded in jsps
  $('div.footer').find('a:contains("Refinitiv")').attr('aria-haspopup', true);
};

/**
 * set the aria attribute haspopup to given link
 * @param linkElement
 */
var setAriaAttributeHaspopupByLink = function setAriaAttributeHaspopupByLink(linkElement) {
  if (linkElement) {
    $(linkElement).attr('aria-haspopup', true);
  }
};

/**
 * set hidden element to links which open a new window
 */
var setAriaAttributesToTargetLinks = exports.setAriaAttributesToTargetLinks = function setAriaAttributesToTargetLinks() {
  var targetLinks = $('a[target=_blank]');
  // my markets link has no target blank attribute
  targetLinks.push(getLinkElement('mainMenu', 'menu.item.mymarkets'));
  //
  targetLinks.each(function (i, el) {
    var message = (0, _messageHandler.getMessage)('navigation.link.openNewWindow');
    var hintElement = $("<span class='visuallyhidden'>".concat(message, "</span>"));
    $(el).append(hintElement);
  });
};

/**
 * returns link element by given menu css class and caption key
 * @param menuCssClass
 * @param captionKey
 * @returns {HTMLElement}
 */
var getLinkElement = function getLinkElement(menuCssClass, captionKey) {
  var menu = $(".".concat(menuCssClass)).find('.menu');
  var linkCaption = (0, _messageHandler.getMessage)("".concat(captionKey));
  return getLinkElementByCaption(menu, linkCaption);
};

/**
 * returns the link element of the given menu by the given caption
 * @param menuElement
 * @param caption
 * @returns {HTMLElement}
 */
var getLinkElementByCaption = function getLinkElementByCaption(menuElement, caption) {
  var linkTag = null;
  $(menuElement).children().each(function (i, e) {
    if ($(e).find('a').text() === caption) {
      linkTag = $(e).find('a');
      return false;
    }
  });
  return linkTag;
};

/**
 * returns the css class of the given element, which matches with one of the array items of matchedCssClasses
 * @param ele
 * @returns {String}
 */
var getMatchedCssClass = function getMatchedCssClass(ele) {
  var matchedCssClass = null;
  matchedCssClasses.forEach(function (cssClass) {
    if ($(ele).hasClass(cssClass)) {
      matchedCssClass = cssClass;
      return false;
    }
  });
  return matchedCssClass;
};

},{"../messages/messageHandler":7}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAriaAttributesToModuleTabMenu = void 0;
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * set aria attributes to moduletabmenus
 */
var setAriaAttributesToModuleTabMenu = exports.setAriaAttributesToModuleTabMenu = function setAriaAttributesToModuleTabMenu($menu) {
  var moduleTabMenus = $menu || $('div.moduleTabMenu div.menu');
  setAttributes(moduleTabMenus);
};

/**
 * set aria attributes to tablist and tabpanel for all tab menus on the page with tab buttons inside
 * @param menus
 */
var setAttributes = function setAttributes(menus) {
  $(menus).each(function (index, menu) {
    if ($(menu).find('button.icon').length > 0) {
      setAttributesToTablist(menu);
    }
  });
};

/**
 * set attributes to module tab menu elements by given tab menu
 * @param menu
 */
var setAttributesToTablist = function setAttributesToTablist(menu) {
  // todo get module title without timeout
  window.setTimeout(function () {
    // timeout because of loading... text at the beginning
    var moduleTitle = $(menu).closest('div.module').find('div.moduleHeader h2');
    $(menu).attr('role', 'tablist');
    $(menu).attr('aria-label', $(moduleTitle).text());
  }, 2000);
  setAriaAttributesToButtons($(menu));
};

/**
 * set attributes to tab buttons to given tab menu
 * @param menu
 */
var setAriaAttributesToButtons = function setAriaAttributesToButtons(menu) {
  var tabMenu = menu;
  var menuItems = $(tabMenu).find('div.menuItem');
  $(tabMenu).find('button').each(function (index, button) {
    $(button).attr('role', 'tab').attr('aria-selected', false).on('keydown', function (e) {
      if (e.keyCode === _keyCodes.default.ENTER || e.keyCode === _keyCodes.default.SPACE) {
        updateTabButtons(tabMenu, e.target);
      }
    }).on('click', function (e) {
      updateTabButtons(tabMenu, e.target);
    });
  });
  $(menuItems).each(function (index, item) {
    if ($(item).hasClass('on')) {
      setTabButtonSelected($(item).find('button'));
      return true;
    }
  });
};

/**
 * update attributes of tab buttons
 * @param menu
 * @param pressedBtn
 */
var updateTabButtons = function updateTabButtons(menu, pressedBtn) {
  var menuItemButtons = $(pressedBtn).parent('.menuItem').parent().find('> .menuItem button');
  menuItemButtons.attr('aria-selected', false).removeAttr('tabindex');
  setTabButtonSelected(pressedBtn);
};

/**
 * set given button as selected
 * @param button
 */
var setTabButtonSelected = function setTabButtonSelected(button) {
  $(button).attr({
    'aria-selected': true,
    tabindex: -1
  });
};

},{"util/enums/keyCodes":9}],4:[function(require,module,exports){
"use strict";

var _countryIsoConverter = require("modules/DynamicWorldmapModule/countryIsoConverter");
var _aria = _interopRequireDefault(require("aria"));
require("./util/pageVisibilityEventHelper.es6.js");
var _menu = _interopRequireDefault(require("menu"));
require("./util/freezeTableHeaderHelper.es6.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); } /* global YAHOO : true */ /* global Event : true */ /* global Dom : true */ /* global fcom : true */
$(function () {
  // after dom ready the aria handler is initialized
  (0, _aria.default)();
  // #. Init the menu customization
  (0, _menu.default)();
});

/*
 * This javascript file provides some basic functions used
 * everywhere on ngp. The basic YUI libraries (DOM, event, lang) must be available
 * for this script to function properly
 */

window.ngpNamespace('YAHOO.fcom');
window.Dom = YAHOO.util.Dom;
window.Lang = YAHOO.lang;
window.FUtil = YAHOO.fcom.Util;
window.debug = true;
window.mouseCoords = [0, 0];
window.genericYUIButton = null;
window.genericButtonLastPressed = 0; // save the timestamp of the last buttonclick, to prevent actions from beeing performed several times when clicking double...
window.genericButtonLastPressedInstance = ''; // save the button instance of the last buttonclick, to prevent actions from beeing performed several times when clicking double...
window.domToYUIMap = {};

/*
 * Returns the item that has currently focus.
 * @type Function
 * @return {HTMLElement}
 */
window.getActiveElement = function () {
  var activeElement = null;
  if (document.addEventListener) {
    // for FF
    document.addEventListener('focus', function (event) {
      activeElement = YAHOO.util.Event.getTarget(event);
    }, true); // capture = true -> bubble up the dom tree
  }

  return function () {
    return activeElement || document.activeElement; // IE only;
  };
}();

/*
 * a map object to keep track of YUI panels and other YUI objects that
 * are responsible for dom nodes. With that object e.g. elements that are situated
 * in panels can find the panel instance from the dom node they are situated in and
 * listen for events from that panel. It can also be used to find a button handler from a
 * button id.
 */
window.domToYUIMap = {};

/*
 * a map to remember which applets are hidden by wich overlays. This is needed because
 * overlays are not displayed on top of applets in the browser. So any applet that intersects a
 * overlay element will be made invisible. Of course it has to be made visible lateron, that's
 * what the map is for.
 * ATTENTION: This functionality has nothing to do with financial.com applets and must be there
 * even when ngp has no applets any more, e.g. when a customer adds an applet to the html-module
 */
window.hiddenAppletMap = {};

/*
 * Often the browser uses a different hostname than the server expects, e.g. when using manuall DNS entries or
 * in customer's intranet behind proxy machines. To be able to create absolute links on server side, this client side
 * host is written to a cookie, so that the server side has access to it.
 */
window.writeClientHostToCookie = function () {
  try {
    if (document.cookie === null || document.cookie.indexOf('clientSideHref') < 0) {
      document.cookie = "clientSideHref=".concat(encodeURIComponent(window.location.href.substring(0, window.location.href.indexOf('/', 9))), "; path=/");
    }
  } catch (e) {
    // no cookies allowed??
  }
};

/*
 * when opening a new url by a press on a button, it's not possible to give a
 * target attribute as is with the link tag. This function will create a dummy form
 * and submit it to the given url, as the form also allows a target attribute.
 * @param url the url to open
 * @param target a target string addressing another frame or window or things like
 * "_top" or "_blank"
 */
window.openUrlWithTarget = function (url, target) {
  var newForm = document.createElement('form');
  var params = {};
  var pos = url.indexOf('?'); // parameters on the url?
  if (pos > -1) {
    // question mark found, get parameters as map
    params = YAHOO.fcom.Util.getURLParams(url);
    url = url.substring(0, pos);
  }
  newForm.action = url;
  newForm.target = target;
  newForm.style.display = 'none'; // keep form invisible to not interfere with the page
  newForm.method = 'GET';
  document.body.appendChild(newForm);
  for (var paramName in params) {
    var inputNode = document.createElement('input');
    inputNode.setAttribute('type', 'hidden');
    inputNode.name = paramName;
    inputNode.value = params[paramName];
    newForm.appendChild(inputNode);
  }
  newForm.submit();
};

/*
 * when onOff === 0, the css class "hover" is removed from the given element,
 * otherwise the css class "hover" is added to it.
 * the delay parameter is optional, if set, the change is not done at once, but after the given number of milliseconds
 */
window.hover = function (element, onOff, delay) {
  if (!delay || YAHOO.lang.isNumber(delay) === false) {
    delay = 0;
  }
  if (onOff === 0) {
    if (delay > 0) {
      YAHOO.lang.later(delay, null, function (param) {
        Dom.removeClass(param, 'hover');
      }, element, false);
    } else {
      Dom.removeClass(element, 'hover');
    }
  } else if (delay > 0) {
    YAHOO.lang.later(delay, null, function (param) {
      Dom.addClass(param, 'hover');
    }, element, false);
  } else {
    Dom.addClass(element, 'hover');
  }
};

/*
 * this small function can be used to stop automatically created
 * form submits. Just not onSubmit="return stopAutoFormSubmit();" and then the
 * form should not submit automatically in any brother. But then you have to
 * set the keylisteners manually when the form should send on ENTER key.
 * @param eventVar
 * @return
 */
window.stopAutoFormSubmit = function (eventVar) {
  return YAHOO.fcom.Forms.stopAutoFormSubmit(eventVar);
};

/*
 * open a new window with a print view of the page or a sub part of the page.
 * @param config a config object that takes parameters for the print view. Expected config attributes are
 *        "printSubNode" : the id of a DOM node in the page, to print its content instead of the complete page
 *        "width"        : (integer) the width in pixels to open the new window with
 *        "height"       : (integer) the height in pixels to open the new window with
 */
window.genericPrintView = function (config) {
  YAHOO.fcom.Broadcaster.sendMessage('.beforePrint', {});
  if (!config) {
    config = {};
  }
  if (!config.width || isNaN(config.width)) {
    config.width = Dom.getViewportWidth() + 18;
  }
  if (!config.height || isNaN(config.height)) {
    config.height = 700;
  }
  var path = '/decorators/printContainer.plain';
  if (config.printSubNode && config.printSubNode != null && config.printSubNode.length > 0) {
    path += "?printSubNode=".concat(config.printSubNode);
  }
  window.open(window.ctx + path, 'printWindow', "width=".concat(config.width, ", height=").concat(config.height, ", location=no, menubar=yes, status=no, toolbar=no, resizable=yes, scrollbars=yes"));
};

/*
 * open a new window with a print view of the newsarticle as pdf.
 * @param {String} nid
 * @param {String} format
 */
window.genericNewsArticleAsPdf = function (nid, format) {
  var url = '/pdf/news/printContainer.plain';
  window.genericArticleAsPdf(nid, url, format);
};

/*
 * open a new window with a print view of the BMI-newsarticle as pdf.
 * @param {String} nid
 * @param {String} format
 */
window.genericPictureNewsArticleAsPdf = function (nid) {
  var url = '/pdf/news/picture/pictureArticle.plain';
  window.genericArticleAsPdf(nid, url, null);
};

/*
 * open a new window with a print view of the newsarticle as pdf.
 * @param {String} nid
 * @param {String} url
 * @param {String} format
 */
window.genericArticleAsPdf = function (nid, url, format) {
  var path = window.ctx + url;
  if (nid && nid != null && nid.length > 0) {
    path += "?nid=".concat(nid);
  }
  if (format != null) {
    path += "&format=".concat(encodeURIComponent(format));
  } else {
    path += '&format=2';
  }
  window.open(path, 'newsarticle', "top=0,width=858,resizable=yes,menubar=yes,status=no,scrollbars=yes,height=".concat(Dom.getViewportHeight())).focus();
};

/*
 * this method can be called when the javascript finds out that the session of the user
 * is expired. This might happen e.g. when the user is login in through another browser.<br>
 * Given the case that there was an ajax call, the call will return 401 error and the right
 * error handling is calling this function
 */
window.sessionExpired = function () {
  window.indexedDB.deleteDatabase("localforage");
  window.redirectTo('/login/logout.action?method=handleLogout');
};
document.onmousemove = function (eventVar) {
  if (!eventVar) {
    eventVar = window.event;
  } // IE style of event
  window.mouseCoords[0] = YAHOO.util.Event.getPageX(eventVar);
  window.mouseCoords[1] = YAHOO.util.Event.getPageY(eventVar);
};

/*
 * link to the detail page. Parameter string should start with the first parameter (without ?)
 * any further parameter should be appended with the & url-syntax.
 * parameter values must be url-encoded, when the use special characters.
 */
window.detail = function (parameterString) {
  if (parameterString.startsWith("ric=")) {
    //To prevent double encoding issue mentioned in NGPII-22681 and NGPII-22098
    parameterString = "ric=" + encodeURIComponent(decodeURIComponent(parameterString.substring(4)));
  }
  window.redirectTo("/detail/detailPage.html?".concat(parameterString));
};
window.detailNews = function (page, parameterString) {
  window.redirectTo("".concat(page, "?").concat(parameterString));
};
window.detailPage = window.detailNews; // TODO: refactor usage, as this is the same

/*
 * this function takes a target object and a source object and copies all attributes
 * that are missing in the target object, but available in the source object into the target object
 * It is just adding the references, objects are not cloned!
 * @param targetObject the object to add attributes to
 * @param srcObject the object to iterate over and copy attributes from.
 */
window.copyMissingAttributes = function (targetObject, srcObject) {
  for (var attributeName in srcObject) {
    if (!targetObject[attributeName]) {
      targetObject[attributeName] = srcObject[attributeName];
    }
  }
};

/*
 * this function can be used to set a group of checkboxes or radioboxes disabled, just by passing one of the
 * input elements. The function will set all elements disabled, that have the same name attribute and are situated in the same form.
 * @param element one of the group elements to be disabled, or the id of one
 * @param isDisabled boolean parameter. When passed as true, elements will be disabled, when passed false, elements will be enabled
 */
window.setElementGroupDisabled = function (element, isDisabled) {
  element = Dom.get(element);
  var elementsArray = element.form.elements[element.name];
  for (var i = 0; i < elementsArray.length; i++) {
    window.setElementDisabled(elementsArray[i], isDisabled);
  }
};

/*
 * this function will set the given element disabled. Therefore the css class
 * "disabled" will be set to the element node and if it is an image, the image source
 * will be updated to use the "disabled" image. When the parameter isDisabled is given
 * as false, the opposite is done. The css class "disabled" will be removed and in case of image,
 * the image source will be updated to use the normal image.
 * The element parameter can either be the id string of an element or the element node from the
 * DOM tree itself.
 * Known element types are
 * - images
 * - buttons
 * - input fields
 * - single checkboxes and radioboxes
 * - YUI style drop down menus (element must be the javascript menu instance, not any DOM node)
 * when a full group of radio boxes or checkboxes should be disabled, use the setElementGroupDisabled(element, isDisabled)
 * function.
 */

window.setElementDisabled = function () {
  var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var isDisabled = arguments.length > 1 ? arguments[1] : undefined;
  element = typeof element === 'string' ? Dom.get(element) : element;
  if (element) {
    isDisabled = isDisabled === false ? false : true;

    /* TODO: there seem to be problems when elements like radios or checkboxes are
     * given as element, as element is then an array of elements and does not directly have a
     * nodeName of course. This case should be implemented and tested.
     * Also see bug#9384 https://intranet.financial.com/bugzilla/show_bug.cgi?id=9384
     */

    var setDomDisabledState = function setDomDisabledState() {
      var disableClass = 'disabled';
      if (isDisabled) {
        Dom.addClass(element, disableClass);
        element.setAttribute('disabled', disableClass);
        element.setAttribute('aria-disabled', true);
      } else {
        Dom.removeClass(element, disableClass);
        element.removeAttribute(disableClass);
        element.setAttribute('aria-disabled', false);
      }
    };
    var setInputElementsState = function setInputElementsState() {
      var disableClass = '';
      if (Dom.hasClass(element, 'checkbox') || Dom.hasClass(element, 'radio') || Dom.hasClass(element, 'radiobutton')) {
        var imgNode = Dom.getPreviousSiblingBy(element, function (node) {
          return node.nodeName === 'SPAN' && (Dom.hasClass(node, 'checkbox') || Dom.hasClass(node, 'radio') || Dom.hasClass(node, 'radiobutton'));
        });
        if (imgNode) {
          disableClass = Dom.hasClass(imgNode, 'checkbox') ? 'checkbox-disabled' : disableClass;
          disableClass = Dom.hasClass(imgNode, 'radiobutton') ? 'radio-disabled' : disableClass;
          disableClass = Dom.hasClass(imgNode, 'radio') ? 'disabled' : disableClass;
          isDisabled ? Dom.addClass(imgNode, disableClass) : Dom.removeClass(imgNode, disableClass);
        }
      }
      var labels = Dom.getElementsBy(function (node) {
        return node.htmlFor && node.htmlFor === element.id;
      }, 'label', document.body);
      if (labels) {
        disableClass = 'disabled';
        for (var i = 0; i < labels.length; i++) {
          isDisabled ? Dom.addClass(labels[i], disableClass) : Dom.removeClass(labels[i], disableClass);
        }
      }
    };
    if (element.cfg && typeof element.cfg.setProperty === 'function') {
      return element.cfg.setProperty('disabled', isDisabled);
    }
    if (element.nodeName) {
      var handler = window.domToYUIMap[element.id];
      if (handler && typeof handler.setDisabled === 'function') {
        // has a setDisabled function? call it!
        return handler.setDisabled(isDisabled);
      }
      setDomDisabledState();
      switch (element.nodeName.toLowerCase()) {
        case 'button':
          if (!Dom.hasClass(element, 'icon')) {
            YAHOO.fcom.Forms.setButtonDisabled(element, isDisabled);
          }
          break;
        case 'img':
          element.src = isDisabled ? window.getImageSource(element.src, ['-hover', '-active'], '-disabled') : window.getImageSource(element.src, '-disabled', null);
          break;
        case 'input':
          setInputElementsState();
          break;
        default:
        //
      }
    }
  }
};

/*
 * this function looks for placeholders in the text in spring message syntax ( "{0}", "{1}", ...)
 * and replaces those by the given arguments array content. If there are more placeholders than
 * arguments array is long, only the ones with arguments are replaced. If the arguments array is longer,
 * the entries that do not match placeholders are ignored.
 */
window.replaceSpringMessageArguments = function (text, args) {
  var pattern = new RegExp('(.*?)[{](.*?)[}]', 'g');
  return YAHOO.fcom.Util.format(text, args, pattern);
};
/*
 * Event fired on resize of a module (includes manual and window resize).
 * First element in the argument list is the dom element of the module
 */
window.onElementResize = new YAHOO.util.CustomEvent('onElemenResize');
window.forceResizeEvent = new YAHOO.util.CustomEvent('forceResizeEvent');

/**
 * Event to fire when a browser tab's visibility changed(background & foreground)
 */
window.pageVisibilityChanged = new YAHOO.util.CustomEvent('pageVisibilityChanged');
window.moduleDropped = new YAHOO.util.CustomEvent('moduleDropped');

/*
 * Event fired when modules are dragged for resizing.
 * First element in the argument list is the dom element of the module. Second element is the drag and drop proxy element.
 */
window.onElementResizeDrag = new YAHOO.util.CustomEvent('onElementResizeDrag');
window.onChildrenChange = new YAHOO.util.CustomEvent('onChildrenChange');
window.onChildrenChange.registeredNodes = [];

// TODO: change so that the event is only fired once, then when the change is known, it should not be fired until it is of interest again.
// how to do that???

/*
 * with this function nodes can be registered, that are interested in changes of their child nodes.
 * @param node the node that is interested in child nodes changing their content
 * @return whether this node is registered (true) or false, when the node was already registered and is not registered another time
 */
window.onChildrenChange.registerNodeInterest = function (node) {
  for (var i = 0; i < window.onChildrenChange.registeredNodes.length; i++) {
    if (window.onChildrenChange.registeredNodes[i] === node) {
      return false; // allready registered
    }
  }

  window.onChildrenChange.registeredNodes.push(node);
  return true;
};
/*
 * width that function, a node can check whether there is a parent node that is interested in
 * changes in the given child node
 * @param node the child node that can be changed and want to know whether there is a parent node interested in changes
 * @return the next acestor node of the given node, that registered interest in change in the given node. If there is no such node, null is returned
 */
window.onChildrenChange.checkNodeInterest = function (node) {
  for (var i = 0; i < window.onChildrenChange.registeredNodes.length; i++) {
    var theParentNode = node.parentNode;
    while (theParentNode && theParentNode != null) {
      if (theParentNode === window.onChildrenChange.registeredNodes[i]) {
        // node found => return node
        return window.onChildrenChange.registeredNodes[i];
      }
      theParentNode = theParentNode.parentNode;
    }
  } // nothing found => return null
  return null;
};
window.cutOutLastOccurence = function (originalString, suffix) {
  var pos = originalString.lastIndexOf(suffix);
  if (pos > -1) {
    return originalString.substring(0, pos) + originalString.substring(pos + suffix.length);
  } else {
    return originalString;
  }
};
window.getImageSource = function (originalSource, removeStrings, addStrings) {
  var src = originalSource;
  if (YAHOO.lang.isString(removeStrings) && removeStrings.length > 0) {
    src = window.cutOutLastOccurence(originalSource, removeStrings);
  } else if (YAHOO.lang.isArray(removeStrings)) {
    for (var i = 0; i < removeStrings.length; i++) {
      src = window.cutOutLastOccurence(src, removeStrings[i]);
    }
  }
  var pos = src.lastIndexOf('.');
  if (addStrings) {
    if (YAHOO.lang.isString(addStrings) && addStrings.length > 0) {
      if (originalSource.indexOf(addStrings) < 0) {
        src = src.substring(0, pos) + addStrings + src.substring(pos);
      }
    } else if (YAHOO.lang.isArray(addStrings)) {
      var tmpSrc = src.substring(0, pos);
      for (var _i = 0; _i < addStrings.length; _i++) {
        if (tmpSrc.indexOf(addStrings[_i]) < 0) {
          tmpSrc += addStrings[_i];
        }
      }
      tmpSrc += src.substring(pos);
      src = tmpSrc;
    }
  }
  return src;
};

/*
 * add mouse over hovers to all tags that have the link class
 */
window.addHoverToLinkNodes = function (node) {
  var linkNodes = [];
  if (node.getElementsByClassName) {
    linkNodes = node.getElementsByClassName('link');
  } else {
    linkNodes = YAHOO.util.Selector.query('.link', node);
  }
  for (var i = 0; i < linkNodes.length; i++) {
    if (linkNodes[i].nodeName.toLowerCase() === 'img') {
      if (Dom.hasClass(linkNodes[i], 'disabled')) {
        if (linkNodes[i].src.indexOf('-disabled') < 0) {
          linkNodes[i].src = window.getImageSource(linkNodes[i].src, null, '-disabled');
        }
      } else {
        // only images that are not disabled get the event listeners
        YAHOO.util.Event.addListener(linkNodes[i], 'mouseover', function (arg1, arg2) {
          if (!Dom.hasClass(arg2, 'disabled')) {
            arg2.src = window.getImageSource(arg2.src, null, '-hover');
          }
        }, linkNodes[i]);
        YAHOO.util.Event.addListener(linkNodes[i], 'mouseout', function (arg1, arg2) {
          if (!Dom.hasClass(arg2, 'disabled')) {
            arg2.src = window.getImageSource(arg2.src, ['-hover', '-active'], null);
          }
        }, linkNodes[i]);
        YAHOO.util.Event.addListener(linkNodes[i], 'mousedown', function (arg1, arg2) {
          if (!Dom.hasClass(arg2, 'disabled')) {
            arg2.src = window.getImageSource(arg2.src, '-hover', '-active');
          }
        }, linkNodes[i]);
        YAHOO.util.Event.addListener(linkNodes[i], 'mouseup', function (arg1, arg2) {
          if (!Dom.hasClass(arg2, 'disabled')) {
            arg2.src = window.getImageSource(arg2.src, '-active', '-hover');
          }
        }, linkNodes[i]);
      }
    } else {
      YAHOO.util.Event.addListener(linkNodes[i], 'mouseover', function (arg1, arg2) {
        if (!Dom.hasClass(arg2, 'disabled')) {
          Dom.addClass(arg2, 'hover');
        }
      }, linkNodes[i]);
      YAHOO.util.Event.addListener(linkNodes[i], 'mouseout', function (arg1, arg2) {
        Dom.removeClass(arg2, 'hover');
        Dom.removeClass(arg2, 'active');
      }, linkNodes[i]);
      YAHOO.util.Event.addListener(linkNodes[i], 'mousedown', function (arg1, arg2) {
        if (!Dom.hasClass(arg2, 'disabled')) {
          Dom.addClass(arg2, 'active');
        }
      }, linkNodes[i]);
      YAHOO.util.Event.addListener(linkNodes[i], 'mouseup', function (arg1, arg2) {
        Dom.removeClass(arg2, 'active');
      }, linkNodes[i]);
    }
  }
};

/*
 * Remove all event listeners from the given link node
 *
 * @param {HTMLElement} node
 */
window.removeHoverFromLinkNodes = function (node) {
  var linkNodes = [];
  if (node.getElementsByClassName) {
    linkNodes = node.getElementsByClassName('link');
  } else {
    linkNodes = YAHOO.util.Selector.query('.link', node);
  }
  for (var i = 0; i < linkNodes.length; i++) {
    YAHOO.util.Event.purgeElement(linkNodes[i]);
  }
};

// for private use by listOfEntries.jsp (evaluating a click on a table row)
window.chooseFromSearchResultForSingleType = function (fromPanel, rowChild, keyFidlet, idType) {
  var id = window.largeTableRow(rowChild, keyFidlet);
  if (fromPanel) {
    if (window.Lang.isUndefined(idType)) {
      YAHOO.fcom.InstrumentsSearchDialog.idChosen(id);
    } else {
      YAHOO.fcom.InstrumentsSearchDialog.ricOrIsinChosen(idType, id);
    }
  } else if (window.Lang.isUndefined(idType)) {
    window.detail("id=".concat(id));
  } else {
    window.detail("".concat(idType.toLowerCase(), "=").concat(id));
  }
};
window.useRicMatchInPopupSearch = function (ric) {
  YAHOO.fcom.InstrumentsSearchDialog.ricOrIsinChosen('RIC', ric);
};

/*
    Function that sends the form on a module edit dialog with a column selection
    param element: The html element
    param cssSelected: The name css class that marks the html element as selected.
    param cssNotSelected: The name css class that marks the html element as not selected.
*/
window.selectMenuItemByCSS = function (element, cssSelected, cssNotSelected) {
  var actualValue = element.className;
  if (actualValue === cssSelected) {
    element.className = cssNotSelected;
  } else {
    element.className = cssSelected;
  }
};

/*
 * Start a bracket search or a category search for news articles. Shortcut for broadcasting on the <tt>.bracketSearch</tt> channel or
 * <tt>.newsCategorySearch</tt> channel, depending on the format of the passed id.
 * Modules that react to news searches should subscribe to the appropriate channel.
 *
 * @param {String} bracketSearchId
 */
window.bracketSearch = function (bracketSearchId) {
  if (bracketSearchId.search(/^n/) !== -1 || bracketSearchId.search(/^ID:/) !== -1) {
    YAHOO.fcom.Broadcaster.sendMessage('.bracketSearch', bracketSearchId);
  } else {
    YAHOO.fcom.Broadcaster.sendMessage('.newsCategorySearch', bracketSearchId);
  }
};
window.setChartToolSettings = function (settings) {
  // chartToolSettings is defined in jsp files...
  window.chartToolSettings = {};
  var item;
  for (item in settings) {
    window.chartToolSettings[item] = settings[item];
  }
};

/*
 * Open a popup window with the location of the chart tool.
 * The ric passed as url parameter will be initially displayed in the chart tool.
 * If the chart tool popup already exists, the popup is only focused, and
 * an event is fired, which sets the new ric in the chart tool.
 * @param {String} <b>ric</b>
 * @param {Object} <b>config</b> containing the following properties:
 * <ul>
 *  <li>{Number}  <b>width</b> (default available viewport width)
 *  <li>{Number}  <b>height</b> (default available viewport height)
 *  <li>{Number}  <b>top</b> y-Position (defaults to 0)
 *  <li>{Number}  <b>left</b> x-Position (defaults to 0)
 *  <li>{Boolean} <b>focus</b> flag whether popup receives focus (defaults to true)
 * </ul>
 */
window.chartToolPopup = function (ric, config) {
  config = config || {};
  var width = window.screen.availWidth || 800;
  var height = window.screen.availHeight || 600;
  var left = 0;
  var top = 0;
  // chartToolSettings is defined in jsp files...
  if (typeof window.chartToolSettings != 'undefined') {
    if (window.chartToolSettings.height && window.chartToolSettings.width) {
      height = window.chartToolSettings.height;
      width = window.chartToolSettings.width;
    } else {
      window.chartToolSettings.height = height;
      window.chartToolSettings.width = width;
    }
    if (typeof window.chartToolSettings.left !== 'undefined' && typeof window.chartToolSettings.top !== 'undefined') {
      left = window.chartToolSettings.left;
      top = window.chartToolSettings.top;
    } else {
      window.chartToolSettings.top = top;
      window.chartToolSettings.left = left;
    }
  }
  var defaultConfig = {
    top: top,
    left: left,
    width: width,
    height: height,
    focus: true,
    useSigned: false
  };
  YAHOO.lang.augmentObject(config, defaultConfig);
  var windowFeatures = "resizable=yes,top=".concat(config.top, ",left=").concat(config.left, ",width=").concat(config.width, ",height=").concat(config.height); // whitelist
  // get popup handle
  var popup = window.open('', 'chartToolPopup', windowFeatures);
  if (popup != null) {
    if (popup.location.href === 'about:blank') {
      /*
      only needed for dbfx, which is stopped right now
      var url = YAHOO.fcom.Util.addURLParam(window.ctx + "/chartTool.action", "ric", ric);
      */
      var url = "".concat(window.ctx, "/common/charttool.blank?useSigned=").concat(config.useSigned, "&useWebStart=").concat(config.useWebStart);
      popup = window.open(url, 'chartToolPopup');
    } else {
      /*
      only needed for dbfx, which is stopped right now
      var applet = popup.document.applets["Dcts-Client"];
      if (ric != null && applet != null) {
          //signature: public void fireAppletEvent(String target, String event, Object args)
          applet.fireAppletEvent("CT", "setRic", ric); //CT for "charttool" module
      }
      */
    }
    if (config.focus === true) {
      popup.focus();
    }
  }
};
window.myJava = function () {
  return {
    HasDefaultNextGenJPlugin: window.deployJava.isPlugin2(),
    InstalledJREs: window.deployJava.getJREs(),
    useWebStart: window.deployJava.getJREs().length === 0
  };
};

/*
 * Create an extension to the superclass.
 *
 * @TODO: check whether this is needed
 * It's not possible to use a bracket function here. Apply(this ... : "this" gets undefined then!
 *
 * @param superclass {Function} the class you want to extend
 * @param override {Object} prototype members to override in the subclass
 *
 * @return {Function} constructor function for the extended class
 */
window.extend = function (superclass, override) {
  override = override || {};
  var constr = function constr() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    constr.superclass.constructor.apply(this, args);
  };
  YAHOO.extend(constr, superclass, override);
  return constr;
};
window.switchToMobileSite = function () {
  var date = new Date();
  date.setTime(date.getTime() + 1000 * 24 * 60 * 60 * 1000);
  var expires = "; expires=".concat(date.toGMTString());
  var isIE = window.YAHOO.fcom.Util.detectInternetExplorer(false);
  var url = YAHOO.fcom.Util.addURLParam('/ajax.action?method=switchToMobile', 'swipeAllowed', !isIE);
  window.ngpAsyncRequest('GET', url, {
    success: function success(response) {
      var json = JSON.parse(response.responseText);
      if (json.mobileVersion === 'swipe' && isIE) {
        window.ngpAlert(window.getMessage('browser.compatibility.mobileSwipe.alert'));
      } else {
        var link = "".concat(window.ctx).concat(json.mobileStartPage);
        // checks whether the mobile version is old or swipe
        if (link.endsWith("/swipe.html")) {
          link = "".concat(link, "#mobile_swipe_markets");
        }
        document.location.href = link;
      }
    },
    waitMask: true,
    silent: true
  });
};
window.checkLoginForm = function (cfg) {
  if (window.Lang.isNull(cfg) || window.Lang.isUndefined(cfg)) {
    cfg = {
      neglectPwd: false
    };
  }
  if (YAHOO.util.Dom.get('loginNameInput').value === '') {
    return false;
  }
  if (!cfg.neglectPwd) {
    if (YAHOO.util.Dom.get('passwordInput').value === '') {
      return false;
    }
  }
  return true;
};
window.getTextWithQuotationMark = function (text) {
  return YAHOO.fcom.Util.format(window.getMessage('text.withQuotationMark'), [text]);
};
window.writeClientHostToCookie(); // call cookie function, see documentation there

if (window.addEventListener) {
  window.addEventListener('orientationchange', function () {
    var els = YAHOO.util.Selector.query('.yui-menu-body-scrolled');
    for (var i = 0; i < els.length; i++) {
      if (YAHOO.util.Dom.hasClass(els[i], 'notouch')) {
        continue;
      }
      YAHOO.util.Dom.addClass(els[i], 'notouch');
      YAHOO.util.Dom.removeClass(els[i], 'notouch');
    }
  }, true);
}

/*
 * opens a panel with the full news page inside, displaying the given news id in the article div on the right side
 * @param newsId
 */
window.createNewsView = function () {
  /* Functions defined in closure */
  var jumpTo = function jumpTo(name) {
    window.location.hash = "#".concat(name);
  };
  var bracketSearch = function bracketSearch(channel, args) {
    var postData = YAHOO.fcom.Util.createPostData({
      bracketSearch: args[0],
      overlay: true
    });
    var url = '/news.action?method=bracketSearch';
    window.replaceAsync(url, 'newsarticle', {
      replaceContainer: true,
      callback: function callback() {
        jumpTo('articleTop');
      },
      postData: postData
    });
  };
  var categorySearch = function categorySearch(channel, args, panel) {
    panel.hide();
    window.createNewsView({
      newsId: null,
      category: args[0]
    });
  };
  var getPanelConnfig = function getPanelConnfig(width) {
    return {
      x: Dom.getViewportWidth() / 2 - width / 2,
      y: 10,
      width: "".concat(width, "px"),
      fixedcenter: false,
      visible: false,
      close: true,
      dragOnly: true,
      draggable: true,
      constraintoviewport: true,
      modal: true
    };
  };

  // return function(newsId, category, queryCategory, fulltext, countries, predefinedNewsFilter, onlyArticle, config, broadcastedMessage) {
  return function (config) {
    var postdata = {
      nid: !fcom.util.StringHelper.empty(config.newsId) ? config.newsId : null,
      cat: !fcom.util.StringHelper.empty(config.category) ? config.category : null,
      queryCat: !fcom.util.StringHelper.empty(config.queryCategory) ? config.queryCategory : null,
      pre: !fcom.util.StringHelper.empty(config.predefinedNewsFilter) ? config.predefinedNewsFilter : null,
      text: !fcom.util.StringHelper.empty(config.fulltext) ? config.fulltext : null,
      countries: config.countries,
      overlay: config.onlyArticle,
      viewId: YAHOO.fcom.Page.getInstance('moduleContainer') === null ? null : YAHOO.fcom.Page.getInstance('moduleContainer').id,
      isInPanel: true,
      country: null
    };
    if (YAHOO.fcom.viewInfo.country !== '' && typeof postdata.countries === 'string') {
      postdata.countries = postdata.countries.split(',');
      postdata.countries.push(YAHOO.fcom.viewInfo.country);
    }
    if (config.broadcastedMessage && config.broadcastedMessage.messageType === 'country') {
      postdata.country = config.broadcastedMessage.country;
      if (_typeof(postdata.country) === 'object') {
        postdata.country = postdata.country[0];
      }
      if (postdata.country.length !== 2) {
        postdata.country = (0, _countryIsoConverter.convertCountry)(postdata.country);
      }
      postdata.countries = [postdata.country];
    }
    var panelConfig = null;
    var url = null;
    if (config.onlyArticle) {
      url = typeof config.url === 'string' ? config.url : '/news.action?method=getNewsArticle';
      panelConfig = getPanelConnfig(650);
    } else {
      url = typeof config.url === 'string' ? config.url : '/news/overview.plain';
      panelConfig = getPanelConnfig(1004);
    }
    window.fillPanelFromAjax('NewsViewPanelDiv', url, postdata, panelConfig, {
      errorMessage: window.getMessage('USER_UNAUTHORIZED'),
      instanceHandler: function instanceHandler( /* YAHOO.widget.Panel */panelInstance, customObj) {
        if (customObj.onlyArticle) {
          YAHOO.fcom.Broadcaster.subscribe('.bracketSearch', bracketSearch, panelInstance);
          YAHOO.fcom.Broadcaster.subscribe('.newsCategorySearch', categorySearch, panelInstance);
        }
        panelInstance.hideEvent.subscribe(function (evt, args, customObj) {
          if (customObj.onlyArticle) {
            YAHOO.fcom.Broadcaster.unsubscribe('.bracketSearch', bracketSearch, this);
            YAHOO.fcom.Broadcaster.unsubscribe('.newsCategorySearch', categorySearch, this);
          }
        }, {
          onlyArticle: customObj.onlyArticle
        }, panelInstance);
      },
      customObject: {
        onlyArticle: config.onlyArticle
      }
    });
  };
}();

/* ctx and agentpatterns are read from meta-tags */
window.agentpatternsJson = [];
YAHOO.util.Dom.getElementsBy(function (el) {
  return el.getAttribute('name') === 'ngp-context';
}, 'meta', document.head, function (el) {
  window.ctx = el.getAttribute('content');
});
YAHOO.util.Dom.getElementsBy(function (el) {
  return el.getAttribute('name') === 'ngp-agentpatterns';
}, 'meta', document.head, function (el) {
  window.agentpatternsJson = window.eval(el.getAttribute('content'));
});

/* accordion impls */
window.fcomExpanders = [];
window.addExpander = function (expander) {
  window.fcomExpanders.push(expander);
  if (window.fcomExpanders.length < 2) {
    var ecpCtrl = YAHOO.util.Dom.get('expander-controls');
    if (!YAHOO.lang.isNull(ecpCtrl)) {
      YAHOO.util.Dom.get('expander-controls').style.display = 'inline';
    }
    if (!expander.opened) {
      expander.toggle();
    }
  }
};
window.closeAllExpanders = function () {
  if (!window.fcomExpanders.length) {
    return;
  }
  for (var i = 0; i < window.fcomExpanders.length; i++) {
    if (window.fcomExpanders[i].opened) {
      window.fcomExpanders[i].toggle();
    }
  }
};
window.openAllExpanders = function () {
  var i;
  if (!window.fcomExpanders.length) {
    return;
  }
  for (i = 0; i < window.fcomExpanders.length; i++) {
    if (!window.fcomExpanders[i].opened) {
      window.fcomExpanders[i].toggle();
    }
  }
};
window.toggleAllExpanders = function () {
  var i;
  var allOpened = true;
  var allClosed = true;
  if (!window.fcomExpanders.length) {
    return;
  }
  for (i = 0; i < window.fcomExpanders.length; i++) {
    if (window.fcomExpanders[i].opened) {
      allClosed = false;
    } else {
      allOpened = false;
    }
  }
  if (allClosed) {
    for (i = 0; i < window.fcomExpanders.length; i++) {
      window.fcomExpanders[i].toggle();
    }
    return;
  }
  if (allOpened) {
    for (i = 0; i < window.fcomExpanders.length; i++) {
      window.fcomExpanders[i].toggle();
    }
    return;
  }
  for (i = 0; i < window.fcomExpanders.length; i++) {
    if (!window.fcomExpanders[i].opened) {
      window.fcomExpanders[i].toggle();
    }
  }
};
window.diagnostics = function () {
  window.location.href = "".concat(window.ctx, "/settings/diagnostic.html");
};
window.setUserDebugLanguage = function () {
  var url = '/ajax.action?method=setUserDebugLanguage';
  window.ajaxPost(url, {});
};
window.resetUserDebugLanguage = function () {
  var url = '/ajax.action?method=resetUserDebugLanguage';
  window.ajaxPost(url, {});
};
window.positionStickySupport = function () {
  /**
   * There is an issue with the position sticky with overflow: auto/hidden.
   * Because of this the sticky headers for tables are not working as expected.
   * So making this variable to false, to always use the javascript solution.
   * https://jira.financial.com/browse/NGPII-20921
   */

  // Keeping the previous code for future reference.
  // const el = document.createElement('a');
  // const mStyle = el.style;
  // mStyle.cssText = 'position:sticky;position:-webkit-sticky;position:-ms-sticky;';
  // return mStyle.position.indexOf('sticky') !== -1;
  return false;
}();
window.setPositionIcons = function (parentElmSelector) {
  Promise.all([window.fcom.themeHandler.loadThemeConfig('_theme'), window.fcom.themeHandler.loadThemeConfig('simpleChart')]).then(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      generalTheme = _ref2[0],
      moduleTheme = _ref2[1];
    var themeConfig = JSON.parse(JSON.stringify(Object.assign({}, generalTheme, moduleTheme)));
    var colors = [themeConfig.chartColors.neutral].concat(_toConsumableArray(themeConfig.chartColors.additionals));
    var positionIcons = document.querySelectorAll("".concat(parentElmSelector, " .positionIcon"));
    for (var i = 0; i < positionIcons.length; i++) {
      var span = positionIcons[i];
      var positionIndex = parseInt(span.classList.value.match(/position([\d+])\s+/)[1]);
      span.style.backgroundColor = colors[positionIndex - 1];
      span.innerText = positionIndex;
    }
  });
};
window.objectToKeyValueArray = function (object) {
  var prop1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'key';
  var prop2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'value';
  if (_typeof(object) === 'object' && object !== null) {
    return Object.entries(object).map(function (_ref3) {
      var _ref5;
      var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        value = _ref4[1];
      return _ref5 = {}, _defineProperty(_ref5, prop1, key), _defineProperty(_ref5, prop2, value), _ref5;
    });
  } else {
    return [];
  }
};
window.openAIAssistant = function () {
  YAHOO.fcom.Broadcaster.sendMessage('.aiAssistant', {
    isAiAssistantOpen: true
  });
};

},{"./util/freezeTableHeaderHelper.es6.js":10,"./util/pageVisibilityEventHelper.es6.js":11,"aria":1,"menu":6,"modules/DynamicWorldmapModule/countryIsoConverter":8}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = require("lodash");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * @class       : LocalizedMenu
                                                                                                                                                                                                                                                                                                                                                                                               * @description : To customize the menu localization
                                                                                                                                                                                                                                                                                                                                                                                               *              : Convert the menu into flag image based menu style
                                                                                                                                                                                                                                                                                                                                                                                               * @dependencies: Jquery
                                                                                                                                                                                                                                                                                                                                                                                               * @references  : NGPII-20764, NGPII-20953
                                                                                                                                                                                                                                                                                                                                                                                               * @singleton
                                                                                                                                                                                                                                                                                                                                                                                               */
var LocalizedMenu = /*#__PURE__*/function () {
  function LocalizedMenu() {
    _classCallCheck(this, LocalizedMenu);
  }
  _createClass(LocalizedMenu, [{
    key: "$countryMenuItems",
    get: function get() {
      return $('[data-country-code]');
    }
  }, {
    key: "$spacerElements",
    get: function get() {
      return $('.menuItem.country-menu.spacer');
    }
  }, {
    key: "$thirdMenu",
    get: function get() {
      return $('.menus .thirdMenu');
    }
  }, {
    key: "$isDirectionRTL",
    get: function get() {
      return $('html').hasClass('RTL-Switch');
    }

    /**
     * @method init
     * @description Initialize the country menu localization
     * @public
     */
  }, {
    key: "init",
    value: function init() {
      var _this = this;
      if (this.$countryMenuItems.length > 0) {
        this._convert();
        $(window).on('resize', (0, _lodash.debounce)(function () {
          // #. Remove all existing spacer elements
          _this.$spacerElements.remove();
          // #. Rearrange the menu again
          _this._convert();
        }, 150));
      }
    }

    /**
     * @method _convert
     * @description Convert the menu styles
     * @private
     */
  }, {
    key: "_convert",
    value: function _convert() {
      var $menuItems = this.$countryMenuItems;
      var maxExpectedWidth = this._getMaxExpectedMenuWidth();
      var menuContainerWidth = $menuItems.closest('.menus').width();
      // #. Remove space class from third menu
      this.$thirdMenu.removeClass('has-spacer');
      // #. Iterate all country menu items
      // #. Insert the country flag inside
      // #. Hide the country name text
      var _iterator = _createForOfIteratorHelper($menuItems),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var $menuItem = _step.value;
          $menuItem = $($menuItem);
          $menuItem.addClass('country-menu');
          // #. Get attr info
          var countryCode = $menuItem.attr('data-country-code');
          var countryName = $menuItem.text();
          var $link = $menuItem.find('a');
          // #. Append the country flag & name spans
          // #. Clear the existing country text from link
          $link.text('').addClass('country-menu-link').append(this._getCountryFlag(countryCode)).append(this._getCountryName(countryName));

          // #. Add a menu spacer
          this._addMenuSpacer($link, menuContainerWidth, maxExpectedWidth);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    /**
     * @method _getCountryFlag
     * @description Create the country flag span
     * @private
     */
  }, {
    key: "_getCountryFlag",
    value: function _getCountryFlag(countryCode) {
      var $span = $('<span></span>');
      $span.addClass("country ".concat(countryCode));
      return $span;
    }

    /**
     * @method _getCountryName
     * @description Create the country name span
     * @private
     */
  }, {
    key: "_getCountryName",
    value: function _getCountryName(countryName) {
      var $span = $('<span></span>');
      $span.attr('tabindex', -1).addClass('country-name').text(countryName);
      return $span;
    }

    /**
     * @method _getCountryFlag
     * @description Create the country flag span
     * @private
     */
  }, {
    key: "_getMaxExpectedMenuWidth",
    value: function _getMaxExpectedMenuWidth() {
      var menuNames = this.$countryMenuItems.text().replace(/\n/g, '@').split('@').filter(function (text) {
        return text && text.length > 0;
      });
      var $menuContainer = this.$countryMenuItems.closest('.menu');
      var maxWidthItems = [];
      for (var i = 0; i < menuNames.length; i++) {
        var expectedWidth = window.YAHOO.fcom.Util.calculateTextWidth(menuNames[i], $menuContainer.css('font'));
        maxWidthItems.push(expectedWidth);
      }
      return Math.max.apply(Math, maxWidthItems);
    }

    /**
     * @method _addMenuSpacer
     * @description Add a menu spacer element
     * @private
     */
  }, {
    key: "_addMenuSpacer",
    value: function _addMenuSpacer($link, menuContainerWidth, maxExpectedWidth) {
      /**
       * Menu spacer is a concept an empty menu element with width 100% and height 0
       * The main purpose is to move the next menu item to next line
       */
      var linkLeftOffset = $link.offset().left;
      var linkExpectedWidth = window.YAHOO.fcom.Util.calculateTextWidth($link.text(), $link.css('font'));
      var isSpacerMenu = menuContainerWidth - linkLeftOffset < maxExpectedWidth + linkExpectedWidth;
      if (this.$isDirectionRTL) {
        isSpacerMenu = linkLeftOffset + linkExpectedWidth < maxExpectedWidth + linkExpectedWidth;
      }
      if (isSpacerMenu) {
        var $insertBefore = $link.closest('.menuItem');
        var $spacer = $('<div />').addClass('menuItem country-menu spacer').css({
          width: '100%',
          height: '0px'
        });
        $spacer.insertBefore($insertBefore);
        // #. Add a spacer class
        this.$thirdMenu.addClass('has-spacer');
      }
    }
  }]);
  return LocalizedMenu;
}();
var _default = exports.default = new LocalizedMenu();

},{"lodash":12}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _LocalizedMenu = _interopRequireDefault(require("./LocalizedMenu.inc"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// #. Export the init method
// #. Init all the menu customization
var _default = exports.default = function _default() {
  _LocalizedMenu.default.init();
};

},{"./LocalizedMenu.inc":5}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerMessages = exports.getMessage = exports.addMessage = void 0;
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/** @module messages/messageHandler */

//use an object in window as cache, in order to prevent multiple instances of the cache
window.__messagesCache = window.__messagesCache || {};
var messages = window.__messagesCache;

/**
 * adds a message object with key value pairs for translation
 * @param {Object} msg
 */
var registerMessages = exports.registerMessages = function registerMessages(msg) {
  Object.assign(messages, msg);
};

/**
 * adds a message to the global message cache for translation
 * @param {string} key
 * @param {string} value
 */
var addMessage = exports.addMessage = function addMessage(key, value) {
  messages[key] = value;
};

/**
 * translates a given key and replaces {0}..{n} with the respective replacements
 * @param {string} key
 * @param {...string} replacements
 * @returns {string}
 * @example
 * addMessage('example', 'example {0} of {1}')
 * getMessage('example', '4', 'many');
 * // --> 'example 4 of many'
 * getMessage('example', ['2', '6']);
 * // --> 'example 2 of 6'
 */
var getMessage = exports.getMessage = function getMessage(key) {
  var _ref;
  for (var _len = arguments.length, replacements = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    replacements[_key - 1] = arguments[_key];
  }
  replacements = (_ref = []).concat.apply(_ref, _toConsumableArray(replacements));
  var message = messages[key] || key.split('.').reduce(function (all, a) {
    return a;
  }, '');
  message = message.replace(/\{(\d)\}/g, function (match, id) {
    return replacements[+id] != null ? replacements[+id] : match;
  });
  return message;
};
window.registerMessages = registerMessages;
window.getMessage = getMessage;
window.addMessage = addMessage;

},{}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertCountry = exports.convertCountries = void 0;
var countryCodes = {
  AF: 'AFG',
  // Afghanistan
  AX: 'ALA',
  // Åland Islands
  AL: 'ALB',
  // Albania
  DZ: 'DZA',
  // Algeria
  AS: 'ASM',
  // American Samoa
  AD: 'AND',
  // Andorra
  AO: 'AGO',
  // Angola
  AI: 'AIA',
  // Anguilla
  AQ: 'ATA',
  // Antarctica
  AG: 'ATG',
  // Antigua and Barbuda
  AR: 'ARG',
  // Argentina
  AM: 'ARM',
  // Armenia
  AW: 'ABW',
  // Aruba
  AU: 'AUS',
  // Australia
  AT: 'AUT',
  // Austria
  AZ: 'AZE',
  // Azerbaijan
  BS: 'BHS',
  // Bahamas
  BH: 'BHR',
  // Bahrain
  BD: 'BGD',
  // Bangladesh
  BB: 'BRB',
  // Barbados
  BY: 'BLR',
  // Belarus
  BE: 'BEL',
  // Belgium
  BZ: 'BLZ',
  // Belize
  BJ: 'BEN',
  // Benin
  BM: 'BMU',
  // Bermuda
  BT: 'BTN',
  // Bhutan
  BO: 'BOL',
  // Bolivia (Plurinational State of)
  BQ: 'BES',
  // Bonaire, Sint Eustatius and Saba
  BA: 'BIH',
  // Bosnia and Herzegovina
  BW: 'BWA',
  // Botswana
  BV: 'BVT',
  // Bouvet Island
  BR: 'BRA',
  // Brazil
  IO: 'IOT',
  // British Indian Ocean Territory
  BN: 'BRN',
  // Brunei Darussalam
  BG: 'BGR',
  // Bulgaria
  BF: 'BFA',
  // Burkina Faso
  BI: 'BDI',
  // Burundi
  CV: 'CPV',
  // Cabo Verde
  KH: 'KHM',
  // Cambodia
  CM: 'CMR',
  // Cameroon
  CA: 'CAN',
  // Canada
  KY: 'CYM',
  // Cayman Islands
  CF: 'CAF',
  // Central African Republic
  TD: 'TCD',
  // Chad
  CL: 'CHL',
  // Chile
  CN: 'CHN',
  // China
  CX: 'CXR',
  // Christmas Island
  CC: 'CCK',
  // Cocos (Keeling) Islands
  CO: 'COL',
  // Colombia
  KM: 'COM',
  // Comoros
  CG: 'COG',
  // Congo
  CD: 'COD',
  // Congo (Democratic Republic of the)
  CK: 'COK',
  // Cook Islands
  CR: 'CRI',
  // Costa Rica
  CI: 'CIV',
  // Côte d'Ivoire
  HR: 'HRV',
  // Croatia
  CU: 'CUB',
  // Cuba
  CW: 'CUW',
  // Curaçao
  CY: 'CYP',
  // Cyprus
  CZ: 'CZE',
  // Czechia
  DK: 'DNK',
  // Denmark
  DJ: 'DJI',
  // Djibouti
  DM: 'DMA',
  // Dominica
  DO: 'DOM',
  // Dominican Republic
  EC: 'ECU',
  // Ecuador
  EG: 'EGY',
  // Egypt
  SV: 'SLV',
  // El Salvador
  GQ: 'GNQ',
  // Equatorial Guinea
  ER: 'ERI',
  // Eritrea
  EE: 'EST',
  // Estonia
  ET: 'ETH',
  // Ethiopia
  FK: 'FLK',
  // Falkland Islands (Malvinas)
  FO: 'FRO',
  // Faroe Islands
  FJ: 'FJI',
  // Fiji
  FI: 'FIN',
  // Finland
  FR: 'FRA',
  // France
  GF: 'GUF',
  // French Guiana
  PF: 'PYF',
  // French Polynesia
  TF: 'ATF',
  // French Southern Territories
  GA: 'GAB',
  // Gabon
  GM: 'GMB',
  // Gambia
  GE: 'GEO',
  // Georgia
  DE: 'DEU',
  // Germany
  GH: 'GHA',
  // Ghana
  GI: 'GIB',
  // Gibraltar
  GR: 'GRC',
  // Greece
  GL: 'GRL',
  // Greenland
  GD: 'GRD',
  // Grenada
  GP: 'GLP',
  // Guadeloupe
  GU: 'GUM',
  // Guam
  GT: 'GTM',
  // Guatemala
  GG: 'GGY',
  // Guernsey
  GN: 'GIN',
  // Guinea
  GW: 'GNB',
  // Guinea-Bissau
  GY: 'GUY',
  // Guyana
  HT: 'HTI',
  // Haiti
  HM: 'HMD',
  // Heard Island and McDonald Islands
  VA: 'VAT',
  // Holy See
  HN: 'HND',
  // Honduras
  HK: 'HKG',
  // Hong Kong
  HU: 'HUN',
  // Hungary
  IS: 'ISL',
  // Iceland
  IN: 'IND',
  // India
  ID: 'IDN',
  // Indonesia
  IR: 'IRN',
  // Iran (Islamic Republic of)
  IQ: 'IRQ',
  // Iraq
  IE: 'IRL',
  // Ireland
  IM: 'IMN',
  // Isle of Man
  IL: 'ISR',
  // Israel
  IT: 'ITA',
  // Italy
  JM: 'JAM',
  // Jamaica
  JP: 'JPN',
  // Japan
  JE: 'JEY',
  // Jersey
  JO: 'JOR',
  // Jordan
  KZ: 'KAZ',
  // Kazakhstan
  KE: 'KEN',
  // Kenya
  KI: 'KIR',
  // Kiribati
  KP: 'PRK',
  // Korea (Democratic People's Republic of)
  KR: 'KOR',
  // Korea (Republic of)
  XK: 'RKS',
  // Kosovo (Republic of)
  KW: 'KWT',
  // Kuwait
  KG: 'KGZ',
  // Kyrgyzstan
  LA: 'LAO',
  // Lao People's Democratic Republic
  LV: 'LVA',
  // Latvia
  LB: 'LBN',
  // Lebanon
  LS: 'LSO',
  // Lesotho
  LR: 'LBR',
  // Liberia
  LY: 'LBY',
  // Libya
  LI: 'LIE',
  // Liechtenstein
  LT: 'LTU',
  // Lithuania
  LU: 'LUX',
  // Luxembourg
  MO: 'MAC',
  // Macao
  MK: 'MKD',
  // Macedonia (the former Yugoslav Republic of)
  MG: 'MDG',
  // Madagascar
  MW: 'MWI',
  // Malawi
  MY: 'MYS',
  // Malaysia
  MV: 'MDV',
  // Maldives
  ML: 'MLI',
  // Mali
  MT: 'MLT',
  // Malta
  MH: 'MHL',
  // Marshall Islands
  MQ: 'MTQ',
  // Martinique
  MR: 'MRT',
  // Mauritania
  MU: 'MUS',
  // Mauritius
  YT: 'MYT',
  // Mayotte
  MX: 'MEX',
  // Mexico
  FM: 'FSM',
  // Micronesia (Federated States of)
  MD: 'MDA',
  // Moldova (Republic of)
  MC: 'MCO',
  // Monaco
  MN: 'MNG',
  // Mongolia
  ME: 'MNE',
  // Montenegro
  MS: 'MSR',
  // Montserrat
  MA: 'MAR',
  // Morocco
  MZ: 'MOZ',
  // Mozambique
  MM: 'MMR',
  // Myanmar
  NA: 'NAM',
  // Namibia
  NR: 'NRU',
  // Nauru
  NP: 'NPL',
  // Nepal
  NL: 'NLD',
  // Netherlands
  NC: 'NCL',
  // New Caledonia
  NZ: 'NZL',
  // New Zealand
  NI: 'NIC',
  // Nicaragua
  NE: 'NER',
  // Niger
  NG: 'NGA',
  // Nigeria
  NU: 'NIU',
  // Niue
  NF: 'NFK',
  // Norfolk Island
  MP: 'MNP',
  // Northern Mariana Islands
  NO: 'NOR',
  // Norway
  OM: 'OMN',
  // Oman
  PK: 'PAK',
  // Pakistan
  PW: 'PLW',
  // Palau
  PS: 'PSE',
  // Palestine, State of
  PA: 'PAN',
  // Panama
  PG: 'PNG',
  // Papua New Guinea
  PY: 'PRY',
  // Paraguay
  PE: 'PER',
  // Peru
  PH: 'PHL',
  // Philippines
  PN: 'PCN',
  // Pitcairn
  PL: 'POL',
  // Poland
  PT: 'PRT',
  // Portugal
  PR: 'PRI',
  // Puerto Rico
  QA: 'QAT',
  // Qatar
  RE: 'REU',
  // Réunion
  RO: 'ROU',
  // Romania
  RU: 'RUS',
  // Russian Federation
  RW: 'RWA',
  // Rwanda
  BL: 'BLM',
  // Saint Barthélemy
  SH: 'SHN',
  // Saint Helena, Ascension and Tristan da Cunha
  KN: 'KNA',
  // Saint Kitts and Nevis
  LC: 'LCA',
  // Saint Lucia
  MF: 'MAF',
  // Saint Martin (French part)
  PM: 'SPM',
  // Saint Pierre and Miquelon
  VC: 'VCT',
  // Saint Vincent and the Grenadines
  WS: 'WSM',
  // Samoa
  SM: 'SMR',
  // San Marino
  ST: 'STP',
  // Sao Tome and Principe
  SA: 'SAU',
  // Saudi Arabia
  SN: 'SEN',
  // Senegal
  RS: 'SRB',
  // Serbia
  SC: 'SYC',
  // Seychelles
  SL: 'SLE',
  // Sierra Leone
  SG: 'SGP',
  // Singapore
  SX: 'SXM',
  // Sint Maarten (Dutch part)
  SK: 'SVK',
  // Slovakia
  SI: 'SVN',
  // Slovenia
  SB: 'SLB',
  // Solomon Islands
  SO: 'SOM',
  // Somalia
  ZA: 'ZAF',
  // South Africa
  GS: 'SGS',
  // South Georgia and the South Sandwich Islands
  SS: 'SSD',
  // South Sudan
  ES: 'ESP',
  // Spain
  LK: 'LKA',
  // Sri Lanka
  SD: 'SDN',
  // Sudan
  SR: 'SUR',
  // Suriname
  SJ: 'SJM',
  // Svalbard and Jan Mayen
  SZ: 'SWZ',
  // Swaziland
  SE: 'SWE',
  // Sweden
  CH: 'CHE',
  // Switzerland
  SY: 'SYR',
  // Syrian Arab Republic
  TW: 'TWN',
  // Taiwan, Province of China[a]
  TJ: 'TJK',
  // Tajikistan
  TZ: 'TZA',
  // Tanzania, United Republic of
  TH: 'THA',
  // Thailand
  TL: 'TLS',
  // Timor-Leste
  TG: 'TGO',
  // Togo
  TK: 'TKL',
  // Tokelau
  TO: 'TON',
  // Tonga
  TT: 'TTO',
  // Trinidad and Tobago
  TN: 'TUN',
  // Tunisia
  TR: 'TUR',
  // Turkey
  TM: 'TKM',
  // Turkmenistan
  TC: 'TCA',
  // Turks and Caicos Islands
  TV: 'TUV',
  // Tuvalu
  UG: 'UGA',
  // Uganda
  UA: 'UKR',
  // Ukraine
  AE: 'ARE',
  // United Arab Emirates
  GB: 'GBR',
  // United Kingdom of Great Britain and Northern Ireland
  US: 'USA',
  // United States of America
  UM: 'UMI',
  // United States Minor Outlying Islands
  UY: 'URY',
  // Uruguay
  UZ: 'UZB',
  // Uzbekistan
  VU: 'VUT',
  // Vanuatu
  VE: 'VEN',
  // Venezuela (Bolivarian Republic of)
  VN: 'VNM',
  // Viet Nam
  VG: 'VGB',
  // Virgin Islands (British)
  VI: 'VIR',
  // Virgin Islands (U.S.)
  WF: 'WLF',
  // Wallis and Futuna
  EH: 'ESH',
  // Western Sahara
  YE: 'YEM',
  // Yemen
  ZM: 'ZMB',
  // Zambia
  ZW: 'ZWE' // Zimbabwe
};

// Fill the countryCodes map with reverse data as well
Object.keys(countryCodes).forEach(function (countryCode) {
  return countryCodes[countryCodes[countryCode]] = countryCode;
});
var convertCountry = exports.convertCountry = function convertCountry(country) {
  return countryCodes[country] || null;
};
var convertCountries = exports.convertCountries = function convertCountries(countries) {
  return countries.map(convertCountry);
};

},{}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var KEYCODE = {
  ENTER: 13,
  SPACE: 32,
  ESCAPE: 27,
  ARROW_LEFT: 37,
  ARROW_UP: 38,
  ARROW_RIGHT: 39,
  ARROW_DOWN: 40,
  TAB: 9,
  KeyA: 65,
  KeyD: 68,
  DELETE: 46
};
var _default = exports.default = KEYCODE;

},{}],10:[function(require,module,exports){
"use strict";

/**
 * Extending jquery-freeze-table to remove the duplicate id attributes in the <tr> element.
 * While cloning a table jquery-freeze-table is not handling the row id attribute.
 * Here we remove the id attribute from the <tr> element from the cloned table.
 */
(function () {
  var interceptor = window.FreezeTable.prototype.init;
  var freezeTableInterceptor = function freezeTableInterceptor() {
    interceptor.apply(this, arguments);
    this.$headTableWrap.find('table tr').removeAttr('id');
  };
  window.FreezeTable.prototype.init = freezeTableInterceptor;
})();

},{}],11:[function(require,module,exports){
"use strict";

/**
 * Registers the 'visibilitychange' event
 */
(function () {
  var pageVisibilityChangedTimer;
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      // Active -> Background
      // Added a delay of 60000ms (1 min) to prevent the reloading of modules in frequent tab switch.
      // If the tab becomes active with in 1 min then no reload will take place
      pageVisibilityChangedTimer = window.setTimeout(function () {
        pageVisibilityChangedTimer = null;
      }, 60000);
    } else {
      // Background -> Active
      if (pageVisibilityChangedTimer) {
        window.clearTimeout(pageVisibilityChangedTimer);
      } else {
        window.pageVisibilityChanged.fire();
      }
    }
  });
})();

},{}],12:[function(require,module,exports){
(function (global){(function (){
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    define(function() {
      return _;
    });
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}]},{},[4]);
;
(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var axiosInstance = _axios.default.create({});
axiosInstance.interceptors.request.use(function (config) {
  config.baseURL = "".concat(window.location.origin).concat(window.ctx, "/api/v1/");
  return Promise.resolve(config);
}, function (error) {
  return Promise.reject(error);
});
var _default = exports.default = axiosInstance;

},{"axios":44}],2:[function(require,module,exports){
"use strict";

var _ngpAsyncRequest = _interopRequireDefault(require("core/Ajax/ngpAsyncRequest"));
var _ngpLoadScripts = _interopRequireDefault(require("core/Ajax/ngpLoadScripts"));
var _replaceAsync = _interopRequireDefault(require("core/Ajax/replaceAsync"));
var _appendAsync = _interopRequireDefault(require("core/Ajax/appendAsync"));
var _sendFormAsync = _interopRequireDefault(require("core/Ajax/sendFormAsync"));
var _ajaxRequest = require("core/Ajax/ajaxRequest");
var _logPageView = _interopRequireDefault(require("core/Ajax/templates/logPageView"));
var _logInstrumentUse = _interopRequireDefault(require("core/Ajax/templates/logInstrumentUse"));
var _logToServer = _interopRequireDefault(require("core/Ajax/templates/logToServer"));
var _logExecutionTime = _interopRequireDefault(require("core/Ajax/templates/logExecutionTime"));
var _removeFromLastUsedInstruments = _interopRequireDefault(require("core/Ajax/templates/removeFromLastUsedInstruments"));
var _handleChangeStyleProfile = _interopRequireDefault(require("core/Ajax/templates/handleChangeStyleProfile"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// templates:

// register these functions in global namespace for convenience
window.ngpAsyncRequest = _ngpAsyncRequest.default;
window.ngpLoadScripts = _ngpLoadScripts.default;
window.replaceAsync = _replaceAsync.default;
window.appendAsync = _appendAsync.default;
window.sendFormAsync = _sendFormAsync.default;
window.ajaxGet = _ajaxRequest.ajaxGet;
window.ajaxGetJson = _ajaxRequest.ajaxGetJson;
window.ajaxPost = _ajaxRequest.ajaxPost;
window.ajaxPostJson = _ajaxRequest.ajaxPostJson;

// register templates:
window.logPageView = _logPageView.default;
window.logInstrumentUse = _logInstrumentUse.default;
window.logToServer = _logToServer.default;
window.logExecutionTime = _logExecutionTime.default;
window.removeFromLastUsedInstruments = _removeFromLastUsedInstruments.default;
window.handleChangeStyleProfile = _handleChangeStyleProfile.default;

},{"core/Ajax/ajaxRequest":3,"core/Ajax/appendAsync":4,"core/Ajax/ngpAsyncRequest":5,"core/Ajax/ngpLoadScripts":6,"core/Ajax/replaceAsync":8,"core/Ajax/sendFormAsync":9,"core/Ajax/templates/handleChangeStyleProfile":10,"core/Ajax/templates/logExecutionTime":11,"core/Ajax/templates/logInstrumentUse":12,"core/Ajax/templates/logPageView":13,"core/Ajax/templates/logToServer":14,"core/Ajax/templates/removeFromLastUsedInstruments":15}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ajaxPostJson = exports.ajaxPost = exports.ajaxGetJson = exports.ajaxGet = void 0;
var _objectToPostdata = _interopRequireDefault(require("core/Ajax/objectToPostdata"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/** @module core/Ajax/ajaxRequest */

/**
 * ajaxRequest is a wrapper for window.fetch that encapsulates all its functionality
 * @private
 * @param {String} method
 * @param {String} url
 * @param {String} [format] data format expected, this can be one of:
 * <ul>
 *  <li>text (default)</li>
 *  <li>json</li>
 *  <li>blob</li>
 *  <li>arrayBuffer</li>
 *  <li>formData</li>
 * </ul>
 * @param {Object} [data] key value object to be sent as post data or appended to url as get parameters
 * @param {Object} [headers] key value object containing request headers to be sent
 * @return {Promise.<any>}
 */
var ajaxRequest = function ajaxRequest(method, url, format, data, headers) {
  format = format || 'text';
  headers = headers || null;
  var fetchOptions = {
    method: method,
    headers: headers,
    credentials: 'same-origin'
  };
  var params = '';
  if (typeof data === 'string') {
    params = data;
  } else {
    params = (0, _objectToPostdata.default)(data);
  }
  if (method === 'GET') {
    if (params) {
      url += (url.indexOf('?') > -1 ? '&' : '?') + params;
    }
  } else {
    fetchOptions.body = params || null;
  }
  if (url.indexOf('/') === 0) {
    url = window.ctx + url;
  }
  return window.fetch(url, fetchOptions).then(function (response) {
    if (response.ok) {
      return response[format]();
    } else {
      if (!response.headers.has('applicationMessage')) {
        throw new Error("".concat(response.status, " - ").concat(response.statusText));
      } else {
        var error = new Error();
        error.code = response.status;
        error.message = response.headers.get('applicationMessage');
        throw error;
      }
    }
  });
};

/**
 * executes a GET request to the provided url and returns a promise
 * @param {String} url
 * @param {Object} [data] key value object to be appended to url as get parameters
 * @param {Object} [headers] key value object containing request headers to be sent
 * @return {Promise.<string>}
 */
var ajaxGet = exports.ajaxGet = function ajaxGet(url, data, headers) {
  return ajaxRequest('GET', url, 'text', data || {}, Object.assign({}, headers));
};

/**
 * executes a GET request to the provided url and returns a promise
 * @param {String} url
 * @param {Object} [data] key value object to be appended to url as get parameters
 * @param {Object} [headers] key value object containing request headers to be sent
 * @return {Promise.<any>}
 */
var ajaxGetJson = exports.ajaxGetJson = function ajaxGetJson(url, data, headers) {
  return ajaxRequest('GET', url, 'json', data || {}, Object.assign({}, headers));
};

/**
 * executes a POST request to the provided url and returns a promise
 * @param {String} url
 * @param {Object} [data] key value object to be sent as post data
 * @param {Object} [headers] key value object containing request headers to be sent
 * @return {Promise.<string>}
 */
var ajaxPost = exports.ajaxPost = function ajaxPost(url, data, headers) {
  return ajaxRequest('POST', url, 'text', data || {}, Object.assign({
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
  }, headers));
};

/**
 * executes a POST request to the provided url and returns a promise
 * @param {String} url
 * @param {Object} [data] key value object to be sent as post data
 * @param {Object} [headers] key value object containing request headers to be sent
 * @return {Promise.<any>}
 */
var ajaxPostJson = exports.ajaxPostJson = function ajaxPostJson(url, data, headers) {
  return ajaxRequest('POST', url, 'json', data || {}, Object.assign({
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
  }, headers));
};

},{"core/Ajax/objectToPostdata":7}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ngpAsyncRequest = _interopRequireDefault(require("core/Ajax/ngpAsyncRequest"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * same as replaceAsync but with append instead of replace
 * @param url of the code which should be appended
 * @param containerNode to append on
 * @param config <- look at replaceAsync
 * @param removeStreamingNodes wheather to remove or ceep streaming nodes.
 * @returns {*}
 */
var appendAsync = function appendAsync(url, containerNode, config, removeStreamingNodes, forceGet) {
  // create empty config object to reduce number of checks
  config = config || {};
  config.allowRedirect = config.allowRedirect || false;
  if (containerNode && window.YAHOO.lang.isString(containerNode)) {
    containerNode = window.Dom.get(containerNode);
  }
  if (config.showWait === true && !config.modallityNode) {
    config.modallityNode = false;
  }
  var method = 'POST';
  if (url.indexOf('?') > -1) {
    // when parameters are available at the end of the url, use get instead of post
    method = 'GET';
  }
  if (!forceGet && (config.form || config.postData)) {
    method = 'POST'; // send forms with post
  }

  return (0, _ngpAsyncRequest.default)(method, url, null, config.postData, config.form, config.modallityNode, config.silent, config.allowRedirect).then(function (response) {
    if (response) {
      if (response.length > 0 || config.replaceEmpty) {
        if (window.YAHOO.fcom.Streaming && removeStreamingNodes) {
          window.YAHOO.fcom.Streaming.removeStreamingNodes(containerNode);
        }
        $(containerNode).append(response);
        window.initDocument(containerNode, true, true);
      }
    }
    if (config.callback) {
      // call outer callback function when available
      config.callback({
        status: 200,
        argument: [config, containerNode]
      }); //TODO: remove the object once it is not necessary anymore
    }
  }).catch(function () {
    if (config.callback) {
      // call outer callback function when available
      config.callback({
        status: 999
      }); //TODO: remove the object once it is not necessary anymore
    }
  });
};
var _default = exports.default = appendAsync;

},{"core/Ajax/ngpAsyncRequest":5}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectToPostdata = _interopRequireDefault(require("core/Ajax/objectToPostdata"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*
 * A wrapper function for window.fetch with a similar signature to <code>YAHOO.util.Connect.asyncRequest</code>.
 * The motivation behind the function is to supply a central handler for connection timeouts, lost connections
 * or expired sessions. The callback parameter is similar to one of <code>YAHOO.util.Connect.asyncRequest</code>,
 * but it can contain additional properties that allow further customizing of the request.
 * There are default callback handlers for success and failure that will be executed before the actual
 * callback handlers. It is also possible to only specify a success callback handler and utilize the default
 * error behavior supplied by this function.
 * If the default failure handling behavior is not enough, the property forceCallback can be set to true.
 * This will call the configured failure handler after the default handler (despite the case session expired,
 * because a redirect happens there).
 * The property waitMask of the callback parameter can be set to block an element during a request.
 * If you want to run a request in the background, set the property silent to true. This will disable all
 * default error messages about timeout, connection loss and server errors.
 * Please see the paramter's doc for a detailed list of possible callback configuration properties.
 *
 * ------------------------------------------------------------------------------------------------------
 * SENDING DATA TO THE SERVER
 * ------------------------------------------------------------------------------------------------------
 * The optional parameter <code>form</code> can be supplied to submit form data.
 *
 * For passing <b>data to the server</b>, following strategies can/should be used:
 * <ol>
 *  <li>Using the method "GET" you can pass URL parameters with the request. These parameters
 *      can be single strings or arrays of strings. Simply use <code>YAHOO.fcom.Util.setURLParam</code>
 *      to add any number of params to an url. The <code>setURLParam</code> function will encode the
 *      params for transport.
 *  <li>Using the method "POST" you can supply a string of parameters in the same Syntax as URL parameters.
 *      The values however do not have to be encoded for transport manually. Post data can be supplied over
 *      the <code>postData</code> parameter and will be merged with any form data.
 *      To add an array of values to a postData string, you can use the function <code>YAHOO.fcom.Util.arrayToParam</code>.
 *  <li>In case you have to send structured data to the server, you can encode any JS Object into JSON format by
 *      calling <code>JSON.stringify</code>. This json string should be added as a parameter to postData.
 *      On serverside the json parameter string can be parsed back in Java to a <code>org.json.JSONObject</code>.
 * </ol>
 * ------------------------------------------------------------------------------------------------------
 * PARAMETERS
 * ------------------------------------------------------------------------------------------------------
 * @param {String}  method
 *  HTTP Method
 * @param {String}  uri
 *  request uri
 * @param {Function|Object} callback
 *  a callback function or an object containing the following properties:
 *      <ul>
 *          <li>{Function} success
 *                  handler executed if request was successful // TODO: document callback signature and how to find server response
 *          <li>{Function} failure
 *                  handler executed if request failed
 *          <li>{Object} scope
 *                  execution context of the handlers
 *          <li>{Object} argument
 *                  will be passed to the handlers as property of the response object
 *          <li>{Number} timeout
 *                  number of milliseconds
 *          <li>{HTMLElement|String|Boolean} waitMask (optional)
 *                  id or element that will be blocked for user interaction.
 *                  If supplied as a Boolean with the value <code>true</code> the whole document will be blocked.
 *                  If supplied as a Boolean with the value <code>false</code> the wait banner is shown, but no element will be blocked
 *          <li>{Boolean} silent (optional)
 *                  if true, there will be no default error messages, suitable for background tasks
 *          <li>{Boolean} forceCallback
 *                  if true, the supplied failure handler will always be executed after the default failure handler
 *      </ul>
 * @param {Object|String} postData either a string or a created from a map
 * @param {HTMLFormElement} form
 * @return {Object} yui transaction object
 */
var ngpAsyncRequest = function ngpAsyncRequest(method, uri, callback, postData, form, waitMask, silent) {
  var allowRedirects = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : true;
  if (!window.YAHOO.fcom.viewInfo.sessionValid) {
    // no further ajax requests, when session is invalid
    return;
  }
  if (!callback) {
    /*
        TODO: this is a temprary workaround to inject waitMask and silent via params while not using a callback.
              This needs to be properly solved by passing a config object to ngpAsyncRequest and removing the callback
              Parameter. Instead of callbacks this function already returns a promise that is far better at handling the
              Ajax behaviour.
    */
    callback = {};
    callback.waitMask = waitMask;
    callback.silent = silent;
  }

  /*
   * Default callback handlers that will be execute the original callback handlers
   */
  var defaultCallback = {
    success: function success(response) {
      if (window.YAHOO.lang.isFunction(this)) {
        this(response);
      } else {
        if (this.waitMask != null) {
          window.showWait(false, this.waitMask);
        }
        if (this.success) {
          this.success.call(this.scope, response);
        }
      }
    },
    /* Default error handling catching timeouts and connection loss */
    failure: function failure(response) {
      var message = response.responseText ? response.responseText.substring(0, 100) : response.statusText;
      window.YAHOO.log("AJAX Error - status code ".concat(response.status, ": ").concat(message), 'ajax_error', 'ngpAsyncRequest');
      //error message should not be not empty
      if (response.responseText == null || !window.YAHOO.fcom.Util.trim(response.responseText)) {
        response.responseText = window.getMessage('DEFAULT_AJAX_ERROR'); //default ajax error message
      }

      if (response.responseText.indexOf('<body') > 0) {
        //please no html body in the error message
        response.responseText = window.getMessage('DEFAULT_AJAX_ERROR'); //throw error page away and use default message
      }

      if (window.YAHOO.lang.isFunction(callback)) {
        this(response);
      } else {
        var doCallBack = this.forceCallback || false;
        if (this.waitMask != null) {
          window.showWait(false, this.waitMask);
        }
        if (response.status === 0) {
          //connection lost
          window.showWait(false);
          if (this.silent !== true) {
            window.YAHOO.lang.later(1000, this, function () {
              // delay alert to avoid alerts before fresh page loads
              if (!window.YAHOO.fcom.Page.isPageUnloaded()) {
                // only if connection not lost because of new page load
                window.ngpAlert(window.getMessage('AJAX_CONNECTION_LOST_ERROR'));
              }
            }, this);
          }
        } else if (response.status === -1) {
          //timeout
          window.showWait(false);
          if (this.silent !== true) {
            window.ngpAlert(window.getMessage('AJAX_TIMEOUT_ERROR'));
          }
        } else if (response.status === 400) {
          //no permission
          window.ngpAlert(window.getMessage('USER_UNAUTHORIZED'));
        } else if (response.status === 401) {
          //session expired
          window.sessionExpired();
        } else if (this.failure) {
          doCallBack = true;
        } else if (this.silent !== true) {
          window.ngpAlert(window.getMessage('DEFAULT_AJAX_ERROR'));
        }
        if (this.failure && doCallBack === true) {
          this.failure.call(this.scope, response);
        }
      }
    },
    scope: callback
  };

  /*
   * Apply additonal settings made in callback, timeout, argument etc.
   */
  if (!window.YAHOO.lang.isFunction(callback)) {
    window.YAHOO.lang.augmentObject(defaultCallback, callback);
  }

  /*
   * Apply default settings such as timeout
   */
  var defaultConfig = {
    timeout: window.ajaxTimeout || 120000
  };
  window.YAHOO.lang.augmentObject(defaultCallback, defaultConfig);
  if (callback.waitMask != null && callback.waitMask !== false) {
    window.showWait(true, callback.waitMask);
  }
  if (form) {
    if (!window.ngpIsType('String', postData)) {
      var formData = $(form).serializeArray().reduce(function (all, a) {
        all[a.name] = all[a.name] ? [].concat(all[a.name], a.value) : a.value;
        return all;
      }, {});
      postData = Object.assign({}, postData || {}, formData);
    } else {
      postData += (postData ? '&' : '') + $(form).serialize();
    }
  }
  if (typeof postData !== 'string') {
    postData = (0, _objectToPostdata.default)(postData);
  }
  if (method === 'GET' && postData) {
    uri += (uri.indexOf('?') > -1 ? '&' : '?') + postData;
  }
  var fetchOptions = {
    method: method,
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    }
  };
  if (method !== 'GET') {
    fetchOptions.body = postData;
  }
  if (uri.indexOf('/') === 0) {
    uri = window.ctx + uri;
  }
  //TODO: all uses of this should be refactored to use promises so this function can use ajaxRequest() (see below)
  return window.fetch(uri, fetchOptions).then(function (response) {
    if (response.redirected) {
      window.YAHOO.lang.later(500, null, function () {
        // delay next ajax call to avoid loops
        if (!window.YAHOO.fcom.Page.isPageUnloaded()) {
          // only if connection not lost because of new page load
          window.checkServer();
        }
      });
      if (!allowRedirects) {
        throw new Error('invalid redirect by server');
      }
    } else if (response.ok) {
      return response.text();
    } else {
      response.argument = defaultCallback.argument;
      response.text().then(function (responseText) {
        response.responseText = responseText;
        defaultCallback.failure(response);
      });
      throw new Error('invalid response from server');
    }
  }).then(function (content) {
    //the result object is only used for backwards compatibility
    var result = {
      textContent: content,
      responseText: content,
      argument: defaultCallback.argument,
      status: 200
    };
    defaultCallback.success(result);
    return content;
  });
};
var _default = exports.default = ngpAsyncRequest;

},{"core/Ajax/objectToPostdata":7}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * Dynamically load and insert scripts.
 * Loading scripts with the same path, will only insert the script once.
 * @function
 * @param {String[]} includesArray Array of script paths
 * @param {Function} callback Callback function will be called when all scripts are available.
 * @param {Object} [scope] Execution scope of the callback function
 */
var ngpLoadScripts = function () {
  var pending = [];
  var callbacks = [];
  var isPending = function isPending(script) {
    return window.YAHOO.fcom.Util.indexOf(script, pending) > -1;
  };
  var removePending = function removePending(scripts, pending) {
    for (var i = 0; i < scripts.length; i++) {
      var index = window.YAHOO.fcom.Util.indexOf(scripts[i], pending);
      if (index > -1) {
        pending.splice(index, 1);
      }
    }
  };
  var scrAttribute = function scrAttribute(nodes) {
    var sources = [];
    for (var i = 0; i < nodes.length; i++) {
      sources.push(nodes[i].getAttribute('src'));
    }
    return sources;
  };
  var hasNode = function hasNode(script) {
    return window.YAHOO.util.Selector.query("head script[src=".concat(script, "]")).length > 0;
  };
  var addCallback = function addCallback(callback, scope, pendingScripts) {
    callbacks.push({
      callback: callback,
      scope: scope,
      pendingScripts: pendingScripts
    });
  };
  var checkCallbacks = function checkCallbacks(scripts) {
    var i = 0;
    while (i < callbacks.length) {
      var entry = callbacks[i];
      removePending(scripts, entry.pendingScripts);
      if (!entry.pendingScripts.length) {
        var scope = null;
        if (entry.scope) {
          scope = entry.scope;
        }
        callbacks.splice(i, 1);
        entry.callback.call(scope);
      } else {
        i++;
      }
    }
  };
  return function (includesArray, callback, scope) {
    var loadScripts = [];
    var pendingScripts = [];
    for (var i = 0; i < includesArray.length; i++) {
      var script = includesArray[i];
      if (!hasNode(script)) {
        if (!isPending(script)) {
          loadScripts.push(script);
          pending.push(script);
        }
        pendingScripts.push(script);
      }
    }
    if (callback) {
      addCallback(callback, scope, pendingScripts);
    }
    window.YAHOO.util.Get.script(loadScripts, {
      onSuccess: function onSuccess(response) {
        removePending(scrAttribute(response.nodes), pending);
        checkCallbacks(scrAttribute(response.nodes));
      },
      onFailure: function onFailure() {
        window.YAHOO.log('Dynamic script import failed.');
      },
      onTimeout: function onTimeout() {
        window.YAHOO.log('Timeout for dynamic script import.');
      }
    });
  };
}();
var _default = exports.default = ngpLoadScripts;

},{}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/*
 * Create a post data string from an object by using the property names as
 * parameter names. The values will be URI encoded.
 * Returns null for any input that is not an object.
 */
var objectToPostdata = function objectToPostdata(postData) {
  return _typeof(postData) !== 'object' || postData == null ? null : Object.keys(postData).map(function (key) {
    return [].concat(itemToString(postData[key])).filter(function (f) {
      return f != null;
    }).map(function (a) {
      return "".concat(key, "=").concat(encodeURIComponent(a));
    });
  }).reduce(function (all, a) {
    return all.concat(a);
  }, []).join('&');
};
var itemToString = function itemToString(item, jsonEncodeArray) {
  if (typeof item === 'function' || item == null) {
    //invalid stuff should be ignored
    return null;
  } else if (!jsonEncodeArray && Array.isArray(item)) {
    return item.map(function (a) {
      return itemToString(a, true);
    });
  } else if (_typeof(item) === 'object') {
    if (typeof item.toString === 'function') {
      var string = item.toString();
      // if the object has an overwritten toString method
      if (string.indexOf('[object ') !== 0) {
        return string;
      }
    }
    return JSON.stringify(item);
  } else {
    return "".concat(item);
  }
};
var _default = exports.default = objectToPostdata;

},{}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ngpAsyncRequest = _interopRequireDefault(require("core/Ajax/ngpAsyncRequest"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*
 * @author Christophe Andreoli, reworked by franky generic method to replace the content of html dom
 *         nodes by asynchronous ajax calls
 * @param url: the url where to send the ajax query to
 * @param containerNode: the dom node or the id of a dom node to replace the inner html of. When
 *        config.replaceContainer is given, the container node is replaced, instead of it's inner
 *        HTML
 * @param config: An optional object with a lot of possible attributes handling optinal behavior.
 *        Known attributes contain:
 *        <ul>
 *        <li>{HTMLFormElement|String} <b>form</b><br>
 *        a form object or the id of a form object to collect
 *        request parameters from.
 *
 *        <li>{String|Object} <b>postData</b><br>
 *        post data that will be merged with the form data
 *
 *        <li>{Boolean} <b>replaceEmpty</b><br>
 *        boolean value whether also to replace inner html, even when
 *        the response is empty. Default is false
 *
 *        <li>{Function} <b>callback</b><br>
 *        function that will be called additionally after the content is
 *        replaced. The function will get the response object from the callback as only argument.
 *        With this object it can find out everything about the ajax requests. See YUI api doc for
 *        the complete list of fields of the response object. Most important fields are "status" and
 *        "responseText". When the status is not 200, the ajax did not return normally.
 *
 *        <li>{HTMLElement|String} <b>modallityNode</b><br>
 *        A node which will be blocked from access as long
 *        as the ajax request runs. Can be a dom node or the id of one. There will be an invisible
 *        div put in front of that node that will steel all mouse events and send'em to nirvana.
 *        Like this the node is blocked from user interaction. After the ajax called returned, the
 *        div is removed automatically.
 *
 *        <li>{Boolean} <b>showWait</b><br>
 *        boolean value setting whether an animated wait symbol should be
 *        shown, communicating the user that something is done in the background. default is false,
 *        not showing anything
 *        
 *        <li>{Boolean} <b>suppressPageEvents</b><br>
 *        optional boolean whether to suppress the chain of page events usually triggered after replacing
 *        DOM. e.g. some resize events are fired. This suppression makes sense if the caller already knows 
 *        that the replace is visually without impact.
 *
 *        <li>{Boolean} <b>replaceContainer</b><br>
 *        optional boolean flag which defaults to false. When given
 *        true, instead of replacing the inner HTML of the given container node, the node itself is
 *        replaced by what is found in the response.
 *        </ul>
 * @param {Boolean} removeStreamingNodes flag whether to remove streaming nodes before replacing
 *        content
 */
var replaceAsync = function replaceAsync(url, containerNode, config, removeStreamingNodes, forceGet) {
  // create empty config object to reduce number of checks
  config = config || {};
  config.allowRedirect = config.allowRedirect || false;
  if (containerNode && window.YAHOO.lang.isString(containerNode)) {
    containerNode = window.Dom.get(containerNode);
  }
  if (config.showWait === true && !config.modallityNode) {
    config.modallityNode = false;
  }
  var method = 'POST';
  if (url.indexOf('?') > -1) {
    // when parameters are available at the end of the url, use get instead of post
    method = 'GET';
  }
  if (!forceGet && (config.form || config.postData)) {
    method = 'POST'; // send forms with post
  }

  return (0, _ngpAsyncRequest.default)(method, url, null, config.postData, config.form, config.modallityNode, config.silent, config.allowRedirect).then(function (response) {
    if (response) {
      if (response.length > 0 || config.replaceEmpty) {
        if (window.YAHOO.fcom.Streaming && removeStreamingNodes) {
          window.YAHOO.fcom.Streaming.removeStreamingNodes(containerNode);
        }
        if (config.replaceContainer) {
          // do replace full container, not only inner html
          config.selectorConfig = {
            selector: '',
            apply: function apply(selector, target, node) {
              return window.YAHOO.fcom.Dom.replaceNodeByString(target, node.innerHTML);
            }
          };
        }
        window.YAHOO.fcom.Page.replace(containerNode, response, config);
      }
    }
    if (config.callback) {
      // call outer callback function when available
      config.callback({
        status: 200,
        argument: [config, containerNode]
      }); //TODO: remove the object once it is not necessary anymore
    }
  }).catch(function () {
    if (config.callback) {
      // call outer callback function when available
      config.callback({
        status: 999
      }); //TODO: remove the object once it is not necessary anymore
    }
  });
};
var _default = exports.default = replaceAsync;

},{"core/Ajax/ngpAsyncRequest":5}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ngpAsyncRequest = _interopRequireDefault(require("core/Ajax/ngpAsyncRequest"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*
 * @author Christophe Andreoli
 * generic method to send with ajax a form useful for sending data to the server side from a dialog.
 * The client can then react to errors scenarios and depending on them,  close the dialog, show an error
 * message an so on.
 *
 * @param url: the url where to send the ajax query to
 * @param config: An optional object with a lot of possible attributes handling optinal behavior. Known attributes contain:
 *        - "form": a form object or the id of a form object to collect request parameters from.
 *        - "postData": postData that will be merged with the form data
 *        - "callback": function that will be called additionally after the content is replaced. The function will get the response
 *                      object from the callback as only argument. With this object it can find out everything about the ajax requests.
 *                      See YUI api doc for the complete list of fields of the response object.
 *                      Most important fields are "status" and "responseText". When the status is not 200, the ajax
 *                      did not return normally. Callback will still be called and has to check for the status code!
 *        - "modallityNode": A node which will be blocked from access as long as the ajax request runs. Can be a dom node or the id
 *                           of one. There will be an invisible div put in front of that node that will steel all mouse events and send'em to nirvana.
 *                           Like this the node is blocked from user interaction. After the ajax called returned, the div is removed automatically.
 *        - "showWait": boolean value setting whether an animated wait symbol should be shown, communicating the user that something is done in the background.
 *                      default is false, not showing anything
 */

var sendFormAsync = function sendFormAsync(url, config) {
  if (!config || config == null) {
    config = {}; // create empty config object to reduce number of checks
  }

  var handleSuccess = function handleSuccess(o) {
    // build success handler
    // call the callBackFunction with output (error code)
    if (o.argument[0].callback) {
      // call outer callback function when available
      o.argument[0].callback(o);
    }
  };
  var handleFailure = function handleFailure(o) {
    if (o.argument[0].callback) {
      // call outer callback function when available
      o.argument[0].callback(o);
    }
  };
  if (config.showWait && config.showWait === true) {
    if (config.modallityNode == null) {
      config.modallityNode = false;
    }
  }

  // callback object to pass to the YUI conection manager
  var callback = {
    success: handleSuccess,
    failure: handleFailure,
    argument: [config],
    waitMask: config.modallityNode
  };
  var method = 'POST';
  if (url.indexOf('?') > -1) {
    // when parameters are available at the end of the url, use get instead of post
    method = 'GET';
  }
  if (config.form || config.postData) {
    // set form to the connect
    method = 'POST'; // send forms with post
  }

  (0, _ngpAsyncRequest.default)(method, url, callback, config.postData, config.form);
};
var _default = exports.default = sendFormAsync;

},{"core/Ajax/ngpAsyncRequest":5}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ajaxRequest = require("core/Ajax/ajaxRequest");
var _default = exports.default = function _default(theme) {
  return (0, _ajaxRequest.ajaxGet)("/ajax.action?method=handleChangeStyleProfile&theme=".concat(theme));
};

},{"core/Ajax/ajaxRequest":3}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ajaxRequest = require("core/Ajax/ajaxRequest");
var _getFps = _interopRequireDefault(require("util/functions/getFps"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = exports.default = function _default(logEventType, executionTime, detailedLogText) {
  executionTime = parseInt(executionTime || 0);
  var url = '/ajax.action?method=logFrontendExecutionTimeToLogFile';
  try {
    (0, _getFps.default)().then(function (fps) {
      (0, _ajaxRequest.ajaxPost)(url, {
        logText: detailedLogText,
        logType: logEventType,
        fps: fps,
        executionTime: executionTime
      });
    });
  } catch (e) {
    console.warn("Failed to log FrontendExecutionTime: ".concat(e));
  }
};

},{"core/Ajax/ajaxRequest":3,"util/functions/getFps":43}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ajaxRequest = require("core/Ajax/ajaxRequest");
var _default = exports.default = function _default(ric, name) {
  (0, _ajaxRequest.ajaxGet)("/ajax.action?method=logInstrumentUse&ric=".concat(ric, "&name=").concat(name));
  // Matomo Tracking Code: Add new module
  if (window._paq) {
    window._paq.push(['trackEvent', 'Instrument', 'Use', ric]);
  }
};

},{"core/Ajax/ajaxRequest":3}],13:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ajaxRequest = require("core/Ajax/ajaxRequest");
var _default = exports.default = function _default() {
  return (0, _ajaxRequest.ajaxGet)('/ajax.action?method=logPageView');
};

},{"core/Ajax/ajaxRequest":3}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ajaxRequest = require("core/Ajax/ajaxRequest");
var _default = exports.default = function _default(logText) {
  var url = '/ajax.action?method=logJsConsoleToJsLogFile';
  (0, _ajaxRequest.ajaxPost)(url, {
    logText: logText
  });
};

},{"core/Ajax/ajaxRequest":3}],15:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ajaxRequest = require("core/Ajax/ajaxRequest");
var _default = exports.default = function _default(ric) {
  return (0, _ajaxRequest.ajaxGet)("/ajax.action?method=removeFromLastUsedInstruments&ric=".concat(ric));
};

},{"core/Ajax/ajaxRequest":3}],16:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/** @module core/Base64 */

/**
 * custom base64 map beeing used:<br/>
 * <code>ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-§_</code>
 * @private
 */
var BASE64_MAP = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-\xA7_";

/**
 * base 64 decoder. It uses some other characters than the official RFC variant
 * @param {string} data
 * @returns {string}
 */
var decodeBase64 = function decodeBase64(data) {
  var byte1;
  var byte2;
  var byte3;
  var ch1;
  var ch2;
  var ch3;
  var ch4;
  var result = []; //array is used instead of string because in most of browsers working with large arrays is faster than working with large strings
  var j = 0;
  while (data.length % 4 !== 0) {
    data += BASE64_MAP.charAt(64);
  }
  for (var i = 0; i < data.length; i += 4) {
    ch1 = BASE64_MAP.indexOf(data.charAt(i));
    ch2 = BASE64_MAP.indexOf(data.charAt(i + 1));
    ch3 = BASE64_MAP.indexOf(data.charAt(i + 2));
    ch4 = BASE64_MAP.indexOf(data.charAt(i + 3));
    byte1 = ch1 << 2 | ch2 >> 4;
    byte2 = (ch2 & 15) << 4 | ch3 >> 2;
    byte3 = (ch3 & 3) << 6 | ch4;
    result[j++] = String.fromCharCode(byte1);
    if (ch3 !== 64) {
      result[j++] = String.fromCharCode(byte2);
    }
    if (ch4 !== 64) {
      result[j++] = String.fromCharCode(byte3);
    }
  }
  return result.join('');
};

/**
 * base 64 encoder. It uses some other characters than the official RFC variant
 * @param {string} data
 * @returns {string}
 */
var base64Encode = function base64Encode(data) {
  var byte1;
  var byte2;
  var byte3;
  var ch1;
  var ch2;
  var ch3;
  var ch4;
  var result = []; //array is used instead of string because in most of browsers working with large arrays is faster than working with large strings
  var j = 0;
  for (var i = 0; i < data.length; i += 3) {
    byte1 = data.charCodeAt(i);
    byte2 = data.charCodeAt(i + 1);
    byte3 = data.charCodeAt(i + 2);
    ch1 = byte1 >> 2;
    ch2 = (byte1 & 3) << 4 | byte2 >> 4;
    ch3 = (byte2 & 15) << 2 | byte3 >> 6;
    ch4 = byte3 & 63;
    if (isNaN(byte2)) {
      ch3 = ch4 = 64;
    } else if (isNaN(byte3)) {
      ch4 = 64;
    }
    result[j++] = BASE64_MAP.charAt(ch1) + BASE64_MAP.charAt(ch2) + BASE64_MAP.charAt(ch3) + BASE64_MAP.charAt(ch4);
  }
  return result.join('');
};
var _default = exports.default = {
  decodeBase64: decodeBase64,
  base64Encode: base64Encode
};
window.decodeBase64 = decodeBase64;
window.base64Encode = base64Encode;

},{}],17:[function(require,module,exports){
"use strict";

var _this = void 0;
window.YAHOO.fcom.Broadcaster = function () {
  var Broadcaster = {};
  var channels = {};
  var getChannelEvent = function getChannelEvent(channel) {
    channels[channel] = channels[channel] || new window.YAHOO.util.CustomEvent(channel);
    return channels[channel];
  };
  var getChannelKeys = function getChannelKeys(channel) {
    if (!channel) {
      return [];
    }
    return channel.split(',').map(function (a) {
      return a.trim();
    }).filter(function (f) {
      return f.length;
    });
  };
  Broadcaster.sendMessage = function (channel, content) {
    var channelKeys = getChannelKeys(channel);
    // eslint-disable-next-line no-console
    console.info('Broadcasting message:', {
      channels: channelKeys,
      content: content
    });
    channelKeys.forEach(function (key) {
      getChannelEvent(key).fire(content);
    });
  };
  Broadcaster.subscribe = function (channel, callback, context, overrideContext) {
    getChannelKeys(channel).forEach(function (key) {
      getChannelEvent(key).subscribe(callback, context, overrideContext);
    });
    return Broadcaster.unsubscribe.bind(_this, channel, callback, context, overrideContext);
  };
  Broadcaster.unsubscribe = function (channel, callback, context) {
    getChannelKeys(channel).forEach(function (key) {
      getChannelEvent(key).unsubscribe(callback, context);
    });
  };
  Broadcaster.initBroadcastLinks = function (channel, senderId, selector) {
    var getHrefMatch = function getHrefMatch(href) {
      var hrefExp = /.*?detail.*?[?].*?[r][i][c][=](.*?)$/g;
      return hrefExp.exec(href);
    };
    if (channel) {
      if (!selector) {
        selector = "#".concat(senderId, " a:not(.forceDetailLink)");
      }
      $(selector).each(function () {
        var _this2 = this;
        var href = $(this).attr('href');
        var hrefMatch = getHrefMatch(href);
        if (href && hrefMatch != null) {
          if ($(this).attr('data-delHrefOnChannel') === 'true') {
            $(this).removeAttr('href');
          }
          $(this).unbind('click').click(function () {
            var content = {
              messageType: 'ric',
              senderId: senderId
            };
            var metaData = $(_this2).closest('tr').data('meta');
            if (metaData && metaData.ric && metaData.ticker) {
              // to support ticker overriding, pass ticker along with ric
              // if required, ric and ticker will be available in closest tr tag
              content.ric = metaData.ric;
              content.ticker = metaData.ticker;
            } else {
              var _href = $(_this2).attr('href');
              var _hrefMatch = getHrefMatch(_href);
              content.ric = _hrefMatch[1];
            }
            window.YAHOO.fcom.Broadcaster.sendMessage(channel, content);
            window.logInstrumentUse(content.ric);
            return false; // stop event
          });
        }
      });

      $(selector).each(function () {
        var ric = $(this).attr('data-ric');
        if (ric) {
          $(this).removeAttr('onclick');
          $(this).unbind('click').click(function () {
            window.YAHOO.fcom.Broadcaster.sendMessage(channel, {
              messageType: 'ric',
              senderId: senderId,
              ric: ric
            });
            window.logInstrumentUse(ric);
            return false; // stop event
          });
        }
      });
    }
  };

  return Broadcaster;
}();

},{}],18:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * Creates a new checkbox instance.
 * @param {HTMLElement} inputEl
 *
 * @class Resembles a skinned checkbox, which has a consistent look and feel across operating systems and browsers.
 * The checkboxes have an input field and can be used in forms.
 * A checkbox is created by using the HTML markup for a checkbox input element:
 * <pre>
 *     &lt;input name="myCheckbox" type="checkbox" class="checkbox" selected="" /&gt;
 * </pre>
 * The actual instances are created by progessive enhancement on page initialization ({@link initButtons}).
 */
var Checkbox = function Checkbox(inputEl) {
  var supressDomClick = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (window.YAHOO.lang.isString(inputEl)) {
    inputEl = window.Dom.get(inputEl);
  }

  /*
   * The actual checkbox input element.
   * @type HTMLElement
   */
  this.domNode = inputEl;
  YAHOO.util.Event.addListener(this.domNode, 'change', window.YAHOO.fcom.Util.createDelegate(this.onChange, this), this, null);
  //changeAuto event is used to distinguish between user interaction and auto selection logic (e.g. select all)
  YAHOO.util.Event.addListener(this.domNode, 'changeAuto', window.YAHOO.fcom.Util.createDelegate(this.onChange, this), this, null);
  this.img = document.createElement('span');
  this.status = document.createElement('span');
  this.img.appendChild(this.status);
  inputEl.parentNode.insertBefore(this.img, inputEl);
  this.setImage();
  window.Dom.addClass(this.img, 'checkbox');
  if (supressDomClick) {
    YAHOO.util.Event.addListener(this.img, 'click', function (eventArg) {
      YAHOO.util.Event.stopEvent(eventArg); // avoid event bubbling through
    }, this, null);
  }
  var _this = this;
  YAHOO.util.Event.addListener(this.img, 'mouseup', function (eventArg, checkElem) {
    if (!_this.isDisabled()) {
      checkElem.toggle();
      if (checkElem.domNode.onclick) {
        checkElem.domNode.onclick(); // call the onclick of the real input tag
      }
    }

    YAHOO.util.Event.stopEvent(eventArg); // avoid event bubbling through
  }, this, null);
  YAHOO.util.Event.addListener(this.img, 'mouseover', function (eventArg, checkElem) {
    checkElem.replaceImage('-hover');
  }, this, null);
  YAHOO.util.Event.addListener(this.img, 'mouseout', function (eventArg, checkElem) {
    checkElem.replaceImage();
  }, this, null);
  YAHOO.util.Event.addListener(this.img, 'mousedown', function (eventArg, checkElem) {
    checkElem.replaceImage('-active');
  }, this, null);
  YAHOO.util.Event.addListener(this.img, 'mouseup', function (eventArg, checkElem) {
    checkElem.replaceImage();
  }, this, null);
};
Checkbox.prototype = {
  /*
   * Changes the backgroundimage according to the state-css-class of the checkbox.
   * @private
   * @param {Boolean} onOff
   */

  setImage: function setImage() {
    window.Dom.addClass(this.status, this.getCssClassPrefix());
  },
  replaceImage: function replaceImage(classPostFix) {
    window.Dom.setAttribute(this.status, 'class', this.getCssClassPrefix() + (classPostFix || ''));
  },
  getCssClassPrefix: function getCssClassPrefix() {
    return this.domNode.checked ? 'checked' : 'unchecked';
  },
  /*
   * Toggle the checkbox.
   * @param {Boolean} [checked] whether to check or uncheck the box
   * @param {Boolean} [silent] when true, change event will not be fired
   */
  toggle: function toggle(checked, silent) {
    if (checked == null) {
      checked = !this.domNode.checked; //use the parameter if supplied, or toggle
    }

    if (!this.isDisabled()) {
      this.domNode.checked = checked;
      this.replaceImage();
      if (silent !== true) {
        window.YAHOO.fcom.Event.fireEvent(this.domNode, 'change');
      }
    }
  },
  /*
   * Returns whether the checkbox is selected.
   * @return {Boolean}
   */
  isSelected: function isSelected() {
    return this.domNode.checked;
  },
  /*
  * Returns whether the checkbox is disabled.
  * @return {Boolean}
  */
  isDisabled: function isDisabled() {
    return $(this.domNode).is(':disabled') || $(this.domNode).hasClass('disabled');
  },
  setDisabled: function setDisabled(disabled) {
    disabled = disabled === false ? false : true;
    $(this.img).toggleClass('checkbox-disabled', disabled);
    $(this.domNode).attr('disabled', disabled ? 'disabled' : null).toggleClass('disabled', disabled);
  },
  /*
   * @private
   */
  onChange: function onChange() {
    this.replaceImage();
  },
  /*
   * Reset the checkbox.
   */
  reset: function reset() {
    this.replaceImage();
  },
  setTitle: function setTitle(title) {
    this.img.setAttribute('title', title);
  }
};
var _default = exports.default = Checkbox;
window.YAHOO.fcom.Checkbox = Checkbox;

},{}],19:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addInstrumentToComparison = exports.addInstrumentListToComparison = void 0;
var broadCastComparisonChange = function broadCastComparisonChange() {
  return window.YAHOO.fcom.Broadcaster.sendMessage('@watchlists', {
    messageType: 'watchlistChanged',
    id: 'instrument_comparison'
  });
};

/*
 * add the instrument with the given fields to the comparison list. fields is an object with attributes to describe the instruments, like ric and isin.
 */
var addInstrumentToComparison = exports.addInstrumentToComparison = function addInstrumentToComparison(fields, callback) {
  var url = '/comparison.action?method=addInstrumentToComparison';
  callback = callback || {
    success: function success(response) {
      window.ngpAlert(response.responseText, {
        fixedcenter: true
      });
    },
    failure: function failure(response) {
      window.ngpAlert(response.responseText, {
        fixedcenter: true
      });
    },
    waitMask: true
  };
  window.ngpAsyncRequest('POST', url, callback, fields).then(broadCastComparisonChange);
};

/*
 * @see addInstrumentToComparison
 * @param {Array} fields
 * @param {Object} callback
 */
var addInstrumentListToComparison = exports.addInstrumentListToComparison = function addInstrumentListToComparison(fields, callback) {
  var url = '/comparison.action?method=addInstrumentListToComparison&clearList=true';
  var json = JSON.stringify(fields);
  window.ngpAsyncRequest('POST', url, callback, "json=".concat(json)).then(broadCastComparisonChange);
};
window.addInstrumentToComparison = addInstrumentToComparison;
window.addInstrumentListToComparison = addInstrumentListToComparison;

},{}],20:[function(require,module,exports){
"use strict";

/* eslint-disable no-console */

/**
 * Console namespace for logging that extends and modifies some of the default window.console behaviours<br/>
 * You can choose which {@link console.LOGLEVEL|Loglevel} is to be used by adding the <code>jsdebuglevel</code> parameter
 * to the url or using <code>jsdebug</code> mode. Everything below that level won't appear on the console.
 * @namespace console
 */

// IE9 console fix
window.console = window.console || {};
console.log = console.log || function () {};

/**
 * @enum {number}
 * @protected
 * @memberof console
 */
var LOGLEVEL = {
  /** <code>jsdebuglevel=debug</code> */
  DEBUG: 0,
  /** <code>jsdebuglevel=log</code> (default for <code>jsdebug=true</code>) */
  LOG: 1,
  /** <code>jsdebuglevel=info</code> */
  INFO: 2,
  /** <code>jsdebuglevel=warn</code> */
  WARN: 3,
  /** <code>jsdebuglevel=error</code> */
  ERROR: 4,
  /** <code>jsdebuglevel=none</code> (default for <code>jsdebug=false</code>) */
  NONE: 5
};
var SYMBOL = {
  DEBUG: '🔧',
  // wrench emoji
  LOG: '📝',
  // text memo emoji
  WARN: '⚠️️',
  // yellow ! emoji
  INFO: 'ℹ️',
  // blue i emoji
  ERROR: '❌' // red x emoji
};

var logLevelNames = {
  none: LOGLEVEL.NONE,
  debug: LOGLEVEL.DEBUG,
  log: LOGLEVEL.LOG,
  info: LOGLEVEL.INFO,
  warn: LOGLEVEL.WARN,
  error: LOGLEVEL.ERROR
};
var currentLogLevel = function () {
  var logLevelName = window.jsdebug ? 'log' : 'none';
  var urlLogLevel = null;
  try {
    urlLogLevel = window.location.href.split('?')[1].split('#')[0].split('&').map(function (a) {
      return a.split('=');
    }).find(function (f) {
      return f[0] === 'jsdebuglevel';
    })[1];
  } catch (e) {
    // do nothing - no jsdebuglevel was set
  }
  return logLevelNames[urlLogLevel || logLevelName];
}();
var isLogLevel = function isLogLevel(targetLevel) {
  return currentLogLevel <= targetLevel;
};
var logPrefixed = function logPrefixed(prefix) {
  try {
    return console.log.bind(window.console, prefix);
  } catch (e) {
    // IE9 fix, where console.log.bind won't work due to the native function not having a bind function
    return console.log;
  }
};
var doNothing = function doNothing() {};

/**
 * Log to the console with debug level {@link console.LOGLEVEL|DEBUG}
 * @function
 * @param {...*} itemsToBeLogged
 */
console.debug = isLogLevel(LOGLEVEL.DEBUG) ? logPrefixed(SYMBOL.DEBUG) : doNothing;
/**
 * Log to the console with debug level {@link console.LOGLEVEL|INFO}
 * @function
 * @param {...*} itemsToBeLogged
 */
console.info = isLogLevel(LOGLEVEL.INFO) ? console.info || logPrefixed(SYMBOL.INFO) : doNothing;
/**
 * Log to the console with debug level {@link console.LOGLEVEL|INFO}<br/>
 * The output will be formatted as a table if the browser supports that feature (will fall back to normal logging)
 * @function
 * @param {...*} itemsToBeLogged
 */
console.table = isLogLevel(LOGLEVEL.INFO) ? console.table || console.info : doNothing;
/**
 * Log to the console with debug level {@link console.LOGLEVEL|WARN}
 * @function
 * @param {...*} itemsToBeLogged
 */
console.warn = isLogLevel(LOGLEVEL.WARN) ? console.warn || logPrefixed(SYMBOL.WARN) : doNothing;
/**
 * Log to the console with debug level {@link console.LOGLEVEL|ERROR}
 * @function
 * @param {...*} itemsToBeLogged
 */
console.error = isLogLevel(LOGLEVEL.ERROR) ? console.error || logPrefixed(SYMBOL.ERROR) : doNothing;
window.YAHOO.log = isLogLevel(LOGLEVEL.INFO) ? logPrefixed('💩') : doNothing;
/**
 * Log to the console with debug level {@link console.LOGLEVEL|LOG}
 * @function
 * @param {...*} itemsToBeLogged
 */
console.log = isLogLevel(LOGLEVEL.LOG) ? logPrefixed(SYMBOL.LOG) : doNothing; // do this one last to prevent multiple prefixes

/**
 * Start a output group on the console that will be expanded by default (use {@link console.groupEnd} to end the group) <br/>
 * Requires debug level {@link console.LOGLEVEL|LOG} to work
 * @function
 * @param {string} groupName
 */
console.group = isLogLevel(LOGLEVEL.LOG) ? console.group || logPrefixed('<=====') : doNothing;

/**
 * Start a output group on the console that will be collapsed by default (use {@link console.groupEnd} to end the group) <br/>
 * Requires debug level {@link console.LOGLEVEL|LOG} to work
 * @function
 * @param {string} groupName
 */
console.groupCollapsed = isLogLevel(LOGLEVEL.LOG) ? console.groupCollapsed || logPrefixed('<=====') : doNothing;

/**
 * End the most recent output group on the console
 * @function
 */
console.groupEnd = isLogLevel(LOGLEVEL.LOG) ? console.groupEnd || logPrefixed('=====>') : doNothing;

},{}],21:[function(require,module,exports){
"use strict";

require("core/Console");
require("core/Globals");
require("core/Ajax");
require("core/redirect");
require("core/Base64");
require("core/Broadcaster");
require("core/Checkbox");
require("core/Comparison");
require("core/Dialogs");
require("core/Dom");
require("core/ErrorMessage");
require("core/Forms");
require("core/Initialization");
require("core/LargeTable");
require("core/ModuleConfig");
require("core/Modules");
require("core/NewsQuickviewFormatter");
require("core/OverlayGroupManager");
require("core/Overlays");
require("core/PageSettings");
require("core/Panel");
require("core/Radio");
require("core/ShowWait");
require("core/Tabs");
require("core/Ticker");
require("core/Widgets");
require("core/ToggleSwitch");

},{"core/Ajax":2,"core/Base64":16,"core/Broadcaster":17,"core/Checkbox":18,"core/Comparison":19,"core/Console":20,"core/Dialogs":22,"core/Dom":23,"core/ErrorMessage":24,"core/Forms":25,"core/Globals":26,"core/Initialization":27,"core/LargeTable":28,"core/ModuleConfig":29,"core/Modules":30,"core/NewsQuickviewFormatter":31,"core/OverlayGroupManager":32,"core/Overlays":33,"core/PageSettings":34,"core/Panel":35,"core/Radio":36,"core/ShowWait":37,"core/Tabs":38,"core/Ticker":39,"core/ToggleSwitch":40,"core/Widgets":41,"core/redirect":42}],22:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showUserSettings = exports.showReutersLink = exports.ngpConfirm = exports.ngpAlert = void 0;
var YAHOO = window.YAHOO;
var Dom = window.Dom;

/*
 * this function opens a panel similar to the ngpAlert panel, but in this case the alert expects the user to say yes or no.
 * The function can not block like the native javascript confirm, so it is not returning boolean, but expects a handler for
 * the yes and the no case. See config attributes for more informations. If message is given null,
 * a default message like "are you sure" will be shown.
 * @param message the message to be shown in the panel. Take care that the question fits to the button texts. If given
 *        null, a default message like "are you sure" is used.
 * @param config configuration attributes for the panel. Every given attribute will be forwarded to the panel used, so have
 *        a look at the YUI api documentation for available configuration possibilities. Some additional configuration
 *        attributes are understood by the ngpConfirm:
 *        - okButtonText: a string that will be shown on the ok button. (optional)
 *        - cancelButtonText: a string that will be shown on the cancel button. (optional)
 *        - okHandler: a function that will be called when the user hits the ok button (optional)
 *        - cancelHandler: a function that will be called when the user hits the cancel button (optional)
 *        - handlerArgument: an argument that will be given to the okHandler or the cancelHandler when they get called (optional).
 *          use an array, when there is the need of several arguments, or the okHandler needs other arguments than the cancelHandler
 *        - title: a string that will be used as the title instead of the default title. (optional)
 */
var ngpConfirm = exports.ngpConfirm = function ngpConfirm(message, config) {
  config = config || {};
  config.message = message;
  YAHOO.fcom.panel.PanelFactory.openConfirmPanel(config);
};

/*
 * do a nice alert using a modal html box instead of the ugly javascript alerts with all there problems.
 * The default behavior is opening a modal panel with a "error message" header and the given message in the panel.
 * @param message a plain text or html message to be added on the panel
 * @param config an optinal config object with attributes to change the dfault behavior of the alert panel. Known fields are
 *        all of the known panel config attributes (see YAHOO.widget.Panel api docu for a list of all possible attributes)
 *        In addition the attribute "title" will be read and the panel's title will be set to the given string.
 *        Another additional config attribute is "onHide", which accepts a function which will be called when the alert is hidden.
 *        in addition another field "handlerArgument" can be passed, which will then be given to the onHide function as only argument.
 */
var ngpAlert = exports.ngpAlert = function ngpAlert(message, config) {
  YAHOO.fcom.panel.PanelFactory.openAlertPanel(message, config);
};
var showReutersLink = exports.showReutersLink = function showReutersLink() {
  window.fillPanelFromAjax('reutersLinksPanelDiv', '/common/reutersLink.plain', null, {
    width: '310px',
    fixedcenter: false,
    visible: false,
    close: true,
    dragOnly: true,
    draggable: true,
    constraintoviewport: true,
    modal: true
  });
};
var showTermsConditions = function showTermsConditions() {
  window.fillPanelFromAjax('reutersLinksPanelDiv', '/customized/fgb/TermsConditions.plain', null, {
    width: '810px',
    fixedcenter: false,
    visible: false,
    x: 200,
    close: true,
    dragOnly: true,
    draggable: true,
    constraintoviewport: true,
    modal: true
  });
};
var showUserSettings = exports.showUserSettings = function showUserSettings() {
  var xPos = Math.max(5, Dom.getViewportWidth() / 2 - 500);
  var yPos = 50;
  var panelConfig = {
    id: 'personalSettingsDialog',
    requiredScripts: ['personalUserSettingsDialog.js'],
    panelNamespace: 'YAHOO.fcom.panel.PersonalUserSettingsDialog',
    url: 'usersettings.panel?method=handleShowUserSettingsDialog',
    width: '1000px',
    x: xPos,
    y: yPos,
    fixedcenter: false,
    visible: false,
    close: true,
    dragOnly: true,
    constraintoviewport: true,
    modal: true,
    refresh: true
  };
  window.showWait(true, true);
  YAHOO.fcom.panel.PanelFactory.getAJAXPanel(panelConfig, {
    fn: function fn(panel) {
      window.showWait(false);
      panel.show();
    }
  });
};
window.ngpConfirm = ngpConfirm;
window.ngpAlert = ngpAlert;
window.showReutersLink = showReutersLink;
window.showUserSettings = showUserSettings;

},{}],23:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var Dom = {
  /*
   * Returns the dimensions of an element.
   * @param {HTMLElement|String} element
   * @return {} dimension object with x, y, width and height properties
   */
  getDimensions: function getDimensions(element) {
    var region = window.Dom.getRegion(element);
    return {
      x: region.left,
      y: region.top,
      width: region.right - region.left,
      height: region.bottom - region.top
    };
  },
  /*
   * append the given appendElem behind the given behindElem.
   * If behindElem does not exist, nothing happens
   * @return the appended element
   */
  appendBehind: function appendBehind(appendElem, behindElem) {
    if (!behindElem || behindElem == null || !behindElem.parentNode || appendElem == null) {
      return appendElem;
    }
    var nextSibling = window.Dom.getNextSibling(behindElem);
    if (nextSibling == null) {
      behindElem.parentNode.appendChild(appendElem);
    } else {
      behindElem.parentNode.insertBefore(appendElem, nextSibling);
    }
    return appendElem;
  },
  /*
   * get all nodes in an array, that pass the given tests.
   * @rootNode one node to start from and return descendants from
   * @param method a function that will be called with every node and only when it returns true,
   *        the node is included in the array. Obligatory parameter.
   */
  getDescendantsBy: function getDescendantsBy(rootNode, method) {
    if (window.YAHOO.lang.isString(rootNode) === true) {
      rootNode = window.Dom.get(rootNode);
    }
    if (!rootNode || rootNode == null || !method || method == null) {
      return [];
    }
    var returnArray = [];
    window.Dom.getChildren(rootNode).forEach(function (child) {
      if (method(child)) {
        returnArray.push(child);
      }
      returnArray = returnArray.concat(window.YAHOO.fcom.Dom.getDescendantsBy(child, method));
    });
    return returnArray;
  },
  /*
   * get the first node inside the given node that pass the given tests.
   * The search is a breadth first search, so first all direct childs are worked on, then the childs of those...
   * If no node is found, null is returned.
   * @param method a function that will be called with every node that is found.
   * @param rootNode one node to start from and return descendants from
   * @param nextIteration this is an intern parameter for the breadth search recursion, it should never be passed from outside.
   */
  getFirstDescendantBy: function getFirstDescendantBy(rootNode, method, nextIteration) {
    if (!nextIteration || nextIteration == null || nextIteration.length < 1) {
      if (window.YAHOO.lang.isString(rootNode) === true) {
        rootNode = window.Dom.get(rootNode);
      }
      if (!rootNode || rootNode == null || !method || method == null) {
        return null;
      }
      nextIteration = window.Dom.getChildren(rootNode);
    }
    var collectChilds = [];
    for (var i = 0; i < nextIteration.length; i++) {
      if (method(nextIteration[i])) {
        return nextIteration[i];
      } else {
        var childs = window.Dom.getChildren(nextIteration[i]);
        if (childs && childs != null && childs.length > 0) {
          collectChilds = collectChilds.concat(childs);
        }
      }
    }
    return window.YAHOO.fcom.Dom.getFirstDescendantBy(null, method, collectChilds);
  },
  /*
   * take an existing dom node and replace it with the content of a given string, like with the
   * innerHTML, but not only inner, but also replace the tag itself.
   * @param node an existing dom node or an id of one
   * @param replaceString a string that is put into the document at the place where the node was.
   * @return {HTMLElement[]} all nodes that have been changed, this includes the replacement node and all
   * additional new nodes
   */
  replaceNodeByString: function replaceNodeByString(node, replaceString) {
    var changedNodes = [];
    var dummyDiv = document.createElement('div');
    dummyDiv.innerHTML = replaceString;
    node = window.Dom.get(node); // make sure to have the node, not it's id
    var theParent = node.parentNode;
    var lastAddedChild = dummyDiv.firstChild; // start with the first child of what was in the string. Last in the meaning of last worked on
    theParent.replaceChild(lastAddedChild, node); // first node from the string is put to the old parent instead of the node that shall be replaced
    changedNodes.push(lastAddedChild);
    while (dummyDiv.hasChildNodes()) {
      // if there was more than one root node in the string, append those nodes also
      lastAddedChild = window.YAHOO.fcom.Dom.appendBehind(dummyDiv.firstChild, lastAddedChild);
      changedNodes.push(lastAddedChild);
    }
    return changedNodes;
  },
  /*
   * Returns whether the provided node is a text node.
   * Usually text nodes can be skipped by operations, which might improve performance.
   * null is not a text node.
   * @method
   * @param {Node} node DOM node
   * @return {Boolean}
   */
  isTextNode: function isTextNode(node) {
    if (node) {
      //Node.TEXT_NODE := 3
      return node.nodeType === 3;
    }
    return false;
  },
  /*
    * Get a style in pixel. Default is zero.
    * @param {HTMLElement} el
    * @param {String} style
    * @return {Number}
    */
  styleInPx: function styleInPx(el, style) {
    style = window.Dom.getStyle(el, style);
    var index = style.indexOf('px');
    if (index > -1) {
      return +window.YAHOO.fcom.Util.trim(style.substring(0, style.indexOf('px')));
    }
    return 0;
  },
  /*
   * A wrapper for the clone node functionality
   * @param {HTMLElement} node
   * @param {String} [container]
   * @returns {HTMLElement}
   */
  cloneNodeWrap: function cloneNodeWrap(node) {
    return node.cloneNode(true);
  }
};
var _default = exports.default = Dom;
window.YAHOO.fcom.Dom = Dom;

},{}],24:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * This function shows the error messages in the given div
 * and the field is marked with the error class,
 * @param fieldId the id of the input field
 * @param errorDivId the id of the error div
 * @param errorMessage
 */
var errorMessage = function errorMessage(fieldId, errorDivId, errrorMessage) {
  if (fieldId != null) {
    var field = window.Dom.get(fieldId);
    window.Dom.addClass(field, 'error');
    field.title = errrorMessage;
  }
  if (errorDivId != null) {
    var errorEl = window.YAHOO.lang.isString(errorDivId) ? window.Dom.get(errorDivId) : errorDivId;
    window.Dom.setStyle(errorEl, 'display', '');
    window.Dom.get(errorEl).innerHTML = errrorMessage;
  }
};

/*
 * Hide the error message that was previously created by the function errorMessage.
 * @param {Object} fieldId the id of the input field
 * @param {Object} errorDiv the id of the error div
 */
var hideErrorMessage = function hideErrorMessage(fieldId, errorDivId) {
  if (fieldId != null) {
    var field = window.Dom.get(fieldId);
    if (field && window.Dom.hasClass(field, 'error')) {
      window.Dom.removeClass(field, 'error');
      field.title = '';
    }
  }
  if (errorDivId != null) {
    var errorEl = window.YAHOO.lang.isString(errorDivId) ? window.Dom.get(errorDivId) : errorDivId;
    window.Dom.setStyle(errorEl, 'display', 'none');
  }
};
var _default = exports.default = {
  errorMessage: errorMessage,
  hideErrorMessage: hideErrorMessage
};
window.errorMessage = errorMessage;
window.hideErrorMessage = hideErrorMessage;

},{}],25:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/*
 * this small function can be used to stop automatically created form submits. Just not
 * onSubmit="return stopAutoFormSubmit();" and then the form should not submit automatically in
 * any brother. But then you have to set the keylisteners manually when the form should send on
 * ENTER key.
 *
 * @param eventVar
 * @return
 */
var stopAutoFormSubmit = function stopAutoFormSubmit(eventVar) {
  if (!eventVar) {
    eventVar = window.event;
  }
  if (eventVar && eventVar != null) {
    YAHOO.util.Event.stopEvent(eventVar);
    eventVar.cancelBubble = true;
  }
  return false;
};

/*
 * create a random string with the given number of digits.
 */
var getRandomString = function getRandomString(length) {
  if (!length || isNaN(length)) {
    length = 5;
  }
  var number = parseInt(Math.pow(36, length) * Math.random(), 10);
  var numberString = number.toString(36);
  while (numberString.length < length) {
    numberString += parseInt(Math.random() * 10, 10);
  }
  return numberString;
};

/*
 * read a parameter that was given to a function that is supposed to
 * address a dom node. If the param is already a dom node, it is returned as given
 * if it is of type string, the node with the given id is returned. If no node is found,
 * the function tries to find the node by name, but this is not supposed to be used,
 * as there can be several nodes using the same name.
 * If nothing is found at all, null is returned.
 * @param nodeParam {Object|String} a dom node object or the id of one or even the name of one (not recommended though).
 */
var getNodeFromParameter = function getNodeFromParameter(nodeParam) {
  if (nodeParam && nodeParam.nodeName) {
    // looks quite much like a dom node
    return nodeParam;
  } else if (window.YAHOO.lang.isString(nodeParam)) {
    var nodeObj = window.Dom.get(nodeParam);
    if (nodeObj && nodeObj.nodeName) {
      // looks quite much like a dom node
      return nodeObj;
    } else {
      var nodeObjects = document.getElementsByName(nodeParam);
      if (nodeObjects && nodeObjects.length > 0) {
        return nodeObjects[0];
      }
    }
  }
  return null;
};

/*
 * add a hidden field with one or more values to a form.
 * @param name the name to be used for the hidden field
 * @param value the value for the hidden field. Can be either a string (one value)
 *              or an array of strings for several values, which will be added as
 *              individual hidden fields, as usual for list types in html forms
 * @param formNode the form tag to append the hidden fields to
 */
var addHiddenField = function addHiddenField(name, value, formNode) {
  if (name && window.YAHOO.lang.isArray(value)) {
    value.forEach(function (val) {
      window.YAHOO.fcom.Forms.addHiddenField(name, val, formNode);
    });
    return;
  }
  var newField = document.createElement('input');
  newField.setAttribute('type', 'hidden');
  newField.setAttribute('name', name);
  newField.setAttribute('value', value);
  formNode.appendChild(newField);
};

/*
 * helper method to get the selected value of a radio button group.
 * the argument el either has to be the radiobutton group array, which will be returned
 * by document.myForm.elements['nameOfMyRadioGroup'].
 * el can also be passed as string, then it has to be the id of one of the radio buttons.<b>
 */
var getCheckedRadioValue = function getCheckedRadioValue(el) {
  if (el && el != null) {
    if (window.YAHOO.lang.isString(el)) {
      el = window.Dom.get(el); // the element by id
      if (el == null) {
        return null;
      }
      if (!el.length) {
        el = el.form.elements[el.name];
      }
    }
    if (!el.length) {
      return null; // does not seem to be a radiogroup
    }

    for (var i = 0; i < el.length; i++) {
      if (el[i] && el[i].checked && el[i].checked) {
        return el[i].value;
      }
    }
  }
  return null;
};

/*
 * walk through a group of radio buttons and select the one with the given value.
 * the given element has to be a radio button group element. As the group element
 * does not correspond to a html node, an id string will not work here
 */
var setCheckedRadioValue = function setCheckedRadioValue(el, value) {
  if (el && el != null) {
    if (window.YAHOO.lang.isString(el)) {
      el = window.Dom.get(el);
    }
    if (el.length) {
      for (var i = 0; i < el.length; i++) {
        if (el[i] && el[i].value && el[i].value === value) {
          if (!el[i].checked) {
            el[i].checked = true;
            window.YAHOO.fcom.Event.fireEvent(el[i], 'change');
          }
          return;
        }
      }
    }
  }
};

/*
 * set a button disabled or enabled by passing the id of the button
 * tag or the button tag node object itself and a boolean value whether
 * this button should now be disabled or not.
 */
var setButtonDisabled = function setButtonDisabled(buttonElement, isDisabled) {
  setButtonProperty(buttonElement, 'disabled', isDisabled);
};

/*
 * set a button property known by the YUI widget button by passing the id of the button
 * tag or the button tag node object itself and the name and value of the attribute.
 */
var setButtonProperty = function setButtonProperty(buttonElement, propertyName, propertyValue) {
  var buttonHandler = null;
  if (buttonElement && buttonElement != null) {
    if (window.YAHOO.lang.isString(buttonElement)) {
      buttonHandler = window.domToYUIMap[buttonElement];
    } else {
      buttonHandler = window.domToYUIMap[buttonElement.parentNode.parentNode.id];
    }
    if (buttonHandler) {
      buttonHandler.set(propertyName, propertyValue);
    } else {
      buttonElement.setAttribute(propertyName, propertyValue);
    }
  }
};

/*
 * get the YUI widget button handler by passing the id of the button
 * tag or the button tag node object itself
 */
var getYUIButtonHandler = function getYUIButtonHandler(buttonElement) {
  var buttonHandler = null;
  if (buttonElement && buttonElement != null) {
    if (window.YAHOO.lang.isString(buttonElement)) {
      buttonHandler = window.domToYUIMap[buttonElement];
    } else {
      buttonHandler = window.domToYUIMap[buttonElement.parentNode.parentNode.id];
    }
    return buttonHandler;
  }
  return null;
};

/*
 * get a button property known by the YUI widget button by passing the id of the button
 * tag or the button tag node object itself and the name of the attribute.
 */
var getButtonProperty = function getButtonProperty(buttonElement, propertyName) {
  var buttonHandler = null;
  if (buttonElement && buttonElement != null) {
    if (window.YAHOO.lang.isString(buttonElement)) {
      buttonHandler = window.domToYUIMap[buttonElement];
    } else {
      buttonHandler = window.domToYUIMap[buttonElement.parentNode.parentNode.id];
    }
    return buttonHandler.get(propertyName);
  }
};

/*
 * this method takes the given YUI menu (must be the YUI object itself, not a DOM node in the html tree)
 * and iterates over the items. For every item that has the property "checked" set to true, the array of
 * hidden fields gets a new entry. All hidden field entries that were added previously and are not checked
 * any more, will be removed.
 * @param menuVariable the YUI menu object
 * @param formObject the formular to append hidden fields to, as found via document.forms[...]
 * @param hiddenFieldName a string holding the name of the hidden field that will become the name
 *        of the array parameter when the form is sent.
 */
var updateHiddenFieldForCheckedMenuEntries = function updateHiddenFieldForCheckedMenuEntries(menuVariable, formObject, hiddenFieldName) {
  var items = menuVariable.getItems(); // getItems is an array of MenuItem
  var fields = formObject.elements[hiddenFieldName]; // remove all previouly set fields
  while (fields && fields.length && fields.length > 0) {
    fields[0].parentNode.removeChild(fields[0]);
    fields = formObject.elements[hiddenFieldName];
  }
  if (fields && fields.value) {
    // stupid workaround, because unique field is different from array fields
    fields.parentNode.removeChild(fields);
  }
  items.forEach(function (item) {
    if (item.cfg.getProperty('checked')) {
      var newField = document.createElement('input');
      newField.setAttribute('type', 'hidden');
      newField.setAttribute('name', hiddenFieldName);
      newField.setAttribute('value', item.value);
      formObject.appendChild(newField);
    }
  });
};

/*
 * this function can be used to reset forms to the state they where loaded in.
 * This is useful to implement reset buttons or similar. Resetting a form will NOT reset hidden fields
 * in some browsers (such as FF). You have to take care of those yourself.
 * Take care, the function can only work correctly, as long as the forms are static
 * ones, that do not get any ajax updates or similar. If the content of form elements is
 * changed while the user in interacting, of course this generic function can not reset the form
 * to any meaningful state. It realy should not be tryed, even if it might give a proper state, as it might be
 * random luck and next time the form gets an inconsistent state.
 * @param formElement the form element as returned by document.forms[...], or the name to get the form element via
 *        document.forms[name]
 * @param @optional renderTo {String|HTMLElement} optional container element, in case a fresh render is required after reset
 *
 * @return the form element of the form that was reseted right now
 */
var resetForm = function resetForm(formElement, renderTo) {
  formElement = window.YAHOO.fcom.Forms._isFormElement(formElement);
  if (formElement != null) {
    formElement.reset(); //reset all native inputs
    var formItems = window.YAHOO.fcom.Forms._inspectForm(formElement);
    formItems.forEach(function (formItem) {
      if (window.YAHOO.lang.isFunction(formItem.reset)) {
        formItem.reset(renderTo); //reset YUI controlled elements
      }
    });
  } else {
    console.error('Call to YAHOO.fcom.Forms.resetForm(...) without form parameter given');
  }
};

/*
 * @private
 * Check whether the supplied element is an actual form
 * @param formElement {String|HTMLElement} the form element as returned by document.forms[...], or the name to get the form element via
 *        document.forms[name]
 * @return {HTMLElement} the form element or null
 */
var _isFormElement = function _isFormElement(formElement) {
  if (!formElement || formElement == null) {
    console.error('Call to YAHOO.fcom.Forms._isFormElement(...) without form parameter given');
    return null;
  }
  if (window.YAHOO.lang.isString(formElement)) {
    formElement = document.forms[formElement];
  }
  //YAHOO.lang.isFunction reports false in IE when testing dom elements. Therefore check if the properties are defined for now
  if (window.YAHOO.lang.isUndefined(formElement.submit) || window.YAHOO.lang.isUndefined(formElement.reset)) {
    console.error('Call to YAHOO.fcom.Forms._isFormElement(...) without a proper form parameter given');
    return null;
  }
  return formElement;
};

/*
 * @private
 * Walk the form and collect all YUI controlled form elements
 * @param formElement {HTMLElement} an actual form element (make sure to check with _isFormElement first)
 * @return {Array} array of YUI form controls
 */
var _inspectForm = function _inspectForm(formElement) {
  var formItems = [];
  var inputs = window.Dom.getElementsBy(function () {
    return true;
  }, 'input', formElement);
  inputs.forEach(function (input) {
    var formItem = window.YAHOO.fcom.Forms.getHandlerForElement(input.name);
    if (formItem == null) {
      formItem = window.YAHOO.fcom.Forms.getHandlerForElement(input.id);
    }
    if (formItem != null && window.YAHOO.fcom.Util.indexOf(formItem, formItems) === -1) {
      formItems.push(formItem);
    }
  });
  return formItems;
};

/*
 * Walks a form and returns all YUI controlled form elements.
 * @param formElement {String|HTMLElement} the form element
 * @return {Array} array of YUI form controls
 */
var getFormControls = function getFormControls(formElement) {
  var formItems = [];
  formElement = window.YAHOO.fcom.Forms._isFormElement(formElement);
  if (formElement != null) {
    formItems = window.YAHOO.fcom.Forms._inspectForm(formElement);
  } else {
    console.error('Call to YAHOO.fcom.Forms.getFormControls(...) without a proper form parameter given');
  }
  return formItems;
};

/*
 * this function can be used to get the javascript handler for the element given, e.g. dropdowns, panels or buttons.
 * the given handlers are typically the yui instances that do the work on those user interfaces.
 * The htmlElement given should be the toplevel dom element, which was also given to the constructor of the
 * user interface hanlder. e.g. when wanting the panel handler, the div where the panel lives in (or it's id) should be given
 * Known elements are
 * - panels
 * - buttons
 * - dropdowns
 * - text value inputs
 * - date inputs
 * - shuffle lists
 * @param htmlElement the element that is the node that was passes to the constructor of the user interface handler or it's id
 * @return the user interface handler, e.g. an instance of YAHOO.widgetPanel or null, if the element was not connected to any handler so far.
 */
var getHandlerForElement = function getHandlerForElement(htmlElement) {
  if (!htmlElement || htmlElement == null) {
    console.error('Call to YAHOO.fcom.Forms.getHandlerForElement(...) with null element given.');
    return null;
  }
  var instance = null;
  if (window.YAHOO.lang.isString(htmlElement)) {
    instance = window.domToYUIMap[htmlElement];
    return instance || null;
  }
  if (!htmlElement.id || htmlElement.id == null) {
    return null;
  }
  instance = window.domToYUIMap[htmlElement.id];
  return instance || null;
};

/*
 * this function creates a YUI menu from markup with multi selection capability.
 * on click the "checked" state of the items is toggled and the function
 * updateHiddenFieldForCheckedMenuEntries(...) can be used to append checked items
 * to a formular before submition.
 * @param domNode the dom node under which the yui menu starts (a block element around the class="bd" div)
 * @param config configuration parameters for the menu. If the menu should be visible always and
 *        not be hided when the user clicks somewhere else e.g the config attribute "position" must be set to "static".
 *        see YUI api doc of YAHOO.widget.Menu for more configuration attributes
 * @return the YUI menu object, that is lateron needed to collect checked entries with the
 *         updateHiddenFieldForCheckedMenuEntries(...) function
 */
var createMultipleSelectMenu = function createMultipleSelectMenu(domNode, config) {
  domNode = window.Dom.get(domNode);
  config.container = domNode;
  var menu = window.domToYUIMap[domNode.id];
  if (menu && menu != null && menu.getItems) {
    // don't destroy when already empty
    try {
      /* somehow there happend errors in IE when destroying the menu node and it was not completly destroyed **/
      menu.destroy();
    } catch (e) {
      /* so in case of an error, we just try another time. Which turned out to help. **/
      menu.destroy();
    }
  }
  menu = new window.YAHOO.widget.Menu(domNode, config);
  menu.render(domNode.parentNode);
  window.domToYUIMap[domNode.id] = menu;
  menu.subscribe('click', function (type, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      oItem = _ref2[1];
    if (oItem && !oItem.cfg.getProperty('disabled')) {
      oItem.cfg.setProperty('checked', !oItem.cfg.getProperty('checked'));
    }
  }, menu, false);
  return menu;
};

/*
 * Set focus to the textfield and move the caret position to the end of the textfield.
 * (Usually the cursor will be at the beginning)
 * @param input {HTMLInputElement}
 */
var focusText = function focusText(input) {
  input.focus();
  var v = input.value;
  //first empty, then reset value -> sets caret to end
  if (v != null) {
    input.value = '';
    input.value = v;
  }
};
var getSelectedRange = function getSelectedRange(input) {
  if (input.selectionStart != null) {
    return {
      start: input.selectionStart,
      end: input.selectionEnd
    };
  }
  var pos = {
    start: 0,
    end: 0
  };
  var range = input.getDocument().selection.createRange();
  if (!range || range.parentElement() !== input) {
    return pos;
  }
  var duplicate = range.duplicate();
  if (input.type === 'text') {
    pos.start = 0 - duplicate.moveStart('character', -100000);
    pos.end = pos.start + range.text.length;
  } else {
    var value = input.get('value');
    var offset = value.length;
    duplicate.moveToElementText(input);
    duplicate.setEndPoint('StartToEnd', range);
    if (duplicate.text.length) {
      offset -= value.match(/[\n\r]*$/)[0].length;
    }
    pos.end = offset - duplicate.text.length;
    duplicate.setEndPoint('StartToStart', range);
    pos.start = offset - duplicate.text.length;
  }
  return pos;
};
var setCaretPosition = function setCaretPosition(input, pos) {
  if (pos === 'end') {
    pos = input.value.length;
  }
  selectRange(input, pos, pos);
  return input;
};
var selectRange = function selectRange(input, start, end) {
  if (input.setSelectionRange) {
    input.focus();
    input.setSelectionRange(start, end);
  } else {
    var value = input.get('value');
    var diff = value.substr(start, end - start).replace(/\r/g, '').length;
    start = value.substr(0, start).replace(/\r/g, '').length;
    var range = input.createTextRange();
    range.collapse(true);
    range.moveEnd('character', start + diff);
    range.moveStart('character', start);
    range.select();
  }
  return input;
};
var _default = exports.default = {
  stopAutoFormSubmit: stopAutoFormSubmit,
  getRandomString: getRandomString,
  getNodeFromParameter: getNodeFromParameter,
  addHiddenField: addHiddenField,
  getCheckedRadioValue: getCheckedRadioValue,
  setCheckedRadioValue: setCheckedRadioValue,
  setButtonDisabled: setButtonDisabled,
  setButtonProperty: setButtonProperty,
  getYUIButtonHandler: getYUIButtonHandler,
  getButtonProperty: getButtonProperty,
  updateHiddenFieldForCheckedMenuEntries: updateHiddenFieldForCheckedMenuEntries,
  resetForm: resetForm,
  _isFormElement: _isFormElement,
  _inspectForm: _inspectForm,
  getFormControls: getFormControls,
  getHandlerForElement: getHandlerForElement,
  createMultipleSelectMenu: createMultipleSelectMenu,
  focusText: focusText,
  getSelectedRange: getSelectedRange,
  setCaretPosition: setCaretPosition,
  selectRange: selectRange
};
window.YAHOO.fcom.Forms = {
  stopAutoFormSubmit: stopAutoFormSubmit,
  getRandomString: getRandomString,
  getNodeFromParameter: getNodeFromParameter,
  addHiddenField: addHiddenField,
  getCheckedRadioValue: getCheckedRadioValue,
  setCheckedRadioValue: setCheckedRadioValue,
  setButtonDisabled: setButtonDisabled,
  setButtonProperty: setButtonProperty,
  getYUIButtonHandler: getYUIButtonHandler,
  getButtonProperty: getButtonProperty,
  updateHiddenFieldForCheckedMenuEntries: updateHiddenFieldForCheckedMenuEntries,
  resetForm: resetForm,
  _isFormElement: _isFormElement,
  _inspectForm: _inspectForm,
  getFormControls: getFormControls,
  getHandlerForElement: getHandlerForElement,
  createMultipleSelectMenu: createMultipleSelectMenu,
  focusText: focusText,
  getSelectedRange: getSelectedRange,
  setCaretPosition: setCaretPosition,
  selectRange: selectRange
};

},{}],26:[function(require,module,exports){
"use strict";

// register some shortcuts for Yahoo Stuff
window.ngpNamespace('YAHOO.fcom.modules');
window.Dom = window.Dom;
window.DDM = window.YAHOO.util.DragDropMgr;

},{}],27:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("../../app/utils/axios"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; } /**
                                                                                                                                                                                     * This function inits all the generic stuff on the document like
                                                                                                                                                                                     * the mouse over handlers on links, the generic yui form elements and so on.
                                                                                                                                                                                     * Both parameters are optional. The first one addresses the node to init the
                                                                                                                                                                                     * content from (if not given document.body will be used) and the second is a boolean
                                                                                                                                                                                     * value specifying whether the content was normally loaded by the browser or rather
                                                                                                                                                                                     * fetched through a javascript ajax request. In latter case new streaming nodes will be
                                                                                                                                                                                     * registered.
                                                                                                                                                                                     * @method
                                                                                                                                                                                     * @param {Node} node The node to initialize. The node defaults do document.body.
                                                                                                                                                                                     * @param {Boolean} fromAjax Optional flag whether the node was loaded from ajax. Defaults to false.
                                                                                                                                                                                     * @param {Boolean} hasStreamingNodes Optional flag whether the node has streaming nodes. Defaults to true.
                                                                                                                                                                                     */
var initDocument = function initDocument(node, fromAjax, hasStreamingNodes) {
  checkTabId(); // check if the page is currently run in a new tab/window by creating a tab unique id in the local storage
  window.addLargeTableObserver();
  if (!node) {
    node = document.body;
  }
  if (node.nodeType !== 1 && node.nodeType !== 9) {
    // no real node, but some comment, text or attribute or similar
    return; // no meaning in initing those nodes.
  }

  if (node === document.body) {
    window.setUserAgentCssBodyClass();
    if (window.self !== window.top) {
      window.Dom.addClass(document.body, 'in-iframe');
    }
  }
  window.initButtons(node);
  window.initRangeBars(node);
  // walk over all nodes with a class="link" and generate mouse over and mousedown effects
  window.addHoverToLinkNodes(node);
  if (fromAjax && node !== document.body) {
    /* only when a part of the document is reloaded, add new streaming nodes to the streaming */
    if (window.YAHOO.fcom.Streaming && window.YAHOO.fcom.Streaming.streamingService != null && window.YAHOO.lang.isFunction(window.YAHOO.fcom.Streaming.addStreamingNodes) && hasStreamingNodes !== false) {
      window.YAHOO.fcom.Streaming.addStreamingNodes(node);
    }
  }
};
var getOpenerTabId = function getOpenerTabId() {
  try {
    if (window.opener) {
      return window.opener.sessionStorage.getItem('tabId');
    }
  } catch (e) {
    console.warn("Tab ID could not be retrieved from opener sessionsStorage", e);
  }
  return null;
};

/**
 * check whether the current tab/frame/window has already a tabId set and if not do so.
 * tabId is a session storage parameter called 'tabId' with a 5 letter id for the current tab
 * It will be put to the global window.user object and can be accessed by
 * window.user.tabId
 */
var checkTabId = function checkTabId() {
  if (window.sessionStorage) {
    // browser support for session storage?
    var tabId = window.sessionStorage.getItem('tabId');

    // second expression is for chrome, which copies the session storage to JS-opened window instances
    if (!tabId || getOpenerTabId() === tabId) {
      window.sessionStorage.setItem('tabId', Math.floor(Math.random() * 60466175).toString(36)); // 5 digit number with radix 36, 60466175 will be 'zzzzz'
    }

    window.user.tabId = window.sessionStorage.getItem('tabId');
  }
};

/*
 * set a css class on the body tag with which css selectors can change behavior depending on the
 * various browser bugs
 */
var setUserAgentCssBodyClass = function setUserAgentCssBodyClass() {
  var className = '';
  var userAgent = window.YAHOO.env.ua;
  if (userAgent.chrome > 0) {
    className = "b-chrome-".concat(parseInt(userAgent.chrome, 10));
  } else if (userAgent.ie > 0) {
    className = "b-ie-".concat(parseInt(userAgent.ie, 10));
  } else if (userAgent.opera > 0) {
    className = "b-opera-".concat(parseInt(userAgent.opera, 10));
  } else if (userAgent.webkit > 0) {
    className = "b-safari-".concat(parseInt(userAgent.webkit, 10));
  } else if (userAgent.gecko > 0) {
    className = "b-firefox-".concat(parseInt(userAgent.gecko, 10));
  }
  if (className.length > 0) {
    window.Dom.addClass(document.body, className);
  }
};
var initRangeBars = function initRangeBars(node) {
  var rangeBars = node.getElementsByClassName('range-meter-parent');
  for (var i = 0; i < rangeBars.length; i++) {
    var barNode = rangeBars[i];
    if (barNode.innerText.split(' ')[0] !== barNode.innerText.split(' ')[2]) {
      var markerSpan = barNode.querySelector('.range-meter-marker-pos');
      if (markerSpan) {
        var pointerPosition = markerSpan.textContent;
        var up = window.getComputedStyle(node.querySelector('.up')).getPropertyValue('color');
        var down = window.getComputedStyle(node.querySelector('.down')).getPropertyValue('color');
        barNode.querySelector('.linear-range-meter').style['background-image'] = "linear-gradient(to right, ".concat(up, " 0%, ").concat(up, " ").concat(pointerPosition, "%,#ffffff ").concat(pointerPosition, "%,#ffffff ").concat(pointerPosition + 1, "%,").concat(down, " ").concat(pointerPosition + 1, "%, ").concat(down, " 100%)");
      }
    }
  }
};
var initButtons = function initButtons(node) {
  var buttonTags;
  if (node === document.body) {
    buttonTags = node.getElementsByTagName('button');
  } else {
    buttonTags = window.Dom.getElementsBy(function () {
      return true;
    }, 'button', node);
  }
  for (var i = 0; i < buttonTags.length; i++) {
    var button = buttonTags[i];
    var buttonElem = void 0;
    if (window.Dom.hasClass(button, 'icon') || window.Dom.hasClass(button, 'no-auto') || button.id && window.domToYUIMap[button.id] && window.domToYUIMap[button.id] != null && node === document.body) {
      // only in initial call, not when reloading ajax nodes.
      continue; // button was already handled, or is of new generation with no YUI additions any more
    }

    if (button.type === 'submit') {
      buttonElem = new window.YAHOO.widget.Button(button);
      buttonElem.addListener('click', function (eventArg, buttonArg) {
        var now = new Date().getTime();
        if (buttonArg === window.genericButtonLastPressedInstance && now - window.genericButtonLastPressed < 2500) {
          // the same button was already pressed shortly before
          if (!eventArg) {
            eventArg = window.event;
          }
          eventArg.cancelBubble = true;
          window.YAHOO.util.Event.stopEvent(eventArg);
          return;
        }
        window.genericButtonLastPressed = now;
        window.genericButtonLastPressedInstance = buttonArg;
      }, null, buttonElem);
      window.domToYUIMap[window.Dom.generateId(button)] = buttonElem;
      if (buttonElem.get('id')) {
        window.YAHOO.fcom.Page.ready(buttonElem.get('id'), buttonElem);
      }
    } else if (button.type === 'button') {
      var configObj = {};
      configObj.onclick = {};
      configObj.onclick.fn = function (eventArg, buttonArg) {
        var now = new Date().getTime();
        if (buttonArg === window.genericButtonLastPressedInstance && now - window.genericButtonLastPressed < 2500) {
          if (!eventArg) {
            eventArg = window.event;
          }
          eventArg.cancelBubble = true;
          window.YAHOO.util.Event.stopEvent(eventArg);
          return;
        }
        window.genericYUIButton = this;
        window.genericButtonLastPressed = now;
        window.genericButtonLastPressedInstance = buttonArg;
        if (this.get('srcelement').onclick) {
          this.get('srcelement').onclick();
        } else {
          window.YAHOO.fcom.Event.fireEvent(this.get('srcelement'), 'click');
        }
      };
      configObj.onclick.obj = button;
      var id = window.Dom.generateId(button);
      buttonElem = new window.YAHOO.widget.Button(button, configObj);
      window.domToYUIMap[id] = buttonElem;
      if (buttonElem.get('id')) {
        window.YAHOO.fcom.Page.ready(buttonElem.get('id'), buttonElem);
      }
    } else if (button.type === 'reset') {
      var buttonId = window.Dom.generateId(button);
      buttonElem = new window.YAHOO.widget.Button(buttonTags[i]);
      window.domToYUIMap[buttonId] = buttonElem;
      if (buttonElem.get('id')) {
        window.YAHOO.fcom.Page.ready(buttonElem.get('id'), buttonElem);
      }
    }
  }

  // walk over all input tags and generate checkbox and radiobutton handlers
  var radioMap = {};
  var inputTags;
  if (node === document.body) {
    inputTags = _toConsumableArray(node.getElementsByTagName('input'));
  } else {
    inputTags = window.YAHOO.fcom.Dom.getDescendantsBy(node, function (theNode) {
      return theNode.nodeName.toLowerCase() === 'input';
    });
  }
  inputTags.forEach(function (inputTag) {
    if (window.Dom.hasClass(inputTag, 'unformatted') === false || window.Dom.hasClass(inputTag, 'add-to-dom-map')) {
      if (inputTag.type === 'radio' && (window.Dom.hasClass(inputTag, 'radiobutton') || window.Dom.hasClass(inputTag, 'radio'))) {
        var groupObject = radioMap[inputTag.name];
        if (!groupObject) {
          groupObject = [];
          radioMap[inputTag.name] = groupObject;
        }
        var radio = new window.YAHOO.fcom.Radio(inputTag, groupObject);
        if (inputTag.id) {
          window.domToYUIMap[inputTag.id] = radio;
          window.YAHOO.fcom.Page.ready(inputTag.id, radio);
        }
      } else if (inputTag.type === 'checkbox' && window.Dom.hasClass(inputTag, 'checkbox')) {
        var supressDomClick = !window.Dom.hasClass(inputTag, 'getDomClick');
        var check = new window.YAHOO.fcom.Checkbox(inputTag, supressDomClick);
        window.domToYUIMap[inputTag.name] = check;
        if (inputTag.id) {
          window.YAHOO.fcom.Page.ready(inputTag.id, check);
        }
      }
    }
  });
};
var _default = exports.default = {
  initDocument: initDocument,
  setUserAgentCssBodyClass: setUserAgentCssBodyClass,
  initButtons: initButtons,
  initRangeBars: initRangeBars
};
window.initDocument = initDocument;
window.setUserAgentCssBodyClass = setUserAgentCssBodyClass;
window.initButtons = initButtons;
window.initRangeBars = initRangeBars;

},{"../../app/utils/axios":1}],28:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _this = void 0;
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/*
 * For private use by largeTableDecodeIdEncoding() only.
 * Decodes a single KeyFidlet contents.
*/
var largeTableDecodeIdEncodingSingleString = function largeTableDecodeIdEncodingSingleString(encoded) {
  if (encoded.indexOf('e.') !== 0) {
    return encoded; // in fact, this is an error, but we gracefully just assume that the string was never encoded
  }

  var s = encoded.substring(2);
  var pos = s.indexOf(':');
  if (pos < 0) {
    return s; // our string does not contain special chars to decode
  }

  var start = 0;
  var n = s.length;
  var result = '';
  while (pos >= 0) {
    if (pos + 4 < n) {
      result += s.substring(start, pos);
      var c = 0x1000 * (s.charCodeAt(pos + 1) - 97) + 0x100 * (s.charCodeAt(pos + 2) - 97) + 0x10 * (s.charCodeAt(pos + 3) - 97) + (s.charCodeAt(pos + 4) - 97);
      result += String.fromCharCode(c);
      start = pos + 5;
      pos = s.indexOf(':', start);
    } else {
      // string is garbled - just do our best to exit gracefully
      pos = -1;
    }
  }
  result += s.substring(start);
  return result;
};
var externalLargeTableUpdateHandler = {};
var externalLargeTableExportHandler = {};

/*
 * For private use by LargeTable only.
 * Decodes the KeyFidlets for the ID string of a single row of the LargeTable.
 */
var largeTableDecodeIdEncoding = function largeTableDecodeIdEncoding(s) {
  var map = [];
  var tokens = s.split('-');
  if (tokens.length > 2) {
    var n = parseInt(tokens[tokens.length - 1], 10);
    if (2 * n < tokens.length) {
      for (var i = 0; i < n; i++) {
        var eKey = tokens[tokens.length - 3 - 2 * i];
        var eValue = tokens[tokens.length - 2 - 2 * i];
        map[largeTableDecodeIdEncodingSingleString(eKey)] = largeTableDecodeIdEncodingSingleString(eValue);
      }
    } // else complete parsing is not possible - rather just return the empty map
  } // else nothing to parse - we just return the empty map

  return map;
};

/*
 * Returns the value of the given KeyFidlet in a specific row of a LargeTable.
 * @param element the chosen TR element or any child of it
 * @param keyFidlet any KeyFidlet contained in the largeTable
 * @return the value of the given KeyFidlet in a specific row of a LargeTable.
 */
var largeTableRow = function largeTableRow(element, keyFidlet) {
  if (element == null || element.parentNode == null || element.parentNode.parentNode == null) {
    element = window.genericYUIButton.get('element');
  }
  while (element != null && element.tagName !== 'TR') {
    element = element.parentNode;
  }
  if (element == null) {
    return null;
  }
  var map = largeTableDecodeIdEncoding(element.id);
  if (keyFidlet != null) {
    for (var i in map) {
      if (i === keyFidlet) {
        return map[i];
      }
    }
    return null;
  } else {
    return map;
  }
};

/*
 * TODO Tobi: This function is very often used for BUTTONS, even though the documentation
 * (also for largeTableGetOuterElement() ) says it should NOT.
 * But it still works if the LargeTable is wrapped in another <table /> tag.
 * But I would consider this as a sideffect. If there is no  <table /> in the tree above a button,
 * then it suddenly doesn't work anymore in combination with the buttons.
 * Further if you have two LargeTables inside the same <table />, you will get the selections of BOTH LargeTables.
 *
 * Returns an array containing the values which the given KeyFidlet has in all selected rows.
 * @param element the LargeTable TABLE element or any child of it
 * @param keyFidlet any KeyFidlet contained in the largeTable
 * @return an array containing the values which the given KeyFidlet has in all selected rows.
 */
//
var largeTableSelected = function largeTableSelected(element, keyFidlet) {
  var table = largeTableGetOuterElement(element);
  var selectedTrs = largeTableGetSelectedTRs(table);
  var result = [];
  selectedTrs.forEach(function (tr) {
    var map = largeTableDecodeIdEncoding(tr.id);
    if (keyFidlet != null) {
      for (var j in map) {
        if (j === keyFidlet) {
          var value = map[j];
          /*
              * LargeTable uses &nbsp for empty cells.
              * We dont want that in javascript.
              */
          if (value === '&nbsp;') {
            value = '';
          }
          result.push(value);
          break;
        }
      }
    } else {
      result.push(map);
    }
  });
  return result;
};

/*
 * For private use by LargeTable only.
 * Handles the click on the selection checkbox of a single row.
 */
var largeTableRowSelect = function largeTableRowSelect(element) {
  var table = largeTableGetOuterElement(element);
  var checkboxes = largeTableGetCheckboxes(table);
  var numSelected = 0;
  for (var i in checkboxes) {
    if (checkboxes[i] != null && checkboxes[i].checked) {
      numSelected++;
    }
  }
  var allSelector;
  if (numSelected !== checkboxes.length) {
    //a checkbox was unselected, thus all selector shouldnt be checked
    allSelector = largeTableGetAllSelector(largeTableGetOuterElement(element));
    allSelector.checked = false;
    window.YAHOO.fcom.Event.fireEvent(allSelector, 'changeAuto');
  } else if (numSelected === checkboxes.length) {
    //all checkboxes have been selected, all selector is checked
    allSelector = largeTableGetAllSelector(largeTableGetOuterElement(element));
    allSelector.checked = true;
    window.YAHOO.fcom.Event.fireEvent(allSelector, 'changeAuto');
  }
  largeTableUpdateSpecificButtonStates(table, numSelected);
};

/*
 * take a dom node or the id of a dom node anywhere inside the large table
 * and walk up the dom tree until the correct id of the large table is found.
 * @param childElement any dom node (or an id of one) inside the large table to search the id of
 * @return the id of the large table (in fact the id of the div surrounding it)
 */
var largeTableFindIdByChildNode = function largeTableFindIdByChildNode(childElement) {
  childElement = window.Dom.get(childElement); // when string is given, it will be the node now.
  var nodeTest = function nodeTest(node) {
    return window.Dom.hasClass(node, 'largeTable') && node.nodeName.toLowerCase() === 'div';
  };
  var rootDiv;
  if (nodeTest(childElement)) {
    rootDiv = childElement;
  } else {
    rootDiv = window.Dom.getAncestorBy(childElement, nodeTest);
  }
  if (rootDiv && !window.YAHOO.lang.isUndefined(rootDiv) && !window.YAHOO.lang.isUndefined(rootDiv.id)) {
    return rootDiv.id;
  }
  return null;
};

/*
 * Return a list of rows representing the table's data.
 * The list items are maps that can be accessed by the fidlet key.
 * If the optional paramter key is supplied, the return object will be a map, accessible by the key's values.
 * Else the data map just will be returned as a flat list of map items.
 * @param {HTMLElement} tableElement
 * @param @optional {String} key
 * @return {Array}
 */
var largeTableGetData = function largeTableGetData(tableElement, key) {
  var data = [];
  var dataRows = window.Dom.getElementsBy(function (node) {
    var rows = window.YAHOO.util.Selector.query('th', node);
    if (rows && rows.length > 0) {
      return false;
    }
    return true;
  }, 'tr', tableElement);
  dataRows.forEach(function (row) {
    var dataRow = largeTableDecodeIdEncoding(row.id);
    data.push(dataRow);
    if (key && dataRow[key]) {
      var rowKey = dataRow[key];
      data[rowKey] = data[data.length - 1];
    }
  });
  return data;
};

/*
 * Select a row frsom code
 * @param row {HTMLElement} the row element
 * @return
 */
var largeTableDoRowSelect = function largeTableDoRowSelect(rowElement, select) {
  if (select == null) {
    select = true;
  }
  var checkbox = window.Dom.getElementsBy(function (node) {
    return window.Dom.hasClass(node, 'checkbox');
  }, 'input', rowElement);
  if (checkbox[0]) {
    checkbox[0].checked = select;
    window.YAHOO.fcom.Event.fireEvent(checkbox[0], 'changeAuto');
    largeTableRowSelect(checkbox[0]);
  }
};

/*
 * For private use by LargeTable only.
 * Handles the click on the top selection checkbox for all rows
 */
var largeTableAllSelect = function largeTableAllSelect(element) {
  var table = largeTableGetOuterElement(element);
  var checkboxes = largeTableGetCheckboxes(table);
  var numSelected = 0;
  for (var i in checkboxes) {
    var checkbox = checkboxes[i];
    if (checkbox != null) {
      checkbox.checked = element.checked;
      window.YAHOO.fcom.Event.fireEvent(checkbox, 'changeAuto');
      numSelected++;
    }
  }
  if (!element.checked) {
    numSelected = 0;
  }
  largeTableUpdateSpecificButtonStates(table, numSelected);
};

/*
 * Returns the TABLE element enclosing a LargeTable. No other TABLE elements must be in
 *   the hierarchy tree between tha LargeTable TABLE root and the 'element' leaf.
 * @param {HTMLElement} element the TABLE element or any child of it. Must not be any of the buttons
 *   residing below the table.
 * @return the TABLE element enclosing a LargeTable
 */
var largeTableGetOuterElement = function largeTableGetOuterElement(element) {
  if (element.tagName.toUpperCase() === 'TABLE') {
    return element;
  }
  if (element == null || element.parentNode == null || element.parentNode.parentNode == null) {
    element = window.genericYUIButton.get('element');
  }
  while (element != null && element.tagName !== 'TABLE') {
    element = element.parentNode;
  }
  return element;
};

/*
 * For private use by LargeTable only.
 * returns an array with all selected <tr> elements of the largeTable.
 * tableElement must be set to the <table> element of the LargeTable itself.
 */
var largeTableGetSelectedTRs = function largeTableGetSelectedTRs(tableElement) {
  var result = [];
  if (tableElement == null) {
    return result;
  }
  _toConsumableArray(tableElement.getElementsByTagName('TR')).forEach(function (row) {
    var columns = row.getElementsByTagName('TD');
    if (columns.length > 0) {
      var column = columns[columns.length - 1];
      var inputs = window.Dom.getElementsBy(function () {
        return true;
      }, 'input', column);
      if (inputs.length === 1 && inputs[0].checked) {
        result[result.length] = row;
      }
    }
  });
  return result;
};

/*
 * For private use by LargeTable only.
 * returns an array with all SpecificButton elements residing in the table
 * which have a permission for the requested url.
 * tableElement must be set to the <table> element of the LargeTable itself.
 */
var largeTableGetSpecificButtons = function largeTableGetSpecificButtons(tableElement) {
  var result = [];
  if (tableElement == null) {
    return result;
  }
  var element = tableElement.parentNode.parentNode;
  if (element == null) {
    return result;
  }
  var children = element.getElementsByTagName('DIV');
  element = null;
  var i;
  var child;
  for (i in children) {
    child = children[i];
    if (child.className === 'tableButtonBar') {
      element = child;
      break;
    }
  }
  if (element == null) {
    return result;
  }
  children = element.getElementsByTagName('DIV');
  element = null;
  for (i in children) {
    child = children[i];
    if (child.className === 'specificButtons') {
      element = child;
      break;
    }
  }
  if (element == null) {
    return result;
  }
  return window.Dom.getElementsBy(function (node) {
    var buttonValue = window.YAHOO.fcom.Forms.getButtonProperty(node, 'value');
    var testPermission = new RegExp('-hasPermission-');
    return testPermission.test(buttonValue);
  }, 'button', element);
};

/*
 * For private use by LargeTable only.
 * updates the enabled/disabled state of all specific buttons of a single LargeTable.
 * tableElement must be set to the <table> element of the LargeTable itself.
 */
var largeTableUpdateSpecificButtonStates = function largeTableUpdateSpecificButtonStates(tableElement, numSelectedLines) {
  var buttons = largeTableGetSpecificButtons(tableElement);
  if (numSelectedLines < 1) {
    buttons.forEach(function (button) {
      window.YAHOO.fcom.Forms.setButtonDisabled(button, true);
    });
  } else if (numSelectedLines === 1) {
    buttons.forEach(function (button) {
      window.YAHOO.fcom.Forms.setButtonDisabled(button, false);
    });
  } else {
    var testSingle = new RegExp('-single$');
    buttons.forEach(function (button) {
      var buttonValue = window.YAHOO.fcom.Forms.getButtonProperty(button, 'value');
      window.YAHOO.fcom.Forms.setButtonDisabled(button, testSingle.test(buttonValue));
    });
  }
};

/*
 * Triggers a download of a table as an CSV file
 */
var largeTableCsvExport = function largeTableCsvExport(tableId) {
  var form = getLargeTableExportForm(tableId);
  var url = "".concat(window.ctx, "/csv.action?method=handleLargeTable");
  form.action = url;
  form.method = 'POST';
  form.submit();
};

/*
 * Triggers a download of a table as an Excel or csv file
 */
var largeTableExcelExport = function largeTableExcelExport(tableId, exportType) {
  var isExternalExportFunction = Object.prototype.hasOwnProperty.call(externalLargeTableExportHandler, tableId);
  if (isExternalExportFunction) {
    externalLargeTableExportHandler[tableId].call(_this, tableId, exportType);
    return;
  }
  if (exportType === 'CSV') {
    largeTableCsvExport(tableId);
  } else {
    var form = getLargeTableExportForm(tableId);
    var formulaSupport = exportType === 'FIDL';
    var url = "".concat(window.ctx, "/excel.action?method=handleLargeTable&formulaSupport=").concat(formulaSupport);
    form.action = url;
    form.method = 'POST';
    form.submit();
  }
};

/*
 * Creates a form which can export any large Table data.
 */
var getLargeTableExportForm = function getLargeTableExportForm(tableId) {
  var tablePersist = document.getElementById("".concat(tableId, "-persist"));
  var form;
  if (tablePersist.form && tablePersist.form != null) {
    form = tablePersist.form;
  } else {
    form = document.createElement('form');
    tablePersist.parentNode.insertBefore(form, tablePersist);
    form.appendChild(tablePersist);
  }
  return form;
};

/*
 * For private use by LargeTable only.
 * returns an array with all selection checkbox elements residing in the righmost table column.
 * tableElement must be set to the <table> element of the LargeTable itself.
 */
var largeTableGetCheckboxes = function largeTableGetCheckboxes(tableElement) {
  return _toConsumableArray(tableElement.getElementsByTagName('TR')).map(function (row) {
    var columns = row.getElementsByTagName('TD');
    if (columns.length > 0) {
      var column = columns[columns.length - 1];
      var inputs = window.Dom.getElementsBy(function () {
        return true;
      }, 'input', column);
      if (inputs.length === 1) {
        return inputs[0];
      }
    }
    return null;
  }).filter(function (f) {
    return f;
  });
};

/*
 * @private
 * @param {HTMLElement} tableElement
 */
var largeTableGetAllSelector = function largeTableGetAllSelector(tableElement) {
  var checkboxes = window.Dom.getElementsBy(function (node) {
    return node.name && node.name.indexOf('largeTableAllSelector') > -1;
  }, 'input', tableElement);
  if (checkboxes.length > 0) {
    return checkboxes[0];
  }
};

/*
 * @private
 * @param {HTMLElement} $activeElement - last active element
 * @param {HTMLElement} $container - large table container
 */
var setFocusToActiveElement = function setFocusToActiveElement($activeElement, $container, params) {
  var sortKeys = Object.keys(params || {});

  // #. To identify the event is for applying the sorting
  if ($activeElement.is('th') && sortKeys.indexOf('reSort') !== -1) {
    var index = $activeElement.index();
    var $column = $($container.find('table th')[index]);
    if ($column && $column.length > 0) {
      $column.find('button.icon.sortButton').focus();
    }
  } else if ($activeElement.is('select')) {
    var $select = $container.find('[name="' + $activeElement.attr('name') + '"]');
    if ($select.length === 0) {
      $select = $container.find('[name="' + $activeElement.attr('id') + '"]');
    }

    // #. Get the select2 control
    var $select2 = $select.next('.select2');
    // #. Set focus to the selection region
    $select2.find('.select2-selection').focus();
  }
};

/*
 * Automatically updates the given LargeTable via Ajax.
 * @param tableChildElement any child html element of the given LargeTable
 *   (may also be a large button or specific button)
 * @param {Function} callback a function which takes one parameter that is the response object of the
 *   ajax call. It holds several attributes. "status" e.g. can be used to find out about the
 *   success of the call. If status is 200 everything is ok. "responseText" holds the server answer, that
 *   can be checked on length or parsed for any other purpose. The callback will be called
 *   after the table is updated.
 * @param params a list of parameters which shall be changed in the LargeTable on this
 *   call, given in named array form. E.g. params[pageNumber] = 0, params[perPage] = 20.
 * @param {Boolean} contentOnly Default: <tt>false</tt>. If set to <tt>true</tt>, only the content of the table
 *      will be refreshed.
 * @return nothing
 */
var largeTableUpdate = function largeTableUpdate(tableChildElement, callback, params) {
  var id = largeTableFindIdByChildNode(tableChildElement);
  var $activeElement = $(tableChildElement);
  var isExternalTable = externalLargeTableUpdateHandler.hasOwnProperty(id);
  var $largeTable = $activeElement.closest('.largeTable');
  var $container = isExternalTable ? $largeTable.closest('.moduleContent') : $largeTable;
  if (isExternalTable) {
    externalLargeTableUpdateHandler[id].call(_this, id, function () {
      if (callback) {
        callback.apply(void 0, arguments);
      }
      setFocusToActiveElement($activeElement, $container, params);
    }, params);
    return;
  }
  var tablePersist = window.Dom.get("".concat(id, "-persist"));
  var url = '/ajax.action?method=getLargeTable';
  var postData = 'largeTablePersist=';
  if (tablePersist) {
    postData += encodeURIComponent(tablePersist.value);
  }
  if (params != null) {
    for (var i in params) {
      if (i && i != null) {
        postData += "&".concat(i, "=").concat(encodeURIComponent(params[i]));
      }
    }
  }
  var callbackFn = function callbackFn() {
    if (callback) {
      callback.apply(void 0, arguments);
    }
    try {
      window.YAHOO.fcom.Streaming.updateServerTimestamp();
    } catch (e) {
      // not all pages have a server timestamp on the page
    }
    window.YAHOO.fcom.Event.fireEvent(window.Dom.get(id), 'largeTableUpdate');
    setFocusToActiveElement($activeElement, $container, params);
  };
  window.replaceAsync(url, id, {
    callback: callbackFn,
    replaceEmpty: true,
    showWait: true,
    postData: postData,
    updateParams: params
  });
};

// for private use by LargeTable
var largeTablePageUpdate = function largeTablePageUpdate(tableChildElement, pageNo) {
  var params = {};
  params.pageNumber = pageNo;
  largeTableUpdate(tableChildElement, null, params);
};

/*
 * Refresh or Reload the Large table with the given id, with its current state.
 * None of the Paging or Sorting parameters changed. Only the content is
 * updated.
 *
 * @param id
 *            The unique id of the large table to be refreshed.
 * @param params a list of parameters which shall be changed in the LargeTable on this
 *   call, given in named array form. E.g. params[pageNumber] = 0, params[perPage] = 20.
 */
var largeTableRefresh = function largeTableRefresh(id, params) {
  var tablePersist = window.Dom.get("".concat(id, "-persist"));
  var url = '/ajax.action?method=getLargeTable';
  var postData = 'largeTablePersist=';
  if (tablePersist) {
    postData += encodeURIComponent(tablePersist.value);
  }
  if (!window.YAHOO.lang.isUndefined(params)) {
    for (var i in params) {
      if (i && i != null) {
        postData += "&".concat(i, "=").concat(encodeURIComponent(params[i]));
      }
    }
  }
  var callbackFn = function callbackFn() {
    window.YAHOO.fcom.Event.fireEvent(window.Dom.get(id), 'largeTableUpdate');
  };
  window.replaceAsync(url, id, {
    'callback': callbackFn,
    'replaceEmpty': true,
    'showWait': true,
    postData: postData
  });
};

/*
 * Find rows that contain a certain value for a fidlet.
 * @param tableElement {HTMLElement}
 * @param fidletKey {String} the fidlet key
 * @param value {Object} finds all rows where key has this value
 * @return  {Array} array containing rows that match the key
 */
var largeTableFindRow = function largeTableFindRow(tableElement, fidletKey, value) {
  var tableId = tableElement.id;
  var dataRows = window.Dom.getElementsBy(function (node) {
    if (node.id.indexOf(tableId) === 0) {
      var map = largeTableDecodeIdEncoding(node.id);
      if (map[fidletKey] != null && map[fidletKey] === value) {
        return true;
      }
    }
    return false;
  }, 'tr', tableElement);
  return dataRows;
};
var saveLargeTableState = function saveLargeTableState(pageId, arg, callBackFn) {
  if (window.YAHOO.lang.isUndefined(callBackFn)) {
    callBackFn = function callBackFn() {};
  }
  var updateParams = arg.argument[0].updateParams;
  var pageSettingsAttribute;
  if (!window.YAHOO.lang.isUndefined(updateParams.noFidsSort) && updateParams.noFidsSort) {
    pageSettingsAttribute = {
      noFidsSort: true
    };
    window.savePageSettings(pageId, pageSettingsAttribute, false, callBackFn);
  } else if (!window.YAHOO.lang.isUndefined(updateParams.reSort)) {
    pageSettingsAttribute = {
      sortColumns: [updateParams.reSort],
      sortOrder: [updateParams.nowSorted],
      noFidsSort: false
    };
    window.savePageSettings(pageId, pageSettingsAttribute, false, callBackFn);
  }
};
var addLargeTableObserver = function addLargeTableObserver() {
  function LargeTableObserver() {
    var _this2 = this;
    this.registered = {};
    this.setEvent = function (tableId, cfg) {
      if (cfg.once) {
        $("#".concat(tableId, " ").concat(cfg.elementSelector)).one(cfg.eventType, cfg.eventHandler);
      } else {
        $("#".concat(tableId, " ").concat(cfg.elementSelector)).on(cfg.eventType, cfg.eventHandler);
      }
    };
    this.onLargeTableReloaded = function (tableId) {
      var registeredEvents = _this2.registered[tableId];
      if (registeredEvents) {
        for (var i = 0; i < registeredEvents.length; i++) {
          _this2.setEvent(tableId, registeredEvents[i]);
        }
      }
      if (!window.positionStickySupport) {
        var $tableElem = $("#".concat(tableId));
        $tableElem.find('.large-table-sticky-header').freezeTable({
          freezeColumn: false,
          backgroundColor: false
        });
      }
    };
    this.registerElement = function (tableId, elementSelector, eventType, eventHandler, fireOnlyOnce) {
      if (!_this2.registered[tableId]) {
        _this2.registered[tableId] = [];
      }
      if (typeof eventType === 'string' && typeof elementSelector === 'string' && typeof eventHandler === 'function') {
        var config = {
          elementSelector: elementSelector,
          eventType: eventType,
          eventHandler: eventHandler,
          once: fireOnlyOnce === true
        };
        _this2.registered[tableId].push(config);
        _this2.setEvent(tableId, config);
      } else {
        // eslint-disable-next-line
        console.warn('largeTableObserver: registering of element failed! ');
      }
    };
    this.unregisterElement = function (tableId, elementSelector, eventType) {
      var registeredEvents = _this2.registered[tableId];
      if (registeredEvents) {
        if (!elementSelector && !eventType) {
          // if no elementSelector and eventType is given, unregister all events of the table.
          for (var i = 0; i < registeredEvents.length; i++) {
            var o = registeredEvents[i];
            $("#".concat(tableId, " ").concat(o.elementSelector)).off(o.eventType, o.eventHandler);
            registeredEvents[i].eventHandler = null;
          }
          delete _this2.registered[tableId];
        }
        // TODO implementation of deeper unregister options
      }
    };

    var onLargeTableReloaded = this.onLargeTableReloaded.bind(this);
    $(window).on('largeTableLoaded', function (evt) {
      onLargeTableReloaded(evt.id);
    });
  }
  if (!window.largeTableObserver) {
    window.largeTableObserver = new LargeTableObserver();
  }
};
var getLargeTableState = function getLargeTableState(tableId) {
  var $tablePersist = $("#".concat(tableId, "-sub"));
  var data = null;
  if ($tablePersist) {
    data = $tablePersist.data('table');
    data = typeof data === 'string' ? JSON.parse(data) : null;
  }
  return data;
};
var largeTableExternUpdateHandler = function largeTableExternUpdateHandler(tableId, handlerFunction) {
  externalLargeTableUpdateHandler[tableId] = handlerFunction;
};
var largeTableExternExportHandler = function largeTableExternExportHandler(tableId, handlerFunction) {
  externalLargeTableExportHandler[tableId] = handlerFunction;
};
var _default = exports.default = {
  largeTableRow: largeTableRow,
  largeTableSelected: largeTableSelected,
  largeTableRowSelect: largeTableRowSelect,
  largeTableGetData: largeTableGetData,
  largeTableDoRowSelect: largeTableDoRowSelect,
  largeTableAllSelect: largeTableAllSelect,
  largeTableCsvExport: largeTableCsvExport,
  largeTableExcelExport: largeTableExcelExport,
  largeTableGetCheckboxes: largeTableGetCheckboxes,
  largeTableUpdate: largeTableUpdate,
  largeTablePageUpdate: largeTablePageUpdate,
  largeTableRefresh: largeTableRefresh,
  largeTableFindRow: largeTableFindRow,
  saveLargeTableState: saveLargeTableState,
  addLargeTableObserver: addLargeTableObserver,
  getLargeTableState: getLargeTableState,
  largeTableExternUpdateHandler: largeTableExternUpdateHandler,
  largeTableExternExportHandler: largeTableExternExportHandler
};
window.largeTableRow = largeTableRow;
window.largeTableSelected = largeTableSelected;
window.largeTableRowSelect = largeTableRowSelect;
window.largeTableGetData = largeTableGetData;
window.largeTableDoRowSelect = largeTableDoRowSelect;
window.largeTableAllSelect = largeTableAllSelect;
window.largeTableCsvExport = largeTableCsvExport;
window.largeTableExcelExport = largeTableExcelExport;
window.largeTableGetCheckboxes = largeTableGetCheckboxes;
window.largeTableUpdate = largeTableUpdate;
window.largeTablePageUpdate = largeTablePageUpdate;
window.largeTableRefresh = largeTableRefresh;
window.largeTableFindRow = largeTableFindRow;
window.saveLargeTableState = saveLargeTableState;
window.addLargeTableObserver = addLargeTableObserver;
window.getLargeTableState = getLargeTableState;
window.largeTableObserver = null;
window.largeTableExternUpdateHandler = largeTableExternUpdateHandler;
window.largeTableExternExportHandler = largeTableExternExportHandler;

},{}],29:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _this = void 0;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/*
 * Provides a tool class for handling modules on views, their config and similar things
 *
 */
var YAHOO = window.YAHOO;
var Dom = YAHOO.util.Dom;
var editColumnDialog = function editColumnDialog(moduleId, conf) {
  var doReload = conf.doReload;
  var maximized = !!conf.maximized;
  var method = maximized ? 'selectModuleMaximizedColumnConfigPage' : 'selectModuleColumnConfigPage';
  var moduleDiv = window.Dom.get(moduleId);
  var moduleContainer = window.YAHOO.fcom.Page.getInstance('moduleContainer');
  if (moduleDiv && moduleDiv != null) {
    window.Dom.addClass(moduleDiv, 'inProcess');
  }
  var url = isAdminMode() ? 'admin/module/admin.action' : 'module.action';
  var postData = {
    method: method,
    moduleId: moduleId,
    viewId: moduleContainer.id
  };
  if (isAdminMode()) {
    var adminData = moduleContainer.config.adminData.split('&').map(function (a) {
      return a.split('=');
    }).reduce(function (all, _ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
      all[key] = "".concat(value);
      return all;
    }, {});
    postData = Object.assign(postData, adminData);
  }
  var panelId = 'chooseColumnPanel';
  var config = {
    url: url
  };
  window.YAHOO.lang.augmentObject(config, window.YAHOO.fcom.panel.AJAXPanel.CHOOSE_COLUMN_PANEL);
  window.YAHOO.fcom.panel.PanelFactory.getAJAXPanel(config, {
    fn: function fn( /* YAHOO.fcom.panel.ChooseColumnPanel */panel) {
      var params = window["".concat(panelId, "_baseParams")];
      var maxSortOrders = 3;
      if (params.context.inputId) {
        params.fidlets = window.JSON.parse(window.Dom.get(params.context.inputId).value);
      }
      if (params.context.lockSettingId) {
        var lockSettingInput = window.Dom.get(params.context.lockSettingId);
        if (lockSettingInput) {
          params.lockedFidlets = window.JSON.parse(lockSettingInput.value);
        }
      }
      params.sortingFidlets = [];
      params.sortingOrder = [];
      var countSorting = 0;
      for (var i = 1; i <= maxSortOrders; i++) {
        var sortingKey = params.context["sortingId".concat(i)];
        var sortingOrderKey = params.context["sortingOrderId".concat(i)];
        if (sortingKey && sortingOrderKey && window.Dom.get(sortingKey)) {
          if (window.Dom.get(sortingKey).value) {
            params.sortingFidlets.push(window.Dom.get(sortingKey).value);
            params.sortingOrder.push(window.Dom.get(sortingOrderKey).value);
          }
          countSorting++;
        } else {
          break;
        }
      }
      params.countSorting = countSorting;
      params.callback = function (result) {
        var _postData;
        if (params.context.inputId && result.fidlets && result.fidlets.length > 0) {
          window.Dom.get(params.context.inputId).value = window.JSON.stringify(result.fidlets);
        } else {
          window.ngpAlert(window.getMessage('module.dialog.configure.errorNoColumn'));
          return;
        }
        if (params.context.lockSettingId && result.lockedColumns && result.lockedColumns.length > 0) {
          var _lockSettingInput = window.Dom.get(params.context.lockSettingId);
          if (_lockSettingInput) {
            _lockSettingInput.value = window.JSON.stringify(result.lockedColumns);
          }
        }
        for (var _i = 1; _i <= countSorting; _i++) {
          var _sortingKey = params.context["sortingId".concat(_i)];
          var _sortingOrderKey = params.context["sortingOrderId".concat(_i)];
          if (_sortingKey && _sortingOrderKey) {
            if (result.sortingFidlets && result.sortingFidlets.length > _i - 1 && result.sortingOrder && result.sortingOrder.length > _i - 1) {
              window.Dom.get(_sortingKey).value = result.sortingFidlets[_i - 1];
              window.Dom.get(_sortingOrderKey).value = result.sortingOrder[_i - 1];
            } else {
              window.Dom.get(_sortingKey).value = '';
              window.Dom.get(_sortingOrderKey).value = 'true';
            }
          }
        }
        var postData = (_postData = {}, _defineProperty(_postData, conf.maximized ? 'columnSelectionStringMaximized' : 'columnSelectionString', result.fidlets), _defineProperty(_postData, "columnLockSelectionString", result.lockedColumns), _postData);
        window.YAHOO.fcom.modules.Tools.sendModuleConfigForm('moduleChangeColumnsForm', postData, panelId, conf.doReload, conf.callback);
        return false;
      };
      if (doReload) {
        panel.panel.hideEvent.subscribe(function hideEventHandler() {
          window.Dom.removeClass(moduleDiv, 'inProcess');
          //unsubscribe
          this.hideEvent.unsubscribe('hide', hideEventHandler, this);
        }, panel.panel, true);
      }
      panel.initDynamicData(params);
      panel.show();
      panel.panel.center();
    }
  }, postData);
};
var editModuleDialog = function editModuleDialog(moduleId) {
  var overwriteConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var moduleDiv = window.Dom.get(moduleId);
  var moduleContainer = window.YAHOO.fcom.Page.getInstance('moduleContainer');
  if (moduleDiv && moduleDiv != null) {
    window.Dom.addClass(moduleDiv, 'inProcess');
  }
  var url = isAdminMode() ? '/admin/module/admin.action' : '/module.action';
  if (moduleId.startsWith(moduleContainer.id)) {
    moduleId = moduleId.slice(moduleContainer.id.length + 1, moduleId.length);
  }
  var postData = "method=selectModuleConfigPage&moduleId=".concat(moduleId, "&viewId=").concat(moduleContainer.id);
  if (isAdminMode()) {
    postData += moduleContainer.config.adminData;
    postData += '&isAdmin=true';
  }
  var panelConfig = Object.assign({
    width: '450px',
    fixedcenter: false,
    x: window.Dom.getViewportWidth() / 3,
    y: 150,
    visible: false,
    close: true,
    dragOnly: true,
    draggable: true,
    constraintoviewport: true,
    modal: true
  }, overwriteConfig);
  window.fillPanelFromAjax('editModulePanel', url, postData, panelConfig, {
    instanceHandler: function instanceHandler(panel, moduleDiv) {
      panel.hideEvent.subscribe(function hideEventHandler() {
        window.Dom.removeClass(moduleDiv, 'inProcess');
        //unsubscribe
        this.hideEvent.unsubscribe('hide', hideEventHandler, this);
      }, panel, true);
    },
    failureHandler: function failureHandler(moduleDiv) {
      window.ngpAlert(window.getMessage('module.dialog.configure.errorOpening'));
      window.Dom.removeClass(moduleDiv, 'inProcess');
    },
    customObject: moduleDiv,
    show: true
  });
};
var editColumnConfigDialog = function editColumnConfigDialog(moduleId) {
  var overwriteConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var moduleDiv = window.Dom.get(moduleId);
  var moduleContainer = window.YAHOO.fcom.Page.getInstance('moduleContainer');
  if (moduleDiv && moduleDiv != null) {
    window.Dom.addClass(moduleDiv, 'inProcess');
  }
  var url = isAdminMode() ? '/admin/module/admin.action' : '/module.action';
  if (moduleId.startsWith(moduleContainer.id)) {
    moduleId = moduleId.slice(moduleContainer.id.length + 1, moduleId.length);
  }
  var postData = "method=selectModuleColumnConfigPage&moduleId=".concat(moduleId, "&viewId=").concat(moduleContainer.id);
  if (isAdminMode()) {
    postData += moduleContainer.config.adminData;
    postData += '&isAdmin=true';
  }
  var panelConfig = Object.assign({
    width: '450px',
    fixedcenter: false,
    x: window.Dom.getViewportWidth() / 3,
    y: 150,
    visible: false,
    close: true,
    dragOnly: true,
    draggable: true,
    constraintoviewport: true,
    modal: true
  }, overwriteConfig);
  window.fillPanelFromAjax('editModulePanel', url, postData, panelConfig, {
    instanceHandler: function instanceHandler(panel, moduleDiv) {
      panel.hideEvent.subscribe(function hideEventHandler() {
        window.Dom.removeClass(moduleDiv, 'inProcess');
        //unsubscribe
        this.hideEvent.unsubscribe('hide', hideEventHandler, this);
      }, panel, true);
    },
    failureHandler: function failureHandler(moduleDiv) {
      window.ngpAlert(window.getMessage('module.dialog.configure.errorOpening'));
      window.Dom.removeClass(moduleDiv, 'inProcess');
    },
    customObject: moduleDiv,
    show: true
  });
};

/*
 * Centralized function to send the Form of a module configuration dialog.
 * Error and success handling can be adjusted in one place.
 * Configuration changes have been refactored on serverside to one method.
 * @param {String} name of the form
 * @param {String} postData will be merged with form data
 */
var sendModuleConfigForm = function sendModuleConfigForm(name, postData, panelId, doReload, callback) {
  if (doReload == null) {
    doReload = true;
  }
  var form = document.forms[name];
  var url = form.action;
  panelId = panelId || 'editModulePanel';
  window.ngpAsyncRequest('POST', url, {
    success: function success() {
      if (window.opener) {
        try {
          if (window.opener.popupInstances && window.opener.popupInstances[panelId]) {
            window.opener.location.reload();
          }
        } catch (e) {
          // opener seems to be wrong , no access to variables allowed
        }
      }
      window.hidePanel(panelId);
      if (doReload) {
        var moduleId = form.moduleId.value;
        var viewId = form.viewId.value;
        if (moduleId.startsWith(viewId)) {
          moduleId.slice(viewId.length + 1, moduleId.length);
        }
        var itemElement = Dom.get(moduleId);
        if (itemElement === null) {
          window.location.reload();
        } else {
          var _url = "/view.action?method=getModule&moduleId=".concat(moduleId, "&viewId=").concat(viewId, "&popout=").concat(YAHOO.fcom.viewInfo.isPopoutMode);
          var params = {
            replaceContainer: true,
            callback: function callback() {
              var columnContainer = YAHOO.fcom.Page.getInstance('moduleContainer');
              columnContainer.updateItem(moduleId);
              window.viewChangedEvent ? window.viewChangedEvent.fire() : null;
            }
          };
          window.replaceAsync(_url, itemElement, params, true, true);
        }
      } else if (callback) {
        callback();
      }
    },
    failure: function failure() {},
    waitMask: panelId
  }, postData, form);
};

/*
 * this function is for sending extended watchlist configuration, used from
 */
var prepareWatchListModuleConfigSending = function prepareWatchListModuleConfigSending() {
  var values = window.YAHOO.fcom.modules.Tools.getSelectedColumns('watchlistSettings', 'li', 'yuimenuitem-checked');
  if (!values.length) {
    window.ngpAlert(window.getMessage('module.dialog.configure.extendedWatchlist.noWatchlist'));
    return;
  }
  var postData = window.YAHOO.fcom.Util.arrayToParam(values, 'watchListSelectionString');
  window.YAHOO.fcom.modules.Tools.sendConfigurationForModule('moduleChangeForm', postData);
};
var preparePeerListModuleConfigSending = function preparePeerListModuleConfigSending() {
  var values = window.YAHOO.fcom.modules.Tools.getSelectedColumns('peerListSettings', 'li', 'yuimenuitem-checked');
  if (!values.length) {
    window.ngpAlert(window.getMessage('module.dialog.configure.extendedWatchlist.noWatchlist'));
    return;
  }
  var postData = window.YAHOO.fcom.Util.arrayToParam(values, 'watchListSelectionString');
  window.YAHOO.fcom.modules.Tools.sendConfigurationForModule('moduleChangeForm', postData);
};
var prepareRssModuleConfigSending = function prepareRssModuleConfigSending() {
  var postData = null;
  var values = window.YAHOO.fcom.modules.Tools.getSelectedColumns('feedSettings', 'li', 'yuimenuitem-checked');
  if (values != null && values.length > 0) {
    postData = window.YAHOO.fcom.Util.arrayToParam(values, 'watchListSelectionString');
  }
  window.YAHOO.fcom.modules.Tools.sendConfigurationForModule('moduleChangeForm', postData);
};
var sendConfigurationForModule = function sendConfigurationForModule(formName, postData) {
  postData != null ? postData += '&' : postData = '';
  /* see if there is a ric popup search that might be altered so far: */
  if (!window.YAHOO.lang.isUndefined(document.forms[formName].ric) && !window.YAHOO.lang.isUndefined(document.forms[formName].lastSearchInputFieldValue) && !window.YAHOO.lang.isUndefined(document.forms[formName].searchInputField)) {
    try {
      if (document.forms[formName].lastSearchInputFieldValue.value !== document.forms[formName].searchInputField.value) {
        /* changed */
        document.forms[formName].lastSearchInputFieldValue.value = '*waiting*for*popupsearch*result*';
        window.YAHOO.fcom.InstrumentsSearchDialog.openFromIcon(formName);
        window.YAHOO.fcom.modules.Tools.sendAfterRicKnown(formName, document.forms[formName].lastSearchInputFieldValue, document.forms[formName].searchInputField, postData);
        return false;
      }
    } catch (e) {
      //do nothing
    }
  }
  window.YAHOO.fcom.modules.Tools.sendModuleConfigForm(formName, postData);
  return true;
};

/*
 * Update a module's configuration (without form and page reload)
 *
 * @param {String} moduleId
 * @param {Object} moduleConfig
 */
var updateConfigurationForModule = function updateConfigurationForModule(moduleId, moduleConfig) {
  if (moduleId.startsWith(window.YAHOO.fcom.viewInfo.name)) {
    moduleId = moduleId.slice(window.YAHOO.fcom.viewInfo.name.length + 1, moduleId.length);
  }
  var postData = {
    method: 'changeModule',
    moduleId: moduleId,
    viewId: window.YAHOO.fcom.viewInfo.name,
    viewOrgId: window.YAHOO.fcom.viewInfo.viewOrgId,
    viewProfile: window.YAHOO.fcom.viewInfo.viewProfile,
    isAdmin: window.YAHOO.fcom.viewInfo.isAdmin
  };
  var url = isAdminMode() ? '/admin/module/admin.action' : '/module.action';
  window.YAHOO.lang.augmentObject(postData, moduleConfig);
  return window.ngpAsyncRequest('POST', url, {
    silent: true
  }, postData);
};

/*
    TAKE CARE EVERYBODY, THIS CODE IS FUNKY! boolean parameters with string type,
    reprogramming YUI-menues using css classes...

    Function that sends the form on a module edit dialog with a column selection
    @param {String} formName: The name of the form
    @param menuId : id of the selection list
    @param postData:
    @return returns true when check was successful, else false
*/
var setColumnConfigurationForModule = function setColumnConfigurationForModule(formName, menuId, postData, panelId, conf) {
  var errorMsg = window.getMessage('module.dialog.configure.errorNoColumn');
  var selectedValues = window.YAHOO.fcom.modules.Tools.getSelectedColumns(menuId, 'li', 'yuimenuitem-checked');
  var doReload;
  var maximized;
  var callback;
  var minColumnsSelected = 1;
  if (conf) {
    doReload = conf.doReload;
    maximized = conf.maximized;
    callback = conf.callback;
    if (conf.minColumnsSelected != null) {
      minColumnsSelected = conf.minColumnsSelected;
    }
  }

  // check if at least one column is selected
  if (minColumnsSelected > 1 && selectedValues.length < minColumnsSelected) {
    window.ngpAlert(window.getMessage('module.dialog.configure.errorNotEnoughColumn').replace('{0}', minColumnsSelected));
    return false;
  } else if (!selectedValues.length) {
    window.ngpAlert(errorMsg);
    return false;
  } else {
    postData != null ? postData += '&' : postData = '';
    postData += window.YAHOO.fcom.Util.arrayToParam(selectedValues, maximized ? 'columnSelectionStringMaximized' : 'columnSelectionString');
    /* see if there is a ric popup search that might be altered so far: */
    if (!window.YAHOO.lang.isUndefined(document.forms[formName].ric) && !window.YAHOO.lang.isUndefined(document.forms[formName].lastSearchInputFieldValue) && !window.YAHOO.lang.isUndefined(document.forms[formName].searchInputField)) {
      try {
        if (document.forms[formName].lastSearchInputFieldValue.value !== document.forms[formName].searchInputField.value) {
          /* changed */
          document.forms[formName].lastSearchInputFieldValue.value = '*waiting*for*popupsearch*result*';
          window.YAHOO.fcom.InstrumentsSearchDialog.openFromIcon(formName);
          window.YAHOO.fcom.modules.Tools.sendAfterRicKnown(formName, document.forms[formName].lastSearchInputFieldValue, document.forms[formName].searchInputField, postData);
          return false;
        }
      } catch (e) {
        //do nothing
      }
    }
    window.YAHOO.fcom.modules.Tools.sendModuleConfigForm(formName, postData, panelId, doReload, callback);
    return true;
  }
};

/*
 * Returns an array of selected values from a column selection list created by the jsp tags
 * <code>moduleEditColumnSelect and</code>, <code>moduleEditWatchlistSelect and</code>
 * and <code>viewColumnConfig</code>. Maybe it would be nice to make a widget for that.
 *
 *  @param {HTMLElement|String} listEl the element that includes the selectable items or its id.
 *  @param {String} htmlTag the tag to identify the single selectable items.
 *  The id of the item element must follow the pattern "htmlTag__{column.uniqueName}".
 *  @param {String} clsChecked the css class that marks an item as checked
 *  @return {Array}
 */
var getSelectedColumns = function getSelectedColumns(listEl, htmlTag, clsChecked) {
  var tag = window.Dom.get(listEl);
  if (tag && tag.tagName.toLowerCase() === 'input') {
    return window.JSON.parse(tag.value);
  }
  var selectedCols = window.Dom.getElementsByClassName(clsChecked, htmlTag, listEl);
  var selectedValues = [];
  selectedCols.forEach(function (element) {
    var value = element.id.split('__');
    if (window.YAHOO.lang.isArray(value) && value.length > 0) {
      value = value[1];
      selectedValues.push(value);
    }
  });
  return selectedValues;
};

/*
 * small hack function for the big hack function setColumnConfigurationForModule(...)
 * this function here will check whether the two given compare fields have identical values
 * (which means the popup search returned) and when they have, then the form is send. When this whole search-popup
 * thing is rebuild using object oriented style, also this should be rebuild using proper event handling.
 * @param formName the form's name to be send
 * @param compareField1 the inputfield number one
 * @param compareFiled2 the input field number two which has to have the same value as the first, for the form to be sent.
 * @return nothing
 */
var sendAfterRicKnown = function sendAfterRicKnown(formName, compareField1, compareFiled2, postData) {
  if (compareField1.value !== compareFiled2.value) {
    window.YAHOO.lang.later(300, null, function (params) {
      window.YAHOO.fcom.modules.Tools.sendAfterRicKnown(params[0], params[1], params[2], params[3]);
    }, [[formName, compareField1, compareFiled2, postData]], false);
  } else {
    window.YAHOO.fcom.modules.Tools.sendModuleConfigForm(formName, postData);
  }
};
var editFeedEntry = function editFeedEntry(moduleId, entryId, profile, orgId, isAdmin) {
  var checkedEntries = window.YAHOO.util.Selector.query("#".concat(moduleId, "_edit_feeds .yuimenuitem.yuimenuitem-checked"));
  var checkedIds = checkedEntries.map(function (checkedEntry) {
    return checkedEntry.getAttribute('data-feedid');
  }).reduce(function (all, a) {
    all[a] = true;
    return all;
  }, {});
  var callback = {
    success: function success(response) {
      var obj = window.JSON.parse(response.responseText);
      var data = null;
      for (var i = 0; i < obj.length; i++) {
        if (obj[i].id === entryId) {
          data = obj[i];
          break;
        }
      }
      if (data == null) {
        window.ngpAlert(window.getMessage('rssModule.js.feedDataNotFound'));
        return;
      }
      window.YAHOO.fcom.panel.PanelFactory.getAJAXPanel(window.YAHOO.fcom.panel.AJAXPanel.EDIT_RSS_FEED, {
        fn: function fn(panel) {
          panel.data.set('feedName', data.name, true);
          panel.data.set('feedUrl', data.url, true);
          panel.hideErrorMessage();
          if (isAdmin) {
            // use other controller when admin system is used.
            panel.onSave.subscribe(panel.editFeedAdmin, {
              listName: 'rss_feed_list_default',
              profile: profile,
              orgId: orgId,
              index: entryId
            }, panel);
          } else {
            panel.onSave.subscribe(panel.editFeed, {
              moduleId: moduleId,
              feedKey: entryId
            }, panel);
          }
          panel.saveEvent.subscribe(function (a, b) {
            window.Dom.get("".concat(moduleId, "_edit_feeds")).innerHTML = b[1].html;
            var entries = window.YAHOO.util.Selector.query("#".concat(moduleId, "_edit_feeds .yuimenuitem"));
            entries.forEach(function (entry) {
              var id = entry.getAttribute('data-feedid');
              if (checkedIds[id]) {
                window.Dom.addClass("li__".concat(id), 'yuimenuitem-checked');
                window.Dom.addClass("a__".concat(id), 'yuimenuitemlabel-checked');
              } else {
                window.Dom.removeClass("li__".concat(id), 'yuimenuitem-checked');
                window.Dom.removeClass("a__".concat(id), 'yuimenuitemlabel-checked');
              }
            });
          });
          panel.show();
        }
      });
    },
    failure: function failure(response) {
      window.ngpAlert(response.responseText);
    },
    scope: _this
  };
  window.ngpAsyncRequest('POST', '/ajax.action?method=getRssFeeds', callback);
};
var deleteFeedEntry = function deleteFeedEntry(moduleId, entryId) {
  var checkedEntries = window.YAHOO.util.Selector.query("#".concat(moduleId, "_edit_feeds .yuimenuitem.yuimenuitem-checked"));
  var checkedIds = checkedEntries.map(function (a) {
    return a.getAttribute('data-feedid');
  }).reduce(function (all, a) {
    all[a] = true;
    return all;
  }, {});
  window.ngpConfirm(window.getMessage('rssModule.js.deleteConfirm'), {
    title: 'rssModule.js.deleteTitle',
    okButtonText: window.getMessage('txt.button.remove'),
    okHandler: function okHandler() {
      var callback = {
        success: function success(response) {
          window.Dom.get("".concat(moduleId, "_edit_feeds")).innerHTML = response.responseText;
          var entries = window.YAHOO.util.Selector.query("#".concat(moduleId, "_edit_feeds .yuimenuitem"));
          entries.forEach(function (entry) {
            var id = entry.getAttribute('data-feedid');
            if (checkedIds[id]) {
              window.Dom.addClass("li__".concat(id), 'yuimenuitem-checked');
              window.Dom.addClass("a__".concat(id), 'yuimenuitemlabel-checked');
            } else {
              window.Dom.removeClass("li__".concat(id), 'yuimenuitem-checked');
              window.Dom.removeClass("a__".concat(id), 'yuimenuitemlabel-checked');
            }
          });
        },
        failure: function failure(response) {
          window.ngpAlert(response.responseText);
        },
        scope: this
      };
      window.ngpAsyncRequest('POST', '/ajax.action', callback, {
        method: 'deleteRssFeed',
        viewId: window.YAHOO.fcom.viewInfo.name,
        moduleId: moduleId,
        feedKey: entryId
      });
    },
    cancelHandler: function cancelHandler() {},
    handlerArgument: [_this]
  });
};
var createFeedEntry = function createFeedEntry(moduleId, isAdmin) {
  var checkedEntries = window.YAHOO.util.Selector.query("#".concat(moduleId, "_edit_feeds .yuimenuitem.yuimenuitem-checked"));
  var checkedIds = checkedEntries.map(function (a) {
    return a.getAttribute('data-feedid');
  }).reduce(function (all, a) {
    all[a] = true;
    return all;
  }, {});
  window.YAHOO.fcom.panel.PanelFactory.getAJAXPanel(window.YAHOO.fcom.panel.AJAXPanel.EDIT_RSS_FEED, {
    fn: function fn(panel) {
      panel.data.set('feedName', '', true);
      panel.data.set('feedUrl', '', true);
      panel.hideErrorMessage();
      if (isAdmin) {
        panel.onSave.subscribe(panel.saveFeedAdmin, {
          moduleId: moduleId
        }, panel);
      } else {
        panel.onSave.subscribe(panel.createFeed, {
          moduleId: moduleId
        }, panel);
      }
      panel.saveEvent.subscribe(function (a, b) {
        window.Dom.get("".concat(moduleId, "_edit_feeds")).innerHTML = b[1].html;
        var entries = window.YAHOO.util.Selector.query("#".concat(moduleId, "_edit_feeds .yuimenuitem"));
        entries.forEach(function (entry) {
          var id = entry.getAttribute('data-feedid');
          if (checkedIds[id]) {
            window.Dom.addClass("li__".concat(id), 'yuimenuitem-checked');
            window.Dom.addClass("a__".concat(id), 'yuimenuitemlabel-checked');
          } else {
            window.Dom.removeClass("li__".concat(id), 'yuimenuitem-checked');
            window.Dom.removeClass("a__".concat(id), 'yuimenuitemlabel-checked');
          }
        });
      });
      panel.show();
    }
  });
};
var isAdminMode = function isAdminMode() {
  var moduleContainer = window.YAHOO.fcom.Page.getInstance('moduleContainer');
  return moduleContainer != null && moduleContainer.config.adminData != null && moduleContainer.config.isAdmin === true; // container is null in full screen view
};
var _default = exports.default = {
  editColumnDialog: editColumnDialog,
  editModuleDialog: editModuleDialog,
  sendModuleConfigForm: sendModuleConfigForm,
  prepareWatchListModuleConfigSending: prepareWatchListModuleConfigSending,
  preparePeerListModuleConfigSending: preparePeerListModuleConfigSending,
  prepareRssModuleConfigSending: prepareRssModuleConfigSending,
  sendConfigurationForModule: sendConfigurationForModule,
  updateConfigurationForModule: updateConfigurationForModule,
  setColumnConfigurationForModule: setColumnConfigurationForModule,
  getSelectedColumns: getSelectedColumns,
  sendAfterRicKnown: sendAfterRicKnown,
  editFeedEntry: editFeedEntry,
  deleteFeedEntry: deleteFeedEntry,
  createFeedEntry: createFeedEntry,
  isAdminMode: isAdminMode
};
window.YAHOO.fcom.modules.Tools = {
  editColumnDialog: editColumnDialog,
  editModuleDialog: editModuleDialog,
  editColumnConfigDialog: editColumnConfigDialog,
  sendModuleConfigForm: sendModuleConfigForm,
  prepareWatchListModuleConfigSending: prepareWatchListModuleConfigSending,
  preparePeerListModuleConfigSending: preparePeerListModuleConfigSending,
  prepareRssModuleConfigSending: prepareRssModuleConfigSending,
  sendConfigurationForModule: sendConfigurationForModule,
  updateConfigurationForModule: updateConfigurationForModule,
  setColumnConfigurationForModule: setColumnConfigurationForModule,
  getSelectedColumns: getSelectedColumns,
  sendAfterRicKnown: sendAfterRicKnown,
  editFeedEntry: editFeedEntry,
  deleteFeedEntry: deleteFeedEntry,
  createFeedEntry: createFeedEntry,
  isAdminMode: isAdminMode
};

},{}],30:[function(require,module,exports){
"use strict";

var Dom = window.Dom;

/*
 * this function will register the given top flop list so that it can be reloaded when
 * the streaming changed some of the prices, so that the order will not be correct any more.
 * @param moduleId the moduleId to load the module with
 * @param tableNodeId the id of the table node to be replaced
 */
window.registerTopFlopModule = function (moduleId, tableNodeId, viewId, url) {
  if (window.onChildrenChange.registerNodeInterest(Dom.get(moduleId))) {
    // only if not yet registered
    window.onChildrenChange.subscribe(function (type, args, objs) {
      if (objs[0] === args[0]) {
        // when the change was for this node
        if (objs[2] < Date.now()) {
          // not each time but throttled
          objs[2] = Date.now() + 10000;
          window.reloadTopFlopModule(objs[0].id, objs[1], objs[3], objs[4]);
        }
      }
    }, [Dom.get(moduleId), tableNodeId, Date.now() + 10000, viewId, url]);
  }
};
var moduleToRicMap = {};
var moduleToConfigMap = {};
window.reloadTopFlopModule = function (moduleId, tableNodeId, viewId, url) {
  var directRic = moduleToRicMap[moduleId] || window.YAHOO.fcom.viewInfo.ric;
  var postData = {
    viewId: viewId,
    moduleId: moduleId.startsWith(viewId) ? moduleId.slice(viewId.length + 1, moduleId.length) : moduleId,
    directRic: directRic
  };
  var tableNode = Dom.get(tableNodeId);
  if (tableNode !== null) {
    window.ngpAsyncRequest('POST', url, null, postData, null, true).then(function (response) {
      var tableParentNode = tableNode.parentNode.parentNode;
      window.YAHOO.fcom.Page.replace(tableParentNode, response);
    }).catch(function () {
      console.warn('Reloading top flop list from ajax failed.');
      window.location.reload(); // do page reload instead
    });
  }
};

// This function reloads the content of yieldCurveModule
window.reloadYieldCurveModule = function (moduleId, viewId) {
  if (moduleId.startsWith(viewId)) {
    moduleId.slice(viewId.length + 1, moduleId.length);
  }
  var itemElement = window.Dom.get(moduleId);
  var url = "/view.action?method=getModule&moduleId=".concat(moduleId, "&viewId=").concat(viewId, "&popout='false'");
  var params = {
    replaceContainer: true,
    callback: function callback() {
      var columnContainer = window.YAHOO.fcom.Page.getInstance('moduleContainer');
      columnContainer.updateItem(moduleId);
      window.viewChangedEvent && window.viewChangedEvent.fire();
    }
  };
  window.replaceAsync(url, itemElement, params, true, true);
};
window.reloadModuleContent = function (moduleId, viewId, containerId, directParameter) {
  var postData;
  if (typeof directParameter == 'undefined') {
    directParameter = window.YAHOO.fcom.viewInfo.ric;
  }
  if (typeof directParameter === 'string') {
    postData = {
      viewId: viewId,
      moduleId: moduleId,
      directRic: directParameter
    };
  } else {
    if (directParameter && directParameter.tickerOverride) {
      // to support ticker overriding in Lipper funds
      // instead of sending only ric, ticker is also passed as a request attribute
      postData = {
        viewId: viewId,
        moduleId: moduleId,
        directRic: directParameter.ric,
        tickerOverride: directParameter.tickerOverride
      };
    } else {
      postData = {
        viewId: viewId,
        moduleId: moduleId,
        directParams: JSON.stringify(directParameter)
      };
    }
  }
  var replaceConfig = {
    postData: postData,
    replaceContainer: true,
    silent: true
  };
  return window.replaceAsync('/view.action?method=getModuleInnerTable', window.Dom.get(containerId), replaceConfig).then(function () {
    if (typeof directParameter === 'string') {
      moduleToRicMap[moduleId] = directParameter;
      window.setConfigAttributeValue(moduleId, 'ric', directParameter);
    }
    var node = window.Dom.get(containerId);
    if (node) {
      // only works if replaced container has same id all the time even after reload
      var nodeRefreshed = window.Dom.get(node.id);
      var name = nodeRefreshed.getAttribute('data-title');
      if (name) {
        window.YAHOO.util.Selector.query("#".concat(moduleId, " .module .title"))[0].innerHTML = name;
      }
    }
    var moduleContainer = window.YAHOO.fcom.Page.getInstance('moduleContainer');
    if (moduleContainer) {
      window.YAHOO.fcom.Page.getInstance('moduleContainer').checkViewportResize(true);
    }
    $(window).trigger({
      type: 'moduleReloaded',
      moduleId: moduleId
    });
  });
};
window.loadModuleFullscreen = function (moduleId, viewId, containerId, callback) {
  var postData = {
    viewId: viewId,
    moduleId: moduleId
  };
  window.replaceAsync('/view.action?method=getModuleFullScreen', containerId, {
    postData: postData,
    replaceContainer: false,
    silent: true,
    callback: callback
  });
};
window.setConfigForModule = function (moduleId, config) {
  moduleToConfigMap[moduleId] = config;
};
window.getConfigForModule = function (moduleId) {
  return moduleToConfigMap[moduleId];
};
window.setConfigAttributeValue = function (moduleId, attributeName, attributeValue) {
  var config = window.getConfigForModule(moduleId);
  if (typeof config != 'undefined') {
    config[attributeName] = attributeValue;
  }
};
window.getConfigAttributeValue = function (moduleId, attributeName) {
  var config = window.getConfigForModule(moduleId);
  if (typeof config != 'undefined') {
    return config[attributeName];
  }
};

},{}],31:[function(require,module,exports){
"use strict";

/*
 * Plugin for displaying news info in the news module
 *
 * @type {Object}
 */
window.YAHOO.fcom.NewsQuickviewFormatter = {
  /*
   * Shows the news overlay
   *
   * @param {} event
   * @param {String} newsId
   */
  showInfo: function showInfo(event, newsId) {
    // if there is an open tooltip, hide it
    if (typeof this.Tooltip !== 'undefined' && this.Tooltip !== null) {
      this.Tooltip.hide();
      this.Tooltip = null;
    } else {
      this.Tooltip = new window.fcom.ui.TooltipText('ngpTooltipNews', {
        hideOnMouseover: false,
        delayHide: 250,
        delayShow: 500,
        cssClasses: ['quickView', 'break-all-links'],
        style: {
          width: '400px',
          overflow: 'hidden'
        }
      });
      this.Tooltip.beforeShowEvent.subscribe(function () {
        this.showInfoAjax();
      }, this, true);
    }
    this.currentNewsId = newsId;

    // show the tooltip
    this.Tooltip.display(event, "<div style=\"padding: 5px;\" id=\"NewsLoading-NewsId-".concat(newsId, "\"></div>"));
  },
  /*
   * Loads the date for the last news overlay
   *
   * @param {String} ric
   */
  showInfoAjax: function showInfoAjax() {
    var callback = {
      success: function success(o) {
        window.Dom.get("NewsLoading-NewsId-".concat(o.argument.currentNewsId)).innerHTML = o.responseText;
      },
      failure: function failure() {},
      argument: this
    };
    window.ngpAsyncRequest('GET', "/news.action?method=getNewsArticle&nid=".concat(encodeURIComponent(this.currentNewsId), "&popup=true"), callback);
  },
  /*
   * closes the last news overlay
   */
  hideInfo: function hideInfo() {
    if (this.Tooltip != null) {
      // maybe some double call on mouseout or similar
      this.Tooltip.hide();
      this.Tooltip = null;
    }
  }
};

},{}],32:[function(require,module,exports){
"use strict";

/*
 * This is a manager singleton that takes care of displaying overlays that are supposed to be arranged
 * relatively to eachother. For example this manager can be used to show alerts nicely stacked on the screen, instead
 * of simply over eachother. The manager works with any overlay instance or one of overlay's subclasses.
 * To create an overlay group, you must specify a key. Further there are optional configuration properties, like
 * <ul>
 * <li>maximum number of dialogs being shown</li>
 * <li>start coordinates</li>
 * <li>a layout function</li>
 * </ul><br />
 * Is an overlay added to a group, the layout function will be called and position the overlay. There is a default
 * layout function available.<br />
 * The OverlayGroupManager pre-defines following groups:
 * <ul>
 * <li>OverlayGroupManager.ALERTS_GROUP - alerts, flash news</li>
 * </ul><br />
 *
 */
window.YAHOO.fcom.OverlayGroupManager = function () {
  return {
    /*
     * @property
     * map storing group objects with the following properties:
     * <ul>
     * <li>{String}key </li>
     * <li>{Array} elements  </li>
     * <li>{Region} startAt </li>
     * <li>{Number} maxDispayed </li>
     * <li>{Function} layoutFunction </li>
     * </ul>
     * @type {Array}
     */
    groupMap: [],
    /*
     * create a new overlay group
     * @param {String} key
     * to identify the group
     * @param @optional {Number} maxDisplayed
     * how many dialogs of this group are being displayed at the same time, default is 100
     * @param @optional {Region} startAt
     * starting to layout the dialogs at a certain position, default is 0, 0
     * @param @optional {Function} layoutFunction
     * A function that calculates the position for the next item, receiving the last item and the current item.
     * Must return a region object. For an example implementation of a layout-function see window.YAHOO.fcom.DialogGroupManager.layoutDefault.
     * If this not supplied a default function will be used.
     */
    create: function create(key, maxDisplayed, startAt, layoutFunction) {
      if (!this.groupMap[key] || this.groupMap[key] == null) {
        if (!startAt || startAt == null) {
          startAt = {
            x: 0,
            y: 0
          };
        }
        if (!layoutFunction || layoutFunction == null) {
          layoutFunction = window.YAHOO.fcom.Util.createDelegate(this.layoutDefault, this);
        }
        if (!maxDisplayed || maxDisplayed == null) {
          maxDisplayed = 100;
        }
        this.groupMap[key] = {
          key: key,
          maxDisplayed: maxDisplayed,
          layoutFunction: layoutFunction,
          elements: [],
          startAt: startAt
        };
      }
    },
    /*
     * Add an overlay to an existing group.
     * The groups layout function will be used to calculate new coordinates for the overlay instance.
     * In case the number of dialogs reaches maxDisplayed, older dialogs will be closed and removed.
     * @param {Object} key
     * @param {Object} element
     */
    add: function add(key, element) {
      var group = this.groupMap[key];
      if (group != null) {
        var region;
        group.elements.push(element);
        if (element.cfg && element.cfg.getProperty('modal')) {
          element.showEvent.subscribe(this.showElement, {
            key: key,
            element: element
          }, this);
        }
        element.hideEvent.subscribe(this.remove, {
          key: key,
          element: element
        }, this);
        if (group.elements.length > 1) {
          var lastBut = group.elements[group.elements.length - 2];
          region = group.layoutFunction(key, lastBut, element);
        } else {
          region = group.layoutFunction(key, null, element);
        }
        element.cfg.setProperty('x', region.x);
        element.cfg.setProperty('y', region.y);
        //too many dialogs on the screen, some must be destroied
        if (group.elements.length > group.maxDisplayed) {
          group.elements[0].destroy(); //remove from dom
          window.domToYUIMap[group.elements[0].id] = null; //also remove from domToYUIMap
          this.remove(null, null, {
            key: group.key,
            element: group.elements[0]
          }); //remove from group
        }
      }
    },

    /*
     * The default layouting function for overlays.
     * Calculate a position for a new overlay instance depending on other group elements.
     * @param {String} key for the overlay group
     * @param {window.YAHOO.widget.Overlay} oldElement can be null
     * @param {window.YAHOO.widget.Overlay} newElement
     */
    layoutDefault: function layoutDefault(key, oldElement, newElement) {
      var mrgn = 20;
      var group = this.get(key);
      var tempX = group.startAt.x;
      var tempY = group.startAt.y;
      if (oldElement != null) {
        tempX = oldElement.cfg.getProperty('x') + mrgn;
        tempY = oldElement.cfg.getProperty('y') + mrgn;
        //check screen boundaries
        var documentWidth = window.Dom.getViewportWidth();
        var documentHeight = window.Dom.getViewportHeight();
        var width = newElement.cfg.getProperty('width');
        if (width == null) {
          width = newElement.element.clientWidth; //dynamic width
        } else {
          width = width.substring(0, width.indexOf('px'));
          width = parseInt(width, 10);
        }
        var height = newElement.element.clientHeight; //height is usually dynamic
        //height = height.substring(0, height.indexOf("px"));
        //height = parseInt(height);
        if (tempX + width > documentWidth || tempY + height > documentHeight) {
          tempX = tempX + mrgn / 2;
          tempY = group.startAt.y;
        }
      }
      return {
        x: tempX,
        y: tempY
      };
    },
    /*
     * Get the overlay group associated with this key
     * @param {String} key
     */
    get: function get(key) {
      return this.groupMap[key];
    },
    /*
     * internal function to remove a overlay from the group
     * @private
     * @param {String} eventType
     * @param {Array} eventArgs
     * @param {Object} customObj
     * Object containing the properties <code>element</code> and <code>key</code>
     */
    remove: function remove(eventType, eventArgs, customObj) {
      var group = this.groupMap[customObj.key];
      if (group != null) {
        var index = window.YAHOO.fcom.Util.indexOf(customObj.element, group.elements);
        if (group.elements.length - 1 >= index) {
          var parent = group.elements[index - 1];
          if (parent && parent.cfg && parent.cfg.getProperty('modal')) {
            group.elements[index - 1].showMask();
          }
        }
        if (index > -1) {
          group.elements.splice(index, 1);
        }
      }
      customObj.element.hideEvent.unsubscribe(this.remove);
    },
    showElement: function showElement(eventType, args, custom) {
      var group = this.groupMap[custom.key];
      var index = window.YAHOO.fcom.Util.indexOf(custom.element, group.elements);
      if (index - 1 >= 0) {
        group.elements[index - 1].hideMask();
      }
    }
  };
}(); //eofmodulepattern OverlayGroupManger Singleton
window.YAHOO.fcom.OverlayGroupManager.ALERTS_GROUP = 'alertGroup';
window.YAHOO.fcom.OverlayGroupManager.create(window.YAHOO.fcom.OverlayGroupManager.ALERTS_GROUP, 10, {
  x: 50,
  y: 50
});

},{}],33:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// ATTENTION: The following functionalities have nothing to do with financial.com applets and must be there
// even when ngp has no applets any more, e.g. when a customer adds an applet to the html-module

var installOverlayListener = function installOverlayListener(overlayInstance) {
  // small performance hack, disabling the focus handler on all overlays, as it leads to IE crashes with larger pages.
  if (overlayInstance._addFocusHandlers && overlayInstance.showMaskEvent) {
    overlayInstance.showMaskEvent.unsubscribe(overlayInstance._addFocusHandlers);
  }
  if (overlayInstance._removeFocusHandlers && overlayInstance.hideMaskEvent) {
    overlayInstance.hideMaskEvent.unsubscribe(overlayInstance._removeFocusHandlers);
  }
  overlayInstance.subscribe('move', function (type, args, overlayInstance) {
    var region = window.Dom.getRegion(overlayInstance.element);
    var hiddenApplets = overlayInstance.hiddenApplets;
    if (hiddenApplets && hiddenApplets.length > 0) {
      for (var i = 0; i < hiddenApplets.length; i++) {
        if (hiddenApplets[i] != null) {
          var appletRegion = window.Dom.getRegion(hiddenApplets[i]);
          if (appletRegion.intersect(region) == null && window.hiddenAppletMap[hiddenApplets[i].name] === overlayInstance.element.id) {
            // only if we were the last to tuch that applet) {
            window.Dom.setStyle(hiddenApplets[i], 'visibility', 'visible');
          }
          hiddenApplets[i] = null;
        }
      }
    }
    var applets = window.Dom.getElementsBy(function () {
      return true;
    }, 'applet', window.Dom.get('body'));
    if (applets && applets != null && applets.length > 0) {
      for (var _i = 0; _i < applets.length; _i++) {
        var _appletRegion = window.Dom.getRegion(applets[_i]);
        if (_appletRegion.intersect(region) != null) {
          window.Dom.setStyle(applets[_i], 'visibility', 'hidden');
          if (!overlayInstance.hiddenApplets || overlayInstance.hiddenApplets == null) {
            overlayInstance.hiddenApplets = [];
          }
          overlayInstance.hiddenApplets[overlayInstance.hiddenApplets.length] = applets[_i];
          window.hiddenAppletMap[applets[_i].name] = overlayInstance.element.id; // remember id of overlay that worked with this applet last time
          window.hiddenAppletMap[overlayInstance.element.id] = applets[_i].name;
        }
      }
    }
  }, overlayInstance, false);
  overlayInstance.subscribe('show', function (type, args, overlayInstance) {
    var region = window.Dom.getRegion(overlayInstance.element);
    var applets = window.Dom.getElementsBy(function () {
      return true;
    }, 'applet', window.Dom.get('body'));
    if (applets && applets != null && applets.length > 0) {
      for (var i = 0; i < applets.length; i++) {
        var appletRegion = window.Dom.getRegion(applets[i]);
        if (appletRegion.intersect(region) != null) {
          window.Dom.setStyle(applets[i], 'visibility', 'hidden');
          if (!overlayInstance.hiddenApplets || overlayInstance.hiddenApplets == null) {
            overlayInstance.hiddenApplets = [];
          }
          overlayInstance.hiddenApplets[overlayInstance.hiddenApplets.length] = applets[i];
          window.hiddenAppletMap[applets[i].name] = overlayInstance.element.id; // remember id of overlay that worked with this applet last time
          window.hiddenAppletMap[overlayInstance.element.id] = applets[i].name;
        }
      }
    }
  }, overlayInstance, false);
  overlayInstance.subscribe('hide', function (type, args, overlayInstance) {
    var hiddenApplets = overlayInstance.hiddenApplets;
    if (hiddenApplets && hiddenApplets != null && hiddenApplets.length > 0) {
      for (var i = 0; i < hiddenApplets.length; i++) {
        if (hiddenApplets[i] != null && window.hiddenAppletMap[hiddenApplets[i].name] === overlayInstance.element.id) {
          // only if we were the last to tuch that applet
          window.Dom.setStyle(hiddenApplets[i], 'visibility', 'visible');
        }
        hiddenApplets[i] = null;
      }
      overlayInstance.hiddenApplets = null;
    }
  }, overlayInstance, false);
};
var _default = exports.default = installOverlayListener;
window.installOverlayListener = installOverlayListener;

},{}],34:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/*
 * a small helper function to send page settings to the server. The settings will be
 * stored there and can be reused on server side through the pageSettings tag.
 * @param pageId an unique id for the page or global functionality that this
 *        settings are used for. E.g. "detailPageBigChart" or "moduleLibrary" or similar
 * @param attributeObject an object with attributes that should be stored for that user and the
 *        given page id. The attributes are stored with string keys and typed values, so when
 *        getting the settings back, boolean fields will remain boolean fields and so on.
 *        Named strings like "type=volume" should be preferred against unnamed cryptic ids like
 *        type=1 where nobody knows what 1 will be.
 * @param persistence optional boolean attribute that when set true will store the settings forever in the db
 *        instead of temporary in the session
 */
var savePageSettings = function savePageSettings(pageId, attributeObject, persistence, callback) {
  persistence = !!persistence;
  var csrfTokenELName = window.YAHOO.fcom.Security.CSRFTokenElName;
  var csrfToken = window.YAHOO.fcom.Security.CSRFToken;
  var url = '/ajax.action';
  var postData = _defineProperty({
    method: 'setPageSettings',
    persistence: !!persistence,
    pageId: pageId,
    attributes: JSON.stringify(attributeObject)
  }, csrfTokenELName, csrfToken);
  return window.ngpAsyncRequest('POST', url, callback || {}, postData);
};
var deletePageSettings = function deletePageSettings(pageId) {
  var csrfTokenELName = window.YAHOO.fcom.Security.CSRFTokenElName;
  var csrfToken = window.YAHOO.fcom.Security.CSRFToken;
  var url = '/ajax.action';
  var postData = _defineProperty({
    method: 'deletePageSettings',
    pageId: pageId
  }, csrfTokenELName, csrfToken);
  return window.ngpAsyncRequest('POST', url, {}, postData);
};
var _default = exports.default = savePageSettings;
window.savePageSettings = savePageSettings;
window.deletePageSettings = deletePageSettings;

},{}],35:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Overlays = _interopRequireDefault(require("core/Overlays"));
var _objectToPostdata = _interopRequireDefault(require("core/Ajax/objectToPostdata"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/*
 * create a new panel from markup. A panel should always be created with that function here, because it handles some generic bugfixes and overlay problems. Do
 * not call the YUI panel constructor directly. If no markup is given, the function can still be used to build an empty panel and fill it e.g. with the
 * setBody() function.
 *
 * @param domNode the div where to build the panel from. Can be the dom node directly, the id of the dom node or null, then a new div is created and appended to
 * the body when given a string and no div with that id is found, a new div is created, given the id string.
 * @param config the config object for the panel. See YUI api docu for all the configuration attributes that can be passed. The most important are
 * modal:true|false,
 * @param show optional boolean value telling whether the panel's show function should be called automatically. Default is true, only when the panel instance
 * returned will be filled programatically, it should be set to false;
 * @param {String} parent id of the parent panel's dom element. Always supply a parent, if you open a new modal panel from an already modal panel.
 * @param {String} overlayGroup key for registering managed overlay groups
 * @return {window.YAHOO.widget.Panel}
 */
var openPanelFromMarkup = function openPanelFromMarkup(domNode, config, show, parent, overlayGroup) {
  if (!window.YAHOO.lang.isBoolean(show)) {
    show = true;
  }
  if (!domNode || domNode == null) {
    domNode = window.YAHOO.fcom.Page.getOverlayDOMNode(window.YAHOO.fcom.util.Dom.generateId());
    window.Dom.setStyle(domNode, 'visibility', 'hidden');
    window.Dom.addClass(domNode, 'panel');
  } else if (window.YAHOO.lang.isString(domNode)) {
    domNode = window.YAHOO.fcom.Page.getOverlayDOMNode(domNode);
  }
  if (window.domToYUIMap[domNode.id] == null) {
    window.Dom.addClass(domNode, 'panel');
    window.Dom.setStyle(domNode, 'display', '');
    window.Dom.setStyle(domNode, 'visibility', 'hidden');
  }
  var panelInstance = window.domToYUIMap[domNode.id];
  if (!panelInstance || panelInstance == null) {
    panelInstance = new window.YAHOO.widget.Panel(domNode, config);
    window.domToYUIMap[domNode.id] = panelInstance;
    subscribeHideAndShowEvents(panelInstance);
    (0, _Overlays.default)(panelInstance);
    panelInstance.render(document.body);
  }

  /* Use OverlayGroupManager to stack panels nicely */
  if (overlayGroup != null) {
    window.YAHOO.fcom.OverlayGroupManager.create(overlayGroup);
    window.YAHOO.fcom.OverlayGroupManager.add(overlayGroup, panelInstance);
  }

  /* Stack modal panels properly by hiding the parents mask */
  if (parent && window.YAHOO.lang.isString(parent)) {
    parent = window.domToYUIMap[parent];
    if (parent != null && panelInstance.cfg.getProperty('modal')) {
      // parent could have changed - unregister old event listeners
      panelInstance.showMaskEvent.unsubscribe(hideParentMask);
      panelInstance.hideMaskEvent.unsubscribe(showParentMask);
      // register hide/show Mask for new parent
      panelInstance.showMaskEvent.subscribe(hideParentMask, parent);
      panelInstance.hideMaskEvent.subscribe(showParentMask, parent);
    }
  }
  if (show) {
    panelInstance.show();
    if (window.YAHOO.fcom.Page.isOverlayIframeRequired()) {
      window.YAHOO.fcom.Page.activateOverlayFrame();
      window.YAHOO.fcom.Page.getIFrameHandler().addOverlayActive(panelInstance.id);
    }
  }
  return panelInstance;
};

/*
 * create a panel, fill it with content from an ajax call an display it TODO: in the moment only the session expiry is handled correctly, any other error (e.g.
 * error 500) is not handled and it is also not possible to give a handler. So there should be a optional outer callback object possible
 *
 * @param domNode the div where to build the panel from. Can be the dom node directly, the id of the dom node or null, then a new div is created and appended to
 * the body when given a string and no div with that id is found, a new div is created, given the id string.
 * @param url the url to get the panels content from. The url really only has to return the panels content with no html header, body or even the panels main div
 * around.
 * @param postData an optional attribute string to be sent with the url. Must be of get format, like e.g. attribute1=value1&attribute2=value%322
 * @param panelConfig the config object for the panel. See YUI api docu for all the configuration attributes that can be passed. The most important are
 * modal:true|false,
 * @param ajaxConfig ajax config is a map of attributes to set the behavior of the ajax call known attributes are: instanceHandler: an optional function that
 * gets the panel instance as only parameter as soon as the ajax is there and the panel is created. With this mechanismn e.g events can be subscribed. The
 * instanceHandler is called with the panelInstance as first argument. failureHandler: an optional function that gets called, when there was an error while
 * requesting the panel. Receives the optional customObject as first parameter and the ajax response object as second. When giving this argument, the argument
 * errorMessage has no effect. scope: context to execute the instanceHandler/failureHandler (optional) customObject: a custom object that will be passed to the
 * instanceHandler as second argument. errorMessage: an optional error message that get's displayed in a panel instead of the original panel, when the ajax call
 * fails. If no message is given, nothing will happen, when the panel content fails. show: wether to show the panel after it was created
 * @param {String} overlayGroupKey key for registering managed overlay groups
 * @param {String} parent id of the parent panel's dom element. Always supply a parent, if you open a new modal panel from an already modal panel.
 */
var fillPanelFromAjax = function fillPanelFromAjax(domNode, url, postData, panelConfig, ajaxConfig, overlayGroupKey, parent) {
  if (window.YAHOO.fcom.Page.isOverlayIframeRequired() && window.YAHOO.fcom.Page.isOverlayIframeRequired() === 'popup') {
    if (window.popupInstances == null) {
      window.popupInstances = {};
    }
    var windowName = "".concat(window.name, "_popup");
    if (domNode != null && window.YAHOO.lang.isString(domNode)) {
      windowName = domNode;
    }
    var popupInstance = getPanelPopup(windowName, panelConfig, url, postData);
    if (window.popupInstances[windowName] == null) {
      window.popupInstances[windowName] = popupInstance;
    }
    window.popupInstances[windowName].focus();
    return;
  }
  if (!ajaxConfig || ajaxConfig == null) {
    ajaxConfig = {
      instanceHandler: null
    };
  } else if (!window.YAHOO.lang.isValue(ajaxConfig.instanceHandler)) {
    ajaxConfig.instanceHandler = null;
  }
  var showWaitNeeded = window.YAHOO.lang.isValue(panelConfig) && window.YAHOO.lang.isValue(panelConfig.modal) && panelConfig.modal;
  if (showWaitNeeded) {
    window.showWait(true, true);
  }
  var documentObject = window.YAHOO.fcom.Page.documentToUseForOverlays();
  if (domNode != null && window.YAHOO.lang.isString(domNode)) {
    domNode = window.YAHOO.fcom.Page.getOverlayDOMNode(domNode);
  }
  if (domNode == null) {
    domNode = documentObject.createElement('div');
    window.Dom.generateId(domNode);
    documentObject.body.insertBefore(domNode, documentObject.body.firstChild);
  }
  window.Dom.setStyle(domNode, 'visibility', 'hidden');
  window.Dom.addClass(domNode, 'panel');
  if (domNode.id == 'personalSettingsDialog') {
    window.Dom.addClass(domNode, 'printbg');
  }
  var id = domNode.id;
  // clean existing node
  window.YAHOO.fcom.Page.replace(domNode, '');
  // destroy panel instance if it exists
  var panelInstance = window.domToYUIMap[id];
  if (panelInstance != null) {
    // removes panel node
    panelInstance.destroy();
    // window.domToYUIMap vs. page.map ?
    // is there a better position to remove this from domToYUIMap?
    // add a factory method which handles domToYUIMap dependencies ?
    delete window.domToYUIMap[id];
    domNode = window.YAHOO.fcom.Page.getOverlayDOMNode(id);
    window.Dom.addClass(domNode, 'panel');
  }
  window.Dom.setStyle(document.body, 'cursor', 'wait');
  var panelId = "panelId=".concat(domNode.id);
  if (postData && _typeof(postData) === 'object') {
    postData = (0, _objectToPostdata.default)(postData);
  }
  postData = postData ? "".concat(postData, "&").concat(panelId) : panelId;
  var callback = {
    success: function success(o) {
      if (o.argument[4]) {
        window.showWait(false);
      }
      if (o.status !== 200) {
        // sessions seems not to be valid any more, or page flow broken => reload
        console.warn('Opening panel from ajax failed.');
        window.location.reload(); // TODO: reload should only be done when really the session did timeout
        return;
      }
      console.log('Installing panel from ajax.');
      var responseText = removePopupsearchMarkup(o.responseText);
      if (window.YAHOO.fcom.Page.isOverlayIframeRequired() && window.parent.frames.ngpOverlayFrame) {
        window.parent.frames.ngpOverlayFrame.window.YAHOO.fcom.Page.replace(o.argument[0], responseText);
      } else {
        window.YAHOO.fcom.Page.replace(o.argument[0], responseText);
      }

      /*
       * TODO: right now a new panel is created every time. Maybe better to reuse the old ones? This is not a good idea, since all of the content (header,
       * body and footer) is replaced and thus breaking all event-handling and basic functionality. It is easier to create a new panel from scratch. *
       */
      var panelInstance = new window.YAHOO.widget.Panel(o.argument[0], o.argument[2]);
      subscribeHideAndShowEvents(panelInstance, o.argument[2].closeCallback);
      (0, _Overlays.default)(panelInstance);
      panelInstance.render();
      window.domToYUIMap[o.argument[0].id] = panelInstance;
      o.argument[1] = panelInstance;

      /* Use OverlayGroupManager to stack panels nicely */
      if (o.argument[5] && o.argument[5] != null) {
        window.YAHOO.fcom.OverlayGroupManager.create(o.argument[5]);
        window.YAHOO.fcom.OverlayGroupManager.add(o.argument[5], panelInstance);
      }

      /* Stack modal panels properly by hiding the parents mask */
      var parent = o.argument[6];
      if (parent && window.YAHOO.lang.isString(parent) && panelInstance.cfg.getPropery('modal')) {
        parent = window.domToYUIMap[parent];
        if (parent != null) {
          // register hide/show Mask for new parent
          panelInstance.showMaskEvent.subscribe(hideParentMask, parent);
          panelInstance.hideMaskEvent.subscribe(showParentMask, parent);
        }
      }
      var show = o.argument[3].show;
      if (show !== false) {
        panelInstance.show();
        if (window.YAHOO.fcom.Page.isOverlayIframeRequired()) {
          window.YAHOO.fcom.Page.activateOverlayFrame();
          window.YAHOO.fcom.Page.getIFrameHandler().addOverlayActive(panelInstance.id);
        }
      }
      window.Dom.setStyle(document.body, 'cursor', '');

      // callback
      if (o.argument[3] && o.argument[3] != null && window.YAHOO.lang.isFunction(o.argument[3].instanceHandler)) {
        // give control back to UI by setting a timeout
        window.YAHOO.lang.later(10, o.argument[3].scope, o.argument[3].instanceHandler, [panelInstance, o.argument[3].customObject]);
      }
    },
    failure: function failure(o) {
      // problem getting edit panel. Maybe session timed out, or page flow broken => reload
      if (o.argument[4]) {
        window.showWait(false);
      }
      console.warn('Opening panel from ajax failed.');
      if (o.status === 401) {
        window.sessionExpired();
      } else if (o.argument[3] != null && o.argument[3].failureHandler != null) {
        o.argument[3].failureHandler.call(o.argument[3].scope, o.argument[3].customObject, o);
      } else if (o.argument[3] && o.argument[3] != null && window.YAHOO.lang.isString(o.argument[3].errorMessage)) {
        window.ngpAlert(o.argument[3].errorMessage);
      }
      window.Dom.setStyle(document.body, 'cursor', '');
    },
    argument: [domNode, panelInstance, panelConfig, ajaxConfig, showWaitNeeded, overlayGroupKey, parent]
  };
  window.ngpAsyncRequest('POST', url, callback, postData);
};
var getPanelPopup = function getPanelPopup(windowName, panelConfig, url, postdata) {
  var includeUrl = url;
  if (includeUrl.indexOf('?') > 0) {
    includeUrl = encodeURIComponent(url.substring(0, url.indexOf('?')));
    includeUrl += '&';
    includeUrl += url.substring(url.indexOf('?') + 1);
  }
  if (postdata != null && postdata.length > 0) {
    includeUrl += "&".concat(postdata);
  }
  if (panelConfig.requiredScripts && panelConfig.requiredScripts.length > 0) {
    includeUrl += '&requiredScripts=';
    for (var i = 0; i < panelConfig.requiredScripts.length; i++) {
      includeUrl += panelConfig.requiredScripts[i];
      if (i < panelConfig.requiredScripts.length - 1) {
        includeUrl += ',';
      }
    }
  }
  if (panelConfig.panelNamespace) {
    includeUrl += "&panelNamespace=".concat(panelConfig.panelNamespace, "&panelId=").concat(windowName);
  }
  var width = 500;
  if (panelConfig.width) {
    if (panelConfig.width.indexOf('px') > 0) {
      width = parseInt(panelConfig.width.substring(0, panelConfig.width.indexOf('px')), 10) + 20;
    }
  }
  var height = 700;
  if (panelConfig.height) {
    if (panelConfig.height.indexOf('px') > 0) {
      height = parseInt(panelConfig.height.substring(0, panelConfig.height.indexOf('px')), 10) + 10;
    }
  }
  return window.open("".concat(window.ctx, "/template/layouts/popupContainer.blank?includePage=").concat(includeUrl), windowName, "width=".concat(width, ",height=").concat(height, ",left=500,top=400,location=no,menubar=no,resizable=no,toolbar=no,scrollbars=1"));
};

/*
 * Replace the content of a panel with string content that is already available. This function got necessary when at the time of sending the ajax call it is not
 * yet clear whether a panel is needed or not as e.g. it is the case with the popup search. The given content string is expected to deliver panel compatible
 * markup.
 *
 * @param {String|window.YAHOO.widget.Module} module
 * @param {String} content
 */
var replacePanelContentByString = function replacePanelContentByString(module, content, strict) {
  var tempNode = document.createElement('div');
  tempNode.innerHTML = content;
  window.Dom.addClass(tempNode, 'panel');
  var outerTempNode = document.createElement('div');
  outerTempNode.appendChild(tempNode);
  if (content) {
    // use strict replacement -> exception indicates wrong panel markup
    window.YAHOO.fcom.Page.replace(module.element, outerTempNode, {
      selectorConfig: [{
        selector: 'div.panel > div.hd',
        apply: function apply(selector, target, node) {
          module.setHeader(node.innerHTML);
          return module.header;
        }
      }, {
        selector: 'div.panel > div.bd',
        apply: function apply(selector, target, node) {
          module.setBody(node.innerHTML);
          return module.body;
        }
      }, {
        selector: 'div.panel > div.ft',
        apply: function apply(selector, target, node) {
          module.setFooter(node.innerHTML);
          return module.footer;
        }
      }],
      strict: strict
    });
  }
};

/*
 * Replace the content of a panel with content from the server. The response is exspected to deliever panel compatible markup.
 *
 * @param {String|window.YAHOO.widget.Module} module
 * @param {String} url
 * @param {Object} ajaxConfig optional parameter containing following properties
 * <ul>
 * &#09;&#09;
 * <li>{FormElement} form data to send with the request &#09;&#09;
 * <li>{String} post data to send with the request, will be merged with form data &#09;&#09;
 * <li>{Function} success &#09;&#09;
 * <li>{Function} failure &#09;&#09;
 * <li>{Object} scope optional context for executing callback methods &#09;&#09;
 * <li>{Array} args parameters for the callback function
 * </ul>
 *
 */
var replacePanelContent = function replacePanelContent(module, url, ajaxConfig) {
  if (window.YAHOO.lang.isString(module)) {
    module = window.domToYUIMap[module];
  }
  if (module == null || url == null) {
    return false;
  }
  if (ajaxConfig.showWait == null) {
    ajaxConfig.showWait = false;
  }
  var callback = {
    success: function success(response) {
      var module = response.argument[0];
      var ajaxConfig = response.argument[1];
      if (ajaxConfig.showWait) {
        window.showWait(false);
      }
      replacePanelContentByString(module, response.responseText, true);
      if (ajaxConfig != null && ajaxConfig.success != null) {
        // give control back to UI by setting a timeout
        window.YAHOO.lang.later(10, ajaxConfig.scope, ajaxConfig.success, ajaxConfig.args);
        // ajaxConfig.success.apply(ajaxConfig.scope, ajaxConfig.args);
      }
    },

    failure: function failure(response) {
      console.log('replacePanelContent failure handler');
      var ajaxConfig = response.argument[1];
      if (ajaxConfig.showWait) {
        window.showWait(false);
      }
      if (ajaxConfig != null && ajaxConfig.failure != null) {
        ajaxConfig.failure.apply(ajaxConfig.scope, ajaxConfig.args);
      }
    },
    argument: [module, ajaxConfig]
  };
  if (ajaxConfig.showWait) {
    window.showWait(true, true);
  }
  var method = 'GET';
  if (ajaxConfig.form != null || ajaxConfig.postData != null) {
    method = 'POST';
  }
  url = window.YAHOO.fcom.Util.addURLParam(url, 'noChache', noChacheId());
  window.ngpAsyncRequest(method, url, callback, ajaxConfig.postData, ajaxConfig.form);
};

/*
 * this function can be used to hide a panel with the button that was pressed as only argument. This can be usefull when the button is coded as include in a
 * place where you don't have a clue what panel it will be rendered into.
 *
 * @param buttonElement this can be either the id string of the button or the button element itself. When sending null, the function will even try to find the
 * button that was pressed most recently.
 */
var hidePanelByButton = function hidePanelByButton(buttonElement) {
  if (!buttonElement || buttonElement == null) {
    buttonElement = window.genericButtonLastPressedInstance;
  } else if (window.YAHOO.lang.isString(buttonElement)) {
    buttonElement = window.Dom.get(buttonElement);
  }
  var panel = window.Dom.getAncestorByClassName(buttonElement, 'panel');
  if (panel != null) {
    hidePanel(panel.id);
  }
};

/*
 * function to hide panels.
 *
 * @param panel the YUI panel instance, or a dom node or an id of a dom node of the div, the panel is living in. the latter only works, when the panel was
 * created with the factory functions fillPanelFromAjax or initPanel, as those keep track of the instances to be able to close them again.
 */
var hidePanel = function hidePanel(panel) {
  if (!panel || panel == null) {
    throw 'No Panel passed to be hidden';
  } else if (window.YAHOO.lang.isString(panel)) {
    if (window.opener) {
      // popup instead of panels
      try {
        if (window.opener.popupInstances != null && window.opener.popupInstances[panel] != null) {
          window.opener.popupInstances[panel] = null;
          window.close();
          return;
        }
      } catch (e) {
        // opener seems to be wrong opener, no access to variables allowed
      }
    } else if (window.popupInstances != null && window.popupInstances[panel] != null) {
      // popup instead of panels but call in main window
      window.popupInstances[panel].close();
      window.popupInstances[panel] = null;
      return;
    }
    panel = window.Dom.get(panel);
  }
  if (panel.nodeName) {
    panel = window.domToYUIMap[panel.id];
  }
  if (!panel || panel == null) {
    throw 'No panel found for the given node, probably panel was not created with ngp factory function.';
  }
  panel.hide();
};

/*
 * Eventhandler that hides the mask of the modal parent panel
 *
 * @param {Object} eventName
 * @param {Object} args
 * @param {window.YAHOO.widget.Panel} parent
 */
var hideParentMask = function hideParentMask(eventName, args, parent) {
  if (parent != null && window.YAHOO.lang.isFunction(parent.hideMask)) {
    parent.hideMask();
  }
};

/*
 * Eventhandler that shows the mask od the modal parent panel
 *
 * @param {Object} eventName
 * @param {Object} args
 * @param {window.YAHOO.widget.Panel} parent
 */
var showParentMask = function showParentMask(eventName, args, parent) {
  if (parent != null && window.YAHOO.lang.isFunction(parent.hideMask) && parent.cfg.getProperty('visible')) {
    parent.showMask();
  }
};

/*
 * Return a random string that is unique while the webapp is running. Can be replaced with a better implementation.
 *
 * @return {String}
 */
var noChacheId = function noChacheId() {
  return new Date().getTime();
};

/*
 * TODO remove this function as soon as popupsearch has been reworked!!
 *
 * This function removes any popup search panel markup from an ajax response if the popupsearch is already available on the page.
 *
 * @param {String} responseText
 * @return {String} responseText with stripped popup search panel markup
 */
var removePopupsearchMarkup = function removePopupsearchMarkup(responseText) {
  if (window.Dom.get('instrumentsSearchPopupDiv')) {
    var tmpNode = document.createElement('div');
    tmpNode.innerHTML = responseText;
    var chlds = window.Dom.getElementsBy(function (node) {
      return node.id === 'instrumentsSearchPopupDiv';
    }, 'div', tmpNode);
    for (var i = 0; i < chlds.length; i++) {
      /* @type {HTMLElement} */
      var child = chlds[i];
      child.parentNode.removeChild(child);
    }
    return tmpNode.innerHTML;
  } else {
    return responseText;
  }
};
var hideFieldPanel = function hideFieldPanel(id) {
  hidePanel(id);
  $('.yui-panel-container.shadow.yui-overlay-hidden').hide();
};

/*
 * this function is for private use for the panel factory. It will subscribe the hide and show event to make all child overlay elements also visible and
 * invisible, once the panel's visibility state changes.
 */
var subscribeHideAndShowEvents = function subscribeHideAndShowEvents(panelInstance, closeCallback) {
  if (window.YAHOO.fcom.Page.isOverlayIframeRequired() && panelInstance.cfg.getProperty('modal')) {
    panelInstance.subscribe('showMask', function (type, args, panelInstance) {
      var windowToUse = window.YAHOO.fcom.Page.windowToUseForOverlays();
      if (panelInstance.mask.parentNode !== windowToUse.document.body) {
        windowToUse.document.body.insertBefore(panelInstance.mask, windowToUse.document.body.firstChild);
        window.Dom.setStyle(panelInstance.mask, 'width', "".concat(windowToUse.innerWidth, "px"));
        window.Dom.setStyle(panelInstance.mask, 'height', "".concat(windowToUse.innerHeight, "px"));
      }
    }, panelInstance, false);
  }
  panelInstance.subscribe('hide', function (type, args, panelInstance) {
    if (window.YAHOO.fcom.Page.isOverlayIframeRequired()) {
      window.YAHOO.fcom.Page.getIFrameHandler().removeOverlayActive(panelInstance.id);
    }
    var overlayChilds = window.YAHOO.fcom.Dom.getDescendantsBy(panelInstance.element, function (node) {
      return !window.fcom.util.StringHelper.empty(node.id) && window.domToYUIMap[node.id] && window.domToYUIMap[node.id] != null;
    });
    if (overlayChilds == null || !overlayChilds.length) {
      return;
    }
    for (var i = 0; i < overlayChilds.length; i++) {
      var overlay = window.domToYUIMap[overlayChilds[i].id];
      // FIX: Even if overlay already has been destroyed 'domToYUIMap' still delivers a Zombie instance.
      // Calling a function on this Zombie causes an exception.
      // To avoid this, check if the config === null, this identifies the Zombi state.
      if (overlay && overlay.cfg && typeof overlay.hide === 'function') {
        overlay.hide();
      }
    }
    if (typeof closeCallback == 'function') {
      closeCallback();
    }
  }, panelInstance, false);
  panelInstance.subscribe('show', function (type, args, panelInstance) {
    if (window.YAHOO.fcom.Page.isOverlayIframeRequired()) {
      if (window.YAHOO.fcom.Page.isOverlayIframeRequired()) {
        window.YAHOO.fcom.Page.getIFrameHandler().addOverlayActive(panelInstance.id);
      }
    }
    // correct panelPosition

    var overlayChilds = window.YAHOO.fcom.Dom.getDescendantsBy(panelInstance.element, function (node) {
      return !window.fcom.util.StringHelper.empty(node.id) && window.domToYUIMap[node.id] && window.domToYUIMap[node.id] != null;
    });
    if (overlayChilds == null || overlayChilds.length === 0) {
      return;
    }
    overlayChilds.forEach(function (child) {
      var overlay = window.domToYUIMap[child.id];
      if (overlay && overlay.show && !(overlay instanceof window.YAHOO.fcom.DateInput)) {
        // don't open popup calendars!
        overlay.show();
      }
    });
  }, panelInstance, false);
};
var _default = exports.default = {
  openPanelFromMarkup: openPanelFromMarkup,
  fillPanelFromAjax: fillPanelFromAjax,
  getPanelPopup: getPanelPopup,
  replacePanelContentByString: replacePanelContentByString,
  replacePanelContent: replacePanelContent,
  hidePanelByButton: hidePanelByButton,
  hidePanel: hidePanel,
  hideParentMask: hideParentMask,
  showParentMask: showParentMask,
  noChacheId: noChacheId,
  removePopupsearchMarkup: removePopupsearchMarkup,
  subscribeHideAndShowEvents: subscribeHideAndShowEvents,
  hideFieldPanel: hideFieldPanel
};
window.openPanelFromMarkup = openPanelFromMarkup;
window.fillPanelFromAjax = fillPanelFromAjax;
window.getPanelPopup = getPanelPopup;
window.replacePanelContentByString = replacePanelContentByString;
window.replacePanelContent = replacePanelContent;
window.hidePanelByButton = hidePanelByButton;
window.hidePanel = hidePanel;
window.hideParentMask = hideParentMask;
window.showParentMask = showParentMask;
window.noChacheId = noChacheId;
window.removePopupsearchMarkup = removePopupsearchMarkup;
window.subscribeHideAndShowEvents = subscribeHideAndShowEvents;
window.hideFieldPanel = hideFieldPanel;

},{"core/Ajax/objectToPostdata":7,"core/Overlays":33}],36:[function(require,module,exports){
"use strict";

/*
 * Create a new radio button instance.
 * @param {HTMLElement} inputEl the actual radio input
 * @param {HTMLElement[]} groupArray list of radio inputs that belong to the same group
 *
 * @class Resembles a skinned radio button, which has a consistent look and feel across operating systems and browsers.
 * The radio buttons have an input field and can be used in forms.
 * A radio button is created by using the HTML markup for a radio input element:
 * <pre>
 *     &lt;input name="myGroup" type="radio" class="radio" value="1" /&gt;
 *     &lt;input name="myGroup" type="radio" class="radio" value="2" /&gt;
 * </pre>
 * The actual instances are created by progessive enhancement on page initialization ({@link initButtons}).
 * Radiobuttons are usually created in groups (identical name attributes). In a radio button group, radio values are
 * selected exclusively. For getting the value of a radio group, use {@link YAOO.fcom.Forms.getCheckedRadioValue}.
 */
window.YAHOO.fcom.Radio = function (inputEl, groupArray) {
  if (window.YAHOO.lang.isString(inputEl)) {
    inputEl = window.Dom.get(inputEl);
  }
  /*
   * The radio input element
   * @type HTMLElement
   */
  this.domNode = inputEl;
  /*
   * List of instances that belong to the same radio group
   * @type window.YAHOO.fcom.Radio[]
   */
  this.groupArray = [];
  // keep a reference to the other radio instances in the group
  if (groupArray && window.YAHOO.lang.isArray(groupArray)) {
    this.groupArray = groupArray;
    this.groupArray[groupArray.length] = this;
  }
  this.img = document.createElement('span');
  this.status = document.createElement('span');
  this.img.appendChild(this.status);
  inputEl.parentNode.insertBefore(this.img, inputEl);
  this.setImage();
  window.Dom.addClass(this.img, 'radiobutton');
  YAHOO.util.Event.addListener(this.domNode, 'change', this.onChange, this, true);
  YAHOO.util.Event.addListener(this.img, 'click', function (eventArg) {
    YAHOO.util.Event.stopEvent(eventArg); // avoid event bubbling through
  }, this, null);
  YAHOO.util.Event.addListener(this.img, 'mouseup', function (eventArg, radioElem) {
    if (!window.Dom.hasClass(this.domNode, 'disabled')) {
      radioElem.setChecked();
      if (radioElem.domNode.onclick) {
        radioElem.domNode.onclick(); // call the onclick of the real input tag
      }
    }

    YAHOO.util.Event.stopEvent(eventArg); // avoid event bubbling through
  }, this, null);
  YAHOO.util.Event.addListener(this.img, 'mouseover', function (eventArg, radioElem) {
    if (!radioElem.domNode.checked) {
      radioElem.replaceImage('-hover');
    }
  }, this, null);
  YAHOO.util.Event.addListener(this.img, 'mouseout', function (eventArg, radioElem) {
    radioElem.replaceImage();
  }, this, null);
  YAHOO.util.Event.addListener(this.img, 'mousedown', function (eventArg, radioElem) {
    if (!radioElem.domNode.checked) {
      radioElem.replaceImage('-active');
    }
  }, this, null);
  YAHOO.util.Event.addListener(this.img, 'mouseup', function (eventArg, radioElem) {
    radioElem.replaceImage();
  }, this, null);
};
window.YAHOO.fcom.Radio.prototype = {
  /*
   * Changes the backgroundimage according to the state-css-class of the radio button.
   * @private
   * @param {Boolean} onOff
   */

  setImage: function setImage() {
    window.Dom.addClass(this.status, this.getCssClassPrefix());
  },
  replaceImage: function replaceImage(classPostFix) {
    window.Dom.setAttribute(this.status, 'class', this.getCssClassPrefix() + (classPostFix || ''));
  },
  getCssClassPrefix: function getCssClassPrefix() {
    return this.domNode.checked ? 'checked' : 'unchecked';
  },
  /*
   * Select or unselect a radiobutton. The <tt>change</tt>-Event will be fired for the radio input.
   * When the parameter <tt>silent</tt> equals <tt>true</tt>, the event will not be fired.
   * Use the <tt>silent</tt> parameter when updating the checkbox state from code.
   * @param {Boolean} silent
   */
  setChecked: function setChecked(silent) {
    silent = silent || false;
    if (!window.Dom.hasClass(this.domNode, 'disabled') && !this.domNode.checked) {
      this.domNode.checked = true;
      if (!silent) {
        window.YAHOO.fcom.Event.fireEvent(this.domNode, 'change');
      } else {
        this.onChange();
      }
    }
  },
  /*
   * Reset the radio button
   */
  reset: function reset() {
    this.replaceImage();
  },
  /*
   * On change handler which handles radio button group
   * @private
   */
  onChange: function onChange() {
    if (this.groupArray) {
      for (var i = 0; i < this.groupArray.length; i++) {
        this.groupArray[i].replaceImage();
      }
    }
  },
  /*
   * Returns true if the radio button is selected
   * @return {Boolean}
   */
  isSelected: function isSelected() {
    return this.domNode.checked;
  },
  /*
   * Add a listener to this RadioButton.
   * The Signature is the same as window.YAHOO.widget.Button.on().
   * @param {String} sType type of event
   * @param {Function} fn event handler function
   * @param {Object} obj object passed to the handler
   * @param {Boolean} override if true, obj becomes the execution scope
   * @return {Boolean} true if successful
   */
  on: function on(sType, fn, obj, override) {
    return window.YAHOO.util.Event.addListener(this.img, sType, fn, obj, override);
  }
};

},{}],37:[function(require,module,exports){
"use strict";

/*
 * display a waiting symbol, so that the user knows something is
 * happening in the background. The waiting state will be kept until
 * the method is called again with enabled == false.
 * @param enabled boolean telling whether to show or hide the waiting symbol
 * @param blockElement optional id or html node which will be overlayed by a
 *              transparent div, so that all mouse events are disabled there.
 *              Instead of an element, also boolean true can be passed, then
 *              the whole browser window will be blocked. When null is passed, also the whole
 *              browser window will be blocked. Just pass false or don't pass the argument, to not block anything.
 */
window.showWait = function (enabled, blockElement) {
  var maskNode = window.Dom.get('showWaitMask');
  var bannerNode = window.getProgressBanner();
  if (blockElement) {
    if (blockElement == null || blockElement === true) {
      blockElement = document.body;
    } else if (window.YAHOO.lang.isString(blockElement)) {
      blockElement = window.Dom.get(blockElement);
    }
  }

  //inline function to get blocksize
  function getBlockElSize(blockEl) {
    if (blockEl === document.body) {
      return {
        width: "".concat(window.Dom.getDocumentWidth(), "px"),
        height: "".concat(window.Dom.getDocumentHeight(), "px")
      };
    } else {
      return {
        width: "".concat(window.Dom.getRegion(blockElement).right - window.Dom.getRegion(blockElement).left, "px"),
        height: "".concat(window.Dom.getRegion(blockElement).bottom - window.Dom.getRegion(blockElement).top, "px")
      };
    }
  }
  if (blockElement && blockElement != null) {
    if (!maskNode) {
      maskNode = document.createElement('div');
      maskNode.id = 'showWaitMask';
      document.body.insertBefore(maskNode, document.body.firstChild);
      window.Dom.setStyle(maskNode, 'background-color', '#FFFFFF');
      window.Dom.setStyle(maskNode, 'opacity', '0.01'); //internet explorer fix to make mask "modal"
      window.Dom.setStyle(maskNode, 'position', 'absolute');
      YAHOO.util.Event.addListener(maskNode, 'click', function (e) {
        YAHOO.util.Event.stopEvent(e);
        return false;
      }, maskNode, true);
      /* TODO this listener is executed before elements are resized,
       * so the mask that has a different blocker element than document.body
       * is not resized. Mostly document.body is used anyways.
       */
      window.YAHOO.widget.Overlay.windowResizeEvent.subscribe(function () {
        if (window.Dom.getStyle(this, 'display') !== 'none' && this.blockEl != null) {
          var size = getBlockElSize(this.blockEl);
          this.style.width = size.width;
          this.style.height = size.height;
          window.Dom.setXY(this, window.Dom.getXY(this.blockEl));
        }
      }, maskNode, true);
    }
  }
  if (enabled) {
    var documentWidth = document.body.clientWidth;
    var bannerWidth = bannerNode.clientWidth;
    //xCoord assures that banner stays within viewport
    var xCoord = window.mouseCoords[0] + 10 + bannerWidth > documentWidth ? documentWidth - bannerWidth - 10 : window.mouseCoords[0] + 10;
    window.Dom.setStyle(bannerNode, 'display', 'block');
    window.Dom.setStyle(bannerNode, 'visibility', 'visible');
    window.Dom.setX(bannerNode, xCoord);
    window.Dom.setY(bannerNode, window.mouseCoords[1] + 10);
    window.Dom.setStyle(bannerNode, 'z-index', '100000');
    window.Dom.setStyle(document.body, 'cursor', 'wait');
    if (blockElement) {
      window.Dom.setStyle(maskNode, 'z-index', '100000');
      window.Dom.setStyle(maskNode, 'display', '');
      window.Dom.setXY(maskNode, window.Dom.getXY(blockElement));
      var size = getBlockElSize(blockElement);
      maskNode.style.width = size.width;
      maskNode.style.height = size.height;
      maskNode.blockEl = blockElement; //reference to block element for resize handler
    }
  } else {
    window.Dom.setStyle(bannerNode, 'display', 'none');
    window.Dom.setStyle(document.body, 'cursor', '');
    window.Dom.setStyle(bannerNode, 'z-index', '0');
    if (maskNode && maskNode != null) {
      window.Dom.setStyle(maskNode, 'z-index', '0');
      window.Dom.setStyle(maskNode, 'display', 'none');
    }
  }
};

/*
 * Get the progress banner element. If it does not
 * exisit yet, it will be created.
 * @return HTMLElement
 */
window.getProgressBanner = function () {
  var bannerNode = window.Dom.get('showWaitSymbolNode');
  if (!bannerNode) {
    bannerNode = document.createElement('div');
    bannerNode.id = 'showWaitSymbolNode';
    document.body.insertBefore(bannerNode, document.body.firstChild);
    window.Dom.addClass(bannerNode, 'progress');
    window.Dom.setStyle(bannerNode, 'position', 'absolute');
    window.Dom.setStyle(bannerNode, 'z-index', 1);
    bannerNode.innerHTML = window.waitProgressText;
  }
  return bannerNode;
};

},{}],38:[function(require,module,exports){
"use strict";

// for private use by standardSearchResult.jsp (evaluating click on a tab)
window.displayTabContents = function (link, fromPanel) {
  if (!fromPanel) {
    window.redirectTo(link);
    return;
  }
  window.showWait(true);
  var callback = {
    success: function success(o) {
      if (o.responseText && o.responseText != null && o.responseText.length > 0 || o.responseText === '' && typeof replaceEmptyLoc != 'undefined') {
        window.showWait(false);
        var insertTD = window.Dom.get('instrumentsSearchPopupRefineTD');
        insertTD.innerHTML = o.responseText;
        // workaround for strange misplacement bug - start
        var outerDiv = window.Dom.getElementsByClassName('module', 'div', insertTD)[0];
        if (outerDiv) {
          var persistenceInput = window.Dom.getElementsBy(function () {
            return true;
          }, 'INPUT', outerDiv)[0];
          if (persistenceInput && persistenceInput != null) {
            var persistenceForm = document.createElement('FORM');
            outerDiv.removeChild(persistenceInput);
            persistenceForm.appendChild(persistenceInput);
            outerDiv.appendChild(persistenceForm);
            var innerDiv = window.Dom.getElementsByClassName('moduleContent', 'div', insertTD)[0];
            innerDiv.parentNode.removeChild(innerDiv);
            outerDiv.appendChild(innerDiv);
          }
        }
        // workaround for strange misplacement bug - end

        window.initDocument(insertTD, true);
      } else {
        // ignore this internal issue
      }
    }
  };
  window.ngpAsyncRequest('GET', link, callback);
};
window.displayTabContentsEncoded = function (link, searchTerm, fromPanel) {
  window.displayTabContents(window.FUtil.format(link, [encodeURIComponent(searchTerm)]), fromPanel);
};

},{}],39:[function(require,module,exports){
"use strict";

/*
 * class to animate a ticker div with price data in tickerItem spans
 * @param tickerDiv the id or the dom node reference of the div where the items should be scrolled into
 * @param tickerItemsDiv the id or the dom node reference of the div with the tickerdata inside.
 * @param config optional object which can be used to change ticker behavior. Expected parameters are
 *        "delay" which is the number in milliseconds one set of items is shown.
 *        "url" which is the url where the ticker can get an update of all items via ajax.
 */
window.YAHOO.fcom.Ticker = function (tickerDiv, tickerItemsDiv, config) {
  if (window.YAHOO.lang.isString(tickerDiv)) {
    tickerDiv = window.Dom.get(tickerDiv);
  }
  if (window.YAHOO.lang.isString(tickerItemsDiv)) {
    tickerItemsDiv = window.Dom.get(tickerItemsDiv);
  }
  this.numItemsPerLine = 4;
  if (config.numItemsPerLine) {
    this.numItemsPerLine = config.numItemsPerLine;
  }
  var controlsElem = window.Dom.getFirstChildBy(tickerDiv, function (elem) {
    return Dom.hasClass(elem, 'controls');
  });
  this.tickerDiv = tickerDiv; // the visible ticker div that gets shifted
  this.tickerItemsDiv = tickerItemsDiv;
  this.numberItems = window.Dom.getChildren(this.tickerItemsDiv).length;
  this.showDiv = document.createElement('div'); // build new div that will hold the shown entries
  if (controlsElem) {
    this.tickerDiv.insertBefore(this.showDiv, controlsElem); // append before controls
  } else {
    this.tickerDiv.appendChild(this.showDiv); // append it to the frameDiv
  }

  this.nextTickerItem = window.Dom.getFirstChild(this.tickerItemsDiv);
  this.delay = 8000;
  this.itemOffset = 0; // needed to continue with the next items when the content is reloaded.
  this.url = null;
  if (config) {
    if (config.delay && config.delay != null && !isNaN(config.delay)) {
      this.delay = config.delay;
    }
    if (config.url && config.url != null) {
      this.url = config.url;
      this.lastUpdate = new Date().getTime();
    }
  }
  this.showNextItems(); // start the ticker process
};

window.YAHOO.fcom.Ticker.prototype = {
  showNextItems: function showNextItems() {
    if (window.ngpQuickview && window.ngpQuickview.currentTarget) {
      if (window.Dom.getAncestorByClassName(window.ngpQuickview.currentTarget, 'headerTicker') || window.Dom.getAncestorByClassName(window.ngpQuickview.currentTarget, 'ticker')) {
        window.YAHOO.lang.later(this.delay, this, 'showNextItems', null, false);
        return;
      }
    }
    if (window.ngpQuickview && window.ngpQuickview.oldTarget) {
      if (window.Dom.getAncestorByClassName(window.ngpQuickview.oldTarget, 'headerTicker') || window.Dom.getAncestorByClassName(window.ngpQuickview.oldTarget, 'ticker')) {
        window.YAHOO.lang.later(this.delay, this, 'showNextItems', null, false);
        return;
      }
    }
    if (this.lastUpdate && this.lastUpdate + 60000 < new Date().getTime()) {
      // update needed and ticker items too old?
      this.reloadItems(); // reload the ticker items
      this.lastUpdate = new Date().getTime(); // set current time as last update time
      return;
    } else if (this.showDiv.childNodes.length > 0) {
      // only when no update was done, remove the nodes back into the tickerItemsDiv
      if (this.numberItems > this.numItemsPerLine) {
        var appendBefore = this.nextTickerItem;
        for (var i = 0; i < this.numItemsPerLine; i++) {
          var moveBackNode = window.Dom.getLastChild(this.showDiv);
          if (moveBackNode && moveBackNode != null) {
            this.tickerItemsDiv.insertBefore(moveBackNode, appendBefore);
            appendBefore = moveBackNode;
          } else {
            break;
          }
        }
      }
    }
    var numberOf = Math.min(this.numItemsPerLine, this.numberItems);
    for (var _i = 0; _i < numberOf; _i++) {
      var moveUpNode = this.nextTickerItem;
      this.nextTickerItem = window.Dom.getNextSibling(this.nextTickerItem);
      this.itemOffset++;
      if (this.nextTickerItem == null) {
        this.nextTickerItem = window.Dom.getFirstChild(this.tickerItemsDiv);
        this.itemOffset = 0;
      }
      this.showDiv.appendChild(moveUpNode);
    }
    var originalY = window.Dom.getY(this.showDiv);
    window.Dom.setY(this.showDiv, originalY + this.showDiv.offsetHeight);
    var a = new window.YAHOO.util.Motion(this.showDiv, {
      points: {
        to: [window.Dom.getX(this.showDiv), originalY]
      }
    }, 0.7, window.YAHOO.util.Easing.easeOut);
    a.animate();
    if (this.numberItems > this.numItemsPerLine) {
      window.YAHOO.lang.later(this.delay, this, 'showNextItems', null, false);
    } else if (this.numberItems > 0) {
      window.YAHOO.lang.later(this.delay + 60000, this, 'reloadItems', null, false);
    }
  },
  /*
   * reload the content of the ticker to get up to date prices. When streaming is enabled,
   * the url will not be filled and thus no reload will be triggered.
   */
  reloadItems: function reloadItems() {
    if (!this.url) {
      return;
    }
    var handleSuccess = function handleSuccess(o) {
      // build success handler
      if (o.responseText && o.responseText != null && o.responseText.length > 0) {
        var container = o.argument[0].tickerItemsDiv;
        container.innerHTML = o.responseText;
        o.argument[0].numberItems = window.Dom.getChildren(container).length;
        o.argument[0].showDiv.innerHTML = '';
        o.argument[0].nextTickerItem = window.Dom.getFirstChild(container);
        for (var i = 0; i < o.argument[0].itemOffset; i++) {
          o.argument[0].nextTickerItem = window.Dom.getNextSibling(o.argument[0].nextTickerItem);
          if (o.argument[0].nextTickerItem == null) {
            // number of ticker items seems to have changed??? => just take the first one
            o.argument[0].nextTickerItem = window.Dom.getFirstChild(container);
            break;
          }
        }
        o.argument[0].showNextItems();
      }
    };
    var handleFailure = function handleFailure(o) {
      //in case of any just continue drawing the old items and retry later.
      o.argument[0].showNextItems();
    };

    // callback object to pass to the YUI conection manager
    var callback = {
      success: handleSuccess,
      failure: handleFailure,
      argument: [this],
      forceCallback: true,
      silent: true
    };
    window.ngpAsyncRequest('GET', this.url, callback);
  },
  stop: function stop() {}
};
window.removeTicker = function (tickerName, tickerContainer) {
  var url = '/usersettings.action';
  var callback = {
    success: function success() {
      var tickerFrame = window.Dom.get('tickerFrame');
      tickerFrame.removeChild(window.Dom.get(tickerContainer));
      tickerFrame.removeChild(window.Dom.get("".concat(tickerContainer, "Items")));
    },
    failure: function failure() {}
  };
  var params = "method=handleRemoveTicker&ticker".concat(tickerName, "=off");
  window.ngpAsyncRequest('POST', url, callback, params);
};

},{}],40:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * Convert checkboxes with markup class switch to toggle switches.
 * TODO:
 	1. When the given checkbox do not have an id given custom id must be created for created nodes
 	2. Convert to pure ES6
 	3. Code must execute on pages & pannels with out making any calls outside this file ?
*/

var checkBoxToToggleSwitch = function checkBoxToToggleSwitch() {
  var toggleSwitchables = document.querySelectorAll('input[type="checkbox"][class*="switch"]');
  toggleSwitchables.forEach(function (chbxNode) {
    var containerNode = document.createElement('label');
    containerNode.setAttribute("id", chbxNode.id + '_container');
    containerNode.setAttribute("class", "tgswitch");
    var __chbxNode = chbxNode.cloneNode(true);
    var sliderNode = document.createElement('span');
    sliderNode.setAttribute("id", chbxNode.id + '_slider');
    sliderNode.setAttribute("class", "tgsslider");
    sliderNode.classList.add("round");
    sliderNode.classList.add("printbg");
    containerNode.appendChild(__chbxNode);
    containerNode.appendChild(sliderNode);
    chbxNode.parentNode.replaceChild(containerNode, chbxNode);
  });
};
var _default = exports.default = {
  checkBoxToToggleSwitch: checkBoxToToggleSwitch
};
window.checkBoxToToggleSwitch = checkBoxToToggleSwitch;
$(document).ready(function () {
  checkBoxToToggleSwitch();
});

},{}],41:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * this function can be used when the caller does not know when the widget (e.g. a dropmenu or a dateInput)
 * will be ready initialized, because the initialization is done in some onDOMReady function block.
 * This function will poll the given variable name from time to time and check whether the variable holds
 * a ready initialized reference of one of those widgets.
 * @param variableName a string with the variable name. It is important to pass a string, not the variable itself, because passing the empty variable
 *                     reference itself will never update, even if the content behind changes. The string will be called with the evil javascript eval function
 *                     and thus it is possible to find out when this global variable actually got a value.
 * @param functionObject the function to be called when the widget is ready to be used
 * @param parameterObject an object to be passed to the given function as only parameter. If several objects are needed, pass an array and the function will be called with that array.
 * @param tryAgainIn this is the number of milliseconds to try again, when reference is not found.
 *                   The value will be doubled automatically each try, to avoid endless javascript delay when an element is missing or similar.
 *                   The parameter is optional, if not given, the default is starting with 150 ms
 */
var onWidgetReferenceReady = function onWidgetReferenceReady(variableName, functionObject, parameterObject, tryAgainIn) {
  if (!variableName) {
    return;
  }
  if (!tryAgainIn || !window.YAHOO.lang.isNumber(tryAgainIn)) {
    tryAgainIn = 150;
  }
  if (window.YAHOO.lang.isString(variableName)) {
    var theReference = window[variableName];
    // if the ready loaded field is there (for own fcom widgets) or the widget reference is in the domToYui Map it should be ready
    if (theReference && theReference != null && theReference.readyLoaded) {
      functionObject(parameterObject);
    } else {
      window.YAHOO.lang.later(tryAgainIn, null, function (argArray) {
        window.onWidgetReferenceReady(argArray[0], argArray[1], argArray[2], argArray[3] * 2);
      }, [[variableName, functionObject, parameterObject, tryAgainIn]]);
    }
  }
};
var _default = exports.default = onWidgetReferenceReady;
window.onWidgetReferenceReady = onWidgetReferenceReady;

},{}],42:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectToPostdata = _interopRequireDefault(require("core/Ajax/objectToPostdata"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * This functions sends the user to a new url <br/>
 * @param {string} url If the url passed in starts with a slash (<code>/</code>) it will automatically be prefixed by <code>window.context</code>
 * @param {Object} [params] an object of request parameters that will be serialized automatically
 */
var redirectTo = function redirectTo(url, params) {
  var targetUrl = url;
  if (url.indexOf('/') === 0) {
    targetUrl = window.ctx + url;
  }
  if (params) {
    targetUrl += (url.indexOf('?') > -1 ? '&' : '?') + (0, _objectToPostdata.default)(params);
  }
  window.location = targetUrl;
};
window.redirectTo = redirectTo;
var _default = exports.default = redirectTo;

},{"core/Ajax/objectToPostdata":7}],43:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = function _default() {
  return new Promise(function (resolve) {
    var times = [];
    var fps;
    var limit = 99;
    var i = 0;
    var refreshLoop = function refreshLoop(resolve) {
      window.requestAnimationFrame(function () {
        var now = performance.now();
        while (times.length > 0 && times[0] <= now - 1000) {
          times.shift();
        }
        times.push(now);
        if (times.length === fps || i > limit) {
          resolve(fps);
        } else {
          fps = times.length;
          i++;
          refreshLoop(resolve);
        }
      });
    };
    refreshLoop(resolve);
  });
};

},{}],44:[function(require,module,exports){
module.exports = require('./lib/axios');
},{"./lib/axios":46}],45:[function(require,module,exports){
'use strict';

var utils = require('./../utils');
var settle = require('./../core/settle');
var cookies = require('./../helpers/cookies');
var buildURL = require('./../helpers/buildURL');
var buildFullPath = require('../core/buildFullPath');
var parseHeaders = require('./../helpers/parseHeaders');
var isURLSameOrigin = require('./../helpers/isURLSameOrigin');
var createError = require('../core/createError');

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

},{"../core/buildFullPath":52,"../core/createError":53,"./../core/settle":57,"./../helpers/buildURL":61,"./../helpers/cookies":63,"./../helpers/isURLSameOrigin":66,"./../helpers/parseHeaders":68,"./../utils":71}],46:[function(require,module,exports){
'use strict';

var utils = require('./utils');
var bind = require('./helpers/bind');
var Axios = require('./core/Axios');
var mergeConfig = require('./core/mergeConfig');
var defaults = require('./defaults');

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = require('./cancel/Cancel');
axios.CancelToken = require('./cancel/CancelToken');
axios.isCancel = require('./cancel/isCancel');

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = require('./helpers/spread');

// Expose isAxiosError
axios.isAxiosError = require('./helpers/isAxiosError');

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;

},{"./cancel/Cancel":47,"./cancel/CancelToken":48,"./cancel/isCancel":49,"./core/Axios":50,"./core/mergeConfig":56,"./defaults":59,"./helpers/bind":60,"./helpers/isAxiosError":65,"./helpers/spread":69,"./utils":71}],47:[function(require,module,exports){
'use strict';

/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;

},{}],48:[function(require,module,exports){
'use strict';

var Cancel = require('./Cancel');

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;

},{"./Cancel":47}],49:[function(require,module,exports){
'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

},{}],50:[function(require,module,exports){
'use strict';

var utils = require('./../utils');
var buildURL = require('../helpers/buildURL');
var InterceptorManager = require('./InterceptorManager');
var dispatchRequest = require('./dispatchRequest');
var mergeConfig = require('./mergeConfig');
var validator = require('../helpers/validator');

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      forcedJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      clarifyTimeoutError: validators.transitional(validators.boolean, '1.0.0')
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;

},{"../helpers/buildURL":61,"../helpers/validator":70,"./../utils":71,"./InterceptorManager":51,"./dispatchRequest":54,"./mergeConfig":56}],51:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;

},{"./../utils":71}],52:[function(require,module,exports){
'use strict';

var isAbsoluteURL = require('../helpers/isAbsoluteURL');
var combineURLs = require('../helpers/combineURLs');

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};

},{"../helpers/combineURLs":62,"../helpers/isAbsoluteURL":64}],53:[function(require,module,exports){
'use strict';

var enhanceError = require('./enhanceError');

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};

},{"./enhanceError":55}],54:[function(require,module,exports){
'use strict';

var utils = require('./../utils');
var transformData = require('./transformData');
var isCancel = require('../cancel/isCancel');
var defaults = require('../defaults');

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};

},{"../cancel/isCancel":49,"../defaults":59,"./../utils":71,"./transformData":58}],55:[function(require,module,exports){
'use strict';

/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};

},{}],56:[function(require,module,exports){
'use strict';

var utils = require('../utils');

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, mergeDeepProperties);

  return config;
};

},{"../utils":71}],57:[function(require,module,exports){
'use strict';

var createError = require('./createError');

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};

},{"./createError":53}],58:[function(require,module,exports){
'use strict';

var utils = require('./../utils');
var defaults = require('./../defaults');

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};

},{"./../defaults":59,"./../utils":71}],59:[function(require,module,exports){
(function (process){(function (){
'use strict';

var utils = require('./utils');
var normalizeHeaderName = require('./helpers/normalizeHeaderName');
var enhanceError = require('./core/enhanceError');

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = require('./adapters/xhr');
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = require('./adapters/http');
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

}).call(this)}).call(this,require('_process'))
},{"./adapters/http":45,"./adapters/xhr":45,"./core/enhanceError":55,"./helpers/normalizeHeaderName":67,"./utils":71,"_process":73}],60:[function(require,module,exports){
'use strict';

module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

},{}],61:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

},{"./../utils":71}],62:[function(require,module,exports){
'use strict';

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};

},{}],63:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);

},{"./../utils":71}],64:[function(require,module,exports){
'use strict';

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

},{}],65:[function(require,module,exports){
'use strict';

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};

},{}],66:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);

},{"./../utils":71}],67:[function(require,module,exports){
'use strict';

var utils = require('../utils');

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

},{"../utils":71}],68:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};

},{"./../utils":71}],69:[function(require,module,exports){
'use strict';

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

},{}],70:[function(require,module,exports){
'use strict';

var pkg = require('./../../package.json');

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};
var currentVerArr = pkg.version.split('.');

/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */
function isOlderVersion(version, thanVersion) {
  var pkgVersionArr = thanVersion ? thanVersion.split('.') : currentVerArr;
  var destVer = version.split('.');
  for (var i = 0; i < 3; i++) {
    if (pkgVersionArr[i] > destVer[i]) {
      return true;
    } else if (pkgVersionArr[i] < destVer[i]) {
      return false;
    }
  }
  return false;
}

/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  var isDeprecated = version && isOlderVersion(version);

  function formatMessage(opt, desc) {
    return '[Axios v' + pkg.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed in ' + version));
    }

    if (isDeprecated && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

module.exports = {
  isOlderVersion: isOlderVersion,
  assertOptions: assertOptions,
  validators: validators
};

},{"./../../package.json":72}],71:[function(require,module,exports){
'use strict';

var bind = require('./helpers/bind');

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};

},{"./helpers/bind":60}],72:[function(require,module,exports){
module.exports={
  "name": "axios",
  "version": "0.21.4",
  "description": "Promise based HTTP client for the browser and node.js",
  "main": "index.js",
  "scripts": {
    "test": "grunt test",
    "start": "node ./sandbox/server.js",
    "build": "NODE_ENV=production grunt build",
    "preversion": "npm test",
    "version": "npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json",
    "postversion": "git push && git push --tags",
    "examples": "node ./examples/server.js",
    "coveralls": "cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js",
    "fix": "eslint --fix lib/**/*.js"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/axios/axios.git"
  },
  "keywords": [
    "xhr",
    "http",
    "ajax",
    "promise",
    "node"
  ],
  "author": "Matt Zabriskie",
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/axios/axios/issues"
  },
  "homepage": "https://axios-http.com",
  "devDependencies": {
    "coveralls": "^3.0.0",
    "es6-promise": "^4.2.4",
    "grunt": "^1.3.0",
    "grunt-banner": "^0.6.0",
    "grunt-cli": "^1.2.0",
    "grunt-contrib-clean": "^1.1.0",
    "grunt-contrib-watch": "^1.0.0",
    "grunt-eslint": "^23.0.0",
    "grunt-karma": "^4.0.0",
    "grunt-mocha-test": "^0.13.3",
    "grunt-ts": "^6.0.0-beta.19",
    "grunt-webpack": "^4.0.2",
    "istanbul-instrumenter-loader": "^1.0.0",
    "jasmine-core": "^2.4.1",
    "karma": "^6.3.2",
    "karma-chrome-launcher": "^3.1.0",
    "karma-firefox-launcher": "^2.1.0",
    "karma-jasmine": "^1.1.1",
    "karma-jasmine-ajax": "^0.1.13",
    "karma-safari-launcher": "^1.0.0",
    "karma-sauce-launcher": "^4.3.6",
    "karma-sinon": "^1.0.5",
    "karma-sourcemap-loader": "^0.3.8",
    "karma-webpack": "^4.0.2",
    "load-grunt-tasks": "^3.5.2",
    "minimist": "^1.2.0",
    "mocha": "^8.2.1",
    "sinon": "^4.5.0",
    "terser-webpack-plugin": "^4.2.3",
    "typescript": "^4.0.5",
    "url-search-params": "^0.10.0",
    "webpack": "^4.44.2",
    "webpack-dev-server": "^3.11.0"
  },
  "browser": {
    "./lib/adapters/http.js": "./lib/adapters/xhr.js"
  },
  "jsdelivr": "dist/axios.min.js",
  "unpkg": "dist/axios.min.js",
  "typings": "./index.d.ts",
  "dependencies": {
    "follow-redirects": "^1.14.0"
  },
  "bundlesize": [
    {
      "path": "./dist/axios.min.js",
      "threshold": "5kB"
    }
  ]
}

},{}],73:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}]},{},[21]);
;
window.YAHOO.fcom.Event={addMousewheelListener:function(e,n,t,o){e=window.Dom.get(e);l=n,i=t,r=!0===(n=o)?i:n||null;var l,i,r,t=function(){var e=0,n=window.YAHOO.util.Event.getEvent();window.YAHOO.util.Event.preventDefault(n),n&&n.detail&&(e=-n.detail/3),n&&n.wheelDelta&&(e=n.wheelDelta/120),l.call(r,e,n,i)};return e.addEventListener?(e.addEventListener("DOMMouseScroll",t,!1),e.addEventListener("mousewheel",t,!1)):e.attachEvent&&e.attachEvent("onmousewheel",t),t},removeMousewheelListener:function(e,n){(e=window.Dom.get(e)).removeEventListener?(e.removeEventListener("DOMMouseScroll",n,!1),e.removeEventListener("mousewheel",n,!1)):e.detachEvent&&e.detachEvent("onmousewheel",n)},fireEvent:function(e,n){var t=YAHOO.util.Event.getListeners(e,n);if(t&&null!=t)if(window.YAHOO.lang.isArray(t))for(var o=0;o<t.length;o++)t[o].fn.call(t[o].scope,null,t[o].obj);else t.fn.call(t.scope,null,t.obj)},suppressFormSubmition:function(e){e&&((e=window.YAHOO.lang.isString(e)?window.Dom.get(e):e).onkeypress=function(e){return 13!==((e=e||window.event).which||e.keyCode)||(e.cancelBubble=!0,window.YAHOO.util.Event.preventDefault(e),!1)})}};
//# sourceMappingURL=Event.js.map;
(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var _skipLinkOptions = require("aria/skipLinkOptions.inc");
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
var _guid = _interopRequireDefault(require("util/guid"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * @name        : SkipLink
                                                                                                                                                                                                                                                                                                                                                                                               * @description : To implement the skip link mechanism in the ngp application
                                                                                                                                                                                                                                                                                                                                                                                               * @namespace   : YAHOO.fcom.skipLink
                                                                                                                                                                                                                                                                                                                                                                                               * @ticket      : NGPII-15421
                                                                                                                                                                                                                                                                                                                                                                                               * @dependencies: Jquery, YUI
                                                                                                                                                                                                                                                                                                                                                                                               * @references  : https://www.w3.org/TR/WCAG20-TECHS/G1.html#maincontent
                                                                                                                                                                                                                                                                                                                                                                                               *                https://accessibility.oit.ncsu.edu/it-accessibility-at-nc-state/developers/accessibility-handbook/mouse-and-keyboard-events/skip-to-main-content/
                                                                                                                                                                                                                                                                                                                                                                                               * */ //#. Import references
// #. Register the namespace into fcom
window.ngpNamespace('YAHOO.fcom.skipLink');
var SkipLink = /*#__PURE__*/function () {
  function SkipLink(newOptions) {
    _classCallCheck(this, SkipLink);
    // #. Set the options of current skip link navigator
    // #. Extend default options with provided
    this.options = {};
    Object.assign(this.options, _skipLinkOptions.defaultSkipOptions, newOptions || {});

    // #. Public prop to identify the link is rendered or not
    this.contentChecked = false;

    // #. To keep the reference of the skip link
    this.$skipLink = null;

    // #. Initialize the component
    this.init();
  }

  /**
   * @method init
   * @description Initialize the skip link component
   * @public
   */
  _createClass(SkipLink, [{
    key: "init",
    value: function init() {
      this._createSkipLink();
    }

    /**
     * @method render
     * @description Render the component to DOM
     * @public
     */
  }, {
    key: "render",
    value: function render() {
      if (this.options.insertBefore) {
        this.$skipLink.insertBefore(this.options.insertBefore);
      }

      // #. Assign the css classes
      this._addCssClasses();

      // #. Mark the content has been checked to DOM
      this.contentChecked = true;
    }

    /**
     * @method _createSkipLink
     * @description Create and append the skip link
     * @private
     */
  }, {
    key: "_createSkipLink",
    value: function _createSkipLink() {
      this.$skipLink = this._getSkipLink();
    }

    /**
     * @method _createSkipLink
     * @description Get the skip link with updated attributes
     * @private
     */
  }, {
    key: "_getSkipLink",
    value: function _getSkipLink() {
      var _this = this;
      // #. Create the skip to link element
      var $skipToElement = $('<a></a>').text(this.options.title).attr({
        tabindex: 0
      }).addClass('skip-link');

      // #. Check the breakHref enabled or not
      if (this.options.breakHref && this.options.breakHref.enabled === true) {
        // #. Unbind the skip to click event
        $skipToElement.off('click');

        // #. Bind the skip to click event
        $skipToElement.on('click', function () {
          _this._onSkipToClicked();
        });

        // #. Unbind the skip to keydown event
        $skipToElement.off('keydown');

        // #. Bind the skip to keydown event
        $skipToElement.on('keydown', function (event) {
          if (event.keyCode === _keyCodes.default.ENTER) {
            event.preventDefault();
            _this._onSkipToClicked();
          }
        });
        $skipToElement.attr({
          role: 'application',
          'aria-label': this.options.title
        });
      } else {
        // #. Get skip to target element
        var $skipTo = this._getSkipToElement();

        // #. Get id of the element
        var elId = $skipTo.attr('id');

        // #. No Id attr found, create guid and assign as id attr
        if (!elId) {
          elId = _guid.default.generate();
          $skipTo.attr('id', elId);
        }

        // #. tabindex set to -1 - otherwise, skip link not working properly in IE
        if (this._detectMSIE()) {
          $skipTo.attr('tabindex', -1);
        }

        // #. Assign the href as target element id
        $skipToElement.attr('href', "#".concat(elId));
      }
      return $skipToElement;
    }

    /**
     * @method _onSkipTo
     * @description On click event of the skip link element
     * @param skipToLocation: expect a string selector or jquery html object
     * @private
     */
  }, {
    key: "_onSkipToClicked",
    value: function _onSkipToClicked() {
      // #. Get the skip to element
      var $skipTo = this._getSkipToElement();

      // #. Move the focus to specific element
      $skipTo.attr({
        tabindex: 0
      }).focus();

      // #. Hide outline of the focused skip to element
      if (this.options.breakHref.hideOutline === true) {
        $skipTo.css('outline', 'none');
      }
    }

    /**
     * @method _getSkipToElement
     * @description Get element based on the skip to location prop
     * @private
     */
  }, {
    key: "_getSkipToElement",
    value: function _getSkipToElement() {
      var $skipTo = this.options.skipToLocation;
      if (typeof $skipTo === 'string') {
        $skipTo = $($skipTo);
      }

      // #. Get the first element from collection
      if ($skipTo.length > 0) {
        $skipTo = $skipTo.filter(':visible').first();
      }
      return $skipTo;
    }

    /**
     * @method _addCssClasses
     * @description Add custom css classes to skip link
     * @private
     */
  }, {
    key: "_addCssClasses",
    value: function _addCssClasses() {
      this.$skipLink.addClass(this.options.cssClasses.join(' '));
    }

    /**
     * @method _detectMSIE
     * @description Check whether the current browser is internet explorer or not
     * @private
     */
  }, {
    key: "_detectMSIE",
    value: function _detectMSIE() {
      var userAgent = window.navigator && window.navigator.userAgent || '';
      return /(edge|msie|trident)/i.test(userAgent) && !window.opera;
    }
  }]);
  return SkipLink;
}(); // #. Set the skipLink prototype to global fcom prototype
window.YAHOO.fcom.skipLink = SkipLink;

},{"aria/skipLinkOptions.inc":2,"util/enums/keyCodes":3,"util/guid":4}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultSkipOptions = void 0;
/**
 * @description     : To set the default options./values for the skip link component
 * @property title              : Set the title of the skip to element
 * @property skipToLocation     : Query selector string expected to set the focus on skip to link click event
 * @property insertBefore       : Query selector string expected to render the skip to link before the provided element
 * @property cssClasses         : Array of strings expected to set the custom styles to link
 * @property breakHref          : Object prop to override the default href of skip to element
 * @property breakHref.enabled      : To enable the break href, default -false
 * @property breakHref.hideOutline  : Hide outline of the focused skip element
 */

var defaultSkipOptions = exports.defaultSkipOptions = {
  title: 'Skip to content',
  skipToLocation: null,
  insertBefore: null,
  cssClasses: [],
  breakHref: {
    enabled: false,
    hideOutline: true
  }
};

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var KEYCODE = {
  ENTER: 13,
  SPACE: 32,
  ESCAPE: 27,
  ARROW_LEFT: 37,
  ARROW_UP: 38,
  ARROW_RIGHT: 39,
  ARROW_DOWN: 40,
  TAB: 9,
  KeyA: 65,
  KeyD: 68,
  DELETE: 46
};
var _default = exports.default = KEYCODE;

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * @name            : GUID
 * @description     : Generate new GUID and GUID related methods
 */
var GUID = exports.default = /*#__PURE__*/function () {
  function GUID() {
    _classCallCheck(this, GUID);
  }
  _createClass(GUID, null, [{
    key: "generate",
    value:
    /**
     * @method generate
     * @description Static method to generate new GUID
     * @public
     * @static
     */
    function generate() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0;
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
      });
    }
  }]);
  return GUID;
}();

},{}]},{},[1]);
;
(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var YAHOO = window.YAHOO;
var Dom = YAHOO.util.Dom;
var Lang = YAHOO.lang;
YAHOO.fcom.InstrumentsSearchDialog = {
  /*
    Displays a modal instruments search popup and returns immediately.
    callback: an object containing the elements 'success', 'cancel', and
      'error', all of them being functions which will be called when the
      popup is closed. Signatures are:
      success(custom, ric, name, xchgPlaces), cancel(custom), error(custom)
      where xchgPlaces has the format {'text':array, 'value':array}, with
      'text' containing exhchange place names and 'value' associated rics
    searchText: the text entered by the user which we are searching for
    types: a comma-separated list or array of instrument type names. The
      search will be restricted to these types.
    custom: a custom object which will be passed to the callbacks
  */
  show: function show(callback, searchText, types, custom) {
    YAHOO.fcom.InstrumentsSearchDialog.callback = callback;
    YAHOO.fcom.InstrumentsSearchDialog.custom = custom;
    var searchInput = YAHOO.util.Dom.get('instrumentsSearchPopupNameInput');
    var panel = window.openPanelFromMarkup('instrumentsSearchPopupDiv', {
      width: '800px',
      fixedcenter: false,
      visible: false,
      close: true,
      dragOnly: true,
      constraintoviewport: true,
      modal: true
    }, false, custom.parentPanel);
    if (!YAHOO.fcom.InstrumentsSearchDialog.panel || YAHOO.fcom.InstrumentsSearchDialog.panel == null) {
      YAHOO.util.Event.addListener(panel.close, 'click', function () {
        var cb = YAHOO.fcom.InstrumentsSearchDialog.callback;
        if (cb != null && cb.close != null) {
          cb.close(YAHOO.fcom.InstrumentsSearchDialog.custom);
        }
      }, panel, true);
      YAHOO.util.Event.addListener('instrumentsSearchPopupCancel', 'click', function (arg0, panel) {
        panel.hide();
        var cb = YAHOO.fcom.InstrumentsSearchDialog.callback;
        if (cb != null && cb.cancel != null) {
          cb.cancel(YAHOO.fcom.InstrumentsSearchDialog.custom);
        }
      }, panel, true);
      var listener = new YAHOO.util.KeyListener(searchInput, {
        keys: 13
      }, YAHOO.fcom.InstrumentsSearchDialog.search);
      listener.enable();
    }
    YAHOO.fcom.InstrumentsSearchDialog.panel = panel;
    window.instrumentsSearchPopupSelectVar.removeAll();
    if (types == null) {
      window.instrumentsSearchPopupSelectVar.addItems(YAHOO.fcom.InstrumentsSearchDialog.defaultInstrumentTypes);
    } else {
      var typeList;
      var typeArray;
      var defaultTypes = YAHOO.fcom.InstrumentsSearchDialog.defaultInstrumentTypes;
      if (YAHOO.lang.isString(types)) {
        typeList = types;
        typeArray = typeList.split(',');
      } else {
        typeArray = types;
        typeList = typeArray.join(',');
      }
      var instrumentTypes = [];
      // --------------------------------------------------------
      // TODO: THIS IS VERY INEFFICIENT --> NEEDS TO BE REFACTORED
      instrumentTypes[0] = {
        text: defaultTypes[0].text,
        value: typeList,
        selected: true
      };
      for (var i = 0; i < typeArray.length; i++) {
        var thisType = typeArray[i];
        for (var j = 1; j < defaultTypes.length; j++) {
          if (defaultTypes[j].value === thisType) {
            instrumentTypes.push({
              text: defaultTypes[j].text,
              value: thisType,
              selected: false
            });
            break;
          }
        }
      }
      // --------------------------------------------------------

      if (typeArray.length === 1) {
        instrumentTypes.shift();
      }
      window.instrumentsSearchPopupSelectVar.addItems(instrumentTypes);
      window.instrumentsSearchPopupSelectVar.selectByValue(instrumentTypes[0].value);
    }
    window.instrumentsSearchPopupSelectVar.render(document.body);
    var insertTD = YAHOO.util.Dom.get('instrumentsSearchPopupRefineTD');
    insertTD.innerHTML = '';
    if (searchText == null) {
      searchText = '';
    }
    searchInput.value = searchText;
    if (searchText !== '') {
      YAHOO.fcom.InstrumentsSearchDialog.search();
    } else {
      window.showWait(false);
      panel.show();
      panel.cfg.setProperty('y', 50);
      searchInput.select();
    }
  },
  // called by show() if a search text has already been entered by the user,
  //   so that an actual search should be performed before the SearchPanel
  //   is opened.
  search: function search() {
    window.showWait(true, document.body);
    var callback = {
      success: function success(o) {
        if (typeof o.responseText !== 'undefined' && o.responseText !== '' || o.responseText === '' && typeof replaceEmptyLoc != 'undefined') {
          var text = o.responseText;
          var useISIN = YAHOO.fcom.InstrumentsSearchDialog.custom.useISIN;
          if (text.substring(0, 4) === 'RIC:') {
            window.showWait(false);
            YAHOO.fcom.InstrumentsSearchDialog.ricOrIsinChosen('RIC', text.substring(4));
          } else if (useISIN && text.substring(0, 5) === 'ISIN:') {
            window.showWait(false);
            YAHOO.fcom.InstrumentsSearchDialog.ricOrIsinChosen('ID', text.substring(5));
          } else {
            window.showWait(false);
            var insertTD = YAHOO.util.Dom.get('instrumentsSearchPopupRefineTD');
            var panel = YAHOO.fcom.InstrumentsSearchDialog.panel;
            insertTD.innerHTML = text;
            window.initDocument(insertTD, true);
            panel.show();
            panel.cfg.setProperty('y', 50);
            var searchInput = YAHOO.util.Dom.get('instrumentsSearchPopupNameInput');
            searchInput.select();
          }
        } else {
          var cb = YAHOO.fcom.InstrumentsSearchDialog.callback;
          var custom = YAHOO.fcom.InstrumentsSearchDialog.custom;
          window.showWait(false);
          if (cb != null) {
            YAHOO.fcom.InstrumentsSearchDialog.panel.hide();
            cb.error(custom);
          }
        }
      },
      failure: function failure() {
        var cb = YAHOO.fcom.InstrumentsSearchDialog.callback;
        var custom = YAHOO.fcom.InstrumentsSearchDialog.custom;
        if (cb != null) {
          YAHOO.fcom.InstrumentsSearchDialog.panel.hide();
          cb.error(custom);
        }
        window.showWait(false);
      }
    };
    var searchForm = YAHOO.util.Dom.get('instrumentsSearchPopupForm');
    if (searchForm != null) {
      var sUrl = searchForm.action;
      searchForm = YAHOO.fcom.InstrumentsSearchDialog._updateFormWithAddOnParams(searchForm, YAHOO.fcom.InstrumentsSearchDialog.custom.addOnParams);
      // !Anoop : The GET creates troubles with IE becasue of huge largeTablePersist value
      // So using POST
      window.ngpAsyncRequest('POST', sUrl, callback, null, searchForm);
    }
  },
  _updateFormWithAddOnParams: function _updateFormWithAddOnParams(formObj, addOnParams) {
    for (var i in addOnParams) {
      if (Lang.isUndefined(Dom.get(i)) || Lang.isNull(Dom.get(i))) {
        var paramElement = document.createElement('input');
        paramElement.type = 'hidden';
        paramElement.name = i;
        paramElement.id = i;
        paramElement.value = addOnParams[i];
        formObj.appendChild(paramElement);
      } else {
        formObj.elements[i].value = addOnParams[i];
      }
    }
    return formObj;
  },
  // the user has chosen an ISIN from a list
  idChosen: function idChosen(id) {
    YAHOO.fcom.InstrumentsSearchDialog.ricOrIsinChosen('ID', id);
  },
  // an instrument has been chosen by its RIC or ID
  ricOrIsinChosen: function ricOrIsinChosen(type, chosen) {
    var callback = {
      success: function success(o) {
        var cb = YAHOO.fcom.InstrumentsSearchDialog.callback;
        var custom = YAHOO.fcom.InstrumentsSearchDialog.custom;
        if (typeof o.responseText !== 'undefined' && o.responseText !== '' || o.responseText === '' && typeof replaceEmptyLoc != 'undefined') {
          if (cb != null) {
            var parts = o.responseText.split('#');
            var n = (parts.length - 1) / 2;
            var xchg = new Array(n);
            for (var i = 0; i < n; i++) {
              var obj = {};
              obj.value = parts[2 * i];
              obj.text = parts[2 * i + 1];
              xchg[i] = obj;
            }
            YAHOO.fcom.InstrumentsSearchDialog.panel.hide();
            cb.success(custom, parts[0], parts[2 * n], xchg);
          }
        } else if (cb != null) {
          YAHOO.fcom.InstrumentsSearchDialog.panel.hide();
          cb.error(custom);
        }
      },
      failure: function failure(o) {
        if (o.status === 401) {
          window.sessionExpired();
        }
        var cb = YAHOO.fcom.InstrumentsSearchDialog.callback;
        var custom = YAHOO.fcom.InstrumentsSearchDialog.custom;
        if (cb != null) {
          YAHOO.fcom.InstrumentsSearchDialog.panel.hide();
          cb.error(custom);
        }
      },
      waitMask: true
    };
    var useISIN = YAHOO.fcom.InstrumentsSearchDialog.custom.useISIN;
    var sUrl;
    if (useISIN) {
      // chosen must be an ISIN in this case
      sUrl = "search.action?method=getNameForISIN&isin=".concat(chosen);
    } else {
      sUrl = "search.action?method=findRICsAndExchgForID&inputType=".concat(type, "&searchValue=").concat(chosen);
    }
    // !Anoop : The GET creates troubles with IE becasue of huge largeTablePersist value
    // So using POST
    window.ngpAsyncRequest('POST', sUrl, callback);
  },
  // for private use by PopupSearchTag
  // called on creation of the tag
  // allowedTypes: array of strings, or null
  // callback: a function
  // searchInput: an html input object, or a string denoting its ID, or null
  // xchgPlaceSelectVar: the name of a select variable, or 'null'
  // custom: an object, or null
  // parentPanel: reference to the modal panel that opens the Popupsearch
  initFromIcon: function initFromIcon(iconID, allowedTypes, callback, searchInput, supressKeyEvent, useISIN, xchgPlaceSelectVar, custom, popupValidator, cancelCallback, panelCloseCallback, addOnParams, parentPanel) {
    if (YAHOO.lang.isString(searchInput)) {
      searchInput = YAHOO.util.Dom.get(searchInput);
    }
    var props = {};
    props.allowedTypes = allowedTypes;
    props.iconCallback = callback;
    props.iconInputField = searchInput;
    props.xchgSelect = xchgPlaceSelectVar;
    props.custom = custom;
    props.popupValidator = popupValidator;
    props.cancelCallback = cancelCallback;
    props.panelCloseCallback = panelCloseCallback;
    props.useISIN = useISIN;
    props.addOnParams = addOnParams;
    props.parentPanel = parentPanel;
    YAHOO.fcom.InstrumentsSearchDialog.dialogProperties[iconID] = props;
    var listener;
    if (YAHOO.lang.isObject(searchInput) && supressKeyEvent === false) {
      listener = new YAHOO.util.KeyListener(searchInput, {
        keys: 13
      }, function () {
        YAHOO.fcom.InstrumentsSearchDialog.openFromIcon(iconID);
      });
      listener.enable();
    }
  },
  // for private use by PopupSearchTag
  // called on clicking the tag icon
  //   or on pressing enter in the search text input field
  openFromIcon: function openFromIcon(iconID) {
    var props = YAHOO.fcom.InstrumentsSearchDialog.dialogProperties[iconID];
    var searchInput = props.iconInputField;
    var allowedTypes = props.allowedTypes;
    var popupValidator = props.popupValidator;
    if (!YAHOO.lang.isNull(popupValidator) && popupValidator) {
      var result;
      eval("result =".concat(popupValidator, "(custom)"));
      if (!result) {
        return;
      }
    }
    window.showWait(true, document.body);
    var myCallback = {
      success: function success(props, ric, name, xchgPlaces) {
        var cb = props.iconCallback;
        if (!YAHOO.lang.isNull(cb)) {
          cb(ric, name, props.custom);
        }
        window.showWait(false);
        var xchgSelect;
        eval("xchgSelect = ".concat(props.xchgSelect));
        if (xchgSelect && xchgSelect != null) {
          xchgSelect.removeAll();
          xchgSelect.addItems(xchgPlaces);
          xchgSelect.render(document.body);
          // 1st item should be automatically selected,
          // but this doesn't work for some reason, so we do it manually here
          if (xchgPlaces.length > 0) {
            xchgSelect.selectByValue(xchgPlaces[0].value, true);
          }
        }
      },
      cancel: function cancel() {
        window.showWait(false);
        var cb = props.cancelCallback;
        if (!YAHOO.lang.isNull(cb)) {
          cb(props.custom);
        }
      },
      error: function error() {
        window.showWait(false);
        var cb = props.cancelCallback;
        if (!YAHOO.lang.isNull(cb)) {
          cb(props.custom);
        }
      },
      close: function close() {
        window.showWait(false);
        var cb = props.panelCloseCallback;
        if (YAHOO.lang.isNull(cb)) {
          cb = props.cancelCallback;
        }
        if (!YAHOO.lang.isNull(cb)) {
          cb(props.custom);
        }
      }
    };
    var searchForm = YAHOO.util.Dom.get('instrumentsSearchPopupForm');
    searchForm.isinOnly.value = props.useISIN;
    var searchString = null;
    if (YAHOO.lang.isObject(searchInput)) {
      searchString = searchInput.value;
      if (YAHOO.lang.isUndefined(searchString) || '' === searchString) {
        searchString = null;
      }
    }
    var select;
    eval("select = ".concat(props.xchgSelect));
    if (YAHOO.lang.isObject(select)) {
      select.onChangeString = "YAHOO.fcom.InstrumentsSearchDialog.callbackFromDropDown(\"".concat(iconID, "\")");
    }
    YAHOO.fcom.InstrumentsSearchDialog.show(myCallback, searchString, allowedTypes, props);
  },
  // for private use by dropMenu items, initiated by PopupSearchTag
  // called on selecting a new value from the select drop down
  //   which is associated with the given PopupSearchTag
  callbackFromDropDown: function callbackFromDropDown(iconID) {
    var props = YAHOO.fcom.InstrumentsSearchDialog.dialogProperties[iconID];
    var select;
    eval("select = ".concat(props.xchgSelect));
    var ric = select.getSelectedValue();
    if (ric != null) {
      YAHOO.fcom.InstrumentsSearchDialog.ricOrIsinChosen('RIC', ric);
    }
  },
  dialogProperties: {}
};

},{}]},{},[1]);
;
(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var axiosInstance = _axios.default.create({});
axiosInstance.interceptors.request.use(function (config) {
  config.baseURL = "".concat(window.location.origin).concat(window.ctx, "/api/v1/");
  return Promise.resolve(config);
}, function (error) {
  return Promise.reject(error);
});
var _default = exports.default = axiosInstance;

},{"axios":27}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _StreamingAccessibility = _interopRequireDefault(require("accessibility/StreamingAccessibility"));
var _ContextMenuAccessibility = _interopRequireDefault(require("accessibility/ContextMenuAccessibility"));
var _AccordionAccessibility = _interopRequireDefault(require("accessibility/AccordionAccessibility"));
var _TooltipAccessibility = _interopRequireDefault(require("accessibility/TooltipAccessibility"));
var _PopupSearchAccessibility = _interopRequireDefault(require("accessibility/PopupSearchAccessibility"));
var _HighchartsAccessibility = _interopRequireDefault(require("accessibility/HighchartsAccessibility"));
var _NewsPlayerAccessibility = _interopRequireDefault(require("accessibility/NewsPlayerAccessibility"));
var _LoginAccessibility = _interopRequireDefault(require("accessibility/LoginAccessibility"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * @class       : Accessibility
                                                                                                                                                                                                                                                                                                                                                                                               * @description : To enable the web content accessibility(WCAG) in the ngp components
                                                                                                                                                                                                                                                                                                                                                                                               *                  - Streaming modules
                                                                                                                                                                                                                                                                                                                                                                                               *                  - Context menu open button
                                                                                                                                                                                                                                                                                                                                                                                               *                  - Context menu
                                                                                                                                                                                                                                                                                                                                                                                               *                  - Accordion controls
                                                                                                                                                                                                                                                                                                                                                                                               *                  - Tooltip component
                                                                                                                                                                                                                                                                                                                                                                                               *                  - Popup search
                                                                                                                                                                                                                                                                                                                                                                                               *                  - Highcharts/Highstocks
                                                                                                                                                                                                                                                                                                                                                                                               *                  - NEWS Player - top news module
                                                                                                                                                                                                                                                                                                                                                                                               * @dependencies: Jquery, StreamingAccessibility, ContextMenuAccessibility, AccordionAccessibility,
                                                                                                                                                                                                                                                                                                                                                                                               *                TooltipAccessibility, PopupSearchAccessibility, NewsPlayerAccessibility
                                                                                                                                                                                                                                                                                                                                                                                               * @references  : https://www.w3.org/TR/WCAG20-TECHS/
                                                                                                                                                                                                                                                                                                                                                                                               */
var Accessibility = /*#__PURE__*/function () {
  function Accessibility() {
    _classCallCheck(this, Accessibility);
  }
  _createClass(Accessibility, null, [{
    key: "init",
    value:
    /**
     * @method init
     * @description Initialize the accessibility module
     * @public
     * @static
     */
    function init(params) {
      Accessibility._start(params);
    }

    /**
     * @method init
     * @description Update an element title based on the inner text
     * @public
     * @static
     */
  }, {
    key: "compareAndUpdateElementTitle",
    value: function compareAndUpdateElementTitle($elements, compareText, updatedTitle) {
      // #. Identify the delete button based on the inner text value
      $elements.filter(function (index) {
        var $element = $($elements[index]);
        var innerText = $element.text();
        if (String(innerText).trim().replace(/[^a-zA-Z ]/g, '') === String(compareText).trim().replace(/[^a-zA-Z ]/g, '')) {
          $element.attr({
            'aria-label': updatedTitle
          });
        }
      });
    }
  }, {
    key: "_start",
    value:
    /**
     * @method _start
     * @description assign accessibility to accessibility services
     * @param { Object } v expect config information or null
     * @private
     * @static
     */
    function _start(config) {
      if (config) {
        // #. Init the streaming accessibility
        if (config.streamingAccessibility) {
          var streamingAccessibility = new _StreamingAccessibility.default();
          streamingAccessibility.init(config.streamingAccessibility.nodes);
        }

        // #. Init context menu accessibility
        if (config.menu && config.menu.enabled) {
          var contextMenuAccessibility = new _ContextMenuAccessibility.default();
          window.setTimeout(function () {
            contextMenuAccessibility.init();
          }, config.menu.initDelay || 0);
        }

        // #. Init accordion accessibility
        if (config.accordion) {
          var accordionAccessibility = new _AccordionAccessibility.default(config.accordion);
          accordionAccessibility.init();
        }

        // #. Init accordion accessibility
        if (config.tooltip) {
          var tooltipAccessibility = new _TooltipAccessibility.default(config.tooltip);
          tooltipAccessibility.init();
        }

        // #. Init popup search accessibility accessibility
        if (config.popupSearch) {
          var popupSearchAccessibility = new _PopupSearchAccessibility.default(config.popupSearch);
          popupSearchAccessibility.init();
        }

        // #. Init highcharts accessibility module
        if (config.highCharts && config.highCharts.enabled) {
          var highchartsAccessibility = new _HighchartsAccessibility.default(config.highCharts);
          highchartsAccessibility.init();
        }

        // #. Init highcharts accessibility module
        if (config.newsPlayer) {
          var newsPlayerAccessibility = new _NewsPlayerAccessibility.default(config.newsPlayer);
          newsPlayerAccessibility.init();
        }

        // #. Init login page accessibility
        if (config.login) {
          var loginAccessibility = new _LoginAccessibility.default();
          loginAccessibility.init();
        }
      }
    }
  }]);
  return Accessibility;
}(); // #. Set the global access
window.fcom.Accessibility = Accessibility;
var _default = exports.default = Accessibility;

},{"accessibility/AccordionAccessibility":3,"accessibility/ContextMenuAccessibility":4,"accessibility/HighchartsAccessibility":5,"accessibility/LoginAccessibility":6,"accessibility/NewsPlayerAccessibility":7,"accessibility/PopupSearchAccessibility":8,"accessibility/StreamingAccessibility":9,"accessibility/TooltipAccessibility":10}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _guid = _interopRequireDefault(require("util/guid"));
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * @class       : AccordionAccessibility
                                                                                                                                                                                                                                                                                                                                                                                               * @description : To enable the web content accessibility(WCAG) in ngp application accordion(expander/collapse) component
                                                                                                                                                                                                                                                                                                                                                                                               *                - NGPII-15088 JAWS: Expander
                                                                                                                                                                                                                                                                                                                                                                                               * @dependencies: Jquery, GUID
                                                                                                                                                                                                                                                                                                                                                                                               * @references  : https://www.w3.org/TR/wai-aria-practices-1.1/examples/accordion/accordion.html
                                                                                                                                                                                                                                                                                                                                                                                               */
var AccordionAccessibility = /*#__PURE__*/function () {
  function AccordionAccessibility(options) {
    _classCallCheck(this, AccordionAccessibility);
    if (!options) {
      return true;
    }

    // #. Keep the config/options into context
    this.options = options;
    // #. Keep the accordion container
    this.$container = _typeof(options.container) === 'object' ? options.container : $(options.container);
    // #. Keep all accordion toggles
    this.$toggles = null;
    // #. Selector to identify the expanded toggle bar - default 'open' is a css class name
    this.expandSelector = options.expandSelector || 'open';
    /**
     * Keep the panel find selector method(ex: next, Jquery selector)
     * next - consider as method ex: findPanelBy: { method: 'next' }
     * multiple methods will be formatted by space { method: 'parent next' }
     * id - consider as attribute ex: findPanelBy: { attr: 'id' }
     */
    this.findPanelBy = options.findPanelBy || {
      method: 'next'
    };
  }

  /**
   * @method init
   * @description Initialize the accordion accessibility
   * @public
   */
  _createClass(AccordionAccessibility, [{
    key: "init",
    value: function init() {
      // #. Find all accordion toggles
      this.$toggles = this.$container.find(this.options.toggleSelector);
      // #. Set default WCAG attributes
      this._setWCAGAttributes();
      // #. Bind the tracking events to toggle bar
      this._bindEvents(this.$toggles);
    }

    /**
     * @method _setWCAGAttributes
     * @description set WCAG attributes to accordion
     * @private
     */
  }, {
    key: "_setWCAGAttributes",
    value: function _setWCAGAttributes() {
      // todo manage the disabled accordions - check the scope
      // todo manage the multiple open accordions - check the scope
      var _iterator = _createForOfIteratorHelper(this.$toggles),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var $toggle = _step.value;
          $toggle = $($toggle);
          var $panel = this._getPanelByToggle($toggle);

          // #. No panel - then continue
          if (!$panel || $panel.length === 0) {
            return true;
          }

          // #. Set toggle bat attr
          var toggleAttr = {
            'aria-expanded': this._isToggleExpanded($toggle)
          };

          // #. lost toggle not require control attr ex: EditView left panel list
          if (this.options.toggleControlAttr !== false) {
            toggleAttr['aria-controls'] = this._getElementId($panel);
          }

          // #. Update toggle attr
          this._setAttributes($toggle, toggleAttr);

          // #. Set panel display attr
          var panelAttr = {
            'aria-labelledby': this._getElementId($toggle)
          };

          // #. options not require role update ex: EditView left panel list
          if (this.options.panelRoleUpdate !== false) {
            panelAttr.role = 'region';
          }

          // #. Update panel attr
          this._setAttributes($panel, panelAttr);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    /**
     * @method _bindEvents
     * @description bind events to update the attributes
     * @param { HTMLElement } $element expect a element or collection of elements object
     * @private
     */
  }, {
    key: "_bindEvents",
    value: function _bindEvents($element) {
      var _this = this;
      $element.on('keydown click', function (event) {
        var $target = $(event.target);
        var keyCode = event.keyCode;
        if (!keyCode || keyCode === _keyCodes.default.ENTER || keyCode === _keyCodes.default.SPACE) {
          // #. Update expanded attribute
          _this._isToggleExpanded($target, function (value) {
            $target.attr('aria-expanded', value);
          });
        }
      });
    }

    /**
     * @method _isToggleExpanded
     * @description check the expand status of a toggle
     * @param { HTMLElement } $element expect a element or collection of elements object
     * @private
     */
  }, {
    key: "_isToggleExpanded",
    value: function _isToggleExpanded($toggle, callback) {
      var $element = $toggle;
      var selector = this.expandSelector;
      var delay = 0;
      if (_typeof(this.expandSelector) === 'object') {
        if (this.expandSelector.parent) {
          $element = $toggle.parent();
          selector = this.expandSelector.parent;
          delay = this.expandSelector.delay || 0;
        }
      }
      if (callback) {
        window.setTimeout(function () {
          callback($element.hasClass(selector));
        }, delay);
      } else {
        return $element.hasClass(selector);
      }
    }

    /**
     * @method _getElementId
     * @description get id attribute of a element, set new one when no id found
     * @param { HTMLElement } $element expect panel display element object
     * @private
     */
  }, {
    key: "_getElementId",
    value: function _getElementId($element) {
      var elementId = $element.attr('id');
      if (!elementId) {
        elementId = _guid.default.generate();
        $element.attr('id', elementId);
      }
      return elementId;
    }

    /**
     * @method _setAttributes
     * @description set attr object to specific element
     * @param { HTMLElement } $element expect element object
     * @param { Object } attr expect object of attributes
     * @private
     */
  }, {
    key: "_setAttributes",
    value: function _setAttributes($element, attr) {
      $element.attr(attr);
    }

    /**
     * @method _getPanelByToggle
     * @description get corresponding panel by toggle bar
     * @param { HTMLElement } $toggle expect toggle bar element object
     * @private
     */
  }, {
    key: "_getPanelByToggle",
    value: function _getPanelByToggle($toggle) {
      /** Find panel element by series of methods or method
        * multiple methods split by space ex: 'parent next' - means next element of the toggle parent
        * method parameter can passed inside the parenthesis ex: 'parent nextAll(.class1#id)'
        */
      if (this.findPanelBy.method) {
        var $element = null;
        var methods = this.findPanelBy.method.split(' ');
        var _iterator2 = _createForOfIteratorHelper(methods),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var method = _step2.value;
            // #. Check any selectors passed as params
            var selector = '';
            if (method.indexOf('(') !== -1) {
              var params = method.split('(');
              method = params[0];
              selector = String(params[1]).replace(')', '');
            }
            $element = $element ? $($element)[method](selector) : $toggle[method](selector);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        return $element;
      }

      // #. Find panel elements by toggle attribute value
      // #. findClosestOfToggle - will get the attribute value from the closest element of the toggle
      if (this.findPanelBy.attr) {
        var _$element = this.findPanelBy.findClosestOfToggle ? $toggle.closest("[".concat(this.findPanelBy.attr, "]")) : $toggle;
        var attrVal = _$element.attr(this.findPanelBy.attr);
        var _selector = "[".concat(this.findPanelBy.attr, "=\"").concat(attrVal, "\"]");
        return this.$container.find(_selector).not(this.findPanelBy.notInclude || '');
      }
    }
  }]);
  return AccordionAccessibility;
}(); // #. Export the accordion accessibility
var _default = exports.default = AccordionAccessibility;

},{"util/enums/keyCodes":24,"util/guid":26}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * @class       : ContextMenuAccessibility
                                                                                                                                                                                                                                                                                                                                                                                               * @description : To enable the web content accessibility(WCAG) in ngp application context menu component
                                                                                                                                                                                                                                                                                                                                                                                               *                - NGPII-15538 JAWS: Context Menu
                                                                                                                                                                                                                                                                                                                                                                                               *                - Context menu item accessibility handled in ExtendedMenu.es6.js
                                                                                                                                                                                                                                                                                                                                                                                               * @dependencies: Jquery, KEYCODES
                                                                                                                                                                                                                                                                                                                                                                                               * @references  : https://www.w3.org/TR/WCAG20-TECHS/
                                                                                                                                                                                                                                                                                                                                                                                               *                https://www.w3.org/TR/wai-aria-practices/examples/menu-button/menu-button-links.html
                                                                                                                                                                                                                                                                                                                                                                                               */
var ContextMenuAccessibility = /*#__PURE__*/function () {
  function ContextMenuAccessibility() {
    _classCallCheck(this, ContextMenuAccessibility);
    // #. To keep the menu opening button collection
    this.$menuOpenButtons = [];
    // #. CSS class selector of module library menu open button
    this.moduleLibraryButtonSelector = '.icon.showModuleLibrary';
    // #. CSS selector of module content header menu button
    this.moduleHeaderButton = 'table.headerContent .controls .control .icon.options';
    // #. CSS selector of context menu open button
    this.menuOpener = 'button.icon.options';
    // #. Const to declare the button context type
    this.contextType = {
      MODULE_LIBRARY: 1,
      MODULE_CONTROL: 2,
      TABLE_ROW_EDIT: 3
    };
  }

  /**
   * @method init
   * @description Initialize the menu accessibility
   * @public
   */
  _createClass(ContextMenuAccessibility, [{
    key: "init",
    value: function init() {
      // #. Get menu opening button elements
      this.$menuOpenButtons = this._findMenuOpenButtons();
      this._start();
    }

    /**
     * @method _start
     * @description start the basic methods, assign attributes, bind key handler
     * @private
     */
  }, {
    key: "_start",
    value: function _start() {
      // #. Handle the focus, keydown event
      this._bindTrackingEvents();

      // #. Check the count of the streaming nodes
      if (this.$menuOpenButtons.length > 0) {
        this._setWCAGAttributesToButton(this.$menuOpenButtons);
      }
    }

    /**
     * @method _findMenuOpenButtons
     * @description find all menu opening buttons from the body element
     * @return { Array } of menu open button elements
     * @private
     */
  }, {
    key: "_findMenuOpenButtons",
    value: function _findMenuOpenButtons() {
      var $body = $('body');
      return $([].concat(_toConsumableArray($body.find(this.menuOpener)), _toConsumableArray($body.find(this.moduleLibraryButtonSelector))));
    }

    /**
     * @method _setWCAGAttributesToButton
     * @description find all menu opening buttons from the body element
     * @param { HTMLCollectionOf } $buttons expecting collection menu open button elements
     * @private
     */
  }, {
    key: "_setWCAGAttributesToButton",
    value: function _setWCAGAttributesToButton($buttons) {
      $buttons.attr({
        'aria-haspopup': 'menu',
        'aria-expanded': false
      });

      // #. Set unique properties
      this._setButtonUniqueProps($buttons);
    }

    /**
     * @method _setButtonUniqueProps
     * @description set unique button properties
     * @param { HTMLCollectionOf } $buttons expecting collection menu open button elements
     * @private
     */
  }, {
    key: "_setButtonUniqueProps",
    value: function _setButtonUniqueProps($buttons) {
      var _iterator = _createForOfIteratorHelper($buttons),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var $button = _step.value;
          $button = $($button);
          var contextType = this._getContextType($button);

          // #. Update the button title
          this._updateButtonTitle($button, contextType, false);

          // #. Set role application for the module head control div element
          // #. otherwise, keydown will not work properly when JAWS is working
          if (contextType === this.contextType.MODULE_CONTROL) {
            $button.closest('.control').attr({
              role: 'application'
            });
          } else {
            // #. Remove the innerText of the image button, because button already has the title
            var bgImg = String($button.css('background-image')).trim();
            if (bgImg && bgImg !== 'none' && !$button.hasClass('include-text')) {
              $button.text('');
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    /**
     * @method _updateButtonTitle
     * @description update button title based on the context
     *              - Button from the table row
     *              - Button from the module header
     *              - Module library button
     * @param { HTMLElement } $button expecting menu open button object
     * @param { Number } button context type
     * @private
     */
  }, {
    key: "_updateButtonTitle",
    value: function _updateButtonTitle($button, contextType, isOnFocus) {
      var label = this._getTitleByButtonContext($button, contextType, isOnFocus);
      if (label) {
        $button.attr({
          'aria-label': label
        });
      }
    }

    /**
     * @method _getContextType
     * @description get type of button context
     * @param { HTMLElement } $button expecting current button element
     * @private
     */
  }, {
    key: "_getContextType",
    value: function _getContextType($button) {
      if ($button.parent().is('td')) {
        return this.contextType.TABLE_ROW_EDIT;
      } else if ($button.is(this.moduleHeaderButton)) {
        return this.contextType.MODULE_CONTROL;
      } else if ($button.is(this.moduleLibraryButtonSelector)) {
        return this.contextType.MODULE_LIBRARY;
      }
    }

    /**
     * @method _setTitleByButtonContext
     * @description get title/name based on the button context
     * @param { HTMLElement } $button expecting current button element
     * @param { Number } button context type
     * @private
     */
  }, {
    key: "_getTitleByButtonContext",
    value: function _getTitleByButtonContext($button, contextType, isOnFocus) {
      // 1. Get name/title of the table row menu button
      if (contextType === this.contextType.TABLE_ROW_EDIT) {
        var name = this._getInstrumentNameByRow($button) || '';
        return window.getMessage('context.menu.open.name.postfix.tooltip', name);
      }

      // 2. Get name/title of module header menu button
      if (contextType === this.contextType.MODULE_CONTROL) {
        var _name = this._getTitleFromModuleHeader($button) || '';
        // #. Header title text may be 'loading...' when module not loaded yet
        // #. Updated title will be set on the focus event
        if (!isOnFocus) {
          return false;
        }
        return window.getMessage('context.menu.module.open.name.postfix.tooltip', _name);
      }

      // 3. Get module library button
      if (contextType === this.contextType.MODULE_LIBRARY) {
        return $button.attr('title');
      }
    }

    /**
     * @method _getInstrumentNameByRow
     * @description get instrument name from table row
     * @param { HTMLElement } $button expecting current button element
     * @private
     */
  }, {
    key: "_getInstrumentNameByRow",
    value: function _getInstrumentNameByRow($button) {
      var $row = $($button.closest('tr'));
      return $row.find('a.instrumentIdentification').text() || $row.find('span.instrumentIdentification').text() || $row.find('input.searchPopupInput').val() || $row.find('a').first().text();
    }

    /**
     * @method _getTitleFromModuleHeader
     * @description get title from the module header element
     * @param { HTMLElement } $button expecting current button element
     * @private
     */
  }, {
    key: "_getTitleFromModuleHeader",
    value: function _getTitleFromModuleHeader($button) {
      var $row = $($button.closest('tr'));
      return $row.find('h2.title').text() || $row.find('span.content').text();
    }

    /**
     * @method _bindTrackingEvents
     * @description update attributes of lately rendered element(Ex: Modules added from the module library, menu button render after large table sorting...etc)
     * @private
     */
  }, {
    key: "_bindTrackingEvents",
    value: function _bindTrackingEvents() {
      var self = this;
      $(window.document).on('focus', this.menuOpener, function (event) {
        var $button = $(this);
        $button.attr('aria-expanded', false);
        if (!$button.attr('aria-label')) {
          var contextType = self._getContextType($button);
          self._updateButtonTitle($button, contextType, true);
        }
      }).on('keydown', this.menuOpener, function (event) {
        var $button = $(this);
        var keyCode = event.keyCode;
        if (keyCode === _keyCodes.default.ENTER) {
          $button.attr('aria-expanded', true);
        }
      });
    }
  }]);
  return ContextMenuAccessibility;
}();
var _default = exports.default = ContextMenuAccessibility;

},{"util/enums/keyCodes":24}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _messageHandler = require("fcom/messages/messageHandler");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * @class       : HighchartsAccessibility
 * @description : To enable the web content accessibility(WCAG) in ngp application highcharts/highstocks
 *                - https://jira.financial.com/browse/NGPII-15551
 * @dependencies: Highcharts, Highstocks, highchart-exporting, highchart-exporting-data, highcharts-accessibility
 * @references  : https://www.highcharts.com/docs/accessibility/accessibility-module
 *              : https://www.highcharts.com/docs/extending-highcharts/extending-highcharts
 *              : https://www.highcharts.com/docs/getting-started/how-to-set-options
 */
var HighchartsAccessibility = /*#__PURE__*/function () {
  function HighchartsAccessibility(options) {
    _classCallCheck(this, HighchartsAccessibility);
    // #. Keep the config/options into context
    this.options = options;
    // #. Get the highcharts object
    this.H = window.Highcharts;
    // #. Set accessibility options
    this.accessibilityOptions = {
      accessibility: {
        enabled: true,
        keyboardNavigation: {
          enabled: true,
          seriesNavigation: {
            mode: 'normal',
            skipNullPoints: true
          }
        },
        announceNewData: {
          enabled: true,
          interruptUser: true
        }
      }
    };
  }

  /**
   * @method init
   * @description Initialize the highcharts accessibility
   * @public
   */
  _createClass(HighchartsAccessibility, [{
    key: "init",
    value: function init() {
      var self = this;
      /**
       * Enable the chart accessibility globally
       */
      window.Highcharts.setOptions(this.accessibilityOptions);

      /**
       * NOTE:
       * Highcharts created a utility called wrap, which wraps an existing prototype function ("method") and -
       * allows you to add your own code before or after it.
       */

      /**
       * Extend the chart render method
       * To assign the proper role attribute to container element - for screen reader
       */
      this.H.wrap(this.H.Chart.prototype, 'onload', function (proceed) {
        proceed.call(this, arguments);
        self._setWCAGtoChart(this.renderTo);
        self._handleFirefoxTabKeyOrder(this.container);
        self._handleEdgeAccessToChart(this.container);
      });

      /**
       * Extend the tooltip refresh method
       * To assign the tooltip to proper role attributes - for screen reader
       */
      this.H.wrap(this.H.Tooltip.prototype, 'refresh', function (proceed, point, e) {
        proceed.call(this, point, e);
        self._setWCAGtoChartTooltip(this.chart.tooltip.container || this.chart.renderTo);
      });

      /**
       * Extend the tooltip hide method
       * To assign the tooltip table hidden - for screen reader
       */
      this.H.wrap(this.H.Tooltip.prototype, 'hide', function (proceed, point, e) {
        proceed.call(this, point, e);
        self._setWCAGtoHiddenTooltipTable(this.chart.renderTo);
      });

      /**
       * Extend the tooltip show method
       * To assign the tooltip table shown - for screen reader
       */
      this.H.wrap(this.H.Tooltip.prototype, 'show', function (proceed, point, e) {
        proceed.call(this, point, e);
        self._setWCAGtoShownTooltipTable(this.chart.renderTo);
      });
    }
  }, {
    key: "_setWCAGtoHiddenTooltipTable",
    value: function _setWCAGtoHiddenTooltipTable(chartContainer) {
      $(chartContainer).find('div.highcharts-tooltip table').attr('aria-hidden', true);
    }
  }, {
    key: "_setWCAGtoShownTooltipTable",
    value: function _setWCAGtoShownTooltipTable(chartContainer) {
      $(chartContainer).find('div.highcharts-tooltip table').attr('aria-hidden', false);
    }

    /**
     * @method _setWCAGtoChart
     * @description update WCAG attributes to highcharts
     * @param { $chartContainer } expecting chart container html element object
     * @private
     */
  }, {
    key: "_setWCAGtoChart",
    value: function _setWCAGtoChart($chartContainer) {
      $($chartContainer).attr({
        role: 'application'
      });
      if ($('#additionalChartTitleId').length > 0) {
        $($chartContainer).find('.highcharts-container').attr('aria-describedby', 'additionalChartTitleId');
      }
      $($chartContainer).find('[id*="highcharts-data-table"]').attr('aria-hidden', true);
    }

    /**
     * @method _setWCAGtoChartTooltip
     * @description update WCAG attributes to highcharts tooltip
     * @param { $chartContainer } expecting chart container html element object
     * @private
     */
  }, {
    key: "_setWCAGtoChartTooltip",
    value: function _setWCAGtoChartTooltip($chartContainer) {
      var $tooltip = $($chartContainer).find('div.highcharts-tooltip > span');
      if ($tooltip.length > 0) {
        $tooltip.attr('role', 'tooltip');
        $tooltip.attr('aria-live', 'assertive');
        var $tooltipTable = $tooltip.find('table');
        if ($($tooltipTable).find('caption').length === 0) {
          $tooltipTable.prepend($('<caption />').text((0, _messageHandler.getMessage)('chart.tooltip.table.caption')).addClass('visuallyhidden'));
        }
      }
    }

    /**
     * @method _handleFirefoxTabKeyOrder
     * @description set tab key order for the module chart
     * @param { $chartContainer } expecting chart container html element object
     * @private
     */
  }, {
    key: "_handleFirefoxTabKeyOrder",
    value: function _handleFirefoxTabKeyOrder($chartContainer) {
      var isFirefox = navigator.userAgent.search('Firefox');
      var $moduleLink = $($chartContainer).closest('.chartImageBox').children().first();
      if (isFirefox > -1 && $moduleLink.is('a')) {
        $moduleLink.attr('tabindex', -1);
      }
    }

    /**
     * @method _handleEdgeAccessToCahrt
     * @description set descriptive label
     * @param { $chartContainer } expecting chart container html element object
     * @private
     */
  }, {
    key: "_handleEdgeAccessToChart",
    value: function _handleEdgeAccessToChart($chartContainer) {
      var isEdge = navigator.userAgent.search('Edg');
      if (isEdge > -1) {
        var chartContainerId = $($chartContainer).attr('id');
        var describedLabelEle = $('<span>').attr('id', "".concat(chartContainerId, "_describedId")).addClass('visuallyhidden').text((0, _messageHandler.getMessage)('chart.descriptive.text.edg'));
        $($chartContainer).find('svg.highcharts-root').attr('aria-describedby', "".concat(chartContainerId, "_describedId")).before(describedLabelEle);
      }
    }
  }]);
  return HighchartsAccessibility;
}();
var _default = exports.default = HighchartsAccessibility;

},{"fcom/messages/messageHandler":15}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * @class       : LoginAccessibility
 * @description : To enable the web content accessibility(WCAG) in login page
 * @references  : https://developer.mozilla.org/en-US/docs/Web/API/Window/devicePixelRatio#monitoring_screen_resolution_or_zoom_level_changes
 */
var LoginAccessibility = /*#__PURE__*/function () {
  function LoginAccessibility() {
    _classCallCheck(this, LoginAccessibility);
    this.loginElement = $('div.login').get(0);
  }

  /**
   * @method init
   * @description Initialize login accessibility
   * @public
   */
  _createClass(LoginAccessibility, [{
    key: "init",
    value: function init() {
      this._initAccessibility();
    }

    /**
     * @method _initAccessibility
     * @description calling methods for wcag
     * @private
     */
  }, {
    key: "_initAccessibility",
    value: function _initAccessibility() {
      this._onPageZoomEvent();
    }

    /**
     * @method _onPageZoomEvent
     * @description when page zoom change, call method to set the scrollbarState
     * @private
     */
  }, {
    key: "_onPageZoomEvent",
    value: function _onPageZoomEvent() {
      var _this = this;
      var updatePixelRatio = function updatePixelRatio() {
        var pr = window.devicePixelRatio;
        var prString = (pr * 100).toFixed(0);
        _this._setScrollBarState();
        matchMedia("(resolution: ".concat(pr, "dppx)")).addEventListener("change", updatePixelRatio, {
          once: true
        });
      };
      updatePixelRatio();
    }

    /**
     * @method hasVerticalScrollBar
     * @returns {boolean}
     * @private
     */
  }, {
    key: "_hasVerticalScrollBar",
    value: function _hasVerticalScrollBar() {
      return this.loginElement.scrollHeight > this.loginElement.clientHeight;
    }

    /**
     * @method _checkLoginContainerScrolling
     * @description add css class hasScrollBar to scrolling login element
     * @private
     */
  }, {
    key: "_setScrollBarState",
    value: function _setScrollBarState() {
      if (this._hasVerticalScrollBar() === true) {
        $(this.loginElement).addClass('hasScrollBar');
      } else {
        $(this.loginElement).removeClass('hasScrollBar');
      }
    }
  }]);
  return LoginAccessibility;
}();
var _default = exports.default = LoginAccessibility;

},{}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * @class       : TopNewsAccessibility
                                                                                                                                                                                                                                                                                                                                                                                               * @description : To enable the web content accessibility(WCAG) in top news module component
                                                                                                                                                                                                                                                                                                                                                                                               *                - GPNGPII-16881 - Keyboard access not enabled for TOP NEWS Module
                                                                                                                                                                                                                                                                                                                                                                                               * @dependencies: Jquery, KEYCODES
                                                                                                                                                                                                                                                                                                                                                                                               * @references  : https://www.w3.org/WAI/tutorials/carousels/
                                                                                                                                                                                                                                                                                                                                                                                               */
var NewsPlayerAccessibility = /*#__PURE__*/function () {
  function NewsPlayerAccessibility(options) {
    _classCallCheck(this, NewsPlayerAccessibility);
    if (!options) {
      return true;
    }

    // #. Keep the config/options into context
    this.options = options;
    this.player = this.options.player;
  }

  // #. Get headline elements
  _createClass(NewsPlayerAccessibility, [{
    key: "$headlines",
    get: function get() {
      return $(this.player.container).find('.headline div');
    }

    // #. Get news module panel element
  }, {
    key: "$newsPlayerModulePanel",
    get: function get() {
      return $('#NewsPlayerModulePanel');
    }

    /**
     * @method init
     * @description Initialize the top news accessibility
     * @public
     */
  }, {
    key: "init",
    value: function init() {
      this._setWCAGAttributes();
    }

    /**
     * @method _setWCAGAttributes
     * @description set WCAG attributes to player elements
     * @private
     */
  }, {
    key: "_setWCAGAttributes",
    value: function _setWCAGAttributes() {
      $(this.player.moduleContainer).attr('role', 'presentation');
      $(this.player.controlBar).attr('role', 'application');
      // #. Set headline attributes
      this._setWCAGToHeadlines();
      // #. Set control buttons attributes
      this._setWCAGToControlButtons();
    }

    /**
     * @method _setWCAGToHeadlines
     * @description set WCAG attributes/events to headline element
     * @private
     */
  }, {
    key: "_setWCAGToHeadlines",
    value: function _setWCAGToHeadlines() {
      var _this = this;
      // #. Set aria-haspopup attribute to headline
      this.$headlines.attr({
        role: 'link',
        'aria-haspopup': true
      });

      // # on bind required for the streaming updates(lately rendered elements)
      $(this.player.container).off('focus', '.headline div');
      $(this.player.container).on('focus', '.headline div', function (event) {
        _this._onHeadlineFocused(event);
      });
      $(this.player.container).off('keydown');
      $(this.player.container).on('keydown', '.headline div', function (event) {
        if (event.keyCode === _keyCodes.default.ENTER) {
          $(event.target).trigger('click');
        }
      });

      // #. application role required to handle the custom keydown event(override screen reader)
      this.$headlines.parent().attr('role', 'application');
    }

    /**
     * @method _setWCAGToControlButtons
     * @description set WCAG attributes to player control button elements
     * @private
     */
  }, {
    key: "_setWCAGToControlButtons",
    value: function _setWCAGToControlButtons() {
      var attr = {
        role: 'button',
        tabindex: 0
      };

      // #. List of player control buttons
      var $buttons = [this.player.previousButton, this.player.nextButton, this.player.playButton, this.player.stopButton];
      var buttonTitles = ['news.topNews.player.previous', 'news.topNews.player.next', 'news.topNews.player.start', 'news.topNews.player.stop'];
      var self = this;
      for (var i = 0; i < $buttons.length; i++) {
        var $buttonActive = $($buttons[i]);
        // Get button title
        attr.title = window.getMessage(buttonTitles[i]);
        // #. Set the attributes
        $buttonActive.attr(attr);
        // #. Bind keydown - Enter should trigger the click event
        $buttonActive.off('keydown');
        $buttonActive.on('keydown', function (event) {
          self._onControlButtonsEventTriggered(event);
        });
        $buttonActive.off('focusout');
        $buttonActive.on('focusout', function (event) {
          $(this).removeAttr('aria-label');
        });
      }
    }

    /**
     * @method _onControlButtonsEventTriggered
     * @description handle the control button events
     * @param { KeydownEvent } event - Keyboard event
     * @private
     */
  }, {
    key: "_onControlButtonsEventTriggered",
    value: function _onControlButtonsEventTriggered(event) {
      var _this2 = this;
      if (event.keyCode === _keyCodes.default.ENTER || event.keyCode === _keyCodes.default.SPACE) {
        var $button = $(event.target);
        var triggerFocus = function triggerFocus() {
          var activeNews = _this2._getActiveNews();
          $button.blur();
          setTimeout(function () {
            $button.attr('aria-label', activeNews).focus();
          }, 50);
        };
        // #. Active element is Stop then focus will be move to Play
        if ($button.is(this.player.stopButton)) {
          this.player.stopAutoplay();
          $(this.player.playButton).css('display', 'inline').focus();
        } else
          // #. Active element is Play then focus will be move to Stop
          if ($button.is(this.player.playButton)) {
            this.player.startAutoplay();
            $(this.player.stopButton).css('display', 'inline').focus();
          } else if ($button.is(this.player.previousButton)) {
            this.player.showPrevious();
            triggerFocus();
          } else if ($button.is(this.player.nextButton)) {
            this.player.showNext();
            triggerFocus();
          }
      }
    }

    /**
     * @method _getActiveNews
     * @description get active news item
     * @private
     */
  }, {
    key: "_getActiveNews",
    value: function _getActiveNews() {
      var $activeNews = $(this.player.container).find('.pictureNewsItem').filter(function () {
        return $(this).css('visibility') === 'visible';
      });
      return $activeNews.find('.headline').text();
    }

    /**
     * @method _onHeadlineFocused
     * @description handle the headline focus event - to show the control buttons(like mouse over)
     * @param { FocusEvent } event - focus event
     * @private
     */
  }, {
    key: "_onHeadlineFocused",
    value: function _onHeadlineFocused(event) {
      // #. Stop the autoplay
      $(this.player.stopButton).click();
      // #. Show proper control buttons
      $(this.player.previousButton).css('display', 'inline');
      $(this.player.nextButton).css('display', 'inline');
      $(this.player.playButton).css('display', 'inline');
    }
  }]);
  return NewsPlayerAccessibility;
}();
var _default = exports.default = NewsPlayerAccessibility;

},{"util/enums/keyCodes":24}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * @class       : PopupSearchAccessibility
                                                                                                                                                                                                                                                                                                                                                                                               * @description : To enable the web content accessibility(WCAG) in the streaming nodes
                                                                                                                                                                                                                                                                                                                                                                                               *                NGPII-15056 - Bonds page - Ticker/ISIN field tag widgets not accessible using keyboard
                                                                                                                                                                                                                                                                                                                                                                                               * @dependencies: Jquery, KEYCODES
                                                                                                                                                                                                                                                                                                                                                                                               */
var PopupSearchAccessibility = /*#__PURE__*/function () {
  function PopupSearchAccessibility(options) {
    _classCallCheck(this, PopupSearchAccessibility);
    // #. Set accessibility config options
    this.options = options || {};
  }

  /**
   * @method init
   * @description Initialize the popup search accessibility
   * @public
   */
  _createClass(PopupSearchAccessibility, [{
    key: "init",
    value: function init() {
      this._start();
    }

    /**
     * @method _start
     * @description start the basic methods, assign attributes, bind key handler
     * @private
     */
  }, {
    key: "_start",
    value: function _start() {
      // #. check whether the search is multi-select or not
      if (this.options.multiSelect) {
        this._setMultiSelectAccessibility();
      }
    }

    /**
     * @method _setMultiSelectAccessibility
     * @description Initialize the multiselect popup search accessibility
     * @private
     */
  }, {
    key: "_setMultiSelectAccessibility",
    value: function _setMultiSelectAccessibility() {
      var _this = this;
      this.$tagContainer = $(this.options.container);
      this.$textInput = $(this.options.textField);
      this.tagSelector = '.popupsearch-tag';

      // #. Set the role to container element
      this.$tagContainer.attr('role', 'application');

      // #. bind keydown event to tag container element
      this.$tagContainer.on('keydown', this.tagSelector, function (event) {
        _this._onTagKeyHandler(event);
      });

      // #. bind keydown event to input element
      this.$textInput.on('keydown', function (event) {
        _this._oninputKeyHandler(event);
      });
    }

    /**
     * @method _setWCAGAttributes
     * @description seet necessary attributes to elements
     * @private
     */
  }, {
    key: "_setWCAGAttributes",
    value: function _setWCAGAttributes() {
      this.$tagContainer.find(this.tagSelector).attr({
        tabindex: 0
      });
    }

    /**
     * @method _onTagKeyHandler
     * @description key handler for the tag elements
     * @private
     */
  }, {
    key: "_onTagKeyHandler",
    value: function _onTagKeyHandler(event) {
      var keyCode = event.keyCode;
      var $activeTag = $(event.target);
      // #. ARROW-UP/LEFT will set the focus to previous tag
      // #. ARROW-DOWN/RIGHT will set the focus to next tag or text input
      // #. DELETE - will delete the item from the list
      if (keyCode === _keyCodes.default.ARROW_UP || keyCode === _keyCodes.default.ARROW_LEFT) {
        event.preventDefault();
        // #. get previous tag and set focus
        var $prevTag = $activeTag.prev(this.tagSelector);
        $prevTag.length > 0 && $prevTag.focus();
      } else if (keyCode === _keyCodes.default.ARROW_DOWN || keyCode === _keyCodes.default.ARROW_RIGHT) {
        event.preventDefault();
        var $nextTag = $activeTag.next(this.tagSelector);
        var $focusableEl = $nextTag.length > 0 ? $nextTag : this.$textInput;
        $focusableEl.focus();
      } else if (keyCode === _keyCodes.default.DELETE) {
        event.preventDefault();
        $activeTag.find('.remove').click();
      }
    }

    /**
     * @method _onInputKeyHandler
     * @description key handler for the input element
     * @private
     */
  }, {
    key: "_oninputKeyHandler",
    value: function _oninputKeyHandler(event) {
      var keyCode = event.keyCode;
      if (keyCode === _keyCodes.default.TAB && event.shiftKey || keyCode === _keyCodes.default.ARROW_UP || keyCode === _keyCodes.default.ARROW_LEFT) {
        event.preventDefault();
        // #. Set the attributes, inside the event because of new tag elements requires attributes
        this._setWCAGAttributes();
        // #. Handle the event
        this._onInputArrowEvent();
      }
    }

    /**
     * @method _onInputArrowEvent
     * @description on input element arrow events
     * @private
     */
  }, {
    key: "_onInputArrowEvent",
    value: function _onInputArrowEvent() {
      // #. Arrow left/up from input element will be set the focus to the last tag element
      this.$tagContainer.find(this.tagSelector).last().focus();
    }
  }]);
  return PopupSearchAccessibility;
}();
var _default = exports.default = PopupSearchAccessibility;

},{"util/enums/keyCodes":24}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * @class       : StreamingAccessibility
                                                                                                                                                                                                                                                                                                                                                                                               * @description : To enable the web content accessibility(WCAG) in the streaming nodes
                                                                                                                                                                                                                                                                                                                                                                                               *                NGPII-15978 - Enable accessibility in the ShowMessage(New Message) Icon
                                                                                                                                                                                                                                                                                                                                                                                               * @dependencies: Jquery, KEYCODES
                                                                                                                                                                                                                                                                                                                                                                                               * @references  : https://www.w3.org/TR/WCAG20-TECHS/
                                                                                                                                                                                                                                                                                                                                                                                               *                https://www.w3.org/TR/wai-aria-1.1/#tooltip
                                                                                                                                                                                                                                                                                                                                                                                               */
var StreamingAccessibility = /*#__PURE__*/function () {
  function StreamingAccessibility() {
    _classCallCheck(this, StreamingAccessibility);
    // #. To keep the news message button collection
    this.$newMessageButtons = [];
    // #. CSS selector of a new message icon element
    this.newsMessageSelector = 'a.newmessage';
  }

  /**
   * @method init
   * @description Initialize the streaming accessibility
   * @public
   */
  _createClass(StreamingAccessibility, [{
    key: "init",
    value: function init($node) {
      // #. Get news message button elements
      this.$newMessageButtons = this._findNewMessageButtons($node);
      this._start();
    }

    /**
     * @method update
     * @description Update the reloaded nodes with accessibility feature, same as init but a wrapper method
     * @public
     */
  }, {
    key: "update",
    value: function update($node) {
      // #. Get news message button elements
      this.$newMessageButtons = this._findNewMessageButtons($node);
      this._start();
    }

    /**
     * @method _start
     * @description start the basic methods, assign attributes, bind key handler
     * @private
     */
  }, {
    key: "_start",
    value: function _start() {
      // #. Check the count of the streaming nodes
      if (this.$newMessageButtons.length === 0) {
        return true;
      }

      // #. Set WCAG attributes
      this._setWCAGAttributes(this.$newMessageButtons);

      // #. Bind the keyboard accessibility event
      this._bindKeyHandler(this.$newMessageButtons);
    }

    /**
     * @method _findNewsMessageButtons
     * @description find the new message button collection from the streaming nodes collection
     * @param { HTMLCollectionOf } $nodes expecting streaming node element collection
     * @return { HTMLCollectionOf } new message button elements
     * @private
     */
  }, {
    key: "_findNewMessageButtons",
    value: function _findNewMessageButtons($nodes) {
      return $nodes.find(this.newsMessageSelector);
    }

    /**
     * @method _setWCAGAttributes
     * @description set WCAG attributes like aria-haspopup, aria-pressed to element
     * @param { HTMLCollectionOf }  { $elements } expecting html element collection
     * @private
     */
  }, {
    key: "_setWCAGAttributes",
    value: function _setWCAGAttributes($elements) {
      var hiddenTooltipContainer = $('<span></span>').attr('id', 'hiddenTooltipContainer').addClass('visuallyhidden');
      if ($('#hiddenTooltipContainer').length === 0) {
        $('body').append($(hiddenTooltipContainer));
      }
      $elements.attr({
        'aria-describedby': 'hiddenTooltipContainer'
      });

      // #. Apply role attribute to the parent table
      $elements.closest('td').attr({
        role: 'application'
      });

      // #. Update the title/arial-labelledby attributes
      this._updateShowMessageTitle($elements);
    }

    /**
     * @method _updateAttributes
     * @description update attribute of an element
     * @param { HTMLElement } $element expecting a html element
     * @param { Object } attributes expecting an object with updated attributes
     * @private
     */
  }, {
    key: "_updateAttributes",
    value: function _updateAttributes($element, attributes) {
      $element.attr(attributes);
    }

    /**
     * @method _bindKeyHandler
     * @description bind the keydown event and handle the event
     * @param { HTMLCollectionOf } $elements expecting html element collection
     * @private
     */
  }, {
    key: "_bindKeyHandler",
    value: function _bindKeyHandler($elements) {
      var _this = this;
      $elements.attr('tabindex', 0).on('keydown', function (event) {
        _this._onKeyHandlerUpdated(event);
      }).on('focus', function (event) {
        _this._onFocusHandlerUpdate(event);
      }).on('blur', function (event) {
        _this._onTabKeyPressed(event);
      });
    }

    /**
     * @method _onKeyHandlerUpdated
     * @description handle the keydown event
     * @param Event#keydown expecting keydown event object
     * @private
     */
  }, {
    key: "_onKeyHandlerUpdated",
    value: function _onKeyHandlerUpdated(event) {
      var keyCode = event.keyCode;
      if (keyCode === _keyCodes.default.TAB) {
        this._onTabKeyPressed(event);
      }
    }
  }, {
    key: "_onFocusHandlerUpdate",
    value: function _onFocusHandlerUpdate(event) {
      // #. Get the active element
      var $element = $(event.target);
      // #. Call the trigger event
      $element.attr({
        'aria-describedby': 'ngpTooltipNews'
      });
      this._triggerEvent($element, 'mouseover', event);
    }

    /**
     * @method _onTabKeyPressed
     * @description handle the tab key
     * @param Event#keydown expecting keydown event object
     * @private
     */
  }, {
    key: "_onTabKeyPressed",
    value: function _onTabKeyPressed(event) {
      // #. Get the active element
      var $element = $(event.target);
      // #. Call the trigger event
      this._triggerEvent($element, 'mouseout', event);
      $('#hiddenTooltipContainer').remove();
    }

    /**
     * @method _getStreamingContext
     * @description get streaming context if element is replaced with illustrate method
     * @param { HTMLElement } $element expecting current active element
     * @private
     */
  }, {
    key: "_getStreamingContext",
    value: function _getStreamingContext($element) {
      return $element.data('streaming-context');
    }

    /**
     * @method _triggerEvent
     * @description trigger event based on element environment
     * @param { HTMLElement } $element expecting current active element
     * @private
     */
  }, {
    key: "_triggerEvent",
    value: function _triggerEvent($element, eventName, event) {
      var streamingContext = this._getStreamingContext($element);
      /**
       * illustrateStreaming method from LastNewsFormatter replace the news message icon
       * mouseout event not available to this newly created element
       * keep the context as data attribute and invoke the hide tooltip method explicitly
       */
      if (streamingContext && streamingContext.hideInfo && eventName === 'mouseout') {
        streamingContext.hideInfo(event);
      } else {
        // #. Trigger the element event
        $element.trigger(eventName);
      }
    }

    /**
     * @method _updateShowMessageTitle
     * @description update show message title/arial-labelledby with the instrument name
     * @param { HTMLCollectionOf } $elements expecting collection of html element objects
     * @private
     */
  }, {
    key: "_updateShowMessageTitle",
    value: function _updateShowMessageTitle($elements) {
      var _iterator = _createForOfIteratorHelper($elements),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var $element = _step.value;
          $element = $($element);
          var title = this._getInstrumentNameByRow($element) || '';

          // #. Update the title with the instrument name in the row
          title = window.getMessage('title.streaming.showMessage', title);
          $element.attr('aria-label', title);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    /**
     * @method _getInstrumentNameByRow
     * @description get the instrument name by the element closest row
     * @param { HTMLElement } $element expecting an HTML element
     * @private
     */
  }, {
    key: "_getInstrumentNameByRow",
    value: function _getInstrumentNameByRow($element) {
      var $row = $($element.closest('tr'));
      return $row.find('a.instrumentIdentification').text() || $row.find('span.instrumentIdentification').text() || $row.find('input.searchPopupInput').val() || $row.find('a').first().text();
    }
  }]);
  return StreamingAccessibility;
}(); // #. Export the class
var _default = exports.default = StreamingAccessibility;

},{"util/enums/keyCodes":24}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
var _tabmenuAccessibility = require("aria/tabmenuAccessibility");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * @class       : TooltipAccessibility
                                                                                                                                                                                                                                                                                                                                                                                               * @description : To enable the web content accessibility(WCAG) in ngp application tooltip views
                                                                                                                                                                                                                                                                                                                                                                                               *                - NGPII-15117 Keyboard: QuickView Panel
                                                                                                                                                                                                                                                                                                                                                                                               * @dependencies: Jquery
                                                                                                                                                                                                                                                                                                                                                                                               * @references  : https://www.w3.org/TR/wai-aria-practices-1.1/examples/accordion/accordion.html
                                                                                                                                                                                                                                                                                                                                                                                               */
var TooltipAccessibility = /*#__PURE__*/function () {
  function TooltipAccessibility(options) {
    _classCallCheck(this, TooltipAccessibility);
    // #. Keep the config/options into context
    this.options = options;

    // #. Active element Identity
    this.ACTIVE_ELEMENT = {
      PANEL: 1,
      CHART: 2,
      CLOSE_BUTTON: 3,
      FIRST_MENU_ITEM: 4,
      FIRST_HEADER_BUTTON: 5,
      NEWS: 6
    };

    // #. Quick view menu identity
    this.QUICK_VIEW_MENU = {
      CHART: '#quickViewMenu\\.chart',
      RATIO: '#quickViewMenu\\.ratios',
      NEWS: '#quickViewMenu\\.news'
    };

    // #. Session storage key
    this.sessionKey = 'quick-panel-status';
  }

  /**
   * @method init
   * @description Initialize the tooltip/tooltip-target accessibility
   * @public
   */
  _createClass(TooltipAccessibility, [{
    key: "$quickView",
    get:
    // #. Quick view container selector
    function get() {
      return $('#ngpQuickview');
    }

    // #. Keep the quick view header
  }, {
    key: "$quickViewHeader",
    get: function get() {
      return this.$quickView.find('#quickViewHeader');
    }

    // #. Keep the quick view body
  }, {
    key: "$quickViewBody",
    get: function get() {
      return this.$quickView.find('#quickViewBody');
    }

    // #. Get the active element from dom
  }, {
    key: "$activeElement",
    get: function get() {
      return $(document.activeElement);
    }

    // #. Get first menu item from the body
  }, {
    key: "$firstMenuItem",
    get: function get() {
      return this.$quickViewBody.find('.menuItem.first button');
    }

    // #. Get last menu item from the body
  }, {
    key: "$lastMenuItem",
    get: function get() {
      return this.$quickViewBody.find('.menuItem button').last();
    }

    // #. Get chart container
  }, {
    key: "$chartContainer",
    get: function get() {
      return this.$quickViewBody.find('.highcharts-container');
    }

    // #. News table
  }, {
    key: "$newsTable",
    get: function get() {
      return this.$quickViewBody.find('#news_table');
    }

    // #. Get all button elements from header
  }, {
    key: "$headerButtons",
    get: function get() {
      return this.$quickViewHeader.find('.menu li.link');
    }

    // #. Get first button element from header
  }, {
    key: "$firstHeaderButton",
    get: function get() {
      return this.$headerButtons.first();
    }

    // #. Get close button
  }, {
    key: "$closeButton",
    get: function get() {
      return this.$quickViewHeader.find('#quickViewClose');
    }

    // #. Get aria-describedby element for the target
  }, {
    key: "$descriptionElement",
    get: function get() {
      var id = 'quick-view-target-desc';
      var $element = $('body').find("#".concat(id));
      // #. no hint element found, create a new one
      if ($element.length === 0) {
        $element = $('<span></span>').attr({
          id: id
        }).addClass('visuallyhidden').appendTo('body');
      }
      return $element;
    }

    // #. get focus status from session storage
  }, {
    key: "panelFocusStatus",
    get: function get() {
      return sessionStorage ? sessionStorage.getItem(this.sessionKey) : '0';
    }

    // #. set focus status to session storage
    ,
    set: function set(value) {
      sessionStorage && sessionStorage.setItem(this.sessionKey, value);
    }
  }, {
    key: "init",
    value: function init() {
      if (this.options.target) {
        this._bindTargetAccessibility();
      } else if (this.options.container) {
        this._bindPanelAccessibility();
        this._addAccessibilityAttributes();
        this._bindMenuItemLinkKeyHandler();
      }
    }

    /**
     * @method _bindTargetAccessibility
     * @description bind accessibility to the tooltip target
     * @private
     */
  }, {
    key: "_bindTargetAccessibility",
    value: function _bindTargetAccessibility() {
      var _this = this;
      $(window.document).on('tooltip-target-focus', this.options.target.selector, function (event, data) {
        if (data && data.panelFocusStatus) {
          _this.panelFocusStatus = data.panelFocusStatus;
        }
        event.currentTarget.focus();
      });
      // #. bind target focus - to trigger the mouseenter
      $(window.document).on('focusin', this.options.target.selector, function (event) {
        if (String($(event.target).attr(_this.options.target.attr)).includes(_this.options.target.contains)) {
          var $target = $(event.target);
          // #. Update the panel description text
          _this.$descriptionElement.text(window.getMessage('quickview.target.shortcut.title', $target.text()));
          // #. Set the attributes to target
          $target.attr({
            role: 'application',
            'aria-describedby': _this.$descriptionElement.attr('id')
          });
          window.setTimeout(function () {
            event.preventDefault();
            var status = _this.panelFocusStatus;
            if (status !== '1') {
              $target.trigger('mouseenter');
            }
            _this.panelFocusStatus = '1';
          }, 50);
        }
      });

      // #. bind target focusout - to manage the hide attr
      $(window.document).on('focusout', this.options.target.selector, function (event) {
        _this.panelFocusStatus = '0';
      });

      // #. bind target keydown event
      $(window.document).on('keydown', this.options.target.selector, function (event) {
        if (String($(event.target).attr(_this.options.target.attr)).includes(_this.options.target.contains)) {
          _this._onTargetKeyHandler(event);
        }
      });
    }

    /**
     * @method _onTargetKeyHandler
     * @description handle keydown of the tooltip target
     * @param { KeyboardEvent } event: keydown event
     * @private
     */
  }, {
    key: "_onTargetKeyHandler",
    value: function _onTargetKeyHandler(event) {
      var keyCode = event.keyCode;

      // #. Handle the keydown
      // #. Tab - will hide the quick view panel
      // #. ARR-LEFT - will set the focus to quick view panel
      if (keyCode === _keyCodes.default.TAB) {
        this._hideTooltip(false);
      } else if (keyCode === _keyCodes.default.ARROW_RIGHT) {
        this.$quickView.attr({
          tabindex: 0
        }).focus();
        this._setPanelWCAGRoles();
      }
    }

    /**
     * @method _setPanelWCAGRoles
     * @description set WCAG roles to the panel elements
     * @private
     */
  }, {
    key: "_setPanelWCAGRoles",
    value: function _setPanelWCAGRoles() {
      // #. Update the quick view tab menu accessibility
      var $menu = this.$quickView.find('div.moduleTabMenu div.menu');
      $menu.find('button.icon').attr('role', 'tab');
      (0, _tabmenuAccessibility.setAriaAttributesToModuleTabMenu)($menu);

      // #. Set live region roles
      this.$quickView.find('.moduleContent').attr('aria-live', 'polite');
    }

    /**
     * @method _bindPanelAccessibility
     * @description bind quick view panel accessibility
     * @private
     */
  }, {
    key: "_bindPanelAccessibility",
    value: function _bindPanelAccessibility() {
      var _this2 = this;
      // #. unbind the previously added event
      this.$quickView.off('keydown');
      // #. Bind keydown
      this.$quickView.attr('role', 'tooltip');
      this.$quickView.on('keydown', function (event) {
        _this2._onPanelKeyHandler(event);
      });
    }

    /**
     * @method _addAccessibilityAttributes
     * @description add necessary attributes to panel elements
     * @private
     */
  }, {
    key: "_addAccessibilityAttributes",
    value: function _addAccessibilityAttributes() {
      var _iterator = _createForOfIteratorHelper(this.$headerButtons),
        _step;
      try {
        var _loop = function _loop() {
          var $button = _step.value;
          $button = $($button);
          $button.attr({
            tabindex: 0,
            role: 'button'
          });

          // #. set the default pressed value
          $button.attr('aria-pressed', $button.hasClass('selected'));

          // Handle pressed attr on click event
          $button.on('click', function (event) {
            $button.attr('aria-pressed', $button.hasClass('selected'));
          });
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    /**
     * @method _bindMenuItemLinkKeyHandler
     * @description trigger menu item link click by using keyboard
     * @private
     */
  }, {
    key: "_bindMenuItemLinkKeyHandler",
    value: function _bindMenuItemLinkKeyHandler() {
      this.$headerButtons.on('keydown', function (event) {
        var keyCode = event.keyCode;
        if (keyCode === _keyCodes.default.SPACE || keyCode === _keyCodes.default.ENTER) {
          event.preventDefault();
          $(event.target).click();
        }
      });
    }

    /**
     * @method _onPanelKeyHandler
     * @description panel keydown event handler
     * @param { KeyboardEvent } event: keydown event
     * @private
     */
  }, {
    key: "_onPanelKeyHandler",
    value: function _onPanelKeyHandler(event) {
      var keyCode = event.keyCode;
      switch (keyCode) {
        case _keyCodes.default.TAB:
          this._onPanelTabKeyPressed(event);
          break;
        case _keyCodes.default.ARROW_LEFT:
        case _keyCodes.default.ESCAPE:
          this._hideTooltip(true);
          break;
        case _keyCodes.default.ARROW_DOWN:
          this._onPanelArrowDownPressed(event);
          break;
        case _keyCodes.default.ARROW_UP:
          this._onPanelArrowUpPressed(event);
          break;
      }
    }

    /**
     * @method _onPanelTabKeyPressed
     * @description handle tab key
     * @param { KeyboardEvent } event: keydown event
     * @private
     */
  }, {
    key: "_onPanelTabKeyPressed",
    value: function _onPanelTabKeyPressed(event) {
      var identity = this._getActiveElementIdentity();
      var result = false;
      switch (identity) {
        case this.ACTIVE_ELEMENT.PANEL:
          event.preventDefault();
          this._setFocusToActiveItemPart(false);
          break;
        case this.ACTIVE_ELEMENT.CHART:
          event.preventDefault();
          this.$chartContainer.blur();
          if (!event.shiftKey) {
            this._setFocusToRatio();
          } else {
            this.$lastMenuItem.focus();
          }
          break;
        case this.ACTIVE_ELEMENT.NEWS:
          event.preventDefault();
          if (!event.shiftKey) {
            this.$firstHeaderButton.focus();
          } else {
            this._setFocusToRatio(true);
          }
          break;
        case this.ACTIVE_ELEMENT.CLOSE_BUTTON:
          if (!event.shiftKey) {
            event.preventDefault();
            this._setFocusToActiveItemPart(false);
          }
          break;
        case this.ACTIVE_ELEMENT.FIRST_MENU_ITEM:
          result = true;
          if (event.shiftKey) {
            event.preventDefault();
            this.$closeButton.focus();
            result = false;
          }
          break;
        case this.ACTIVE_ELEMENT.FIRST_HEADER_BUTTON:
          if (event.shiftKey) {
            event.preventDefault();
            this._setFocusToActiveItemPart(true);
          }
          break;
        default:
          result = true;
          break;
      }
      return result;
    }

    /**
     * @method _onPanelArrowUpPressed
     * @description handle panel arrow up key
     * @param { KeyboardEvent } event: keydown event
     * @private
     */
  }, {
    key: "_onPanelArrowUpPressed",
    value: function _onPanelArrowUpPressed(event) {
      var identity = this._getActiveElementIdentity();
      if (identity === this.ACTIVE_ELEMENT.NEWS) {
        event.preventDefault();
        // #. Get active row
        var $activeRow = this.$activeElement;
        // #. Get all table rows except header
        var $rows = this.$newsTable.find('tr').not(':first');
        // #. Variable to keep the previous row
        var $row = null;
        // 1. If no rows selected yet, focus to last row
        // 2. If row is first row then, last row will select
        // 3. prev - select the previous row
        if (!$activeRow.is('tr')) {
          $row = $rows.last();
        } else if ($activeRow.is('tr')) {
          if ($activeRow.is($rows.first())) {
            $row = $rows.last();
          } else {
            $row = $activeRow.prev();
          }
        }
        if ($row) {
          $row.focus();
        }
      }
    }

    /**
     * @method _onPanelArrowDownPressed
     * @description handle arrow down key
     * @param { KeyboardEvent } event: keydown event
     * @private
     */
  }, {
    key: "_onPanelArrowDownPressed",
    value: function _onPanelArrowDownPressed(event) {
      var identity = this._getActiveElementIdentity();
      // #. Handle news table arrow down
      if (identity === this.ACTIVE_ELEMENT.NEWS) {
        event.preventDefault();
        // #. Get active row
        var $activeRow = this.$activeElement;
        // #. Get all table rows except header
        var $rows = this.$newsTable.find('tr').not(':first');
        // #. Variable to keep the next row
        var $row = null;
        // 1. If no rows selected yet, focus to first row
        // 2. If row is last row then, first row will select
        // 3. next - select next row
        if (!$activeRow.is('tr')) {
          $row = $rows.first();
        } else if ($activeRow.is('tr')) {
          if ($activeRow.is($rows.last())) {
            $row = $rows.first();
          } else {
            $row = $activeRow.next();
          }
        }
        if ($row) {
          $row.focus();
        }
      }
    }

    /**
    * @method _hideTooltip
    * @description hide the tooltip panel
    * @param { boolean } setFocusToTarget: to identify set focus to target element
    * @private
    */
  }, {
    key: "_hideTooltip",
    value: function _hideTooltip(setFocusToTarget) {
      this.$closeButton.trigger('click');
      if (this.options.$target) {
        var $target = $(this.options.$target);
        if (setFocusToTarget) {
          this.panelFocusStatus = '1';
          $target.focus();
        }
      }
    }

    /**
     * @method _getActiveElementIdentity
     * @description get active element identity
     * @private
     */
  }, {
    key: "_getActiveElementIdentity",
    value: function _getActiveElementIdentity() {
      var $activeElement = this.$activeElement;
      if ($activeElement.is(this.$quickView)) {
        return this.ACTIVE_ELEMENT.PANEL;
      } else if ($activeElement.is(this.$closeButton)) {
        return this.ACTIVE_ELEMENT.CLOSE_BUTTON;
      } else if ($activeElement.is(this.$firstMenuItem)) {
        return this.ACTIVE_ELEMENT.FIRST_MENU_ITEM;
      } else if ($activeElement.is(this.$chartContainer) || $activeElement.closest(this.$chartContainer).length > 0 || $activeElement.closest('.chartImageBox').length > 0) {
        return this.ACTIVE_ELEMENT.CHART;
      } else if ($activeElement.is(this.$firstHeaderButton)) {
        return this.ACTIVE_ELEMENT.FIRST_HEADER_BUTTON;
      } else if ($activeElement.is(this.$newsTable) || $activeElement.closest(this.$newsTable).length > 0) {
        return this.ACTIVE_ELEMENT.NEWS;
      }
    }

    /**
     * @method _getFirstSelectedPart
     * @description get first selected parts identity
     * @private
     */
  }, {
    key: "_getFirstSelectedPart",
    value: function _getFirstSelectedPart() {
      var selected = 'selected';
      if (this.$quickViewHeader.find(this.QUICK_VIEW_MENU.CHART).hasClass(selected)) {
        return this.QUICK_VIEW_MENU.CHART;
      } else if (this.$quickViewHeader.find(this.QUICK_VIEW_MENU.RATIO).hasClass(selected)) {
        return this.QUICK_VIEW_MENU.RATIO;
      } else if (this.$quickViewHeader.find(this.QUICK_VIEW_MENU.NEWS).hasClass(selected)) {
        return this.QUICK_VIEW_MENU.NEWS;
      }
    }

    /**
     * @method _getLastSelectedPart
     * @description get last selected parts identity
     * @private
     */
  }, {
    key: "_getLastSelectedPart",
    value: function _getLastSelectedPart() {
      var selected = 'selected';
      if (this.$quickViewHeader.find(this.QUICK_VIEW_MENU.NEWS).hasClass(selected)) {
        return this.QUICK_VIEW_MENU.NEWS;
      } else if (this.$quickViewHeader.find(this.QUICK_VIEW_MENU.RATIO).hasClass(selected)) {
        return this.QUICK_VIEW_MENU.RATIO;
      } else if (this.$quickViewHeader.find(this.QUICK_VIEW_MENU.CHART).hasClass(selected)) {
        return this.QUICK_VIEW_MENU.CHART;
      }
    }

    /**
     * @method _setFocusToActiveItemPart
     * @description set focus to the first active item in the panel
     * @param { Boolean } chooseLastPart - to identify the last/first part
     * @private
     */
  }, {
    key: "_setFocusToActiveItemPart",
    value: function _setFocusToActiveItemPart(chooseLastPart) {
      var partId = chooseLastPart ? this._getLastSelectedPart() : this._getFirstSelectedPart();
      switch (partId) {
        case this.QUICK_VIEW_MENU.CHART:
          if (chooseLastPart) {
            this._setFocusToChart();
          } else {
            this._setFocusToChartMenuItem();
          }
          break;
        case this.QUICK_VIEW_MENU.NEWS:
          this._setFocusToNews();
          break;
        case this.QUICK_VIEW_MENU.RATIO:
          this._setFocusToRatio(chooseLastPart);
          break;
        default:
          this.$firstHeaderButton.focus();
          break;
      }
    }

    /**
     * @method _setFocusToChartMenuItem
     * @description set focus to the chart menu item in the body
     * @private
     */
  }, {
    key: "_setFocusToChartMenuItem",
    value: function _setFocusToChartMenuItem() {
      this.$firstMenuItem.focus();
    }

    /**
     * @method _setFocusToNews
     * @description set focus to news table
     * @private
     */
  }, {
    key: "_setFocusToNews",
    value: function _setFocusToNews() {
      this._setNewsTableAccessibility();
      this.$newsTable.focus();
    }

    /**
     * @method _setFocusToRatio
     * @description ration view has no focusable elements, so focus may set to news or header buttons
     * @param { boolean } isShiftKey: identify shift key pressed or not
     * @private
     */
  }, {
    key: "_setFocusToRatio",
    value: function _setFocusToRatio(isShiftKey) {
      var selected = 'selected';
      if (isShiftKey) {
        if ($(this.QUICK_VIEW_MENU.CHART).hasClass(selected)) {
          this._setFocusToChart();
        } else {
          this.$closeButton.focus();
        }
      } else {
        // #. 1. If news selected - focus will be set to news table
        // #. 2. else the focus set to quick view chart button element
        if ($(this.QUICK_VIEW_MENU.NEWS).hasClass(selected)) {
          this._setFocusToNews();
        } else {
          this.$firstHeaderButton.focus();
        }
      }
    }

    /**
     * @method _setFocusToChart
     * @description set focus to the chart container
     * @private
     */
  }, {
    key: "_setFocusToChart",
    value: function _setFocusToChart() {
      this.$chartContainer.focus();
    }

    /**
     * @method _setNewsTableAccessibility
     * @description set news table accessibility
     * @private
     */
  }, {
    key: "_setNewsTableAccessibility",
    value: function _setNewsTableAccessibility() {
      // #. Set table
      this.$newsTable.attr({
        tabindex: 0
      });
      this.$newsTable.parent().attr({
        role: 'application'
      });

      // #. Set table row
      this.$newsTable.find('tr').attr({
        tabindex: 0,
        role: 'button'
      });
    }
  }]);
  return TooltipAccessibility;
}();
var _default = exports.default = TooltipAccessibility;

},{"aria/tabmenuAccessibility":11,"util/enums/keyCodes":24}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAriaAttributesToModuleTabMenu = void 0;
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * set aria attributes to moduletabmenus
 */
var setAriaAttributesToModuleTabMenu = exports.setAriaAttributesToModuleTabMenu = function setAriaAttributesToModuleTabMenu($menu) {
  var moduleTabMenus = $menu || $('div.moduleTabMenu div.menu');
  setAttributes(moduleTabMenus);
};

/**
 * set aria attributes to tablist and tabpanel for all tab menus on the page with tab buttons inside
 * @param menus
 */
var setAttributes = function setAttributes(menus) {
  $(menus).each(function (index, menu) {
    if ($(menu).find('button.icon').length > 0) {
      setAttributesToTablist(menu);
    }
  });
};

/**
 * set attributes to module tab menu elements by given tab menu
 * @param menu
 */
var setAttributesToTablist = function setAttributesToTablist(menu) {
  // todo get module title without timeout
  window.setTimeout(function () {
    // timeout because of loading... text at the beginning
    var moduleTitle = $(menu).closest('div.module').find('div.moduleHeader h2');
    $(menu).attr('role', 'tablist');
    $(menu).attr('aria-label', $(moduleTitle).text());
  }, 2000);
  setAriaAttributesToButtons($(menu));
};

/**
 * set attributes to tab buttons to given tab menu
 * @param menu
 */
var setAriaAttributesToButtons = function setAriaAttributesToButtons(menu) {
  var tabMenu = menu;
  var menuItems = $(tabMenu).find('div.menuItem');
  $(tabMenu).find('button').each(function (index, button) {
    $(button).attr('role', 'tab').attr('aria-selected', false).on('keydown', function (e) {
      if (e.keyCode === _keyCodes.default.ENTER || e.keyCode === _keyCodes.default.SPACE) {
        updateTabButtons(tabMenu, e.target);
      }
    }).on('click', function (e) {
      updateTabButtons(tabMenu, e.target);
    });
  });
  $(menuItems).each(function (index, item) {
    if ($(item).hasClass('on')) {
      setTabButtonSelected($(item).find('button'));
      return true;
    }
  });
};

/**
 * update attributes of tab buttons
 * @param menu
 * @param pressedBtn
 */
var updateTabButtons = function updateTabButtons(menu, pressedBtn) {
  var menuItemButtons = $(pressedBtn).parent('.menuItem').parent().find('> .menuItem button');
  menuItemButtons.attr('aria-selected', false).removeAttr('tabindex');
  setTabButtonSelected(pressedBtn);
};

/**
 * set given button as selected
 * @param button
 */
var setTabButtonSelected = function setTabButtonSelected(button) {
  $(button).attr({
    'aria-selected': true,
    tabindex: -1
  });
};

},{"util/enums/keyCodes":24}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ajaxPostJson = exports.ajaxPost = exports.ajaxGetJson = exports.ajaxGet = void 0;
var _objectToPostdata = _interopRequireDefault(require("core/Ajax/objectToPostdata"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/** @module core/Ajax/ajaxRequest */

/**
 * ajaxRequest is a wrapper for window.fetch that encapsulates all its functionality
 * @private
 * @param {String} method
 * @param {String} url
 * @param {String} [format] data format expected, this can be one of:
 * <ul>
 *  <li>text (default)</li>
 *  <li>json</li>
 *  <li>blob</li>
 *  <li>arrayBuffer</li>
 *  <li>formData</li>
 * </ul>
 * @param {Object} [data] key value object to be sent as post data or appended to url as get parameters
 * @param {Object} [headers] key value object containing request headers to be sent
 * @return {Promise.<any>}
 */
var ajaxRequest = function ajaxRequest(method, url, format, data, headers) {
  format = format || 'text';
  headers = headers || null;
  var fetchOptions = {
    method: method,
    headers: headers,
    credentials: 'same-origin'
  };
  var params = '';
  if (typeof data === 'string') {
    params = data;
  } else {
    params = (0, _objectToPostdata.default)(data);
  }
  if (method === 'GET') {
    if (params) {
      url += (url.indexOf('?') > -1 ? '&' : '?') + params;
    }
  } else {
    fetchOptions.body = params || null;
  }
  if (url.indexOf('/') === 0) {
    url = window.ctx + url;
  }
  return window.fetch(url, fetchOptions).then(function (response) {
    if (response.ok) {
      return response[format]();
    } else {
      if (!response.headers.has('applicationMessage')) {
        throw new Error("".concat(response.status, " - ").concat(response.statusText));
      } else {
        var error = new Error();
        error.code = response.status;
        error.message = response.headers.get('applicationMessage');
        throw error;
      }
    }
  });
};

/**
 * executes a GET request to the provided url and returns a promise
 * @param {String} url
 * @param {Object} [data] key value object to be appended to url as get parameters
 * @param {Object} [headers] key value object containing request headers to be sent
 * @return {Promise.<string>}
 */
var ajaxGet = exports.ajaxGet = function ajaxGet(url, data, headers) {
  return ajaxRequest('GET', url, 'text', data || {}, Object.assign({}, headers));
};

/**
 * executes a GET request to the provided url and returns a promise
 * @param {String} url
 * @param {Object} [data] key value object to be appended to url as get parameters
 * @param {Object} [headers] key value object containing request headers to be sent
 * @return {Promise.<any>}
 */
var ajaxGetJson = exports.ajaxGetJson = function ajaxGetJson(url, data, headers) {
  return ajaxRequest('GET', url, 'json', data || {}, Object.assign({}, headers));
};

/**
 * executes a POST request to the provided url and returns a promise
 * @param {String} url
 * @param {Object} [data] key value object to be sent as post data
 * @param {Object} [headers] key value object containing request headers to be sent
 * @return {Promise.<string>}
 */
var ajaxPost = exports.ajaxPost = function ajaxPost(url, data, headers) {
  return ajaxRequest('POST', url, 'text', data || {}, Object.assign({
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
  }, headers));
};

/**
 * executes a POST request to the provided url and returns a promise
 * @param {String} url
 * @param {Object} [data] key value object to be sent as post data
 * @param {Object} [headers] key value object containing request headers to be sent
 * @return {Promise.<any>}
 */
var ajaxPostJson = exports.ajaxPostJson = function ajaxPostJson(url, data, headers) {
  return ajaxRequest('POST', url, 'json', data || {}, Object.assign({
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
  }, headers));
};

},{"core/Ajax/objectToPostdata":13}],13:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/*
 * Create a post data string from an object by using the property names as
 * parameter names. The values will be URI encoded.
 * Returns null for any input that is not an object.
 */
var objectToPostdata = function objectToPostdata(postData) {
  return _typeof(postData) !== 'object' || postData == null ? null : Object.keys(postData).map(function (key) {
    return [].concat(itemToString(postData[key])).filter(function (f) {
      return f != null;
    }).map(function (a) {
      return "".concat(key, "=").concat(encodeURIComponent(a));
    });
  }).reduce(function (all, a) {
    return all.concat(a);
  }, []).join('&');
};
var itemToString = function itemToString(item, jsonEncodeArray) {
  if (typeof item === 'function' || item == null) {
    //invalid stuff should be ignored
    return null;
  } else if (!jsonEncodeArray && Array.isArray(item)) {
    return item.map(function (a) {
      return itemToString(a, true);
    });
  } else if (_typeof(item) === 'object') {
    if (typeof item.toString === 'function') {
      var string = item.toString();
      // if the object has an overwritten toString method
      if (string.indexOf('[object ') !== 0) {
        return string;
      }
    }
    return JSON.stringify(item);
  } else {
    return "".concat(item);
  }
};
var _default = exports.default = objectToPostdata;

},{}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Hooks = exports.default = /*#__PURE__*/function () {
  function Hooks() {
    _classCallCheck(this, Hooks);
  }
  _createClass(Hooks, null, [{
    key: "onModuleAdded",
    value: function onModuleAdded(type) {
      // Matomo Tracking Code: Add new module
      if (window._paq) {
        window._paq.push(['trackEvent', 'Modules', 'Add', type]);
      }
    }
  }, {
    key: "onModuleRemoved",
    value: function onModuleRemoved(type) {
      // Matomo Tracking Code: Add new module
      if (window._paq) {
        window._paq.push(['trackEvent', 'Modules', 'Removed', type]);
      }
    }
  }, {
    key: "onSearchResult",
    value: function onSearchResult(search, results) {
      // Matomo Tracking Code: Search
      if (window._paq) {
        window._paq.push(['trackSiteSearch', search,
        // Category
        'instruments',
        // Result count
        results.length > 0 ? results[0].count : 0]);
      }
    }
  }]);
  return Hooks;
}();

},{}],15:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerMessages = exports.getMessage = exports.addMessage = void 0;
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/** @module messages/messageHandler */

//use an object in window as cache, in order to prevent multiple instances of the cache
window.__messagesCache = window.__messagesCache || {};
var messages = window.__messagesCache;

/**
 * adds a message object with key value pairs for translation
 * @param {Object} msg
 */
var registerMessages = exports.registerMessages = function registerMessages(msg) {
  Object.assign(messages, msg);
};

/**
 * adds a message to the global message cache for translation
 * @param {string} key
 * @param {string} value
 */
var addMessage = exports.addMessage = function addMessage(key, value) {
  messages[key] = value;
};

/**
 * translates a given key and replaces {0}..{n} with the respective replacements
 * @param {string} key
 * @param {...string} replacements
 * @returns {string}
 * @example
 * addMessage('example', 'example {0} of {1}')
 * getMessage('example', '4', 'many');
 * // --> 'example 4 of many'
 * getMessage('example', ['2', '6']);
 * // --> 'example 2 of 6'
 */
var getMessage = exports.getMessage = function getMessage(key) {
  var _ref;
  for (var _len = arguments.length, replacements = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    replacements[_key - 1] = arguments[_key];
  }
  replacements = (_ref = []).concat.apply(_ref, _toConsumableArray(replacements));
  var message = messages[key] || key.split('.').reduce(function (all, a) {
    return a;
  }, '');
  message = message.replace(/\{(\d)\}/g, function (match, id) {
    return replacements[+id] != null ? replacements[+id] : match;
  });
  return message;
};
window.registerMessages = registerMessages;
window.getMessage = getMessage;
window.addMessage = addMessage;

},{}],16:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.detailLink = exports.default = void 0;
var _axios = _interopRequireDefault(require("../../app/utils/axios"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var TOOL_TEMPLATE = document.createElement('template');
var detailLink = exports.detailLink = function detailLink(item, subPage) {
  return "/detail/detailPage.html?".concat(getQueryString(item, subPage));
};
var getQueryString = function getQueryString(item, subPage) {
  var viewName = item.viewName;
  var queryString = "subPage=".concat(subPage, "&").concat(item.symbol || item.id ? "ric=".concat(item.symbol || item.id) : "isin=".concat(item.isin));
  if (viewName) {
    queryString = "".concat(queryString, "&view=").concat(viewName);
  }
  return queryString;
};
var DFA_PARENT_CSS = 'dfa-parent';
var saveSearchHistory = function saveSearchHistory(item) {
  var params = {
    isin: item.isin,
    ric: item.ric || item.symbol || item.id || item.isin
  };
  _axios.default.post('/searchHistory/updateHistory', params).catch(function (error) {
    console.error(error);
  });
};

/*
 * Genrates a direct function access from search result on a single instrument
 * User can directly move to individual sub detail page from the search result.
 */

/*
    constructor for direct function access panel.

    Characteristics of the DFA panel

    The panel appears when the user clicks on a data row.
    Panel appears in the same table as of the search result just one row below the data row which the user had clicked.
    All other rows including paging control panel will be hidden except
        i) Data row which the user had clicked.
        ii) Header row.
    A close button appears on the right most column in the data row which can close the panel

    @param $navigationData {Object} A data JSON which contains all available subpage navigation
            definitions for a given type of instrument.
    @param $node {Object} The node to which the Panel need to be attached which is the reference to data row
                            which the user had clicked.
    @param $item {Object} The data item (JSON) that describes a single record in the search response.
 */
var DirectFunctionAccessPanel = function DirectFunctionAccessPanel($navigationData, $node, $item) {
  this.container = new Container($node);
  this.navData = $navigationData;
  this.item = $item;
};
/*
    Prepare rendering Direct Function Access Panel
 */
DirectFunctionAccessPanel.prototype._preRender = function () {
  this.container.hideIrrelevant();
  this.container.addStyles();
};
/*
    Generate direct access to a single navigation from the given data.

    @param data {Object} A data JSON which contains a single subpage navigation
            definition for a given type of instrument.
 */
DirectFunctionAccessPanel.prototype._generateDFAFromData = function (data) {
  return "\n                    <div class=\"dfa-code\">".concat(data.shortCode, "</div>\n                    <div class=\"dfa-name\">").concat(data.displayName, "</div>\n            ").replace(/[\r\n\t]+/g, "");
};
/*
    Create container for the Panel
 */
DirectFunctionAccessPanel.prototype._createPanelContainer = function () {
  TOOL_TEMPLATE.innerHTML = "<div class=\"search-result-dfa\"></div>";
  return TOOL_TEMPLATE.content.firstChild;
};
/*

    @param data {Object} A data JSON which contains a single subpage navigation
            definition for a given type of instrument.
 */
DirectFunctionAccessPanel.prototype._createSingleDFAContainer = function (data) {
  var _this = this;
  TOOL_TEMPLATE.innerHTML = "<div class=\"dfa-block\"></div>";
  var navContainer = TOOL_TEMPLATE.content.firstChild;
  navContainer.onclick = function (evt) {
    var dataItem = _this._generateDataItem(data, _this.item);
    saveSearchHistory(dataItem);
    DirectFunctionAccessPanel.redirectToFunction(dataItem, data.linkCode);
    evt.stopPropagation();
  };
  return navContainer;
};
/*
    Merge Navigation Data with selected search result data
    this data is used for
    1. detail page link
    2. Saving Search Results

    @param $navData {Object} A data JSON which contains a single subpage navigation
            definition for a given type of instrument.
    @param $item {Object} The data item (JSON) that describes a single record in the search response.
 */
DirectFunctionAccessPanel.prototype._generateDataItem = function ($navData, $instrData) {
  var dataItem = Object.assign({}, $instrData);
  if ($navData.ric) {
    dataItem = Object.assign(dataItem, {
      symbol: $navData.ric
    });
  }
  if ($navData.linkUrl && $navData.linkUrl.includes('&view=')) {
    var queryParams = $navData.linkUrl.split('?')[1];
    var viewName = new URLSearchParams(queryParams).get('view');
    dataItem = Object.assign(dataItem, {
      viewName: viewName
    });
  }
  return dataItem;
};
/*
    Convert the dfa navigation data in to GUI list components.
 */
DirectFunctionAccessPanel.prototype._navDataToDFA = function () {
  var _this2 = this;
  return this.navData.itemList.map(function (data) {
    var singleDFAContainer = _this2._createSingleDFAContainer(data);
    var singleDFA = _this2._generateDFAFromData(data);
    singleDFAContainer.insertAdjacentHTML('beforeend', singleDFA);
    return singleDFAContainer;
  });
};

/*
    Render Direct Function Access Panel
*/
DirectFunctionAccessPanel.prototype.render = function () {
  this._preRender();
  var dfaPanel = this._createPanelContainer();
  var dfaList = this._navDataToDFA();
  dfaList.forEach(function (aDFA) {
    return dfaPanel.appendChild(aDFA);
  });
  var footer = this.createFooter();
  dfaPanel.appendChild(footer);
  this.container.cCell.append(dfaPanel);
};
/*
    Create footer for the Panel
 */
DirectFunctionAccessPanel.prototype.createFooter = function () {
  TOOL_TEMPLATE.innerHTML = "<div class=\"dfa-ft\"><i class=\"far fa-info-circle\"></i><span>".concat(window.getMessage('incrementalsearch.dfa.info'), "</span></div>");
  return TOOL_TEMPLATE.content.firstChild;
};
/*
    check if a panel is already active on the data row
    Active data row has a class 'dfa'
 */
DirectFunctionAccessPanel.isActive = function ($parentRow) {
  return $parentRow.classList.contains(DFA_PARENT_CSS);
};
DirectFunctionAccessPanel.activeStatus = false;

/*
    double-clicking will trigger multiple instances of the panel to be generated
    to solve it a flag style is added on each click and removed on susequent click
     from the row
 */
DirectFunctionAccessPanel.allowClick = function () {
  if (DirectFunctionAccessPanel.activeStatus === false) {
    DirectFunctionAccessPanel.activate();
    return true;
  }
  return false;
};
DirectFunctionAccessPanel.deActivate = function () {
  DirectFunctionAccessPanel.activeStatus = false;
};
DirectFunctionAccessPanel.activate = function () {
  DirectFunctionAccessPanel.activeStatus = true;
};
DirectFunctionAccessPanel.navDataForShortCode = function ($navData, shortCode) {
  return $navData.find(function (n) {
    return n.shortCode === shortCode.toUpperCase();
  }) || {
    linkCode: 'overv',
    shortCode: 'OV'
  };
};
DirectFunctionAccessPanel.redirectToFunction = function ($instrData, functionCode) {
  window.location = "".concat(window.ctx).concat(detailLink($instrData, functionCode));
};
var Container = function Container($parentRow) {
  /* A row in search result table which contains the instrument data, a click on this row will trigger direct function access*/
  this.pRow = $parentRow;
  this.pTable = $parentRow.closest("table");
  this.pTableHeader = Array.from(this.pTable.rows)[0];
  this.pCtrlPane = this.pTable.closest("div").getElementsByClassName("controls")[0];
  this._init();
  this._addPanelCloseButton();
};
/*

 */
Container.prototype._init = function () {
  this.cRow = this.pTable.insertRow(this.pRow.rowIndex + 1);
  this.cCell = this.cRow.insertCell(0);
  this.cCell.colSpan = this.pRow.cells.length;
};
Container.prototype._addPanelCloseButton = function () {
  var _this3 = this;
  this._addRowsAdjustmentForCloseButton();
  TOOL_TEMPLATE.innerHTML = "<div class=\"dfa-close-btn\" title=\"".concat(window.getMessage('txt.button.close.panel'), "\"><i class=\"fal fa-times\"></i></div>");
  var closeBtn = TOOL_TEMPLATE.content.firstChild;
  closeBtn.onclick = function (evt) {
    DirectFunctionAccessPanel.deActivate();
    _this3.reset();
    _this3.detach();
    closeBtn.remove();
    evt.stopPropagation();
  };
  var lastColumnOfParentRow = this.pRow.lastChild;
  /* Add close button to the dfa-ctrl-block div */
  lastColumnOfParentRow.firstChild.append(closeBtn);
};
/*
    Last column of the search result table has isin  & close btn added side by side
    in the following structure
    <div class="dfa-ctrl-block">
        <div class="dfa-isin"></div>
        <div class="dfa-close-btn">X</div>
    </div>
 */
Container.prototype._addRowsAdjustmentForCloseButton = function () {
  this.pRow.classList.add(DFA_PARENT_CSS);
  var lastColumnOfParentRow = this.pRow.lastChild;
  if (!lastColumnOfParentRow.classList.contains('dfa-ctrl')) {
    /*get column data & close btn side by side using style 'flex'*/
    /* put a div around the colum data */
    $(lastColumnOfParentRow).wrapInner("<div class=\"dfa-isin\"></div>");
    /* put a div around the entire column content including close button */
    $(lastColumnOfParentRow).wrapInner("<div class=\"dfa-ctrl-block\"></div>");
  }
  if (!lastColumnOfParentRow.classList.contains('dfa-ctrl')) {
    lastColumnOfParentRow.classList.add('dfa-ctrl');
  }
};
Container.prototype._removeRowsAdjustmentForCloseButton = function () {
  this.pRow.classList.remove(DFA_PARENT_CSS);
};
Container.prototype.isDFAActive = function () {
  return this.pRow.classList.contains(DFA_PARENT_CSS);
};
Container.prototype.hideIrrelevant = function () {
  var _this4 = this;
  Array.from(this.pTable.rows).filter(function (row) {
    return _this4._rowsToHide(row, _this4.cRow.rowIndex);
  }).forEach(function (row) {
    return row.style.display = 'none';
  });
  if (this.pCtrlPane) {
    this.pCtrlPane.style.display = 'none';
  }
};
Container.prototype.addStyles = function () {
  this.cRow.classList.add('dfa');
};
Container.prototype.removeStyles = function () {
  this.cRow.classList.remove('dfa');
};
Container.prototype.reset = function () {
  Array.from(this.pTable.rows).forEach(function (row) {
    return row.style.display = '';
  });
  if (this.pCtrlPane) {
    this.pCtrlPane.style.display = '';
  }
  this._removeRowsAdjustmentForCloseButton();
};
Container.prototype.detach = function () {
  this.cRow.remove();
};
Container.prototype.addCloseButton = function ($closeBtn) {
  this.cRow.lastChild.append($closeBtn);
};
Container.prototype._rowsToHide = function ($row, containerRowIndex) {
  var isHeaderRow = $row.rowIndex === 0;
  var isParentRow = $row.rowIndex === containerRowIndex - 1;
  var isContainerRow = $row.rowIndex === containerRowIndex;
  var toHide = !isHeaderRow && !isParentRow && !isContainerRow;
  return toHide;
};
var _default = exports.default = DirectFunctionAccessPanel;

},{"../../app/utils/axios":1}],17:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _messageHandler = require("fcom/messages/messageHandler");
var _axios = _interopRequireDefault(require("../../app/utils/axios"));
var _ajaxRequest = require("core/Ajax/ajaxRequest");
var _DirectFunctionAccessPanel = _interopRequireDefault(require("fcom/search/DirectFunctionAccessPanel"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var SearchHistory = function SearchHistory(config, searchInput) {
  var container = document.querySelector("#".concat(config.searchHistoryContainerId));
  if (!container) {
    container = document.createElement('div');
    container.id = config.searchHistoryContainerId;
    container.className = 'search-history';
    container.style.display = 'none';
    document.body.appendChild(container);
  }
  container.classList.add('search-history');
  this.createHistoryWindowContents(container, config);
  this.container = container;
  this.containerId = config.searchHistoryContainerId;
  this.searchInput = searchInput; // set associated search input
  this.dfaEnabled = config.enableDFAInSearchHistory;
  this.closeHistoryWindowHandler = null;
  this.config = config;
};
SearchHistory.prototype.createHistoryWindowContents = function (container, config) {
  var showFlags = !window.user.isChinaSpecificUser;
  // clear existing childrens
  container.replaceChildren();
  var titleDiv = document.createElement('div');
  titleDiv.className = 'search-history-title';
  titleDiv.innerText = (0, _messageHandler.getMessage)('searchHistory.title');
  container.appendChild(titleDiv);
  var table = document.createElement('table');
  table.id = "".concat(config.searchHistoryContainerId, "_table");
  table.classList.add('list', 'marktr');
  var tr = document.createElement('tr');
  tr.className = 'search-history-header';
  this.columns = ['description', 'group', 'isin'];
  var colGroup = document.createElement('colgroup');
  table.appendChild(colGroup);
  if (showFlags) {
    var flagCol = document.createElement('col');
    flagCol.style.width = '30px';
    colGroup.appendChild(flagCol);
  }
  var _iterator = _createForOfIteratorHelper(this.columns),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var column = _step.value;
      var col = document.createElement('col');
      var th = document.createElement('th');
      if (column === 'description' && showFlags) {
        th.colSpan = 2;
      }
      colGroup.appendChild(col);
      th.innerText = (0, _messageHandler.getMessage)("incrementalsearch.col.instruments.".concat(column));
      tr.appendChild(th);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  table.appendChild(tr);
  container.appendChild(table);
  this.table = table;
};
SearchHistory.prototype.render = function () {
  var _this = this;
  // need to fetch and render data only if the history window is not already displayed
  // and search input is empty
  if (this.container.style.display === 'none' && this.searchInput.value.length === 0) {
    var self = this;
    this.setContainerStyle();
    _axios.default.get("/searchHistory/getHistory").then(function (response) {
      var data = response.data ? response.data : [];
      _this.setTableData(data);
      var closeSearchHistory = function closeSearchHistory(e) {
        if (!e.target.closest('div.search-history') && e.target !== self.searchInput) {
          document.body.removeEventListener('click', closeSearchHistory);
          self.container.style.display = 'none';
        }
      };
      document.body.addEventListener('click', closeSearchHistory);
      _this.closeHistoryWindowHandler = closeSearchHistory;
    });
  }
};
SearchHistory.prototype.setContainerStyle = function () {
  var containerTop = this.searchInput.getBoundingClientRect().top + this.searchInput.offsetHeight;
  this.container.style.top = "".concat(containerTop, "px");
};
var generateCountryFlag = function generateCountryFlag(country) {
  if (country) {
    return "<span title=\"".concat(window.YAHOO.lang.escapeHTML(country), "\" class=\"country ").concat(window.YAHOO.lang.escapeHTML(country), "\" style=\"width:16px;\"></span>");
  }
  return "<span style=\"width:16px;\"></span>";
};
SearchHistory.prototype.setTableData = function (data) {
  var _this2 = this;
  var showFlags = !window.user.isChinaSpecificUser;
  var self = this;
  this.table.querySelectorAll('tr:not(.search-history-header)').forEach(function (row) {
    return row.remove();
  });
  if (data.length) {
    var _this$table;
    var rows = data.map(function (datum) {
      var tr = document.createElement('tr');
      tr.role = 'button';
      tr.addEventListener('click', function (event) {
        onRowClick(self, datum, event.currentTarget);
      });

      // add flag
      if (showFlags) {
        var td = document.createElement('td');
        td.innerHTML = generateCountryFlag(datum.country);
        tr.appendChild(td);
      }
      var _iterator2 = _createForOfIteratorHelper(_this2.columns),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var column = _step2.value;
          var _td = document.createElement('td');
          _td.textContent = datum[column] ?? '-';
          if (column === 'description') {
            _td.style.textAlign = 'left';
          }
          tr.appendChild(_td);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return tr;
    });
    (_this$table = this.table).append.apply(_this$table, _toConsumableArray(rows));
  } else {
    // add row with empty message
    var tr = document.createElement('tr');
    tr.className = 'noresults';
    var td = document.createElement('td');
    td.colSpan = 3;
    td.innerText = (0, _messageHandler.getMessage)('searchHistory.emptyMessage');
    tr.appendChild(td);
    this.table.appendChild(tr);
  }
  this.container.style.display = 'block';
};
var onRowClick = function onRowClick(self, item, row) {
  if (self.dfaEnabled) {
    (0, _ajaxRequest.ajaxGet)('/api/v1/navigationData/navigationItemList', item).then(function (response) {
      var navData = JSON.parse(response);
      if (!_DirectFunctionAccessPanel.default.isActive(row)) {
        var dfa = new _DirectFunctionAccessPanel.default(navData, row, item);
        dfa.render();
      }
    }).catch(function () {
      var redirectLink = "/detail/detailPage.html?".concat(item.isin ? "isin=".concat(item.isin) : "ric=".concat(item.ric));
      window.location = window.ctx + redirectLink;
    });
  } else if (self.config.searchRicCallback) {
    self.config.searchRicCallback({
      name: item.description,
      ric: item.ric,
      isin: item.isin,
      type: item.type
    });
  } else if (self.config.itemCallback) {
    self.config.itemCallback('instruments', {
      description: item.description,
      id: item.ric,
      isin: item.isin,
      type: item.type
    });
  } else {
    var redirectLink = "/detail/detailPage.html?".concat(item.isin ? "isin=".concat(item.isin) : "ric=".concat(item.ric));
    window.location = window.ctx + redirectLink;
  }
};
var _default = exports.default = SearchHistory;

},{"../../app/utils/axios":1,"core/Ajax/ajaxRequest":12,"fcom/messages/messageHandler":15,"fcom/search/DirectFunctionAccessPanel":16}],18:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ajaxRequest = require("core/Ajax/ajaxRequest");
var _messageHandler = require("fcom/messages/messageHandler");
var _searchTypesEnum = _interopRequireDefault(require("fcom/search/searchTypesEnum"));
var _ThirdLevelTable = _interopRequireDefault(require("fcom/search/ThirdLevelTable"));
var _basicTableControls = _interopRequireDefault(require("fcom/search/basicTableControls"));
var _keyCodes = _interopRequireDefault(require("fcom/util/enums/keyCodes"));
var _DirectFunctionAccessPanel = _interopRequireWildcard(require("fcom/search/DirectFunctionAccessPanel"));
var _axios = _interopRequireDefault(require("../../app/utils/axios"));
var _tableColumnDefinitio;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var tableColumnDefinitions = (_tableColumnDefinitio = {}, _defineProperty(_tableColumnDefinitio, _searchTypesEnum.default.INSTRUMENTS, ['description', 'group', 'isin']), _defineProperty(_tableColumnDefinitio, _searchTypesEnum.default.NEWS, ['headline', 'timestamp']), _defineProperty(_tableColumnDefinitio, _searchTypesEnum.default.WLPF, ['caption', 'type']), _defineProperty(_tableColumnDefinitio, _searchTypesEnum.default.NAV, ['page']), _defineProperty(_tableColumnDefinitio, _searchTypesEnum.default.ISSUER, ['bnd_issuer', 'bnd_issuer_domicile']), _tableColumnDefinitio);
var ELEMENT_ID = {
  SEARCH_INPUT: 1,
  LEFT_PANEL: 2,
  RESULT_TABLE1: 3,
  RESULT_TABLE2: 4,
  PAGINATION_CONTROL: 5,
  RESULT2_BACK: 6,
  GENERIC_BUTTONS: 7
};
var INSTRUMENT_ENUM = {
  BON: "BONDS",
  CER: "CERTIFICATES",
  COM: "COMMODITIES",
  CUR: "CURRENCIES",
  ECI: "ECONOMY",
  FUN: "FUNDS",
  FUT: "FUTURES",
  IND: "INDICES",
  MON: "MONEY_MARKET",
  OPT: "OPTIONS",
  STO: "STOCKS",
  WAR: "WARRANTS",
  CHN: "CHAIN"
};
var pagePathDivider = '&raquo;';
var newsLink = function newsLink(item) {
  return "/news/overview.html#newsId=".concat(item.id);
};
var detailLink = function detailLink(item) {
  return "/detail/detailPage.html?".concat(item.isin ? "isin=".concat(item.isin) : "ric=".concat(item.symbol || item.id));
};
var watchlistLink = function watchlistLink(item) {
  return "/portfolios/watchlists/detail.html?id=".concat(item.id);
};
var portfolioLink = function portfolioLink(item) {
  return "/portfolios/portfolios/portfolio.html?pfid=".concat(item.id);
};
var pageLink = function pageLink(item) {
  return "".concat(item.link);
};
var bondIssuerLink = function bondIssuerLink(item) {
  return "/screener.html?method=bondScreenerResult&purpose=&secTypeGroup=BONDS&issuer=".concat(item.bnd_issuer_code);
};
var directRicLink = function directRicLink(item) {
  return "/detail/detailPage.html?ric=".concat(encodeURIComponent(item.ric));
};
var dfaNavDataRestLink = '/api/v1/navigationData/navigationItemList';
var maxItemsPerPage = 10;
var RIC_PATTTERN = /(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*(?:[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2\uDF00-\uDF09]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDF43-\uDF4F\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F])(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*/;
var FUTURE_RIC_PATTERN = /(?=.*\d)(?=.*[A-Z])(?=.*[\d]$)/;
var SearchResultBox = function SearchResultBox(config) {
  var _this2 = this;
  var searchBox = $("#".concat(config.searchBoxId));
  if (!searchBox.length) {
    searchBox = $('<form/>').attr('id', config.searchBoxId).css('display', 'none');
    $('body').append(searchBox);
  }
  searchBox.addClass('searchbox-container');
  searchBox.toggleClass('ricsearch-enabled', config.searchRic);
  if (config.static) {
    searchBox.addClass('searchbox-static');
  }
  if (config.inPage) {
    searchBox.addClass('searchbox-inPage');
  } else {
    searchBox.removeClass('searchbox-inPage');
  }
  this.config = config || {};
  this.$searchBox = searchBox;
  this.searchTerm = null;
  this.dfaShortCut = null;
  this.searchType = config.searchType || _searchTypesEnum.default.INSTRUMENTS;
  this.searchFilter = config.instrumentTypes;
  this.instrumentTypes = config.instrumentTypes || ['*'];
  this.countInstTypeOnly = config.countInstTypeOnly !== false;
  this.page = 1;
  this.itemsPerPage = maxItemsPerPage;
  this.availableTypes = config.searchType ? [config.searchType] : window.user.searchSpacesAvailable;
  this.timeTracking = [];

  // #. To keep the active left panel item index
  this.activeLeftPanelItem = 0;

  // #. To keep the active result table 1 item index
  this.activeResultTable1Item = 0;

  // #. To keep the active result table 2 item index
  this.activeResultTable2Item = 0;

  // #. To track the result table 1 navigation starts from first row or not
  this.resetRowSelection = false;

  // #. To track the result table 2 navigation starts from first row or not
  this.resetRowSelection2 = false;

  // #. To keep the search input text box
  this.$searchInput = null;

  // #. To keep the search input text box offset position
  this.searchInputOffset = null;

  // #. To keep the search input text box Height
  this.searchInputHeight = null;

  // #. To track if the position of result box top or bottom
  this.showOnTop = false;

  // attach handlers for keyboard navigation
  var keyHandler = function keyHandler(event) {
    var keyCode = event.keyCode;
    if (!_this2.$searchBox || !_this2.isSearchBoxVisible()) {
      return true;
    }
    var propagation = true;
    switch (keyCode) {
      case _keyCodes.default.ESCAPE:
        event.preventDefault();
        _this2.hide();
        if (_this2.config.inPage) {
          _this2.setFocusToSolarSearchInput();
        }
        propagation = false;
        break;
      case _keyCodes.default.ARROW_LEFT:
        propagation = _this2.onArrowLeftPressed(event);
        break;
      case _keyCodes.default.ARROW_RIGHT:
        propagation = _this2.onArrowRightPressed(event);
        break;
      case _keyCodes.default.ARROW_DOWN:
        _this2.onArrowDownPressed(event);
        propagation = false;
        break;
      case _keyCodes.default.ARROW_UP:
        _this2.onArrowUpPressed(event);
        propagation = false;
        break;
      case _keyCodes.default.ENTER:
        _this2.onEnterKeyPressed(event);
        propagation = false;
        break;
      case _keyCodes.default.TAB:
        _this2.onTabKeyPressed(event);
        propagation = true;
        break;
      default:
        propagation = true;
        break;
    }
    return propagation;
  };
  var $panel = this.$searchBox.closest('.panel');
  var $container = $panel.length > 0 ? $panel : this.$searchBox;
  $container.unbind('keydown');
  $container.on('keydown', keyHandler);

  // #. Keep the search input ref
  this.setSearchInputRef();
  window.setTimeout(function () {
    if (!_this2.isSolarSearch()) {
      _this2.setFocusToSearch();
    } else {
      _this2.bindSolarInputKeydown();
      _this2.setRootElementRole();
    }
  }, 100);
};

/**
 * Set search input ref
 */
SearchResultBox.prototype.setSearchInputRef = function () {
  this.$searchInput = this.config.searchInput;
  this.searchInputHeight = this.$searchInput.outerHeight();
  this.searchInputOffset = this.$searchInput.offset();
};

/**
 * Bind keydown event to solar input
 */
SearchResultBox.prototype.bindSolarInputKeydown = function () {
  var _this3 = this;
  // #. Bind the event, if it is not added yet
  if (!this.$searchInput.data('solar-keydown')) {
    this.$searchInput.on('keydown', function (event) {
      _this3.onSolarInputKeydown(event);
    }).data('solar-keydown', true);
  }
};

/**
 * Set search input ref
 */
SearchResultBox.prototype.onSolarInputKeydown = function (event) {
  if (event.keyCode === _keyCodes.default.TAB && this.isSearchBoxVisible()) {
    event.preventDefault();
    event.stopPropagation();
    // #. Handle shift combo
    if (event.shiftKey === true) {
      this.setFocusToSolarLastFocusableElement();
    } else {
      this.setFocusToLeftPanel();
    }
    return false;
  }
};

/**
 * Check whether the search box is visible or not
 * @returns {boolean}
 */
SearchResultBox.prototype.isSearchBoxVisible = function () {
  return this.$searchBox.is(':visible');
};

/**
 * Check the current search is solar search or nor
 * Status based on the visibility of the result form
 * @returns {boolean}
 */
SearchResultBox.prototype.isSolarSearch = function () {
  return $(this.$searchInput).closest('.quickSearch').length > 0 || this.config.inPage === true;
};

/**
 * Returns active element id
 * @returns {numeric}
 */
SearchResultBox.prototype.activeElementId = function () {
  var $element = this.getActiveElement();
  var elementId = -1;
  if ($element.is('#popupSearchPanelInput')) {
    elementId = ELEMENT_ID.SEARCH_INPUT;
  } else if ($element.is('ul.search-list-items') || $element.is('a.keyboard-focus') && $element.parents('ul.search-list-items').length > 0) {
    elementId = ELEMENT_ID.LEFT_PANEL;
  } else if ($element.is('.controls button')) {
    elementId = ELEMENT_ID.PAGINATION_CONTROL;
  } else if ($element.is('.ricsearch table.list') || $element.is('tr.keyboard-focus') && $element.parent().is('.ricsearch table.list')) {
    elementId = ELEMENT_ID.RESULT_TABLE2;
  } else if ($element.is('table.list.marktr') || $element.is('tr.keyboard-focus') && $element.parent().is('table.list.marktr')) {
    elementId = ELEMENT_ID.RESULT_TABLE1;
  } else if ($element.is('span.back')) {
    elementId = ELEMENT_ID.RESULT2_BACK;
  } else if ($element.is('.buttonBar button') || $element.is('button.container-close')) {
    elementId = ELEMENT_ID.GENERIC_BUTTONS;
  }
  return elementId;
};

/**
 * Handle left key press event
 * #1. Focus on result table 1 - move focus to left panel
 * #2. Focus on result table 2 - move focus to result table 1(trigger back button click)
 */
SearchResultBox.prototype.onArrowLeftPressed = function (event) {
  var activeElId = this.activeElementId();
  var propagation = false;
  switch (activeElId) {
    case ELEMENT_ID.RESULT_TABLE1:
      event.preventDefault();
      this.setFocusToLeftPanel();
      break;
    case ELEMENT_ID.RESULT_TABLE2:
      event.preventDefault();
      this.$searchBox.find('.controls .back').trigger('click');
      this.disableResult2TabIndex();
      this.setFocusToResultTable();
      break;
    default:
      propagation = true;
      break;
  }
  return propagation;
};

/**
 * Handle right key press event
 * Focus on left panel - move the focus to result table 1
 */
SearchResultBox.prototype.onArrowRightPressed = function (event) {
  var activeElId = this.activeElementId();
  if (activeElId === ELEMENT_ID.LEFT_PANEL) {
    event.preventDefault();
    this.setFocusToResultTable();
    return false;
  } else {
    return true;
  }
};

/**
 * Handle arrow down key press event
 * Navigate through list/table items
 * Left Panel - list items(li.a)
 */
SearchResultBox.prototype.onArrowDownPressed = function (event) {
  var activeElId = this.activeElementId();
  switch (activeElId) {
    case ELEMENT_ID.SEARCH_INPUT:
      event.preventDefault();
      this.activeLeftPanelItem = 0;
      this.setFocusToLeftPanel();
      break;
    case ELEMENT_ID.LEFT_PANEL:
      event.preventDefault();
      this.handleLeftPanelNavigation(true);
      break;
    case ELEMENT_ID.RESULT_TABLE1:
      event.preventDefault();
      this.handleResultTableNavigation(this.getResultTable1Rows(), true, true);
      break;
    case ELEMENT_ID.RESULT_TABLE2:
      event.preventDefault();
      this.handleResultTableNavigation(this.getResultTable2Rows(), true, false);
      break;
    default:
      break;
  }
};

/**
 * Handle arrow up key press event
 * Navigate through list/table items
 * Left Panel - list items(li.a)
 */
SearchResultBox.prototype.onArrowUpPressed = function (event) {
  var activeElId = this.activeElementId();
  switch (activeElId) {
    case ELEMENT_ID.LEFT_PANEL:
      event.preventDefault();
      this.handleLeftPanelNavigation(false);
      break;
    case ELEMENT_ID.RESULT_TABLE1:
      event.preventDefault();
      this.handleResultTableNavigation(this.getResultTable1Rows(), false, true);
      break;
    case ELEMENT_ID.RESULT_TABLE2:
      event.preventDefault();
      this.handleResultTableNavigation(this.getResultTable2Rows(), false, false);
      break;
    default:
      break;
  }
};

/**
 * Handle arrow down key press event
 * Navigate through list/table items
 */
SearchResultBox.prototype.handleLeftPanelNavigation = function (isArrowDown) {
  // #. Get all list items from the left panel
  var $items = this.$searchBox.find('li a');

  // #. Get next item index
  this.activeLeftPanelItem = isArrowDown ? this.activeLeftPanelItem + 1 : this.activeLeftPanelItem - 1;

  // #. Get next item by index
  var $next = $items[this.activeLeftPanelItem];

  // #. Set first/last item as default, if no items found
  if (!$next) {
    this.activeLeftPanelItem = isArrowDown ? 0 : $items.length - 1;
    $next = $items[this.activeLeftPanelItem];
  }
  this.setRowActive($($next));

  // #. Set focus to the active row for announcing by screenreader
  $($next).attr('tabindex', 0);
  $($next).focus();
};

/**
 * Handle result table navigations
 * Navigate through list/table items
 */
SearchResultBox.prototype.handleResultTableNavigation = function ($rows, isArrowDown, isResultTable1) {
  if (!$rows || $rows && $rows.length === 0) {
    return;
  }

  // #. Local variable declaration
  var index = 0;
  var $next = null;
  var parentClassName = null;
  if (this.activeResultTable1Item === -1) {
    this.activeResultTable1Item = $rows.length - 1;
  }
  if (this.resetRowSelection === true) {
    this.activeResultTable1Item = -1;
    this.resetRowSelection = false;
  }
  if (this.activeResultTable2Item === -1) {
    this.activeResultTable2Item = $rows.length - 1;
  }
  if (this.resetRowSelection2 === true) {
    this.activeResultTable2Item = -1;
    this.resetRowSelection2 = false;
  }

  // #. Get elements bases on the table id
  // #. Update related table item index
  if (isResultTable1 === true) {
    parentClassName = '.mainsearch';
    if (isArrowDown) {
      this.activeResultTable1Item++;
    } else {
      this.activeResultTable1Item--;
    }
    index = this.activeResultTable1Item;
  } else if (!isResultTable1) {
    parentClassName = '.ricsearch';
    if (isArrowDown) {
      this.activeResultTable2Item++;
    } else {
      this.activeResultTable2Item--;
    }
    index = this.activeResultTable2Item;
  }

  // #. Get table controls
  var $prevButton = this.$searchBox.find("".concat(parentClassName, " .controls .previousPage")).not('.disabled');
  var $nextButton = this.$searchBox.find("".concat(parentClassName, " .controls .nextPage")).not('.disabled');
  var $firstButton = this.$searchBox.find("".concat(parentClassName, " .controls .firstPage")).not('.disabled');
  var $lastButton = this.$searchBox.find("".concat(parentClassName, " .controls .lastPage")).not('.disabled');

  // #. Handle last row and first row event
  if (index > $rows.length - 1) {
    // #. Update index
    if (isResultTable1 === true) {
      this.activeResultTable1Item = 0;
    } else {
      this.activeResultTable2Item = 0;
    }

    // #. Trigger pagination controls
    if ($nextButton.length) {
      $nextButton.trigger('click');
    } else if ($firstButton.length) {
      $firstButton.trigger('click');
    }
    return;
  } else if (index < 0) {
    // #. Update index
    if (isResultTable1 === true) {
      this.activeResultTable1Item = -1;
    } else {
      this.activeResultTable2Item = -1;
    }

    // #. Trigger pagination controls
    if ($prevButton.length) {
      $prevButton.trigger('click');
    } else if ($lastButton.length) {
      $lastButton.trigger('click');
    }
    return;
  }

  // #. Get next row
  $next = $rows[index];

  // #. Set updated table item index
  if (isResultTable1 === true) {
    this.activeResultTable1Item = index;
  } else {
    this.activeResultTable2Item = index;
  }

  // #. Set the row as active
  this.setRowActive($($next));

  // #. Set focus to the active row for announcing by screenreader
  $($next).attr('tabindex', 0);
  $($next).focus();
};

/**
 * Set row active - add related css class
 */
SearchResultBox.prototype.setRowActive = function ($element) {
  if (!$element) {
    return;
  }

  // #. Remove tabindex attribute from the old element
  if (this.$searchBox.find('.keyboard-focus').attr('tabindex')) {
    this.$searchBox.find('.keyboard-focus').removeAttr('tabindex');
  }

  // #. Remove active class from the old element
  this.$searchBox.find('.keyboard-focus').removeClass('hover keyboard-focus');

  // #. Set active class to new element
  $element.addClass('hover keyboard-focus');
};

/**
 * Handle Tab key press event
 *
 * @param event
 * @param isShiftKeyPressed
 * @returns {boolean}
 */
SearchResultBox.prototype.onTabKeyPressed = function (event) {
  // #. Check whether the search is solar or not
  var isSolar = this.isSolarSearch();
  var shiftKey = event.shiftKey;

  // #. Handle the solar search
  if (isSolar) {
    this.onSolarTabKeyPressed(event);
    return true;
  }
  var activeElId = this.activeElementId();
  // #. Manage shift tab combination
  if (shiftKey === true) {
    switch (activeElId) {
      case ELEMENT_ID.LEFT_PANEL:
        event.preventDefault();
        this.setFocusToSearch();
        break;
      case ELEMENT_ID.RESULT_TABLE2:
        event.preventDefault();
        this.setFocusToSearch();
        this.$searchBox.find('.controls .back').trigger('click');
        break;
      case ELEMENT_ID.RESULT_TABLE1:
        event.preventDefault();
        this.setFocusToLeftPanel();
        break;
      case ELEMENT_ID.PAGINATION_CONTROL:
        {
          // #. List only visible in the first slide of the panel
          var $list = this.$searchBox.find('ul.search-list-items');
          var $rows = null;
          var $firstButton = this.getFirstPaginationButton();
          if (!$(event.target).is($firstButton)) {
            return true;
          }
          if ($list.is(':visible')) {
            var $table = this.$searchBox.find('.mainsearch table.list.marktr');
            if ($table.length > 0) {
              event.preventDefault();
              $rows = this.getResultTable1Rows();
              this.activeResultTable1Item = $rows.length - 1;
              this.setFocusToResultTable();
            }
          } else {
            event.preventDefault();
            $rows = this.getResultTable2Rows();
            this.activeResultTable2Item = $rows.length - 1;
            this.setFocusToResultTable2();
          }
          break;
        }
      default:
        break;
    }
  } else {
    switch (activeElId) {
      case ELEMENT_ID.SEARCH_INPUT:
        event.preventDefault();
        this.activeResultTable1Item = -1;
        this.setFocusToLeftPanel(true);
        break;
      case ELEMENT_ID.LEFT_PANEL:
        {
          var _$table = this.$searchBox.find('.mainsearch table.list.marktr');
          if (_$table.length > 0) {
            event.preventDefault();
            this.setFocusToResultTable(true, event);
          }
          break;
        }
      case ELEMENT_ID.RESULT_TABLE2:
        event.preventDefault();
        this.$searchBox.find('.controls .back').focus();
        break;
      default:
        break;
    }
  }
};

/**
 * Handle Tab key press event of solar search
 * @param {Event} event
 * @returns {boolean}
 */
SearchResultBox.prototype.onSolarTabKeyPressed = function (event) {
  var _this4 = this;
  var activeElId = this.activeElementId();
  var shiftKey = event.shiftKey;
  var setFocus = function setFocus() {
    event.preventDefault();
    _this4.setFocusToSolarSearchInput();
    return false;
  };

  // #. Handle shift combination
  if (shiftKey) {
    // #. Shift + Tab from level 0 will move the focus to solar search input
    if (activeElId === ELEMENT_ID.LEFT_PANEL) {
      return setFocus();
    }
  } else {
    var $lastElement = this.getLastFocusableElement();
    var res = false;
    switch (activeElId) {
      case ELEMENT_ID.PAGINATION_CONTROL:
        if ($(event.target).is($lastElement)) {
          res = setFocus();
        }
        break;
      case ELEMENT_ID.RESULT_TABLE1:
        if ($($lastElement).is('table')) {
          res = setFocus();
        }
        break;
      case ELEMENT_ID.LEFT_PANEL:
        if ($($lastElement).find('tr.noresults').length > 0) {
          res = setFocus();
        }
        break;
      case ELEMENT_ID.RESULT2_BACK:
        if ($($lastElement).is('span.back')) {
          event.preventDefault();
          this.setFocusToResultTable2();
          res = false;
        }
        break;
      default:
        res = true;
        break;
    }
    return res;
  }
  return true;
};

/**
 * Handle Enter key press event
 *
 * @param event
 * @returns {boolean}
 */
SearchResultBox.prototype.onEnterKeyPressed = function (event) {
  var _this5 = this;
  event.preventDefault();
  var activeElId = this.activeElementId();
  var res = false;

  // 1. Trigger left panel selected item click
  // 2. Result table 1 selected row click
  // 3. Result table 2 selected row click
  // 4. Result table 2 back button click
  // 5. Result table pagination control click
  // 6. Trigger arrow right key event
  switch (activeElId) {
    case ELEMENT_ID.LEFT_PANEL:
      this.activeResultTable1Item = 0;
      // #. Set aria-selected attribute to true
      this.$searchBox.find('li a.hover.keyboard-focus').attr('aria-selected', true).trigger('click');
      break;
    case ELEMENT_ID.RESULT_TABLE1:
      this.resetRowSelection2 = true;
      this.activeResultTable2Item = 0;
      this.$searchBox.find('.mainsearch table.list.marktr').find('tr.keyboard-focus').trigger('click');
      break;
    case ELEMENT_ID.RESULT_TABLE2:
      this.$searchBox.find('.ricsearch table.list.marktr').find('tr.keyboard-focus').trigger('click');
      break;
    case ELEMENT_ID.RESULT2_BACK:
      this.getActiveElement().trigger('click');
      window.setTimeout(function () {
        _this5.setFocusToResultTable();
      }, 300);
      break;
    case ELEMENT_ID.GENERIC_BUTTONS:
    case ELEMENT_ID.PAGINATION_CONTROL:
      this.getActiveElement().click();
      break;
    default:
      this.onArrowRightPressed(event);
      res = false;
      break;
  }
  return res;
};

/**
 * Get all focusable elements in the form
 */
SearchResultBox.prototype.getAllFocusableElements = function () {
  return this.$searchBox.find('button, [href], table.list, input, select, textarea, [tabindex]:not([tabindex="-1"])').not(':disabled').not(':hidden');
};

/**
 * Get last focusable element in the form
 */
SearchResultBox.prototype.getLastFocusableElement = function () {
  var $elements = this.getAllFocusableElements();
  var isResTab2Visible = this.isResultTable2Visible();

  // #. Remove the items under result table 2 when the table is not visible
  if (!isResTab2Visible) {
    for (var i = $elements.length; i >= 0; i--) {
      if ($($elements[i]).closest('.ricsearch').length > 0) {
        $elements.splice(i, 1);
      }
    }
  }
  return $elements[$elements.length - 1];
};

/**
 * Get DOM active element
 */
SearchResultBox.prototype.getActiveElement = function () {
  return $(document.activeElement);
};

/**
 * Get solar search input element
 */
SearchResultBox.prototype.getSolarSearchInput = function () {
  return this.$searchInput || $('.quickSearch input.incrementalSearch');
};

/**
 * Get result table 1 rows collection
 */
SearchResultBox.prototype.getResultTable1Rows = function () {
  return this.$searchBox.find('table tr').not(':first');
};

/**
 * Get first active pagination control button
 */
SearchResultBox.prototype.getFirstPaginationButton = function () {
  return this.$searchBox.find('.controls button:enabled').first();
};

/**
 * Get result table 2 rows collection
 */
SearchResultBox.prototype.getResultTable2Rows = function () {
  return this.$searchBox.find('.ricsearch table tr').not(':first');
};

/**
 * Set focus to solar search input element
 */
SearchResultBox.prototype.setFocusToSolarSearchInput = function () {
  this.getSolarSearchInput().focus();
};

/**
 * Set focus to solar search last focusable element
 */
SearchResultBox.prototype.setFocusToSolarLastFocusableElement = function () {
  this.getLastFocusableElement().focus();
};

/**
 * Set focus to the right panel result table
 */
SearchResultBox.prototype.setFocusToResultTable = function (isTabKey) {
  this.$searchBox.find('.mainsearch table.list.marktr').focus();
  if (!isTabKey) {
    var $rows = this.getResultTable1Rows();
    if (this.activeResultTable1Item === -1) {
      this.activeResultTable1Item = $rows.length - 1;
    }
    this.setRowActive($($rows[this.activeResultTable1Item]));
  } else {
    this.resetRowSelection = true;
  }
};

/**
 * Set focus to the result table 2
 */
SearchResultBox.prototype.setFocusToResultTable2 = function () {
  this.$searchBox.find('.ricsearch table.list.marktr').focus();
  var $rows = this.getResultTable2Rows();
  if (this.activeResultTable2Item === -1) {
    this.activeResultTable2Item = $rows.length - 1;
  }
  this.setRowActive($($rows[this.activeResultTable2Item]));
};

/**
 * Set focus to search input
 * @returns {*|jQuery}
 */
SearchResultBox.prototype.setFocusToSearch = function () {
  this.$searchInput.focus();
};

/**
 * Assign role to the inPage/solar main div
 * Purpose to assign the WCAG attributes
 */
SearchResultBox.prototype.setRootElementRole = function () {
  this.$searchBox.closest('form').attr({
    role: 'application'
  });
};

/**
 * Set focus to search input
 */
SearchResultBox.prototype.setFocusToLeftPanel = function (isTabKey) {
  this.$searchBox.find('ul.search-list-items').focus();
  if (!isTabKey) {
    // #. Get all rows from the left panel
    var $items = this.$searchBox.find('li a');

    // #. Get last selected item
    var $item = $items[this.activeLeftPanelItem];

    // #. Set element as active
    if ($item) {
      this.setRowActive($($item));

      // #. Set focus to the active row for announcing by screenreader
      $($item).attr('tabindex', 0);
      $($item).focus();
    }
  } else {
    this.activeLeftPanelItem = -1;
  }
};

/*
 * Listen the back button click event
 */
SearchResultBox.prototype.onBackButtonClicked = function () {
  var _this6 = this;
  this.$searchBox.find('.controls .back').click(function () {
    _this6.disableResult2TabIndex();
  });
};

/**
 * Check whether the table is visible or not
 * Only visible table has class 'active'
 */
SearchResultBox.prototype.isResultTable2Visible = function () {
  return this.$searchBox.find('.ricsearch.active').length > 0;
};

/**
 * Disable tab index of buttons under result table 2
 */
SearchResultBox.prototype.disableResult2TabIndex = function () {
  var btnAttr = {
    tabindex: -1
  };
  var $ricSearch = this.$searchBox.find('.ricsearch');

  // #. Disable the table focus
  $ricSearch.find('table.list').attr(btnAttr);

  // #. Disable tabindex of the back button
  $ricSearch.find('.controls .back').attr(btnAttr);

  // #. Disable tabindex of pagination controls
  $ricSearch.find('.firstPage,.nextPage,.lastPage,.previousPage').attr(btnAttr);
  $ricSearch.find('.firstPage,.nextPage,.lastPage,.previousPage').attr(btnAttr);

  // #. Remove tab index from table row
  $ricSearch.find('tr.keyboard-focus').removeAttr('tabindex').removeClass('hover keyboard-focus');
};

/**
 * Enable tab index of buttons under result table 2
 */
SearchResultBox.prototype.enableResult2TabIndex = function () {
  var btnAttr = {
    tabindex: 0
  };
  var $ricSearch = this.$searchBox.find('.ricsearch');

  // #. Enable tabindex of the back button
  $ricSearch.find('.controls .back').attr(btnAttr);

  // #. Enable tabindex of pagination controls
  $ricSearch.find('table.list').attr(btnAttr);
};
SearchResultBox.prototype.checkDirectRicHit = function () {
  var _this7 = this;
  var timestamp = Date.now();
  var checkDirectHit = function checkDirectHit() {
    if (_this7.navigationData && _this7.searchTerm && _this7.navigationData[0] && _this7.searchTerm === _this7.navigationData[0].searchTerm[0]) {
      // Navigation data exist and its searchTerm matches with the current searchTerm
      if (_this7.results && _this7.results.length > 0 && !!_this7.results[0][window.themeProperties['incrementalSearch.symbolHitFromIncrementalResponseField']]) {
        var ric = _this7.results[0][window.themeProperties['incrementalSearch.symbolHitFromIncrementalResponseField']];
        var tickerOverride = null;
        if (_this7.results[0]['exchangePlace'] === 'LIP' && _this7.results[0]['type'] === 'FUN') {
          tickerOverride = _this7.results[0]['ticker'];
        }
        if (_this7.config.searchRicCallback) {
          _this7.hide();
          if (_this7.config.searchRicCallbackScope) {
            _this7.config.searchRicCallback.call(_this7.config.searchRicCallbackScope, {
              ric: ric,
              tickerOverride: tickerOverride
            });
          } else {
            _this7.config.searchRicCallback({
              ric: ric,
              tickerOverride: tickerOverride
            });
          }
        } else {
          defaultItemClickCallback(_this7.searchType, {
            ric: ric
          }, _this7);
        }
      } else {
        // check extraserver as fallback when incremental search does not know id
        checkExtraserver();
      }
    } else if (Date.now() < timestamp + 8000) {
      // Requests are still pending
      window.setTimeout(function () {
        checkDirectHit();
      }, 100); // wait some time whether there will be a result
    }
  };

  var checkExtraserver = function checkExtraserver() {
    (0, _ajaxRequest.ajaxGetJson)("/generalSearch.action?method=testStringForInstrumentId&test=".concat(encodeURIComponent(_this7.searchTerm))).then(function (result) {
      var isRic = result.isRic,
        ric = result.ric,
        link = result.link,
        isId = result.isId,
        isISIN = result.isISIN,
        isin = result.isin,
        description = result.description,
        type = result.type;
      // To handle duplicate entries in search history while adding ric (edit module -> search)
      if (link && (!_this7.config.searchRicCallback || isISIN)) {
        var params = {
          ric: ric
        };
        if (isISIN) {
          params.isin = isin;
        }
        // save to search history
        _axios.default.post('/searchHistory/updateHistory', params).catch(function (error) {
          console.error(error);
        });
      }
      if (_this7.dfaShortCut && (isRic || isId || isISIN)) {
        handleDFAShortCut(result, _this7);
        return;
      }
      if (isRic) {
        if (_this7.config.searchRicCallback) {
          _this7.hide();
          if (_this7.config.searchRicCallbackScope) {
            _this7.config.searchRicCallback.call(_this7.config.searchRicCallbackScope, {
              name: description,
              ric: ric,
              isin: isin,
              type: type
            });
          } else {
            _this7.config.searchRicCallback({
              name: description,
              ric: ric,
              isin: isin,
              type: type
            });
          }
        } else {
          defaultItemClickCallback(_this7.searchType, {
            ric: ric
          }, _this7);
        }
      } else if (link && !_this7.config.searchRic) {
        // only when isin is enough
        // TODO: only redirect when there is no specific click handler. e.g. a popup search on a screener should never link to detail page!
        window.redirectTo("/detail/detailPage.html?".concat(link));
        if (!_this7.config.static) {
          _this7.hide();
        }
      } else if (isISIN && _this7.config.searchRic) {// display ric hits for that isin
        // TODO: try to open ric results like if user clicked the isin, but as user
        //       anyhow has then to select a ric, it's not that severe that he must click on the isin also
        //       in the moment (one unnecessary step)
      } else if (!isId && ric && !_this7.config.ignoreUncertainRics) {
        // expect this to be a chain ric or speedguide
        speedGuideRedirect(ric, _this7.dfaShortCut);
      } else if (_this7.config.multipleSymbolInputCallback) {
        // no hits from solr and also not from extraserver, try whether it could be a multi symbol paste
        var rics = _this7.searchTerm.trim().split(/\s*[,;\n\s]\s*/);
        rics = rics.filter(function (v) {
          return v != '';
        }); // remove array positions with only empty strings
        if (rics.length > 1) {
          _this7.hide();
          _this7.config.multipleSymbolInputCallback(rics);
        }
      }
    });
  };
  if (window.themeProperties['incrementalSearch.symbolHitFromIncrementalResponseField']) {
    checkDirectHit();
  } else {
    checkExtraserver();
  }
};
SearchResultBox.prototype.hide = function () {
  this.searchTerm = null;
  this.ajaxPending = false;
  this.searchType = this.config.searchType || _searchTypesEnum.default.INSTRUMENTS;
  this.searchFilter = null;
  this.instrumentTypes = this.config.instrumentTypes || ['*'];
  this.page = 1;
  this.$searchBox.css('display', 'none');
  this.logTimeTracking();
};
SearchResultBox.prototype.show = function () {
  // #. Bind the solar search button keydown event
  if (this.isSolarSearch()) {
    this.onSolarSearchButtonKeydown();
  }
  // TODO: check if this function is even necessary as render() resets this anyway
  this.$searchBox.css('display', 'block');
};
SearchResultBox.prototype.logTimeTracking = function () {
  if (this.timeTracking && this.timeTracking.length) {
    var sum = 0;
    var max = 0;
    var finalSearchTerm = "";
    this.timeTracking.forEach(function (item) {
      sum += item.millis;
      if (item.millis > max) {
        max = item.millis;
      }
      if (item.searchTerm.length > finalSearchTerm.length) {
        finalSearchTerm = item.searchTerm;
      }
    });
    var avg = sum / this.timeTracking.length;
    window.logExecutionTime('incrementalSearch', avg, "".concat(this.timeTracking.length, " search queries for \"").concat(finalSearchTerm, "\", avg ").concat(avg, "ms, max ").concat(max, "ms time to display per query"));
    this.timeTracking = [];
  }
};

/**
 * Key handler for the solar search icon button
 * Tab - key will move the focus to result table list menu
 */
SearchResultBox.prototype.onSolarSearchButtonKeydown = function () {
  var _this8 = this;
  // #. Get the search input
  var $input = this.getSolarSearchInput();

  // #. Get the search icon button
  this.$solarSearchButton = $input.next('button.search');
  var inputID = 'incrementalsearch_results';
  var resultTable = "#".concat(inputID);

  // #. Unbind the keydown event
  this.$solarSearchButton.off('keydown');

  // #. Bind the keydown event
  this.$solarSearchButton.on('keydown', function (event) {
    var isResultVisible = $(resultTable).is(':visible');
    // #. Set focus to item list - level 0 when the result table is visible
    if (event.keyCode === _keyCodes.default.TAB && isResultVisible && !event.shiftKey) {
      event.preventDefault();
      event.stopPropagation();
      _this8.setFocusToLeftPanel();
      return false;
    }
  });
};
SearchResultBox._analyseSearchTerm = function (searchTerm) {
  if (!searchTerm || searchTerm.length < 1) {
    return {
      term: '',
      error: 'empty search string',
      dfaShortCut: null
    };
  } else {
    var serchTermWithDFAShortCut = searchTerm.split('/');
    if (serchTermWithDFAShortCut.length == 1) {
      return {
        term: searchTerm,
        error: '',
        dfaShortCut: null
      };
    } else {
      var vdfaShortCut = serchTermWithDFAShortCut.pop();
      var vterm = serchTermWithDFAShortCut.join('/');
      return {
        term: vterm,
        error: '',
        dfaShortCut: vdfaShortCut
      };
    }
  }
};
SearchResultBox.prototype.setSearchTerm = function (searchTerm, instantSearch) {
  var _this9 = this;
  var searchTermStatus = SearchResultBox._analyseSearchTerm(searchTerm);
  searchTerm = searchTermStatus.term;
  var oldSearchTerm = this.searchTerm;
  this.searchTerm = searchTerm.trim();
  this.page = 1; //reset the page to first page when there is a change in search term
  this.dfaShortCut = searchTermStatus.dfaShortCut == null ? null : searchTermStatus.dfaShortCut.trim();
  if (instantSearch && !this.config.disableInstantSearch) {
    this.itemsPerPage = 1;
    this.checkDirectRicHit();
  } else {
    this.calculateItemsPerPage();
  }
  var isSearchTermValid = this.searchTerm && this.searchTerm.length > 0;
  if (!isSearchTermValid) {
    this.navigationData = [];
  }
  if (!isSearchTermValid || this.searchTerm === oldSearchTerm) {
    // do nothing and return a successful promise
    this.render(); // TODO: full rerender should not be necessary here (currently necessary because render attaches the proper click handlers to hide the overlay)
    return Promise.resolve([]);
  }
  return Promise.all(this.availableTypes.map(this.requestSearchType.bind(this))).then(function (responseList) {
    _this9.ajaxPending = false;
    if (responseList[0] && responseList[0].searchTerm && responseList[0].searchTerm[0] === _this9.searchTerm) {
      _this9.setData(responseList);
      _this9.render();
      _this9.updatePosition();
    }
    _this9.logData(responseList);
    return responseList;
  });
};
SearchResultBox.prototype.requestSearchType = function (type) {
  var offset = (this.page - 1) * this.itemsPerPage;
  var settings = {
    type: type,
    term: this.searchTerm,
    offset: offset,
    limit: this.itemsPerPage,
    filter: this.instrumentTypes[0],
    countInstTypeOnly: this.countInstTypeOnly
  };
  var filter = this.searchFilter ?? this.config.instrumentTypes ?? '*';
  settings.filter = filter;
  if (!this.searchTerm || this.searchTerm.length < 1) {
    return {
      // return an empty list in case of errors
      type: type,
      count: 0,
      result: [],
      facets: [],
      error: 'empty search string'
    };
  }
  if ((window.user.locale === 'ja' || window.user.locale === 'zh') && type === "instruments") {
    // fetch the index based on user locale
    var index = window.user.locale === 'ja' ? 'LMM_ja' : 'LMM_zh';
    var shortenInstrumentTitle = filter === "*" ? "*" : Object.keys(INSTRUMENT_ENUM).find(function (key) {
      return INSTRUMENT_ENUM[key] === filter;
    });
    return this.requestSearchTypeForAsia(index, shortenInstrumentTitle);
  } else {
    this.ajaxPending = true;
    return (0, _ajaxRequest.ajaxGetJson)('/incrementalSearch.action', settings).catch(function (error) {
      return {
        // return an empty list in case of errors
        type: type,
        count: 0,
        result: [],
        facets: [],
        error: error
      };
    });
  }
};
SearchResultBox.prototype.requestSearchTypeForAsia = function (index) {
  var _this10 = this;
  var instrument = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "*";
  return new Promise(function (resolve, reject) {
    // set the payload for api request
    var payload = {
      search: _this10.searchTerm,
      instrumentType: [instrument],
      exchanges: [],
      fids: ["symbol", "type", "country", "currency", "exchangePlace", "displayname", "id"],
      pageSize: _this10.itemsPerPage,
      pageNo: _this10.page - 1,
      boost: {}
    };
    window.dory.ServiceRest.post("/find/globalsearch/".concat(index), payload).then(function (response) {
      var responseData = response.data;
      var modifiedData = {};
      if (responseData.status === "OK") {
        // Modify the data object to the required format
        modifiedData.count = responseData.totalCount;
        modifiedData.result = [];
        modifiedData.searchTerm = [_this10.searchTerm];
        modifiedData.type = "instruments";
        modifiedData.facets = [];
        var partialCounts = responseData.partialCounts;
        var instrumentAvailable = Object.keys(partialCounts);
        // Update facets
        for (var _i = 0, _instrumentAvailable = instrumentAvailable; _i < _instrumentAvailable.length; _i++) {
          var _instrument = _instrumentAvailable[_i];
          var instrumentTitle = INSTRUMENT_ENUM[_instrument];
          modifiedData.facets.push({
            count: partialCounts[_instrument],
            title: window.getMessage("instrumentType.select.".concat(instrumentTitle)),
            value: instrumentTitle
          });
        }
        // Update result array
        modifiedData.result = responseData.data.map(function (data) {
          return {
            country: data.country,
            description: data.displayname,
            type: data.type,
            group: data.type === "CHN" ? INSTRUMENT_ENUM["CHN"] : window.getMessage("instrumentType.select.".concat(INSTRUMENT_ENUM[data.type])),
            isin: data.id !== data.symbol ? data.id : '',
            symbol: data.symbol
          };
        });
      }
      resolve(modifiedData);
    }).catch(function (error) {
      reject({
        type: "instruments",
        count: 0,
        result: [],
        facets: [],
        error: error
      });
    });
  });
};
SearchResultBox.prototype.setPage = function (page) {
  this.page = page;
  this.refresh();
};
SearchResultBox.prototype.refresh = function (resetNavigationIndex) {
  var _this11 = this;
  this.requestSearchType(this.searchType).then(function (results) {
    _this11.setResults(results);
    if (_this11.navigationData[resetNavigationIndex]) {
      _this11.navigationData[resetNavigationIndex] = results;
    }
    _this11.render();
    var $table = _this11.$searchBox.find('.mainsearch table.list.marktr');
    if ($table.is(':visible')) {
      _this11.setFocusToResultTable();
    } else {
      _this11.setFocusToResultTable2();
    }
  });
};
SearchResultBox.prototype.setSearchType = function (type, filter) {
  this.page = 1;
  this.searchType = type;
  this.searchFilter = filter || null;
  var resetNavigationIndex = this.availableTypes.indexOf(type);
  this.refresh(resetNavigationIndex);
};
SearchResultBox.prototype.getTableControls = function () {
  var _this12 = this;
  var pages = Math.ceil(this.totalItems / this.itemsPerPage);
  return (0, _basicTableControls.default)({
    page: this.page,
    pages: pages,
    noLastPage: this.searchType === _searchTypesEnum.default.NEWS,
    first: function first() {
      _this12.setPage(1);
    },
    prev: function prev() {
      _this12.setPage(_this12.page - 1);
    },
    next: function next() {
      _this12.setPage(_this12.page + 1);
    },
    last: function last() {
      _this12.setPage(pages);
    },
    tableCaption: this.getTableCaption()
  });
};
SearchResultBox.prototype.getTableCaption = function () {
  return (0, _messageHandler.getMessage)('incrementalsearch.results');
};
var getCountString = function getCountString(type, count, limit) {
  return type !== 'news' ? count : count > limit ? (0, _messageHandler.getMessage)('incrementalsearch.countplus', limit) : count;
};
var generateCountryFlag = function generateCountryFlag(country) {
  if (country) {
    return "<span title=\"".concat(window.YAHOO.lang.escapeHTML(country), "\" class=\"country ").concat(window.YAHOO.lang.escapeHTML(country), "\" style=\"width:16px;\"></span>");
  }
  return "<span style=\"width:16px;\"></span>";
};
var formatColumnValue = function formatColumnValue(value, columnName, searchType, item) {
  value = value ? value : '';
  switch (columnName) {
    case 'headline':
    case 'description':
    // case 'displayname':
    case 'displaynameLeumi': // For several North American customers.
    case 'bnd_issuer':
    case 'caption':
      return "<span title=\"".concat(window.YAHOO.lang.escapeHTML(value), "\" style=\"text-align: left\">").concat(window.YAHOO.lang.escapeHTML(value), "</span>");
    case 'timestamp':
      return window.YAHOO.fcom.Format.formatDateTime(new window.fcom.date.DateTime().setTimestamp(value), {
        style: 'dateTimeLong'
      });
    case 'page':
      return "<span>".concat(value.map(function (a) {
        return "<span>".concat(window.YAHOO.lang.escapeHTML(a), "</span>");
      }).join("<span class=\"spacer\">".concat(pagePathDivider, "</span>")), "</span>");
    case 'quickQuote':
      return "<span class=\"link quickQuote\" onclick=\"quickQuote('".concat(item.symbol || item.id, "', event)\">Quick Quote</span>");
    case 'bnd_issuer_domicile':
      return "<span title=\"".concat(window.YAHOO.lang.escapeHTML(value), "\" class=\"country ").concat(window.YAHOO.lang.escapeHTML(value), "\" style=\"width:16px;\"></span>");
    case 'country':
      return "<span title=\"".concat(window.YAHOO.lang.escapeHTML(value), "\" class=\"country large ").concat(window.YAHOO.lang.escapeHTML(value), "\" style=\"width:32px;\"></span>");
    default:
      return window.YAHOO.lang.escapeHTML(value);
  }
};
var defaultItemClickCallback = function defaultItemClickCallback(type, item, searchResultBox, evt) {
  var dfaStatus = decideDirectFunctionAccess(type, item, evt);
  switch (dfaStatus.state) {
    case DFA_STATUS.CREATE:
      {
        toDirectFunctionAccess(type, item, dfaStatus.parent);
        break;
      }
    case DFA_STATUS.IRRELEVANT:
      {
        redirectDecision(type, item, searchResultBox);
        break;
      }
  }
};
var handleDFAShortCut = function handleDFAShortCut($searchTermMetaDta, $searchResultBox) {
  (0, _ajaxRequest.ajaxGet)(dfaNavDataRestLink, generateDataItem($searchTermMetaDta)).then(function (response) {
    var navData = JSON.parse(response);
    var navDataForShortCut = _DirectFunctionAccessPanel.default.navDataForShortCode(navData.itemList, $searchResultBox.dfaShortCut);
    if ($searchResultBox.dfaShortCut != navDataForShortCut.shortCode && !(RIC_PATTTERN.test($searchResultBox.searchTerm) || FUTURE_RIC_PATTERN.test($searchResultBox.searchTerm))) {
      speedGuideRedirect($searchResultBox.searchTerm, $searchResultBox.dfaShortCut);
    } else {
      dfaRedirect($searchTermMetaDta, navDataForShortCut);
    }
  }).catch(function (e) {
    console.error(e);
    dfaRedirect($searchTermMetaDta, {
      linkCode: 'overv'
    });
  });
};
/*
    When search term is an ISIN use the RIC from navigation data
    because ric is the safest id for all detail pages.
 */
var dfaRedirect = function dfaRedirect($instrMetaData, $navMetaData) {
  var instrData = {};
  if ($instrMetaData.isISIN) {
    if ($navMetaData.ric) {
      instrData = Object.assign(instrData, {
        isin: $instrMetaData.isin,
        symbol: $navMetaData.ric
      });
    } else {
      instrData = Object.assign(instrData, {
        isin: $instrMetaData.isin
      });
    }
  } else {
    instrData = Object.assign(instrData, {
      isin: $instrMetaData.isin,
      symbol: $instrMetaData.ric
    });
  }
  if ($navMetaData.linkUrl && $navMetaData.linkUrl.includes('&view=')) {
    var queryParams = $navMetaData.linkUrl.split('?')[1];
    var viewName = new URLSearchParams(queryParams).get('view');
    instrData = Object.assign(instrData, {
      viewName: viewName
    });
  }
  _DirectFunctionAccessPanel.default.redirectToFunction(instrData, $navMetaData.linkCode);
};
var DFA_STATUS = {
  CREATE: 'create',
  ACTIVE: 'active',
  IRRELEVANT: 'irrelevant'
};
var decideDirectFunctionAccess = function decideDirectFunctionAccess(type, item, evt) {
  if (type === _searchTypesEnum.default.INSTRUMENTS) {
    if (item.isin || item.id || item.symbol) {
      var dfaParentRow = evt.target.closest("tr");
      if (!_DirectFunctionAccessPanel.default.isActive(dfaParentRow)) {
        return {
          state: DFA_STATUS.CREATE,
          parent: dfaParentRow
        };
      } else {
        return {
          state: DFA_STATUS.ACTIVE,
          parent: dfaParentRow
        };
      }
    }
  }
  return {
    state: DFA_STATUS.IRRELEVANT,
    parent: null
  };
};
var toDirectFunctionAccess = function toDirectFunctionAccess(type, $item, $dfaParentRow) {
  (0, _ajaxRequest.ajaxGet)(dfaNavDataRestLink, generateDataItem($item)).then(function (response) {
    var navData = JSON.parse(response);
    var dfa = new _DirectFunctionAccessPanel.default(navData, $dfaParentRow, $item);
    dfa.render();
  }).catch(function (e) {
    console.error(e);
    redirectDecision(type, item, searchResultBox);
  });
};
var generateDataItem = function generateDataItem($item) {
  return $item.isin ? {
    isin: $item.isin
  } : {
    ric: $item.symbol || $item.id
  };
};
var redirectDecision = function redirectDecision(type, item, searchResultBox) {
  var _SEARCHTYPE$NEWS$SEAR;
  // choose the appropriate function and pass item to get the new target url
  if (item.ric) {
    window.redirectTo(directRicLink(item));
    return;
  }
  window.location = window.ctx + (_SEARCHTYPE$NEWS$SEAR = {}, _defineProperty(_SEARCHTYPE$NEWS$SEAR, _searchTypesEnum.default.NEWS, newsLink), _defineProperty(_SEARCHTYPE$NEWS$SEAR, _searchTypesEnum.default.INSTRUMENTS, detailLink), _defineProperty(_SEARCHTYPE$NEWS$SEAR, _searchTypesEnum.default.WLPF, item.group === 'WL' ? watchlistLink : portfolioLink), _defineProperty(_SEARCHTYPE$NEWS$SEAR, _searchTypesEnum.default.NAV, pageLink), _defineProperty(_SEARCHTYPE$NEWS$SEAR, _searchTypesEnum.default.ISSUER, bondIssuerLink), _SEARCHTYPE$NEWS$SEAR)[type](item);
  if (!searchResultBox.config.static) {
    searchResultBox.hide();
  }
};
var ricSearchItemClickCallback = function ricSearchItemClickCallback(type, item, searchResultBox) {
  var tickerOverride = null;
  if (item.exchangePlace === 'LIP' && item.type === 'FUN') {
    tickerOverride = item.ticker;
  }
  (0, _ajaxRequest.ajaxPostJson)('/generalSearch.action', {
    method: 'handleRicSearch',
    id: item.symbol || item.id,
    isin: item.isin
  }).then(function (response) {
    if (response.result.length <= 1) {
      var ric = item.symbol || item.id;
      if (response.result.length === 1 && response.result[0].ric) {
        ric = response.result[0].ric;
      }
      // use item ric instead of exchange selection
      searchResultBox.hide();
      if (searchResultBox.config.searchRicCallbackScope) {
        searchResultBox.config.searchRicCallback.call(searchResultBox.config.searchRicCallbackScope, {
          ric: ric,
          name: item.description || item.displaynameLeumi,
          tickerOverride: tickerOverride,
          type: item.type
        });
      } else {
        searchResultBox.config.searchRicCallback({
          ric: ric,
          name: item.description || item.displaynameLeumi,
          tickerOverride: tickerOverride,
          type: item.type
        });
      }
      return;
    }
    var $ricSearch = searchResultBox.$searchBox.find('.ricsearch');
    new _ThirdLevelTable.default($ricSearch.get(0), response, {
      itemsPerPage: searchResultBox.itemsPerPage,
      columns: searchResultBox.config.l3Columns,
      clickHandler: function clickHandler() {
        searchResultBox.hide();
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        if (searchResultBox.config.searchRicCallbackScope) {
          var _searchResultBox$conf;
          (_searchResultBox$conf = searchResultBox.config.searchRicCallback).call.apply(_searchResultBox$conf, [searchResultBox.config.searchRicCallbackScope].concat(args));
        } else {
          var _searchResultBox$conf2;
          (_searchResultBox$conf2 = searchResultBox.config).searchRicCallback.apply(_searchResultBox$conf2, args);
        }
      }
    });
    $ricSearch.addClass('active');
    var $mainSearch = searchResultBox.$searchBox.find('.mainsearch');
    $mainSearch.removeClass('active');
    searchResultBox.enableResult2TabIndex();
    searchResultBox.onBackButtonClicked();
    $ricSearch.find('table.list').focus();
  });
};
SearchResultBox.prototype.handleItemClick = function (item, e) {
  var callbackFunction = this.config.itemCallback || (this.config.searchRic ? ricSearchItemClickCallback : defaultItemClickCallback);
  callbackFunction(this.searchType, item, this, e);
};
SearchResultBox.prototype.getNavigationListItem = function (name, count, isActive, clickHandler) {
  var sublist = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  return $('<li/>').toggleClass('active', isActive).append($('<a/>').attr({
    role: 'tab',
    'aria-controls': 'panelMainSearch',
    'aria-selected': isActive,
    tabindex: this.config.isMobile ? 0 : -1
  }).html("<span class=\"name\">".concat(name, "</span> <span class=\"count\">").concat(count, "</span>")).on('click', clickHandler)).append(sublist);
};
SearchResultBox.prototype.render = function () {
  var _this13 = this;
  var showFlags = !window.user.isChinaSpecificUser;
  var _this = this;
  this.navigationData = this.navigationData || [];

  // Create Navigation HTML
  var searchResultNavigation = this.navigationData.map(function (navigationItem) {
    navigationItem.facets = navigationItem.facets || [];
    var getClickHandler = function getClickHandler(facetValue) {
      return function () {
        _this.$searchBox.find('li').removeClass('active');
        if (facetValue === _this.searchFilter) {
          _this.setSearchType(navigationItem.type);
        } else {
          $(this).parent('li').addClass('active');
          $(this).attr('aria-selected', true);
          _this.setSearchType(navigationItem.type, facetValue);
        }
      };
    };
    var name = (0, _messageHandler.getMessage)("incrementalsearch.type.".concat(navigationItem.type));
    var sublist = navigationItem.facets.filter(function (f) {
      return f.count;
    }) // filter out facets without results
    .map(function (facet) {
      return _this13.getNavigationListItem(facet.title, facet.count, _this13.searchFilter === facet.value, getClickHandler(facet.value));
    });
    sublist = sublist.length ? $('<ul/>').append(sublist) : [];
    return _this13.getNavigationListItem(name, getCountString(navigationItem.type, navigationItem.facets.reduce(function (sum, a) {
      return sum + a.count;
    }, 0) || navigationItem.count, _this13.itemsPerPage), !_this13.searchFilter && navigationItem.type === _this13.searchType, getClickHandler(), sublist);
  });

  // Get Table Columns to be displayed
  var tableColumns = Object.assign({}, tableColumnDefinitions, this.config.columns || {})[this.searchType] || [];
  if (!(this.config.columns && this.config.columns[this.searchType]) && this.results && this.results[0] && this.results[0].ticker && this.searchType === _searchTypesEnum.default.INSTRUMENTS) {
    // if a ticker is available it should be used instead of ISIN
    tableColumns = ['description', 'group', 'ticker'];
    if (this.results[0].country) {
      tableColumns.push('country');
    }
  }
  // Create Results HTML if available
  var searchResults = null;
  if (this.results) {
    _DirectFunctionAccessPanel.default.deActivate();
    searchResults = this.results.map(function (resultRow) {
      return $('<tr/>').attr('role', 'button').attr('tabindex', _this13.isMobile ? 0 : -1).append(_this13.searchType === _searchTypesEnum.default.INSTRUMENTS && showFlags ? "<td>".concat(generateCountryFlag(resultRow.country), "</td>") : '').append(tableColumns.map(function (col) {
        return "<td class=\"".concat(col === 'ticker' ? 'trim' : '', "\">").concat(formatColumnValue(resultRow[col], col, _this13.searchType, resultRow), "</td>");
      })).on('click', function (e) {
        if (_DirectFunctionAccessPanel.default.allowClick()) {
          _this13.handleItemClick(resultRow, e);
        }
        e.stopPropagation();
      });
    });
  }
  var $resultTable = $('<table/>').addClass('list').append($('<colgroup/>').append(this.searchType === _searchTypesEnum.default.INSTRUMENTS && showFlags ? $('<col/>').css('width', '30px') : '').append(tableColumns.map(function (colName) {
    return $('<col/>').addClass("col-".concat(colName));
  }))).append($('<tr/>').append(tableColumns.map(function (colName) {
    return $('<th/>').text((0, _messageHandler.getMessage)("incrementalsearch.col.".concat(_this13.searchType, ".").concat(colName))).attr('colSpan', _this13.searchType === _searchTypesEnum.default.INSTRUMENTS && colName === 'description' && showFlags ? 2 : 1);
  })));
  var $ul = $('<ul/>').attr({
    tabindex: 0
  }).addClass('search-list-items').attr('role', 'tablist').append(searchResultNavigation);
  var $mainsearchRightPanel = $('<div/>').append($resultTable);
  if (searchResults && searchResults.length) {
    var $tableCaption = $('<caption/>').text(this.getTableCaption()).addClass('visuallyhidden');
    $resultTable.addClass('marktr').attr('tabindex', 0).prepend($tableCaption).append(searchResults);
    $mainsearchRightPanel.append(this.getTableControls());
  } else {
    $resultTable.append($('<tr/>').addClass('noresults').append($('<td/>').attr('colspan', tableColumns.length).attr({
      'role': 'alert',
      'aria-live': 'polite'
    }).html((0, _messageHandler.getMessage)('incrementalsearch.noresults', (0, _messageHandler.getMessage)("incrementalsearch.type.".concat(this.searchType))))));
  }
  var $results = $('<div/>').addClass('mainsearch active').attr({
    role: 'tabpanel',
    id: 'panelMainSearch'
  }).attr('id', 'panelMainSearch').append($ul).append($mainsearchRightPanel);
  var $combinedResults = $('<div/>').addClass('search-results').append($results).append('<div class="ricsearch"></div>');

  // Add items to DOM
  this.$searchBox.html('').append($combinedResults);
  if (!this.config.static) {
    // Register a body click handler to remove the box
    var clickFunction = function clickFunction(e) {
      if (!$(e.target).parents("#".concat(_this13.config.searchBoxId)).length && !$(e.target).is('[data-incrementalsearch]') && !e.target.isEqualNode(_this13.$searchInput[0])) {
        $('body').unbind('click', clickFunction);
        _this13.hide();
      }
    };
    $('body').on('click', clickFunction.bind(_this));
  }
};

// Position Search Box properly on the screen
SearchResultBox.prototype.updatePosition = function () {
  var enableSmartPositioning = this.config.smartPositioning || false;
  var height = this.$searchBox.outerHeight();
  var position = this.searchInputOffset;
  var top = position.top + this.searchInputHeight;
  if (enableSmartPositioning && this.showOnTop) {
    top = position.top - height - 8;
  }
  this.$searchBox.css({
    top: "".concat(top, "px")
  });
  window.setTimeout(function () {
    window.YAHOO.widget.Overlay.windowResizeEvent.fire();
  });
};
SearchResultBox.prototype.setResults = function (_ref) {
  var result = _ref.result,
    type = _ref.type,
    count = _ref.count,
    error = _ref.error;
  if (error) {
    console.error(error);
  }
  this.results = result;
  this.searchType = type;
  this.totalItems = Math.min(this.itemsPerPage * 100, count); // sets the 'totalItems' based on 'itemsPerPage' to limit the page size to 100
};

SearchResultBox.prototype.setData = function (data) {
  this.navigationData = data;
  // Take the first resultset that has any results, or as fallback select instruments (index 0)
  var returnResult = data.find(function (f) {
    return !!f && f.count;
  });
  this.setResults(returnResult || data[0]);
};
SearchResultBox.prototype.logData = function (data) {
  data.map(function (navigationItem) {
    if (navigationItem && navigationItem.pathString) {
      console.log({
        Solr_search_human_readable: navigationItem.pathString
      });
      console.log("Solr search link: ".concat(encodeURI(navigationItem.pathString)));
    }
  });
};
SearchResultBox.prototype.calculateItemsPerPage = function () {
  this.searchInputOffset = this.$searchInput.offset();
  var searchInputX = this.searchInputOffset.top - $(window).scrollTop();
  this.showOnTop = true;
  var availableHeight = searchInputX;
  if (availableHeight < window.innerHeight - (searchInputX + this.searchInputHeight)) {
    // Top has more space, show results on bottom
    this.showOnTop = false;
    availableHeight = window.innerHeight - searchInputX - this.searchInputHeight;
  }
  var headRowHeight = 44;
  var rowHeight = 45;
  var paginationHeight = 30;
  var searchBoxSpacing = 10;
  var possibleRows = (availableHeight - headRowHeight - paginationHeight - searchBoxSpacing) / rowHeight;
  if (possibleRows > 4 && possibleRows < maxItemsPerPage) {
    this.itemsPerPage = Math.floor(possibleRows);
  }
};
var speedGuideRedirect = function speedGuideRedirect(ric, dfaShortCut) {
  // Convert ric to uppercase only if it's currently in lowercase
  var modifiedRic = ric && ric.toLowerCase() === ric ? ric.toUpperCase() : ric;
  // Convert dfa to uppercase only if it's currently in lowercase
  var modifiedDFA = dfaShortCut && dfaShortCut.toLowerCase() === dfaShortCut ? dfaShortCut.toUpperCase() : dfaShortCut;
  var joinedRic = dfaShortCut ? modifiedRic + '/' + modifiedDFA : ric;
  window.redirectTo("/detail/detailPage.html?ric=".concat(encodeURIComponent(joinedRic)));
};
var _default = exports.default = SearchResultBox;

},{"../../app/utils/axios":1,"core/Ajax/ajaxRequest":12,"fcom/messages/messageHandler":15,"fcom/search/DirectFunctionAccessPanel":16,"fcom/search/ThirdLevelTable":19,"fcom/search/basicTableControls":20,"fcom/search/searchTypesEnum":23,"fcom/util/enums/keyCodes":24}],19:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _messageHandler = require("fcom/messages/messageHandler");
var _basicTableControls = _interopRequireDefault(require("fcom/search/basicTableControls"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var tableFidlets = ['SEGMENT', 'DATA_QUALITY_IMAGE', 'TRADE_PRICE_MARKED', 'CURRENCY_SHORT'];
var TABLE_ACTIONS = {
  FIRST: 0,
  PREVIOUS: 1,
  NEXT: 2,
  LAST: 3
};
var ThirdLevelTable = function ThirdLevelTable(node, data, config) {
  var _this = this;
  var tableFidletsAtm = tableFidlets.slice(0);
  if (data.type === 'FUT') {
    tableFidletsAtm = ['EXPIR_DATE', 'RIC_KEY', 'DATA_QUALITY_IMAGE', 'TRADE_PRICE_MARKED', 'CURRENCY_SHORT'];
  }
  var fidlets = config.columns.length > 0 ? config.columns : window.themeProperties['incrementalSearch.level3Columns'] || tableFidletsAtm;
  this.columns = fidlets.map(function (a) {
    var index = data.fidlets.findIndex(function (f) {
      return f[0] === a;
    });
    return [].concat(_toConsumableArray(data.fidlets[index]), [index]);
  });
  this.rawData = data;
  this.data = data.result.map(function (a) {
    return {
      ric: a.ric,
      isin: a.isin,
      data: _this.columns.map(function (c) {
        return a.data[c[2]];
      }) // find datapoints that are in the columns array
    };
  });

  this.type = data.type;
  if (data.type === 'FUT') {
    this.data.sort(function (a, b) {
      if (a.ric < b.ric) {
        return -1;
      }
      if (a.ric > b.ric) {
        return 1;
      }
      return 0;
    });
  }
  this.node = node;
  this.page = 1;
  this.count = data.count;
  this.itemsPerPage = config.itemsPerPage;
  this.clickHandler = config.clickHandler;
  this.tableAction = null;
  this.render(true);
};
ThirdLevelTable.prototype.getTableControls = function () {
  var _this2 = this;
  var pages = Math.ceil(this.count / this.itemsPerPage);
  var $controls = (0, _basicTableControls.default)({
    page: this.page,
    pages: pages,
    first: function first() {
      _this2.tableAction = TABLE_ACTIONS.FIRST;
      _this2.setPage(1);
    },
    prev: function prev() {
      _this2.tableAction = TABLE_ACTIONS.PREVIOUS;
      _this2.setPage(_this2.page - 1);
    },
    next: function next() {
      _this2.tableAction = TABLE_ACTIONS.NEXT;
      _this2.setPage(_this2.page + 1);
    },
    last: function last() {
      _this2.tableAction = TABLE_ACTIONS.LAST;
      _this2.setPage(pages);
    },
    tableCaption: this.getTableCaption()
  });
  var $backButton = $('<span/>').addClass('back').attr({
    'role': 'button',
    'tabindex': 0
  }).text((0, _messageHandler.getMessage)('incrementalsearch.ricsearch.back')).click(function () {
    return $(_this2.node).removeClass('active').siblings('.mainsearch').addClass('active');
  });
  $controls.prepend($backButton);
  return $controls;
};
ThirdLevelTable.prototype.getTableCaption = function () {
  return (0, _messageHandler.getMessage)('incrementalsearch.results.level');
};
ThirdLevelTable.prototype.setPage = function (page) {
  this.page = page;
  this.render();
};
ThirdLevelTable.prototype.render = function (isOnLoad) {
  var _this3 = this;
  var $activeRow = $('.ricsearch table.list.marktr tr.hover.keyboard-focus');
  var $nextRow = $activeRow.next('tr');
  var $prevRow = $activeRow.prev('tr');
  if ($prevRow.is(':first-child')) {
    $prevRow = [];
  }
  var $table = $('<table/>').addClass('list marktr');
  var $tableCaption = $('<caption/>').text(this.getTableCaption()).addClass('visuallyhidden');
  var offset = (this.page - 1) * this.itemsPerPage;
  var displayResults = this.data.slice(offset, offset + this.itemsPerPage);

  // create header row
  var firstColWidth = '50%';
  if (this.columns.length === 5) {
    firstColWidth = '40%';
  } else if (this.columns.length >= 5) {
    firstColWidth = '30%';
  }
  var colsRow = this.columns.map(function (a, i) {
    return $('<col/>').attr('width', !i ? firstColWidth : 'auto');
  });
  var headerRow = this.columns.map(function (a, i) {
    return $('<th/>').text(a[1]);
  });
  $table.append($('<colgroup/>').append(colsRow));
  $table.append($('<tr/>').append(headerRow));
  $table.append(displayResults.map(function (result) {
    return $('<tr/>').attr('role', 'button').attr('tabindex', _this3.isMobile ? 0 : -1).append(
    // create data row
    result.data.map(function (a) {
      return $('<td/>').html("<span>".concat(a[1], "</span>"));
    })).on('click', function () {
      var dataForCallback = _this3.getDataForCallback(result.ric);
      if (result.isin) {
        dataForCallback.isin = result.isin;
      }
      if (_this3.type) {
        dataForCallback.type = _this3.type;
      }
      _this3.clickHandler(dataForCallback);
    });
  }));
  $table.prepend($tableCaption);
  $(this.node).html('').append($('<div/>').append($table).append(this.getTableControls()));
  $table.attr({
    tabindex: 0
  });

  // #. Set focus to active row
  if (!isOnLoad) {
    if (this.tableAction === TABLE_ACTIONS.NEXT || this.tableAction === TABLE_ACTIONS.FIRST) {
      $table.find('.keyboard-focus').removeClass('hover keyboard-focus');
      this.setRowActive($table, $table.find('tr').not(':first').first());
    } else if (this.tableAction === TABLE_ACTIONS.PREVIOUS || this.tableAction === TABLE_ACTIONS.LAST) {
      var $rows = $table.find('tr').not(':first');
      this.setRowActive($table, $($rows[$rows.length - 1]));
    }
  } else {
    $table.focus();
  }
};
ThirdLevelTable.prototype.getDataForCallback = function (ric) {
  var dataSet = this.rawData.result.find(function (f) {
    return f.ric === ric;
  }).data;
  var nameKeyIndex = this.rawData.fidlets.findIndex(function (f) {
    return f[0] === 'NAME_SHORT_KEY';
  });
  return {
    ric: ric,
    name: dataSet[nameKeyIndex][1]
  };
};
ThirdLevelTable.prototype.setRowActive = function ($table, $row) {
  $table.find('.keyboard-focus').removeClass('hover keyboard-focus');
  $row.addClass('hover keyboard-focus').attr({
    tabindex: 0
  }).focus();
};
var _default = exports.default = ThirdLevelTable;

},{"fcom/messages/messageHandler":15,"fcom/search/basicTableControls":20}],20:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _messageHandler = require("fcom/messages/messageHandler");
/**
 * Simple Method to generate a table control item
 * config param includes current page, total pages, and functions for paginating to first, next, previous and last page
 */
var getBasicTableControls = function getBasicTableControls(_ref) {
  var page = _ref.page,
    pages = _ref.pages,
    first = _ref.first,
    next = _ref.next,
    prev = _ref.prev,
    last = _ref.last,
    noLastPage = _ref.noLastPage,
    tableCaption = _ref.tableCaption;
  var navItem = function navItem(className, disabled, fn) {
    return $('<button/>').addClass('icon').addClass(className + (disabled ? ' disabled' : '')).prop('disabled', disabled ? true : false).attr('title', (0, _messageHandler.getMessage)("tables.tableControls.paging.tooltip.".concat(className))).attr('aria-label', (0, _messageHandler.getMessage)("tables.tableControls.paging.label.".concat(className), tableCaption)).click(function (e) {
      if (!disabled) {
        e.preventDefault();
        e.stopPropagation();
        fn();
      }
      return false;
    });
  };
  var $controls = $('<div/>').addClass('controls');
  var pageInfo = (0, _messageHandler.getMessage)("incrementalsearch.paging.number".concat(noLastPage ? '.simple' : ''), page, pages);
  $controls.append(navItem('firstPage', page === 1, first)).append(navItem('previousPage', page === 1, prev)).append($('<span/>').text(pageInfo)).append(navItem('nextPage', page === pages, next));
  if (!noLastPage) {
    $controls.append(navItem('lastPage', page === pages, last));
  }
  return $controls;
};
var _default = exports.default = getBasicTableControls;

},{"fcom/messages/messageHandler":15}],21:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _SearchResultBox = _interopRequireDefault(require("fcom/search/SearchResultBox"));
var _runFunctionDebounced = _interopRequireDefault(require("fcom/util/functions/runFunctionDebounced"));
var _keyCodes = _interopRequireDefault(require("fcom/util/enums/keyCodes"));
var _hooks = _interopRequireDefault(require("fcom/hooks"));
var _SearchHistory = _interopRequireDefault(require("fcom/search/SearchHistory"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var debounceMilliseconds = 150; // only count keyup events after n milliseconds

var handleSearch = function handleSearch(searchBox, config, searchHistory) {
  return function (_ref) {
    var target = _ref.target,
      keyCode = _ref.keyCode;
    var input = $(target);
    var searchTerm = input.val();
    var pattern = /^[\w,.:=\+\-\/\*#\s]+$/;
    var isValidSearchTerm = pattern.test(searchTerm);
    if (keyCode === _keyCodes.default.ENTER && !isValidSearchTerm) {
      searchBox.show();
      return;
    }
    if (keyCode === _keyCodes.default.ESCAPE) {
      input.attr('value', '');
      searchBox.hide();
      return true;
    }
    if (keyCode === _keyCodes.default.TAB) {
      return true;
    }
    if (!searchTerm) {
      // show search history window as the search input has been cleared
      if (searchHistory) {
        searchHistory.render();
      }
      searchBox.hide();
      // return after creating a new SearchResultBox so it will be cleared from the screen
      return;
    }
    if (searchTerm.length > 0) {
      // Handle multi ric submit using ; or , or \n as seperator
      if (config.multipleSymbolInputCallback) {
        var rics = searchTerm.trim().split(/\s*[,;\n\t\f\r\v]\s*/);
        rics = rics.filter(function (v) {
          return v != '';
        }); // remove array positions with only empty strings
        if (rics.length > 1 && isValidSearchTerm) {
          searchBox.hide();
          if (keyCode === _keyCodes.default.ENTER) {
            config.multipleSymbolInputCallback(rics);
          }
          return;
        }
      }
    }
    var now = Date.now();
    searchBox.setSearchTerm(searchTerm, keyCode === _keyCodes.default.ENTER).then(function (results) {
      if (keyCode !== _keyCodes.default.ENTER && results[0] && results[0]['searchTerm'][0] === searchBox.searchTerm) {
        searchBox.show();
      }
      if (searchTerm.length > 0) {
        _hooks.default.onSearchResult(searchTerm, results);
        var timeTrackingObj = {
          searchTerm: searchTerm
        };
        timeTrackingObj.millis = Date.now() - now;
        searchBox.timeTracking.push(timeTrackingObj);
        $('body').unbind('click', searchHistory.closeHistoryWindowHandler);
        $("#".concat(config.searchHistoryContainerId)).hide();
      }
    });
  };
};
var initSearch = function initSearch(node, config, trigger) {
  config = config || {
    searchBoxId: 'incrementalsearch_results',
    columns: $(node).data('incrementalsearch-columns') || {},
    countInstTypeOnly: false,
    searchHistoryContainerId: 'incrementalsearch_history',
    enableDFAInSearchHistory: true
  };
  config.searchInput = $(node);
  var searchHistoryContainer;
  if (!config.isMobile) {
    searchHistoryContainer = new _SearchHistory.default(config, node);
    $(node).on('focus', function () {
      searchHistoryContainer.render();
    });
  }
  var searchBox = new _SearchResultBox.default(config);
  var handleFunction = (0, _runFunctionDebounced.default)(debounceMilliseconds, handleSearch(searchBox, config, searchHistoryContainer));
  $(node).on('keyup', handleFunction);
  $(node).siblings('button.search').click(function () {
    if ($("#".concat(config.searchBoxId, ":visible")).length > 0) {
      handleFunction({
        target: node,
        keyCode: _keyCodes.default.ENTER
      });
    } else {
      handleFunction({
        target: node
      });
    }
  });
  if (trigger) {
    handleFunction({
      target: node
    });
  }
};
var _default = exports.default = initSearch;

},{"fcom/hooks":14,"fcom/search/SearchHistory":17,"fcom/search/SearchResultBox":18,"fcom/util/enums/keyCodes":24,"fcom/util/functions/runFunctionDebounced":25}],22:[function(require,module,exports){
"use strict";

var _ajaxRequest = require("core/Ajax/ajaxRequest");
var _incrementalSearch = _interopRequireDefault(require("search/incrementalSearch"));
var _searchTypesEnum = _interopRequireDefault(require("search/searchTypesEnum"));
var _Accessibility = _interopRequireDefault(require("accessibility/Accessibility"));
var _axios = _interopRequireDefault(require("../../app/utils/axios"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var YAHOO = window.YAHOO;
var Dom = YAHOO.util.Dom;

/*
 * Name search class with all kind of helper functions for the
 * popup search as well as for the general search in the ngp navigation
 */
YAHOO.fcom.PopupSearch = {
  /*
   * the callback function that was passed last call
   */
  callback: null,
  /*
   * the searchParameter that was passed last call
   */
  searchParameter: null,
  /*
   *
   */
  popupSearchPanel: null,
  /*
   * the input field on the popup panel itself. The user can reenter
   * other search terms here, if the results with the initial
   * search term are not satisfying.
   */
  popupSearchInput: null,
  /*
   * helper variable for when a search is submitted on blur and no user interaction
   * should be forced. Only direct hit will result in a callback then.
   */
  returnOnlyDirectHit: false,
  /*
   * The expander to show or hide popup search counts. Will be set by the popup search markup
   */
  popupSearchCountsExpander: null,
  /*
   * handle the input a user has given to a search popup input field.
   * A search is sent to the server and depending whether the search generated
   * a unambiguous hit, either the search hit is returned to the given callback,
   * or a search popup is opened and the user can select an item, which will then
   * trigger the given callback function.
   * @param {Object} searchParameter the parameterization of the search. The given object
   *        is a bean with several attributes expected:
   *        "searchTerm" : the term the user entered to search for
   *        "searchSpace" : the search space to look in (see YAHOO.fcom.SearchSpace)
   *        "searchSettings" : an object with attributes matching the server side
   *                           com.financial.ngp.web.search.SearchSettingsBean classes.
   *                           e.g. when using the YAHOO.fcom.SearchSpace.INSTRUMENT search space,
   *                           then a boolean "ricLevelNeeded" and an array of YAHOO.fcom.InstrumentType strings
   *                           is expected.
   *        "obj" : an optional scope object which can be given to the search and which will be given back to
   *                the callback function. With this references can be kept. Objects with several attributes or
   *                arrays can be used to keep several references.
   *
   * @param {function} callback a function that will be called when a unambiguous search hit is either found
   *        directly or the user has selected an item from the search popup. The callback gets a single argument,
   *        which is an object with attributes describing the result:
   *        "searchTerm": what the user was actually looking for (for message displaying purpose)
   *        "obj"       : the scope object given in the searchParameter object.
   *        "canceled": boolean whether the user canceled the operation or selected
   *                     an item. If true, all further attributes will be undefined.
   *
   *        "itemId": the unique id of the item selected by the user
   *        "typeOfId": the type of id, e.g. for instruments this could be "ric" or "isin"
   *        "displayName": the display name of the returned item
   *
   */
  handlePopupSearchInput: function handlePopupSearchInput(searchParameter, callback) {
    // save the callback state
    YAHOO.fcom.PopupSearch.callback = callback;
    YAHOO.fcom.PopupSearch.searchParameter = searchParameter;
    // now call controller method via ajax:

    var postData = searchParameter.searchSettings || {};
    postData.searchTerm = searchParameter.searchTerm;
    postData.searchSpace = searchParameter.searchSpace;
    var showWaitMask = !YAHOO.fcom.PopupSearch.returnOnlyDirectHit;
    var getEmptyFormReq = function getEmptyFormReq() {
      return window.ngpAsyncRequest('POST', '/generalSearch.action?method=getEmptyForm', null, postData, null, showWaitMask);
    };
    var ajaxPromise;
    if (searchParameter.searchTerm.trim().length <= 0) {
      ajaxPromise = getEmptyFormReq();
    } else if (searchParameter.obj && searchParameter.obj.config && searchParameter.obj.config.enableIncrementalSearch === true) {
      var queryString = {};
      queryString.type = 'INSTRUMENTS';
      queryString.term = searchParameter.searchTerm;
      queryString.offset = 0;
      queryString.limit = 1;
      queryString.filter = '*';
      queryString.countInstTypeOnly = false;
      ajaxPromise = (0, _ajaxRequest.ajaxGetJson)('/incrementalSearch.action', queryString).then(function (responseJson) {
        if (responseJson.result && responseJson.result.length) {
          var resultObj = responseJson.result[0];
          YAHOO.fcom.PopupSearch.invokeCallback({
            displayName: resultObj.description,
            itemId: resultObj.id,
            typeOfId: 'ric',
            obj: searchParameter.obj
          });
          return null;
        } else {
          return getEmptyFormReq();
        }
      });
    } else {
      ajaxPromise = (0, _ajaxRequest.ajaxPostJson)('/generalSearch.action?method=handlePopupSearch', postData).then(function (responseJson) {
        if (responseJson.typeOfId) {
          YAHOO.fcom.PopupSearch.invokeCallback({
            displayName: responseJson.displayName,
            itemId: responseJson.itemId,
            typeOfId: responseJson.typeOfId,
            obj: searchParameter.obj
          });
          return null;
        } else {
          return getEmptyFormReq();
        }
      });
    }
    ajaxPromise.then(function (responseHtml) {
      if (responseHtml) {
        YAHOO.fcom.PopupSearch.handleInitialAjaxCallback(responseHtml);
        if (searchParameter.callback) {
          searchParameter.callback(responseHtml);
        }
        var config = {
          searchBoxId: 'popupsearch_results',
          searchHistoryContainerId: 'popupsearch_history',
          searchType: _searchTypesEnum.default[searchParameter.searchSettings.searchSpace || 'INSTRUMENTS'],
          searchRic: searchParameter.searchSettings.ricLevelNeeded !== false,
          instrumentTypes: searchParameter.searchSettings.instrumentTypes || ['*'],
          countInstTypeOnly: searchParameter.searchSettings.countInstTypeOnly !== false,
          columns: searchParameter.searchSettings.columns || {},
          l3Columns: searchParameter.searchSettings.thirdLevelColumns || [],
          static: true,
          ignoreUncertainRics: true
        };
        if (config.searchType !== _searchTypesEnum.default.INSTRUMENTS) {
          config.searchRic = false;
        }
        if (config.searchRic) {
          config.searchRicCallback = function (item) {
            saveSearchHistory(item);
            YAHOO.fcom.PopupSearch.invokeCallback({
              displayName: item.name,
              itemId: item.ric,
              typeOfId: 'ric',
              obj: searchParameter.obj
            });
          };
        } else {
          config.itemCallback = function (type, item) {
            if (type === 'bnd_issuer') {
              var typeOfId = 'bnd_issuer_code';
              YAHOO.fcom.PopupSearch.invokeCallback({
                displayName: item.bnd_issuer,
                itemId: item[typeOfId],
                typeOfId: typeOfId,
                obj: searchParameter.obj
              });
            } else {
              saveSearchHistory(item);
              var _typeOfId = item.isin ? 'isin' : 'id';
              YAHOO.fcom.PopupSearch.invokeCallback({
                displayName: item.description,
                itemId: item[_typeOfId],
                typeOfId: _typeOfId,
                obj: searchParameter.obj
              });
            }
          };
        }
        // #. Get the search input
        var $input = $('#popupSearchPanelInput');
        (0, _incrementalSearch.default)($input.get(0), config, searchParameter.searchTerm.length);

        // #. Set focus to search input
        $input.focus();

        // #. Set tabindex of search icon to -1
        // #. Tab must focus to result panel
        $input.next('button.search').attr('tabindex', -1);
      }
    });
  },
  /*
   * @return {boolean} whether the popup search panel is currently opened or not
   */
  isPanelOpen: function isPanelOpen() {
    return this.popupSearchPanel != null && this.popupSearchPanel.cfg.getProperty('visible');
  },
  /*
   * take the given return object and call the callback function that was passed to
   * the popup search. In addition some handlers will be deregistered.
   */
  invokeCallback: function invokeCallback(returnObject) {
    YAHOO.fcom.PopupSearch.unsubscribeHideHandler();
    if (YAHOO.fcom.PopupSearch.popupSearchPanel != null) {
      YAHOO.fcom.PopupSearch.popupSearchPanel.hide();
    }
    YAHOO.fcom.PopupSearch.callback(returnObject);
    return;
  },
  /*
   * subscribe an hide handler that is called when the user cancels or closes the popup
   * to inform the calling page about this event
   */
  subscribeHideHandler: function subscribeHideHandler() {
    if (YAHOO.fcom.PopupSearch.hideHandler == null) {
      YAHOO.fcom.PopupSearch.hideHandler = function (type, args, popupSearch) {
        var returnObj = {};
        if (!YAHOO.lang.isUndefined(popupSearch.searchParameter.obj)) {
          returnObj.obj = popupSearch.searchParameter.obj;
        }
        returnObj.searchTerm = popupSearch.searchParameter.searchTerm;
        returnObj.canceled = true;
        popupSearch.callback(returnObj);
      };
    }
    YAHOO.fcom.PopupSearch.popupSearchPanel.subscribe('hide', YAHOO.fcom.PopupSearch.hideHandler, YAHOO.fcom.PopupSearch, false);
  },
  /*
   * intern function that unsubscribes the hide handler that is only used to inform the
   * popup search caller when the user closes the popupsearch without a result. Of course this
   * listener should not be notified when a result is returned and then the popup is closed.
   */
  unsubscribeHideHandler: function unsubscribeHideHandler() {
    if (YAHOO.fcom.PopupSearch.hideHandler != null) {
      YAHOO.fcom.PopupSearch.popupSearchPanel.unsubscribe('hide', YAHOO.fcom.PopupSearch.hideHandler, YAHOO.fcom.PopupSearch);
    }
  },
  /*
   * method called when an inital call (no panel opened yet) to the popup search is answered
   * from the server.
   * @param responseObject the response object as it comes from the async request functions
   */
  handleInitialAjaxCallback: function handleInitialAjaxCallback(responseHtml) {
    if (YAHOO.fcom.PopupSearch.returnOnlyDirectHit === false) {
      // only if the direct hit marker was not set
      // ------
      // changes for early version of NGPII-14050 / TD Wealth: Inline Editing Concept/Implementation
      // ------
      if (YAHOO.fcom.PopupSearch.popupSearchPanel == null) {
        var panelConfig = window.YAHOO.fcom.PopupSearch.searchParameter.obj.config || {};
        var cfg = {
          modal: true,
          width: '728px',
          visible: false,
          close: panelConfig.close === false ? false : true,
          dragOnly: panelConfig.dragOnly === false ? false : true,
          draggable: panelConfig.draggable === false ? false : true,
          constraintoviewport: panelConfig.constraintoviewport === false ? false : true,
          fixedcenter: false,
          context: panelConfig.context || null,
          x: 20,
          y: 50
        };
        // TODO root the parent panel id from the tag through to here
        var panel = YAHOO.fcom.PopupSearch.popupSearchPanel = window.openPanelFromMarkup('popupSearchPanel', cfg, false);
        if (cfg.context) {
          YAHOO.util.Event.on(document, 'click', function (evt) {
            var el = YAHOO.util.Event.getTarget(evt);
            var dialogEl = panel.element;
            if (el !== dialogEl && !Dom.isAncestor(dialogEl, el)) {
              panel.hide();
            }
          });
          var placePanel = function placePanel() {
            var contextPosition = $("#".concat(cfg.context[0])).position();
            // TODO get the final search panel height upfront from config ? css ?
            var panelHeight = 700; // 700 // hardcoded v.01
            var dyTop = panelHeight;
            panel.align('tl', 'bl');
            if (contextPosition && contextPosition.top > dyTop) {
              var dyBottom = $(window).height() - contextPosition.top;
              if (dyBottom < dyTop) {
                panel.moveTo(null, contextPosition.top - dyTop);
              }
            }
          };
          var onResize = function onResize() {
            placePanel();
          };
          YAHOO.fcom.Page.onResize(onResize, this, true);
          placePanel();
        }
      }
      // ------
      // /changes for early version of NGPII-14050 / TD Wealth: Inline Editing Concept/Implementation
      // ------
      YAHOO.fcom.PopupSearch.popupSearchPanel.setBody(document.createElement('div')); // set some dummy content to be sure that the body is replaced
      YAHOO.fcom.PopupSearch.popupSearchPanel.render(document.body); // render call is needed after changing body content
      window.replacePanelContentByString(YAHOO.fcom.PopupSearch.popupSearchPanel, responseHtml, false);
      YAHOO.fcom.PopupSearch.subscribeHideHandler();
      YAHOO.fcom.PopupSearch.popupSearchPanel.show();
      YAHOO.fcom.PopupSearch.popupSearchInput = Dom.get('popupSearchPanelInput');
      YAHOO.fcom.PopupSearch.popupSearchInput.focus();
      YAHOO.fcom.PopupSearch.popupSearchInput.select();
      YAHOO.fcom.PopupSearch.ie10zIndexFix();
    } else {
      YAHOO.fcom.PopupSearch.returnOnlyDirectHit = false; // set it back
    }
  },

  /*
   * cancel the popup panel without selecting an item.
   */
  cancel: function cancel() {
    // TODO: the callback should also be called with the cancel message. Best by subscribing the
    // panels onHide function, so that also the close button of the panel does this.
    this.popupSearchPanel.hide();
  },
  /*
   * ugly fix for ie10 z-index bug. Just bring to top the panel with some delay, that ie10 looses the style after filling the ajax content to
   */
  ie10zIndexFix: function ie10zIndexFix() {
    document.body.appendChild(YAHOO.fcom.PopupSearch.popupSearchPanel.element); // reinsert panel into the page body, so that ie10 is forced to redraw the part.
  }
};

/*
 * constructor for a new search popup input. A search popup input is
 * an input field where the user can enter any search term and in addition there
 * will be a hidden field where unique ids are stored, when an item is selected
 * by the user or when the search is already unambiguous.
 * @param textField {Object|String|DropMenu} the node object of the input field for user input, or it's id as string
 *        or, a variable reference to a YAHOO.fcom.DropMenu in combo mode. If this is the case,
 *        the valueField should be given null.
 * @param valueField {Object|String} the node object of the hidden input field for storing the unique id of a result.
 *        this hidden field must have the name that is expected by the server when submitting the form. Either pass the
 *        node object or the unique id on the page as string.
 * @param conf {Object} a config bean for to adjust the popup search for the specific needs in that form
 *        known attributes of the conf object are
 *        "searchSpace" {String} (mandatory) which limits the popup search to a given
 *                      searchSpace. The string values are the ones of the YAHOO.fcom.SearchSpace attributes
 *        "searchSettings" {Object} (optional) bean with attributes specifying further limitations to the search.
 *                      The attributes must match the attributes of the server side
 *                      com.financial.ngp.web.search.SearchSettingsBean classes.
 *                        e.g. when using the YAHOO.fcom.SearchSpace.INSTRUMENT search space,
 *                      then a boolean "ricLevelNeeded" and an array of YAHOO.fcom.InstrumentType strings
 *                      is expected.
 *        "actionOnBlur" {String} field that can be used to tell the popup search input what to do when the
 *                       user blurs the input field. TODO: update the docu
 *        "obj"  an optional scope object which can be given to the search and which will be given back to
 *               the callback function. Objects with several attributes or
 *               arrays can be used to keep several references.
 *        "focus" {boolean} optional boolean flag whether the input field should have the focus initially
 *        "callOnCancel" {boolean} a boolean flag that defaults to false. It makes only sense when also a
 *               callback function is provided and then if the flag is true, the callback function is
 *               also called, when the user canceled the search operation and has no valid item found.
 *        "callback" an optional function that will be called when an unambiguous search hit is either found
 *        directly or the user has selected an item from the search popup. The callback gets a single argument,
 *        which is an object with attributes describing the result:
 *        "searchTerm" : what the user was actually looking for (for message displaying purpose)
 *        "obj"        : the scope object given in the searchParameter object.
 *        "canceled" : boolean whether the user canceled the operation or selected
 *                     an item. If true, all further attributes will be undefined.
 *
 *        "itemId" : the unique id of the item selected by the user
 *        "idType" : the type of id, e.g. for instruments this could be "ric" or "isin"
 *        "displayName" : the display name of the returned item
 */
YAHOO.fcom.PopupSearchInput = function (textField, valueField, config) {
  var _this2 = this;
  var _this = this;
  this.config = config;
  this.textChanged = false; // remember if the user really changed the content, to avoid searching with display names

  if (textField && textField.type && textField.type === 'droplist') {
    // select given, no input fields
    this.textField = textField.inputField;
    this.valueField = null;
    this.dropMenu = textField;
    this.dropMenu.setPopupSearchHandler(this);
    this.lastTextFieldContent = this.textField.value;
    this.dropMenu.selectionChangeEvent.subscribe(function () {
      var value = this.dropMenu.getSelectedValue();
      var text = this.dropMenu.getSelectedText();
      this.setTextChanged(false);
      var isValid = value !== '*' && value.length;
      this.setHasFound(isValid);
      if (this.config.actionOnBlur === 'RESTORE_LAST_SEARCH_HIT') {
        this.lastSearchResult = isValid ? {
          text: text,
          value: value
        } : null;
      }
      this.lastTextFieldContent = isValid ? text : '';
    }, this, true);
    YAHOO.util.Event.addListener(this.textField, 'blur', function () {
      if (this.textChanged && !YAHOO.fcom.PopupSearch.isPanelOpen()) {
        // only when user wrote something and panel is not open already
        this.setHasFound(false);
        // search is only submitted when the flag is set

        if (this.config.actionOnBlur === 'NONE') {
          //this.valueField.value = '';
          if (this.config.callOnCancel) {
            if (YAHOO.lang.isFunction(this.config.callback)) {
              this.config.callback({
                canceled: true,
                searchTerm: '-'
              });
            }
          }
        } else if (this.config.actionOnBlur === 'RESTORE_LAST_SEARCH_HIT') {
          if (!this.textField.value) {
            this.lastSearchResult = null;
          }
          this.blurTimeout = window.setTimeout(function () {
            _this.blurTimeout = null;
            if (_this.lastSearchResult) {
              _this.lastTextFieldContent = _this.lastSearchResult.text;
              _this.dropMenu.setComboValueAndText(_this.lastSearchResult.value, _this.lastSearchResult.text);
              _this.setHasFound(true);
              _this.setTextChanged(false);
            } else {
              _this.dropMenu.selectItemByIndex(0, true);
              _this.lastTextFieldContent = _this.dropMenu.getItemData()[0].text;

              //_this.dropMenu.setComboValueAndText('', '');
              _this.setHasFound(false);
              _this.setTextChanged(false);
              if (_this.config.callOnCancel) {
                if (YAHOO.lang.isFunction(_this.config.callback)) {
                  _this.config.callback({
                    canceled: true,
                    searchTerm: '-'
                  });
                }
                _this.dropMenu._callChangeEvents({
                  'onChange': true
                });
              }
            }
          }, 1000);
        }
      }
    }, this, true);
  } else if (textField instanceof window.fcom.Select) {
    this.textField = textField;
    this.valueField = textField;
    this._isSelect = true;
    this.getSelectedValue = function () {
      return _this2.textField.value;
    };
    this.textField.$element.on('select2:select', function () {
      var value = _this.textField.getSelectedValue();
      var isCustomValue = _this.textField.isCustomValue(value);
      if (isCustomValue) {
        _this.handleUserInput(null, true);
      }
    });
    this.textField.$element.on('change', function () {
      var value = _this.textField.getSelectedValue();
      var text = _this.textField.getSelectedText();
      var isValid = value && value !== '*';
      _this.lastSearchResult = isValid ? {
        text: text,
        value: value
      } : null;
      _this.setHasFound(isValid);
      if (_this.textChanged && !YAHOO.fcom.PopupSearch.isPanelOpen()) {
        // only when user wrote something and panel is not open already
        _this.setHasFound(false);
        // search is only submitted when the flag is set
        if (_this.config.actionOnBlur === 'NONE') {
          if (_this.config.callOnCancel) {
            if (YAHOO.lang.isFunction(_this.config.callback)) {
              _this.config.callback({
                canceled: true,
                searchTerm: '-'
              });
            }
          }
        } else if (_this.config.actionOnBlur === 'RESTORE_LAST_SEARCH_HIT') {
          if (!_this.textField.value) {
            _this.lastSearchResult = null;
          }
          _this.blurTimeout = window.setTimeout(function () {
            _this.blurTimeout = null;
            if (_this.lastSearchResult) {
              _this.textField.setComboValueAndText(_this.lastSearchResult.value, _this.lastSearchResult.text);
              _this.setHasFound(true);
              _this.setTextChanged(false);
            } else {
              _this.textField.selectByValue(''); //_this.dropMenu.selectItemByIndex(0, true);
              _this.setHasFound(false);
              _this.setTextChanged(false);
              if (_this.config.callOnCancel) {
                if (YAHOO.lang.isFunction(_this.config.callback)) {
                  _this.config.callback({
                    canceled: true,
                    searchTerm: '-'
                  });
                }
                _this.textField.$element.trigger('change');
              }
            }
          }, 1000);
        }
      } else if (!_this.textField.isCustomValue(value)) {
        _this2.itemFoundEvent.fire();
      }
    });
  } else if (config.multipleSelection) {
    if (config.callOnCancel) {
      throw new Error('PopupSearchInput multipleSelection does not allow callOnCancel = true');
    }
    this.textField = YAHOO.fcom.Forms.getNodeFromParameter(textField);
    this.tagContainer = $(this.textField).parents('.popupsearch-tags').get(0);
    this.lastTextFieldContent = this.textField.value;
    this.valueField = YAHOO.fcom.Forms.getNodeFromParameter(valueField);
    // #. Add tags based on the values
    this.addTagsOnInit(this.valueField.value);
    // #. Manage the button state
    this.mangeDeleteButtonState();
    YAHOO.util.Event.addListener(this.textField, 'keypress', function (eventVar) {
      this.keyPressed(eventVar);
    }, this, true);
    YAHOO.util.Event.addListener(this.textField, 'keydown', function (eventVar) {
      this.keyDown(eventVar);
    }, this, true);

    // #. init the popup search accessibility
    _Accessibility.default.init({
      popupSearch: {
        container: this.tagContainer,
        textField: this.textField,
        multiSelect: true
      }
    });
    if (config.focus && this.textField) {
      try {
        this.textField.focus();
      } catch (e) {
        // nothing to do, user must focus himself. Some browsers complain when trying to set the focus
      }
    }
    if (config.select) {
      try {
        this.textField.select();
      } catch (e) {
        // nothing to do, user must focus himself. Some browsers complain when trying to set the focus
      }
    }
  } else {
    this.textField = YAHOO.fcom.Forms.getNodeFromParameter(textField);
    this.lastTextFieldContent = this.textField.value;
    this.valueField = YAHOO.fcom.Forms.getNodeFromParameter(valueField);
    YAHOO.util.Event.addListener(this.textField, 'blur', function () {
      if (this.textChanged && !YAHOO.fcom.PopupSearch.isPanelOpen()) {
        // only when user wrote something and panel is not open already
        this.setHasFound(false);
        // search is only submitted when the flag is set

        if (this.config.actionOnBlur === 'NONE') {
          this.valueField.value = '';
          if (this.config.callOnCancel) {
            if (YAHOO.lang.isFunction(this.config.callback)) {
              this.config.callback({
                canceled: true,
                searchTerm: "".concat(_this.valueField.value, "-")
              });
            }
          }
        } else if (this.config.actionOnBlur === 'RESTORE_LAST_SEARCH_HIT') {
          if (this.textField.value === '') {
            this.lastSearchResult = null;
          }
          this.blurTimeout = window.setTimeout(function () {
            _this.blurTimeout = null;
            if (_this.lastSearchResult) {
              _this.lastTextFieldContent = _this.textField.value = _this.lastSearchResult.text;
              _this.valueField.value = _this.lastSearchResult.value;
              _this.setHasFound(true);
            } else {
              _this.lastTextFieldContent = '';
              _this.setHasFound(false);
              if (_this.config.callOnCancel) {
                if (YAHOO.lang.isFunction(_this.config.callback)) {
                  _this.config.callback({
                    canceled: true,
                    searchTerm: "".concat(_this.valueField.value, "-")
                  });
                }
              }
            }
          }, 1000);
        }
      }
    }, this, true);
    YAHOO.util.Event.addListener(this.textField, 'keypress', function (eventVar) {
      this.keyPressed(eventVar);
    }, this, true);
    YAHOO.util.Event.addListener(this.textField, 'keydown', function (eventVar) {
      this.keyDown(eventVar);
    }, this, true);
    if (config.focus && this.textField) {
      try {
        this.textField.focus();
      } catch (e) {
        // nothing to do, user must focus himself. Some browsers complain when trying to set the focus
      }
    }
    if (config.select) {
      try {
        this.textField.select();
      } catch (e) {
        // nothing to do, user must focus himself. Some browsers complain when trying to set the focus
      }
    }
  }
  var dropdownButton = this.findDropdownButton();
  if (dropdownButton != null) {
    YAHOO.util.Event.addListener(dropdownButton, 'click', function () {
      if (this.blurTimeout) {
        window.clearTimeout(this.blurTimeout);
        this.blurTimeout = null;
      }
    }, this, true);
  }
  var searchImageButton = this.findSearchButtonImage();
  if (searchImageButton != null) {
    YAHOO.util.Event.addListener(searchImageButton, 'click', function (eventVar) {
      if (this.blurTimeout) {
        window.clearTimeout(this.blurTimeout);
        this.blurTimeout = null;
      }
      if (this.getHasFound()) {
        return;
      }
      this.handleUserInput(eventVar);
    }, this, true);
  }
  var searchImageButtonDeletable = this.findSearchButtonImageDeletable();
  if (searchImageButtonDeletable != null) {
    YAHOO.util.Event.addListener(searchImageButtonDeletable, 'click', this.resetImageClickFunction, this, true);
  }

  /*
   * Event fired if an item was found for the current search.
   * @event
   * @param {String} event
   * @param {Array} args The first member containing the search result with following properties:
   * <ul>
   *  <li>{String} itemId the unique id of the item selected by the user
   *  <li>{String} typeOfId the type of id, e.g. for instruments this could be ric or isin
   *  <li>{String} displayName the display name of the item
   * </ul>
   */
  this.itemFoundEvent = new YAHOO.util.CustomEvent('itemFound');

  /*
   * Event fired when the selected item was removed, for example by clicking on the delete instrument button.
   */
  this.itemRemovedEvent = new YAHOO.util.CustomEvent('itemRemoved');
  if (this.config.onChange) {
    this.itemFoundEvent.subscribe(this.config.onChange);
    this.itemRemovedEvent.subscribe(this.config.onChange);
  }
};

/**
 * Hide/show delete search button based on the values
 */
YAHOO.fcom.PopupSearchInput.prototype.mangeDeleteButtonState = function () {
  var $deleteButton = this.findSearchButtonImageDeletable();
  if (!this.valueField.value) {
    $($deleteButton).hide();
    $($deleteButton).prev().show();
  } else {
    $($deleteButton).show();
    $($deleteButton).prev().hide();
  }
};

/**
 * Add tags when the init the component
 * @param values
 */
YAHOO.fcom.PopupSearchInput.prototype.addTagsOnInit = function (values) {
  var _this3 = this;
  // #. Get selected instruments from the value field
  var instruments = values ? values.split(',') : [];
  // #. Get instrument info from db and add the tag
  instruments.forEach(function (instrument) {
    _this3.findAndAddTag(instrument);
  });
};
YAHOO.fcom.PopupSearchInput.prototype.findAndAddTag = function (value) {
  var _this4 = this;
  this.searchValue(value, function (result) {
    if (result.found) {
      _this4.appendTags(result.data.displayName, result.data.itemId);
    }
  });
};
YAHOO.fcom.PopupSearchInput.prototype.resetImageClickFunction = function () {
  var _this5 = this;
  if (this.config.multipleSelection) {
    this.reset();
    this.itemRemovedEvent.fire();
  } else if (this._isSelect) {
    this.textField.selectByValue('');
    this.textChanged = true;
    this.lastSearchResult = null;
    this.itemRemovedEvent.fire();
    this.textField.$element.trigger('change');
  } else {
    this.textField.value = '';
    this.valueField.value = '';
    this.textChanged = true;
    this.lastSearchResult = null;
    this.itemRemovedEvent.fire();
    this.textField.focus();
    window.setTimeout(function () {
      _this5.textField.blur();
    }, 50);
  }
};
YAHOO.fcom.PopupSearchInput.prototype.getHasFound = function () {
  return this.textField.style ? this.textField.style.textDecoration === 'underline' : !!this.textField._hasFound;
};
YAHOO.fcom.PopupSearchInput.prototype.setHasFound = function (found) {
  var img = this.findSearchButtonImage();
  var imgDeletable = this.findSearchButtonImageDeletable();
  if (found) {
    if (this.textField.style) {
      this.textField.style.textDecoration = 'underline';
      this.textField.setAttribute('title', this.textField.value);
    } else {
      this.textField._hasFound = true;
    }
    if (img) {
      img.style.display = 'none';
      imgDeletable.style.display = 'inline';
    }
  } else {
    if (this.textField.style) {
      this.textField.setAttribute('title', '');
      this.textField.style.textDecoration = 'none';
    } else {
      this.textField._hasFound = false;
    }
    if (img) {
      img.style.display = 'inline';
      imgDeletable.style.display = 'none';
    }
  }
};

/*
 * set this search popup input disabled, e.g. when a precondition has to be fulfilled,
 * before the user is allowed to start a popup search.
 * @param disbaled {boolean} whether the search popup input should be disabled (true) or enabled (false)
 */
YAHOO.fcom.PopupSearchInput.prototype.setDisabled = function (disabled) {
  window.setElementDisabled(this.textField, disabled);
  var searchImageButton = this.findSearchButtonImage();
  if (searchImageButton != null) {
    $(searchImageButton).attr('disabled', disabled);
  }
  var searchImageButtonDeletable = this.findSearchButtonImageDeletable();
  if (searchImageButtonDeletable != null) {
    $(searchImageButtonDeletable).attr('disabled', disabled);
  }
};
YAHOO.fcom.PopupSearchInput.prototype.setError = function () {
  Dom.addClass(this.textField, 'error');
};
YAHOO.fcom.PopupSearchInput.prototype.removeError = function () {
  Dom.removeClass(this.textField, 'error');
};

/*
 * get the search button reference.
 * @return the image reference to the search button or null if none found.
 */
YAHOO.fcom.PopupSearchInput.prototype.findSearchButtonImage = function () {
  if (this.config.multipleSelection) {
    return $(this.textField).parents('.popupsearch-tags').parent().find('.icon').get(0);
  } else if (this.textField.$element) {
    return this.textField.$element.parent().find('.icon').get(0);
  } else if (this.dropMenu != null) {
    return Dom.getNextSiblingBy(this.textField.parentNode, function (node) {
      return Dom.hasClass(node, 'icon');
    });
  } else {
    return Dom.getNextSiblingBy(this.textField, function (node) {
      return Dom.hasClass(node, 'icon');
    });
  }
};
YAHOO.fcom.PopupSearchInput.prototype.findDropdownButton = function () {
  if (this.dropMenu != null) {
    return Dom.getNextSiblingBy(this.textField, function (node) {
      return Dom.hasClass(node, 'icon');
    });
  }
  return null;
};

/*
 * get the search deletable button reference.
 * @return the image reference to the search button or null if none found.
 */
YAHOO.fcom.PopupSearchInput.prototype.findSearchButtonImageDeletable = function () {
  if (this.config.multipleSelection) {
    return $(this.textField).parents('.popupsearch-tags').parent().find('.searchdeletable').get(0);
  } else if (this.textField.$element) {
    return this.textField.$element.parent().find('.searchdeletable').get(0);
  } else if (this.dropMenu != null) {
    return Dom.getNextSiblingBy(this.textField.parentNode, function (node) {
      return Dom.hasClass(node, 'searchdeletable');
    });
  } else {
    return Dom.getNextSiblingBy(this.textField, function (node) {
      return Dom.hasClass(node, 'searchdeletable');
    });
  }
};

/*
 * this is the function that will start to handle new user input. It will call a
 * text search with the given input and depending on whether there is a direct
 * unique hit or not, the display name of the hit will be shown in the text field
 * or a search popup will be opened, where the user can select an item.
 */
YAHOO.fcom.PopupSearchInput.prototype.handleUserInput = function (eventVar, force) {
  if (this.getHasFound() && !force) {
    return;
  }
  var searchTerm = this.textField.value = YAHOO.lang.trim(this.textField.value);
  if (this.dropMenu == null && this.textField.disabled) {
    return;
  }
  if (this.dropMenu != null && !this.dropMenu.hasUncommitedTextChange()) {
    // user did not enter anything
    searchTerm = '';
  }
  YAHOO.fcom.PopupSearch.handlePopupSearchInput({
    searchTerm: searchTerm,
    searchSpace: this.config.searchSpace,
    searchSettings: this.config.searchSettings,
    obj: this
  }, function (callbackObject) {
    callbackObject.obj.handlePopupSearchCallback(callbackObject);
  });
};
YAHOO.fcom.PopupSearchInput.prototype.searchValue = function (term, callback) {
  var postData = Object.assign({}, this.config.searchSettings || {});
  postData.searchTerm = term;
  postData.searchSpace = this.config.searchSpace;
  postData.method = 'handlePopupSearch';
  window.ngpAsyncRequest('POST', '/generalSearch.action', null, postData, null, true).then(function (response) {
    var data = JSON.parse(response);
    callback({
      found: !!data.itemId,
      data: data
    });
  }).catch(function () {
    callback({
      found: false
    });
  });
};

/*
 * this function takes the callback object from the YAHOO.fcom.PopupSearch
 * and fills the selected item to the input and calls outer callback function
 * when available.
 * @param callbackObject the callback obejct from the YAHOO.fcom.PopupSearch.handlePopupSearchInput(...) call
 */
YAHOO.fcom.PopupSearchInput.prototype.handlePopupSearchCallback = function (callbackObject) {
  if (this.config.multipleSelection) {
    this.handlePopupSearchCallbackForMultiSelection(callbackObject);
  } else if (callbackObject.canceled) {
    // user did not select anything but canceled the popup panel
    this.textField.focus();
    this.textField.select(); // select text field to show user that he should remove text, or alter it.
    if (this.lastSearchResult) {
      if (this._isSelect) {
        this.lastTextFieldContent = this.lastSearchResult.text;
        this.textField.setComboValueAndText(this.lastSearchResult.value, this.lastSearchResult.text);
        this.textField.$element.trigger('change');
      } else if (this.dropMenu) {
        this.lastTextFieldContent = this.lastSearchResult.text;
        this.dropMenu.setComboValueAndText(this.lastSearchResult.value, this.lastSearchResult.text);
        this.dropMenu._callChangeEvents({
          'onChange': true
        });
      } else {
        this.textField.value = this.lastSearchResult.text;
        this.valueField.value = this.lastSearchResult.value;
      }
      this.setHasFound(true);
    } else if (this.config.callOnCancel) {
      if (YAHOO.lang.isFunction(this.config.callback)) {
        this.config.callback(callbackObject);
      }
      this.setHasFound(false);
    }
  } else {
    this.setTextChanged(false);
    if (this.config.actionOnBlur === 'RESTORE_LAST_SEARCH_HIT') {
      this.lastSearchResult = {
        text: callbackObject.displayName,
        value: callbackObject.itemId,
        typeOfId: callbackObject.typeOfId
      };
    }
    if (this._isSelect) {
      this.lastTextFieldContent = callbackObject.displayName;
      this.textField.setComboValueAndText(callbackObject.itemId, callbackObject.displayName);
      this.textField.$element.trigger('change');
    } else if (this.dropMenu) {
      this.lastTextFieldContent = callbackObject.displayName;
      this.dropMenu.setComboValueAndText(callbackObject.itemId, callbackObject.displayName);
      this.dropMenu._callChangeEvents({
        'onChange': true
      });
    } else {
      this.lastTextFieldContent = this.textField.value = callbackObject.displayName;
      this.valueField.value = callbackObject.itemId;
      if (YAHOO.lang.isFunction(this.config.callback)) {
        this.config.callback(callbackObject);
      }
    }
    this.setHasFound(true);
    this.itemFoundEvent.fire(callbackObject);
  }
};
YAHOO.fcom.PopupSearchInput.prototype.handlePopupSearchCallbackForMultiSelection = function (callbackObject) {
  if (callbackObject.canceled) {
    // user did not select anything but canceled the popup panel
    this.textField.value = '';
    this.textField.focus();
  } else {
    this.setTextChanged(false);

    // clear the input
    this.textField.value = '';

    // add the tag
    var values = this.valueField.value.split(',').filter(function (f) {
      return f;
    });
    if (values.indexOf(callbackObject.itemId) === -1) {
      this.addTextValue({
        text: callbackObject.displayName,
        value: callbackObject.itemId
      });
    }
    if (YAHOO.lang.isFunction(this.config.callback)) {
      this.config.callback(callbackObject);
    }
    this.setHasFound(true);
    this.itemFoundEvent.fire(callbackObject);
  }
};

/*
 * check whether the content was manually change by the user. Calling this
 * function delayed after user activity is the only way to realy say whether there
 * was a change in the input field, as some special keys, altering the input field
 * can not be checked by javascript key events.
 */
YAHOO.fcom.PopupSearchInput.prototype.checkForInputChange = function () {
  // remove leading spaces
  while (this.textField.value.length > 0 && this.textField.value.charCodeAt(0) < 33) {
    this.textField.value = this.textField.value.substring(1);
  }

  // only allow one trailing space,
  if (this.textField.value.length > 2 && this.textField.value.charCodeAt(this.textField.value.length - 1) < 33) {
    while (this.textField.value.charCodeAt(this.textField.value.length - 2) < 33) {
      this.textField.value = this.textField.value.substring(0, this.textField.value.length - 1);
    }
  }
  if (this.lastTextFieldContent !== this.textField.value) {
    // content manually changed
    this.setTextChanged(true);
  } else {
    //this.setTextChanged(false);
  }
};

/*
 * function called whenever the user is pressing a key on the input field (key down event)
 * @param eventconst the event that was returned with the keypress call
 * @return true
 */
YAHOO.fcom.PopupSearchInput.prototype.keyDown = function (eventVar) {
  var whichKey;
  if (!eventVar) {
    eventVar = window.event;
  }
  if (eventVar.which) {
    whichKey = eventVar.which;
  } else {
    whichKey = eventVar.keyCode;
  }
  if (whichKey !== 13) {
    // enter submits the search (it is handles by keypress handler)
    // special key like backspace, delete or having selected something an writing over can change the content without adding real characters
    YAHOO.lang.later(50, this, 'checkForInputChange');
  }
  return true;
};

/*
 * function called whenever the user is pressing a key on the input field  (key press event)
 * @param eventconst the event that was returned with the keypress call
 * @return true
 */
YAHOO.fcom.PopupSearchInput.prototype.keyPressed = function (eventVar) {
  var whichKey;
  if (!eventVar) {
    eventVar = window.event;
  }
  if (eventVar.which) {
    whichKey = eventVar.which;
  } else {
    whichKey = eventVar.keyCode;
  }
  if (whichKey === 13) {
    // enter submits the search
    this.handleUserInput(eventVar);
  } else {
    // something changed? not so easy to say, as the value is not yet written to the textfield.
    // special key like backspace, delete or having selected something an writing over can change the content without adding real characters
    YAHOO.lang.later(50, this, 'checkForInputChange');
  }
  return true;
};
YAHOO.fcom.PopupSearchInput.prototype.isTextChanged = function () {
  return this.textChanged;
};
YAHOO.fcom.PopupSearchInput.prototype.setTextChanged = function (textChanged) {
  if (textChanged) {
    this.setHasFound(false);
  }
  this.textChanged = textChanged;
};
YAHOO.fcom.PopupSearchInput.prototype.getValue = function () {
  if (this.dropMenu != null) {
    return this.dropMenu.getSelectedValue();
  } else if (this.config.multipleSelection) {
    return this.valueField.value.split(',').filter(function (f) {
      return f;
    });
  }
  return this.valueField.value;
};
YAHOO.fcom.PopupSearchInput.prototype.setValue = function (value) {
  if (this.config.multipleSelection) {
    throw new TypeError('setValue is not implemented for multipleSelection, please use setTextValue instead');
  }
  this.valueField.value = value;
};
YAHOO.fcom.PopupSearchInput.prototype.getText = function () {
  if (this.config.multipleSelection) {
    return $(this.tagContainer).find('.popupsearch-tag').text().split('×').filter(function (f) {
      return f;
    });
  } else {
    return this.textField.value;
  }
};
YAHOO.fcom.PopupSearchInput.prototype.setText = function (text) {
  if (this.config.multipleSelection) {
    throw new TypeError('setText is not implemented for multipleSelection, please use setTextValue instead');
  }
  this.textField.value = text;
};
YAHOO.fcom.PopupSearchInput.prototype.setTextValue = function (textValue) {
  var _this6 = this;
  if (!this.config.multipleSelection) {
    this.setText(textValue.text);
    this.setValue(textValue.value);
  } else {
    $(this.tagContainer).find('.popupsearch-tag').remove(); // remove all tags (text)
    this.valueField.value = ''; // remove all values

    textValue.map(function (item) {
      return _this6.addTextValue(item);
    });
  }
};
YAHOO.fcom.PopupSearchInput.prototype.addTextValue = function (_ref) {
  var text = _ref.text,
    value = _ref.value;
  if (!this.config.multipleSelection) {
    throw new TypeError('addTextValue is only implemented for multipleSelection');
  }
  this.valueField.value = [value].concat(_toConsumableArray(this.valueField.value.split(',').filter(function (f) {
    return f;
  }))).join(',');
  this.appendTags(text, value);
};
YAHOO.fcom.PopupSearchInput.prototype.appendTags = function (text, value) {
  var _this = this;
  var $item = $('<li/>').addClass('popupsearch-tag').html("".concat(text)).prepend($('<span class="remove">×</span>').click(function () {
    _this.valueField.value = _this.valueField.value.split(',').filter(function (f) {
      return f;
    }).filter(function (f) {
      return f !== value;
    }).join(',');
    $(this).parent().remove();
    _this.itemRemovedEvent.fire();
    // #. Manage the button state
    _this.mangeDeleteButtonState();
  }));
  $(this.tagContainer).prepend($item);
};
YAHOO.fcom.PopupSearchInput.prototype.getTextValue = function () {
  if (this.config.multipleSelection) {
    var texts = this.getText();
    var values = this.getValue();
    return values.map(function (value, i) {
      return {
        text: texts[i],
        value: value
      };
    });
  } else {
    return {
      text: this.getText(),
      value: this.getValue()
    };
  }
};
YAHOO.fcom.PopupSearchInput.prototype.initializeContent = function (obj) {
  this.textField.setAttribute('title', obj.title || '');
  this.setHasFound(false);
  this.setTextChanged(false);
  YAHOO.fcom.PopupSearch.returnOnlyDirectHit = true;
  var searchTerm = this.textField.value = YAHOO.lang.trim(obj.text);
  if (this.dropMenu == null && this.textField.disabled) {
    return;
  }
  if (obj.search) {
    YAHOO.fcom.PopupSearch.handlePopupSearchInput({
      searchTerm: searchTerm,
      searchSpace: this.config.searchSpace,
      searchSettings: this.config.searchSettings,
      obj: this,
      callback: obj.callback
    }, function (callbackObject) {
      callbackObject.obj.handlePopupSearchCallback(callbackObject);
    });
  }
};
YAHOO.fcom.PopupSearchInput.prototype.getIsMultipleSelection = function () {
  return !!this.config.multipleSelection;
};

/*
 * remove the value and text from that popup search input
 * @return
 */
YAHOO.fcom.PopupSearchInput.prototype.reset = function () {
  this.lastSearchResult = null;
  this.textChanged = false;
  this.textField.setAttribute('title', '');
  this.setHasFound(false);
  if (this.dropMenu == null) {
    // dropdown has a reset itself
    this.textField.value = '';
    this.valueField.value = '';
    this.lastTextFieldContent = '';
  }
  if (this.config.multipleSelection) {
    this.setTextValue([]); // set to empty array
  }
};

var saveSearchHistory = function saveSearchHistory(item) {
  var params = {
    ric: item.ric || item.symbol || item.id || item.isin,
    isin: item.isin
  };
  _axios.default.post('/searchHistory/updateHistory', params).catch(function (error) {
    console.error(error);
  });
};

},{"../../app/utils/axios":1,"accessibility/Accessibility":2,"core/Ajax/ajaxRequest":12,"search/incrementalSearch":21,"search/searchTypesEnum":23}],23:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// Enum-like object containing all SearchTypes used by incrementalSearch
var SEARCHTYPE = {
  INSTRUMENTS: 'instruments',
  INSTRUMENT: 'instruments',
  NEWS: 'news',
  WLPF: 'wlpf',
  NAV: 'nav',
  BND_ISSUER: 'bnd_issuer',
  ISSUER: 'bnd_issuer'
};
var _default = exports.default = SEARCHTYPE;

},{}],24:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var KEYCODE = {
  ENTER: 13,
  SPACE: 32,
  ESCAPE: 27,
  ARROW_LEFT: 37,
  ARROW_UP: 38,
  ARROW_RIGHT: 39,
  ARROW_DOWN: 40,
  TAB: 9,
  KeyA: 65,
  KeyD: 68,
  DELETE: 46
};
var _default = exports.default = KEYCODE;

},{}],25:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * This functions takes a function fn as input and returns a function that when executed
 * will only run every millis milliseconds
 */
var runFunctionDebounced = function runFunctionDebounced(millis, fn) {
  var timeout = null;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (timeout) {
      window.clearTimeout(timeout);
    }
    timeout = window.setTimeout(function () {
      timeout = null;
      fn.apply(void 0, args);
    }, millis);
  };
};
var _default = exports.default = runFunctionDebounced;

},{}],26:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * @name            : GUID
 * @description     : Generate new GUID and GUID related methods
 */
var GUID = exports.default = /*#__PURE__*/function () {
  function GUID() {
    _classCallCheck(this, GUID);
  }
  _createClass(GUID, null, [{
    key: "generate",
    value:
    /**
     * @method generate
     * @description Static method to generate new GUID
     * @public
     * @static
     */
    function generate() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0;
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
      });
    }
  }]);
  return GUID;
}();

},{}],27:[function(require,module,exports){
module.exports = require('./lib/axios');
},{"./lib/axios":29}],28:[function(require,module,exports){
'use strict';

var utils = require('./../utils');
var settle = require('./../core/settle');
var cookies = require('./../helpers/cookies');
var buildURL = require('./../helpers/buildURL');
var buildFullPath = require('../core/buildFullPath');
var parseHeaders = require('./../helpers/parseHeaders');
var isURLSameOrigin = require('./../helpers/isURLSameOrigin');
var createError = require('../core/createError');

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

},{"../core/buildFullPath":35,"../core/createError":36,"./../core/settle":40,"./../helpers/buildURL":44,"./../helpers/cookies":46,"./../helpers/isURLSameOrigin":49,"./../helpers/parseHeaders":51,"./../utils":54}],29:[function(require,module,exports){
'use strict';

var utils = require('./utils');
var bind = require('./helpers/bind');
var Axios = require('./core/Axios');
var mergeConfig = require('./core/mergeConfig');
var defaults = require('./defaults');

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = require('./cancel/Cancel');
axios.CancelToken = require('./cancel/CancelToken');
axios.isCancel = require('./cancel/isCancel');

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = require('./helpers/spread');

// Expose isAxiosError
axios.isAxiosError = require('./helpers/isAxiosError');

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;

},{"./cancel/Cancel":30,"./cancel/CancelToken":31,"./cancel/isCancel":32,"./core/Axios":33,"./core/mergeConfig":39,"./defaults":42,"./helpers/bind":43,"./helpers/isAxiosError":48,"./helpers/spread":52,"./utils":54}],30:[function(require,module,exports){
'use strict';

/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;

},{}],31:[function(require,module,exports){
'use strict';

var Cancel = require('./Cancel');

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;

},{"./Cancel":30}],32:[function(require,module,exports){
'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

},{}],33:[function(require,module,exports){
'use strict';

var utils = require('./../utils');
var buildURL = require('../helpers/buildURL');
var InterceptorManager = require('./InterceptorManager');
var dispatchRequest = require('./dispatchRequest');
var mergeConfig = require('./mergeConfig');
var validator = require('../helpers/validator');

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      forcedJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      clarifyTimeoutError: validators.transitional(validators.boolean, '1.0.0')
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;

},{"../helpers/buildURL":44,"../helpers/validator":53,"./../utils":54,"./InterceptorManager":34,"./dispatchRequest":37,"./mergeConfig":39}],34:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;

},{"./../utils":54}],35:[function(require,module,exports){
'use strict';

var isAbsoluteURL = require('../helpers/isAbsoluteURL');
var combineURLs = require('../helpers/combineURLs');

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};

},{"../helpers/combineURLs":45,"../helpers/isAbsoluteURL":47}],36:[function(require,module,exports){
'use strict';

var enhanceError = require('./enhanceError');

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};

},{"./enhanceError":38}],37:[function(require,module,exports){
'use strict';

var utils = require('./../utils');
var transformData = require('./transformData');
var isCancel = require('../cancel/isCancel');
var defaults = require('../defaults');

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};

},{"../cancel/isCancel":32,"../defaults":42,"./../utils":54,"./transformData":41}],38:[function(require,module,exports){
'use strict';

/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};

},{}],39:[function(require,module,exports){
'use strict';

var utils = require('../utils');

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, mergeDeepProperties);

  return config;
};

},{"../utils":54}],40:[function(require,module,exports){
'use strict';

var createError = require('./createError');

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};

},{"./createError":36}],41:[function(require,module,exports){
'use strict';

var utils = require('./../utils');
var defaults = require('./../defaults');

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};

},{"./../defaults":42,"./../utils":54}],42:[function(require,module,exports){
(function (process){(function (){
'use strict';

var utils = require('./utils');
var normalizeHeaderName = require('./helpers/normalizeHeaderName');
var enhanceError = require('./core/enhanceError');

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = require('./adapters/xhr');
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = require('./adapters/http');
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

}).call(this)}).call(this,require('_process'))
},{"./adapters/http":28,"./adapters/xhr":28,"./core/enhanceError":38,"./helpers/normalizeHeaderName":50,"./utils":54,"_process":56}],43:[function(require,module,exports){
'use strict';

module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

},{}],44:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

},{"./../utils":54}],45:[function(require,module,exports){
'use strict';

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};

},{}],46:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);

},{"./../utils":54}],47:[function(require,module,exports){
'use strict';

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

},{}],48:[function(require,module,exports){
'use strict';

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};

},{}],49:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);

},{"./../utils":54}],50:[function(require,module,exports){
'use strict';

var utils = require('../utils');

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

},{"../utils":54}],51:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};

},{"./../utils":54}],52:[function(require,module,exports){
'use strict';

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

},{}],53:[function(require,module,exports){
'use strict';

var pkg = require('./../../package.json');

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};
var currentVerArr = pkg.version.split('.');

/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */
function isOlderVersion(version, thanVersion) {
  var pkgVersionArr = thanVersion ? thanVersion.split('.') : currentVerArr;
  var destVer = version.split('.');
  for (var i = 0; i < 3; i++) {
    if (pkgVersionArr[i] > destVer[i]) {
      return true;
    } else if (pkgVersionArr[i] < destVer[i]) {
      return false;
    }
  }
  return false;
}

/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  var isDeprecated = version && isOlderVersion(version);

  function formatMessage(opt, desc) {
    return '[Axios v' + pkg.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed in ' + version));
    }

    if (isDeprecated && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

module.exports = {
  isOlderVersion: isOlderVersion,
  assertOptions: assertOptions,
  validators: validators
};

},{"./../../package.json":55}],54:[function(require,module,exports){
'use strict';

var bind = require('./helpers/bind');

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};

},{"./helpers/bind":43}],55:[function(require,module,exports){
module.exports={
  "name": "axios",
  "version": "0.21.4",
  "description": "Promise based HTTP client for the browser and node.js",
  "main": "index.js",
  "scripts": {
    "test": "grunt test",
    "start": "node ./sandbox/server.js",
    "build": "NODE_ENV=production grunt build",
    "preversion": "npm test",
    "version": "npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json",
    "postversion": "git push && git push --tags",
    "examples": "node ./examples/server.js",
    "coveralls": "cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js",
    "fix": "eslint --fix lib/**/*.js"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/axios/axios.git"
  },
  "keywords": [
    "xhr",
    "http",
    "ajax",
    "promise",
    "node"
  ],
  "author": "Matt Zabriskie",
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/axios/axios/issues"
  },
  "homepage": "https://axios-http.com",
  "devDependencies": {
    "coveralls": "^3.0.0",
    "es6-promise": "^4.2.4",
    "grunt": "^1.3.0",
    "grunt-banner": "^0.6.0",
    "grunt-cli": "^1.2.0",
    "grunt-contrib-clean": "^1.1.0",
    "grunt-contrib-watch": "^1.0.0",
    "grunt-eslint": "^23.0.0",
    "grunt-karma": "^4.0.0",
    "grunt-mocha-test": "^0.13.3",
    "grunt-ts": "^6.0.0-beta.19",
    "grunt-webpack": "^4.0.2",
    "istanbul-instrumenter-loader": "^1.0.0",
    "jasmine-core": "^2.4.1",
    "karma": "^6.3.2",
    "karma-chrome-launcher": "^3.1.0",
    "karma-firefox-launcher": "^2.1.0",
    "karma-jasmine": "^1.1.1",
    "karma-jasmine-ajax": "^0.1.13",
    "karma-safari-launcher": "^1.0.0",
    "karma-sauce-launcher": "^4.3.6",
    "karma-sinon": "^1.0.5",
    "karma-sourcemap-loader": "^0.3.8",
    "karma-webpack": "^4.0.2",
    "load-grunt-tasks": "^3.5.2",
    "minimist": "^1.2.0",
    "mocha": "^8.2.1",
    "sinon": "^4.5.0",
    "terser-webpack-plugin": "^4.2.3",
    "typescript": "^4.0.5",
    "url-search-params": "^0.10.0",
    "webpack": "^4.44.2",
    "webpack-dev-server": "^3.11.0"
  },
  "browser": {
    "./lib/adapters/http.js": "./lib/adapters/xhr.js"
  },
  "jsdelivr": "dist/axios.min.js",
  "unpkg": "dist/axios.min.js",
  "typings": "./index.d.ts",
  "dependencies": {
    "follow-redirects": "^1.14.0"
  },
  "bundlesize": [
    {
      "path": "./dist/axios.min.js",
      "threshold": "5kB"
    }
  ]
}

},{}],56:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}]},{},[22]);
;
window.ngpNamespace("YAHOO.fcom.connection");var ConnectionState={NEW:0,ACTIVE:1,IDLE:2,FINALIZED:-1},RequestMode={GET:0,POST:1};function ConnectionEventHandler(){this.onStart=function(eventType,args){var _core=args[1][0],queElementIndex=(window.showWait(!0),_core.State=ConnectionState.ACTIVE,args[1].length-1),queueElement=eval(args[1][queElementIndex]);queueElement.State=ConnectionState.ACTIVE},this.onComplete=function(){},this.onSuccess=function(eventType,args){var _core=args[0].argument[0],queElementIndex=args[0].argument.length-1,queueElement=eval(args[0].argument[queElementIndex]);window.showWait(!1),_core.setIdle(queueElement),queueElement.State=ConnectionState.IDLE,_core.next(queueElement.Listener)},this.onFailure=function(eventType,args){var _core=args[0].argument[0],queElementIndex=args[0].argument.length-1,queueElement=eval(args[0].argument[queElementIndex]);window.showWait(!1),_core.setIdle(queueElement),queueElement.State=ConnectionState.IDLE,_core.next(queueElement.Listener)},this.onAbort=function(eventType,args){var _core,queElementIndex,queueElement;args.length&&!args[0].argument||(_core=args[0].argument[0],queElementIndex=args[0].argument.length-1,queueElement=eval(args[0].argument[queElementIndex]),window.showWait(!1),_core.setIdle(queueElement),queueElement.State=ConnectionState.IDLE,_core.next(queueElement.Listener))}}YAHOO.fcom.connection.Core=function(){this.State=ConnectionState.NEW,this.ActiveElement=null,this.FinalizerElement="Aggregate",this.Queue=[],this.queueRequest=function(e,t){var n;!0===e.IsAFinalizer?this.FinalizerElement=e.ID:(!1===e.isQualified()&&t.disqualified(e),!0===this.toQueue()?(n=e.Listener,YAHOO.lang.isNull(n)&&(n=this._cloneCallBack(t,e),e.Listener=n),-1<(n=this.Queue.indexOf(e.ID))&&this.Queue.splice(n,1),this.Queue.push(e.ID)):this.query(e,t))},this.toQueue=function(){return this.State==ConnectionState.ACTIVE||0!==this.Queue.length},this.query=function(e,t){!0===e.isQualified()?!0===e.isStateChanged()?(e.updateState(),this._makeAsyncRequest(e,t)):(!0===e.IsAFinalizer?this.State=ConnectionState.FINALIZED:this.State=ConnectionState.IDLE,this.next(t)):(this.State=ConnectionState.IDLE,this.next(t))},this.next=function(callBack){var stackedQueueElement=null;if(0===this.Queue.length){if(YAHOO.lang.isNull(this.FinalizerElement)||this.State===ConnectionState.FINALIZED)return;stackedQueueElement=eval(this.FinalizerElement)}else stackedQueueElement=eval(this.Queue.shift());!1===YAHOO.lang.isNull(stackedQueueElement)&&this.query(stackedQueueElement,callBack)},this.setIdle=function(e){0===this.Queue.length&&(!0===e.IsAFinalizer?this.State=ConnectionState.FINALIZED:this.State=ConnectionState.IDLE)},this._makeAsyncRequest=function(e,t){this.ActiveElement=e.ID,e.LastModified=(new Date).getTime();var n=e.getSURL(),i=e.Listener;YAHOO.lang.isNull(i)&&(i=this._cloneCallBack(t,e),e.Listener=i),e.RequestMode==RequestMode.GET?YAHOO.util.Connect.asyncRequest("GET",n,i,null):(e=(t=n.split("?"))[0],n=t[1],YAHOO.util.Connect.asyncRequest("POST",e,i,n))},this._cloneCallBack=function(e,t){try{var n=YAHOO.fcom.Util.cloneJSObject(e);return n.argument[0]=this,n.argument[e.argument.length]=t.ID,n}catch(i){return window.alert(i+"\nCallBack Object is not clonable"),e}},this.makeCoreAvailToHandler=function(e){if(0===e.argument.length)e.argument=[this];else{var t=[];t[0]=this;for(var n=0;n<e.argument.length;n++)t[n+1]=this.CallBack.argument[n];e.argument=t}return e}},YAHOO.fcom.connection.QueueElement=function(e){this.ID=e,this.LastModified=0,this.IsAFinalizer=!1,this.State=ConnectionState.NEW,this.Listener=null,this.RequestMode=RequestMode.GET,this.getSURL=function(){return""},this.isQualified=function(){return!0},this.isStateChanged=function(){return!0},this.updateState=function(){}},YAHOO.fcom.connection.CallBack=function(e){this.success=function(){},this.failure=function(){},this.timeout=e,this.argument=[],this.customevents=new ConnectionEventHandler,this.disqualified=function(){}},YAHOO.fcom.connection.Manager=function(e){this.Core=new YAHOO.fcom.connection.Core,this.CallBack=this.Core.makeCoreAvailToHandler(e),this.queueRequest=function(e){this.Core.queueRequest(e,this.CallBack)}};
//# sourceMappingURL=connection.js.map;
(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _StreamingAccessibility = _interopRequireDefault(require("accessibility/StreamingAccessibility"));
var _ContextMenuAccessibility = _interopRequireDefault(require("accessibility/ContextMenuAccessibility"));
var _AccordionAccessibility = _interopRequireDefault(require("accessibility/AccordionAccessibility"));
var _TooltipAccessibility = _interopRequireDefault(require("accessibility/TooltipAccessibility"));
var _PopupSearchAccessibility = _interopRequireDefault(require("accessibility/PopupSearchAccessibility"));
var _HighchartsAccessibility = _interopRequireDefault(require("accessibility/HighchartsAccessibility"));
var _NewsPlayerAccessibility = _interopRequireDefault(require("accessibility/NewsPlayerAccessibility"));
var _LoginAccessibility = _interopRequireDefault(require("accessibility/LoginAccessibility"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * @class       : Accessibility
                                                                                                                                                                                                                                                                                                                                                                                               * @description : To enable the web content accessibility(WCAG) in the ngp components
                                                                                                                                                                                                                                                                                                                                                                                               *                  - Streaming modules
                                                                                                                                                                                                                                                                                                                                                                                               *                  - Context menu open button
                                                                                                                                                                                                                                                                                                                                                                                               *                  - Context menu
                                                                                                                                                                                                                                                                                                                                                                                               *                  - Accordion controls
                                                                                                                                                                                                                                                                                                                                                                                               *                  - Tooltip component
                                                                                                                                                                                                                                                                                                                                                                                               *                  - Popup search
                                                                                                                                                                                                                                                                                                                                                                                               *                  - Highcharts/Highstocks
                                                                                                                                                                                                                                                                                                                                                                                               *                  - NEWS Player - top news module
                                                                                                                                                                                                                                                                                                                                                                                               * @dependencies: Jquery, StreamingAccessibility, ContextMenuAccessibility, AccordionAccessibility,
                                                                                                                                                                                                                                                                                                                                                                                               *                TooltipAccessibility, PopupSearchAccessibility, NewsPlayerAccessibility
                                                                                                                                                                                                                                                                                                                                                                                               * @references  : https://www.w3.org/TR/WCAG20-TECHS/
                                                                                                                                                                                                                                                                                                                                                                                               */
var Accessibility = /*#__PURE__*/function () {
  function Accessibility() {
    _classCallCheck(this, Accessibility);
  }
  _createClass(Accessibility, null, [{
    key: "init",
    value:
    /**
     * @method init
     * @description Initialize the accessibility module
     * @public
     * @static
     */
    function init(params) {
      Accessibility._start(params);
    }

    /**
     * @method init
     * @description Update an element title based on the inner text
     * @public
     * @static
     */
  }, {
    key: "compareAndUpdateElementTitle",
    value: function compareAndUpdateElementTitle($elements, compareText, updatedTitle) {
      // #. Identify the delete button based on the inner text value
      $elements.filter(function (index) {
        var $element = $($elements[index]);
        var innerText = $element.text();
        if (String(innerText).trim().replace(/[^a-zA-Z ]/g, '') === String(compareText).trim().replace(/[^a-zA-Z ]/g, '')) {
          $element.attr({
            'aria-label': updatedTitle
          });
        }
      });
    }
  }, {
    key: "_start",
    value:
    /**
     * @method _start
     * @description assign accessibility to accessibility services
     * @param { Object } v expect config information or null
     * @private
     * @static
     */
    function _start(config) {
      if (config) {
        // #. Init the streaming accessibility
        if (config.streamingAccessibility) {
          var streamingAccessibility = new _StreamingAccessibility.default();
          streamingAccessibility.init(config.streamingAccessibility.nodes);
        }

        // #. Init context menu accessibility
        if (config.menu && config.menu.enabled) {
          var contextMenuAccessibility = new _ContextMenuAccessibility.default();
          window.setTimeout(function () {
            contextMenuAccessibility.init();
          }, config.menu.initDelay || 0);
        }

        // #. Init accordion accessibility
        if (config.accordion) {
          var accordionAccessibility = new _AccordionAccessibility.default(config.accordion);
          accordionAccessibility.init();
        }

        // #. Init accordion accessibility
        if (config.tooltip) {
          var tooltipAccessibility = new _TooltipAccessibility.default(config.tooltip);
          tooltipAccessibility.init();
        }

        // #. Init popup search accessibility accessibility
        if (config.popupSearch) {
          var popupSearchAccessibility = new _PopupSearchAccessibility.default(config.popupSearch);
          popupSearchAccessibility.init();
        }

        // #. Init highcharts accessibility module
        if (config.highCharts && config.highCharts.enabled) {
          var highchartsAccessibility = new _HighchartsAccessibility.default(config.highCharts);
          highchartsAccessibility.init();
        }

        // #. Init highcharts accessibility module
        if (config.newsPlayer) {
          var newsPlayerAccessibility = new _NewsPlayerAccessibility.default(config.newsPlayer);
          newsPlayerAccessibility.init();
        }

        // #. Init login page accessibility
        if (config.login) {
          var loginAccessibility = new _LoginAccessibility.default();
          loginAccessibility.init();
        }
      }
    }
  }]);
  return Accessibility;
}(); // #. Set the global access
window.fcom.Accessibility = Accessibility;
var _default = exports.default = Accessibility;

},{"accessibility/AccordionAccessibility":2,"accessibility/ContextMenuAccessibility":3,"accessibility/HighchartsAccessibility":4,"accessibility/LoginAccessibility":5,"accessibility/NewsPlayerAccessibility":6,"accessibility/PopupSearchAccessibility":7,"accessibility/StreamingAccessibility":8,"accessibility/TooltipAccessibility":9}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _guid = _interopRequireDefault(require("util/guid"));
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * @class       : AccordionAccessibility
                                                                                                                                                                                                                                                                                                                                                                                               * @description : To enable the web content accessibility(WCAG) in ngp application accordion(expander/collapse) component
                                                                                                                                                                                                                                                                                                                                                                                               *                - NGPII-15088 JAWS: Expander
                                                                                                                                                                                                                                                                                                                                                                                               * @dependencies: Jquery, GUID
                                                                                                                                                                                                                                                                                                                                                                                               * @references  : https://www.w3.org/TR/wai-aria-practices-1.1/examples/accordion/accordion.html
                                                                                                                                                                                                                                                                                                                                                                                               */
var AccordionAccessibility = /*#__PURE__*/function () {
  function AccordionAccessibility(options) {
    _classCallCheck(this, AccordionAccessibility);
    if (!options) {
      return true;
    }

    // #. Keep the config/options into context
    this.options = options;
    // #. Keep the accordion container
    this.$container = _typeof(options.container) === 'object' ? options.container : $(options.container);
    // #. Keep all accordion toggles
    this.$toggles = null;
    // #. Selector to identify the expanded toggle bar - default 'open' is a css class name
    this.expandSelector = options.expandSelector || 'open';
    /**
     * Keep the panel find selector method(ex: next, Jquery selector)
     * next - consider as method ex: findPanelBy: { method: 'next' }
     * multiple methods will be formatted by space { method: 'parent next' }
     * id - consider as attribute ex: findPanelBy: { attr: 'id' }
     */
    this.findPanelBy = options.findPanelBy || {
      method: 'next'
    };
  }

  /**
   * @method init
   * @description Initialize the accordion accessibility
   * @public
   */
  _createClass(AccordionAccessibility, [{
    key: "init",
    value: function init() {
      // #. Find all accordion toggles
      this.$toggles = this.$container.find(this.options.toggleSelector);
      // #. Set default WCAG attributes
      this._setWCAGAttributes();
      // #. Bind the tracking events to toggle bar
      this._bindEvents(this.$toggles);
    }

    /**
     * @method _setWCAGAttributes
     * @description set WCAG attributes to accordion
     * @private
     */
  }, {
    key: "_setWCAGAttributes",
    value: function _setWCAGAttributes() {
      // todo manage the disabled accordions - check the scope
      // todo manage the multiple open accordions - check the scope
      var _iterator = _createForOfIteratorHelper(this.$toggles),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var $toggle = _step.value;
          $toggle = $($toggle);
          var $panel = this._getPanelByToggle($toggle);

          // #. No panel - then continue
          if (!$panel || $panel.length === 0) {
            return true;
          }

          // #. Set toggle bat attr
          var toggleAttr = {
            'aria-expanded': this._isToggleExpanded($toggle)
          };

          // #. lost toggle not require control attr ex: EditView left panel list
          if (this.options.toggleControlAttr !== false) {
            toggleAttr['aria-controls'] = this._getElementId($panel);
          }

          // #. Update toggle attr
          this._setAttributes($toggle, toggleAttr);

          // #. Set panel display attr
          var panelAttr = {
            'aria-labelledby': this._getElementId($toggle)
          };

          // #. options not require role update ex: EditView left panel list
          if (this.options.panelRoleUpdate !== false) {
            panelAttr.role = 'region';
          }

          // #. Update panel attr
          this._setAttributes($panel, panelAttr);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    /**
     * @method _bindEvents
     * @description bind events to update the attributes
     * @param { HTMLElement } $element expect a element or collection of elements object
     * @private
     */
  }, {
    key: "_bindEvents",
    value: function _bindEvents($element) {
      var _this = this;
      $element.on('keydown click', function (event) {
        var $target = $(event.target);
        var keyCode = event.keyCode;
        if (!keyCode || keyCode === _keyCodes.default.ENTER || keyCode === _keyCodes.default.SPACE) {
          // #. Update expanded attribute
          _this._isToggleExpanded($target, function (value) {
            $target.attr('aria-expanded', value);
          });
        }
      });
    }

    /**
     * @method _isToggleExpanded
     * @description check the expand status of a toggle
     * @param { HTMLElement } $element expect a element or collection of elements object
     * @private
     */
  }, {
    key: "_isToggleExpanded",
    value: function _isToggleExpanded($toggle, callback) {
      var $element = $toggle;
      var selector = this.expandSelector;
      var delay = 0;
      if (_typeof(this.expandSelector) === 'object') {
        if (this.expandSelector.parent) {
          $element = $toggle.parent();
          selector = this.expandSelector.parent;
          delay = this.expandSelector.delay || 0;
        }
      }
      if (callback) {
        window.setTimeout(function () {
          callback($element.hasClass(selector));
        }, delay);
      } else {
        return $element.hasClass(selector);
      }
    }

    /**
     * @method _getElementId
     * @description get id attribute of a element, set new one when no id found
     * @param { HTMLElement } $element expect panel display element object
     * @private
     */
  }, {
    key: "_getElementId",
    value: function _getElementId($element) {
      var elementId = $element.attr('id');
      if (!elementId) {
        elementId = _guid.default.generate();
        $element.attr('id', elementId);
      }
      return elementId;
    }

    /**
     * @method _setAttributes
     * @description set attr object to specific element
     * @param { HTMLElement } $element expect element object
     * @param { Object } attr expect object of attributes
     * @private
     */
  }, {
    key: "_setAttributes",
    value: function _setAttributes($element, attr) {
      $element.attr(attr);
    }

    /**
     * @method _getPanelByToggle
     * @description get corresponding panel by toggle bar
     * @param { HTMLElement } $toggle expect toggle bar element object
     * @private
     */
  }, {
    key: "_getPanelByToggle",
    value: function _getPanelByToggle($toggle) {
      /** Find panel element by series of methods or method
        * multiple methods split by space ex: 'parent next' - means next element of the toggle parent
        * method parameter can passed inside the parenthesis ex: 'parent nextAll(.class1#id)'
        */
      if (this.findPanelBy.method) {
        var $element = null;
        var methods = this.findPanelBy.method.split(' ');
        var _iterator2 = _createForOfIteratorHelper(methods),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var method = _step2.value;
            // #. Check any selectors passed as params
            var selector = '';
            if (method.indexOf('(') !== -1) {
              var params = method.split('(');
              method = params[0];
              selector = String(params[1]).replace(')', '');
            }
            $element = $element ? $($element)[method](selector) : $toggle[method](selector);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        return $element;
      }

      // #. Find panel elements by toggle attribute value
      // #. findClosestOfToggle - will get the attribute value from the closest element of the toggle
      if (this.findPanelBy.attr) {
        var _$element = this.findPanelBy.findClosestOfToggle ? $toggle.closest("[".concat(this.findPanelBy.attr, "]")) : $toggle;
        var attrVal = _$element.attr(this.findPanelBy.attr);
        var _selector = "[".concat(this.findPanelBy.attr, "=\"").concat(attrVal, "\"]");
        return this.$container.find(_selector).not(this.findPanelBy.notInclude || '');
      }
    }
  }]);
  return AccordionAccessibility;
}(); // #. Export the accordion accessibility
var _default = exports.default = AccordionAccessibility;

},{"util/enums/keyCodes":16,"util/guid":17}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * @class       : ContextMenuAccessibility
                                                                                                                                                                                                                                                                                                                                                                                               * @description : To enable the web content accessibility(WCAG) in ngp application context menu component
                                                                                                                                                                                                                                                                                                                                                                                               *                - NGPII-15538 JAWS: Context Menu
                                                                                                                                                                                                                                                                                                                                                                                               *                - Context menu item accessibility handled in ExtendedMenu.es6.js
                                                                                                                                                                                                                                                                                                                                                                                               * @dependencies: Jquery, KEYCODES
                                                                                                                                                                                                                                                                                                                                                                                               * @references  : https://www.w3.org/TR/WCAG20-TECHS/
                                                                                                                                                                                                                                                                                                                                                                                               *                https://www.w3.org/TR/wai-aria-practices/examples/menu-button/menu-button-links.html
                                                                                                                                                                                                                                                                                                                                                                                               */
var ContextMenuAccessibility = /*#__PURE__*/function () {
  function ContextMenuAccessibility() {
    _classCallCheck(this, ContextMenuAccessibility);
    // #. To keep the menu opening button collection
    this.$menuOpenButtons = [];
    // #. CSS class selector of module library menu open button
    this.moduleLibraryButtonSelector = '.icon.showModuleLibrary';
    // #. CSS selector of module content header menu button
    this.moduleHeaderButton = 'table.headerContent .controls .control .icon.options';
    // #. CSS selector of context menu open button
    this.menuOpener = 'button.icon.options';
    // #. Const to declare the button context type
    this.contextType = {
      MODULE_LIBRARY: 1,
      MODULE_CONTROL: 2,
      TABLE_ROW_EDIT: 3
    };
  }

  /**
   * @method init
   * @description Initialize the menu accessibility
   * @public
   */
  _createClass(ContextMenuAccessibility, [{
    key: "init",
    value: function init() {
      // #. Get menu opening button elements
      this.$menuOpenButtons = this._findMenuOpenButtons();
      this._start();
    }

    /**
     * @method _start
     * @description start the basic methods, assign attributes, bind key handler
     * @private
     */
  }, {
    key: "_start",
    value: function _start() {
      // #. Handle the focus, keydown event
      this._bindTrackingEvents();

      // #. Check the count of the streaming nodes
      if (this.$menuOpenButtons.length > 0) {
        this._setWCAGAttributesToButton(this.$menuOpenButtons);
      }
    }

    /**
     * @method _findMenuOpenButtons
     * @description find all menu opening buttons from the body element
     * @return { Array } of menu open button elements
     * @private
     */
  }, {
    key: "_findMenuOpenButtons",
    value: function _findMenuOpenButtons() {
      var $body = $('body');
      return $([].concat(_toConsumableArray($body.find(this.menuOpener)), _toConsumableArray($body.find(this.moduleLibraryButtonSelector))));
    }

    /**
     * @method _setWCAGAttributesToButton
     * @description find all menu opening buttons from the body element
     * @param { HTMLCollectionOf } $buttons expecting collection menu open button elements
     * @private
     */
  }, {
    key: "_setWCAGAttributesToButton",
    value: function _setWCAGAttributesToButton($buttons) {
      $buttons.attr({
        'aria-haspopup': 'menu',
        'aria-expanded': false
      });

      // #. Set unique properties
      this._setButtonUniqueProps($buttons);
    }

    /**
     * @method _setButtonUniqueProps
     * @description set unique button properties
     * @param { HTMLCollectionOf } $buttons expecting collection menu open button elements
     * @private
     */
  }, {
    key: "_setButtonUniqueProps",
    value: function _setButtonUniqueProps($buttons) {
      var _iterator = _createForOfIteratorHelper($buttons),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var $button = _step.value;
          $button = $($button);
          var contextType = this._getContextType($button);

          // #. Update the button title
          this._updateButtonTitle($button, contextType, false);

          // #. Set role application for the module head control div element
          // #. otherwise, keydown will not work properly when JAWS is working
          if (contextType === this.contextType.MODULE_CONTROL) {
            $button.closest('.control').attr({
              role: 'application'
            });
          } else {
            // #. Remove the innerText of the image button, because button already has the title
            var bgImg = String($button.css('background-image')).trim();
            if (bgImg && bgImg !== 'none' && !$button.hasClass('include-text')) {
              $button.text('');
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    /**
     * @method _updateButtonTitle
     * @description update button title based on the context
     *              - Button from the table row
     *              - Button from the module header
     *              - Module library button
     * @param { HTMLElement } $button expecting menu open button object
     * @param { Number } button context type
     * @private
     */
  }, {
    key: "_updateButtonTitle",
    value: function _updateButtonTitle($button, contextType, isOnFocus) {
      var label = this._getTitleByButtonContext($button, contextType, isOnFocus);
      if (label) {
        $button.attr({
          'aria-label': label
        });
      }
    }

    /**
     * @method _getContextType
     * @description get type of button context
     * @param { HTMLElement } $button expecting current button element
     * @private
     */
  }, {
    key: "_getContextType",
    value: function _getContextType($button) {
      if ($button.parent().is('td')) {
        return this.contextType.TABLE_ROW_EDIT;
      } else if ($button.is(this.moduleHeaderButton)) {
        return this.contextType.MODULE_CONTROL;
      } else if ($button.is(this.moduleLibraryButtonSelector)) {
        return this.contextType.MODULE_LIBRARY;
      }
    }

    /**
     * @method _setTitleByButtonContext
     * @description get title/name based on the button context
     * @param { HTMLElement } $button expecting current button element
     * @param { Number } button context type
     * @private
     */
  }, {
    key: "_getTitleByButtonContext",
    value: function _getTitleByButtonContext($button, contextType, isOnFocus) {
      // 1. Get name/title of the table row menu button
      if (contextType === this.contextType.TABLE_ROW_EDIT) {
        var name = this._getInstrumentNameByRow($button) || '';
        return window.getMessage('context.menu.open.name.postfix.tooltip', name);
      }

      // 2. Get name/title of module header menu button
      if (contextType === this.contextType.MODULE_CONTROL) {
        var _name = this._getTitleFromModuleHeader($button) || '';
        // #. Header title text may be 'loading...' when module not loaded yet
        // #. Updated title will be set on the focus event
        if (!isOnFocus) {
          return false;
        }
        return window.getMessage('context.menu.module.open.name.postfix.tooltip', _name);
      }

      // 3. Get module library button
      if (contextType === this.contextType.MODULE_LIBRARY) {
        return $button.attr('title');
      }
    }

    /**
     * @method _getInstrumentNameByRow
     * @description get instrument name from table row
     * @param { HTMLElement } $button expecting current button element
     * @private
     */
  }, {
    key: "_getInstrumentNameByRow",
    value: function _getInstrumentNameByRow($button) {
      var $row = $($button.closest('tr'));
      return $row.find('a.instrumentIdentification').text() || $row.find('span.instrumentIdentification').text() || $row.find('input.searchPopupInput').val() || $row.find('a').first().text();
    }

    /**
     * @method _getTitleFromModuleHeader
     * @description get title from the module header element
     * @param { HTMLElement } $button expecting current button element
     * @private
     */
  }, {
    key: "_getTitleFromModuleHeader",
    value: function _getTitleFromModuleHeader($button) {
      var $row = $($button.closest('tr'));
      return $row.find('h2.title').text() || $row.find('span.content').text();
    }

    /**
     * @method _bindTrackingEvents
     * @description update attributes of lately rendered element(Ex: Modules added from the module library, menu button render after large table sorting...etc)
     * @private
     */
  }, {
    key: "_bindTrackingEvents",
    value: function _bindTrackingEvents() {
      var self = this;
      $(window.document).on('focus', this.menuOpener, function (event) {
        var $button = $(this);
        $button.attr('aria-expanded', false);
        if (!$button.attr('aria-label')) {
          var contextType = self._getContextType($button);
          self._updateButtonTitle($button, contextType, true);
        }
      }).on('keydown', this.menuOpener, function (event) {
        var $button = $(this);
        var keyCode = event.keyCode;
        if (keyCode === _keyCodes.default.ENTER) {
          $button.attr('aria-expanded', true);
        }
      });
    }
  }]);
  return ContextMenuAccessibility;
}();
var _default = exports.default = ContextMenuAccessibility;

},{"util/enums/keyCodes":16}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _messageHandler = require("fcom/messages/messageHandler");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * @class       : HighchartsAccessibility
 * @description : To enable the web content accessibility(WCAG) in ngp application highcharts/highstocks
 *                - https://jira.financial.com/browse/NGPII-15551
 * @dependencies: Highcharts, Highstocks, highchart-exporting, highchart-exporting-data, highcharts-accessibility
 * @references  : https://www.highcharts.com/docs/accessibility/accessibility-module
 *              : https://www.highcharts.com/docs/extending-highcharts/extending-highcharts
 *              : https://www.highcharts.com/docs/getting-started/how-to-set-options
 */
var HighchartsAccessibility = /*#__PURE__*/function () {
  function HighchartsAccessibility(options) {
    _classCallCheck(this, HighchartsAccessibility);
    // #. Keep the config/options into context
    this.options = options;
    // #. Get the highcharts object
    this.H = window.Highcharts;
    // #. Set accessibility options
    this.accessibilityOptions = {
      accessibility: {
        enabled: true,
        keyboardNavigation: {
          enabled: true,
          seriesNavigation: {
            mode: 'normal',
            skipNullPoints: true
          }
        },
        announceNewData: {
          enabled: true,
          interruptUser: true
        }
      }
    };
  }

  /**
   * @method init
   * @description Initialize the highcharts accessibility
   * @public
   */
  _createClass(HighchartsAccessibility, [{
    key: "init",
    value: function init() {
      var self = this;
      /**
       * Enable the chart accessibility globally
       */
      window.Highcharts.setOptions(this.accessibilityOptions);

      /**
       * NOTE:
       * Highcharts created a utility called wrap, which wraps an existing prototype function ("method") and -
       * allows you to add your own code before or after it.
       */

      /**
       * Extend the chart render method
       * To assign the proper role attribute to container element - for screen reader
       */
      this.H.wrap(this.H.Chart.prototype, 'onload', function (proceed) {
        proceed.call(this, arguments);
        self._setWCAGtoChart(this.renderTo);
        self._handleFirefoxTabKeyOrder(this.container);
        self._handleEdgeAccessToChart(this.container);
      });

      /**
       * Extend the tooltip refresh method
       * To assign the tooltip to proper role attributes - for screen reader
       */
      this.H.wrap(this.H.Tooltip.prototype, 'refresh', function (proceed, point, e) {
        proceed.call(this, point, e);
        self._setWCAGtoChartTooltip(this.chart.tooltip.container || this.chart.renderTo);
      });

      /**
       * Extend the tooltip hide method
       * To assign the tooltip table hidden - for screen reader
       */
      this.H.wrap(this.H.Tooltip.prototype, 'hide', function (proceed, point, e) {
        proceed.call(this, point, e);
        self._setWCAGtoHiddenTooltipTable(this.chart.renderTo);
      });

      /**
       * Extend the tooltip show method
       * To assign the tooltip table shown - for screen reader
       */
      this.H.wrap(this.H.Tooltip.prototype, 'show', function (proceed, point, e) {
        proceed.call(this, point, e);
        self._setWCAGtoShownTooltipTable(this.chart.renderTo);
      });
    }
  }, {
    key: "_setWCAGtoHiddenTooltipTable",
    value: function _setWCAGtoHiddenTooltipTable(chartContainer) {
      $(chartContainer).find('div.highcharts-tooltip table').attr('aria-hidden', true);
    }
  }, {
    key: "_setWCAGtoShownTooltipTable",
    value: function _setWCAGtoShownTooltipTable(chartContainer) {
      $(chartContainer).find('div.highcharts-tooltip table').attr('aria-hidden', false);
    }

    /**
     * @method _setWCAGtoChart
     * @description update WCAG attributes to highcharts
     * @param { $chartContainer } expecting chart container html element object
     * @private
     */
  }, {
    key: "_setWCAGtoChart",
    value: function _setWCAGtoChart($chartContainer) {
      $($chartContainer).attr({
        role: 'application'
      });
      if ($('#additionalChartTitleId').length > 0) {
        $($chartContainer).find('.highcharts-container').attr('aria-describedby', 'additionalChartTitleId');
      }
      $($chartContainer).find('[id*="highcharts-data-table"]').attr('aria-hidden', true);
    }

    /**
     * @method _setWCAGtoChartTooltip
     * @description update WCAG attributes to highcharts tooltip
     * @param { $chartContainer } expecting chart container html element object
     * @private
     */
  }, {
    key: "_setWCAGtoChartTooltip",
    value: function _setWCAGtoChartTooltip($chartContainer) {
      var $tooltip = $($chartContainer).find('div.highcharts-tooltip > span');
      if ($tooltip.length > 0) {
        $tooltip.attr('role', 'tooltip');
        $tooltip.attr('aria-live', 'assertive');
        var $tooltipTable = $tooltip.find('table');
        if ($($tooltipTable).find('caption').length === 0) {
          $tooltipTable.prepend($('<caption />').text((0, _messageHandler.getMessage)('chart.tooltip.table.caption')).addClass('visuallyhidden'));
        }
      }
    }

    /**
     * @method _handleFirefoxTabKeyOrder
     * @description set tab key order for the module chart
     * @param { $chartContainer } expecting chart container html element object
     * @private
     */
  }, {
    key: "_handleFirefoxTabKeyOrder",
    value: function _handleFirefoxTabKeyOrder($chartContainer) {
      var isFirefox = navigator.userAgent.search('Firefox');
      var $moduleLink = $($chartContainer).closest('.chartImageBox').children().first();
      if (isFirefox > -1 && $moduleLink.is('a')) {
        $moduleLink.attr('tabindex', -1);
      }
    }

    /**
     * @method _handleEdgeAccessToCahrt
     * @description set descriptive label
     * @param { $chartContainer } expecting chart container html element object
     * @private
     */
  }, {
    key: "_handleEdgeAccessToChart",
    value: function _handleEdgeAccessToChart($chartContainer) {
      var isEdge = navigator.userAgent.search('Edg');
      if (isEdge > -1) {
        var chartContainerId = $($chartContainer).attr('id');
        var describedLabelEle = $('<span>').attr('id', "".concat(chartContainerId, "_describedId")).addClass('visuallyhidden').text((0, _messageHandler.getMessage)('chart.descriptive.text.edg'));
        $($chartContainer).find('svg.highcharts-root').attr('aria-describedby', "".concat(chartContainerId, "_describedId")).before(describedLabelEle);
      }
    }
  }]);
  return HighchartsAccessibility;
}();
var _default = exports.default = HighchartsAccessibility;

},{"fcom/messages/messageHandler":11}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * @class       : LoginAccessibility
 * @description : To enable the web content accessibility(WCAG) in login page
 * @references  : https://developer.mozilla.org/en-US/docs/Web/API/Window/devicePixelRatio#monitoring_screen_resolution_or_zoom_level_changes
 */
var LoginAccessibility = /*#__PURE__*/function () {
  function LoginAccessibility() {
    _classCallCheck(this, LoginAccessibility);
    this.loginElement = $('div.login').get(0);
  }

  /**
   * @method init
   * @description Initialize login accessibility
   * @public
   */
  _createClass(LoginAccessibility, [{
    key: "init",
    value: function init() {
      this._initAccessibility();
    }

    /**
     * @method _initAccessibility
     * @description calling methods for wcag
     * @private
     */
  }, {
    key: "_initAccessibility",
    value: function _initAccessibility() {
      this._onPageZoomEvent();
    }

    /**
     * @method _onPageZoomEvent
     * @description when page zoom change, call method to set the scrollbarState
     * @private
     */
  }, {
    key: "_onPageZoomEvent",
    value: function _onPageZoomEvent() {
      var _this = this;
      var updatePixelRatio = function updatePixelRatio() {
        var pr = window.devicePixelRatio;
        var prString = (pr * 100).toFixed(0);
        _this._setScrollBarState();
        matchMedia("(resolution: ".concat(pr, "dppx)")).addEventListener("change", updatePixelRatio, {
          once: true
        });
      };
      updatePixelRatio();
    }

    /**
     * @method hasVerticalScrollBar
     * @returns {boolean}
     * @private
     */
  }, {
    key: "_hasVerticalScrollBar",
    value: function _hasVerticalScrollBar() {
      return this.loginElement.scrollHeight > this.loginElement.clientHeight;
    }

    /**
     * @method _checkLoginContainerScrolling
     * @description add css class hasScrollBar to scrolling login element
     * @private
     */
  }, {
    key: "_setScrollBarState",
    value: function _setScrollBarState() {
      if (this._hasVerticalScrollBar() === true) {
        $(this.loginElement).addClass('hasScrollBar');
      } else {
        $(this.loginElement).removeClass('hasScrollBar');
      }
    }
  }]);
  return LoginAccessibility;
}();
var _default = exports.default = LoginAccessibility;

},{}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * @class       : TopNewsAccessibility
                                                                                                                                                                                                                                                                                                                                                                                               * @description : To enable the web content accessibility(WCAG) in top news module component
                                                                                                                                                                                                                                                                                                                                                                                               *                - GPNGPII-16881 - Keyboard access not enabled for TOP NEWS Module
                                                                                                                                                                                                                                                                                                                                                                                               * @dependencies: Jquery, KEYCODES
                                                                                                                                                                                                                                                                                                                                                                                               * @references  : https://www.w3.org/WAI/tutorials/carousels/
                                                                                                                                                                                                                                                                                                                                                                                               */
var NewsPlayerAccessibility = /*#__PURE__*/function () {
  function NewsPlayerAccessibility(options) {
    _classCallCheck(this, NewsPlayerAccessibility);
    if (!options) {
      return true;
    }

    // #. Keep the config/options into context
    this.options = options;
    this.player = this.options.player;
  }

  // #. Get headline elements
  _createClass(NewsPlayerAccessibility, [{
    key: "$headlines",
    get: function get() {
      return $(this.player.container).find('.headline div');
    }

    // #. Get news module panel element
  }, {
    key: "$newsPlayerModulePanel",
    get: function get() {
      return $('#NewsPlayerModulePanel');
    }

    /**
     * @method init
     * @description Initialize the top news accessibility
     * @public
     */
  }, {
    key: "init",
    value: function init() {
      this._setWCAGAttributes();
    }

    /**
     * @method _setWCAGAttributes
     * @description set WCAG attributes to player elements
     * @private
     */
  }, {
    key: "_setWCAGAttributes",
    value: function _setWCAGAttributes() {
      $(this.player.moduleContainer).attr('role', 'presentation');
      $(this.player.controlBar).attr('role', 'application');
      // #. Set headline attributes
      this._setWCAGToHeadlines();
      // #. Set control buttons attributes
      this._setWCAGToControlButtons();
    }

    /**
     * @method _setWCAGToHeadlines
     * @description set WCAG attributes/events to headline element
     * @private
     */
  }, {
    key: "_setWCAGToHeadlines",
    value: function _setWCAGToHeadlines() {
      var _this = this;
      // #. Set aria-haspopup attribute to headline
      this.$headlines.attr({
        role: 'link',
        'aria-haspopup': true
      });

      // # on bind required for the streaming updates(lately rendered elements)
      $(this.player.container).off('focus', '.headline div');
      $(this.player.container).on('focus', '.headline div', function (event) {
        _this._onHeadlineFocused(event);
      });
      $(this.player.container).off('keydown');
      $(this.player.container).on('keydown', '.headline div', function (event) {
        if (event.keyCode === _keyCodes.default.ENTER) {
          $(event.target).trigger('click');
        }
      });

      // #. application role required to handle the custom keydown event(override screen reader)
      this.$headlines.parent().attr('role', 'application');
    }

    /**
     * @method _setWCAGToControlButtons
     * @description set WCAG attributes to player control button elements
     * @private
     */
  }, {
    key: "_setWCAGToControlButtons",
    value: function _setWCAGToControlButtons() {
      var attr = {
        role: 'button',
        tabindex: 0
      };

      // #. List of player control buttons
      var $buttons = [this.player.previousButton, this.player.nextButton, this.player.playButton, this.player.stopButton];
      var buttonTitles = ['news.topNews.player.previous', 'news.topNews.player.next', 'news.topNews.player.start', 'news.topNews.player.stop'];
      var self = this;
      for (var i = 0; i < $buttons.length; i++) {
        var $buttonActive = $($buttons[i]);
        // Get button title
        attr.title = window.getMessage(buttonTitles[i]);
        // #. Set the attributes
        $buttonActive.attr(attr);
        // #. Bind keydown - Enter should trigger the click event
        $buttonActive.off('keydown');
        $buttonActive.on('keydown', function (event) {
          self._onControlButtonsEventTriggered(event);
        });
        $buttonActive.off('focusout');
        $buttonActive.on('focusout', function (event) {
          $(this).removeAttr('aria-label');
        });
      }
    }

    /**
     * @method _onControlButtonsEventTriggered
     * @description handle the control button events
     * @param { KeydownEvent } event - Keyboard event
     * @private
     */
  }, {
    key: "_onControlButtonsEventTriggered",
    value: function _onControlButtonsEventTriggered(event) {
      var _this2 = this;
      if (event.keyCode === _keyCodes.default.ENTER || event.keyCode === _keyCodes.default.SPACE) {
        var $button = $(event.target);
        var triggerFocus = function triggerFocus() {
          var activeNews = _this2._getActiveNews();
          $button.blur();
          setTimeout(function () {
            $button.attr('aria-label', activeNews).focus();
          }, 50);
        };
        // #. Active element is Stop then focus will be move to Play
        if ($button.is(this.player.stopButton)) {
          this.player.stopAutoplay();
          $(this.player.playButton).css('display', 'inline').focus();
        } else
          // #. Active element is Play then focus will be move to Stop
          if ($button.is(this.player.playButton)) {
            this.player.startAutoplay();
            $(this.player.stopButton).css('display', 'inline').focus();
          } else if ($button.is(this.player.previousButton)) {
            this.player.showPrevious();
            triggerFocus();
          } else if ($button.is(this.player.nextButton)) {
            this.player.showNext();
            triggerFocus();
          }
      }
    }

    /**
     * @method _getActiveNews
     * @description get active news item
     * @private
     */
  }, {
    key: "_getActiveNews",
    value: function _getActiveNews() {
      var $activeNews = $(this.player.container).find('.pictureNewsItem').filter(function () {
        return $(this).css('visibility') === 'visible';
      });
      return $activeNews.find('.headline').text();
    }

    /**
     * @method _onHeadlineFocused
     * @description handle the headline focus event - to show the control buttons(like mouse over)
     * @param { FocusEvent } event - focus event
     * @private
     */
  }, {
    key: "_onHeadlineFocused",
    value: function _onHeadlineFocused(event) {
      // #. Stop the autoplay
      $(this.player.stopButton).click();
      // #. Show proper control buttons
      $(this.player.previousButton).css('display', 'inline');
      $(this.player.nextButton).css('display', 'inline');
      $(this.player.playButton).css('display', 'inline');
    }
  }]);
  return NewsPlayerAccessibility;
}();
var _default = exports.default = NewsPlayerAccessibility;

},{"util/enums/keyCodes":16}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * @class       : PopupSearchAccessibility
                                                                                                                                                                                                                                                                                                                                                                                               * @description : To enable the web content accessibility(WCAG) in the streaming nodes
                                                                                                                                                                                                                                                                                                                                                                                               *                NGPII-15056 - Bonds page - Ticker/ISIN field tag widgets not accessible using keyboard
                                                                                                                                                                                                                                                                                                                                                                                               * @dependencies: Jquery, KEYCODES
                                                                                                                                                                                                                                                                                                                                                                                               */
var PopupSearchAccessibility = /*#__PURE__*/function () {
  function PopupSearchAccessibility(options) {
    _classCallCheck(this, PopupSearchAccessibility);
    // #. Set accessibility config options
    this.options = options || {};
  }

  /**
   * @method init
   * @description Initialize the popup search accessibility
   * @public
   */
  _createClass(PopupSearchAccessibility, [{
    key: "init",
    value: function init() {
      this._start();
    }

    /**
     * @method _start
     * @description start the basic methods, assign attributes, bind key handler
     * @private
     */
  }, {
    key: "_start",
    value: function _start() {
      // #. check whether the search is multi-select or not
      if (this.options.multiSelect) {
        this._setMultiSelectAccessibility();
      }
    }

    /**
     * @method _setMultiSelectAccessibility
     * @description Initialize the multiselect popup search accessibility
     * @private
     */
  }, {
    key: "_setMultiSelectAccessibility",
    value: function _setMultiSelectAccessibility() {
      var _this = this;
      this.$tagContainer = $(this.options.container);
      this.$textInput = $(this.options.textField);
      this.tagSelector = '.popupsearch-tag';

      // #. Set the role to container element
      this.$tagContainer.attr('role', 'application');

      // #. bind keydown event to tag container element
      this.$tagContainer.on('keydown', this.tagSelector, function (event) {
        _this._onTagKeyHandler(event);
      });

      // #. bind keydown event to input element
      this.$textInput.on('keydown', function (event) {
        _this._oninputKeyHandler(event);
      });
    }

    /**
     * @method _setWCAGAttributes
     * @description seet necessary attributes to elements
     * @private
     */
  }, {
    key: "_setWCAGAttributes",
    value: function _setWCAGAttributes() {
      this.$tagContainer.find(this.tagSelector).attr({
        tabindex: 0
      });
    }

    /**
     * @method _onTagKeyHandler
     * @description key handler for the tag elements
     * @private
     */
  }, {
    key: "_onTagKeyHandler",
    value: function _onTagKeyHandler(event) {
      var keyCode = event.keyCode;
      var $activeTag = $(event.target);
      // #. ARROW-UP/LEFT will set the focus to previous tag
      // #. ARROW-DOWN/RIGHT will set the focus to next tag or text input
      // #. DELETE - will delete the item from the list
      if (keyCode === _keyCodes.default.ARROW_UP || keyCode === _keyCodes.default.ARROW_LEFT) {
        event.preventDefault();
        // #. get previous tag and set focus
        var $prevTag = $activeTag.prev(this.tagSelector);
        $prevTag.length > 0 && $prevTag.focus();
      } else if (keyCode === _keyCodes.default.ARROW_DOWN || keyCode === _keyCodes.default.ARROW_RIGHT) {
        event.preventDefault();
        var $nextTag = $activeTag.next(this.tagSelector);
        var $focusableEl = $nextTag.length > 0 ? $nextTag : this.$textInput;
        $focusableEl.focus();
      } else if (keyCode === _keyCodes.default.DELETE) {
        event.preventDefault();
        $activeTag.find('.remove').click();
      }
    }

    /**
     * @method _onInputKeyHandler
     * @description key handler for the input element
     * @private
     */
  }, {
    key: "_oninputKeyHandler",
    value: function _oninputKeyHandler(event) {
      var keyCode = event.keyCode;
      if (keyCode === _keyCodes.default.TAB && event.shiftKey || keyCode === _keyCodes.default.ARROW_UP || keyCode === _keyCodes.default.ARROW_LEFT) {
        event.preventDefault();
        // #. Set the attributes, inside the event because of new tag elements requires attributes
        this._setWCAGAttributes();
        // #. Handle the event
        this._onInputArrowEvent();
      }
    }

    /**
     * @method _onInputArrowEvent
     * @description on input element arrow events
     * @private
     */
  }, {
    key: "_onInputArrowEvent",
    value: function _onInputArrowEvent() {
      // #. Arrow left/up from input element will be set the focus to the last tag element
      this.$tagContainer.find(this.tagSelector).last().focus();
    }
  }]);
  return PopupSearchAccessibility;
}();
var _default = exports.default = PopupSearchAccessibility;

},{"util/enums/keyCodes":16}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * @class       : StreamingAccessibility
                                                                                                                                                                                                                                                                                                                                                                                               * @description : To enable the web content accessibility(WCAG) in the streaming nodes
                                                                                                                                                                                                                                                                                                                                                                                               *                NGPII-15978 - Enable accessibility in the ShowMessage(New Message) Icon
                                                                                                                                                                                                                                                                                                                                                                                               * @dependencies: Jquery, KEYCODES
                                                                                                                                                                                                                                                                                                                                                                                               * @references  : https://www.w3.org/TR/WCAG20-TECHS/
                                                                                                                                                                                                                                                                                                                                                                                               *                https://www.w3.org/TR/wai-aria-1.1/#tooltip
                                                                                                                                                                                                                                                                                                                                                                                               */
var StreamingAccessibility = /*#__PURE__*/function () {
  function StreamingAccessibility() {
    _classCallCheck(this, StreamingAccessibility);
    // #. To keep the news message button collection
    this.$newMessageButtons = [];
    // #. CSS selector of a new message icon element
    this.newsMessageSelector = 'a.newmessage';
  }

  /**
   * @method init
   * @description Initialize the streaming accessibility
   * @public
   */
  _createClass(StreamingAccessibility, [{
    key: "init",
    value: function init($node) {
      // #. Get news message button elements
      this.$newMessageButtons = this._findNewMessageButtons($node);
      this._start();
    }

    /**
     * @method update
     * @description Update the reloaded nodes with accessibility feature, same as init but a wrapper method
     * @public
     */
  }, {
    key: "update",
    value: function update($node) {
      // #. Get news message button elements
      this.$newMessageButtons = this._findNewMessageButtons($node);
      this._start();
    }

    /**
     * @method _start
     * @description start the basic methods, assign attributes, bind key handler
     * @private
     */
  }, {
    key: "_start",
    value: function _start() {
      // #. Check the count of the streaming nodes
      if (this.$newMessageButtons.length === 0) {
        return true;
      }

      // #. Set WCAG attributes
      this._setWCAGAttributes(this.$newMessageButtons);

      // #. Bind the keyboard accessibility event
      this._bindKeyHandler(this.$newMessageButtons);
    }

    /**
     * @method _findNewsMessageButtons
     * @description find the new message button collection from the streaming nodes collection
     * @param { HTMLCollectionOf } $nodes expecting streaming node element collection
     * @return { HTMLCollectionOf } new message button elements
     * @private
     */
  }, {
    key: "_findNewMessageButtons",
    value: function _findNewMessageButtons($nodes) {
      return $nodes.find(this.newsMessageSelector);
    }

    /**
     * @method _setWCAGAttributes
     * @description set WCAG attributes like aria-haspopup, aria-pressed to element
     * @param { HTMLCollectionOf }  { $elements } expecting html element collection
     * @private
     */
  }, {
    key: "_setWCAGAttributes",
    value: function _setWCAGAttributes($elements) {
      var hiddenTooltipContainer = $('<span></span>').attr('id', 'hiddenTooltipContainer').addClass('visuallyhidden');
      if ($('#hiddenTooltipContainer').length === 0) {
        $('body').append($(hiddenTooltipContainer));
      }
      $elements.attr({
        'aria-describedby': 'hiddenTooltipContainer'
      });

      // #. Apply role attribute to the parent table
      $elements.closest('td').attr({
        role: 'application'
      });

      // #. Update the title/arial-labelledby attributes
      this._updateShowMessageTitle($elements);
    }

    /**
     * @method _updateAttributes
     * @description update attribute of an element
     * @param { HTMLElement } $element expecting a html element
     * @param { Object } attributes expecting an object with updated attributes
     * @private
     */
  }, {
    key: "_updateAttributes",
    value: function _updateAttributes($element, attributes) {
      $element.attr(attributes);
    }

    /**
     * @method _bindKeyHandler
     * @description bind the keydown event and handle the event
     * @param { HTMLCollectionOf } $elements expecting html element collection
     * @private
     */
  }, {
    key: "_bindKeyHandler",
    value: function _bindKeyHandler($elements) {
      var _this = this;
      $elements.attr('tabindex', 0).on('keydown', function (event) {
        _this._onKeyHandlerUpdated(event);
      }).on('focus', function (event) {
        _this._onFocusHandlerUpdate(event);
      }).on('blur', function (event) {
        _this._onTabKeyPressed(event);
      });
    }

    /**
     * @method _onKeyHandlerUpdated
     * @description handle the keydown event
     * @param Event#keydown expecting keydown event object
     * @private
     */
  }, {
    key: "_onKeyHandlerUpdated",
    value: function _onKeyHandlerUpdated(event) {
      var keyCode = event.keyCode;
      if (keyCode === _keyCodes.default.TAB) {
        this._onTabKeyPressed(event);
      }
    }
  }, {
    key: "_onFocusHandlerUpdate",
    value: function _onFocusHandlerUpdate(event) {
      // #. Get the active element
      var $element = $(event.target);
      // #. Call the trigger event
      $element.attr({
        'aria-describedby': 'ngpTooltipNews'
      });
      this._triggerEvent($element, 'mouseover', event);
    }

    /**
     * @method _onTabKeyPressed
     * @description handle the tab key
     * @param Event#keydown expecting keydown event object
     * @private
     */
  }, {
    key: "_onTabKeyPressed",
    value: function _onTabKeyPressed(event) {
      // #. Get the active element
      var $element = $(event.target);
      // #. Call the trigger event
      this._triggerEvent($element, 'mouseout', event);
      $('#hiddenTooltipContainer').remove();
    }

    /**
     * @method _getStreamingContext
     * @description get streaming context if element is replaced with illustrate method
     * @param { HTMLElement } $element expecting current active element
     * @private
     */
  }, {
    key: "_getStreamingContext",
    value: function _getStreamingContext($element) {
      return $element.data('streaming-context');
    }

    /**
     * @method _triggerEvent
     * @description trigger event based on element environment
     * @param { HTMLElement } $element expecting current active element
     * @private
     */
  }, {
    key: "_triggerEvent",
    value: function _triggerEvent($element, eventName, event) {
      var streamingContext = this._getStreamingContext($element);
      /**
       * illustrateStreaming method from LastNewsFormatter replace the news message icon
       * mouseout event not available to this newly created element
       * keep the context as data attribute and invoke the hide tooltip method explicitly
       */
      if (streamingContext && streamingContext.hideInfo && eventName === 'mouseout') {
        streamingContext.hideInfo(event);
      } else {
        // #. Trigger the element event
        $element.trigger(eventName);
      }
    }

    /**
     * @method _updateShowMessageTitle
     * @description update show message title/arial-labelledby with the instrument name
     * @param { HTMLCollectionOf } $elements expecting collection of html element objects
     * @private
     */
  }, {
    key: "_updateShowMessageTitle",
    value: function _updateShowMessageTitle($elements) {
      var _iterator = _createForOfIteratorHelper($elements),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var $element = _step.value;
          $element = $($element);
          var title = this._getInstrumentNameByRow($element) || '';

          // #. Update the title with the instrument name in the row
          title = window.getMessage('title.streaming.showMessage', title);
          $element.attr('aria-label', title);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    /**
     * @method _getInstrumentNameByRow
     * @description get the instrument name by the element closest row
     * @param { HTMLElement } $element expecting an HTML element
     * @private
     */
  }, {
    key: "_getInstrumentNameByRow",
    value: function _getInstrumentNameByRow($element) {
      var $row = $($element.closest('tr'));
      return $row.find('a.instrumentIdentification').text() || $row.find('span.instrumentIdentification').text() || $row.find('input.searchPopupInput').val() || $row.find('a').first().text();
    }
  }]);
  return StreamingAccessibility;
}(); // #. Export the class
var _default = exports.default = StreamingAccessibility;

},{"util/enums/keyCodes":16}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
var _tabmenuAccessibility = require("aria/tabmenuAccessibility");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * @class       : TooltipAccessibility
                                                                                                                                                                                                                                                                                                                                                                                               * @description : To enable the web content accessibility(WCAG) in ngp application tooltip views
                                                                                                                                                                                                                                                                                                                                                                                               *                - NGPII-15117 Keyboard: QuickView Panel
                                                                                                                                                                                                                                                                                                                                                                                               * @dependencies: Jquery
                                                                                                                                                                                                                                                                                                                                                                                               * @references  : https://www.w3.org/TR/wai-aria-practices-1.1/examples/accordion/accordion.html
                                                                                                                                                                                                                                                                                                                                                                                               */
var TooltipAccessibility = /*#__PURE__*/function () {
  function TooltipAccessibility(options) {
    _classCallCheck(this, TooltipAccessibility);
    // #. Keep the config/options into context
    this.options = options;

    // #. Active element Identity
    this.ACTIVE_ELEMENT = {
      PANEL: 1,
      CHART: 2,
      CLOSE_BUTTON: 3,
      FIRST_MENU_ITEM: 4,
      FIRST_HEADER_BUTTON: 5,
      NEWS: 6
    };

    // #. Quick view menu identity
    this.QUICK_VIEW_MENU = {
      CHART: '#quickViewMenu\\.chart',
      RATIO: '#quickViewMenu\\.ratios',
      NEWS: '#quickViewMenu\\.news'
    };

    // #. Session storage key
    this.sessionKey = 'quick-panel-status';
  }

  /**
   * @method init
   * @description Initialize the tooltip/tooltip-target accessibility
   * @public
   */
  _createClass(TooltipAccessibility, [{
    key: "$quickView",
    get:
    // #. Quick view container selector
    function get() {
      return $('#ngpQuickview');
    }

    // #. Keep the quick view header
  }, {
    key: "$quickViewHeader",
    get: function get() {
      return this.$quickView.find('#quickViewHeader');
    }

    // #. Keep the quick view body
  }, {
    key: "$quickViewBody",
    get: function get() {
      return this.$quickView.find('#quickViewBody');
    }

    // #. Get the active element from dom
  }, {
    key: "$activeElement",
    get: function get() {
      return $(document.activeElement);
    }

    // #. Get first menu item from the body
  }, {
    key: "$firstMenuItem",
    get: function get() {
      return this.$quickViewBody.find('.menuItem.first button');
    }

    // #. Get last menu item from the body
  }, {
    key: "$lastMenuItem",
    get: function get() {
      return this.$quickViewBody.find('.menuItem button').last();
    }

    // #. Get chart container
  }, {
    key: "$chartContainer",
    get: function get() {
      return this.$quickViewBody.find('.highcharts-container');
    }

    // #. News table
  }, {
    key: "$newsTable",
    get: function get() {
      return this.$quickViewBody.find('#news_table');
    }

    // #. Get all button elements from header
  }, {
    key: "$headerButtons",
    get: function get() {
      return this.$quickViewHeader.find('.menu li.link');
    }

    // #. Get first button element from header
  }, {
    key: "$firstHeaderButton",
    get: function get() {
      return this.$headerButtons.first();
    }

    // #. Get close button
  }, {
    key: "$closeButton",
    get: function get() {
      return this.$quickViewHeader.find('#quickViewClose');
    }

    // #. Get aria-describedby element for the target
  }, {
    key: "$descriptionElement",
    get: function get() {
      var id = 'quick-view-target-desc';
      var $element = $('body').find("#".concat(id));
      // #. no hint element found, create a new one
      if ($element.length === 0) {
        $element = $('<span></span>').attr({
          id: id
        }).addClass('visuallyhidden').appendTo('body');
      }
      return $element;
    }

    // #. get focus status from session storage
  }, {
    key: "panelFocusStatus",
    get: function get() {
      return sessionStorage ? sessionStorage.getItem(this.sessionKey) : '0';
    }

    // #. set focus status to session storage
    ,
    set: function set(value) {
      sessionStorage && sessionStorage.setItem(this.sessionKey, value);
    }
  }, {
    key: "init",
    value: function init() {
      if (this.options.target) {
        this._bindTargetAccessibility();
      } else if (this.options.container) {
        this._bindPanelAccessibility();
        this._addAccessibilityAttributes();
        this._bindMenuItemLinkKeyHandler();
      }
    }

    /**
     * @method _bindTargetAccessibility
     * @description bind accessibility to the tooltip target
     * @private
     */
  }, {
    key: "_bindTargetAccessibility",
    value: function _bindTargetAccessibility() {
      var _this = this;
      $(window.document).on('tooltip-target-focus', this.options.target.selector, function (event, data) {
        if (data && data.panelFocusStatus) {
          _this.panelFocusStatus = data.panelFocusStatus;
        }
        event.currentTarget.focus();
      });
      // #. bind target focus - to trigger the mouseenter
      $(window.document).on('focusin', this.options.target.selector, function (event) {
        if (String($(event.target).attr(_this.options.target.attr)).includes(_this.options.target.contains)) {
          var $target = $(event.target);
          // #. Update the panel description text
          _this.$descriptionElement.text(window.getMessage('quickview.target.shortcut.title', $target.text()));
          // #. Set the attributes to target
          $target.attr({
            role: 'application',
            'aria-describedby': _this.$descriptionElement.attr('id')
          });
          window.setTimeout(function () {
            event.preventDefault();
            var status = _this.panelFocusStatus;
            if (status !== '1') {
              $target.trigger('mouseenter');
            }
            _this.panelFocusStatus = '1';
          }, 50);
        }
      });

      // #. bind target focusout - to manage the hide attr
      $(window.document).on('focusout', this.options.target.selector, function (event) {
        _this.panelFocusStatus = '0';
      });

      // #. bind target keydown event
      $(window.document).on('keydown', this.options.target.selector, function (event) {
        if (String($(event.target).attr(_this.options.target.attr)).includes(_this.options.target.contains)) {
          _this._onTargetKeyHandler(event);
        }
      });
    }

    /**
     * @method _onTargetKeyHandler
     * @description handle keydown of the tooltip target
     * @param { KeyboardEvent } event: keydown event
     * @private
     */
  }, {
    key: "_onTargetKeyHandler",
    value: function _onTargetKeyHandler(event) {
      var keyCode = event.keyCode;

      // #. Handle the keydown
      // #. Tab - will hide the quick view panel
      // #. ARR-LEFT - will set the focus to quick view panel
      if (keyCode === _keyCodes.default.TAB) {
        this._hideTooltip(false);
      } else if (keyCode === _keyCodes.default.ARROW_RIGHT) {
        this.$quickView.attr({
          tabindex: 0
        }).focus();
        this._setPanelWCAGRoles();
      }
    }

    /**
     * @method _setPanelWCAGRoles
     * @description set WCAG roles to the panel elements
     * @private
     */
  }, {
    key: "_setPanelWCAGRoles",
    value: function _setPanelWCAGRoles() {
      // #. Update the quick view tab menu accessibility
      var $menu = this.$quickView.find('div.moduleTabMenu div.menu');
      $menu.find('button.icon').attr('role', 'tab');
      (0, _tabmenuAccessibility.setAriaAttributesToModuleTabMenu)($menu);

      // #. Set live region roles
      this.$quickView.find('.moduleContent').attr('aria-live', 'polite');
    }

    /**
     * @method _bindPanelAccessibility
     * @description bind quick view panel accessibility
     * @private
     */
  }, {
    key: "_bindPanelAccessibility",
    value: function _bindPanelAccessibility() {
      var _this2 = this;
      // #. unbind the previously added event
      this.$quickView.off('keydown');
      // #. Bind keydown
      this.$quickView.attr('role', 'tooltip');
      this.$quickView.on('keydown', function (event) {
        _this2._onPanelKeyHandler(event);
      });
    }

    /**
     * @method _addAccessibilityAttributes
     * @description add necessary attributes to panel elements
     * @private
     */
  }, {
    key: "_addAccessibilityAttributes",
    value: function _addAccessibilityAttributes() {
      var _iterator = _createForOfIteratorHelper(this.$headerButtons),
        _step;
      try {
        var _loop = function _loop() {
          var $button = _step.value;
          $button = $($button);
          $button.attr({
            tabindex: 0,
            role: 'button'
          });

          // #. set the default pressed value
          $button.attr('aria-pressed', $button.hasClass('selected'));

          // Handle pressed attr on click event
          $button.on('click', function (event) {
            $button.attr('aria-pressed', $button.hasClass('selected'));
          });
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    /**
     * @method _bindMenuItemLinkKeyHandler
     * @description trigger menu item link click by using keyboard
     * @private
     */
  }, {
    key: "_bindMenuItemLinkKeyHandler",
    value: function _bindMenuItemLinkKeyHandler() {
      this.$headerButtons.on('keydown', function (event) {
        var keyCode = event.keyCode;
        if (keyCode === _keyCodes.default.SPACE || keyCode === _keyCodes.default.ENTER) {
          event.preventDefault();
          $(event.target).click();
        }
      });
    }

    /**
     * @method _onPanelKeyHandler
     * @description panel keydown event handler
     * @param { KeyboardEvent } event: keydown event
     * @private
     */
  }, {
    key: "_onPanelKeyHandler",
    value: function _onPanelKeyHandler(event) {
      var keyCode = event.keyCode;
      switch (keyCode) {
        case _keyCodes.default.TAB:
          this._onPanelTabKeyPressed(event);
          break;
        case _keyCodes.default.ARROW_LEFT:
        case _keyCodes.default.ESCAPE:
          this._hideTooltip(true);
          break;
        case _keyCodes.default.ARROW_DOWN:
          this._onPanelArrowDownPressed(event);
          break;
        case _keyCodes.default.ARROW_UP:
          this._onPanelArrowUpPressed(event);
          break;
      }
    }

    /**
     * @method _onPanelTabKeyPressed
     * @description handle tab key
     * @param { KeyboardEvent } event: keydown event
     * @private
     */
  }, {
    key: "_onPanelTabKeyPressed",
    value: function _onPanelTabKeyPressed(event) {
      var identity = this._getActiveElementIdentity();
      var result = false;
      switch (identity) {
        case this.ACTIVE_ELEMENT.PANEL:
          event.preventDefault();
          this._setFocusToActiveItemPart(false);
          break;
        case this.ACTIVE_ELEMENT.CHART:
          event.preventDefault();
          this.$chartContainer.blur();
          if (!event.shiftKey) {
            this._setFocusToRatio();
          } else {
            this.$lastMenuItem.focus();
          }
          break;
        case this.ACTIVE_ELEMENT.NEWS:
          event.preventDefault();
          if (!event.shiftKey) {
            this.$firstHeaderButton.focus();
          } else {
            this._setFocusToRatio(true);
          }
          break;
        case this.ACTIVE_ELEMENT.CLOSE_BUTTON:
          if (!event.shiftKey) {
            event.preventDefault();
            this._setFocusToActiveItemPart(false);
          }
          break;
        case this.ACTIVE_ELEMENT.FIRST_MENU_ITEM:
          result = true;
          if (event.shiftKey) {
            event.preventDefault();
            this.$closeButton.focus();
            result = false;
          }
          break;
        case this.ACTIVE_ELEMENT.FIRST_HEADER_BUTTON:
          if (event.shiftKey) {
            event.preventDefault();
            this._setFocusToActiveItemPart(true);
          }
          break;
        default:
          result = true;
          break;
      }
      return result;
    }

    /**
     * @method _onPanelArrowUpPressed
     * @description handle panel arrow up key
     * @param { KeyboardEvent } event: keydown event
     * @private
     */
  }, {
    key: "_onPanelArrowUpPressed",
    value: function _onPanelArrowUpPressed(event) {
      var identity = this._getActiveElementIdentity();
      if (identity === this.ACTIVE_ELEMENT.NEWS) {
        event.preventDefault();
        // #. Get active row
        var $activeRow = this.$activeElement;
        // #. Get all table rows except header
        var $rows = this.$newsTable.find('tr').not(':first');
        // #. Variable to keep the previous row
        var $row = null;
        // 1. If no rows selected yet, focus to last row
        // 2. If row is first row then, last row will select
        // 3. prev - select the previous row
        if (!$activeRow.is('tr')) {
          $row = $rows.last();
        } else if ($activeRow.is('tr')) {
          if ($activeRow.is($rows.first())) {
            $row = $rows.last();
          } else {
            $row = $activeRow.prev();
          }
        }
        if ($row) {
          $row.focus();
        }
      }
    }

    /**
     * @method _onPanelArrowDownPressed
     * @description handle arrow down key
     * @param { KeyboardEvent } event: keydown event
     * @private
     */
  }, {
    key: "_onPanelArrowDownPressed",
    value: function _onPanelArrowDownPressed(event) {
      var identity = this._getActiveElementIdentity();
      // #. Handle news table arrow down
      if (identity === this.ACTIVE_ELEMENT.NEWS) {
        event.preventDefault();
        // #. Get active row
        var $activeRow = this.$activeElement;
        // #. Get all table rows except header
        var $rows = this.$newsTable.find('tr').not(':first');
        // #. Variable to keep the next row
        var $row = null;
        // 1. If no rows selected yet, focus to first row
        // 2. If row is last row then, first row will select
        // 3. next - select next row
        if (!$activeRow.is('tr')) {
          $row = $rows.first();
        } else if ($activeRow.is('tr')) {
          if ($activeRow.is($rows.last())) {
            $row = $rows.first();
          } else {
            $row = $activeRow.next();
          }
        }
        if ($row) {
          $row.focus();
        }
      }
    }

    /**
    * @method _hideTooltip
    * @description hide the tooltip panel
    * @param { boolean } setFocusToTarget: to identify set focus to target element
    * @private
    */
  }, {
    key: "_hideTooltip",
    value: function _hideTooltip(setFocusToTarget) {
      this.$closeButton.trigger('click');
      if (this.options.$target) {
        var $target = $(this.options.$target);
        if (setFocusToTarget) {
          this.panelFocusStatus = '1';
          $target.focus();
        }
      }
    }

    /**
     * @method _getActiveElementIdentity
     * @description get active element identity
     * @private
     */
  }, {
    key: "_getActiveElementIdentity",
    value: function _getActiveElementIdentity() {
      var $activeElement = this.$activeElement;
      if ($activeElement.is(this.$quickView)) {
        return this.ACTIVE_ELEMENT.PANEL;
      } else if ($activeElement.is(this.$closeButton)) {
        return this.ACTIVE_ELEMENT.CLOSE_BUTTON;
      } else if ($activeElement.is(this.$firstMenuItem)) {
        return this.ACTIVE_ELEMENT.FIRST_MENU_ITEM;
      } else if ($activeElement.is(this.$chartContainer) || $activeElement.closest(this.$chartContainer).length > 0 || $activeElement.closest('.chartImageBox').length > 0) {
        return this.ACTIVE_ELEMENT.CHART;
      } else if ($activeElement.is(this.$firstHeaderButton)) {
        return this.ACTIVE_ELEMENT.FIRST_HEADER_BUTTON;
      } else if ($activeElement.is(this.$newsTable) || $activeElement.closest(this.$newsTable).length > 0) {
        return this.ACTIVE_ELEMENT.NEWS;
      }
    }

    /**
     * @method _getFirstSelectedPart
     * @description get first selected parts identity
     * @private
     */
  }, {
    key: "_getFirstSelectedPart",
    value: function _getFirstSelectedPart() {
      var selected = 'selected';
      if (this.$quickViewHeader.find(this.QUICK_VIEW_MENU.CHART).hasClass(selected)) {
        return this.QUICK_VIEW_MENU.CHART;
      } else if (this.$quickViewHeader.find(this.QUICK_VIEW_MENU.RATIO).hasClass(selected)) {
        return this.QUICK_VIEW_MENU.RATIO;
      } else if (this.$quickViewHeader.find(this.QUICK_VIEW_MENU.NEWS).hasClass(selected)) {
        return this.QUICK_VIEW_MENU.NEWS;
      }
    }

    /**
     * @method _getLastSelectedPart
     * @description get last selected parts identity
     * @private
     */
  }, {
    key: "_getLastSelectedPart",
    value: function _getLastSelectedPart() {
      var selected = 'selected';
      if (this.$quickViewHeader.find(this.QUICK_VIEW_MENU.NEWS).hasClass(selected)) {
        return this.QUICK_VIEW_MENU.NEWS;
      } else if (this.$quickViewHeader.find(this.QUICK_VIEW_MENU.RATIO).hasClass(selected)) {
        return this.QUICK_VIEW_MENU.RATIO;
      } else if (this.$quickViewHeader.find(this.QUICK_VIEW_MENU.CHART).hasClass(selected)) {
        return this.QUICK_VIEW_MENU.CHART;
      }
    }

    /**
     * @method _setFocusToActiveItemPart
     * @description set focus to the first active item in the panel
     * @param { Boolean } chooseLastPart - to identify the last/first part
     * @private
     */
  }, {
    key: "_setFocusToActiveItemPart",
    value: function _setFocusToActiveItemPart(chooseLastPart) {
      var partId = chooseLastPart ? this._getLastSelectedPart() : this._getFirstSelectedPart();
      switch (partId) {
        case this.QUICK_VIEW_MENU.CHART:
          if (chooseLastPart) {
            this._setFocusToChart();
          } else {
            this._setFocusToChartMenuItem();
          }
          break;
        case this.QUICK_VIEW_MENU.NEWS:
          this._setFocusToNews();
          break;
        case this.QUICK_VIEW_MENU.RATIO:
          this._setFocusToRatio(chooseLastPart);
          break;
        default:
          this.$firstHeaderButton.focus();
          break;
      }
    }

    /**
     * @method _setFocusToChartMenuItem
     * @description set focus to the chart menu item in the body
     * @private
     */
  }, {
    key: "_setFocusToChartMenuItem",
    value: function _setFocusToChartMenuItem() {
      this.$firstMenuItem.focus();
    }

    /**
     * @method _setFocusToNews
     * @description set focus to news table
     * @private
     */
  }, {
    key: "_setFocusToNews",
    value: function _setFocusToNews() {
      this._setNewsTableAccessibility();
      this.$newsTable.focus();
    }

    /**
     * @method _setFocusToRatio
     * @description ration view has no focusable elements, so focus may set to news or header buttons
     * @param { boolean } isShiftKey: identify shift key pressed or not
     * @private
     */
  }, {
    key: "_setFocusToRatio",
    value: function _setFocusToRatio(isShiftKey) {
      var selected = 'selected';
      if (isShiftKey) {
        if ($(this.QUICK_VIEW_MENU.CHART).hasClass(selected)) {
          this._setFocusToChart();
        } else {
          this.$closeButton.focus();
        }
      } else {
        // #. 1. If news selected - focus will be set to news table
        // #. 2. else the focus set to quick view chart button element
        if ($(this.QUICK_VIEW_MENU.NEWS).hasClass(selected)) {
          this._setFocusToNews();
        } else {
          this.$firstHeaderButton.focus();
        }
      }
    }

    /**
     * @method _setFocusToChart
     * @description set focus to the chart container
     * @private
     */
  }, {
    key: "_setFocusToChart",
    value: function _setFocusToChart() {
      this.$chartContainer.focus();
    }

    /**
     * @method _setNewsTableAccessibility
     * @description set news table accessibility
     * @private
     */
  }, {
    key: "_setNewsTableAccessibility",
    value: function _setNewsTableAccessibility() {
      // #. Set table
      this.$newsTable.attr({
        tabindex: 0
      });
      this.$newsTable.parent().attr({
        role: 'application'
      });

      // #. Set table row
      this.$newsTable.find('tr').attr({
        tabindex: 0,
        role: 'button'
      });
    }
  }]);
  return TooltipAccessibility;
}();
var _default = exports.default = TooltipAccessibility;

},{"aria/tabmenuAccessibility":10,"util/enums/keyCodes":16}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAriaAttributesToModuleTabMenu = void 0;
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * set aria attributes to moduletabmenus
 */
var setAriaAttributesToModuleTabMenu = exports.setAriaAttributesToModuleTabMenu = function setAriaAttributesToModuleTabMenu($menu) {
  var moduleTabMenus = $menu || $('div.moduleTabMenu div.menu');
  setAttributes(moduleTabMenus);
};

/**
 * set aria attributes to tablist and tabpanel for all tab menus on the page with tab buttons inside
 * @param menus
 */
var setAttributes = function setAttributes(menus) {
  $(menus).each(function (index, menu) {
    if ($(menu).find('button.icon').length > 0) {
      setAttributesToTablist(menu);
    }
  });
};

/**
 * set attributes to module tab menu elements by given tab menu
 * @param menu
 */
var setAttributesToTablist = function setAttributesToTablist(menu) {
  // todo get module title without timeout
  window.setTimeout(function () {
    // timeout because of loading... text at the beginning
    var moduleTitle = $(menu).closest('div.module').find('div.moduleHeader h2');
    $(menu).attr('role', 'tablist');
    $(menu).attr('aria-label', $(moduleTitle).text());
  }, 2000);
  setAriaAttributesToButtons($(menu));
};

/**
 * set attributes to tab buttons to given tab menu
 * @param menu
 */
var setAriaAttributesToButtons = function setAriaAttributesToButtons(menu) {
  var tabMenu = menu;
  var menuItems = $(tabMenu).find('div.menuItem');
  $(tabMenu).find('button').each(function (index, button) {
    $(button).attr('role', 'tab').attr('aria-selected', false).on('keydown', function (e) {
      if (e.keyCode === _keyCodes.default.ENTER || e.keyCode === _keyCodes.default.SPACE) {
        updateTabButtons(tabMenu, e.target);
      }
    }).on('click', function (e) {
      updateTabButtons(tabMenu, e.target);
    });
  });
  $(menuItems).each(function (index, item) {
    if ($(item).hasClass('on')) {
      setTabButtonSelected($(item).find('button'));
      return true;
    }
  });
};

/**
 * update attributes of tab buttons
 * @param menu
 * @param pressedBtn
 */
var updateTabButtons = function updateTabButtons(menu, pressedBtn) {
  var menuItemButtons = $(pressedBtn).parent('.menuItem').parent().find('> .menuItem button');
  menuItemButtons.attr('aria-selected', false).removeAttr('tabindex');
  setTabButtonSelected(pressedBtn);
};

/**
 * set given button as selected
 * @param button
 */
var setTabButtonSelected = function setTabButtonSelected(button) {
  $(button).attr({
    'aria-selected': true,
    tabindex: -1
  });
};

},{"util/enums/keyCodes":16}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerMessages = exports.getMessage = exports.addMessage = void 0;
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/** @module messages/messageHandler */

//use an object in window as cache, in order to prevent multiple instances of the cache
window.__messagesCache = window.__messagesCache || {};
var messages = window.__messagesCache;

/**
 * adds a message object with key value pairs for translation
 * @param {Object} msg
 */
var registerMessages = exports.registerMessages = function registerMessages(msg) {
  Object.assign(messages, msg);
};

/**
 * adds a message to the global message cache for translation
 * @param {string} key
 * @param {string} value
 */
var addMessage = exports.addMessage = function addMessage(key, value) {
  messages[key] = value;
};

/**
 * translates a given key and replaces {0}..{n} with the respective replacements
 * @param {string} key
 * @param {...string} replacements
 * @returns {string}
 * @example
 * addMessage('example', 'example {0} of {1}')
 * getMessage('example', '4', 'many');
 * // --> 'example 4 of many'
 * getMessage('example', ['2', '6']);
 * // --> 'example 2 of 6'
 */
var getMessage = exports.getMessage = function getMessage(key) {
  var _ref;
  for (var _len = arguments.length, replacements = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    replacements[_key - 1] = arguments[_key];
  }
  replacements = (_ref = []).concat.apply(_ref, _toConsumableArray(replacements));
  var message = messages[key] || key.split('.').reduce(function (all, a) {
    return a;
  }, '');
  message = message.replace(/\{(\d)\}/g, function (match, id) {
    return replacements[+id] != null ? replacements[+id] : match;
  });
  return message;
};
window.registerMessages = registerMessages;
window.getMessage = getMessage;
window.addMessage = addMessage;

},{}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _awaitAsyncGenerator(e) { return new _OverloadYield(e, 0); }
function _wrapAsyncGenerator(fn) { return function () { return new _AsyncGenerator(fn.apply(this, arguments)); }; }
function _AsyncGenerator(e) { var r, t; function resume(r, t) { try { var n = e[r](t), o = n.value, u = o instanceof _OverloadYield; Promise.resolve(u ? o.v : o).then(function (t) { if (u) { var i = "return" === r ? "return" : "next"; if (!o.k || t.done) return resume(i, t); t = e[i](t).value; } settle(n.done ? "return" : "normal", t); }, function (e) { resume("throw", e); }); } catch (e) { settle("throw", e); } } function settle(e, n) { switch (e) { case "return": r.resolve({ value: n, done: !0 }); break; case "throw": r.reject(n); break; default: r.resolve({ value: n, done: !1 }); } (r = r.next) ? resume(r.key, r.arg) : t = null; } this._invoke = function (e, n) { return new Promise(function (o, u) { var i = { key: e, arg: n, resolve: o, reject: u, next: null }; t ? t = t.next = i : (r = t = i, resume(e, n)); }); }, "function" != typeof e.return && (this.return = void 0); }
_AsyncGenerator.prototype["function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator"] = function () { return this; }, _AsyncGenerator.prototype.next = function (e) { return this._invoke("next", e); }, _AsyncGenerator.prototype.throw = function (e) { return this._invoke("throw", e); }, _AsyncGenerator.prototype.return = function (e) { return this._invoke("return", e); };
function _OverloadYield(t, e) { this.v = t, this.k = e; }
var MIN_BUFFER_LENGTH = 200;
var MIN_RENDER_PARALLEL = 2;
var MAX_RENDER_PARALLEL = 4;
var AjaxConnector = /*#__PURE__*/function () {
  /**
   * Adapter for coverting the polling mechanisem into a pull based stream (Async Iterator)
   * @constructor
   * @param {function} pollFunc - wrapped poll function, it should call onUpdate internally
   */
  function AjaxConnector(pollFunc, pollingIntervall) {
    _classCallCheck(this, AjaxConnector);
    this.pollingIntervall = pollingIntervall;
    this.pollFunc = pollFunc;
    this.buffer = [];
    this.lastPoll = null;
    this.lastUpdateSize = 0;
    this.wake = function () {};
  }
  _createClass(AjaxConnector, [{
    key: "getLastUpdateSize",
    value: function getLastUpdateSize() {
      return this.lastUpdateSize;
    }

    /**
     * Returns N contiguous chunks of updates with the same RIC
     * @private
     * @param {number} count - how many contiguous chunks should be returned
     */
  }, {
    key: "_getContiguousRicUpdates",
    value: function _getContiguousRicUpdates() {
      var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var first = this.buffer[0];
      var updates = [first];
      var lastRic = first.ric;
      var i = 1;
      for (var x = 0; i < this.buffer.length && x < count; x++) {
        while (i < this.buffer.length) {
          var update = this.buffer[i];
          if (update.ric === lastRic) {
            updates.push(update);
          } else {
            lastRic = update.ric;
            break;
          }
          i++;
        }
      }
      this.buffer = this.buffer.slice(i);
      return updates;
    }
  }, {
    key: "_pollThrottled",
    value: function _pollThrottled() {
      var now, diff, timeToSleep;
      return _regeneratorRuntime().async(function _pollThrottled$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(this.lastPoll != null)) {
              _context.next = 13;
              break;
            }
            now = Date.now();
            diff = now - this.lastPoll;
            if (!(diff >= this.pollingIntervall)) {
              _context.next = 8;
              break;
            }
            this.pollFunc();
            this.lastPoll = Date.now();
            _context.next = 11;
            break;
          case 8:
            timeToSleep = this.pollingIntervall - diff;
            _context.next = 11;
            return _regeneratorRuntime().awrap(this.sleep(timeToSleep));
          case 11:
            _context.next = 15;
            break;
          case 13:
            this.lastPoll = Date.now();
            this.pollFunc();
          case 15:
          case "end":
            return _context.stop();
        }
      }, null, this, null, Promise);
    }
  }, {
    key: "sleep",
    value: function sleep(timeToSleep) {
      var _this2 = this;
      return new Promise(function (resolve, reject) {
        var wakeHandle = setTimeout(resolve, timeToSleep);
        _this2.wake = function () {
          clearTimeout(wakeHandle);
          resolve();
        };
      });
    }
  }, {
    key: "iter",
    value: function iter() {
      var _this = this;
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var parallelUpdateCnt;
        return _regeneratorRuntime().wrap(function _callee$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!true) {
                _context2.next = 12;
                break;
              }
              if (_this.buffer.length < MIN_BUFFER_LENGTH) {
                _this._pollThrottled();
              }
              if (!_this.buffer.length) {
                _context2.next = 8;
                break;
              }
              // Randomise how many updates should be rendered at once
              parallelUpdateCnt = Math.floor(Math.random() * MAX_RENDER_PARALLEL) + MIN_RENDER_PARALLEL;
              _context2.next = 6;
              return _this._getContiguousRicUpdates(parallelUpdateCnt);
            case 6:
              _context2.next = 10;
              break;
            case 8:
              _context2.next = 10;
              return _awaitAsyncGenerator(_this._pollThrottled());
            case 10:
              _context2.next = 0;
              break;
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee);
      }))();
    }
  }, {
    key: "onUpdate",
    value: function onUpdate(updates) {
      this.lastUpdateSize = updates ? updates.length : 0;
      if (updates && updates.length) {
        if (this.buffer.length) {
          this.buffer = this.buffer.concat(updates);
        } else {
          this.buffer = updates;
        }
      }
      this.wake();
    }
  }]);
  return AjaxConnector;
}();
var _default = exports.default = AjaxConnector;

},{}],13:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _StreamingInfo = _interopRequireDefault(require("streaming/StreamingInfo"));
var _Accessibility = _interopRequireDefault(require("accessibility/Accessibility"));
var _AjaxConnector = _interopRequireDefault(require("./AjaxConnector"));
var _StreamingRenderer = _interopRequireDefault(require("./StreamingRenderer"));
var _throttle = _interopRequireDefault(require("lodash/throttle"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var YAHOO = window.YAHOO;
var Dom = window.Dom;

/*
 * html Streaming through javascript dom updates. This is a quite flexible
 * interface.
 */

/*
 * returns a string that is usefull as timestamp for logging entries in the javascript
 * frontend. The string will look something like '23:59:59.12' with the last two digits
 * being the hundredth of the seconds.
 * @param date optional parameter when another date then the current one should be used
 * @return a timestamp formatted for logging.
 */
var getLogTimestamp = function getLogTimestamp(date) {
  date = date || new Date();
  var _map = [date.getHours(), date.getMinutes(), date.getSeconds(), parseInt(date.getMilliseconds() / 10, 10)].map(function (number) {
      return "0".concat(number).substr(-2);
    }),
    _map2 = _slicedToArray(_map, 4),
    hours = _map2[0],
    minutes = _map2[1],
    seconds = _map2[2],
    millis = _map2[3];
  return "".concat(hours, ":").concat(minutes, ":").concat(seconds, ".").concat(millis);
};
var debugLog = [];
var maxlogLength = 300;
var logDebug = function logDebug(level, string) {
  if (window.jsdebug) {
    debugLog.push([level, getLogTimestamp(), string]);
    if (maxlogLength && debugLog.length > maxlogLength) {
      // keep the last 300 entries and remove everything before that
      debugLog = debugLog.slice(-300);
    }
  }
};
var showDebugLog = function showDebugLog() {
  console.groupCollapsed('Streaming debug log dump');
  debugLog.map(function (_ref) {
    var _console;
    var _ref2 = _toArray(_ref),
      level = _ref2[0],
      infos = _ref2.slice(1);
    return (_console = console)[level].apply(_console, _toConsumableArray(infos));
  });
  console.groupEnd();
};
var saveData = function saveData(data, fileName) {
  var a = document.createElement("a");
  document.body.appendChild(a);
  a.style = "display: none";
  var blob = new Blob([data], {
      type: "octet/stream"
    }),
    url = window.URL.createObjectURL(blob);
  a.href = url;
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(url);
  a.remove();
};
window.startRecordTicks = function () {
  maxlogLength = 0;
};
window.downloadRecordedTicks = function () {
  var data = debugLog.map(function (d) {
    return d.join('~');
  }).join('\r\n');
  saveData(data, "jslog_".concat(new Date().getTime(), ".txt"));
  debugLog = [];
  maxlogLength = 300;
};

/*
 * a sort of hashmap for streaming nodes mapped with rics. Should not be touched from outside.
 */
var nodeMap = {};
var Streaming = {
  /*
   * count the offscreen illustrations for log reasons
   */
  offscreenIllustrations: 0,
  /*
  * count unknown ric fid updates for log reasons
  */
  unknownUpdates: 0,
  /*
   * count unimplemented updates that are not illustrated yet.
   */
  unimplementedUpdates: 0,
  /*
   * count unimplemented updates that are not illustrated yet.
   */
  emptyUpdates: 0,
  /*
   * a boolean flag indicating whether the streaming is currently paused or not
   */
  paused: false,
  /*
   * whether the ric fid pairs have been already registered to the streaming service or not
   */
  registered: false,
  /*
   * maximum number of rics updated together before giving some time to the browser
   */
  updateDisplayRate: 10,
  /*
   * this integer number is the amount of miliseconds the streaming will stay idle
   * minimum in between displaying updates. This is very important for large pages,
   * because at a point the streaming does not manage to display all updates and then
   * the browser will be stuck with no reaction any more.
   */
  minDelayBetweenUpdates: 3,
  /*
   * maximum time in milliseconds, the streaming service is allowed to delay updates,
   * when polling is used. The streaming service will be continously asked for updates
   * and the idle times in between displaying updates are set so, that the updates look like a
   * smooth flow of data. This only works if there are no longer breaks in between updates than this
   * polling intervall. So on one hand setting this value to small number (around 1000) will result
   * in less delay, but on the other side, updates will be displayed in a more pull-like manner,
   * always a bunch of them together with a gap in between the next ones.
   */
  pollingIntervall: 4000,
  /*
   * the maximum number of simultaneous ric fid pairs to be registered to the streaming service
   */
  maxFieldsPerRegistration: 1000,
  /*
   * the maximum number of items on the page, that streaming will be registered for
   */
  maxItemsPerPage: 20000,
  /*
   * nodes that do not get an animation, will be appended to that list and then cleared all together.
   */
  nodesToClear: [],
  /*
   * the reference to the image to display the streaming status with.
   */
  statusImageReference: null,
  /*
   * the node with the page timestamp to be updated with every streaming update
   */
  timestampNodeReference: null,
  /*
   * Map containing all registered formatter plugins for this instance
   */
  formatterPlugins: {},
  /**
   * Map object containing permission strings for all rics registered and
   * answered from the server yet. permission can be one out of 'R' (realtime), 'D' (delayed) or
   * 'X' (access denied).
   */
  ricPermissions: {},
  /*
   * fired when streaming service is available     *
   */
  streamingServiceAvailable: new YAHOO.util.CustomEvent('streamingServiceAvailable'),
  renderer: null,
  compositeFids: {},
  compositeAdditionalFids: new Set(),
  compositeCache: {},
  /**
   * To track the value of window.STREAMING_SHOW_SESSIONS_EXCEEDED
   */
  showSessionsExceeded: null,
  /*
   * build a unique id from a ric and a fid to be used as identifier for registering
   * The base64 encoding and decoding is expensive, so try to keep references to
   * your rics and fids and not get them calculated too often
   */
  nodeIdFromRicFid: function nodeIdFromRicFid(ric, fid) {
    return "".concat(window.base64Encode(ric), ".").concat(window.base64Encode(fid));
  },
  /*
   * get the ric and fid from a node id. The base64 encoding and decoding is expensive,
   * so try to keep references to your rics and fids and not get them calculated too often
   */
  ricFidFromNodeId: function ricFidFromNodeId(nodeId) {
    var ricfid = nodeId.split('.');
    return {
      ric: window.decodeBase64(ricfid[0]),
      fid: window.decodeBase64(ricfid[1])
    };
  },
  /**
   * get the number of items that are currently registered for streaming
   * This is actually the number of streaming nodes on the page, so even if there is
   * just one fid streaming for one ric, the number might be greater than 1, if the fid is
   * displayed in several places on the document
   * @returns {number} number of items
   */
  /* Commenting the changes since this code is causing the issue mentioned in the ticket NGPII-25984.
     More analysis is required
  getNumberOfRegisteredItems: function() {
      return Object.keys(nodeMap).length;
  },*/

  /*
   * temporarily pause the streaming service. This method should also be called by the extending classes.
   */
  pause: function pause() {
    if (YAHOO.fcom.Streaming.streamingService && YAHOO.fcom.Streaming.streamingService.isAvailable()) {
      YAHOO.fcom.Streaming.paused = true;
      YAHOO.fcom.Streaming.notifyStatus('disabled');
      YAHOO.fcom.Broadcaster.sendMessage('.streaming', {
        streamingEnabled: false
      });
      YAHOO.fcom.Streaming.streamingService.pause();
    } else {
      /* pause later **/
      YAHOO.lang.later(150, null, function () {
        YAHOO.fcom.Streaming.pause();
      }, null, false);
    }
    if (YAHOO.fcom.Streaming.statusButtonReference) {
      YAHOO.fcom.Streaming.statusButtonReference.setAttribute('aria-pressed', true);
    }
  },
  /*
   * resume a temporarily paused streaming service to run again. This method should also be called by the extending classes.
   */
  resume: function resume() {
    if (YAHOO.fcom.Streaming.streamingService && YAHOO.fcom.Streaming.streamingService.isAvailable()) {
      YAHOO.fcom.Streaming.notifyStatus('running');
      YAHOO.fcom.Broadcaster.sendMessage('.streaming', {
        streamingEnabled: true
      });
      YAHOO.fcom.Streaming.streamingService.resume().then(function (response) {
        YAHOO.fcom.Streaming.paused = false;
        YAHOO.fcom.Streaming.renderer.start();
      }).catch(function () {
        window.location.reload(); // bail out as last option
      });
    } else {
      YAHOO.lang.later(150, null, function () {
        YAHOO.fcom.Streaming.resume();
      }, null, false);
    }
    if (YAHOO.fcom.Streaming.statusButtonReference) {
      YAHOO.fcom.Streaming.statusButtonReference.setAttribute('aria-pressed', false);
    }
  },
  /*
   * For manual later registration of ric fid pairs, this method allows to check for snapshots.
   * This is required as a later subscription of a already subscribed ric fid pair will not send another snapshot.
   * @return an object with attributes "content", "fid", "ric" or null if no snapshot is available yet. In this latter case,
   *         a snapshot will arrive through the normal streaming way as soon as the item was registered successfully
   */
  getSnapshotIfAvailable: function getSnapshotIfAvailable(ric, fid) {
    var nodeId = YAHOO.fcom.Streaming.nodeIdFromRicFid(ric, fid);
    var nodeInfo = nodeMap[nodeId];
    if (nodeInfo && nodeInfo.lastRawUpdate) {
      return nodeInfo.lastRawUpdate;
    } else {
      return null;
    }
  },
  /**
   * Get the permission answer for the given RIC if it was registered and an answer was already received.
   * The value might change, as some rics first have to be registered in the backend and will temporarily
   * pretend to be delayed, but can get updated to realtime with the next pull response.
   * @param ric instrument's ric to check the permission for
   * @returns {String} 'R', 'D', 'X' or null
   */
  getPermission: function getPermission(ric) {
    var base64EncodedRic = window.base64Encode(ric);
    var permission = YAHOO.fcom.Streaming.ricPermissions[base64EncodedRic];
    return permission || null;
  },
  /*
   * initialization function that will walk over the complete dom tree and search for
   * nodes marked for streaming. Those are put into a map and registered to the streaming service.
   */
  registerStreamingNodes: function registerStreamingNodes() {
    if (!YAHOO.fcom.Streaming.nodesToRegisterCounter) {
      nodeMap = {};
      YAHOO.fcom.Streaming.statusImageReference = Dom.get('streamingStatusImage');
      YAHOO.fcom.Streaming.statusButtonReference = Dom.get('streamingStatusButton');
      if (YAHOO.fcom.Streaming.statusButtonReference) {
        YAHOO.util.Event.addListener(YAHOO.fcom.Streaming.statusButtonReference, 'click', function (eventVar) {
          if (eventVar.altKey) {
            showDebugLog();
          } else if (YAHOO.fcom.Streaming.paused || YAHOO.fcom.Streaming.status === 'exceeded') {
            YAHOO.fcom.Streaming.resume();
          } else {
            YAHOO.fcom.Streaming.pause();
          }
          YAHOO.util.Event.stopEvent(eventVar);
          return false;
        }, null, false);
      }
      YAHOO.fcom.Streaming.timestampNodeReference = Dom.get('serverTimestamp'); // reference to the timestamp node
      YAHOO.fcom.Streaming.nodesToRegister = Dom.getElementsByClassName('stream', 'span');
      YAHOO.fcom.Streaming.nodesToRegisterCounter = 0;
      if (YAHOO.fcom.Streaming.nodesToRegister.length > 0) {
        _Accessibility.default.init({
          streamingAccessibility: {
            nodes: $('body')
          }
        });
      }
    }
    var nodes = YAHOO.fcom.Streaming.nodesToRegister;
    var counter = YAHOO.fcom.Streaming.nodesToRegisterCounter;
    var until = Math.min(counter + YAHOO.fcom.Streaming.maxFieldsPerRegistration, Math.min(nodes.length, YAHOO.fcom.Streaming.maxItemsPerPage));
    while (counter < until) {
      YAHOO.fcom.Streaming.appendStreamingNode(nodes[counter], YAHOO.fcom.Streaming.getStreamingInfoFromNode(nodes[counter]));
      counter++;
    }
    logDebug('info', "".concat(counter - YAHOO.fcom.Streaming.nodesToRegisterCounter, " items registered to the streaming Service."));
    YAHOO.fcom.Streaming.nodesToRegisterCounter = counter;
    if (counter < Math.min(nodes.length, YAHOO.fcom.Streaming.maxItemsPerPage)) {
      YAHOO.lang.later(100, null, function () {
        YAHOO.fcom.Streaming.registerStreamingNodes();
      }, null, false);
    } else {
      YAHOO.fcom.Streaming.nodesToRegister = null; // remove references as they are not used any more.
    }

    if (YAHOO.fcom.Streaming.statusButtonReference) {
      YAHOO.fcom.Streaming.statusButtonReference.setAttribute('aria-pressed', YAHOO.fcom.Streaming.paused);
    }
  },
  updateServerTimestamp: function updateServerTimestamp() {
    if (!YAHOO.fcom.Streaming.timestampNodeReference) {
      YAHOO.fcom.Streaming.timestampNodeReference = Dom.get('serverTimestamp');
    }
    var formattedDate = new window.fcom.date.DateTime(user.timezone, Date.now() - window.timestampOffset).format(YAHOO.fcom.Format.localized.patternDateTimeLong);
    YAHOO.fcom.Streaming.timestampNodeReference.innerHTML = formattedDate;
  },
  /*
   * read data-stream-src from the node and decode it
   */
  getStreamingInfoFromNode: function getStreamingInfoFromNode(node) {
    return $(node).data('stream-src');
  },
  /*
   * get a bean object with number format settings from the given
   * format string
   */
  getFloatFractionsFromFormatString: function getFloatFractionsFromFormatString(formatString) {
    YAHOO.fcom.Streaming.floatingFormatSettings = YAHOO.fcom.Streaming.floatingFormatSettings || {}; // init the object if it does not exist yet
    var settingsBean = YAHOO.fcom.Streaming.floatingFormatSettings[formatString];
    if (settingsBean) {
      // return from cache
      return settingsBean;
    }
    var defaultSettingsBean = {
      maxFractionDigits: 5,
      minFractionDigits: 2
    };
    if (formatString === 'f') {
      // default behavior, no specific format information
      settingsBean = defaultSettingsBean;
    } else {
      // specific format information available behind the 'f'
      settingsBean = {}; // new object to fill attributes to

      var formatArray = formatString.substr(1) // remove the 'f'
      .replace(/H$/, '') // remove 'H' if necessary
      .split('').reduce(function (all, item, i, arr) {
        if (!i) {
          // first item will always be for showPlusSign
          all.push(item === '+');
        }
        if (item === '-') {
          // this will be overwritten in the next iteration
          all.push('-');
        } else if (all[all.length - 1] === '-') {
          // overwrite '-' with -1
          all[all.length - 1] = -1;
        } else if (all.length > 4) {
          // optional scaling factor that will fill the rest of the format array
          all[all.length - 1] = all[all.length - 1] || '';
          all[all.length - 1] += item;
          if (i === arr.length - 1) {
            // parse as float on last iteration
            all[all.length - 1] = parseFloat(all[all.length - 1]);
          }
        } else if (item !== '+') {
          all.push(parseInt(item, 35));
        }
        return all;
      }, []);
      settingsBean = {
        showPlusSign: formatArray[0],
        minFractionDigits: formatArray[1],
        maxFractionDigits: formatArray[2],
        minSignificants: formatArray[3],
        maxSignificants: formatArray[4],
        multiplier: formatArray[5]
      };
    }
    YAHOO.fcom.Streaming.floatingFormatSettings[formatString] = settingsBean;
    return settingsBean;
  },
  /*
   * take a list node as parameter and remove it from the underlying list of node info objects
   * first the ancestor is checked whether it exists and if it does, it's next attribute is set to the
   * listNodes's next attribute. If there was no next attribute, the ancestor get's null next pointer.
   * if there was no ancestor and no follower, the attribute is removed from the map completely.
   * @param listNode the node element that should be removed from the linked list. Must not be null
   * @param ancestor the node element that is the previous element in the linked list. If the given
   *        list node is the first in the list, this parameter must be given null.
   */
  removeEntryFromList: function removeEntryFromList(listNode, ancestor) {
    if (ancestor) {
      ancestor.next = listNode.next || null;
    } else if (listNode.next) {
      nodeMap[listNode.nodeId] = listNode.next; // next element becomes first element in the list
      listNode.next.lastRawUpdate = listNode.lastRawUpdate; // first element in the list remembers snapshot
    } else {
      var fids = listNode.fid.split(',');
      fids.forEach(function (fid) {
        return YAHOO.fcom.Streaming.streamingService.removeRicFidPair(listNode.ric, fid);
      });
      delete nodeMap[listNode.nodeId]; // nothing in the map any more with that id
    }
  },

  /*
   * remove all registered streaming nodes from a given node.
   */
  removeStreamingNodes: function removeStreamingNodes(parentNode) {
    var streamingNodes = $(parentNode).find('[data-stream-src]').get();
    var nodeInfosForLaterRemoval = [];
    streamingNodes.forEach(function (node) {
      var infoArray = YAHOO.fcom.Streaming.getStreamingInfoFromNode(node);
      var nodeId = YAHOO.fcom.Streaming.nodeIdFromRicFid(infoArray[0], infoArray[1]);
      var nodeInfo = nodeMap[nodeId];
      var previousNodeInfo = null;
      while (nodeInfo) {
        if (nodeInfo.node && nodeInfo.node === node) {
          if (nodeInfo.lastRawUpdate && !nodeInfo.next) {
            // this info is still needed, last node for that ric/fid
            nodeInfosForLaterRemoval.push(nodeInfo);
          } else {
            YAHOO.fcom.Streaming.removeEntryFromList(nodeInfo, previousNodeInfo);
          }
          break;
        } else {
          previousNodeInfo = nodeInfo;
          nodeInfo = nodeInfo.next;
        }
      }
    });
    if (nodeInfosForLaterRemoval.length > 0) {
      YAHOO.lang.later(10000, null, function () {
        nodeInfosForLaterRemoval.forEach(function (nodeInfo) {
          var currInfo = nodeMap[nodeInfo.nodeId];
          var previousNodeInfo = null;
          while (currInfo) {
            if (currInfo === nodeInfo) {
              YAHOO.fcom.Streaming.removeEntryFromList(currInfo, previousNodeInfo);
              break;
            } else {
              previousNodeInfo = currInfo;
              currInfo = currInfo.next;
            }
          }
        });
      }, null, false);
    }
  },
  /*
   * add additional streaming nodes, that e.g. came to the page via an
   * ajax call or similar. The given node will be searched for html nodes
   * having the stream class set.
   */
  addStreamingNodes: function addStreamingNodes(node) {
    var streamingNodes = $(node).data('stream-src') ? node : $(node).find('[data-stream-src]').get();
    var lastUpdates = [];
    var _loop = function _loop() {
      var lastUpdate = YAHOO.fcom.Streaming.appendStreamingNode(streamingNodes[i], YAHOO.fcom.Streaming.getStreamingInfoFromNode(streamingNodes[i]));
      if (lastUpdate) {
        if (lastUpdate.ric) {
          var update = lastUpdates.find(function (u) {
            return u.symbol === lastUpdate.ric;
          });
          if (update) {
            update[lastUpdate.fid] = lastUpdate.content;
          } else {
            update = _defineProperty({
              symbol: lastUpdate.ric,
              source: 'DELAY'
            }, lastUpdate.fid, lastUpdate.content);
          }
          lastUpdates.push(update);
        } else if (lastUpdate.symbol) {
          var updateIdx = lastUpdates.findIndex(function (u) {
            return u.symbol === lastUpdate.symbol;
          });
          if (updateIdx > -1) {
            lastUpdates[updateIdx] = lastUpdate;
          } else {
            lastUpdates.push(lastUpdate);
          }
        }
      }
    };
    for (var i = 0; i < Math.min(streamingNodes.length, YAHOO.fcom.Streaming.maxFieldsPerRegistration); i++) {
      _loop();
    }
    if (lastUpdates.length) {
      YAHOO.fcom.Streaming.streamingService.streamingListenerCallback(lastUpdates, YAHOO.fcom.Streaming.streamingService);
    }
    logDebug('info', "".concat(Math.min(streamingNodes.length, YAHOO.fcom.Streaming.maxFieldsPerRegistration), " more items registered to the streaming Service."));
    if (streamingNodes.length >= YAHOO.fcom.Streaming.maxFieldsPerRegistration) {
      YAHOO.lang.later(150, this, 'addSubsequentStreamingNodes', [streamingNodes, YAHOO.fcom.Streaming.maxFieldsPerRegistration], false);
    }

    // #. Init new nodes with accessibility
    if (streamingNodes.length > 0) {
      _Accessibility.default.init({
        streamingAccessibility: {
          nodes: $(node)
        }
      });
    }
  },
  /*
   * helper method for the addStreamingNodes method, to register subsequent nodes with a short time delay, to keep the browser responsive
   */
  addSubsequentStreamingNodes: function addSubsequentStreamingNodes(nodes, offset) {
    var i = offset;
    var until = Math.min(Math.min(nodes.length, YAHOO.fcom.Streaming.maxItemsPerPage), offset + YAHOO.fcom.Streaming.maxFieldsPerRegistration);
    while (i < until) {
      YAHOO.fcom.Streaming.appendStreamingNode(nodes[i], YAHOO.fcom.Streaming.getStreamingInfoFromNode(nodes[i]));
      i++;
    }
    if (i < Math.min(nodes.length, YAHOO.fcom.Streaming.maxItemsPerPage)) {
      YAHOO.lang.later(150, this, 'addSubsequentStreamingNodes', [nodes, i], false);
    }
  },
  /*
   * this method is called when the streaming service is set, after the streaming collected all streaming
   * nodes from the page. If the streaming service is already set in advance, the ric fid pairs are already
   * registered while collecting the streaming nodes. Somehow some implementations might need to wait e.g.
   * for an appconst to be fully loaded before the streaming service can register ric fid pairs. Then of course
   * the streaming service is set after the nodes are collected.
   */
  registerRicFidPairs: function registerRicFidPairs() {
    if (YAHOO.fcom.Streaming.registered || !YAHOO.fcom.Streaming.streamingService) {
      // streaming ric fid pairs are already registered, or streaming service not available
      return;
    }
    // only when the streaming service was not yet set when the registerStreamingNodes() function ran, but
    // is available now, the ric fid pairs have to be registered to the streaming service at the moment it is set.
    var numberOf = 0;
    logDebug('info', '--------------- registered ric fid pairs: ---------------');
    for (var nodeId in nodeMap) {
      var nodeValue = nodeMap[nodeId]; // get the node for the given id
      YAHOO.fcom.Streaming.streamingService.registerRicFidPair(nodeValue.ric, nodeValue.fid);
      logDebug('log', "ric: ".concat(nodeValue.ric, " fid: ").concat(nodeValue.fid));
      YAHOO.fcom.Streaming.registered = true;
      numberOf++;
    }
    logDebug('info', "".concat(numberOf, " items registered to the streaming Service."));
  },
  requestUpdatesThrottled: function requestUpdatesThrottled() {},
  /*
   * do poll will be called when the streaming buffer needs polling. It will request the
   * streaming service for updates in regular intervals, waiting the buffer to finish to a specified level,
   * set in AjaxConnector.
   */
  doPoll: function doPoll() {
    if (YAHOO.fcom.Streaming.streamingService && YAHOO.fcom.Streaming.streamingService.needsPolling()) {
      if (!YAHOO.fcom.Streaming.paused && !document.hidden /* && YAHOO.fcom.Streaming.getNumberOfRegisteredItems() > 0*/) {
        YAHOO.fcom.Streaming.requestUpdatesThrottled();
      }
    }
  },
  statusChanged: function statusChanged(statusUpdate) {
    if (statusUpdate && statusUpdate.status) {
      switch (statusUpdate.status) {
        case 'ready':
          YAHOO.fcom.Streaming.notifyStatus('running');
          logDebug('log', "".concat(statusUpdate.message));
          break;
        case 'denied':
          // bail out and force a new login
          window.sessionExpired();
          break;
        case 'exceeded':
          logDebug('warn', statusUpdate.message);
          YAHOO.fcom.Streaming.notifyStatus(statusUpdate.status);
          YAHOO.fcom.Streaming.renderer.stop();
          if (YAHOO.fcom.Streaming.streamingService.needsPolling() && YAHOO.fcom.Streaming.nextPoll) {
            clearTimeout(YAHOO.fcom.Streaming.nextPoll);
          }
          break;
        case 'error':
          console.error(statusUpdate.message);
          logDebug('error', statusUpdate.message);
          YAHOO.fcom.Streaming.notifyStatus(statusUpdate.status);
          break;
        case 'initializing':
          YAHOO.fcom.Streaming.notifyStatus(statusUpdate.status);
          break;
        default:
          // do nothing
          break;
      }
      YAHOO.fcom.Streaming.status = statusUpdate.status;
    }
  },
  /*
   * A logging handler to be passed to streaming services
   * take a log message and append it to the logging buffer. LoggingMessage
   * is an object with several attributes:
   * - message: a string with the logging message
   * - level: a string out of 'info', 'warn', 'error' which describes the importance of the log message
   * - parameters: whatever was given to the streaming service as parameters when registering this logging listener
   */
  appendLogMessage: function appendLogMessage(loggingMessage) {
    if (!loggingMessage.level) {
      // logging message not well formed??
      console.error('YAHOO.fcom.Streaming.appendLogMessage called with malformed log message object:', loggingMessage);
      return;
    }
    if (loggingMessage.level === 'error') {
      console.error(loggingMessage.message);
    }
    logDebug(loggingMessage.level, loggingMessage.message);
  },
  /*
   * set the streaming service to which ric fid pairs should be registered
   * and which will provide updates for those pairs.
   */
  setStreamingService: function setStreamingService(streamingService) {
    YAHOO.fcom.Streaming.streamingService = streamingService;
    if (window.STREAMING_POLLING_RATE) {
      YAHOO.fcom.Streaming.pollingIntervall = window.STREAMING_POLLING_RATE;
    }
    YAHOO.fcom.Streaming.registerStreamingNodes();
    YAHOO.fcom.Streaming.streamingService.setStatusListener(this.statusChanged, this);
    YAHOO.fcom.Streaming.streamingService.setLoggingListener(this.appendLogMessage, this);
    if (nodeMap) {
      if (streamingService.isAvailable()) {
        YAHOO.fcom.Streaming.registerRicFidPairs();
        // fire service available delayed, to give the rest of this function a chance to run.
        YAHOO.lang.later(10, YAHOO.fcom.Streaming, function () {
          this.streamingServiceAvailable.fire();
        });
      } else {
        YAHOO.lang.later(100, YAHOO.fcom.Streaming, 'setStreamingService', streamingService, false);
        return;
      }
    }
    YAHOO.fcom.Streaming.requestUpdatesThrottled = (0, _throttle.default)(function () {
      return YAHOO.fcom.Streaming.streamingService.requestUpdates();
    }, YAHOO.fcom.Streaming.pollingIntervall, {
      'trailing': false
    });
    var connector = new _AjaxConnector.default(this.doPoll, YAHOO.fcom.Streaming.pollingIntervall);
    YAHOO.fcom.Streaming.streamingService.setCallbackFunction(function (updates) {
      connector.onUpdate(updates);
    }, null, function (update) {
      // Failure callback function
      if (!YAHOO.fcom.Streaming.failureUpdates) {
        YAHOO.fcom.Streaming.failureUpdates = {};
      }
      if (update && update.symbol) {
        YAHOO.fcom.Streaming.failureUpdates[update.symbol] = update;
        var perm = 2; // 2 for realtime, 1 for delayed, 0 for access denied
        if (update.source) {
          var base64EncodedRic = window.base64Encode(update.symbol);
          if (update.source !== 'REALTIME') {
            // no realtime source message?
            if (update.source === 'DELAY') {
              // delay messge?
              perm--; // downgrade one from realtime to delay
            } else if (update.source.indexOf('Realtime:AccessDenied') > -1 || update.source.indexOf('Realtime:ItemState=notFound') > -1) {
              // realtime not possible
              perm--; // also downgrade one from realtime to delay
            }

            if (update.source.indexOf('Delay:AccessDenied') > -1 || update.source.indexOf('Delay:ItemState=notFound') > -1) {
              // not even delay?
              perm--; // downgrade one further to access denied / not available
            }
          }

          switch (perm) {
            case 2:
              YAHOO.fcom.Streaming.ricPermissions[base64EncodedRic] = 'R';
              break;
            case 1:
              YAHOO.fcom.Streaming.ricPermissions[base64EncodedRic] = 'D';
              break;
            default:
              YAHOO.fcom.Streaming.ricPermissions[base64EncodedRic] = 'X';
          }
        }
      }
    });
    YAHOO.fcom.Streaming.renderer = new _StreamingRenderer.default(YAHOO.fcom.Streaming.addUpdates, connector);
    if (YAHOO.fcom.Streaming.streamingService.needsPolling()) {
      YAHOO.fcom.Streaming.renderer.start();
    }
    YAHOO.util.Event.addListener('body', 'unload', function () {
      YAHOO.fcom.Streaming.unregisterAllNodes();
    });
  },
  setStreamingIllustration: function setStreamingIllustration(streamingIllustration) {
    YAHOO.fcom.Streaming.streamingIllustration = streamingIllustration;
  },
  /*
   * append the node with the given streaming information to the map
   * of streaming nodes.
   */
  appendStreamingNode: function appendStreamingNode(node, infoArray) {
    if (!infoArray.length) {
      // invalid data - ignore this node
      return;
    }
    var nodeInfo = new _StreamingInfo.default(node, infoArray);
    var nodeId = YAHOO.fcom.Streaming.nodeIdFromRicFid(nodeInfo.ric, nodeInfo.fid);
    nodeInfo.nodeId = nodeId;
    if (window.onChildrenChange) {
      // event available?
      nodeInfo.changeInterestAncestor = window.onChildrenChange.checkNodeInterest(node);
    }
    if (!nodeMap[nodeId]) {
      // this is the very first node with the given ric/fid pair
      nodeMap[nodeId] = nodeInfo;
    } else {
      nodeInfo.next = nodeMap[nodeId]; // append former element to the next attribute
      nodeMap[nodeId] = nodeInfo;
      if (nodeInfo.next.lastRawUpdate) {
        // there was already a snapshot or update to that ric/fid
        nodeInfo.lastRawUpdate = nodeInfo.next.lastRawUpdate;
        nodeInfo.next.lastRawUpdate = null;
        nodeInfo.updateContent(nodeInfo.lastRawUpdate);
      }
    }
    if (YAHOO.fcom.Streaming.streamingService) {
      if (nodeInfo.fid.indexOf(',') > -1) {
        YAHOO.fcom.Streaming.registerCompositeFid(nodeInfo.fid);
      }
      nodeInfo.fid.split(',').forEach(function (fid) {
        YAHOO.fcom.Streaming.streamingService.registerRicFidPair(nodeInfo.ric, fid);
      });
      YAHOO.fcom.Streaming.registered = true;
    }
    if (nodeInfo.lastRawUpdate) {
      return nodeInfo.lastRawUpdate;
    } else if (YAHOO.fcom.Streaming.failureUpdates && YAHOO.fcom.Streaming.failureUpdates[nodeInfo.ric]) {
      return YAHOO.fcom.Streaming.failureUpdates[nodeInfo.ric];
    }
  },
  registerCompositeFid: function registerCompositeFid(fidString) {
    var fids = fidString.split(',');
    fids.slice(1).forEach(function (f) {
      return YAHOO.fcom.Streaming.compositeAdditionalFids.add(f);
    });
    YAHOO.fcom.Streaming.compositeFids[fids[0]] = YAHOO.fcom.Streaming.compositeFids[fids[0]] || [];
    if (YAHOO.fcom.Streaming.compositeFids[fids[0]].indexOf(fidString) === -1) {
      YAHOO.fcom.Streaming.compositeFids[fids[0]].push(fidString);
    }
  },
  setCompositeCache: function setCompositeCache(ric, fid, value) {
    YAHOO.fcom.Streaming.compositeCache[ric] = YAHOO.fcom.Streaming.compositeCache[ric] || {};
    YAHOO.fcom.Streaming.compositeCache[ric][fid] = value;
  },
  getCompositeCache: function getCompositeCache(ric, fid) {
    try {
      return YAHOO.fcom.Streaming.compositeCache[ric][fid];
    } catch (e) {
      return null;
    }
  },
  /*
   * if the streaming service implementation needs unregistration,
   * this function will walk over all registered ric fid pairs unregister them from the streaming.
   */
  unregisterAllNodes: function unregisterAllNodes() {
    if (YAHOO.fcom.Streaming.streamingService.needsUnregistration()) {
      var numberRemoved = 0;
      var ricFidAction = function ricFidAction(ric) {
        return function (fid) {
          YAHOO.fcom.Streaming.streamingService.removeRicFidPair(ric, fid);
          numberRemoved++;
        };
      };
      for (var nodeId in nodeMap) {
        var nodeValue = nodeMap[nodeId]; // get the node for the given id
        var fids = nodeValue.fid.split(',');
        fids.forEach(ricFidAction(nodeValue.ric));
      }
      // Remove all stored failure responses
      YAHOO.fcom.Streaming.failureUpdates = null;
      console.debug("".concat(numberRemoved, " items removed from streaming service."));
    }
  },
  appendUpdateToDebugInfos: function appendUpdateToDebugInfos(updates) {
    if (window.jsdebug) {
      [].concat(updates).forEach(function (update) {
        if (update.ric) {
          logDebug('log', "update: ".concat(update.ric, ", ").concat(update.fid, " = ").concat(update.content));
        } else if (update.id) {
          var ricFid = YAHOO.fcom.Streaming.ricFidFromNodeId(update.id);
          logDebug('warn', "lost node!!! ".concat(ricFid.ric, ", ").concat(ricFid.fid, " = ").concat(update.content));
        }
      });
    }
  },
  /*
   * pop the next update from the updates array, display it and continue.
   * if no updates available any more, call the next polling or hope to get a new update in the addUpdates function
   *
   */
  displayNextUpdate: function displayNextUpdate() {
    var _this = this;
    if (YAHOO.fcom.Streaming.paused || document.hidden) {
      return; // ignore update as streaming is already paused
    }

    if (!YAHOO.fcom.Streaming.currentUpdates) {
      // no updates no more, nothing to do.
      return;
    }
    if (!YAHOO.fcom.Streaming.currentUpdates.length) {
      // no updates no more? set array null and recurse
      YAHOO.fcom.Streaming.currentUpdates = null;
      return;
    }
    if (Object.keys(this.compositeFids).length) {
      var compositeUpdates = [];
      YAHOO.fcom.Streaming.currentUpdates.forEach(function (update) {
        if (update.fid in _this.compositeFids) {
          compositeUpdates.push(update);
          return;
        }
        if (YAHOO.fcom.Streaming.compositeAdditionalFids.has(update.fid)) {
          YAHOO.fcom.Streaming.setCompositeCache(update.ric, update.fid, update.content);
        }
      });
      compositeUpdates.forEach(function (update) {
        YAHOO.fcom.Streaming.compositeFids[update.fid].forEach(function (fidCombination) {
          var compositeUpdate = {
            content: [update.content],
            fid: fidCombination,
            ric: update.ric
          };
          var splitFidCombination = fidCombination.split(',');
          splitFidCombination.slice(1).forEach(function (additionalFid) {
            var content = YAHOO.fcom.Streaming.getCompositeCache(update.ric, additionalFid);
            if (content) {
              compositeUpdate.content.push(content);
            }
          });
          if (compositeUpdate.content.length === splitFidCombination.length) {
            YAHOO.fcom.Streaming.currentUpdates.push(compositeUpdate);
          }
        });
      });
    }
    var update = YAHOO.fcom.Streaming.currentUpdates.shift();
    var i = YAHOO.fcom.Streaming.updateDisplayRate;

    // no delay on first update:
    if (!YAHOO.fcom.Streaming.lastUpdateTimestamp) {
      i = -1;
    }
    YAHOO.fcom.Streaming.lastUpdateTimestamp = Date.now();
    while (update) {
      update.id = update.id || YAHOO.fcom.Streaming.nodeIdFromRicFid(update.ric, update.fid);
      if (update.permission) {
        var base64EncodedRic = window.base64Encode(update.ric);
        YAHOO.fcom.Streaming.ricPermissions[base64EncodedRic] = update.permission.toUpperCase().substring(0, 1);
      }
      var streamingInfo = nodeMap[update.id];
      if (!streamingInfo) {
        streamingInfo = new _StreamingInfo.default(null, [update.ric, update.fid, null]);
        nodeMap[update.id] = streamingInfo;
      }
      var somethingUpdated = false;
      while (streamingInfo) {
        // walk linked list and search for equal fid
        if (somethingUpdated === false) {
          streamingInfo.lastRawUpdate = update; // remember the last raw value on the first nodeInfo in the linked list
        }

        streamingInfo.updateContent(update);
        somethingUpdated = true;
        streamingInfo = streamingInfo.next; // continue searching, fid can be there several times in several locations
      }

      if (!somethingUpdated) {
        YAHOO.fcom.Streaming.unknownUpdates++;
      }
      if (!YAHOO.fcom.Streaming.paused) {// when just adding the last updates in the row, do not show status any more
        //YAHOO.fcom.Streaming.notifyStatus('update');
      }
      if (YAHOO.fcom.Streaming.currentUpdates.length > 0 && YAHOO.fcom.Streaming.currentUpdates[0].ric !== update.ric) {
        i--; // only count down per ric, not per update. Count down will stop at 1, but still th shift will lead to loop end.
        // in case of first snapshot, i is negative already initially, so decreasing it further will not change anything => all snapshots at once
      }

      if (i !== 0) {
        update = YAHOO.fcom.Streaming.currentUpdates.shift();
      } else {
        update = null; // break condition for outer loop, will call this function again after delay
      }
    }
  },

  /*
   * add an updates to the html frontend. As updates argument an array of objects with attributes
   * ric, fid and content is expected. This function looks for the appropriate streaming
   * info objects and calls the updateContent function of those.
   */
  addUpdates: function addUpdates(updates) {
    if (YAHOO.fcom.Streaming.paused || document.hidden) {
      YAHOO.fcom.Streaming.currentUpdates = null;
      return;
    }
    YAHOO.fcom.Streaming.appendUpdateToDebugInfos(updates);
    if (YAHOO.fcom.Streaming.currentUpdates && YAHOO.fcom.Streaming.currentUpdates.length > 0) {
      // still updates to display!
      YAHOO.fcom.Streaming.currentUpdates = YAHOO.fcom.Streaming.currentUpdates.concat(updates);
    } else {
      YAHOO.fcom.Streaming.currentUpdates = updates;
    }
    YAHOO.fcom.Streaming.displayNextUpdate(); // first display is not delayed
  },

  notifyStatus: function notifyStatus(statusString) {
    var statusImage = YAHOO.fcom.Streaming.statusImageReference;
    if (!statusString || statusString.length < 1 || !YAHOO.fcom.Streaming.statusImageReference) {
      return;
    }
    var updateStatusImage = function updateStatusImage(srcState, titleState) {
      srcState = srcState || statusString;
      titleState = titleState || srcState;
      statusImage.classList.remove('initializing');
      statusImage.classList.remove('disabled');
      statusImage.classList.remove('error');
      statusImage.classList.remove('exceeded');
      statusImage.classList.add(statusString);
      statusImage.title = window.getMessage("txt.tooltip.streaming.status.".concat(titleState));
    };
    switch (statusString) {
      case 'update':
        if (YAHOO.fcom.Streaming.paused) {
          return;
        }
        if (!YAHOO.fcom.Streaming.lastUpdateNotify || Date.now() - YAHOO.fcom.Streaming.lastUpdateNotify > 1000) {
          updateStatusImage();
          // YAHOO.lang.later(1700, null, () => {
          //     YAHOO.fcom.Streaming.notifyStatus('running');
          // }, null, false);
          YAHOO.fcom.Streaming.lastUpdateNotify = Date.now();
          YAHOO.fcom.Streaming.updateServerTimestamp();
        }
        break;
      case 'error':
      case 'disabled':
        updateStatusImage();
        break;
      case 'javaDisabled':
        updateStatusImage('disabled', 'javaDisabled');
        break;
      case 'initializing':
      case 'running':
        if (YAHOO.fcom.Streaming.paused) {
          return;
        }
        updateStatusImage();
        YAHOO.fcom.Streaming.updateServerTimestamp();
        break;
      case 'exceeded':
        updateStatusImage();
        window.checkServer().then(function () {
          if (YAHOO.fcom.Streaming.showSessionsExceeded) {
            // explain why streaming is stopped
            window.fillPanelFromAjax('streamingSessionsExceededPanel', '/settings/streamingSessionsExceededInfo.plain', null, {
              width: '650px',
              fixedcenter: true,
              visible: true,
              close: true,
              dragOnly: true,
              draggable: true,
              constraintoviewport: true,
              modal: true
            });
          }
        });
        break;
      default:
        // do nothing
        break;
    }
  },
  /*
   * Register a formatter plugin to this streaming instance.
   * A formatter plugin is defined for a certain streaming data type.
   * The plugin is a Highlander, as there can only be one formatting plugin
   * registered with the streaming instance with the same streaming data type.
   * @param {YAHOO.fcom.StreamingFormatterPlugin} plugin
   */
  registerFormatterPlugin: function registerFormatterPlugin(plugin) {
    if (!this.formatterPlugins[plugin.streamingDataType]) {
      this.formatterPlugins[plugin.streamingDataType] = plugin;
    }
  },
  /*
   * get the formatter plugin registered for a certain streaming data type
   * @param {String} streamingDataType
   * @return YAHOO.fcom.StreamingFormatterPlugin
   */
  getFormatterPlugin: function getFormatterPlugin(streamingDataType) {
    return this.formatterPlugins[streamingDataType];
  }
};
window.YAHOO.fcom.Streaming = Streaming;
var _default = exports.default = Streaming;

},{"./AjaxConnector":12,"./StreamingRenderer":15,"accessibility/Accessibility":1,"lodash/throttle":31,"streaming/StreamingInfo":14}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var YAHOO = window.YAHOO;
var Dom = window.Dom;

/*
 * streaming info object that is used internally by the streaming class to find out
 * where to render updates to and how to format them.
 */
var StreamingInfo = function StreamingInfo(node, infoArray) {
  this.node = node;
  this.ric = infoArray[0];
  this.fid = infoArray[1];
  this.format = infoArray[2];
  this.updateCount = 0; // remember the running number of this update
  this.nodeId = YAHOO.fcom.Streaming.nodeIdFromRicFid(this.ric, this.fid);
  this.lastValue = null; // store the last original value unformatted but parsed, for quick comparison
  this.lastRawUpdate; // remember last raw update to inform new registrations about a snapshot
};

StreamingInfo.prototype = {
  updateContent: function updateContent(update) {
    // TODO: this function should be refactored because it is incredibly complex
    if (!this.node) {
      // some info objects are only used to keep lastRaw updates and inform listeners directly, no DOM update needed
      return;
    }
    var newContent = typeof update.content === 'string' ? this.trim(update.content) : update.content.filter(function (f) {
      return f;
    }); // ensure string without leading spaces and non empty values in arrays
    var newValue = null; // the new value to compare with
    var oldContent = YAHOO.lang.trim(this.node.innerHTML); // get the last original formatted content

    var $node = $(this.node);
    if ($node.hasClass('noValue') >= 0 || $node.find('.noValue').length > 0 || $node.parents('.noValue').length > 0) {
      $node.removeClass('noValue');
      $node.find('.noValue').removeClass('noValue');
      $node.parents('.noValue').removeClass('noValue');
    }
    try {
      if (this.format === 'c' || this.format === 'g' || this.format.indexOf('w') === 0) {
        // no value, but only an up/down/unchanged marker for a css class or image source
        if (newContent.length < 1) {
          newContent = '0.00';
        }
        newValue = YAHOO.fcom.Parse.parseNumber(newContent);
      } else if (this.format.indexOf('f') === 0 || this.format === 'm' || this.format === 'd') {
        if (newContent.length > 0) {
          newValue = parseFloat(newContent);
        }
        if (newValue === 0 && this.format.indexOf('H') === this.format.length - 1) {
          // use empty String for H command (HideZeroValues)
          newValue = '';
        }
      } else if (this.format === 'i') {
        if (newContent.length > 0) {
          newValue = parseInt(newContent, 10);
        }
      } else if (this.format.indexOf('t') === 0 || this.format.indexOf('z') === 0) {
        //date time, parse time stamp
        if (newContent.length > 0) {
          newValue = YAHOO.fcom.Parse.parseMachineDate(newContent);
        }
      } else if (this.format.indexOf('x') === 0) {
        //combined date time
        /**
         * xdd/MM/yy HH:mm@HH:mm@0
         * 0: "16:32:46"
         * 1: "17 NOV 2020"
         * newContent[0] = ' : : ';
        */
        var offset = parseInt(this.format.split('@')[2], 10) * 60 * 1000;
        if (newContent.length >= 2 && newContent[0].match(/\d+:\d+/)) {
          var _YAHOO$fcom$Parse$par = YAHOO.fcom.Parse.parseMachineDate(newContent[0]).date.getCalendar(),
            hour = _YAHOO$fcom$Parse$par.hour,
            minute = _YAHOO$fcom$Parse$par.minute,
            second = _YAHOO$fcom$Parse$par.second;
          var dateObj = YAHOO.fcom.Parse.parseMachineDate(newContent[1]).date;
          dateObj.setTime({
            hour: hour,
            minute: minute,
            second: second
          });
          newValue = {
            date: new window.fcom.date.DateTime(0, dateObj.timestamp),
            time: true
          };
        } else {
          return;
        }
      } else if (this.format === 'p') {
        // percentage value which needs to be multiplied by 100
        if (newContent.length > 0) {
          newValue = 100.0 * parseFloat(newContent);
        }
      } else {
        newValue = newContent;
      }
      if (this.updateCount < 1 && this.changeInterestAncestor == null) {
        // maybe the registration came too late, check again whether there is nodeinterest
        if (window.onChildrenChange != null) {
          // event available?
          this.changeInterestAncestor = window.onChildrenChange.checkNodeInterest(this.node);
        }
      }
      if (this.isMatchingFirstSnapshot(newValue)) {
        // see whether it's only an initial snapshot with no new value
        return;
      }
      if (this.format === 'u' && this.changeInterestAncestor == null) {
        // looks like the registration came too late
        if (window.onChildrenChange != null) {
          // event available?
          this.changeInterestAncestor = window.onChildrenChange.checkNodeInterest(this.node);
        }
      }
    } catch (e) {
      console.error('Exception while parsing streaming update', {
        ric: update.ric,
        fid: update.fid,
        content: update.content
      });
    }
    var titleNode = null; // find the title node that should get the new value set, so that small table columns can be read with mouse over
    if (!this.boxNode || this.boxNode == null) {
      this.boxNode = this.getParentBoxNode(); // remember the box node to save that searching step next time
      if (this.boxNode && this.boxNode.title && this.boxNode.title.length > 0) {
        if (this.boxNode.title.indexOf(oldContent) > -1) {
          titleNode = this.boxNode;
        }
      }
      if (this.node.title && this.node.title.length > 0) {
        if (this.node.title.indexOf(oldContent) > -1) {
          titleNode = this.node;
        }
      }
      if (titleNode == null) {
        // search for tilte node
        titleNode = Dom.getAncestorBy(this.node, function (ancestorNode) {
          if (ancestorNode.title && ancestorNode.title.length > 0) {
            if (['TD', 'DIV', 'TH', 'LI'].indexOf(ancestorNode.nodeName) > -1) {
              return true;
            }
            if (ancestorNode.nodeName === 'SPAN' && Dom.getStyle(ancestorNode, 'display').indexOf('block') > -1 && !Dom.hasClass(ancestorNode, 'stream')) {
              return true;
            }
          }
          return false;
        });
        if (titleNode) {
          if (titleNode.title.indexOf(oldContent) < 0) {
            titleNode = null;
          } else {
            this.boxNode = titleNode;
          }
        }
      }
    } else if (this.boxNode && this.boxNode.title && this.boxNode.title.length > 0 && this.boxNode.title.indexOf(oldContent) > -1) {
      titleNode = this.boxNode;
    }

    // when there is an ancestor that is interested in changes of it's children
    if (this.changeInterestAncestor && this.changeInterestAncestor != null) {
      window.onChildrenChange.fire(this.changeInterestAncestor); // fire the children changed event
    }

    if (this.format === 'c') {
      // no value, but only an up/down/unchanged marker for a css class
      var neededClass = 'unchanged';
      if (!isNaN(newValue)) {
        if (newValue > YAHOO.fcom.Format.MIN_FLOAT) {
          neededClass = 'up';
        } else if (Math.abs(newValue) > YAHOO.fcom.Format.MIN_FLOAT) {
          neededClass = 'down';
        }
        if (!$node.hasClass(neededClass)) {
          $node.removeClass('up');
          $node.removeClass('down');
          $node.removeClass('unchanged');
          $node.addClass(neededClass);
        }
        this.lastValue = newValue; // remember last value
        return; // css is already changed, nothing further to be done
      } else {
        YAHOO.fcom.Streaming.emptyUpdates++;
        return; // no valid number found, don't update anything
      }
    } else if (this.format.indexOf('f') === 0 || this.format === 'd') {
      if (!isNaN(newValue)) {
        var fractions = YAHOO.fcom.Streaming.getFloatFractionsFromFormatString(this.format);
        var originalPlusSign = fractions.showPlusSign;
        if (!originalPlusSign && oldContent.length > 0 && oldContent.indexOf('+') > -1 || oldContent.indexOf(String.fromCharCode(177)) > -1) {
          // there was an plus sign in the original number
          fractions.showPlusSign = true; // also show a sign in the new value
        }

        if (update.trend == null || isNaN(update.trend)) {
          if (!isNaN(this.lastValue)) {
            if (this.lastValue > newValue) {
              update.trend = -1;
            } else if (this.lastValue < newValue) {
              update.trend = 1;
            }
          }
        }
        newContent = YAHOO.fcom.Format.formatNumber(newValue, fractions);
        fractions.showPlusSign = originalPlusSign; // set plus sign flag from bean to original state as it gets reused!

        this.lastValue = newValue; // remember last value
      } else {
        YAHOO.fcom.Streaming.emptyUpdates++;
        return; // no valid number found, don't update anything
      }
    } else if (this.format === 'i') {
      // integer
      if (!isNaN(newValue)) {
        newContent = YAHOO.fcom.Format.formatNumber(newValue, {
          maxFractionDigits: 0,
          minFractionDigits: 0
        });
        this.lastValue = newValue; // remember last value
      } else {
        YAHOO.fcom.Streaming.emptyUpdates++;
        return; // no valid number found, don't update anything
      }
    } else if (this.format === 'u') {
      //image that needs to get updated when new values arrive
      return; // nothing to be done here, image is updates via intrest ancestor mechanism 50 lines above.
    } else if (this.format === 'g') {
      // parse float and exchange classes when necessary, no generic streaming illustration
      this.updateTrendClasses(newValue);
      return;
    } else if (this.format.indexOf('w') === 0) {
      //image that must be stretched in width depending on the given value
      // parse float and exchange src when necessary, no generic streaming illustration
      if (this.scalingFactor == null) {
        this.scalingFactor = parseFloat(this.format.substring(1));
        if (isNaN(this.scalingFactor)) {
          this.scalingFactor = 5;
        }
        try {
          this.maxWidth = this.format.split('@')[1];
        } catch (e) {
          this.maxWidth = +Infinity;
        }
      }
      this.updateTrendBarImage(newValue);
      YAHOO.fcom.Streaming.streamingIllustration.illustrateStreaming(null, update, this); // mark background
      return;
    } else if (this.format.indexOf('t') === 0 || this.format.indexOf('z') === 0) {
      //date time, parse time stamp
      var pattern = this.format.substring(1);
      var doTimezoneConversion = this.format.indexOf('t') === 0; // z means not timeZZZone conversion
      if (newValue && newValue.date) {
        newContent = YAHOO.fcom.Format.formatDateTime(newValue.date, {
          pattern: pattern,
          timezoneConversion: doTimezoneConversion
        });
      } else {
        return;
      }
      this.lastValue = newContent;
    } else if (this.format.indexOf('x') === 0) {
      //combined date time
      // xdd/MM/yy HH:mm@HH:mm@0
      var _myPatterns = this.format.substring(1).split('@');
      var dateTimePattern = _myPatterns[0];
      var datePattern = _myPatterns[1];
      newContent = YAHOO.fcom.Format.formatDateTime(newValue.date, {
        pattern: newValue.time ? dateTimePattern : datePattern,
        timezoneConversion: true
      });
      this.lastValue = newContent;
    } else if (this.format === 'm') {
      // m for million, for very huge numbers like volume or turnover
      if (!isNaN(newValue)) {
        newContent = YAHOO.fcom.Format.formatNumber(newValue, {
          mio: true,
          maxFractionDigits: 3
        });
        this.lastValue = newValue; // remember last value
      } else {
        YAHOO.fcom.Streaming.emptyUpdates++;
        return; // no valid number found, don't update anything
      }
    } else if (this.format === 'p') {
      // percentage value which needs to be multiplied by 100
      if (!isNaN(newValue)) {
        newContent = YAHOO.fcom.Format.formatNumber(newValue, {
          maxFractionDigits: 4,
          minFractionDigits: 2,
          multiplier: 100
        });
        this.lastValue = newValue; // remember last value
      } else {
        YAHOO.fcom.Streaming.emptyUpdates++;
        return; // no valid number found, don't update anything
      }
    } else if (this.format === 'rb') {
      newContent = null;
      this.lastValue = newValue; // remember last value
      this.updateRangeBar($node, newValue);
    } else if (this.format === '.ad') {
      newContent = YAHOO.fcom.Format.formatNumber(newValue, {
        maxFractionDigits: 0,
        minFractionDigits: 0
      });
      this.lastValue = newValue; // remember last value
      this.updateIndexAdvancedDeclines($node, newValue);
    } else {
      // use the plugin that is registered for this format string
      var plugin = YAHOO.fcom.Streaming.getFormatterPlugin(this.format);
      if (plugin) {
        plugin.illustrateStreaming(plugin.format(update, this), update, this);
        return;
      } else {
        newContent = newValue;
      }
    }
    if (newContent != null) {
      YAHOO.fcom.Streaming.streamingIllustration.illustrateStreaming(newContent, update, this);
      if (titleNode) {
        titleNode.title = newContent;
      }
    }
  },
  /*
   * special function to exchange the trend classes
   */
  updateTrendClasses: function updateTrendClasses(floatValue) {
    var className = '';
    if (floatValue <= -5.0) {
      className = 'strongdown';
    } else if (floatValue <= -1.0) {
      className = 'down';
    } else if (floatValue <= -0.00001) {
      className = 'littledown';
    } else if (Math.abs(floatValue) < 0.00001) {
      className = 'unchanged';
    } else if (floatValue <= 1.0) {
      className = 'littleup';
    } else if (floatValue <= 5.0) {
      className = 'up';
    } else {
      // larger than 5.0
      className = 'strongup';
    }
    var $arrow = $(this.node).find('.trend-arrow');
    $arrow.removeClass('strongdown down littledown unchanged littleup up strongup');
    $arrow.addClass(className);
  },
  updateRangeBar: function updateRangeBar($node, newValue) {
    var $low = $node.find('.lowVal1D');
    var $high = $node.find('.highVal1D');
    var high = Number($high.data('high'));
    var low = Number($low.data('low'));
    newValue = Number(newValue);
    if (newValue > high) {
      high = newValue;
      $high.text(YAHOO.fcom.Format.formatNumber(newValue, {
        maxFractionDigits: 2,
        minFractionDigits: 2,
        multiplier: 1,
        showPlusSign: false
      }));
      $high.attr('data-high', newValue);
    } else if (newValue < low) {
      low = newValue;
      $low.text(YAHOO.fcom.Format.formatNumber(newValue, {
        maxFractionDigits: 2,
        minFractionDigits: 2,
        multiplier: 1,
        showPlusSign: false
      }));
      $low.attr('data-low', newValue);
    }
    var linePercentage = this.calculatePointerPosition(low, high, newValue);
    $node.find('.linear-range-meter').css('background-image', this.buildRangeMeter(linePercentage, $node));
    $node.find('.rangePointer').css('left', "".concat(linePercentage - 7, "px"));
  },
  updateIndexAdvancedDeclines: function updateIndexAdvancedDeclines($node, newValue) {
    var dataProvider = $node.parents('.dataProvider').children();
    var ISSUES_ADV = Number(dataProvider[0].textContent);
    var ISSUES_DEC = Number(dataProvider[1].textContent);
    var ISSUES_UNC = Number(dataProvider[2].textContent);
    var TOT_ISSUES = ISSUES_ADV + ISSUES_DEC + ISSUES_UNC;
    var $indexAdvancedDeclinesText = $node.parent().siblings('.indexAdvancedDeclinesText');
    var $indexAdvancedDeclines = $node.parent().siblings('.indexAdvancedDeclines');
    if (TOT_ISSUES > 0) {
      // calculation
      var upPercChange = 100 / TOT_ISSUES * ISSUES_ADV;
      var noChangePercChange = 100 / TOT_ISSUES * ISSUES_UNC;
      var downPercChange = 100 / TOT_ISSUES * ISSUES_DEC;

      //bar
      var $up = $indexAdvancedDeclines.find('.up');
      var $noChange = $indexAdvancedDeclines.find('.noChange');
      var $down = $indexAdvancedDeclines.find('.down');
      $up.width("".concat(upPercChange, "%"));
      $noChange.width("".concat(noChangePercChange, "%"));
      $down.width("".concat(downPercChange, "%"));

      //text
      var $upText = $indexAdvancedDeclinesText.find('.up');
      var $noChangeText = $indexAdvancedDeclinesText.find('.noChange');
      var $downText = $indexAdvancedDeclinesText.find('.down');
      var numberConfig = {
        maxFractionDigits: 1,
        minFractionDigits: 1,
        multiplier: 1,
        showPlusSign: false
      };
      $upText.text("".concat(YAHOO.fcom.Format.formatNumber(upPercChange, numberConfig), "%"));
      $noChangeText.text("".concat(YAHOO.fcom.Format.formatNumber(noChangePercChange, numberConfig), "%"));
      $downText.text("".concat(YAHOO.fcom.Format.formatNumber(downPercChange, numberConfig), "%"));

      //setting tooltips:
      $indexAdvancedDeclines.parent('td').attr('title', "".concat(YAHOO.fcom.Format.formatNumber(upPercChange, numberConfig), "%  ").concat(YAHOO.fcom.Format.formatNumber(noChangePercChange, numberConfig), "%  ").concat(YAHOO.fcom.Format.formatNumber(downPercChange, numberConfig), "%"));
      $indexAdvancedDeclinesText.parent('td').attr('title', "".concat(YAHOO.fcom.Format.formatNumber(upPercChange, numberConfig), "%  ").concat(YAHOO.fcom.Format.formatNumber(noChangePercChange, numberConfig), "%  ").concat(YAHOO.fcom.Format.formatNumber(downPercChange, numberConfig), "%"));
    } else {
      $indexAdvancedDeclines.parent('td').attr('title', ' ');
      $indexAdvancedDeclinesText.parent('td').attr('title', ' ');
    }
  },
  buildRangeMeter: function buildRangeMeter(pointerPosition, $node) {
    var up = $node.find('.up').css('color');
    var down = $node.find('.down').css('color');
    return "linear-gradient(to right, ".concat(up, " 0%, ").concat(up, " ").concat(pointerPosition, "%,#ffffff ").concat(pointerPosition, "%,#ffffff ").concat(pointerPosition + 1, "%,").concat(down, " ").concat(pointerPosition + 1, "%, ").concat(down, " 100%)");
  },
  calculatePointerPosition: function calculatePointerPosition(priceLow, priceHigh, priceTraded) {
    var dif = priceHigh - priceLow;
    if (dif === 0) {
      return 50;
    }
    var pChange = 100 / dif;
    var position = (priceTraded - priceLow) * pChange;
    return Math.round(position);
  },
  /*
   * special function to exchange the trend images in dependency of the given float value
   */
  updateTrendBarImage: function updateTrendBarImage(floatValue) {
    var imageTags = this.trendBarImages;
    var divClassTag = this.divClassTag;
    if (imageTags == null) {
      imageTags = YAHOO.fcom.Dom.getDescendantsBy(this.node, function (node) {
        return node.nodeName.toLowerCase() === 'img';
      });
      this.trendBarImages = imageTags;
    }
    if (divClassTag == null) {
      divClassTag = YAHOO.util.Dom.getFirstChildBy(this.node, function (node) {
        return YAHOO.util.Dom.hasClass(node, 'performanceBar');
      });
      this.divClassTag = divClassTag;
    }
    var newImageExchangePart = '';
    var newDivClass = '';
    if (YAHOO.fcom.Format._isZero(floatValue)) {
      newImageExchangePart = '-unchanged-';
      newDivClass = 'unchanged';
    } else if (floatValue > 0) {
      newImageExchangePart = '-up-';
      newDivClass = 'up';
    } else {
      // negative
      newImageExchangePart = '-down-';
      newDivClass = 'down';
    }
    if (!YAHOO.util.Dom.hasClass(divClassTag, newDivClass)) {
      // only when current class is not correct (which will be almost never)
      YAHOO.util.Dom.removeClass(divClassTag, 'unchanged');
      YAHOO.util.Dom.removeClass(divClassTag, 'up');
      YAHOO.util.Dom.removeClass(divClassTag, 'down');
      YAHOO.util.Dom.addClass(divClassTag, newDivClass);
    }
    var oldImagePart = '';
    if (imageTags[0].src.indexOf('-up-') > -1) {
      oldImagePart = '-up-';
    } else if (imageTags[0].src.indexOf('-down-') > -1) {
      oldImagePart = '-down-';
    } else {
      oldImagePart = '-unchanged-';
    }
    if (newImageExchangePart.indexOf(oldImagePart) !== 0) {
      // do images have to be replaced?
      for (var i = 0; i < imageTags.length; i++) {
        var appendPos = imageTags[i].src.indexOf(oldImagePart);
        imageTags[i].src = imageTags[i].src.substring(0, appendPos) + newImageExchangePart + imageTags[i].src.substring(appendPos + oldImagePart.length);
        if (imageTags[i].title != null && imageTags[i].title.length > 0) {
          imageTags[i].title = ''; // clear tooltip, as it will state wrong values
        }
      }
    }

    imageTags[1].width = Math.min(this.maxWidth, this.scalingFactor * Math.abs(floatValue));
  },
  /*
   * simple trim function, that throws away every character at the beginning or ending of the string
   * which has a char code lower to 33. That means tabs, line feeds, empty space and also strange
   * special characters are removed.
   * @param inputString the inputString to work on
   * @return the input string with trailing and leading special characters removed
   */
  trim: function trim(inputString) {
    var start = 0;
    var end = inputString.length;
    var character = inputString.charCodeAt(start);
    while (character < 33 && start < inputString.length - 1) {
      start++;
      character = inputString.charCodeAt(start);
    }
    character = inputString.charCodeAt(end - 1);
    while (character < 33 && end > 1) {
      end--;
      character = inputString.charCodeAt(end - 1);
    }
    return inputString.substring(start, end);
  },
  /*
   * the last value is always stored unformatted, to compare with new values.
   * Initially this is of course not possible and this function allows to fill the last value
   * variable from whatever is found in the markup.
   */
  fillLastValueFromMarkup: function fillLastValueFromMarkup() {
    var oldContent = YAHOO.lang.trim(this.node.innerHTML); // get old content to guess value from.
    if (oldContent.length < 1) {
      this.lastValue = null;
      return; // nothing found, keep null value
    }

    if (this.format === 'c') {
      // those formats are not interested in last values
      return;
    }
    if (this.format === 'i' || this.format.indexOf('f') === 0) {
      // float or integer
      this.lastValue = YAHOO.fcom.Parse.guessFormattedFloat(oldContent);
    } else {
      // just keep value for now, format "c" is not interested in old values, TODO: also look for the percentage, the million and other formats
      this.lastValue = oldContent;
    }
  },
  /*
   * this function checks whether the update is the first one and whether the content matches
   * the already available content in the markup. If this is the case, true is returned and the
   * update should be omitted. Otherwise false is returned.
   * The function also increases the updateCount by one, so the caller should not already do this
   */
  isMatchingFirstSnapshot: function isMatchingFirstSnapshot(newContent) {
    var getInitialSnapshots = ['rb', '.ad'];
    if (getInitialSnapshots.includes(this.format)) {
      //some formats requires an initial snapshot
      return false;
    }
    if (this.updateCount > 0) {
      // not the initial update
      this.updateCount++;
      return false;
    }
    this.updateCount++;
    this.fillLastValueFromMarkup(); // first fill the value from the markup

    if (this.format === 'c' || this.format.indexOf('f') === 0 || this.format === 'm' || this.format === 'i' || this.format === 'p') {
      // no value, but only an up/down/unchanged marker for a css class
      if (this.lastValue && !isNaN(this.lastValue) && !isNaN(newContent)) {
        return Math.abs(newContent - this.lastValue) < 0.000001;
      } else {
        return false;
      }
    } else {
      return newContent === this.lastValue;
    }
  },
  /*
   * find the next ancestor which is a box node. This is needed to colour the
   * background of any text. Only box nodes realy make sence to have coloured background.
   */
  getParentBoxNode: function getParentBoxNode() {
    return Dom.getAncestorBy(this.node, function (ancestorNode) {
      if (['TD', 'DIV', 'TH', 'LI'].indexOf(ancestorNode.nodeName) > -1) {
        return true;
      }
      if (ancestorNode.nodeName === 'SPAN' && !Dom.hasClass(ancestorNode, 'stream')) {
        var display = Dom.getStyle(ancestorNode, 'display');
        return display.match(/(block|flex)/i);
      }
      return false;
    });
  }
};
var _default = exports.default = StreamingInfo;

},{}],15:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var MIN_RENDER_GAP = 70;
var StreamingRenderer = /*#__PURE__*/function () {
  function StreamingRenderer(renderFunc, connector) {
    _classCallCheck(this, StreamingRenderer);
    this.renderFunc = renderFunc;
    this.ref = null;
    this._loop = this._loop.bind(this);
    this.lastRender = Date.now();
    this.lastSample = Date.now();
    this.connector = connector;
    this.updateIter = connector.iter();
    this.renderGap = MIN_RENDER_GAP;
    this.running = false;
  }

  // Returns gap in ms between update render calls
  _createClass(StreamingRenderer, [{
    key: "_calcRenderGap",
    value: function _calcRenderGap() {
      var updateSize = this.connector.getLastUpdateSize();
      var result = MIN_RENDER_GAP;
      if (updateSize <= 50) {
        result = 200;
      } else if (updateSize <= 100) {
        result = 100;
      }

      // Add a random amout of time to make it feel less consistent / more like real Streaming
      result += Math.floor(Math.random() * 200);
      return result;
    }
  }, {
    key: "start",
    value: function start() {
      if (!this.ref) {
        this.running = true;
        this.ref = window.requestAnimationFrame(this._loop);
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      this.ref = null;
      this.running = false;
    }
  }, {
    key: "_loop",
    value: function _loop() {
      var now, diffRender, _await$this$updateIte, value;
      return _regeneratorRuntime().async(function _loop$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (this.running) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            now = Date.now();
            diffRender = now - this.lastRender;
            if (!(diffRender >= this.renderGap)) {
              _context.next = 12;
              break;
            }
            this.renderGap = this._calcRenderGap();
            _context.next = 8;
            return _regeneratorRuntime().awrap(this.updateIter.next());
          case 8:
            _await$this$updateIte = _context.sent;
            value = _await$this$updateIte.value;
            this._render(value);
            this.lastRender = Date.now();
          case 12:
            this.ref = window.requestAnimationFrame(this._loop);
          case 13:
          case "end":
            return _context.stop();
        }
      }, null, this, null, Promise);
    }
  }, {
    key: "_render",
    value: function _render(updates) {
      this.renderFunc(updates);
    }
  }]);
  return StreamingRenderer;
}();
var _default = exports.default = StreamingRenderer;

},{}],16:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var KEYCODE = {
  ENTER: 13,
  SPACE: 32,
  ESCAPE: 27,
  ARROW_LEFT: 37,
  ARROW_UP: 38,
  ARROW_RIGHT: 39,
  ARROW_DOWN: 40,
  TAB: 9,
  KeyA: 65,
  KeyD: 68,
  DELETE: 46
};
var _default = exports.default = KEYCODE;

},{}],17:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * @name            : GUID
 * @description     : Generate new GUID and GUID related methods
 */
var GUID = exports.default = /*#__PURE__*/function () {
  function GUID() {
    _classCallCheck(this, GUID);
  }
  _createClass(GUID, null, [{
    key: "generate",
    value:
    /**
     * @method generate
     * @description Static method to generate new GUID
     * @public
     * @static
     */
    function generate() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0;
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
      });
    }
  }]);
  return GUID;
}();

},{}],18:[function(require,module,exports){
var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;

},{"./_root":24}],19:[function(require,module,exports){
var Symbol = require('./_Symbol'),
    getRawTag = require('./_getRawTag'),
    objectToString = require('./_objectToString');

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;

},{"./_Symbol":18,"./_getRawTag":22,"./_objectToString":23}],20:[function(require,module,exports){
var trimmedEndIndex = require('./_trimmedEndIndex');

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;

},{"./_trimmedEndIndex":25}],21:[function(require,module,exports){
(function (global){(function (){
/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],22:[function(require,module,exports){
var Symbol = require('./_Symbol');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;

},{"./_Symbol":18}],23:[function(require,module,exports){
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;

},{}],24:[function(require,module,exports){
var freeGlobal = require('./_freeGlobal');

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;

},{"./_freeGlobal":21}],25:[function(require,module,exports){
/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;

},{}],26:[function(require,module,exports){
var isObject = require('./isObject'),
    now = require('./now'),
    toNumber = require('./toNumber');

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;

},{"./isObject":27,"./now":30,"./toNumber":32}],27:[function(require,module,exports){
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;

},{}],28:[function(require,module,exports){
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;

},{}],29:[function(require,module,exports){
var baseGetTag = require('./_baseGetTag'),
    isObjectLike = require('./isObjectLike');

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;

},{"./_baseGetTag":19,"./isObjectLike":28}],30:[function(require,module,exports){
var root = require('./_root');

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;

},{"./_root":24}],31:[function(require,module,exports){
var debounce = require('./debounce'),
    isObject = require('./isObject');

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;

},{"./debounce":26,"./isObject":27}],32:[function(require,module,exports){
var baseTrim = require('./_baseTrim'),
    isObject = require('./isObject'),
    isSymbol = require('./isSymbol');

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;

},{"./_baseTrim":20,"./isObject":27,"./isSymbol":29}]},{},[13]);
;
(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _StreamingAccessibility = _interopRequireDefault(require("accessibility/StreamingAccessibility"));
var _ContextMenuAccessibility = _interopRequireDefault(require("accessibility/ContextMenuAccessibility"));
var _AccordionAccessibility = _interopRequireDefault(require("accessibility/AccordionAccessibility"));
var _TooltipAccessibility = _interopRequireDefault(require("accessibility/TooltipAccessibility"));
var _PopupSearchAccessibility = _interopRequireDefault(require("accessibility/PopupSearchAccessibility"));
var _HighchartsAccessibility = _interopRequireDefault(require("accessibility/HighchartsAccessibility"));
var _NewsPlayerAccessibility = _interopRequireDefault(require("accessibility/NewsPlayerAccessibility"));
var _LoginAccessibility = _interopRequireDefault(require("accessibility/LoginAccessibility"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * @class       : Accessibility
                                                                                                                                                                                                                                                                                                                                                                                               * @description : To enable the web content accessibility(WCAG) in the ngp components
                                                                                                                                                                                                                                                                                                                                                                                               *                  - Streaming modules
                                                                                                                                                                                                                                                                                                                                                                                               *                  - Context menu open button
                                                                                                                                                                                                                                                                                                                                                                                               *                  - Context menu
                                                                                                                                                                                                                                                                                                                                                                                               *                  - Accordion controls
                                                                                                                                                                                                                                                                                                                                                                                               *                  - Tooltip component
                                                                                                                                                                                                                                                                                                                                                                                               *                  - Popup search
                                                                                                                                                                                                                                                                                                                                                                                               *                  - Highcharts/Highstocks
                                                                                                                                                                                                                                                                                                                                                                                               *                  - NEWS Player - top news module
                                                                                                                                                                                                                                                                                                                                                                                               * @dependencies: Jquery, StreamingAccessibility, ContextMenuAccessibility, AccordionAccessibility,
                                                                                                                                                                                                                                                                                                                                                                                               *                TooltipAccessibility, PopupSearchAccessibility, NewsPlayerAccessibility
                                                                                                                                                                                                                                                                                                                                                                                               * @references  : https://www.w3.org/TR/WCAG20-TECHS/
                                                                                                                                                                                                                                                                                                                                                                                               */
var Accessibility = /*#__PURE__*/function () {
  function Accessibility() {
    _classCallCheck(this, Accessibility);
  }
  _createClass(Accessibility, null, [{
    key: "init",
    value:
    /**
     * @method init
     * @description Initialize the accessibility module
     * @public
     * @static
     */
    function init(params) {
      Accessibility._start(params);
    }

    /**
     * @method init
     * @description Update an element title based on the inner text
     * @public
     * @static
     */
  }, {
    key: "compareAndUpdateElementTitle",
    value: function compareAndUpdateElementTitle($elements, compareText, updatedTitle) {
      // #. Identify the delete button based on the inner text value
      $elements.filter(function (index) {
        var $element = $($elements[index]);
        var innerText = $element.text();
        if (String(innerText).trim().replace(/[^a-zA-Z ]/g, '') === String(compareText).trim().replace(/[^a-zA-Z ]/g, '')) {
          $element.attr({
            'aria-label': updatedTitle
          });
        }
      });
    }
  }, {
    key: "_start",
    value:
    /**
     * @method _start
     * @description assign accessibility to accessibility services
     * @param { Object } v expect config information or null
     * @private
     * @static
     */
    function _start(config) {
      if (config) {
        // #. Init the streaming accessibility
        if (config.streamingAccessibility) {
          var streamingAccessibility = new _StreamingAccessibility.default();
          streamingAccessibility.init(config.streamingAccessibility.nodes);
        }

        // #. Init context menu accessibility
        if (config.menu && config.menu.enabled) {
          var contextMenuAccessibility = new _ContextMenuAccessibility.default();
          window.setTimeout(function () {
            contextMenuAccessibility.init();
          }, config.menu.initDelay || 0);
        }

        // #. Init accordion accessibility
        if (config.accordion) {
          var accordionAccessibility = new _AccordionAccessibility.default(config.accordion);
          accordionAccessibility.init();
        }

        // #. Init accordion accessibility
        if (config.tooltip) {
          var tooltipAccessibility = new _TooltipAccessibility.default(config.tooltip);
          tooltipAccessibility.init();
        }

        // #. Init popup search accessibility accessibility
        if (config.popupSearch) {
          var popupSearchAccessibility = new _PopupSearchAccessibility.default(config.popupSearch);
          popupSearchAccessibility.init();
        }

        // #. Init highcharts accessibility module
        if (config.highCharts && config.highCharts.enabled) {
          var highchartsAccessibility = new _HighchartsAccessibility.default(config.highCharts);
          highchartsAccessibility.init();
        }

        // #. Init highcharts accessibility module
        if (config.newsPlayer) {
          var newsPlayerAccessibility = new _NewsPlayerAccessibility.default(config.newsPlayer);
          newsPlayerAccessibility.init();
        }

        // #. Init login page accessibility
        if (config.login) {
          var loginAccessibility = new _LoginAccessibility.default();
          loginAccessibility.init();
        }
      }
    }
  }]);
  return Accessibility;
}(); // #. Set the global access
window.fcom.Accessibility = Accessibility;
var _default = exports.default = Accessibility;

},{"accessibility/AccordionAccessibility":2,"accessibility/ContextMenuAccessibility":3,"accessibility/HighchartsAccessibility":4,"accessibility/LoginAccessibility":5,"accessibility/NewsPlayerAccessibility":6,"accessibility/PopupSearchAccessibility":7,"accessibility/StreamingAccessibility":8,"accessibility/TooltipAccessibility":9}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _guid = _interopRequireDefault(require("util/guid"));
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * @class       : AccordionAccessibility
                                                                                                                                                                                                                                                                                                                                                                                               * @description : To enable the web content accessibility(WCAG) in ngp application accordion(expander/collapse) component
                                                                                                                                                                                                                                                                                                                                                                                               *                - NGPII-15088 JAWS: Expander
                                                                                                                                                                                                                                                                                                                                                                                               * @dependencies: Jquery, GUID
                                                                                                                                                                                                                                                                                                                                                                                               * @references  : https://www.w3.org/TR/wai-aria-practices-1.1/examples/accordion/accordion.html
                                                                                                                                                                                                                                                                                                                                                                                               */
var AccordionAccessibility = /*#__PURE__*/function () {
  function AccordionAccessibility(options) {
    _classCallCheck(this, AccordionAccessibility);
    if (!options) {
      return true;
    }

    // #. Keep the config/options into context
    this.options = options;
    // #. Keep the accordion container
    this.$container = _typeof(options.container) === 'object' ? options.container : $(options.container);
    // #. Keep all accordion toggles
    this.$toggles = null;
    // #. Selector to identify the expanded toggle bar - default 'open' is a css class name
    this.expandSelector = options.expandSelector || 'open';
    /**
     * Keep the panel find selector method(ex: next, Jquery selector)
     * next - consider as method ex: findPanelBy: { method: 'next' }
     * multiple methods will be formatted by space { method: 'parent next' }
     * id - consider as attribute ex: findPanelBy: { attr: 'id' }
     */
    this.findPanelBy = options.findPanelBy || {
      method: 'next'
    };
  }

  /**
   * @method init
   * @description Initialize the accordion accessibility
   * @public
   */
  _createClass(AccordionAccessibility, [{
    key: "init",
    value: function init() {
      // #. Find all accordion toggles
      this.$toggles = this.$container.find(this.options.toggleSelector);
      // #. Set default WCAG attributes
      this._setWCAGAttributes();
      // #. Bind the tracking events to toggle bar
      this._bindEvents(this.$toggles);
    }

    /**
     * @method _setWCAGAttributes
     * @description set WCAG attributes to accordion
     * @private
     */
  }, {
    key: "_setWCAGAttributes",
    value: function _setWCAGAttributes() {
      // todo manage the disabled accordions - check the scope
      // todo manage the multiple open accordions - check the scope
      var _iterator = _createForOfIteratorHelper(this.$toggles),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var $toggle = _step.value;
          $toggle = $($toggle);
          var $panel = this._getPanelByToggle($toggle);

          // #. No panel - then continue
          if (!$panel || $panel.length === 0) {
            return true;
          }

          // #. Set toggle bat attr
          var toggleAttr = {
            'aria-expanded': this._isToggleExpanded($toggle)
          };

          // #. lost toggle not require control attr ex: EditView left panel list
          if (this.options.toggleControlAttr !== false) {
            toggleAttr['aria-controls'] = this._getElementId($panel);
          }

          // #. Update toggle attr
          this._setAttributes($toggle, toggleAttr);

          // #. Set panel display attr
          var panelAttr = {
            'aria-labelledby': this._getElementId($toggle)
          };

          // #. options not require role update ex: EditView left panel list
          if (this.options.panelRoleUpdate !== false) {
            panelAttr.role = 'region';
          }

          // #. Update panel attr
          this._setAttributes($panel, panelAttr);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    /**
     * @method _bindEvents
     * @description bind events to update the attributes
     * @param { HTMLElement } $element expect a element or collection of elements object
     * @private
     */
  }, {
    key: "_bindEvents",
    value: function _bindEvents($element) {
      var _this = this;
      $element.on('keydown click', function (event) {
        var $target = $(event.target);
        var keyCode = event.keyCode;
        if (!keyCode || keyCode === _keyCodes.default.ENTER || keyCode === _keyCodes.default.SPACE) {
          // #. Update expanded attribute
          _this._isToggleExpanded($target, function (value) {
            $target.attr('aria-expanded', value);
          });
        }
      });
    }

    /**
     * @method _isToggleExpanded
     * @description check the expand status of a toggle
     * @param { HTMLElement } $element expect a element or collection of elements object
     * @private
     */
  }, {
    key: "_isToggleExpanded",
    value: function _isToggleExpanded($toggle, callback) {
      var $element = $toggle;
      var selector = this.expandSelector;
      var delay = 0;
      if (_typeof(this.expandSelector) === 'object') {
        if (this.expandSelector.parent) {
          $element = $toggle.parent();
          selector = this.expandSelector.parent;
          delay = this.expandSelector.delay || 0;
        }
      }
      if (callback) {
        window.setTimeout(function () {
          callback($element.hasClass(selector));
        }, delay);
      } else {
        return $element.hasClass(selector);
      }
    }

    /**
     * @method _getElementId
     * @description get id attribute of a element, set new one when no id found
     * @param { HTMLElement } $element expect panel display element object
     * @private
     */
  }, {
    key: "_getElementId",
    value: function _getElementId($element) {
      var elementId = $element.attr('id');
      if (!elementId) {
        elementId = _guid.default.generate();
        $element.attr('id', elementId);
      }
      return elementId;
    }

    /**
     * @method _setAttributes
     * @description set attr object to specific element
     * @param { HTMLElement } $element expect element object
     * @param { Object } attr expect object of attributes
     * @private
     */
  }, {
    key: "_setAttributes",
    value: function _setAttributes($element, attr) {
      $element.attr(attr);
    }

    /**
     * @method _getPanelByToggle
     * @description get corresponding panel by toggle bar
     * @param { HTMLElement } $toggle expect toggle bar element object
     * @private
     */
  }, {
    key: "_getPanelByToggle",
    value: function _getPanelByToggle($toggle) {
      /** Find panel element by series of methods or method
        * multiple methods split by space ex: 'parent next' - means next element of the toggle parent
        * method parameter can passed inside the parenthesis ex: 'parent nextAll(.class1#id)'
        */
      if (this.findPanelBy.method) {
        var $element = null;
        var methods = this.findPanelBy.method.split(' ');
        var _iterator2 = _createForOfIteratorHelper(methods),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var method = _step2.value;
            // #. Check any selectors passed as params
            var selector = '';
            if (method.indexOf('(') !== -1) {
              var params = method.split('(');
              method = params[0];
              selector = String(params[1]).replace(')', '');
            }
            $element = $element ? $($element)[method](selector) : $toggle[method](selector);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        return $element;
      }

      // #. Find panel elements by toggle attribute value
      // #. findClosestOfToggle - will get the attribute value from the closest element of the toggle
      if (this.findPanelBy.attr) {
        var _$element = this.findPanelBy.findClosestOfToggle ? $toggle.closest("[".concat(this.findPanelBy.attr, "]")) : $toggle;
        var attrVal = _$element.attr(this.findPanelBy.attr);
        var _selector = "[".concat(this.findPanelBy.attr, "=\"").concat(attrVal, "\"]");
        return this.$container.find(_selector).not(this.findPanelBy.notInclude || '');
      }
    }
  }]);
  return AccordionAccessibility;
}(); // #. Export the accordion accessibility
var _default = exports.default = AccordionAccessibility;

},{"util/enums/keyCodes":14,"util/guid":15}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * @class       : ContextMenuAccessibility
                                                                                                                                                                                                                                                                                                                                                                                               * @description : To enable the web content accessibility(WCAG) in ngp application context menu component
                                                                                                                                                                                                                                                                                                                                                                                               *                - NGPII-15538 JAWS: Context Menu
                                                                                                                                                                                                                                                                                                                                                                                               *                - Context menu item accessibility handled in ExtendedMenu.es6.js
                                                                                                                                                                                                                                                                                                                                                                                               * @dependencies: Jquery, KEYCODES
                                                                                                                                                                                                                                                                                                                                                                                               * @references  : https://www.w3.org/TR/WCAG20-TECHS/
                                                                                                                                                                                                                                                                                                                                                                                               *                https://www.w3.org/TR/wai-aria-practices/examples/menu-button/menu-button-links.html
                                                                                                                                                                                                                                                                                                                                                                                               */
var ContextMenuAccessibility = /*#__PURE__*/function () {
  function ContextMenuAccessibility() {
    _classCallCheck(this, ContextMenuAccessibility);
    // #. To keep the menu opening button collection
    this.$menuOpenButtons = [];
    // #. CSS class selector of module library menu open button
    this.moduleLibraryButtonSelector = '.icon.showModuleLibrary';
    // #. CSS selector of module content header menu button
    this.moduleHeaderButton = 'table.headerContent .controls .control .icon.options';
    // #. CSS selector of context menu open button
    this.menuOpener = 'button.icon.options';
    // #. Const to declare the button context type
    this.contextType = {
      MODULE_LIBRARY: 1,
      MODULE_CONTROL: 2,
      TABLE_ROW_EDIT: 3
    };
  }

  /**
   * @method init
   * @description Initialize the menu accessibility
   * @public
   */
  _createClass(ContextMenuAccessibility, [{
    key: "init",
    value: function init() {
      // #. Get menu opening button elements
      this.$menuOpenButtons = this._findMenuOpenButtons();
      this._start();
    }

    /**
     * @method _start
     * @description start the basic methods, assign attributes, bind key handler
     * @private
     */
  }, {
    key: "_start",
    value: function _start() {
      // #. Handle the focus, keydown event
      this._bindTrackingEvents();

      // #. Check the count of the streaming nodes
      if (this.$menuOpenButtons.length > 0) {
        this._setWCAGAttributesToButton(this.$menuOpenButtons);
      }
    }

    /**
     * @method _findMenuOpenButtons
     * @description find all menu opening buttons from the body element
     * @return { Array } of menu open button elements
     * @private
     */
  }, {
    key: "_findMenuOpenButtons",
    value: function _findMenuOpenButtons() {
      var $body = $('body');
      return $([].concat(_toConsumableArray($body.find(this.menuOpener)), _toConsumableArray($body.find(this.moduleLibraryButtonSelector))));
    }

    /**
     * @method _setWCAGAttributesToButton
     * @description find all menu opening buttons from the body element
     * @param { HTMLCollectionOf } $buttons expecting collection menu open button elements
     * @private
     */
  }, {
    key: "_setWCAGAttributesToButton",
    value: function _setWCAGAttributesToButton($buttons) {
      $buttons.attr({
        'aria-haspopup': 'menu',
        'aria-expanded': false
      });

      // #. Set unique properties
      this._setButtonUniqueProps($buttons);
    }

    /**
     * @method _setButtonUniqueProps
     * @description set unique button properties
     * @param { HTMLCollectionOf } $buttons expecting collection menu open button elements
     * @private
     */
  }, {
    key: "_setButtonUniqueProps",
    value: function _setButtonUniqueProps($buttons) {
      var _iterator = _createForOfIteratorHelper($buttons),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var $button = _step.value;
          $button = $($button);
          var contextType = this._getContextType($button);

          // #. Update the button title
          this._updateButtonTitle($button, contextType, false);

          // #. Set role application for the module head control div element
          // #. otherwise, keydown will not work properly when JAWS is working
          if (contextType === this.contextType.MODULE_CONTROL) {
            $button.closest('.control').attr({
              role: 'application'
            });
          } else {
            // #. Remove the innerText of the image button, because button already has the title
            var bgImg = String($button.css('background-image')).trim();
            if (bgImg && bgImg !== 'none' && !$button.hasClass('include-text')) {
              $button.text('');
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    /**
     * @method _updateButtonTitle
     * @description update button title based on the context
     *              - Button from the table row
     *              - Button from the module header
     *              - Module library button
     * @param { HTMLElement } $button expecting menu open button object
     * @param { Number } button context type
     * @private
     */
  }, {
    key: "_updateButtonTitle",
    value: function _updateButtonTitle($button, contextType, isOnFocus) {
      var label = this._getTitleByButtonContext($button, contextType, isOnFocus);
      if (label) {
        $button.attr({
          'aria-label': label
        });
      }
    }

    /**
     * @method _getContextType
     * @description get type of button context
     * @param { HTMLElement } $button expecting current button element
     * @private
     */
  }, {
    key: "_getContextType",
    value: function _getContextType($button) {
      if ($button.parent().is('td')) {
        return this.contextType.TABLE_ROW_EDIT;
      } else if ($button.is(this.moduleHeaderButton)) {
        return this.contextType.MODULE_CONTROL;
      } else if ($button.is(this.moduleLibraryButtonSelector)) {
        return this.contextType.MODULE_LIBRARY;
      }
    }

    /**
     * @method _setTitleByButtonContext
     * @description get title/name based on the button context
     * @param { HTMLElement } $button expecting current button element
     * @param { Number } button context type
     * @private
     */
  }, {
    key: "_getTitleByButtonContext",
    value: function _getTitleByButtonContext($button, contextType, isOnFocus) {
      // 1. Get name/title of the table row menu button
      if (contextType === this.contextType.TABLE_ROW_EDIT) {
        var name = this._getInstrumentNameByRow($button) || '';
        return window.getMessage('context.menu.open.name.postfix.tooltip', name);
      }

      // 2. Get name/title of module header menu button
      if (contextType === this.contextType.MODULE_CONTROL) {
        var _name = this._getTitleFromModuleHeader($button) || '';
        // #. Header title text may be 'loading...' when module not loaded yet
        // #. Updated title will be set on the focus event
        if (!isOnFocus) {
          return false;
        }
        return window.getMessage('context.menu.module.open.name.postfix.tooltip', _name);
      }

      // 3. Get module library button
      if (contextType === this.contextType.MODULE_LIBRARY) {
        return $button.attr('title');
      }
    }

    /**
     * @method _getInstrumentNameByRow
     * @description get instrument name from table row
     * @param { HTMLElement } $button expecting current button element
     * @private
     */
  }, {
    key: "_getInstrumentNameByRow",
    value: function _getInstrumentNameByRow($button) {
      var $row = $($button.closest('tr'));
      return $row.find('a.instrumentIdentification').text() || $row.find('span.instrumentIdentification').text() || $row.find('input.searchPopupInput').val() || $row.find('a').first().text();
    }

    /**
     * @method _getTitleFromModuleHeader
     * @description get title from the module header element
     * @param { HTMLElement } $button expecting current button element
     * @private
     */
  }, {
    key: "_getTitleFromModuleHeader",
    value: function _getTitleFromModuleHeader($button) {
      var $row = $($button.closest('tr'));
      return $row.find('h2.title').text() || $row.find('span.content').text();
    }

    /**
     * @method _bindTrackingEvents
     * @description update attributes of lately rendered element(Ex: Modules added from the module library, menu button render after large table sorting...etc)
     * @private
     */
  }, {
    key: "_bindTrackingEvents",
    value: function _bindTrackingEvents() {
      var self = this;
      $(window.document).on('focus', this.menuOpener, function (event) {
        var $button = $(this);
        $button.attr('aria-expanded', false);
        if (!$button.attr('aria-label')) {
          var contextType = self._getContextType($button);
          self._updateButtonTitle($button, contextType, true);
        }
      }).on('keydown', this.menuOpener, function (event) {
        var $button = $(this);
        var keyCode = event.keyCode;
        if (keyCode === _keyCodes.default.ENTER) {
          $button.attr('aria-expanded', true);
        }
      });
    }
  }]);
  return ContextMenuAccessibility;
}();
var _default = exports.default = ContextMenuAccessibility;

},{"util/enums/keyCodes":14}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _messageHandler = require("fcom/messages/messageHandler");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * @class       : HighchartsAccessibility
 * @description : To enable the web content accessibility(WCAG) in ngp application highcharts/highstocks
 *                - https://jira.financial.com/browse/NGPII-15551
 * @dependencies: Highcharts, Highstocks, highchart-exporting, highchart-exporting-data, highcharts-accessibility
 * @references  : https://www.highcharts.com/docs/accessibility/accessibility-module
 *              : https://www.highcharts.com/docs/extending-highcharts/extending-highcharts
 *              : https://www.highcharts.com/docs/getting-started/how-to-set-options
 */
var HighchartsAccessibility = /*#__PURE__*/function () {
  function HighchartsAccessibility(options) {
    _classCallCheck(this, HighchartsAccessibility);
    // #. Keep the config/options into context
    this.options = options;
    // #. Get the highcharts object
    this.H = window.Highcharts;
    // #. Set accessibility options
    this.accessibilityOptions = {
      accessibility: {
        enabled: true,
        keyboardNavigation: {
          enabled: true,
          seriesNavigation: {
            mode: 'normal',
            skipNullPoints: true
          }
        },
        announceNewData: {
          enabled: true,
          interruptUser: true
        }
      }
    };
  }

  /**
   * @method init
   * @description Initialize the highcharts accessibility
   * @public
   */
  _createClass(HighchartsAccessibility, [{
    key: "init",
    value: function init() {
      var self = this;
      /**
       * Enable the chart accessibility globally
       */
      window.Highcharts.setOptions(this.accessibilityOptions);

      /**
       * NOTE:
       * Highcharts created a utility called wrap, which wraps an existing prototype function ("method") and -
       * allows you to add your own code before or after it.
       */

      /**
       * Extend the chart render method
       * To assign the proper role attribute to container element - for screen reader
       */
      this.H.wrap(this.H.Chart.prototype, 'onload', function (proceed) {
        proceed.call(this, arguments);
        self._setWCAGtoChart(this.renderTo);
        self._handleFirefoxTabKeyOrder(this.container);
        self._handleEdgeAccessToChart(this.container);
      });

      /**
       * Extend the tooltip refresh method
       * To assign the tooltip to proper role attributes - for screen reader
       */
      this.H.wrap(this.H.Tooltip.prototype, 'refresh', function (proceed, point, e) {
        proceed.call(this, point, e);
        self._setWCAGtoChartTooltip(this.chart.tooltip.container || this.chart.renderTo);
      });

      /**
       * Extend the tooltip hide method
       * To assign the tooltip table hidden - for screen reader
       */
      this.H.wrap(this.H.Tooltip.prototype, 'hide', function (proceed, point, e) {
        proceed.call(this, point, e);
        self._setWCAGtoHiddenTooltipTable(this.chart.renderTo);
      });

      /**
       * Extend the tooltip show method
       * To assign the tooltip table shown - for screen reader
       */
      this.H.wrap(this.H.Tooltip.prototype, 'show', function (proceed, point, e) {
        proceed.call(this, point, e);
        self._setWCAGtoShownTooltipTable(this.chart.renderTo);
      });
    }
  }, {
    key: "_setWCAGtoHiddenTooltipTable",
    value: function _setWCAGtoHiddenTooltipTable(chartContainer) {
      $(chartContainer).find('div.highcharts-tooltip table').attr('aria-hidden', true);
    }
  }, {
    key: "_setWCAGtoShownTooltipTable",
    value: function _setWCAGtoShownTooltipTable(chartContainer) {
      $(chartContainer).find('div.highcharts-tooltip table').attr('aria-hidden', false);
    }

    /**
     * @method _setWCAGtoChart
     * @description update WCAG attributes to highcharts
     * @param { $chartContainer } expecting chart container html element object
     * @private
     */
  }, {
    key: "_setWCAGtoChart",
    value: function _setWCAGtoChart($chartContainer) {
      $($chartContainer).attr({
        role: 'application'
      });
      if ($('#additionalChartTitleId').length > 0) {
        $($chartContainer).find('.highcharts-container').attr('aria-describedby', 'additionalChartTitleId');
      }
      $($chartContainer).find('[id*="highcharts-data-table"]').attr('aria-hidden', true);
    }

    /**
     * @method _setWCAGtoChartTooltip
     * @description update WCAG attributes to highcharts tooltip
     * @param { $chartContainer } expecting chart container html element object
     * @private
     */
  }, {
    key: "_setWCAGtoChartTooltip",
    value: function _setWCAGtoChartTooltip($chartContainer) {
      var $tooltip = $($chartContainer).find('div.highcharts-tooltip > span');
      if ($tooltip.length > 0) {
        $tooltip.attr('role', 'tooltip');
        $tooltip.attr('aria-live', 'assertive');
        var $tooltipTable = $tooltip.find('table');
        if ($($tooltipTable).find('caption').length === 0) {
          $tooltipTable.prepend($('<caption />').text((0, _messageHandler.getMessage)('chart.tooltip.table.caption')).addClass('visuallyhidden'));
        }
      }
    }

    /**
     * @method _handleFirefoxTabKeyOrder
     * @description set tab key order for the module chart
     * @param { $chartContainer } expecting chart container html element object
     * @private
     */
  }, {
    key: "_handleFirefoxTabKeyOrder",
    value: function _handleFirefoxTabKeyOrder($chartContainer) {
      var isFirefox = navigator.userAgent.search('Firefox');
      var $moduleLink = $($chartContainer).closest('.chartImageBox').children().first();
      if (isFirefox > -1 && $moduleLink.is('a')) {
        $moduleLink.attr('tabindex', -1);
      }
    }

    /**
     * @method _handleEdgeAccessToCahrt
     * @description set descriptive label
     * @param { $chartContainer } expecting chart container html element object
     * @private
     */
  }, {
    key: "_handleEdgeAccessToChart",
    value: function _handleEdgeAccessToChart($chartContainer) {
      var isEdge = navigator.userAgent.search('Edg');
      if (isEdge > -1) {
        var chartContainerId = $($chartContainer).attr('id');
        var describedLabelEle = $('<span>').attr('id', "".concat(chartContainerId, "_describedId")).addClass('visuallyhidden').text((0, _messageHandler.getMessage)('chart.descriptive.text.edg'));
        $($chartContainer).find('svg.highcharts-root').attr('aria-describedby', "".concat(chartContainerId, "_describedId")).before(describedLabelEle);
      }
    }
  }]);
  return HighchartsAccessibility;
}();
var _default = exports.default = HighchartsAccessibility;

},{"fcom/messages/messageHandler":11}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * @class       : LoginAccessibility
 * @description : To enable the web content accessibility(WCAG) in login page
 * @references  : https://developer.mozilla.org/en-US/docs/Web/API/Window/devicePixelRatio#monitoring_screen_resolution_or_zoom_level_changes
 */
var LoginAccessibility = /*#__PURE__*/function () {
  function LoginAccessibility() {
    _classCallCheck(this, LoginAccessibility);
    this.loginElement = $('div.login').get(0);
  }

  /**
   * @method init
   * @description Initialize login accessibility
   * @public
   */
  _createClass(LoginAccessibility, [{
    key: "init",
    value: function init() {
      this._initAccessibility();
    }

    /**
     * @method _initAccessibility
     * @description calling methods for wcag
     * @private
     */
  }, {
    key: "_initAccessibility",
    value: function _initAccessibility() {
      this._onPageZoomEvent();
    }

    /**
     * @method _onPageZoomEvent
     * @description when page zoom change, call method to set the scrollbarState
     * @private
     */
  }, {
    key: "_onPageZoomEvent",
    value: function _onPageZoomEvent() {
      var _this = this;
      var updatePixelRatio = function updatePixelRatio() {
        var pr = window.devicePixelRatio;
        var prString = (pr * 100).toFixed(0);
        _this._setScrollBarState();
        matchMedia("(resolution: ".concat(pr, "dppx)")).addEventListener("change", updatePixelRatio, {
          once: true
        });
      };
      updatePixelRatio();
    }

    /**
     * @method hasVerticalScrollBar
     * @returns {boolean}
     * @private
     */
  }, {
    key: "_hasVerticalScrollBar",
    value: function _hasVerticalScrollBar() {
      return this.loginElement.scrollHeight > this.loginElement.clientHeight;
    }

    /**
     * @method _checkLoginContainerScrolling
     * @description add css class hasScrollBar to scrolling login element
     * @private
     */
  }, {
    key: "_setScrollBarState",
    value: function _setScrollBarState() {
      if (this._hasVerticalScrollBar() === true) {
        $(this.loginElement).addClass('hasScrollBar');
      } else {
        $(this.loginElement).removeClass('hasScrollBar');
      }
    }
  }]);
  return LoginAccessibility;
}();
var _default = exports.default = LoginAccessibility;

},{}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * @class       : TopNewsAccessibility
                                                                                                                                                                                                                                                                                                                                                                                               * @description : To enable the web content accessibility(WCAG) in top news module component
                                                                                                                                                                                                                                                                                                                                                                                               *                - GPNGPII-16881 - Keyboard access not enabled for TOP NEWS Module
                                                                                                                                                                                                                                                                                                                                                                                               * @dependencies: Jquery, KEYCODES
                                                                                                                                                                                                                                                                                                                                                                                               * @references  : https://www.w3.org/WAI/tutorials/carousels/
                                                                                                                                                                                                                                                                                                                                                                                               */
var NewsPlayerAccessibility = /*#__PURE__*/function () {
  function NewsPlayerAccessibility(options) {
    _classCallCheck(this, NewsPlayerAccessibility);
    if (!options) {
      return true;
    }

    // #. Keep the config/options into context
    this.options = options;
    this.player = this.options.player;
  }

  // #. Get headline elements
  _createClass(NewsPlayerAccessibility, [{
    key: "$headlines",
    get: function get() {
      return $(this.player.container).find('.headline div');
    }

    // #. Get news module panel element
  }, {
    key: "$newsPlayerModulePanel",
    get: function get() {
      return $('#NewsPlayerModulePanel');
    }

    /**
     * @method init
     * @description Initialize the top news accessibility
     * @public
     */
  }, {
    key: "init",
    value: function init() {
      this._setWCAGAttributes();
    }

    /**
     * @method _setWCAGAttributes
     * @description set WCAG attributes to player elements
     * @private
     */
  }, {
    key: "_setWCAGAttributes",
    value: function _setWCAGAttributes() {
      $(this.player.moduleContainer).attr('role', 'presentation');
      $(this.player.controlBar).attr('role', 'application');
      // #. Set headline attributes
      this._setWCAGToHeadlines();
      // #. Set control buttons attributes
      this._setWCAGToControlButtons();
    }

    /**
     * @method _setWCAGToHeadlines
     * @description set WCAG attributes/events to headline element
     * @private
     */
  }, {
    key: "_setWCAGToHeadlines",
    value: function _setWCAGToHeadlines() {
      var _this = this;
      // #. Set aria-haspopup attribute to headline
      this.$headlines.attr({
        role: 'link',
        'aria-haspopup': true
      });

      // # on bind required for the streaming updates(lately rendered elements)
      $(this.player.container).off('focus', '.headline div');
      $(this.player.container).on('focus', '.headline div', function (event) {
        _this._onHeadlineFocused(event);
      });
      $(this.player.container).off('keydown');
      $(this.player.container).on('keydown', '.headline div', function (event) {
        if (event.keyCode === _keyCodes.default.ENTER) {
          $(event.target).trigger('click');
        }
      });

      // #. application role required to handle the custom keydown event(override screen reader)
      this.$headlines.parent().attr('role', 'application');
    }

    /**
     * @method _setWCAGToControlButtons
     * @description set WCAG attributes to player control button elements
     * @private
     */
  }, {
    key: "_setWCAGToControlButtons",
    value: function _setWCAGToControlButtons() {
      var attr = {
        role: 'button',
        tabindex: 0
      };

      // #. List of player control buttons
      var $buttons = [this.player.previousButton, this.player.nextButton, this.player.playButton, this.player.stopButton];
      var buttonTitles = ['news.topNews.player.previous', 'news.topNews.player.next', 'news.topNews.player.start', 'news.topNews.player.stop'];
      var self = this;
      for (var i = 0; i < $buttons.length; i++) {
        var $buttonActive = $($buttons[i]);
        // Get button title
        attr.title = window.getMessage(buttonTitles[i]);
        // #. Set the attributes
        $buttonActive.attr(attr);
        // #. Bind keydown - Enter should trigger the click event
        $buttonActive.off('keydown');
        $buttonActive.on('keydown', function (event) {
          self._onControlButtonsEventTriggered(event);
        });
        $buttonActive.off('focusout');
        $buttonActive.on('focusout', function (event) {
          $(this).removeAttr('aria-label');
        });
      }
    }

    /**
     * @method _onControlButtonsEventTriggered
     * @description handle the control button events
     * @param { KeydownEvent } event - Keyboard event
     * @private
     */
  }, {
    key: "_onControlButtonsEventTriggered",
    value: function _onControlButtonsEventTriggered(event) {
      var _this2 = this;
      if (event.keyCode === _keyCodes.default.ENTER || event.keyCode === _keyCodes.default.SPACE) {
        var $button = $(event.target);
        var triggerFocus = function triggerFocus() {
          var activeNews = _this2._getActiveNews();
          $button.blur();
          setTimeout(function () {
            $button.attr('aria-label', activeNews).focus();
          }, 50);
        };
        // #. Active element is Stop then focus will be move to Play
        if ($button.is(this.player.stopButton)) {
          this.player.stopAutoplay();
          $(this.player.playButton).css('display', 'inline').focus();
        } else
          // #. Active element is Play then focus will be move to Stop
          if ($button.is(this.player.playButton)) {
            this.player.startAutoplay();
            $(this.player.stopButton).css('display', 'inline').focus();
          } else if ($button.is(this.player.previousButton)) {
            this.player.showPrevious();
            triggerFocus();
          } else if ($button.is(this.player.nextButton)) {
            this.player.showNext();
            triggerFocus();
          }
      }
    }

    /**
     * @method _getActiveNews
     * @description get active news item
     * @private
     */
  }, {
    key: "_getActiveNews",
    value: function _getActiveNews() {
      var $activeNews = $(this.player.container).find('.pictureNewsItem').filter(function () {
        return $(this).css('visibility') === 'visible';
      });
      return $activeNews.find('.headline').text();
    }

    /**
     * @method _onHeadlineFocused
     * @description handle the headline focus event - to show the control buttons(like mouse over)
     * @param { FocusEvent } event - focus event
     * @private
     */
  }, {
    key: "_onHeadlineFocused",
    value: function _onHeadlineFocused(event) {
      // #. Stop the autoplay
      $(this.player.stopButton).click();
      // #. Show proper control buttons
      $(this.player.previousButton).css('display', 'inline');
      $(this.player.nextButton).css('display', 'inline');
      $(this.player.playButton).css('display', 'inline');
    }
  }]);
  return NewsPlayerAccessibility;
}();
var _default = exports.default = NewsPlayerAccessibility;

},{"util/enums/keyCodes":14}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * @class       : PopupSearchAccessibility
                                                                                                                                                                                                                                                                                                                                                                                               * @description : To enable the web content accessibility(WCAG) in the streaming nodes
                                                                                                                                                                                                                                                                                                                                                                                               *                NGPII-15056 - Bonds page - Ticker/ISIN field tag widgets not accessible using keyboard
                                                                                                                                                                                                                                                                                                                                                                                               * @dependencies: Jquery, KEYCODES
                                                                                                                                                                                                                                                                                                                                                                                               */
var PopupSearchAccessibility = /*#__PURE__*/function () {
  function PopupSearchAccessibility(options) {
    _classCallCheck(this, PopupSearchAccessibility);
    // #. Set accessibility config options
    this.options = options || {};
  }

  /**
   * @method init
   * @description Initialize the popup search accessibility
   * @public
   */
  _createClass(PopupSearchAccessibility, [{
    key: "init",
    value: function init() {
      this._start();
    }

    /**
     * @method _start
     * @description start the basic methods, assign attributes, bind key handler
     * @private
     */
  }, {
    key: "_start",
    value: function _start() {
      // #. check whether the search is multi-select or not
      if (this.options.multiSelect) {
        this._setMultiSelectAccessibility();
      }
    }

    /**
     * @method _setMultiSelectAccessibility
     * @description Initialize the multiselect popup search accessibility
     * @private
     */
  }, {
    key: "_setMultiSelectAccessibility",
    value: function _setMultiSelectAccessibility() {
      var _this = this;
      this.$tagContainer = $(this.options.container);
      this.$textInput = $(this.options.textField);
      this.tagSelector = '.popupsearch-tag';

      // #. Set the role to container element
      this.$tagContainer.attr('role', 'application');

      // #. bind keydown event to tag container element
      this.$tagContainer.on('keydown', this.tagSelector, function (event) {
        _this._onTagKeyHandler(event);
      });

      // #. bind keydown event to input element
      this.$textInput.on('keydown', function (event) {
        _this._oninputKeyHandler(event);
      });
    }

    /**
     * @method _setWCAGAttributes
     * @description seet necessary attributes to elements
     * @private
     */
  }, {
    key: "_setWCAGAttributes",
    value: function _setWCAGAttributes() {
      this.$tagContainer.find(this.tagSelector).attr({
        tabindex: 0
      });
    }

    /**
     * @method _onTagKeyHandler
     * @description key handler for the tag elements
     * @private
     */
  }, {
    key: "_onTagKeyHandler",
    value: function _onTagKeyHandler(event) {
      var keyCode = event.keyCode;
      var $activeTag = $(event.target);
      // #. ARROW-UP/LEFT will set the focus to previous tag
      // #. ARROW-DOWN/RIGHT will set the focus to next tag or text input
      // #. DELETE - will delete the item from the list
      if (keyCode === _keyCodes.default.ARROW_UP || keyCode === _keyCodes.default.ARROW_LEFT) {
        event.preventDefault();
        // #. get previous tag and set focus
        var $prevTag = $activeTag.prev(this.tagSelector);
        $prevTag.length > 0 && $prevTag.focus();
      } else if (keyCode === _keyCodes.default.ARROW_DOWN || keyCode === _keyCodes.default.ARROW_RIGHT) {
        event.preventDefault();
        var $nextTag = $activeTag.next(this.tagSelector);
        var $focusableEl = $nextTag.length > 0 ? $nextTag : this.$textInput;
        $focusableEl.focus();
      } else if (keyCode === _keyCodes.default.DELETE) {
        event.preventDefault();
        $activeTag.find('.remove').click();
      }
    }

    /**
     * @method _onInputKeyHandler
     * @description key handler for the input element
     * @private
     */
  }, {
    key: "_oninputKeyHandler",
    value: function _oninputKeyHandler(event) {
      var keyCode = event.keyCode;
      if (keyCode === _keyCodes.default.TAB && event.shiftKey || keyCode === _keyCodes.default.ARROW_UP || keyCode === _keyCodes.default.ARROW_LEFT) {
        event.preventDefault();
        // #. Set the attributes, inside the event because of new tag elements requires attributes
        this._setWCAGAttributes();
        // #. Handle the event
        this._onInputArrowEvent();
      }
    }

    /**
     * @method _onInputArrowEvent
     * @description on input element arrow events
     * @private
     */
  }, {
    key: "_onInputArrowEvent",
    value: function _onInputArrowEvent() {
      // #. Arrow left/up from input element will be set the focus to the last tag element
      this.$tagContainer.find(this.tagSelector).last().focus();
    }
  }]);
  return PopupSearchAccessibility;
}();
var _default = exports.default = PopupSearchAccessibility;

},{"util/enums/keyCodes":14}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * @class       : StreamingAccessibility
                                                                                                                                                                                                                                                                                                                                                                                               * @description : To enable the web content accessibility(WCAG) in the streaming nodes
                                                                                                                                                                                                                                                                                                                                                                                               *                NGPII-15978 - Enable accessibility in the ShowMessage(New Message) Icon
                                                                                                                                                                                                                                                                                                                                                                                               * @dependencies: Jquery, KEYCODES
                                                                                                                                                                                                                                                                                                                                                                                               * @references  : https://www.w3.org/TR/WCAG20-TECHS/
                                                                                                                                                                                                                                                                                                                                                                                               *                https://www.w3.org/TR/wai-aria-1.1/#tooltip
                                                                                                                                                                                                                                                                                                                                                                                               */
var StreamingAccessibility = /*#__PURE__*/function () {
  function StreamingAccessibility() {
    _classCallCheck(this, StreamingAccessibility);
    // #. To keep the news message button collection
    this.$newMessageButtons = [];
    // #. CSS selector of a new message icon element
    this.newsMessageSelector = 'a.newmessage';
  }

  /**
   * @method init
   * @description Initialize the streaming accessibility
   * @public
   */
  _createClass(StreamingAccessibility, [{
    key: "init",
    value: function init($node) {
      // #. Get news message button elements
      this.$newMessageButtons = this._findNewMessageButtons($node);
      this._start();
    }

    /**
     * @method update
     * @description Update the reloaded nodes with accessibility feature, same as init but a wrapper method
     * @public
     */
  }, {
    key: "update",
    value: function update($node) {
      // #. Get news message button elements
      this.$newMessageButtons = this._findNewMessageButtons($node);
      this._start();
    }

    /**
     * @method _start
     * @description start the basic methods, assign attributes, bind key handler
     * @private
     */
  }, {
    key: "_start",
    value: function _start() {
      // #. Check the count of the streaming nodes
      if (this.$newMessageButtons.length === 0) {
        return true;
      }

      // #. Set WCAG attributes
      this._setWCAGAttributes(this.$newMessageButtons);

      // #. Bind the keyboard accessibility event
      this._bindKeyHandler(this.$newMessageButtons);
    }

    /**
     * @method _findNewsMessageButtons
     * @description find the new message button collection from the streaming nodes collection
     * @param { HTMLCollectionOf } $nodes expecting streaming node element collection
     * @return { HTMLCollectionOf } new message button elements
     * @private
     */
  }, {
    key: "_findNewMessageButtons",
    value: function _findNewMessageButtons($nodes) {
      return $nodes.find(this.newsMessageSelector);
    }

    /**
     * @method _setWCAGAttributes
     * @description set WCAG attributes like aria-haspopup, aria-pressed to element
     * @param { HTMLCollectionOf }  { $elements } expecting html element collection
     * @private
     */
  }, {
    key: "_setWCAGAttributes",
    value: function _setWCAGAttributes($elements) {
      var hiddenTooltipContainer = $('<span></span>').attr('id', 'hiddenTooltipContainer').addClass('visuallyhidden');
      if ($('#hiddenTooltipContainer').length === 0) {
        $('body').append($(hiddenTooltipContainer));
      }
      $elements.attr({
        'aria-describedby': 'hiddenTooltipContainer'
      });

      // #. Apply role attribute to the parent table
      $elements.closest('td').attr({
        role: 'application'
      });

      // #. Update the title/arial-labelledby attributes
      this._updateShowMessageTitle($elements);
    }

    /**
     * @method _updateAttributes
     * @description update attribute of an element
     * @param { HTMLElement } $element expecting a html element
     * @param { Object } attributes expecting an object with updated attributes
     * @private
     */
  }, {
    key: "_updateAttributes",
    value: function _updateAttributes($element, attributes) {
      $element.attr(attributes);
    }

    /**
     * @method _bindKeyHandler
     * @description bind the keydown event and handle the event
     * @param { HTMLCollectionOf } $elements expecting html element collection
     * @private
     */
  }, {
    key: "_bindKeyHandler",
    value: function _bindKeyHandler($elements) {
      var _this = this;
      $elements.attr('tabindex', 0).on('keydown', function (event) {
        _this._onKeyHandlerUpdated(event);
      }).on('focus', function (event) {
        _this._onFocusHandlerUpdate(event);
      }).on('blur', function (event) {
        _this._onTabKeyPressed(event);
      });
    }

    /**
     * @method _onKeyHandlerUpdated
     * @description handle the keydown event
     * @param Event#keydown expecting keydown event object
     * @private
     */
  }, {
    key: "_onKeyHandlerUpdated",
    value: function _onKeyHandlerUpdated(event) {
      var keyCode = event.keyCode;
      if (keyCode === _keyCodes.default.TAB) {
        this._onTabKeyPressed(event);
      }
    }
  }, {
    key: "_onFocusHandlerUpdate",
    value: function _onFocusHandlerUpdate(event) {
      // #. Get the active element
      var $element = $(event.target);
      // #. Call the trigger event
      $element.attr({
        'aria-describedby': 'ngpTooltipNews'
      });
      this._triggerEvent($element, 'mouseover', event);
    }

    /**
     * @method _onTabKeyPressed
     * @description handle the tab key
     * @param Event#keydown expecting keydown event object
     * @private
     */
  }, {
    key: "_onTabKeyPressed",
    value: function _onTabKeyPressed(event) {
      // #. Get the active element
      var $element = $(event.target);
      // #. Call the trigger event
      this._triggerEvent($element, 'mouseout', event);
      $('#hiddenTooltipContainer').remove();
    }

    /**
     * @method _getStreamingContext
     * @description get streaming context if element is replaced with illustrate method
     * @param { HTMLElement } $element expecting current active element
     * @private
     */
  }, {
    key: "_getStreamingContext",
    value: function _getStreamingContext($element) {
      return $element.data('streaming-context');
    }

    /**
     * @method _triggerEvent
     * @description trigger event based on element environment
     * @param { HTMLElement } $element expecting current active element
     * @private
     */
  }, {
    key: "_triggerEvent",
    value: function _triggerEvent($element, eventName, event) {
      var streamingContext = this._getStreamingContext($element);
      /**
       * illustrateStreaming method from LastNewsFormatter replace the news message icon
       * mouseout event not available to this newly created element
       * keep the context as data attribute and invoke the hide tooltip method explicitly
       */
      if (streamingContext && streamingContext.hideInfo && eventName === 'mouseout') {
        streamingContext.hideInfo(event);
      } else {
        // #. Trigger the element event
        $element.trigger(eventName);
      }
    }

    /**
     * @method _updateShowMessageTitle
     * @description update show message title/arial-labelledby with the instrument name
     * @param { HTMLCollectionOf } $elements expecting collection of html element objects
     * @private
     */
  }, {
    key: "_updateShowMessageTitle",
    value: function _updateShowMessageTitle($elements) {
      var _iterator = _createForOfIteratorHelper($elements),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var $element = _step.value;
          $element = $($element);
          var title = this._getInstrumentNameByRow($element) || '';

          // #. Update the title with the instrument name in the row
          title = window.getMessage('title.streaming.showMessage', title);
          $element.attr('aria-label', title);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    /**
     * @method _getInstrumentNameByRow
     * @description get the instrument name by the element closest row
     * @param { HTMLElement } $element expecting an HTML element
     * @private
     */
  }, {
    key: "_getInstrumentNameByRow",
    value: function _getInstrumentNameByRow($element) {
      var $row = $($element.closest('tr'));
      return $row.find('a.instrumentIdentification').text() || $row.find('span.instrumentIdentification').text() || $row.find('input.searchPopupInput').val() || $row.find('a').first().text();
    }
  }]);
  return StreamingAccessibility;
}(); // #. Export the class
var _default = exports.default = StreamingAccessibility;

},{"util/enums/keyCodes":14}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
var _tabmenuAccessibility = require("aria/tabmenuAccessibility");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * @class       : TooltipAccessibility
                                                                                                                                                                                                                                                                                                                                                                                               * @description : To enable the web content accessibility(WCAG) in ngp application tooltip views
                                                                                                                                                                                                                                                                                                                                                                                               *                - NGPII-15117 Keyboard: QuickView Panel
                                                                                                                                                                                                                                                                                                                                                                                               * @dependencies: Jquery
                                                                                                                                                                                                                                                                                                                                                                                               * @references  : https://www.w3.org/TR/wai-aria-practices-1.1/examples/accordion/accordion.html
                                                                                                                                                                                                                                                                                                                                                                                               */
var TooltipAccessibility = /*#__PURE__*/function () {
  function TooltipAccessibility(options) {
    _classCallCheck(this, TooltipAccessibility);
    // #. Keep the config/options into context
    this.options = options;

    // #. Active element Identity
    this.ACTIVE_ELEMENT = {
      PANEL: 1,
      CHART: 2,
      CLOSE_BUTTON: 3,
      FIRST_MENU_ITEM: 4,
      FIRST_HEADER_BUTTON: 5,
      NEWS: 6
    };

    // #. Quick view menu identity
    this.QUICK_VIEW_MENU = {
      CHART: '#quickViewMenu\\.chart',
      RATIO: '#quickViewMenu\\.ratios',
      NEWS: '#quickViewMenu\\.news'
    };

    // #. Session storage key
    this.sessionKey = 'quick-panel-status';
  }

  /**
   * @method init
   * @description Initialize the tooltip/tooltip-target accessibility
   * @public
   */
  _createClass(TooltipAccessibility, [{
    key: "$quickView",
    get:
    // #. Quick view container selector
    function get() {
      return $('#ngpQuickview');
    }

    // #. Keep the quick view header
  }, {
    key: "$quickViewHeader",
    get: function get() {
      return this.$quickView.find('#quickViewHeader');
    }

    // #. Keep the quick view body
  }, {
    key: "$quickViewBody",
    get: function get() {
      return this.$quickView.find('#quickViewBody');
    }

    // #. Get the active element from dom
  }, {
    key: "$activeElement",
    get: function get() {
      return $(document.activeElement);
    }

    // #. Get first menu item from the body
  }, {
    key: "$firstMenuItem",
    get: function get() {
      return this.$quickViewBody.find('.menuItem.first button');
    }

    // #. Get last menu item from the body
  }, {
    key: "$lastMenuItem",
    get: function get() {
      return this.$quickViewBody.find('.menuItem button').last();
    }

    // #. Get chart container
  }, {
    key: "$chartContainer",
    get: function get() {
      return this.$quickViewBody.find('.highcharts-container');
    }

    // #. News table
  }, {
    key: "$newsTable",
    get: function get() {
      return this.$quickViewBody.find('#news_table');
    }

    // #. Get all button elements from header
  }, {
    key: "$headerButtons",
    get: function get() {
      return this.$quickViewHeader.find('.menu li.link');
    }

    // #. Get first button element from header
  }, {
    key: "$firstHeaderButton",
    get: function get() {
      return this.$headerButtons.first();
    }

    // #. Get close button
  }, {
    key: "$closeButton",
    get: function get() {
      return this.$quickViewHeader.find('#quickViewClose');
    }

    // #. Get aria-describedby element for the target
  }, {
    key: "$descriptionElement",
    get: function get() {
      var id = 'quick-view-target-desc';
      var $element = $('body').find("#".concat(id));
      // #. no hint element found, create a new one
      if ($element.length === 0) {
        $element = $('<span></span>').attr({
          id: id
        }).addClass('visuallyhidden').appendTo('body');
      }
      return $element;
    }

    // #. get focus status from session storage
  }, {
    key: "panelFocusStatus",
    get: function get() {
      return sessionStorage ? sessionStorage.getItem(this.sessionKey) : '0';
    }

    // #. set focus status to session storage
    ,
    set: function set(value) {
      sessionStorage && sessionStorage.setItem(this.sessionKey, value);
    }
  }, {
    key: "init",
    value: function init() {
      if (this.options.target) {
        this._bindTargetAccessibility();
      } else if (this.options.container) {
        this._bindPanelAccessibility();
        this._addAccessibilityAttributes();
        this._bindMenuItemLinkKeyHandler();
      }
    }

    /**
     * @method _bindTargetAccessibility
     * @description bind accessibility to the tooltip target
     * @private
     */
  }, {
    key: "_bindTargetAccessibility",
    value: function _bindTargetAccessibility() {
      var _this = this;
      $(window.document).on('tooltip-target-focus', this.options.target.selector, function (event, data) {
        if (data && data.panelFocusStatus) {
          _this.panelFocusStatus = data.panelFocusStatus;
        }
        event.currentTarget.focus();
      });
      // #. bind target focus - to trigger the mouseenter
      $(window.document).on('focusin', this.options.target.selector, function (event) {
        if (String($(event.target).attr(_this.options.target.attr)).includes(_this.options.target.contains)) {
          var $target = $(event.target);
          // #. Update the panel description text
          _this.$descriptionElement.text(window.getMessage('quickview.target.shortcut.title', $target.text()));
          // #. Set the attributes to target
          $target.attr({
            role: 'application',
            'aria-describedby': _this.$descriptionElement.attr('id')
          });
          window.setTimeout(function () {
            event.preventDefault();
            var status = _this.panelFocusStatus;
            if (status !== '1') {
              $target.trigger('mouseenter');
            }
            _this.panelFocusStatus = '1';
          }, 50);
        }
      });

      // #. bind target focusout - to manage the hide attr
      $(window.document).on('focusout', this.options.target.selector, function (event) {
        _this.panelFocusStatus = '0';
      });

      // #. bind target keydown event
      $(window.document).on('keydown', this.options.target.selector, function (event) {
        if (String($(event.target).attr(_this.options.target.attr)).includes(_this.options.target.contains)) {
          _this._onTargetKeyHandler(event);
        }
      });
    }

    /**
     * @method _onTargetKeyHandler
     * @description handle keydown of the tooltip target
     * @param { KeyboardEvent } event: keydown event
     * @private
     */
  }, {
    key: "_onTargetKeyHandler",
    value: function _onTargetKeyHandler(event) {
      var keyCode = event.keyCode;

      // #. Handle the keydown
      // #. Tab - will hide the quick view panel
      // #. ARR-LEFT - will set the focus to quick view panel
      if (keyCode === _keyCodes.default.TAB) {
        this._hideTooltip(false);
      } else if (keyCode === _keyCodes.default.ARROW_RIGHT) {
        this.$quickView.attr({
          tabindex: 0
        }).focus();
        this._setPanelWCAGRoles();
      }
    }

    /**
     * @method _setPanelWCAGRoles
     * @description set WCAG roles to the panel elements
     * @private
     */
  }, {
    key: "_setPanelWCAGRoles",
    value: function _setPanelWCAGRoles() {
      // #. Update the quick view tab menu accessibility
      var $menu = this.$quickView.find('div.moduleTabMenu div.menu');
      $menu.find('button.icon').attr('role', 'tab');
      (0, _tabmenuAccessibility.setAriaAttributesToModuleTabMenu)($menu);

      // #. Set live region roles
      this.$quickView.find('.moduleContent').attr('aria-live', 'polite');
    }

    /**
     * @method _bindPanelAccessibility
     * @description bind quick view panel accessibility
     * @private
     */
  }, {
    key: "_bindPanelAccessibility",
    value: function _bindPanelAccessibility() {
      var _this2 = this;
      // #. unbind the previously added event
      this.$quickView.off('keydown');
      // #. Bind keydown
      this.$quickView.attr('role', 'tooltip');
      this.$quickView.on('keydown', function (event) {
        _this2._onPanelKeyHandler(event);
      });
    }

    /**
     * @method _addAccessibilityAttributes
     * @description add necessary attributes to panel elements
     * @private
     */
  }, {
    key: "_addAccessibilityAttributes",
    value: function _addAccessibilityAttributes() {
      var _iterator = _createForOfIteratorHelper(this.$headerButtons),
        _step;
      try {
        var _loop = function _loop() {
          var $button = _step.value;
          $button = $($button);
          $button.attr({
            tabindex: 0,
            role: 'button'
          });

          // #. set the default pressed value
          $button.attr('aria-pressed', $button.hasClass('selected'));

          // Handle pressed attr on click event
          $button.on('click', function (event) {
            $button.attr('aria-pressed', $button.hasClass('selected'));
          });
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    /**
     * @method _bindMenuItemLinkKeyHandler
     * @description trigger menu item link click by using keyboard
     * @private
     */
  }, {
    key: "_bindMenuItemLinkKeyHandler",
    value: function _bindMenuItemLinkKeyHandler() {
      this.$headerButtons.on('keydown', function (event) {
        var keyCode = event.keyCode;
        if (keyCode === _keyCodes.default.SPACE || keyCode === _keyCodes.default.ENTER) {
          event.preventDefault();
          $(event.target).click();
        }
      });
    }

    /**
     * @method _onPanelKeyHandler
     * @description panel keydown event handler
     * @param { KeyboardEvent } event: keydown event
     * @private
     */
  }, {
    key: "_onPanelKeyHandler",
    value: function _onPanelKeyHandler(event) {
      var keyCode = event.keyCode;
      switch (keyCode) {
        case _keyCodes.default.TAB:
          this._onPanelTabKeyPressed(event);
          break;
        case _keyCodes.default.ARROW_LEFT:
        case _keyCodes.default.ESCAPE:
          this._hideTooltip(true);
          break;
        case _keyCodes.default.ARROW_DOWN:
          this._onPanelArrowDownPressed(event);
          break;
        case _keyCodes.default.ARROW_UP:
          this._onPanelArrowUpPressed(event);
          break;
      }
    }

    /**
     * @method _onPanelTabKeyPressed
     * @description handle tab key
     * @param { KeyboardEvent } event: keydown event
     * @private
     */
  }, {
    key: "_onPanelTabKeyPressed",
    value: function _onPanelTabKeyPressed(event) {
      var identity = this._getActiveElementIdentity();
      var result = false;
      switch (identity) {
        case this.ACTIVE_ELEMENT.PANEL:
          event.preventDefault();
          this._setFocusToActiveItemPart(false);
          break;
        case this.ACTIVE_ELEMENT.CHART:
          event.preventDefault();
          this.$chartContainer.blur();
          if (!event.shiftKey) {
            this._setFocusToRatio();
          } else {
            this.$lastMenuItem.focus();
          }
          break;
        case this.ACTIVE_ELEMENT.NEWS:
          event.preventDefault();
          if (!event.shiftKey) {
            this.$firstHeaderButton.focus();
          } else {
            this._setFocusToRatio(true);
          }
          break;
        case this.ACTIVE_ELEMENT.CLOSE_BUTTON:
          if (!event.shiftKey) {
            event.preventDefault();
            this._setFocusToActiveItemPart(false);
          }
          break;
        case this.ACTIVE_ELEMENT.FIRST_MENU_ITEM:
          result = true;
          if (event.shiftKey) {
            event.preventDefault();
            this.$closeButton.focus();
            result = false;
          }
          break;
        case this.ACTIVE_ELEMENT.FIRST_HEADER_BUTTON:
          if (event.shiftKey) {
            event.preventDefault();
            this._setFocusToActiveItemPart(true);
          }
          break;
        default:
          result = true;
          break;
      }
      return result;
    }

    /**
     * @method _onPanelArrowUpPressed
     * @description handle panel arrow up key
     * @param { KeyboardEvent } event: keydown event
     * @private
     */
  }, {
    key: "_onPanelArrowUpPressed",
    value: function _onPanelArrowUpPressed(event) {
      var identity = this._getActiveElementIdentity();
      if (identity === this.ACTIVE_ELEMENT.NEWS) {
        event.preventDefault();
        // #. Get active row
        var $activeRow = this.$activeElement;
        // #. Get all table rows except header
        var $rows = this.$newsTable.find('tr').not(':first');
        // #. Variable to keep the previous row
        var $row = null;
        // 1. If no rows selected yet, focus to last row
        // 2. If row is first row then, last row will select
        // 3. prev - select the previous row
        if (!$activeRow.is('tr')) {
          $row = $rows.last();
        } else if ($activeRow.is('tr')) {
          if ($activeRow.is($rows.first())) {
            $row = $rows.last();
          } else {
            $row = $activeRow.prev();
          }
        }
        if ($row) {
          $row.focus();
        }
      }
    }

    /**
     * @method _onPanelArrowDownPressed
     * @description handle arrow down key
     * @param { KeyboardEvent } event: keydown event
     * @private
     */
  }, {
    key: "_onPanelArrowDownPressed",
    value: function _onPanelArrowDownPressed(event) {
      var identity = this._getActiveElementIdentity();
      // #. Handle news table arrow down
      if (identity === this.ACTIVE_ELEMENT.NEWS) {
        event.preventDefault();
        // #. Get active row
        var $activeRow = this.$activeElement;
        // #. Get all table rows except header
        var $rows = this.$newsTable.find('tr').not(':first');
        // #. Variable to keep the next row
        var $row = null;
        // 1. If no rows selected yet, focus to first row
        // 2. If row is last row then, first row will select
        // 3. next - select next row
        if (!$activeRow.is('tr')) {
          $row = $rows.first();
        } else if ($activeRow.is('tr')) {
          if ($activeRow.is($rows.last())) {
            $row = $rows.first();
          } else {
            $row = $activeRow.next();
          }
        }
        if ($row) {
          $row.focus();
        }
      }
    }

    /**
    * @method _hideTooltip
    * @description hide the tooltip panel
    * @param { boolean } setFocusToTarget: to identify set focus to target element
    * @private
    */
  }, {
    key: "_hideTooltip",
    value: function _hideTooltip(setFocusToTarget) {
      this.$closeButton.trigger('click');
      if (this.options.$target) {
        var $target = $(this.options.$target);
        if (setFocusToTarget) {
          this.panelFocusStatus = '1';
          $target.focus();
        }
      }
    }

    /**
     * @method _getActiveElementIdentity
     * @description get active element identity
     * @private
     */
  }, {
    key: "_getActiveElementIdentity",
    value: function _getActiveElementIdentity() {
      var $activeElement = this.$activeElement;
      if ($activeElement.is(this.$quickView)) {
        return this.ACTIVE_ELEMENT.PANEL;
      } else if ($activeElement.is(this.$closeButton)) {
        return this.ACTIVE_ELEMENT.CLOSE_BUTTON;
      } else if ($activeElement.is(this.$firstMenuItem)) {
        return this.ACTIVE_ELEMENT.FIRST_MENU_ITEM;
      } else if ($activeElement.is(this.$chartContainer) || $activeElement.closest(this.$chartContainer).length > 0 || $activeElement.closest('.chartImageBox').length > 0) {
        return this.ACTIVE_ELEMENT.CHART;
      } else if ($activeElement.is(this.$firstHeaderButton)) {
        return this.ACTIVE_ELEMENT.FIRST_HEADER_BUTTON;
      } else if ($activeElement.is(this.$newsTable) || $activeElement.closest(this.$newsTable).length > 0) {
        return this.ACTIVE_ELEMENT.NEWS;
      }
    }

    /**
     * @method _getFirstSelectedPart
     * @description get first selected parts identity
     * @private
     */
  }, {
    key: "_getFirstSelectedPart",
    value: function _getFirstSelectedPart() {
      var selected = 'selected';
      if (this.$quickViewHeader.find(this.QUICK_VIEW_MENU.CHART).hasClass(selected)) {
        return this.QUICK_VIEW_MENU.CHART;
      } else if (this.$quickViewHeader.find(this.QUICK_VIEW_MENU.RATIO).hasClass(selected)) {
        return this.QUICK_VIEW_MENU.RATIO;
      } else if (this.$quickViewHeader.find(this.QUICK_VIEW_MENU.NEWS).hasClass(selected)) {
        return this.QUICK_VIEW_MENU.NEWS;
      }
    }

    /**
     * @method _getLastSelectedPart
     * @description get last selected parts identity
     * @private
     */
  }, {
    key: "_getLastSelectedPart",
    value: function _getLastSelectedPart() {
      var selected = 'selected';
      if (this.$quickViewHeader.find(this.QUICK_VIEW_MENU.NEWS).hasClass(selected)) {
        return this.QUICK_VIEW_MENU.NEWS;
      } else if (this.$quickViewHeader.find(this.QUICK_VIEW_MENU.RATIO).hasClass(selected)) {
        return this.QUICK_VIEW_MENU.RATIO;
      } else if (this.$quickViewHeader.find(this.QUICK_VIEW_MENU.CHART).hasClass(selected)) {
        return this.QUICK_VIEW_MENU.CHART;
      }
    }

    /**
     * @method _setFocusToActiveItemPart
     * @description set focus to the first active item in the panel
     * @param { Boolean } chooseLastPart - to identify the last/first part
     * @private
     */
  }, {
    key: "_setFocusToActiveItemPart",
    value: function _setFocusToActiveItemPart(chooseLastPart) {
      var partId = chooseLastPart ? this._getLastSelectedPart() : this._getFirstSelectedPart();
      switch (partId) {
        case this.QUICK_VIEW_MENU.CHART:
          if (chooseLastPart) {
            this._setFocusToChart();
          } else {
            this._setFocusToChartMenuItem();
          }
          break;
        case this.QUICK_VIEW_MENU.NEWS:
          this._setFocusToNews();
          break;
        case this.QUICK_VIEW_MENU.RATIO:
          this._setFocusToRatio(chooseLastPart);
          break;
        default:
          this.$firstHeaderButton.focus();
          break;
      }
    }

    /**
     * @method _setFocusToChartMenuItem
     * @description set focus to the chart menu item in the body
     * @private
     */
  }, {
    key: "_setFocusToChartMenuItem",
    value: function _setFocusToChartMenuItem() {
      this.$firstMenuItem.focus();
    }

    /**
     * @method _setFocusToNews
     * @description set focus to news table
     * @private
     */
  }, {
    key: "_setFocusToNews",
    value: function _setFocusToNews() {
      this._setNewsTableAccessibility();
      this.$newsTable.focus();
    }

    /**
     * @method _setFocusToRatio
     * @description ration view has no focusable elements, so focus may set to news or header buttons
     * @param { boolean } isShiftKey: identify shift key pressed or not
     * @private
     */
  }, {
    key: "_setFocusToRatio",
    value: function _setFocusToRatio(isShiftKey) {
      var selected = 'selected';
      if (isShiftKey) {
        if ($(this.QUICK_VIEW_MENU.CHART).hasClass(selected)) {
          this._setFocusToChart();
        } else {
          this.$closeButton.focus();
        }
      } else {
        // #. 1. If news selected - focus will be set to news table
        // #. 2. else the focus set to quick view chart button element
        if ($(this.QUICK_VIEW_MENU.NEWS).hasClass(selected)) {
          this._setFocusToNews();
        } else {
          this.$firstHeaderButton.focus();
        }
      }
    }

    /**
     * @method _setFocusToChart
     * @description set focus to the chart container
     * @private
     */
  }, {
    key: "_setFocusToChart",
    value: function _setFocusToChart() {
      this.$chartContainer.focus();
    }

    /**
     * @method _setNewsTableAccessibility
     * @description set news table accessibility
     * @private
     */
  }, {
    key: "_setNewsTableAccessibility",
    value: function _setNewsTableAccessibility() {
      // #. Set table
      this.$newsTable.attr({
        tabindex: 0
      });
      this.$newsTable.parent().attr({
        role: 'application'
      });

      // #. Set table row
      this.$newsTable.find('tr').attr({
        tabindex: 0,
        role: 'button'
      });
    }
  }]);
  return TooltipAccessibility;
}();
var _default = exports.default = TooltipAccessibility;

},{"aria/tabmenuAccessibility":10,"util/enums/keyCodes":14}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAriaAttributesToModuleTabMenu = void 0;
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * set aria attributes to moduletabmenus
 */
var setAriaAttributesToModuleTabMenu = exports.setAriaAttributesToModuleTabMenu = function setAriaAttributesToModuleTabMenu($menu) {
  var moduleTabMenus = $menu || $('div.moduleTabMenu div.menu');
  setAttributes(moduleTabMenus);
};

/**
 * set aria attributes to tablist and tabpanel for all tab menus on the page with tab buttons inside
 * @param menus
 */
var setAttributes = function setAttributes(menus) {
  $(menus).each(function (index, menu) {
    if ($(menu).find('button.icon').length > 0) {
      setAttributesToTablist(menu);
    }
  });
};

/**
 * set attributes to module tab menu elements by given tab menu
 * @param menu
 */
var setAttributesToTablist = function setAttributesToTablist(menu) {
  // todo get module title without timeout
  window.setTimeout(function () {
    // timeout because of loading... text at the beginning
    var moduleTitle = $(menu).closest('div.module').find('div.moduleHeader h2');
    $(menu).attr('role', 'tablist');
    $(menu).attr('aria-label', $(moduleTitle).text());
  }, 2000);
  setAriaAttributesToButtons($(menu));
};

/**
 * set attributes to tab buttons to given tab menu
 * @param menu
 */
var setAriaAttributesToButtons = function setAriaAttributesToButtons(menu) {
  var tabMenu = menu;
  var menuItems = $(tabMenu).find('div.menuItem');
  $(tabMenu).find('button').each(function (index, button) {
    $(button).attr('role', 'tab').attr('aria-selected', false).on('keydown', function (e) {
      if (e.keyCode === _keyCodes.default.ENTER || e.keyCode === _keyCodes.default.SPACE) {
        updateTabButtons(tabMenu, e.target);
      }
    }).on('click', function (e) {
      updateTabButtons(tabMenu, e.target);
    });
  });
  $(menuItems).each(function (index, item) {
    if ($(item).hasClass('on')) {
      setTabButtonSelected($(item).find('button'));
      return true;
    }
  });
};

/**
 * update attributes of tab buttons
 * @param menu
 * @param pressedBtn
 */
var updateTabButtons = function updateTabButtons(menu, pressedBtn) {
  var menuItemButtons = $(pressedBtn).parent('.menuItem').parent().find('> .menuItem button');
  menuItemButtons.attr('aria-selected', false).removeAttr('tabindex');
  setTabButtonSelected(pressedBtn);
};

/**
 * set given button as selected
 * @param button
 */
var setTabButtonSelected = function setTabButtonSelected(button) {
  $(button).attr({
    'aria-selected': true,
    tabindex: -1
  });
};

},{"util/enums/keyCodes":14}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerMessages = exports.getMessage = exports.addMessage = void 0;
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/** @module messages/messageHandler */

//use an object in window as cache, in order to prevent multiple instances of the cache
window.__messagesCache = window.__messagesCache || {};
var messages = window.__messagesCache;

/**
 * adds a message object with key value pairs for translation
 * @param {Object} msg
 */
var registerMessages = exports.registerMessages = function registerMessages(msg) {
  Object.assign(messages, msg);
};

/**
 * adds a message to the global message cache for translation
 * @param {string} key
 * @param {string} value
 */
var addMessage = exports.addMessage = function addMessage(key, value) {
  messages[key] = value;
};

/**
 * translates a given key and replaces {0}..{n} with the respective replacements
 * @param {string} key
 * @param {...string} replacements
 * @returns {string}
 * @example
 * addMessage('example', 'example {0} of {1}')
 * getMessage('example', '4', 'many');
 * // --> 'example 4 of many'
 * getMessage('example', ['2', '6']);
 * // --> 'example 2 of 6'
 */
var getMessage = exports.getMessage = function getMessage(key) {
  var _ref;
  for (var _len = arguments.length, replacements = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    replacements[_key - 1] = arguments[_key];
  }
  replacements = (_ref = []).concat.apply(_ref, _toConsumableArray(replacements));
  var message = messages[key] || key.split('.').reduce(function (all, a) {
    return a;
  }, '');
  message = message.replace(/\{(\d)\}/g, function (match, id) {
    return replacements[+id] != null ? replacements[+id] : match;
  });
  return message;
};
window.registerMessages = registerMessages;
window.getMessage = getMessage;
window.addMessage = addMessage;

},{}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * A streaming formatter plugin can be registered for a certain streamingDataType
 * and is responsible for formatting streaming updates. A streaming formatter plugin
 * can utilize any kind of formatter. To use a formatter from a plugin, simply
 * pass a reference to the formatting method. The most simple formatter could be a
 * function that returns a string.
 *
 * Optional a streaming illustration can be configured over the plugin. If not configured,
 * the default streaming illustration of YAHOO.fcom.Streaming is being called.
 *
 * @param {String} streamingDataType
 * @param {Function} method
 * @param {Object} scope
 * @param {YAHOO.fcom.StreamingIllustration} streamingIllustration (optional)
 */
var StreamingFormatterPlugin = function StreamingFormatterPlugin(streamingDataType, method, scope, streamingIllustration) {
  this.streamingDataType = streamingDataType;
  this.method = method;
  this.scope = scope;
  this.streamingIllustration = streamingIllustration;
};

/*
 * Calls the formatting function configured in this plugin
 * @param {Object} update containing following properties
 * @property {String} content
 * @property {String} fid
 * @property {String} id
 * @property {String} ric
 * @property {Number} trend
 * @param {StreamingInfo} streamingInfo
 * @returns {String} formatted value
 */
StreamingFormatterPlugin.prototype.format = function (update, streamingInfo) {
  return this.method.call(this.scope, update, streamingInfo);
};

/*
 * Calls the streaming illustration configured for this plugin.
 * The streaming illustration object itself will be the execution scope.
 * @param {String} newValue
 * @param {Object} update containing following properties
 * @property {String} content
 * @property {String} fid
 * @property {String} id
 * @property {String} ric
 * @property {Number} trend
 * @param {StreamingInfo} streamingInfo
 */
StreamingFormatterPlugin.prototype.illustrateStreaming = function (newValue, update, streamingInfo) {
  if (this.streamingIllustration) {
    this.streamingIllustration.illustrateStreaming(newValue, update, streamingInfo);
  } else {
    window.YAHOO.fcom.Streaming.streamingIllustration.illustrateStreaming(newValue, update, streamingInfo);
  }
};
var _default = exports.default = StreamingFormatterPlugin;

},{}],13:[function(require,module,exports){
"use strict";

var _StreamingFormatterPlugin = _interopRequireDefault(require("streaming/StreamingFormatterPlugin"));
var _Accessibility = _interopRequireDefault(require("accessibility/Accessibility"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var YAHOO = window.YAHOO;
var STREAMING_DATA_TYPE = 'n';

/*
 * Streaming formatter plugin for displaying last news info icon in tables
 * @type {Object}
 */
var LastNewsFormatter = {
  /*
   * Shows the last news overlay, with timeout
   * @param {} event
   * @param {String} ric
   */
  showInfo: function showInfo(event, ric) {
    var _this2 = this;
    // if there is an open tooltip, hide it
    if (this.Tooltip) {
      this.Tooltip.hide();
    } else {
      this.Tooltip = new window.fcom.ui.TooltipText('ngpTooltipNews', {
        hideOnMouseover: false,
        delayHide: 250,
        delayShow: 500,
        cssClasses: ['quickView', 'break-all-links'],
        style: {
          width: '400px',
          overflow: 'hidden'
        }
      });
      this.Tooltip.beforeShowEvent.subscribe(function () {
        _this2.showInfoAjax();
      });
    }

    /*
     * currentRic will hold the (last) ric of the underlying instrument.
     */
    this.currentRic = ric;

    // #. Set the tooltip role attributes
    this.assignTooltipRoleAttributes();

    /*
     * WCAG - trigger the mouseover event programmatically so,
     * the event object may not contains the pageX, clientX... values
     * pageX & pageY information require to set the tooltip position
     * Set the missing values from the current target offset position values
     */
    if (!event.pageX) {
      event.pageX = $(event.target).offset().left;
      event.pageY = $(event.target).offset().top;
    }

    // show the tooltip
    this.Tooltip.display(event, "<div style=\"padding: 5px;\" id=\"NewsLoading-Ric-".concat(ric, "\"></div>"));
  },
  /*
   * Assign role and described by attributes to the tooltip element
   */
  assignTooltipRoleAttributes: function assignTooltipRoleAttributes() {
    $(this.Tooltip.element).attr('role', 'tooltip');
  },
  /*
   * Loads the date for the last news overlay
   * @param {String} ric
   */
  showInfoAjax: function showInfoAjax() {
    this.showTimeout = null;
    var _this = this;
    var callback = {
      success: function success(o) {
        var newsInfo = JSON.parse(o.responseText);
        if (!newsInfo.found) {
          _this.showPermissionErrorMessage(newsInfo.ric);
          return;
        }
        if (_this.currentRic !== newsInfo.ric) {
          return;
        }
        var code = "<div><b>".concat(newsInfo.headline, "</b></div>") + "<div>".concat(newsInfo.article, "</div>");
        var enableDetailpageLink = true;
        try {
          enableDetailpageLink = !!window.fcom.customized.tdwealth.customized.enableDetailpageLink;
        } catch (e) {}
        if (enableDetailpageLink === true) {
          code += "<div><a class=\"readmore\" href=\"".concat(window.ctx, "/detail/detailPage.html?ric=").concat(encodeURIComponent(newsInfo.ric), "&subPage=news&nid=").concat(encodeURIComponent(newsInfo.id), "\">").concat(window.getMessage('readmore'), "</a></div>");
        } else {
          code += "<div><a class=\"readmore\" href=\"".concat(window.ctx, "/news/overview.html?nid=").concat(encodeURIComponent(newsInfo.id), "\">").concat(window.getMessage('readmore'), "</a></div>");
        }
        YAHOO.util.Dom.get("NewsLoading-Ric-".concat(_this.currentRic)).innerHTML = code;
      },
      failure: function failure() {
        _this.hideInfoOnError(_this.currentRic);
      }
    };
    window.ngpAsyncRequest('GET', '/ajax.action', callback, {
      method: 'getLatestNews',
      ric: this.currentRic
    });
  },
  /*
   * closes the last new overlay
   * @param {String} ric
   */
  hideInfoOnError: function hideInfoOnError(ric) {
    if (this.currentRic === ric) {
      this.Tooltip.hide();
      this.currentRic = '';
    }
  },
  showPermissionErrorMessage: function showPermissionErrorMessage(ric) {
    if (this.currentRic === ric) {
      var code = "<div><b>".concat(window.getMessage('news.noPermission.message'), "</b></div>");
      YAHOO.util.Dom.get("NewsLoading-Ric-".concat(this.currentRic)).innerHTML = code;
    }
  },
  /*
   * closes the last news overlay
   * @param {String} ric
   */
  hideInfo: function hideInfo(event /*, ric */) {
    this.Tooltip.hideOnLeave(event);
  },
  /*
   * Checks whether the given streaming data contains a valid NEWS_TIME
   * @param {Object} update
   * @param {Object} streamingInfo
   * @return {Boolean}
   */
  format: function format(update /* , streamingInfo */) {
    if (!update) {
      return false;
    }
    if (window.fcom.util.StringHelper.trim(update.content) === ' : ') {
      return false;
    }
    return true;
  },
  /*
   * renders the streaming data for the last news info
   * @param {boolean} newValue
   * @param {Object} update
   * @param {Object} streamingInfo
   */
  illustrateStreaming: function illustrateStreaming(newValue, update, streamingInfo) {
    var _this3 = this;
    if (newValue) {
      var href = "".concat(window.ctx, "/detail/detailPage.html?ric=").concat(window.fcom.util.StringHelper.escapeHTML(encodeURIComponent(update.ric)), "&subPage=news");
      var $link = $('<a/>').addClass('newmessage').mouseover(function (event) {
        _this3.showInfo(event, window.fcom.util.StringHelper.escapeHTML(update.ric));
      }).attr('href', href).data('streaming-context', this);
      $(streamingInfo.node).css('display', 'inline-block').html('').append($link);

      // #. Update the accessibility
      _Accessibility.default.init({
        streamingAccessibility: {
          nodes: $(streamingInfo.node)
        }
      });
    } else {
      streamingInfo.node.innerHTML = '';
    }
  }
};

// always register last news plugin
YAHOO.fcom.Streaming.registerFormatterPlugin(new _StreamingFormatterPlugin.default(STREAMING_DATA_TYPE, LastNewsFormatter.format, LastNewsFormatter, LastNewsFormatter));
window.YAHOO.fcom.LastNewsFormatter = LastNewsFormatter;

},{"accessibility/Accessibility":1,"streaming/StreamingFormatterPlugin":12}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var KEYCODE = {
  ENTER: 13,
  SPACE: 32,
  ESCAPE: 27,
  ARROW_LEFT: 37,
  ARROW_UP: 38,
  ARROW_RIGHT: 39,
  ARROW_DOWN: 40,
  TAB: 9,
  KeyA: 65,
  KeyD: 68,
  DELETE: 46
};
var _default = exports.default = KEYCODE;

},{}],15:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * @name            : GUID
 * @description     : Generate new GUID and GUID related methods
 */
var GUID = exports.default = /*#__PURE__*/function () {
  function GUID() {
    _classCallCheck(this, GUID);
  }
  _createClass(GUID, null, [{
    key: "generate",
    value:
    /**
     * @method generate
     * @description Static method to generate new GUID
     * @public
     * @static
     */
    function generate() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0;
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
      });
    }
  }]);
  return GUID;
}();

},{}]},{},[13]);
;
(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * A streaming formatter plugin can be registered for a certain streamingDataType
 * and is responsible for formatting streaming updates. A streaming formatter plugin
 * can utilize any kind of formatter. To use a formatter from a plugin, simply
 * pass a reference to the formatting method. The most simple formatter could be a
 * function that returns a string.
 *
 * Optional a streaming illustration can be configured over the plugin. If not configured,
 * the default streaming illustration of YAHOO.fcom.Streaming is being called.
 *
 * @param {String} streamingDataType
 * @param {Function} method
 * @param {Object} scope
 * @param {YAHOO.fcom.StreamingIllustration} streamingIllustration (optional)
 */
var StreamingFormatterPlugin = function StreamingFormatterPlugin(streamingDataType, method, scope, streamingIllustration) {
  this.streamingDataType = streamingDataType;
  this.method = method;
  this.scope = scope;
  this.streamingIllustration = streamingIllustration;
};

/*
 * Calls the formatting function configured in this plugin
 * @param {Object} update containing following properties
 * @property {String} content
 * @property {String} fid
 * @property {String} id
 * @property {String} ric
 * @property {Number} trend
 * @param {StreamingInfo} streamingInfo
 * @returns {String} formatted value
 */
StreamingFormatterPlugin.prototype.format = function (update, streamingInfo) {
  return this.method.call(this.scope, update, streamingInfo);
};

/*
 * Calls the streaming illustration configured for this plugin.
 * The streaming illustration object itself will be the execution scope.
 * @param {String} newValue
 * @param {Object} update containing following properties
 * @property {String} content
 * @property {String} fid
 * @property {String} id
 * @property {String} ric
 * @property {Number} trend
 * @param {StreamingInfo} streamingInfo
 */
StreamingFormatterPlugin.prototype.illustrateStreaming = function (newValue, update, streamingInfo) {
  if (this.streamingIllustration) {
    this.streamingIllustration.illustrateStreaming(newValue, update, streamingInfo);
  } else {
    window.YAHOO.fcom.Streaming.streamingIllustration.illustrateStreaming(newValue, update, streamingInfo);
  }
};
var _default = exports.default = StreamingFormatterPlugin;

},{}],2:[function(require,module,exports){
"use strict";

var _StreamingFormatterPlugin = _interopRequireDefault(require("streaming/StreamingFormatterPlugin"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var YAHOO = window.YAHOO;
var STREAMING_DATA_TYPE = 'r';

/*
 * Formats streaming updates for reuters display templates.
 * @static
 * @type
 */
var ReutersStreamingFormatter = {
  TYPE_PRICE: 6,
  TYPE_INTEGER: 1,
  TYPE_ALPHANUMERIC: 2,
  TYPE_DATE: 5,
  TYPE_TIME: 4,
  TYPE_TIME_SECONDS: 8,
  BLINK_TIME: 3000,
  ARR_UP: 0x2191,
  ARR_DOWN: 0x2193,
  FONT_SIZE_FOR_WIDTH: [],
  // will be overwritten later

  /*
   * reads the additional formatting information encoded in the class
   * of the streaming node
   * @param {String} prefix
   * @param {HTMLElement} node
   * @return {String}
   * @private
   */
  getFormatInfoFromClass: function getFormatInfoFromClass(classPrefix, node) {
    var index = node.className.indexOf(classPrefix);
    if (index > -1) {
      var formatInfo = node.className.substring(index + classPrefix.length, node.className.length);
      index = formatInfo.indexOf(' ');
      if (index === -1) {
        index = formatInfo.length;
      }
      return formatInfo.substring(0, index).split('_');
    }
  },
  /*
   * Helper method to find with string starts with another string (whitespaces at the beginning are ignored).
   * No regex for performance reasons.
   * @param {String} prefix
   * @param {String} str
   * @private
   */
  startsWith: function startsWith(prefix, str) {
    var prefixIndex = 0;
    if (prefix.length > str.length) {
      return false;
    }
    for (var i = 0; i < str.length; i++) {
      if (str.charAt(i) === ' ' && prefixIndex === 0) {
        continue;
      } else if (str.charAt(i) !== prefix.charAt(prefixIndex)) {
        return false;
      }
      prefixIndex++;
      if (prefixIndex === prefix.length) {
        break;
      }
    }
    return true;
  },
  /*
   * parse the <code>font-size</code> style of a node and return the size in pixel
   * @param {HTMLElement} node
   * @private
   */
  getAvaiableTextLength: function getAvaiableTextLength(node) {
    var fontsize = YAHOO.util.Dom.getStyle(node, 'font-size');
    if (!fontsize) {
      return;
    }
    fontsize = fontsize.substring(0, fontsize.indexOf('px'));
    var region = YAHOO.util.Dom.getRegion(node);
    var width = region.right - region.left;
    var charWidth = YAHOO.fcom.Util.lastIndexOf(parseInt(fontsize, 10), this.FONT_SIZE_FOR_WIDTH);
    return Math.floor(width / charWidth);
  },
  /*
   * Formats the streaming updates according to the formatting bits encoded in the
   * node's class string.
   *
   * This is a JavaScript port of the formatting function used in
   * com.financial.rwt.module.terminal.data.DisplayItem.init() of project
   * MyMarkets.
   *
   * @param {Sring} update
   * @param {StreamingInfo} streamingInfo
   */
  format: function format(update, streamingInfo) {
    //get additional streaming info
    if (streamingInfo.reutersFormat == null) {
      /*
       * Add information to streamingInfo, so it only has to be parsed once.
       */
      var formatInfo = this.getFormatInfoFromClass('rfq_', streamingInfo.node);
      if (formatInfo.length > 0) {
        streamingInfo.reutersFormat = formatInfo[0];
        streamingInfo.reutersFidType = +formatInfo[1];
        streamingInfo.reutersColorIndex = formatInfo[2];
        streamingInfo.linksEnabled = formatInfo[3] === 'true';
        streamingInfo.interactionsDisabled = formatInfo[4] === 'true';
      }
    }
    if (streamingInfo.reutersTextLen == null) {
      //calculate the space available for text to determine truncation
      streamingInfo.reutersTextLen = this.getAvaiableTextLength(YAHOO.util.Dom.getAncestorByClassName(streamingInfo.node, 'fqItem'));
    }

    /* @type String */
    var oldContent = streamingInfo.node.innerHTML;
    /* @type String */
    var t = this.trim0(update.content);

    //remove zero values
    if (streamingInfo.reutersFidType === this.TYPE_INTEGER || streamingInfo.reutersFidType === this.TYPE_PRICE) {
      if (this.isZero(t)) {
        t = '';
      }
    }

    /*
     * add signs to the update if old content also had signs, only for numeric types
     */
    if ((streamingInfo.reutersFidType === this.TYPE_INTEGER || streamingInfo.reutersFidType === this.TYPE_PRICE) && (window.fcom.util.StringHelper.startsWith('+', oldContent) || window.fcom.util.StringHelper.startsWith('-', oldContent))) {
      t = YAHOO.fcom.Format.addSign(t);
    }

    /*
     * "Y" For PRICE fields, if present suppress leading zeroes before the decimal point or
     * fraction. If NOT present leading zeroes before the decimal point or fraction are not
     * suppressed. For INTEGER or ALPHANUMERIC fields, if present, suppress leading zeroes from
     * the field. If NOT present, do not suppress.
     */
    if ((streamingInfo.reutersFormat & 1) !== 0 && (streamingInfo.reutersFidType === this.TYPE_INTEGER || streamingInfo.reutersFidType === this.TYPE_PRICE || streamingInfo.reutersFidType === this.TYPE_ALPHANUMERIC)) {
      var l = t.length;
      for (var i = 0; i < l; i++) {
        var c = t.charAt(i);
        if (i === l - 1 && c === '0') {
          t = '';
        } else if (c !== '0') {
          t = t.substring(i);
          break;
        }
      }
    }

    /*
     * "Z" If present suppress redundant trailing zeroes. If NOT present trailing zeroes after
     * the decimal point are not suppressed. This flag applies to PRICE fields only.
     *
     * Note the first zero after the decimal point is NOT redundant and is always displayed. For
     * example, with this option present, the value 4.5600 becomes 4.56, and the value 4.0000
     * becomes 4.0 and not 4. i.e. a single zero is displayed to the right of the decimal point
     * when the mantissa is zero.
     */
    if ((streamingInfo.reutersFormat & 2) !== 0 && streamingInfo.reutersFidType === this.TYPE_PRICE) {
      var p = t.indexOf('.') + 2;
      var end = t.length;
      var cut = 0;
      while (--end >= p) {
        if (t.charAt(end) === '0') {
          cut++;
        } else {
          break;
        }
      }
      if (cut > 0) {
        t = t.substring(0, t.length - cut);
      }
    }

    /*
     * "S" If present suppress signs according to the "M" format option. If NOT present, the "M"
     * format option is ignored, and signs are NOT suppressed. This flag applies to PRICE and
     * INTEGER fields only.
     *
     * "M" If present suppress plus sign "+" only if first character in field. If NOT present
     * suppress plus OR minus sign if first character in field. (as stated above, suppress
     * NEITHER sign if "S" option is not present). This flag applies to PRICE and INTEGER fields
     * only.
     */
    if ((streamingInfo.reutersFormat & 0x4) !== 0 && (streamingInfo.reutersFidType === this.TYPE_INTEGER || streamingInfo.reutersFidType === this.TYPE_PRICE)) {
      if ((streamingInfo.reutersFormat & 0x8) === 0 && window.fcom.util.StringHelper.startsWith('-', t)) {
        t = t.substring(1);
      } else if (window.fcom.util.StringHelper.startsWith('+', t)) {
        t = t.substring(1);
      }
      if ((streamingInfo.reutersFormat & 0xC) === 0xC && t.length > streamingInfo.reutersTextLen) {
        var _p = t.indexOf('.');
        if (t.length === _p + 5) {
          t = t.substring(t.length - 2);
        }
      }
    }

    /*
     * "A" If present AND truncation is necessary (the field is larger than the display length
     * after the above suppression has been applied) the field is truncated as follows:-
     *
     * 1) If numeric value with 4 decimal places truncate to 2 characters (or the display length
     * if smaller). For example, "1.1125" would be truncated to "25", assuming truncation from
     * the left.
     *
     * 2) If numeric value with 3 decimal places truncate to 3 characters (or the display length
     * if smaller). For example, "435.112" would be truncated to "112", assuming truncation from
     * the left.
     *
     * 3) Otherwise truncation is to a width equivalent to the display length.
     *
     * Truncation is from left or right as indicated by the "T" format option. This flag applies
     * to PRICE fields only.
     */

    if ((streamingInfo.reutersFormat & 0x20) !== 0 && streamingInfo.reutersFidType === this.TYPE_PRICE) {
      if (t.length > streamingInfo.reutersTextLen) {
        var _p2 = t.indexOf('.');
        if (_p2 >= 0) {
          if (t.length === _p2 + 5) {
            t = t.substring(_p2 + 3); //truncates only left
          } else if (t.length === _p2 + 4) {
            t = t.substring(_p2 + 1); //truncates only left
          }
        }
      }
    }

    /*
     * "V" If present, the field will be scaled as outlined below. This flag is applicable to
     * PRICE and INTEGER fields only.
     *
     * 1) Values less than 100 will be considered invalid, and the data field will be space
     * filled. 2) For values from 100 to 999, the basic rule is to scale "nxx" to "0.n". The
     * following examples show this scaling:
     *
     * Value Scales to 100 0.1 200 0.2 250 0.2 287 0.2 950 0.9 999 0.9 3) For values from 1000
     * to 999,999, the basic rule is to scale "nnn,hxx" to "nnn.h". The following examples show
     * this scaling:
     *
     * Value Scales to 1000 1 2000 2 5000 5 10,000 10 999,000 999 1200 1.2 1250 1.2 1287 1.2
     * 50,587 50.5 999,999 999.9
     *
     * 4) For values of 1 million and above, the rule is to scale "nnn,hxx,xxx" to "nnn.h" and
     * follow it with an 'm'. The following examples show this scaling:
     *
     * Value Scales to 1,000,000 1.0m 1,900,000 1.9m 3,450,000 3.4m 78,999,999 78.9m
     *
     */
    if (((streamingInfo.reutersFormat & 0x200) !== 0 || (streamingInfo.reutersFormat & 0x800) !== 0) && (streamingInfo.reutersFidType === this.TYPE_INTEGER || streamingInfo.reutersFidType === this.TYPE_PRICE)) {
      if (t.length > 0) {
        var minus = window.fcom.util.StringHelper.startsWith('-', t) ? true : false;
        if (minus) {
          t = t.substring(1);
        }
        var value = Math.round(parseFloat(t));
        if (value < 100) {
          t = '';
        } else if (value <= 999) {
          t = (minus ? '-' : '') + Math.round(value / 100) * 0.1;
        } else if (value <= 999999) {
          t = (minus ? '-' : '') + Math.round(value / 100) * 0.1;
        } else if ((streamingInfo.reutersFormat & 0x800) !== 0) {
          t = '';
        } else {
          t = "".concat(minus ? '-' : '').concat(Math.round(value / 100000) * 0.1, "m");
        }
      }
    }

    /*
     * "P" If present append a space followed by a ‘%’ sign.
     * Will only append the specified chars when there is a value
     */
    if ((streamingInfo.reutersFormat & 0x10) !== 0 && streamingInfo.reutersFidType === this.TYPE_PRICE) {
      if (t.length > 0) {
        t += ' %';
      }
    }

    /*
     * Replace chars representing arrows
     */
    t = t.replace(/\u00DE/g, String.fromCharCode(this.ARR_UP));
    t = t.replace(/\u00FE/g, String.fromCharCode(this.ARR_DOWN));
    if (streamingInfo.reutersFidType === this.TYPE_DATE) {
      // convert typical Reuter date string dd MMM yyyy to ddMMMyy
      t = t.replace(/\u0020/g, ''); // remove spaces for condenced date format
      t = t.replace(/([0-9]+)([A-Z]+)([0-9]{2,2})([0-9]{2,2})/g, '$1$2$4'); // remove first 2 letters of year
    }

    if (streamingInfo.reutersFidType === this.TYPE_TIME || streamingInfo.reutersFidType === this.TYPE_TIME_SECONDS) {
      // time in GMT, correct to local time of user
      var timeValue = YAHOO.fcom.Parse.parseMachineDate(t);
      if (timeValue != null && timeValue.date != null) {
        if (streamingInfo.reutersTextLen < 4 && update.fid === '29') {
          // special treatment for news_time
          t = '*';
        } else {
          //seconds are omitted
          t = YAHOO.fcom.Format.formatDateTime(timeValue.date, {
            'pattern': 'HH:mm'
          });
        }
      }
    }

    /*
     * "T" If present truncation of a field larger than the display position is from the right, else
     * from the left. This flag is valid for all field types.
     */
    if (t.length > streamingInfo.reutersTextLen) {
      if (update.fid === '28') {
        // special treamtment for this NEWS fid. Content comes as YYYY
        if (t.indexOf('Y') > -1) {
          t = '*';
        }
      } else if ((streamingInfo.reutersFormat & 0x40) !== 0) {
        t = t.substring(0, streamingInfo.reutersTextLen);
      } else {
        t = YAHOO.fcom.Util.trim(t);
        if (t.length > streamingInfo.reutersTextLen) {
          t = t.substring(t.length - streamingInfo.reutersTextLen);
        }
      }
    }
    t = window.fcom.util.StringHelper.escapeHTML(t);
    t = t.replace(/\u0020/g, '&nbsp;');
    if (streamingInfo.reutersFidType === this.TYPE_ALPHANUMERIC && !streamingInfo.interactionsDisabled) {
      t = this.createLinks(streamingInfo, t);
    }
    return t;
  },
  /*
   * Trim a string of 0x00 characters
   * @param {String} str
   * @return {String} the trimmed string
   */
  trim0: function trim0(str) {
    var zero = String.fromCharCode(0);
    var index = -1;
    while ((index = str.indexOf(zero)) > -1) {
      var index2 = index + 1 > str.length ? str.length : index + 1;
      str = str.substring(0, index) + str.substring(index2, str.length);
    }
    return str;
  },
  /*
   * Check if the value is zero.
   * @param {String} str
   * @return {Boolean}
   */
  isZero: function isZero(str) {
    if ((str = window.fcom.util.StringHelper.trim(str)) === '') {
      return true;
    }
    for (var i = 0, l = str.length; i < l; i++) {
      if (['0', '.', '+', '-'].indexOf(str.charAt(i)) === -1) {
        return false;
      }
    }
    return true;
  },
  /*
   * illustrate streaming updates according to blink colors of the reuters display template
   * color lookup table.
   * @param {String} newValue
   * @param {Object} update
   * @param {StreamingInfo} streamingInfo
   */
  illustrateStreaming: function illustrateStreaming(newValue, update, streamingInfo) {
    var _this2 = this;
    var _this = this;
    //replace innerHTML of the node with new value
    streamingInfo.node.innerHTML = newValue;
    //no illustration for initial streaming snapshot
    if (streamingInfo.updateCount <= 1) {
      return false;
    }
    Promise.all([window.fcom.themeHandler.loadThemeConfig('_theme'), window.fcom.themeHandler.loadThemeConfig('ReutersFullQuoteModule')]).then(function (configs) {
      var themeConfig = configs[0];
      var rfqConfig = configs[1];
      //create color config
      var colors = themeConfig.chartColors;
      colors.byIndex = rfqConfig.colors;
      return colors;
    }).then(function (colors) {
      var element = streamingInfo.getParentBoxNode();
      if (element && !YAHOO.util.Dom.hasClass(element, 'streamingTouched')) {
        var $element = $(element);
        var color = colors.byIndex[+streamingInfo.reutersColorIndex] || colors[streamingInfo.reutersColorIndex];
        var fgColor;
        if (_this.isArrowUp(streamingInfo, newValue)) {
          fgColor = colors.up;
        }
        if (_this.isArrowDown(streamingInfo, newValue)) {
          fgColor = colors.down;
        }
        $element.css({
          'color': fgColor || color[0] || 'transparent',
          'background-color': ($element.is('[data-rfq-region]') ? fgColor || color[0] : color[1]) || 'transparent'
        });
        if (_this.isAnimatedValue(newValue, update, streamingInfo)) {
          $element.addClass('streamingTouched');
          window.setTimeout(function () {
            $element.removeClass('streamingTouched');
            $element.css({
              'color': fgColor || color[0] || 'transparent',
              'background-color': ($element.is('[data-rfq-region]') ? fgColor || color[0] : color[1]) || 'transparent'
            });
          }, _this2.BLINK_TIME);
        }
      }
    });
  },
  isAnimatedValue: function isAnimatedValue(text, update, streamingInfo) {
    //no animation for arrows
    return !(this.isArrowUp(streamingInfo, text) || this.isArrowDown(streamingInfo, text));
  },
  /*
   *
   * @param {} streamingInfo
   * @param {String} text
   * @return {Boolean}
   */
  isArrowUp: function isArrowUp(streamingInfo, text) {
    return text.indexOf(String.fromCharCode(this.ARR_UP)) > -1;
  },
  /*
   *
   * @param {} streamingInfo
   * @param {} text
   * @return {Boolean}
   */
  isArrowDown: function isArrowDown(streamingInfo, text) {
    return text.indexOf(String.fromCharCode(this.ARR_DOWN)) > -1;
  },
  /*
   *
   * @param {} streamingInfo
   * @param {String} text
   * @return {String}
   */
  createLinks: function createLinks(streamingInfo, text) {
    var regInstrument = new RegExp('&lt;([^<&=]+.*?)&gt;', 'g');
    var regNews = new RegExp('\\[(.*?)\\]', 'g');
    var matches = null;
    var result = '';
    var lastIndex = 0;
    while ((matches = regInstrument.exec(text)) != null) {
      if (matches && matches.length > 0) {
        var inner = matches[1]; //grouped substring match
        var innerEsc = window.fcom.util.StringHelper.escapeJavaScript(inner);
        if (streamingInfo.linksEnabled) {
          inner = "&lt;<a onclick=\"YAHOO.fcom.ReutersFullQuoteFactory.refresh(this, '".concat(innerEsc, "'); return false;\" href=\"#\">").concat(inner, "</a>&gt;");
        } else {
          inner = "&lt;<a onclick=\"YAHOO.fcom.ReutersFullQuoteFactory.linkToTools('".concat(innerEsc, "'); return false;\" href=\"#\">").concat(inner, "</a>&gt;");
        }
        result += text.substring(lastIndex, matches.index) + inner;
        lastIndex = regInstrument.lastIndex;
      }
    }
    result += text.substring(lastIndex);
    text = result;
    result = '';
    lastIndex = 0;
    while ((matches = regNews.exec(text)) != null) {
      if (matches.length > 0) {
        var _inner = matches[1]; //grouped substring match
        var _innerEsc = window.fcom.util.StringHelper.escapeJavaScript(_inner);
        _inner = "[<a href=\"".concat(window.ctx, "/news/overview.html?cat=").concat(_innerEsc, "\">").concat(_inner, "</a>]");
        result += text.substring(lastIndex, matches.index) + _inner;
        lastIndex = regNews.lastIndex;
      }
    }
    result += text.substring(lastIndex);
    return result;
  }
};
YAHOO.fcom.Streaming.registerFormatterPlugin(new _StreamingFormatterPlugin.default(STREAMING_DATA_TYPE, ReutersStreamingFormatter.format, ReutersStreamingFormatter, ReutersStreamingFormatter));

},{"streaming/StreamingFormatterPlugin":1}]},{},[2]);
;
(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * A streaming formatter plugin can be registered for a certain streamingDataType
 * and is responsible for formatting streaming updates. A streaming formatter plugin
 * can utilize any kind of formatter. To use a formatter from a plugin, simply
 * pass a reference to the formatting method. The most simple formatter could be a
 * function that returns a string.
 *
 * Optional a streaming illustration can be configured over the plugin. If not configured,
 * the default streaming illustration of YAHOO.fcom.Streaming is being called.
 *
 * @param {String} streamingDataType
 * @param {Function} method
 * @param {Object} scope
 * @param {YAHOO.fcom.StreamingIllustration} streamingIllustration (optional)
 */
var StreamingFormatterPlugin = function StreamingFormatterPlugin(streamingDataType, method, scope, streamingIllustration) {
  this.streamingDataType = streamingDataType;
  this.method = method;
  this.scope = scope;
  this.streamingIllustration = streamingIllustration;
};

/*
 * Calls the formatting function configured in this plugin
 * @param {Object} update containing following properties
 * @property {String} content
 * @property {String} fid
 * @property {String} id
 * @property {String} ric
 * @property {Number} trend
 * @param {StreamingInfo} streamingInfo
 * @returns {String} formatted value
 */
StreamingFormatterPlugin.prototype.format = function (update, streamingInfo) {
  return this.method.call(this.scope, update, streamingInfo);
};

/*
 * Calls the streaming illustration configured for this plugin.
 * The streaming illustration object itself will be the execution scope.
 * @param {String} newValue
 * @param {Object} update containing following properties
 * @property {String} content
 * @property {String} fid
 * @property {String} id
 * @property {String} ric
 * @property {Number} trend
 * @param {StreamingInfo} streamingInfo
 */
StreamingFormatterPlugin.prototype.illustrateStreaming = function (newValue, update, streamingInfo) {
  if (this.streamingIllustration) {
    this.streamingIllustration.illustrateStreaming(newValue, update, streamingInfo);
  } else {
    window.YAHOO.fcom.Streaming.streamingIllustration.illustrateStreaming(newValue, update, streamingInfo);
  }
};
var _default = exports.default = StreamingFormatterPlugin;

},{}],2:[function(require,module,exports){
"use strict";

var _StreamingFormatterPlugin = _interopRequireDefault(require("streaming/StreamingFormatterPlugin"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var YAHOO = window.YAHOO;
var STREAMING_DATA_TYPE = 'dy';

/*
 * Streaming formatter plugin for calculating the dividend yield column
 * @type {Object}
 */
var DivYieldFormatter = {
  /*
   * Checks whether the given streaming data contains a valid value
   * @param {Object} update
   * @return {Boolean}
   */
  format: function format(update) {
    if (!update) {
      return false;
    }
    return true;
  },
  /*
   * renders the streaming data for the dividend yield
   * @param {boolean} newValue
   * @param {Object} update
   * @param {Object} streamingInfo
   */
  illustrateStreaming: function illustrateStreaming(newValue, update, streamingInfo) {
    if (newValue) {
      var price = +update.content;
      var $divEl = $(streamingInfo.node).find('.divValue');
      if ($divEl.find('span.stream').length) {
        // If the dividend is streaming
        $divEl = $divEl.find('span.stream');
      }
      var $divYEl = $(streamingInfo.node).find('.divYieldValue');
      if ($divEl.length && $divYEl.length) {
        try {
          var lastValue = +$divYEl.text().replace(/^\n/, '').replace(/,/g, '.');
          var minFractionDigits = +$divYEl.data('min-fraction-digits') || 2;
          var maxFractionDigits = +$divYEl.data('max-fraction-digits') || 4;
          var dividend = +$divEl.text().replace(/,/g, '.');
          var _newValue = dividend / price * 100;
          if (!isNaN(lastValue)) {
            if (lastValue > _newValue) {
              update.trend = -1;
            } else if (lastValue < _newValue) {
              update.trend = 1;
            }
          }
          $divYEl.text(YAHOO.fcom.Format.formatNumber(_newValue, {
            minFractionDigits: minFractionDigits,
            maxFractionDigits: maxFractionDigits
          }));
          if (lastValue) {
            YAHOO.fcom.Streaming.streamingIllustration.highlightStreaming(streamingInfo, update);
          }
        } catch (e) {
          $divYEl.text('');
        }
      }
    }
  }
};
YAHOO.fcom.Streaming.registerFormatterPlugin(new _StreamingFormatterPlugin.default(STREAMING_DATA_TYPE, DivYieldFormatter.format, DivYieldFormatter, DivYieldFormatter));

},{"streaming/StreamingFormatterPlugin":1}]},{},[2]);
;
(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * A streaming formatter plugin can be registered for a certain streamingDataType
 * and is responsible for formatting streaming updates. A streaming formatter plugin
 * can utilize any kind of formatter. To use a formatter from a plugin, simply
 * pass a reference to the formatting method. The most simple formatter could be a
 * function that returns a string.
 *
 * Optional a streaming illustration can be configured over the plugin. If not configured,
 * the default streaming illustration of YAHOO.fcom.Streaming is being called.
 *
 * @param {String} streamingDataType
 * @param {Function} method
 * @param {Object} scope
 * @param {YAHOO.fcom.StreamingIllustration} streamingIllustration (optional)
 */
var StreamingFormatterPlugin = function StreamingFormatterPlugin(streamingDataType, method, scope, streamingIllustration) {
  this.streamingDataType = streamingDataType;
  this.method = method;
  this.scope = scope;
  this.streamingIllustration = streamingIllustration;
};

/*
 * Calls the formatting function configured in this plugin
 * @param {Object} update containing following properties
 * @property {String} content
 * @property {String} fid
 * @property {String} id
 * @property {String} ric
 * @property {Number} trend
 * @param {StreamingInfo} streamingInfo
 * @returns {String} formatted value
 */
StreamingFormatterPlugin.prototype.format = function (update, streamingInfo) {
  return this.method.call(this.scope, update, streamingInfo);
};

/*
 * Calls the streaming illustration configured for this plugin.
 * The streaming illustration object itself will be the execution scope.
 * @param {String} newValue
 * @param {Object} update containing following properties
 * @property {String} content
 * @property {String} fid
 * @property {String} id
 * @property {String} ric
 * @property {Number} trend
 * @param {StreamingInfo} streamingInfo
 */
StreamingFormatterPlugin.prototype.illustrateStreaming = function (newValue, update, streamingInfo) {
  if (this.streamingIllustration) {
    this.streamingIllustration.illustrateStreaming(newValue, update, streamingInfo);
  } else {
    window.YAHOO.fcom.Streaming.streamingIllustration.illustrateStreaming(newValue, update, streamingInfo);
  }
};
var _default = exports.default = StreamingFormatterPlugin;

},{}],2:[function(require,module,exports){
"use strict";

var _StreamingFormatterPlugin = _interopRequireDefault(require("streaming/StreamingFormatterPlugin"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var YAHOO = window.YAHOO;
var STREAMING_DATA_TYPE = 'hpc';
var PercentageChangeFormatter = {
  BLINK_TIME: 1000,
  /*
  * Checks whether the given streaming data contains a valid value
  * @param {Object} update
  * @return {Boolean}
  */
  format: function format(update) {
    if (!update) {
      return false;
    }
    return true;
  },
  /*
  * renders the streaming data for percentage change
  * @param {boolean} newValue
  * @param {Object} update
  * @param {Object} streamingInfo
  */
  illustrateStreaming: function illustrateStreaming(newValue, update, streamingInfo) {
    if (newValue) {
      try {
        // Extract current trade price and previous trade price from update and streamingInfo
        var currentTradePrice = parseFloat(update.content) || null;
        var previousTradePrice = parseFloat($(streamingInfo.node).closest('[data-prev-value]').data('prev-value')) || null;
        var previousChangeInPercentage = parseFloat($(streamingInfo.node).text());
        if (currentTradePrice && previousTradePrice) {
          var changeInPercentage = this.calculateChangeInPercentage(currentTradePrice, previousTradePrice);
          this.updateChangeInPercentageAndAddTrendMarker(streamingInfo, changeInPercentage);
          this.addPercentageChangeStreamingAnimation(streamingInfo, changeInPercentage, previousChangeInPercentage, this.BLINK_TIME);
        }
      } catch (e) {
        console.log(e);
      }
    }
  },
  /*
  * The percentage change calculator determines the percentage change between two values
  * @param {Number} current
  * @param {Number} previous
  * @return {Number}
  */
  calculateChangeInPercentage: function calculateChangeInPercentage(current, previous) {
    return parseFloat(((current - previous) / previous * 100).toFixed(3));
  },
  /*
  * Update Percentage change streaming node value and add trend color based on '-' or '+'
  * @param {Object} streamingInfo
  * @param {Number} changeInPercentage
  */
  updateChangeInPercentageAndAddTrendMarker: function updateChangeInPercentageAndAddTrendMarker(streamingInfo, changeInPercentage) {
    var trendClass;
    var signedNumber = changeInPercentage;
    var showTrendPositiveMarker = $(streamingInfo.node).closest('[data-positive-marker]').data('positive-marker') ?? true;
    if (changeInPercentage === 0) {
      trendClass = 'stream';
    } else if (changeInPercentage > 0) {
      trendClass = 'stream up';
      signedNumber = "".concat(showTrendPositiveMarker ? '+' : '').concat(changeInPercentage);
    } else {
      trendClass = 'stream down';
    }
    streamingInfo.node.innerHTML = signedNumber;
    var showTrendMarker = $(streamingInfo.node).closest('[data-trend-marker]').data('trend-marker') ?? true;
    if (showTrendMarker) {
      $(streamingInfo.node).removeClass();
      $(streamingInfo.node).addClass(trendClass);
    }
  },
  /*
  * Adding animation to the parent node of Percentage change streamingInfo node
  * @param {Object} streamingInfo
  * @param {Number} changeInPercentage
  * @param {Number} interval
  */
  addPercentageChangeStreamingAnimation: function addPercentageChangeStreamingAnimation(streamingInfo, changeInPercentage, previousChangeInPercentage, interval) {
    var animationNode = streamingInfo.getParentBoxNode();
    var animationClass;
    if (changeInPercentage > previousChangeInPercentage) {
      animationClass = 'streamingTouched streamingUp';
    } else if (changeInPercentage < previousChangeInPercentage) {
      animationClass = 'streamingTouched streamingDown';
    }
    $(animationNode).addClass(animationClass);
    window.setTimeout(function () {
      $(animationNode).removeClass('streamingTouched streamingUp streamingDown');
    }, interval);
  }
};
YAHOO.fcom.Streaming.registerFormatterPlugin(new _StreamingFormatterPlugin.default(STREAMING_DATA_TYPE, PercentageChangeFormatter.format, PercentageChangeFormatter, PercentageChangeFormatter));

},{"streaming/StreamingFormatterPlugin":1}]},{},[2]);
;
(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * A streaming formatter plugin can be registered for a certain streamingDataType
 * and is responsible for formatting streaming updates. A streaming formatter plugin
 * can utilize any kind of formatter. To use a formatter from a plugin, simply
 * pass a reference to the formatting method. The most simple formatter could be a
 * function that returns a string.
 *
 * Optional a streaming illustration can be configured over the plugin. If not configured,
 * the default streaming illustration of YAHOO.fcom.Streaming is being called.
 *
 * @param {String} streamingDataType
 * @param {Function} method
 * @param {Object} scope
 * @param {YAHOO.fcom.StreamingIllustration} streamingIllustration (optional)
 */
var StreamingFormatterPlugin = function StreamingFormatterPlugin(streamingDataType, method, scope, streamingIllustration) {
  this.streamingDataType = streamingDataType;
  this.method = method;
  this.scope = scope;
  this.streamingIllustration = streamingIllustration;
};

/*
 * Calls the formatting function configured in this plugin
 * @param {Object} update containing following properties
 * @property {String} content
 * @property {String} fid
 * @property {String} id
 * @property {String} ric
 * @property {Number} trend
 * @param {StreamingInfo} streamingInfo
 * @returns {String} formatted value
 */
StreamingFormatterPlugin.prototype.format = function (update, streamingInfo) {
  return this.method.call(this.scope, update, streamingInfo);
};

/*
 * Calls the streaming illustration configured for this plugin.
 * The streaming illustration object itself will be the execution scope.
 * @param {String} newValue
 * @param {Object} update containing following properties
 * @property {String} content
 * @property {String} fid
 * @property {String} id
 * @property {String} ric
 * @property {Number} trend
 * @param {StreamingInfo} streamingInfo
 */
StreamingFormatterPlugin.prototype.illustrateStreaming = function (newValue, update, streamingInfo) {
  if (this.streamingIllustration) {
    this.streamingIllustration.illustrateStreaming(newValue, update, streamingInfo);
  } else {
    window.YAHOO.fcom.Streaming.streamingIllustration.illustrateStreaming(newValue, update, streamingInfo);
  }
};
var _default = exports.default = StreamingFormatterPlugin;

},{}],2:[function(require,module,exports){
"use strict";

var _StreamingFormatterPlugin = _interopRequireDefault(require("streaming/StreamingFormatterPlugin"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var YAHOO = window.YAHOO;
var STREAMING_DATA_TYPE = 'pd';
var SPECIAL_STREAMING_DATA_TYPE = 'spd';

/*
 * Streaming formatter plugin for calculating the price difference
 * @type {Object}
 */
var PriceDifferenceFormatter = {
  BLINK_TIME: 1000,
  /*
   * Checks whether the given streaming data contains a valid value
   * @param {Object} update
   * @return {Boolean}
   */
  format: function format(update) {
    if (!update) {
      return false;
    }
    return true;
  },
  /*
   * renders the streaming data for the price difference
   * @param {boolean} newValue
   * @param {Object} update
   * @param {Object} streamingInfo
   */
  illustrateStreaming: function illustrateStreaming(newValue, update, streamingInfo) {
    if (newValue) {
      try {
        var tradePrice = parseFloat(update.content) || null;
        var targetPrice = parseFloat($(streamingInfo.node).closest('[data-target-value]').data('target-value')) || null;
        var previousTargetPriceDifference = parseFloat($(streamingInfo.node).text());
        if (tradePrice && targetPrice) {
          var currentTargetPriceDifference = 0;
          if (streamingInfo.format === SPECIAL_STREAMING_DATA_TYPE) {
            currentTargetPriceDifference = this.calculateDifference(targetPrice, tradePrice);
          } else {
            currentTargetPriceDifference = this.calculateDifference(tradePrice, targetPrice);
          }
          this.updatePriceDifferenceTrendMarker(streamingInfo, currentTargetPriceDifference);
          this.addPriceDifferenceStreamingAnimation(streamingInfo, currentTargetPriceDifference, previousTargetPriceDifference, this.BLINK_TIME);
        }
      } catch (e) {
        console.log(e);
      }
    }
  },
  /*
  * The difference calculator determines the difference between two values
  * @param {Number} current
  * @param {Number} previous
  * @return {Number}
  */
  calculateDifference: function calculateDifference(tradePrice, targetPrice) {
    return parseFloat((targetPrice - tradePrice).toFixed(3));
  },
  /*
  * Update the price difference streaming node value and add trend color based on '-' or '+'
  * @param {Object} streamingInfo
  * @param {Number} priceDifference
  */
  updatePriceDifferenceTrendMarker: function updatePriceDifferenceTrendMarker(streamingInfo, priceDifference) {
    var trendClass;
    var signedNumber = priceDifference;
    var showTrendPositiveMarker = $(streamingInfo.node).closest('[data-positive-marker]').data('positive-marker') ?? true;
    if (priceDifference === 0) {
      trendClass = 'stream';
    } else if (priceDifference > 0) {
      trendClass = 'stream up';
      signedNumber = "".concat(showTrendPositiveMarker ? '+' : '').concat(priceDifference);
    } else {
      trendClass = 'stream down';
    }
    streamingInfo.node.innerHTML = signedNumber;
    var showTrendMarker = $(streamingInfo.node).closest('[data-trend-marker]').data('trend-marker') ?? true;
    if (showTrendMarker) {
      $(streamingInfo.node).removeClass();
      $(streamingInfo.node).addClass(trendClass);
    }
  },
  /*
  * Adding animation to the parent node of price difference streamingInfo node
  * @param {Object} streamingInfo
  * @param {Number} priceDifference
  * @param {Number} previousPriceDifference
  * @param {Number} interval
  */
  addPriceDifferenceStreamingAnimation: function addPriceDifferenceStreamingAnimation(streamingInfo, priceDifference, previousPriceDifference, interval) {
    var animationNode = streamingInfo.getParentBoxNode();
    var animationClass;
    if (priceDifference > previousPriceDifference) {
      animationClass = 'streamingTouched streamingUp';
    } else if (priceDifference < previousPriceDifference) {
      animationClass = 'streamingTouched streamingDown';
    }
    $(animationNode).addClass(animationClass);
    window.setTimeout(function () {
      $(animationNode).removeClass('streamingTouched streamingUp streamingDown');
    }, interval);
  }
};
YAHOO.fcom.Streaming.registerFormatterPlugin(new _StreamingFormatterPlugin.default(STREAMING_DATA_TYPE, PriceDifferenceFormatter.format, PriceDifferenceFormatter, PriceDifferenceFormatter));
YAHOO.fcom.Streaming.registerFormatterPlugin(new _StreamingFormatterPlugin.default(SPECIAL_STREAMING_DATA_TYPE, PriceDifferenceFormatter.format, PriceDifferenceFormatter, PriceDifferenceFormatter));

},{"streaming/StreamingFormatterPlugin":1}]},{},[2]);
;
(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var YAHOO = window.YAHOO;

/*
 * the YAHOO.fcom.Context is a static helper class which holds the
 * functionality for the context menu.
 * All context menus except very specific ones (admin pages...) have the same
 * entry point, which is the YAHOO.fcom.Context.openMenu(configObject) function
 * depending on the attributes of the given config object, the menu's
 * entries will be selected. To add new menu entries scroll down to the definition of the
 * YAHOO.fcom.ContextMenuItem class, which is the class for all context menu items. To build a
 * new context menu item, create a new instance of that class and give it the required functions
 * and attributes. It will be automatically registered and shown. See the api doc of
 * YAHOO.fcom.ContextMenuItem for more informations.
 */
YAHOO.fcom.Context = {
  /*
   * the YAHOO.widget.Menu instance that is shown when a context menu link is clicked
   */
  menu: null,
  /*
   * the configuration attributes of the last opened context menu.
   * this info is used by the menu items to perform the requested actions.
   * Each time a context menu is opened, this config object is updated.
   */
  configObject: null,
  /*
   * available context menu entries. All context menu items available
   * in this array will be checked and shown when applicable. The order is important,
   * as the items will be exactly presented in the order that they appear in
   * this array. Registering to that array is done in the constructor of the
   * YAHOO.fcom.ContextMenuItem class, so there's no need to do this manually
   */
  availableItems: [],
  /*
   * a map object which will hold all context menu items, that are already added to the
   * menu (no matter whether they are visible or not). This is needed to find out whether
   * a given menu item is already initialized or not, as only the currently needed items get initialized
   */
  addedItems: {},
  /*
   * a count to keep track of pending ajax calls, before the menu can be rendered.
   */
  pendingAjaxCalls: 0,
  /*
   * this function will open a context menu with the given
   * configuration attributes. If no attributes are present
   * or the config object is not given at all, nothing is done.
   * @param event the event that triggered the call of this function
   * @param configObject The list of possible attributes is very long
   *        and will grow with every additional context functionality.
   *        Here's the list of known attributes:
   *        "context" : (optional) like in YAHOO.widget.Overlay or
   *            YAHOO.widget.Menu, this is expecting an array with
   *            three fields, to specify where the context menu should
   *            be aligned to.
   *            If this attribute is missing (the default), the context
   *            menu is aligned to the given element.
   *            An example could be ["myButton", "tl", "bl"], which
   *            would stick the menu with it's top left corner to the
   *            button's bottom left corner.
   *            
   *    "whitelist" : (optional String[]) limited set of contect menu unique names the
   *            context menu should be limited to. This can be helpful when e.g. modules are
   *            used as widgets in other pages, that do not apply to all the context menu entries. 
   *
   *    All following configuration attributes are describing the
   *    context item. At least one of those must be given, to allow a
   *    context menu. Some build logical unions, others does not make any sense
   *    without additional ones set.
   *
   *         "module" : the unique id of a module on a view. This will render context menu entries
   *           like remove this module or edit module settings. If no permission is available to alter those
   *           modules, the module id must not be passed to the context menu.
   *
   *        "ric" : the ric of an instrument for which the context menu
   *           is opened. This will allow actions like "add to watchlist" or similar
   *        "isin" : if the ric is not known, the isin can be given to have some
   *           minimal instrument possibilities. If a ric is given, isin will be ignored
   *        "secType" : if the secType is already known to the opener, this can help safe
   *           additional ajax requests, as the content of the menu strongly depends on the
   *           security type of the instrument. E.g. Warrants have an issuer, but stocks might
   *           have a company page.
   *           TODO: write which secType is expected here
   *        "isList" : (boolean) whether the context menu is used on several similar items in a list,
   *           or if it is used on the detail view of one single item. There are differences in
   *           the necessary actions after a successful command, that's why this information is needed.
   *
   *        "instrumentIndex" : in the watchlist things like ric or isin are not unique.
   *           the reason therefore are old imported customer watchlists with other type of identifiers
   *           or ambigous identifiers like isin or similar. Removing entries from a watchlist
   *           is therefore only possible by the index of the instrument in that watchlist.
   *        "watchlist" : the unique identifier of a watchlist. If in addition also an
   *           instrument is given, the context menu will behave as if the entries of this
   *           wachtlist are shown. So entries like "remove from watchlist" are shown
   *           in addition to the normal instrumnet functionalities. There will be no entries to
   *           directly access that watchlist.
   *           If only the watchlist is given, but no instrument, the context menu will behave like
   *           in a list of watchlists, giving functionality for that watchlist like
   *           "delete", "edit", "rename", "copy" and so on. This context menu can be used in a list
   *           of watchlists as well as on the function menu in the detailed view of the specific watchlist.
   *        "origin" : the origin of a watchlist or portfolio as returned by the direct fid WATCHLIST_ORIGIN
   *           depending on the value, instruments can be removed from that watchlist/portfolio, or not.
   *           Also the sharing only is added for own watchlists.
   *
   *        "portfolio" : the unique identifier of a portfolio. The behavior is identical to the watchlist:
   *           If an instrument is given in addition (ric or isin), only functions to alter the state of that instrument
   *           in the specific portfolio are shown, if there is no instrument given, functionality to work
   *           on that portfolio is shown (like "delete, "duplicate as watchlist"...)
   *
   *        "portfolioName": name of the portfolio (optional)
   *
   *        "position" (object): If the position is given in addition to the portfolio, additional functions
   *             to edit that position are available. The "portfolio" parameter is mandatory for positions.
   *             The position object contains the following properties:
   *             - id (string): The unique identifier of a position in a portfolio.
   *             - historic (boolean): Flag whether the position is historic (true -> historic).
   *             Position functions are only available if the portfolio is owned by the user.
   *             - instrumentName (string): the name of the position's instrument
   *             - notationFactor (number): notation factor of the instrument (1,100,1000)
   *
   *        "alert" : the unique id of an alert. In addition to the instrument functions, the
   *           functionality to work on that alert is shown, like "delete", "copy", "edit"
   *
   *        "newsStreaming": (Boolean) flag wheter news streaming is activated. Default is false.
   *
   *        "account" (object):  A cash account bean (see PortfolioCashAccountForm).
   *
   *        "moneyTransfer" (object): A money transfer bean (see PortfolioMoneyTransferForm).
   *
   *
   * @param element the element which was pressed to open the menu. This will be used to align the menu,
   *        if no context is given through the configuration attributes. In addition, the element will be
   *        held in mouse over mode as long as the menu is open, so that the user sees where the menu belongs.
   */
  openMenu: function openMenu(event, configObject, element) {
    if (!event) {
      event = window.event;
    }
    if (!configObject || configObject == null) {
      console.error('Call to context menu without attributes.');
    }
    if (this.availableItems.length < 1) {
      // context menu is not yet initialized
      // TODO: make a waitMask and a recall
      return;
    }
    var context = configObject.context;
    if (!context || context == null) {
      context = [element, 'tr', 'tl'];
    }
    if (YAHOO.fcom.Context.menu == null) {
      YAHOO.fcom.Context.menu = new YAHOO.widget.Menu('contextMenu', {
        clicktohide: true,
        context: context,
        hidedelay: 1500,
        position: 'dynamic'
      });
      for (var i = 0; i < this.availableItems.length; i++) {
        // add menu item and also register it to the addedItems
        YAHOO.fcom.Context.addedItems[this.availableItems[i].name] = YAHOO.fcom.Context.menu.addItem(this.availableItems[i].menuItem, this.availableItems[i].groupId);
      }
    } else {
      YAHOO.fcom.Context.menu.cfg.setProperty('context', context);
    }
    YAHOO.fcom.Context.pendingAjaxCalls = 0; // set 0 for every opening
    YAHOO.fcom.Context.configObject = configObject; // save the config for later use by the menu items
    YAHOO.fcom.Context.checkNeededItems();
    if (YAHOO.fcom.Context.pendingAjaxCalls < 1) {
      /* no calls pending, render and show menu */
      YAHOO.fcom.Context.menu.render(document.body); // append to document body so that ie does not create z-index problems
      YAHOO.fcom.Context.checkGroupDividers(); // check if there are empty groups, that lead to ugly dividers with nothing to divide
      YAHOO.fcom.Context.menu.show();
      YAHOO.fcom.Context.menu.align();
      YAHOO.fcom.Context.markContextElement(); // mark the context menu image
    }

    YAHOO.util.Event.stopEvent(event); // stop event to prevent old tables with tr-onclick to link away
  },

  /*
   * this is the handler that has to be called by context menu items that need an initial
   * ajax call to build their isNeeded condition or their content.
   */
  menuItemFromAjaxReady: function menuItemFromAjaxReady(contextMenuItem) {
    YAHOO.fcom.Context.prepareContextMenuItem(contextMenuItem);
    YAHOO.fcom.Context.pendingAjaxCalls--;
    if (YAHOO.fcom.Context.pendingAjaxCalls < 1) {
      /* no calls pending, render and show menu */
      YAHOO.fcom.Context.menu.render(document.body); // append to document body so that ie does not create z-index problems
      YAHOO.fcom.Context.checkGroupDividers(); // check if there are empty groups, that lead to ugly dividers with nothing to divide
      YAHOO.fcom.Context.menu.show();
      YAHOO.fcom.Context.menu.align();
      YAHOO.fcom.Context.markContextElement();
    }
    // if ajax calls are pending, nothing is shoiwn right now, the last pending ajax call will show the menu.
  },

  /*
   * walk through the menu and check if there are dividers who are not needed because all of the
   * group entries are invisible.
   */
  checkGroupDividers: function checkGroupDividers() {
    var ulElement = YAHOO.fcom.Context.addedItems[this.availableItems[0].name].element.parentNode;
    while (ulElement != null) {
      var childNodes = window.Dom.getChildrenBy(ulElement, function (node) {
        return node.nodeName === 'LI';
      });
      var anyVisible = false;
      for (var i = 0; i < childNodes.length; i++) {
        if (window.Dom.getStyle(childNodes[i], 'display') !== 'none') {
          anyVisible = true;
          break;
        }
      }
      if (anyVisible === false) {
        window.Dom.setStyle(ulElement, 'display', 'none');
      } else {
        window.Dom.setStyle(ulElement, 'display', '');
      }
      ulElement = window.Dom.getNextSiblingBy(ulElement, function (node) {
        return node.nodeName === 'UL';
      });
    }
  },
  /*
   * check through the array of available items and pick out the ones
   * that need to be displayed. If the items are already added, they are just made visible,
   * if they are not already added, they will be added to the menu.
   */
  checkNeededItems: function checkNeededItems() {
    for (var i = 0; i < YAHOO.fcom.Context.availableItems.length; i++) {
      if (YAHOO.fcom.Context.availableItems[i].triggerAjaxCallback(YAHOO.fcom.Context.configObject)) {
        /* if ajax is needed, continue here and wait for callbacks */
        YAHOO.fcom.Context.pendingAjaxCalls++;
        continue;
      }
      YAHOO.fcom.Context.prepareContextMenuItem(YAHOO.fcom.Context.availableItems[i]);
    }
  },
  /*
   * check whether the given item is needed and if it is, render it to the menu,
   * if it is not, hide it from the menu
   */
  prepareContextMenuItem: function prepareContextMenuItem(contextMenuItem) {
    var isNeeded = contextMenuItem.isNeeded(YAHOO.fcom.Context.configObject);
    if (isNeeded && YAHOO.fcom.Context.configObject['whitelist']) {
      isNeeded = $.inArray(contextMenuItem.name, YAHOO.fcom.Context.configObject['whitelist']) !== -1;
    }
    var menuItem = YAHOO.fcom.Context.addedItems[contextMenuItem.name];
    if (isNeeded) {
      if (!contextMenuItem.isVisible) {
        /* is it visible also? */
        YAHOO.fcom.Context.setItemVisible(contextMenuItem);
      }
    } else if (!YAHOO.lang.isUndefined(menuItem)) {
      /* item is not needed but was already added */
      if (contextMenuItem.isVisible) {
        YAHOO.fcom.Context.setItemInvisible(contextMenuItem);
      }
    }
  },
  /*
   * set this menu item invisible.
   */
  setItemInvisible: function setItemInvisible(menuItem) {
    menuItem.isVisible = false;
    var yuiMenuItem = YAHOO.fcom.Context.addedItems[menuItem.name];
    window.Dom.setStyle(yuiMenuItem.element, 'display', 'none');
  },
  /*
   * set this menu item visible.
   */
  setItemVisible: function setItemVisible(menuItem) {
    menuItem.isVisible = true;
    var yuiMenuItem = YAHOO.fcom.Context.addedItems[menuItem.name];
    window.Dom.setStyle(yuiMenuItem.element, 'display', '');
  },
  /*
   * when the context menu was opened by a push on the context menu button, this button should be
   * marked selected, so that the user sees which element the context menu items belong to.
   * If the element, the menu will be aligned to, is not an image, nothing is done.
   */
  markContextElement: function markContextElement() {
    var contextElement = YAHOO.util.Dom.get(YAHOO.fcom.Context.menu.cfg.getProperty('context')[0]);
    if (contextElement && contextElement.nodeName && contextElement.nodeName.toLowerCase() === 'button') {
      YAHOO.util.Dom.addClass(contextElement, 'disabled'); // set disabled to avoid standard mouse listeners
      YAHOO.fcom.Context.linkNodeLastPressed = contextElement;
      YAHOO.fcom.Context.menu.subscribe('hide', function subscribedFunction(type, args, contextElement) {
        YAHOO.util.Dom.removeClass(contextElement, 'disabled');
        YAHOO.fcom.Context.menu.unsubscribe('hide', subscribedFunction); //run listener once
      }, contextElement, false);
    }
  }
};

},{}]},{},[1]);
;
(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); } /**
                                                                                                                                                                                                                      * @use          : Extended YUI Menu class(yui/2.9.0/build/menu/menu.js)
                                                                                                                                                                                                                      * @dscription   : NGPII-15232 - Set the focus to last active element in the DOM
                                                                                                                                                                                                                      * @dependencies : JQuery, YUI Menu
                                                                                                                                                                                                                      */ // #. Import keycodes from the util
var ExtendedMenu = /*#__PURE__*/function (_window$YAHOO$widget$) {
  _inherits(ExtendedMenu, _window$YAHOO$widget$);
  var _super = _createSuper(ExtendedMenu);
  function ExtendedMenu() {
    var _this;
    _classCallCheck(this, ExtendedMenu);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));

    // #. Context variable to track the sub menu item from the context menu
    _this.isMenuItemSelected = false;
    _this.$activeSubMenu = null;
    return _this;
  }

  /**
   * @description: Extend the show method from base class yui menu
   * @method: show
   */
  _createClass(ExtendedMenu, [{
    key: "show",
    value: function show() {
      // #. Call the show method from the base class
      _get(_getPrototypeOf(ExtendedMenu.prototype), "show", this).call(this);
      this._setWCAGAttributes();

      // #. Get the menu context from cfg - base class method
      // $context[0] - contains the button/link html object which opens the menu
      var $context = this.cfg.getProperty('context');
      $context = $context ? $($context[0]) : null;

      // #. No need to set the context when the active menu item is a sub menu item
      if ($context && !$context.is('.yuimenuitem-hassubmenu-selected')) {
        this.isMenuItemSelected = false;
        window.YAHOO.fcom.Util.setValueToObject(window.YAHOO, 'fcom.ExtendedMenu.lastContext', $context);
      } else {
        if ($context) {
          this.$activeSubMenu = $context;
          $context.find('a').attr('aria-expanded', true);
        }
        this.isMenuItemSelected = true;
      }
    }

    /**
     * @description: Extend the hide method from base class yui menu
     * @method: hide
     */
  }, {
    key: "hide",
    value: function hide() {
      // #. Call the hide method from the base class
      _get(_getPrototypeOf(ExtendedMenu.prototype), "hide", this).call(this);

      // #. Get context variable from the global constant ExtendedMenu
      var $element = window.YAHOO.fcom.Util.deepFind(window.YAHOO, 'fcom.ExtendedMenu.lastContext');

      // #. Set focus to menu opened element
      // #. isMenuItemSelected - false means the context menu is hidden/selected
      // #. lastContext - value not null in the global constant
      if (this.isMenuItemSelected === false && $element) {
        // #. Set the tabindex attribute to context element
        if (!$element.attr('tabindex')) {
          $element.attr('tabindex', 0);
        }

        // #. Set the focus to context element
        // #. Set the timeout value to zero to make sure that menu hide method has completed.
        window.setTimeout(function () {
          $element.attr('aria-expanded', false).focus();
        }, 0);
      } else if (this.isMenuItemSelected === true) {
        if (this.$activeSubMenu) {
          this.$activeSubMenu.find('a').attr('aria-expanded', false);
        } else if ($element) {
          $element.attr('aria-expanded', false);
        }
      }
    }

    /**
     * @description: Extend the _onKeyDown method from base class yui menu
     * To set isMenuItemSelected value to true for avoid set focus at sub menu item selection event
     * @method: _onClick
     */
  }, {
    key: "_onClick",
    value: function _onClick() {
      var _get2;
      this.isMenuItemSelected = true;

      // #. Call the _onClick method from the base class
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      (_get2 = _get(_getPrototypeOf(ExtendedMenu.prototype), "_onClick", this)).call.apply(_get2, [this].concat(args));
    }

    /**
     * @description: Extend the _onKeyDown method from base class yui menu
     * To set isMenuItemSelected value to true for avoid set focus at sub menu item selection event
     * @method: _onKeyDown
     */
  }, {
    key: "_onKeyDown",
    value: function _onKeyDown() {
      var _get3;
      this.isMenuItemSelected = true;

      // #. Condition to manage the tab loop inside the context menu
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      if (args.length >= 1) {
        // #. Get the event object
        var event = args[1][0];
        // #. Get key code from the event
        var keyCode = event.keyCode;

        // #. Handle tab event - make sure that the tab loop is working properly in the menu
        if (keyCode === _keyCodes.default.TAB) {
          // #. Get current active menu
          var $activeMenuItem = $(event.target);
          // #. Get first menu item
          var $firstItem = this._getFirstEnabledItem();
          // #. Get last menu item
          var $lastMenuItem = this._getLastEnabledItem();

          // #. Convert menu items as HTML objects
          $lastMenuItem = $($lastMenuItem.element);
          $firstItem = $($firstItem.element);

          /**
           * Tab from last menu will be moved the focus to first menu item
           * Shift+Tab from first menu will be moved the focus to last menu item
           */
          if (!event.shiftKey && $lastMenuItem.find($activeMenuItem).length > 0) {
            event.preventDefault();
            this.setInitialFocus();
            return false;
          } else if (event.shiftKey && $firstItem.find($activeMenuItem).length > 0) {
            event.preventDefault();
            $lastMenuItem.find('a.yuimenuitemlabel').focus();
            return false;
          }
        }
      }

      // #. Call the _onKeyDown method from the base class
      (_get3 = _get(_getPrototypeOf(ExtendedMenu.prototype), "_onKeyDown", this)).call.apply(_get3, [this].concat(args));
    }

    /**
     * @method _getLastEnabledItem
     * @description Returns the last enabled item in the menu.
     * @return {YAHOO.widget.MenuItem}
     * @private
     */
  }, {
    key: "_getLastEnabledItem",
    value: function _getLastEnabledItem() {
      var menuItems = this.getItems();
      var menuCount = menuItems.length;
      var menu = null;
      var result = null;

      // #. Iterate menu items from the last
      for (var i = menuCount - 1; i >= 0; i--) {
        menu = menuItems[i];

        // #. Get the enabled menu item - not disabled & not hidden
        if (menu && !menu.cfg.getProperty('disabled') && menu.element.style.display !== 'none') {
          result = menu;
          break;
        }
      }
      return result;
    }

    /**
     * @method _setWCAGAttributes
     * @description set WCAG attributes to menu items
     * @private
     */
  }, {
    key: "_setWCAGAttributes",
    value: function _setWCAGAttributes() {
      var menuItems = this.getItems();
      // #. Set disabled attr
      var $body = $(this.body);
      $body.find('.yuimenuitemlabel-disabled').attr('aria-disabled', true);
      // #. Set hidden
      $body.find(':hidden').attr('aria-hidden', true);

      // #. Iterate menu items to set the attribute
      var _loop = function _loop() {
        var menu = menuItems[i];

        // #. Get the enabled menu item - not disabled & not hidden
        if (menu && !menu.cfg.getProperty('disabled') && menu.element.style.display !== 'none') {
          var subMenuSelector = 'yuimenuitem-hassubmenu';
          var hasSubMenu = $(menu.element).hasClass(subMenuSelector);
          var $link = $(menu.element).find('a');

          // #. Set menu item attributes
          $link.attr({
            role: 'menuitem'
          });
          var $li = $link.closest('li');
          var $ul = $link.closest('ul');
          $li.attr('role', 'none');

          // #. Set menu attributes
          if (hasSubMenu) {
            // for each item check if it has a sub menu to set menu attributes
            var itemSubMenuSelector = 'yuimenuitemlabel-hassubmenu';
            $link.each(function (i, item) {
              var itemHasSubmenu = $(item).hasClass(itemSubMenuSelector);
              if (itemHasSubmenu) {
                $(item).attr('aria-expanded', false);
                $(item).attr('aria-haspopup', true);
              }
            });
          }
          var $closestLi = $link.closest("li.".concat(subMenuSelector));
          var $parent = $link.parent();
          if ($closestLi.length > 0 && !$parent.is($closestLi)) {
            $ul.attr('role', 'menu');
          }
        }
      };
      for (var i = 0; i < menuItems.length; i++) {
        _loop();
      }
    }
  }]);
  return ExtendedMenu;
}(window.YAHOO.widget.Menu);
Object.assign(ExtendedMenu.prototype, window.YAHOO.widget.Menu.prototype);
// #. Assign the extended menu class to main YUI Menu prototype
window.YAHOO.widget.Menu.prototype = ExtendedMenu.prototype;

},{"util/enums/keyCodes":23}],2:[function(require,module,exports){
"use strict";

require("contextMenu/helperFunctions/addInstrumentListToUserWatchlist");
require("contextMenu/helperFunctions/copyWatchlist");
require("contextMenu/helperFunctions/createPortfolio");
require("contextMenu/helperFunctions/createWatchlist");
require("contextMenu/helperFunctions/clearWatchlist");
require("contextMenu/helperFunctions/deleteAlert");
require("contextMenu/helperFunctions/openFactsheetWindow");
require("contextMenu/helperFunctions/portfolioPositionDelete");
require("contextMenu/helperFunctions/relatedInstrumentClicked");
require("contextMenu/helperFunctions/removeWatchlists");
require("contextMenu/helperFunctions/portfolioDelete");
require("contextMenu/helperFunctions/watchlistConvertToPortfolio");
require("contextMenu/ExtendedMenu.es6");

},{"contextMenu/ExtendedMenu.es6":1,"contextMenu/helperFunctions/addInstrumentListToUserWatchlist":3,"contextMenu/helperFunctions/clearWatchlist":4,"contextMenu/helperFunctions/copyWatchlist":5,"contextMenu/helperFunctions/createPortfolio":6,"contextMenu/helperFunctions/createWatchlist":7,"contextMenu/helperFunctions/deleteAlert":8,"contextMenu/helperFunctions/openFactsheetWindow":9,"contextMenu/helperFunctions/portfolioDelete":10,"contextMenu/helperFunctions/portfolioPositionDelete":11,"contextMenu/helperFunctions/relatedInstrumentClicked":14,"contextMenu/helperFunctions/removeWatchlists":15,"contextMenu/helperFunctions/watchlistConvertToPortfolio":18}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * Add a list of instruments to a selected watchlist
 * @param {Array} ricList flat list of ric strings
 * @param {String} watchlistId
 * @param {Object} callback for ngpAsyncRequest
 */
var addInstrumentListToUserWatchlist = function addInstrumentListToUserWatchlist(ricList, watchlistId, callback) {
  var url = '/watchlist.action?method=handleAddInstrumentList';
  var json = JSON.stringify(ricList);
  window.ngpAsyncRequest('POST', url, callback, "watchlistId=".concat(watchlistId, "&json=").concat(json)).then(function () {
    return window.YAHOO.fcom.Broadcaster.sendMessage('@watchlists', {
      messageType: 'watchlistChanged',
      id: watchlistId
    });
  });
};
window.addInstrumentListToUserWatchlist = addInstrumentListToUserWatchlist;
var _default = exports.default = addInstrumentListToUserWatchlist;

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ajaxRequest = require("core/Ajax/ajaxRequest");
var _messageHandler = require("messages/messageHandler");
var _Dialogs = require("core/Dialogs");
/*
 * Clear a watchlist.
 * @param watchlist {String} name of the watchlist to rename
 * @param callback {Object}
 */
var clearWatchlist = function clearWatchlist(watchlist, callback) {
  var title = (0, _messageHandler.getMessage)('portfolio.dialog.wl.clear.title');
  var description = (0, _messageHandler.getMessage)('watchlist.deleteAllInstruments.confirm');
  (0, _Dialogs.ngpConfirm)(description, {
    title: title,
    okButtonText: (0, _messageHandler.getMessage)('txt.button.clear'),
    okHandler: function okHandler() {
      (0, _ajaxRequest.ajaxGet)('/watchlist.action', {
        method: 'handleRemoveAllInstruments',
        watchlistName: watchlist
      }).catch(function (response) {
        (0, _Dialogs.ngpAlert)(response);
      }).then(function (response) {
        if (callback) {
          callback();
        } else {
          window.location.reload();
        }
      });
    }
  });
};
window.clearWatchlist = clearWatchlist;
var _default = exports.default = clearWatchlist;

},{"core/Ajax/ajaxRequest":19,"core/Dialogs":21,"messages/messageHandler":22}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _showWatchlistInputPanel = _interopRequireDefault(require("contextMenu/helperFunctions/showWatchlistInputPanel"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*
 * Create a new watchlist and copy all instruments into the new watchlist.
 * @param wlName {String} name of the watchlist to copy
 * @param callback {Object}
 */
var copyWatchlist = function copyWatchlist(wlName, callback, isConversion) {
  //get watchlist info
  var url1 = window.YAHOO.fcom.Util.addURLParam('/watchlist.action?method=handleGetWatchlistsJSON', 'wlNames', wlName);
  var callback1 = {
    success: function success(response) {
      var wl = JSON.parse(response.responseText);
      if (wl.length > 0) {
        wl = wl[0];
        var displayName = "".concat(wl.displayName, " ").concat(window.getMessage('portfolio.dialog.wl.copy.input.value'));
        (0, _showWatchlistInputPanel.default)(window.getMessage(isConversion ? 'portfolio.dialog.wl.convert.title' : 'portfolio.dialog.wl.copy.title'), {
          displayName: displayName
        }, {
          fn: function fn(inputPanel) {
            //save the watchlist copy
            var map = {
              displayName: inputPanel.getFieldValues().displayName,
              name: wl.name
            };
            var url = '/watchlist.action?method=handleCopyWatchlist';
            var callback2 = {
              success: function success(response) {
                if (callback && callback.fn != null) {
                  callback.fn.call(callback.scope, response);
                } else {
                  window.location.reload();
                }
              },
              failure: function failure(response) {
                if (response.status === 409) {
                  inputPanel.showError(response.responseText, inputPanel.getInputField('displayName'));
                } else {
                  inputPanel.hide();
                  window.ngpAlert(window.getMessage('DEFAULT_AJAX_ERROR'));
                }
              },
              waitMask: true
            };
            window.ngpAsyncRequest('POST', url, callback2, window.YAHOO.fcom.Util.createPostData(map));
          }
        });
      }
    },
    waitMask: true
  };
  window.ngpAsyncRequest('POST', url1, callback1);
};
window.copyWatchlist = copyWatchlist;
var _default = exports.default = copyWatchlist;

},{"contextMenu/helperFunctions/showWatchlistInputPanel":16}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * Opens a dialog to create a portfolio. YUI-style callback parameters are available
 * @param callback {Function} receives
 * @param custom {Object} a custom object
 * @param override {Boolean|Object} if override is true, custom will become the scope for the callback. If override is an object,
 * it will be come the scope itself.
 */
var createPortfolio = function createPortfolio(callback, custom, override) {
  window.YAHOO.fcom.panel.PanelFactory.getAJAXPanel(window.YAHOO.fcom.panel.AJAXPanel.PORTFOLIO_CREATE, {
    fn: function fn(panel) {
      panel.saveEvent.subscribe(function (portfolio) {
        if (callback) {
          var scope = null;
          if (typeof override == 'boolean') {
            if (override === true) {
              scope = custom;
            }
          } else {
            scope = override;
          }
          callback.call(scope, portfolio, custom);
        }
      });
      panel.show();
    }
  });
};
window.createPortfolio = createPortfolio;
var _default = exports.default = createPortfolio;

},{}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _showWatchlistInputPanel = _interopRequireDefault(require("contextMenu/helperFunctions/showWatchlistInputPanel"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*
 * Shows an input dialog to create a new watchlist.
 * If no name is given, an input panel will be opened to enter a name for the new watchlist.
 * The server response contains a json object:
 * <pre>
 * {displayName:String, name:String}
 * </pre>
 * @param name {String} (optional) the name for the new watchlist
 * @param callback {Object} (optional) a callback object containing the members success, failure, scope.
 * The callback functions will be called with the server response as argument.
 * If no callback object is not given, the default behavior for success is a page reload, and for failure an alert.
 *
 */
var createWatchlist = function createWatchlist(name, callback) {
  //inner function to create watchlist serverside
  function create(wlName, inputPanel) {
    var watchlistCreatedCallback = {
      success: function success(response) {
        if (inputPanel != null) {
          inputPanel.hide();
        }
        if (callback && callback.success) {
          callback.success.call(callback.scope, response);
        } else {
          window.location.reload();
        }
      },
      failure: function failure(response) {
        if (callback && callback.failure) {
          if (inputPanel != null) {
            inputPanel.hide();
          }
          callback.failure.call(callback.scope, response);
        } else if (inputPanel != null && response.status === 409) {
          inputPanel.showError(response.responseText, inputPanel.getInputField('displayName'));
        } else {
          if (inputPanel != null) {
            inputPanel.hide();
          }
          window.ngpAlert(window.getMessage('DEFAULT_AJAX_ERROR'));
        }
      },
      waitMask: true
    };
    var encodedWlName = encodeURIComponent(wlName);
    var postData = "method=handleCreateWatchlist&property1=".concat(encodedWlName);
    window.ngpAsyncRequest('POST', '/watchlist.action', watchlistCreatedCallback, postData);
  }
  if (name != null && window.YAHOO.fcom.Util.trim(name)) {
    create(name);
  } else {
    //no name was supplied -> show input panel
    (0, _showWatchlistInputPanel.default)(window.getMessage('portfolio.dialog.wl.create.title'), {
      displayName: window.getMessage('portfolio.dialog.wl.create.input.value')
    }, {
      fn: function fn(inputPanel) {
        var wlName = inputPanel.getFieldValues().displayName;
        create(wlName, inputPanel);
      }
    });
  }
};
window.createWatchlist = createWatchlist;
var _default = exports.default = createWatchlist;

},{"contextMenu/helperFunctions/showWatchlistInputPanel":16}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * Shows a confirmation dialog to delete one or more alerts.
 * Fires the page event <tt>"alertChanged"</tt>.
 * @param {String|String[]} alertIds single id or a list of alert ids
 */
var deleteAlert = function deleteAlert(alertIds) {
  var message = window.getMessage('alert.dialog.js.delete.simple.message');
  if (window.ngpIsType('Array', alertIds) && alertIds) {
    message = window.getMessage('alert.dialog.js.delete.multiple.message');
  }
  window.ngpConfirm(message, {
    width: '250px',
    fixedcenter: true,
    dragOnly: true,
    constraintoviewport: true,
    modal: true,
    okButtonText: window.getMessage('txt.button.delete'),
    okHandler: function okHandler() {
      window.ngpAsyncRequest('POST', '/alert.action?method=alertDelete', {
        success: function success() {
          window.YAHOO.fcom.Page.fire('alertChanged', 'delete');
        }
      }, window.YAHOO.fcom.Util.createPostData({
        trigger: alertIds
      }));
    },
    title: window.getMessage('alert.dialog.js.delete.title')
  });
};
window.deleteAlert = deleteAlert;
var _default = exports.default = deleteAlert;

},{}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openFundFactsheetWindow = exports.openFactsheetWindow = void 0;
/*
 * Opens the factsheet window
 *
 * @param ric
 * @param secType
 */
var openFactsheetWindow = exports.openFactsheetWindow = function openFactsheetWindow(ric, filename) {
  var popupwinUrl = "".concat(window.ctx).concat(filename, ".plain?ric=").concat(ric);
  window.open(popupwinUrl, 'factsheet', "top=0,width=858,resizable=yes,menubar=yes,status=no,scrollbars=yes,height=".concat(window.Dom.getViewportHeight())).focus();
};
var openFundFactsheetWindow = exports.openFundFactsheetWindow = function openFundFactsheetWindow(ric, id, filename) {
  var popupwinUrl = "".concat(window.ctx).concat(filename, ".plain?ric=").concat(ric, "&id=").concat(id);
  window.open(popupwinUrl, 'factsheet', "top=0,width=858,resizable=yes,menubar=yes,status=no,scrollbars=yes,height=".concat(window.Dom.getViewportHeight())).focus();
};
window.openFactsheetWindow = openFactsheetWindow;
window.openFundFactsheetWindow = openFundFactsheetWindow;

},{}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * Delete portfolios
 * @param portfolios {Array} containing objects with the following properties:
 *  <ul>
 *     <li> id {String} the portfolio id
 *     <li> name {String} the portfolio name
 * </ul>
 */
var portfolioDelete = function portfolioDelete(portfolios) {
  var message = '';
  var idList = portfolios[0].id.split(',') || [];
  if (idList.length > 1) {
    message = window.replaceSpringMessageArguments(window.getMessage('portfolio.dialog.deletePortfolio.question.several'), [idList.length]);
  } else if (idList.length === 1) {
    var pfName = window.fcom.util.StringHelper.escapeHTML(portfolios[0].name);
    message = window.replaceSpringMessageArguments(window.getMessage('portfolio.dialog.deletePortfolio.question.one'), [pfName]);
  } else {
    return; //no positions to delete
  }

  window.ngpConfirm(message, {
    okButtonText: window.getMessage('txt.button.delete'),
    okHandler: function okHandler() {
      var url = window.YAHOO.fcom.Util.addURLParam('/portfolio.action?method=handleRemovePortfolio', 'idList', idList);
      var callback = {
        success: function success() {
          //reload page
          window.location.reload();
        },
        failure: function failure(response) {
          window.ngpAlert(response.responseText);
        },
        waitMask: true
      };
      window.ngpAsyncRequest('GET', url, callback);
    },
    fixedCenter: true
  });
};
window.portfolioDelete = portfolioDelete;
var _default = exports.default = portfolioDelete;

},{}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _portfolioPositionDeleteList = _interopRequireDefault(require("contextMenu/helperFunctions/portfolioPositionDeleteList"));
var _portfolioPositionDeleteSingle = _interopRequireDefault(require("contextMenu/helperFunctions/portfolioPositionDeleteSingle"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*
 * Delete a positions from a portfolio.
 * Removing positions from a portfolio depends whether the position is a pure position.
 * If it is a pure position, it can be deleted directly. Otherwise the according buy or sell transaction
 * can be deleted instead, but with all its consequences: Deleting a buy transaction will delete all
 * related transactions and positions.
 *
 * @param portfolio {Object} containing the following properties:
 * <ul>
 *     <li> id {String} the portfolio id
 *     <li> name {String} the portfolio name
 * </ul>
 * @param positions {Array} list of position objects containing the following properties:
 * <ul>
 *     <li> id {String} the id of the position
 *  <li> instrumentName {String} the instrument name of the position
 * </ul>
 * @param historic {Boolean} true -> historic position
 */
var portfolioPositionDelete = function portfolioPositionDelete(portfolio, positions, historic) {
  if (positions.length > 1) {
    (0, _portfolioPositionDeleteList.default)(portfolio, positions, historic);
  } else if (positions.length === 1) {
    (0, _portfolioPositionDeleteSingle.default)(portfolio, positions[0], historic);
  }
};
window.portfolioPositionDelete = portfolioPositionDelete;
var _default = exports.default = portfolioPositionDelete;

},{"contextMenu/helperFunctions/portfolioPositionDeleteList":12,"contextMenu/helperFunctions/portfolioPositionDeleteSingle":13}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 *
 *
 * @param portfolio {Object} containing the following properties:
 * <ul>
 *     <li> id {String} the portfolio id
 *     <li> name {String} the portfolio name
 * </ul>
 * @param positions {Array} list of position objects containing the following properties:
 * <ul>
 *     <li> id {String} the id of the position
 *  <li> instrumentName {String} the instrument name of the position
 * </ul>
 * @param historic {Boolean} true -> historic position
 */
var portfolioPositionDeleteList = function portfolioPositionDeleteList(portfolio, positions, historic) {
  var message = '';
  var pfName = window.fcom.util.StringHelper.escapeHTML(portfolio.name);
  if (historic === true) {
    message = window.getMessage('portfolio.dialog.deleteHistoricPosition.question.several');
  } else {
    message = window.getMessage('portfolio.dialog.deleteCurrentPosition.question.several');
  }
  message = window.replaceSpringMessageArguments(message, [positions.length, pfName]);
  var idList = [];
  var len = positions.length;
  for (; len--;) {
    idList.push(positions[len].id);
  }
  window.ngpConfirm(message, {
    okButtonText: window.getMessage('txt.button.delete'),
    okHandler: function okHandler() {
      var url = window.YAHOO.fcom.Util.addURLParam("/portfolio.action?method=handleRemovePositionList&pfid=".concat(encodeURIComponent(portfolio.id)), 'idList', idList);
      var callback = {
        success: function success() {
          //reload page
          window.location.reload();
        },
        failure: function failure(response) {
          window.ngpAlert(response.responseText, {
            onHide: function onHide() {
              if (response.status === 409) {
                window.location.reload();
              }
            }
          });
        },
        waitMask: true
      };
      window.ngpAsyncRequest('GET', url, callback);
    },
    fixedCenter: true
  });
};
var _default = exports.default = portfolioPositionDeleteList;

},{}],13:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _transactionDelete = _interopRequireDefault(require("contextMenu/helperFunctions/transactionDelete"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*
 * @param portfolio {Object} containing the following properties:
 * <ul>
 *     <li> id {String} the portfolio id
 *     <li> name {String} the portfolio name
 * </ul>
 * @param position {Object}
 * <ul>
 *     <li> id {String} the id of the position
 *  <li> instrumentName {String} the instrument name of the position
 * </ul>
 * @param historic {Boolean} true -> historic position
 */
var portfolioPositionDeleteSingle = function portfolioPositionDeleteSingle(portfolio, position, historic) {
  var message = '';
  var pfName = window.fcom.util.StringHelper.escapeHTML(portfolio.name);
  if (historic === true) {
    message = window.getMessage('portfolio.dialog.deleteHistoricPosition.question.one');
  } else {
    message = window.getMessage('portfolio.dialog.deleteCurrentPosition.question.one');
  }
  message = window.replaceSpringMessageArguments(message, [position.instrumentName, pfName]);
  window.ngpConfirm(message, {
    okButtonText: window.getMessage('txt.button.delete'),
    okHandler: function okHandler() {
      var url = '/portfolio.action?method=handleRemovePosition';
      var postData = window.YAHOO.fcom.Util.createPostData({
        portfolioID: portfolio.id,
        positionID: position.id,
        historic: historic
      });
      var callback = {
        success: function success() {
          //reload page
          window.location.reload();
        },
        failure: function failure(response) {
          var historic = response.argument.historic;
          if (response.status === 409) {
            //position is not pure -> suggest deleting buy transaction
            var _position = /* @type YAHOO.fcom.bean.Position*/JSON.parse(response.responseText);
            if (historic && _position.sellTransaction) {
              window.ngpConfirm(window.getMessage('portfolio.dialog.deleteHistoricPosition.sellTransaction'), {
                okHandler: function okHandler() {
                  (0, _transactionDelete.default)('sell', _position.sellTransaction, false);
                },
                okButtonText: window.getMessage('txt.button.delete')
              });
            } else if (_position.buyTransaction) {
              window.ngpConfirm(window.getMessage('portfolio.dialog.deleteCurrentPosition.buyTransaction'), {
                okHandler: function okHandler() {
                  (0, _transactionDelete.default)('buy', _position.buyTransaction, false);
                },
                okButtonText: window.getMessage('txt.button.delete')
              });
            }
          } else {
            window.ngpAlert(response.responseText);
          }
        },
        waitMask: true,
        argument: {
          historic: historic
        }
      };
      window.ngpAsyncRequest('POST', url, callback, postData);
    }
  });
};
var _default = exports.default = portfolioPositionDeleteSingle;

},{"contextMenu/helperFunctions/transactionDelete":17}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * one of the related instrument types in the menu was clicked.
 * @param type the full text version of the type like "warrants" or "futures"
 */
var relatedInstrumentClicked = function relatedInstrumentClicked(type) {
  var parameter = window.YAHOO.fcom.Context.configObject.isin;
  if (window.YAHOO.lang.isUndefined(parameter)) {
    parameter = window.YAHOO.fcom.Context.configObject.ric;
  }
  if (type === 'warrants') {
    window.redirectTo("/screener.html?method=derScreenerResult&secTypeGroup=WARRANT&derivativeUnderlying=".concat(parameter));
  } else if (type === 'options') {
    window.redirectTo("/screener.html?method=optScreenerResult&underlying=".concat(parameter));
  } else if (type === 'futures') {
    window.redirectTo("/screener.html?method=futScreenerResult&underlying=".concat(parameter));
  } else {
    // certificate with a certificate subtype
    window.redirectTo("/screener.html?method=derScreenerResult&secTypeGroup=".concat(type, "&derivativeUnderlying=").concat(parameter));
  }
};
window.relatedInstrumentClicked = relatedInstrumentClicked;
var _default = exports.default = relatedInstrumentClicked;

},{}],15:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * delete a watchlist or an array of watchlist
 * @param watchlist {String || Array} a watchlist id or an array of watchlist ids
 */
var removeWatchlists = function removeWatchlists(watchlist) {
  window.ngpConfirm(window.getMessage('portfolio.dialog.wl.delete.info'), {
    title: window.getMessage('portfolio.dialog.wl.delete.title'),
    okButtonText: window.getMessage('txt.button.delete'),
    okHandler: function okHandler() {
      var url = '/watchlist.action?method=handleDeleteWatchlist';
      if (typeof watchlist == 'string') {
        url = window.YAHOO.fcom.Util.addURLParam(url, 'wlNames', watchlist);
      } else if (watchlist instanceof Array) {
        url += "&".concat(window.YAHOO.fcom.Util.arrayToParam(watchlist, 'wlNames'));
      }
      var callback = {
        success: function success() {
          window.location.reload();
        },
        failure: function failure(response) {
          window.ngpAlert(response.responseText, {
            onHide: function onHide() {
              if (response.status === 409) {
                window.location.reload();
              }
            }
          });
        },
        waitMask: true
      };
      window.ngpAsyncRequest('GET', url, callback);
    }
  });
};
window.removeWatchlists = removeWatchlists; // required from code that does not support imports
var _default = exports.default = removeWatchlists;

},{}],16:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * Shows a input panel for watchlists.
 * @param title {String} title of the panel
 * @param fieldInput {Object} containing the following properties:
 * <ul>
 *     <li>displayName {String} input for the display name field
 * </ul>
 * @param callback {Object} containing the properties <code>fn:Function</code> and <code>scope:Object</code>.
 *     The callback function will be called with the input panel as argument.
 */
var showWatchlistInputPanel = function showWatchlistInputPanel(title, fieldInput, callback) {
  var uniqueId = 'panel' + '_' + Math.random().toString(36).substr(2, 9) + '_OnId';
  fieldInput = fieldInput || {};
  window.YAHOO.fcom.panel.PanelFactory.openInputPanel({
    title: title || '',
    fields: [{
      //field config
      type: 'text',
      maxlength: '100',
      label: window.getMessage('portfolio.dialog.wl.create.label.name'),
      name: 'displayName',
      id: uniqueId,
      defaultValue: fieldInput.displayName || '',
      styles: [['width', '200px']],
      validateFn: function validateFn(inputField) {
        if (!window.YAHOO.fcom.Util.trim(inputField.value)) {
          return window.getMessage('portfolio.dialog.wl.error.id.empty');
        }
        return null;
      }
    }],
    saveHandler: function saveHandler(inputDialog) {
      //save the watchlist
      if (callback && callback.fn != null) {
        callback.fn.call(callback.scope, inputDialog);
      }
    }
  }, {
    //panel config
    close: true,
    width: '300px'
  });
};
var _default = exports.default = showWatchlistInputPanel;

},{}],17:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * Opens a confirmation dialog to delete a transaction. Type must be given, as the message shown to
 * the user will be different.
 *
 * @param {String} type
 * @param {String} id
 * @param {Boolean} confirmation
 */
var transactionDelete = function transactionDelete(type, id, confirmation) {
  function sendRequest(transactionId) {
    var url = window.YAHOO.fcom.Util.addURLParam('/portfolio.action?method=handleTransactionDelete', 'transactionID', transactionId);
    window.ngpAsyncRequest('POST', url, {
      success: function success() {
        window.location.reload();
      },
      failure: function failure(response) {
        window.ngpAlert(response.responseText);
      }
    });
  }
  if (confirmation !== false) {
    var message = type === 'buy' ? window.getMessage('portfolio.dialog.js.transaction.confirm.deleteBuy') : window.getMessage('portfolio.dialog.js.transaction.confirm.delete');
    window.ngpConfirm(message, {
      title: window.getMessage('context.menu.entry.txt.transaction.delete'),
      okHandler: function okHandler() {
        sendRequest(id);
      },
      okButtonText: window.getMessage('txt.button.delete')
    });
  } else {
    sendRequest(id);
  }
};
var _default = exports.default = transactionDelete;

},{}],18:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * Convert the given watchlists into portfolios.
 * @param watchlists {Array} array containing the watchlist ids
 */
var watchlistConvertToPortfolio = function watchlistConvertToPortfolio(watchlists) {
  if (watchlists.length > 0) {
    window.ngpConfirm(window.getMessage('portfolio.dialog.copyWatchlist2Portfolio.question'), {
      okButtonText: window.getMessage('txt.button.copy'),
      okHandler: function okHandler() {
        var url = '/watchlist.action?method=handleCopyWatchlists2Portfolios';
        var copyPortfolioCallBack = {
          success: function success(response) {
            window.ngpAlert(response.responseText);
          },
          failure: function failure() {
            window.ngpAlert(window.getMessage('DEFAULT_AJAX_ERROR'));
          },
          waitMask: true
        };
        var postData = window.YAHOO.fcom.Util.arrayToParam(watchlists, 'watchlistIds');
        window.ngpAsyncRequest('POST', url, copyPortfolioCallBack, postData);
      }
    });
  }
};
window.watchlistConvertToPortfolio = watchlistConvertToPortfolio;
var _default = exports.default = watchlistConvertToPortfolio;

},{}],19:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ajaxPostJson = exports.ajaxPost = exports.ajaxGetJson = exports.ajaxGet = void 0;
var _objectToPostdata = _interopRequireDefault(require("core/Ajax/objectToPostdata"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/** @module core/Ajax/ajaxRequest */

/**
 * ajaxRequest is a wrapper for window.fetch that encapsulates all its functionality
 * @private
 * @param {String} method
 * @param {String} url
 * @param {String} [format] data format expected, this can be one of:
 * <ul>
 *  <li>text (default)</li>
 *  <li>json</li>
 *  <li>blob</li>
 *  <li>arrayBuffer</li>
 *  <li>formData</li>
 * </ul>
 * @param {Object} [data] key value object to be sent as post data or appended to url as get parameters
 * @param {Object} [headers] key value object containing request headers to be sent
 * @return {Promise.<any>}
 */
var ajaxRequest = function ajaxRequest(method, url, format, data, headers) {
  format = format || 'text';
  headers = headers || null;
  var fetchOptions = {
    method: method,
    headers: headers,
    credentials: 'same-origin'
  };
  var params = '';
  if (typeof data === 'string') {
    params = data;
  } else {
    params = (0, _objectToPostdata.default)(data);
  }
  if (method === 'GET') {
    if (params) {
      url += (url.indexOf('?') > -1 ? '&' : '?') + params;
    }
  } else {
    fetchOptions.body = params || null;
  }
  if (url.indexOf('/') === 0) {
    url = window.ctx + url;
  }
  return window.fetch(url, fetchOptions).then(function (response) {
    if (response.ok) {
      return response[format]();
    } else {
      if (!response.headers.has('applicationMessage')) {
        throw new Error("".concat(response.status, " - ").concat(response.statusText));
      } else {
        var error = new Error();
        error.code = response.status;
        error.message = response.headers.get('applicationMessage');
        throw error;
      }
    }
  });
};

/**
 * executes a GET request to the provided url and returns a promise
 * @param {String} url
 * @param {Object} [data] key value object to be appended to url as get parameters
 * @param {Object} [headers] key value object containing request headers to be sent
 * @return {Promise.<string>}
 */
var ajaxGet = exports.ajaxGet = function ajaxGet(url, data, headers) {
  return ajaxRequest('GET', url, 'text', data || {}, Object.assign({}, headers));
};

/**
 * executes a GET request to the provided url and returns a promise
 * @param {String} url
 * @param {Object} [data] key value object to be appended to url as get parameters
 * @param {Object} [headers] key value object containing request headers to be sent
 * @return {Promise.<any>}
 */
var ajaxGetJson = exports.ajaxGetJson = function ajaxGetJson(url, data, headers) {
  return ajaxRequest('GET', url, 'json', data || {}, Object.assign({}, headers));
};

/**
 * executes a POST request to the provided url and returns a promise
 * @param {String} url
 * @param {Object} [data] key value object to be sent as post data
 * @param {Object} [headers] key value object containing request headers to be sent
 * @return {Promise.<string>}
 */
var ajaxPost = exports.ajaxPost = function ajaxPost(url, data, headers) {
  return ajaxRequest('POST', url, 'text', data || {}, Object.assign({
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
  }, headers));
};

/**
 * executes a POST request to the provided url and returns a promise
 * @param {String} url
 * @param {Object} [data] key value object to be sent as post data
 * @param {Object} [headers] key value object containing request headers to be sent
 * @return {Promise.<any>}
 */
var ajaxPostJson = exports.ajaxPostJson = function ajaxPostJson(url, data, headers) {
  return ajaxRequest('POST', url, 'json', data || {}, Object.assign({
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
  }, headers));
};

},{"core/Ajax/objectToPostdata":20}],20:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/*
 * Create a post data string from an object by using the property names as
 * parameter names. The values will be URI encoded.
 * Returns null for any input that is not an object.
 */
var objectToPostdata = function objectToPostdata(postData) {
  return _typeof(postData) !== 'object' || postData == null ? null : Object.keys(postData).map(function (key) {
    return [].concat(itemToString(postData[key])).filter(function (f) {
      return f != null;
    }).map(function (a) {
      return "".concat(key, "=").concat(encodeURIComponent(a));
    });
  }).reduce(function (all, a) {
    return all.concat(a);
  }, []).join('&');
};
var itemToString = function itemToString(item, jsonEncodeArray) {
  if (typeof item === 'function' || item == null) {
    //invalid stuff should be ignored
    return null;
  } else if (!jsonEncodeArray && Array.isArray(item)) {
    return item.map(function (a) {
      return itemToString(a, true);
    });
  } else if (_typeof(item) === 'object') {
    if (typeof item.toString === 'function') {
      var string = item.toString();
      // if the object has an overwritten toString method
      if (string.indexOf('[object ') !== 0) {
        return string;
      }
    }
    return JSON.stringify(item);
  } else {
    return "".concat(item);
  }
};
var _default = exports.default = objectToPostdata;

},{}],21:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showUserSettings = exports.showReutersLink = exports.ngpConfirm = exports.ngpAlert = void 0;
var YAHOO = window.YAHOO;
var Dom = window.Dom;

/*
 * this function opens a panel similar to the ngpAlert panel, but in this case the alert expects the user to say yes or no.
 * The function can not block like the native javascript confirm, so it is not returning boolean, but expects a handler for
 * the yes and the no case. See config attributes for more informations. If message is given null,
 * a default message like "are you sure" will be shown.
 * @param message the message to be shown in the panel. Take care that the question fits to the button texts. If given
 *        null, a default message like "are you sure" is used.
 * @param config configuration attributes for the panel. Every given attribute will be forwarded to the panel used, so have
 *        a look at the YUI api documentation for available configuration possibilities. Some additional configuration
 *        attributes are understood by the ngpConfirm:
 *        - okButtonText: a string that will be shown on the ok button. (optional)
 *        - cancelButtonText: a string that will be shown on the cancel button. (optional)
 *        - okHandler: a function that will be called when the user hits the ok button (optional)
 *        - cancelHandler: a function that will be called when the user hits the cancel button (optional)
 *        - handlerArgument: an argument that will be given to the okHandler or the cancelHandler when they get called (optional).
 *          use an array, when there is the need of several arguments, or the okHandler needs other arguments than the cancelHandler
 *        - title: a string that will be used as the title instead of the default title. (optional)
 */
var ngpConfirm = exports.ngpConfirm = function ngpConfirm(message, config) {
  config = config || {};
  config.message = message;
  YAHOO.fcom.panel.PanelFactory.openConfirmPanel(config);
};

/*
 * do a nice alert using a modal html box instead of the ugly javascript alerts with all there problems.
 * The default behavior is opening a modal panel with a "error message" header and the given message in the panel.
 * @param message a plain text or html message to be added on the panel
 * @param config an optinal config object with attributes to change the dfault behavior of the alert panel. Known fields are
 *        all of the known panel config attributes (see YAHOO.widget.Panel api docu for a list of all possible attributes)
 *        In addition the attribute "title" will be read and the panel's title will be set to the given string.
 *        Another additional config attribute is "onHide", which accepts a function which will be called when the alert is hidden.
 *        in addition another field "handlerArgument" can be passed, which will then be given to the onHide function as only argument.
 */
var ngpAlert = exports.ngpAlert = function ngpAlert(message, config) {
  YAHOO.fcom.panel.PanelFactory.openAlertPanel(message, config);
};
var showReutersLink = exports.showReutersLink = function showReutersLink() {
  window.fillPanelFromAjax('reutersLinksPanelDiv', '/common/reutersLink.plain', null, {
    width: '310px',
    fixedcenter: false,
    visible: false,
    close: true,
    dragOnly: true,
    draggable: true,
    constraintoviewport: true,
    modal: true
  });
};
var showTermsConditions = function showTermsConditions() {
  window.fillPanelFromAjax('reutersLinksPanelDiv', '/customized/fgb/TermsConditions.plain', null, {
    width: '810px',
    fixedcenter: false,
    visible: false,
    x: 200,
    close: true,
    dragOnly: true,
    draggable: true,
    constraintoviewport: true,
    modal: true
  });
};
var showUserSettings = exports.showUserSettings = function showUserSettings() {
  var xPos = Math.max(5, Dom.getViewportWidth() / 2 - 500);
  var yPos = 50;
  var panelConfig = {
    id: 'personalSettingsDialog',
    requiredScripts: ['personalUserSettingsDialog.js'],
    panelNamespace: 'YAHOO.fcom.panel.PersonalUserSettingsDialog',
    url: 'usersettings.panel?method=handleShowUserSettingsDialog',
    width: '1000px',
    x: xPos,
    y: yPos,
    fixedcenter: false,
    visible: false,
    close: true,
    dragOnly: true,
    constraintoviewport: true,
    modal: true,
    refresh: true
  };
  window.showWait(true, true);
  YAHOO.fcom.panel.PanelFactory.getAJAXPanel(panelConfig, {
    fn: function fn(panel) {
      window.showWait(false);
      panel.show();
    }
  });
};
window.ngpConfirm = ngpConfirm;
window.ngpAlert = ngpAlert;
window.showReutersLink = showReutersLink;
window.showUserSettings = showUserSettings;

},{}],22:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerMessages = exports.getMessage = exports.addMessage = void 0;
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/** @module messages/messageHandler */

//use an object in window as cache, in order to prevent multiple instances of the cache
window.__messagesCache = window.__messagesCache || {};
var messages = window.__messagesCache;

/**
 * adds a message object with key value pairs for translation
 * @param {Object} msg
 */
var registerMessages = exports.registerMessages = function registerMessages(msg) {
  Object.assign(messages, msg);
};

/**
 * adds a message to the global message cache for translation
 * @param {string} key
 * @param {string} value
 */
var addMessage = exports.addMessage = function addMessage(key, value) {
  messages[key] = value;
};

/**
 * translates a given key and replaces {0}..{n} with the respective replacements
 * @param {string} key
 * @param {...string} replacements
 * @returns {string}
 * @example
 * addMessage('example', 'example {0} of {1}')
 * getMessage('example', '4', 'many');
 * // --> 'example 4 of many'
 * getMessage('example', ['2', '6']);
 * // --> 'example 2 of 6'
 */
var getMessage = exports.getMessage = function getMessage(key) {
  var _ref;
  for (var _len = arguments.length, replacements = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    replacements[_key - 1] = arguments[_key];
  }
  replacements = (_ref = []).concat.apply(_ref, _toConsumableArray(replacements));
  var message = messages[key] || key.split('.').reduce(function (all, a) {
    return a;
  }, '');
  message = message.replace(/\{(\d)\}/g, function (match, id) {
    return replacements[+id] != null ? replacements[+id] : match;
  });
  return message;
};
window.registerMessages = registerMessages;
window.getMessage = getMessage;
window.addMessage = addMessage;

},{}],23:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var KEYCODE = {
  ENTER: 13,
  SPACE: 32,
  ESCAPE: 27,
  ARROW_LEFT: 37,
  ARROW_UP: 38,
  ARROW_RIGHT: 39,
  ARROW_DOWN: 40,
  TAB: 9,
  KeyA: 65,
  KeyD: 68,
  DELETE: 46
};
var _default = exports.default = KEYCODE;

},{}]},{},[2]);
;
(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var YAHOO = window.YAHOO;

/*
 * @constructor
 * @param panelConfig
 */
var AJAXPanel = function AJAXPanel(panel, config) {
  /*
   * the panel's configuration,
   * it might differ from the static configuration that is was derived from
   * @property
   * @private
   */
  this.config = config;

  /*
   * the wrapped panel instance
   * @property
   * @type YAHOO.widget.Panel
   */
  this.panel = panel;
  /*
   * @property
   * @type String
   */
  this.id = panel.id;
  if (this.panel.showEvent) {
    // popup implementation has no yahoo panel instance
    /*
     * showEvent, fires when the panel is shown
     * @event
     * @type YAHOO.util.CustomEvent
     */
    this.showEvent = new YAHOO.util.CustomEvent('show', this);
    this.panel.showEvent.subscribe(function () {
      YAHOO.util.Dom.setStyle(this.panel.element, 'display', '');
      this.showEvent.fire();
    }, this, true);
    this.panel.hideEvent.subscribe(function () {
      YAHOO.util.Dom.setStyle(this.panel.element, 'display', 'none');
    }, this, true);
  }

  /*
   * flag indicating wether this panel needs a content refreshed
   * @private
   * @type Boolean
   */
  this.isDirty = false;
  this.hideErrorMessage();
  this.init(); //breakpoint here when debugging a AJAXPanel subclass
};

/*
 * An panel that will be filled from a remote source.
 * This panel has a functionality to include needed scripts on demand.
 * @class
 *
 */
AJAXPanel.prototype = {
  /*
   * Initialize the panel. Initialize will be called after creating the panel instance,
   * and after a refresh of the panel's content was triggered.
   * Override this function in subclasses.
   *
   * While debugging, to jump into the init function of the actual instance,
   * use constructor of this class
   *
   */
  init: function init() {},
  /*
   * Set dynamic panel data.
   * This is a callback function and will be called automatically with the panel's required data.
   * See Java Method <tt>AjaxResponseHelper.writePanel</tt>
   *
   * Override this function in subclasses.
   *
   * @param {} panelData arbitrary panel data, specifiy this parameter more detailed in the subclass implementation
   */
  setData: function setData( /*panelData*/) {},
  show: function show() {
    this.panel.show();
  },
  hide: function hide() {
    this.panel.hide();
  },
  /*
   * Returns a gui element instance by its id.
   * @param {String} id The id without panel prefix
   * @return {Object}
   */
  getInstance: function getInstance(id) {
    if (id.indexOf('.') > -1) {
      //TEMP FIX AND ALERT
      //TODO: remove this
      console.error('id contains dot!', id);
      id = id.replace('.', '_');
    }
    return YAHOO.fcom.Page.getInstance("".concat(this.id, "_").concat(id));
  },
  /*
   * returns a HTMLElement (elements, inputs etc.) included in the panel
   * @param {String} id without panelNamespace
   * @return HTMLElement
   */
  getElement: function getElement(id) {
    if (id.indexOf('.') > -1) {
      //TEMP FIX AND ALERT
      //TODO: remove this
      console.error('id contains dot!', id);
      id = id.replace('.', '_');
    }
    return YAHOO.util.Dom.get("".concat(this.id, "_").concat(id));
  },
  /*
   * set this panel to dirty, meaning that the content has to be refreshed
   * This allows to have finer controll over refreshing the content than over
   * the refresh configuration property.
   */
  setDirty: function setDirty() {
    this.isDirty = true;
  },
  /*
   * Add an error message to the error message element.
   * The panel must have an element with id "errorMessage".
   * @param {String} message
   * @param {HTMLElement} field
   */
  showErrorMessage: function showErrorMessage(name, message, field) {
    if (this.markedFields == null) {
      this.markedFields = [];
    }
    if (field) {
      this.markedFields.push(field);
      YAHOO.util.Dom.addClass(field, 'error');
      field.title = message || '';
    }
    var msgEl = this.getElement('errorMessage');
    if (msgEl && !window.fcom.util.StringHelper.empty(message)) {
      YAHOO.util.Dom.setStyle(msgEl, 'display', '');
      msgEl.appendChild(this.createMessage("".concat(msgEl.id, "_").concat(name), message));
    }
  },
  /*
   * Creates a error message
   * @private
   * @param {String} id
   * @param {String} message
   * @return {HTMLElement}
   */
  createMessage: function createMessage(id, message) {
    /* @type HTMLElement */
    var el = YAHOO.util.Dom.get(id);
    if (el == null) {
      el = document.createElement('span');
      el.id = id;
    }
    el.innerHTML = "".concat(message, "<br />");
    return el;
  },
  /*
   * Hide all error messages and remove the css error marker from invalid fields.
   * If parameters name and field are passed, only the error message belonging to this field is removed.
   * @param {String} [name] name of the message
   * @param {HTMLElement} [field] the field that was marked as invalid.
   */
  hideErrorMessage: function hideErrorMessage(name, field) {
    var msgEl = this.getElement('errorMessage');
    if (msgEl) {
      if (name != null) {
        var el = YAHOO.util.Dom.get("".concat(msgEl.id, "_").concat(name));
        if (el != null && el.parentNode != null) {
          el.parentNode.removeChild(el);
        }
        if (!msgEl.childNodes.length) {
          YAHOO.util.Dom.setStyle(msgEl, 'display', 'none');
        }
        if (field != null) {
          if (YAHOO.util.Dom.hasClass(field, 'error')) {
            YAHOO.util.Dom.removeClass(field, 'error');
            field.title = '';
          }
          if (this.markedFields) {
            var i = YAHOO.fcom.Util.indexOf(field, this.markedFields);
            if (i > -1) {
              this.markedFields.slice(i, 1);
            }
          }
        }
      } else {
        YAHOO.util.Dom.setStyle(msgEl, 'display', 'none');
        if (this.markedFields) {
          for (var _i = this.markedFields.length; _i--;) {
            var _field = this.markedFields[_i];
            YAHOO.util.Dom.removeClass(_field, 'error');
            _field.title = '';
          }
        }
      }
    }
  }
};
var _default = exports.default = AJAXPanel;
window.YAHOO.fcom.panel.AJAXPanel = AJAXPanel;

},{}],2:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
var _guid = _interopRequireDefault(require("util/guid"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); } /**
                                                                                                                                                                                                                      * @use          : Extended YUI panel class(yui/2.9.0/build/container/container.js)
                                                                                                                                                                                                                      * @description  : Ensure the working of tab loop. Imported in Panels.es6.js.
                                                                                                                                                                                                                      *                 Implement Panel JAWS accessibility(aria attributes)
                                                                                                                                                                                                                      * @dependencies : JQuery, YUI Panel
                                                                                                                                                                                                                      */
var ExtendedPanel = exports.default = /*#__PURE__*/function (_window$YAHOO$widget$) {
  _inherits(ExtendedPanel, _window$YAHOO$widget$);
  var _super = _createSuper(ExtendedPanel);
  function ExtendedPanel(el, userConfig) {
    var _this;
    _classCallCheck(this, ExtendedPanel);
    _this = _super.call(this, el, userConfig);
    // #. To keep the panel visibility state
    _this.panelVisible = false;
    // #. To keep the first element in the panel
    _this.$firstElement = null;
    // #. To keep the last element in the panel
    _this.$lastElement = null;
    // #. To keep the panel opener element
    _this.$panelOpener = null;
    // #. To track the panel opener from active elements
    _this.activeElements = [];
    return _this;
  }

  /**
   * @description: Extend the show method from base class yui panel
   * @method: show
   */
  _createClass(ExtendedPanel, [{
    key: "show",
    value: function show() {
      var _this2 = this;
      // #. Get the latest panel opener element(link/button)
      this.activeElements.push($(document.activeElement));
      this._setPanelAccessibilityAttributes();
      // #. Call the show method from the base class
      _get(_getPrototypeOf(ExtendedPanel.prototype), "show", this).call(this);
      if (this.panelVisible === false) {
        this.$panelOpener = this.activeElements[0];
        this.panelVisible = true;
        window.setTimeout(function () {
          _this2._setTabIndexToFocusableElements();
          _this2._setFocusToFirstElement();
          _this2._bindKeyDown();

          // #. JAWS - accessibility implementation
          _this2._setRoleForTable();
        }, 25);
      }
    }

    /**
     * @description: Extend the hide method from base class yui panel
     * @method: hide
     */
  }, {
    key: "hide",
    value: function hide() {
      // #. Call the hide method from the base class
      _get(_getPrototypeOf(ExtendedPanel.prototype), "hide", this).call(this);
      if (this.panelVisible === true) {
        this.panelVisible = false;
        this.activeElements = [];

        // #. Unbind the event for stop the propagation
        $(this.firstElement).off('keydown');
        $(this.$lastElement).off('keydown');
        $(this.element).attr('data-accessibility', 'disabled').off('keydown');

        // #. Set focus to the panel opener
        this._setFocusToPanelOpener();
      }
    }

    /**
     * @description: Set tabindex to focusable elements in the panel
     * @method: _setTabIndexToFocusableElements
     */
  }, {
    key: "_setTabIndexToFocusableElements",
    value: function _setTabIndexToFocusableElements() {
      // #. Get all the focusable elements
      var $elements = this.getFocusableElements(this.innerElement);
      $elements = $($elements).filter(':visible');

      // #. Set the first focusable element
      this.$firstElement = $elements[0];

      // #. Set the last focusable element
      this.$lastElement = $elements[$elements.length - 1];

      // #. Set the tabindex attribute to all focusable elements
      $($elements).attr('tabindex', 0);

      // #. Handle the select 2 dropdown elements
      this._setTabindexToSelect($elements);
    }

    /**
     * @description: Set focus to focusable elements in the panel
     * @method: _setFocusToFirstElement
     */
  }, {
    key: "_setFocusToFirstElement",
    value: function _setFocusToFirstElement() {
      $(this.$firstElement).focus();
    }

    /**
     * @description: Set focus to the panel opener element(link/button)
     * This method checks the type of the panel opened element
     * If type is body means panel opened via a context menu
     * Otherwise, panel opened from a button/link or any other dom element
     * @method: _setFocusToPanelOpener
     */
  }, {
    key: "_setFocusToPanelOpener",
    value: function _setFocusToPanelOpener() {
      var _this3 = this;
      // #. Check the type of the panel opener
      // #. Menu item or menu label or body will consider panel opener as a context menu
      if (this.$panelOpener.is('.yuimenuitem') || this.$panelOpener.is('.yuimenuitemlabel') || this.$panelOpener.is('body')) {
        // #. Get the context menu opened element(js/fcom/contextMenu/ExtendedMenu.es6.js)
        var $context = window.YAHOO.fcom.Util.deepFind(window.YAHOO, 'fcom.ExtendedMenu.lastContext');
        if ($context) {
          this.$panelOpener = $context || this.$panelOpener;
        }
      }

      // #. No panel opener get - don't do anything
      if (!this.$panelOpener) {
        return;
      }

      // #. Set focus to the last active(panel open button/link) element
      if (!this.$panelOpener.attr('tabindex')) {
        this.$panelOpener.attr('tabindex', 0);
      }

      // #. Set focus to the panel opener after close the dialog
      window.setTimeout(function () {
        _this3.$panelOpener.focus();
      }, 0);
    }

    /**
     * @description: Bind keydown event to main inner element in the panel
     * @method: _bindKeyDown
     */
  }, {
    key: "_bindKeyDown",
    value: function _bindKeyDown() {
      var _this4 = this;
      // #. Bind the keydown event to first element
      $(this.$firstElement).on('keydown', function (event) {
        _this4._keyHandler(event);
      });

      // #. Bind the keydown event to last element
      $(this.$lastElement).on('keydown', function (event) {
        _this4._keyHandler(event);
      });

      // #. Bind the keydown event to element
      $(this.element).on('keydown', function (event) {
        _this4._panelKeyHandler(event);
      }).attr('data-accessibility', 'enabled');
    }

    /**
     * @description: Panel key handler
     * @method:  _panelKeyHandler
     * @param: { event } inner element keydown event object
     */
  }, {
    key: "_panelKeyHandler",
    value: function _panelKeyHandler(event) {
      if (event.keyCode === _keyCodes.default.ESCAPE) {
        this.hide();
      }
      return true;
    }
    /**
     * @description: Handle the keydown event
     * @method:  _keyHandler
     * @param: { event } inner element keydown event object
     */
  }, {
    key: "_keyHandler",
    value: function _keyHandler(event) {
      if (event.keyCode === _keyCodes.default.TAB) {
        this._onTabKeyPressed(event);
      }
      return true;
    }

    /**
     * @description: Handle the tab key press event, make sure the tab loop is working properly
     * Shift + Tab from first element will move the focus to last element
     * Tab - from last element will move the focus to first element
     * @method:  _onTabKeyPressed
     * @param: { event } inner element keydown event object
     */
  }, {
    key: "_onTabKeyPressed",
    value: function _onTabKeyPressed(event) {
      var $activeEl = this._getActiveElement();
      var shiftKey = event.shiftKey;
      if ($activeEl.is(this.$firstElement)) {
        if (shiftKey === true) {
          event.preventDefault();
          $(this.$lastElement).focus();
        }
      } else if ($activeEl.is(this.$lastElement)) {
        if (shiftKey !== true) {
          event.preventDefault();
          this._setFocusToFirstElement();
        }
      }
    }

    /**
     * @description: Get the active element of the panel
     * @method: _getActiveElement
     */
  }, {
    key: "_getActiveElement",
    value: function _getActiveElement() {
      return $(document.activeElement);
    }

    /**
     * @description: Manage the tabindex of select2 dropdown elements
     * @method: _setTabindexToSelect
     * @param: { $elements } Array of focusable elements
     */
  }, {
    key: "_setTabindexToSelect",
    value: function _setTabindexToSelect($elements) {
      // #. Get all select elements
      var $selectEl = $($elements).filter('select');
      if ($selectEl.length > 0) {
        var _iterator = _createForOfIteratorHelper($selectEl),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var $select = _step.value;
            $select = $($select);
            if ($select.data('select2')) {
              // #. Disable tabindex to hidden select 2 element
              $select.attr('tabindex', -1);

              // #. Set tabindex to select2 selection element
              $select.next('.select2').find('.select2-selection').attr('tabindex', 0);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }

    /**
     * @description: Set JAWS accessibility role attribute to panel,
     *               handle different types of panels, form panel, alert, confirm...etc
     * @method: _setPanelAccessibilityAttributes
     */
  }, {
    key: "_setPanelAccessibilityAttributes",
    value: function _setPanelAccessibilityAttributes() {
      var $panel = $(this.element);
      var $title = $panel.find('.hd .title');
      var labelledBy = null;
      var describedBy = null;

      // #. Some panel may not contains title element inside the hd element
      if ($title.length === 0) {
        $title = $panel.find('.hd');
      }

      // #. Get labelled-by attr infor
      // #. Set a new id when element not found the id attribute
      if ($title.length > 0) {
        // #. Get id attribute if title element
        labelledBy = this._getAriaAttributeValue($title);
      }

      // #. Get information panel details(confirm, alert)
      // #. Get described-by attr info
      var $info = $panel.find('.bd .info');
      if ($info.length > 0) {
        // #. Get id attribute if title element
        describedBy = this._getAriaAttributeValue($info);
      }

      // #. Set the attributes
      this._setAriaAttributesToPanel(labelledBy, describedBy);
    }

    /**
     * @description: Get aria-value from the element
     * @method: _getAriaAttributeValue
     * @private
     */
  }, {
    key: "_getAriaAttributeValue",
    value: function _getAriaAttributeValue($element) {
      // #. Get id attribute of the element
      var labelledBy = $element.attr('id');

      // #. Set a new id, if id attr not set yet
      if (!labelledBy) {
        labelledBy = _guid.default.generate();
        $element.attr('id', labelledBy);
      }
      return labelledBy;
    }

    /**
     * @description: Set aria-attributes to the panel element
     * @method: _setAriaAttributesToPanel
     * @private
     */
  }, {
    key: "_setAriaAttributesToPanel",
    value: function _setAriaAttributesToPanel(labelledBy, describedBy) {
      var $panel = $(this.element);

      // #. Set panel to role attributes
      $panel.attr({
        'aria-modal': true
      });

      // #. Set title element id as the aria-describedby attr
      // #. describedBy - only hold value for info type panels
      if (describedBy) {
        $panel.attr({
          role: 'alertdialog',
          'aria-labelledby': labelledBy,
          'aria-describedby': describedBy
        });
      } else {
        $panel.attr({
          role: 'dialog',
          'aria-describedby': labelledBy
        });
      }
    }

    /**
     * @description: Set presentation role attribute to table element
     * @method: _setRoleForTable
     */
  }, {
    key: "_setRoleForTable",
    value: function _setRoleForTable() {
      var $table = $(this.innerElement).find('table');
      if ($table && $table.length > 0 && $table.hasClass('fieldset')) {
        $table.attr('role', 'presentation');
      }
    }
  }]);
  return ExtendedPanel;
}(window.YAHOO.widget.Panel);

},{"util/enums/keyCodes":8,"util/guid":9}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var YAHOO = window.YAHOO;
var Dom = window.Dom;

/*
 * With this class several types of Dialogs can be build.
 * This class abstracts the building of alert, confirm and input dialogs.
 * It provides functions to add fields and buttons to the dialog.
 * @class GenericPanel
 * @namespace YAHOO.fcom.panel
 * @constructor
 * @param {String} id the panel element's id
 * @param {Object} conifg a panel configuration object
 * @param {String} id of the parent panel
 */
var GenericPanel = function GenericPanel(id, config, parent) {
  var defaultConfig = {
    width: '400px',
    visible: false,
    close: false,
    dragOnly: true,
    draggable: true,
    constraintoviewport: true,
    modal: true,
    fixedcenter: true
  };
  if (config && config != null) {
    window.copyMissingAttributes(config, defaultConfig); // TODO: use YAHOO.lang.augmentObject?
  } else {
    config = defaultConfig;
  }

  /*
   * the panel instance
   * @property
   * @type YAHOO.widget.Panel
   */
  this.panel = window.openPanelFromMarkup(id, config, false, parent);
  this.panel.cfg.applyConfig(config);
  this.panel.cfg.fireQueue();
  this.panelEl = YAHOO.util.Dom.get(id);

  /*
   * list of fields managed by this panel
   * an element of the list contains the properties field and fieldConfig
   * @type Array
   */
  this.fields = [];

  /*
   * list of buttons
   * @type Array
   */
  this.buttons = [];

  //remove old errormessage
  YAHOO.util.Dom.getElementsBy(function (node) {
    return YAHOO.util.Dom.hasClass(node, 'errorMessage');
  }, 'div', this.panelEl, function (node) {
    node.parentNode.removeChild(node);
  });
  this.errorMessageEl = null;
  this.reset();
};
GenericPanel.prototype = {
  /*
   * add a button to the button bar
   * @param {String} text for the button
   * @param {Object} onClick handler object consisting of the following properties
   * <ul>
   * <li>{Function} fn required
   * <li>{Array} args optional
   * <li>{Object} scope optional
   * </ul>
   * @return {YAHOO.widget.Button}
   */
  addButton: function addButton(text, buttonConfig) {
    var buttonTag = document.createElement('button');
    buttonTag.setAttribute('type', 'button');
    buttonTag.innerHTML = text;
    this.getButtonSet().appendChild(buttonTag);
    var button = new YAHOO.widget.Button(buttonTag, buttonConfig);
    window.domToYUIMap[Dom.generateId(buttonTag)] = button;
    this.buttons.push(button);
    return button;
  },
  /*
   * add a form field to the body of the Panel
   * @param {Object} fieldConfig containing the following properties
   * <ul>
   * <li>{String} type (required)
   * type of the input field (e.g text)
   * <li>{String} label
   * the label for this field
   * <li>{String} name (required)
   * the name of the field, as it will be returned
   * <li>{String} defaultValue
   * default value for the input field
   * <li>{Array} styles
   * additonal css styles added to the inputfield.
   * <li>number maxlength
   * the maxlength added to the inputfield.
   * The stlyes array should contain name/value pairs like ["width","200px"]
   * </ul>
   */
  addField: function addField(fieldConfig) {
    var tr = document.createElement('tr');
    // label column
    var firstTd = document.createElement('td');
    YAHOO.util.Dom.addClass(firstTd, 'first');
    YAHOO.util.Dom.setStyle(firstTd, 'vertical-align', 'top');
    tr.appendChild(firstTd);
    var label = document.createElement('label');
    if (fieldConfig.id === undefined) {
      label.setAttribute('for', fieldConfig.name);
    } else {
      label.setAttribute('for', fieldConfig.id);
    }
    label.innerHTML = fieldConfig.label;
    firstTd.appendChild(label);
    // field column
    var secondTd = document.createElement('td');
    var field = document.createElement('input');
    if (fieldConfig.defaultValue == null) {
      fieldConfig.defaultValue = '';
    }
    if (!fieldConfig.placeholder) {
      fieldConfig.placeholder = '';
    }
    field.setAttribute('value', fieldConfig.defaultValue);
    field.setAttribute('name', fieldConfig.name);
    field.setAttribute('type', fieldConfig.type);
    field.setAttribute('maxlength', fieldConfig.maxlength);
    field.setAttribute('placeholder', fieldConfig.placeholder);
    if (fieldConfig.id === undefined) {
      field.setAttribute('id', fieldConfig.name);
    } else {
      field.setAttribute('id', fieldConfig.id);
    }
    if (YAHOO.lang.isArray(fieldConfig.styles)) {
      for (var i = 0; i < fieldConfig.styles.length; i++) {
        var pair = fieldConfig.styles[i];
        YAHOO.util.Dom.setStyle(field, pair[0], pair[1]);
      }
    }
    if (fieldConfig.type === 'text') {
      YAHOO.util.Dom.addClass(field, 'textfield');
    }
    YAHOO.util.Dom.generateId(field);
    secondTd.appendChild(field);
    if (fieldConfig.hint) {
      var hintElWrap = document.createElement('div');
      var hintEl = document.createElement('small');
      hintEl.innerHTML = fieldConfig.hint;
      hintElWrap.appendChild(hintEl);
      secondTd.appendChild(hintElWrap);
    }
    tr.appendChild(secondTd);
    this.getFieldTable().appendChild(tr);
    this.fields.push({
      field: field,
      config: fieldConfig
    });
  },
  /*
   * get a input field by its name
   * @param fieldName {String}
   */
  getInputField: function getInputField(fieldName) {
    return this.fields.find(function (field) {
      return field.config.name === fieldName;
    });
  },
  show: function show() {
    this.panel.render();
    this.panel.show();

    //select first field
    if (this.fields.length > 0) {
      /* @type HTMLInputElement */
      var field = this.fields[0].field;
      field.focus();
      field.select();
    } else if (this.buttons.length > 0) {
      var btn = this.buttons[0];
      //do not focus the button right away in case dialog was opened with enter
      YAHOO.lang.later(50, btn, function () {
        this.focus();
      });
    }
  },
  reset: function reset() {
    this.panel.setBody('');
    this.fieldTable = null;
    this.messageEl = null;
    this.panel.setFooter('');
    this.buttonSet = null;
    this.fields = [];
    this.buttons = [];
  },
  /*
   *
   * @return {HTMLElement}
   */
  getButtonSet: function getButtonSet() {
    if (this.buttonSet == null) {
      var buttonBar = document.createElement('div');
      buttonBar.className = 'buttonBar';
      this.buttonSet = document.createElement('div');
      this.buttonSet.className = 'fieldset reversed';
      buttonBar.appendChild(this.buttonSet);
      this.panel.appendToFooter(buttonBar);
    }
    return this.buttonSet;
  },
  /*
   * @private
   * @return {HTMLElement}
   */
  getFieldTable: function getFieldTable() {
    if (this.fieldTable == null) {
      var table = document.createElement('table');
      table.setAttribute('border', '0');
      table.setAttribute('cellpadding', '0');
      table.setAttribute('cellspacing', '0');
      table.setAttribute('width', '100%');
      YAHOO.util.Dom.addClass(table, 'fieldset');
      this.fieldTable = document.createElement('tbody');
      table.appendChild(this.fieldTable);
      this.panel.appendToBody(table);
    }
    return this.fieldTable;
  },
  /*
   * show a error message
   * @param {String} errorMessage
   * @param {HTMLElement} field
   */
  showError: function showError(message, field) {
    this.errorFieldId = null;
    if (field != null) {
      this.errorFieldId = field.id;
    }
    window.errorMessage(this.errorFieldId, this.getErrorMessageEl(), message);
  },
  /*
   * hide the last error message
   */
  hideError: function hideError() {
    window.hideErrorMessage(this.errorFieldId, this.getErrorMessageEl());
    this.errorFieldId = null;
  },
  /*
   * set the dialog's message
   * @param {String} message
   */
  setMessage: function setMessage(message) {
    this.getMessageEl().innerHTML = message;
  },
  /*
   *
   * @return {HTMLElement}
   * @private
   */
  getMessageEl: function getMessageEl() {
    if (this.messageEl == null) {
      this.messageEl = document.createElement('div');
      YAHOO.util.Dom.addClass(this.messageEl, 'info');
      this.panel.appendToBody(this.messageEl);
    }
    return this.messageEl;
  },
  /*
   * @return {HTMLElement}
   * @private
   */
  getErrorMessageEl: function getErrorMessageEl() {
    if (this.errorMessageEl == null) {
      this.errorMessageEl = document.createElement('div');
      this.errorMessageEl.setAttribute("role", "alert");
      this.errorMessageEl.setAttribute("aria-atomic", "true");
      Dom.addClass(this.errorMessageEl, 'errorMessage');
      Dom.setStyle(this.errorMessageEl, 'display', 'none');
      if (this.panel.body != null) {
        this.panelEl.insertBefore(this.errorMessageEl, this.panel.body);
      }
    }
    return this.errorMessageEl;
  },
  /*
   * Validates all fields by executing their vaildation functions.
   * This function will return false for the first invalid field it can find.
   * @return {Boolean}
   */
  validateFields: function validateFields() {
    for (var i = 0; i < this.fields.length; i++) {
      var field = this.fields[i];
      if (field.config.validateFn != null) {
        var error = field.config.validateFn(field.field);
        if (error != null) {
          this.showError(error, field.field);
          return false;
        }
      }
    }
    return true;
  },
  /*
   * returns a map of values for all fields
   * access the map with the field's name.
   * @return {Object}
   */
  getFieldValues: function getFieldValues() {
    var values = {};
    for (var i = 0; i < this.fields.length; i++) {
      var field = this.fields[i].field;
      values[field.name] = field.value;
    }
    return values;
  },
  /*
   * hide the panel
   */
  hide: function hide() {
    this.panel.hide();
  }
};
var _default = exports.default = GenericPanel;

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _GenericPanel = _interopRequireDefault(require("panel/GenericPanel"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var YAHOO = window.YAHOO;
window.ngpNamespace('YAHOO.fcom.panel');

/*
 * The panel factory is used to create panels that are created from existing markup
 * or markup loaded by AJAX. Panels should always be created by the panel factory
 * as they include a lot of application specific fixes and additional features,
 * like automatic display of waiting masks, grouping etc.
 * @namespace YAHOO.fcom.panel
 * @class YAHOO.fcom.panel.PanelFactory
 *
 */
var PanelFactory = {
  /*
   * @private
   * @type Array
   */
  panels: {},
  /*
   * A map containing lists of listeners identified by the panelId
   * @private
   * @type Object
   */
  panelListeners: {},
  /*
   * A list of panel scripts that were loaded with the panel factory.
   * @private
   * @type Array
   */
  loadedScripts: [],
  /*
   * Returns a panel instance created by this panel factory
   * @param {Stssring} panelId
   * @return {YAHOO.fcom.panel.NGPPabel}
   */
  getPanel: function getPanel(panelId) {
    return this.panels[panelId];
  },
  /*
   * Open an input style dialog, that can contain dynamic input fields.
   * To configure the fields of this dialog, a field array must be supplied in the config parameter.
   * The field array must contain <b>field configuration objects</b> with the following properties:
   * <ul>
   * <li>{String} type (required)
   * type of the input field (e.g text)
   * <li>{String} label
   * the label for this field
   * <li>{String} name (required)
   * the name of the field, as it will be returned
   * <li>{String} defaultValue
   * default value for the input field
   * <li>{Array} styles
   * additonal css styles added to the inputfield.
   * The stlyes array should contain name/value pairs like ["width","200px"],
   * <li>{Function} validateFn
   * a validation function with the field input as only argument. The validation is failed
   * when the functions returns an error message. The validation was successful, if null is returned.
   * </ul>
   *
   * The dialog's title and message can also be customized.
   * This dialog has two buttons: save and cancel. The click events for both buttons are handled by
   * the functions saveHandler and cancelHandler of the config parameter.
   *
   *
   * @param {Object} config object with the following properties
   * <ul>
   * <li>{String} title
   * <li>{String} message
   * <li>{Array} fields
   * <li>{Function} saveHandler
   * <li>{String} saveButtonLabel
   * <li>{Function} cancelHandler
   * </ul>
   * @param {Object} panelConfig configuration object used for YAHOO.widget.Panel
   * @param {String} id of the parent panel
   */
  openInputPanel: function openInputPanel(config, panelConfig, parent) {
    var id = 'genericInputPanelDiv';
    /*
     * @type GenericPanel
     */
    var inputPanel = new _GenericPanel.default(id, panelConfig, parent);
    if (YAHOO.lang.isString(config.title)) {
      inputPanel.panel.setHeader(config.title);
    }
    if (YAHOO.lang.isString(config.message)) {
      inputPanel.setMessage(config.message);
    }
    if (config.saveHandler == null) {
      config.saveHandler = function (inputPanel) {
        inputPanel.panel.hide();
      };
    }
    var saveButtonLabel = config.saveButtonLabel || window.getMessage('txt.button.save');
    inputPanel.addButton(window.getMessage('txt.forms.confirm.cancelButtonText'), {
      type: 'push',
      onclick: {
        fn: function fn() {
          this.panel.hide();
        },
        obj: {},
        scope: inputPanel
      }
    });
    inputPanel.addButton(saveButtonLabel, {
      type: 'push',
      onclick: {
        fn: function fn(event, inputPanel) {
          inputPanel.hideError();
          if (inputPanel.validateFields()) {
            //fields successfully validated?
            config.saveHandler.call(null, inputPanel);
          }
        },
        obj: inputPanel
      }
    });
    if (config.fields == null) {
      config.fields = [];
    }
    for (var i = 0; i < config.fields.length; i++) {
      inputPanel.addField(config.fields[i]);
    }
    inputPanel.show();
    return inputPanel;
  },
  /*
   * Shorthand for this function: window.ngpConfirm(message, config)
   *
   * Opens a generic panel to display a confirmation dialog with a custom message.
   *
   * @param {Object} config object including configuration properties for the yui panel and the following properties:
   * <ul>
   *     <li>{String} title
   *     <li>{String} message
   *     <li>{String} okButtonText
   *  <li>{String} cancelButtonText
   *  <li>{Function} okHandler
   *  <li>{Function} cancelHandler
   *  <li>{Object} handlerArgument
   *      single argument being passed to the button handler functions
   * </ul>
   * @param {String} parent id of the parent panel
   */
  openConfirmPanel: function openConfirmPanel(config, parent) {
    var id = 'genericConfirmPanelDiv';
    var defaultConfig = {
      title: window.getMessage('txt.forms.confirm.title'),
      message: window.getMessage('txt.forms.confirm.message'),
      okButtonText: window.getMessage('txt.forms.alert.okButtonText'),
      cancelButtonText: window.getMessage('txt.forms.confirm.cancelButtonText')
    };
    YAHOO.lang.augmentObject(config, defaultConfig);

    /*
     * @type GenericPanel
     */
    var confirmPanel = new _GenericPanel.default(id, config, parent);
    confirmPanel.panel.setHeader(config.title);
    confirmPanel.setMessage(config.message);
    var buttonHandler = function buttonHandler(event, callback) {
      if (callback) {
        callback(config.handlerArgument);
      }
      confirmPanel.hide();
    };
    confirmPanel.addButton(config.cancelButtonText, {
      type: 'push',
      onclick: {
        fn: buttonHandler,
        obj: config.cancelHandler
      }
    });
    confirmPanel.addButton(config.okButtonText, {
      type: 'push',
      onclick: {
        fn: buttonHandler,
        obj: config.okHandler
      }
    });
    confirmPanel.show();
  },
  /*
   * Shorthand for this function: window.ngpAlert(message, config)
   *
   * @param {String} message
   * @param {Object} config panelConfiguration Object plus following properties:
   *<ul>
   *    <li>{String} title
   *    <li>{Function} onHide
   *        function is called when panel is hidden
   *    <li>{Object} handlerArgument
   *      single argument being passed to the onHide callback
   */
  openAlertPanel: function openAlertPanel(message, config, parent) {
    config = config || {};
    var id = 'genericAlertPanelDiv';
    var defaultConfig = {
      title: window.getMessage('txt.forms.alert.title'),
      close: true
    };
    YAHOO.lang.augmentObject(config, defaultConfig);
    /* @type GenericPanel */
    var alertPanel = new _GenericPanel.default(id, config, parent);
    alertPanel.panel.setHeader(config.title);
    alertPanel.setMessage(message);
    alertPanel.addButton(window.getMessage('txt.forms.alert.okButtonText'), {
      type: 'push',
      onclick: {
        fn: function fn() {
          this.hide();
        },
        scope: alertPanel
      }
    });
    var hideHandler = function hideHandler(event, args, handler) {
      if (config.onHide != null) {
        config.onHide(config.handlerArgument);
      }
      //execute handler only once
      alertPanel.panel.hideEvent.unsubscribe(handler);
    };
    alertPanel.panel.hideEvent.subscribe(hideHandler, hideHandler);
    alertPanel.show();
  },
  /*
   * Return a  function that acts as a delegate to do the actual callback.
   * This is neccessary to provide a reference to callback functions even if the
   * panel instance is not yet ready. This kind of function is usually used by markup,
   * that is not aware of the panel or it can be used by other panels.
   * @param {String} panelId
   * @param {String} functionName
   */
  createCallback: function createCallback(panelId, functionName) {
    var thisRef = this;
    return function () {
      var panel = thisRef.getPanel(panelId);
      if (panel != null) {
        panel[functionName].apply(panel, arguments);
      }
    };
  },
  /*
   * Execute a handler or callback function that is defined inside a panel.
   * Using this function is a safe way to call functions of a panel without knowing if the panel
   * was already initialized or not. If the panel was not initialized, the callback will have no effect and
   * throw no exception. This kind of function is usually used by markup,
   * that is not aware of the panel or it can be used by other panels.
   * @param {String} panelId
   * @param {String} functionName
   * @param {Array} args
   */
  doCallback: function doCallback(panelId, functionName, args) {
    if (args == null) {
      args = [];
    }
    this.createCallback(panelId, functionName).apply(this, args);
  },
  /*
   * Add a panel ready listener that will be notified once the AJAX panel was created.
   * This can be used for example from jsps that contain the panelmarkup and additional configuration
   * settings that have to be created dynamcically on the server. Or it can be used if panels depend on
   * eachother but dont know their instances.
   *
   * The handler function will be called with the panel instance as first argument. If override is true
   * obj will be the execution context for the handler, otherwise it will be passed as second argument.
   * @param {String} panelId
   * @param {Function} handler
   * @param {Object} obj
   * @param {Boolean} override
   */
  onPanelReady: function onPanelReady(panelId, handler, obj, override) {
    if (this.panelListeners[panelId] == null) {
      this.panelListeners[panelId] = [];
    }
    this.panelListeners[panelId].push({
      handler: handler,
      obj: obj,
      override: override
    });
  },
  /*
   * @private
   * @param {String} panelId
   * @param {String} panelInstance
   */
  firePanelReady: function firePanelReady(panelId, panelInstance) {
    if (this.panelListeners[panelId] && YAHOO.lang.isArray(this.panelListeners[panelId])) {
      for (var i = 0; i < this.panelListeners[panelId].length; i++) {
        var listener = this.panelListeners[panelId][i];
        if (listener.override) {
          listener.handler.call(listener.obj, panelInstance);
        } else {
          listener.handler.call(listener.obj, panelInstance);
        }
      }
      this.panelListeners[panelId] = [];
      this.makeCSRFSafe(panelId);
    }
  },
  /*
   * Add secure token to the panel form which will keep
   * post actions of the form safe from cross site script forgery.
   * The secure token is added as a hidden field to the form which will be submitted with every form submission.
   * @param {String} panelId
   */
  makeCSRFSafe: function makeCSRFSafe(panelId) {
    var panelForm = $('#' + panelId).find('form');
    var csrfTokenElName = YAHOO.fcom.Security.CSRFTokenElName;
    var csrfToken = YAHOO.fcom.Security.CSRFToken;
    if (panelForm.length > 0) {
      var csrfTokenEl = $(panelForm).children('input:hidden[name=' + csrfTokenElName + ']');
      if (csrfTokenEl.length > 0) {
        $(csrfTokenEl).val(csrfToken);
      } else {
        var _csrfTokenEl = $('<input/>', {
          type: 'hidden',
          name: csrfTokenElName,
          value: csrfToken
        });
        $(_csrfTokenEl).appendTo(panelForm);
      }
    }
  },
  /*
   * Show an ajax panel. Is the panel not loaded yet, it will be loaded on demand.
   * An ajax panel usually has a disributed script file and its own panel markup that will
   * be loaded on demand from the server. The paths to this reseources are defined in the panelConfig
   * Parameter.
   * Sometimes the contents of a panel must be refreshed. The panelConfig parameter "refresh"
   * will trigger a content refresh for the panel's parts header, body and footer, every time the panel
   * is opened over the factory. Another way to refresh a panel is to call the setDirty method.
   * This allows for finer control when a panel has to be refresh or not.
   * There are predefined Panel Configurations available for panels that are used over the whole
   * project. If available it is recommended to use those predefined configurations. If a parameter has to be
   * changed, please dont change the static configurations, but rather create your own config object and augment
   * it with a predefined config.
   *
   * @param {Object} a YAHOO.widget.Panel configuration object with additional properties
   * <ul>
   * <li> {String} id
   *         the panels unqique id, that also matches the panel namespace for the markup.</li>
   * <li> {Array} requiredScripts
   *         a list of JS files that will be included on demand. JS files for panels are usually located under js/fcom/panels</li>
   * <li> {String} panelNamespace
   *        the complete name of the constructor function including the namespace</li>
   * <li> {String} url
   *         endpoint to request the panel's markup</li>
   * <li> {Boolean} refresh @optional
   *         optional flag to indicate that a content refresh is neccessary</li>
   * </ul>
   *
   * @param {Object} callback after panel has been created. callback has the following properties:
   * <ul>
   * <li>{Function} fn called with the panel instance as parameter
   * <li>{Object} scope
   * <ul>
   *
   * @param {Object|String} postData additional post data send to the panel endpoint
   */
  getAJAXPanel: function getAJAXPanel(panelConfig, callback, postData) {
    var ajaxPanel = this.getPanel(panelConfig.id);
    if (ajaxPanel) {
      if (panelConfig.refresh === true || ajaxPanel.isDirty === true) {
        this.refreshPanel(panelConfig, callback, postData);
      } else if (postData != null) {
        this.loadPanelData(panelConfig, callback, postData);
      } else {
        callback.fn.call(callback.scope, ajaxPanel);
      }
    } else {
      //load sources
      this.loadRequiredScripts(panelConfig, callback, postData);
    }
  },
  /*
   * Request panel url for panel data
   * @param {} panelConfig
   * @param {} callback
   * @param {} postData
   */
  loadPanelData: function loadPanelData(panelConfig, callback, postData) {
    window.ngpAsyncRequest('POST', this.getPanelUrl(panelConfig, true, false), {
      success: function success(response) {
        YAHOO.fcom.Page.insert(document.body, response.responseText);
        var id = response.argument.panelConfig.id;
        var panel = this.getPanel(id);
        var callback = response.argument.callback;
        this.firePanelReady(id, panel);
        callback.fn.call(callback.scope, panel);
      },
      scope: this,
      argument: {
        callback: callback,
        panelConfig: panelConfig
      }
    }, this.mergePostData(panelConfig, postData));
  },
  /*
   * Build the panel url, with all necessary parameters.
   * The panel url is called to refresh a resource, which is either
   * the panel markup or the panel data. Which of the resources is needed
   * can be specified by the paramaters <tt>panelData</tt> and <tt>panelHtml</tt>.
   *
   * @private
   * @param {} panelConfig
   * @param {Boolean} panelData
   * @param {Boolean} panelHtml
   */
  getPanelUrl: function getPanelUrl(panelConfig, panelData, panelHtml) {
    var url = "/".concat(panelConfig.url);
    url = YAHOO.fcom.Util.addURLParam(url, 'id', panelConfig.id);
    if (panelData) {
      url = YAHOO.fcom.Util.addURLParam(url, 'panelData', 'true');
    }
    if (panelHtml) {
      url = YAHOO.fcom.Util.addURLParam(url, 'panelHtml', 'true');
    }
    return url;
  },
  /*
   * Loads all required scripts for this panel on demand
   * @private
   */
  loadRequiredScripts: function loadRequiredScripts(panelConfig, callback, postData) {
    if (panelConfig.requiredScripts != null) {
      var requiredScripts = [];
      for (var i = 0; i < panelConfig.requiredScripts.length; i++) {
        //add path
        if (YAHOO.fcom.Util.indexOf(panelConfig.requiredScripts[i], this.loadedScripts) === -1) {
          //only load scripts that were not previously loaded before
          requiredScripts.push("".concat(window.ctx).concat(window.jsFolder, "/fcom/panels/").concat(panelConfig.requiredScripts[i]));
        }
      }
      if (requiredScripts.length > 0) {
        YAHOO.util.Get.script(requiredScripts, {
          onSuccess: this.scriptLoaded,
          onFailure: function onFailure() {
            window.ngpAlert(window.getMessage('DEFAULT_AJAX_ERROR')); // TODO: better error handling
          },

          scope: this,
          data: {
            config: panelConfig,
            callback: callback,
            postData: postData
          }
        });
      } else {
        this.scriptLoaded({
          data: {
            config: panelConfig,
            callback: callback,
            postData: postData
          }
        });
      }
    }
  },
  /*
   * callback after all scripts are loaded
   * @param {Object} obj
   * @private
   */
  scriptLoaded: function scriptLoaded(obj) {
    var panelConfig = obj.data.config;

    //in IE this callback can be called several times, so we must stop if the panel was already loaded
    if (this.getPanel(panelConfig.id)) {
      return; //if there is already a panel instance, scripts must be loaded
    }

    for (var len = panelConfig.requiredScripts.length; len--;) {
      if (YAHOO.fcom.Util.indexOf(this.loadedScripts, panelConfig.requiredScripts[len]) === -1) {
        this.loadedScripts.push(panelConfig.requiredScripts[len]);
      }
    }
    //create a panel
    var url = this.getPanelUrl(panelConfig, obj.data.postData != null || panelConfig.refresh, true);
    window.fillPanelFromAjax(panelConfig.id, url, this.mergePostData(panelConfig, obj.data.postData), panelConfig, {
      instanceHandler: this.createPanel,
      scope: this,
      customObject: obj.data,
      show: false
    });
  },
  /*
   * callback once the actual panel was created
   * @param {YAHOO.widget.Panel} panel
   * @param {Object} customObject
   * @private
   */
  createPanel: function createPanel(panel, customObject) {
    var panelConfig = customObject.config;
    var constr = this.getConstructorByNamespace(panelConfig.panelNamespace);
    YAHOO.fcom.Page.onReady(function () {
      var ajaxPanel = new constr(panel, panelConfig);
      this.panels[panelConfig.id] = ajaxPanel;
      //callback that was passed on by createAJAXPanel
      this.firePanelReady(panelConfig.id, ajaxPanel);
      var callback = customObject.callback;
      if (callback != null) {
        callback.fn.call(callback.scope, ajaxPanel);
      }
    }, this, true);
  },
  /*
   * Refresh the panel's markup.
   *
   * @private
   * @param {} panelConfig
   */
  refreshPanel: function refreshPanel(panelConfig, callback, postData) {
    var ajaxPanel = this.getPanel(panelConfig.id);
    if (panelConfig.refresh === true || ajaxPanel.isDirty === true) {
      ajaxPanel.config = panelConfig;
      var url = this.getPanelUrl(panelConfig, postData != null || panelConfig.refresh, true);
      window.replacePanelContent(ajaxPanel.panel, url, {
        scope: this,
        success: this.contentReplaced,
        failure: function failure() {
          window.ngpAlert(window.getMessage('DEFAULT_AJAX_ERROR'));
        },
        args: [panelConfig, callback],
        form: panelConfig.form,
        postData: this.mergePostData(panelConfig, postData)
      });
    }
  },
  /*
   * returns the panel's constructor
   * @param {String} panelNamespace
   * @returns {Function} constructor
   * @private
   */
  getConstructorByNamespace: function getConstructorByNamespace(panelNamespace) {
    var tokens = panelNamespace.split('.');
    var constr = window;
    for (var i = 0; i < tokens.length; i++) {
      constr = constr[tokens[i]];
    }
    return constr;
  },
  /*
   * executes callback after panel content has been refreshed
   * @private
   * @param {Object} panelConfig
   * @param {Object} callback
   */
  contentReplaced: function contentReplaced(panelConfig, callback) {
    var panel = this.getPanel(panelConfig.id);
    panel.isDirty = false;
    YAHOO.fcom.Page.onReady(function () {
      panel.init();
      this.firePanelReady(panelConfig.id, panel);
      callback.fn.call(callback.scope, panel);
    }, this, true);
  },
  /*
   * Merge static postData from panelConfig with dynamic post data.
   * @private
   * @param {} panelConfig
   * @param {Object|String} postData
   */
  mergePostData: function mergePostData(panelConfig, postData) {
    var old = YAHOO.fcom.Util.createPostData(panelConfig.postData);
    return YAHOO.fcom.Util.createPostData(postData, old);
  }
};
var _default = exports.default = PanelFactory;

},{"panel/GenericPanel":3}],5:[function(require,module,exports){
"use strict";

var _PanelFactory = _interopRequireDefault(require("panel/PanelFactory"));
require("panel/AjaxPanel");
require("panel/ResetableAjaxPanel");
require("panel/panelConfig");
var _ExtendedPanel = _interopRequireDefault(require("panel/ExtendedPanel"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
window.YAHOO.widget.Panel = _ExtendedPanel.default;
window.YAHOO.fcom.panel.PanelFactory = _PanelFactory.default;

},{"panel/AjaxPanel":1,"panel/ExtendedPanel":2,"panel/PanelFactory":4,"panel/ResetableAjaxPanel":6,"panel/panelConfig":7}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _AjaxPanel = _interopRequireDefault(require("panel/AjaxPanel"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var YAHOO = window.YAHOO;

/*
 * Abstract baseclass for panels that are loaded from AJAX and
 * contain reset buttons for various fields and menus.
 * To make use of the dynamic data generated by a jsp, simply register for
 * the onPanelReady event and call the method <code>setDynamicDataForForm</code>.
 * This will implicitly call the method <code>initDynamicData</code> which has
 * to be implemented in every subclass. The reason for the implicit call is
 * to ensure that the property of the dynamicData always has the same name in the
 * subclasses.
 * @param {Object} panel
 * @param {Object} config
 */
var ResetableAJAXPanel = function ResetableAJAXPanel(panel, config) {
  YAHOO.fcom.panel.ResetableAJAXPanel.superclass.constructor.call(this, panel, config);
};
YAHOO.extend(ResetableAJAXPanel, _AjaxPanel.default, {
  /*
   * inititalize the resetting buttons (images) when the dialog is opened.
   *
   */
  setResettingImages: function setResettingImages() {
    // run through all the hidden helements
    for (var i = 0; i < this.resetableForm.elements.length; i++) {
      var element = this.resetableForm.elements[i];
      var name = element.name;
      if (element.type === 'hidden' && name.indexOf('_Modified') > -1) {
        // get corresponding reset image
        var imgName = "".concat(name, "Img");
        var field = name.substring(0, name.indexOf('_Modified'));
        if (field && this.resetableForm[field] != null && this.resetableForm[field].disabled) {
          window.setElementDisabled("".concat(this.id, "_").concat(imgName), true);
        } else if (this.resetableForm.elements[i].value === 'true') {
          window.setElementDisabled("".concat(this.id, "_").concat(imgName), false);
        } else {
          window.setElementDisabled("".concat(this.id, "_").concat(imgName), true);
        }
      }
    }
  },
  /*
   * Toggle the reset button/image. If the user changed any values,
   * the resetting buttons will be activated. If the reset button was clicked
   * it has to be deactivated. The default value is restored by the actual click handler.
   * @param {String} name
   * @param {Boolean} inactivate
   */
  toggleReset: function toggleReset(name, inactivate) {
    var imgName = "".concat(name, "_ModifiedImg");
    var hiddenName = "".concat(name, "_Modified");
    if (this.resetableForm.elements[hiddenName] != null) {
      this.resetableForm.elements[hiddenName].value = !inactivate;
      window.setElementDisabled("".concat(this.id, "_").concat(imgName), inactivate);
    }
  },
  /*
   * Click handler for reset buttons that control checkboxes
   * @param {String} name
   */
  resetCheckBox: function resetCheckBox(name) {
    this.resetableForm.elements[name].checked = this.dynamicData["".concat(name, "_Reset")];
    YAHOO.fcom.Event.fireEvent(this.resetableForm.elements[name], 'change');
    this.toggleReset(name, true);
  },
  /*
   * Click handler for reset buttons that control radio button (groups)
   * @param {String} name
   */
  resetRadio: function resetRadio(name) {
    YAHOO.fcom.Forms.setCheckedRadioValue(this.resetableForm.elements[name], this.dynamicData["".concat(name, "_Reset")]);
    this.toggleReset(name, true);
  },
  /*
   * Click handler for reset buttons that control text boxes
   * @param {String} name
   */
  resetTextBox: function resetTextBox(name) {
    this.resetableForm.elements[name].value = this.dynamicData["".concat(name, "_Reset")];
    this.toggleReset(name, true);
  },
  /*
   * Click handler for reset buttons that control drop downs
   * @param {String} name
   */
  resetDropDown: function resetDropDown(name) {
    /* @type YAHOO.fcom.DropMenu */
    var selectvar = YAHOO.fcom.Forms.getHandlerForElement(name);
    var selectedItems = this.dynamicData["".concat(name, "_Reset")];
    if (window.ngpIsType('Array', selectedItems)) {
      selectvar.deselectAll(true);
      selectvar.selectByValues(selectedItems);
    } else {
      selectvar.selectByValue(selectedItems);
    }
    this.toggleReset(name, true);
  },
  /*
   * function to update selection in multiple menus according to the corresponding resetting array values
   * @param {String} varName key to identify the list of menu items in the dynamic config object
   */
  updateMenu: function updateMenu(varName) {
    var menu = this["".concat(varName, "Menu")];
    var items = menu.getItems();
    for (var i = 0; i < items.length; i++) {
      var val = items[i].value;
      // is the value in the reset array ? If yes, checked else no
      var resetValues = this.dynamicData["".concat(varName, "_Reset")];
      var isCheckedInReset = false;
      // if the reset array is empty, set to false !
      if (!resetValues.length) {
        items[i].cfg.setProperty('checked', false);
      }
      for (var k = 0; k < resetValues.length; k++) {
        // the entry is checked in reset
        if (resetValues[k] === val) {
          isCheckedInReset = true;
        }
      }
      // if checked in Reset, check if not checked
      if (isCheckedInReset) {
        if (!items[i].cfg.getProperty('checked')) {
          items[i].cfg.setProperty('checked', true);
        }
      }
      // if notchecked in Reset, uncheck if checked
      if (!isCheckedInReset) {
        if (items[i].cfg.getProperty('checked')) {
          items[i].cfg.setProperty('checked', false);
        }
      }
    }
    this.toggleReset(varName, true);
  }
});
var _default = exports.default = ResetableAJAXPanel;
window.YAHOO.fcom.panel.ResetableAJAXPanel = ResetableAJAXPanel;

},{"panel/AjaxPanel":1}],7:[function(require,module,exports){
"use strict";

var YAHOO = window.YAHOO;
var Dom = window.Dom;
var xPos = Math.max(5, Dom.getViewportWidth() / 2 - 236);
var yPos = 50;

/*
 * This JavaScript file defines all globally available Panels that are loaded by AJAX.
 * If an AJAX-Panel should be available throughout the application, for example by the context menu,
 * then its configuration should be defined here.
 *
 * The configuration objects are considered to be constants and should not be changed.
 * If you need a configuration based on another, use YAHOO.lang.augmentObject to achieve this.
 *
 * To add a new panel, create a new object in the YAHOO.fcom.panel.AJAXPanel namespace.
 * Required properties are
 * <ul>
 * <li> id {String} unique id for the panel. The panel elements should start with this id.
 * <li> requiredScripts {Array} list of javascripts that are needed by this panel and are dynamically included.
 *         The scripts are loaded relative to the js/fcom/panels folder.
 * <li> url {String} the panel's markup will be requested from this url.
 * </ul>
 * For further configuration properties see <code>YAHOO.fcom.PanelFactory.getAJAXPanel</code>
 * All configuration properties of YAHOO.widget.Panel are also supported.
 *
 * To open an AJAX-Panel always use the function <code>YAHOO.fcom.PanelFactory.getAJAXPanel</code>
 * and pass the configuration object for your panel. A callback object can be passed to the function
 * and will be called once the panel is created. The callback function will receice the panel as argument.
 * Call panel.show() to show the panel.
 *
 */

/*
 * Predefined AJAXPanel configuration for creating alerts
 *
 * @type Object
 *
 */
YAHOO.fcom.panel.AJAXPanel.ADD_ALERT_PANEL = {
  id: 'addAlertPanel',
  requiredScripts: ['alertPanel.js'],
  panelNamespace: 'YAHOO.fcom.panel.AlertPanel',
  url: 'alert.panel?method=showAlert',
  width: '350px',
  fixedcenter: true,
  visible: false,
  close: true,
  dragOnly: true,
  constraintoviewport: true,
  modal: true
};

/*
 * Configuration for alert panels with fixed instrument.
 *
 * @type
 */
YAHOO.fcom.panel.AJAXPanel.ADD_ALERT_FIXED_PANEL = {
  id: 'addAlertFixedPanel'
};
YAHOO.lang.augmentObject(YAHOO.fcom.panel.AJAXPanel.ADD_ALERT_FIXED_PANEL, YAHOO.fcom.panel.AJAXPanel.ADD_ALERT_PANEL);

/*
 * Predefined AJAXPanel configuration for editing alerts
 *
 * @type Object
 *
 */
YAHOO.fcom.panel.AJAXPanel.EDIT_ALERT_PANEL = {
  id: 'editAlertPanel'
};
YAHOO.lang.augmentObject(YAHOO.fcom.panel.AJAXPanel.EDIT_ALERT_PANEL, YAHOO.fcom.panel.AJAXPanel.ADD_ALERT_PANEL);
YAHOO.fcom.panel.AJAXPanel.EDIT_RSS_FEED = {
  id: 'editRssFeedPanel',
  requiredScripts: ['editRssFeedPanel.js'],
  panelNamespace: 'YAHOO.fcom.panel.EditRssFeedPanel',
  url: 'common/editRssFeedPanel.panel',
  width: '440px',
  fixedcenter: true,
  visible: false,
  close: true,
  dragOnly: true,
  constraintoviewport: true,
  modal: true
};

/*
 * Predefined AJAXPanel configuration for adding instruments to an existing or new watchlist
 *
 * @type Object
 *
 */
YAHOO.fcom.panel.AJAXPanel.ADD_TO_WATCHLIST = {
  id: 'addToWatchlistPanel',
  requiredScripts: ['addToWatchlistPanel.js'],
  panelNamespace: 'YAHOO.fcom.panel.AddToWatchlistPanel',
  url: 'portfolios/watchlists/addToWatchlistPanel.panel',
  width: '280px',
  fixedcenter: true,
  visible: false,
  close: true,
  dragOnly: true,
  constraintoviewport: true,
  modal: true
};

/*
 * Predefined AJAXPanel configuration for editing sharing authorizations
 *
 * @type Object
 *
 */
YAHOO.fcom.panel.AJAXPanel.EDIT_SHARING = {
  id: 'editSharingPanel',
  requiredScripts: ['editSharingPanel.js'],
  panelNamespace: 'YAHOO.fcom.panel.EditSharingPanel',
  url: 'portfolios/watchlists/editSharingPanel.panel',
  width: '630px',
  fixedcenter: true,
  visible: false,
  close: true,
  dragOnly: true,
  constraintoviewport: true,
  modal: true,
  refresh: true
};

/*
 * Predefined AJAXPanel configuration for editing user/organisation or profile
 *
 * @type Object
 *
 */
YAHOO.fcom.panel.AJAXPanel.ADMIN_USER_EDIT = {
  id: 'adminUserEditPanel',
  requiredScripts: ['adminUserEditPanel.js'],
  panelNamespace: 'YAHOO.fcom.panel.AdminUserEditPanel',
  url: 'admin/user/edit/adminUserEditPanel.panel',
  width: '800px',
  fixedcenter: false,
  visible: false,
  close: true,
  dragOnly: true,
  constraintoviewport: true,
  modal: true,
  refresh: true
};

/*
 * Predefined AJAXPanel configuration for adding position
 *
 * @type Object
 *
 */
YAHOO.fcom.panel.AJAXPanel.PORTFOLIO_ADD = {
  id: 'portfolioAddPanel',
  requiredScripts: ['portfolioPanel.js', 'portfolioAddPanel.js'],
  panelNamespace: 'YAHOO.fcom.panel.PortfolioAddPanel',
  url: 'portfolio.panel?method=showPosition',
  width: 'auto',
  fixedcenter: true,
  visible: false,
  close: true,
  dragOnly: true,
  constraintoviewport: true,
  modal: true
};

/*
 * Predefined AJAXPanel configuration for adding position
 *
 * @type Object
 *
 */
YAHOO.fcom.panel.AJAXPanel.PORTFOLIO_ADD_FIXED = {
  id: 'portfolioAddFixedPanel',
  url: 'portfolio.panel?method=showPosition&fixed=true'
};
YAHOO.lang.augmentObject(YAHOO.fcom.panel.AJAXPanel.PORTFOLIO_ADD_FIXED, YAHOO.fcom.panel.AJAXPanel.PORTFOLIO_ADD);

/*
 * Predefined AJAXPanel configuration for reducing a position
 *
 * @type Object
 *
 */
YAHOO.fcom.panel.AJAXPanel.PORTFOLIO_REDUCE = {
  id: 'portfolioReducePanel',
  requiredScripts: ['portfolioPanel.js', 'portfolioAddPanel.js', 'portfolioReducePanel.js'],
  panelNamespace: 'YAHOO.fcom.panel.PortfolioReducePanel',
  url: 'portfolio.panel?method=showReducePosition&fixed=true',
  width: 'auto',
  fixedcenter: true,
  visible: false,
  close: true,
  dragOnly: true,
  constraintoviewport: true,
  modal: true
};

/*
 * Predefined AJAXPanel configuration for editing a position
 *
 * @type Object
 *
 */
YAHOO.fcom.panel.AJAXPanel.PORTFOLIO_EDIT = {
  id: 'portfolioEditPanel',
  postData: {
    fixed: true
  },
  requiredScripts: ['portfolioPanel.js', 'portfolioAddPanel.js'],
  panelNamespace: 'YAHOO.fcom.panel.PortfolioEditPanel',
  url: 'portfolio.panel?method=showPosition',
  width: 'auto',
  x: xPos,
  y: yPos,
  fixedcenter: false,
  visible: false,
  close: true,
  dragOnly: true,
  constraintoviewport: true,
  modal: true
};

/*
 * Predefined AJAXPanel configuration for editing a historical position
 *
 * @type Object
 *
 */
YAHOO.fcom.panel.AJAXPanel.PORTFOLIO_EDIT_HISTORICAL = {
  id: 'portfolioEditHistoricalPanel',
  postData: {
    fixed: true
  },
  requiredScripts: ['portfolioPanel.js', 'portfolioAddPanel.js', 'portfolioReducePanel.js', 'portfolioEditHistoricalPanel.js'],
  panelNamespace: 'YAHOO.fcom.panel.PortfolioEditHistoricalPanel',
  url: 'portfolio.panel?method=showHistoricPosition',
  width: 'auto',
  x: xPos,
  y: yPos,
  fixedcenter: false,
  visible: false,
  close: true,
  dragOnly: true,
  constraintoviewport: true,
  modal: true
};

/*
 * Predefined AJAXPanel creating and editing a portfolio module
 *
 * @type Object
 *
 */
YAHOO.fcom.panel.AJAXPanel.PORTFOLIO_CREATE = {
  id: 'portfolioCreatePanel',
  requiredScripts: ['portfolioPanel.js', 'portfolioCreatePanel.js'],
  panelNamespace: 'YAHOO.fcom.panel.PortfolioCreatePanel',
  url: 'portfolios/portfolios/panels/portfolioCreatePanel.plain',
  width: '360px',
  fixedcenter: true,
  visible: false,
  close: true,
  dragOnly: true,
  constraintoviewport: true,
  modal: true,
  refresh: true
};

/*
 * Predefined AJAXPanel creating and editing the portfolio-page
 *
 * @type Object
 */
YAHOO.fcom.panel.AJAXPanel.COLUMNS_CONFIG = {
  id: 'portfolioAddPanel',
  requiredScripts: ['portfolioPanel.js', 'portfolioAddPanel.js'],
  panelNamespace: 'YAHOO.fcom.panel.PortfolioAddPanel',
  url: '/view.action?method=selectPortfolioColumnConfigPage',
  // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
  width: '680px',
  fixedcenter: true,
  visible: true,
  close: true,
  dragOnly: true,
  constraintoviewport: true,
  modal: true
};
YAHOO.fcom.panel.AJAXPanel.PORTFOLIO_PRINT = {
  id: 'portfolioPrintPanel',
  requiredScripts: ['portfolioPanel.js', 'portfolioPrintPanel.js'],
  panelNamespace: 'YAHOO.fcom.panel.PortfolioPrintPanel',
  url: 'portfolios/portfolios/panels/portfolioPrintPanel.plain',
  width: '400px',
  fixedcenter: true,
  visible: false,
  close: true,
  dragOnly: true,
  constraintoviewport: true,
  modal: true,
  refresh: true
};
YAHOO.fcom.panel.AJAXPanel.TRANSACTION_NEW = {
  id: 'transactionNewPanel',
  requiredScripts: ['portfolioPanel.js', 'transactionPanel.js'],
  panelNamespace: 'YAHOO.fcom.panel.TransactionPanel',
  url: 'portfolios/portfolios/panels/transactionPanel.plain',
  width: 'auto',
  fixedcenter: true,
  visible: false,
  close: true,
  dragOnly: true,
  constraintoviewport: true,
  modal: true
};
YAHOO.fcom.panel.AJAXPanel.TRANSACTION_META = {
  id: 'transactionMetaPanel',
  requiredScripts: ['portfolioPanel.js', 'transactionMetaPanel.js'],
  panelNamespace: 'YAHOO.fcom.panel.TransactionMetaPanel',
  url: 'portfolios/portfolios/panels/transactionMetaPanel.plain',
  width: 'auto',
  fixedcenter: true,
  visible: false,
  close: true,
  dragOnly: true,
  constraintoviewport: true,
  modal: true,
  refresh: true
};
YAHOO.fcom.panel.AJAXPanel.CASH_ACCOUNT = {
  id: 'cashAccountPanel',
  requiredScripts: ['portfolioPanel.js', 'cashAccountPanel.js'],
  panelNamespace: 'YAHOO.fcom.panel.CashAccountPanel',
  url: 'portfolios/portfolios/panels/cashAccountPanel.plain',
  width: '360px',
  fixedcenter: true,
  visible: false,
  close: true,
  dragOnly: true,
  constraintoviewport: true,
  modal: true
};
YAHOO.fcom.panel.AJAXPanel.MONEY_TRANSFER = {
  id: 'moneyTransferNewPanel',
  requiredScripts: ['portfolioPanel.js', 'moneyTransferPanel.js'],
  panelNamespace: 'YAHOO.fcom.panel.MoneyTransferPanel',
  url: 'portfolio.panel?method=showMoneyTransfer',
  width: '360px',
  fixedcenter: true,
  visible: false,
  close: true,
  dragOnly: true,
  constraintoviewport: true,
  modal: true
};
YAHOO.fcom.panel.AJAXPanel.NEWS_EDIT = {
  id: 'newsEditPanel',
  requiredScripts: ['newsEditPanel.js'],
  panelNamespace: 'YAHOO.fcom.panel.NewsEditPanel',
  url: 'news.panel?method=handleEditNews',
  width: '560px',
  fixedcenter: false,
  visible: false,
  close: true,
  dragOnly: true,
  draggable: true,
  constraintoviewport: true,
  modal: true,
  refresh: true
};
YAHOO.fcom.panel.AJAXPanel.CHOOSE_COLUMN_PANEL = {
  id: 'chooseColumnPanel',
  requiredScripts: ['chooseColumnPanel.js'],
  panelNamespace: 'YAHOO.fcom.panel.ChooseColumnPanel',
  width: '880px',
  fixedcenter: true,
  visible: false,
  close: true,
  dragOnly: true,
  constraintoviewport: true,
  modal: true,
  refresh: true
};

},{}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var KEYCODE = {
  ENTER: 13,
  SPACE: 32,
  ESCAPE: 27,
  ARROW_LEFT: 37,
  ARROW_UP: 38,
  ARROW_RIGHT: 39,
  ARROW_DOWN: 40,
  TAB: 9,
  KeyA: 65,
  KeyD: 68,
  DELETE: 46
};
var _default = exports.default = KEYCODE;

},{}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * @name            : GUID
 * @description     : Generate new GUID and GUID related methods
 */
var GUID = exports.default = /*#__PURE__*/function () {
  function GUID() {
    _classCallCheck(this, GUID);
  }
  _createClass(GUID, null, [{
    key: "generate",
    value:
    /**
     * @method generate
     * @description Static method to generate new GUID
     * @public
     * @static
     */
    function generate() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0;
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
      });
    }
  }]);
  return GUID;
}();

},{}]},{},[5]);
;
(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _StreamingAccessibility = _interopRequireDefault(require("accessibility/StreamingAccessibility"));
var _ContextMenuAccessibility = _interopRequireDefault(require("accessibility/ContextMenuAccessibility"));
var _AccordionAccessibility = _interopRequireDefault(require("accessibility/AccordionAccessibility"));
var _TooltipAccessibility = _interopRequireDefault(require("accessibility/TooltipAccessibility"));
var _PopupSearchAccessibility = _interopRequireDefault(require("accessibility/PopupSearchAccessibility"));
var _HighchartsAccessibility = _interopRequireDefault(require("accessibility/HighchartsAccessibility"));
var _NewsPlayerAccessibility = _interopRequireDefault(require("accessibility/NewsPlayerAccessibility"));
var _LoginAccessibility = _interopRequireDefault(require("accessibility/LoginAccessibility"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * @class       : Accessibility
                                                                                                                                                                                                                                                                                                                                                                                               * @description : To enable the web content accessibility(WCAG) in the ngp components
                                                                                                                                                                                                                                                                                                                                                                                               *                  - Streaming modules
                                                                                                                                                                                                                                                                                                                                                                                               *                  - Context menu open button
                                                                                                                                                                                                                                                                                                                                                                                               *                  - Context menu
                                                                                                                                                                                                                                                                                                                                                                                               *                  - Accordion controls
                                                                                                                                                                                                                                                                                                                                                                                               *                  - Tooltip component
                                                                                                                                                                                                                                                                                                                                                                                               *                  - Popup search
                                                                                                                                                                                                                                                                                                                                                                                               *                  - Highcharts/Highstocks
                                                                                                                                                                                                                                                                                                                                                                                               *                  - NEWS Player - top news module
                                                                                                                                                                                                                                                                                                                                                                                               * @dependencies: Jquery, StreamingAccessibility, ContextMenuAccessibility, AccordionAccessibility,
                                                                                                                                                                                                                                                                                                                                                                                               *                TooltipAccessibility, PopupSearchAccessibility, NewsPlayerAccessibility
                                                                                                                                                                                                                                                                                                                                                                                               * @references  : https://www.w3.org/TR/WCAG20-TECHS/
                                                                                                                                                                                                                                                                                                                                                                                               */
var Accessibility = /*#__PURE__*/function () {
  function Accessibility() {
    _classCallCheck(this, Accessibility);
  }
  _createClass(Accessibility, null, [{
    key: "init",
    value:
    /**
     * @method init
     * @description Initialize the accessibility module
     * @public
     * @static
     */
    function init(params) {
      Accessibility._start(params);
    }

    /**
     * @method init
     * @description Update an element title based on the inner text
     * @public
     * @static
     */
  }, {
    key: "compareAndUpdateElementTitle",
    value: function compareAndUpdateElementTitle($elements, compareText, updatedTitle) {
      // #. Identify the delete button based on the inner text value
      $elements.filter(function (index) {
        var $element = $($elements[index]);
        var innerText = $element.text();
        if (String(innerText).trim().replace(/[^a-zA-Z ]/g, '') === String(compareText).trim().replace(/[^a-zA-Z ]/g, '')) {
          $element.attr({
            'aria-label': updatedTitle
          });
        }
      });
    }
  }, {
    key: "_start",
    value:
    /**
     * @method _start
     * @description assign accessibility to accessibility services
     * @param { Object } v expect config information or null
     * @private
     * @static
     */
    function _start(config) {
      if (config) {
        // #. Init the streaming accessibility
        if (config.streamingAccessibility) {
          var streamingAccessibility = new _StreamingAccessibility.default();
          streamingAccessibility.init(config.streamingAccessibility.nodes);
        }

        // #. Init context menu accessibility
        if (config.menu && config.menu.enabled) {
          var contextMenuAccessibility = new _ContextMenuAccessibility.default();
          window.setTimeout(function () {
            contextMenuAccessibility.init();
          }, config.menu.initDelay || 0);
        }

        // #. Init accordion accessibility
        if (config.accordion) {
          var accordionAccessibility = new _AccordionAccessibility.default(config.accordion);
          accordionAccessibility.init();
        }

        // #. Init accordion accessibility
        if (config.tooltip) {
          var tooltipAccessibility = new _TooltipAccessibility.default(config.tooltip);
          tooltipAccessibility.init();
        }

        // #. Init popup search accessibility accessibility
        if (config.popupSearch) {
          var popupSearchAccessibility = new _PopupSearchAccessibility.default(config.popupSearch);
          popupSearchAccessibility.init();
        }

        // #. Init highcharts accessibility module
        if (config.highCharts && config.highCharts.enabled) {
          var highchartsAccessibility = new _HighchartsAccessibility.default(config.highCharts);
          highchartsAccessibility.init();
        }

        // #. Init highcharts accessibility module
        if (config.newsPlayer) {
          var newsPlayerAccessibility = new _NewsPlayerAccessibility.default(config.newsPlayer);
          newsPlayerAccessibility.init();
        }

        // #. Init login page accessibility
        if (config.login) {
          var loginAccessibility = new _LoginAccessibility.default();
          loginAccessibility.init();
        }
      }
    }
  }]);
  return Accessibility;
}(); // #. Set the global access
window.fcom.Accessibility = Accessibility;
var _default = exports.default = Accessibility;

},{"accessibility/AccordionAccessibility":2,"accessibility/ContextMenuAccessibility":3,"accessibility/HighchartsAccessibility":4,"accessibility/LoginAccessibility":5,"accessibility/NewsPlayerAccessibility":6,"accessibility/PopupSearchAccessibility":7,"accessibility/StreamingAccessibility":8,"accessibility/TooltipAccessibility":10}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _guid = _interopRequireDefault(require("util/guid"));
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * @class       : AccordionAccessibility
                                                                                                                                                                                                                                                                                                                                                                                               * @description : To enable the web content accessibility(WCAG) in ngp application accordion(expander/collapse) component
                                                                                                                                                                                                                                                                                                                                                                                               *                - NGPII-15088 JAWS: Expander
                                                                                                                                                                                                                                                                                                                                                                                               * @dependencies: Jquery, GUID
                                                                                                                                                                                                                                                                                                                                                                                               * @references  : https://www.w3.org/TR/wai-aria-practices-1.1/examples/accordion/accordion.html
                                                                                                                                                                                                                                                                                                                                                                                               */
var AccordionAccessibility = /*#__PURE__*/function () {
  function AccordionAccessibility(options) {
    _classCallCheck(this, AccordionAccessibility);
    if (!options) {
      return true;
    }

    // #. Keep the config/options into context
    this.options = options;
    // #. Keep the accordion container
    this.$container = _typeof(options.container) === 'object' ? options.container : $(options.container);
    // #. Keep all accordion toggles
    this.$toggles = null;
    // #. Selector to identify the expanded toggle bar - default 'open' is a css class name
    this.expandSelector = options.expandSelector || 'open';
    /**
     * Keep the panel find selector method(ex: next, Jquery selector)
     * next - consider as method ex: findPanelBy: { method: 'next' }
     * multiple methods will be formatted by space { method: 'parent next' }
     * id - consider as attribute ex: findPanelBy: { attr: 'id' }
     */
    this.findPanelBy = options.findPanelBy || {
      method: 'next'
    };
  }

  /**
   * @method init
   * @description Initialize the accordion accessibility
   * @public
   */
  _createClass(AccordionAccessibility, [{
    key: "init",
    value: function init() {
      // #. Find all accordion toggles
      this.$toggles = this.$container.find(this.options.toggleSelector);
      // #. Set default WCAG attributes
      this._setWCAGAttributes();
      // #. Bind the tracking events to toggle bar
      this._bindEvents(this.$toggles);
    }

    /**
     * @method _setWCAGAttributes
     * @description set WCAG attributes to accordion
     * @private
     */
  }, {
    key: "_setWCAGAttributes",
    value: function _setWCAGAttributes() {
      // todo manage the disabled accordions - check the scope
      // todo manage the multiple open accordions - check the scope
      var _iterator = _createForOfIteratorHelper(this.$toggles),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var $toggle = _step.value;
          $toggle = $($toggle);
          var $panel = this._getPanelByToggle($toggle);

          // #. No panel - then continue
          if (!$panel || $panel.length === 0) {
            return true;
          }

          // #. Set toggle bat attr
          var toggleAttr = {
            'aria-expanded': this._isToggleExpanded($toggle)
          };

          // #. lost toggle not require control attr ex: EditView left panel list
          if (this.options.toggleControlAttr !== false) {
            toggleAttr['aria-controls'] = this._getElementId($panel);
          }

          // #. Update toggle attr
          this._setAttributes($toggle, toggleAttr);

          // #. Set panel display attr
          var panelAttr = {
            'aria-labelledby': this._getElementId($toggle)
          };

          // #. options not require role update ex: EditView left panel list
          if (this.options.panelRoleUpdate !== false) {
            panelAttr.role = 'region';
          }

          // #. Update panel attr
          this._setAttributes($panel, panelAttr);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    /**
     * @method _bindEvents
     * @description bind events to update the attributes
     * @param { HTMLElement } $element expect a element or collection of elements object
     * @private
     */
  }, {
    key: "_bindEvents",
    value: function _bindEvents($element) {
      var _this = this;
      $element.on('keydown click', function (event) {
        var $target = $(event.target);
        var keyCode = event.keyCode;
        if (!keyCode || keyCode === _keyCodes.default.ENTER || keyCode === _keyCodes.default.SPACE) {
          // #. Update expanded attribute
          _this._isToggleExpanded($target, function (value) {
            $target.attr('aria-expanded', value);
          });
        }
      });
    }

    /**
     * @method _isToggleExpanded
     * @description check the expand status of a toggle
     * @param { HTMLElement } $element expect a element or collection of elements object
     * @private
     */
  }, {
    key: "_isToggleExpanded",
    value: function _isToggleExpanded($toggle, callback) {
      var $element = $toggle;
      var selector = this.expandSelector;
      var delay = 0;
      if (_typeof(this.expandSelector) === 'object') {
        if (this.expandSelector.parent) {
          $element = $toggle.parent();
          selector = this.expandSelector.parent;
          delay = this.expandSelector.delay || 0;
        }
      }
      if (callback) {
        window.setTimeout(function () {
          callback($element.hasClass(selector));
        }, delay);
      } else {
        return $element.hasClass(selector);
      }
    }

    /**
     * @method _getElementId
     * @description get id attribute of a element, set new one when no id found
     * @param { HTMLElement } $element expect panel display element object
     * @private
     */
  }, {
    key: "_getElementId",
    value: function _getElementId($element) {
      var elementId = $element.attr('id');
      if (!elementId) {
        elementId = _guid.default.generate();
        $element.attr('id', elementId);
      }
      return elementId;
    }

    /**
     * @method _setAttributes
     * @description set attr object to specific element
     * @param { HTMLElement } $element expect element object
     * @param { Object } attr expect object of attributes
     * @private
     */
  }, {
    key: "_setAttributes",
    value: function _setAttributes($element, attr) {
      $element.attr(attr);
    }

    /**
     * @method _getPanelByToggle
     * @description get corresponding panel by toggle bar
     * @param { HTMLElement } $toggle expect toggle bar element object
     * @private
     */
  }, {
    key: "_getPanelByToggle",
    value: function _getPanelByToggle($toggle) {
      /** Find panel element by series of methods or method
        * multiple methods split by space ex: 'parent next' - means next element of the toggle parent
        * method parameter can passed inside the parenthesis ex: 'parent nextAll(.class1#id)'
        */
      if (this.findPanelBy.method) {
        var $element = null;
        var methods = this.findPanelBy.method.split(' ');
        var _iterator2 = _createForOfIteratorHelper(methods),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var method = _step2.value;
            // #. Check any selectors passed as params
            var selector = '';
            if (method.indexOf('(') !== -1) {
              var params = method.split('(');
              method = params[0];
              selector = String(params[1]).replace(')', '');
            }
            $element = $element ? $($element)[method](selector) : $toggle[method](selector);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        return $element;
      }

      // #. Find panel elements by toggle attribute value
      // #. findClosestOfToggle - will get the attribute value from the closest element of the toggle
      if (this.findPanelBy.attr) {
        var _$element = this.findPanelBy.findClosestOfToggle ? $toggle.closest("[".concat(this.findPanelBy.attr, "]")) : $toggle;
        var attrVal = _$element.attr(this.findPanelBy.attr);
        var _selector = "[".concat(this.findPanelBy.attr, "=\"").concat(attrVal, "\"]");
        return this.$container.find(_selector).not(this.findPanelBy.notInclude || '');
      }
    }
  }]);
  return AccordionAccessibility;
}(); // #. Export the accordion accessibility
var _default = exports.default = AccordionAccessibility;

},{"util/enums/keyCodes":17,"util/guid":18}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * @class       : ContextMenuAccessibility
                                                                                                                                                                                                                                                                                                                                                                                               * @description : To enable the web content accessibility(WCAG) in ngp application context menu component
                                                                                                                                                                                                                                                                                                                                                                                               *                - NGPII-15538 JAWS: Context Menu
                                                                                                                                                                                                                                                                                                                                                                                               *                - Context menu item accessibility handled in ExtendedMenu.es6.js
                                                                                                                                                                                                                                                                                                                                                                                               * @dependencies: Jquery, KEYCODES
                                                                                                                                                                                                                                                                                                                                                                                               * @references  : https://www.w3.org/TR/WCAG20-TECHS/
                                                                                                                                                                                                                                                                                                                                                                                               *                https://www.w3.org/TR/wai-aria-practices/examples/menu-button/menu-button-links.html
                                                                                                                                                                                                                                                                                                                                                                                               */
var ContextMenuAccessibility = /*#__PURE__*/function () {
  function ContextMenuAccessibility() {
    _classCallCheck(this, ContextMenuAccessibility);
    // #. To keep the menu opening button collection
    this.$menuOpenButtons = [];
    // #. CSS class selector of module library menu open button
    this.moduleLibraryButtonSelector = '.icon.showModuleLibrary';
    // #. CSS selector of module content header menu button
    this.moduleHeaderButton = 'table.headerContent .controls .control .icon.options';
    // #. CSS selector of context menu open button
    this.menuOpener = 'button.icon.options';
    // #. Const to declare the button context type
    this.contextType = {
      MODULE_LIBRARY: 1,
      MODULE_CONTROL: 2,
      TABLE_ROW_EDIT: 3
    };
  }

  /**
   * @method init
   * @description Initialize the menu accessibility
   * @public
   */
  _createClass(ContextMenuAccessibility, [{
    key: "init",
    value: function init() {
      // #. Get menu opening button elements
      this.$menuOpenButtons = this._findMenuOpenButtons();
      this._start();
    }

    /**
     * @method _start
     * @description start the basic methods, assign attributes, bind key handler
     * @private
     */
  }, {
    key: "_start",
    value: function _start() {
      // #. Handle the focus, keydown event
      this._bindTrackingEvents();

      // #. Check the count of the streaming nodes
      if (this.$menuOpenButtons.length > 0) {
        this._setWCAGAttributesToButton(this.$menuOpenButtons);
      }
    }

    /**
     * @method _findMenuOpenButtons
     * @description find all menu opening buttons from the body element
     * @return { Array } of menu open button elements
     * @private
     */
  }, {
    key: "_findMenuOpenButtons",
    value: function _findMenuOpenButtons() {
      var $body = $('body');
      return $([].concat(_toConsumableArray($body.find(this.menuOpener)), _toConsumableArray($body.find(this.moduleLibraryButtonSelector))));
    }

    /**
     * @method _setWCAGAttributesToButton
     * @description find all menu opening buttons from the body element
     * @param { HTMLCollectionOf } $buttons expecting collection menu open button elements
     * @private
     */
  }, {
    key: "_setWCAGAttributesToButton",
    value: function _setWCAGAttributesToButton($buttons) {
      $buttons.attr({
        'aria-haspopup': 'menu',
        'aria-expanded': false
      });

      // #. Set unique properties
      this._setButtonUniqueProps($buttons);
    }

    /**
     * @method _setButtonUniqueProps
     * @description set unique button properties
     * @param { HTMLCollectionOf } $buttons expecting collection menu open button elements
     * @private
     */
  }, {
    key: "_setButtonUniqueProps",
    value: function _setButtonUniqueProps($buttons) {
      var _iterator = _createForOfIteratorHelper($buttons),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var $button = _step.value;
          $button = $($button);
          var contextType = this._getContextType($button);

          // #. Update the button title
          this._updateButtonTitle($button, contextType, false);

          // #. Set role application for the module head control div element
          // #. otherwise, keydown will not work properly when JAWS is working
          if (contextType === this.contextType.MODULE_CONTROL) {
            $button.closest('.control').attr({
              role: 'application'
            });
          } else {
            // #. Remove the innerText of the image button, because button already has the title
            var bgImg = String($button.css('background-image')).trim();
            if (bgImg && bgImg !== 'none' && !$button.hasClass('include-text')) {
              $button.text('');
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    /**
     * @method _updateButtonTitle
     * @description update button title based on the context
     *              - Button from the table row
     *              - Button from the module header
     *              - Module library button
     * @param { HTMLElement } $button expecting menu open button object
     * @param { Number } button context type
     * @private
     */
  }, {
    key: "_updateButtonTitle",
    value: function _updateButtonTitle($button, contextType, isOnFocus) {
      var label = this._getTitleByButtonContext($button, contextType, isOnFocus);
      if (label) {
        $button.attr({
          'aria-label': label
        });
      }
    }

    /**
     * @method _getContextType
     * @description get type of button context
     * @param { HTMLElement } $button expecting current button element
     * @private
     */
  }, {
    key: "_getContextType",
    value: function _getContextType($button) {
      if ($button.parent().is('td')) {
        return this.contextType.TABLE_ROW_EDIT;
      } else if ($button.is(this.moduleHeaderButton)) {
        return this.contextType.MODULE_CONTROL;
      } else if ($button.is(this.moduleLibraryButtonSelector)) {
        return this.contextType.MODULE_LIBRARY;
      }
    }

    /**
     * @method _setTitleByButtonContext
     * @description get title/name based on the button context
     * @param { HTMLElement } $button expecting current button element
     * @param { Number } button context type
     * @private
     */
  }, {
    key: "_getTitleByButtonContext",
    value: function _getTitleByButtonContext($button, contextType, isOnFocus) {
      // 1. Get name/title of the table row menu button
      if (contextType === this.contextType.TABLE_ROW_EDIT) {
        var name = this._getInstrumentNameByRow($button) || '';
        return window.getMessage('context.menu.open.name.postfix.tooltip', name);
      }

      // 2. Get name/title of module header menu button
      if (contextType === this.contextType.MODULE_CONTROL) {
        var _name = this._getTitleFromModuleHeader($button) || '';
        // #. Header title text may be 'loading...' when module not loaded yet
        // #. Updated title will be set on the focus event
        if (!isOnFocus) {
          return false;
        }
        return window.getMessage('context.menu.module.open.name.postfix.tooltip', _name);
      }

      // 3. Get module library button
      if (contextType === this.contextType.MODULE_LIBRARY) {
        return $button.attr('title');
      }
    }

    /**
     * @method _getInstrumentNameByRow
     * @description get instrument name from table row
     * @param { HTMLElement } $button expecting current button element
     * @private
     */
  }, {
    key: "_getInstrumentNameByRow",
    value: function _getInstrumentNameByRow($button) {
      var $row = $($button.closest('tr'));
      return $row.find('a.instrumentIdentification').text() || $row.find('span.instrumentIdentification').text() || $row.find('input.searchPopupInput').val() || $row.find('a').first().text();
    }

    /**
     * @method _getTitleFromModuleHeader
     * @description get title from the module header element
     * @param { HTMLElement } $button expecting current button element
     * @private
     */
  }, {
    key: "_getTitleFromModuleHeader",
    value: function _getTitleFromModuleHeader($button) {
      var $row = $($button.closest('tr'));
      return $row.find('h2.title').text() || $row.find('span.content').text();
    }

    /**
     * @method _bindTrackingEvents
     * @description update attributes of lately rendered element(Ex: Modules added from the module library, menu button render after large table sorting...etc)
     * @private
     */
  }, {
    key: "_bindTrackingEvents",
    value: function _bindTrackingEvents() {
      var self = this;
      $(window.document).on('focus', this.menuOpener, function (event) {
        var $button = $(this);
        $button.attr('aria-expanded', false);
        if (!$button.attr('aria-label')) {
          var contextType = self._getContextType($button);
          self._updateButtonTitle($button, contextType, true);
        }
      }).on('keydown', this.menuOpener, function (event) {
        var $button = $(this);
        var keyCode = event.keyCode;
        if (keyCode === _keyCodes.default.ENTER) {
          $button.attr('aria-expanded', true);
        }
      });
    }
  }]);
  return ContextMenuAccessibility;
}();
var _default = exports.default = ContextMenuAccessibility;

},{"util/enums/keyCodes":17}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _messageHandler = require("fcom/messages/messageHandler");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * @class       : HighchartsAccessibility
 * @description : To enable the web content accessibility(WCAG) in ngp application highcharts/highstocks
 *                - https://jira.financial.com/browse/NGPII-15551
 * @dependencies: Highcharts, Highstocks, highchart-exporting, highchart-exporting-data, highcharts-accessibility
 * @references  : https://www.highcharts.com/docs/accessibility/accessibility-module
 *              : https://www.highcharts.com/docs/extending-highcharts/extending-highcharts
 *              : https://www.highcharts.com/docs/getting-started/how-to-set-options
 */
var HighchartsAccessibility = /*#__PURE__*/function () {
  function HighchartsAccessibility(options) {
    _classCallCheck(this, HighchartsAccessibility);
    // #. Keep the config/options into context
    this.options = options;
    // #. Get the highcharts object
    this.H = window.Highcharts;
    // #. Set accessibility options
    this.accessibilityOptions = {
      accessibility: {
        enabled: true,
        keyboardNavigation: {
          enabled: true,
          seriesNavigation: {
            mode: 'normal',
            skipNullPoints: true
          }
        },
        announceNewData: {
          enabled: true,
          interruptUser: true
        }
      }
    };
  }

  /**
   * @method init
   * @description Initialize the highcharts accessibility
   * @public
   */
  _createClass(HighchartsAccessibility, [{
    key: "init",
    value: function init() {
      var self = this;
      /**
       * Enable the chart accessibility globally
       */
      window.Highcharts.setOptions(this.accessibilityOptions);

      /**
       * NOTE:
       * Highcharts created a utility called wrap, which wraps an existing prototype function ("method") and -
       * allows you to add your own code before or after it.
       */

      /**
       * Extend the chart render method
       * To assign the proper role attribute to container element - for screen reader
       */
      this.H.wrap(this.H.Chart.prototype, 'onload', function (proceed) {
        proceed.call(this, arguments);
        self._setWCAGtoChart(this.renderTo);
        self._handleFirefoxTabKeyOrder(this.container);
        self._handleEdgeAccessToChart(this.container);
      });

      /**
       * Extend the tooltip refresh method
       * To assign the tooltip to proper role attributes - for screen reader
       */
      this.H.wrap(this.H.Tooltip.prototype, 'refresh', function (proceed, point, e) {
        proceed.call(this, point, e);
        self._setWCAGtoChartTooltip(this.chart.tooltip.container || this.chart.renderTo);
      });

      /**
       * Extend the tooltip hide method
       * To assign the tooltip table hidden - for screen reader
       */
      this.H.wrap(this.H.Tooltip.prototype, 'hide', function (proceed, point, e) {
        proceed.call(this, point, e);
        self._setWCAGtoHiddenTooltipTable(this.chart.renderTo);
      });

      /**
       * Extend the tooltip show method
       * To assign the tooltip table shown - for screen reader
       */
      this.H.wrap(this.H.Tooltip.prototype, 'show', function (proceed, point, e) {
        proceed.call(this, point, e);
        self._setWCAGtoShownTooltipTable(this.chart.renderTo);
      });
    }
  }, {
    key: "_setWCAGtoHiddenTooltipTable",
    value: function _setWCAGtoHiddenTooltipTable(chartContainer) {
      $(chartContainer).find('div.highcharts-tooltip table').attr('aria-hidden', true);
    }
  }, {
    key: "_setWCAGtoShownTooltipTable",
    value: function _setWCAGtoShownTooltipTable(chartContainer) {
      $(chartContainer).find('div.highcharts-tooltip table').attr('aria-hidden', false);
    }

    /**
     * @method _setWCAGtoChart
     * @description update WCAG attributes to highcharts
     * @param { $chartContainer } expecting chart container html element object
     * @private
     */
  }, {
    key: "_setWCAGtoChart",
    value: function _setWCAGtoChart($chartContainer) {
      $($chartContainer).attr({
        role: 'application'
      });
      if ($('#additionalChartTitleId').length > 0) {
        $($chartContainer).find('.highcharts-container').attr('aria-describedby', 'additionalChartTitleId');
      }
      $($chartContainer).find('[id*="highcharts-data-table"]').attr('aria-hidden', true);
    }

    /**
     * @method _setWCAGtoChartTooltip
     * @description update WCAG attributes to highcharts tooltip
     * @param { $chartContainer } expecting chart container html element object
     * @private
     */
  }, {
    key: "_setWCAGtoChartTooltip",
    value: function _setWCAGtoChartTooltip($chartContainer) {
      var $tooltip = $($chartContainer).find('div.highcharts-tooltip > span');
      if ($tooltip.length > 0) {
        $tooltip.attr('role', 'tooltip');
        $tooltip.attr('aria-live', 'assertive');
        var $tooltipTable = $tooltip.find('table');
        if ($($tooltipTable).find('caption').length === 0) {
          $tooltipTable.prepend($('<caption />').text((0, _messageHandler.getMessage)('chart.tooltip.table.caption')).addClass('visuallyhidden'));
        }
      }
    }

    /**
     * @method _handleFirefoxTabKeyOrder
     * @description set tab key order for the module chart
     * @param { $chartContainer } expecting chart container html element object
     * @private
     */
  }, {
    key: "_handleFirefoxTabKeyOrder",
    value: function _handleFirefoxTabKeyOrder($chartContainer) {
      var isFirefox = navigator.userAgent.search('Firefox');
      var $moduleLink = $($chartContainer).closest('.chartImageBox').children().first();
      if (isFirefox > -1 && $moduleLink.is('a')) {
        $moduleLink.attr('tabindex', -1);
      }
    }

    /**
     * @method _handleEdgeAccessToCahrt
     * @description set descriptive label
     * @param { $chartContainer } expecting chart container html element object
     * @private
     */
  }, {
    key: "_handleEdgeAccessToChart",
    value: function _handleEdgeAccessToChart($chartContainer) {
      var isEdge = navigator.userAgent.search('Edg');
      if (isEdge > -1) {
        var chartContainerId = $($chartContainer).attr('id');
        var describedLabelEle = $('<span>').attr('id', "".concat(chartContainerId, "_describedId")).addClass('visuallyhidden').text((0, _messageHandler.getMessage)('chart.descriptive.text.edg'));
        $($chartContainer).find('svg.highcharts-root').attr('aria-describedby', "".concat(chartContainerId, "_describedId")).before(describedLabelEle);
      }
    }
  }]);
  return HighchartsAccessibility;
}();
var _default = exports.default = HighchartsAccessibility;

},{"fcom/messages/messageHandler":12}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * @class       : LoginAccessibility
 * @description : To enable the web content accessibility(WCAG) in login page
 * @references  : https://developer.mozilla.org/en-US/docs/Web/API/Window/devicePixelRatio#monitoring_screen_resolution_or_zoom_level_changes
 */
var LoginAccessibility = /*#__PURE__*/function () {
  function LoginAccessibility() {
    _classCallCheck(this, LoginAccessibility);
    this.loginElement = $('div.login').get(0);
  }

  /**
   * @method init
   * @description Initialize login accessibility
   * @public
   */
  _createClass(LoginAccessibility, [{
    key: "init",
    value: function init() {
      this._initAccessibility();
    }

    /**
     * @method _initAccessibility
     * @description calling methods for wcag
     * @private
     */
  }, {
    key: "_initAccessibility",
    value: function _initAccessibility() {
      this._onPageZoomEvent();
    }

    /**
     * @method _onPageZoomEvent
     * @description when page zoom change, call method to set the scrollbarState
     * @private
     */
  }, {
    key: "_onPageZoomEvent",
    value: function _onPageZoomEvent() {
      var _this = this;
      var updatePixelRatio = function updatePixelRatio() {
        var pr = window.devicePixelRatio;
        var prString = (pr * 100).toFixed(0);
        _this._setScrollBarState();
        matchMedia("(resolution: ".concat(pr, "dppx)")).addEventListener("change", updatePixelRatio, {
          once: true
        });
      };
      updatePixelRatio();
    }

    /**
     * @method hasVerticalScrollBar
     * @returns {boolean}
     * @private
     */
  }, {
    key: "_hasVerticalScrollBar",
    value: function _hasVerticalScrollBar() {
      return this.loginElement.scrollHeight > this.loginElement.clientHeight;
    }

    /**
     * @method _checkLoginContainerScrolling
     * @description add css class hasScrollBar to scrolling login element
     * @private
     */
  }, {
    key: "_setScrollBarState",
    value: function _setScrollBarState() {
      if (this._hasVerticalScrollBar() === true) {
        $(this.loginElement).addClass('hasScrollBar');
      } else {
        $(this.loginElement).removeClass('hasScrollBar');
      }
    }
  }]);
  return LoginAccessibility;
}();
var _default = exports.default = LoginAccessibility;

},{}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * @class       : TopNewsAccessibility
                                                                                                                                                                                                                                                                                                                                                                                               * @description : To enable the web content accessibility(WCAG) in top news module component
                                                                                                                                                                                                                                                                                                                                                                                               *                - GPNGPII-16881 - Keyboard access not enabled for TOP NEWS Module
                                                                                                                                                                                                                                                                                                                                                                                               * @dependencies: Jquery, KEYCODES
                                                                                                                                                                                                                                                                                                                                                                                               * @references  : https://www.w3.org/WAI/tutorials/carousels/
                                                                                                                                                                                                                                                                                                                                                                                               */
var NewsPlayerAccessibility = /*#__PURE__*/function () {
  function NewsPlayerAccessibility(options) {
    _classCallCheck(this, NewsPlayerAccessibility);
    if (!options) {
      return true;
    }

    // #. Keep the config/options into context
    this.options = options;
    this.player = this.options.player;
  }

  // #. Get headline elements
  _createClass(NewsPlayerAccessibility, [{
    key: "$headlines",
    get: function get() {
      return $(this.player.container).find('.headline div');
    }

    // #. Get news module panel element
  }, {
    key: "$newsPlayerModulePanel",
    get: function get() {
      return $('#NewsPlayerModulePanel');
    }

    /**
     * @method init
     * @description Initialize the top news accessibility
     * @public
     */
  }, {
    key: "init",
    value: function init() {
      this._setWCAGAttributes();
    }

    /**
     * @method _setWCAGAttributes
     * @description set WCAG attributes to player elements
     * @private
     */
  }, {
    key: "_setWCAGAttributes",
    value: function _setWCAGAttributes() {
      $(this.player.moduleContainer).attr('role', 'presentation');
      $(this.player.controlBar).attr('role', 'application');
      // #. Set headline attributes
      this._setWCAGToHeadlines();
      // #. Set control buttons attributes
      this._setWCAGToControlButtons();
    }

    /**
     * @method _setWCAGToHeadlines
     * @description set WCAG attributes/events to headline element
     * @private
     */
  }, {
    key: "_setWCAGToHeadlines",
    value: function _setWCAGToHeadlines() {
      var _this = this;
      // #. Set aria-haspopup attribute to headline
      this.$headlines.attr({
        role: 'link',
        'aria-haspopup': true
      });

      // # on bind required for the streaming updates(lately rendered elements)
      $(this.player.container).off('focus', '.headline div');
      $(this.player.container).on('focus', '.headline div', function (event) {
        _this._onHeadlineFocused(event);
      });
      $(this.player.container).off('keydown');
      $(this.player.container).on('keydown', '.headline div', function (event) {
        if (event.keyCode === _keyCodes.default.ENTER) {
          $(event.target).trigger('click');
        }
      });

      // #. application role required to handle the custom keydown event(override screen reader)
      this.$headlines.parent().attr('role', 'application');
    }

    /**
     * @method _setWCAGToControlButtons
     * @description set WCAG attributes to player control button elements
     * @private
     */
  }, {
    key: "_setWCAGToControlButtons",
    value: function _setWCAGToControlButtons() {
      var attr = {
        role: 'button',
        tabindex: 0
      };

      // #. List of player control buttons
      var $buttons = [this.player.previousButton, this.player.nextButton, this.player.playButton, this.player.stopButton];
      var buttonTitles = ['news.topNews.player.previous', 'news.topNews.player.next', 'news.topNews.player.start', 'news.topNews.player.stop'];
      var self = this;
      for (var i = 0; i < $buttons.length; i++) {
        var $buttonActive = $($buttons[i]);
        // Get button title
        attr.title = window.getMessage(buttonTitles[i]);
        // #. Set the attributes
        $buttonActive.attr(attr);
        // #. Bind keydown - Enter should trigger the click event
        $buttonActive.off('keydown');
        $buttonActive.on('keydown', function (event) {
          self._onControlButtonsEventTriggered(event);
        });
        $buttonActive.off('focusout');
        $buttonActive.on('focusout', function (event) {
          $(this).removeAttr('aria-label');
        });
      }
    }

    /**
     * @method _onControlButtonsEventTriggered
     * @description handle the control button events
     * @param { KeydownEvent } event - Keyboard event
     * @private
     */
  }, {
    key: "_onControlButtonsEventTriggered",
    value: function _onControlButtonsEventTriggered(event) {
      var _this2 = this;
      if (event.keyCode === _keyCodes.default.ENTER || event.keyCode === _keyCodes.default.SPACE) {
        var $button = $(event.target);
        var triggerFocus = function triggerFocus() {
          var activeNews = _this2._getActiveNews();
          $button.blur();
          setTimeout(function () {
            $button.attr('aria-label', activeNews).focus();
          }, 50);
        };
        // #. Active element is Stop then focus will be move to Play
        if ($button.is(this.player.stopButton)) {
          this.player.stopAutoplay();
          $(this.player.playButton).css('display', 'inline').focus();
        } else
          // #. Active element is Play then focus will be move to Stop
          if ($button.is(this.player.playButton)) {
            this.player.startAutoplay();
            $(this.player.stopButton).css('display', 'inline').focus();
          } else if ($button.is(this.player.previousButton)) {
            this.player.showPrevious();
            triggerFocus();
          } else if ($button.is(this.player.nextButton)) {
            this.player.showNext();
            triggerFocus();
          }
      }
    }

    /**
     * @method _getActiveNews
     * @description get active news item
     * @private
     */
  }, {
    key: "_getActiveNews",
    value: function _getActiveNews() {
      var $activeNews = $(this.player.container).find('.pictureNewsItem').filter(function () {
        return $(this).css('visibility') === 'visible';
      });
      return $activeNews.find('.headline').text();
    }

    /**
     * @method _onHeadlineFocused
     * @description handle the headline focus event - to show the control buttons(like mouse over)
     * @param { FocusEvent } event - focus event
     * @private
     */
  }, {
    key: "_onHeadlineFocused",
    value: function _onHeadlineFocused(event) {
      // #. Stop the autoplay
      $(this.player.stopButton).click();
      // #. Show proper control buttons
      $(this.player.previousButton).css('display', 'inline');
      $(this.player.nextButton).css('display', 'inline');
      $(this.player.playButton).css('display', 'inline');
    }
  }]);
  return NewsPlayerAccessibility;
}();
var _default = exports.default = NewsPlayerAccessibility;

},{"util/enums/keyCodes":17}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * @class       : PopupSearchAccessibility
                                                                                                                                                                                                                                                                                                                                                                                               * @description : To enable the web content accessibility(WCAG) in the streaming nodes
                                                                                                                                                                                                                                                                                                                                                                                               *                NGPII-15056 - Bonds page - Ticker/ISIN field tag widgets not accessible using keyboard
                                                                                                                                                                                                                                                                                                                                                                                               * @dependencies: Jquery, KEYCODES
                                                                                                                                                                                                                                                                                                                                                                                               */
var PopupSearchAccessibility = /*#__PURE__*/function () {
  function PopupSearchAccessibility(options) {
    _classCallCheck(this, PopupSearchAccessibility);
    // #. Set accessibility config options
    this.options = options || {};
  }

  /**
   * @method init
   * @description Initialize the popup search accessibility
   * @public
   */
  _createClass(PopupSearchAccessibility, [{
    key: "init",
    value: function init() {
      this._start();
    }

    /**
     * @method _start
     * @description start the basic methods, assign attributes, bind key handler
     * @private
     */
  }, {
    key: "_start",
    value: function _start() {
      // #. check whether the search is multi-select or not
      if (this.options.multiSelect) {
        this._setMultiSelectAccessibility();
      }
    }

    /**
     * @method _setMultiSelectAccessibility
     * @description Initialize the multiselect popup search accessibility
     * @private
     */
  }, {
    key: "_setMultiSelectAccessibility",
    value: function _setMultiSelectAccessibility() {
      var _this = this;
      this.$tagContainer = $(this.options.container);
      this.$textInput = $(this.options.textField);
      this.tagSelector = '.popupsearch-tag';

      // #. Set the role to container element
      this.$tagContainer.attr('role', 'application');

      // #. bind keydown event to tag container element
      this.$tagContainer.on('keydown', this.tagSelector, function (event) {
        _this._onTagKeyHandler(event);
      });

      // #. bind keydown event to input element
      this.$textInput.on('keydown', function (event) {
        _this._oninputKeyHandler(event);
      });
    }

    /**
     * @method _setWCAGAttributes
     * @description seet necessary attributes to elements
     * @private
     */
  }, {
    key: "_setWCAGAttributes",
    value: function _setWCAGAttributes() {
      this.$tagContainer.find(this.tagSelector).attr({
        tabindex: 0
      });
    }

    /**
     * @method _onTagKeyHandler
     * @description key handler for the tag elements
     * @private
     */
  }, {
    key: "_onTagKeyHandler",
    value: function _onTagKeyHandler(event) {
      var keyCode = event.keyCode;
      var $activeTag = $(event.target);
      // #. ARROW-UP/LEFT will set the focus to previous tag
      // #. ARROW-DOWN/RIGHT will set the focus to next tag or text input
      // #. DELETE - will delete the item from the list
      if (keyCode === _keyCodes.default.ARROW_UP || keyCode === _keyCodes.default.ARROW_LEFT) {
        event.preventDefault();
        // #. get previous tag and set focus
        var $prevTag = $activeTag.prev(this.tagSelector);
        $prevTag.length > 0 && $prevTag.focus();
      } else if (keyCode === _keyCodes.default.ARROW_DOWN || keyCode === _keyCodes.default.ARROW_RIGHT) {
        event.preventDefault();
        var $nextTag = $activeTag.next(this.tagSelector);
        var $focusableEl = $nextTag.length > 0 ? $nextTag : this.$textInput;
        $focusableEl.focus();
      } else if (keyCode === _keyCodes.default.DELETE) {
        event.preventDefault();
        $activeTag.find('.remove').click();
      }
    }

    /**
     * @method _onInputKeyHandler
     * @description key handler for the input element
     * @private
     */
  }, {
    key: "_oninputKeyHandler",
    value: function _oninputKeyHandler(event) {
      var keyCode = event.keyCode;
      if (keyCode === _keyCodes.default.TAB && event.shiftKey || keyCode === _keyCodes.default.ARROW_UP || keyCode === _keyCodes.default.ARROW_LEFT) {
        event.preventDefault();
        // #. Set the attributes, inside the event because of new tag elements requires attributes
        this._setWCAGAttributes();
        // #. Handle the event
        this._onInputArrowEvent();
      }
    }

    /**
     * @method _onInputArrowEvent
     * @description on input element arrow events
     * @private
     */
  }, {
    key: "_onInputArrowEvent",
    value: function _onInputArrowEvent() {
      // #. Arrow left/up from input element will be set the focus to the last tag element
      this.$tagContainer.find(this.tagSelector).last().focus();
    }
  }]);
  return PopupSearchAccessibility;
}();
var _default = exports.default = PopupSearchAccessibility;

},{"util/enums/keyCodes":17}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * @class       : StreamingAccessibility
                                                                                                                                                                                                                                                                                                                                                                                               * @description : To enable the web content accessibility(WCAG) in the streaming nodes
                                                                                                                                                                                                                                                                                                                                                                                               *                NGPII-15978 - Enable accessibility in the ShowMessage(New Message) Icon
                                                                                                                                                                                                                                                                                                                                                                                               * @dependencies: Jquery, KEYCODES
                                                                                                                                                                                                                                                                                                                                                                                               * @references  : https://www.w3.org/TR/WCAG20-TECHS/
                                                                                                                                                                                                                                                                                                                                                                                               *                https://www.w3.org/TR/wai-aria-1.1/#tooltip
                                                                                                                                                                                                                                                                                                                                                                                               */
var StreamingAccessibility = /*#__PURE__*/function () {
  function StreamingAccessibility() {
    _classCallCheck(this, StreamingAccessibility);
    // #. To keep the news message button collection
    this.$newMessageButtons = [];
    // #. CSS selector of a new message icon element
    this.newsMessageSelector = 'a.newmessage';
  }

  /**
   * @method init
   * @description Initialize the streaming accessibility
   * @public
   */
  _createClass(StreamingAccessibility, [{
    key: "init",
    value: function init($node) {
      // #. Get news message button elements
      this.$newMessageButtons = this._findNewMessageButtons($node);
      this._start();
    }

    /**
     * @method update
     * @description Update the reloaded nodes with accessibility feature, same as init but a wrapper method
     * @public
     */
  }, {
    key: "update",
    value: function update($node) {
      // #. Get news message button elements
      this.$newMessageButtons = this._findNewMessageButtons($node);
      this._start();
    }

    /**
     * @method _start
     * @description start the basic methods, assign attributes, bind key handler
     * @private
     */
  }, {
    key: "_start",
    value: function _start() {
      // #. Check the count of the streaming nodes
      if (this.$newMessageButtons.length === 0) {
        return true;
      }

      // #. Set WCAG attributes
      this._setWCAGAttributes(this.$newMessageButtons);

      // #. Bind the keyboard accessibility event
      this._bindKeyHandler(this.$newMessageButtons);
    }

    /**
     * @method _findNewsMessageButtons
     * @description find the new message button collection from the streaming nodes collection
     * @param { HTMLCollectionOf } $nodes expecting streaming node element collection
     * @return { HTMLCollectionOf } new message button elements
     * @private
     */
  }, {
    key: "_findNewMessageButtons",
    value: function _findNewMessageButtons($nodes) {
      return $nodes.find(this.newsMessageSelector);
    }

    /**
     * @method _setWCAGAttributes
     * @description set WCAG attributes like aria-haspopup, aria-pressed to element
     * @param { HTMLCollectionOf }  { $elements } expecting html element collection
     * @private
     */
  }, {
    key: "_setWCAGAttributes",
    value: function _setWCAGAttributes($elements) {
      var hiddenTooltipContainer = $('<span></span>').attr('id', 'hiddenTooltipContainer').addClass('visuallyhidden');
      if ($('#hiddenTooltipContainer').length === 0) {
        $('body').append($(hiddenTooltipContainer));
      }
      $elements.attr({
        'aria-describedby': 'hiddenTooltipContainer'
      });

      // #. Apply role attribute to the parent table
      $elements.closest('td').attr({
        role: 'application'
      });

      // #. Update the title/arial-labelledby attributes
      this._updateShowMessageTitle($elements);
    }

    /**
     * @method _updateAttributes
     * @description update attribute of an element
     * @param { HTMLElement } $element expecting a html element
     * @param { Object } attributes expecting an object with updated attributes
     * @private
     */
  }, {
    key: "_updateAttributes",
    value: function _updateAttributes($element, attributes) {
      $element.attr(attributes);
    }

    /**
     * @method _bindKeyHandler
     * @description bind the keydown event and handle the event
     * @param { HTMLCollectionOf } $elements expecting html element collection
     * @private
     */
  }, {
    key: "_bindKeyHandler",
    value: function _bindKeyHandler($elements) {
      var _this = this;
      $elements.attr('tabindex', 0).on('keydown', function (event) {
        _this._onKeyHandlerUpdated(event);
      }).on('focus', function (event) {
        _this._onFocusHandlerUpdate(event);
      }).on('blur', function (event) {
        _this._onTabKeyPressed(event);
      });
    }

    /**
     * @method _onKeyHandlerUpdated
     * @description handle the keydown event
     * @param Event#keydown expecting keydown event object
     * @private
     */
  }, {
    key: "_onKeyHandlerUpdated",
    value: function _onKeyHandlerUpdated(event) {
      var keyCode = event.keyCode;
      if (keyCode === _keyCodes.default.TAB) {
        this._onTabKeyPressed(event);
      }
    }
  }, {
    key: "_onFocusHandlerUpdate",
    value: function _onFocusHandlerUpdate(event) {
      // #. Get the active element
      var $element = $(event.target);
      // #. Call the trigger event
      $element.attr({
        'aria-describedby': 'ngpTooltipNews'
      });
      this._triggerEvent($element, 'mouseover', event);
    }

    /**
     * @method _onTabKeyPressed
     * @description handle the tab key
     * @param Event#keydown expecting keydown event object
     * @private
     */
  }, {
    key: "_onTabKeyPressed",
    value: function _onTabKeyPressed(event) {
      // #. Get the active element
      var $element = $(event.target);
      // #. Call the trigger event
      this._triggerEvent($element, 'mouseout', event);
      $('#hiddenTooltipContainer').remove();
    }

    /**
     * @method _getStreamingContext
     * @description get streaming context if element is replaced with illustrate method
     * @param { HTMLElement } $element expecting current active element
     * @private
     */
  }, {
    key: "_getStreamingContext",
    value: function _getStreamingContext($element) {
      return $element.data('streaming-context');
    }

    /**
     * @method _triggerEvent
     * @description trigger event based on element environment
     * @param { HTMLElement } $element expecting current active element
     * @private
     */
  }, {
    key: "_triggerEvent",
    value: function _triggerEvent($element, eventName, event) {
      var streamingContext = this._getStreamingContext($element);
      /**
       * illustrateStreaming method from LastNewsFormatter replace the news message icon
       * mouseout event not available to this newly created element
       * keep the context as data attribute and invoke the hide tooltip method explicitly
       */
      if (streamingContext && streamingContext.hideInfo && eventName === 'mouseout') {
        streamingContext.hideInfo(event);
      } else {
        // #. Trigger the element event
        $element.trigger(eventName);
      }
    }

    /**
     * @method _updateShowMessageTitle
     * @description update show message title/arial-labelledby with the instrument name
     * @param { HTMLCollectionOf } $elements expecting collection of html element objects
     * @private
     */
  }, {
    key: "_updateShowMessageTitle",
    value: function _updateShowMessageTitle($elements) {
      var _iterator = _createForOfIteratorHelper($elements),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var $element = _step.value;
          $element = $($element);
          var title = this._getInstrumentNameByRow($element) || '';

          // #. Update the title with the instrument name in the row
          title = window.getMessage('title.streaming.showMessage', title);
          $element.attr('aria-label', title);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    /**
     * @method _getInstrumentNameByRow
     * @description get the instrument name by the element closest row
     * @param { HTMLElement } $element expecting an HTML element
     * @private
     */
  }, {
    key: "_getInstrumentNameByRow",
    value: function _getInstrumentNameByRow($element) {
      var $row = $($element.closest('tr'));
      return $row.find('a.instrumentIdentification').text() || $row.find('span.instrumentIdentification').text() || $row.find('input.searchPopupInput').val() || $row.find('a').first().text();
    }
  }]);
  return StreamingAccessibility;
}(); // #. Export the class
var _default = exports.default = StreamingAccessibility;

},{"util/enums/keyCodes":17}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * @name            : TableAccessibility
                                                                                                                                                                                                                                                                                                                                                                                               * @description     : To make the large table keyboard accessible when the accessibility prop true
                                                                                                                                                                                                                                                                                                                                                                                               * @dependencies    : Jquery, Large Table
                                                                                                                                                                                                                                                                                                                                                                                               * @ticket          : NGPII-15402
                                                                                                                                                                                                                                                                                                                                                                                               */ // #. Import references
var TableAccessibility = exports.default = /*#__PURE__*/function () {
  function TableAccessibility(options) {
    var _this = this;
    _classCallCheck(this, TableAccessibility);
    // #. Set the table instance from argument
    this.tableInstance = options.tableInstance;

    // #. Set accessibility config options
    this.options = options.config || {};

    // #. Prop to keep the container object
    this.$container = null;

    // #. Prop to keep the table object
    this.$table = null;

    // #. Init table accessibility
    this._initAccessibility();

    // #. Subscribe the large table load event
    $(window).on('largeTableLoaded', function () {
      _this._initAccessibility();
    });
  }

  /**
   * @name _updateTableInstance
   * @description Get latest table instance and related html objects
   * @private
   */
  _createClass(TableAccessibility, [{
    key: "_updateTableInstance",
    value: function _updateTableInstance() {
      // #. Store the table container
      this.$container = $("#".concat(this.tableInstance.tableId));

      // #. Store table element object
      this.$table = this.$container.find('table.list:visible').first();
    }

    /**
     * @name _initAccessibility
     * @description Init accessibility implementation
     * @private
     */
  }, {
    key: "_initAccessibility",
    value: function _initAccessibility() {
      // #. Get latest instances
      this._updateTableInstance();
      if (!this.$table || this.$table && this.$table.length === 0) {
        return;
      }

      // #. Set table focusable
      this._setTableFocusable();

      // #. Call the bind method
      this._bind();

      // #. Set screenreader attributes
      this.$table.closest('.largeTable').attr('role', 'application');
      this.$table.prepend($('<span />').attr('id', 'tableDescribedId').addClass('hideContainer').text(window.getMessage('news.table.description')));
      this.$table.attr('aria-describedby', 'tableDescribedId');
      this.$table.find('tbody tr').attr('role', 'button');
    }

    /**
     * @name _setTableFocusable
     * @description Set table element focusable, not by default
     * @private
     */
  }, {
    key: "_setTableFocusable",
    value: function _setTableFocusable() {
      this.$table.attr('tabindex', 0);
    }

    /**
     * @name _bind
     * @description Bind the keydown event to the table element
     * @private
     */
  }, {
    key: "_bind",
    value: function _bind() {
      var _this2 = this;
      // #. Flag key name to identify the event is already bind or not
      var key = 'keydown-bind';

      // #. Unbind event if already bind
      if (this.$table.data(key) === true) {
        this.$table.off('keydown');
      }

      // #. Bind the keydown event
      this.$table.on('keydown', function (event) {
        // #. Check custom keypress event available in the config
        var onKeyPressed = _this2.tableInstance.config.onKeyPressed;

        // #. Execute the custom keypress handler
        if (onKeyPressed && typeof onKeyPressed === 'function') {
          var result = onKeyPressed({
            event: event,
            table: _this2.$table
          });

          // #. Prevent further execution based on the result
          if (result === false) {
            return result;
          }
        }

        // #. Execute the keydown handler
        _this2._onKeyDown(event);
      }).data(key, true);
    }

    /**
     * name _onKeyDown
     * @description Handle the keydown event
     * @private
     */
  }, {
    key: "_onKeyDown",
    value: function _onKeyDown(event) {
      // #. Get keycode from the event
      var keyCode = event.keyCode || event.which;

      // #. Assign events based on the keycode
      switch (keyCode) {
        case _keyCodes.default.ARROW_DOWN:
          this._onArrowKeyDown(event);
          break;
        case _keyCodes.default.ARROW_UP:
          this._onArrowKeyUp(event);
          break;
        case _keyCodes.default.SPACE:
        case _keyCodes.default.ENTER:
          this._onEnterKeyPressed(event);
          break;
        default:
          return true;
      }
    }

    /**
     * name _onArrowKeyDown
     * @description Handle the arrow down key event
     * @private
     */
  }, {
    key: "_onArrowKeyDown",
    value: function _onArrowKeyDown(event) {
      event.preventDefault();

      // #. Get active row
      var $row = this._getSelectedRow();

      // #. Get first row when no active row found
      if ($row.length === 0) {
        $row = this._getFirstRow();
      } else {
        $row = $row.next('tr');

        // #. If current row is last row, set first row as active
        if (!$row || $row && $row.length === 0) {
          $row = this._getFirstRow();
        }
      }

      // #. Remove active row active state
      this._removeActiveState();

      // #. Set new row as active
      $row.addClass('active');
      $row.attr('tabindex', 0).focus();
    }

    /**
     * name _onArrowKeyUp
     * @description Handle the arrow up key event
     * @private
     */
  }, {
    key: "_onArrowKeyUp",
    value: function _onArrowKeyUp(event) {
      event.preventDefault();

      // #. Get active row
      var $row = this._getSelectedRow();

      // #. Get first row when no active row found
      if ($row.length === 0) {
        $row = this._getFirstRow();
      } else {
        $row = $row.prev('tr');

        // #. If current row is first row, set last row as active
        if (!$row || $row && $row.length === 0) {
          $row = this._getLastRow();
        }
      }

      // #. Remove active row active state
      this._removeActiveState();

      // #. Set new row as active
      $row.addClass('active');
      $row.attr('tabindex', 0).focus();
    }

    /**
     * name _onArrowKeyUp
     * @description Handle the arrow up key event
     * @private
     */
  }, {
    key: "_onEnterKeyPressed",
    value: function _onEnterKeyPressed(event) {
      // #. Get active row
      var $row = this._getSelectedRow();

      // #. Trigger the row click event
      if ($row.length > 0) {
        event.preventDefault();
        var $clickableEl = $row;

        // #. Find custom clickable element in the row
        if (this.options.triggerClickOn) {
          $clickableEl = $row.find(this.options.triggerClickOn);
        }

        // #. Trigger the click
        $clickableEl.trigger('click');
        window.setTimeout(function () {
          var newsContent = $('#newsarticlediv .newscontent').clone();
          var newsText = $.trim($(newsContent).text());
          $('#accessibleLiveNewsContainer').text(newsText);
        }, 500);
        window.setTimeout(function () {
          $('#accessibleLiveNewsContainer').text('');
        }, 1000);
      }
    }

    /**
     * name _getSelectedRow
     * @description Get active row from the table. Selector css class .active
     * @private
     */
  }, {
    key: "_getSelectedRow",
    value: function _getSelectedRow() {
      return this.$table.find('tbody').find('tr.active').first();
    }

    /**
     * name _getFirstRow
     * @description Get first row in the table
     * @private
     */
  }, {
    key: "_getFirstRow",
    value: function _getFirstRow() {
      return this.$table.find('tbody').find('tr:first');
    }

    /**
     * name _getLastRow
     * @description Get last row in the table
     * @private
     */
  }, {
    key: "_getLastRow",
    value: function _getLastRow() {
      return this.$table.find('tbody').find('tr:last');
    }

    /**
     * name _removeActiveState
     * @description Remove active css class from the row
     * @private
     */
  }, {
    key: "_removeActiveState",
    value: function _removeActiveState() {
      this.$table.find('tr.active').removeAttr('tabindex');
      this.$table.find('tr.active').removeClass('active');
    }
  }]);
  return TableAccessibility;
}();

},{"util/enums/keyCodes":17}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
var _tabmenuAccessibility = require("aria/tabmenuAccessibility");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * @class       : TooltipAccessibility
                                                                                                                                                                                                                                                                                                                                                                                               * @description : To enable the web content accessibility(WCAG) in ngp application tooltip views
                                                                                                                                                                                                                                                                                                                                                                                               *                - NGPII-15117 Keyboard: QuickView Panel
                                                                                                                                                                                                                                                                                                                                                                                               * @dependencies: Jquery
                                                                                                                                                                                                                                                                                                                                                                                               * @references  : https://www.w3.org/TR/wai-aria-practices-1.1/examples/accordion/accordion.html
                                                                                                                                                                                                                                                                                                                                                                                               */
var TooltipAccessibility = /*#__PURE__*/function () {
  function TooltipAccessibility(options) {
    _classCallCheck(this, TooltipAccessibility);
    // #. Keep the config/options into context
    this.options = options;

    // #. Active element Identity
    this.ACTIVE_ELEMENT = {
      PANEL: 1,
      CHART: 2,
      CLOSE_BUTTON: 3,
      FIRST_MENU_ITEM: 4,
      FIRST_HEADER_BUTTON: 5,
      NEWS: 6
    };

    // #. Quick view menu identity
    this.QUICK_VIEW_MENU = {
      CHART: '#quickViewMenu\\.chart',
      RATIO: '#quickViewMenu\\.ratios',
      NEWS: '#quickViewMenu\\.news'
    };

    // #. Session storage key
    this.sessionKey = 'quick-panel-status';
  }

  /**
   * @method init
   * @description Initialize the tooltip/tooltip-target accessibility
   * @public
   */
  _createClass(TooltipAccessibility, [{
    key: "$quickView",
    get:
    // #. Quick view container selector
    function get() {
      return $('#ngpQuickview');
    }

    // #. Keep the quick view header
  }, {
    key: "$quickViewHeader",
    get: function get() {
      return this.$quickView.find('#quickViewHeader');
    }

    // #. Keep the quick view body
  }, {
    key: "$quickViewBody",
    get: function get() {
      return this.$quickView.find('#quickViewBody');
    }

    // #. Get the active element from dom
  }, {
    key: "$activeElement",
    get: function get() {
      return $(document.activeElement);
    }

    // #. Get first menu item from the body
  }, {
    key: "$firstMenuItem",
    get: function get() {
      return this.$quickViewBody.find('.menuItem.first button');
    }

    // #. Get last menu item from the body
  }, {
    key: "$lastMenuItem",
    get: function get() {
      return this.$quickViewBody.find('.menuItem button').last();
    }

    // #. Get chart container
  }, {
    key: "$chartContainer",
    get: function get() {
      return this.$quickViewBody.find('.highcharts-container');
    }

    // #. News table
  }, {
    key: "$newsTable",
    get: function get() {
      return this.$quickViewBody.find('#news_table');
    }

    // #. Get all button elements from header
  }, {
    key: "$headerButtons",
    get: function get() {
      return this.$quickViewHeader.find('.menu li.link');
    }

    // #. Get first button element from header
  }, {
    key: "$firstHeaderButton",
    get: function get() {
      return this.$headerButtons.first();
    }

    // #. Get close button
  }, {
    key: "$closeButton",
    get: function get() {
      return this.$quickViewHeader.find('#quickViewClose');
    }

    // #. Get aria-describedby element for the target
  }, {
    key: "$descriptionElement",
    get: function get() {
      var id = 'quick-view-target-desc';
      var $element = $('body').find("#".concat(id));
      // #. no hint element found, create a new one
      if ($element.length === 0) {
        $element = $('<span></span>').attr({
          id: id
        }).addClass('visuallyhidden').appendTo('body');
      }
      return $element;
    }

    // #. get focus status from session storage
  }, {
    key: "panelFocusStatus",
    get: function get() {
      return sessionStorage ? sessionStorage.getItem(this.sessionKey) : '0';
    }

    // #. set focus status to session storage
    ,
    set: function set(value) {
      sessionStorage && sessionStorage.setItem(this.sessionKey, value);
    }
  }, {
    key: "init",
    value: function init() {
      if (this.options.target) {
        this._bindTargetAccessibility();
      } else if (this.options.container) {
        this._bindPanelAccessibility();
        this._addAccessibilityAttributes();
        this._bindMenuItemLinkKeyHandler();
      }
    }

    /**
     * @method _bindTargetAccessibility
     * @description bind accessibility to the tooltip target
     * @private
     */
  }, {
    key: "_bindTargetAccessibility",
    value: function _bindTargetAccessibility() {
      var _this = this;
      $(window.document).on('tooltip-target-focus', this.options.target.selector, function (event, data) {
        if (data && data.panelFocusStatus) {
          _this.panelFocusStatus = data.panelFocusStatus;
        }
        event.currentTarget.focus();
      });
      // #. bind target focus - to trigger the mouseenter
      $(window.document).on('focusin', this.options.target.selector, function (event) {
        if (String($(event.target).attr(_this.options.target.attr)).includes(_this.options.target.contains)) {
          var $target = $(event.target);
          // #. Update the panel description text
          _this.$descriptionElement.text(window.getMessage('quickview.target.shortcut.title', $target.text()));
          // #. Set the attributes to target
          $target.attr({
            role: 'application',
            'aria-describedby': _this.$descriptionElement.attr('id')
          });
          window.setTimeout(function () {
            event.preventDefault();
            var status = _this.panelFocusStatus;
            if (status !== '1') {
              $target.trigger('mouseenter');
            }
            _this.panelFocusStatus = '1';
          }, 50);
        }
      });

      // #. bind target focusout - to manage the hide attr
      $(window.document).on('focusout', this.options.target.selector, function (event) {
        _this.panelFocusStatus = '0';
      });

      // #. bind target keydown event
      $(window.document).on('keydown', this.options.target.selector, function (event) {
        if (String($(event.target).attr(_this.options.target.attr)).includes(_this.options.target.contains)) {
          _this._onTargetKeyHandler(event);
        }
      });
    }

    /**
     * @method _onTargetKeyHandler
     * @description handle keydown of the tooltip target
     * @param { KeyboardEvent } event: keydown event
     * @private
     */
  }, {
    key: "_onTargetKeyHandler",
    value: function _onTargetKeyHandler(event) {
      var keyCode = event.keyCode;

      // #. Handle the keydown
      // #. Tab - will hide the quick view panel
      // #. ARR-LEFT - will set the focus to quick view panel
      if (keyCode === _keyCodes.default.TAB) {
        this._hideTooltip(false);
      } else if (keyCode === _keyCodes.default.ARROW_RIGHT) {
        this.$quickView.attr({
          tabindex: 0
        }).focus();
        this._setPanelWCAGRoles();
      }
    }

    /**
     * @method _setPanelWCAGRoles
     * @description set WCAG roles to the panel elements
     * @private
     */
  }, {
    key: "_setPanelWCAGRoles",
    value: function _setPanelWCAGRoles() {
      // #. Update the quick view tab menu accessibility
      var $menu = this.$quickView.find('div.moduleTabMenu div.menu');
      $menu.find('button.icon').attr('role', 'tab');
      (0, _tabmenuAccessibility.setAriaAttributesToModuleTabMenu)($menu);

      // #. Set live region roles
      this.$quickView.find('.moduleContent').attr('aria-live', 'polite');
    }

    /**
     * @method _bindPanelAccessibility
     * @description bind quick view panel accessibility
     * @private
     */
  }, {
    key: "_bindPanelAccessibility",
    value: function _bindPanelAccessibility() {
      var _this2 = this;
      // #. unbind the previously added event
      this.$quickView.off('keydown');
      // #. Bind keydown
      this.$quickView.attr('role', 'tooltip');
      this.$quickView.on('keydown', function (event) {
        _this2._onPanelKeyHandler(event);
      });
    }

    /**
     * @method _addAccessibilityAttributes
     * @description add necessary attributes to panel elements
     * @private
     */
  }, {
    key: "_addAccessibilityAttributes",
    value: function _addAccessibilityAttributes() {
      var _iterator = _createForOfIteratorHelper(this.$headerButtons),
        _step;
      try {
        var _loop = function _loop() {
          var $button = _step.value;
          $button = $($button);
          $button.attr({
            tabindex: 0,
            role: 'button'
          });

          // #. set the default pressed value
          $button.attr('aria-pressed', $button.hasClass('selected'));

          // Handle pressed attr on click event
          $button.on('click', function (event) {
            $button.attr('aria-pressed', $button.hasClass('selected'));
          });
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    /**
     * @method _bindMenuItemLinkKeyHandler
     * @description trigger menu item link click by using keyboard
     * @private
     */
  }, {
    key: "_bindMenuItemLinkKeyHandler",
    value: function _bindMenuItemLinkKeyHandler() {
      this.$headerButtons.on('keydown', function (event) {
        var keyCode = event.keyCode;
        if (keyCode === _keyCodes.default.SPACE || keyCode === _keyCodes.default.ENTER) {
          event.preventDefault();
          $(event.target).click();
        }
      });
    }

    /**
     * @method _onPanelKeyHandler
     * @description panel keydown event handler
     * @param { KeyboardEvent } event: keydown event
     * @private
     */
  }, {
    key: "_onPanelKeyHandler",
    value: function _onPanelKeyHandler(event) {
      var keyCode = event.keyCode;
      switch (keyCode) {
        case _keyCodes.default.TAB:
          this._onPanelTabKeyPressed(event);
          break;
        case _keyCodes.default.ARROW_LEFT:
        case _keyCodes.default.ESCAPE:
          this._hideTooltip(true);
          break;
        case _keyCodes.default.ARROW_DOWN:
          this._onPanelArrowDownPressed(event);
          break;
        case _keyCodes.default.ARROW_UP:
          this._onPanelArrowUpPressed(event);
          break;
      }
    }

    /**
     * @method _onPanelTabKeyPressed
     * @description handle tab key
     * @param { KeyboardEvent } event: keydown event
     * @private
     */
  }, {
    key: "_onPanelTabKeyPressed",
    value: function _onPanelTabKeyPressed(event) {
      var identity = this._getActiveElementIdentity();
      var result = false;
      switch (identity) {
        case this.ACTIVE_ELEMENT.PANEL:
          event.preventDefault();
          this._setFocusToActiveItemPart(false);
          break;
        case this.ACTIVE_ELEMENT.CHART:
          event.preventDefault();
          this.$chartContainer.blur();
          if (!event.shiftKey) {
            this._setFocusToRatio();
          } else {
            this.$lastMenuItem.focus();
          }
          break;
        case this.ACTIVE_ELEMENT.NEWS:
          event.preventDefault();
          if (!event.shiftKey) {
            this.$firstHeaderButton.focus();
          } else {
            this._setFocusToRatio(true);
          }
          break;
        case this.ACTIVE_ELEMENT.CLOSE_BUTTON:
          if (!event.shiftKey) {
            event.preventDefault();
            this._setFocusToActiveItemPart(false);
          }
          break;
        case this.ACTIVE_ELEMENT.FIRST_MENU_ITEM:
          result = true;
          if (event.shiftKey) {
            event.preventDefault();
            this.$closeButton.focus();
            result = false;
          }
          break;
        case this.ACTIVE_ELEMENT.FIRST_HEADER_BUTTON:
          if (event.shiftKey) {
            event.preventDefault();
            this._setFocusToActiveItemPart(true);
          }
          break;
        default:
          result = true;
          break;
      }
      return result;
    }

    /**
     * @method _onPanelArrowUpPressed
     * @description handle panel arrow up key
     * @param { KeyboardEvent } event: keydown event
     * @private
     */
  }, {
    key: "_onPanelArrowUpPressed",
    value: function _onPanelArrowUpPressed(event) {
      var identity = this._getActiveElementIdentity();
      if (identity === this.ACTIVE_ELEMENT.NEWS) {
        event.preventDefault();
        // #. Get active row
        var $activeRow = this.$activeElement;
        // #. Get all table rows except header
        var $rows = this.$newsTable.find('tr').not(':first');
        // #. Variable to keep the previous row
        var $row = null;
        // 1. If no rows selected yet, focus to last row
        // 2. If row is first row then, last row will select
        // 3. prev - select the previous row
        if (!$activeRow.is('tr')) {
          $row = $rows.last();
        } else if ($activeRow.is('tr')) {
          if ($activeRow.is($rows.first())) {
            $row = $rows.last();
          } else {
            $row = $activeRow.prev();
          }
        }
        if ($row) {
          $row.focus();
        }
      }
    }

    /**
     * @method _onPanelArrowDownPressed
     * @description handle arrow down key
     * @param { KeyboardEvent } event: keydown event
     * @private
     */
  }, {
    key: "_onPanelArrowDownPressed",
    value: function _onPanelArrowDownPressed(event) {
      var identity = this._getActiveElementIdentity();
      // #. Handle news table arrow down
      if (identity === this.ACTIVE_ELEMENT.NEWS) {
        event.preventDefault();
        // #. Get active row
        var $activeRow = this.$activeElement;
        // #. Get all table rows except header
        var $rows = this.$newsTable.find('tr').not(':first');
        // #. Variable to keep the next row
        var $row = null;
        // 1. If no rows selected yet, focus to first row
        // 2. If row is last row then, first row will select
        // 3. next - select next row
        if (!$activeRow.is('tr')) {
          $row = $rows.first();
        } else if ($activeRow.is('tr')) {
          if ($activeRow.is($rows.last())) {
            $row = $rows.first();
          } else {
            $row = $activeRow.next();
          }
        }
        if ($row) {
          $row.focus();
        }
      }
    }

    /**
    * @method _hideTooltip
    * @description hide the tooltip panel
    * @param { boolean } setFocusToTarget: to identify set focus to target element
    * @private
    */
  }, {
    key: "_hideTooltip",
    value: function _hideTooltip(setFocusToTarget) {
      this.$closeButton.trigger('click');
      if (this.options.$target) {
        var $target = $(this.options.$target);
        if (setFocusToTarget) {
          this.panelFocusStatus = '1';
          $target.focus();
        }
      }
    }

    /**
     * @method _getActiveElementIdentity
     * @description get active element identity
     * @private
     */
  }, {
    key: "_getActiveElementIdentity",
    value: function _getActiveElementIdentity() {
      var $activeElement = this.$activeElement;
      if ($activeElement.is(this.$quickView)) {
        return this.ACTIVE_ELEMENT.PANEL;
      } else if ($activeElement.is(this.$closeButton)) {
        return this.ACTIVE_ELEMENT.CLOSE_BUTTON;
      } else if ($activeElement.is(this.$firstMenuItem)) {
        return this.ACTIVE_ELEMENT.FIRST_MENU_ITEM;
      } else if ($activeElement.is(this.$chartContainer) || $activeElement.closest(this.$chartContainer).length > 0 || $activeElement.closest('.chartImageBox').length > 0) {
        return this.ACTIVE_ELEMENT.CHART;
      } else if ($activeElement.is(this.$firstHeaderButton)) {
        return this.ACTIVE_ELEMENT.FIRST_HEADER_BUTTON;
      } else if ($activeElement.is(this.$newsTable) || $activeElement.closest(this.$newsTable).length > 0) {
        return this.ACTIVE_ELEMENT.NEWS;
      }
    }

    /**
     * @method _getFirstSelectedPart
     * @description get first selected parts identity
     * @private
     */
  }, {
    key: "_getFirstSelectedPart",
    value: function _getFirstSelectedPart() {
      var selected = 'selected';
      if (this.$quickViewHeader.find(this.QUICK_VIEW_MENU.CHART).hasClass(selected)) {
        return this.QUICK_VIEW_MENU.CHART;
      } else if (this.$quickViewHeader.find(this.QUICK_VIEW_MENU.RATIO).hasClass(selected)) {
        return this.QUICK_VIEW_MENU.RATIO;
      } else if (this.$quickViewHeader.find(this.QUICK_VIEW_MENU.NEWS).hasClass(selected)) {
        return this.QUICK_VIEW_MENU.NEWS;
      }
    }

    /**
     * @method _getLastSelectedPart
     * @description get last selected parts identity
     * @private
     */
  }, {
    key: "_getLastSelectedPart",
    value: function _getLastSelectedPart() {
      var selected = 'selected';
      if (this.$quickViewHeader.find(this.QUICK_VIEW_MENU.NEWS).hasClass(selected)) {
        return this.QUICK_VIEW_MENU.NEWS;
      } else if (this.$quickViewHeader.find(this.QUICK_VIEW_MENU.RATIO).hasClass(selected)) {
        return this.QUICK_VIEW_MENU.RATIO;
      } else if (this.$quickViewHeader.find(this.QUICK_VIEW_MENU.CHART).hasClass(selected)) {
        return this.QUICK_VIEW_MENU.CHART;
      }
    }

    /**
     * @method _setFocusToActiveItemPart
     * @description set focus to the first active item in the panel
     * @param { Boolean } chooseLastPart - to identify the last/first part
     * @private
     */
  }, {
    key: "_setFocusToActiveItemPart",
    value: function _setFocusToActiveItemPart(chooseLastPart) {
      var partId = chooseLastPart ? this._getLastSelectedPart() : this._getFirstSelectedPart();
      switch (partId) {
        case this.QUICK_VIEW_MENU.CHART:
          if (chooseLastPart) {
            this._setFocusToChart();
          } else {
            this._setFocusToChartMenuItem();
          }
          break;
        case this.QUICK_VIEW_MENU.NEWS:
          this._setFocusToNews();
          break;
        case this.QUICK_VIEW_MENU.RATIO:
          this._setFocusToRatio(chooseLastPart);
          break;
        default:
          this.$firstHeaderButton.focus();
          break;
      }
    }

    /**
     * @method _setFocusToChartMenuItem
     * @description set focus to the chart menu item in the body
     * @private
     */
  }, {
    key: "_setFocusToChartMenuItem",
    value: function _setFocusToChartMenuItem() {
      this.$firstMenuItem.focus();
    }

    /**
     * @method _setFocusToNews
     * @description set focus to news table
     * @private
     */
  }, {
    key: "_setFocusToNews",
    value: function _setFocusToNews() {
      this._setNewsTableAccessibility();
      this.$newsTable.focus();
    }

    /**
     * @method _setFocusToRatio
     * @description ration view has no focusable elements, so focus may set to news or header buttons
     * @param { boolean } isShiftKey: identify shift key pressed or not
     * @private
     */
  }, {
    key: "_setFocusToRatio",
    value: function _setFocusToRatio(isShiftKey) {
      var selected = 'selected';
      if (isShiftKey) {
        if ($(this.QUICK_VIEW_MENU.CHART).hasClass(selected)) {
          this._setFocusToChart();
        } else {
          this.$closeButton.focus();
        }
      } else {
        // #. 1. If news selected - focus will be set to news table
        // #. 2. else the focus set to quick view chart button element
        if ($(this.QUICK_VIEW_MENU.NEWS).hasClass(selected)) {
          this._setFocusToNews();
        } else {
          this.$firstHeaderButton.focus();
        }
      }
    }

    /**
     * @method _setFocusToChart
     * @description set focus to the chart container
     * @private
     */
  }, {
    key: "_setFocusToChart",
    value: function _setFocusToChart() {
      this.$chartContainer.focus();
    }

    /**
     * @method _setNewsTableAccessibility
     * @description set news table accessibility
     * @private
     */
  }, {
    key: "_setNewsTableAccessibility",
    value: function _setNewsTableAccessibility() {
      // #. Set table
      this.$newsTable.attr({
        tabindex: 0
      });
      this.$newsTable.parent().attr({
        role: 'application'
      });

      // #. Set table row
      this.$newsTable.find('tr').attr({
        tabindex: 0,
        role: 'button'
      });
    }
  }]);
  return TooltipAccessibility;
}();
var _default = exports.default = TooltipAccessibility;

},{"aria/tabmenuAccessibility":11,"util/enums/keyCodes":17}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAriaAttributesToModuleTabMenu = void 0;
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * set aria attributes to moduletabmenus
 */
var setAriaAttributesToModuleTabMenu = exports.setAriaAttributesToModuleTabMenu = function setAriaAttributesToModuleTabMenu($menu) {
  var moduleTabMenus = $menu || $('div.moduleTabMenu div.menu');
  setAttributes(moduleTabMenus);
};

/**
 * set aria attributes to tablist and tabpanel for all tab menus on the page with tab buttons inside
 * @param menus
 */
var setAttributes = function setAttributes(menus) {
  $(menus).each(function (index, menu) {
    if ($(menu).find('button.icon').length > 0) {
      setAttributesToTablist(menu);
    }
  });
};

/**
 * set attributes to module tab menu elements by given tab menu
 * @param menu
 */
var setAttributesToTablist = function setAttributesToTablist(menu) {
  // todo get module title without timeout
  window.setTimeout(function () {
    // timeout because of loading... text at the beginning
    var moduleTitle = $(menu).closest('div.module').find('div.moduleHeader h2');
    $(menu).attr('role', 'tablist');
    $(menu).attr('aria-label', $(moduleTitle).text());
  }, 2000);
  setAriaAttributesToButtons($(menu));
};

/**
 * set attributes to tab buttons to given tab menu
 * @param menu
 */
var setAriaAttributesToButtons = function setAriaAttributesToButtons(menu) {
  var tabMenu = menu;
  var menuItems = $(tabMenu).find('div.menuItem');
  $(tabMenu).find('button').each(function (index, button) {
    $(button).attr('role', 'tab').attr('aria-selected', false).on('keydown', function (e) {
      if (e.keyCode === _keyCodes.default.ENTER || e.keyCode === _keyCodes.default.SPACE) {
        updateTabButtons(tabMenu, e.target);
      }
    }).on('click', function (e) {
      updateTabButtons(tabMenu, e.target);
    });
  });
  $(menuItems).each(function (index, item) {
    if ($(item).hasClass('on')) {
      setTabButtonSelected($(item).find('button'));
      return true;
    }
  });
};

/**
 * update attributes of tab buttons
 * @param menu
 * @param pressedBtn
 */
var updateTabButtons = function updateTabButtons(menu, pressedBtn) {
  var menuItemButtons = $(pressedBtn).parent('.menuItem').parent().find('> .menuItem button');
  menuItemButtons.attr('aria-selected', false).removeAttr('tabindex');
  setTabButtonSelected(pressedBtn);
};

/**
 * set given button as selected
 * @param button
 */
var setTabButtonSelected = function setTabButtonSelected(button) {
  $(button).attr({
    'aria-selected': true,
    tabindex: -1
  });
};

},{"util/enums/keyCodes":17}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerMessages = exports.getMessage = exports.addMessage = void 0;
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/** @module messages/messageHandler */

//use an object in window as cache, in order to prevent multiple instances of the cache
window.__messagesCache = window.__messagesCache || {};
var messages = window.__messagesCache;

/**
 * adds a message object with key value pairs for translation
 * @param {Object} msg
 */
var registerMessages = exports.registerMessages = function registerMessages(msg) {
  Object.assign(messages, msg);
};

/**
 * adds a message to the global message cache for translation
 * @param {string} key
 * @param {string} value
 */
var addMessage = exports.addMessage = function addMessage(key, value) {
  messages[key] = value;
};

/**
 * translates a given key and replaces {0}..{n} with the respective replacements
 * @param {string} key
 * @param {...string} replacements
 * @returns {string}
 * @example
 * addMessage('example', 'example {0} of {1}')
 * getMessage('example', '4', 'many');
 * // --> 'example 4 of many'
 * getMessage('example', ['2', '6']);
 * // --> 'example 2 of 6'
 */
var getMessage = exports.getMessage = function getMessage(key) {
  var _ref;
  for (var _len = arguments.length, replacements = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    replacements[_key - 1] = arguments[_key];
  }
  replacements = (_ref = []).concat.apply(_ref, _toConsumableArray(replacements));
  var message = messages[key] || key.split('.').reduce(function (all, a) {
    return a;
  }, '');
  message = message.replace(/\{(\d)\}/g, function (match, id) {
    return replacements[+id] != null ? replacements[+id] : match;
  });
  return message;
};
window.registerMessages = registerMessages;
window.getMessage = getMessage;
window.addMessage = addMessage;

},{}],13:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Table = _interopRequireDefault(require("tables/Table"));
var _TableAccessibility = _interopRequireDefault(require("accessibility/TableAccessibility.inc"));
var _Accessibility = _interopRequireDefault(require("accessibility/Accessibility"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/*
 *
 * @param {} element
 * @param {} config
 */
var LargeTable = function LargeTable(element, config) {
  LargeTable.superclass.constructor.call(this, element, window.largeTableGetData(element), config);
  /*
   * the large table has been updated e.g. by paging
   *
   * @event window.YAHOO.util.CustomEvent.FLAT
   * @type window.YAHOO.util.CustomEvent
   */
  this.tableUpdated = new window.YAHOO.util.CustomEvent('tableUpdated', this, false, window.YAHOO.util.CustomEvent.LIST);
};
window.YAHOO.lang.extend(LargeTable, _Table.default, {
  /*
   * fire the tableUpdated event
   *
   * @private
   */
  fireTableUpdate: function fireTableUpdate() {
    this.refresh();
    this.data = window.largeTableGetData(this.element);
    this.tableUpdated.fire();
  },
  refresh: function refresh(init) {
    window.YAHOO.fcom.LargeTable.superclass.refresh.call(this, init);
    // listen to the update event of the table element
    window.YAHOO.util.Event.addListener(this.element, 'largeTableUpdate', window.YAHOO.fcom.Util.createDelegate(this.fireTableUpdate, this));

    // #. Invoke table accessibility module
    if (this.config && this.config.accessibility) {
      var accessibility = _typeof(this.config.accessibility) === 'object' ? this.config.accessibility.enabled : this.config.accessibility;
      if (accessibility === true) {
        new _TableAccessibility.default({
          tableInstance: this,
          config: _typeof(this.config.accessibility) === 'object' ? this.config.accessibility : null
        });
      }
    }

    // #. Activate the accordion accessibility
    var $toggle = $(this.element).find('button.toggleBar');
    if ($toggle.length > 0) {
      _Accessibility.default.init({
        accordion: {
          container: $(this.element).parent(),
          toggleSelector: 'button.toggleBar',
          findPanelBy: {
            method: 'parent parent next'
          }
        }
      });
    }
  }
});
var _default = exports.default = LargeTable;

},{"accessibility/Accessibility":1,"accessibility/TableAccessibility.inc":9,"tables/Table":15}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _LargeTable = _interopRequireDefault(require("tables/LargeTable"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*
 * Factory that creates Large instances. Further it provides a save way to set up event listeners even before the instances are created.
 *
 * @type
 */
var LargeTableFactory = function LargeTableFactory() {
  /*
  * map collecting all instances
  *
  * @private
  * @type
  */
  this.instanceMap = {};

  /*
   * map containing the listeners for each instance
   *
   * @private
   * @type
   */
  this.listenerMap = {};
};

/*
 * Create a new instance of type window.YAHOO.fcom.LargeTable.
 *
 * @param {String} id
 * @param {Object} config object for LargeTable
 */
LargeTableFactory.prototype.createLargeTable = function (id, config) {
  this.cleanUp(id);
  // wait until the document was initialized
  window.YAHOO.fcom.Page.onReady(function (config, custom) {
    var _this = this;
    var instance = new _LargeTable.default(custom.id, custom.config);
    this.instanceMap[custom.id] = instance;

    // subscribe all events
    [instance.mouseoverRowEvent, instance.mouseoutRowEvent, instance.tableUpdated, instance.selectionChanged, instance.rowClickedEvent, instance.tableReady, instance.activeRowChanged].forEach(function (event) {
      return event.subscribe(_this.onCustomEvent, custom.id, _this);
    });
    instance.tableReady.fire(instance);
  }, {
    id: id,
    config: config
  }, this);
};
LargeTableFactory.prototype.cleanUp = function (id) {
  delete this.listenerMap[id];
};

/*
 * Add an event listener to the InstrumentList with specified id. The handler will be called like from CustomEvent.LIST with the following arguments:
 * eventType, array of arguments passed on fire, customObj. Available events are:
 * <tt>tableReady, mouseoverRow, mouseoutRow, selectionChanged, rowClicked, activeRowChanged</tt>.
 *
 * @param {String} id
 * @param {String} event
 * @param {Function} handler
 * @param {Object} customObj
 * @param {Boolean} override
 * @param {Boolean} executeOnce
 */
LargeTableFactory.prototype.addListener = function (id, event, handler, customObj, override, executeOnce) {
  if (!this.listenerMap[id]) {
    this.listenerMap[id] = {};
  }
  if (!this.listenerMap[id][event]) {
    this.listenerMap[id][event] = [];
  }
  this.listenerMap[id][event].push({
    handler: handler,
    customObj: customObj,
    override: override,
    executeOnce: executeOnce
  });
  if (event === 'tableReady' && this.instanceMap[id]) {
    this.instanceMap[id].tableReady.fire(this.instanceMap[id]);
  }
};

/*
 * @private
 * @param {String} event
 * @param {Array} args
 * @param {String} id
 */
LargeTableFactory.prototype.onCustomEvent = function (event, args, id) {
  var toRemove = [];
  if (this.listenerMap[id]) {
    if (this.listenerMap[id][event]) {
      for (var i = 0; i < this.listenerMap[id][event].length; i++) {
        this.notifyListener(this.listenerMap[id][event][i], event, args);
        if (this.listenerMap[id][event][i].executeOnce === true) {
          toRemove.push(i);
        }
      }
      for (var _i = 0; _i < toRemove.length; _i++) {
        this.listenerMap[id][event].splice(toRemove[_i], 1);
      }
    }
  }
};

/*
 * @private
 * @param {Object} listener
 * @param {Array} args
 */
LargeTableFactory.prototype.notifyListener = function (listener, event, args) {
  var scope = listener.override === true ? listener.customObj : listener.override;
  listener.handler.call(scope, event, args, listener.customObj);
};

/*
 * get an instrument list by its id
 *
 * @param {String} id
 * @return {YAHOO.fcom.Table}
 */
LargeTableFactory.prototype.getInstance = function (id) {
  return this.instanceMap[id];
};
var _default = exports.default = LargeTableFactory;

},{"tables/LargeTable":13}],15:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _flatten = _interopRequireDefault(require("lodash/flatten"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*
 * Creates a scriptable object for a table containing data. The class provides access to the table's events, like change of selection or the table being updated
 * over ajax.
 *
 * @param element {HTMLElement|String}
 * @param data {Array}
 * @param config {Object}
 */
var Table = function Table(element, data, config) {
  this.config = Object.assign({
    markActive: false,
    inactivate: false
  }, config || {});

  /*
   * the id of the large table html element
   *
   * @type String
   * @property
   */
  this.tableId = element.id || element;

  /*
   * the large table's element
   *
   * @type HTMLElement
   * @property
   */

  /*
   * The table elements of this large table. In case of multi column tables, this list can have more than 1 entry
   *
   * @type Array
   * @property
   */

  /*
   * The table's data as a list of rows. The rows are accessable by the key fidlet names
   *
   * @type Array
   */
  this.data = data;

  /*
   * The table's selection as a list of rows. The rows are accessable by the key fidlet names
   */
  this.selectedData = [];

  /*
   * The row that is highlighted as active
   *
   * @type HTMLElement
   */
  this.activeRow;

  /*
   * Stores a map of data of the last active row. This is needed, as the row might be removed from the dom, due to large table updates.
   *
   * @type Object
   */
  this.activeData = {};

  /*
   * selection of this table changed listener function will be called with following arguments
   *
   * @argument {String} eventType
   * @argument {Object} selection the selection containing following properties
   * <ul>
   * <li> {Array} selectedElements list of elements that was selected or unselected
   * <li> {Boolean} selected whether the elements were selected or unselected
   * <li> {Array} selection - the current selection as array. Each list item is a map, KeyFidlet names are used as keys
   * </ul>
   * @argument {Object} customObject of the event handler
   * @event window.YAHOO.util.CustomEvent.FLAT
   * @type window.YAHOO.util.CustomEvent
   */
  this.selectionChanged = new window.YAHOO.util.CustomEvent('selectionChanged', this, false, window.YAHOO.util.CustomEvent.LIST);

  /*
   * LargeTable instance is initialized Handler will be called with the LargeTable instance as argument.
   *
   * @event window.YAHOO.util.CustomEvent.FLAT
   * @type window.YAHOO.util.CustomEvent
   */
  this.tableReady = new window.YAHOO.util.CustomEvent('tableReady', this, false, window.YAHOO.util.CustomEvent.LIST);

  /*
   * event is fired when there was a mouse over a row. The handler function will receive an array as second parameter that includes the row data of that row.
   *
   * @event
   * @type window.YAHOO.util.CustomEvent.LIST
   */
  this.mouseoverRowEvent = new window.YAHOO.util.CustomEvent('mouseoverRow', this, false, window.YAHOO.util.CustomEvent.LIST);

  /*
   * event is fired when there was a mouse over a row. The handler function will receive an array as second parameter that includes the row data
   *
   * @event
   * @type window.YAHOO.util.CustomEvent.LIST
   */
  this.mouseoutRowEvent = new window.YAHOO.util.CustomEvent('mouseoutRow', this, false, window.YAHOO.util.CustomEvent.LIST);

  /*
   * Event is fired when a row was clicked. The row element is passed as first argument to the handler. Second argument is the row data as map.
   *
   * @event
   * @type window.YAHOO.util.CustomEvent.LIST
   */
  this.rowClickedEvent = new window.YAHOO.util.CustomEvent('rowClicked', this, false, window.YAHOO.util.CustomEvent.LIST);

  /*
   * Event is fired when the active row was changed. The row element is passed as first argument to the handler. Second argument is the row data as map.
   */
  this.activeRowChanged = new window.YAHOO.util.CustomEvent('activeRowChanged', this, false, window.YAHOO.util.CustomEvent.LIST);

  /*
   * containing a list of type window.YAHOO.fcom.Checkbox
   *
   * @property
   * @type Array
   */
  this.checkboxes = [];

  /*
   * the select all checkbox
   *
   * @type window.YAHOO.fcom.Checkbox
   * @property
   */
  this.selectAllCheckbox;

  // initialize data and selection properties
  this.refresh(true);
};

/*
 * @private
 * @param {Event} event
 * @param {HTMLFormElement} checkbox
 */
Table.prototype.checkBoxChangedHandler = function (event, checkbox) {
  this.selectionChanged.fire({
    selectedElements: [this.getDataForRow(this.getRowForElement(checkbox))],
    selected: checkbox.checked,
    selection: this.getSelection()
  });
};

/*
 * @private
 */
Table.prototype.checkBoxAllChangedHandler = function () {
  var selected = this.selectAllCheckbox.domNode.checked;
  var selection = selected ? this.data : [];
  this.selectionChanged.fire({
    selectedElements: this.data,
    selected: selected,
    selection: selection
  });
};

/*
 * refresh the table's current data and selection
 *
 * @private
 */
Table.prototype.refresh = function () {
  var _this = this;
  if (this.element) {
    window.YAHOO.util.Event.purgeElement(this.element);
  }
  this.element = window.YAHOO.util.Dom.get(this.tableId);
  if (!this.element) {
    // empty module
    return;
  }

  /*
   * Actually the Large Table can have multiple table elements. So keep in mind we are dealing with arrays here.
   *
   * @property
   * @type Array
   */
  this.tableElements = this.element.tagName.toLowerCase() === 'table' ? [this.element] : $(this.element).find('table').get();

  // add click listener for rows
  window.YAHOO.util.Event.addListener(this.element, 'click', function (event) {
    var target = window.YAHOO.util.Event.getTarget(event);
    var row = $(target).parents('tr').get(0);
    if (row && window.YAHOO.util.Dom.isAncestor(this.element, row)) {
      this.markActive(row);
      this.rowClickedEvent.fire(row, this.getDataForRow(row));
    }
  }, this, true);
  this.selectedData = this.tableElements.reduce(function (all, element) {
    all.concat(window.largeTableSelected(element));
    return all;
  }, []);

  // remove old checkbox listeners
  this.checkboxes.forEach(function (checkbox) {
    return window.YAHOO.util.Event.purgeElement(checkbox);
  });

  // add listeners to checkboxes (must be re-added after table update)
  this.checkboxes = [];
  this.tableElements.map(function (tableElement) {
    return window.largeTableGetCheckboxes(tableElement) || [];
  }).forEach(function (checkboxes) {
    checkboxes.forEach(function (checkbox) {
      _this.checkboxes.push(window.domToYUIMap[checkbox.name]);
      window.YAHOO.util.Event.addListener(checkbox, 'change', window.YAHOO.fcom.Util.createDelegate(_this.checkBoxChangedHandler, _this), checkbox);
    });
  });
  this.selectAllCheckbox = window.domToYUIMap["".concat(this.element.id, "_largeTableAllSelector")] || $("#".concat(this.element.id, "_largeTableAllSelector"));
  if (this.selectAllCheckbox) {
    window.YAHOO.util.Event.addListener(this.selectAllCheckbox.domNode, 'change', window.YAHOO.fcom.Util.createDelegate(this.checkBoxAllChangedHandler, this), this.selectAllCheckbox.domNode);
  }
  var handleEvent = function handleEvent(eventReference) {
    return function (event) {
      var target = window.YAHOO.util.Event.getTarget(event);
      var id = _this.element.id;
      var row = $(target).parents("div#".concat(id, " table.list tr, table#").concat(id, " tr")).get(0);
      if (row) {
        var value = _this.getDataForRow(row);
        var coords = {
          x: window.YAHOO.util.Event.getPageX(event),
          y: window.YAHOO.util.Event.getPageY(event)
        };
        eventReference.fire(value, coords);
      }
    };
  };
  YAHOO.util.Event.addListener(this.element, 'mouseover', handleEvent(this.mouseoverRowEvent));
  YAHOO.util.Event.addListener(this.element, 'mouseout', handleEvent(this.mouseoutRowEvent));
};

/*
 * Returns all selected elements of the table. Each element is a map that can be accessed by
 *
 * <pre>
 * KeyFidlet
 * </pre>
 *
 * names.
 *
 * @return Array of selected rows
 */
Table.prototype.getSelection = function () {
  var values = this.tableElements.map(function (element) {
    return window.largeTableSelected(element);
  });
  return (0, _flatten.default)(values);
};

/*
 * Returns the values for all selected elements for the given key.
 *
 * @param key {String}
 * @return Array of values for given key for selected rows
 */
Table.prototype.getSelectedValues = function (key) {
  var values = this.tableElements.map(function (element) {
    return window.largeTableSelected(element, key);
  });
  return (0, _flatten.default)(values);
};

/*
 * Retrieve the data associated with a certain table row. If the key parameter is passed, only the value for the key is returned. Otherwise a map is
 * returned, containing all values.
 *
 * @param {HTMLElement} row
 * @param {String} key
 */
Table.prototype.getDataForRow = function (row, key) {
  var item = this.data[this.getRowIndex(row)];
  return key ? item[key] : item;
};

/*
 * The index for the row element. or -1 if not found.
 *
 * @param row {HTMLElement}
 */
Table.prototype.getRowIndex = function (row) {
  return this.getRows().findIndex(function (f) {
    return f === row;
  });
};

/*
 *
 * @param index {Number}
 */
Table.prototype.getRowByIndex = function (index) {
  return this.getRows()[index] || null;
};
Table.prototype.getRowForElement = function (element) {
  return $(element).parents('tr').get(0);
};
Table.prototype.getRows = function () {
  return $(this.tableElements).find('tbody tr').filter(function (i, e) {
    return !$(e).find('th, [colspan]').not('[colspan=1]').length;
  }).get();
};

/*
 * Returns all row elements that match the key/value pair.
 *
 * @param {String} key
 * @param {String} value
 * @return {Array} of HTMLElements (tr element). Returns an empty array if no rows were found.
 */
Table.prototype.findRows = function (key, value) {
  var _this2 = this;
  return this.getRows().filter(function (row, i) {
    return _this2.data[i][key] === value;
  });
};

/*
 * highlight all table rows that match the supplied key
 *
 * @param {String} key
 * @param {String} value
 * @param {Boolean} highlight
 */
Table.prototype.hover = function (key, value, highlight) {
  var rows = this.findRows(key, value);
  $(rows).toggleClass('hover', highlight);
};

/*
 * Mark an row as active. Therefore it reveives the css class "active". Only one row can be active.
 *
 * @param row {HTMLElement}
 */
Table.prototype.markActive = function (row, silent) {
  if (this.config.markActive && row) {
    if (this.activeRow) {
      $(this.activeRow).removeClass('active');
    }
    if (this.activeRow === row && this.config.inactivate) {
      this.activeRow = null;
      this.activeData = null;
    } else {
      $(row).addClass('active');
      this.activeRow = row;
      this.activeData = this.getDataForRow(this.activeRow);
    }
    if (!silent) {
      this.activeRowChanged.fire(this.activeRow, this.activeData);
    }
  }
};

/*
 * Returns the active row element
 *
 * @return {HTMLElement}
 */
Table.prototype.getActive = function () {
  return this.activeRow;
};

/*
 * Returns the last active data
 *
 * @return map
 */
Table.prototype.getActiveData = function () {
  return this.activeData;
};

/*
 * Triggers a table update.
 *
 * @param {Function} [callback]
 * @param {} [scope]
 * @param {Array} [args]
 */
Table.prototype.update = function (callback, scope, args) {
  window.largeTableUpdate(this.element, function () {
    if (callback) {
      callback.apply(scope, args);
    }
  });
};
var _default = exports.default = Table;

},{"lodash/flatten":29}],16:[function(require,module,exports){
"use strict";

var _Table = _interopRequireDefault(require("tables/Table"));
var _LargeTable = _interopRequireDefault(require("tables/LargeTable"));
var _LargeTableFactory = _interopRequireDefault(require("tables/LargeTableFactory"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
window.ngpNamespace('YAHOO.fcom');
window.YAHOO.fcom.Table = _Table.default;
window.YAHOO.fcom.LargeTable = _LargeTable.default;
window.YAHOO.fcom.LargeTableFactory = new _LargeTableFactory.default();

},{"tables/LargeTable":13,"tables/LargeTableFactory":14,"tables/Table":15}],17:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var KEYCODE = {
  ENTER: 13,
  SPACE: 32,
  ESCAPE: 27,
  ARROW_LEFT: 37,
  ARROW_UP: 38,
  ARROW_RIGHT: 39,
  ARROW_DOWN: 40,
  TAB: 9,
  KeyA: 65,
  KeyD: 68,
  DELETE: 46
};
var _default = exports.default = KEYCODE;

},{}],18:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * @name            : GUID
 * @description     : Generate new GUID and GUID related methods
 */
var GUID = exports.default = /*#__PURE__*/function () {
  function GUID() {
    _classCallCheck(this, GUID);
  }
  _createClass(GUID, null, [{
    key: "generate",
    value:
    /**
     * @method generate
     * @description Static method to generate new GUID
     * @public
     * @static
     */
    function generate() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0;
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
      });
    }
  }]);
  return GUID;
}();

},{}],19:[function(require,module,exports){
var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;

},{"./_root":28}],20:[function(require,module,exports){
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;

},{}],21:[function(require,module,exports){
var arrayPush = require('./_arrayPush'),
    isFlattenable = require('./_isFlattenable');

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;

},{"./_arrayPush":20,"./_isFlattenable":26}],22:[function(require,module,exports){
var Symbol = require('./_Symbol'),
    getRawTag = require('./_getRawTag'),
    objectToString = require('./_objectToString');

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;

},{"./_Symbol":19,"./_getRawTag":25,"./_objectToString":27}],23:[function(require,module,exports){
var baseGetTag = require('./_baseGetTag'),
    isObjectLike = require('./isObjectLike');

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;

},{"./_baseGetTag":22,"./isObjectLike":32}],24:[function(require,module,exports){
(function (global){(function (){
/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],25:[function(require,module,exports){
var Symbol = require('./_Symbol');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;

},{"./_Symbol":19}],26:[function(require,module,exports){
var Symbol = require('./_Symbol'),
    isArguments = require('./isArguments'),
    isArray = require('./isArray');

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;

},{"./_Symbol":19,"./isArguments":30,"./isArray":31}],27:[function(require,module,exports){
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;

},{}],28:[function(require,module,exports){
var freeGlobal = require('./_freeGlobal');

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;

},{"./_freeGlobal":24}],29:[function(require,module,exports){
var baseFlatten = require('./_baseFlatten');

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;

},{"./_baseFlatten":21}],30:[function(require,module,exports){
var baseIsArguments = require('./_baseIsArguments'),
    isObjectLike = require('./isObjectLike');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;

},{"./_baseIsArguments":23,"./isObjectLike":32}],31:[function(require,module,exports){
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;

},{}],32:[function(require,module,exports){
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;

},{}]},{},[16]);
;
(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var defaultPanelConfig = {
  url: 'view.action',
  width: '250px',
  fixedcenter: true,
  visible: false,
  close: true,
  dragOnly: true,
  constraintoviewport: true,
  modal: true,
  refresh: true
};
var defaultCallback = {
  fn: function fn(panel) {
    window.showWait(false);
    panel.show();
  }
};
var changeStartPage = function changeStartPage() {
  var postData = "method=handleChangeStartPageDialog&viewObjectName=".concat(encodeURIComponent(window.YAHOO.fcom.viewInfo.name));
  var panelConfig = Object.assign({}, defaultPanelConfig, {
    id: 'changeStartPageDialog',
    requiredScripts: ['changeStartPageDialog.js'],
    panelNamespace: 'YAHOO.fcom.panel.ChangeStartPageDialog',
    postData: postData
  });
  window.showWait(true, true);
  window.YAHOO.fcom.panel.PanelFactory.getAJAXPanel(panelConfig, defaultCallback);
};
var changeMobileStartPage = function changeMobileStartPage() {
  var postData = "method=handleChangeMobileStartPageDialog&viewObjectName=".concat(encodeURIComponent(window.YAHOO.fcom.viewInfo.name));
  var panelConfig = Object.assign({}, defaultPanelConfig, {
    id: 'changeMobileStartPageDialog',
    requiredScripts: ['changeMobileStartPageDialog.js'],
    panelNamespace: 'YAHOO.fcom.panel.ChangeMobileStartPageDialog',
    width: 'auto',
    postData: postData
  });
  window.showWait(true, true);
  window.YAHOO.fcom.panel.PanelFactory.getAJAXPanel(panelConfig, defaultCallback);
};
var changeView = function changeView() {
  var postData = "method=handleChangeViewDialog&viewObjectName=".concat(encodeURIComponent(window.YAHOO.fcom.viewInfo.name));
  var panelConfig = Object.assign({}, defaultPanelConfig, {
    id: 'changeViewDialog',
    requiredScripts: ['changeViewDialog.js'],
    panelNamespace: 'YAHOO.fcom.panel.ChangeViewDialog',
    width: '300px',
    postData: postData
  });
  window.showWait(true, true);
  window.YAHOO.fcom.panel.PanelFactory.getAJAXPanel(panelConfig, defaultCallback);
};
var copyView = function copyView() {
  var postData = "method=handleCopyViewDialog&viewObjectName=".concat(encodeURIComponent(window.YAHOO.fcom.viewInfo.name));
  var panelConfig = Object.assign({}, defaultPanelConfig, {
    id: 'copyViewDialog',
    requiredScripts: ['copyViewDialog.js'],
    panelNamespace: 'YAHOO.fcom.panel.CopyViewDialog',
    postData: postData
  });
  window.showWait(true, true);
  window.YAHOO.fcom.panel.PanelFactory.getAJAXPanel(panelConfig, defaultCallback);
};
var createView = function createView() {
  var postData = "method=handleCreateViewDialog&viewObjectName=".concat(encodeURIComponent(window.YAHOO.fcom.viewInfo.name));
  var panelConfig = Object.assign({}, defaultPanelConfig, {
    id: 'createViewDialog',
    requiredScripts: ['createViewDialog.js'],
    panelNamespace: 'YAHOO.fcom.panel.CreateViewDialog',
    width: '300px',
    postData: postData
  });
  window.showWait(true, true);
  window.YAHOO.fcom.panel.PanelFactory.getAJAXPanel(panelConfig, defaultCallback);
};
var deleteView = function deleteView(type, event, obj) {
  var postData = "method=handleDeleteViewDialog&viewObjectName=".concat(encodeURIComponent(window.YAHOO.fcom.viewInfo.name));
  var panelConfig = Object.assign({}, defaultPanelConfig, {
    id: 'deleteViewDialog',
    requiredScripts: ['deleteViewDialog.js'],
    panelNamespace: 'YAHOO.fcom.panel.DeleteViewDialog',
    postData: postData
  });
  window.showWait(true, true);
  window.YAHOO.fcom.panel.PanelFactory.getAJAXPanel(panelConfig, {
    fn: function fn(panel) {
      window.showWait(false);
      if (obj && obj.reset) {
        panel.setReset(obj.reset);
      }
      panel.show();
    }
  });
};
var ViewManager = {
  changeStartPage: changeStartPage,
  changeMobileStartPage: changeMobileStartPage,
  changeView: changeView,
  copyView: copyView,
  createView: createView,
  deleteView: deleteView
};
window.YAHOO.fcom.ViewManager = ViewManager;
var _default = exports.default = ViewManager;

},{}]},{},[1]);
;
(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

window.ngpNamespace('YAHOO.fcom.panel');
window.ngpNamespace('YAHOO.fcom.ModuleLib');
window.YAHOO.fcom.panel.ModuleLibrary = function (panel, panelConfig) {
  window.YAHOO.fcom.panel.ModuleLibrary.superclass.constructor.call(this, panel, panelConfig);
};

// extend from ResetableAJAXPanel to receive functionality to reset values over buttons
window.YAHOO.extend(window.YAHOO.fcom.panel.ModuleLibrary, window.YAHOO.fcom.panel.ResetableAJAXPanel, {
  init: function init() {},
  initDynamicData: function initDynamicData() {},
  setDirectCallMode: function setDirectCallMode(enabled) {
    enabled ? setDirectCallEnabled() : null;
  }
});
var getPanelConfig = function getPanelConfig() {
  return {
    id: 'moduleLibraryDiv',
    requiredScripts: [],
    panelNamespace: 'window.YAHOO.fcom.panel.ModuleLibrary',
    url: 'module.action',
    width: '335px',
    visible: false,
    constraintoviewport: true,
    modal: false,
    close: true,
    draggable: true,
    closeOnClickOutside: true,
    context: ['moduleLibMenuItem', 'tr', 'bl']
  };
};
var directCallModuleLib = null;
var panel = null;
var setDirectCallEnabled = function setDirectCallEnabled() {
  directCallModuleLib = function directCallModuleLib() {
    window.YAHOO.util.Dom.setStyle('moduleLibraryDiv', 'display', '');
    window.YAHOO.util.Dom.setStyle('moduleLibraryDiv', 'visibility', 'hidden');
    var panelConfig = getPanelConfig();
    panelConfig.draggable = false;
    panelConfig.x = window.Dom.getViewportWidth() / 3;
    panelConfig.y = 15;
    // this fixes the strange problem the close button is rendered twice
    // and the new button is below the old one
    // and so a close-click is blocked!
    $('#moduleLibraryDiv button.container-close').remove();
    //
    panel = new window.YAHOO.widget.Panel('moduleLibraryDiv', panelConfig);
    panel.render(document.body);
    panel.show();
  };
};
window.YAHOO.fcom.ModuleLib.show = function () {
  if (directCallModuleLib) {
    return directCallModuleLib();
  }
  var panelConfig = getPanelConfig();
  panelConfig.postData = {
    method: 'handleShowPanel',
    viewObjectName: encodeURIComponent(window.YAHOO.fcom.viewInfo.name),
    orgId: encodeURIComponent(window.YAHOO.fcom.viewInfo.viewOrgId),
    profileName: encodeURIComponent(window.YAHOO.fcom.viewInfo.viewProfile),
    isAdmin: encodeURIComponent(window.YAHOO.fcom.viewInfo.isAdmin)
  };
  var addClickOutsideHandler = function addClickOutsideHandler(panelContainer) {
    var onClickWindow = function onClickWindow(evt) {
      var $tg1 = $('#moduleLibraryDiv');
      var $tg2 = $('#moduleLibMenuItem');
      var isOverPanel = $tg1.is(evt.target) || $tg1.has(evt.target).length > 0;
      var isOverButton = $tg2.is(evt.target) || $tg2.has(evt.target).length > 0;
      if (!isOverPanel && !isOverButton) {
        panelContainer.hide('fadeOut');
      }
    };
    var addClickWindowEvent = function addClickWindowEvent() {
      $(window).off('mousedown', onClickWindow);
      $(window).on('mousedown', onClickWindow);
    };
    var onPanelClosed = function onPanelClosed() {
      $(window).off('mousedown', onClickWindow);
      panelContainer.panel.beforeHideEvent.unsubscribe(onPanelClosed);
    };
    panelContainer.panel.beforeHideEvent.subscribe(onPanelClosed);
    window.setTimeout(addClickWindowEvent, 2);
  };
  window.showWait(true, true);
  window.YAHOO.fcom.panel.PanelFactory.getAJAXPanel(panelConfig, {
    fn: function fn(panelContainer) {
      window.showWait(false);
      if (panelContainer.panel) {
        panelContainer.show('fadeIn');
        if (panelConfig.closeOnClickOutside) {
          addClickOutsideHandler(panelContainer);
        }
        panelContainer.panel.align();
        window.moduleLibPanel = panelContainer;

        // #. Activate accessibility
        window.fcom.Accessibility.init({
          accordion: {
            container: $(panelContainer.panel.element),
            toggleSelector: '.expanderBar button',
            findPanelBy: {
              method: 'parent next'
            },
            expandSelector: {
              parent: 'open',
              delay: 500
            }
          }
        });
      }
    }
  });
};

},{}]},{},[1]);
;
var Dom=YAHOO.util.Dom;YAHOO.fcom.DropMenuItem=function(e,t){var i;(null==t.text||t.text.length<1)&&(t.text=t.value),null!=t.submenu&&null==(i=t.submenu).id&&(i.id=Dom.generateId()),this.SUBMENU_TYPE=YAHOO.fcom.DropSubMenu,YAHOO.fcom.DropMenuItem.superclass.constructor.call(this,e,t),this.cfg.setProperty("url",""),this.caption=t.caption,1==this.caption&&(i=Dom.getFirstChild(this.element),Dom.setStyle(i,"cursor","default"),Dom.addClass(i,"yuimenuitemlabel-caption"),Dom.addClass(this.element,"yuimenuitem-no_value"),Dom.addClass(i,"yuimenuitem-no_value")),1==t.exclusive&&(this.exclusive=!0)},YAHOO.extend(YAHOO.fcom.DropMenuItem,YAHOO.widget.MenuItem),YAHOO.fcom.DropSubMenu=function(e,t){this.ITEM_TYPE=YAHOO.fcom.DropMenuItem,YAHOO.fcom.DropSubMenu.superclass.constructor.call(this,e,t)},YAHOO.extend(YAHOO.fcom.DropSubMenu,YAHOO.widget.Menu),YAHOO.fcom.DropMenu=function(e,t,i,l,n){this.inputField=Dom.get(t),this.name=i,l&&null!=l&&this._checkGivenConfig(l),YAHOO.fcom.DropMenu.superclass.constructor.call(this,e,l),this.ITEM_TYPE=YAHOO.fcom.DropMenuItem,1!=this.isCombo&&this.inputField.setAttribute("autocomplete","off"),1==this.isMultipleSelection?this.hiddenFields={}:this._createHiddenField(),this.setFormAttributes(),this.lastHidden=0,this.lastValue=null,this.justClicked=!1,this.isInPanel=!1,this.defaultItem=null,this.numberSelected=0,this.menuLinkNodes=YAHOO.util.Dom.getChildrenBy(this.inputField.parentNode,function(e){return Dom.hasClass(e,"link")}),window.domToYUIMap[this.name]=this,(window.domToYUIMap[this.inputField.name]=this).changeEvent=new YAHOO.util.CustomEvent("change"),this.textChangeEvent=new YAHOO.util.CustomEvent("textChange"),this.selectionChangeEvent=new YAHOO.util.CustomEvent("selectionChange"),this.hasTextfieldFocus=!1,YAHOO.util.Event.addListener(this.inputField,"focus",function(){this.hasTextfieldFocus=!0},this,!0),YAHOO.lang.later(1,null,function(e){var t=e[0];t.lazyLoad?t.itemData=e[1]:t.addItems(e[1]),t.render(document.body),window.installOverlayListener(t),0==t.isMultipleSelection&&null==t.activeItem?t.preSelect?t.selectByValue(t.preSelect):t._reselectDefault():t.lastValue=t.inputField.value,1==e[2].resetable&&t.saveState(),t.readyLoaded=!0,YAHOO.fcom.Page.ready(e[2].pageId,t)},[[this,n,l]])},YAHOO.extend(YAHOO.fcom.DropMenu,YAHOO.widget.Menu,{_checkGivenConfig:function(e){e.context&&null!=e.context||(e.context=new Array(this.inputField.id,"tl","bl")),e.isCombo&&(this.isCombo=e.isCombo),0==YAHOO.lang.isBoolean(this.isCombo)&&(this.isCombo=!1),e.isMultipleSelection&&(this.isMultipleSelection=e.isMultipleSelection),0==YAHOO.lang.isBoolean(this.isMultipleSelection)&&(this.isMultipleSelection=!1),e.onChangeString?this.onChangeString=e.onChangeString:this.onChangeString=null,e.onTextChangeString?this.onTextChangeString=e.onTextChangeString:this.onTextChangeString=null,e.onSelectionChangeString?this.onSelectionChangeString=e.onSelectionChangeString:this.onSelectionChangeString=null,e.showValuesInInput?this.showValuesInInput=e.showValuesInInput:this.showValuesInInput=!1,null!=e.maxLength&&(this.maxLength=e.maxLength),null!=e.pageId&&(this.pageId=e.pageId),null!=e.preSelect&&(this.preSelect=e.preSelect),null!=e.openListOnEnterKey&&(this.openListOnEnterKey=e.openListOnEnterKey),e.position="dynamic"},setFormAttributes:function(){this.type="droplist",this.form=this.inputField.form},_getInputFieldText:function(e,t){var i;return e&&null!=e?(1!=this.showValuesInInput||null==e.value)&&(null!=(i=this._getItemAttribute(e,"plain"))&&0<i.length||null!=(i=this._getItemAttribute(e,"text"))&&0<i.length)?i:e.value:t&&null!=t?t:null},getMaxLength:function(){var e;return null==this.maxLength&&(e=Dom.getRegion(this.inputField),this.maxLength=Math.ceil((e.right-e.left)/6.5)),this.maxLength},resetInputNode:function(e){this.inputField=Dom.get(e),1==this.isMultipleSelection?this.hiddenFields={}:this.hiddenField=this.inputField.parentNode.lastChild,this.menuLinkNodes=YAHOO.util.Dom.getChildrenBy(this.inputField.parentNode,function(e){return Dom.hasClass(e,"link")}),this.form=this.inputField.form},hasUncommitedTextChange:function(){return this.lastValue!=this.inputField.value},focus:function(){this.hasTextfieldFocus?YAHOO.fcom.DropMenu.superclass.focus.call(this):(this.inputField.focus(),1==this.isCombo&&this.inputField.select())},getAllItemsBy:function(e,t){var i=this.getItems();(null==i||i.length<1)&&(i=this.itemData);return this._getAllItemsBy(i,e,t,[])},_getAllItemsBy:function(e,t,i,l){if(null!=e)for(var n=0;n<e.length;n++){var s,u=e[n];1==YAHOO.lang.isArray(u)?this._getAllItemsBy(u,t,i,l):(t(u,this,i)&&l.push(u),null!=(u=this._getItemAttribute(u,"submenu"))&&(((s=null)==(s=null==(s=0==YAHOO.lang.isArray(u)&&u.getItems?u.getItems():s)||s.length<1?u.itemData:s)||s.length<1)&&(s=u.itemdata),this._getAllItemsBy(s,t,i,l)))}return l},forAllItems:function(e,t){var i=this.getItems();return(null==i||i.length<1)&&(i=this.itemData),this._forAllItems(i,e,t)},_forAllItems:function(e,t,i){if(null!=e)for(var l=0;l<e.length;l++){var n=e[l];if(YAHOO.lang.isArray(n)){if(1==this._forAllItems(n,t,i))return!0}else{if(1==t(n,this,i))return!0;n=this._getItemAttribute(n,"submenu");if(null!=n){var s=null;if((null==(s=null==(s=0==YAHOO.lang.isArray(n)&&n.getItems?n.getItems():s)||s.length<1?n.itemData:s)||s.length<1)&&(s=n.itemdata),1==this._forAllItems(s,t,i))return!0}}}return!1},_updateTextFieldMultiple:function(){if(1==this.isMultipleSelection){for(var e="",t=-1,i=this.getAllItemsBy(function(e,t){return t._getItemAttribute(e,"checked",!1)}),l=0;l<i.length;l++){if(e+=this._getInputFieldText(i[l]),-1<t&&e.length>this.getMaxLength())return e=e.substring(0,t)+", ...",void(this.inputField.value=fcom.util.StringHelper.unescapeHTML(e));t=e.length,e+=", "}(e=e.length>this.getMaxLength()&&1<this.numberSelected?e.substring(0,t)+", ...":e.substring(0,t)).length<1&&null!=this.dummySelectedHeader?this.inputField.value=fcom.util.StringHelper.unescapeHTML(this._getInputFieldText(this.dummySelectedHeader)):this.inputField.value=fcom.util.StringHelper.unescapeHTML(e)}},isAnItemValue:function(e){return!!this.isAListedItemValue(e)||!!this.isCombo&&this.hiddenField.value==e},isAListedItemValue:function(e){return this.forAllItems(function(e,t,i){if(null!=e.value&&e.value==i)return!0},e)},getValueForTheText:function(l){var e=this.getAllItemsBy(function(e,t){var i=t._getItemAttribute(e,"text");return null!=i&&i==l||null!=(i=t._getItemAttribute(e,"plain"))&&i==l},l);return null!=e&&0<e.length?e[0].value:null},hide:function(){1==this.isMultipleSelection&&1==this.justClicked?this.justClicked=!1:(YAHOO.fcom.DropMenu.superclass.hide.call(this),this.lastHidden=(new Date).getTime())},removeBy:function(e,t,i){YAHOO.lang.isUndefined(t)&&(t=!0);for(var l=0;l<this.getItems().length;){var n=this.getItems()[l];1==e(n,this,i)?this._removeItem(n,t,!1):l++}},addSelectionVerifier:function(e,t){this.selectionVerifier=e,this.selectionVerifierObj=t},_reselectDefault:function(){if(0==this.isMultipleSelection)if(this.defaultItem&&null!=this.defaultItem)this._selectByItem(this.defaultItem,!0);else if(this.preSelect)this.selectByValue(this.preSelect);else{for(var e=this.getItems(),t=null,i=0;i<e.length&&(null==(t=e[i]).value||1==this._getItemAttribute(t,"disabled",!1));i++)t=null;null!=t&&this._selectByItem(t,!0)}},_getItemAttribute:function(e,t,i){return null!=e.cfg?e.cfg.getProperty(t):null!=(t=e[t])?t:i},_setItemAttribute:function(e,t,i){null!=e.cfg?e.cfg.setProperty(t,i):e[t]=i},_removeItem:function(e,t,i){var l;1==this.isMultipleSelection?(this.exclusiveItem&&null!=this.exclusiveItem&&this.exclusiveItem==e&&(this.exclusiveItem=null),this._updateFormField(e,!1),1!=this._getItemAttribute(e,"checked",!1)||i||this._updateTextFieldMultiple(),e.parent instanceof YAHOO.fcom.DropMenu?YAHOO.fcom.DropMenu.superclass.removeItem.call(this,e,e.groupIndex):e.parent.removeItem(e,e.groupIndex)):(l=!1,this.defaultItem&&this.defaultItem==e&&(this.defaultItem=null),1!=this._getItemAttribute(e,"selected",!1)&&this.activeItem!=e||i||(l=!0),e.parent instanceof YAHOO.fcom.DropMenu?YAHOO.fcom.DropMenu.superclass.removeItem.call(this,e,e.groupIndex):e.parent.removeItem(e,e.groupIndex),1==l&&this._reselectDefault())},removeItem:function(e){this._removeItem(e,!0,!1)},removeAll:function(){for(var e=this.getItems().length;0<e;){var t=this.getItems()[e-1];this._removeItem(t,!0,!0),e=this.getItems().length}0==this.isMultipleSelection?(this.inputField.value="",this.hiddenField&&this.hiddenField.value&&(this.hiddenField.value="")):this._updateTextFieldMultiple()},addItemsByValueAndText:function(e,t,i){if(e&&null!=e&&0!=YAHOO.lang.isArray(e)){t&&null!=t&&t.length==e.length||(t=e);for(var l=i&&null!=i&&1==YAHOO.lang.isArray(i)&&i.length==e.length,n=0;n<e.length;n++){var s=null;(s=l?i[n]:{}).text=t[n],s.value=e[n],this.addItem(s)}}},addItem:function(e,t){e=YAHOO.fcom.DropMenu.superclass.addItem.call(this,e,t),null==t&&(t=0),t=this.getItemGroups()[t];return this._initItem(t[t.length-1]),e},addItems:function(e,t){YAHOO.fcom.DropMenu.superclass.addItems.call(this,e,t)},deselectAll:function(e){0==this.isMultipleSelection?(this.clearActiveItem(!1),this.forAllItems(function(e,t){return 1==t._getItemAttribute(e,"selected",!1)&&t._setItemAttribute(e,"selected",!1),!1},null),this._reselectDefault()):(this.clearActiveItem(!1),this.forAllItems(function(e,t){return 1==t._getItemAttribute(e,"checked",!1)&&(t._setItemAttribute(e,"checked",!1),t._updateFormField(e,!1)),!1},null),0==(e=e||!1)&&this._updateTextFieldMultiple())},selectByValues:function(e){if(e&&null!=e&&0!=YAHOO.lang.isArray(e)&&0!=this.isMultipleSelection&&0!=this.isMultipleSelection){for(var t={},i=0;i<e.length;i++)t[e[i]]=e[i];this.forAllItems(function(e,t,i){return null!=e.value&&i[e.value]==e.value&&0==t._getItemAttribute(e,"checked",!1)&&t._selectByItem(e,!0,!0),!1},t),this._updateTextFieldMultiple()}},selectByValueComparator:function(e,t){e=this.getAllItemsBy(e,t);1==e.length&&this.selectByValue(e[0].value)},_selectByItem:function(e,t,i){var l,n;YAHOO.lang.isUndefined(i)&&(i=!1),0==this.isMultipleSelection?(l=this.activeItem,this.hiddenField.value!=e.value&&(this.hiddenField.value=e.value,this._setItemAttribute(e,"selected",!0),this.activeItem=e,this.inputField.value=fcom.util.StringHelper.unescapeHTML(this._getInputFieldText(e)),this.lastValue=this.inputField.value,l)&&!0===this._getItemAttribute(l,"selected")&&this._setItemAttribute(l,"selected",!1)):this._getItemAttribute(e,"checked",!1)!=t&&(l=!1,1==t&&((n=e.exclusive)&&1==n?this.deselectAll(!0):this.exclusiveItem&&null!=this.exclusiveItem&&1==this._getItemAttribute(this.exclusiveItem,"checked",!1)&&(l=!0)),this._setItemAttribute(e,"checked",t),this._updateFormField(e,t),l&&(this._setItemAttribute(this.exclusiveItem,"checked",!1),this._setItemAttribute(this.exclusiveItem,"selected",!1),this._updateFormField(this.exclusiveItem,!1)),i||this._updateTextFieldMultiple())},hasValue:function(e){return this.isAListedItemValue(e)},selectByValue:function(e,t){t=[e,t=YAHOO.lang.isUndefined(t)?!0:t,!1];return this.forAllItems(function(e,t,i){if(i[0]==e.value)return t.isMultipleSelection?(t._getItemAttribute(e,"checked",!1)!=i[1]&&(t._selectByItem(e,i[1]),i[2]=!0),!1):(1!=t._getItemAttribute(e,"selected",!1)&&t._selectByItem(e,!0),i[2]=!0)},t),t[2]||!this.isCombo?t[2]:(this.inputField.value=e,this.lastValue=this.inputField.value,this.activeItem&&null!=this.activeItem&&this._setItemAttribute(this.activeItem,"selected",!1),this.clearActiveItem(!1),this.hiddenField.value=e,!1)},setComboValueAndText:function(e,t){this.selectByValue(e),this.inputField.value=t,this.lastValue=t},getSelectedValues:function(){var e=[];if(0==this.isMultipleSelection)e[0]=this.hiddenField.value;else for(var t=this.getAllItemsBy(function(e,t){return t._getItemAttribute(e,"checked",!1)}),i=0;i<t.length;i++)e.push(t[i].value);return e},getSelectedItems:function(){var t;return 0==this.isMultipleSelection?(t=this.getSelectedValue(),this.getAllItemsBy(function(e){if(e.value==t)return e})):this.getAllItemsBy(function(e,t){return t._getItemAttribute(e,"checked",!1)})},setManualInputCorrectionHandler:function(e){this.manualInputHandler=e},getSelectedValue:function(){var e;return 0==this.isMultipleSelection?this.hiddenField.value:0<(e=this.getSelectedValues()).length?e[0]:null},getSelectedText:function(){return this.inputField.value},selectItemByIndex:function(e,t){null==t&&(t=!0);e=this.getItem(e);this._selectByItem(e,t)},getSelectedIndex:function(){if(0==this.isMultipleSelection){if(!(0<this.hiddenField.value.length))return-1;for(var e=this.getItems(),t=0;t<e.length;t++)if(this.hiddenField.value==e[t].value)return t}else for(e=this.getItems(),t=0;t<e.length;t++)if(1==this._getItemAttribute(e[t],"checked",!1))return t;return-1},saveState:function(){this.initialSelectedItems=[],this.initialItems=[];for(var e=this.getItems(),t=0;t<e.length;t++)!0!==this._getItemAttribute(e[t],"selected")&&!0!==this._getItemAttribute(e[t],"checked")||this.initialSelectedItems.push(e[t]),this.initialItems.push(e[t])},reset:function(e){if(null!=this.initialSelectedItems&&0<this.initialSelectedItems.length&&null!=this.initialItems&&0<this.initialItems.length){this.removeAll(),this.addItems(this.initialItems),this.deselectAll(!0);for(var t=0;t<this.initialSelectedItems.length;t++)this._selectByItem(this.initialSelectedItems[t],!0);e=e||document.body,this.render(e),this.isMultipleSelection&&this._updateTextFieldMultiple(),this._callChangeEvents({onChange:!0})}},_onRender:function(e,t){YAHOO.fcom.DropMenu.superclass._onRender.call(this,e,t),1!=this.isCombo?(YAHOO.util.Event.addListener(this.inputField,"click",this.show,null,this),YAHOO.util.Event.addListener(this.inputField,"keydown",function(e,t){e=(e=e||window.event).which||e.keyCode;40!=e&&32!=e||(t.show(),t.focus()),9==e&&this.blur()},this,this),this.inputField.onkeypress=function(e){if(13!=(e=(e=e||window.event).which||e.keyCode)&&40!=e&&9!=e)return!1}):(YAHOO.util.Event.addListener(this.inputField,"click",function(e,t){t.inputField.select()},this,!0),YAHOO.util.Event.addListener(this.inputField,"keydown",function(e,t){var i;40==(i=(e=e||window.event).which||e.keyCode)?(t.show(),t.focus()):38==i?t.hide():13==i?t.enterPressed(e):t.keyPressed(e)},this,!0),YAHOO.util.Event.addListener(this.inputField,"keyup",function(e,t){e=e.which||e.keyCode;[13,38,40,9].includes(e)||(t.hiddenField.value=t.inputField.value)},this,!0),YAHOO.util.Event.addListener(this.inputField,"blur",function(e,t){t.lastValue!=t.inputField.value&&null==t.popupSearchHandler&&(this.handleFinishedUserInput(),this._callChangeEvents({onChange:!0,onTextChange:!0}),t.lastValue=t.inputField.value)},this,!0)),null!=Dom.getAncestorByClassName(this.inputField,"panel")&&(this.isInPanel=!0);for(var i=0;i<this.menuLinkNodes.length;i++)1==this.cfg.getProperty("disabled")&&window.setElementDisabled(this.menuLinkNodes[i],!0),YAHOO.util.Event.addListener(this.menuLinkNodes[i],"click",function(e,t){0==t.cfg.getProperty("disabled")&&0==t.cfg.getProperty("visible")&&t.show(e)},this),YAHOO.util.Event.addListener(this.menuLinkNodes[i],"keydown",function(e,t){0==t.cfg.getProperty("disabled")&&(40==(e=(e=e||window.event).which||e.keyCode)||32==e||13==e?t.show():38==e&&t.hide())},this,this);this.destroyEvent.subscribe(function(e,t,i){YAHOO.util.Event.purgeElement(i.inputField,!1);for(var l,n=0;n<i.menuLinkNodes.length;n++)YAHOO.util.Event.purgeElement(i.menuLinkNodes[n],!1);if(1==i.isMultipleSelection)for(var s in i.hiddenFields)s&&null!=s&&null!=(l=i.hiddenFields[s])&&(l.parentNode.removeChild(l),i.hiddenFields[s]=null);else i.hiddenField&&(i.hiddenField.parentNode.removeChild(i.hiddenField),i.hiddenField=null)},this,!1);var l=this.getItems();this.dummySelectedHeader=null;for(i=0;i<l.length;i++)this._initItem(l[i]);1==this.isMultipleSelection?this._updateTextFieldMultiple():this.lazyLoad&&(0<(e=this.getAllItemsBy(function(e,t){return t._getItemAttribute(e,"selected",!1)},this)).length?this._selectByItem(e[0],!0):(t=this.getAllItemsBy(function(e,t){return!t[1]&&(t[1]=!0)},[this,!1]),this._selectByItem(t[0],!0)))},setPopupSearchHandler:function(e){this.popupSearchHandler=e},keyPressed:function(e){null!=this.popupSearchHandler&&this.popupSearchHandler.keyPressed(e)},enterPressed:function(e){this.lastValue==this.inputField.value?this._callChangeEvents({onChange:!0,onSelectionChange:!0}):(this.handleFinishedUserInput(),null!=this.popupSearchHandler?(this.popupSearchHandler.handleUserInput(),YAHOO.util.Event.stopEvent(e)):this._callChangeEvents({onChange:!0,onTextChange:!0}),this.lastValue=this.inputField.value),this.openListOnEnterKey&&(this.show(),this.focus())},clearActiveItem:function(e){null!=this.activeItem&&(this._setItemAttribute(this.activeItem,"selected",!1),null!=this.activeItem.cfg&&YAHOO.fcom.DropMenu.superclass.clearActiveItem.call(this,e),this.activeItem=null)},handleFinishedUserInput:function(){var e,t=this.inputField.value,i=t;this.manualInputHandler&&(t=(e=this.manualInputHandler(t))[0],i=e[1]),this.clearActiveItem(!1),this.hiddenField.value=i,this.inputField.value=t},_initItem:function(e,t){if(YAHOO.lang.isUndefined(t)&&(t=!0),e.id&&null!=e.id||(e.id=Dom.generateId(e.element)),1==this.isMultipleSelection&&(i=e.exclusive)&&1==i&&(this.exclusiveItem=e),1!=this._getItemAttribute(e,"selected")&&1!=this._getItemAttribute(e,"checked")||(this._updateFormField(e,!0),1==this.isMultipleSelection?(this._setItemAttribute(e,"checked",!0),this._setItemAttribute(e,"selected",!1)):(this.inputField.value=fcom.util.StringHelper.unescapeHTML(this._getInputFieldText(e)),this._setItemAttribute(e,"checked",!1),this._setItemAttribute(e,"selected",!0),this.defaultItem=e,this.hiddenField.value=e.value)),null!=this._getItemAttribute(e,"submenu")){null==e.value&&(i=Dom.getFirstChild(e.element),Dom.setStyle(i,"cursor","default"),Dom.addClass(i,"yuimenuitem-no_value"),Dom.addClass(e.element,"yuimenuitem-no_value"));var i=this._getItemAttribute(e,"submenu"),l=(t&&(i.subscribe("click",function(e,t,i){this._onClick(e,t,i)},this,!0),t=!1),i.getItems());if(l&&0<l.length)for(var n=0;n<l.length;n++)this._initItem(l[n],t)}},_updateFormField:function(e,t){if(1==this.isMultipleSelection){if(1==t){if(0==YAHOO.lang.isUndefined(this.hiddenFields)&&null!=this.hiddenFields)for(var i in this.hiddenFields)if(i&&null!=i&&null!=this.hiddenFields[i]&&this.hiddenFields[i].value==e.value)return;this._createHiddenField(e.value,e.id),this.numberSelected++}else if(!YAHOO.lang.isUndefined(this.hiddenFields)&&null!=this.hiddenFields)for(var i in this.hiddenFields)if(i&&null!=i){var l=this.hiddenFields[i];if(null!=l&&l.value==e.value)return null!=l.parentNode&&l.parentNode.removeChild(l),this.hiddenFields[i]=null,this.numberSelected--,void(0==this.numberSelected&&this.exclusiveItem&&null!=this.exclusiveItem&&(this.exclusiveItem.cfg.setProperty("checked",!0),this._updateFormField(this.exclusiveItem,!0)))}}else 1==t&&(YAHOO.lang.isUndefined(this.hiddenField)||null==this.hiddenField?this._createHiddenField(e.value):this.hiddenField.value=e.value)},_createHiddenField:function(e,t){var i;null!=this.hiddenField&&!this.isMultipleSelection||((i=document.createElement("input")).setAttribute("type","hidden"),i.setAttribute("name",this.name),i.setAttribute("value",e),this.pageId&&i.setAttribute("id",t?this.pageId+"__value_"+t:this.pageId+"__value"),null!=this.inputField.parentNode&&(this.inputField.parentNode.appendChild(i),this.hiddenField=this.inputField.parentNode.lastChild),null==t)||(this.hiddenFields[t]=i)},configDisabled:function(e,t,i){YAHOO.fcom.DropMenu.superclass.configDisabled.call(this,e,t,i);var l=t[0];if(window.setElementDisabled(this.inputField,l),this.menuLinkNodes)for(var n=0;n<this.menuLinkNodes.length;n++)window.setElementDisabled(this.menuLinkNodes[n],l)},_callChangeEvents:function(o_conf){if(null!=o_conf){if(1==o_conf.onChange){if(null!=this.onChangeString)try{eval(this.onChangeString)}catch(e){console.error("Exception "+e+" while trying to call on change handler in drop menu: "+this.onChangeString)}this.changeEvent.fire()}if(1==o_conf.onTextChange){if(null!=this.onTextChangeString)try{eval(this.onTextChangeString)}catch(e){console.error("Exception "+e+" while trying to call on text change handler in drop menu: "+this.onTextChangeString)}this.textChangeEvent.fire()}if(1==o_conf.onSelectionChange){if(null!=this.onSelectionChangeString)try{eval(this.onSelectionChangeString)}catch(e){console.error("Exception "+e+" while trying to call on selection change handler in drop menu: "+this.onSelectionChangeString)}this.selectionChangeEvent.fire()}}},_onClick:function(e,t,i){var l=t[1];if(!l||this._getItemAttribute(l,"disabled")||1==l.caption)return YAHOO.util.Event.stopEvent(t[0]),!1;if(null!=this.selectionVerifier){var n=!1,n=1==this.isMultipleSelection?this._getItemAttribute(l,"checked"):this._getItemAttribute(l,"selected");if(null==this.selectionVerifierObj){if(0==this.selectionVerifier(l,0==n))return YAHOO.util.Event.stopEvent(t[0]),!1}else if(0==this.selectionVerifier(l,0==n,this.selectionVerifierObj))return YAHOO.util.Event.stopEvent(t[0]),!1}1==this._itemClicked(l,t[0])&&YAHOO.fcom.DropMenu.superclass._onClick.call(this,e,t,i),!1===this.cfg.getProperty("visible")&&(this.inputField.select(),this.inputField.focus())},_itemClicked:function(e,t){if(null!=e.value)if(1==this.isMultipleSelection){if(this.justClicked=!0,e.cfg.setProperty("selected",!1),1==this._getItemAttribute(e,"checked")){var i=e.exclusive;if(i&&1==i)return!1}this._selectByItem(e,!this._getItemAttribute(e,"checked")),this._callChangeEvents({onChange:!0,onSelectionChange:!0})}else this.hiddenField.value!=e.value&&(this._selectByItem(e,!0),this._callChangeEvents({onChange:!0,onSelectionChange:!0})),null!=this._getItemAttribute(e,"submenu")&&this.hide();return YAHOO.util.Event.stopEvent(t),!0},show:function(e,t){var i,l;(new Date).getTime()-this.lastHidden<500||(this.lazyLoad&&0==this.getItems().length&&(i=window.getProgressBanner(),Dom.setStyle(i,"z-index","100000"),Dom.setStyle(i,"visibility","visible"),Dom.setX(i,Dom.getX(this.inputField)),l=Dom.getY(this.inputField)+Dom.getRegion(this.inputField).bottom-Dom.getRegion(this.inputField).top,Dom.setY(i,l)),YAHOO.lang.later(10,this,function(e,t){YAHOO.fcom.DropMenu.superclass.show.call(this,e,t),this.lazyLoad&&(e=window.getProgressBanner(),Dom.setStyle(e,"z-index","0"),Dom.setStyle(e,"visibility","hidden")),0==this.isMultipleSelection&&(!((t=this.activeItem)&&null!=t||this.hiddenField&&this.hiddenField.value&&!(this.hiddenField.value.length<1))&&0<this.getItems().length&&(this._reselectDefault(),t=this.activeItem),null!=t)&&t.focus(),1==this.isInPanel&&this.bringToTop();e=this.cfg.getProperty("context");this.align(e[1],e[2])},[e,t])),e&&YAHOO.util.Event.stopEvent(e)},getItemData:function(){var e=[];if(null!=this.itemData)e=e.concat.apply(e,this.itemData);else for(var t=this.getItems(),i=0,l=t.length;i<l;i++){var n=t[i];e.push({text:this._getItemAttribute(n,"text"),plain:this._getItemAttribute(n,"plain"),value:n.value})}return e},setVisible:function(e){var t=YAHOO.util.Dom.getAncestorByClassName(this.inputField,"select");YAHOO.util.Dom.setStyle(t,"display",e?"":"none")},getItemByValue:function(t){var i=null;return this.forAllItems(function(e){if(e.value==t)return i=e,!1}),i},addClass:function(e){Dom.addClass(this.inputField,e)},removeClass:function(e){Dom.removeClass(this.inputField,e)}}),YAHOO.augment(YAHOO.fcom.DropMenu,YAHOO.widget.Menu);
//# sourceMappingURL=DropMenu.js.map;
(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
var _lodash = require("lodash");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; } /**
                                                                                                                                                                                     * Import dependencies
                                                                                                                                                                                     * KEYCODE - Contains enum about the keycode information
                                                                                                                                                                                    **/
/** @module ui/Select */
var YAHOO = window.YAHOO;
var fcom = window.fcom;

/**
 * fcom.Select is an alternative for YAHOO.fcom.DropMenu that can by used by the ngp:select tag.<br/>
 * fcom.Select is exported to the global namespace and can thus be instanciated by using <code>new window.fcom.Select()</code>
 * @class
 * @param {string} elementId a string that is the id for the new menu node
 *        it needs to be a dom node id of a select tag that contains options
 * @param {Object} config a config object for jquery select2
 *        for more information see <a href="https://select2.github.io/examples.html">select2 examples</a>
 */
var Select = function Select(elementId, config) {
  var _this2 = this;
  var _this = this;
  this.$element = $("#".concat(elementId));
  if (config.onSelectionChangeString) {
    config.onChangeString = config.onSelectionChangeString;
  }

  // #. Identify the dropdown is multiselect or not
  this.isMulti = this.$element.is('[multiple]');

  // #. Listen and manage new tag creation
  config.createTag = function (params) {
    if (!params.term) {
      return null;
    }

    // #. Don't need to create a new tag when the value is already exists
    var $option = this.$element.find("option[value=\"".concat(params.term.trim(), "\"i]"));
    if ($option.length > 0) {
      return null;
    }
    return {
      id: params.term,
      text: _this.getCustomLabel(params.term),
      newTag: config.tags
    };
  };

  // #. tags - must have search option
  // #. Search term must display option with same value prop
  if (config.tags && this.isMulti) {
    config.matcher = function (params, data) {
      if (!params.term) {
        return data;
      }
      // #. Compare with the main options value and text
      var value = String(data.element.value).toLowerCase().includes(String(params.term).toLowerCase());
      var text = String(data.text).toLowerCase().includes(String(params.term).toLowerCase());
      // #. Compare with the child under optgroup options value and text
      var filteredChildren = [];
      var optGroupOptions = data.children || [];
      optGroupOptions.forEach(function (child) {
        var cValue = String(child.element.value).toLowerCase().includes(String(params.term).toLowerCase());
        var cText = String(child.text).toLowerCase().includes(String(params.term).toLowerCase());
        if (cValue || cText) {
          filteredChildren.push(child);
        }
      });
      if (filteredChildren.length > 0) {
        var modifiedData = $.extend({}, data, true);
        modifiedData.children = filteredChildren;
        return modifiedData;
      }
      return value || text ? data : null;
    };
  } else if (config.disableSearch) {
    config.matcher = function (params, data) {
      return params.term ? null : data;
    };
  }
  if (config.checkBoxSelection) {
    config.closeOnSelect = false;
    config.templateResult = this.setCheckBoxResultTemplate.bind(this);
  }
  this.isMulti = this.$element.is('[multiple]');

  /**
   * Custom template for the locked feature
   * For multi select dropdown locked feature implemented
   * To make an option permanent add locked="locked" attr to the option element
   * This will permanently visible as tag - remove button will be removed
   */

  if (this.isMulti) {
    config.templateSelection = this.onTemplateSelection.bind(this);
  }
  if (config.countryFlagSpan) {
    config.closeOnSelect = true;
    config.templateResult = this.setCountryFlagSpan.bind(this);
    config.templateSelection = this.setCountryFlagSpan.bind(this);
  }
  this.$element.select2(config);
  this.inputField = this.$element.get(0); // for compatibility
  this.valueField = this.$element.get(0); // for compatibility
  window.domToYUIMap[this.$element.prop('name')] = this;
  this.elId = this.$element.attr('id');
  this.changeEvent = new YAHOO.util.CustomEvent('change');
  this.config = config;
  this.initialData = this.getItems();
  this.lockedValues = [];
  this.innerOptGroupData = {};
  if (config.tags && config.tagValues) {
    this.selectByValues(config.tagValues);
  }

  // sometimes element isn't correct rendered in dom calling these methods
  // on ready
  $(function () {
    _this2.initScreenreaderAccess();
    if (_this2.isMulti === true) {
      _this.initKeyBoardAccess();
      _this.setPrintViewClass();
      _this.setSelectedItemValues(config.tagValues);
      _this2.selectListUnselectingHandler();
    } else {
      _this2.initSingleSelectKeyBoardAccess();
    }
  });
  YAHOO.lang.later(1, null, function (parameterArray) {
    var _this = parameterArray[0];

    // save selected value internally
    _this.selected = _this.getSelectedValue();
    _this.value = _this.selected;
    _this.$element.on('change', handleChange);
    YAHOO.fcom.Page.ready(elementId, _this);
  }, [[this]]);
  var onHandleCheckboxState = (0, _lodash.debounce)(this.handleCheckBoxSelection.bind(this), 175);
  var handleChange = function handleChange() {
    if (_this.isMulti) {
      // clear exclusive values and make them exclusive
      var newSelected = _this.getSelectedValue();
      var newValue = newSelected.find(function (f) {
        return _this.selected.indexOf(f) === -1;
      });
      // new value is exclusive - deselect all others
      if (_this.getIsValueExclusive(newValue) && newSelected.length > 1) {
        _this.selectByValues([newValue]);
        return;
      }
      // old value was exclusive - deselect it
      var filteredSelection = newSelected.filter(function (f) {
        return !_this.getIsValueExclusive(f);
      });
      if (filteredSelection.length && filteredSelection.length < newSelected.length) {
        _this.selectByValues(filteredSelection);
        return;
      }
      _this.initKeyBoardAccess();
      _this.setPrintViewClass();
      _this.setSelectedItemValues(newSelected);
    }
    if (config.onChangeString) {
      _this.runInScope(config.onChangeString);
    }
    _this.changeEvent.fire();
    _this.selected = _this.getSelectedValue();
    _this.value = _this.selected;
    _this.initScreenreaderAccess();
    onHandleCheckboxState(_this.selected);
  };
};
Select.prototype.onTemplateSelection = function (params, container) {
  var isLocked = $(params.element).attr('locked');
  if (isLocked) {
    $(container).addClass('locked');
  }
  return params.text;
};

/**
 * init screenreader access
 */
Select.prototype.initScreenreaderAccess = function () {
  this.getRenderedSelect().attr('role', 'application');
  this.initActivedescendantList();
  this.updateActivedescendantList();
  this.updateLabelledbyAttributes();
  if (this.isMulti === true) {
    var spanMultipleSelection = this.$element.next('.select2').find('.select2-selection--multiple');
    $(spanMultipleSelection).removeAttr('role', 'aria-haspopup', 'aria-expanded', 'aria-labelledby');
    this.setWCAGAttributesToSearchField();
    this.setWCAGAttributesToTags();
  } else {
    var renderedSpanElement = this.getRenderedSelect().find('.select2-selection__rendered');
    $(renderedSpanElement).attr('role', 'textbox');
    var placeholder = $(renderedSpanElement).find('.select2-selection__placeholder');
    if ($(placeholder).length > 0) {
      $(renderedSpanElement).attr('title', $(placeholder).text());
    }
  }
  this.selectListOpenHandler();
  this.selectListCloseHandler();
};

/**
 * returns the current rendered select2 element
 * @returns {*}
 */
Select.prototype.getRenderedSelect = function () {
  return this.$element.next('.select2');
};

/**
 * set wcag attributes to the search input field of multiple selection box
 */
Select.prototype.setWCAGAttributesToSearchField = function () {
  var inputSearchField = this.$element.next('.select2').find('.select2-search__field');
  $(inputSearchField).attr({
    role: 'combobox',
    id: "".concat(this.elId, "__text"),
    'aria-haspopup': true,
    'aria-expanded': false,
    'aria-owns': "".concat(this.elId, "-SelectedList")
  });
  this.keydownHandlerByInputSearchField(inputSearchField);
};

/**
 * set wcag attributes to selected tags of multiple select box
 */
Select.prototype.setWCAGAttributesToTags = function () {
  var multipleSelection = this.$element.next('.select2').find('.select2-selection--multiple');
  $(multipleSelection).find('.select2-selection__choice__remove').attr('aria-hidden', true);
  $(multipleSelection).find('.select2-selection__choice').each(function (index, tag) {
    var tagWithoutChildren = $(tag).clone().children().remove().end();
    var replaceText = tagWithoutChildren.text() || tagWithoutChildren[0].title;
    $(tag).attr({
      role: 'button',
      'aria-label': window.getMessage('label.button.removeItem', replaceText)
    });
  });
};

/**
 * update labelledby attribute with current elements of unvisible activedescendant list element
 */
Select.prototype.updateLabelledbyAttributes = function () {
  var renderedSelectElement = this.$element.next('.select2').find('.select2-selection--single');
  var labelId = "select2-".concat(this.elId, "-container_onId");
  if (this.isMulti === true) {
    labelId = "select2-".concat(this.elId, "-container");
    renderedSelectElement = this.$element.next('.select2').find('.select2-search__field');
    $(renderedSelectElement).attr('aria-describedby', this.getActivedescendantListElementIds());
  }
  $(renderedSelectElement).attr('aria-labelledby', labelId);
};

/**
 * returns a concatination of IDs of all listelements of the unvisible activedescendant list
 * @returns {string}
 */
Select.prototype.getActivedescendantListElementIds = function () {
  var selectedIds = '';
  var li = this.getActivedescendantList();
  $(li).children().each(function (i, e) {
    selectedIds += "".concat($(e).attr('id'), " ");
  });
  return selectedIds;
};

/**
 * select list open handler
 */
Select.prototype.selectListOpenHandler = function () {
  this.selectOpeningEventHandler();
  this.selectOpenEventHandler();
  this.selectOnSelectedEvent();
};

/**
 * select2 opening handler
 */
Select.prototype.selectOpeningEventHandler = function () {
  var _this3 = this;
  $(this.$element).off('select2:opening');
  $(this.$element).on('select2:opening', function () {
    // #. Clear the locked values
    _this3.lockedValues = [];
    _this3.innerOptGroupData = {};
    var liveEle = $('.select2-container--open').attr('role', 'application').find('.select2-results__option[aria-live]');
    if (liveEle.length > 0) {
      $('.select2-container--open').attr('role', 'region').attr('aria-live', 'polite');
    }
    if (_this3.isMulti === true) {
      var selectInput = _this3.$element.next('.select2').find('.select2-search__field');
      var selectionMultiple = $(selectInput).closest('.select2-selection--multiple');
      $(selectionMultiple).removeAttr('role', 'aria-haspopup', 'aria-expanded', 'aria-labelledby', 'aria-activedescendant');
      $(selectInput).attr({
        'aria-expanded': true,
        'aria-activedescendant': $(_this3.getActivedescendantList().children().first()).attr('id')
      });
    }
  });
};

/**
 * select2 select handler
 */
Select.prototype.selectOnSelectedEvent = function () {
  var _this4 = this;
  // #. Clear the search term from input after selecting the value
  // #. Do not off select2:select - event because it is used in name-search
  if (this.isMulti === true && this.config.tags) {
    $(this.$element).on('select2:select', function (e) {
      var selectInput = _this4.$element.next('.select2').find('.select2-search__field');
      $(selectInput).val('');
    });
  }
};

/**
 * select2 open handler
 */
Select.prototype.selectOpenEventHandler = function () {
  var _this5 = this;
  $(this.$element).off('select2:open');
  $(this.$element).on('select2:open', function () {
    // add label to search input field of select2 result list and the result list itself
    var combobox = _this5.getRenderedSelect().find('[role=combobox]');
    var labels = $(combobox).attr('aria-labelledby');
    labels && $(labels.split(' ')).each(function (i, label) {
      if (label.indexOf('-container') > 0) {
        var labelId = "selectList_search_".concat(_this5.elId, "_label");
        if (!$("selectList_".concat(_this5.elId, "_label"))) {
          var hiddenLabel = $('<span/>').addClass('hideContainer').attr('id', "selectList_".concat(_this5.elId, "_label")).text(window.getMessage('search.placeholder'));
          $('.select2-container--open').find('input.select2-search__field').before($(hiddenLabel)).attr('aria-labelledby', labelId + ' ' + label);
        }
        var resultListBox = $('.select2-container--open .select2-results').find('[role=listbox]');
        $(resultListBox).attr('aria-label', window.getMessage('select.resultList.label', $("#".concat(label)).text()));
      }
    });
    var inputSearchField = $('.select2-container--open').find('input.select2-search__field');
    _this5.updateActivedescendantAttribute(inputSearchField);
    document.querySelector('.select2-container--open .select2-search__field').focus();
    // this.keydownHandlerByInputSearchField(inputSearchField);
    if (_this5.config.checkBoxSelection) {
      $('.select2-results').addClass('select-checkbox-selection-enabled');
      window.setTimeout(function () {
        _this5.handleOptgroupCheckBoxState();
      }, 75);
    }
  });
};

/**
 * select list close handler
 * @param inputListEle
 */
Select.prototype.selectListCloseHandler = function (inputListEle) {
  var _this6 = this;
  $(this.$element).off('select2:close');
  $(this.$element).on('select2:close', function () {
    $(inputListEle).attr('aria-expanded', false);
    if (_this6.config.checkBoxSelection) {
      $('.select2-results').removeClass('select-checkbox-selection-enabled');
    }
  });
};

/**
 * select list unselecting handler
 * @param
 */
Select.prototype.selectListUnselectingHandler = function () {
  $(this.$element).off('select2:unselecting');
  // #. Do not allow to remove an locked item
  $(this.$element).on('select2:unselecting', function (e) {
    if ($(e.params.args.data.element).attr('locked')) {
      e.preventDefault();
    }
  });
};

/**
 * keydown handler of given element
 * @param inputSearchField
 */
Select.prototype.keydownHandlerByInputSearchField = function (inputSearchField) {
  var _this7 = this;
  var opGroupChkState = (0, _lodash.debounce)(this.handleOptgroupCheckBoxState.bind(this), 100);
  $(inputSearchField).on('keydown', function (event) {
    if (_this7.config.checkBoxSelection) {
      _this7.onSelectKeyDownEvent(inputSearchField, event);
    } else {
      _this7.updateActivedescendantAttribute(inputSearchField, event.keyCode);
    }
    opGroupChkState();
  });
};

/**
 * Handle the keydown event only for the checkbox selection enabled controls
 * @param inputSearchField
 * @param event
 * @returns {boolean}
 */
Select.prototype.onSelectKeyDownEvent = function (inputSearchField, event) {
  var _this8 = this;
  var keyCode = event.keyCode;
  var $activeOption = this.getActiveOptionElement();
  var rt = true;
  switch (keyCode) {
    case _keyCodes.default.ENTER:
    case _keyCodes.default.SPACE:
      event.preventDefault();
      this.onSelectionEvent($activeOption);
      break;
    case _keyCodes.default.ARROW_DOWN:
      setTimeout(function () {
        _this8.onArrowDownPressedChkSelection($activeOption);
      }, 50);
      rt = false;
      break;
    case _keyCodes.default.ARROW_UP:
      setTimeout(function () {
        _this8.onArrowUpPressedChkSelection($activeOption);
      }, 50);
      rt = false;
      break;
    case _keyCodes.default.KeyA:
      if (event.ctrlKey) {
        this.onSelectAllEvent($activeOption);
      }
      break;
    default:
      break;
  }
  this.updateActivedescendantAttribute(inputSearchField, event.keyCode);
  return rt;
};

/**
 * Get active/highlighted option element
 * @returns {*}
 */
Select.prototype.getActiveOptionElement = function () {
  var listElements = $('.select2-container--open').find('.select2-dropdown').find('.select2-results__option[aria-selected]');
  return this.getHighlightedItem(listElements);
};

/**
 * Ctrl + A - select all opt groups items
 * @param $activeOption
 */
Select.prototype.onSelectAllEvent = function ($activeOption) {
  var $parentGroup = $activeOption.closest('.select2-results__option[role="group"]');
  // #. Select all items under the optgroup
  if ($parentGroup.length > 0) {
    $parentGroup.find('.select2-checkbox-selection.optgroup').click();
  }
};

/**
 * Handle the Space/Enter key selection events
 * @param $activeOption
 * @returns {boolean}
 */
Select.prototype.onSelectionEvent = function ($activeOption) {
  // #. Inner optgroup elements are binding with click events
  if ($activeOption.find('.inner-optgroup').length > 0) {
    $activeOption.click();
    return true;
  }

  // #. Normal options are binding with the mouseup event
  $activeOption.mouseup();
};

/**
 * Handle the arrow down event
 * @param $activeOption
 */
Select.prototype.onArrowDownPressedChkSelection = function ($activeOption) {
  // #. Get next option
  var $next = $activeOption.next('.select2-results__option[role="option"]');
  $('.select2-results__option.select2-results__option--highlighted').removeClass('select2-results__option--highlighted');
  if ($next.length === 0) {
    // #. Find parent group if inside a group else find next group
    var $parentGroup = $activeOption.closest('.select2-results__option[role="group"]');
    var $nextOptGroup = $parentGroup.length > 0 ? $parentGroup.next('.select2-results__option') : $activeOption.next('.select2-results__option');
    var role = $nextOptGroup.attr('role');
    if ($nextOptGroup.length > 0 && role === 'group') {
      $nextOptGroup.find('.select2-results__option').first().addClass('select2-results__option--highlighted');
    } else if (role === 'option') {
      $nextOptGroup.addClass('select2-results__option--highlighted');
    }
  } else {
    $next.addClass('select2-results__option--highlighted');
  }
};

/**
 * Handle the arrow up event
 * @param $activeOption
 */
Select.prototype.onArrowUpPressedChkSelection = function ($activeOption) {
  var $prev = $activeOption.prev('.select2-results__option[role="option"]');
  $('.select2-results__option.select2-results__option--highlighted').removeClass('select2-results__option--highlighted');
  if ($prev.length === 0) {
    var $parentGroup = $activeOption.closest('.select2-results__option[role="group"]');
    var $prevOptGroup = $parentGroup.length > 0 ? $parentGroup.prev('.select2-results__option') : $activeOption.prev('.select2-results__option');
    var role = $prevOptGroup.attr('role');
    if ($prevOptGroup.length > 0 && role === 'group') {
      $prevOptGroup.find('.select2-results__option').last().addClass('select2-results__option--highlighted');
    } else if (role === 'option') {
      $prevOptGroup.addClass('select2-results__option--highlighted');
    }
  } else {
    $prev.addClass('select2-results__option--highlighted');
  }
};

/**
 * update attribute activedescendant of given element and by given keycode
 * @param el
 * @param keycode
 */
Select.prototype.updateActivedescendantAttribute = function (el, keycode) {
  var activeDescendantId = this.getActiveDescendantId(this.getActiveOptionElement(), keycode, el);
  var $activeEl = $("#".concat($.escapeSelector(activeDescendantId)));
  if ($activeEl.find('.inner-optgroup').length > 0) {
    $activeEl.attr('aria-disabled', false);
  }
  if (activeDescendantId) {
    $(el).attr('aria-activedescendant', activeDescendantId);
  } else {
    $(el).attr('aria-activedescendant', this.getRenderedSelect().find('[role=combobox]').attr('aria-activedescendant'));
  }
};

/**
 * get id of active descendant of given list item and by given keycode
 * @param item
 * @param keycode
 * @param el
 * @returns {string}
 */
Select.prototype.getActiveDescendantId = function (item, keycode, el) {
  var activeDescendantId = '';
  switch (keycode) {
    case _keyCodes.default.ARROW_DOWN:
      activeDescendantId = $(item).next().attr('id');
      activeDescendantId = activeDescendantId || $(item).attr('id');
      break;
    case _keyCodes.default.ARROW_UP:
      activeDescendantId = $(item).prev().attr('id');
      activeDescendantId = activeDescendantId || $(item).attr('id');
      break;
    case _keyCodes.default.ARROW_LEFT:
      $(el).removeAttr('aria-activedescendant');
      break;
    default:
      if ($(el).text() === '') {
        activeDescendantId = $(item).attr('id');
      }
      break;
  }
  return activeDescendantId;
};

/**
 * get highlighted item of given list elements
 * @param listElements
 * @returns {*}
 */
Select.prototype.getHighlightedItem = function (listElements) {
  var highlightedItem = null;
  $(listElements).each(function (i, el) {
    if ($(el).hasClass('select2-results__option--highlighted')) {
      highlightedItem = $(el);
      return false;
    }
  });
  return highlightedItem;
};

/**
 * init active descendant list
 */
Select.prototype.initActivedescendantList = function () {
  var list = $('<ul/>').attr({
    id: "".concat(this.elId, "-SelectedList"),
    role: 'listbox',
    'aria-multiselectable': this.isMulti,
    'aria-expanded': false,
    tabindex: -1
  }).addClass('hideContainer');
  if (this.getActivedescendantList().length === 0) {
    $(this.getRenderedSelect().find('[role=combobox]')).append(list);
  }
};

/**
 * update activedescendent list
 */
Select.prototype.updateActivedescendantList = function () {
  var _this9 = this;
  var list = this.getActivedescendantList();
  var selectedValues = this.getSelectedValues();
  $(list).children().remove();
  selectedValues.forEach(function (val, index) {
    var valText = _this9.getAllItemsBy(function (obj, index) {
      return obj.value === val;
    });
    $(list).append($('<li/>').attr({
      id: _this9.elId + index,
      role: 'option',
      'aria-selected': true
    }).text(valText[0].text));
  });
};

/**
 *
 * @returns {jQuery|HTMLElement}
 */
Select.prototype.getActivedescendantList = function () {
  return $("#".concat(this.elId, "-SelectedList"));
};

/**
 * Access keyboard functionality
 */
Select.prototype.initKeyBoardAccess = function () {
  var _this10 = this;
  var inlineField = this.$element.next().find('input[type="search"]');
  var uiChildElement = $(inlineField).parent().siblings().attr('tabIndex', -1);
  $(inlineField).on('keydown', function (e) {
    if (e.which === _keyCodes.default.ARROW_LEFT || e.keyCode === _keyCodes.default.ARROW_LEFT) {
      $(inlineField).parent().prev().focus();
      e.stopPropagation();
    }
  });
  uiChildElement.on('keydown', function (e) {
    _this10.keyDownEventHandler(e);
  });
};

/**
 * Initialize the keydown event for the single select element
 **/
Select.prototype.initSingleSelectKeyBoardAccess = function () {
  var _this11 = this;
  var select2elId = this.elId;
  var $element = $("#".concat(select2elId));
  var $subEl = $element.next('.select2').find('.select2-selection');
  $subEl.on('keydown', function (event) {
    _this11.singleSelectKeyHandler(event);
  });
};

/**
 * Single select key handler
 **/
Select.prototype.singleSelectKeyHandler = function (event) {
  var result = true;
  if (this.isResultVisible()) {
    return true;
  }
  switch (event.which || event.keyCode) {
    case _keyCodes.default.ARROW_DOWN:
    case _keyCodes.default.ARROW_UP:
      this.$element.select2('open');
      break;
    default:
      result = this.onSingleSelectAlphaNumeric(event);
      break;
  }
  return result;
};

/**
 * Check whether the result dropdown is visible or not
 **/
Select.prototype.isResultVisible = function () {
  return $('.select2-container .select2-results').is(':visible');
};

/**
  * @param {Event} e the keydown event
**/
Select.prototype.keyDownEventHandler = function (e) {
  switch (e.which || e.keyCode) {
    case _keyCodes.default.ARROW_LEFT:
      $(e.target).prev().focus();
      break;
    case _keyCodes.default.ARROW_RIGHT:
      var next = $(e.target).next();
      if (next.hasClass('select2-search')) {
        next.children('input').focus();
      } else {
        next.focus();
      }
      break;
    case _keyCodes.default.SPACE:
    case _keyCodes.default.ENTER:
      e.preventDefault();
      if ($(e.target).hasClass('select2-selection__choice')) {
        $(e.target).find('.select2-selection__choice__remove').click();
        e.stopPropagation();
      }
      break;
    default:
      return false;
  }
};

/**
 * Handle single select alphabets and numeric keycodes
 * Alphabets and numeric keycodes should open the data list
 **/
Select.prototype.onSingleSelectAlphaNumeric = function (event) {
  // #. Get character code from the keycode
  var char = String.fromCharCode(event.keyCode);

  // #. Check whether the character is alphabet or numeric
  // #. true will open the options list
  if (/[a-zA-Z0-9]/.test(char)) {
    this.$element.select2('open');
  }
  return true;
};

/**
 * @deprecated because it uses eval
 * @returns {this}
 */
Select.prototype.runInScope = function (stringToEval) {
  // TODO: dont use eval=evil
  eval(stringToEval);
  return this;
};

/**
 * @param {string} value
 * @returns {boolean}
 */
Select.prototype.getIsValueExclusive = function (value) {
  return this.isMulti && this.$element.find("option[value=\"".concat(value, "\"]")).first().is('[data-exclusive]');
};

/**
 * @returns {string}
 */
Select.prototype.getSelectedValue = function () {
  try {
    return this.isMulti ? this.getSelectedValues() : this.$element[0][this.$element.prop('selectedIndex')].value || '';
  } catch (e) {
    return ''; // return empty strings for compatibility reasons (lots of indexOf checks happening)
  }
};

/**
 * @returns {string[]}
 */
Select.prototype.getSelectedValues = function () {
  return [].concat(this.$element.val() || []);
};

/**
 * @returns {string}
 */
Select.prototype.getSelectedText = function () {
  return $(this.$element[0][this.$element.prop('selectedIndex')]).text();
};
Select.prototype.getSelectedIndex = function () {
  try {
    return this.isMulti ? 0 : this.$element.prop('selectedIndex');
  } catch (e) {
    return 0; // return empty strings for compatibility reasons (lots of indexOf checks happening)
  }
};

/**
 * @param {string} value
 * @param {string} text
 * @returns {this}
 */
Select.prototype.setComboValueAndText = function (value, text) {
  this.selectByValue(value, text);
  return this;
};

/**
 * @returns {this}
 */
Select.prototype.reset = function () {
  var _this = this;
  this.$element.html('');
  this.initialData.forEach(function (item) {
    // TODO: fix optgroups
    var disabled = item.disabled ? ' disabled="disabled"' : '';
    var selected = item.selected ? ' selected="selected"' : '';
    _this.$element.append("<option value=\"".concat(item.value, "\"").concat(disabled).concat(selected, ">").concat(item.text, "</option>"));
  });
  return this;
};

/**
 * @deprecated does nothing and is just kept to not break existing calls to this function
 * @returns {this}
 */
Select.prototype.focus = function () {
  // do nothing, just a dummy
  return this;
};

/**
 * @deprecated use selectByValue instead
 * @param {string} value
 * @returns {this}
 */
Select.prototype.select = function (value) {
  this.selectByValue(value);
  return this;
};

/**
 * @returns {this}
 */
Select.prototype.deselectAll = function () {
  this.select(null);
  return this;
};

/**
 * @returns {this}
 */
Select.prototype.rebuild = function () {
  this.$element.select2(this.config);
  this.initScreenreaderAccess();
  if (this.isMulti !== true) {
    this.initSingleSelectKeyBoardAccess();
  } else {
    this.initKeyBoardAccess();
  }
  return this;
};

/**
 * @param {string} value
 * @returns {string}
 */
Select.prototype.getCustomLabel = function (value) {
  return this.config.customValueFormat ? fcom.util.StringHelper.formatMessage(this.config.customValueFormat, value) : value; // TODO: stop using formatmessage here
};

/**
 * @param {string} value
 * @param {string} text
 * @returns {string}
 */
Select.prototype.getCustomValueOption = function (value, text) {
  text = text || this.getCustomLabel(value);
  return "<option value=\"".concat(value, "\">").concat(text, "</option>");
};

/**
 * @param {string} value
 * @param {string} customText
 * @returns {boolean} true if the value could be selected
 */
Select.prototype.selectByValue = function (value, customText) {
  value = value === null ? '' : value;
  var hasValue = this.hasValue(value);
  if ((customText || !hasValue) && this.config.tags) {
    hasValue = true; // signal successful select by value
    this.reset();
    this.$element.append(this.getCustomValueOption(value, customText));
    this.rebuild();
  }
  if (hasValue && value !== this.getSelectedValue()) {
    this.$element.val(value).trigger('change');
  }
  return hasValue;
};

/**
 * @param {string[]}
 * @returns {this}
 */
Select.prototype.selectByValues = function (values) {
  this.addCustomValues(values);
  this.$element.val(values).trigger('change');
  return this;
};

/**
 * @param {number} index
 * @returns {boolean} true if the index existed and could be selected
 */
Select.prototype.selectItemByIndex = function (index) {
  var item = this.getItems()[index];
  if (!item) {
    return false;
  }
  this.$element.val(item.value).trigger('change');
  return true;
};

/**
 * @param {string[]}
 * tags: true allow user to add custom values to the input
 * @returns {this}
 */
Select.prototype.addCustomValues = function (values) {
  var _this12 = this;
  if (this.config.tags && Array.isArray(values)) {
    values.forEach(function (value) {
      var $option = _this12.$element.find("option[value=\"".concat(value, "\"]"));
      if ($option.length === 0) {
        var $newOption = new Option(value, value, true, true);
        _this12.$element.append($newOption);
      }
    });
  }
  return this;
};

/**
 * @param {Object[]} items
 * @returns {this}
 */
Select.prototype.replaceItems = function (items) {
  var _this = this;
  this.$element.html('');
  items.forEach(function (item) {
    var disabled = item.disabled ? ' disabled="disabled"' : '';
    var selected = item.selected ? ' selected="selected"' : '';
    _this.$element.append("<option value=\"".concat(item.value, "\"").concat(disabled).concat(selected, ">").concat(item.text, "</option>"));
  });
  this.rebuild();
  return this;
};
Select.prototype.addItem = function (value, displayName, index) {
  if (!displayName) {
    displayName = value;
  }
  if (index == null) {
    index = this.getItems().length;
  }
  var element = this.$element[0];
  var option = document.createElement('option');
  option.text = displayName;
  option.value = value;
  element.add(option, element[index]);
  this.rebuild();
  return this;
};

/**
 * @returns {Object[]}
 */
Select.prototype.getItems = function () {
  var _this = this;
  return this.$element.find('option').map(function (i, el) {
    return {
      text: $(el).text(),
      value: $(el).val(),
      selected: $(el).attr('[selected]'),
      disabled: $(el).is(':disabled'),
      node: el,
      cfg: {
        setProperty: function setProperty(prop, value) {
          $(el).prop(prop, value);
          _this.rebuild();
        },
        getProperty: function getProperty(prop) {
          $(el).prop(prop);
        }
      }
    };
  }).get();
};

/**
 * @deprecated use getItems instead
 * @returns {Object[]}
 */
Select.prototype.getItemData = function () {
  // just an alias for getItems
  return this.getItems();
};

/**
 * @param {function} filterFunction
 * @returns {Object[]}
 */
Select.prototype.getAllItemsBy = function (filterFunction) {
  return this.getItems().filter(filterFunction);
};

/**
 * @param {string} value
 * @returns {boolean}
 */
Select.prototype.hasValue = function (value) {
  return !!this.getItems().filter(function (item) {
    return item.value == value;
  } /* from many places we are passing numeric values, but the dom value is string */).length;
};

/**
 * @param {string} value
 * @returns {boolean}
 */
Select.prototype.isCustomValue = function (value) {
  return !this.initialData.filter(function (item) {
    return item.value === value;
  }).length;
};

/**
 * @param {string} value
 * @param {boolean} disabled
 * @returns {this}
 */
Select.prototype.disableByValue = function (value, disabled) {
  var _this = this;
  disabled = disabled === false ? disabled : true;
  this.getItems().filter(function (item) {
    return item.value === value;
  }).forEach(function (item) {
    $(item.node).prop('disabled', disabled);
    _this.rebuild();
  });
  return this;
};

/**
 * @returns {this}
 */
Select.prototype.disable = function () {
  this.$element.prop('disabled', true);
  this.$element.data('select2')._syncAttributes();
  return this;
};

/**
 * @returns {this}
 */
Select.prototype.enable = function () {
  this.$element.prop('disabled', false);
  this.$element.data('select2')._syncAttributes();
  return this;
};

/**
 * @returns {boolean}
 */
Select.prototype.getIsDisabled = function () {
  return this.$element.is(':disabled');
};

/**
 * Set printbg class to multi-selection choices
 **/
Select.prototype.setPrintViewClass = function () {
  this.$element.next('.select2').find('.select2-selection--multiple .select2-selection__choice').addClass('printbg');
};
Select.prototype.setSelectedItemValues = function (selectedValues) {
  this.$element.next('.select2').find('.select2-selection--multiple .select2-selection__choice').each(function (index, element) {
    if (selectedValues[index]) {
      $(element).attr('data-value', selectedValues[index]);
    }
  });
};

/**
 * @method setCheckBoxResultTemplate
 * @description add checkbox input inside the selection option
 * @param params
 * @returns {*|jQuery}
 */
Select.prototype.setCheckBoxResultTemplate = function (params, container) {
  var _this13 = this;
  // #. Add locked class to the container
  if ($(params.element).attr('locked')) {
    this.lockedValues.push(params.id);
    $(container).addClass('locked');
  }

  // #. Create wrapper
  var $wrapper = $('<span class="select2-checkbox-selection"></span>');
  // #. Create checkbox input
  var $checkBox = $('<input />').attr({
    type: 'checkbox',
    'data-item': params.id || '',
    disabled: params.disabled
  }).prop('checked', this.isOptionSelected(params.id)).addClass('checkbox unformatted selection');

  /**
   * #. Normally optgroup elements are just like labels
   * #. Here we have to add select all like checkbox for the group
   * #. Bind click event for the optgroup wrapper
   */
  if ($(params.element).is('optgroup')) {
    if (this.isMulti) {
      $wrapper.click(function (e) {
        var childValues = (params.children || []).map(function (item) {
          if (!$(item.element).attr('disabled')) {
            return item.id;
          }
        });
        _this13.onOptGroupSelected(childValues, _this13.isOptgorupSelected(e));
      });
      $wrapper.addClass('optgroup').data('child-items', params.children);

      // #. Add parent element a css class to handle th UI
      $(container).addClass('selection-enabled-optgroup').on('mouseover', function () {
        var $highlightedItem = $('.select2-results__option.select2-results__option--highlighted');
        $highlightedItem.removeClass('select2-results__option--highlighted');
      });

      // #. Add an identifier class to checkbox
      $checkBox.addClass('optgroup');
    } else {
      $checkBox = '';
    }
  } else if (params.id) {
    // #. Handling the inner optgroup
    /**
     * inner optgroup is a concept which is actually not a real optgroup element
     * it is an option but contains more sub options values
     * values will be separated with | pipe
     * if the separated values have an existing option element will be consider as inner optgroup
     */
    var isInnerOpt = this.isInnerOptGroup(params);
    if (isInnerOpt) {
      $wrapper.addClass('inner-optgroup');
      $checkBox.addClass('inner-optgroup');
      // #. Arrange the inner optgroup
      this.setInnerOptGroup(params);
    } else {
      // #. options checkbox state handled via code
      $checkBox.click(function (e) {
        e.preventDefault();
      });
    }
  } else {
    $checkBox = '';
  }

  // #. Create the checkbox label
  var $label = $("<label class=\"checkbox\"></label>").text(params.text);

  // #. Create a wrapper and append the control
  return $wrapper.append($checkBox, $label);
};

/**
 * @method setCountryFlagSpan
 * @description adds a span with the css for country flag images
 * @param params
 * @returns {*|jQuery}
 * */
Select.prototype.setCountryFlagSpan = function (params, container) {
  var isLocked = $(params.element).attr('locked');
  if (isLocked) {
    $(container).addClass('locked');
  }
  var $outerSpan = $('<span></span>');
  if (params.id) {
    var $span = $('<span></span>');
    $span.addClass('country ' + params.id);
    $outerSpan.append($span);
  }
  $outerSpan.append(params.text);
  return $outerSpan;
};

/**
 * @method isInnerOptGroup
 * @description check the option element is a inner optgroup
 * @param params
 * @returns {*|jQuery}
 */
Select.prototype.isInnerOptGroup = function (params) {
  var $option = $(params.element);
  var value = String(params.id);
  /**
   * Expectation: Inner optgroup is an option element, it is a custom concept
   * If an option has value with '|' separator we will take it as a inner optgroup
   * but the first value must be the value of next option item
   * Example: value: GOL|SIL -> then GOL is the value of next option element
   * Inner optgroup options value will not add to element
   * We split the value with '|' and insert as array items - same as add child items one by one
   * Inner optgroup state will be handled separately by code
   */
  if ($option.is('option') && value.includes('|')) {
    var values = value.split('|');
    var firstValue = values[0];
    // #. First value must be the next option element
    var $next = $option.next();
    var $findEl = $(this.$element).find("option[value=\"".concat(firstValue, "\"]"));
    // #. If next element is the first value option - it is a inner optgroup element
    return $next.is($findEl);
  }
  return false;
};

/**
 * @method setInnerOptGroup
 * @description Arrange inner optgroup
 * @param params
 * @returns {*|jQuery}
 */
Select.prototype.setInnerOptGroup = function (params) {
  var _this14 = this;
  // #. Disabled the inner optgroup
  var $option = $(params.element);
  $option.attr('disabled', 'disabled');
  // #. Keep the inner optgroup data
  var optionId = $option.data('select2-id');
  this.innerOptGroupData[optionId] = params.id;
  // #. Escape selector required to because the id value contains special characters
  var itemSelector = $.escapeSelector(params._resultId);
  // #. Click handled for disabled options
  // #. Inner optgroup option will be disabled and the click event handled here
  $(document).off('click', "#".concat(itemSelector));
  $(document).on('click', "#".concat(itemSelector), function (e) {
    _this14.onInnerOptGroupSelected(e, optionId);
  });
};

/**
 * @method onInnerOptGroupSelected
 * @description after inner opt group element clicked
 * @param params
 * @returns {*|jQuery}
 */
Select.prototype.onInnerOptGroupSelected = function (e, optionId) {
  var value = this.innerOptGroupData[optionId];
  var values = value.split('|');
  var $element = $(this.$element);
  var selectedValue = $element.val();
  var $checkbox = $(e.target).is('input.checkbox') ? $(e.target) : $(e.target).is('label.checkbox') ? $(e.target).prev() : $(e.target).find('input.checkbox');
  var isSelected = $(e.target).is('input.checkbox') ? $checkbox.prop('checked') : !$checkbox.prop('checked');
  // #. If selected, insert the new values else remove it
  if (isSelected) {
    selectedValue = _toConsumableArray(new Set([].concat(_toConsumableArray(selectedValue), _toConsumableArray(values))));
    $checkbox.prop('checked', true);
  } else {
    selectedValue = selectedValue.filter(function (item) {
      return values.indexOf(item) === -1;
    });
    $checkbox.prop('checked', false);
  }
  $element.val(selectedValue).change();
};

/**
 * @method isOptgorupSelected
 * @description check the optgroup is selected or not by event
 * @param params
 * @returns {*|jQuery}
 */
Select.prototype.isOptgorupSelected = function (event) {
  var $cTarget = $(event.target);
  var $checkbox = $(event.target).closest('li').find('input.checkbox').first();
  var isChecked = $checkbox.prop('checked');
  if ($cTarget.is('input.checkbox')) {
    return isChecked;
  } else {
    return !isChecked;
  }
};

/**
 * @method isOptionSelected
 * @description check the option is selected or not by event
 * @param params
 * @returns {boolean}
 */
Select.prototype.isOptionSelected = function (value) {
  var values = $(this.$element).val();
  if (this.isMulti) {
    return values.indexOf(value) !== -1;
  } else {
    return values === value;
  }
};

/**
* @method onOptGroupSelected
* @description handle dynamic optgroup checkbox selection
* @param params
* @returns {*|jQuery}
*/
Select.prototype.onOptGroupSelected = function (selectedValues, isSelected) {
  var $element = $(this.$element);
  var value = null;
  if (this.isMulti) {
    value = $element.val() || [];
    if (isSelected) {
      value = _toConsumableArray(new Set([].concat(_toConsumableArray(value), _toConsumableArray(selectedValues), _toConsumableArray(this.lockedValues))));
    } else {
      value = value.filter(function (item) {
        return selectedValues.indexOf(item) === -1;
      });
      value = _toConsumableArray(new Set([].concat(_toConsumableArray(value), _toConsumableArray(this.lockedValues))));
    }
  } else {
    value = selectedValues;
  }
  // #. Trigger the change event with the new values
  $element.val(value).change();
};

/**
 * @method handleCheckBoxSelection
 * @description handle dynamic checkbox selection
 * @param params
 */
Select.prototype.handleCheckBoxSelection = function (selectedValues) {
  var $selected = $('.select2-results.select-checkbox-selection-enabled').find('.select2-results__option[aria-selected]');
  $selected.attr('aria-selected', false);
  if (this.isResultVisible() && this.config.checkBoxSelection) {
    var $items = $('.select2-container .select2-results input.selection.checkbox[data-item]').not('.optgroup,.inner-optgroup');
    $items.prop('checked', false);
    if (this.isMulti) {
      var _iterator = _createForOfIteratorHelper(selectedValues),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var selectedValue = _step.value;
          var $item = $(".select2-container .select2-results input.selection.checkbox[data-item=\"".concat(selectedValue, "\"]"));
          $item.prop('checked', true);
          this.handleCheckBoxSelectionAriaAttr($item, true);
        }

        // #. Handle group checkbox state
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.handleOptgroupCheckBoxState();
    } else {
      var _$item = $(".select2-container .select2-results input.selection.checkbox[data-item=\"".concat(selectedValues, "\"]"));
      _$item.prop('checked', true);
      this.handleCheckBoxSelectionAriaAttr(_$item, true);
    }
  }
};

/**
 * @method handleCheckBoxSelectionAriaAttr
 * @description handle aria attributes checkbox selection
 * @param params
 */
Select.prototype.handleCheckBoxSelectionAriaAttr = function ($item, value) {
  var $container = $item.closest('li.select2-results__option');
  $container.attr('aria-selected', value);
};

/**
 * @method handleOptgroupCheckBoxState
 * @description State management method for optgroup checkbox
 */
Select.prototype.handleOptgroupCheckBoxState = function () {
  if (!this.config.checkBoxSelection) {
    return;
  }
  // #. Handle the inner optgroup state first
  this.handleInnerOptgroupCheckBoxState();

  // #. Handle main optgroup states
  var $items = $('.select2-container .select2-results input.selection.checkbox.optgroup');
  var _iterator2 = _createForOfIteratorHelper($items),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var $item = _step2.value;
      $item = $($item);
      var childValues = $item.parent().data('child-items') || [];
      childValues = childValues.map(function (item) {
        if (item.disabled !== true) {
          return item.id;
        }
      });
      // #. Selected items and active children count must be same for the checked state
      var selectedItems = $item.closest('li').find('ul.select2-results__options--nested').find('li input.selection.checkbox:checked');
      var isSelected = childValues.length === selectedItems.length;
      $item.prop('checked', isSelected);
      $item.closest('.selection-enabled-optgroup').attr('aria-selected', isSelected);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
};

/**
 * @method handleInnerOptgroupCheckBoxState
 * @description State management method for inner optgroup checkbox
 * Child elements values separated by '|'
 * The count values and checked items must be same for the checked state
 */
Select.prototype.handleInnerOptgroupCheckBoxState = function () {
  var _this15 = this;
  var items = Object.keys(this.innerOptGroupData);
  var _loop = function _loop() {
    var value = String(_this15.innerOptGroupData[items[i]]);
    var values = value.split('|');
    var selectedValues = $(_this15.$element).val();
    var isAllSelected = values.every(function (x) {
      return selectedValues.indexOf(x) !== -1;
    });
    var $checkbox = $(".select2-results__option input.checkbox[data-item=\"".concat(value, "\"]"));
    $checkbox.prop('checked', isAllSelected);
    _this15.handleCheckBoxSelectionAriaAttr($checkbox, isAllSelected);
  };
  for (var i = 0; i < items.length; i++) {
    _loop();
  }
};
window.fcom.Select = Select;
var _default = exports.default = Select;

},{"lodash":3,"util/enums/keyCodes":2}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var KEYCODE = {
  ENTER: 13,
  SPACE: 32,
  ESCAPE: 27,
  ARROW_LEFT: 37,
  ARROW_UP: 38,
  ARROW_RIGHT: 39,
  ARROW_DOWN: 40,
  TAB: 9,
  KeyA: 65,
  KeyD: 68,
  DELETE: 46
};
var _default = exports.default = KEYCODE;

},{}],3:[function(require,module,exports){
(function (global){(function (){
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    define(function() {
      return _;
    });
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}]},{},[1]);
;
var Dom=YAHOO.util.Dom;YAHOO.fcom.ShuffleList=function(e,t,i){if(e&&null!=e){1==YAHOO.lang.isString(e)?this.element=Dom.get(e):this.element=e,this.items={},Dom.addClass(this.element,"yuimenu shufflelist ddcontainer");var l=document.createElement("div");this.element.appendChild(l),Dom.addClass(l,"bd yui-menu-body-scrolled-fix-width"),this.ulElem=document.createElement("ul"),l.appendChild(this.ulElem),Dom.addClass(this.ulElem,"first-of-type"),i&&i.width&&Dom.setStyle(this.ulElem,"width",i.width),i&&i.resetable&&(this.resetable=i.resetable,this.originalSortMap={});for(var o=0;o<t.length;o++){var s=t[o].value,n=(null!=t[o].text&&(s=t[o].text),document.createElement("li")),s=(Dom.generateId(n),this.ulElem.appendChild(n),Dom.addClass(n,"yuimenuitem shuffleitem"),Dom.setStyle(n,"cursor","move"),n.innerHTML=s,new YAHOO.fcom.ShuffleItem(n,e.id,{position:t[o].position,value:t[o].value,parent:this}));this.items[n.id]=s,this.resetable&&(this.originalSortMap[n.id]=o)}this.readyLoaded=!0}},YAHOO.fcom.ShuffleList.prototype={getPositions:function(){for(var e=Dom.getChildrenBy(this.ulElem,function(e){return"li"==e.nodeName.toLowerCase()}),t=new Array(e.length),i=0;i<e.length;i++)t[i]=this.items[e[i].id].position;return t},sortItems:function(e){var t,i=[];for(t in this.items){var l=this.items[t];i.push(l),this.ulElem.removeChild(l.element)}i.sort(null!=e?e:this.doSortByValue);for(var o=0;o<i.length;o++)this.ulElem.appendChild(i[o].element)},doSortByValue:function(e,t){if(null!=e.value&&null!=t.value){var i=e.value,l=t.value;if(YAHOO.lang.isString(e.value)&&YAHOO.lang.isString(t.value)&&(i=i.toLowerCase(),l=l.toLowerCase()),i<l)return-1;if(l<i)return 1}return 0},reset:function(){var i;this.originalSortMap&&(i=this).sortItems(function(e,t){e=i.originalSortMap[e.element.id],t=i.originalSortMap[t.element.id];return e<t?-1:t<e?1:void 0})}},YAHOO.fcom.ShuffleItem=function(e,t,i){YAHOO.fcom.ShuffleItem.superclass.constructor.call(this,e.id,t,i);t=this.getDragEl();Dom.setStyle(t,"opacity",.6),this.goingUp=!1,this.lastY=0,this.position=i.position,this.value=i.value,this.parent=i.parent,this.element=e},YAHOO.extend(YAHOO.fcom.ShuffleItem,YAHOO.util.DDProxy,{startDrag:function(){var e=this.getDragEl(),t=this.getEl();Dom.setStyle(t,"visibility","hidden"),e.innerHTML=t.innerHTML,Dom.setStyle(e,"color",Dom.getStyle(t,"color")),Dom.addClass(e,"shufflelistitem dragged"),Dom.setStyle(e,"backgroundColor",Dom.getStyle(t,"backgroundColor")),Dom.setStyle(e,"border",""),Dom.setStyle(e,"font-size",Dom.getStyle(t,"font-size")),Dom.setStyle(e,"font-family",Dom.getStyle(t,"font-family"))},endDrag:function(){var e=this.getDragEl();Dom.setStyle(e.id,"visibility","hidden"),Dom.setStyle(this.id,"visibility","")},onDrag:function(e){e=YAHOO.util.Event.getPageY(e);e<this.lastY?this.goingUp=!0:e>this.lastY&&(this.goingUp=!1),this.lastY=e},onDragOver:function(e,t){var i,l=this.getEl(),t=Dom.get(t);"li"==t.nodeName.toLowerCase()&&(i=t.parentNode,this.goingUp?i.insertBefore(l,t):YAHOO.fcom.Dom.appendBehind(l,t),window.DDM.refreshCache())}});
//# sourceMappingURL=ShuffleList.js.map;
YAHOO.fcom.CascadedMenuItem=function(e,s){this.SUBMENU_TYPE=YAHOO.fcom.CascadedMenu,YAHOO.fcom.CascadedMenuItem.superclass.constructor.call(this,e,s),this.active=s.active,this.code=s.code,this.readyLoaded=!0},YAHOO.extend(YAHOO.fcom.CascadedMenuItem,YAHOO.widget.MenuItem),YAHOO.fcom.CascadedMenu=function(e,s){this.ITEM_TYPE=YAHOO.fcom.CascadedMenuItem,YAHOO.fcom.CascadedMenu.superclass.constructor.call(this,e,s),this.lastHidden=0,this.subscribe("click",function(e,s){!0===s[1].active&&this.cfg.setProperty("visible",!1)},this,!0)},YAHOO.extend(YAHOO.fcom.CascadedMenu,YAHOO.widget.Menu,{hide:function(){this.getRoot()==this&&(this.lastHidden=(new Date).getTime()),YAHOO.fcom.CascadedMenu.superclass.hide.call(this)},show:function(e,s){(new Date).getTime()-this.lastHidden<500||YAHOO.fcom.CascadedMenu.superclass.show.call(this,e,s)}});
//# sourceMappingURL=CascadedMenu.js.map;
YAHOO.fcom.TextValueInput=function(t,e,n){this.textField=Dom.get(t),this.hiddenField=Dom.get(e),this.hiddenResetValue=this.hiddenField.value,this.lastTextFieldContent=this.textField.value,n&&null!=n&&n.onChangeString&&null!=n.onChangeString&&(this.onChangeString=n.onChangeString),this.changeEvent=new YAHOO.util.CustomEvent("onChange",this,!1,YAHOO.util.CustomEvent.LIST),this.textChanged=!1,YAHOO.util.Event.addListener(this.textField,"keyup",function(t,e){e.keyPressed(t)},this,!0),YAHOO.util.Event.addListener(this.textField,"blur",function(t,e){e.checkForInputChange()},this,!0),this.readyLoaded=!0,window.domToYUIMap[this.textField.id]=this},YAHOO.fcom.TextValueInput.prototype={setValue:function(t){this.hiddenField.value=t},getValue:function(){return this.hiddenField.value},setText:function(t){this.textField.value=t,this.lastTextFieldContent=this.textField.value},getText:function(){return this.textField.value},setManualInputCorrectionHandler:function(t){this.manualInputHandler=t},_submitTextChange:function(){if(1==this.textChanged){this.textChanged=!1;var inputContent=this.textField.value,hiddenContent=inputContent,ipTextAndValue,inputContent,hiddenContent;if(this.manualInputHandler&&(ipTextAndValue=this.manualInputHandler(inputContent),inputContent=ipTextAndValue[0],hiddenContent=ipTextAndValue[1]),null!=hiddenContent&&(this.hiddenField.value=hiddenContent),this.textField.value=inputContent,this.lastTextFieldContent=inputContent,null!=this.onChangeString)try{eval(this.onChangeString)}catch(e){console.error("Exception "+e+" while trying to call on change handler in drop menu: "+this.onChangeString)}}else if(null!=this.onChangeString)try{eval(this.onChangeString)}catch(e){console.error("Exception "+e+" while trying to call on change handler in drop menu: "+this.onChangeString)}this.changeEvent.fire()},keyPressed:function(t){return 13==((t=t||window.event).which||t.keyCode)?this.textChanged?this._submitTextChange():(this.textField.blur(),this.textField.focus()):this.checkForInputChange(),!0},checkForInputChange:function(){this.lastTextFieldContent!=this.textField.value&&(this.hiddenField.value=this.textField.value,this.textChanged=!0,this.lastTextFieldContent=this.textField.value)},reset:function(){this.hiddenField.value=this.hiddenResetValue}};
//# sourceMappingURL=TextValueInput.js.map;
YAHOO.fcom.DateInput=function(hiddenInputElement,configObject){this.hiddenField=Dom.get(hiddenInputElement),null==configObject&&(configObject={}),this.config=configObject,this.config.noTimezoneCorrection||(this.config.noTimezoneCorrection=!1),this.dayField=Dom.get(this.hiddenField.id+"__DAY"),this.monthField=Dom.get(this.hiddenField.id+"__MONTH"),this.yearField=Dom.get(this.hiddenField.id+"__YEAR"),null!=this.config.onlyDate&&0==this.config.onlyDate&&(this.hourField=Dom.get(this.hiddenField.id+"__HOUR"),this.minuteField=Dom.get(this.hiddenField.id+"__MINUTE")),this.propagateCalendarSelect=!1,this.icon=Dom.get(this.hiddenField.id+"__icon"),this.initializeListeners(),null!=this.config.disabled&&1==this.config.disabled&&this.setDisabled(!0),this.panel=null,this.calendar=null,this.isInPanel=null!=this.config.isInPanel&&1==this.config.isInPanel,null!=this.config.initialDate&&0<this.config.initialDate.length&&this.setDate(this.config.initialDate),null==this.config.emptyAllowed&&(this.config.emptyAllowed=!0),window.domToYUIMap[this.hiddenField.id]=this,null!=this.config.onDateChange&&1==YAHOO.lang.isString(this.config.onDateChange)&&(this.config.onDateChange=eval(this.config.onDateChange)),this.dateChanged=new YAHOO.util.CustomEvent("dateChanged",this,!1,YAHOO.util.CustomEvent.LIST),this.delayedBlurListener=null,this.hasFocusFlags={},this.readyLoaded=!0},YAHOO.fcom.DateInput.prototype={show:function(){this.propagateCalendarSelect=!1,1!=this.disabled&&(null==this.panel&&this.initPanel(),this.closeOtherInstance(),this.panel.show())},closeOtherInstance:function(){var e="startDate"==this.hiddenField.id?window.endDate:window.startDate;null!=e&&e.closePanel()},isValidDate:function(){return this.evaluateDateInputs()},isEmpty:function(){var e=this.dayField.value+this.monthField.value+this.yearField.value;return null!=this.config.onlyDate&&0==this.config.onlyDate&&(e+=this.minuteField.value+this.hourField.value),0==e.length},hasErrorMarker:function(){return null!=this.config.onlyDate&&0==this.config.onlyDate?Dom.hasClass(this.dayField,"error")||Dom.hasClass(this.monthField,"error")||Dom.hasClass(this.yearField,"error")||Dom.hasClass(this.minuteField,"error")||Dom.hasClass(this.hourField,"error"):Dom.hasClass(this.dayField,"error")||Dom.hasClass(this.monthField,"error")||Dom.hasClass(this.yearField,"error")},evaluateDateInputs:function(){if(this.config.emptyAllowed&&(this.monthField.value+this.dayField.value+this.yearField.value).length<1)this.setDate(null);else{if(this.hasErrorMarker())return!1;var e=!1,i,t=(1==(i=this.dayField.value).length?this.dayField.value=i="0"+i:0==i.length&&(Dom.addClass(this.dayField,"error"),this.focus(this.dayField),e=!0),this.monthField.value),n=(1==t.length?this.monthField.value=t="0"+t:0==t.length&&(Dom.addClass(this.monthField,"error"),this.focus(this.monthField),e=!0),this.yearField.value),l=(0==e&&(n.length<1?n=(new fcom.date.DateTime).getCalendar().year:n.length<3&&(l=parseInt(n,10),n=""+(l+=l<50?2e3:1900)),this.yearField.value=n),n+"-"+t+"-"+i),n=(!1===this.config.onlyDate&&(s=this.hourField.value,(0==this.config.emptyAllowed||0==e)&&s.length<2&&(s=YAHOO.lang.isUndefined(this.config.defaultHour)||""!==s?"0"+s:this.config.defaultHour<10?"0"+this.config.defaultHour:""+this.config.defaultHour),this.hourField.value=s,a=this.minuteField.value,(0==this.config.emptyAllowed||0==e)&&a.length<2&&(a=YAHOO.lang.isUndefined(this.config.defaultMinute)||""!==a?"0"+a:this.config.defaultMinute<10?"0"+this.config.defaultMinute:""+this.config.defaultMinute),l+=" "+s+":"+(this.minuteField.value=a)),null);if(e||(n=(new fcom.date.DateTime).parse(l,!1===this.config.onlyDate?"yyyy-MM-dd HH:mm":"yyyy-MM-dd",this.config.noTimezoneCorrection)),e||null==n)return!1;if(this.config.minDate){t=(new fcom.date.DateTime).parse(this.config.minDate,"MM/dd/yyyy");if(t.clearTime(),t.getTimestamp()>n.getTimestamp())return!1}if(this.config.maxDate){var s,a,i=(new fcom.date.DateTime).parse(this.config.maxDate,"MM/dd/yyyy");if(i.clearTime(),null!=this.config.onlyDate&&0==this.config.onlyDate&&(a=s="00",YAHOO.lang.isUndefined(this.config.defaultHour)||(s=this.config.defaultHour<10?"0"+this.config.defaultHour:""+this.config.defaultHour),YAHOO.lang.isUndefined(this.config.defaultMinute)||""!==a||(a=this.config.defaultMinute<10?"0"+this.config.defaultMinute:""+this.config.defaultMinute),i=(new fcom.date.DateTime).parse(this.config.maxDate+" "+s+":"+a,"MM/dd/yyyy HH:mm")),i.getTimestamp()<n.getTimestamp())return!1}this.setDate(n)}return this.removeAllErrorMarkers(),!0},hideDateFromInputField:function(){this.removeAllErrorMarkers(),this.dayField.value="",this.monthField.value="",this.yearField.value="",null!=this.config.onlyDate&&0==this.config.onlyDate&&(this.hourField.value="",this.minuteField.value="")},removeAllErrorMarkers:function(){this.removeClass("error")},setAllErrorMarkers:function(){this.addClass("error")},addClass:function(e){Dom.addClass(this.dayField,e),Dom.addClass(this.monthField,e),Dom.addClass(this.yearField,e),null!=this.config.onlyDate&&0==this.config.onlyDate&&(Dom.addClass(this.hourField,e),Dom.addClass(this.minuteField,e))},removeClass:function(e){Dom.removeClass(this.dayField,e),Dom.removeClass(this.monthField,e),Dom.removeClass(this.yearField,e),null!=this.config.onlyDate&&0==this.config.onlyDate&&(Dom.removeClass(this.hourField,e),Dom.removeClass(this.minuteField,e))},initializeListeners:function(){YAHOO.util.Event.addListener(this.dayField,"keyup",this.checkInputField,[this,this.dayField]),YAHOO.util.Event.addListener(this.monthField,"keyup",this.checkInputField,[this,this.monthField]),YAHOO.util.Event.addListener(this.yearField,"keyup",this.checkInputField,[this,this.yearField]),null!=this.config.onlyDate&&0==this.config.onlyDate&&(YAHOO.util.Event.addListener(this.hourField,"keyup",this.checkInputField,[this,this.hourField]),YAHOO.util.Event.addListener(this.minuteField,"keyup",this.checkInputField,[this,this.minuteField])),YAHOO.util.Event.addListener(this.dayField,"blur",this.inputFieldBlured,[this,this.dayField]),YAHOO.util.Event.addListener(this.monthField,"blur",this.inputFieldBlured,[this,this.monthField]),YAHOO.util.Event.addListener(this.yearField,"blur",this.inputFieldBlured,[this,this.yearField]),null!=this.config.onlyDate&&0==this.config.onlyDate&&(YAHOO.util.Event.addListener(this.hourField,"blur",this.inputFieldBlured,[this,this.hourField]),YAHOO.util.Event.addListener(this.minuteField,"blur",this.inputFieldBlured,[this,this.minuteField])),YAHOO.util.Event.addListener(this.dayField,"focus",this.inputFieldFocused,[this,this.dayField]),YAHOO.util.Event.addListener(this.monthField,"focus",this.inputFieldFocused,[this,this.monthField]),YAHOO.util.Event.addListener(this.yearField,"focus",this.inputFieldFocused,[this,this.yearField]),null!=this.config.onlyDate&&0==this.config.onlyDate&&(YAHOO.util.Event.addListener(this.hourField,"focus",this.inputFieldFocused,[this,this.hourField]),YAHOO.util.Event.addListener(this.minuteField,"focus",this.inputFieldFocused,[this,this.minuteField])),YAHOO.util.Event.addListener(this.icon,"click",this.show,this,!0)},setDate:function(e){if(null==e){if(this.config.emptyAllowed)return this.hiddenField.value="",void this.setInputFields(null);null!=this.config.initialDate&&this.setDate(this.config.initialDate)}var i;YAHOO.lang.isString(e)?(i=e,null==(e=fcom.date.DateTime.deserialize(i))?e=(new fcom.date.DateTime).parse(i,"yyyy-MM-dd",this.config.noTimezoneCorrection):e.setTimezone(window.user.timezone)):(window.ngpIsType("Date",e)||e instanceof fcom.date.UTCDate)&&(e=new fcom.date.DateTime(null,e)),null!=this.config.onlyDate&&0==this.config.onlyDate?this.hiddenField.value=e.setCalendar({seconds:0}).toString():this.hiddenField.value=e.clearTime().toString(),this.setInputFields(e)},setInputFields:function(e){null==e?(this.dayField.value="",this.monthField.value="",this.yearField.value="",null!=this.config.onlyDate&&0==this.config.onlyDate&&(this.minuteField.value="",this.hourField.value="")):(e=e.getCalendar(),this.dayField.value=fcom.util.StringHelper.leftPad(e.day,2,"0"),this.monthField.value=fcom.util.StringHelper.leftPad(e.month+1,2,"0"),this.yearField.value=e.year,null!=this.config.onlyDate&&0==this.config.onlyDate&&(this.hourField.value=fcom.util.StringHelper.leftPad(e.hour,2,"0"),this.minuteField.value=fcom.util.StringHelper.leftPad(e.minute,2,"0")))},checkInputField:function(eventArg,args){for(var inputField=args[1],wasError=!1,that=args[0],i=0;i<inputField.value.length;){var character=inputField.value.charCodeAt(i);character<48||57<character?i<inputField.value.length-1?inputField.value=inputField.value.substring(0,i)+inputField.value.substring(i+1,inputField.value.length):inputField.value=inputField.value.substring(0,i):i++}var size=inputField.getAttribute("size"),whichKey,onEnterFunction;if(inputField.value.length>size?(Dom.addClass(inputField,"error"),wasError=!0):Dom.removeClass(inputField,"error"),eventArg=eventArg||window.event,whichKey=null!=eventArg.which?eventArg.which:eventArg.keyCode,13==whichKey)return 1!=wasError&&1==that.evaluateDateInputs(!0)?(window.getActiveElement().blur(),that.handleDateChanged(!0),null==that.config.onEnter||(that.config.onEnter.length<1?(eventArg.cancelBubble=!0,YAHOO.util.Event.preventDefault(eventArg),!1):(onEnterFunction=eval(that.config.onEnter),void onEnterFunction()))):(eventArg.cancelBubble=!0,YAHOO.util.Event.preventDefault(eventArg),!1)},handleDateChanged:function(e){null!=this.config.onDateChange&&(null!=this.config.onChangeParameter?this.config.onDateChange(this.config.onChangeParameter,e):this.config.onDateChange(null,e)),this.dateChanged.fire(e)},initPanel:function(){var e=document.createElement("div"),i=(document.body.insertBefore(e,document.body.firstChild),YAHOO.util.Dom.setStyle(e,"display",""),e.innerHTML='<div class="hd"><div class="title">'+window.getMessage("calendar.title")+'</div></div><div class="bd"><div></div></div>',Dom.addClass(e,"panel calendar"),Dom.getFirstChildBy(e,function(e){return Dom.hasClass(e,"bd")}).firstChild);this.config.iframe=!1,this.config.hide_blank_weeks=!0,this.calendar=new YAHOO.widget.Calendar(i,this.config),(YAHOO.lang.isUndefined(this.config.enableCalenderNavigation)||this.config.enableCalenderNavigation)&&this.calendar.cfg.setProperty("navigator",{strings:{month:window.getMessage("calendar.month"),year:window.getMessage("calendar.year"),submit:window.getMessage("txt.button.ok"),cancel:window.getMessage("txt.button.cancel"),invalidYear:window.getMessage("calendar.error.year")},monthFormat:YAHOO.widget.Calendar.MEDIUM,initialFocus:"year"}),this.calendar.cfg.setProperty("DATE_FIELD_DELIMITER",window.getMessage("calender.DateFieldDelimiter")),this.calendar.cfg.setProperty("MONTHS_SHORT",window.getMessage("calender.MonthsShorts").split(",")),this.calendar.cfg.setProperty("MONTHS_LONG",window.getMessage("calender.MonthsLong").split(",")),this.calendar.cfg.setProperty("WEEKDAYS_1CHAR",window.getMessage("calender.Weekdays1Chart").split(",")),this.calendar.cfg.setProperty("WEEKDAYS_SHORT",window.getMessage("calender.WeekdaysShort").split(",")),this.calendar.cfg.setProperty("WEEKDAYS_MEDIUM",window.getMessage("calender.WeekdaysMedium").split(",")),this.calendar.cfg.setProperty("WEEKDAYS_LONG",window.getMessage("calender.WeekdaysLong").split(",")),this.calendar.render(),this.panel=new YAHOO.widget.Panel(e,{draggable:!0,close:!0,dragOnly:!0,constraintoviewport:!0,modal:!1,context:[this.icon,this.config.contextCorner,"bl"]}),this.isInPanel&&Dom.addClass(this.panel.element,"calendar-in-panel"),this.panel.render(),this.panel.hide(),this.panel.showEvent.subscribe(this.handleShow,this,!0),this.calendar.selectEvent.subscribe(this.handleSelect,this,!0),this.calendar.renderEvent.subscribe(function(e,i,t){t.fireEvent("changeContent")},this.panel,!0)},closePanel:function(){null!=this.panel&&this.panel.hide()},handleSelect:function(e,i){var t,n;this.propagateCalendarSelect&&(t=(i=i[0][0])[0],n=i[1],i=i[2],this.dayField.value=i,this.monthField.value=n,this.yearField.value=t,null!=this.config.onlyDate&&0==this.config.onlyDate&&(this.hourField.value.length<1&&(this.hourField.value="0"|this.config.defaultHour),this.minuteField.value.length<1&&(this.config.defaultMinute?this.minuteField.value=this.config.defaultMinute:this.minuteField.value="0"),this.hourField.focus()),this.removeAllErrorMarkers(),this.evaluateDateInputs(),this.handleDateChanged(!0),this.panel.hide()),this.propagateCalendarSelect=!0},getDate:function(){return 0<this.hiddenField.value.length?fcom.date.DateTime.deserialize(this.hiddenField.value):null},getDateString:function(){return this.hiddenField.value.length<1?null:this.hiddenField.value},handleShow:function(){var e,i,t;this.hiddenField.value.length<1?(i=(new fcom.date.DateTime).getCalendar(),e=new Date(i.year,i.month,i.day),this.propagateCalendarSelect=!1):(i=this.getDate().getCalendar(),e=new Date(i.year,i.month,i.day)),this.calendar.select(e),this.calendar.cfg.setProperty("pagedate",e.getMonth()+1+window.getMessage("calender.DateFieldDelimiter")+e.getFullYear()),this.calendar.render(),this.panel.bringToTop(),this.config.hideOnClick&&(t=function(e){var i=this.panel.element,e=YAHOO.util.Event.getTarget(e);e!=i&&e!=this.icon&&null==YAHOO.util.Dom.getAncestorBy(e,function(e){return e==i})&&this.panel.hide()},YAHOO.util.Event.addListener(document,"click",t,this,!0),this.panel.hideEvent.subscribe(function(){YAHOO.util.Event.removeListener(document,"click",t)},this,!0))},setDisabled:function(e){this.disabled!==(e=null==e||!1!==e||e)&&(this.disabled=e,this.config.isDisabled=e,window.setElementDisabled(this.icon,e),1==e?(Dom.addClass(this.dayField,"disabled"),Dom.addClass(this.monthField,"disabled"),Dom.addClass(this.yearField,"disabled"),this.dayField.setAttribute("disabled","true"),this.monthField.setAttribute("disabled","true"),this.yearField.setAttribute("disabled","true"),null!=this.config.onlyDate&&0==this.config.onlyDate&&(Dom.addClass(this.hourField,"disabled"),Dom.addClass(this.minuteField,"disabled"),this.hourField.setAttribute("disabled","true"),this.minuteField.setAttribute("disabled","true"))):(Dom.removeClass(this.dayField,"disabled"),Dom.removeClass(this.monthField,"disabled"),Dom.removeClass(this.yearField,"disabled"),this.dayField.removeAttribute("disabled"),this.monthField.removeAttribute("disabled"),this.yearField.removeAttribute("disabled"),null!=this.config.onlyDate&&0==this.config.onlyDate&&(Dom.removeClass(this.hourField,"disabled"),Dom.removeClass(this.minuteField,"disabled"),this.hourField.removeAttribute("disabled"),this.minuteField.removeAttribute("disabled"))))},inputFieldBlured:function(e,i,t){var n=i[0];n.hasFocusFlags[i[1].id]=!1,t?(n=i[0]).hasFocus()||n.evaluateDateInputs()&&n.handleDateChanged(!1):n.delayedBlurListener=YAHOO.lang.later(1,null,function(e){e[0].inputFieldBlured(null,e,!0)},[i],!1)},focus:function(e){e.focus(),this.inputFieldFocused(null,[this,e])},hasFocus:function(){for(var e in this.hasFocusFlags)if(e&&null!=e&&1==this.hasFocusFlags[e])return!0;return!1},inputFieldFocused:function(e,i){var t,n=i[0];for(t in n.hasFocusFlags)t&&null!=t&&1==n.hasFocusFlags[t]&&(n.hasFocusFlags[t]=!1);n.hasFocusFlags[i[1].id]=!0}};
//# sourceMappingURL=DateInput.js.map;
YAHOO.fcom.DateInputHtml5=function(hiddenInputElement,configObject){this.hiddenField=Dom.get(hiddenInputElement),null==configObject&&(configObject={}),this.config=configObject,this.config.noTimezoneCorrection||(this.config.noTimezoneCorrection=!1),this.inputField=Dom.get(this.hiddenField.id+"__value"),this.hasTime=null!=this.config.onlyDate&&0==this.config.onlyDate,this.initializeListeners(),null!=this.config.disabled&&1==this.config.disabled&&this.setDisabled(!0),this.panel=null,this.calendar=null,this.isInPanel=null!=this.config.isInPanel&&1==this.config.isInPanel,null!=this.config.initialDate&&0<this.config.initialDate.length&&this.setDate(this.config.initialDate),null==this.config.emptyAllowed&&(this.config.emptyAllowed=!0),window.domToYUIMap[this.hiddenField.id]=this,null!=this.config.onDateChange&&1==YAHOO.lang.isString(this.config.onDateChange)&&(this.config.onDateChange=eval(this.config.onDateChange)),this.dateChanged=new YAHOO.util.CustomEvent("dateChanged",this,!1,YAHOO.util.CustomEvent.LIST),this.delayedBlurListener=null,this.hasFocusFlags={},this.readyLoaded=!0},YAHOO.fcom.DateInputHtml5.prototype={inputFieldChange:function(i,e){e=e[0];e.evaluateDateInputs()&&e.handleDateChanged(!1)},initializeListeners:function(){YAHOO.util.Event.addListener(this.inputField,"blur",this.inputFieldChange,[this])},isValidDate:function(){return this.evaluateDateInputs()},isEmpty:function(){return""==this.inputField.value},hasErrorMarker:function(){return Dom.hasClass(this.inputField,"error")},evaluateDateInputs:function(){if(this.config.emptyAllowed&&this.inputField.value.length<1)this.setDate(null);else{if(this.hasErrorMarker())return!1;if(this.inputField.value.length<1)return Dom.addClass(this.inputField,"error"),this.focus(this.inputField),!1;var i=this.inputField.value,i;if(null==(i=(new fcom.date.DateTime).parse(i,!0===this.hasTime?"yyyy-MM-ddTHH:mm":"yyyy-MM-dd",this.config.noTimezoneCorrection)))return!1;if(this.config.minDate){var e=(new fcom.date.DateTime).parse(this.config.minDate,"MM/dd/yyyy");if(e.clearTime(),e.getTimestamp()>i.getTimestamp())return!1}if(this.config.maxDate){e=(new fcom.date.DateTime).parse(this.config.maxDate,"MM/dd/yyyy");if(e.clearTime(),e.getTimestamp()<i.getTimestamp())return!1}this.setDate(i)}return this.removeAllErrorMarkers(),!0},hideDateFromInputField:function(){this.removeAllErrorMarkers(),this.inputField.value=""},removeAllErrorMarkers:function(){Dom.removeClass(this.inputField,"error")},setAllErrorMarkers:function(){Dom.addClass(this.inputField,"error")},setDate:function(i){if(null==i){if(this.config.emptyAllowed)return this.hiddenField.value="",void this.setInputFields(null);null!=this.config.initialDate&&this.setDate(this.config.initialDate)}var e;YAHOO.lang.isString(i)?(e=i,null==(i=fcom.date.DateTime.deserialize(e))?i=(new fcom.date.DateTime).parse(e,"yyyy-MM-dd",this.config.noTimezoneCorrection):i.setTimezone(window.user.timezone)):(window.ngpIsType("Date",i)||i instanceof fcom.date.UTCDate)&&(i=new fcom.date.DateTime(null,i)),null!=this.config.onlyDate&&0==this.config.onlyDate?this.hiddenField.value=i.setCalendar({seconds:0}).toString():this.hiddenField.value=i.clearTime().toString(),this.setInputFields(i)},setInputFields:function(i){var e,t,n;null==i?this.inputField.value="":(i=i.getCalendar(),n="",e=fcom.util.StringHelper.leftPad(i.day,2,"0"),t=fcom.util.StringHelper.leftPad(i.month+1,2,"0"),n=i.year+"-"+t+"-"+e,this.hasTime&&(n+="T"+fcom.util.StringHelper.leftPad(i.hour,2,"0")+":"+fcom.util.StringHelper.leftPad(i.minute,2,"0")),this.inputField.value=n)},getDate:function(){return 0<this.hiddenField.value.length?fcom.date.DateTime.deserialize(this.hiddenField.value):null},getDateString:function(){return this.hiddenField.value.length<1?null:this.hiddenField.value},setDisabled:function(i){this.disabled!==(i=null==i||!1!==i||i)&&(this.disabled=i,1==(this.config.isDisabled=i)?(Dom.addClass(this.inputField,"disabled"),this.inputField.setAttribute("disabled","true")):(Dom.removeClass(this.inputField,"disabled"),this.inputField.removeAttribute("disabled")))},handleDateChanged:function(i){null!=this.config.onDateChange&&(null!=this.config.onChangeParameter?this.config.onDateChange(this.config.onChangeParameter,i):this.config.onDateChange(null,i)),this.dateChanged.fire(i)},focus:function(i){i.focus(),this.inputFieldFocused(null,[this,i])},hasFocus:function(){for(var i in this.hasFocusFlags)if(i&&null!=i&&1==this.hasFocusFlags[i])return!0;return!1},inputFieldFocused:function(i,e){var t,n=e[0];for(t in n.hasFocusFlags)t&&null!=t&&1==n.hasFocusFlags[t]&&(n.hasFocusFlags[t]=!1);n.hasFocusFlags[e[1].id]=!0}};
//# sourceMappingURL=DateInputHtml5.js.map;
window.ngpNamespace("YAHOO.fcom.ui"),function(){var n=YAHOO.util.Dom,e=function(e){e=e||{};if(YAHOO.lang.augmentObject(e,{opened:!1,hasTooltips:!0,fireResizeEvent:!1}),this.config=e,this.opened=this.config.opened,this.expanderEl=n.get(this.config.expanderEl),this.switchEl=[],YAHOO.lang.isArray(this.config.switchEl))for(var i=0;i<this.config.switchEl.length;i++)this.addListener(this.config.switchEl[i]);else this.addListener(this.config.switchEl);this.onExpand=new YAHOO.util.CustomEvent("onExpand",this),this.onCollapse=new YAHOO.util.CustomEvent("onCollapse",this),this.expanderEl.id&&window.domToYUIMap&&(window.domToYUIMap[this.expanderEl.id]=this)};e.prototype={addListener:function(e){this.switchEl.push(n.get(e)),YAHOO.util.Event.addListener(e,"click",function(e,i){i.toggle(),YAHOO.util.Event.stopEvent(e),i.isCollapsed()&&i.closeCalendarPanels()},this,!1)},toggle:function(e,i){var t=!1;if(!0===e?this.opened=!1:!1===e&&(this.opened=!0),1==this.opened){this.config.animClose&&!1!==i?(this.config.animClose.onComplete.subscribe(function(){n.setStyle(this.expanderEl,"display","none"),this.onCollapse.fire()},this,!0),this.config.animClose.animate(),t=!0):n.setStyle(this.expanderEl,"display","none"),this.opened=!1;for(var s=this.switchEl.length;s--;)n.addClass(this.switchEl[s],"close"),n.removeClass(this.switchEl[s],"open"),this.updateAriaLabel(this.switchEl[s],this.config.openTooltip)}else{n.setStyle(this.expanderEl,"display",""),this.config.animOpen&&!1!==i&&(this.config.animOpen.onComplete.subscribe(function(){this.onExpand.fire()},this,!0),this.config.animOpen.animate(),t=!0),this.opened=!0;for(s=this.switchEl.length;s--;)n.removeClass(this.switchEl,"close"),n.addClass(this.switchEl,"open"),this.updateAriaLabel(this.switchEl[s],this.config.closeTooltip);this.config.fireResizeEvent&&null!=window.onElementResize&&window.onElementResize.fire(this.expanderEl)}1==this.config.hasTooltips&&this.toggleTooltips(),this.toggleImage(),this.alertToggle(),(this.opened&&!t?this.onExpand:this.onCollapse).fire()},updateAriaLabel:function(e,i){var t=e;(t=0<n.getChildren(e).length?n.getChildren(e)[0]:t).hasAttribute("aria-label")&&t.setAttribute("aria-label",i)},closeCalendarPanels:function(){var e=window.startDate,i=window.endDate;null!=e&&e.closePanel(),null!=i&&i.closePanel()},toggleTooltips:function(){for(var e=1==this.opened?this.config.closeTooltip:this.config.openTooltip,i=0;i<this.switchEl.length;i++)this.switchEl[i].title=e},alertToggle:function(){var e;YAHOO.lang.isUndefined(this.config.toggleHandler)||YAHOO.lang.isNull(this.config.toggleHandler)||(YAHOO.lang.isFunction(this.config.toggleHandler)?(e=null,e=YAHOO.lang.isUndefined(this.config.toggleHandlerArgs)||YAHOO.lang.isNull(this.config.toggleHandlerArgs)?[]:this.config.toggleHandlerArgs,this.config.toggleHandler(this.opened,e)):console.error("toggleHandler must be a Function"))},toggleImage:function(){for(var e=this.switchEl.length;e--;){var i=this.switchEl[e],t=YAHOO.util.Dom.getAncestorBy(i,function(e){return!!(YAHOO.util.Dom.hasClass(e,"tableToggleBar")||YAHOO.util.Dom.hasClass(e,"toggleBar")||YAHOO.util.Dom.hasClass(e,"moduleHeader"))});"button"===i.nodeName.toLowerCase()&&(!0===this.opened?n.replaceClass(t,"close","open"):n.replaceClass(t,"open","close"))}},isCollapsed:function(){return!this.opened}},YAHOO.fcom.ui.Expander=e}();
//# sourceMappingURL=Expander.js.map;
window.ngpNamespace("YAHOO.fcom.ui"),YAHOO.fcom.ui.TabMenu=function(e,t,i,s){if(YAHOO.lang.isArray(e))for(var n=0;n<e.length;n++)this.addItem(null,e[n]);else this.element=e?YAHOO.util.Dom.get(e):null;this.selectedCls=i,this.itemCls=t,this.callback=s,this.elements=[],this.tabChangeEvent=new YAHOO.util.CustomEvent("tabChange",this,!1,YAHOO.util.CustomEvent.LIST),this.destroyEvent=new YAHOO.util.CustomEvent("tabsDestroyed",this,!1,YAHOO.util.CustomEvent.LIST)},YAHOO.fcom.ui.TabMenu.prototype={renderTo:function(e){var t=document.createElement("div");YAHOO.util.Dom.addClass(t,"menu");for(var i=0;i<this.elements.length;i++)this.elements[i].renderTo(t);this.element=t,e.appendChild(this.element)},destroy:function(){for(var e=0;e<this.elements.length;e++){var t=this.elements[e].element;YAHOO.util.Event.removeListener(t,"click",this.itemClicked),this.element.removeChild(t)}this.element.parentNode&&this.element.parentNode.removeChild(this.element),this.destroyEvent.fire()},addItem:function(e,t){t=t||{},YAHOO.lang.augmentObject(t,{index:this.elements.length});e=new YAHOO.fcom.ui.TabItem(e,t);return this.elements.push(e),e.clickEvent.subscribe(this.itemClicked,this,!0),e},itemClicked:function(e,t,i){if(i=i||!1,!this.isItemSelected(e)){for(var s=0;s<this.elements.length;s++)this.elements[s]!=e&&this.deselectItem(this.elements[s]);this.selectItem(e),i||(this.callback&&(null==this.callback.args&&(this.callback.args=[]),this.callback.args.splice(0,0,e.data),this.callback.fn.apply(this.callback.scope,this.callback.args)),this.tabChangeEvent.fire(e.data))}},isItemSelected:function(e){return YAHOO.util.Dom.hasClass(e.element,this.selectedCls)},selectItem:function(e){YAHOO.util.Dom.addClass(e.element,this.selectedCls)},deselectItem:function(e){YAHOO.util.Dom.removeClass(e.element,this.selectedCls)},getSelectedItem:function(){for(var e=0;e<this.elements.length;e++)if(this.isItemSelected(this.elements[e]))return this.elements[e]},getSelectedIndex:function(){for(var e=0;e<this.elements.length;e++)if(this.isItemSelected(this.elements[e]))return e},getItemByIndex:function(e){return this.elements[e]},setSelectedItem:function(){if(1==arguments.length&&window.ngpIsType("Number",arguments[0])){var e=this.elements[arguments[0]];if(null!=e)this.itemClicked(e,null,!0);else for(var t=this.elements.length;t--;)this.deselectItem(this.elements[t])}}},YAHOO.fcom.ui.TabItem=function(e,t){t=t||{},YAHOO.lang.augmentObject(this,t),this.element=e?YAHOO.util.Dom.get(e):null,this.element&&this.addListeners(),this.clickEvent=new YAHOO.util.CustomEvent("tabitem-clicked",null,!0,YAHOO.util.CustomEvent.FLAT)},YAHOO.fcom.ui.TabItem.prototype={renderTo:function(e){var t=document.createElement("div"),i=(YAHOO.util.Dom.addClass(t,"menuItem"),0==this.index&&YAHOO.util.Dom.addClass(t,"first"),this.cls&&YAHOO.util.Dom.addClass(t,this.cls),document.createElement("div")),s=document.createElement("a");this.title&&s.setAttribute("title",this.title),s.innerHTML=this.text,i.appendChild(s),t.appendChild(i),this.element=t,this.addListeners(),e.appendChild(this.element)},addListeners:function(){YAHOO.util.Event.addListener(this.element,"click",function(){this.clickEvent.fire(this)},this,!0)}},YAHOO.fcom.ui.Tabs=function(e,t,i,s,n){this.tabMenu=new YAHOO.fcom.ui.TabMenu(e,t,i),this.contentEl=YAHOO.util.Dom.get(s);for(var l=YAHOO.util.Dom.getElementsByClassName(t,null,this.tabMenu.element),m=YAHOO.util.Dom.getElementsByClassName(n,null,this.contentEl),a=0;a<l.length;a++){var h=l[a],c=null;a<m.length&&(c=m[a]),null!=s&&this.tabMenu.addItem(h,{data:c})}this.tabMenu.tabChangeEvent.subscribe(function(e,t){for(var t=t[0],i=0;i<m.length;i++)YAHOO.util.Dom.setStyle(m[i],"display","none");YAHOO.util.Dom.setStyle(t,"display","")})};
//# sourceMappingURL=Tabs.js.map;
YAHOO.fcom.Autocomplete=function(t,e){this.name=t,this.config=e,this.id=e.pageId,this.container=YAHOO.util.Dom.get(this.id+"__container"),this.valueField=YAHOO.util.Dom.get(this.id+"__value"),this.inputField=YAHOO.util.Dom.get(this.id+"__input"),this.labelField=YAHOO.util.Dom.get(this.id+"__label"),this.toggleImg=YAHOO.util.Dom.get(this.id+"__toggle"),this.main=YAHOO.util.Dom.get(this.id+"__main"),this.changeEvent=new YAHOO.util.CustomEvent("change"),this.groups=[],this.lastHoveredLine=null,this.lastRenderMode=null,this.inputField.value="",window.domToYUIMap[this.name]=this,YAHOO.lang.later(1,null,function(t){var e=t[0];YAHOO.fcom.Page.ready(t[1].pageId,e)},[[this,e]]),YAHOO.util.Event.addListener(this.toggleImg,"click",this.toggleView,null,this),YAHOO.util.Event.addListener(this.labelField,"click",this.toggleView,null,this),YAHOO.util.Event.addListener(document,"keydown",this.checkOutsideEvent,null,this),YAHOO.util.Event.addListener(document,"mousedown",this.checkOutsideEvent,null,this),YAHOO.util.Event.addListener(document,"focus",this.checkOutsideEvent,null,this),YAHOO.util.Event.addListener(this.inputField,"click",this.inputFieldOnClick,null,this),YAHOO.util.Event.addListener(this.inputField,"mousedown",this.inputFieldOnMousedown,null,this),YAHOO.util.Event.addListener(this.inputField,"keyup",this.inputFieldOnKeyup,null,this),YAHOO.util.Event.addListener(this.inputField,"keypress",this.inputFieldOnKeypress,null,this),YAHOO.util.Event.addListener(this.inputField,"keydown",this.handleKeyDown,null,this)},YAHOO.fcom.Autocomplete.prototype.checkOutsideEvent=function(t){t=YAHOO.util.Event.getTarget(t);YAHOO.util.Dom.isAncestor(this.overlayContainer,t)||this.overlayContainer==t||YAHOO.util.Dom.isAncestor(this.main,t)||this.main==t||this.hide()},YAHOO.fcom.Autocomplete.prototype.inputFieldOnMousedown=function(){this.checkInputDefault()},YAHOO.fcom.Autocomplete.prototype.inputFieldOnClick=function(){this.checkInputDefault()},YAHOO.fcom.Autocomplete.prototype.handleKeyDown=function(t){9!=t.keyCode||t.shiftKey?9==t.keyCode&&t.shiftKey?this.hoverPrevious()&&YAHOO.util.Event.stopEvent(t):13==t.keyCode?(this.chooseHovered(),YAHOO.util.Event.stopEvent(t)):27==t.keyCode?this.hide():38==t.keyCode?(this.hoverPrevious(),YAHOO.util.Event.stopEvent(t)):40==t.keyCode&&(this.hoverNext(),YAHOO.util.Event.stopEvent(t)):this.hoverNext()&&YAHOO.util.Event.stopEvent(t)},YAHOO.fcom.Autocomplete.prototype.inputFieldOnKeypress=function(){this.checkInputDefault()},YAHOO.fcom.Autocomplete.prototype.inputFieldOnKeyup=function(t){9!=t.keyCode&&13!=t.keyCode&&27!=t.keyCode&&40!=t.keyCode&&38!=t.keyCode&&this.render()},YAHOO.fcom.Autocomplete.prototype.checkInputDefault=function(){this.inputDefaultMode&&(this.inputField.value="",this.inputDefaultMode=!1)},YAHOO.fcom.Autocomplete.prototype.getSearchText=function(){return this.inputField.value},YAHOO.fcom.Autocomplete.prototype.stopMouseEventHandlers=function(){this._bStopMouseEventHandlers=!0,this._bStopMouseEventHandlersTimer&&this._bStopMouseEventHandlersTimer.cancel(),this._bStopMouseEventHandlersTimer=Lang.later(50,this,function(){this._bStopMouseEventHandlers=!1})},YAHOO.fcom.Autocomplete.prototype.getPreviousLine=function(t){var e=YAHOO.util.Dom.getPreviousSibling(t);if(e)return e;for(var i=YAHOO.util.Selector.query("li.yuimenuitem",this.overlayContainer),o=0;o<i.length;o++)if(i[o]==t)return 0<o?i[o-1]:i[i.length-1];return null},YAHOO.fcom.Autocomplete.prototype.getNextLine=function(t){var e=YAHOO.util.Dom.getNextSibling(t);if(e)return e;for(var i=YAHOO.util.Selector.query("li.yuimenuitem",this.overlayContainer),o=0;o<i.length;o++)if(i[o]==t)return o<i.length-1?i[o+1]:i[0];return null},YAHOO.fcom.Autocomplete.prototype.hoverPrevious=function(){var t=YAHOO.util.Selector.query("li.yuimenuitem-selected",this.overlayContainer);if(t=t.length?t[0]:this.lastHoveredLine){if(null==(i=this.getPreviousLine(t)))return!1}else var t=null,e=YAHOO.util.Selector.query("li.yuimenuitem",this.overlayContainer),i=e[e.length-1];t&&this.lineHout(null,t),i&&this.lineHover(null,i);var e=i,t=this.options,i=t.scrollTop,o=t.offsetHeight,n=YAHOO.util.Selector.query("li.yuimenuitem",this.overlayContainer),l=e.offsetTop;return this.stopMouseEventHandlers(),l<=i?t.scrollTop=l-e.offsetHeight:i+o<=l&&(t.scrollTop=l),e==n[0]&&(t.scrollTop=0),!0},YAHOO.fcom.Autocomplete.prototype.hoverNext=function(){var t=YAHOO.util.Selector.query("li.yuimenuitem-selected",this.overlayContainer),t=t.length?t[0]:this.lastHoveredLine;if(t){if(null==(e=this.getNextLine(t)))return!1}else t=null,e=YAHOO.util.Selector.query("li.yuimenuitem",this.overlayContainer)[0];t&&this.lineHout(null,t),e&&this.lineHover(null,e);var t=e,e=this.options,i=e.scrollTop,o=e.offsetHeight,n=YAHOO.util.Selector.query("li.yuimenuitem",this.overlayContainer),l=n.length-1,s=t.offsetTop,u=s+t.offsetHeight;return this.stopMouseEventHandlers(),o+i<=u?e.scrollTop=u-o:s<=i&&(e.scrollTop=0),t==n[l]&&(e.scrollTop=u),!0},YAHOO.fcom.Autocomplete.prototype.lineHover=function(t,e){this._bStopMouseEventHandlers&&t||((t=YAHOO.util.Selector.query("li.yuimenuitem-selected",this.overlayContainer)).length&&this.lineHout(null,t[0]),YAHOO.util.Dom.addClass(e,"yuimenuitem-selected"),YAHOO.util.Dom.addClass(YAHOO.util.Selector.query(".yuimenuitemlabel",e)[0],"yuimenuitemlabel-selected"),this.lastHoveredLine=e)},YAHOO.fcom.Autocomplete.prototype.lineHout=function(t,e){this._bStopMouseEventHandlers&&t||(YAHOO.util.Dom.removeClass(e,"yuimenuitem-selected"),YAHOO.util.Dom.removeClass(YAHOO.util.Selector.query(".yuimenuitemlabel",e)[0],"yuimenuitemlabel-selected"))},YAHOO.fcom.Autocomplete.prototype.chooseHovered=function(){var t=YAHOO.util.Selector.query("li.yuimenuitem-value.yuimenuitem-selected",this.overlayContainer);t.length&&this.lineClicked(null,t[0])},YAHOO.fcom.Autocomplete.prototype.lineClicked=function(t,e){var i=parseInt(e.getAttribute("index")),e=parseInt(e.getAttribute("groupindex")),e=this.groups[e][i];this.selectByItem(e),this.toggleView(),t&&YAHOO.util.Event.stopEvent(t)},YAHOO.fcom.Autocomplete.prototype.adaptPosition=function(){var t=YAHOO.util.Dom.getViewportHeight(),e=YAHOO.util.Dom.getDocumentScrollTop()||0,i=YAHOO.util.Dom.getDocumentScrollLeft()||0,o=this.inputField.offsetHeight,n=YAHOO.util.Dom.getY(this.inputField)-e,l=YAHOO.util.Dom.getX(this.inputField)-i,s=t-(n+o),u=n,r=YAHOO.widget.Overlay.VIEWPORT_OFFSET,a=!1,h=0,p=this,c=0,d=(this.options.style.maxHeight=Math.max(s-10,u-10)+"px",function(){return p.overlayContainer.offsetTop-e>n?s-r:u-r}),m=function(){return p.overlayContainer.offsetTop-e>n?u-r:s-r},O=function(){var t=p.overlayContainer.offsetTop-e>n?n+o:n-p.overlayContainer.offsetHeight;p.overlayContainer.style.top=t+e+"px"},y=function(){var t=p.overlayContainer.offsetTop-e>n?n-p.overlayContainer.offsetHeight:n+o;return p.overlayContainer.style.top=t+e+"px",t},v=function(){if("none"!=p.overlayContainer.style.display){var t,e=d(),i=m(),o=p.optionsInner.offsetHeight;if(!(o<10))return p.overlayContainer.style.left=l+"px",e<o?(c=90<e?e:h,p.options.style.maxHeight=p.options.style.height=c+"px",O(),(e<90||e<i)&&(a?y():(y(),a=!0,t=v()))):(p.options.style.maxHeight=p.options.style.height=c&&c!==h&&h?h+"px":"",O()),p.overlayContainer.style.visibility="visible",t;window.setTimeout(v,100)}};window.setTimeout(v,150)},YAHOO.fcom.Autocomplete.prototype.hide=function(){null!=this.overlayContainer&&"none"!=this.overlayContainer.style.display&&this.toggleView()},YAHOO.fcom.Autocomplete.prototype.show=function(){null!=this.overlayContainer&&"none"!=this.overlayContainer.style.display||this.toggleView()},YAHOO.fcom.Autocomplete.prototype.toggleView=function(){this.overlayContainer||this.addOverlayContainer();var t="none"==this.overlayContainer.style.display;t||(this.lastScrollTop=this.options.scrollTop),this.overlayContainer.style.visibility="hidden",this.overlayContainer.style.display=t?"block":"none",this.labelField.style.display=t?"none":"block",this.inputField.style.display=t?"inline":"none",t?(this.inputField.value=window.getMessage("tools.exchangeCalculator.js.searchinfo"),this.inputDefaultMode=!0,"Items"!=this.lastRenderMode||this.isDirty?this.render():this.lastScrollTop&&(this.stopMouseEventHandlers(),this.options.scrollTop=this.lastScrollTop),this.inputField.focus(),this.inputField.select(),this.adaptPosition(!0)):this.toggleImg.focus()},YAHOO.fcom.Autocomplete.prototype.getItemByValue=function(t){for(var e=0;e<this.groups.length;e++){var i=this.groups[e];if(i)for(var o=0;o<i.length;o++){var n=i[o];if(n&&n.value==t&&!n.caption)return n}}},YAHOO.fcom.Autocomplete.prototype.selectByValue=function(t){t=this.getItemByValue(t);t&&this.selectByItem(t)},YAHOO.fcom.Autocomplete.prototype.selectByItem=function(t){t&&(this.labelField.innerHTML=t.text,this.valueField.value!=t.value)&&(this.valueField.value=t.value,this.changeEvent.fire(),this.inputField.value=window.getMessage("tools.exchangeCalculator.js.searchinfo"),this.inputDefaultMode=!0)},YAHOO.fcom.Autocomplete.prototype.getSelectedValue=function(){return this.valueField.value},YAHOO.fcom.Autocomplete.prototype.isAListedItemValue=function(t){return!!this.getItemByValue(t)},YAHOO.fcom.Autocomplete.prototype.getValueForTheText=function(){return null},YAHOO.fcom.Autocomplete.prototype.addItem=function(t,e){return null==this.groups[e]&&(this.groups[e]=[]),this.groups[e].push(t),this.isDirty=!0,t},YAHOO.fcom.Autocomplete.prototype.getItemGroups=function(){return this.groups},YAHOO.fcom.Autocomplete.prototype.removeItem=function(t,e){var i=this.groups[e];if(i)for(var o=0;o<i.length;o++)if(i[o]==t)return i.splice(o,1),void(this.isDirty=!0)},YAHOO.fcom.Autocomplete.prototype.renderItems=function(){for(var t="",e=0,i=0;i<this.groups.length;i++)this.groups[i]&&(t+=this.getGroupCode(i,e++,""));this.optionsInner.innerHTML=t},YAHOO.fcom.Autocomplete.prototype.renderSearchResults=function(){var t="",e=('<ul class="first-of-type"></ul>'==(t+=this.getGroupCode(1,0,this.inputField.value.toLowerCase()))&&(t='<ul class="first-of-type">',t=(t+='<li class="yuimenuitem yuimenuitem-no_value first-of-type"><a class="yuimenuitemlabel yuimenuitemlabel-caption yuimenuitem-no_value" href="#" style="cursor: default;">')+window.getMessage("tools.exchangeCalculator.js.emptyresult")+"</a></li></ul>"),YAHOO.util.Dom.getDocumentScrollTop()),i=YAHOO.util.Dom.getViewportHeight(),o=this.inputField.offsetHeight,e=YAHOO.util.Dom.getY(this.inputField)-e;this.options.style.maxHeight=Math.max(i-(e+o)-10,e-10)+"px",this.optionsInner.innerHTML=t,this.adaptPosition(!1)},YAHOO.fcom.Autocomplete.prototype.addOverlayContainer=function(){var o=this;this.overlayContainer=document.createElement("div"),document.body.appendChild(this.overlayContainer),this.overlayContainer.setAttribute("id",this.id+"__overlayContainer"),YAHOO.util.Dom.addClass(this.overlayContainer,"yui-module"),YAHOO.util.Dom.addClass(this.overlayContainer,"yuimenu"),this.overlayContainer.style.display="none",this.overlayContainer.style.width="340px",this.overlayContainer.style.zIndex="12",this.overlayContainer.style.top="0px",this.overlayContainer.style.position="absolute",this.overlayContainer.innerHTML='<div id="'+this.id+'__options" class="bd yui-menu-body-scrolled" style="overflow-y: auto;"><div id="'+this.id+'__optionsInner">&nbsp;</div></div>',this.options=YAHOO.util.Dom.get(this.id+"__options"),this.optionsInner=YAHOO.util.Dom.get(this.id+"__optionsInner"),YAHOO.util.Event.delegate(this.id+"__options","click",function(t,e,i){o.lineClicked(t,e,i)},"li.yuimenuitem-value"),YAHOO.util.Event.delegate(this.id+"__options","click",function(t){YAHOO.util.Event.stopEvent(t)},"li.yuimenuitem-no_value"),YAHOO.util.Event.delegate(this.id+"__options","mouseover",function(t,e,i){o.lineHover(t,e,i)},"li.yuimenuitem"),YAHOO.util.Event.delegate(this.id+"__options","mouseout",function(t,e,i){o.lineHout(t,e,i)},"li.yuimenuitem"),YAHOO.util.Event.addListener(this.overlayContainer,"keydown",this.handleKeyDown,null,this)},YAHOO.fcom.Autocomplete.prototype.render=function(){if(this.overlayContainer||this.addOverlayContainer(),this.inputDefaultMode||""==this.inputField.value){if("Items"==this.lastRenderMode&&!this.isDirty)return;this.lastScrollTop=this.options.scrollTop=0,this.lastHoveredLine=null,this.renderItems(),this.lastRenderMode="Items"}else{if("SearchResults"==this.lastRenderMode&&this.lastSearchText==this.inputField.value&&!this.isDirty)return;this.lastScrollTop=this.options.scrollTop=0,this.lastHoveredLine=null,this.renderSearchResults(),this.lastRenderMode="SearchResults",this.lastSearchText=this.inputField.value}this.isDirty=!1},YAHOO.fcom.Autocomplete.prototype.getGroupCode=function(t,e,i){var o=this.groups[t],n="<ul";0==e&&(n+=' class="first-of-type"'),n+=">";for(var l=0;l<o.length;l++)n+=this.getItemCode(o[l],t,l,i);return n+="</ul>"},YAHOO.fcom.Autocomplete.prototype.getItemCode=function(t,e,i,o){return o&&t.caption||o&&t.plain.toLowerCase().indexOf(o)<0?"":(o='<li class="yuimenuitem',t.caption?o+=" yuimenuitem-no_value":o+=" yuimenuitem-value",0==i&&(o+=" first-of-type"),o+='" groupindex="'+e+'" index="'+i+'">',t.caption?o+='<a class="yuimenuitemlabel yuimenuitemlabel-caption yuimenuitem-no_value" href="#" style="cursor: default;">':o+='<a class="yuimenuitemlabel" href="#">',o+t.text+"</a></li>")};
//# sourceMappingURL=Autocomplete.js.map;
!function(){var s=-1<window.navigator.userAgent.toLowerCase().indexOf("android"),e="object"==typeof Touch||s,i=!1,h=!1,l=1,d=1;function v(e,t,o){try{e.preventDefault();var n=e.changedTouches[0],r=document.createEvent("MouseEvent");if(r.initMouseEvent(t,!0,!0,window,1,n.screenX,n.screenY,n.clientX,n.clientY,!1,!1,!1,!1,0,null),o)for(var c in o)r[c]=o[c];e.target.dispatchEvent(r)}catch(u){console.error("Error in simulateMouseEvent "+u)}}function g(e){var t=e.touches[0],e=e.touches[1];return Math.pow(Math.pow(t.pageX-e.pageX,2)+Math.pow(t.pageY-e.pageY,2),.5)}e&&(document.addEventListener("touchstart",function(e){try{for(var t=YAHOO.util.Event.getTarget(e),o=["ddcontainer","move"],n=["nodd"],r=!1,c=0;c<n.length;c++)if(YAHOO.util.Dom.getAncestorByClassName(t,n[c])){r=!0;break}if(!r){for(var u,c=0;c<o.length;c++)if(YAHOO.util.Dom.getAncestorByClassName(t,o[c])){r=!0;break}r&&!(h=1!=e.touches.length&&h)&&(2==e.touches.length&&s?(u=g(e),i=!(h=!0),d=l=u,v(e,"gesturestart",{scale:1,rotation:0})):1!=e.touches.length||i||(i=!0,this._touchMoved=!1,v(e,"mouseover"),v(e,"mousemove"),v(e,"mousedown")))}}catch(a){console.error("Error in ontouchstart "+a)}}),document.addEventListener("touchmove",function(e){try{var t;this._touchMoved=!0,h&&2==e.touches.length?(t=g(e),v(e,"gesturechange",{scale:(d=t)/l,rotation:0})):i&&1==e.touches.length&&v(e,"mousemove")}catch(o){console.error("Error in ontouchmove "+o)}}),document.addEventListener("touchend",function(e){try{h&&1==e.touches.length?(v(e,"gestureend",{scale:d/l,rotation:0}),h=!1):i&&(v(e,"mouseup"),v(e,"mouseout"),this._touchMoved||v(e,"click"),i=!1)}catch(t){console.error("Error in ontouchend "+t)}}),YAHOO.util.DragDropMgr.clickPixelThresh=1e4)}();
//# sourceMappingURL=TouchDD.js.map;
window.ngpNamespace("fcom.ui"),fcom.ui.Tooltip=function(e,t){t=t||{},YAHOO.lang.augmentObject(t,{delayShow:0,delayHide:1,hideOnMouseover:!0,constrainToViewport:!0}),this.config=t,this.overlay=null,this.element=e,this.blocked=!1,this.hideTimer=null,this.showTimer=null,this.fixed=!1,this.currentTarget=null,this.beforeShowEvent=new YAHOO.util.CustomEvent("beforeShow"),this.onHideEvent=new YAHOO.util.CustomEvent("onHide")},fcom.ui.Tooltip.prototype={OFFSET:1,doPosition:function(e,t){var i,s,o;this.createOverlay(),null!=e&&(t=null==t?this.OFFSET:t,s=0,(o=YAHOO.util.Selector.query(".quickViewHeader",this.element)).length&&(s=YAHOO.fcom.Dom.getDimensions(o[0]).width),o=YAHOO.fcom.Page.getViewportSize(),(i=YAHOO.fcom.Dom.getDimensions(this.element)).width+=s,s=e.x+i.width+t>o.width?Math.max(Math.min(o.width-i.width,e.x-t-i.width),0):e.x+t,o=e.y-i.height-t<o.y?o.y:e.y-i.height-t,this.overlay.moveTo(s,Math.max(o,0)))},show:function(e){null==e&&(e=!0),this.createOverlay(),null!=this.hideTimer&&this.resetHideTimer(),this.blocked||(this.overlay.show(),YAHOO.fcom.Page.isOverlayIframeRequired()&&YAHOO.fcom.Page.getIFrameHandler()&&YAHOO.fcom.Page.getIFrameHandler().addOverlayActive(this.overlay.id),e&&this.overlay.bringToTop())},defaultPosition:function(){null==this.position&&(this.position={}),this.position.x=window.innerWidth/3,this.position.y=window.innerHeight/3},display:function(e,t){var i,s=null;null!=e&&(s=YAHOO.util.Event.getTarget(e)),this.currentTarget=s,YAHOO.fcom.Page.checkIframeOverlayNeeded(YAHOO.util.Dom.getAncestorByClassName(s,"module"),e)&&e&&e.type&&("mouseenter"==e.type||"mouseover"==e.type)||(i=YAHOO.fcom.Page.isOverlayIframeRequired(),null!=e?this.position={x:YAHOO.util.Event.getPageX(e)||$(this.currentTarget).offset().left,y:YAHOO.util.Event.getPageY(e)||$(this.currentTarget).offset().top}:null!=t?this.position=t:null==this.position&&this.defaultPosition(),i&&(e=YAHOO.fcom.Page.getIframeOffset(),this.position.x+=e[0],this.position.y+=e[1]),this.currentTarget&&YAHOO.util.Event.addListener(this.currentTarget,"mouseleave",this.hideOnLeave,this,!0),window.ngpIsType("Number",this.config.delayShow)&&0<this.config.delayShow?this.showTimer=YAHOO.lang.later(this.config.delayShow,this,function(e){null!=e&&e!=this.currentTarget||this.doDisplay()},s):this.doDisplay())},doDisplay:function(){this.fixed||(this.beforeShowEvent.fire(),this.doPosition(this.position),this.show())},hide:function(){this.createOverlay(),this.resetShowTimer(),this.fixed||null!=this.hideTimer||(window.ngpIsType("Number",this.config.delayHide)&&0<this.config.delayHide?(this.oldTarget=this.currentTarget,this.hideTimer=YAHOO.lang.later(this.config.delayHide,this,function(){this.fixed||(this.overlay.hide(),this.onHideEvent.fire(),this.currentTarget&&YAHOO.util.Event.removeListener(this.currentTarget,"mouseout",this.hide),YAHOO.fcom.Page.isOverlayIframeRequired()&&YAHOO.fcom.Page.getIFrameHandler()&&YAHOO.fcom.Page.getIFrameHandler().removeOverlayActive(this.overlay.id),this.oldTarget=null)})):(this.overlay.hide(),this.currentTarget&&YAHOO.util.Event.removeListener(this.currentTarget,"mouseout",this.hide),YAHOO.fcom.Page.isOverlayIframeRequired()&&YAHOO.fcom.Page.getIFrameHandler().removeOverlayActive(this.overlay.id),this.onHideEvent.fire()),this.currentTarget=null)},hideOnLeave:function(e){e.relatedTarget&&($(e.relatedTarget).is(this.element)||$(this.element).find(e.relatedTarget).length)?$(this.element).mouseleave(function(){this.hide()}.bind(this)):this.hide()},block:function(e){(this.blocked=e=!1!==e?!0:e)&&(this.fixed=!1,this.hide())},destroy:function(){null!=this.overlay&&this.overlay.destroy(),delete this.overlay,delete this.element},setContent:function(e){this.createOverlay(),YAHOO.fcom.Page.replace(this.element,e)},createOverlay:function(){null==this.overlay&&(this.createTooltipElement(),this.overlay=new YAHOO.widget.Overlay(this.element,this.config),this.overlay.moveTo(-1e4,-1e4),!0===this.config.hideOnMouseover?YAHOO.util.Event.addListener(this.element,"mouseover",function(){this.hide()},this,!0):($(this.element).on("mouseover",function(){window.ngpQuickview.fixed=!0,window.ngpQuickview.resetHideTimer()}),$(this.element).on("mouseout",function(){window.ngpQuickview.fixed=!1,window.ngpQuickview.hide()})))},createTooltipElement:function(){var e=null;null==(e=this.element?YAHOO.fcom.Page.getOverlayDOMNode(this.element):e)&&(e=YAHOO.fcom.Page.documentToUseForOverlays().createElement("div"),null!=this.element?e.id=this.element:YAHOO.util.Dom.generateId(e),YAHOO.fcom.Page.documentToUseForOverlays().body.appendChild(e)),this.element=e,this.doClassAndStyle()},doClassAndStyle:function(){for(var e=this.config.cssClasses?[].concat(this.config.cssClasses):["tooltip"],t=0;t<e.length;t++)YAHOO.util.Dom.addClass(this.element,e[t]);var i=this.config.style;if(i)for(var s in i)YAHOO.util.Dom.setStyle(this.element,s,i[s]);YAHOO.util.Dom.setStyle(this.element,"display","")},resetHideTimer:function(){null!=this.hideTimer&&(this.hideTimer.cancel(),this.hideTimer=null,this.oldTarget)&&(this.currentTarget=this.oldTarget)},resetShowTimer:function(){null!=this.showTimer&&(this.showTimer.cancel(),this.showTimer=null)}},fcom.ui.TooltipText=function(e,t){fcom.ui.TooltipText.superclass.constructor.call(this,e,t)},YAHOO.extend(fcom.ui.TooltipText,fcom.ui.Tooltip,{display:function(e,t){fcom.util.StringHelper.empty(t)||(this.setContent(t),fcom.ui.TooltipText.superclass.display.call(this,e))}}),fcom.ui.Quickview=function(e,t){fcom.ui.Quickview.superclass.constructor.call(this,e,t),this.id=e,this.onHideEvent.subscribe(function(){this.setContent("")},this,!0)},YAHOO.extend(fcom.ui.Quickview,fcom.ui.Tooltip,{show:function(){fcom.ui.Quickview.superclass.show.call(this),this.initAccessibility()},display:function(e,t){this.ric=t,fcom.ui.Quickview.superclass.display.call(this,e)},doDisplay:function(){this.fixed||window.ngpAsyncRequest("POST","/quickview/quickview.plain",{success:function(e){this.setContent(e.responseText),this.adjustDimensions(),this.beforeShowEvent.fire(),null==this.position&&this.defaultPosition(),this.doPosition(this.position),this.show(),null!=this.currentTarget&&YAHOO.util.Event.addListener(this.currentTarget,"mouseout",this.hide,this,!0)},scope:this,silent:!0},{ric:this.ric,id:this.id})},setTargetFocus:function(e){this.currentTarget&&$(this.currentTarget).trigger("tooltip-target-focus",e)},setContent:function(e){if(fcom.ui.Quickview.superclass.setContent.call(this,e),e&&!(e.length<1)){for(var e=YAHOO.fcom.Page.getOverlayDOMNode("quickViewMenu",!0),i=YAHOO.util.Dom.getElementsBy(function(){return!0},"li",e),t=0;t<i.length;t++)YAHOO.util.Event.addListener(i[t],"click",function(e,t){YAHOO.util.Dom.hasClass(t,"selected")?YAHOO.util.Dom.removeClass(t,"selected"):YAHOO.util.Dom.addClass(t,"selected"),0==this.getSelectedParts().length&&YAHOO.util.Dom.addClass(i[0],"selected"),this.updateQuickviewBody()},i[t],this);e=YAHOO.fcom.Page.getOverlayDOMNode("quickViewClose",!0),e=(YAHOO.util.Event.addListener(e,"click",function(){window.Dom.get("quickViewCloseMenuCheckbox").checked?(this.overlay.hide(),YAHOO.fcom.Page.isOverlayIframeRequired()&&YAHOO.fcom.Page.getIFrameHandler().removeOverlayActive(this.overlay.id),this.setTargetFocus({panelFocusStatus:"1"})):window.ngpAsyncRequest("GET","/ajax.action?method=blockQuickview",{success:function(){this.block(),this.setTargetFocus()},scope:this,slient:!0})},this,!0),window.Dom.get("quickViewCloseMenuCheckbox"));e&&YAHOO.util.Event.addListener(e,"change",function(){window.ngpAsyncRequest("GET","/ajax.action?method=blockQuickview",{success:function(){this.block()},scope:this,slient:!0}),this.overlay.hide()},this,!0)}},updateQuickviewBody:function(){window.ngpAsyncRequest("POST","/ajax.action?method=updateQuickview",{success:function(e){var t=this.overlay.cfg.getProperty("xy"),i=0,s=YAHOO.util.Selector.query(".quickViewHeader",this.element);s.length&&(i=YAHOO.fcom.Dom.getDimensions(s[0]).width);var o=YAHOO.fcom.Dom.getDimensions(this.element).width+i,n=window,n=((n=YAHOO.fcom.Page.isOverlayIframeRequired()?YAHOO.fcom.Page.windowToUseForOverlays():n).YAHOO.fcom.Page.replace("quickViewBody",e.responseText,{selectorConfig:{selector:"",apply:function(e,t,i){if(t&&t.parentNode)return t.parentNode.appendChild(i),t.parentNode.removeChild(t),i}}}),this.adjustDimensions(),i=0,(s=YAHOO.util.Selector.query(".quickViewHeader",this.element)).length&&(i=YAHOO.fcom.Dom.getDimensions(s[0]).width),YAHOO.fcom.Dom.getDimensions(this.element).width+i),e=Math.max(t[0]-(n-o),0);this.overlay.moveTo(e,t[1]),YAHOO.lang.later(10,this,function(){this.resetHideTimer(),this.fixed=!0})},scope:this,waitMask:"quickView"},{ric:this.ric,bodyOnly:!0,id:this.id,selectedParts:this.getSelectedParts()})},getSelectedParts:function(){for(var e=YAHOO.util.Dom.getElementsByClassName("selected","li","quickViewMenu"),t=[],i=0;i<e.length;i++){var s=e[i].id;t.push(s.substring(s.indexOf("quickViewMenu.")+"quickViewMenu.".length,s.length))}return t},adjustDimensions:function(){var e=YAHOO.util.Dom.getRegion("quickViewHeader"),t=YAHOO.util.Dom.getRegion("quickViewBody");e.bottom-e.top!=t.bottom-t.top&&YAHOO.util.Dom.setStyle(YAHOO.util.Dom.get("quickViewHeader"),"height",t.bottom-t.top+"px")},newsLink:function(e,t,i){window.themeProperties["quickview.newsLink.popup"]&&"undefined"!=typeof window.createNewsView?(this.hide(),window.createNewsView({newsId:t,category:e,onlyArticle:!0})):(i=YAHOO.fcom.Util.addURLParam("/detail/detailPage.html","ric",i),i=YAHOO.fcom.Util.addURLParam(i,"cat",e),i=YAHOO.fcom.Util.addURLParam(i,"nid",t),i=YAHOO.fcom.Util.addURLParam(i,"subPage","news"),window.redirectTo(i))},initAccessibility:function(){var i=this;window.fcom.Accessibility.init({tooltip:{container:{id:"ngpQuickview"},selectedParts:this.getSelectedParts()||[],$target:this.currentTarget,hide:function(){i.hide()}}}),$(window.document).attr("data-focus-bind")||$(window.document).attr("data-focus-bind",!0).on("focus","body",function(t){window.setTimeout(function(){var e=$(document.activeElement);!e.is(i.currentTarget)&&!e.is("#ngpQuickview")&&0<!e.closest("#ngpQuickview").length&&(t.preventDefault(),i.hide())},10)})}});
//# sourceMappingURL=Tooltip.js.map;
window.ngpNamespace("fcom.ui"),fcom.ui.DisplayGroup=function(){if(this.elements=[],this.subsets={},this.visibleSubset,1<arguments.length)for(var s=YAHOO.util.Dom.get(arguments[0]),e=1,t=arguments.length;e<t;e++){var i=arguments[e];this.registerSubset({name:i,selector:"."+i,root:s,visible:1==e})}this.showSubset(this.visibleSubset)},fcom.ui.DisplayGroup.prototype={registerSubset:function(s){var e;fcom.util.StringHelper.empty(s.selector)||(e=YAHOO.util.Dom.get(s.root),s.elements=YAHOO.util.Selector.query(s.selector,e)),this.elements=this.elements.concat(s.elements),(this.subsets[s.name]=s).visible&&(this.visibleSubset=s.name)},addElementsToSet:function(s,e){var t=(e=e instanceof Array?e:[e]).length;for(null==this.subsets[s]&&(this.subsets[s]={visible:!1,elements:[]});t--;){var i=YAHOO.util.Dom.get(e[t]);this.elements.push(i),this.subsets[s].elements.push(i)}this.showSubset(this.visibleSubset)},toggleSubset:function(s){s=this.subsets[s];if(s)return s.visible?this._displaySubset(s,!1):this._displaySubset(s,!0),s.visible},showSubset:function(s){var e;null!=s&&(e=this.subsets[s])&&(this.visibleSubset=s,this._displaySubset(e,!0))},hideSubset:function(s){if(null!=s){var e=this.subsets[s];if(e){for(var t=0;t<this.elements.length;t++){var i=this.elements[t];-1!=window.FUtil.indexOf(i,e.elements)&&this._displayElement(i,!1)}e.visible=!1}}},isVisible:function(s){return this.visibleSubset==s},_displaySubset:function(s,e){for(var t,i=0;i<this.elements.length;i++){var l=this.elements[i];-1==window.FUtil.indexOf(l,s.elements)?this._displayElement(l,!1):this._displayElement(l,e)}for(t in s.visible=e,this.subsets)this.subsets[t]!==s&&(this.subsets[t].visible=!1)},_displayElement:function(s,e){e?YAHOO.util.Dom.setStyle(s,"display",""):YAHOO.util.Dom.setStyle(s,"display","none")}};
//# sourceMappingURL=DisplayGroup.js.map;
window.chartPeriodSelector=function(e,i,t,n){window[e]=function(){for(var e=new YAHOO.fcom.ui.TabMenu(t,"menuItem","on",i.menuConfig),n=0;n<i.items.length;n++){var o=i.items[n];e.addItem("tabItem_"+i.genericId+"_"+o.period,{data:o})}return e},n&&(YAHOO.fcom.Page.register(t),YAHOO.util.Event.onDOMReady(function(){window[e]=window[e](),YAHOO.fcom.Page.ready(t,window[e])}))};
//# sourceMappingURL=Tags.js.map;
(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var _lodash = require("lodash");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * @class       : TagsInput
                                                                                                                                                                                                                                                                                                                                                                                               * @description : To make an input to tagify input
                                                                                                                                                                                                                                                                                                                                                                                               * @reference   : https://github.com/yairEO/tagify
                                                                                                                                                                                                                                                                                                                                                                                               * @ticket      : https://jira.financial.com/browse/NGPII-20999
                                                                                                                                                                                                                                                                                                                                                                                               */
var TagsInput = /*#__PURE__*/function () {
  function TagsInput($element, config) {
    _classCallCheck(this, TagsInput);
    // #. Set the configuration
    this.config = (0, _lodash.merge)(this.defaultConfig, config || {});
    this.$element = $element;
    this.tagColors = this.config.tagColors;
    this.tagColorsLength = 10;
    this.tagColorLastIndex = 0;
    // #. Check tag colors prop added
    if (this.tagColors) {
      this.config.transformTag = this._transformTag.bind(this);
    }
    this.storageSettings = null;
    if (this.config.localStorage.enabled) {
      var settings = window.localStorage.getItem(this.config.localStorage.key);
      this.storageSettings = settings && JSON.parse(settings);
    }

    // #. Init the control
    this.init();
  }

  /**
   * @method init
   * @description initialize the tagify control
   */
  _createClass(TagsInput, [{
    key: "defaultConfig",
    get: function get() {
      return (0, _lodash.clone)({
        delimiters: ',| ',
        originalInputValueFormat: function originalInputValueFormat(valuesArr) {
          return valuesArr.map(function (item) {
            return item.value;
          }).join(',');
        },
        localStorage: {
          enabled: false
        },
        a11y: {
          focusableTags: true
        }
      });
    }
  }, {
    key: "activeAppTheme",
    get: function get() {
      var theme = String((0, _lodash.get)(window, 'user.theme') || '').toLowerCase();
      return theme;
    }
  }, {
    key: "isDarkTheme",
    get: function get() {
      return this.activeAppTheme.indexOf('dark') !== -1 || this.activeAppTheme.indexOf('modern') !== -1;
    }
  }, {
    key: "$allTags",
    get: function get() {
      return $(this.$tagInput.DOM.scope).find('tag') || [];
    }
  }, {
    key: "init",
    value: function init() {
      var _this = this;
      if (!window.Tagify) {
        return true;
      }

      // #. Add values after init - to keep the tag color index
      var values = this.$element.value;
      this.$element.value = '';
      this.$tagInput = new window.Tagify(this.$element, this.config).on('input', function () {
        // #. Clear storage settings
        _this.storageSettings = null;
      }).on('add', function (event) {
        _this._applyDefaultTagStyles(event.detail);
        _this._updateWCAGAttributes(event.detail);
        // #. Update store
        _this._updateStore(100);
      }).on('remove', function (event) {
        _this._reArrangeDefaultTagStyles(event.detail);
        // #. Update store
        _this._updateStore(100);
      }).on('change', function (event) {
        if (_this.config.onChange) {
          _this.config.onChange(event);
        }
      });

      // #. Apply theme info
      this._applyTheme();
      // #. Add initial values after initialization
      this.$tagInput.addTags(values.split(this.config.delimiters));
    }

    /**
     * @method _applyTheme
     * @description Apply theme information
     */
  }, {
    key: "_applyTheme",
    value: function _applyTheme() {
      var $scopeEl = $((0, _lodash.get)(this.$tagInput, 'DOM.scope'));
      $scopeEl.addClass(this.isDarkTheme ? 'dark' : 'light');
    }

    /**
     * @method _transformTag
     * @description Transform the tag with specific color/format
     */
  }, {
    key: "_transformTag",
    value: function _transformTag(params) {
      if (this.tagColors) {
        // #. Repeat the colors when array values are over the index
        if (this.tagColorLastIndex >= this.tagColors.length) {
          this.tagColorLastIndex = 0;
        }

        // #. Get settings from storage, if available
        var color = null;
        if (this.storageSettings) {
          var values = this.storageSettings.values || [];
          var tagItem = values.find(function (item) {
            return item.value === params.value;
          });
          color = tagItem && tagItem.color;
          this.tagColorLastIndex = this.storageSettings.colorIndex;
        }

        // #. Assign the tag colors
        params.style = "--tag-bg: ".concat(color || this.tagColors[this.tagColorLastIndex]);
        // #. Update the tag index
        this.tagColorLastIndex++;
      }
    }

    /**
     * @method _applyDefaultTagStyles
     * @description Apply default tag style based on index
     * CSS information added on tags-input.scss
     */
  }, {
    key: "_applyDefaultTagStyles",
    value: function _applyDefaultTagStyles(data) {
      var $tag = $(data.tag);
      var index = data.index < this.tagColorsLength ? data.index + 1 : data.index / this.tagColorsLength;
      $tag.addClass("tag".concat(index));
      $tag.data('index', index);
    }

    /**
     * @method _updateWCAGAttributes
     * @description Apply WCAG standard attributes
     */
  }, {
    key: "_updateWCAGAttributes",
    value: function _updateWCAGAttributes(node) {
      var removeButton = node.tag.querySelector('.tagify__tag__removeBtn');
      removeButton.removeAttribute('aria-label');
      removeButton.setAttribute('aria-label', window.getMessage('tagify.button.wcag.remove', node.data.value));
      removeButton.setAttribute('role', 'button');
    }

    /**
     * @method _reArrangeDefaultTagStyles
     * @description Rearrange default style after removing an item
     */
  }, {
    key: "_reArrangeDefaultTagStyles",
    value: function _reArrangeDefaultTagStyles(data) {
      var $tags = this.$allTags;
      for (var i = 0; i < $tags.length; i++) {
        var $tag = $($tags[i]);
        var prevIndex = $tag.data('index');
        // #. Remove previous class
        $tag.removeClass("tag".concat(prevIndex));
        // #. Add new index
        $tag.addClass("tag".concat(i + 1));
        $tag.data('index', i + 1);
      }
    }

    /**
     * @method _updateStore
     * @description Update details to local storage
     */
  }, {
    key: "_updateStore",
    value: function _updateStore(delay) {
      var _this2 = this;
      if (window.localStorage && this.config.localStorage.enabled) {
        window.setTimeout(function () {
          var values = [];
          var $tags = _this2.$allTags;
          for (var i = 0; i < $tags.length; i++) {
            var $tag = $($tags[i]);
            values.push({
              value: $tag.find('.tagify__tag-text').text(),
              background: $tag.css('--tag-bg'),
              color: $tag.css('--tag-text-color')
            });
          }
          // #. Store to localStorage
          window.localStorage.setItem(_this2.config.localStorage.key, JSON.stringify(values));
        }, delay || 50);
      }
    }
  }]);
  return TagsInput;
}(); // #. Assign the class to the namespace
window.YAHOO.fcom.TagsInput = TagsInput;

},{"lodash":2}],2:[function(require,module,exports){
(function (global){(function (){
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    define(function() {
      return _;
    });
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}]},{},[1]);
;
window.ngpNamespace("fcom.ui"),fcom.ui.ResetButton=function(t,e){this.el=YAHOO.util.Dom.get(t),this.comparator=e.comparator||this.compareSimple,this.onDataReset=new YAHOO.util.CustomEvent("dataReset"),this.init(e)},fcom.ui.ResetButton.prototype={init:function(t){YAHOO.util.Event.addListener(this.el,"click",this.clickListener,this,!0),t.defaultData&&this.setDefaultData(t.defaultData),t.data&&this.setData(t.data),t.onDataReset&&this.onDataReset.subscribe(t.onDataReset.fn,t.onDataReset.scope,!0)},comparator:null,compareSimple:function(t,e){return t==e},clickListener:function(){this.setDefaultState(!0),this.onDataReset.fire(this.defaultData)},setDefaultState:function(t){window.setElementDisabled(this.el,t)},setDefaultData:function(t){this.defaultData=t},setData:function(t){this.setDefaultState(this.comparator(t,this.defaultData))}};
//# sourceMappingURL=ResetButton.js.map;
window.ngpNamespace("fcom.ui"),fcom.ui.TreeView=function(e){var t={mode:"focus",toggleTooltip:window.getMessage("treeview.toggleSelection.tooltip"),toggleNoTooltip:""};this.config=YAHOO.lang.augmentObject(e,t),this.container=YAHOO.util.Dom.get(e.container),this.tree=null,this.focusedNode=null,this.selectedNodes=[],this.focusChangedEvent=new YAHOO.util.CustomEvent("focusChanged"),this.selectionChangedEvent=new YAHOO.util.CustomEvent("selectionChanged"),this.init()},fcom.ui.TreeView.prototype={init:function init(){this.tree=new YAHOO.widget.TreeView(this.container),this.tree.singleNodeHighlight=!0,this.tree.subscribe("labelClick",this.labelClickListener,this,!0),this.tree.subscribe("checkClick",this.checkClickListener,this,!0),this.tree.subscribe("clickEvent",function(){return!1})},labelClickListener:function labelClickListener(e){this.focusedNode!==e&&this.focusNode(e),"recursive"!=this.config.mode&&"select"!=this.config.mode||(e.checked?this._deselectNode(e):this._selectNode(e))},checkClickListener:function checkClickListener(e){e.checked?this.selectNode(e):this.deselectNode(e)},focusNode:function focusNode(e){e.highlight(),this.focusedNode=e,this.focusChangedEvent.fire(e.data.value),this.expandPath(e)},focusRootNode:function focusRootNode(){var e=this.tree.getRoot();(e=e&&null==e.label?e.children[0]:e)&&this.focusNode(e)},focusByValue:function focusByValue(e,t){e=this.getNodeByValue(e);return e&&this.focusNode(e,t),this.focusedNode},getFocusedValue:function getFocusedValue(){return this.focusedNode&&this.focusedNode.data?this.focusedNode.data.value:null},getFocusedLabel:function getFocusedLabel(){return this.focusedNode.label},selectNode:function selectNode(e,t){switch(this.config.mode){case"select":this._selectNode(e,t);break;case"recursive":this._selectNodeRecursive(e,t),e.expand();break;case"recursiveAuto":this.deselectNode(e),this._selectNodeRecursiveAuto(e,t),e.expand()}},deselectNode:function deselectNode(e,t){switch(this.config.mode){case"select":this._deselectNode(e,t);break;case"recursive":this._deselectNodeRecursive(e,t);break;case"recursiveAuto":this._deselectNodeRecursiveAuto(e,t)}},_selectNode:function _selectNode(e,t){e.disabled&&"function"!=typeof e.check||(e.check(),-1==YAHOO.fcom.Util.indexOf(e,this.selectedNodes)&&this.selectedNodes.push(e),this.selectionChangedEvent.fire(this.getSelectedValues()),t&&this.expandPath(e))},_selectNodeRecursive:function _selectNodeRecursive(e,t){this._selectNode(e,t);for(var i=0;i<e.children.length;i++)this._selectNodeRecursive(e.children[i],t)},_selectNodeRecursiveAuto:function _selectNodeRecursiveAuto(e,t){this._selectNode(e,t),this.forAll(function(e){e.check(),e.disable()},e)},_deselectNode:function _deselectNode(e){e.disabled&&"function"!=typeof e.uncheck||(e.uncheck(),-1!=(e=YAHOO.fcom.Util.indexOf(e,this.selectedNodes))&&this.selectedNodes.splice(e,1),this.selectionChangedEvent.fire(this.getSelectedValues()))},_deselectNodeRecursive:function _selectNodeRecursive(e,t){this._deselectNode(e,t);for(var i=0;i<e.children.length;i++)this._deselectNodeRecursive(e.children[i],t)},_deselectNodeRecursiveAuto:function _selectNodeRecursiveAuto(e,t){this._deselectNode(e,t);for(var i=0;i<e.children.length;i++)this._deselectNodeRecursiveAuto(e.children[i],t),e.children[i].enable(!0),e.children[i].uncheck()},selectByValue:function selectByValue(e,t){e=this.getNodeByValue(e);return e&&("recursive"===this.config.mode?this._selectNode(e,t):(this.deselectNode(e),this.selectNode(e,t))),e},deselectByValue:function deselectByValue(e){e=this.getNodeByValue(e);e&&this.deselectNode(e)},_setSelectedValues:function _setSelectedValues(e,t){this.clearSelection();for(var i=0;i<e.length;i++)this.selectByValue(e[i],t)},setSelectedValues:function setSelectedValues(e,t){switch(this.config.mode){case"select":case"recursive":this._setSelectedValues(e,t);break;case"recursiveAuto":this._setSelectedValuesRecursiveAuto(e,t)}},_setSelectedValuesRecursiveAuto:function _setSelectedValuesRecursiveAuto(e,t){for(var i=[],s=0;s<e.length;s++){var o=this.getNodeByValue(e[s]);o&&-1<o.depth&&("undefined"==typeof i[o.depth]&&(i[o.depth]=[]),i[o.depth].push(e[s]))}for(s=i.length;s--;)if(void 0!==(e=i[s]))for(var c=0;c<e.length;c++)this.selectByValue(e[c],t)},getSelectedValues:function getSelectedValues(){for(var e=[],t=0;t<this.selectedNodes.length;t++)e.push(this.selectedNodes[t].data.value);return e},clearSelection:function clearSelection(){for(var e=0;e<this.selectedNodes.length;e++)this.selectedNodes[e]&&this.selectedNodes[e].checked&&this.selectedNodes[e].uncheck();this.selectedNodes=[]},getNodeByValue:function getNodeByValue(e){return this.tree.getNodeByProperty("value",e)},getLabelByValue:function getLabelByValue(e){e=this.getNodeByValue(e);if(e)return e.label},expandPath:function(e){null!=e.parent&&(e.parent.expand(),this.expandPath(e.parent))},addChildren:function(e,t,i){if(e&&e.children)for(var s=0;s<e.children.length;s++)this.addNode(e.children[s],t,i)},addNode:function(e,t,i){var s=i?i(e):this._mapNodeData(e),s=this._treeNodeByType(s,t);if(s)return this.addChildren(e,s,i),s},_treeNodeByType:function(e,t){if(!e.label)return null;if(e.type){if("text"==e.type)return new YAHOO.widget.ExtendedTextNode(e,t);if("check"==e.type)return new YAHOO.widget.CheckNode(e,t)}return new("focus"==this.config.mode?"undefined"==typeof e.clickable||e.clickable?YAHOO.widget.ExtendedTextNode:YAHOO.widget.UnclickableTextNode:"select"!=this.config.mode&&"recursive"!=this.config.mode&&"recursiveAuto"!=this.config.mode||"undefined"==typeof e.clickable||e.clickable?YAHOO.widget.CheckNode:YAHOO.widget.ExtendedTextNode)(e,t)},_mapNodeData:function(e){return{label:e.label,value:e.value}},setData:function setData(e,t){this.data=[].concat(e);for(var i=this.tree.getRoot(),s=0;s<this.data.length;s++)this.addNode(this.data[s],i,t);this.tree.draw()},setMode:function setMode(e){var t=this._tree_needs_rebuild(e);this.config.mode=e,t?(this.tree.removeChildren(this.tree.getRoot()),this.setData(this.data)):this.forAll(function(e){e.enable(),e.uncheck()}),"focus"!=this.config.mode?this.setSelectedValues(this.getSelectedValues(),!0):this.clearSelection(),this.setLabelTitleAllNodes()},setLabelTitleAllNodes:function setLabelTitleAllNodes(){var e=this.config.toggleNoTooltip,t=("recursive"==this.config.mode&&(e=this.config.toggleTooltip),this.tree.getRoot());this.forAll(function(e,t){e.setLabelTitle&&e.setLabelTitle(t)},t,e)},_tree_needs_rebuild:function _tree_needs_rebuild(e){return e!=this.config.mode&&("focus"==e||"focus"==this.config.mode)},forAll:function forAll(e,t,i){t=t||this.tree.getRoot();for(var s=0;s<t.children.length;s++){var o=t.children[s];e(o,i),this.forAll(e,o,i)}}},fcom.ui.TreeViewSelect=function(e){this.toggleEl=YAHOO.util.Dom.get(e.toggleEl),this.inputEl=YAHOO.util.Dom.get(e.inputEl),this.hiddenEl=YAHOO.util.Dom.get(e.hiddenEl),this.visible=!1,this.overlay=this.createOverlay(e),e.container||(e.container=this.overlay.element),fcom.ui.TreeViewSelect.superclass.constructor.call(this,e)},YAHOO.extend(fcom.ui.TreeViewSelect,fcom.ui.TreeView,{init:function init(){fcom.ui.TreeViewSelect.superclass.init.call(this),YAHOO.util.Event.addListener(this.toggleEl,"click",this.toggleTree,this,!0)},createOverlay:function createOverlay(e){var t=document.createElement("div"),e=(YAHOO.util.Dom.addClass(t,"treeviewmodule"),YAHOO.util.Dom.addClass(t,"treeviewselect"),YAHOO.util.Dom.addClass(t,e.cssClass),new YAHOO.widget.Overlay(t,{constraintoviewport:!0,context:[this.inputEl,"tl","bl"],visible:!1}));return document.body.appendChild(t),e},toggleTree:function toggleTree(){this.visible?this.hideTree():this.showTree()},showTree:function showList(){this.resetWidth(),this.overlay.align(),this.overlay.bringToTop(),this.overlay.show(),YAHOO.util.Event.addListener(document,"mousedown",this._onDocumentMouseDown,this,!0),this.visible=!0},hideTree:function hideTree(){this.overlay.hide(),YAHOO.util.Event.removeListener(document,"mousedown",this._onDocumentMouseDown),this.visible=!1},_onDocumentMouseDown:function _onDocumentMouseDown(e){var t,e=YAHOO.util.Event.getTarget(e);e!=this.container&&e!=this.inputEl&&e!=this.toggleEl&&(t=this,null==YAHOO.util.Dom.getAncestorBy(e,function(e){return e==t.container}))&&this.hideTree()},resetWidth:function(){var e=YAHOO.fcom.Dom.getDimensions(this.inputEl);this.overlay.cfg.setProperty("width",(this.config.width||2*e.width)+"px")},focusNode:function focusNode(e){fcom.ui.TreeViewSelect.superclass.focusNode.call(this,e),this.inputEl.value=this.getFocusedLabel(),this.inputEl.title=this.getFocusedLabel(),this.hiddenEl&&(this.hiddenEl.value=this.getFocusedValue()),this.hideTree()}});
//# sourceMappingURL=TreeView.js.map;
"undefined"!=typeof Raphael&&(Raphael.fn.debug=function(t){var h;if(t.push)return h=this.set(),t.forEach(function(t){h.push(this.debug(t))},this),h.push(this.debug(t.getBBox())),h;if(t.getBBoxFix){var e=t.getBBoxFix(),a=this.set(),i=(a.push(this.rect(e.x,e.y,e.width,e.height).attr({stroke:"#FF0000"})),e.x),s=e.y;if("text"==t.type){switch(t.attr("text-anchor")){case"end":i+=e.width;break;case"middle":i+=e.width/2}s+=e.height/2}return a.push(this.circle(i,s,3).attr({stroke:"#FF0000"})),a}return this.rect(t.x,t.y,t.width,t.height).attr({stroke:"#00FF21","stroke-dasharray":"- "})},Raphael.fn.intersects=function(t,h,e){t=t.getBBoxFix?t.getBBoxFix():t,h=h.getBBoxFix?h.getBBoxFix():h;var a=t.x,i=t.x+t.width,s=t.y,t=t.y+t.height,r=h.x,n=h.x+h.width,o=h.y,h=h.y+h.height;return e&&(a-=e,i+=e,s-=e,t+=e),r<=i&&o<=t&&a<=n&&s<=h},Raphael.fn.contains=function(t,h){var e,a,i,s;return null==t.width?(e=h.x,a=h.y,i=h.width,s=h.height,!(t.x<e||t.y<a)&&(s+=a,(i+=e)<e||i>=t.x)&&(s<a||s>=t.y)):this.contains({x:t.x,y:t.y},h)&&this.contains({x:t.x+t.width,y:t.y},h)&&this.contains({x:t.x+t.width,y:t.y+t.height},h)&&this.contains({x:t.x,y:t.y+t.height},h)},Raphael.fn.rotationCoordinates=function(t,h,e){var a={};return e*=Math.PI/180,a.x=h.x+(t.x-h.x)*Math.cos(e)-(t.y-h.y)*Math.sin(e),a.y=h.y+(t.x-h.x)*Math.sin(e)+(t.y-h.y)*Math.cos(e),a},Raphael.fn.toRad=function(t){return t*Math.PI/180},Raphael.fn.toDeg=function(t){return 180*t/Math.PI},Raphael.fn.hex2Hsv=function(t){var h,t=this.raphael.getRGB(t),e=1<t.r?t.r/255:t.r,a=1<t.g?t.g/255:t.g,t=1<t.b?t.b/255:t.b,i=Math.min(e,a,t),s=Math.max(e,a,t),i=s-i;return 0==s?{h:h=-1,s:0,v:s}:(h=e==s?(a-t)/i||0:a==s?2+(t-e)/i||0:4+(e-a)/i||0,(h*=60)<0&&(h+=360),{h:h,s:i/s,v:s})},Raphael.fn.hsv2Hex=function(t,h,e){var a,i,s,r,n,o,c;if(0==h)n=o=c=e;else switch(i=e*(1-h),s=e*(1-h*(a=(t/=60)-(t=Math.floor(t)))),r=e*(1-h*(1-a)),t){case 0:n=e,o=r,c=i;break;case 1:n=s,o=e,c=i;break;case 2:n=i,o=e,c=r;break;case 3:n=i,o=s,c=e;break;case 4:n=r,o=i,c=e;break;default:n=e,o=i,c=s}return this.raphael.getRGB("rgb("+(n=n<=1?255*n:n)+","+(o=o<=1?255*o:o)+","+(c=c<=1?255*c:c)+")").hex},Raphael.fn.alignTextWithinBBox=function(t,h,e,a,i,s,r){var n=this.text(0,0,t).attr(r),o=n.getBBoxFix();switch(n.remove(),r["text-anchor"]){case"start":return this.text(h.x+s,h.y+e+o.height/2,t).attr(r);case"end":return this.text(h.x+h.width-a,h.y+e+o.height/2,t).attr(r);default:return this.text(h.x+h.width/2,h.y+e+o.height/2,t).attr(r)}},Raphael.fn.margin=function(t,h){return t.attr({x:t.attrs.x+h.marginLeft-h.marginRight,y:t.attrs.y+h.marginTop-h.marginBottom})},Raphael.fn.verticalAlignWithinBBox=function(t,h,e,a,i){var s=t.getBBoxFix();switch(i.align){case"bottom":t.attr({y:h.y+h.height-a-s.height/2});break;case"middle":t.attr({y:h.y+h.height/2});break;default:t.attr({y:h.y+e+s.height/2})}},Raphael.fn.constrainToBBox=function(t,h,e){if(!this.contains(t,h)){var a=t.x,i=t.y;if(e&&((h.x>a||h.x+h.width<t.x+t.width)&&(a=e.x-(t.x-e.x)-t.width),h.y>i||h.y+h.height<i+t.height)&&(i=e.y-(t.y-e.y)-t.height),h.x>a&&(a=h.x),h.x+h.width<t.x+t.width&&(a=h.x+h.width-t.width),h.y>i&&(i=h.y),h.y+h.height<i+t.height&&(i=h.y+h.height-t.height),this.contains({x:a,y:i,width:t.width,height:t.height},h))return{x:a,y:i}}return{x:t.x,y:t.y}},Raphael.fn.filterSet=function(t,h,e,a){for(var i,s=this.set();i=t.items.shift();)!0===h.call(this,i)?(s.push(i),e&&e.call(this,i)):a&&a.call(this,i);return s},Raphael.fn.lighter=function(t,h){h=h||1.2;t=this.hex2Hsv(t);return t.v=Math.min(t.v*h,1),t.s/=h,this.hsv2Hex(t.h,t.s,t.v)},Raphael.fn.getBBoxSet=function(t){for(var h=[],e=[],a=[],i=[],s=t.items.length;s--;){var r=t.items[s].getBBoxFix();h.push(r.x),e.push(r.y),a.push(r.x+r.width),i.push(r.y+r.height)}return{x:h=Math.min.apply(0,h),y:e=Math.min.apply(0,e),width:Math.max.apply(0,a)-h,height:Math.max.apply(0,i)-e}},Raphael.fn.square=function(t,h,e){return this.rect(t-e/2,h-e/2,e,e)},Raphael.fn.roundOFive=function(t){return t*=10,(t=Math.floor(t+5-t%10))/10},Raphael.fn.gridLine=function(t){var h;return t[0]==t[2]?(h=this.roundOFive(t[0]),t[0]=t[2]=h):t[1]==t[3]&&(h=this.roundOFive(t[1]),t[1]=t[3]=h),this.path(["M",t[0],t[1],"L",t[2],t[3]])},Raphael.fn.sector=function(t,h,e,a,i,s,r,n){return a-=90,i-=90,!n&&359.9<i-a?this.circle(t,h,e).attr(s).attr({fill:r}):((n=(n?this.path(this.ringPath(t,h,.65*e,e,a,i)):this.path(this.sectorPath(t,h,e,a,i))).attr(s).attr({fill:r})).conf={c:{x:t,y:h},r:e,startAngle:a,endAngle:i},n)},Raphael.fn.sectorPath=function(t,h,e,a,i){var s=t+e*Math.cos(this.toRad(a)),r=t+e*Math.cos(this.toRad(i));return["M",t,h,"L",s,h+e*Math.sin(this.toRad(a)),"A",e,e,0,+(180<i-a),1,r,h+e*Math.sin(this.toRad(i)),"z"]},Raphael.fn.ringPath=function(t,h,e,a,i,s){var r=Math.abs(i-s),r=((r<.01||359.99<r)&&(s-=.01),t+e*Math.cos(this.toRad(i))),n=t+e*Math.cos(this.toRad(s)),o=h+e*Math.sin(this.toRad(i)),c=h+e*Math.sin(this.toRad(s)),l=t+a*Math.cos(this.toRad(i)),t=t+a*Math.cos(this.toRad(s)),f=h+a*Math.sin(this.toRad(i));return["M",r,o,"A",e,e,0,+(180<s-i),1,n,c,"L",t,h+a*Math.sin(this.toRad(s)),"A",a,a,0,+(180<s-i),0,l,f,"z"]},Raphael.fn.moveSector=function(t,h,e){var a,i,s,r;t.conf&&(a=t.conf.c,i=t.conf.r,s=this.toRad((t.conf.endAngle-t.conf.startAngle)/2+t.conf.startAngle),r=null!=h?h*Math.cos(s)+a.x:a.x,h=null!=h?h*Math.sin(s)+a.y:a.y,e?t.attr({path:this.ringPath(r,h,.65*i,i,t.conf.startAngle,t.conf.endAngle)}):t.attr({path:this.sectorPath(r,h,i,t.conf.startAngle,t.conf.endAngle)}))},Raphael.fn.pieChart=function(e,a,i,t,h,s,r,n){for(var o=0,c=0,l=[],f=0;f<t.items.length;f++)c+=t.getValue(f);for(var g=this.sector(e,a,i+1,0,360,s.sector.shape,"#999999",n).shadow(),f=0;f<t.items.length;f++){var u,p,x=t.getValue(f)/c*360,d=o+x;f==t.items.length-1&&(d=360),!isNaN(d)&&.1<x&&(p=(x=s.sector.multipleColors).rotation.length,u=null,u=h&&f==t.items.length-1?t.items[f][h.key]==h.value?x.other:x.last:f<p?x.rotation[f]:x.rotation[f%p],p=this.sector(e,a,i+1,o,d,s.sector.shape,"#999999",n),this.moveSector(p,s.sector.marginLeft,n),p.shadow().hide(),(x=this.sector(e,a,i,o,d,s.sector.shape,u,n)).color=u,x.data=t.items[f],x.highlight=function(t){!0===t?(this.attr(s.sector.highlight.shape),null!=s.sector.highlight.shape.fill&&this.paper.raphael.getRGB(s.sector.highlight.shape.fill)!=this.paper.raphael.getRGB(this.color)||this.attr({fill:this.paper.lighter(this.color)})):!0!==this.active&&this.attr(s.sector.shape).attr({fill:this.color})},x.mouseover(function(){this.highlight(!0),r.mouseover(this.data)}).mouseout(function(){this.highlight(!1),r.mouseout(this.data)}),x.click(function(){r.mouseclick(this.data)}),x.shadow=p,l.push(x),o=d)}return{sectors:l,shadow:g,sectorShadow:null,activeSector:null,paper:this,detach:function(t){this.shadow.remove(),this.partShadow=this.paper.sector(t.conf.c.x,t.conf.c.y,t.conf.r+1,t.conf.endAngle+90,360+t.conf.startAngle+90,s.sector.shape,"#999999",n).shadow();for(var h=this.sectors.length;h--;)this.sectors[h].toFront();this.paper.moveSector(t,s.sector.marginLeft,n),t.shadow.show(),t.active=!0,t.highlight(!0)},attach:function(t){t.shadow.hide(),this.partShadow.remove(),this.paper.moveSector(t,null,n),this.shadow=this.paper.sector(e,a,i+1,0,360,s.sector.shape,"#999999",n).shadow();for(var h=this.sectors.length;h--;)this.sectors[h].toFront();t.active=!1,t.highlight(!1)}}},Raphael.fn.cycle=function(t){var h;return!!(t&&0<t.length)&&(h=t.shift(),t.push(h),h)},Raphael.el.style=function(t){var h;return!1!==(h=this.paper.cycle(t.colors))&&(t.stroke=h),!1!==(h=this.paper.cycle(t.bgcolors))&&(t.fill=h),this.attr(t)},Raphael.el.shadow=function(){return this.attr({fill:"rgba(0,0,0,0.2)",stroke:"none"}),this.blur(2),this.translate(-2,2),this},Raphael.el.getBBoxFix=function(){var t=this.getBBox();return Raphael.vml&&this.type,t});
//# sourceMappingURL=fcom.raphael.js.map;
window.ngpNamespace("YAHOO.fcom.charts"),YAHOO.fcom.charts.ContextProvider=function(){var r=null;return{setContext:function(t){r=t},createContext:function(t,n,e){return null!=(r="string"==typeof r?function(t){for(var n=t.split("."),e=window,r=0;r<n.length;r++)e=e[n[r]];return e}(r):r)?new r(t,n,e):null}}}(),YAHOO.fcom.charts.GfxContext={TEXT_ALIGN_LEFT:"text-left",TEXT_ALIGN_RIGHT:"text-right",TEXT_ALIGN_CENTER:"text-center",ALIGN_TOP_LEFT:"tl",ALIGN_TOP_RIGHT:"tr",ALIGN_BOTTOM_LEFT:"bl",ALIGN_BOTTOM_RIGHT:"br",ALIGN_CENTER:"c"};
//# sourceMappingURL=ContextProvider.js.map;
window.ngpNamespace("YAHOO.fcom.charts"),YAHOO.fcom.charts.RaphaelContext=function(t,i,e){this.contextEl=t;var r=YAHOO.util.Dom.getStyle(this.contextEl,"width"),s=YAHOO.util.Dom.getStyle(this.contextEl,"height");this.paper=Raphael(t,i,e),YAHOO.util.Dom.setStyle(this.contextEl,"width",r),YAHOO.util.Dom.setStyle(this.contextEl,"height",s),this.width=i,this.height=e,this.shim={stroke:"none",fill:"#FF0000","fill-opacity":0},this.pathArray=[],this.destroyed=!1,this.destroyEvent=new YAHOO.util.CustomEvent("destroy")},YAHOO.fcom.charts.RaphaelContext.prototype={destroy:function(){this.destroyed=!0,this.destroyEvent.fire();try{this.paper.remove()}catch(t){}},reset:function(t,i){var e=YAHOO.util.Dom.getStyle(this.contextEl,"width"),r=YAHOO.util.Dom.getStyle(this.contextEl,"height");this.width=t||this.width,this.height=i||this.height,this.paper.remove(),this.paper=Raphael(this.contextEl,this.width,this.height),YAHOO.util.Dom.setStyle(this.contextEl,"width",e),YAHOO.util.Dom.setStyle(this.contextEl,"height",r)},beginPath:function(){this.pathArray=[]},moveTo:function(t,i){null==i&&(i=t.y,t=t.x),this.pathArray=this.pathArray.concat(["M",t,i])},lineTo:function(t,i){null==i&&(i=t.y,t=t.x),this.pathArray=this.pathArray.concat(["l",t,i])},endPath:function(t,i){(i=i||{}).shape=i.shape||this.shim;i=this.paper.path(this.pathArray).attr(i.shape);this.addPrimitive(t,i)},gridLine:function(t,i,e){(e=e||{}).shape=e.shape||this.shim;i=this.paper.gridLine([i[0],i[1],i[0]+i[2],i[1]+i[3]]).attr(e.shape);this.addPrimitive(t,i)},text:function(t,i,e,r,s,n){var o=YAHOO.fcom.charts.GfxContext,h=((s=s||{}).text=s.text||{},{});switch(n){case o.TEXT_ALIGN_RIGHT:h={"text-anchor":"end"};break;case o.TEXT_ALIGN_CENTER:h={"text-anchor":"middle"};break;default:h={"text-anchor":"start"}}r&&!1!==s.display&&(n=this.paper.text(i,e,r).attr(h).attr(s.text),this.addPrimitive(t,n))},rect:function(t,i,e,r,s,n){(n=n||{}).shape=n.shape||this.shim;i=this.paper.rect(i,e,r,s).attr(n.shape);this.addPrimitive(t,i)},gridRect:function(t,i,e,r,s,n){i=this.paper.roundOFive(i),r=Math.round(r),s=this.paper.roundOFive(s),this.rect(t,i,e,r,s,n)},fill:function(t,i,e,r,s,n){(n=n||{}).shape=n.shape||this.shim,n.shape.stroke="none",this.rect(t,i,e,r,s,n)},square:function(t,i,e,r,s){return this.rect(t,i,e,r,r,s)},circle:function(t,i,e,r,s){(s=s||{}).shape=s.shape||this.shim;i=this.paper.circle(i,e,r).attr(s.shape);this.addPrimitive(t,i)},rotate:function(t,i){t.primitives&&t.primitives.forEach(function(t){t.transform(Raphael.format("...R{0}",i))},this),t.debugPrimitives&&t.debugPrimitives.forEach(function(t){t.transform(Raphael.format("...R{0}",i))},this)},movePivot:function(t,i,e){null!=t.primitives&&t.primitives.forEach(function(t){t.transform(""),t.transform(Raphael.format("...T{0},{1}",i,e))},this),null!=t.debugPrimitives&&t.debugPrimitives.forEach(function(t){t.transform(""),t.transform(Raphael.format("...T{0},{1}",i,e))},this)},move:function(t,i,e){var r=t.getBBox();this.translate(t,i-r.x,e-r.y)},translate:function(t,i,e){null!=t.primitives&&t.primitives.forEach(function(t){t.transform(Raphael.format("...T{0},{1}",i,e))},this),null!=t.debugPrimitives&&t.debugPrimitives.forEach(function(t){t.transform(Raphael.format("...T{0},{1}",i,e))},this)},debug:function(t,i){if(null==t.debugPrimitives&&(t.debugPrimitives=this.paper.set()),i&&t.primitives){for(var e=t.primitives.length;e--;)t.debugPrimitives.push(this.paper.debug(t.primitives[e]));i=this.getBBox(t);t.debugPrimitives.push(this.paper.debug(i))}else t.debugPrimitives.remove(),t.debugPrimitives=this.paper.set()},getBBox:function(t,i){var e=null;if(t instanceof Array){for(var r=this.paper.set(),s=t.length;s--;){var n=t[s];n.ownedPrimitives&&(r.items=r.items.concat(n.ownedPrimitives.items))}e=this.paper.getBBoxSet(r)}else!1===i&&t.ownedPrimitives?e=this.paper.getBBoxSet(t.ownedPrimitives):t.primitives&&(e=this.paper.getBBoxSet(t.primitives));if(e)return new YAHOO.fcom.charts.GfxBoundingBox(e.x,e.y,e.width,e.height)},clear:function(t,i){if(t instanceof Array)for(var e=t.length;e--;)this.clear(t[e],i);else t instanceof YAHOO.fcom.charts.GfxElement&&t.ownedPrimitives&&(t.ownedPrimitives=this.paper.filterSet(t.ownedPrimitives,function(t){return!t.paper.intersects(t,i)},null,function(t){t.remove()}),this.checkPrimitives(t))},remove:function(t){t instanceof YAHOO.fcom.charts.GfxElement&&(this.removeListeners(t),t.ownedPrimitives&&(t.ownedPrimitives.remove(),delete t.ownedPrimitives),t.debugPrimitives&&(t.debugPrimitives.remove(),delete t.debugPrimitives),delete t.primitives)},intersects:function(t,i){return t instanceof YAHOO.fcom.charts.GfxElement&&(t=this.getBBox(t)),i instanceof YAHOO.fcom.charts.GfxElement&&(i=this.getBBox(i)),this.paper.intersects(t,i)},toFront:function(t,i){t.walkTopDown(function(t){t.silent=!0}),!1!==i&&null!=t.primitives?t.primitives.toFront():null!=t.ownedPrimitves&&t.ownedPrimitives.toFront(),null!=t.debugPrimitives&&t.debugPrimitives.toFront(),YAHOO.lang.later(1,t,function(){this.walkTopDown(function(t){t.silent=!1})})},addPrimitive:function(t,i,e){null==t.primitives&&(t.primitives=this.paper.set()),!1!==e&&null==t.ownedPrimitives&&(t.ownedPrimitives=this.paper.set()),t.primitives.push(i),!1!==e&&t.ownedPrimitives.push(i),null!=t.parent&&this.addPrimitive(t.parent,i,!1)},checkPrimitives:function(t){t.primitives&&(t.primitives=this.paper.filterSet(t.primitives,function(t){return null!=t.paper}),0==t.primitives.length?t.rendered=!1:t.rendered=!0),null!=t.parent&&this.checkPrimitives(t.parent)},fireMouseClick:function(){!0!==this.silent&&this.mouseclick.fire(this)},fireMouseOver:function(){!0!==this.silent&&this.mouseover.fire(this)},fireMouseOut:function(){!0!==this.silent&&this.mouseout.fire(this)},addListeners:function(t){t.ownedPrimitives&&(t.ownedPrimitives.click(this.fireMouseClick,t),t.ownedPrimitives.mouseover(this.fireMouseOver,t),t.ownedPrimitives.mouseout(this.fireMouseOut,t))},removeListeners:function(t){function i(t,i,e,r){try{i["un"+t](e,r)}catch(s){}}if(t.ownedPrimitives)for(var e=t.ownedPrimitives.length;e--;){var r=t.ownedPrimitives[e];i("click",r,this.fireMouseClick,t),i("mouseover",r,this.fireMouseOver,t),i("mouseout",r,this.fireMouseOut,t)}},applyPadding:function(t,i){return t.addOffset(i.paddingLeft+i.paddingRight,i.paddingTop+i.paddingBottom)},applyMargin:function(t,i){return new YAHOO.fcom.charts.GfxBoundingBox(t.x+i.marginLeft,t.y+i.marginTop,t.width-i.marginLeft-i.marginRight,t.height-i.marginTop-i.marginBottom)},constrainToContext:function(t){var i=this.paper.constrainToBBox(t.getBBox(),{x:0,y:0,width:this.width,height:this.height});this.move(t,i.x,i.y)},setVisible:function(t,i){t.primitives&&(i?t.primitives.show():t.primitives.hide())},setStyle:function(t,i){t.locked||null==t.ownedPrimitives||t.ownedPrimitives.attr(i);for(var e=0,r=t.childElements.length;e<r;e++)this.setStyle(t.childElements[e],i)},getStyle:function(t,i){return t.primitives?t.primitives.attrs[i]:null},createAnim:function(t,i,e){return new YAHOO.fcom.charts.RaphaelAnim(t,i,e)}},YAHOO.fcom.charts.ContextProvider.setContext(YAHOO.fcom.charts.RaphaelContext);
//# sourceMappingURL=RaphaelContext.js.map;
window.ngpNamespace("YAHOO.fcom.charts"),YAHOO.fcom.charts.GfxBoundingBox=function(t,h,i,o){this.x=t,this.y=h,this.width=i,this.height=o},YAHOO.fcom.charts.GfxBoundingBox.prototype={addOffset:function(t,h){return t=t||0,h=h||0,new YAHOO.fcom.charts.GfxBoundingBox(this.x-t,this.y-h,this.width+2*t,this.height+2*h)}};
//# sourceMappingURL=GfxBoundingBox.js.map;
window.ngpNamespace("YAHOO.fcom.charts"),YAHOO.fcom.charts.GfxElement=function(t,e,i){this.style=e,this.parent=i,this.childElements=[],i&&this.parent.childElements.push(this),this.config={},YAHOO.lang.augmentObject(this.config,t||{}),this.mouseover=new YAHOO.util.CustomEvent("gfx-mouseover",this,null,YAHOO.util.CustomEvent.FLAT),this.mouseover.subscribe(function(t){this.isBubbleEvent()&&this.parent.mouseover.fire(t)},this,!0),this.mouseout=new YAHOO.util.CustomEvent("gfx-mouseout",this,null,YAHOO.util.CustomEvent.FLAT),this.mouseout.subscribe(function(t){this.isBubbleEvent()&&this.parent.mouseout.fire(t)},this,!0),this.mouseclick=new YAHOO.util.CustomEvent("gfx-mouseclick",this,null,YAHOO.util.CustomEvent.FLAT),this.mouseclick.subscribe(function(t){this.parent&&this.parent.mouseclick.fire(t)},this,!0),this.onRender=new YAHOO.util.CustomEvent("gfx-onrender",this,null,YAHOO.util.CustomEvent.FLAT),this.onDestroy=new YAHOO.util.CustomEvent("gfx-destroy",this,null,YAHOO.util.CustomEvent.FLAT),this.rendered=!1,this.renderContext=null,this.visible=!1,this.locked=!1,this.silent=!1,this.mouseclick.subscribe(function(t){this.parent&&this.parent.mouseclick.fire(t)})},YAHOO.fcom.charts.GfxElement.prototype={render:function(t,e){if(this.renderContext=t,this.renderContext.destroyEvent.subscribe(this.destroy,this,!0),null!=this.childElements.length)for(var i=this.childElements.length;i--;)this.childElements[i].render(t);this.renderElement(t,this.style),t.checkPrimitives(this),!1!==e&&this.onRender.fire(this),t.addListeners(this)},renderElement:function(){},setVisible:function(t){this.renderContext.setVisible(this,t)},debug:function(t){"boolean"!=typeof t&&(t=!0),this.renderContext&&this.renderContext.debug(this,t)},getBBox:function(t){return this.style.display?this.renderContext.getBBox(this,t):new YAHOO.fcom.charts.GfxBoundingBox(0,0,0,0)},align:function(t,e,i,s){var n=this.getBBox(),h=n.x,o=n.y,r=YAHOO.fcom.charts.GfxContext;switch(i){case r.ALIGN_TOP_LEFT:h=t.x,o=t.y;break;case r.ALIGN_TOP_RIGHT:h=t.x+t.width,o=t.y;break;case r.ALIGN_CENTER:h=t.x+t.width/2,o=t.y+t.height/2;break;case r.ALIGN_BOTTOM_LEFT:h=t.x,o=t.y+t.height;break;case r.ALIGN_BOTTOM_RIGHT:h=t.x+t.width,o=t.y+t.height}switch(e){case r.ALIGN_TOP_LEFT:break;case r.ALIGN_TOP_RIGHT:h-=n.width;break;case r.ALIGN_CENTER:h-=n.width/2,o-=n.height/2;break;case r.ALIGN_BOTTOM_LEFT:o-=n.height;break;case r.ALIGN_BOTTOM_RIGHT:h-=n.width,o-=n.height}s&&(h+=s.x||0,o+=s.y||0),this.move(h,o)},move:function(t,e){this.renderContext.move(this,t+(this.style.marginLeft||0)-(this.style.marginRight||0),e+(this.style.marginTop||0)-(this.style.marginBottom||0))},constrainToContext:function(){this.renderContext.constrainToContext(this)},clear:function(t){this.renderContext.clear(this,t)},toFront:function(t){this.renderContext.toFront(this,t)},destroy:function(){if(this.renderContext&&(this.renderContext.destroyEvent.unsubscribe(this.destroy,this),this.renderContext.remove(this)),this.childElements)for(var t=this.childElements.length;t--;)this.childElements[t].destroy();delete this.childElements,delete this.parent,delete this.renderContext,this.onDestroy.fire(),this.mouseclick.unsubscribeAll(),this.mouseout.unsubscribeAll(),this.mouseover.unsubscribeAll(),this.onDestroy.unsubscribeAll(),this.onRender.unsubscribeAll()},addChild:function(t){this.childElements.push(t)},lock:function(t){this.locked=t="boolean"!=typeof t?!0:t},isBubbleEvent:function(){return null!=this.parent&&!this.parent.silent&&!this.silent},walkTopDown:function(t,e,i){if(null!=this.childElements){var s=e||this,n=i||[];n.splice(0,0,this),t.apply(s,n);for(var h=0,o=this.childElements.length;h<o;h++){var r=this.childElements[h].walkTopDown(t,e,i);if(!1===r)return r}}},walkBottomUp:function(t,e,i){var s=e||this,n=i||[];if(n.splice(0,0,this),t.apply(s,n),null!=this.parent){s=this.parent.walkBottomUp(t,e,i);if(!1===s)return s}},toString:function(){return"GfxElement"}};
//# sourceMappingURL=GfxElement.js.map;
window.ngpNamespace("YAHOO.fcom.charts"),YAHOO.fcom.charts.Plot=function(t,e,i,s,r){YAHOO.fcom.charts.Plot.superclass.constructor.call(this,i,s,r),this.unitX=t,this.unitY=e,this.markers=[],this.activeMarker,this.mouseoverMarker=new YAHOO.util.CustomEvent("plot-mouseover-marker",this,!1,YAHOO.util.CustomEvent.FLAT),this.mouseoutMarker=new YAHOO.util.CustomEvent("plot-mouseout-marker",this,!1,YAHOO.util.CustomEvent.FLAT),this.clickMarker=new YAHOO.util.CustomEvent("plot-click-marker",this,!1,YAHOO.util.CustomEvent.FLAT)},YAHOO.fcom.charts.Plot.prototype={getCoordinates:function(t){return{x:this.xaxis.getAxisCoordinate(t.x),y:this.yaxis.getAxisCoordinate(t.y)}},getValues:function(t){return{x:this.xaxis.getAxisValue(t.x),y:this.yaxis.getAxisValue(t.y)}},addMarkers:function(t,e,h){h=h||this,e=e||{};for(var i={},s=(YAHOO.lang.augmentObject(i,e),YAHOO.lang.augmentObject(i,this.style.data),[i]),r=1;r<=5;r++){var a={};YAHOO.lang.augmentObject(a,this.style["data color"+r]||{}),YAHOO.lang.augmentObject(a,i),s[r]=a}var x=t.getMax("z");t.process(function(t,e){if(!h.renderContext||h.renderContext.destroyed)return!1;for(var i=[],s=0;s<=5;s++)i[s]=e[s];for(var s=0,r=t.length;s<r;s++){var a=t[s],n=0,o=(a.values.color&&(n=a.values.color),this.getCoordinates(a)),o=new YAHOO.fcom.charts.BubbleMarker({x:o.x,y:o.y,max:x,data:a,toolText:this.config.getToolText(a)},i[n],h);o.render(h.renderContext),o.markerOver.subscribe(function(t){null!=this.activeMarker&&this.activeMarker!=t&&this.activeMarker.stopHover(),this.activeMarker=t,this.mouseoverMarker.fire(t)},this,!0),o.markerOut.subscribe(function(t){null!=this.activeMarker&&this.activeMarker!=t&&(this.activeMarker.stopHover(),this.activeMarker=null),this.mouseoutMarker.fire(t)},this,!0),o.mouseclick.subscribe(function(t){this.clickMarker.fire(t)},this,!0),this.markers.push(o)}},this,{arguments:s})},findMarker:function(t,e){for(var i=0,s=this.markers.length;i<s;i++){var r=this.markers[i];if(r.config.data[t]==e)return r}return null},addCurve:function(a,n){n=n||this.style.data;var t=new YAHOO.fcom.charts.Curve({},n.curve,this);return t.onRender.subscribe(function(t){var e=t.renderContext,i=a.iterator();if(i.hasNext()){var s=this.getCoordinates(i.next());for(e.beginPath();i.hasNext();){e.moveTo(s);var r=i.next(),r=this.getCoordinates(r);e.lineTo(r.x-s.x,r.y-s.y),s=r}e.endPath(t,t.style),this.addMarkers(a,n,t)}},this,!0),t.render(this.renderContext),t},addColumns:function(t,e){for(var i=0,s=t.iterator();s.hasNext();){var r=s.next(),a=r.y<0?r.y:0,n=r.y<0?0:r.y,n=this.getCoordinates({x:i++,y:n}),o=this.xaxis.intervalPx,n=new YAHOO.fcom.charts.ColumnMarker({x:n.x,y:n.y,y0:this.getCoordinates({x:0,y:a}).y,interval:.5*o,data:r,color:e},this.style.data,this);n.render(this.renderContext),this.markers.push(n)}},addHLine:function(t){var e=this.xaxis.getBBox(),t=this.getCoordinates({x:0,y:t}).y;this.renderContext.gridLine(this,[e.x,t,e.width,0],this.style["x-axis"])},renderElement:function(t,e){var i=new YAHOO.fcom.charts.GfxBoundingBox(this.config.x,this.config.y,this.config.width,this.config.height),i=t.applyMargin(i,e),s=(i=t.applyMargin(i,e["x-axis"]),i=t.applyMargin(i,e["y-axis"]),this.xaxis=this.createXAxis(i.x,i.y,i.width),this.yaxis=this.createYAxis(i.x,i.y,i.height),this.yaxis.render(t),this.xaxis.render(t),this.xaxis.getBBox()),r=this.yaxis.getBBox();this.xaxis.destroy(),this.yaxis.destroy(),i=new YAHOO.fcom.charts.GfxBoundingBox(r.width,i.y,i.width-r.width,i.height-s.height),i=t.applyMargin(i,e),this.xaxis=this.createXAxis(i.x,i.y+i.height,i.width),this.yaxis=this.createYAxis(i.x,i.y+i.height,i.height),this.yaxis.render(t),this.xaxis.render(t),this.renderBackground(t,i),new YAHOO.fcom.charts.Grid(this.xaxis.ticks,{orientation:0,bbox:i},this.style["x-axis"].grid,this).render(t),new YAHOO.fcom.charts.Grid(this.yaxis.ticks,{orientation:1,bbox:i},this.style["y-axis"].grid,this).render(t),this.xaxis.toFront(),this.yaxis.toFront()},createXAxis:function(t,e,i){t={orientation:0,x:t,y:e,length:i};return YAHOO.lang.augmentObject(t,this.config.xaxis),new YAHOO.fcom.charts.Axis(this.unitX,t,this.style["x-axis"])},createYAxis:function(t,e,i){t={orientation:1,x:t,y:e,length:i};return YAHOO.lang.augmentObject(t,this.config.yaxis),new YAHOO.fcom.charts.Axis(this.unitY,t,this.style["y-axis"])},renderBackground:function(t,e){var i={shape:{}};YAHOO.lang.augmentObject(i.shape,this.style.shape),YAHOO.lang.augmentObject(i.shape,this.style.gradient),t.fill(this,e.x,e.y,e.width,e.height,i)},toString:function(){return"Gfx::Plot"}},YAHOO.extend(YAHOO.fcom.charts.Plot,YAHOO.fcom.charts.GfxElement,YAHOO.fcom.charts.Plot.prototype);
//# sourceMappingURL=Plot.js.map;
window.ngpNamespace("YAHOO.fcom.charts"),YAHOO.fcom.charts.Axis=function(t,i,s,n){YAHOO.lang.augmentObject(i,{orientation:0,offset:0}),YAHOO.fcom.charts.Axis.superclass.constructor.call(this,i,s,n),this.unit=t,this.config.offset=this.config.offset||0,this.config.spacer=this.config.spacer||0,this.length=this.config.length-this.config.offset-this.config.spacer,this.intervalPx=this.length/t.getSteps(),i.label=i.label||{},i.label.x=this.config.x,i.label.y=this.config.y,i.label.align=YAHOO.fcom.charts.GfxContext.TEXT_ALIGN_CENTER,this.label=new YAHOO.fcom.charts.Label(i.label,s.label,this),this.ticks=[]},YAHOO.fcom.charts.Axis.prototype={OFFSET_FIRST_TICK:10,getScaleFactor:function(){return this.intervalPx/this.unit.getInterval()},renderElement:function(t,i){var s=this.config.orientation%2?this.config.x:this.config.x+this.config.offset,n=this.config.orientation%2?this.config.y+this.config.offset:this.config.y;if(1==this.config.orientation||3==this.config.orientation){t.gridLine(this,[this.config.x,this.config.y,0,-this.config.length],i);for(var e=n,o=this.unit.getFrom();this.checkRange(e-this.intervalPx);)e<n&&this.renderTick(s,e,o),e-=this.intervalPx,o=this.unit.nextTick(o);t.rotate(this.label,270)}else{t.gridLine(this,[this.config.x,this.config.y,this.config.length,0],i);for(e=s,o=this.unit.getFrom();this.checkRange(e+this.intervalPx);)e>s+this.OFFSET_FIRST_TICK&&this.renderTick(e,n,o),e+=this.intervalPx,o=this.unit.nextTick(o)}this.alignLabel()},renderTick:function(t,i,s){s=this.unit.format(s);if(null!=s)return(t=new YAHOO.fcom.charts.Tick(this.ticks[this.ticks.length-1],{orientation:this.config.orientation,x:t,y:i,label:{text:s}},this.style,this)).render(this.renderContext),this.ticks.push(t),t},alignLabel:function(){if(this.label.style.display){var t=YAHOO.fcom.charts.GfxContext,i=null,s=this.config.orientation%2?5:0,n=this.config.orientation%2?0:5;if("middle"==this.label.style.shape.align)i=t.ALIGN_CENTER;else switch(this.config.orientation){case 0:i=t.ALIGN_BOTTOM_RIGHT;break;case 1:case 2:i=t.ALIGN_TOP_RIGHT;break;case 3:i=t.ALIGN_TOP_LEFT}var e=[this];null!=this.ticks[0]&&(e=e.concat(this.ticks[0],this.ticks[0].label)),this.label.align(this.renderContext.getBBox(e),i,i);for(var o=this.ticks.length;o--;)null!=this.ticks[o].label&&this.renderContext.intersects(this.ticks[o].label.getBBox(),this.label.getBBox().addOffset(s,n))&&this.ticks[o].label.setVisible(!1)}},checkRange:function(t){return this.config.orientation%2?+t.toFixed(1)>=this.config.y-this.config.offset-this.length:+t.toFixed(1)<=this.config.x+this.config.offset+this.length},getAxisCoordinate:function(t){return+((this.config.orientation%2?this.config.y+this.config.offset:this.config.x+this.config.offset)+(this.config.orientation%2?-1:1)*(this.unit.transform(t)-this.unit.transform(this.unit.getFrom()))*this.getScaleFactor()).toFixed(1)},getAxisValue:function(t){return 0==this.config.orientation||2==this.config.orientation?+this.unit.transformBack((t-this.config.x)/this.getScaleFactor()+this.unit.transform(this.unit.getFrom())):+this.unit.transformBack(0-((t-this.config.y-this.length)/this.getScaleFactor()-this.unit.transform(this.unit.getFrom())))},toString:function(){return"Axis::GfxElement"}},YAHOO.extend(YAHOO.fcom.charts.Axis,YAHOO.fcom.charts.GfxElement,YAHOO.fcom.charts.Axis.prototype),YAHOO.fcom.charts.StaticAxis=function(t,i,s,n){YAHOO.fcom.charts.StaticAxis.superclass.constructor.call(this,t,i,s,n)},YAHOO.fcom.charts.StaticAxis.prototype={renderTick:function(){return null},renderElement:function(t,i){YAHOO.fcom.charts.StaticAxis.superclass.renderElement.call(this,t,i);for(var s=0,n=this.config.ticks.length;s<n;s++){var e,o=this.config.ticks[s],h=this.getAxisCoordinate(o.value);this.checkRange(h)&&(e=this.orientation%2?this.config.x:h,h=this.orientation%2?h:this.config.y,!!(this.orientation%2)||e>this.config.x+this.OFFSET_FIRST_TICK)&&((e=new YAHOO.fcom.charts.Tick(this.ticks[this.ticks.length-1],{x:e,y:h,label:{text:o.text}},this.style,this)).render(this.renderContext),this.ticks.push(e))}t=null;(t=this.ticks.pop())&&(i=t.getBBox(),0==this.config.orientation||2==this.config.orientation?this.checkRange(i.x+i.width)?this.ticks.push(t):t.setVisible(!1):this.checkRange(i.y-i.height)?this.ticks.push(t):t.setVisible(!1)),this.alignLabel()}},YAHOO.extend(YAHOO.fcom.charts.StaticAxis,YAHOO.fcom.charts.Axis,YAHOO.fcom.charts.StaticAxis.prototype),YAHOO.fcom.charts.ColumnAxis=function(t,i,s,n){YAHOO.fcom.charts.ColumnAxis.superclass.constructor.call(this,t,i,s,n),1&this.config.orientation||(this.intervalPx=this.length/(t.getSteps()+1),this.config.offset=this.config.offset+this.intervalPx,this.OFFSET_FIRST_TICK=-this.intervalPx)},YAHOO.extend(YAHOO.fcom.charts.ColumnAxis,YAHOO.fcom.charts.Axis,{checkRange:function(t){return 1&this.config.orientation?+t.toFixed(1)>=this.config.y-this.config.offset-this.length:+t.toFixed(1)<=this.config.x+this.length}});
//# sourceMappingURL=Axis.js.map;
window.ngpNamespace("YAHOO.fcom.charts"),YAHOO.fcom.charts.Label=function(t,i,e){t=t||{},YAHOO.lang.augmentObject(t,{x:0,y:0,align:YAHOO.fcom.charts.GfxContext.TEXT_ALIGN_LEFT,text:""}),YAHOO.fcom.charts.Label.superclass.constructor.call(this,t,i,e)},YAHOO.fcom.charts.Label.prototype={renderElement:function(t,i){var e;i.display&&(t.text(this,this.config.x,this.config.y,this.config.text,i,this.config.align),this.config.hasBackground&&(e=this.getBBox(),t.clear(this,e),e=t.applyPadding(e,i),t.rect(this,e.x,e.y,e.width,e.height,i),t.text(this,this.config.x,this.config.y,this.config.text,i,this.config.align),t.move(this,this.config.x,this.config.y)),this.alignLabel(this.config.x,this.config.y))},toString:function(){return"Label::GfxElement"},alignLabel:function(t,i){var e=this.getBBox(),s=e.width,c=e.height;switch("left"==this.style["float"]&&(t-=s),this.style.shape.align){case"top":i-=c;break;case"middle":i-=c/2}this.move(t,i)}},YAHOO.extend(YAHOO.fcom.charts.Label,YAHOO.fcom.charts.GfxElement,YAHOO.fcom.charts.Label.prototype);
//# sourceMappingURL=Label.js.map;
window.ngpNamespace("YAHOO.fcom.charts"),YAHOO.fcom.charts.Tick=function(t,i,s,n){var e=YAHOO.fcom.charts.GfxContext;i=i||{},YAHOO.lang.augmentObject(i,{x:0,y:0}),YAHOO.fcom.charts.Tick.superclass.constructor.call(this,i,s,n),this.config.label=this.config.label||{},this.config.label.align=e.TEXT_ALIGN_CENTER,1!=this.config.orientation&&3!=this.config.orientation||(this.config.label.align=this.config.orientation-1?e.TEXT_ALIGN_LEFT:e.TEXT_ALIGN_RIGHT),this.label=new YAHOO.fcom.charts.Label(this.config.label,this.style,this),this.last=t,null!=this.last&&(this.last.next=this),this.next=null},YAHOO.fcom.charts.Tick.prototype={renderElement:function(t){for(var i=this.style.unit.size||2,s={},n=(s.x=this.config.orientation%2?(this.config.orientation-1?1:-1)*(i+3+!!(this.config.orientation-1)):0,s.y=!this.config.orientation%2?(this.config.orientation?-1:1)*(i+9+!this.config.orientation):0,t.movePivot(this.label,this.config.x+(s.x||0),this.config.y+(s.y||0)),this.last);null!=n;){if(null!=n.label&&t.intersects(this.label,n.label))return this.label.destroy(),void delete this.label;n=n.last}switch(this.style.unit.type){case"square":t.square(this,this.config.x-i/2,this.config.y-i/2,i,this.style.unit);break;case"circle":t.circle(this,this.config.x,this.config.y,i,this.style.unit);break;case"none":break;default:var e=i/2*(this.config.orientation%2),o=i/2*!(this.config.orientation%2);t.beginPath(),t.moveTo(this.config.x-e,this.config.y-o),t.lineTo(2*e,2*o),t.endPath(this,this.style)}}},YAHOO.extend(YAHOO.fcom.charts.Tick,YAHOO.fcom.charts.GfxElement,YAHOO.fcom.charts.Tick.prototype);
//# sourceMappingURL=Tick.js.map;
window.ngpNamespace("YAHOO.fcom.charts"),YAHOO.fcom.charts.Unit=function(t,i){this.applyConfig(i)},YAHOO.fcom.charts.Unit.prototype={applyConfig:function(t){t=t||{},YAHOO.lang.augmentObject(t,{steps:10}),YAHOO.lang.augmentObject(this,t)},format:function(){},nextTick:function(){},prevTick:function(){},getFrom:function(){},getTo:function(){},getInterval:function(){},getSteps:function(){},transform:function(t){return t},transformBack:function(t){return t}},YAHOO.fcom.charts.UnitNumeric=function(t,i){YAHOO.fcom.charts.UnitNumeric.superclass.constructor.call(this,t,i);var i=null!=this.from?this.transform(Math.min.apply(this,t.concat(this.from))):this.transform(Math.min.apply(this,t)),t=null!=this.to?this.transform(this.to):this.transform(Math.max.apply(this,t)),n=(i==t&&(t=this.transform(this.transformBack(i)+1)),this.findInterval(i,t,this.steps)),e=n.base,n=n.exponent;this.interval=e*n,this.exponent=n,this.presc=n<1?Math.abs(Math.round(Math.log(n)/Math.log(10))):0,this.from=Math.floor(i/this.exponent-((i<0?e:0)+i/this.exponent%e))*this.exponent,this.to=Math.ceil(t/this.exponent+(e-t/this.exponent%e))*this.exponent,this.steps=Math.ceil((this.to-this.from)/this.interval)},YAHOO.fcom.charts.UnitNumeric.prototype={findInterval:function(t,i,n){var e=(i-t)/n,r=1,o=1;if(.75<=e)for(var s=0;s<20;s++){if(e<1.5){r=1;break}if(e<3.5){r=2;break}if(e<7.5){r=5;break}e/=10,o*=10}else for(s=0;s<20;s++){if(o/=10,3<=(e*=10)){r=5;break}if(1.5<=e){r=2;break}if(.75<=e){r=1;break}}return{base:r,exponent:o}},formatTransformed:function(t){return this.format(this.transformBack(t))},format:function(t){var i=this.postfix||"";return YAHOO.fcom.Format.formatNumber(t,{minFractionDigits:this.presc,maxFractionDigits:this.presc})+i},prevTick:function(t){return this.transformBack(this.transform(t)-this.interval)},nextTick:function(t){return+this.transformBack(this.transform(t)+this.interval).toFixed(this.presc)},getFrom:function(){return this.transformBack(this.from)},getTo:function(){return this.transformBack(this.to)},getInterval:function(){return this.interval},getSteps:function(){return this.steps}},YAHOO.extend(YAHOO.fcom.charts.UnitNumeric,YAHOO.fcom.charts.Unit,YAHOO.fcom.charts.UnitNumeric.prototype),YAHOO.fcom.charts.UnitDate=function(t,i){YAHOO.fcom.charts.UnitDate.superclass.constructor.call(this,t,i),this.TICKS=(n=new fcom.date.DateTime,[{time:6e4,factors:[1,2,3,4,5,6,10,12,15,20,30],postfix:YAHOO.fcom.Format.localized.postfixMinute,nextTick:function(t,i){t=n.setTimestamp(t).getCalendar();return n.setCalendar({minute:t.minute+i,second:0,millisecond:0}),n.getTimestamp()},prevTick:function(t,i){return this.nextTick(t,-(i-1))},format:function(t){return n.setTimestamp(t),n.format("mm")}},{time:36e5,factors:[1,2,3,4,6,8,12],postfix:YAHOO.fcom.Format.localized.postfixHour,nextTick:function(t,i){t=n.setTimestamp(t).getCalendar();return n.clearTime().setCalendar({hour:t.hour+i}),n.getTimestamp()},prevTick:function(t,i){return this.nextTick(t,-(i-1))},format:function(t){return n.setTimestamp(t),n.format("kk:mm")}},{time:864e5,factors:[1,2,3,5,6,10,15],postfix:YAHOO.fcom.Format.localized.postfixDay,nextTick:function(t,i){return n.setTimestamp(t).clearTime().addDays(i),n.getTimestamp()},prevTick:function(t,i){return this.nextTick(t,-(i-1))},format:function(t){return n.setTimestamp(t),YAHOO.fcom.Format.formatDateTime(n,{style:"dateLong"})}},{time:2629743830,factors:[1,2,3,4,6],postfix:YAHOO.fcom.Format.localized.postfixMonth,nextTick:function(t,i){return n.setTimestamp(t).clearTime(),n.setCalendar({day:1}).addMonths(i),n.getTimestamp()},prevTick:function(t,i){return this.nextTick(t,-(i-1))},format:function(t){return n.setTimestamp(t),n<3?n.format("MMMM"):n.format("MMM yyyy")}},{time:31556926e3,factors:[1,2,3,5,10,15,20,25,50,100],postfix:YAHOO.fcom.Format.localized.postfixYear,nextTick:function(t,i){t=n.setTimestamp(t).getCalendar();return n.clearTime().setCalendar({year:t.year+i,month:0,day:1}),n.getTimestamp()},prevTick:function(t,i){return this.nextTick(t,-(i-1))},format:function(t){return n.setTimestamp(t),n.format("yyyy")}}]);var n,i=null!=this.from?this.from:Math.min.apply(this,t),t=null!=this.to?this.to:Math.max.apply(this,t),e=(i==t&&((s=new Date).setTime(i),s.setDate(s.getDate()+1),t=s.getTime()),(t-i)/this.steps);this.tick=null,this.factor=null;for(var r=0;r<this.TICKS.length&&null==this.factor;r++){this.tick=this.TICKS[r];for(var o=0;o<this.tick.factors.length;o++)if(e<=this.tick.time*this.tick.factors[o]){this.factor=this.tick.factors[o];break}}this.from=this.tick.prevTick(i,1);var s=this.tick.nextTick(t,1);this.to=Math.ceil(s/(this.tick.time*this.factor))*this.tick.time*this.factor,this.interval=this.tick.time*this.factor,this.steps=Math.round((this.to-this.from)/this.interval),null!=this.relativeTo&&(this.relativeTo=this.tick.prevTick(this.relativeTo,1))},YAHOO.fcom.charts.UnitDate.prototype={format:function(t){return null!=this.relativeTo?Math.round((t-this.relativeTo)/this.tick.time)+" "+this.tick.postfix:this.tick.format(t)},nextTick:function(t){return this.tick.nextTick(t,this.factor)},prevTick:function(t){return this.tick.prevTick(t,this.factor)},getFrom:function(){return this.from},getTo:function(){return this.to},getInterval:function(){return this.interval},getSteps:function(){return this.steps}},YAHOO.extend(YAHOO.fcom.charts.UnitDate,YAHOO.fcom.charts.Unit,YAHOO.fcom.charts.UnitDate.prototype),YAHOO.fcom.charts.UnitLog=function(t,i){YAHOO.fcom.charts.UnitLog.superclass.constructor.call(this,t,i)},YAHOO.fcom.charts.UnitLog.prototype={applyConfig:function(t){YAHOO.lang.augmentObject(t,{base:10}),YAHOO.fcom.charts.UnitLog.superclass.applyConfig.call(this,t)},transform:function(t){return t<1?-1+t:Math.log(t)/Math.log(this.base)},transformBack:function(t){return t<0?1+t:Math.pow(this.base,t)}},YAHOO.extend(YAHOO.fcom.charts.UnitLog,YAHOO.fcom.charts.UnitNumeric,YAHOO.fcom.charts.UnitLog.prototype),YAHOO.fcom.charts.StaticUnit=function(t,i){this.values=t,this.applyConfig(i),this.pointer=0},YAHOO.extend(YAHOO.fcom.charts.StaticUnit,YAHOO.fcom.charts.Unit,{format:function(t){return this.values[t]},nextTick:function(t){return t+1},prevTick:function(t){return t-1},getFrom:function(){return 0},getTo:function(){return this.values.length-1},getInterval:function(){return 1},getSteps:function(){return this.values.length}});
//# sourceMappingURL=Unit.js.map;
window.ngpNamespace("YAHOO.fcom.charts"),YAHOO.fcom.charts.Grid=function(i,t,h,s){YAHOO.fcom.charts.Grid.superclass.constructor.call(this,t,h,s),this.ticks=i,this.x=this.config.bbox.x,this.y=this.config.bbox.y+this.config.bbox.height,this.width=this.config.bbox.width,this.height=this.config.bbox.height},YAHOO.fcom.charts.Grid.prototype={renderElement:function(i){if(this.style.display){for(var t,h,s,e,n=null,o=0;o<this.ticks.length;o++)(n=this.ticks[o]).rendered&&(t=this.x,h=this.y,s=n.config.x,e=n.config.y,null!=n.last&&(t=n.last.config.x,h=n.last.config.y),this.renderGridElement(i,{x:t,y:h},{x:s,y:e},o));null!=n&&(this.config.orientation%2?this.renderGridElement(i,{x:n.config.x,y:n.config.y},{x:this.x,y:this.y-this.height},o):this.renderGridElement(i,{x:n.config.x,y:n.config.y},{x:this.x+this.width,y:this.y},o))}},renderGridElement:function(i,t,h,s){var e=h.x,h=h.y,n=t.x,t=t.y,o=this.config.orientation%2*this.width,c=!this.config.orientation%2*this.height,r={shape:{}};YAHOO.lang.augmentObject(r.shape,this.style.shape),YAHOO.lang.augmentObject(r.shape,s%2?this.style.color.A:this.style.color.B,!0),this.config.orientation%2?i.fill(this,e,h,this.width,t-h,r):i.fill(this,n,t-this.height,e-n,this.height,r),i.gridLine(this,[e,h,o,-c],this.style)}},YAHOO.extend(YAHOO.fcom.charts.Grid,YAHOO.fcom.charts.GfxElement,YAHOO.fcom.charts.Grid.prototype);
//# sourceMappingURL=Grid.js.map;
window.ngpNamespace("YAHOO.fcom.charts"),YAHOO.fcom.charts.Marker=function(t,i,s){YAHOO.fcom.charts.Marker.superclass.constructor.call(this,t,i,s),this.markerOver=new YAHOO.util.CustomEvent("marker-over",this,!1,YAHOO.util.CustomEvent.FLAT),this.markerOut=new YAHOO.util.CustomEvent("marker-out",this,!1,YAHOO.util.CustomEvent.FLAT)},YAHOO.fcom.charts.Marker.prototype={toString:function(){return"Gfx::Marker"}},YAHOO.extend(YAHOO.fcom.charts.Marker,YAHOO.fcom.charts.GfxElement,YAHOO.fcom.charts.Marker.prototype),YAHOO.fcom.charts.BubbleMarker=function(t,i,s){YAHOO.fcom.charts.BubbleMarker.superclass.constructor.call(this,t,i,s);t=i.radius.max/(this.config.max||1);this.radius=Math.max(i.radius.min,Math.min(i.radius.max,(this.config.data.z||1)*t)),this.bubble=new YAHOO.fcom.charts.GfxElement({},i,this),this.bubble.onRender.subscribe(this.renderBubble,this,!0),this.tooltip=null,this.mouseover.subscribe(this.onMouseover,this,!0),this.mouseout.subscribe(this.onMouseout,this,!0),this.anim=null,this.ANIM_RADIUS=4,this.over=!1},YAHOO.fcom.charts.BubbleMarker.prototype={renderBubble:function(t){var i=t.renderContext,s=t.style;i.circle(t,this.config.x,this.config.y,this.radius,s)},renderElement:function(t){t.circle(this,this.config.x,this.config.y,this.radius+this.ANIM_RADIUS),this.lock()},hover:function(t,i,s,o){this.anim&&(this.anim.onComplete.unsubscribe(),this.anim.stop()),!0===t?(this.anim=this.renderContext.createAnim(this.bubble,{r:{from:this.radius,to:this.radius+this.ANIM_RADIUS}},.15),o&&this.anim.onComplete.subscribe(function(){this.markerOver.fire(this)},this,!0)):(this.anim=this.renderContext.createAnim(this.bubble,{r:{from:this.radius+this.ANIM_RADIUS,to:this.radius}},.15),o&&this.anim.onComplete.subscribe(function(){this.markerOut.fire(this)},this,!0)),i&&this.anim.onComplete.subscribe(i,s,!0),this.anim.animate()},onMouseover:function(t){t!=this||this.over||(this.hover(!0,this.showTooltip,this,!0),this.over=!0)},onMouseout:function(t){t==this&&this.over&&(this.hideTooltip(),this.hover(!1,null,null,!0),this.over=!1)},showTooltip:function(){var t,i,s;null==this.tooltip?(t=this.renderContext,s={text:this.config.toolText,hasBackground:!0,x:this.config.x,y:this.config.y},this.tooltip=new YAHOO.fcom.charts.Label(s,this.style.label,this),this.tooltip.render(t),i=(s=this.tooltip.getBBox()).x+s.width>t.width?this.config.x-(s.x-this.config.x)-s.width:s.x,s=s.y+s.height>t.height?this.config.y-(s.y-this.config.y)-s.height:s.y,t.move(this.tooltip,i,s),this.tooltip.constrainToContext(),this.tooltip.mouseout.subscribe(this.stopHover,this,!0),this.tooltip.lock()):(this.tooltip.setVisible(!0),this.tooltip.toFront())},hideTooltip:function(){this.tooltip&&this.tooltip.setVisible(!1)},stopHover:function(){this.anim&&this.anim.stop(),this.renderContext.setStyle(this,{r:this.radius}),this.hideTooltip(),this.over=!1},toString:function(){return"Gfx::BubbleMarker"}},YAHOO.extend(YAHOO.fcom.charts.BubbleMarker,YAHOO.fcom.charts.Marker,YAHOO.fcom.charts.BubbleMarker.prototype),YAHOO.fcom.charts.ColumnMarker=function(t,i,s){YAHOO.fcom.charts.ColumnMarker.superclass.constructor.call(this,t,i,s)},YAHOO.extend(YAHOO.fcom.charts.ColumnMarker,YAHOO.fcom.charts.Marker,{renderElement:function(t,i){var s=this.config.x-.5*this.config.interval,o=this.config.y,e=this.config.interval,r=this.config.y0-this.config.y,h={fill:this.config.color||i.shape.fill};YAHOO.lang.augmentObject(h,i.shape),t.gridRect(this,s,o,e,r,{shape:h})},toString:function(){return"Gfx::ColumnMarker"}});
//# sourceMappingURL=Marker.js.map;
window.ngpNamespace("YAHOO.fcom.charts"),YAHOO.fcom.charts.Curve=function(t,e,o){YAHOO.fcom.charts.Curve.superclass.constructor.call(this,t,e,o),this.mouseoverEvent=new YAHOO.util.CustomEvent("mouseover",this,!1,YAHOO.util.CustomEvent.FLAT),this.mouseoutEvent=new YAHOO.util.CustomEvent("mouseout",this,!1,YAHOO.util.CustomEvent.FLAT),this.clickEvent=new YAHOO.util.CustomEvent("click",this,!1,YAHOO.util.CustomEvent.FLAT)},YAHOO.fcom.charts.Curve.prototype={toString:function(){return"Gfx::Curve"}},YAHOO.extend(YAHOO.fcom.charts.Curve,YAHOO.fcom.charts.GfxElement,YAHOO.fcom.charts.Curve.prototype);
//# sourceMappingURL=Curve.js.map;
YAHOO.fcom.charts.RaphaelAnim=function(e,t,n,r){this.elements=[],this.elements=this.elements.concat(e),this.gfxEl=e;e=document.createElement("div");YAHOO.fcom.charts.RaphaelAnim.superclass.constructor.call(this,e,t,n,r)},YAHOO.extend(YAHOO.fcom.charts.RaphaelAnim,YAHOO.util.Anim,{getAttribute:function(e){for(var t=this.elements.length;t--;){var n=this.elements[t];return n.renderContext.getStyle(n,e)||0}return 0},setAttribute:function(e,t){var n={};n[e]=t;for(var r=this.elements.length;r--;){var s=this.elements[r];s.renderContext&&s.renderContext.setStyle(s,n)}}});
//# sourceMappingURL=Anim.js.map;
(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GroupedDataset = exports.Dataset = void 0;
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var YAHOO = window.YAHOO;

/*
 * @class Dataset
 * A dataset is a collection of DataItems, which supports iterators and chunks.
 * @namespace YAHOO.fcom.chart
 * @constructor
 * @param items {YAHOO.fcom.charts.DataItem[] | YAHOO.fcom.charts.DataItem} arbitary number of single DataItems or arrays of DataItems
 */
var Dataset = exports.Dataset = function Dataset() {
  var _ref,
    _this = this;
  /*
   * @type YAHOO.fcom.charts.DataItem[]
   * @private
   */
  this.items = (_ref = []).concat.apply(_ref, arguments);

  /*
   * key: property of a DataItem
   * value: a list of all values for that property in the complete dataset
   * @type {Object|Map}
   */
  this.values = Object.keys(this.items[0]) // use first item to determine keys
  .reduce(function (all, key) {
    all[key] = _this.items.map(function (item) {
      return item[key];
    });
    return all;
  }, {});
};
Dataset.prototype = {
  /*
   * Returns an array of values for the property "key".
   * @param key {String}
   * @return {Array}
   */
  getValues: function getValues(key) {
    return this.values[key];
  },
  /*
   * Returns the maximum for the DataItem property "key".
   * @param key {String} property name
   * @return {Number} returns 0 if property was not found
   */
  getMax: function getMax(key) {
    if (this.values[key] != null) {
      return Math.max.apply(Math, _toConsumableArray(this.values[key]));
    }
    return 0;
  },
  /*
   * Calls a processing function on chunks of data.
   * The processing should be indepenent on execution order
   *
   * @param processFn {Function} the processing function will receive the current chunk of data as first argument.
   * @param scope {Object}
   * @param config {Object}
   * <ul>
   *     <li>size {Number} chunk size to process (default: 10)
   *     <li>interval {Number} processing interval in ms (default: 10)
   *     <li>arguments {Array} an array of custom parameters passed to the processing function as second argument
   * </ul>
   */
  process: function process(processFn, scope, config) {
    config = config || {};
    YAHOO.lang.augmentObject(config, {
      size: 10,
      interval: 10,
      arguments: []
    });
    var iterator = this.iterator();
    window.setTimeout(function timeoutFunction() {
      var chunk = iterator.nextChunk(config.size);
      if (processFn.call(scope, chunk, config.arguments) !== false && iterator.hasNext()) {
        window.setTimeout(timeoutFunction, config.interval);
      }
    }, config.interval);
  },
  /*
   * Returns an iterator for the data structure. The iterator can return
   * single elements by the function next, or chunks of items (with a
   * specified size) by the function nextChunk.
   *
   * @return the iterator
   */
  iterator: function iterator() {
    var data = this.items;
    var currentIndex = 0;
    return {
      /*
       * returns the next data item or null
       * @return {YAHOO.fcom.charts.DataItem}
       */
      next: function next() {
        return currentIndex < data.length ? data[currentIndex++] : null;
      },
      /*
       * return the next chunk of num data items or less.
       * returns null when end of data was reached
       * @return {DataItem[]}
       */
      nextChunk: function nextChunk(num) {
        num = +num;
        if (currentIndex >= data.length) {
          return null;
        }
        var newIndex = currentIndex + num;
        if (newIndex > data.length) {
          newIndex = data.length;
        }
        var chunk = [];
        for (; currentIndex < newIndex; currentIndex++) {
          chunk.push(data[currentIndex]);
        }
        return chunk;
      },
      /*
       * more data items available?
       * @return {Boolean}
       */
      hasNext: function hasNext() {
        return currentIndex < data.length;
      }
    };
  }
};
/*
 * A grouped dataset is a dataset that can access sub-sets by a group index.
 * This is used by charts that display multiple curves.
 * @class GroupedDataset
 */
var GroupedDataset = exports.GroupedDataset = function GroupedDataset() {
  var _ref2, _GroupedDataset$super;
  var sets = (_ref2 = []).concat.apply(_ref2, arguments);
  (_GroupedDataset$super = GroupedDataset.superclass.constructor).call.apply(_GroupedDataset$super, [this].concat(_toConsumableArray(sets)));
  /*
   * stores all groups
   * @type YAHOO.fcom.charts.Dataset[]
   */
  this.groups = sets.map(function (set) {
    return new Dataset(set);
  });
};
GroupedDataset.prototype = {
  /*
   * Returns the dataset for a single group
   * @param index {Number}
   * @return {YAHOO.fcom.charts.Dataset}
   */
  getGroup: function getGroup(index) {
    return this.groups[index];
  }
};
YAHOO.extend(GroupedDataset, Dataset, GroupedDataset.prototype);
window.YAHOO.fcom.charts.Dataset = Dataset;

},{}]},{},[1]);
;
YAHOO.fcom.charts.BeanData=function(t,a){YAHOO.fcom.charts.BeanData.superclass.constructor.call(this,t),this.defaultPropertyName=a},YAHOO.lang.extend(YAHOO.fcom.charts.BeanData,YAHOO.fcom.charts.Dataset,{getValue:function(t,a){a=a||this.defaultPropertyName;a=this.getValues(a);return a.length>t?a[t]:null}});
//# sourceMappingURL=BeanData.js.map;
YAHOO.fcom.charts.StyledChart=function(t,e,i,l,s){var n=YAHOO.util.Dom;this.element=n.get(t),this.data=i,n.addClass(this.element,"chart"),null!=e&&n.addClass(this.element,e),this.styleElement=document.createElement("div"),n.setStyle(this.styleElement,"visibility","hidden"),n.setStyle(this.styleElement,"z-index","0"),n.setStyle(this.styleElement,"position","relative"),this.styleElement=this.createStyleElement(this.styleElement),this.element.appendChild(this.styleElement),this.styleMap={},this.resizeEl=n.get(l),this.context=null,!1!==s&&YAHOO.fcom.Page.onResize(this.resize,this,!0),this.mouseOverEvent=new YAHOO.util.CustomEvent("mouseover",this,!1,YAHOO.util.CustomEvent.LIST),this.mouseOutEvent=new YAHOO.util.CustomEvent("mouseout",this,!1,YAHOO.util.CustomEvent.LIST),this.mouseClickEvent=new YAHOO.util.CustomEvent("mouseclick",this,!1,YAHOO.util.CustomEvent.LIST),this.failureEvent=new YAHOO.util.CustomEvent("failure",this,!1,YAHOO.util.CustomEvent.LIST),this.successEvent=new YAHOO.util.CustomEvent("success",this,!1,YAHOO.util.CustomEvent.LIST)},YAHOO.fcom.charts.StyledChart.prototype={createStyleElement:function(){},createElementAndAddClass:function(t){var e=document.createElement("div");return YAHOO.util.Dom.addClass(e,t),e},destroy:function(){YAHOO.widget.Overlay.windowResizeEvent.unsubscribe(this.resize,this),this.styleElement&&this.element.removeChild(this.styleElement),this.context&&this.context.destroy()},render:function(){this.isVisible()&&(this.context&&this.context.destroy(),YAHOO.util.Dom.setStyle(this.styleElement,"display",""),this.createStyleMap(this.styleMap,this.styleElement),YAHOO.util.Dom.setStyle(this.styleElement,"display","none"),this.context=YAHOO.fcom.charts.ContextProvider.createContext(this.element,this.styleMap.canvas.width,this.styleMap.canvas.height),this.renderBackground(),(this.data.items&&0!=this.data.items.length?(this.renderChart(),this.successEvent):(this.renderEmpty(),this.failureEvent)).fire())},renderBackground:function(){var t=new YAHOO.fcom.charts.GfxElement({},this.styleMap.canvas);t.onRender.subscribe(function(t){var e=t.renderContext,i=t.style;e.rect(t,0,0,i.width,i.height,i)},this,!0),t.render(this.context)},createStyleMap:function(t,e){var i,l=this.keyForEntry(e);switch(l){case"radius":i=this.styleForRadius(e);break;case"gradient":i=this.styleForGradient(e);break;case"color":i=this.styleForAlternatingColors(e);break;case"unit":i=this.styleForUnit(e);break;case"multipleColors":i=this.multipleColors(e);break;default:(i=this.styleForBox(e)).shape=this.styleForShape(e),i.text=this.styleForText(e);for(var s=0;s<e.childNodes.length;s++){var n=e.childNodes[s];"div"==n.tagName.toLowerCase()&&this.createStyleMap(i,n)}}t[l]=i},keyForEntry:function(t){t=null!=t.id&&""!=t.id?t.id:t.className;if(null!=t)return t;throw new Error("An element without id or class cannot be added to the style map.")},isDisplayed:function(t){return"none"!==YAHOO.util.Dom.getStyle(t,"display")},styleForText:function(t){var e={};if(this.isDisplayed(t))switch(e["font-family"]=YAHOO.util.Dom.getStyle(t,"font-family"),e["font-size"]=YAHOO.util.Dom.getStyle(t,"font-size"),e["font-weight"]=YAHOO.util.Dom.getStyle(t,"font-weight"),e.fill=YAHOO.util.Dom.getStyle(t,"color"),e["fill-opacity"]=YAHOO.util.Dom.getStyle(t,"opacity"),YAHOO.util.Dom.getStyle(t,"text-align")){case"left":e["text-anchor"]="start";break;case"right":e["text-anchor"]="end"}return e},styleForGradient:function(t){var e,i={};return this.isDisplayed(t)&&"none"!=YAHOO.util.Dom.getStyle(t,"display")&&(e=YAHOO.util.Dom.getStyle(t,"color"),t=YAHOO.util.Dom.getStyle(t,"background-color"),e)&&t&&(i.gradient="90-"+e+"-"+t),i},styleForShape:function(t){var e={};if(this.isDisplayed(t)){if(0<(i=this.pixelStyleToValue(YAHOO.util.Dom.getStyle(t,"border-left-width"))))switch(e.stroke=YAHOO.util.Dom.getStyle(t,"border-left-color"),e["stroke-width"]=i,e["stroke-opacity"]=YAHOO.util.Dom.getStyle(t,"opacity"),YAHOO.util.Dom.getStyle(t,"border-left-style")){case"dashed":e["stroke-dasharray"]="- ";break;case"dotted":e["stroke-dasharray"]=". "}else e.stroke="none";var i=YAHOO.util.Dom.getStyle(t,"background-color");this.isTransparent(i)||(e.fill=i,e["fill-opacity"]=YAHOO.util.Dom.getStyle(t,"opacity")),e.align=YAHOO.util.Dom.getStyle(t,"vertical-align")}return e},styleForBox:function(t){var e={},i=YAHOO.util.Dom.getRegion(t);return e.x=i.left,e.y=i.top,e.width=i.right-i.left,e.height=i.bottom-i.top,e.paddingTop=this.pixelStyleToValue(YAHOO.util.Dom.getStyle(t,"padding-top")),e.paddingRight=this.pixelStyleToValue(YAHOO.util.Dom.getStyle(t,"padding-right")),e.paddingLeft=this.pixelStyleToValue(YAHOO.util.Dom.getStyle(t,"padding-left")),e.paddingBottom=this.pixelStyleToValue(YAHOO.util.Dom.getStyle(t,"padding-bottom")),e.marginTop=this.pixelStyleToValue(YAHOO.util.Dom.getStyle(t,"margin-top")),e.marginRight=this.pixelStyleToValue(YAHOO.util.Dom.getStyle(t,"margin-right")),e.marginLeft=this.pixelStyleToValue(YAHOO.util.Dom.getStyle(t,"margin-left")),e.marginBottom=this.pixelStyleToValue(YAHOO.util.Dom.getStyle(t,"margin-bottom")),e["float"]=YAHOO.util.Dom.getStyle(t,"float"),e.display="none"!=YAHOO.util.Dom.getStyle(t,"display"),e},styleForAlternatingColors:function(t){var e={A:{}},i=YAHOO.util.Dom.getStyle(t,"color");return this.isTransparent(i)||(e.A.fill=i,e.A["fill-opacity"]=YAHOO.util.Dom.getStyle(t,"opacity")),e.B={},i=YAHOO.util.Dom.getStyle(t,"background-color"),this.isTransparent(i)||(e.B.fill=i,e.B["fill-opacity"]=YAHOO.util.Dom.getStyle(t,"opacity")),e},multipleColors:function(t){var i=/.*color\d+.*/,l={},s=[],n=this;return YAHOO.util.Dom.getChildrenBy(t,function(t){var e;i.test(t.className)?(e=YAHOO.util.Dom.getStyle(t,"background-color"),n.isTransparent(e)||s.push(YAHOO.util.Dom.getStyle(t,"background-color"))):YAHOO.util.Dom.hasClass(t,"colorOther")?l.other=YAHOO.util.Dom.getStyle(t,"background-color"):YAHOO.util.Dom.hasClass(t,"colorLast")&&(l.last=YAHOO.util.Dom.getStyle(t,"background-color"))}),l.rotation=s,l},styleForRadius:function(t){var e,i,l={},s=YAHOO.util.Dom,t=s.hasClass(t,"radius")?[t]:s.getElementsByClassName("radius","div",t);return 0<t.length&&(t=t[0],i=s.getRegion(t),l.radius=i.right-i.left,0<(e=s.getElementsByClassName("min","div",t)).length&&(e=e[0],i=s.getRegion(e),l.min=i.right-i.left||l.radius),0<(e=s.getElementsByClassName("max","div",t)).length)&&(e=e[0],i=s.getRegion(e),l.max=i.right-i.left||l.radius),l},styleForUnit:function(t){var e={};return e.size=this.pixelStyleToValue(YAHOO.util.Dom.getStyle(t,"width")),e.shape=this.styleForShape(t),e.type=YAHOO.util.Dom.getStyle(t,"list-style-type"),e},pixelStyleToValue:function(t){t=t.substring(0,t.length-2),t=0<t.indexOf(".")?Math.round(parseFloat(t)):parseInt(t);return isNaN(t)?0:t},isVisible:function(){return $(this.element).is(":visible")},isTransparent:function(t){return"transparent"==t||"none"==t||"rgba(0, 0, 0, 0)"==t},getWidth:function(){return this.styleMap.canvas.width-this.styleMap.canvas.chartElement.paddingRight-this.styleMap.canvas.chartElement.paddingLeft},getHeight:function(){return this.styleMap.canvas.height-this.styleMap.canvas.chartElement.paddingBottom-this.styleMap.canvas.chartElement.paddingTop},getX:function(){return this.styleMap.canvas.chartElement.paddingLeft},getY:function(){return this.styleMap.canvas.chartElement.paddingTop},onMouseOverDataItem:function(t){this.mouseOverEvent.fire(t)},onMouseOutDataItem:function(t){this.mouseOutEvent.fire(t)},onMouseClickDataItem:function(t){this.mouseClickEvent.fire(t)},resize:function(){this.isVisible()&&YAHOO.lang.later(2,this,function(){var t;this.styleMap.canvas||this.createStyleMap(this.styleMap,this.styleElement),this.resizeEl?t=YAHOO.util.Dom.getRegion(this.resizeEl):(YAHOO.util.Dom.setStyle(this.styleElement,"display",""),t=YAHOO.util.Dom.getRegion(this.styleElement),YAHOO.util.Dom.setStyle(this.styleElement,"display","none")),t.right-t.left==this.styleMap.canvas.width&&t.bottom-t.top==this.styleMap.canvas.height||(this.styleMap.canvas.width=t.right-t.left,this.styleMap.canvas.height=t.bottom-t.top,this.render())})}};
//# sourceMappingURL=StyledChart.js.map;
YAHOO.fcom.charts.ScatterChart=function(t,e,i){this.config=i||{},YAHOO.lang.augmentObject(this.config,{xaxis:{label:{text:"x-Achse"}},yaxis:{label:{text:"y-Achse"}},getToolText:function(t){return this.xAxis.label+": "+t.x+"\n"+this.yAxis.label+": "+t.y}}),YAHOO.fcom.charts.ScatterChart.superclass.constructor.call(this,t,i.cssCls,e,i.resizeEl,i.resizing),this.mouseOverEvent.subscribe(function(){YAHOO.util.Dom.setStyle(this.element,"cursor","pointer")},this,!0),this.mouseOutEvent.subscribe(function(){YAHOO.util.Dom.setStyle(this.element,"cursor","default")},this,!0),this.mouseClickEvent.subscribe(function(t,e){e=e[0];null!=e&&null!=e.key&&(i.channelName?YAHOO.fcom.Broadcaster.sendMessage(i.channelName,{ric:e.key}):window.detail("ric="+encodeURIComponent(e.key)))})},YAHOO.extend(YAHOO.fcom.charts.ScatterChart,YAHOO.fcom.charts.StyledChart,{renderChart:function(){this.unitX=new YAHOO.fcom.charts.UnitNumeric(this.data.getValues("x"),{postfix:this.config.xaxis.postfix}),this.unitY=new YAHOO.fcom.charts.UnitNumeric(this.data.getValues("y"),{postfix:this.config.yaxis.postfix}),YAHOO.lang.augmentObject(this.config,{x:this.getX(),y:this.getY(),width:this.getWidth(),height:this.getHeight()},!0),this.plot=new YAHOO.fcom.charts.Plot(this.unitX,this.unitY,this.config,this.styleMap.canvas.chartElement),this.plot.render(this.context),this.plot.addMarkers(this.data),this.plot.mouseoverMarker.subscribe(function(t){this.mouseOverEvent.fire(t.config.data)},this,!0),this.plot.mouseoutMarker.subscribe(function(t){this.mouseOutEvent.fire(t.config.data)},this,!0),this.plot.clickMarker.subscribe(function(t){this.mouseClickEvent.fire(t.config.data)},this,!0)},renderEmpty:function(){var t=YAHOO.fcom.charts.GfxContext,e=new YAHOO.fcom.charts.Label({x:0,y:0,text:this.config.emptyChartMsg,align:t.TEXT_ALIGN_CENTER},this.styleMap.canvas.emptyMsg);e.render(this.context),e.align(new YAHOO.fcom.charts.GfxBoundingBox(this.getX(),this.getY(),this.getWidth(),this.getHeight()),t.ALIGN_CENTER,t.ALIGN_CENTER)},setData:function(t){this.data=t,this.render()},createStyleElement:function(t){YAHOO.util.Dom.addClass(t,"canvas"),t.appendChild(this.createElementAndAddClass("gradient")),t.appendChild(this.createElementAndAddClass("emptyMsg"));var e=this.createElementAndAddClass("chartElement"),i=(e.appendChild(this.createElementAndAddClass("gradient")),e.appendChild(this.createAxisEl("x-axis")),e.appendChild(this.createAxisEl("y-axis")),this.createElementAndAddClass("data"));i.appendChild(this.createRadiusEl()),(n=this.createElementAndAddClass("label")).appendChild(this.createRadiusEl()),i.appendChild(n);for(var s=0;s<4;s++)i.appendChild(this.createElementAndAddClass("group"+s));e.appendChild(i);for(var a=1;a<=5;a++){var n,d=this.createElementAndAddClass("data");YAHOO.util.Dom.addClass(d,"color"+a),d.appendChild(this.createRadiusEl()),(n=this.createElementAndAddClass("label")).appendChild(this.createRadiusEl()),d.appendChild(n);for(s=0;s<4;s++)d.appendChild(this.createElementAndAddClass("group"+s));e.appendChild(d)}return t.appendChild(e),t},createAxisEl:function(t){var e=this.createElementAndAddClass("axis"),t=(e.id=t,e.appendChild(this.createElementAndAddClass("unit")),this.createElementAndAddClass("grid"));return t.appendChild(this.createElementAndAddClass("color")),t.appendChild(this.createElementAndAddClass("border")),e.appendChild(t),e.appendChild(this.createElementAndAddClass("label")),e},createRadiusEl:function(){var t=this.createElementAndAddClass("radius");return t.appendChild(this.createElementAndAddClass("min")),t.appendChild(this.createElementAndAddClass("max")),t},hover:function(t){t=this.plot.findMarker("key",t);null!=t&&!0===t.visible&&t.hover(!0,function(){this.hover(!1)},t)},showTooltip:function(t,e){t=this.plot.findMarker("key",t);null!=t&&!0===t.visible&&(!1===e?t.hideTooltip():(t.toFront(),t.showTooltip()))}});
//# sourceMappingURL=ScatterChart.js.map;
YAHOO.fcom.charts.YieldGraph=function(t,i,s){YAHOO.fcom.charts.YieldGraph.superclass.constructor.call(this,t,i,s)},YAHOO.lang.extend(YAHOO.fcom.charts.YieldGraph,YAHOO.fcom.charts.ScatterChart,{renderChart:function(){this.unitX=new YAHOO.fcom.charts.UnitDate(this.data.getValues("x"),{relativeTo:(new Date).getTime()}),this.unitY=new YAHOO.fcom.charts.UnitNumeric(this.data.getValues("y"),{postfix:this.config.yaxis.postfix}),YAHOO.lang.augmentObject(this.config,{x:this.getX(),y:this.getY(),width:this.getWidth(),height:this.getHeight()},!0),this.plot=new YAHOO.fcom.charts.Plot(this.unitX,this.unitY,this.config,this.styleMap.canvas.chartElement),this.plot.render(this.context),this.plot.addMarkers(this.data),this.plot.mouseoverMarker.subscribe(function(t){this.mouseOverEvent.fire(t.config.data)},this,!0),this.plot.mouseoutMarker.subscribe(function(t){this.mouseOutEvent.fire(t.config.data)},this,!0),this.plot.clickMarker.subscribe(function(t){this.mouseClickEvent.fire(t.config.data)},this,!0)}});
//# sourceMappingURL=YieldGraph.js.map;
window.ngpNamespace("YAHOO.fcom.highstock"),YAHOO.fcom.highstock.PieChart=function YAHOO_fcom_highstock_PieChart(t,e,i,s){this._init(t,e,i,s)},YAHOO.fcom.highstock.PieChart.prototype=new function YAHOO_fcom_highstock_PieChart(){this._init=function(t,e,i,s){this._config=s(t,e),this._table=void 0!==i?i:null;var o=null;null!==this._table&&(this._config.plotOptions.pie.point.events.mouseOver=YAHOO.fcom.Util.createDelegate(function(t){o=t.target.id,this._table.obj.hover(this._table.keyName3,t.target.id,!0)},this),this._config.plotOptions.pie.point.events.mouseOut=YAHOO.fcom.Util.createDelegate(function(t){o=null,this._table.obj.hover(this._table.keyName3,t.target.id,!1)},this),this._config.plotOptions.pie.point.events.click=YAHOO.fcom.Util.createDelegate(function(t){var e=this._table.obj.findRows(this._table.keyName3,o);return 0<e.length&&this._table.obj.markActive(e[0]),!1},this)),this._chart=new Highcharts.Chart(this._config),null!==this._table&&(this._table.obj.mouseoverRowEvent.subscribe(YAHOO.fcom.Util.createDelegate(function(t,e){e=this._chart.get(e[0][this._table.keyName3]);null!==e&&e.setState("hover")},this)),this._table.obj.mouseoutRowEvent.subscribe(YAHOO.fcom.Util.createDelegate(function(t,e){e=this._chart.get(e[0][this._table.keyName3]);null!==e&&e.setState("")},this)),this._table.obj.activeRowChanged.subscribe(YAHOO.fcom.Util.createDelegate(function(t,e){if(null!==e[0]){e=this._chart.get(e[1][this._table.keyName3]);null!==e&&e.select&&!e.selected&&e.select(!0)}else for(var i=this._chart.getSelectedPoints(),s=0;s<i.length;s++)i[s].select(!1)},this)))}};
//# sourceMappingURL=PieChart.js.map;
window.ngpNamespace("fcom.highstock",function(){function e(e,i){if("percent"==this.options.compare){if(0==this.compareValue&&i)for(var s=0;s<i.series.data.length;s++)if(i.series.data[s]&&0!==i.series.data[s].y){this.compareValue=i.series.data[s].y,this.compareIndex=s;break}e=0!==this.compareValue?(e-this.compareValue)/Math.abs(this.compareValue)*100:0}return i&&(i.change=e),e}var i=Highcharts.extendClass(Highcharts.seriesTypes.line,{type:"line",init:function(){Highcharts.seriesTypes.line.prototype.init.apply(this,arguments),this.options.compare&&(this.modifyValue=e)}}),s=(Highcharts.seriesTypes.ngpLine=i,Highcharts.extendClass(Highcharts.seriesTypes.area,{type:"area",init:function(){Highcharts.seriesTypes.area.prototype.init.apply(this,arguments),this.options.compare&&(this.modifyValue=e)}}));return{LineSeries:i,AreaSeries:Highcharts.seriesTypes.ngpArea=s}});
//# sourceMappingURL=Series.js.map;
window.ngpNamespace("fcom.highstock"),fcom.highstock.LineChart=function(e,t,i){this.chartContainer=e+"_chartContainer",this.messageContainer=e+"_messageContainer",this.cfg=t,this.chart=null,this.interval={},this.extremesChanged=new YAHOO.util.CustomEvent("extremesChanged",this),this.chartRendered=new YAHOO.util.CustomEvent("chartRendered",this,!1,YAHOO.util.CustomEvent.LIST,!0),this.dataSet=new YAHOO.util.CustomEvent("dataSet",this,!1),this.datasource=i,this.referencedSeries={},this.series=[],this.seriesMap={}},fcom.highstock.LineChart.prototype={refresh:function(e){this.datasource.request(e,YAHOO.fcom.Util.createDelegate(this.setData,this),{paramList:e})},createChart:function(){this.cfg.chart.renderTo=this.chartContainer,this.cfg.tooltip.formatter=this.formatTooltip,this.cfg.xAxis.events={setExtremes:YAHOO.fcom.Util.createDelegate(this.setExtremesListener,this)};var e=this.findNavigatorSeries();this.cfg.series=[Object.assign({},e)],this.cfg.navigator.series.data=e.data,this.cfg.navigator.series.color=e.color,this.cfg.navigator.series.lineColor=e.color,this.chart=new Highcharts.StockChart(this.cfg),this.render()},setData:function(e,t){this.validateData(e,t.paramList)&&(this.setSeries(e,t.paramList),this.chart||this.createChart(),this.removeSeries(!1),this.addSeries(!1),this.render())},setSeries:function(e,t){this.series=e,this.mapAllSeries(t),this.dataSet.fire(),this.modifyAllSeries(t),this.referenceAllSeries()},mapAllSeries:function(e){this.referencedSeries={},this.seriesMap={};for(var t=0;t<this.series.length;t++)this.mapSeries(this.series[t],e[t])},mapSeries:function(e,t){t.id&&((this.seriesMap[t.id]=e).id=t.id),t.id&&t.reference&&(this.referencedSeries[t.reference]||(this.referencedSeries[t.reference]=[]),this.referencedSeries[t.reference].push(t.id)),e.params=t},modifyAllSeries:function(e){for(var t=0;t<this.series.length;t++)this.modifySeries(t,this.series[t],e[t])},modifySeries:function(e,t){t.color=this.cfg.colors[e%this.cfg.colors.length];var e=this.referencedSeries[t.id],i=this;return e&&0<e.length&&(t.events={hide:function(){i.hideSeries(this)},show:function(){i.showSeries(this)}}),t},referenceAllSeries:function(){for(var e in this.referencedSeries)if(this.referencedSeries.hasOwnProperty(e))for(var t=this.referencedSeries[e],i=0;i<t.length;i++)this.referenceSeries(this.seriesMap[t[i]],this.seriesMap[e])},referenceSeries:function(e,t){e.color=t.color,e.showInLegend=!1},removeSeries:function(e){for(var t=this.chart.series.length;t--;){var i=this.chart.series[t];this.removeSingleSeries(i,e)}},removeSingleSeries:function(e,t){"Navigator"!=e.name&&"nullSeries"!=e.name&&("benchmark"==e.name&&e.hide(),e.remove(t))},addSeries:function(e){for(var t=0,i=0;i<this.series.length;i++)0<this.series[i].data.length&&(this.addNavigatorSeries(this.series[i],t,e),this.chart.addSeries(this.series[i],e),t++);this.addNullSeries(e)},getNullSeries:function(){var e;return"function"==typeof this.incrementNullSeries?(e=this.getDisplayInterval(),this.datasource.getNullSeries(e.min,e.max,this.incrementNullSeries)):null},addNullSeries:function(e){this.chart.get("nullSeries")&&this.chart.get("nullSeries").remove(!1);var t=this.getNullSeries();t&&0<t.data.length&&(t.showInLegend=!1,t.id="nullSeries",t.name="nullSeries",this.chart.addSeries(t,e)),this.chart.redraw(e)},getNullSeriesInterval:function(){var e=this.chart.get("nullSeries");if(e)return{min:(e=e.options.data)[0][0],max:e[e.length-1][0],toString:this.intervalToString}},addNavigatorSeries:function(e,t,i){e=this.modifyNavigatorSeries(e,t);0==t?this.setNavigatorSeries(e,i):this.cfg.custom&&this.cfg.custom.multiNavSeries&&this.chart.addSeries(e,i)},setNavigatorSeries:function(e,t){var i,r,s=this.chart.get("navigator");e?(i=this.getDisplayInterval(),r=e.data,"function"==typeof this.incrementNullSeries&&(r=this.datasource.appendNullSeries(e.data,i.min,i.max,this.incrementNullSeries)),s.setData(r,t),s.graph.attr({stroke:e.color}),"area"==s.options.type&&s.area&&s.area.attr({fill:e.color,"fill-opacity":s.options.fillOpacity})):s.setData([],t)},findNavigatorSeries:function(){for(var e=0;e<this.series.length;e++){var t=this.series[e];if(t&&0<t.data.length&&"Navigator"!=t.name)return t}},modifyNavigatorSeries:function(e){var t=YAHOO.fcom.Util.cloneJSObject(e.data),i=this.referencedSeries[e.id];if(i)for(var r=0;r<i.length;r++)var s=this.seriesMap[i[r]],t=t.concat(s.data);var a={enableMouseTracking:!1,type:"line",xAxis:this.chart.xAxis.length-1,yAxis:this.chart.yAxis.length-1,color:e.color,showInLegend:!1,lineWidth:1,data:t};return YAHOO.lang.augmentObject(a,e),a},render:function(){this.chart||this.createChart(),this.refreshInterval(!1),this.chart.redraw(),this.chartRendered.fire()},validateData:function(e){if(e)for(var t=0;t<e.length;t++)if(e[t].data&&0<e[t].data.length)return this.showMessage(),!0;return this.showMessage("no_data"),!1},showMessage:function(e){e?(YAHOO.util.Dom.setStyle(this.chartContainer,"display","none"),YAHOO.util.Dom.setStyle(this.messageContainer,"display",""),"no_data"===e&&(this.messageContainer.innerHTML=window.getMessage("chart.message.failed"))):(YAHOO.util.Dom.setStyle(this.chartContainer,"display",""),YAHOO.util.Dom.setStyle(this.messageContainer,"display","none"))},setExtremesListener:function(e){var t,i;"navigator"==e.trigger&&(this.interval={min:e.min,max:e.max},this.chart.get("nullSeries"))&&(t=this.datasource.getTimeIntervalFromData(this.series),i=this.getNullSeriesInterval(),this.interval.max<t.max&&i.max>t.max||this.interval.min>t.min&&i.min<t.min)&&(this.addNullSeries(!1),this.addNavigatorSeries(this.findNavigatorSeries(),0,!0)),this.extremesChanged.fire({min:e.min,max:e.max,trigger:e.trigger})},setInterval:function(e,t){this.chart&&(e=Math.max(e,this.getMaxInterval().min),t=Math.min(t,this.getMaxInterval().max),this.interval={min:e,max:t},this.chart.xAxis[0].setExtremes(e,t))},refreshInterval:function(e){this.chart.get("navigator").xAxis.setExtremes(null,null,e),this.chart.xAxis[0].setExtremes(null,null,e);var e=this.getMaxInterval(),t=this.chart.xAxis[0].getExtremes();this.setInterval(Math.max(t.min,e.min),Math.min(t.max,e.max))},setMaxInterval:function(){this.chart&&(this.chart.xAxis[0].setExtremes(),this.interval=this.getMaxInterval())},getInterval:function(){return{min:this.interval.min,max:this.interval.max,toString:this.intervalToString}},getMaxInterval:function(){var e=this.chart.get("navigator").xAxis.getExtremes();return{min:e.min,max:e.max,toString:this.intervalToString}},getDisplayInterval:function(){var e=this.getInterval(),t=this.datasource.getTimeIntervalFromData(this.series);return{min:isNaN(e.min)?t.min:Math.min(e.min,t.min),max:isNaN(e.max)?t.max:Math.max(e.max,t.max),toString:this.intervalToString}},formatTooltip:function(){for(var e=this.points[0].series.chart.tooltip.tooltipFooterHeaderFormatter(this.points[0]),t=(e+="<table>",{}),i=0,r=this.points.length;i<r;i++){e+="<tr>";var s,a=this.points[i];!0!==t[a.series.name]&&(s=Highcharts.numberFormat(a.y,2),e=e+('<td style="color:'+a.series.color+';">'+a.series.name)+'</td><td style="text-align: right; padding-left: 5px;">'+s+"</td>",t[a.series.name]=!0),e+="</tr>"}return e+="</table>"},resize:function(){var e=YAHOO.fcom.Dom.getDimensions(this.chartContainer);this.chart.setSize(e.width,e.height)},showSeries:function(e){var t=this.referencedSeries[e.options.id];if(t)for(var i=0;i<t.length;i++)(e=this.chart.get(t[i]))&&e.show()},hideSeries:function(e){var t=this.referencedSeries[e.options.id];if(t)for(var i=0;i<t.length;i++)(e=this.chart.get(t[i]))&&e.hide()},intervalToString:function(){var e=new Date(this.min),t=new Date(this.max);return"start: "+e.toString()+" end: "+t.toString()}};
//# sourceMappingURL=LineChart.js.map;
window.ngpNamespace("fcom.highstock"),fcom.highstock.DataSource=function(t){this.data={},this.stack=[],this.parameterList=t.parameterList,this.setRequestUrl(t.url),this.loadingStart=new YAHOO.util.CustomEvent("loadingStart",this),this.loadingComplete=new YAHOO.util.CustomEvent("loadingComplete",this)},fcom.highstock.DataSource.prototype={MAX_DATA_KEYS:100,CLEANUP_RATE:50,setRequestUrl:function(t){this.requestUrl=t},toHash:function(t){for(var a="",e=0;e<this.parameterList.length;e++){var s=this.parameterList[e];t[s]&&(a+=s+"="+t[s])}return a},putEntry:function(t,a){t=this.toHash(t);this.data[t]=a,this.stack.push(t)},cleanData:function(){if(this.stack.length>this.MAX_DATA_KEYS)for(var t=~~(this.MAX_DATA_KEYS*this.CLEANUP_RATE/100),a=this.stack.splice(0,t),e=0;e<a.length;e++)delete this.data[a[e]]},getEntry:function(t){return YAHOO.fcom.Util.cloneJSObject(this.data[this.toHash(t)])},check:function(t){return this.toHash(t)in this.data&&!t.retry&&0!=this.getEntry(t).data.length},addData:function(t,a){for(var e=0;e<t.length;e++){var s=t[e];this.putEntry(s,a[e])}},getData:function(t){for(var a=[],e=0;e<t.length;e++){var s=this.getEntry(t[e]);s&&a.push(s)}return YAHOO.fcom.Util.cloneJSObject(a)},checkList:function(t){for(var a=[],e=0;e<t.length;e++)this.check(t[e])||a.push(t[e]);return a},request:function(t,a,e){var s=this.checkList(t);0<s.length?(this.loadingStart.fire(),window.ngpAsyncRequest("POST",this.requestUrl,{success:function(t){this.loadingComplete.fire();var a=JSON.parse(t.responseText);this.addData(t.argument.requested,a),t.argument.callback&&t.argument.callback(this.getData(t.argument.paramList),t.argument.callbackParams),this.cleanData()},failure:function(){this.loadingComplete.fire()},scope:this,argument:{requested:s,paramList:t,callback:a,callbackParams:e}},{json:JSON.stringify(s)})):a&&a(this.getData(t),e)}};
//# sourceMappingURL=DataSource.js.map;
window.ngpNamespace("fcom.highstock"),fcom.highstock.DataSourceTimeSeries=function(e){fcom.highstock.DataSourceTimeSeries.superclass.constructor.call(this,e)},YAHOO.extend(fcom.highstock.DataSourceTimeSeries,fcom.highstock.DataSource,{getData:function(e,t){var a=this.getBenchmarkParams(e);if(a){for(var n=this.getSeriesParams(e),n=fcom.highstock.DataSourceTimeSeries.superclass.getData.call(this,n,t),i=this.getTimeIntervalFromData(n),r=this.getEntry(a),o=this.findIndex(i.min,r.data),c=this.findIndex(i.max,r.data);o<r.data.length&&r.data[o][0]<i.min;)o++;for(;o<c&&r.data[c][0]>i.max;)c--;return r.data=r.data.slice(o,c),n.splice(YAHOO.fcom.Util.indexOf(a,e),0,r),n}return fcom.highstock.DataSourceTimeSeries.superclass.getData.call(this,e,t)},getSeriesParams:function(e){for(var t=[],a=0;a<e.length;a++)"benchmark"!=e[a].id&&t.push(e[a]);return t},getBenchmarkParams:function(e){for(var t=0;t<e.length;t++)if("benchmark"==e[t].id)return e[t]},getRelativeDifference:function(e,t,a){if(void 0===t)throw new Error("fcom.highstock.DataSourceTimeSeries -> getRelativeDifference: Parameter period is undefined");var n=[];e=this.removeZeroValue(e),a=a&&this.removeZeroValue(a);for(var i=0;i<e.length;i++){var r=new fcom.date.DateTime,o=(r.setTimestamp(e[i][0]),r.addCalendar(t),this.findItem(r.getTimestamp(),a||e)),c=new fcom.date.DateTime,c=(c.setTimestamp(o[0]),fcom.date.DateTime.getTimeBetween(c,r));Math.abs(c.days)<3&&n.push([e[i][0],this.toRelativeValue(e[i][1],o[1])])}return n},getPercentChange:function(e,t){var a=[];if(0<(e=this.removeZeroValue(e)).length){void 0===t&&(t=e[0][1]);for(var n=0;n<e.length;n++)a.push([e[n][0],this.toRelativeValue(e[n][1],t)])}return a},findItem:function(e,t){e=this.findIndex(e,t);return-1!=e?t[e]:null},findIndex:function(e,t){return fcom.util.helper.binSearch(e,t,function(e,t){return fcom.util.helper.compare(e,t[0])},function(e,t){return fcom.util.helper.delta(e,t[0])})},removeZeroValue:function(e){var t=YAHOO.fcom.Util.cloneJSObject(e);if(0<t.length){for(var a=t[0][1],n=0;0==a&&n<t.length;)a="undefined"!=typeof t[++n]?t[n][1]:0;0<n&&(t=t.slice(n))}return t},toRelativeValue:function(e,t){return 0!==t?(e-t)/Math.abs(t)*100:0},getTimeIntervalFromData:function(e){for(var t=null,a=null,n=0;n<e.length;n++){var i=e[n].data;0<i.length&&((null==t||i[0][0]<t)&&(t=i[0][0]),null==a||i[i.length-1][0]>a)&&(a=i[i.length-1][0])}return{min:t,max:a}},getNullSeries:function(e,t,a){for(var n={data:[]},i=(new fcom.date.DateTime).setTimestamp(e);i.getTimestamp()<t;)n.data.push([i.getTimestamp(),null]),i=a(i);return n},appendNullSeries:function(e,t,a,n){var i=e[0][0],r=e[e.length-1][0];return e=(e=this.getNullSeries(t,i,n).data.concat(e)).concat(this.getNullSeries(r,a,n).data)},mergeSeries:function(e,t){var a;if((t=YAHOO.fcom.Util.cloneJSObject(t))[0][0]<e[0][0]&&-1!==(a=this.findIndex(e[0][0],t))){for(;t[a][0]>e[0][0]&&0<a;)a--;e=t.splice(0,a).concat(e)}if(t[t.length-1][0]>e[e.length-1][0]&&-1!==(a=this.findIndex(e[e.length-1][0],t))){for(;t[a][0]<e[e.length-1][0]&&a<t.length;)a++;e=e.concat(t.splice(a,t.length-1))}return e}});
//# sourceMappingURL=DataSourceTimeSeries.js.map;
(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var axiosInstance = _axios.default.create({});
axiosInstance.interceptors.request.use(function (config) {
  config.baseURL = "".concat(window.location.origin).concat(window.ctx, "/api/v1/");
  return Promise.resolve(config);
}, function (error) {
  return Promise.reject(error);
});
var _default = exports.default = axiosInstance;

},{"axios":150}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAriaAttributesToModuleTabMenu = void 0;
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * set aria attributes to moduletabmenus
 */
var setAriaAttributesToModuleTabMenu = exports.setAriaAttributesToModuleTabMenu = function setAriaAttributesToModuleTabMenu($menu) {
  var moduleTabMenus = $menu || $('div.moduleTabMenu div.menu');
  setAttributes(moduleTabMenus);
};

/**
 * set aria attributes to tablist and tabpanel for all tab menus on the page with tab buttons inside
 * @param menus
 */
var setAttributes = function setAttributes(menus) {
  $(menus).each(function (index, menu) {
    if ($(menu).find('button.icon').length > 0) {
      setAttributesToTablist(menu);
    }
  });
};

/**
 * set attributes to module tab menu elements by given tab menu
 * @param menu
 */
var setAttributesToTablist = function setAttributesToTablist(menu) {
  // todo get module title without timeout
  window.setTimeout(function () {
    // timeout because of loading... text at the beginning
    var moduleTitle = $(menu).closest('div.module').find('div.moduleHeader h2');
    $(menu).attr('role', 'tablist');
    $(menu).attr('aria-label', $(moduleTitle).text());
  }, 2000);
  setAriaAttributesToButtons($(menu));
};

/**
 * set attributes to tab buttons to given tab menu
 * @param menu
 */
var setAriaAttributesToButtons = function setAriaAttributesToButtons(menu) {
  var tabMenu = menu;
  var menuItems = $(tabMenu).find('div.menuItem');
  $(tabMenu).find('button').each(function (index, button) {
    $(button).attr('role', 'tab').attr('aria-selected', false).on('keydown', function (e) {
      if (e.keyCode === _keyCodes.default.ENTER || e.keyCode === _keyCodes.default.SPACE) {
        updateTabButtons(tabMenu, e.target);
      }
    }).on('click', function (e) {
      updateTabButtons(tabMenu, e.target);
    });
  });
  $(menuItems).each(function (index, item) {
    if ($(item).hasClass('on')) {
      setTabButtonSelected($(item).find('button'));
      return true;
    }
  });
};

/**
 * update attributes of tab buttons
 * @param menu
 * @param pressedBtn
 */
var updateTabButtons = function updateTabButtons(menu, pressedBtn) {
  var menuItemButtons = $(pressedBtn).parent('.menuItem').parent().find('> .menuItem button');
  menuItemButtons.attr('aria-selected', false).removeAttr('tabindex');
  setTabButtonSelected(pressedBtn);
};

/**
 * set given button as selected
 * @param button
 */
var setTabButtonSelected = function setTabButtonSelected(button) {
  $(button).attr({
    'aria-selected': true,
    tabindex: -1
  });
};

},{"util/enums/keyCodes":139}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Legend = _interopRequireDefault(require("charts/components/Legend"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var YAHOO = window.YAHOO;
var YieldCurve = function YieldCurve(element, data, config) {
  YieldCurve.superclass.constructor.call(this, element, data, config);
  this.curveAnim = null;
  this.successEvent.subscribe(function () {
    var _this = this;
    setTimeout(function () {
      var j = 0;
      _this.plot.childElements.forEach(function (group) {
        if (group.toString() == 'Gfx::Curve') {
          group.childElements.forEach(function (marker) {
            marker.primitives[1].node.setAttribute('data-tabindex', ++j);
            marker.markerOver.subscribe(function (mr) {
              $(element).attr('aria-description', mr.config.toolText);
            });
          });
        }
      });
    }, 400); // Wait for curve animation to end
  });
};

YieldCurve.prototype = {
  renderChart: function renderChart() {
    //create a legend for the multiple curves with mouseover interaction

    this.legend = new _Legend.default({
      groups: this.config.groups,
      width: this.getWidth()
    }, this.styleMap.canvas.chartElement.data);
    this.legend.mouseoverItem.subscribe(function (index) {
      if (this.curves[index]) {
        this.onCurveOver(this.curves[index]);
      }
    }, this, true);
    this.legend.mouseoutItem.subscribe(function (index) {
      if (this.curves[index]) {
        this.onCurveOut(this.curves[index]);
      }
    }, this, true);
    this.legend.render(this.context);
    if (this.config.groupsColor) {
      this.legend.setVisible(false);
    }
    var bb = this.legend.getBBox().addOffset(0, 5);
    this.unitX = new YAHOO.fcom.charts.UnitLog(this.data.getValues('x'), {
      base: 3,
      postfix: this.config.xaxis.postfix
    });
    this.unitY = new YAHOO.fcom.charts.UnitNumeric(this.data.getValues('y'), {
      postfix: this.config.yaxis.postfix
    });
    this.unitY.steps += 2;
    YAHOO.lang.augmentObject(this.config, {
      x: this.getX(),
      y: this.getY() + bb.height,
      width: this.getWidth(),
      height: this.getHeight() - bb.height
    }, true); //overwrite!
    var extendedPlot = window.extend(YAHOO.fcom.charts.Plot, {
      createXAxis: function createXAxis(x, y, length) {
        var Y = YAHOO.fcom.Format.localized.postfixYear;
        var M = YAHOO.fcom.Format.localized.postfixMonth;
        var config = {
          orientation: 0,
          x: x,
          y: y,
          length: length,
          offset: 20,
          ticks: [{
            text: "1".concat(M),
            value: 1
          }, {
            text: "3".concat(M),
            value: 3
          }, {
            text: "6".concat(M),
            value: 6
          }, {
            text: "1".concat(Y),
            value: 12
          }, {
            text: "2".concat(Y),
            value: 24
          }, {
            text: "5".concat(Y),
            value: 60
          }, {
            text: "10".concat(Y),
            value: 120
          }, {
            text: "20".concat(Y),
            value: 240
          }, {
            text: "30".concat(Y),
            value: 360
          }, {
            text: "50".concat(Y),
            value: 600
          }]
        };
        YAHOO.lang.augmentObject(config, this.config.xaxis);
        return new YAHOO.fcom.charts.StaticAxis(this.unitX, config, this.style['x-axis']);
      }
    });
    this.plot = new extendedPlot(this.unitX, this.unitY, this.config, this.styleMap.canvas.chartElement);
    this.plot.render(this.context);
    this.curves = [];
    for (var i = 0, len = this.data.groups.length; i < len; i++) {
      if (this.config.groupsColor) {
        this.styleMap.canvas.chartElement.data["group".concat(i)].shape.fill = this.config.groupsColor[i];
        this.styleMap.canvas.chartElement.data["group".concat(i)].curve.shape.stroke = this.config.groupsColor[i];
      }
      this.styleMap.canvas.chartElement.data["group".concat(i)].curve.shape.tabindex = 0;
      this.curves.push(this.plot.addCurve(this.data.getGroup(i), this.styleMap.canvas.chartElement.data["group".concat(i)]));
    }
    this.plot.mouseoverMarker.subscribe(function (marker) {
      this.curveToFront(marker.parent);
    }, this, true);
    this.plot.mouseoverMarker.subscribe(function (marker) {
      this.mouseOverEvent.fire(marker.config.data);
    }, this, true);
    this.plot.mouseoutMarker.subscribe(function (marker) {
      this.mouseOutEvent.fire(marker.config.data);
    }, this, true);
    if (!this.config.groupsColor) {
      this.plot.clickMarker.subscribe(function ( /*YAHOO.fcom.charts.GfxElement*/marker) {
        if (marker instanceof YAHOO.fcom.charts.Label) {
          marker = marker.parent;
        }
        this.mouseClickEvent.fire(marker.config.data);
      }, this, true);
    }
  },
  renderEmpty: function renderEmpty() {/* do nothing */
  },
  onCurveOver: function onCurveOver(element) {
    if (this.curveAnim) {
      this.curveAnim.stop();
    }
    var crvs = [];
    for (var len = this.curves.length; len--;) {
      var c = this.curves[len];
      if (c !== element) {
        crvs.push(c);
      } else {
        c.toFront();
      }
    }
    this.curveAnim = this.context.createAnim(crvs, {
      'fill-opacity': {
        from: 1,
        to: 0.0
      },
      'stroke-opacity': {
        from: 1,
        to: 0.0
      }
    }, 0.4);
    this.curveAnim.animate();
  },
  onCurveOut: function onCurveOut() {
    if (this.curveAnim) {
      this.curveAnim.stop();
    }
    for (var len = this.curves.length; len--;) {
      var c = this.curves[len];
      this.context.setStyle(c, {
        'fill-opacity': 1,
        'stroke-opacity': 1
      });
    }
  },
  curveToFront: function curveToFront(element) {
    this.onCurveOut(element);
    element.toFront();
  },
  /*
   * implementation of the abstract function of StyledChart
   * @override
   * @return HTMLElement
   */
  createStyleElement: function createStyleElement(styleElement) {
    YAHOO.util.Dom.addClass(styleElement, 'canvas');
    styleElement.appendChild(this.createElementAndAddClass('gradient'));
    styleElement.appendChild(this.createElementAndAddClass('emptyMsg'));
    var chart = this.createElementAndAddClass('chartElement');
    chart.appendChild(this.createElementAndAddClass('gradient'));
    chart.appendChild(this.createAxisEl('x-axis'));
    chart.appendChild(this.createAxisEl('y-axis'));
    var data = this.createElementAndAddClass('data');
    data.appendChild(this.createRadiusEl());
    var label = this.createElementAndAddClass('label');
    label.appendChild(this.createRadiusEl());
    data.appendChild(label);
    for (var i = 0; i < 10; i++) {
      var group = this.createElementAndAddClass("group".concat(i));
      group.appendChild(this.createElementAndAddClass('curve'));
      data.appendChild(group);
    }
    var legend = this.createElementAndAddClass('legend');
    var item = this.createElementAndAddClass('legendItem');
    legend.appendChild(item);
    data.appendChild(legend);
    chart.appendChild(data);
    styleElement.appendChild(chart);
    return styleElement;
  }
};
YAHOO.extend(YieldCurve, YAHOO.fcom.charts.ScatterChart, YieldCurve.prototype);
var _default = exports.default = YieldCurve;

},{"charts/components/Legend":4}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var YAHOO = window.YAHOO;

/*
 *
 * @param {} config
 * <ul>
 *     <li>width {Number} available width, if exeeded, the legend items will break to a new line
 *     <li>groups {String[]} a list of group names
 * </ul>
 * @param {} style
 * @param {} parent
 */
var Legend = function Legend(config, style, parent) {
  Legend.superclass.constructor.call(this, config, style, parent);

  /*
   * Fires when mouseover on a legend item.
   * First argument passed to handler function is the item's index
   * @event YAHOO.util.CustomEvent.FLAT
   */
  this.mouseoverItem = new YAHOO.util.CustomEvent('legendItem-mouseover', this, false, YAHOO.util.CustomEvent.FLAT);
  /*
   * Fires when mouseout on a legend item.
   * First argument passed to handler function is the item's index
   * @event YAHOO.util.CustomEvent.FLAT
   */
  this.mouseoutItem = new YAHOO.util.CustomEvent('legendItem-mouseout', this, false, YAHOO.util.CustomEvent.FLAT);
  this.items = [];
  for (var i = 0, len = this.config.groups.length; i < len; i++) {
    var item = new LegendItem({
      x: style.legend.paddingLeft,
      y: style.legend.paddingTop,
      name: this.config.groups[i]
    }, style["group".concat(i)], style.legend, this);
    item.mouseover.subscribe(function (element, index) {
      this.mouseoverItem.fire(index);
    }, i, this);
    item.mouseout.subscribe(function (element, index) {
      this.mouseoutItem.fire(index);
    }, i, this);
    this.items.push(item);
  }
};
Legend.prototype = {
  renderElement: function renderElement(context, style) {
    for (var i = 0, len = this.items.length; i < len - 1; i++) {
      var current = this.items[i];
      var next = this.items[i + 1];
      var curBB = current.getBBox();
      var nextBB = next.getBBox();
      var margin = style.legend.legendItem.marginLeft;
      if (curBB.x + curBB.width + nextBB.width > this.config.width) {
        //new line;
        next.move(margin, curBB.y + curBB.height);
      } else {
        next.move(curBB.x + curBB.width + margin, curBB.y);
      }
    }
  }
};
YAHOO.extend(Legend, YAHOO.fcom.charts.GfxElement, Legend.prototype);

/*
 * A legend item
 * @param {} config
 * <ul>
 *     <li>x {Number}
 *     <li>y {Number}
 *     <li>name {String} Name for the legend item
 * </ul>
 * @param {} style
 * @param {} parent
 */
var LegendItem = function LegendItem(config, style, labelStyle, parent) {
  Legend.superclass.constructor.call(this, config, style, parent);
  this.label = new YAHOO.fcom.charts.Label({
    x: this.config.x,
    y: this.config.y,
    text: this.config.name
  }, labelStyle, this);
};
LegendItem.prototype = {
  renderElement: function renderElement(context, style) {
    var bb = this.label.getBBox();
    context.beginPath();
    context.moveTo(this.config.x, bb.y + bb.height / 2);
    context.lineTo(20, 0);
    context.endPath(this, style.curve);
    context.translate(this.label, 20 + 5, 0);
    //create a shim for mouse listeners
    bb = this.getBBox();
    context.fill(this, bb.x, bb.y, bb.width, bb.height);
  }
};
YAHOO.extend(LegendItem, YAHOO.fcom.charts.GfxElement, LegendItem.prototype);
var _default = exports.default = Legend;

},{}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GroupedDataset = exports.Dataset = void 0;
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var YAHOO = window.YAHOO;

/*
 * @class Dataset
 * A dataset is a collection of DataItems, which supports iterators and chunks.
 * @namespace YAHOO.fcom.chart
 * @constructor
 * @param items {YAHOO.fcom.charts.DataItem[] | YAHOO.fcom.charts.DataItem} arbitary number of single DataItems or arrays of DataItems
 */
var Dataset = exports.Dataset = function Dataset() {
  var _ref,
    _this = this;
  /*
   * @type YAHOO.fcom.charts.DataItem[]
   * @private
   */
  this.items = (_ref = []).concat.apply(_ref, arguments);

  /*
   * key: property of a DataItem
   * value: a list of all values for that property in the complete dataset
   * @type {Object|Map}
   */
  this.values = Object.keys(this.items[0]) // use first item to determine keys
  .reduce(function (all, key) {
    all[key] = _this.items.map(function (item) {
      return item[key];
    });
    return all;
  }, {});
};
Dataset.prototype = {
  /*
   * Returns an array of values for the property "key".
   * @param key {String}
   * @return {Array}
   */
  getValues: function getValues(key) {
    return this.values[key];
  },
  /*
   * Returns the maximum for the DataItem property "key".
   * @param key {String} property name
   * @return {Number} returns 0 if property was not found
   */
  getMax: function getMax(key) {
    if (this.values[key] != null) {
      return Math.max.apply(Math, _toConsumableArray(this.values[key]));
    }
    return 0;
  },
  /*
   * Calls a processing function on chunks of data.
   * The processing should be indepenent on execution order
   *
   * @param processFn {Function} the processing function will receive the current chunk of data as first argument.
   * @param scope {Object}
   * @param config {Object}
   * <ul>
   *     <li>size {Number} chunk size to process (default: 10)
   *     <li>interval {Number} processing interval in ms (default: 10)
   *     <li>arguments {Array} an array of custom parameters passed to the processing function as second argument
   * </ul>
   */
  process: function process(processFn, scope, config) {
    config = config || {};
    YAHOO.lang.augmentObject(config, {
      size: 10,
      interval: 10,
      arguments: []
    });
    var iterator = this.iterator();
    window.setTimeout(function timeoutFunction() {
      var chunk = iterator.nextChunk(config.size);
      if (processFn.call(scope, chunk, config.arguments) !== false && iterator.hasNext()) {
        window.setTimeout(timeoutFunction, config.interval);
      }
    }, config.interval);
  },
  /*
   * Returns an iterator for the data structure. The iterator can return
   * single elements by the function next, or chunks of items (with a
   * specified size) by the function nextChunk.
   *
   * @return the iterator
   */
  iterator: function iterator() {
    var data = this.items;
    var currentIndex = 0;
    return {
      /*
       * returns the next data item or null
       * @return {YAHOO.fcom.charts.DataItem}
       */
      next: function next() {
        return currentIndex < data.length ? data[currentIndex++] : null;
      },
      /*
       * return the next chunk of num data items or less.
       * returns null when end of data was reached
       * @return {DataItem[]}
       */
      nextChunk: function nextChunk(num) {
        num = +num;
        if (currentIndex >= data.length) {
          return null;
        }
        var newIndex = currentIndex + num;
        if (newIndex > data.length) {
          newIndex = data.length;
        }
        var chunk = [];
        for (; currentIndex < newIndex; currentIndex++) {
          chunk.push(data[currentIndex]);
        }
        return chunk;
      },
      /*
       * more data items available?
       * @return {Boolean}
       */
      hasNext: function hasNext() {
        return currentIndex < data.length;
      }
    };
  }
};
/*
 * A grouped dataset is a dataset that can access sub-sets by a group index.
 * This is used by charts that display multiple curves.
 * @class GroupedDataset
 */
var GroupedDataset = exports.GroupedDataset = function GroupedDataset() {
  var _ref2, _GroupedDataset$super;
  var sets = (_ref2 = []).concat.apply(_ref2, arguments);
  (_GroupedDataset$super = GroupedDataset.superclass.constructor).call.apply(_GroupedDataset$super, [this].concat(_toConsumableArray(sets)));
  /*
   * stores all groups
   * @type YAHOO.fcom.charts.Dataset[]
   */
  this.groups = sets.map(function (set) {
    return new Dataset(set);
  });
};
GroupedDataset.prototype = {
  /*
   * Returns the dataset for a single group
   * @param index {Number}
   * @return {YAHOO.fcom.charts.Dataset}
   */
  getGroup: function getGroup(index) {
    return this.groups[index];
  }
};
YAHOO.extend(GroupedDataset, Dataset, GroupedDataset.prototype);
window.YAHOO.fcom.charts.Dataset = Dataset;

},{}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ONE_YEAR = exports.ONE_WEEK = exports.ONE_QUARTER = exports.ONE_DAY = void 0;
var ONE_DAY = exports.ONE_DAY = 24 * 60 * 60 * 1000;
var ONE_WEEK = exports.ONE_WEEK = 7 * ONE_DAY;
var ONE_YEAR = exports.ONE_YEAR = 365 * ONE_DAY;
var ONE_QUARTER = exports.ONE_QUARTER = Math.round(ONE_YEAR / 4);

},{}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ajaxPostJson = exports.ajaxPost = exports.ajaxGetJson = exports.ajaxGet = void 0;
var _objectToPostdata = _interopRequireDefault(require("core/Ajax/objectToPostdata"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/** @module core/Ajax/ajaxRequest */

/**
 * ajaxRequest is a wrapper for window.fetch that encapsulates all its functionality
 * @private
 * @param {String} method
 * @param {String} url
 * @param {String} [format] data format expected, this can be one of:
 * <ul>
 *  <li>text (default)</li>
 *  <li>json</li>
 *  <li>blob</li>
 *  <li>arrayBuffer</li>
 *  <li>formData</li>
 * </ul>
 * @param {Object} [data] key value object to be sent as post data or appended to url as get parameters
 * @param {Object} [headers] key value object containing request headers to be sent
 * @return {Promise.<any>}
 */
var ajaxRequest = function ajaxRequest(method, url, format, data, headers) {
  format = format || 'text';
  headers = headers || null;
  var fetchOptions = {
    method: method,
    headers: headers,
    credentials: 'same-origin'
  };
  var params = '';
  if (typeof data === 'string') {
    params = data;
  } else {
    params = (0, _objectToPostdata.default)(data);
  }
  if (method === 'GET') {
    if (params) {
      url += (url.indexOf('?') > -1 ? '&' : '?') + params;
    }
  } else {
    fetchOptions.body = params || null;
  }
  if (url.indexOf('/') === 0) {
    url = window.ctx + url;
  }
  return window.fetch(url, fetchOptions).then(function (response) {
    if (response.ok) {
      return response[format]();
    } else {
      if (!response.headers.has('applicationMessage')) {
        throw new Error("".concat(response.status, " - ").concat(response.statusText));
      } else {
        var error = new Error();
        error.code = response.status;
        error.message = response.headers.get('applicationMessage');
        throw error;
      }
    }
  });
};

/**
 * executes a GET request to the provided url and returns a promise
 * @param {String} url
 * @param {Object} [data] key value object to be appended to url as get parameters
 * @param {Object} [headers] key value object containing request headers to be sent
 * @return {Promise.<string>}
 */
var ajaxGet = exports.ajaxGet = function ajaxGet(url, data, headers) {
  return ajaxRequest('GET', url, 'text', data || {}, Object.assign({}, headers));
};

/**
 * executes a GET request to the provided url and returns a promise
 * @param {String} url
 * @param {Object} [data] key value object to be appended to url as get parameters
 * @param {Object} [headers] key value object containing request headers to be sent
 * @return {Promise.<any>}
 */
var ajaxGetJson = exports.ajaxGetJson = function ajaxGetJson(url, data, headers) {
  return ajaxRequest('GET', url, 'json', data || {}, Object.assign({}, headers));
};

/**
 * executes a POST request to the provided url and returns a promise
 * @param {String} url
 * @param {Object} [data] key value object to be sent as post data
 * @param {Object} [headers] key value object containing request headers to be sent
 * @return {Promise.<string>}
 */
var ajaxPost = exports.ajaxPost = function ajaxPost(url, data, headers) {
  return ajaxRequest('POST', url, 'text', data || {}, Object.assign({
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
  }, headers));
};

/**
 * executes a POST request to the provided url and returns a promise
 * @param {String} url
 * @param {Object} [data] key value object to be sent as post data
 * @param {Object} [headers] key value object containing request headers to be sent
 * @return {Promise.<any>}
 */
var ajaxPostJson = exports.ajaxPostJson = function ajaxPostJson(url, data, headers) {
  return ajaxRequest('POST', url, 'json', data || {}, Object.assign({
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
  }, headers));
};

},{"core/Ajax/objectToPostdata":8}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/*
 * Create a post data string from an object by using the property names as
 * parameter names. The values will be URI encoded.
 * Returns null for any input that is not an object.
 */
var objectToPostdata = function objectToPostdata(postData) {
  return _typeof(postData) !== 'object' || postData == null ? null : Object.keys(postData).map(function (key) {
    return [].concat(itemToString(postData[key])).filter(function (f) {
      return f != null;
    }).map(function (a) {
      return "".concat(key, "=").concat(encodeURIComponent(a));
    });
  }).reduce(function (all, a) {
    return all.concat(a);
  }, []).join('&');
};
var itemToString = function itemToString(item, jsonEncodeArray) {
  if (typeof item === 'function' || item == null) {
    //invalid stuff should be ignored
    return null;
  } else if (!jsonEncodeArray && Array.isArray(item)) {
    return item.map(function (a) {
      return itemToString(a, true);
    });
  } else if (_typeof(item) === 'object') {
    if (typeof item.toString === 'function') {
      var string = item.toString();
      // if the object has an overwritten toString method
      if (string.indexOf('[object ') !== 0) {
        return string;
      }
    }
    return JSON.stringify(item);
  } else {
    return "".concat(item);
  }
};
var _default = exports.default = objectToPostdata;

},{}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectToPostdata = _interopRequireDefault(require("core/Ajax/objectToPostdata"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * This functions sends the user to a new url <br/>
 * @param {string} url If the url passed in starts with a slash (<code>/</code>) it will automatically be prefixed by <code>window.context</code>
 * @param {Object} [params] an object of request parameters that will be serialized automatically
 */
var redirectTo = function redirectTo(url, params) {
  var targetUrl = url;
  if (url.indexOf('/') === 0) {
    targetUrl = window.ctx + url;
  }
  if (params) {
    targetUrl += (url.indexOf('?') > -1 ? '&' : '?') + (0, _objectToPostdata.default)(params);
  }
  window.location = targetUrl;
};
window.redirectTo = redirectTo;
var _default = exports.default = redirectTo;

},{"core/Ajax/objectToPostdata":8}],10:[function(require,module,exports){
"use strict";

window.ngpNamespace('fcom.customized.tdwealth.contextPassing');
var sendContextPassingMessage = function sendContextPassingMessage(symbol, command, optionType, expiryDate, strikePrice, instrumentType) {
  if (instrumentType === 'OPTIONS' && ['openBuyTicket', 'openSellTicket'].includes(command)) {
    strikePrice = parseFloat(strikePrice);
    window.parent.postMessage({
      symbol: symbol,
      command: command,
      optionType: optionType,
      expiryDate: expiryDate,
      strikePrice: strikePrice
    }, '*');
  } else {
    sendMessage(symbol, command);
  }
};
var sendMessage = function sendMessage(symbol, command) {
  window.parent.postMessage({
    symbol: symbol,
    command: command
  }, '*');
};
window.fcom.customized.tdwealth.contextPassing.sendContextPassingMessage = sendContextPassingMessage;

},{}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Hooks = exports.default = /*#__PURE__*/function () {
  function Hooks() {
    _classCallCheck(this, Hooks);
  }
  _createClass(Hooks, null, [{
    key: "onModuleAdded",
    value: function onModuleAdded(type) {
      // Matomo Tracking Code: Add new module
      if (window._paq) {
        window._paq.push(['trackEvent', 'Modules', 'Add', type]);
      }
    }
  }, {
    key: "onModuleRemoved",
    value: function onModuleRemoved(type) {
      // Matomo Tracking Code: Add new module
      if (window._paq) {
        window._paq.push(['trackEvent', 'Modules', 'Removed', type]);
      }
    }
  }, {
    key: "onSearchResult",
    value: function onSearchResult(search, results) {
      // Matomo Tracking Code: Search
      if (window._paq) {
        window._paq.push(['trackSiteSearch', search,
        // Category
        'instruments',
        // Result count
        results.length > 0 ? results[0].count : 0]);
      }
    }
  }]);
  return Hooks;
}();

},{}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerMessages = exports.getMessage = exports.addMessage = void 0;
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/** @module messages/messageHandler */

//use an object in window as cache, in order to prevent multiple instances of the cache
window.__messagesCache = window.__messagesCache || {};
var messages = window.__messagesCache;

/**
 * adds a message object with key value pairs for translation
 * @param {Object} msg
 */
var registerMessages = exports.registerMessages = function registerMessages(msg) {
  Object.assign(messages, msg);
};

/**
 * adds a message to the global message cache for translation
 * @param {string} key
 * @param {string} value
 */
var addMessage = exports.addMessage = function addMessage(key, value) {
  messages[key] = value;
};

/**
 * translates a given key and replaces {0}..{n} with the respective replacements
 * @param {string} key
 * @param {...string} replacements
 * @returns {string}
 * @example
 * addMessage('example', 'example {0} of {1}')
 * getMessage('example', '4', 'many');
 * // --> 'example 4 of many'
 * getMessage('example', ['2', '6']);
 * // --> 'example 2 of 6'
 */
var getMessage = exports.getMessage = function getMessage(key) {
  var _ref;
  for (var _len = arguments.length, replacements = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    replacements[_key - 1] = arguments[_key];
  }
  replacements = (_ref = []).concat.apply(_ref, _toConsumableArray(replacements));
  var message = messages[key] || key.split('.').reduce(function (all, a) {
    return a;
  }, '');
  message = message.replace(/\{(\d)\}/g, function (match, id) {
    return replacements[+id] != null ? replacements[+id] : match;
  });
  return message;
};
window.registerMessages = registerMessages;
window.getMessage = getMessage;
window.addMessage = addMessage;

},{}],13:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var AfterMarketResearchModule = function AfterMarketResearchModule(node, config) {
  var _this = this;
  /**
  * lookup map to match the aftermarket API transfer strings to number of days
  */
  var periodDayLookup = {
    customDate: -1,
    today: 0,
    last7Days: 7,
    last30Days: 30,
    last60Days: 60,
    last90Days: 90,
    last6Months: 180
  };
  var DEFAULT_PERIOD = 7;
  var lastMessage = null;
  var moduleId = node.id;
  var viewId = window.YAHOO.fcom.Page.getInstance('moduleContainer').id;
  var targetId = "".concat(moduleId + config.sizeId, "_div");
  var forcedMaximized = config.forceMaximized === true ? true : false;
  var getHandlerId = function getHandlerId(id) {
    return "".concat(moduleId, "_").concat(id);
  };
  var getHandler = function getHandler(id) {
    return window.YAHOO.fcom.Page.getInstance(getHandlerId(id));
  };
  var datePickerFrom = null;
  var datePickerTo = null;
  var periodDropdown = null;
  var watchlistSelectDropDown = null;
  var ricSearchField = null;
  this['@destroy'] = function () {
    removeFormEvents();
  };
  if (config.receiverChannel) {
    this['@broadcast'] = _defineProperty({}, config.receiverChannel, function (message) {
      return onMessage(message);
    });
  }
  var isSupportedMessageType = function isSupportedMessageType(message) {
    var types = ['ric', 'multiRic', 'country', 'multiCountry'];
    return Boolean(message) && types.indexOf(message.messageType) > -1;
  };
  var onMessage = function onMessage(message) {
    if (message.senderId !== node.id) {
      lastMessage = message;
      if (message.messageType === 'ric') {
        window.reloadModuleContent(moduleId, viewId, targetId, message.ric);
      } else if (isSupportedMessageType(message)) {
        window.reloadModuleContent(moduleId, viewId, targetId, message);
      }
    }
  };
  var updateSearch = function updateSearch() {
    var url = '/ajax.action';
    var target = "".concat(moduleId, "Max_div");
    window.replaceAsync(url, target, {
      form: window.YAHOO.util.Dom.get("".concat(moduleId, "_form")),
      postData: {
        maximized: !forcedMaximized,
        method: 'getAfterMarketResearchTable'
      },
      replaceContainer: true,
      showWait: true,
      modallityNode: "".concat(moduleId)
    });
  };
  var saveSearch = function saveSearch() {
    var formName = "".concat(moduleId, "_form");
    var form = document.getElementById(formName);
    var postData = {
      method: 'changeModule'
    };
    var url = '/module.action';
    var reloadCallback = function reloadCallback() {
      window.reloadModuleContent(moduleId, viewId, "".concat(moduleId, "Min_div"));
    };
    window.ngpAsyncRequest('POST', url, reloadCallback, postData, form, false, false);
  };
  var reloadModule = function reloadModule() {
    var url = '/ajax.action';
    var target = "".concat(moduleId, "_formNTable");
    window.replaceAsync(url, target, {
      postData: {
        maximized: !forcedMaximized,
        method: 'getAfterMarketModuleAndForm',
        moduleId: encodeURIComponent(moduleId),
        viewId: encodeURIComponent(viewId)
      },
      setFormEvents: setFormEvents,
      replaceContainer: true
    });
  };
  var setFormEvents = function setFormEvents() {
    window.YAHOO.util.Event.addListener(getHandlerId('UpdateSearch'), 'click', updateSearch, null, _this);
    window.YAHOO.util.Event.addListener(getHandlerId('ResetSearch'), 'click', reloadModule, null, _this);
    window.YAHOO.util.Event.addListener(getHandlerId('SaveSearch'), 'click', saveSearch, null, _this);
    datePickerFrom.dateChanged.subscribe(datePickerChanged, _this, true);
    datePickerTo.dateChanged.subscribe(datePickerChanged, _this, true);
    periodDropdown.changeEvent.subscribe(periodDropdownChanged, _this, true);
    if (watchlistSelectDropDown) {
      // not available e.g. on instrument detail pages
      watchlistSelectDropDown.changeEvent.subscribe(onWatchlistSelectDropDownChanged, _this, true);
    }
    if (ricSearchField) {
      ricSearchField.itemFoundEvent.subscribe(onRicSearchChanged, _this, true);
    }
  };
  var removeFormEvents = function removeFormEvents() {
    if (periodDropdown) {
      window.YAHOO.util.Event.removeListener(getHandlerId('UpdateSearch'), 'click');
      window.YAHOO.util.Event.removeListener(getHandlerId('ResetSearch'), 'click');
      window.YAHOO.util.Event.removeListener(getHandlerId('SaveSearch'), 'click');
      datePickerFrom.dateChanged.unsubscribe(datePickerChanged);
      datePickerTo.dateChanged.unsubscribe(datePickerChanged);
      periodDropdown.changeEvent.unsubscribe(periodDropdownChanged);
      if (watchlistSelectDropDown) {
        // not available e.g. on instrument detail pages
        watchlistSelectDropDown.changeEvent.unsubscribe(onWatchlistSelectDropDownChanged);
      }
      if (ricSearchField) {
        ricSearchField.itemFoundEvent.unsubscribe(onRicSearchChanged);
      }
    }
  };
  var getFormElements = function getFormElements() {
    datePickerFrom = getHandler('PeriodDateFrom');
    datePickerTo = getHandler('PeriodDateTo');
    periodDropdown = getHandler('PeriodDropDown');
    watchlistSelectDropDown = getHandler('WatchlistSelectDropDown');
    ricSearchField = getHandler('ric');
  };
  var prepareLargeViewWithForm = function prepareLargeViewWithForm() {
    getFormElements();
    setFormEvents();
  };
  var onRicSearchChanged = function onRicSearchChanged() {
    // simple first version
    resetWatchlistSelect();
    updateSearch();
  };
  var onWatchlistSelectDropDownChanged = function onWatchlistSelectDropDownChanged() {
    if (watchlistSelectDropDown.getSelectedValue() !== '') {
      resetRicSearch();
    }
    updateSearch();
  };
  var resetRicSearch = function resetRicSearch() {
    ricSearchField.setText('');
    ricSearchField.setValue('');
  };
  var resetWatchlistSelect = function resetWatchlistSelect() {
    watchlistSelectDropDown.selectByValue('');
  };
  var datePickerChanged = function datePickerChanged() {
    if (periodDropdown.selected !== 'customDate') {
      var daysBack = periodDayLookup[periodDropdown.selected] || DEFAULT_PERIOD;
      periodDropdown.selectByValue('customDate');
      if (!datePickerFrom.getDate()) {
        // only if from-picker still empty
        var dateTo = datePickerTo.getDate();
        var dateFrom = dateTo.addCalendar({
          day: -1 * daysBack
        });
        datePickerFrom.setDate(dateFrom);
      }
    }
    updateSearch();
  };
  var periodDropdownChanged = function periodDropdownChanged() {
    if (periodDropdown.getSelectedValue() !== 'customDate') {
      datePickerFrom.setDate(null);
      datePickerTo.setDate(new Date());
    }
    updateSearch();
  };
  var showMaximized = function showMaximized() {
    var postData = {
      method: 'getModuleMaximized',
      moduleId: moduleId,
      viewId: viewId
    };
    var directParams = null;
    if (lastMessage) {
      directParams = {};
      for (var _i = 0, _Object$keys = Object.keys(lastMessage); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        directParams[key] = lastMessage[key];
      }
    } else if (window.YAHOO.fcom.viewInfo.country !== '') {
      directParams = {
        messageType: 'country',
        country: window.YAHOO.fcom.viewInfo.country
      };
    }
    directParams ? postData.directParams = JSON.stringify(directParams) : null;
    var maximizedPanelId = "".concat(moduleId, "_panel");
    var ajaxConfig = {
      instanceHandler: function instanceHandler(panel) {
        prepareLargeViewWithForm(panel);
      },
      customObject: _this
    };
    var panelConfig = {
      draggable: false,
      modal: true,
      y: 30,
      width: '99%',
      constraintoviewport: true
    };
    window.fillPanelFromAjax(maximizedPanelId, '/view.action', postData, panelConfig, ajaxConfig);
  };
  var initModule = function initModule() {
    var maximizeIcon = window.YAHOO.util.Dom.get("".concat(moduleId, "_maximize"));
    if (maximizeIcon && !forcedMaximized) {
      // if maximize icon is available and the large form is not already in the module
      window.YAHOO.util.Event.addListener(maximizeIcon, 'click', showMaximized, null, _this); // add click handler
    }

    if (forcedMaximized) {
      prepareLargeViewWithForm();
    }
  };
  initModule();
};
window.fcom.moduleHandler.registerModuleType('AfterMarketResearchModule', function (node, config) {
  return new AfterMarketResearchModule(node, config);
}, true);

},{}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var CapitalStructureModule = function CapitalStructureModule(node, config, themeConfig) {
  config.theme = themeConfig;
  var viewId = window.YAHOO.fcom.Page.getInstance('moduleContainer').id;
  var moduleId = node.id;
  if (config.receiverChannel) {
    this['@broadcast'] = _defineProperty({}, config.receiverChannel, function (message) {
      if (message.messageType === 'ric') {
        window.reloadModuleContent(moduleId, viewId, "".concat(moduleId, "_div"), message.ric).then(function () {
          config.ric = message.ric;
          window.fcom.moduleHandler.initModule(node);
        });
      }
    });
  }
};
window.fcom.moduleHandler.registerModuleType('CapitalStructureModule', function (node, config, themeConfig) {
  return new CapitalStructureModule(node, config, themeConfig);
}, true);
var _default = exports.default = CapitalStructureModule;

},{}],15:[function(require,module,exports){
"use strict";

var _ChainChartContainer = _interopRequireDefault(require("modules/ChainChartModule/ChainChartContainer"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// register the module and its callback function
window.fcom.moduleHandler.registerModuleType('ChainChartModule', function (node, config, themeConfig) {
  var moduleInstance = new _ChainChartContainer.default(node, config, themeConfig);
  return moduleInstance;
}, true);

},{"modules/ChainChartModule/ChainChartContainer":16}],16:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _SingleChart = _interopRequireWildcard(require("modules/InstrumentChartModule/SingleChart"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ChainChartContainer = function ChainChartContainer(node, config, themeConfig) {
  var _this = this;
  this.node = node;
  this.config = config;
  this.chainRics = this.config.chainRic.split(',');
  this.themeConfig = themeConfig;
  this.getInitialData().then(function (chartData) {
    _this.chartData = chartData;
    _this.processErrors();
    _this.render();
  });

  // setup point syncing
  $(this.node).bind('mousemove touchmove touchstart', function (e) {
    if (!_this.chart) {
      return;
    }
    _this.chart.chart.getSelectedPoints().forEach(function (point) {
      point.select(false);
    });
    var normalizedEvent = _this.chart.chart.pointer.normalize(e.originalEvent);
    var points = _this.findClosestPoints(normalizedEvent);
    if (points.length > 0) {
      points.forEach(function (point) {
        point.select(true, true);
      });
    }
  });
  $(this.node).bind('mouseout touchend', function () {
    if (!_this.chart) {
      return;
    }
    _this.chart.chart.tooltip.hide();
    _this.chart.chart.xAxis[0].hideCrosshair();
    _this.chart.chart.getSelectedPoints().forEach(function (point) {
      point.select(false);
    });
  });
};
ChainChartContainer.prototype.render = function () {
  var _this2 = this;
  // checks to prevent console error messages if no valid data
  if (!this.chartData) {
    return;
  }
  var validSeriesCount = this.chartData.reduce(function (count, item) {
    if (item.data && item.data.length > 0) {
      count++;
    }
    return count;
  }, 0);
  if (validSeriesCount === 0) {
    return;
  }
  var $chartContainer = $(this.node).find('[data-chartcontainer]');
  $chartContainer.html('');
  var chartHeight = 100;
  var $container = $("<div style=\"height:".concat(chartHeight, "%;\"/>"));
  $chartContainer.append($container);
  var chartData = {};
  chartData.series = this.chartData.filter(function (ricData) {
    return ricData.data && ricData.data.length > 0;
  }).map(function (ricData, i) {
    var name = ricData.name;
    var config = {
      color: _this2.themeConfig.chartColors.seriesColors[i],
      showInLegend: true
    };
    var data = ricData.data.map(function (d) {
      return {
        close: d.yAxis,
        timestamp: d.ts,
        name: d.lable
      };
    }).filter(function (d) {
      return d.close;
    });
    return {
      name: name,
      type: 'line',
      config: config,
      data: data
    };
  });
  var styleOverwrites = {
    chart: {
      spacingRight: 0
    },
    plotOptions: {
      line: {
        marker: {
          enabled: true,
          radius: 4,
          lineWidth: 1,
          symbol: 'circle',
          states: {
            hover: {
              enabled: false
            }
          }
        }
      }
    },
    xAxis: [{
      title: {
        text: this.config.xAxisLabel,
        style: {
          color: this.themeConfig.chartColors.labels
        }
      }
    }],
    yAxis: [{
      title: {
        text: this.config.yAxisLabel,
        style: {
          color: this.themeConfig.chartColors.labels
        }
      }
    }]
  };
  var chartConfig = {
    dataType: 'maturities',
    themeConfig: Object.assign(styleOverwrites, this.themeConfig),
    interval: 'D',
    isComplex: false,
    chartScale: _SingleChart.CHARTSCALE.ABSOLUTE,
    isStreaming: false,
    // it is not streaming in the sense that items will be added to the end of the line
    showLegend: true,
    isChainChart: true,
    datePattern: "".concat(this.config.xAxisLabel.split(" ")[0], ": ").concat(window.YAHOO.fcom.Format.localized.patternChartDay),
    yAxisLabelName: this.config.yAxisLabel.split(" ")[0],
    hasNonMatchingTimestamps: true,
    tooltipBorderColor: '#565e66',
    tooltipPositioner: function tooltipPositioner(tooltipWidth, tooltipHeight) {
      var chart = this.chart;
      var selectedPoints = chart.getSelectedPoints();
      var closestPoint = selectedPoints[0];
      var leastDist = closestPoint.dist;
      if (selectedPoints.length > 1) {
        chart.getSelectedPoints().forEach(function (point) {
          if (point.dist < leastDist) {
            leastDist = point.dist;
            closestPoint = point;
          }
        });
      }
      var offsetX = closestPoint.plotX + tooltipWidth > chart.plotWidth ? closestPoint.plotX + tooltipWidth - chart.plotWidth : 0;
      var offsetY = closestPoint.plotY + tooltipHeight > chart.plotHeight ? closestPoint.plotY + tooltipHeight - chart.plotHeight : 0;
      var x = chart.plotLeft + closestPoint.plotX - offsetX;
      var y = chart.plotTop + closestPoint.plotY - offsetY;
      return {
        x: x,
        y: y
      };
    },
    tooltipBackground: this.themeConfig.chartColors.tooltipBackground,
    tooltipStyle: {
      color: this.themeConfig.chartColors.labels,
      opacity: 0.9
    }
  };
  this.chart = new _SingleChart.default($container.get(0), chartData, chartConfig);
};
ChainChartContainer.prototype.processErrors = function () {
  var noPermissionRics = [];
  var noDataRics = [];
  this.chartData.forEach(function (data) {
    if (data.status) {
      if (data.status.includes('noPermission')) {
        noPermissionRics.push(data.ric);
      } else if (data.status.includes('noValues')) {
        noDataRics.push(data.ric || data.name);
      }
    }
  });
  var parentContainer = $(this.node).find('.chartImageBox');
  if (noDataRics.length > 0) {
    // show error message for rics with no data
    var errorText = noDataRics.length === 1 ? window.getMessage('module.chainchartmodule.noDataForSingleIntrument', noDataRics.join(', ')) : window.getMessage('module.chainchartmodule.noDataForMultipleIntruments', noDataRics.join(', '));
    $(parentContainer).prepend("<div class=\"hint\">".concat(errorText, "</div>"));
  }
  if (noPermissionRics.length > 0) {
    // show error message for rics with no permission
    var _errorText = window.getMessage('errorpage.nopermissions', noPermissionRics.join(', '));
    $(parentContainer).prepend("<div class=\"hint\">".concat(_errorText, "</div>"));
  }
  var chartHeight = $(parentContainer).find('[data-chartcontainer]')[0].offsetHeight;
  if (this.chartData.length === noPermissionRics.length + noDataRics.length) {
    // no data present for any rics
    $(parentContainer).find('[data-chartcontainer]').hide();
  }
  var errorMessageHeight = 0;
  var errorDivMarginTop = 0;
  var offset = 0;
  $(parentContainer).find('.hint').each(function (i, el) {
    if (i === 0) {
      errorDivMarginTop = parseInt($(el).css('margin-top'));
    } else if (i === 1) {
      // offset is needed only if there are two error messages as the margin bottom of first error div and margin top of second div overlap
      offset = errorDivMarginTop;
    }
    errorMessageHeight += $(el).outerHeight(true);
  });
  $(parentContainer).find('[data-chartcontainer]')[0].style.height = "".concat(chartHeight - errorMessageHeight + offset, "px");
  // parent container needs to be adjusted, otherwise the module will appear a bit longer because of the margin top set on error message div
  $(parentContainer)[0].style.height = "".concat(chartHeight - errorDivMarginTop, "px");
};
ChainChartContainer.prototype.getInitialData = function () {
  var _this3 = this;
  return Promise.all(this.chainRics.map(function (ric) {
    return window.ajaxGetJson('/ricPermission.action', {
      method: 'getRicPermission',
      ric: ric
    }).then(function (data) {
      if (data.permission !== 'NO_ACCESS' && data.permission !== 'RIC_NOT_FOUND') {
        var params = Object.assign({
          method: 'getChainChart',
          yAxis: _this3.config.yAxis,
          xAxis: _this3.config.xAxis,
          chainRic: ric,
          label: _this3.config.label
        }, _this3.extraCallParams || {});
        return window.ajaxGetJson('/chainseries.action', params);
      } else if (data.permission === 'NO_ACCESS') {
        return {
          ric: data.ric,
          status: 'noPermission'
        };
      } else {
        return {
          ric: data.ric,
          status: 'noValues'
        };
      }
    });
  }));
};
ChainChartContainer.prototype.findClosestPoints = function (normalizedEvent) {
  var closestPoints = [];
  var leastDist = Infinity;
  this.chart.chart.series.forEach(function (series) {
    var point = series.searchPoint(normalizedEvent, true);
    if (point) {
      if (point.distX === leastDist) {
        closestPoints.push(point);
      } else if (point.distX < leastDist) {
        leastDist = point.distX;
        closestPoints = [point];
      }
    }
  });
  return closestPoints;
};
ChainChartContainer.prototype.showError = function (errorText) {
  $(this.node).find('.chartImageBox [data-chartcontainer]').hide();
  $(this.node).find('.chartImageBox .hint').remove();
  $(this.node).find('.chartImageBox').append("<div class=\"hint\">".concat(errorText, "</div>"));
  return this;
};
ChainChartContainer.prototype['@resize'] = function () {
  this.render();
};
var _default = exports.default = ChainChartContainer;

},{"modules/InstrumentChartModule/SingleChart":102}],17:[function(require,module,exports){
"use strict";

require("modules/AfterMarketResearchModule");
require("modules/DynamicHeatmapModule");
require("modules/DynamicScatterPlotModule");
require("modules/InstrumentListScatterPlotModule");
require("modules/DynamicWorldmapModule");
require("modules/ProfessionalChartModule/ProfessionalChartModule");
require("modules/ExtendedWatchlistModule");
require("modules/InstrumentChartModule");
require("modules/InstrumentListHeatmapModule");
require("modules/LineChartModule");
require("modules/MaturityChartModule");
require("modules/HistoricalKpiChartModule");
require("modules/ChainChartModule");
require("modules/NewsListModule");
require("modules/NewsModule");
require("modules/OptionChainModule");
require("modules/WatchlistModule");
require("modules/UpcomingEventsModule");
require("modules/ListOfChainsModule");
require("modules/InternalJspModule");
require("modules/RatingsModule/RatingsModule");
require("modules/TimeAndSalesDataModule/TimeAndSalesDataModule");
require("modules/InternalSearchModule");
require("modules/YieldCurveModule");
require("modules/HistoricalTimeSeriesDataModule/HistoricalTimeSeriesDataModule");
require("modules/CapitalStructureModule/CapitalStructureModule");
require("modules/LongQuoteModule/LongQuoteModule");
require("modules/SmartChartModule");

},{"modules/AfterMarketResearchModule":13,"modules/CapitalStructureModule/CapitalStructureModule":14,"modules/ChainChartModule":15,"modules/DynamicHeatmapModule":18,"modules/DynamicScatterPlotModule":21,"modules/DynamicWorldmapModule":26,"modules/ExtendedWatchlistModule":30,"modules/HistoricalKpiChartModule":32,"modules/HistoricalTimeSeriesDataModule/HistoricalTimeSeriesDataModule":34,"modules/InstrumentChartModule":35,"modules/InstrumentListHeatmapModule":105,"modules/InstrumentListScatterPlotModule":107,"modules/InternalJspModule":108,"modules/InternalSearchModule":109,"modules/LineChartModule":110,"modules/ListOfChainsModule":111,"modules/LongQuoteModule/LongQuoteModule":112,"modules/MaturityChartModule":114,"modules/NewsListModule":116,"modules/NewsModule":117,"modules/OptionChainModule":118,"modules/ProfessionalChartModule/ProfessionalChartModule":119,"modules/RatingsModule/RatingsModule":120,"modules/SmartChartModule":121,"modules/TimeAndSalesDataModule/TimeAndSalesDataModule":123,"modules/UpcomingEventsModule":124,"modules/WatchlistModule":125,"modules/YieldCurveModule":126}],18:[function(require,module,exports){
"use strict";

var _HeatmapContainer = _interopRequireDefault(require("modules/DynamicHeatmapModule/HeatmapContainer"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var YAHOO = window.YAHOO;
window.fcom.moduleHandler.registerModuleType('DynamicHeatmapModule', function (node, config, themeConfig) {
  config.labelName = $("#".concat(node.id, "_labelMenu option:selected")).text();
  var moduleInstance = new _HeatmapContainer.default(node, config, themeConfig);
  moduleInstance.loadData();
  moduleInstance['@destroy'] = function () {
    return null;
  };
  // #. Bind the orientation change event
  moduleInstance.onOrientationChange();
  if (config.receiverChannel) {
    moduleInstance['@broadcast'] = _defineProperty({}, config.receiverChannel, function (message) {
      return onMessage(message);
    });
  }
  var onMessage = function onMessage(message) {
    if (message.senderId !== node.id) {
      if (message.messageType === 'ric') {
        moduleInstance.setRic(message.ric);
      }
    }
  };
  var settingsClicked = function settingsClicked() {
    var label = YAHOO.util.Dom.get("".concat(moduleInstance.moduleId, "_labelMenu")).value;
    var size = YAHOO.util.Dom.get("".concat(moduleInstance.moduleId, "_sizeMenu")).value;
    var config = moduleInstance.getConfig();
    config.size = size;
    config.label = label;
    config.labelName = $("#".concat(moduleInstance.moduleId, "_labelMenu option:selected")).text();
    // NGPII-22419 - added timeout so that keypad is closed and chart height is calculated correctly
    window.setTimeout(function () {
      moduleInstance.setConfig(config);
      sort();
    }, 300);
  };
  var indexChange = function indexChange() {
    var label = YAHOO.util.Dom.get("".concat(moduleInstance.moduleId, "_labelMenu")).value;
    var size = YAHOO.util.Dom.get("".concat(moduleInstance.moduleId, "_sizeMenu")).value;
    var index = YAHOO.util.Dom.get("".concat(moduleInstance.moduleId, "_indexMenu")).value;
    var config = moduleInstance.getConfig();
    config.size = size;
    config.label = label;
    config.labelName = $("#".concat(moduleInstance.moduleId, "_labelMenu option:selected")).text();
    moduleInstance.setConfig(config);
    moduleInstance.setRic(index);
  };
  var sort = function sort() {
    var sortBy = [YAHOO.util.Dom.get("".concat(moduleInstance.moduleId, "_sortMenu")).value, YAHOO.util.Dom.get("".concat(moduleInstance.moduleId, "_sortDirectionMenu")).value];
    moduleInstance.sortElements(sortBy);
  };
  window.setTimeout(function () {
    $("#".concat(moduleInstance.moduleId, "_sizeMenu")).change(settingsClicked);
    $("#".concat(moduleInstance.moduleId, "_sortMenu")).change(sort);
    $("#".concat(moduleInstance.moduleId, "_sortDirectionMenu")).change(sort);
    $("#".concat(moduleInstance.moduleId, "_labelMenu")).change(settingsClicked);
    if (YAHOO.fcom.Page.getInstance("".concat(moduleInstance.moduleId, "_indexMenu"))) {
      $("#".concat(moduleInstance.moduleId, "_indexMenu")).change(indexChange);
    }
  }, 50);
  return moduleInstance;
}, true);

},{"modules/DynamicHeatmapModule/HeatmapContainer":20}],19:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _positionTooltip = _interopRequireDefault(require("util/d3/positionTooltip"));
var _quartileRange3 = _interopRequireDefault(require("util/functions/quartileRange"));
var _resizeMenuItems = require("util/resizeMenuItems");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var D3Heatmap = function D3Heatmap(element, config) {
  this.element = element;
  this.config = config;
  this.config.sort = [];
  this.margin = {
    top: 3,
    right: 3,
    bottom: 3,
    left: 3
  };
  var width = (this.config.width != null ? this.config.width : this.element.parentNode.clientWidth) - this.margin.left - this.margin.right;
  var height = this.config.height - this.margin.top - this.margin.bottom;
  (0, _resizeMenuItems.resizeMenuItems)(this.element.parentElement);
  this.treemap = d3.treemap().size([width, height]).round(true);
  this.setSorting([this.config.sortBy, this.config.sortDirection]);
  this.div = d3.select(this.element).append('div').style('position', 'relative').style('height', "".concat(height + this.margin.top + this.margin.bottom, "px")).style('left', "".concat(this.margin.left, "px")).style('top', "".concat(this.margin.top, "px"));
  if (this.config.dynamicHeight) {
    this.spacerBottom = d3.select(this.element).append('div');
  }
  this.tooltip = d3.select(this.element).append('div').attr('class', 'd3-tooltip').style('position', 'absolute').style('opacity', '0');
};
D3Heatmap.prototype.setData = function (data) {
  this.rawData = data;
  this.configureData();
};
D3Heatmap.prototype.setFields = function (fields) {
  this.fieldConfig = fields;
};
D3Heatmap.prototype.getDisplayRics = function () {
  var _this = this;
  var displayRics = [this.config.label, this.config.size, this.config.sort[0]].filter(function (f) {
    return _this.fieldConfig[f];
  });
  return displayRics.filter(function (f, i, array) {
    return array.indexOf(f) === i;
  });
};
D3Heatmap.prototype.setConfig = function (config) {
  this.config = config;
  this.configureData();
};
D3Heatmap.prototype.configureData = function () {
  var _this2 = this;
  this.data = Object.assign({}, this.rawData);
  this.data.children = this.rawData.children.map(function (d) {
    return Object.assign({}, d, {
      size: _this2.config.size === 'equal' ? 1 : d.data[_this2.config.size].value,
      label: d.data[_this2.config.label].value
    });
  }).filter(function (f) {
    return f.size != null;
  }); // only show items that have a size

  if (!this.data.children.length) {
    var errorText = window.getMessage('module.InstrumentListHeatmapModule.error.noFilteredData');
    this.showMessage(errorText);
    return;
  } else {
    this.hideMessage();
  }
  this.config.mode = this.fieldConfig[this.config.label].negPossible ? 'rel' : 'abs';
  this.createColorScale();
  this.resize();
};
D3Heatmap.prototype.showMessage = function (message) {
  var $mainEl = $(this.element);
  var $msgEl = $mainEl.find('.hint');
  if ($msgEl.length === 0) {
    $msgEl = $('<div class="hint"></div>');
    $mainEl.append($msgEl);
  }
  // #. Hide other elements
  $mainEl.children().hide();
  // #. Set message text
  $msgEl.text(message).show();
};
D3Heatmap.prototype.hideMessage = function () {
  var $mainEl = $(this.element);
  var $msgEl = $mainEl.find('.hint');
  // #. Show other elements
  $mainEl.children().show();
  // #. Hide/Clear message
  $msgEl.text('').hide();
};
D3Heatmap.prototype.setSorting = function (sort) {
  if (this.config.sort.join('.') !== sort.join('.')) {
    this.config.sort = sort;
    return true;
  } else {
    return false;
  }
};
D3Heatmap.prototype.createColorScale = function () {
  var values = this.data.children.map(function (d) {
    return isNaN(d.label) ? Infinity : d.label;
  });
  var _quartileRange = (0, _quartileRange3.default)(values),
    _quartileRange2 = _slicedToArray(_quartileRange, 2),
    lowerBound = _quartileRange2[0],
    upperBound = _quartileRange2[1];
  var colorRange = this.fieldConfig[this.config.label].colorGroup ? this.config["colorRange".concat(this.fieldConfig[this.config.label].colorGroup)] : this.config.mode === 'abs' ? this.config.colorRangeAbs : this.config.colorRangeRel;
  var domain = colorRange.length === 2 ? [lowerBound < 0 ? 0 : lowerBound, upperBound] : [lowerBound, 0, upperBound];
  this.color = d3.scaleLinear().domain(domain).range(colorRange).clamp(true);
};
D3Heatmap.prototype.getSortFunction = function () {
  var sortField = this.config.sort[0];
  sortField = sortField === 'size' ? this.config.size : sortField;
  var sortDir = this.config.sort[1];
  return function (a, b) {
    var sorter;
    try {
      sorter = sortDir === 'asc' ? d3.ascending(a.data.data[sortField].value, b.data.data[sortField].value) : d3.descending(a.data.data[sortField].value, b.data.data[sortField].value);
    } catch (e) {
      sorter = 0;
    }
    if (sorter === 0) {
      sorter = sortDir === 'asc' ? d3.ascending(a.data.name, b.data.name) : d3.descending(a.data.name, b.data.name);
    }
    return sorter;
  };
};
D3Heatmap.prototype.renderChart = function (noTransition) {
  var _this3 = this;
  if (!this.data || !this.data.children || !this.data.children.length) {
    // only render when data has been loaded
    return;
  }
  //dont animate the first time the chart renders
  noTransition = !this.initialized ? true : noTransition;
  this.initialized = true;
  var transitionTime = noTransition ? 0 : 700;

  //create the root Node
  var rootNode = d3.hierarchy(this.data).sum(function (d) {
    return d.size;
  }).sort(this.getSortFunction());
  var tabindexFunction = function tabindexFunction(d, i) {
    return i;
  };
  var ariaLabelIdFunction = function ariaLabelIdFunction(d, i) {
    return "tooltip-".concat(i);
  };
  var nodes = this.div.selectAll('.node').data(this.treemap(rootNode).descendants(), function (d) {
    return d.data.ric;
  }); // identify items by ric

  var linkRICTemplate;
  if ("".concat(this.config.linkRIC) === 'false') {
    linkRICTemplate = null;
  } else {
    linkRICTemplate = "".concat(this.config.linkRIC) !== 'true' ? this.config.linkRIC : '${ctx}/detail/detailPage.html?ric=${ric}';
  }
  nodes.exit().transition().duration(transitionTime).style('width', '0px').style('height', '0px').style('left', '0px').style('top', '0px').style('opacity', '0').remove();
  nodes.enter().append('a').style('opacity', '0').merge(nodes)
  // the following applies to all nodes (new and old)
  // href can contain placeholders like {CTX} or {RIC}
  .attr('href', function (d) {
    if (!linkRICTemplate) {
      return;
    }
    var exp = /[\$][\{]([A-Za-z]+)[\}]/g;
    return linkRICTemplate.replace(exp, function (match, p1) {
      var arg = {
        ric: d.data.ric,
        ctx: window.ctx
      };
      return arg[p1.toLowerCase()];
    });
  }).attr('target', this.config.linkTarget || null).attr('class', 'node printbg').attr('aria-labelledby', ariaLabelIdFunction).attr('tabindex', '-1').attr('data-tabindex', tabindexFunction).classed('parent', function (d) {
    return d.children;
  }).classed('nolink', !linkRICTemplate).classed('invert-colors', function (d) {
    return d.children ? false : d3.lab(_this3.color(d.data.label)).l < 60;
  }).html(function (d) {
    var height = d.y1 - d.y0;
    var width = d.x1 - d.x0;
    if (d.children) {
      return null;
    } else if (height < 26 || width < 26) {
      //dont add text for small nodes
      return '';
    } else {
      var name = width > 100 ? d.data.name : d.data.ric.split('.')[0];
      var displayName = width >= 60 ? name : name.substr(0, Math.floor((width - 10) / 10));
      var displayNumber = height > 35 && width >= 60 ? d.data.data[_this3.config.label].label : ''; // TODO: do not use label
      return "<div>".concat(displayName, "<br/>").concat(displayNumber, "</div>");
    }
  }).on('mouseover', function (event, d) {
    var tooltipRows = _this3.getDisplayRics().map(function (ric) {
      return "".concat(_this3.fieldConfig[ric].label, ": ").concat(d.data.data[ric].label);
    });
    _this3.tooltip.html("<div>".concat(d.data.name, " (").concat(d.data.ric, ")<br/>").concat(tooltipRows.join('<br/>'), "</div><div class=\"d3-tooltip-ptr\"></div>"));
    _this3.tooltip.attr('id', event.currentTarget.getAttribute('aria-labelledby'));
    var container = {
      w: d.parent.x1 - d.parent.x0,
      h: d.parent.y1 - d.parent.y0
    };
    var element = {
      x: d.x0,
      y: d.y0,
      w: d.x1 - d.x0,
      h: d.y1 - d.y0
    };
    (0, _positionTooltip.default)(_this3.tooltip, container, element);
  }).on('mouseout', function () {
    _this3.tooltip.transition().duration(500).style('opacity', '0');
  }).transition().duration(transitionTime).style('left', function (d) {
    return "".concat(d.x0, "px");
  }).style('top', function (d) {
    return "".concat(d.y0, "px");
  }).style('width', function (d) {
    return "".concat(Math.max(0, d.x1 - d.x0 - 1), "px");
  }).style('height', function (d) {
    return "".concat(Math.max(0, d.y1 - d.y0 - 1), "px");
  }).style('opacity', '1').style('background', function (d) {
    return d.children ? null : _this3.color(d.data.label);
  });

  // IE fix to force color update
  window.setTimeout(function () {
    d3.select(_this3.element).selectAll('.node').classed('touched', true).classed('touched', false);
  }, transitionTime);
  (0, _resizeMenuItems.resizeMenuItems)(this.element.parentElement);
};
D3Heatmap.prototype.getSpacingBottom = function () {
  var footerHeight = $('body>.footer:visible').height();
  return footerHeight ? 5 : 20; // 20px bottom spacing for edge curved devices.
};

D3Heatmap.prototype.getChartOffsetTop = function () {
  return $(this.element).offset().top;
};
D3Heatmap.prototype.vhToPx = function (value) {
  var w = window;
  var d = document;
  var e = d.documentElement;
  var g = d.getElementsByTagName('body')[0];
  var x = w.innerHeight || e.clientHeight || g.clientHeight;
  var result = x * value / 100;
  return result;
};
D3Heatmap.prototype.getChartHeight = function () {
  var height = this.config.height;
  if (this.config.dynamicHeight && this.rawData && this.rawData.children) {
    var ricCount = this.rawData.children.length;
    if (this.config.size === 'equal') {
      var width = $(this.element).width();
      var maxItemsPerRow = Math.floor(width / 60);
      var totalRows = Math.ceil(ricCount / maxItemsPerRow);
      height = Math.max(this.vhToPx(100) - this.getChartOffsetTop(), totalRows * 60);
      $(this.element).css('height', 'auto');
    } else {
      var offsetTop = this.getChartOffsetTop();
      var relHeight = 100;
      if (ricCount <= 60) {
        relHeight = 100;
      } else if (ricCount <= 120) {
        relHeight = 120;
      } else if (ricCount <= 220) {
        relHeight = 150;
      } else {
        relHeight = 200;
      }
      $(this.element).css('height', "calc(".concat(relHeight, "vh - ").concat(offsetTop, "px)"));
      height = $(this.element).height();
    }
    this.spacerBottom.style('height', "".concat(this.getSpacingBottom(), "px"));
  }
  return height - this.margin.top - this.margin.bottom;
};
D3Heatmap.prototype.resize = function () {
  var width = this.element.parentNode.clientWidth - this.margin.left - this.margin.right;
  var height = this.getChartHeight();
  this.treemap.size([width, height]);
  this.div.style('height', "".concat(height, "px"));
  this.renderChart(true);
};
var _default = exports.default = D3Heatmap;

},{"util/d3/positionTooltip":137,"util/functions/quartileRange":144,"util/resizeMenuItems":147}],20:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _D3Heatmap = _interopRequireDefault(require("modules/DynamicHeatmapModule/D3Heatmap"));
var _transformHeatmapData2 = _interopRequireDefault(require("util/d3/transformHeatmapData"));
var _resizeMenuItems = require("util/resizeMenuItems");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _d = d3,
  select = _d.select;
var DynamicHeatmapModule = function DynamicHeatmapModule(containerNode, config, themeConfig) {
  if (!config) {
    return;
  }
  this.config = config;
  this.moduleId = containerNode.id;
  this.containerId = "".concat(this.moduleId, "_container");
  this.container = window.Dom.get(this.containerId);
  this.error = window.Dom.get("".concat(this.moduleId, "_error"));
  this.senderChannel = $(containerNode).data('module-senderchannel') || null;

  // Create a new HeatMap in the container
  config.colorRangeRel = themeConfig.colorRangeRel;
  config.colorRangeAbs = themeConfig.colorRangeAbs;
  config.colorRangeVola = themeConfig.colorRangeVola;
  config.colorRangeFund = themeConfig.colorRangeFund;
  this.chart = new _D3Heatmap.default(window.Dom.get(this.containerId), config);
  this.enableKeyboardNavigation(this.containerId);
};
DynamicHeatmapModule.prototype.loadData = function () {
  var _this = this;
  var ric = this.getConfig().ric;
  return window.ajaxGetJson('/constituents.action', {
    method: 'getHeatmapData',
    ric: ric
  }).then(function (heatmapData) {
    var rootData = {};
    var _transformHeatmapData = (0, _transformHeatmapData2.default)(heatmapData),
      data = _transformHeatmapData.data,
      fields = _transformHeatmapData.fields;
    rootData.name = heatmapData.indexName || ric;
    rootData.ric = ric;
    rootData.children = data;
    _this.chart.setFields(fields);
    _this.chart.setData(rootData);
    return rootData.name;
  }).then(function (title) {
    // update title
    if (!_this.config.hasFixedTitle) {
      $("#".concat(_this.moduleId, " .moduleHeader .title .content")).html(title);
    }
    // add broadcast links
    if (_this.senderChannel) {
      window.YAHOO.fcom.Broadcaster.initBroadcastLinks(_this.senderChannel, _this.moduleId);
    }
  }).catch(function (err) {
    $("#".concat(_this.moduleId, " .moduleHeader .title .content")).html(ric);
    _this.chart.showMessage(window.getMessage('module.DynamicHeatmapModule.error'));
  });
};
DynamicHeatmapModule.prototype.getConfig = function () {
  return this.chart.config;
};
DynamicHeatmapModule.prototype.setConfig = function (config) {
  this.chart.setConfig(config);
};
DynamicHeatmapModule.prototype.setRic = function (ric) {
  if (this.chart.config.ric !== ric) {
    // only update ric if necessary
    this.chart.config.ric = ric;
    this.loadData();
  }
};
DynamicHeatmapModule.prototype.sortElements = function (sortBy) {
  if (this.chart.setSorting(sortBy)) {
    this.chart.renderChart();
  }
};
DynamicHeatmapModule.prototype['@resize'] = function () {
  (0, _resizeMenuItems.resizeMenuItems)(this.container.parentNode);
  this.chart.resize(true);
};
DynamicHeatmapModule.prototype.onOrientationChange = function () {
  var _this2 = this;
  window.addEventListener('orientationchange', function () {
    window.setTimeout(function () {
      (0, _resizeMenuItems.resizeMenuItems)(_this2.container.parentNode);
      _this2.chart.resize(true);
    }, 50);
  });
};
DynamicHeatmapModule.prototype.enableKeyboardNavigation = function (containerId) {
  $("#".concat(containerId)).on('keyup', function (e) {
    var activeIndex = null;
    var nextIndex = null;
    var activeElement = document.activeElement;
    if (activeElement && activeElement.nodeName.toLowerCase() == 'a') {
      select(activeElement).dispatch('mouseout');
      var tabIndex = activeElement.getAttribute('data-tabindex');
      activeIndex = +tabIndex;
    }
    if (e.keyCode == 37) {
      if (activeIndex) {
        nextIndex = activeIndex - 1;
      }
    } else if (e.keyCode == 39) {
      if (activeIndex) {
        nextIndex = activeIndex + 1;
      } else {
        nextIndex = 1;
      }
    }
    if (nextIndex) {
      var nextElem = $("#".concat(containerId, " a[data-tabindex=\"").concat(nextIndex, "\"]"));
      if (nextElem.length) {
        nextElem.focus();
        select(nextElem[0]).dispatch('mouseover');
      }
    }
  });
};
var _default = exports.default = DynamicHeatmapModule;

},{"modules/DynamicHeatmapModule/D3Heatmap":19,"util/d3/transformHeatmapData":138,"util/resizeMenuItems":147}],21:[function(require,module,exports){
"use strict";

var _DynamicScatterPlot = _interopRequireDefault(require("modules/DynamicScatterPlotModule/DynamicScatterPlot"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
window.fcom.moduleHandler.registerModuleType('DynamicScatterPlotModule', function (node, config, themeConfig) {
  var moduleInstance = new _DynamicScatterPlot.default(node, config, themeConfig);
  if (config.receiverChannel) {
    moduleInstance['@broadcast'] = _defineProperty({}, config.receiverChannel, function (message) {
      return onMessage(message);
    });
  }
  var onMessage = function onMessage(message) {
    if (message.senderId !== node.id) {
      if (message && message.messageType === 'ric') {
        var _config = moduleInstance.getConfig();
        _config.ric = message.ric;
        loadData(_config, true);
      }
    }
  };
  var loadData = function loadData(config, resetZoom) {
    if (config) {
      return moduleInstance.setConfig(config).loadData(resetZoom);
    }
    moduleInstance.loadData(resetZoom);
  };
  var settingsClicked = function settingsClicked(resetZoom) {
    var xAxis = $("#".concat(node.id, "_xAxisMenu")).val();
    var yAxis = $("#".concat(node.id, "_yAxisMenu")).val();
    var size = $("#".concat(node.id, "_sizeMenu")).val();
    var color = $("#".concat(node.id, "_colorMenu")).val();
    var config = Object.assign({}, moduleInstance.getConfig(), {
      xAxis: xAxis,
      yAxis: yAxis,
      size: size,
      color: color
    });
    moduleInstance.setConfig(config).updateSettings(resetZoom);
  };
  var initModule = function initModule() {
    loadData(null, true);
    window.setTimeout(function () {
      $("#".concat(node.id, "_xAxisMenu")).change(function () {
        return settingsClicked(true);
      });
      $("#".concat(node.id, "_yAxisMenu")).change(function () {
        return settingsClicked(true);
      });
      $("#".concat(node.id, "_sizeMenu")).change(function () {
        return settingsClicked(false);
      });
      $("#".concat(node.id, "_colorMenu")).change(function () {
        return settingsClicked(false);
      });
    }, 50);
  };
  initModule();
  return moduleInstance;
}, true);

},{"modules/DynamicScatterPlotModule/DynamicScatterPlot":23}],22:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _positionTooltip = _interopRequireDefault(require("util/d3/positionTooltip"));
var _lodash = require("lodash");
var _legendColorGrouping = require("./legendColorGrouping.inc");
var _formatFieldValue = _interopRequireDefault(require("./formatFieldValue.inc"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var transitionDuration = 400;
var moveStep = 50;
var zoomStep = 0.5;
var D3ScatterPlot = function D3ScatterPlot(element, config) {
  this.element = element;
  this.config = config;
  this.reRenderBubbles = true;
  this.filteredLegends = [];
  this.margin = {
    top: 10,
    right: 30,
    bottom: 40,
    left: 60
  };
  this.initSvgMarkup().resize();
};
D3ScatterPlot.prototype.formatFieldValue = function (value, field) {
  var isRelative = this.fieldConfig[field].relative;
  return (0, _formatFieldValue.default)(value, field, isRelative);
};
D3ScatterPlot.prototype.getInnerWidth = function () {
  return (this.config.width || this.element.parentNode.clientWidth) - this.margin.left - this.margin.right;
};
D3ScatterPlot.prototype.initSvgMarkup = function () {
  var _this = this;
  var innerWidth = this.getInnerWidth();
  var innerHeight = this.config.height - this.margin.top - this.margin.bottom;
  var getTickFormatter = function getTickFormatter(axis) {
    return function (d) {
      return _this.formatFieldValue(d, _this.config[axis]);
    };
  };
  this.originalXScale = d3.scaleLinear();
  this.originalYScale = d3.scaleLinear();
  this.xScale = this.originalXScale;
  this.yScale = this.originalYScale;
  this.xAxisGrid = d3.axisBottom().scale(this.xScale).tickFormat('');
  this.xAxis = d3.axisBottom().scale(this.xScale).tickFormat(getTickFormatter('xAxis'));
  this.yAxisGrid = d3.axisLeft().scale(this.yScale).tickFormat('');
  this.yAxis = d3.axisLeft().scale(this.yScale).tickFormat(getTickFormatter('yAxis'));
  this.zoom = d3.zoom().scaleExtent([0.5, 20]).extent([[0, 0], [innerWidth, innerHeight]]).on('zoom', function (event) {
    _this.updateZoom(event.transform);
  });
  this.svg = d3.select(this.element).append('svg').attr('aria-hidden', 'true').append('g').attr('transform', "translate(".concat(this.margin.left, ", ").concat(this.margin.top, ")")).call(this.zoom);
  this.xAxisGridElement = this.svg.append('g').attr('class', 'x axis-grid');
  this.yAxisGridElement = this.svg.append('g').attr('transform', 'translate(0, 0)').attr('class', 'y axis-grid');
  this.xAxisElement = this.svg.append('g').attr('class', 'x axis');
  this.xAxisLabel = this.svg.append('g').attr('class', 'xAxisLabel').append('text').attr('text-anchor', 'middle');
  this.yAxisElement = this.svg.append('g').attr('transform', 'translate(0, 0)').attr('class', 'y axis');
  this.yAxisLabel = this.svg.append('g').attr('class', 'yAxisLabel').append('text').attr('text-anchor', 'middle');
  this.radius = d3.scaleSqrt();
  this.tooltip = d3.select(this.element).append('div').attr('class', 'd3-tooltip').style('position', 'absolute').style('opacity', '0').attr('id', this.element.id.replace('container', 'tooltip')).attr('aria-hidden', 'true');
  this.brush = d3.brush().on('end', function (event) {
    return _this.doBrushSelection.bind(_this, event);
  });
  this.brushElement = this.svg.append('g').attr('class', 'brush');
  var clipPathId = "".concat(this.config.moduleId, "_clip_boundary");
  this.clipPath = this.svg.append('clipPath').attr('id', clipPathId).append('rect').attr('x', 0).attr('y', 0).attr('width', innerWidth).attr('height', innerHeight);
  this.bubbles = this.svg.append('g').attr('clip-path', "url(#".concat(clipPathId, ")")).attr('class', 'bubbles');

  // Zoom Handles
  this.handles = d3.select(this.element).append('div').attr('class', 'dynamicworldmap-handles').attr('style', "bottom: ".concat(this.margin.bottom + 18, "px"));
  this.handles.append('div').attr('class', 'handle-move-up').on('click', function () {
    _this.moveUp();
  });
  this.handles.append('div').attr('class', 'handle-move-down').on('click', function () {
    _this.moveDown();
  });
  this.handles.append('div').attr('class', 'handle-move-left').on('click', function () {
    _this.moveLeft();
  });
  this.handles.append('div').attr('class', 'handle-move-right').on('click', function () {
    _this.moveRight();
  });
  this.handles.append('div').attr('class', 'handle-zoom-in').on('click', function () {
    _this.zoomIn();
  });
  this.handles.append('div').attr('class', 'handle-zoom-out').on('click', function () {
    _this.zoomOut();
  });
  this.handles.append('div').attr('class', 'handle-reset').on('click', function () {
    _this.resetZoom();
  });
  this.legend = this.svg.append('g').attr('class', 'legend');
  return this;
};
D3ScatterPlot.prototype.resetZoom = function (callback) {
  this.svg.transition().duration(300).call(this.zoom.transform, d3.zoomIdentity).on('end', function () {
    if (callback) {
      callback();
    }
  });
};
D3ScatterPlot.prototype.zoomIn = function () {
  this.svg.transition().duration(300).call(this.zoom.scaleBy, 1 + zoomStep);
};
D3ScatterPlot.prototype.zoomOut = function () {
  this.svg.transition().duration(300).call(this.zoom.scaleBy, 1 - zoomStep);
};
D3ScatterPlot.prototype.moveLeft = function () {
  this.svg.transition().duration(300).call(this.zoom.translateBy, moveStep, 0);
};
D3ScatterPlot.prototype.moveRight = function () {
  this.svg.transition().duration(300).call(this.zoom.translateBy, -moveStep, 0);
};
D3ScatterPlot.prototype.moveUp = function () {
  this.svg.transition().duration(300).call(this.zoom.translateBy, 0, moveStep);
};
D3ScatterPlot.prototype.moveDown = function () {
  this.svg.transition().duration(300).call(this.zoom.translateBy, 0, -moveStep);
};
D3ScatterPlot.prototype.updateZoom = (0, _lodash.throttle)(function (transform) {
  var _this2 = this;
  if (this.isRendering === true) {
    return;
  }
  this.updateXAxis(transform).updateYAxis(transform);
  var xAxisFunction = this.getXAxisFunction();
  var yAxisFunction = this.getYAxisFunction();

  // k is the scale factor. This is, how much we should scale the plot when zoom changed
  var k = transform.k;
  var sizeFunction = function sizeFunction(d) {
    return _this2.radius(_this2.config.size === 'equal' ? 1 : d.data[_this2.config.size].value || 0) * k;
  };

  // update bubbles
  this.bubbles.selectAll('circle').transition().duration(transitionDuration).attr('cx', xAxisFunction).attr('cy', yAxisFunction).attr('r', sizeFunction);
  this.bubbles.selectAll('text').transition().duration(transitionDuration).attr('x', xAxisFunction).attr('y', function (d) {
    return yAxisFunction(d) + 1;
  });
  this.drawRegressionLine();
  if (this.config.drawLabels) {
    this.debounceOverlappedLabels();
  } else {
    this.hideAllLabels();
  }
}, 100);
D3ScatterPlot.prototype.setConfig = function (config) {
  this.config = config;
  return this;
};
D3ScatterPlot.prototype.getXAxisLabel = function () {
  return this.fieldConfig[this.config.xAxis].label;
};
D3ScatterPlot.prototype.getYAxisLabel = function () {
  return this.fieldConfig[this.config.yAxis].label;
};
D3ScatterPlot.prototype.setData = function (data) {
  this.data = data;
  if (this.data.length === 0) {
    var errorText = window.getMessage('module.InstrumentListHeatmapModule.error.noFilteredData');
    this.showMessage(errorText);
  } else {
    this.hideMessage();
    this.setDrawLabels();
    this.reRenderBubbles = true;
  }
  return this;
};
D3ScatterPlot.prototype.setDrawLabels = function () {
  this.config.drawLabels = this.data.length <= 60; // draw labels up until 60 items
};

D3ScatterPlot.prototype.setFields = function (fieldConfig) {
  this.fieldConfig = fieldConfig;
  return this;
};
D3ScatterPlot.prototype.showMessage = function (message) {
  var $mainEl = $(this.element);
  var $msgEl = $mainEl.find('.hint');
  if ($msgEl.length === 0) {
    $msgEl = $('<div class="hint"></div>');
    $mainEl.append($msgEl);
  }
  // #. Hide other elements
  $mainEl.children().hide();
  // #. Set message text
  $msgEl.text(message).show();
};
D3ScatterPlot.prototype.hideMessage = function () {
  var $mainEl = $(this.element);
  var $msgEl = $mainEl.find('.hint');
  // #. Show other elements
  $mainEl.children().show();
  // #. Hide/Clear message
  $msgEl.text('').hide();
};
D3ScatterPlot.prototype.doBrushSelection = function (event) {
  var _this3 = this;
  var selection = event.selection;
  var rics = [];
  if (selection) {
    var _selection = _slicedToArray(selection, 2),
      _selection$ = _slicedToArray(_selection[0], 2),
      x1 = _selection$[0],
      y1 = _selection$[1],
      _selection$2 = _slicedToArray(_selection[1], 2),
      x2 = _selection$2[0],
      y2 = _selection$2[1];
    var xStart = this.xScale.invert(x1);
    var xEnd = this.xScale.invert(x2);
    var yStart = this.yScale.invert(this.config.yAxis === 'rank' ? y1 : y2);
    var yEnd = this.yScale.invert(this.config.yAxis === 'rank' ? y2 : y1);
    var xAxisFunction = this.getXAxisFunction();
    var yAxisFunction = this.getYAxisFunction();
    rics = this.data.filter(function (d) {
      var xVal = _this3.xScale.invert(xAxisFunction(d));
      var yVal = _this3.yScale.invert(yAxisFunction(d));
      return xStart <= xVal && xVal <= xEnd && yStart <= yVal && yVal <= yEnd;
    }).map(function (d) {
      return d.ric;
    });
    this.brushElement.call(this.brush.move, null); // remove the brush
  }

  this.setSelection(rics);
};
D3ScatterPlot.prototype.highlightSettingsIcon = function () {
  var moduleHeader = $("#".concat(this.config.moduleId, " .moduleHeader"));
  if (moduleHeader) {
    if (this.selection && this.selection.length > 0) {
      moduleHeader[0].classList.add('animateSettingsIcon');
    } else {
      moduleHeader[0].classList.remove('animateSettingsIcon');
    }
  }
};
D3ScatterPlot.prototype.setSelection = function (rics) {
  this.svg.selectAll('.bubble').classed('selected', function (d) {
    return rics.indexOf(d.ric) > -1;
  });
  this.selection = rics;
  this.highlightSettingsIcon();
  if (!this.config.senderChannel || !rics.length) {
    return this;
  }
  var message = {
    senderId: this.element.id
  };
  if (rics.length === 1) {
    message.messageType = 'ric';
    message.ric = rics[0];
  } else {
    message.messageType = 'multiRic';
    message.rics = rics;
  }
  window.YAHOO.fcom.Broadcaster.sendMessage(this.config.senderChannel, message);
  return this;
};
D3ScatterPlot.prototype.drawRegressionLine = function () {
  var _this4 = this;
  if (!this.config.drawRegressionLine || this.config.xAxis === 'rank' || this.config.yAxis === 'rank') {
    return this;
  }
  var width = (this.config.width || this.element.parentNode.clientWidth) - this.margin.left - this.margin.right;
  var resolution = 20;
  var regressionLine = this.svg.select('.regression');
  if (!regressionLine.size()) {
    regressionLine = this.svg.append('polyline').attr('class', 'regression');
  }
  var average = function average(values) {
    return values.reduce(function (a, b) {
      return a + b;
    }, 0) / values.length;
  };
  var standardDeviation = function standardDeviation(values) {
    var avg = average(values);
    var squareDiffs = values.map(function (value) {
      return Math.pow(value - avg, 2);
    });
    var avgSquareDiff = average(squareDiffs);
    return Math.sqrt(avgSquareDiff);
  };
  var n = this.data.length;
  var xValues = this.data.map(function (d) {
    return d.data[_this4.config.xAxis].value;
  });
  var yValues = this.data.map(function (d) {
    return d.data[_this4.config.yAxis].value;
  });
  var averageX = average(xValues);
  var averageY = average(yValues);
  var standardDeviationX = standardDeviation(xValues);
  var standardDeviationY = standardDeviation(yValues);
  var correlationSum = xValues.reduce(function (sum, x, i) {
    return sum + x * yValues[i];
  }, 0);
  var correlation = (correlationSum - n * averageX * averageY) / ((n - 1) * standardDeviationX * standardDeviationY);
  var m = correlation * (standardDeviationX / standardDeviationY);
  var b = averageY - m * averageX;
  var yHat = function yHat(x) {
    return m * x + b;
  };
  var scaleY = function scaleY(x) {
    return Math.round(_this4.yScale(yHat(_this4.xScale.invert(x))));
  };
  var xStep = width / resolution;
  var points = new Array(resolution + 1).fill(0).map(function (_, i) {
    return i * xStep;
  }).map(function (x) {
    return "".concat(x, ",").concat(scaleY(x));
  });
  regressionLine.attr('points', points.join(' '));
  return this;
};
D3ScatterPlot.prototype.getSelection = function () {
  return this.selection || [];
};
D3ScatterPlot.prototype.getXAxisFunction = function () {
  var _this5 = this;
  var xAxisFunction = function xAxisFunction(d) {
    return _this5.xScale(d.data[_this5.config.xAxis].value);
  };
  if (this.config.xAxis === 'rank') {
    var referenceValue = this.config.yAxis === 'rank' ? 'RIC' : this.config.yAxis;
    var sortedY = this.data.map(function (d) {
      return d.data;
    }).sort(function (a, b) {
      return b[referenceValue].value - a[referenceValue].value;
    }).map(function (d) {
      return d.RIC.value;
    });
    xAxisFunction = function xAxisFunction(d) {
      return _this5.xScale(sortedY.indexOf(d.data.RIC.value) + 1);
    };
  }
  return xAxisFunction;
};
D3ScatterPlot.prototype.getYAxisFunction = function () {
  var _this6 = this;
  var yAxisFunction = function yAxisFunction(d) {
    return _this6.yScale(d.data[_this6.config.yAxis].value);
  };
  if (this.config.yAxis === 'rank') {
    var referenceValue = this.config.xAxis === 'rank' ? 'RIC' : this.config.xAxis;
    var sortedX = this.data.map(function (d) {
      return d.data;
    }).sort(function (a, b) {
      return b[referenceValue].value - a[referenceValue].value;
    }).map(function (d) {
      return d.RIC.value;
    });
    yAxisFunction = function yAxisFunction(d) {
      return _this6.yScale(sortedX.indexOf(d.data.RIC.value) + 1);
    };
  }
  return yAxisFunction;
};
D3ScatterPlot.prototype.updateYAxisMargin = function () {
  var _this7 = this;
  return new Promise(function (resolve) {
    _this7.updateYAxisDomain(_this7.data);
    var tempYAxis = _this7.svg.append('g').attr('class', 'visuallyhidden').call(_this7.yAxis.scale(_this7.yScale));
    var maxw = 0;
    tempYAxis.selectAll('text').each(function () {
      if (this.getBBox().width > maxw) maxw = this.getBBox().width;
    });
    tempYAxis.remove();
    var oldMarginLeft = _this7.margin.left;
    _this7.margin.left = 40 + Math.ceil(maxw);
    if (_this7.margin.left !== oldMarginLeft) {
      _this7.resize();
    }
    resolve();
  });
};
D3ScatterPlot.prototype.updateXAxisDomain = function () {
  var _this8 = this;
  this.xScale = this.originalXScale;
  var _ref = this.config.xAxis === 'rank' ? [1, this.data.length] : d3.extent(this.data, function (d) {
      return d.data[_this8.config.xAxis].value;
    }),
    _ref2 = _slicedToArray(_ref, 2),
    min = _ref2[0],
    max = _ref2[1];
  var step = (max - min) / 10 || 1; // if max = min, set step to 1
  var domain = [min - step, max + step]; // 10% extra at top and bottom to make space for circles with min/max value
  if (this.config.xAxis === 'rank') {
    if (domain[0] < 0) {
      domain[0] = 1;
    }
  }
  this.xScale.domain(domain).nice();
};
D3ScatterPlot.prototype.updateXAxis = function (transform) {
  this.updateXAxisDomain();
  if (transform) {
    // create new scale oject based on event
    this.xScale = transform.rescaleX(this.xScale);
  }
  var maxRange = this.xScale.range()[1];
  this.xAxisElement.transition().duration(transitionDuration).call(this.xAxis.scale(this.xScale).ticks(maxRange / 80));
  this.xAxisGridElement.transition().duration(transitionDuration).call(this.xAxisGrid.scale(this.xScale).ticks(maxRange / 80));
  this.xAxisGridElement.selectAll('.tick line').classed('zero', function (d) {
    return d === 0;
  });

  // transform ticks into a grid
  this.xAxisElement.attr('y1', -(this.config.height - this.margin.top - this.margin.bottom));
  this.xAxisLabel.text(this.getXAxisLabel());
  return this;
};
D3ScatterPlot.prototype.updateYAxisDomain = function () {
  var _this9 = this;
  this.yScale = this.originalYScale;
  var _ref3 = this.config.yAxis === 'rank' ? [this.data.length, 1] : d3.extent(this.data, function (d) {
      return d.data[_this9.config.yAxis].value;
    }),
    _ref4 = _slicedToArray(_ref3, 2),
    min = _ref4[0],
    max = _ref4[1];
  var step = (max - min) / 10 || 1; // if max = min, set step to 1
  var domain = [min - step, max + step]; // 10% extra at top and bottom to make space for circles with min/max value
  this.yScale.domain(domain).nice();
};
D3ScatterPlot.prototype.updateYAxis = function (transform) {
  this.updateYAxisDomain();
  if (transform) {
    this.yScale = transform.rescaleY(this.yScale);
  }
  this.yAxisElement.transition().duration(transitionDuration).call(this.yAxis.scale(this.yScale));
  this.yAxisGridElement.transition().duration(transitionDuration).call(this.yAxisGrid.scale(this.yScale));
  this.yAxisGridElement.selectAll('.tick line').classed('zero', function (d) {
    return d === 0;
  });

  // transform ticks into a grid
  this.yAxisElement.attr('x1', (this.config.width || this.element.parentNode.clientWidth) - this.margin.left - this.margin.right);
  this.yAxisLabel.text(this.getYAxisLabel());
  return this;
};
D3ScatterPlot.prototype.updateColorScale = function () {
  var _this10 = this;
  this.legend.selectAll('*').remove();
  var legends = {};
  var legendSeparator = ' - ';
  if (this.config.color === 'constant') {
    this.data.forEach(function (d, i) {
      d.colorIndex = 0;
    });
  } else {
    // #. Sort the data based on the selected value
    this.data = this.data.sort(function (comp1, comp2) {
      var value1 = comp1.data[_this10.config.color].value;
      var value2 = comp2.data[_this10.config.color].value;
      if (value1 < value2) {
        return -1;
      } else if (value1 > value2) {
        return 1;
      }
      return 0;
    });
    var colorIndex = 0;
    var maxGroups = 10;
    if (['REUTERS_KNOWLEDGE_RATIO_MARKETCAPITALIZATION', 'TURNOVER', 'ACVOL', 'HISTORIC_RATIO_AVGVOL_1M', 'RKD_RECOM_MEAN_CURRENT_ASBAR_SMALL'].includes(this.config.color)) {
      var dataLength = this.data.length;
      var chunkSize = Math.ceil(dataLength / maxGroups);
      this.data.forEach(function (d, i) {
        if (d.data[_this10.config.color].value) {
          d.colorIndex = i === 0 ? 0 : i % chunkSize ? colorIndex : ++colorIndex;
          var legendLabel = _this10.formatFieldValue(d.data[_this10.config.color].value, _this10.config.color);
          legends[d.colorIndex] = legends[d.colorIndex] ? d3.extent(legends[d.colorIndex].concat(legendLabel)) : [legendLabel];
        } else {
          d.colorIndex = 0;
        }
      });
    } else if (this.config.color.includes('CHANGE_PERC')) {
      legends = (0, _legendColorGrouping.colorGroupingChangePerc)(this.data, this.config.color);
      var _loop = function _loop() {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];
        if (value.length === 1) {
          // Add zero for legend with single item
          value.push(0);
        }
        legends[key] = d3.extent(value).map(function (v) {
          return (0, _formatFieldValue.default)(v, key, true);
        });
      };
      for (var _i = 0, _Object$entries = Object.entries(legends); _i < _Object$entries.length; _i++) {
        _loop();
      }
    } else if (['RELATIVE_VOLUME_INTRADAY', 'RELATIVE_VOLUME_YESTERDAY'].includes(this.config.color)) {
      var _dataLength = this.data.length;
      this.data.forEach(function (d, i) {
        var group = Math.min(Math.floor(d.data[_this10.config.color].value / 10), 10);
        d.colorIndex = 100 + group;
        var legendLabel = (group < 10 ? group * 10 + ' - ' + (group * 10 + 10) : '>100') + '%';
        legends[d.colorIndex] = legends[d.colorIndex] && !legends[d.colorIndex].includes(legendLabel) ? legends[d.colorIndex].concat(legendLabel) : [legendLabel];
      });
      legendSeparator = ' - ';
    } else if (['TRBC_ECONOMIC_SECTOR', 'TRBC_BUSINESS_SECTOR', 'COUNTRY'].includes(this.config.color)) {
      colorIndex = -1;
      var lastValue = null;
      this.data.forEach(function (d, i) {
        if (d.data[_this10.config.color].value) {
          if (lastValue !== d.data[_this10.config.color].value) {
            lastValue = d.data[_this10.config.color].value;
            colorIndex++;
          }
          d.colorIndex = colorIndex;
          if (!legends[d.colorIndex]) {
            var legendLabel = d.data[_this10.config.color].label;
            legends[d.colorIndex] = [legendLabel];
          }
        } else {
          d.colorIndex = 0;
        }
      });
    }
  }
  var innerWidth = this.getInnerWidth();
  var x = 0;
  var y = 0;
  var _loop2 = function _loop2() {
    var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
      key = _Object$entries2$_i[0],
      value = _Object$entries2$_i[1];
    var activeKey = Number(key);
    var className = _this10.filteredLegends.indexOf(activeKey) === -1 ? "legend-".concat(key) : 'legend-inactive';
    var legendItem = _this10.legend.append('g').attr('class', className).style('cursor', 'pointer').on('click', function () {
      _this10.applyLegendFilter(activeKey, legendItem);
    });
    legendItem.append('circle').attr('cx', x).attr('cy', y).attr('r', 6);
    legendItem.append('text').attr('x', x + 12).attr('y', y).text(value.join(legendSeparator)).attr('dy', '0.35em');
    var legendItemWidth = legendItem.node().getBBox().width;
    x += legendItemWidth + 10;
    if (x / innerWidth >= 1) {
      // Switch to next row
      x = legendItemWidth + 10;
      y += 20;
      legendItem.select('circle').attr('cx', 0).attr('cy', y);
      legendItem.select('text').attr('x', 12).attr('y', y);
    }
  };
  for (var _i2 = 0, _Object$entries2 = Object.entries(legends); _i2 < _Object$entries2.length; _i2++) {
    _loop2();
  }
  y = x ? y + 20 : y;
  if (this.margin.bottom !== 40 + y) {
    this.margin.bottom = 40 + y;
    this.resize();
  }
  return this;
};
D3ScatterPlot.prototype.applyLegendFilter = function (activeKey, legendItem) {
  var index = this.filteredLegends.indexOf(activeKey);
  var className = "legend-".concat(activeKey);
  // #. Check filter already applied or not
  if (index === -1) {
    this.filteredLegends.push(activeKey);
    className = 'legend-inactive';
  } else {
    this.filteredLegends.splice(index, 1);
  }
  // #. Assign the new classes
  legendItem.attr('class', className);
  if (!this.originalData) {
    this.originalData = (0, _lodash.cloneDeep)(this.data);
  }
  this.setOriginalData();
  this.render(true, true);
};
D3ScatterPlot.prototype.setOriginalData = function () {
  if (this.originalData) {
    this.data = (0, _lodash.cloneDeep)(this.originalData);
  }
};
D3ScatterPlot.prototype.clearLegendFilter = function () {
  this.filteredLegends = [];
  var $allBubbles = this.svg.selectAll('.bubble');
  // #. Make all bubble visible
  $allBubbles.style('display', '');
  // #. Clear cloned data
  this.originalData = null;
};
D3ScatterPlot.prototype.getDisplayFids = function () {
  var _this11 = this;
  var displayRics = [this.config.xAxis, this.config.yAxis, this.config.size, this.config.color].filter(function (f) {
    return _this11.fieldConfig[f];
  }).filter(function (f) {
    return f !== 'rank';
  });
  return displayRics.filter(function (f, i, array) {
    return array.indexOf(f) === i;
  });
};
D3ScatterPlot.prototype.getTabindexFunction = function () {
  var referenceValue = this.config.xAxis === 'rank' ? 'RIC' : this.config.xAxis;
  var sortedX = this.data.map(function (d) {
    return d.data;
  }).sort(function (a, b) {
    return a[referenceValue].value - b[referenceValue].value;
  }).map(function (d) {
    return d.RIC.value;
  });
  var tabIndexScale = d3.scaleLinear().domain([0, sortedX.length - 1]).range([1, sortedX.length]);
  return function (d) {
    return tabIndexScale(sortedX.indexOf(d.data.RIC.value));
  };
};
D3ScatterPlot.prototype.resize = function () {
  var forceRerender = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var innerWidth = this.getInnerWidth();
  var innerHeight = this.config.height - this.margin.top - this.margin.bottom;
  var maxRadius = Math.max(12, Math.min(innerWidth / 20, innerHeight / 20, 60));
  var minRadius = maxRadius / 4;
  d3.select(this.element).select('svg').transition().duration(transitionDuration).attr('width', innerWidth + this.margin.left + this.margin.right).attr('height', innerHeight + this.margin.top + this.margin.bottom);
  this.svg.transition().duration(transitionDuration).attr('transform', "translate(".concat(this.margin.left, ", ").concat(this.margin.top, ")"));
  this.xAxisElement.attr('transform', "translate(0, ".concat(innerHeight, ")"));
  this.xAxisGridElement.attr('transform', "translate(0, ".concat(innerHeight, ")"));
  this.svg.select('.xAxisLabel').transition().duration(transitionDuration).attr('transform', "translate(".concat(innerWidth / 2, ", ").concat(innerHeight + this.margin.top + 25, ")"));
  this.svg.select('.yAxisLabel').transition().duration(transitionDuration).attr('transform', "translate(".concat(20 - this.margin.left, ", ").concat(innerHeight / 2, ") rotate(-90)"));
  this.xAxisGrid.tickSize(-innerHeight);
  this.originalXScale.range([0, innerWidth]);
  this.yAxisGrid.tickSize(-innerWidth);
  this.originalYScale.range([innerHeight, 0]);
  this.radius.range([minRadius, maxRadius]);
  this.brush.extent([[0, 0], [innerWidth, innerHeight]]);
  this.brushElement.call(this.brush);
  this.clipPath.attr('width', innerWidth).attr('height', innerHeight);
  this.legend.transition().duration(transitionDuration).attr('transform', "translate(20, ".concat(innerHeight + this.margin.top + 40, ")"));
  this.handles.attr('style', "bottom: ".concat(this.margin.bottom + 18, "px"));
  if (forceRerender) {
    this.render(true);
  }
  return this;
};
D3ScatterPlot.prototype.toggleError = function (showError, errorText) {
  var chartElements = this.element.children;
  var errorElm = this.element.querySelector('.hint');
  Array.from(chartElements).forEach(function (elm) {
    elm.style.display = showError ? 'none' : 'block';
  });
  if (showError) {
    errorElm.innerHTML = errorText;
    errorElm.style.display = 'block';
  } else {
    errorElm.style.display = 'none';
  }
};
D3ScatterPlot.prototype.render = function (resetZoom) {
  var _this12 = this;
  var keepLegendFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!keepLegendFilter) {
    // #. Clear the legend filter
    this.clearLegendFilter();
    // #. Clear filtered data
    this.setOriginalData();
  }
  var validData = this.data.filter(function (item) {
    return (_this12.config.xAxis === 'rank' || item.data[_this12.config.xAxis].value) && (_this12.config.yAxis === 'rank' || item.data[_this12.config.yAxis].value);
  });
  var errorText = window.getMessage('module.InstrumentListHeatmapModule.error.noFilteredData');
  this.toggleError(!validData.length, errorText);
  if (!validData.length) {
    return;
  }
  this.isRendering = true;
  var renderCallback = function renderCallback() {
    var xAxisFunction, yAxisFunction, sizeFunction, bubbleClassFunction, tabindexFunction, newBubbles, bubbles;
    return _regeneratorRuntime().async(function renderCallback$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return _regeneratorRuntime().awrap(_this12.updateYAxisMargin());
        case 2:
          _this12.updateColorScale();
          if (_this12.filteredLegends) {
            _this12.data = _this12.data.filter(function (item) {
              return _this12.filteredLegends.indexOf(item.colorIndex) === -1;
            });
            _this12.setDrawLabels();
          }
          xAxisFunction = _this12.getXAxisFunction();
          yAxisFunction = _this12.getYAxisFunction();
          sizeFunction = function sizeFunction(d) {
            return _this12.radius(_this12.config.size === 'equal' ? 1 : d.data[_this12.config.size].value || 0);
          };
          bubbleClassFunction = function bubbleClassFunction(d) {
            return "bubble-color_".concat(d.colorIndex);
          };
          tabindexFunction = _this12.getTabindexFunction();
          _this12.updateXAxis().updateYAxis().drawRegressionLine();
          _this12.radius.domain(_this12.config.size === 'equal' ? [0, 2] : d3.extent(_this12.data, function (d) {
            return Number(d.data[_this12.config.size].value || 0);
          }));
          newBubbles = null;
          if (_this12.reRenderBubbles) {
            bubbles = _this12.bubbles.selectAll('.bubble').data(_this12.data, function (d) {
              return d.ric;
            }); // identify items by ric
            bubbles.order();
            bubbles.exit().remove();
            newBubbles = bubbles.enter().append('g').attr('class', 'bubble').attr('data-tabindex', tabindexFunction);
            newBubbles.append('circle');
          }
          _this12.bubbles.selectAll('circle').data(_this12.data, function (d) {
            return d.ric;
          }).on('mouseover focus', function (_, d) {
            var ticker = window.getMessage('chart.label.ticker');
            var tooltipRows = _this12.getDisplayFids().map(function (fid) {
              return "".concat(_this12.fieldConfig[fid].label, ": ").concat(d.data[fid].label);
            });
            _this12.tooltip.attr('data-tooltip-border-color', d.colorIndex).html("<div><span class=\"visuallyhidden\">Chart Tooltip</span>".concat(d.name, " (").concat(d.ric, ")<br/>").concat(tooltipRows.join('<br/>'), "<br/><span>").concat(ticker, ": ").concat(d.ticker || '', "</span><br/></div><div class=\"d3-tooltip-ptr\"></div>"));
            var container = {
              w: _this12.config.width || _this12.element.parentNode.clientWidth,
              h: _this12.config.height
            };
            var radius = sizeFunction(d);
            var element = {
              x: _this12.margin.left + xAxisFunction(d) - radius - 3,
              y: _this12.margin.top + yAxisFunction(d) - radius - 2,
              w: radius * 2,
              h: radius * 2
            };
            (0, _positionTooltip.default)(_this12.tooltip, container, element);
          }).on('mouseout focusout', function () {
            _this12.tooltip.transition().duration(transitionDuration).duration(500).style('opacity', '0');
          }).on('click', function (_, d) {
            _this12.setSelection([d.ric]);
          }).on('keyup', function (event, d) {
            var keyCode = event.keyCode;
            if (keyCode === 13) {
              _this12.setSelection([d.ric]);
            }
          }).attr('class', bubbleClassFunction).transition().duration(transitionDuration).attr('cx', xAxisFunction).attr('cy', yAxisFunction).attr('r', sizeFunction).attr('tabindex', -1).attr('aria-labelledby', _this12.tooltip.attr('id')).on('end', (0, _lodash.debounce)(function () {
            _this12.isRendering = false;
          }, 150));
          if (newBubbles) {
            newBubbles.append('text').attr('alignment-baseline', 'middle').attr('text-anchor', 'middle').attr('x', xAxisFunction).attr('y', function (d) {
              return yAxisFunction(d) + 1;
            });
          }
          _this12.bubbles.selectAll('text').text(function (d) {
            return d.ticker;
          }).transition().duration(transitionDuration).attr('x', xAxisFunction).attr('y', function (d) {
            return yAxisFunction(d) + 1;
          });
          if (_this12.config.drawLabels) {
            // #. Hide overlapped labels
            _this12.debounceOverlappedLabels();
          } else {
            _this12.hideAllLabels();
          }

          // #. Align the legend to center
          _this12.alignLegendToCenter();
        case 18:
        case "end":
          return _context.stop();
      }
    }, null, null, null, Promise);
  };
  if (resetZoom) {
    this.resetZoom(renderCallback);
  } else {
    renderCallback();
  }
  return this;
};
D3ScatterPlot.prototype.alignLegendToCenter = function () {
  var _this13 = this;
  window.setTimeout(function () {
    var legendBB = _this13.legend.node().getBBox();
    var innerWidth = _this13.getInnerWidth();
    var xPos = (innerWidth - legendBB.width) / 2;
    var topPosition = _this13.svg.select('.xAxisLabel').attr('transform').match(/(-?[0-9\.]+)/g).map(Number);
    _this13.legend.transition().duration(10).attr('transform', "translate(".concat(xPos, ", ").concat(topPosition[1] + 15, ")"));
  }, transitionDuration + 50);
};
D3ScatterPlot.prototype.debounceOverlappedLabels = function () {
  var _this14 = this;
  if (this.lid) {
    clearTimeout(this.lid);
  }
  this.lid = setTimeout(function () {
    _this14.bubbles.selectAll('text').style('display', '');
    _this14.hideOverlappedLabels();
  }, 500);
};
D3ScatterPlot.prototype.hideAllLabels = function () {
  this.bubbles.selectAll('text').style('display', 'none');
};
D3ScatterPlot.prototype.hideOverlappedLabels = function () {
  var allLabels = this.bubbles.selectAll('text');
  // #. Function to check whether two bounding boxes overlap
  // #. Cycle through overlapped labels and hide them
  var processedLabels = [];
  allLabels.each(function (d, i) {
    if (processedLabels.indexOf(this.textContent) !== -1) {
      return true;
    }
    // #. Get bounding box
    var activeLabel = this.getBoundingClientRect();

    // #. Iterate through each box to see if it overlaps with any following
    // #. If they do, hide them
    // #. And only get labels later in the order than this one
    setTimeout(function () {
      allLabels.filter(function (k, j) {
        return j < i;
      }).each(function (d) {
        var parentBubble = this.parentElement.getBBox();
        var nextLabel = this.getBoundingClientRect();
        // #. If not overlapping with a subsequent item, and isn't meant to be shown always, hide it
        if (Math.abs(activeLabel.left - nextLabel.left) * 2 < activeLabel.width + nextLabel.width && Math.abs(activeLabel.top - nextLabel.top) * 2 < activeLabel.height + nextLabel.height && parentBubble.width < 32) {
          processedLabels.push(this.textContent);
          // #. Animate the label hide
          window.d3.select(this).style('display', 'none');
        }
      });
    }, 10);
  });
};
var _default = exports.default = D3ScatterPlot;

},{"./formatFieldValue.inc":24,"./legendColorGrouping.inc":25,"lodash":192,"util/d3/positionTooltip":137}],23:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _D3ScatterPlot = _interopRequireDefault(require("modules/DynamicScatterPlotModule/D3ScatterPlot"));
var _transformHeatmapData2 = _interopRequireDefault(require("util/d3/transformHeatmapData"));
var _resizeMenuItems = require("util/resizeMenuItems");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var DynamicScatterPlotModule = function DynamicScatterPlotModule(containerNode, config, themeConfig) {
  this.element = containerNode;
  this.config = config;
  this.moduleId = containerNode.id;
  config.colorRangeRel = themeConfig.colorRangeRel;
  config.colorRangeAbs = themeConfig.colorRangeAbs;
  config.colorRangeVola = themeConfig.colorRangeVola;
  config.colorRangeFund = themeConfig.colorRangeFund;
  config.moduleId = containerNode.id;
  this.chart = new _D3ScatterPlot.default($("#".concat(this.moduleId, "_container")).get(0), config);
  this.enableKeyboardNavigation("".concat(this.moduleId, "_container"));
};
DynamicScatterPlotModule.prototype.getConfig = function () {
  return this.config;
};
DynamicScatterPlotModule.prototype.setConfig = function (config) {
  this.config = config;
  this.chart.setConfig(config);
  return this;
};
DynamicScatterPlotModule.prototype.getSelectedInstruments = function () {
  return this.chart.getSelection();
};
DynamicScatterPlotModule.prototype.loadData = function () {
  var _this = this;
  var resetZoom = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var ric = this.getConfig().ric;
  var watchlistId = this.getConfig().watchlistId;
  var portfolioId = this.getConfig().portfolioId;
  var ricList = this.getConfig().ricList;
  var moduleType = 'scatter';
  (0, _resizeMenuItems.resizeMenuItems)(this.element);
  return window.ajaxGetJson('/constituents.action', {
    method: 'getHeatmapData',
    moduleType: moduleType,
    portfolioId: portfolioId,
    watchlistId: watchlistId,
    ric: ric,
    ricList: ricList
  }).then(function (heatmapData) {
    var _transformHeatmapData = (0, _transformHeatmapData2.default)(heatmapData),
      data = _transformHeatmapData.data,
      fields = _transformHeatmapData.fields;
    var errorText = window.getMessage('module.InstrumentListHeatmapModule.error.noItems');
    _this.chart.toggleError(!data.length, errorText);
    if (!data.length) {
      return;
    }
    fields.rank = {
      relative: false,
      label: window.getMessage('module.dialog.DynamicHeatmapModule.indicator.rank')
    };
    _this.chart.setData(data).setFields(fields).render(resetZoom);
    return heatmapData.indexName || ric;
  }).then(function (title) {
    // update title
    if (!_this.config.hasFixedTitle) {
      $("#".concat(_this.moduleId, " .moduleHeader .title .content")).html(title);
    }
    // add broadcast links
    if (_this.senderChannel) {
      window.YAHOO.fcom.Broadcaster.initBroadcastLinks(_this.senderChannel, _this.moduleId);
    }
  }).catch(function (err) {
    $("#".concat(_this.moduleId, " .moduleHeader .title .content")).html(ric);
    _this.chart.setData([]);
    _this.chart.showMessage(window.getMessage('module.DynamicScatterPlotModule.error'));
  });
};
DynamicScatterPlotModule.prototype.updateSettings = function (resetZoom) {
  this.chart.render(resetZoom);
};
DynamicScatterPlotModule.prototype.enableKeyboardNavigation = function (containerId) {
  $("#".concat(containerId)).on('keyup', function (e) {
    var activeIndex = null;
    var nextIndex = null;
    var activeElement = document.activeElement;
    if (activeElement && activeElement.nodeName == 'circle') {
      $(activeElement).trigger('mouseout');
      var tabIndex = activeElement.parentNode.getAttribute('data-tabindex');
      activeIndex = +tabIndex;
    }
    if (e.keyCode == 37) {
      if (activeIndex) {
        nextIndex = activeIndex - 1;
      }
    } else if (e.keyCode == 39) {
      if (activeIndex) {
        nextIndex = activeIndex + 1;
      } else {
        nextIndex = 1;
      }
    }
    if (nextIndex) {
      var nextElem = $("#".concat(containerId, " g.bubble[data-tabindex=\"").concat(nextIndex, "\"]"));
      if (nextElem.length) {
        nextElem.find('circle').trigger('focus');
      }
    }
  });
};
DynamicScatterPlotModule.prototype['@resize'] = function () {
  (0, _resizeMenuItems.resizeMenuItems)(this.element);
  this.chart.resize(true);
};
var _default = exports.default = DynamicScatterPlotModule;

},{"modules/DynamicScatterPlotModule/D3ScatterPlot":22,"util/d3/transformHeatmapData":138,"util/resizeMenuItems":147}],24:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = function _default(value, field, isRelative) {
  var postfix = isRelative ? '%' : '';
  switch (field) {
    case 'REUTERS_KNOWLEDGE_RATIO_MARKETCAPITALIZATION':
    case 'REUTERS_KNOWLEDGE_RATIO_EBIT':
    case 'COMPANY_TOTAL_REVENUE':
      value *= 1000000;
      break;
    default:
      if (!Number.isNaN(Number(value))) value = Number(value);
  }
  return window.YAHOO.fcom.Format.formatNumber(value, {
    minFractionDigits: 0,
    maxFractionDigits: 2,
    maxSignificants: null,
    mio: true,
    showPlusSign: isRelative
  }) + postfix;
};

},{}],25:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colorGroupingChangePerc = void 0;
var colorGroupingChangePerc = exports.colorGroupingChangePerc = function colorGroupingChangePerc(data, key) {
  var legends = {};
  var colorIndex = 0;
  var maxGroups = 10;
  var minusData = data.filter(function (d) {
    return d.data[key].value < 0;
  });
  var plusData = data.filter(function (d) {
    return d.data[key].value >= 0;
  });
  var minusGroupsCount = Math.round(minusData.length / data.length * maxGroups);
  var plusGroupsCount = Math.max(plusData.length ? 1 : 0, maxGroups - minusGroupsCount);
  var minusChunkSize = Math.ceil(minusData.length / minusGroupsCount);
  var plusChunkSize = Math.ceil(plusData.length / plusGroupsCount);
  var minusStep = Math.round(maxGroups / minusGroupsCount);
  var plusStep = Math.round(maxGroups / plusGroupsCount);
  var maxColorIndex = maxGroups - 1;
  var minPlusChunkSize = plusData.length % plusChunkSize;
  var isNegative = true;
  data.forEach(function (d, i) {
    if (d.data[key].value >= 0 && isNegative) {
      colorIndex = 0;
      isNegative = false;
    }
    var actualIndex = isNegative ? i : i - minusData.length;
    var step = isNegative ? minusStep : plusStep;
    // Show group with least items at first for positives
    var chunkSize = isNegative ? minusChunkSize : actualIndex < minPlusChunkSize ? minPlusChunkSize : plusChunkSize;
    if (!isNegative && minPlusChunkSize && actualIndex >= minPlusChunkSize) {
      actualIndex += chunkSize - minPlusChunkSize;
    }
    d.colorIndex = (isNegative ? 200 : 300) + (actualIndex == 0 ? 0 : actualIndex % chunkSize ? colorIndex : colorIndex = Math.min(step + colorIndex, maxColorIndex));
    var legendLabel = d.data[key].value;
    legends[d.colorIndex] = legends[d.colorIndex] ? legends[d.colorIndex].concat(legendLabel) : [legendLabel];
  });
  return legends;
};

},{}],26:[function(require,module,exports){
"use strict";

var _DynamicWorldmap = _interopRequireDefault(require("modules/DynamicWorldmapModule/DynamicWorldmap"));
var _countryIsoConverter = require("modules/DynamicWorldmapModule/countryIsoConverter");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
window.fcom.moduleHandler.registerModuleType('DynamicWorldmapModule', function (node, config, themeConfig) {
  config.theme = themeConfig;
  if (config.senderChannel) {
    config.onCountryClick = function (country) {
      window.YAHOO.fcom.Broadcaster.sendMessage(config.senderChannel, {
        senderId: node.id,
        messageType: 'country',
        country: country
      });
    };
  }
  var moduleInstance = new _DynamicWorldmap.default(node, config);
  var heatmapDataPromise = null;
  var getHeatmapData = function getHeatmapData() {
    if (!heatmapDataPromise) {
      heatmapDataPromise = window.ajaxGetJson('/dynamicWorldmap.action?method=getWorldmapData');
    }
    return heatmapDataPromise;
  };
  var updateWorldmapData = function updateWorldmapData() {
    var value = window.YAHOO.util.Dom.get("".concat(node.id, "_valueMenu")).value;
    getHeatmapData().then(function (data) {
      var dataIndex = data.fields.findIndex(function (f) {
        return f.id === value;
      });
      var scaleType = data.fields[dataIndex].relative ? 'rel' : 'abs';
      var colorScale = data.fields[dataIndex].colorScale;
      var countryData = Object.keys(data.values).reduce(function (all, countryCode) {
        // NGPII-25315 - in case of Chinese users, data shown for Taiwan and Hong Kong should be that of China
        var replacedCountryCode = window.user.isChinaSpecificUser && (countryCode === 'TW' || countryCode === 'HK') ? 'CN' : countryCode;
        all[(0, _countryIsoConverter.convertCountry)(countryCode)] = {
          value: data.values[replacedCountryCode][dataIndex],
          display: data.display[replacedCountryCode][dataIndex],
          name: data.values[replacedCountryCode][0],
          index: data.indexAndISINDetails[replacedCountryCode].indexName || null,
          isin: data.indexAndISINDetails[replacedCountryCode].indexISIN || null
        };
        return all;
      }, {});
      moduleInstance.setColorScale(scaleType, colorScale);
      moduleInstance.setCountryValues(countryData, data.fields[dataIndex].label);
    });
  };
  updateWorldmapData();
  var updateSelectedCountryWorldmapData = function updateSelectedCountryWorldmapData(countryCode) {
    moduleInstance.updateSelectedCountry(countryCode);
  };
  var countryMenu = "".concat(node.id, "_countryMenu");
  window.YAHOO.fcom.Page.onInstanceReady(countryMenu, function () {
    var oldNames = window.YAHOO.fcom.Page.getInstance(countryMenu).valueField;
    var countrySelect = window.YAHOO.fcom.Page.getInstance(countryMenu);
    var countrySelectVals = moduleInstance.getCountryValuesForSelect();
    //for translations:
    var mixedCountrySelectVals = moduleInstance.mixCountrySelects(oldNames, countrySelectVals);
    mixedCountrySelectVals.unshift({
      'value': '',
      'text': window.getMessage('worldmap.chart.control.CountrySearch')
    });
    countrySelect.replaceItems(mixedCountrySelectVals);
    countrySelect.selectByValue(config.country);
    window.setTimeout(function () {
      $("#".concat(node.id, "_countryMenu")).trigger('change');
    }, 0);
  });
  $("#".concat(node.id, "_valueMenu")).change(updateWorldmapData);
  $("#".concat(node.id, "_countryMenu")).change(function () {
    var countryCode = $("#".concat(node.id, "_countryMenu")).val(); //convertCountry();
    if (countryCode !== '') {
      updateSelectedCountryWorldmapData(countryCode);
    } else {
      moduleInstance.selectCountry(null);
      moduleInstance.resetZoom();
    }
  });

  // init receiver channel behaviour
  if (config.receiverChannel) {
    moduleInstance['@broadcast'] = _defineProperty({}, config.receiverChannel, function (message) {
      if (message.messageType === 'country') {
        updateSelectedCountryWorldmapData((0, _countryIsoConverter.convertCountry)(message.country));
      }
    });
  }
  return moduleInstance;
});

},{"modules/DynamicWorldmapModule/DynamicWorldmap":27,"modules/DynamicWorldmapModule/countryIsoConverter":28}],27:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _worldGeo = _interopRequireDefault(require("geojson/world.geo.json"));
var _geographicRegions = require("modules/DynamicWorldmapModule/geographicRegions");
var _countryIsoConverter = require("modules/DynamicWorldmapModule/countryIsoConverter");
var _redirect = _interopRequireDefault(require("core/redirect"));
var _quartileRange3 = _interopRequireDefault(require("util/functions/quartileRange"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
// List of countries to ignore
var ignoreCountriesForWorldMap = ['ATA']; // remove antarctica
var ignoreCountriesForDetails = ['ATF', 'XXX']; // remove unknown countries
var ignoreCountriesForZoom = []; // remove unknown countries

var scaleExtent = [1, 10];
var moveStep = 25;
var zoomStep = 0.25;
var worldGeoFeatures = _worldGeo.default.features.filter(function (f) {
  return ignoreCountriesForWorldMap.indexOf(f.properties.id) === -1;
});
var nonIndexKpis = ['GS_ISIN', 'DOMAIN_NAME_LONG', 'Population', 'Unemployment', 'GDP Growth', 'Inflation', 'Interest Rates'];
var DynamicWorldmap = function DynamicWorldmap(node, config) {
  this.node = node;
  this.mapContainer = $(this.node).find('.dynamicworldmapmodule').get(0);
  this.moduleWidth = $(this.mapContainer).width();
  this.moduleHeight = config.height;
  this.config = config;
  this.selectedCountry = null;
  this.init();
  this.setDisplayRegions(['Europe', 'America', 'Africa', 'Oceania', 'Asia', 'EastCentralEurope', 'NorthEurope', 'SouthEastEurope', 'SouthEurope', 'WestEurope']);
  this.setCountryValues({});
};
var redirectToCountryDetail = function redirectToCountryDetail(country) {
  (0, _redirect.default)('/countries/countryView.html', {
    country: (0, _countryIsoConverter.convertCountry)(country)
  });
};
var redirectToIndexOverviewPage = function redirectToIndexOverviewPage(isin) {
  (0, _redirect.default)('/detail/detailPage.html', {
    isin: isin
  });
};
DynamicWorldmap.prototype.setColorScale = function (scaleType, colorType) {
  var _this2 = this;
  this.scaleType = scaleType || this.scaleType || 'abs'; // default is abs and will only be changed when a param is passed
  this.colorType = colorType || scaleType || this.colorType || 'abs'; // use scaleType for colors if colorType is not given

  var values = Object.keys(this.countryValueMap).map(function (a) {
    return _this2.countryValueMap[a].value;
  }).filter(function (f) {
    return f != null;
  });
  var _quartileRange = (0, _quartileRange3.default)(values),
    _quartileRange2 = _slicedToArray(_quartileRange, 2),
    lowerBound = _quartileRange2[0],
    upperBound = _quartileRange2[1];
  var domain = this.colorType === 'abs' ? [lowerBound < 0 ? 0 : lowerBound, upperBound] : [lowerBound, 0, upperBound];
  var range = this.colorType === 'rel' ? this.config.theme.colorRangeRel : this.config.theme.colorRangeAbs;
  this.colorScale = d3.scaleLinear().domain(domain).range(range).clamp(true).nice();
  this.updateLegend();
};
DynamicWorldmap.prototype.getColorScale = function () {
  return this.colorScale;
};
DynamicWorldmap.prototype.setDisplayCountries = function (displayCountries) {
  this.displayCountries = displayCountries.filter(function (f) {
    return ignoreCountriesForDetails.indexOf(f) === -1;
  });
  this.updateCustomGeoFeatures();
  this.updateProjection();
};
DynamicWorldmap.prototype.resize = function () {
  this.moduleWidth = $(this.mapContainer).width();
  this.svg.attr('width', this.moduleWidth);
  this.updateProjection();
  this.updateLegend();
  this.refresh();
};
DynamicWorldmap.prototype.refresh = function () {
  this.drawGraticule();
  this.drawContinents();
  this.drawCountriesWithoutData();
  this.drawCountries();
  this.updateSelectedCountry(this.selectedCountry);
};
DynamicWorldmap.prototype.setCountryValues = function (valueMap, valueLabel) {
  this.countryValueMap = valueMap;
  this.valueLabel = valueLabel || 'Value';
  this.setColorScale(); // update the color scale for new values
  this.refresh();
};
DynamicWorldmap.prototype.setDisplayRegions = function (displayRegions) {
  this.setDisplayCountries(displayRegions.map(function (region) {
    return (0, _geographicRegions.getCountriesByRegion)(region);
  }).reduce(function (all, a) {
    return all.concat(a);
  }, []));
};
DynamicWorldmap.prototype.updateCustomGeoFeatures = function () {
  var _this3 = this;
  this.customGeoFeatures = worldGeoFeatures.filter(function (f) {
    return _this3.displayCountries.indexOf(f.properties.id) > -1;
  });
};
DynamicWorldmap.prototype.formatNumber = function (number) {
  return isNaN(number) ? '' : window.YAHOO.fcom.Format.formatNumber(number, {
    minFractionDigits: 0,
    maxFractionDigits: 2,
    mio: true
  }) + (this.scaleType === 'rel' ? '%' : '');
};
DynamicWorldmap.prototype.updateLegend = function () {
  var _this4 = this;
  if (this.config.disableLegend) {
    return;
  }
  var targetItemWidth = 50;
  var targetTicks = 10;
  var legend = d3.select(this.mapContainer).select('.dynamicworldmap-legend-items').style('width', 'auto'); // reset width before measuring
  var legendWidth = $(legend.node()).width();
  var tickNumber = Math.min(targetTicks, Math.floor(legendWidth / targetItemWidth));
  var ticks = this.colorScale.ticks(tickNumber);
  var itemWidth = Math.floor(legendWidth / ticks.length);
  legend.style('width', "".concat(itemWidth * ticks.length, "px")); // restore a proper width

  // update legend data
  var legendItems = legend.select('ul').style('width', "".concat(itemWidth * ticks.length, "px")).selectAll('li');
  legendItems.data(ticks).exit().remove();
  legendItems.data(ticks).enter().append('li').merge(legendItems).text(function (d) {
    return _this4.formatNumber(d);
  }).classed('invert-colors', function (d) {
    return d3.lab(_this4.colorScale(d)).l < 60;
  }).style('width', "".concat(itemWidth, "px")).style('background', this.colorScale);
};
DynamicWorldmap.prototype.getProjection = function () {
  // Miller projection
  return d3.geoProjection(function (lambda, phi) {
    var quarterPi = Math.PI / 4;
    return [lambda, 1.25 * Math.log(Math.tan(quarterPi + 0.4 * phi))];
  });
};
DynamicWorldmap.prototype.updateProjection = function () {
  var featureCollection = {
    type: 'FeatureCollection',
    features: this.customGeoFeatures
  };
  featureCollection.features = featureCollection.features.filter(function (f) {
    return ignoreCountriesForZoom.indexOf(f.properties.id) === -1;
  });
  var width = this.moduleWidth;
  var height = this.moduleHeight;
  var projection = this.getProjection();
  projection.fitSize([width, height || Math.max(width * 0.75, 200)], featureCollection); // width * factor is maximum height

  this.pathProjector = d3.geoPath().projection(projection);
  if (!height) {
    var _this$pathProjector$b = this.pathProjector.bounds(featureCollection),
      _this$pathProjector$b2 = _slicedToArray(_this$pathProjector$b, 2),
      _this$pathProjector$b3 = _slicedToArray(_this$pathProjector$b2[0], 2),
      y1 = _this$pathProjector$b3[1],
      _this$pathProjector$b4 = _slicedToArray(_this$pathProjector$b2[1], 2),
      y2 = _this$pathProjector$b4[1];
    height = Math.ceil(y2 - y1);

    // update svg height to fit new projection
    this.svg.attr('height', Math.max(height, 200));
  }
  projection.fitSize([width, height], featureCollection);
  try {
    // try to update column layout
    window.YAHOO.fcom.Page.getInstance('moduleContainer').correctMultiColElements();
  } catch (e) {
    // do nothing
  }
};
DynamicWorldmap.prototype.getCustomGeoFeatures = function () {
  return this.customGeoFeatures;
};
var transformPointCoordinates = function transformPointCoordinates(_ref, transform) {
  var _ref2 = _slicedToArray(_ref, 2),
    x = _ref2[0],
    y = _ref2[1];
  return [transform.x + x * transform.k, transform.y + y * transform.k];
};
var clamp = function clamp(min, val, max) {
  return Math.max(min, Math.min(max, val));
};
var positionTooltipOnPoint = function positionTooltipOnPoint(tooltip, point, _ref3) {
  var _ref4 = _slicedToArray(_ref3, 2),
    containerWidth = _ref4[0],
    containerHeight = _ref4[1];
  // TODO: this method needs to be simplified (maybe by calculating a vector between the point and tooltip and comparing angles?)
  var width = $(tooltip.node()).width();
  var height = $(tooltip.node()).height();
  var _point = _slicedToArray(point, 2),
    x = _point[0],
    y = _point[1];
  var arrowSize = 6;
  var spaceSize = 4;
  var borderDistance = arrowSize + spaceSize;
  var posTop = [x - width / 2, y - height - arrowSize];
  var posBottom = [x - width / 2, y + arrowSize];
  var posLeft = [x - width - arrowSize, y - height / 2];
  var posRight = [x + arrowSize, y - height / 2];
  var left;
  var top;
  var positionClass = '';
  var checkIsValidPosition = function checkIsValidPosition(_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
      posX = _ref6[0],
      posY = _ref6[1];
    return posX > spaceSize && posY > spaceSize && posX < containerWidth - width - spaceSize && posY < containerHeight - height - spaceSize;
  };
  var hasValidPosition = checkIsValidPosition(posTop) && checkIsValidPosition(posRight) && checkIsValidPosition(posBottom) && checkIsValidPosition(posLeft);
  if (!hasValidPosition) {
    posTop[1] = clamp(borderDistance, posTop[1], containerHeight - height - borderDistance);
    posBottom[1] = clamp(borderDistance, posBottom[1], containerHeight - height - borderDistance);
    posLeft[0] = clamp(borderDistance, posLeft[0], containerWidth - width - borderDistance);
    posRight[0] = clamp(borderDistance, posRight[0], containerWidth - width - borderDistance);
  }

  // These are in prefered order
  if (checkIsValidPosition(posTop) && (hasValidPosition || posTop[1] > borderDistance)) {
    // Top
    left = posTop[0];
    top = posTop[1];
    positionClass = 'top';
  } else if (checkIsValidPosition(posRight) && (hasValidPosition || posRight[0] < containerWidth - width - borderDistance)) {
    // Right
    left = posRight[0];
    top = posRight[1];
    positionClass = 'right';
  } else if (checkIsValidPosition(posBottom)) {
    // Bottom
    left = posBottom[0];
    top = posBottom[1];
    positionClass = 'bottom';
  } else if (checkIsValidPosition(posLeft)) {
    // Left
    left = posLeft[0];
    top = posLeft[1];
    positionClass = 'left';
  } else {
    // Closest Corner Mode (no arrow)
    left = clamp(borderDistance, x, containerWidth - width - borderDistance);
    top = clamp(borderDistance, y, containerHeight - height - borderDistance);
  }
  var arrowPosition = function () {
    switch (positionClass) {
      case 'top':
        return [Math.floor(width / 2 - arrowSize / 2), height + 1];
      case 'right':
        return [-(arrowSize * 2 + 1), Math.floor(height / 2 - arrowSize)];
      case 'bottom':
        return [Math.floor(width / 2 - arrowSize), -(arrowSize * 2 + 1)];
      case 'left':
        return [width + 1, Math.floor(height / 2 - arrowSize)];
      default:
        return null;
    }
  }();

  // please insert magic here
  tooltip.transition().duration(200).attr('class', "d3-tooltip d3-tooltip-".concat(positionClass)).style('left', "".concat(left, "px")).style('top', "".concat(top, "px")).style('opacity', '0.9');
  if (arrowPosition) {
    // position the pointer correctly
    tooltip.select('.d3-tooltip-ptr').style('left', "".concat(arrowPosition[0], "px")).style('top', "".concat(arrowPosition[1], "px"));
  }
};

// NGPII-25327 - for Chinese users flags should not be displayed
var getFlag = function getFlag(countryCode) {
  return window.user.isChinaSpecificUser ? '' : "<span class=\"country flag ".concat((0, _countryIsoConverter.convertCountry)(countryCode), "\" name=\"flag\"></span>");
};
DynamicWorldmap.prototype.selectCountry = function (country) {
  this.selectedCountry = country;
  this.selectedItem.attr('d', '');
  this.selectedItem.attr('d', $(this.node).find("[data-country=\"".concat(country, "\"]")).attr('d'));
  $(this.node).find('.dynamicworldmap-detailpage').toggleClass('hidden', !this.selectedCountry).attr('tabindex', this.selectedCountry ? 0 : -1);
};
DynamicWorldmap.prototype.updateSelectedCountry = function (country) {
  var countryFeature = this.getCustomGeoFeatures().filter(function (d) {
    return d.properties.id === country;
  })[0];
  if (countryFeature) {
    this.translateToFeature(countryFeature);
  }
  this.selectCountry(country);
};
DynamicWorldmap.prototype.drawCountries = function () {
  var _this5 = this;
  var _this = this;
  var colorScale = this.getColorScale();

  // Filter countries without values
  var countryData = this.getCustomGeoFeatures().filter(function (f) {
    return _this5.countryValueMap[f.properties.id] && _this5.countryValueMap[f.properties.id].value != null;
  }).map(function (a) {
    a.properties.value = _this5.countryValueMap[a.properties.id].value;
    a.properties.valueDisplay = _this5.countryValueMap[a.properties.id].display;
    a.properties.name = _this5.countryValueMap[a.properties.id].name;
    a.properties.index = _this5.countryValueMap[a.properties.id].index;
    a.properties.isin = _this5.countryValueMap[a.properties.id].isin;
    return a;
  });
  var countriesGroup = this.svgGroup.select('.countries');
  if (!countriesGroup.size()) {
    countriesGroup = this.svgGroup.append('g').attr('class', 'countries');
  }

  // Draw individual countries
  var countries = countriesGroup.selectAll('path').data(countryData);
  countries.exit().remove();
  countries.enter().append('path').style('stroke-width', '0.33px').style('stroke-linejoin', 'round').style('cursor', 'pointer').merge(countries).attr('d', this.pathProjector).attr('data-country', function (a) {
    return a.properties.id;
  }).style('fill', function (a) {
    return colorScale(a.properties.value);
  }).style('stroke', function (a) {
    return _this5.config.theme.colors.continentBorder;
  }).on('click', function (_, a) {
    var selectedKpi = window.YAHOO.util.Dom.get("".concat(_this.node.id, "_valueMenu")).value;
    if (_this5.config.onCountryClick) {
      _this5.config.onCountryClick((0, _countryIsoConverter.convertCountry)(a.properties.id));
    } else if (a.properties.isin && !nonIndexKpis.includes(selectedKpi)) {
      redirectToIndexOverviewPage(a.properties.isin);
    } else {
      redirectToCountryDetail(a.properties.id);
    }
    _this5.selectCountry(_this5.selectedCountry === a.properties.id ? null : a.properties.id);
  }).on('mouseover', function (_, a) {
    var selectedKpi = window.YAHOO.util.Dom.get("".concat(_this.node.id, "_valueMenu")).value;
    var indexNameTemplate = a.properties.index && !nonIndexKpis.includes(selectedKpi) ? " <b>".concat(a.properties.index, "</b><br/>") : '';
    // NGPII-25315 - for Chinese users hovering over Taiwan and Hong Kong should show data for China
    var countryCode = window.user.isChinaSpecificUser && (a.properties.id === 'TWN' || a.properties.id === 'HKG') ? 'CHN' : a.properties.id;
    _this.tooltip.html("<div>".concat(getFlag(a.properties.id), " ").concat(a.properties.name, " (").concat(countryCode, ")<br/>").concat(indexNameTemplate).concat(_this.valueLabel, ": ").concat(a.properties.valueDisplay, "</div><div class=\"d3-tooltip-ptr\"></div>"));
    positionTooltipOnPoint(_this.tooltip, transformPointCoordinates(_this.pathProjector.centroid(a), d3.zoomTransform(_this.svg.node())), [$(_this.svg.node()).width(), $(_this.svg.node()).height()]);
    // copy the path to highlight
    highlightItem.attr('d', $(_this5).attr('d'));
  }).on('mouseout', function () {
    _this5.tooltip.transition().duration(500).style('opacity', '0');
    highlightItem.attr('d', '');
  });

  // Create Highlight outline if necessary
  var highlightItem = this.svgGroup.selectAll('.highlight path');
  if (!highlightItem.size()) {
    highlightItem = this.svgGroup.append('g').attr('class', 'highlight').append('path').style('fill', 'none').style('stroke', 'black').style('stroke-width', '1.5px').style('stroke-linejoin', 'round').style('opacity', '0.3').style('pointer-events', 'none');
  }
  this.selectedItem = this.svgGroup.selectAll('.selected path');
  if (!this.selectedItem.size()) {
    this.selectedItem = this.svgGroup.append('g').attr('class', 'selected').append('path').style('fill', 'none').style('stroke', 'black').style('stroke-width', '1px').style('stroke-linejoin', 'round').style('opacity', '1').style('pointer-events', 'none');
  }
};
DynamicWorldmap.prototype.drawCountriesWithoutData = function () {
  var _this6 = this;
  var _this = this;

  // Filter countries with values
  var countryData = this.getCustomGeoFeatures().filter(function (f) {
    return !(_this6.countryValueMap[f.properties.id] && _this6.countryValueMap[f.properties.id].value != null);
  }).map(function (a) {
    a.properties.value = 0;
    a.properties.valueDisplay = '';
    return a;
  });
  var countriesGroup = this.svgGroup.select('.countriesWithoutData');
  if (!countriesGroup.size()) {
    countriesGroup = this.svgGroup.append('g').attr('class', 'countriesWithoutData');
  }

  // Draw individual countriesWithoutData
  var countriesWithoutData = countriesGroup.selectAll('path').data(countryData);
  countriesWithoutData.exit().remove();
  countriesWithoutData.enter().append('path').style('stroke-width', '0.33px').style('stroke-linejoin', 'round').merge(countriesWithoutData).attr('d', this.pathProjector).attr('data-country', function (a) {
    return a.properties.id;
  }).style('fill', this.config.theme.colors.continents).style('opacity', '0.3').style('stroke', function () {
    return d3.color(_this6.config.theme.colors.continents).darker(20);
  }).on('click', function (_, a) {
    _this6.selectCountry(_this6.selectedCountry === a.properties.id ? null : a.properties.id);
  }).on('mouseover', function (_, a) {
    // NGPII-25315 - for Chinese users hovering over Taiwan and Hong Kong should show data for China
    var countryCode = window.user.isChinaSpecificUser && (a.properties.id === 'TWN' || a.properties.id === 'HKG') ? 'CHN' : a.properties.id;
    _this.tooltip.html("<div>".concat(getFlag(a.properties.id), " ").concat(a.properties.name, " (").concat(countryCode, ")</div><div class=\"d3-tooltip-ptr\"></div>"));
    positionTooltipOnPoint(_this.tooltip, transformPointCoordinates(_this.pathProjector.centroid(a), d3.zoomTransform(_this.svg.node())), [$(_this.svg.node()).width(), $(_this.svg.node()).height()]);
  }).on('mouseout', function () {
    _this6.tooltip.transition().duration(500).style('opacity', '0');
  });
};
DynamicWorldmap.prototype.drawContinents = function () {
  // Draw continent backgrounds
  var path = this.svgGroup.selectAll('.continents path');
  if (!path.size()) {
    // create the element if necessary
    path = this.svgGroup.append('g').attr('class', 'continents').append('path').style('fill', this.config.theme.colors.continents).style('opacity', '0.75');
  }
  // Update the path
  path.attr('d', this.pathProjector({
    type: 'FeatureCollection',
    features: worldGeoFeatures
  }));
};
DynamicWorldmap.prototype.drawGraticule = function () {
  // Draw graticule
  var graticule = d3.geoGraticule();
  var path = this.svgGroup.selectAll('.graticule path');
  if (!path.size()) {
    // create the element if necessary
    path = this.svgGroup.append('g').attr('class', 'graticule').append('path').style('stroke', 'black').style('stroke-width', '0.33px').style('fill', 'transparent').style('opacity', '0.05');
  }
  // Update the path
  path.datum(graticule).attr('d', this.pathProjector);
};
DynamicWorldmap.prototype.translateToFeature = function (feature) {
  var _d3$zoomIdentity,
    _this7 = this;
  var _this$pathProjector$b5 = this.pathProjector.bounds(feature),
    _this$pathProjector$b6 = _slicedToArray(_this$pathProjector$b5, 2),
    _this$pathProjector$b7 = _slicedToArray(_this$pathProjector$b6[0], 2),
    x1 = _this$pathProjector$b7[0],
    y1 = _this$pathProjector$b7[1],
    _this$pathProjector$b8 = _slicedToArray(_this$pathProjector$b6[1], 2),
    x2 = _this$pathProjector$b8[0],
    y2 = _this$pathProjector$b8[1];
  var dx = x2 - x1;
  var dy = y2 - y1;
  var x = (x1 + x2) / 2;
  var y = (y1 + y2) / 2;
  var height = this.moduleHeight ? this.moduleHeight : this.getWorldGraphDimensions().height;
  var scale = Math.min(0.9 / Math.max(dx / this.moduleWidth, dy / height), scaleExtent[1]);
  var translate = [this.moduleWidth / 2 - scale * x, height / 2 - scale * y];
  var transform = (_d3$zoomIdentity = d3.zoomIdentity).translate.apply(_d3$zoomIdentity, translate).scale(scale);
  window.setTimeout(function () {
    _this7.svg.transition().duration(750).call(_this7.zoomObject.transform, transform);
  }, 100);
};
DynamicWorldmap.prototype.resetZoom = function () {
  this.svg.transition().duration(300).call(this.zoomObject.transform, d3.zoomIdentity);
};
DynamicWorldmap.prototype.zoomIn = function () {
  this.svg.transition().duration(300).call(this.zoomObject.scaleBy, 1 + zoomStep);
};
DynamicWorldmap.prototype.zoomOut = function () {
  this.svg.transition().duration(300).call(this.zoomObject.scaleBy, 1 - zoomStep);
};
DynamicWorldmap.prototype.moveLeft = function () {
  this.svg.transition().duration(300).call(this.zoomObject.translateBy, moveStep, 0);
};
DynamicWorldmap.prototype.moveRight = function () {
  this.svg.transition().duration(300).call(this.zoomObject.translateBy, -moveStep, 0);
};
DynamicWorldmap.prototype.moveUp = function () {
  this.svg.transition().duration(300).call(this.zoomObject.translateBy, 0, moveStep);
};
DynamicWorldmap.prototype.moveDown = function () {
  this.svg.transition().duration(300).call(this.zoomObject.translateBy, 0, -moveStep);
};
DynamicWorldmap.prototype.getCountryValuesForSelect = function () {
  return this.getCustomGeoFeatures().filter(function (f) {
    return ignoreCountriesForDetails.indexOf(f.properties.id) === -1;
  }).map(function (f) {
    return {
      value: f.properties.id,
      text: f.properties.name
    };
  });
};
DynamicWorldmap.prototype.getWorldGraphDimensions = function () {
  return {
    width: parseInt(this.svg.attr('width'), 10),
    height: parseInt(this.svg.attr('height'), 10)
  };
};
DynamicWorldmap.prototype.mixCountrySelects = function (oldNames, newNames) {
  var oldNamesMap = Array.apply(void 0, _toConsumableArray(oldNames.options)).map(function (f) {
    return {
      value: (0, _countryIsoConverter.convertCountry)(f.value),
      text: f.text
    };
  });
  return newNames.map(function (f) {
    return {
      value: f.value,
      text: oldNamesMap.find(function (oldNames) {
        return oldNames.value === f.value;
      }) ? oldNamesMap.find(function (oldNames) {
        return oldNames.value === f.value;
      }).text : window.getMessage("country.short.".concat((0, _countryIsoConverter.convertCountry)(f.value)))
    };
  }).sort(function (a, b) {
    return a.text.localeCompare(b.text, window.user.locale, {});
  });
};
DynamicWorldmap.prototype.init = function () {
  var _this8 = this;
  // Create the svg and container group
  this.svg = d3.select(this.mapContainer).append('svg').attr('width', this.moduleWidth).attr('height', this.moduleHeight).attr('aria-hidden', 'true').style('background-color', this.config.theme.colors.ocean);
  this.svgGroup = this.svg.append('g');

  // Scale Legend
  if (!this.config.disableLegend) {
    // detail page link to override linkmode
    d3.select(this.mapContainer).append('button').text(window.getMessage('module.DynamicWorldmapModule.link.more')).attr('class', 'dynamicworldmap-detailpage hidden').on('click', function () {
      return redirectToCountryDetail(_this8.selectedCountry);
    });
    var legend = d3.select(this.mapContainer).append('div').attr('class', 'dynamicworldmap-legend');
    legend.append('button').attr('class', 'dynamicworldmap-legend-toggle').attr('role', 'button').attr('tabindex', 0).attr('aria-label', window.getMessage('module.DynamicWorldmapModule.legends.toggle')).on('click', function () {
      legend.classed('toggled', function () {
        return !legend.classed('toggled');
      });
      setTimeout(function () {
        _this8.updateLegend();
      }, 150);
    });
    legend.append('div').attr('class', 'dynamicworldmap-legend-items').append('ul');
  }
  if (!this.config.disableZoom) {
    this.zoomObject = d3.zoom().scaleExtent(scaleExtent).on('zoom', function (event) {
      _this8.svgGroup.attr('transform', event.transform);
    });

    // Zoom Behaviour
    this.svg.call(this.zoomObject);

    // Zoom Handles
    var handles = d3.select(this.mapContainer).append('div').attr('class', 'dynamicworldmap-handles');
    handles.append('button').attr('class', 'handle-move-up').attr('aria-label', window.getMessage('module.DynamicWorldmapModule.link.scrollUp')).on('click', function () {
      _this8.moveUp();
    });
    handles.append('button').attr('class', 'handle-move-left').attr('aria-label', window.getMessage('module.DynamicWorldmapModule.link.scrollLeft')).on('click', function () {
      _this8.moveLeft();
    });
    handles.append('button').attr('class', 'handle-reset').attr('aria-label', window.getMessage('module.DynamicWorldmapModule.link.reset')).on('click', function () {
      _this8.resetZoom();
    });
    handles.append('button').attr('class', 'handle-move-right').attr('aria-label', window.getMessage('module.DynamicWorldmapModule.link.scrollRight')).on('click', function () {
      _this8.moveRight();
    });
    handles.append('button').attr('class', 'handle-move-down').attr('aria-label', window.getMessage('module.DynamicWorldmapModule.link.scrollDown')).on('click', function () {
      _this8.moveDown();
    });
    handles.append('button').attr('class', 'handle-zoom-in').attr('aria-label', window.getMessage('module.DynamicWorldmapModule.link.zoomIn')).on('click', function () {
      _this8.zoomIn();
    });
    handles.append('button').attr('class', 'handle-zoom-out').attr('aria-label', window.getMessage('module.DynamicWorldmapModule.link.zoomOut')).on('click', function () {
      _this8.zoomOut();
    });
  }

  // Tooltip Object
  this.tooltip = d3.select(this.mapContainer).append('div').attr('class', 'd3-tooltip').style('position', 'absolute').style('top', '10px').style('left', '10px').style('opacity', '0');
};
DynamicWorldmap.prototype['@resize'] = function () {
  this.resize(true);
};
var _default = exports.default = DynamicWorldmap;

},{"core/redirect":9,"geojson/world.geo.json":148,"modules/DynamicWorldmapModule/countryIsoConverter":28,"modules/DynamicWorldmapModule/geographicRegions":29,"util/functions/quartileRange":144}],28:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertCountry = exports.convertCountries = void 0;
var countryCodes = {
  AF: 'AFG',
  // Afghanistan
  AX: 'ALA',
  // Åland Islands
  AL: 'ALB',
  // Albania
  DZ: 'DZA',
  // Algeria
  AS: 'ASM',
  // American Samoa
  AD: 'AND',
  // Andorra
  AO: 'AGO',
  // Angola
  AI: 'AIA',
  // Anguilla
  AQ: 'ATA',
  // Antarctica
  AG: 'ATG',
  // Antigua and Barbuda
  AR: 'ARG',
  // Argentina
  AM: 'ARM',
  // Armenia
  AW: 'ABW',
  // Aruba
  AU: 'AUS',
  // Australia
  AT: 'AUT',
  // Austria
  AZ: 'AZE',
  // Azerbaijan
  BS: 'BHS',
  // Bahamas
  BH: 'BHR',
  // Bahrain
  BD: 'BGD',
  // Bangladesh
  BB: 'BRB',
  // Barbados
  BY: 'BLR',
  // Belarus
  BE: 'BEL',
  // Belgium
  BZ: 'BLZ',
  // Belize
  BJ: 'BEN',
  // Benin
  BM: 'BMU',
  // Bermuda
  BT: 'BTN',
  // Bhutan
  BO: 'BOL',
  // Bolivia (Plurinational State of)
  BQ: 'BES',
  // Bonaire, Sint Eustatius and Saba
  BA: 'BIH',
  // Bosnia and Herzegovina
  BW: 'BWA',
  // Botswana
  BV: 'BVT',
  // Bouvet Island
  BR: 'BRA',
  // Brazil
  IO: 'IOT',
  // British Indian Ocean Territory
  BN: 'BRN',
  // Brunei Darussalam
  BG: 'BGR',
  // Bulgaria
  BF: 'BFA',
  // Burkina Faso
  BI: 'BDI',
  // Burundi
  CV: 'CPV',
  // Cabo Verde
  KH: 'KHM',
  // Cambodia
  CM: 'CMR',
  // Cameroon
  CA: 'CAN',
  // Canada
  KY: 'CYM',
  // Cayman Islands
  CF: 'CAF',
  // Central African Republic
  TD: 'TCD',
  // Chad
  CL: 'CHL',
  // Chile
  CN: 'CHN',
  // China
  CX: 'CXR',
  // Christmas Island
  CC: 'CCK',
  // Cocos (Keeling) Islands
  CO: 'COL',
  // Colombia
  KM: 'COM',
  // Comoros
  CG: 'COG',
  // Congo
  CD: 'COD',
  // Congo (Democratic Republic of the)
  CK: 'COK',
  // Cook Islands
  CR: 'CRI',
  // Costa Rica
  CI: 'CIV',
  // Côte d'Ivoire
  HR: 'HRV',
  // Croatia
  CU: 'CUB',
  // Cuba
  CW: 'CUW',
  // Curaçao
  CY: 'CYP',
  // Cyprus
  CZ: 'CZE',
  // Czechia
  DK: 'DNK',
  // Denmark
  DJ: 'DJI',
  // Djibouti
  DM: 'DMA',
  // Dominica
  DO: 'DOM',
  // Dominican Republic
  EC: 'ECU',
  // Ecuador
  EG: 'EGY',
  // Egypt
  SV: 'SLV',
  // El Salvador
  GQ: 'GNQ',
  // Equatorial Guinea
  ER: 'ERI',
  // Eritrea
  EE: 'EST',
  // Estonia
  ET: 'ETH',
  // Ethiopia
  FK: 'FLK',
  // Falkland Islands (Malvinas)
  FO: 'FRO',
  // Faroe Islands
  FJ: 'FJI',
  // Fiji
  FI: 'FIN',
  // Finland
  FR: 'FRA',
  // France
  GF: 'GUF',
  // French Guiana
  PF: 'PYF',
  // French Polynesia
  TF: 'ATF',
  // French Southern Territories
  GA: 'GAB',
  // Gabon
  GM: 'GMB',
  // Gambia
  GE: 'GEO',
  // Georgia
  DE: 'DEU',
  // Germany
  GH: 'GHA',
  // Ghana
  GI: 'GIB',
  // Gibraltar
  GR: 'GRC',
  // Greece
  GL: 'GRL',
  // Greenland
  GD: 'GRD',
  // Grenada
  GP: 'GLP',
  // Guadeloupe
  GU: 'GUM',
  // Guam
  GT: 'GTM',
  // Guatemala
  GG: 'GGY',
  // Guernsey
  GN: 'GIN',
  // Guinea
  GW: 'GNB',
  // Guinea-Bissau
  GY: 'GUY',
  // Guyana
  HT: 'HTI',
  // Haiti
  HM: 'HMD',
  // Heard Island and McDonald Islands
  VA: 'VAT',
  // Holy See
  HN: 'HND',
  // Honduras
  HK: 'HKG',
  // Hong Kong
  HU: 'HUN',
  // Hungary
  IS: 'ISL',
  // Iceland
  IN: 'IND',
  // India
  ID: 'IDN',
  // Indonesia
  IR: 'IRN',
  // Iran (Islamic Republic of)
  IQ: 'IRQ',
  // Iraq
  IE: 'IRL',
  // Ireland
  IM: 'IMN',
  // Isle of Man
  IL: 'ISR',
  // Israel
  IT: 'ITA',
  // Italy
  JM: 'JAM',
  // Jamaica
  JP: 'JPN',
  // Japan
  JE: 'JEY',
  // Jersey
  JO: 'JOR',
  // Jordan
  KZ: 'KAZ',
  // Kazakhstan
  KE: 'KEN',
  // Kenya
  KI: 'KIR',
  // Kiribati
  KP: 'PRK',
  // Korea (Democratic People's Republic of)
  KR: 'KOR',
  // Korea (Republic of)
  XK: 'RKS',
  // Kosovo (Republic of)
  KW: 'KWT',
  // Kuwait
  KG: 'KGZ',
  // Kyrgyzstan
  LA: 'LAO',
  // Lao People's Democratic Republic
  LV: 'LVA',
  // Latvia
  LB: 'LBN',
  // Lebanon
  LS: 'LSO',
  // Lesotho
  LR: 'LBR',
  // Liberia
  LY: 'LBY',
  // Libya
  LI: 'LIE',
  // Liechtenstein
  LT: 'LTU',
  // Lithuania
  LU: 'LUX',
  // Luxembourg
  MO: 'MAC',
  // Macao
  MK: 'MKD',
  // Macedonia (the former Yugoslav Republic of)
  MG: 'MDG',
  // Madagascar
  MW: 'MWI',
  // Malawi
  MY: 'MYS',
  // Malaysia
  MV: 'MDV',
  // Maldives
  ML: 'MLI',
  // Mali
  MT: 'MLT',
  // Malta
  MH: 'MHL',
  // Marshall Islands
  MQ: 'MTQ',
  // Martinique
  MR: 'MRT',
  // Mauritania
  MU: 'MUS',
  // Mauritius
  YT: 'MYT',
  // Mayotte
  MX: 'MEX',
  // Mexico
  FM: 'FSM',
  // Micronesia (Federated States of)
  MD: 'MDA',
  // Moldova (Republic of)
  MC: 'MCO',
  // Monaco
  MN: 'MNG',
  // Mongolia
  ME: 'MNE',
  // Montenegro
  MS: 'MSR',
  // Montserrat
  MA: 'MAR',
  // Morocco
  MZ: 'MOZ',
  // Mozambique
  MM: 'MMR',
  // Myanmar
  NA: 'NAM',
  // Namibia
  NR: 'NRU',
  // Nauru
  NP: 'NPL',
  // Nepal
  NL: 'NLD',
  // Netherlands
  NC: 'NCL',
  // New Caledonia
  NZ: 'NZL',
  // New Zealand
  NI: 'NIC',
  // Nicaragua
  NE: 'NER',
  // Niger
  NG: 'NGA',
  // Nigeria
  NU: 'NIU',
  // Niue
  NF: 'NFK',
  // Norfolk Island
  MP: 'MNP',
  // Northern Mariana Islands
  NO: 'NOR',
  // Norway
  OM: 'OMN',
  // Oman
  PK: 'PAK',
  // Pakistan
  PW: 'PLW',
  // Palau
  PS: 'PSE',
  // Palestine, State of
  PA: 'PAN',
  // Panama
  PG: 'PNG',
  // Papua New Guinea
  PY: 'PRY',
  // Paraguay
  PE: 'PER',
  // Peru
  PH: 'PHL',
  // Philippines
  PN: 'PCN',
  // Pitcairn
  PL: 'POL',
  // Poland
  PT: 'PRT',
  // Portugal
  PR: 'PRI',
  // Puerto Rico
  QA: 'QAT',
  // Qatar
  RE: 'REU',
  // Réunion
  RO: 'ROU',
  // Romania
  RU: 'RUS',
  // Russian Federation
  RW: 'RWA',
  // Rwanda
  BL: 'BLM',
  // Saint Barthélemy
  SH: 'SHN',
  // Saint Helena, Ascension and Tristan da Cunha
  KN: 'KNA',
  // Saint Kitts and Nevis
  LC: 'LCA',
  // Saint Lucia
  MF: 'MAF',
  // Saint Martin (French part)
  PM: 'SPM',
  // Saint Pierre and Miquelon
  VC: 'VCT',
  // Saint Vincent and the Grenadines
  WS: 'WSM',
  // Samoa
  SM: 'SMR',
  // San Marino
  ST: 'STP',
  // Sao Tome and Principe
  SA: 'SAU',
  // Saudi Arabia
  SN: 'SEN',
  // Senegal
  RS: 'SRB',
  // Serbia
  SC: 'SYC',
  // Seychelles
  SL: 'SLE',
  // Sierra Leone
  SG: 'SGP',
  // Singapore
  SX: 'SXM',
  // Sint Maarten (Dutch part)
  SK: 'SVK',
  // Slovakia
  SI: 'SVN',
  // Slovenia
  SB: 'SLB',
  // Solomon Islands
  SO: 'SOM',
  // Somalia
  ZA: 'ZAF',
  // South Africa
  GS: 'SGS',
  // South Georgia and the South Sandwich Islands
  SS: 'SSD',
  // South Sudan
  ES: 'ESP',
  // Spain
  LK: 'LKA',
  // Sri Lanka
  SD: 'SDN',
  // Sudan
  SR: 'SUR',
  // Suriname
  SJ: 'SJM',
  // Svalbard and Jan Mayen
  SZ: 'SWZ',
  // Swaziland
  SE: 'SWE',
  // Sweden
  CH: 'CHE',
  // Switzerland
  SY: 'SYR',
  // Syrian Arab Republic
  TW: 'TWN',
  // Taiwan, Province of China[a]
  TJ: 'TJK',
  // Tajikistan
  TZ: 'TZA',
  // Tanzania, United Republic of
  TH: 'THA',
  // Thailand
  TL: 'TLS',
  // Timor-Leste
  TG: 'TGO',
  // Togo
  TK: 'TKL',
  // Tokelau
  TO: 'TON',
  // Tonga
  TT: 'TTO',
  // Trinidad and Tobago
  TN: 'TUN',
  // Tunisia
  TR: 'TUR',
  // Turkey
  TM: 'TKM',
  // Turkmenistan
  TC: 'TCA',
  // Turks and Caicos Islands
  TV: 'TUV',
  // Tuvalu
  UG: 'UGA',
  // Uganda
  UA: 'UKR',
  // Ukraine
  AE: 'ARE',
  // United Arab Emirates
  GB: 'GBR',
  // United Kingdom of Great Britain and Northern Ireland
  US: 'USA',
  // United States of America
  UM: 'UMI',
  // United States Minor Outlying Islands
  UY: 'URY',
  // Uruguay
  UZ: 'UZB',
  // Uzbekistan
  VU: 'VUT',
  // Vanuatu
  VE: 'VEN',
  // Venezuela (Bolivarian Republic of)
  VN: 'VNM',
  // Viet Nam
  VG: 'VGB',
  // Virgin Islands (British)
  VI: 'VIR',
  // Virgin Islands (U.S.)
  WF: 'WLF',
  // Wallis and Futuna
  EH: 'ESH',
  // Western Sahara
  YE: 'YEM',
  // Yemen
  ZM: 'ZMB',
  // Zambia
  ZW: 'ZWE' // Zimbabwe
};

// Fill the countryCodes map with reverse data as well
Object.keys(countryCodes).forEach(function (countryCode) {
  return countryCodes[countryCodes[countryCode]] = countryCode;
});
var convertCountry = exports.convertCountry = function convertCountry(country) {
  return countryCodes[country] || null;
};
var convertCountries = exports.convertCountries = function convertCountries(countries) {
  return countries.map(convertCountry);
};

},{}],29:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCountriesByRegion = exports.getAllCountries = void 0;
var _countryIsoConverter = require("modules/DynamicWorldmapModule/countryIsoConverter");
// A list of all possible regions:
var Africa = 'Africa';
var Alpine = 'Alpine';
var America = 'America';
var Andean = 'Andean';
var Asia = 'Asia';
var Balkan = 'Balkan';
var Baltic = 'Baltic';
var Benelux = 'Benelux';
var BritishIslands = 'BritishIslands';
var CaribbeanIslands = 'CaribbeanIslands';
var CentralAfrica = 'CentralAfrica';
var CentralAmerica = 'CentralAmerica';
var CentralAsia = 'CentralAsia';
var CIS = 'CIS';
var EastAfrica = 'EastAfrica';
var EastAsia = 'EastAsia';
var EastCentralEurope = 'EastCentralEurope';
var EastEurope = 'EastEurope';
var Europe = 'Europe';
var GreaterChina = 'GreaterChina';
var Iberia = 'Iberia';
var LatinAmerica = 'LatinAmerica';
var MiddleEast = 'MiddleEast';
var Nordic = 'Nordic';
var NorthAfrica = 'NorthAfrica';
var NorthAmerica = 'NorthAmerica';
var NorthEastAsia = 'NorthEastAsia';
var NorthEurope = 'NorthEurope';
var Oceania = 'Oceania';
var SouthAmerica = 'SouthAmerica';
var SouthAsia = 'SouthAsia';
var SouthEastAsia = 'SouthEastAsia';
var SouthEastEurope = 'SouthEastEurope';
var SouthernAfrica = 'SouthernAfrica';
var SouthEurope = 'SouthEurope';
var SouthWestAsia = 'SouthWestAsia';
var VEC = 'VEC';
var WestAfrica = 'WestAfrica';
var WestEurope = 'WestEurope';
var regionAtlas = [
// EUROPE
{
  region: Europe,
  countries: [],
  regions: [EastEurope, NorthEurope, SouthEurope, WestEurope /*Other European Countries*/]
}, {
  region: NorthEurope,
  countries: [],
  regions: [Baltic, Nordic]
}, {
  region: WestEurope,
  countries: ['DE', 'FR'],
  regions: [Alpine, Benelux, BritishIslands]
}, {
  region: EastEurope,
  countries: [],
  regions: [Balkan, CIS, EastCentralEurope]
}, {
  region: SouthEurope,
  countries: ['IT'],
  regions: [Iberia, SouthEastEurope]
}, {
  region: SouthEastEurope,
  countries: ['CY', 'GR', 'MT', 'TR'],
  regions: []
}, {
  region: EastCentralEurope,
  countries: ['BG', 'CZ', 'HU', 'PL', 'RO', 'SK'],
  regions: []
}, {
  region: BritishIslands,
  countries: ['GB', 'GG', 'IE', 'JE'],
  regions: []
}, {
  region: CIS,
  // Commonwealth of Indepentant States
  countries: ['AM', 'BY', 'GE', 'MD', 'RU', 'UA'],
  regions: []
}, {
  region: Iberia,
  countries: ['AD', 'ES', 'GI', 'PT'],
  regions: []
}, {
  region: Benelux,
  countries: ['BE', 'LU', 'NL'],
  regions: []
}, {
  region: Balkan,
  countries: ['AL', 'BA', 'HR', 'ME', 'MK', 'RS', 'SI', 'XK'],
  regions: []
}, {
  region: Baltic,
  countries: ['EE', 'LT', 'LV'],
  regions: []
}, {
  region: Nordic,
  countries: ['DK', 'FI', 'FO', 'GL', 'IS', 'NO', 'SE'],
  regions: []
}, {
  region: Alpine,
  countries: ['AT', 'CH'],
  regions: []
},
// ASIA
{
  region: Asia,
  countries: [],
  regions: [CentralAsia, EastAsia, SouthEastAsia, SouthWestAsia]
}, {
  region: CentralAsia,
  countries: ['AF', 'AZ', 'KG', 'KZ', 'MN', 'TJ', 'TM', 'UZ'],
  regions: []
}, {
  region: EastAsia,
  countries: [],
  regions: [GreaterChina, NorthEastAsia]
}, {
  region: GreaterChina,
  countries: ['CN', 'HK', 'TW'],
  regions: []
}, {
  region: NorthEastAsia,
  countries: ['JP', 'KP', 'KR'],
  regions: []
}, {
  region: SouthEastAsia,
  countries: ['BN', 'BT', 'KH', 'LA', 'MM', 'TH', 'VN'],
  regions: [SouthAsia]
}, {
  region: SouthAsia,
  countries: ['ID', 'MY', 'PH', 'SG'],
  regions: []
},
// AFRICA
{
  region: Africa,
  countries: [],
  regions: [CentralAfrica, EastAfrica, MiddleEast, NorthAfrica, SouthernAfrica, WestAfrica]
}, {
  region: WestAfrica,
  countries: ['BF', 'BJ', 'CI', 'CV', 'GH', 'GM', 'GN', 'GW', 'LR', 'ML', 'MR', 'NE', 'NG', 'SL', 'SN', 'TG', 'EH'],
  regions: []
}, {
  region: NorthAfrica,
  countries: ['DZ', 'EG', 'LY', 'MA', 'TN'],
  regions: []
}, {
  region: SouthernAfrica,
  countries: ['BW', 'LS', 'NA', 'ZA', 'ZM', 'ZW', 'SZ'],
  regions: []
}, {
  region: EastAfrica,
  countries: ['BI', 'DJ', 'ER', 'ET', 'KE', 'MG', 'MU', 'MW', 'MZ', 'RE', 'RW', 'SC', 'SD', 'SO', 'SS', 'TZ', 'UG'],
  regions: []
}, {
  region: CentralAfrica,
  countries: ['AO', 'CD', 'CF', 'CG', 'CM', 'GA', 'GQ', 'TD'],
  regions: []
}, {
  region: SouthWestAsia,
  countries: ['BD', 'IN', 'LK', 'NP', 'PK'],
  regions: []
},
// AMERICA
{
  region: America,
  countries: [],
  regions: [NorthAmerica, LatinAmerica]
}, {
  region: NorthAmerica,
  countries: ['CA', 'MX', 'US'],
  regions: []
}, {
  region: LatinAmerica,
  countries: [],
  regions: [CaribbeanIslands, CentralAmerica, SouthAmerica]
}, {
  region: CentralAmerica,
  countries: ['BZ', 'CR', 'GF', 'GT', 'GY', 'HN', 'NI', 'PA', 'SR', 'SV'],
  regions: []
}, {
  region: SouthAmerica,
  countries: ['AR', 'BR', 'CL', 'Ot', 'PY', 'UY', 'FK'],
  regions: [Andean, VEC]
}, {
  region: CaribbeanIslands,
  countries: ['AN', 'BB', 'BM', 'BS', 'CU', 'DM', 'DO', 'FA', 'HT', 'JM', 'KY', 'PR', 'TT', 'VI'],
  regions: []
}, {
  region: VEC,
  countries: ['CO', 'EC', 'VE'],
  regions: []
}, {
  region: Andean,
  countries: ['BO', 'PE'],
  regions: []
},
// OTHER
{
  region: MiddleEast,
  countries: ['AE', 'BH', 'IL', 'IQ', 'IR', 'JO', 'KW', 'LB', 'OM', 'Ot', 'PS', 'QA', 'SA', 'SY', 'YE'],
  regions: []
}, {
  region: Oceania,
  countries: ['NZ', 'AU', 'PG', 'NC', 'FJ', 'SB', 'VU', 'TL'],
  regions: []
}];
var regionAtlasMap = {}; // this will be filled for quicker access
var getCountriesByRegion = exports.getCountriesByRegion = function getCountriesByRegion(region) {
  if (!regionAtlasMap[region]) {
    var regionItem = regionAtlas.find(function (f) {
      return f.region === region;
    });
    if (regionItem) {
      var subRegionCountries = regionItem.regions.map(getCountriesByRegion).reduce(function (all, a) {
        return all.concat(a);
      }, []);
      regionAtlasMap[region] = [].concat((0, _countryIsoConverter.convertCountries)(regionItem.countries), subRegionCountries);
    }
  }
  return regionAtlasMap[region] || [];
};
var allCountries = regionAtlas.map(function (region) {
  return (0, _countryIsoConverter.convertCountries)(region.countries);
}).reduce(function (all, a) {
  return all.concat(a);
}, []);
var getAllCountries = exports.getAllCountries = function getAllCountries() {
  return allCountries;
};

},{"modules/DynamicWorldmapModule/countryIsoConverter":28}],30:[function(require,module,exports){
"use strict";

var _ExtendedWatchlistModule = _interopRequireDefault(require("modules/ExtendedWatchlistModule/ExtendedWatchlistModule"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var YAHOO = window.YAHOO;
window.fcom.moduleHandler.registerModuleType('ExtendedWatchlistModule', function (node, config) {
  var moduleInstance = new _ExtendedWatchlistModule.default(node, config);
  var showMaximized = function showMaximized() {
    var url = '/view.action';
    var postData = {
      method: 'getModuleMaximized',
      moduleId: node.id,
      viewId: config.viewId
    };
    $(node).addClass('inProcess');
    window.fillPanelFromAjax('ExtendedWatchlistViewPanelDiv', url, postData, {
      width: '1000px',
      fixedcenter: true,
      visible: false,
      close: true,
      dragOnly: true,
      draggable: true,
      constraintoviewport: true,
      modal: true
    }, {
      errorMessage: window.getMessage('USER_UNAUTHORIZED'),
      instanceHandler: function instanceHandler(panelInstance) {
        window["".concat(node.id, "_wl_maxViewPanel")] = panelInstance;
        panelInstance.hideEvent.subscribe(function () {
          $(node).removeClass('inProcess');
          //unsubscribe
          this.hideEvent.unsubscribe('hide', instanceHandler, this); //TODO: get rid of arguments.callee
        }, panelInstance, true);
      }
    });
  };
  if (config.senderChannel) {
    $(node).click(function (event) {
      var possibleTargets = $(node).find('.select-instrument').siblings('.checkbox');
      if (possibleTargets.index(event.target) >= 0) {
        var message = {
          senderId: node.id,
          messageType: 'multiRic',
          rics: getSelectedInstruments(node)
        };
        window.YAHOO.fcom.Broadcaster.sendMessage(config.senderChannel, message);
      }
      var possibleTargetAll = $(node).find('.select-instrument-all').siblings('.checkbox')[0];
      if (possibleTargetAll === event.target) {
        sendBroadcastAll($(node), config.senderChannel);
      }
    });
  }
  moduleInstance['@broadcast'] = _defineProperty({}, "".concat(node.id, "_refreshMaxView"), function _refreshMaxView() {
    window["".concat(node.id, "_wl_maxViewPanel")].hide();
    showMaximized();
  });
  YAHOO.util.Event.addListener("".concat(node.id, "_maximize"), 'click', showMaximized);
  return moduleInstance;
}, true);
var getSelectedInstruments = function getSelectedInstruments(node) {
  return $(node).find('.select-instrument:checked').get().map(function (e) {
    return $(e).val();
  });
};
var sendBroadcastAll = function sendBroadcastAll($node, senderChannel) {
  var checked = $node.find('.select-instrument-all').prop('checked');
  $node.find('.select-instrument').prop('checked', checked);
  $node.find('.select-instrument').siblings('.checkbox').find('span').removeClass(checked ? 'unchecked' : 'checked').addClass(checked ? 'checked' : 'unchecked');
  var message = {
    senderId: $node.attr('id'),
    messageType: 'multiRic',
    rics: getSelectedInstruments($node)
  };
  window.YAHOO.fcom.Broadcaster.sendMessage(senderChannel, message);
};

},{"modules/ExtendedWatchlistModule/ExtendedWatchlistModule":31}],31:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var YAHOO = window.YAHOO;
var ExtendedWatchlistModule = function ExtendedWatchlistModule(node, config) {
  this.params = config;
  this.moduleId = node.id;
  this.uniqueId = config.uniqueId;
  this.largeTableId = $(node).find('.moduleContent table').get(0);
  this.channelName = config.senderChannel;
  this.watchlist = config.watchlist;
  this.init();
};
ExtendedWatchlistModule.prototype = {
  init: function init() {
    YAHOO.util.Event.addListener(YAHOO.util.Dom.get(this.largeTableId), 'largeTableUpdate', this.onLargeTableUpdate, null, this);
    this.initTable();
  },
  onLargeTableUpdate: function onLargeTableUpdate() {
    this.initTable();
  },
  addToWatchlist: function addToWatchlist(ric, watchlist, callback, contextObj) {
    window.ngpAsyncRequest('POST', '/ajax.action?method=addToWatchlist', {
      success: function success(response) {
        var data = JSON.parse(response.responseText);
        callback.call(contextObj, data);
      },
      scope: this,
      silent: true
    }, {
      watchlist: watchlist,
      ric: ric
    });
  },
  addToPeerlist: function addToPeerlist(ric, watchlist, callback, contextObj) {
    window.ngpAsyncRequest('POST', '/ajax.action?method=addToPeerlist', {
      success: function success(response) {
        var data = JSON.parse(response.responseText);
        callback.call(contextObj, data);
      },
      scope: this,
      silent: true
    }, {
      watchlist: watchlist,
      ric: ric
    });
  },
  removeFromWatchlist: function removeFromWatchlist(params, watchlist, callback, contextObj) {
    window.ngpAsyncRequest('POST', '/ajax.action?method=removeFromWatchlist', {
      success: function success(response) {
        var data = JSON.parse(response.responseText);
        callback.call(contextObj, data);
      },
      scope: this,
      silent: true
    }, {
      watchlist: watchlist,
      ric: params.ric,
      watchlist2: params.watchlist
    });
  },
  removeFromPeerlist: function removeFromPeerlist(params, watchlist, callback, contextObj) {
    window.ngpAsyncRequest('POST', '/ajax.action?method=removeFromPeerlist', {
      success: function success(response) {
        var data = JSON.parse(response.responseText);
        callback.call(contextObj, data);
      },
      scope: this,
      silent: true
    }, {
      watchlist: watchlist,
      ric: params.ric,
      watchlist2: params.watchlist
    });
  },
  refreshFavorites: function refreshFavorites(data) {
    var cells = YAHOO.util.Selector.query('.watchlistfidlet.wlfavorite', this.largeTableId);
    var favorites = null;
    if (data.entries !== null) {
      favorites = {};
      for (var i = 0; i < data.entries.length; i++) {
        favorites[data.entries[i]] = i;
      }
    }
    for (var _i = 0; _i < cells.length; _i++) {
      var ric = cells[_i].getAttribute('data-ric');
      if (favorites === null) {
        YAHOO.util.Dom.addClass(cells[_i], 'favorites-disabled');
        YAHOO.util.Dom.removeClass(cells[_i], 'favorites-unselected');
        YAHOO.util.Dom.removeClass(cells[_i], 'favorites-selected');
        cells[_i].title = '';
      } else if (favorites[ric] != null) {
        YAHOO.util.Dom.addClass(cells[_i], 'favorites-selected');
        YAHOO.util.Dom.removeClass(cells[_i], 'favorites-unselected');
        YAHOO.util.Dom.removeClass(cells[_i], 'favorites-disabled');
        cells[_i].title = window.getMessage('ac.javascript.peers.remove');
      } else {
        YAHOO.util.Dom.addClass(cells[_i], 'favorites-unselected');
        YAHOO.util.Dom.removeClass(cells[_i], 'favorites-selected');
        YAHOO.util.Dom.removeClass(cells[_i], 'favorites-disabled');
        cells[_i].title = window.getMessage('ac.javascript.peers.add');
      }
    }
  },
  refreshSelection: function refreshSelection(data) {
    var cells = YAHOO.util.Selector.query('.watchlistfidlet.wlselection', this.largeTableId);
    var numberCells = YAHOO.util.Selector.query('.watchlistfidlet.wlselectionnumber', this.largeTableId);
    var selectedPeers = null;
    if (data.entries) {
      selectedPeers = {};
      for (var i = 0; i < data.entries.length; i++) {
        selectedPeers[data.entries[i]] = i;
      }
    }
    for (var _i2 = 0; _i2 < cells.length; _i2++) {
      var ric = cells[_i2].getAttribute('data-ric');
      var cbId = "".concat(this.moduleId + this.uniqueId, "_").concat(ric);
      var element = YAHOO.fcom.Page.getInstance(cbId);
      if (selectedPeers === null) {
        element.toggle(false, true);
      } else if (selectedPeers[ric] != null) {
        element.toggle(true, true);
      } else {
        element.toggle(false, true);
      }
    }
    for (var _i3 = 0; _i3 < numberCells.length; _i3++) {
      var _ric = cells[_i3].getAttribute('data-ric');
      var spanTag = YAHOO.util.Selector.query('span', numberCells[_i3])[0];
      if (selectedPeers === null) {
        spanTag.innerHTML = '';
        spanTag.className = '';
      } else if (selectedPeers[_ric] != null) {
        spanTag.innerHTML = selectedPeers[_ric] + 1;
        spanTag.className = "selectionIndexIcon position".concat(selectedPeers[_ric] + 1);
      } else {
        spanTag.innerHTML = '';
        spanTag.className = '';
      }
    }
  },
  onSelectionWatchlistChange: function onSelectionWatchlistChange(e, data, obj) {
    if (data[0].uniqueId !== obj.uniqueId) {
      obj.refreshSelection(data[0]);
    }
  },
  onFavoritesWatchlistChange: function onFavoritesWatchlistChange(e, data, obj) {
    if (data[0].uniqueId !== obj.uniqueId) {
      obj.refreshFavorites(data[0]);
    }
  },
  onSelectionClick: function onSelectionClick(e, context) {
    var cell = context[0];
    var chbObj = context[1];
    if (chbObj.isSelected()) {
      this.addToPeerlist(cell.getAttribute('data-ric'), 'peers_selected', function (data) {
        this.refreshSelection(data);
        data.uniqueId = this.uniqueId;
        YAHOO.fcom.Broadcaster.sendMessage('.selectionWatchlistChanged', data);
      }, this);
    } else {
      this.removeFromPeerlist({
        ric: cell.getAttribute('data-ric')
      }, 'peers_selected', function (data) {
        this.refreshSelection(data);
        data.uniqueId = this.uniqueId;
        YAHOO.fcom.Broadcaster.sendMessage('.selectionWatchlistChanged', data);
      }, this);
    }
  },
  onSelectionResetClick: function onSelectionResetClick(e, context) {
    var chbObj = context[1];
    if (chbObj.isSelected()) {
      return;
    }
    chbObj.toggle(true, false);
    this.removeFromPeerlist({
      watchlist: this.watchlist
    }, 'peers_selected', function (data) {
      this.refreshSelection(data);
      data.uniqueId = this.uniqueId;
      YAHOO.fcom.Broadcaster.sendMessage('.selectionWatchlistChanged', data);
    }, this);
  },
  onFavoritesResetClick: function onFavoritesResetClick(e, cell) {
    this.removeFromWatchlist({
      watchlist: this.watchlist
    }, 'favorites', function (data) {
      YAHOO.util.Dom.replaceClass(cell, 'favorites-selected', 'favorites-unselected');
      YAHOO.fcom.Broadcaster.sendMessage('.favoritesWatchlistChanged', data);
    }, this);
  },
  onFavoritesClick: function onFavoritesClick(e, cell) {
    var _this = this;
    if (YAHOO.util.Dom.hasClass(cell, 'favorites-selected')) {
      this.removeFromWatchlist({
        ric: cell.getAttribute('data-ric')
      }, 'favorites', function (data) {
        YAHOO.util.Dom.replaceClass(cell, 'favorites-selected', 'favorites-unselected');
        data.uniqueId = _this.uniqueId;
        YAHOO.fcom.Broadcaster.sendMessage('.favoritesWatchlistChanged', data);
        cell.title = window.getMessage('ac.javascript.peers.add');
      }, this);
    } else {
      this.addToWatchlist(cell.getAttribute('data-ric'), 'favorites', function (data) {
        YAHOO.util.Dom.replaceClass(cell, 'favorites-unselected', 'favorites-selected');
        data.uniqueId = _this.uniqueId;
        YAHOO.fcom.Broadcaster.sendMessage('.favoritesWatchlistChanged', data);
        cell.title = window.getMessage('ac.javascript.peers.remove');
      }, this);
    }
  },
  initWatchlistFidlets: function initWatchlistFidlets(cells) {
    window.ngpAsyncRequest('POST', '/ajax.action?method=getFavoriteWatchlists', {
      success: function success(response) {
        var data = JSON.parse(response.responseText);
        var favorites;
        var element;
        var ric;
        if (data.favorites) {
          favorites = data.favorites.reduce(function (obj, ric, i) {
            obj[ric] = i;
            return obj;
          }, {});
        }
        for (var i = 0; i < cells.length; i++) {
          if (YAHOO.util.Dom.hasClass(cells[i], 'wlfavorite')) {
            ric = cells[i].getAttribute('data-ric');
            if (!favorites) {
              YAHOO.util.Dom.addClass(cells[i], 'favorites-disabled');
            } else if (favorites.hasOwnProperty(ric)) {
              YAHOO.util.Dom.addClass(cells[i], 'favorites-selected');
              cells[i].title = window.getMessage('ac.javascript.peers.remove');
            } else {
              YAHOO.util.Dom.addClass(cells[i], 'favorites-unselected');
              cells[i].title = window.getMessage('ac.javascript.peers.add');
            }
            if (favorites) {
              YAHOO.util.Event.addListener(cells[i], 'click', this.onFavoritesClick, cells[i], this);
            }
            cells[i].innerHTML = '<div class="star"></div>';
          } else if (YAHOO.util.Dom.hasClass(cells[i], 'wlselection')) {
            ric = cells[i].getAttribute('data-ric');
            var cbId = "".concat(this.moduleId + this.uniqueId, "_").concat(ric);
            if (!selectedPeers) {
              cells[i].innerHTML = "<input id=\"".concat(cbId, "\" class=\"checkbox\" type=\"checkbox\" disabled=\"disabled\"/>");
              window.initDocument(cells[i], false, false);
            } else if (selectedPeers[ric]) {
              cells[i].innerHTML = "<input id=\"".concat(cbId, "\" class=\"checkbox\" type=\"checkbox\" checked=\"checked\"/> ");
              window.initDocument(cells[i], false, false);
            } else {
              cells[i].innerHTML = "<input id=\"".concat(cbId, "\" class=\"checkbox\" type=\"checkbox\"/>");
              window.initDocument(cells[i], false, false);
            }
          } else if (YAHOO.util.Dom.hasClass(cells[i], 'wlselectionnumber')) {
            ric = cells[i].getAttribute('data-ric');
            if (!selectedPeers) {
              cells[i].innerHTML = '&nbsp;';
            } else if (selectedPeers[ric]) {
              var className = "selectionIndexIcon position".concat(selectedPeers[ric] + 1);
              cells[i].innerHTML = "<span class=\"".concat(className, "\">").concat(selectedPeers[ric] + 1, "</span>");
            } else {
              cells[i].innerHTML = '<span>&nbsp;</span>';
            }
          } else if (YAHOO.util.Dom.hasClass(cells[i], 'wlfavoritereset')) {
            cells[i].innerHTML = '<span class="star"></span>';
            if (favorites) {
              YAHOO.util.Event.addListener(cells[i], 'click', this.onFavoritesResetClick, cells[i], this);
            }
          } else if (YAHOO.util.Dom.hasClass(cells[i], 'wlselectionreset')) {
            var _cbId = "".concat(this.moduleId + this.uniqueId, "_reset");
            cells[i].innerHTML = "<input id=\"".concat(_cbId, "\" class=\"checkbox\" checked=\"checked\" readonly=\"readonly\" type=\"checkbox\"/>");
            window.initDocument(cells[i], false, false);
          }
        }
      },
      scope: this,
      silent: true
    });
  },
  initTable: function initTable() {
    YAHOO.fcom.Broadcaster.initBroadcastLinks(this.channelName, this.moduleId);
    var cells = YAHOO.util.Selector.query('.watchlistfidlet', this.largeTableId);
    if (cells.length) {
      this.initWatchlistFidlets(cells);
    }
    YAHOO.fcom.Broadcaster.subscribe('.selectionWatchlistChanged', this.onSelectionWatchlistChange, this);
    YAHOO.fcom.Broadcaster.subscribe('.favoritesWatchlistChanged', this.onFavoritesWatchlistChange, this);
  }
};
window.YAHOO.fcom.ExtendedWatchlistModule = ExtendedWatchlistModule;
var _default = exports.default = ExtendedWatchlistModule;

},{}],32:[function(require,module,exports){
"use strict";

var _HistoricalKpiChartContainer = _interopRequireDefault(require("modules/HistoricalKpiChartModule/HistoricalKpiChartContainer"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// register the module and its callback function
window.fcom.moduleHandler.registerModuleType('HistoricalKpiChartModule', function (node, config, themeConfig) {
  var $kpiMenu = $("#".concat(node.id, "_kpiMenu"));
  config.kpi = $kpiMenu.val();
  var moduleInstance = new _HistoricalKpiChartContainer.default(node, config, themeConfig);
  $kpiMenu.change(function () {
    moduleInstance.setKpi($kpiMenu.val());
  });
  $(node).find('[data-days]').click(function () {
    moduleInstance.setDays($(this).data('days'));
  });
  $(node).find('[data-scale]').click(function () {
    moduleInstance.setChartScale($(this).data('scale'));
  });
  $(node).find('[data-periodicity]').click(function () {
    moduleInstance.setFixedInterval($(this).data('periodicity'));
    $(node).find('[data-periodicity]').removeClass('on');
    $(this).addClass('on');
  });

  // init receiver channel behaviour
  if (config.receiverChannel) {
    moduleInstance['@broadcast'] = _defineProperty({}, config.receiverChannel, function (message) {
      if (message.messageType === 'ric') {
        moduleInstance.setRic(message.ric);
      } else if (message.messageType === 'multiRic') {
        moduleInstance.setRic(message.rics);
      }
      var subPage = $("#".concat(node.id, "_sendChannelLink")).data('sub-page');
      var hrefURL = "".concat(window.ctx, "/detail/detailPage.html?ric=").concat(message.ric).concat(subPage);
      $("#".concat(node.id, "_sendChannelLink")).attr('href', hrefURL);
    });
  }
  return moduleInstance;
}, true);

},{"modules/HistoricalKpiChartModule/HistoricalKpiChartContainer":33}],33:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _getStatusMessageFromError = _interopRequireDefault(require("util/functions/getStatusMessageFromError"));
var _SingleChart = _interopRequireWildcard(require("modules/InstrumentChartModule/SingleChart"));
var _timeSeriesConverter = require("modules/InstrumentChartModule/timeSeriesConverter");
var _tabmenuAccessibility = require("fcom/aria/tabmenuAccessibility");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var DEBUGMODE = false;
var chartMinHeight = 170;
var ChartContainer = function ChartContainer(node, config, themeConfig) {
  var _this = this;
  this.node = node;
  this.config = config;
  this.themeConfig = themeConfig;
  this.charts = [];
  this.kpi = config.kpi;
  this.init();
  this.chartScale = this.scale === 'absolute' ? _SingleChart.CHARTSCALE.ABSOLUTE : _SingleChart.CHARTSCALE.RELATIVE;

  //setup point syncing
  $(this.node).find('.chartImageBox').bind('mousemove touchmove touchstart', function (e) {
    if (!$(e.target).parents('svg').length) {
      return;
    }
    _this.charts.forEach(function (chartItem) {
      var normalizedEvent = chartItem.chart.pointer.normalize(e.originalEvent);
      var points = chartItem.chart.series.map(function (series) {
        return series.searchPoint(normalizedEvent, true);
      }).filter(function (f) {
        return f;
      });
      if (points.length) {
        chartItem.chart.tooltip.refresh(points, e); // Show the tooltip
        chartItem.chart.xAxis[0].drawCrosshair(e, points[0]); // Show the crosshair
      }
    });
  });

  $(this.node).find('.chartImageBox').bind('mouseout touchend', function () {
    _this.charts.forEach(function (chartItem) {
      chartItem.chart.tooltip.hide();
      chartItem.chart.xAxis[0].hideCrosshair();
      chartItem.chart.series.forEach(function (series) {
        return series.points.forEach(function (point) {
          return point.select(false);
        });
      });
    });
  });

  //delay loading in order to wait for the module to render in a proper width, otherwise it will render too many data points
  if (!config.suppressInitialRequest) {
    window.setTimeout(function () {
      _this.triggerInitialRequest();
    }, 50);
  }
};
ChartContainer.prototype.triggerInitialRequest = function () {
  var _this2 = this;
  //get initial data
  var promise = this.getInitialData().then(function (chartData) {
    _this2.setChartData(chartData);
    if (!_this2.config.hasFixedTitle) {
      $(_this2.node).find('.moduleHeader .title .content').html(_this2.title || chartData[0].title);
    }
    _this2.render();
  });
  if (!DEBUGMODE) {
    promise.catch(function (err) {
      var ricText = _this2.rics ? _this2.rics[0] || '' : '';
      if (!_this2.config.hasFixedTitle) {
        $(_this2.node).find('.moduleHeader .title .content').text(ricText);
      }
      _this2.showError(window.getMessage((0, _getStatusMessageFromError.default)(err), ricText));
    });
  }
};
ChartContainer.prototype.getInterval = function () {
  return this.fixedInterval;
};
ChartContainer.prototype.setFixedInterval = function (interval) {
  if (this.fixedInterval !== interval) {
    this.fixedInterval = interval;
    this.reload();
  }
  return this;
};
ChartContainer.prototype.setKpi = function (kpi) {
  if (this.kpi !== kpi) {
    this.kpi = kpi;
    this.reload();
  }
  return this;
};
ChartContainer.prototype.getKpi = function () {
  return this.kpi;
};
ChartContainer.prototype.reload = function () {
  var _this3 = this;
  if (this.frozen) {
    return this;
  }

  //set a timer in order to prevent ui flickering when responses are very fast (<250ms)
  var timer = window.setTimeout(function () {
    _this3.showError(window.getMessage('module.frontend.status.NOT_READY', _this3.rics[0]));
  }, 250);
  var promise = this.getInitialData().then(function (chartData) {
    return _this3.handleReloadPromise(timer, chartData);
  });
  if (!DEBUGMODE) {
    promise.catch(function (err) {
      if (err.message === 'negativeLogarithmicData') {
        _this3.showError(window.getMessage('module.frontend.status.NEGATIVELOGARITHMICDATAERROR', _this3.rics[0]));
        return;
      }
      window.clearTimeout(timer);
      if (!_this3.config.hasFixedTitle) {
        $(_this3.node).find('.moduleHeader .title .content').text(_this3.rics[0]);
      }
      _this3.showError(window.getMessage((0, _getStatusMessageFromError.default)(err), _this3.rics[0]));
      if (err.code === 400) {
        _this3.showError(err.message);
      }
    });
  }
  return this;
};
ChartContainer.prototype.handleReloadPromise = function (timer, chartData) {
  window.clearTimeout(timer);
  this.setChartData(chartData);
  if (!this.config.hasFixedTitle) {
    $(this.node).find('.moduleHeader .title .content').text(this.title || chartData[0].title);
  }
  this.render();
};
ChartContainer.prototype.setChartData = function (chartData) {
  var _this4 = this;
  this.mainChartDataStatus = chartData[0].status || 'OK';
  this.instrumentType = chartData[0].instrumentType;
  // save some meta information from chartData
  // use first charts end and start time to determine the time possible range
  this.startTimestamp = chartData[0].timestampChart;
  chartData = chartData.map(function (d) {
    var dat = Object.keys(d.data).reduce(function (all, x) {
      all[x] = d.data[x];
      return all;
    }, {});
    d.data = (0, _timeSeriesConverter.joinSeries)(dat);
    return d;
  });
  {
    // unify timestamps across all series
    var timestamps = chartData.map(function (c) {
      return c.data.map(function (d) {
        return d.timestamp;
      });
    }).reduce(function (all, a) {
      return [].concat(_toConsumableArray(all), _toConsumableArray(a));
    }, []).filter(function (f, i, array) {
      return array.indexOf(f) === i;
    }).sort(function (a, b) {
      return a - b;
    });
    if (timestamps.length) {
      timestamps.push(timestamps[timestamps.length - 1] * 2 - timestamps[timestamps.length - 2]);
    }
    chartData = chartData.map(function (d) {
      d.data = timestamps.map(function (timestamp) {
        var close = (d.data.find(function (f) {
          return f.timestamp === timestamp;
        }) || {
          close: null
        }).close;
        return close ? {
          timestamp: timestamp,
          close: close
        } : {
          timestamp: timestamp
        };
      });
      // Need to keep the empty data point at the end only for the column type chart
      if (_this4.type !== 'column') {
        d.data = d.data.filter(function (i) {
          return i.close;
        });
      }
      return d;
    });
  }
  this.chartData = chartData.reduce(function (charts, instrumentData, instrumentIndex) {
    var dataArrays = (0, _timeSeriesConverter.getDataArraysFromTimeSeries)(instrumentData.data, true);
    var prepend = _this4.type === 'column' && dataArrays.close[1] ? [{
      timestamp: dataArrays.close[0].timestamp * 2 - dataArrays.close[1].timestamp
    }] : [];
    var data = prepend.concat(dataArrays.close);
    var colorBasedOnIndex = instrumentIndex ? _this4.themeConfig.chartColors.additionals[instrumentIndex - 1] : _this4.themeConfig.chartColors.neutral;

    // build a config object for the primary line
    var config = {
      zIndex: 2,
      color: colorBasedOnIndex
    };

    // find the close value in primary data array that will be used as 0% baseline for comparison
    var baselineValue = (instrumentData.data[instrumentData.data.length - 1] || {
      close: null
    }).close;
    var instrumentName = instrumentData.shortTitle || instrumentData.title;

    // generate main primary series
    charts.push({
      series: [{
        name: instrumentName,
        tooltipName: instrumentName,
        type: _this4.getType(),
        baselineValue: baselineValue,
        config: config,
        data: data
      }]
    });
    return charts;
  }, []);
  return this;
};
ChartContainer.prototype.showError = function (errorText) {
  $(this.node).find('.chartImageBox [data-chartcontainer]').hide();
  $(this.node).find('.chartImageBox .hint').remove();
  $(this.node).find('.chartImageBox').append("<div class=\"hint\">".concat(errorText, "</div>"));
  return this;
};
ChartContainer.prototype.hideError = function () {
  $(this.node).find('.chartImageBox [data-chartcontainer]').show();
  $(this.node).find('.chartImageBox .hint').remove();
  return this;
};
ChartContainer.prototype.getChartWidth = function () {
  return $(this.node).find('.chartImageBox').width();
};
ChartContainer.prototype.freeze = function () {
  this.frozen = true;
  return this;
};
ChartContainer.prototype.unfreeze = function () {
  this.frozen = false;
  return this;
};
ChartContainer.prototype.render = function (targetNode) {
  var _this5 = this;
  targetNode = targetNode || this.node;
  var sandboxed = targetNode !== this.node;
  if (this.frozen) {
    return this;
  }
  if (!sandboxed) {
    this.hideError();
    if (!this.chartData.length || !this.chartData[0].series.length || !this.chartData[0].series[0].data.length) {
      var statusMessageId = this.instrumentType === 'STO' ? 'INVALID_ITEM' : 'INVALID_TYPE';
      if (['ERROR', 'MAYBE', 'OLD', 'NEVER'].indexOf(this.mainChartDataStatus) > -1) {
        statusMessageId = this.mainChartDataStatus;
      }
      this.showError(window.getMessage("module.frontend.status.".concat(statusMessageId), this.rics[0]));
      return this;
    }
  }
  var $chartContainer = $(targetNode).find('[data-chartcontainer]');
  $chartContainer.empty();
  var totalHeight = $chartContainer.height();
  var chartHeight = Math.floor(totalHeight / this.chartData.length);

  // destroy old charts to prevent memory leak
  if (!sandboxed) {
    this.charts.map(function (singleChartObject) {
      return singleChartObject.chart.destroy();
    });
    this.charts = [];
  }
  this.chartData.forEach(function (data, i, arr) {
    var $container = $("<div style=\"height:".concat(chartHeight, "px;\"/>"));
    $chartContainer.append($container);
    var chartConfig = _this5.getChartConfiguration(i, i + 1 === arr.length);
    var chart = new _SingleChart.default($container.get(0), data, chartConfig);
    if (!sandboxed) {
      _this5.charts.push(chart);
    }
  });
  return this;
};
ChartContainer.prototype.setTooltipsDisabled = function (disabled) {
  this.config.disableTooltips = disabled;
  return this;
};
ChartContainer.prototype.getChartConfiguration = function (chartIndex, isLast) {
  var disableAxis = {
    xAxis: [{
      tickWidth: 0,
      labels: {
        enabled: false
      }
    }]
  };
  var chartConfig = {
    dataType: 'close',
    days: this.getDays(),
    themeConfig: Object.assign({}, this.themeConfig, isLast ? {} : disableAxis),
    // only enable xAxis for the last chart
    interval: this.getInterval(),
    isComplex: this.isComplex,
    chartScale: this.chartScale,
    showLegend: this.config.showLegend,
    multiChart: this.chartData.length > 1,
    digits: 3
  };
  return Object.assign({}, chartConfig);
};
ChartContainer.prototype.setRic = function (rics) {
  rics = [].concat(rics);
  if (this.rics.join(',') !== rics.join(',')) {
    this.rics = [].concat(rics);
    this.reload();
  }
  if (!rics || rics.length === 0) {
    this.rics = this.getConfigRic();
    this.reload();
  }
  return this;
};
ChartContainer.prototype.setName = function (names) {
  this.seriesNames = [].concat(names);
  return this;
};
ChartContainer.prototype.setTitle = function (title) {
  this.title = title || null;
  return this;
};
ChartContainer.prototype.getDays = function () {
  return this.days;
};
ChartContainer.prototype.getType = function () {
  return this.type;
};
ChartContainer.prototype.setDays = function (days) {
  if (this.days !== days) {
    this.days = days;
    $(this.node).find('[data-days]').removeClass('on');
    $(this.node).find("[data-days=".concat(days, "]")).addClass('on');
    this.reload();
  }
  return this;
};
ChartContainer.prototype.setChartScale = function (scaleName) {
  this.chartScale = {
    absolute: _SingleChart.CHARTSCALE.ABSOLUTE,
    relative: _SingleChart.CHARTSCALE.RELATIVE,
    logarithmic: _SingleChart.CHARTSCALE.LOGARITHMIC
  }[scaleName];
  this.chartData[0].series[0].type = this.getType(); // force update the type in the series

  $(this.node).find('[data-scale]').removeClass('on');
  $(this.node).find("[data-scale=".concat(scaleName, "]")).addClass('on');
  this.render();
  return this;
};
ChartContainer.prototype.setExtraCallParameters = function (params) {
  this.extraCallParams = params;
  return this;
};
ChartContainer.prototype.getConfigRic = function () {
  var _this6 = this;
  var readDataFromNode = function readDataFromNode(dataName) {
    var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return $(_this6.node).find("[data-".concat(dataName, "]").concat(selector)).first().data(dataName);
  };
  return (readDataFromNode('ric') || '').split(',').filter(function (f) {
    return f;
  });
};
ChartContainer.prototype.init = function () {
  var _this7 = this;
  this.freeze();
  var readDataFromNode = function readDataFromNode(dataName) {
    var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return $(_this7.node).find("[data-".concat(dataName, "]").concat(selector)).first().data(dataName);
  };
  this.type = readDataFromNode('type');
  this.rics = (readDataFromNode('ric') || '').split(',').filter(function (f) {
    return f;
  });
  this.fixedInterval = readDataFromNode('periodicity', '.on');
  this.scale = readDataFromNode('scale', '.on');
  this.days = readDataFromNode('days', '.on');
  this.days = this.days != null ? this.days : readDataFromNode('days-default');
  this.id = $(this.node).attr('id');
  this.title = readDataFromNode('title') || null;
  this.seriesNames = [];
  this.setChartData([{
    data: []
  }]);
  this.initAccessibility();
  return this.unfreeze();
};
ChartContainer.prototype.getInitialData = function () {
  var _this8 = this;
  var data = this.rics.map(function (ric) {
    return {
      ric: ric
    };
  });
  if (!data || !data[0]) {
    return Promise.resolve([{
      data: []
    }]);
  }
  var $chartContainer = $(this.node).find('[data-chartcontainer]');
  var totalHeight = $chartContainer.height();
  var maxCharts = Math.floor(totalHeight / chartMinHeight);
  data = data.slice(0, maxCharts + 1);
  return Promise.all(data.map(function (ric, i) {
    var params = Object.assign({
      method: 'getInstrumentChart',
      interval: _this8.getInterval(),
      days: _this8.getDays(),
      kpi: _this8.getKpi()
    }, ric, _this8.extraCallParams || {});
    var returnPromise = window.ajaxGetJson('/kpiseries.action', params);
    if (i) {
      // dont catch for the first ric, in order to display a proper error
      return returnPromise.catch(function () {
        return null;
      });
    }
    return returnPromise;
  })).then(function (dataSet) {
    return dataSet.filter(function (a, i) {
      return !i || a !== null;
    });
  });
};
ChartContainer.prototype.initAccessibility = function () {
  var $moduleTabMenu = $(this.node).find('div.moduleTabMenu div.menu');
  (0, _tabmenuAccessibility.setAriaAttributesToModuleTabMenu)($moduleTabMenu);
};
ChartContainer.prototype['@resize'] = function () {
  this.reload();
};
var _default = exports.default = ChartContainer;

},{"fcom/aria/tabmenuAccessibility":2,"modules/InstrumentChartModule/SingleChart":102,"modules/InstrumentChartModule/timeSeriesConverter":104,"util/functions/getStatusMessageFromError":141}],34:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var HistoricalTimeSeriesDataModule = function HistoricalTimeSeriesDataModule(node, config, themeConfig) {
  var _this = this;
  config.theme = themeConfig;
  var viewId = window.YAHOO.fcom.Page.getInstance('moduleContainer').id;
  var moduleId = node.id;
  var showBtn = window.YAHOO.widget.Button.getButton("".concat(moduleId, "_show"));
  var saveValues = function saveValues() {
    var ric = $("#".concat(moduleId, "_searchRicPopup__hidden")).val();
    var $toDate = YAHOO.fcom.Page.getInstance("".concat(moduleId, "_historicDataTo"));
    var $fromDate = YAHOO.fcom.Page.getInstance("".concat(moduleId, "_historicDataFrom"));
    var fromDateMs = new Date($fromDate.getDate() || '').getTime();
    var toDateMs = new Date($toDate.getDate() || '').getTime();
    var periodicity = $("#".concat(moduleId, "_periodicity")).val();
    var postData = {
      method: 'changeModule',
      viewId: viewId,
      moduleId: moduleId,
      ric: ric,
      period: periodicity,
      startTime: fromDateMs,
      endTime: toDateMs
    };
    var url = '/module.action';
    var reloadCallback = function reloadCallback() {
      window.reloadModuleContent(moduleId, viewId, "".concat(moduleId, "_div"), ric).then(function () {
        config.ric = ric;
        window.fcom.moduleHandler.initModule(node);
      });
    };
    window.ngpAsyncRequest('POST', url, reloadCallback, postData, null, false, false);
  };
  YAHOO.fcom.Page.onReady(function () {
    showBtn.addListener('click', saveValues);
    var searchHandler = YAHOO.fcom.Page.getInstance("".concat(moduleId, "_searchRicPopup"));
    if (searchHandler) {
      searchHandler.itemFoundEvent.subscribe(saveValues);
    }
    var fromDateHandler = YAHOO.fcom.Page.getInstance("".concat(moduleId, "_historicDataFrom"));
    if (fromDateHandler) {
      fromDateHandler.dateChanged.subscribe(saveValues);
    }
    var toDateHandler = YAHOO.fcom.Page.getInstance("".concat(moduleId, "_historicDataTo"));
    if (toDateHandler) {
      toDateHandler.dateChanged.subscribe(saveValues);
    }
    var periodicityHandler = YAHOO.fcom.Page.getInstance("".concat(moduleId, "_periodicity"));
    if (periodicityHandler) {
      periodicityHandler.changeEvent.subscribe(saveValues);
    }
    _this['@destroy'] = function () {
      showBtn.removeListener('click', saveValues);
      searchHandler.itemFoundEvent.unsubscribe(saveValues);
      fromDateHandler.dateChanged.unsubscribe(saveValues);
      toDateHandler.dateChanged.unsubscribe(saveValues);
      periodicityHandler.changeEvent.unsubscribe(saveValues);
    };
  });
  if (config.receiverChannel) {
    this['@broadcast'] = _defineProperty({}, config.receiverChannel, function (message) {
      if (message.messageType === 'ric') {
        $("#".concat(moduleId, "_searchRicPopup__hidden")).val(message.ric);
        saveValues();
      }
    });
  }
};
window.fcom.moduleHandler.registerModuleType('HistoricalTimeSeriesDataModule', function (node, config, themeConfig) {
  return new HistoricalTimeSeriesDataModule(node, config, themeConfig);
});
var _default = exports.default = HistoricalTimeSeriesDataModule;

},{}],35:[function(require,module,exports){
"use strict";

var _ChartContainer = _interopRequireDefault(require("modules/InstrumentChartModule/ChartContainer"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
//register the module and its callback function
window.fcom.moduleHandler.registerModuleType('InstrumentChartModule', function (node, config, themeConfig) {
  if (config.chartLegend) {
    config = addLegend(config, themeConfig.chartColors);
  }
  var moduleInstance = new _ChartContainer.default(node, config, themeConfig);
  //init receiver channel behaviour
  if (config.receiverChannel) {
    moduleInstance['@broadcast'] = _defineProperty({}, config.receiverChannel, function (message) {
      if (message.type === 'InstrumentChartModule') {
        moduleInstance.freeze();
        if (message.ric) {
          moduleInstance.setRic(message.ric);
        }
        if (message.name) {
          moduleInstance.setName(message.name);
        }
        if (message.title) {
          moduleInstance.setTitle(message.title);
        }
        if (message.chartType) {
          moduleInstance.setType(message.chartType);
        }
        if (message.interval) {
          moduleInstance.setFixedInterval(message.interval);
        }
        if (message.days) {
          moduleInstance.setDays(message.days);
        }
        moduleInstance.unfreeze();
        moduleInstance.reload();
      } else if (message.ric) {
        moduleInstance.replaceRic([message.ric]);
      } else if (message.messageType === 'multiRic') {
        moduleInstance.setRic(message.rics);
      }
    });
  }
  $("#".concat(moduleInstance.id, "_exportChartCSV")).click(function () {
    moduleInstance.exportCSV();
  });
  moduleInstance.initTooltipSynchronization();
  return moduleInstance;
});
var addLegend = function addLegend(config, colors) {
  return Object.assign(config, {
    legend: {
      align: 'left',
      verticalAlign: 'top',
      floating: true,
      padding: 3,
      backgroundColor: colors.legendBackground || 'transparent',
      itemStyle: {
        color: colors.labels,
        cursor: 'auto',
        fontWeight: 'normal',
        fontSize: '11px'
      },
      itemHoverStyle: {
        color: colors.labels
      }
    },
    showLegend: true
  });
};

},{"modules/InstrumentChartModule/ChartContainer":36}],36:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _mergeObjects = _interopRequireDefault(require("util/functions/mergeObjects"));
var _hexToRgba = _interopRequireDefault(require("util/functions/hexToRgba"));
var _getStatusMessageFromError = _interopRequireDefault(require("util/functions/getStatusMessageFromError"));
var _SingleChart = _interopRequireWildcard(require("modules/InstrumentChartModule/SingleChart"));
var _intervalMapper = _interopRequireDefault(require("modules/InstrumentChartModule/intervalMapper"));
var _timeSeriesConverter = require("modules/InstrumentChartModule/timeSeriesConverter");
var _indicators = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/indicators"));
var _debounce = _interopRequireDefault(require("lodash/debounce"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; } /**
                                                                       * @module modules/InstrumentChartModule/ChartContainer
                                                                       */
var DEBUGMODE = false;
var getIndicatorOptions = function getIndicatorOptions(indicator, i, colors) {
  var options = indicator.getOptions ? indicator.getOptions(i) : {};
  if (options.config && options.config.zones) {
    options.config.zones = options.config.zones.map(function (zone) {
      var color = zone.fillColor = colors[zone.fillColor] || zone.fillColor;
      if (color.startsWith('#')) {
        color = (0, _hexToRgba.default)(color, 0.6);
      }
      zone.fillColor = color;
      return zone;
    });
  }
  return options;
};
var getTypeForIndicator = function getTypeForIndicator(indicator, index) {
  var defaultType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'line';
  return indicator.getType ? indicator.getType(index) || defaultType : defaultType;
};
var getColorForIndicator = function getColorForIndicator(indicator, index, defaultColor) {
  return indicator.getColor ? indicator.getColor(index) || defaultColor : defaultColor;
};
var getLineStyleForIndicator = function getLineStyleForIndicator(indicator, index) {
  var defaultLineStyle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'ShortDot';
  return indicator.getLineStyle ? indicator.getLineStyle(index) || defaultLineStyle : defaultLineStyle;
};
var DATAPOINT = {
  OPEN: 'open',
  HIGH: 'high',
  LOW: 'low',
  CLOSE: 'close',
  BID: 'bid',
  ASK: 'ask',
  VOLUME: 'volume',
  TIMESTAMP: 'timestamp'
};

/**
 * InstrumentChartModule is the module that will be registered and uses instances of SingleChart to render data.
 * Unusual params are config.gapSize and config.gapUnit, params that override the series display in SingleChart.
 * @class
 * @param {HTMLElement} node
 * @param {Object} config
 * @param {Object} themeConfig
 */
var ChartContainer = function ChartContainer(node, config, themeConfig) {
  var _this2 = this;
  this.node = node;
  this.config = config;
  this.themeConfig = themeConfig;
  this.charts = [];
  this.chartIndicators = [];
  this.extraChartIndicators = [];
  this.init();
  this.chartScale = this.scale === 'absolute' ? _SingleChart.CHARTSCALE.ABSOLUTE : _SingleChart.CHARTSCALE.RELATIVE;
  this.libConfig = $(this.node).data('moduleLibconfig'); //additional properties for chart
  this.reload = (0, _debounce.default)(this.reload, 150);
  this.showBenchmarkErrors = true;
  this.compareRics = false;
  // delay loading in order to wait for the module to render in a proper width, otherwise it will render too many data points
  if (!config.suppressInitialRequest) {
    window.setTimeout(function () {
      _this2.triggerInitialRequest();
    }, 50);
  }
};

/**
 * @returns {this}
 */
ChartContainer.prototype.triggerInitialRequest = function () {
  var _this3 = this;
  // get initial data
  var promise = this.getInitialData().then(function (chartData) {
    _this3.setChartData(chartData);
    if (!_this3.config.hasFixedTitle) {
      $(_this3.node).find('.moduleHeader .title .content').html(_this3.title || chartData[0].title || (_this3.rics && _this3.rics.length ? _this3.rics[0] || '' : ''));
    }
    _this3.setPerformanceText(chartData);
    _this3.render();
    var Streaming = window.YAHOO.fcom.Streaming;
    if (Streaming.streamingService) {
      var streamingInit = function streamingInit() {
        Streaming.streamingService.addSingleItemCallback(_this3.streamCallback);
      };
      window.setTimeout(function () {
        // check is streaming is available and register callback
        if (Streaming.streamingService.isAvailable()) {
          streamingInit();
        } else {
          Streaming.streamingServiceAvailable.subscribe(streamingInit);
        }
      }, 150);
    }
  });
  if (!DEBUGMODE) {
    promise.catch(function (err) {
      var ricText = _this3.rics ? _this3.rics[0] || '' : '';
      if (!_this3.config.hasFixedTitle) {
        $(_this3.node).find('.moduleHeader .title .content').text(ricText);
      }
      _this3.showError(window.getMessage((0, _getStatusMessageFromError.default)(err, _this3.config.isMiniChart), ricText));
      if (err.code === 400) {
        _this3.showError(err.message);
      }
    });
  }
};

/**
 * @returns {Number} days
 */
ChartContainer.prototype.getInterval = function () {
  return this.fixedInterval || (0, _intervalMapper.default)(this.getDays(), this.getChartWidth() - 60, this.isComplex, this.historicOnly);
};

/**
 * @param {Number} interval - fixed interval in days
 * @returns {this}
 */
ChartContainer.prototype.setFixedInterval = function (interval) {
  if (this.fixedInterval !== interval) {
    this.fixedInterval = interval;
    this.reload();
  }
  return this;
};

/**
 * @returns {bool}
 */
ChartContainer.prototype.getIsStreaming = function () {
  // if interval can be cast to a numeric value higher than 0 and it is only one ric
  return +this.getInterval() > 0 && this.rics.length === 1;
};
ChartContainer.prototype.getLastPoint = function (rawData) {
  var lastIndex = rawData.timestamp.length - 1;
  var lastPoint = Object.keys(rawData).reduce(function (all, dataKey) {
    all[dataKey] = rawData[dataKey][lastIndex];
    return all;
  }, {});
  return lastPoint;
};

/**
 * @param {string} type - datatype, for example 'close'
 * @param {Object} dataPoint - containing streamed value and timestamp
 * @returns {this}
 */
ChartContainer.prototype.addStreamingDataPoint = function (type, dataPoint) {
  var timeStep = +this.getInterval() * 1000 * 60;
  var rawData = this.rawChartData[0].data;
  var lastPoint = this.getLastPoint(rawData);
  var newPoint;
  if (type === 'close' || type === 'yield') {
    if (dataPoint.timestamp > lastPoint.timestamp) {
      // add an empty point to be filled later
      Object.keys(rawData).forEach(function (dataKey) {
        return rawData[dataKey].push(null);
      });
      newPoint = {
        timestamp: Math.ceil(dataPoint.timestamp / timeStep) * timeStep,
        open: dataPoint.value,
        high: dataPoint.value,
        low: dataPoint.value,
        close: dataPoint.value
      };
      if (type === 'yield') {
        newPoint['close'] = lastPoint.close;
        newPoint['yield'] = dataPoint.value;
      }
    } else {
      // reuse and update old point
      newPoint = {
        timestamp: lastPoint.timestamp,
        open: lastPoint.open || dataPoint.value,
        high: lastPoint.high ? Math.max(lastPoint.high, dataPoint.value) : dataPoint.value,
        low: lastPoint.low ? Math.min(lastPoint.low, dataPoint.value) : dataPoint.value,
        close: dataPoint.value
      };
      if (type === 'yield') {
        newPoint['close'] = lastPoint.close;
        newPoint['yield'] = dataPoint.value;
      }
    }
    Object.keys(rawData).forEach(function (dataKey) {
      return rawData[dataKey][rawData[dataKey].length - 1] = newPoint[dataKey] || null;
    });
    this.setChartData(this.rawChartData);
    if (!this.pauseStreamingRender) {
      this.render();
    }
  }
  return this;
};

/**
 * @returns {this}
 * Added debounce to prevent sending multiple ajax request for data when updating via link mode.
 */
ChartContainer.prototype.reload = function () {
  var _this4 = this;
  if (this.frozen) {
    return this;
  }

  // set a timer in order to prevent ui flickering when responses are very fast (<250ms)
  var timer = window.setTimeout(function () {
    _this4.showError(window.getMessage('module.frontend.status.NOT_READY', _this4.rics[0]));
  }, 250);
  var promises = [this.getInitialData()];
  if (!this.pfid && this.rics && this.rics.length > 0) {
    promises.push(window.ajaxGet('/template/modules/detail/includes/instrumentChartPriceInfo.inc.plain', {
      ric: this.rics[0]
    }));
  }
  var promise = Promise.all(promises).then(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      chartData = _ref2[0],
      chartPriceHtml = _ref2[1];
    return _this4.handleReloadPromise(timer, chartData, chartPriceHtml);
  });
  if (!DEBUGMODE) {
    promise.catch(function (err) {
      if (err.message === 'negativeLogarithmicData') {
        _this4.showError(window.getMessage('module.frontend.status.NEGATIVELOGARITHMICDATAERROR', _this4.rics[0]));
        return;
      }
      window.clearTimeout(timer);
      if (!_this4.config.hasFixedTitle) {
        $(_this4.node).find('.moduleHeader .title .content').text(_this4.rics[0]);
      }
      _this4.showError(window.getMessage((0, _getStatusMessageFromError.default)(err, _this4.config.isMiniChart), _this4.rics[0]));
      if (err.code === 400) {
        _this4.showError(err.message);
      }
    });
  }
  return this;
};
ChartContainer.prototype.handleReloadPromise = function (timer, chartData, chartPriceHtml) {
  var $chartPriceInfoElem = $(this.node).find('.moduleContent .price-chart-price-info');
  window.YAHOO.fcom.Streaming.removeStreamingNodes($chartPriceInfoElem.get());
  if (chartPriceHtml) {
    $chartPriceInfoElem.replaceWith(chartPriceHtml);
  }
  window.YAHOO.fcom.Streaming.addStreamingNodes($(this.node).find('.moduleContent .price-chart-price-info').get());
  window.clearTimeout(timer);
  this.setChartData(chartData);
  if (!this.config.hasFixedTitle) {
    $(this.node).find('.moduleHeader .title .content').text(this.title || chartData[0].title || (this.rics && this.rics.length ? this.rics[0] || '' : ''));
  }
  this.setPerformanceText(chartData);
  var chartLinkTemplate = $(this.node).find('.chartImageBox').data('chartlinktemplate');
  var arg = {
    ric: this.rics[0],
    ctx: window.ctx
  };
  if (chartLinkTemplate) {
    var chartLink = chartLinkTemplate.replace(/\$\{([A-Za-z]+)\}/g, function (match, p1) {
      return arg[p1.toLowerCase()];
    });
    $(this.node).find('.chartImageBox a').attr('href', chartLink);
  }
  this.setTimeSeriesLink();
  this.render();
};
ChartContainer.prototype.setPerformanceText = function (chartData) {
  var textNode = $(this.node).find('.performanceName');
  if (!textNode.length) {
    var outer = $(this.node.parentNode).closest('.module')[0];
    if (outer) {
      textNode = $(outer).find('.performanceName');
    }
  }
  if (textNode.length) {
    var text = this.getPerformanceTitle();
    var numNode = $(textNode[0].parentNode).find('.performancePercentage');
    if (numNode.length) {
      var mainChart = chartData[0];
      var series = mainChart ? mainChart.data : null;
      var firstSample = series ? series[0] : null;
      var firstValue = parseFloat(firstSample ? firstSample.close : null);
      var lastSample = series && series.length ? series[series.length - 1] : null;
      var lastValue = parseFloat(lastSample ? lastSample.close : null);
      if (mainChart && this.getDays() === 1) {
        firstValue = parseFloat(mainChart.previousClose);
      }
      if (firstValue !== 0 && !isNaN(firstValue) && !isNaN(lastValue)) {
        var performance = 100 * (lastValue - firstValue) / firstValue;
        var perfString = performance.toFixed(2);
        if (perfString.startsWith('-')) {
          numNode.removeClass('up');
          numNode.addClass('down');
          text += ' down';
        } else {
          numNode.removeClass('down');
          if (perfString === '0.00') {
            numNode.removeClass('up');
          } else {
            perfString = '+' + perfString;
            text += ' up';
            numNode.addClass('up');
          }
        }
        numNode.text(perfString + '%');
      } else {
        numNode.text('-');
        numNode.removeClass('up');
        numNode.removeClass('down');
      }
    }
    textNode.text(text);
  }
};
ChartContainer.prototype.getPerformanceTitle = function () {
  var days = this.getDays();
  var text = '',
    maxFlag = false;
  switch (days) {
    case 1:
      text = 'Today\'s performance';
      break;
    case 2:
      text = 'Two-day performance';
      break;
    case 7:
      text = 'Week performance';
      break;
    case 15:
      text = 'Two-week performance';
      break;
    case 30:
      text = 'Month performance';
      break;
    case 90:
      text = 'Three-month performance';
      break;
    case 185:
      text = 'Six-month performance';
      break;
    case 365:
      text = 'Year performance';
      break;
    case 730:
      text = 'Two-year performance';
      break;
    case 1825:
      text = 'Five-year performance';
      break;
    case 3650:
      text = 'Ten-year performance';
      break;
    case 14965:
      maxFlag = true;
      text = 'Performance within maximum available time';
      break;
    default:
      text = 'Current year performance';
      break;
  }
  if (this.config.displayPriceText) {
    return maxFlag ? text.replace('Performance', 'Price performance') : text.replace('performance', 'price performance');
  } else {
    return text;
  }
};

/**
 * @param {function} callbackFunction
 */
ChartContainer.prototype.setChartDataCallback = function (callbackFunction) {
  this.chartDataCallback = callbackFunction;
};

/**
 * @param {Array[]} chartData
 * @returns {this}
 */
ChartContainer.prototype.setChartData = function (chartData) {
  var _this5 = this;
  this.rawChartData = JSON.parse(JSON.stringify(chartData)); // make a hard copy for streaming

  this.mainChartDataStatus = chartData[0].status || 'OK';
  if (new RegExp(/^\d+$/).test(this.mainChartDataStatus)) {
    this.mainChartDataStatus = chartData[0].errorMessage || chartData[0].title;
  }
  // save some meta information from chartData
  // use first charts end and start time to determine the time possible range
  this.tradingEnd = chartData[0].tradingEnd || null;
  this.tradingStart = chartData[0].tradingStart || null;
  this.previousClose = chartData[0].previousClose || null;
  this.startTimestamp = chartData[0].timestampChart;
  this.title = null;
  var setUBSChartData = function setUBSChartData(d, startValue) {
    var baseVal = null;
    _this5.previousClose = startValue;
    if (d.timestampChart === _this5.startTimestamp) {
      var startVal = d.data.find(function (f) {
        return f.timestamp >= _this5.startTimestamp;
      });
      if (startVal) {
        baseVal = startVal.close;
      }
    } else {
      baseVal = d.previousClose;
      d.previousClose = startValue;
    }
    d.data.forEach(function (x) {
      x.close = Number((startValue * x.close / baseVal).toFixed(2));
    });
    return d;
  };
  chartData = chartData.map(function (d) {
    var dat = Object.keys(d.data).reduce(function (all, x) {
      all[x] = d.data[x];
      return all;
    }, {});
    d.data = (0, _timeSeriesConverter.joinSeries)(dat);
    if (_this5.config.hypInvAmt) {
      d = setUBSChartData(d, _this5.config.hypInvAmt);
    }
    return d;
  });
  this.hideError();
  var errors = [];

  // filter data for benchmarks to only use points that exist in the main ric if there are any extraCharts
  if (this.extraChartIndicators.length) {
    var mainTimestamps = chartData[0].data.map(function (_ref3) {
      var timestamp = _ref3.timestamp;
      return timestamp;
    });
    chartData.forEach(function (d, index) {
      if (index > 0) {
        d.data = d.data.filter(function (_ref4) {
          var timestamp = _ref4.timestamp;
          return mainTimestamps.includes(timestamp);
        });
      }
    });
  }
  var getPrimaryData = function getPrimaryData(dataArrays, dataType) {
    return dataArrays[{
      bidask: 'bid',
      ohlc: 'ohlc'
    }[dataType] || 'close'];
  };
  this.chartData = chartData.reduce(function (charts, instrumentData, instrumentIndex) {
    var dataArrays = (0, _timeSeriesConverter.getDataArraysFromTimeSeries)(instrumentData.data);
    var dataType = (0, _timeSeriesConverter.getDataTypeFromTimeSeriesDataPoint)(instrumentData.data[0]);
    var splitIndex = instrumentData.data.findIndex(function (f) {
      return f.timestamp >= _this5.startTimestamp;
    });
    // create fake points for candlestick and bars to fix shoulder cut of first and last candles
    if (_this5.type === 'candlestick' || _this5.type === 'ohlc') {
      var startPoint = dataArrays.ohlc[splitIndex];
      var endPoint = dataArrays.ohlc[dataArrays.ohlc.length - 1];
      var fakeTimestamp = 1;
      dataArrays.ohlc.splice(splitIndex, 0, {
        timestamp: startPoint.timestamp - fakeTimestamp
      });
      dataArrays.ohlc.push({
        timestamp: endPoint.timestamp + fakeTimestamp
      });
      _this5.startTimestamp = startPoint.timestamp - fakeTimestamp;
    }
    var yieldOnlyChart = _this5.config.favourYieldOverPrice && dataArrays.yield && dataArrays.yield.length;
    var primaryChartOnly = _this5.config.primaryChartOnly;
    var $chartPriceInfoElem = $(_this5.node).find('.moduleContent .price-chart-price-info');
    if (instrumentData.status && instrumentData.status !== 'OK' && instrumentData.status !== 'OLD') {
      errors.push(instrumentData.errorMessage || instrumentData.title);
      return charts;
    } else if (instrumentData.data.length === 0) {
      errors.push(window.getMessage("module.advancedchart.noInstrumentSelected"));
      $chartPriceInfoElem.hide();
      return charts;
    }

    // dont show series without any relevant data
    if (splitIndex < 0) {
      errors.push(window.getMessage("module.frontend.status.INVALID_ITEM", _this5.rics[instrumentIndex]));
      return charts;
    }

    // set primary chart and use default if necessary
    var primaryChart = charts[0] = charts[0] || {
      series: []
    };

    // determine series type
    var baseType = _this5.getBaseType();
    var defaultType = baseType.indexOf('step') === 0 ? 'stepline' : 'line';
    var seriesType = instrumentIndex ? defaultType : baseType;
    var colorBasedOnIndex = instrumentIndex ? _this5.themeConfig.chartColors.additionals[instrumentIndex - 1] : _this5.themeConfig.chartColors.neutral;

    // build a config object for the primary line
    var config = {
      zIndex: 2,
      showInLegend: _this5.config.showInLegend
    };
    if (seriesType !== 'candlestick' && seriesType !== 'ohlc') {
      config.color = dataType === 'bidask' ? _this5.themeConfig.chartColors.down : colorBasedOnIndex;
    }

    // map dataType to its primary data array
    var primaryData = yieldOnlyChart ? dataArrays.yield : getPrimaryData(dataArrays, dataType);
    if (!primaryData.length) {
      errors.push(window.getMessage("module.frontend.status.INVALID_ITEM", _this5.rics[instrumentIndex]));
      return charts;
    }

    // find the close value in primary data array that will be used as 0% baseline for comparison
    var baselineValue = null;
    var ts = _this5.startTimestamp;
    if (_this5.showBenchmarkErrors) {
      ts = instrumentData.timestampChart;
    }
    if (instrumentData.timestampChart === ts) {
      var startVal = _this5.showBenchmarkErrors ? ts : instrumentData.data.find(function (f) {
        return f.timestamp >= ts;
      });
      if (startVal) {
        baselineValue = yieldOnlyChart ? startVal.yield : dataType === 'bidask' ? startVal.bid : startVal.close;
      }
    } else {
      baselineValue = yieldOnlyChart || _this5.compareRics ? null : instrumentData.previousClose;
    }
    var longtitle = window.themeProperties['instrumentname.longtitle'];
    var instrumentName = longtitle ? instrumentData.title : instrumentData.shortTitle || instrumentData.title;
    if (!_this5.title) {
      _this5.title = instrumentName;
    }
    var getSeriesName = function getSeriesName(type) {
      if (chartData.length > 1) {
        return instrumentName;
      }
      if (instrumentData.timeSeriesName) {
        return window.getMessage("chart.timeSeries.name.".concat(instrumentData.timeSeriesName));
      }
      return _this5.portfolioValueTypeString && type === 'price' ? _this5.portfolioValueTypeString : window.getMessage("chart.value.".concat(type));
    };

    // generate main primary series
    primaryChart.series.push({
      name: instrumentName,
      tooltipName: yieldOnlyChart ? getSeriesName('yield') : getSeriesName(dataType === 'bidask' ? 'bid' : 'price'),
      titleStyle: _this5.config.titleStyle,
      type: seriesType,
      baselineValue: baselineValue,
      config: config,
      ohlcv: dataArrays.ohlcv,
      data: _this5.config.enableAnalystTargetPrice === 'true' ? primaryData : primaryData.slice(splitIndex)
    });
    if (_this5.config.enableAnalystTargetPrice === 'true' && dataArrays.targetPrice && dataArrays.targetPrice.length > 0) {
      primaryChart.series.push({
        name: window.getMessage('analysis.target.price.header.title'),
        tooltipName: window.getMessage('analysis.target.price.header.title'),
        titleStyle: _this5.config.titleStyle,
        type: 'stepline',
        baselineValue: baselineValue,
        config: _objectSpread(_objectSpread({}, config), {}, {
          color: _this5.config.targetPriceSeriesColor
        }),
        data: dataArrays.targetPrice
      });
    }

    // generate ask series if necessary
    if (dataType === 'bidask') {
      primaryChart.series.push({
        name: instrumentName,
        tooltipName: getSeriesName('ask'),
        type: seriesType,
        baselineValue: baselineValue,
        config: {
          color: colorBasedOnIndex
        },
        data: dataArrays.ask.slice(splitIndex)
      });
    }

    // generate yield series if necessary
    if (dataType === 'yield' && !yieldOnlyChart && !primaryChartOnly) {
      var secondaryChart = charts[1] = charts[1] || {
        series: []
      }; // set secondary chart and use default if necessary

      secondaryChart.series.push({
        name: getSeriesName('yield'),
        //instrumentName,
        tooltipName: getSeriesName('yield'),
        constantColor: true,
        type: seriesType,
        baselineValue: baselineValue,
        config: config,
        data: dataArrays.yield.slice(splitIndex)
      });
      primaryChart.series[0].name = getSeriesName('price');
    }
    if (!instrumentIndex) {
      // generate flags if necessary
      if (instrumentData.events && instrumentData.events.length) {
        var colors = {
          capitalChange: _this5.themeConfig.chartColors.additionals[0],
          generalMeeting: _this5.themeConfig.chartColors.additionals[1],
          eps: _this5.themeConfig.chartColors.additionals[2],
          dividend: _this5.themeConfig.chartColors.additionals[3]
        };
        primaryChart.series.push({
          type: 'flags',
          config: {
            zIndex: 3
          },
          data: instrumentData.events.sort(function (a, b) {
            return a.timestamp - b.timestamp;
          }).map(function (_ref5) {
            var timestamp = _ref5.timestamp,
              title = _ref5.title,
              type = _ref5.type,
              description = _ref5.description;
            return {
              timestamp: timestamp,
              title: window.getMessage("chart.events.".concat(type, ".shortCode")),
              fillColor: colors[type],
              color: colors[type],
              event: {
                type: type,
                title: title,
                description: description
              }
            };
          })
        });
      }
      //ToDo same color solution as events (Or at least no syle in this code)
      if (instrumentData.significantDevelopment && instrumentData.significantDevelopment.length) {
        var _colors = {
          1: _this5.themeConfig.sigDevColors.colors.color1,
          2: _this5.themeConfig.sigDevColors.colors.color2,
          3: _this5.themeConfig.sigDevColors.colors.color3,
          4: _this5.themeConfig.sigDevColors.colors.color4,
          5: _this5.themeConfig.sigDevColors.colors.color5,
          6: _this5.themeConfig.sigDevColors.colors.color6,
          7: _this5.themeConfig.sigDevColors.colors.color7,
          8: _this5.themeConfig.sigDevColors.colors.color8,
          9: _this5.themeConfig.sigDevColors.colors.color9,
          10: _this5.themeConfig.sigDevColors.colors.color10,
          11: _this5.themeConfig.sigDevColors.colors.color11,
          12: _this5.themeConfig.sigDevColors.colors.color12
        };
        primaryChart.series.push({
          type: 'flags',
          config: {
            zIndex: 3,
            allowOverlapX: true
          },
          data: instrumentData.significantDevelopment.sort(function (a, b) {
            return a.ts - b.ts;
          }).map(function (_ref6) {
            var ts = _ref6.ts,
              topicCode = _ref6.topicCode,
              parentTopicCode = _ref6.parentTopicCode,
              headline = _ref6.headline;
            return {
              timestamp: ts,
              title: window.getMessage("sigDev.parentTopicId.".concat(parentTopicCode, ".code")),
              fillColor: _colors[parentTopicCode],
              color: _colors[parentTopicCode],
              event: {
                parentTopicCode: parentTopicCode,
                title: window.getMessage("sigDev.parentTopicId.".concat(parentTopicCode, ".label")),
                description: headline
              }
            };
          })
        });
      }

      // generate indicators if necessary
      var seriesData = (0, _timeSeriesConverter.extractSeries)(dataArrays.ohlcv, ['open', 'high', 'low', 'close', 'volume', 'timestamp']);
      _this5.chartIndicators.forEach(function (indicator, indicatorIndex) {
        var indicatorSeries = indicator.calculate.apply(indicator, [seriesData.timestamp].concat(_toConsumableArray(indicator.getRequiredSeries().map(function (x) {
          return seriesData[x];
        }))));
        [].concat(indicatorSeries).forEach(function (series, i) {
          var indicatorSplitIndex = series.timestamp.findIndex(function (f) {
            return f >= _this5.startTimestamp;
          });
          var indicatorData = (0, _timeSeriesConverter.joinSeries)(series).slice(indicatorSplitIndex);

          // calculate baseline/point for SMA/EMA indicators: NGPII-14253
          if (['SimpleMovingAverage', 'ExponentialMovingAverage'].includes(indicator.constructor.name)) {
            baselineValue = indicatorSplitIndex > 0 ? series[indicatorSplitIndex - 1] : series[0];
            if (!baselineValue) {
              if (series.close) {
                baselineValue = indicatorSplitIndex > 0 ? series.close[indicatorSplitIndex - 1] : series.close[0];
              } else if (series.high) {
                baselineValue = indicatorSplitIndex > 0 ? series.high[indicatorSplitIndex - 1] : series.high[0];
              }
            }
          }
          primaryChart.series.push((0, _mergeObjects.default)({
            tooltipName: indicator.getDisplayName(),
            name: indicator.getLegend(),
            type: getTypeForIndicator(indicator, i),
            baselineValue: baselineValue,
            config: {
              zIndex: 1,
              color: getColorForIndicator(indicator, i, _this5.themeConfig.chartColors.indicators[indicatorIndex]),
              dashStyle: getLineStyleForIndicator(indicator, i),
              states: {
                hover: {
                  enabled: true
                }
              },
              isIndicator: true
            },
            data: indicatorData
          }, getIndicatorOptions(indicator, i, _this5.themeConfig.chartColors)));
        });
      });
    }
    return charts;
  }, []);
  if (typeof this.chartDataCallback === 'function') {
    this.chartDataCallback.call(this.rawChartData, this);
  }
  this.hideChartContainer = errors.length == chartData.length;
  if (errors.length) {
    this.showError(errors.join('<br>'), this.hideChartContainer);
  }
  return this;
};

/**
 * @returns {number} tradingEnd timestamp
 */
ChartContainer.prototype.getDayEndTime = function () {
  return this.tradingEnd;
};

/**
 * @returns {number} tradingStart timestamp
 */
ChartContainer.prototype.getDayStartTime = function () {
  return this.tradingStart;
};

/**
 * @returns {this}
 */
ChartContainer.prototype.hideContainer = function () {
  $(this.node).find('.chartImageBox [data-chartcontainer]').hide();
  return this;
};

/**
 * @returns {this}
 */
ChartContainer.prototype.showContainer = function () {
  $(this.node).find('.chartImageBox [data-chartcontainer]').show();
  return this;
};

/**
 * @param {string} errorText
 * @param {boolean} hideChartContainer
 * @returns {this}
 */
ChartContainer.prototype.showError = function (errorText) {
  var hideChartContainer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (hideChartContainer) {
    this.hideContainer();
  }
  $(this.node).find('.chartImageBox .hint').remove();
  if (hideChartContainer || !this.config.suppressErrorDisplay) {
    $(this.node).find('.chartImageBox').append("<div class=\"hint\">".concat(errorText, "</div>"));
  }
  return this;
};

/**
 * @returns {this}
 */
ChartContainer.prototype.hideError = function () {
  this.showContainer();
  $(this.node).find('.chartImageBox .hint').remove();
  return this;
};

/**
 * @returns {number} chart box width in pixels
 */
ChartContainer.prototype.getChartWidth = function () {
  return $(this.node).find('.chartImageBox').width();
};

/**
 * @returns {this}
 */
ChartContainer.prototype.freeze = function () {
  this.frozen = true;
  return this;
};

/**
 * @returns {this}
 */
ChartContainer.prototype.unfreeze = function () {
  this.frozen = false;
  return this;
};

/**
 * @returns {this}
 */
ChartContainer.prototype.render = function (targetNode) {
  var _this6 = this;
  targetNode = targetNode || this.node;
  var sandboxed = targetNode !== this.node;
  if (this.frozen) {
    return this;
  }
  if (this.chartData[0]?.series[0]?.data?.length < 2) {
    this.showError(window.getMessage('module.InstrumentChartModule.requiredDataPoints'));
  } else {
    if (!sandboxed) {
      if (this.hideChartContainer) {
        return this;
      }
    }
    var $chartContainer = $(targetNode).find('[data-chartcontainer]');
    $chartContainer.empty();
    var totalHeight = $chartContainer.height();

    // 30% height for one indicator, 20% if there is more than one
    var indicatorChartHeight = Math.floor(this.extraChartIndicators.length === 1 ? totalHeight * 0.3 : totalHeight * 0.2);
    var chartHeight = Math.floor(totalHeight / this.chartData.length) - indicatorChartHeight * this.extraChartIndicators.length;

    // destroy old charts to prevent memory leak
    if (!sandboxed) {
      this.charts.map(function (singleChartObject) {
        return singleChartObject.chart.destroy();
      });
      this.charts = [];
    }
    this.chartData.forEach(function (data, i, arr) {
      var $container = $("<div style=\"height:".concat(chartHeight, "px;\"/>"));
      $chartContainer.append($container);
      var chartConfig = _this6.getChartConfiguration(i, !_this6.extraChartIndicators.length && i + 1 === arr.length, false);
      var chart = new _SingleChart.default($container.get(0), data, chartConfig, _this6.ricColors);
      if (!sandboxed) {
        _this6.charts.push(chart);
      }
    });
    if (this.extraChartIndicators.length) {
      // get timestamps corresponding to each data point in main chart for syncing data points in indicator chart(s)
      var mainChartTimestamps = this.chartData[0].series[0].data.map(function (_ref7) {
        var timestamp = _ref7.timestamp;
        return timestamp;
      });
      this.extraChartIndicators.forEach(function (indicator, i, arr) {
        var $container = $("<div style=\"height:".concat(indicatorChartHeight, "px;\"/>"));
        $chartContainer.append($container);
        var extraConfig = indicator.getExtraConfig ? indicator.getExtraConfig() : {};
        var chartConfig = _this6.getChartConfiguration(0, i + 1 === arr.length, true, extraConfig);
        var chart = new _SingleChart.default($container.get(0), _this6.getIndicatorChart(indicator, _this6.chartData[0].series[0].ohlcv, mainChartTimestamps), chartConfig, _this6.ricColors);
        if (!sandboxed) {
          _this6.charts.push(chart);
        }
      });
    }
    this.updateChartContainerLabel();
    return this;
  }
};

/**
 * @description Update chart container label for WCAG integration
 */
ChartContainer.prototype.updateChartContainerLabel = function () {
  var $imgBox = $(this.node).find('.chartImageBox');
  var $link = $($imgBox).children().first();
  if ($link.is('a')) {
    var chartName = this.getChartNameByType();
    var chartDetails = '';

    // #. Set chart details
    if (chartName) {
      chartDetails = "".concat(window.getMessage('chart.type'), " ").concat(chartName);
    }

    // #. Set WCAG attributes
    $link.attr({
      'aria-label': "".concat(this.title, " ").concat(chartDetails)
    });
  }
};

/**
 * @description Get chart name by type
 */
ChartContainer.prototype.getChartNameByType = function () {
  var chartType = this.type;
  var name = '';
  switch (chartType) {
    case 'candlestick':
      name = window.getMessage('chart.type.candle');
      break;
    case 'bidask':
      name = window.getMessage('chart.type.quote');
      break;
    case 'ohlc':
      name = window.getMessage('chart.type.bar');
      break;
    case 'area':
    case 'steparea':
      name = window.getMessage('chart.type.mountain');
      break;
    case 'line':
      name = window.getMessage('chart.type.line');
      break;
    case 'stepline':
      name = window.getMessage('chart.type.step');
      break;
    default:
      name = '';
      break;
  }
  return name;
};
ChartContainer.prototype.getIndicatorChart = function (indicator, baseSeriesData, mainChartTimestamps) {
  var _this7 = this;
  var seriesData = (0, _timeSeriesConverter.extractSeries)(baseSeriesData, ['open', 'high', 'low', 'close', 'volume', 'timestamp']);
  var indicatorSeries = [].concat(indicator.calculate.apply(indicator, _toConsumableArray(['timestamp'].concat(_toConsumableArray(indicator.getRequiredSeries())).map(function (x) {
    return seriesData[x];
  })))).map(function (indicatorData) {
    if (indicatorData.color) {
      indicatorData.color = indicatorData.color.map(function (color) {
        return _this7.themeConfig.chartColors[color] || color;
      });
    }
    return indicatorData;
  });
  var indicatorSplitIndex = seriesData.timestamp.findIndex(function (f) {
    return f >= _this7.startTimestamp;
  });
  var getDefaultColor = function getDefaultColor(index) {
    return _this7.themeConfig.chartColors.indicators[index];
  };
  var defaultLineStyle = 'Solid';
  var defaultType = 'line';
  var getDataForSeries = function getDataForSeries(series) {
    var data = (0, _timeSeriesConverter.joinSeries)(series).slice(indicatorSplitIndex);
    if (mainChartTimestamps && mainChartTimestamps.length > 0) {
      // filter data points for indicator chart(s) such that timestamps missing in main chart are ignored
      data = data.filter(function (_ref8) {
        var timestamp = _ref8.timestamp;
        return mainChartTimestamps.includes(timestamp);
      });
    }
    return data;
  };
  return {
    series: indicatorSeries.map(function (series, i) {
      return (0, _mergeObjects.default)({
        tooltipName: indicator.getDisplayName(i),
        name: indicator.getLegend(),
        titleStyle: indicator.titleStyle,
        data: getDataForSeries(series),
        type: indicator.getType ? indicator.getType(i) || defaultType : defaultType,
        config: {
          showInLegend: !i,
          // only display one legend
          color: indicator.getColor ? indicator.getColor(i) || getDefaultColor(i) : getDefaultColor(i),
          dashStyle: indicator.getLineStyle ? indicator.getLineStyle(i) || defaultLineStyle : defaultLineStyle,
          isIndicator: true
        }
      }, getIndicatorOptions(indicator, i, _this7.themeConfig.chartColors));
    })
  };
};

/**
 * @param {boolean} disabled
 * @returns {this}
 */
ChartContainer.prototype.setTooltipsDisabled = function (disabled) {
  this.config.disableTooltips = disabled;
  return this;
};

/**
 * @param {boolean} disabled
 * @returns {this}
 */
ChartContainer.prototype.setMarkersDisabled = function (disabled) {
  this.config.disableMarkers = disabled;
  return this;
};

/**
 * @param {number} chartIndex
 * @param {boolean} isLast
 * @returns {Object} configuration for a chart
 */
ChartContainer.prototype.getChartConfiguration = function (chartIndex, isLast, isIndicator, extraConfig) {
  var _this8 = this;
  chartIndex = chartIndex || 0;
  var disableAxis = {
    xAxis: [{
      tickWidth: 0,
      labels: {
        enabled: false
      }
    }]
  };
  var chartConfig = {
    dataType: this.getDataType(isIndicator),
    dayEndTime: this.getDayEndTime(),
    days: this.getDays(),
    themeConfig: Object.assign({}, this.themeConfig, isLast ? {} : disableAxis),
    // only enable xAxis for the last chart
    interval: this.getInterval(),
    digits: isIndicator ? 3 : this.digits,
    isIndicator: isIndicator,
    forceComparison: this.extraChartIndicators.length || this.chartData[chartIndex].series.length > 1,
    isComplex: !isIndicator && this.isComplex,
    chartScale: isIndicator ? _SingleChart.CHARTSCALE.ABSOLUTE : this.chartScale,
    isStreaming: this.getIsStreaming(),
    showLegend: this.config.showLegend,
    disableTooltips: this.config.disableTooltips || false,
    disableMarkers: this.config.disableMarkers || false,
    multiChart: this.chartData.length + this.extraChartIndicators.length > 1,
    zoom: this.config.zoom || false,
    previousClose: chartIndex === 0 ? this.previousClose : null,
    csvSeparator: this.config.csvSeparator,
    // Extra properties that override everything in the series.
    gapUnit: this.config.gapUnit,
    gapSize: this.config.gapSize,
    tooltipOutside: this.config.tooltipOutside,
    tooltipFollowPointer: this.config.tooltipFollowPointer,
    disableReflow: this.config.disableReflow,
    zoomCallback: function zoomCallback(_ref9, triggerChart) {
      var min = _ref9.min,
        max = _ref9.max;
      var isZoomed = !!(min % 1 || max % 1);
      _this8.pauseStreamingRender = isZoomed; // pause streaming updates when chart is zoomed
      _this8.charts.forEach(function (chart) {
        var extremes = chart.chart.xAxis[0].getExtremes();
        if (chart !== triggerChart && (extremes.min !== min || extremes.max !== max)) {
          chart.chart.xAxis[0].setExtremes(min, max, true, false);
        } else if (!isZoomed) {
          chart.chart.zoomOut();
        }
      });
    },
    tooltipPositioner: this.config.tooltipPositionerOverride === true ? function (boxWidth, boxHeight, point) {
      var chart = this.chart;
      var chartPosition = chart.pointer.getChartPosition();
      var plotWidth = chart.plotWidth;
      var plotHeight = chart.plotHeight;
      var x = chartPosition.left + (point.plotX + boxWidth > plotWidth ? point.plotX - boxWidth - 20 : point.plotX);
      var y = (point.plotY > plotHeight ? point.plotY - (point.plotY - plotHeight) : point.plotY) + 20;
      return {
        x: x,
        y: y
      };
    } : null
  };
  if (this.libConfig) {
    if (!isLast) {
      var libConfigTemp = Object.assign({}, this.libConfig);
      if ('xAxis' in libConfigTemp) {
        libConfigTemp.xAxis[0].tickWidth = disableAxis.xAxis[0].tickWidth;
        libConfigTemp.xAxis[0].labels.enabled = disableAxis.xAxis[0].labels.enabled;
      } else {
        libConfigTemp.xAxis = [];
        var content = {
          tickWidth: disableAxis.xAxis[0].tickWidth,
          labels: {
            enabled: disableAxis.xAxis[0].labels.enabled
          }
        };
        libConfigTemp.xAxis.push(content);
      }
      chartConfig.themeConfig = Object.assign({}, this.themeConfig, libConfigTemp);
    } else {
      chartConfig.themeConfig = Object.assign({}, this.themeConfig, this.libConfig);
    }
  }
  return Object.assign({}, chartConfig, extraConfig || {});
};

/**
 * @param {(Array|string)} rics - rics array or single ric
 * @param {(Array|string)} ricColors - custom colors per ric, position-dependent
 * @returns {this}
 */
ChartContainer.prototype.setRic = function (rics, ricColors) {
  if (rics.join && this.rics.join(',') !== rics.join(',') || typeof rics === 'string' && this.rics.join(',') !== rics || this.ricColors !== ricColors) {
    this.rics = [].concat(rics);
    if (typeof ricColors !== 'undefined') {
      this.ricColors = [].concat(ricColors);
    }
    this.reload();
  }
  return this;
};
/**
 * @param {(Array)} changedRics - rics array, will replace the array of rics & benchmarks of the chart,
 * if the given list is smaller than the internal list, elements of internal list poisitioned
 * higher than the changed list are preserved.
 * @returns {this}
 */
ChartContainer.prototype.replaceRic = function (changedRics) {
  var newRics = [].concat(_toConsumableArray(changedRics), _toConsumableArray(this.rics.slice(changedRics.length)));
  return this.setRic(newRics);
};

/**
 * helper function to set ric array empty
 */
ChartContainer.prototype.setRicEmpty = function () {
  this.rics = [];
};

/**
 * @param {(Array|string)} names - names array or single name
 * @returns {this}
 */
ChartContainer.prototype.setName = function (names) {
  this.seriesNames = [].concat(names);
  return this;
};

/**
 * @param {string} title
 * @returns {this}
 */
ChartContainer.prototype.setTitle = function (title) {
  this.title = title || null;
  return this;
};

/**
 * @returns {number} days
 */
ChartContainer.prototype.getDays = function () {
  return this.days;
};

/**
 * @param {number} days
 * @returns {this}
 */
ChartContainer.prototype.setDays = function (days) {
  if (this.timeRange) {
    this.timeRange = null;
    this.days = null; //reset days so it will reload (see if clause below)
  }

  if (this.days !== days) {
    this.days = days;
    $(this.node).find('[data-days]').removeClass('on');
    $(this.node).find("[data-days=".concat(days, "]")).addClass('on');
    this.reload();
  }
  return this;
};

/**
 * @param {number} fromTs - from timestamp
 * @param {number} [toTs] - to timestamp
 * @returns {this}
 */
ChartContainer.prototype.setTimeRange = function (fromTs, toTs) {
  var days = Math.floor(((toTs || new Date().getTime()) - fromTs) / (24 * 60 * 60 * 1000));
  this.days = days;
  this.timeRange = {
    from: fromTs,
    to: toTs || null
  };
  this.reload();
  return this;
};

/**
 * @returns {this}
 */
ChartContainer.prototype.setYTD = function () {
  var startOfYear = new Date(new Date().getFullYear(), 0, 1).getTime();
  this.setTimeRange(startOfYear, Date.now());
  this.days = Math.floor((Date.now() - startOfYear) / (24 * 60 * 60 * 1000)); // set days so other calculations (like periodicity) will work
  $(this.node).find('[data-days]').removeClass('on');
  $(this.node).find('[data-days=0]').addClass('on');
  return this;
};

/**
 * @returns {Object} timeRange
 */
ChartContainer.prototype.getTimeRange = function () {
  return this.timeRange;
};

/**
 * @returns {number} requiredPoints
 */
ChartContainer.prototype.getRequiredPoints = function () {
  return Math.max.apply(Math, [0].concat(_toConsumableArray([].concat(_toConsumableArray(this.chartIndicators), _toConsumableArray(this.extraChartIndicators)).map(function (indicator) {
    return indicator.getRequiredPoints();
  }))));
};

/**
 * @returns {this}
 */
ChartContainer.prototype.setChartScale = function (scaleName) {
  var chartScale = {
    absolute: _SingleChart.CHARTSCALE.ABSOLUTE,
    relative: _SingleChart.CHARTSCALE.RELATIVE,
    logarithmic: _SingleChart.CHARTSCALE.LOGARITHMIC
  }[scaleName];
  this.chartScale = chartScale;
  $(this.node).find('[data-scale]').removeClass('on');
  $(this.node).find("[data-scale=".concat(scaleName, "]")).addClass('on');
  this.render();
  return this;
};

/**
 * @returns {string}
 */
ChartContainer.prototype.getDataType = function (isndicator) {
  return this.type === 'bidask' ? 'bidask' : this.isComplex && !isndicator ? 'ohlc' : this.config.favourYieldOverPrice ? 'yield' : this.rics.length > 1 ? 'close' : 'yield';
};

/**
 * @returns {this}
 */
ChartContainer.prototype.setType = function (type, silent) {
  var validTypes = ['candlestick', 'ohlc', 'line', 'stepline', 'area', 'steparea', 'bidask'];
  if (validTypes.indexOf(type) === -1) {
    throw new Error('invalid chart type for InstrumentChartModule');
  }
  this.type = type;
  this.isComplex = ['candlestick', 'ohlc'].indexOf(this.type) > -1;
  if (!silent) {
    this.reload();
  }
  return this;
};

/**
 * @returns {String}
 */
ChartContainer.prototype.getType = function () {
  return this.type;
};

/**
 * @returns {String}
 */
ChartContainer.prototype.getBaseType = function () {
  var type = this.getType();
  return type === 'bidask' ? 'stepline' : type;
};

/**
 * @params {Object} params - extra params to be sent when requesting data
 * @returns {this}
 */
ChartContainer.prototype.setExtraCallParameters = function (params) {
  this.extraCallParams = params;
  return this;
};

/**
 * @params {Array} indicators
 * @returns {this}
 */
ChartContainer.prototype.setIndicators = function () {
  var indicators = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  this.chartIndicators = indicators.map(function (indicator) {
    return _construct((0, _indicators.default)(indicator.type), _toConsumableArray(indicator.parameters || []));
  });
  this.reload();
  return this;
};
ChartContainer.prototype.setIndicatorCharts = function () {
  var indicators = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  this.extraChartIndicators = indicators.map(function (indicator) {
    var result = _construct((0, _indicators.default)(indicator.type), _toConsumableArray(indicator.parameters || []));
    Object.assign(result, indicator.properties);
    return result;
  });
  this.reload();
  return this;
};
ChartContainer.prototype.setDigits = function (digits) {
  this.digits = digits;
  this.reload();
  return this;
};

/**
 * @params {string} portfolioValueType
 * @returns {this}
 */
ChartContainer.prototype.setPortfolioValueType = function (portfolioValueType, portfolioValueTypeString) {
  this.valuetype = portfolioValueType;
  this.portfolioValueTypeString = portfolioValueTypeString;
  return this;
};

/**
 * @params {pfid} PortfolioId
 * @returns {this}
 */
ChartContainer.prototype.setPortfolioId = function (pfid) {
  this.pfid = pfid;
  this.reload();
  return this;
};
ChartContainer.prototype.setCurrency = function (currency) {
  this.currency = currency;
  this.reload();
  return this;
};

/**
 * @private
 * @returns {function} streaming callback function
 */
var createStreamCallback = function createStreamCallback() {
  var _this9 = this;
  var streamCache = {
    close: {},
    yield: {}
  };
  return function (update) {
    if (!_this9.getIsStreaming() || update.ric !== _this9.rics[0] || $(_this9.node).find('.chartImageBox [data-chartcontainer]').not(':visible').length) {
      return;
    }
    if (update.fid === '30018') {
      // time fid
      var _update$content$split = update.content.split(':'),
        _update$content$split2 = _slicedToArray(_update$content$split, 2),
        hours = _update$content$split2[0],
        minutes = _update$content$split2[1]; // update.content has the format hh:mm
      if (hours.trim().length === 0 && minutes.trim().length === 0) {
        // when there is not hours and minutes
        return;
      }
      var date = new window.fcom.date.DateTime(window.user.timezone);
      date = new window.fcom.date.UTCDate(date.timestamp);
      if (_this9.rawChartData[0]) {
        var lastPoint = _this9.getLastPoint(_this9.rawChartData[0].data);
        date = new window.fcom.date.UTCDate(lastPoint.timestamp);
      }
      date.setHours(hours, minutes, 0, 0);
      var ts = date.getTime();
      streamCache.close.timestamp = ts;
      streamCache.yield.timestamp = ts;
    } else if (update.fid === '30006') {
      // close fid
      streamCache.close.value = +update.content;
    } else if (_this9.chartData.length > 1 && update.fid === '30035') {
      // yield fid
      streamCache.yield.value = +update.content;
    }

    // do the updates (triggering the streamupdate and resetting streamCache)
    if (streamCache.close.timestamp && streamCache.close.value != null) {
      _this9.addStreamingDataPoint('close', streamCache.close);
      streamCache.close = {};
    } else if (streamCache.yield.timestamp && streamCache.yield.value != null) {
      _this9.addStreamingDataPoint('yield', streamCache.yield);
      streamCache.yield = {};
    }
  };
};

/**
 * @returns {this}
 */
ChartContainer.prototype.init = function () {
  var _this10 = this;
  this.freeze();
  this.rics = ($(this.node).find('[data-ric]').first().data('ric') || '').split(',').filter(function (f) {
    return f;
  });
  this.days = $(this.node).find('[data-days].on').first().data('days');
  this.days = this.days != null ? this.days : $(this.node).find('[data-days-default]').first().data('days-default');
  this.scale = $(this.node).find('[data-scale].on').first().data('scale') || this.config.fallbackScale;
  this.id = $(this.node).attr('id');
  this.title = $(this.node).find('[data-title]').first().data('title') || null;
  this.seriesNames = [];
  this.setType($(this.node).find('[data-chart-type]').first().data('chart-type') || 'line');
  this.historicOnly = $(this.node).find('[data-chart-type]').first().is('[data-historiconly]');
  this.isins = ($(this.node).find('[data-isin]').first().data('isin') || '').split(',').filter(function (f) {
    return f;
  });
  if (this.days === 0) {
    this.setYTD();
  }
  var _this = this;
  $(this.node).find('[data-days]').click(function () {
    var days = $(this).data('days');
    if (days) {
      _this.setDays(days);
    } else {
      _this.setYTD();
    }
  });
  $(this.node).find('[data-scale]').click(function () {
    _this.setChartScale($(this).data('scale'));
  });

  // add context menu handler
  $(this.node).find('[data-module-action="contextMenu"]').click(function (event) {
    var contextConfig = window.getConfigForModule(_this.id);
    if (typeof contextConfig.interval === 'string') {
      contextConfig.interval = _this.getInterval();
    }
    if (typeof contextConfig.days === 'number') {
      contextConfig.days = _this.getDays();
    }
    window.YAHOO.fcom.Context.openMenu(event, contextConfig, this);
  });

  // _this.setTimeSeriesLink();

  this.streamCallback = createStreamCallback.call(this);

  // Add custom title update handler
  $(this.node).find('.chartImageBox [data-chartcontainer]').on('setChartTitle', function (e, title) {
    _this10.setTitle(title);
  });
  return this.unfreeze();
};
ChartContainer.prototype.setTimeSeriesLink = function () {
  var chartLinkTimeseriesTemplate = $(this.node).find('.timeserieslink').data('chartlinktemplate');
  var arg = {
    ric: this.rics[0],
    days: this.days,
    interval: this.getInterval()
  };
  if (chartLinkTimeseriesTemplate) {
    var chartLink = chartLinkTimeseriesTemplate.replace(/\$\{([A-Za-z]+)\}/g, function (match, p1) {
      return arg[p1.toLowerCase()];
    });
    $(this.node).find('.timeserieslink a').attr('href', chartLink);
  }
};

/**
 * @returns {String[]}
 */
ChartContainer.prototype.getRequiredSeries = function () {
  var requiredMainSeries = {
    close: ['close'],
    yield: ['close', 'yield'],
    ohlc: ['open', 'high', 'low', 'close'],
    bidask: ['bid', 'ask']
  }[this.getDataType()];
  var requiredSeries = [].concat(_toConsumableArray(this.chartIndicators), _toConsumableArray(this.extraChartIndicators)).map(function (indicator) {
    return indicator.getRequiredSeries();
  }).concat(requiredMainSeries).reduce(function (all, series) {
    return all.concat(series);
  }, []).filter(function (f, i, all) {
    return all.indexOf(f) === i;
  });
  return requiredSeries;
};
ChartContainer.prototype.getDataPromiseParams = function (ric, i, data) {
  var params = Object.assign({
    method: this.config.enableAnalystTargetPrice === 'true' ? 'getAnalystTargetpriceChart' : 'getInstrumentChart',
    interval: this.getInterval(),
    types: this.getRequiredSeries(),
    indicatorSize: this.getRequiredPoints(),
    isMiniChart: this.config.isMiniChart
  }, ric, this.extraCallParams || {});
  var timeRange = this.getTimeRange();
  if (timeRange) {
    params.from = timeRange.from;
    if (timeRange.to) {
      // only set to if necessary, default will be today
      params.to = timeRange.to;
    }
  } else {
    params.days = this.getDays();
  }
  if (this.valuetype) {
    params.valuetype = this.valuetype;
    params.portfolioValueTypeString = this.portfolioValueTypeString;
  }
  if (this.currency) {
    params.currency = this.currency[i];
  } else {
    params.currency = [];
  }
  return params;
};

/**
 * @returns {Promise.<Object[]>}
 */
ChartContainer.prototype.getInitialData = function () {
  var _this11 = this;
  var data = this.pfid ? [{
    pfid: this.pfid
  }] : [];
  data = data.concat(this.rics.map(function (ric, index) {
    return _this11.isins[index] ? {
      ric: ric,
      isin: _this11.isins[index]
    } : {
      ric: ric
    };
  }));
  if (!data || !data[0]) {
    return Promise.resolve([{
      data: []
    }]);
  }
  return Promise.all(data.map(function (ric, i) {
    var params = _this11.getDataPromiseParams(ric, i, data);
    var returnPromise = window.ajaxGetJson('/timeseries.action', params);
    if (i) {
      // dont catch for the first ric, in order to display a proper error
      return returnPromise.catch(function () {
        return null;
      });
    }
    return returnPromise;
  })).then(function (dataSet) {
    var returnData = [];
    var errorMessages = [];
    dataSet.forEach(function (a, position) {
      if (a) {
        returnData.push(a);
        if (a.status !== 'OK' && a.status !== 'OLD' && _this11.showBenchmarkErrors && position > 0) {
          errorMessages.push({
            error: a.title,
            position: position,
            symbol: a.name
          });
        }
      }
    });
    _this11.handleBenchmarkError(errorMessages);
    return returnData;
  });
};
ChartContainer.prototype.setShowBenchmarkErrors = function (value) {
  this.showBenchmarkErrors = value;
};
ChartContainer.prototype.setcompareRics = function (value) {
  this.compareRics = value;
};
ChartContainer.prototype.handleBenchmarkError = function (errorMessages) {
  var $moduleHeader = $(this.node).closest('.module').find('.moduleHeader');
  $moduleHeader.siblings('.chartHint').remove();
  if (errorMessages.length) {
    var errorHintHtml = errorMessages.map(function (error) {
      var symbolPrefix = error.symbol.startsWith('fc_ltsf_') ? '' : "<strong>&lt;".concat(error.symbol, "&gt;</strong> ");
      return "<div class=\"chartHint\">".concat(symbolPrefix).concat(error.error, "</div>");
    }).join('');
    $moduleHeader.after(errorHintHtml);
  }
};
ChartContainer.prototype.exportCSV = function () {
  if (this.charts && this.charts.length) {
    var rows = null;
    this.charts.forEach(function (chartItem) {
      var chartRows = chartItem.chart.getDataRows();
      if (!rows) {
        rows = chartRows;
      } else {
        var existingHeaders = rows[0];
        var newHeaders = chartRows[0];
        for (var i = 0; i < newHeaders.length; i++) {
          if (!existingHeaders.includes(newHeaders[i])) {
            for (var j = 0; j < rows.length; j++) {
              rows[j].push(chartRows[j][i]);
            }
          }
        }
      }
    });
    var primaryChart = this.charts[0].chart;
    var csv = this.getCSV(primaryChart, rows, true);
    window.Highcharts.downloadURL("data:text/csv,\uFEFF" + encodeURIComponent(csv), 'chart.csv');
  } else {
    window.ngpAlert(window.getMessage('chart.export.wait.message'));
  }
};
ChartContainer.prototype.getCSV = function (chart, rows, useLocalDecimalPoint) {
  var csv = '';
  var options = (chart.options.exporting || {}).csv || {};
  var itemDelimiter = options.itemDelimiter || ','; // use ';' for direct to Excel
  var lineDelimiter = options.lineDelimiter || '\n'; // '\n' isn't working with the js csv data extraction

  // Transform the rows to CSV
  rows.forEach(function (row, i) {
    var val = '';
    var rowLength = row.length;
    while (rowLength--) {
      val = row[rowLength];
      if (typeof val === 'number') {
        val = window.Highcharts.numberFormat(val, undefined, undefined, '');
      } else if (typeof val === 'undefined') {
        val = '';
      }
      row[rowLength] = '"' + val + '"';
    }
    // Add the values
    csv += row.join(itemDelimiter);

    // Add the line delimiter
    if (i < rows.length - 1) {
      csv += lineDelimiter;
    }
  });
  return csv;
};
ChartContainer.prototype.hideAllTooltip = function (e) {
  if (!this.charts.length) return;
  this.charts.forEach(function (chartObj) {
    var chart = chartObj.chart;
    chart.tooltip.hide();
    chart.xAxis[0].hideCrosshair();
    chart.series.forEach(function (series) {
      return series.onMouseOut();
    });
  });
};
ChartContainer.prototype.syncIndicatorPoints = function (e, sourcePoint) {
  var points = [];
  // Sync is only needed if we show more then 1 chart
  if (this.charts.length <= 1) return;
  this.charts.forEach(function (chartObj) {
    var chart = chartObj.chart;
    // Find coordinates within the chart
    var event = chart.pointer.normalize(e);
    // Get the hovered point
    var point = chart.series[0].searchPoint(event, true);
    if (point && !point.isNull) {
      point.onMouseOver();
    }
  });
};

/**
 * resize lifecycle method
 */
ChartContainer.prototype['@resize'] = function () {
  this.render();
};
ChartContainer.prototype['@reload'] = function () {
  this.reload();
};

/**
 * In order to synchronize tooltips and crosshairs
 */
ChartContainer.prototype.initTooltipSynchronization = function () {
  var _this12 = this;
  var chartContainerElm = $(this.node).find('.chartImageBox [data-chartcontainer]');
  ['mousemove', 'touchmove', 'touchstart'].forEach(function (eventType) {
    chartContainerElm.on(eventType, function (e) {
      return _this12.syncIndicatorPoints(e);
    });
  });
  chartContainerElm.on('mouseleave', function (e) {
    window.requestAnimationFrame(function () {
      _this12.hideAllTooltip(e);
    });
  });
};
var _default = exports.default = ChartContainer;

},{"lodash/debounce":188,"modules/InstrumentChartModule/ChartIndicators/indicators/indicators":88,"modules/InstrumentChartModule/SingleChart":102,"modules/InstrumentChartModule/intervalMapper":103,"modules/InstrumentChartModule/timeSeriesConverter":104,"util/functions/getStatusMessageFromError":141,"util/functions/hexToRgba":142,"util/functions/mergeObjects":143}],37:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZERO = exports.Underlying = exports.TWO = exports.ONEOTWO = exports.ONEOTHREE = exports.ONEOSEVEN = exports.ONE = exports.NO_VALUE = exports.MovingDeviation = exports.MovingAverage = exports.FOUR = exports.EPSDENOM = exports.Coefficient = void 0;
var ZERO = exports.ZERO = 0;
var ONE = exports.ONE = 1;
var TWO = exports.TWO = 2;
var FOUR = exports.FOUR = 4;
var EPSDENOM = exports.EPSDENOM = 1e-14;
var ONEOSEVEN = exports.ONEOSEVEN = 1 / 7;
var ONEOTHREE = exports.ONEOTHREE = 1 / 3;
var ONEOTWO = exports.ONEOTWO = 1 / 2;
var NO_VALUE = exports.NO_VALUE = null;
var Underlying = exports.Underlying = {
  ClosePrice: Symbol('Underlying.ClosePrice'),
  TypicalPrice: Symbol('Underlying.TypicalPrice')
};
var MovingAverage = exports.MovingAverage = {
  Arithmetic: Symbol('MovingAverage.Arithmetic'),
  Exponential: Symbol('MovingAverage.Exponential'),
  Wilders: Symbol('MovingAverage.Wilders')
};
var MovingDeviation = exports.MovingDeviation = {
  Mean: Symbol('MovingDeviation.Mean'),
  Standard: Symbol('MovingDeviation.Standard')
};
var Coefficient = exports.Coefficient = {
  OpenPrices: Symbol('Coefficient.OpenPrices'),
  ClosePrices: Symbol('Coefficient.ClosePrices'),
  ClosePricesWithoutAggregation: Symbol('Coefficient.ClosePricesWithoutAggregation')
};

},{}],38:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
var _movingAverage = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/movingAverage"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * @param {Array} ots the time series of open prices.
 * @param {Array} hts the time series of high prices.
 * @param {Array} lts the time series of low prices.
 * @param {Array} cts the time series of close prices.
 * @param {Array} vts the time series of volume values.
 * @param {Number} coeff the number to encode the choice for the coefficient of the volume values in the computation of accumulation distribution line.
 * @param {Number} ma the number to encode the choice of moving average type.
 * @param {Number} nocp the number of considered periods.
 *
 * @returns {Array} the time series of accumulation distribution line and its moving average.
 */
var _default = exports.default = function _default(ots, hts, lts, cts, vts, coeff, ma, nocp) {
  var adl;
  if (coeff === _constants.Coefficient.OpenPrices) {
    adl = cts.reduce(function (all, c, i) {
      if (!i) {
        all.push(_constants.ZERO);
      } else {
        var denom = hts[i] - lts[i];
        all.push(denom < _constants.EPSDENOM ? all[i - 1] : all[i - 1] + (c - ots[i]) * vts[i] / denom);
      }
      return all;
    }, []);
  } else if (coeff === _constants.Coefficient.ClosePricesWithoutAggregation) {
    adl = cts.reduce(function (all, c, i) {
      if (!i) {
        all.push(_constants.ZERO);
      } else {
        var denom = hts[i] - lts[i];
        all.push(denom < _constants.EPSDENOM ? _constants.ZERO : (_constants.TWO * c - hts[i] - lts[i]) * vts[i] / denom);
      }
      return all;
    }, []);
  } else if (coeff === _constants.Coefficient.ClosePrices) {
    adl = cts.reduce(function (all, c, i) {
      if (!i) {
        all.push(_constants.ZERO);
      } else {
        var denom = hts[i] - lts[i];
        all.push(denom < _constants.EPSDENOM ? all[i - 1] : all[i - 1] + (_constants.TWO * c - hts[i] - lts[i]) * vts[i] / denom);
      }
      return all;
    }, []);
  } else {
    throw new Error("coefficient type ".concat(coeff, " does not exist"));
  }
  return nocp <= 1 ? adl : (0, _movingAverage.default)(adl, ma, nocp);
};

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37,"modules/InstrumentChartModule/ChartIndicators/calculators/movingAverage":55}],39:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _aroonUpDown = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/aroonUpDown"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 * @param {Array} hts the time series of high prices.
 * @param {Array} lts the time series of low prices.
 * @param {Number} nocp the number of considered periods.
 *
 * @returns {Array} the time series of Aroon.
 */
var _default = exports.default = function _default(hts, lts, nocp) {
  var _arud = (0, _aroonUpDown.default)(hts, lts, nocp),
    _arud2 = _slicedToArray(_arud, 2),
    ar = _arud2[0],
    ard = _arud2[1];
  return ar.map(function (x, i) {
    return x - ard[i];
  });
};

},{"modules/InstrumentChartModule/ChartIndicators/calculators/aroonUpDown":40}],40:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constantsInc = require("./_constants.inc.js");
var _movingMaximaPositions = _interopRequireDefault(require("./movingMaximaPositions"));
var _movingMinimaPositions = _interopRequireDefault(require("./movingMinimaPositions"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * @param {Array} hts the time series of high prices.
 * @param {Array} lts the time series of low prices.
 * @param {Number} grn the number of the graph.
 * @param {Number} nocp the number of considered periods.
 *
 * @return {Array} the time series of Aroon up and Aroon down.
 */
var _default = exports.default = function _default(hts, lts, nocp) {
  var oneonocpmone = _constantsInc.ONE / (nocp - _constantsInc.ONE);
  var arud = Array(hts.length).fill(_constantsInc.ONE);
  if (nocp === 1) {
    return [arud, arud];
  }
  var maxpos = (0, _movingMaximaPositions.default)(hts, nocp);
  var maxArud = arud.map(function (_, i) {
    return _constantsInc.ONE - (i - maxpos[i]) * oneonocpmone;
  });
  var minpos = (0, _movingMinimaPositions.default)(lts, nocp);
  var minArud = arud.map(function (_, i) {
    return _constantsInc.ONE - (i - minpos[i]) * oneonocpmone;
  });
  return [maxArud, minArud];
};

},{"./_constants.inc.js":37,"./movingMaximaPositions":59,"./movingMinimaPositions":61}],41:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _directionalMovementIndex = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/directionalMovementIndex"));
var _movingAverage = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/movingAverage"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * @param {Array} hts the time series of high prices.
 * @param {Array} lts the time series of low prices.
 * @param {Array} cts the time series of close prices.
 * @param {Number} ma the number to encode the choice of moving average type.
 * @param {Number} nocp1 the number of considered periods1.
 * @param {Number} nocp2 the number of considered periods2.
 *
 * @returns {Array} the time series of average directional index.
 */
var _default = exports.default = function _default(hts, lts, cts, ma, nocp1, nocp2) {
  return (0, _movingAverage.default)((0, _directionalMovementIndex.default)(hts, lts, cts, ma, nocp1)[2], ma, nocp2);
};

},{"modules/InstrumentChartModule/ChartIndicators/calculators/directionalMovementIndex":47,"modules/InstrumentChartModule/ChartIndicators/calculators/movingAverage":55}],42:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _movingAverage = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/movingAverage"));
var _trueRange = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/trueRange"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * @param {Array} hts the time series of high prices.
 * @param {Array} lts the time series of low prices.
 * @param {Array} cts the time series of close prices.
 * @param {Number} ma the number to encode the choice of moving average type.
 * @param {Number} nocp the number of considered periods.
 *
 * @returns {Array} the time series of average true range.
 */
var _default = exports.default = function _default(hts, lts, cts, ma, nocp) {
  return (0, _movingAverage.default)((0, _trueRange.default)(hts, lts, cts), ma, nocp);
};

},{"modules/InstrumentChartModule/ChartIndicators/calculators/movingAverage":55,"modules/InstrumentChartModule/ChartIndicators/calculators/trueRange":68}],43:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _movingAverage = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/movingAverage"));
var _movingDeviation = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/movingDeviation"));
var _underlying = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/underlying"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * @param {Array} hts the time series of high prices.
 * @param {Array} lts the time series of low prices.
 * @param {Array} cts the time series of close prices.
 * @param {Number} ul the number to encode the choice of underlying.
 * @param {Number} ma the number to encode the choice of moving average type.
 * @param {Number} md the number to encode the choice of moving deviation type.
 * @param {Number} nocp the number of considered periods.
 * @param {Number} delta the number of moving deviations.
 *
 * @returns {Array} the time series of Bollinger bands.
 */
var _default = exports.default = function _default(hts, lts, cts, ul, ma, md, nocp, delta) {
  var ts = (0, _underlying.default)(hts, lts, cts, ul);
  var bb = (0, _movingAverage.default)(ts, ma, nocp);
  var dev = (0, _movingDeviation.default)(ts, md, nocp);
  var bb1 = bb.map(function (x, i) {
    return x + delta * dev[i];
  });
  var bb2 = bb.map(function (x, i) {
    return x - delta * dev[i];
  });
  return [bb1, bb2];
};

},{"modules/InstrumentChartModule/ChartIndicators/calculators/movingAverage":55,"modules/InstrumentChartModule/ChartIndicators/calculators/movingDeviation":57,"modules/InstrumentChartModule/ChartIndicators/calculators/underlying":71}],44:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
/**
 * @param {Array} lts the time series of low prices.
 * @param {Array} cts the time series of close prices.
 *
 * @returns {Array} the time series of buying pressure.
 */
var _default = exports.default = function _default(lts, cts) {
  return cts.map(function (c, i) {
    return !i ? _constants.ZERO : c - Math.min(lts[i], cts[i - 1]);
  });
};

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37}],45:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
var _accumulationDistributionLine = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/accumulationDistributionLine"));
var _movingAverage = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/movingAverage"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * @param {Array} ots the time series of open prices.
 * @param {Array} hts the time series of high prices.
 * @param {Array} lts the time series of low prices.
 * @param {Array} cts the time series of close prices.
 * @param {Array} vts the time series of volume values.
 * @param {Number} coeff
 * @param {Number} ma the number to encode the choice of moving average type.
 * @param {Number} nocp1 the number of considered periods1.
 * @param {Number} nocp2 the number of considered periods2.
 *
 * @returns {Array} the time series of Chaikin oscillator.
 */
var _default = exports.default = function _default(ots, hts, lts, cts, vts, coeff, ma, nocp1, nocp2) {
  var adl = (0, _accumulationDistributionLine.default)(ots, hts, lts, cts, vts, coeff, _constants.ADL_MOVING_AVERAGE, 1);
  var cho = (0, _movingAverage.default)(adl, ma, nocp1);
  var aadl2 = (0, _movingAverage.default)(adl, ma, nocp2);
  return cho.map(function (x, i) {
    return x - aadl2[i];
  });
};

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37,"modules/InstrumentChartModule/ChartIndicators/calculators/accumulationDistributionLine":38,"modules/InstrumentChartModule/ChartIndicators/calculators/movingAverage":55}],46:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
var _movingAverage = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/movingAverage"));
var _movingDeviation = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/movingDeviation"));
var _typicalPrice = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/typicalPrice"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * @param {Array} hts the time series of high prices.
 * @param {Array} lts the time series of low prices.
 * @param {Array} cts the time series of close prices.
 * @param {Number} ma the number to encode the choice of moving average type.
 * @param {Number} md the number to encode the choice of moving deviation type.
 * @param {Number} nocp the number of considered periods.
 * @param {Number} delta the weight factor.
 *
 * @returns {Array} the time series of commodity channel index.
 */
var _default = exports.default = function _default(hts, lts, cts, ma, md, nocp, delta) {
  var tp = (0, _typicalPrice.default)(hts, lts, cts);
  var mean = (0, _movingAverage.default)(cts, ma, nocp);
  var dev = (0, _movingDeviation.default)(cts, md, nocp);
  return tp.map(function (x, i) {
    var denom = delta * dev[i];
    return denom < _constants.EPSDENOM ? _constants.ZERO : (x - mean[i]) / denom;
  });
};

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37,"modules/InstrumentChartModule/ChartIndicators/calculators/movingAverage":55,"modules/InstrumentChartModule/ChartIndicators/calculators/movingDeviation":57,"modules/InstrumentChartModule/ChartIndicators/calculators/typicalPrice":69}],47:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
var _movingAverage = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/movingAverage"));
var _trueRange = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/trueRange"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 * @param {Array} hts the time series of high prices.
 * @param {Array} lts the time series of low prices.
 * @param {Array} cts the time series of close prices.
 * @param {Number} ma the number to encode the choice of moving average type.
 * @param {Number} nocp the number of considered periods.
 *
 * @returns {Array} the time series of directional movement index.
 */
var _default = exports.default = function _default(hts, lts, cts, ma, nocp) {
  var atr = (0, _movingAverage.default)((0, _trueRange.default)(hts, lts, cts), ma, nocp);
  var _cts$reduce = cts.reduce(function (_ref, _, i) {
      var _ref2 = _slicedToArray(_ref, 2),
        pdi = _ref2[0],
        mdi = _ref2[1];
      if (!i) {
        return [[_constants.ZERO], [_constants.ZERO]];
      }
      var h = hts[i] - hts[i - 1];
      var l = lts[i - 1] - lts[i];
      pdi.push(_constants.ZERO < h && l < h ? h : _constants.ZERO);
      mdi.push(_constants.ZERO < l && h < l ? l : _constants.ZERO);
      return [pdi, mdi];
    }, []),
    _cts$reduce2 = _slicedToArray(_cts$reduce, 2),
    pdi = _cts$reduce2[0],
    mdi = _cts$reduce2[1];
  pdi = (0, _movingAverage.default)(pdi, ma, nocp);
  pdi = pdi.map(function (x, i) {
    return atr[i] < _constants.EPSDENOM ? _constants.ONEOTWO : x / atr[i];
  });
  mdi = (0, _movingAverage.default)(mdi, ma, nocp);
  mdi = mdi.map(function (x, i) {
    return atr[i] < _constants.EPSDENOM ? _constants.ONEOTWO : x / atr[i];
  });
  var dmi = pdi.map(function (x, i) {
    var denom = x + mdi[i];
    return denom < _constants.EPSDENOM ? _constants.ONE : Math.abs(x - mdi[i]) / denom;
  });
  return [pdi, mdi, dmi];
};

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37,"modules/InstrumentChartModule/ChartIndicators/calculators/movingAverage":55,"modules/InstrumentChartModule/ChartIndicators/calculators/trueRange":68}],48:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
var _movingAverage = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/movingAverage"));
var _underlying = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/underlying"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * @param {Array} hts the time series of high prices.
 * @param {Array} lts the time series of low prices.
 * @param {Array} cts the time series of close prices.
 * @param {Number} grn the number of the graph.
 * @param {Number} ul the number to encode the choice of underlying.
 * @param {Number} ma the number to encode the choice of moving average type.
 * @param {Number} nocp the number of considered periods.
 * @param {Number} deltau the upper shift.
 * @param {Number} deltal the lower shift.
 *
 * @returns {Array} the time series of envelopes.
 */
var _default = exports.default = function _default(hts, lts, cts, ul, ma, nocp, deltau, deltal) {
  var coeffu = _constants.ONE + deltau;
  var coeffl = _constants.ONE - deltal;
  var env = (0, _movingAverage.default)((0, _underlying.default)(hts, lts, cts, ul), ma, nocp);
  var envUpper = env.map(function (x) {
    return coeffu * x;
  });
  var envLower = env.map(function (x) {
    return coeffl * x;
  });
  return [envUpper, envLower];
};

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37,"modules/InstrumentChartModule/ChartIndicators/calculators/movingAverage":55,"modules/InstrumentChartModule/ChartIndicators/calculators/underlying":71}],49:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
var _movingAverage = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/movingAverage"));
var _underlying = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/underlying"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * @param {Array} hts the time series of high prices.
 * @param {Array} lts the time series of low prices.
 * @param {Array} cts the time series of close prices.
 * @param {Number} ul the number to encode the choice of underlying.
 * @param {Number} nocp the number of considered periods.
 *
 * @returns {Array} the time series of exponential moving average.
 */
var _default = exports.default = function _default(hts, lts, cts, ul, nocp) {
  return (0, _movingAverage.default)((0, _underlying.default)(hts, lts, cts, ul), _constants.MovingAverage.Exponential, nocp);
};

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37,"modules/InstrumentChartModule/ChartIndicators/calculators/movingAverage":55,"modules/InstrumentChartModule/ChartIndicators/calculators/underlying":71}],50:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
var _movingAverage = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/movingAverage"));
var _movingMaxima = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/movingMaxima"));
var _movingMinima = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/movingMinima"));
var _underlying = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/underlying"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * @param {Array} hts the time series of high prices.
 * @param {Array} lts the time series of low prices.
 * @param {Array} cts the time series of close prices.
 * @param {Number} ul the number to encode the choice of underlying.
 * @param {Number} ma the number to encode the choice of moving average type.
 * @param {Number} nocp1 the number of considered periods1.
 * @param {Number} nocp2 the number of considered periods2.
 *
 * @returns {Array} the time series of fast stochastics.
 */
var _default = exports.default = function _default(hts, lts, cts, ul, ma, nocp1, nocp2) {
  var mh = (0, _movingMaxima.default)(hts, nocp1);
  var ml = (0, _movingMinima.default)(lts, nocp1);
  var movul = (0, _underlying.default)(hts, lts, cts, ul);
  var pk = movul.map(function (m, i) {
    var denom = mh[i] - ml[i];
    return denom < _constants.EPSDENOM ? _constants.ONEOTWO : (m - ml[i]) / denom;
  });
  return [pk, (0, _movingAverage.default)(pk, ma, nocp2)];
};

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37,"modules/InstrumentChartModule/ChartIndicators/calculators/movingAverage":55,"modules/InstrumentChartModule/ChartIndicators/calculators/movingMaxima":58,"modules/InstrumentChartModule/ChartIndicators/calculators/movingMinima":60,"modules/InstrumentChartModule/ChartIndicators/calculators/underlying":71}],51:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
var _logarithmicReturns = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/logarithmicReturns"));
var _movingDeviation = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/movingDeviation"));
var _underlying = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/underlying"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * @param {Array} hts the time series of high prices.
 * @param {Array} lts the time series of low prices.
 * @param {Array} cts the time series of close prices.
 * @param {Number} ul the number to encode the choice of underlying.
 * @param {Number} nocp1 the number of considered periods1.
 * @param {Number} nocp2 the number of considered periods2.
 * @param {Number} nocpn the number of normalizing periods.
 *
 * @returns {Array} the time series of historical volatility.
 */
var _default = exports.default = function _default(hts, lts, cts, ul, nocp1, nocp2, nocpn) {
  var norm = Math.sqrt(nocpn);
  var logReturn = (0, _logarithmicReturns.default)((0, _underlying.default)(hts, lts, cts, ul));
  var hv1 = (0, _movingDeviation.default)(logReturn, _constants.MovingDeviation.Standard, nocp1).map(function (x) {
    return x * norm;
  });
  var hv2 = (0, _movingDeviation.default)(logReturn, _constants.MovingDeviation.Standard, nocp2).map(function (x) {
    return x * norm;
  });
  return [hv1, hv2];
};

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37,"modules/InstrumentChartModule/ChartIndicators/calculators/logarithmicReturns":52,"modules/InstrumentChartModule/ChartIndicators/calculators/movingDeviation":57,"modules/InstrumentChartModule/ChartIndicators/calculators/underlying":71}],52:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
/**
 * @param {Array} ts the time series of market prices.
 *
 * @returns {Array} the time series of logarithmic returns.
 */
var _default = exports.default = function _default(ts) {
  return ts.map(function (x, i) {
    return !i ? _constants.ZERO : Math.log(x / ts[i - 1]);
  });
};

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37}],53:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _underlying = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/underlying"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * @param {Array} hts the time series of high prices.
 * @param {Array} lts the time series of low prices.
 * @param {Array} cts the time series of close prices.
 * @param {Number} ul the number to encode the choice of underlying.
 * @param {Number} nocp the number of considered periods.
 *
 * @returns {Array} the time series of momentum.
 */
var _default = exports.default = function _default(hts, lts, cts, ul, nocp) {
  var ts = (0, _underlying.default)(hts, lts, cts, ul);
  var nocpmone = Math.min(nocp, ts.length);
  return ts.map(function (x, i) {
    return i < nocpmone ? x - ts[0] : x - ts[i - nocpmone];
  });
};

},{"modules/InstrumentChartModule/ChartIndicators/calculators/underlying":71}],54:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
var _movingAverage = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/movingAverage"));
var _underlying = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/underlying"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * @param {Array} hts the time series of high prices.
 * @param {Array} lts the time series of low prices.
 * @param {Array} cts the time series of close prices.
 * @param {Array} vts the time series of volume values.
 * @param {Number} ul the number to encode the choice of underlying.
 * @param {Number} ma the number to encode the choice of moving average type.
 * @param {Number} nocp the number of considered periods.
 *
 * @returns {Array} the time series of money flow index.
 */
var _default = exports.default = function _default(hts, lts, cts, vts, ul, ma, nocp) {
  var ts = (0, _underlying.default)(hts, lts, cts, ul);
  var apmf = Array(ts.length);
  var anmf = Array(ts.length);
  var mfi = Array(ts.length);
  apmf[0] = _constants.ZERO;
  anmf[0] = _constants.ZERO;
  for (var k = 1; k < apmf.length; k++) {
    if (ts[k - 1] < ts[k]) {
      apmf[k] = ts[k] * vts[k];
      anmf[k] = _constants.ZERO;
    } else if (ts[k - 1] === ts[k]) {
      apmf[k] = _constants.ZERO;
      anmf[k] = _constants.ZERO;
    } else {
      apmf[k] = _constants.ZERO;
      anmf[k] = ts[k] * vts[k];
    }
  }
  apmf = (0, _movingAverage.default)(apmf, ma, nocp);
  anmf = (0, _movingAverage.default)(anmf, ma, nocp);
  for (var _k = 0; _k < mfi.length; _k++) {
    if (anmf[_k] < _constants.EPSDENOM) {
      mfi[_k] = _constants.ONE;
    } else {
      mfi[_k] = apmf[_k] / (anmf[_k] + apmf[_k]);
    }
  }
  return mfi;
};

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37,"modules/InstrumentChartModule/ChartIndicators/calculators/movingAverage":55,"modules/InstrumentChartModule/ChartIndicators/calculators/underlying":71}],55:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
var arithmeticMovingAverage = function arithmeticMovingAverage(ts, m) {
  m = Math.min(m, ts.length);
  var oneom = _constants.ONE / m;
  var sum = ts[0];
  return ts.map(function (x, i) {
    if (!i) {
      return x;
    } else if (i < m) {
      sum += x;
      return sum / (i + _constants.ONE);
    } else {
      sum += x - ts[i - m];
      return sum * oneom;
    }
  });
};
var exponentialMovingAverage = function exponentialMovingAverage(ts, m) {
  m = Math.min(m, ts.length);
  var twoompone = _constants.TWO / (m + _constants.ONE);
  var onemtwoompone = _constants.ONE - twoompone;
  return ts.reduce(function (all, x, i) {
    if (!i) {
      all.push(x);
    } else if (i < m) {
      all.push(all[i - 1] + _constants.TWO * (x - all[i - 1]) / (i + _constants.TWO));
    } else {
      all.push(all[i - 1] * onemtwoompone + x * twoompone);
    }
    return all;
  }, []);
};
var wildersMovingAverage = function wildersMovingAverage(ts, m) {
  m = Math.min(m, ts.length);
  var oneom = _constants.ONE / m;
  var onemoneom = _constants.ONE - oneom;
  return ts.reduce(function (all, x, i) {
    if (!i) {
      all.push(x);
    } else if (i < m) {
      all.push(all[i - 1] + (x - all[i - 1]) / (i + _constants.ONE));
    } else {
      all.push(all[i - 1] * onemoneom + x * oneom);
    }
    return all;
  }, []);
};

/**
 * @param {Array} ts the input time series.
 * @param {Mixed} ma the type of moving average.
 * @param {Number} m the number of considered periods.
 *
 * @returns {Array} the time series of moving average.
 */
var _default = exports.default = function _default(ts, ma, m) {
  switch (ma) {
    case _constants.MovingAverage.Arithmetic:
      return arithmeticMovingAverage(ts, m);
    case _constants.MovingAverage.Exponential:
      return exponentialMovingAverage(ts, m);
    case _constants.MovingAverage.Wilders:
      return wildersMovingAverage(ts, m);
    default:
      throw new Error("movingAverage type ".concat(ma, " does not exist"));
  }
};

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37}],56:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _movingAverage = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/movingAverage"));
var _underlying = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/underlying"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * @param {Array} hts the time series of high prices.
 * @param {Array} lts the time series of low prices.
 * @param {Array} cts the time series of close prices.
 * @param {Number} grn the number of the graph.
 * @param {Number} ul the number to encode the choice of underlying.
 * @param {Number} ma the number to encode the choice of moving average type.
 * @param {Number} nocp1 the number of considered periods1.
 * @param {Number} nocp2 the number of considered periods2.
 * @param {Number} nocp3 the number of considered periods3.
 *
 * @returns {Array} the time series of moving average convergence divergence.
 */
var _default = exports.default = function _default(hts, lts, cts, ul, ma, nocp1, nocp2, nocp3) {
  var ts = (0, _underlying.default)(hts, lts, cts, ul);
  var mean1 = (0, _movingAverage.default)(ts, ma, nocp1);
  var mean2 = (0, _movingAverage.default)(ts, ma, nocp2);
  var result1 = mean1.map(function (x, i) {
    return x - mean2[i];
  });
  var result2 = (0, _movingAverage.default)(result1, ma, nocp3);
  var result3 = result1.map(function (x, i) {
    return x - result2[i];
  });
  return [result1, result2, result3];
};

},{"modules/InstrumentChartModule/ChartIndicators/calculators/movingAverage":55,"modules/InstrumentChartModule/ChartIndicators/calculators/underlying":71}],57:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
var _movingAverage = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/movingAverage"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * @param {Array} ts the input time series.
 * @param {Mixed} md the type of moving deviation.
 * @param {Number} m the number of considered periods.
 *
 * @returns {Array} the time series of moving deviation.
 */
var _default = exports.default = function _default(ts, md, m) {
  m = Math.min(m, ts.length);
  var movarmean = (0, _movingAverage.default)(ts, _constants.MovingAverage.Arithmetic, m);
  if (md === _constants.MovingDeviation.Mean) {
    var oneom = _constants.ONE / m;
    return ts.map(function (_, i) {
      if (!i) {
        return _constants.ZERO;
      } else if (i < m) {
        var sum = _constants.ZERO;
        for (var j = 0; j < i; j++) {
          sum += Math.abs(movarmean[i] - ts[j]);
        }
        return sum / (i + _constants.ONE);
      } else {
        var _sum = _constants.ZERO;
        for (var _j = 0; _j < m; _j++) {
          _sum += Math.abs(movarmean[i] - ts[i - _j]);
        }
        return _sum * oneom;
      }
    });
  }
  if (md === _constants.MovingDeviation.Standard) {
    return (0, _movingAverage.default)(ts.map(function (x) {
      return x * x;
    }), _constants.MovingAverage.Arithmetic, m).reduce(function (all, x, i) {
      all.push(Math.sqrt(x - movarmean[i] * movarmean[i]));
      return all;
    }, []);
  }
  throw new Error("movingDeviation type ".concat(md, " does not exist"));
};

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37,"modules/InstrumentChartModule/ChartIndicators/calculators/movingAverage":55}],58:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * @param {Array} ts the input time series.
 * @param [Number} m the number of considered periods.
 *
 * @returns {Array} the time series of moving maxima.
 */
var _default = exports.default = function _default(ts, m) {
  m = Math.min(m, ts.length);
  if (m === 1) {
    return ts;
  }
  var movmax = Array(ts.length);
  var max = ts[0];
  var maxpos = 0;
  movmax[0] = max;
  for (var k = 1; k < m; k++) {
    if (max <= ts[k]) {
      max = ts[k];
      maxpos = k;
    }
    movmax[k] = max;
  }
  for (var _k = m; _k < movmax.length; _k++) {
    if (maxpos === _k - m) {
      max = ts[maxpos + 1];
      maxpos += 1;
      for (var j = _k - m + 2; j < _k + 1; j++) {
        if (max <= ts[j]) {
          max = ts[j];
          maxpos = j;
        }
      }
    }
    if (max <= ts[_k]) {
      max = ts[_k];
      maxpos = _k;
    }
    movmax[_k] = max;
  }
  return movmax;
};

},{}],59:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * @param {Array} ts the input time series.
 * @param {Number} m the number of considered periods.
 *
 * @returns {Array} the time series of the positions of moving maxima.
 */
var _default = exports.default = function _default(ts, m) {
  m = Math.min(m, ts.length);
  var movmaxpos = Array(ts.length);
  if (m === 1) {
    for (var k = 0; k < movmaxpos.length; k++) {
      movmaxpos[k] = k;
    }
    return movmaxpos;
  }
  var maxpos = 0;
  var max = ts[0];
  movmaxpos[0] = maxpos;
  for (var _k = 1; _k < m; _k++) {
    if (max <= ts[_k]) {
      max = ts[_k];
      maxpos = _k;
    }
    movmaxpos[_k] = maxpos;
  }
  for (var _k2 = m; _k2 < movmaxpos.length; _k2++) {
    if (maxpos === _k2 - m) {
      max = ts[maxpos + 1];
      maxpos += 1;
      for (var j = _k2 - m + 2; j < _k2 + 1; j++) {
        if (max <= ts[j]) {
          max = ts[j];
          maxpos = j;
        }
      }
    }
    if (max <= ts[_k2]) {
      max = ts[_k2];
      maxpos = _k2;
    }
    movmaxpos[_k2] = maxpos;
  }
  return movmaxpos;
};

},{}],60:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * @param {Array} ts the input time series.
 * @param [Number} m the number of considered periods.
 *
 * @returns {Array} the time series of moving minima.
 */
var _default = exports.default = function _default(ts, m) {
  m = Math.min(m, ts.length);
  if (m === 1) {
    return ts;
  }
  var movmin = Array(ts.length);
  var min = ts[0];
  var minpos = 0;
  movmin[0] = min;
  for (var k = 1; k < m; k++) {
    if (min >= ts[k]) {
      min = ts[k];
      minpos = k;
    }
    movmin[k] = min;
  }
  for (var _k = m; _k < movmin.length; _k++) {
    if (minpos === _k - m) {
      min = ts[minpos + 1];
      minpos += 1;
      for (var j = _k - m + 2; j < _k + 1; j++) {
        if (min >= ts[j]) {
          min = ts[j];
          minpos = j;
        }
      }
    }
    if (min >= ts[_k]) {
      min = ts[_k];
      minpos = _k;
    }
    movmin[_k] = min;
  }
  return movmin;
};

},{}],61:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * @param {Array} ts the input time series.
 * @param {Number} m the number of considered periods.
 *
 * @returns {Array} the time series of the positions of moving minima.
 */
var _default = exports.default = function _default(ts, m) {
  m = Math.min(m, ts.length);
  var movminpos = Array(ts.length);
  if (m === 1) {
    for (var k = 0; k < movminpos.length; k++) {
      movminpos[k] = k;
    }
    return movminpos;
  }
  var min = ts[0];
  var minpos = 0;
  movminpos[0] = minpos;
  for (var _k = 1; _k < m; _k++) {
    if (ts[_k] <= min) {
      min = ts[_k];
      minpos = _k;
    }
    movminpos[_k] = minpos;
  }
  for (var _k2 = m; _k2 < movminpos.length; _k2++) {
    if (minpos === _k2 - m) {
      min = ts[minpos + 1];
      minpos += 1;
      for (var j = _k2 - m + 2; j < _k2 + 1; j++) {
        if (ts[j] <= min) {
          min = ts[j];
          minpos = j;
        }
      }
    }
    if (ts[_k2] <= min) {
      min = ts[_k2];
      minpos = _k2;
    }
    movminpos[_k2] = minpos;
  }
  return movminpos;
};

},{}],62:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
var _movingAverage = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/movingAverage"));
var _underlying = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/underlying"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * @param {Array} hts the time series of high prices.
 * @param {Array} lts the time series of low prices.
 * @param {Array} cts the time series of close prices.
 * @param {Array} vts the time series of volume values.
 * @param {Number} ul the number to encode the choice of underlying.
 * @param {Number} ma the number to encode the choice of moving average type.
 * @param {Number} nocp the number of considered periods.
 *
 * @returns {Array} the time series of on balance volume.
 */
var _default = exports.default = function _default(hts, lts, cts, vts, ul, ma, nocp) {
  var ts = (0, _underlying.default)(hts, lts, cts, ul);
  var obv = ts.reduce(function (all, x, i) {
    if (!i) {
      all.push(_constants.ZERO);
    } else if (ts[i - 1] < x) {
      all.push(all[i - 1] + vts[i]);
    } else if (x < ts[i - 1]) {
      all.push(all[i - 1] - vts[i]);
    } else {
      all.push(all[i - 1]);
    }
    return all;
  }, []);
  return [obv, (0, _movingAverage.default)(obv, ma, nocp)];
};

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37,"modules/InstrumentChartModule/ChartIndicators/calculators/movingAverage":55,"modules/InstrumentChartModule/ChartIndicators/calculators/underlying":71}],63:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var SAR_START = 30;

/**
 * @param {Array} hts the time series of high prices.
 * @param {Array} lts the time series of low prices.
 * @param {Number} afsv the acceleration factor start value.
 * @param {Number} afsw the acceleration factor step width.
 * @param {Number} afmax the maximum acceleration factor.
 *
 * @returns {Array} the time series of Parabolic.
 */
var _default = exports.default = function _default(hts, lts, afsv, afsw, afmax) {
  var sar = Array(hts.length);
  var af = afsv;
  var ep = _constants.ONE;
  var startpos = Math.min(SAR_START, sar.length); // 30 works!

  var _hts$slice$reduce = hts.slice(0, startpos).reduce(function (_ref, x, i) {
      var _ref2 = _slicedToArray(_ref, 2),
        max = _ref2[0],
        maxpos = _ref2[1];
      return max <= x ? [x, i] : [max, maxpos];
    }, [-Infinity]),
    _hts$slice$reduce2 = _slicedToArray(_hts$slice$reduce, 2),
    max = _hts$slice$reduce2[0],
    maxpos = _hts$slice$reduce2[1];
  var _lts$slice$reduce = lts.slice(0, startpos).reduce(function (_ref3, x, i) {
      var _ref4 = _slicedToArray(_ref3, 2),
        min = _ref4[0],
        minpos = _ref4[1];
      return x <= min ? [x, i] : [min, minpos];
    }, [Infinity]),
    _lts$slice$reduce2 = _slicedToArray(_lts$slice$reduce, 2),
    min = _lts$slice$reduce2[0],
    minpos = _lts$slice$reduce2[1];
  var max2 = hts[minpos];
  var min2 = lts[maxpos];
  var maxpos2 = minpos;
  var minpos2 = maxpos;
  var longtrade = lts[0] - min > max - hts[0];
  var newintrade = true;
  if (longtrade) {
    startpos = Math.min(minpos + 5, sar.length);
    for (var k = minpos; k < startpos; k++) {
      if (max2 <= hts[k]) {
        max2 = hts[k];
        maxpos2 = k;
      }
    }
    startpos = maxpos2;
    min = lts[0];
    for (var _k = 0; _k < startpos; _k++) {
      sar[_k] = 1.05 * hts[_k];
      if (lts[_k] <= min) {
        min = lts[_k];
      }
      ep = min;
    }
  } else {
    startpos = Math.min(maxpos + 5, sar.length);
    for (var _k2 = maxpos; _k2 < startpos; _k2++) {
      if (lts[_k2] <= min2) {
        min2 = lts[_k2];
        minpos2 = _k2;
      }
    }
    startpos = minpos2;
    max = hts[0];
    for (var _k3 = 0; _k3 < startpos; _k3++) {
      sar[_k3] = 0.95 * lts[_k3];
      if (max <= hts[_k3]) {
        max = hts[_k3];
      }
      ep = max;
    }
  }
  for (var _k4 = startpos; _k4 < sar.length; _k4++) {
    if (longtrade) {
      if (newintrade) {
        sar[_k4] = Math.min(ep, lts[_k4]);
        ep = hts[_k4];
        af = afsv;
        newintrade = false;
      } else {
        sar[_k4] = sar[_k4 - 1] + af * (ep - sar[_k4 - 1]);
        if (ep < hts[_k4]) {
          ep = hts[_k4];
          if (af < afmax) {
            af += afsw;
          }
        }
        if (lts[_k4] < sar[_k4]) {
          _k4 -= 1;
          longtrade = false;
          newintrade = true;
        }
      }
      if (lts[_k4 - 2] < sar[_k4] || lts[_k4 - 1] < sar[_k4]) {
        sar[_k4] = Math.min(lts[_k4 - 2], lts[_k4 - 1]);
      }
    } else {
      if (newintrade) {
        sar[_k4] = Math.max(ep, hts[_k4]);
        ep = lts[_k4];
        af = afsv;
        newintrade = false;
      } else {
        sar[_k4] = sar[_k4 - 1] + af * (ep - sar[_k4 - 1]);
        if (lts[_k4] < ep) {
          ep = lts[_k4];
          if (af < afmax) {
            af += afsw;
          }
        }
        if (sar[_k4] < hts[_k4]) {
          _k4 -= 1;
          longtrade = true;
          newintrade = true;
        }
      }
      if (sar[_k4] < hts[_k4 - 2] || sar[_k4] < hts[_k4 - 1]) {
        sar[_k4] = Math.max(hts[_k4 - 2], hts[_k4 - 1]);
      }
    }
  }
  return sar.reduce(function (_ref5, x, i) {
    var _ref6 = _slicedToArray(_ref5, 2),
      sarlong = _ref6[0],
      sarshort = _ref6[1];
    sarlong.push(x <= lts[i] ? x : _constants.NO_VALUE);
    sarshort.push(x <= lts[i] ? _constants.NO_VALUE : x);
    return [sarlong, sarshort];
  }, [[], []]);
};

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37}],64:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
var _underlying = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/underlying"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * @param {Array} hts the time series of high prices.
 * @param {Array} lts the time series of low prices.
 * @param {Array} cts the time series of close prices.
 * @param {Number} ul the number to encode the choice of underlying.
 * @param {Number} nocp the number of considered periods.
 *
 * @returns {Array} the time series of rate of change.
 */
var _default = exports.default = function _default(hts, lts, cts, ul, nocp) {
  var ts = (0, _underlying.default)(hts, lts, cts, ul);
  var nocpmone = Math.min(nocp, ts.length);
  return ts.map(function (x, i) {
    return i < nocpmone ? x / ts[0] - _constants.ONE : x / ts[i - nocpmone] - _constants.ONE;
  });
};

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37,"modules/InstrumentChartModule/ChartIndicators/calculators/underlying":71}],65:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
var _movingAverage = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/movingAverage"));
var _underlying = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/underlying"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 * @param {Array} hts the time series of high prices.
 * @param {Array} lts the time series of low prices.
 * @param {Array} cts the time series of close prices.
 * @param {Number} ul the number to encode the choice of underlying.
 * @param {Number} ma the number to encode the choice of moving average type.
 * @param {Number} nocp the number of considered periods.
 *
 * @returns {Array} the time series of relative strength index.
 */
var _default = exports.default = function _default(hts, lts, cts, ul, ma, nocp) {
  var ts = (0, _underlying.default)(hts, lts, cts, ul);
  var _ts$reduce = ts.reduce(function (_ref, x, i) {
      var _ref2 = _slicedToArray(_ref, 2),
        au = _ref2[0],
        ad = _ref2[1];
      if (!i) {
        return [[_constants.ZERO], [_constants.ZERO]];
      }
      var mom2 = x - ts[i - 1];
      au.push(_constants.ZERO < mom2 ? mom2 : _constants.ZERO);
      ad.push(_constants.ZERO > mom2 ? -mom2 : _constants.ZERO);
      return [au, ad];
    }, []),
    _ts$reduce2 = _slicedToArray(_ts$reduce, 2),
    au = _ts$reduce2[0],
    ad = _ts$reduce2[1];
  au = (0, _movingAverage.default)(au, ma, nocp);
  ad = (0, _movingAverage.default)(ad, ma, nocp);
  return ad.map(function (a, i) {
    return a < _constants.EPSDENOM ? _constants.ONE : _constants.ONE - _constants.ONE / (_constants.ONE + au[i] / a);
  });
};

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37,"modules/InstrumentChartModule/ChartIndicators/calculators/movingAverage":55,"modules/InstrumentChartModule/ChartIndicators/calculators/underlying":71}],66:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
var _movingAverage = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/movingAverage"));
var _underlying = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/underlying"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * @param {Array} hts the time series of high prices.
 * @param {Array} lts the time series of low prices.
 * @param {Array} cts the time series of close prices.
 * @param {Number} ul the number to encode the choice of underlying.
 * @param {Number} nocp the number of considered periods.
 *
 * @returns {Array} the time series of simple moving average.
 */
var _default = exports.default = function _default(hts, lts, cts, ul, nocp) {
  return (0, _movingAverage.default)((0, _underlying.default)(hts, lts, cts, ul), _constants.MovingAverage.Arithmetic, nocp);
};

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37,"modules/InstrumentChartModule/ChartIndicators/calculators/movingAverage":55,"modules/InstrumentChartModule/ChartIndicators/calculators/underlying":71}],67:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _fastStochastics = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/fastStochastics"));
var _movingAverage = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/movingAverage"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 * @param {Array} hts the time series of high prices.
 * @param {Array} lts the time series of low prices.
 * @param {Array} cts the time series of close prices.
 * @param {Number} grn the number of the graph.
 * @param {Number} ul the number to encode the choice of underlying.
 * @param {Number} ma the number to encode the choice of moving average type.
 * @param {Number} nocp1 the number of considered periods1.
 * @param {Number} nocp2 the number of considered periods2.
 * @param {Number} nocp3 the number of considered periods3.
 *
 * @returns {Array} the time series of slow stochastics.
 */
var _default = exports.default = function _default(hts, lts, cts, ul, ma, nocp1, nocp2, nocp3) {
  var _pk = (0, _fastStochastics.default)(hts, lts, cts, ul, ma, nocp1, nocp2),
    _pk2 = _slicedToArray(_pk, 2),
    pd = _pk2[1];
  return [pd, (0, _movingAverage.default)(pd, ma, nocp3)];
};

},{"modules/InstrumentChartModule/ChartIndicators/calculators/fastStochastics":50,"modules/InstrumentChartModule/ChartIndicators/calculators/movingAverage":55}],68:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * @param {Array} hts the time series of high prices.
 * @param {Array} lts the time series of low prices.
 * @param {Array} cts the time series of close prices.
 *
 * @returns {Array} the time series of true range.
 */
var _default = exports.default = function _default(hts, lts, cts) {
  return cts.map(function (_, i) {
    if (!i) {
      return hts[i] - lts[i];
    } else if (cts[i - 1] < lts[i]) {
      return hts[i] - cts[i - 1];
    } else if (hts[i] < cts[i - 1]) {
      return cts[i - 1] - lts[i];
    } else {
      return hts[i] - lts[i];
    }
  });
};

},{}],69:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
/**
 * @param {Array} hts the time series of high prices.
 * @param {Array} lts the time series of low prices.
 * @param {Array} cts the time series of close prices.
 *
 * @returns {Array} the time series of typical price.
 */
var _default = exports.default = function _default(hts, lts, cts) {
  return cts.map(function (_, i) {
    return (hts[i] + lts[i] + cts[i]) * _constants.ONEOTHREE;
  });
};

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37}],70:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
var _buyingPressure = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/buyingPressure"));
var _movingAverage = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/movingAverage"));
var _trueRange = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/trueRange"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * @param {Array} hts the time series of high prices.
 * @param {Array} lts the time series of low prices.
 * @param {Array} cts the time series of close prices.
 * @param {Number} ma the number to encode the choice of moving average type.
 * @param {Number} nocp1 the number of considered periods1.
 * @param {Number} nocp2 the number of considered periods2.
 * @param {Number} nocp3 the number of considered periods3.
 *
 * @returns {Array} the time series of ultimate oscillator.
 */
var _default = exports.default = function _default(hts, lts, cts, ma, nocp1, nocp2, nocp3) {
  var mbp = (0, _buyingPressure.default)(lts, cts);
  var mtr = (0, _trueRange.default)(hts, lts, cts);
  var abp1 = (0, _movingAverage.default)(mbp, ma, nocp1);
  var abp2 = (0, _movingAverage.default)(mbp, ma, nocp2);
  var abp3 = (0, _movingAverage.default)(mbp, ma, nocp3);
  var atr1 = (0, _movingAverage.default)(mtr, ma, nocp1);
  var atr2 = (0, _movingAverage.default)(mtr, ma, nocp2);
  var atr3 = (0, _movingAverage.default)(mtr, ma, nocp3);
  return atr1.map(function (x, i) {
    return x < _constants.EPSDENOM ? _constants.ONE : (_constants.FOUR * abp1[i] / x + _constants.TWO * abp2[i] / atr2[i] + abp3[i] / atr3[i]) * _constants.ONEOSEVEN;
  });
};

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37,"modules/InstrumentChartModule/ChartIndicators/calculators/buyingPressure":44,"modules/InstrumentChartModule/ChartIndicators/calculators/movingAverage":55,"modules/InstrumentChartModule/ChartIndicators/calculators/trueRange":68}],71:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
var _typicalPrice = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/typicalPrice"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * @param {Array} hts the time series of high prices.
 * @param {Array} lts the time series of low prices.
 * @param {Array} cts the time series of close prices.
 * @param {Number} ul the number to encode the choice of underlying.
 *
 * @returns {Array} the time series of the underlying.
 */
var _default = exports.default = function _default(hts, lts, cts, ul) {
  if ([_constants.Underlying.ClosePrice, _constants.Underlying.TypicalPrice].indexOf(ul) === -1) {
    throw new Error("underlying type ".concat(ul, " does not exist"));
  }
  return ul === _constants.Underlying.ClosePrice ? cts : (0, _typicalPrice.default)(hts, lts, cts);
};

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37,"modules/InstrumentChartModule/ChartIndicators/calculators/typicalPrice":69}],72:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
var _movingMaxima = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/movingMaxima"));
var _movingMinima = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/movingMinima"));
var _underlying = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/underlying"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * @param {Array} hts the time series of high prices.
 * @param {Array} lts the time series of low prices.
 * @param {Array} cts the time series of close prices.
 * @param {Array} ul the number to encode the choice of underlying.
 * @param {Array} nocp the number of considered periods.
 *
 * @returns {Array} the time series of Williams' percent R.
 */
var _default = exports.default = function _default(hts, lts, cts, ul, nocp) {
  var wpr = (0, _underlying.default)(hts, lts, cts, ul);
  var mh = (0, _movingMaxima.default)(hts, nocp);
  var ml = (0, _movingMinima.default)(lts, nocp);
  return wpr.map(function (x, i) {
    var denom = mh[i] - ml[i];
    return denom < _constants.EPSDENOM ? -_constants.ONE : (x - mh[i]) / denom;
  });
};

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37,"modules/InstrumentChartModule/ChartIndicators/calculators/movingMaxima":58,"modules/InstrumentChartModule/ChartIndicators/calculators/movingMinima":60,"modules/InstrumentChartModule/ChartIndicators/calculators/underlying":71}],73:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
/**
 * @param {Array} hts the time series of high prices.
 * @param {Array} lts the time series of low prices.
 * @param {Number} delta the fraction of the stock price.
 * @param {Boolean} useFirstExtreme <code>true</code>, if the first of a series of successive extreme points should be used; <code>false</code>,
 * otherwise.
 *
 * @return the time series of zig zag.
 */
var _default = exports.default = function _default(hts, lts, delta, useFirstExtreme) {
  var onepdelta = _constants.ONE + delta;
  var onemdelta = _constants.ONE - delta;
  var zz = Array(hts.length).fill(_constants.NO_VALUE);
  var length = hts.length;
  if (length <= 1) {
    return length ? [(hts[0] + lts[0]) / 2] : [];
  }
  var extreme = null;
  var index = -1;
  var downTrend = false;

  // determine first trend
  var minIndex = 0;
  var maxIndex = 0;
  var min = lts[0];
  var max = hts[0];
  var toleranceUp = max * onepdelta;
  var toleranceDown = min * onemdelta;
  for (var i = 1; i < length; i++) {
    var avg = (hts[i] + lts[i]) / 2;
    if (lts[i] < min) {
      min = lts[i];
      minIndex = i;
      if (avg <= toleranceDown) {
        zz[maxIndex] = max;
        if (maxIndex > 0) {
          zz[0] = lts[0];
        }
        extreme = min;
        index = minIndex;
        downTrend = true;
        toleranceUp = extreme * onepdelta;
        break;
      }
    }
    if (hts[i] > max) {
      max = hts[i];
      maxIndex = i;
      if (avg >= toleranceUp) {
        zz[minIndex] = min;
        if (minIndex > 0) {
          zz[0] = hts[0];
        }
        extreme = max;
        index = maxIndex;
        downTrend = false;
        toleranceDown = extreme * onemdelta;
        break;
      }
    }
  }
  if (index < 0) {
    if (hts[length - 1] + lts[length - 1] > hts[0] + lts[0]) {
      zz[0] = lts[0];
      zz[length - 1] = hts[length - 1];
    } else {
      zz[0] = hts[0];
      zz[length - 1] = lts[length - 1];
    }
    return zz;
  }
  for (var _i = index + 1; _i < length; _i++) {
    var _avg = (hts[_i] + lts[_i]) / 2;
    if (downTrend) {
      // down trend
      if (_avg >= toleranceUp) {
        zz[index] = extreme;
        extreme = hts[_i];
        toleranceDown = extreme * onemdelta;
        index = _i;
        downTrend = false;
      } else if (lts[_i] <= extreme) {
        if (!useFirstExtreme || lts[_i] !== lts[_i - 1]) {
          extreme = lts[_i];
          toleranceUp = extreme * onepdelta;
          index = _i;
        }
      }
    } else if (_avg <= toleranceDown) {
      zz[index] = extreme;
      extreme = lts[_i];
      toleranceUp = extreme * onepdelta;
      index = _i;
      downTrend = true;
    } else if (hts[_i] >= extreme) {
      if (!useFirstExtreme || hts[_i] !== hts[_i - 1]) {
        extreme = hts[_i];
        toleranceDown = extreme * onemdelta;
        index = _i;
      }
    }
  }
  zz[index] = extreme;
  if (index < length - 1) {
    downTrend = !downTrend;
    zz[length - 1] = downTrend ? lts[length - 1] : hts[length - 1];
  }
  return zz;
};

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37}],74:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/*
 * Abstract class for all indicators that implements the most commonly used methods by simply returning instance properties
 */
var ChartIndicator = exports.default = /*#__PURE__*/function () {
  function ChartIndicator() {
    _classCallCheck(this, ChartIndicator);
  }
  _createClass(ChartIndicator, [{
    key: "getRequiredPoints",
    value: function getRequiredPoints() {
      return this.requiredPoints || 0;
    }
  }, {
    key: "getRequiredSeries",
    value: function getRequiredSeries() {
      return this.requiredSeries || ['close'];
    }
  }, {
    key: "getExtraConfig",
    value: function getExtraConfig() {
      return this.extraConfig || {};
    }
  }, {
    key: "getDisplayName",
    value: function getDisplayName() {
      if (!this.displayName) {
        throw new Error('displayName must be set, or getDisplayName implemented');
      }
      return this.displayName;
    }
  }, {
    key: "getLegend",
    value: function getLegend() {
      if (!this.legend) {
        throw new Error('legend must be set, or getLegend implemented');
      }
      return this.legend;
    }
  }, {
    key: "getType",
    value: function getType() {
      return this.type || 'line';
    }
  }, {
    key: "getColor",
    value: function getColor() {
      return this.color || null;
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "calculate",
    value: function calculate() {
      throw new Error('calculate function must be implemented individually for each indicator');
    }
  }]);
  return ChartIndicator;
}();

},{}],75:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ChartIndicator2 = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator"));
var _accumulationDistributionLine = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/accumulationDistributionLine"));
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var AccumulationDistributionLine = exports.default = /*#__PURE__*/function (_ChartIndicator) {
  _inherits(AccumulationDistributionLine, _ChartIndicator);
  var _super = _createSuper(AccumulationDistributionLine);
  function AccumulationDistributionLine() {
    var _this;
    var period = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 38;
    _classCallCheck(this, AccumulationDistributionLine);
    _this = _super.call(this);
    _this.period = period;
    _this.requiredPoints = period;
    _this.requiredSeries = ['open', 'high', 'low', 'close', 'volume'];
    _this.legend = "".concat(window.getMessage('chart.indicator.legend.adl'), " (").concat(period, ")");
    _this.extraConfig = {
      digits: 0
    };
    return _this;
  }

  // eslint-disable-next-line class-methods-use-this
  _createClass(AccumulationDistributionLine, [{
    key: "getDisplayName",
    value: function getDisplayName(i) {
      return [window.getMessage('chart.indicator.legend.adl'), window.getMessage('chart.indicator.legend.aadl')][i];
    }
  }, {
    key: "calculate",
    value: function calculate(timestamp, open, high, low, close, volume) {
      return [{
        timestamp: timestamp,
        close: (0, _accumulationDistributionLine.default)(open, high, low, close, volume, _constants.Coefficient.ClosePrices, _constants.MovingAverage.Arithmetic, 1)
      }, {
        timestamp: timestamp,
        close: (0, _accumulationDistributionLine.default)(open, high, low, close, volume, _constants.Coefficient.ClosePrices, _constants.MovingAverage.Arithmetic, this.period)
      }];
    }
  }]);
  return AccumulationDistributionLine;
}(_ChartIndicator2.default);

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37,"modules/InstrumentChartModule/ChartIndicators/calculators/accumulationDistributionLine":38,"modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator":74}],76:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ChartIndicator2 = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator"));
var _aroon = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/aroon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var Aroon = exports.default = /*#__PURE__*/function (_ChartIndicator) {
  _inherits(Aroon, _ChartIndicator);
  var _super = _createSuper(Aroon);
  function Aroon() {
    var _this;
    var period = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 25;
    _classCallCheck(this, Aroon);
    _this = _super.call(this);
    _this.period = period;
    _this.requiredPoints = period;
    _this.requiredSeries = ['high', 'low'];
    _this.displayName = window.getMessage('chart.indicator.legend.ar');
    _this.legend = "".concat(window.getMessage('chart.indicator.legend.ar'), " (").concat(period, ")");
    _this.extraConfig = {
      valueSuffix: '%',
      getTicks: function getTicks() {
        return [-100, 0, 100];
      }
    };
    return _this;
  }
  _createClass(Aroon, [{
    key: "calculate",
    value: function calculate(timestamp, high, low) {
      return {
        timestamp: timestamp,
        close: (0, _aroon.default)(high, low, this.period).map(function (x) {
          return x * 100;
        })
      };
    }
  }]);
  return Aroon;
}(_ChartIndicator2.default);

},{"modules/InstrumentChartModule/ChartIndicators/calculators/aroon":39,"modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator":74}],77:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ChartIndicator2 = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator"));
var _aroonUpDown = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/aroonUpDown"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var sortedUnique = function sortedUnique(array) {
  return _toConsumableArray(new Set(array)).sort(function (a, b) {
    return a - b;
  });
};
var AroonUpDown = exports.default = /*#__PURE__*/function (_ChartIndicator) {
  _inherits(AroonUpDown, _ChartIndicator);
  var _super = _createSuper(AroonUpDown);
  function AroonUpDown() {
    var _this;
    var period = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 25;
    var sell = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 30;
    var buy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 70;
    _classCallCheck(this, AroonUpDown);
    _this = _super.call(this);
    _this.period = period;
    _this.requiredPoints = period;
    _this.requiredSeries = ['high', 'low'];
    _this.legend = "".concat(window.getMessage('chart.indicator.legend.arud'), " (").concat(period, ")");
    _this.extraConfig = {
      valueSuffix: '%',
      getTicks: function getTicks() {
        return sortedUnique([0, 50, 100, buy, sell]);
      },
      yLines: [{
        value: buy,
        color: 'up'
      }, {
        value: sell,
        color: 'down'
      }]
    };
    return _this;
  }

  // eslint-disable-next-line class-methods-use-this
  _createClass(AroonUpDown, [{
    key: "getDisplayName",
    value: function getDisplayName(i) {
      return [window.getMessage('chart.indicator.legend.arud.up'), window.getMessage('chart.indicator.legend.arud.down')][i];
    }
  }, {
    key: "calculate",
    value: function calculate(timestamp, high, low) {
      return (0, _aroonUpDown.default)(high, low, this.period).map(function (close) {
        return {
          timestamp: timestamp,
          close: close.map(function (x) {
            return x * 100;
          })
        };
      });
    }
  }]);
  return AroonUpDown;
}(_ChartIndicator2.default);

},{"modules/InstrumentChartModule/ChartIndicators/calculators/aroonUpDown":40,"modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator":74}],78:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ChartIndicator2 = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator"));
var _averageDirectionalIndex = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/averageDirectionalIndex"));
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var AverageDirectionalIndex = exports.default = /*#__PURE__*/function (_ChartIndicator) {
  _inherits(AverageDirectionalIndex, _ChartIndicator);
  var _super = _createSuper(AverageDirectionalIndex);
  function AverageDirectionalIndex() {
    var _this;
    var period = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 14;
    _classCallCheck(this, AverageDirectionalIndex);
    _this = _super.call(this);
    _this.period = period;
    _this.requiredPoints = period;
    _this.requiredSeries = ['high', 'low', 'close'];
    _this.displayName = window.getMessage('chart.indicator.legend.adx');
    _this.legend = "".concat(window.getMessage('chart.indicator.legend.adx'), " (").concat(period, ")");
    _this.extraConfig = {
      valueSuffix: '%'
    };
    return _this;
  }
  _createClass(AverageDirectionalIndex, [{
    key: "calculate",
    value: function calculate(timestamp, high, low, close) {
      return {
        timestamp: timestamp,
        close: (0, _averageDirectionalIndex.default)(high, low, close, _constants.MovingAverage.Wilders, this.period, this.period).map(function (x) {
          return x * 100;
        })
      };
    }
  }]);
  return AverageDirectionalIndex;
}(_ChartIndicator2.default);

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37,"modules/InstrumentChartModule/ChartIndicators/calculators/averageDirectionalIndex":41,"modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator":74}],79:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ChartIndicator2 = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator"));
var _averageTrueRange = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/averageTrueRange"));
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var AverageTrueRange = exports.default = /*#__PURE__*/function (_ChartIndicator) {
  _inherits(AverageTrueRange, _ChartIndicator);
  var _super = _createSuper(AverageTrueRange);
  function AverageTrueRange() {
    var _this;
    var period = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 14;
    _classCallCheck(this, AverageTrueRange);
    _this = _super.call(this);
    _this.period = period;
    _this.requiredPoints = period;
    _this.requiredSeries = ['high', 'low', 'close'];
    _this.displayName = window.getMessage('chart.indicator.legend.atr');
    _this.legend = "".concat(window.getMessage('chart.indicator.legend.atr'), " (").concat(period, ")");
    return _this;
  }
  _createClass(AverageTrueRange, [{
    key: "calculate",
    value: function calculate(timestamp, high, low, close) {
      return {
        timestamp: timestamp,
        close: (0, _averageTrueRange.default)(high, low, close, _constants.MovingAverage.Wilders, this.period)
      };
    }
  }]);
  return AverageTrueRange;
}(_ChartIndicator2.default);

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37,"modules/InstrumentChartModule/ChartIndicators/calculators/averageTrueRange":42,"modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator":74}],80:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ChartIndicator2 = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator"));
var _bollingerBands3 = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/bollingerBands"));
var _simpleMovingAverage = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/simpleMovingAverage"));
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var BollingerBands = exports.default = /*#__PURE__*/function (_ChartIndicator) {
  _inherits(BollingerBands, _ChartIndicator);
  var _super = _createSuper(BollingerBands);
  function BollingerBands() {
    var _this;
    var period = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 20;
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    _classCallCheck(this, BollingerBands);
    _this = _super.call(this);
    _this.period = period;
    _this.distance = distance;
    _this.requiredPoints = period;
    _this.requiredSeries = ['high', 'low', 'close'];
    _this.displayName = "".concat(window.getMessage('chart.indicator.bollingerbands'), " (").concat(period, "/").concat(distance, ")");
    _this.legend = "".concat(window.getMessage('chart.indicator.legend.bollingerbands'), " (").concat(period, ", ").concat(distance, ")");
    _this.color = '#888888';
    return _this;
  }

  // eslint-disable-next-line class-methods-use-this
  _createClass(BollingerBands, [{
    key: "getType",
    value: function getType(i) {
      return i ? 'line' : 'arearange';
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "getOptions",
    value: function getOptions(i) {
      return {
        config: {
          showInLegend: !i
        }
      };
    }
  }, {
    key: "calculate",
    value: function calculate(timestamp, high, low, close) {
      var _bollingerBands = (0, _bollingerBands3.default)(high, low, close, _constants.Underlying.TypicalPrice, _constants.MovingAverage.Arithmetic, _constants.MovingDeviation.Standard, this.period, this.distance),
        _bollingerBands2 = _slicedToArray(_bollingerBands, 2),
        bbLow = _bollingerBands2[0],
        bbHigh = _bollingerBands2[1];
      return [{
        timestamp: timestamp,
        high: bbHigh,
        low: bbLow
      }, {
        timestamp: timestamp,
        close: (0, _simpleMovingAverage.default)(null, null, close, _constants.Underlying.ClosePrice, this.period)
      }];
    }
  }]);
  return BollingerBands;
}(_ChartIndicator2.default);

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37,"modules/InstrumentChartModule/ChartIndicators/calculators/bollingerBands":43,"modules/InstrumentChartModule/ChartIndicators/calculators/simpleMovingAverage":66,"modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator":74}],81:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ChartIndicator2 = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator"));
var _chaikinOscillator = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/chaikinOscillator"));
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var ChaikinOscillator = exports.default = /*#__PURE__*/function (_ChartIndicator) {
  _inherits(ChaikinOscillator, _ChartIndicator);
  var _super = _createSuper(ChaikinOscillator);
  function ChaikinOscillator() {
    var _this;
    var period1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;
    var period2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
    _classCallCheck(this, ChaikinOscillator);
    _this = _super.call(this);
    _this.period1 = period1;
    _this.period2 = period2;
    _this.requiredPoints = Math.max(period1, period2);
    _this.requiredSeries = ['open', 'high', 'low', 'close', 'volume'];
    _this.displayName = window.getMessage('chart.indicator.legend.cho');
    _this.legend = "".concat(window.getMessage('chart.indicator.legend.cho'), " (").concat(period1, ", ").concat(period2, ")");
    _this.extraConfig = {
      digits: 0,
      yLines: [{
        value: 0
      }]
    };
    return _this;
  }
  _createClass(ChaikinOscillator, [{
    key: "calculate",
    value: function calculate(timestamp, open, high, low, close, volume) {
      return {
        timestamp: timestamp,
        close: (0, _chaikinOscillator.default)(open, high, low, close, volume, _constants.Coefficient.ClosePrices, _constants.MovingAverage.Exponential, this.period1, this.period2)
      };
    }
  }]);
  return ChaikinOscillator;
}(_ChartIndicator2.default);

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37,"modules/InstrumentChartModule/ChartIndicators/calculators/chaikinOscillator":45,"modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator":74}],82:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ChartIndicator2 = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator"));
var _commodityChannelIndex = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/commodityChannelIndex"));
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var sortedUnique = function sortedUnique(array) {
  return _toConsumableArray(new Set(array)).sort(function (a, b) {
    return a - b;
  });
};
var CommodityChannelIndex = exports.default = /*#__PURE__*/function (_ChartIndicator) {
  _inherits(CommodityChannelIndex, _ChartIndicator);
  var _super = _createSuper(CommodityChannelIndex);
  function CommodityChannelIndex() {
    var _this;
    var period = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 20;
    var factor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.015;
    var sell = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
    var buy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : -100;
    _classCallCheck(this, CommodityChannelIndex);
    _this = _super.call(this);
    _this.period = period;
    _this.factor = factor;
    _this.requiredPoints = period;
    _this.requiredSeries = ['high', 'low', 'close'];
    _this.displayName = window.getMessage('chart.indicator.legend.cci');
    _this.legend = "".concat(window.getMessage('chart.indicator.legend.cci'), " (").concat(period, ", ").concat(factor, ")");
    _this.extraConfig = {
      getTicks: function getTicks() {
        return sortedUnique([-200, -100, 0, 100, 200, buy, sell]);
      },
      yLines: [{
        value: buy,
        color: 'up'
      }, {
        value: sell,
        color: 'down'
      }]
    };
    return _this;
  }
  _createClass(CommodityChannelIndex, [{
    key: "calculate",
    value: function calculate(timestamp, high, low, close) {
      return {
        timestamp: timestamp,
        close: (0, _commodityChannelIndex.default)(high, low, close, _constants.MovingAverage.Arithmetic, _constants.MovingDeviation.Standard, this.period, this.factor)
      };
    }
  }]);
  return CommodityChannelIndex;
}(_ChartIndicator2.default);

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37,"modules/InstrumentChartModule/ChartIndicators/calculators/commodityChannelIndex":46,"modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator":74}],83:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ChartIndicator2 = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator"));
var _directionalMovementIndex = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/directionalMovementIndex"));
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var DirectionalMovementIndex = exports.default = /*#__PURE__*/function (_ChartIndicator) {
  _inherits(DirectionalMovementIndex, _ChartIndicator);
  var _super = _createSuper(DirectionalMovementIndex);
  function DirectionalMovementIndex() {
    var _this;
    var period = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 14;
    _classCallCheck(this, DirectionalMovementIndex);
    _this = _super.call(this);
    _this.period = period;
    _this.requiredPoints = period;
    _this.requiredSeries = ['high', 'low', 'close'];
    _this.legend = "".concat(window.getMessage('chart.indicator.legend.dmi'), " (").concat(period, ")");
    return _this;
  }

  // eslint-disable-next-line class-methods-use-this
  _createClass(DirectionalMovementIndex, [{
    key: "getDisplayName",
    value: function getDisplayName(i) {
      return [window.getMessage('chart.indicator.legend.dmi'), '+DIP', '-DIP'][i];
    }
  }, {
    key: "calculate",
    value: function calculate(timestamp, high, low, close) {
      return (0, _directionalMovementIndex.default)(high, low, close, _constants.MovingAverage.Wilders, this.period).map(function (close) {
        return {
          timestamp: timestamp,
          close: close
        };
      });
    }
  }]);
  return DirectionalMovementIndex;
}(_ChartIndicator2.default);

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37,"modules/InstrumentChartModule/ChartIndicators/calculators/directionalMovementIndex":47,"modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator":74}],84:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ChartIndicator2 = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator"));
var _envelopes3 = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/envelopes"));
var _simpleMovingAverage = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/simpleMovingAverage"));
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var Envelopes = exports.default = /*#__PURE__*/function (_ChartIndicator) {
  _inherits(Envelopes, _ChartIndicator);
  var _super = _createSuper(Envelopes);
  function Envelopes() {
    var _this;
    var period = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 20;
    var distanceUp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var distanceDown = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 6;
    _classCallCheck(this, Envelopes);
    _this = _super.call(this);
    _this.period = period;
    _this.distanceUp = distanceUp / 100;
    _this.distanceDown = distanceDown / 100;
    _this.requiredPoints = period;
    _this.displayName = "".concat(window.getMessage('chart.indicator.envelopes'), " (").concat(period, "/").concat(distanceUp, "%/").concat(distanceDown, "%)");
    _this.legend = "".concat(window.getMessage('chart.indicator.legend.envelopes'), " (").concat(period, ", ").concat(distanceUp, "%, ").concat(distanceDown, "%)");
    _this.color = 'neutral';
    return _this;
  }

  // eslint-disable-next-line class-methods-use-this
  _createClass(Envelopes, [{
    key: "getType",
    value: function getType(i) {
      return i ? 'line' : 'arearange';
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "getOptions",
    value: function getOptions(i) {
      return {
        config: {
          showInLegend: !i
        }
      };
    }
  }, {
    key: "calculate",
    value: function calculate(timestamp, close) {
      var _envelopes = (0, _envelopes3.default)(null, null, close, _constants.Underlying.ClosePrice, _constants.MovingAverage.Arithmetic, this.period, this.distanceUp, this.distanceDown),
        _envelopes2 = _slicedToArray(_envelopes, 2),
        low = _envelopes2[0],
        high = _envelopes2[1];
      return [{
        timestamp: timestamp,
        high: high,
        low: low
      }, {
        timestamp: timestamp,
        close: (0, _simpleMovingAverage.default)(null, null, close, _constants.Underlying.ClosePrice, this.period)
      }];
    }
  }]);
  return Envelopes;
}(_ChartIndicator2.default);

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37,"modules/InstrumentChartModule/ChartIndicators/calculators/envelopes":48,"modules/InstrumentChartModule/ChartIndicators/calculators/simpleMovingAverage":66,"modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator":74}],85:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ChartIndicator2 = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator"));
var _exponentialMovingAverage = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/exponentialMovingAverage"));
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var ExponentialMovingAverage = exports.default = /*#__PURE__*/function (_ChartIndicator) {
  _inherits(ExponentialMovingAverage, _ChartIndicator);
  var _super = _createSuper(ExponentialMovingAverage);
  function ExponentialMovingAverage() {
    var _this;
    var period = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 30;
    _classCallCheck(this, ExponentialMovingAverage);
    _this = _super.call(this);
    _this.period = period;
    _this.requiredPoints = period;
    _this.displayName = "EMA ".concat(period);
    _this.legend = _this.displayName;
    return _this;
  }
  _createClass(ExponentialMovingAverage, [{
    key: "calculate",
    value: function calculate(timestamp, close) {
      return {
        timestamp: timestamp,
        close: (0, _exponentialMovingAverage.default)(null, null, close, _constants.Underlying.ClosePrice, this.period)
      };
    }
  }]);
  return ExponentialMovingAverage;
}(_ChartIndicator2.default);

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37,"modules/InstrumentChartModule/ChartIndicators/calculators/exponentialMovingAverage":49,"modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator":74}],86:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ChartIndicator2 = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator"));
var _fastStochastics = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/fastStochastics"));
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var sortedUnique = function sortedUnique(array) {
  return _toConsumableArray(new Set(array)).sort(function (a, b) {
    return a - b;
  });
};
var FastStochastics = exports.default = /*#__PURE__*/function (_ChartIndicator) {
  _inherits(FastStochastics, _ChartIndicator);
  var _super = _createSuper(FastStochastics);
  function FastStochastics() {
    var _this;
    var period1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 14;
    var period2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
    var sell = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20;
    var buy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 80;
    _classCallCheck(this, FastStochastics);
    _this = _super.call(this);
    _this.period1 = period1;
    _this.period2 = period2;
    _this.requiredPoints = Math.max(period1, period2);
    _this.requiredSeries = ['high', 'low', 'close'];
    _this.legend = "".concat(window.getMessage('chart.indicator.legend.stof'), " (").concat(period1, ", ").concat(period2, ")");
    _this.extraConfig = {
      valueSuffix: '%',
      getTicks: function getTicks() {
        return sortedUnique([0, 20, 40, 60, 80, 100, buy, sell]);
      },
      yLines: [{
        value: buy,
        color: 'up'
      }, {
        value: sell,
        color: 'down'
      }]
    };
    return _this;
  }

  // eslint-disable-next-line class-methods-use-this
  _createClass(FastStochastics, [{
    key: "getDisplayName",
    value: function getDisplayName(i) {
      return "".concat(window.getMessage('chart.indicator.legend.stof'), " %K<sup>").concat(i ? 's' : 'f', "</sup>");
    }
  }, {
    key: "calculate",
    value: function calculate(timestamp, high, low, close) {
      return (0, _fastStochastics.default)(high, low, close, _constants.Underlying.TypicalPrice, _constants.MovingAverage.Exponential, this.period1, this.period2).map(function (series) {
        return {
          timestamp: timestamp,
          close: series.map(function (x) {
            return x * 100;
          })
        };
      });
    }
  }]);
  return FastStochastics;
}(_ChartIndicator2.default);

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37,"modules/InstrumentChartModule/ChartIndicators/calculators/fastStochastics":50,"modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator":74}],87:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ChartIndicator2 = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator"));
var _historicalVolatility = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/historicalVolatility"));
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var HistoricalVolatility = exports.default = /*#__PURE__*/function (_ChartIndicator) {
  _inherits(HistoricalVolatility, _ChartIndicator);
  var _super = _createSuper(HistoricalVolatility);
  function HistoricalVolatility() {
    var _this;
    var period1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
    var period2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
    var period3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;
    _classCallCheck(this, HistoricalVolatility);
    _this = _super.call(this);
    _this.period1 = period1;
    _this.period2 = period2;
    _this.period3 = period3;
    _this.requiredPoints = Math.max(period1, period2, period3);
    _this.requiredSeries = ['high', 'low', 'close'];
    _this.legend = "".concat(window.getMessage('chart.indicator.legend.hv'), " (").concat(period1, ", ").concat(period2, ")");
    _this.extraConfig = {
      valueSuffix: '%'
    };
    return _this;
  }

  // eslint-disable-next-line class-methods-use-this
  _createClass(HistoricalVolatility, [{
    key: "getDisplayName",
    value: function getDisplayName(i) {
      return "".concat(window.getMessage('chart.indicator.legend.hv'), " ").concat(i + 1);
    }
  }, {
    key: "calculate",
    value: function calculate(timestamp, high, low, close) {
      return (0, _historicalVolatility.default)(high, low, close, _constants.Underlying.TypicalPrice, this.period1, this.period2, this.period3).map(function (series) {
        return {
          timestamp: timestamp,
          close: series.map(function (x) {
            return x * 1000;
          })
        };
      });
    }
  }]);
  return HistoricalVolatility;
}(_ChartIndicator2.default);

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37,"modules/InstrumentChartModule/ChartIndicators/calculators/historicalVolatility":51,"modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator":74}],88:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _envelopes = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/envelopes"));
var _bollingerBands = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/bollingerBands"));
var _simpleMovingAverage = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/simpleMovingAverage"));
var _exponentialMovingAverage = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/exponentialMovingAverage"));
var _parabolicSAR = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/parabolicSAR"));
var _zigZag = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/zigZag"));
var _accumulationDistributionLine = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/accumulationDistributionLine"));
var _aroon = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/aroon"));
var _aroonUpDown = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/aroonUpDown"));
var _averageDirectionalIndex = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/averageDirectionalIndex"));
var _averageTrueRange = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/averageTrueRange"));
var _chaikinOscillator = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/chaikinOscillator"));
var _commodityChannelIndex = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/commodityChannelIndex"));
var _directionalMovementIndex = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/directionalMovementIndex"));
var _fastStochastics = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/fastStochastics"));
var _historicalVolatility = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/historicalVolatility"));
var _momentum = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/momentum"));
var _moneyFlowIndex = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/moneyFlowIndex"));
var _movingAverageConvergenceDivergence = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/movingAverageConvergenceDivergence"));
var _onBalanceVolume = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/onBalanceVolume"));
var _rateOfChange = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/rateOfChange"));
var _relativeStrengthIndex = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/relativeStrengthIndex"));
var _slowStochastics = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/slowStochastics"));
var _ultimateOscillator = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/ultimateOscillator"));
var _volume = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/volume"));
var _williamsPercentR = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/williamsPercentR"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// In Chart Indicators:

// Extra Graph Indicators

var indicators = {
  // In Chart Indicators
  envelopes: _envelopes.default,
  bollingerbands: _bollingerBands.default,
  sma: _simpleMovingAverage.default,
  ema: _exponentialMovingAverage.default,
  sarparabolic: _parabolicSAR.default,
  zigzag: _zigZag.default,
  // Extra Graph Indicators
  adl: _accumulationDistributionLine.default,
  ar: _aroon.default,
  arud: _aroonUpDown.default,
  adx: _averageDirectionalIndex.default,
  atr: _averageTrueRange.default,
  cho: _chaikinOscillator.default,
  cci: _commodityChannelIndex.default,
  dmi: _directionalMovementIndex.default,
  stof: _fastStochastics.default,
  hv: _historicalVolatility.default,
  mom: _momentum.default,
  mfi: _moneyFlowIndex.default,
  macd: _movingAverageConvergenceDivergence.default,
  obv: _onBalanceVolume.default,
  roc: _rateOfChange.default,
  rsi: _relativeStrengthIndex.default,
  stos: _slowStochastics.default,
  uo: _ultimateOscillator.default,
  volume: _volume.default,
  will: _williamsPercentR.default
};
var getIndicator = function getIndicator(indicatorId) {
  if (indicators[indicatorId]) {
    return indicators[indicatorId];
  }
  throw new Error("indicator ".concat(indicatorId, " not found"));
};
var _default = exports.default = getIndicator;

},{"modules/InstrumentChartModule/ChartIndicators/indicators/accumulationDistributionLine":75,"modules/InstrumentChartModule/ChartIndicators/indicators/aroon":76,"modules/InstrumentChartModule/ChartIndicators/indicators/aroonUpDown":77,"modules/InstrumentChartModule/ChartIndicators/indicators/averageDirectionalIndex":78,"modules/InstrumentChartModule/ChartIndicators/indicators/averageTrueRange":79,"modules/InstrumentChartModule/ChartIndicators/indicators/bollingerBands":80,"modules/InstrumentChartModule/ChartIndicators/indicators/chaikinOscillator":81,"modules/InstrumentChartModule/ChartIndicators/indicators/commodityChannelIndex":82,"modules/InstrumentChartModule/ChartIndicators/indicators/directionalMovementIndex":83,"modules/InstrumentChartModule/ChartIndicators/indicators/envelopes":84,"modules/InstrumentChartModule/ChartIndicators/indicators/exponentialMovingAverage":85,"modules/InstrumentChartModule/ChartIndicators/indicators/fastStochastics":86,"modules/InstrumentChartModule/ChartIndicators/indicators/historicalVolatility":87,"modules/InstrumentChartModule/ChartIndicators/indicators/momentum":89,"modules/InstrumentChartModule/ChartIndicators/indicators/moneyFlowIndex":90,"modules/InstrumentChartModule/ChartIndicators/indicators/movingAverageConvergenceDivergence":91,"modules/InstrumentChartModule/ChartIndicators/indicators/onBalanceVolume":92,"modules/InstrumentChartModule/ChartIndicators/indicators/parabolicSAR":93,"modules/InstrumentChartModule/ChartIndicators/indicators/rateOfChange":94,"modules/InstrumentChartModule/ChartIndicators/indicators/relativeStrengthIndex":95,"modules/InstrumentChartModule/ChartIndicators/indicators/simpleMovingAverage":96,"modules/InstrumentChartModule/ChartIndicators/indicators/slowStochastics":97,"modules/InstrumentChartModule/ChartIndicators/indicators/ultimateOscillator":98,"modules/InstrumentChartModule/ChartIndicators/indicators/volume":99,"modules/InstrumentChartModule/ChartIndicators/indicators/williamsPercentR":100,"modules/InstrumentChartModule/ChartIndicators/indicators/zigZag":101}],89:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ChartIndicator2 = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator"));
var _momentum = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/momentum"));
var _simpleMovingAverage = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/simpleMovingAverage"));
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var Momentum = exports.default = /*#__PURE__*/function (_ChartIndicator) {
  _inherits(Momentum, _ChartIndicator);
  var _super = _createSuper(Momentum);
  function Momentum() {
    var _this;
    var period = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 28;
    _classCallCheck(this, Momentum);
    _this = _super.call(this);
    _this.period = period;
    _this.requiredPoints = period;
    _this.requiredSeries = ['high', 'low', 'close'];
    _this.legend = "".concat(window.getMessage('chart.indicator.legend.mom'), " (").concat(period, ")");
    _this.extraConfig = {
      yLines: [{
        value: 0
      }]
    };
    return _this;
  }

  // eslint-disable-next-line class-methods-use-this
  _createClass(Momentum, [{
    key: "getDisplayName",
    value: function getDisplayName(i) {
      return [window.getMessage('chart.indicator.legend.mom'), window.getMessage('chart.indicator.legend.amom')][i];
    }
  }, {
    key: "calculate",
    value: function calculate(timestamp, high, low, close) {
      var mom = (0, _momentum.default)(high, low, close, _constants.Underlying.ClosePrice, this.period);
      return [{
        timestamp: timestamp,
        close: mom
      }, {
        timestamp: timestamp,
        close: (0, _simpleMovingAverage.default)(null, null, mom, _constants.Underlying.ClosePrice, this.period)
      }];
    }
  }]);
  return Momentum;
}(_ChartIndicator2.default);

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37,"modules/InstrumentChartModule/ChartIndicators/calculators/momentum":53,"modules/InstrumentChartModule/ChartIndicators/calculators/simpleMovingAverage":66,"modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator":74}],90:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ChartIndicator2 = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator"));
var _moneyFlowIndex = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/moneyFlowIndex"));
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var sortedUnique = function sortedUnique(array) {
  return _toConsumableArray(new Set(array)).sort(function (a, b) {
    return a - b;
  });
};
var MoneyFlowIndex = exports.default = /*#__PURE__*/function (_ChartIndicator) {
  _inherits(MoneyFlowIndex, _ChartIndicator);
  var _super = _createSuper(MoneyFlowIndex);
  function MoneyFlowIndex() {
    var _this;
    var period = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 14;
    var sell = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
    var buy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 80;
    _classCallCheck(this, MoneyFlowIndex);
    _this = _super.call(this);
    _this.period = period;
    _this.requiredPoints = period;
    _this.requiredSeries = ['high', 'low', 'close', 'volume'];
    _this.displayName = window.getMessage('chart.indicator.legend.mfi');
    _this.legend = "".concat(window.getMessage('chart.indicator.legend.mfi'), " (").concat(period, ")");
    _this.extraConfig = {
      valueSuffix: '%',
      getTicks: function getTicks() {
        return sortedUnique([0, 20, 40, 60, 80, 100, buy, sell]);
      },
      yLines: [{
        value: buy,
        color: 'up'
      }, {
        value: sell,
        color: 'down'
      }]
    };
    return _this;
  }
  _createClass(MoneyFlowIndex, [{
    key: "calculate",
    value: function calculate(timestamp, high, low, close, volume) {
      return {
        timestamp: timestamp,
        close: (0, _moneyFlowIndex.default)(high, low, close, volume, _constants.Underlying.TypicalPrice, _constants.MovingAverage.Arithmetic, this.period).map(function (x) {
          return x * 100;
        })
      };
    }
  }]);
  return MoneyFlowIndex;
}(_ChartIndicator2.default);

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37,"modules/InstrumentChartModule/ChartIndicators/calculators/moneyFlowIndex":54,"modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator":74}],91:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ChartIndicator2 = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator"));
var _movingAverageConvergenceDivergence = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/movingAverageConvergenceDivergence"));
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var MovingAverageConvergenceDivergence = exports.default = /*#__PURE__*/function (_ChartIndicator) {
  _inherits(MovingAverageConvergenceDivergence, _ChartIndicator);
  var _super = _createSuper(MovingAverageConvergenceDivergence);
  function MovingAverageConvergenceDivergence() {
    var _this;
    var period1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 12;
    var period2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 26;
    var period3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 9;
    _classCallCheck(this, MovingAverageConvergenceDivergence);
    _this = _super.call(this);
    _this.period1 = period1;
    _this.period2 = period2;
    _this.period3 = period3;
    _this.requiredPoints = Math.max(period1, period2, period3);
    _this.requiredSeries = ['high', 'low', 'close'];
    _this.legend = "".concat(window.getMessage('chart.indicator.legend.macd'), " (").concat(period1, ", ").concat(period2, ", ").concat(period3, ")");
    return _this;
  }

  // eslint-disable-next-line class-methods-use-this
  _createClass(MovingAverageConvergenceDivergence, [{
    key: "getType",
    value: function getType(i) {
      return !i ? 'column' : null;
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "getColor",
    value: function getColor(i) {
      return !i ? 'histogram' : null;
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "getDisplayName",
    value: function getDisplayName(i) {
      return [window.getMessage('chart.indicator.legend.macd.d'), window.getMessage('chart.indicator.legend.macd'), window.getMessage('chart.indicator.legend.macd.t')][i];
    }
  }, {
    key: "calculate",
    value: function calculate(timestamp, high, low, close) {
      var _movingAverageConverg = (0, _movingAverageConvergenceDivergence.default)(high, low, close, _constants.Underlying.TypicalPrice, _constants.MovingAverage.Exponential, this.period1, this.period2, this.period3).map(function (close) {
          return {
            timestamp: timestamp,
            close: close
          };
        }),
        _movingAverageConverg2 = _slicedToArray(_movingAverageConverg, 3),
        macd = _movingAverageConverg2[0],
        t = _movingAverageConverg2[1],
        c = _movingAverageConverg2[2];
      return [c, macd, t];
    }
  }]);
  return MovingAverageConvergenceDivergence;
}(_ChartIndicator2.default);

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37,"modules/InstrumentChartModule/ChartIndicators/calculators/movingAverageConvergenceDivergence":56,"modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator":74}],92:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ChartIndicator2 = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator"));
var _onBalanceVolume = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/onBalanceVolume"));
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var OnBalanceVolume = exports.default = /*#__PURE__*/function (_ChartIndicator) {
  _inherits(OnBalanceVolume, _ChartIndicator);
  var _super = _createSuper(OnBalanceVolume);
  function OnBalanceVolume() {
    var _this;
    var period = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 38;
    _classCallCheck(this, OnBalanceVolume);
    _this = _super.call(this);
    _this.period = period;
    _this.requiredPoints = period;
    _this.requiredSeries = ['high', 'low', 'close', 'volume'];
    _this.legend = "".concat(window.getMessage('chart.indicator.legend.obv'), " (").concat(period, ")");
    _this.extraConfig = {
      digits: 0
    };
    return _this;
  }

  // eslint-disable-next-line class-methods-use-this
  _createClass(OnBalanceVolume, [{
    key: "getDisplayName",
    value: function getDisplayName(i) {
      return [window.getMessage('chart.indicator.legend.obv'), window.getMessage('chart.indicator.legend.aobv')][i];
    }
  }, {
    key: "calculate",
    value: function calculate(timestamp, high, low, close, volume) {
      return (0, _onBalanceVolume.default)(high, low, close, volume, _constants.Underlying.ClosePrice, _constants.MovingAverage.Arithmetic, this.period).map(function (close) {
        return {
          timestamp: timestamp,
          close: close
        };
      });
    }
  }]);
  return OnBalanceVolume;
}(_ChartIndicator2.default);

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37,"modules/InstrumentChartModule/ChartIndicators/calculators/onBalanceVolume":62,"modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator":74}],93:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ChartIndicator2 = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator"));
var _parabolicSAR = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/parabolicSAR"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var ParabolicSAR = exports.default = /*#__PURE__*/function (_ChartIndicator) {
  _inherits(ParabolicSAR, _ChartIndicator);
  var _super = _createSuper(ParabolicSAR);
  function ParabolicSAR() {
    var _this;
    var acceleration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.02;
    var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.2;
    var start = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 30;
    _classCallCheck(this, ParabolicSAR);
    _this = _super.call(this);
    _this.start = start;
    _this.acceleration = acceleration;
    _this.max = max;
    _this.requiredPoints = start;
    _this.requiredSeries = ['high', 'low'];
    _this.displayName = "".concat(window.getMessage('chart.indicator.sarparabolic'), " (").concat(acceleration, "/").concat(max, ")");
    _this.legend = "".concat(window.getMessage('chart.indicator.legend.sarparabolic'), " (").concat(acceleration, ", ").concat(max, ")");
    _this.type = 'scatter';
    return _this;
  }

  // eslint-disable-next-line class-methods-use-this
  _createClass(ParabolicSAR, [{
    key: "getColor",
    value: function getColor(i) {
      return i ? 'down' : 'up';
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "getOptions",
    value: function getOptions(i) {
      return {
        config: {
          showInLegend: !i,
          marker: {
            symbol: 'square',
            radius: 2
          }
        }
      };
    }
  }, {
    key: "calculate",
    value: function calculate(timestamp, high, low) {
      var sar = (0, _parabolicSAR.default)(high, low, this.acceleration, this.acceleration, this.max);
      return sar.map(function (close) {
        return {
          timestamp: timestamp.filter(function (_, i) {
            return close[i] !== null;
          }),
          close: close.filter(function (_, i) {
            return close[i] !== null;
          })
        };
      });
    }
  }]);
  return ParabolicSAR;
}(_ChartIndicator2.default);

},{"modules/InstrumentChartModule/ChartIndicators/calculators/parabolicSAR":63,"modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator":74}],94:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ChartIndicator2 = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator"));
var _rateOfChange = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/rateOfChange"));
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var RateOfChange = exports.default = /*#__PURE__*/function (_ChartIndicator) {
  _inherits(RateOfChange, _ChartIndicator);
  var _super = _createSuper(RateOfChange);
  function RateOfChange() {
    var _this;
    var period = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 12;
    _classCallCheck(this, RateOfChange);
    _this = _super.call(this);
    _this.period = period;
    _this.requiredPoints = period;
    _this.requiredSeries = ['high', 'low', 'close'];
    _this.displayName = window.getMessage('chart.indicator.legend.roc');
    _this.legend = "".concat(window.getMessage('chart.indicator.legend.roc'), " (").concat(period, ")");
    _this.extraConfig = {
      digits: 4,
      valueSuffix: '%',
      yLines: [{
        value: 0
      }]
    };
    return _this;
  }
  _createClass(RateOfChange, [{
    key: "calculate",
    value: function calculate(timestamp, high, low, close) {
      return {
        timestamp: timestamp,
        close: (0, _rateOfChange.default)(high, low, close, _constants.Underlying.ClosePrice, this.period).map(function (x) {
          return x * 100;
        })
      };
    }
  }]);
  return RateOfChange;
}(_ChartIndicator2.default);

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37,"modules/InstrumentChartModule/ChartIndicators/calculators/rateOfChange":64,"modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator":74}],95:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ChartIndicator2 = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator"));
var _relativeStrengthIndex = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/relativeStrengthIndex"));
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var sortedUnique = function sortedUnique(array) {
  return _toConsumableArray(new Set(array)).sort(function (a, b) {
    return a - b;
  });
};
var RelativeStrengthIndex = exports.default = /*#__PURE__*/function (_ChartIndicator) {
  _inherits(RelativeStrengthIndex, _ChartIndicator);
  var _super = _createSuper(RelativeStrengthIndex);
  function RelativeStrengthIndex() {
    var _this;
    var period = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 14;
    var sell = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
    var buy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 80;
    _classCallCheck(this, RelativeStrengthIndex);
    _this = _super.call(this);
    _this.period = period;
    _this.requiredPoints = period;
    _this.requiredSeries = ['high', 'low', 'close'];
    _this.displayName = window.getMessage('chart.indicator.legend.rsi');
    _this.legend = "".concat(window.getMessage('chart.indicator.legend.rsi'), " (").concat(period, ")");
    _this.extraConfig = {
      valueSuffix: '%',
      getTicks: function getTicks() {
        return sortedUnique([0, 20, 40, 60, 80, 100, buy, sell]);
      },
      yLines: [{
        value: buy,
        color: 'up'
      }, {
        value: sell,
        color: 'down'
      }]
    };
    return _this;
  }
  _createClass(RelativeStrengthIndex, [{
    key: "calculate",
    value: function calculate(timestamp, high, low, close) {
      return {
        timestamp: timestamp,
        close: (0, _relativeStrengthIndex.default)(high, low, close, _constants.Underlying.ClosePrice, _constants.MovingAverage.Wilders, this.period).map(function (x) {
          return x * 100;
        })
      };
    }
  }]);
  return RelativeStrengthIndex;
}(_ChartIndicator2.default);

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37,"modules/InstrumentChartModule/ChartIndicators/calculators/relativeStrengthIndex":65,"modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator":74}],96:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ChartIndicator2 = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator"));
var _simpleMovingAverage = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/simpleMovingAverage"));
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var SimpleMovingAverage = exports.default = /*#__PURE__*/function (_ChartIndicator) {
  _inherits(SimpleMovingAverage, _ChartIndicator);
  var _super = _createSuper(SimpleMovingAverage);
  function SimpleMovingAverage() {
    var _this;
    var period = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 30;
    _classCallCheck(this, SimpleMovingAverage);
    _this = _super.call(this);
    _this.period = period;
    _this.requiredPoints = period;
    _this.displayName = "SMA ".concat(period);
    _this.legend = _this.displayName;
    return _this;
  }
  _createClass(SimpleMovingAverage, [{
    key: "calculate",
    value: function calculate(timestamp, close) {
      return {
        timestamp: timestamp,
        close: (0, _simpleMovingAverage.default)(null, null, close, _constants.Underlying.ClosePrice, this.period)
      };
    }
  }]);
  return SimpleMovingAverage;
}(_ChartIndicator2.default);

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37,"modules/InstrumentChartModule/ChartIndicators/calculators/simpleMovingAverage":66,"modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator":74}],97:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ChartIndicator2 = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator"));
var _slowStochastics = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/slowStochastics"));
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var sortedUnique = function sortedUnique(array) {
  return _toConsumableArray(new Set(array)).sort(function (a, b) {
    return a - b;
  });
};
var SlowStochastics = exports.default = /*#__PURE__*/function (_ChartIndicator) {
  _inherits(SlowStochastics, _ChartIndicator);
  var _super = _createSuper(SlowStochastics);
  function SlowStochastics() {
    var _this;
    var period1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 14;
    var period2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
    var period3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
    var sell = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 20;
    var buy = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 80;
    _classCallCheck(this, SlowStochastics);
    _this = _super.call(this);
    _this.period1 = period1;
    _this.period2 = period2;
    _this.period3 = period3;
    _this.requiredPoints = Math.max(period1, period2, period3);
    _this.requiredSeries = ['high', 'low', 'close'];
    _this.legend = "".concat(window.getMessage('chart.indicator.legend.stos'), " (").concat(period1, ", ").concat(period2, ", ").concat(period3, ")");
    _this.extraConfig = {
      valueSuffix: '%',
      getTicks: function getTicks() {
        return sortedUnique([0, 20, 40, 60, 80, 100, buy, sell]);
      },
      yLines: [{
        value: buy,
        color: 'up'
      }, {
        value: sell,
        color: 'down'
      }]
    };
    return _this;
  }

  // eslint-disable-next-line class-methods-use-this
  _createClass(SlowStochastics, [{
    key: "getDisplayName",
    value: function getDisplayName(i) {
      return "".concat(window.getMessage('chart.indicator.legend.stos'), " %D<sup>").concat(i ? 's' : 'f', "</sup>");
    }
  }, {
    key: "calculate",
    value: function calculate(timestamp, high, low, close) {
      return (0, _slowStochastics.default)(high, low, close, _constants.Underlying.TypicalPrice, _constants.MovingAverage.Wilders, this.period1, this.period2, this.period3).map(function (close) {
        return {
          timestamp: timestamp,
          close: close.map(function (x) {
            return x * 100;
          })
        };
      });
    }
  }]);
  return SlowStochastics;
}(_ChartIndicator2.default);

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37,"modules/InstrumentChartModule/ChartIndicators/calculators/slowStochastics":67,"modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator":74}],98:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ChartIndicator2 = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator"));
var _ultimateOscillator = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/ultimateOscillator"));
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var UltimateOscillator = exports.default = /*#__PURE__*/function (_ChartIndicator) {
  _inherits(UltimateOscillator, _ChartIndicator);
  var _super = _createSuper(UltimateOscillator);
  function UltimateOscillator() {
    var _this;
    var period1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 7;
    var period2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 14;
    var period3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 28;
    _classCallCheck(this, UltimateOscillator);
    _this = _super.call(this);
    _this.period1 = period1;
    _this.period2 = period2;
    _this.period3 = period3;
    _this.requiredPoints = Math.max(period1, period2, period3);
    _this.requiredSeries = ['high', 'low', 'close'];
    _this.displayName = window.getMessage('chart.indicator.legend.uo');
    _this.legend = "".concat(window.getMessage('chart.indicator.legend.uo'), " (").concat(period1, ", ").concat(period2, ", ").concat(period3, ")");
    _this.extraConfig = {
      valueSuffix: '%',
      getTicks: function getTicks() {
        return [0, 20, 40, 60, 80, 100];
      }
    };
    return _this;
  }
  _createClass(UltimateOscillator, [{
    key: "calculate",
    value: function calculate(timestamp, high, low, close) {
      return {
        timestamp: timestamp,
        close: (0, _ultimateOscillator.default)(high, low, close, _constants.MovingAverage.Arithmetic, this.period1, this.period2, this.period3).map(function (x) {
          return x * 100;
        })
      };
    }
  }]);
  return UltimateOscillator;
}(_ChartIndicator2.default);

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37,"modules/InstrumentChartModule/ChartIndicators/calculators/ultimateOscillator":70,"modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator":74}],99:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ChartIndicator2 = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var Volume = exports.default = /*#__PURE__*/function (_ChartIndicator) {
  _inherits(Volume, _ChartIndicator);
  var _super = _createSuper(Volume);
  function Volume() {
    var _this;
    _classCallCheck(this, Volume);
    _this = _super.call(this);
    _this.requiredSeries = ['volume', 'open', 'close'];
    _this.displayName = window.getMessage('chart.indicator.volume');
    _this.legend = _this.displayName;
    _this.type = 'column';
    _this.color = 'histogram'; // default color, will be overwritten by individual datapoints
    _this.extraConfig = {
      digits: 0
    };
    return _this;
  }

  // eslint-disable-next-line class-methods-use-this
  _createClass(Volume, [{
    key: "calculate",
    value: function calculate(timestamp, volume, open, close) {
      return {
        timestamp: timestamp,
        close: volume,
        color: close.map(function (c, i) {
          var o = open[i];
          var compare = Math.abs(o - c) < Number.EPSILON ? close[i - 1] : o;
          return compare > c ? 'down' : 'up';
        })
      };
    }
  }]);
  return Volume;
}(_ChartIndicator2.default);

},{"modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator":74}],100:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ChartIndicator2 = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator"));
var _williamsPercentR = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/williamsPercentR"));
var _constants = require("modules/InstrumentChartModule/ChartIndicators/calculators/_constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var sortedUnique = function sortedUnique(array) {
  return _toConsumableArray(new Set(array)).sort(function (a, b) {
    return a - b;
  });
};
var WilliamsPercentR = exports.default = /*#__PURE__*/function (_ChartIndicator) {
  _inherits(WilliamsPercentR, _ChartIndicator);
  var _super = _createSuper(WilliamsPercentR);
  function WilliamsPercentR() {
    var _this;
    var period = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 14;
    var sell = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -20;
    var buy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -80;
    _classCallCheck(this, WilliamsPercentR);
    _this = _super.call(this);
    _this.period = period;
    _this.requiredPoints = period;
    _this.requiredSeries = ['high', 'low', 'close'];
    _this.displayName = window.getMessage('chart.indicator.legend.will');
    _this.legend = "".concat(window.getMessage('chart.indicator.legend.will'), " (").concat(period, ")");
    _this.extraConfig = {
      valueSuffix: '%',
      getTicks: function getTicks() {
        return sortedUnique([-100, -80, -60, -40, -20, 0, buy, sell]);
      },
      yLines: [{
        value: buy,
        color: 'up'
      }, {
        value: sell,
        color: 'down'
      }]
    };
    return _this;
  }
  _createClass(WilliamsPercentR, [{
    key: "calculate",
    value: function calculate(timestamp, high, low, close) {
      return {
        timestamp: timestamp,
        close: (0, _williamsPercentR.default)(high, low, close, _constants.Underlying.ClosePrice, this.period).map(function (x) {
          return x * 100;
        })
      };
    }
  }]);
  return WilliamsPercentR;
}(_ChartIndicator2.default);

},{"modules/InstrumentChartModule/ChartIndicators/calculators/_constants":37,"modules/InstrumentChartModule/ChartIndicators/calculators/williamsPercentR":72,"modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator":74}],101:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ChartIndicator2 = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator"));
var _zigZag = _interopRequireDefault(require("modules/InstrumentChartModule/ChartIndicators/calculators/zigZag"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var ZigZag = exports.default = /*#__PURE__*/function (_ChartIndicator) {
  _inherits(ZigZag, _ChartIndicator);
  var _super = _createSuper(ZigZag);
  function ZigZag() {
    var _this;
    var delta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
    var useFirstExtreme = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    _classCallCheck(this, ZigZag);
    _this = _super.call(this);
    _this.delta = delta / 100;
    _this.useFirstExtreme = useFirstExtreme;
    _this.requiredSeries = ['high', 'low'];
    _this.displayName = "".concat(window.getMessage('chart.indicator.zigzag'), " (").concat(delta, "%)");
    _this.legend = "".concat(window.getMessage('chart.indicator.legend.zigzag'), " (").concat(delta, "%)");
    _this.color = 'marker';
    return _this;
  }

  // eslint-disable-next-line class-methods-use-this
  _createClass(ZigZag, [{
    key: "getLineStyle",
    value: function getLineStyle() {
      return 'Solid';
    }
  }, {
    key: "calculate",
    value: function calculate(timestamp, high, low) {
      var zz = (0, _zigZag.default)(high, low, this.delta, this.useFirstExtreme);
      var zzFilter = function zzFilter(_, i) {
        return zz[i] != null;
      };
      return {
        timestamp: timestamp.filter(zzFilter),
        close: zz.filter(zzFilter)
      };
    }
  }]);
  return ZigZag;
}(_ChartIndicator2.default);

},{"modules/InstrumentChartModule/ChartIndicators/calculators/zigZag":73,"modules/InstrumentChartModule/ChartIndicators/indicators/ChartIndicator":74}],102:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CHARTSCALE = void 0;
var _mergeObjects = _interopRequireDefault(require("util/functions/mergeObjects"));
var _colorToRgba = _interopRequireDefault(require("util/functions/colorToRgba"));
var PERIOD = _interopRequireWildcard(require("constants/time"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; } /**
                                                                                                                                                                                     * @module modules/InstrumentChartModule/SingleChart
                                                                                                                                                                                     */
/**
 * available Chart Scales
 * @enum
 */
var CHARTSCALE = exports.CHARTSCALE = {
  /** absolute chart scale */
  ABSOLUTE: 0,
  /** percentage based chart scale */
  RELATIVE: 1,
  /** logarithmic chart scale */
  LOGARITHMIC: 2
};

/**
 * Chart Object for individual charts that will be rendered into the module
 * @class
 * @param {HTMLElement} node
 * @param {Object[]} chartData
 * @param {Object} config regular HighStocks configuration; 2 special properties, `gapSize` and `gapUnit`
 *  apply to each individual series.
 * @param {string[]} ricColors elements to override the colors obtained from the theme
 */
var SingleChart = function SingleChart(node, chartData, config, ricColors) {
  this.node = node;
  this.config = config;
  this.themeConfig = config.themeConfig;
  this.chartData = chartData;
  this.ricColors = ricColors;
  this.render();
};

/**
 * @returns {this}
 */
SingleChart.prototype.render = function () {
  var chartOptions = this.getHighchartOptions();
  this.chart = window.Highcharts.StockChart(this.node, chartOptions);
  return this;
};
SingleChart.prototype.getSeriesData = function (firstPoint) {
  var _this2 = this;
  if (this.chartData.series.length === 1 && this.config.days === 1 && this.config.chartScale === CHARTSCALE.RELATIVE && this.config.previousClose) {
    return [].concat(this.chartData.series.map(function (d) {
      return [{
        timestamp: firstPoint - 2,
        close: _this2.config.previousClose,
        hidden: true
      }].concat(d.data);
    }));
  } else if (this.chartData.series.length > 1 || this.config.forceComparison) {
    return [].concat(this.chartData.series.map(function (d) {
      return (d.type === 'flags' ? [] : [{
        timestamp: firstPoint - 2,
        close: d.baselineValue || (!d.data.length ? null : d.data[0].close),
        hidden: true
      }, {
        timestamp: firstPoint - 1
      }]).concat(d.data);
    }));
  } else {
    return [].concat(this.chartData.series.map(function (d) {
      return d.data;
    }));
  }
};

/**
 * @returns {Object} highchartOptions
 */
SingleChart.prototype.getHighchartOptions = function () {
  var _this3 = this;
  var _this = this;
  var disabled = {
    enabled: false
  };
  var dataMetaInfo = getDataMetaInfo(this.chartData.series, this.config.dataType);
  var digits = this.config.digits != null ? this.config.digits : dataMetaInfo.digits;
  var axisDigits = this.config.chartScale === CHARTSCALE.RELATIVE ? 2 : Math.min(digits, "".concat(1 / (dataMetaInfo.max - dataMetaInfo.min) * 100).split('.')[0].length - 1);
  var firstPoint = Math.min.apply(Math, _toConsumableArray(this.chartData.series.filter(function (f) {
    return f.type !== 'flags';
  }).map(function (d) {
    return d.data.length ? d.data[0].timestamp : Infinity;
  })));
  var timeOffset = this.config.days > 30 ? 0 : window.YAHOO.fcom.Format.localized.timeZone;
  var data = this.getSeriesData(firstPoint);

  // check interval and if its an intraday chart fill empty space for streaming
  if (this.config.isStreaming) {
    data = createDataPlaceholders(data, this.config.dayEndTime, +this.config.interval);
  } else {
    // create one placeholder for padding
    var interval = {
      D: PERIOD.ONE_DAY / 1000 / 60,
      W: PERIOD.ONE_WEEK / 1000 / 60,
      Q: PERIOD.ONE_QUARTER / 1000 / 60,
      Y: PERIOD.ONE_YEAR / 1000 / 60
    }[this.config.interval] || +this.config.interval;
    if (data.length > 10) {
      data = createDataPlaceholders(data, data[0][data[0].length - 1].timestamp + interval * 60 * 1000, interval);
    }
  }
  var axisFormatterValues = function axisFormatterValues() {
    if (this.axis.tickInterval >= 1e5) {
      // interval should be bigger than 0.1 million
      var valueSuffix = this.axis.tickInterval >= 1e8 ? window.YAHOO.fcom.Format.localized.gigaString : window.YAHOO.fcom.Format.localized.megaString;
      var value = Math.floor(this.axis.tickInterval >= 1e8 ? this.value / 1e8 : this.value / 1e5) / 10;
      var _digits = this.axis.tickInterval >= 1e9 || this.axis.tickInterval >= 1e6 && this.axis.tickInterval < 1e8 ? 0 : 1;
      return "".concat(window.Highcharts.numberFormat(value, _digits), " ").concat(valueSuffix, " ").concat(_this.config.valueSuffix || '');
    }
    return "".concat(window.Highcharts.numberFormat(this.value, axisDigits)).concat(_this.config.valueSuffix || '');
  };
  var axisFormatterPercentage = function axisFormatterPercentage() {
    var value = window.Highcharts.numberFormat(this.value, axisDigits);
    var prefix = this.value >= 0 ? '+' : '';
    return "".concat(prefix + value, "%");
  };
  var pointFormatterValues = function pointFormatterValues(point) {
    var ohlc = ['open', 'high', 'low', 'close'];
    var label = (point.series.tooltipName || point.name || point.series.name) + (point.currency ? ' (' + point.currency + ')' : '');
    var isIndicator = point.series.userOptions.isIndicator;
    if (!isIndicator && _this.config.isComplex && ohlc.map(function (a) {
      return point.hasOwnProperty(a);
    }).every(function (b) {
      return !!b;
    }) === true) {
      return ohlc.map(function (a) {
        return simplePointFormat(point.color || point.series.color, window.getMessage("chart.value.".concat(a)), window.Highcharts.numberFormat(point[a], digits));
      }).join('');
    } else {
      if (_this.config.isChainChart) {
        var currencyLabel = point.currency ? " - ".concat(point.currency) : '';
        label = "".concat(point.series.name, " (").concat(_this.config.yAxisLabelName).concat(currencyLabel, ")");
      }
      return simplePointFormat(point.color || point.series.color, label, window.Highcharts.numberFormat(point.y, digits));
    }
  };
  var pointFormatterPercentage = function pointFormatterPercentage(point) {
    var ohlc = ['open', 'high', 'low', 'close'];
    var isIndicator = point.series.userOptions.isIndicator;
    if (!isIndicator && _this.config.isComplex && ohlc.map(function (a) {
      return point.hasOwnProperty(a);
    }).every(function (b) {
      return !!b;
    }) === true) {
      return ohlc.map(function (a) {
        return simplePointFormat(point.color || point.series.color, window.getMessage("chart.value.".concat(a)), window.Highcharts.numberFormat(point[a], digits));
      }).join('');
    } else {
      var label = generateTooltipLabel(point);
      if (isIndicator) {
        // percentage values not needed for indicators
        return simplePointFormat(point.color || point.series.color, label, window.Highcharts.numberFormat(point.y, digits));
      } else {
        return simplePointFormat(point.color || point.series.color, label, window.Highcharts.numberFormat(point.y, digits), " (".concat(point.change >= 0 ? '+' : '').concat(window.Highcharts.numberFormat(point.change, 2), "%)"));
      }
    }
  };

  /**
   * Method to extract high and low points from the area range series
   * @param {*} points The points array from the highchart tooltip formatter function.
   * @param {*} areaRangePoints Filtered array which only contains the points from the area range series
   * @returns {Array} Array containing the extracted points
   */
  var extractPointsFromAreaRangeSeries = function extractPointsFromAreaRangeSeries(points, areaRangePoints) {
    areaRangePoints.forEach(function (item) {
      var high = extractPoint(item, item.point.high);
      var low = extractPoint(item, item.point.low);
      var index = points.findIndex(function (p) {
        return p.point.id === item.point.id;
      });
      // To oder the tooltip values as high, mid, low
      points.splice(index, 2, low, points[index + 1], high);
    });
    return points;
  };
  var generateTooltipLabel = function generateTooltipLabel(point) {
    var seriesName = point.series.tooltipName || point.name || point.series.name;
    var seriesCurrency = point.currency || '';
    var nameWithCurrencyPattern = new RegExp(".*?(".concat(seriesCurrency, ")"), 'g');
    var appendCurrencyToName = seriesCurrency.length == 3 && !nameWithCurrencyPattern.test(seriesName);
    return appendCurrencyToName ? "".concat(seriesName, " (").concat(seriesCurrency, ")") : seriesName;
  };
  /**
   * Method to crate new point from an existing point
   */
  var extractPoint = function extractPoint(item, value) {
    var newPoint = _objectSpread({}, item.point);
    newPoint.y = value;
    item.point = newPoint;
    return _objectSpread({}, item);
  };
  var dateFormatter = function dateFormatter(date) {
    return window.Highcharts.dateFormat(_this.config.datePattern || (+_this.config.interval > 0 ? window.YAHOO.fcom.Format.localized.patternChartMinute : window.YAHOO.fcom.Format.localized.patternChartDay), date);
  };
  var colors = this.themeConfig.chartColors;
  var gradient = this.themeConfig.areaGradient || [-0.2, 2];

  // X Axis date label patterns
  var dayLabel = window.getMessage('pattern.dateTime.chart.axisLabel.day');
  var weekLabel = window.getMessage('pattern.dateTime.chart.axisLabel.week');
  var monthLabel = window.getMessage('pattern.dateTime.chart.axisLabel.month');
  var yearLabel = window.getMessage('pattern.dateTime.chart.axisLabel.year');
  var defaultOptions = {
    legend: {
      align: 'left',
      verticalAlign: 'top',
      floating: true,
      padding: 3,
      backgroundColor: colors.legendBackground || 'transparent',
      itemStyle: {
        color: colors.labels,
        cursor: 'auto',
        fontWeight: 'normal',
        fontSize: '11px'
      },
      itemHoverStyle: {
        color: colors.labels
      },
      accessibility: {
        enabled: false
      },
      labelFormatter: function labelFormatter() {
        var dataCurrency = _this.getDataCurrency(this.index);
        var nameWithCurrencyPattern = new RegExp(".*?(".concat(dataCurrency, ")"));
        var chartName = this.name;
        return nameWithCurrencyPattern.test(chartName) ? chartName : "".concat(chartName, " (").concat(dataCurrency, ")");
      }
    },
    title: !this.config.multiChart || this.config.showLegend || this.chartData.series[0].titleStyle === 'none' ? null : {
      // show either legend or title, never both
      text: this.chartData.series[0].name,
      floating: this.chartData.series[0].titleStyle === 'float',
      align: 'left',
      margin: 5,
      style: {
        color: colors.labels,
        fontSize: '13px'
      }
    },
    chart: {
      // If there is no disableReflow flag present then assign true (default).
      reflow: !this.config.disableReflow,
      spacing: [10, 10, 5, 10],
      backgroundColor: colors.background
    },
    xAxis: [{
      type: 'datetime',
      gridLineDashStyle: 'ShortDot',
      gridLineColor: colors.grid,
      lineColor: colors.grid,
      tickColor: colors.grid,
      crosshair: true,
      gridLineWidth: 1.25,
      tickPixelInterval: 100,
      labels: {
        style: {
          color: colors.labels
        }
      },
      // set date label formats only for valid cases, otherwise default will be taken which is the previously existing behavior
      dateTimeLabelFormats: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, dayLabel !== '-' && {
        day: dayLabel
      }), weekLabel !== '-' && {
        week: weekLabel
      }), monthLabel !== '-' && {
        month: monthLabel
      }), yearLabel !== '-' && {
        year: yearLabel
      })
    }],
    yAxis: [{
      showLastLabel: true,
      gridLineDashStyle: 'ShortDot',
      gridLineColor: colors.grid,
      lineColor: colors.grid,
      tickColor: colors.grid,
      tickPixelInterval: 30,
      gridLineWidth: 1.25,
      labels: {
        y: 3.5,
        align: 'left',
        style: {
          color: colors.labels
        }
      }
    }],
    plotOptions: {
      flags: {
        shape: 'circlepin',
        showInLegend: false,
        color: 'white',
        width: 16,
        height: 16,
        stackDistance: 20,
        y: -32,
        useHTML: false,
        style: {
          color: 'white',
          lineHeight: '20px',
          zIndex: 0
        },
        states: {
          hover: disabled
        }
      },
      line: {
        lineWidth: 1.75,
        marker: {
          enabled: false,
          lineColor: colors.background
        }
      },
      series: {
        pointPlacement: 'on',
        animation: {
          duration: 0
        },
        fillOpacity: 0.3,
        states: {
          inactive: {
            opacity: 1
          }
        }
      },
      ohlc: {
        lineWidth: 1.75
      },
      area: {
        fillColor: {
          linearGradient: {
            x1: 0,
            x2: 0,
            y1: gradient[0],
            y2: gradient[1]
          },
          stops: [[0, colors.neutral], [1, (0, _colorToRgba.default)(colors.neutral, 0)]]
        }
      }
    },
    series: this.chartData.series.map(function (d, index) {
      var config = {
        type: getHighChartsType(d.type),
        step: getStepType(d.type),
        name: d.name
      };
      if (d.config.color) {
        if (typeof _this3.ricColors !== 'undefined') {
          config.color = _this3.ricColors[index % _this3.ricColors.length];
        } else {
          config.color = colors[d.config.color] || d.config.color;
        }
      }
      if (typeof _this3.config.gapSize !== 'undefined') {
        config.gapSize = _this3.config.gapSize;
        if (typeof _this3.config.gapUnit !== 'undefined') {
          config.gapUnit = _this3.config.gapUnit;
        }
      }
      if (!d.constantColor && getHighChartsType(d.type) === 'line') {
        var overwriteColor = _this3.getOverwriteLineColor(colors.up, colors.down);
        if (overwriteColor) {
          config.color = overwriteColor;
        }
      }
      if (!d.constantColor && getHighChartsType(d.type) === 'area' && _this3.chartData.series.length === 1 && (_this3.config.chartScale === CHARTSCALE.RELATIVE || _this3.config.days === 1 && _this3.getThreshold() !== null)) {
        config.color = colors.up;
        config.negativeColor = colors.down;
      }
      return Object.assign({}, d.config || {}, config);
    }).reduce(function (all, a) {
      return all.concat(a);
    }, [])
  };
  var forcedOptions = {
    rangeSelector: disabled,
    legend: !this.config.showLegend ? disabled : {
      enabled: true
    },
    navigator: disabled,
    scrollbar: disabled,
    credits: disabled,
    chart: {
      marginRight: this.config.multiChart ? 80 : null,
      zoomType: this.config.zoom ? 'x' : false,
      panning: this.config.zoom,
      panKey: 'shift',
      events: {
        load: function load() {
          var $isSmartChartModule = $(this.container).closest('.module-smart-chart');
          if ($isSmartChartModule.length > 0) {
            window.forceResizeEvent.fire();
          }
        }
      }
    },
    xAxis: [{
      plotLines: this.getXPlotLines(),
      events: {
        afterSetExtremes: function afterSetExtremes(event) {
          _this3.config.zoomCallback(event, _this3);
        }
      }
    }],
    yAxis: [{
      type: this.config.chartScale === CHARTSCALE.LOGARITHMIC ? 'logarithmic' : 'linear',
      allowNegativeLog: this.config.chartScale === CHARTSCALE.LOGARITHMIC,
      labels: this.yAxisLabelFormatter(axisFormatterPercentage, axisFormatterValues),
      plotLines: this.getYPlotLines(),
      tickPositioner: this.config.getTicks || function (min, max) {
        // don't try to correct a log scale
        if (_this.config.chartScale === CHARTSCALE.LOGARITHMIC) {
          if (!this.tickPositions.length) {
            throw new Error('negativeLogarithmicData');
          }
          return;
        }
        // this function will correct some yAxis label choices
        var pos = this.tickPositions.map(function (a) {
          return +a.toFixed(axisDigits);
        }).filter(function (f, i, all) {
          return all.indexOf(f) === i;
        });
        if (!_this.config.forceComparison) {
          pos = pos.filter(function (f) {
            return _this.config.chartScale === CHARTSCALE.RELATIVE || dataMetaInfo.min < 0 || f >= 0;
          }); // only display negative ticks if the lowest data point is below zero or if it is a relative chart
        }

        if (pos.length < 2) {
          if (min === 0 && max === 0) {
            return [0, 1, 2];
          }
          return min >= 0 ? [0, max, max * 2] : [min * 2, min, 0];
        }
        var dist = pos[1] - pos[0];
        var ticks = [pos[0]];
        while (dist > 0 && ticks[ticks.length - 1] < max || dist < 0 && ticks[ticks.length - 1] > max) {
          var newTick = +(ticks[ticks.length - 1] + dist).toFixed(axisDigits);
          ticks.push(Math.abs(newTick) > Number.EPSILON ? newTick : 0); // compare to Epsilon in order to prevent negative zero
        }

        return ticks;
      }
    }],
    plotOptions: {
      series: {
        dataGrouping: disabled,
        turboThreshold: Infinity,
        compare: this.config.chartScale === CHARTSCALE.RELATIVE ? 'percent' : null,
        states: {
          hover: {
            lineWidthPlus: 0
          }
        },
        events: {
          legendItemClick: function legendItemClick() {
            return false;
          }
        },
        marker: {
          states: {
            hover: {
              enabled: this.config.disableMarkers ? false : true
            }
          }
        }
      },
      candlestick: {
        color: colors.candleDown || colors.down,
        upColor: colors.candleUp || colors.up,
        lineWidth: 0.40
      },
      ohlc: {
        color: colors.candleDown || colors.down,
        upColor: colors.candleUp || colors.up
      },
      area: {
        threshold: this.getThreshold()
      }
    },
    tooltip: this.config.disableTooltips ? {
      enabled: false
    } : _objectSpread(_objectSpread({}, this.config.tooltipBackground && {
      backgroundColor: this.config.tooltipBackground
    }), {}, {
      useHTML: true,
      style: _objectSpread({
        minWidth: '300px',
        fontFamily: 'inherit'
      }, this.config.tooltipStyle),
      formatter: function formatter() {
        if (this.x === firstPoint - 2 + timeOffset) {
          return false;
        }
        if (this.points) {
          var pointFormatter = _this.config.chartScale === CHARTSCALE.RELATIVE ? pointFormatterPercentage : pointFormatterValues;
          var header = "<tr style=\"font-size: 100%;line-height:18px;\"><td colspan=\"3\">".concat(dateFormatter(this.x), "</td></tr>");
          // For series of type area range, need to show 2 tooltip values (high and low) from one point. So added some special logic to handle them.
          var areaRangePoints = this.points.filter(function (point) {
            return point.series.userOptions.isIndicator && point.series.userOptions.type === 'arearange';
          });
          var points = areaRangePoints.length > 0 ? extractPointsFromAreaRangeSeries(_toConsumableArray(this.points), areaRangePoints) : this.points;
          var selectedPoints = _this.config.hasNonMatchingTimestamps ? _this.chart.getSelectedPoints() : points.map(function (pt) {
            return pt.point;
          });
          var formattedPoints = selectedPoints.filter(function (point) {
            return point.series.options.states.hover.enabled !== false;
          }) // dont show points from hover disabled series in tooltip
          .map(pointFormatter);
          return "<table>".concat(header).concat(formattedPoints.join(''), "</table>");
        } else if (this.point && this.point.event) {
          // default events
          return "\n                        <table class=\"highcharts-tooltip-event highcharts-tooltip-event-".concat(this.point.event.type, "\">\n                            <tr class=\"event-date\" style=\"font-size: 12px;line-height:18px;\"><td>").concat(dateFormatter(this.point.timestamp + timeOffset), "</td></tr>\n                            <tr class=\"event-title\" style=\"font-weight:bold;\"><td>").concat(this.point.event.title, "</td></tr>\n                            ").concat(this.point.event.description ? "<tr class=\"event-description\"><td>".concat(this.point.event.description, "</td></tr>") : '', "\n                        </table>\n                    ");
        }
      },
      outside: _this.config.tooltipOutside,
      split: false,
      shared: true,
      followPointer: _this.config.tooltipFollowPointer,
      positioner: _this.config.tooltipPositioner,
      borderColor: _this.config.tooltipBorderColor,
      borderWidth: 1
    }),
    series: data.map(function (d, i) {
      return {
        data: (d.length && d[0].title ? transformChartDataForFlags : _this.config.isComplex && !i || _this3.chartData.series[i].type === 'arearange' ? transformChartDataForOHLC : transformChartDataForLine)(d, timeOffset, 'close')
      };
    }).reduce(function (all, a) {
      return all.concat(a);
    }, [])
  };

  // overwrite area fill color for threshold based area coloring
  if (this.getThreshold() !== null) {
    forcedOptions.plotOptions.area.fillColor = null;
  }
  defaultOptions.exporting = {
    buttons: {
      contextButton: {
        enabled: false
      }
    },
    csv: {
      itemDelimiter: _this.config.csvSeparator
    }
  };

  // remove pointPlacement prop for candlestick chart
  //this.setPointPlacement(defaultOptions);

  var exportOptions = (0, _mergeObjects.default)({}, defaultOptions, this.themeConfig, forcedOptions);
  if (this.themeConfig.xAxis && this.themeConfig.xAxis[0].title && this.themeConfig.yAxis && this.themeConfig.yAxis[0].title) {
    if (this.themeConfig.xAxis[0].title.text) {
      exportOptions.xAxis[0].title.text = this.themeConfig.xAxis[0].title.text;
    }
    if (this.themeConfig.yAxis[0].title.text) {
      exportOptions.yAxis[0].title.text = this.themeConfig.yAxis[0].title.text;
    }
  }
  return exportOptions;
};

/**
 * Get yAxis logarithmic interval
 */
SingleChart.prototype.yAxisLabelFormatter = function (axisFormatterPercentage, axisFormatterValues) {
  var labels = {};
  if (this.config.chartScale === CHARTSCALE.LOGARITHMIC) {
    return labels;
  } else if (this.config.chartScale === CHARTSCALE.RELATIVE) {
    labels.formatter = axisFormatterPercentage;
  } else {
    labels.formatter = axisFormatterValues;
  }
  return labels;
};

/**
 * Set pointPlacement for the chart
 * candlestick - not requires pointPlacement prop
 */
SingleChart.prototype.setPointPlacement = function (defaultOptions) {
  var series = this.chartData.series;
  if (series && series[0] && series[0].type === 'candlestick') {
    delete defaultOptions.plotOptions.series.pointPlacement;
  }
};

/**
 * @returns {Object[]} yPlotLines
 */
SingleChart.prototype.getYPlotLines = function () {
  var _this4 = this;
  var lines = [];
  if (!this.config.isIndicator) {
    // zero line
    lines.push({
      color: this.themeConfig.chartColors.lines,
      value: 0,
      width: 1.25,
      zIndex: 1
    });
  }
  if (this.config.yLines) {
    this.config.yLines.forEach(function (line) {
      lines.push({
        dashStyle: line.style || 'ShortDash',
        color: _this4.themeConfig.chartColors[line.color] || line.color || _this4.themeConfig.chartColors.labels,
        value: line.value,
        width: 1.25,
        zIndex: 1
      });
    });
  }

  // previous close line
  if (this.config.days === 1 && this.config.previousClose && this.config.chartScale !== CHARTSCALE.RELATIVE) {
    lines.push({
      dashStyle: this.themeConfig.markerStyle || 'Solid',
      color: this.themeConfig.chartColors.marker,
      value: +this.config.previousClose,
      width: 1.25,
      zIndex: 1
    });
  }
  return lines;
};

/**
 * @returns {Object[]} xPlotlines
 */
SingleChart.prototype.getXPlotLines = function () {
  var _this5 = this;
  var _this = this;
  var filterIndicators = !this.chartData.series[0].isIndicator;
  var getTimestamps = function getTimestamps(extremeValue) {
    return _this5.chartData.series.filter(function (f) {
      return (!filterIndicators || !f.isIndicator) && f.type !== 'flags';
    }).map(function (d) {
      return d.data.length ? d.data[0].timestamp : extremeValue;
    });
  };
  var firstPoint = Math.min.apply(Math, _toConsumableArray(getTimestamps(+Infinity)));
  var dateTimes = [];
  var firstDate = new Date(firstPoint);
  var date;
  var i;
  if (this.config.days > 1 && this.config.days < 30) {
    date = new Date(firstDate.getFullYear(), firstDate.getMonth(), firstDate.getDate());
    for (i = 0; i < this.config.days; i++) {
      date.setDate(date.getDate() + 1);
      if (date.getDay() !== 1 && date.getDay() !== 6) {
        dateTimes.push({
          time: date.getTime(),
          width: date.getDay() === 0 ? 3.5 : 1.25
        });
      }
    }
  } else if (this.config.days < 300) {
    date = new Date(firstDate.getFullYear(), firstDate.getMonth(), 1);
    for (i = 0; i < Math.floor(this.config.days / 30); i++) {
      date.setMonth(date.getMonth() + 1);
      dateTimes.push({
        time: date.getTime(),
        width: 1.25
      });
    }
  } else if (this.config.days > 360) {
    date = new Date(firstDate.getFullYear(), 0, 1);
    for (i = 0; i < Math.floor(this.config.days / 365); i++) {
      date.setFullYear(date.getFullYear() + 1);
      dateTimes.push({
        time: date.getTime(),
        width: 1.25
      });
    }
  }

  // border on the right
  if (this.themeConfig.borderRight) {
    var lastPoint = Math.max.apply(null, this.chartData.series.map(function (d) {
      return d.data[d.data.length - 1].timestamp;
    }));
    dateTimes.push({
      time: lastPoint,
      width: 1.25
    });
  }
  return dateTimes.map(function (a) {
    return {
      dashStyle: a.dashStyle || 'Solid',
      color: a.color || _this.themeConfig.chartColors.lines,
      value: a.time + window.YAHOO.fcom.Format.localized.timeZone,
      width: a.width,
      zIndex: 1
    };
  });
};

/**
 * @param {string} upColor
 * @param {string} downColor
 * @returns {?string} color
 */
SingleChart.prototype.getOverwriteLineColor = function (upColor, downColor) {
  if (this.chartData.series.length > 1) {
    return null;
  }
  var open = +this.config.previousClose;
  var close = +this.chartData.series[0].data.reduce(function (last, a) {
    return a.close || last;
  }, null);
  return this.config.days !== 1 || open === close ? null : open < close ? upColor : downColor;
};

/**
 * @returns {?number}
 */
SingleChart.prototype.getThreshold = function () {
  if (this.config.chartScale === CHARTSCALE.RELATIVE) {
    return 0;
  } else {
    return this.config.days === 1 ? +this.config.previousClose || null : null;
  }
};
/**
 * Identify the currency in which chart data is delivered .
 * chart data for all charts are available in {chartData} object as an array.
 * From the chartData series get the data for the given chart index then read the
 * first available currency code in the data series
 * @param {string} chartName The chart for which data currency need to be identified.
  * @returns {?string} 3 letter ISO currency code in which chart data is delivered.
 */
SingleChart.prototype.getDataCurrency = function (index) {
  var dataConfig = this.chartData.series[index];
  var dataObj = dataConfig.data.find(function (d) {
    return d.currency && d.currency.length == 3;
  });
  return dataObj ? dataObj.currency : '';
};
var createDataPlaceholders = function createDataPlaceholders(data, dayEndTime, interval) {
  var mainData = data[0];
  while (mainData.length && mainData[mainData.length - 1].timestamp < dayEndTime) {
    mainData.push({
      timestamp: mainData[mainData.length - 1].timestamp + interval * 60 * 1000
    });
  }
  data[0] = mainData;
  return data;
};
var getStepType = function getStepType(type) {
  return type.indexOf('step') === 0 ? 'left' : false;
};
var getDataMetaInfo = function getDataMetaInfo(data, type) {
  var plainData = data.filter(function (f, i) {
    return !i || !f.isIndicator;
  }).map(function (a) {
    return a.data;
  }).reduce(function (all, a) {
    return all.concat(a);
  }, []).map(function (a) {
    return type === 'ohlc' ? [a.open, a.high, a.low, a.close] : a.close;
  }) // get all values from the object into an array
  .reduce(function (all, a) {
    if (!!a) {
      return Array.isArray(a) && a[0] === undefined ? all : all.concat(a);
    } else {
      return all;
    }
  }, []);
  var min = Math.min.apply(Math, _toConsumableArray(plainData.map(function (a) {
    return isNaN(+a) ? +Infinity : +a;
  })));
  var max = Math.max.apply(Math, _toConsumableArray(plainData.map(function (a) {
    return isNaN(+a) ? -Infinity : +a;
  })));
  var digits = Math.max.apply(Math, _toConsumableArray(plainData.slice(-Math.ceil(plainData.length / 4)) // only take the last quarter of items
  .map(function (a) {
    return ("".concat(a).split('.')[1] || '').length;
  })));
  return {
    min: min,
    max: max,
    digits: digits
  };
};
var transformChartDataForLine = function transformChartDataForLine(data, offset, key) {
  return data.map(function (a) {
    return {
      x: a.timestamp + offset,
      y: +a[key],
      name: a.name || null,
      color: a.color || null,
      currency: a.currency,
      marker: !a.hidden ? null : {
        states: {
          hover: {
            enabled: false
          }
        }
      }
    };
  });
};
var transformChartDataForOHLC = function transformChartDataForOHLC(data, offset) {
  return data.map(function (a) {
    return {
      x: a.timestamp + offset,
      name: a.name || null,
      currency: a.currency,
      open: a.open != null ? +a.open : +a.close,
      high: a.high != null ? +a.high : +a.close,
      low: a.low != null ? +a.low : +a.close,
      close: +a.close
    };
  });
};
var transformChartDataForFlags = function transformChartDataForFlags(data, offset) {
  return data.map(function (a) {
    a.x = a.timestamp + offset;
    return a;
  });
};
var getHighChartsType = function getHighChartsType(type) {
  return {
    stepline: 'line',
    steparea: 'area'
  }[type] || type;
};
var simplePointFormat = function simplePointFormat(color, label, number, suffix) {
  return '<tr>' + "<td><span style=\"color:".concat(color, "\">\u25CF</span> ").concat(label, ":</td>") + "<td style=\"text-align:right;\"><b>".concat(number, "</b></td>") + "<td style=\"text-align:right;\">".concat(suffix || '', "</td>") + '</tr>';
};
var _default = exports.default = SingleChart;

},{"constants/time":6,"util/functions/colorToRgba":140,"util/functions/mergeObjects":143}],103:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _maxMinutesPerPeriod;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/*
    Possible Values:
    1-1440 (Minutes)
    D (Days)
    W (Weeks)
    M (Months)
    Q (Quarter)
    Y (Years)
*/

var PERIODS = {
  DAYS: 'D',
  WEEKS: 'W',
  MONTHS: 'M',
  QUARTILES: 'Q',
  YEARS: 'Y'
};
var maxMinutesPerPeriod = (_maxMinutesPerPeriod = {}, _defineProperty(_maxMinutesPerPeriod, PERIODS.DAYS, 2 * 365 * 24 * 60), _defineProperty(_maxMinutesPerPeriod, PERIODS.WEEKS, 5 * 365 * 24 * 60), _defineProperty(_maxMinutesPerPeriod, PERIODS.MONTH, 10 * 365 * 24 * 60), _maxMinutesPerPeriod);
var validPeriods = [1, 5, 15, 30, 60, 180];
var validPeriodsComplex = [1, 5, 15, 30, 60];
var pixelsPerLinePoint = 0.5;
var pixelsPerOHLCPoint = 2;
var getInterval = function getInterval(days, totalWidth, isComplex, historicOnly) {
  var pointWidth = isComplex ? pixelsPerOHLCPoint : pixelsPerLinePoint;
  var totalMinutes = days * 24 * 60;
  var targetPeriod = pointWidth / totalWidth * totalMinutes;
  if (days === 1 && !isComplex) {
    // use 1 Minute period for all daily charts / 10 Minute for IE
    return window.YAHOO.fcom.Util.detectInternetExplorer(false) ? '10' : '1';
  } else if (days > 30 && targetPeriod > 30 * 24 * 60 || totalMinutes > maxMinutesPerPeriod[PERIODS.MONTHS]) {
    return PERIODS.QUARTILES;
  } else if (days > 30 && targetPeriod > 7 * 24 * 60 || totalMinutes > maxMinutesPerPeriod[PERIODS.WEEKS]) {
    return PERIODS.MONTHS;
  } else if (days > 30 && targetPeriod > 24 * 60 || totalMinutes > maxMinutesPerPeriod[PERIODS.DAYS]) {
    return PERIODS.WEEKS;
  } else if (historicOnly || days > 30) {
    return PERIODS.DAYS;
  } else if (isComplex) {
    return "".concat(validPeriodsComplex.find(function (f) {
      return f > targetPeriod;
    }) || PERIODS.DAYS);
  } else {
    return "".concat(validPeriods.find(function (f) {
      return f > targetPeriod;
    }) || 360);
  }
};
var _default = exports.default = getInterval;

},{}],104:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.joinSeries = exports.getDataTypeFromTimeSeriesDataPoint = exports.getDataArraysFromTimeSeries = exports.extractSeries = void 0;
var getDataTypeFromTimeSeriesDataPoint = exports.getDataTypeFromTimeSeriesDataPoint = function getDataTypeFromTimeSeriesDataPoint(dataPoint) {
  return !dataPoint ? 'empty' : dataPoint.bid ? 'bidask' : dataPoint.open || dataPoint.open === null ? 'ohlc' : dataPoint.yield ? 'yield' : 'close';
};
var getDataPointAsClose = function getDataPointAsClose(dp) {
  return function (d) {
    return {
      timestamp: d.timestamp,
      currency: d.currency,
      close: d[dp]
    };
  };
};
var filterForAnyValue = function filterForAnyValue(f) {
  return f.volume != null || f.open != null || f.high != null || f.low != null || f.close != null;
};
var getDataArraysFromTimeSeries = exports.getDataArraysFromTimeSeries = function getDataArraysFromTimeSeries(timeSeries) {
  var dontFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    ohlc: timeSeries.map(function (d) {
      return {
        timestamp: d.timestamp,
        open: d.open,
        high: d.high,
        low: d.low,
        close: d.close,
        currency: d.currency
      };
    }).filter(dontFilter ? function () {
      return true;
    } : filterForAnyValue),
    ohlcv: timeSeries.map(function (d) {
      return {
        timestamp: d.timestamp,
        open: d.open,
        high: d.high,
        low: d.low,
        close: d.close,
        volume: d.volume,
        currency: d.currency
      };
    }).filter(dontFilter ? function () {
      return true;
    } : filterForAnyValue),
    close: timeSeries.map(getDataPointAsClose('close')).filter(dontFilter ? function () {
      return true;
    } : filterForAnyValue),
    yield: timeSeries.map(getDataPointAsClose('yield')).filter(dontFilter ? function () {
      return true;
    } : filterForAnyValue),
    bid: timeSeries.map(getDataPointAsClose('bid')).filter(dontFilter ? function () {
      return true;
    } : filterForAnyValue),
    ask: timeSeries.map(getDataPointAsClose('ask')).filter(dontFilter ? function () {
      return true;
    } : filterForAnyValue),
    targetPrice: timeSeries.map(getDataPointAsClose('targetprice')).filter(dontFilter ? function () {
      return true;
    } : filterForAnyValue),
    flags: timeSeries.filter(function (f) {
      return f.sd && f.sd.length;
    })
  };
};
var extractSeries = exports.extractSeries = function extractSeries(data, series) {
  var init = series.reduce(function (all, s) {
    all[s] = [];
    return all;
  }, {});
  return data.reduce(function (all, d) {
    series.forEach(function (s) {
      all[s].push(+d[s]);
    });
    return all;
  }, init);
};
var joinSeries = exports.joinSeries = function joinSeries(series) {
  return Object.keys(series).reduce(function (all, key) {
    series[key].forEach(function (item, i) {
      all[i] = all[i] || {};
      all[i][key] = item;
    });
    return all;
  }, []);
};

},{}],105:[function(require,module,exports){
"use strict";

var _HeatmapContainer = _interopRequireDefault(require("modules/InstrumentListHeatmapModule/HeatmapContainer"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var YAHOO = window.YAHOO;
window.fcom.moduleHandler.registerModuleType('InstrumentListHeatmapModule', function (node, config, themeConfig) {
  config.labelName = $("#".concat(node.id, "_labelMenu option:selected")).text();
  if (!config.instrumentListId) {
    config.instrumentListId = YAHOO.util.Dom.get("".concat(node.id, "_instrumentList")).value;
  }
  var moduleInstance = new _HeatmapContainer.default(node, config, themeConfig);
  moduleInstance.loadData();
  moduleInstance['@destroy'] = function () {
    return null;
  };
  var settingsClicked = function settingsClicked(listChanged) {
    var config = moduleInstance.getConfig();
    var instrumentListId = getInstrumentListId();
    var label = YAHOO.util.Dom.get("".concat(moduleInstance.moduleId, "_labelMenu")).value;
    var size = YAHOO.util.Dom.get("".concat(moduleInstance.moduleId, "_sizeMenu")).value;
    var sort = YAHOO.util.Dom.get("".concat(moduleInstance.moduleId, "_sortMenu")).value;
    var sortDirection = YAHOO.util.Dom.get("".concat(moduleInstance.moduleId, "_sortDirectionMenu")).value;
    var switchList = listChanged || !Array.isArray(config.instrumentListId);
    if (switchList) {
      config.instrumentListId = instrumentListId;
    }
    config.size = size;
    config.label = label;
    config.labelName = $("#".concat(moduleInstance.moduleId, "_labelMenu option:selected")).text();
    moduleInstance.setConfig(config);
    if (config.savePageSettings) {
      window.savePageSettings("".concat(moduleInstance.moduleId, "_settings"), {
        label: label,
        sortDirection: sortDirection,
        size: size,
        sort: sort,
        instrumentListId: instrumentListId
      }, true, null);
    }
    sortFunction();
    if (!switchList) {
      moduleInstance.loadData();
    }
  };
  var sortFunction = function sortFunction() {
    var sortBy = [YAHOO.util.Dom.get("".concat(moduleInstance.moduleId, "_sortMenu")).value, YAHOO.util.Dom.get("".concat(moduleInstance.moduleId, "_sortDirectionMenu")).value];
    moduleInstance.sortElements(sortBy);
    var config = moduleInstance.getConfig();
    var instrumentListId = getInstrumentListId();
    var label = YAHOO.util.Dom.get("".concat(moduleInstance.moduleId, "_labelMenu")).value;
    var size = YAHOO.util.Dom.get("".concat(moduleInstance.moduleId, "_sizeMenu")).value;
    var sort = YAHOO.util.Dom.get("".concat(moduleInstance.moduleId, "_sortMenu")).value;
    var sortDirection = YAHOO.util.Dom.get("".concat(moduleInstance.moduleId, "_sortDirectionMenu")).value;
    if (config.savePageSettings) {
      window.savePageSettings("".concat(moduleInstance.moduleId, "_settings"), {
        label: label,
        sortDirection: sortDirection,
        size: size,
        sort: sort,
        instrumentListId: instrumentListId
      }, true, null);
    }
  };
  window.setTimeout(function () {
    YAHOO.fcom.Page.getInstance("".concat(moduleInstance.moduleId, "_sizeMenu")).changeEvent.subscribe(function () {
      return settingsClicked(false);
    });
    YAHOO.fcom.Page.getInstance("".concat(moduleInstance.moduleId, "_sortMenu")).changeEvent.subscribe(sortFunction);
    YAHOO.fcom.Page.getInstance("".concat(moduleInstance.moduleId, "_sortDirectionMenu")).changeEvent.subscribe(sortFunction);
    YAHOO.fcom.Page.getInstance("".concat(moduleInstance.moduleId, "_labelMenu")).changeEvent.subscribe(function () {
      return settingsClicked(false);
    });
    if (YAHOO.fcom.Page.getInstance("".concat(moduleInstance.moduleId, "_instrumentList"))) {
      YAHOO.fcom.Page.getInstance("".concat(moduleInstance.moduleId, "_instrumentList")).changeEvent.subscribe(function () {
        return settingsClicked(true);
      });
    }
  }, 50);
  window.addEventListener('resize', function () {
    moduleInstance['@resize']();
  });

  // refresh the data when the current list has been changed
  if (!moduleInstance['@broadcast']) {
    moduleInstance['@broadcast'] = {};
  }
  moduleInstance['@broadcast']['@watchlists,@portfolios'] = function (message) {
    if (['portfolioChanged', 'watchlistChanged'].indexOf(message.messageType) === -1) {
      return;
    }
    var listID = "".concat(message.messageType[0], "_").concat(message.id);
    YAHOO.fcom.Page.getInstance("".concat(moduleInstance.moduleId, "_instrumentList")).selectByValue(listID);
    moduleInstance.setConfig(Object.assign(moduleInstance.getConfig(), {
      instrumentListId: listID
    }));
    moduleInstance.loadData();
  };
  if (config.receiverChannel) {
    moduleInstance['@broadcast'][config.receiverChannel] = function (message) {
      return onMessage(message);
    };
  }
  var onMessage = function onMessage(message) {
    if (message.senderId !== node.id) {
      if (message.messageType === 'ric') {
        moduleInstance.setRic([message.ric]);
      } else if (message.messageType === 'multiRic') {
        if (message.rics.length > 0) {
          var ricList = message.rics;
          moduleInstance.setConfig(Object.assign(moduleInstance.getConfig(), {
            instrumentListId: ricList
          }));
        } else {
          moduleInstance.setRic(YAHOO.util.Dom.get("".concat(moduleInstance.moduleId, "_instrumentList")).value);
        }
      }
    }
  };
  var getInstrumentListId = function getInstrumentListId() {
    var config = moduleInstance.getConfig();
    if (config.showInstrumentList || config.showInstrumentList === undefined) {
      return YAHOO.util.Dom.get("".concat(moduleInstance.moduleId, "_instrumentList")).value;
    } else {
      return config.instrumentListId;
    }
  };
  return moduleInstance;
});

},{"modules/InstrumentListHeatmapModule/HeatmapContainer":106}],106:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _D3Heatmap = _interopRequireDefault(require("modules/DynamicHeatmapModule/D3Heatmap"));
var _HeatmapContainer = _interopRequireDefault(require("../DynamicHeatmapModule/HeatmapContainer.inc"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var InstrumentListHeatmapModule = function InstrumentListHeatmapModule(containerNode, config, themeConfig) {
  if (!config) {
    return;
  }
  this.config = config;
  this.moduleId = containerNode.id;
  this.containerId = "".concat(this.moduleId, "_container");
  this.$container = $("#".concat(this.containerId));
  this.$error = $("#".concat(this.moduleId, "_error"));
  this.senderChannel = $(containerNode).data('module-senderchannel') || null;

  // Create a new HeatMap in the container
  config.colorRangeRel = themeConfig.colorRangeRel;
  config.colorRangeAbs = themeConfig.colorRangeAbs;
  config.colorRangeVola = themeConfig.colorRangeVola;
  config.colorRangeFund = themeConfig.colorRangeFund;
  this.chart = new _D3Heatmap.default(window.Dom.get(this.containerId), config);
};
InstrumentListHeatmapModule.prototype.loadData = function () {
  var _this = this;
  this.lastInstrumentListId = this.config.instrumentListId;
  return window.ajaxGetJson('/constituents.action', this.getParams()).then(function (data) {
    var rootData = {};
    rootData.name = data.indexName || _this.config.instrumentListId;
    if (!Object.keys(data.memberValues).length) {
      // should show error for empty lists
      var errorText = window.getMessage('module.InstrumentListHeatmapModule.error.noItems');
      _this.$error.html("<div class=\"hint\">".concat(errorText, "</div>")).css('display', 'block');
      _this.$container.css('display', 'none');
    } else {
      _this.$error.css('display', 'none');
      _this.$container.css('display', 'block');
    }
    rootData.ric = data.indexRic;
    rootData.children = Object.keys(data.memberValues).map(function (ric) {
      var ricData = data.memberFields.reduce(function (all, field, index) {
        all[field.id] = {
          value: data.memberValues[ric][index],
          label: data.memberDisplay[ric][index]
        };
        return all;
      }, {});
      return {
        ric: ric,
        name: ricData.NAME_SHORT.label,
        data: ricData
      };
    });
    var fields = data.memberFields.reduce(function (all, field) {
      var id = field.id;
      delete field.id;
      all[id] = field;
      return all;
    }, {});
    _this.chart.setFields(fields);
    _this.chart.setData(rootData);
    return rootData.name;
  }).then(function (title) {
    // update title
    if (!_this.config.hasFixedTitle) {
      $("#".concat(_this.moduleId, " .moduleHeader .title .content")).html(title);
    }
    // add broadcast links
    if (_this.senderChannel) {
      window.YAHOO.fcom.Broadcaster.initBroadcastLinks(_this.senderChannel, _this.moduleId);
    }
  });
};
InstrumentListHeatmapModule.prototype.getParams = function () {
  var parameters = {
    filter: this.config.filterForEquities
  };
  if (Array.isArray(this.config.instrumentListId)) {
    parameters.method = 'getHeatmapDataWithRicList';
    parameters.ricList = this.config.instrumentListId;
    parameters.name = 'Linkmode';
    parameters.id = 'Linkmode';
  } else if (this.config.instrumentListId.substr(0, 1) === 'w') {
    parameters.method = 'getHeatmapDataWithWatchlistId';
    parameters.watchlistId = this.config.instrumentListId.substr(2);
  } else {
    parameters.method = 'getHeatmapDataWithPortfolioId';
    parameters.portfolioId = this.config.instrumentListId.substr(2);
  }
  return parameters;
};
InstrumentListHeatmapModule.prototype.getConfig = function () {
  return this.chart.config;
};
InstrumentListHeatmapModule.prototype.setConfig = function (config) {
  this.chart.setConfig(config);
  this.config = config;
  if (this.lastInstrumentListId !== this.config.instrumentListId) {
    // load new data
    this.loadData();
  }
};
InstrumentListHeatmapModule.prototype.setRic = function (ric) {
  if (this.config.instrumentListId !== ric) {
    // only update ric if necessary
    this.config.instrumentListId = ric;
    this.loadData();
  }
};
InstrumentListHeatmapModule.prototype.sortElements = function (sortBy) {
  if (this.chart.setSorting(sortBy)) {
    this.chart.renderChart();
  }
};
InstrumentListHeatmapModule.prototype['@resize'] = function () {
  this.chart.resize(true);
};
var _default = exports.default = InstrumentListHeatmapModule;

},{"../DynamicHeatmapModule/HeatmapContainer.inc":20,"modules/DynamicHeatmapModule/D3Heatmap":19}],107:[function(require,module,exports){
"use strict";

var _DynamicScatterPlot = _interopRequireDefault(require("modules/DynamicScatterPlotModule/DynamicScatterPlot"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
window.fcom.moduleHandler.registerModuleType('InstrumentListScatterPlotModule', function (node, config, themeConfig) {
  var moduleInstance = new _DynamicScatterPlot.default(node, config, themeConfig);
  moduleInstance.loadData(true);
  var settingsClicked = function settingsClicked(resetZoom, refreshData) {
    var xAxis = $("#".concat(node.id, "_xAxisMenu")).val();
    var yAxis = $("#".concat(node.id, "_yAxisMenu")).val();
    var size = $("#".concat(node.id, "_sizeMenu")).val();
    var color = $("#".concat(node.id, "_colorMenu")).val();
    var instrumentListId = getInstrumentListId();
    var instrumentListIdPlain = instrumentListId.substring(2);
    var portfolioId;
    var watchlistId;
    var ric;
    if (instrumentListId.substring(0, 2) === 'w_') {
      watchlistId = instrumentListIdPlain;
      portfolioId = '';
      ric = '';
    } else {
      watchlistId = '';
      portfolioId = instrumentListIdPlain;
      ric = '';
    }
    var config = Object.assign({}, moduleInstance.getConfig(), {
      xAxis: xAxis,
      yAxis: yAxis,
      size: size,
      color: color,
      watchlistId: watchlistId,
      portfolioId: portfolioId,
      ric: ric
    });
    moduleInstance.setConfig(config);
    if (refreshData) {
      moduleInstance.loadData(resetZoom);
    } else {
      moduleInstance.updateSettings(resetZoom);
    }
  };
  window.setTimeout(function () {
    $("#".concat(node.id, "_xAxisMenu")).change(function () {
      return settingsClicked(true);
    });
    $("#".concat(node.id, "_yAxisMenu")).change(function () {
      return settingsClicked(true);
    });
    $("#".concat(node.id, "_sizeMenu")).change(function () {
      return settingsClicked(false);
    });
    $("#".concat(node.id, "_colorMenu")).change(function () {
      return settingsClicked(false);
    });
    $("#".concat(node.id, "_instrumentList")).change(function () {
      return settingsClicked(true, true);
    });
  }, 50);
  window.addEventListener('resize', function () {
    moduleInstance['@resize']();
  });
  var getInstrumentListId = function getInstrumentListId() {
    var jsConfig = moduleInstance.getConfig();
    if (jsConfig.showInstrumentList || jsConfig.showInstrumentList === undefined) {
      return $("#".concat(node.id, "_instrumentList")).val();
    } else {
      return jsConfig.instrumentListId;
    }
  };
  return moduleInstance;
}, true);

},{"modules/DynamicScatterPlotModule/DynamicScatterPlot":23}],108:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var InternalJspModule = function InternalJspModule(node, config) {
  var targetId = "".concat(node.id, "_wrapper");
  this['@destroy'] = function () {
    return null;
  };
  if (config.receiverChannel) {
    this['@broadcast'] = _defineProperty({}, config.receiverChannel, function (message) {
      return onMessage(message);
    });
  }
  var isSupportedMessageType = function isSupportedMessageType(message) {
    var types = ['ric', 'multiRic', 'country', 'multiCountry']; // ric currently handled as string diectly
    return Boolean(message) && types.indexOf(message.messageType) > -1;
  };
  var onMessage = function onMessage(message) {
    if (message.senderId !== node.id) {
      var viewId = window.YAHOO.fcom.Page.getInstance('moduleContainer').id;
      if (message.messageType === 'ric') {
        window.reloadModuleContent(node.id, viewId, targetId, message.ric);
      } else if (message.messageType === 'multiRic') {
        window.reloadModuleContent(node.id, viewId, targetId, message.rics.join());
      } else if (isSupportedMessageType(message)) {
        window.reloadModuleContent(node.id, viewId, targetId, message);
      }
    }
  };
};
window.fcom.moduleHandler.registerModuleType('InternalJspModule', function (node, config) {
  return new InternalJspModule(node, config);
}, true);

},{}],109:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _incrementalSearch = _interopRequireDefault(require("search/incrementalSearch"));
var _ajaxRequest = require("core/Ajax/ajaxRequest");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var InternalSearchModule = exports.default = /*#__PURE__*/function () {
  function InternalSearchModule(node, config, themeConfig) {
    _classCallCheck(this, InternalSearchModule);
    config.theme = themeConfig;
    this.config = config;
    this.viewId = window.YAHOO.fcom.Page.getInstance('moduleContainer').id;
    this.moduleId = config.moduleId;
    this.targetId = "".concat(node.id, "_wrapper");
    this.persist = config.persistInstrument;
    this.titleName = window.getMessage('module.library.moduleType.InternalSearchModule');
    this.initIncrementalSearch(node);
    if (config.senderChannel) {
      window.YAHOO.fcom.Broadcaster.initBroadcastLinks(config.senderChannel, $(node).id);
      if (config.ric && this.persist) {
        setTimeout(function () {
          window.YAHOO.fcom.Broadcaster.sendMessage(config.senderChannel, {
            messageType: 'ric',
            senderId: node.id,
            ric: config.ric
          });
        }, 150);
      }
    }
  }
  _createClass(InternalSearchModule, [{
    key: "initIncrementalSearch",
    value: function initIncrementalSearch(node) {
      var _this = this;
      var $input = $(node).find('input.incrementalSearchInput');
      var searchConfig = Object.assign({
        searchBoxId: 'internalIncrementalSearchResults',
        inPage: true,
        searchRicCallback: function searchRicCallback(_ref) {
          var ric = _ref.ric,
            name = _ref.name;
          if (ric) {
            window.logInstrumentUse(ric, name);
            if (_this.persist) {
              _this.persistInstrument(name, ric, node);
            } else {
              _this.reloadAndBroadcast(name, ric, node);
            }
          }
        }
      }, this.getDefaultSearchConfig());
      (0, _incrementalSearch.default)($input.get(), searchConfig);
    }
  }, {
    key: "persistInstrument",
    value: function persistInstrument(name, ric, node) {
      var postData = {
        method: 'changeModule',
        viewId: this.viewId,
        moduleId: this.moduleId,
        ric: ric
      };
      window.ngpAsyncRequest('POST', '/module.action', this.reloadAndBroadcast(name, ric, node), postData, null, false, false);
    }
  }, {
    key: "reloadAndBroadcast",
    value: function reloadAndBroadcast(name, ric, node) {
      var _this2 = this;
      if (this.config.senderChannel) {
        window.YAHOO.fcom.Broadcaster.sendMessage(this.config.senderChannel, {
          messageType: 'ric',
          senderId: node.id,
          ric: ric
        });
        window.reloadModuleContent(this.moduleId, this.viewId, this.targetId, ric, name).then(function () {
          _this2.initIncrementalSearch(node);
          if (_this2.persist) {
            _this2.setTitle(node, ric);
          }
        });
      } else {
        window.detail("ric=".concat(encodeURIComponent(ric)));
      }
    }
  }, {
    key: "setTitle",
    value: function setTitle(node, ric) {
      var _this3 = this;
      (0, _ajaxRequest.ajaxPostJson)('/ajax.action?method=getInstrumentName', {
        ric: ric
      }).then(function (result) {
        $(node).find('.moduleHeader .title .content').html("".concat(_this3.titleName, " - ").concat(result.short));
      });
    }
  }, {
    key: "getDefaultSearchConfig",
    value: function getDefaultSearchConfig() {
      return {
        searchType: 'instruments',
        searchRic: true,
        disableInstantSearch: false,
        l3Columns: []
      };
    }
  }]);
  return InternalSearchModule;
}();
window.fcom.moduleHandler.registerModuleType('InternalSearchModule', function (node, config, themeConfig) {
  return new InternalSearchModule(node, config, themeConfig);
}, true);

},{"core/Ajax/ajaxRequest":7,"search/incrementalSearch":134}],110:[function(require,module,exports){
"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var YAHOO = window.YAHOO;
var LineChartModule = function LineChartModule(params, datasource) {
  this.params = params;
  this.moduleId = params.moduleId;
  this.moduleContainer = YAHOO.util.Dom.get(this.moduleId);
  LineChartModule.superclass.constructor.call(this, this.moduleId, this.params.chartConfig, datasource);
  this.init();
};
YAHOO.extend(LineChartModule, window.fcom.highstock.LineChart, {
  init: function init() {
    var _this = this;
    this.initPeriodSelection();
    this.initResize();
    $(this.moduleContainer).bind('mouseout touchend', function () {
      if (!_this.chart) {
        // do nothing - chart is not initialized yet
        return;
      }
      _this.chart.tooltip.hide();
      _this.chart.xAxis.forEach(function (axis) {
        return axis.hideCrosshair();
      });
      _this.chart.series.forEach(function (series) {
        series.points.forEach(function (point) {
          point.select(false);
        });
      });
    });
  },
  initResize: function initResize() {
    this.width = YAHOO.util.Dom.getRegion(this.moduleContainer).width;
    window.onElementResize.subscribe(function (event, _ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        theModule = _ref2[0];
      if (theModule.id === this.moduleId) {
        var width = YAHOO.util.Dom.getRegion(this.moduleContainer).width;
        if (width !== this.width) {
          this.resize();
          this.width = width;
        }
      }
    }, this, true);
  },
  initPeriodSelection: function initPeriodSelection() {
    this.periodSelector = YAHOO.fcom.Page.getInstance("".concat(this.moduleId, "_periodSelector"));
    this.periodIndex = this.params.pageSettings.period;
    if (this.periodIndex != null) {
      this.periodSelector.setSelectedItem(this.periodIndex);
    }
    this.periodSelector.tabChangeEvent.subscribe(this.setExtremes, this, true);
    this.extremesChanged.subscribe(function (type, args) {
      if (args[0].trigger === 'navigator') {
        var item = this.periodSelector.getSelectedItem();
        if (item) {
          this.periodSelector.deselectItem(item);
        }
      }
    }, this, true);
  },
  render: function render() {
    LineChartModule.superclass.render.call(this);
    this.setExtremes();
  },
  setExtremes: function setExtremes() {
    var item = this.periodSelector.getSelectedItem();
    if (item != null) {
      this.periodIndex = item.index;
      if (item.data.period === 'maxY') {
        this.setMaxInterval();
      } else {
        var periodValue = +item.data.days;
        var max = typeof this.getInterval().max !== 'undefined' ? Math.min(this.getMaxInterval().max, this.getInterval().max) : this.getMaxInterval().max;
        var start = new window.fcom.date.DateTime().setTimestamp(max);
        start.addCalendar({
          day: -periodValue
        });
        this.setInterval(start.getTimestamp(), max);
      }
    }
  },
  modifySeries: function modifySeries(index, series, params) {
    series = LineChartModule.superclass.modifySeries.call(this, index, series, params);
    series.valueFormatter = YAHOO.fcom.Util.createDelegate(this.formatValue, this);
    return series;
  },
  formatTooltip: function formatTooltip() {
    var series = this.points[0].series;
    var rendered = {};
    var text = series.chart.tooltip.tooltipFooterHeaderFormatter(this.points[0]);
    this.points.forEach(function (point) {
      if (!rendered[point.series.name]) {
        text += '<tr>';
        text += "<td style=\"color:".concat(point.series.color, ";\">").concat(point.series.name, "</td>");
        text += "<td style=\"text-align: right; padding-left: 5px;\">".concat(series.options.valueFormatter(point, series), "</td>");
        text += '</tr>';
        rendered[point.series.name] = true;
      }
    });
    return "<table>".concat(text, "</table>");
  },
  formatValue: function formatValue(item) {
    var value = item.y;
    if (item.series.options.compare === 'percent' || item.series.options.compare === 'growth') {
      value = "".concat(Highcharts.numberFormat(item.point.change, 2), " %");
    } else {
      value = Highcharts.numberFormat(value, 2);
      item.series.options.tooltip && item.series.options.tooltip.ySuffix && (value += item.series.options.tooltip.ySuffix);
    }
    return value;
  }
});

//Not registered because it will never be initialised directly, just extended
window.ngpNamespace('fcom.modules');
window.fcom.modules.LineChartModule = LineChartModule;

},{}],111:[function(require,module,exports){
"use strict";

var ListOfChainsModule = function ListOfChainsModule(node, config) {
  this['@destroy'] = function () {
    return null;
  };
  var containerId = "".concat(config.moduleId).concat(config.sizeId);
  var dropdownNodeId = "".concat(config.viewId, "_").concat(containerId, "_chain");
  window.YAHOO.fcom.Page.onInstanceReady(dropdownNodeId, function () {
    initDropdownChangeHandler(node, config);
  });
};
window.fcom.moduleHandler.registerModuleType('ListOfChainsModule', function (node, config) {
  return new ListOfChainsModule(node, config);
}, true);

// this is triggered on dropdown selection
var updateListOfChainsModule = function updateListOfChainsModule(node, config) {
  var maximized = config.sizeId === '_max';
  var containerId = "".concat(config.moduleId).concat(config.sizeId);
  var dropdownNodeId = "".concat(config.viewId, "_").concat(containerId, "_chain");
  var chainlistSelectDropDown = window.YAHOO.fcom.Page.getInstance(dropdownNodeId);
  var combinedId = "".concat(config.viewId, "_").concat(config.moduleId);
  var pageSettingsKey = "".concat(combinedId, "_settings");
  var $jqBox = $("#".concat(dropdownNodeId, " :selected"), node);
  var newChain = $jqBox.val();
  var newTitle = $jqBox.text();
  if (!chainlistSelectDropDown || chainlistSelectDropDown.getIsDisabled()) {
    // select was already unregistered or disabled?
    return; // do not send another ajax until the result of the last one arrives, that will also provide a new copy of the dropdown
  }

  chainlistSelectDropDown.disable(); // disable and unregister, as ajax that will also provide a new copy of the dropdown
  window.YAHOO.fcom.Page.unregister(dropdownNodeId);
  var $title = $('.title .content', node);
  $title.html(newTitle);
  window.showWait(true);
  window.savePageSettings(pageSettingsKey, {
    selectedChain: newChain
  }, true, function () {
    if (!maximized) {
      window.reloadModuleContent(combinedId, window.YAHOO.fcom.viewInfo.name, "".concat(combinedId).concat(config.sizeId), {
        chainRic: newChain
      }).then(function () {
        window.YAHOO.fcom.Page.onInstanceReady(dropdownNodeId, function () {
          initDropdownChangeHandler(node, config);
        });
      });
    } else {
      window.YAHOO.fcom.Broadcaster.sendMessage("".concat(combinedId, "_refreshMaxView"));
    }
    window.showWait(false);
  });
};
var initDropdownChangeHandler = function initDropdownChangeHandler(node, config) {
  var containerId = "".concat(config.moduleId).concat(config.sizeId);
  var dropdownNodeId = "".concat(config.viewId, "_").concat(containerId, "_chain");
  var chainlistSelectDropDown = window.YAHOO.fcom.Page.getInstance(dropdownNodeId);
  var scopeArgs = {
    node: node,
    config: config
  };
  if (chainlistSelectDropDown) {
    chainlistSelectDropDown.changeEvent.unsubscribeAll();
    chainlistSelectDropDown.changeEvent.subscribe(function (eventType, args, scopeArgs) {
      updateListOfChainsModule(scopeArgs.node, scopeArgs.config);
    }, scopeArgs);
  }
};

},{}],112:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _longQuote = _interopRequireDefault(require("./longQuote"));
var _contextPassing = _interopRequireDefault(require("../../customized/tdwealth/contextPassing.es6"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
//used to include contextPassing js

var LongQuoteModule = function LongQuoteModule(node, config, themeConfig) {
  config.theme = themeConfig;
  var viewId = window.YAHOO.fcom.Page.getInstance('moduleContainer').id;
  var moduleId = node.id;
  var configData = $.parseJSON($("#".concat(moduleId, "_configData")).val());
  var contextPassingOptions = {
    contextPassSymbol: configData.contextPassSymbol,
    optionType: configData.optionType,
    expiryDate: configData.expiryDate,
    strikePrice: configData.strikePrice,
    instrumentType: configData.instrumentType
  };
  var longQuote = new _longQuote.default(moduleId, configData.title, contextPassingOptions, configData.exchangeName);
  if (config.receiverChannel) {
    this['@broadcast'] = _defineProperty({}, config.receiverChannel, function (message) {
      if (message.messageType === 'ric') {
        var directParameter = message.ric;
        if (message.ticker) {
          // to support ticker overriding, pass ticker if available
          directParameter = {
            ric: message.ric,
            tickerOverride: message.ticker
          };
        }
        window.reloadModuleContent(moduleId, viewId, "".concat(moduleId, "_div"), directParameter).then(function () {
          config.ric = message.ric;
          config.ticker = message.ticker;
          window.fcom.moduleHandler.initModule(node);
        });
      }
    });
  }
};
window.fcom.moduleHandler.registerModuleType('LongQuoteModule', function (node, config, themeConfig) {
  return new LongQuoteModule(node, config, themeConfig);
});
var _default = exports.default = LongQuoteModule;

},{"../../customized/tdwealth/contextPassing.es6":10,"./longQuote":113}],113:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _gaugeJS = require("gaugeJS");
var _fontawesomeSvgCore = require("@fortawesome/fontawesome-svg-core");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var iconFaChevronUp = (0, _fontawesomeSvgCore.icon)({
  prefix: 'fas',
  iconName: 'caret-up'
}, {
  classes: ['fa-2x']
});
var iconFaChevronDown = (0, _fontawesomeSvgCore.icon)({
  prefix: 'fas',
  iconName: 'caret-down'
}, {
  classes: ['fa-2x']
});
var LongQuote = exports.default = /*#__PURE__*/function () {
  function LongQuote(moduleId, title, contextPassingOptions, exchangeName) {
    var _this = this;
    _classCallCheck(this, LongQuote);
    this.contextPassingOptions = contextPassingOptions;
    this.moduleId = moduleId;
    this.moduleElement = $("#".concat(moduleId));
    this.moduleElement.find('.title').find('.content').text(title);
    this.chartContainer = null;
    this.exchangeName = exchangeName;
    this.detailOpen = window.localStorage.getItem('longQuote.open') === 'true';
    this.buttonOpenDetail = $("#".concat(this.moduleId, "_long-quote-button-toggle-detail"));
    this.buttonOpenDetail.click(this.toggleDetail.bind(this));
    this.chartModule = window.fcom.moduleHandler.initModule(document.getElementById("".concat(moduleId, "_longQuoteChartModule_detail")));
    $("#".concat(this.moduleId, "_long-quote-button-buy")).click(function () {
      return _this.sendContextPassingMessage('openBuyTicket');
    });
    $("#".concat(this.moduleId, "_long-quote-button-sell")).click(function () {
      return _this.sendContextPassingMessage('openSellTicket');
    });
    $("#".concat(this.moduleId, "_long-quote-button-add-to-watchlist")).click(function () {
      return _this.sendContextPassingMessage('addToWatchlist');
    });
    $("#".concat(this.moduleId, "_long-quote-button-set-alert")).click(function () {
      return _this.sendContextPassingMessage('openAlerts');
    });
    $("#".concat(this.moduleId, "_long-quote-button-open-instrument")).click(function () {
      return _this.sendContextPassingMessage('openInstrument');
    });
    $("#".concat(this.moduleId, "_long-quote-button-open-option-chain")).click(function () {
      return _this.sendContextPassingMessage('openOptionChain');
    });
    this.checkSymbol(contextPassingOptions.contextPassSymbol, contextPassingOptions.instrumentType);
    this.initGauge();
    this.setDetailState(this.detailOpen);
  }
  _createClass(LongQuote, [{
    key: "updateGaugefromDom",
    value: function updateGaugefromDom() {
      if ($("#".concat(this.moduleId, "_todaysVolume span")).text() !== '') {
        var avgVolume1M = $("#".concat(this.moduleId, "_avgVolume")).text();
        avgVolume1M = avgVolume1M.replace(/\s/g, '');
        var trdVolume = $("#".concat(this.moduleId, "_todaysVolume span")).text();
        if (trdVolume === '') {
          trdVolume = $("#".concat(this.moduleId, "_todaysVolume")).text();
        }
        trdVolume = trdVolume.replace(/\s/g, '');
        this.setVolumeGauge(trdVolume, avgVolume1M);
      } else {
        $("#".concat(this.moduleId, "_todaysVolume span")).html('0');
      }
    }

    /**
     * @method getGaugeStaticColors
     * @description To get the static gauge color values
     * @return {{green: (*|jQuery)}}
     */
  }, {
    key: "getGaugeStaticColors",
    value: function getGaugeStaticColors() {
      var $default = 'rgb(0, 0, 0)';
      // #. Get the green color
      var staticUpColor = $('.volume-gauge-up').css('color');
      staticUpColor = staticUpColor === $default ? '#2c792c' : staticUpColor;

      // #. Get the neutral color
      var staticNeutralColor = $('.volume-gauge-neutral').css('color');
      staticNeutralColor = staticNeutralColor === $default ? '#b3b3b3' : staticNeutralColor;

      // #. Get the down color
      var staticDownColor = $('.volume-gauge-down').css('color');
      staticDownColor = staticDownColor === $default ? '#c71818' : staticDownColor;

      // #. Return the result set
      return {
        up: staticUpColor,
        neutral: staticNeutralColor,
        down: staticDownColor
      };
    }
  }, {
    key: "initGauge",
    value: function initGauge() {
      var _this2 = this;
      var gaugeNeedleColor = $('.volume-gauge-div').css('color');
      var staticColors = this.getGaugeStaticColors();
      var opts = {
        angle: 0,
        lineWidth: 0.3,
        radiusScale: 0.7,
        pointer: {
          length: 0.45,
          strokeWidth: 0.035,
          color: gaugeNeedleColor
        },
        staticZones: [{
          strokeStyle: staticColors.up,
          min: 0,
          max: 1
        }, {
          strokeStyle: staticColors.neutral,
          min: 1,
          max: 2
        }, {
          strokeStyle: staticColors.down,
          min: 2,
          max: 3
        }],
        limitMax: true,
        limitMin: true,
        colorStart: '#6FADCF',
        colorStop: '#8FC0DA',
        strokeColor: '#E0E0E0',
        highDpiSupport: true,
        renderTicks: {
          divisions: 3,
          divWidth: 2,
          divLength: 1,
          divColor: '#ffffff',
          subDivisions: 0,
          subLength: 0.5,
          subWidth: 0.6,
          subColor: '#000000'
        }
      };
      var target = document.getElementById("".concat(this.moduleId, "_volumeGauge"));
      this.gauge = new _gaugeJS.Gauge(target).setOptions(opts);
      this.gauge.maxValue = 3;
      this.gauge.setMinValue(0);
      this.gauge.animationSpeed = 32;
      this.gauge.set(0);
      this.updateGaugefromDom();
      /* events to control movement of range meter */
      $('#todaysVolume').bind('DOMSubtreeModified', function () {
        return _this2.updateGaugefromDom();
      });
    }
  }, {
    key: "setChartWidth",
    value: function setChartWidth(width) {
      var _this3 = this;
      this.chartModule.then(function (chartContainer) {
        _this3.moduleElement.find(".chartImageBox#".concat(_this3.moduleId, "_longQuoteChart")).width(width);
        _this3.moduleElement.find(".chartImageBox#".concat(_this3.moduleId, "_longQuoteChart>div")).width(width);
        _this3.moduleElement.find(".chartImageBox#".concat(_this3.moduleId, "_longQuoteChart>div>div")).width(width);
        _this3.moduleElement.find('.mini-chart').find('.moduleContent').width(width);
        chartContainer.getChartConfiguration().themeConfig.chart.width = width;
        chartContainer['@resize']();
      });
    }
  }, {
    key: "setChartHeight",
    value: function setChartHeight(height) {
      var _this4 = this;
      this.chartModule.then(function (chartContainer) {
        _this4.moduleElement.find(".chartImageBox#".concat(_this4.moduleId, "_longQuoteChart")).height(height);
        _this4.moduleElement.find(".chartImageBox#".concat(_this4.moduleId, "_longQuoteChart>div")).height(height);
        _this4.moduleElement.find(".chartImageBox#".concat(_this4.moduleId, "_longQuoteChart>div>div")).height(height);
        chartContainer.getChartConfiguration().themeConfig.chart.height = height;
        chartContainer['@resize']();
      });
    }
  }, {
    key: "setVolumeGauge",
    value: function setVolumeGauge(trdVolume, avgVolume1M) {
      var relativeVolume = trdVolume / avgVolume1M;
      this.gauge.set(relativeVolume);
    }
  }, {
    key: "setDetailState",
    value: function setDetailState(open) {
      if (open) {
        this.setChartHeight(165);
        this.setChartWidth(228);
        $("#".concat(this.moduleId, "_long-quote-extended-row")).removeClass('hide');
        this.buttonOpenDetail.find('span.icon-placeholder').html(iconFaChevronUp.html);
      } else {
        this.setChartHeight(95);
        this.setChartWidth(158);
        $("#".concat(this.moduleId, "_long-quote-extended-row")).addClass('hide');
        this.buttonOpenDetail.find('span.icon-placeholder').html(iconFaChevronDown.html);
      }
      this.buttonOpenDetail.attr('aria-pressed', open);
      this.buttonOpenDetail.attr('aria-label', window.getMessage('longquote.button.expand.label'));
      $('.long-quote-expand-row').attr('title', open ? window.getMessage('longquote.button.collapse.title') : window.getMessage('longquote.button.expand.title'));
      setTimeout(function () {
        window.forceResizeEvent.fire();
      });
    }
  }, {
    key: "toggleDetail",
    value: function toggleDetail() {
      this.detailOpen = !this.detailOpen;
      this.setDetailState(this.detailOpen);
      window.localStorage.setItem('longQuote.open', this.detailOpen ? 'true' : 'false');
      window.forceResizeEvent.fire();
    }
  }, {
    key: "sendContextPassingMessage",
    value: function sendContextPassingMessage(type) {
      window.fcom.customized.tdwealth.contextPassing.sendContextPassingMessage(this.contextPassingOptions.contextPassSymbol, type, this.contextPassingOptions.optionType, this.contextPassingOptions.expiryDate, this.contextPassingOptions.strikePrice, this.contextPassingOptions.instrumentType);
    }
  }, {
    key: "checkSymbol",
    value: function checkSymbol(symbol, type) {
      $("#".concat(this.moduleId, "_long-quote-button-buy")).prop('disabled', !symbol);
      $("#".concat(this.moduleId, "_long-quote-button-sell")).prop('disabled', !symbol);
      $("#".concat(this.moduleId, "_long-quote-button-add-to-watchlist")).prop('disabled', !symbol);
      $("#".concat(this.moduleId, "_long-quote-button-set-alert")).prop('disabled', !symbol);
      $("#".concat(this.moduleId, "_long-quote-button-open-instrument")).prop('disabled', !symbol);
      $("#".concat(this.moduleId, "_long-quote-button-open-option-chain")).prop('disabled', !symbol || type === 'FUNDS' && this.exchangeName === 'LIP');
      $("#".concat(this.moduleId, "_long-quote-button-buy")).attr('title', !symbol ? window.getMessage('longquote.button.disabled') : '');
      $("#".concat(this.moduleId, "_long-quote-button-sell")).attr('title', !symbol ? window.getMessage('longquote.button.disabled') : '');
      $("#".concat(this.moduleId, "_long-quote-button-add-to-watchlist")).attr('title', !symbol ? window.getMessage('longquote.button.disabled') : '');
      $("#".concat(this.moduleId, "_long-quote-button-set-alert")).attr('title', !symbol ? window.getMessage('longquote.button.disabled') : '');
      $("#".concat(this.moduleId, "_long-quote-button-open-instrument")).attr('title', !symbol ? window.getMessage('longquote.button.disabled') : '');
      $("#".concat(this.moduleId, "_long-quote-button-open-option-chain")).attr('title', !symbol ? window.getMessage('longquote.button.disabled') : '');
    }
  }]);
  return LongQuote;
}();

},{"@fortawesome/fontawesome-svg-core":149,"gaugeJS":179}],114:[function(require,module,exports){
"use strict";

var _MaturityChartContainer = _interopRequireDefault(require("modules/MaturityChartModule/MaturityChartContainer"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// register the module and its callback function
window.fcom.moduleHandler.registerModuleType('MaturityChartModule', function (node, config, themeConfig) {
  var moduleInstance = new _MaturityChartContainer.default(node, config, themeConfig);
  return moduleInstance;
}, true);

},{"modules/MaturityChartModule/MaturityChartContainer":115}],115:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _SingleChart = _interopRequireWildcard(require("modules/InstrumentChartModule/SingleChart"));
var _getStatusMessageFromError = _interopRequireDefault(require("util/functions/getStatusMessageFromError"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var MaturityChartContainer = function MaturityChartContainer(node, config, themeConfig) {
  var _this = this;
  this.node = node;
  this.config = config;
  this.ric = this.config.ric;
  this.themeConfig = themeConfig;
  if (config.receiverChannel) {
    this['@broadcast'] = _defineProperty({}, config.receiverChannel, function (message) {
      if (message.messageType === 'ric') {
        _this.ric = message.ric;
        // #. Load the chart with new ric data
        _this.loadChart();
      }
    });
  }

  // #. Load the chart with initial data
  this.loadChart();

  // setup point syncing
  $(this.node).bind('mousemove touchmove touchstart', function (e) {
    if (!_this.chart) {
      return;
    }
    var normalizedEvent = _this.chart.chart.pointer.normalize(e.originalEvent);
    var point = _this.chart.chart.series[0].searchPoint(normalizedEvent, true);
    if (point) {
      point.highlight(e);
    }
  });
  $(this.node).bind('mouseout touchend', function () {
    if (!_this.chart) {
      return;
    }
    _this.chart.chart.tooltip.hide();
    _this.chart.chart.xAxis[0].hideCrosshair();
    _this.chart.chart.series[0].points.forEach(function (point) {
      point.select(false);
    });
  });

  // add context menu handler
  $(this.node).find('[data-module-action="contextMenu"]').click(function (event) {
    var $node = $(event.target);
    var moduleNode = $node.data('module-id') ? $node : $node.parents('[data-module-id]').get(0);
    // #. Time series will display last 3 years data as Monthly interval
    if (moduleNode) {
      var moduleId = $(moduleNode).data('module-id');
      var contextConfig = window.getConfigForModule(moduleId);
      contextConfig.interval = 'M';
      contextConfig.days = 1096;
    }
  });
};
MaturityChartContainer.prototype.loadChart = function () {
  var _this2 = this;
  this.getInitialData().then(function (chartData) {
    _this2.chartData = chartData;
    if (!_this2.config.hasFixedTitle) {
      $(_this2.node).find('.moduleHeader .title .content').html(_this2.config.title || chartData.title);
    }
    _this2.hideError();
    if (_this2.chartData.data.length < 3) {
      _this2.showMinimumDataError(window.getMessage('module.MaturityChartModule.requiredDataPoints'));
    } else if (_this2.chartData.invalidType === 'true') {
      _this2.showError(window.getMessage('module.MaturityChartModule.onlyFutures'));
    } else {
      _this2.render();
    }
  }).catch(function (err) {
    var ricText = _this2.ric || '';
    if (!_this2.config.hasFixedTitle) {
      $(_this2.node).find('.moduleHeader .title .content').text(ricText);
    }
    var message = String(err.message).includes('500') ? window.getMessage('module.MaturityChartModule.onlyFutures') : window.getMessage((0, _getStatusMessageFromError.default)(err), ricText);
    _this2.showError(message);
  });
};
MaturityChartContainer.prototype.render = function () {
  if (!this.chartData) {
    return;
  }
  var $chartContainer = $(this.node).find('.moduleContent>div');
  $chartContainer.html('');
  var chartHeight = 100;
  var $container = $("<div class=\"chart-container\" style=\"height:".concat(chartHeight, "%;\"/>"));
  $chartContainer.append($container);
  var chartData = {
    series: [{
      name: window.getMessage('chart.value.price'),
      type: 'line',
      config: {
        color: this.themeConfig.chartColors.neutral
      },
      data: this.chartData.data.map(function (d) {
        return {
          close: d.c,
          timestamp: d.ts,
          name: d.shortTitle
        };
      }).filter(function (d) {
        return d.close;
      })
    }]
  };
  var styleOverwrites = {
    plotOptions: {
      line: {
        marker: {
          enabled: false,
          radius: 4,
          lineWidth: 1
        }
      }
    }
  };
  var chartConfig = {
    dataType: 'maturities',
    themeConfig: Object.assign(styleOverwrites, this.themeConfig),
    interval: 'D',
    isComplex: false,
    chartScale: _SingleChart.CHARTSCALE.ABSOLUTE,
    isStreaming: false,
    // it is not streaming in the sense that items will be added to the end of the line
    showLegend: false,
    datePattern: "".concat(window.getMessage('chart.future.maturity'), ": ").concat(window.YAHOO.fcom.Format.localized.patternChartDay)
  };
  this.chart = new _SingleChart.default($container.get(0), chartData, chartConfig);
  if (!this.streamingInitialised && window.YAHOO.fcom.Streaming.streamingService) {
    this.initStreaming();
  }
};
MaturityChartContainer.prototype.initStreaming = function () {
  var _this3 = this;
  var streamingFid = '30006';
  var rics = this.chartData.data.map(function (a) {
    return a.ric;
  });
  var streamingMarkers = rics.map(function (ric) {
    return "<span class=\"stream\" data-stream-src=\"[&quot;".concat(ric, "&quot;,&quot;").concat(streamingFid, "&quot;,&quot;u&quot;]\"></span>");
  });
  var $streamingContainer = $('<div/>').css('display', 'none').append(streamingMarkers);
  $(this.node).append($streamingContainer);
  var Streaming = window.YAHOO.fcom.Streaming;
  Streaming.addStreamingNodes(this.node);
  Streaming.streamingService.addSingleItemCallback(function (update) {
    if (update.fid === streamingFid && rics.indexOf(update.ric) > -1 && _this3.chartData) {
      var dataPoint = _this3.chartData.data.find(function (f) {
        return f.ric === update.ric;
      });
      if (dataPoint) {
        dataPoint.c = "".concat(update.content);
        _this3.render();
      }
    }
  });
  this.streamingInitialised = true;
};
MaturityChartContainer.prototype.getInitialData = function () {
  var params = {
    method: 'getInstrumentChart',
    ric: this.ric
  };
  return window.ajaxGetJson('/maturityseries.action', params);
};
MaturityChartContainer.prototype.showError = function (errorText) {
  $(this.node).find('.moduleContent>div .chart-container').hide();
  $(this.node).find('.moduleContent>div .hint').remove();
  $(this.node).find('.moduleContent>div').append("<div class=\"hint\">".concat(errorText, "</div>"));
  this.chartData = null;
  return this;
};
MaturityChartContainer.prototype.showMinimumDataError = function (errorText) {
  $(this.node).find('.moduleContent>div .chartImageBox').hide();
  this.showError(errorText);
};
MaturityChartContainer.prototype.hideError = function () {
  $(this.node).find('.moduleContent>div .chart-container').show();
  $(this.node).find('.moduleContent>div .hint').remove();
};
MaturityChartContainer.prototype['@resize'] = function () {
  this.render();
};
var _default = exports.default = MaturityChartContainer;

},{"modules/InstrumentChartModule/SingleChart":102,"util/functions/getStatusMessageFromError":141}],116:[function(require,module,exports){
"use strict";

var _NewsSearchHighlight = _interopRequireDefault(require("fcom/pages/news/NewsSearchHighlight"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
window.fcom.moduleHandler.registerModuleType('NewsListModule', function (node, config) {
  var fakeModuleInstance = {};
  var refreshTime = config.newsRefreshTime || 10000;
  var ric = config.ric || null;
  var timer;
  var resetTimer = function resetTimer(triggerInstantly) {
    if (timer) {
      window.clearInterval(timer);
    }
    var reloadContent = window.reloadModuleContent.bind(null, node.id, config.viewName, "".concat(node.id, "_div"), ric);
    if (triggerInstantly) {
      reloadContent();
    }
    if (config.reloadForStreaming) {
      timer = window.setInterval(function () {
        if (!document.hidden) {
          reloadContent();
        }
      }, refreshTime);
    }
    _NewsSearchHighlight.default.highlight({
      isModule: true,
      moduleId: node.id
    });
  };
  resetTimer();
  if (config.receiverChannel) {
    fakeModuleInstance['@broadcast'] = _defineProperty({}, config.receiverChannel, function (message) {
      if (message.ric) {
        ric = message.ric;
        resetTimer(true);
      }
    });
  }
  fakeModuleInstance['@destroy'] = function () {
    if (timer) {
      window.clearInterval(timer);
      window.setTimeout(function () {
        if ($("#".concat(node.id)).length === 0) {
          window.localStorage.removeItem(node.id);
        }
      }, 250);
    }
  };
  $(node).on('popout.onload', function () {
    resetTimer(true);
  });
  $(window).on('moduleReloaded', function (moduleInfo) {
    if (moduleInfo.moduleId === node.id) {
      _NewsSearchHighlight.default.highlight({
        isModule: true,
        moduleId: moduleInfo.moduleId
      });
    }
  });
  return fakeModuleInstance;
}, true);
$('ready').ready(function () {
  if (window.YAHOO.fcom.viewInfo.isMobile) {
    $('[data-mobile-news]').click(function () {
      if ($(this).data('open')) {
        $(this).data('open', false);
        var nid = $(this).data('mobile-news').nid;
        $("tr[data-mobile-news-site-id=\"".concat(nid, "\"]")).remove();
      } else {
        $(this).data('open', true);
        insertNewsBody($(this).parent().parent());
      }
    });
  }
});
var insertNewsBody = function insertNewsBody(jTableRow) {
  var newsObject = jTableRow.find('[data-mobile-news]').data('mobile-news');
  var cssClass = jTableRow.hasClass('odd') ? 'odd' : 'even';
  var nid = newsObject.nid;
  $("<tr data-mobile-news-site-id='".concat(nid, "' class=\"").concat(cssClass, "\"><td colspan='2'><div  data-mobile-news-site-id='").concat(nid, "'>").concat(nid, "</div></td></tr>")).insertAfter(jTableRow);
  var url = "news/mobile.html?nid=".concat(nid);
  if (newsObject.cat !== undefined) url = "".concat(url, "&cat=").concat(encodeURIComponent(newsObject.cat));
  if (newsObject.text !== undefined) url = "".concat(url, "&text=").concat(newsObject.text);
  var newsSiteDiv = $("div[data-mobile-news-site-id=\"".concat(nid, "\"]"));
  newsSiteDiv.load("".concat(url, " .moduleContent"));
};

},{"fcom/pages/news/NewsSearchHighlight":128}],117:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/*global YAHOO : true*/
/*global fcom : true*/
/*global window : true*/

var NewsModule = function NewsModule(node, config) {
  var moduleId = node.id;
  var predefinedNewsFilter = config.predefinedNewsFilter || '';
  var viewId = YAHOO.fcom.Page.getInstance('moduleContainer').id;
  var tableId = "".concat(node.id, "_newsTable");
  var defaultTopicCode = typeof config.useTopicCode === 'string' ? config.useTopicCode : '';
  var ric = null;
  var lastMessage = null;
  this['@destroy'] = function () {
    return null;
  };
  if (config.receiverChannel) {
    this['@broadcast'] = _defineProperty({}, config.receiverChannel, function (message) {
      return onMessage(message);
    });
  }
  var isSupportedMessageType = function isSupportedMessageType(message) {
    // const types = ['ric', 'multiRic', 'country', 'multiCountry']; // ric currently handled as string diectly
    var types = ['ric', 'multiRic', 'country']; // ric currently handled as string diectly
    return Boolean(message) && types.indexOf(message.messageType) > -1;
  };
  var onMessage = function onMessage(message) {
    if (message.senderId !== node.id) {
      lastMessage = message;
      if (message.messageType === 'ric' && typeof message.ric === 'string') {
        ric = message.ric;
        reloadModule(ric);
      } else if (isSupportedMessageType(message)) {
        reloadModule(message);
      }
    }
  };
  var getTopicCode = function getTopicCode() {
    var topicCode = defaultTopicCode === '' ? ric : "".concat(defaultTopicCode, "&").concat(ric);
    return ric ? topicCode : defaultTopicCode;
  };
  var reloadModule = function reloadModule() {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    window.reloadModuleContent(node.id, viewId, tableId, message);
  };

  // Setup broadcast listeners to reload module content
  YAHOO.fcom.Broadcaster.subscribe('.selectionWatchlistChanged', function () {
    if (predefinedNewsFilter.indexOf('SelectedPeerNews') > -1) {
      //if the module content is selected peer news
      reloadModule();
    }
  });
  YAHOO.fcom.Broadcaster.subscribe('.favoritesWatchlistChanged', function () {
    if (predefinedNewsFilter.indexOf('FavoritePeerNews') > -1) {
      //if the module content is favourite peer news
      reloadModule();
    }
  });
  YAHOO.fcom.Broadcaster.subscribe('.selectionMarketsChanged', function () {
    if (predefinedNewsFilter.indexOf('SelectedMarketNews') > -1) {
      //if the module content is selected market news
      reloadModule();
    }
  });
  YAHOO.fcom.Broadcaster.subscribe('.favoritesMarketsChanged', function () {
    if (predefinedNewsFilter.indexOf('FavoriteMarketNews') > -1) {
      //if the module content is favourite market news
      reloadModule();
    }
  });
  var onMaximize = function onMaximize() {
    var newsConfig = {
      category: getTopicCode(),
      queryCategory: null,
      fulltext: config.detailFullText || config.fullTextSearch || '',
      countries: null,
      predefinedNewsFilter: predefinedNewsFilter,
      onlyArticle: false,
      broadcastedMessage: lastMessage
    };
    window.createNewsView(newsConfig);
  };

  // maximize button functionality
  $("#".concat(moduleId, "_maximize")).click(function () {
    return onMaximize();
  });
};
fcom.moduleHandler.registerModuleType('NewsModule', function (node, config) {
  return new NewsModule(node, config);
}, true);

},{}],118:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var YAHOO = window.YAHOO;
var OptionChainModule = function OptionChainModule(moduleId, node, config) {
  this.moduleId = moduleId;
  this.node = node;
  this.config = config;
  this.init();
};
OptionChainModule.prototype.init = function () {
  var _this = this;
  YAHOO.fcom.Page.onInstanceReady("".concat(this.moduleId, "_numberStrikes"), function () {
    YAHOO.fcom.Page.onInstanceReady("".concat(_this.moduleId, "_maturityDate"), function () {
      // wait till both elements are ready
      _this.intOptionDefaultState();
      doCalculation(_this.moduleId);
    });
  });
};
OptionChainModule.prototype.doCalculation = function () {
  doCalculation(this.moduleId);
};

/*
 * Only when the default state of the input form finalized. together with
 * Underlying info ,Only call this method inside a call back function which
 * will update the default state of the input form.
 */
OptionChainModule.prototype.intOptionDefaultState = function () {
  var _this2 = this;
  var center = YAHOO.util.Dom.get("".concat(this.moduleId, "_center"));
  new YAHOO.util.KeyListener(center, {
    keys: [YAHOO.util.KeyListener.KEY.ENTER]
  }, {
    fn: doCalculation.bind(null, this.moduleId),
    scope: this,
    correctScope: true
  }).enable();
  var numberStrikes = YAHOO.fcom.Page.getInstance("".concat(this.moduleId, "_numberStrikes"));
  numberStrikes.changeEvent.subscribe(function () {
    doCalculation(_this2.moduleId);
  });
  var maturityDate = YAHOO.fcom.Page.getInstance("".concat(this.moduleId, "_maturityDate"));
  maturityDate.changeEvent.subscribe(function () {
    doCalculation(_this2.moduleId);
  });
  var searchRicPopup = YAHOO.fcom.Page.getInstance("".concat(this.moduleId, "_searchRicPopup")) || window["".concat(this.moduleId, "_searchRicPopup")];
  searchRicPopup.itemFoundEvent.subscribe(function () {
    var param;
    if (searchRicPopup.lastSearchResult.typeOfId === 'ric') {
      param = {
        ric: searchRicPopup.getTextValue().value
      };
    } else if (searchRicPopup.lastSearchResult.typeOfId === 'isin') {
      param = {
        isin: searchRicPopup.getTextValue().value
      };
    } else if (searchRicPopup.lastSearchResult.typeOfId === 'id') {
      param = {
        id: searchRicPopup.getTextValue().value
      };
    }
    window.reloadModuleContent(_this2.node.id, _this2.config.viewId, "".concat(_this2.moduleId, "_div"), param).then(function () {
      return _this2.init();
    });
  });
};
var getQueryString = function getQueryString(moduleId) {
  var viewId = document.getElementsByName("".concat(moduleId, "_viewId"))[0].value;
  var isin = document.getElementsByName("".concat(moduleId, "_isin"))[0].value;
  var ric = document.getElementsByName("".concat(moduleId, "_ric"))[0].value;
  var fcomId = document.getElementsByName("".concat(moduleId, "_fcomId"))[0].value;
  var moduleDataId = encodeURIComponent(moduleId);
  if (moduleDataId.startsWith(viewId)) {
    moduleDataId = moduleDataId.slice(viewId.length + 1, moduleDataId.length);
  }
  var center = YAHOO.util.Dom.get("".concat(moduleId, "_center")).value;
  center = YAHOO.fcom.Parse.parseNumber(center);
  if (isNaN(center)) {
    center = YAHOO.util.Dom.get("".concat(moduleId, "_savedCenter")).value;
    center = YAHOO.fcom.Parse.parseNumber(center);
  }
  var numberStrikes = encodeURIComponent(YAHOO.fcom.Page.getInstance("".concat(moduleId, "_numberStrikes")).getSelectedValue());
  var maturityDate = encodeURIComponent(YAHOO.fcom.Page.getInstance("".concat(moduleId, "_maturityDate")).getSelectedValue());
  return "&ric=".concat(ric, "&fcomId=").concat(fcomId, "&isin=").concat(isin, "&moduleId=").concat(moduleDataId, "&viewId=").concat(viewId, "&center=").concat(center, "&numberStrikes=").concat(numberStrikes, "&maturityDate=").concat(maturityDate).concat(getOptionStateQueryString(moduleId));
};
var getOptionStateQueryString = function getOptionStateQueryString(moduleId) {
  var url = '';
  url += getMenuQueryString(moduleId, '_exchangeMenu', 'exchange');
  url += getMenuQueryString(moduleId, '_typeEAMenu', 'typeEA');
  url += getMenuQueryString(moduleId, '_lotSizeMenu', 'lotSize');
  return url;
};
var doCalculation = function doCalculation(moduleId) {
  YAHOO.fcom.Page.unregister("".concat(moduleId, "_exchangeMenu"));
  YAHOO.fcom.Page.unregister("".concat(moduleId, "_lotSizeMenu"));
  YAHOO.fcom.Page.unregister("".concat(moduleId, "_typeEAMenu"));
  var url = "/ajax.action?method=optionChainModule".concat(getQueryString(moduleId));
  window.replaceAsync(url, "".concat(moduleId, "_optionChainResponseContainer"), {
    showWait: true,
    callback: function callback() {
      listenAdditionalFilterChanges(moduleId);
    }
  });
};
var getMenuQueryString = function getMenuQueryString(moduleId, menuName, parameterName) {
  var menuObject = YAHOO.fcom.Page.getInstance(moduleId + menuName);
  if (existSelectedValue(menuObject)) {
    return "&".concat(parameterName, "=").concat(encodeURIComponent(menuObject.getSelectedValue()));
  } else {
    return '';
  }
};
var existSelectedValue = function existSelectedValue(menuObject) {
  if (menuObject == null) {
    return false;
  }
  try {
    // sometimes there is an Exception
    return !!menuObject.getSelectedValue();
  } catch (e) {
    return false;
  }
};
var listenAdditionalFilterChanges = function listenAdditionalFilterChanges(moduleId) {
  var listenFilterChange = function listenFilterChange(filterId) {
    if (document.getElementById(filterId)) {
      YAHOO.fcom.Page.onInstanceReady(filterId, function () {
        var filerInstance = YAHOO.fcom.Page.getInstance(filterId);
        if (filerInstance) {
          filerInstance.changeEvent.subscribe(function () {
            doCalculation(moduleId);
          });
        }
      });
    }
  };
  listenFilterChange("".concat(moduleId, "_lotSizeMenu"));
  listenFilterChange("".concat(moduleId, "_exchangeMenu"));
  listenFilterChange("".concat(moduleId, "_typeEAMenu"));
};
window.fcom.moduleHandler.registerModuleType('OptionChainModule', function (node, config) {
  var moduleId = node.id;
  var moduleInstance = new OptionChainModule(moduleId, node, config);
  if (config.receiverChannel) {
    moduleInstance['@broadcast'] = _defineProperty({}, config.receiverChannel, function (message) {
      window.reloadModuleContent(moduleId, config.viewId, "".concat(moduleId, "_div"), message.ric).then(function () {
        return moduleInstance.init();
      });
    });
  }
  return moduleInstance;
}, true);

},{}],119:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var ProfessionalChartModule = function ProfessionalChartModule(node, config, themeConfig) {
  config.theme = themeConfig;
  var viewId = window.YAHOO.fcom.Page.getInstance('moduleContainer').id;
  var moduleId = node.id;
  if (config.receiverChannel) {
    this['@broadcast'] = _defineProperty({}, config.receiverChannel, function (message) {
      if (message.messageType === 'ric') {
        window.reloadModuleContent(moduleId, viewId, "".concat(moduleId, "_div"), message.ric).then(function () {
          config.ric = message.ric;
          window.fcom.moduleHandler.initModule(node);
        });
      }
    });
  }
  this['@destroy'] = function () {
    var containerId = "".concat(moduleId, "_trading-view-container");
    if (window.tvw[containerId]) {
      delete window.tvw[containerId];
    }
  };
  this['@dropped'] = function (data) {
    var _data = _slicedToArray(data, 1),
      droppedModuleId = _data[0];
    var containerId = "".concat(moduleId, "_trading-view-container");
    if (moduleId === droppedModuleId && window.tvw[containerId]) {
      window.tvw[containerId].reloadTradingViewChart();
    }
  };
};
window.fcom.moduleHandler.registerModuleType('ProfessionalChartModule', function (node, config, themeConfig) {
  return new ProfessionalChartModule(node, config, themeConfig);
}, true);
var _default = exports.default = ProfessionalChartModule;

},{}],120:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var RatingsModule = exports.default = /*#__PURE__*/function () {
  function RatingsModule(node, config, themeConfig) {
    _classCallCheck(this, RatingsModule);
    this.config = config;
    this.node = node;
    this.themeConfig = themeConfig;
    if (config.receiverChannel) {
      this['@broadcast'] = _defineProperty({}, config.receiverChannel, function (message) {
        if (message.messageType === 'ric') {
          var viewId = window.YAHOO.fcom.Page.getInstance('moduleContainer').id;
          window.reloadModuleContent(node.id, viewId, $("#".concat(node.id)).find("#".concat(node.id, "_div")).get(0), message.ric).then(function () {
            config.ric = message.ric;
            window.fcom.moduleHandler.initModule(node);
          });
        }
      });
    }
    this.updateChart();
    this.updateWCAGAttributes();
  }
  _createClass(RatingsModule, [{
    key: "updateChart",
    value: function updateChart() {
      var _this = this;
      var tableRows = this.node.querySelectorAll(".analyst-ratings > table > tbody > tr.chart-table-row");
      Array.from(tableRows).forEach(function (child, index) {
        var mean = parseFloat(child.getAttribute('data-mean'));
        _this.setPointerPosition(child, mean);
      });
    }

    /**
     * @method updateWCAGAttributes
     * @description Update rating sub table caption/aria-label
     */
  }, {
    key: "updateWCAGAttributes",
    value: function updateWCAGAttributes() {
      // #. Get the module title
      var tableTitle = String(this.node.querySelector('h2.title').textContent).trim();
      // #. Get all trade price tables
      var $priceTables = this.node.querySelectorAll('div.trade-price-group');
      // #. Assign updated title text as the aria-label attribute
      if ($priceTables && $priceTables.length > 0) {
        $priceTables.forEach(function ($table) {
          var subTitle = String($table.querySelector('.trade-price-box-label').textContent).trim();
          var ariaLabel = "".concat(tableTitle, " ").concat(subTitle);
          // #. Set the updated title as table aria-label
          $table.setAttribute('aria-label', ariaLabel);
        });
      }
    }
  }, {
    key: "setPointerPosition",
    value: function setPointerPosition(row, mean) {
      var pointer = row.querySelector('.slider-pointer');

      // Convert mean to offset percentage
      // Y = (X-A)/(B-A) * (D-C) + C

      var offset = (mean - 0.5) / 5.0 * 100.0;
      pointer.style.marginLeft = "".concat(offset, "%");
    }
  }]);
  return RatingsModule;
}();
;
window.fcom.moduleHandler.registerModuleType('RatingsModule', function (node, config, themeConfig) {
  return new RatingsModule(node, config, themeConfig);
}, true);

},{}],121:[function(require,module,exports){
"use strict";

var _SmartChartModule = _interopRequireDefault(require("fcom/modules/SmartChartModule/SmartChartModule"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
//register the module and its callback function
window.fcom.moduleHandler.registerModuleType('SmartChartModule', function (node, config, themeConfig) {
  var module = {};
  var viewId = window.YAHOO.fcom.Page.getInstance('moduleContainer').id;
  var moduleId = node.id;
  var chartConfig = $.parseJSON($("#".concat(moduleId, "_chartConfig")).val());
  var changeModuleCallback = function changeModuleCallback() {
    if (window.viewChangedEvent) {
      window.viewChangedEvent.fire();
    }
  };
  var chartOptions = {
    moduleId: moduleId,
    saveSettingsCallback: function saveSettingsCallback(data) {
      var url = '/module.action';
      var postData = {
        method: 'changeModule',
        viewId: viewId,
        moduleId: moduleId,
        ric: data.RIC,
        height: data.h,
        jsonConfig: data
      };
      window.ngpAsyncRequest('POST', url, changeModuleCallback, postData, null, false, false);
    }
  };
  $(document).ready(function () {
    YAHOO.fcom.Page.onReady(function () {
      module.chartInstance = new _SmartChartModule.default(chartConfig, chartOptions);
    });
  });
  if (config.receiverChannel) {
    module['@broadcast'] = _defineProperty({}, config.receiverChannel, function (message) {
      if (message.messageType === 'ric' && module.chartInstance) {
        module.chartInstance.updateRic(message.ric);
      }
    });
  }
  module['@resize'] = function () {
    module.chartInstance.refreshChart();
  };
  return module;
}, true);

},{"fcom/modules/SmartChartModule/SmartChartModule":122}],122:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _runFunctionDebounced = _interopRequireDefault(require("util/functions/runFunctionDebounced"));
var _this = void 0;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var SMART_CHART_DATE_SAVE_FORMAT = 'yyyy-MM-dd';
var SmartChartModule = function SmartChartModule(config, options) {
  var YAHOO = window.YAHOO;
  var fcom = window.fcom;
  var $moduleNode = null;
  var persistedParams = ['type', 'n', 'p',
  // scale:
  'perc', 'log',
  // average
  'sma1', 'sma2', 'ema1', 'ema2',
  // benchmarks
  'b0', 'b1', 'b2', 'b3',
  // end date
  'ed',
  // indicators in chart
  'indicatorCharts',
  // indicators in extra charts
  'indicatorLines',
  // totalReturn
  'tsr',
  // show information
  'noLegend'];
  // Set persisted params if set in db. Due to the way in which fcom.util.PersistenceHelper.filterAttributes() works,
  // it's important to not have an empty persistedParams structure, otherwise everything will get persisted.
  if (config.persistedParams) {
    persistedParams = config.persistedParams;
  }
  var elemIdprefix = options.moduleId ? "".concat(options.moduleId, "_") : '';
  var $moduleTitle = $("#".concat(options.moduleId)).find('.module-smart-chart > .moduleHeader .title>.content');
  var chartModulePromise;
  var $chartContainer = $("#".concat(elemIdprefix, "InstrumentChartModule_large [data-chartcontainer]"));
  var $chartImageBox = $("#".concat(elemIdprefix, "InstrumentChartModule_large .chartImageBox"));

  /*
   * Load chart settings according to persistence configuration
   * @param {String} id
   */
  var loadChartSettings = function loadChartSettings(id) {
    if (id !== 'main') {
      return config.params;
    } else {
      return fcom.util.PersistenceHelper.getCookie("".concat(options.moduleId, "_").concat(id));
    }
  };
  var initialLoadCompleted = false;
  var searchHandler = YAHOO.fcom.Page.getInstance("".concat(elemIdprefix, "searchRicPopup"));
  if (searchHandler) {
    searchHandler.textField.value = config.instrumentName;
  }

  // default binding config
  var _defaultBinding = {
    onChange: {
      fn: function fn() {
        refreshChart();
      },
      scope: _this
    }
  };

  // returns binding config for benchmarks
  var _benchmarkBinding = function _benchmarkBinding(checkbox, dropdown, currency) {
    return {
      onChange: {
        fn: function fn() {
          benchmarkChanged(checkbox, dropdown, currency);
        },
        scope: _this
      }
    };
  };
  var _benchmarkCheckboxBinding = function _benchmarkCheckboxBinding(checkbox, dropdown) {
    return {
      onChange: {
        fn: function fn() {
          benchmarkCheckboxChanged(checkbox, dropdown);
        },
        scope: _this
      }
    };
  };

  // binding config for date fields
  var _dateBinding = {
    onChange: {
      fn: function fn() {
        dateChanged();
        refreshChart();
      },
      scope: _this
    }
  };
  var _additionalDiagramBindings = function _additionalDiagramBindings(checkbox, dropdown) {
    return {
      onChange: {
        fn: function fn() {
          indicatorChanged(checkbox, dropdown);
        },
        scope: _this
      }
    };
  };

  // binding config for portfolio value
  var _portfolioValueBinding = {
    onChange: {
      fn: function fn() {
        if (isGain()) {
          _data.set('scale', 'perc');
          disableScales('perc', true);
        } else {
          _data.set('scale', 'abs');
          disableScales('abs', false);
        }
        refreshChart();
      },
      scope: _this
    }
  };

  // event marker binding config
  var _eventBinding = {
    onChange: {
      fn: function fn() {
        _data.set('eventMarkers', false);
        refreshChart();
      },
      scope: _this
    }
  };
  var _ricBinding = {
    onChange: {
      fn: function fn() {
        checkTsr();
        refreshChart();
      },
      scope: _this
    }
  };

  // set up DataBinding
  /* eslint-disable camelcase */ // disabled because the keys need to be bound to name attributes that will contain underscores
  var _data = fcom.util.DataBinding.link(YAHOO.util.Dom.get("".concat(elemIdprefix, "chartControls")), {
    ric: _ricBinding,
    Benchmark1CheckBox: _benchmarkCheckboxBinding('Benchmark1CheckBox', config.popupSearchEnabled ? 'Benchmark1_search' : 'Benchmark1'),
    Benchmark2CheckBox: _benchmarkCheckboxBinding('Benchmark2CheckBox', config.popupSearchEnabled ? 'Benchmark2_search' : 'Benchmark2'),
    Benchmark3CheckBox: _benchmarkCheckboxBinding('Benchmark3CheckBox', config.popupSearchEnabled ? 'Benchmark3_search' : 'Benchmark3'),
    Benchmark4CheckBox: _benchmarkCheckboxBinding('Benchmark4CheckBox', config.popupSearchEnabled ? 'Benchmark4_search' : 'Benchmark4'),
    Benchmark1_search: _benchmarkBinding('Benchmark1CheckBox', config.popupSearchEnabled ? 'Benchmark1_search' : 'Benchmark1', 'currency1'),
    Benchmark2_search: _benchmarkBinding('Benchmark2CheckBox', config.popupSearchEnabled ? 'Benchmark2_search' : 'Benchmark2', 'currency2'),
    Benchmark3_search: _benchmarkBinding('Benchmark3CheckBox', config.popupSearchEnabled ? 'Benchmark3_search' : 'Benchmark3', 'currency3'),
    Benchmark4_search: _benchmarkBinding('Benchmark4CheckBox', config.popupSearchEnabled ? 'Benchmark4_search' : 'Benchmark4', 'currency4'),
    Benchmark1: _benchmarkBinding('Benchmark1CheckBox', config.popupSearchEnabled ? 'Benchmark1_search' : 'Benchmark1', 'currency1'),
    Benchmark2: _benchmarkBinding('Benchmark2CheckBox', config.popupSearchEnabled ? 'Benchmark2_search' : 'Benchmark2', 'currency2'),
    Benchmark3: _benchmarkBinding('Benchmark3CheckBox', config.popupSearchEnabled ? 'Benchmark3_search' : 'Benchmark3', 'currency3'),
    Benchmark4: _benchmarkBinding('Benchmark4CheckBox', config.popupSearchEnabled ? 'Benchmark4_search' : 'Benchmark4', 'currency4'),
    currency1: _benchmarkBinding('Benchmark1CheckBox', config.popupSearchEnabled ? 'Benchmark1_search' : 'Benchmark1', 'currency1'),
    currency2: _benchmarkBinding('Benchmark2CheckBox', config.popupSearchEnabled ? 'Benchmark2_search' : 'Benchmark2', 'currency2'),
    currency3: _benchmarkBinding('Benchmark3CheckBox', config.popupSearchEnabled ? 'Benchmark3_search' : 'Benchmark3', 'currency3'),
    currency4: _benchmarkBinding('Benchmark4CheckBox', config.popupSearchEnabled ? 'Benchmark4_search' : 'Benchmark4', 'currency4'),
    EMAIndicator1CheckBox: _defaultBinding,
    EMAIndicator2CheckBox: _defaultBinding,
    SMAIndicator1CheckBox: _defaultBinding,
    SMAIndicator2CheckBox: _defaultBinding,
    showZigZagIndicator: _defaultBinding,
    showEnvelops: _defaultBinding,
    showBollingerBands: _defaultBinding,
    showParabolicSARIndicator: _defaultBinding,
    EMAIndicator1: _benchmarkBinding('EMAIndicator1CheckBox', 'EMAIndicator1'),
    EMAIndicator2: _benchmarkBinding('EMAIndicator2CheckBox', 'EMAIndicator2'),
    SMAIndicator1: _benchmarkBinding('SMAIndicator1CheckBox', 'SMAIndicator1'),
    SMAIndicator2: _benchmarkBinding('SMAIndicator2CheckBox', 'SMAIndicator2'),
    indicator1CheckBox: _defaultBinding,
    indicator2CheckBox: _defaultBinding,
    indicator1ChartType: _additionalDiagramBindings('indicator1CheckBox', 'indicator1ChartType'),
    indicator2ChartType: _additionalDiagramBindings('indicator2CheckBox', 'indicator2ChartType'),
    scale: _defaultBinding,
    currency: _defaultBinding,
    showInformation: _defaultBinding,
    periodicity: {
      onChange: {
        fn: function fn() {
          periodicityChanged();
          refreshChart();
        },
        scope: _this
      }
    },
    tsr: _defaultBinding,
    portfolioValueType: _portfolioValueBinding,
    eventMarkers: {
      onChange: {
        fn: function fn() {
          var toggled = _data.get('eventMarkers');
          for (var i = 1; i <= 12; i++) {
            _data.set("eventMarker_".concat(i), toggled);
          }
          refreshChart();
        },
        scope: _this
      }
    },
    eventMarker_1: _eventBinding,
    eventMarker_2: _eventBinding,
    eventMarker_3: _eventBinding,
    eventMarker_4: _eventBinding,
    eventMarker_5: _eventBinding,
    eventMarker_6: _eventBinding,
    eventMarker_7: _eventBinding,
    eventMarker_8: _eventBinding,
    eventMarker_9: _eventBinding,
    eventMarker_10: _eventBinding,
    eventMarker_11: _eventBinding,
    eventMarker_12: _eventBinding,
    startDate: _dateBinding,
    endDate: _dateBinding,
    numberOfPeriods: {
      onChange: {
        fn: function fn() {
          changeChartType();
          dateChanged(_data.get('numberOfPeriods'));
          refreshChart();
        },
        scope: _this
      }
    },
    chartType: {
      onChange: {
        fn: function fn() {
          intradayChartOnly();
          refreshChart();
        }
      },
      scope: _this
    }
  });
  /* eslint-enable camelcase */

  var timePeriodDays = config.periodDays.split(',').map(function (timePeriod) {
    return parseInt(timePeriod, 10);
  });
  var getRicArrayFromChartSettings = function getRicArrayFromChartSettings() {
    return [config.params.RIC,
    // main RIC
    config.params.b0,
    // benchmark 1
    config.params.b1,
    // benchmark 2
    config.params.b2,
    // benchmark 3
    config.params.b3 // benchmark 4
    ].filter(function (f) {
      return f;
    });
  };

  // const colorIndices = config.colorIndices;
  var portfolioId = config.pfid;
  var checkChartType = function checkChartType() {
    var chartTypeValue = _data.get('chartType');
    if (!chartTypeValue) {
      return;
    }
    var periodicityValue = _data.get('periodicity');
    if ((chartTypeValue === 'quote' || chartTypeValue === 'quoteandprice') && (periodicityValue.indexOf('m') < 0 || !config.isBidAskType)) {
      _data.set('chartType', 'line');
    }
  };
  var changeChartType = function changeChartType() {
    var chartTypeValue = _data.get('chartType');
    var numberOfPeriods = _data.get('numberOfPeriods');
    if ((numberOfPeriods > 30 || !config.isBidAskType) && (chartTypeValue === 'quote' || chartTypeValue === 'quoteandprice')) {
      _data.set('chartType', 'line');
    }
  };
  var disableInvalidChartTypes = function disableInvalidChartTypes() {
    var ctc = _data.getElement('chartType');
    if (!ctc) {
      return;
    }
    var items = window.periodicityMenu.getItems();
    var typeItems = ctc.getAllItemsBy(function (item) {
      return item.value === 'quote' || item.value === 'quoteandprice';
    });
    if (!typeItems.length) {
      return;
    }
    var disabledBidAskType = true;
    if (config.isBidAskType) {
      items.forEach(function (item) {
        var value = item.value;
        var disabled = item.cfg.getProperty('disabled');
        if (value.indexOf('m') >= 0 && !disabled) {
          disabledBidAskType = false;
        }
      });
    }
    typeItems.foreach(function (item) {
      return item.cfg.setProperty('disabled', !!disabledBidAskType);
    });
  };
  var periodicityChanged = function periodicityChanged() {
    checkChartType();
    checkTsr();
  };

  /*
   * Refreshes all charts in the chart area.
   *
   * @param {Boolean} [isSavedParams] Defaults to true. Whether to include saved chart parameters.
   */
  var chartModuleInstancePromise;
  var refreshTimeout;
  var refreshChart = (0, _runFunctionDebounced.default)(150, function () {
    chartModulePromise.then(function (module) {
      setChartParameters(module, getMainChartParams());
    });
  });

  // #. Context config for module context menu
  var updateContextConfig = function updateContextConfig(period, interval) {
    if (!$moduleNode) {
      return true;
    }
    var $configNode = $($moduleNode).closest('[data-module-contextconfig]');
    if (!$configNode.length) {
      return true;
    }

    // #. Days & Interval required for show time series menu item
    var contextConfig = $configNode.data('module-contextconfig') || {};
    contextConfig.ric = _data.get('ric');
    contextConfig.days = period;
    contextConfig.interval = interval;
    $configNode.data('module-contextconfig', contextConfig);
  };
  var setChartParameters = function setChartParameters(chartModuleInstance, params) {
    if (!chartModuleInstance) return;
    var rics = [params.RIC,
    // main RIC
    params.b0,
    // benchmark 1
    params.b1,
    // benchmark 2
    params.b2,
    // benchmark 3
    params.b3 // benchmark 4
    ].filter(function (f) {
      return f;
    });
    if (!params.p) {
      params.p = 'D';
    }
    var interval = params.p.indexOf('m') > -1 ? +params.p.slice(0, -1) || 1 : params.p;
    var chartType = {
      area: +interval ? 'steparea' : null,
      line: +interval ? 'stepline' : null
    }[params.type] || params.type;
    var indicators = ['sma1', 'sma2', 'ema1', 'ema2'].filter(function (f) {
      return params[f];
    }) // filter empty values
    .map(function (a) {
      return {
        type: a.substr(0, 3),
        parameters: [+params[a]]
      };
    }).concat(params.indicatorLines.map(function (a) {
      return {
        type: a,
        parameters: []
      };
    }));
    var indicatorCharts = params.indicatorCharts.map(function (indicator) {
      return {
        type: indicator,
        parameters: []
      };
    });
    chartModuleInstance.freeze();
    if (portfolioId && portfolioId !== '' && portfolioId !== null) {
      chartModuleInstance.setPortfolioId(portfolioId);
      params.pfid = portfolioId;
    }
    chartModuleInstance.setPortfolioValueType(params.valuetype, params.valueTypeString);
    chartModuleInstance.setRic(rics);
    chartModuleInstance.setType(chartType).setChartScale(params.perc ? 'relative' : params.log ? 'logarithmic' : 'absolute');
    var currencies = [params.currency ? params.currency : ''];
    if (params.b0) {
      currencies.push(params.currency1 ? params.currency1 : '');
    }
    if (params.b1) {
      currencies.push(params.currency2 ? params.currency2 : '');
    }
    if (params.b2) {
      currencies.push(params.currency3 ? params.currency3 : '');
    }
    if (params.b3) {
      currencies.push(params.currency4 ? params.currency4 : '');
    }
    chartModuleInstance.setCurrency(currencies);
    var period = getNumberOfDays(_data.get('startDate'), _data.get('endDate'));
    if (isEndToday() && period === 1) {
      // special behavior in order to display the last day if only one day was selected
      chartModuleInstance.setDays(1);
    } else {
      // NGPII-25099 , NGPII-17634
      // adding zone offset to shifted timestamp from UTC timestamp
      // YAHOO.fcom.Format.localized.timeZone contain tzOffset without daylight savings
      // calculating tzOffset from params.sd.calcUTCOffset
      var now = new fcom.date.DateTime();
      var tzOffset = params.sd.calcUTCOffset(now.getTimestamp());
      var realDaysToNow = (now.getTimestamp() - params.sd.getTimestamp()) / (1000 * 60 * 60 * 24);
      var isIntraday = realDaysToNow <= 14 && !config.historyOnly;
      var toDate = params.ed.timestamp + tzOffset;
      // for intraday, need to fetch full day data
      if (isIntraday) {
        // adding day end timestamp to endDate
        toDate = toDate + 23 * 59 * 59 * 999;
      }
      chartModuleInstance.setTimeRange(params.sd.timestamp + tzOffset, toDate);
    }
    chartModuleInstance.setFixedInterval("".concat(interval));
    // #. Make legend true always
    chartModuleInstance.config.showLegend = true;
    // #. Make tooltip dynamically enabled
    if (params.noLegend) {
      chartModuleInstance.config.disableTooltips = true;
    } else {
      chartModuleInstance.config.disableTooltips = false;
    }
    $chartContainer.css({
      height: "".concat(params.h, "px")
    });
    $chartImageBox.css({
      height: "".concat(params.h, "px")
    });
    chartModuleInstance.setIndicators(indicators).setIndicatorCharts(indicatorCharts).setDigits(params.digits).setExtraCallParameters({
      tsr: params.tsr,
      events: params.events
    }).unfreeze().reload();

    // save chart settings
    if (initialLoadCompleted) {
      var paramsCopy = Object.assign({}, params);
      paramsCopy.n = _data.get('numberOfPeriods');
      if (paramsCopy.n == -1) {
        paramsCopy.n = getNumberOfDays(_data.get('startDate'), _data.get('endDate'));
      }
      paramsCopy.ed = paramsCopy.ed.format(SMART_CHART_DATE_SAVE_FORMAT);
      paramsCopy.sd = paramsCopy.sd.format(SMART_CHART_DATE_SAVE_FORMAT);
      saveChartSettings('main', fcom.util.PersistenceHelper.filterAttributes(paramsCopy, persistedParams));
    }
    initialLoadCompleted = true;
    updateContextConfig(period, interval);
  };

  /*
   * Get the default chart parameters, which are combined with saved chart parameters and config parameters.
   * The config parameters are considered more important than the saved parameters.
   *
   * @param {Boolean} [isSavedParameters] Defaults to true. Whether to included saved parameters.
   * @return {LargeChartParametersClass}
   */
  var defaultParams = function defaultParams(isSavedParameters) {
    // defaults
    var sd = new fcom.date.DateTime().setTimestamp(config.startDate);
    var ed = new fcom.date.DateTime().setTimestamp(config.endDate);
    var params = new window.LargeChartParametersClass({
      type: 'area',
      sd: sd,
      ed: ed,
      isYield: config.isBenchmarkBond || config.isContributorBond
    });
    var save = loadChartSettings('main');

    // saved parameters
    if (isSavedParameters !== false && save != null) {
      params.setParameters(save);
      var days;
      if (config.historyOnly && save.n < 30) {
        days = 30;
      } else {
        days = save.n;
      }
      if (days) {
        var dates = getDatesForPeriod(days);
        params.ed = dates.ed;
        ed = params.ed;
        params.sd = dates.sd;
        sd = params.sd;
      }
    }
    params.n = getNumberOfDays(sd, ed);
    var oldConfig = config.periodicity || 'm';
    params.p = window.getPeriodicityFromDates(sd, ed, oldConfig, config.historyOnly);
    if (save) {
      params.p = save.p ? save.p : _data.get('periodicity');
      params.tsr = save.tsr ? save.tsr : _data.get('tsr');
    }

    // config parameters
    var rics = getRicArrayFromChartSettings();
    params.RIC = rics[0];
    if (rics[1]) {
      params.b0 = rics[1];
    }
    if (rics[2]) {
      params.b1 = rics[2];
    }
    if (rics[3]) {
      params.b2 = rics[3];
    }
    if (rics[4]) {
      params.b3 = rics[4];
    }

    // digits for tooltips:
    params.digits = 4;
    return params;
  };
  var getRicParameter = function getRicParameter() {
    var params = {};
    params.RIC = _data.get('ric');
    /* Benchmarks */
    if (config.compareRics) {
      var rics = getRicArrayFromChartSettings();
      params.b0 = rics[1];
      params.b1 = rics[2];
      params.b2 = rics[3];
      params.b3 = rics[4];
    } else {
      params.b0 = getOptionalValue('Benchmark1CheckBox', 'Benchmark1_search');
      params.b1 = getOptionalValue('Benchmark2CheckBox', 'Benchmark2_search');
      params.b2 = getOptionalValue('Benchmark3CheckBox', 'Benchmark3_search');
      params.b3 = getOptionalValue('Benchmark4CheckBox', 'Benchmark4_search');
    }
    return params;
  };

  /*
       * @param {Boolean} [isSavedParams] Defaults to true. Whether to include saved chart parameters.
       */
  var getMainChartParams = function getMainChartParams(isSavedParams) {
    var params = defaultParams(isSavedParams);
    /* General */

    params.RIC = _data.get('ric');
    params.sd = _data.get('startDate');
    params.ed = _data.get('endDate');
    params.n = getNumberOfDays(params.sd, params.ed);
    var chartTypeElement = _data.getElement('chartType');
    if (chartTypeElement) {
      params.type = _data.get('chartType');
    }
    params.p = _data.get('periodicity');
    params.tsr = _data.get('tsr');
    params.events = [];
    for (var i = 1; i <= 12; i++) {
      if (_data.get("eventMarker_".concat(i))) {
        params.events.push(i);
      }
    }
    if (_data.get('portfolioValueType')) {
      params.valuetype = _data.get('portfolioValueType').substring(0, 1);
      params.valueTypeString = _data.get('portfolioValueType').substring(1, _data.get('portfolioValueType').length);
    }
    params.perc = isGain() ? true : _data.get('scale') === 'perc';
    params.log = params.perc === false && _data.get('scale') === 'log';
    params.hist = params.p.indexOf('m') < 0;

    /* Height - has to be set before width is calculated */
    params.h = getMainChartHeight(config.heightString);
    params.noLegend = _data.get('showInformation') === 'hide';
    params.currency = _data.get('currency');
    params.currency1 = _data.get('currency1');
    params.currency2 = _data.get('currency2');
    params.currency3 = _data.get('currency3');
    params.currency4 = _data.get('currency4');
    if (isSavedParams !== true) {
      Object.assign(params, getRicParameter());
    }

    /* Moving average */
    params.ema1 = getOptionalValue('EMAIndicator1CheckBox', 'EMAIndicator1');
    params.ema2 = getOptionalValue('EMAIndicator2CheckBox', 'EMAIndicator2');
    params.sma1 = getOptionalValue('SMAIndicator1CheckBox', 'SMAIndicator1');
    params.sma2 = getOptionalValue('SMAIndicator2CheckBox', 'SMAIndicator2');

    /* indicators */
    params.indicatorLines = [_data.get('showZigZagIndicator') ? 'zigzag' : null, _data.get('showEnvelops') ? 'envelopes' : null, _data.get('showBollingerBands') ? 'bollingerbands' : null, _data.get('showParabolicSARIndicator') ? 'sarparabolic' : null].filter(function (f) {
      return f;
    });
    params.indicatorCharts = [getOptionalValue('indicator1CheckBox', 'indicator1ChartType'), getOptionalValue('indicator2CheckBox', 'indicator2ChartType')].filter(function (f) {
      return f;
    });
    return params;
  };
  var initializeBenchmarkSelection = function initializeBenchmarkSelection(selectionArray) {
    if (!selectionArray.length) {
      return;
    }
    var notFoundArray = [];
    for (var i = 0; i < selectionArray.length; i++) {
      var item = selectionArray[i];
      var value = item.value || '';
      var toggleValue = item.value != null && !item.doReset;
      var menu = _data.getElement(item.menu);
      if (menu) {
        if (!value && !item.doReset) {
          if (window.Lang.isFunction(menu.hasValue)) {
            _data.set(item.checkbox, toggleValue);
            _data.set(item.menu, '');
          }
          continue;
        } else if (window.Lang.isFunction(menu.hasValue) && menu.hasValue(value) && !item.doReset) {
          _data.set(item.menu, value);
          _data.set(item.checkbox, toggleValue);
          var text = menu.getSelectedText();
          if (config.popupSearchEnabled) {
            item.searchInput.setHasFound(true);
            item.searchInput.lastSearchResult = {
              value: value,
              text: text
            };
            item.searchInput.lastTextFieldContent = text;
            item.searchInput.setTextChanged(false);
          }
        } else if (item.doReset) {
          item.searchInput.textField.reset();
          _data.set(item.checkbox, false);
          item.searchInput.resetImageClickFunction();
        } else {
          notFoundArray.push(item);
        }
      }
    }
    notFoundArray.forEach(initializeUnknownBenchmarkEntry);
  };
  var initializeUnknownBenchmarkEntry = function initializeUnknownBenchmarkEntry(item) {
    if (config.popupSearchEnabled) {
      item.searchInput.searchValue(item.value, function (result) {
        if (result.found) {
          item.searchInput.textField.setComboValueAndText(item.value, result.data.displayName);
          _data.set(item.menu, item.value);
          _data.set(item.checkbox, !item.doReset);
          item.searchInput.setHasFound(true);
          item.searchInput.lastSearchResult = {
            value: item.value,
            text: result.data.displayName
          };
          item.searchInput.lastTextFieldContent = result.data.displayName;
          item.searchInput.setTextChanged(false);
        } else {
          item.searchInput.textField.setComboValueAndText(item.value, item.value);
          _data.set(item.menu, item.value);
          _data.set(item.checkbox, !item.doReset);
          item.searchInput.setHasFound(true);
          item.searchInput.lastSearchResult = {
            value: item.value,
            text: item.value
          };
          item.searchInput.lastTextFieldContent = item.value;
          item.searchInput.setTextChanged(false);
        }
      });
    }
  };

  /*
   * Fill the control panel according to the chart parameters.
   *
   * @param {LargeChartParametersClass} mainParams
   */
  var setControlPanel = function setControlPanel(mainParams, doReset) {
    if (!_data.get('ric')) {
      _data.set('ric', mainParams.RIC);
    }
    if (_data.getElement('chartType')) {
      _data.set('chartType', mainParams.type);
    }
    if (_data.getElement('tsr')) {
      _data.set('tsr', mainParams.tsr);
    }
    if (_data.getElement('showInformation')) {
      if (mainParams.noLegend) {
        _data.set('showInformation', 'hide');
      } else {
        _data.set('showInformation', 'show');
      }
    }
    var menuSelectionArray = [];
    [1, 2, 3, 4].forEach(function (benchmarkNumber) {
      if (_data.getElement("Benchmark".concat(benchmarkNumber, "CheckBox"))) {
        menuSelectionArray.push({
          menu: config.popupSearchEnabled ? "Benchmark".concat(benchmarkNumber, "_search") : "Benchmark".concat(benchmarkNumber),
          checkbox: "Benchmark".concat(benchmarkNumber, "CheckBox"),
          value: mainParams["b".concat(benchmarkNumber - 1)],
          searchInput: window["".concat(elemIdprefix, "Benchmark").concat(benchmarkNumber, "SearchInput")],
          doReset: doReset
        });
      }
    });
    initializeBenchmarkSelection(menuSelectionArray);
    disableNonPercentualScales(false);
    if (!mainParams.eventMarkers) {
      for (var i = 1; i <= 12; i++) {
        _data.set("eventMarker_".concat(i), false);
      }
    }

    /* extra chart indicators */
    for (var _i = 0; _i < 2; _i++) {
      if (mainParams.indicatorCharts && mainParams.indicatorCharts[_i]) {
        _data.set("indicator".concat(_i + 1, "ChartType"), mainParams.indicatorCharts[_i]);
        _data.set("indicator".concat(_i + 1, "CheckBox"), true);
      } else {
        _data.set("indicator".concat(_i + 1, "ChartType"), '');
        _data.set("indicator".concat(_i + 1, "CheckBox"), false);
      }
    }

    /* indicators */
    var defIndicators = {
      showZigZagIndicator: false,
      showEnvelops: false,
      showBollingerBands: false,
      showParabolicSARIndicator: false
    };
    if (mainParams.indicatorLines) {
      defIndicators.showZigZagIndicator = mainParams.indicatorLines.includes('zigzag');
      defIndicators.showEnvelops = mainParams.indicatorLines.includes('envelopes');
      defIndicators.showBollingerBands = mainParams.indicatorLines.includes('bollingerbands');
      defIndicators.showParabolicSARIndicator = mainParams.indicatorLines.includes('sarparabolic');
    }
    _data.set('showZigZagIndicator', defIndicators.showZigZagIndicator);
    _data.set('showEnvelops', defIndicators.showEnvelops);
    _data.set('showBollingerBands', defIndicators.showBollingerBands);
    _data.set('showParabolicSARIndicator', defIndicators.showParabolicSARIndicator);

    /* average */
    if (_data.getElement('SMAIndicator1')) {
      _data.set('SMAIndicator1', mainParams.sma1 || '38');
      _data.set('SMAIndicator1CheckBox', !!mainParams.sma1);
    }
    if (_data.getElement('SMAIndicator2')) {
      _data.set('SMAIndicator2', mainParams.sma2 || '100');
      _data.set('SMAIndicator2CheckBox', !!mainParams.sma2);
    }
    if (_data.getElement('EMAIndicator1')) {
      _data.set('EMAIndicator1', mainParams.ema1 || '38');
      _data.set('EMAIndicator1CheckBox', !!mainParams.ema1);
    }
    if (_data.getElement('EMAIndicator2')) {
      _data.set('EMAIndicator2', mainParams.ema2 || '100');
      _data.set('EMAIndicator2CheckBox', !!mainParams.ema2);
    }
    _data.set('periodicity', mainParams.p);
    if (config.ecetraKAGFunds) {
      _data.set('scale', 'perc');
    } else if (_data.getElement('scale')) {
      if (mainParams.perc) {
        _data.set('scale', 'perc');
      } else if (mainParams.log) {
        _data.set('scale', 'log');
      } else {
        _data.set('scale', 'abs');
      }
    }
    if (mainParams.sd && mainParams.ed) {
      disableInvalidPeriodicities(mainParams.sd, mainParams.ed, _data.getElement('periodicity'), config.historyOnly);
    }
    _data.set('currency', mainParams.currency || null);
    _data.set('currency1', mainParams.currency1 || null);
    _data.set('currency2', mainParams.currency2 || null);
    _data.set('currency3', mainParams.currency3 || null);
    _data.set('currency4', mainParams.currency4 || null);
    checkChartType();
    checkTsr();
    setTsrValue(mainParams);
    if (!mainParams.n) {
      mainParams.n = 365;
    }
    if (_data.get('numberOfPeriods') != mainParams.n) {
      _data.set('numberOfPeriods', mainParams.n);
    } else {
      dateChanged(mainParams.n);
    }
  };
  var setTsrValue = function setTsrValue(mainParams) {
    if (mainParams.tsr) {
      var tsrCheckbox = _data.getElement('tsr');
      tsrCheckbox.disabled = false;
      _data.set('tsr', mainParams.tsr);
    }
  };

  /*
   * Disable or Enable all non-percentual-scales
   *
   * @param {Boolean} true, if all non-percentual-scales should be disables / false, if they should be enabled.
   */
  function disableNonPercentualScales(disable) {
    var scaleSelect = _data.getElement('scale');
    if (scaleSelect) {
      var scaleItems = scaleSelect.getItems();
      for (var i = 0; i < scaleItems.length; i++) {
        var item = scaleItems[i];
        if (item.value !== 'perc') {
          item.cfg.setProperty('disabled', disable);
        }
      }
    }
  }

  /*
   * Calculates the height for the main chart.
   * @param {String} chartAreaHeight the height of the total chart area.
   * Value can be in percent. Examples: <tt>'200'<tt> (200 pixels) or <tt>'50%'</tt>.
   * @return {Number}
   */
  var getMainChartHeight = function getMainChartHeight(chartAreaHeight) {
    if (String(chartAreaHeight).includes('%')) {
      // percentual height
      var maxHeight = window.Dom.getViewportHeight() - 350;
      return Math.max(600, parseInt(parseInt(chartAreaHeight.substring(0, chartAreaHeight.length - 1), 10) * maxHeight / 100, 10));
    } else {
      return chartAreaHeight;
    }
  };

  /*
   * Returns the value of the menu if the fitting checkbox is selected. Returns null if nothing is selected.
   * @param {String} checkboxKey
   * @param {String} menuKey
   * @return null if nothing was selected or checkbox is not active
   */
  var getOptionalValue = function getOptionalValue(checkboxKey, menuKey) {
    return _data.get(checkboxKey) ? _data.get(menuKey) || null : null;
  };

  /*
   * Returns the number of days between startDate and endDate
   * @param {fcom.date.DateTime} startDate
   * @param {fcom.date.DateTime} endDate
   */
  var getNumberOfDays = function getNumberOfDays(startDate, endDate) {
    try {
      var ed = new fcom.date.DateTime().setTimestamp(endDate.getTimestamp()).setCalendar({
        hour: 23,
        minute: 59
      });
      return Math.round((ed.getTimestamp() - startDate.getTimestamp()) / (1000 * 60 * 60 * 24));
    } catch (e) {
      // return 1 for intraday chart if invalid dates are passed
      return 1;
    }
  };

  /*
   * Returns the start date and end date for a given period of days.
   * @param {Number} period period in days
   * @param {Date} End date with attributes timezone and timestamp
   */
  var getDatesForPeriod = function getDatesForPeriod(period, _ed) {
    var ed = _ed ? new fcom.date.DateTime(_ed.timezone, _ed.timestamp) : new fcom.date.DateTime().clearTime();
    var sd = _ed ? new fcom.date.DateTime(_ed.timezone, _ed.timestamp).addCalendar({
      day: -(period - 1)
    }) : new fcom.date.DateTime().clearTime().addCalendar({
      day: -(period - 1)
    });
    return {
      ed: ed,
      sd: sd
    };
  };
  var convertAttributesFromDBDefaultToSmartChartReadableConfig = function convertAttributesFromDBDefaultToSmartChartReadableConfig(attributesFromDB) {
    var smartChartReadableConfig = {};
    if (attributesFromDB) {
      smartChartReadableConfig.RIC = attributesFromDB.symbol || config.ricArray[0];
      smartChartReadableConfig.type = attributesFromDB.chartType || 'line';
      smartChartReadableConfig.n = attributesFromDB.period || '30';
      smartChartReadableConfig.p = attributesFromDB.periodicity || 'D';
      smartChartReadableConfig.noLegend = !attributesFromDB.showInfos;
      smartChartReadableConfig.perc = attributesFromDB.scale === 'perc';
      smartChartReadableConfig.log = attributesFromDB.scale === 'log';
      smartChartReadableConfig.sma1 = attributesFromDB.sma1;
      smartChartReadableConfig.sma2 = attributesFromDB.sma2;
      smartChartReadableConfig.ema1 = attributesFromDB.ema1;
      smartChartReadableConfig.ema2 = attributesFromDB.ema2;
      smartChartReadableConfig.b0 = attributesFromDB.benchmark1;
      smartChartReadableConfig.b1 = attributesFromDB.benchmark2;
      smartChartReadableConfig.b2 = attributesFromDB.benchmark3;
      smartChartReadableConfig.b3 = attributesFromDB.benchmark4;
      smartChartReadableConfig.tsr = attributesFromDB.calculationAdjustment;
      smartChartReadableConfig.currency = attributesFromDB.currency;
      smartChartReadableConfig.currency1 = attributesFromDB.currency1;
      smartChartReadableConfig.currency2 = attributesFromDB.currency2;
      smartChartReadableConfig.currency3 = attributesFromDB.currency3;
      smartChartReadableConfig.currency4 = attributesFromDB.currency4;
      smartChartReadableConfig.indicatorLines = [];
      if (attributesFromDB.zigZagIndicator) {
        smartChartReadableConfig.indicatorLines.push('zigzag');
      }
      if (attributesFromDB.bollingerBandsIndicator) {
        smartChartReadableConfig.indicatorLines.push('bollingerbands');
      }
      if (attributesFromDB.envelopesIndicator) {
        smartChartReadableConfig.indicatorLines.push('envelopes');
      }
      if (attributesFromDB.sarParabolicIndicator) {
        smartChartReadableConfig.indicatorLines.push('sarparabolic');
      }
      smartChartReadableConfig.indicatorCharts = [];
      if (attributesFromDB.indicator1) {
        smartChartReadableConfig.indicatorCharts = attributesFromDB.indicator1;
      }
      if (attributesFromDB.indicator2) {
        smartChartReadableConfig.indicatorCharts = attributesFromDB.indicator2;
      }
    }
    return smartChartReadableConfig;
  };

  /*
   * Save chart settings according to persistence configuration
   * @param {String} id
   * @param {Object} value
   */
  var saveChartSettings = function saveChartSettings(id, value) {
    if (id == 'main' && typeof options.saveSettingsCallback == 'function') {
      options.saveSettingsCallback(value);
      config.params = value;
      return;
    }
    fcom.util.PersistenceHelper.setCookie("".concat(options.moduleId, "_").concat(id), value);
  };
  var isTsrActive = function isTsrActive() {
    return _data.get('tsr');
  };
  var checkTsr = function checkTsr() {
    var tsrCheckbox = _data.getElement('tsr');
    if (!tsrCheckbox) {
      return;
    }
    if (_data.get('periodicity').indexOf('m') >= 0) {
      // Intraday
      doDisableTsr(tsrCheckbox);
    } else {
      checkFundPerformanceModeRics(tsrCheckbox);
    }
  };
  var checkEventMarkers = function checkEventMarkers() {
    var eventCheckBox = _data.getElement('eventMarkers');
    if (!eventCheckBox) {
      return;
    }
    if (isBenchmarkActive()) {
      if (eventCheckBox.disabled) {} else {
        eventCheckBox.lastSelectedValue = _data.get('eventMarkers');
        _data.set('eventMarkers', false);
        setDisabled(eventCheckBox);
        for (var i = 1; i <= 12; i++) {
          var elementId = "eventMarker_".concat(i);
          var eventMarkerCheckBox = _data.getElement(elementId);
          eventMarkerCheckBox.lastSelectedValue = _data.get(elementId);
          _data.set(elementId, false);
          setDisabled(eventMarkerCheckBox);
        }
      }
    } else if (eventCheckBox.disabled) {
      setDisabled(eventCheckBox, false);
      _data.set('eventMarkers', eventCheckBox.lastSelectedValue);
      for (var _i2 = 1; _i2 <= 12; _i2++) {
        var _elementId = "eventMarker_".concat(_i2);
        var _eventMarkerCheckBox = _data.getElement(_elementId);
        setDisabled(_eventMarkerCheckBox, false);
        _data.set(_elementId, _eventMarkerCheckBox.lastSelectedValue);
      }
    }
  };
  var lastCheckedRics;
  var hasTsrRic = {};
  var checkFundPerformanceModeRics = function checkFundPerformanceModeRics(tsrCheckbox) {
    var rics = getAllRics();
    var jrics = rics.join('|');
    if (jrics !== lastCheckedRics) {
      // Prevent multiple queries with the same rics
      lastCheckedRics = jrics;
      window.ajaxGetJson('/ajax.action', {
        method: 'checkAreRicsPerformanceCapable',
        rics: rics
      }).then(function (response) {
        return Object.keys(response).reduce(function (all, key) {
          return response[key] || all;
        }, null);
      }).then(function (hasTsrRics) {
        hasTsrRic[jrics] = hasTsrRics;
        if (hasTsrRics) {
          doEnableTsr(tsrCheckbox);
        } else {
          doDisableTsr(tsrCheckbox);
        }
      });
    } else if (hasTsrRic[jrics]) {
      doEnableTsr(tsrCheckbox);
    } else {
      doDisableTsr(tsrCheckbox);
    }
  };
  var doDisableTsr = function doDisableTsr(tsrCheckbox) {
    if (tsrCheckbox.disabled) {
      // is already disabled
      return;
    }
    tsrCheckbox.lastSelectedValue = _data.get('tsr');
    setDisabled(tsrCheckbox);
    _data.set('tsr', false);
  };
  var setDisabled = function setDisabled(checkBox, disabled) {
    disabled = disabled !== false;
    checkBox.disabled = disabled;
    if (checkBox.checked) {
      checkBox.checked = false;
    }
  };
  var doEnableTsr = function doEnableTsr(tsrCheckbox) {
    if (!tsrCheckbox.disabled ||
    // is already enabled
    _data.get('periodicity').indexOf('m') >= 0) {
      // No need to enable for Intraday
      return;
    }
    tsrCheckbox.disabled = false;
    _data.set('tsr', tsrCheckbox.lastSelectedValue);
  };
  var getAllRics = function getAllRics() {
    var chartParams = getRicParameter(true);
    return ['RIC', 'b0', 'b1', 'b2', 'b3'].map(function (a) {
      return chartParams[a];
    }).filter(function (f) {
      return f;
    });
  };

  /*
   * Date settings for the chart have been changed.
   * @param {String|Number} [period]
   */
  var dateChanged = function dateChanged(period) {
    period = period !== undefined ? Number(period) : period;
    if (period > 0) {
      // period menu or chart tab changed
      if (!config.advancedChart && Number(_data.get('numberOfPeriods')) !== period) {
        _data.set('numberOfPeriods', period);
      }
      var dates = getDatesForPeriod(period);
      _data.set('endDate', dates.ed);
      _data.set('startDate', dates.sd);
      if (+period === timePeriodDays[timePeriodDays.length - 1]) {
        // max years
        _data.getElement('startDate').hideDateFromInputField();
      }
    } else if (period === 0) {
      var startOfYear = new fcom.date.DateTime().setCalendar({
        year: new Date().getFullYear(),
        month: 0,
        day: 1
      });
      _data.set('startDate', startOfYear);
      _data.set('endDate', new fcom.date.DateTime().clearTime());
    } else {
      var periodMenu = _data.getElement('numberOfPeriods');
      period = getNumberOfDays(_data.get('startDate'), _data.get('endDate'));
      // only try to set a value in the periodMenu if the end date is today, for consistent behaviour
      if (!isEndToday() || !periodMenu.hasValue(period)) {
        period = -1;
      }
      if (_data.get('numberOfPeriods') != period) {
        _data.set('numberOfPeriods', period);
      }
      checkPeriodAndChartType();
      if (!_data.get('startDate') || !_data.get('endDate')) {
        checkCurrencyConversion(true);
      }
    }

    // adjust periodicity for the updated startDate and endDate
    try {
      disableInvalidPeriodicities(_data.get('startDate'), _data.get('endDate'), _data.getElement('periodicity'), config.historyOnly);
    } catch (e) {
      // do nothing - this can happen when start and end date are null for intraday charts
    }
    checkChartType();
    disableInvalidChartTypes();
    checkTsr();
  };
  var disableInvalidPeriodicities = function disableInvalidPeriodicities(startDate, endDate, periodicitySelect, historyOnly) {
    var now = new fcom.date.DateTime();
    var realDaysToNow = (now.getTimestamp() - startDate.getTimestamp()) / (1000 * 60 * 60 * 24);
    var realDaysToEndDate = (endDate.getTimestamp() - startDate.getTimestamp()) / (1000 * 60 * 60 * 24);
    var isIntraday = realDaysToNow <= 14 && !historyOnly;
    checkCurrencyConversion(isIntraday);
    var mapping = isIntraday ? window.mappingIntraday : window.mappingNoIntraday;
    var interval = isIntraday ? realDaysToNow : realDaysToEndDate;
    window.chartPeriodicityMapping.forEach(function (periodicity, index) {
      var disable = mapping.minDays[index] > interval || mapping.maxDays[index] < interval;
      if (disable && _data.get('periodicity') === periodicity) {
        _data.set('periodicity', window.getPeriodicityFromDates(_data.get('startDate'), _data.get('endDate'), null, config.historyOnly));
      }
      periodicitySelect.getItems()[index].cfg.setProperty('disabled', disable);
    });
  };

  /*
   * Returns whether a benchmark is currently active
   * @return {Boolean}
   */
  var isBenchmarkActive = function isBenchmarkActive() {
    return getOptionalValue('Benchmark1CheckBox', 'Benchmark1_search') != null || getOptionalValue('Benchmark2CheckBox', 'Benchmark2_search') != null || getOptionalValue('Benchmark3CheckBox', 'Benchmark3_search') != null || getOptionalValue('Benchmark4CheckBox', 'Benchmark4_search') != null;
  };

  /*
   * Returns how many benchmarks are currently active
   * @return {Boolean}
   */
  var countBenchmarkActive = function countBenchmarkActive() {
    var counter = 0;
    for (var i = 1; i <= 4; i++) {
      if (getOptionalValue("Benchmark".concat(i, "CheckBox"), "Benchmark".concat(i, "_search")) != null) {
        counter++;
      }
    }
    return counter;
  };

  /*
   * Handler for benchmark changes.
   * If a benchmark is active, the scaling is automatically set to absolute.
   * @param {YAHOO.fcom.Checkbox} checkbox
   * @param {YAHOO.fcom.DropMenu} menu
   */
  var benchmarkCheckboxChanged = function benchmarkCheckboxChanged(checkbox, menuKey) {
    var checked = checkbox && _data.get(checkbox);
    var menu = _data.getElement(menuKey);
    var value = menu.getSelectedValue();

    // This is useful please dont delete
    // console.log("benchmarkCheckboxChanged", checkbox, countBenchmarkActive(), value);

    // Note: this somehow works. dont ask me how
    if (checked && value && countBenchmarkActive() < 2) {
      var scale = isBenchmarkActive() || isTsrActive() || config.ecetraKAGFunds ? 'perc' : 'abs';
      _data.set('scale', scale);
    }
    if (!isGain()) {
      disableScales('perc', false);
    }
    checkTsr();
    checkEventMarkers();
    refreshChart();
  };

  /*
   * Handler for benchmark changes.
   * If a benchmark is active, the scaling is automatically set to absolute.
   * @param {YAHOO.fcom.Checkbox} checkbox
   * @param {YAHOO.fcom.DropMenu} menu
   */
  var benchmarkChanged = function benchmarkChanged(checkbox, menuKey, currency) {
    var value;
    if (menuKey && checkbox) {
      var menu = _data.getElement(menuKey);
      value = menu.getSelectedValue();
      _data.set(checkbox, value);
    }
    var checked = _data.get(checkbox);

    // This is useful please dont delete
    // console.log("benchmarkChanged", checkbox, countBenchmarkActive(), value);

    // Note: this somehow works. dont ask me how
    if (checked && value && countBenchmarkActive() < 2) {
      var scale = isBenchmarkActive() || isTsrActive() || config.ecetraKAGFunds ? 'perc' : 'abs';
      _data.set('scale', scale);
    }
    if (!isGain()) {
      disableScales('perc', false);
    }
    checkTsr();
    checkEventMarkers();
    refreshChart();
  };

  /*
   * Handler for indicator diagram changes.
   * @param {YAHOO.fcom.Checkbox} checkbox
   * @param {YAHOO.fcom.DropMenu} menu
   */
  var indicatorChanged = function indicatorChanged(checkbox, menuKey) {
    if (menuKey && checkbox) {
      var menu = _data.getElement(menuKey);
      _data.set(checkbox, menu.getSelectedValue());
    }
    refreshChart();
  };

  /**
   * checks if portfolioValueType is Gain
   */
  var isGain = function isGain() {
    return _data.get('portfolioValueType') ? _data.get('portfolioValueType').substring(0, 1) === '2' : false;
  };

  /*
   * Disable or Enable all non-percentual-scales
   *
   * @param {Boolean} true, if all non-percentual-scales should be disables / false, if they should be enabled.
   */
  var disableScales = function disableScales(type, disable) {
    var scaleSelect = _data.getElement('scale');
    if (scaleSelect) {
      var scaleItems = scaleSelect.getItems();
      scaleItems.forEach(function (item) {
        if (item.value !== type) {
          item.cfg.setProperty('disabled', disable);
        } else {
          item.cfg.setProperty('disabled', false);
        }
      });
    }
  };
  var checkCurrencyConversion = function checkCurrencyConversion(disable) {
    var currencySelectArray = [_data.getElement('currency'), _data.getElement('currency1'), _data.getElement('currency2'), _data.getElement('currency3'), _data.getElement('currency4')];
    currencySelectArray.forEach(function (currencySelect) {
      if (disable) {
        currencySelect.disable();
        currencySelect.selectByValue('');
      } else {
        currencySelect.enable();
      }
    });
  };
  var setChartTitle = function setChartTitle(ricname) {
    var title = "".concat(config.moduleTitlePrefix || '', " ").concat(ricname);
    $moduleTitle.text(title);
  };

  /*
   * Reset the chart control panel with the initial settings.
   * Persistent chart settings are overwritten.
   */
  var resetChart = function resetChart() {
    // get defaults without saved parameters
    var defaults = defaultParams(false);
    var defaultsDB = convertAttributesFromDBDefaultToSmartChartReadableConfig(config.defaultConfig);
    Object.assign(defaults, defaultsDB);
    defaults.eventMarkers = false;
    setControlPanel(defaults, true);
    if (defaults.RIC) {
      setTitleWithRic(defaults.RIC);
    }
    refreshChart();
  };
  var setTitleWithRic = function setTitleWithRic(ric) {
    var fireItemFoundEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var postData = "&ric=".concat(ric);
    var callback = {
      success: function success(response) {
        var data = JSON.parse(response.responseText);
        if (searchHandler) {
          searchHandler.setText(data.short);
          searchHandler.setValue(ric);
          searchHandler.setHasFound(true);
          if (fireItemFoundEvent) {
            searchHandler.itemFoundEvent.fire({
              value: ric,
              typeOfId: 'ric'
            });
          }
        }
        setChartTitle(data.short);
      }
    };
    window.ngpAsyncRequest('POST', '/ajax.action?method=getInstrumentName', callback, postData);
  };
  var verticalExpander;
  var toggleHandler = function toggleHandler() {
    if (verticalExpander.opened) {
      YAHOO.util.Dom.addClass("".concat(elemIdprefix, "verticalExpanderContainer"), 'open');
      YAHOO.util.Dom.removeClass("".concat(elemIdprefix, "verticalExpanderContainer"), 'close');
    } else {
      YAHOO.util.Dom.removeClass("".concat(elemIdprefix, "verticalExpanderContainer"), 'open');
      YAHOO.util.Dom.addClass("".concat(elemIdprefix, "verticalExpanderContainer"), 'close');
    }
    saveChartSettings('exp', {
      opened: verticalExpander.opened
    });
  };
  var associateDateLabelsWithFirstInput = function associateDateLabelsWithFirstInput() {
    var firstInputs = $('span.calendar').find('input:first-child');
    $(firstInputs).each(function (index, input) {
      var elId = $(input).attr('id');
      var inputLabel = $(input).parents('form tr').find('label');
      $(inputLabel).attr('for', elId);
    });
  };
  var intradayChartOnly = function intradayChartOnly() {
    var chartTypeValue = _data.get('chartType');
    var periodMenu = _data.getElement('numberOfPeriods');
    var periodMenuItems = periodMenu.getItems();
    if (chartTypeValue === 'bidask') {
      _data.set('numberOfPeriods', 1);
      periodMenuItems.forEach(function (item) {
        var value = +item.value;
        if (!value || value > 14) {
          item.cfg.setProperty('disabled', true);
        }
      });
    } else {
      periodMenuItems.forEach(function (item) {
        var value = +item.value;
        if (value === 0 || item.value >= 30) {
          item.cfg.setProperty('disabled', false);
        }
      });
    }
  };
  var checkPeriodAndChartType = function checkPeriodAndChartType() {
    var chartTypeValue = _data.get('chartType');
    var numberOfPeriods = _data.get('numberOfPeriods');
    if (numberOfPeriods > 30 && chartTypeValue === 'bidask') {
      _data.set('chartType', 'line');
    }
  };
  var isEndToday = function isEndToday() {
    var endDayIsToday;
    try {
      endDayIsToday = !Math.floor((new fcom.date.DateTime().getTimestamp() - _data.get('endDate').getTimestamp()) / (1000 * 60 * 60 * 24));
    } catch (e) {
      endDayIsToday = true;
    }
    return endDayIsToday;
  };
  var updateRic = function updateRic(ric) {
    searchHandler.setText(ric);
    setTitleWithRic(ric, true);
  };
  var init = function init() {
    var defaultConfig = convertAttributesFromDBDefaultToSmartChartReadableConfig(config.defaultConfig);
    if (!config.params) {
      config.params = {};
    }
    config.params = Object.assign(defaultConfig, config.params);
    config.params.RIC = config.mainRic;

    /* @type YAHOO.widget.Button */
    var resetBtn = YAHOO.fcom.Page.getInstance("".concat(elemIdprefix, "resetBtn"));
    resetBtn.addListener('click', resetChart);

    /* Vertical expander for the control panel */
    verticalExpander = new YAHOO.fcom.ui.Expander({
      id: "".concat(elemIdprefix, "verticalExpander"),
      switchEl: "".concat(elemIdprefix, "verticalExpander"),
      expanderEl: "".concat(elemIdprefix, "chartControls"),
      openTooltip: window.getMessage('expanderBar.open'),
      closeTooltip: window.getMessage('expanderBar.close'),
      opened: true
    });
    var initExp = loadChartSettings('exp');
    if (initExp && initExp.opened === false) {
      verticalExpander.toggle(false, false);
    }
    verticalExpander.onExpand.subscribe(toggleHandler);
    verticalExpander.onCollapse.subscribe(toggleHandler);
    if (!initExp || initExp.opened !== false) {
      YAHOO.util.Dom.addClass("".concat(elemIdprefix, "verticalExpanderContainer"), 'open');
    } else {
      YAHOO.util.Dom.addClass("".concat(elemIdprefix, "verticalExpanderContainer"), 'close');
    }
    $chartContainer.data('module-jsconfig', '{"zoom": true, "showLegend": true}');
    $chartContainer.data('module-libconfig', '{"title":""}');
    $moduleNode = document.getElementById("".concat(elemIdprefix, "InstrumentChartModule_large"));
    chartModulePromise = window.fcom.moduleHandler.initModule($moduleNode);
    if (typeof config.params.sd === "string") {
      config.params.sd = new fcom.date.DateTime().parse(config.params.sd, SMART_CHART_DATE_SAVE_FORMAT);
    }
    if (typeof config.params.ed === "string") {
      config.params.ed = new fcom.date.DateTime().parse(config.params.ed, SMART_CHART_DATE_SAVE_FORMAT);
    }
    setControlPanel(config.params);
    refreshChart();
    associateDateLabelsWithFirstInput();

    // #. init accordion accessibility
    window.fcom.Accessibility.init({
      accordion: {
        container: $(verticalExpander.expanderEl),
        toggleSelector: '.tableToggleBar button.toggleBar',
        findPanelBy: {
          method: 'parent next'
        }
      }
    });
    if (searchHandler) {
      searchHandler.itemFoundEvent.subscribe(function () {
        var ricName = searchHandler.textField.value;
        if (!ricName || ricName === 'undefined') {
          ricName = searchHandler.valueField.value;
          if (ricName) {
            setTitleWithRic(ricName);
          }
          return;
        }
        setChartTitle(ricName);
      });
    }
  };
  init();
  return {
    refreshChart: refreshChart,
    updateRic: updateRic
  };
};
var _default = exports.default = SmartChartModule;

},{"util/functions/runFunctionDebounced":146}],123:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var YAHOO = window.YAHOO;
var TimeAndSalesDataModule = function TimeAndSalesDataModule(node, config, themeConfig) {
  var _this = this;
  config.theme = themeConfig;
  var viewId = window.YAHOO.fcom.Page.getInstance('moduleContainer').id;
  var moduleId = node.id;
  var saveBtn = window.YAHOO.widget.Button.getButton("".concat(moduleId, "_saveBtn"));
  var reloadInProgress = false;
  var fromDate = $("#".concat(moduleId, "_fromDate")).val();
  var toDate = $("#".concat(moduleId, "_toDate")).val();
  var fromDateMs = Date.parse(fromDate);
  var toDateMs = Date.parse(toDate);

  // This function reloads the content
  var reloadTimeSalesModule = function reloadTimeSalesModule() {
    var itemElement = Dom.get(moduleId);
    if (itemElement === null) {
      window.location.reload();
    } else {
      var _url = "/view.action?method=getModule&moduleId=".concat(moduleId, "&viewId=").concat(viewId, "&popout='false'");
      var params = {
        replaceContainer: true,
        callback: function callback() {
          var columnContainer = YAHOO.fcom.Page.getInstance('moduleContainer');
          columnContainer.updateItem(moduleId);
        }
      };
      window.replaceAsync(_url, itemElement, params, true, true);
    }
  };
  var saveValues = function saveValues(refresh) {
    if (reloadInProgress) {
      return;
    }
    reloadInProgress = true;
    var ric = $("#".concat(moduleId, "_searchRicPopup__hidden")).val();
    var fromDate = $("#".concat(moduleId, "_fromDate")).val();
    var toDate = $("#".concat(moduleId, "_toDate")).val();
    fromDateMs = Date.parse(fromDate);
    toDateMs = Date.parse(toDate);
    if (refresh) {
      // refresh button clicked, change to date to current date and time
      toDateMs = Date.now();
    }
    var formName = 'moduleChangeForm';
    var form = document.getElementById(formName);
    var postData = {
      method: 'changeModule',
      viewId: viewId,
      moduleId: moduleId,
      ric: ric,
      startTime: fromDateMs,
      endTime: toDateMs
    };
    var url = '/module.action';
    var reloadCallback = function reloadCallback() {
      window.reloadModuleContent(moduleId, viewId, "".concat(moduleId, "_datatable"), ric).then(function () {
        config.ric = ric;
        reloadTimeSalesModule();
        reloadInProgress = false;
      });
    };
    window.ngpAsyncRequest('POST', url, reloadCallback, postData, form, false, false);
    $("#".concat(moduleId, "_datatable")).hide();
    $("#".concat(moduleId, "_display_progress")).show();
  };
  var saveKeyupEventListener = function saveKeyupEventListener(event) {
    if (event.keyCode === 13) {
      saveValues();
    }
  };
  saveBtn.addListener('click', function () {
    saveValues(true);
  });
  saveBtn.addListener('keyup', saveKeyupEventListener);
  var searchHandler = YAHOO.fcom.Page.getInstance("".concat(moduleId, "_searchRicPopup"));
  if (searchHandler) {
    searchHandler.itemFoundEvent.subscribe(saveValues);
  }
  var fromDateHandler = YAHOO.fcom.Page.getInstance("".concat(moduleId, "_fromDate"));
  if (fromDateHandler) {
    fromDateHandler.dateChanged.subscribe(function () {
      var fromDateObject = Date.parse($("#".concat(moduleId, "_fromDate")).val());
      var fromDateNotChanged = fromDateObject === fromDateMs;
      if (!fromDateNotChanged) {
        saveValues();
      }
    });
  }
  var toDateHandler = YAHOO.fcom.Page.getInstance("".concat(moduleId, "_toDate"));
  if (toDateHandler) {
    toDateHandler.dateChanged.subscribe(function () {
      var toDateObject = Date.parse($("#".concat(moduleId, "_toDate")).val());
      var toDateNotChanged = toDateObject === toDateMs;
      if (!toDateNotChanged) {
        saveValues();
      }
    });
  }

  // init receiver channel behaviour
  if (config.receiverChannel) {
    this['@broadcast'] = _defineProperty({}, config.receiverChannel, function (message) {
      if (message.messageType === 'ric') {
        $("#".concat(moduleId, "_searchRicPopup__hidden")).val(message.ric);
        $("#".concat(moduleId, "_searchRicPopup__text")).val(message.ric);
        $("#".concat(moduleId, "_searchRicPopup__text")).prop('title', message.ric);
        $("#".concat(moduleId, "_searchRicPopup__text")).prop('value', message.ric);
        saveValues();
      }
    });
  }
  this['@destroy'] = function () {
    saveBtn.removeListener('click', saveValues);
    saveBtn.removeListener('keyup', saveKeyupEventListener);
    searchHandler.itemFoundEvent.unsubscribe(saveValues);
    fromDateHandler.dateChanged.unsubscribe(saveValues);
    toDateHandler.dateChanged.unsubscribe(saveValues);
  };
  var myColumnDefs = [];
  $("#".concat(moduleId, "_datatable>table>thead>tr>th")).each(function (i, el) {
    var text = $(el).text();
    var colDef = {
      key: text,
      label: text,
      sortable: false
    };
    if (i === 0) {
      colDef.minWidth = 145;
    }
    myColumnDefs.push(colDef);
  });
  var updateDatatable = function updateDatatable() {
    _this.myDataSource = new YAHOO.util.DataSource($("#".concat(moduleId, "_datatable>table"))[0]);
    _this.myDataSource.responseType = YAHOO.util.DataSource.TYPE_HTMLTABLE;
    _this.myDataSource.responseSchema = {
      fields: myColumnDefs
    };
    _this.myDataTable = new YAHOO.widget.DataTable("".concat(moduleId, "_datatable"), myColumnDefs, _this.myDataSource, {
      paginator: new YAHOO.widget.Paginator({
        rowsPerPage: config.countRow,
        template: '{PreviousPageLink} <strong>{CurrentPageReport}</strong> {NextPageLink}',
        pageReportTemplate: window.getMessage('module.TimeAndSalesDataModule.tableControls.paging.template'),
        nextPageLinkLabel: window.getMessage('module.TimeAndSalesDataModule.tableControls.paging.next'),
        previousPageLinkLabel: window.getMessage('module.TimeAndSalesDataModule.tableControls.paging.previous')
      }),
      caption: $("#".concat(moduleId, "_datatable>table>caption")).text() || ''
    });
    _this.myDataTable.subscribe('initEvent', function () {
      $("#".concat(moduleId, "_datatable>table")).addClass('list table-sticky-header').attr('border', '0').attr('cellpadding', '0').attr('cellspacing', '0').css('min-width', '100%');
      $("#".concat(moduleId, "_datatable>table>caption")).addClass('visuallyhidden');
      $("#".concat(moduleId, "_display_progress")).hide();
      $("#".concat(moduleId, "_datatable")).show();
      window.setTimeout(function () {
        window.onElementResize.fire(moduleId);
        window.forceResizeEvent.fire();
      });
    });
  };
  updateDatatable();
};
window.fcom.moduleHandler.registerModuleType('TimeAndSalesDataModule', function (node, config, themeConfig) {
  return new TimeAndSalesDataModule(node, config, themeConfig);
}, true);
var _default = exports.default = TimeAndSalesDataModule;

},{}],124:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/*global YAHOO : true*/
/*global fcom : true*/
/*global window : true*/

var UpcomingEventsModule = function UpcomingEventsModule(node, config) {
  var tableId = "".concat(node.id, "_upcomingEventsList");
  this['@destroy'] = function () {
    return null;
  };
  if (config.receiverChannel) {
    this['@broadcast'] = _defineProperty({}, config.receiverChannel, function (message) {
      return onMessage(message);
    });
  }
  var isSupportedMessageType = function isSupportedMessageType(message) {
    var types = ['ric', 'multiRic', 'country', 'multiCountry']; // ric currently handled as string diectly
    return Boolean(message) && types.indexOf(message.messageType) > -1;
  };
  var onMessage = function onMessage(message) {
    if (message.senderId !== node.id) {
      var viewId = YAHOO.fcom.Page.getInstance('moduleContainer').id;
      if (message.messageType === 'ric') {
        window.reloadModuleContent(node.id, viewId, tableId, message.ric);
      } else if (isSupportedMessageType(message)) {
        window.reloadModuleContent(node.id, viewId, tableId, message);
      }
    }
  };
  YAHOO.fcom.LargeTableFactory.createLargeTable(tableId);
  YAHOO.fcom.LargeTableFactory.addListener(tableId, 'tableReady', function () {
    this.eventsList = YAHOO.fcom.LargeTableFactory.getInstance(tableId);
    this.eventsList.mouseoverRowEvent.subscribe(function (evt, args) {
      var rowData = args[0];
      var coords = args[1];
      if (rowData) {
        var data = JSON.parse(rowData.STREET_EVENT_DATA_KEY);
        tooltip.display(coords, data);
      }
    }, this, true);
    this.eventsList.mouseoutRowEvent.subscribe(function () {
      tooltip.hide();
    }, this, true);
  }, this, true, true);

  /*
   * Tooltip for upcoming events. Tooltips show all information abou the event.
   * @param {String} id
   * @param {} config panel config object
   */
  var UpcomingEventsTooltip = function UpcomingEventsTooltip(id, config) {
    this.config = config || {};
    YAHOO.lang.augmentObject(this.config, {
      constrainToViewport: true,
      delayShow: 500
    });
    UpcomingEventsTooltip.superclass.constructor.call(this, id, this.config);
    this.binding = fcom.util.DataBinding.link(YAHOO.util.Dom.get(id));
  };
  YAHOO.extend(UpcomingEventsTooltip, fcom.ui.Tooltip, {
    display: function display(coords, data) {
      this.binding.resetValues();
      this.binding.setValues(data);
      UpcomingEventsTooltip.superclass.display.call(this, null, coords);
    }
  });
  var tooltip = new UpcomingEventsTooltip("".concat(node.id, "_tooltip"), {});
};
fcom.moduleHandler.registerModuleType('UpcomingEventsModule', function (node, config) {
  return new UpcomingEventsModule(node, config);
}, true);

},{}],125:[function(require,module,exports){
"use strict";

var _TableExtensions = _interopRequireDefault(require("tables/TableExtensions"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
window.fcom.moduleHandler.registerModuleType('WatchlistModule', function (node, config) {
  var dropdownNodeId = "".concat(node.id, "_WatchlistSelectDropDown");
  var moduleId = node.id;
  var watchlistName = config.watchlistName;
  node.querySelectorAll('.select-instrument, .select-instrument-all').forEach(function (e) {
    e.disabled = !config.senderChannel;
  });
  $(node).on('change', "#".concat(dropdownNodeId), function () {
    var watchlistSelectDropDown = window.YAHOO.fcom.Page.getInstance("".concat(node.id, "_WatchlistSelectDropDown"));
    watchlistName = watchlistSelectDropDown.getSelectedValue().substring(2);
  });
  if (config.senderChannel) {
    $(node).click(function (event) {
      var possibleTargets = $(node).find('.select-instrument');
      if (possibleTargets.index($(event.target)) >= 0) {
        var message = {
          senderId: node.id,
          messageType: 'multiRic',
          rics: _getSelectedInstruments(node)
        };
        window.YAHOO.fcom.Broadcaster.sendMessage(config.senderChannel, message);
      }
    });
    $(node).on('click', '.select-instrument-all', function () {
      sendBroadcastAll($(node), config.senderChannel);
    });
    if ($(node).find('.select-instrument-all').is(':checked')) {
      sendBroadcastAll($(node), config.senderChannel);
    }
  }
  $(window).on('moduleReloaded', function (moduleInfo) {
    if (moduleInfo.moduleId === node.id) {
      initWatchlistInteraction({
        initWatchlistInteraction: initWatchlistInteraction,
        dropdownNodeId: "".concat(node.id, "_WatchlistSelectDropDown"),
        moduleId: "".concat(node.id)
      });
    }
  });
  $(node).on('inline-edit:initialize inline-edit:update', "table#".concat(moduleId, "_table-sub"), function (e) {
    (0, _TableExtensions.default)($(e.target));
  });
  var updateSelectedWatchlist = function updateSelectedWatchlist(scopeObjects) {
    var watchlistSelectDropDown = window.YAHOO.fcom.Page.getInstance(scopeObjects.dropdownNodeId);
    if (!watchlistSelectDropDown || watchlistSelectDropDown.getIsDisabled()) {
      // select was already unregistered or disabled?
      return; // do not send another ajax until the result of the last one arrives, that will also provide a new copy of the dropdown
    }

    var selectedWatchlistId = watchlistSelectDropDown.getSelectedValue().substring(2); // watchlists in that dropdown component are prefixed to distinguish from portfolios
    watchlistSelectDropDown.disable(); // disable, unregistering is done by page replace. Ajax will also provide a new copy of the dropdown
    var postData = {
      viewId: window.YAHOO.fcom.viewInfo.name,
      moduleId: scopeObjects.moduleId,
      watchlistId: selectedWatchlistId,
      viewOrgId: window.YAHOO.fcom.viewInfo.viewOrgId,
      viewProfile: window.YAHOO.fcom.viewInfo.viewProfile,
      isAdmin: window.YAHOO.fcom.viewInfo.isAdmin
    };
    window.replaceAsync('/module.action?method=changeAndReloadModule', $("div#".concat(scopeObjects.moduleId, "_div")).parent()[0], {
      showWait: true,
      postData: postData
    }, true // remove streaming registrations of old watchlist markup
    ).then(function () {
      watchlistName = selectedWatchlistId;
      var editAllowed = $("div#".concat(scopeObjects.moduleId, "_div")).attr('data-watchlist-edit-allowed') === "true";
      var $moduleNode = $("div#".concat(scopeObjects.moduleId));
      var jsconfig = $moduleNode.data("module-jsconfig");
      jsconfig.watchlistEditAllowed = editAllowed;
      $moduleNode.attr("data-module-jsconfig", JSON.stringify(jsconfig));
      $(window).trigger({
        type: 'moduleReloaded',
        moduleId: scopeObjects.moduleId,
        watchlistId: selectedWatchlistId,
        watchlistEditAllowed: editAllowed,
        inlineEditEnabled: jsconfig.inlineEditEnabled
      });
    }).catch(function () {
      console.warn('Reloading watchlist after dropdown change failed.');
      window.location.reload(); // do page reload instead
    });
  };

  var initWatchlistInteraction = function initWatchlistInteraction(scopeObjects) {
    window.YAHOO.fcom.Page.onInstanceReady(scopeObjects.dropdownNodeId, function (dropdown, scopeObjects) {
      var watchlistSelectDropDown = window.YAHOO.fcom.Page.getInstance(scopeObjects.dropdownNodeId);
      if (watchlistSelectDropDown) {
        watchlistSelectDropDown.changeEvent.subscribe(function (eventType, args, scopeObjects) {
          updateSelectedWatchlist(scopeObjects);
        }, scopeObjects);
      }
    }, scopeObjects);
    var createCallback = {
      success: function success(response) {
        var createdWatchlist = JSON.parse(response.textContent);
        if (createdWatchlist && createdWatchlist.displayName && createdWatchlist.name) {
          var dropdown = window.YAHOO.fcom.Page.getInstance(scopeObjects.dropdownNodeId);
          if (dropdown) {
            dropdown.addItem("w_".concat(createdWatchlist.name), createdWatchlist.displayName);
            dropdown.selectByValue("w_".concat(createdWatchlist.name));
          }
        }
      }
    };
    var renameCallback = {
      fn: function fn(response) {
        var responseObj = JSON.parse(response.textContent);
        var dropdown = window.YAHOO.fcom.Page.getInstance(scopeObjects.dropdownNodeId);
        var selectedValue = dropdown.getSelectedValue();
        var items = dropdown.getItems();
        for (var i = 0; i < items.length; i++) {
          if (items[i].value === renameCallback.lastSelectedWatchlist) {
            items[i].text = responseObj.displayName;
            break;
          }
        }
        dropdown.replaceItems(items);
        if (dropdown.getSelectedValue() !== selectedValue) {
          dropdown.selectByValues(selectedValue);
        }
      },
      lastSelectedWatchlist: null
    };
    $("button#".concat(scopeObjects.moduleId, "_addWatchlistIcon")).on('click', function () {
      window.createWatchlist(null, createCallback);
    });
    $("button#".concat(scopeObjects.moduleId, "_renameWatchlistIcon")).on('click', function () {
      var dropdown = window.YAHOO.fcom.Page.getInstance(scopeObjects.dropdownNodeId);
      var watchlist = dropdown.getSelectedValue();
      renameCallback.lastSelectedWatchlist = watchlist;
      window.renameWatchlist(watchlist.substring(2), renameCallback); // watchlists in that dropdown component are prefixed to distinguish from portfolios
    });

    $("button#".concat(scopeObjects.moduleId, "_copyWatchlistIcon")).on('click', function () {
      var dropdown = window.YAHOO.fcom.Page.getInstance(scopeObjects.dropdownNodeId);
      var watchlist = dropdown.getSelectedValue();
      window.copyWatchlist(watchlist.substring(2), function () {
        return updateSelectedWatchlist(scopeObjects);
      });
    });
    $("button#".concat(scopeObjects.moduleId, "_clearWatchlistIcon")).on('click', function () {
      var dropdown = window.YAHOO.fcom.Page.getInstance(scopeObjects.dropdownNodeId);
      var watchlist = dropdown.getSelectedValue();
      window.clearWatchlist(watchlist.substring(2), function () {
        return updateSelectedWatchlist(scopeObjects);
      });
    });
    $("button#".concat(scopeObjects.moduleId, "_deleteWatchlistIcon")).on('click', function () {
      var dropdown = window.YAHOO.fcom.Page.getInstance(scopeObjects.dropdownNodeId);
      var watchlist = dropdown.getSelectedValue().substring(2); // watchlists in that dropdown component are prefixed to distinguish from portfolios
      var newWatchlist = watchlist;
      var items = dropdown.getItems();
      for (var i = 0; i < items.length; i++) {
        // select first one that is not the same
        newWatchlist = items[i].value.substring(2);
        if (newWatchlist !== watchlist) {
          break;
        }
      }
      var postData = {
        // set the next available watchlist in the dropdown for the module
        viewId: window.YAHOO.fcom.viewInfo.name,
        moduleId: scopeObjects.moduleId,
        watchlistId: newWatchlist,
        viewOrgId: window.YAHOO.fcom.viewInfo.viewOrgId,
        viewProfile: window.YAHOO.fcom.viewInfo.viewProfile,
        isAdmin: window.YAHOO.fcom.viewInfo.isAdmin,
        method: 'changeModule'
      };
      window.ngpAsyncRequest('POST', '/module.action', null, postData, null, true).then(function () {
        window.removeWatchlists(watchlist); // helper method already triggers a full reload
      }).catch(function () {
        console.warn("Deleting watchlist ".concat(watchlist, " failed."));
        window.location.reload(); // do page reload instead
      });
    });

    var tableObj = $("table#".concat(scopeObjects.moduleId, "_table-sub"));
    (0, _TableExtensions.default)(tableObj);
    initRefreshMessenger();
  };
  if (window.onChildrenChange.registerNodeInterest(node)) {
    // only if not yet registered
    window.onChildrenChange.subscribe(function (type, args, objs) {
      if (objs[0] === args[0] && !document.hidden && document.querySelector("div#".concat(objs[0].id, "_performance_div")) !== null) {
        // when the change was for this node
        if (objs[1] + 10000 < new Date().getTime()) {
          // only every 20 seconds...
          objs[1] = new Date().getTime();
          var postData = {
            viewId: window.YAHOO.fcom.viewInfo.name,
            moduleId: objs[0].id,
            viewOrgId: window.YAHOO.fcom.viewInfo.viewOrgId,
            viewProfile: window.YAHOO.fcom.viewInfo.viewProfile,
            isAdmin: window.YAHOO.fcom.viewInfo.isAdmin,
            onlyPerformanceBar: 'true'
          };
          //  disabled the performance bar for the new mobile version as it was causing NGPII-17635
          if (!window.YAHOO.fcom.viewInfo.isMobileSwipe || window.YAHOO.fcom.viewInfo.name !== '') {
            window.ngpAsyncRequest('POST', '/view.action?method=getModuleInnerTable', null, postData, null, false, true).then(function (response) {
              console.log($("div#".concat(objs[0].id, "_performance_div")));
              $("div#".concat(objs[0].id, "_performance_div")).replaceWith(response);
              //const tableParentNode = Dom.get(objs[0].id + '_performance_div');
              //window.YAHOO.fcom.Page.replace(tableParentNode, response);
            }).catch(function () {
              console.warn('Reloading watchlist performance bar from ajax failed.');
              window.location.reload(); // do page reload instead
            });
          }
        }
      }
    }, [node, new Date().getTime()]);
  }
  var initRefreshMessenger = function initRefreshMessenger() {
    window.YAHOO.fcom.Broadcaster.subscribe('@watchlists', receiveMessage);
  };

  // Receive Message
  var receiveMessage = function receiveMessage(arg, _ref) {
    var _ref2 = _slicedToArray(_ref, 1),
      message = _ref2[0];
    var messageType = message.messageType;
    var watchlistId = message.id;
    if (messageType === 'watchlistChanged' && watchlistId === watchlistName && (moduleId !== message.moduleId || !message.moduleId)) {
      window.reloadModuleContent(moduleId, window.YAHOO.fcom.viewInfo.name, $("#".concat(moduleId, "_div"))[0]).then(function () {
        window.YAHOO.fcom.Broadcaster.unsubscribe('@watchlists', receiveMessage);
      });
    }
  };
  initWatchlistInteraction({
    dropdownNodeId: "".concat(node.id, "_WatchlistSelectDropDown"),
    moduleId: "".concat(node.id)
  });
  window.largeTableExternUpdateHandler("".concat(node.id, "_table"), function (id, callback, params) {
    window.showWait(true);
    var watchlistSelectDropDown = window.YAHOO.fcom.Page.getInstance("".concat(node.id, "_WatchlistSelectDropDown"));
    if (watchlistSelectDropDown && !watchlistSelectDropDown.getIsDisabled()) {
      // select was already unregistered or disabled?
      watchlistSelectDropDown.disable(); // disable. Ajax will provide a new copy of the dropdown, page.replace will unregister the old one
    }

    window.reloadModuleContent(moduleId, window.YAHOO.fcom.viewInfo.name, $('#' + moduleId + '_div')[0], params).then(function () {
      window.showWait(false);
      window.YAHOO.fcom.Broadcaster.unsubscribe('@watchlists', receiveMessage); // check: still required??
      if (callback) {
        callback();
      }
    });
  });
  window.largeTableExternExportHandler("".concat(node.id, "_table"), function (tableId, exportType) {
    var url;
    if (exportType === 'CSV') {
      url = "".concat(window.ctx, "/csv.action?method=handleWatchlist");
    } else {
      var formulaSupport = exportType === 'FIDL';
      url = "".concat(window.ctx, "/excel.action?method=handleWatchlist&formulaSupport=").concat(formulaSupport);
    }
    url += "&watchlistName=".concat(watchlistName, "&moduleId=").concat(moduleId, "&viewId=").concat(window.YAHOO.fcom.viewInfo.name);
    var form = document.createElement('form');
    form.action = url;
    form.method = 'POST';
    var tableElem = document.getElementById("".concat(tableId));
    tableElem.appendChild(form);
    form.submit();
  });
  var moduleInstance = {
    getSelectedInstruments: function getSelectedInstruments() {
      return _getSelectedInstruments(node);
    }
  };
  moduleInstance['@destroy'] = function () {
    $(node).trigger('module.destroy');
  };
  return moduleInstance;
}, true);
var sendBroadcastAll = function sendBroadcastAll($node, senderChannel) {
  var checked = $node.find('.select-instrument-all').prop('checked');
  $node.find('.select-instrument').prop('checked', checked);
  $node.find('.select-instrument').siblings('.checkbox').find('span').removeClass(checked ? 'unchecked' : 'checked').addClass(checked ? 'checked' : 'unchecked');
  var message = {
    senderId: $node.attr('id'),
    messageType: 'multiRic',
    rics: _getSelectedInstruments($node)
  };
  window.YAHOO.fcom.Broadcaster.sendMessage(senderChannel, message);
};
var _getSelectedInstruments = function _getSelectedInstruments(node) {
  return $(node).find('.select-instrument:checked').get().map(function (e) {
    return $(e).val();
  });
};

},{"tables/TableExtensions":136}],126:[function(require,module,exports){
"use strict";

var _YieldCurveModule = _interopRequireDefault(require("modules/YieldCurveModule/YieldCurveModule"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
window.fcom.moduleHandler.registerModuleType('YieldCurveModule', function (node, config) {
  var moduleInstance = new _YieldCurveModule.default(node, config);
  return moduleInstance;
}, true);

},{"modules/YieldCurveModule/YieldCurveModule":127}],127:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _messageHandler = require("messages/messageHandler");
var _Dataset = require("charts/data/Dataset");
var _YieldCurve = _interopRequireDefault(require("charts/YieldCurve"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var YAHOO = window.YAHOO;

/*
 * YieldCurve Module.
 * @param {Object} config containing the following properties
 * <ul>
 *  <li>{Array} chartData
 *  <li>{Array} groups
 * </ul>
 */
var enableKeyboardNavigation = function enableKeyboardNavigation(containerId) {
  var lastIndex = 0;
  $("#".concat(containerId)).on('keyup', function (e) {
    var nextIndex = null;
    if (e.keyCode == 37) {
      nextIndex = Math.max(lastIndex - 1, 1);
    } else if (e.keyCode == 39) {
      nextIndex = lastIndex + 1;
    }
    if (nextIndex) {
      var nextElem = $("#".concat(containerId, " circle[data-tabindex=\"").concat(nextIndex, "\"]"));
      if (nextElem.length) {
        var event = new MouseEvent('mouseover', {
          'view': window,
          'bubbles': true,
          'cancelable': true
        });
        nextElem[0].dispatchEvent(event);
        lastIndex = nextIndex;
      }
    }
  }).on('blur', function () {
    var lastElem = $("#".concat(containerId, " circle[data-tabindex=\"").concat(lastIndex, "\"]"));
    if (lastElem.length) {
      var event = new MouseEvent('mouseout', {
        'view': window,
        'bubbles': true,
        'cancelable': true
      });
      lastElem[0].dispatchEvent(event);
    }
    // Remove old tooltip data
    $("#".concat(containerId)).removeAttr('aria-description');
    lastIndex = 0;
  });
};
var YieldCurveModule = function YieldCurveModule(containerNode, config) {
  var moduleId = containerNode.id;
  var containerId = "".concat(moduleId, "_chartContainer");
  var container = YAHOO.util.Dom.get(containerId);
  var error = YAHOO.util.Dom.get("".concat(moduleId, "_chartError"));
  var viewId = window.YAHOO.fcom.Page.getInstance('moduleContainer').id;
  if (config.dataStatus.some(function (status) {
    return status === "WAIT_FOR_DATA";
  })) {
    setTimeout(function () {
      window.reloadYieldCurveModule(moduleId, viewId);
    }, 2000);
  }
  if (!config.chartData.length) {
    // cant draw a yieldcurve without data
    YAHOO.util.Dom.setStyle(error, 'display', '');
    return;
  }
  var chart = new _YieldCurve.default(YAHOO.util.Dom.get(containerId), new _Dataset.GroupedDataset(config.chartData), {
    xaxis: {
      label: {
        text: (0, _messageHandler.getMessage)('chart.yieldcurve.axis.y')
      }
    },
    yaxis: {
      label: {
        text: (0, _messageHandler.getMessage)('chart.yieldgraph.x.axis')
      },
      from: 0,
      postfix: '%'
    },
    groups: config.groups,
    channelName: config.channelName,
    getToolText: function getToolText(data) {
      var years = Math.max(0, Math.floor(data.x / 12));
      var months = Math.max(0, (data.x / 12 - years) * 12);
      var maturity = '';
      if (years > 0) {
        maturity += "".concat(years + YAHOO.fcom.Format.localized.postfixYear, " ");
        months = +months.toFixed(0);
      }
      if (months > 0 || !months && years < 1) {
        maturity += "".concat(YAHOO.fcom.Format.formatNumber(months, {
          minFractionDigits: 0,
          maxFractionDigits: 1
        }) + YAHOO.fcom.Format.localized.postfixMonth, " ");
      }
      var maturityDate = data.values.maturityDate;
      var xText = maturityDate ? "".concat((0, _messageHandler.getMessage)('chart.yieldcurve.marker.x'), ": ").concat(maturity, " (").concat(data.values.maturityDate, ")") : "".concat((0, _messageHandler.getMessage)('chart.yieldcurve.marker.noMaturityDate'), ": ").concat(maturity);
      return "".concat(data.displayName, " \n").concat(xText, "\n").concat((0, _messageHandler.getMessage)('chart.yieldgraph.x.axis'), ": ").concat(data.y.toFixed(3), " %");
    },
    cssCls: 'yieldcurve',
    resizeEl: containerId
  });
  chart.failureEvent.subscribe(function () {
    chart.destroy();
    YAHOO.util.Dom.setStyle(error, 'display', '');
    YAHOO.util.Dom.setStyle(container, 'display', 'none');
  });
  chart.render();
  window.onElementResize.subscribe(function (e, _ref) {
    var _ref2 = _slicedToArray(_ref, 1),
      theModule = _ref2[0];
    if (theModule.id === moduleId) {
      chart.resize();
    }
  }, moduleId, true);
  enableKeyboardNavigation(containerId);
};
var _default = exports.default = YieldCurveModule;

},{"charts/YieldCurve":3,"charts/data/Dataset":5,"messages/messageHandler":12}],128:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * @class       : NewsSearchHighlight
 * @description : To highlight the search result on news module
 * @ticket      : NGPII-19974
 * @singleton
 */
var NewsSearchHighlight = /*#__PURE__*/function () {
  function NewsSearchHighlight() {
    _classCallCheck(this, NewsSearchHighlight);
  }
  _createClass(NewsSearchHighlight, [{
    key: "$newsListArea",
    get: function get() {
      return $('#newsOverviewList table.list');
    }
  }, {
    key: "$newsContentArea",
    get: function get() {
      return $('.news .newscontent');
    }
  }, {
    key: "$fullTextTags",
    get: function get() {
      var $fullText = $('#fullText');
      return $fullText.closest('td').find('tag');
    }

    /**
     * @method highlight
     * @description Start the highlight process
     * @public
     */
  }, {
    key: "highlight",
    value: function highlight(config) {
      var _this = this;
      if (config && config.isModule) {
        // #. Full tex search highlight
        window.setTimeout(function () {
          _this._doFullTextModuleHighlight(config);
        }, 50);
      } else {
        // #. Full tex search highlight
        window.setTimeout(function () {
          _this._doFullTextHighlight();
        }, 50);
      }
    }

    /**
     * @method _doFullTextModuleHighlight
     * @description Full text search terms highlights on modules
     * @private
     */
  }, {
    key: "_doFullTextModuleHighlight",
    value: function _doFullTextModuleHighlight(config) {
      // #. Highlight color details available in localStorage
      // #. Key should be module id
      var storageITem = window.localStorage.getItem(config.moduleId);
      var searchItems = storageITem && JSON.parse(storageITem);
      if (searchItems) {
        var $listTable = $("#".concat(config.moduleId)).find('table.list tbody');
        var _iterator = _createForOfIteratorHelper(searchItems),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var searchItem = _step.value;
            this._addHighlighter(searchItem.value, searchItem.background, searchItem.color, [$listTable]);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }

    /**
     * @method _doFullTextHighlight
     * @description Full text search terms highlights
     * @private
     */
  }, {
    key: "_doFullTextHighlight",
    value: function _doFullTextHighlight() {
      var $tags = this.$fullTextTags;
      if ($tags.length > 0) {
        var _iterator2 = _createForOfIteratorHelper($tags),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var $tag = _step2.value;
            $tag = $($tag);
            // #. Get color and search term
            var searchTerm = $tag.find('.tagify__tag-text').text();
            var background = $tag.css('--tag-bg');
            var color = $tag.css('--tag-text-color');
            // #. Do highlight
            this._addHighlighter(searchTerm, background, color, [this.$newsListArea, this.$newsContentArea]);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }

    /**
     * @method _searchTermAsPattern
     * @description News search uses Elasticsearch for text search matchPhraseQuery
     * that means the words have to be in the right order, but prefix matches are accepted,
     * also The search is word based, so all special characters and whitespaces are ignored.
     * in such case searchTerm can't be matched exactly ,instead a pattern match is necessary.
     * The search term itself wil be a pattern.Each word in the searchTerm is separated with a space
     * so the pattern format for N words in a single searchTerm will be
     * word1\S*\W*\sword2\S*\W*\sword3\S*\W*\s....\sWordN
     * 1. \S matches any non-whitespace character (equivalent to [^\r\n\t\f\v ])
     *
     * 2.  \W matches any non-word character (equivalent to [^a-zA-Z0-9_])
     *
     * 3.  \s matches any whitespace character (equivalent to [\r\n\t\f\v ]) and matches the characters
     *      and literally (case-sensitive)
     *
     * *(Star) matches the previous token between zero and unlimited times,
     *      as many times as possible, giving back as needed (greedy)
     *
     * @param searchTerm A single search string as given by the user
     * @returns {*} given searchTerm converted to a pattern , which will be matched on headlines & articles.
     * @private
     */
  }, {
    key: "_searchTermAsPattern",
    value: function _searchTermAsPattern(searchTerm) {
      var generateSearchTermPattern = function generateSearchTermPattern(ary) {
        return ary.join('\\S*\\W*\\s*');
      };
      //split with non-ascii special characters
      var st = searchTerm.split(/[$-/:-?{-~!"^_`\[\]\\\s@#]/);
      if (st.length > 1) {
        st = st.filter(function (el) {
          return el.length > 0;
        });
        return generateSearchTermPattern(st);
      } else {
        return searchTerm;
      }
    }

    /**
     * @method _addHighlighter
     * @description Add highlight element
     * @private
     */
  }, {
    key: "_addHighlighter",
    value: function _addHighlighter(searchTerm, highlightColor, textColor, $contentElements) {
      var _this2 = this;
      // #. Regular expression to search the term
      // #. (?!([^<]+)?>) - handles the attributes/html ex: a tag href attr
      // #. g - global
      // #. i - case sensitive
      // #. [.*+?^${}()|[\]\\] - to escape the special characters
      searchTerm = searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      var searchTermAsPattern = this._searchTermAsPattern(searchTerm);
      var regExp = new RegExp("(?<!<[^>]*)(".concat(searchTermAsPattern, ")"), 'gi');
      // #. Update content html with search term
      var _iterator3 = _createForOfIteratorHelper($contentElements),
        _step3;
      try {
        var _loop = function _loop() {
          var $contentElement = _step3.value;
          $contentElement.html(function (_, html) {
            if (!_this2._isHighlighted(searchTerm, $contentElement)) {
              return html.replace(regExp, "<span class=\"searchItem\" style=\"background:".concat(highlightColor, ";color:").concat(textColor, "\">$&</span>"));
            }
          });
        };
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }

    /**
     * @method _isHighlighted
     * @description checks wether the search string is already replaced by search item markup
     * @returns {boolean}
     * @private
     */
  }, {
    key: "_isHighlighted",
    value: function _isHighlighted(searchTerm, contentElement) {
      var reg = new RegExp(searchTerm, 'ig');
      return reg.test(contentElement.find('.searchItem').text()) === true;
    }
  }]);
  return NewsSearchHighlight;
}();
var _default = exports.default = new NewsSearchHighlight();

},{}],129:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.detailLink = exports.default = void 0;
var _axios = _interopRequireDefault(require("../../app/utils/axios"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var TOOL_TEMPLATE = document.createElement('template');
var detailLink = exports.detailLink = function detailLink(item, subPage) {
  return "/detail/detailPage.html?".concat(getQueryString(item, subPage));
};
var getQueryString = function getQueryString(item, subPage) {
  var viewName = item.viewName;
  var queryString = "subPage=".concat(subPage, "&").concat(item.symbol || item.id ? "ric=".concat(item.symbol || item.id) : "isin=".concat(item.isin));
  if (viewName) {
    queryString = "".concat(queryString, "&view=").concat(viewName);
  }
  return queryString;
};
var DFA_PARENT_CSS = 'dfa-parent';
var saveSearchHistory = function saveSearchHistory(item) {
  var params = {
    isin: item.isin,
    ric: item.ric || item.symbol || item.id || item.isin
  };
  _axios.default.post('/searchHistory/updateHistory', params).catch(function (error) {
    console.error(error);
  });
};

/*
 * Genrates a direct function access from search result on a single instrument
 * User can directly move to individual sub detail page from the search result.
 */

/*
    constructor for direct function access panel.

    Characteristics of the DFA panel

    The panel appears when the user clicks on a data row.
    Panel appears in the same table as of the search result just one row below the data row which the user had clicked.
    All other rows including paging control panel will be hidden except
        i) Data row which the user had clicked.
        ii) Header row.
    A close button appears on the right most column in the data row which can close the panel

    @param $navigationData {Object} A data JSON which contains all available subpage navigation
            definitions for a given type of instrument.
    @param $node {Object} The node to which the Panel need to be attached which is the reference to data row
                            which the user had clicked.
    @param $item {Object} The data item (JSON) that describes a single record in the search response.
 */
var DirectFunctionAccessPanel = function DirectFunctionAccessPanel($navigationData, $node, $item) {
  this.container = new Container($node);
  this.navData = $navigationData;
  this.item = $item;
};
/*
    Prepare rendering Direct Function Access Panel
 */
DirectFunctionAccessPanel.prototype._preRender = function () {
  this.container.hideIrrelevant();
  this.container.addStyles();
};
/*
    Generate direct access to a single navigation from the given data.

    @param data {Object} A data JSON which contains a single subpage navigation
            definition for a given type of instrument.
 */
DirectFunctionAccessPanel.prototype._generateDFAFromData = function (data) {
  return "\n                    <div class=\"dfa-code\">".concat(data.shortCode, "</div>\n                    <div class=\"dfa-name\">").concat(data.displayName, "</div>\n            ").replace(/[\r\n\t]+/g, "");
};
/*
    Create container for the Panel
 */
DirectFunctionAccessPanel.prototype._createPanelContainer = function () {
  TOOL_TEMPLATE.innerHTML = "<div class=\"search-result-dfa\"></div>";
  return TOOL_TEMPLATE.content.firstChild;
};
/*

    @param data {Object} A data JSON which contains a single subpage navigation
            definition for a given type of instrument.
 */
DirectFunctionAccessPanel.prototype._createSingleDFAContainer = function (data) {
  var _this = this;
  TOOL_TEMPLATE.innerHTML = "<div class=\"dfa-block\"></div>";
  var navContainer = TOOL_TEMPLATE.content.firstChild;
  navContainer.onclick = function (evt) {
    var dataItem = _this._generateDataItem(data, _this.item);
    saveSearchHistory(dataItem);
    DirectFunctionAccessPanel.redirectToFunction(dataItem, data.linkCode);
    evt.stopPropagation();
  };
  return navContainer;
};
/*
    Merge Navigation Data with selected search result data
    this data is used for
    1. detail page link
    2. Saving Search Results

    @param $navData {Object} A data JSON which contains a single subpage navigation
            definition for a given type of instrument.
    @param $item {Object} The data item (JSON) that describes a single record in the search response.
 */
DirectFunctionAccessPanel.prototype._generateDataItem = function ($navData, $instrData) {
  var dataItem = Object.assign({}, $instrData);
  if ($navData.ric) {
    dataItem = Object.assign(dataItem, {
      symbol: $navData.ric
    });
  }
  if ($navData.linkUrl && $navData.linkUrl.includes('&view=')) {
    var queryParams = $navData.linkUrl.split('?')[1];
    var viewName = new URLSearchParams(queryParams).get('view');
    dataItem = Object.assign(dataItem, {
      viewName: viewName
    });
  }
  return dataItem;
};
/*
    Convert the dfa navigation data in to GUI list components.
 */
DirectFunctionAccessPanel.prototype._navDataToDFA = function () {
  var _this2 = this;
  return this.navData.itemList.map(function (data) {
    var singleDFAContainer = _this2._createSingleDFAContainer(data);
    var singleDFA = _this2._generateDFAFromData(data);
    singleDFAContainer.insertAdjacentHTML('beforeend', singleDFA);
    return singleDFAContainer;
  });
};

/*
    Render Direct Function Access Panel
*/
DirectFunctionAccessPanel.prototype.render = function () {
  this._preRender();
  var dfaPanel = this._createPanelContainer();
  var dfaList = this._navDataToDFA();
  dfaList.forEach(function (aDFA) {
    return dfaPanel.appendChild(aDFA);
  });
  var footer = this.createFooter();
  dfaPanel.appendChild(footer);
  this.container.cCell.append(dfaPanel);
};
/*
    Create footer for the Panel
 */
DirectFunctionAccessPanel.prototype.createFooter = function () {
  TOOL_TEMPLATE.innerHTML = "<div class=\"dfa-ft\"><i class=\"far fa-info-circle\"></i><span>".concat(window.getMessage('incrementalsearch.dfa.info'), "</span></div>");
  return TOOL_TEMPLATE.content.firstChild;
};
/*
    check if a panel is already active on the data row
    Active data row has a class 'dfa'
 */
DirectFunctionAccessPanel.isActive = function ($parentRow) {
  return $parentRow.classList.contains(DFA_PARENT_CSS);
};
DirectFunctionAccessPanel.activeStatus = false;

/*
    double-clicking will trigger multiple instances of the panel to be generated
    to solve it a flag style is added on each click and removed on susequent click
     from the row
 */
DirectFunctionAccessPanel.allowClick = function () {
  if (DirectFunctionAccessPanel.activeStatus === false) {
    DirectFunctionAccessPanel.activate();
    return true;
  }
  return false;
};
DirectFunctionAccessPanel.deActivate = function () {
  DirectFunctionAccessPanel.activeStatus = false;
};
DirectFunctionAccessPanel.activate = function () {
  DirectFunctionAccessPanel.activeStatus = true;
};
DirectFunctionAccessPanel.navDataForShortCode = function ($navData, shortCode) {
  return $navData.find(function (n) {
    return n.shortCode === shortCode.toUpperCase();
  }) || {
    linkCode: 'overv',
    shortCode: 'OV'
  };
};
DirectFunctionAccessPanel.redirectToFunction = function ($instrData, functionCode) {
  window.location = "".concat(window.ctx).concat(detailLink($instrData, functionCode));
};
var Container = function Container($parentRow) {
  /* A row in search result table which contains the instrument data, a click on this row will trigger direct function access*/
  this.pRow = $parentRow;
  this.pTable = $parentRow.closest("table");
  this.pTableHeader = Array.from(this.pTable.rows)[0];
  this.pCtrlPane = this.pTable.closest("div").getElementsByClassName("controls")[0];
  this._init();
  this._addPanelCloseButton();
};
/*

 */
Container.prototype._init = function () {
  this.cRow = this.pTable.insertRow(this.pRow.rowIndex + 1);
  this.cCell = this.cRow.insertCell(0);
  this.cCell.colSpan = this.pRow.cells.length;
};
Container.prototype._addPanelCloseButton = function () {
  var _this3 = this;
  this._addRowsAdjustmentForCloseButton();
  TOOL_TEMPLATE.innerHTML = "<div class=\"dfa-close-btn\" title=\"".concat(window.getMessage('txt.button.close.panel'), "\"><i class=\"fal fa-times\"></i></div>");
  var closeBtn = TOOL_TEMPLATE.content.firstChild;
  closeBtn.onclick = function (evt) {
    DirectFunctionAccessPanel.deActivate();
    _this3.reset();
    _this3.detach();
    closeBtn.remove();
    evt.stopPropagation();
  };
  var lastColumnOfParentRow = this.pRow.lastChild;
  /* Add close button to the dfa-ctrl-block div */
  lastColumnOfParentRow.firstChild.append(closeBtn);
};
/*
    Last column of the search result table has isin  & close btn added side by side
    in the following structure
    <div class="dfa-ctrl-block">
        <div class="dfa-isin"></div>
        <div class="dfa-close-btn">X</div>
    </div>
 */
Container.prototype._addRowsAdjustmentForCloseButton = function () {
  this.pRow.classList.add(DFA_PARENT_CSS);
  var lastColumnOfParentRow = this.pRow.lastChild;
  if (!lastColumnOfParentRow.classList.contains('dfa-ctrl')) {
    /*get column data & close btn side by side using style 'flex'*/
    /* put a div around the colum data */
    $(lastColumnOfParentRow).wrapInner("<div class=\"dfa-isin\"></div>");
    /* put a div around the entire column content including close button */
    $(lastColumnOfParentRow).wrapInner("<div class=\"dfa-ctrl-block\"></div>");
  }
  if (!lastColumnOfParentRow.classList.contains('dfa-ctrl')) {
    lastColumnOfParentRow.classList.add('dfa-ctrl');
  }
};
Container.prototype._removeRowsAdjustmentForCloseButton = function () {
  this.pRow.classList.remove(DFA_PARENT_CSS);
};
Container.prototype.isDFAActive = function () {
  return this.pRow.classList.contains(DFA_PARENT_CSS);
};
Container.prototype.hideIrrelevant = function () {
  var _this4 = this;
  Array.from(this.pTable.rows).filter(function (row) {
    return _this4._rowsToHide(row, _this4.cRow.rowIndex);
  }).forEach(function (row) {
    return row.style.display = 'none';
  });
  if (this.pCtrlPane) {
    this.pCtrlPane.style.display = 'none';
  }
};
Container.prototype.addStyles = function () {
  this.cRow.classList.add('dfa');
};
Container.prototype.removeStyles = function () {
  this.cRow.classList.remove('dfa');
};
Container.prototype.reset = function () {
  Array.from(this.pTable.rows).forEach(function (row) {
    return row.style.display = '';
  });
  if (this.pCtrlPane) {
    this.pCtrlPane.style.display = '';
  }
  this._removeRowsAdjustmentForCloseButton();
};
Container.prototype.detach = function () {
  this.cRow.remove();
};
Container.prototype.addCloseButton = function ($closeBtn) {
  this.cRow.lastChild.append($closeBtn);
};
Container.prototype._rowsToHide = function ($row, containerRowIndex) {
  var isHeaderRow = $row.rowIndex === 0;
  var isParentRow = $row.rowIndex === containerRowIndex - 1;
  var isContainerRow = $row.rowIndex === containerRowIndex;
  var toHide = !isHeaderRow && !isParentRow && !isContainerRow;
  return toHide;
};
var _default = exports.default = DirectFunctionAccessPanel;

},{"../../app/utils/axios":1}],130:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _messageHandler = require("fcom/messages/messageHandler");
var _axios = _interopRequireDefault(require("../../app/utils/axios"));
var _ajaxRequest = require("core/Ajax/ajaxRequest");
var _DirectFunctionAccessPanel = _interopRequireDefault(require("fcom/search/DirectFunctionAccessPanel"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var SearchHistory = function SearchHistory(config, searchInput) {
  var container = document.querySelector("#".concat(config.searchHistoryContainerId));
  if (!container) {
    container = document.createElement('div');
    container.id = config.searchHistoryContainerId;
    container.className = 'search-history';
    container.style.display = 'none';
    document.body.appendChild(container);
  }
  container.classList.add('search-history');
  this.createHistoryWindowContents(container, config);
  this.container = container;
  this.containerId = config.searchHistoryContainerId;
  this.searchInput = searchInput; // set associated search input
  this.dfaEnabled = config.enableDFAInSearchHistory;
  this.closeHistoryWindowHandler = null;
  this.config = config;
};
SearchHistory.prototype.createHistoryWindowContents = function (container, config) {
  var showFlags = !window.user.isChinaSpecificUser;
  // clear existing childrens
  container.replaceChildren();
  var titleDiv = document.createElement('div');
  titleDiv.className = 'search-history-title';
  titleDiv.innerText = (0, _messageHandler.getMessage)('searchHistory.title');
  container.appendChild(titleDiv);
  var table = document.createElement('table');
  table.id = "".concat(config.searchHistoryContainerId, "_table");
  table.classList.add('list', 'marktr');
  var tr = document.createElement('tr');
  tr.className = 'search-history-header';
  this.columns = ['description', 'group', 'isin'];
  var colGroup = document.createElement('colgroup');
  table.appendChild(colGroup);
  if (showFlags) {
    var flagCol = document.createElement('col');
    flagCol.style.width = '30px';
    colGroup.appendChild(flagCol);
  }
  var _iterator = _createForOfIteratorHelper(this.columns),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var column = _step.value;
      var col = document.createElement('col');
      var th = document.createElement('th');
      if (column === 'description' && showFlags) {
        th.colSpan = 2;
      }
      colGroup.appendChild(col);
      th.innerText = (0, _messageHandler.getMessage)("incrementalsearch.col.instruments.".concat(column));
      tr.appendChild(th);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  table.appendChild(tr);
  container.appendChild(table);
  this.table = table;
};
SearchHistory.prototype.render = function () {
  var _this = this;
  // need to fetch and render data only if the history window is not already displayed
  // and search input is empty
  if (this.container.style.display === 'none' && this.searchInput.value.length === 0) {
    var self = this;
    this.setContainerStyle();
    _axios.default.get("/searchHistory/getHistory").then(function (response) {
      var data = response.data ? response.data : [];
      _this.setTableData(data);
      var closeSearchHistory = function closeSearchHistory(e) {
        if (!e.target.closest('div.search-history') && e.target !== self.searchInput) {
          document.body.removeEventListener('click', closeSearchHistory);
          self.container.style.display = 'none';
        }
      };
      document.body.addEventListener('click', closeSearchHistory);
      _this.closeHistoryWindowHandler = closeSearchHistory;
    });
  }
};
SearchHistory.prototype.setContainerStyle = function () {
  var containerTop = this.searchInput.getBoundingClientRect().top + this.searchInput.offsetHeight;
  this.container.style.top = "".concat(containerTop, "px");
};
var generateCountryFlag = function generateCountryFlag(country) {
  if (country) {
    return "<span title=\"".concat(window.YAHOO.lang.escapeHTML(country), "\" class=\"country ").concat(window.YAHOO.lang.escapeHTML(country), "\" style=\"width:16px;\"></span>");
  }
  return "<span style=\"width:16px;\"></span>";
};
SearchHistory.prototype.setTableData = function (data) {
  var _this2 = this;
  var showFlags = !window.user.isChinaSpecificUser;
  var self = this;
  this.table.querySelectorAll('tr:not(.search-history-header)').forEach(function (row) {
    return row.remove();
  });
  if (data.length) {
    var _this$table;
    var rows = data.map(function (datum) {
      var tr = document.createElement('tr');
      tr.role = 'button';
      tr.addEventListener('click', function (event) {
        onRowClick(self, datum, event.currentTarget);
      });

      // add flag
      if (showFlags) {
        var td = document.createElement('td');
        td.innerHTML = generateCountryFlag(datum.country);
        tr.appendChild(td);
      }
      var _iterator2 = _createForOfIteratorHelper(_this2.columns),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var column = _step2.value;
          var _td = document.createElement('td');
          _td.textContent = datum[column] ?? '-';
          if (column === 'description') {
            _td.style.textAlign = 'left';
          }
          tr.appendChild(_td);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return tr;
    });
    (_this$table = this.table).append.apply(_this$table, _toConsumableArray(rows));
  } else {
    // add row with empty message
    var tr = document.createElement('tr');
    tr.className = 'noresults';
    var td = document.createElement('td');
    td.colSpan = 3;
    td.innerText = (0, _messageHandler.getMessage)('searchHistory.emptyMessage');
    tr.appendChild(td);
    this.table.appendChild(tr);
  }
  this.container.style.display = 'block';
};
var onRowClick = function onRowClick(self, item, row) {
  if (self.dfaEnabled) {
    (0, _ajaxRequest.ajaxGet)('/api/v1/navigationData/navigationItemList', item).then(function (response) {
      var navData = JSON.parse(response);
      if (!_DirectFunctionAccessPanel.default.isActive(row)) {
        var dfa = new _DirectFunctionAccessPanel.default(navData, row, item);
        dfa.render();
      }
    }).catch(function () {
      var redirectLink = "/detail/detailPage.html?".concat(item.isin ? "isin=".concat(item.isin) : "ric=".concat(item.ric));
      window.location = window.ctx + redirectLink;
    });
  } else if (self.config.searchRicCallback) {
    self.config.searchRicCallback({
      name: item.description,
      ric: item.ric,
      isin: item.isin,
      type: item.type
    });
  } else if (self.config.itemCallback) {
    self.config.itemCallback('instruments', {
      description: item.description,
      id: item.ric,
      isin: item.isin,
      type: item.type
    });
  } else {
    var redirectLink = "/detail/detailPage.html?".concat(item.isin ? "isin=".concat(item.isin) : "ric=".concat(item.ric));
    window.location = window.ctx + redirectLink;
  }
};
var _default = exports.default = SearchHistory;

},{"../../app/utils/axios":1,"core/Ajax/ajaxRequest":7,"fcom/messages/messageHandler":12,"fcom/search/DirectFunctionAccessPanel":129}],131:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ajaxRequest = require("core/Ajax/ajaxRequest");
var _messageHandler = require("fcom/messages/messageHandler");
var _searchTypesEnum = _interopRequireDefault(require("fcom/search/searchTypesEnum"));
var _ThirdLevelTable = _interopRequireDefault(require("fcom/search/ThirdLevelTable"));
var _basicTableControls = _interopRequireDefault(require("fcom/search/basicTableControls"));
var _keyCodes = _interopRequireDefault(require("fcom/util/enums/keyCodes"));
var _DirectFunctionAccessPanel = _interopRequireWildcard(require("fcom/search/DirectFunctionAccessPanel"));
var _axios = _interopRequireDefault(require("../../app/utils/axios"));
var _tableColumnDefinitio;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var tableColumnDefinitions = (_tableColumnDefinitio = {}, _defineProperty(_tableColumnDefinitio, _searchTypesEnum.default.INSTRUMENTS, ['description', 'group', 'isin']), _defineProperty(_tableColumnDefinitio, _searchTypesEnum.default.NEWS, ['headline', 'timestamp']), _defineProperty(_tableColumnDefinitio, _searchTypesEnum.default.WLPF, ['caption', 'type']), _defineProperty(_tableColumnDefinitio, _searchTypesEnum.default.NAV, ['page']), _defineProperty(_tableColumnDefinitio, _searchTypesEnum.default.ISSUER, ['bnd_issuer', 'bnd_issuer_domicile']), _tableColumnDefinitio);
var ELEMENT_ID = {
  SEARCH_INPUT: 1,
  LEFT_PANEL: 2,
  RESULT_TABLE1: 3,
  RESULT_TABLE2: 4,
  PAGINATION_CONTROL: 5,
  RESULT2_BACK: 6,
  GENERIC_BUTTONS: 7
};
var INSTRUMENT_ENUM = {
  BON: "BONDS",
  CER: "CERTIFICATES",
  COM: "COMMODITIES",
  CUR: "CURRENCIES",
  ECI: "ECONOMY",
  FUN: "FUNDS",
  FUT: "FUTURES",
  IND: "INDICES",
  MON: "MONEY_MARKET",
  OPT: "OPTIONS",
  STO: "STOCKS",
  WAR: "WARRANTS",
  CHN: "CHAIN"
};
var pagePathDivider = '&raquo;';
var newsLink = function newsLink(item) {
  return "/news/overview.html#newsId=".concat(item.id);
};
var detailLink = function detailLink(item) {
  return "/detail/detailPage.html?".concat(item.isin ? "isin=".concat(item.isin) : "ric=".concat(item.symbol || item.id));
};
var watchlistLink = function watchlistLink(item) {
  return "/portfolios/watchlists/detail.html?id=".concat(item.id);
};
var portfolioLink = function portfolioLink(item) {
  return "/portfolios/portfolios/portfolio.html?pfid=".concat(item.id);
};
var pageLink = function pageLink(item) {
  return "".concat(item.link);
};
var bondIssuerLink = function bondIssuerLink(item) {
  return "/screener.html?method=bondScreenerResult&purpose=&secTypeGroup=BONDS&issuer=".concat(item.bnd_issuer_code);
};
var directRicLink = function directRicLink(item) {
  return "/detail/detailPage.html?ric=".concat(encodeURIComponent(item.ric));
};
var dfaNavDataRestLink = '/api/v1/navigationData/navigationItemList';
var maxItemsPerPage = 10;
var RIC_PATTTERN = /(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*(?:[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2\uDF00-\uDF09]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDF43-\uDF4F\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F])(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*/;
var FUTURE_RIC_PATTERN = /(?=.*\d)(?=.*[A-Z])(?=.*[\d]$)/;
var SearchResultBox = function SearchResultBox(config) {
  var _this2 = this;
  var searchBox = $("#".concat(config.searchBoxId));
  if (!searchBox.length) {
    searchBox = $('<form/>').attr('id', config.searchBoxId).css('display', 'none');
    $('body').append(searchBox);
  }
  searchBox.addClass('searchbox-container');
  searchBox.toggleClass('ricsearch-enabled', config.searchRic);
  if (config.static) {
    searchBox.addClass('searchbox-static');
  }
  if (config.inPage) {
    searchBox.addClass('searchbox-inPage');
  } else {
    searchBox.removeClass('searchbox-inPage');
  }
  this.config = config || {};
  this.$searchBox = searchBox;
  this.searchTerm = null;
  this.dfaShortCut = null;
  this.searchType = config.searchType || _searchTypesEnum.default.INSTRUMENTS;
  this.searchFilter = config.instrumentTypes;
  this.instrumentTypes = config.instrumentTypes || ['*'];
  this.countInstTypeOnly = config.countInstTypeOnly !== false;
  this.page = 1;
  this.itemsPerPage = maxItemsPerPage;
  this.availableTypes = config.searchType ? [config.searchType] : window.user.searchSpacesAvailable;
  this.timeTracking = [];

  // #. To keep the active left panel item index
  this.activeLeftPanelItem = 0;

  // #. To keep the active result table 1 item index
  this.activeResultTable1Item = 0;

  // #. To keep the active result table 2 item index
  this.activeResultTable2Item = 0;

  // #. To track the result table 1 navigation starts from first row or not
  this.resetRowSelection = false;

  // #. To track the result table 2 navigation starts from first row or not
  this.resetRowSelection2 = false;

  // #. To keep the search input text box
  this.$searchInput = null;

  // #. To keep the search input text box offset position
  this.searchInputOffset = null;

  // #. To keep the search input text box Height
  this.searchInputHeight = null;

  // #. To track if the position of result box top or bottom
  this.showOnTop = false;

  // attach handlers for keyboard navigation
  var keyHandler = function keyHandler(event) {
    var keyCode = event.keyCode;
    if (!_this2.$searchBox || !_this2.isSearchBoxVisible()) {
      return true;
    }
    var propagation = true;
    switch (keyCode) {
      case _keyCodes.default.ESCAPE:
        event.preventDefault();
        _this2.hide();
        if (_this2.config.inPage) {
          _this2.setFocusToSolarSearchInput();
        }
        propagation = false;
        break;
      case _keyCodes.default.ARROW_LEFT:
        propagation = _this2.onArrowLeftPressed(event);
        break;
      case _keyCodes.default.ARROW_RIGHT:
        propagation = _this2.onArrowRightPressed(event);
        break;
      case _keyCodes.default.ARROW_DOWN:
        _this2.onArrowDownPressed(event);
        propagation = false;
        break;
      case _keyCodes.default.ARROW_UP:
        _this2.onArrowUpPressed(event);
        propagation = false;
        break;
      case _keyCodes.default.ENTER:
        _this2.onEnterKeyPressed(event);
        propagation = false;
        break;
      case _keyCodes.default.TAB:
        _this2.onTabKeyPressed(event);
        propagation = true;
        break;
      default:
        propagation = true;
        break;
    }
    return propagation;
  };
  var $panel = this.$searchBox.closest('.panel');
  var $container = $panel.length > 0 ? $panel : this.$searchBox;
  $container.unbind('keydown');
  $container.on('keydown', keyHandler);

  // #. Keep the search input ref
  this.setSearchInputRef();
  window.setTimeout(function () {
    if (!_this2.isSolarSearch()) {
      _this2.setFocusToSearch();
    } else {
      _this2.bindSolarInputKeydown();
      _this2.setRootElementRole();
    }
  }, 100);
};

/**
 * Set search input ref
 */
SearchResultBox.prototype.setSearchInputRef = function () {
  this.$searchInput = this.config.searchInput;
  this.searchInputHeight = this.$searchInput.outerHeight();
  this.searchInputOffset = this.$searchInput.offset();
};

/**
 * Bind keydown event to solar input
 */
SearchResultBox.prototype.bindSolarInputKeydown = function () {
  var _this3 = this;
  // #. Bind the event, if it is not added yet
  if (!this.$searchInput.data('solar-keydown')) {
    this.$searchInput.on('keydown', function (event) {
      _this3.onSolarInputKeydown(event);
    }).data('solar-keydown', true);
  }
};

/**
 * Set search input ref
 */
SearchResultBox.prototype.onSolarInputKeydown = function (event) {
  if (event.keyCode === _keyCodes.default.TAB && this.isSearchBoxVisible()) {
    event.preventDefault();
    event.stopPropagation();
    // #. Handle shift combo
    if (event.shiftKey === true) {
      this.setFocusToSolarLastFocusableElement();
    } else {
      this.setFocusToLeftPanel();
    }
    return false;
  }
};

/**
 * Check whether the search box is visible or not
 * @returns {boolean}
 */
SearchResultBox.prototype.isSearchBoxVisible = function () {
  return this.$searchBox.is(':visible');
};

/**
 * Check the current search is solar search or nor
 * Status based on the visibility of the result form
 * @returns {boolean}
 */
SearchResultBox.prototype.isSolarSearch = function () {
  return $(this.$searchInput).closest('.quickSearch').length > 0 || this.config.inPage === true;
};

/**
 * Returns active element id
 * @returns {numeric}
 */
SearchResultBox.prototype.activeElementId = function () {
  var $element = this.getActiveElement();
  var elementId = -1;
  if ($element.is('#popupSearchPanelInput')) {
    elementId = ELEMENT_ID.SEARCH_INPUT;
  } else if ($element.is('ul.search-list-items') || $element.is('a.keyboard-focus') && $element.parents('ul.search-list-items').length > 0) {
    elementId = ELEMENT_ID.LEFT_PANEL;
  } else if ($element.is('.controls button')) {
    elementId = ELEMENT_ID.PAGINATION_CONTROL;
  } else if ($element.is('.ricsearch table.list') || $element.is('tr.keyboard-focus') && $element.parent().is('.ricsearch table.list')) {
    elementId = ELEMENT_ID.RESULT_TABLE2;
  } else if ($element.is('table.list.marktr') || $element.is('tr.keyboard-focus') && $element.parent().is('table.list.marktr')) {
    elementId = ELEMENT_ID.RESULT_TABLE1;
  } else if ($element.is('span.back')) {
    elementId = ELEMENT_ID.RESULT2_BACK;
  } else if ($element.is('.buttonBar button') || $element.is('button.container-close')) {
    elementId = ELEMENT_ID.GENERIC_BUTTONS;
  }
  return elementId;
};

/**
 * Handle left key press event
 * #1. Focus on result table 1 - move focus to left panel
 * #2. Focus on result table 2 - move focus to result table 1(trigger back button click)
 */
SearchResultBox.prototype.onArrowLeftPressed = function (event) {
  var activeElId = this.activeElementId();
  var propagation = false;
  switch (activeElId) {
    case ELEMENT_ID.RESULT_TABLE1:
      event.preventDefault();
      this.setFocusToLeftPanel();
      break;
    case ELEMENT_ID.RESULT_TABLE2:
      event.preventDefault();
      this.$searchBox.find('.controls .back').trigger('click');
      this.disableResult2TabIndex();
      this.setFocusToResultTable();
      break;
    default:
      propagation = true;
      break;
  }
  return propagation;
};

/**
 * Handle right key press event
 * Focus on left panel - move the focus to result table 1
 */
SearchResultBox.prototype.onArrowRightPressed = function (event) {
  var activeElId = this.activeElementId();
  if (activeElId === ELEMENT_ID.LEFT_PANEL) {
    event.preventDefault();
    this.setFocusToResultTable();
    return false;
  } else {
    return true;
  }
};

/**
 * Handle arrow down key press event
 * Navigate through list/table items
 * Left Panel - list items(li.a)
 */
SearchResultBox.prototype.onArrowDownPressed = function (event) {
  var activeElId = this.activeElementId();
  switch (activeElId) {
    case ELEMENT_ID.SEARCH_INPUT:
      event.preventDefault();
      this.activeLeftPanelItem = 0;
      this.setFocusToLeftPanel();
      break;
    case ELEMENT_ID.LEFT_PANEL:
      event.preventDefault();
      this.handleLeftPanelNavigation(true);
      break;
    case ELEMENT_ID.RESULT_TABLE1:
      event.preventDefault();
      this.handleResultTableNavigation(this.getResultTable1Rows(), true, true);
      break;
    case ELEMENT_ID.RESULT_TABLE2:
      event.preventDefault();
      this.handleResultTableNavigation(this.getResultTable2Rows(), true, false);
      break;
    default:
      break;
  }
};

/**
 * Handle arrow up key press event
 * Navigate through list/table items
 * Left Panel - list items(li.a)
 */
SearchResultBox.prototype.onArrowUpPressed = function (event) {
  var activeElId = this.activeElementId();
  switch (activeElId) {
    case ELEMENT_ID.LEFT_PANEL:
      event.preventDefault();
      this.handleLeftPanelNavigation(false);
      break;
    case ELEMENT_ID.RESULT_TABLE1:
      event.preventDefault();
      this.handleResultTableNavigation(this.getResultTable1Rows(), false, true);
      break;
    case ELEMENT_ID.RESULT_TABLE2:
      event.preventDefault();
      this.handleResultTableNavigation(this.getResultTable2Rows(), false, false);
      break;
    default:
      break;
  }
};

/**
 * Handle arrow down key press event
 * Navigate through list/table items
 */
SearchResultBox.prototype.handleLeftPanelNavigation = function (isArrowDown) {
  // #. Get all list items from the left panel
  var $items = this.$searchBox.find('li a');

  // #. Get next item index
  this.activeLeftPanelItem = isArrowDown ? this.activeLeftPanelItem + 1 : this.activeLeftPanelItem - 1;

  // #. Get next item by index
  var $next = $items[this.activeLeftPanelItem];

  // #. Set first/last item as default, if no items found
  if (!$next) {
    this.activeLeftPanelItem = isArrowDown ? 0 : $items.length - 1;
    $next = $items[this.activeLeftPanelItem];
  }
  this.setRowActive($($next));

  // #. Set focus to the active row for announcing by screenreader
  $($next).attr('tabindex', 0);
  $($next).focus();
};

/**
 * Handle result table navigations
 * Navigate through list/table items
 */
SearchResultBox.prototype.handleResultTableNavigation = function ($rows, isArrowDown, isResultTable1) {
  if (!$rows || $rows && $rows.length === 0) {
    return;
  }

  // #. Local variable declaration
  var index = 0;
  var $next = null;
  var parentClassName = null;
  if (this.activeResultTable1Item === -1) {
    this.activeResultTable1Item = $rows.length - 1;
  }
  if (this.resetRowSelection === true) {
    this.activeResultTable1Item = -1;
    this.resetRowSelection = false;
  }
  if (this.activeResultTable2Item === -1) {
    this.activeResultTable2Item = $rows.length - 1;
  }
  if (this.resetRowSelection2 === true) {
    this.activeResultTable2Item = -1;
    this.resetRowSelection2 = false;
  }

  // #. Get elements bases on the table id
  // #. Update related table item index
  if (isResultTable1 === true) {
    parentClassName = '.mainsearch';
    if (isArrowDown) {
      this.activeResultTable1Item++;
    } else {
      this.activeResultTable1Item--;
    }
    index = this.activeResultTable1Item;
  } else if (!isResultTable1) {
    parentClassName = '.ricsearch';
    if (isArrowDown) {
      this.activeResultTable2Item++;
    } else {
      this.activeResultTable2Item--;
    }
    index = this.activeResultTable2Item;
  }

  // #. Get table controls
  var $prevButton = this.$searchBox.find("".concat(parentClassName, " .controls .previousPage")).not('.disabled');
  var $nextButton = this.$searchBox.find("".concat(parentClassName, " .controls .nextPage")).not('.disabled');
  var $firstButton = this.$searchBox.find("".concat(parentClassName, " .controls .firstPage")).not('.disabled');
  var $lastButton = this.$searchBox.find("".concat(parentClassName, " .controls .lastPage")).not('.disabled');

  // #. Handle last row and first row event
  if (index > $rows.length - 1) {
    // #. Update index
    if (isResultTable1 === true) {
      this.activeResultTable1Item = 0;
    } else {
      this.activeResultTable2Item = 0;
    }

    // #. Trigger pagination controls
    if ($nextButton.length) {
      $nextButton.trigger('click');
    } else if ($firstButton.length) {
      $firstButton.trigger('click');
    }
    return;
  } else if (index < 0) {
    // #. Update index
    if (isResultTable1 === true) {
      this.activeResultTable1Item = -1;
    } else {
      this.activeResultTable2Item = -1;
    }

    // #. Trigger pagination controls
    if ($prevButton.length) {
      $prevButton.trigger('click');
    } else if ($lastButton.length) {
      $lastButton.trigger('click');
    }
    return;
  }

  // #. Get next row
  $next = $rows[index];

  // #. Set updated table item index
  if (isResultTable1 === true) {
    this.activeResultTable1Item = index;
  } else {
    this.activeResultTable2Item = index;
  }

  // #. Set the row as active
  this.setRowActive($($next));

  // #. Set focus to the active row for announcing by screenreader
  $($next).attr('tabindex', 0);
  $($next).focus();
};

/**
 * Set row active - add related css class
 */
SearchResultBox.prototype.setRowActive = function ($element) {
  if (!$element) {
    return;
  }

  // #. Remove tabindex attribute from the old element
  if (this.$searchBox.find('.keyboard-focus').attr('tabindex')) {
    this.$searchBox.find('.keyboard-focus').removeAttr('tabindex');
  }

  // #. Remove active class from the old element
  this.$searchBox.find('.keyboard-focus').removeClass('hover keyboard-focus');

  // #. Set active class to new element
  $element.addClass('hover keyboard-focus');
};

/**
 * Handle Tab key press event
 *
 * @param event
 * @param isShiftKeyPressed
 * @returns {boolean}
 */
SearchResultBox.prototype.onTabKeyPressed = function (event) {
  // #. Check whether the search is solar or not
  var isSolar = this.isSolarSearch();
  var shiftKey = event.shiftKey;

  // #. Handle the solar search
  if (isSolar) {
    this.onSolarTabKeyPressed(event);
    return true;
  }
  var activeElId = this.activeElementId();
  // #. Manage shift tab combination
  if (shiftKey === true) {
    switch (activeElId) {
      case ELEMENT_ID.LEFT_PANEL:
        event.preventDefault();
        this.setFocusToSearch();
        break;
      case ELEMENT_ID.RESULT_TABLE2:
        event.preventDefault();
        this.setFocusToSearch();
        this.$searchBox.find('.controls .back').trigger('click');
        break;
      case ELEMENT_ID.RESULT_TABLE1:
        event.preventDefault();
        this.setFocusToLeftPanel();
        break;
      case ELEMENT_ID.PAGINATION_CONTROL:
        {
          // #. List only visible in the first slide of the panel
          var $list = this.$searchBox.find('ul.search-list-items');
          var $rows = null;
          var $firstButton = this.getFirstPaginationButton();
          if (!$(event.target).is($firstButton)) {
            return true;
          }
          if ($list.is(':visible')) {
            var $table = this.$searchBox.find('.mainsearch table.list.marktr');
            if ($table.length > 0) {
              event.preventDefault();
              $rows = this.getResultTable1Rows();
              this.activeResultTable1Item = $rows.length - 1;
              this.setFocusToResultTable();
            }
          } else {
            event.preventDefault();
            $rows = this.getResultTable2Rows();
            this.activeResultTable2Item = $rows.length - 1;
            this.setFocusToResultTable2();
          }
          break;
        }
      default:
        break;
    }
  } else {
    switch (activeElId) {
      case ELEMENT_ID.SEARCH_INPUT:
        event.preventDefault();
        this.activeResultTable1Item = -1;
        this.setFocusToLeftPanel(true);
        break;
      case ELEMENT_ID.LEFT_PANEL:
        {
          var _$table = this.$searchBox.find('.mainsearch table.list.marktr');
          if (_$table.length > 0) {
            event.preventDefault();
            this.setFocusToResultTable(true, event);
          }
          break;
        }
      case ELEMENT_ID.RESULT_TABLE2:
        event.preventDefault();
        this.$searchBox.find('.controls .back').focus();
        break;
      default:
        break;
    }
  }
};

/**
 * Handle Tab key press event of solar search
 * @param {Event} event
 * @returns {boolean}
 */
SearchResultBox.prototype.onSolarTabKeyPressed = function (event) {
  var _this4 = this;
  var activeElId = this.activeElementId();
  var shiftKey = event.shiftKey;
  var setFocus = function setFocus() {
    event.preventDefault();
    _this4.setFocusToSolarSearchInput();
    return false;
  };

  // #. Handle shift combination
  if (shiftKey) {
    // #. Shift + Tab from level 0 will move the focus to solar search input
    if (activeElId === ELEMENT_ID.LEFT_PANEL) {
      return setFocus();
    }
  } else {
    var $lastElement = this.getLastFocusableElement();
    var res = false;
    switch (activeElId) {
      case ELEMENT_ID.PAGINATION_CONTROL:
        if ($(event.target).is($lastElement)) {
          res = setFocus();
        }
        break;
      case ELEMENT_ID.RESULT_TABLE1:
        if ($($lastElement).is('table')) {
          res = setFocus();
        }
        break;
      case ELEMENT_ID.LEFT_PANEL:
        if ($($lastElement).find('tr.noresults').length > 0) {
          res = setFocus();
        }
        break;
      case ELEMENT_ID.RESULT2_BACK:
        if ($($lastElement).is('span.back')) {
          event.preventDefault();
          this.setFocusToResultTable2();
          res = false;
        }
        break;
      default:
        res = true;
        break;
    }
    return res;
  }
  return true;
};

/**
 * Handle Enter key press event
 *
 * @param event
 * @returns {boolean}
 */
SearchResultBox.prototype.onEnterKeyPressed = function (event) {
  var _this5 = this;
  event.preventDefault();
  var activeElId = this.activeElementId();
  var res = false;

  // 1. Trigger left panel selected item click
  // 2. Result table 1 selected row click
  // 3. Result table 2 selected row click
  // 4. Result table 2 back button click
  // 5. Result table pagination control click
  // 6. Trigger arrow right key event
  switch (activeElId) {
    case ELEMENT_ID.LEFT_PANEL:
      this.activeResultTable1Item = 0;
      // #. Set aria-selected attribute to true
      this.$searchBox.find('li a.hover.keyboard-focus').attr('aria-selected', true).trigger('click');
      break;
    case ELEMENT_ID.RESULT_TABLE1:
      this.resetRowSelection2 = true;
      this.activeResultTable2Item = 0;
      this.$searchBox.find('.mainsearch table.list.marktr').find('tr.keyboard-focus').trigger('click');
      break;
    case ELEMENT_ID.RESULT_TABLE2:
      this.$searchBox.find('.ricsearch table.list.marktr').find('tr.keyboard-focus').trigger('click');
      break;
    case ELEMENT_ID.RESULT2_BACK:
      this.getActiveElement().trigger('click');
      window.setTimeout(function () {
        _this5.setFocusToResultTable();
      }, 300);
      break;
    case ELEMENT_ID.GENERIC_BUTTONS:
    case ELEMENT_ID.PAGINATION_CONTROL:
      this.getActiveElement().click();
      break;
    default:
      this.onArrowRightPressed(event);
      res = false;
      break;
  }
  return res;
};

/**
 * Get all focusable elements in the form
 */
SearchResultBox.prototype.getAllFocusableElements = function () {
  return this.$searchBox.find('button, [href], table.list, input, select, textarea, [tabindex]:not([tabindex="-1"])').not(':disabled').not(':hidden');
};

/**
 * Get last focusable element in the form
 */
SearchResultBox.prototype.getLastFocusableElement = function () {
  var $elements = this.getAllFocusableElements();
  var isResTab2Visible = this.isResultTable2Visible();

  // #. Remove the items under result table 2 when the table is not visible
  if (!isResTab2Visible) {
    for (var i = $elements.length; i >= 0; i--) {
      if ($($elements[i]).closest('.ricsearch').length > 0) {
        $elements.splice(i, 1);
      }
    }
  }
  return $elements[$elements.length - 1];
};

/**
 * Get DOM active element
 */
SearchResultBox.prototype.getActiveElement = function () {
  return $(document.activeElement);
};

/**
 * Get solar search input element
 */
SearchResultBox.prototype.getSolarSearchInput = function () {
  return this.$searchInput || $('.quickSearch input.incrementalSearch');
};

/**
 * Get result table 1 rows collection
 */
SearchResultBox.prototype.getResultTable1Rows = function () {
  return this.$searchBox.find('table tr').not(':first');
};

/**
 * Get first active pagination control button
 */
SearchResultBox.prototype.getFirstPaginationButton = function () {
  return this.$searchBox.find('.controls button:enabled').first();
};

/**
 * Get result table 2 rows collection
 */
SearchResultBox.prototype.getResultTable2Rows = function () {
  return this.$searchBox.find('.ricsearch table tr').not(':first');
};

/**
 * Set focus to solar search input element
 */
SearchResultBox.prototype.setFocusToSolarSearchInput = function () {
  this.getSolarSearchInput().focus();
};

/**
 * Set focus to solar search last focusable element
 */
SearchResultBox.prototype.setFocusToSolarLastFocusableElement = function () {
  this.getLastFocusableElement().focus();
};

/**
 * Set focus to the right panel result table
 */
SearchResultBox.prototype.setFocusToResultTable = function (isTabKey) {
  this.$searchBox.find('.mainsearch table.list.marktr').focus();
  if (!isTabKey) {
    var $rows = this.getResultTable1Rows();
    if (this.activeResultTable1Item === -1) {
      this.activeResultTable1Item = $rows.length - 1;
    }
    this.setRowActive($($rows[this.activeResultTable1Item]));
  } else {
    this.resetRowSelection = true;
  }
};

/**
 * Set focus to the result table 2
 */
SearchResultBox.prototype.setFocusToResultTable2 = function () {
  this.$searchBox.find('.ricsearch table.list.marktr').focus();
  var $rows = this.getResultTable2Rows();
  if (this.activeResultTable2Item === -1) {
    this.activeResultTable2Item = $rows.length - 1;
  }
  this.setRowActive($($rows[this.activeResultTable2Item]));
};

/**
 * Set focus to search input
 * @returns {*|jQuery}
 */
SearchResultBox.prototype.setFocusToSearch = function () {
  this.$searchInput.focus();
};

/**
 * Assign role to the inPage/solar main div
 * Purpose to assign the WCAG attributes
 */
SearchResultBox.prototype.setRootElementRole = function () {
  this.$searchBox.closest('form').attr({
    role: 'application'
  });
};

/**
 * Set focus to search input
 */
SearchResultBox.prototype.setFocusToLeftPanel = function (isTabKey) {
  this.$searchBox.find('ul.search-list-items').focus();
  if (!isTabKey) {
    // #. Get all rows from the left panel
    var $items = this.$searchBox.find('li a');

    // #. Get last selected item
    var $item = $items[this.activeLeftPanelItem];

    // #. Set element as active
    if ($item) {
      this.setRowActive($($item));

      // #. Set focus to the active row for announcing by screenreader
      $($item).attr('tabindex', 0);
      $($item).focus();
    }
  } else {
    this.activeLeftPanelItem = -1;
  }
};

/*
 * Listen the back button click event
 */
SearchResultBox.prototype.onBackButtonClicked = function () {
  var _this6 = this;
  this.$searchBox.find('.controls .back').click(function () {
    _this6.disableResult2TabIndex();
  });
};

/**
 * Check whether the table is visible or not
 * Only visible table has class 'active'
 */
SearchResultBox.prototype.isResultTable2Visible = function () {
  return this.$searchBox.find('.ricsearch.active').length > 0;
};

/**
 * Disable tab index of buttons under result table 2
 */
SearchResultBox.prototype.disableResult2TabIndex = function () {
  var btnAttr = {
    tabindex: -1
  };
  var $ricSearch = this.$searchBox.find('.ricsearch');

  // #. Disable the table focus
  $ricSearch.find('table.list').attr(btnAttr);

  // #. Disable tabindex of the back button
  $ricSearch.find('.controls .back').attr(btnAttr);

  // #. Disable tabindex of pagination controls
  $ricSearch.find('.firstPage,.nextPage,.lastPage,.previousPage').attr(btnAttr);
  $ricSearch.find('.firstPage,.nextPage,.lastPage,.previousPage').attr(btnAttr);

  // #. Remove tab index from table row
  $ricSearch.find('tr.keyboard-focus').removeAttr('tabindex').removeClass('hover keyboard-focus');
};

/**
 * Enable tab index of buttons under result table 2
 */
SearchResultBox.prototype.enableResult2TabIndex = function () {
  var btnAttr = {
    tabindex: 0
  };
  var $ricSearch = this.$searchBox.find('.ricsearch');

  // #. Enable tabindex of the back button
  $ricSearch.find('.controls .back').attr(btnAttr);

  // #. Enable tabindex of pagination controls
  $ricSearch.find('table.list').attr(btnAttr);
};
SearchResultBox.prototype.checkDirectRicHit = function () {
  var _this7 = this;
  var timestamp = Date.now();
  var checkDirectHit = function checkDirectHit() {
    if (_this7.navigationData && _this7.searchTerm && _this7.navigationData[0] && _this7.searchTerm === _this7.navigationData[0].searchTerm[0]) {
      // Navigation data exist and its searchTerm matches with the current searchTerm
      if (_this7.results && _this7.results.length > 0 && !!_this7.results[0][window.themeProperties['incrementalSearch.symbolHitFromIncrementalResponseField']]) {
        var ric = _this7.results[0][window.themeProperties['incrementalSearch.symbolHitFromIncrementalResponseField']];
        var tickerOverride = null;
        if (_this7.results[0]['exchangePlace'] === 'LIP' && _this7.results[0]['type'] === 'FUN') {
          tickerOverride = _this7.results[0]['ticker'];
        }
        if (_this7.config.searchRicCallback) {
          _this7.hide();
          if (_this7.config.searchRicCallbackScope) {
            _this7.config.searchRicCallback.call(_this7.config.searchRicCallbackScope, {
              ric: ric,
              tickerOverride: tickerOverride
            });
          } else {
            _this7.config.searchRicCallback({
              ric: ric,
              tickerOverride: tickerOverride
            });
          }
        } else {
          defaultItemClickCallback(_this7.searchType, {
            ric: ric
          }, _this7);
        }
      } else {
        // check extraserver as fallback when incremental search does not know id
        checkExtraserver();
      }
    } else if (Date.now() < timestamp + 8000) {
      // Requests are still pending
      window.setTimeout(function () {
        checkDirectHit();
      }, 100); // wait some time whether there will be a result
    }
  };

  var checkExtraserver = function checkExtraserver() {
    (0, _ajaxRequest.ajaxGetJson)("/generalSearch.action?method=testStringForInstrumentId&test=".concat(encodeURIComponent(_this7.searchTerm))).then(function (result) {
      var isRic = result.isRic,
        ric = result.ric,
        link = result.link,
        isId = result.isId,
        isISIN = result.isISIN,
        isin = result.isin,
        description = result.description,
        type = result.type;
      // To handle duplicate entries in search history while adding ric (edit module -> search)
      if (link && (!_this7.config.searchRicCallback || isISIN)) {
        var params = {
          ric: ric
        };
        if (isISIN) {
          params.isin = isin;
        }
        // save to search history
        _axios.default.post('/searchHistory/updateHistory', params).catch(function (error) {
          console.error(error);
        });
      }
      if (_this7.dfaShortCut && (isRic || isId || isISIN)) {
        handleDFAShortCut(result, _this7);
        return;
      }
      if (isRic) {
        if (_this7.config.searchRicCallback) {
          _this7.hide();
          if (_this7.config.searchRicCallbackScope) {
            _this7.config.searchRicCallback.call(_this7.config.searchRicCallbackScope, {
              name: description,
              ric: ric,
              isin: isin,
              type: type
            });
          } else {
            _this7.config.searchRicCallback({
              name: description,
              ric: ric,
              isin: isin,
              type: type
            });
          }
        } else {
          defaultItemClickCallback(_this7.searchType, {
            ric: ric
          }, _this7);
        }
      } else if (link && !_this7.config.searchRic) {
        // only when isin is enough
        // TODO: only redirect when there is no specific click handler. e.g. a popup search on a screener should never link to detail page!
        window.redirectTo("/detail/detailPage.html?".concat(link));
        if (!_this7.config.static) {
          _this7.hide();
        }
      } else if (isISIN && _this7.config.searchRic) {// display ric hits for that isin
        // TODO: try to open ric results like if user clicked the isin, but as user
        //       anyhow has then to select a ric, it's not that severe that he must click on the isin also
        //       in the moment (one unnecessary step)
      } else if (!isId && ric && !_this7.config.ignoreUncertainRics) {
        // expect this to be a chain ric or speedguide
        speedGuideRedirect(ric, _this7.dfaShortCut);
      } else if (_this7.config.multipleSymbolInputCallback) {
        // no hits from solr and also not from extraserver, try whether it could be a multi symbol paste
        var rics = _this7.searchTerm.trim().split(/\s*[,;\n\s]\s*/);
        rics = rics.filter(function (v) {
          return v != '';
        }); // remove array positions with only empty strings
        if (rics.length > 1) {
          _this7.hide();
          _this7.config.multipleSymbolInputCallback(rics);
        }
      }
    });
  };
  if (window.themeProperties['incrementalSearch.symbolHitFromIncrementalResponseField']) {
    checkDirectHit();
  } else {
    checkExtraserver();
  }
};
SearchResultBox.prototype.hide = function () {
  this.searchTerm = null;
  this.ajaxPending = false;
  this.searchType = this.config.searchType || _searchTypesEnum.default.INSTRUMENTS;
  this.searchFilter = null;
  this.instrumentTypes = this.config.instrumentTypes || ['*'];
  this.page = 1;
  this.$searchBox.css('display', 'none');
  this.logTimeTracking();
};
SearchResultBox.prototype.show = function () {
  // #. Bind the solar search button keydown event
  if (this.isSolarSearch()) {
    this.onSolarSearchButtonKeydown();
  }
  // TODO: check if this function is even necessary as render() resets this anyway
  this.$searchBox.css('display', 'block');
};
SearchResultBox.prototype.logTimeTracking = function () {
  if (this.timeTracking && this.timeTracking.length) {
    var sum = 0;
    var max = 0;
    var finalSearchTerm = "";
    this.timeTracking.forEach(function (item) {
      sum += item.millis;
      if (item.millis > max) {
        max = item.millis;
      }
      if (item.searchTerm.length > finalSearchTerm.length) {
        finalSearchTerm = item.searchTerm;
      }
    });
    var avg = sum / this.timeTracking.length;
    window.logExecutionTime('incrementalSearch', avg, "".concat(this.timeTracking.length, " search queries for \"").concat(finalSearchTerm, "\", avg ").concat(avg, "ms, max ").concat(max, "ms time to display per query"));
    this.timeTracking = [];
  }
};

/**
 * Key handler for the solar search icon button
 * Tab - key will move the focus to result table list menu
 */
SearchResultBox.prototype.onSolarSearchButtonKeydown = function () {
  var _this8 = this;
  // #. Get the search input
  var $input = this.getSolarSearchInput();

  // #. Get the search icon button
  this.$solarSearchButton = $input.next('button.search');
  var inputID = 'incrementalsearch_results';
  var resultTable = "#".concat(inputID);

  // #. Unbind the keydown event
  this.$solarSearchButton.off('keydown');

  // #. Bind the keydown event
  this.$solarSearchButton.on('keydown', function (event) {
    var isResultVisible = $(resultTable).is(':visible');
    // #. Set focus to item list - level 0 when the result table is visible
    if (event.keyCode === _keyCodes.default.TAB && isResultVisible && !event.shiftKey) {
      event.preventDefault();
      event.stopPropagation();
      _this8.setFocusToLeftPanel();
      return false;
    }
  });
};
SearchResultBox._analyseSearchTerm = function (searchTerm) {
  if (!searchTerm || searchTerm.length < 1) {
    return {
      term: '',
      error: 'empty search string',
      dfaShortCut: null
    };
  } else {
    var serchTermWithDFAShortCut = searchTerm.split('/');
    if (serchTermWithDFAShortCut.length == 1) {
      return {
        term: searchTerm,
        error: '',
        dfaShortCut: null
      };
    } else {
      var vdfaShortCut = serchTermWithDFAShortCut.pop();
      var vterm = serchTermWithDFAShortCut.join('/');
      return {
        term: vterm,
        error: '',
        dfaShortCut: vdfaShortCut
      };
    }
  }
};
SearchResultBox.prototype.setSearchTerm = function (searchTerm, instantSearch) {
  var _this9 = this;
  var searchTermStatus = SearchResultBox._analyseSearchTerm(searchTerm);
  searchTerm = searchTermStatus.term;
  var oldSearchTerm = this.searchTerm;
  this.searchTerm = searchTerm.trim();
  this.page = 1; //reset the page to first page when there is a change in search term
  this.dfaShortCut = searchTermStatus.dfaShortCut == null ? null : searchTermStatus.dfaShortCut.trim();
  if (instantSearch && !this.config.disableInstantSearch) {
    this.itemsPerPage = 1;
    this.checkDirectRicHit();
  } else {
    this.calculateItemsPerPage();
  }
  var isSearchTermValid = this.searchTerm && this.searchTerm.length > 0;
  if (!isSearchTermValid) {
    this.navigationData = [];
  }
  if (!isSearchTermValid || this.searchTerm === oldSearchTerm) {
    // do nothing and return a successful promise
    this.render(); // TODO: full rerender should not be necessary here (currently necessary because render attaches the proper click handlers to hide the overlay)
    return Promise.resolve([]);
  }
  return Promise.all(this.availableTypes.map(this.requestSearchType.bind(this))).then(function (responseList) {
    _this9.ajaxPending = false;
    if (responseList[0] && responseList[0].searchTerm && responseList[0].searchTerm[0] === _this9.searchTerm) {
      _this9.setData(responseList);
      _this9.render();
      _this9.updatePosition();
    }
    _this9.logData(responseList);
    return responseList;
  });
};
SearchResultBox.prototype.requestSearchType = function (type) {
  var offset = (this.page - 1) * this.itemsPerPage;
  var settings = {
    type: type,
    term: this.searchTerm,
    offset: offset,
    limit: this.itemsPerPage,
    filter: this.instrumentTypes[0],
    countInstTypeOnly: this.countInstTypeOnly
  };
  var filter = this.searchFilter ?? this.config.instrumentTypes ?? '*';
  settings.filter = filter;
  if (!this.searchTerm || this.searchTerm.length < 1) {
    return {
      // return an empty list in case of errors
      type: type,
      count: 0,
      result: [],
      facets: [],
      error: 'empty search string'
    };
  }
  if ((window.user.locale === 'ja' || window.user.locale === 'zh') && type === "instruments") {
    // fetch the index based on user locale
    var index = window.user.locale === 'ja' ? 'LMM_ja' : 'LMM_zh';
    var shortenInstrumentTitle = filter === "*" ? "*" : Object.keys(INSTRUMENT_ENUM).find(function (key) {
      return INSTRUMENT_ENUM[key] === filter;
    });
    return this.requestSearchTypeForAsia(index, shortenInstrumentTitle);
  } else {
    this.ajaxPending = true;
    return (0, _ajaxRequest.ajaxGetJson)('/incrementalSearch.action', settings).catch(function (error) {
      return {
        // return an empty list in case of errors
        type: type,
        count: 0,
        result: [],
        facets: [],
        error: error
      };
    });
  }
};
SearchResultBox.prototype.requestSearchTypeForAsia = function (index) {
  var _this10 = this;
  var instrument = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "*";
  return new Promise(function (resolve, reject) {
    // set the payload for api request
    var payload = {
      search: _this10.searchTerm,
      instrumentType: [instrument],
      exchanges: [],
      fids: ["symbol", "type", "country", "currency", "exchangePlace", "displayname", "id"],
      pageSize: _this10.itemsPerPage,
      pageNo: _this10.page - 1,
      boost: {}
    };
    window.dory.ServiceRest.post("/find/globalsearch/".concat(index), payload).then(function (response) {
      var responseData = response.data;
      var modifiedData = {};
      if (responseData.status === "OK") {
        // Modify the data object to the required format
        modifiedData.count = responseData.totalCount;
        modifiedData.result = [];
        modifiedData.searchTerm = [_this10.searchTerm];
        modifiedData.type = "instruments";
        modifiedData.facets = [];
        var partialCounts = responseData.partialCounts;
        var instrumentAvailable = Object.keys(partialCounts);
        // Update facets
        for (var _i = 0, _instrumentAvailable = instrumentAvailable; _i < _instrumentAvailable.length; _i++) {
          var _instrument = _instrumentAvailable[_i];
          var instrumentTitle = INSTRUMENT_ENUM[_instrument];
          modifiedData.facets.push({
            count: partialCounts[_instrument],
            title: window.getMessage("instrumentType.select.".concat(instrumentTitle)),
            value: instrumentTitle
          });
        }
        // Update result array
        modifiedData.result = responseData.data.map(function (data) {
          return {
            country: data.country,
            description: data.displayname,
            type: data.type,
            group: data.type === "CHN" ? INSTRUMENT_ENUM["CHN"] : window.getMessage("instrumentType.select.".concat(INSTRUMENT_ENUM[data.type])),
            isin: data.id !== data.symbol ? data.id : '',
            symbol: data.symbol
          };
        });
      }
      resolve(modifiedData);
    }).catch(function (error) {
      reject({
        type: "instruments",
        count: 0,
        result: [],
        facets: [],
        error: error
      });
    });
  });
};
SearchResultBox.prototype.setPage = function (page) {
  this.page = page;
  this.refresh();
};
SearchResultBox.prototype.refresh = function (resetNavigationIndex) {
  var _this11 = this;
  this.requestSearchType(this.searchType).then(function (results) {
    _this11.setResults(results);
    if (_this11.navigationData[resetNavigationIndex]) {
      _this11.navigationData[resetNavigationIndex] = results;
    }
    _this11.render();
    var $table = _this11.$searchBox.find('.mainsearch table.list.marktr');
    if ($table.is(':visible')) {
      _this11.setFocusToResultTable();
    } else {
      _this11.setFocusToResultTable2();
    }
  });
};
SearchResultBox.prototype.setSearchType = function (type, filter) {
  this.page = 1;
  this.searchType = type;
  this.searchFilter = filter || null;
  var resetNavigationIndex = this.availableTypes.indexOf(type);
  this.refresh(resetNavigationIndex);
};
SearchResultBox.prototype.getTableControls = function () {
  var _this12 = this;
  var pages = Math.ceil(this.totalItems / this.itemsPerPage);
  return (0, _basicTableControls.default)({
    page: this.page,
    pages: pages,
    noLastPage: this.searchType === _searchTypesEnum.default.NEWS,
    first: function first() {
      _this12.setPage(1);
    },
    prev: function prev() {
      _this12.setPage(_this12.page - 1);
    },
    next: function next() {
      _this12.setPage(_this12.page + 1);
    },
    last: function last() {
      _this12.setPage(pages);
    },
    tableCaption: this.getTableCaption()
  });
};
SearchResultBox.prototype.getTableCaption = function () {
  return (0, _messageHandler.getMessage)('incrementalsearch.results');
};
var getCountString = function getCountString(type, count, limit) {
  return type !== 'news' ? count : count > limit ? (0, _messageHandler.getMessage)('incrementalsearch.countplus', limit) : count;
};
var generateCountryFlag = function generateCountryFlag(country) {
  if (country) {
    return "<span title=\"".concat(window.YAHOO.lang.escapeHTML(country), "\" class=\"country ").concat(window.YAHOO.lang.escapeHTML(country), "\" style=\"width:16px;\"></span>");
  }
  return "<span style=\"width:16px;\"></span>";
};
var formatColumnValue = function formatColumnValue(value, columnName, searchType, item) {
  value = value ? value : '';
  switch (columnName) {
    case 'headline':
    case 'description':
    // case 'displayname':
    case 'displaynameLeumi': // For several North American customers.
    case 'bnd_issuer':
    case 'caption':
      return "<span title=\"".concat(window.YAHOO.lang.escapeHTML(value), "\" style=\"text-align: left\">").concat(window.YAHOO.lang.escapeHTML(value), "</span>");
    case 'timestamp':
      return window.YAHOO.fcom.Format.formatDateTime(new window.fcom.date.DateTime().setTimestamp(value), {
        style: 'dateTimeLong'
      });
    case 'page':
      return "<span>".concat(value.map(function (a) {
        return "<span>".concat(window.YAHOO.lang.escapeHTML(a), "</span>");
      }).join("<span class=\"spacer\">".concat(pagePathDivider, "</span>")), "</span>");
    case 'quickQuote':
      return "<span class=\"link quickQuote\" onclick=\"quickQuote('".concat(item.symbol || item.id, "', event)\">Quick Quote</span>");
    case 'bnd_issuer_domicile':
      return "<span title=\"".concat(window.YAHOO.lang.escapeHTML(value), "\" class=\"country ").concat(window.YAHOO.lang.escapeHTML(value), "\" style=\"width:16px;\"></span>");
    case 'country':
      return "<span title=\"".concat(window.YAHOO.lang.escapeHTML(value), "\" class=\"country large ").concat(window.YAHOO.lang.escapeHTML(value), "\" style=\"width:32px;\"></span>");
    default:
      return window.YAHOO.lang.escapeHTML(value);
  }
};
var defaultItemClickCallback = function defaultItemClickCallback(type, item, searchResultBox, evt) {
  var dfaStatus = decideDirectFunctionAccess(type, item, evt);
  switch (dfaStatus.state) {
    case DFA_STATUS.CREATE:
      {
        toDirectFunctionAccess(type, item, dfaStatus.parent);
        break;
      }
    case DFA_STATUS.IRRELEVANT:
      {
        redirectDecision(type, item, searchResultBox);
        break;
      }
  }
};
var handleDFAShortCut = function handleDFAShortCut($searchTermMetaDta, $searchResultBox) {
  (0, _ajaxRequest.ajaxGet)(dfaNavDataRestLink, generateDataItem($searchTermMetaDta)).then(function (response) {
    var navData = JSON.parse(response);
    var navDataForShortCut = _DirectFunctionAccessPanel.default.navDataForShortCode(navData.itemList, $searchResultBox.dfaShortCut);
    if ($searchResultBox.dfaShortCut != navDataForShortCut.shortCode && !(RIC_PATTTERN.test($searchResultBox.searchTerm) || FUTURE_RIC_PATTERN.test($searchResultBox.searchTerm))) {
      speedGuideRedirect($searchResultBox.searchTerm, $searchResultBox.dfaShortCut);
    } else {
      dfaRedirect($searchTermMetaDta, navDataForShortCut);
    }
  }).catch(function (e) {
    console.error(e);
    dfaRedirect($searchTermMetaDta, {
      linkCode: 'overv'
    });
  });
};
/*
    When search term is an ISIN use the RIC from navigation data
    because ric is the safest id for all detail pages.
 */
var dfaRedirect = function dfaRedirect($instrMetaData, $navMetaData) {
  var instrData = {};
  if ($instrMetaData.isISIN) {
    if ($navMetaData.ric) {
      instrData = Object.assign(instrData, {
        isin: $instrMetaData.isin,
        symbol: $navMetaData.ric
      });
    } else {
      instrData = Object.assign(instrData, {
        isin: $instrMetaData.isin
      });
    }
  } else {
    instrData = Object.assign(instrData, {
      isin: $instrMetaData.isin,
      symbol: $instrMetaData.ric
    });
  }
  if ($navMetaData.linkUrl && $navMetaData.linkUrl.includes('&view=')) {
    var queryParams = $navMetaData.linkUrl.split('?')[1];
    var viewName = new URLSearchParams(queryParams).get('view');
    instrData = Object.assign(instrData, {
      viewName: viewName
    });
  }
  _DirectFunctionAccessPanel.default.redirectToFunction(instrData, $navMetaData.linkCode);
};
var DFA_STATUS = {
  CREATE: 'create',
  ACTIVE: 'active',
  IRRELEVANT: 'irrelevant'
};
var decideDirectFunctionAccess = function decideDirectFunctionAccess(type, item, evt) {
  if (type === _searchTypesEnum.default.INSTRUMENTS) {
    if (item.isin || item.id || item.symbol) {
      var dfaParentRow = evt.target.closest("tr");
      if (!_DirectFunctionAccessPanel.default.isActive(dfaParentRow)) {
        return {
          state: DFA_STATUS.CREATE,
          parent: dfaParentRow
        };
      } else {
        return {
          state: DFA_STATUS.ACTIVE,
          parent: dfaParentRow
        };
      }
    }
  }
  return {
    state: DFA_STATUS.IRRELEVANT,
    parent: null
  };
};
var toDirectFunctionAccess = function toDirectFunctionAccess(type, $item, $dfaParentRow) {
  (0, _ajaxRequest.ajaxGet)(dfaNavDataRestLink, generateDataItem($item)).then(function (response) {
    var navData = JSON.parse(response);
    var dfa = new _DirectFunctionAccessPanel.default(navData, $dfaParentRow, $item);
    dfa.render();
  }).catch(function (e) {
    console.error(e);
    redirectDecision(type, item, searchResultBox);
  });
};
var generateDataItem = function generateDataItem($item) {
  return $item.isin ? {
    isin: $item.isin
  } : {
    ric: $item.symbol || $item.id
  };
};
var redirectDecision = function redirectDecision(type, item, searchResultBox) {
  var _SEARCHTYPE$NEWS$SEAR;
  // choose the appropriate function and pass item to get the new target url
  if (item.ric) {
    window.redirectTo(directRicLink(item));
    return;
  }
  window.location = window.ctx + (_SEARCHTYPE$NEWS$SEAR = {}, _defineProperty(_SEARCHTYPE$NEWS$SEAR, _searchTypesEnum.default.NEWS, newsLink), _defineProperty(_SEARCHTYPE$NEWS$SEAR, _searchTypesEnum.default.INSTRUMENTS, detailLink), _defineProperty(_SEARCHTYPE$NEWS$SEAR, _searchTypesEnum.default.WLPF, item.group === 'WL' ? watchlistLink : portfolioLink), _defineProperty(_SEARCHTYPE$NEWS$SEAR, _searchTypesEnum.default.NAV, pageLink), _defineProperty(_SEARCHTYPE$NEWS$SEAR, _searchTypesEnum.default.ISSUER, bondIssuerLink), _SEARCHTYPE$NEWS$SEAR)[type](item);
  if (!searchResultBox.config.static) {
    searchResultBox.hide();
  }
};
var ricSearchItemClickCallback = function ricSearchItemClickCallback(type, item, searchResultBox) {
  var tickerOverride = null;
  if (item.exchangePlace === 'LIP' && item.type === 'FUN') {
    tickerOverride = item.ticker;
  }
  (0, _ajaxRequest.ajaxPostJson)('/generalSearch.action', {
    method: 'handleRicSearch',
    id: item.symbol || item.id,
    isin: item.isin
  }).then(function (response) {
    if (response.result.length <= 1) {
      var ric = item.symbol || item.id;
      if (response.result.length === 1 && response.result[0].ric) {
        ric = response.result[0].ric;
      }
      // use item ric instead of exchange selection
      searchResultBox.hide();
      if (searchResultBox.config.searchRicCallbackScope) {
        searchResultBox.config.searchRicCallback.call(searchResultBox.config.searchRicCallbackScope, {
          ric: ric,
          name: item.description || item.displaynameLeumi,
          tickerOverride: tickerOverride,
          type: item.type
        });
      } else {
        searchResultBox.config.searchRicCallback({
          ric: ric,
          name: item.description || item.displaynameLeumi,
          tickerOverride: tickerOverride,
          type: item.type
        });
      }
      return;
    }
    var $ricSearch = searchResultBox.$searchBox.find('.ricsearch');
    new _ThirdLevelTable.default($ricSearch.get(0), response, {
      itemsPerPage: searchResultBox.itemsPerPage,
      columns: searchResultBox.config.l3Columns,
      clickHandler: function clickHandler() {
        searchResultBox.hide();
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        if (searchResultBox.config.searchRicCallbackScope) {
          var _searchResultBox$conf;
          (_searchResultBox$conf = searchResultBox.config.searchRicCallback).call.apply(_searchResultBox$conf, [searchResultBox.config.searchRicCallbackScope].concat(args));
        } else {
          var _searchResultBox$conf2;
          (_searchResultBox$conf2 = searchResultBox.config).searchRicCallback.apply(_searchResultBox$conf2, args);
        }
      }
    });
    $ricSearch.addClass('active');
    var $mainSearch = searchResultBox.$searchBox.find('.mainsearch');
    $mainSearch.removeClass('active');
    searchResultBox.enableResult2TabIndex();
    searchResultBox.onBackButtonClicked();
    $ricSearch.find('table.list').focus();
  });
};
SearchResultBox.prototype.handleItemClick = function (item, e) {
  var callbackFunction = this.config.itemCallback || (this.config.searchRic ? ricSearchItemClickCallback : defaultItemClickCallback);
  callbackFunction(this.searchType, item, this, e);
};
SearchResultBox.prototype.getNavigationListItem = function (name, count, isActive, clickHandler) {
  var sublist = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  return $('<li/>').toggleClass('active', isActive).append($('<a/>').attr({
    role: 'tab',
    'aria-controls': 'panelMainSearch',
    'aria-selected': isActive,
    tabindex: this.config.isMobile ? 0 : -1
  }).html("<span class=\"name\">".concat(name, "</span> <span class=\"count\">").concat(count, "</span>")).on('click', clickHandler)).append(sublist);
};
SearchResultBox.prototype.render = function () {
  var _this13 = this;
  var showFlags = !window.user.isChinaSpecificUser;
  var _this = this;
  this.navigationData = this.navigationData || [];

  // Create Navigation HTML
  var searchResultNavigation = this.navigationData.map(function (navigationItem) {
    navigationItem.facets = navigationItem.facets || [];
    var getClickHandler = function getClickHandler(facetValue) {
      return function () {
        _this.$searchBox.find('li').removeClass('active');
        if (facetValue === _this.searchFilter) {
          _this.setSearchType(navigationItem.type);
        } else {
          $(this).parent('li').addClass('active');
          $(this).attr('aria-selected', true);
          _this.setSearchType(navigationItem.type, facetValue);
        }
      };
    };
    var name = (0, _messageHandler.getMessage)("incrementalsearch.type.".concat(navigationItem.type));
    var sublist = navigationItem.facets.filter(function (f) {
      return f.count;
    }) // filter out facets without results
    .map(function (facet) {
      return _this13.getNavigationListItem(facet.title, facet.count, _this13.searchFilter === facet.value, getClickHandler(facet.value));
    });
    sublist = sublist.length ? $('<ul/>').append(sublist) : [];
    return _this13.getNavigationListItem(name, getCountString(navigationItem.type, navigationItem.facets.reduce(function (sum, a) {
      return sum + a.count;
    }, 0) || navigationItem.count, _this13.itemsPerPage), !_this13.searchFilter && navigationItem.type === _this13.searchType, getClickHandler(), sublist);
  });

  // Get Table Columns to be displayed
  var tableColumns = Object.assign({}, tableColumnDefinitions, this.config.columns || {})[this.searchType] || [];
  if (!(this.config.columns && this.config.columns[this.searchType]) && this.results && this.results[0] && this.results[0].ticker && this.searchType === _searchTypesEnum.default.INSTRUMENTS) {
    // if a ticker is available it should be used instead of ISIN
    tableColumns = ['description', 'group', 'ticker'];
    if (this.results[0].country) {
      tableColumns.push('country');
    }
  }
  // Create Results HTML if available
  var searchResults = null;
  if (this.results) {
    _DirectFunctionAccessPanel.default.deActivate();
    searchResults = this.results.map(function (resultRow) {
      return $('<tr/>').attr('role', 'button').attr('tabindex', _this13.isMobile ? 0 : -1).append(_this13.searchType === _searchTypesEnum.default.INSTRUMENTS && showFlags ? "<td>".concat(generateCountryFlag(resultRow.country), "</td>") : '').append(tableColumns.map(function (col) {
        return "<td class=\"".concat(col === 'ticker' ? 'trim' : '', "\">").concat(formatColumnValue(resultRow[col], col, _this13.searchType, resultRow), "</td>");
      })).on('click', function (e) {
        if (_DirectFunctionAccessPanel.default.allowClick()) {
          _this13.handleItemClick(resultRow, e);
        }
        e.stopPropagation();
      });
    });
  }
  var $resultTable = $('<table/>').addClass('list').append($('<colgroup/>').append(this.searchType === _searchTypesEnum.default.INSTRUMENTS && showFlags ? $('<col/>').css('width', '30px') : '').append(tableColumns.map(function (colName) {
    return $('<col/>').addClass("col-".concat(colName));
  }))).append($('<tr/>').append(tableColumns.map(function (colName) {
    return $('<th/>').text((0, _messageHandler.getMessage)("incrementalsearch.col.".concat(_this13.searchType, ".").concat(colName))).attr('colSpan', _this13.searchType === _searchTypesEnum.default.INSTRUMENTS && colName === 'description' && showFlags ? 2 : 1);
  })));
  var $ul = $('<ul/>').attr({
    tabindex: 0
  }).addClass('search-list-items').attr('role', 'tablist').append(searchResultNavigation);
  var $mainsearchRightPanel = $('<div/>').append($resultTable);
  if (searchResults && searchResults.length) {
    var $tableCaption = $('<caption/>').text(this.getTableCaption()).addClass('visuallyhidden');
    $resultTable.addClass('marktr').attr('tabindex', 0).prepend($tableCaption).append(searchResults);
    $mainsearchRightPanel.append(this.getTableControls());
  } else {
    $resultTable.append($('<tr/>').addClass('noresults').append($('<td/>').attr('colspan', tableColumns.length).attr({
      'role': 'alert',
      'aria-live': 'polite'
    }).html((0, _messageHandler.getMessage)('incrementalsearch.noresults', (0, _messageHandler.getMessage)("incrementalsearch.type.".concat(this.searchType))))));
  }
  var $results = $('<div/>').addClass('mainsearch active').attr({
    role: 'tabpanel',
    id: 'panelMainSearch'
  }).attr('id', 'panelMainSearch').append($ul).append($mainsearchRightPanel);
  var $combinedResults = $('<div/>').addClass('search-results').append($results).append('<div class="ricsearch"></div>');

  // Add items to DOM
  this.$searchBox.html('').append($combinedResults);
  if (!this.config.static) {
    // Register a body click handler to remove the box
    var clickFunction = function clickFunction(e) {
      if (!$(e.target).parents("#".concat(_this13.config.searchBoxId)).length && !$(e.target).is('[data-incrementalsearch]') && !e.target.isEqualNode(_this13.$searchInput[0])) {
        $('body').unbind('click', clickFunction);
        _this13.hide();
      }
    };
    $('body').on('click', clickFunction.bind(_this));
  }
};

// Position Search Box properly on the screen
SearchResultBox.prototype.updatePosition = function () {
  var enableSmartPositioning = this.config.smartPositioning || false;
  var height = this.$searchBox.outerHeight();
  var position = this.searchInputOffset;
  var top = position.top + this.searchInputHeight;
  if (enableSmartPositioning && this.showOnTop) {
    top = position.top - height - 8;
  }
  this.$searchBox.css({
    top: "".concat(top, "px")
  });
  window.setTimeout(function () {
    window.YAHOO.widget.Overlay.windowResizeEvent.fire();
  });
};
SearchResultBox.prototype.setResults = function (_ref) {
  var result = _ref.result,
    type = _ref.type,
    count = _ref.count,
    error = _ref.error;
  if (error) {
    console.error(error);
  }
  this.results = result;
  this.searchType = type;
  this.totalItems = Math.min(this.itemsPerPage * 100, count); // sets the 'totalItems' based on 'itemsPerPage' to limit the page size to 100
};

SearchResultBox.prototype.setData = function (data) {
  this.navigationData = data;
  // Take the first resultset that has any results, or as fallback select instruments (index 0)
  var returnResult = data.find(function (f) {
    return !!f && f.count;
  });
  this.setResults(returnResult || data[0]);
};
SearchResultBox.prototype.logData = function (data) {
  data.map(function (navigationItem) {
    if (navigationItem && navigationItem.pathString) {
      console.log({
        Solr_search_human_readable: navigationItem.pathString
      });
      console.log("Solr search link: ".concat(encodeURI(navigationItem.pathString)));
    }
  });
};
SearchResultBox.prototype.calculateItemsPerPage = function () {
  this.searchInputOffset = this.$searchInput.offset();
  var searchInputX = this.searchInputOffset.top - $(window).scrollTop();
  this.showOnTop = true;
  var availableHeight = searchInputX;
  if (availableHeight < window.innerHeight - (searchInputX + this.searchInputHeight)) {
    // Top has more space, show results on bottom
    this.showOnTop = false;
    availableHeight = window.innerHeight - searchInputX - this.searchInputHeight;
  }
  var headRowHeight = 44;
  var rowHeight = 45;
  var paginationHeight = 30;
  var searchBoxSpacing = 10;
  var possibleRows = (availableHeight - headRowHeight - paginationHeight - searchBoxSpacing) / rowHeight;
  if (possibleRows > 4 && possibleRows < maxItemsPerPage) {
    this.itemsPerPage = Math.floor(possibleRows);
  }
};
var speedGuideRedirect = function speedGuideRedirect(ric, dfaShortCut) {
  // Convert ric to uppercase only if it's currently in lowercase
  var modifiedRic = ric && ric.toLowerCase() === ric ? ric.toUpperCase() : ric;
  // Convert dfa to uppercase only if it's currently in lowercase
  var modifiedDFA = dfaShortCut && dfaShortCut.toLowerCase() === dfaShortCut ? dfaShortCut.toUpperCase() : dfaShortCut;
  var joinedRic = dfaShortCut ? modifiedRic + '/' + modifiedDFA : ric;
  window.redirectTo("/detail/detailPage.html?ric=".concat(encodeURIComponent(joinedRic)));
};
var _default = exports.default = SearchResultBox;

},{"../../app/utils/axios":1,"core/Ajax/ajaxRequest":7,"fcom/messages/messageHandler":12,"fcom/search/DirectFunctionAccessPanel":129,"fcom/search/ThirdLevelTable":132,"fcom/search/basicTableControls":133,"fcom/search/searchTypesEnum":135,"fcom/util/enums/keyCodes":139}],132:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _messageHandler = require("fcom/messages/messageHandler");
var _basicTableControls = _interopRequireDefault(require("fcom/search/basicTableControls"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var tableFidlets = ['SEGMENT', 'DATA_QUALITY_IMAGE', 'TRADE_PRICE_MARKED', 'CURRENCY_SHORT'];
var TABLE_ACTIONS = {
  FIRST: 0,
  PREVIOUS: 1,
  NEXT: 2,
  LAST: 3
};
var ThirdLevelTable = function ThirdLevelTable(node, data, config) {
  var _this = this;
  var tableFidletsAtm = tableFidlets.slice(0);
  if (data.type === 'FUT') {
    tableFidletsAtm = ['EXPIR_DATE', 'RIC_KEY', 'DATA_QUALITY_IMAGE', 'TRADE_PRICE_MARKED', 'CURRENCY_SHORT'];
  }
  var fidlets = config.columns.length > 0 ? config.columns : window.themeProperties['incrementalSearch.level3Columns'] || tableFidletsAtm;
  this.columns = fidlets.map(function (a) {
    var index = data.fidlets.findIndex(function (f) {
      return f[0] === a;
    });
    return [].concat(_toConsumableArray(data.fidlets[index]), [index]);
  });
  this.rawData = data;
  this.data = data.result.map(function (a) {
    return {
      ric: a.ric,
      isin: a.isin,
      data: _this.columns.map(function (c) {
        return a.data[c[2]];
      }) // find datapoints that are in the columns array
    };
  });

  this.type = data.type;
  if (data.type === 'FUT') {
    this.data.sort(function (a, b) {
      if (a.ric < b.ric) {
        return -1;
      }
      if (a.ric > b.ric) {
        return 1;
      }
      return 0;
    });
  }
  this.node = node;
  this.page = 1;
  this.count = data.count;
  this.itemsPerPage = config.itemsPerPage;
  this.clickHandler = config.clickHandler;
  this.tableAction = null;
  this.render(true);
};
ThirdLevelTable.prototype.getTableControls = function () {
  var _this2 = this;
  var pages = Math.ceil(this.count / this.itemsPerPage);
  var $controls = (0, _basicTableControls.default)({
    page: this.page,
    pages: pages,
    first: function first() {
      _this2.tableAction = TABLE_ACTIONS.FIRST;
      _this2.setPage(1);
    },
    prev: function prev() {
      _this2.tableAction = TABLE_ACTIONS.PREVIOUS;
      _this2.setPage(_this2.page - 1);
    },
    next: function next() {
      _this2.tableAction = TABLE_ACTIONS.NEXT;
      _this2.setPage(_this2.page + 1);
    },
    last: function last() {
      _this2.tableAction = TABLE_ACTIONS.LAST;
      _this2.setPage(pages);
    },
    tableCaption: this.getTableCaption()
  });
  var $backButton = $('<span/>').addClass('back').attr({
    'role': 'button',
    'tabindex': 0
  }).text((0, _messageHandler.getMessage)('incrementalsearch.ricsearch.back')).click(function () {
    return $(_this2.node).removeClass('active').siblings('.mainsearch').addClass('active');
  });
  $controls.prepend($backButton);
  return $controls;
};
ThirdLevelTable.prototype.getTableCaption = function () {
  return (0, _messageHandler.getMessage)('incrementalsearch.results.level');
};
ThirdLevelTable.prototype.setPage = function (page) {
  this.page = page;
  this.render();
};
ThirdLevelTable.prototype.render = function (isOnLoad) {
  var _this3 = this;
  var $activeRow = $('.ricsearch table.list.marktr tr.hover.keyboard-focus');
  var $nextRow = $activeRow.next('tr');
  var $prevRow = $activeRow.prev('tr');
  if ($prevRow.is(':first-child')) {
    $prevRow = [];
  }
  var $table = $('<table/>').addClass('list marktr');
  var $tableCaption = $('<caption/>').text(this.getTableCaption()).addClass('visuallyhidden');
  var offset = (this.page - 1) * this.itemsPerPage;
  var displayResults = this.data.slice(offset, offset + this.itemsPerPage);

  // create header row
  var firstColWidth = '50%';
  if (this.columns.length === 5) {
    firstColWidth = '40%';
  } else if (this.columns.length >= 5) {
    firstColWidth = '30%';
  }
  var colsRow = this.columns.map(function (a, i) {
    return $('<col/>').attr('width', !i ? firstColWidth : 'auto');
  });
  var headerRow = this.columns.map(function (a, i) {
    return $('<th/>').text(a[1]);
  });
  $table.append($('<colgroup/>').append(colsRow));
  $table.append($('<tr/>').append(headerRow));
  $table.append(displayResults.map(function (result) {
    return $('<tr/>').attr('role', 'button').attr('tabindex', _this3.isMobile ? 0 : -1).append(
    // create data row
    result.data.map(function (a) {
      return $('<td/>').html("<span>".concat(a[1], "</span>"));
    })).on('click', function () {
      var dataForCallback = _this3.getDataForCallback(result.ric);
      if (result.isin) {
        dataForCallback.isin = result.isin;
      }
      if (_this3.type) {
        dataForCallback.type = _this3.type;
      }
      _this3.clickHandler(dataForCallback);
    });
  }));
  $table.prepend($tableCaption);
  $(this.node).html('').append($('<div/>').append($table).append(this.getTableControls()));
  $table.attr({
    tabindex: 0
  });

  // #. Set focus to active row
  if (!isOnLoad) {
    if (this.tableAction === TABLE_ACTIONS.NEXT || this.tableAction === TABLE_ACTIONS.FIRST) {
      $table.find('.keyboard-focus').removeClass('hover keyboard-focus');
      this.setRowActive($table, $table.find('tr').not(':first').first());
    } else if (this.tableAction === TABLE_ACTIONS.PREVIOUS || this.tableAction === TABLE_ACTIONS.LAST) {
      var $rows = $table.find('tr').not(':first');
      this.setRowActive($table, $($rows[$rows.length - 1]));
    }
  } else {
    $table.focus();
  }
};
ThirdLevelTable.prototype.getDataForCallback = function (ric) {
  var dataSet = this.rawData.result.find(function (f) {
    return f.ric === ric;
  }).data;
  var nameKeyIndex = this.rawData.fidlets.findIndex(function (f) {
    return f[0] === 'NAME_SHORT_KEY';
  });
  return {
    ric: ric,
    name: dataSet[nameKeyIndex][1]
  };
};
ThirdLevelTable.prototype.setRowActive = function ($table, $row) {
  $table.find('.keyboard-focus').removeClass('hover keyboard-focus');
  $row.addClass('hover keyboard-focus').attr({
    tabindex: 0
  }).focus();
};
var _default = exports.default = ThirdLevelTable;

},{"fcom/messages/messageHandler":12,"fcom/search/basicTableControls":133}],133:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _messageHandler = require("fcom/messages/messageHandler");
/**
 * Simple Method to generate a table control item
 * config param includes current page, total pages, and functions for paginating to first, next, previous and last page
 */
var getBasicTableControls = function getBasicTableControls(_ref) {
  var page = _ref.page,
    pages = _ref.pages,
    first = _ref.first,
    next = _ref.next,
    prev = _ref.prev,
    last = _ref.last,
    noLastPage = _ref.noLastPage,
    tableCaption = _ref.tableCaption;
  var navItem = function navItem(className, disabled, fn) {
    return $('<button/>').addClass('icon').addClass(className + (disabled ? ' disabled' : '')).prop('disabled', disabled ? true : false).attr('title', (0, _messageHandler.getMessage)("tables.tableControls.paging.tooltip.".concat(className))).attr('aria-label', (0, _messageHandler.getMessage)("tables.tableControls.paging.label.".concat(className), tableCaption)).click(function (e) {
      if (!disabled) {
        e.preventDefault();
        e.stopPropagation();
        fn();
      }
      return false;
    });
  };
  var $controls = $('<div/>').addClass('controls');
  var pageInfo = (0, _messageHandler.getMessage)("incrementalsearch.paging.number".concat(noLastPage ? '.simple' : ''), page, pages);
  $controls.append(navItem('firstPage', page === 1, first)).append(navItem('previousPage', page === 1, prev)).append($('<span/>').text(pageInfo)).append(navItem('nextPage', page === pages, next));
  if (!noLastPage) {
    $controls.append(navItem('lastPage', page === pages, last));
  }
  return $controls;
};
var _default = exports.default = getBasicTableControls;

},{"fcom/messages/messageHandler":12}],134:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _SearchResultBox = _interopRequireDefault(require("fcom/search/SearchResultBox"));
var _runFunctionDebounced = _interopRequireDefault(require("fcom/util/functions/runFunctionDebounced"));
var _keyCodes = _interopRequireDefault(require("fcom/util/enums/keyCodes"));
var _hooks = _interopRequireDefault(require("fcom/hooks"));
var _SearchHistory = _interopRequireDefault(require("fcom/search/SearchHistory"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var debounceMilliseconds = 150; // only count keyup events after n milliseconds

var handleSearch = function handleSearch(searchBox, config, searchHistory) {
  return function (_ref) {
    var target = _ref.target,
      keyCode = _ref.keyCode;
    var input = $(target);
    var searchTerm = input.val();
    var pattern = /^[\w,.:=\+\-\/\*#\s]+$/;
    var isValidSearchTerm = pattern.test(searchTerm);
    if (keyCode === _keyCodes.default.ENTER && !isValidSearchTerm) {
      searchBox.show();
      return;
    }
    if (keyCode === _keyCodes.default.ESCAPE) {
      input.attr('value', '');
      searchBox.hide();
      return true;
    }
    if (keyCode === _keyCodes.default.TAB) {
      return true;
    }
    if (!searchTerm) {
      // show search history window as the search input has been cleared
      if (searchHistory) {
        searchHistory.render();
      }
      searchBox.hide();
      // return after creating a new SearchResultBox so it will be cleared from the screen
      return;
    }
    if (searchTerm.length > 0) {
      // Handle multi ric submit using ; or , or \n as seperator
      if (config.multipleSymbolInputCallback) {
        var rics = searchTerm.trim().split(/\s*[,;\n\t\f\r\v]\s*/);
        rics = rics.filter(function (v) {
          return v != '';
        }); // remove array positions with only empty strings
        if (rics.length > 1 && isValidSearchTerm) {
          searchBox.hide();
          if (keyCode === _keyCodes.default.ENTER) {
            config.multipleSymbolInputCallback(rics);
          }
          return;
        }
      }
    }
    var now = Date.now();
    searchBox.setSearchTerm(searchTerm, keyCode === _keyCodes.default.ENTER).then(function (results) {
      if (keyCode !== _keyCodes.default.ENTER && results[0] && results[0]['searchTerm'][0] === searchBox.searchTerm) {
        searchBox.show();
      }
      if (searchTerm.length > 0) {
        _hooks.default.onSearchResult(searchTerm, results);
        var timeTrackingObj = {
          searchTerm: searchTerm
        };
        timeTrackingObj.millis = Date.now() - now;
        searchBox.timeTracking.push(timeTrackingObj);
        $('body').unbind('click', searchHistory.closeHistoryWindowHandler);
        $("#".concat(config.searchHistoryContainerId)).hide();
      }
    });
  };
};
var initSearch = function initSearch(node, config, trigger) {
  config = config || {
    searchBoxId: 'incrementalsearch_results',
    columns: $(node).data('incrementalsearch-columns') || {},
    countInstTypeOnly: false,
    searchHistoryContainerId: 'incrementalsearch_history',
    enableDFAInSearchHistory: true
  };
  config.searchInput = $(node);
  var searchHistoryContainer;
  if (!config.isMobile) {
    searchHistoryContainer = new _SearchHistory.default(config, node);
    $(node).on('focus', function () {
      searchHistoryContainer.render();
    });
  }
  var searchBox = new _SearchResultBox.default(config);
  var handleFunction = (0, _runFunctionDebounced.default)(debounceMilliseconds, handleSearch(searchBox, config, searchHistoryContainer));
  $(node).on('keyup', handleFunction);
  $(node).siblings('button.search').click(function () {
    if ($("#".concat(config.searchBoxId, ":visible")).length > 0) {
      handleFunction({
        target: node,
        keyCode: _keyCodes.default.ENTER
      });
    } else {
      handleFunction({
        target: node
      });
    }
  });
  if (trigger) {
    handleFunction({
      target: node
    });
  }
};
var _default = exports.default = initSearch;

},{"fcom/hooks":11,"fcom/search/SearchHistory":130,"fcom/search/SearchResultBox":131,"fcom/util/enums/keyCodes":139,"fcom/util/functions/runFunctionDebounced":146}],135:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// Enum-like object containing all SearchTypes used by incrementalSearch
var SEARCHTYPE = {
  INSTRUMENTS: 'instruments',
  INSTRUMENT: 'instruments',
  NEWS: 'news',
  WLPF: 'wlpf',
  NAV: 'nav',
  BND_ISSUER: 'bnd_issuer',
  ISSUER: 'bnd_issuer'
};
var _default = exports.default = SEARCHTYPE;

},{}],136:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _runFunctionDebounced = _interopRequireDefault(require("util/functions/runFunctionDebounced"));
var _throttle = _interopRequireDefault(require("lodash/throttle"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var arrangeFixedCols = function arrangeFixedCols($table) {
  if (!$table.hasClass('layout-auto')) {
    return;
  }
  if (!$table.parent().hasClass('sticky-wrap')) {
    $table.wrap('<div class="sticky-wrap" />');
  }
  var $w = $(window);
  var $stickyWrap = $table.parent();
  var $stickyHead = $table.find('thead');
  // clear previous styles if any
  $stickyWrap.css({
    'margin-left': 0,
    width: '100%'
  });
  $('th,td', $table).css('position', '');
  // To prevent locked column overflow
  $stickyWrap.parent().css({
    position: 'relative',
    'overflow-x': 'hidden'
  });
  $stickyWrap.parent().addClass('sticky-content');

  // calculate wrapper margin and fixed column width
  var wrapperLeftMargin = 0;
  var fixedColsWidth = [];
  $('th', $table).each(function (index, el) {
    if ($(el).hasClass('col-locked')) {
      wrapperLeftMargin += $(el).outerWidth();
      fixedColsWidth[index] = $(el).outerWidth();
    } else {
      return false;
    }
  });
  if (fixedColsWidth.length) {
    var fixedColsMargin = [];
    var nextMargin = 0;
    // calcualte margin for each column
    $.each(fixedColsWidth, function (key, value) {
      if (key === 0) {
        fixedColsMargin[key] = wrapperLeftMargin;
      } else {
        nextMargin = 0;
        $.each(fixedColsWidth, function (keyNext, valueNext) {
          if (keyNext < key) {
            nextMargin += valueNext;
          }
        });
        fixedColsMargin[key] = wrapperLeftMargin - nextMargin;
      }
    });
    $table.parent().css({
      'margin-left': wrapperLeftMargin + 'px',
      width: "calc(100% - ".concat(wrapperLeftMargin, "px)")
    });

    // let currentRowHeight = null;
    // set position for fixed columns
    $('tr', $table).each(function () {
      var rowHeight = $(this).outerHeight();
      $(this).css('height', rowHeight);
      $('th,td', $(this)).each(function (index) {
        // set position
        if (fixedColsMargin[index]) {
          $(this).css({
            position: 'absolute',
            'margin-left': "-".concat(fixedColsMargin[index], "px"),
            width: fixedColsWidth[index],
            height: rowHeight
          });
        }
      });
    });
  }
  var repositionStickyHead = function repositionStickyHead() {
    // Check if wrapper parent is overflowing along the y-axis
    if ($table.height() > $stickyWrap.height()) {
      // If it is overflowing (advanced layout)
      // Position sticky header based on wrapper scrollTop()
      if ($stickyWrap.scrollTop() > 0) {
        // When top of wrapping parent is out of view
        $stickyHead.find('th').css({
          opacity: 10,
          top: $stickyWrap.scrollTop()
        });
      } else {
        // When top of wrapping parent is in view
        $stickyHead.find('th').css({
          opacity: 1,
          top: 0
        });
      }
    } else {
      var fixedOffset = $stickyHead.attr('data-fixed-offset') || 0;
      var offsetTop = $table.offset().top - +fixedOffset;
      // If it is not overflowing (basic layout)
      // Position sticky header based on viewport scrollTop
      if ($w.scrollTop() > offsetTop && $w.scrollTop() < offsetTop + $table.outerHeight() - $stickyHead.outerHeight()) {
        // When top of viewport is in the table itself
        $stickyHead.find('th').css({
          opacity: 10,
          top: $w.scrollTop() - offsetTop - 1
        });
      } else {
        // When top of viewport is above or below table
        $stickyHead.find('th').css({
          opacity: 1,
          top: 0
        });
      }
    }
  };
  if ($table.hasClass('table-sticky-header')) {
    $w.resize((0, _runFunctionDebounced.default)(250, function () {
      repositionStickyHead();
    })).scroll((0, _throttle.default)(repositionStickyHead, 25));
  }
};
var _default = exports.default = arrangeFixedCols;

},{"lodash/throttle":194,"util/functions/runFunctionDebounced":146}],137:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * This functions positions tooltip for element within container
 * tooltip is a d3 node object
 * container is an object {w, h} for width and height
 * element is an object {x, y, w, h} for x and y positions and width, height
 */
var positionTooltip = function positionTooltip(tooltip, container, element) {
  var width = $(tooltip.node()).width();
  var height = $(tooltip.node()).height();
  var arrowSize = 6;
  var xLeft = element.x;
  var xRight = element.x + element.w;
  var xCenter = Math.round((xLeft + xRight) / 2);
  var yTop = element.y;
  var yBottom = element.y + element.h;
  var yCenter = Math.round((yTop + yBottom) / 2);
  var position;
  var positionClass;
  var arrowPosition;
  if (yTop < height && yBottom + height > container.h && xRight + width > container.w) {
    //Left
    positionClass = 'left';
    position = [xLeft - width - arrowSize, yCenter - Math.round(height / 2)];
    arrowPosition = [width + 1, Math.floor(height / 2 - arrowSize)];
  } else if (yTop < height && xRight + width > container.w) {
    //Bottom
    positionClass = 'bottom';
    position = [xCenter - Math.round(width / 2), yBottom + 5 + arrowSize];
    arrowPosition = [Math.floor(width / 2 - arrowSize), -(arrowSize * 2 + 1)];
  } else if (yTop < height) {
    //Right
    positionClass = 'right';
    position = [xRight + 5 + arrowSize, yCenter - Math.round(height / 2)];
    arrowPosition = [-(arrowSize * 2 + 1), Math.floor(height / 2 - arrowSize)];
  } else {
    //Top
    positionClass = 'top';
    position = [xCenter - Math.round(width / 2), yTop - height - arrowSize];
    arrowPosition = [Math.floor(width / 2 - arrowSize / 2), height + 1];
  }

  //clamp values
  var realPosition = [Math.min(container.w - width, Math.max(0, position[0])), Math.min(container.h - height, Math.max(0, position[1]))];
  var xDist = position[0] - realPosition[0];
  var yDist = position[1] - realPosition[1];

  //adjust the pointer to point on the actual node
  if (['top', 'bottom'].indexOf(positionClass) > -1) {
    arrowPosition = [Math.min(width - 2 * arrowSize, Math.max(0, arrowPosition[0] + xDist)), arrowPosition[1] + yDist];
  } else {
    arrowPosition = [arrowPosition[0] + xDist, Math.min(height - 2 * arrowSize, Math.max(0, arrowPosition[1] + yDist))];
  }

  //position the tooltip and adjust its class
  tooltip.transition().duration(200).style('opacity', '0.9').attr('class', "d3-tooltip d3-tooltip-".concat(positionClass)).style('left', "".concat(realPosition[0], "px")).style('top', "".concat(realPosition[1], "px"));
  tooltip.select('.d3-tooltip-ptr').style('left', "".concat(arrowPosition[0], "px")).style('top', "".concat(arrowPosition[1], "px"));
};
var _default = exports.default = positionTooltip;

},{}],138:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var transformHeatmapData = function transformHeatmapData(dataSource) {
  var data = Object.keys(dataSource.memberValues).map(function (ric) {
    var ricData = dataSource.memberFields.reduce(function (all, field, index) {
      all[field.id] = {
        value: dataSource.memberValues[ric][index],
        label: dataSource.memberDisplay[ric][index]
      };
      return all;
    }, {});
    return {
      ric: ric,
      name: ricData.NAME_SHORT.label,
      data: ricData,
      ticker: ricData.TICKER.value
    };
  });
  var fields = dataSource.memberFields.reduce(function (all, field) {
    var id = field.id;
    delete field.id;
    all[id] = field;
    return all;
  }, {});
  return {
    data: data,
    fields: fields
  };
};
var _default = exports.default = transformHeatmapData;

},{}],139:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var KEYCODE = {
  ENTER: 13,
  SPACE: 32,
  ESCAPE: 27,
  ARROW_LEFT: 37,
  ARROW_UP: 38,
  ARROW_RIGHT: 39,
  ARROW_DOWN: 40,
  TAB: 9,
  KeyA: 65,
  KeyD: 68,
  DELETE: 46
};
var _default = exports.default = KEYCODE;

},{}],140:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _hexToRgba = _interopRequireDefault(require("util/functions/hexToRgba"));
var _rgbToRgba = _interopRequireDefault(require("util/functions/rgbToRgba"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = exports.default = function _default(color) {
  var a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return color.startsWith('#') ? (0, _hexToRgba.default)(color, a) : (0, _rgbToRgba.default)(color, a);
};

},{"util/functions/hexToRgba":142,"util/functions/rgbToRgba":145}],141:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var getStatusMessageFromError = function getStatusMessageFromError(error, isMiniChart) {
  var message = {
    402: 'NO_ACCESS',
    404: 'INVALID_ITEM'
  }[+error.message.split(' - ')[0]] || 'ERROR';
  // if minichart use module.frontend.status.minichart.<message>
  // otherwise use module.frontend.status.<message>
  return "module.frontend.status.".concat(isMiniChart ? 'minichart.' : '').concat(message);
};
var _default = exports.default = getStatusMessageFromError;

},{}],142:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/** @module util/functions/hexToRgba */
/**
 * Convert hex color string to rgba string
 * @name hexToRgba
 * @function
 * @param {string} hex Color in hex like <code>#ff0000</code>
 * @param {number} a opacity in number range from 0 to 1
 * @returns {string} color string in rgba like <code>rgba(255,0,0,1)</code>
 */
var _default = exports.default = function _default(hex) {
  var a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  hex = hex.replace('#', '');
  var r = parseInt(hex.substring(0, 2), 16);
  var g = parseInt(hex.substring(2, 4), 16);
  var b = parseInt(hex.substring(4, 6), 16);
  return "rgba(".concat([r, g, b, a].join(','), ")");
};

},{}],143:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/** @module util/functions/mergeObjects */

var assignTargetKeyValue = function assignTargetKeyValue(target, key, value) {
  if (Array.isArray(value)) {
    target[key] = mergeObjects(target[key] || [], value);
  } else if (value && _typeof(value) === 'object') {
    target[key] = mergeObjects(target[key] || {}, value);
  } else {
    target[key] = value;
  }
};

/**
 * This function will deep merge Objects and Arrays.
 * It works similar to Object.assign but is not limited to one level of merging. <br/>
 * Please note that you cannot merge objects and arrays on the same level.
 * @param {...(Object|Array)} objects
 * @return {Object|Array}
 */
var mergeObjects = function mergeObjects() {
  for (var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++) {
    objects[_key] = arguments[_key];
  }
  var target = objects.shift();
  objects.forEach(function (object) {
    if (Array.isArray(object)) {
      object.forEach(function (value, key) {
        assignTargetKeyValue(target, key, value);
      });
    } else {
      for (var key in object) {
        assignTargetKeyValue(target, key, object[key]);
      }
    }
  });
  return target;
};
var _default = exports.default = mergeObjects;

},{}],144:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/** @module util/functions/quartileRange */

/**
 * this function calculates a quartile range and is used for some color range calculations
 * @param {number[]} values
 * @param {number} quartileRange
 * @returns {number[]} upper and lower bounds
*/
var quartileRange = function quartileRange(values) {
  var quartileRange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1.5;
  // sort descending
  values = values.sort(function (a, b) {
    return a - b;
  });

  // calculate quartile 1 and 3
  var q1 = values[parseInt(values.length / 4, 10)];
  var q3 = values[parseInt(values.length * 3 / 4, 10)];

  // calculate upper and lower bounds
  var iqr = q3 - q1;
  var lowerBound = q1 - quartileRange * iqr;
  var upperBound = q3 + quartileRange * iqr;
  return [lowerBound, upperBound];
};
var _default = exports.default = quartileRange;

},{}],145:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = function _default(rgb) {
  var a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return rgb.replace('rgb', 'rgba').replace(/\)$/, ",".concat(a, ")"));
};

},{}],146:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * This functions takes a function fn as input and returns a function that when executed
 * will only run every millis milliseconds
 */
var runFunctionDebounced = function runFunctionDebounced(millis, fn) {
  var timeout = null;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (timeout) {
      window.clearTimeout(timeout);
    }
    timeout = window.setTimeout(function () {
      timeout = null;
      fn.apply(void 0, args);
    }, millis);
  };
};
var _default = exports.default = runFunctionDebounced;

},{}],147:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resizeMenuItems = resizeMenuItems;
function resizeMenuItems(rootNode) {
  resetMenuItems(rootNode);
  var menuItemList = rootNode.querySelectorAll('.menuItem');

  // check if all items are on same line, if so no need to set width
  var menuItemTop = menuItemList[0].offsetTop;
  var isOnSameLevel = true;
  menuItemList.forEach(function (node) {
    isOnSameLevel = isOnSameLevel && menuItemTop === node.offsetTop;
  });
  if (!isOnSameLevel) {
    var labelMaxWidth = 0;
    menuItemList.forEach(function (node) {
      var label = node.children[0];
      var labelWidth = label.offsetWidth;
      if (labelWidth > labelMaxWidth) {
        labelMaxWidth = labelWidth;
      }
    });
    if (labelMaxWidth + 200 > rootNode.offsetWidth) {
      // Check if there is enough space for displaying labels and fields horizontally 
      // And add class 'verticalLayout' if there is no enough space
      // 200 is the default width for a select field
      $(rootNode).find('.moduleTabMenu').addClass('verticalLayout');
    }
    if (labelMaxWidth > 0) {
      menuItemList.forEach(function (node) {
        var label = node.children[0];
        label.style.minWidth = labelMaxWidth + 'px';
        var selector = $(label).siblings('.select2-container');
        var labelOffsetTop = $(label).offset().top;
        var selectorOffsetTop = selector.offset().top;
        label.style.textAlign = selectorOffsetTop - labelOffsetTop > 5 ? 'left' : '';
      });
    }
  }
}
;
function resetMenuItems(rootNode) {
  // remove min-width and text alignment for labels and set width for drop-downs to 200px - default
  $(rootNode).find('.moduleTabMenu').removeClass('verticalLayout');
  var menuItemList = rootNode.querySelectorAll('.menuItem');
  $(menuItemList).find('label').css({
    'min-width': '',
    'text-align': ''
  });
  $(menuItemList).find('label ~ .select2-container').css('width', '200px');
}
;

},{}],148:[function(require,module,exports){
module.exports={
"type": "FeatureCollection",
"name": "world",
"crs": { "type": "name", "properties": { "name": "urn:ogc:def:crs:OGC:1.3:CRS84" } },
"features": [
{ "type": "Feature", "properties": { "id": "MYS", "name": "Malaysia" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 118.618321, 4.478202 ], [ 117.882035, 4.137551 ], [ 117.015214, 4.306094 ], [ 115.865517, 4.306559 ], [ 115.519078, 3.169238 ], [ 115.134037, 2.821482 ], [ 114.621355, 1.430688 ], [ 113.80585, 1.217549 ], [ 112.859809, 1.49779 ], [ 112.380252, 1.410121 ], [ 111.797548, 0.904441 ], [ 111.159138, 0.976478 ], [ 110.514061, 0.773131 ], [ 109.830227, 1.338136 ], [ 109.66326, 2.006467 ], [ 110.396135, 1.663775 ], [ 111.168853, 1.850637 ], [ 111.370081, 2.697303 ], [ 111.796928, 2.885897 ], [ 112.995615, 3.102395 ], [ 113.712935, 3.893509 ], [ 114.204017, 4.525874 ], [ 114.659596, 4.007637 ], [ 114.869557, 4.348314 ], [ 115.347461, 4.316636 ], [ 115.4057, 4.955228 ], [ 115.45071, 5.44773 ], [ 116.220741, 6.143191 ], [ 116.725103, 6.924771 ], [ 117.129626, 6.928053 ], [ 117.643393, 6.422166 ], [ 117.689075, 5.98749 ], [ 118.347691, 5.708696 ], [ 119.181904, 5.407836 ], [ 119.110694, 5.016128 ], [ 118.439727, 4.966519 ], [ 118.618321, 4.478202 ] ] ], [ [ [ 104.139285201625285, 1.284625224056316 ], [ 104.04066100602536, 1.50624090772953 ], [ 103.699852540904047, 1.486945065925548 ], [ 103.522560880303885, 1.226602499078547 ], [ 103.519707, 1.226334 ], [ 102.573615, 1.967115 ], [ 101.390638, 2.760814 ], [ 101.27354, 3.270292 ], [ 100.695435, 3.93914 ], [ 100.557408, 4.76728 ], [ 100.196706, 5.312493 ], [ 100.30626, 6.040562 ], [ 100.085757, 6.464489 ], [ 100.259596, 6.642825 ], [ 101.075516, 6.204867 ], [ 101.154219, 5.691384 ], [ 101.814282, 5.810808 ], [ 102.141187, 6.221636 ], [ 102.371147, 6.128205 ], [ 102.961705, 5.524495 ], [ 103.381215, 4.855001 ], [ 103.438575, 4.181606 ], [ 103.332122, 3.726698 ], [ 103.429429, 3.382869 ], [ 103.502448, 2.791019 ], [ 103.854674, 2.515454 ], [ 104.247932, 1.631141 ], [ 104.228811, 1.293048 ], [ 104.139285201625285, 1.284625224056316 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "CHN", "name": "China" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 114.750516811512696, 22.658399377752342 ], [ 114.572093023255817, 22.862681686046461 ], [ 113.851416807423163, 22.506438329356449 ], [ 113.80678, 22.54834 ], [ 113.241078, 22.051367 ], [ 111.843592, 21.550494 ], [ 110.785466, 21.397144 ], [ 110.444039, 20.341033 ], [ 109.889861, 20.282457 ], [ 109.627655, 21.008227 ], [ 109.864488, 21.395051 ], [ 108.522813, 21.715212 ], [ 108.05018, 21.55238 ], [ 107.04342, 21.811899 ], [ 106.567273, 22.218205 ], [ 106.725403, 22.794268 ], [ 105.811247, 22.976892 ], [ 105.329209, 23.352063 ], [ 104.476858, 22.81915 ], [ 103.504515, 22.703757 ], [ 102.706992, 22.708795 ], [ 102.170436, 22.464753 ], [ 101.652018, 22.318199 ], [ 101.80312, 21.174367 ], [ 101.270026, 21.201652 ], [ 101.180005, 21.436573 ], [ 101.150033, 21.849984 ], [ 100.416538, 21.558839 ], [ 99.983489, 21.742937 ], [ 99.240899, 22.118314 ], [ 99.531992, 22.949039 ], [ 98.898749, 23.142722 ], [ 98.660262, 24.063286 ], [ 97.60472, 23.897405 ], [ 97.724609, 25.083637 ], [ 98.671838, 25.918703 ], [ 98.712094, 26.743536 ], [ 98.68269, 27.508812 ], [ 98.246231, 27.747221 ], [ 97.911988, 28.335945 ], [ 97.327114, 28.261583 ], [ 96.248833, 28.411031 ], [ 96.586591, 28.83098 ], [ 96.117679, 29.452802 ], [ 95.404802, 29.031717 ], [ 94.56599, 29.277438 ], [ 93.413348, 28.640629 ], [ 92.503119, 27.896876 ], [ 91.696657, 27.771742 ], [ 91.258854, 28.040614 ], [ 90.730514, 28.064954 ], [ 90.015829, 28.296439 ], [ 89.47581, 28.042759 ], [ 88.814248, 27.299316 ], [ 88.730326, 28.086865 ], [ 88.120441, 27.876542 ], [ 86.954517, 27.974262 ], [ 85.82332, 28.203576 ], [ 85.011638, 28.642774 ], [ 84.23458, 28.839894 ], [ 83.898993, 29.320226 ], [ 83.337115, 29.463732 ], [ 82.327513, 30.115268 ], [ 81.525804, 30.422717 ], [ 81.111256, 30.183481 ], [ 79.721367, 30.882715 ], [ 78.738894, 31.515906 ], [ 78.458446, 32.618164 ], [ 79.176129, 32.48378 ], [ 79.208892, 32.994395 ], [ 78.811086, 33.506198 ], [ 78.912269, 34.321936 ], [ 77.837451, 35.49401 ], [ 76.192848, 35.898403 ], [ 75.896897, 36.666806 ], [ 75.158028, 37.133031 ], [ 74.980002, 37.41999 ], [ 74.829986, 37.990007 ], [ 74.864816, 38.378846 ], [ 74.257514, 38.606507 ], [ 73.928852, 38.505815 ], [ 73.675379, 39.431237 ], [ 73.960013, 39.660008 ], [ 73.822244, 39.893973 ], [ 74.776862, 40.366425 ], [ 75.467828, 40.562072 ], [ 76.526368, 40.427946 ], [ 76.904484, 41.066486 ], [ 78.187197, 41.185316 ], [ 78.543661, 41.582243 ], [ 80.11943, 42.123941 ], [ 80.25999, 42.349999 ], [ 80.18015, 42.920068 ], [ 80.866206, 43.180362 ], [ 79.966106, 44.917517 ], [ 81.947071, 45.317027 ], [ 82.458926, 45.53965 ], [ 83.180484, 47.330031 ], [ 85.16429, 47.000956 ], [ 85.720484, 47.452969 ], [ 85.768233, 48.455751 ], [ 86.598776, 48.549182 ], [ 87.35997, 49.214981 ], [ 87.751264, 49.297198 ], [ 88.013832, 48.599463 ], [ 88.854298, 48.069082 ], [ 90.280826, 47.693549 ], [ 90.970809, 46.888146 ], [ 90.585768, 45.719716 ], [ 90.94554, 45.286073 ], [ 92.133891, 45.115076 ], [ 93.480734, 44.975472 ], [ 94.688929, 44.352332 ], [ 95.306875, 44.241331 ], [ 95.762455, 43.319449 ], [ 96.349396, 42.725635 ], [ 97.451757, 42.74889 ], [ 99.515817, 42.524691 ], [ 100.845866, 42.663804 ], [ 101.83304, 42.514873 ], [ 103.312278, 41.907468 ], [ 104.522282, 41.908347 ], [ 104.964994, 41.59741 ], [ 106.129316, 42.134328 ], [ 107.744773, 42.481516 ], [ 109.243596, 42.519446 ], [ 110.412103, 42.871234 ], [ 111.129682, 43.406834 ], [ 111.829588, 43.743118 ], [ 111.667737, 44.073176 ], [ 111.348377, 44.457442 ], [ 111.873306, 45.102079 ], [ 112.436062, 45.011646 ], [ 113.463907, 44.808893 ], [ 114.460332, 45.339817 ], [ 115.985096, 45.727235 ], [ 116.717868, 46.388202 ], [ 117.421701, 46.672733 ], [ 118.874326, 46.805412 ], [ 119.66327, 46.69268 ], [ 119.772824, 47.048059 ], [ 118.866574, 47.74706 ], [ 118.064143, 48.06673 ], [ 117.295507, 47.697709 ], [ 116.308953, 47.85341 ], [ 115.742837, 47.726545 ], [ 115.485282, 48.135383 ], [ 116.191802, 49.134598 ], [ 116.678801, 49.888531 ], [ 117.879244, 49.510983 ], [ 119.288461, 50.142883 ], [ 119.279366, 50.582908 ], [ 120.18205, 51.643566 ], [ 120.738191, 51.964115 ], [ 120.725789, 52.516226 ], [ 120.177089, 52.753886 ], [ 121.003085, 53.251401 ], [ 122.245748, 53.431726 ], [ 123.571507, 53.458804 ], [ 125.068211, 53.161045 ], [ 125.946349, 52.792799 ], [ 126.564399, 51.784255 ], [ 126.939157, 51.353894 ], [ 127.287456, 50.739797 ], [ 127.657407, 49.76027 ], [ 129.397818, 49.4406 ], [ 130.582293, 48.729687 ], [ 130.987282, 47.790132 ], [ 132.506672, 47.78897 ], [ 133.373596, 48.183442 ], [ 135.026311, 48.47823 ], [ 134.500814, 47.57844 ], [ 134.112362, 47.212467 ], [ 133.769644, 46.116927 ], [ 133.097127, 45.144066 ], [ 131.883454, 45.321162 ], [ 131.025212, 44.967953 ], [ 131.288555, 44.11152 ], [ 131.144688, 42.92999 ], [ 130.633866, 42.903015 ], [ 130.640016, 42.395009 ], [ 129.994267, 42.985387 ], [ 129.596669, 42.424982 ], [ 128.052215, 41.994285 ], [ 128.208433, 41.466772 ], [ 127.343783, 41.503152 ], [ 126.869083, 41.816569 ], [ 126.182045, 41.107336 ], [ 125.079942, 40.569824 ], [ 124.265625, 39.928493 ], [ 122.86757, 39.637788 ], [ 122.131388, 39.170452 ], [ 121.054554, 38.897471 ], [ 121.585995, 39.360854 ], [ 121.376757, 39.750261 ], [ 122.168595, 40.422443 ], [ 121.640359, 40.94639 ], [ 120.768629, 40.593388 ], [ 119.639602, 39.898056 ], [ 119.023464, 39.252333 ], [ 118.042749, 39.204274 ], [ 117.532702, 38.737636 ], [ 118.059699, 38.061476 ], [ 118.87815, 37.897325 ], [ 118.911636, 37.448464 ], [ 119.702802, 37.156389 ], [ 120.823457, 37.870428 ], [ 121.711259, 37.481123 ], [ 122.357937, 37.454484 ], [ 122.519995, 36.930614 ], [ 121.104164, 36.651329 ], [ 120.637009, 36.11144 ], [ 119.664562, 35.609791 ], [ 119.151208, 34.909859 ], [ 120.227525, 34.360332 ], [ 120.620369, 33.376723 ], [ 121.229014, 32.460319 ], [ 121.908146, 31.692174 ], [ 121.891919, 30.949352 ], [ 121.264257, 30.676267 ], [ 121.503519, 30.142915 ], [ 122.092114, 29.83252 ], [ 121.938428, 29.018022 ], [ 121.684439, 28.225513 ], [ 121.125661, 28.135673 ], [ 120.395473, 27.053207 ], [ 119.585497, 25.740781 ], [ 118.656871, 24.547391 ], [ 117.281606, 23.624501 ], [ 115.890735, 22.782873 ], [ 114.763827, 22.668074 ], [ 114.750516811512696, 22.658399377752342 ] ] ], [ [ [ 110.339188, 18.678395 ], [ 109.47521, 18.197701 ], [ 108.655208, 18.507682 ], [ 108.626217, 19.367888 ], [ 109.119056, 19.821039 ], [ 110.211599, 20.101254 ], [ 110.786551, 20.077534 ], [ 111.010051, 19.69593 ], [ 110.570647, 19.255879 ], [ 110.339188, 18.678395 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "AFG", "name": "Afghanistan" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 61.210817, 35.650072 ], [ 62.230651, 35.270664 ], [ 62.984662, 35.404041 ], [ 63.193538, 35.857166 ], [ 63.982896, 36.007957 ], [ 64.546479, 36.312073 ], [ 64.746105, 37.111818 ], [ 65.588948, 37.305217 ], [ 65.745631, 37.661164 ], [ 66.217385, 37.39379 ], [ 66.518607, 37.362784 ], [ 67.075782, 37.356144 ], [ 67.83, 37.144994 ], [ 68.135562, 37.023115 ], [ 68.859446, 37.344336 ], [ 69.196273, 37.151144 ], [ 69.518785, 37.608997 ], [ 70.116578, 37.588223 ], [ 70.270574, 37.735165 ], [ 70.376304, 38.138396 ], [ 70.806821, 38.486282 ], [ 71.348131, 38.258905 ], [ 71.239404, 37.953265 ], [ 71.541918, 37.905774 ], [ 71.448693, 37.065645 ], [ 71.844638, 36.738171 ], [ 72.193041, 36.948288 ], [ 72.63689, 37.047558 ], [ 73.260056, 37.495257 ], [ 73.948696, 37.421566 ], [ 74.980002, 37.41999 ], [ 75.158028, 37.133031 ], [ 74.575893, 37.020841 ], [ 74.067552, 36.836176 ], [ 72.920025, 36.720007 ], [ 71.846292, 36.509942 ], [ 71.262348, 36.074388 ], [ 71.498768, 35.650563 ], [ 71.613076, 35.153203 ], [ 71.115019, 34.733126 ], [ 71.156773, 34.348911 ], [ 70.881803, 33.988856 ], [ 69.930543, 34.02012 ], [ 70.323594, 33.358533 ], [ 69.687147, 33.105499 ], [ 69.262522, 32.501944 ], [ 69.317764, 31.901412 ], [ 68.926677, 31.620189 ], [ 68.556932, 31.71331 ], [ 67.792689, 31.58293 ], [ 67.683394, 31.303154 ], [ 66.938891, 31.304911 ], [ 66.381458, 30.738899 ], [ 66.346473, 29.887943 ], [ 65.046862, 29.472181 ], [ 64.350419, 29.560031 ], [ 64.148002, 29.340819 ], [ 63.550261, 29.468331 ], [ 62.549857, 29.318572 ], [ 60.874248, 29.829239 ], [ 61.781222, 30.73585 ], [ 61.699314, 31.379506 ], [ 60.941945, 31.548075 ], [ 60.863655, 32.18292 ], [ 60.536078, 32.981269 ], [ 60.9637, 33.528832 ], [ 60.52843, 33.676446 ], [ 60.803193, 34.404102 ], [ 61.210817, 35.650072 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "AGO", "name": "Angola" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 16.326528, -5.87747 ], [ 16.57318, -6.622645 ], [ 16.860191, -7.222298 ], [ 17.089996, -7.545689 ], [ 17.47297, -8.068551 ], [ 18.134222, -7.987678 ], [ 18.464176, -7.847014 ], [ 19.016752, -7.988246 ], [ 19.166613, -7.738184 ], [ 19.417502, -7.155429 ], [ 20.037723, -7.116361 ], [ 20.091622, -6.94309 ], [ 20.601823, -6.939318 ], [ 20.514748, -7.299606 ], [ 21.728111, -7.290872 ], [ 21.746456, -7.920085 ], [ 21.949131, -8.305901 ], [ 21.801801, -8.908707 ], [ 21.875182, -9.523708 ], [ 22.208753, -9.894796 ], [ 22.155268, -11.084801 ], [ 22.402798, -10.993075 ], [ 22.837345, -11.017622 ], [ 23.456791, -10.867863 ], [ 23.912215, -10.926826 ], [ 24.017894, -11.237298 ], [ 23.904154, -11.722282 ], [ 24.079905, -12.191297 ], [ 23.930922, -12.565848 ], [ 24.016137, -12.911046 ], [ 21.933886, -12.898437 ], [ 21.887843, -16.08031 ], [ 22.562478, -16.898451 ], [ 23.215048, -17.523116 ], [ 21.377176, -17.930636 ], [ 18.956187, -17.789095 ], [ 18.263309, -17.309951 ], [ 14.209707, -17.353101 ], [ 14.058501, -17.423381 ], [ 13.462362, -16.971212 ], [ 12.814081, -16.941343 ], [ 12.215461, -17.111668 ], [ 11.734199, -17.301889 ], [ 11.640096, -16.673142 ], [ 11.778537, -15.793816 ], [ 12.123581, -14.878316 ], [ 12.175619, -14.449144 ], [ 12.500095, -13.5477 ], [ 12.738479, -13.137906 ], [ 13.312914, -12.48363 ], [ 13.633721, -12.038645 ], [ 13.738728, -11.297863 ], [ 13.686379, -10.731076 ], [ 13.387328, -10.373578 ], [ 13.120988, -9.766897 ], [ 12.87537, -9.166934 ], [ 12.929061, -8.959091 ], [ 13.236433, -8.562629 ], [ 12.93304, -7.596539 ], [ 12.728298, -6.927122 ], [ 12.227347, -6.294448 ], [ 12.322432, -6.100092 ], [ 12.735171, -5.965682 ], [ 13.024869, -5.984389 ], [ 13.375597, -5.864241 ], [ 16.326528, -5.87747 ] ] ], [ [ [ 12.436688, -5.684304 ], [ 12.182337, -5.789931 ], [ 11.914963, -5.037987 ], [ 12.318608, -4.60623 ], [ 12.62076, -4.438023 ], [ 12.995517, -4.781103 ], [ 12.631612, -4.991271 ], [ 12.468004, -5.248362 ], [ 12.436688, -5.684304 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "ALB", "name": "Albania" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 20.590247, 41.855404 ], [ 20.463175, 41.515089 ], [ 20.605182, 41.086226 ], [ 21.02004, 40.842727 ], [ 20.99999, 40.580004 ], [ 20.674997, 40.435 ], [ 20.615, 40.110007 ], [ 20.150016, 39.624998 ], [ 19.98, 39.694993 ], [ 19.960002, 39.915006 ], [ 19.406082, 40.250773 ], [ 19.319059, 40.72723 ], [ 19.40355, 41.409566 ], [ 19.540027, 41.719986 ], [ 19.371769, 41.877548 ], [ 19.304486, 42.195745 ], [ 19.738051, 42.688247 ], [ 19.801613, 42.500093 ], [ 20.0707, 42.58863 ], [ 20.283755, 42.32026 ], [ 20.52295, 42.21787 ], [ 20.590247, 41.855404 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "ARE", "name": "United Arab Emirates" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 51.579519, 24.245497 ], [ 51.757441, 24.294073 ], [ 51.794389, 24.019826 ], [ 52.577081, 24.177439 ], [ 53.404007, 24.151317 ], [ 54.008001, 24.121758 ], [ 54.693024, 24.797892 ], [ 55.439025, 25.439145 ], [ 56.070821, 26.055464 ], [ 56.261042, 25.714606 ], [ 56.396847, 24.924732 ], [ 55.886233, 24.920831 ], [ 55.804119, 24.269604 ], [ 55.981214, 24.130543 ], [ 55.528632, 23.933604 ], [ 55.525841, 23.524869 ], [ 55.234489, 23.110993 ], [ 55.208341, 22.70833 ], [ 55.006803, 22.496948 ], [ 52.000733, 23.001154 ], [ 51.617708, 24.014219 ], [ 51.579519, 24.245497 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "ARG", "name": "Argentina" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -65.5, -55.2 ], [ -66.45, -55.25 ], [ -66.95992, -54.89681 ], [ -67.56244, -54.87001 ], [ -68.63335, -54.8695 ], [ -68.63401, -52.63637 ], [ -68.25, -53.1 ], [ -67.75, -53.85 ], [ -66.45, -54.45 ], [ -65.05, -54.7 ], [ -65.5, -55.2 ] ] ], [ [ [ -64.964892, -22.075862 ], [ -64.377021, -22.798091 ], [ -63.986838, -21.993644 ], [ -62.846468, -22.034985 ], [ -62.685057, -22.249029 ], [ -60.846565, -23.880713 ], [ -60.028966, -24.032796 ], [ -58.807128, -24.771459 ], [ -57.777217, -25.16234 ], [ -57.63366, -25.603657 ], [ -58.618174, -27.123719 ], [ -57.60976, -27.395899 ], [ -56.486702, -27.548499 ], [ -55.695846, -27.387837 ], [ -54.788795, -26.621786 ], [ -54.625291, -25.739255 ], [ -54.13005, -25.547639 ], [ -53.628349, -26.124865 ], [ -53.648735, -26.923473 ], [ -54.490725, -27.474757 ], [ -55.162286, -27.881915 ], [ -56.2909, -28.852761 ], [ -57.625133, -30.216295 ], [ -57.874937, -31.016556 ], [ -58.14244, -32.044504 ], [ -58.132648, -33.040567 ], [ -58.349611, -33.263189 ], [ -58.427074, -33.909454 ], [ -58.495442, -34.43149 ], [ -57.22583, -35.288027 ], [ -57.362359, -35.97739 ], [ -56.737487, -36.413126 ], [ -56.788285, -36.901572 ], [ -57.749157, -38.183871 ], [ -59.231857, -38.72022 ], [ -61.237445, -38.928425 ], [ -62.335957, -38.827707 ], [ -62.125763, -39.424105 ], [ -62.330531, -40.172586 ], [ -62.145994, -40.676897 ], [ -62.745803, -41.028761 ], [ -63.770495, -41.166789 ], [ -64.73209, -40.802677 ], [ -65.118035, -41.064315 ], [ -64.978561, -42.058001 ], [ -64.303408, -42.359016 ], [ -63.755948, -42.043687 ], [ -63.458059, -42.563138 ], [ -64.378804, -42.873558 ], [ -65.181804, -43.495381 ], [ -65.328823, -44.501366 ], [ -65.565269, -45.036786 ], [ -66.509966, -45.039628 ], [ -67.293794, -45.551896 ], [ -67.580546, -46.301773 ], [ -66.597066, -47.033925 ], [ -65.641027, -47.236135 ], [ -65.985088, -48.133289 ], [ -67.166179, -48.697337 ], [ -67.816088, -49.869669 ], [ -68.728745, -50.264218 ], [ -69.138539, -50.73251 ], [ -68.815561, -51.771104 ], [ -68.149995, -52.349983 ], [ -68.571545, -52.299444 ], [ -69.498362, -52.142761 ], [ -71.914804, -52.009022 ], [ -72.329404, -51.425956 ], [ -72.309974, -50.67701 ], [ -72.975747, -50.74145 ], [ -73.328051, -50.378785 ], [ -73.415436, -49.318436 ], [ -72.648247, -48.878618 ], [ -72.331161, -48.244238 ], [ -72.447355, -47.738533 ], [ -71.917258, -46.884838 ], [ -71.552009, -45.560733 ], [ -71.659316, -44.973689 ], [ -71.222779, -44.784243 ], [ -71.329801, -44.407522 ], [ -71.793623, -44.207172 ], [ -71.464056, -43.787611 ], [ -71.915424, -43.408565 ], [ -72.148898, -42.254888 ], [ -71.746804, -42.051386 ], [ -71.915734, -40.832339 ], [ -71.680761, -39.808164 ], [ -71.413517, -38.916022 ], [ -70.814664, -38.552995 ], [ -71.118625, -37.576827 ], [ -71.121881, -36.658124 ], [ -70.364769, -36.005089 ], [ -70.388049, -35.169688 ], [ -69.817309, -34.193571 ], [ -69.814777, -33.273886 ], [ -70.074399, -33.09121 ], [ -70.535069, -31.36501 ], [ -69.919008, -30.336339 ], [ -70.01355, -29.367923 ], [ -69.65613, -28.459141 ], [ -69.001235, -27.521214 ], [ -68.295542, -26.89934 ], [ -68.5948, -26.506909 ], [ -68.386001, -26.185016 ], [ -68.417653, -24.518555 ], [ -67.328443, -24.025303 ], [ -66.985234, -22.986349 ], [ -67.106674, -22.735925 ], [ -66.273339, -21.83231 ], [ -64.964892, -22.075862 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "ARM", "name": "Armenia" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 43.582746, 41.092143 ], [ 44.97248, 41.248129 ], [ 45.179496, 40.985354 ], [ 45.560351, 40.81229 ], [ 45.359175, 40.561504 ], [ 45.891907, 40.218476 ], [ 45.610012, 39.899994 ], [ 46.034534, 39.628021 ], [ 46.483499, 39.464155 ], [ 46.50572, 38.770605 ], [ 46.143623, 38.741201 ], [ 45.735379, 39.319719 ], [ 45.739978, 39.473999 ], [ 45.298145, 39.471751 ], [ 45.001987, 39.740004 ], [ 44.79399, 39.713003 ], [ 44.400009, 40.005 ], [ 43.656436, 40.253564 ], [ 43.752658, 40.740201 ], [ 43.582746, 41.092143 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "ATA", "name": "Antarctica" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -59.572095, -80.040179 ], [ -59.865849, -80.549657 ], [ -60.159656, -81.000327 ], [ -62.255393, -80.863178 ], [ -64.488125, -80.921934 ], [ -65.741666, -80.588827 ], [ -65.741666, -80.549657 ], [ -66.290031, -80.255773 ], [ -64.037688, -80.294944 ], [ -61.883246, -80.39287 ], [ -61.138976, -79.981371 ], [ -60.610119, -79.628679 ], [ -59.572095, -80.040179 ] ] ], [ [ [ -159.208184, -79.497059 ], [ -161.127601, -79.634209 ], [ -162.439847, -79.281465 ], [ -163.027408, -78.928774 ], [ -163.066604, -78.869966 ], [ -163.712896, -78.595667 ], [ -163.105801, -78.223338 ], [ -161.245113, -78.380176 ], [ -160.246208, -78.693645 ], [ -159.482405, -79.046338 ], [ -159.208184, -79.497059 ] ] ], [ [ [ -45.154758, -78.04707 ], [ -43.920828, -78.478103 ], [ -43.48995, -79.08556 ], [ -43.372438, -79.516645 ], [ -43.333267, -80.026123 ], [ -44.880537, -80.339644 ], [ -46.506174, -80.594357 ], [ -48.386421, -80.829485 ], [ -50.482107, -81.025442 ], [ -52.851988, -80.966685 ], [ -54.164259, -80.633528 ], [ -53.987991, -80.222028 ], [ -51.853134, -79.94773 ], [ -50.991326, -79.614623 ], [ -50.364595, -79.183487 ], [ -49.914131, -78.811209 ], [ -49.306959, -78.458569 ], [ -48.660616, -78.047018 ], [ -48.660616, -78.047019 ], [ -48.151396, -78.04707 ], [ -46.662857, -77.831476 ], [ -45.154758, -78.04707 ] ] ], [ [ [ -121.211511, -73.50099 ], [ -119.918851, -73.657725 ], [ -118.724143, -73.481353 ], [ -119.292119, -73.834097 ], [ -120.232217, -74.08881 ], [ -121.62283, -74.010468 ], [ -122.621735, -73.657778 ], [ -122.621735, -73.657777 ], [ -122.406245, -73.324619 ], [ -121.211511, -73.50099 ] ] ], [ [ [ -125.559566, -73.481353 ], [ -124.031882, -73.873268 ], [ -124.619469, -73.834097 ], [ -125.912181, -73.736118 ], [ -127.28313, -73.461769 ], [ -127.28313, -73.461768 ], [ -126.558472, -73.246226 ], [ -125.559566, -73.481353 ] ] ], [ [ [ -98.98155, -71.933334 ], [ -97.884743, -72.070535 ], [ -96.787937, -71.952971 ], [ -96.20035, -72.521205 ], [ -96.983765, -72.442864 ], [ -98.198083, -72.482035 ], [ -99.432013, -72.442864 ], [ -100.783455, -72.50162 ], [ -101.801868, -72.305663 ], [ -102.330725, -71.894164 ], [ -101.703967, -71.717792 ], [ -100.430919, -71.854993 ], [ -98.98155, -71.933334 ] ] ], [ [ [ -68.451346, -70.955823 ], [ -68.333834, -71.406493 ], [ -68.510128, -71.798407 ], [ -68.784297, -72.170736 ], [ -69.959471, -72.307885 ], [ -71.075889, -72.503842 ], [ -72.388134, -72.484257 ], [ -71.8985, -72.092343 ], [ -73.073622, -72.229492 ], [ -74.19004, -72.366693 ], [ -74.953895, -72.072757 ], [ -75.012625, -71.661258 ], [ -73.915819, -71.269345 ], [ -73.915819, -71.269344 ], [ -73.230331, -71.15178 ], [ -72.074717, -71.190951 ], [ -71.780962, -70.681473 ], [ -71.72218, -70.309196 ], [ -71.741791, -69.505782 ], [ -71.173815, -69.035475 ], [ -70.253252, -68.87874 ], [ -69.724447, -69.251017 ], [ -69.489422, -69.623346 ], [ -69.058518, -70.074016 ], [ -68.725541, -70.505153 ], [ -68.451346, -70.955823 ] ] ], [ [ [ -58.614143, -64.152467 ], [ -59.045073, -64.36801 ], [ -59.789342, -64.211223 ], [ -60.611928, -64.309202 ], [ -61.297416, -64.54433 ], [ -62.0221, -64.799094 ], [ -62.51176, -65.09303 ], [ -62.648858, -65.484942 ], [ -62.590128, -65.857219 ], [ -62.120079, -66.190326 ], [ -62.805567, -66.425505 ], [ -63.74569, -66.503847 ], [ -64.294106, -66.837004 ], [ -64.881693, -67.150474 ], [ -65.508425, -67.58161 ], [ -65.665082, -67.953887 ], [ -65.312545, -68.365335 ], [ -64.783715, -68.678908 ], [ -63.961103, -68.913984 ], [ -63.1973, -69.227556 ], [ -62.785955, -69.619419 ], [ -62.570516, -69.991747 ], [ -62.276736, -70.383661 ], [ -61.806661, -70.716768 ], [ -61.512906, -71.089045 ], [ -61.375809, -72.010074 ], [ -61.081977, -72.382351 ], [ -61.003661, -72.774265 ], [ -60.690269, -73.166179 ], [ -60.827367, -73.695242 ], [ -61.375809, -74.106742 ], [ -61.96337, -74.439848 ], [ -63.295201, -74.576997 ], [ -63.74569, -74.92974 ], [ -64.352836, -75.262847 ], [ -65.860987, -75.635124 ], [ -67.192818, -75.79191 ], [ -68.446282, -76.007452 ], [ -69.797724, -76.222995 ], [ -70.600724, -76.634494 ], [ -72.206776, -76.673665 ], [ -73.969536, -76.634494 ], [ -75.555977, -76.712887 ], [ -77.24037, -76.712887 ], [ -76.926979, -77.104802 ], [ -75.399294, -77.28107 ], [ -74.282876, -77.55542 ], [ -73.656119, -77.908112 ], [ -74.772536, -78.221633 ], [ -76.4961, -78.123654 ], [ -77.925858, -78.378419 ], [ -77.984666, -78.789918 ], [ -78.023785, -79.181833 ], [ -76.848637, -79.514939 ], [ -76.633224, -79.887216 ], [ -75.360097, -80.259545 ], [ -73.244852, -80.416331 ], [ -71.442946, -80.69063 ], [ -70.013163, -81.004151 ], [ -68.191646, -81.317672 ], [ -65.704279, -81.474458 ], [ -63.25603, -81.748757 ], [ -61.552026, -82.042692 ], [ -59.691416, -82.37585 ], [ -58.712121, -82.846106 ], [ -58.222487, -83.218434 ], [ -57.008117, -82.865691 ], [ -55.362894, -82.571755 ], [ -53.619771, -82.258235 ], [ -51.543644, -82.003521 ], [ -49.76135, -81.729171 ], [ -47.273931, -81.709586 ], [ -44.825708, -81.846735 ], [ -42.808363, -82.081915 ], [ -42.16202, -81.65083 ], [ -40.771433, -81.356894 ], [ -38.244818, -81.337309 ], [ -36.26667, -81.121715 ], [ -34.386397, -80.906172 ], [ -32.310296, -80.769023 ], [ -30.097098, -80.592651 ], [ -28.549802, -80.337938 ], [ -29.254901, -79.985195 ], [ -29.685805, -79.632503 ], [ -29.685805, -79.260226 ], [ -31.624808, -79.299397 ], [ -33.681324, -79.456132 ], [ -35.639912, -79.456132 ], [ -35.914107, -79.083855 ], [ -35.77701, -78.339248 ], [ -35.326546, -78.123654 ], [ -33.896763, -77.888526 ], [ -32.212369, -77.65345 ], [ -30.998051, -77.359515 ], [ -29.783732, -77.065579 ], [ -28.882779, -76.673665 ], [ -27.511752, -76.497345 ], [ -26.160336, -76.360144 ], [ -25.474822, -76.281803 ], [ -23.927552, -76.24258 ], [ -22.458598, -76.105431 ], [ -21.224694, -75.909474 ], [ -20.010375, -75.674346 ], [ -18.913543, -75.439218 ], [ -17.522982, -75.125698 ], [ -16.641589, -74.79254 ], [ -15.701491, -74.498604 ], [ -15.40771, -74.106742 ], [ -16.46532, -73.871614 ], [ -16.112784, -73.460114 ], [ -15.446855, -73.146542 ], [ -14.408805, -72.950585 ], [ -13.311973, -72.715457 ], [ -12.293508, -72.401936 ], [ -11.510067, -72.010074 ], [ -11.020433, -71.539767 ], [ -10.295774, -71.265416 ], [ -9.101015, -71.324224 ], [ -8.611381, -71.65733 ], [ -7.416622, -71.696501 ], [ -7.377451, -71.324224 ], [ -6.868232, -70.93231 ], [ -5.790985, -71.030289 ], [ -5.536375, -71.402617 ], [ -4.341667, -71.461373 ], [ -3.048981, -71.285053 ], [ -1.795492, -71.167438 ], [ -0.659489, -71.226246 ], [ -0.228637, -71.637745 ], [ 0.868195, -71.304639 ], [ 1.886686, -71.128267 ], [ 3.022638, -70.991118 ], [ 4.139055, -70.853917 ], [ 5.157546, -70.618789 ], [ 6.273912, -70.462055 ], [ 7.13572, -70.246512 ], [ 7.742866, -69.893769 ], [ 8.48711, -70.148534 ], [ 9.525135, -70.011333 ], [ 10.249845, -70.48164 ], [ 10.817821, -70.834332 ], [ 11.953824, -70.638375 ], [ 12.404287, -70.246512 ], [ 13.422778, -69.972162 ], [ 14.734998, -70.030918 ], [ 15.126757, -70.403247 ], [ 15.949342, -70.030918 ], [ 17.026589, -69.913354 ], [ 18.201711, -69.874183 ], [ 19.259373, -69.893769 ], [ 20.375739, -70.011333 ], [ 21.452985, -70.07014 ], [ 21.923034, -70.403247 ], [ 22.569403, -70.697182 ], [ 23.666184, -70.520811 ], [ 24.841357, -70.48164 ], [ 25.977309, -70.48164 ], [ 27.093726, -70.462055 ], [ 28.09258, -70.324854 ], [ 29.150242, -70.20729 ], [ 30.031583, -69.93294 ], [ 30.971733, -69.75662 ], [ 31.990172, -69.658641 ], [ 32.754053, -69.384291 ], [ 33.302443, -68.835642 ], [ 33.870419, -68.502588 ], [ 34.908495, -68.659271 ], [ 35.300202, -69.012014 ], [ 36.16201, -69.247142 ], [ 37.200035, -69.168748 ], [ 37.905108, -69.52144 ], [ 38.649404, -69.776205 ], [ 39.667894, -69.541077 ], [ 40.020431, -69.109941 ], [ 40.921358, -68.933621 ], [ 41.959434, -68.600514 ], [ 42.938702, -68.463313 ], [ 44.113876, -68.267408 ], [ 44.897291, -68.051866 ], [ 45.719928, -67.816738 ], [ 46.503343, -67.601196 ], [ 47.44344, -67.718759 ], [ 48.344419, -67.366068 ], [ 48.990736, -67.091718 ], [ 49.930885, -67.111303 ], [ 50.753471, -66.876175 ], [ 50.949325, -66.523484 ], [ 51.791547, -66.249133 ], [ 52.614133, -66.053176 ], [ 53.613038, -65.89639 ], [ 54.53355, -65.818049 ], [ 55.414943, -65.876805 ], [ 56.355041, -65.974783 ], [ 57.158093, -66.249133 ], [ 57.255968, -66.680218 ], [ 58.137361, -67.013324 ], [ 58.744508, -67.287675 ], [ 59.939318, -67.405239 ], [ 60.605221, -67.679589 ], [ 61.427806, -67.953887 ], [ 62.387489, -68.012695 ], [ 63.19049, -67.816738 ], [ 64.052349, -67.405239 ], [ 64.992447, -67.620729 ], [ 65.971715, -67.738345 ], [ 66.911864, -67.855909 ], [ 67.891133, -67.934302 ], [ 68.890038, -67.934302 ], [ 69.712624, -68.972791 ], [ 69.673453, -69.227556 ], [ 69.555941, -69.678226 ], [ 68.596258, -69.93294 ], [ 67.81274, -70.305268 ], [ 67.949889, -70.697182 ], [ 69.066307, -70.677545 ], [ 68.929157, -71.069459 ], [ 68.419989, -71.441788 ], [ 67.949889, -71.853287 ], [ 68.71377, -72.166808 ], [ 69.869307, -72.264787 ], [ 71.024895, -72.088415 ], [ 71.573285, -71.696501 ], [ 71.906288, -71.324224 ], [ 72.454627, -71.010703 ], [ 73.08141, -70.716768 ], [ 73.33602, -70.364024 ], [ 73.864877, -69.874183 ], [ 74.491557, -69.776205 ], [ 75.62756, -69.737034 ], [ 76.626465, -69.619419 ], [ 77.644904, -69.462684 ], [ 78.134539, -69.07077 ], [ 78.428371, -68.698441 ], [ 79.113859, -68.326216 ], [ 80.093127, -68.071503 ], [ 80.93535, -67.875546 ], [ 81.483792, -67.542388 ], [ 82.051767, -67.366068 ], [ 82.776426, -67.209282 ], [ 83.775331, -67.30726 ], [ 84.676206, -67.209282 ], [ 85.655527, -67.091718 ], [ 86.752359, -67.150474 ], [ 87.477017, -66.876175 ], [ 87.986289, -66.209911 ], [ 88.358411, -66.484261 ], [ 88.828408, -66.954568 ], [ 89.67063, -67.150474 ], [ 90.630365, -67.228867 ], [ 91.5901, -67.111303 ], [ 92.608539, -67.189696 ], [ 93.548637, -67.209282 ], [ 94.17542, -67.111303 ], [ 95.017591, -67.170111 ], [ 95.781472, -67.385653 ], [ 96.682399, -67.248504 ], [ 97.759646, -67.248504 ], [ 98.68021, -67.111303 ], [ 99.718182, -67.248504 ], [ 100.384188, -66.915346 ], [ 100.893356, -66.58224 ], [ 101.578896, -66.30789 ], [ 102.832411, -65.563284 ], [ 103.478676, -65.700485 ], [ 104.242557, -65.974783 ], [ 104.90846, -66.327527 ], [ 106.181561, -66.934931 ], [ 107.160881, -66.954568 ], [ 108.081393, -66.954568 ], [ 109.15864, -66.837004 ], [ 110.235835, -66.699804 ], [ 111.058472, -66.425505 ], [ 111.74396, -66.13157 ], [ 112.860378, -66.092347 ], [ 113.604673, -65.876805 ], [ 114.388088, -66.072762 ], [ 114.897308, -66.386283 ], [ 115.602381, -66.699804 ], [ 116.699161, -66.660633 ], [ 117.384701, -66.915346 ], [ 118.57946, -67.170111 ], [ 119.832924, -67.268089 ], [ 120.871, -67.189696 ], [ 121.654415, -66.876175 ], [ 122.320369, -66.562654 ], [ 123.221296, -66.484261 ], [ 124.122274, -66.621462 ], [ 125.160247, -66.719389 ], [ 126.100396, -66.562654 ], [ 127.001427, -66.562654 ], [ 127.882768, -66.660633 ], [ 128.80328, -66.758611 ], [ 129.704259, -66.58224 ], [ 130.781454, -66.425505 ], [ 131.799945, -66.386283 ], [ 132.935896, -66.386283 ], [ 133.85646, -66.288304 ], [ 134.757387, -66.209963 ], [ 135.031582, -65.72007 ], [ 135.070753, -65.308571 ], [ 135.697485, -65.582869 ], [ 135.873805, -66.033591 ], [ 136.206705, -66.44509 ], [ 136.618049, -66.778197 ], [ 137.460271, -66.954568 ], [ 138.596223, -66.895761 ], [ 139.908442, -66.876175 ], [ 140.809421, -66.817367 ], [ 142.121692, -66.817367 ], [ 143.061842, -66.797782 ], [ 144.374061, -66.837004 ], [ 145.490427, -66.915346 ], [ 146.195552, -67.228867 ], [ 145.999699, -67.601196 ], [ 146.646067, -67.895131 ], [ 147.723263, -68.130259 ], [ 148.839629, -68.385024 ], [ 150.132314, -68.561292 ], [ 151.483705, -68.71813 ], [ 152.502247, -68.874813 ], [ 153.638199, -68.894502 ], [ 154.284567, -68.561292 ], [ 155.165857, -68.835642 ], [ 155.92979, -69.149215 ], [ 156.811132, -69.384291 ], [ 158.025528, -69.482269 ], [ 159.181013, -69.599833 ], [ 159.670699, -69.991747 ], [ 160.80665, -70.226875 ], [ 161.570479, -70.579618 ], [ 162.686897, -70.736353 ], [ 163.842434, -70.716768 ], [ 164.919681, -70.775524 ], [ 166.11444, -70.755938 ], [ 167.309095, -70.834332 ], [ 168.425616, -70.971481 ], [ 169.463589, -71.20666 ], [ 170.501665, -71.402617 ], [ 171.20679, -71.696501 ], [ 171.089227, -72.088415 ], [ 170.560422, -72.441159 ], [ 170.109958, -72.891829 ], [ 169.75737, -73.24452 ], [ 169.287321, -73.65602 ], [ 167.975101, -73.812806 ], [ 167.387489, -74.165498 ], [ 166.094803, -74.38104 ], [ 165.644391, -74.772954 ], [ 164.958851, -75.145283 ], [ 164.234193, -75.458804 ], [ 163.822797, -75.870303 ], [ 163.568239, -76.24258 ], [ 163.47026, -76.693302 ], [ 163.489897, -77.065579 ], [ 164.057873, -77.457442 ], [ 164.273363, -77.82977 ], [ 164.743464, -78.182514 ], [ 166.604126, -78.319611 ], [ 166.995781, -78.750748 ], [ 165.193876, -78.907483 ], [ 163.666217, -79.123025 ], [ 161.766385, -79.162248 ], [ 160.924162, -79.730482 ], [ 160.747894, -80.200737 ], [ 160.316964, -80.573066 ], [ 159.788211, -80.945395 ], [ 161.120016, -81.278501 ], [ 161.629287, -81.690001 ], [ 162.490992, -82.062278 ], [ 163.705336, -82.395435 ], [ 165.095949, -82.708956 ], [ 166.604126, -83.022477 ], [ 168.895665, -83.335998 ], [ 169.404782, -83.825891 ], [ 172.283934, -84.041433 ], [ 172.477049, -84.117914 ], [ 173.224083, -84.41371 ], [ 175.985672, -84.158997 ], [ 178.277212, -84.472518 ], [ 180.0, -84.71338 ], [ -179.942499, -84.721443 ], [ -179.058677, -84.139412 ], [ -177.256772, -84.452933 ], [ -177.140807, -84.417941 ], [ -176.084673, -84.099259 ], [ -175.947235, -84.110449 ], [ -175.829882, -84.117914 ], [ -174.382503, -84.534323 ], [ -173.116559, -84.117914 ], [ -172.889106, -84.061019 ], [ -169.951223, -83.884647 ], [ -168.999989, -84.117914 ], [ -168.530199, -84.23739 ], [ -167.022099, -84.570497 ], [ -164.182144, -84.82521 ], [ -161.929775, -85.138731 ], [ -158.07138, -85.37391 ], [ -155.192253, -85.09956 ], [ -150.942099, -85.295517 ], [ -148.533073, -85.609038 ], [ -145.888918, -85.315102 ], [ -143.107718, -85.040752 ], [ -142.892279, -84.570497 ], [ -146.829068, -84.531274 ], [ -150.060732, -84.296146 ], [ -150.902928, -83.904232 ], [ -153.586201, -83.68869 ], [ -153.409907, -83.23802 ], [ -153.037759, -82.82652 ], [ -152.665637, -82.454192 ], [ -152.861517, -82.042692 ], [ -154.526299, -81.768394 ], [ -155.29018, -81.41565 ], [ -156.83745, -81.102129 ], [ -154.408787, -81.160937 ], [ -152.097662, -81.004151 ], [ -150.648293, -81.337309 ], [ -148.865998, -81.043373 ], [ -147.22075, -80.671045 ], [ -146.417749, -80.337938 ], [ -146.770286, -79.926439 ], [ -148.062947, -79.652089 ], [ -149.531901, -79.358205 ], [ -151.588416, -79.299397 ], [ -153.390322, -79.162248 ], [ -155.329376, -79.064269 ], [ -155.975668, -78.69194 ], [ -157.268302, -78.378419 ], [ -158.051768, -78.025676 ], [ -158.365134, -76.889207 ], [ -157.875474, -76.987238 ], [ -156.974573, -77.300759 ], [ -155.329376, -77.202728 ], [ -153.742832, -77.065579 ], [ -152.920247, -77.496664 ], [ -151.33378, -77.398737 ], [ -150.00195, -77.183143 ], [ -148.748486, -76.908845 ], [ -147.612483, -76.575738 ], [ -146.104409, -76.47776 ], [ -146.143528, -76.105431 ], [ -146.496091, -75.733154 ], [ -146.20231, -75.380411 ], [ -144.909624, -75.204039 ], [ -144.322037, -75.537197 ], [ -142.794353, -75.34124 ], [ -141.638764, -75.086475 ], [ -140.209007, -75.06689 ], [ -138.85759, -74.968911 ], [ -137.5062, -74.733783 ], [ -136.428901, -74.518241 ], [ -135.214583, -74.302699 ], [ -134.431194, -74.361455 ], [ -133.745654, -74.439848 ], [ -132.257168, -74.302699 ], [ -130.925311, -74.479019 ], [ -129.554284, -74.459433 ], [ -128.242038, -74.322284 ], [ -126.890622, -74.420263 ], [ -125.402082, -74.518241 ], [ -124.011496, -74.479019 ], [ -122.562152, -74.498604 ], [ -121.073613, -74.518241 ], [ -119.70256, -74.479019 ], [ -118.684145, -74.185083 ], [ -117.469801, -74.028348 ], [ -116.216312, -74.243891 ], [ -115.021552, -74.067519 ], [ -113.944331, -73.714828 ], [ -113.297988, -74.028348 ], [ -112.945452, -74.38104 ], [ -112.299083, -74.714198 ], [ -111.261059, -74.420263 ], [ -110.066325, -74.79254 ], [ -108.714909, -74.910103 ], [ -107.559346, -75.184454 ], [ -106.149148, -75.125698 ], [ -104.876074, -74.949326 ], [ -103.367949, -74.988497 ], [ -102.016507, -75.125698 ], [ -100.645531, -75.302018 ], [ -100.1167, -74.870933 ], [ -100.763043, -74.537826 ], [ -101.252703, -74.185083 ], [ -102.545337, -74.106742 ], [ -103.113313, -73.734413 ], [ -103.328752, -73.362084 ], [ -103.681289, -72.61753 ], [ -102.917485, -72.754679 ], [ -101.60524, -72.813436 ], [ -100.312528, -72.754679 ], [ -99.13738, -72.911414 ], [ -98.118889, -73.20535 ], [ -97.688037, -73.558041 ], [ -96.336595, -73.616849 ], [ -95.043961, -73.4797 ], [ -93.672907, -73.283743 ], [ -92.439003, -73.166179 ], [ -91.420564, -73.401307 ], [ -90.088733, -73.322914 ], [ -89.226951, -72.558722 ], [ -88.423951, -73.009393 ], [ -87.268337, -73.185764 ], [ -86.014822, -73.087786 ], [ -85.192236, -73.4797 ], [ -83.879991, -73.518871 ], [ -82.665646, -73.636434 ], [ -81.470913, -73.851977 ], [ -80.687447, -73.4797 ], [ -80.295791, -73.126956 ], [ -79.296886, -73.518871 ], [ -77.925858, -73.420892 ], [ -76.907367, -73.636434 ], [ -76.221879, -73.969541 ], [ -74.890049, -73.871614 ], [ -73.852024, -73.65602 ], [ -72.833533, -73.401307 ], [ -71.619215, -73.264157 ], [ -70.209042, -73.146542 ], [ -68.935916, -73.009393 ], [ -67.956622, -72.79385 ], [ -67.369061, -72.480329 ], [ -67.134036, -72.049244 ], [ -67.251548, -71.637745 ], [ -67.56494, -71.245831 ], [ -67.917477, -70.853917 ], [ -68.230843, -70.462055 ], [ -68.485452, -70.109311 ], [ -68.544209, -69.717397 ], [ -68.446282, -69.325535 ], [ -67.976233, -68.953206 ], [ -67.5845, -68.541707 ], [ -67.427843, -68.149844 ], [ -67.62367, -67.718759 ], [ -67.741183, -67.326845 ], [ -67.251548, -66.876175 ], [ -66.703184, -66.58224 ], [ -66.056815, -66.209963 ], [ -65.371327, -65.89639 ], [ -64.568276, -65.602506 ], [ -64.176542, -65.171423 ], [ -63.628152, -64.897073 ], [ -63.001394, -64.642308 ], [ -62.041686, -64.583552 ], [ -61.414928, -64.270031 ], [ -60.709855, -64.074074 ], [ -59.887269, -63.95651 ], [ -59.162585, -63.701745 ], [ -58.594557, -63.388224 ], [ -57.811143, -63.27066 ], [ -57.223582, -63.525425 ], [ -57.59573, -63.858532 ], [ -58.614143, -64.152467 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "ATF", "name": "French Southern and Antarctic Lands" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 68.935, -48.625 ], [ 69.58, -48.94 ], [ 70.525, -49.065 ], [ 70.56, -49.255 ], [ 70.28, -49.71 ], [ 68.745, -49.775 ], [ 68.72, -49.2425 ], [ 68.8675, -48.83 ], [ 68.935, -48.625 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "AUS", "name": "Australia" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 145.397978, -40.792549 ], [ 146.364121, -41.137695 ], [ 146.908584, -41.000546 ], [ 147.689259, -40.808258 ], [ 148.289068, -40.875438 ], [ 148.359865, -42.062445 ], [ 148.017301, -42.407024 ], [ 147.914052, -43.211522 ], [ 147.564564, -42.937689 ], [ 146.870343, -43.634597 ], [ 146.663327, -43.580854 ], [ 146.048378, -43.549745 ], [ 145.43193, -42.693776 ], [ 145.29509, -42.03361 ], [ 144.718071, -41.162552 ], [ 144.743755, -40.703975 ], [ 145.397978, -40.792549 ] ] ], [ [ [ 143.561811, -13.763656 ], [ 143.922099, -14.548311 ], [ 144.563714, -14.171176 ], [ 144.894908, -14.594458 ], [ 145.374724, -14.984976 ], [ 145.271991, -15.428205 ], [ 145.48526, -16.285672 ], [ 145.637033, -16.784918 ], [ 145.888904, -16.906926 ], [ 146.160309, -17.761655 ], [ 146.063674, -18.280073 ], [ 146.387478, -18.958274 ], [ 147.471082, -19.480723 ], [ 148.177602, -19.955939 ], [ 148.848414, -20.39121 ], [ 148.717465, -20.633469 ], [ 149.28942, -21.260511 ], [ 149.678337, -22.342512 ], [ 150.077382, -22.122784 ], [ 150.482939, -22.556142 ], [ 150.727265, -22.402405 ], [ 150.899554, -23.462237 ], [ 151.609175, -24.076256 ], [ 152.07354, -24.457887 ], [ 152.855197, -25.267501 ], [ 153.136162, -26.071173 ], [ 153.161949, -26.641319 ], [ 153.092909, -27.2603 ], [ 153.569469, -28.110067 ], [ 153.512108, -28.995077 ], [ 153.339095, -29.458202 ], [ 153.069241, -30.35024 ], [ 153.089602, -30.923642 ], [ 152.891578, -31.640446 ], [ 152.450002, -32.550003 ], [ 151.709117, -33.041342 ], [ 151.343972, -33.816023 ], [ 151.010555, -34.31036 ], [ 150.714139, -35.17346 ], [ 150.32822, -35.671879 ], [ 150.075212, -36.420206 ], [ 149.946124, -37.109052 ], [ 149.997284, -37.425261 ], [ 149.423882, -37.772681 ], [ 148.304622, -37.809061 ], [ 147.381733, -38.219217 ], [ 146.922123, -38.606532 ], [ 146.317922, -39.035757 ], [ 145.489652, -38.593768 ], [ 144.876976, -38.417448 ], [ 145.032212, -37.896188 ], [ 144.485682, -38.085324 ], [ 143.609974, -38.809465 ], [ 142.745427, -38.538268 ], [ 142.17833, -38.380034 ], [ 141.606582, -38.308514 ], [ 140.638579, -38.019333 ], [ 139.992158, -37.402936 ], [ 139.806588, -36.643603 ], [ 139.574148, -36.138362 ], [ 139.082808, -35.732754 ], [ 138.120748, -35.612296 ], [ 138.449462, -35.127261 ], [ 138.207564, -34.384723 ], [ 137.71917, -35.076825 ], [ 136.829406, -35.260535 ], [ 137.352371, -34.707339 ], [ 137.503886, -34.130268 ], [ 137.890116, -33.640479 ], [ 137.810328, -32.900007 ], [ 136.996837, -33.752771 ], [ 136.372069, -34.094766 ], [ 135.989043, -34.890118 ], [ 135.208213, -34.47867 ], [ 135.239218, -33.947953 ], [ 134.613417, -33.222778 ], [ 134.085904, -32.848072 ], [ 134.273903, -32.617234 ], [ 132.990777, -32.011224 ], [ 132.288081, -31.982647 ], [ 131.326331, -31.495803 ], [ 129.535794, -31.590423 ], [ 128.240938, -31.948489 ], [ 127.102867, -32.282267 ], [ 126.148714, -32.215966 ], [ 125.088623, -32.728751 ], [ 124.221648, -32.959487 ], [ 124.028947, -33.483847 ], [ 123.659667, -33.890179 ], [ 122.811036, -33.914467 ], [ 122.183064, -34.003402 ], [ 121.299191, -33.821036 ], [ 120.580268, -33.930177 ], [ 119.893695, -33.976065 ], [ 119.298899, -34.509366 ], [ 119.007341, -34.464149 ], [ 118.505718, -34.746819 ], [ 118.024972, -35.064733 ], [ 117.295507, -35.025459 ], [ 116.625109, -35.025097 ], [ 115.564347, -34.386428 ], [ 115.026809, -34.196517 ], [ 115.048616, -33.623425 ], [ 115.545123, -33.487258 ], [ 115.714674, -33.259572 ], [ 115.679379, -32.900369 ], [ 115.801645, -32.205062 ], [ 115.689611, -31.612437 ], [ 115.160909, -30.601594 ], [ 114.997043, -30.030725 ], [ 115.040038, -29.461095 ], [ 114.641974, -28.810231 ], [ 114.616498, -28.516399 ], [ 114.173579, -28.118077 ], [ 114.048884, -27.334765 ], [ 113.477498, -26.543134 ], [ 113.338953, -26.116545 ], [ 113.778358, -26.549025 ], [ 113.440962, -25.621278 ], [ 113.936901, -25.911235 ], [ 114.232852, -26.298446 ], [ 114.216161, -25.786281 ], [ 113.721255, -24.998939 ], [ 113.625344, -24.683971 ], [ 113.393523, -24.384764 ], [ 113.502044, -23.80635 ], [ 113.706993, -23.560215 ], [ 113.843418, -23.059987 ], [ 113.736552, -22.475475 ], [ 114.149756, -21.755881 ], [ 114.225307, -22.517488 ], [ 114.647762, -21.82952 ], [ 115.460167, -21.495173 ], [ 115.947373, -21.068688 ], [ 116.711615, -20.701682 ], [ 117.166316, -20.623599 ], [ 117.441545, -20.746899 ], [ 118.229559, -20.374208 ], [ 118.836085, -20.263311 ], [ 118.987807, -20.044203 ], [ 119.252494, -19.952942 ], [ 119.805225, -19.976506 ], [ 120.85622, -19.683708 ], [ 121.399856, -19.239756 ], [ 121.655138, -18.705318 ], [ 122.241665, -18.197649 ], [ 122.286624, -17.798603 ], [ 122.312772, -17.254967 ], [ 123.012574, -16.4052 ], [ 123.433789, -17.268558 ], [ 123.859345, -17.069035 ], [ 123.503242, -16.596506 ], [ 123.817073, -16.111316 ], [ 124.258287, -16.327944 ], [ 124.379726, -15.56706 ], [ 124.926153, -15.0751 ], [ 125.167275, -14.680396 ], [ 125.670087, -14.51007 ], [ 125.685796, -14.230656 ], [ 126.125149, -14.347341 ], [ 126.142823, -14.095987 ], [ 126.582589, -13.952791 ], [ 127.065867, -13.817968 ], [ 127.804633, -14.276906 ], [ 128.35969, -14.86917 ], [ 128.985543, -14.875991 ], [ 129.621473, -14.969784 ], [ 129.4096, -14.42067 ], [ 129.888641, -13.618703 ], [ 130.339466, -13.357376 ], [ 130.183506, -13.10752 ], [ 130.617795, -12.536392 ], [ 131.223495, -12.183649 ], [ 131.735091, -12.302453 ], [ 132.575298, -12.114041 ], [ 132.557212, -11.603012 ], [ 131.824698, -11.273782 ], [ 132.357224, -11.128519 ], [ 133.019561, -11.376411 ], [ 133.550846, -11.786515 ], [ 134.393068, -12.042365 ], [ 134.678632, -11.941183 ], [ 135.298491, -12.248606 ], [ 135.882693, -11.962267 ], [ 136.258381, -12.049342 ], [ 136.492475, -11.857209 ], [ 136.95162, -12.351959 ], [ 136.685125, -12.887223 ], [ 136.305407, -13.29123 ], [ 135.961758, -13.324509 ], [ 136.077617, -13.724278 ], [ 135.783836, -14.223989 ], [ 135.428664, -14.715432 ], [ 135.500184, -14.997741 ], [ 136.295175, -15.550265 ], [ 137.06536, -15.870762 ], [ 137.580471, -16.215082 ], [ 138.303217, -16.807604 ], [ 138.585164, -16.806622 ], [ 139.108543, -17.062679 ], [ 139.260575, -17.371601 ], [ 140.215245, -17.710805 ], [ 140.875463, -17.369069 ], [ 141.07111, -16.832047 ], [ 141.274095, -16.38887 ], [ 141.398222, -15.840532 ], [ 141.702183, -15.044921 ], [ 141.56338, -14.561333 ], [ 141.63552, -14.270395 ], [ 141.519869, -13.698078 ], [ 141.65092, -12.944688 ], [ 141.842691, -12.741548 ], [ 141.68699, -12.407614 ], [ 141.928629, -11.877466 ], [ 142.118488, -11.328042 ], [ 142.143706, -11.042737 ], [ 142.51526, -10.668186 ], [ 142.79731, -11.157355 ], [ 142.866763, -11.784707 ], [ 143.115947, -11.90563 ], [ 143.158632, -12.325656 ], [ 143.522124, -12.834358 ], [ 143.597158, -13.400422 ], [ 143.561811, -13.763656 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "AUT", "name": "Austria" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 16.979667, 48.123497 ], [ 16.903754, 47.714866 ], [ 16.340584, 47.712902 ], [ 16.534268, 47.496171 ], [ 16.202298, 46.852386 ], [ 16.011664, 46.683611 ], [ 15.137092, 46.658703 ], [ 14.632472, 46.431817 ], [ 13.806475, 46.509306 ], [ 12.376485, 46.767559 ], [ 12.153088, 47.115393 ], [ 11.164828, 46.941579 ], [ 11.048556, 46.751359 ], [ 10.442701, 46.893546 ], [ 9.932448, 46.920728 ], [ 9.47997, 47.10281 ], [ 9.632932, 47.347601 ], [ 9.594226, 47.525058 ], [ 9.896068, 47.580197 ], [ 10.402084, 47.302488 ], [ 10.544504, 47.566399 ], [ 11.426414, 47.523766 ], [ 12.141357, 47.703083 ], [ 12.62076, 47.672388 ], [ 12.932627, 47.467646 ], [ 13.025851, 47.637584 ], [ 12.884103, 48.289146 ], [ 13.243357, 48.416115 ], [ 13.595946, 48.877172 ], [ 14.338898, 48.555305 ], [ 14.901447, 48.964402 ], [ 15.253416, 49.039074 ], [ 16.029647, 48.733899 ], [ 16.499283, 48.785808 ], [ 16.960288, 48.596982 ], [ 16.879983, 48.470013 ], [ 16.979667, 48.123497 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "AZE", "name": "Azerbaijan" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 45.001987, 39.740004 ], [ 45.298145, 39.471751 ], [ 45.739978, 39.473999 ], [ 45.735379, 39.319719 ], [ 46.143623, 38.741201 ], [ 45.457722, 38.874139 ], [ 44.952688, 39.335765 ], [ 44.79399, 39.713003 ], [ 45.001987, 39.740004 ] ] ], [ [ [ 47.373315, 41.219732 ], [ 47.815666, 41.151416 ], [ 47.987283, 41.405819 ], [ 48.584353, 41.80887 ], [ 49.110264, 41.282287 ], [ 49.618915, 40.572924 ], [ 50.08483, 40.526157 ], [ 50.392821, 40.256561 ], [ 49.569202, 40.176101 ], [ 49.395259, 39.399482 ], [ 49.223228, 39.049219 ], [ 48.856532, 38.815486 ], [ 48.883249, 38.320245 ], [ 48.634375, 38.270378 ], [ 48.010744, 38.794015 ], [ 48.355529, 39.288765 ], [ 48.060095, 39.582235 ], [ 47.685079, 39.508364 ], [ 46.50572, 38.770605 ], [ 46.483499, 39.464155 ], [ 46.034534, 39.628021 ], [ 45.610012, 39.899994 ], [ 45.891907, 40.218476 ], [ 45.359175, 40.561504 ], [ 45.560351, 40.81229 ], [ 45.179496, 40.985354 ], [ 44.97248, 41.248129 ], [ 45.217426, 41.411452 ], [ 45.962601, 41.123873 ], [ 46.501637, 41.064445 ], [ 46.637908, 41.181673 ], [ 46.145432, 41.722802 ], [ 46.404951, 41.860675 ], [ 46.686071, 41.827137 ], [ 47.373315, 41.219732 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "BDI", "name": "Burundi" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 29.339998, -4.499983 ], [ 29.276384, -3.293907 ], [ 29.024926, -2.839258 ], [ 29.632176, -2.917858 ], [ 29.938359, -2.348487 ], [ 30.469696, -2.413858 ], [ 30.527677, -2.807632 ], [ 30.743013, -3.034285 ], [ 30.752263, -3.35933 ], [ 30.50556, -3.568567 ], [ 30.116333, -4.090138 ], [ 29.753512, -4.452389 ], [ 29.339998, -4.499983 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "BEL", "name": "Belgium" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 3.314971, 51.345781 ], [ 4.047071, 51.267259 ], [ 4.973991, 51.475024 ], [ 5.606976, 51.037298 ], [ 6.156658, 50.803721 ], [ 6.043073, 50.128052 ], [ 5.782417, 50.090328 ], [ 5.674052, 49.529484 ], [ 4.799222, 49.985373 ], [ 4.286023, 49.907497 ], [ 3.588184, 50.378992 ], [ 3.123252, 50.780363 ], [ 2.658422, 50.796848 ], [ 2.513573, 51.148506 ], [ 3.314971, 51.345781 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "BEN", "name": "Benin" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 2.691702, 6.258817 ], [ 1.865241, 6.142158 ], [ 1.618951, 6.832038 ], [ 1.664478, 9.12859 ], [ 1.463043, 9.334624 ], [ 1.425061, 9.825395 ], [ 1.077795, 10.175607 ], [ 0.772336, 10.470808 ], [ 0.899563, 10.997339 ], [ 1.24347, 11.110511 ], [ 1.447178, 11.547719 ], [ 1.935986, 11.64115 ], [ 2.154474, 11.94015 ], [ 2.490164, 12.233052 ], [ 2.848643, 12.235636 ], [ 3.61118, 11.660167 ], [ 3.572216, 11.327939 ], [ 3.797112, 10.734746 ], [ 3.60007, 10.332186 ], [ 3.705438, 10.06321 ], [ 3.220352, 9.444153 ], [ 2.912308, 9.137608 ], [ 2.723793, 8.506845 ], [ 2.749063, 7.870734 ], [ 2.691702, 6.258817 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "BFA", "name": "Burkina Faso" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -2.827496, 9.642461 ], [ -3.511899, 9.900326 ], [ -3.980449, 9.862344 ], [ -4.330247, 9.610835 ], [ -4.779884, 9.821985 ], [ -4.954653, 10.152714 ], [ -5.404342, 10.370737 ], [ -5.470565, 10.95127 ], [ -5.197843, 11.375146 ], [ -5.220942, 11.713859 ], [ -4.427166, 12.542646 ], [ -4.280405, 13.228444 ], [ -4.006391, 13.472485 ], [ -3.522803, 13.337662 ], [ -3.103707, 13.541267 ], [ -2.967694, 13.79815 ], [ -2.191825, 14.246418 ], [ -2.001035, 14.559008 ], [ -1.066363, 14.973815 ], [ -0.515854, 15.116158 ], [ -0.266257, 14.924309 ], [ 0.374892, 14.928908 ], [ 0.295646, 14.444235 ], [ 0.429928, 13.988733 ], [ 0.993046, 13.33575 ], [ 1.024103, 12.851826 ], [ 2.177108, 12.625018 ], [ 2.154474, 11.94015 ], [ 1.935986, 11.64115 ], [ 1.447178, 11.547719 ], [ 1.24347, 11.110511 ], [ 0.899563, 10.997339 ], [ 0.023803, 11.018682 ], [ -0.438702, 11.098341 ], [ -0.761576, 10.93693 ], [ -1.203358, 11.009819 ], [ -2.940409, 10.96269 ], [ -2.963896, 10.395335 ], [ -2.827496, 9.642461 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "BGD", "name": "Bangladesh" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 92.672721, 22.041239 ], [ 92.652257, 21.324048 ], [ 92.303234, 21.475485 ], [ 92.368554, 20.670883 ], [ 92.082886, 21.192195 ], [ 92.025215, 21.70157 ], [ 91.834891, 22.182936 ], [ 91.417087, 22.765019 ], [ 90.496006, 22.805017 ], [ 90.586957, 22.392794 ], [ 90.272971, 21.836368 ], [ 89.847467, 22.039146 ], [ 89.70205, 21.857116 ], [ 89.418863, 21.966179 ], [ 89.031961, 22.055708 ], [ 88.876312, 22.879146 ], [ 88.52977, 23.631142 ], [ 88.69994, 24.233715 ], [ 88.084422, 24.501657 ], [ 88.306373, 24.866079 ], [ 88.931554, 25.238692 ], [ 88.209789, 25.768066 ], [ 88.563049, 26.446526 ], [ 89.355094, 26.014407 ], [ 89.832481, 25.965082 ], [ 89.920693, 25.26975 ], [ 90.872211, 25.132601 ], [ 91.799596, 25.147432 ], [ 92.376202, 24.976693 ], [ 91.915093, 24.130414 ], [ 91.46773, 24.072639 ], [ 91.158963, 23.503527 ], [ 91.706475, 22.985264 ], [ 91.869928, 23.624346 ], [ 92.146035, 23.627499 ], [ 92.672721, 22.041239 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "BGR", "name": "Bulgaria" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 22.65715, 44.234923 ], [ 22.944832, 43.823785 ], [ 23.332302, 43.897011 ], [ 24.100679, 43.741051 ], [ 25.569272, 43.688445 ], [ 26.065159, 43.943494 ], [ 27.2424, 44.175986 ], [ 27.970107, 43.812468 ], [ 28.558081, 43.707462 ], [ 28.039095, 43.293172 ], [ 27.673898, 42.577892 ], [ 27.99672, 42.007359 ], [ 27.135739, 42.141485 ], [ 26.117042, 41.826905 ], [ 26.106138, 41.328899 ], [ 25.197201, 41.234486 ], [ 24.492645, 41.583896 ], [ 23.692074, 41.309081 ], [ 22.952377, 41.337994 ], [ 22.881374, 41.999297 ], [ 22.380526, 42.32026 ], [ 22.545012, 42.461362 ], [ 22.436595, 42.580321 ], [ 22.604801, 42.898519 ], [ 22.986019, 43.211161 ], [ 22.500157, 43.642814 ], [ 22.410446, 44.008063 ], [ 22.65715, 44.234923 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "BHS", "name": "The Bahamas" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -77.53466, 23.75975 ], [ -77.78, 23.71 ], [ -78.03405, 24.28615 ], [ -78.40848, 24.57564 ], [ -78.19087, 25.2103 ], [ -77.89, 25.17 ], [ -77.54, 24.34 ], [ -77.53466, 23.75975 ] ] ], [ [ [ -77.82, 26.58 ], [ -78.91, 26.42 ], [ -78.98, 26.79 ], [ -78.51, 26.87 ], [ -77.85, 26.84 ], [ -77.82, 26.58 ] ] ], [ [ [ -77.0, 26.59 ], [ -77.17255, 25.87918 ], [ -77.35641, 26.00735 ], [ -77.34, 26.53 ], [ -77.78802, 26.92516 ], [ -77.79, 27.04 ], [ -77.0, 26.59 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "BIH", "name": "Bosnia and Herzegovina" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 19.005486, 44.860234 ], [ 19.36803, 44.863 ], [ 19.11761, 44.42307 ], [ 19.59976, 44.03847 ], [ 19.454, 43.5681 ], [ 19.21852, 43.52384 ], [ 19.03165, 43.43253 ], [ 18.70648, 43.20011 ], [ 18.56, 42.65 ], [ 17.674922, 43.028563 ], [ 17.297373, 43.446341 ], [ 16.916156, 43.667722 ], [ 16.456443, 44.04124 ], [ 16.23966, 44.351143 ], [ 15.750026, 44.818712 ], [ 15.959367, 45.233777 ], [ 16.318157, 45.004127 ], [ 16.534939, 45.211608 ], [ 17.002146, 45.233777 ], [ 17.861783, 45.06774 ], [ 18.553214, 45.08159 ], [ 19.005486, 44.860234 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "BLR", "name": "Belarus" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 23.484128, 53.912498 ], [ 24.450684, 53.905702 ], [ 25.536354, 54.282423 ], [ 25.768433, 54.846963 ], [ 26.588279, 55.167176 ], [ 26.494331, 55.615107 ], [ 27.10246, 55.783314 ], [ 28.176709, 56.16913 ], [ 29.229513, 55.918344 ], [ 29.371572, 55.670091 ], [ 29.896294, 55.789463 ], [ 30.873909, 55.550976 ], [ 30.971836, 55.081548 ], [ 30.757534, 54.811771 ], [ 31.384472, 54.157056 ], [ 31.791424, 53.974639 ], [ 31.731273, 53.794029 ], [ 32.405599, 53.618045 ], [ 32.693643, 53.351421 ], [ 32.304519, 53.132726 ], [ 31.497644, 53.167427 ], [ 31.305201, 53.073996 ], [ 31.540018, 52.742052 ], [ 31.785998, 52.101678 ], [ 30.927549, 52.042353 ], [ 30.619454, 51.822806 ], [ 30.555117, 51.319503 ], [ 30.157364, 51.416138 ], [ 29.254938, 51.368234 ], [ 28.992835, 51.602044 ], [ 28.617613, 51.427714 ], [ 28.241615, 51.572227 ], [ 27.454066, 51.592303 ], [ 26.337959, 51.832289 ], [ 25.327788, 51.910656 ], [ 24.553106, 51.888461 ], [ 24.005078, 51.617444 ], [ 23.527071, 51.578454 ], [ 23.508002, 52.023647 ], [ 23.199494, 52.486977 ], [ 23.799199, 52.691099 ], [ 23.804935, 53.089731 ], [ 23.527536, 53.470122 ], [ 23.484128, 53.912498 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "BLZ", "name": "Belize" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -89.14308, 17.808319 ], [ -89.150909, 17.955468 ], [ -89.029857, 18.001511 ], [ -88.848344, 17.883198 ], [ -88.490123, 18.486831 ], [ -88.300031, 18.499982 ], [ -88.296336, 18.353273 ], [ -88.106813, 18.348674 ], [ -88.123479, 18.076675 ], [ -88.285355, 17.644143 ], [ -88.197867, 17.489475 ], [ -88.302641, 17.131694 ], [ -88.239518, 17.036066 ], [ -88.355428, 16.530774 ], [ -88.551825, 16.265467 ], [ -88.732434, 16.233635 ], [ -88.930613, 15.887273 ], [ -89.229122, 15.886938 ], [ -89.150806, 17.015577 ], [ -89.14308, 17.808319 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "BMU", "name": "Bermuda" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -64.779973433299801, 32.3072000581802 ], [ -64.768738200563007, 32.308836981657201 ], [ -64.756677373961296, 32.313050913017499 ], [ -64.746248235428098, 32.318538611580998 ], [ -64.742301921648505, 32.323311561213004 ], [ -64.741172997633299, 32.331179086462697 ], [ -64.738352154909407, 32.340721651491798 ], [ -64.734962460882002, 32.344281983049903 ], [ -64.727061606722202, 32.346646171547498 ], [ -64.7214189847314, 32.351883023134199 ], [ -64.718596766666906, 32.3552239212394 ], [ -64.714930157611207, 32.355218875351298 ], [ -64.706732854446003, 32.342901072303597 ], [ -64.688709064818298, 32.334243940805301 ], [ -64.673733123538398, 32.3390281851635 ], [ -64.659881126497794, 32.349762577175497 ], [ -64.6672170444687, 32.359775161747301 ], [ -64.6801998697415, 32.3631199096979 ], [ -64.683587665283497, 32.362644767796802 ], [ -64.682463599550402, 32.3540628176846 ], [ -64.686415009925497, 32.3547797587266 ], [ -64.689516482608198, 32.363359857986602 ], [ -64.694034803396704, 32.3640708659835 ], [ -64.700531552697001, 32.359060135681801 ], [ -64.706176474440397, 32.360011059355898 ], [ -64.711756998279796, 32.368132600248998 ], [ -64.704386895650003, 32.370425476046897 ], [ -64.695461767271397, 32.376322128586899 ], [ -64.683427054859493, 32.3854968316788 ], [ -64.669066607439703, 32.388444543924003 ], [ -64.661322751283194, 32.376313500872101 ], [ -64.6462011670816, 32.369751697490003 ], [ -64.651258194709996, 32.361560090646599 ], [ -64.660572038442893, 32.358942348776303 ], [ -64.653216882349895, 32.3494356627941 ], [ -64.6567136927777, 32.345177645846903 ], [ -64.676892112745193, 32.332409539755503 ], [ -64.696277881313307, 32.327502911553204 ], [ -64.711785124713401, 32.317682336080601 ], [ -64.720699179768204, 32.313754220125801 ], [ -64.742398297143595, 32.299673499402402 ], [ -64.755180344227597, 32.290832670253103 ], [ -64.764474243642596, 32.285593135321399 ], [ -64.774541597041605, 32.2718413023427 ], [ -64.790017772733805, 32.265944693699197 ], [ -64.810508727557902, 32.256120897415599 ], [ -64.820569755602605, 32.253169888032801 ], [ -64.825638953058402, 32.247263739859399 ], [ -64.833400257553194, 32.246271471469797 ], [ -64.838824260520894, 32.247577347253397 ], [ -64.842311980074001, 32.249212331729602 ], [ -64.851981955572199, 32.248551913466301 ], [ -64.863194968876996, 32.246579948580099 ], [ -64.878323000462899, 32.261300141868098 ], [ -64.884977665829197, 32.281926136600397 ], [ -64.878004684432099, 32.290775783169202 ], [ -64.877966732848506, 32.303863280046201 ], [ -64.872135459341493, 32.304190860630101 ], [ -64.868666899407899, 32.309107450829998 ], [ -64.863592293257298, 32.304846943336301 ], [ -64.852029865116407, 32.311091187995402 ], [ -64.833869059367203, 32.329458756155702 ], [ -64.835024232931104, 32.324216176000597 ], [ -64.843923348671694, 32.314055385254299 ], [ -64.859742907227897, 32.301584202193297 ], [ -64.855906876443697, 32.296032118647098 ], [ -64.867142212729505, 32.293076054798902 ], [ -64.871775285664398, 32.281937158202602 ], [ -64.874865133895099, 32.275712026475297 ], [ -64.862824145956296, 32.272448193395903 ], [ -64.868229678944601, 32.261639361432202 ], [ -64.856609046235405, 32.2547740387514 ], [ -64.839992485497206, 32.254782282336002 ], [ -64.830673214349801, 32.258394484023498 ], [ -64.828754884030602, 32.266907547381699 ], [ -64.822558787368294, 32.266911128939498 ], [ -64.806670769108706, 32.274776756946501 ], [ -64.799702551343699, 32.279689641732801 ], [ -64.781508633697797, 32.286897311451398 ], [ -64.796229146548399, 32.293440973242703 ], [ -64.810196802964199, 32.302283318051103 ], [ -64.816789635243694, 32.305884571846597 ], [ -64.809429798128306, 32.309817572841403 ], [ -64.794694271017306, 32.303268270038799 ], [ -64.787331918306094, 32.303923714342801 ], [ -64.779973433299801, 32.3072000581802 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "BOL", "name": "Bolivia" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -62.846468, -22.034985 ], [ -63.986838, -21.993644 ], [ -64.377021, -22.798091 ], [ -64.964892, -22.075862 ], [ -66.273339, -21.83231 ], [ -67.106674, -22.735925 ], [ -67.82818, -22.872919 ], [ -68.219913, -21.494347 ], [ -68.757167, -20.372658 ], [ -68.442225, -19.405068 ], [ -68.966818, -18.981683 ], [ -69.100247, -18.260125 ], [ -69.590424, -17.580012 ], [ -68.959635, -16.500698 ], [ -69.389764, -15.660129 ], [ -69.160347, -15.323974 ], [ -69.339535, -14.953195 ], [ -68.948887, -14.453639 ], [ -68.929224, -13.602684 ], [ -68.88008, -12.899729 ], [ -68.66508, -12.5613 ], [ -69.529678, -10.951734 ], [ -68.786158, -11.03638 ], [ -68.271254, -11.014521 ], [ -68.048192, -10.712059 ], [ -67.173801, -10.306812 ], [ -66.646908, -9.931331 ], [ -65.338435, -9.761988 ], [ -65.444837, -10.511451 ], [ -65.321899, -10.895872 ], [ -65.402281, -11.56627 ], [ -64.316353, -12.461978 ], [ -63.196499, -12.627033 ], [ -62.80306, -13.000653 ], [ -62.127081, -13.198781 ], [ -61.713204, -13.489202 ], [ -61.084121, -13.479384 ], [ -60.503304, -13.775955 ], [ -60.459198, -14.354007 ], [ -60.264326, -14.645979 ], [ -60.251149, -15.077219 ], [ -60.542966, -15.09391 ], [ -60.15839, -16.258284 ], [ -58.24122, -16.299573 ], [ -58.388058, -16.877109 ], [ -58.280804, -17.27171 ], [ -57.734558, -17.552468 ], [ -57.498371, -18.174188 ], [ -57.676009, -18.96184 ], [ -57.949997, -19.400004 ], [ -57.853802, -19.969995 ], [ -58.166392, -20.176701 ], [ -58.183471, -19.868399 ], [ -59.115042, -19.356906 ], [ -60.043565, -19.342747 ], [ -61.786326, -19.633737 ], [ -62.265961, -20.513735 ], [ -62.291179, -21.051635 ], [ -62.685057, -22.249029 ], [ -62.846468, -22.034985 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "BRA", "name": "Brazil" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -57.625133, -30.216295 ], [ -56.2909, -28.852761 ], [ -55.162286, -27.881915 ], [ -54.490725, -27.474757 ], [ -53.648735, -26.923473 ], [ -53.628349, -26.124865 ], [ -54.13005, -25.547639 ], [ -54.625291, -25.739255 ], [ -54.428946, -25.162185 ], [ -54.293476, -24.5708 ], [ -54.29296, -24.021014 ], [ -54.652834, -23.839578 ], [ -55.027902, -24.001274 ], [ -55.400747, -23.956935 ], [ -55.517639, -23.571998 ], [ -55.610683, -22.655619 ], [ -55.797958, -22.35693 ], [ -56.473317, -22.0863 ], [ -56.88151, -22.282154 ], [ -57.937156, -22.090176 ], [ -57.870674, -20.732688 ], [ -58.166392, -20.176701 ], [ -57.853802, -19.969995 ], [ -57.949997, -19.400004 ], [ -57.676009, -18.96184 ], [ -57.498371, -18.174188 ], [ -57.734558, -17.552468 ], [ -58.280804, -17.27171 ], [ -58.388058, -16.877109 ], [ -58.24122, -16.299573 ], [ -60.15839, -16.258284 ], [ -60.542966, -15.09391 ], [ -60.251149, -15.077219 ], [ -60.264326, -14.645979 ], [ -60.459198, -14.354007 ], [ -60.503304, -13.775955 ], [ -61.084121, -13.479384 ], [ -61.713204, -13.489202 ], [ -62.127081, -13.198781 ], [ -62.80306, -13.000653 ], [ -63.196499, -12.627033 ], [ -64.316353, -12.461978 ], [ -65.402281, -11.56627 ], [ -65.321899, -10.895872 ], [ -65.444837, -10.511451 ], [ -65.338435, -9.761988 ], [ -66.646908, -9.931331 ], [ -67.173801, -10.306812 ], [ -68.048192, -10.712059 ], [ -68.271254, -11.014521 ], [ -68.786158, -11.03638 ], [ -69.529678, -10.951734 ], [ -70.093752, -11.123972 ], [ -70.548686, -11.009147 ], [ -70.481894, -9.490118 ], [ -71.302412, -10.079436 ], [ -72.184891, -10.053598 ], [ -72.563033, -9.520194 ], [ -73.226713, -9.462213 ], [ -73.015383, -9.032833 ], [ -73.571059, -8.424447 ], [ -73.987235, -7.52383 ], [ -73.723401, -7.340999 ], [ -73.724487, -6.918595 ], [ -73.120027, -6.629931 ], [ -73.219711, -6.089189 ], [ -72.964507, -5.741251 ], [ -72.891928, -5.274561 ], [ -71.748406, -4.593983 ], [ -70.928843, -4.401591 ], [ -70.794769, -4.251265 ], [ -69.893635, -4.298187 ], [ -69.444102, -1.556287 ], [ -69.420486, -1.122619 ], [ -69.577065, -0.549992 ], [ -70.020656, -0.185156 ], [ -70.015566, 0.541414 ], [ -69.452396, 0.706159 ], [ -69.252434, 0.602651 ], [ -69.218638, 0.985677 ], [ -69.804597, 1.089081 ], [ -69.816973, 1.714805 ], [ -67.868565, 1.692455 ], [ -67.53781, 2.037163 ], [ -67.259998, 1.719999 ], [ -67.065048, 1.130112 ], [ -66.876326, 1.253361 ], [ -66.325765, 0.724452 ], [ -65.548267, 0.789254 ], [ -65.354713, 1.095282 ], [ -64.611012, 1.328731 ], [ -64.199306, 1.492855 ], [ -64.083085, 1.916369 ], [ -63.368788, 2.2009 ], [ -63.422867, 2.411068 ], [ -64.269999, 2.497006 ], [ -64.408828, 3.126786 ], [ -64.368494, 3.79721 ], [ -64.816064, 4.056445 ], [ -64.628659, 4.148481 ], [ -63.888343, 4.02053 ], [ -63.093198, 3.770571 ], [ -62.804533, 4.006965 ], [ -62.08543, 4.162124 ], [ -60.966893, 4.536468 ], [ -60.601179, 4.918098 ], [ -60.733574, 5.200277 ], [ -60.213683, 5.244486 ], [ -59.980959, 5.014061 ], [ -60.111002, 4.574967 ], [ -59.767406, 4.423503 ], [ -59.53804, 3.958803 ], [ -59.815413, 3.606499 ], [ -59.974525, 2.755233 ], [ -59.718546, 2.24963 ], [ -59.646044, 1.786894 ], [ -59.030862, 1.317698 ], [ -58.540013, 1.268088 ], [ -58.429477, 1.463942 ], [ -58.11345, 1.507195 ], [ -57.660971, 1.682585 ], [ -57.335823, 1.948538 ], [ -56.782704, 1.863711 ], [ -56.539386, 1.899523 ], [ -55.995698, 1.817667 ], [ -55.9056, 2.021996 ], [ -56.073342, 2.220795 ], [ -55.973322, 2.510364 ], [ -55.569755, 2.421506 ], [ -55.097587, 2.523748 ], [ -54.524754, 2.311849 ], [ -54.088063, 2.105557 ], [ -53.778521, 2.376703 ], [ -53.554839, 2.334897 ], [ -53.418465, 2.053389 ], [ -52.939657, 2.124858 ], [ -52.556425, 2.504705 ], [ -52.249338, 3.241094 ], [ -51.657797, 4.156232 ], [ -51.317146, 4.203491 ], [ -51.069771, 3.650398 ], [ -50.508875, 1.901564 ], [ -49.974076, 1.736483 ], [ -49.947101, 1.04619 ], [ -50.699251, 0.222984 ], [ -50.388211, -0.078445 ], [ -48.620567, -0.235489 ], [ -48.584497, -1.237805 ], [ -47.824956, -0.581618 ], [ -46.566584, -0.941028 ], [ -44.905703, -1.55174 ], [ -44.417619, -2.13775 ], [ -44.581589, -2.691308 ], [ -43.418791, -2.38311 ], [ -41.472657, -2.912018 ], [ -39.978665, -2.873054 ], [ -38.500383, -3.700652 ], [ -37.223252, -4.820946 ], [ -36.452937, -5.109404 ], [ -35.597796, -5.149504 ], [ -35.235389, -5.464937 ], [ -34.89603, -6.738193 ], [ -34.729993, -7.343221 ], [ -35.128212, -8.996401 ], [ -35.636967, -9.649282 ], [ -37.046519, -11.040721 ], [ -37.683612, -12.171195 ], [ -38.423877, -13.038119 ], [ -38.673887, -13.057652 ], [ -38.953276, -13.79337 ], [ -38.882298, -15.667054 ], [ -39.161092, -17.208407 ], [ -39.267339, -17.867746 ], [ -39.583521, -18.262296 ], [ -39.760823, -19.599113 ], [ -40.774741, -20.904512 ], [ -40.944756, -21.937317 ], [ -41.754164, -22.370676 ], [ -41.988284, -22.97007 ], [ -43.074704, -22.967693 ], [ -44.647812, -23.351959 ], [ -45.352136, -23.796842 ], [ -46.472093, -24.088969 ], [ -47.648972, -24.885199 ], [ -48.495458, -25.877025 ], [ -48.641005, -26.623698 ], [ -48.474736, -27.175912 ], [ -48.66152, -28.186135 ], [ -48.888457, -28.674115 ], [ -49.587329, -29.224469 ], [ -50.696874, -30.984465 ], [ -51.576226, -31.777698 ], [ -52.256081, -32.24537 ], [ -52.7121, -33.196578 ], [ -53.373662, -33.768378 ], [ -53.650544, -33.202004 ], [ -53.209589, -32.727666 ], [ -53.787952, -32.047243 ], [ -54.572452, -31.494511 ], [ -55.60151, -30.853879 ], [ -55.973245, -30.883076 ], [ -56.976026, -30.109686 ], [ -57.625133, -30.216295 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "BRN", "name": "Brunei" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 114.204017, 4.525874 ], [ 114.599961, 4.900011 ], [ 115.45071, 5.44773 ], [ 115.4057, 4.955228 ], [ 115.347461, 4.316636 ], [ 114.869557, 4.348314 ], [ 114.659596, 4.007637 ], [ 114.204017, 4.525874 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "BTN", "name": "Bhutan" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 91.696657, 27.771742 ], [ 92.103712, 27.452614 ], [ 92.033484, 26.83831 ], [ 91.217513, 26.808648 ], [ 90.373275, 26.875724 ], [ 89.744528, 26.719403 ], [ 88.835643, 27.098966 ], [ 88.814248, 27.299316 ], [ 89.47581, 28.042759 ], [ 90.015829, 28.296439 ], [ 90.730514, 28.064954 ], [ 91.258854, 28.040614 ], [ 91.696657, 27.771742 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "BWA", "name": "Botswana" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 25.649163, -18.536026 ], [ 25.850391, -18.714413 ], [ 26.164791, -19.293086 ], [ 27.296505, -20.39152 ], [ 27.724747, -20.499059 ], [ 27.727228, -20.851802 ], [ 28.02137, -21.485975 ], [ 28.794656, -21.639454 ], [ 29.432188, -22.091313 ], [ 28.017236, -22.827754 ], [ 27.11941, -23.574323 ], [ 26.786407, -24.240691 ], [ 26.485753, -24.616327 ], [ 25.941652, -24.696373 ], [ 25.765849, -25.174845 ], [ 25.664666, -25.486816 ], [ 25.025171, -25.71967 ], [ 24.211267, -25.670216 ], [ 23.73357, -25.390129 ], [ 23.312097, -25.26869 ], [ 22.824271, -25.500459 ], [ 22.579532, -25.979448 ], [ 22.105969, -26.280256 ], [ 21.605896, -26.726534 ], [ 20.889609, -26.828543 ], [ 20.66647, -26.477453 ], [ 20.758609, -25.868136 ], [ 20.165726, -24.917962 ], [ 19.895768, -24.76779 ], [ 19.895458, -21.849157 ], [ 20.881134, -21.814327 ], [ 20.910641, -18.252219 ], [ 21.65504, -18.219146 ], [ 23.196858, -17.869038 ], [ 23.579006, -18.281261 ], [ 24.217365, -17.889347 ], [ 24.520705, -17.887125 ], [ 25.084443, -17.661816 ], [ 25.264226, -17.73654 ], [ 25.649163, -18.536026 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "CAF", "name": "Central African Republic" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 15.27946, 7.421925 ], [ 16.106232, 7.497088 ], [ 16.290562, 7.754307 ], [ 16.456185, 7.734774 ], [ 16.705988, 7.508328 ], [ 17.96493, 7.890914 ], [ 18.389555, 8.281304 ], [ 18.911022, 8.630895 ], [ 18.81201, 8.982915 ], [ 19.094008, 9.074847 ], [ 20.059685, 9.012706 ], [ 21.000868, 9.475985 ], [ 21.723822, 10.567056 ], [ 22.231129, 10.971889 ], [ 22.864165, 11.142395 ], [ 22.977544, 10.714463 ], [ 23.554304, 10.089255 ], [ 23.55725, 9.681218 ], [ 23.394779, 9.265068 ], [ 23.459013, 8.954286 ], [ 23.805813, 8.666319 ], [ 24.567369, 8.229188 ], [ 25.114932, 7.825104 ], [ 25.124131, 7.500085 ], [ 25.796648, 6.979316 ], [ 26.213418, 6.546603 ], [ 26.465909, 5.946717 ], [ 27.213409, 5.550953 ], [ 27.374226, 5.233944 ], [ 27.044065, 5.127853 ], [ 26.402761, 5.150875 ], [ 25.650455, 5.256088 ], [ 25.278798, 5.170408 ], [ 25.128833, 4.927245 ], [ 24.805029, 4.897247 ], [ 24.410531, 5.108784 ], [ 23.297214, 4.609693 ], [ 22.84148, 4.710126 ], [ 22.704124, 4.633051 ], [ 22.405124, 4.02916 ], [ 21.659123, 4.224342 ], [ 20.927591, 4.322786 ], [ 20.290679, 4.691678 ], [ 19.467784, 5.031528 ], [ 18.932312, 4.709506 ], [ 18.542982, 4.201785 ], [ 18.453065, 3.504386 ], [ 17.8099, 3.560196 ], [ 17.133042, 3.728197 ], [ 16.537058, 3.198255 ], [ 16.012852, 2.26764 ], [ 15.907381, 2.557389 ], [ 15.862732, 3.013537 ], [ 15.405396, 3.335301 ], [ 15.03622, 3.851367 ], [ 14.950953, 4.210389 ], [ 14.478372, 4.732605 ], [ 14.558936, 5.030598 ], [ 14.459407, 5.451761 ], [ 14.53656, 6.226959 ], [ 14.776545, 6.408498 ], [ 15.27946, 7.421925 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "CAN", "name": "Canada" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -63.6645, 46.55001 ], [ -62.9393, 46.41587 ], [ -62.01208, 46.44314 ], [ -62.50391, 46.03339 ], [ -62.87433, 45.96818 ], [ -64.1428, 46.39265 ], [ -64.39261, 46.72747 ], [ -64.01486, 47.03601 ], [ -63.6645, 46.55001 ] ] ], [ [ [ -61.806305, 49.10506 ], [ -62.29318, 49.08717 ], [ -63.58926, 49.40069 ], [ -64.51912, 49.87304 ], [ -64.17322, 49.95718 ], [ -62.85829, 49.70641 ], [ -61.835585, 49.28855 ], [ -61.806305, 49.10506 ] ] ], [ [ [ -123.510002, 48.510011 ], [ -124.012891, 48.370846 ], [ -125.655013, 48.825005 ], [ -125.954994, 49.179996 ], [ -126.850004, 49.53 ], [ -127.029993, 49.814996 ], [ -128.059336, 49.994959 ], [ -128.444584, 50.539138 ], [ -128.358414, 50.770648 ], [ -127.308581, 50.552574 ], [ -126.695001, 50.400903 ], [ -125.755007, 50.295018 ], [ -125.415002, 49.950001 ], [ -124.920768, 49.475275 ], [ -123.922509, 49.062484 ], [ -123.510002, 48.510011 ] ] ], [ [ [ -56.134036, 50.68701 ], [ -56.795882, 49.812309 ], [ -56.143105, 50.150117 ], [ -55.471492, 49.935815 ], [ -55.822401, 49.587129 ], [ -54.935143, 49.313011 ], [ -54.473775, 49.556691 ], [ -53.476549, 49.249139 ], [ -53.786014, 48.516781 ], [ -53.086134, 48.687804 ], [ -52.958648, 48.157164 ], [ -52.648099, 47.535548 ], [ -53.069158, 46.655499 ], [ -53.521456, 46.618292 ], [ -54.178936, 46.807066 ], [ -53.961869, 47.625207 ], [ -54.240482, 47.752279 ], [ -55.400773, 46.884994 ], [ -55.997481, 46.91972 ], [ -55.291219, 47.389562 ], [ -56.250799, 47.632545 ], [ -57.325229, 47.572807 ], [ -59.266015, 47.603348 ], [ -59.419494, 47.899454 ], [ -58.796586, 48.251525 ], [ -59.231625, 48.523188 ], [ -58.391805, 49.125581 ], [ -57.35869, 50.718274 ], [ -56.73865, 51.287438 ], [ -55.870977, 51.632094 ], [ -55.406974, 51.588273 ], [ -55.600218, 51.317075 ], [ -56.134036, 50.68701 ] ] ], [ [ [ -132.710008, 54.040009 ], [ -131.74999, 54.120004 ], [ -132.04948, 52.984621 ], [ -131.179043, 52.180433 ], [ -131.57783, 52.182371 ], [ -132.180428, 52.639707 ], [ -132.549992, 53.100015 ], [ -133.054611, 53.411469 ], [ -133.239664, 53.85108 ], [ -133.180004, 54.169975 ], [ -132.710008, 54.040009 ] ] ], [ [ [ -79.26582, 62.158675 ], [ -79.65752, 61.63308 ], [ -80.09956, 61.7181 ], [ -80.36215, 62.01649 ], [ -80.315395, 62.085565 ], [ -79.92939, 62.3856 ], [ -79.52002, 62.36371 ], [ -79.26582, 62.158675 ] ] ], [ [ [ -81.89825, 62.7108 ], [ -83.06857, 62.15922 ], [ -83.77462, 62.18231 ], [ -83.99367, 62.4528 ], [ -83.25048, 62.91409 ], [ -81.87699, 62.90458 ], [ -81.89825, 62.7108 ] ] ], [ [ [ -85.161308, 65.657285 ], [ -84.975764, 65.217518 ], [ -84.464012, 65.371772 ], [ -83.882626, 65.109618 ], [ -82.787577, 64.766693 ], [ -81.642014, 64.455136 ], [ -81.55344, 63.979609 ], [ -80.817361, 64.057486 ], [ -80.103451, 63.725981 ], [ -80.99102, 63.411246 ], [ -82.547178, 63.651722 ], [ -83.108798, 64.101876 ], [ -84.100417, 63.569712 ], [ -85.523405, 63.052379 ], [ -85.866769, 63.637253 ], [ -87.221983, 63.541238 ], [ -86.35276, 64.035833 ], [ -86.224886, 64.822917 ], [ -85.883848, 65.738778 ], [ -85.161308, 65.657285 ] ] ], [ [ [ -75.86588, 67.14886 ], [ -76.98687, 67.09873 ], [ -77.2364, 67.58809 ], [ -76.81166, 68.14856 ], [ -75.89521, 68.28721 ], [ -75.1145, 68.01036 ], [ -75.10333, 67.58202 ], [ -75.21597, 67.44425 ], [ -75.86588, 67.14886 ] ] ], [ [ [ -95.647681, 69.10769 ], [ -96.269521, 68.75704 ], [ -97.617401, 69.06003 ], [ -98.431801, 68.9507 ], [ -99.797401, 69.40003 ], [ -98.917401, 69.71003 ], [ -98.218261, 70.14354 ], [ -97.157401, 69.86003 ], [ -96.557401, 69.68003 ], [ -96.257401, 69.49003 ], [ -95.647681, 69.10769 ] ] ], [ [ [ -90.5471, 69.49766 ], [ -90.55151, 68.47499 ], [ -89.21515, 69.25873 ], [ -88.01966, 68.61508 ], [ -88.31749, 67.87338 ], [ -87.35017, 67.19872 ], [ -86.30607, 67.92146 ], [ -85.57664, 68.78456 ], [ -85.52197, 69.88211 ], [ -84.10081, 69.80539 ], [ -82.62258, 69.65826 ], [ -81.28043, 69.16202 ], [ -81.2202, 68.66567 ], [ -81.96436, 68.13253 ], [ -81.25928, 67.59716 ], [ -81.38653, 67.11078 ], [ -83.34456, 66.41154 ], [ -84.73542, 66.2573 ], [ -85.76943, 66.55833 ], [ -86.0676, 66.05625 ], [ -87.03143, 65.21297 ], [ -87.32324, 64.77563 ], [ -88.48296, 64.09897 ], [ -89.91444, 64.03273 ], [ -90.70398, 63.61017 ], [ -90.77004, 62.96021 ], [ -91.93342, 62.83508 ], [ -93.15698, 62.02469 ], [ -94.24153, 60.89865 ], [ -94.62931, 60.11021 ], [ -94.6846, 58.94882 ], [ -93.21502, 58.78212 ], [ -92.76462, 57.84571 ], [ -92.29703, 57.08709 ], [ -90.89769, 57.28468 ], [ -89.03953, 56.85172 ], [ -88.03978, 56.47162 ], [ -87.32421, 55.99914 ], [ -86.07121, 55.72383 ], [ -85.01181, 55.3026 ], [ -83.36055, 55.24489 ], [ -82.27285, 55.14832 ], [ -82.4362, 54.28227 ], [ -82.12502, 53.27703 ], [ -81.40075, 52.15788 ], [ -79.91289, 51.20842 ], [ -79.14301, 51.53393 ], [ -78.60191, 52.56208 ], [ -79.12421, 54.14145 ], [ -79.82958, 54.66772 ], [ -78.22874, 55.13645 ], [ -77.0956, 55.83741 ], [ -76.54137, 56.53423 ], [ -76.62319, 57.20263 ], [ -77.30226, 58.05209 ], [ -78.51688, 58.80458 ], [ -77.33676, 59.85261 ], [ -77.77272, 60.75788 ], [ -78.10687, 62.31964 ], [ -77.41067, 62.55053 ], [ -75.69621, 62.2784 ], [ -74.6682, 62.18111 ], [ -73.83988, 62.4438 ], [ -72.90853, 62.10507 ], [ -71.67708, 61.52535 ], [ -71.37369, 61.13717 ], [ -69.59042, 61.06141 ], [ -69.62033, 60.22125 ], [ -69.2879, 58.95736 ], [ -68.37455, 58.80106 ], [ -67.64976, 58.21206 ], [ -66.20178, 58.76731 ], [ -65.24517, 59.87071 ], [ -64.58352, 60.33558 ], [ -63.80475, 59.4426 ], [ -62.50236, 58.16708 ], [ -61.39655, 56.96745 ], [ -61.79866, 56.33945 ], [ -60.46853, 55.77548 ], [ -59.56962, 55.20407 ], [ -57.97508, 54.94549 ], [ -57.3332, 54.6265 ], [ -56.93689, 53.78032 ], [ -56.15811, 53.64749 ], [ -55.75632, 53.27036 ], [ -55.68338, 52.14664 ], [ -56.40916, 51.7707 ], [ -57.12691, 51.41972 ], [ -58.77482, 51.0643 ], [ -60.03309, 50.24277 ], [ -61.72366, 50.08046 ], [ -63.86251, 50.29099 ], [ -65.36331, 50.2982 ], [ -66.39905, 50.22897 ], [ -67.23631, 49.51156 ], [ -68.51114, 49.06836 ], [ -69.95362, 47.74488 ], [ -71.10458, 46.82171 ], [ -70.25522, 46.98606 ], [ -68.65, 48.3 ], [ -66.55243, 49.1331 ], [ -65.05626, 49.23278 ], [ -64.17099, 48.74248 ], [ -65.11545, 48.07085 ], [ -64.79854, 46.99297 ], [ -64.47219, 46.23849 ], [ -63.17329, 45.73902 ], [ -61.52072, 45.88377 ], [ -60.51815, 47.00793 ], [ -60.4486, 46.28264 ], [ -59.80287, 45.9204 ], [ -61.03988, 45.26525 ], [ -63.25471, 44.67014 ], [ -64.24656, 44.26553 ], [ -65.36406, 43.54523 ], [ -66.1234, 43.61867 ], [ -66.16173, 44.46512 ], [ -64.42549, 45.29204 ], [ -66.02605, 45.25931 ], [ -67.13741, 45.13753 ], [ -67.79134, 45.70281 ], [ -67.79046, 47.06636 ], [ -68.23444, 47.35486 ], [ -68.905, 47.185 ], [ -69.237216, 47.447781 ], [ -69.99997, 46.69307 ], [ -70.305, 45.915 ], [ -70.66, 45.46 ], [ -71.08482, 45.30524 ], [ -71.405, 45.255 ], [ -71.50506, 45.0082 ], [ -73.34783, 45.00738 ], [ -74.867, 45.00048 ], [ -75.31821, 44.81645 ], [ -76.375, 44.09631 ], [ -76.5, 44.018459 ], [ -76.820034, 43.628784 ], [ -77.737885, 43.629056 ], [ -78.72028, 43.625089 ], [ -79.171674, 43.466339 ], [ -79.01, 43.27 ], [ -78.92, 42.965 ], [ -78.939362, 42.863611 ], [ -80.247448, 42.3662 ], [ -81.277747, 42.209026 ], [ -82.439278, 41.675105 ], [ -82.690089, 41.675105 ], [ -83.02981, 41.832796 ], [ -83.142, 41.975681 ], [ -83.12, 42.08 ], [ -82.9, 42.43 ], [ -82.43, 42.98 ], [ -82.137642, 43.571088 ], [ -82.337763, 44.44 ], [ -82.550925, 45.347517 ], [ -83.592851, 45.816894 ], [ -83.469551, 45.994686 ], [ -83.616131, 46.116927 ], [ -83.890765, 46.116927 ], [ -84.091851, 46.275419 ], [ -84.14212, 46.512226 ], [ -84.3367, 46.40877 ], [ -84.6049, 46.4396 ], [ -84.543749, 46.538684 ], [ -84.779238, 46.637102 ], [ -84.87608, 46.900083 ], [ -85.652363, 47.220219 ], [ -86.461991, 47.553338 ], [ -87.439793, 47.94 ], [ -88.378114, 48.302918 ], [ -89.272917, 48.019808 ], [ -89.6, 48.01 ], [ -90.83, 48.27 ], [ -91.64, 48.14 ], [ -92.61, 48.45 ], [ -93.63087, 48.60926 ], [ -94.32914, 48.67074 ], [ -94.64, 48.84 ], [ -94.81758, 49.38905 ], [ -95.15609, 49.38425 ], [ -95.15907, 49.0 ], [ -97.22872, 49.0007 ], [ -100.65, 49.0 ], [ -104.04826, 48.99986 ], [ -107.05, 49.0 ], [ -110.05, 49.0 ], [ -113.0, 49.0 ], [ -116.04818, 49.0 ], [ -117.03121, 49.0 ], [ -120.0, 49.0 ], [ -122.84, 49.0 ], [ -122.97421, 49.002538 ], [ -124.91024, 49.98456 ], [ -125.62461, 50.41656 ], [ -127.43561, 50.83061 ], [ -127.99276, 51.71583 ], [ -127.85032, 52.32961 ], [ -129.12979, 52.75538 ], [ -129.30523, 53.56159 ], [ -130.51497, 54.28757 ], [ -130.53611, 54.80278 ], [ -129.98, 55.285 ], [ -130.00778, 55.91583 ], [ -131.70781, 56.55212 ], [ -132.73042, 57.69289 ], [ -133.35556, 58.41028 ], [ -134.27111, 58.86111 ], [ -134.945, 59.27056 ], [ -135.47583, 59.78778 ], [ -136.47972, 59.46389 ], [ -137.4525, 58.905 ], [ -138.34089, 59.56211 ], [ -139.039, 60.0 ], [ -140.013, 60.27682 ], [ -140.99778, 60.30639 ], [ -140.9925, 66.00003 ], [ -140.986, 69.712 ], [ -139.12052, 69.47102 ], [ -137.54636, 68.99002 ], [ -136.50358, 68.89804 ], [ -135.62576, 69.31512 ], [ -134.41464, 69.62743 ], [ -132.92925, 69.50534 ], [ -131.43136, 69.94451 ], [ -129.79471, 70.19369 ], [ -129.10773, 69.77927 ], [ -128.36156, 70.01286 ], [ -128.13817, 70.48384 ], [ -127.44712, 70.37721 ], [ -125.75632, 69.48058 ], [ -124.42483, 70.1584 ], [ -124.28968, 69.39969 ], [ -123.06108, 69.56372 ], [ -122.6835, 69.85553 ], [ -121.47226, 69.79778 ], [ -119.94288, 69.37786 ], [ -117.60268, 69.01128 ], [ -116.22643, 68.84151 ], [ -115.2469, 68.90591 ], [ -113.89794, 68.3989 ], [ -115.30489, 67.90261 ], [ -113.49727, 67.68815 ], [ -110.798, 67.80612 ], [ -109.94619, 67.98104 ], [ -108.8802, 67.38144 ], [ -107.79239, 67.88736 ], [ -108.81299, 68.31164 ], [ -108.16721, 68.65392 ], [ -106.95, 68.7 ], [ -106.15, 68.8 ], [ -105.34282, 68.56122 ], [ -104.33791, 68.018 ], [ -103.22115, 68.09775 ], [ -101.45433, 67.64689 ], [ -99.90195, 67.80566 ], [ -98.4432, 67.78165 ], [ -98.5586, 68.40394 ], [ -97.66948, 68.57864 ], [ -96.11991, 68.23939 ], [ -96.12588, 67.29338 ], [ -95.48943, 68.0907 ], [ -94.685, 68.06383 ], [ -94.23282, 69.06903 ], [ -95.30408, 69.68571 ], [ -96.47131, 70.08976 ], [ -96.39115, 71.19482 ], [ -95.2088, 71.92053 ], [ -93.88997, 71.76015 ], [ -92.87818, 71.31869 ], [ -91.51964, 70.19129 ], [ -92.40692, 69.69997 ], [ -90.5471, 69.49766 ] ] ], [ [ [ -114.16717, 73.12145 ], [ -114.66634, 72.65277 ], [ -112.44102, 72.9554 ], [ -111.05039, 72.4504 ], [ -109.92035, 72.96113 ], [ -109.00654, 72.63335 ], [ -108.18835, 71.65089 ], [ -107.68599, 72.06548 ], [ -108.39639, 73.08953 ], [ -107.51645, 73.23598 ], [ -106.52259, 73.07601 ], [ -105.40246, 72.67259 ], [ -104.77484, 71.6984 ], [ -104.46476, 70.99297 ], [ -102.78537, 70.49776 ], [ -100.98078, 70.02432 ], [ -101.08929, 69.58447 ], [ -102.73116, 69.50402 ], [ -102.09329, 69.11962 ], [ -102.43024, 68.75282 ], [ -104.24, 68.91 ], [ -105.96, 69.18 ], [ -107.12254, 69.11922 ], [ -109.0, 68.78 ], [ -111.534149, 68.630059 ], [ -113.3132, 68.53554 ], [ -113.85496, 69.00744 ], [ -115.22, 69.28 ], [ -116.10794, 69.16821 ], [ -117.34, 69.96 ], [ -116.67473, 70.06655 ], [ -115.13112, 70.2373 ], [ -113.72141, 70.19237 ], [ -112.4161, 70.36638 ], [ -114.35, 70.6 ], [ -116.48684, 70.52045 ], [ -117.9048, 70.54056 ], [ -118.43238, 70.9092 ], [ -116.11311, 71.30918 ], [ -117.65568, 71.2952 ], [ -119.40199, 71.55859 ], [ -118.56267, 72.30785 ], [ -117.86642, 72.70594 ], [ -115.18909, 73.31459 ], [ -114.16717, 73.12145 ] ] ], [ [ [ -104.5, 73.42 ], [ -105.38, 72.76 ], [ -106.94, 73.46 ], [ -106.6, 73.6 ], [ -105.26, 73.64 ], [ -104.5, 73.42 ] ] ], [ [ [ -76.34, 73.102685 ], [ -76.251404, 72.826385 ], [ -77.314438, 72.855545 ], [ -78.39167, 72.876656 ], [ -79.486252, 72.742203 ], [ -79.775833, 72.802902 ], [ -80.876099, 73.333183 ], [ -80.833885, 73.693184 ], [ -80.353058, 73.75972 ], [ -78.064438, 73.651932 ], [ -76.34, 73.102685 ] ] ], [ [ [ -86.562179, 73.157447 ], [ -85.774371, 72.534126 ], [ -84.850112, 73.340278 ], [ -82.31559, 73.750951 ], [ -80.600088, 72.716544 ], [ -80.748942, 72.061907 ], [ -78.770639, 72.352173 ], [ -77.824624, 72.749617 ], [ -75.605845, 72.243678 ], [ -74.228616, 71.767144 ], [ -74.099141, 71.33084 ], [ -72.242226, 71.556925 ], [ -71.200015, 70.920013 ], [ -68.786054, 70.525024 ], [ -67.91497, 70.121948 ], [ -66.969033, 69.186087 ], [ -68.805123, 68.720198 ], [ -66.449866, 68.067163 ], [ -64.862314, 67.847539 ], [ -63.424934, 66.928473 ], [ -61.851981, 66.862121 ], [ -62.163177, 66.160251 ], [ -63.918444, 64.998669 ], [ -65.14886, 65.426033 ], [ -66.721219, 66.388041 ], [ -68.015016, 66.262726 ], [ -68.141287, 65.689789 ], [ -67.089646, 65.108455 ], [ -65.73208, 64.648406 ], [ -65.320168, 64.382737 ], [ -64.669406, 63.392927 ], [ -65.013804, 62.674185 ], [ -66.275045, 62.945099 ], [ -68.783186, 63.74567 ], [ -67.369681, 62.883966 ], [ -66.328297, 62.280075 ], [ -66.165568, 61.930897 ], [ -68.877367, 62.330149 ], [ -71.023437, 62.910708 ], [ -72.235379, 63.397836 ], [ -71.886278, 63.679989 ], [ -73.378306, 64.193963 ], [ -74.834419, 64.679076 ], [ -74.818503, 64.389093 ], [ -77.70998, 64.229542 ], [ -78.555949, 64.572906 ], [ -77.897281, 65.309192 ], [ -76.018274, 65.326969 ], [ -73.959795, 65.454765 ], [ -74.293883, 65.811771 ], [ -73.944912, 66.310578 ], [ -72.651167, 67.284576 ], [ -72.92606, 67.726926 ], [ -73.311618, 68.069437 ], [ -74.843307, 68.554627 ], [ -76.869101, 68.894736 ], [ -76.228649, 69.147769 ], [ -77.28737, 69.76954 ], [ -78.168634, 69.826488 ], [ -78.957242, 70.16688 ], [ -79.492455, 69.871808 ], [ -81.305471, 69.743185 ], [ -84.944706, 69.966634 ], [ -87.060003, 70.260001 ], [ -88.681713, 70.410741 ], [ -89.51342, 70.762038 ], [ -88.467721, 71.218186 ], [ -89.888151, 71.222552 ], [ -90.20516, 72.235074 ], [ -89.436577, 73.129464 ], [ -88.408242, 73.537889 ], [ -85.826151, 73.803816 ], [ -86.562179, 73.157447 ] ] ], [ [ [ -100.35642, 73.84389 ], [ -99.16387, 73.63339 ], [ -97.38, 73.76 ], [ -97.12, 73.47 ], [ -98.05359, 72.99052 ], [ -96.54, 72.56 ], [ -96.72, 71.66 ], [ -98.35966, 71.27285 ], [ -99.32286, 71.35639 ], [ -100.01482, 71.73827 ], [ -102.5, 72.51 ], [ -102.48, 72.83 ], [ -100.43836, 72.70588 ], [ -101.54, 73.36 ], [ -100.35642, 73.84389 ] ] ], [ [ [ -93.196296, 72.771992 ], [ -94.269047, 72.024596 ], [ -95.409856, 72.061881 ], [ -96.033745, 72.940277 ], [ -96.018268, 73.43743 ], [ -95.495793, 73.862417 ], [ -94.503658, 74.134907 ], [ -92.420012, 74.100025 ], [ -90.509793, 73.856732 ], [ -92.003965, 72.966244 ], [ -93.196296, 72.771992 ] ] ], [ [ [ -120.46, 71.383602 ], [ -123.09219, 70.90164 ], [ -123.62, 71.34 ], [ -125.928949, 71.868688 ], [ -125.5, 72.292261 ], [ -124.80729, 73.02256 ], [ -123.94, 73.68 ], [ -124.91775, 74.29275 ], [ -121.53788, 74.44893 ], [ -120.10978, 74.24135 ], [ -117.55564, 74.18577 ], [ -116.58442, 73.89607 ], [ -115.51081, 73.47519 ], [ -116.76794, 73.22292 ], [ -119.22, 72.52 ], [ -120.46, 71.82 ], [ -120.46, 71.383602 ] ] ], [ [ [ -93.612756, 74.979997 ], [ -94.156909, 74.592347 ], [ -95.608681, 74.666864 ], [ -96.820932, 74.927623 ], [ -96.288587, 75.377828 ], [ -94.85082, 75.647218 ], [ -93.977747, 75.29649 ], [ -93.612756, 74.979997 ] ] ], [ [ [ -98.5, 76.72 ], [ -97.735585, 76.25656 ], [ -97.704415, 75.74344 ], [ -98.16, 75.0 ], [ -99.80874, 74.89744 ], [ -100.88366, 75.05736 ], [ -100.86292, 75.64075 ], [ -102.50209, 75.5638 ], [ -102.56552, 76.3366 ], [ -101.48973, 76.30537 ], [ -99.98349, 76.64634 ], [ -98.57699, 76.58859 ], [ -98.5, 76.72 ] ] ], [ [ [ -108.21141, 76.20168 ], [ -107.81943, 75.84552 ], [ -106.92893, 76.01282 ], [ -105.881, 75.9694 ], [ -105.70498, 75.47951 ], [ -106.31347, 75.00527 ], [ -109.7, 74.85 ], [ -112.22307, 74.41696 ], [ -113.74381, 74.39427 ], [ -113.87135, 74.72029 ], [ -111.79421, 75.1625 ], [ -116.31221, 75.04343 ], [ -117.7104, 75.2222 ], [ -116.34602, 76.19903 ], [ -115.40487, 76.47887 ], [ -112.59056, 76.14134 ], [ -110.81422, 75.54919 ], [ -109.0671, 75.47321 ], [ -110.49726, 76.42982 ], [ -109.5811, 76.79417 ], [ -108.54859, 76.67832 ], [ -108.21141, 76.20168 ] ] ], [ [ [ -94.684086, 77.097878 ], [ -93.573921, 76.776296 ], [ -91.605023, 76.778518 ], [ -90.741846, 76.449597 ], [ -90.969661, 76.074013 ], [ -89.822238, 75.847774 ], [ -89.187083, 75.610166 ], [ -87.838276, 75.566189 ], [ -86.379192, 75.482421 ], [ -84.789625, 75.699204 ], [ -82.753445, 75.784315 ], [ -81.128531, 75.713983 ], [ -80.057511, 75.336849 ], [ -79.833933, 74.923127 ], [ -80.457771, 74.657304 ], [ -81.948843, 74.442459 ], [ -83.228894, 74.564028 ], [ -86.097452, 74.410032 ], [ -88.15035, 74.392307 ], [ -89.764722, 74.515555 ], [ -92.422441, 74.837758 ], [ -92.768285, 75.38682 ], [ -92.889906, 75.882655 ], [ -93.893824, 76.319244 ], [ -95.962457, 76.441381 ], [ -97.121379, 76.751078 ], [ -96.745123, 77.161389 ], [ -94.684086, 77.097878 ] ] ], [ [ [ -116.198587, 77.645287 ], [ -116.335813, 76.876962 ], [ -117.106051, 76.530032 ], [ -118.040412, 76.481172 ], [ -119.899318, 76.053213 ], [ -121.499995, 75.900019 ], [ -122.854924, 76.116543 ], [ -122.854925, 76.116543 ], [ -121.157535, 76.864508 ], [ -119.103939, 77.51222 ], [ -117.570131, 77.498319 ], [ -116.198587, 77.645287 ] ] ], [ [ [ -93.840003, 77.519997 ], [ -94.295608, 77.491343 ], [ -96.169654, 77.555111 ], [ -96.436304, 77.834629 ], [ -94.422577, 77.820005 ], [ -93.720656, 77.634331 ], [ -93.840003, 77.519997 ] ] ], [ [ [ -110.186938, 77.697015 ], [ -112.051191, 77.409229 ], [ -113.534279, 77.732207 ], [ -112.724587, 78.05105 ], [ -111.264443, 78.152956 ], [ -109.854452, 77.996325 ], [ -110.186938, 77.697015 ] ] ], [ [ [ -109.663146, 78.601973 ], [ -110.881314, 78.40692 ], [ -112.542091, 78.407902 ], [ -112.525891, 78.550555 ], [ -111.50001, 78.849994 ], [ -110.963661, 78.804441 ], [ -109.663146, 78.601973 ] ] ], [ [ [ -95.830295, 78.056941 ], [ -97.309843, 77.850597 ], [ -98.124289, 78.082857 ], [ -98.552868, 78.458105 ], [ -98.631984, 78.87193 ], [ -97.337231, 78.831984 ], [ -96.754399, 78.765813 ], [ -95.559278, 78.418315 ], [ -95.830295, 78.056941 ] ] ], [ [ [ -100.060192, 78.324754 ], [ -99.670939, 77.907545 ], [ -101.30394, 78.018985 ], [ -102.949809, 78.343229 ], [ -105.176133, 78.380332 ], [ -104.210429, 78.67742 ], [ -105.41958, 78.918336 ], [ -105.492289, 79.301594 ], [ -103.529282, 79.165349 ], [ -100.825158, 78.800462 ], [ -100.060192, 78.324754 ] ] ], [ [ [ -87.02, 79.66 ], [ -85.81435, 79.3369 ], [ -87.18756, 79.0393 ], [ -89.03535, 78.28723 ], [ -90.80436, 78.21533 ], [ -92.87669, 78.34333 ], [ -93.95116, 78.75099 ], [ -93.93574, 79.11373 ], [ -93.14524, 79.3801 ], [ -94.974, 79.37248 ], [ -96.07614, 79.70502 ], [ -96.70972, 80.15777 ], [ -96.01644, 80.60233 ], [ -95.32345, 80.90729 ], [ -94.29843, 80.97727 ], [ -94.73542, 81.20646 ], [ -92.40984, 81.25739 ], [ -91.13289, 80.72345 ], [ -89.45, 80.509322 ], [ -87.81, 80.32 ], [ -87.02, 79.66 ] ] ], [ [ [ -68.5, 83.106322 ], [ -65.82735, 83.02801 ], [ -63.68, 82.9 ], [ -61.85, 82.6286 ], [ -61.89388, 82.36165 ], [ -64.334, 81.92775 ], [ -66.75342, 81.72527 ], [ -67.65755, 81.50141 ], [ -65.48031, 81.50657 ], [ -67.84, 80.9 ], [ -69.4697, 80.61683 ], [ -71.18, 79.8 ], [ -73.2428, 79.63415 ], [ -73.88, 79.430162 ], [ -76.90773, 79.32309 ], [ -75.52924, 79.19766 ], [ -76.22046, 79.01907 ], [ -75.39345, 78.52581 ], [ -76.34354, 78.18296 ], [ -77.88851, 77.89991 ], [ -78.36269, 77.50859 ], [ -79.75951, 77.20968 ], [ -79.61965, 76.98336 ], [ -77.91089, 77.022045 ], [ -77.88911, 76.777955 ], [ -80.56125, 76.17812 ], [ -83.17439, 76.45403 ], [ -86.11184, 76.29901 ], [ -87.6, 76.42 ], [ -89.49068, 76.47239 ], [ -89.6161, 76.95213 ], [ -87.76739, 77.17833 ], [ -88.26, 77.9 ], [ -87.65, 77.970222 ], [ -84.97634, 77.53873 ], [ -86.34, 78.18 ], [ -87.96192, 78.37181 ], [ -87.15198, 78.75867 ], [ -85.37868, 78.9969 ], [ -85.09495, 79.34543 ], [ -86.50734, 79.73624 ], [ -86.93179, 80.25145 ], [ -84.19844, 80.20836 ], [ -83.408696, 80.1 ], [ -81.84823, 80.46442 ], [ -84.1, 80.58 ], [ -87.59895, 80.51627 ], [ -89.36663, 80.85569 ], [ -90.2, 81.26 ], [ -91.36786, 81.5531 ], [ -91.58702, 81.89429 ], [ -90.1, 82.085 ], [ -88.93227, 82.11751 ], [ -86.97024, 82.27961 ], [ -85.5, 82.652273 ], [ -84.260005, 82.6 ], [ -83.18, 82.32 ], [ -82.42, 82.86 ], [ -81.1, 83.02 ], [ -79.30664, 83.13056 ], [ -76.25, 83.172059 ], [ -75.71878, 83.06404 ], [ -72.83153, 83.23324 ], [ -70.665765, 83.169781 ], [ -68.5, 83.106322 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "CHE", "name": "Switzerland" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 9.594226, 47.525058 ], [ 9.632932, 47.347601 ], [ 9.47997, 47.10281 ], [ 9.932448, 46.920728 ], [ 10.442701, 46.893546 ], [ 10.363378, 46.483571 ], [ 9.922837, 46.314899 ], [ 9.182882, 46.440215 ], [ 8.966306, 46.036932 ], [ 8.489952, 46.005151 ], [ 8.31663, 46.163642 ], [ 7.755992, 45.82449 ], [ 7.273851, 45.776948 ], [ 6.843593, 45.991147 ], [ 6.5001, 46.429673 ], [ 6.022609, 46.27299 ], [ 6.037389, 46.725779 ], [ 6.768714, 47.287708 ], [ 6.736571, 47.541801 ], [ 7.192202, 47.449766 ], [ 7.466759, 47.620582 ], [ 8.317301, 47.61358 ], [ 8.522612, 47.830828 ], [ 9.594226, 47.525058 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "CHL", "name": "Chile" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -68.63401, -52.63637 ], [ -68.63335, -54.8695 ], [ -67.56244, -54.87001 ], [ -66.95992, -54.89681 ], [ -67.29103, -55.30124 ], [ -68.14863, -55.61183 ], [ -68.639991, -55.580018 ], [ -69.2321, -55.49906 ], [ -69.95809, -55.19843 ], [ -71.00568, -55.05383 ], [ -72.2639, -54.49514 ], [ -73.2852, -53.95752 ], [ -74.66253, -52.83749 ], [ -73.8381, -53.04743 ], [ -72.43418, -53.7154 ], [ -71.10773, -54.07433 ], [ -70.59178, -53.61583 ], [ -70.26748, -52.93123 ], [ -69.34565, -52.5183 ], [ -68.63401, -52.63637 ] ] ], [ [ [ -68.219913, -21.494347 ], [ -67.82818, -22.872919 ], [ -67.106674, -22.735925 ], [ -66.985234, -22.986349 ], [ -67.328443, -24.025303 ], [ -68.417653, -24.518555 ], [ -68.386001, -26.185016 ], [ -68.5948, -26.506909 ], [ -68.295542, -26.89934 ], [ -69.001235, -27.521214 ], [ -69.65613, -28.459141 ], [ -70.01355, -29.367923 ], [ -69.919008, -30.336339 ], [ -70.535069, -31.36501 ], [ -70.074399, -33.09121 ], [ -69.814777, -33.273886 ], [ -69.817309, -34.193571 ], [ -70.388049, -35.169688 ], [ -70.364769, -36.005089 ], [ -71.121881, -36.658124 ], [ -71.118625, -37.576827 ], [ -70.814664, -38.552995 ], [ -71.413517, -38.916022 ], [ -71.680761, -39.808164 ], [ -71.915734, -40.832339 ], [ -71.746804, -42.051386 ], [ -72.148898, -42.254888 ], [ -71.915424, -43.408565 ], [ -71.464056, -43.787611 ], [ -71.793623, -44.207172 ], [ -71.329801, -44.407522 ], [ -71.222779, -44.784243 ], [ -71.659316, -44.973689 ], [ -71.552009, -45.560733 ], [ -71.917258, -46.884838 ], [ -72.447355, -47.738533 ], [ -72.331161, -48.244238 ], [ -72.648247, -48.878618 ], [ -73.415436, -49.318436 ], [ -73.328051, -50.378785 ], [ -72.975747, -50.74145 ], [ -72.309974, -50.67701 ], [ -72.329404, -51.425956 ], [ -71.914804, -52.009022 ], [ -69.498362, -52.142761 ], [ -68.571545, -52.299444 ], [ -69.461284, -52.291951 ], [ -69.94278, -52.537931 ], [ -70.845102, -52.899201 ], [ -71.006332, -53.833252 ], [ -71.429795, -53.856455 ], [ -72.557943, -53.53141 ], [ -73.702757, -52.835069 ], [ -73.702757, -52.83507 ], [ -74.946763, -52.262754 ], [ -75.260026, -51.629355 ], [ -74.976632, -51.043396 ], [ -75.479754, -50.378372 ], [ -75.608015, -48.673773 ], [ -75.18277, -47.711919 ], [ -74.126581, -46.939253 ], [ -75.644395, -46.647643 ], [ -74.692154, -45.763976 ], [ -74.351709, -44.103044 ], [ -73.240356, -44.454961 ], [ -72.717804, -42.383356 ], [ -73.3889, -42.117532 ], [ -73.701336, -43.365776 ], [ -74.331943, -43.224958 ], [ -74.017957, -41.794813 ], [ -73.677099, -39.942213 ], [ -73.217593, -39.258689 ], [ -73.505559, -38.282883 ], [ -73.588061, -37.156285 ], [ -73.166717, -37.12378 ], [ -72.553137, -35.50884 ], [ -71.861732, -33.909093 ], [ -71.43845, -32.418899 ], [ -71.668721, -30.920645 ], [ -71.370083, -30.095682 ], [ -71.489894, -28.861442 ], [ -70.905124, -27.64038 ], [ -70.724954, -25.705924 ], [ -70.403966, -23.628997 ], [ -70.091246, -21.393319 ], [ -70.16442, -19.756468 ], [ -70.372572, -18.347975 ], [ -69.858444, -18.092694 ], [ -69.590424, -17.580012 ], [ -69.100247, -18.260125 ], [ -68.966818, -18.981683 ], [ -68.442225, -19.405068 ], [ -68.757167, -20.372658 ], [ -68.219913, -21.494347 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "HKG", "name": "Hong Kong" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 113.851416807423163, 22.506438329356449 ], [ 114.572093023255817, 22.862681686046461 ], [ 114.750516811512696, 22.658399377752342 ], [ 114.22985101744186, 22.132412790697622 ], [ 113.804051598837205, 22.159883720930178 ], [ 113.851416807423163, 22.506438329356449 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "CIV", "name": "Ivory Coast" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -2.856125, 4.994476 ], [ -3.311084, 4.984296 ], [ -4.00882, 5.179813 ], [ -4.649917, 5.168264 ], [ -5.834496, 4.993701 ], [ -6.528769, 4.705088 ], [ -7.518941, 4.338288 ], [ -7.712159, 4.364566 ], [ -7.635368, 5.188159 ], [ -7.539715, 5.313345 ], [ -7.570153, 5.707352 ], [ -7.993693, 6.12619 ], [ -8.311348, 6.193033 ], [ -8.60288, 6.467564 ], [ -8.385452, 6.911801 ], [ -8.485446, 7.395208 ], [ -8.439298, 7.686043 ], [ -8.280703, 7.68718 ], [ -8.221792, 8.123329 ], [ -8.299049, 8.316444 ], [ -8.203499, 8.455453 ], [ -7.8321, 8.575704 ], [ -8.079114, 9.376224 ], [ -8.309616, 9.789532 ], [ -8.229337, 10.12902 ], [ -8.029944, 10.206535 ], [ -7.89959, 10.297382 ], [ -7.622759, 10.147236 ], [ -6.850507, 10.138994 ], [ -6.666461, 10.430811 ], [ -6.493965, 10.411303 ], [ -6.205223, 10.524061 ], [ -6.050452, 10.096361 ], [ -5.816926, 10.222555 ], [ -5.404342, 10.370737 ], [ -4.954653, 10.152714 ], [ -4.779884, 9.821985 ], [ -4.330247, 9.610835 ], [ -3.980449, 9.862344 ], [ -3.511899, 9.900326 ], [ -2.827496, 9.642461 ], [ -2.56219, 8.219628 ], [ -2.983585, 7.379705 ], [ -3.24437, 6.250472 ], [ -2.810701, 5.389051 ], [ -2.856125, 4.994476 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "CMR", "name": "Cameroon" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 13.075822, 2.267097 ], [ 12.951334, 2.321616 ], [ 12.35938, 2.192812 ], [ 11.751665, 2.326758 ], [ 11.276449, 2.261051 ], [ 9.649158, 2.283866 ], [ 9.795196, 3.073404 ], [ 9.404367, 3.734527 ], [ 8.948116, 3.904129 ], [ 8.744924, 4.352215 ], [ 8.488816, 4.495617 ], [ 8.500288, 4.771983 ], [ 8.757533, 5.479666 ], [ 9.233163, 6.444491 ], [ 9.522706, 6.453482 ], [ 10.118277, 7.03877 ], [ 10.497375, 7.055358 ], [ 11.058788, 6.644427 ], [ 11.745774, 6.981383 ], [ 11.839309, 7.397042 ], [ 12.063946, 7.799808 ], [ 12.218872, 8.305824 ], [ 12.753672, 8.717763 ], [ 12.955468, 9.417772 ], [ 13.1676, 9.640626 ], [ 13.308676, 10.160362 ], [ 13.57295, 10.798566 ], [ 14.415379, 11.572369 ], [ 14.468192, 11.904752 ], [ 14.577178, 12.085361 ], [ 14.181336, 12.483657 ], [ 14.213531, 12.802035 ], [ 14.495787, 12.859396 ], [ 14.893386, 12.219048 ], [ 14.960152, 11.555574 ], [ 14.923565, 10.891325 ], [ 15.467873, 9.982337 ], [ 14.909354, 9.992129 ], [ 14.627201, 9.920919 ], [ 14.171466, 10.021378 ], [ 13.954218, 9.549495 ], [ 14.544467, 8.965861 ], [ 14.979996, 8.796104 ], [ 15.120866, 8.38215 ], [ 15.436092, 7.692812 ], [ 15.27946, 7.421925 ], [ 14.776545, 6.408498 ], [ 14.53656, 6.226959 ], [ 14.459407, 5.451761 ], [ 14.558936, 5.030598 ], [ 14.478372, 4.732605 ], [ 14.950953, 4.210389 ], [ 15.03622, 3.851367 ], [ 15.405396, 3.335301 ], [ 15.862732, 3.013537 ], [ 15.907381, 2.557389 ], [ 16.012852, 2.26764 ], [ 15.940919, 1.727673 ], [ 15.146342, 1.964015 ], [ 14.337813, 2.227875 ], [ 13.075822, 2.267097 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "COD", "name": "Democratic Republic of the Congo" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 30.83386, 3.509166 ], [ 30.773347, 2.339883 ], [ 31.174149, 2.204465 ], [ 30.85267, 1.849396 ], [ 30.468508, 1.583805 ], [ 30.086154, 1.062313 ], [ 29.875779, 0.59738 ], [ 29.819503, -0.20531 ], [ 29.587838, -0.587406 ], [ 29.579466, -1.341313 ], [ 29.291887, -1.620056 ], [ 29.254835, -2.21511 ], [ 29.117479, -2.292211 ], [ 29.024926, -2.839258 ], [ 29.276384, -3.293907 ], [ 29.339998, -4.499983 ], [ 29.519987, -5.419979 ], [ 29.419993, -5.939999 ], [ 29.620032, -6.520015 ], [ 30.199997, -7.079981 ], [ 30.740015, -8.340007 ], [ 30.346086, -8.238257 ], [ 29.002912, -8.407032 ], [ 28.734867, -8.526559 ], [ 28.449871, -9.164918 ], [ 28.673682, -9.605925 ], [ 28.49607, -10.789884 ], [ 28.372253, -11.793647 ], [ 28.642417, -11.971569 ], [ 29.341548, -12.360744 ], [ 29.616001, -12.178895 ], [ 29.699614, -13.257227 ], [ 28.934286, -13.248958 ], [ 28.523562, -12.698604 ], [ 28.155109, -12.272481 ], [ 27.388799, -12.132747 ], [ 27.16442, -11.608748 ], [ 26.553088, -11.92444 ], [ 25.75231, -11.784965 ], [ 25.418118, -11.330936 ], [ 24.78317, -11.238694 ], [ 24.314516, -11.262826 ], [ 24.257155, -10.951993 ], [ 23.912215, -10.926826 ], [ 23.456791, -10.867863 ], [ 22.837345, -11.017622 ], [ 22.402798, -10.993075 ], [ 22.155268, -11.084801 ], [ 22.208753, -9.894796 ], [ 21.875182, -9.523708 ], [ 21.801801, -8.908707 ], [ 21.949131, -8.305901 ], [ 21.746456, -7.920085 ], [ 21.728111, -7.290872 ], [ 20.514748, -7.299606 ], [ 20.601823, -6.939318 ], [ 20.091622, -6.94309 ], [ 20.037723, -7.116361 ], [ 19.417502, -7.155429 ], [ 19.166613, -7.738184 ], [ 19.016752, -7.988246 ], [ 18.464176, -7.847014 ], [ 18.134222, -7.987678 ], [ 17.47297, -8.068551 ], [ 17.089996, -7.545689 ], [ 16.860191, -7.222298 ], [ 16.57318, -6.622645 ], [ 16.326528, -5.87747 ], [ 13.375597, -5.864241 ], [ 13.024869, -5.984389 ], [ 12.735171, -5.965682 ], [ 12.322432, -6.100092 ], [ 12.182337, -5.789931 ], [ 12.436688, -5.684304 ], [ 12.468004, -5.248362 ], [ 12.631612, -4.991271 ], [ 12.995517, -4.781103 ], [ 13.25824, -4.882957 ], [ 13.600235, -4.500138 ], [ 14.144956, -4.510009 ], [ 14.209035, -4.793092 ], [ 14.582604, -4.970239 ], [ 15.170992, -4.343507 ], [ 15.75354, -3.855165 ], [ 16.00629, -3.535133 ], [ 15.972803, -2.712392 ], [ 16.407092, -1.740927 ], [ 16.865307, -1.225816 ], [ 17.523716, -0.74383 ], [ 17.638645, -0.424832 ], [ 17.663553, -0.058084 ], [ 17.82654, 0.288923 ], [ 17.774192, 0.855659 ], [ 17.898835, 1.741832 ], [ 18.094276, 2.365722 ], [ 18.393792, 2.900443 ], [ 18.453065, 3.504386 ], [ 18.542982, 4.201785 ], [ 18.932312, 4.709506 ], [ 19.467784, 5.031528 ], [ 20.290679, 4.691678 ], [ 20.927591, 4.322786 ], [ 21.659123, 4.224342 ], [ 22.405124, 4.02916 ], [ 22.704124, 4.633051 ], [ 22.84148, 4.710126 ], [ 23.297214, 4.609693 ], [ 24.410531, 5.108784 ], [ 24.805029, 4.897247 ], [ 25.128833, 4.927245 ], [ 25.278798, 5.170408 ], [ 25.650455, 5.256088 ], [ 26.402761, 5.150875 ], [ 27.044065, 5.127853 ], [ 27.374226, 5.233944 ], [ 27.979977, 4.408413 ], [ 28.428994, 4.287155 ], [ 28.696678, 4.455077 ], [ 29.159078, 4.389267 ], [ 29.715995, 4.600805 ], [ 29.9535, 4.173699 ], [ 30.83386, 3.509166 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "COG", "name": "Republic of the Congo" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 12.995517, -4.781103 ], [ 12.62076, -4.438023 ], [ 12.318608, -4.60623 ], [ 11.914963, -5.037987 ], [ 11.093773, -3.978827 ], [ 11.855122, -3.426871 ], [ 11.478039, -2.765619 ], [ 11.820964, -2.514161 ], [ 12.495703, -2.391688 ], [ 12.575284, -1.948511 ], [ 13.109619, -2.42874 ], [ 13.992407, -2.470805 ], [ 14.29921, -1.998276 ], [ 14.425456, -1.333407 ], [ 14.316418, -0.552627 ], [ 13.843321, 0.038758 ], [ 14.276266, 1.19693 ], [ 14.026669, 1.395677 ], [ 13.282631, 1.314184 ], [ 13.003114, 1.830896 ], [ 13.075822, 2.267097 ], [ 14.337813, 2.227875 ], [ 15.146342, 1.964015 ], [ 15.940919, 1.727673 ], [ 16.012852, 2.26764 ], [ 16.537058, 3.198255 ], [ 17.133042, 3.728197 ], [ 17.8099, 3.560196 ], [ 18.453065, 3.504386 ], [ 18.393792, 2.900443 ], [ 18.094276, 2.365722 ], [ 17.898835, 1.741832 ], [ 17.774192, 0.855659 ], [ 17.82654, 0.288923 ], [ 17.663553, -0.058084 ], [ 17.638645, -0.424832 ], [ 17.523716, -0.74383 ], [ 16.865307, -1.225816 ], [ 16.407092, -1.740927 ], [ 15.972803, -2.712392 ], [ 16.00629, -3.535133 ], [ 15.75354, -3.855165 ], [ 15.170992, -4.343507 ], [ 14.582604, -4.970239 ], [ 14.209035, -4.793092 ], [ 14.144956, -4.510009 ], [ 13.600235, -4.500138 ], [ 13.25824, -4.882957 ], [ 12.995517, -4.781103 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "COL", "name": "Colombia" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -75.373223, -0.152032 ], [ -75.801466, 0.084801 ], [ -76.292314, 0.416047 ], [ -76.57638, 0.256936 ], [ -77.424984, 0.395687 ], [ -77.668613, 0.825893 ], [ -77.855061, 0.809925 ], [ -78.855259, 1.380924 ], [ -78.990935, 1.69137 ], [ -78.617831, 1.766404 ], [ -78.662118, 2.267355 ], [ -78.42761, 2.629556 ], [ -77.931543, 2.696606 ], [ -77.510431, 3.325017 ], [ -77.12769, 3.849636 ], [ -77.496272, 4.087606 ], [ -77.307601, 4.667984 ], [ -77.533221, 5.582812 ], [ -77.318815, 5.845354 ], [ -77.476661, 6.691116 ], [ -77.881571, 7.223771 ], [ -77.753414, 7.70984 ], [ -77.431108, 7.638061 ], [ -77.242566, 7.935278 ], [ -77.474723, 8.524286 ], [ -77.353361, 8.670505 ], [ -76.836674, 8.638749 ], [ -76.086384, 9.336821 ], [ -75.6746, 9.443248 ], [ -75.664704, 9.774003 ], [ -75.480426, 10.61899 ], [ -74.906895, 11.083045 ], [ -74.276753, 11.102036 ], [ -74.197223, 11.310473 ], [ -73.414764, 11.227015 ], [ -72.627835, 11.731972 ], [ -72.238195, 11.95555 ], [ -71.75409, 12.437303 ], [ -71.399822, 12.376041 ], [ -71.137461, 12.112982 ], [ -71.331584, 11.776284 ], [ -71.973922, 11.608672 ], [ -72.227575, 11.108702 ], [ -72.614658, 10.821975 ], [ -72.905286, 10.450344 ], [ -73.027604, 9.73677 ], [ -73.304952, 9.152 ], [ -72.78873, 9.085027 ], [ -72.660495, 8.625288 ], [ -72.439862, 8.405275 ], [ -72.360901, 8.002638 ], [ -72.479679, 7.632506 ], [ -72.444487, 7.423785 ], [ -72.198352, 7.340431 ], [ -71.960176, 6.991615 ], [ -70.674234, 7.087785 ], [ -70.093313, 6.960376 ], [ -69.38948, 6.099861 ], [ -68.985319, 6.206805 ], [ -68.265052, 6.153268 ], [ -67.695087, 6.267318 ], [ -67.34144, 6.095468 ], [ -67.521532, 5.55687 ], [ -67.744697, 5.221129 ], [ -67.823012, 4.503937 ], [ -67.621836, 3.839482 ], [ -67.337564, 3.542342 ], [ -67.303173, 3.318454 ], [ -67.809938, 2.820655 ], [ -67.447092, 2.600281 ], [ -67.181294, 2.250638 ], [ -66.876326, 1.253361 ], [ -67.065048, 1.130112 ], [ -67.259998, 1.719999 ], [ -67.53781, 2.037163 ], [ -67.868565, 1.692455 ], [ -69.816973, 1.714805 ], [ -69.804597, 1.089081 ], [ -69.218638, 0.985677 ], [ -69.252434, 0.602651 ], [ -69.452396, 0.706159 ], [ -70.015566, 0.541414 ], [ -70.020656, -0.185156 ], [ -69.577065, -0.549992 ], [ -69.420486, -1.122619 ], [ -69.444102, -1.556287 ], [ -69.893635, -4.298187 ], [ -70.394044, -3.766591 ], [ -70.692682, -3.742872 ], [ -70.047709, -2.725156 ], [ -70.813476, -2.256865 ], [ -71.413646, -2.342802 ], [ -71.774761, -2.16979 ], [ -72.325787, -2.434218 ], [ -73.070392, -2.308954 ], [ -73.659504, -1.260491 ], [ -74.122395, -1.002833 ], [ -74.441601, -0.53082 ], [ -75.106625, -0.057205 ], [ -75.373223, -0.152032 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "CRI", "name": "Costa Rica" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -82.965783, 8.225028 ], [ -83.508437, 8.446927 ], [ -83.711474, 8.656836 ], [ -83.596313, 8.830443 ], [ -83.632642, 9.051386 ], [ -83.909886, 9.290803 ], [ -84.303402, 9.487354 ], [ -84.647644, 9.615537 ], [ -84.713351, 9.908052 ], [ -84.97566, 10.086723 ], [ -84.911375, 9.795992 ], [ -85.110923, 9.55704 ], [ -85.339488, 9.834542 ], [ -85.660787, 9.933347 ], [ -85.797445, 10.134886 ], [ -85.791709, 10.439337 ], [ -85.659314, 10.754331 ], [ -85.941725, 10.895278 ], [ -85.71254, 11.088445 ], [ -85.561852, 11.217119 ], [ -84.903003, 10.952303 ], [ -84.673069, 11.082657 ], [ -84.355931, 10.999226 ], [ -84.190179, 10.79345 ], [ -83.895054, 10.726839 ], [ -83.655612, 10.938764 ], [ -83.40232, 10.395438 ], [ -83.015677, 9.992982 ], [ -82.546196, 9.566135 ], [ -82.932891, 9.476812 ], [ -82.927155, 9.07433 ], [ -82.719183, 8.925709 ], [ -82.868657, 8.807266 ], [ -82.829771, 8.626295 ], [ -82.913176, 8.423517 ], [ -82.965783, 8.225028 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "CUB", "name": "Cuba" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -82.268151, 23.188611 ], [ -81.404457, 23.117271 ], [ -80.618769, 23.10598 ], [ -79.679524, 22.765303 ], [ -79.281486, 22.399202 ], [ -78.347434, 22.512166 ], [ -77.993296, 22.277194 ], [ -77.146422, 21.657851 ], [ -76.523825, 21.20682 ], [ -76.19462, 21.220565 ], [ -75.598222, 21.016624 ], [ -75.67106, 20.735091 ], [ -74.933896, 20.693905 ], [ -74.178025, 20.284628 ], [ -74.296648, 20.050379 ], [ -74.961595, 19.923435 ], [ -75.63468, 19.873774 ], [ -76.323656, 19.952891 ], [ -77.755481, 19.855481 ], [ -77.085108, 20.413354 ], [ -77.492655, 20.673105 ], [ -78.137292, 20.739949 ], [ -78.482827, 21.028613 ], [ -78.719867, 21.598114 ], [ -79.285, 21.559175 ], [ -80.217475, 21.827324 ], [ -80.517535, 22.037079 ], [ -81.820943, 22.192057 ], [ -82.169992, 22.387109 ], [ -81.795002, 22.636965 ], [ -82.775898, 22.68815 ], [ -83.494459, 22.168518 ], [ -83.9088, 22.154565 ], [ -84.052151, 21.910575 ], [ -84.54703, 21.801228 ], [ -84.974911, 21.896028 ], [ -84.447062, 22.20495 ], [ -84.230357, 22.565755 ], [ -83.77824, 22.788118 ], [ -83.267548, 22.983042 ], [ -82.510436, 23.078747 ], [ -82.268151, 23.188611 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "XXX", "name": "Northern Cyprus" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 32.73178, 35.140026 ], [ 32.802474, 35.145504 ], [ 32.946961, 35.386703 ], [ 33.667227, 35.373216 ], [ 34.576474, 35.671596 ], [ 33.900804, 35.245756 ], [ 33.973617, 35.058506 ], [ 33.86644, 35.093595 ], [ 33.675392, 35.017863 ], [ 33.525685, 35.038688 ], [ 33.475817, 35.000345 ], [ 33.455922, 35.101424 ], [ 33.383833, 35.162712 ], [ 33.190977, 35.173125 ], [ 32.919572, 35.087833 ], [ 32.73178, 35.140026 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "CYP", "name": "Cyprus" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 33.973617, 35.058506 ], [ 34.004881, 34.978098 ], [ 32.979827, 34.571869 ], [ 32.490296, 34.701655 ], [ 32.256667, 35.103232 ], [ 32.73178, 35.140026 ], [ 32.919572, 35.087833 ], [ 33.190977, 35.173125 ], [ 33.383833, 35.162712 ], [ 33.455922, 35.101424 ], [ 33.475817, 35.000345 ], [ 33.525685, 35.038688 ], [ 33.675392, 35.017863 ], [ 33.86644, 35.093595 ], [ 33.973617, 35.058506 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "CZE", "name": "Czech Republic" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 16.960288, 48.596982 ], [ 16.499283, 48.785808 ], [ 16.029647, 48.733899 ], [ 15.253416, 49.039074 ], [ 14.901447, 48.964402 ], [ 14.338898, 48.555305 ], [ 13.595946, 48.877172 ], [ 13.031329, 49.307068 ], [ 12.521024, 49.547415 ], [ 12.415191, 49.969121 ], [ 12.240111, 50.266338 ], [ 12.966837, 50.484076 ], [ 13.338132, 50.733234 ], [ 14.056228, 50.926918 ], [ 14.307013, 51.117268 ], [ 14.570718, 51.002339 ], [ 15.016996, 51.106674 ], [ 15.490972, 50.78473 ], [ 16.238627, 50.697733 ], [ 16.176253, 50.422607 ], [ 16.719476, 50.215747 ], [ 16.868769, 50.473974 ], [ 17.554567, 50.362146 ], [ 17.649445, 50.049038 ], [ 18.392914, 49.988629 ], [ 18.853144, 49.49623 ], [ 18.554971, 49.495015 ], [ 18.399994, 49.315001 ], [ 18.170498, 49.271515 ], [ 18.104973, 49.043983 ], [ 17.913512, 48.996493 ], [ 17.886485, 48.903475 ], [ 17.545007, 48.800019 ], [ 17.101985, 48.816969 ], [ 16.960288, 48.596982 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "DEU", "name": "Germany" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 9.921906, 54.983104 ], [ 9.93958, 54.596642 ], [ 10.950112, 54.363607 ], [ 10.939467, 54.008693 ], [ 11.956252, 54.196486 ], [ 12.51844, 54.470371 ], [ 13.647467, 54.075511 ], [ 14.119686, 53.757029 ], [ 14.353315, 53.248171 ], [ 14.074521, 52.981263 ], [ 14.4376, 52.62485 ], [ 14.685026, 52.089947 ], [ 14.607098, 51.745188 ], [ 15.016996, 51.106674 ], [ 14.570718, 51.002339 ], [ 14.307013, 51.117268 ], [ 14.056228, 50.926918 ], [ 13.338132, 50.733234 ], [ 12.966837, 50.484076 ], [ 12.240111, 50.266338 ], [ 12.415191, 49.969121 ], [ 12.521024, 49.547415 ], [ 13.031329, 49.307068 ], [ 13.595946, 48.877172 ], [ 13.243357, 48.416115 ], [ 12.884103, 48.289146 ], [ 13.025851, 47.637584 ], [ 12.932627, 47.467646 ], [ 12.62076, 47.672388 ], [ 12.141357, 47.703083 ], [ 11.426414, 47.523766 ], [ 10.544504, 47.566399 ], [ 10.402084, 47.302488 ], [ 9.896068, 47.580197 ], [ 9.594226, 47.525058 ], [ 8.522612, 47.830828 ], [ 8.317301, 47.61358 ], [ 7.466759, 47.620582 ], [ 7.593676, 48.333019 ], [ 8.099279, 49.017784 ], [ 6.65823, 49.201958 ], [ 6.18632, 49.463803 ], [ 6.242751, 49.902226 ], [ 6.043073, 50.128052 ], [ 6.156658, 50.803721 ], [ 5.988658, 51.851616 ], [ 6.589397, 51.852029 ], [ 6.84287, 52.22844 ], [ 7.092053, 53.144043 ], [ 6.90514, 53.482162 ], [ 7.100425, 53.693932 ], [ 7.936239, 53.748296 ], [ 8.121706, 53.527792 ], [ 8.800734, 54.020786 ], [ 8.572118, 54.395646 ], [ 8.526229, 54.962744 ], [ 9.282049, 54.830865 ], [ 9.921906, 54.983104 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "DJI", "name": "Djibouti" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 43.081226, 12.699639 ], [ 43.317852, 12.390148 ], [ 43.286381, 11.974928 ], [ 42.715874, 11.735641 ], [ 43.145305, 11.46204 ], [ 42.776852, 10.926879 ], [ 42.55493, 11.10511 ], [ 42.31414, 11.0342 ], [ 41.75557, 11.05091 ], [ 41.73959, 11.35511 ], [ 41.66176, 11.6312 ], [ 42.0, 12.1 ], [ 42.35156, 12.54223 ], [ 42.779642, 12.455416 ], [ 43.081226, 12.699639 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "DNK", "name": "Denmark" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 12.690006, 55.609991 ], [ 12.089991, 54.800015 ], [ 11.043543, 55.364864 ], [ 10.903914, 55.779955 ], [ 12.370904, 56.111407 ], [ 12.690006, 55.609991 ] ] ], [ [ [ 10.912182, 56.458621 ], [ 10.667804, 56.081383 ], [ 10.369993, 56.190007 ], [ 9.649985, 55.469999 ], [ 9.921906, 54.983104 ], [ 9.282049, 54.830865 ], [ 8.526229, 54.962744 ], [ 8.120311, 55.517723 ], [ 8.089977, 56.540012 ], [ 8.256582, 56.809969 ], [ 8.543438, 57.110003 ], [ 9.424469, 57.172066 ], [ 9.775559, 57.447941 ], [ 10.580006, 57.730017 ], [ 10.546106, 57.215733 ], [ 10.25, 56.890016 ], [ 10.369993, 56.609982 ], [ 10.912182, 56.458621 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "DOM", "name": "Dominican Republic" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -71.712361, 19.714456 ], [ -71.587304, 19.884911 ], [ -70.806706, 19.880286 ], [ -70.214365, 19.622885 ], [ -69.950815, 19.648 ], [ -69.76925, 19.293267 ], [ -69.222126, 19.313214 ], [ -69.254346, 19.015196 ], [ -68.809412, 18.979074 ], [ -68.317943, 18.612198 ], [ -68.689316, 18.205142 ], [ -69.164946, 18.422648 ], [ -69.623988, 18.380713 ], [ -69.952934, 18.428307 ], [ -70.133233, 18.245915 ], [ -70.517137, 18.184291 ], [ -70.669298, 18.426886 ], [ -70.99995, 18.283329 ], [ -71.40021, 17.598564 ], [ -71.657662, 17.757573 ], [ -71.708305, 18.044997 ], [ -71.687738, 18.31666 ], [ -71.945112, 18.6169 ], [ -71.701303, 18.785417 ], [ -71.624873, 19.169838 ], [ -71.712361, 19.714456 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "DZA", "name": "Algeria" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 11.999506, 23.471668 ], [ 8.572893, 21.565661 ], [ 5.677566, 19.601207 ], [ 4.267419, 19.155265 ], [ 3.158133, 19.057364 ], [ 3.146661, 19.693579 ], [ 2.683588, 19.85623 ], [ 2.060991, 20.142233 ], [ 1.823228, 20.610809 ], [ -1.550055, 22.792666 ], [ -4.923337, 24.974574 ], [ -8.6844, 27.395744 ], [ -8.665124, 27.589479 ], [ -8.66559, 27.656426 ], [ -8.674116, 28.841289 ], [ -7.059228, 29.579228 ], [ -6.060632, 29.7317 ], [ -5.242129, 30.000443 ], [ -4.859646, 30.501188 ], [ -3.690441, 30.896952 ], [ -3.647498, 31.637294 ], [ -3.06898, 31.724498 ], [ -2.616605, 32.094346 ], [ -1.307899, 32.262889 ], [ -1.124551, 32.651522 ], [ -1.388049, 32.864015 ], [ -1.733455, 33.919713 ], [ -1.792986, 34.527919 ], [ -2.169914, 35.168396 ], [ -1.208603, 35.714849 ], [ -0.127454, 35.888662 ], [ 0.503877, 36.301273 ], [ 1.466919, 36.605647 ], [ 3.161699, 36.783905 ], [ 4.815758, 36.865037 ], [ 5.32012, 36.716519 ], [ 6.26182, 37.110655 ], [ 7.330385, 37.118381 ], [ 7.737078, 36.885708 ], [ 8.420964, 36.946427 ], [ 8.217824, 36.433177 ], [ 8.376368, 35.479876 ], [ 8.140981, 34.655146 ], [ 7.524482, 34.097376 ], [ 7.612642, 33.344115 ], [ 8.430473, 32.748337 ], [ 8.439103, 32.506285 ], [ 9.055603, 32.102692 ], [ 9.48214, 30.307556 ], [ 9.805634, 29.424638 ], [ 9.859998, 28.95999 ], [ 9.683885, 28.144174 ], [ 9.756128, 27.688259 ], [ 9.629056, 27.140953 ], [ 9.716286, 26.512206 ], [ 9.319411, 26.094325 ], [ 9.910693, 25.365455 ], [ 9.948261, 24.936954 ], [ 10.303847, 24.379313 ], [ 10.771364, 24.562532 ], [ 11.560669, 24.097909 ], [ 11.999506, 23.471668 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "ECU", "name": "Ecuador" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -80.302561, -3.404856 ], [ -79.770293, -2.657512 ], [ -79.986559, -2.220794 ], [ -80.368784, -2.685159 ], [ -80.967765, -2.246943 ], [ -80.764806, -1.965048 ], [ -80.933659, -1.057455 ], [ -80.58337, -0.906663 ], [ -80.399325, -0.283703 ], [ -80.020898, 0.36034 ], [ -80.09061, 0.768429 ], [ -79.542762, 0.982938 ], [ -78.855259, 1.380924 ], [ -77.855061, 0.809925 ], [ -77.668613, 0.825893 ], [ -77.424984, 0.395687 ], [ -76.57638, 0.256936 ], [ -76.292314, 0.416047 ], [ -75.801466, 0.084801 ], [ -75.373223, -0.152032 ], [ -75.233723, -0.911417 ], [ -75.544996, -1.56161 ], [ -76.635394, -2.608678 ], [ -77.837905, -3.003021 ], [ -78.450684, -3.873097 ], [ -78.639897, -4.547784 ], [ -79.205289, -4.959129 ], [ -79.624979, -4.454198 ], [ -80.028908, -4.346091 ], [ -80.442242, -4.425724 ], [ -80.469295, -4.059287 ], [ -80.184015, -3.821162 ], [ -80.302561, -3.404856 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "EGY", "name": "Egypt" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 34.9226, 29.50133 ], [ 34.64174, 29.09942 ], [ 34.42655, 28.34399 ], [ 34.15451, 27.8233 ], [ 33.92136, 27.6487 ], [ 33.58811, 27.97136 ], [ 33.13676, 28.41765 ], [ 32.42323, 29.85108 ], [ 32.32046, 29.76043 ], [ 32.73482, 28.70523 ], [ 33.34876, 27.69989 ], [ 34.10455, 26.14227 ], [ 34.47387, 25.59856 ], [ 34.79507, 25.03375 ], [ 35.69241, 23.92671 ], [ 35.49372, 23.75237 ], [ 35.52598, 23.10244 ], [ 36.69069, 22.20485 ], [ 36.86623, 22.0 ], [ 32.9, 22.0 ], [ 29.02, 22.0 ], [ 25.0, 22.0 ], [ 25.0, 25.6825 ], [ 25.0, 29.238655 ], [ 24.70007, 30.04419 ], [ 24.95762, 30.6616 ], [ 24.80287, 31.08929 ], [ 25.16482, 31.56915 ], [ 26.49533, 31.58568 ], [ 27.45762, 31.32126 ], [ 28.45048, 31.02577 ], [ 28.91353, 30.87005 ], [ 29.68342, 31.18686 ], [ 30.09503, 31.4734 ], [ 30.97693, 31.55586 ], [ 31.68796, 31.4296 ], [ 31.96041, 30.9336 ], [ 32.19247, 31.26034 ], [ 32.99392, 31.02407 ], [ 33.7734, 30.96746 ], [ 34.26544, 31.21936 ], [ 34.9226, 29.50133 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "ERI", "name": "Eritrea" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 42.35156, 12.54223 ], [ 42.00975, 12.86582 ], [ 41.59856, 13.45209 ], [ 41.155194, 13.77332 ], [ 40.8966, 14.11864 ], [ 40.026219, 14.519579 ], [ 39.34061, 14.53155 ], [ 39.0994, 14.74064 ], [ 38.51295, 14.50547 ], [ 37.90607, 14.95943 ], [ 37.59377, 14.2131 ], [ 36.42951, 14.42211 ], [ 36.323189, 14.822481 ], [ 36.75386, 16.291874 ], [ 36.85253, 16.95655 ], [ 37.16747, 17.26314 ], [ 37.904, 17.42754 ], [ 38.41009, 17.998307 ], [ 38.990623, 16.840626 ], [ 39.26611, 15.922723 ], [ 39.814294, 15.435647 ], [ 41.179275, 14.49108 ], [ 41.734952, 13.921037 ], [ 42.276831, 13.343992 ], [ 42.589576, 13.000421 ], [ 43.081226, 12.699639 ], [ 42.779642, 12.455416 ], [ 42.35156, 12.54223 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "ESP", "name": "Spain" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -9.034818, 41.880571 ], [ -8.984433, 42.592775 ], [ -9.392884, 43.026625 ], [ -7.97819, 43.748338 ], [ -6.754492, 43.567909 ], [ -5.411886, 43.57424 ], [ -4.347843, 43.403449 ], [ -3.517532, 43.455901 ], [ -1.901351, 43.422802 ], [ -1.502771, 43.034014 ], [ 0.338047, 42.579546 ], [ 0.701591, 42.795734 ], [ 1.826793, 42.343385 ], [ 2.985999, 42.473015 ], [ 3.039484, 41.89212 ], [ 2.091842, 41.226089 ], [ 0.810525, 41.014732 ], [ 0.721331, 40.678318 ], [ 0.106692, 40.123934 ], [ -0.278711, 39.309978 ], [ 0.111291, 38.738514 ], [ -0.467124, 38.292366 ], [ -0.683389, 37.642354 ], [ -1.438382, 37.443064 ], [ -2.146453, 36.674144 ], [ -3.415781, 36.6589 ], [ -4.368901, 36.677839 ], [ -4.995219, 36.324708 ], [ -5.37716, 35.94685 ], [ -5.866432, 36.029817 ], [ -6.236694, 36.367677 ], [ -6.520191, 36.942913 ], [ -7.453726, 37.097788 ], [ -7.537105, 37.428904 ], [ -7.166508, 37.803894 ], [ -7.029281, 38.075764 ], [ -7.374092, 38.373059 ], [ -7.098037, 39.030073 ], [ -7.498632, 39.629571 ], [ -7.066592, 39.711892 ], [ -7.026413, 40.184524 ], [ -6.86402, 40.330872 ], [ -6.851127, 41.111083 ], [ -6.389088, 41.381815 ], [ -6.668606, 41.883387 ], [ -7.251309, 41.918346 ], [ -7.422513, 41.792075 ], [ -8.013175, 41.790886 ], [ -8.263857, 42.280469 ], [ -8.671946, 42.134689 ], [ -9.034818, 41.880571 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "EST", "name": "Estonia" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 24.312863, 57.793424 ], [ 24.428928, 58.383413 ], [ 24.061198, 58.257375 ], [ 23.42656, 58.612753 ], [ 23.339795, 59.18724 ], [ 24.604214, 59.465854 ], [ 25.864189, 59.61109 ], [ 26.949136, 59.445803 ], [ 27.981114, 59.475388 ], [ 28.131699, 59.300825 ], [ 27.420166, 58.724581 ], [ 27.716686, 57.791899 ], [ 27.288185, 57.474528 ], [ 26.463532, 57.476389 ], [ 25.60281, 57.847529 ], [ 25.164594, 57.970157 ], [ 24.312863, 57.793424 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "ETH", "name": "Ethiopia" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 37.90607, 14.95943 ], [ 38.51295, 14.50547 ], [ 39.0994, 14.74064 ], [ 39.34061, 14.53155 ], [ 40.02625, 14.51959 ], [ 40.8966, 14.11864 ], [ 41.1552, 13.77333 ], [ 41.59856, 13.45209 ], [ 42.00975, 12.86582 ], [ 42.35156, 12.54223 ], [ 42.0, 12.1 ], [ 41.66176, 11.6312 ], [ 41.73959, 11.35511 ], [ 41.75557, 11.05091 ], [ 42.31414, 11.0342 ], [ 42.55493, 11.10511 ], [ 42.776852, 10.926879 ], [ 42.55876, 10.57258 ], [ 42.92812, 10.02194 ], [ 43.29699, 9.54048 ], [ 43.67875, 9.18358 ], [ 46.94834, 7.99688 ], [ 47.78942, 8.003 ], [ 44.9636, 5.00162 ], [ 43.66087, 4.95755 ], [ 42.76967, 4.25259 ], [ 42.12861, 4.23413 ], [ 41.855083, 3.918912 ], [ 41.1718, 3.91909 ], [ 40.76848, 4.25702 ], [ 39.85494, 3.83879 ], [ 39.559384, 3.42206 ], [ 38.89251, 3.50074 ], [ 38.67114, 3.61607 ], [ 38.43697, 3.58851 ], [ 38.120915, 3.598605 ], [ 36.855093, 4.447864 ], [ 36.159079, 4.447864 ], [ 35.817448, 4.776966 ], [ 35.817448, 5.338232 ], [ 35.298007, 5.506 ], [ 34.70702, 6.59422 ], [ 34.25032, 6.82607 ], [ 34.0751, 7.22595 ], [ 33.56829, 7.71334 ], [ 32.95418, 7.78497 ], [ 33.2948, 8.35458 ], [ 33.8255, 8.37916 ], [ 33.97498, 8.68456 ], [ 33.96162, 9.58358 ], [ 34.25745, 10.63009 ], [ 34.73115, 10.91017 ], [ 34.83163, 11.31896 ], [ 35.26049, 12.08286 ], [ 35.86363, 12.57828 ], [ 36.27022, 13.56333 ], [ 36.42951, 14.42211 ], [ 37.59377, 14.2131 ], [ 37.90607, 14.95943 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "FIN", "name": "Finland" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 28.59193, 69.064777 ], [ 28.445944, 68.364613 ], [ 29.977426, 67.698297 ], [ 29.054589, 66.944286 ], [ 30.21765, 65.80598 ], [ 29.54443, 64.948672 ], [ 30.444685, 64.204453 ], [ 30.035872, 63.552814 ], [ 31.516092, 62.867687 ], [ 31.139991, 62.357693 ], [ 30.211107, 61.780028 ], [ 28.069998, 60.503517 ], [ 26.255173, 60.423961 ], [ 24.496624, 60.057316 ], [ 22.869695, 59.846373 ], [ 22.290764, 60.391921 ], [ 21.322244, 60.72017 ], [ 21.544866, 61.705329 ], [ 21.059211, 62.607393 ], [ 21.536029, 63.189735 ], [ 22.442744, 63.81781 ], [ 24.730512, 64.902344 ], [ 25.398068, 65.111427 ], [ 25.294043, 65.534346 ], [ 23.903379, 66.006927 ], [ 23.56588, 66.396051 ], [ 23.539473, 67.936009 ], [ 21.978535, 68.616846 ], [ 20.645593, 69.106247 ], [ 21.244936, 69.370443 ], [ 22.356238, 68.841741 ], [ 23.66205, 68.891247 ], [ 24.735679, 68.649557 ], [ 25.689213, 69.092114 ], [ 26.179622, 69.825299 ], [ 27.732292, 70.164193 ], [ 29.015573, 69.766491 ], [ 28.59193, 69.064777 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "FJI", "name": "Fiji" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 178.3736, -17.33992 ], [ 178.71806, -17.62846 ], [ 178.55271, -18.15059 ], [ 177.93266, -18.28799 ], [ 177.38146, -18.16432 ], [ 177.28504, -17.72465 ], [ 177.67087, -17.38114 ], [ 178.12557, -17.50481 ], [ 178.3736, -17.33992 ] ] ], [ [ [ 179.364143, -16.801354 ], [ 178.725059, -17.012042 ], [ 178.596839, -16.63915 ], [ 179.096609, -16.433984 ], [ 179.413509, -16.379054 ], [ 180.0, -16.067133 ], [ 180.0, -16.555217 ], [ 179.364143, -16.801354 ] ] ], [ [ [ -179.917369, -16.501783 ], [ -180.0, -16.555217 ], [ -180.0, -16.067133 ], [ -179.79332, -16.020882 ], [ -179.917369, -16.501783 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "FLK", "name": "Falkland Islands" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -61.2, -51.85 ], [ -60.0, -51.25 ], [ -59.15, -51.5 ], [ -58.55, -51.1 ], [ -57.75, -51.55 ], [ -58.05, -51.9 ], [ -59.4, -52.2 ], [ -59.85, -51.85 ], [ -60.7, -52.3 ], [ -61.2, -51.85 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "FRA", "name": "France" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 9.560016, 42.152492 ], [ 9.229752, 41.380007 ], [ 8.775723, 41.583612 ], [ 8.544213, 42.256517 ], [ 8.746009, 42.628122 ], [ 9.390001, 43.009985 ], [ 9.560016, 42.152492 ] ] ], [ [ [ 3.588184, 50.378992 ], [ 4.286023, 49.907497 ], [ 4.799222, 49.985373 ], [ 5.674052, 49.529484 ], [ 5.897759, 49.442667 ], [ 6.18632, 49.463803 ], [ 6.65823, 49.201958 ], [ 8.099279, 49.017784 ], [ 7.593676, 48.333019 ], [ 7.466759, 47.620582 ], [ 7.192202, 47.449766 ], [ 6.736571, 47.541801 ], [ 6.768714, 47.287708 ], [ 6.037389, 46.725779 ], [ 6.022609, 46.27299 ], [ 6.5001, 46.429673 ], [ 6.843593, 45.991147 ], [ 6.802355, 45.70858 ], [ 7.096652, 45.333099 ], [ 6.749955, 45.028518 ], [ 7.007562, 44.254767 ], [ 7.549596, 44.127901 ], [ 7.435185, 43.693845 ], [ 6.529245, 43.128892 ], [ 4.556963, 43.399651 ], [ 3.100411, 43.075201 ], [ 2.985999, 42.473015 ], [ 1.826793, 42.343385 ], [ 0.701591, 42.795734 ], [ 0.338047, 42.579546 ], [ -1.502771, 43.034014 ], [ -1.901351, 43.422802 ], [ -1.384225, 44.02261 ], [ -1.193798, 46.014918 ], [ -2.225724, 47.064363 ], [ -2.963276, 47.570327 ], [ -4.491555, 47.954954 ], [ -4.59235, 48.68416 ], [ -3.295814, 48.901692 ], [ -1.616511, 48.644421 ], [ -1.933494, 49.776342 ], [ -0.989469, 49.347376 ], [ 1.338761, 50.127173 ], [ 1.639001, 50.946606 ], [ 2.513573, 51.148506 ], [ 2.658422, 50.796848 ], [ 3.123252, 50.780363 ], [ 3.588184, 50.378992 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "GAB", "name": "Gabon" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 11.093773, -3.978827 ], [ 10.066135, -2.969483 ], [ 9.405245, -2.144313 ], [ 8.797996, -1.111301 ], [ 8.830087, -0.779074 ], [ 9.04842, -0.459351 ], [ 9.291351, 0.268666 ], [ 9.492889, 1.01012 ], [ 9.830284, 1.067894 ], [ 11.285079, 1.057662 ], [ 11.276449, 2.261051 ], [ 11.751665, 2.326758 ], [ 12.35938, 2.192812 ], [ 12.951334, 2.321616 ], [ 13.075822, 2.267097 ], [ 13.003114, 1.830896 ], [ 13.282631, 1.314184 ], [ 14.026669, 1.395677 ], [ 14.276266, 1.19693 ], [ 13.843321, 0.038758 ], [ 14.316418, -0.552627 ], [ 14.425456, -1.333407 ], [ 14.29921, -1.998276 ], [ 13.992407, -2.470805 ], [ 13.109619, -2.42874 ], [ 12.575284, -1.948511 ], [ 12.495703, -2.391688 ], [ 11.820964, -2.514161 ], [ 11.478039, -2.765619 ], [ 11.855122, -3.426871 ], [ 11.093773, -3.978827 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "GBR", "name": "United Kingdom" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -5.661949, 54.554603 ], [ -6.197885, 53.867565 ], [ -6.95373, 54.073702 ], [ -7.572168, 54.059956 ], [ -7.366031, 54.595841 ], [ -7.572168, 55.131622 ], [ -6.733847, 55.17286 ], [ -5.661949, 54.554603 ] ] ], [ [ [ -3.005005, 58.635 ], [ -4.073828, 57.553025 ], [ -3.055002, 57.690019 ], [ -1.959281, 57.6848 ], [ -2.219988, 56.870017 ], [ -3.119003, 55.973793 ], [ -2.085009, 55.909998 ], [ -2.005676, 55.804903 ], [ -1.114991, 54.624986 ], [ -0.430485, 54.464376 ], [ 0.184981, 53.325014 ], [ 0.469977, 52.929999 ], [ 1.681531, 52.73952 ], [ 1.559988, 52.099998 ], [ 1.050562, 51.806761 ], [ 1.449865, 51.289428 ], [ 0.550334, 50.765739 ], [ -0.787517, 50.774989 ], [ -2.489998, 50.500019 ], [ -2.956274, 50.69688 ], [ -3.617448, 50.228356 ], [ -4.542508, 50.341837 ], [ -5.245023, 49.96 ], [ -5.776567, 50.159678 ], [ -4.30999, 51.210001 ], [ -3.414851, 51.426009 ], [ -3.422719, 51.426848 ], [ -4.984367, 51.593466 ], [ -5.267296, 51.9914 ], [ -4.222347, 52.301356 ], [ -4.770013, 52.840005 ], [ -4.579999, 53.495004 ], [ -3.093831, 53.404547 ], [ -3.09208, 53.404441 ], [ -2.945009, 53.985 ], [ -3.614701, 54.600937 ], [ -3.630005, 54.615013 ], [ -4.844169, 54.790971 ], [ -5.082527, 55.061601 ], [ -4.719112, 55.508473 ], [ -5.047981, 55.783986 ], [ -5.586398, 55.311146 ], [ -5.644999, 56.275015 ], [ -6.149981, 56.78501 ], [ -5.786825, 57.818848 ], [ -5.009999, 58.630013 ], [ -4.211495, 58.550845 ], [ -3.005005, 58.635 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "GEO", "name": "Georgia" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 41.554084, 41.535656 ], [ 41.703171, 41.962943 ], [ 41.45347, 42.645123 ], [ 40.875469, 43.013628 ], [ 40.321394, 43.128634 ], [ 39.955009, 43.434998 ], [ 40.076965, 43.553104 ], [ 40.922185, 43.382159 ], [ 42.394395, 43.220308 ], [ 43.756017, 42.740828 ], [ 43.9312, 42.554974 ], [ 44.537623, 42.711993 ], [ 45.470279, 42.502781 ], [ 45.77641, 42.092444 ], [ 46.404951, 41.860675 ], [ 46.145432, 41.722802 ], [ 46.637908, 41.181673 ], [ 46.501637, 41.064445 ], [ 45.962601, 41.123873 ], [ 45.217426, 41.411452 ], [ 44.97248, 41.248129 ], [ 43.582746, 41.092143 ], [ 42.619549, 41.583173 ], [ 41.554084, 41.535656 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "GHA", "name": "Ghana" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 1.060122, 5.928837 ], [ -0.507638, 5.343473 ], [ -1.063625, 5.000548 ], [ -1.964707, 4.710462 ], [ -2.856125, 4.994476 ], [ -2.810701, 5.389051 ], [ -3.24437, 6.250472 ], [ -2.983585, 7.379705 ], [ -2.56219, 8.219628 ], [ -2.827496, 9.642461 ], [ -2.963896, 10.395335 ], [ -2.940409, 10.96269 ], [ -1.203358, 11.009819 ], [ -0.761576, 10.93693 ], [ -0.438702, 11.098341 ], [ 0.023803, 11.018682 ], [ -0.049785, 10.706918 ], [ 0.36758, 10.191213 ], [ 0.365901, 9.465004 ], [ 0.461192, 8.677223 ], [ 0.712029, 8.312465 ], [ 0.490957, 7.411744 ], [ 0.570384, 6.914359 ], [ 0.836931, 6.279979 ], [ 1.060122, 5.928837 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "GIN", "name": "Guinea" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -8.439298, 7.686043 ], [ -8.722124, 7.711674 ], [ -8.926065, 7.309037 ], [ -9.208786, 7.313921 ], [ -9.403348, 7.526905 ], [ -9.33728, 7.928534 ], [ -9.755342, 8.541055 ], [ -10.016567, 8.428504 ], [ -10.230094, 8.406206 ], [ -10.505477, 8.348896 ], [ -10.494315, 8.715541 ], [ -10.65477, 8.977178 ], [ -10.622395, 9.26791 ], [ -10.839152, 9.688246 ], [ -11.117481, 10.045873 ], [ -11.917277, 10.046984 ], [ -12.150338, 9.858572 ], [ -12.425929, 9.835834 ], [ -12.596719, 9.620188 ], [ -12.711958, 9.342712 ], [ -13.24655, 8.903049 ], [ -13.685154, 9.494744 ], [ -14.074045, 9.886167 ], [ -14.330076, 10.01572 ], [ -14.579699, 10.214467 ], [ -14.693232, 10.656301 ], [ -14.839554, 10.876572 ], [ -15.130311, 11.040412 ], [ -14.685687, 11.527824 ], [ -14.382192, 11.509272 ], [ -14.121406, 11.677117 ], [ -13.9008, 11.678719 ], [ -13.743161, 11.811269 ], [ -13.828272, 12.142644 ], [ -13.718744, 12.247186 ], [ -13.700476, 12.586183 ], [ -13.217818, 12.575874 ], [ -12.499051, 12.33209 ], [ -12.278599, 12.35444 ], [ -12.203565, 12.465648 ], [ -11.658301, 12.386583 ], [ -11.513943, 12.442988 ], [ -11.456169, 12.076834 ], [ -11.297574, 12.077971 ], [ -11.036556, 12.211245 ], [ -10.87083, 12.177887 ], [ -10.593224, 11.923975 ], [ -10.165214, 11.844084 ], [ -9.890993, 12.060479 ], [ -9.567912, 12.194243 ], [ -9.327616, 12.334286 ], [ -9.127474, 12.30806 ], [ -8.905265, 12.088358 ], [ -8.786099, 11.812561 ], [ -8.376305, 11.393646 ], [ -8.581305, 11.136246 ], [ -8.620321, 10.810891 ], [ -8.407311, 10.909257 ], [ -8.282357, 10.792597 ], [ -8.335377, 10.494812 ], [ -8.029944, 10.206535 ], [ -8.229337, 10.12902 ], [ -8.309616, 9.789532 ], [ -8.079114, 9.376224 ], [ -7.8321, 8.575704 ], [ -8.203499, 8.455453 ], [ -8.299049, 8.316444 ], [ -8.221792, 8.123329 ], [ -8.280703, 7.68718 ], [ -8.439298, 7.686043 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "GMB", "name": "Gambia" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -16.841525, 13.151394 ], [ -16.713729, 13.594959 ], [ -15.624596, 13.623587 ], [ -15.39877, 13.860369 ], [ -15.081735, 13.876492 ], [ -14.687031, 13.630357 ], [ -14.376714, 13.62568 ], [ -14.046992, 13.794068 ], [ -13.844963, 13.505042 ], [ -14.277702, 13.280585 ], [ -14.712197, 13.298207 ], [ -15.141163, 13.509512 ], [ -15.511813, 13.27857 ], [ -15.691001, 13.270353 ], [ -15.931296, 13.130284 ], [ -16.841525, 13.151394 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "GNB", "name": "Guinea Bissau" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -15.130311, 11.040412 ], [ -15.66418, 11.458474 ], [ -16.085214, 11.524594 ], [ -16.314787, 11.806515 ], [ -16.308947, 11.958702 ], [ -16.613838, 12.170911 ], [ -16.677452, 12.384852 ], [ -16.147717, 12.547762 ], [ -15.816574, 12.515567 ], [ -15.548477, 12.62817 ], [ -13.700476, 12.586183 ], [ -13.718744, 12.247186 ], [ -13.828272, 12.142644 ], [ -13.743161, 11.811269 ], [ -13.9008, 11.678719 ], [ -14.121406, 11.677117 ], [ -14.382192, 11.509272 ], [ -14.685687, 11.527824 ], [ -15.130311, 11.040412 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "GNQ", "name": "Equatorial Guinea" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 9.492889, 1.01012 ], [ 9.305613, 1.160911 ], [ 9.649158, 2.283866 ], [ 11.276449, 2.261051 ], [ 11.285079, 1.057662 ], [ 9.830284, 1.067894 ], [ 9.492889, 1.01012 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "GRC", "name": "Greece" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 23.69998, 35.705004 ], [ 24.246665, 35.368022 ], [ 25.025015, 35.424996 ], [ 25.769208, 35.354018 ], [ 25.745023, 35.179998 ], [ 26.290003, 35.29999 ], [ 26.164998, 35.004995 ], [ 24.724982, 34.919988 ], [ 24.735007, 35.084991 ], [ 23.514978, 35.279992 ], [ 23.69998, 35.705004 ] ] ], [ [ [ 26.604196, 41.562115 ], [ 26.294602, 40.936261 ], [ 26.056942, 40.824123 ], [ 25.447677, 40.852545 ], [ 24.925848, 40.947062 ], [ 23.714811, 40.687129 ], [ 24.407999, 40.124993 ], [ 23.899968, 39.962006 ], [ 23.342999, 39.960998 ], [ 22.813988, 40.476005 ], [ 22.626299, 40.256561 ], [ 22.849748, 39.659311 ], [ 23.350027, 39.190011 ], [ 22.973099, 38.970903 ], [ 23.530016, 38.510001 ], [ 24.025025, 38.219993 ], [ 24.040011, 37.655015 ], [ 23.115003, 37.920011 ], [ 23.409972, 37.409991 ], [ 22.774972, 37.30501 ], [ 23.154225, 36.422506 ], [ 22.490028, 36.41 ], [ 21.670026, 36.844986 ], [ 21.295011, 37.644989 ], [ 21.120034, 38.310323 ], [ 20.730032, 38.769985 ], [ 20.217712, 39.340235 ], [ 20.150016, 39.624998 ], [ 20.615, 40.110007 ], [ 20.674997, 40.435 ], [ 20.99999, 40.580004 ], [ 21.02004, 40.842727 ], [ 21.674161, 40.931275 ], [ 22.055378, 41.149866 ], [ 22.597308, 41.130487 ], [ 22.76177, 41.3048 ], [ 22.952377, 41.337994 ], [ 23.692074, 41.309081 ], [ 24.492645, 41.583896 ], [ 25.197201, 41.234486 ], [ 26.106138, 41.328899 ], [ 26.117042, 41.826905 ], [ 26.604196, 41.562115 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "GRL", "name": "Greenland" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -46.76379, 82.62796 ], [ -43.40644, 83.22516 ], [ -39.89753, 83.18018 ], [ -38.62214, 83.54905 ], [ -35.08787, 83.64513 ], [ -27.10046, 83.51966 ], [ -20.84539, 82.72669 ], [ -22.69182, 82.34165 ], [ -26.51753, 82.29765 ], [ -31.9, 82.2 ], [ -31.39646, 82.02154 ], [ -27.85666, 82.13178 ], [ -24.84448, 81.78697 ], [ -22.90328, 82.09317 ], [ -22.07175, 81.73449 ], [ -23.16961, 81.15271 ], [ -20.62363, 81.52462 ], [ -15.76818, 81.91245 ], [ -12.77018, 81.71885 ], [ -12.20855, 81.29154 ], [ -16.28533, 80.58004 ], [ -16.85, 80.35 ], [ -20.04624, 80.17708 ], [ -17.73035, 80.12912 ], [ -18.9, 79.4 ], [ -19.70499, 78.75128 ], [ -19.67353, 77.63859 ], [ -18.47285, 76.98565 ], [ -20.03503, 76.94434 ], [ -21.67944, 76.62795 ], [ -19.83407, 76.09808 ], [ -19.59896, 75.24838 ], [ -20.66818, 75.15585 ], [ -19.37281, 74.29561 ], [ -21.59422, 74.22382 ], [ -20.43454, 73.81713 ], [ -20.76234, 73.46436 ], [ -22.17221, 73.30955 ], [ -23.56593, 73.30663 ], [ -22.31311, 72.62928 ], [ -22.29954, 72.18409 ], [ -24.27834, 72.59788 ], [ -24.79296, 72.3302 ], [ -23.44296, 72.08016 ], [ -22.13281, 71.46898 ], [ -21.75356, 70.66369 ], [ -23.53603, 70.471 ], [ -24.30702, 70.85649 ], [ -25.54341, 71.43094 ], [ -25.20135, 70.75226 ], [ -26.36276, 70.22646 ], [ -23.72742, 70.18401 ], [ -22.34902, 70.12946 ], [ -25.02927, 69.2588 ], [ -27.74737, 68.47046 ], [ -30.67371, 68.12503 ], [ -31.77665, 68.12078 ], [ -32.81105, 67.73547 ], [ -34.20196, 66.67974 ], [ -36.35284, 65.9789 ], [ -37.04378, 65.93768 ], [ -38.37505, 65.69213 ], [ -39.81222, 65.45848 ], [ -40.66899, 64.83997 ], [ -40.68281, 64.13902 ], [ -41.1887, 63.48246 ], [ -42.81938, 62.68233 ], [ -42.41666, 61.90093 ], [ -42.86619, 61.07404 ], [ -43.3784, 60.09772 ], [ -44.7875, 60.03676 ], [ -46.26364, 60.85328 ], [ -48.26294, 60.85843 ], [ -49.23308, 61.40681 ], [ -49.90039, 62.38336 ], [ -51.63325, 63.62691 ], [ -52.14014, 64.27842 ], [ -52.27659, 65.1767 ], [ -53.66166, 66.09957 ], [ -53.30161, 66.8365 ], [ -53.96911, 67.18899 ], [ -52.9804, 68.35759 ], [ -51.47536, 68.72958 ], [ -51.08041, 69.14781 ], [ -50.87122, 69.9291 ], [ -52.013585, 69.574925 ], [ -52.55792, 69.42616 ], [ -53.45629, 69.283625 ], [ -54.68336, 69.61003 ], [ -54.75001, 70.28932 ], [ -54.35884, 70.821315 ], [ -53.431315, 70.835755 ], [ -51.39014, 70.56978 ], [ -53.10937, 71.20485 ], [ -54.00422, 71.54719 ], [ -55.0, 71.406537 ], [ -55.83468, 71.65444 ], [ -54.71819, 72.58625 ], [ -55.32634, 72.95861 ], [ -56.12003, 73.64977 ], [ -57.32363, 74.71026 ], [ -58.59679, 75.09861 ], [ -58.58516, 75.51727 ], [ -61.26861, 76.10238 ], [ -63.39165, 76.1752 ], [ -66.06427, 76.13486 ], [ -68.50438, 76.06141 ], [ -69.66485, 76.37975 ], [ -71.40257, 77.00857 ], [ -68.77671, 77.32312 ], [ -66.76397, 77.37595 ], [ -71.04293, 77.63595 ], [ -73.297, 78.04419 ], [ -73.15938, 78.43271 ], [ -69.37345, 78.91388 ], [ -65.7107, 79.39436 ], [ -65.3239, 79.75814 ], [ -68.02298, 80.11721 ], [ -67.15129, 80.51582 ], [ -63.68925, 81.21396 ], [ -62.23444, 81.3211 ], [ -62.65116, 81.77042 ], [ -60.28249, 82.03363 ], [ -57.20744, 82.19074 ], [ -54.13442, 82.19962 ], [ -53.04328, 81.88833 ], [ -50.39061, 82.43883 ], [ -48.00386, 82.06481 ], [ -46.59984, 81.985945 ], [ -44.523, 81.6607 ], [ -46.9007, 82.19979 ], [ -46.76379, 82.62796 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "GTM", "name": "Guatemala" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -90.095555, 13.735338 ], [ -90.608624, 13.909771 ], [ -91.23241, 13.927832 ], [ -91.689747, 14.126218 ], [ -92.22775, 14.538829 ], [ -92.20323, 14.830103 ], [ -92.087216, 15.064585 ], [ -92.229249, 15.251447 ], [ -91.74796, 16.066565 ], [ -90.464473, 16.069562 ], [ -90.438867, 16.41011 ], [ -90.600847, 16.470778 ], [ -90.711822, 16.687483 ], [ -91.08167, 16.918477 ], [ -91.453921, 17.252177 ], [ -91.002269, 17.254658 ], [ -91.00152, 17.817595 ], [ -90.067934, 17.819326 ], [ -89.14308, 17.808319 ], [ -89.150806, 17.015577 ], [ -89.229122, 15.886938 ], [ -88.930613, 15.887273 ], [ -88.604586, 15.70638 ], [ -88.518364, 15.855389 ], [ -88.225023, 15.727722 ], [ -88.68068, 15.346247 ], [ -89.154811, 15.066419 ], [ -89.22522, 14.874286 ], [ -89.145535, 14.678019 ], [ -89.353326, 14.424133 ], [ -89.587343, 14.362586 ], [ -89.534219, 14.244816 ], [ -89.721934, 14.134228 ], [ -90.064678, 13.88197 ], [ -90.095555, 13.735338 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "GUF", "name": "French Guiana" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -52.556425, 2.504705 ], [ -52.939657, 2.124858 ], [ -53.418465, 2.053389 ], [ -53.554839, 2.334897 ], [ -53.778521, 2.376703 ], [ -54.088063, 2.105557 ], [ -54.524754, 2.311849 ], [ -54.27123, 2.738748 ], [ -54.184284, 3.194172 ], [ -54.011504, 3.62257 ], [ -54.399542, 4.212611 ], [ -54.478633, 4.896756 ], [ -53.958045, 5.756548 ], [ -53.618453, 5.646529 ], [ -52.882141, 5.409851 ], [ -51.823343, 4.565768 ], [ -51.657797, 4.156232 ], [ -52.249338, 3.241094 ], [ -52.556425, 2.504705 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "GUY", "name": "Guyana" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -59.758285, 8.367035 ], [ -59.101684, 7.999202 ], [ -58.482962, 7.347691 ], [ -58.454876, 6.832787 ], [ -58.078103, 6.809094 ], [ -57.542219, 6.321268 ], [ -57.147436, 5.97315 ], [ -57.307246, 5.073567 ], [ -57.914289, 4.812626 ], [ -57.86021, 4.576801 ], [ -58.044694, 4.060864 ], [ -57.601569, 3.334655 ], [ -57.281433, 3.333492 ], [ -57.150098, 2.768927 ], [ -56.539386, 1.899523 ], [ -56.782704, 1.863711 ], [ -57.335823, 1.948538 ], [ -57.660971, 1.682585 ], [ -58.11345, 1.507195 ], [ -58.429477, 1.463942 ], [ -58.540013, 1.268088 ], [ -59.030862, 1.317698 ], [ -59.646044, 1.786894 ], [ -59.718546, 2.24963 ], [ -59.974525, 2.755233 ], [ -59.815413, 3.606499 ], [ -59.53804, 3.958803 ], [ -59.767406, 4.423503 ], [ -60.111002, 4.574967 ], [ -59.980959, 5.014061 ], [ -60.213683, 5.244486 ], [ -60.733574, 5.200277 ], [ -61.410303, 5.959068 ], [ -61.139415, 6.234297 ], [ -61.159336, 6.696077 ], [ -60.543999, 6.856584 ], [ -60.295668, 7.043911 ], [ -60.637973, 7.415 ], [ -60.550588, 7.779603 ], [ -59.758285, 8.367035 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "HND", "name": "Honduras" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -87.316654, 12.984686 ], [ -87.489409, 13.297535 ], [ -87.793111, 13.38448 ], [ -87.723503, 13.78505 ], [ -87.859515, 13.893312 ], [ -88.065343, 13.964626 ], [ -88.503998, 13.845486 ], [ -88.541231, 13.980155 ], [ -88.843073, 14.140507 ], [ -89.058512, 14.340029 ], [ -89.353326, 14.424133 ], [ -89.145535, 14.678019 ], [ -89.22522, 14.874286 ], [ -89.154811, 15.066419 ], [ -88.68068, 15.346247 ], [ -88.225023, 15.727722 ], [ -88.121153, 15.688655 ], [ -87.901813, 15.864458 ], [ -87.61568, 15.878799 ], [ -87.522921, 15.797279 ], [ -87.367762, 15.84694 ], [ -86.903191, 15.756713 ], [ -86.440946, 15.782835 ], [ -86.119234, 15.893449 ], [ -86.001954, 16.005406 ], [ -85.683317, 15.953652 ], [ -85.444004, 15.885749 ], [ -85.182444, 15.909158 ], [ -84.983722, 15.995923 ], [ -84.52698, 15.857224 ], [ -84.368256, 15.835158 ], [ -84.063055, 15.648244 ], [ -83.773977, 15.424072 ], [ -83.410381, 15.270903 ], [ -83.147219, 14.995829 ], [ -83.489989, 15.016267 ], [ -83.628585, 14.880074 ], [ -83.975721, 14.749436 ], [ -84.228342, 14.748764 ], [ -84.449336, 14.621614 ], [ -84.649582, 14.666805 ], [ -84.820037, 14.819587 ], [ -84.924501, 14.790493 ], [ -85.052787, 14.551541 ], [ -85.148751, 14.560197 ], [ -85.165365, 14.35437 ], [ -85.514413, 14.079012 ], [ -85.698665, 13.960078 ], [ -85.801295, 13.836055 ], [ -86.096264, 14.038187 ], [ -86.312142, 13.771356 ], [ -86.520708, 13.778487 ], [ -86.755087, 13.754845 ], [ -86.733822, 13.263093 ], [ -86.880557, 13.254204 ], [ -87.005769, 13.025794 ], [ -87.316654, 12.984686 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "HRV", "name": "Croatia" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 18.829838, 45.908878 ], [ 19.072769, 45.521511 ], [ 19.390476, 45.236516 ], [ 19.005486, 44.860234 ], [ 18.553214, 45.08159 ], [ 17.861783, 45.06774 ], [ 17.002146, 45.233777 ], [ 16.534939, 45.211608 ], [ 16.318157, 45.004127 ], [ 15.959367, 45.233777 ], [ 15.750026, 44.818712 ], [ 16.23966, 44.351143 ], [ 16.456443, 44.04124 ], [ 16.916156, 43.667722 ], [ 17.297373, 43.446341 ], [ 17.674922, 43.028563 ], [ 18.56, 42.65 ], [ 18.450016, 42.479991 ], [ 17.50997, 42.849995 ], [ 16.930006, 43.209998 ], [ 16.015385, 43.507215 ], [ 15.174454, 44.243191 ], [ 15.37625, 44.317915 ], [ 14.920309, 44.738484 ], [ 14.901602, 45.07606 ], [ 14.258748, 45.233777 ], [ 13.952255, 44.802124 ], [ 13.656976, 45.136935 ], [ 13.679403, 45.484149 ], [ 13.71506, 45.500324 ], [ 14.411968, 45.466166 ], [ 14.595109, 45.634941 ], [ 14.935244, 45.471695 ], [ 15.327675, 45.452316 ], [ 15.323954, 45.731783 ], [ 15.67153, 45.834154 ], [ 15.768733, 46.238108 ], [ 16.564808, 46.503751 ], [ 16.882515, 46.380632 ], [ 17.630066, 45.951769 ], [ 18.456062, 45.759481 ], [ 18.829838, 45.908878 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "HTI", "name": "Haiti" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -73.189791, 19.915684 ], [ -72.579673, 19.871501 ], [ -71.712361, 19.714456 ], [ -71.624873, 19.169838 ], [ -71.701303, 18.785417 ], [ -71.945112, 18.6169 ], [ -71.687738, 18.31666 ], [ -71.708305, 18.044997 ], [ -72.372476, 18.214961 ], [ -72.844411, 18.145611 ], [ -73.454555, 18.217906 ], [ -73.922433, 18.030993 ], [ -74.458034, 18.34255 ], [ -74.369925, 18.664908 ], [ -73.449542, 18.526053 ], [ -72.694937, 18.445799 ], [ -72.334882, 18.668422 ], [ -72.79165, 19.101625 ], [ -72.784105, 19.483591 ], [ -73.415022, 19.639551 ], [ -73.189791, 19.915684 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "HUN", "name": "Hungary" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 16.202298, 46.852386 ], [ 16.534268, 47.496171 ], [ 16.340584, 47.712902 ], [ 16.903754, 47.714866 ], [ 16.979667, 48.123497 ], [ 17.488473, 47.867466 ], [ 17.857133, 47.758429 ], [ 18.696513, 47.880954 ], [ 18.777025, 48.081768 ], [ 19.174365, 48.111379 ], [ 19.661364, 48.266615 ], [ 19.769471, 48.202691 ], [ 20.239054, 48.327567 ], [ 20.473562, 48.56285 ], [ 20.801294, 48.623854 ], [ 21.872236, 48.319971 ], [ 22.085608, 48.422264 ], [ 22.64082, 48.15024 ], [ 22.710531, 47.882194 ], [ 22.099768, 47.672439 ], [ 21.626515, 46.994238 ], [ 21.021952, 46.316088 ], [ 20.220192, 46.127469 ], [ 19.596045, 46.17173 ], [ 18.829838, 45.908878 ], [ 18.456062, 45.759481 ], [ 17.630066, 45.951769 ], [ 16.882515, 46.380632 ], [ 16.564808, 46.503751 ], [ 16.370505, 46.841327 ], [ 16.202298, 46.852386 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "IDN", "name": "Indonesia" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 120.715609, -10.239581 ], [ 120.295014, -10.25865 ], [ 118.967808, -9.557969 ], [ 119.90031, -9.36134 ], [ 120.425756, -9.665921 ], [ 120.775502, -9.969675 ], [ 120.715609, -10.239581 ] ] ], [ [ [ 124.43595, -10.140001 ], [ 123.579982, -10.359987 ], [ 123.459989, -10.239995 ], [ 123.550009, -9.900016 ], [ 123.980009, -9.290027 ], [ 124.968682, -8.89279 ], [ 125.07002, -9.089987 ], [ 125.08852, -9.393173 ], [ 124.43595, -10.140001 ] ] ], [ [ [ 117.900018, -8.095681 ], [ 118.260616, -8.362383 ], [ 118.87846, -8.280683 ], [ 119.126507, -8.705825 ], [ 117.970402, -8.906639 ], [ 117.277731, -9.040895 ], [ 116.740141, -9.032937 ], [ 117.083737, -8.457158 ], [ 117.632024, -8.449303 ], [ 117.900018, -8.095681 ] ] ], [ [ [ 122.903537, -8.094234 ], [ 122.756983, -8.649808 ], [ 121.254491, -8.933666 ], [ 119.924391, -8.810418 ], [ 119.920929, -8.444859 ], [ 120.715092, -8.236965 ], [ 121.341669, -8.53674 ], [ 122.007365, -8.46062 ], [ 122.903537, -8.094234 ] ] ], [ [ [ 108.623479, -6.777674 ], [ 110.539227, -6.877358 ], [ 110.759576, -6.465186 ], [ 112.614811, -6.946036 ], [ 112.978768, -7.594213 ], [ 114.478935, -7.776528 ], [ 115.705527, -8.370807 ], [ 114.564511, -8.751817 ], [ 113.464734, -8.348947 ], [ 112.559672, -8.376181 ], [ 111.522061, -8.302129 ], [ 110.58615, -8.122605 ], [ 109.427667, -7.740664 ], [ 108.693655, -7.6416 ], [ 108.277763, -7.766657 ], [ 106.454102, -7.3549 ], [ 106.280624, -6.9249 ], [ 105.365486, -6.851416 ], [ 106.051646, -5.895919 ], [ 107.265009, -5.954985 ], [ 108.072091, -6.345762 ], [ 108.486846, -6.421985 ], [ 108.623479, -6.777674 ] ] ], [ [ [ 134.724624, -6.214401 ], [ 134.210134, -6.895238 ], [ 134.112776, -6.142467 ], [ 134.290336, -5.783058 ], [ 134.499625, -5.445042 ], [ 134.727002, -5.737582 ], [ 134.724624, -6.214401 ] ] ], [ [ [ 127.249215, -3.459065 ], [ 126.874923, -3.790983 ], [ 126.183802, -3.607376 ], [ 125.989034, -3.177273 ], [ 127.000651, -3.129318 ], [ 127.249215, -3.459065 ] ] ], [ [ [ 130.471344, -3.093764 ], [ 130.834836, -3.858472 ], [ 129.990547, -3.446301 ], [ 129.155249, -3.362637 ], [ 128.590684, -3.428679 ], [ 127.898891, -3.393436 ], [ 128.135879, -2.84365 ], [ 129.370998, -2.802154 ], [ 130.471344, -3.093764 ] ] ], [ [ [ 134.143368, -1.151867 ], [ 134.422627, -2.769185 ], [ 135.457603, -3.367753 ], [ 136.293314, -2.307042 ], [ 137.440738, -1.703513 ], [ 138.329727, -1.702686 ], [ 139.184921, -2.051296 ], [ 139.926684, -2.409052 ], [ 141.00021, -2.600151 ], [ 141.017057, -5.859022 ], [ 141.033852, -9.117893 ], [ 140.143415, -8.297168 ], [ 139.127767, -8.096043 ], [ 138.881477, -8.380935 ], [ 137.614474, -8.411683 ], [ 138.039099, -7.597882 ], [ 138.668621, -7.320225 ], [ 138.407914, -6.232849 ], [ 137.92784, -5.393366 ], [ 135.98925, -4.546544 ], [ 135.164598, -4.462931 ], [ 133.66288, -3.538853 ], [ 133.367705, -4.024819 ], [ 132.983956, -4.112979 ], [ 132.756941, -3.746283 ], [ 132.753789, -3.311787 ], [ 131.989804, -2.820551 ], [ 133.066845, -2.460418 ], [ 133.780031, -2.479848 ], [ 133.696212, -2.214542 ], [ 132.232373, -2.212526 ], [ 131.836222, -1.617162 ], [ 130.94284, -1.432522 ], [ 130.519558, -0.93772 ], [ 131.867538, -0.695461 ], [ 132.380116, -0.369538 ], [ 133.985548, -0.78021 ], [ 134.143368, -1.151867 ] ] ], [ [ [ 125.240501, 1.419836 ], [ 124.437035, 0.427881 ], [ 123.685505, 0.235593 ], [ 122.723083, 0.431137 ], [ 121.056725, 0.381217 ], [ 120.183083, 0.237247 ], [ 120.04087, -0.519658 ], [ 120.935905, -1.408906 ], [ 121.475821, -0.955962 ], [ 123.340565, -0.615673 ], [ 123.258399, -1.076213 ], [ 122.822715, -0.930951 ], [ 122.38853, -1.516858 ], [ 121.508274, -1.904483 ], [ 122.454572, -3.186058 ], [ 122.271896, -3.5295 ], [ 123.170963, -4.683693 ], [ 123.162333, -5.340604 ], [ 122.628515, -5.634591 ], [ 122.236394, -5.282933 ], [ 122.719569, -4.464172 ], [ 121.738234, -4.851331 ], [ 121.489463, -4.574553 ], [ 121.619171, -4.188478 ], [ 120.898182, -3.602105 ], [ 120.972389, -2.627643 ], [ 120.305453, -2.931604 ], [ 120.390047, -4.097579 ], [ 120.430717, -5.528241 ], [ 119.796543, -5.6734 ], [ 119.366906, -5.379878 ], [ 119.653606, -4.459417 ], [ 119.498835, -3.494412 ], [ 119.078344, -3.487022 ], [ 118.767769, -2.801999 ], [ 119.180974, -2.147104 ], [ 119.323394, -1.353147 ], [ 119.825999, 0.154254 ], [ 120.035702, 0.566477 ], [ 120.885779, 1.309223 ], [ 121.666817, 1.013944 ], [ 122.927567, 0.875192 ], [ 124.077522, 0.917102 ], [ 125.065989, 1.643259 ], [ 125.240501, 1.419836 ] ] ], [ [ [ 128.688249, 1.132386 ], [ 128.635952, 0.258486 ], [ 128.12017, 0.356413 ], [ 127.968034, -0.252077 ], [ 128.379999, -0.780004 ], [ 128.100016, -0.899996 ], [ 127.696475, -0.266598 ], [ 127.39949, 1.011722 ], [ 127.600512, 1.810691 ], [ 127.932378, 2.174596 ], [ 128.004156, 1.628531 ], [ 128.594559, 1.540811 ], [ 128.688249, 1.132386 ] ] ], [ [ [ 117.875627, 1.827641 ], [ 118.996747, 0.902219 ], [ 117.811858, 0.784242 ], [ 117.478339, 0.102475 ], [ 117.521644, -0.803723 ], [ 116.560048, -1.487661 ], [ 116.533797, -2.483517 ], [ 116.148084, -4.012726 ], [ 116.000858, -3.657037 ], [ 114.864803, -4.106984 ], [ 114.468652, -3.495704 ], [ 113.755672, -3.43917 ], [ 113.256994, -3.118776 ], [ 112.068126, -3.478392 ], [ 111.703291, -2.994442 ], [ 111.04824, -3.049426 ], [ 110.223846, -2.934032 ], [ 110.070936, -1.592874 ], [ 109.571948, -1.314907 ], [ 109.091874, -0.459507 ], [ 108.952658, 0.415375 ], [ 109.069136, 1.341934 ], [ 109.66326, 2.006467 ], [ 109.830227, 1.338136 ], [ 110.514061, 0.773131 ], [ 111.159138, 0.976478 ], [ 111.797548, 0.904441 ], [ 112.380252, 1.410121 ], [ 112.859809, 1.49779 ], [ 113.80585, 1.217549 ], [ 114.621355, 1.430688 ], [ 115.134037, 2.821482 ], [ 115.519078, 3.169238 ], [ 115.865517, 4.306559 ], [ 117.015214, 4.306094 ], [ 117.882035, 4.137551 ], [ 117.313232, 3.234428 ], [ 118.04833, 2.28769 ], [ 117.875627, 1.827641 ] ] ], [ [ [ 105.817655, -5.852356 ], [ 104.710384, -5.873285 ], [ 103.868213, -5.037315 ], [ 102.584261, -4.220259 ], [ 102.156173, -3.614146 ], [ 101.399113, -2.799777 ], [ 100.902503, -2.050262 ], [ 100.141981, -0.650348 ], [ 99.26374, 0.183142 ], [ 98.970011, 1.042882 ], [ 98.601351, 1.823507 ], [ 97.699598, 2.453184 ], [ 97.176942, 3.308791 ], [ 96.424017, 3.86886 ], [ 95.380876, 4.970782 ], [ 95.293026, 5.479821 ], [ 95.936863, 5.439513 ], [ 97.484882, 5.246321 ], [ 98.369169, 4.26837 ], [ 99.142559, 3.59035 ], [ 99.693998, 3.174329 ], [ 100.641434, 2.099381 ], [ 101.658012, 2.083697 ], [ 102.498271, 1.3987 ], [ 103.07684, 0.561361 ], [ 103.838396, 0.104542 ], [ 103.437645, -0.711946 ], [ 104.010789, -1.059212 ], [ 104.369991, -1.084843 ], [ 104.53949, -1.782372 ], [ 104.887893, -2.340425 ], [ 105.622111, -2.428844 ], [ 106.108593, -3.061777 ], [ 105.857446, -4.305525 ], [ 105.817655, -5.852356 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "IND", "name": "India" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 77.837451, 35.49401 ], [ 78.912269, 34.321936 ], [ 78.811086, 33.506198 ], [ 79.208892, 32.994395 ], [ 79.176129, 32.48378 ], [ 78.458446, 32.618164 ], [ 78.738894, 31.515906 ], [ 79.721367, 30.882715 ], [ 81.111256, 30.183481 ], [ 80.476721, 29.729865 ], [ 80.088425, 28.79447 ], [ 81.057203, 28.416095 ], [ 81.999987, 27.925479 ], [ 83.304249, 27.364506 ], [ 84.675018, 27.234901 ], [ 85.251779, 26.726198 ], [ 86.024393, 26.630985 ], [ 87.227472, 26.397898 ], [ 88.060238, 26.414615 ], [ 88.174804, 26.810405 ], [ 88.043133, 27.445819 ], [ 88.120441, 27.876542 ], [ 88.730326, 28.086865 ], [ 88.814248, 27.299316 ], [ 88.835643, 27.098966 ], [ 89.744528, 26.719403 ], [ 90.373275, 26.875724 ], [ 91.217513, 26.808648 ], [ 92.033484, 26.83831 ], [ 92.103712, 27.452614 ], [ 91.696657, 27.771742 ], [ 92.503119, 27.896876 ], [ 93.413348, 28.640629 ], [ 94.56599, 29.277438 ], [ 95.404802, 29.031717 ], [ 96.117679, 29.452802 ], [ 96.586591, 28.83098 ], [ 96.248833, 28.411031 ], [ 97.327114, 28.261583 ], [ 97.402561, 27.882536 ], [ 97.051989, 27.699059 ], [ 97.133999, 27.083774 ], [ 96.419366, 27.264589 ], [ 95.124768, 26.573572 ], [ 95.155153, 26.001307 ], [ 94.603249, 25.162495 ], [ 94.552658, 24.675238 ], [ 94.106742, 23.850741 ], [ 93.325188, 24.078556 ], [ 93.286327, 23.043658 ], [ 93.060294, 22.703111 ], [ 93.166128, 22.27846 ], [ 92.672721, 22.041239 ], [ 92.146035, 23.627499 ], [ 91.869928, 23.624346 ], [ 91.706475, 22.985264 ], [ 91.158963, 23.503527 ], [ 91.46773, 24.072639 ], [ 91.915093, 24.130414 ], [ 92.376202, 24.976693 ], [ 91.799596, 25.147432 ], [ 90.872211, 25.132601 ], [ 89.920693, 25.26975 ], [ 89.832481, 25.965082 ], [ 89.355094, 26.014407 ], [ 88.563049, 26.446526 ], [ 88.209789, 25.768066 ], [ 88.931554, 25.238692 ], [ 88.306373, 24.866079 ], [ 88.084422, 24.501657 ], [ 88.69994, 24.233715 ], [ 88.52977, 23.631142 ], [ 88.876312, 22.879146 ], [ 89.031961, 22.055708 ], [ 88.888766, 21.690588 ], [ 88.208497, 21.703172 ], [ 86.975704, 21.495562 ], [ 87.033169, 20.743308 ], [ 86.499351, 20.151638 ], [ 85.060266, 19.478579 ], [ 83.941006, 18.30201 ], [ 83.189217, 17.671221 ], [ 82.192792, 17.016636 ], [ 82.191242, 16.556664 ], [ 81.692719, 16.310219 ], [ 80.791999, 15.951972 ], [ 80.324896, 15.899185 ], [ 80.025069, 15.136415 ], [ 80.233274, 13.835771 ], [ 80.286294, 13.006261 ], [ 79.862547, 12.056215 ], [ 79.857999, 10.357275 ], [ 79.340512, 10.308854 ], [ 78.885345, 9.546136 ], [ 79.18972, 9.216544 ], [ 78.277941, 8.933047 ], [ 77.941165, 8.252959 ], [ 77.539898, 7.965535 ], [ 76.592979, 8.899276 ], [ 76.130061, 10.29963 ], [ 75.746467, 11.308251 ], [ 75.396101, 11.781245 ], [ 74.864816, 12.741936 ], [ 74.616717, 13.992583 ], [ 74.443859, 14.617222 ], [ 73.534199, 15.990652 ], [ 73.119909, 17.92857 ], [ 72.820909, 19.208234 ], [ 72.824475, 20.419503 ], [ 72.630533, 21.356009 ], [ 71.175273, 20.757441 ], [ 70.470459, 20.877331 ], [ 69.16413, 22.089298 ], [ 69.644928, 22.450775 ], [ 69.349597, 22.84318 ], [ 68.176645, 23.691965 ], [ 68.842599, 24.359134 ], [ 71.04324, 24.356524 ], [ 70.844699, 25.215102 ], [ 70.282873, 25.722229 ], [ 70.168927, 26.491872 ], [ 69.514393, 26.940966 ], [ 70.616496, 27.989196 ], [ 71.777666, 27.91318 ], [ 72.823752, 28.961592 ], [ 73.450638, 29.976413 ], [ 74.42138, 30.979815 ], [ 74.405929, 31.692639 ], [ 75.258642, 32.271105 ], [ 74.451559, 32.7649 ], [ 74.104294, 33.441473 ], [ 73.749948, 34.317699 ], [ 74.240203, 34.748887 ], [ 75.757061, 34.504923 ], [ 76.871722, 34.653544 ], [ 77.837451, 35.49401 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "IRL", "name": "Ireland" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -6.197885, 53.867565 ], [ -6.032985, 53.153164 ], [ -6.788857, 52.260118 ], [ -8.561617, 51.669301 ], [ -9.977086, 51.820455 ], [ -9.166283, 52.864629 ], [ -9.688525, 53.881363 ], [ -8.327987, 54.664519 ], [ -7.572168, 55.131622 ], [ -7.366031, 54.595841 ], [ -7.572168, 54.059956 ], [ -6.95373, 54.073702 ], [ -6.197885, 53.867565 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "IRN", "name": "Iran" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 53.921598, 37.198918 ], [ 54.800304, 37.392421 ], [ 55.511578, 37.964117 ], [ 56.180375, 37.935127 ], [ 56.619366, 38.121394 ], [ 57.330434, 38.029229 ], [ 58.436154, 37.522309 ], [ 59.234762, 37.412988 ], [ 60.377638, 36.527383 ], [ 61.123071, 36.491597 ], [ 61.210817, 35.650072 ], [ 60.803193, 34.404102 ], [ 60.52843, 33.676446 ], [ 60.9637, 33.528832 ], [ 60.536078, 32.981269 ], [ 60.863655, 32.18292 ], [ 60.941945, 31.548075 ], [ 61.699314, 31.379506 ], [ 61.781222, 30.73585 ], [ 60.874248, 29.829239 ], [ 61.369309, 29.303276 ], [ 61.771868, 28.699334 ], [ 62.72783, 28.259645 ], [ 62.755426, 27.378923 ], [ 63.233898, 27.217047 ], [ 63.316632, 26.756532 ], [ 61.874187, 26.239975 ], [ 61.497363, 25.078237 ], [ 59.616134, 25.380157 ], [ 58.525761, 25.609962 ], [ 57.397251, 25.739902 ], [ 56.970766, 26.966106 ], [ 56.492139, 27.143305 ], [ 55.72371, 26.964633 ], [ 54.71509, 26.480658 ], [ 53.493097, 26.812369 ], [ 52.483598, 27.580849 ], [ 51.520763, 27.86569 ], [ 50.852948, 28.814521 ], [ 50.115009, 30.147773 ], [ 49.57685, 29.985715 ], [ 48.941333, 30.31709 ], [ 48.567971, 29.926778 ], [ 48.014568, 30.452457 ], [ 48.004698, 30.985137 ], [ 47.685286, 30.984853 ], [ 47.849204, 31.709176 ], [ 47.334661, 32.469155 ], [ 46.109362, 33.017287 ], [ 45.416691, 33.967798 ], [ 45.64846, 34.748138 ], [ 46.151788, 35.093259 ], [ 46.07634, 35.677383 ], [ 45.420618, 35.977546 ], [ 44.77267, 37.17045 ], [ 44.225756, 37.971584 ], [ 44.421403, 38.281281 ], [ 44.109225, 39.428136 ], [ 44.79399, 39.713003 ], [ 44.952688, 39.335765 ], [ 45.457722, 38.874139 ], [ 46.143623, 38.741201 ], [ 46.50572, 38.770605 ], [ 47.685079, 39.508364 ], [ 48.060095, 39.582235 ], [ 48.355529, 39.288765 ], [ 48.010744, 38.794015 ], [ 48.634375, 38.270378 ], [ 48.883249, 38.320245 ], [ 49.199612, 37.582874 ], [ 50.147771, 37.374567 ], [ 50.842354, 36.872814 ], [ 52.264025, 36.700422 ], [ 53.82579, 36.965031 ], [ 53.921598, 37.198918 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "IRQ", "name": "Iraq" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 45.420618, 35.977546 ], [ 46.07634, 35.677383 ], [ 46.151788, 35.093259 ], [ 45.64846, 34.748138 ], [ 45.416691, 33.967798 ], [ 46.109362, 33.017287 ], [ 47.334661, 32.469155 ], [ 47.849204, 31.709176 ], [ 47.685286, 30.984853 ], [ 48.004698, 30.985137 ], [ 48.014568, 30.452457 ], [ 48.567971, 29.926778 ], [ 47.974519, 29.975819 ], [ 47.302622, 30.05907 ], [ 46.568713, 29.099025 ], [ 44.709499, 29.178891 ], [ 41.889981, 31.190009 ], [ 40.399994, 31.889992 ], [ 39.195468, 32.161009 ], [ 38.792341, 33.378686 ], [ 41.006159, 34.419372 ], [ 41.383965, 35.628317 ], [ 41.289707, 36.358815 ], [ 41.837064, 36.605854 ], [ 42.349591, 37.229873 ], [ 42.779126, 37.385264 ], [ 43.942259, 37.256228 ], [ 44.293452, 37.001514 ], [ 44.772699, 37.170445 ], [ 45.420618, 35.977546 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "ISL", "name": "Iceland" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -14.508695, 66.455892 ], [ -14.739637, 65.808748 ], [ -13.609732, 65.126671 ], [ -14.909834, 64.364082 ], [ -17.794438, 63.678749 ], [ -18.656246, 63.496383 ], [ -19.972755, 63.643635 ], [ -22.762972, 63.960179 ], [ -21.778484, 64.402116 ], [ -23.955044, 64.89113 ], [ -22.184403, 65.084968 ], [ -22.227423, 65.378594 ], [ -24.326184, 65.611189 ], [ -23.650515, 66.262519 ], [ -22.134922, 66.410469 ], [ -20.576284, 65.732112 ], [ -19.056842, 66.276601 ], [ -17.798624, 65.993853 ], [ -16.167819, 66.526792 ], [ -14.508695, 66.455892 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "ISR", "name": "Israel" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 35.719918, 32.709192 ], [ 35.545665, 32.393992 ], [ 35.18393, 32.532511 ], [ 34.974641, 31.866582 ], [ 35.225892, 31.754341 ], [ 34.970507, 31.616778 ], [ 34.927408, 31.353435 ], [ 35.397561, 31.489086 ], [ 35.420918, 31.100066 ], [ 34.922603, 29.501326 ], [ 34.265433, 31.219361 ], [ 34.556372, 31.548824 ], [ 34.488107, 31.605539 ], [ 34.752587, 32.072926 ], [ 34.955417, 32.827376 ], [ 35.098457, 33.080539 ], [ 35.126053, 33.0909 ], [ 35.460709, 33.08904 ], [ 35.552797, 33.264275 ], [ 35.821101, 33.277426 ], [ 35.836397, 32.868123 ], [ 35.700798, 32.716014 ], [ 35.719918, 32.709192 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "ITA", "name": "Italy" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 15.520376, 38.231155 ], [ 15.160243, 37.444046 ], [ 15.309898, 37.134219 ], [ 15.099988, 36.619987 ], [ 14.335229, 36.996631 ], [ 13.826733, 37.104531 ], [ 12.431004, 37.61295 ], [ 12.570944, 38.126381 ], [ 13.741156, 38.034966 ], [ 14.761249, 38.143874 ], [ 15.520376, 38.231155 ] ] ], [ [ [ 9.210012, 41.209991 ], [ 9.809975, 40.500009 ], [ 9.669519, 39.177376 ], [ 9.214818, 39.240473 ], [ 8.806936, 38.906618 ], [ 8.428302, 39.171847 ], [ 8.388253, 40.378311 ], [ 8.159998, 40.950007 ], [ 8.709991, 40.899984 ], [ 9.210012, 41.209991 ] ] ], [ [ [ 12.376485, 46.767559 ], [ 13.806475, 46.509306 ], [ 13.69811, 46.016778 ], [ 13.93763, 45.591016 ], [ 13.141606, 45.736692 ], [ 12.328581, 45.381778 ], [ 12.383875, 44.885374 ], [ 12.261453, 44.600482 ], [ 12.589237, 44.091366 ], [ 13.526906, 43.587727 ], [ 14.029821, 42.761008 ], [ 15.14257, 41.95514 ], [ 15.926191, 41.961315 ], [ 16.169897, 41.740295 ], [ 15.889346, 41.541082 ], [ 16.785002, 41.179606 ], [ 17.519169, 40.877143 ], [ 18.376687, 40.355625 ], [ 18.480247, 40.168866 ], [ 18.293385, 39.810774 ], [ 17.73838, 40.277671 ], [ 16.869596, 40.442235 ], [ 16.448743, 39.795401 ], [ 17.17149, 39.4247 ], [ 17.052841, 38.902871 ], [ 16.635088, 38.843572 ], [ 16.100961, 37.985899 ], [ 15.684087, 37.908849 ], [ 15.687963, 38.214593 ], [ 15.891981, 38.750942 ], [ 16.109332, 38.964547 ], [ 15.718814, 39.544072 ], [ 15.413613, 40.048357 ], [ 14.998496, 40.172949 ], [ 14.703268, 40.60455 ], [ 14.060672, 40.786348 ], [ 13.627985, 41.188287 ], [ 12.888082, 41.25309 ], [ 12.106683, 41.704535 ], [ 11.191906, 42.355425 ], [ 10.511948, 42.931463 ], [ 10.200029, 43.920007 ], [ 9.702488, 44.036279 ], [ 8.888946, 44.366336 ], [ 8.428561, 44.231228 ], [ 7.850767, 43.767148 ], [ 7.435185, 43.693845 ], [ 7.549596, 44.127901 ], [ 7.007562, 44.254767 ], [ 6.749955, 45.028518 ], [ 7.096652, 45.333099 ], [ 6.802355, 45.70858 ], [ 6.843593, 45.991147 ], [ 7.273851, 45.776948 ], [ 7.755992, 45.82449 ], [ 8.31663, 46.163642 ], [ 8.489952, 46.005151 ], [ 8.966306, 46.036932 ], [ 9.182882, 46.440215 ], [ 9.922837, 46.314899 ], [ 10.363378, 46.483571 ], [ 10.442701, 46.893546 ], [ 11.048556, 46.751359 ], [ 11.164828, 46.941579 ], [ 12.153088, 47.115393 ], [ 12.376485, 46.767559 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "JAM", "name": "Jamaica" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -77.569601, 18.490525 ], [ -76.896619, 18.400867 ], [ -76.365359, 18.160701 ], [ -76.199659, 17.886867 ], [ -76.902561, 17.868238 ], [ -77.206341, 17.701116 ], [ -77.766023, 17.861597 ], [ -78.337719, 18.225968 ], [ -78.217727, 18.454533 ], [ -77.797365, 18.524218 ], [ -77.569601, 18.490525 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "JOR", "name": "Jordan" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 35.545665, 32.393992 ], [ 35.719918, 32.709192 ], [ 36.834062, 32.312938 ], [ 38.792341, 33.378686 ], [ 39.195468, 32.161009 ], [ 39.004886, 32.010217 ], [ 37.002166, 31.508413 ], [ 37.998849, 30.5085 ], [ 37.66812, 30.338665 ], [ 37.503582, 30.003776 ], [ 36.740528, 29.865283 ], [ 36.501214, 29.505254 ], [ 36.068941, 29.197495 ], [ 34.956037, 29.356555 ], [ 34.922603, 29.501326 ], [ 35.420918, 31.100066 ], [ 35.397561, 31.489086 ], [ 35.545252, 31.782505 ], [ 35.545665, 32.393992 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "JPN", "name": "Japan" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 134.638428, 34.149234 ], [ 134.766379, 33.806335 ], [ 134.203416, 33.201178 ], [ 133.79295, 33.521985 ], [ 133.280268, 33.28957 ], [ 133.014858, 32.704567 ], [ 132.363115, 32.989382 ], [ 132.371176, 33.463642 ], [ 132.924373, 34.060299 ], [ 133.492968, 33.944621 ], [ 133.904106, 34.364931 ], [ 134.638428, 34.149234 ] ] ], [ [ [ 140.976388, 37.142074 ], [ 140.59977, 36.343983 ], [ 140.774074, 35.842877 ], [ 140.253279, 35.138114 ], [ 138.975528, 34.6676 ], [ 137.217599, 34.606286 ], [ 135.792983, 33.464805 ], [ 135.120983, 33.849071 ], [ 135.079435, 34.596545 ], [ 133.340316, 34.375938 ], [ 132.156771, 33.904933 ], [ 130.986145, 33.885761 ], [ 132.000036, 33.149992 ], [ 131.33279, 31.450355 ], [ 130.686318, 31.029579 ], [ 130.20242, 31.418238 ], [ 130.447676, 32.319475 ], [ 129.814692, 32.61031 ], [ 129.408463, 33.296056 ], [ 130.353935, 33.604151 ], [ 130.878451, 34.232743 ], [ 131.884229, 34.749714 ], [ 132.617673, 35.433393 ], [ 134.608301, 35.731618 ], [ 135.677538, 35.527134 ], [ 136.723831, 37.304984 ], [ 137.390612, 36.827391 ], [ 138.857602, 37.827485 ], [ 139.426405, 38.215962 ], [ 140.05479, 39.438807 ], [ 139.883379, 40.563312 ], [ 140.305783, 41.195005 ], [ 141.368973, 41.37856 ], [ 141.914263, 39.991616 ], [ 141.884601, 39.180865 ], [ 140.959489, 38.174001 ], [ 140.976388, 37.142074 ] ] ], [ [ [ 143.910162, 44.1741 ], [ 144.613427, 43.960883 ], [ 145.320825, 44.384733 ], [ 145.543137, 43.262088 ], [ 144.059662, 42.988358 ], [ 143.18385, 41.995215 ], [ 141.611491, 42.678791 ], [ 141.067286, 41.584594 ], [ 139.955106, 41.569556 ], [ 139.817544, 42.563759 ], [ 140.312087, 43.333273 ], [ 141.380549, 43.388825 ], [ 141.671952, 44.772125 ], [ 141.967645, 45.551483 ], [ 143.14287, 44.510358 ], [ 143.910162, 44.1741 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "KAZ", "name": "Kazakhstan" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 70.962315, 42.266154 ], [ 70.388965, 42.081308 ], [ 69.070027, 41.384244 ], [ 68.632483, 40.668681 ], [ 68.259896, 40.662325 ], [ 67.985856, 41.135991 ], [ 66.714047, 41.168444 ], [ 66.510649, 41.987644 ], [ 66.023392, 41.994646 ], [ 66.098012, 42.99766 ], [ 64.900824, 43.728081 ], [ 63.185787, 43.650075 ], [ 62.0133, 43.504477 ], [ 61.05832, 44.405817 ], [ 60.239972, 44.784037 ], [ 58.689989, 45.500014 ], [ 58.503127, 45.586804 ], [ 55.928917, 44.995858 ], [ 55.968191, 41.308642 ], [ 55.455251, 41.259859 ], [ 54.755345, 42.043971 ], [ 54.079418, 42.324109 ], [ 52.944293, 42.116034 ], [ 52.50246, 41.783316 ], [ 52.446339, 42.027151 ], [ 52.692112, 42.443895 ], [ 52.501426, 42.792298 ], [ 51.342427, 43.132975 ], [ 50.891292, 44.031034 ], [ 50.339129, 44.284016 ], [ 50.305643, 44.609836 ], [ 51.278503, 44.514854 ], [ 51.316899, 45.245998 ], [ 52.16739, 45.408391 ], [ 53.040876, 45.259047 ], [ 53.220866, 46.234646 ], [ 53.042737, 46.853006 ], [ 52.042023, 46.804637 ], [ 51.191945, 47.048705 ], [ 50.034083, 46.60899 ], [ 49.10116, 46.39933 ], [ 48.593241, 46.561034 ], [ 48.694734, 47.075628 ], [ 48.057253, 47.743753 ], [ 47.315231, 47.715847 ], [ 46.466446, 48.394152 ], [ 47.043672, 49.152039 ], [ 46.751596, 49.356006 ], [ 47.54948, 50.454698 ], [ 48.577841, 49.87476 ], [ 48.702382, 50.605128 ], [ 50.766648, 51.692762 ], [ 52.328724, 51.718652 ], [ 54.532878, 51.02624 ], [ 55.716941, 50.621717 ], [ 56.777961, 51.043551 ], [ 58.363291, 51.063653 ], [ 59.642282, 50.545442 ], [ 59.932807, 50.842194 ], [ 61.337424, 50.79907 ], [ 61.588003, 51.272659 ], [ 59.967534, 51.96042 ], [ 60.927269, 52.447548 ], [ 60.739993, 52.719986 ], [ 61.699986, 52.979996 ], [ 60.978066, 53.664993 ], [ 61.436591, 54.006265 ], [ 65.178534, 54.354228 ], [ 65.666876, 54.601267 ], [ 68.1691, 54.970392 ], [ 69.068167, 55.38525 ], [ 70.865267, 55.169734 ], [ 71.180131, 54.133285 ], [ 72.22415, 54.376655 ], [ 73.508516, 54.035617 ], [ 73.425679, 53.48981 ], [ 74.384845, 53.546861 ], [ 76.8911, 54.490524 ], [ 76.525179, 54.177003 ], [ 77.800916, 53.404415 ], [ 80.03556, 50.864751 ], [ 80.568447, 51.388336 ], [ 81.945986, 50.812196 ], [ 83.383004, 51.069183 ], [ 83.935115, 50.889246 ], [ 84.416377, 50.3114 ], [ 85.11556, 50.117303 ], [ 85.54127, 49.692859 ], [ 86.829357, 49.826675 ], [ 87.35997, 49.214981 ], [ 86.598776, 48.549182 ], [ 85.768233, 48.455751 ], [ 85.720484, 47.452969 ], [ 85.16429, 47.000956 ], [ 83.180484, 47.330031 ], [ 82.458926, 45.53965 ], [ 81.947071, 45.317027 ], [ 79.966106, 44.917517 ], [ 80.866206, 43.180362 ], [ 80.18015, 42.920068 ], [ 80.25999, 42.349999 ], [ 79.643645, 42.496683 ], [ 79.142177, 42.856092 ], [ 77.658392, 42.960686 ], [ 76.000354, 42.988022 ], [ 75.636965, 42.8779 ], [ 74.212866, 43.298339 ], [ 73.645304, 43.091272 ], [ 73.489758, 42.500894 ], [ 71.844638, 42.845395 ], [ 71.186281, 42.704293 ], [ 70.962315, 42.266154 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "KEN", "name": "Kenya" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 40.993, -0.85829 ], [ 41.58513, -1.68325 ], [ 40.88477, -2.08255 ], [ 40.63785, -2.49979 ], [ 40.26304, -2.57309 ], [ 40.12119, -3.27768 ], [ 39.80006, -3.68116 ], [ 39.60489, -4.34653 ], [ 39.20222, -4.67677 ], [ 37.7669, -3.67712 ], [ 37.69869, -3.09699 ], [ 34.07262, -1.05982 ], [ 33.903711, -0.95 ], [ 33.893569, 0.109814 ], [ 34.18, 0.515 ], [ 34.6721, 1.17694 ], [ 35.03599, 1.90584 ], [ 34.59607, 3.05374 ], [ 34.47913, 3.5556 ], [ 34.005, 4.249885 ], [ 34.620196, 4.847123 ], [ 35.298007, 5.506 ], [ 35.817448, 5.338232 ], [ 35.817448, 4.776966 ], [ 36.159079, 4.447864 ], [ 36.855093, 4.447864 ], [ 38.120915, 3.598605 ], [ 38.43697, 3.58851 ], [ 38.67114, 3.61607 ], [ 38.89251, 3.50074 ], [ 39.559384, 3.42206 ], [ 39.85494, 3.83879 ], [ 40.76848, 4.25702 ], [ 41.1718, 3.91909 ], [ 41.855083, 3.918912 ], [ 40.98105, 2.78452 ], [ 40.993, -0.85829 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "KGZ", "name": "Kyrgyzstan" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 70.962315, 42.266154 ], [ 71.186281, 42.704293 ], [ 71.844638, 42.845395 ], [ 73.489758, 42.500894 ], [ 73.645304, 43.091272 ], [ 74.212866, 43.298339 ], [ 75.636965, 42.8779 ], [ 76.000354, 42.988022 ], [ 77.658392, 42.960686 ], [ 79.142177, 42.856092 ], [ 79.643645, 42.496683 ], [ 80.25999, 42.349999 ], [ 80.11943, 42.123941 ], [ 78.543661, 41.582243 ], [ 78.187197, 41.185316 ], [ 76.904484, 41.066486 ], [ 76.526368, 40.427946 ], [ 75.467828, 40.562072 ], [ 74.776862, 40.366425 ], [ 73.822244, 39.893973 ], [ 73.960013, 39.660008 ], [ 73.675379, 39.431237 ], [ 71.784694, 39.279463 ], [ 70.549162, 39.604198 ], [ 69.464887, 39.526683 ], [ 69.55961, 40.103211 ], [ 70.648019, 39.935754 ], [ 71.014198, 40.244366 ], [ 71.774875, 40.145844 ], [ 73.055417, 40.866033 ], [ 71.870115, 41.3929 ], [ 71.157859, 41.143587 ], [ 70.420022, 41.519998 ], [ 71.259248, 42.167711 ], [ 70.962315, 42.266154 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "KHM", "name": "Cambodia" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 103.49728, 10.632555 ], [ 103.09069, 11.153661 ], [ 102.584932, 12.186595 ], [ 102.348099, 13.394247 ], [ 102.988422, 14.225721 ], [ 104.281418, 14.416743 ], [ 105.218777, 14.273212 ], [ 106.043946, 13.881091 ], [ 106.496373, 14.570584 ], [ 107.382727, 14.202441 ], [ 107.614548, 13.535531 ], [ 107.491403, 12.337206 ], [ 105.810524, 11.567615 ], [ 106.24967, 10.961812 ], [ 105.199915, 10.88931 ], [ 104.334335, 10.486544 ], [ 103.49728, 10.632555 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "KOR", "name": "South Korea" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 128.349716, 38.612243 ], [ 129.21292, 37.432392 ], [ 129.46045, 36.784189 ], [ 129.468304, 35.632141 ], [ 129.091377, 35.082484 ], [ 128.18585, 34.890377 ], [ 127.386519, 34.475674 ], [ 126.485748, 34.390046 ], [ 126.37392, 34.93456 ], [ 126.559231, 35.684541 ], [ 126.117398, 36.725485 ], [ 126.860143, 36.893924 ], [ 126.174759, 37.749686 ], [ 126.237339, 37.840378 ], [ 126.68372, 37.804773 ], [ 127.073309, 38.256115 ], [ 127.780035, 38.304536 ], [ 128.205746, 38.370397 ], [ 128.349716, 38.612243 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "RKS", "name": "Kosovo" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 20.76216, 42.05186 ], [ 20.71731, 41.84711 ], [ 20.59023, 41.85541 ], [ 20.52295, 42.21787 ], [ 20.28374, 42.32025 ], [ 20.0707, 42.58863 ], [ 20.25758, 42.81275 ], [ 20.49679, 42.88469 ], [ 20.63508, 43.21671 ], [ 20.81448, 43.27205 ], [ 20.95651, 43.13094 ], [ 21.143395, 43.068685 ], [ 21.27421, 42.90959 ], [ 21.43866, 42.86255 ], [ 21.63302, 42.67717 ], [ 21.77505, 42.6827 ], [ 21.66292, 42.43922 ], [ 21.54332, 42.32025 ], [ 21.576636, 42.245224 ], [ 21.3527, 42.2068 ], [ 20.76216, 42.05186 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "KWT", "name": "Kuwait" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 47.974519, 29.975819 ], [ 48.183189, 29.534477 ], [ 48.093943, 29.306299 ], [ 48.416094, 28.552004 ], [ 47.708851, 28.526063 ], [ 47.459822, 29.002519 ], [ 46.568713, 29.099025 ], [ 47.302622, 30.05907 ], [ 47.974519, 29.975819 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "LAO", "name": "Laos" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 105.218777, 14.273212 ], [ 105.544338, 14.723934 ], [ 105.589039, 15.570316 ], [ 104.779321, 16.441865 ], [ 104.716947, 17.428859 ], [ 103.956477, 18.240954 ], [ 103.200192, 18.309632 ], [ 102.998706, 17.961695 ], [ 102.413005, 17.932782 ], [ 102.113592, 18.109102 ], [ 101.059548, 17.512497 ], [ 101.035931, 18.408928 ], [ 101.282015, 19.462585 ], [ 100.606294, 19.508344 ], [ 100.548881, 20.109238 ], [ 100.115988, 20.41785 ], [ 100.329101, 20.786122 ], [ 101.180005, 21.436573 ], [ 101.270026, 21.201652 ], [ 101.80312, 21.174367 ], [ 101.652018, 22.318199 ], [ 102.170436, 22.464753 ], [ 102.754896, 21.675137 ], [ 103.203861, 20.766562 ], [ 104.435, 20.758733 ], [ 104.822574, 19.886642 ], [ 104.183388, 19.624668 ], [ 103.896532, 19.265181 ], [ 105.094598, 18.666975 ], [ 105.925762, 17.485315 ], [ 106.556008, 16.604284 ], [ 107.312706, 15.908538 ], [ 107.564525, 15.202173 ], [ 107.382727, 14.202441 ], [ 106.496373, 14.570584 ], [ 106.043946, 13.881091 ], [ 105.218777, 14.273212 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "LBN", "name": "Lebanon" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 35.821101, 33.277426 ], [ 35.552797, 33.264275 ], [ 35.460709, 33.08904 ], [ 35.126053, 33.0909 ], [ 35.482207, 33.90545 ], [ 35.979592, 34.610058 ], [ 35.998403, 34.644914 ], [ 36.448194, 34.593935 ], [ 36.61175, 34.201789 ], [ 36.06646, 33.824912 ], [ 35.821101, 33.277426 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "LBR", "name": "Liberia" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -7.712159, 4.364566 ], [ -7.974107, 4.355755 ], [ -9.004794, 4.832419 ], [ -9.91342, 5.593561 ], [ -10.765384, 6.140711 ], [ -11.438779, 6.785917 ], [ -11.199802, 7.105846 ], [ -11.146704, 7.396706 ], [ -10.695595, 7.939464 ], [ -10.230094, 8.406206 ], [ -10.016567, 8.428504 ], [ -9.755342, 8.541055 ], [ -9.33728, 7.928534 ], [ -9.403348, 7.526905 ], [ -9.208786, 7.313921 ], [ -8.926065, 7.309037 ], [ -8.722124, 7.711674 ], [ -8.439298, 7.686043 ], [ -8.485446, 7.395208 ], [ -8.385452, 6.911801 ], [ -8.60288, 6.467564 ], [ -8.311348, 6.193033 ], [ -7.993693, 6.12619 ], [ -7.570153, 5.707352 ], [ -7.539715, 5.313345 ], [ -7.635368, 5.188159 ], [ -7.712159, 4.364566 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "LBY", "name": "Libya" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 14.8513, 22.86295 ], [ 14.143871, 22.491289 ], [ 13.581425, 23.040506 ], [ 11.999506, 23.471668 ], [ 11.560669, 24.097909 ], [ 10.771364, 24.562532 ], [ 10.303847, 24.379313 ], [ 9.948261, 24.936954 ], [ 9.910693, 25.365455 ], [ 9.319411, 26.094325 ], [ 9.716286, 26.512206 ], [ 9.629056, 27.140953 ], [ 9.756128, 27.688259 ], [ 9.683885, 28.144174 ], [ 9.859998, 28.95999 ], [ 9.805634, 29.424638 ], [ 9.48214, 30.307556 ], [ 9.970017, 30.539325 ], [ 10.056575, 30.961831 ], [ 9.950225, 31.37607 ], [ 10.636901, 31.761421 ], [ 10.94479, 32.081815 ], [ 11.432253, 32.368903 ], [ 11.488787, 33.136996 ], [ 12.66331, 32.79278 ], [ 13.08326, 32.87882 ], [ 13.91868, 32.71196 ], [ 15.24563, 32.26508 ], [ 15.71394, 31.37626 ], [ 16.61162, 31.18218 ], [ 18.02109, 30.76357 ], [ 19.08641, 30.26639 ], [ 19.57404, 30.52582 ], [ 20.05335, 30.98576 ], [ 19.82033, 31.75179 ], [ 20.13397, 32.2382 ], [ 20.85452, 32.7068 ], [ 21.54298, 32.8432 ], [ 22.89576, 32.63858 ], [ 23.2368, 32.19149 ], [ 23.60913, 32.18726 ], [ 23.9275, 32.01667 ], [ 24.92114, 31.89936 ], [ 25.16482, 31.56915 ], [ 24.80287, 31.08929 ], [ 24.95762, 30.6616 ], [ 24.70007, 30.04419 ], [ 25.0, 29.238655 ], [ 25.0, 25.6825 ], [ 25.0, 22.0 ], [ 25.0, 20.00304 ], [ 23.85, 20.0 ], [ 23.83766, 19.58047 ], [ 19.84926, 21.49509 ], [ 15.86085, 23.40972 ], [ 14.8513, 22.86295 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "LKA", "name": "Sri Lanka" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 81.787959, 7.523055 ], [ 81.637322, 6.481775 ], [ 81.21802, 6.197141 ], [ 80.348357, 5.96837 ], [ 79.872469, 6.763463 ], [ 79.695167, 8.200843 ], [ 80.147801, 9.824078 ], [ 80.838818, 9.268427 ], [ 81.304319, 8.564206 ], [ 81.787959, 7.523055 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "LSO", "name": "Lesotho" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 28.978263, -28.955597 ], [ 29.325166, -29.257387 ], [ 29.018415, -29.743766 ], [ 28.8484, -30.070051 ], [ 28.291069, -30.226217 ], [ 28.107205, -30.545732 ], [ 27.749397, -30.645106 ], [ 26.999262, -29.875954 ], [ 27.532511, -29.242711 ], [ 28.074338, -28.851469 ], [ 28.5417, -28.647502 ], [ 28.978263, -28.955597 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "LTU", "name": "Lithuania" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 22.731099, 54.327537 ], [ 22.651052, 54.582741 ], [ 22.757764, 54.856574 ], [ 22.315724, 55.015299 ], [ 21.268449, 55.190482 ], [ 21.0558, 56.031076 ], [ 22.201157, 56.337802 ], [ 23.878264, 56.273671 ], [ 24.860684, 56.372528 ], [ 25.000934, 56.164531 ], [ 25.533047, 56.100297 ], [ 26.494331, 55.615107 ], [ 26.588279, 55.167176 ], [ 25.768433, 54.846963 ], [ 25.536354, 54.282423 ], [ 24.450684, 53.905702 ], [ 23.484128, 53.912498 ], [ 23.243987, 54.220567 ], [ 22.731099, 54.327537 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "LUX", "name": "Luxembourg" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 6.043073, 50.128052 ], [ 6.242751, 49.902226 ], [ 6.18632, 49.463803 ], [ 5.897759, 49.442667 ], [ 5.674052, 49.529484 ], [ 5.782417, 50.090328 ], [ 6.043073, 50.128052 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "LVA", "name": "Latvia" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 21.0558, 56.031076 ], [ 21.090424, 56.783873 ], [ 21.581866, 57.411871 ], [ 22.524341, 57.753374 ], [ 23.318453, 57.006236 ], [ 24.12073, 57.025693 ], [ 24.312863, 57.793424 ], [ 25.164594, 57.970157 ], [ 25.60281, 57.847529 ], [ 26.463532, 57.476389 ], [ 27.288185, 57.474528 ], [ 27.770016, 57.244258 ], [ 27.855282, 56.759326 ], [ 28.176709, 56.16913 ], [ 27.10246, 55.783314 ], [ 26.494331, 55.615107 ], [ 25.533047, 56.100297 ], [ 25.000934, 56.164531 ], [ 24.860684, 56.372528 ], [ 23.878264, 56.273671 ], [ 22.201157, 56.337802 ], [ 21.0558, 56.031076 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "MAR", "name": "Morocco" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -5.193863, 35.755182 ], [ -4.591006, 35.330712 ], [ -3.640057, 35.399855 ], [ -2.604306, 35.179093 ], [ -2.169914, 35.168396 ], [ -1.792986, 34.527919 ], [ -1.733455, 33.919713 ], [ -1.388049, 32.864015 ], [ -1.124551, 32.651522 ], [ -1.307899, 32.262889 ], [ -2.616605, 32.094346 ], [ -3.06898, 31.724498 ], [ -3.647498, 31.637294 ], [ -3.690441, 30.896952 ], [ -4.859646, 30.501188 ], [ -5.242129, 30.000443 ], [ -6.060632, 29.7317 ], [ -7.059228, 29.579228 ], [ -8.674116, 28.841289 ], [ -8.66559, 27.656426 ], [ -8.817809, 27.656426 ], [ -8.817828, 27.656426 ], [ -8.794884, 27.120696 ], [ -9.413037, 27.088476 ], [ -9.735343, 26.860945 ], [ -10.189424, 26.860945 ], [ -10.551263, 26.990808 ], [ -11.392555, 26.883424 ], [ -11.71822, 26.104092 ], [ -12.030759, 26.030866 ], [ -12.500963, 24.770116 ], [ -13.89111, 23.691009 ], [ -14.221168, 22.310163 ], [ -14.630833, 21.86094 ], [ -14.750955, 21.5006 ], [ -17.002962, 21.420734 ], [ -17.020428, 21.42231 ], [ -16.973248, 21.885745 ], [ -16.589137, 22.158234 ], [ -16.261922, 22.67934 ], [ -16.326414, 23.017768 ], [ -15.982611, 23.723358 ], [ -15.426004, 24.359134 ], [ -15.089332, 24.520261 ], [ -14.824645, 25.103533 ], [ -14.800926, 25.636265 ], [ -14.43994, 26.254418 ], [ -13.773805, 26.618892 ], [ -13.139942, 27.640148 ], [ -13.121613, 27.654148 ], [ -12.618837, 28.038186 ], [ -11.688919, 28.148644 ], [ -10.900957, 28.832142 ], [ -10.399592, 29.098586 ], [ -9.564811, 29.933574 ], [ -9.814718, 31.177736 ], [ -9.434793, 32.038096 ], [ -9.300693, 32.564679 ], [ -8.657476, 33.240245 ], [ -7.654178, 33.697065 ], [ -6.912544, 34.110476 ], [ -6.244342, 35.145865 ], [ -5.929994, 35.759988 ], [ -5.193863, 35.755182 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "MDA", "name": "Moldova" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 26.619337, 48.220726 ], [ 26.857824, 48.368211 ], [ 27.522537, 48.467119 ], [ 28.259547, 48.155562 ], [ 28.670891, 48.118149 ], [ 29.122698, 47.849095 ], [ 29.050868, 47.510227 ], [ 29.415135, 47.346645 ], [ 29.559674, 46.928583 ], [ 29.908852, 46.674361 ], [ 29.83821, 46.525326 ], [ 30.024659, 46.423937 ], [ 29.759972, 46.349988 ], [ 29.170654, 46.379262 ], [ 29.072107, 46.517678 ], [ 28.862972, 46.437889 ], [ 28.933717, 46.25883 ], [ 28.659987, 45.939987 ], [ 28.485269, 45.596907 ], [ 28.233554, 45.488283 ], [ 28.054443, 45.944586 ], [ 28.160018, 46.371563 ], [ 28.12803, 46.810476 ], [ 27.551166, 47.405117 ], [ 27.233873, 47.826771 ], [ 26.924176, 48.123264 ], [ 26.619337, 48.220726 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "MDG", "name": "Madagascar" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 49.543519, -12.469833 ], [ 49.808981, -12.895285 ], [ 50.056511, -13.555761 ], [ 50.217431, -14.758789 ], [ 50.476537, -15.226512 ], [ 50.377111, -15.706069 ], [ 50.200275, -16.000263 ], [ 49.860606, -15.414253 ], [ 49.672607, -15.710204 ], [ 49.863344, -16.451037 ], [ 49.774564, -16.875042 ], [ 49.498612, -17.106036 ], [ 49.435619, -17.953064 ], [ 49.041792, -19.118781 ], [ 48.548541, -20.496888 ], [ 47.930749, -22.391501 ], [ 47.547723, -23.781959 ], [ 47.095761, -24.94163 ], [ 46.282478, -25.178463 ], [ 45.409508, -25.601434 ], [ 44.833574, -25.346101 ], [ 44.03972, -24.988345 ], [ 43.763768, -24.460677 ], [ 43.697778, -23.574116 ], [ 43.345654, -22.776904 ], [ 43.254187, -22.057413 ], [ 43.433298, -21.336475 ], [ 43.893683, -21.163307 ], [ 43.89637, -20.830459 ], [ 44.374325, -20.072366 ], [ 44.464397, -19.435454 ], [ 44.232422, -18.961995 ], [ 44.042976, -18.331387 ], [ 43.963084, -17.409945 ], [ 44.312469, -16.850496 ], [ 44.446517, -16.216219 ], [ 44.944937, -16.179374 ], [ 45.502732, -15.974373 ], [ 45.872994, -15.793454 ], [ 46.312243, -15.780018 ], [ 46.882183, -15.210182 ], [ 47.70513, -14.594303 ], [ 48.005215, -14.091233 ], [ 47.869047, -13.663869 ], [ 48.293828, -13.784068 ], [ 48.84506, -13.089175 ], [ 48.863509, -12.487868 ], [ 49.194651, -12.040557 ], [ 49.543519, -12.469833 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "MEX", "name": "Mexico" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -97.140008, 25.869997 ], [ -97.528072, 24.992144 ], [ -97.702946, 24.272343 ], [ -97.776042, 22.93258 ], [ -97.872367, 22.444212 ], [ -97.699044, 21.898689 ], [ -97.38896, 21.411019 ], [ -97.189333, 20.635433 ], [ -96.525576, 19.890931 ], [ -96.292127, 19.320371 ], [ -95.900885, 18.828024 ], [ -94.839063, 18.562717 ], [ -94.42573, 18.144371 ], [ -93.548651, 18.423837 ], [ -92.786114, 18.524839 ], [ -92.037348, 18.704569 ], [ -91.407903, 18.876083 ], [ -90.77187, 19.28412 ], [ -90.53359, 19.867418 ], [ -90.451476, 20.707522 ], [ -90.278618, 20.999855 ], [ -89.601321, 21.261726 ], [ -88.543866, 21.493675 ], [ -87.658417, 21.458846 ], [ -87.05189, 21.543543 ], [ -86.811982, 21.331515 ], [ -86.845908, 20.849865 ], [ -87.383291, 20.255405 ], [ -87.621054, 19.646553 ], [ -87.43675, 19.472403 ], [ -87.58656, 19.04013 ], [ -87.837191, 18.259816 ], [ -88.090664, 18.516648 ], [ -88.300031, 18.499982 ], [ -88.490123, 18.486831 ], [ -88.848344, 17.883198 ], [ -89.029857, 18.001511 ], [ -89.150909, 17.955468 ], [ -89.14308, 17.808319 ], [ -90.067934, 17.819326 ], [ -91.00152, 17.817595 ], [ -91.002269, 17.254658 ], [ -91.453921, 17.252177 ], [ -91.08167, 16.918477 ], [ -90.711822, 16.687483 ], [ -90.600847, 16.470778 ], [ -90.438867, 16.41011 ], [ -90.464473, 16.069562 ], [ -91.74796, 16.066565 ], [ -92.229249, 15.251447 ], [ -92.087216, 15.064585 ], [ -92.20323, 14.830103 ], [ -92.22775, 14.538829 ], [ -93.359464, 15.61543 ], [ -93.875169, 15.940164 ], [ -94.691656, 16.200975 ], [ -95.250227, 16.128318 ], [ -96.053382, 15.752088 ], [ -96.557434, 15.653515 ], [ -97.263592, 15.917065 ], [ -98.01303, 16.107312 ], [ -98.947676, 16.566043 ], [ -99.697397, 16.706164 ], [ -100.829499, 17.171071 ], [ -101.666089, 17.649026 ], [ -101.918528, 17.91609 ], [ -102.478132, 17.975751 ], [ -103.50099, 18.292295 ], [ -103.917527, 18.748572 ], [ -104.99201, 19.316134 ], [ -105.493038, 19.946767 ], [ -105.731396, 20.434102 ], [ -105.397773, 20.531719 ], [ -105.500661, 20.816895 ], [ -105.270752, 21.076285 ], [ -105.265817, 21.422104 ], [ -105.603161, 21.871146 ], [ -105.693414, 22.26908 ], [ -106.028716, 22.773752 ], [ -106.90998, 23.767774 ], [ -107.915449, 24.548915 ], [ -108.401905, 25.172314 ], [ -109.260199, 25.580609 ], [ -109.444089, 25.824884 ], [ -109.291644, 26.442934 ], [ -109.801458, 26.676176 ], [ -110.391732, 27.162115 ], [ -110.641019, 27.859876 ], [ -111.178919, 27.941241 ], [ -111.759607, 28.467953 ], [ -112.228235, 28.954409 ], [ -112.271824, 29.266844 ], [ -112.809594, 30.021114 ], [ -113.163811, 30.786881 ], [ -113.148669, 31.170966 ], [ -113.871881, 31.567608 ], [ -114.205737, 31.524045 ], [ -114.776451, 31.799532 ], [ -114.9367, 31.393485 ], [ -114.771232, 30.913617 ], [ -114.673899, 30.162681 ], [ -114.330974, 29.750432 ], [ -113.588875, 29.061611 ], [ -113.424053, 28.826174 ], [ -113.271969, 28.754783 ], [ -113.140039, 28.411289 ], [ -112.962298, 28.42519 ], [ -112.761587, 27.780217 ], [ -112.457911, 27.525814 ], [ -112.244952, 27.171727 ], [ -111.616489, 26.662817 ], [ -111.284675, 25.73259 ], [ -110.987819, 25.294606 ], [ -110.710007, 24.826004 ], [ -110.655049, 24.298595 ], [ -110.172856, 24.265548 ], [ -109.771847, 23.811183 ], [ -109.409104, 23.364672 ], [ -109.433392, 23.185588 ], [ -109.854219, 22.818272 ], [ -110.031392, 22.823078 ], [ -110.295071, 23.430973 ], [ -110.949501, 24.000964 ], [ -111.670568, 24.484423 ], [ -112.182036, 24.738413 ], [ -112.148989, 25.470125 ], [ -112.300711, 26.012004 ], [ -112.777297, 26.32196 ], [ -113.464671, 26.768186 ], [ -113.59673, 26.63946 ], [ -113.848937, 26.900064 ], [ -114.465747, 27.14209 ], [ -115.055142, 27.722727 ], [ -114.982253, 27.7982 ], [ -114.570366, 27.741485 ], [ -114.199329, 28.115003 ], [ -114.162018, 28.566112 ], [ -114.931842, 29.279479 ], [ -115.518654, 29.556362 ], [ -115.887365, 30.180794 ], [ -116.25835, 30.836464 ], [ -116.721526, 31.635744 ], [ -117.12776, 32.53534 ], [ -115.99135, 32.61239 ], [ -114.72139, 32.72083 ], [ -114.815, 32.52528 ], [ -113.30498, 32.03914 ], [ -111.02361, 31.33472 ], [ -109.035, 31.34194 ], [ -108.24194, 31.34222 ], [ -108.24, 31.754854 ], [ -106.50759, 31.75452 ], [ -106.1429, 31.39995 ], [ -105.63159, 31.08383 ], [ -105.03737, 30.64402 ], [ -104.70575, 30.12173 ], [ -104.45697, 29.57196 ], [ -103.94, 29.27 ], [ -103.11, 28.97 ], [ -102.48, 29.76 ], [ -101.6624, 29.7793 ], [ -100.9576, 29.38071 ], [ -100.45584, 28.69612 ], [ -100.11, 28.11 ], [ -99.52, 27.54 ], [ -99.3, 26.84 ], [ -99.02, 26.37 ], [ -98.24, 26.06 ], [ -97.53, 25.84 ], [ -97.140008, 25.869997 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "MKD", "name": "Macedonia" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 20.59023, 41.85541 ], [ 20.71731, 41.84711 ], [ 20.76216, 42.05186 ], [ 21.3527, 42.2068 ], [ 21.576636, 42.245224 ], [ 21.91708, 42.30364 ], [ 22.380526, 42.32026 ], [ 22.881374, 41.999297 ], [ 22.952377, 41.337994 ], [ 22.76177, 41.3048 ], [ 22.597308, 41.130487 ], [ 22.055378, 41.149866 ], [ 21.674161, 40.931275 ], [ 21.02004, 40.842727 ], [ 20.60518, 41.08622 ], [ 20.46315, 41.51509 ], [ 20.59023, 41.85541 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "MLI", "name": "Mali" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -12.17075, 14.616834 ], [ -11.834208, 14.799097 ], [ -11.666078, 15.388208 ], [ -11.349095, 15.411256 ], [ -10.650791, 15.132746 ], [ -10.086846, 15.330486 ], [ -9.700255, 15.264107 ], [ -9.550238, 15.486497 ], [ -5.537744, 15.50169 ], [ -5.315277, 16.201854 ], [ -5.488523, 16.325102 ], [ -5.971129, 20.640833 ], [ -6.453787, 24.956591 ], [ -4.923337, 24.974574 ], [ -1.550055, 22.792666 ], [ 1.823228, 20.610809 ], [ 2.060991, 20.142233 ], [ 2.683588, 19.85623 ], [ 3.146661, 19.693579 ], [ 3.158133, 19.057364 ], [ 4.267419, 19.155265 ], [ 4.27021, 16.852227 ], [ 3.723422, 16.184284 ], [ 3.638259, 15.56812 ], [ 2.749993, 15.409525 ], [ 1.385528, 15.323561 ], [ 1.015783, 14.968182 ], [ 0.374892, 14.928908 ], [ -0.266257, 14.924309 ], [ -0.515854, 15.116158 ], [ -1.066363, 14.973815 ], [ -2.001035, 14.559008 ], [ -2.191825, 14.246418 ], [ -2.967694, 13.79815 ], [ -3.103707, 13.541267 ], [ -3.522803, 13.337662 ], [ -4.006391, 13.472485 ], [ -4.280405, 13.228444 ], [ -4.427166, 12.542646 ], [ -5.220942, 11.713859 ], [ -5.197843, 11.375146 ], [ -5.470565, 10.95127 ], [ -5.404342, 10.370737 ], [ -5.816926, 10.222555 ], [ -6.050452, 10.096361 ], [ -6.205223, 10.524061 ], [ -6.493965, 10.411303 ], [ -6.666461, 10.430811 ], [ -6.850507, 10.138994 ], [ -7.622759, 10.147236 ], [ -7.89959, 10.297382 ], [ -8.029944, 10.206535 ], [ -8.335377, 10.494812 ], [ -8.282357, 10.792597 ], [ -8.407311, 10.909257 ], [ -8.620321, 10.810891 ], [ -8.581305, 11.136246 ], [ -8.376305, 11.393646 ], [ -8.786099, 11.812561 ], [ -8.905265, 12.088358 ], [ -9.127474, 12.30806 ], [ -9.327616, 12.334286 ], [ -9.567912, 12.194243 ], [ -9.890993, 12.060479 ], [ -10.165214, 11.844084 ], [ -10.593224, 11.923975 ], [ -10.87083, 12.177887 ], [ -11.036556, 12.211245 ], [ -11.297574, 12.077971 ], [ -11.456169, 12.076834 ], [ -11.513943, 12.442988 ], [ -11.467899, 12.754519 ], [ -11.553398, 13.141214 ], [ -11.927716, 13.422075 ], [ -12.124887, 13.994727 ], [ -12.17075, 14.616834 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "MLT", "name": "Malta" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 14.566171, 35.852721 ], [ 14.532684, 35.820191 ], [ 14.436463, 35.821664 ], [ 14.352334, 35.872281 ], [ 14.3513, 35.978399 ], [ 14.448348, 35.957444 ], [ 14.537025, 35.886285 ], [ 14.566171, 35.852721 ] ] ], [ [ [ 14.313473, 36.027569 ], [ 14.253632, 36.012143 ], [ 14.194204, 36.042245 ], [ 14.180354, 36.060383 ], [ 14.263243, 36.075809 ], [ 14.303758, 36.062295 ], [ 14.320914, 36.03625 ], [ 14.313473, 36.027569 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "MMR", "name": "Myanmar" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 99.543309, 20.186598 ], [ 98.959676, 19.752981 ], [ 98.253724, 19.708203 ], [ 97.797783, 18.62708 ], [ 97.375896, 18.445438 ], [ 97.859123, 17.567946 ], [ 98.493761, 16.837836 ], [ 98.903348, 16.177824 ], [ 98.537376, 15.308497 ], [ 98.192074, 15.123703 ], [ 98.430819, 14.622028 ], [ 99.097755, 13.827503 ], [ 99.212012, 13.269294 ], [ 99.196354, 12.804748 ], [ 99.587286, 11.892763 ], [ 99.038121, 10.960546 ], [ 98.553551, 9.93296 ], [ 98.457174, 10.675266 ], [ 98.764546, 11.441292 ], [ 98.428339, 12.032987 ], [ 98.509574, 13.122378 ], [ 98.103604, 13.64046 ], [ 97.777732, 14.837286 ], [ 97.597072, 16.100568 ], [ 97.16454, 16.928734 ], [ 96.505769, 16.427241 ], [ 95.369352, 15.71439 ], [ 94.808405, 15.803454 ], [ 94.188804, 16.037936 ], [ 94.533486, 17.27724 ], [ 94.324817, 18.213514 ], [ 93.540988, 19.366493 ], [ 93.663255, 19.726962 ], [ 93.078278, 19.855145 ], [ 92.368554, 20.670883 ], [ 92.303234, 21.475485 ], [ 92.652257, 21.324048 ], [ 92.672721, 22.041239 ], [ 93.166128, 22.27846 ], [ 93.060294, 22.703111 ], [ 93.286327, 23.043658 ], [ 93.325188, 24.078556 ], [ 94.106742, 23.850741 ], [ 94.552658, 24.675238 ], [ 94.603249, 25.162495 ], [ 95.155153, 26.001307 ], [ 95.124768, 26.573572 ], [ 96.419366, 27.264589 ], [ 97.133999, 27.083774 ], [ 97.051989, 27.699059 ], [ 97.402561, 27.882536 ], [ 97.327114, 28.261583 ], [ 97.911988, 28.335945 ], [ 98.246231, 27.747221 ], [ 98.68269, 27.508812 ], [ 98.712094, 26.743536 ], [ 98.671838, 25.918703 ], [ 97.724609, 25.083637 ], [ 97.60472, 23.897405 ], [ 98.660262, 24.063286 ], [ 98.898749, 23.142722 ], [ 99.531992, 22.949039 ], [ 99.240899, 22.118314 ], [ 99.983489, 21.742937 ], [ 100.416538, 21.558839 ], [ 101.150033, 21.849984 ], [ 101.180005, 21.436573 ], [ 100.329101, 20.786122 ], [ 100.115988, 20.41785 ], [ 99.543309, 20.186598 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "MNE", "name": "Montenegro" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 19.801613, 42.500093 ], [ 19.738051, 42.688247 ], [ 19.30449, 42.19574 ], [ 19.37177, 41.87755 ], [ 19.16246, 41.95502 ], [ 18.88214, 42.28151 ], [ 18.45, 42.48 ], [ 18.56, 42.65 ], [ 18.70648, 43.20011 ], [ 19.03165, 43.43253 ], [ 19.21852, 43.52384 ], [ 19.48389, 43.35229 ], [ 19.63, 43.21378 ], [ 19.95857, 43.10604 ], [ 20.3398, 42.89852 ], [ 20.25758, 42.81275 ], [ 20.0707, 42.58863 ], [ 19.801613, 42.500093 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "MNG", "name": "Mongolia" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 87.751264, 49.297198 ], [ 88.805567, 49.470521 ], [ 90.713667, 50.331812 ], [ 92.234712, 50.802171 ], [ 93.104219, 50.49529 ], [ 94.147566, 50.480537 ], [ 94.815949, 50.013433 ], [ 95.814028, 49.977467 ], [ 97.259728, 49.726061 ], [ 98.231762, 50.422401 ], [ 97.82574, 51.010995 ], [ 98.861491, 52.047366 ], [ 99.981732, 51.634006 ], [ 100.88948, 51.516856 ], [ 102.065223, 51.259921 ], [ 102.255909, 50.510561 ], [ 103.676545, 50.089966 ], [ 104.621552, 50.275329 ], [ 105.886591, 50.406019 ], [ 106.888804, 50.274296 ], [ 107.868176, 49.793705 ], [ 108.475167, 49.282548 ], [ 109.402449, 49.292961 ], [ 110.662011, 49.130128 ], [ 111.581231, 49.377968 ], [ 112.89774, 49.543565 ], [ 114.362456, 50.248303 ], [ 114.96211, 50.140247 ], [ 115.485695, 49.805177 ], [ 116.678801, 49.888531 ], [ 116.191802, 49.134598 ], [ 115.485282, 48.135383 ], [ 115.742837, 47.726545 ], [ 116.308953, 47.85341 ], [ 117.295507, 47.697709 ], [ 118.064143, 48.06673 ], [ 118.866574, 47.74706 ], [ 119.772824, 47.048059 ], [ 119.66327, 46.69268 ], [ 118.874326, 46.805412 ], [ 117.421701, 46.672733 ], [ 116.717868, 46.388202 ], [ 115.985096, 45.727235 ], [ 114.460332, 45.339817 ], [ 113.463907, 44.808893 ], [ 112.436062, 45.011646 ], [ 111.873306, 45.102079 ], [ 111.348377, 44.457442 ], [ 111.667737, 44.073176 ], [ 111.829588, 43.743118 ], [ 111.129682, 43.406834 ], [ 110.412103, 42.871234 ], [ 109.243596, 42.519446 ], [ 107.744773, 42.481516 ], [ 106.129316, 42.134328 ], [ 104.964994, 41.59741 ], [ 104.522282, 41.908347 ], [ 103.312278, 41.907468 ], [ 101.83304, 42.514873 ], [ 100.845866, 42.663804 ], [ 99.515817, 42.524691 ], [ 97.451757, 42.74889 ], [ 96.349396, 42.725635 ], [ 95.762455, 43.319449 ], [ 95.306875, 44.241331 ], [ 94.688929, 44.352332 ], [ 93.480734, 44.975472 ], [ 92.133891, 45.115076 ], [ 90.94554, 45.286073 ], [ 90.585768, 45.719716 ], [ 90.970809, 46.888146 ], [ 90.280826, 47.693549 ], [ 88.854298, 48.069082 ], [ 88.013832, 48.599463 ], [ 87.751264, 49.297198 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "MOZ", "name": "Mozambique" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 34.559989, -11.52002 ], [ 35.312398, -11.439146 ], [ 36.514082, -11.720938 ], [ 36.775151, -11.594537 ], [ 37.471284, -11.568751 ], [ 37.827645, -11.268769 ], [ 38.427557, -11.285202 ], [ 39.52103, -10.896854 ], [ 40.316589, -10.317096 ], [ 40.478387, -10.765441 ], [ 40.437253, -11.761711 ], [ 40.560811, -12.639177 ], [ 40.59962, -14.201975 ], [ 40.775475, -14.691764 ], [ 40.477251, -15.406294 ], [ 40.089264, -16.100774 ], [ 39.452559, -16.720891 ], [ 38.538351, -17.101023 ], [ 37.411133, -17.586368 ], [ 36.281279, -18.659688 ], [ 35.896497, -18.84226 ], [ 35.1984, -19.552811 ], [ 34.786383, -19.784012 ], [ 34.701893, -20.497043 ], [ 35.176127, -21.254361 ], [ 35.373428, -21.840837 ], [ 35.385848, -22.14 ], [ 35.562546, -22.09 ], [ 35.533935, -23.070788 ], [ 35.371774, -23.535359 ], [ 35.60747, -23.706563 ], [ 35.458746, -24.12261 ], [ 35.040735, -24.478351 ], [ 34.215824, -24.816314 ], [ 33.01321, -25.357573 ], [ 32.574632, -25.727318 ], [ 32.660363, -26.148584 ], [ 32.915955, -26.215867 ], [ 32.83012, -26.742192 ], [ 32.071665, -26.73382 ], [ 31.985779, -26.29178 ], [ 31.837778, -25.843332 ], [ 31.752408, -25.484284 ], [ 31.930589, -24.369417 ], [ 31.670398, -23.658969 ], [ 31.191409, -22.25151 ], [ 32.244988, -21.116489 ], [ 32.508693, -20.395292 ], [ 32.659743, -20.30429 ], [ 32.772708, -19.715592 ], [ 32.611994, -19.419383 ], [ 32.654886, -18.67209 ], [ 32.849861, -17.979057 ], [ 32.847639, -16.713398 ], [ 32.328239, -16.392074 ], [ 31.852041, -16.319417 ], [ 31.636498, -16.07199 ], [ 31.173064, -15.860944 ], [ 30.338955, -15.880839 ], [ 30.274256, -15.507787 ], [ 30.179481, -14.796099 ], [ 33.214025, -13.97186 ], [ 33.7897, -14.451831 ], [ 34.064825, -14.35995 ], [ 34.459633, -14.61301 ], [ 34.517666, -15.013709 ], [ 34.307291, -15.478641 ], [ 34.381292, -16.18356 ], [ 35.03381, -16.8013 ], [ 35.339063, -16.10744 ], [ 35.771905, -15.896859 ], [ 35.686845, -14.611046 ], [ 35.267956, -13.887834 ], [ 34.907151, -13.565425 ], [ 34.559989, -13.579998 ], [ 34.280006, -12.280025 ], [ 34.559989, -11.52002 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "MRT", "name": "Mauritania" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -12.17075, 14.616834 ], [ -12.830658, 15.303692 ], [ -13.435738, 16.039383 ], [ -14.099521, 16.304302 ], [ -14.577348, 16.598264 ], [ -15.135737, 16.587282 ], [ -15.623666, 16.369337 ], [ -16.12069, 16.455663 ], [ -16.463098, 16.135036 ], [ -16.549708, 16.673892 ], [ -16.270552, 17.166963 ], [ -16.146347, 18.108482 ], [ -16.256883, 19.096716 ], [ -16.377651, 19.593817 ], [ -16.277838, 20.092521 ], [ -16.536324, 20.567866 ], [ -17.063423, 20.999752 ], [ -16.845194, 21.333323 ], [ -12.929102, 21.327071 ], [ -13.118754, 22.77122 ], [ -12.874222, 23.284832 ], [ -11.937224, 23.374594 ], [ -11.969419, 25.933353 ], [ -8.687294, 25.881056 ], [ -8.6844, 27.395744 ], [ -4.923337, 24.974574 ], [ -6.453787, 24.956591 ], [ -5.971129, 20.640833 ], [ -5.488523, 16.325102 ], [ -5.315277, 16.201854 ], [ -5.537744, 15.50169 ], [ -9.550238, 15.486497 ], [ -9.700255, 15.264107 ], [ -10.086846, 15.330486 ], [ -10.650791, 15.132746 ], [ -11.349095, 15.411256 ], [ -11.666078, 15.388208 ], [ -11.834208, 14.799097 ], [ -12.17075, 14.616834 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "MWI", "name": "Malawi" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 34.559989, -11.52002 ], [ 34.280006, -12.280025 ], [ 34.559989, -13.579998 ], [ 34.907151, -13.565425 ], [ 35.267956, -13.887834 ], [ 35.686845, -14.611046 ], [ 35.771905, -15.896859 ], [ 35.339063, -16.10744 ], [ 35.03381, -16.8013 ], [ 34.381292, -16.18356 ], [ 34.307291, -15.478641 ], [ 34.517666, -15.013709 ], [ 34.459633, -14.61301 ], [ 34.064825, -14.35995 ], [ 33.7897, -14.451831 ], [ 33.214025, -13.97186 ], [ 32.688165, -13.712858 ], [ 32.991764, -12.783871 ], [ 33.306422, -12.435778 ], [ 33.114289, -11.607198 ], [ 33.31531, -10.79655 ], [ 33.485688, -10.525559 ], [ 33.231388, -9.676722 ], [ 32.759375, -9.230599 ], [ 33.739729, -9.417151 ], [ 33.940838, -9.693674 ], [ 34.280006, -10.16 ], [ 34.559989, -11.52002 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "SGP", "name": "Singapore" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 103.522560880303885, 1.226602499078547 ], [ 103.699852540904047, 1.486945065925548 ], [ 104.04066100602536, 1.50624090772953 ], [ 104.139285201625285, 1.284625224056316 ], [ 103.522560880303885, 1.226602499078547 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "NAM", "name": "Namibia" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 16.344977, -28.576705 ], [ 15.601818, -27.821247 ], [ 15.210472, -27.090956 ], [ 14.989711, -26.117372 ], [ 14.743214, -25.39292 ], [ 14.408144, -23.853014 ], [ 14.385717, -22.656653 ], [ 14.257714, -22.111208 ], [ 13.868642, -21.699037 ], [ 13.352498, -20.872834 ], [ 12.826845, -19.673166 ], [ 12.608564, -19.045349 ], [ 11.794919, -18.069129 ], [ 11.734199, -17.301889 ], [ 12.215461, -17.111668 ], [ 12.814081, -16.941343 ], [ 13.462362, -16.971212 ], [ 14.058501, -17.423381 ], [ 14.209707, -17.353101 ], [ 18.263309, -17.309951 ], [ 18.956187, -17.789095 ], [ 21.377176, -17.930636 ], [ 23.215048, -17.523116 ], [ 24.033862, -17.295843 ], [ 24.682349, -17.353411 ], [ 25.07695, -17.578823 ], [ 25.084443, -17.661816 ], [ 24.520705, -17.887125 ], [ 24.217365, -17.889347 ], [ 23.579006, -18.281261 ], [ 23.196858, -17.869038 ], [ 21.65504, -18.219146 ], [ 20.910641, -18.252219 ], [ 20.881134, -21.814327 ], [ 19.895458, -21.849157 ], [ 19.895768, -24.76779 ], [ 19.894734, -28.461105 ], [ 19.002127, -28.972443 ], [ 18.464899, -29.045462 ], [ 17.836152, -28.856378 ], [ 17.387497, -28.783514 ], [ 17.218929, -28.355943 ], [ 16.824017, -28.082162 ], [ 16.344977, -28.576705 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "NCL", "name": "New Caledonia" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 165.77999, -21.080005 ], [ 166.599991, -21.700019 ], [ 167.120011, -22.159991 ], [ 166.740035, -22.399976 ], [ 166.189732, -22.129708 ], [ 165.474375, -21.679607 ], [ 164.829815, -21.14982 ], [ 164.167995, -20.444747 ], [ 164.029606, -20.105646 ], [ 164.459967, -20.120012 ], [ 165.020036, -20.459991 ], [ 165.460009, -20.800022 ], [ 165.77999, -21.080005 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "NER", "name": "Niger" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 2.154474, 11.94015 ], [ 2.177108, 12.625018 ], [ 1.024103, 12.851826 ], [ 0.993046, 13.33575 ], [ 0.429928, 13.988733 ], [ 0.295646, 14.444235 ], [ 0.374892, 14.928908 ], [ 1.015783, 14.968182 ], [ 1.385528, 15.323561 ], [ 2.749993, 15.409525 ], [ 3.638259, 15.56812 ], [ 3.723422, 16.184284 ], [ 4.27021, 16.852227 ], [ 4.267419, 19.155265 ], [ 5.677566, 19.601207 ], [ 8.572893, 21.565661 ], [ 11.999506, 23.471668 ], [ 13.581425, 23.040506 ], [ 14.143871, 22.491289 ], [ 14.8513, 22.86295 ], [ 15.096888, 21.308519 ], [ 15.471077, 21.048457 ], [ 15.487148, 20.730415 ], [ 15.903247, 20.387619 ], [ 15.685741, 19.95718 ], [ 15.300441, 17.92795 ], [ 15.247731, 16.627306 ], [ 13.972202, 15.684366 ], [ 13.540394, 14.367134 ], [ 13.956699, 13.996691 ], [ 13.954477, 13.353449 ], [ 14.595781, 13.330427 ], [ 14.495787, 12.859396 ], [ 14.213531, 12.802035 ], [ 14.181336, 12.483657 ], [ 13.995353, 12.461565 ], [ 13.318702, 13.556356 ], [ 13.083987, 13.596147 ], [ 12.302071, 13.037189 ], [ 11.527803, 13.32898 ], [ 10.989593, 13.387323 ], [ 10.701032, 13.246918 ], [ 10.114814, 13.277252 ], [ 9.524928, 12.851102 ], [ 9.014933, 12.826659 ], [ 7.804671, 13.343527 ], [ 7.330747, 13.098038 ], [ 6.820442, 13.115091 ], [ 6.445426, 13.492768 ], [ 5.443058, 13.865924 ], [ 4.368344, 13.747482 ], [ 4.107946, 13.531216 ], [ 3.967283, 12.956109 ], [ 3.680634, 12.552903 ], [ 3.61118, 11.660167 ], [ 2.848643, 12.235636 ], [ 2.490164, 12.233052 ], [ 2.154474, 11.94015 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "NGA", "name": "Nigeria" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 8.500288, 4.771983 ], [ 7.462108, 4.412108 ], [ 7.082596, 4.464689 ], [ 6.698072, 4.240594 ], [ 5.898173, 4.262453 ], [ 5.362805, 4.887971 ], [ 5.033574, 5.611802 ], [ 4.325607, 6.270651 ], [ 3.57418, 6.2583 ], [ 2.691702, 6.258817 ], [ 2.749063, 7.870734 ], [ 2.723793, 8.506845 ], [ 2.912308, 9.137608 ], [ 3.220352, 9.444153 ], [ 3.705438, 10.06321 ], [ 3.60007, 10.332186 ], [ 3.797112, 10.734746 ], [ 3.572216, 11.327939 ], [ 3.61118, 11.660167 ], [ 3.680634, 12.552903 ], [ 3.967283, 12.956109 ], [ 4.107946, 13.531216 ], [ 4.368344, 13.747482 ], [ 5.443058, 13.865924 ], [ 6.445426, 13.492768 ], [ 6.820442, 13.115091 ], [ 7.330747, 13.098038 ], [ 7.804671, 13.343527 ], [ 9.014933, 12.826659 ], [ 9.524928, 12.851102 ], [ 10.114814, 13.277252 ], [ 10.701032, 13.246918 ], [ 10.989593, 13.387323 ], [ 11.527803, 13.32898 ], [ 12.302071, 13.037189 ], [ 13.083987, 13.596147 ], [ 13.318702, 13.556356 ], [ 13.995353, 12.461565 ], [ 14.181336, 12.483657 ], [ 14.577178, 12.085361 ], [ 14.468192, 11.904752 ], [ 14.415379, 11.572369 ], [ 13.57295, 10.798566 ], [ 13.308676, 10.160362 ], [ 13.1676, 9.640626 ], [ 12.955468, 9.417772 ], [ 12.753672, 8.717763 ], [ 12.218872, 8.305824 ], [ 12.063946, 7.799808 ], [ 11.839309, 7.397042 ], [ 11.745774, 6.981383 ], [ 11.058788, 6.644427 ], [ 10.497375, 7.055358 ], [ 10.118277, 7.03877 ], [ 9.522706, 6.453482 ], [ 9.233163, 6.444491 ], [ 8.757533, 5.479666 ], [ 8.500288, 4.771983 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "NIC", "name": "Nicaragua" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -85.71254, 11.088445 ], [ -86.058488, 11.403439 ], [ -86.52585, 11.806877 ], [ -86.745992, 12.143962 ], [ -87.167516, 12.458258 ], [ -87.668493, 12.90991 ], [ -87.557467, 13.064552 ], [ -87.392386, 12.914018 ], [ -87.316654, 12.984686 ], [ -87.005769, 13.025794 ], [ -86.880557, 13.254204 ], [ -86.733822, 13.263093 ], [ -86.755087, 13.754845 ], [ -86.520708, 13.778487 ], [ -86.312142, 13.771356 ], [ -86.096264, 14.038187 ], [ -85.801295, 13.836055 ], [ -85.698665, 13.960078 ], [ -85.514413, 14.079012 ], [ -85.165365, 14.35437 ], [ -85.148751, 14.560197 ], [ -85.052787, 14.551541 ], [ -84.924501, 14.790493 ], [ -84.820037, 14.819587 ], [ -84.649582, 14.666805 ], [ -84.449336, 14.621614 ], [ -84.228342, 14.748764 ], [ -83.975721, 14.749436 ], [ -83.628585, 14.880074 ], [ -83.489989, 15.016267 ], [ -83.147219, 14.995829 ], [ -83.233234, 14.899866 ], [ -83.284162, 14.676624 ], [ -83.182126, 14.310703 ], [ -83.4125, 13.970078 ], [ -83.519832, 13.567699 ], [ -83.552207, 13.127054 ], [ -83.498515, 12.869292 ], [ -83.473323, 12.419087 ], [ -83.626104, 12.32085 ], [ -83.719613, 11.893124 ], [ -83.650858, 11.629032 ], [ -83.85547, 11.373311 ], [ -83.808936, 11.103044 ], [ -83.655612, 10.938764 ], [ -83.895054, 10.726839 ], [ -84.190179, 10.79345 ], [ -84.355931, 10.999226 ], [ -84.673069, 11.082657 ], [ -84.903003, 10.952303 ], [ -85.561852, 11.217119 ], [ -85.71254, 11.088445 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "NLD", "name": "Netherlands" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 6.074183, 53.510403 ], [ 6.90514, 53.482162 ], [ 7.092053, 53.144043 ], [ 6.84287, 52.22844 ], [ 6.589397, 51.852029 ], [ 5.988658, 51.851616 ], [ 6.156658, 50.803721 ], [ 5.606976, 51.037298 ], [ 4.973991, 51.475024 ], [ 4.047071, 51.267259 ], [ 3.314971, 51.345755 ], [ 3.830289, 51.620545 ], [ 4.705997, 53.091798 ], [ 6.074183, 53.510403 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "NOR", "name": "Norway" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 28.165547, 71.185474 ], [ 31.293418, 70.453788 ], [ 30.005435, 70.186259 ], [ 31.101079, 69.55808 ], [ 29.399581, 69.156916 ], [ 28.59193, 69.064777 ], [ 29.015573, 69.766491 ], [ 27.732292, 70.164193 ], [ 26.179622, 69.825299 ], [ 25.689213, 69.092114 ], [ 24.735679, 68.649557 ], [ 23.66205, 68.891247 ], [ 22.356238, 68.841741 ], [ 21.244936, 69.370443 ], [ 20.645593, 69.106247 ], [ 20.025269, 69.065139 ], [ 19.87856, 68.407194 ], [ 17.993868, 68.567391 ], [ 17.729182, 68.010552 ], [ 16.768879, 68.013937 ], [ 16.108712, 67.302456 ], [ 15.108411, 66.193867 ], [ 13.55569, 64.787028 ], [ 13.919905, 64.445421 ], [ 13.571916, 64.049114 ], [ 12.579935, 64.066219 ], [ 11.930569, 63.128318 ], [ 11.992064, 61.800362 ], [ 12.631147, 61.293572 ], [ 12.300366, 60.117933 ], [ 11.468272, 59.432393 ], [ 11.027369, 58.856149 ], [ 10.356557, 59.469807 ], [ 8.382, 58.313288 ], [ 7.048748, 58.078884 ], [ 5.665835, 58.588155 ], [ 5.308234, 59.663232 ], [ 4.992078, 61.970998 ], [ 5.9129, 62.614473 ], [ 8.553411, 63.454008 ], [ 10.527709, 64.486038 ], [ 12.358347, 65.879726 ], [ 14.761146, 67.810642 ], [ 16.435927, 68.563205 ], [ 19.184028, 69.817444 ], [ 21.378416, 70.255169 ], [ 23.023742, 70.202072 ], [ 24.546543, 71.030497 ], [ 26.37005, 70.986262 ], [ 28.165547, 71.185474 ] ] ], [ [ [ 24.72412, 77.85385 ], [ 22.49032, 77.44493 ], [ 20.72601, 77.67704 ], [ 21.41611, 77.93504 ], [ 20.8119, 78.25463 ], [ 22.88426, 78.45494 ], [ 23.28134, 78.07954 ], [ 24.72412, 77.85385 ] ] ], [ [ [ 18.25183, 79.70175 ], [ 21.54383, 78.95611 ], [ 19.02737, 78.5626 ], [ 18.47172, 77.82669 ], [ 17.59441, 77.63796 ], [ 17.1182, 76.80941 ], [ 15.91315, 76.77045 ], [ 13.76259, 77.38035 ], [ 14.66956, 77.73565 ], [ 13.1706, 78.02493 ], [ 11.22231, 78.8693 ], [ 10.44453, 79.65239 ], [ 13.17077, 80.01046 ], [ 13.71852, 79.66039 ], [ 15.14282, 79.67431 ], [ 15.52255, 80.01608 ], [ 16.99085, 80.05086 ], [ 18.25183, 79.70175 ] ] ], [ [ [ 25.447625, 80.40734 ], [ 27.407506, 80.056406 ], [ 25.924651, 79.517834 ], [ 23.024466, 79.400012 ], [ 20.075188, 79.566823 ], [ 19.897266, 79.842362 ], [ 18.462264, 79.85988 ], [ 17.368015, 80.318896 ], [ 20.455992, 80.598156 ], [ 21.907945, 80.357679 ], [ 22.919253, 80.657144 ], [ 25.447625, 80.40734 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "NPL", "name": "Nepal" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 88.120441, 27.876542 ], [ 88.043133, 27.445819 ], [ 88.174804, 26.810405 ], [ 88.060238, 26.414615 ], [ 87.227472, 26.397898 ], [ 86.024393, 26.630985 ], [ 85.251779, 26.726198 ], [ 84.675018, 27.234901 ], [ 83.304249, 27.364506 ], [ 81.999987, 27.925479 ], [ 81.057203, 28.416095 ], [ 80.088425, 28.79447 ], [ 80.476721, 29.729865 ], [ 81.111256, 30.183481 ], [ 81.525804, 30.422717 ], [ 82.327513, 30.115268 ], [ 83.337115, 29.463732 ], [ 83.898993, 29.320226 ], [ 84.23458, 28.839894 ], [ 85.011638, 28.642774 ], [ 85.82332, 28.203576 ], [ 86.954517, 27.974262 ], [ 88.120441, 27.876542 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "NZL", "name": "New Zealand" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 173.020375, -40.919052 ], [ 173.247234, -41.331999 ], [ 173.958405, -40.926701 ], [ 174.247587, -41.349155 ], [ 174.248517, -41.770008 ], [ 173.876447, -42.233184 ], [ 173.22274, -42.970038 ], [ 172.711246, -43.372288 ], [ 173.080113, -43.853344 ], [ 172.308584, -43.865694 ], [ 171.452925, -44.242519 ], [ 171.185138, -44.897104 ], [ 170.616697, -45.908929 ], [ 169.831422, -46.355775 ], [ 169.332331, -46.641235 ], [ 168.411354, -46.619945 ], [ 167.763745, -46.290197 ], [ 166.676886, -46.219917 ], [ 166.509144, -45.852705 ], [ 167.046424, -45.110941 ], [ 168.303763, -44.123973 ], [ 168.949409, -43.935819 ], [ 169.667815, -43.555326 ], [ 170.52492, -43.031688 ], [ 171.12509, -42.512754 ], [ 171.569714, -41.767424 ], [ 171.948709, -41.514417 ], [ 172.097227, -40.956104 ], [ 172.79858, -40.493962 ], [ 173.020375, -40.919052 ] ] ], [ [ [ 174.612009, -36.156397 ], [ 175.336616, -37.209098 ], [ 175.357596, -36.526194 ], [ 175.808887, -36.798942 ], [ 175.95849, -37.555382 ], [ 176.763195, -37.881253 ], [ 177.438813, -37.961248 ], [ 178.010354, -37.579825 ], [ 178.517094, -37.695373 ], [ 178.274731, -38.582813 ], [ 177.97046, -39.166343 ], [ 177.206993, -39.145776 ], [ 176.939981, -39.449736 ], [ 177.032946, -39.879943 ], [ 176.885824, -40.065978 ], [ 176.508017, -40.604808 ], [ 176.01244, -41.289624 ], [ 175.239567, -41.688308 ], [ 175.067898, -41.425895 ], [ 174.650973, -41.281821 ], [ 175.22763, -40.459236 ], [ 174.900157, -39.908933 ], [ 173.824047, -39.508854 ], [ 173.852262, -39.146602 ], [ 174.574802, -38.797683 ], [ 174.743474, -38.027808 ], [ 174.697017, -37.381129 ], [ 174.292028, -36.711092 ], [ 174.319004, -36.534824 ], [ 173.840997, -36.121981 ], [ 173.054171, -35.237125 ], [ 172.636005, -34.529107 ], [ 173.007042, -34.450662 ], [ 173.551298, -35.006183 ], [ 174.32939, -35.265496 ], [ 174.612009, -36.156397 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "OMN", "name": "Oman" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 58.861141, 21.114035 ], [ 58.487986, 20.428986 ], [ 58.034318, 20.481437 ], [ 57.826373, 20.243002 ], [ 57.665762, 19.736005 ], [ 57.7887, 19.06757 ], [ 57.694391, 18.94471 ], [ 57.234264, 18.947991 ], [ 56.609651, 18.574267 ], [ 56.512189, 18.087113 ], [ 56.283521, 17.876067 ], [ 55.661492, 17.884128 ], [ 55.269939, 17.632309 ], [ 55.2749, 17.228354 ], [ 54.791002, 16.950697 ], [ 54.239253, 17.044981 ], [ 53.570508, 16.707663 ], [ 53.108573, 16.651051 ], [ 52.782184, 17.349742 ], [ 52.00001, 19.000003 ], [ 54.999982, 19.999994 ], [ 55.666659, 22.000001 ], [ 55.208341, 22.70833 ], [ 55.234489, 23.110993 ], [ 55.525841, 23.524869 ], [ 55.528632, 23.933604 ], [ 55.981214, 24.130543 ], [ 55.804119, 24.269604 ], [ 55.886233, 24.920831 ], [ 56.396847, 24.924732 ], [ 56.84514, 24.241673 ], [ 57.403453, 23.878594 ], [ 58.136948, 23.747931 ], [ 58.729211, 23.565668 ], [ 59.180502, 22.992395 ], [ 59.450098, 22.660271 ], [ 59.80806, 22.533612 ], [ 59.806148, 22.310525 ], [ 59.442191, 21.714541 ], [ 59.282408, 21.433886 ], [ 58.861141, 21.114035 ] ] ], [ [ [ 56.391421, 25.895991 ], [ 56.261042, 25.714606 ], [ 56.070821, 26.055464 ], [ 56.362017, 26.395934 ], [ 56.485679, 26.309118 ], [ 56.391421, 25.895991 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "PAK", "name": "Pakistan" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 75.158028, 37.133031 ], [ 75.896897, 36.666806 ], [ 76.192848, 35.898403 ], [ 77.837451, 35.49401 ], [ 76.871722, 34.653544 ], [ 75.757061, 34.504923 ], [ 74.240203, 34.748887 ], [ 73.749948, 34.317699 ], [ 74.104294, 33.441473 ], [ 74.451559, 32.7649 ], [ 75.258642, 32.271105 ], [ 74.405929, 31.692639 ], [ 74.42138, 30.979815 ], [ 73.450638, 29.976413 ], [ 72.823752, 28.961592 ], [ 71.777666, 27.91318 ], [ 70.616496, 27.989196 ], [ 69.514393, 26.940966 ], [ 70.168927, 26.491872 ], [ 70.282873, 25.722229 ], [ 70.844699, 25.215102 ], [ 71.04324, 24.356524 ], [ 68.842599, 24.359134 ], [ 68.176645, 23.691965 ], [ 67.443667, 23.944844 ], [ 67.145442, 24.663611 ], [ 66.372828, 25.425141 ], [ 64.530408, 25.237039 ], [ 62.905701, 25.218409 ], [ 61.497363, 25.078237 ], [ 61.874187, 26.239975 ], [ 63.316632, 26.756532 ], [ 63.233898, 27.217047 ], [ 62.755426, 27.378923 ], [ 62.72783, 28.259645 ], [ 61.771868, 28.699334 ], [ 61.369309, 29.303276 ], [ 60.874248, 29.829239 ], [ 62.549857, 29.318572 ], [ 63.550261, 29.468331 ], [ 64.148002, 29.340819 ], [ 64.350419, 29.560031 ], [ 65.046862, 29.472181 ], [ 66.346473, 29.887943 ], [ 66.381458, 30.738899 ], [ 66.938891, 31.304911 ], [ 67.683394, 31.303154 ], [ 67.792689, 31.58293 ], [ 68.556932, 31.71331 ], [ 68.926677, 31.620189 ], [ 69.317764, 31.901412 ], [ 69.262522, 32.501944 ], [ 69.687147, 33.105499 ], [ 70.323594, 33.358533 ], [ 69.930543, 34.02012 ], [ 70.881803, 33.988856 ], [ 71.156773, 34.348911 ], [ 71.115019, 34.733126 ], [ 71.613076, 35.153203 ], [ 71.498768, 35.650563 ], [ 71.262348, 36.074388 ], [ 71.846292, 36.509942 ], [ 72.920025, 36.720007 ], [ 74.067552, 36.836176 ], [ 74.575893, 37.020841 ], [ 75.158028, 37.133031 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "PAN", "name": "Panama" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -77.881571, 7.223771 ], [ -78.214936, 7.512255 ], [ -78.429161, 8.052041 ], [ -78.182096, 8.319182 ], [ -78.435465, 8.387705 ], [ -78.622121, 8.718124 ], [ -79.120307, 8.996092 ], [ -79.557877, 8.932375 ], [ -79.760578, 8.584515 ], [ -80.164481, 8.333316 ], [ -80.382659, 8.298409 ], [ -80.480689, 8.090308 ], [ -80.00369, 7.547524 ], [ -80.276671, 7.419754 ], [ -80.421158, 7.271572 ], [ -80.886401, 7.220541 ], [ -81.059543, 7.817921 ], [ -81.189716, 7.647906 ], [ -81.519515, 7.70661 ], [ -81.721311, 8.108963 ], [ -82.131441, 8.175393 ], [ -82.390934, 8.292362 ], [ -82.820081, 8.290864 ], [ -82.850958, 8.073823 ], [ -82.965783, 8.225028 ], [ -82.913176, 8.423517 ], [ -82.829771, 8.626295 ], [ -82.868657, 8.807266 ], [ -82.719183, 8.925709 ], [ -82.927155, 9.07433 ], [ -82.932891, 9.476812 ], [ -82.546196, 9.566135 ], [ -82.187123, 9.207449 ], [ -82.207586, 8.995575 ], [ -81.808567, 8.950617 ], [ -81.714154, 9.031955 ], [ -81.439287, 8.786234 ], [ -80.947302, 8.858504 ], [ -80.521901, 9.111072 ], [ -79.9146, 9.312765 ], [ -79.573303, 9.61161 ], [ -79.021192, 9.552931 ], [ -79.05845, 9.454565 ], [ -78.500888, 9.420459 ], [ -78.055928, 9.24773 ], [ -77.729514, 8.946844 ], [ -77.353361, 8.670505 ], [ -77.474723, 8.524286 ], [ -77.242566, 7.935278 ], [ -77.431108, 7.638061 ], [ -77.753414, 7.70984 ], [ -77.881571, 7.223771 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "PER", "name": "Peru" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -69.590424, -17.580012 ], [ -69.858444, -18.092694 ], [ -70.372572, -18.347975 ], [ -71.37525, -17.773799 ], [ -71.462041, -17.363488 ], [ -73.44453, -16.359363 ], [ -75.237883, -15.265683 ], [ -76.009205, -14.649286 ], [ -76.423469, -13.823187 ], [ -76.259242, -13.535039 ], [ -77.106192, -12.222716 ], [ -78.092153, -10.377712 ], [ -79.036953, -8.386568 ], [ -79.44592, -7.930833 ], [ -79.760578, -7.194341 ], [ -80.537482, -6.541668 ], [ -81.249996, -6.136834 ], [ -80.926347, -5.690557 ], [ -81.410943, -4.736765 ], [ -81.09967, -4.036394 ], [ -80.302561, -3.404856 ], [ -80.184015, -3.821162 ], [ -80.469295, -4.059287 ], [ -80.442242, -4.425724 ], [ -80.028908, -4.346091 ], [ -79.624979, -4.454198 ], [ -79.205289, -4.959129 ], [ -78.639897, -4.547784 ], [ -78.450684, -3.873097 ], [ -77.837905, -3.003021 ], [ -76.635394, -2.608678 ], [ -75.544996, -1.56161 ], [ -75.233723, -0.911417 ], [ -75.373223, -0.152032 ], [ -75.106625, -0.057205 ], [ -74.441601, -0.53082 ], [ -74.122395, -1.002833 ], [ -73.659504, -1.260491 ], [ -73.070392, -2.308954 ], [ -72.325787, -2.434218 ], [ -71.774761, -2.16979 ], [ -71.413646, -2.342802 ], [ -70.813476, -2.256865 ], [ -70.047709, -2.725156 ], [ -70.692682, -3.742872 ], [ -70.394044, -3.766591 ], [ -69.893635, -4.298187 ], [ -70.794769, -4.251265 ], [ -70.928843, -4.401591 ], [ -71.748406, -4.593983 ], [ -72.891928, -5.274561 ], [ -72.964507, -5.741251 ], [ -73.219711, -6.089189 ], [ -73.120027, -6.629931 ], [ -73.724487, -6.918595 ], [ -73.723401, -7.340999 ], [ -73.987235, -7.52383 ], [ -73.571059, -8.424447 ], [ -73.015383, -9.032833 ], [ -73.226713, -9.462213 ], [ -72.563033, -9.520194 ], [ -72.184891, -10.053598 ], [ -71.302412, -10.079436 ], [ -70.481894, -9.490118 ], [ -70.548686, -11.009147 ], [ -70.093752, -11.123972 ], [ -69.529678, -10.951734 ], [ -68.66508, -12.5613 ], [ -68.88008, -12.899729 ], [ -68.929224, -13.602684 ], [ -68.948887, -14.453639 ], [ -69.339535, -14.953195 ], [ -69.160347, -15.323974 ], [ -69.389764, -15.660129 ], [ -68.959635, -16.500698 ], [ -69.590424, -17.580012 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "PHL", "name": "Philippines" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 126.376814, 8.414706 ], [ 126.478513, 7.750354 ], [ 126.537424, 7.189381 ], [ 126.196773, 6.274294 ], [ 125.831421, 7.293715 ], [ 125.363852, 6.786485 ], [ 125.683161, 6.049657 ], [ 125.396512, 5.581003 ], [ 124.219788, 6.161355 ], [ 123.93872, 6.885136 ], [ 124.243662, 7.36061 ], [ 123.610212, 7.833527 ], [ 123.296071, 7.418876 ], [ 122.825506, 7.457375 ], [ 122.085499, 6.899424 ], [ 121.919928, 7.192119 ], [ 122.312359, 8.034962 ], [ 122.942398, 8.316237 ], [ 123.487688, 8.69301 ], [ 123.841154, 8.240324 ], [ 124.60147, 8.514158 ], [ 124.764612, 8.960409 ], [ 125.471391, 8.986997 ], [ 125.412118, 9.760335 ], [ 126.222714, 9.286074 ], [ 126.306637, 8.782487 ], [ 126.376814, 8.414706 ] ] ], [ [ [ 123.982438, 10.278779 ], [ 123.623183, 9.950091 ], [ 123.309921, 9.318269 ], [ 122.995883, 9.022189 ], [ 122.380055, 9.713361 ], [ 122.586089, 9.981045 ], [ 122.837081, 10.261157 ], [ 122.947411, 10.881868 ], [ 123.49885, 10.940624 ], [ 123.337774, 10.267384 ], [ 124.077936, 11.232726 ], [ 123.982438, 10.278779 ] ] ], [ [ [ 118.504581, 9.316383 ], [ 117.174275, 8.3675 ], [ 117.664477, 9.066889 ], [ 118.386914, 9.6845 ], [ 118.987342, 10.376292 ], [ 119.511496, 11.369668 ], [ 119.689677, 10.554291 ], [ 119.029458, 10.003653 ], [ 118.504581, 9.316383 ] ] ], [ [ [ 121.883548, 11.891755 ], [ 122.483821, 11.582187 ], [ 123.120217, 11.58366 ], [ 123.100838, 11.165934 ], [ 122.637714, 10.741308 ], [ 122.00261, 10.441017 ], [ 121.967367, 10.905691 ], [ 122.03837, 11.415841 ], [ 121.883548, 11.891755 ] ] ], [ [ [ 125.502552, 12.162695 ], [ 125.783465, 11.046122 ], [ 125.011884, 11.311455 ], [ 125.032761, 10.975816 ], [ 125.277449, 10.358722 ], [ 124.801819, 10.134679 ], [ 124.760168, 10.837995 ], [ 124.459101, 10.88993 ], [ 124.302522, 11.495371 ], [ 124.891013, 11.415583 ], [ 124.87799, 11.79419 ], [ 124.266762, 12.557761 ], [ 125.227116, 12.535721 ], [ 125.502552, 12.162695 ] ] ], [ [ [ 121.527394, 13.06959 ], [ 121.26219, 12.20556 ], [ 120.833896, 12.704496 ], [ 120.323436, 13.466413 ], [ 121.180128, 13.429697 ], [ 121.527394, 13.06959 ] ] ], [ [ [ 121.321308, 18.504065 ], [ 121.937601, 18.218552 ], [ 122.246006, 18.47895 ], [ 122.336957, 18.224883 ], [ 122.174279, 17.810283 ], [ 122.515654, 17.093505 ], [ 122.252311, 16.262444 ], [ 121.662786, 15.931018 ], [ 121.50507, 15.124814 ], [ 121.728829, 14.328376 ], [ 122.258925, 14.218202 ], [ 122.701276, 14.336541 ], [ 123.950295, 13.782131 ], [ 123.855107, 13.237771 ], [ 124.181289, 12.997527 ], [ 124.077419, 12.536677 ], [ 123.298035, 13.027526 ], [ 122.928652, 13.55292 ], [ 122.671355, 13.185836 ], [ 122.03465, 13.784482 ], [ 121.126385, 13.636687 ], [ 120.628637, 13.857656 ], [ 120.679384, 14.271016 ], [ 120.991819, 14.525393 ], [ 120.693336, 14.756671 ], [ 120.564145, 14.396279 ], [ 120.070429, 14.970869 ], [ 119.920929, 15.406347 ], [ 119.883773, 16.363704 ], [ 120.286488, 16.034629 ], [ 120.390047, 17.599081 ], [ 120.715867, 18.505227 ], [ 121.321308, 18.504065 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "PNG", "name": "Papua New Guinea" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 155.880026, -6.819997 ], [ 155.599991, -6.919991 ], [ 155.166994, -6.535931 ], [ 154.729192, -5.900828 ], [ 154.514114, -5.139118 ], [ 154.652504, -5.042431 ], [ 154.759991, -5.339984 ], [ 155.062918, -5.566792 ], [ 155.547746, -6.200655 ], [ 156.019965, -6.540014 ], [ 155.880026, -6.819997 ] ] ], [ [ [ 151.982796, -5.478063 ], [ 151.459107, -5.56028 ], [ 151.30139, -5.840728 ], [ 150.754447, -6.083763 ], [ 150.241197, -6.317754 ], [ 149.709963, -6.316513 ], [ 148.890065, -6.02604 ], [ 148.318937, -5.747142 ], [ 148.401826, -5.437756 ], [ 149.298412, -5.583742 ], [ 149.845562, -5.505503 ], [ 149.99625, -5.026101 ], [ 150.139756, -5.001348 ], [ 150.236908, -5.53222 ], [ 150.807467, -5.455842 ], [ 151.089672, -5.113693 ], [ 151.647881, -4.757074 ], [ 151.537862, -4.167807 ], [ 152.136792, -4.14879 ], [ 152.338743, -4.312966 ], [ 152.318693, -4.867661 ], [ 151.982796, -5.478063 ] ] ], [ [ [ 147.191874, -7.388024 ], [ 148.084636, -8.044108 ], [ 148.734105, -9.104664 ], [ 149.306835, -9.071436 ], [ 149.266631, -9.514406 ], [ 150.038728, -9.684318 ], [ 149.738798, -9.872937 ], [ 150.801628, -10.293687 ], [ 150.690575, -10.582713 ], [ 150.028393, -10.652476 ], [ 149.78231, -10.393267 ], [ 148.923138, -10.280923 ], [ 147.913018, -10.130441 ], [ 147.135443, -9.492444 ], [ 146.567881, -8.942555 ], [ 146.048481, -8.067414 ], [ 144.744168, -7.630128 ], [ 143.897088, -7.91533 ], [ 143.286376, -8.245491 ], [ 143.413913, -8.983069 ], [ 142.628431, -9.326821 ], [ 142.068259, -9.159596 ], [ 141.033852, -9.117893 ], [ 141.017057, -5.859022 ], [ 141.00021, -2.600151 ], [ 142.735247, -3.289153 ], [ 144.583971, -3.861418 ], [ 145.27318, -4.373738 ], [ 145.829786, -4.876498 ], [ 145.981922, -5.465609 ], [ 147.648073, -6.083659 ], [ 147.891108, -6.614015 ], [ 146.970905, -6.721657 ], [ 147.191874, -7.388024 ] ] ], [ [ [ 153.140038, -4.499983 ], [ 152.827292, -4.766427 ], [ 152.638673, -4.176127 ], [ 152.406026, -3.789743 ], [ 151.953237, -3.462062 ], [ 151.384279, -3.035422 ], [ 150.66205, -2.741486 ], [ 150.939965, -2.500002 ], [ 151.479984, -2.779985 ], [ 151.820015, -2.999972 ], [ 152.239989, -3.240009 ], [ 152.640017, -3.659983 ], [ 153.019994, -3.980015 ], [ 153.140038, -4.499983 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "POL", "name": "Poland" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 15.016996, 51.106674 ], [ 14.607098, 51.745188 ], [ 14.685026, 52.089947 ], [ 14.4376, 52.62485 ], [ 14.074521, 52.981263 ], [ 14.353315, 53.248171 ], [ 14.119686, 53.757029 ], [ 14.8029, 54.050706 ], [ 16.363477, 54.513159 ], [ 17.622832, 54.851536 ], [ 18.620859, 54.682606 ], [ 18.696255, 54.438719 ], [ 19.66064, 54.426084 ], [ 20.892245, 54.312525 ], [ 22.731099, 54.327537 ], [ 23.243987, 54.220567 ], [ 23.484128, 53.912498 ], [ 23.527536, 53.470122 ], [ 23.804935, 53.089731 ], [ 23.799199, 52.691099 ], [ 23.199494, 52.486977 ], [ 23.508002, 52.023647 ], [ 23.527071, 51.578454 ], [ 24.029986, 50.705407 ], [ 23.922757, 50.424881 ], [ 23.426508, 50.308506 ], [ 22.51845, 49.476774 ], [ 22.776419, 49.027395 ], [ 22.558138, 49.085738 ], [ 21.607808, 49.470107 ], [ 20.887955, 49.328772 ], [ 20.415839, 49.431453 ], [ 19.825023, 49.217125 ], [ 19.320713, 49.571574 ], [ 18.909575, 49.435846 ], [ 18.853144, 49.49623 ], [ 18.392914, 49.988629 ], [ 17.649445, 50.049038 ], [ 17.554567, 50.362146 ], [ 16.868769, 50.473974 ], [ 16.719476, 50.215747 ], [ 16.176253, 50.422607 ], [ 16.238627, 50.697733 ], [ 15.490972, 50.78473 ], [ 15.016996, 51.106674 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "PRI", "name": "Puerto Rico" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -66.282434, 18.514762 ], [ -65.771303, 18.426679 ], [ -65.591004, 18.228035 ], [ -65.847164, 17.975906 ], [ -66.599934, 17.981823 ], [ -67.184162, 17.946553 ], [ -67.242428, 18.37446 ], [ -67.100679, 18.520601 ], [ -66.282434, 18.514762 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "PRK", "name": "North Korea" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 130.640016, 42.395009 ], [ 130.780007, 42.220007 ], [ 130.400031, 42.280004 ], [ 129.965949, 41.941368 ], [ 129.667362, 41.601104 ], [ 129.705189, 40.882828 ], [ 129.188115, 40.661808 ], [ 129.0104, 40.485436 ], [ 128.633368, 40.189847 ], [ 127.967414, 40.025413 ], [ 127.533436, 39.75685 ], [ 127.50212, 39.323931 ], [ 127.385434, 39.213472 ], [ 127.783343, 39.050898 ], [ 128.349716, 38.612243 ], [ 128.205746, 38.370397 ], [ 127.780035, 38.304536 ], [ 127.073309, 38.256115 ], [ 126.68372, 37.804773 ], [ 126.237339, 37.840378 ], [ 126.174759, 37.749686 ], [ 125.689104, 37.94001 ], [ 125.568439, 37.752089 ], [ 125.27533, 37.669071 ], [ 125.240087, 37.857224 ], [ 124.981033, 37.948821 ], [ 124.712161, 38.108346 ], [ 124.985994, 38.548474 ], [ 125.221949, 38.665857 ], [ 125.132859, 38.848559 ], [ 125.38659, 39.387958 ], [ 125.321116, 39.551385 ], [ 124.737482, 39.660344 ], [ 124.265625, 39.928493 ], [ 125.079942, 40.569824 ], [ 126.182045, 41.107336 ], [ 126.869083, 41.816569 ], [ 127.343783, 41.503152 ], [ 128.208433, 41.466772 ], [ 128.052215, 41.994285 ], [ 129.596669, 42.424982 ], [ 129.994267, 42.985387 ], [ 130.640016, 42.395009 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "PRT", "name": "Portugal" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -9.034818, 41.880571 ], [ -8.671946, 42.134689 ], [ -8.263857, 42.280469 ], [ -8.013175, 41.790886 ], [ -7.422513, 41.792075 ], [ -7.251309, 41.918346 ], [ -6.668606, 41.883387 ], [ -6.389088, 41.381815 ], [ -6.851127, 41.111083 ], [ -6.86402, 40.330872 ], [ -7.026413, 40.184524 ], [ -7.066592, 39.711892 ], [ -7.498632, 39.629571 ], [ -7.098037, 39.030073 ], [ -7.374092, 38.373059 ], [ -7.029281, 38.075764 ], [ -7.166508, 37.803894 ], [ -7.537105, 37.428904 ], [ -7.453726, 37.097788 ], [ -7.855613, 36.838269 ], [ -8.382816, 36.97888 ], [ -8.898857, 36.868809 ], [ -8.746101, 37.651346 ], [ -8.839998, 38.266243 ], [ -9.287464, 38.358486 ], [ -9.526571, 38.737429 ], [ -9.446989, 39.392066 ], [ -9.048305, 39.755093 ], [ -8.977353, 40.159306 ], [ -8.768684, 40.760639 ], [ -8.790853, 41.184334 ], [ -8.990789, 41.543459 ], [ -9.034818, 41.880571 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "PRY", "name": "Paraguay" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -62.685057, -22.249029 ], [ -62.291179, -21.051635 ], [ -62.265961, -20.513735 ], [ -61.786326, -19.633737 ], [ -60.043565, -19.342747 ], [ -59.115042, -19.356906 ], [ -58.183471, -19.868399 ], [ -58.166392, -20.176701 ], [ -57.870674, -20.732688 ], [ -57.937156, -22.090176 ], [ -56.88151, -22.282154 ], [ -56.473317, -22.0863 ], [ -55.797958, -22.35693 ], [ -55.610683, -22.655619 ], [ -55.517639, -23.571998 ], [ -55.400747, -23.956935 ], [ -55.027902, -24.001274 ], [ -54.652834, -23.839578 ], [ -54.29296, -24.021014 ], [ -54.293476, -24.5708 ], [ -54.428946, -25.162185 ], [ -54.625291, -25.739255 ], [ -54.788795, -26.621786 ], [ -55.695846, -27.387837 ], [ -56.486702, -27.548499 ], [ -57.60976, -27.395899 ], [ -58.618174, -27.123719 ], [ -57.63366, -25.603657 ], [ -57.777217, -25.16234 ], [ -58.807128, -24.771459 ], [ -60.028966, -24.032796 ], [ -60.846565, -23.880713 ], [ -62.685057, -22.249029 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "QAT", "name": "Qatar" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 50.810108, 24.754743 ], [ 50.743911, 25.482424 ], [ 51.013352, 26.006992 ], [ 51.286462, 26.114582 ], [ 51.589079, 25.801113 ], [ 51.6067, 25.21567 ], [ 51.389608, 24.627386 ], [ 51.112415, 24.556331 ], [ 50.810108, 24.754743 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "ROU", "name": "Romania" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 22.710531, 47.882194 ], [ 23.142236, 48.096341 ], [ 23.760958, 47.985598 ], [ 24.402056, 47.981878 ], [ 24.866317, 47.737526 ], [ 25.207743, 47.891056 ], [ 25.945941, 47.987149 ], [ 26.19745, 48.220881 ], [ 26.619337, 48.220726 ], [ 26.924176, 48.123264 ], [ 27.233873, 47.826771 ], [ 27.551166, 47.405117 ], [ 28.12803, 46.810476 ], [ 28.160018, 46.371563 ], [ 28.054443, 45.944586 ], [ 28.233554, 45.488283 ], [ 28.679779, 45.304031 ], [ 29.149725, 45.464925 ], [ 29.603289, 45.293308 ], [ 29.626543, 45.035391 ], [ 29.141612, 44.82021 ], [ 28.837858, 44.913874 ], [ 28.558081, 43.707462 ], [ 27.970107, 43.812468 ], [ 27.2424, 44.175986 ], [ 26.065159, 43.943494 ], [ 25.569272, 43.688445 ], [ 24.100679, 43.741051 ], [ 23.332302, 43.897011 ], [ 22.944832, 43.823785 ], [ 22.65715, 44.234923 ], [ 22.474008, 44.409228 ], [ 22.705726, 44.578003 ], [ 22.459022, 44.702517 ], [ 22.145088, 44.478422 ], [ 21.562023, 44.768947 ], [ 21.483526, 45.18117 ], [ 20.874313, 45.416375 ], [ 20.762175, 45.734573 ], [ 20.220192, 46.127469 ], [ 21.021952, 46.316088 ], [ 21.626515, 46.994238 ], [ 22.099768, 47.672439 ], [ 22.710531, 47.882194 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "RUS", "name": "Russia" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 143.648007, 50.7476 ], [ 144.654148, 48.976391 ], [ 143.173928, 49.306551 ], [ 142.558668, 47.861575 ], [ 143.533492, 46.836728 ], [ 143.505277, 46.137908 ], [ 142.747701, 46.740765 ], [ 142.09203, 45.966755 ], [ 141.906925, 46.805929 ], [ 142.018443, 47.780133 ], [ 141.904445, 48.859189 ], [ 142.1358, 49.615163 ], [ 142.179983, 50.952342 ], [ 141.594076, 51.935435 ], [ 141.682546, 53.301966 ], [ 142.606934, 53.762145 ], [ 142.209749, 54.225476 ], [ 142.654786, 54.365881 ], [ 142.914616, 53.704578 ], [ 143.260848, 52.74076 ], [ 143.235268, 51.75666 ], [ 143.648007, 50.7476 ] ] ], [ [ [ 22.731099, 54.327537 ], [ 20.892245, 54.312525 ], [ 19.66064, 54.426084 ], [ 19.888481, 54.86616 ], [ 21.268449, 55.190482 ], [ 22.315724, 55.015299 ], [ 22.757764, 54.856574 ], [ 22.651052, 54.582741 ], [ 22.731099, 54.327537 ] ] ], [ [ [ -175.01425, 66.58435 ], [ -174.33983, 66.33556 ], [ -174.57182, 67.06219 ], [ -171.85731, 66.91308 ], [ -169.89958, 65.97724 ], [ -170.89107, 65.54139 ], [ -172.53025, 65.43791 ], [ -172.555, 64.46079 ], [ -172.95533, 64.25269 ], [ -173.89184, 64.2826 ], [ -174.65392, 64.63125 ], [ -175.98353, 64.92288 ], [ -176.20716, 65.35667 ], [ -177.22266, 65.52024 ], [ -178.35993, 65.39052 ], [ -178.90332, 65.74044 ], [ -178.68611, 66.11211 ], [ -179.88377, 65.87456 ], [ -179.43268, 65.40411 ], [ -180.0, 64.979709 ], [ -180.0, 68.963636 ], [ -177.55, 68.2 ], [ -174.92825, 67.20589 ], [ -175.01425, 66.58435 ] ] ], [ [ [ 180.0, 70.832199 ], [ 178.903425, 70.78114 ], [ 178.7253, 71.0988 ], [ 180.0, 71.515714 ], [ 180.0, 70.832199 ] ] ], [ [ [ -178.69378, 70.89302 ], [ -180.0, 70.832199 ], [ -180.0, 71.515714 ], [ -179.871875, 71.55762 ], [ -179.02433, 71.55553 ], [ -177.577945, 71.26948 ], [ -177.663575, 71.13277 ], [ -178.69378, 70.89302 ] ] ], [ [ [ 143.60385, 73.21244 ], [ 142.08763, 73.20544 ], [ 140.038155, 73.31692 ], [ 139.86312, 73.36983 ], [ 140.81171, 73.76506 ], [ 142.06207, 73.85758 ], [ 143.48283, 73.47525 ], [ 143.60385, 73.21244 ] ] ], [ [ [ 150.73167, 75.08406 ], [ 149.575925, 74.68892 ], [ 147.977465, 74.778355 ], [ 146.11919, 75.17298 ], [ 146.358485, 75.49682 ], [ 148.22223, 75.345845 ], [ 150.73167, 75.08406 ] ] ], [ [ [ 145.086285, 75.562625 ], [ 144.3, 74.82 ], [ 140.61381, 74.84768 ], [ 138.95544, 74.61148 ], [ 136.97439, 75.26167 ], [ 137.51176, 75.94917 ], [ 138.831075, 76.13676 ], [ 141.471615, 76.09289 ], [ 145.086285, 75.562625 ] ] ], [ [ [ 57.535693, 70.720464 ], [ 56.944979, 70.632743 ], [ 53.677375, 70.762658 ], [ 53.412017, 71.206662 ], [ 51.601895, 71.474759 ], [ 51.455754, 72.014881 ], [ 52.478275, 72.229442 ], [ 52.444169, 72.774731 ], [ 54.427614, 73.627548 ], [ 53.50829, 73.749814 ], [ 55.902459, 74.627486 ], [ 55.631933, 75.081412 ], [ 57.868644, 75.60939 ], [ 61.170044, 76.251883 ], [ 64.498368, 76.439055 ], [ 66.210977, 76.809782 ], [ 68.15706, 76.939697 ], [ 68.852211, 76.544811 ], [ 68.180573, 76.233642 ], [ 64.637326, 75.737755 ], [ 61.583508, 75.260885 ], [ 58.477082, 74.309056 ], [ 56.986786, 73.333044 ], [ 55.419336, 72.371268 ], [ 55.622838, 71.540595 ], [ 57.535693, 70.720464 ] ] ], [ [ [ 106.97013, 76.97419 ], [ 107.24, 76.48 ], [ 108.1538, 76.72335 ], [ 111.07726, 76.71 ], [ 113.33151, 76.22224 ], [ 114.13417, 75.84764 ], [ 113.88539, 75.32779 ], [ 112.77918, 75.03186 ], [ 110.15125, 74.47673 ], [ 109.4, 74.18 ], [ 110.64, 74.04 ], [ 112.11919, 73.78774 ], [ 113.01954, 73.97693 ], [ 113.52958, 73.33505 ], [ 113.96881, 73.59488 ], [ 115.56782, 73.75285 ], [ 118.77633, 73.58772 ], [ 119.02, 73.12 ], [ 123.20066, 72.97122 ], [ 123.25777, 73.73503 ], [ 125.38, 73.56 ], [ 126.97644, 73.56549 ], [ 128.59126, 73.03871 ], [ 129.05157, 72.39872 ], [ 128.46, 71.98 ], [ 129.71599, 71.19304 ], [ 131.28858, 70.78699 ], [ 132.2535, 71.8363 ], [ 133.85766, 71.38642 ], [ 135.56193, 71.65525 ], [ 137.49755, 71.34763 ], [ 138.23409, 71.62803 ], [ 139.86983, 71.48783 ], [ 139.14791, 72.41619 ], [ 140.46817, 72.84941 ], [ 149.5, 72.2 ], [ 150.35118, 71.60643 ], [ 152.9689, 70.84222 ], [ 157.00688, 71.03141 ], [ 158.99779, 70.86672 ], [ 159.83031, 70.45324 ], [ 159.70866, 69.72198 ], [ 160.94053, 69.43728 ], [ 162.27907, 69.64204 ], [ 164.05248, 69.66823 ], [ 165.94037, 69.47199 ], [ 167.83567, 69.58269 ], [ 169.57763, 68.6938 ], [ 170.81688, 69.01363 ], [ 170.0082, 69.65276 ], [ 170.45345, 70.09703 ], [ 173.64391, 69.81743 ], [ 175.72403, 69.87725 ], [ 178.6, 69.4 ], [ 180.0, 68.963636 ], [ 180.0, 64.979709 ], [ 179.99281, 64.97433 ], [ 178.7072, 64.53493 ], [ 177.41128, 64.60821 ], [ 178.313, 64.07593 ], [ 178.90825, 63.25197 ], [ 179.37034, 62.98262 ], [ 179.48636, 62.56894 ], [ 179.22825, 62.3041 ], [ 177.3643, 62.5219 ], [ 174.56929, 61.76915 ], [ 173.68013, 61.65261 ], [ 172.15, 60.95 ], [ 170.6985, 60.33618 ], [ 170.33085, 59.88177 ], [ 168.90046, 60.57355 ], [ 166.29498, 59.78855 ], [ 165.84, 60.16 ], [ 164.87674, 59.7316 ], [ 163.53929, 59.86871 ], [ 163.21711, 59.21101 ], [ 162.01733, 58.24328 ], [ 162.05297, 57.83912 ], [ 163.19191, 57.61503 ], [ 163.05794, 56.15924 ], [ 162.12958, 56.12219 ], [ 161.70146, 55.28568 ], [ 162.11749, 54.85514 ], [ 160.36877, 54.34433 ], [ 160.02173, 53.20257 ], [ 158.53094, 52.95868 ], [ 158.23118, 51.94269 ], [ 156.78979, 51.01105 ], [ 156.42, 51.7 ], [ 155.99182, 53.15895 ], [ 155.43366, 55.38103 ], [ 155.91442, 56.76792 ], [ 156.75815, 57.3647 ], [ 156.81035, 57.83204 ], [ 158.36433, 58.05575 ], [ 160.15064, 59.31477 ], [ 161.87204, 60.343 ], [ 163.66969, 61.1409 ], [ 164.47355, 62.55061 ], [ 163.25842, 62.46627 ], [ 162.65791, 61.6425 ], [ 160.12148, 60.54423 ], [ 159.30232, 61.77396 ], [ 156.72068, 61.43442 ], [ 154.21806, 59.75818 ], [ 155.04375, 59.14495 ], [ 152.81185, 58.88385 ], [ 151.26573, 58.78089 ], [ 151.33815, 59.50396 ], [ 149.78371, 59.65573 ], [ 148.54481, 59.16448 ], [ 145.48722, 59.33637 ], [ 142.19782, 59.03998 ], [ 138.95848, 57.08805 ], [ 135.12619, 54.72959 ], [ 136.70171, 54.60355 ], [ 137.19342, 53.97732 ], [ 138.1647, 53.75501 ], [ 138.80463, 54.25455 ], [ 139.90151, 54.18968 ], [ 141.34531, 53.08957 ], [ 141.37923, 52.23877 ], [ 140.59742, 51.23967 ], [ 140.51308, 50.04553 ], [ 140.06193, 48.44671 ], [ 138.55472, 46.99965 ], [ 138.21971, 46.30795 ], [ 136.86232, 45.1435 ], [ 135.51535, 43.989 ], [ 134.86939, 43.39821 ], [ 133.53687, 42.81147 ], [ 132.90627, 42.79849 ], [ 132.27807, 43.28456 ], [ 130.93587, 42.55274 ], [ 130.78, 42.22 ], [ 130.64, 42.395 ], [ 130.633866, 42.903015 ], [ 131.144688, 42.92999 ], [ 131.288555, 44.11152 ], [ 131.02519, 44.96796 ], [ 131.883454, 45.321162 ], [ 133.09712, 45.14409 ], [ 133.769644, 46.116927 ], [ 134.11235, 47.21248 ], [ 134.50081, 47.57845 ], [ 135.026311, 48.47823 ], [ 133.373596, 48.183442 ], [ 132.50669, 47.78896 ], [ 130.98726, 47.79013 ], [ 130.582293, 48.729687 ], [ 129.397818, 49.4406 ], [ 127.6574, 49.76027 ], [ 127.287456, 50.739797 ], [ 126.939157, 51.353894 ], [ 126.564399, 51.784255 ], [ 125.946349, 52.792799 ], [ 125.068211, 53.161045 ], [ 123.57147, 53.4588 ], [ 122.245748, 53.431726 ], [ 121.003085, 53.251401 ], [ 120.177089, 52.753886 ], [ 120.725789, 52.516226 ], [ 120.7382, 51.96411 ], [ 120.18208, 51.64355 ], [ 119.27939, 50.58292 ], [ 119.288461, 50.142883 ], [ 117.879244, 49.510983 ], [ 116.678801, 49.888531 ], [ 115.485695, 49.805177 ], [ 114.96211, 50.140247 ], [ 114.362456, 50.248303 ], [ 112.89774, 49.543565 ], [ 111.581231, 49.377968 ], [ 110.662011, 49.130128 ], [ 109.402449, 49.292961 ], [ 108.475167, 49.282548 ], [ 107.868176, 49.793705 ], [ 106.888804, 50.274296 ], [ 105.886591, 50.406019 ], [ 104.62158, 50.27532 ], [ 103.676545, 50.089966 ], [ 102.25589, 50.51056 ], [ 102.06521, 51.25991 ], [ 100.88948, 51.516856 ], [ 99.981732, 51.634006 ], [ 98.861491, 52.047366 ], [ 97.82574, 51.010995 ], [ 98.231762, 50.422401 ], [ 97.25976, 49.72605 ], [ 95.81402, 49.97746 ], [ 94.815949, 50.013433 ], [ 94.147566, 50.480537 ], [ 93.10421, 50.49529 ], [ 92.234712, 50.802171 ], [ 90.713667, 50.331812 ], [ 88.805567, 49.470521 ], [ 87.751264, 49.297198 ], [ 87.35997, 49.214981 ], [ 86.829357, 49.826675 ], [ 85.54127, 49.692859 ], [ 85.11556, 50.117303 ], [ 84.416377, 50.3114 ], [ 83.935115, 50.889246 ], [ 83.383004, 51.069183 ], [ 81.945986, 50.812196 ], [ 80.568447, 51.388336 ], [ 80.03556, 50.864751 ], [ 77.800916, 53.404415 ], [ 76.525179, 54.177003 ], [ 76.8911, 54.490524 ], [ 74.38482, 53.54685 ], [ 73.425679, 53.48981 ], [ 73.508516, 54.035617 ], [ 72.22415, 54.376655 ], [ 71.180131, 54.133285 ], [ 70.865267, 55.169734 ], [ 69.068167, 55.38525 ], [ 68.1691, 54.970392 ], [ 65.66687, 54.60125 ], [ 65.178534, 54.354228 ], [ 61.4366, 54.00625 ], [ 60.978066, 53.664993 ], [ 61.699986, 52.979996 ], [ 60.739993, 52.719986 ], [ 60.927269, 52.447548 ], [ 59.967534, 51.96042 ], [ 61.588003, 51.272659 ], [ 61.337424, 50.79907 ], [ 59.932807, 50.842194 ], [ 59.642282, 50.545442 ], [ 58.36332, 51.06364 ], [ 56.77798, 51.04355 ], [ 55.71694, 50.62171 ], [ 54.532878, 51.02624 ], [ 52.328724, 51.718652 ], [ 50.766648, 51.692762 ], [ 48.702382, 50.605128 ], [ 48.577841, 49.87476 ], [ 47.54948, 50.454698 ], [ 46.751596, 49.356006 ], [ 47.043672, 49.152039 ], [ 46.466446, 48.394152 ], [ 47.31524, 47.71585 ], [ 48.05725, 47.74377 ], [ 48.694734, 47.075628 ], [ 48.59325, 46.56104 ], [ 49.10116, 46.39933 ], [ 48.64541, 45.80629 ], [ 47.67591, 45.64149 ], [ 46.68201, 44.6092 ], [ 47.59094, 43.66016 ], [ 47.49252, 42.98658 ], [ 48.58437, 41.80888 ], [ 47.987283, 41.405819 ], [ 47.815666, 41.151416 ], [ 47.373315, 41.219732 ], [ 46.686071, 41.827137 ], [ 46.404951, 41.860675 ], [ 45.7764, 42.09244 ], [ 45.470279, 42.502781 ], [ 44.537623, 42.711993 ], [ 43.93121, 42.55496 ], [ 43.75599, 42.74083 ], [ 42.3944, 43.2203 ], [ 40.92219, 43.38215 ], [ 40.076965, 43.553104 ], [ 39.955009, 43.434998 ], [ 38.68, 44.28 ], [ 37.53912, 44.65721 ], [ 36.67546, 45.24469 ], [ 37.40317, 45.40451 ], [ 38.23295, 46.24087 ], [ 37.67372, 46.63657 ], [ 39.14767, 47.04475 ], [ 39.1212, 47.26336 ], [ 38.223538, 47.10219 ], [ 38.255112, 47.5464 ], [ 38.77057, 47.82562 ], [ 39.738278, 47.898937 ], [ 39.89562, 48.23241 ], [ 39.67465, 48.78382 ], [ 40.080789, 49.30743 ], [ 40.06904, 49.60105 ], [ 38.594988, 49.926462 ], [ 38.010631, 49.915662 ], [ 37.39346, 50.383953 ], [ 36.626168, 50.225591 ], [ 35.356116, 50.577197 ], [ 35.37791, 50.77394 ], [ 35.022183, 51.207572 ], [ 34.224816, 51.255993 ], [ 34.141978, 51.566413 ], [ 34.391731, 51.768882 ], [ 33.7527, 52.335075 ], [ 32.715761, 52.238465 ], [ 32.412058, 52.288695 ], [ 32.15944, 52.06125 ], [ 31.78597, 52.10168 ], [ 31.540018, 52.742052 ], [ 31.305201, 53.073996 ], [ 31.49764, 53.16743 ], [ 32.304519, 53.132726 ], [ 32.693643, 53.351421 ], [ 32.405599, 53.618045 ], [ 31.731273, 53.794029 ], [ 31.791424, 53.974639 ], [ 31.384472, 54.157056 ], [ 30.757534, 54.811771 ], [ 30.971836, 55.081548 ], [ 30.873909, 55.550976 ], [ 29.896294, 55.789463 ], [ 29.371572, 55.670091 ], [ 29.229513, 55.918344 ], [ 28.176709, 56.16913 ], [ 27.855282, 56.759326 ], [ 27.770016, 57.244258 ], [ 27.288185, 57.474528 ], [ 27.716686, 57.791899 ], [ 27.42015, 58.72457 ], [ 28.131699, 59.300825 ], [ 27.98112, 59.47537 ], [ 29.1177, 60.02805 ], [ 28.07, 60.50352 ], [ 30.211107, 61.780028 ], [ 31.139991, 62.357693 ], [ 31.516092, 62.867687 ], [ 30.035872, 63.552814 ], [ 30.444685, 64.204453 ], [ 29.54443, 64.948672 ], [ 30.21765, 65.80598 ], [ 29.054589, 66.944286 ], [ 29.977426, 67.698297 ], [ 28.445944, 68.364613 ], [ 28.59193, 69.064777 ], [ 29.39955, 69.15692 ], [ 31.10108, 69.55811 ], [ 32.13272, 69.90595 ], [ 33.77547, 69.30142 ], [ 36.51396, 69.06342 ], [ 40.29234, 67.9324 ], [ 41.05987, 67.45713 ], [ 41.12595, 66.79158 ], [ 40.01583, 66.26618 ], [ 38.38295, 65.99953 ], [ 33.91871, 66.75961 ], [ 33.18444, 66.63253 ], [ 34.81477, 65.90015 ], [ 34.878574, 65.436213 ], [ 34.94391, 64.41437 ], [ 36.23129, 64.10945 ], [ 37.01273, 63.84983 ], [ 37.14197, 64.33471 ], [ 36.539579, 64.76446 ], [ 37.17604, 65.14322 ], [ 39.59345, 64.52079 ], [ 40.4356, 64.76446 ], [ 39.7626, 65.49682 ], [ 42.09309, 66.47623 ], [ 43.01604, 66.41858 ], [ 43.94975, 66.06908 ], [ 44.53226, 66.75634 ], [ 43.69839, 67.35245 ], [ 44.18795, 67.95051 ], [ 43.45282, 68.57079 ], [ 46.25, 68.25 ], [ 46.82134, 67.68997 ], [ 45.55517, 67.56652 ], [ 45.56202, 67.01005 ], [ 46.34915, 66.66767 ], [ 47.89416, 66.88455 ], [ 48.13876, 67.52238 ], [ 50.22766, 67.99867 ], [ 53.71743, 68.85738 ], [ 54.47171, 68.80815 ], [ 53.48582, 68.20131 ], [ 54.72628, 68.09702 ], [ 55.44268, 68.43866 ], [ 57.31702, 68.46628 ], [ 58.802, 68.88082 ], [ 59.94142, 68.27844 ], [ 61.07784, 68.94069 ], [ 60.03, 69.52 ], [ 60.55, 69.85 ], [ 63.504, 69.54739 ], [ 64.888115, 69.234835 ], [ 68.51216, 68.09233 ], [ 69.18068, 68.61563 ], [ 68.16444, 69.14436 ], [ 68.13522, 69.35649 ], [ 66.93008, 69.45461 ], [ 67.25976, 69.92873 ], [ 66.72492, 70.70889 ], [ 66.69466, 71.02897 ], [ 68.54006, 71.9345 ], [ 69.19636, 72.84336 ], [ 69.94, 73.04 ], [ 72.58754, 72.77629 ], [ 72.79603, 72.22006 ], [ 71.84811, 71.40898 ], [ 72.47011, 71.09019 ], [ 72.79188, 70.39114 ], [ 72.5647, 69.02085 ], [ 73.66787, 68.4079 ], [ 73.2387, 67.7404 ], [ 71.28, 66.32 ], [ 72.42301, 66.17267 ], [ 72.82077, 66.53267 ], [ 73.92099, 66.78946 ], [ 74.18651, 67.28429 ], [ 75.052, 67.76047 ], [ 74.46926, 68.32899 ], [ 74.93584, 68.98918 ], [ 73.84236, 69.07146 ], [ 73.60187, 69.62763 ], [ 74.3998, 70.63175 ], [ 73.1011, 71.44717 ], [ 74.89082, 72.12119 ], [ 74.65926, 72.83227 ], [ 75.15801, 72.85497 ], [ 75.68351, 72.30056 ], [ 75.28898, 71.33556 ], [ 76.35911, 71.15287 ], [ 75.90313, 71.87401 ], [ 77.57665, 72.26717 ], [ 79.65202, 72.32011 ], [ 81.5, 71.75 ], [ 80.61071, 72.58285 ], [ 80.51109, 73.6482 ], [ 82.25, 73.85 ], [ 84.65526, 73.80591 ], [ 86.8223, 73.93688 ], [ 86.00956, 74.45967 ], [ 87.16682, 75.11643 ], [ 88.31571, 75.14393 ], [ 90.26, 75.64 ], [ 92.90058, 75.77333 ], [ 93.23421, 76.0472 ], [ 95.86, 76.14 ], [ 96.67821, 75.91548 ], [ 98.92254, 76.44689 ], [ 100.75967, 76.43028 ], [ 101.03532, 76.86189 ], [ 101.99084, 77.28754 ], [ 104.3516, 77.69792 ], [ 106.06664, 77.37389 ], [ 104.705, 77.1274 ], [ 106.97013, 76.97419 ] ] ], [ [ [ 105.07547, 78.30689 ], [ 99.43814, 77.921 ], [ 101.2649, 79.23399 ], [ 102.08635, 79.34641 ], [ 102.837815, 79.28129 ], [ 105.37243, 78.71334 ], [ 105.07547, 78.30689 ] ] ], [ [ [ 51.136187, 80.54728 ], [ 49.793685, 80.415428 ], [ 48.894411, 80.339567 ], [ 48.754937, 80.175468 ], [ 47.586119, 80.010181 ], [ 46.502826, 80.247247 ], [ 47.072455, 80.559424 ], [ 44.846958, 80.58981 ], [ 46.799139, 80.771918 ], [ 48.318477, 80.78401 ], [ 48.522806, 80.514569 ], [ 49.09719, 80.753986 ], [ 50.039768, 80.918885 ], [ 51.522933, 80.699726 ], [ 51.136187, 80.54728 ] ] ], [ [ [ 99.93976, 78.88094 ], [ 97.75794, 78.7562 ], [ 94.97259, 79.044745 ], [ 93.31288, 79.4265 ], [ 92.5454, 80.14379 ], [ 91.18107, 80.34146 ], [ 93.77766, 81.0246 ], [ 95.940895, 81.2504 ], [ 97.88385, 80.746975 ], [ 100.186655, 79.780135 ], [ 99.93976, 78.88094 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "RWA", "name": "Rwanda" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 30.419105, -1.134659 ], [ 30.816135, -1.698914 ], [ 30.758309, -2.28725 ], [ 30.469696, -2.413858 ], [ 29.938359, -2.348487 ], [ 29.632176, -2.917858 ], [ 29.024926, -2.839258 ], [ 29.117479, -2.292211 ], [ 29.254835, -2.21511 ], [ 29.291887, -1.620056 ], [ 29.579466, -1.341313 ], [ 29.821519, -1.443322 ], [ 30.419105, -1.134659 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "ESH", "name": "Western Sahara" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -8.794884, 27.120696 ], [ -8.817828, 27.656426 ], [ -8.66559, 27.656426 ], [ -8.665124, 27.589479 ], [ -8.6844, 27.395744 ], [ -8.687294, 25.881056 ], [ -11.969419, 25.933353 ], [ -11.937224, 23.374594 ], [ -12.874222, 23.284832 ], [ -13.118754, 22.77122 ], [ -12.929102, 21.327071 ], [ -16.845194, 21.333323 ], [ -17.063423, 20.999752 ], [ -17.020428, 21.42231 ], [ -17.002962, 21.420734 ], [ -14.750955, 21.5006 ], [ -14.630833, 21.86094 ], [ -14.221168, 22.310163 ], [ -13.89111, 23.691009 ], [ -12.500963, 24.770116 ], [ -12.030759, 26.030866 ], [ -11.71822, 26.104092 ], [ -11.392555, 26.883424 ], [ -10.551263, 26.990808 ], [ -10.189424, 26.860945 ], [ -9.735343, 26.860945 ], [ -9.413037, 27.088476 ], [ -8.794884, 27.120696 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "SAU", "name": "Saudi Arabia" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 42.779332, 16.347891 ], [ 42.649573, 16.774635 ], [ 42.347989, 17.075806 ], [ 42.270888, 17.474722 ], [ 41.754382, 17.833046 ], [ 41.221391, 18.6716 ], [ 40.939341, 19.486485 ], [ 40.247652, 20.174635 ], [ 39.801685, 20.338862 ], [ 39.139399, 21.291905 ], [ 39.023696, 21.986875 ], [ 39.066329, 22.579656 ], [ 38.492772, 23.688451 ], [ 38.02386, 24.078686 ], [ 37.483635, 24.285495 ], [ 37.154818, 24.858483 ], [ 37.209491, 25.084542 ], [ 36.931627, 25.602959 ], [ 36.639604, 25.826228 ], [ 36.249137, 26.570136 ], [ 35.640182, 27.37652 ], [ 35.130187, 28.063352 ], [ 34.632336, 28.058546 ], [ 34.787779, 28.607427 ], [ 34.83222, 28.957483 ], [ 34.956037, 29.356555 ], [ 36.068941, 29.197495 ], [ 36.501214, 29.505254 ], [ 36.740528, 29.865283 ], [ 37.503582, 30.003776 ], [ 37.66812, 30.338665 ], [ 37.998849, 30.5085 ], [ 37.002166, 31.508413 ], [ 39.004886, 32.010217 ], [ 39.195468, 32.161009 ], [ 40.399994, 31.889992 ], [ 41.889981, 31.190009 ], [ 44.709499, 29.178891 ], [ 46.568713, 29.099025 ], [ 47.459822, 29.002519 ], [ 47.708851, 28.526063 ], [ 48.416094, 28.552004 ], [ 48.807595, 27.689628 ], [ 49.299554, 27.461218 ], [ 49.470914, 27.109999 ], [ 50.152422, 26.689663 ], [ 50.212935, 26.277027 ], [ 50.113303, 25.943972 ], [ 50.239859, 25.60805 ], [ 50.527387, 25.327808 ], [ 50.660557, 24.999896 ], [ 50.810108, 24.754743 ], [ 51.112415, 24.556331 ], [ 51.389608, 24.627386 ], [ 51.579519, 24.245497 ], [ 51.617708, 24.014219 ], [ 52.000733, 23.001154 ], [ 55.006803, 22.496948 ], [ 55.208341, 22.70833 ], [ 55.666659, 22.000001 ], [ 54.999982, 19.999994 ], [ 52.00001, 19.000003 ], [ 49.116672, 18.616668 ], [ 48.183344, 18.166669 ], [ 47.466695, 17.116682 ], [ 47.000005, 16.949999 ], [ 46.749994, 17.283338 ], [ 46.366659, 17.233315 ], [ 45.399999, 17.333335 ], [ 45.216651, 17.433329 ], [ 44.062613, 17.410359 ], [ 43.791519, 17.319977 ], [ 43.380794, 17.579987 ], [ 43.115798, 17.08844 ], [ 43.218375, 16.66689 ], [ 42.779332, 16.347891 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "SDN", "name": "Sudan" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 33.963393, 9.464285 ], [ 33.824963, 9.484061 ], [ 33.842131, 9.981915 ], [ 33.721959, 10.325262 ], [ 33.206938, 10.720112 ], [ 33.086766, 11.441141 ], [ 33.206938, 12.179338 ], [ 32.743419, 12.248008 ], [ 32.67475, 12.024832 ], [ 32.073892, 11.97333 ], [ 32.314235, 11.681484 ], [ 32.400072, 11.080626 ], [ 31.850716, 10.531271 ], [ 31.352862, 9.810241 ], [ 30.837841, 9.707237 ], [ 29.996639, 10.290927 ], [ 29.618957, 10.084919 ], [ 29.515953, 9.793074 ], [ 29.000932, 9.604232 ], [ 28.966597, 9.398224 ], [ 27.97089, 9.398224 ], [ 27.833551, 9.604232 ], [ 27.112521, 9.638567 ], [ 26.752006, 9.466893 ], [ 26.477328, 9.55273 ], [ 25.962307, 10.136421 ], [ 25.790633, 10.411099 ], [ 25.069604, 10.27376 ], [ 24.794926, 9.810241 ], [ 24.537415, 8.917538 ], [ 24.194068, 8.728696 ], [ 23.88698, 8.61973 ], [ 23.805813, 8.666319 ], [ 23.459013, 8.954286 ], [ 23.394779, 9.265068 ], [ 23.55725, 9.681218 ], [ 23.554304, 10.089255 ], [ 22.977544, 10.714463 ], [ 22.864165, 11.142395 ], [ 22.87622, 11.38461 ], [ 22.50869, 11.67936 ], [ 22.49762, 12.26024 ], [ 22.28801, 12.64605 ], [ 21.93681, 12.58818 ], [ 22.03759, 12.95546 ], [ 22.29658, 13.37232 ], [ 22.18329, 13.78648 ], [ 22.51202, 14.09318 ], [ 22.30351, 14.32682 ], [ 22.56795, 14.94429 ], [ 23.02459, 15.68072 ], [ 23.88689, 15.61084 ], [ 23.83766, 19.58047 ], [ 23.85, 20.0 ], [ 25.0, 20.00304 ], [ 25.0, 22.0 ], [ 29.02, 22.0 ], [ 32.9, 22.0 ], [ 36.86623, 22.0 ], [ 37.18872, 21.01885 ], [ 36.96941, 20.83744 ], [ 37.1147, 19.80796 ], [ 37.48179, 18.61409 ], [ 37.86276, 18.36786 ], [ 38.41009, 17.998307 ], [ 37.904, 17.42754 ], [ 37.16747, 17.26314 ], [ 36.85253, 16.95655 ], [ 36.75389, 16.29186 ], [ 36.32322, 14.82249 ], [ 36.42951, 14.42211 ], [ 36.27022, 13.56333 ], [ 35.86363, 12.57828 ], [ 35.26049, 12.08286 ], [ 34.83163, 11.31896 ], [ 34.73115, 10.91017 ], [ 34.25745, 10.63009 ], [ 33.96162, 9.58358 ], [ 33.963393, 9.464285 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "SSD", "name": "South Sudan" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 33.963393, 9.464285 ], [ 33.97498, 8.68456 ], [ 33.8255, 8.37916 ], [ 33.2948, 8.35458 ], [ 32.95418, 7.78497 ], [ 33.56829, 7.71334 ], [ 34.0751, 7.22595 ], [ 34.25032, 6.82607 ], [ 34.70702, 6.59422 ], [ 35.298007, 5.506 ], [ 34.620196, 4.847123 ], [ 34.005, 4.249885 ], [ 33.39, 3.79 ], [ 32.68642, 3.79232 ], [ 31.88145, 3.55827 ], [ 31.24556, 3.7819 ], [ 30.83385, 3.50917 ], [ 29.95349, 4.1737 ], [ 29.715995, 4.600805 ], [ 29.159078, 4.389267 ], [ 28.696678, 4.455077 ], [ 28.428994, 4.287155 ], [ 27.979977, 4.408413 ], [ 27.374226, 5.233944 ], [ 27.213409, 5.550953 ], [ 26.465909, 5.946717 ], [ 26.213418, 6.546603 ], [ 25.796648, 6.979316 ], [ 25.124131, 7.500085 ], [ 25.114932, 7.825104 ], [ 24.567369, 8.229188 ], [ 23.88698, 8.61973 ], [ 24.194068, 8.728696 ], [ 24.537415, 8.917538 ], [ 24.794926, 9.810241 ], [ 25.069604, 10.27376 ], [ 25.790633, 10.411099 ], [ 25.962307, 10.136421 ], [ 26.477328, 9.55273 ], [ 26.752006, 9.466893 ], [ 27.112521, 9.638567 ], [ 27.833551, 9.604232 ], [ 27.97089, 9.398224 ], [ 28.966597, 9.398224 ], [ 29.000932, 9.604232 ], [ 29.515953, 9.793074 ], [ 29.618957, 10.084919 ], [ 29.996639, 10.290927 ], [ 30.837841, 9.707237 ], [ 31.352862, 9.810241 ], [ 31.850716, 10.531271 ], [ 32.400072, 11.080626 ], [ 32.314235, 11.681484 ], [ 32.073892, 11.97333 ], [ 32.67475, 12.024832 ], [ 32.743419, 12.248008 ], [ 33.206938, 12.179338 ], [ 33.086766, 11.441141 ], [ 33.206938, 10.720112 ], [ 33.721959, 10.325262 ], [ 33.842131, 9.981915 ], [ 33.824963, 9.484061 ], [ 33.963393, 9.464285 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "SEN", "name": "Senegal" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -16.713729, 13.594959 ], [ -17.126107, 14.373516 ], [ -17.625043, 14.729541 ], [ -17.185173, 14.919477 ], [ -16.700706, 15.621527 ], [ -16.463098, 16.135036 ], [ -16.12069, 16.455663 ], [ -15.623666, 16.369337 ], [ -15.135737, 16.587282 ], [ -14.577348, 16.598264 ], [ -14.099521, 16.304302 ], [ -13.435738, 16.039383 ], [ -12.830658, 15.303692 ], [ -12.17075, 14.616834 ], [ -12.124887, 13.994727 ], [ -11.927716, 13.422075 ], [ -11.553398, 13.141214 ], [ -11.467899, 12.754519 ], [ -11.513943, 12.442988 ], [ -11.658301, 12.386583 ], [ -12.203565, 12.465648 ], [ -12.278599, 12.35444 ], [ -12.499051, 12.33209 ], [ -13.217818, 12.575874 ], [ -13.700476, 12.586183 ], [ -15.548477, 12.62817 ], [ -15.816574, 12.515567 ], [ -16.147717, 12.547762 ], [ -16.677452, 12.384852 ], [ -16.841525, 13.151394 ], [ -15.931296, 13.130284 ], [ -15.691001, 13.270353 ], [ -15.511813, 13.27857 ], [ -15.141163, 13.509512 ], [ -14.712197, 13.298207 ], [ -14.277702, 13.280585 ], [ -13.844963, 13.505042 ], [ -14.046992, 13.794068 ], [ -14.376714, 13.62568 ], [ -14.687031, 13.630357 ], [ -15.081735, 13.876492 ], [ -15.39877, 13.860369 ], [ -15.624596, 13.623587 ], [ -16.713729, 13.594959 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "SLB", "name": "Solomon Islands" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 162.119025, -10.482719 ], [ 162.398646, -10.826367 ], [ 161.700032, -10.820011 ], [ 161.319797, -10.204751 ], [ 161.917383, -10.446701 ], [ 162.119025, -10.482719 ] ] ], [ [ [ 160.852229, -9.872937 ], [ 160.462588, -9.89521 ], [ 159.849447, -9.794027 ], [ 159.640003, -9.63998 ], [ 159.702945, -9.24295 ], [ 160.362956, -9.400304 ], [ 160.688518, -9.610162 ], [ 160.852229, -9.872937 ] ] ], [ [ [ 161.679982, -9.599982 ], [ 161.529397, -9.784312 ], [ 160.788253, -8.917543 ], [ 160.579997, -8.320009 ], [ 160.920028, -8.320009 ], [ 161.280006, -9.120011 ], [ 161.679982, -9.599982 ] ] ], [ [ [ 159.875027, -8.33732 ], [ 159.917402, -8.53829 ], [ 159.133677, -8.114181 ], [ 158.586114, -7.754824 ], [ 158.21115, -7.421872 ], [ 158.359978, -7.320018 ], [ 158.820001, -7.560003 ], [ 159.640003, -8.020027 ], [ 159.875027, -8.33732 ] ] ], [ [ [ 157.538426, -7.34782 ], [ 157.33942, -7.404767 ], [ 156.90203, -7.176874 ], [ 156.491358, -6.765943 ], [ 156.542828, -6.599338 ], [ 157.14, -7.021638 ], [ 157.538426, -7.34782 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "SLE", "name": "Sierra Leone" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -11.438779, 6.785917 ], [ -11.708195, 6.860098 ], [ -12.428099, 7.262942 ], [ -12.949049, 7.798646 ], [ -13.124025, 8.163946 ], [ -13.24655, 8.903049 ], [ -12.711958, 9.342712 ], [ -12.596719, 9.620188 ], [ -12.425929, 9.835834 ], [ -12.150338, 9.858572 ], [ -11.917277, 10.046984 ], [ -11.117481, 10.045873 ], [ -10.839152, 9.688246 ], [ -10.622395, 9.26791 ], [ -10.65477, 8.977178 ], [ -10.494315, 8.715541 ], [ -10.505477, 8.348896 ], [ -10.230094, 8.406206 ], [ -10.695595, 7.939464 ], [ -11.146704, 7.396706 ], [ -11.199802, 7.105846 ], [ -11.438779, 6.785917 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "SLV", "name": "El Salvador" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -87.793111, 13.38448 ], [ -87.904112, 13.149017 ], [ -88.483302, 13.163951 ], [ -88.843228, 13.259734 ], [ -89.256743, 13.458533 ], [ -89.812394, 13.520622 ], [ -90.095555, 13.735338 ], [ -90.064678, 13.88197 ], [ -89.721934, 14.134228 ], [ -89.534219, 14.244816 ], [ -89.587343, 14.362586 ], [ -89.353326, 14.424133 ], [ -89.058512, 14.340029 ], [ -88.843073, 14.140507 ], [ -88.541231, 13.980155 ], [ -88.503998, 13.845486 ], [ -88.065343, 13.964626 ], [ -87.859515, 13.893312 ], [ -87.723503, 13.78505 ], [ -87.793111, 13.38448 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "XXX", "name": "Somaliland" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 48.93813, 9.451749 ], [ 48.486736, 8.837626 ], [ 47.78942, 8.003 ], [ 46.948328, 7.996877 ], [ 43.67875, 9.18358 ], [ 43.296975, 9.540477 ], [ 42.92812, 10.02194 ], [ 42.55876, 10.57258 ], [ 42.776852, 10.926879 ], [ 43.145305, 11.46204 ], [ 43.47066, 11.27771 ], [ 43.666668, 10.864169 ], [ 44.117804, 10.445538 ], [ 44.614259, 10.442205 ], [ 45.556941, 10.698029 ], [ 46.645401, 10.816549 ], [ 47.525658, 11.127228 ], [ 48.021596, 11.193064 ], [ 48.378784, 11.375482 ], [ 48.948206, 11.410622 ], [ 48.942005, 11.394266 ], [ 48.938491, 10.982327 ], [ 48.938233, 9.9735 ], [ 48.93813, 9.451749 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "SOM", "name": "Somalia" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 49.72862, 11.5789 ], [ 50.25878, 11.67957 ], [ 50.73202, 12.0219 ], [ 51.1112, 12.02464 ], [ 51.13387, 11.74815 ], [ 51.04153, 11.16651 ], [ 51.04531, 10.6409 ], [ 50.83418, 10.27972 ], [ 50.55239, 9.19874 ], [ 50.07092, 8.08173 ], [ 49.4527, 6.80466 ], [ 48.59455, 5.33911 ], [ 47.74079, 4.2194 ], [ 46.56476, 2.85529 ], [ 45.56399, 2.04576 ], [ 44.06815, 1.05283 ], [ 43.13597, 0.2922 ], [ 42.04157, -0.91916 ], [ 41.81095, -1.44647 ], [ 41.58513, -1.68325 ], [ 40.993, -0.85829 ], [ 40.98105, 2.78452 ], [ 41.855083, 3.918912 ], [ 42.12861, 4.23413 ], [ 42.76967, 4.25259 ], [ 43.66087, 4.95755 ], [ 44.9636, 5.00162 ], [ 47.78942, 8.003 ], [ 48.486736, 8.837626 ], [ 48.93813, 9.451749 ], [ 48.938233, 9.9735 ], [ 48.938491, 10.982327 ], [ 48.942005, 11.394266 ], [ 48.948205, 11.410617 ], [ 49.26776, 11.43033 ], [ 49.72862, 11.5789 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "SRB", "name": "Republic of Serbia" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 20.874313, 45.416375 ], [ 21.483526, 45.18117 ], [ 21.562023, 44.768947 ], [ 22.145088, 44.478422 ], [ 22.459022, 44.702517 ], [ 22.705726, 44.578003 ], [ 22.474008, 44.409228 ], [ 22.65715, 44.234923 ], [ 22.410446, 44.008063 ], [ 22.500157, 43.642814 ], [ 22.986019, 43.211161 ], [ 22.604801, 42.898519 ], [ 22.436595, 42.580321 ], [ 22.545012, 42.461362 ], [ 22.380526, 42.32026 ], [ 21.91708, 42.30364 ], [ 21.576636, 42.245224 ], [ 21.54332, 42.32025 ], [ 21.66292, 42.43922 ], [ 21.77505, 42.6827 ], [ 21.63302, 42.67717 ], [ 21.43866, 42.86255 ], [ 21.27421, 42.90959 ], [ 21.143395, 43.068685 ], [ 20.95651, 43.13094 ], [ 20.81448, 43.27205 ], [ 20.63508, 43.21671 ], [ 20.49679, 42.88469 ], [ 20.25758, 42.81275 ], [ 20.3398, 42.89852 ], [ 19.95857, 43.10604 ], [ 19.63, 43.21378 ], [ 19.48389, 43.35229 ], [ 19.21852, 43.52384 ], [ 19.454, 43.5681 ], [ 19.59976, 44.03847 ], [ 19.11761, 44.42307 ], [ 19.36803, 44.863 ], [ 19.00548, 44.86023 ], [ 19.390476, 45.236516 ], [ 19.072769, 45.521511 ], [ 18.82982, 45.90888 ], [ 19.596045, 46.17173 ], [ 20.220192, 46.127469 ], [ 20.762175, 45.734573 ], [ 20.874313, 45.416375 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "SUR", "name": "Suriname" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -57.147436, 5.97315 ], [ -55.949318, 5.772878 ], [ -55.84178, 5.953125 ], [ -55.03325, 6.025291 ], [ -53.958045, 5.756548 ], [ -54.478633, 4.896756 ], [ -54.399542, 4.212611 ], [ -54.006931, 3.620038 ], [ -54.181726, 3.18978 ], [ -54.269705, 2.732392 ], [ -54.524754, 2.311849 ], [ -55.097587, 2.523748 ], [ -55.569755, 2.421506 ], [ -55.973322, 2.510364 ], [ -56.073342, 2.220795 ], [ -55.9056, 2.021996 ], [ -55.995698, 1.817667 ], [ -56.539386, 1.899523 ], [ -57.150098, 2.768927 ], [ -57.281433, 3.333492 ], [ -57.601569, 3.334655 ], [ -58.044694, 4.060864 ], [ -57.86021, 4.576801 ], [ -57.914289, 4.812626 ], [ -57.307246, 5.073567 ], [ -57.147436, 5.97315 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "SVK", "name": "Slovakia" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 18.853144, 49.49623 ], [ 18.909575, 49.435846 ], [ 19.320713, 49.571574 ], [ 19.825023, 49.217125 ], [ 20.415839, 49.431453 ], [ 20.887955, 49.328772 ], [ 21.607808, 49.470107 ], [ 22.558138, 49.085738 ], [ 22.280842, 48.825392 ], [ 22.085608, 48.422264 ], [ 21.872236, 48.319971 ], [ 20.801294, 48.623854 ], [ 20.473562, 48.56285 ], [ 20.239054, 48.327567 ], [ 19.769471, 48.202691 ], [ 19.661364, 48.266615 ], [ 19.174365, 48.111379 ], [ 18.777025, 48.081768 ], [ 18.696513, 47.880954 ], [ 17.857133, 47.758429 ], [ 17.488473, 47.867466 ], [ 16.979667, 48.123497 ], [ 16.879983, 48.470013 ], [ 16.960288, 48.596982 ], [ 17.101985, 48.816969 ], [ 17.545007, 48.800019 ], [ 17.886485, 48.903475 ], [ 17.913512, 48.996493 ], [ 18.104973, 49.043983 ], [ 18.170498, 49.271515 ], [ 18.399994, 49.315001 ], [ 18.554971, 49.495015 ], [ 18.853144, 49.49623 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "SVN", "name": "Slovenia" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 13.806475, 46.509306 ], [ 14.632472, 46.431817 ], [ 15.137092, 46.658703 ], [ 16.011664, 46.683611 ], [ 16.202298, 46.852386 ], [ 16.370505, 46.841327 ], [ 16.564808, 46.503751 ], [ 15.768733, 46.238108 ], [ 15.67153, 45.834154 ], [ 15.323954, 45.731783 ], [ 15.327675, 45.452316 ], [ 14.935244, 45.471695 ], [ 14.595109, 45.634941 ], [ 14.411968, 45.466166 ], [ 13.71506, 45.500324 ], [ 13.93763, 45.591016 ], [ 13.69811, 46.016778 ], [ 13.806475, 46.509306 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "SWE", "name": "Sweden" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 22.183173, 65.723741 ], [ 21.213517, 65.026005 ], [ 21.369631, 64.413588 ], [ 19.778876, 63.609554 ], [ 17.847779, 62.7494 ], [ 17.119555, 61.341166 ], [ 17.831346, 60.636583 ], [ 18.787722, 60.081914 ], [ 17.869225, 58.953766 ], [ 16.829185, 58.719827 ], [ 16.44771, 57.041118 ], [ 15.879786, 56.104302 ], [ 14.666681, 56.200885 ], [ 14.100721, 55.407781 ], [ 12.942911, 55.361737 ], [ 12.625101, 56.30708 ], [ 11.787942, 57.441817 ], [ 11.027369, 58.856149 ], [ 11.468272, 59.432393 ], [ 12.300366, 60.117933 ], [ 12.631147, 61.293572 ], [ 11.992064, 61.800362 ], [ 11.930569, 63.128318 ], [ 12.579935, 64.066219 ], [ 13.571916, 64.049114 ], [ 13.919905, 64.445421 ], [ 13.55569, 64.787028 ], [ 15.108411, 66.193867 ], [ 16.108712, 67.302456 ], [ 16.768879, 68.013937 ], [ 17.729182, 68.010552 ], [ 17.993868, 68.567391 ], [ 19.87856, 68.407194 ], [ 20.025269, 69.065139 ], [ 20.645593, 69.106247 ], [ 21.978535, 68.616846 ], [ 23.539473, 67.936009 ], [ 23.56588, 66.396051 ], [ 23.903379, 66.006927 ], [ 22.183173, 65.723741 ] ] ], [ [ [ 17.061767, 57.385783 ], [ 17.210083, 57.326521 ], [ 16.430053, 56.179196 ], [ 16.364135, 56.556455 ], [ 17.061767, 57.385783 ] ] ], [ [ [ 19.35791, 57.958588 ], [ 18.8031, 57.651279 ], [ 18.825073, 57.444949 ], [ 18.995361, 57.441993 ], [ 18.951416, 57.370976 ], [ 18.693237, 57.305756 ], [ 18.709716, 57.204734 ], [ 18.462524, 57.127295 ], [ 18.319702, 56.926992 ], [ 18.105468, 56.891003 ], [ 18.187866, 57.109402 ], [ 18.072509, 57.267163 ], [ 18.154907, 57.394664 ], [ 18.094482, 57.545312 ], [ 18.660278, 57.929434 ], [ 19.039306, 57.941098 ], [ 19.105224, 57.993543 ], [ 19.374389, 57.996454 ], [ 19.35791, 57.958588 ] ] ], [ [ [ 20.846557, 63.82371 ], [ 21.066284, 63.829768 ], [ 20.9729, 63.71567 ], [ 20.824584, 63.579121 ], [ 20.695495, 63.59134 ], [ 20.819091, 63.714454 ], [ 20.799865, 63.780059 ], [ 20.846557, 63.82371 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "SWZ", "name": "Swaziland" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 32.071665, -26.73382 ], [ 31.86806, -27.177927 ], [ 31.282773, -27.285879 ], [ 30.685962, -26.743845 ], [ 30.676609, -26.398078 ], [ 30.949667, -26.022649 ], [ 31.04408, -25.731452 ], [ 31.333158, -25.660191 ], [ 31.837778, -25.843332 ], [ 31.985779, -26.29178 ], [ 32.071665, -26.73382 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "SYR", "name": "Syria" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 38.792341, 33.378686 ], [ 36.834062, 32.312938 ], [ 35.719918, 32.709192 ], [ 35.700798, 32.716014 ], [ 35.836397, 32.868123 ], [ 35.821101, 33.277426 ], [ 36.06646, 33.824912 ], [ 36.61175, 34.201789 ], [ 36.448194, 34.593935 ], [ 35.998403, 34.644914 ], [ 35.905023, 35.410009 ], [ 36.149763, 35.821535 ], [ 36.41755, 36.040617 ], [ 36.685389, 36.259699 ], [ 36.739494, 36.81752 ], [ 37.066761, 36.623036 ], [ 38.167727, 36.90121 ], [ 38.699891, 36.712927 ], [ 39.52258, 36.716054 ], [ 40.673259, 37.091276 ], [ 41.212089, 37.074352 ], [ 42.349591, 37.229873 ], [ 41.837064, 36.605854 ], [ 41.289707, 36.358815 ], [ 41.383965, 35.628317 ], [ 41.006159, 34.419372 ], [ 38.792341, 33.378686 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "TCD", "name": "Chad" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 14.495787, 12.859396 ], [ 14.595781, 13.330427 ], [ 13.954477, 13.353449 ], [ 13.956699, 13.996691 ], [ 13.540394, 14.367134 ], [ 13.97217, 15.68437 ], [ 15.247731, 16.627306 ], [ 15.300441, 17.92795 ], [ 15.685741, 19.95718 ], [ 15.903247, 20.387619 ], [ 15.487148, 20.730415 ], [ 15.47106, 21.04845 ], [ 15.096888, 21.308519 ], [ 14.8513, 22.86295 ], [ 15.86085, 23.40972 ], [ 19.84926, 21.49509 ], [ 23.83766, 19.58047 ], [ 23.88689, 15.61084 ], [ 23.02459, 15.68072 ], [ 22.56795, 14.94429 ], [ 22.30351, 14.32682 ], [ 22.51202, 14.09318 ], [ 22.18329, 13.78648 ], [ 22.29658, 13.37232 ], [ 22.03759, 12.95546 ], [ 21.93681, 12.58818 ], [ 22.28801, 12.64605 ], [ 22.49762, 12.26024 ], [ 22.50869, 11.67936 ], [ 22.87622, 11.38461 ], [ 22.864165, 11.142395 ], [ 22.231129, 10.971889 ], [ 21.723822, 10.567056 ], [ 21.000868, 9.475985 ], [ 20.059685, 9.012706 ], [ 19.094008, 9.074847 ], [ 18.81201, 8.982915 ], [ 18.911022, 8.630895 ], [ 18.389555, 8.281304 ], [ 17.96493, 7.890914 ], [ 16.705988, 7.508328 ], [ 16.456185, 7.734774 ], [ 16.290562, 7.754307 ], [ 16.106232, 7.497088 ], [ 15.27946, 7.421925 ], [ 15.436092, 7.692812 ], [ 15.120866, 8.38215 ], [ 14.979996, 8.796104 ], [ 14.544467, 8.965861 ], [ 13.954218, 9.549495 ], [ 14.171466, 10.021378 ], [ 14.627201, 9.920919 ], [ 14.909354, 9.992129 ], [ 15.467873, 9.982337 ], [ 14.923565, 10.891325 ], [ 14.960152, 11.555574 ], [ 14.89336, 12.21905 ], [ 14.495787, 12.859396 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "TGO", "name": "Togo" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 1.865241, 6.142158 ], [ 1.060122, 5.928837 ], [ 0.836931, 6.279979 ], [ 0.570384, 6.914359 ], [ 0.490957, 7.411744 ], [ 0.712029, 8.312465 ], [ 0.461192, 8.677223 ], [ 0.365901, 9.465004 ], [ 0.36758, 10.191213 ], [ -0.049785, 10.706918 ], [ 0.023803, 11.018682 ], [ 0.899563, 10.997339 ], [ 0.772336, 10.470808 ], [ 1.077795, 10.175607 ], [ 1.425061, 9.825395 ], [ 1.463043, 9.334624 ], [ 1.664478, 9.12859 ], [ 1.618951, 6.832038 ], [ 1.865241, 6.142158 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "THA", "name": "Thailand" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 102.584932, 12.186595 ], [ 101.687158, 12.64574 ], [ 100.83181, 12.627085 ], [ 100.978467, 13.412722 ], [ 100.097797, 13.406856 ], [ 100.018733, 12.307001 ], [ 99.478921, 10.846367 ], [ 99.153772, 9.963061 ], [ 99.222399, 9.239255 ], [ 99.873832, 9.207862 ], [ 100.279647, 8.295153 ], [ 100.459274, 7.429573 ], [ 101.017328, 6.856869 ], [ 101.623079, 6.740622 ], [ 102.141187, 6.221636 ], [ 101.814282, 5.810808 ], [ 101.154219, 5.691384 ], [ 101.075516, 6.204867 ], [ 100.259596, 6.642825 ], [ 100.085757, 6.464489 ], [ 99.690691, 6.848213 ], [ 99.519642, 7.343454 ], [ 98.988253, 7.907993 ], [ 98.503786, 8.382305 ], [ 98.339662, 7.794512 ], [ 98.150009, 8.350007 ], [ 98.25915, 8.973923 ], [ 98.553551, 9.93296 ], [ 99.038121, 10.960546 ], [ 99.587286, 11.892763 ], [ 99.196354, 12.804748 ], [ 99.212012, 13.269294 ], [ 99.097755, 13.827503 ], [ 98.430819, 14.622028 ], [ 98.192074, 15.123703 ], [ 98.537376, 15.308497 ], [ 98.903348, 16.177824 ], [ 98.493761, 16.837836 ], [ 97.859123, 17.567946 ], [ 97.375896, 18.445438 ], [ 97.797783, 18.62708 ], [ 98.253724, 19.708203 ], [ 98.959676, 19.752981 ], [ 99.543309, 20.186598 ], [ 100.115988, 20.41785 ], [ 100.548881, 20.109238 ], [ 100.606294, 19.508344 ], [ 101.282015, 19.462585 ], [ 101.035931, 18.408928 ], [ 101.059548, 17.512497 ], [ 102.113592, 18.109102 ], [ 102.413005, 17.932782 ], [ 102.998706, 17.961695 ], [ 103.200192, 18.309632 ], [ 103.956477, 18.240954 ], [ 104.716947, 17.428859 ], [ 104.779321, 16.441865 ], [ 105.589039, 15.570316 ], [ 105.544338, 14.723934 ], [ 105.218777, 14.273212 ], [ 104.281418, 14.416743 ], [ 102.988422, 14.225721 ], [ 102.348099, 13.394247 ], [ 102.584932, 12.186595 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "TJK", "name": "Tajikistan" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 71.014198, 40.244366 ], [ 70.648019, 39.935754 ], [ 69.55961, 40.103211 ], [ 69.464887, 39.526683 ], [ 70.549162, 39.604198 ], [ 71.784694, 39.279463 ], [ 73.675379, 39.431237 ], [ 73.928852, 38.505815 ], [ 74.257514, 38.606507 ], [ 74.864816, 38.378846 ], [ 74.829986, 37.990007 ], [ 74.980002, 37.41999 ], [ 73.948696, 37.421566 ], [ 73.260056, 37.495257 ], [ 72.63689, 37.047558 ], [ 72.193041, 36.948288 ], [ 71.844638, 36.738171 ], [ 71.448693, 37.065645 ], [ 71.541918, 37.905774 ], [ 71.239404, 37.953265 ], [ 71.348131, 38.258905 ], [ 70.806821, 38.486282 ], [ 70.376304, 38.138396 ], [ 70.270574, 37.735165 ], [ 70.116578, 37.588223 ], [ 69.518785, 37.608997 ], [ 69.196273, 37.151144 ], [ 68.859446, 37.344336 ], [ 68.135562, 37.023115 ], [ 67.83, 37.144994 ], [ 68.392033, 38.157025 ], [ 68.176025, 38.901553 ], [ 67.44222, 39.140144 ], [ 67.701429, 39.580478 ], [ 68.536416, 39.533453 ], [ 69.011633, 40.086158 ], [ 69.329495, 40.727824 ], [ 70.666622, 40.960213 ], [ 70.45816, 40.496495 ], [ 70.601407, 40.218527 ], [ 71.014198, 40.244366 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "TKM", "name": "Turkmenistan" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 61.210817, 35.650072 ], [ 61.123071, 36.491597 ], [ 60.377638, 36.527383 ], [ 59.234762, 37.412988 ], [ 58.436154, 37.522309 ], [ 57.330434, 38.029229 ], [ 56.619366, 38.121394 ], [ 56.180375, 37.935127 ], [ 55.511578, 37.964117 ], [ 54.800304, 37.392421 ], [ 53.921598, 37.198918 ], [ 53.735511, 37.906136 ], [ 53.880929, 38.952093 ], [ 53.101028, 39.290574 ], [ 53.357808, 39.975286 ], [ 52.693973, 40.033629 ], [ 52.915251, 40.876523 ], [ 53.858139, 40.631034 ], [ 54.736845, 40.951015 ], [ 54.008311, 41.551211 ], [ 53.721713, 42.123191 ], [ 52.91675, 41.868117 ], [ 52.814689, 41.135371 ], [ 52.50246, 41.783316 ], [ 52.944293, 42.116034 ], [ 54.079418, 42.324109 ], [ 54.755345, 42.043971 ], [ 55.455251, 41.259859 ], [ 55.968191, 41.308642 ], [ 57.096391, 41.32231 ], [ 56.932215, 41.826026 ], [ 57.78653, 42.170553 ], [ 58.629011, 42.751551 ], [ 59.976422, 42.223082 ], [ 60.083341, 41.425146 ], [ 60.465953, 41.220327 ], [ 61.547179, 41.26637 ], [ 61.882714, 41.084857 ], [ 62.37426, 40.053886 ], [ 63.518015, 39.363257 ], [ 64.170223, 38.892407 ], [ 65.215999, 38.402695 ], [ 66.54615, 37.974685 ], [ 66.518607, 37.362784 ], [ 66.217385, 37.39379 ], [ 65.745631, 37.661164 ], [ 65.588948, 37.305217 ], [ 64.746105, 37.111818 ], [ 64.546479, 36.312073 ], [ 63.982896, 36.007957 ], [ 63.193538, 35.857166 ], [ 62.984662, 35.404041 ], [ 62.230651, 35.270664 ], [ 61.210817, 35.650072 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "TLS", "name": "East Timor" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 124.968682, -8.89279 ], [ 125.086246, -8.656887 ], [ 125.947072, -8.432095 ], [ 126.644704, -8.398247 ], [ 126.957243, -8.273345 ], [ 127.335928, -8.397317 ], [ 126.967992, -8.668256 ], [ 125.925885, -9.106007 ], [ 125.08852, -9.393173 ], [ 125.07002, -9.089987 ], [ 124.968682, -8.89279 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "TTO", "name": "Trinidad and Tobago" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -61.68, 10.76 ], [ -61.105, 10.89 ], [ -60.895, 10.855 ], [ -60.935, 10.11 ], [ -61.77, 10.0 ], [ -61.95, 10.09 ], [ -61.66, 10.365 ], [ -61.68, 10.76 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "TUN", "name": "Tunisia" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 9.48214, 30.307556 ], [ 9.055603, 32.102692 ], [ 8.439103, 32.506285 ], [ 8.430473, 32.748337 ], [ 7.612642, 33.344115 ], [ 7.524482, 34.097376 ], [ 8.140981, 34.655146 ], [ 8.376368, 35.479876 ], [ 8.217824, 36.433177 ], [ 8.420964, 36.946427 ], [ 9.509994, 37.349994 ], [ 10.210002, 37.230002 ], [ 10.18065, 36.724038 ], [ 11.028867, 37.092103 ], [ 11.100026, 36.899996 ], [ 10.600005, 36.41 ], [ 10.593287, 35.947444 ], [ 10.939519, 35.698984 ], [ 10.807847, 34.833507 ], [ 10.149593, 34.330773 ], [ 10.339659, 33.785742 ], [ 10.856836, 33.76874 ], [ 11.108501, 33.293343 ], [ 11.488787, 33.136996 ], [ 11.432253, 32.368903 ], [ 10.94479, 32.081815 ], [ 10.636901, 31.761421 ], [ 9.950225, 31.37607 ], [ 10.056575, 30.961831 ], [ 9.970017, 30.539325 ], [ 9.48214, 30.307556 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "TUR", "name": "Turkey" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 36.913127, 41.335358 ], [ 38.347665, 40.948586 ], [ 39.512607, 41.102763 ], [ 40.373433, 41.013673 ], [ 41.554084, 41.535656 ], [ 42.619549, 41.583173 ], [ 43.582746, 41.092143 ], [ 43.752658, 40.740201 ], [ 43.656436, 40.253564 ], [ 44.400009, 40.005 ], [ 44.79399, 39.713003 ], [ 44.109225, 39.428136 ], [ 44.421403, 38.281281 ], [ 44.225756, 37.971584 ], [ 44.772699, 37.170445 ], [ 44.293452, 37.001514 ], [ 43.942259, 37.256228 ], [ 42.779126, 37.385264 ], [ 42.349591, 37.229873 ], [ 41.212089, 37.074352 ], [ 40.673259, 37.091276 ], [ 39.52258, 36.716054 ], [ 38.699891, 36.712927 ], [ 38.167727, 36.90121 ], [ 37.066761, 36.623036 ], [ 36.739494, 36.81752 ], [ 36.685389, 36.259699 ], [ 36.41755, 36.040617 ], [ 36.149763, 35.821535 ], [ 35.782085, 36.274995 ], [ 36.160822, 36.650606 ], [ 35.550936, 36.565443 ], [ 34.714553, 36.795532 ], [ 34.026895, 36.21996 ], [ 32.509158, 36.107564 ], [ 31.699595, 36.644275 ], [ 30.621625, 36.677865 ], [ 30.391096, 36.262981 ], [ 29.699976, 36.144357 ], [ 28.732903, 36.676831 ], [ 27.641187, 36.658822 ], [ 27.048768, 37.653361 ], [ 26.318218, 38.208133 ], [ 26.8047, 38.98576 ], [ 26.170785, 39.463612 ], [ 27.28002, 40.420014 ], [ 28.819978, 40.460011 ], [ 29.240004, 41.219991 ], [ 31.145934, 41.087622 ], [ 32.347979, 41.736264 ], [ 33.513283, 42.01896 ], [ 35.167704, 42.040225 ], [ 36.913127, 41.335358 ] ] ], [ [ [ 27.192377, 40.690566 ], [ 26.358009, 40.151994 ], [ 26.043351, 40.617754 ], [ 26.056942, 40.824123 ], [ 26.294602, 40.936261 ], [ 26.604196, 41.562115 ], [ 26.117042, 41.826905 ], [ 27.135739, 42.141485 ], [ 27.99672, 42.007359 ], [ 28.115525, 41.622886 ], [ 28.988443, 41.299934 ], [ 28.806438, 41.054962 ], [ 27.619017, 40.999823 ], [ 27.192377, 40.690566 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "TWN", "name": "Taiwan" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 121.777818, 24.394274 ], [ 121.175632, 22.790857 ], [ 120.74708, 21.970571 ], [ 120.220083, 22.814861 ], [ 120.106189, 23.556263 ], [ 120.69468, 24.538451 ], [ 121.495044, 25.295459 ], [ 121.951244, 24.997596 ], [ 121.777818, 24.394274 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "TZA", "name": "United Republic of Tanzania" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 33.903711, -0.95 ], [ 34.07262, -1.05982 ], [ 37.69869, -3.09699 ], [ 37.7669, -3.67712 ], [ 39.20222, -4.67677 ], [ 38.74054, -5.90895 ], [ 38.79977, -6.47566 ], [ 39.44, -6.84 ], [ 39.47, -7.1 ], [ 39.19469, -7.7039 ], [ 39.25203, -8.00781 ], [ 39.18652, -8.48551 ], [ 39.53574, -9.11237 ], [ 39.9496, -10.0984 ], [ 40.31659, -10.3171 ], [ 39.521, -10.89688 ], [ 38.427557, -11.285202 ], [ 37.82764, -11.26879 ], [ 37.47129, -11.56876 ], [ 36.775151, -11.594537 ], [ 36.514082, -11.720938 ], [ 35.312398, -11.439146 ], [ 34.559989, -11.52002 ], [ 34.28, -10.16 ], [ 33.940838, -9.693674 ], [ 33.73972, -9.41715 ], [ 32.759375, -9.230599 ], [ 32.191865, -8.930359 ], [ 31.556348, -8.762049 ], [ 31.157751, -8.594579 ], [ 30.74, -8.34 ], [ 30.2, -7.08 ], [ 29.62, -6.52 ], [ 29.419993, -5.939999 ], [ 29.519987, -5.419979 ], [ 29.339998, -4.499983 ], [ 29.753512, -4.452389 ], [ 30.11632, -4.09012 ], [ 30.50554, -3.56858 ], [ 30.75224, -3.35931 ], [ 30.74301, -3.03431 ], [ 30.52766, -2.80762 ], [ 30.46967, -2.41383 ], [ 30.758309, -2.28725 ], [ 30.816135, -1.698914 ], [ 30.419105, -1.134659 ], [ 30.76986, -1.01455 ], [ 31.86617, -1.02736 ], [ 33.903711, -0.95 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "UGA", "name": "Uganda" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 31.86617, -1.02736 ], [ 30.76986, -1.01455 ], [ 30.419105, -1.134659 ], [ 29.821519, -1.443322 ], [ 29.579466, -1.341313 ], [ 29.587838, -0.587406 ], [ 29.8195, -0.2053 ], [ 29.875779, 0.59738 ], [ 30.086154, 1.062313 ], [ 30.468508, 1.583805 ], [ 30.85267, 1.849396 ], [ 31.174149, 2.204465 ], [ 30.77332, 2.33989 ], [ 30.83385, 3.50917 ], [ 31.24556, 3.7819 ], [ 31.88145, 3.55827 ], [ 32.68642, 3.79232 ], [ 33.39, 3.79 ], [ 34.005, 4.249885 ], [ 34.47913, 3.5556 ], [ 34.59607, 3.05374 ], [ 35.03599, 1.90584 ], [ 34.6721, 1.17694 ], [ 34.18, 0.515 ], [ 33.893569, 0.109814 ], [ 33.903711, -0.95 ], [ 31.86617, -1.02736 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "UKR", "name": "Ukraine" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 31.785998, 52.101678 ], [ 32.159412, 52.061267 ], [ 32.412058, 52.288695 ], [ 32.715761, 52.238465 ], [ 33.7527, 52.335075 ], [ 34.391731, 51.768882 ], [ 34.141978, 51.566413 ], [ 34.224816, 51.255993 ], [ 35.022183, 51.207572 ], [ 35.377924, 50.773955 ], [ 35.356116, 50.577197 ], [ 36.626168, 50.225591 ], [ 37.39346, 50.383953 ], [ 38.010631, 49.915662 ], [ 38.594988, 49.926462 ], [ 40.069058, 49.601055 ], [ 40.080789, 49.30743 ], [ 39.674664, 48.783818 ], [ 39.895632, 48.232405 ], [ 39.738278, 47.898937 ], [ 38.770585, 47.825608 ], [ 38.255112, 47.5464 ], [ 38.223538, 47.10219 ], [ 37.425137, 47.022221 ], [ 36.759855, 46.6987 ], [ 35.823685, 46.645964 ], [ 34.962342, 46.273197 ], [ 35.020788, 45.651219 ], [ 35.510009, 45.409993 ], [ 36.529998, 45.46999 ], [ 36.334713, 45.113216 ], [ 35.239999, 44.939996 ], [ 33.882511, 44.361479 ], [ 33.326421, 44.564877 ], [ 33.546924, 45.034771 ], [ 32.454174, 45.327466 ], [ 32.630804, 45.519186 ], [ 33.588162, 45.851569 ], [ 33.298567, 46.080598 ], [ 31.74414, 46.333348 ], [ 31.675307, 46.706245 ], [ 30.748749, 46.5831 ], [ 30.377609, 46.03241 ], [ 29.603289, 45.293308 ], [ 29.149725, 45.464925 ], [ 28.679779, 45.304031 ], [ 28.233554, 45.488283 ], [ 28.485269, 45.596907 ], [ 28.659987, 45.939987 ], [ 28.933717, 46.25883 ], [ 28.862972, 46.437889 ], [ 29.072107, 46.517678 ], [ 29.170654, 46.379262 ], [ 29.759972, 46.349988 ], [ 30.024659, 46.423937 ], [ 29.83821, 46.525326 ], [ 29.908852, 46.674361 ], [ 29.559674, 46.928583 ], [ 29.415135, 47.346645 ], [ 29.050868, 47.510227 ], [ 29.122698, 47.849095 ], [ 28.670891, 48.118149 ], [ 28.259547, 48.155562 ], [ 27.522537, 48.467119 ], [ 26.857824, 48.368211 ], [ 26.619337, 48.220726 ], [ 26.19745, 48.220881 ], [ 25.945941, 47.987149 ], [ 25.207743, 47.891056 ], [ 24.866317, 47.737526 ], [ 24.402056, 47.981878 ], [ 23.760958, 47.985598 ], [ 23.142236, 48.096341 ], [ 22.710531, 47.882194 ], [ 22.64082, 48.15024 ], [ 22.085608, 48.422264 ], [ 22.280842, 48.825392 ], [ 22.558138, 49.085738 ], [ 22.776419, 49.027395 ], [ 22.51845, 49.476774 ], [ 23.426508, 50.308506 ], [ 23.922757, 50.424881 ], [ 24.029986, 50.705407 ], [ 23.527071, 51.578454 ], [ 24.005078, 51.617444 ], [ 24.553106, 51.888461 ], [ 25.327788, 51.910656 ], [ 26.337959, 51.832289 ], [ 27.454066, 51.592303 ], [ 28.241615, 51.572227 ], [ 28.617613, 51.427714 ], [ 28.992835, 51.602044 ], [ 29.254938, 51.368234 ], [ 30.157364, 51.416138 ], [ 30.555117, 51.319503 ], [ 30.619454, 51.822806 ], [ 30.927549, 52.042353 ], [ 31.785998, 52.101678 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "URY", "name": "Uruguay" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -57.625133, -30.216295 ], [ -56.976026, -30.109686 ], [ -55.973245, -30.883076 ], [ -55.60151, -30.853879 ], [ -54.572452, -31.494511 ], [ -53.787952, -32.047243 ], [ -53.209589, -32.727666 ], [ -53.650544, -33.202004 ], [ -53.373662, -33.768378 ], [ -53.806426, -34.396815 ], [ -54.935866, -34.952647 ], [ -55.67409, -34.752659 ], [ -56.215297, -34.859836 ], [ -57.139685, -34.430456 ], [ -57.817861, -34.462547 ], [ -58.427074, -33.909454 ], [ -58.349611, -33.263189 ], [ -58.132648, -33.040567 ], [ -58.14244, -32.044504 ], [ -57.874937, -31.016556 ], [ -57.625133, -30.216295 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "USA", "name": "United States of America" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -155.54211, 19.08348 ], [ -155.68817, 18.91619 ], [ -155.93665, 19.05939 ], [ -155.90806, 19.33888 ], [ -156.07347, 19.70294 ], [ -156.02368, 19.81422 ], [ -155.85008, 19.97729 ], [ -155.91907, 20.17395 ], [ -155.86108, 20.26721 ], [ -155.78505, 20.2487 ], [ -155.40214, 20.07975 ], [ -155.22452, 19.99302 ], [ -155.06226, 19.8591 ], [ -154.80741, 19.50871 ], [ -154.83147, 19.45328 ], [ -155.22217, 19.23972 ], [ -155.54211, 19.08348 ] ] ], [ [ [ -156.07926, 20.64397 ], [ -156.41445, 20.57241 ], [ -156.58673, 20.783 ], [ -156.70167, 20.8643 ], [ -156.71055, 20.92676 ], [ -156.61258, 21.01249 ], [ -156.25711, 20.91745 ], [ -155.99566, 20.76404 ], [ -156.07926, 20.64397 ] ] ], [ [ [ -156.75824, 21.17684 ], [ -156.78933, 21.06873 ], [ -157.32521, 21.09777 ], [ -157.25027, 21.21958 ], [ -156.75824, 21.17684 ] ] ], [ [ [ -157.65283, 21.32217 ], [ -157.70703, 21.26442 ], [ -157.7786, 21.27729 ], [ -158.12667, 21.31244 ], [ -158.2538, 21.53919 ], [ -158.29265, 21.57912 ], [ -158.0252, 21.71696 ], [ -157.94161, 21.65272 ], [ -157.65283, 21.32217 ] ] ], [ [ [ -159.34512, 21.982 ], [ -159.46372, 21.88299 ], [ -159.80051, 22.06533 ], [ -159.74877, 22.1382 ], [ -159.5962, 22.23618 ], [ -159.36569, 22.21494 ], [ -159.34512, 21.982 ] ] ], [ [ [ -94.81758, 49.38905 ], [ -94.64, 48.84 ], [ -94.32914, 48.67074 ], [ -93.63087, 48.60926 ], [ -92.61, 48.45 ], [ -91.64, 48.14 ], [ -90.83, 48.27 ], [ -89.6, 48.01 ], [ -89.272917, 48.019808 ], [ -88.378114, 48.302918 ], [ -87.439793, 47.94 ], [ -86.461991, 47.553338 ], [ -85.652363, 47.220219 ], [ -84.87608, 46.900083 ], [ -84.779238, 46.637102 ], [ -84.543749, 46.538684 ], [ -84.6049, 46.4396 ], [ -84.3367, 46.40877 ], [ -84.14212, 46.512226 ], [ -84.091851, 46.275419 ], [ -83.890765, 46.116927 ], [ -83.616131, 46.116927 ], [ -83.469551, 45.994686 ], [ -83.592851, 45.816894 ], [ -82.550925, 45.347517 ], [ -82.337763, 44.44 ], [ -82.137642, 43.571088 ], [ -82.43, 42.98 ], [ -82.9, 42.43 ], [ -83.12, 42.08 ], [ -83.142, 41.975681 ], [ -83.02981, 41.832796 ], [ -82.690089, 41.675105 ], [ -82.439278, 41.675105 ], [ -81.277747, 42.209026 ], [ -80.247448, 42.3662 ], [ -78.939362, 42.863611 ], [ -78.92, 42.965 ], [ -79.01, 43.27 ], [ -79.171674, 43.466339 ], [ -78.72028, 43.625089 ], [ -77.737885, 43.629056 ], [ -76.820034, 43.628784 ], [ -76.5, 44.018459 ], [ -76.375, 44.09631 ], [ -75.31821, 44.81645 ], [ -74.867, 45.00048 ], [ -73.34783, 45.00738 ], [ -71.50506, 45.0082 ], [ -71.405, 45.255 ], [ -71.08482, 45.30524 ], [ -70.66, 45.46 ], [ -70.305, 45.915 ], [ -69.99997, 46.69307 ], [ -69.237216, 47.447781 ], [ -68.905, 47.185 ], [ -68.23444, 47.35486 ], [ -67.79046, 47.06636 ], [ -67.79134, 45.70281 ], [ -67.13741, 45.13753 ], [ -66.96466, 44.8097 ], [ -68.03252, 44.3252 ], [ -69.06, 43.98 ], [ -70.11617, 43.68405 ], [ -70.645476, 43.090238 ], [ -70.81489, 42.8653 ], [ -70.825, 42.335 ], [ -70.495, 41.805 ], [ -70.08, 41.78 ], [ -70.185, 42.145 ], [ -69.88497, 41.92283 ], [ -69.96503, 41.63717 ], [ -70.64, 41.475 ], [ -71.12039, 41.49445 ], [ -71.86, 41.32 ], [ -72.295, 41.27 ], [ -72.87643, 41.22065 ], [ -73.71, 40.931102 ], [ -72.24126, 41.11948 ], [ -71.945, 40.93 ], [ -73.345, 40.63 ], [ -73.982, 40.628 ], [ -73.952325, 40.75075 ], [ -74.25671, 40.47351 ], [ -73.96244, 40.42763 ], [ -74.17838, 39.70926 ], [ -74.90604, 38.93954 ], [ -74.98041, 39.1964 ], [ -75.20002, 39.24845 ], [ -75.52805, 39.4985 ], [ -75.32, 38.96 ], [ -75.071835, 38.782032 ], [ -75.05673, 38.40412 ], [ -75.37747, 38.01551 ], [ -75.94023, 37.21689 ], [ -76.03127, 37.2566 ], [ -75.72205, 37.93705 ], [ -76.23287, 38.319215 ], [ -76.35, 39.15 ], [ -76.542725, 38.717615 ], [ -76.32933, 38.08326 ], [ -76.989998, 38.239992 ], [ -76.30162, 37.917945 ], [ -76.25874, 36.9664 ], [ -75.9718, 36.89726 ], [ -75.86804, 36.55125 ], [ -75.72749, 35.55074 ], [ -76.36318, 34.80854 ], [ -77.397635, 34.51201 ], [ -78.05496, 33.92547 ], [ -78.55435, 33.86133 ], [ -79.06067, 33.49395 ], [ -79.20357, 33.15839 ], [ -80.301325, 32.509355 ], [ -80.86498, 32.0333 ], [ -81.33629, 31.44049 ], [ -81.49042, 30.72999 ], [ -81.31371, 30.03552 ], [ -80.98, 29.18 ], [ -80.535585, 28.47213 ], [ -80.53, 28.04 ], [ -80.056539, 26.88 ], [ -80.088015, 26.205765 ], [ -80.13156, 25.816775 ], [ -80.38103, 25.20616 ], [ -80.68, 25.08 ], [ -81.17213, 25.20126 ], [ -81.33, 25.64 ], [ -81.71, 25.87 ], [ -82.24, 26.73 ], [ -82.70515, 27.49504 ], [ -82.85526, 27.88624 ], [ -82.65, 28.55 ], [ -82.93, 29.1 ], [ -83.70959, 29.93656 ], [ -84.1, 30.09 ], [ -85.10882, 29.63615 ], [ -85.28784, 29.68612 ], [ -85.7731, 30.15261 ], [ -86.4, 30.4 ], [ -87.53036, 30.27433 ], [ -88.41782, 30.3849 ], [ -89.18049, 30.31598 ], [ -89.593831, 30.159994 ], [ -89.413735, 29.89419 ], [ -89.43, 29.48864 ], [ -89.21767, 29.29108 ], [ -89.40823, 29.15961 ], [ -89.77928, 29.30714 ], [ -90.15463, 29.11743 ], [ -90.880225, 29.148535 ], [ -91.626785, 29.677 ], [ -92.49906, 29.5523 ], [ -93.22637, 29.78375 ], [ -93.84842, 29.71363 ], [ -94.69, 29.48 ], [ -95.60026, 28.73863 ], [ -96.59404, 28.30748 ], [ -97.14, 27.83 ], [ -97.37, 27.38 ], [ -97.38, 26.69 ], [ -97.33, 26.21 ], [ -97.14, 25.87 ], [ -97.53, 25.84 ], [ -98.24, 26.06 ], [ -99.02, 26.37 ], [ -99.3, 26.84 ], [ -99.52, 27.54 ], [ -100.11, 28.11 ], [ -100.45584, 28.69612 ], [ -100.9576, 29.38071 ], [ -101.6624, 29.7793 ], [ -102.48, 29.76 ], [ -103.11, 28.97 ], [ -103.94, 29.27 ], [ -104.45697, 29.57196 ], [ -104.70575, 30.12173 ], [ -105.03737, 30.64402 ], [ -105.63159, 31.08383 ], [ -106.1429, 31.39995 ], [ -106.50759, 31.75452 ], [ -108.24, 31.754854 ], [ -108.24194, 31.34222 ], [ -109.035, 31.34194 ], [ -111.02361, 31.33472 ], [ -113.30498, 32.03914 ], [ -114.815, 32.52528 ], [ -114.72139, 32.72083 ], [ -115.99135, 32.61239 ], [ -117.12776, 32.53534 ], [ -117.295938, 33.046225 ], [ -117.944, 33.621236 ], [ -118.410602, 33.740909 ], [ -118.519895, 34.027782 ], [ -119.081, 34.078 ], [ -119.438841, 34.348477 ], [ -120.36778, 34.44711 ], [ -120.62286, 34.60855 ], [ -120.74433, 35.15686 ], [ -121.71457, 36.16153 ], [ -122.54747, 37.55176 ], [ -122.51201, 37.78339 ], [ -122.95319, 38.11371 ], [ -123.7272, 38.95166 ], [ -123.86517, 39.76699 ], [ -124.39807, 40.3132 ], [ -124.17886, 41.14202 ], [ -124.2137, 41.99964 ], [ -124.53284, 42.76599 ], [ -124.14214, 43.70838 ], [ -124.020535, 44.615895 ], [ -123.89893, 45.52341 ], [ -124.079635, 46.86475 ], [ -124.39567, 47.72017 ], [ -124.68721, 48.184433 ], [ -124.566101, 48.379715 ], [ -123.12, 48.04 ], [ -122.58736, 47.096 ], [ -122.34, 47.36 ], [ -122.5, 48.18 ], [ -122.84, 49.0 ], [ -120.0, 49.0 ], [ -117.03121, 49.0 ], [ -116.04818, 49.0 ], [ -113.0, 49.0 ], [ -110.05, 49.0 ], [ -107.05, 49.0 ], [ -104.04826, 48.99986 ], [ -100.65, 49.0 ], [ -97.22872, 49.0007 ], [ -95.15907, 49.0 ], [ -95.15609, 49.38425 ], [ -94.81758, 49.38905 ] ] ], [ [ [ -153.006314, 57.115842 ], [ -154.00509, 56.734677 ], [ -154.516403, 56.992749 ], [ -154.670993, 57.461196 ], [ -153.76278, 57.816575 ], [ -153.228729, 57.968968 ], [ -152.564791, 57.901427 ], [ -152.141147, 57.591059 ], [ -153.006314, 57.115842 ] ] ], [ [ [ -165.579164, 59.909987 ], [ -166.19277, 59.754441 ], [ -166.848337, 59.941406 ], [ -167.455277, 60.213069 ], [ -166.467792, 60.38417 ], [ -165.67443, 60.293607 ], [ -165.579164, 59.909987 ] ] ], [ [ [ -171.731657, 63.782515 ], [ -171.114434, 63.592191 ], [ -170.491112, 63.694975 ], [ -169.682505, 63.431116 ], [ -168.689439, 63.297506 ], [ -168.771941, 63.188598 ], [ -169.52944, 62.976931 ], [ -170.290556, 63.194438 ], [ -170.671386, 63.375822 ], [ -171.553063, 63.317789 ], [ -171.791111, 63.405846 ], [ -171.731657, 63.782515 ] ] ], [ [ [ -155.06779, 71.147776 ], [ -154.344165, 70.696409 ], [ -153.900006, 70.889989 ], [ -152.210006, 70.829992 ], [ -152.270002, 70.600006 ], [ -150.739992, 70.430017 ], [ -149.720003, 70.53001 ], [ -147.613362, 70.214035 ], [ -145.68999, 70.12001 ], [ -144.920011, 69.989992 ], [ -143.589446, 70.152514 ], [ -142.07251, 69.851938 ], [ -140.985988, 69.711998 ], [ -140.992499, 66.000029 ], [ -140.99777, 60.306397 ], [ -140.012998, 60.276838 ], [ -139.039, 60.000007 ], [ -138.34089, 59.56211 ], [ -137.4525, 58.905 ], [ -136.47972, 59.46389 ], [ -135.47583, 59.78778 ], [ -134.945, 59.27056 ], [ -134.27111, 58.86111 ], [ -133.355549, 58.410285 ], [ -132.73042, 57.69289 ], [ -131.70781, 56.55212 ], [ -130.00778, 55.91583 ], [ -129.979994, 55.284998 ], [ -130.53611, 54.802753 ], [ -131.085818, 55.178906 ], [ -131.967211, 55.497776 ], [ -132.250011, 56.369996 ], [ -133.539181, 57.178887 ], [ -134.078063, 58.123068 ], [ -135.038211, 58.187715 ], [ -136.628062, 58.212209 ], [ -137.800006, 58.499995 ], [ -139.867787, 59.537762 ], [ -140.825274, 59.727517 ], [ -142.574444, 60.084447 ], [ -143.958881, 59.99918 ], [ -145.925557, 60.45861 ], [ -147.114374, 60.884656 ], [ -148.224306, 60.672989 ], [ -148.018066, 59.978329 ], [ -148.570823, 59.914173 ], [ -149.727858, 59.705658 ], [ -150.608243, 59.368211 ], [ -151.716393, 59.155821 ], [ -151.859433, 59.744984 ], [ -151.409719, 60.725803 ], [ -150.346941, 61.033588 ], [ -150.621111, 61.284425 ], [ -151.895839, 60.727198 ], [ -152.57833, 60.061657 ], [ -154.019172, 59.350279 ], [ -153.287511, 58.864728 ], [ -154.232492, 58.146374 ], [ -155.307491, 57.727795 ], [ -156.308335, 57.422774 ], [ -156.556097, 56.979985 ], [ -158.117217, 56.463608 ], [ -158.433321, 55.994154 ], [ -159.603327, 55.566686 ], [ -160.28972, 55.643581 ], [ -161.223048, 55.364735 ], [ -162.237766, 55.024187 ], [ -163.069447, 54.689737 ], [ -164.785569, 54.404173 ], [ -164.942226, 54.572225 ], [ -163.84834, 55.039431 ], [ -162.870001, 55.348043 ], [ -161.804175, 55.894986 ], [ -160.563605, 56.008055 ], [ -160.07056, 56.418055 ], [ -158.684443, 57.016675 ], [ -158.461097, 57.216921 ], [ -157.72277, 57.570001 ], [ -157.550274, 58.328326 ], [ -157.041675, 58.918885 ], [ -158.194731, 58.615802 ], [ -158.517218, 58.787781 ], [ -159.058606, 58.424186 ], [ -159.711667, 58.93139 ], [ -159.981289, 58.572549 ], [ -160.355271, 59.071123 ], [ -161.355003, 58.670838 ], [ -161.968894, 58.671665 ], [ -162.054987, 59.266925 ], [ -161.874171, 59.633621 ], [ -162.518059, 59.989724 ], [ -163.818341, 59.798056 ], [ -164.662218, 60.267484 ], [ -165.346388, 60.507496 ], [ -165.350832, 61.073895 ], [ -166.121379, 61.500019 ], [ -165.734452, 62.074997 ], [ -164.919179, 62.633076 ], [ -164.562508, 63.146378 ], [ -163.753332, 63.219449 ], [ -163.067224, 63.059459 ], [ -162.260555, 63.541936 ], [ -161.53445, 63.455817 ], [ -160.772507, 63.766108 ], [ -160.958335, 64.222799 ], [ -161.518068, 64.402788 ], [ -160.777778, 64.788604 ], [ -161.391926, 64.777235 ], [ -162.45305, 64.559445 ], [ -162.757786, 64.338605 ], [ -163.546394, 64.55916 ], [ -164.96083, 64.446945 ], [ -166.425288, 64.686672 ], [ -166.845004, 65.088896 ], [ -168.11056, 65.669997 ], [ -166.705271, 66.088318 ], [ -164.47471, 66.57666 ], [ -163.652512, 66.57666 ], [ -163.788602, 66.077207 ], [ -161.677774, 66.11612 ], [ -162.489715, 66.735565 ], [ -163.719717, 67.116395 ], [ -164.430991, 67.616338 ], [ -165.390287, 68.042772 ], [ -166.764441, 68.358877 ], [ -166.204707, 68.883031 ], [ -164.430811, 68.915535 ], [ -163.168614, 69.371115 ], [ -162.930566, 69.858062 ], [ -161.908897, 70.33333 ], [ -160.934797, 70.44769 ], [ -159.039176, 70.891642 ], [ -158.119723, 70.824721 ], [ -156.580825, 71.357764 ], [ -155.06779, 71.147776 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "UZB", "name": "Uzbekistan" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 66.518607, 37.362784 ], [ 66.54615, 37.974685 ], [ 65.215999, 38.402695 ], [ 64.170223, 38.892407 ], [ 63.518015, 39.363257 ], [ 62.37426, 40.053886 ], [ 61.882714, 41.084857 ], [ 61.547179, 41.26637 ], [ 60.465953, 41.220327 ], [ 60.083341, 41.425146 ], [ 59.976422, 42.223082 ], [ 58.629011, 42.751551 ], [ 57.78653, 42.170553 ], [ 56.932215, 41.826026 ], [ 57.096391, 41.32231 ], [ 55.968191, 41.308642 ], [ 55.928917, 44.995858 ], [ 58.503127, 45.586804 ], [ 58.689989, 45.500014 ], [ 60.239972, 44.784037 ], [ 61.05832, 44.405817 ], [ 62.0133, 43.504477 ], [ 63.185787, 43.650075 ], [ 64.900824, 43.728081 ], [ 66.098012, 42.99766 ], [ 66.023392, 41.994646 ], [ 66.510649, 41.987644 ], [ 66.714047, 41.168444 ], [ 67.985856, 41.135991 ], [ 68.259896, 40.662325 ], [ 68.632483, 40.668681 ], [ 69.070027, 41.384244 ], [ 70.388965, 42.081308 ], [ 70.962315, 42.266154 ], [ 71.259248, 42.167711 ], [ 70.420022, 41.519998 ], [ 71.157859, 41.143587 ], [ 71.870115, 41.3929 ], [ 73.055417, 40.866033 ], [ 71.774875, 40.145844 ], [ 71.014198, 40.244366 ], [ 70.601407, 40.218527 ], [ 70.45816, 40.496495 ], [ 70.666622, 40.960213 ], [ 69.329495, 40.727824 ], [ 69.011633, 40.086158 ], [ 68.536416, 39.533453 ], [ 67.701429, 39.580478 ], [ 67.44222, 39.140144 ], [ 68.176025, 38.901553 ], [ 68.392033, 38.157025 ], [ 67.83, 37.144994 ], [ 67.075782, 37.356144 ], [ 66.518607, 37.362784 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "VEN", "name": "Venezuela" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ -71.331584, 11.776284 ], [ -71.360006, 11.539994 ], [ -71.94705, 11.423282 ], [ -71.620868, 10.96946 ], [ -71.633064, 10.446494 ], [ -72.074174, 9.865651 ], [ -71.695644, 9.072263 ], [ -71.264559, 9.137195 ], [ -71.039999, 9.859993 ], [ -71.350084, 10.211935 ], [ -71.400623, 10.968969 ], [ -70.155299, 11.375482 ], [ -70.293843, 11.846822 ], [ -69.943245, 12.162307 ], [ -69.5843, 11.459611 ], [ -68.882999, 11.443385 ], [ -68.233271, 10.885744 ], [ -68.194127, 10.554653 ], [ -67.296249, 10.545868 ], [ -66.227864, 10.648627 ], [ -65.655238, 10.200799 ], [ -64.890452, 10.077215 ], [ -64.329479, 10.389599 ], [ -64.318007, 10.641418 ], [ -63.079322, 10.701724 ], [ -61.880946, 10.715625 ], [ -62.730119, 10.420269 ], [ -62.388512, 9.948204 ], [ -61.588767, 9.873067 ], [ -60.830597, 9.38134 ], [ -60.671252, 8.580174 ], [ -60.150096, 8.602757 ], [ -59.758285, 8.367035 ], [ -60.550588, 7.779603 ], [ -60.637973, 7.415 ], [ -60.295668, 7.043911 ], [ -60.543999, 6.856584 ], [ -61.159336, 6.696077 ], [ -61.139415, 6.234297 ], [ -61.410303, 5.959068 ], [ -60.733574, 5.200277 ], [ -60.601179, 4.918098 ], [ -60.966893, 4.536468 ], [ -62.08543, 4.162124 ], [ -62.804533, 4.006965 ], [ -63.093198, 3.770571 ], [ -63.888343, 4.02053 ], [ -64.628659, 4.148481 ], [ -64.816064, 4.056445 ], [ -64.368494, 3.79721 ], [ -64.408828, 3.126786 ], [ -64.269999, 2.497006 ], [ -63.422867, 2.411068 ], [ -63.368788, 2.2009 ], [ -64.083085, 1.916369 ], [ -64.199306, 1.492855 ], [ -64.611012, 1.328731 ], [ -65.354713, 1.095282 ], [ -65.548267, 0.789254 ], [ -66.325765, 0.724452 ], [ -66.876326, 1.253361 ], [ -67.181294, 2.250638 ], [ -67.447092, 2.600281 ], [ -67.809938, 2.820655 ], [ -67.303173, 3.318454 ], [ -67.337564, 3.542342 ], [ -67.621836, 3.839482 ], [ -67.823012, 4.503937 ], [ -67.744697, 5.221129 ], [ -67.521532, 5.55687 ], [ -67.34144, 6.095468 ], [ -67.695087, 6.267318 ], [ -68.265052, 6.153268 ], [ -68.985319, 6.206805 ], [ -69.38948, 6.099861 ], [ -70.093313, 6.960376 ], [ -70.674234, 7.087785 ], [ -71.960176, 6.991615 ], [ -72.198352, 7.340431 ], [ -72.444487, 7.423785 ], [ -72.479679, 7.632506 ], [ -72.360901, 8.002638 ], [ -72.439862, 8.405275 ], [ -72.660495, 8.625288 ], [ -72.78873, 9.085027 ], [ -73.304952, 9.152 ], [ -73.027604, 9.73677 ], [ -72.905286, 10.450344 ], [ -72.614658, 10.821975 ], [ -72.227575, 11.108702 ], [ -71.973922, 11.608672 ], [ -71.331584, 11.776284 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "VNM", "name": "Vietnam" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 108.05018, 21.55238 ], [ 106.715068, 20.696851 ], [ 105.881682, 19.75205 ], [ 105.662006, 19.058165 ], [ 106.426817, 18.004121 ], [ 107.361954, 16.697457 ], [ 108.269495, 16.079742 ], [ 108.877107, 15.276691 ], [ 109.33527, 13.426028 ], [ 109.200136, 11.666859 ], [ 108.36613, 11.008321 ], [ 107.220929, 10.364484 ], [ 106.405113, 9.53084 ], [ 105.158264, 8.59976 ], [ 104.795185, 9.241038 ], [ 105.076202, 9.918491 ], [ 104.334335, 10.486544 ], [ 105.199915, 10.88931 ], [ 106.24967, 10.961812 ], [ 105.810524, 11.567615 ], [ 107.491403, 12.337206 ], [ 107.614548, 13.535531 ], [ 107.382727, 14.202441 ], [ 107.564525, 15.202173 ], [ 107.312706, 15.908538 ], [ 106.556008, 16.604284 ], [ 105.925762, 17.485315 ], [ 105.094598, 18.666975 ], [ 103.896532, 19.265181 ], [ 104.183388, 19.624668 ], [ 104.822574, 19.886642 ], [ 104.435, 20.758733 ], [ 103.203861, 20.766562 ], [ 102.754896, 21.675137 ], [ 102.170436, 22.464753 ], [ 102.706992, 22.708795 ], [ 103.504515, 22.703757 ], [ 104.476858, 22.81915 ], [ 105.329209, 23.352063 ], [ 105.811247, 22.976892 ], [ 106.725403, 22.794268 ], [ 106.567273, 22.218205 ], [ 107.04342, 21.811899 ], [ 108.05018, 21.55238 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "VUT", "name": "Vanuatu" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 167.844877, -16.466333 ], [ 167.515181, -16.59785 ], [ 167.180008, -16.159995 ], [ 167.216801, -15.891846 ], [ 167.844877, -16.466333 ] ] ], [ [ [ 167.107712, -14.93392 ], [ 167.270028, -15.740021 ], [ 167.001207, -15.614602 ], [ 166.793158, -15.668811 ], [ 166.649859, -15.392704 ], [ 166.629137, -14.626497 ], [ 167.107712, -14.93392 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "PSE", "name": "West Bank" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 35.545665, 32.393992 ], [ 35.545252, 31.782505 ], [ 35.397561, 31.489086 ], [ 34.927408, 31.353435 ], [ 34.970507, 31.616778 ], [ 35.225892, 31.754341 ], [ 34.974641, 31.866582 ], [ 35.18393, 32.532511 ], [ 35.545665, 32.393992 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "YEM", "name": "Yemen" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 53.108573, 16.651051 ], [ 52.385206, 16.382411 ], [ 52.191729, 15.938433 ], [ 52.168165, 15.59742 ], [ 51.172515, 15.17525 ], [ 49.574576, 14.708767 ], [ 48.679231, 14.003202 ], [ 48.238947, 13.94809 ], [ 47.938914, 14.007233 ], [ 47.354454, 13.59222 ], [ 46.717076, 13.399699 ], [ 45.877593, 13.347764 ], [ 45.62505, 13.290946 ], [ 45.406459, 13.026905 ], [ 45.144356, 12.953938 ], [ 44.989533, 12.699587 ], [ 44.494576, 12.721653 ], [ 44.175113, 12.58595 ], [ 43.482959, 12.6368 ], [ 43.222871, 13.22095 ], [ 43.251448, 13.767584 ], [ 43.087944, 14.06263 ], [ 42.892245, 14.802249 ], [ 42.604873, 15.213335 ], [ 42.805015, 15.261963 ], [ 42.702438, 15.718886 ], [ 42.823671, 15.911742 ], [ 42.779332, 16.347891 ], [ 43.218375, 16.66689 ], [ 43.115798, 17.08844 ], [ 43.380794, 17.579987 ], [ 43.791519, 17.319977 ], [ 44.062613, 17.410359 ], [ 45.216651, 17.433329 ], [ 45.399999, 17.333335 ], [ 46.366659, 17.233315 ], [ 46.749994, 17.283338 ], [ 47.000005, 16.949999 ], [ 47.466695, 17.116682 ], [ 48.183344, 18.166669 ], [ 49.116672, 18.616668 ], [ 52.00001, 19.000003 ], [ 52.782184, 17.349742 ], [ 53.108573, 16.651051 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "ZAF", "name": "South Africa" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 31.521001, -29.257387 ], [ 31.325561, -29.401978 ], [ 30.901763, -29.909957 ], [ 30.622813, -30.423776 ], [ 30.055716, -31.140269 ], [ 28.925553, -32.172041 ], [ 28.219756, -32.771953 ], [ 27.464608, -33.226964 ], [ 26.419452, -33.61495 ], [ 25.909664, -33.66704 ], [ 25.780628, -33.944646 ], [ 25.172862, -33.796851 ], [ 24.677853, -33.987176 ], [ 23.594043, -33.794474 ], [ 22.988189, -33.916431 ], [ 22.574157, -33.864083 ], [ 21.542799, -34.258839 ], [ 20.689053, -34.417175 ], [ 20.071261, -34.795137 ], [ 19.616405, -34.819166 ], [ 19.193278, -34.462599 ], [ 18.855315, -34.444306 ], [ 18.424643, -33.997873 ], [ 18.377411, -34.136521 ], [ 18.244499, -33.867752 ], [ 18.25008, -33.281431 ], [ 17.92519, -32.611291 ], [ 18.24791, -32.429131 ], [ 18.221762, -31.661633 ], [ 17.566918, -30.725721 ], [ 17.064416, -29.878641 ], [ 17.062918, -29.875954 ], [ 16.344977, -28.576705 ], [ 16.824017, -28.082162 ], [ 17.218929, -28.355943 ], [ 17.387497, -28.783514 ], [ 17.836152, -28.856378 ], [ 18.464899, -29.045462 ], [ 19.002127, -28.972443 ], [ 19.894734, -28.461105 ], [ 19.895768, -24.76779 ], [ 20.165726, -24.917962 ], [ 20.758609, -25.868136 ], [ 20.66647, -26.477453 ], [ 20.889609, -26.828543 ], [ 21.605896, -26.726534 ], [ 22.105969, -26.280256 ], [ 22.579532, -25.979448 ], [ 22.824271, -25.500459 ], [ 23.312097, -25.26869 ], [ 23.73357, -25.390129 ], [ 24.211267, -25.670216 ], [ 25.025171, -25.71967 ], [ 25.664666, -25.486816 ], [ 25.765849, -25.174845 ], [ 25.941652, -24.696373 ], [ 26.485753, -24.616327 ], [ 26.786407, -24.240691 ], [ 27.11941, -23.574323 ], [ 28.017236, -22.827754 ], [ 29.432188, -22.091313 ], [ 29.839037, -22.102216 ], [ 30.322883, -22.271612 ], [ 30.659865, -22.151567 ], [ 31.191409, -22.25151 ], [ 31.670398, -23.658969 ], [ 31.930589, -24.369417 ], [ 31.752408, -25.484284 ], [ 31.837778, -25.843332 ], [ 31.333158, -25.660191 ], [ 31.04408, -25.731452 ], [ 30.949667, -26.022649 ], [ 30.676609, -26.398078 ], [ 30.685962, -26.743845 ], [ 31.282773, -27.285879 ], [ 31.86806, -27.177927 ], [ 32.071665, -26.73382 ], [ 32.83012, -26.742192 ], [ 32.580265, -27.470158 ], [ 32.462133, -28.301011 ], [ 32.203389, -28.752405 ], [ 31.521001, -29.257387 ] ], [ [ 28.978263, -28.955597 ], [ 28.5417, -28.647502 ], [ 28.074338, -28.851469 ], [ 27.532511, -29.242711 ], [ 26.999262, -29.875954 ], [ 27.749397, -30.645106 ], [ 28.107205, -30.545732 ], [ 28.291069, -30.226217 ], [ 28.8484, -30.070051 ], [ 29.018415, -29.743766 ], [ 29.325166, -29.257387 ], [ 28.978263, -28.955597 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "ZMB", "name": "Zambia" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 32.759375, -9.230599 ], [ 33.231388, -9.676722 ], [ 33.485688, -10.525559 ], [ 33.31531, -10.79655 ], [ 33.114289, -11.607198 ], [ 33.306422, -12.435778 ], [ 32.991764, -12.783871 ], [ 32.688165, -13.712858 ], [ 33.214025, -13.97186 ], [ 30.179481, -14.796099 ], [ 30.274256, -15.507787 ], [ 29.516834, -15.644678 ], [ 28.947463, -16.043051 ], [ 28.825869, -16.389749 ], [ 28.467906, -16.4684 ], [ 27.598243, -17.290831 ], [ 27.044427, -17.938026 ], [ 26.706773, -17.961229 ], [ 26.381935, -17.846042 ], [ 25.264226, -17.73654 ], [ 25.084443, -17.661816 ], [ 25.07695, -17.578823 ], [ 24.682349, -17.353411 ], [ 24.033862, -17.295843 ], [ 23.215048, -17.523116 ], [ 22.562478, -16.898451 ], [ 21.887843, -16.08031 ], [ 21.933886, -12.898437 ], [ 24.016137, -12.911046 ], [ 23.930922, -12.565848 ], [ 24.079905, -12.191297 ], [ 23.904154, -11.722282 ], [ 24.017894, -11.237298 ], [ 23.912215, -10.926826 ], [ 24.257155, -10.951993 ], [ 24.314516, -11.262826 ], [ 24.78317, -11.238694 ], [ 25.418118, -11.330936 ], [ 25.75231, -11.784965 ], [ 26.553088, -11.92444 ], [ 27.16442, -11.608748 ], [ 27.388799, -12.132747 ], [ 28.155109, -12.272481 ], [ 28.523562, -12.698604 ], [ 28.934286, -13.248958 ], [ 29.699614, -13.257227 ], [ 29.616001, -12.178895 ], [ 29.341548, -12.360744 ], [ 28.642417, -11.971569 ], [ 28.372253, -11.793647 ], [ 28.49607, -10.789884 ], [ 28.673682, -9.605925 ], [ 28.449871, -9.164918 ], [ 28.734867, -8.526559 ], [ 29.002912, -8.407032 ], [ 30.346086, -8.238257 ], [ 30.740015, -8.340007 ], [ 31.157751, -8.594579 ], [ 31.556348, -8.762049 ], [ 32.191865, -8.930359 ], [ 32.759375, -9.230599 ] ] ] ] } },
{ "type": "Feature", "properties": { "id": "ZWE", "name": "Zimbabwe" }, "geometry": { "type": "MultiPolygon", "coordinates": [ [ [ [ 31.191409, -22.25151 ], [ 30.659865, -22.151567 ], [ 30.322883, -22.271612 ], [ 29.839037, -22.102216 ], [ 29.432188, -22.091313 ], [ 28.794656, -21.639454 ], [ 28.02137, -21.485975 ], [ 27.727228, -20.851802 ], [ 27.724747, -20.499059 ], [ 27.296505, -20.39152 ], [ 26.164791, -19.293086 ], [ 25.850391, -18.714413 ], [ 25.649163, -18.536026 ], [ 25.264226, -17.73654 ], [ 26.381935, -17.846042 ], [ 26.706773, -17.961229 ], [ 27.044427, -17.938026 ], [ 27.598243, -17.290831 ], [ 28.467906, -16.4684 ], [ 28.825869, -16.389749 ], [ 28.947463, -16.043051 ], [ 29.516834, -15.644678 ], [ 30.274256, -15.507787 ], [ 30.338955, -15.880839 ], [ 31.173064, -15.860944 ], [ 31.636498, -16.07199 ], [ 31.852041, -16.319417 ], [ 32.328239, -16.392074 ], [ 32.847639, -16.713398 ], [ 32.849861, -17.979057 ], [ 32.654886, -18.67209 ], [ 32.611994, -19.419383 ], [ 32.772708, -19.715592 ], [ 32.659743, -20.30429 ], [ 32.508693, -20.395292 ], [ 32.244988, -21.116489 ], [ 31.191409, -22.25151 ] ] ] ] } }
]
}

},{}],149:[function(require,module,exports){
(function (process){(function (){
/*!
 * Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (factory((global['fontawesome-svg-core'] = {})));
}(this, (function (exports) { 'use strict';

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }

    return target;
  }

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }

  function _wrapRegExp() {
    _wrapRegExp = function (re, groups) {
      return new BabelRegExp(re, void 0, groups);
    };

    var _super = RegExp.prototype,
        _groups = new WeakMap();

    function BabelRegExp(re, flags, groups) {
      var _this = new RegExp(re, flags);

      return _groups.set(_this, groups || _groups.get(re)), _setPrototypeOf(_this, BabelRegExp.prototype);
    }

    function buildGroups(result, re) {
      var g = _groups.get(re);

      return Object.keys(g).reduce(function (groups, name) {
        return groups[name] = result[g[name]], groups;
      }, Object.create(null));
    }

    return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (str) {
      var result = _super.exec.call(this, str);

      return result && (result.groups = buildGroups(result, this)), result;
    }, BabelRegExp.prototype[Symbol.replace] = function (str, substitution) {
      if ("string" == typeof substitution) {
        var groups = _groups.get(this);

        return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) {
          return "$" + groups[name];
        }));
      }

      if ("function" == typeof substitution) {
        var _this = this;

        return _super[Symbol.replace].call(this, str, function () {
          var args = arguments;
          return "object" != typeof args[args.length - 1] && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args);
        });
      }

      return _super[Symbol.replace].call(this, str, substitution);
    }, _wrapRegExp.apply(this, arguments);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }

  function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;

    var _s, _e;

    try {
      for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var noop = function noop() {};

  var _WINDOW = {};
  var _DOCUMENT = {};
  var _MUTATION_OBSERVER = null;
  var _PERFORMANCE = {
    mark: noop,
    measure: noop
  };

  try {
    if (typeof window !== 'undefined') _WINDOW = window;
    if (typeof document !== 'undefined') _DOCUMENT = document;
    if (typeof MutationObserver !== 'undefined') _MUTATION_OBSERVER = MutationObserver;
    if (typeof performance !== 'undefined') _PERFORMANCE = performance;
  } catch (e) {}

  var _ref = _WINDOW.navigator || {},
      _ref$userAgent = _ref.userAgent,
      userAgent = _ref$userAgent === void 0 ? '' : _ref$userAgent;
  var WINDOW = _WINDOW;
  var DOCUMENT = _DOCUMENT;
  var MUTATION_OBSERVER = _MUTATION_OBSERVER;
  var PERFORMANCE = _PERFORMANCE;
  var IS_BROWSER = !!WINDOW.document;
  var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === 'function' && typeof DOCUMENT.createElement === 'function';
  var IS_IE = ~userAgent.indexOf('MSIE') || ~userAgent.indexOf('Trident/');

  var _familyProxy, _familyProxy2, _familyProxy3, _familyProxy4, _familyProxy5;

  var NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
  var UNITS_IN_GRID = 16;
  var DEFAULT_CSS_PREFIX = 'fa';
  var DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
  var DATA_FA_I2SVG = 'data-fa-i2svg';
  var DATA_FA_PSEUDO_ELEMENT = 'data-fa-pseudo-element';
  var DATA_FA_PSEUDO_ELEMENT_PENDING = 'data-fa-pseudo-element-pending';
  var DATA_PREFIX = 'data-prefix';
  var DATA_ICON = 'data-icon';
  var HTML_CLASS_I2SVG_BASE_CLASS = 'fontawesome-i2svg';
  var MUTATION_APPROACH_ASYNC = 'async';
  var TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = ['HTML', 'HEAD', 'STYLE', 'SCRIPT'];
  var PRODUCTION = function () {
    try {
      return process.env.NODE_ENV === 'production';
    } catch (e) {
      return false;
    }
  }();
  var FAMILY_CLASSIC = 'classic';
  var FAMILY_SHARP = 'sharp';
  var FAMILIES = [FAMILY_CLASSIC, FAMILY_SHARP];

  function familyProxy(obj) {
    // Defaults to the classic family if family is not available
    return new Proxy(obj, {
      get: function get(target, prop) {
        return prop in target ? target[prop] : target[FAMILY_CLASSIC];
      }
    });
  }
  var PREFIX_TO_STYLE = familyProxy((_familyProxy = {}, _defineProperty(_familyProxy, FAMILY_CLASSIC, {
    'fa': 'solid',
    'fas': 'solid',
    'fa-solid': 'solid',
    'far': 'regular',
    'fa-regular': 'regular',
    'fal': 'light',
    'fa-light': 'light',
    'fat': 'thin',
    'fa-thin': 'thin',
    'fad': 'duotone',
    'fa-duotone': 'duotone',
    'fab': 'brands',
    'fa-brands': 'brands',
    'fak': 'kit',
    'fakd': 'kit',
    'fa-kit': 'kit',
    'fa-kit-duotone': 'kit'
  }), _defineProperty(_familyProxy, FAMILY_SHARP, {
    'fa': 'solid',
    'fass': 'solid',
    'fa-solid': 'solid',
    'fasr': 'regular',
    'fa-regular': 'regular',
    'fasl': 'light',
    'fa-light': 'light',
    'fast': 'thin',
    'fa-thin': 'thin'
  }), _familyProxy));
  var STYLE_TO_PREFIX = familyProxy((_familyProxy2 = {}, _defineProperty(_familyProxy2, FAMILY_CLASSIC, {
    solid: 'fas',
    regular: 'far',
    light: 'fal',
    thin: 'fat',
    duotone: 'fad',
    brands: 'fab',
    kit: 'fak'
  }), _defineProperty(_familyProxy2, FAMILY_SHARP, {
    solid: 'fass',
    regular: 'fasr',
    light: 'fasl',
    thin: 'fast'
  }), _familyProxy2));
  var PREFIX_TO_LONG_STYLE = familyProxy((_familyProxy3 = {}, _defineProperty(_familyProxy3, FAMILY_CLASSIC, {
    fab: 'fa-brands',
    fad: 'fa-duotone',
    fak: 'fa-kit',
    fal: 'fa-light',
    far: 'fa-regular',
    fas: 'fa-solid',
    fat: 'fa-thin'
  }), _defineProperty(_familyProxy3, FAMILY_SHARP, {
    fass: 'fa-solid',
    fasr: 'fa-regular',
    fasl: 'fa-light',
    fast: 'fa-thin'
  }), _familyProxy3));
  var LONG_STYLE_TO_PREFIX = familyProxy((_familyProxy4 = {}, _defineProperty(_familyProxy4, FAMILY_CLASSIC, {
    'fa-brands': 'fab',
    'fa-duotone': 'fad',
    'fa-kit': 'fak',
    'fa-light': 'fal',
    'fa-regular': 'far',
    'fa-solid': 'fas',
    'fa-thin': 'fat'
  }), _defineProperty(_familyProxy4, FAMILY_SHARP, {
    'fa-solid': 'fass',
    'fa-regular': 'fasr',
    'fa-light': 'fasl',
    'fa-thin': 'fast'
  }), _familyProxy4));
  var ICON_SELECTION_SYNTAX_PATTERN = /fa(s|r|l|t|d|b|k|ss|sr|sl|st)?[\-\ ]/; // eslint-disable-line no-useless-escape

  var LAYERS_TEXT_CLASSNAME = 'fa-layers-text';
  var FONT_FAMILY_PATTERN = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp|Kit)?.*/i;
  var FONT_WEIGHT_TO_PREFIX = familyProxy((_familyProxy5 = {}, _defineProperty(_familyProxy5, FAMILY_CLASSIC, {
    900: 'fas',
    400: 'far',
    normal: 'far',
    300: 'fal',
    100: 'fat'
  }), _defineProperty(_familyProxy5, FAMILY_SHARP, {
    900: 'fass',
    400: 'fasr',
    300: 'fasl',
    100: 'fast'
  }), _familyProxy5));
  var oneToTen = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  var oneToTwenty = oneToTen.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]);
  var ATTRIBUTES_WATCHED_FOR_MUTATION = ['class', 'data-prefix', 'data-icon', 'data-fa-transform', 'data-fa-mask'];
  var DUOTONE_CLASSES = {
    GROUP: 'duotone-group',
    SWAP_OPACITY: 'swap-opacity',
    PRIMARY: 'primary',
    SECONDARY: 'secondary'
  };
  var prefixes = new Set();
  Object.keys(STYLE_TO_PREFIX[FAMILY_CLASSIC]).map(prefixes.add.bind(prefixes));
  Object.keys(STYLE_TO_PREFIX[FAMILY_SHARP]).map(prefixes.add.bind(prefixes));
  var RESERVED_CLASSES = [].concat(FAMILIES, _toConsumableArray(prefixes), ['2xs', 'xs', 'sm', 'lg', 'xl', '2xl', 'beat', 'border', 'fade', 'beat-fade', 'bounce', 'flip-both', 'flip-horizontal', 'flip-vertical', 'flip', 'fw', 'inverse', 'layers-counter', 'layers-text', 'layers', 'li', 'pull-left', 'pull-right', 'pulse', 'rotate-180', 'rotate-270', 'rotate-90', 'rotate-by', 'shake', 'spin-pulse', 'spin-reverse', 'spin', 'stack-1x', 'stack-2x', 'stack', 'ul', DUOTONE_CLASSES.GROUP, DUOTONE_CLASSES.SWAP_OPACITY, DUOTONE_CLASSES.PRIMARY, DUOTONE_CLASSES.SECONDARY]).concat(oneToTen.map(function (n) {
    return "".concat(n, "x");
  })).concat(oneToTwenty.map(function (n) {
    return "w-".concat(n);
  }));

  var initial = WINDOW.FontAwesomeConfig || {};

  function getAttrConfig(attr) {
    var element = DOCUMENT.querySelector('script[' + attr + ']');

    if (element) {
      return element.getAttribute(attr);
    }
  }

  function coerce(val) {
    // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
    // We'll assume that this is an indication that it should be toggled to true
    if (val === '') return true;
    if (val === 'false') return false;
    if (val === 'true') return true;
    return val;
  }

  if (DOCUMENT && typeof DOCUMENT.querySelector === 'function') {
    var attrs = [['data-family-prefix', 'familyPrefix'], ['data-css-prefix', 'cssPrefix'], ['data-family-default', 'familyDefault'], ['data-style-default', 'styleDefault'], ['data-replacement-class', 'replacementClass'], ['data-auto-replace-svg', 'autoReplaceSvg'], ['data-auto-add-css', 'autoAddCss'], ['data-auto-a11y', 'autoA11y'], ['data-search-pseudo-elements', 'searchPseudoElements'], ['data-observe-mutations', 'observeMutations'], ['data-mutate-approach', 'mutateApproach'], ['data-keep-original-source', 'keepOriginalSource'], ['data-measure-performance', 'measurePerformance'], ['data-show-missing-icons', 'showMissingIcons']];
    attrs.forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          attr = _ref2[0],
          key = _ref2[1];

      var val = coerce(getAttrConfig(attr));

      if (val !== undefined && val !== null) {
        initial[key] = val;
      }
    });
  }

  var _default = {
    styleDefault: 'solid',
    familyDefault: 'classic',
    cssPrefix: DEFAULT_CSS_PREFIX,
    replacementClass: DEFAULT_REPLACEMENT_CLASS,
    autoReplaceSvg: true,
    autoAddCss: true,
    autoA11y: true,
    searchPseudoElements: false,
    observeMutations: true,
    mutateApproach: 'async',
    keepOriginalSource: true,
    measurePerformance: false,
    showMissingIcons: true
  }; // familyPrefix is deprecated but we must still support it if present

  if (initial.familyPrefix) {
    initial.cssPrefix = initial.familyPrefix;
  }

  var _config = _objectSpread2(_objectSpread2({}, _default), initial);

  if (!_config.autoReplaceSvg) _config.observeMutations = false;
  var config = {};
  Object.keys(_default).forEach(function (key) {
    Object.defineProperty(config, key, {
      enumerable: true,
      set: function set(val) {
        _config[key] = val;

        _onChangeCb.forEach(function (cb) {
          return cb(config);
        });
      },
      get: function get() {
        return _config[key];
      }
    });
  }); // familyPrefix is deprecated as of 6.2.0 and should be removed in 7.0.0

  Object.defineProperty(config, 'familyPrefix', {
    enumerable: true,
    set: function set(val) {
      _config.cssPrefix = val;

      _onChangeCb.forEach(function (cb) {
        return cb(config);
      });
    },
    get: function get() {
      return _config.cssPrefix;
    }
  });
  WINDOW.FontAwesomeConfig = config;
  var _onChangeCb = [];
  function onChange(cb) {
    _onChangeCb.push(cb);

    return function () {
      _onChangeCb.splice(_onChangeCb.indexOf(cb), 1);
    };
  }

  var d = UNITS_IN_GRID;
  var meaninglessTransform = {
    size: 16,
    x: 0,
    y: 0,
    rotate: 0,
    flipX: false,
    flipY: false
  };
  function insertCss(css) {
    if (!css || !IS_DOM) {
      return;
    }

    var style = DOCUMENT.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    var headChildren = DOCUMENT.head.childNodes;
    var beforeChild = null;

    for (var i = headChildren.length - 1; i > -1; i--) {
      var child = headChildren[i];
      var tagName = (child.tagName || '').toUpperCase();

      if (['STYLE', 'LINK'].indexOf(tagName) > -1) {
        beforeChild = child;
      }
    }

    DOCUMENT.head.insertBefore(style, beforeChild);
    return css;
  }
  var idPool = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  function nextUniqueId() {
    var size = 12;
    var id = '';

    while (size-- > 0) {
      id += idPool[Math.random() * 62 | 0];
    }

    return id;
  }
  function toArray(obj) {
    var array = [];

    for (var i = (obj || []).length >>> 0; i--;) {
      array[i] = obj[i];
    }

    return array;
  }
  function classArray(node) {
    if (node.classList) {
      return toArray(node.classList);
    } else {
      return (node.getAttribute('class') || '').split(' ').filter(function (i) {
        return i;
      });
    }
  }
  function htmlEscape(str) {
    return "".concat(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  function joinAttributes(attributes) {
    return Object.keys(attributes || {}).reduce(function (acc, attributeName) {
      return acc + "".concat(attributeName, "=\"").concat(htmlEscape(attributes[attributeName]), "\" ");
    }, '').trim();
  }
  function joinStyles(styles) {
    return Object.keys(styles || {}).reduce(function (acc, styleName) {
      return acc + "".concat(styleName, ": ").concat(styles[styleName].trim(), ";");
    }, '');
  }
  function transformIsMeaningful(transform) {
    return transform.size !== meaninglessTransform.size || transform.x !== meaninglessTransform.x || transform.y !== meaninglessTransform.y || transform.rotate !== meaninglessTransform.rotate || transform.flipX || transform.flipY;
  }
  function transformForSvg(_ref) {
    var transform = _ref.transform,
        containerWidth = _ref.containerWidth,
        iconWidth = _ref.iconWidth;
    var outer = {
      transform: "translate(".concat(containerWidth / 2, " 256)")
    };
    var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
    var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
    var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
    var inner = {
      transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
    };
    var path = {
      transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
    };
    return {
      outer: outer,
      inner: inner,
      path: path
    };
  }
  function transformForCss(_ref2) {
    var transform = _ref2.transform,
        _ref2$width = _ref2.width,
        width = _ref2$width === void 0 ? UNITS_IN_GRID : _ref2$width,
        _ref2$height = _ref2.height,
        height = _ref2$height === void 0 ? UNITS_IN_GRID : _ref2$height,
        _ref2$startCentered = _ref2.startCentered,
        startCentered = _ref2$startCentered === void 0 ? false : _ref2$startCentered;
    var val = '';

    if (startCentered && IS_IE) {
      val += "translate(".concat(transform.x / d - width / 2, "em, ").concat(transform.y / d - height / 2, "em) ");
    } else if (startCentered) {
      val += "translate(calc(-50% + ".concat(transform.x / d, "em), calc(-50% + ").concat(transform.y / d, "em)) ");
    } else {
      val += "translate(".concat(transform.x / d, "em, ").concat(transform.y / d, "em) ");
    }

    val += "scale(".concat(transform.size / d * (transform.flipX ? -1 : 1), ", ").concat(transform.size / d * (transform.flipY ? -1 : 1), ") ");
    val += "rotate(".concat(transform.rotate, "deg) ");
    return val;
  }

  var baseStyles = ":root, :host {\n  --fa-font-solid: normal 900 1em/1 \"Font Awesome 6 Solid\";\n  --fa-font-regular: normal 400 1em/1 \"Font Awesome 6 Regular\";\n  --fa-font-light: normal 300 1em/1 \"Font Awesome 6 Light\";\n  --fa-font-thin: normal 100 1em/1 \"Font Awesome 6 Thin\";\n  --fa-font-duotone: normal 900 1em/1 \"Font Awesome 6 Duotone\";\n  --fa-font-sharp-solid: normal 900 1em/1 \"Font Awesome 6 Sharp\";\n  --fa-font-sharp-regular: normal 400 1em/1 \"Font Awesome 6 Sharp\";\n  --fa-font-sharp-light: normal 300 1em/1 \"Font Awesome 6 Sharp\";\n  --fa-font-sharp-thin: normal 100 1em/1 \"Font Awesome 6 Sharp\";\n  --fa-font-brands: normal 400 1em/1 \"Font Awesome 6 Brands\";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-counter-scale, 0.25));\n          transform: scale(var(--fa-counter-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(var(--fa-li-width, 2em) * -1);\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  -webkit-animation-name: fa-beat;\n          animation-name: fa-beat;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  -webkit-animation-name: fa-bounce;\n          animation-name: fa-bounce;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  -webkit-animation-name: fa-fade;\n          animation-name: fa-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  -webkit-animation-name: fa-beat-fade;\n          animation-name: fa-beat-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  -webkit-animation-name: fa-flip;\n          animation-name: fa-flip;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  -webkit-animation-name: fa-shake;\n          animation-name: fa-shake;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 2s);\n          animation-duration: var(--fa-animation-duration, 2s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));\n          animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    -webkit-animation-delay: -1ms;\n            animation-delay: -1ms;\n    -webkit-animation-duration: 1ms;\n            animation-duration: 1ms;\n    -webkit-animation-iteration-count: 1;\n            animation-iteration-count: 1;\n    -webkit-transition-delay: 0s;\n            transition-delay: 0s;\n    -webkit-transition-duration: 0s;\n            transition-duration: 0s;\n  }\n}\n@-webkit-keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@-webkit-keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@-webkit-keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@-webkit-keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@-webkit-keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@-webkit-keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  -webkit-transform: rotate(var(--fa-rotate-angle, 0));\n          transform: rotate(var(--fa-rotate-angle, 0));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse,\n.fa-duotone.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}";

  function css() {
    var dcp = DEFAULT_CSS_PREFIX;
    var drc = DEFAULT_REPLACEMENT_CLASS;
    var fp = config.cssPrefix;
    var rc = config.replacementClass;
    var s = baseStyles;

    if (fp !== dcp || rc !== drc) {
      var dPatt = new RegExp("\\.".concat(dcp, "\\-"), 'g');
      var customPropPatt = new RegExp("\\--".concat(dcp, "\\-"), 'g');
      var rPatt = new RegExp("\\.".concat(drc), 'g');
      s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
    }

    return s;
  }

  var _cssInserted = false;

  function ensureCss() {
    if (config.autoAddCss && !_cssInserted) {
      insertCss(css());
      _cssInserted = true;
    }
  }

  var InjectCSS = {
    mixout: function mixout() {
      return {
        dom: {
          css: css,
          insertCss: ensureCss
        }
      };
    },
    hooks: function hooks() {
      return {
        beforeDOMElementCreation: function beforeDOMElementCreation() {
          ensureCss();
        },
        beforeI2svg: function beforeI2svg() {
          ensureCss();
        }
      };
    }
  };

  var w = WINDOW || {};
  if (!w[NAMESPACE_IDENTIFIER]) w[NAMESPACE_IDENTIFIER] = {};
  if (!w[NAMESPACE_IDENTIFIER].styles) w[NAMESPACE_IDENTIFIER].styles = {};
  if (!w[NAMESPACE_IDENTIFIER].hooks) w[NAMESPACE_IDENTIFIER].hooks = {};
  if (!w[NAMESPACE_IDENTIFIER].shims) w[NAMESPACE_IDENTIFIER].shims = [];
  var namespace = w[NAMESPACE_IDENTIFIER];

  var functions = [];

  var listener = function listener() {
    DOCUMENT.removeEventListener('DOMContentLoaded', listener);
    loaded = 1;
    functions.map(function (fn) {
      return fn();
    });
  };

  var loaded = false;

  if (IS_DOM) {
    loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState);
    if (!loaded) DOCUMENT.addEventListener('DOMContentLoaded', listener);
  }

  function domready (fn) {
    if (!IS_DOM) return;
    loaded ? setTimeout(fn, 0) : functions.push(fn);
  }

  function toHtml(abstractNodes) {
    var tag = abstractNodes.tag,
        _abstractNodes$attrib = abstractNodes.attributes,
        attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib,
        _abstractNodes$childr = abstractNodes.children,
        children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;

    if (typeof abstractNodes === 'string') {
      return htmlEscape(abstractNodes);
    } else {
      return "<".concat(tag, " ").concat(joinAttributes(attributes), ">").concat(children.map(toHtml).join(''), "</").concat(tag, ">");
    }
  }

  function iconFromMapping(mapping, prefix, iconName) {
    if (mapping && mapping[prefix] && mapping[prefix][iconName]) {
      return {
        prefix: prefix,
        iconName: iconName,
        icon: mapping[prefix][iconName]
      };
    }
  }

  /**
   * Internal helper to bind a function known to have 4 arguments
   * to a given context.
   */

  var bindInternal4 = function bindInternal4(func, thisContext) {
    return function (a, b, c, d) {
      return func.call(thisContext, a, b, c, d);
    };
  };

  /**
   * # Reduce
   *
   * A fast object `.reduce()` implementation.
   *
   * @param  {Object}   subject      The object to reduce over.
   * @param  {Function} fn           The reducer function.
   * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
   * @param  {Object}   thisContext  The context for the reducer.
   * @return {mixed}                 The final result.
   */


  var reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
    var keys = Object.keys(subject),
        length = keys.length,
        iterator = thisContext !== undefined ? bindInternal4(fn, thisContext) : fn,
        i,
        key,
        result;

    if (initialValue === undefined) {
      i = 1;
      result = subject[keys[0]];
    } else {
      i = 0;
      result = initialValue;
    }

    for (; i < length; i++) {
      key = keys[i];
      result = iterator(result, subject[key], key, subject);
    }

    return result;
  };

  /**
   * ucs2decode() and codePointAt() are both works of Mathias Bynens and licensed under MIT
   *
   * Copyright Mathias Bynens <https://mathiasbynens.be/>

   * Permission is hereby granted, free of charge, to any person obtaining
   * a copy of this software and associated documentation files (the
   * "Software"), to deal in the Software without restriction, including
   * without limitation the rights to use, copy, modify, merge, publish,
   * distribute, sublicense, and/or sell copies of the Software, and to
   * permit persons to whom the Software is furnished to do so, subject to
   * the following conditions:

   * The above copyright notice and this permission notice shall be
   * included in all copies or substantial portions of the Software.

   * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
   * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
   * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
   * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
   * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
   * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
   * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
   */
  function ucs2decode(string) {
    var output = [];
    var counter = 0;
    var length = string.length;

    while (counter < length) {
      var value = string.charCodeAt(counter++);

      if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
        var extra = string.charCodeAt(counter++);

        if ((extra & 0xFC00) == 0xDC00) {
          // eslint-disable-line eqeqeq
          output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
        } else {
          output.push(value);
          counter--;
        }
      } else {
        output.push(value);
      }
    }

    return output;
  }

  function toHex(unicode) {
    var decoded = ucs2decode(unicode);
    return decoded.length === 1 ? decoded[0].toString(16) : null;
  }
  function codePointAt(string, index) {
    var size = string.length;
    var first = string.charCodeAt(index);
    var second;

    if (first >= 0xD800 && first <= 0xDBFF && size > index + 1) {
      second = string.charCodeAt(index + 1);

      if (second >= 0xDC00 && second <= 0xDFFF) {
        return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
      }
    }

    return first;
  }

  function normalizeIcons(icons) {
    return Object.keys(icons).reduce(function (acc, iconName) {
      var icon = icons[iconName];
      var expanded = !!icon.icon;

      if (expanded) {
        acc[icon.iconName] = icon.icon;
      } else {
        acc[iconName] = icon;
      }

      return acc;
    }, {});
  }

  function defineIcons(prefix, icons) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _params$skipHooks = params.skipHooks,
        skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
    var normalized = normalizeIcons(icons);

    if (typeof namespace.hooks.addPack === 'function' && !skipHooks) {
      namespace.hooks.addPack(prefix, normalizeIcons(icons));
    } else {
      namespace.styles[prefix] = _objectSpread2(_objectSpread2({}, namespace.styles[prefix] || {}), normalized);
    }
    /**
     * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
     * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
     * for `fas` so we'll ease the upgrade process for our users by automatically defining
     * this as well.
     */


    if (prefix === 'fas') {
      defineIcons('fa', icons);
    }
  }

  var duotonePathRe = [/*#__PURE__*/_wrapRegExp(/path d="((?:(?!")[\s\S])+)".*path d="((?:(?!")[\s\S])+)"/, {
    d1: 1,
    d2: 2
  }), /*#__PURE__*/_wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)".*path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
    cls1: 1,
    d1: 2,
    cls2: 3,
    d2: 4
  }), /*#__PURE__*/_wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
    cls1: 1,
    d1: 2
  })];

  var _LONG_STYLE, _PREFIXES, _PREFIXES_FOR_FAMILY;
  var styles = namespace.styles,
      shims = namespace.shims;
  var LONG_STYLE = (_LONG_STYLE = {}, _defineProperty(_LONG_STYLE, FAMILY_CLASSIC, Object.values(PREFIX_TO_LONG_STYLE[FAMILY_CLASSIC])), _defineProperty(_LONG_STYLE, FAMILY_SHARP, Object.values(PREFIX_TO_LONG_STYLE[FAMILY_SHARP])), _LONG_STYLE);
  var _defaultUsablePrefix = null;
  var _byUnicode = {};
  var _byLigature = {};
  var _byOldName = {};
  var _byOldUnicode = {};
  var _byAlias = {};
  var PREFIXES = (_PREFIXES = {}, _defineProperty(_PREFIXES, FAMILY_CLASSIC, Object.keys(PREFIX_TO_STYLE[FAMILY_CLASSIC])), _defineProperty(_PREFIXES, FAMILY_SHARP, Object.keys(PREFIX_TO_STYLE[FAMILY_SHARP])), _PREFIXES);

  function isReserved(name) {
    return ~RESERVED_CLASSES.indexOf(name);
  }

  function getIconName(cssPrefix, cls) {
    var parts = cls.split('-');
    var prefix = parts[0];
    var iconName = parts.slice(1).join('-');

    if (prefix === cssPrefix && iconName !== '' && !isReserved(iconName)) {
      return iconName;
    } else {
      return null;
    }
  }
  var build = function build() {
    var lookup = function lookup(reducer) {
      return reduce(styles, function (o, style, prefix) {
        o[prefix] = reduce(style, reducer, {});
        return o;
      }, {});
    };

    _byUnicode = lookup(function (acc, icon, iconName) {
      if (icon[3]) {
        acc[icon[3]] = iconName;
      }

      if (icon[2]) {
        var aliases = icon[2].filter(function (a) {
          return typeof a === 'number';
        });
        aliases.forEach(function (alias) {
          acc[alias.toString(16)] = iconName;
        });
      }

      return acc;
    });
    _byLigature = lookup(function (acc, icon, iconName) {
      acc[iconName] = iconName;

      if (icon[2]) {
        var aliases = icon[2].filter(function (a) {
          return typeof a === 'string';
        });
        aliases.forEach(function (alias) {
          acc[alias] = iconName;
        });
      }

      return acc;
    });
    _byAlias = lookup(function (acc, icon, iconName) {
      var aliases = icon[2];
      acc[iconName] = iconName;
      aliases.forEach(function (alias) {
        acc[alias] = iconName;
      });
      return acc;
    }); // If we have a Kit, we can't determine if regular is available since we
    // could be auto-fetching it. We'll have to assume that it is available.

    var hasRegular = 'far' in styles || config.autoFetchSvg;
    var shimLookups = reduce(shims, function (acc, shim) {
      var maybeNameMaybeUnicode = shim[0];
      var prefix = shim[1];
      var iconName = shim[2];

      if (prefix === 'far' && !hasRegular) {
        prefix = 'fas';
      }

      if (typeof maybeNameMaybeUnicode === 'string') {
        acc.names[maybeNameMaybeUnicode] = {
          prefix: prefix,
          iconName: iconName
        };
      }

      if (typeof maybeNameMaybeUnicode === 'number') {
        acc.unicodes[maybeNameMaybeUnicode.toString(16)] = {
          prefix: prefix,
          iconName: iconName
        };
      }

      return acc;
    }, {
      names: {},
      unicodes: {}
    });
    _byOldName = shimLookups.names;
    _byOldUnicode = shimLookups.unicodes;
    _defaultUsablePrefix = getCanonicalPrefix(config.styleDefault, {
      family: config.familyDefault
    });
  };
  onChange(function (c) {
    _defaultUsablePrefix = getCanonicalPrefix(c.styleDefault, {
      family: config.familyDefault
    });
  });
  build();
  function byUnicode(prefix, unicode) {
    return (_byUnicode[prefix] || {})[unicode];
  }
  function byLigature(prefix, ligature) {
    return (_byLigature[prefix] || {})[ligature];
  }
  function byAlias(prefix, alias) {
    return (_byAlias[prefix] || {})[alias];
  }
  function byOldName(name) {
    return _byOldName[name] || {
      prefix: null,
      iconName: null
    };
  }
  function byOldUnicode(unicode) {
    var oldUnicode = _byOldUnicode[unicode];
    var newUnicode = byUnicode('fas', unicode);
    return oldUnicode || (newUnicode ? {
      prefix: 'fas',
      iconName: newUnicode
    } : null) || {
      prefix: null,
      iconName: null
    };
  }
  function getDefaultUsablePrefix() {
    return _defaultUsablePrefix;
  }
  var emptyCanonicalIcon = function emptyCanonicalIcon() {
    return {
      prefix: null,
      iconName: null,
      rest: []
    };
  };
  function getCanonicalPrefix(styleOrPrefix) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$family = params.family,
        family = _params$family === void 0 ? FAMILY_CLASSIC : _params$family;
    var style = PREFIX_TO_STYLE[family][styleOrPrefix];
    var prefix = STYLE_TO_PREFIX[family][styleOrPrefix] || STYLE_TO_PREFIX[family][style];
    var defined = styleOrPrefix in namespace.styles ? styleOrPrefix : null;
    return prefix || defined || null;
  }
  var PREFIXES_FOR_FAMILY = (_PREFIXES_FOR_FAMILY = {}, _defineProperty(_PREFIXES_FOR_FAMILY, FAMILY_CLASSIC, Object.keys(PREFIX_TO_LONG_STYLE[FAMILY_CLASSIC])), _defineProperty(_PREFIXES_FOR_FAMILY, FAMILY_SHARP, Object.keys(PREFIX_TO_LONG_STYLE[FAMILY_SHARP])), _PREFIXES_FOR_FAMILY);
  function getCanonicalIcon(values) {
    var _famProps;

    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$skipLookups = params.skipLookups,
        skipLookups = _params$skipLookups === void 0 ? false : _params$skipLookups;
    var famProps = (_famProps = {}, _defineProperty(_famProps, FAMILY_CLASSIC, "".concat(config.cssPrefix, "-").concat(FAMILY_CLASSIC)), _defineProperty(_famProps, FAMILY_SHARP, "".concat(config.cssPrefix, "-").concat(FAMILY_SHARP)), _famProps);
    var givenPrefix = null;
    var family = FAMILY_CLASSIC;

    if (values.includes(famProps[FAMILY_CLASSIC]) || values.some(function (v) {
      return PREFIXES_FOR_FAMILY[FAMILY_CLASSIC].includes(v);
    })) {
      family = FAMILY_CLASSIC;
    }

    if (values.includes(famProps[FAMILY_SHARP]) || values.some(function (v) {
      return PREFIXES_FOR_FAMILY[FAMILY_SHARP].includes(v);
    })) {
      family = FAMILY_SHARP;
    }

    var canonical = values.reduce(function (acc, cls) {
      var iconName = getIconName(config.cssPrefix, cls);

      if (styles[cls]) {
        cls = LONG_STYLE[family].includes(cls) ? LONG_STYLE_TO_PREFIX[family][cls] : cls;
        givenPrefix = cls;
        acc.prefix = cls;
      } else if (PREFIXES[family].indexOf(cls) > -1) {
        givenPrefix = cls;
        acc.prefix = getCanonicalPrefix(cls, {
          family: family
        });
      } else if (iconName) {
        acc.iconName = iconName;
      } else if (cls !== config.replacementClass && cls !== famProps[FAMILY_CLASSIC] && cls !== famProps[FAMILY_SHARP]) {
        acc.rest.push(cls);
      }

      if (!skipLookups && acc.prefix && acc.iconName) {
        var shim = givenPrefix === 'fa' ? byOldName(acc.iconName) : {};
        var aliasIconName = byAlias(acc.prefix, acc.iconName);

        if (shim.prefix) {
          givenPrefix = null;
        }

        acc.iconName = shim.iconName || aliasIconName || acc.iconName;
        acc.prefix = shim.prefix || acc.prefix;

        if (acc.prefix === 'far' && !styles['far'] && styles['fas'] && !config.autoFetchSvg) {
          // Allow a fallback from the regular style to solid if regular is not available
          // but only if we aren't auto-fetching SVGs
          acc.prefix = 'fas';
        }
      }

      return acc;
    }, emptyCanonicalIcon());

    if (values.includes('fa-brands') || values.includes('fab')) {
      canonical.prefix = 'fab';
    }

    if (values.includes('fa-duotone') || values.includes('fad')) {
      canonical.prefix = 'fad';
    }

    if (!canonical.prefix && family === FAMILY_SHARP && (styles['fass'] || config.autoFetchSvg)) {
      canonical.prefix = 'fass';
      canonical.iconName = byAlias(canonical.prefix, canonical.iconName) || canonical.iconName;
    }

    if (canonical.prefix === 'fa' || givenPrefix === 'fa') {
      // The fa prefix is not canonical. So if it has made it through until this point
      // we will shift it to the correct prefix.
      canonical.prefix = getDefaultUsablePrefix() || 'fas';
    }

    return canonical;
  }

  var Library = /*#__PURE__*/function () {
    function Library() {
      _classCallCheck(this, Library);

      this.definitions = {};
    }

    _createClass(Library, [{
      key: "add",
      value: function add() {
        var _this = this;

        for (var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++) {
          definitions[_key] = arguments[_key];
        }

        var additions = definitions.reduce(this._pullDefinitions, {});
        Object.keys(additions).forEach(function (key) {
          _this.definitions[key] = _objectSpread2(_objectSpread2({}, _this.definitions[key] || {}), additions[key]);
          defineIcons(key, additions[key]); // TODO can we stop doing this? We can't get the icons by 'fa-solid' any longer so this probably needs to change

          var longPrefix = PREFIX_TO_LONG_STYLE[FAMILY_CLASSIC][key];
          if (longPrefix) defineIcons(longPrefix, additions[key]);
          build();
        });
      }
    }, {
      key: "reset",
      value: function reset() {
        this.definitions = {};
      }
    }, {
      key: "_pullDefinitions",
      value: function _pullDefinitions(additions, definition) {
        var normalized = definition.prefix && definition.iconName && definition.icon ? {
          0: definition
        } : definition;
        Object.keys(normalized).map(function (key) {
          var _normalized$key = normalized[key],
              prefix = _normalized$key.prefix,
              iconName = _normalized$key.iconName,
              icon = _normalized$key.icon;
          var aliases = icon[2];
          if (!additions[prefix]) additions[prefix] = {};

          if (aliases.length > 0) {
            aliases.forEach(function (alias) {
              if (typeof alias === 'string') {
                additions[prefix][alias] = icon;
              }
            });
          }

          additions[prefix][iconName] = icon;
        });
        return additions;
      }
    }]);

    return Library;
  }();

  var _plugins = [];
  var _hooks = {};
  var providers = {};
  var defaultProviderKeys = Object.keys(providers);
  function registerPlugins(nextPlugins, _ref) {
    var obj = _ref.mixoutsTo;
    _plugins = nextPlugins;
    _hooks = {};
    Object.keys(providers).forEach(function (k) {
      if (defaultProviderKeys.indexOf(k) === -1) {
        delete providers[k];
      }
    });

    _plugins.forEach(function (plugin) {
      var mixout = plugin.mixout ? plugin.mixout() : {};
      Object.keys(mixout).forEach(function (tk) {
        if (typeof mixout[tk] === 'function') {
          obj[tk] = mixout[tk];
        }

        if (_typeof(mixout[tk]) === 'object') {
          Object.keys(mixout[tk]).forEach(function (sk) {
            if (!obj[tk]) {
              obj[tk] = {};
            }

            obj[tk][sk] = mixout[tk][sk];
          });
        }
      });

      if (plugin.hooks) {
        var hooks = plugin.hooks();
        Object.keys(hooks).forEach(function (hook) {
          if (!_hooks[hook]) {
            _hooks[hook] = [];
          }

          _hooks[hook].push(hooks[hook]);
        });
      }

      if (plugin.provides) {
        plugin.provides(providers);
      }
    });

    return obj;
  }
  function chainHooks(hook, accumulator) {
    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }

    var hookFns = _hooks[hook] || [];
    hookFns.forEach(function (hookFn) {
      accumulator = hookFn.apply(null, [accumulator].concat(args)); // eslint-disable-line no-useless-call
    });
    return accumulator;
  }
  function callHooks(hook) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    var hookFns = _hooks[hook] || [];
    hookFns.forEach(function (hookFn) {
      hookFn.apply(null, args);
    });
    return undefined;
  }
  function callProvided() {
    var hook = arguments[0];
    var args = Array.prototype.slice.call(arguments, 1);
    return providers[hook] ? providers[hook].apply(null, args) : undefined;
  }

  function findIconDefinition(iconLookup) {
    if (iconLookup.prefix === 'fa') {
      iconLookup.prefix = 'fas';
    }

    var iconName = iconLookup.iconName;
    var prefix = iconLookup.prefix || getDefaultUsablePrefix();
    if (!iconName) return;
    iconName = byAlias(prefix, iconName) || iconName;
    return iconFromMapping(library.definitions, prefix, iconName) || iconFromMapping(namespace.styles, prefix, iconName);
  }
  var library = new Library();
  var noAuto = function noAuto() {
    config.autoReplaceSvg = false;
    config.observeMutations = false;
    callHooks('noAuto');
  };
  var dom = {
    i2svg: function i2svg() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (IS_DOM) {
        callHooks('beforeI2svg', params);
        callProvided('pseudoElements2svg', params);
        return callProvided('i2svg', params);
      } else {
        return Promise.reject('Operation requires a DOM of some kind.');
      }
    },
    watch: function watch() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var autoReplaceSvgRoot = params.autoReplaceSvgRoot;

      if (config.autoReplaceSvg === false) {
        config.autoReplaceSvg = true;
      }

      config.observeMutations = true;
      domready(function () {
        autoReplace({
          autoReplaceSvgRoot: autoReplaceSvgRoot
        });
        callHooks('watch', params);
      });
    }
  };
  var parse = {
    icon: function icon(_icon) {
      if (_icon === null) {
        return null;
      }

      if (_typeof(_icon) === 'object' && _icon.prefix && _icon.iconName) {
        return {
          prefix: _icon.prefix,
          iconName: byAlias(_icon.prefix, _icon.iconName) || _icon.iconName
        };
      }

      if (Array.isArray(_icon) && _icon.length === 2) {
        var iconName = _icon[1].indexOf('fa-') === 0 ? _icon[1].slice(3) : _icon[1];
        var prefix = getCanonicalPrefix(_icon[0]);
        return {
          prefix: prefix,
          iconName: byAlias(prefix, iconName) || iconName
        };
      }

      if (typeof _icon === 'string' && (_icon.indexOf("".concat(config.cssPrefix, "-")) > -1 || _icon.match(ICON_SELECTION_SYNTAX_PATTERN))) {
        var canonicalIcon = getCanonicalIcon(_icon.split(' '), {
          skipLookups: true
        });
        return {
          prefix: canonicalIcon.prefix || getDefaultUsablePrefix(),
          iconName: byAlias(canonicalIcon.prefix, canonicalIcon.iconName) || canonicalIcon.iconName
        };
      }

      if (typeof _icon === 'string') {
        var _prefix = getDefaultUsablePrefix();

        return {
          prefix: _prefix,
          iconName: byAlias(_prefix, _icon) || _icon
        };
      }
    }
  };
  var api = {
    noAuto: noAuto,
    config: config,
    dom: dom,
    parse: parse,
    library: library,
    findIconDefinition: findIconDefinition,
    toHtml: toHtml
  };

  var autoReplace = function autoReplace() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _params$autoReplaceSv = params.autoReplaceSvgRoot,
        autoReplaceSvgRoot = _params$autoReplaceSv === void 0 ? DOCUMENT : _params$autoReplaceSv;
    if ((Object.keys(namespace.styles).length > 0 || config.autoFetchSvg) && IS_DOM && config.autoReplaceSvg) api.dom.i2svg({
      node: autoReplaceSvgRoot
    });
  };

  function domVariants(val, abstractCreator) {
    Object.defineProperty(val, 'abstract', {
      get: abstractCreator
    });
    Object.defineProperty(val, 'html', {
      get: function get() {
        return val.abstract.map(function (a) {
          return toHtml(a);
        });
      }
    });
    Object.defineProperty(val, 'node', {
      get: function get() {
        if (!IS_DOM) return;
        var container = DOCUMENT.createElement('div');
        container.innerHTML = val.html;
        return container.children;
      }
    });
    return val;
  }

  function asIcon (_ref) {
    var children = _ref.children,
        main = _ref.main,
        mask = _ref.mask,
        attributes = _ref.attributes,
        styles = _ref.styles,
        transform = _ref.transform;

    if (transformIsMeaningful(transform) && main.found && !mask.found) {
      var width = main.width,
          height = main.height;
      var offset = {
        x: width / height / 2,
        y: 0.5
      };
      attributes['style'] = joinStyles(_objectSpread2(_objectSpread2({}, styles), {}, {
        'transform-origin': "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
      }));
    }

    return [{
      tag: 'svg',
      attributes: attributes,
      children: children
    }];
  }

  function asSymbol (_ref) {
    var prefix = _ref.prefix,
        iconName = _ref.iconName,
        children = _ref.children,
        attributes = _ref.attributes,
        symbol = _ref.symbol;
    var id = symbol === true ? "".concat(prefix, "-").concat(config.cssPrefix, "-").concat(iconName) : symbol;
    return [{
      tag: 'svg',
      attributes: {
        style: 'display: none;'
      },
      children: [{
        tag: 'symbol',
        attributes: _objectSpread2(_objectSpread2({}, attributes), {}, {
          id: id
        }),
        children: children
      }]
    }];
  }

  function makeInlineSvgAbstract(params) {
    var _params$icons = params.icons,
        main = _params$icons.main,
        mask = _params$icons.mask,
        prefix = params.prefix,
        iconName = params.iconName,
        transform = params.transform,
        symbol = params.symbol,
        title = params.title,
        maskId = params.maskId,
        titleId = params.titleId,
        extra = params.extra,
        _params$watchable = params.watchable,
        watchable = _params$watchable === void 0 ? false : _params$watchable;

    var _ref = mask.found ? mask : main,
        width = _ref.width,
        height = _ref.height;

    var isUploadedIcon = prefix === 'fak';
    var attrClass = [config.replacementClass, iconName ? "".concat(config.cssPrefix, "-").concat(iconName) : ''].filter(function (c) {
      return extra.classes.indexOf(c) === -1;
    }).filter(function (c) {
      return c !== '' || !!c;
    }).concat(extra.classes).join(' ');
    var content = {
      children: [],
      attributes: _objectSpread2(_objectSpread2({}, extra.attributes), {}, {
        'data-prefix': prefix,
        'data-icon': iconName,
        'class': attrClass,
        'role': extra.attributes.role || 'img',
        'xmlns': 'http://www.w3.org/2000/svg',
        'viewBox': "0 0 ".concat(width, " ").concat(height)
      })
    };
    var uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf('fa-fw') ? {
      width: "".concat(width / height * 16 * 0.0625, "em")
    } : {};

    if (watchable) {
      content.attributes[DATA_FA_I2SVG] = '';
    }

    if (title) {
      content.children.push({
        tag: 'title',
        attributes: {
          id: content.attributes['aria-labelledby'] || "title-".concat(titleId || nextUniqueId())
        },
        children: [title]
      });
      delete content.attributes.title;
    }

    var args = _objectSpread2(_objectSpread2({}, content), {}, {
      prefix: prefix,
      iconName: iconName,
      main: main,
      mask: mask,
      maskId: maskId,
      transform: transform,
      symbol: symbol,
      styles: _objectSpread2(_objectSpread2({}, uploadedIconWidthStyle), extra.styles)
    });

    var _ref2 = mask.found && main.found ? callProvided('generateAbstractMask', args) || {
      children: [],
      attributes: {}
    } : callProvided('generateAbstractIcon', args) || {
      children: [],
      attributes: {}
    },
        children = _ref2.children,
        attributes = _ref2.attributes;

    args.children = children;
    args.attributes = attributes;

    if (symbol) {
      return asSymbol(args);
    } else {
      return asIcon(args);
    }
  }
  function makeLayersTextAbstract(params) {
    var content = params.content,
        width = params.width,
        height = params.height,
        transform = params.transform,
        title = params.title,
        extra = params.extra,
        _params$watchable2 = params.watchable,
        watchable = _params$watchable2 === void 0 ? false : _params$watchable2;

    var attributes = _objectSpread2(_objectSpread2(_objectSpread2({}, extra.attributes), title ? {
      'title': title
    } : {}), {}, {
      'class': extra.classes.join(' ')
    });

    if (watchable) {
      attributes[DATA_FA_I2SVG] = '';
    }

    var styles = _objectSpread2({}, extra.styles);

    if (transformIsMeaningful(transform)) {
      styles['transform'] = transformForCss({
        transform: transform,
        startCentered: true,
        width: width,
        height: height
      });
      styles['-webkit-transform'] = styles['transform'];
    }

    var styleString = joinStyles(styles);

    if (styleString.length > 0) {
      attributes['style'] = styleString;
    }

    var val = [];
    val.push({
      tag: 'span',
      attributes: attributes,
      children: [content]
    });

    if (title) {
      val.push({
        tag: 'span',
        attributes: {
          class: 'sr-only'
        },
        children: [title]
      });
    }

    return val;
  }
  function makeLayersCounterAbstract(params) {
    var content = params.content,
        title = params.title,
        extra = params.extra;

    var attributes = _objectSpread2(_objectSpread2(_objectSpread2({}, extra.attributes), title ? {
      'title': title
    } : {}), {}, {
      'class': extra.classes.join(' ')
    });

    var styleString = joinStyles(extra.styles);

    if (styleString.length > 0) {
      attributes['style'] = styleString;
    }

    var val = [];
    val.push({
      tag: 'span',
      attributes: attributes,
      children: [content]
    });

    if (title) {
      val.push({
        tag: 'span',
        attributes: {
          class: 'sr-only'
        },
        children: [title]
      });
    }

    return val;
  }

  var styles$1 = namespace.styles;
  function asFoundIcon(icon) {
    var width = icon[0];
    var height = icon[1];

    var _icon$slice = icon.slice(4),
        _icon$slice2 = _slicedToArray(_icon$slice, 1),
        vectorData = _icon$slice2[0];

    var element = null;

    if (Array.isArray(vectorData)) {
      element = {
        tag: 'g',
        attributes: {
          class: "".concat(config.cssPrefix, "-").concat(DUOTONE_CLASSES.GROUP)
        },
        children: [{
          tag: 'path',
          attributes: {
            class: "".concat(config.cssPrefix, "-").concat(DUOTONE_CLASSES.SECONDARY),
            fill: 'currentColor',
            d: vectorData[0]
          }
        }, {
          tag: 'path',
          attributes: {
            class: "".concat(config.cssPrefix, "-").concat(DUOTONE_CLASSES.PRIMARY),
            fill: 'currentColor',
            d: vectorData[1]
          }
        }]
      };
    } else {
      element = {
        tag: 'path',
        attributes: {
          fill: 'currentColor',
          d: vectorData
        }
      };
    }

    return {
      found: true,
      width: width,
      height: height,
      icon: element
    };
  }
  var missingIconResolutionMixin = {
    found: false,
    width: 512,
    height: 512
  };

  function maybeNotifyMissing(iconName, prefix) {
    if (!PRODUCTION && !config.showMissingIcons && iconName) {
      console.error("Icon with name \"".concat(iconName, "\" and prefix \"").concat(prefix, "\" is missing."));
    }
  }

  function findIcon(iconName, prefix) {
    var givenPrefix = prefix;

    if (prefix === 'fa' && config.styleDefault !== null) {
      prefix = getDefaultUsablePrefix();
    }

    return new Promise(function (resolve, reject) {
      var val = {
        found: false,
        width: 512,
        height: 512,
        icon: callProvided('missingIconAbstract') || {}
      };

      if (givenPrefix === 'fa') {
        var shim = byOldName(iconName) || {};
        iconName = shim.iconName || iconName;
        prefix = shim.prefix || prefix;
      }

      if (iconName && prefix && styles$1[prefix] && styles$1[prefix][iconName]) {
        var icon = styles$1[prefix][iconName];
        return resolve(asFoundIcon(icon));
      }

      maybeNotifyMissing(iconName, prefix);
      resolve(_objectSpread2(_objectSpread2({}, missingIconResolutionMixin), {}, {
        icon: config.showMissingIcons && iconName ? callProvided('missingIconAbstract') || {} : {}
      }));
    });
  }

  var noop$1 = function noop() {};

  var p = config.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : {
    mark: noop$1,
    measure: noop$1
  };
  var preamble = "FA \"6.5.2\"";

  var begin = function begin(name) {
    p.mark("".concat(preamble, " ").concat(name, " begins"));
    return function () {
      return end(name);
    };
  };

  var end = function end(name) {
    p.mark("".concat(preamble, " ").concat(name, " ends"));
    p.measure("".concat(preamble, " ").concat(name), "".concat(preamble, " ").concat(name, " begins"), "".concat(preamble, " ").concat(name, " ends"));
  };

  var perf = {
    begin: begin,
    end: end
  };

  var noop$2 = function noop() {};

  function isWatched(node) {
    var i2svg = node.getAttribute ? node.getAttribute(DATA_FA_I2SVG) : null;
    return typeof i2svg === 'string';
  }

  function hasPrefixAndIcon(node) {
    var prefix = node.getAttribute ? node.getAttribute(DATA_PREFIX) : null;
    var icon = node.getAttribute ? node.getAttribute(DATA_ICON) : null;
    return prefix && icon;
  }

  function hasBeenReplaced(node) {
    return node && node.classList && node.classList.contains && node.classList.contains(config.replacementClass);
  }

  function getMutator() {
    if (config.autoReplaceSvg === true) {
      return mutators.replace;
    }

    var mutator = mutators[config.autoReplaceSvg];
    return mutator || mutators.replace;
  }

  function createElementNS(tag) {
    return DOCUMENT.createElementNS('http://www.w3.org/2000/svg', tag);
  }

  function createElement(tag) {
    return DOCUMENT.createElement(tag);
  }

  function convertSVG(abstractObj) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$ceFn = params.ceFn,
        ceFn = _params$ceFn === void 0 ? abstractObj.tag === 'svg' ? createElementNS : createElement : _params$ceFn;

    if (typeof abstractObj === 'string') {
      return DOCUMENT.createTextNode(abstractObj);
    }

    var tag = ceFn(abstractObj.tag);
    Object.keys(abstractObj.attributes || []).forEach(function (key) {
      tag.setAttribute(key, abstractObj.attributes[key]);
    });
    var children = abstractObj.children || [];
    children.forEach(function (child) {
      tag.appendChild(convertSVG(child, {
        ceFn: ceFn
      }));
    });
    return tag;
  }

  function nodeAsComment(node) {
    var comment = " ".concat(node.outerHTML, " ");
    /* BEGIN.ATTRIBUTION */

    comment = "".concat(comment, "Font Awesome fontawesome.com ");
    /* END.ATTRIBUTION */

    return comment;
  }

  var mutators = {
    replace: function replace(mutation) {
      var node = mutation[0];

      if (node.parentNode) {
        mutation[1].forEach(function (_abstract) {
          node.parentNode.insertBefore(convertSVG(_abstract), node);
        });

        if (node.getAttribute(DATA_FA_I2SVG) === null && config.keepOriginalSource) {
          var comment = DOCUMENT.createComment(nodeAsComment(node));
          node.parentNode.replaceChild(comment, node);
        } else {
          node.remove();
        }
      }
    },
    nest: function nest(mutation) {
      var node = mutation[0];
      var _abstract2 = mutation[1]; // If we already have a replaced node we do not want to continue nesting within it.
      // Short-circuit to the standard replacement

      if (~classArray(node).indexOf(config.replacementClass)) {
        return mutators.replace(mutation);
      }

      var forSvg = new RegExp("".concat(config.cssPrefix, "-.*"));
      delete _abstract2[0].attributes.id;

      if (_abstract2[0].attributes.class) {
        var splitClasses = _abstract2[0].attributes.class.split(' ').reduce(function (acc, cls) {
          if (cls === config.replacementClass || cls.match(forSvg)) {
            acc.toSvg.push(cls);
          } else {
            acc.toNode.push(cls);
          }

          return acc;
        }, {
          toNode: [],
          toSvg: []
        });

        _abstract2[0].attributes.class = splitClasses.toSvg.join(' ');

        if (splitClasses.toNode.length === 0) {
          node.removeAttribute('class');
        } else {
          node.setAttribute('class', splitClasses.toNode.join(' '));
        }
      }

      var newInnerHTML = _abstract2.map(function (a) {
        return toHtml(a);
      }).join('\n');

      node.setAttribute(DATA_FA_I2SVG, '');
      node.innerHTML = newInnerHTML;
    }
  };

  function performOperationSync(op) {
    op();
  }

  function perform(mutations, callback) {
    var callbackFunction = typeof callback === 'function' ? callback : noop$2;

    if (mutations.length === 0) {
      callbackFunction();
    } else {
      var frame = performOperationSync;

      if (config.mutateApproach === MUTATION_APPROACH_ASYNC) {
        frame = WINDOW.requestAnimationFrame || performOperationSync;
      }

      frame(function () {
        var mutator = getMutator();
        var mark = perf.begin('mutate');
        mutations.map(mutator);
        mark();
        callbackFunction();
      });
    }
  }
  var disabled = false;
  function disableObservation() {
    disabled = true;
  }
  function enableObservation() {
    disabled = false;
  }
  var mo = null;
  function observe(options) {
    if (!MUTATION_OBSERVER) {
      return;
    }

    if (!config.observeMutations) {
      return;
    }

    var _options$treeCallback = options.treeCallback,
        treeCallback = _options$treeCallback === void 0 ? noop$2 : _options$treeCallback,
        _options$nodeCallback = options.nodeCallback,
        nodeCallback = _options$nodeCallback === void 0 ? noop$2 : _options$nodeCallback,
        _options$pseudoElemen = options.pseudoElementsCallback,
        pseudoElementsCallback = _options$pseudoElemen === void 0 ? noop$2 : _options$pseudoElemen,
        _options$observeMutat = options.observeMutationsRoot,
        observeMutationsRoot = _options$observeMutat === void 0 ? DOCUMENT : _options$observeMutat;
    mo = new MUTATION_OBSERVER(function (objects) {
      if (disabled) return;
      var defaultPrefix = getDefaultUsablePrefix();
      toArray(objects).forEach(function (mutationRecord) {
        if (mutationRecord.type === 'childList' && mutationRecord.addedNodes.length > 0 && !isWatched(mutationRecord.addedNodes[0])) {
          if (config.searchPseudoElements) {
            pseudoElementsCallback(mutationRecord.target);
          }

          treeCallback(mutationRecord.target);
        }

        if (mutationRecord.type === 'attributes' && mutationRecord.target.parentNode && config.searchPseudoElements) {
          pseudoElementsCallback(mutationRecord.target.parentNode);
        }

        if (mutationRecord.type === 'attributes' && isWatched(mutationRecord.target) && ~ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
          if (mutationRecord.attributeName === 'class' && hasPrefixAndIcon(mutationRecord.target)) {
            var _getCanonicalIcon = getCanonicalIcon(classArray(mutationRecord.target)),
                prefix = _getCanonicalIcon.prefix,
                iconName = _getCanonicalIcon.iconName;

            mutationRecord.target.setAttribute(DATA_PREFIX, prefix || defaultPrefix);
            if (iconName) mutationRecord.target.setAttribute(DATA_ICON, iconName);
          } else if (hasBeenReplaced(mutationRecord.target)) {
            nodeCallback(mutationRecord.target);
          }
        }
      });
    });
    if (!IS_DOM) return;
    mo.observe(observeMutationsRoot, {
      childList: true,
      attributes: true,
      characterData: true,
      subtree: true
    });
  }
  function disconnect() {
    if (!mo) return;
    mo.disconnect();
  }

  function styleParser (node) {
    var style = node.getAttribute('style');
    var val = [];

    if (style) {
      val = style.split(';').reduce(function (acc, style) {
        var styles = style.split(':');
        var prop = styles[0];
        var value = styles.slice(1);

        if (prop && value.length > 0) {
          acc[prop] = value.join(':').trim();
        }

        return acc;
      }, {});
    }

    return val;
  }

  function classParser (node) {
    var existingPrefix = node.getAttribute('data-prefix');
    var existingIconName = node.getAttribute('data-icon');
    var innerText = node.innerText !== undefined ? node.innerText.trim() : '';
    var val = getCanonicalIcon(classArray(node));

    if (!val.prefix) {
      val.prefix = getDefaultUsablePrefix();
    }

    if (existingPrefix && existingIconName) {
      val.prefix = existingPrefix;
      val.iconName = existingIconName;
    }

    if (val.iconName && val.prefix) {
      return val;
    }

    if (val.prefix && innerText.length > 0) {
      val.iconName = byLigature(val.prefix, node.innerText) || byUnicode(val.prefix, toHex(node.innerText));
    }

    if (!val.iconName && config.autoFetchSvg && node.firstChild && node.firstChild.nodeType === Node.TEXT_NODE) {
      val.iconName = node.firstChild.data;
    }

    return val;
  }

  function attributesParser (node) {
    var extraAttributes = toArray(node.attributes).reduce(function (acc, attr) {
      if (acc.name !== 'class' && acc.name !== 'style') {
        acc[attr.name] = attr.value;
      }

      return acc;
    }, {});
    var title = node.getAttribute('title');
    var titleId = node.getAttribute('data-fa-title-id');

    if (config.autoA11y) {
      if (title) {
        extraAttributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
      } else {
        extraAttributes['aria-hidden'] = 'true';
        extraAttributes['focusable'] = 'false';
      }
    }

    return extraAttributes;
  }

  function blankMeta() {
    return {
      iconName: null,
      title: null,
      titleId: null,
      prefix: null,
      transform: meaninglessTransform,
      symbol: false,
      mask: {
        iconName: null,
        prefix: null,
        rest: []
      },
      maskId: null,
      extra: {
        classes: [],
        styles: {},
        attributes: {}
      }
    };
  }
  function parseMeta(node) {
    var parser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      styleParser: true
    };

    var _classParser = classParser(node),
        iconName = _classParser.iconName,
        prefix = _classParser.prefix,
        extraClasses = _classParser.rest;

    var extraAttributes = attributesParser(node);
    var pluginMeta = chainHooks('parseNodeAttributes', {}, node);
    var extraStyles = parser.styleParser ? styleParser(node) : [];
    return _objectSpread2({
      iconName: iconName,
      title: node.getAttribute('title'),
      titleId: node.getAttribute('data-fa-title-id'),
      prefix: prefix,
      transform: meaninglessTransform,
      mask: {
        iconName: null,
        prefix: null,
        rest: []
      },
      maskId: null,
      symbol: false,
      extra: {
        classes: extraClasses,
        styles: extraStyles,
        attributes: extraAttributes
      }
    }, pluginMeta);
  }

  var styles$2 = namespace.styles;

  function generateMutation(node) {
    var nodeMeta = config.autoReplaceSvg === 'nest' ? parseMeta(node, {
      styleParser: false
    }) : parseMeta(node);

    if (~nodeMeta.extra.classes.indexOf(LAYERS_TEXT_CLASSNAME)) {
      return callProvided('generateLayersText', node, nodeMeta);
    } else {
      return callProvided('generateSvgReplacementMutation', node, nodeMeta);
    }
  }

  var knownPrefixes = new Set();
  FAMILIES.map(function (family) {
    knownPrefixes.add("fa-".concat(family));
  });
  Object.keys(PREFIX_TO_STYLE[FAMILY_CLASSIC]).map(knownPrefixes.add.bind(knownPrefixes));
  Object.keys(PREFIX_TO_STYLE[FAMILY_SHARP]).map(knownPrefixes.add.bind(knownPrefixes));
  knownPrefixes = _toConsumableArray(knownPrefixes);

  function onTree(root) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (!IS_DOM) return Promise.resolve();
    var htmlClassList = DOCUMENT.documentElement.classList;

    var hclAdd = function hclAdd(suffix) {
      return htmlClassList.add("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };

    var hclRemove = function hclRemove(suffix) {
      return htmlClassList.remove("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };

    var prefixes = config.autoFetchSvg ? knownPrefixes : FAMILIES.map(function (f) {
      return "fa-".concat(f);
    }).concat(Object.keys(styles$2));

    if (!prefixes.includes('fa')) {
      prefixes.push('fa');
    }

    var prefixesDomQuery = [".".concat(LAYERS_TEXT_CLASSNAME, ":not([").concat(DATA_FA_I2SVG, "])")].concat(prefixes.map(function (p) {
      return ".".concat(p, ":not([").concat(DATA_FA_I2SVG, "])");
    })).join(', ');

    if (prefixesDomQuery.length === 0) {
      return Promise.resolve();
    }

    var candidates = [];

    try {
      candidates = toArray(root.querySelectorAll(prefixesDomQuery));
    } catch (e) {// noop
    }

    if (candidates.length > 0) {
      hclAdd('pending');
      hclRemove('complete');
    } else {
      return Promise.resolve();
    }

    var mark = perf.begin('onTree');
    var mutations = candidates.reduce(function (acc, node) {
      try {
        var mutation = generateMutation(node);

        if (mutation) {
          acc.push(mutation);
        }
      } catch (e) {
        if (!PRODUCTION) {
          if (e.name === 'MissingIcon') {
            console.error(e);
          }
        }
      }

      return acc;
    }, []);
    return new Promise(function (resolve, reject) {
      Promise.all(mutations).then(function (resolvedMutations) {
        perform(resolvedMutations, function () {
          hclAdd('active');
          hclAdd('complete');
          hclRemove('pending');
          if (typeof callback === 'function') callback();
          mark();
          resolve();
        });
      }).catch(function (e) {
        mark();
        reject(e);
      });
    });
  }

  function onNode(node) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    generateMutation(node).then(function (mutation) {
      if (mutation) {
        perform([mutation], callback);
      }
    });
  }

  function resolveIcons(next) {
    return function (maybeIconDefinition) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : findIconDefinition(maybeIconDefinition || {});
      var mask = params.mask;

      if (mask) {
        mask = (mask || {}).icon ? mask : findIconDefinition(mask || {});
      }

      return next(iconDefinition, _objectSpread2(_objectSpread2({}, params), {}, {
        mask: mask
      }));
    };
  }

  var render = function render(iconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$transform = params.transform,
        transform = _params$transform === void 0 ? meaninglessTransform : _params$transform,
        _params$symbol = params.symbol,
        symbol = _params$symbol === void 0 ? false : _params$symbol,
        _params$mask = params.mask,
        mask = _params$mask === void 0 ? null : _params$mask,
        _params$maskId = params.maskId,
        maskId = _params$maskId === void 0 ? null : _params$maskId,
        _params$title = params.title,
        title = _params$title === void 0 ? null : _params$title,
        _params$titleId = params.titleId,
        titleId = _params$titleId === void 0 ? null : _params$titleId,
        _params$classes = params.classes,
        classes = _params$classes === void 0 ? [] : _params$classes,
        _params$attributes = params.attributes,
        attributes = _params$attributes === void 0 ? {} : _params$attributes,
        _params$styles = params.styles,
        styles = _params$styles === void 0 ? {} : _params$styles;
    if (!iconDefinition) return;
    var prefix = iconDefinition.prefix,
        iconName = iconDefinition.iconName,
        icon = iconDefinition.icon;
    return domVariants(_objectSpread2({
      type: 'icon'
    }, iconDefinition), function () {
      callHooks('beforeDOMElementCreation', {
        iconDefinition: iconDefinition,
        params: params
      });

      if (config.autoA11y) {
        if (title) {
          attributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
        } else {
          attributes['aria-hidden'] = 'true';
          attributes['focusable'] = 'false';
        }
      }

      return makeInlineSvgAbstract({
        icons: {
          main: asFoundIcon(icon),
          mask: mask ? asFoundIcon(mask.icon) : {
            found: false,
            width: null,
            height: null,
            icon: {}
          }
        },
        prefix: prefix,
        iconName: iconName,
        transform: _objectSpread2(_objectSpread2({}, meaninglessTransform), transform),
        symbol: symbol,
        title: title,
        maskId: maskId,
        titleId: titleId,
        extra: {
          attributes: attributes,
          styles: styles,
          classes: classes
        }
      });
    });
  };
  var ReplaceElements = {
    mixout: function mixout() {
      return {
        icon: resolveIcons(render)
      };
    },
    hooks: function hooks() {
      return {
        mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
          accumulator.treeCallback = onTree;
          accumulator.nodeCallback = onNode;
          return accumulator;
        }
      };
    },
    provides: function provides(providers$$1) {
      providers$$1.i2svg = function (params) {
        var _params$node = params.node,
            node = _params$node === void 0 ? DOCUMENT : _params$node,
            _params$callback = params.callback,
            callback = _params$callback === void 0 ? function () {} : _params$callback;
        return onTree(node, callback);
      };

      providers$$1.generateSvgReplacementMutation = function (node, nodeMeta) {
        var iconName = nodeMeta.iconName,
            title = nodeMeta.title,
            titleId = nodeMeta.titleId,
            prefix = nodeMeta.prefix,
            transform = nodeMeta.transform,
            symbol = nodeMeta.symbol,
            mask = nodeMeta.mask,
            maskId = nodeMeta.maskId,
            extra = nodeMeta.extra;
        return new Promise(function (resolve, reject) {
          Promise.all([findIcon(iconName, prefix), mask.iconName ? findIcon(mask.iconName, mask.prefix) : Promise.resolve({
            found: false,
            width: 512,
            height: 512,
            icon: {}
          })]).then(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                main = _ref2[0],
                mask = _ref2[1];

            resolve([node, makeInlineSvgAbstract({
              icons: {
                main: main,
                mask: mask
              },
              prefix: prefix,
              iconName: iconName,
              transform: transform,
              symbol: symbol,
              maskId: maskId,
              title: title,
              titleId: titleId,
              extra: extra,
              watchable: true
            })]);
          }).catch(reject);
        });
      };

      providers$$1.generateAbstractIcon = function (_ref3) {
        var children = _ref3.children,
            attributes = _ref3.attributes,
            main = _ref3.main,
            transform = _ref3.transform,
            styles = _ref3.styles;
        var styleString = joinStyles(styles);

        if (styleString.length > 0) {
          attributes['style'] = styleString;
        }

        var nextChild;

        if (transformIsMeaningful(transform)) {
          nextChild = callProvided('generateAbstractTransformGrouping', {
            main: main,
            transform: transform,
            containerWidth: main.width,
            iconWidth: main.width
          });
        }

        children.push(nextChild || main.icon);
        return {
          children: children,
          attributes: attributes
        };
      };
    }
  };

  var Layers = {
    mixout: function mixout() {
      return {
        layer: function layer(assembler) {
          var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var _params$classes = params.classes,
              classes = _params$classes === void 0 ? [] : _params$classes;
          return domVariants({
            type: 'layer'
          }, function () {
            callHooks('beforeDOMElementCreation', {
              assembler: assembler,
              params: params
            });
            var children = [];
            assembler(function (args) {
              Array.isArray(args) ? args.map(function (a) {
                children = children.concat(a.abstract);
              }) : children = children.concat(args.abstract);
            });
            return [{
              tag: 'span',
              attributes: {
                class: ["".concat(config.cssPrefix, "-layers")].concat(_toConsumableArray(classes)).join(' ')
              },
              children: children
            }];
          });
        }
      };
    }
  };

  var LayersCounter = {
    mixout: function mixout() {
      return {
        counter: function counter(content) {
          var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var _params$title = params.title,
              title = _params$title === void 0 ? null : _params$title,
              _params$classes = params.classes,
              classes = _params$classes === void 0 ? [] : _params$classes,
              _params$attributes = params.attributes,
              attributes = _params$attributes === void 0 ? {} : _params$attributes,
              _params$styles = params.styles,
              styles = _params$styles === void 0 ? {} : _params$styles;
          return domVariants({
            type: 'counter',
            content: content
          }, function () {
            callHooks('beforeDOMElementCreation', {
              content: content,
              params: params
            });
            return makeLayersCounterAbstract({
              content: content.toString(),
              title: title,
              extra: {
                attributes: attributes,
                styles: styles,
                classes: ["".concat(config.cssPrefix, "-layers-counter")].concat(_toConsumableArray(classes))
              }
            });
          });
        }
      };
    }
  };

  var LayersText = {
    mixout: function mixout() {
      return {
        text: function text(content) {
          var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var _params$transform = params.transform,
              transform = _params$transform === void 0 ? meaninglessTransform : _params$transform,
              _params$title = params.title,
              title = _params$title === void 0 ? null : _params$title,
              _params$classes = params.classes,
              classes = _params$classes === void 0 ? [] : _params$classes,
              _params$attributes = params.attributes,
              attributes = _params$attributes === void 0 ? {} : _params$attributes,
              _params$styles = params.styles,
              styles = _params$styles === void 0 ? {} : _params$styles;
          return domVariants({
            type: 'text',
            content: content
          }, function () {
            callHooks('beforeDOMElementCreation', {
              content: content,
              params: params
            });
            return makeLayersTextAbstract({
              content: content,
              transform: _objectSpread2(_objectSpread2({}, meaninglessTransform), transform),
              title: title,
              extra: {
                attributes: attributes,
                styles: styles,
                classes: ["".concat(config.cssPrefix, "-layers-text")].concat(_toConsumableArray(classes))
              }
            });
          });
        }
      };
    },
    provides: function provides(providers$$1) {
      providers$$1.generateLayersText = function (node, nodeMeta) {
        var title = nodeMeta.title,
            transform = nodeMeta.transform,
            extra = nodeMeta.extra;
        var width = null;
        var height = null;

        if (IS_IE) {
          var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
          var boundingClientRect = node.getBoundingClientRect();
          width = boundingClientRect.width / computedFontSize;
          height = boundingClientRect.height / computedFontSize;
        }

        if (config.autoA11y && !title) {
          extra.attributes['aria-hidden'] = 'true';
        }

        return Promise.resolve([node, makeLayersTextAbstract({
          content: node.innerHTML,
          width: width,
          height: height,
          transform: transform,
          title: title,
          extra: extra,
          watchable: true
        })]);
      };
    }
  };

  var CLEAN_CONTENT_PATTERN = new RegExp("\"", 'ug');
  var SECONDARY_UNICODE_RANGE = [1105920, 1112319];
  function hexValueFromContent(content) {
    var cleaned = content.replace(CLEAN_CONTENT_PATTERN, '');
    var codePoint = codePointAt(cleaned, 0);
    var isPrependTen = codePoint >= SECONDARY_UNICODE_RANGE[0] && codePoint <= SECONDARY_UNICODE_RANGE[1];
    var isDoubled = cleaned.length === 2 ? cleaned[0] === cleaned[1] : false;
    return {
      value: isDoubled ? toHex(cleaned[0]) : toHex(cleaned),
      isSecondary: isPrependTen || isDoubled
    };
  }

  function replaceForPosition(node, position) {
    var pendingAttribute = "".concat(DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(':', '-'));
    return new Promise(function (resolve, reject) {
      if (node.getAttribute(pendingAttribute) !== null) {
        // This node is already being processed
        return resolve();
      }

      var children = toArray(node.children);
      var alreadyProcessedPseudoElement = children.filter(function (c) {
        return c.getAttribute(DATA_FA_PSEUDO_ELEMENT) === position;
      })[0];
      var styles = WINDOW.getComputedStyle(node, position);
      var fontFamily = styles.getPropertyValue('font-family').match(FONT_FAMILY_PATTERN);
      var fontWeight = styles.getPropertyValue('font-weight');
      var content = styles.getPropertyValue('content');

      if (alreadyProcessedPseudoElement && !fontFamily) {
        // If we've already processed it but the current computed style does not result in a font-family,
        // that probably means that a class name that was previously present to make the icon has been
        // removed. So we now should delete the icon.
        node.removeChild(alreadyProcessedPseudoElement);
        return resolve();
      } else if (fontFamily && content !== 'none' && content !== '') {
        var _content = styles.getPropertyValue('content');

        var family = ~['Sharp'].indexOf(fontFamily[2]) ? FAMILY_SHARP : FAMILY_CLASSIC;
        var prefix = ~['Solid', 'Regular', 'Light', 'Thin', 'Duotone', 'Brands', 'Kit'].indexOf(fontFamily[2]) ? STYLE_TO_PREFIX[family][fontFamily[2].toLowerCase()] : FONT_WEIGHT_TO_PREFIX[family][fontWeight];

        var _hexValueFromContent = hexValueFromContent(_content),
            hexValue = _hexValueFromContent.value,
            isSecondary = _hexValueFromContent.isSecondary;

        var isV4 = fontFamily[0].startsWith('FontAwesome');
        var iconName = byUnicode(prefix, hexValue);
        var iconIdentifier = iconName;

        if (isV4) {
          var iconName4 = byOldUnicode(hexValue);

          if (iconName4.iconName && iconName4.prefix) {
            iconName = iconName4.iconName;
            prefix = iconName4.prefix;
          }
        } // Only convert the pseudo element in this ::before/::after position into an icon if we haven't
        // already done so with the same prefix and iconName


        if (iconName && !isSecondary && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute(DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute(DATA_ICON) !== iconIdentifier)) {
          node.setAttribute(pendingAttribute, iconIdentifier);

          if (alreadyProcessedPseudoElement) {
            // Delete the old one, since we're replacing it with a new one
            node.removeChild(alreadyProcessedPseudoElement);
          }

          var meta = blankMeta();
          var extra = meta.extra;
          extra.attributes[DATA_FA_PSEUDO_ELEMENT] = position;
          findIcon(iconName, prefix).then(function (main) {
            var _abstract = makeInlineSvgAbstract(_objectSpread2(_objectSpread2({}, meta), {}, {
              icons: {
                main: main,
                mask: emptyCanonicalIcon()
              },
              prefix: prefix,
              iconName: iconIdentifier,
              extra: extra,
              watchable: true
            }));

            var element = DOCUMENT.createElementNS('http://www.w3.org/2000/svg', 'svg');

            if (position === '::before') {
              node.insertBefore(element, node.firstChild);
            } else {
              node.appendChild(element);
            }

            element.outerHTML = _abstract.map(function (a) {
              return toHtml(a);
            }).join('\n');
            node.removeAttribute(pendingAttribute);
            resolve();
          }).catch(reject);
        } else {
          resolve();
        }
      } else {
        resolve();
      }
    });
  }

  function replace(node) {
    return Promise.all([replaceForPosition(node, '::before'), replaceForPosition(node, '::after')]);
  }

  function processable(node) {
    return node.parentNode !== document.head && !~TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute(DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== 'svg');
  }

  function searchPseudoElements(root) {
    if (!IS_DOM) return;
    return new Promise(function (resolve, reject) {
      var operations = toArray(root.querySelectorAll('*')).filter(processable).map(replace);
      var end = perf.begin('searchPseudoElements');
      disableObservation();
      Promise.all(operations).then(function () {
        end();
        enableObservation();
        resolve();
      }).catch(function () {
        end();
        enableObservation();
        reject();
      });
    });
  }

  var PseudoElements = {
    hooks: function hooks() {
      return {
        mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
          accumulator.pseudoElementsCallback = searchPseudoElements;
          return accumulator;
        }
      };
    },
    provides: function provides(providers$$1) {
      providers$$1.pseudoElements2svg = function (params) {
        var _params$node = params.node,
            node = _params$node === void 0 ? DOCUMENT : _params$node;

        if (config.searchPseudoElements) {
          searchPseudoElements(node);
        }
      };
    }
  };

  var _unwatched = false;
  var MutationObserver$1 = {
    mixout: function mixout() {
      return {
        dom: {
          unwatch: function unwatch() {
            disableObservation();
            _unwatched = true;
          }
        }
      };
    },
    hooks: function hooks() {
      return {
        bootstrap: function bootstrap() {
          observe(chainHooks('mutationObserverCallbacks', {}));
        },
        noAuto: function noAuto() {
          disconnect();
        },
        watch: function watch(params) {
          var observeMutationsRoot = params.observeMutationsRoot;

          if (_unwatched) {
            enableObservation();
          } else {
            observe(chainHooks('mutationObserverCallbacks', {
              observeMutationsRoot: observeMutationsRoot
            }));
          }
        }
      };
    }
  };

  var parseTransformString = function parseTransformString(transformString) {
    var transform = {
      size: 16,
      x: 0,
      y: 0,
      flipX: false,
      flipY: false,
      rotate: 0
    };
    return transformString.toLowerCase().split(' ').reduce(function (acc, n) {
      var parts = n.toLowerCase().split('-');
      var first = parts[0];
      var rest = parts.slice(1).join('-');

      if (first && rest === 'h') {
        acc.flipX = true;
        return acc;
      }

      if (first && rest === 'v') {
        acc.flipY = true;
        return acc;
      }

      rest = parseFloat(rest);

      if (isNaN(rest)) {
        return acc;
      }

      switch (first) {
        case 'grow':
          acc.size = acc.size + rest;
          break;

        case 'shrink':
          acc.size = acc.size - rest;
          break;

        case 'left':
          acc.x = acc.x - rest;
          break;

        case 'right':
          acc.x = acc.x + rest;
          break;

        case 'up':
          acc.y = acc.y - rest;
          break;

        case 'down':
          acc.y = acc.y + rest;
          break;

        case 'rotate':
          acc.rotate = acc.rotate + rest;
          break;
      }

      return acc;
    }, transform);
  };
  var PowerTransforms = {
    mixout: function mixout() {
      return {
        parse: {
          transform: function transform(transformString) {
            return parseTransformString(transformString);
          }
        }
      };
    },
    hooks: function hooks() {
      return {
        parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
          var transformString = node.getAttribute('data-fa-transform');

          if (transformString) {
            accumulator.transform = parseTransformString(transformString);
          }

          return accumulator;
        }
      };
    },
    provides: function provides(providers) {
      providers.generateAbstractTransformGrouping = function (_ref) {
        var main = _ref.main,
            transform = _ref.transform,
            containerWidth = _ref.containerWidth,
            iconWidth = _ref.iconWidth;
        var outer = {
          transform: "translate(".concat(containerWidth / 2, " 256)")
        };
        var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
        var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
        var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
        var inner = {
          transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
        };
        var path = {
          transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
        };
        var operations = {
          outer: outer,
          inner: inner,
          path: path
        };
        return {
          tag: 'g',
          attributes: _objectSpread2({}, operations.outer),
          children: [{
            tag: 'g',
            attributes: _objectSpread2({}, operations.inner),
            children: [{
              tag: main.icon.tag,
              children: main.icon.children,
              attributes: _objectSpread2(_objectSpread2({}, main.icon.attributes), operations.path)
            }]
          }]
        };
      };
    }
  };

  var ALL_SPACE = {
    x: 0,
    y: 0,
    width: '100%',
    height: '100%'
  };

  function fillBlack(_abstract) {
    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (_abstract.attributes && (_abstract.attributes.fill || force)) {
      _abstract.attributes.fill = 'black';
    }

    return _abstract;
  }

  function deGroup(_abstract2) {
    if (_abstract2.tag === 'g') {
      return _abstract2.children;
    } else {
      return [_abstract2];
    }
  }

  var Masks = {
    hooks: function hooks() {
      return {
        parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
          var maskData = node.getAttribute('data-fa-mask');
          var mask = !maskData ? emptyCanonicalIcon() : getCanonicalIcon(maskData.split(' ').map(function (i) {
            return i.trim();
          }));

          if (!mask.prefix) {
            mask.prefix = getDefaultUsablePrefix();
          }

          accumulator.mask = mask;
          accumulator.maskId = node.getAttribute('data-fa-mask-id');
          return accumulator;
        }
      };
    },
    provides: function provides(providers) {
      providers.generateAbstractMask = function (_ref) {
        var children = _ref.children,
            attributes = _ref.attributes,
            main = _ref.main,
            mask = _ref.mask,
            explicitMaskId = _ref.maskId,
            transform = _ref.transform;
        var mainWidth = main.width,
            mainPath = main.icon;
        var maskWidth = mask.width,
            maskPath = mask.icon;
        var trans = transformForSvg({
          transform: transform,
          containerWidth: maskWidth,
          iconWidth: mainWidth
        });
        var maskRect = {
          tag: 'rect',
          attributes: _objectSpread2(_objectSpread2({}, ALL_SPACE), {}, {
            fill: 'white'
          })
        };
        var maskInnerGroupChildrenMixin = mainPath.children ? {
          children: mainPath.children.map(fillBlack)
        } : {};
        var maskInnerGroup = {
          tag: 'g',
          attributes: _objectSpread2({}, trans.inner),
          children: [fillBlack(_objectSpread2({
            tag: mainPath.tag,
            attributes: _objectSpread2(_objectSpread2({}, mainPath.attributes), trans.path)
          }, maskInnerGroupChildrenMixin))]
        };
        var maskOuterGroup = {
          tag: 'g',
          attributes: _objectSpread2({}, trans.outer),
          children: [maskInnerGroup]
        };
        var maskId = "mask-".concat(explicitMaskId || nextUniqueId());
        var clipId = "clip-".concat(explicitMaskId || nextUniqueId());
        var maskTag = {
          tag: 'mask',
          attributes: _objectSpread2(_objectSpread2({}, ALL_SPACE), {}, {
            id: maskId,
            maskUnits: 'userSpaceOnUse',
            maskContentUnits: 'userSpaceOnUse'
          }),
          children: [maskRect, maskOuterGroup]
        };
        var defs = {
          tag: 'defs',
          children: [{
            tag: 'clipPath',
            attributes: {
              id: clipId
            },
            children: deGroup(maskPath)
          }, maskTag]
        };
        children.push(defs, {
          tag: 'rect',
          attributes: _objectSpread2({
            fill: 'currentColor',
            'clip-path': "url(#".concat(clipId, ")"),
            mask: "url(#".concat(maskId, ")")
          }, ALL_SPACE)
        });
        return {
          children: children,
          attributes: attributes
        };
      };
    }
  };

  var MissingIconIndicator = {
    provides: function provides(providers) {
      var reduceMotion = false;

      if (WINDOW.matchMedia) {
        reduceMotion = WINDOW.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      providers.missingIconAbstract = function () {
        var gChildren = [];
        var FILL = {
          fill: 'currentColor'
        };
        var ANIMATION_BASE = {
          attributeType: 'XML',
          repeatCount: 'indefinite',
          dur: '2s'
        }; // Ring

        gChildren.push({
          tag: 'path',
          attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
            d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
          })
        });

        var OPACITY_ANIMATE = _objectSpread2(_objectSpread2({}, ANIMATION_BASE), {}, {
          attributeName: 'opacity'
        });

        var dot = {
          tag: 'circle',
          attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
            cx: '256',
            cy: '364',
            r: '28'
          }),
          children: []
        };

        if (!reduceMotion) {
          dot.children.push({
            tag: 'animate',
            attributes: _objectSpread2(_objectSpread2({}, ANIMATION_BASE), {}, {
              attributeName: 'r',
              values: '28;14;28;28;14;28;'
            })
          }, {
            tag: 'animate',
            attributes: _objectSpread2(_objectSpread2({}, OPACITY_ANIMATE), {}, {
              values: '1;0;1;1;0;1;'
            })
          });
        }

        gChildren.push(dot);
        gChildren.push({
          tag: 'path',
          attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
            opacity: '1',
            d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
          }),
          children: reduceMotion ? [] : [{
            tag: 'animate',
            attributes: _objectSpread2(_objectSpread2({}, OPACITY_ANIMATE), {}, {
              values: '1;0;0;0;0;1;'
            })
          }]
        });

        if (!reduceMotion) {
          // Exclamation
          gChildren.push({
            tag: 'path',
            attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
              opacity: '0',
              d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
            }),
            children: [{
              tag: 'animate',
              attributes: _objectSpread2(_objectSpread2({}, OPACITY_ANIMATE), {}, {
                values: '0;0;1;1;0;0;'
              })
            }]
          });
        }

        return {
          tag: 'g',
          attributes: {
            'class': 'missing'
          },
          children: gChildren
        };
      };
    }
  };

  var SvgSymbols = {
    hooks: function hooks() {
      return {
        parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
          var symbolData = node.getAttribute('data-fa-symbol');
          var symbol = symbolData === null ? false : symbolData === '' ? true : symbolData;
          accumulator['symbol'] = symbol;
          return accumulator;
        }
      };
    }
  };

  var plugins = [InjectCSS, ReplaceElements, Layers, LayersCounter, LayersText, PseudoElements, MutationObserver$1, PowerTransforms, Masks, MissingIconIndicator, SvgSymbols];

  registerPlugins(plugins, {
    mixoutsTo: api
  });
  var noAuto$1 = api.noAuto;
  var config$1 = api.config;
  var library$1 = api.library;
  var dom$1 = api.dom;
  var parse$1 = api.parse;
  var findIconDefinition$1 = api.findIconDefinition;
  var toHtml$1 = api.toHtml;
  var icon = api.icon;
  var layer = api.layer;
  var text = api.text;
  var counter = api.counter;

  exports.noAuto = noAuto$1;
  exports.config = config$1;
  exports.library = library$1;
  exports.dom = dom$1;
  exports.parse = parse$1;
  exports.findIconDefinition = findIconDefinition$1;
  exports.toHtml = toHtml$1;
  exports.icon = icon;
  exports.layer = layer;
  exports.text = text;
  exports.counter = counter;
  exports.api = api;

  Object.defineProperty(exports, '__esModule', { value: true });

})));

}).call(this)}).call(this,require('_process'))
},{"_process":196}],150:[function(require,module,exports){
module.exports = require('./lib/axios');
},{"./lib/axios":152}],151:[function(require,module,exports){
'use strict';

var utils = require('./../utils');
var settle = require('./../core/settle');
var cookies = require('./../helpers/cookies');
var buildURL = require('./../helpers/buildURL');
var buildFullPath = require('../core/buildFullPath');
var parseHeaders = require('./../helpers/parseHeaders');
var isURLSameOrigin = require('./../helpers/isURLSameOrigin');
var createError = require('../core/createError');

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

},{"../core/buildFullPath":158,"../core/createError":159,"./../core/settle":163,"./../helpers/buildURL":167,"./../helpers/cookies":169,"./../helpers/isURLSameOrigin":172,"./../helpers/parseHeaders":174,"./../utils":177}],152:[function(require,module,exports){
'use strict';

var utils = require('./utils');
var bind = require('./helpers/bind');
var Axios = require('./core/Axios');
var mergeConfig = require('./core/mergeConfig');
var defaults = require('./defaults');

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = require('./cancel/Cancel');
axios.CancelToken = require('./cancel/CancelToken');
axios.isCancel = require('./cancel/isCancel');

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = require('./helpers/spread');

// Expose isAxiosError
axios.isAxiosError = require('./helpers/isAxiosError');

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;

},{"./cancel/Cancel":153,"./cancel/CancelToken":154,"./cancel/isCancel":155,"./core/Axios":156,"./core/mergeConfig":162,"./defaults":165,"./helpers/bind":166,"./helpers/isAxiosError":171,"./helpers/spread":175,"./utils":177}],153:[function(require,module,exports){
'use strict';

/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;

},{}],154:[function(require,module,exports){
'use strict';

var Cancel = require('./Cancel');

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;

},{"./Cancel":153}],155:[function(require,module,exports){
'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

},{}],156:[function(require,module,exports){
'use strict';

var utils = require('./../utils');
var buildURL = require('../helpers/buildURL');
var InterceptorManager = require('./InterceptorManager');
var dispatchRequest = require('./dispatchRequest');
var mergeConfig = require('./mergeConfig');
var validator = require('../helpers/validator');

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      forcedJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      clarifyTimeoutError: validators.transitional(validators.boolean, '1.0.0')
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;

},{"../helpers/buildURL":167,"../helpers/validator":176,"./../utils":177,"./InterceptorManager":157,"./dispatchRequest":160,"./mergeConfig":162}],157:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;

},{"./../utils":177}],158:[function(require,module,exports){
'use strict';

var isAbsoluteURL = require('../helpers/isAbsoluteURL');
var combineURLs = require('../helpers/combineURLs');

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};

},{"../helpers/combineURLs":168,"../helpers/isAbsoluteURL":170}],159:[function(require,module,exports){
'use strict';

var enhanceError = require('./enhanceError');

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};

},{"./enhanceError":161}],160:[function(require,module,exports){
'use strict';

var utils = require('./../utils');
var transformData = require('./transformData');
var isCancel = require('../cancel/isCancel');
var defaults = require('../defaults');

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};

},{"../cancel/isCancel":155,"../defaults":165,"./../utils":177,"./transformData":164}],161:[function(require,module,exports){
'use strict';

/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};

},{}],162:[function(require,module,exports){
'use strict';

var utils = require('../utils');

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, mergeDeepProperties);

  return config;
};

},{"../utils":177}],163:[function(require,module,exports){
'use strict';

var createError = require('./createError');

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};

},{"./createError":159}],164:[function(require,module,exports){
'use strict';

var utils = require('./../utils');
var defaults = require('./../defaults');

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};

},{"./../defaults":165,"./../utils":177}],165:[function(require,module,exports){
(function (process){(function (){
'use strict';

var utils = require('./utils');
var normalizeHeaderName = require('./helpers/normalizeHeaderName');
var enhanceError = require('./core/enhanceError');

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = require('./adapters/xhr');
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = require('./adapters/http');
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

}).call(this)}).call(this,require('_process'))
},{"./adapters/http":151,"./adapters/xhr":151,"./core/enhanceError":161,"./helpers/normalizeHeaderName":173,"./utils":177,"_process":196}],166:[function(require,module,exports){
'use strict';

module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

},{}],167:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

},{"./../utils":177}],168:[function(require,module,exports){
'use strict';

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};

},{}],169:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);

},{"./../utils":177}],170:[function(require,module,exports){
'use strict';

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

},{}],171:[function(require,module,exports){
'use strict';

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};

},{}],172:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);

},{"./../utils":177}],173:[function(require,module,exports){
'use strict';

var utils = require('../utils');

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

},{"../utils":177}],174:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};

},{"./../utils":177}],175:[function(require,module,exports){
'use strict';

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

},{}],176:[function(require,module,exports){
'use strict';

var pkg = require('./../../package.json');

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};
var currentVerArr = pkg.version.split('.');

/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */
function isOlderVersion(version, thanVersion) {
  var pkgVersionArr = thanVersion ? thanVersion.split('.') : currentVerArr;
  var destVer = version.split('.');
  for (var i = 0; i < 3; i++) {
    if (pkgVersionArr[i] > destVer[i]) {
      return true;
    } else if (pkgVersionArr[i] < destVer[i]) {
      return false;
    }
  }
  return false;
}

/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  var isDeprecated = version && isOlderVersion(version);

  function formatMessage(opt, desc) {
    return '[Axios v' + pkg.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed in ' + version));
    }

    if (isDeprecated && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

module.exports = {
  isOlderVersion: isOlderVersion,
  assertOptions: assertOptions,
  validators: validators
};

},{"./../../package.json":178}],177:[function(require,module,exports){
'use strict';

var bind = require('./helpers/bind');

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};

},{"./helpers/bind":166}],178:[function(require,module,exports){
module.exports={
  "name": "axios",
  "version": "0.21.4",
  "description": "Promise based HTTP client for the browser and node.js",
  "main": "index.js",
  "scripts": {
    "test": "grunt test",
    "start": "node ./sandbox/server.js",
    "build": "NODE_ENV=production grunt build",
    "preversion": "npm test",
    "version": "npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json",
    "postversion": "git push && git push --tags",
    "examples": "node ./examples/server.js",
    "coveralls": "cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js",
    "fix": "eslint --fix lib/**/*.js"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/axios/axios.git"
  },
  "keywords": [
    "xhr",
    "http",
    "ajax",
    "promise",
    "node"
  ],
  "author": "Matt Zabriskie",
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/axios/axios/issues"
  },
  "homepage": "https://axios-http.com",
  "devDependencies": {
    "coveralls": "^3.0.0",
    "es6-promise": "^4.2.4",
    "grunt": "^1.3.0",
    "grunt-banner": "^0.6.0",
    "grunt-cli": "^1.2.0",
    "grunt-contrib-clean": "^1.1.0",
    "grunt-contrib-watch": "^1.0.0",
    "grunt-eslint": "^23.0.0",
    "grunt-karma": "^4.0.0",
    "grunt-mocha-test": "^0.13.3",
    "grunt-ts": "^6.0.0-beta.19",
    "grunt-webpack": "^4.0.2",
    "istanbul-instrumenter-loader": "^1.0.0",
    "jasmine-core": "^2.4.1",
    "karma": "^6.3.2",
    "karma-chrome-launcher": "^3.1.0",
    "karma-firefox-launcher": "^2.1.0",
    "karma-jasmine": "^1.1.1",
    "karma-jasmine-ajax": "^0.1.13",
    "karma-safari-launcher": "^1.0.0",
    "karma-sauce-launcher": "^4.3.6",
    "karma-sinon": "^1.0.5",
    "karma-sourcemap-loader": "^0.3.8",
    "karma-webpack": "^4.0.2",
    "load-grunt-tasks": "^3.5.2",
    "minimist": "^1.2.0",
    "mocha": "^8.2.1",
    "sinon": "^4.5.0",
    "terser-webpack-plugin": "^4.2.3",
    "typescript": "^4.0.5",
    "url-search-params": "^0.10.0",
    "webpack": "^4.44.2",
    "webpack-dev-server": "^3.11.0"
  },
  "browser": {
    "./lib/adapters/http.js": "./lib/adapters/xhr.js"
  },
  "jsdelivr": "dist/axios.min.js",
  "unpkg": "dist/axios.min.js",
  "typings": "./index.d.ts",
  "dependencies": {
    "follow-redirects": "^1.14.0"
  },
  "bundlesize": [
    {
      "path": "./dist/axios.min.js",
      "threshold": "5kB"
    }
  ]
}

},{}],179:[function(require,module,exports){
// Generated by CoffeeScript 1.11.1
(function() {
  var AnimatedText, AnimatedTextFactory, Bar, BaseDonut, BaseGauge, Donut, Gauge, GaugePointer, TextRenderer, ValueUpdater, addCommas, cutHex, formatNumber, mergeObjects, secondsToString,
    slice = [].slice,
    hasProp = {}.hasOwnProperty,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  (function() {
    var browserRequestAnimationFrame, isCancelled, j, lastId, len, vendor, vendors;
    vendors = ['ms', 'moz', 'webkit', 'o'];
    for (j = 0, len = vendors.length; j < len; j++) {
      vendor = vendors[j];
      if (window.requestAnimationFrame) {
        break;
      }
      window.requestAnimationFrame = window[vendor + 'RequestAnimationFrame'];
      window.cancelAnimationFrame = window[vendor + 'CancelAnimationFrame'] || window[vendor + 'CancelRequestAnimationFrame'];
    }
    browserRequestAnimationFrame = null;
    lastId = 0;
    isCancelled = {};
    if (!requestAnimationFrame) {
      window.requestAnimationFrame = function(callback, element) {
        var currTime, id, lastTime, timeToCall;
        currTime = new Date().getTime();
        timeToCall = Math.max(0, 16 - (currTime - lastTime));
        id = window.setTimeout(function() {
          return callback(currTime + timeToCall);
        }, timeToCall);
        lastTime = currTime + timeToCall;
        return id;
      };
      return window.cancelAnimationFrame = function(id) {
        return clearTimeout(id);
      };
    } else if (!window.cancelAnimationFrame) {
      browserRequestAnimationFrame = window.requestAnimationFrame;
      window.requestAnimationFrame = function(callback, element) {
        var myId;
        myId = ++lastId;
        browserRequestAnimationFrame(function() {
          if (!isCancelled[myId]) {
            return callback();
          }
        }, element);
        return myId;
      };
      return window.cancelAnimationFrame = function(id) {
        return isCancelled[id] = true;
      };
    }
  })();

  secondsToString = function(sec) {
    var hr, min;
    hr = Math.floor(sec / 3600);
    min = Math.floor((sec - (hr * 3600)) / 60);
    sec -= (hr * 3600) + (min * 60);
    sec += '';
    min += '';
    while (min.length < 2) {
      min = '0' + min;
    }
    while (sec.length < 2) {
      sec = '0' + sec;
    }
    hr = hr ? hr + ':' : '';
    return hr + min + ':' + sec;
  };

  formatNumber = function() {
    var digits, num, value;
    num = 1 <= arguments.length ? slice.call(arguments, 0) : [];
    value = num[0];
    digits = 0 || num[1];
    return addCommas(value.toFixed(digits));
  };

  mergeObjects = function(obj1, obj2) {
    var key, out, val;
    out = {};
    for (key in obj1) {
      if (!hasProp.call(obj1, key)) continue;
      val = obj1[key];
      out[key] = val;
    }
    for (key in obj2) {
      if (!hasProp.call(obj2, key)) continue;
      val = obj2[key];
      out[key] = val;
    }
    return out;
  };

  addCommas = function(nStr) {
    var rgx, x, x1, x2;
    nStr += '';
    x = nStr.split('.');
    x1 = x[0];
    x2 = '';
    if (x.length > 1) {
      x2 = '.' + x[1];
    }
    rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
  };

  cutHex = function(nStr) {
    if (nStr.charAt(0) === "#") {
      return nStr.substring(1, 7);
    }
    return nStr;
  };

  ValueUpdater = (function() {
    ValueUpdater.prototype.animationSpeed = 32;

    function ValueUpdater(addToAnimationQueue, clear) {
      if (addToAnimationQueue == null) {
        addToAnimationQueue = true;
      }
      this.clear = clear != null ? clear : true;
      if (addToAnimationQueue) {
        AnimationUpdater.add(this);
      }
    }

    ValueUpdater.prototype.update = function(force) {
      var diff;
      if (force == null) {
        force = false;
      }
      if (force || this.displayedValue !== this.value) {
        if (this.ctx && this.clear) {
          this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        }
        diff = this.value - this.displayedValue;
        if (Math.abs(diff / this.animationSpeed) <= 0.001) {
          this.displayedValue = this.value;
        } else {
          this.displayedValue = this.displayedValue + diff / this.animationSpeed;
        }
        this.render();
        return true;
      }
      return false;
    };

    return ValueUpdater;

  })();

  BaseGauge = (function(superClass) {
    extend(BaseGauge, superClass);

    function BaseGauge() {
      return BaseGauge.__super__.constructor.apply(this, arguments);
    }

    BaseGauge.prototype.displayScale = 1;

    BaseGauge.prototype.forceUpdate = true;

    BaseGauge.prototype.setTextField = function(textField, fractionDigits) {
      return this.textField = textField instanceof TextRenderer ? textField : new TextRenderer(textField, fractionDigits);
    };

    BaseGauge.prototype.setMinValue = function(minValue, updateStartValue) {
      var gauge, j, len, ref, results;
      this.minValue = minValue;
      if (updateStartValue == null) {
        updateStartValue = true;
      }
      if (updateStartValue) {
        this.displayedValue = this.minValue;
        ref = this.gp || [];
        results = [];
        for (j = 0, len = ref.length; j < len; j++) {
          gauge = ref[j];
          results.push(gauge.displayedValue = this.minValue);
        }
        return results;
      }
    };

    BaseGauge.prototype.setOptions = function(options) {
      if (options == null) {
        options = null;
      }
      this.options = mergeObjects(this.options, options);
      if (this.textField) {
        this.textField.el.style.fontSize = options.fontSize + 'px';
      }
      if (this.options.angle > .5) {
        this.options.angle = .5;
      }
      this.configDisplayScale();
      return this;
    };

    BaseGauge.prototype.configDisplayScale = function() {
      var backingStorePixelRatio, devicePixelRatio, height, prevDisplayScale, width;
      prevDisplayScale = this.displayScale;
      if (this.options.highDpiSupport === false) {
        delete this.displayScale;
      } else {
        devicePixelRatio = window.devicePixelRatio || 1;
        backingStorePixelRatio = this.ctx.webkitBackingStorePixelRatio || this.ctx.mozBackingStorePixelRatio || this.ctx.msBackingStorePixelRatio || this.ctx.oBackingStorePixelRatio || this.ctx.backingStorePixelRatio || 1;
        this.displayScale = devicePixelRatio / backingStorePixelRatio;
      }
      if (this.displayScale !== prevDisplayScale) {
        width = this.canvas.G__width || this.canvas.width;
        height = this.canvas.G__height || this.canvas.height;
        this.canvas.width = width * this.displayScale;
        this.canvas.height = height * this.displayScale;
        this.canvas.style.width = width + "px";
        this.canvas.style.height = height + "px";
        this.canvas.G__width = width;
        this.canvas.G__height = height;
      }
      return this;
    };

    BaseGauge.prototype.parseValue = function(value) {
      value = parseFloat(value) || Number(value);
      if (isFinite(value)) {
        return value;
      } else {
        return 0;
      }
    };

    return BaseGauge;

  })(ValueUpdater);

  TextRenderer = (function() {
    function TextRenderer(el, fractionDigits1) {
      this.el = el;
      this.fractionDigits = fractionDigits1;
    }

    TextRenderer.prototype.render = function(gauge) {
      return this.el.innerHTML = formatNumber(gauge.displayedValue, this.fractionDigits);
    };

    return TextRenderer;

  })();

  AnimatedText = (function(superClass) {
    extend(AnimatedText, superClass);

    AnimatedText.prototype.displayedValue = 0;

    AnimatedText.prototype.value = 0;

    AnimatedText.prototype.setVal = function(value) {
      return this.value = 1 * value;
    };

    function AnimatedText(elem1, text) {
      this.elem = elem1;
      this.text = text != null ? text : false;
      AnimatedText.__super__.constructor.call(this);
      if (this.elem === void 0) {
        throw new Error('The element isn\'t defined.');
      }
      this.value = 1 * this.elem.innerHTML;
      if (this.text) {
        this.value = 0;
      }
    }

    AnimatedText.prototype.render = function() {
      var textVal;
      if (this.text) {
        textVal = secondsToString(this.displayedValue.toFixed(0));
      } else {
        textVal = addCommas(formatNumber(this.displayedValue));
      }
      return this.elem.innerHTML = textVal;
    };

    return AnimatedText;

  })(ValueUpdater);

  AnimatedTextFactory = {
    create: function(objList) {
      var elem, j, len, out;
      out = [];
      for (j = 0, len = objList.length; j < len; j++) {
        elem = objList[j];
        out.push(new AnimatedText(elem));
      }
      return out;
    }
  };

  GaugePointer = (function(superClass) {
    extend(GaugePointer, superClass);

    GaugePointer.prototype.displayedValue = 0;

    GaugePointer.prototype.value = 0;

    GaugePointer.prototype.options = {
      strokeWidth: 0.035,
      length: 0.1,
      color: "#000000",
      iconPath: null,
      iconScale: 1.0,
      iconAngle: 0
    };

    GaugePointer.prototype.img = null;

    function GaugePointer(gauge1) {
      this.gauge = gauge1;
      if (this.gauge === void 0) {
        throw new Error('The element isn\'t defined.');
      }
      this.ctx = this.gauge.ctx;
      this.canvas = this.gauge.canvas;
      GaugePointer.__super__.constructor.call(this, false, false);
      this.setOptions();
    }

    GaugePointer.prototype.setOptions = function(options) {
      if (options == null) {
        options = null;
      }
      this.options = mergeObjects(this.options, options);
      this.length = 2 * this.gauge.radius * this.gauge.options.radiusScale * this.options.length;
      this.strokeWidth = this.canvas.height * this.options.strokeWidth;
      this.maxValue = this.gauge.maxValue;
      this.minValue = this.gauge.minValue;
      this.animationSpeed = this.gauge.animationSpeed;
      this.options.angle = this.gauge.options.angle;
      if (this.options.iconPath) {
        this.img = new Image();
        return this.img.src = this.options.iconPath;
      }
    };

    GaugePointer.prototype.render = function() {
      var angle, endX, endY, imgX, imgY, startX, startY, x, y;
      angle = this.gauge.getAngle.call(this, this.displayedValue);
      x = Math.round(this.length * Math.cos(angle));
      y = Math.round(this.length * Math.sin(angle));
      startX = Math.round(this.strokeWidth * Math.cos(angle - Math.PI / 2));
      startY = Math.round(this.strokeWidth * Math.sin(angle - Math.PI / 2));
      endX = Math.round(this.strokeWidth * Math.cos(angle + Math.PI / 2));
      endY = Math.round(this.strokeWidth * Math.sin(angle + Math.PI / 2));
      this.ctx.beginPath();
      this.ctx.fillStyle = this.options.color;
      this.ctx.arc(0, 0, this.strokeWidth, 0, Math.PI * 2, false);
      this.ctx.fill();
      this.ctx.beginPath();
      this.ctx.moveTo(startX, startY);
      this.ctx.lineTo(x, y);
      this.ctx.lineTo(endX, endY);
      this.ctx.fill();
      if (this.img) {
        imgX = Math.round(this.img.width * this.options.iconScale);
        imgY = Math.round(this.img.height * this.options.iconScale);
        this.ctx.save();
        this.ctx.translate(x, y);
        this.ctx.rotate(angle + Math.PI / 180.0 * (90 + this.options.iconAngle));
        this.ctx.drawImage(this.img, -imgX / 2, -imgY / 2, imgX, imgY);
        return this.ctx.restore();
      }
    };

    return GaugePointer;

  })(ValueUpdater);

  Bar = (function() {
    function Bar(elem1) {
      this.elem = elem1;
    }

    Bar.prototype.updateValues = function(arrValues) {
      this.value = arrValues[0];
      this.maxValue = arrValues[1];
      this.avgValue = arrValues[2];
      return this.render();
    };

    Bar.prototype.render = function() {
      var avgPercent, valPercent;
      if (this.textField) {
        this.textField.text(formatNumber(this.value));
      }
      if (this.maxValue === 0) {
        this.maxValue = this.avgValue * 2;
      }
      valPercent = (this.value / this.maxValue) * 100;
      avgPercent = (this.avgValue / this.maxValue) * 100;
      $(".bar-value", this.elem).css({
        "width": valPercent + "%"
      });
      return $(".typical-value", this.elem).css({
        "width": avgPercent + "%"
      });
    };

    return Bar;

  })();

  Gauge = (function(superClass) {
    extend(Gauge, superClass);

    Gauge.prototype.elem = null;

    Gauge.prototype.value = [20];

    Gauge.prototype.maxValue = 80;

    Gauge.prototype.minValue = 0;

    Gauge.prototype.displayedAngle = 0;

    Gauge.prototype.displayedValue = 0;

    Gauge.prototype.lineWidth = 40;

    Gauge.prototype.paddingTop = 0.1;

    Gauge.prototype.paddingBottom = 0.1;

    Gauge.prototype.percentColors = null;

    Gauge.prototype.options = {
      colorStart: "#6fadcf",
      colorStop: void 0,
      gradientType: 0,
      strokeColor: "#e0e0e0",
      pointer: {
        length: 0.8,
        strokeWidth: 0.035,
        iconScale: 1.0
      },
      angle: 0.15,
      lineWidth: 0.44,
      radiusScale: 1.0,
      fontSize: 40,
      limitMax: false,
      limitMin: false
    };

    function Gauge(canvas) {
      var h, w;
      this.canvas = canvas;
      Gauge.__super__.constructor.call(this);
      this.percentColors = null;
      if (typeof G_vmlCanvasManager !== 'undefined') {
        this.canvas = window.G_vmlCanvasManager.initElement(this.canvas);
      }
      this.ctx = this.canvas.getContext('2d');
      h = this.canvas.clientHeight;
      w = this.canvas.clientWidth;
      this.canvas.height = h;
      this.canvas.width = w;
      this.gp = [new GaugePointer(this)];
      this.setOptions();
    }

    Gauge.prototype.setOptions = function(options) {
      var gauge, j, len, phi, ref;
      if (options == null) {
        options = null;
      }
      Gauge.__super__.setOptions.call(this, options);
      this.configPercentColors();
      this.extraPadding = 0;
      if (this.options.angle < 0) {
        phi = Math.PI * (1 + this.options.angle);
        this.extraPadding = Math.sin(phi);
      }
      this.availableHeight = this.canvas.height * (1 - this.paddingTop - this.paddingBottom);
      this.lineWidth = this.availableHeight * this.options.lineWidth;
      this.radius = (this.availableHeight - this.lineWidth / 2) / (1.0 + this.extraPadding);
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      ref = this.gp;
      for (j = 0, len = ref.length; j < len; j++) {
        gauge = ref[j];
        gauge.setOptions(this.options.pointer);
        gauge.render();
      }
      this.render();
      return this;
    };

    Gauge.prototype.configPercentColors = function() {
      var bval, gval, i, j, ref, results, rval;
      this.percentColors = null;
      if (this.options.percentColors !== void 0) {
        this.percentColors = new Array();
        results = [];
        for (i = j = 0, ref = this.options.percentColors.length - 1; 0 <= ref ? j <= ref : j >= ref; i = 0 <= ref ? ++j : --j) {
          rval = parseInt((cutHex(this.options.percentColors[i][1])).substring(0, 2), 16);
          gval = parseInt((cutHex(this.options.percentColors[i][1])).substring(2, 4), 16);
          bval = parseInt((cutHex(this.options.percentColors[i][1])).substring(4, 6), 16);
          results.push(this.percentColors[i] = {
            pct: this.options.percentColors[i][0],
            color: {
              r: rval,
              g: gval,
              b: bval
            }
          });
        }
        return results;
      }
    };

    Gauge.prototype.set = function(value) {
      var gp, i, j, l, len, m, ref, ref1, val;
      if (!(value instanceof Array)) {
        value = [value];
      }
      for (i = j = 0, ref = value.length - 1; 0 <= ref ? j <= ref : j >= ref; i = 0 <= ref ? ++j : --j) {
        value[i] = this.parseValue(value[i]);
      }
      if (value.length > this.gp.length) {
        for (i = l = 0, ref1 = value.length - this.gp.length; 0 <= ref1 ? l < ref1 : l > ref1; i = 0 <= ref1 ? ++l : --l) {
          gp = new GaugePointer(this);
          gp.setOptions(this.options.pointer);
          this.gp.push(gp);
        }
      } else if (value.length < this.gp.length) {
        this.gp = this.gp.slice(this.gp.length - value.length);
      }
      i = 0;
      for (m = 0, len = value.length; m < len; m++) {
        val = value[m];
        if (val > this.maxValue) {
          if (this.options.limitMax) {
            val = this.maxValue;
          } else {
            this.maxValue = val + 1;
          }
        } else if (val < this.minValue) {
          if (this.options.limitMin) {
            val = this.minValue;
          } else {
            this.minValue = val - 1;
          }
        }
        this.gp[i].value = val;
        this.gp[i++].setOptions({
          minValue: this.minValue,
          maxValue: this.maxValue,
          angle: this.options.angle
        });
      }
      this.value = Math.max(Math.min(value[value.length - 1], this.maxValue), this.minValue);
      AnimationUpdater.add(this);
      AnimationUpdater.run(this.forceUpdate);
      return this.forceUpdate = false;
    };

    Gauge.prototype.getAngle = function(value) {
      return (1 + this.options.angle) * Math.PI + ((value - this.minValue) / (this.maxValue - this.minValue)) * (1 - this.options.angle * 2) * Math.PI;
    };

    Gauge.prototype.getColorForPercentage = function(pct, grad) {
      var color, endColor, i, j, rangePct, ref, startColor;
      if (pct === 0) {
        color = this.percentColors[0].color;
      } else {
        color = this.percentColors[this.percentColors.length - 1].color;
        for (i = j = 0, ref = this.percentColors.length - 1; 0 <= ref ? j <= ref : j >= ref; i = 0 <= ref ? ++j : --j) {
          if (pct <= this.percentColors[i].pct) {
            if (grad === true) {
              startColor = this.percentColors[i - 1] || this.percentColors[0];
              endColor = this.percentColors[i];
              rangePct = (pct - startColor.pct) / (endColor.pct - startColor.pct);
              color = {
                r: Math.floor(startColor.color.r * (1 - rangePct) + endColor.color.r * rangePct),
                g: Math.floor(startColor.color.g * (1 - rangePct) + endColor.color.g * rangePct),
                b: Math.floor(startColor.color.b * (1 - rangePct) + endColor.color.b * rangePct)
              };
            } else {
              color = this.percentColors[i].color;
            }
            break;
          }
        }
      }
      return 'rgb(' + [color.r, color.g, color.b].join(',') + ')';
    };

    Gauge.prototype.getColorForValue = function(val, grad) {
      var pct;
      pct = (val - this.minValue) / (this.maxValue - this.minValue);
      return this.getColorForPercentage(pct, grad);
    };

    Gauge.prototype.renderStaticLabels = function(staticLabels, w, h, radius) {
      var font, fontsize, j, len, match, re, ref, rest, rotationAngle, value;
      this.ctx.save();
      this.ctx.translate(w, h);
      font = staticLabels.font || "10px Times";
      re = /\d+\.?\d?/;
      match = font.match(re)[0];
      rest = font.slice(match.length);
      fontsize = parseFloat(match) * this.displayScale;
      this.ctx.font = fontsize + rest;
      this.ctx.fillStyle = staticLabels.color || "#000000";
      this.ctx.textBaseline = "bottom";
      this.ctx.textAlign = "center";
      ref = staticLabels.labels;
      for (j = 0, len = ref.length; j < len; j++) {
        value = ref[j];
        if (value.label !== void 0) {
          if ((!this.options.limitMin || value >= this.minValue) && (!this.options.limitMax || value <= this.maxValue)) {
            font = value.font || staticLabels.font;
            match = font.match(re)[0];
            rest = font.slice(match.length);
            fontsize = parseFloat(match) * this.displayScale;
            this.ctx.font = fontsize + rest;
            rotationAngle = this.getAngle(value.label) - 3 * Math.PI / 2;
            this.ctx.rotate(rotationAngle);
            this.ctx.fillText(formatNumber(value.label, staticLabels.fractionDigits), 0, -radius - this.lineWidth / 2);
            this.ctx.rotate(-rotationAngle);
          }
        } else {
          if ((!this.options.limitMin || value >= this.minValue) && (!this.options.limitMax || value <= this.maxValue)) {
            rotationAngle = this.getAngle(value) - 3 * Math.PI / 2;
            this.ctx.rotate(rotationAngle);
            this.ctx.fillText(formatNumber(value, staticLabels.fractionDigits), 0, -radius - this.lineWidth / 2);
            this.ctx.rotate(-rotationAngle);
          }
        }
      }
      return this.ctx.restore();
    };

    Gauge.prototype.renderTicks = function(ticksOptions, w, h, radius) {
      var currentDivision, currentSubDivision, divColor, divLength, divWidth, divisionCount, j, lineWidth, range, rangeDivisions, ref, results, scaleMutate, st, subColor, subDivisions, subLength, subWidth, subdivisionCount, t, tmpRadius;
      if (ticksOptions !== {}) {
        divisionCount = ticksOptions.divisions || 0;
        subdivisionCount = ticksOptions.subDivisions || 0;
        divColor = ticksOptions.divColor || '#fff';
        subColor = ticksOptions.subColor || '#fff';
        divLength = ticksOptions.divLength || 0.7;
        subLength = ticksOptions.subLength || 0.2;
        range = parseFloat(this.maxValue) - parseFloat(this.minValue);
        rangeDivisions = parseFloat(range) / parseFloat(ticksOptions.divisions);
        subDivisions = parseFloat(rangeDivisions) / parseFloat(ticksOptions.subDivisions);
        currentDivision = parseFloat(this.minValue);
        currentSubDivision = 0.0 + subDivisions;
        lineWidth = range / 400;
        divWidth = lineWidth * (ticksOptions.divWidth || 1);
        subWidth = lineWidth * (ticksOptions.subWidth || 1);
        results = [];
        for (t = j = 0, ref = divisionCount + 1; j < ref; t = j += 1) {
          this.ctx.lineWidth = this.lineWidth * divLength;
          scaleMutate = (this.lineWidth / 2) * (1 - divLength);
          tmpRadius = (this.radius * this.options.radiusScale) + scaleMutate;
          this.ctx.strokeStyle = divColor;
          this.ctx.beginPath();
          this.ctx.arc(0, 0, tmpRadius, this.getAngle(currentDivision - divWidth), this.getAngle(currentDivision + divWidth), false);
          this.ctx.stroke();
          currentSubDivision = currentDivision + subDivisions;
          currentDivision += rangeDivisions;
          if (t !== ticksOptions.divisions && subdivisionCount > 0) {
            results.push((function() {
              var l, ref1, results1;
              results1 = [];
              for (st = l = 0, ref1 = subdivisionCount - 1; l < ref1; st = l += 1) {
                this.ctx.lineWidth = this.lineWidth * subLength;
                scaleMutate = (this.lineWidth / 2) * (1 - subLength);
                tmpRadius = (this.radius * this.options.radiusScale) + scaleMutate;
                this.ctx.strokeStyle = subColor;
                this.ctx.beginPath();
                this.ctx.arc(0, 0, tmpRadius, this.getAngle(currentSubDivision - subWidth), this.getAngle(currentSubDivision + subWidth), false);
                this.ctx.stroke();
                results1.push(currentSubDivision += subDivisions);
              }
              return results1;
            }).call(this));
          } else {
            results.push(void 0);
          }
        }
        return results;
      }
    };

    Gauge.prototype.render = function() {
      var displayedAngle, fillStyle, gauge, h, j, l, len, len1, max, min, radius, ref, ref1, scaleMutate, tmpRadius, w, zone;
      w = this.canvas.width / 2;
      h = (this.canvas.height * this.paddingTop + this.availableHeight) - ((this.radius + this.lineWidth / 2) * this.extraPadding);
      displayedAngle = this.getAngle(this.displayedValue);
      if (this.textField) {
        this.textField.render(this);
      }
      this.ctx.lineCap = "butt";
      radius = this.radius * this.options.radiusScale;
      if (this.options.staticLabels) {
        this.renderStaticLabels(this.options.staticLabels, w, h, radius);
      }
      if (this.options.staticZones) {
        this.ctx.save();
        this.ctx.translate(w, h);
        this.ctx.lineWidth = this.lineWidth;
        ref = this.options.staticZones;
        for (j = 0, len = ref.length; j < len; j++) {
          zone = ref[j];
          min = zone.min;
          if (this.options.limitMin && min < this.minValue) {
            min = this.minValue;
          }
          max = zone.max;
          if (this.options.limitMax && max > this.maxValue) {
            max = this.maxValue;
          }
          tmpRadius = this.radius * this.options.radiusScale;
          if (zone.height) {
            this.ctx.lineWidth = this.lineWidth * zone.height;
            scaleMutate = (this.lineWidth / 2) * (zone.offset || 1 - zone.height);
            tmpRadius = (this.radius * this.options.radiusScale) + scaleMutate;
          }
          this.ctx.strokeStyle = zone.strokeStyle;
          this.ctx.beginPath();
          this.ctx.arc(0, 0, tmpRadius, this.getAngle(min), this.getAngle(max), false);
          this.ctx.stroke();
        }
      } else {
        if (this.options.customFillStyle !== void 0) {
          fillStyle = this.options.customFillStyle(this);
        } else if (this.percentColors !== null) {
          fillStyle = this.getColorForValue(this.displayedValue, this.options.generateGradient);
        } else if (this.options.colorStop !== void 0) {
          if (this.options.gradientType === 0) {
            fillStyle = this.ctx.createRadialGradient(w, h, 9, w, h, 70);
          } else {
            fillStyle = this.ctx.createLinearGradient(0, 0, w, 0);
          }
          fillStyle.addColorStop(0, this.options.colorStart);
          fillStyle.addColorStop(1, this.options.colorStop);
        } else {
          fillStyle = this.options.colorStart;
        }
        this.ctx.strokeStyle = fillStyle;
        this.ctx.beginPath();
        this.ctx.arc(w, h, radius, (1 + this.options.angle) * Math.PI, displayedAngle, false);
        this.ctx.lineWidth = this.lineWidth;
        this.ctx.stroke();
        this.ctx.strokeStyle = this.options.strokeColor;
        this.ctx.beginPath();
        this.ctx.arc(w, h, radius, displayedAngle, (2 - this.options.angle) * Math.PI, false);
        this.ctx.stroke();
        this.ctx.save();
        this.ctx.translate(w, h);
      }
      if (this.options.renderTicks) {
        this.renderTicks(this.options.renderTicks, w, h, radius);
      }
      this.ctx.restore();
      this.ctx.translate(w, h);
      ref1 = this.gp;
      for (l = 0, len1 = ref1.length; l < len1; l++) {
        gauge = ref1[l];
        gauge.update(true);
      }
      return this.ctx.translate(-w, -h);
    };

    return Gauge;

  })(BaseGauge);

  BaseDonut = (function(superClass) {
    extend(BaseDonut, superClass);

    BaseDonut.prototype.lineWidth = 15;

    BaseDonut.prototype.displayedValue = 0;

    BaseDonut.prototype.value = 33;

    BaseDonut.prototype.maxValue = 80;

    BaseDonut.prototype.minValue = 0;

    BaseDonut.prototype.options = {
      lineWidth: 0.10,
      colorStart: "#6f6ea0",
      colorStop: "#c0c0db",
      strokeColor: "#eeeeee",
      shadowColor: "#d5d5d5",
      angle: 0.35,
      radiusScale: 1.0
    };

    function BaseDonut(canvas) {
      this.canvas = canvas;
      BaseDonut.__super__.constructor.call(this);
      if (typeof G_vmlCanvasManager !== 'undefined') {
        this.canvas = window.G_vmlCanvasManager.initElement(this.canvas);
      }
      this.ctx = this.canvas.getContext('2d');
      this.setOptions();
      this.render();
    }

    BaseDonut.prototype.getAngle = function(value) {
      return (1 - this.options.angle) * Math.PI + ((value - this.minValue) / (this.maxValue - this.minValue)) * ((2 + this.options.angle) - (1 - this.options.angle)) * Math.PI;
    };

    BaseDonut.prototype.setOptions = function(options) {
      if (options == null) {
        options = null;
      }
      BaseDonut.__super__.setOptions.call(this, options);
      this.lineWidth = this.canvas.height * this.options.lineWidth;
      this.radius = this.options.radiusScale * (this.canvas.height / 2 - this.lineWidth / 2);
      return this;
    };

    BaseDonut.prototype.set = function(value) {
      this.value = this.parseValue(value);
      if (this.value > this.maxValue) {
        if (this.options.limitMax) {
          this.value = this.maxValue;
        } else {
          this.maxValue = this.value;
        }
      } else if (this.value < this.minValue) {
        if (this.options.limitMin) {
          this.value = this.minValue;
        } else {
          this.minValue = this.value;
        }
      }
      AnimationUpdater.add(this);
      AnimationUpdater.run(this.forceUpdate);
      return this.forceUpdate = false;
    };

    BaseDonut.prototype.render = function() {
      var displayedAngle, grdFill, h, start, stop, w;
      displayedAngle = this.getAngle(this.displayedValue);
      w = this.canvas.width / 2;
      h = this.canvas.height / 2;
      if (this.textField) {
        this.textField.render(this);
      }
      grdFill = this.ctx.createRadialGradient(w, h, 39, w, h, 70);
      grdFill.addColorStop(0, this.options.colorStart);
      grdFill.addColorStop(1, this.options.colorStop);
      start = this.radius - this.lineWidth / 2;
      stop = this.radius + this.lineWidth / 2;
      this.ctx.strokeStyle = this.options.strokeColor;
      this.ctx.beginPath();
      this.ctx.arc(w, h, this.radius, (1 - this.options.angle) * Math.PI, (2 + this.options.angle) * Math.PI, false);
      this.ctx.lineWidth = this.lineWidth;
      this.ctx.lineCap = "round";
      this.ctx.stroke();
      this.ctx.strokeStyle = grdFill;
      this.ctx.beginPath();
      this.ctx.arc(w, h, this.radius, (1 - this.options.angle) * Math.PI, displayedAngle, false);
      return this.ctx.stroke();
    };

    return BaseDonut;

  })(BaseGauge);

  Donut = (function(superClass) {
    extend(Donut, superClass);

    function Donut() {
      return Donut.__super__.constructor.apply(this, arguments);
    }

    Donut.prototype.strokeGradient = function(w, h, start, stop) {
      var grd;
      grd = this.ctx.createRadialGradient(w, h, start, w, h, stop);
      grd.addColorStop(0, this.options.shadowColor);
      grd.addColorStop(0.12, this.options._orgStrokeColor);
      grd.addColorStop(0.88, this.options._orgStrokeColor);
      grd.addColorStop(1, this.options.shadowColor);
      return grd;
    };

    Donut.prototype.setOptions = function(options) {
      var h, start, stop, w;
      if (options == null) {
        options = null;
      }
      Donut.__super__.setOptions.call(this, options);
      w = this.canvas.width / 2;
      h = this.canvas.height / 2;
      start = this.radius - this.lineWidth / 2;
      stop = this.radius + this.lineWidth / 2;
      this.options._orgStrokeColor = this.options.strokeColor;
      this.options.strokeColor = this.strokeGradient(w, h, start, stop);
      return this;
    };

    return Donut;

  })(BaseDonut);

  window.AnimationUpdater = {
    elements: [],
    animId: null,
    addAll: function(list) {
      var elem, j, len, results;
      results = [];
      for (j = 0, len = list.length; j < len; j++) {
        elem = list[j];
        results.push(AnimationUpdater.elements.push(elem));
      }
      return results;
    },
    add: function(object) {
      if (indexOf.call(AnimationUpdater.elements, object) < 0) {
        return AnimationUpdater.elements.push(object);
      }
    },
    run: function(force) {
      var elem, finished, isCallback, j, k, l, len, ref, toRemove;
      if (force == null) {
        force = false;
      }
      isCallback = isFinite(parseFloat(force));
      if (isCallback || force === true) {
        finished = true;
        toRemove = [];
        ref = AnimationUpdater.elements;
        for (k = j = 0, len = ref.length; j < len; k = ++j) {
          elem = ref[k];
          if (elem.update(force === true)) {
            finished = false;
          } else {
            toRemove.push(k);
          }
        }
        for (l = toRemove.length - 1; l >= 0; l += -1) {
          k = toRemove[l];
          AnimationUpdater.elements.splice(k, 1);
        }
        return AnimationUpdater.animId = finished ? null : requestAnimationFrame(AnimationUpdater.run);
      } else if (force === false) {
        if (AnimationUpdater.animId === !null) {
          cancelAnimationFrame(AnimationUpdater.animId);
        }
        return AnimationUpdater.animId = requestAnimationFrame(AnimationUpdater.run);
      }
    }
  };

  if (typeof window.define === 'function' && (window.define.amd != null)) {
    define(function() {
      return {
        Gauge: Gauge,
        Donut: Donut,
        BaseDonut: BaseDonut,
        TextRenderer: TextRenderer
      };
    });
  } else if (typeof module !== 'undefined' && (module.exports != null)) {
    module.exports = {
      Gauge: Gauge,
      Donut: Donut,
      BaseDonut: BaseDonut,
      TextRenderer: TextRenderer
    };
  } else {
    window.Gauge = Gauge;
    window.Donut = Donut;
    window.BaseDonut = BaseDonut;
    window.TextRenderer = TextRenderer;
  }

}).call(this);



},{}],180:[function(require,module,exports){
var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;

},{"./_root":186}],181:[function(require,module,exports){
var Symbol = require('./_Symbol'),
    getRawTag = require('./_getRawTag'),
    objectToString = require('./_objectToString');

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;

},{"./_Symbol":180,"./_getRawTag":184,"./_objectToString":185}],182:[function(require,module,exports){
var trimmedEndIndex = require('./_trimmedEndIndex');

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;

},{"./_trimmedEndIndex":187}],183:[function(require,module,exports){
(function (global){(function (){
/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],184:[function(require,module,exports){
var Symbol = require('./_Symbol');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;

},{"./_Symbol":180}],185:[function(require,module,exports){
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;

},{}],186:[function(require,module,exports){
var freeGlobal = require('./_freeGlobal');

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;

},{"./_freeGlobal":183}],187:[function(require,module,exports){
/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;

},{}],188:[function(require,module,exports){
var isObject = require('./isObject'),
    now = require('./now'),
    toNumber = require('./toNumber');

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;

},{"./isObject":189,"./now":193,"./toNumber":195}],189:[function(require,module,exports){
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;

},{}],190:[function(require,module,exports){
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;

},{}],191:[function(require,module,exports){
var baseGetTag = require('./_baseGetTag'),
    isObjectLike = require('./isObjectLike');

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;

},{"./_baseGetTag":181,"./isObjectLike":190}],192:[function(require,module,exports){
(function (global){(function (){
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    define(function() {
      return _;
    });
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],193:[function(require,module,exports){
var root = require('./_root');

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;

},{"./_root":186}],194:[function(require,module,exports){
var debounce = require('./debounce'),
    isObject = require('./isObject');

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;

},{"./debounce":188,"./isObject":189}],195:[function(require,module,exports){
var baseTrim = require('./_baseTrim'),
    isObject = require('./isObject'),
    isSymbol = require('./isSymbol');

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;

},{"./_baseTrim":182,"./isObject":189,"./isSymbol":191}],196:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}]},{},[17]);
;
(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var axiosInstance = _axios.default.create({});
axiosInstance.interceptors.request.use(function (config) {
  config.baseURL = "".concat(window.location.origin).concat(window.ctx, "/api/v1/");
  return Promise.resolve(config);
}, function (error) {
  return Promise.reject(error);
});
var _default = exports.default = axiosInstance;

},{"axios":79}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _StreamingAccessibility = _interopRequireDefault(require("accessibility/StreamingAccessibility"));
var _ContextMenuAccessibility = _interopRequireDefault(require("accessibility/ContextMenuAccessibility"));
var _AccordionAccessibility = _interopRequireDefault(require("accessibility/AccordionAccessibility"));
var _TooltipAccessibility = _interopRequireDefault(require("accessibility/TooltipAccessibility"));
var _PopupSearchAccessibility = _interopRequireDefault(require("accessibility/PopupSearchAccessibility"));
var _HighchartsAccessibility = _interopRequireDefault(require("accessibility/HighchartsAccessibility"));
var _NewsPlayerAccessibility = _interopRequireDefault(require("accessibility/NewsPlayerAccessibility"));
var _LoginAccessibility = _interopRequireDefault(require("accessibility/LoginAccessibility"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * @class       : Accessibility
                                                                                                                                                                                                                                                                                                                                                                                               * @description : To enable the web content accessibility(WCAG) in the ngp components
                                                                                                                                                                                                                                                                                                                                                                                               *                  - Streaming modules
                                                                                                                                                                                                                                                                                                                                                                                               *                  - Context menu open button
                                                                                                                                                                                                                                                                                                                                                                                               *                  - Context menu
                                                                                                                                                                                                                                                                                                                                                                                               *                  - Accordion controls
                                                                                                                                                                                                                                                                                                                                                                                               *                  - Tooltip component
                                                                                                                                                                                                                                                                                                                                                                                               *                  - Popup search
                                                                                                                                                                                                                                                                                                                                                                                               *                  - Highcharts/Highstocks
                                                                                                                                                                                                                                                                                                                                                                                               *                  - NEWS Player - top news module
                                                                                                                                                                                                                                                                                                                                                                                               * @dependencies: Jquery, StreamingAccessibility, ContextMenuAccessibility, AccordionAccessibility,
                                                                                                                                                                                                                                                                                                                                                                                               *                TooltipAccessibility, PopupSearchAccessibility, NewsPlayerAccessibility
                                                                                                                                                                                                                                                                                                                                                                                               * @references  : https://www.w3.org/TR/WCAG20-TECHS/
                                                                                                                                                                                                                                                                                                                                                                                               */
var Accessibility = /*#__PURE__*/function () {
  function Accessibility() {
    _classCallCheck(this, Accessibility);
  }
  _createClass(Accessibility, null, [{
    key: "init",
    value:
    /**
     * @method init
     * @description Initialize the accessibility module
     * @public
     * @static
     */
    function init(params) {
      Accessibility._start(params);
    }

    /**
     * @method init
     * @description Update an element title based on the inner text
     * @public
     * @static
     */
  }, {
    key: "compareAndUpdateElementTitle",
    value: function compareAndUpdateElementTitle($elements, compareText, updatedTitle) {
      // #. Identify the delete button based on the inner text value
      $elements.filter(function (index) {
        var $element = $($elements[index]);
        var innerText = $element.text();
        if (String(innerText).trim().replace(/[^a-zA-Z ]/g, '') === String(compareText).trim().replace(/[^a-zA-Z ]/g, '')) {
          $element.attr({
            'aria-label': updatedTitle
          });
        }
      });
    }
  }, {
    key: "_start",
    value:
    /**
     * @method _start
     * @description assign accessibility to accessibility services
     * @param { Object } v expect config information or null
     * @private
     * @static
     */
    function _start(config) {
      if (config) {
        // #. Init the streaming accessibility
        if (config.streamingAccessibility) {
          var streamingAccessibility = new _StreamingAccessibility.default();
          streamingAccessibility.init(config.streamingAccessibility.nodes);
        }

        // #. Init context menu accessibility
        if (config.menu && config.menu.enabled) {
          var contextMenuAccessibility = new _ContextMenuAccessibility.default();
          window.setTimeout(function () {
            contextMenuAccessibility.init();
          }, config.menu.initDelay || 0);
        }

        // #. Init accordion accessibility
        if (config.accordion) {
          var accordionAccessibility = new _AccordionAccessibility.default(config.accordion);
          accordionAccessibility.init();
        }

        // #. Init accordion accessibility
        if (config.tooltip) {
          var tooltipAccessibility = new _TooltipAccessibility.default(config.tooltip);
          tooltipAccessibility.init();
        }

        // #. Init popup search accessibility accessibility
        if (config.popupSearch) {
          var popupSearchAccessibility = new _PopupSearchAccessibility.default(config.popupSearch);
          popupSearchAccessibility.init();
        }

        // #. Init highcharts accessibility module
        if (config.highCharts && config.highCharts.enabled) {
          var highchartsAccessibility = new _HighchartsAccessibility.default(config.highCharts);
          highchartsAccessibility.init();
        }

        // #. Init highcharts accessibility module
        if (config.newsPlayer) {
          var newsPlayerAccessibility = new _NewsPlayerAccessibility.default(config.newsPlayer);
          newsPlayerAccessibility.init();
        }

        // #. Init login page accessibility
        if (config.login) {
          var loginAccessibility = new _LoginAccessibility.default();
          loginAccessibility.init();
        }
      }
    }
  }]);
  return Accessibility;
}(); // #. Set the global access
window.fcom.Accessibility = Accessibility;
var _default = exports.default = Accessibility;

},{"accessibility/AccordionAccessibility":3,"accessibility/ContextMenuAccessibility":4,"accessibility/HighchartsAccessibility":5,"accessibility/LoginAccessibility":6,"accessibility/NewsPlayerAccessibility":7,"accessibility/PopupSearchAccessibility":8,"accessibility/StreamingAccessibility":9,"accessibility/TooltipAccessibility":10}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _guid = _interopRequireDefault(require("util/guid"));
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * @class       : AccordionAccessibility
                                                                                                                                                                                                                                                                                                                                                                                               * @description : To enable the web content accessibility(WCAG) in ngp application accordion(expander/collapse) component
                                                                                                                                                                                                                                                                                                                                                                                               *                - NGPII-15088 JAWS: Expander
                                                                                                                                                                                                                                                                                                                                                                                               * @dependencies: Jquery, GUID
                                                                                                                                                                                                                                                                                                                                                                                               * @references  : https://www.w3.org/TR/wai-aria-practices-1.1/examples/accordion/accordion.html
                                                                                                                                                                                                                                                                                                                                                                                               */
var AccordionAccessibility = /*#__PURE__*/function () {
  function AccordionAccessibility(options) {
    _classCallCheck(this, AccordionAccessibility);
    if (!options) {
      return true;
    }

    // #. Keep the config/options into context
    this.options = options;
    // #. Keep the accordion container
    this.$container = _typeof(options.container) === 'object' ? options.container : $(options.container);
    // #. Keep all accordion toggles
    this.$toggles = null;
    // #. Selector to identify the expanded toggle bar - default 'open' is a css class name
    this.expandSelector = options.expandSelector || 'open';
    /**
     * Keep the panel find selector method(ex: next, Jquery selector)
     * next - consider as method ex: findPanelBy: { method: 'next' }
     * multiple methods will be formatted by space { method: 'parent next' }
     * id - consider as attribute ex: findPanelBy: { attr: 'id' }
     */
    this.findPanelBy = options.findPanelBy || {
      method: 'next'
    };
  }

  /**
   * @method init
   * @description Initialize the accordion accessibility
   * @public
   */
  _createClass(AccordionAccessibility, [{
    key: "init",
    value: function init() {
      // #. Find all accordion toggles
      this.$toggles = this.$container.find(this.options.toggleSelector);
      // #. Set default WCAG attributes
      this._setWCAGAttributes();
      // #. Bind the tracking events to toggle bar
      this._bindEvents(this.$toggles);
    }

    /**
     * @method _setWCAGAttributes
     * @description set WCAG attributes to accordion
     * @private
     */
  }, {
    key: "_setWCAGAttributes",
    value: function _setWCAGAttributes() {
      // todo manage the disabled accordions - check the scope
      // todo manage the multiple open accordions - check the scope
      var _iterator = _createForOfIteratorHelper(this.$toggles),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var $toggle = _step.value;
          $toggle = $($toggle);
          var $panel = this._getPanelByToggle($toggle);

          // #. No panel - then continue
          if (!$panel || $panel.length === 0) {
            return true;
          }

          // #. Set toggle bat attr
          var toggleAttr = {
            'aria-expanded': this._isToggleExpanded($toggle)
          };

          // #. lost toggle not require control attr ex: EditView left panel list
          if (this.options.toggleControlAttr !== false) {
            toggleAttr['aria-controls'] = this._getElementId($panel);
          }

          // #. Update toggle attr
          this._setAttributes($toggle, toggleAttr);

          // #. Set panel display attr
          var panelAttr = {
            'aria-labelledby': this._getElementId($toggle)
          };

          // #. options not require role update ex: EditView left panel list
          if (this.options.panelRoleUpdate !== false) {
            panelAttr.role = 'region';
          }

          // #. Update panel attr
          this._setAttributes($panel, panelAttr);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    /**
     * @method _bindEvents
     * @description bind events to update the attributes
     * @param { HTMLElement } $element expect a element or collection of elements object
     * @private
     */
  }, {
    key: "_bindEvents",
    value: function _bindEvents($element) {
      var _this = this;
      $element.on('keydown click', function (event) {
        var $target = $(event.target);
        var keyCode = event.keyCode;
        if (!keyCode || keyCode === _keyCodes.default.ENTER || keyCode === _keyCodes.default.SPACE) {
          // #. Update expanded attribute
          _this._isToggleExpanded($target, function (value) {
            $target.attr('aria-expanded', value);
          });
        }
      });
    }

    /**
     * @method _isToggleExpanded
     * @description check the expand status of a toggle
     * @param { HTMLElement } $element expect a element or collection of elements object
     * @private
     */
  }, {
    key: "_isToggleExpanded",
    value: function _isToggleExpanded($toggle, callback) {
      var $element = $toggle;
      var selector = this.expandSelector;
      var delay = 0;
      if (_typeof(this.expandSelector) === 'object') {
        if (this.expandSelector.parent) {
          $element = $toggle.parent();
          selector = this.expandSelector.parent;
          delay = this.expandSelector.delay || 0;
        }
      }
      if (callback) {
        window.setTimeout(function () {
          callback($element.hasClass(selector));
        }, delay);
      } else {
        return $element.hasClass(selector);
      }
    }

    /**
     * @method _getElementId
     * @description get id attribute of a element, set new one when no id found
     * @param { HTMLElement } $element expect panel display element object
     * @private
     */
  }, {
    key: "_getElementId",
    value: function _getElementId($element) {
      var elementId = $element.attr('id');
      if (!elementId) {
        elementId = _guid.default.generate();
        $element.attr('id', elementId);
      }
      return elementId;
    }

    /**
     * @method _setAttributes
     * @description set attr object to specific element
     * @param { HTMLElement } $element expect element object
     * @param { Object } attr expect object of attributes
     * @private
     */
  }, {
    key: "_setAttributes",
    value: function _setAttributes($element, attr) {
      $element.attr(attr);
    }

    /**
     * @method _getPanelByToggle
     * @description get corresponding panel by toggle bar
     * @param { HTMLElement } $toggle expect toggle bar element object
     * @private
     */
  }, {
    key: "_getPanelByToggle",
    value: function _getPanelByToggle($toggle) {
      /** Find panel element by series of methods or method
        * multiple methods split by space ex: 'parent next' - means next element of the toggle parent
        * method parameter can passed inside the parenthesis ex: 'parent nextAll(.class1#id)'
        */
      if (this.findPanelBy.method) {
        var $element = null;
        var methods = this.findPanelBy.method.split(' ');
        var _iterator2 = _createForOfIteratorHelper(methods),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var method = _step2.value;
            // #. Check any selectors passed as params
            var selector = '';
            if (method.indexOf('(') !== -1) {
              var params = method.split('(');
              method = params[0];
              selector = String(params[1]).replace(')', '');
            }
            $element = $element ? $($element)[method](selector) : $toggle[method](selector);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        return $element;
      }

      // #. Find panel elements by toggle attribute value
      // #. findClosestOfToggle - will get the attribute value from the closest element of the toggle
      if (this.findPanelBy.attr) {
        var _$element = this.findPanelBy.findClosestOfToggle ? $toggle.closest("[".concat(this.findPanelBy.attr, "]")) : $toggle;
        var attrVal = _$element.attr(this.findPanelBy.attr);
        var _selector = "[".concat(this.findPanelBy.attr, "=\"").concat(attrVal, "\"]");
        return this.$container.find(_selector).not(this.findPanelBy.notInclude || '');
      }
    }
  }]);
  return AccordionAccessibility;
}(); // #. Export the accordion accessibility
var _default = exports.default = AccordionAccessibility;

},{"util/enums/keyCodes":76,"util/guid":78}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * @class       : ContextMenuAccessibility
                                                                                                                                                                                                                                                                                                                                                                                               * @description : To enable the web content accessibility(WCAG) in ngp application context menu component
                                                                                                                                                                                                                                                                                                                                                                                               *                - NGPII-15538 JAWS: Context Menu
                                                                                                                                                                                                                                                                                                                                                                                               *                - Context menu item accessibility handled in ExtendedMenu.es6.js
                                                                                                                                                                                                                                                                                                                                                                                               * @dependencies: Jquery, KEYCODES
                                                                                                                                                                                                                                                                                                                                                                                               * @references  : https://www.w3.org/TR/WCAG20-TECHS/
                                                                                                                                                                                                                                                                                                                                                                                               *                https://www.w3.org/TR/wai-aria-practices/examples/menu-button/menu-button-links.html
                                                                                                                                                                                                                                                                                                                                                                                               */
var ContextMenuAccessibility = /*#__PURE__*/function () {
  function ContextMenuAccessibility() {
    _classCallCheck(this, ContextMenuAccessibility);
    // #. To keep the menu opening button collection
    this.$menuOpenButtons = [];
    // #. CSS class selector of module library menu open button
    this.moduleLibraryButtonSelector = '.icon.showModuleLibrary';
    // #. CSS selector of module content header menu button
    this.moduleHeaderButton = 'table.headerContent .controls .control .icon.options';
    // #. CSS selector of context menu open button
    this.menuOpener = 'button.icon.options';
    // #. Const to declare the button context type
    this.contextType = {
      MODULE_LIBRARY: 1,
      MODULE_CONTROL: 2,
      TABLE_ROW_EDIT: 3
    };
  }

  /**
   * @method init
   * @description Initialize the menu accessibility
   * @public
   */
  _createClass(ContextMenuAccessibility, [{
    key: "init",
    value: function init() {
      // #. Get menu opening button elements
      this.$menuOpenButtons = this._findMenuOpenButtons();
      this._start();
    }

    /**
     * @method _start
     * @description start the basic methods, assign attributes, bind key handler
     * @private
     */
  }, {
    key: "_start",
    value: function _start() {
      // #. Handle the focus, keydown event
      this._bindTrackingEvents();

      // #. Check the count of the streaming nodes
      if (this.$menuOpenButtons.length > 0) {
        this._setWCAGAttributesToButton(this.$menuOpenButtons);
      }
    }

    /**
     * @method _findMenuOpenButtons
     * @description find all menu opening buttons from the body element
     * @return { Array } of menu open button elements
     * @private
     */
  }, {
    key: "_findMenuOpenButtons",
    value: function _findMenuOpenButtons() {
      var $body = $('body');
      return $([].concat(_toConsumableArray($body.find(this.menuOpener)), _toConsumableArray($body.find(this.moduleLibraryButtonSelector))));
    }

    /**
     * @method _setWCAGAttributesToButton
     * @description find all menu opening buttons from the body element
     * @param { HTMLCollectionOf } $buttons expecting collection menu open button elements
     * @private
     */
  }, {
    key: "_setWCAGAttributesToButton",
    value: function _setWCAGAttributesToButton($buttons) {
      $buttons.attr({
        'aria-haspopup': 'menu',
        'aria-expanded': false
      });

      // #. Set unique properties
      this._setButtonUniqueProps($buttons);
    }

    /**
     * @method _setButtonUniqueProps
     * @description set unique button properties
     * @param { HTMLCollectionOf } $buttons expecting collection menu open button elements
     * @private
     */
  }, {
    key: "_setButtonUniqueProps",
    value: function _setButtonUniqueProps($buttons) {
      var _iterator = _createForOfIteratorHelper($buttons),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var $button = _step.value;
          $button = $($button);
          var contextType = this._getContextType($button);

          // #. Update the button title
          this._updateButtonTitle($button, contextType, false);

          // #. Set role application for the module head control div element
          // #. otherwise, keydown will not work properly when JAWS is working
          if (contextType === this.contextType.MODULE_CONTROL) {
            $button.closest('.control').attr({
              role: 'application'
            });
          } else {
            // #. Remove the innerText of the image button, because button already has the title
            var bgImg = String($button.css('background-image')).trim();
            if (bgImg && bgImg !== 'none' && !$button.hasClass('include-text')) {
              $button.text('');
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    /**
     * @method _updateButtonTitle
     * @description update button title based on the context
     *              - Button from the table row
     *              - Button from the module header
     *              - Module library button
     * @param { HTMLElement } $button expecting menu open button object
     * @param { Number } button context type
     * @private
     */
  }, {
    key: "_updateButtonTitle",
    value: function _updateButtonTitle($button, contextType, isOnFocus) {
      var label = this._getTitleByButtonContext($button, contextType, isOnFocus);
      if (label) {
        $button.attr({
          'aria-label': label
        });
      }
    }

    /**
     * @method _getContextType
     * @description get type of button context
     * @param { HTMLElement } $button expecting current button element
     * @private
     */
  }, {
    key: "_getContextType",
    value: function _getContextType($button) {
      if ($button.parent().is('td')) {
        return this.contextType.TABLE_ROW_EDIT;
      } else if ($button.is(this.moduleHeaderButton)) {
        return this.contextType.MODULE_CONTROL;
      } else if ($button.is(this.moduleLibraryButtonSelector)) {
        return this.contextType.MODULE_LIBRARY;
      }
    }

    /**
     * @method _setTitleByButtonContext
     * @description get title/name based on the button context
     * @param { HTMLElement } $button expecting current button element
     * @param { Number } button context type
     * @private
     */
  }, {
    key: "_getTitleByButtonContext",
    value: function _getTitleByButtonContext($button, contextType, isOnFocus) {
      // 1. Get name/title of the table row menu button
      if (contextType === this.contextType.TABLE_ROW_EDIT) {
        var name = this._getInstrumentNameByRow($button) || '';
        return window.getMessage('context.menu.open.name.postfix.tooltip', name);
      }

      // 2. Get name/title of module header menu button
      if (contextType === this.contextType.MODULE_CONTROL) {
        var _name = this._getTitleFromModuleHeader($button) || '';
        // #. Header title text may be 'loading...' when module not loaded yet
        // #. Updated title will be set on the focus event
        if (!isOnFocus) {
          return false;
        }
        return window.getMessage('context.menu.module.open.name.postfix.tooltip', _name);
      }

      // 3. Get module library button
      if (contextType === this.contextType.MODULE_LIBRARY) {
        return $button.attr('title');
      }
    }

    /**
     * @method _getInstrumentNameByRow
     * @description get instrument name from table row
     * @param { HTMLElement } $button expecting current button element
     * @private
     */
  }, {
    key: "_getInstrumentNameByRow",
    value: function _getInstrumentNameByRow($button) {
      var $row = $($button.closest('tr'));
      return $row.find('a.instrumentIdentification').text() || $row.find('span.instrumentIdentification').text() || $row.find('input.searchPopupInput').val() || $row.find('a').first().text();
    }

    /**
     * @method _getTitleFromModuleHeader
     * @description get title from the module header element
     * @param { HTMLElement } $button expecting current button element
     * @private
     */
  }, {
    key: "_getTitleFromModuleHeader",
    value: function _getTitleFromModuleHeader($button) {
      var $row = $($button.closest('tr'));
      return $row.find('h2.title').text() || $row.find('span.content').text();
    }

    /**
     * @method _bindTrackingEvents
     * @description update attributes of lately rendered element(Ex: Modules added from the module library, menu button render after large table sorting...etc)
     * @private
     */
  }, {
    key: "_bindTrackingEvents",
    value: function _bindTrackingEvents() {
      var self = this;
      $(window.document).on('focus', this.menuOpener, function (event) {
        var $button = $(this);
        $button.attr('aria-expanded', false);
        if (!$button.attr('aria-label')) {
          var contextType = self._getContextType($button);
          self._updateButtonTitle($button, contextType, true);
        }
      }).on('keydown', this.menuOpener, function (event) {
        var $button = $(this);
        var keyCode = event.keyCode;
        if (keyCode === _keyCodes.default.ENTER) {
          $button.attr('aria-expanded', true);
        }
      });
    }
  }]);
  return ContextMenuAccessibility;
}();
var _default = exports.default = ContextMenuAccessibility;

},{"util/enums/keyCodes":76}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _messageHandler = require("fcom/messages/messageHandler");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * @class       : HighchartsAccessibility
 * @description : To enable the web content accessibility(WCAG) in ngp application highcharts/highstocks
 *                - https://jira.financial.com/browse/NGPII-15551
 * @dependencies: Highcharts, Highstocks, highchart-exporting, highchart-exporting-data, highcharts-accessibility
 * @references  : https://www.highcharts.com/docs/accessibility/accessibility-module
 *              : https://www.highcharts.com/docs/extending-highcharts/extending-highcharts
 *              : https://www.highcharts.com/docs/getting-started/how-to-set-options
 */
var HighchartsAccessibility = /*#__PURE__*/function () {
  function HighchartsAccessibility(options) {
    _classCallCheck(this, HighchartsAccessibility);
    // #. Keep the config/options into context
    this.options = options;
    // #. Get the highcharts object
    this.H = window.Highcharts;
    // #. Set accessibility options
    this.accessibilityOptions = {
      accessibility: {
        enabled: true,
        keyboardNavigation: {
          enabled: true,
          seriesNavigation: {
            mode: 'normal',
            skipNullPoints: true
          }
        },
        announceNewData: {
          enabled: true,
          interruptUser: true
        }
      }
    };
  }

  /**
   * @method init
   * @description Initialize the highcharts accessibility
   * @public
   */
  _createClass(HighchartsAccessibility, [{
    key: "init",
    value: function init() {
      var self = this;
      /**
       * Enable the chart accessibility globally
       */
      window.Highcharts.setOptions(this.accessibilityOptions);

      /**
       * NOTE:
       * Highcharts created a utility called wrap, which wraps an existing prototype function ("method") and -
       * allows you to add your own code before or after it.
       */

      /**
       * Extend the chart render method
       * To assign the proper role attribute to container element - for screen reader
       */
      this.H.wrap(this.H.Chart.prototype, 'onload', function (proceed) {
        proceed.call(this, arguments);
        self._setWCAGtoChart(this.renderTo);
        self._handleFirefoxTabKeyOrder(this.container);
        self._handleEdgeAccessToChart(this.container);
      });

      /**
       * Extend the tooltip refresh method
       * To assign the tooltip to proper role attributes - for screen reader
       */
      this.H.wrap(this.H.Tooltip.prototype, 'refresh', function (proceed, point, e) {
        proceed.call(this, point, e);
        self._setWCAGtoChartTooltip(this.chart.tooltip.container || this.chart.renderTo);
      });

      /**
       * Extend the tooltip hide method
       * To assign the tooltip table hidden - for screen reader
       */
      this.H.wrap(this.H.Tooltip.prototype, 'hide', function (proceed, point, e) {
        proceed.call(this, point, e);
        self._setWCAGtoHiddenTooltipTable(this.chart.renderTo);
      });

      /**
       * Extend the tooltip show method
       * To assign the tooltip table shown - for screen reader
       */
      this.H.wrap(this.H.Tooltip.prototype, 'show', function (proceed, point, e) {
        proceed.call(this, point, e);
        self._setWCAGtoShownTooltipTable(this.chart.renderTo);
      });
    }
  }, {
    key: "_setWCAGtoHiddenTooltipTable",
    value: function _setWCAGtoHiddenTooltipTable(chartContainer) {
      $(chartContainer).find('div.highcharts-tooltip table').attr('aria-hidden', true);
    }
  }, {
    key: "_setWCAGtoShownTooltipTable",
    value: function _setWCAGtoShownTooltipTable(chartContainer) {
      $(chartContainer).find('div.highcharts-tooltip table').attr('aria-hidden', false);
    }

    /**
     * @method _setWCAGtoChart
     * @description update WCAG attributes to highcharts
     * @param { $chartContainer } expecting chart container html element object
     * @private
     */
  }, {
    key: "_setWCAGtoChart",
    value: function _setWCAGtoChart($chartContainer) {
      $($chartContainer).attr({
        role: 'application'
      });
      if ($('#additionalChartTitleId').length > 0) {
        $($chartContainer).find('.highcharts-container').attr('aria-describedby', 'additionalChartTitleId');
      }
      $($chartContainer).find('[id*="highcharts-data-table"]').attr('aria-hidden', true);
    }

    /**
     * @method _setWCAGtoChartTooltip
     * @description update WCAG attributes to highcharts tooltip
     * @param { $chartContainer } expecting chart container html element object
     * @private
     */
  }, {
    key: "_setWCAGtoChartTooltip",
    value: function _setWCAGtoChartTooltip($chartContainer) {
      var $tooltip = $($chartContainer).find('div.highcharts-tooltip > span');
      if ($tooltip.length > 0) {
        $tooltip.attr('role', 'tooltip');
        $tooltip.attr('aria-live', 'assertive');
        var $tooltipTable = $tooltip.find('table');
        if ($($tooltipTable).find('caption').length === 0) {
          $tooltipTable.prepend($('<caption />').text((0, _messageHandler.getMessage)('chart.tooltip.table.caption')).addClass('visuallyhidden'));
        }
      }
    }

    /**
     * @method _handleFirefoxTabKeyOrder
     * @description set tab key order for the module chart
     * @param { $chartContainer } expecting chart container html element object
     * @private
     */
  }, {
    key: "_handleFirefoxTabKeyOrder",
    value: function _handleFirefoxTabKeyOrder($chartContainer) {
      var isFirefox = navigator.userAgent.search('Firefox');
      var $moduleLink = $($chartContainer).closest('.chartImageBox').children().first();
      if (isFirefox > -1 && $moduleLink.is('a')) {
        $moduleLink.attr('tabindex', -1);
      }
    }

    /**
     * @method _handleEdgeAccessToCahrt
     * @description set descriptive label
     * @param { $chartContainer } expecting chart container html element object
     * @private
     */
  }, {
    key: "_handleEdgeAccessToChart",
    value: function _handleEdgeAccessToChart($chartContainer) {
      var isEdge = navigator.userAgent.search('Edg');
      if (isEdge > -1) {
        var chartContainerId = $($chartContainer).attr('id');
        var describedLabelEle = $('<span>').attr('id', "".concat(chartContainerId, "_describedId")).addClass('visuallyhidden').text((0, _messageHandler.getMessage)('chart.descriptive.text.edg'));
        $($chartContainer).find('svg.highcharts-root').attr('aria-describedby', "".concat(chartContainerId, "_describedId")).before(describedLabelEle);
      }
    }
  }]);
  return HighchartsAccessibility;
}();
var _default = exports.default = HighchartsAccessibility;

},{"fcom/messages/messageHandler":61}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * @class       : LoginAccessibility
 * @description : To enable the web content accessibility(WCAG) in login page
 * @references  : https://developer.mozilla.org/en-US/docs/Web/API/Window/devicePixelRatio#monitoring_screen_resolution_or_zoom_level_changes
 */
var LoginAccessibility = /*#__PURE__*/function () {
  function LoginAccessibility() {
    _classCallCheck(this, LoginAccessibility);
    this.loginElement = $('div.login').get(0);
  }

  /**
   * @method init
   * @description Initialize login accessibility
   * @public
   */
  _createClass(LoginAccessibility, [{
    key: "init",
    value: function init() {
      this._initAccessibility();
    }

    /**
     * @method _initAccessibility
     * @description calling methods for wcag
     * @private
     */
  }, {
    key: "_initAccessibility",
    value: function _initAccessibility() {
      this._onPageZoomEvent();
    }

    /**
     * @method _onPageZoomEvent
     * @description when page zoom change, call method to set the scrollbarState
     * @private
     */
  }, {
    key: "_onPageZoomEvent",
    value: function _onPageZoomEvent() {
      var _this = this;
      var updatePixelRatio = function updatePixelRatio() {
        var pr = window.devicePixelRatio;
        var prString = (pr * 100).toFixed(0);
        _this._setScrollBarState();
        matchMedia("(resolution: ".concat(pr, "dppx)")).addEventListener("change", updatePixelRatio, {
          once: true
        });
      };
      updatePixelRatio();
    }

    /**
     * @method hasVerticalScrollBar
     * @returns {boolean}
     * @private
     */
  }, {
    key: "_hasVerticalScrollBar",
    value: function _hasVerticalScrollBar() {
      return this.loginElement.scrollHeight > this.loginElement.clientHeight;
    }

    /**
     * @method _checkLoginContainerScrolling
     * @description add css class hasScrollBar to scrolling login element
     * @private
     */
  }, {
    key: "_setScrollBarState",
    value: function _setScrollBarState() {
      if (this._hasVerticalScrollBar() === true) {
        $(this.loginElement).addClass('hasScrollBar');
      } else {
        $(this.loginElement).removeClass('hasScrollBar');
      }
    }
  }]);
  return LoginAccessibility;
}();
var _default = exports.default = LoginAccessibility;

},{}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * @class       : TopNewsAccessibility
                                                                                                                                                                                                                                                                                                                                                                                               * @description : To enable the web content accessibility(WCAG) in top news module component
                                                                                                                                                                                                                                                                                                                                                                                               *                - GPNGPII-16881 - Keyboard access not enabled for TOP NEWS Module
                                                                                                                                                                                                                                                                                                                                                                                               * @dependencies: Jquery, KEYCODES
                                                                                                                                                                                                                                                                                                                                                                                               * @references  : https://www.w3.org/WAI/tutorials/carousels/
                                                                                                                                                                                                                                                                                                                                                                                               */
var NewsPlayerAccessibility = /*#__PURE__*/function () {
  function NewsPlayerAccessibility(options) {
    _classCallCheck(this, NewsPlayerAccessibility);
    if (!options) {
      return true;
    }

    // #. Keep the config/options into context
    this.options = options;
    this.player = this.options.player;
  }

  // #. Get headline elements
  _createClass(NewsPlayerAccessibility, [{
    key: "$headlines",
    get: function get() {
      return $(this.player.container).find('.headline div');
    }

    // #. Get news module panel element
  }, {
    key: "$newsPlayerModulePanel",
    get: function get() {
      return $('#NewsPlayerModulePanel');
    }

    /**
     * @method init
     * @description Initialize the top news accessibility
     * @public
     */
  }, {
    key: "init",
    value: function init() {
      this._setWCAGAttributes();
    }

    /**
     * @method _setWCAGAttributes
     * @description set WCAG attributes to player elements
     * @private
     */
  }, {
    key: "_setWCAGAttributes",
    value: function _setWCAGAttributes() {
      $(this.player.moduleContainer).attr('role', 'presentation');
      $(this.player.controlBar).attr('role', 'application');
      // #. Set headline attributes
      this._setWCAGToHeadlines();
      // #. Set control buttons attributes
      this._setWCAGToControlButtons();
    }

    /**
     * @method _setWCAGToHeadlines
     * @description set WCAG attributes/events to headline element
     * @private
     */
  }, {
    key: "_setWCAGToHeadlines",
    value: function _setWCAGToHeadlines() {
      var _this = this;
      // #. Set aria-haspopup attribute to headline
      this.$headlines.attr({
        role: 'link',
        'aria-haspopup': true
      });

      // # on bind required for the streaming updates(lately rendered elements)
      $(this.player.container).off('focus', '.headline div');
      $(this.player.container).on('focus', '.headline div', function (event) {
        _this._onHeadlineFocused(event);
      });
      $(this.player.container).off('keydown');
      $(this.player.container).on('keydown', '.headline div', function (event) {
        if (event.keyCode === _keyCodes.default.ENTER) {
          $(event.target).trigger('click');
        }
      });

      // #. application role required to handle the custom keydown event(override screen reader)
      this.$headlines.parent().attr('role', 'application');
    }

    /**
     * @method _setWCAGToControlButtons
     * @description set WCAG attributes to player control button elements
     * @private
     */
  }, {
    key: "_setWCAGToControlButtons",
    value: function _setWCAGToControlButtons() {
      var attr = {
        role: 'button',
        tabindex: 0
      };

      // #. List of player control buttons
      var $buttons = [this.player.previousButton, this.player.nextButton, this.player.playButton, this.player.stopButton];
      var buttonTitles = ['news.topNews.player.previous', 'news.topNews.player.next', 'news.topNews.player.start', 'news.topNews.player.stop'];
      var self = this;
      for (var i = 0; i < $buttons.length; i++) {
        var $buttonActive = $($buttons[i]);
        // Get button title
        attr.title = window.getMessage(buttonTitles[i]);
        // #. Set the attributes
        $buttonActive.attr(attr);
        // #. Bind keydown - Enter should trigger the click event
        $buttonActive.off('keydown');
        $buttonActive.on('keydown', function (event) {
          self._onControlButtonsEventTriggered(event);
        });
        $buttonActive.off('focusout');
        $buttonActive.on('focusout', function (event) {
          $(this).removeAttr('aria-label');
        });
      }
    }

    /**
     * @method _onControlButtonsEventTriggered
     * @description handle the control button events
     * @param { KeydownEvent } event - Keyboard event
     * @private
     */
  }, {
    key: "_onControlButtonsEventTriggered",
    value: function _onControlButtonsEventTriggered(event) {
      var _this2 = this;
      if (event.keyCode === _keyCodes.default.ENTER || event.keyCode === _keyCodes.default.SPACE) {
        var $button = $(event.target);
        var triggerFocus = function triggerFocus() {
          var activeNews = _this2._getActiveNews();
          $button.blur();
          setTimeout(function () {
            $button.attr('aria-label', activeNews).focus();
          }, 50);
        };
        // #. Active element is Stop then focus will be move to Play
        if ($button.is(this.player.stopButton)) {
          this.player.stopAutoplay();
          $(this.player.playButton).css('display', 'inline').focus();
        } else
          // #. Active element is Play then focus will be move to Stop
          if ($button.is(this.player.playButton)) {
            this.player.startAutoplay();
            $(this.player.stopButton).css('display', 'inline').focus();
          } else if ($button.is(this.player.previousButton)) {
            this.player.showPrevious();
            triggerFocus();
          } else if ($button.is(this.player.nextButton)) {
            this.player.showNext();
            triggerFocus();
          }
      }
    }

    /**
     * @method _getActiveNews
     * @description get active news item
     * @private
     */
  }, {
    key: "_getActiveNews",
    value: function _getActiveNews() {
      var $activeNews = $(this.player.container).find('.pictureNewsItem').filter(function () {
        return $(this).css('visibility') === 'visible';
      });
      return $activeNews.find('.headline').text();
    }

    /**
     * @method _onHeadlineFocused
     * @description handle the headline focus event - to show the control buttons(like mouse over)
     * @param { FocusEvent } event - focus event
     * @private
     */
  }, {
    key: "_onHeadlineFocused",
    value: function _onHeadlineFocused(event) {
      // #. Stop the autoplay
      $(this.player.stopButton).click();
      // #. Show proper control buttons
      $(this.player.previousButton).css('display', 'inline');
      $(this.player.nextButton).css('display', 'inline');
      $(this.player.playButton).css('display', 'inline');
    }
  }]);
  return NewsPlayerAccessibility;
}();
var _default = exports.default = NewsPlayerAccessibility;

},{"util/enums/keyCodes":76}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * @class       : PopupSearchAccessibility
                                                                                                                                                                                                                                                                                                                                                                                               * @description : To enable the web content accessibility(WCAG) in the streaming nodes
                                                                                                                                                                                                                                                                                                                                                                                               *                NGPII-15056 - Bonds page - Ticker/ISIN field tag widgets not accessible using keyboard
                                                                                                                                                                                                                                                                                                                                                                                               * @dependencies: Jquery, KEYCODES
                                                                                                                                                                                                                                                                                                                                                                                               */
var PopupSearchAccessibility = /*#__PURE__*/function () {
  function PopupSearchAccessibility(options) {
    _classCallCheck(this, PopupSearchAccessibility);
    // #. Set accessibility config options
    this.options = options || {};
  }

  /**
   * @method init
   * @description Initialize the popup search accessibility
   * @public
   */
  _createClass(PopupSearchAccessibility, [{
    key: "init",
    value: function init() {
      this._start();
    }

    /**
     * @method _start
     * @description start the basic methods, assign attributes, bind key handler
     * @private
     */
  }, {
    key: "_start",
    value: function _start() {
      // #. check whether the search is multi-select or not
      if (this.options.multiSelect) {
        this._setMultiSelectAccessibility();
      }
    }

    /**
     * @method _setMultiSelectAccessibility
     * @description Initialize the multiselect popup search accessibility
     * @private
     */
  }, {
    key: "_setMultiSelectAccessibility",
    value: function _setMultiSelectAccessibility() {
      var _this = this;
      this.$tagContainer = $(this.options.container);
      this.$textInput = $(this.options.textField);
      this.tagSelector = '.popupsearch-tag';

      // #. Set the role to container element
      this.$tagContainer.attr('role', 'application');

      // #. bind keydown event to tag container element
      this.$tagContainer.on('keydown', this.tagSelector, function (event) {
        _this._onTagKeyHandler(event);
      });

      // #. bind keydown event to input element
      this.$textInput.on('keydown', function (event) {
        _this._oninputKeyHandler(event);
      });
    }

    /**
     * @method _setWCAGAttributes
     * @description seet necessary attributes to elements
     * @private
     */
  }, {
    key: "_setWCAGAttributes",
    value: function _setWCAGAttributes() {
      this.$tagContainer.find(this.tagSelector).attr({
        tabindex: 0
      });
    }

    /**
     * @method _onTagKeyHandler
     * @description key handler for the tag elements
     * @private
     */
  }, {
    key: "_onTagKeyHandler",
    value: function _onTagKeyHandler(event) {
      var keyCode = event.keyCode;
      var $activeTag = $(event.target);
      // #. ARROW-UP/LEFT will set the focus to previous tag
      // #. ARROW-DOWN/RIGHT will set the focus to next tag or text input
      // #. DELETE - will delete the item from the list
      if (keyCode === _keyCodes.default.ARROW_UP || keyCode === _keyCodes.default.ARROW_LEFT) {
        event.preventDefault();
        // #. get previous tag and set focus
        var $prevTag = $activeTag.prev(this.tagSelector);
        $prevTag.length > 0 && $prevTag.focus();
      } else if (keyCode === _keyCodes.default.ARROW_DOWN || keyCode === _keyCodes.default.ARROW_RIGHT) {
        event.preventDefault();
        var $nextTag = $activeTag.next(this.tagSelector);
        var $focusableEl = $nextTag.length > 0 ? $nextTag : this.$textInput;
        $focusableEl.focus();
      } else if (keyCode === _keyCodes.default.DELETE) {
        event.preventDefault();
        $activeTag.find('.remove').click();
      }
    }

    /**
     * @method _onInputKeyHandler
     * @description key handler for the input element
     * @private
     */
  }, {
    key: "_oninputKeyHandler",
    value: function _oninputKeyHandler(event) {
      var keyCode = event.keyCode;
      if (keyCode === _keyCodes.default.TAB && event.shiftKey || keyCode === _keyCodes.default.ARROW_UP || keyCode === _keyCodes.default.ARROW_LEFT) {
        event.preventDefault();
        // #. Set the attributes, inside the event because of new tag elements requires attributes
        this._setWCAGAttributes();
        // #. Handle the event
        this._onInputArrowEvent();
      }
    }

    /**
     * @method _onInputArrowEvent
     * @description on input element arrow events
     * @private
     */
  }, {
    key: "_onInputArrowEvent",
    value: function _onInputArrowEvent() {
      // #. Arrow left/up from input element will be set the focus to the last tag element
      this.$tagContainer.find(this.tagSelector).last().focus();
    }
  }]);
  return PopupSearchAccessibility;
}();
var _default = exports.default = PopupSearchAccessibility;

},{"util/enums/keyCodes":76}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * @class       : StreamingAccessibility
                                                                                                                                                                                                                                                                                                                                                                                               * @description : To enable the web content accessibility(WCAG) in the streaming nodes
                                                                                                                                                                                                                                                                                                                                                                                               *                NGPII-15978 - Enable accessibility in the ShowMessage(New Message) Icon
                                                                                                                                                                                                                                                                                                                                                                                               * @dependencies: Jquery, KEYCODES
                                                                                                                                                                                                                                                                                                                                                                                               * @references  : https://www.w3.org/TR/WCAG20-TECHS/
                                                                                                                                                                                                                                                                                                                                                                                               *                https://www.w3.org/TR/wai-aria-1.1/#tooltip
                                                                                                                                                                                                                                                                                                                                                                                               */
var StreamingAccessibility = /*#__PURE__*/function () {
  function StreamingAccessibility() {
    _classCallCheck(this, StreamingAccessibility);
    // #. To keep the news message button collection
    this.$newMessageButtons = [];
    // #. CSS selector of a new message icon element
    this.newsMessageSelector = 'a.newmessage';
  }

  /**
   * @method init
   * @description Initialize the streaming accessibility
   * @public
   */
  _createClass(StreamingAccessibility, [{
    key: "init",
    value: function init($node) {
      // #. Get news message button elements
      this.$newMessageButtons = this._findNewMessageButtons($node);
      this._start();
    }

    /**
     * @method update
     * @description Update the reloaded nodes with accessibility feature, same as init but a wrapper method
     * @public
     */
  }, {
    key: "update",
    value: function update($node) {
      // #. Get news message button elements
      this.$newMessageButtons = this._findNewMessageButtons($node);
      this._start();
    }

    /**
     * @method _start
     * @description start the basic methods, assign attributes, bind key handler
     * @private
     */
  }, {
    key: "_start",
    value: function _start() {
      // #. Check the count of the streaming nodes
      if (this.$newMessageButtons.length === 0) {
        return true;
      }

      // #. Set WCAG attributes
      this._setWCAGAttributes(this.$newMessageButtons);

      // #. Bind the keyboard accessibility event
      this._bindKeyHandler(this.$newMessageButtons);
    }

    /**
     * @method _findNewsMessageButtons
     * @description find the new message button collection from the streaming nodes collection
     * @param { HTMLCollectionOf } $nodes expecting streaming node element collection
     * @return { HTMLCollectionOf } new message button elements
     * @private
     */
  }, {
    key: "_findNewMessageButtons",
    value: function _findNewMessageButtons($nodes) {
      return $nodes.find(this.newsMessageSelector);
    }

    /**
     * @method _setWCAGAttributes
     * @description set WCAG attributes like aria-haspopup, aria-pressed to element
     * @param { HTMLCollectionOf }  { $elements } expecting html element collection
     * @private
     */
  }, {
    key: "_setWCAGAttributes",
    value: function _setWCAGAttributes($elements) {
      var hiddenTooltipContainer = $('<span></span>').attr('id', 'hiddenTooltipContainer').addClass('visuallyhidden');
      if ($('#hiddenTooltipContainer').length === 0) {
        $('body').append($(hiddenTooltipContainer));
      }
      $elements.attr({
        'aria-describedby': 'hiddenTooltipContainer'
      });

      // #. Apply role attribute to the parent table
      $elements.closest('td').attr({
        role: 'application'
      });

      // #. Update the title/arial-labelledby attributes
      this._updateShowMessageTitle($elements);
    }

    /**
     * @method _updateAttributes
     * @description update attribute of an element
     * @param { HTMLElement } $element expecting a html element
     * @param { Object } attributes expecting an object with updated attributes
     * @private
     */
  }, {
    key: "_updateAttributes",
    value: function _updateAttributes($element, attributes) {
      $element.attr(attributes);
    }

    /**
     * @method _bindKeyHandler
     * @description bind the keydown event and handle the event
     * @param { HTMLCollectionOf } $elements expecting html element collection
     * @private
     */
  }, {
    key: "_bindKeyHandler",
    value: function _bindKeyHandler($elements) {
      var _this = this;
      $elements.attr('tabindex', 0).on('keydown', function (event) {
        _this._onKeyHandlerUpdated(event);
      }).on('focus', function (event) {
        _this._onFocusHandlerUpdate(event);
      }).on('blur', function (event) {
        _this._onTabKeyPressed(event);
      });
    }

    /**
     * @method _onKeyHandlerUpdated
     * @description handle the keydown event
     * @param Event#keydown expecting keydown event object
     * @private
     */
  }, {
    key: "_onKeyHandlerUpdated",
    value: function _onKeyHandlerUpdated(event) {
      var keyCode = event.keyCode;
      if (keyCode === _keyCodes.default.TAB) {
        this._onTabKeyPressed(event);
      }
    }
  }, {
    key: "_onFocusHandlerUpdate",
    value: function _onFocusHandlerUpdate(event) {
      // #. Get the active element
      var $element = $(event.target);
      // #. Call the trigger event
      $element.attr({
        'aria-describedby': 'ngpTooltipNews'
      });
      this._triggerEvent($element, 'mouseover', event);
    }

    /**
     * @method _onTabKeyPressed
     * @description handle the tab key
     * @param Event#keydown expecting keydown event object
     * @private
     */
  }, {
    key: "_onTabKeyPressed",
    value: function _onTabKeyPressed(event) {
      // #. Get the active element
      var $element = $(event.target);
      // #. Call the trigger event
      this._triggerEvent($element, 'mouseout', event);
      $('#hiddenTooltipContainer').remove();
    }

    /**
     * @method _getStreamingContext
     * @description get streaming context if element is replaced with illustrate method
     * @param { HTMLElement } $element expecting current active element
     * @private
     */
  }, {
    key: "_getStreamingContext",
    value: function _getStreamingContext($element) {
      return $element.data('streaming-context');
    }

    /**
     * @method _triggerEvent
     * @description trigger event based on element environment
     * @param { HTMLElement } $element expecting current active element
     * @private
     */
  }, {
    key: "_triggerEvent",
    value: function _triggerEvent($element, eventName, event) {
      var streamingContext = this._getStreamingContext($element);
      /**
       * illustrateStreaming method from LastNewsFormatter replace the news message icon
       * mouseout event not available to this newly created element
       * keep the context as data attribute and invoke the hide tooltip method explicitly
       */
      if (streamingContext && streamingContext.hideInfo && eventName === 'mouseout') {
        streamingContext.hideInfo(event);
      } else {
        // #. Trigger the element event
        $element.trigger(eventName);
      }
    }

    /**
     * @method _updateShowMessageTitle
     * @description update show message title/arial-labelledby with the instrument name
     * @param { HTMLCollectionOf } $elements expecting collection of html element objects
     * @private
     */
  }, {
    key: "_updateShowMessageTitle",
    value: function _updateShowMessageTitle($elements) {
      var _iterator = _createForOfIteratorHelper($elements),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var $element = _step.value;
          $element = $($element);
          var title = this._getInstrumentNameByRow($element) || '';

          // #. Update the title with the instrument name in the row
          title = window.getMessage('title.streaming.showMessage', title);
          $element.attr('aria-label', title);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    /**
     * @method _getInstrumentNameByRow
     * @description get the instrument name by the element closest row
     * @param { HTMLElement } $element expecting an HTML element
     * @private
     */
  }, {
    key: "_getInstrumentNameByRow",
    value: function _getInstrumentNameByRow($element) {
      var $row = $($element.closest('tr'));
      return $row.find('a.instrumentIdentification').text() || $row.find('span.instrumentIdentification').text() || $row.find('input.searchPopupInput').val() || $row.find('a').first().text();
    }
  }]);
  return StreamingAccessibility;
}(); // #. Export the class
var _default = exports.default = StreamingAccessibility;

},{"util/enums/keyCodes":76}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
var _tabmenuAccessibility = require("aria/tabmenuAccessibility");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * @class       : TooltipAccessibility
                                                                                                                                                                                                                                                                                                                                                                                               * @description : To enable the web content accessibility(WCAG) in ngp application tooltip views
                                                                                                                                                                                                                                                                                                                                                                                               *                - NGPII-15117 Keyboard: QuickView Panel
                                                                                                                                                                                                                                                                                                                                                                                               * @dependencies: Jquery
                                                                                                                                                                                                                                                                                                                                                                                               * @references  : https://www.w3.org/TR/wai-aria-practices-1.1/examples/accordion/accordion.html
                                                                                                                                                                                                                                                                                                                                                                                               */
var TooltipAccessibility = /*#__PURE__*/function () {
  function TooltipAccessibility(options) {
    _classCallCheck(this, TooltipAccessibility);
    // #. Keep the config/options into context
    this.options = options;

    // #. Active element Identity
    this.ACTIVE_ELEMENT = {
      PANEL: 1,
      CHART: 2,
      CLOSE_BUTTON: 3,
      FIRST_MENU_ITEM: 4,
      FIRST_HEADER_BUTTON: 5,
      NEWS: 6
    };

    // #. Quick view menu identity
    this.QUICK_VIEW_MENU = {
      CHART: '#quickViewMenu\\.chart',
      RATIO: '#quickViewMenu\\.ratios',
      NEWS: '#quickViewMenu\\.news'
    };

    // #. Session storage key
    this.sessionKey = 'quick-panel-status';
  }

  /**
   * @method init
   * @description Initialize the tooltip/tooltip-target accessibility
   * @public
   */
  _createClass(TooltipAccessibility, [{
    key: "$quickView",
    get:
    // #. Quick view container selector
    function get() {
      return $('#ngpQuickview');
    }

    // #. Keep the quick view header
  }, {
    key: "$quickViewHeader",
    get: function get() {
      return this.$quickView.find('#quickViewHeader');
    }

    // #. Keep the quick view body
  }, {
    key: "$quickViewBody",
    get: function get() {
      return this.$quickView.find('#quickViewBody');
    }

    // #. Get the active element from dom
  }, {
    key: "$activeElement",
    get: function get() {
      return $(document.activeElement);
    }

    // #. Get first menu item from the body
  }, {
    key: "$firstMenuItem",
    get: function get() {
      return this.$quickViewBody.find('.menuItem.first button');
    }

    // #. Get last menu item from the body
  }, {
    key: "$lastMenuItem",
    get: function get() {
      return this.$quickViewBody.find('.menuItem button').last();
    }

    // #. Get chart container
  }, {
    key: "$chartContainer",
    get: function get() {
      return this.$quickViewBody.find('.highcharts-container');
    }

    // #. News table
  }, {
    key: "$newsTable",
    get: function get() {
      return this.$quickViewBody.find('#news_table');
    }

    // #. Get all button elements from header
  }, {
    key: "$headerButtons",
    get: function get() {
      return this.$quickViewHeader.find('.menu li.link');
    }

    // #. Get first button element from header
  }, {
    key: "$firstHeaderButton",
    get: function get() {
      return this.$headerButtons.first();
    }

    // #. Get close button
  }, {
    key: "$closeButton",
    get: function get() {
      return this.$quickViewHeader.find('#quickViewClose');
    }

    // #. Get aria-describedby element for the target
  }, {
    key: "$descriptionElement",
    get: function get() {
      var id = 'quick-view-target-desc';
      var $element = $('body').find("#".concat(id));
      // #. no hint element found, create a new one
      if ($element.length === 0) {
        $element = $('<span></span>').attr({
          id: id
        }).addClass('visuallyhidden').appendTo('body');
      }
      return $element;
    }

    // #. get focus status from session storage
  }, {
    key: "panelFocusStatus",
    get: function get() {
      return sessionStorage ? sessionStorage.getItem(this.sessionKey) : '0';
    }

    // #. set focus status to session storage
    ,
    set: function set(value) {
      sessionStorage && sessionStorage.setItem(this.sessionKey, value);
    }
  }, {
    key: "init",
    value: function init() {
      if (this.options.target) {
        this._bindTargetAccessibility();
      } else if (this.options.container) {
        this._bindPanelAccessibility();
        this._addAccessibilityAttributes();
        this._bindMenuItemLinkKeyHandler();
      }
    }

    /**
     * @method _bindTargetAccessibility
     * @description bind accessibility to the tooltip target
     * @private
     */
  }, {
    key: "_bindTargetAccessibility",
    value: function _bindTargetAccessibility() {
      var _this = this;
      $(window.document).on('tooltip-target-focus', this.options.target.selector, function (event, data) {
        if (data && data.panelFocusStatus) {
          _this.panelFocusStatus = data.panelFocusStatus;
        }
        event.currentTarget.focus();
      });
      // #. bind target focus - to trigger the mouseenter
      $(window.document).on('focusin', this.options.target.selector, function (event) {
        if (String($(event.target).attr(_this.options.target.attr)).includes(_this.options.target.contains)) {
          var $target = $(event.target);
          // #. Update the panel description text
          _this.$descriptionElement.text(window.getMessage('quickview.target.shortcut.title', $target.text()));
          // #. Set the attributes to target
          $target.attr({
            role: 'application',
            'aria-describedby': _this.$descriptionElement.attr('id')
          });
          window.setTimeout(function () {
            event.preventDefault();
            var status = _this.panelFocusStatus;
            if (status !== '1') {
              $target.trigger('mouseenter');
            }
            _this.panelFocusStatus = '1';
          }, 50);
        }
      });

      // #. bind target focusout - to manage the hide attr
      $(window.document).on('focusout', this.options.target.selector, function (event) {
        _this.panelFocusStatus = '0';
      });

      // #. bind target keydown event
      $(window.document).on('keydown', this.options.target.selector, function (event) {
        if (String($(event.target).attr(_this.options.target.attr)).includes(_this.options.target.contains)) {
          _this._onTargetKeyHandler(event);
        }
      });
    }

    /**
     * @method _onTargetKeyHandler
     * @description handle keydown of the tooltip target
     * @param { KeyboardEvent } event: keydown event
     * @private
     */
  }, {
    key: "_onTargetKeyHandler",
    value: function _onTargetKeyHandler(event) {
      var keyCode = event.keyCode;

      // #. Handle the keydown
      // #. Tab - will hide the quick view panel
      // #. ARR-LEFT - will set the focus to quick view panel
      if (keyCode === _keyCodes.default.TAB) {
        this._hideTooltip(false);
      } else if (keyCode === _keyCodes.default.ARROW_RIGHT) {
        this.$quickView.attr({
          tabindex: 0
        }).focus();
        this._setPanelWCAGRoles();
      }
    }

    /**
     * @method _setPanelWCAGRoles
     * @description set WCAG roles to the panel elements
     * @private
     */
  }, {
    key: "_setPanelWCAGRoles",
    value: function _setPanelWCAGRoles() {
      // #. Update the quick view tab menu accessibility
      var $menu = this.$quickView.find('div.moduleTabMenu div.menu');
      $menu.find('button.icon').attr('role', 'tab');
      (0, _tabmenuAccessibility.setAriaAttributesToModuleTabMenu)($menu);

      // #. Set live region roles
      this.$quickView.find('.moduleContent').attr('aria-live', 'polite');
    }

    /**
     * @method _bindPanelAccessibility
     * @description bind quick view panel accessibility
     * @private
     */
  }, {
    key: "_bindPanelAccessibility",
    value: function _bindPanelAccessibility() {
      var _this2 = this;
      // #. unbind the previously added event
      this.$quickView.off('keydown');
      // #. Bind keydown
      this.$quickView.attr('role', 'tooltip');
      this.$quickView.on('keydown', function (event) {
        _this2._onPanelKeyHandler(event);
      });
    }

    /**
     * @method _addAccessibilityAttributes
     * @description add necessary attributes to panel elements
     * @private
     */
  }, {
    key: "_addAccessibilityAttributes",
    value: function _addAccessibilityAttributes() {
      var _iterator = _createForOfIteratorHelper(this.$headerButtons),
        _step;
      try {
        var _loop = function _loop() {
          var $button = _step.value;
          $button = $($button);
          $button.attr({
            tabindex: 0,
            role: 'button'
          });

          // #. set the default pressed value
          $button.attr('aria-pressed', $button.hasClass('selected'));

          // Handle pressed attr on click event
          $button.on('click', function (event) {
            $button.attr('aria-pressed', $button.hasClass('selected'));
          });
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    /**
     * @method _bindMenuItemLinkKeyHandler
     * @description trigger menu item link click by using keyboard
     * @private
     */
  }, {
    key: "_bindMenuItemLinkKeyHandler",
    value: function _bindMenuItemLinkKeyHandler() {
      this.$headerButtons.on('keydown', function (event) {
        var keyCode = event.keyCode;
        if (keyCode === _keyCodes.default.SPACE || keyCode === _keyCodes.default.ENTER) {
          event.preventDefault();
          $(event.target).click();
        }
      });
    }

    /**
     * @method _onPanelKeyHandler
     * @description panel keydown event handler
     * @param { KeyboardEvent } event: keydown event
     * @private
     */
  }, {
    key: "_onPanelKeyHandler",
    value: function _onPanelKeyHandler(event) {
      var keyCode = event.keyCode;
      switch (keyCode) {
        case _keyCodes.default.TAB:
          this._onPanelTabKeyPressed(event);
          break;
        case _keyCodes.default.ARROW_LEFT:
        case _keyCodes.default.ESCAPE:
          this._hideTooltip(true);
          break;
        case _keyCodes.default.ARROW_DOWN:
          this._onPanelArrowDownPressed(event);
          break;
        case _keyCodes.default.ARROW_UP:
          this._onPanelArrowUpPressed(event);
          break;
      }
    }

    /**
     * @method _onPanelTabKeyPressed
     * @description handle tab key
     * @param { KeyboardEvent } event: keydown event
     * @private
     */
  }, {
    key: "_onPanelTabKeyPressed",
    value: function _onPanelTabKeyPressed(event) {
      var identity = this._getActiveElementIdentity();
      var result = false;
      switch (identity) {
        case this.ACTIVE_ELEMENT.PANEL:
          event.preventDefault();
          this._setFocusToActiveItemPart(false);
          break;
        case this.ACTIVE_ELEMENT.CHART:
          event.preventDefault();
          this.$chartContainer.blur();
          if (!event.shiftKey) {
            this._setFocusToRatio();
          } else {
            this.$lastMenuItem.focus();
          }
          break;
        case this.ACTIVE_ELEMENT.NEWS:
          event.preventDefault();
          if (!event.shiftKey) {
            this.$firstHeaderButton.focus();
          } else {
            this._setFocusToRatio(true);
          }
          break;
        case this.ACTIVE_ELEMENT.CLOSE_BUTTON:
          if (!event.shiftKey) {
            event.preventDefault();
            this._setFocusToActiveItemPart(false);
          }
          break;
        case this.ACTIVE_ELEMENT.FIRST_MENU_ITEM:
          result = true;
          if (event.shiftKey) {
            event.preventDefault();
            this.$closeButton.focus();
            result = false;
          }
          break;
        case this.ACTIVE_ELEMENT.FIRST_HEADER_BUTTON:
          if (event.shiftKey) {
            event.preventDefault();
            this._setFocusToActiveItemPart(true);
          }
          break;
        default:
          result = true;
          break;
      }
      return result;
    }

    /**
     * @method _onPanelArrowUpPressed
     * @description handle panel arrow up key
     * @param { KeyboardEvent } event: keydown event
     * @private
     */
  }, {
    key: "_onPanelArrowUpPressed",
    value: function _onPanelArrowUpPressed(event) {
      var identity = this._getActiveElementIdentity();
      if (identity === this.ACTIVE_ELEMENT.NEWS) {
        event.preventDefault();
        // #. Get active row
        var $activeRow = this.$activeElement;
        // #. Get all table rows except header
        var $rows = this.$newsTable.find('tr').not(':first');
        // #. Variable to keep the previous row
        var $row = null;
        // 1. If no rows selected yet, focus to last row
        // 2. If row is first row then, last row will select
        // 3. prev - select the previous row
        if (!$activeRow.is('tr')) {
          $row = $rows.last();
        } else if ($activeRow.is('tr')) {
          if ($activeRow.is($rows.first())) {
            $row = $rows.last();
          } else {
            $row = $activeRow.prev();
          }
        }
        if ($row) {
          $row.focus();
        }
      }
    }

    /**
     * @method _onPanelArrowDownPressed
     * @description handle arrow down key
     * @param { KeyboardEvent } event: keydown event
     * @private
     */
  }, {
    key: "_onPanelArrowDownPressed",
    value: function _onPanelArrowDownPressed(event) {
      var identity = this._getActiveElementIdentity();
      // #. Handle news table arrow down
      if (identity === this.ACTIVE_ELEMENT.NEWS) {
        event.preventDefault();
        // #. Get active row
        var $activeRow = this.$activeElement;
        // #. Get all table rows except header
        var $rows = this.$newsTable.find('tr').not(':first');
        // #. Variable to keep the next row
        var $row = null;
        // 1. If no rows selected yet, focus to first row
        // 2. If row is last row then, first row will select
        // 3. next - select next row
        if (!$activeRow.is('tr')) {
          $row = $rows.first();
        } else if ($activeRow.is('tr')) {
          if ($activeRow.is($rows.last())) {
            $row = $rows.first();
          } else {
            $row = $activeRow.next();
          }
        }
        if ($row) {
          $row.focus();
        }
      }
    }

    /**
    * @method _hideTooltip
    * @description hide the tooltip panel
    * @param { boolean } setFocusToTarget: to identify set focus to target element
    * @private
    */
  }, {
    key: "_hideTooltip",
    value: function _hideTooltip(setFocusToTarget) {
      this.$closeButton.trigger('click');
      if (this.options.$target) {
        var $target = $(this.options.$target);
        if (setFocusToTarget) {
          this.panelFocusStatus = '1';
          $target.focus();
        }
      }
    }

    /**
     * @method _getActiveElementIdentity
     * @description get active element identity
     * @private
     */
  }, {
    key: "_getActiveElementIdentity",
    value: function _getActiveElementIdentity() {
      var $activeElement = this.$activeElement;
      if ($activeElement.is(this.$quickView)) {
        return this.ACTIVE_ELEMENT.PANEL;
      } else if ($activeElement.is(this.$closeButton)) {
        return this.ACTIVE_ELEMENT.CLOSE_BUTTON;
      } else if ($activeElement.is(this.$firstMenuItem)) {
        return this.ACTIVE_ELEMENT.FIRST_MENU_ITEM;
      } else if ($activeElement.is(this.$chartContainer) || $activeElement.closest(this.$chartContainer).length > 0 || $activeElement.closest('.chartImageBox').length > 0) {
        return this.ACTIVE_ELEMENT.CHART;
      } else if ($activeElement.is(this.$firstHeaderButton)) {
        return this.ACTIVE_ELEMENT.FIRST_HEADER_BUTTON;
      } else if ($activeElement.is(this.$newsTable) || $activeElement.closest(this.$newsTable).length > 0) {
        return this.ACTIVE_ELEMENT.NEWS;
      }
    }

    /**
     * @method _getFirstSelectedPart
     * @description get first selected parts identity
     * @private
     */
  }, {
    key: "_getFirstSelectedPart",
    value: function _getFirstSelectedPart() {
      var selected = 'selected';
      if (this.$quickViewHeader.find(this.QUICK_VIEW_MENU.CHART).hasClass(selected)) {
        return this.QUICK_VIEW_MENU.CHART;
      } else if (this.$quickViewHeader.find(this.QUICK_VIEW_MENU.RATIO).hasClass(selected)) {
        return this.QUICK_VIEW_MENU.RATIO;
      } else if (this.$quickViewHeader.find(this.QUICK_VIEW_MENU.NEWS).hasClass(selected)) {
        return this.QUICK_VIEW_MENU.NEWS;
      }
    }

    /**
     * @method _getLastSelectedPart
     * @description get last selected parts identity
     * @private
     */
  }, {
    key: "_getLastSelectedPart",
    value: function _getLastSelectedPart() {
      var selected = 'selected';
      if (this.$quickViewHeader.find(this.QUICK_VIEW_MENU.NEWS).hasClass(selected)) {
        return this.QUICK_VIEW_MENU.NEWS;
      } else if (this.$quickViewHeader.find(this.QUICK_VIEW_MENU.RATIO).hasClass(selected)) {
        return this.QUICK_VIEW_MENU.RATIO;
      } else if (this.$quickViewHeader.find(this.QUICK_VIEW_MENU.CHART).hasClass(selected)) {
        return this.QUICK_VIEW_MENU.CHART;
      }
    }

    /**
     * @method _setFocusToActiveItemPart
     * @description set focus to the first active item in the panel
     * @param { Boolean } chooseLastPart - to identify the last/first part
     * @private
     */
  }, {
    key: "_setFocusToActiveItemPart",
    value: function _setFocusToActiveItemPart(chooseLastPart) {
      var partId = chooseLastPart ? this._getLastSelectedPart() : this._getFirstSelectedPart();
      switch (partId) {
        case this.QUICK_VIEW_MENU.CHART:
          if (chooseLastPart) {
            this._setFocusToChart();
          } else {
            this._setFocusToChartMenuItem();
          }
          break;
        case this.QUICK_VIEW_MENU.NEWS:
          this._setFocusToNews();
          break;
        case this.QUICK_VIEW_MENU.RATIO:
          this._setFocusToRatio(chooseLastPart);
          break;
        default:
          this.$firstHeaderButton.focus();
          break;
      }
    }

    /**
     * @method _setFocusToChartMenuItem
     * @description set focus to the chart menu item in the body
     * @private
     */
  }, {
    key: "_setFocusToChartMenuItem",
    value: function _setFocusToChartMenuItem() {
      this.$firstMenuItem.focus();
    }

    /**
     * @method _setFocusToNews
     * @description set focus to news table
     * @private
     */
  }, {
    key: "_setFocusToNews",
    value: function _setFocusToNews() {
      this._setNewsTableAccessibility();
      this.$newsTable.focus();
    }

    /**
     * @method _setFocusToRatio
     * @description ration view has no focusable elements, so focus may set to news or header buttons
     * @param { boolean } isShiftKey: identify shift key pressed or not
     * @private
     */
  }, {
    key: "_setFocusToRatio",
    value: function _setFocusToRatio(isShiftKey) {
      var selected = 'selected';
      if (isShiftKey) {
        if ($(this.QUICK_VIEW_MENU.CHART).hasClass(selected)) {
          this._setFocusToChart();
        } else {
          this.$closeButton.focus();
        }
      } else {
        // #. 1. If news selected - focus will be set to news table
        // #. 2. else the focus set to quick view chart button element
        if ($(this.QUICK_VIEW_MENU.NEWS).hasClass(selected)) {
          this._setFocusToNews();
        } else {
          this.$firstHeaderButton.focus();
        }
      }
    }

    /**
     * @method _setFocusToChart
     * @description set focus to the chart container
     * @private
     */
  }, {
    key: "_setFocusToChart",
    value: function _setFocusToChart() {
      this.$chartContainer.focus();
    }

    /**
     * @method _setNewsTableAccessibility
     * @description set news table accessibility
     * @private
     */
  }, {
    key: "_setNewsTableAccessibility",
    value: function _setNewsTableAccessibility() {
      // #. Set table
      this.$newsTable.attr({
        tabindex: 0
      });
      this.$newsTable.parent().attr({
        role: 'application'
      });

      // #. Set table row
      this.$newsTable.find('tr').attr({
        tabindex: 0,
        role: 'button'
      });
    }
  }]);
  return TooltipAccessibility;
}();
var _default = exports.default = TooltipAccessibility;

},{"aria/tabmenuAccessibility":11,"util/enums/keyCodes":76}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAriaAttributesToModuleTabMenu = void 0;
var _keyCodes = _interopRequireDefault(require("util/enums/keyCodes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * set aria attributes to moduletabmenus
 */
var setAriaAttributesToModuleTabMenu = exports.setAriaAttributesToModuleTabMenu = function setAriaAttributesToModuleTabMenu($menu) {
  var moduleTabMenus = $menu || $('div.moduleTabMenu div.menu');
  setAttributes(moduleTabMenus);
};

/**
 * set aria attributes to tablist and tabpanel for all tab menus on the page with tab buttons inside
 * @param menus
 */
var setAttributes = function setAttributes(menus) {
  $(menus).each(function (index, menu) {
    if ($(menu).find('button.icon').length > 0) {
      setAttributesToTablist(menu);
    }
  });
};

/**
 * set attributes to module tab menu elements by given tab menu
 * @param menu
 */
var setAttributesToTablist = function setAttributesToTablist(menu) {
  // todo get module title without timeout
  window.setTimeout(function () {
    // timeout because of loading... text at the beginning
    var moduleTitle = $(menu).closest('div.module').find('div.moduleHeader h2');
    $(menu).attr('role', 'tablist');
    $(menu).attr('aria-label', $(moduleTitle).text());
  }, 2000);
  setAriaAttributesToButtons($(menu));
};

/**
 * set attributes to tab buttons to given tab menu
 * @param menu
 */
var setAriaAttributesToButtons = function setAriaAttributesToButtons(menu) {
  var tabMenu = menu;
  var menuItems = $(tabMenu).find('div.menuItem');
  $(tabMenu).find('button').each(function (index, button) {
    $(button).attr('role', 'tab').attr('aria-selected', false).on('keydown', function (e) {
      if (e.keyCode === _keyCodes.default.ENTER || e.keyCode === _keyCodes.default.SPACE) {
        updateTabButtons(tabMenu, e.target);
      }
    }).on('click', function (e) {
      updateTabButtons(tabMenu, e.target);
    });
  });
  $(menuItems).each(function (index, item) {
    if ($(item).hasClass('on')) {
      setTabButtonSelected($(item).find('button'));
      return true;
    }
  });
};

/**
 * update attributes of tab buttons
 * @param menu
 * @param pressedBtn
 */
var updateTabButtons = function updateTabButtons(menu, pressedBtn) {
  var menuItemButtons = $(pressedBtn).parent('.menuItem').parent().find('> .menuItem button');
  menuItemButtons.attr('aria-selected', false).removeAttr('tabindex');
  setTabButtonSelected(pressedBtn);
};

/**
 * set given button as selected
 * @param button
 */
var setTabButtonSelected = function setTabButtonSelected(button) {
  $(button).attr({
    'aria-selected': true,
    tabindex: -1
  });
};

},{"util/enums/keyCodes":76}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * the context menu item is a container class for menu items and
 * some additional informations. A context menu item must have a unique name
 * with which it can be identified, and it must provide some additional informations,
 * like a function to find out whether it should be rendered or not.
 * See the api doc for all necessary fields and functions.
 * This super class constructor will set the given name attribute and register the
 * context menu item to the array of available items. The constructor should be
 * called for all the context menu items in the order they should appear
 * to the user. Take care when creating new entries:
 * 1. group ids must not be shuffled. Each item must have the same group id the group id exactly one larger, than the previous item.
 * 2. when adding items, also check the com.financial.ngp.web.tag.Functions.checkContextMenuAttributes() method, if it needs
 *    to be adjusted. This function removes context menu attributes from modules, whenever it thinks they are not valid for the given user
 * @param uniqueName the name with which this context menu item can be accessed
 * @param groupId the integer id of the group the item belongs to. Ids must start at 0 and
 *        count up without gaps due to YUI limitations.
 */
var ContextMenuItem = function ContextMenuItem(uniqueName, groupId) {
  this.name = uniqueName;
  window.YAHOO.fcom.Context.availableItems.push(this);
  this.isVisible = true; // whether this item is currently made visible or not
  this.groupId = groupId;
};

/*
 * the is needed function will be called whenever a context menu is opened for an
 * element of the page. It should return false when the menu item is not applicable
 * for that element and true if it is.
  */
ContextMenuItem.prototype.isNeeded = function () {
  return false;
};

/*
 * the menu item must be an object that is applicable to be passed to the
 * YAHOO.widget.Menu.addItem() function. So it can be a bean or an instance of
 * YAHOO.widget.MenuItem. Should never be null, when isNeeded return true!
 */
ContextMenuItem.prototype.menuItem = null;

/*
 * this triggerAjaxCallback function can be used by menu items, that need info from an ajax
 * request before being able to decide whether the menu item is needed or how it is named.
 * Menu items that do not need ajax requests, should not overwrite this function, or return
 * false. If true is returned, the isNeeded function is only called after the context menu item
 * registered it's ready state at the YAHOO.fcom.Context.menuItemFromAjaxReady(contextMenuItem) function.
 * Even if the ajax call fails or the menu item decides that it is not needed, the menuItemReady
 * function must be called, as the context menu waits until every registered ajax menu item has called
 * this function.
 */
ContextMenuItem.prototype.triggerAjaxCallback = function () {
  return false;
};
var _default = exports.default = ContextMenuItem;

},{}],13:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * group indices for different groups of context menu items.
 * TAKE CARE !!! YUI is very strict here. The group ids must start with 0
 * and need to be intergers with a step of 1 not having any gaps,
 * or YUI will completely mess up the menu
 */
var menuGroups = {
  MODULE_ACTIONS: 0,
  TRANSACTION_ACTIONS: 1,
  WATCHLIST_PORTFOLIO_ACTIONS: 2,
  ALERT_ACTIONS: 3,
  INSTRUMENT_ACTIONS: 4
};
var _default = exports.default = menuGroups;

},{}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * Add a list of instruments to a selected watchlist
 * @param {Array} ricList flat list of ric strings
 * @param {String} watchlistId
 * @param {Object} callback for ngpAsyncRequest
 */
var addInstrumentListToUserWatchlist = function addInstrumentListToUserWatchlist(ricList, watchlistId, callback) {
  var url = '/watchlist.action?method=handleAddInstrumentList';
  var json = JSON.stringify(ricList);
  window.ngpAsyncRequest('POST', url, callback, "watchlistId=".concat(watchlistId, "&json=").concat(json)).then(function () {
    return window.YAHOO.fcom.Broadcaster.sendMessage('@watchlists', {
      messageType: 'watchlistChanged',
      id: watchlistId
    });
  });
};
window.addInstrumentListToUserWatchlist = addInstrumentListToUserWatchlist;
var _default = exports.default = addInstrumentListToUserWatchlist;

},{}],15:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * Add an instrument to a portfolio.
 * This will open the AddPositonPanel with the instrument preset.
 * @param {String} ric
 * @param {Object} portfolio
 */
var addInstrumentToPortfolio = function addInstrumentToPortfolio(instrument, portfolio) {
  window.YAHOO.fcom.panel.PanelFactory.getAJAXPanel(window.YAHOO.fcom.panel.AJAXPanel.PORTFOLIO_ADD_FIXED, {
    fn: function fn(panel) {
      panel.setPortfolio(portfolio);
      panel.setInstrument({
        RIC: instrument
      });
      panel.show();
    }
  }, {
    fixed: true
  });
};
var _default = exports.default = addInstrumentToPortfolio;

},{}],16:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var addInstrumentToUserWatchlist = function addInstrumentToUserWatchlist(ric, watchlistId) {
  // TODO: change to a more fcom like function call with wait symbol also
  var postData = "method=handleAddInstrument&watchlistId=".concat(watchlistId, "&ric=").concat(ric);
  var callback = {
    success: function success() {
      window.ngpAlert(window.getMessage('page.functions.title.addtowatchlist.success'), {
        fixedcenter: true
      });
    },
    failure: function failure() {
      window.ngpAlert(window.getMessage('page.functions.title.addtowatchlist.failure'), {
        fixedcenter: true
      });
    },
    argument: null
  };
  window.ngpAsyncRequest('POST', '/watchlist.action', callback, postData).then(function () {
    return window.YAHOO.fcom.Broadcaster.sendMessage('@watchlists', {
      messageType: 'watchlistChanged',
      id: watchlistId
    });
  });
};
var _default = exports.default = addInstrumentToUserWatchlist;

},{}],17:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var columnConfigToPageSettings = function columnConfigToPageSettings(moduleId, pageSettingsKey) {
  var moduleContainer = window.YAHOO.fcom.Page.getInstance('moduleContainer');
  var moduleDataId = moduleId;
  if (moduleDataId.startsWith(moduleContainer.id)) {
    moduleDataId = moduleDataId.slice(moduleContainer.id.length + 1, moduleDataId.length);
  }
  var postData = "method=selectModuleColumnConfigPage&moduleId=".concat(moduleDataId, "&viewId=").concat(moduleContainer.id);
  var config = {
    url: 'module.action'
  };
  window.YAHOO.lang.augmentObject(config, window.YAHOO.fcom.panel.AJAXPanel.CHOOSE_COLUMN_PANEL);
  window.YAHOO.fcom.panel.PanelFactory.getAJAXPanel(config, {
    fn: function fn(panel) {
      var params = window["".concat(panel.id, "_baseParams")];
      if (params.context.inputId) {
        params.fidlets = JSON.parse(window.YAHOO.util.Dom.get(params.context.inputId).value);
      }
      params.callback = function (result) {
        if (!result.fidlets || result.fidlets.length === 0) {
          window.ngpAlert(window.getMessage('module.dialog.configure.errorNoColumn'));
          return;
        }
        //save page settings
        window.savePageSettings(pageSettingsKey, {
          columnStringList: result.fidlets
        }, true, function () {
          panel.hide();
          window.location.reload();
        });
      };
      panel.initDynamicData(params);
      panel.show();
    }
  }, postData);
};
var _default = exports.default = columnConfigToPageSettings;

},{}],18:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * Add all chain constituents to the comparison.
 * On success the user is redirected to the comparison page.
 * @param {String} chainRic
 */
var compareChainConstituents = function compareChainConstituents(chainRic) {
  var url = "/comparison.action?method=addChainConstituentsToComparison&ric=".concat(encodeURIComponent(chainRic));
  window.ngpAsyncRequest('POST', url, {
    success: function success() {
      window.redirectTo(window.COMPARISON_DEFAULT_PAGE);
    },
    failure: function failure() {
      window.ngpAlert(window.getMessage('errorpage.noConstituents'), {
        fixedcenter: true
      });
    }
  });
};
var _default = exports.default = compareChainConstituents;

},{}],19:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * Add all index constituents to the comparison.
 * On success the user is redirected to the comparison page.
 * @param {String} indexRic
 */
var compareIndexConstituents = function compareIndexConstituents(indexRic) {
  var url = "/comparison.action?method=addIndexConstituentsToComparison&ric=".concat(encodeURIComponent(indexRic));
  window.ngpAsyncRequest('POST', url, {
    success: function success() {
      window.redirectTo(window.COMPARISON_DEFAULT_PAGE);
    },
    failure: function failure() {
      window.ngpAlert(window.getMessage('errorpage.noConstituents'), {
        fixedcenter: true
      });
    }
  }).then(function () {
    return window.YAHOO.fcom.Broadcaster.sendMessage('@watchlists', {
      messageType: 'watchlistChanged',
      id: 'instrument_comparison'
    });
  });
};
var _default = exports.default = compareIndexConstituents;

},{}],20:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * Add all instruments of a portfolio or watchlist to the comparison.
 * On success the user is redirected to the comparison page.
 * @param {String} id
 * @param {String} type
 * type can be either "watchlist" or "portfolio"
 */
var compareWatchlistPortfolio = function compareWatchlistPortfolio(id, type) {
  var url = "/comparison.action?method=addWatchlistPortfolioToComparison&id=".concat(id, "&type=").concat(type);
  window.ngpAsyncRequest('POST', url, {
    success: function success() {
      window.redirectTo(window.COMPARISON_DEFAULT_PAGE);
    },
    failure: function failure() {
      window.ngpAlert(window.getMessage('comparison.txt.error.adding.watchlistPortfolio'), {
        fixedcenter: true
      });
    }
  }).then(function () {
    return window.YAHOO.fcom.Broadcaster.sendMessage('@watchlists', {
      messageType: 'watchlistChanged',
      id: 'instrument_comparison'
    });
  });
};
var _default = exports.default = compareWatchlistPortfolio;

},{}],21:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _showWatchlistInputPanel = _interopRequireDefault(require("contextMenu/helperFunctions/showWatchlistInputPanel"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*
 * Create a new watchlist and copy all instruments into the new watchlist.
 * @param wlName {String} name of the watchlist to copy
 * @param callback {Object}
 */
var copyWatchlist = function copyWatchlist(wlName, callback, isConversion) {
  //get watchlist info
  var url1 = window.YAHOO.fcom.Util.addURLParam('/watchlist.action?method=handleGetWatchlistsJSON', 'wlNames', wlName);
  var callback1 = {
    success: function success(response) {
      var wl = JSON.parse(response.responseText);
      if (wl.length > 0) {
        wl = wl[0];
        var displayName = "".concat(wl.displayName, " ").concat(window.getMessage('portfolio.dialog.wl.copy.input.value'));
        (0, _showWatchlistInputPanel.default)(window.getMessage(isConversion ? 'portfolio.dialog.wl.convert.title' : 'portfolio.dialog.wl.copy.title'), {
          displayName: displayName
        }, {
          fn: function fn(inputPanel) {
            //save the watchlist copy
            var map = {
              displayName: inputPanel.getFieldValues().displayName,
              name: wl.name
            };
            var url = '/watchlist.action?method=handleCopyWatchlist';
            var callback2 = {
              success: function success(response) {
                if (callback && callback.fn != null) {
                  callback.fn.call(callback.scope, response);
                } else {
                  window.location.reload();
                }
              },
              failure: function failure(response) {
                if (response.status === 409) {
                  inputPanel.showError(response.responseText, inputPanel.getInputField('displayName'));
                } else {
                  inputPanel.hide();
                  window.ngpAlert(window.getMessage('DEFAULT_AJAX_ERROR'));
                }
              },
              waitMask: true
            };
            window.ngpAsyncRequest('POST', url, callback2, window.YAHOO.fcom.Util.createPostData(map));
          }
        });
      }
    },
    waitMask: true
  };
  window.ngpAsyncRequest('POST', url1, callback1);
};
window.copyWatchlist = copyWatchlist;
var _default = exports.default = copyWatchlist;

},{"contextMenu/helperFunctions/showWatchlistInputPanel":37}],22:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * Shows a confirmation dialog to duplicate an alert.
 * Fires the page event <tt>"alertChanged"</tt>.
 *
 * @param {String} id of the alert you want to create a duplicate of
 */
var duplicateAlert = function duplicateAlert(id) {
  window.ngpConfirm(window.getMessage('alert.dialog.js.duplicate.message'), {
    width: '250px',
    fixedcenter: true,
    dragOnly: true,
    constraintoviewport: true,
    modal: true,
    okButtonText: window.getMessage('txt.button.duplicate'),
    okHandler: function okHandler() {
      window.ngpAsyncRequest('POST', '/alert.action?method=alertDuplicate', {
        success: function success() {
          window.YAHOO.fcom.Page.fire('alertChanged', 'duplicate');
        },
        failure: function failure(response) {
          window.ngpAlert(response.responseText);
        }
      }, window.YAHOO.fcom.Util.createPostData({
        triggerID: id
      }));
    },
    title: window.getMessage('alert.dialog.js.duplicate.title')
  });
};
var _default = exports.default = duplicateAlert;

},{}],23:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * open a panel to allow the user to edit the sharing authorizations
 * of his watchlists or portfolios
 * @param type of object, can be "watchlist" or "portfolio"
 * @param watchlistId the id of the watchlist to alter authorizations for
 * @param origin the origin of the watchlist
 * @param reloadTable when the call is done from a large table, the large table id can be given here,
 *        than not the full page, but only the table will be reloaded to refresh the+
 */
var editSharingAuthorizations = function editSharingAuthorizations(type, sharableObjectId, origin, reloadTable) {
  if (origin === 'own') {
    var panelConfig = {
      url: "".concat(type, ".action?method=handleGetSharingAuthorization&property1=").concat(sharableObjectId)
    };
    window.YAHOO.lang.augmentObject(panelConfig, window.YAHOO.fcom.panel.AJAXPanel.EDIT_SHARING);
    window.YAHOO.fcom.panel.PanelFactory.getAJAXPanel(panelConfig, {
      fn: function fn(panel) {
        panel.setSharedObjectId(sharableObjectId);
        panel.setControllerUri("/".concat(type, ".action"));
        if (reloadTable) {
          panel.setOverviewTable(reloadTable);
        }
        panel.show();
      }
    });
  } else {
    window.ngpAlert(window.getMessage('share.error.owned.only'), {
      fixedcenter: true
    });
  }
};
var _default = exports.default = editSharingAuthorizations;

},{}],24:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * Convert the given portfolios to watchlists.
 * @param portfolioIDs {Array} array containg the portfolio ids.
 */
var portfolioConvertToWatchlist = function portfolioConvertToWatchlist(portfolioIDs) {
  if (portfolioIDs.length > 0) {
    window.ngpConfirm(window.getMessage('portfolio.dialog.copyPortfolio2Watchlist.question'), {
      okButtonText: window.getMessage('txt.button.copy'),
      okHandler: function okHandler() {
        var url = '/portfolio.action?method=handleCopyPortfolios2Watchlists';
        var copyPortfolioCallBack = {
          success: function success(response) {
            window.ngpAlert(response.responseText);
          },
          failure: function failure() {
            window.ngpAlert(window.getMessage('DEFAULT_AJAX_ERROR'));
          },
          waitMask: true
        };
        var postData = window.YAHOO.fcom.Util.arrayToParam(portfolioIDs, 'pfids');
        window.ngpAsyncRequest('POST', url, copyPortfolioCallBack, postData);
      }
    });
  }
};
var _default = exports.default = portfolioConvertToWatchlist;

},{}],25:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * Delete portfolios
 * @param portfolios {Array} containing objects with the following properties:
 *  <ul>
 *     <li> id {String} the portfolio id
 *     <li> name {String} the portfolio name
 * </ul>
 */
var portfolioDelete = function portfolioDelete(portfolios) {
  var message = '';
  var idList = portfolios[0].id.split(',') || [];
  if (idList.length > 1) {
    message = window.replaceSpringMessageArguments(window.getMessage('portfolio.dialog.deletePortfolio.question.several'), [idList.length]);
  } else if (idList.length === 1) {
    var pfName = window.fcom.util.StringHelper.escapeHTML(portfolios[0].name);
    message = window.replaceSpringMessageArguments(window.getMessage('portfolio.dialog.deletePortfolio.question.one'), [pfName]);
  } else {
    return; //no positions to delete
  }

  window.ngpConfirm(message, {
    okButtonText: window.getMessage('txt.button.delete'),
    okHandler: function okHandler() {
      var url = window.YAHOO.fcom.Util.addURLParam('/portfolio.action?method=handleRemovePortfolio', 'idList', idList);
      var callback = {
        success: function success() {
          //reload page
          window.location.reload();
        },
        failure: function failure(response) {
          window.ngpAlert(response.responseText);
        },
        waitMask: true
      };
      window.ngpAsyncRequest('GET', url, callback);
    },
    fixedCenter: true
  });
};
window.portfolioDelete = portfolioDelete;
var _default = exports.default = portfolioDelete;

},{}],26:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * Opens a dialog to edit a portfolio. YUI-style callback parameters are available
 * @param portfolioId {String}
 * @param callback {Function}
 * @param custom {Object} a custom object
 * @param override {Boolean|Object} if override is true, custom will become the scope for the callback. If override is an object,
 * it will be come the scope itself.
 */
var portfolioEdit = function portfolioEdit(portfolioId, callback, custom, override) {
  var config = {
    postData: window.YAHOO.fcom.Util.createPostData({
      portfolioId: portfolioId
    })
  };
  window.YAHOO.lang.augmentObject(config, window.YAHOO.fcom.panel.AJAXPanel.PORTFOLIO_CREATE);
  window.YAHOO.fcom.panel.PanelFactory.getAJAXPanel(config, {
    fn: function fn(panel) {
      panel.saveEvent.subscribe(function (portfolio) {
        if (callback) {
          var scope = null;
          if (typeof override == 'boolean') {
            if (override === true) {
              scope = custom;
            }
          } else {
            scope = override;
          }
          callback.call(scope, portfolio, custom);
        }
      });
      panel.show();
    }
  });
};
var _default = exports.default = portfolioEdit;

},{}],27:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * Opens a panel to edit a position of a portfolio
 * @param portfolioID {String}
 * @param positionID {String}
 */
var portfolioPositionEdit = function portfolioPositionEdit(portfolioID, positionID) {
  window.YAHOO.fcom.panel.PanelFactory.getAJAXPanel(window.YAHOO.fcom.panel.AJAXPanel.PORTFOLIO_EDIT, {
    fn: function fn(panel) {
      panel.saveEvent.subscribe(function () {
        window.location.reload();
      });
      panel.show();
    }
  }, {
    portfolioID: portfolioID,
    positionID: positionID
  });
};
var _default = exports.default = portfolioPositionEdit;

},{}],28:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * Opens a panel to edit a historic position of a portfolio
 * @param portfolioID {String}
 * @param positionID {String}
 */
var portfolioPositionEditHistoric = function portfolioPositionEditHistoric(portfolioID, positionID) {
  window.YAHOO.fcom.panel.PanelFactory.getAJAXPanel(window.YAHOO.fcom.panel.AJAXPanel.PORTFOLIO_EDIT_HISTORICAL, {
    fn: function fn(panel) {
      panel.saveEvent.subscribe(function () {
        window.location.reload();
      });
      panel.show();
    }
  }, {
    portfolioID: portfolioID,
    positionID: positionID
  });
};
var _default = exports.default = portfolioPositionEditHistoric;

},{}],29:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * Opens a panel to reduce a position of a portfolio
 * @param portfolioID {String}
 * @param positionID {String}
 */
var portfolioPositionReduce = function portfolioPositionReduce(portfolioID, positionID) {
  window.YAHOO.fcom.panel.PanelFactory.getAJAXPanel(window.YAHOO.fcom.panel.AJAXPanel.PORTFOLIO_REDUCE, {
    fn: function fn(panel) {
      panel.saveEvent.subscribe(function () {
        window.location.reload();
      });
      panel.show();
    }
  }, {
    portfolioID: portfolioID,
    positionID: positionID
  });
};
var _default = exports.default = portfolioPositionReduce;

},{}],30:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * Opens a dialog for generating a print report for the given portfolio.
 * @param portfolioID {String}
 */
var portfolioPrintReport = function portfolioPrintReport(portfolioID) {
  var panelConfig = {
    postData: window.YAHOO.fcom.Util.createPostData({
      portfolioID: portfolioID
    })
  };
  window.YAHOO.lang.augmentObject(panelConfig, window.YAHOO.fcom.panel.AJAXPanel.PORTFOLIO_PRINT);
  window.YAHOO.fcom.panel.PanelFactory.getAJAXPanel(panelConfig, {
    fn: function fn(panel) {
      panel.show();
    }
  });
};
var _default = exports.default = portfolioPrintReport;

},{}],31:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * Reject a sharing authorization, i.e. if someone shared a portfolio/watchlist with the user,
 * the user can quit the sharing. This only works on items, that have the origin "shared".
 * @param type {String} can be "watchlist" or "portfolio"
 * @param sharableObjectId {String}
 */
var rejectAuthorization = function rejectAuthorization(type, sharableObjectId, origin) {
  if (origin !== 'own' && origin !== 'origin') {
    window.ngpConfirm(window.getMessage('share.dialog.reject.info'), {
      okHandler: function okHandler() {
        var url = "/".concat(type, ".action?method=handleRejectSharingAuthorization&id=").concat(sharableObjectId);
        var callback = {
          success: function success() {
            window.location.reload();
          },
          waitMask: true
        };
        window.ngpAsyncRequest('GET', url, callback);
      },
      okButtonText: window.getMessage('share.dialog.reject.button'),
      title: window.getMessage('share.dialog.reject.title')
    });
  }
};
var _default = exports.default = rejectAuthorization;

},{}],32:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * this function removes an instrument from a given watchlist by index and will use the
 * callback, when given.
 * @param instrumentIndex
 * @param watchlist
 * @param callback
 */
var removeInstrumentFromWatchlist = function removeInstrumentFromWatchlist(instrumentIndex) {
  window.instrumentAction(window.removeInstrumentPanel, 'removeInstrumentDiv', 'remove', [instrumentIndex]);
};
var _default = exports.default = removeInstrumentFromWatchlist;

},{}],33:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _showWatchlistInputPanel = _interopRequireDefault(require("contextMenu/helperFunctions/showWatchlistInputPanel"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*
 * Rename a watchlist.
 * @param wlName {String} name of the watchlist to rename
 * @param callback {Object}
 */
var renameWatchlist = function renameWatchlist(wlName, callback) {
  //get watchlist info
  var url = window.YAHOO.fcom.Util.addURLParam('/watchlist.action?method=handleGetWatchlistsJSON', 'wlNames', wlName);
  var callback1 = {
    success: function success(response) {
      var wl = JSON.parse(response.responseText);
      if (wl.length > 0) {
        wl = wl[0];
        (0, _showWatchlistInputPanel.default)(window.getMessage('portfolio.dialog.wl.rename.title'), {
          displayName: wl.displayName
        }, {
          fn: function fn(inputPanel) {
            //save the watchlist copy
            var map = {
              displayName: inputPanel.getFieldValues().displayName,
              name: wl.name
            };
            var url = '/watchlist.action?method=handleRenameWatchlist';
            var callback2 = {
              success: function success(response) {
                if (callback && callback.fn != null) {
                  callback.fn.call(callback.scope, response);
                  inputPanel.hide();
                } else {
                  window.location.reload();
                }
              },
              failure: function failure(response) {
                if (response.status === 409) {
                  inputPanel.showError(response.responseText, inputPanel.getInputField('displayName'));
                } else {
                  inputPanel.hide();
                  window.ngpAlert(window.getMessage('DEFAULT_AJAX_ERROR'));
                }
              },
              waitMask: true
            };
            window.ngpAsyncRequest('POST', url, callback2, window.YAHOO.fcom.Util.createPostData(map));
          }
        });
      }
    },
    waitMask: true
  };
  window.ngpAsyncRequest('POST', url, callback1);
};
window.renameWatchlist = renameWatchlist; // required from code that does not support imports
var _default = exports.default = renameWatchlist;

},{"contextMenu/helperFunctions/showWatchlistInputPanel":37}],34:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var showChainInTicker = function showChainInTicker(chainRic) {
  var postData = "&ric=".concat(chainRic);
  var callback = {
    success: function success() {
      window.ngpAlert(window.getMessage('context.menu.entry.txt.showChainInTicker.success'), {
        fixedcenter: true,
        onHide: function onHide() {
          window.location.reload();
        }
      });
    },
    failure: function failure() {
      window.ngpAlert(window.getMessage('context.menu.entry.txt.showChainInTicker.failure'), {
        fixedcenter: true
      });
    },
    argument: null
  };
  window.ngpAsyncRequest('POST', '/ajax.action?method=handleShowChainInPersonalTicker', callback, postData);
};
var _default = exports.default = showChainInTicker;

},{}],35:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var showChartInTimeSeries = function showChartInTimeSeries(ric, days, interval) {
  window.location.href = "timeseries.action?method=callTimeSeriesPage&ric=".concat(ric, "&days=").concat(days, "&interval=").concat(interval);
};
var _default = exports.default = showChartInTimeSeries;

},{}],36:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var showIndexInTicker = function showIndexInTicker(ric) {
  var postData = "&ric=".concat(ric);
  var callback = {
    success: function success() {
      window.ngpAlert(window.getMessage('context.menu.entry.txt.showIndexInTicker.success'), {
        fixedcenter: true,
        onHide: function onHide() {
          window.location.reload();
        }
      });
    },
    failure: function failure() {
      window.ngpAlert(window.getMessage('context.menu.entry.txt.showIndexInTicker.failure'), {
        fixedcenter: true
      });
    },
    argument: null
  };
  window.ngpAsyncRequest('POST', '/ajax.action?method=handleShowIndexInPersonalTicker', callback, postData);
};
var _default = exports.default = showIndexInTicker;

},{}],37:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * Shows a input panel for watchlists.
 * @param title {String} title of the panel
 * @param fieldInput {Object} containing the following properties:
 * <ul>
 *     <li>displayName {String} input for the display name field
 * </ul>
 * @param callback {Object} containing the properties <code>fn:Function</code> and <code>scope:Object</code>.
 *     The callback function will be called with the input panel as argument.
 */
var showWatchlistInputPanel = function showWatchlistInputPanel(title, fieldInput, callback) {
  var uniqueId = 'panel' + '_' + Math.random().toString(36).substr(2, 9) + '_OnId';
  fieldInput = fieldInput || {};
  window.YAHOO.fcom.panel.PanelFactory.openInputPanel({
    title: title || '',
    fields: [{
      //field config
      type: 'text',
      maxlength: '100',
      label: window.getMessage('portfolio.dialog.wl.create.label.name'),
      name: 'displayName',
      id: uniqueId,
      defaultValue: fieldInput.displayName || '',
      styles: [['width', '200px']],
      validateFn: function validateFn(inputField) {
        if (!window.YAHOO.fcom.Util.trim(inputField.value)) {
          return window.getMessage('portfolio.dialog.wl.error.id.empty');
        }
        return null;
      }
    }],
    saveHandler: function saveHandler(inputDialog) {
      //save the watchlist
      if (callback && callback.fn != null) {
        callback.fn.call(callback.scope, inputDialog);
      }
    }
  }, {
    //panel config
    close: true,
    width: '300px'
  });
};
var _default = exports.default = showWatchlistInputPanel;

},{}],38:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * configure the ticker to use the given watchlist or portfolio for display
 * @param id the uniwue identifier for the watchlist or the portfolio
 * @param type (string) "watchlist" or "portfolio", to denote of which type the id is.
 * @return nothing (void function)
 */
var showWatchlistPortfolioInTicker = function showWatchlistPortfolioInTicker(id, type) {
  var url;
  var postdata;
  if (type === 'portfolio') {
    url = '/portfolio.action';
    postdata = "method=handleAddToTicker&portfolioID=".concat(id);
  } else if (type === 'watchlist') {
    url = '/watchlist.action';
    postdata = "method=handleShowWatchlistInTicker&property1=".concat(id);
  }
  var callback = {
    success: function success() {
      window.ngpAlert(window.getMessage('context.menu.entry.txt.showWatchlistPortfolioInTicker.success'), {
        fixedcenter: true,
        onHide: function onHide() {
          window.location.reload();
        }
      });
    },
    waitMask: true
  };
  window.ngpAsyncRequest('POST', url, callback, postdata);
};
var _default = exports.default = showWatchlistPortfolioInTicker;

},{}],39:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * Opens a confirmation dialog to delete a transaction. Type must be given, as the message shown to
 * the user will be different.
 *
 * @param {String} type
 * @param {String} id
 * @param {Boolean} confirmation
 */
var transactionDelete = function transactionDelete(type, id, confirmation) {
  function sendRequest(transactionId) {
    var url = window.YAHOO.fcom.Util.addURLParam('/portfolio.action?method=handleTransactionDelete', 'transactionID', transactionId);
    window.ngpAsyncRequest('POST', url, {
      success: function success() {
        window.location.reload();
      },
      failure: function failure(response) {
        window.ngpAlert(response.responseText);
      }
    });
  }
  if (confirmation !== false) {
    var message = type === 'buy' ? window.getMessage('portfolio.dialog.js.transaction.confirm.deleteBuy') : window.getMessage('portfolio.dialog.js.transaction.confirm.delete');
    window.ngpConfirm(message, {
      title: window.getMessage('context.menu.entry.txt.transaction.delete'),
      okHandler: function okHandler() {
        sendRequest(id);
      },
      okButtonText: window.getMessage('txt.button.delete')
    });
  } else {
    sendRequest(id);
  }
};
var _default = exports.default = transactionDelete;

},{}],40:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * Show the transaction edit dialog.
 * @param {} transaction form bean
 */
var transactionEdit = function transactionEdit(transaction) {
  var type = transaction.transactionType.value;
  if (window.fcom.util.StringHelper.empty(type)) {
    type = 'plain';
  }
  if (type === 'split' || type === 'cash' || type === 'issue' || type === 'simple') {
    var panelConfig = {
      type: transaction.transactionType,
      id: "".concat(type, "TransactionPanel"),
      url: "portfolios/portfolios/panels/transactionPanel.plain?type=".concat(encodeURIComponent(type), "&op=edit")
    };
    window.YAHOO.lang.augmentObject(panelConfig, window.YAHOO.fcom.panel.AJAXPanel.TRANSACTION_NEW);
    window.YAHOO.fcom.panel.PanelFactory.getAJAXPanel(panelConfig, {
      fn: function fn( /*YAHOO.fcom.panel.TransactionPanel*/panel) {
        panel.setTransaction(transaction);
        panel.saveEvent.subscribe(function () {
          window.location.reload();
        });
        panel.show();
      }
    });
  } else if (type === 'buy' || type === 'sell') {
    window.YAHOO.fcom.panel.PanelFactory.getAJAXPanel(window.YAHOO.fcom.panel.AJAXPanel.TRANSACTION_META, {
      fn: function fn( /*YAHOO.fcom.panel.TransactionMetaPanel*/panel) {
        panel.setTransaction(transaction);
        panel.saveEvent.subscribe(function () {
          window.location.reload();
        });
        panel.show();
      }
    }, {
      type: type
    });
  }
};
var _default = exports.default = transactionEdit;

},{}],41:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _basicItems = _interopRequireDefault(require("contextMenu/registerItems/basicItems"));
var _watchlistPortfolioItems = _interopRequireDefault(require("contextMenu/registerItems/watchlistPortfolioItems"));
var _transactionItems = _interopRequireDefault(require("contextMenu/registerItems/transactionItems"));
var _instrumentItems = _interopRequireDefault(require("contextMenu/registerItems/instrumentItems"));
var _startPageItems = _interopRequireDefault(require("contextMenu/registerItems/startPageItems"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*
 * In this onDOMReady block all available context Menu entries should be defined. onDOMReady is
 * important, as some useful informations like the local dependent messages or user permissions are not
 * available before.
 *
 * The order in which the menu Items are instantiated will be the order they are presented.
 */
var registerItems = function registerItems() {
  (0, _basicItems.default)();
  (0, _watchlistPortfolioItems.default)();
  (0, _transactionItems.default)();
  (0, _instrumentItems.default)();
  (0, _startPageItems.default)();
};
var _default = exports.default = registerItems;

},{"contextMenu/registerItems/basicItems":42,"contextMenu/registerItems/instrumentItems":44,"contextMenu/registerItems/startPageItems":45,"contextMenu/registerItems/transactionItems":46,"contextMenu/registerItems/watchlistPortfolioItems":47}],42:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ContextMenuItem = _interopRequireDefault(require("contextMenu/ContextMenuItem"));
var _getMenuItem = _interopRequireDefault(require("contextMenu/registerItems/getMenuItem"));
var _contextMenuGroupsEnum = _interopRequireDefault(require("contextMenu/contextMenuGroupsEnum"));
var _columnConfigToPageSettings = _interopRequireDefault(require("contextMenu/helperFunctions/columnConfigToPageSettings"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var YAHOO = window.YAHOO;
var _default = exports.default = function _default() {
  var moduleContainer = YAHOO.fcom.Page.getInstance('moduleContainer');

  /* menu entry to edit a module content */
  var editModule = new _ContextMenuItem.default('editModule', _contextMenuGroupsEnum.default.MODULE_ACTIONS);
  editModule.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.editModule', function () {
    YAHOO.fcom.modules.Tools.editModuleDialog(YAHOO.fcom.Context.configObject.module, YAHOO.fcom.Context.configObject.configWidth ? {
      width: YAHOO.fcom.Context.configObject.configWidth
    } : null);
  });

  // TODO : Need to simplify this logic after investigating
  editModule.isNeeded = function (objectConfig) {
    return !objectConfig.editDisabled && objectConfig.module != null && moduleContainer != null && (moduleContainer.isModuleEditable(objectConfig.module) && (moduleContainer.getEditAllowed() || window.user.isViewsModify) || objectConfig.whitelist && $.inArray('editModule', objectConfig.whitelist) > -1);
  };

  /* menu entry to show a tutorial */
  var showTutorial = new _ContextMenuItem.default('showTutorial', _contextMenuGroupsEnum.default.MODULE_ACTIONS);
  showTutorial.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.showTutorial', function () {
    window.redirectTo(YAHOO.fcom.Context.configObject.tutorialURL);
  });
  showTutorial.isNeeded = function (objectConfig) {
    return objectConfig.module != null && moduleContainer != null && !YAHOO.lang.isUndefined(objectConfig.tutorialURL);
  };

  /* menu entry to remove a module from a view */
  var removeModule = new _ContextMenuItem.default('removeModule', _contextMenuGroupsEnum.default.MODULE_ACTIONS);
  removeModule.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.removeModule', function () {
    if (moduleContainer) {
      moduleContainer.removeModuleFromView(YAHOO.fcom.Context.configObject.module, true);
    }
  });
  removeModule.isNeeded = function (objectConfig) {
    return objectConfig.module != null && moduleContainer != null && moduleContainer.config.dragDropEnabled && (moduleContainer.getEditAllowed() || window.user.isViewsModify);
  };

  /* menu entry to edit a module content */
  var editColumns = new _ContextMenuItem.default('editColumns', _contextMenuGroupsEnum.default.MODULE_ACTIONS);
  editColumns.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.editColumns', function () {
    YAHOO.fcom.modules.Tools.editColumnDialog(YAHOO.fcom.Context.configObject.module, {
      doReload: true
    });
  });
  editColumns.isNeeded = function (objectConfig) {
    return objectConfig.module != null && moduleContainer != null && (moduleContainer.isModuleEditable(objectConfig.module) && (moduleContainer.getEditAllowed() || window.user.isViewsModify) || objectConfig.whitelist && $.inArray('editColumns', objectConfig.whitelist) > -1) && objectConfig.columndialog;
  };

  /* menu entry to edit a configure columns */
  var editColumnConfig = new _ContextMenuItem.default('editColumnConfig', _contextMenuGroupsEnum.default.MODULE_ACTIONS);
  editColumnConfig.menuItem = (0, _getMenuItem.default)('portfolio.table.button.fidletConfig', function () {
    YAHOO.fcom.modules.Tools.editColumnConfigDialog(YAHOO.fcom.Context.configObject.module, YAHOO.fcom.Context.configObject.configWidth ? {
      width: YAHOO.fcom.Context.configObject.configWidth
    } : null);
  });
  editColumnConfig.isNeeded = function (objectConfig) {
    return objectConfig.module != null && moduleContainer != null && (moduleContainer.isModuleEditable(objectConfig.module) && (moduleContainer.getEditAllowed() || window.user.isViewsModify) || objectConfig.whitelist && $.inArray('editColumnConfig', objectConfig.whitelist) > -1) && objectConfig.configdialog;
  };
  var editColumnsMaximized = new _ContextMenuItem.default('editColumnsMaximized', _contextMenuGroupsEnum.default.MODULE_ACTIONS);
  editColumnsMaximized.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.editColumnsMaximized', function () {
    YAHOO.fcom.modules.Tools.editColumnDialog(YAHOO.fcom.Context.configObject.module, {
      doReload: true,
      maximized: true
    });
  });
  editColumnsMaximized.isNeeded = function (objectConfig) {
    return objectConfig.module != null && moduleContainer != null && moduleContainer.isModuleEditable(objectConfig.module) && (moduleContainer.getEditAllowed() || window.user.isViewsModify) && objectConfig.maximizedcolumndialog;
  };

  /* menu entry to edit a module content */
  var editColumnsPageSettings = new _ContextMenuItem.default('editColumnsPageSettings', _contextMenuGroupsEnum.default.MODULE_ACTIONS);
  editColumnsPageSettings.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.editColumns', function () {
    (0, _columnConfigToPageSettings.default)(YAHOO.fcom.Context.configObject.module, YAHOO.fcom.Context.configObject.columnsPageSettingsId);
  });
  //columns are only saved to page settings if user cannot change module configuration
  editColumnsPageSettings.isNeeded = function (objectConfig) {
    return objectConfig.module != null && objectConfig.columnsPageSettingsId != null && !(moduleContainer.getEditAllowed() || window.user.isViewsModify);
  };
};

},{"contextMenu/ContextMenuItem":12,"contextMenu/contextMenuGroupsEnum":13,"contextMenu/helperFunctions/columnConfigToPageSettings":17,"contextMenu/registerItems/getMenuItem":43}],43:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// helper function to create menu items for registration calls in a simplified way
var getMenuItem = function getMenuItem(messageKey, clickFn) {
  return {
    text: window.getMessage(messageKey),
    onclick: {
      fn: clickFn
    }
  };
};
var _default = exports.default = getMenuItem;

},{}],44:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ContextMenuItem = _interopRequireDefault(require("contextMenu/ContextMenuItem"));
var _getMenuItem = _interopRequireDefault(require("contextMenu/registerItems/getMenuItem"));
var _contextMenuGroupsEnum = _interopRequireDefault(require("contextMenu/contextMenuGroupsEnum"));
var _Comparison = require("core/Comparison");
var _addInstrumentToPortfolio = _interopRequireDefault(require("contextMenu/helperFunctions/addInstrumentToPortfolio"));
var _addInstrumentToUserWatchlist = _interopRequireDefault(require("contextMenu/helperFunctions/addInstrumentToUserWatchlist"));
var _addInstrumentListToUserWatchlist = _interopRequireDefault(require("contextMenu/helperFunctions/addInstrumentListToUserWatchlist"));
var _compareChainConstituents = _interopRequireDefault(require("contextMenu/helperFunctions/compareChainConstituents"));
var _compareIndexConstituents = _interopRequireDefault(require("contextMenu/helperFunctions/compareIndexConstituents"));
var _duplicateAlert = _interopRequireDefault(require("contextMenu/helperFunctions/duplicateAlert"));
var _removeInstrumentFromWatchlist = _interopRequireDefault(require("contextMenu/helperFunctions/removeInstrumentFromWatchlist"));
var _showChainInTicker = _interopRequireDefault(require("contextMenu/helperFunctions/showChainInTicker"));
var _showIndexInTicker = _interopRequireDefault(require("contextMenu/helperFunctions/showIndexInTicker"));
var _showChartInTimeSeries = _interopRequireDefault(require("contextMenu/helperFunctions/showChartInTimeSeries"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var YAHOO = window.YAHOO;
var showResponseAsAlert = function showResponseAsAlert(_ref) {
  var responseText = _ref.responseText;
  return window.ngpAlert(responseText, {
    fixedcenter: true
  });
};
var _default = exports.default = function _default() {
  /* menu entry to remove an instrument from the given watchlist */
  var removeFromWatchlist = new _ContextMenuItem.default('removeFromWatchlist', _contextMenuGroupsEnum.default.WATCHLIST_PORTFOLIO_ACTIONS);
  removeFromWatchlist.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.removeFromWatchlist', function () {
    var callback = {
      success: function success() {
        window.location.reload();
      },
      failure: function failure() {
        window.ngpAlert(window.getMessage('portfolio.dialog.wl.instrument.remove.error'));
      },
      argument: null
    };
    (0, _removeInstrumentFromWatchlist.default)(YAHOO.fcom.Context.configObject.instrumentIndex, YAHOO.fcom.Context.configObject.watchlist, callback);
  });
  removeFromWatchlist.isNeeded = function (objectConfig) {
    return !YAHOO.lang.isUndefined(objectConfig.instrumentIndex) && !YAHOO.lang.isUndefined(objectConfig.watchlist) && !YAHOO.lang.isUndefined(objectConfig.origin) && objectConfig.origin === 'own' && (!window.listForComparison || objectConfig.watchlist === 'instrument_comparison') // not on comparison page, except when it is the comparison list
    ;
  };

  /* menu entry to add an instrument to a portfolio or a watchlist. It is only shown when the user has at least
   * permission for one of the tools and if the context item is an instrument (ric needed)
   * The list of available portfolios and/or watchlists is fetched on demand through an ajax call.
   * This menu here is a good entry point when trying to implement new context menu entries with ajax
   * fetched submenus.
   */
  var addToPortfolioOrWatchlist = new _ContextMenuItem.default('addToPortfolioOrWatchlist', _contextMenuGroupsEnum.default.INSTRUMENT_ACTIONS);
  var addToPortfolioOrWatchlistSubMenu = new YAHOO.widget.Menu('addToPortfolioOrWatchlistContextMenu', {
    hidedelay: 1500,
    position: 'dynamic'
  });
  addToPortfolioOrWatchlistSubMenu.beforeShowEvent.subscribe(function (type, args, menuObject) {
    if (!menuObject.getItems() || menuObject.getItems().length < 1) {
      /* only if not yet loaded */
      var callback = {
        success: function success(o) {
          var portfoliosAndWatchlists = JSON.parse(o.responseText);
          var groupId = 0;
          /* -------> watchlists */
          if (window.user.isToolsWatchlists) {
            o.argument[0].addItem({
              text: "<b>".concat(window.getMessage('context.menu.entry.header.addToWatchlist'), "</b>"),
              disabled: true
            }, groupId);
            o.argument[0].addItem({
              // item to create a new watchlist and add the instrument to it
              text: window.getMessage('portfolio.dialog.wl.create.title'),
              onclick: {
                fn: function fn(evntType, evntArg, obj) {
                  // create the new watchlist and add it to the context menu
                  var callback = {
                    success: function success(response) {
                      var wl = JSON.parse(response.responseText);
                      var encodedWatchlistName = window.fcom.util.StringHelper.escapeHTML(wl.displayName);

                      // add the new watchlist to the context menu
                      obj.menu.addItem({
                        text: encodedWatchlistName,
                        onclick: {
                          fn: function fn(evntType, evntArg, wl) {
                            (0, _addInstrumentToUserWatchlist.default)(YAHOO.fcom.Context.configObject.ric, wl);
                          },
                          obj: wl.name
                        }
                      }, obj.groupId);
                      // add instrument
                      (0, _addInstrumentToUserWatchlist.default)(YAHOO.fcom.Context.configObject.ric, wl.name);
                    }
                  };
                  window.createWatchlist(null, callback);
                },
                obj: {
                  menu: menuObject,
                  groupId: groupId
                }
              }
            }, groupId);
            if (portfoliosAndWatchlists.watchlists && portfoliosAndWatchlists.watchlists.length > 0) {
              for (var i = 0; i < portfoliosAndWatchlists.watchlists.length; i++) {
                o.argument[0].addItem({
                  text: portfoliosAndWatchlists.watchlists[i].text,
                  onclick: {
                    fn: function fn(evntType, evntArg, wl) {
                      (0, _addInstrumentToUserWatchlist.default)(YAHOO.fcom.Context.configObject.ric, wl);
                    },
                    obj: portfoliosAndWatchlists.watchlists[i].value
                  }
                }, groupId);
              }
            }
          }
          groupId++;
          /* ---------> portfolios */
          if (window.user.isToolsPortfolio) {
            o.argument[0].addItem({
              text: "<b>".concat(window.getMessage('context.menu.entry.header.addToPortfolio'), "</b>"),
              disabled: true
            }, groupId);
            o.argument[0].addItem({
              // item to create a new portfolio and add the instrument to it
              text: window.getMessage('portfolio.dialog.addPortfolio.title'),
              onclick: {
                fn: function fn(evntType, evntArg, obj) {
                  var callback = function callback(portfolio, obj) {
                    var pf = {
                      value: portfolio.id,
                      text: portfolio.name,
                      currency: portfolio.currency
                    };
                    var encodedPfName = window.fcom.util.StringHelper.escapeHTML(pf.text);

                    // add the new portfolio to the context menu
                    obj.menu.addItem({
                      text: encodedPfName,
                      onclick: {
                        fn: function fn(evntType, evntArg, pf) {
                          (0, _addInstrumentToPortfolio.default)(YAHOO.fcom.Context.configObject.ric, pf);
                        },
                        obj: pf
                      }
                    }, obj.groupId);
                    // add instrument
                    (0, _addInstrumentToPortfolio.default)(YAHOO.fcom.Context.configObject.ric, pf);
                  };
                  window.createPortfolio(callback, obj);
                },
                obj: {
                  menu: menuObject,
                  groupId: groupId
                }
              }
            }, groupId);
            if (portfoliosAndWatchlists.portfolios && portfoliosAndWatchlists.portfolios.length > 0) {
              for (var _i = 0; _i < portfoliosAndWatchlists.portfolios.length; _i++) {
                o.argument[0].addItem({
                  text: portfoliosAndWatchlists.portfolios[_i].text,
                  onclick: {
                    fn: function fn(eventType, evntArg, pf) {
                      var instrument = YAHOO.fcom.Context.configObject.ric || YAHOO.fcom.Context.configObject.isin;
                      (0, _addInstrumentToPortfolio.default)(instrument, pf);
                    },
                    obj: portfoliosAndWatchlists.portfolios[_i]
                  }
                }, groupId);
              }
            }
          }
          o.argument[0].render(o.argument[0].parent.element);
          /* bad hack to work around a YUI problem, aligning the menu wrong the first time */
          window.Dom.setStyle(o.argument[0].element, 'visibility', 'hidden');
          YAHOO.lang.later(10, o.argument[0], function (menu) {
            menu.hide();
            menu.show();
            window.Dom.setStyle(o.argument[0].element, 'visibility', 'visible');
          }, o.argument[0], false);
        },
        failure: function failure() {
          console.warn('Loading of watchlists/portfolios failed for context menu.');
          window.ngpAlert(window.getMessage('context.menu.error.loadPortfolioWatchlistFailed'));
        },
        argument: [menuObject]
      };
      window.ngpAsyncRequest('GET', '/ajax.action?method=getUserWatchlistsAndPortfolios', callback);
    }
  }, addToPortfolioOrWatchlistSubMenu, true);
  addToPortfolioOrWatchlist.menuItem = {
    text: ' ',
    submenu: addToPortfolioOrWatchlistSubMenu
  };
  if (window.user.isToolsPortfolio && window.user.isToolsWatchlists) {
    addToPortfolioOrWatchlist.menuItem.text = window.getMessage('context.menu.entry.txt.addToWatchlistPortfolio');
  } else if (window.user.isToolsPortfolio) {
    addToPortfolioOrWatchlist.menuItem.text = window.getMessage('context.menu.entry.txt.addToPortfolio');
  } else if (window.user.isToolsWatchlists) {
    addToPortfolioOrWatchlist.menuItem.text = window.getMessage('context.menu.entry.txt.addToWatchlist');
  }
  addToPortfolioOrWatchlist.isNeeded = function (objectConfig) {
    return objectConfig.ric && (window.user.isToolsPortfolio || window.user.isToolsWatchlists);
  };

  /*
   * menu entry to add an instrument list to a watchlist.
   * The list of available portfolios and/or watchlists is fetched on demand through an ajax call.
   */
  var addSelectionToWatchlist = new _ContextMenuItem.default('addSelectionToWatchlist', _contextMenuGroupsEnum.default.INSTRUMENT_ACTIONS);
  var addSelectionToWatchlistSubMenu = new YAHOO.widget.Menu('addSelectionToWatchlistContextMenu', {
    hidedelay: 1500,
    position: 'dynamic'
  });
  addSelectionToWatchlistSubMenu.beforeShowEvent.subscribe(function (type, args, menuObject) {
    if (!menuObject.getItems() || menuObject.getItems().length < 1) {
      /* only if not yet loaded */
      var addItemsToWatchList = function addItemsToWatchList(watchlistId) {
        return (0, _addInstrumentListToUserWatchlist.default)(YAHOO.fcom.Context.configObject.instrumentListMethod(), watchlistId, {
          success: showResponseAsAlert,
          failure: showResponseAsAlert,
          waitMask: true
        });
      };
      var callback = {
        success: function success(_ref2) {
          var responseText = _ref2.responseText,
            _ref2$argument = _slicedToArray(_ref2.argument, 1),
            watchlistMenu = _ref2$argument[0];
          var portfoliosAndWatchlists = JSON.parse(responseText);
          var groupId = 0;
          watchlistMenu.addItem({
            text: "<b>".concat(window.getMessage('context.menu.entry.header.addToWatchlist'), "</b>"),
            disabled: true
          }, groupId);
          watchlistMenu.addItem({
            // item to create a new watchlist and add the instrument to it
            text: window.getMessage('portfolio.dialog.wl.create.title'),
            onclick: {
              fn: function fn(evntType, evntArg, obj) {
                // create the new watchlist and add it to the context menu
                var callback = {
                  success: function success(response) {
                    var wl = JSON.parse(response.responseText);
                    var encodedWatchlistName = window.fcom.util.StringHelper.escapeHTML(wl.displayName);

                    // add the new watchlist to the context menu
                    obj.menu.addItem({
                      text: encodedWatchlistName,
                      onclick: {
                        fn: function fn(evntType, evntArg, wl) {
                          addItemsToWatchList(wl);
                        },
                        obj: wl.name
                      }
                    }, obj.groupId);
                    // add instrument
                    addItemsToWatchList(wl.name);
                  }
                };
                window.createWatchlist(null, callback);
              },
              obj: {
                menu: menuObject,
                groupId: groupId
              }
            }
          }, groupId);
          if (portfoliosAndWatchlists.watchlists && portfoliosAndWatchlists.watchlists.length > 0) {
            portfoliosAndWatchlists.watchlists.forEach(function (watchlist) {
              watchlistMenu.addItem({
                text: watchlist.text,
                onclick: {
                  fn: function fn(evntType, evntArg, wl) {
                    addItemsToWatchList(wl);
                  },
                  obj: watchlist.value
                }
              }, groupId);
            });
          }
          groupId++;
          watchlistMenu.render(watchlistMenu.parent.element);
          // bad hack to work around a YUI problem, aligning the menu wrong the first time
          window.Dom.setStyle(watchlistMenu.element, 'visibility', 'hidden');
          YAHOO.lang.later(10, watchlistMenu, function (menu) {
            menu.hide();
            menu.show();
            window.Dom.setStyle(watchlistMenu.element, 'visibility', 'visible');
          }, watchlistMenu, false);
        },
        failure: function failure() {
          console.warn('Loading of watchlists/portfolios failed for context menu.');
          window.ngpAlert(window.getMessage('context.menu.error.loadPortfolioWatchlistFailed'));
        },
        argument: [menuObject]
      };
      window.ngpAsyncRequest('GET', '/ajax.action?method=getUserWatchlistsAndPortfolios', callback);
    }
  }, addSelectionToWatchlistSubMenu, true);
  addSelectionToWatchlist.menuItem = {
    text: window.getMessage('context.menu.entry.txt.addSelectionToWatchlist'),
    submenu: addSelectionToWatchlistSubMenu
  };
  addSelectionToWatchlist.isNeeded = function (objectConfig) {
    return window.user.isToolsWatchlists && objectConfig.instrumentListMethod;
  };

  /* menu entry to add an instrument to the comparison */
  var addToComparison = new _ContextMenuItem.default('addToComparison', _contextMenuGroupsEnum.default.INSTRUMENT_ACTIONS);
  addToComparison.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.addToComparison', function () {
    var attr = {};
    if (!YAHOO.lang.isUndefined(YAHOO.fcom.Context.configObject.ric)) {
      attr.ric = YAHOO.fcom.Context.configObject.ric;
    }
    if (!YAHOO.lang.isUndefined(YAHOO.fcom.Context.configObject.isin)) {
      attr.isin = YAHOO.fcom.Context.configObject.isin;
    }
    window.addInstrumentToComparison(attr);
  });
  addToComparison.isNeeded = function (objectConfig) {
    return window.user.isComparisonEnabled && !window.listForComparison &&
    // not on comparison page
    objectConfig.watchlist !== 'instrument_comparison' && (!YAHOO.lang.isUndefined(objectConfig.ric) || !YAHOO.lang.isUndefined(objectConfig.isin));
  };
  var addIndexToComparison = new _ContextMenuItem.default('addIndexToComparison', _contextMenuGroupsEnum.default.INSTRUMENT_ACTIONS);
  addIndexToComparison.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.addIndexToComparison', function () {
    var attr = {};
    if (!YAHOO.lang.isUndefined(YAHOO.fcom.Context.configObject.ric)) {
      attr.ric = YAHOO.fcom.Context.configObject.ric;
      (0, _compareIndexConstituents.default)(attr.ric);
    }
  });
  addIndexToComparison.isNeeded = function (objectConfig) {
    return window.user.isComparisonEnabled && !window.listForComparison &&
    // not on comparison page
    objectConfig.secType === 'IND' && objectConfig.ric != null;
  };
  var addSelectionToComparison = new _ContextMenuItem.default('addSelectionToComparison', _contextMenuGroupsEnum.default.INSTRUMENT_ACTIONS);
  addSelectionToComparison.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.addSelectionToComparison', function () {
    var callback = {
      success: showResponseAsAlert,
      failure: showResponseAsAlert,
      waitMask: true
    };
    (0, _Comparison.addInstrumentListToComparison)(YAHOO.fcom.Context.configObject.instrumentListMethod().map(function (ric) {
      return {
        ric: ric
      };
    }), callback);
  });
  addSelectionToComparison.isNeeded = function (objectConfig) {
    return window.user.isComparisonEnabled && !window.listForComparison &&
    // not on comparison page
    objectConfig.instrumentListMethod;
  };
  var addChainToComparison = new _ContextMenuItem.default('addChainToComparison', _contextMenuGroupsEnum.default.INSTRUMENT_ACTIONS);
  addChainToComparison.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.addChainToComparison', function () {
    var attr = {};
    if (!YAHOO.lang.isUndefined(YAHOO.fcom.Context.configObject.chainRic)) {
      attr.chainRic = YAHOO.fcom.Context.configObject.chainRic;
      (0, _compareChainConstituents.default)(attr.chainRic);
    }
  });
  addChainToComparison.isNeeded = function (objectConfig) {
    return !YAHOO.lang.isUndefined(objectConfig.chainRic);
  };

  /* menu entry to place an alert for an instrument */
  var addToAlerts = new _ContextMenuItem.default('addToAlerts', _contextMenuGroupsEnum.default.INSTRUMENT_ACTIONS);
  addToAlerts.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.addToAlerts', function () {
    var instrument = YAHOO.fcom.Context.configObject.ric || YAHOO.fcom.Context.configObject.isin;
    if (instrument) {
      YAHOO.fcom.panel.PanelFactory.getAJAXPanel(YAHOO.fcom.panel.AJAXPanel.ADD_ALERT_FIXED_PANEL, {
        fn: function fn(panel) {
          panel.setInstrument(instrument);
          if (YAHOO.fcom.Context.configObject.position && YAHOO.fcom.Context.configObject.position.historic !== true) {
            panel.setPosition(YAHOO.fcom.Context.configObject.portfolio, YAHOO.fcom.Context.configObject.position.id);
          }
          panel.saveEvent.subscribe(function () {
            panel.hide();
            window.ngpAlert(window.getMessage('alert.dialog.js.success'));
          });
          panel.show();
        }
      });
    }
  });
  addToAlerts.isNeeded = function (objectConfig) {
    return window.user.isToolsAlerts && !YAHOO.lang.isUndefined(objectConfig.ric) && objectConfig.ric.length > 0 || !YAHOO.lang.isUndefined(objectConfig.isin) && objectConfig.isin.length > 0;
  };

  /* Show the alerts for an item. This item depends heavily on the current page.
   * For example on a portfolio detail page, the alerts are shown right below.
   * Therefore the menu item will only fire a page event. The page must then implement a listener. */
  var showAlerts = new _ContextMenuItem.default('showAlerts', _contextMenuGroupsEnum.default.INSTRUMENT_ACTIONS);
  showAlerts.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.showAlerts', function () {
    YAHOO.fcom.Page.fire('showAlertsForPosition', [YAHOO.fcom.Context.configObject.position.id]);
  });
  showAlerts.isNeeded = function (objectConfig) {
    // only on portfolio detail pages when inside a list of current positions.
    return window.user.isToolsAlerts && objectConfig.position != null && objectConfig.position.historic !== true;
  };

  /* menu item to duplicate an alert */
  var editAlertItem = new _ContextMenuItem.default('editAlertItem', _contextMenuGroupsEnum.default.ALERT_ACTIONS);
  editAlertItem.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.editAlert', function () {
    YAHOO.fcom.panel.PanelFactory.getAJAXPanel(YAHOO.fcom.panel.AJAXPanel.EDIT_ALERT_PANEL, {
      fn: function fn( /* YAHOO.fcom.panel.AlertPanel */panel) {
        var portfolio = YAHOO.fcom.Context.configObject.portfolio;
        var position = YAHOO.fcom.Context.configObject.position;
        if (window.ngpIsType('String', portfolio) && position != null) {
          panel.setPosition(portfolio, position.id);
        }
        panel.saveEvent.subscribe(function () {
          panel.hide();
          YAHOO.fcom.Page.fire('alertChanged', 'edit');
        });
        panel.show();
      }
    }, {
      triggerID: YAHOO.fcom.Context.configObject.alert
    });
  });
  editAlertItem.isNeeded = function (objectConfig) {
    return !window.fcom.util.StringHelper.empty(objectConfig.alert);
  };

  /* menu item to delete an alert */
  var deleteAlertItem = new _ContextMenuItem.default('deleteAlertItem', _contextMenuGroupsEnum.default.ALERT_ACTIONS);
  deleteAlertItem.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.deleteAlert', function () {
    window.deleteAlert(YAHOO.fcom.Context.configObject.alert);
  });
  deleteAlertItem.isNeeded = function (objectConfig) {
    return !window.fcom.util.StringHelper.empty(objectConfig.alert);
  };

  /* menu item to duplicate an alert */
  var duplicateAlertItem = new _ContextMenuItem.default('duplicateAlertItem', _contextMenuGroupsEnum.default.ALERT_ACTIONS);
  duplicateAlertItem.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.duplicateAlert', function () {
    (0, _duplicateAlert.default)(YAHOO.fcom.Context.configObject.alert);
  });
  duplicateAlertItem.isNeeded = function (objectConfig) {
    return !window.fcom.util.StringHelper.empty(objectConfig.alert);
  };

  /*
   * menu entry to see related instruments for a given instrument. Links to the according detail page
   */
  var relatedInstruments = new _ContextMenuItem.default('relatedInstruments', _contextMenuGroupsEnum.default.INSTRUMENT_ACTIONS);
  relatedInstruments.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.relatedInstruments', function () {
    var ric = YAHOO.fcom.Context.configObject.ric;
    var isin = YAHOO.fcom.Context.configObject.isin;
    var url = '/detail/detailPage.html?subPage=related';
    if (!window.fcom.util.StringHelper.empty(ric)) {
      url = YAHOO.fcom.Util.addURLParam(url, 'ric', ric);
    } else if (!window.fcom.util.StringHelper.empty(isin)) {
      url = YAHOO.fcom.Util.addURLParam(url, 'isin', isin);
    }
    window.redirectTo(url);
  });
  relatedInstruments.isNeeded = function (objectConfig) {
    return (!YAHOO.lang.isUndefined(objectConfig.ric) && objectConfig.ric.length > 0 || !YAHOO.lang.isUndefined(objectConfig.isin) && objectConfig.isin.length > 0) && window.user.isInstrumentsSimilar && !window.fcom.util.StringHelper.empty(objectConfig.secType) && ['STO', 'IND', 'BON', 'BO1', 'CUR', 'CU1'].indexOf(objectConfig.secType) > -1;
  };
  var similarWarrants = new _ContextMenuItem.default('similarWarrants', _contextMenuGroupsEnum.default.INSTRUMENT_ACTIONS);
  similarWarrants.menuItem = {
    text: window.getMessage('page.functions.title.similarWarrants'),
    onclick: {
      fn: function fn(eventType, eventObject, baseUrl) {
        window.redirectTo(baseUrl + encodeURIComponent(YAHOO.fcom.Context.configObject.ric));
      },
      obj: '/screener.html?secTypeGroup=WARRANT&method=similarWarrants&ric='
    }
  };
  similarWarrants.isNeeded = function (objectConfig) {
    return !YAHOO.lang.isUndefined(objectConfig.ric) && objectConfig.ric.length > 0 && !YAHOO.lang.isUndefined(objectConfig.secType) && objectConfig.secType.indexOf('WA') === 0 && window.user.isInstrumentsSimilar;
  };

  /* menu entry to show current timeseries of chartmodule */
  var showTimeSeries = new _ContextMenuItem.default('showTimeSeries', _contextMenuGroupsEnum.default.INSTRUMENT_ACTIONS);
  showTimeSeries.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.showTimeSeries', function () {
    (0, _showChartInTimeSeries.default)(YAHOO.fcom.Context.configObject.ric, YAHOO.fcom.Context.configObject.days, YAHOO.fcom.Context.configObject.interval);
  });
  showTimeSeries.isNeeded = function (objectConfig) {
    return !YAHOO.lang.isUndefined(objectConfig.ric) && !YAHOO.lang.isUndefined(objectConfig.module) && objectConfig.module.indexOf('ChartModule') > -1 && window.themeProperties['detailpage.timeseries'] === true;
  };

  /* menu entry to add an index to the ticker display */
  var indexToTicker = new _ContextMenuItem.default('indexToTicker', _contextMenuGroupsEnum.default.INSTRUMENT_ACTIONS);
  indexToTicker.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.showIndexInTicker', function () {
    (0, _showIndexInTicker.default)(YAHOO.fcom.Context.configObject.ric);
  });
  indexToTicker.isNeeded = function (objectConfig) {
    return !YAHOO.lang.isUndefined(objectConfig.ric) && !YAHOO.lang.isUndefined(objectConfig.secType) && objectConfig.secType === 'IND' && window.user.isTickerAvailable;
  };

  /* menu entry to add an chain to the ticker display */
  var chainToTicker = new _ContextMenuItem.default('chainToTicker', _contextMenuGroupsEnum.default.INSTRUMENT_ACTIONS);
  chainToTicker.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.showIndexInTicker', function () {
    (0, _showChainInTicker.default)(YAHOO.fcom.Context.configObject.chainRic);
  });
  chainToTicker.isNeeded = function (objectConfig) {
    return !YAHOO.lang.isUndefined(objectConfig.chainRic) && window.user.isTickerAvailable;
  };
};

},{"contextMenu/ContextMenuItem":12,"contextMenu/contextMenuGroupsEnum":13,"contextMenu/helperFunctions/addInstrumentListToUserWatchlist":14,"contextMenu/helperFunctions/addInstrumentToPortfolio":15,"contextMenu/helperFunctions/addInstrumentToUserWatchlist":16,"contextMenu/helperFunctions/compareChainConstituents":18,"contextMenu/helperFunctions/compareIndexConstituents":19,"contextMenu/helperFunctions/duplicateAlert":22,"contextMenu/helperFunctions/removeInstrumentFromWatchlist":32,"contextMenu/helperFunctions/showChainInTicker":34,"contextMenu/helperFunctions/showChartInTimeSeries":35,"contextMenu/helperFunctions/showIndexInTicker":36,"contextMenu/registerItems/getMenuItem":43,"core/Comparison":53}],45:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ContextMenuItem = _interopRequireDefault(require("contextMenu/ContextMenuItem"));
var _getMenuItem = _interopRequireDefault(require("contextMenu/registerItems/getMenuItem"));
var _contextMenuGroupsEnum = _interopRequireDefault(require("contextMenu/contextMenuGroupsEnum"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var YAHOO = window.YAHOO;
var _default = exports.default = function _default() {
  /* menu entry to set current page as startpage */
  var setAsStartPageItem = new _ContextMenuItem.default('setAsStartPageItem', _contextMenuGroupsEnum.default.WATCHLIST_PORTFOLIO_ACTIONS);
  setAsStartPageItem.menuItem = (0, _getMenuItem.default)('context.menu.page.changeStartPage.title', function () {
    var href = window.location.href;
    var postdata = 'url=';
    if (!YAHOO.lang.isUndefined(YAHOO.fcom.Context.configObject.portfolio) && href.indexOf('pfid=') < 0) {
      // portfolio set as start page from somewhere else, not the portfolio page
      postdata += encodeURIComponent("/portfolios/portfolios/portfolio.html?pfid=".concat(YAHOO.fcom.Context.configObject.portfolio));
    } else if (!YAHOO.lang.isUndefined(YAHOO.fcom.Context.configObject.watchlist) && href.indexOf('detail.html?id=') < 0) {
      // watchlist set as start page from somewhere else, not the watchlist page
      postdata += encodeURIComponent("/portfolios/watchlists/detail.html?id=".concat(YAHOO.fcom.Context.configObject.watchlist));
    } else if (href.indexOf('/portfolios/') > -1) {
      postdata += encodeURIComponent(href.substring(href.indexOf('/portfolios/')));
    }
    var callback = {
      success: function success(responseObj) {
        window.ngpAlert(responseObj.responseText, {
          fixedcenter: true,
          onHide: function onHide() {
            window.location.reload();
          }
        });
      },
      waitMask: true
    };
    window.ngpAsyncRequest('POST', '/ajax.action?method=setAsStartPage', callback, postdata);
  });
  setAsStartPageItem.isNeeded = function (objectConfig) {
    var href = window.location.href;
    return window.user.isSetStartpageEnabled && (href.indexOf('/portfolios/portfolios/overview.html') > -1 || href.indexOf('/portfolios/watchlists/overview.html') > -1 || href.indexOf('/portfolios/watchlists/detail.html') > -1 && !YAHOO.lang.isUndefined(objectConfig.watchlist) || href.indexOf('/portfolios/portfolios/portfolio.html') > -1 && !YAHOO.lang.isUndefined(objectConfig.portfolio));
  };
};

},{"contextMenu/ContextMenuItem":12,"contextMenu/contextMenuGroupsEnum":13,"contextMenu/registerItems/getMenuItem":43}],46:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ContextMenuItem = _interopRequireDefault(require("contextMenu/ContextMenuItem"));
var _getMenuItem = _interopRequireDefault(require("contextMenu/registerItems/getMenuItem"));
var _contextMenuGroupsEnum = _interopRequireDefault(require("contextMenu/contextMenuGroupsEnum"));
var _portfolioPositionEdit = _interopRequireDefault(require("contextMenu/helperFunctions/portfolioPositionEdit"));
var _portfolioPositionEditHistoric = _interopRequireDefault(require("contextMenu/helperFunctions/portfolioPositionEditHistoric"));
var _transactionDelete = _interopRequireDefault(require("contextMenu/helperFunctions/transactionDelete"));
var _transactionEdit = _interopRequireDefault(require("contextMenu/helperFunctions/transactionEdit"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var YAHOO = window.YAHOO;
var _default = exports.default = function _default() {
  /* create new payout transaction */
  var transactionNewPayoutItem = new _ContextMenuItem.default('transactionNewPayoutItem', _contextMenuGroupsEnum.default.TRANSACTION_ACTIONS);
  transactionNewPayoutItem.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.transaction.payout.new', function () {
    var panelConfig = {
      id: 'newPayoutPanel',
      url: 'portfolios/portfolios/panels/transactionPanel.plain?op=new'
    };
    var transaction = YAHOO.fcom.Context.configObject.transaction;
    var position = YAHOO.fcom.Context.configObject.position;
    YAHOO.lang.augmentObject(panelConfig, YAHOO.fcom.panel.AJAXPanel.TRANSACTION_NEW);
    YAHOO.fcom.panel.PanelFactory.getAJAXPanel(panelConfig, {
      fn: function fn(panel) {
        if (transaction) {
          panel.fromTransaction(transaction);
        } else if (position) {
          panel.fromPosition(position, YAHOO.fcom.Context.configObject.portfolio, YAHOO.fcom.Context.configObject.portfolioName);
        }
        panel.saveEvent.subscribe(function () {
          window.location.reload();
        });
        panel.show();
      }
    });
  });
  transactionNewPayoutItem.isNeeded = function (objectConfig) {
    return !YAHOO.lang.isUndefined(objectConfig.transaction) && objectConfig.transaction.origin === 'own' && objectConfig.transaction.transactionType.value === 'buy' || !YAHOO.lang.isUndefined(objectConfig.position) && objectConfig.origin === 'own';
  };

  /* create new split transaction */
  var transactionNewSplitItem = new _ContextMenuItem.default('transactionNewSplitItem', _contextMenuGroupsEnum.default.TRANSACTION_ACTIONS);
  transactionNewSplitItem.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.transaction.split.new', function () {
    var panelConfig = {
      type: {
        value: 'split'
      },
      id: 'splitTransactionPanel',
      url: 'portfolios/portfolios/panels/transactionPanel.plain?type=split&op=new'
    };
    var transaction = YAHOO.fcom.Context.configObject.transaction;
    var position = YAHOO.fcom.Context.configObject.position;
    YAHOO.lang.augmentObject(panelConfig, YAHOO.fcom.panel.AJAXPanel.TRANSACTION_NEW);
    YAHOO.fcom.panel.PanelFactory.getAJAXPanel(panelConfig, {
      fn: function fn(panel) {
        if (transaction) {
          panel.fromTransaction(transaction);
        } else if (position) {
          panel.fromPosition(position, YAHOO.fcom.Context.configObject.portfolio, YAHOO.fcom.Context.configObject.portfolioName);
        }
        panel.saveEvent.subscribe(function () {
          window.location.reload();
        });
        panel.show();
      }
    });
  });
  transactionNewSplitItem.isNeeded = function (objectConfig) {
    return !YAHOO.lang.isUndefined(objectConfig.transaction) && objectConfig.transaction.origin === 'own' && objectConfig.transaction.transactionType.value === 'buy' && +objectConfig.transaction.notationFactor === 1 //only for per piece notated instruments
    || !YAHOO.lang.isUndefined(objectConfig.position) && objectConfig.position.notationFactor === 1 && objectConfig.origin === 'own';
  };

  /* menu entry to edit transactions */
  var transactionEditItem = new _ContextMenuItem.default('transactionEditItem', _contextMenuGroupsEnum.default.TRANSACTION_ACTIONS);
  transactionEditItem.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.transaction.edit', function () {
    (0, _transactionEdit.default)(YAHOO.fcom.Context.configObject.transaction);
  });
  transactionEditItem.isNeeded = function (objectConfig) {
    return !YAHOO.lang.isUndefined(objectConfig.transaction) && objectConfig.transaction.origin === 'own' && objectConfig.transaction.suggestionType.value === 'none';
  };

  /* menu entry to edit suggestions */
  var transactionSuggestionItem = new _ContextMenuItem.default('transactionSuggestionItem', _contextMenuGroupsEnum.default.TRANSACTION_ACTIONS);
  transactionSuggestionItem.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.transaction.suggestion', function () {
    (0, _transactionEdit.default)(YAHOO.fcom.Context.configObject.transaction);
  });
  transactionSuggestionItem.isNeeded = function (objectConfig) {
    return !YAHOO.lang.isUndefined(objectConfig.transaction) && objectConfig.transaction.origin === 'own' && objectConfig.transaction.suggestionType.value !== 'none';
  };

  /* delete a transaction */
  var transactionDeleteItem = new _ContextMenuItem.default('transactionDeleteItem', _contextMenuGroupsEnum.default.TRANSACTION_ACTIONS);
  transactionDeleteItem.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.transaction.delete', function () {
    var type = YAHOO.fcom.Context.configObject.transaction.transactionType.value;
    var id = YAHOO.fcom.Context.configObject.transaction.transactionID;
    (0, _transactionDelete.default)(type, id);
  });
  transactionDeleteItem.isNeeded = function (objectConfig) {
    return !YAHOO.lang.isUndefined(objectConfig.transaction) && objectConfig.transaction.origin === 'own' && objectConfig.transaction.suggestionType.value === 'none'; //cannot delete suggestions
  };

  /* edit a current position from an according transaction */
  var transactionEditCurrentPositionItem = new _ContextMenuItem.default('transactionEditCurrentPositionItem', _contextMenuGroupsEnum.default.WATCHLIST_PORTFOLIO_ACTIONS);
  transactionEditCurrentPositionItem.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.transaction.edit.position.current', function () {
    var transaction = YAHOO.fcom.Context.configObject.transaction;
    (0, _portfolioPositionEdit.default)(transaction.portfolioID, transaction.positionCurrent);
  });
  transactionEditCurrentPositionItem.isNeeded = function (objectConfig) {
    return !YAHOO.lang.isUndefined(objectConfig.transaction) && objectConfig.transaction.origin === 'own' && objectConfig.transaction.positionCurrent && (objectConfig.transaction.transactionType.value === 'buy' || objectConfig.transaction.transactionType.value === 'sell');
  };

  /* edit a current position from an according transaction */
  var transactionEditHistoricPositionItem = new _ContextMenuItem.default('transactionEditHistoricPositionItem', _contextMenuGroupsEnum.default.WATCHLIST_PORTFOLIO_ACTIONS);
  transactionEditHistoricPositionItem.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.transaction.edit.position.historic', function () {
    var transaction = YAHOO.fcom.Context.configObject.transaction;
    (0, _portfolioPositionEditHistoric.default)(transaction.portfolioID, transaction.positionHistoric);
  });
  transactionEditHistoricPositionItem.isNeeded = function (objectConfig) {
    return !YAHOO.lang.isUndefined(objectConfig.transaction) && objectConfig.transaction.origin === 'own' && objectConfig.transaction.positionHistoric && objectConfig.transaction.transactionType.value === 'sell';
  };

  /* menu entry to edit cash accounts */
  var cashAccountEditItem = new _ContextMenuItem.default('cashAccountEditItem', _contextMenuGroupsEnum.default.TRANSACTION_ACTIONS);
  cashAccountEditItem.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.cashAccount.edit', function () {
    var panelConfig = {
      postData: YAHOO.fcom.Util.createPostData({
        op: 'edit'
      })
    };
    YAHOO.lang.augmentObject(panelConfig, YAHOO.fcom.panel.AJAXPanel.CASH_ACCOUNT);
    YAHOO.fcom.panel.PanelFactory.getAJAXPanel(panelConfig, {
      fn: function fn(panel) {
        panel.setCashAccount(YAHOO.fcom.Context.configObject.account);
        panel.saveEvent.subscribe(function () {
          panel.hide();
        });
        panel.show();
      }
    });
  });
  cashAccountEditItem.isNeeded = function (objectConfig) {
    return !YAHOO.lang.isUndefined(objectConfig.account) && objectConfig.account.origin === 'own';
  };

  /* menu entry to delete cash accounts */
  var cashAccountDeleteItem = new _ContextMenuItem.default('cashAccountDeleteItem', _contextMenuGroupsEnum.default.TRANSACTION_ACTIONS);
  cashAccountDeleteItem.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.cashAccount.delete', function () {
    var account = YAHOO.fcom.Context.configObject.account;
    var postData = YAHOO.fcom.Util.createPostData(account);
    window.ngpConfirm(window.getMessage('portfolio.dialog.js.cashAccount.delete.message', account.accountName), {
      title: window.getMessage('portfolio.dialog.js.cashAccount.delete.title'),
      okHandler: function okHandler() {
        window.ngpAsyncRequest('POST', '/portfolio.action?method=handleDeleteCashAccount', {
          success: function success() {
            YAHOO.fcom.Page.fire('cashAccountsChanged');
          }
        }, postData);
      }
    });
  });
  cashAccountDeleteItem.isNeeded = function (objectConfig) {
    return !YAHOO.lang.isUndefined(objectConfig.account) && objectConfig.account.origin === 'own';
  };

  /* menu entry to edit money transfers */
  var moneyTransferEditItem = new _ContextMenuItem.default('moneyTransferEditItem', _contextMenuGroupsEnum.default.TRANSACTION_ACTIONS);
  moneyTransferEditItem.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.moneyTransfer.edit', function () {
    var panelConfig = {
      id: 'moneyTransferEditPanel'
    };
    YAHOO.lang.augmentObject(panelConfig, YAHOO.fcom.panel.AJAXPanel.MONEY_TRANSFER);
    YAHOO.fcom.panel.PanelFactory.getAJAXPanel(panelConfig, {
      fn: function fn(panel) {
        panel.show();
      }
    }, YAHOO.fcom.Context.configObject.moneyTransfer);
  });
  moneyTransferEditItem.isNeeded = function (objectConfig) {
    return !YAHOO.lang.isUndefined(objectConfig.moneyTransfer) && objectConfig.moneyTransfer.origin === 'own';
  };

  /* menu entry to delete cash accounts */
  var moneyTransferDeleteItem = new _ContextMenuItem.default('moneyTransferDeleteItem', _contextMenuGroupsEnum.default.TRANSACTION_ACTIONS);
  moneyTransferDeleteItem.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.moneyTransfer.delete', function () {
    var moneyTransfer = YAHOO.fcom.Context.configObject.moneyTransfer;
    var postData = YAHOO.fcom.Util.createPostData(moneyTransfer);
    window.ngpConfirm(window.getMessage('portfolio.dialog.js.moneyTransfer.delete.message'), {
      title: window.getMessage('portfolio.dialog.js.moneyTransfer.delete.title'),
      okHandler: function okHandler() {
        window.ngpAsyncRequest('POST', '/portfolio.action?method=handleDeleteMoneyTransfer', {
          success: function success() {
            YAHOO.fcom.Page.fire('moneyTransfersChanged');
          }
        }, postData);
      }
    });
  });
  moneyTransferDeleteItem.isNeeded = function (objectConfig) {
    return !YAHOO.lang.isUndefined(objectConfig.moneyTransfer) && objectConfig.moneyTransfer.origin === 'own';
  };

  /* cash account sub menus */
  var positionBuySubMenu = new YAHOO.widget.Menu('moneyTransferPositionBuyConextMenu', {
    'hidedelay': 1500,
    'position': 'dynamic'
  });
  var positionSaleSubMenu = new YAHOO.widget.Menu('moneyTransferPositionSaleConextMenu', {
    'hidedelay': 1500,
    'position': 'dynamic'
  });

  /* function to load cash accounts and build the according menu items */
  (function (positionBuySubMenu, positionSaleSubMenu) {
    var cashAccounts = null;
    function beforeShowHandler(evt, args, menu) {
      if (cashAccounts == null) {
        window.ngpAsyncRequest('POST', '/portfolio.action?method=handleGetCashAccounts', {
          success: function success(response) {
            cashAccounts = JSON.parse(response.responseText);
            createItems(this);
          },
          silent: true,
          scope: menu
        }, {
          portfolioID: YAHOO.fcom.Context.configObject.portfolio || YAHOO.fcom.Context.configObject.transaction.portfolioID
        });
      } else {
        createItems(menu);
      }
    }
    function createItems(menu) {
      if (menu.getItems().length > 0) {
        return;
      }
      var panelId = menu === positionBuySubMenu ? 'moneyTransferBookAcquisitionPanel' : 'moneyTransferBookDepositionPanel';
      var transactionType = menu === positionBuySubMenu ? 'withdrawal' : 'deposit';
      for (var i = 0, l = cashAccounts.length; i < l; i++) {
        var account = cashAccounts[i];
        menu.addItem({
          text: account.accountName,
          onclick: {
            fn: function fn(evt, args, account) {
              var panelConfig = {
                id: panelId,
                transactionType: {
                  value: transactionType
                }
              };
              YAHOO.lang.augmentObject(panelConfig, YAHOO.fcom.panel.AJAXPanel.MONEY_TRANSFER);
              YAHOO.fcom.panel.PanelFactory.getAJAXPanel(panelConfig, {
                fn: function fn( /*YAHOO.fcom.panel.MoneyTransferPanel*/panel) {
                  var context = YAHOO.fcom.Context.configObject;
                  var portfolioID = null;
                  var positionID = null;
                  var historic = false;
                  if (context.position) {
                    portfolioID = context.portfolio;
                    positionID = context.position.id;
                    historic = context.position.historic;
                  } else if (context.transaction) {
                    portfolioID = context.transaction.portfolioID;
                    positionID = context.transaction.positionCurrent || context.transaction.positionHistoric;
                    historic = context.transaction.positionHistoric != null;
                  }
                  panel.setCashAccount(account);
                  panel.setPosition(positionID, portfolioID, historic);
                  panel.show();
                }
              });
            },
            obj: account
          }
        });
      }
      if (!cashAccounts.length) {
        menu.addItem({
          text: window.getMessage('context.menu.entry.txt.submenu.empty'),
          disabled: true
        });
      }
      menu.render(menu.parent.element);
      /* bad hack to work around a YUI problem, aligning the menu wrong the first time*/
      window.Dom.setStyle(menu.element, 'visibility', 'hidden');
      YAHOO.lang.later(10, this, function (menu) {
        menu.hide();
        menu.show();
        window.Dom.setStyle(menu.element, 'visibility', 'visible');
      }, menu, false);
    }
    positionBuySubMenu.beforeShowEvent.subscribe(beforeShowHandler, positionBuySubMenu);
    positionSaleSubMenu.beforeShowEvent.subscribe(beforeShowHandler, positionSaleSubMenu);
  })(positionBuySubMenu, positionSaleSubMenu);

  /* menu entry for booking the cost of acquisition to a cash account */
  var moneyTransferPositionBuyItem = new _ContextMenuItem.default('moneyTransferPositionBuyItem', _contextMenuGroupsEnum.default.WATCHLIST_PORTFOLIO_ACTIONS);
  moneyTransferPositionBuyItem.menuItem = {
    text: window.getMessage('context.menu.entry.txt.moneyTransfer.position.buy'),
    submenu: positionBuySubMenu
  };
  moneyTransferPositionBuyItem.isNeeded = function () {
    return false;
  };

  /* menu entry for booking the cost of deposition to a cash account */
  var moneyTransferPositionSaleItem = new _ContextMenuItem.default('moneyTransferPositionSaleItem', _contextMenuGroupsEnum.default.WATCHLIST_PORTFOLIO_ACTIONS);
  moneyTransferPositionSaleItem.menuItem = {
    text: window.getMessage('context.menu.entry.txt.moneyTransfer.position.sale'),
    submenu: positionSaleSubMenu
  };
  moneyTransferPositionSaleItem.isNeeded = function () {
    return false;
  };
};

},{"contextMenu/ContextMenuItem":12,"contextMenu/contextMenuGroupsEnum":13,"contextMenu/helperFunctions/portfolioPositionEdit":27,"contextMenu/helperFunctions/portfolioPositionEditHistoric":28,"contextMenu/helperFunctions/transactionDelete":39,"contextMenu/helperFunctions/transactionEdit":40,"contextMenu/registerItems/getMenuItem":43}],47:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ContextMenuItem = _interopRequireDefault(require("contextMenu/ContextMenuItem"));
var _getMenuItem = _interopRequireDefault(require("contextMenu/registerItems/getMenuItem"));
var _contextMenuGroupsEnum = _interopRequireDefault(require("contextMenu/contextMenuGroupsEnum"));
var _compareWatchlistPortfolio = _interopRequireDefault(require("contextMenu/helperFunctions/compareWatchlistPortfolio"));
var _copyWatchlist = _interopRequireDefault(require("contextMenu/helperFunctions/copyWatchlist"));
var _editSharingAuthorizations = _interopRequireDefault(require("contextMenu/helperFunctions/editSharingAuthorizations"));
var _portfolioConvertToWatchlist = _interopRequireDefault(require("contextMenu/helperFunctions/portfolioConvertToWatchlist"));
var _portfolioDelete = _interopRequireDefault(require("contextMenu/helperFunctions/portfolioDelete"));
var _portfolioEdit = _interopRequireDefault(require("contextMenu/helperFunctions/portfolioEdit"));
var _portfolioPositionEdit = _interopRequireDefault(require("contextMenu/helperFunctions/portfolioPositionEdit"));
var _portfolioPositionEditHistoric = _interopRequireDefault(require("contextMenu/helperFunctions/portfolioPositionEditHistoric"));
var _portfolioPositionReduce = _interopRequireDefault(require("contextMenu/helperFunctions/portfolioPositionReduce"));
var _portfolioPrintReport = _interopRequireDefault(require("contextMenu/helperFunctions/portfolioPrintReport"));
var _rejectAuthorization = _interopRequireDefault(require("contextMenu/helperFunctions/rejectAuthorization"));
var _renameWatchlist = _interopRequireDefault(require("contextMenu/helperFunctions/renameWatchlist"));
var _showWatchlistPortfolioInTicker = _interopRequireDefault(require("contextMenu/helperFunctions/showWatchlistPortfolioInTicker"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var YAHOO = window.YAHOO;
var _default = exports.default = function _default() {
  /* menu entry to delete a watchlist or portfolio
   */
  var deleteWatchlistPortfolio = new _ContextMenuItem.default('deleteWatchlistPortfolio', _contextMenuGroupsEnum.default.WATCHLIST_PORTFOLIO_ACTIONS);
  deleteWatchlistPortfolio.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.deleteWatchlistPortfolio', function () {
    if (YAHOO.fcom.Context.configObject.portfolio != null && YAHOO.fcom.Context.configObject.position != null) {
      window.portfolioPositionDelete({
        id: YAHOO.fcom.Context.configObject.portfolio,
        name: YAHOO.fcom.Context.configObject.portfolioName
      }, [{
        id: YAHOO.fcom.Context.configObject.position.id,
        instrumentName: YAHOO.fcom.Context.configObject.position.instrumentName
      }], YAHOO.fcom.Context.configObject.position.historic);
    } else if (YAHOO.fcom.Context.configObject.portfolio != null) {
      (0, _portfolioDelete.default)([{
        id: YAHOO.fcom.Context.configObject.portfolio,
        name: YAHOO.fcom.Context.configObject.portfolioName
      }]);
    } else if (YAHOO.fcom.Context.configObject.watchlist != null) {
      window.removeWatchlists(YAHOO.fcom.Context.configObject.watchlist);
    }
  });
  deleteWatchlistPortfolio.isNeeded = function (objectConfig) {
    return !YAHOO.lang.isUndefined(objectConfig.origin) && objectConfig.origin === 'own' // only remove owned watchlists/portfolios
    && objectConfig.isList === true // not in the page menu of one specific watchlist
    && YAHOO.lang.isUndefined(objectConfig.instrumentIndex) // no listing of one watchlist
    && (!YAHOO.lang.isUndefined(objectConfig.watchlist) // only if there is a watchlist or portfolio
    || !YAHOO.lang.isUndefined(objectConfig.portfolio));
  };

  /* entry to edit watchlists or portfolios (even though there currently is no use case to edit watchlists) */
  var watchlistPortfolioEditItem = new _ContextMenuItem.default('watchlistPortfolioEditItem', _contextMenuGroupsEnum.default.WATCHLIST_PORTFOLIO_ACTIONS);
  watchlistPortfolioEditItem.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.editWatchlistPortfolio', function () {
    if (YAHOO.fcom.Context.configObject.portfolio != null && YAHOO.fcom.Context.configObject.position != null && YAHOO.fcom.Context.configObject.position.id != null) {
      //distinguish between current and historic positons
      if (YAHOO.fcom.Context.configObject.position.historic === true) {
        (0, _portfolioPositionEditHistoric.default)(YAHOO.fcom.Context.configObject.portfolio, YAHOO.fcom.Context.configObject.position.id);
      } else {
        (0, _portfolioPositionEdit.default)(YAHOO.fcom.Context.configObject.portfolio, YAHOO.fcom.Context.configObject.position.id);
      }
    } else if (YAHOO.fcom.Context.configObject.portfolio != null) {
      (0, _portfolioEdit.default)(YAHOO.fcom.Context.configObject.portfolio, function () {
        window.location.reload();
      });
    }
  });
  watchlistPortfolioEditItem.isNeeded = function (objectConfig) {
    return !YAHOO.lang.isUndefined(objectConfig.portfolio) /*|| !YAHOO.lang.isUndefined(objectConfig.watchlist)*/ && objectConfig.origin === 'own' && objectConfig.isList === true;
  };

  /* menu entry to copy a watchlist or portfolio
   */
  var copyWatchlistPortfolio = new _ContextMenuItem.default('copyWatchlistPortfolio', _contextMenuGroupsEnum.default.WATCHLIST_PORTFOLIO_ACTIONS);
  copyWatchlistPortfolio.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.copyWatchlistPortfolio', function () {
    if (YAHOO.fcom.Context.configObject.watchlist != null) {
      (0, _copyWatchlist.default)(YAHOO.fcom.Context.configObject.watchlist);
    }
  });
  copyWatchlistPortfolio.isNeeded = function (objectConfig) {
    return YAHOO.lang.isUndefined(objectConfig.instrumentIndex) // no listing of one watchlist, as there will be the page menu
    && !YAHOO.lang.isUndefined(objectConfig.watchlist) // only if there is a watchlist or portfolio
    /*|| !YAHOO.lang.isUndefined(objectConfig.portfolio)*/ && window.user.isToolsWatchlists;
  };

  /* menu entry to copy a watchlist or portfolio
   */
  var renameWatchlistPortfolio = new _ContextMenuItem.default('renameWatchlistPortfolio', _contextMenuGroupsEnum.default.WATCHLIST_PORTFOLIO_ACTIONS);
  renameWatchlistPortfolio.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.renameWatchlistPortfolio', function () {
    if (YAHOO.fcom.Context.configObject.watchlist != null) {
      (0, _renameWatchlist.default)(YAHOO.fcom.Context.configObject.watchlist);
    }
  });
  renameWatchlistPortfolio.isNeeded = function (objectConfig) {
    return !YAHOO.lang.isUndefined(objectConfig.origin) && objectConfig.origin === 'own' // only own ones
    && YAHOO.lang.isUndefined(objectConfig.instrumentIndex) // no listing of one watchlist
    && !YAHOO.lang.isUndefined(objectConfig.watchlist) // only if there is a watchlist or portfolio
    /*|| !YAHOO.lang.isUndefined(objectConfig.portfolio)*/;
  };

  /* menu entry to change the sharing state for that watchlist or portfolio.
   * sharings are used to give other users access to user watchlists */
  var watchlistPortfolioSharings = new _ContextMenuItem.default('watchlistPortfolioSharings', _contextMenuGroupsEnum.default.WATCHLIST_PORTFOLIO_ACTIONS);
  watchlistPortfolioSharings.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.watchlistPortfolioSharings', function () {
    var type;
    var id;
    if (YAHOO.fcom.Context.configObject.watchlist != null) {
      type = 'watchlist';
      id = YAHOO.fcom.Context.configObject.watchlist;
    } else if (YAHOO.fcom.Context.configObject.portfolio != null) {
      type = 'portfolio';
      id = YAHOO.fcom.Context.configObject.portfolio;
    }
    if (type && id) {
      (0, _editSharingAuthorizations.default)(type, id, YAHOO.fcom.Context.configObject.origin);
    }
  });
  watchlistPortfolioSharings.isNeeded = function (objectConfig) {
    return !YAHOO.lang.isUndefined(objectConfig.origin) && objectConfig.origin === 'own' && window.user.isShareObjects && YAHOO.lang.isUndefined(objectConfig.ric) && YAHOO.lang.isUndefined(objectConfig.instrumentIndex) // no listing of one watchlist
    && (!YAHOO.lang.isUndefined(objectConfig.watchlist) || !YAHOO.lang.isUndefined(objectConfig.portfolio));
  };
  var watchlistPortfolioRejectAuthorization = new _ContextMenuItem.default('watchlistPortfolioRejectAuthorization', _contextMenuGroupsEnum.default.WATCHLIST_PORTFOLIO_ACTIONS);
  watchlistPortfolioRejectAuthorization.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.rejectAuthorization', function () {
    var type;
    var id;
    if (YAHOO.fcom.Context.configObject.watchlist != null) {
      type = 'watchlist';
      id = YAHOO.fcom.Context.configObject.watchlist;
    } else if (YAHOO.fcom.Context.configObject.portfolio != null) {
      type = 'portfolio';
      id = YAHOO.fcom.Context.configObject.portfolio;
    }
    if (type && id) {
      (0, _rejectAuthorization.default)(type, id, YAHOO.fcom.Context.configObject.origin);
    }
  });
  watchlistPortfolioRejectAuthorization.isNeeded = function (objectConfig) {
    return !YAHOO.lang.isUndefined(objectConfig.origin) && objectConfig.origin !== 'own' && objectConfig.origin !== 'origin' && window.user.isShareObjects && YAHOO.lang.isUndefined(objectConfig.ric) && YAHOO.lang.isUndefined(objectConfig.instrumentIndex) // no listing of one watchlist
    && (!YAHOO.lang.isUndefined(objectConfig.watchlist) || !YAHOO.lang.isUndefined(objectConfig.portfolio));
  };

  /* menu entry to add a watchlist to the ticker display */
  var watchlistPortfolioToTicker = new _ContextMenuItem.default('watchlistPortfolioToTicker', _contextMenuGroupsEnum.default.WATCHLIST_PORTFOLIO_ACTIONS);
  watchlistPortfolioToTicker.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.showWatchlistPortfolioInTicker', function () {
    if (YAHOO.fcom.Context.configObject.watchlist && YAHOO.fcom.Context.configObject.watchlist != null) {
      (0, _showWatchlistPortfolioInTicker.default)(YAHOO.fcom.Context.configObject.watchlist, 'watchlist');
    } else if (YAHOO.fcom.Context.configObject.portfolio && YAHOO.fcom.Context.configObject.portfolio != null) {
      (0, _showWatchlistPortfolioInTicker.default)(YAHOO.fcom.Context.configObject.portfolio, 'portfolio');
    }
  });
  watchlistPortfolioToTicker.isNeeded = function (objectConfig) {
    return YAHOO.lang.isUndefined(objectConfig.ric) && YAHOO.lang.isUndefined(objectConfig.instrumentIndex) && (!YAHOO.lang.isUndefined(objectConfig.watchlist) || !YAHOO.lang.isUndefined(objectConfig.portfolio)) && window.user.isTickerAvailable;
  };
  var watchlistPortfolioToComparison = new _ContextMenuItem.default('watchlistPortfolioToComparison', _contextMenuGroupsEnum.default.WATCHLIST_PORTFOLIO_ACTIONS);
  watchlistPortfolioToComparison.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.compareWatchlistPortfolio', function () {
    if (YAHOO.fcom.Context.configObject.watchlist && YAHOO.fcom.Context.configObject.watchlist != null) {
      (0, _compareWatchlistPortfolio.default)(YAHOO.fcom.Context.configObject.watchlist, 'watchlist');
    } else if (YAHOO.fcom.Context.configObject.portfolio && YAHOO.fcom.Context.configObject.portfolio != null) {
      (0, _compareWatchlistPortfolio.default)(YAHOO.fcom.Context.configObject.portfolio, 'portfolio');
    }
  });
  watchlistPortfolioToComparison.isNeeded = function (objectConfig) {
    return (!YAHOO.lang.isUndefined(objectConfig.watchlist) || !YAHOO.lang.isUndefined(objectConfig.portfolio)) && YAHOO.lang.isUndefined(objectConfig.instrumentIndex) // no listing of one watchlist
    && YAHOO.lang.isUndefined(objectConfig.position) // no listing of positions
    && !window.listForComparison // not on comparison page
    && window.user.isComparisonEnabled;
  };

  /* menu entry for converting portfolios into watchlists */
  var portfolioConvertToWatchlistItem = new _ContextMenuItem.default('portfolioConvertToWatchlistItem', _contextMenuGroupsEnum.default.WATCHLIST_PORTFOLIO_ACTIONS);
  portfolioConvertToWatchlistItem.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.portfolioConvertToWatchlist', function () {
    (0, _portfolioConvertToWatchlist.default)([YAHOO.fcom.Context.configObject.portfolio]);
  });
  portfolioConvertToWatchlistItem.isNeeded = function (objectConfig) {
    return window.user.isToolsWatchlists && window.user.isConvertPortfolioWatchlistEnabled && !YAHOO.lang.isUndefined(objectConfig.portfolio) && YAHOO.lang.isUndefined(objectConfig.position);
  };

  /* menu entry for converting watchlists into portfolios */
  var watchlistConvertToPortfolioItem = new _ContextMenuItem.default('watchlistConvertToPortfolioItem', _contextMenuGroupsEnum.default.WATCHLIST_PORTFOLIO_ACTIONS);
  watchlistConvertToPortfolioItem.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.watchlistConvertToPortfolio', function () {
    window.watchlistConvertToPortfolio([YAHOO.fcom.Context.configObject.watchlist]);
  });
  watchlistConvertToPortfolioItem.isNeeded = function (objectConfig) {
    return window.user.isToolsPortfolio && window.user.isConvertPortfolioWatchlistEnabled && !YAHOO.lang.isUndefined(objectConfig.watchlist) && YAHOO.lang.isUndefined(objectConfig.instrumentIndex); //not when in instrument list
  };

  /* menu entry to reduce a current position */
  var portfolioPositionReduceItem = new _ContextMenuItem.default('portfolioPositionReduceItem', _contextMenuGroupsEnum.default.WATCHLIST_PORTFOLIO_ACTIONS);
  portfolioPositionReduceItem.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.portfolioPositionReduce', function () {
    (0, _portfolioPositionReduce.default)(YAHOO.fcom.Context.configObject.portfolio, YAHOO.fcom.Context.configObject.position.id);
  });
  portfolioPositionReduceItem.isNeeded = function (objectConfig) {
    return !YAHOO.lang.isUndefined(objectConfig.portfolio) && objectConfig.origin === 'own' && !YAHOO.lang.isUndefined(objectConfig.position) && objectConfig.position.id != null && objectConfig.position.historic !== true;
  };

  /* menu entry to create a print report of a portfolio */
  var portfolioPrintReportItem = new _ContextMenuItem.default('portfolioPrintReportItem', _contextMenuGroupsEnum.default.WATCHLIST_PORTFOLIO_ACTIONS);
  portfolioPrintReportItem.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.portfolioPrintReport', function () {
    (0, _portfolioPrintReport.default)(YAHOO.fcom.Context.configObject.portfolio);
  });
  portfolioPrintReportItem.isNeeded = function (objectConfig) {
    return false && !YAHOO.lang.isUndefined(objectConfig.portfolio) && YAHOO.lang.isUndefined(objectConfig.position) && objectConfig.origin === 'own';
  };

  /* menu entry to add portfolio fees */
  var portfolioFeeItem = new _ContextMenuItem.default('portfolioFeeItem', _contextMenuGroupsEnum.default.WATCHLIST_PORTFOLIO_ACTIONS);
  portfolioFeeItem.menuItem = (0, _getMenuItem.default)('context.menu.entry.txt.portfolioFee', function () {
    var panelConfig = {
      type: {
        value: 'simple'
      },
      id: 'feeTransactionPanel',
      url: 'portfolios/portfolios/panels/transactionPanel.plain?type=simple&op=new'
    };
    var context = YAHOO.fcom.Context.configObject;
    YAHOO.lang.augmentObject(panelConfig, YAHOO.fcom.panel.AJAXPanel.TRANSACTION_NEW);
    YAHOO.fcom.panel.PanelFactory.getAJAXPanel(panelConfig, {
      fn: function fn( /*YAHOO.fcom.panel.TransactionPanel*/panel) {
        panel.setPortfolio(context.portfolio, context.portfolioName, context.portfolioCurrency);
        panel.saveEvent.subscribe(function () {
          window.location.reload();
        });
        panel.show();
      }
    });
  });
  portfolioFeeItem.isNeeded = function (objectConfig) {
    return !YAHOO.lang.isUndefined(objectConfig.portfolio) && YAHOO.lang.isUndefined(objectConfig.position) && objectConfig.origin === 'own' && window.user.isPortfolioFeeEnabled;
  };
};

},{"contextMenu/ContextMenuItem":12,"contextMenu/contextMenuGroupsEnum":13,"contextMenu/helperFunctions/compareWatchlistPortfolio":20,"contextMenu/helperFunctions/copyWatchlist":21,"contextMenu/helperFunctions/editSharingAuthorizations":23,"contextMenu/helperFunctions/portfolioConvertToWatchlist":24,"contextMenu/helperFunctions/portfolioDelete":25,"contextMenu/helperFunctions/portfolioEdit":26,"contextMenu/helperFunctions/portfolioPositionEdit":27,"contextMenu/helperFunctions/portfolioPositionEditHistoric":28,"contextMenu/helperFunctions/portfolioPositionReduce":29,"contextMenu/helperFunctions/portfolioPrintReport":30,"contextMenu/helperFunctions/rejectAuthorization":31,"contextMenu/helperFunctions/renameWatchlist":33,"contextMenu/helperFunctions/showWatchlistPortfolioInTicker":38,"contextMenu/registerItems/getMenuItem":43}],48:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ajaxPostJson = exports.ajaxPost = exports.ajaxGetJson = exports.ajaxGet = void 0;
var _objectToPostdata = _interopRequireDefault(require("core/Ajax/objectToPostdata"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/** @module core/Ajax/ajaxRequest */

/**
 * ajaxRequest is a wrapper for window.fetch that encapsulates all its functionality
 * @private
 * @param {String} method
 * @param {String} url
 * @param {String} [format] data format expected, this can be one of:
 * <ul>
 *  <li>text (default)</li>
 *  <li>json</li>
 *  <li>blob</li>
 *  <li>arrayBuffer</li>
 *  <li>formData</li>
 * </ul>
 * @param {Object} [data] key value object to be sent as post data or appended to url as get parameters
 * @param {Object} [headers] key value object containing request headers to be sent
 * @return {Promise.<any>}
 */
var ajaxRequest = function ajaxRequest(method, url, format, data, headers) {
  format = format || 'text';
  headers = headers || null;
  var fetchOptions = {
    method: method,
    headers: headers,
    credentials: 'same-origin'
  };
  var params = '';
  if (typeof data === 'string') {
    params = data;
  } else {
    params = (0, _objectToPostdata.default)(data);
  }
  if (method === 'GET') {
    if (params) {
      url += (url.indexOf('?') > -1 ? '&' : '?') + params;
    }
  } else {
    fetchOptions.body = params || null;
  }
  if (url.indexOf('/') === 0) {
    url = window.ctx + url;
  }
  return window.fetch(url, fetchOptions).then(function (response) {
    if (response.ok) {
      return response[format]();
    } else {
      if (!response.headers.has('applicationMessage')) {
        throw new Error("".concat(response.status, " - ").concat(response.statusText));
      } else {
        var error = new Error();
        error.code = response.status;
        error.message = response.headers.get('applicationMessage');
        throw error;
      }
    }
  });
};

/**
 * executes a GET request to the provided url and returns a promise
 * @param {String} url
 * @param {Object} [data] key value object to be appended to url as get parameters
 * @param {Object} [headers] key value object containing request headers to be sent
 * @return {Promise.<string>}
 */
var ajaxGet = exports.ajaxGet = function ajaxGet(url, data, headers) {
  return ajaxRequest('GET', url, 'text', data || {}, Object.assign({}, headers));
};

/**
 * executes a GET request to the provided url and returns a promise
 * @param {String} url
 * @param {Object} [data] key value object to be appended to url as get parameters
 * @param {Object} [headers] key value object containing request headers to be sent
 * @return {Promise.<any>}
 */
var ajaxGetJson = exports.ajaxGetJson = function ajaxGetJson(url, data, headers) {
  return ajaxRequest('GET', url, 'json', data || {}, Object.assign({}, headers));
};

/**
 * executes a POST request to the provided url and returns a promise
 * @param {String} url
 * @param {Object} [data] key value object to be sent as post data
 * @param {Object} [headers] key value object containing request headers to be sent
 * @return {Promise.<string>}
 */
var ajaxPost = exports.ajaxPost = function ajaxPost(url, data, headers) {
  return ajaxRequest('POST', url, 'text', data || {}, Object.assign({
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
  }, headers));
};

/**
 * executes a POST request to the provided url and returns a promise
 * @param {String} url
 * @param {Object} [data] key value object to be sent as post data
 * @param {Object} [headers] key value object containing request headers to be sent
 * @return {Promise.<any>}
 */
var ajaxPostJson = exports.ajaxPostJson = function ajaxPostJson(url, data, headers) {
  return ajaxRequest('POST', url, 'json', data || {}, Object.assign({
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
  }, headers));
};

},{"core/Ajax/objectToPostdata":51}],49:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _replaceAsync = _interopRequireDefault(require("core/Ajax/replaceAsync"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var checkServer = function checkServer() {
  if (window.user && window.user.locale && !window.isLoginPage) {
    // only on pages with logged in users, e.g. not on login pages
    var checkDiv = window.Dom.get('jsCheckDiv');
    if (!checkDiv || checkDiv == null) {
      checkDiv = document.createElement('div');
      checkDiv.id = 'jsCheckDiv';
      document.body.appendChild(checkDiv);
    }
    return (0, _replaceAsync.default)('/flash/flash.plain', checkDiv, {
      callback: function callback(o) {
        if (!window.themeProperties.disableCheckServerPolling && o.status === 200) {
          window.checkServerRequest = window.setTimeout(checkServer, window.user.serverPingRate);
        } else if (o.status > 300) {
          // server ping does not directly support redirects
          location.reload(); // reload the main browser page and hope to get the same redirect (e.g. to login page, or IDP)
        }
      },

      silent: true,
      suppressPageEvents: true,
      postData: {
        tabId: window.user.tabId,
        lastCheck: window.user.lastServerPing
      }
    });
  }
};
var _default = exports.default = checkServer;
window.checkServer = checkServer;
var cancelCheckServerPollingRequest = function cancelCheckServerPollingRequest() {
  window.checkServer = function () {};
  clearTimeout(window.checkServerRequest);
};
window.cancelCheckServerPollingRequest = cancelCheckServerPollingRequest;

},{"core/Ajax/replaceAsync":52}],50:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectToPostdata = _interopRequireDefault(require("core/Ajax/objectToPostdata"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*
 * A wrapper function for window.fetch with a similar signature to <code>YAHOO.util.Connect.asyncRequest</code>.
 * The motivation behind the function is to supply a central handler for connection timeouts, lost connections
 * or expired sessions. The callback parameter is similar to one of <code>YAHOO.util.Connect.asyncRequest</code>,
 * but it can contain additional properties that allow further customizing of the request.
 * There are default callback handlers for success and failure that will be executed before the actual
 * callback handlers. It is also possible to only specify a success callback handler and utilize the default
 * error behavior supplied by this function.
 * If the default failure handling behavior is not enough, the property forceCallback can be set to true.
 * This will call the configured failure handler after the default handler (despite the case session expired,
 * because a redirect happens there).
 * The property waitMask of the callback parameter can be set to block an element during a request.
 * If you want to run a request in the background, set the property silent to true. This will disable all
 * default error messages about timeout, connection loss and server errors.
 * Please see the paramter's doc for a detailed list of possible callback configuration properties.
 *
 * ------------------------------------------------------------------------------------------------------
 * SENDING DATA TO THE SERVER
 * ------------------------------------------------------------------------------------------------------
 * The optional parameter <code>form</code> can be supplied to submit form data.
 *
 * For passing <b>data to the server</b>, following strategies can/should be used:
 * <ol>
 *  <li>Using the method "GET" you can pass URL parameters with the request. These parameters
 *      can be single strings or arrays of strings. Simply use <code>YAHOO.fcom.Util.setURLParam</code>
 *      to add any number of params to an url. The <code>setURLParam</code> function will encode the
 *      params for transport.
 *  <li>Using the method "POST" you can supply a string of parameters in the same Syntax as URL parameters.
 *      The values however do not have to be encoded for transport manually. Post data can be supplied over
 *      the <code>postData</code> parameter and will be merged with any form data.
 *      To add an array of values to a postData string, you can use the function <code>YAHOO.fcom.Util.arrayToParam</code>.
 *  <li>In case you have to send structured data to the server, you can encode any JS Object into JSON format by
 *      calling <code>JSON.stringify</code>. This json string should be added as a parameter to postData.
 *      On serverside the json parameter string can be parsed back in Java to a <code>org.json.JSONObject</code>.
 * </ol>
 * ------------------------------------------------------------------------------------------------------
 * PARAMETERS
 * ------------------------------------------------------------------------------------------------------
 * @param {String}  method
 *  HTTP Method
 * @param {String}  uri
 *  request uri
 * @param {Function|Object} callback
 *  a callback function or an object containing the following properties:
 *      <ul>
 *          <li>{Function} success
 *                  handler executed if request was successful // TODO: document callback signature and how to find server response
 *          <li>{Function} failure
 *                  handler executed if request failed
 *          <li>{Object} scope
 *                  execution context of the handlers
 *          <li>{Object} argument
 *                  will be passed to the handlers as property of the response object
 *          <li>{Number} timeout
 *                  number of milliseconds
 *          <li>{HTMLElement|String|Boolean} waitMask (optional)
 *                  id or element that will be blocked for user interaction.
 *                  If supplied as a Boolean with the value <code>true</code> the whole document will be blocked.
 *                  If supplied as a Boolean with the value <code>false</code> the wait banner is shown, but no element will be blocked
 *          <li>{Boolean} silent (optional)
 *                  if true, there will be no default error messages, suitable for background tasks
 *          <li>{Boolean} forceCallback
 *                  if true, the supplied failure handler will always be executed after the default failure handler
 *      </ul>
 * @param {Object|String} postData either a string or a created from a map
 * @param {HTMLFormElement} form
 * @return {Object} yui transaction object
 */
var ngpAsyncRequest = function ngpAsyncRequest(method, uri, callback, postData, form, waitMask, silent) {
  var allowRedirects = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : true;
  if (!window.YAHOO.fcom.viewInfo.sessionValid) {
    // no further ajax requests, when session is invalid
    return;
  }
  if (!callback) {
    /*
        TODO: this is a temprary workaround to inject waitMask and silent via params while not using a callback.
              This needs to be properly solved by passing a config object to ngpAsyncRequest and removing the callback
              Parameter. Instead of callbacks this function already returns a promise that is far better at handling the
              Ajax behaviour.
    */
    callback = {};
    callback.waitMask = waitMask;
    callback.silent = silent;
  }

  /*
   * Default callback handlers that will be execute the original callback handlers
   */
  var defaultCallback = {
    success: function success(response) {
      if (window.YAHOO.lang.isFunction(this)) {
        this(response);
      } else {
        if (this.waitMask != null) {
          window.showWait(false, this.waitMask);
        }
        if (this.success) {
          this.success.call(this.scope, response);
        }
      }
    },
    /* Default error handling catching timeouts and connection loss */
    failure: function failure(response) {
      var message = response.responseText ? response.responseText.substring(0, 100) : response.statusText;
      window.YAHOO.log("AJAX Error - status code ".concat(response.status, ": ").concat(message), 'ajax_error', 'ngpAsyncRequest');
      //error message should not be not empty
      if (response.responseText == null || !window.YAHOO.fcom.Util.trim(response.responseText)) {
        response.responseText = window.getMessage('DEFAULT_AJAX_ERROR'); //default ajax error message
      }

      if (response.responseText.indexOf('<body') > 0) {
        //please no html body in the error message
        response.responseText = window.getMessage('DEFAULT_AJAX_ERROR'); //throw error page away and use default message
      }

      if (window.YAHOO.lang.isFunction(callback)) {
        this(response);
      } else {
        var doCallBack = this.forceCallback || false;
        if (this.waitMask != null) {
          window.showWait(false, this.waitMask);
        }
        if (response.status === 0) {
          //connection lost
          window.showWait(false);
          if (this.silent !== true) {
            window.YAHOO.lang.later(1000, this, function () {
              // delay alert to avoid alerts before fresh page loads
              if (!window.YAHOO.fcom.Page.isPageUnloaded()) {
                // only if connection not lost because of new page load
                window.ngpAlert(window.getMessage('AJAX_CONNECTION_LOST_ERROR'));
              }
            }, this);
          }
        } else if (response.status === -1) {
          //timeout
          window.showWait(false);
          if (this.silent !== true) {
            window.ngpAlert(window.getMessage('AJAX_TIMEOUT_ERROR'));
          }
        } else if (response.status === 400) {
          //no permission
          window.ngpAlert(window.getMessage('USER_UNAUTHORIZED'));
        } else if (response.status === 401) {
          //session expired
          window.sessionExpired();
        } else if (this.failure) {
          doCallBack = true;
        } else if (this.silent !== true) {
          window.ngpAlert(window.getMessage('DEFAULT_AJAX_ERROR'));
        }
        if (this.failure && doCallBack === true) {
          this.failure.call(this.scope, response);
        }
      }
    },
    scope: callback
  };

  /*
   * Apply additonal settings made in callback, timeout, argument etc.
   */
  if (!window.YAHOO.lang.isFunction(callback)) {
    window.YAHOO.lang.augmentObject(defaultCallback, callback);
  }

  /*
   * Apply default settings such as timeout
   */
  var defaultConfig = {
    timeout: window.ajaxTimeout || 120000
  };
  window.YAHOO.lang.augmentObject(defaultCallback, defaultConfig);
  if (callback.waitMask != null && callback.waitMask !== false) {
    window.showWait(true, callback.waitMask);
  }
  if (form) {
    if (!window.ngpIsType('String', postData)) {
      var formData = $(form).serializeArray().reduce(function (all, a) {
        all[a.name] = all[a.name] ? [].concat(all[a.name], a.value) : a.value;
        return all;
      }, {});
      postData = Object.assign({}, postData || {}, formData);
    } else {
      postData += (postData ? '&' : '') + $(form).serialize();
    }
  }
  if (typeof postData !== 'string') {
    postData = (0, _objectToPostdata.default)(postData);
  }
  if (method === 'GET' && postData) {
    uri += (uri.indexOf('?') > -1 ? '&' : '?') + postData;
  }
  var fetchOptions = {
    method: method,
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    }
  };
  if (method !== 'GET') {
    fetchOptions.body = postData;
  }
  if (uri.indexOf('/') === 0) {
    uri = window.ctx + uri;
  }
  //TODO: all uses of this should be refactored to use promises so this function can use ajaxRequest() (see below)
  return window.fetch(uri, fetchOptions).then(function (response) {
    if (response.redirected) {
      window.YAHOO.lang.later(500, null, function () {
        // delay next ajax call to avoid loops
        if (!window.YAHOO.fcom.Page.isPageUnloaded()) {
          // only if connection not lost because of new page load
          window.checkServer();
        }
      });
      if (!allowRedirects) {
        throw new Error('invalid redirect by server');
      }
    } else if (response.ok) {
      return response.text();
    } else {
      response.argument = defaultCallback.argument;
      response.text().then(function (responseText) {
        response.responseText = responseText;
        defaultCallback.failure(response);
      });
      throw new Error('invalid response from server');
    }
  }).then(function (content) {
    //the result object is only used for backwards compatibility
    var result = {
      textContent: content,
      responseText: content,
      argument: defaultCallback.argument,
      status: 200
    };
    defaultCallback.success(result);
    return content;
  });
};
var _default = exports.default = ngpAsyncRequest;

},{"core/Ajax/objectToPostdata":51}],51:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/*
 * Create a post data string from an object by using the property names as
 * parameter names. The values will be URI encoded.
 * Returns null for any input that is not an object.
 */
var objectToPostdata = function objectToPostdata(postData) {
  return _typeof(postData) !== 'object' || postData == null ? null : Object.keys(postData).map(function (key) {
    return [].concat(itemToString(postData[key])).filter(function (f) {
      return f != null;
    }).map(function (a) {
      return "".concat(key, "=").concat(encodeURIComponent(a));
    });
  }).reduce(function (all, a) {
    return all.concat(a);
  }, []).join('&');
};
var itemToString = function itemToString(item, jsonEncodeArray) {
  if (typeof item === 'function' || item == null) {
    //invalid stuff should be ignored
    return null;
  } else if (!jsonEncodeArray && Array.isArray(item)) {
    return item.map(function (a) {
      return itemToString(a, true);
    });
  } else if (_typeof(item) === 'object') {
    if (typeof item.toString === 'function') {
      var string = item.toString();
      // if the object has an overwritten toString method
      if (string.indexOf('[object ') !== 0) {
        return string;
      }
    }
    return JSON.stringify(item);
  } else {
    return "".concat(item);
  }
};
var _default = exports.default = objectToPostdata;

},{}],52:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ngpAsyncRequest = _interopRequireDefault(require("core/Ajax/ngpAsyncRequest"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*
 * @author Christophe Andreoli, reworked by franky generic method to replace the content of html dom
 *         nodes by asynchronous ajax calls
 * @param url: the url where to send the ajax query to
 * @param containerNode: the dom node or the id of a dom node to replace the inner html of. When
 *        config.replaceContainer is given, the container node is replaced, instead of it's inner
 *        HTML
 * @param config: An optional object with a lot of possible attributes handling optinal behavior.
 *        Known attributes contain:
 *        <ul>
 *        <li>{HTMLFormElement|String} <b>form</b><br>
 *        a form object or the id of a form object to collect
 *        request parameters from.
 *
 *        <li>{String|Object} <b>postData</b><br>
 *        post data that will be merged with the form data
 *
 *        <li>{Boolean} <b>replaceEmpty</b><br>
 *        boolean value whether also to replace inner html, even when
 *        the response is empty. Default is false
 *
 *        <li>{Function} <b>callback</b><br>
 *        function that will be called additionally after the content is
 *        replaced. The function will get the response object from the callback as only argument.
 *        With this object it can find out everything about the ajax requests. See YUI api doc for
 *        the complete list of fields of the response object. Most important fields are "status" and
 *        "responseText". When the status is not 200, the ajax did not return normally.
 *
 *        <li>{HTMLElement|String} <b>modallityNode</b><br>
 *        A node which will be blocked from access as long
 *        as the ajax request runs. Can be a dom node or the id of one. There will be an invisible
 *        div put in front of that node that will steel all mouse events and send'em to nirvana.
 *        Like this the node is blocked from user interaction. After the ajax called returned, the
 *        div is removed automatically.
 *
 *        <li>{Boolean} <b>showWait</b><br>
 *        boolean value setting whether an animated wait symbol should be
 *        shown, communicating the user that something is done in the background. default is false,
 *        not showing anything
 *        
 *        <li>{Boolean} <b>suppressPageEvents</b><br>
 *        optional boolean whether to suppress the chain of page events usually triggered after replacing
 *        DOM. e.g. some resize events are fired. This suppression makes sense if the caller already knows 
 *        that the replace is visually without impact.
 *
 *        <li>{Boolean} <b>replaceContainer</b><br>
 *        optional boolean flag which defaults to false. When given
 *        true, instead of replacing the inner HTML of the given container node, the node itself is
 *        replaced by what is found in the response.
 *        </ul>
 * @param {Boolean} removeStreamingNodes flag whether to remove streaming nodes before replacing
 *        content
 */
var replaceAsync = function replaceAsync(url, containerNode, config, removeStreamingNodes, forceGet) {
  // create empty config object to reduce number of checks
  config = config || {};
  config.allowRedirect = config.allowRedirect || false;
  if (containerNode && window.YAHOO.lang.isString(containerNode)) {
    containerNode = window.Dom.get(containerNode);
  }
  if (config.showWait === true && !config.modallityNode) {
    config.modallityNode = false;
  }
  var method = 'POST';
  if (url.indexOf('?') > -1) {
    // when parameters are available at the end of the url, use get instead of post
    method = 'GET';
  }
  if (!forceGet && (config.form || config.postData)) {
    method = 'POST'; // send forms with post
  }

  return (0, _ngpAsyncRequest.default)(method, url, null, config.postData, config.form, config.modallityNode, config.silent, config.allowRedirect).then(function (response) {
    if (response) {
      if (response.length > 0 || config.replaceEmpty) {
        if (window.YAHOO.fcom.Streaming && removeStreamingNodes) {
          window.YAHOO.fcom.Streaming.removeStreamingNodes(containerNode);
        }
        if (config.replaceContainer) {
          // do replace full container, not only inner html
          config.selectorConfig = {
            selector: '',
            apply: function apply(selector, target, node) {
              return window.YAHOO.fcom.Dom.replaceNodeByString(target, node.innerHTML);
            }
          };
        }
        window.YAHOO.fcom.Page.replace(containerNode, response, config);
      }
    }
    if (config.callback) {
      // call outer callback function when available
      config.callback({
        status: 200,
        argument: [config, containerNode]
      }); //TODO: remove the object once it is not necessary anymore
    }
  }).catch(function () {
    if (config.callback) {
      // call outer callback function when available
      config.callback({
        status: 999
      }); //TODO: remove the object once it is not necessary anymore
    }
  });
};
var _default = exports.default = replaceAsync;

},{"core/Ajax/ngpAsyncRequest":50}],53:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addInstrumentToComparison = exports.addInstrumentListToComparison = void 0;
var broadCastComparisonChange = function broadCastComparisonChange() {
  return window.YAHOO.fcom.Broadcaster.sendMessage('@watchlists', {
    messageType: 'watchlistChanged',
    id: 'instrument_comparison'
  });
};

/*
 * add the instrument with the given fields to the comparison list. fields is an object with attributes to describe the instruments, like ric and isin.
 */
var addInstrumentToComparison = exports.addInstrumentToComparison = function addInstrumentToComparison(fields, callback) {
  var url = '/comparison.action?method=addInstrumentToComparison';
  callback = callback || {
    success: function success(response) {
      window.ngpAlert(response.responseText, {
        fixedcenter: true
      });
    },
    failure: function failure(response) {
      window.ngpAlert(response.responseText, {
        fixedcenter: true
      });
    },
    waitMask: true
  };
  window.ngpAsyncRequest('POST', url, callback, fields).then(broadCastComparisonChange);
};

/*
 * @see addInstrumentToComparison
 * @param {Array} fields
 * @param {Object} callback
 */
var addInstrumentListToComparison = exports.addInstrumentListToComparison = function addInstrumentListToComparison(fields, callback) {
  var url = '/comparison.action?method=addInstrumentListToComparison&clearList=true';
  var json = JSON.stringify(fields);
  window.ngpAsyncRequest('POST', url, callback, "json=".concat(json)).then(broadCastComparisonChange);
};
window.addInstrumentToComparison = addInstrumentToComparison;
window.addInstrumentListToComparison = addInstrumentListToComparison;

},{}],54:[function(require,module,exports){
"use strict";

var _AjaxStreaming = _interopRequireDefault(require("streaming/AjaxStreaming"));
var _checkServer = _interopRequireDefault(require("core/Ajax/checkServer"));
var _ColumnContainer = _interopRequireDefault(require("floatingCols/ColumnContainer"));
var _incrementalSearch = _interopRequireDefault(require("search/incrementalSearch"));
var _registerItems = _interopRequireDefault(require("contextMenu/registerItems"));
var _StreamingIllustration = _interopRequireDefault(require("streaming/StreamingIllustration"));
var _Accessibility = _interopRequireDefault(require("accessibility/Accessibility"));
var _NegativeLogValue = _interopRequireDefault(require("highstock/NegativeLogValue"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*
 * This function will be run when Dom is loaded and is used to register all kinds of elements on the page
 */
$(function () {
  // init server ping
  if (!window.themeProperties.disableCheckServerPolling && window.user && window.user.locale) {
    window.setTimeout(_checkServer.default, window.themeProperties.checkServerTimeOut);
  }

  // init global incrementalSearch
  var searchNode = $('[data-incrementalsearch]').get(0);
  if (searchNode) {
    var configBuilderFnName = $(searchNode).data('configbuilder');
    (0, _incrementalSearch.default)(searchNode, configBuilderFnName ? window[configBuilderFnName]() : null);
  }
  if (window.YAHOO.fcom.Util.detectInternetExplorer(false) && window.sessionStorage.getItem('browser_compatibility_warning_showed') !== 'true' && window.localStorage.getItem('browser_compatibility_hide_msg') !== 'true') {
    window.ngpAlert(window.getMessage('browser.compatibility.warning') + window.getMessage('browser.compatibility.warning.hide.popup'));
    window.sessionStorage.setItem('browser_compatibility_warning_showed', 'true');
  }
  YAHOO.util.Event.addListener('browserInfo', 'click', function (eventArg) {
    var checkbox = YAHOO.util.Dom.get('browserInfo');
    window.localStorage.setItem('browser_compatibility_hide_msg', checkbox.checked ? 'true' : 'false');
  }, null);

  // init the streaming service
  if (window.STREAMING_LOGIN_SEQUENCE != null) {
    if (window.STREAMING_PAUSED != null && window.STREAMING_PAUSED) {
      window.YAHOO.fcom.Streaming.pause();
    }
    if (window.STREAMING_MAX_ITEMS != null && !isNaN(window.STREAMING_MAX_ITEMS)) {
      window.YAHOO.fcom.Streaming.maxItemsPerPage = parseInt(window.STREAMING_MAX_ITEMS, 10);
    }
    window.YAHOO.fcom.Page.register('streaming');
    var streamingService = new _AjaxStreaming.default();
    window.YAHOO.fcom.Streaming.setStreamingService(streamingService);
    window.YAHOO.fcom.Streaming.showSessionsExceeded = window.STREAMING_SHOW_SESSIONS_EXCEEDED;
    window.YAHOO.fcom.Streaming.setStreamingIllustration(new _StreamingIllustration.default());
    window.YAHOO.fcom.Page.ready('streaming', streamingService);
  }

  // load theme config init module container (will also start the init of any modules)
  var $moduleContainer = $('[data-modulecontainer]');
  if ($moduleContainer.length) {
    window.YAHOO.fcom.Page.register('moduleContainer');
    var containerConfig = $moduleContainer.data('modulecontainer');
    var columnContainerVar = new _ColumnContainer.default($moduleContainer.attr('id'), containerConfig.columnCount, containerConfig.sequenceNumber, {
      dragDropEnabled: containerConfig.dragDropEnabled,
      isAdmin: containerConfig.isAdmin,
      adminData: containerConfig.adminData
    });
    $moduleContainer.find('[data-module-id]:not(.module-container-child)').each(function (i, elem) {
      var moduleId = $(elem).data('module-id');
      if (!moduleId) {
        return;
      }
      columnContainerVar.addItem(moduleId, $(elem).data('floating-colspan') || 1);
    });
    columnContainerVar.init();
    columnContainerVar.setEditAllowed(containerConfig.editAllowed);
    window.YAHOO.fcom.Page.ready('moduleContainer', columnContainerVar);
  } else if (window.user.isMobileApplication) {
    $('[data-module-id]').each(function (i, elem) {
      if (!$(elem).data('module-id')) {
        return;
      }
      window.fcom.moduleHandler.initModule(elem).catch(function () {
        // do nothing on error as an error will be thrown even when it is not necessary to init the module via moduleHandler
      });
    });
  }
  $('[data-module-autoinit]').each(function (i, elem) {
    if (!$(elem).data('module-id')) {
      return;
    }
    window.fcom.moduleHandler.initModule(elem).catch(function () {
      // do nothing on error as an error will be thrown even when it is not necessary to init the module via moduleHandler
    });
  });

  // init context menu entries (must be done after moduleContainer is ready)
  (0, _registerItems.default)();

  // #. Init negative logarithmic value extension for highcharts
  (0, _NegativeLogValue.default)();
  if (window.name && window.name.startsWith('popoutview')) {
    $(document.body).trigger('contextMenuEntriesRegistered');
  }

  // init Tooltips and Quickview
  window.ngpTooltip = new window.fcom.ui.TooltipText('ngpTooltip', {
    delayShow: 500,
    style: {
      width: '300px'
    }
  });
  window.ngpQuickview = new window.fcom.ui.Quickview('ngpQuickview', {
    delayShow: 750,
    delayHide: 750,
    hideOnMouseover: false,
    cssClasses: ['quickView']
  });

  // if(window.jsdebug) {
  //     // Log all postMessage data
  //     window.addEventListener('message', (e) => { console.log('postMessageData', e.data); }, false);
  // }

  var skiplinkTitle = window.getMessage('skiplink.main.title');
  if (skiplinkTitle && skiplinkTitle !== 'suppress-skip-link') {
    // #. Init the global skip link
    var $skipLink = new window.YAHOO.fcom.skipLink({
      title: skiplinkTitle,
      skipToLocation: '#page .pageTitle',
      insertBefore: 'body #mainFrame',
      cssClasses: ['skip-link-main']
    });

    // #. Render the skip link if content not checked yet
    if ($skipLink.contentChecked === false) {
      $skipLink.render();
    }
  }

  // #. Check the dom completely loaded or not
  var intId = setInterval(function () {
    if (document.readyState === 'complete') {
      clearInterval(intId);
      setFocusToLastSelectedMenuItem();
      initAccessibility();
    }
  }, 100);

  // #. Register window unload event
  window.addEventListener('beforeunload', function () {
    storeActiveMenuItem();
  });

  /**
   * @description Store active menu item to session storage
   * Active element dom path will be stores
   * sessionStorage: no need to keep the item after close the browser/tab
   */
  var storeActiveMenuItem = function storeActiveMenuItem() {
    var $activeElement = $(document.activeElement);
    var elPath;
    if ($activeElement.closest('.menu .menuItem').length > 0) {
      elPath = window.YAHOO.fcom.Util.getDomPath(document.activeElement, ' > ');
    }
    window.sessionStorage.setItem('lastActiveMenu', elPath);
  };

  /**
   * @description Set focus to active menu item
   * Active element path will be retrieved from the session storage
   */
  var setFocusToLastSelectedMenuItem = function setFocusToLastSelectedMenuItem() {
    var elPath = window.sessionStorage.getItem('lastActiveMenu');
    if (elPath) {
      $(elPath).focus();
    }
  };

  /**
   * @description Start the accessibility
   * Init accessibility of menus in the application
   * Init accessibility of tooltip target in the application
   */
  var initAccessibility = function initAccessibility() {
    _Accessibility.default.init({
      menu: {
        enabled: true,
        initDelay: 750
      },
      tooltip: {
        target: {
          selector: 'a.instrumentIdentification',
          attr: 'onmouseenter',
          contains: 'ngpQuickview.display'
        }
      },
      highCharts: {
        enabled: true
      }
    });
  };
});

},{"accessibility/Accessibility":2,"contextMenu/registerItems":41,"core/Ajax/checkServer":49,"floatingCols/ColumnContainer":58,"highstock/NegativeLogValue":59,"search/incrementalSearch":67,"streaming/AjaxStreaming":69,"streaming/StreamingIllustration":70}],55:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ColItemContainer = _interopRequireDefault(require("floatingCols/ColItemContainer"));
var _hooks = _interopRequireDefault(require("hooks"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var YAHOO = window.YAHOO;
var Dom = window.Dom;
var DDM = YAHOO.util.DragDropMgr;
var ColDD = function ColDD(id, sGroup, config, columnCount, parent) {
  ColDD.superclass.constructor.call(this, id, sGroup, config);
  // this.previewDiv = undefined; // the dotted square, showing where the module would go, when dropped
  // this.visibleEl = undefined; // the drag element that sticks to the mouse cursor
  this.externPreview;
  // this.elem = undefined;
  this.parent = parent;
  this.extern = config && config != null && config.extern;
  this.colDDconfig = config;
  window.Dom.setStyle(this.getDragEl(), 'opacity', 0.5); // Use a transparent drag&drop proxy
  this.goingUp = false;
  this.lastY = 0;
  this.lastX = 0;
  this.lastCol = null;
  this.colItem = null;
  this.xOffset = -1; // remember the x offset of the click (
  this.columnCount = columnCount;
  this.lastDeltaY = null; // to avoid dragdrop bottom flickering
};

YAHOO.extend(ColDD, window.YAHOO.util.DDProxy, {
  startDrag: function startDrag(x, y) {
    var _this = this;
    // make the proxy look like the source element
    var dragEl = this.getDragEl();
    this.elem = this.getEl();
    if (this.extern) {
      // first we close the module library:
      if (window.moduleLibPanel) {
        window.moduleLibPanel.hide();
      }

      // the visibleEl is the shared preview, steal look from it
      this.parent.copyContentAndStyle(this.externPreview, dragEl, true);

      // create a new div as spacer as long as we do not have the actual module
      this.elem = document.createElement('div');
      Dom.generateId(this.elem);
      this.visibleEl = null; // clear reference, so that it is created new from the new elem
      this.parent.copyContentAndStyle(this.externPreview, this.elem);
      var column = this.parent.getNearestColumn(x);
      if (this.lastCol == null) {
        this.lastCol = column;
      }
      var colElement = this.parent.getNearestColumnItem(column, y);
      if (colElement == null) {
        column.appendChild(this.elem);
      } else {
        var colElementColItem = this.parent.itemMap[colElement.id];
        if (colElement.id && colElement.id.indexOf('_sp_0') > -1) {
          colElement = colElement.previousElementSibling; // do not insert between multiColumn element and spacer
        }

        column.insertBefore(this.elem, colElement);
      }
      this.colItem = this.parent.itemMap[this.elem.id];
      if (!this.colItem || this.colItem == null) {
        this.colItem = new _ColItemContainer.default(this.elem.id, this.colDDconfig.colspan, this.parent.getColOffset(this.elem));
        this.colItem.resizerDiv = null;
        this.colItem.resizerDiv = null;
        this.colItem.colDD = this;
        this.parent.itemMap[this.elem.id] = this.colItem;
      }
      this.colItem.inProcess = true;
      this.colItem.contentUpdate = null;
      if (this.colItem.colspan > 1 && this.parent.columnCount > 2) {
        /**
         * Default 2 column module will only work if the the page layout is greater than 2.
         * This means the module needs to be displayed in 2 columns by default.
         * In this case we need to add spacers in the drag preview itself.
         * But ath this point of time the actual module id is not yet generated/available (we need module id to create spacers).
         * So we will create temporary spacers to manage the drag preview and add it to the DOM.
         * These temporary spacers will be removed once the module is dropped.
         */
        // TODO - add support for more than 2 column (default) modules.
        this.addTemporaryPreviewColSpacers();
      } else if (this.colItem.colspan > 1 && this.parent.columnCount <= 2) {
        // In this case the module is configured as 2 column by default. But the page layout override this rule.
        this.colItem.colspan--;
      }
      Dom.setStyle(dragEl, 'width', "".concat(column.offsetWidth * this.colItem.colspan, "px"));
      Dom.setStyle(dragEl, 'height', ''); // remove height
      Dom.setStyle(Dom.getElementsByClassName('moduleContent', 'div', dragEl)[0], 'height', "".concat(this.colDDconfig.height, "px"));
      Dom.setStyle(this.elem, 'width', "".concat(column.offsetWidth * this.colItem.colspan, "px"));
      Dom.setStyle(this.elem, 'visibility', 'hidden');
      Dom.setStyle(dragEl, 'position', 'absolute');
      if (this.colDDconfig.title) {
        dragEl.querySelector('.moduleHeader .title').innerHTML = this.colDDconfig.title;
      }
      _hooks.default.onModuleAdded(this.colDDconfig.class.substring(this.colDDconfig.class.lastIndexOf('.') + 1));
      var url = this.colDDconfig.url;
      if (url && url != null) {
        // static example will also run without ajax
        var that = this;
        var callback = {
          success: function success(o) {
            if (!o.argument[1].inProcess) {
              // item already situated in the dom => replace
              YAHOO.fcom.Page.replace(o.argument[0], o.responseText, {
                selectorConfig: {
                  selector: '',
                  apply: function apply(selector, target, node) {
                    var containerDiv = Dom.getFirstChildBy(node, function (elem) {
                      return Dom.hasClass(elem, 'moduleContainer');
                    });
                    target.parentNode.insertBefore(containerDiv, target);
                    target.parentNode.removeChild(target);
                    o.argument[2].addItem(containerDiv, o.argument[1].colspan, that.extern);
                    return containerDiv;
                  }
                }
              });
              o.argument[1].contentUpdate = null;
              o.argument[2].sendUpdateToServer();
              o.argument[2].correctMultiColElements(); // sometimes modules are much smaller than their preview => correction needed.
              // TODO: for performance reasons, the old colItem should be cleared and also the DD Handlers.
            } else {
              // if not yet situated, the endDrag method will replace the content
              o.argument[1].contentUpdate = o.responseText; // only set update into colItem
            }
          },

          argument: [this.elem, this.colItem, this.parent]
        };
        var postData = "viewId=".concat(this.parent.id);
        window.ngpAsyncRequest('POST', url, callback, postData);
      }
    } else {
      // normal element, not extern one
      Dom.setStyle(this.elem, 'visibility', 'hidden');
      this.colItem = this.parent.itemMap[this.id];
      this.parent.copyContentAndStyle(this.elem, dragEl, false);
      if (!this.colItem || this.colItem == null) {
        this.colItem = new _ColItemContainer.default(this.id, this.parent.setColspanFromWidth(this.elem.offsetWidth), this.parent.getColOffset(this.elem));
        this.colItem.resizerDiv = Dom.getElementsByClassName('resize', 'img', this.elem)[0];
        this.parent.itemMap[this.id] = this.colItem;
      }
      if (this.lastCol == null) {
        this.lastCol = this.parent.columns[this.colItem.colOffset];
      }
      this.elem.classList.add('module-dragging');
    }

    // arrange the preview pane which shows how the result would look like when droping here
    if (this.visibleEl == null) {
      this.visibleEl = this.elem;
      while (this.visibleEl != null && !Dom.hasClass(this.visibleEl, 'module')) {
        this.visibleEl = Dom.getFirstChild(this.visibleEl);
      }
      if (this.visibleEl == null) {
        this.visibleEl = this.elem;
      }
    }
    if (this.extern) {
      Dom.setStyle(Dom.getElementsByClassName('moduleContent', 'div', this.visibleEl)[0], 'height', "".concat(this.colDDconfig.height, "px"));
    }
    if (!this.previewDiv || this.previewDiv == null) {
      // preview not created, create one
      this.previewDiv = this.parent.preparePreviewPane();
      Dom.setStyle(this.previewDiv, 'position', 'absolute');
      Dom.setStyle(this.previewDiv, 'z-index', '10');
    }
    Dom.setStyle(this.previewDiv, 'display', '');
    Dom.setStyle(this.previewDiv, 'width', "".concat(this.visibleEl.offsetWidth, "px"));
    Dom.setStyle(this.previewDiv, 'height', "".concat(this.visibleEl.offsetHeight, "px"));
    if (this.extern && this.colItem.colspanSpacers) {
      // The height for preview spacers will be incorrect at this point.
      // So we will update the height of the spacers
      this.colItem.colspanSpacers.forEach(function (elm) {
        return Dom.setStyle(elm, 'height', "".concat(_this.visibleEl.offsetHeight, "px"));
      });
    }
    this.xOffset = x - Dom.getXY(dragEl)[0];
    this.lastY = y;
    Dom.setXY(this.previewDiv, Dom.getXY(this.visibleEl));
    Dom.setStyle(this.previewDiv, 'visibility', 'visible');
    this.parent.highlightRulers(true);
    this.parent.dragMask(true);
  },
  /**
   * This method is to add temporary spacers for handling the module preview.
   */
  addTemporaryPreviewColSpacers: function addTemporaryPreviewColSpacers() {
    var firstSpacer = null;
    var elementTop = Dom.getRegion(this.elem).top;
    firstSpacer = this.createSpacerElement("".concat(this.elem.id, "_sp_0"));
    YAHOO.fcom.Dom.appendBehind(firstSpacer, this.elem);
    Dom.setStyle(this.elem, 'position', 'absolute');
    Dom.setXY(this.elem, Dom.getXY(firstSpacer));
    var rightmostSpacer = this.createSpacerElement("".concat(this.elem.id, "_sp_").concat(this.colItem.colspan - 1));
    var columnNumber = this.colItem.colOffset + this.colItem.colspan - 1;
    columnNumber = columnNumber >= this.parent.columnCount ? this.parent.columnCount - 1 : columnNumber;
    var column = this.parent.columns[columnNumber];
    var childNodes = Dom.getChildrenBy(column, this.isModuleNode);
    if (!childNodes || childNodes == null || !childNodes.length) {
      column.appendChild(rightmostSpacer);
    } else {
      var inserted = false;
      for (var i = 0; i < childNodes.length; i++) {
        var currentRegion = Dom.getRegion(childNodes[i]);
        if (currentRegion.bottom > elementTop + 20) {
          // current node's bottom is realy lower than element top => insert before that node
          Dom.insertBefore(rightmostSpacer, childNodes[i]);
          inserted = true;
          break;
        }
      }
      if (!inserted) {
        column.appendChild(rightmostSpacer);
      }
      this.parent.handleMultiColItemConstraintsFromPeviousCol(rightmostSpacer, this.parent.columns[this.colItem.colspan + this.colItem.colOffset - 2]);
    }
    if (firstSpacer == null) {
      firstSpacer = this.colItem.colspanSpacers[0];
    }
    var left = Dom.getRegion(firstSpacer).left;
    var region = Dom.getRegion(rightmostSpacer);
    var right = region.right;
    Dom.setStyle(this.elem, 'width', "".concat(right - left, "px"));
    this.parent.correctMultiColElements();
  },
  /**
   * Method to create a spacer element
   * @param {*} id
   * @returns spacer element
   */
  createSpacerElement: function createSpacerElement(id) {
    var spacer = document.createElement('div'); // create a brand new div element ...
    spacer.setAttribute('id', id); // with the given id
    this.parent.itemMap[id] = this.colItem; // remember the colItem object with the id (to quickly find the underlying real element)
    if (this.colItem.colspanSpacers == null) {
      this.colItem.colspanSpacers = []; // the array holding all spacer elements
    }

    this.colItem.colspanSpacers.push(spacer); // append this newly created spacer to that array
    var imgElem = document.createElement('img');
    imgElem.src = "".concat(window.ctx + window.resourceFolderPrefix, "/ngp/img/blank.png");
    imgElem.width = '1';
    imgElem.height = '1';
    imgElem.alt = '';
    spacer.appendChild(imgElem);
    spacer.className = 'colspanSpacer'; // set the correct css class name (which is used to identify spacer elements somewhere else)
    Dom.setStyle(spacer, 'height', "".concat(this.elem.offsetHeight, "px"));
    Dom.setStyle(spacer, 'width', '100%'); // occupy full column
    Dom.setStyle(spacer, 'visibility', 'hidden'); // set the spacer hidden so that they are not seen, just reserve space for the underlying real element

    // for debug reason:
    var debugMulticolspans = false;
    if (debugMulticolspans) {
      Dom.setStyle(spacer, 'visibility', 'visible');
      Dom.setStyle(spacer, 'background-color', this.color);
    }
    return spacer;
  },
  endDrag: function endDrag() {
    var srcEl = this.elem;
    var dragEl = this.getDragEl();
    Dom.setStyle(srcEl, 'visibility', '');
    if (this.previewDiv && this.previewDiv != null) {
      Dom.setXY(this.previewDiv, [0, 0]);
      Dom.setStyle(this.previewDiv, 'display', 'none');
    }
    Dom.setXY(dragEl, [0, 0]);
    dragEl.innerHTML = ''; // remove contents of dragEl. It can contain duplicate IDs!

    if (this.extern) {
      // Removing the temporary added spacers for drag preview.
      if (this.colItem.colspanSpacers) {
        this.colItem.colspanSpacers.forEach(function (e) {
          e.remove();
        });
      }
      if (this.colItem.contentUpdate != null && this.colItem.contentUpdate.length > 0) {
        // content already available
        var that = this;
        YAHOO.fcom.Page.replace(this.elem, this.colItem.contentUpdate, {
          selectorConfig: {
            selector: '',
            apply: function apply(selector, target, node) {
              var containerDiv = Dom.getFirstChildBy(node, function (elem) {
                return Dom.hasClass(elem, 'moduleContainer');
              });
              target.parentNode.insertBefore(containerDiv, target);
              target.parentNode.removeChild(target);
              that.parent.addItem(containerDiv, that.colItem.colspan, that.extern);
              return containerDiv;
            }
          }
        });
        this.colItem.contentUpdate = null;
        this.parent.sendUpdateToServer(); // only send when already loaded, not with dummy content
        this.parent.correctMultiColElements();
        YAHOO.lang.later(50, this.parent, 'checkViewportResize', null, false);
      }
    } else {
      this.parent.sendUpdateToServer(); // only send when not extern
      YAHOO.lang.later(50, this.parent, 'checkViewportResize', null, false);
    }
    if (srcEl.classList.contains('module-dragging')) {
      srcEl.classList.remove('module-dragging');
      window.moduleDropped.fire(srcEl.id);
    }
    this.colItem.inProcess = false;
    this.parent.highlightRulers(false);
    this.parent.dragMask(false);
  },
  checkYPosition: function checkYPosition() {
    var somethingMoved = false;
    if (this.goingUp) {
      // when going up, we search the element(s) with maximum bottom
      var maxBottom = 0;
      var currBottom = 0;
      var elem = null;
      for (var i = 0; i < this.colItem.colspan; i++) {
        var previousElem = null;
        if (this.colItem.colspan === 1) {
          elem = this.elem;
          previousElem = this.getPreviousModule(elem, this.colItem.id);
        } else {
          elem = this.colItem.colspanSpacers[i];
          previousElem = this.getPreviousModule(elem, this.colItem.id);
        }
        if (previousElem != null) {
          currBottom = Dom.getRegion(previousElem).bottom;
          if (currBottom > maxBottom) {
            maxBottom = currBottom;
          }
        }
      }
      if (maxBottom - 20 < Dom.getRegion(this.getDragEl()).top) {
        // if element is not yet overlapping enough, just jump out
        return;
      }
      for (var _i = 0; _i < this.colItem.colspan; _i++) {
        if (this.colItem.colspan === 1) {
          elem = this.elem;
        } else {
          elem = this.colItem.colspanSpacers[_i];
        }
        var _previousElem = this.getPreviousModule(elem, this.colItem.id);
        if (_previousElem != null) {
          currBottom = Dom.getRegion(_previousElem).bottom;
          if (currBottom === maxBottom && this.parent.isModuleNode(_previousElem)) {
            elem.parentNode.insertBefore(elem, _previousElem);
            somethingMoved = true;
          }
        }
      }
    } else {
      /* when going down, we search all elements that have already enough room above the
       * draged element, if there is none, the one with the minimum overlap is taken. */
      var minOverlap = 90000;
      var minOverlapElem = null;
      window.nextSiblingsArray = new Array(this.colItem.colspan);
      window.overlapsArray = new Array(this.colItem.colspan);
      var _elem = null;
      var dragRegion = Dom.getRegion(this.getDragEl());
      for (var _i2 = 0; _i2 < this.colItem.colspan; _i2++) {
        if (this.colItem.colspan === 1) {
          _elem = this.elem;
        } else {
          _elem = this.colItem.colspanSpacers[_i2];
        }
        var nextElem = Dom.getNextSiblingBy(_elem, this.parent.isModuleNode);
        if (nextElem != null) {
          var nextElemColItem = this.parent.itemMap[nextElem.id];
          if (nextElemColItem && nextElemColItem != null && nextElemColItem.colspan > 1 && !this.parent.isColspanSpacer(nextElem)) {
            nextElem = nextElemColItem.colspanSpacers[0];
          }
          var _previousElem2 = this.getPreviousModule(_elem, this.colItem.id);
          window.nextSiblingsArray[_i2] = nextElem;
          var nextRegion = Dom.getRegion(nextElem);
          if (nextRegion.top + 20 > dragRegion.bottom) {
            return; // elements are not overlapping enough yet, just jump out
          }

          var previousBottom = 0;
          if (_previousElem2 != null) {
            previousBottom = Dom.getRegion(_previousElem2).bottom;
          } else {
            previousBottom = Dom.getRegion(_elem).top;
          }
          var overlap = previousBottom + nextRegion.bottom - dragRegion.top;
          if (overlap < minOverlap) {
            minOverlap = overlap;
            minOverlapElem = nextElem;
          }
          window.overlapsArray[_i2] = overlap;
        }
      }
      if (minOverlapElem == null) {
        return; // there seems to be no further item to move up...
      }

      /*
       * when the minoverlap is a multi colspan, look for all spacers and move them up,
       * otherwise just move the minoverlap up.
       */
      var nextColItem = this.parent.itemMap[minOverlapElem.id];
      for (var _i3 = 0; _i3 < this.colItem.colspan; _i3++) {
        if (this.colItem.colspan === 1) {
          _elem = this.elem;
        } else {
          _elem = this.colItem.colspanSpacers[_i3];
        }
        if (this.parent.isColspanSpacer(window.nextSiblingsArray[_i3])) {
          if (this.parent.itemMap[window.nextSiblingsArray[_i3].id].id === nextColItem.id) {
            _elem.parentNode.insertBefore(window.nextSiblingsArray[_i3], _elem);
            if (window.nextSiblingsArray[_i3].id === nextColItem.colspanSpacers[0].id) {
              // first spacer, also move element itself
              _elem.parentNode.insertBefore(Dom.get(nextColItem.id), window.nextSiblingsArray[_i3]);
            }
            somethingMoved = true;
          } else if (window.overlapsArray[_i3] === minOverlap) {
            _elem.parentNode.insertBefore(window.nextSiblingsArray[_i3], _elem);
            var extraColItem = this.parent.itemMap[window.nextSiblingsArray[_i3].id];
            if (window.nextSiblingsArray[_i3].id === extraColItem.colspanSpacers[0].id) {
              // first spacer, also move element itself
              _elem.parentNode.insertBefore(Dom.get(extraColItem.id), window.nextSiblingsArray[_i3]);
            }
            somethingMoved = true;
          }
        } else if (window.overlapsArray[_i3] === minOverlap && window.nextSiblingsArray[_i3] != null) {
          _elem.parentNode.insertBefore(window.nextSiblingsArray[_i3], _elem);
          somethingMoved = true;
        }
      }
    }
    if (somethingMoved) {
      if (this.colItem.colspan > 1) {
        this.colItem.colspanSpacers[0].parentNode.insertBefore(this.elem, this.colItem.colspanSpacers[0]);
      }
      this.parent.correctMultiColElements();
      Dom.setXY(this.previewDiv, Dom.getXY(this.visibleEl));
      DDM.refreshCache();
    }
  },
  onDrag: function onDrag(e) {
    // Keep track of the direction of the drag for use during onDragOver
    var y = YAHOO.util.Event.getPageY(e);
    if (y < this.lastY - 10) {
      this.goingUp = true;
      this.lastY = y;
      this.checkYPosition(y);
      return; // only do a shift in one direction at a time (not also column change)
    } else if (y > this.lastY + 10) {
      this.goingUp = false;
      this.lastY = y;
      this.checkYPosition(y);
      return; // only do a shift in one direction at a time (not also column change)
    }

    var x = YAHOO.util.Event.getPageX(e) - this.xOffset;
    if (Math.abs(this.lastX - x) < 30) {
      return; // don't calculate too often
    }

    // find the x coordinate of the draged element and calculate with that, rather than with cursor position.
    var dragLeft = Dom.getRegion(this.getDragEl()).left;
    for (var i = 0; i < this.columnCount; i++) {
      var currentCol = this.parent.columns[i];
      var region = Dom.getRegion(currentCol);
      if (region.right < dragLeft) {
        continue; // element is further right than that column
      }

      if (dragLeft > region.left + (region.right - region.left) / 2) {
        continue; // element only takes less than half of that column => shift to next column
      }

      if (currentCol === this.lastCol) {
        return; // nothing changed, jump out
      }

      this.handleColumnShift(x, y, currentCol);
      break;
    }
    this.lastX = x;
  },
  getTargetCoord: function getTargetCoord(iPageX, iPageY) {
    var x = iPageX - this.deltaX;
    var y = iPageY - this.deltaY;
    var dragEl = this.getDragEl();
    var restrictedArea = document.getElementById('mainFrame');
    if (restrictedArea) {
      var restrictRegion = Dom.getRegion(restrictedArea);
      var elRegion = Dom.getRegion(dragEl);
      if (iPageX - this.deltaX + elRegion.width >= restrictRegion.right) {
        this.setDelta(iPageX - elRegion.left, this.deltaY);
        x = restrictRegion.right - elRegion.width;
      }
      if (y + elRegion.height >= restrictRegion.bottom) {
        // to avoid screen flickering when scroll reached bottom
        // keeping lastDeltaY
        if (!this.lastDeltaY) {
          this.lastDeltaY = iPageY - elRegion.top;
        }
        this.setDelta(this.deltaX, this.lastDeltaY);
        y = restrictRegion.bottom - elRegion.height;
      } else if (y + elRegion.height < restrictRegion.bottom) {
        // reset lastDeltaY when dragged to top
        this.lastDeltaY = null;
      }
    }
    if (this.constrainX) {
      if (x < this.minX) {
        x = this.minX;
      }
      if (x > this.maxX) {
        x = this.maxX;
      }
    }
    if (this.constrainY) {
      if (y < this.minY) {
        y = this.minY;
      }
      if (y > this.maxY) {
        y = this.maxY;
      }
    }
    x = this.getTick(x, this.xTicks);
    y = this.getTick(y, this.yTicks);
    return {
      x: x,
      y: y
    };
  },
  /*
   * get the module (or module spacer) that is the previous sibling to that element.
   * The id is needed to check that the previous element is not the multi colspan element
   * of a colspan spacer. If there is no previous element, null is returned
   */
  getPreviousModule: function getPreviousModule(elem, id) {
    var previousElem = Dom.getPreviousSiblingBy(elem, this.parent.isModuleNode);
    if (previousElem != null && previousElem.id === id) {
      // do not use the own element as previous element
      previousElem = Dom.getPreviousSiblingBy(previousElem, this.parent.isModuleNode);
    }
    return previousElem;
  },
  /**
    * function to handle shifting a module one column left or right and also find out whether it's already required
   * or even possible at all (module might already be occupying the outmost column)
   */
  handleColumnShift: function handleColumnShift(x, y, destCol) {
    var srcEl = this.elem;
    var currOffset = this.colItem.colOffset;
    var desiredColOffset = this.parent.getColOffset(destCol);
    if (desiredColOffset > currOffset) {
      // moving right
      desiredColOffset = currOffset + 1; // limit to maximum one move right
      if (this.colItem.colspan + desiredColOffset > this.columnCount) {
        return; // item already occupying rightmost column no further move possible => ignore drag and drop
      }

      var elem = srcEl;
      for (var i = 0; i < this.colItem.colspan; i++) {
        if (this.colItem.colspan > 1) {
          elem = this.colItem.colspanSpacers[i];
          if (i < this.colItem.colspan - 1) {
            var newParentCol = this.colItem.colspanSpacers[i + 1].parentNode;
            newParentCol.insertBefore(elem, this.colItem.colspanSpacers[i + 1]);
            if (i === 0) {
              // work on first spacer, also move real element to the same column:
              newParentCol.insertBefore(this.elem, elem); // insert element in fornt of first spacer
            }

            continue;
          }
        } // last spacer still needs to be placed

        var _destCol = this.parent.columns[this.colItem.colspan + currOffset];
        var destEl = this.parent.getNearestColumnItem(_destCol, y);
        if (destEl == null) {
          _destCol.appendChild(elem);
        } else if (this.goingUp) {
          if (destEl.id.indexOf('_sp_0') > -1) {
            destEl = destEl.previousElementSibling; // do not put in between spacer and parent element
          }

          _destCol.insertBefore(elem, destEl); // temporarily insert above (but check whether that's a valid position concerning constraints)
        } else {
          var nextElem = destEl.nextElementSibling;
          if (nextElem && nextElem.id.indexOf('_sp_0') > -1) {
            destEl = nextElem; // put behind spacer not in between parent element and spacer
          }

          YAHOO.fcom.Dom.appendBehind(elem, destEl); // temporarily insert below (but check whether that's a valid position concerning constraints)
        }

        if (this.colItem.colspan > 1) {
          this.parent.handleMultiColItemConstraintsFromPeviousCol(elem, this.parent.columns[this.colItem.colspan + currOffset - 1]);
        }
        this.lastCol = this.parent.columns[currOffset + 1];
        this.colItem.colOffset = currOffset + 1;
      }
    } else if (desiredColOffset < currOffset) {
      // this is only possible if currOffset is > 0
      desiredColOffset = currOffset - 1; // limit to maximum one move to the left
      var _elem2 = srcEl;
      for (var _i4 = this.colItem.colspan - 1; _i4 >= 0; _i4--) {
        if (this.colItem.colspan > 1) {
          _elem2 = this.colItem.colspanSpacers[_i4];
          if (_i4 > 0) {
            var _newParentCol = this.colItem.colspanSpacers[_i4 - 1].parentNode;
            _newParentCol.insertBefore(_elem2, this.colItem.colspanSpacers[_i4 - 1]);
            continue;
          }
        } // last spacer needs to be packed somewhere, taking care that it is not creating impossible layouts

        var _destCol2 = this.parent.columns[currOffset - 1];
        var _destEl = this.parent.getNearestColumnItem(_destCol2, y);
        if (_destEl == null) {
          _destCol2.appendChild(_elem2);
        } else if (this.goingUp) {
          if (_destEl.id.indexOf('_sp_0') > -1) {
            _destEl = _destEl.previousElementSibling; // do not put in between spacer and parent element
          }

          _destCol2.insertBefore(_elem2, _destEl); // insert above
        } else {
          var _nextElem = _destEl.nextElementSibling;
          if (_nextElem && _nextElem.id.indexOf('_sp_0') > -1) {
            _destEl = _nextElem; // put behind spacer not in between parent element and spacer
          }

          YAHOO.fcom.Dom.appendBehind(_elem2, _destEl); // insert below
        }

        if (this.colItem.colspan > 1) {
          //
          this.parent.handleMultiColItemConstraintsFromPeviousCol(_elem2, this.colItem.colspanSpacers[1].parentNode);
          _destCol2.insertBefore(this.elem, _elem2); // insert element in front of first spacer
        }

        this.lastCol = _destCol2;
        this.colItem.colOffset = currOffset - 1;
      }
    } else {
      // not right but also not left, just bail out
      return;
    }
    if (this.colItem.colspan > 1) {
      // move visible element to the same column as the colspanSpacers
      var elementXY = Dom.getXY(srcEl);
      var firstSpacerXY = Dom.getXY(this.colItem.colspanSpacers[0]);
      elementXY[0] = firstSpacerXY[0]; // set the x-coordinate to the x-coordinate of the first colspan spacer
      Dom.setXY(srcEl, elementXY);
    }

    // place preview with the same size where the src element will be located.
    DDM.refreshCache();
    this.parent.correctMultiColElements();
    Dom.setXY(this.previewDiv, Dom.getXY(this.visibleEl));
  }
});
var _default = exports.default = ColDD;

},{"floatingCols/ColItemContainer":56,"hooks":60}],56:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * Provides an object for the item container informations
 */
var ColItemContainer = function ColItemContainer(id, colspan, colOffset) {
  this.id = id;
  this.colspan = colspan;
  this.colOffset = colOffset;
  this.colspanSpacers = [];
  this.resizerDiv = null;
  this.colDD = null;
  this.resizeDD = null;
  this.inProcess = false; // when in process, the user is dragging the element, otherwise it's statically in the dom tree
  this.contentUpdate = null; // when a colItem is only a drag dummy and is waiting for cconten from ajax, the content will be put here
  this.isConfigurable = window.Dom.hasClass(this.id, 'configurable');
  /*
   * Fires when container resizes, subscriber function is called with this item as second parameter (first is event type)
   * @type YAHOO.util.CustomEvent
   */
  this.resizeEvent = new window.YAHOO.util.CustomEvent('column-container-resize', this, false, window.YAHOO.util.CustomEvent.FLAT);
};
var _default = exports.default = ColItemContainer;

},{}],57:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ColItemContainer = _interopRequireDefault(require("floatingCols/ColItemContainer"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var YAHOO = window.YAHOO;
var Dom = window.Dom;

/*
 * ColResize is a class that extends from YAHOO.util.DDProxy and it used to control
 * the horizontal resize of module items in the floating column container.
 * Each module item that should be able to be stretched over several columns need an instance
 * of a ColResize class.
 */
var ColResize = function ColResize(id, sGroup, config, columnCount, parentContainer) {
  ColResize.superclass.constructor.call(this, id, sGroup, config);
  this.lastXPos = -1; // the x position when on drag was called last time
  // color only for debug reason to see invisible elements
  this.color = "#".concat(parseInt(10 + Math.random() * 89.0, 10)).concat(parseInt(10 + Math.random() * 89.0, 10)).concat(parseInt(10 + Math.random() * 89.0, 10));
  this.lastWidth = 0;
  this.dragWidth = 0;
  this.halfColumnWidth = 0; // helper variable to quickly check whether already to increase or decrease the size by one column
  this.visiblePart = null; // the visible part of the div tree, the reference is needed to quickly redraw the preview element
  this.columnCount = columnCount; // number of available columns in the underlying floating column container
  this.parent = parentContainer; // remember the floating column container reference
};

YAHOO.extend(ColResize, YAHOO.util.DD, {
  startDrag: function startDrag(x) {
    var tmpNode = this.getEl();
    while (!Dom.hasClass(tmpNode, 'module')) {
      // walk up until the module is found
      tmpNode = tmpNode.parentNode;
    }
    this.visiblePart = tmpNode; // set the visible part variable, which refers to the div object that is actually visible to the user
    if (!this.preview || this.preview == null) {
      // preview not created, create one
      this.preview = this.parent.preparePreviewPane();
      Dom.setStyle(this.preview, 'position', 'absolute');
      Dom.setStyle(this.preview, 'z-index', '10');
      Dom.setStyle(this.preview, 'visibility', 'hidden'); // but keep it invisible until it realy looks like it should
    }

    // the actual element is the div all around the visible div, having the moduleContainer class
    if (!this.elem || this.elem == null) {
      this.elem = this.visiblePart;
      while (!Dom.hasClass(this.elem, 'moduleContainer')) {
        this.elem = this.elem.parentNode; // walk up the parent nodes until the correct item is found
      }
    }

    // now prepare the preview div to have the same dimensions as the visible part of the item
    Dom.setStyle(this.preview, 'width', "".concat(this.visiblePart.offsetWidth, "px"));
    Dom.setStyle(this.preview, 'height', "".concat(this.visiblePart.offsetHeight, "px"));
    var visibleXY = Dom.getXY(this.visiblePart);
    Dom.setStyle(this.preview, 'display', '');
    Dom.setStyle(this.preview, 'position', 'absolute');
    Dom.setXY(this.preview, visibleXY);
    Dom.setStyle(this.preview, 'visibility', 'visible'); // eventually display the preview. For now at the old position

    this.lastXPos = x; // initialize the xPos

    /* now create a copy of the actual element, to use it as a drag'n drop proxy. YUI sais that this is better to avoid
       side effects when the drag'n drop library works on the css of the draged element. The real element is just hidden,
       and only when the drag drop operation is finished it get's moved in the dom tree to the new position. The
       drag proxy gets invisible for later reuse */

    this.dragElem = document.createElement('div');
    Dom.setStyle(this.dragElem, 'position', 'absolute');
    this.elem.parentNode.insertBefore(this.dragElem, this.elem);
    this.parent.copyContentAndStyle(this.elem, this.dragElem, true);
    window.onElementResizeDrag.fire(this.elem, this.dragElem);
    this.dragWidth = this.elem.offsetWidth; // remember some sizes
    this.lastWidth = this.elem.offsetWidth;
    Dom.setStyle(this.dragElem, 'height', "".concat(this.elem.offsetHeight, "px"));
    Dom.setStyle(this.dragElem, 'opacity', 0.5); // Use a transparent drag&drop proxy
    Dom.setStyle(this.dragElem, 'visibility', 'visible');
    Dom.setStyle(this.dragElem, 'display', ''); // eventually show the drag proxy element

    Dom.setStyle(this.elem, 'visibility', 'hidden'); // original real element gets invisible

    // check if the colItem for this element is already created, if not do so.
    this.colItem = this.parent.itemMap[this.elem.id];
    if (!this.colItem || this.colItem == null) {
      this.colItem = new _ColItemContainer.default(this.elem.id, this.parent.setColspanFromWidth(this.elem.offsetWidth), this.parent.getColOffset(this.elem));
      this.colItem.resizerDiv = this.getEl();
      this.parent.itemMap[this.elem.id] = this.colItem;
    }
    this.colItem.inProcess = true;
    if (!this.colItem.resizerDiv || this.colItem.resizerDiv == null) {
      this.colItem.resizerDiv = this.getEl();
    }
    Dom.setStyle(this.getDragEl(), 'display', '');
    Dom.setStyle(this.getDragEl(), 'visibility', 'hidden');
    Dom.setStyle(document.body, 'cursor', 'e-resize'); // change the cursor for the duration of the drag operation
    var firstCol = this.parent.columns[0];
    var columnRegion = Dom.getRegion(firstCol);
    this.halfColumnWidth = (columnRegion.right - columnRegion.left) / 2;
    this.parent.highlightRulers(true);
    this.parent.dragMask(true);
  },
  endDrag: function endDrag() {
    Dom.setStyle(document.body, 'cursor', 'auto');
    this.dragElem.parentNode.removeChild(this.dragElem); // TODO: what element is removed here actually and why???
    // TODO: find out what element is sticking out of the doc and creates a scrollbar

    /* make the preview invisible and the actual element visible. The element is already how it should be, all steps are done
       in the increase or decrease colspan methods */
    Dom.setXY(this.preview, [0, 0]);
    Dom.setStyle(this.preview, 'display', 'none');
    Dom.setStyle(this.preview, 'visibility', 'hidden');
    Dom.setStyle(this.elem, 'visibility', 'visible');
    this.lastXPos = -1;
    this.colItem.inProcess = false;
    this.parent.sendUpdateToServer();
    window.onElementResize.fire(this.elem);
    this.parent.highlightRulers(false);
    this.parent.dragMask(false);
    YAHOO.lang.later(50, this.colItem, function (floatingColumnLayout) {
      floatingColumnLayout.removeStaticContainerHeight();
      if (floatingColumnLayout.checkViewportResize(true)) {
        this.resizeEvent.fire(this);
      }
      YAHOO.util.Dom.setStyle(this.id, 'left', ''); // remove left style, which was used when element was moved around the page
    }, this.parent, false); // has to be delayed so that javascript redrawed in between
    /*
    var applets = Dom.getElementsBy(function(n){return true;}, "applet", this.elem);
    if (applets && applets!= null && applets.length > 0) {
        for (var i = 0; i < applets.length; i++) {
            var divRegion = Dom.getRegion(applets[i].parentNode);
            applets[i].setBounds(0, 0, (divRegion.right - divRegion.left), (divRegion.bottom - divRegion.top));
        }
    }
    TODO: applet hack removed, test and remove completely
    */
  },

  onDrag: function onDrag(e) {
    // Keep track of the direction of the drag for use during onDragOver
    var x = YAHOO.util.Event.getPageX(e);

    // sometimes the iPAD (and maybe other touch clients) have here x-value of 0, which is
    // invalid. In this case the onDrag is ignored
    var ua = window.navigator.userAgent.toLowerCase();
    var isAndroid = ua.indexOf('android') > -1; //&& ua.indexOf("mobile");
    var supportTouch = (typeof Touch === "undefined" ? "undefined" : _typeof(Touch)) === 'object' || isAndroid;
    if (supportTouch && x === 0) {
      return;
    }
    this.dragWidth = this.dragWidth + (x - this.lastXPos);
    if (this.dragWidth < 0) {
      this.dragWidth = 0;
    }
    this.lastXPos = x;
    var restrictedArea = document.getElementById('mainFrame');
    if (restrictedArea) {
      var dragElemRegion = Dom.getRegion(this.dragElem);
      var restrictRegion = Dom.getRegion(restrictedArea);
      if (dragElemRegion.left + this.dragWidth > restrictRegion.right) {
        return;
      }
    }
    Dom.setStyle(this.dragElem, 'width', "".concat(this.dragWidth, "px"));

    // only if the preview width exceeds the middle of the next column, increase or decrease by one column
    if (this.dragWidth - this.lastWidth > this.halfColumnWidth + 10) {
      this.increaseColspan();
      this.lastWidth = this.preview.offsetWidth;
    } else if (this.lastWidth - this.dragWidth > this.halfColumnWidth + 10) {
      this.decreaseColspan();
      this.lastWidth = this.preview.offsetWidth;
    }
  },
  /**
   * This method is for handling the default multi column layout for modules.
   * Here we are reusing the existing increaseColspan() method.
   * @param {*} element DOM element for the visible div, having the moduleContainer class
   */
  handleDefaultMultiColumns: function handleDefaultMultiColumns(element) {
    // TODO - add support for more than 2 column (default) modules
    this.elem = element;
    this.colItem = this.parent.itemMap[this.elem.id];
    this.colItem.colspan--;
    this.increaseColspan(true);
  },
  decreaseColspan: function decreaseColspan() {
    if (this.colItem.colspan > 1) {
      this.colItem.colspan--;

      // remove the rightmost colspan spacer from colItem and dom tree
      var needlessSpacer = this.colItem.colspanSpacers[this.colItem.colspan];
      this.colItem.colspanSpacers[this.colItem.colspan] = null;
      if (needlessSpacer && needlessSpacer != null) {
        needlessSpacer.parentNode.removeChild(needlessSpacer);
      }

      // if this element has no colspan any more ..
      if (this.colItem.colspan === 1) {
        // do everything to include it into the div structure again
        this.colItem.colspanSpacers[0].parentNode.replaceChild(this.elem, this.colItem.colspanSpacers[0]);
        Dom.setStyle(this.elem, 'position', 'static');
        Dom.setStyle(this.elem, 'width', '100%');
        this.colItem.colspanSpacers[0] = null;
      } else {
        // if not, set the new width to the element
        var left = Dom.getRegion(this.colItem.colspanSpacers[0]).left;
        var right = Dom.getRegion(this.colItem.colspanSpacers[this.colItem.colspan - 1]).right;
        Dom.setStyle(this.elem, 'width', "".concat(right - left, "px"));
      }
      this.parent.correctMultiColElements();
      Dom.setStyle(this.preview, 'width', "".concat(this.visiblePart.offsetWidth, "px"));
      Dom.setStyle(this.preview, 'height', "".concat(this.visiblePart.offsetHeight, "px"));
      Dom.setXY(this.preview, Dom.getXY(this.visiblePart));
    }
  },
  increaseColspan: function increaseColspan() {
    var skipPreview = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (this.colItem.colspan + this.colItem.colOffset < this.columnCount) {
      //only when the element is not already occupying the last column
      var firstSpacer = null;
      var elementTop = Dom.getRegion(this.elem).top;
      if (this.colItem.colspan === 1) {
        // initial colspan => remove element from div columns
        firstSpacer = this.createSpacerElement("".concat(this.elem.id, "_sp_0")); // TODO: add methods to the floatingColClass that take care the element ids don't use single underscores
        YAHOO.fcom.Dom.appendBehind(firstSpacer, this.elem);
        Dom.setStyle(this.elem, 'position', 'absolute');
        Dom.setXY(this.elem, Dom.getXY(firstSpacer));
      }
      this.colItem.colspan++;
      var rightmostSpacer = this.createSpacerElement("".concat(this.elem.id, "_sp_").concat(this.colItem.colspan - 1));
      var columnNumber = this.colItem.colOffset + this.colItem.colspan - 1;
      var column = this.parent.columns[columnNumber];
      var childNodes = Dom.getChildrenBy(column, this.isModuleNode);
      if (!childNodes || childNodes == null || !childNodes.length) {
        column.appendChild(rightmostSpacer);
      } else {
        var inserted = false;
        for (var i = 0; i < childNodes.length; i++) {
          var currentRegion = Dom.getRegion(childNodes[i]);
          if (currentRegion.bottom > elementTop + 20) {
            // current node's bottom is realy lower than element top => insert before that node
            Dom.insertBefore(rightmostSpacer, childNodes[i]);
            inserted = true;
            break;
          }
        }
        if (!inserted) {
          column.appendChild(rightmostSpacer);
        }
        this.parent.handleMultiColItemConstraintsFromPeviousCol(rightmostSpacer, this.parent.columns[this.colItem.colspan + this.colItem.colOffset - 2]);
      }
      if (firstSpacer == null) {
        firstSpacer = this.colItem.colspanSpacers[0];
      }
      var left = Dom.getRegion(firstSpacer).left;
      var region = Dom.getRegion(rightmostSpacer);
      var right = region.right;
      Dom.setStyle(this.elem, 'width', "".concat(right - left, "px"));
      this.parent.correctMultiColElements();
      if (!skipPreview) {
        Dom.setStyle(this.preview, 'width', "".concat(this.visiblePart.offsetWidth, "px"));
        Dom.setStyle(this.preview, 'height', "".concat(this.visiblePart.offsetHeight, "px"));
        Dom.setXY(this.preview, Dom.getXY(this.visiblePart));
      }
    }
  },
  createSpacerElement: function createSpacerElement(id) {
    var spacer = document.createElement('div'); // create a brand new div element ...
    spacer.setAttribute('id', id); // with the given id
    this.parent.itemMap[id] = this.colItem; // remember the colItem object with the id (to quickly find the underlying real element)
    if (this.colItem.colspanSpacers == null) {
      this.colItem.colspanSpacers = []; // the array holding all spacer elements
    }

    this.colItem.colspanSpacers[this.colItem.colspan - 1] = spacer; // append this newly created spacer to that array
    var imgElem = document.createElement('img');
    imgElem.src = "".concat(window.ctx + window.resourceFolderPrefix, "/ngp/img/blank.png");
    imgElem.width = '1';
    imgElem.height = '1';
    imgElem.alt = '';
    spacer.appendChild(imgElem);
    spacer.className = 'colspanSpacer'; // set the correct css class name (which is used to identify spacer elements somewhere else)
    Dom.setStyle(spacer, 'height', "".concat(this.elem.offsetHeight, "px"));
    Dom.setStyle(spacer, 'width', '100%'); // occupy full column
    Dom.setStyle(spacer, 'visibility', 'hidden'); // set the spacer hidden so that they are not seen, just reserve space for the underlying real element

    // for debug reason:
    var debugMulticolspans = false;
    if (debugMulticolspans) {
      Dom.setStyle(spacer, 'visibility', 'visible');
      Dom.setStyle(spacer, 'background-color', this.color);
    }
    return spacer;
  }
});
var _default = exports.default = ColResize;

},{"floatingCols/ColItemContainer":56}],58:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ColDD = _interopRequireDefault(require("floatingCols/ColDD"));
var _ColItemContainer = _interopRequireDefault(require("floatingCols/ColItemContainer"));
var _ColResize = _interopRequireDefault(require("floatingCols/ColResize"));
var _hooks = _interopRequireDefault(require("hooks"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var YAHOO = window.YAHOO;
var Dom = YAHOO.util.Dom;
window.viewChangedEvent = new YAHOO.util.CustomEvent('onViewChangedEvent');

/*
 * Provides an object for the floating column container. The
 * elementId is the id of the div used as container.
 * TODOs:
 * - there seems to be several updates to the server per new module instance!!
 */
var ColumnContainer = function ColumnContainer(elementId, columnCount, sequenceNumber, config) {
  this.id = elementId; // id to enable several floating column containers on one html page
  this.columnCount = columnCount; // number of columns in the container
  this.itemMap = {}; // a map to quickly find columnItem instances by id
  this.columns = new Array(columnCount); // an array with references to the column divs
  this.outOfSync = {}; // TODO: make a linked list instead of an boolean
  this.sequenceNumber = sequenceNumber;
  this.screenWidth = Dom.getViewportWidth();
  this.screenHeight = Dom.getViewportHeight();
  this.nextViewportResizeCheck = null;
  this.config = config;
  if (!config || config == null) {
    this.config = {};
  }
  if (this.config.dragDropEnabled !== false) {
    this.config.dragDropEnabled = true;
  }
  /* when the window is resized, we make a delayed call to correct the view. in between, all
   * further resize events are ignored. Delay is important, as the resize is called
   * a lot of times when the window is resized, but the reorganization is an expensive action
   */
  YAHOO.util.Event.addListener(window, 'resize', function (eventArg, container) {
    if (container.nextViewportResizeCheck == null) {
      /* no reorganization already waiting? */
      container.nextViewportResizeCheck = YAHOO.lang.later(500, null, function (container) {
        container.checkViewportResize();
        container.nextViewportResizeCheck = null;
      }, container, false); // create a new reorganization
    }
  }, this, true);
  YAHOO.fcom.Page.onResize(function () {
    this.checkViewportResize();
  }, this, true);
  if (window.forceResizeEvent != null) {
    window.forceResizeEvent.subscribe(function () {
      this.checkViewportResize(true);
    }, this, true);
  }
  window.domToYUIMap[this.id] = this;
  this.readyLoaded = true;
};
ColumnContainer.prototype = {
  init: function init() {
    if (!this.columns[0] || this.columns[0] == null) {
      this.initializeColumns();
    }
    this.correctMultiColElements(true);
    if (this.nextViewportResizeCheck == null) {
      /* no reorganization already waiting? */
      this.nextViewportResizeCheck = YAHOO.lang.later(10, null, function (container) {
        container.checkViewportResize(true);
        container.nextViewportResizeCheck = null;
      }, this, false); // create a new reorganization
    }
  },

  /*
   * set whether this floating column layout is allowed to be changed by the user
   * @param editAllowed is the user allowed to change the content of the floating column layout
   */
  setEditAllowed: function setEditAllowed(editAllowed) {
    this.editAllowed = editAllowed;
  },
  /*
   * @return whether this floating column layout is allowed to be changed by the user
   */
  getEditAllowed: function getEditAllowed() {
    return this.editAllowed || false;
  },
  /*
   * get the handler for the module with the given module id
   */
  getModuleHandler: function getModuleHandler(moduleId) {
    return this.itemMap[moduleId];
  },
  /*
   * check whether the module with the given id is a valid module and has attributes that can be
   * edited by the user. In any other case false is returned
   * @param moduleId the module id to check for
   * @return true if the user is allowed to edit the module with the specified module id
   */
  isModuleEditable: function isModuleEditable(moduleId) {
    if (!this.getEditAllowed()) {
      return false;
    }
    var module = this.itemMap[moduleId];
    return module != null && module.isConfigurable != null && module.isConfigurable;
  },
  /*
   * whether this node is an element that plays a role in the drag'n drop module flow
   */
  isModuleNode: function isModuleNode(elem) {
    return elem && elem.nodeType === 1 // existing DOM node reference
    && !Dom.hasClass(elem, 'previewPane') && !Dom.hasClass(elem, 'preview') // not the div used for displaying module previews
    && !Dom.hasClass(elem, 'hiddenColumnSpacer') // TODO: remove, is not used any more
    && (Dom.hasClass(elem, 'moduleContainer') || Dom.hasClass(elem, 'colspanSpacer')); // either a module div or a spacer div of a multi col element
  },

  initializeColumns: function initializeColumns() {
    var columnNodes = YAHOO.fcom.Dom.getDescendantsBy(Dom.get(this.id), function (childNode) {
      return Dom.hasClass(childNode, 'dragColumn');
    });

    // TODO: when not enough columnNodes are found, append them.
    for (var columnNumber = 0; columnNumber < this.columnCount; columnNumber++) {
      new YAHOO.util.DDTarget(columnNodes[columnNumber].id, 'columnCont');
      this.columns[columnNumber] = columnNodes[columnNumber];
    }
  },
  addItem: function addItem(itemElement, colspan) {
    var isExternal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    /* TODO itemElement should work as element and as string
     * - colspan is not yet read
     */
    itemElement = Dom.get(itemElement);
    if (!itemElement.id || itemElement.id == null) {
      Dom.generateId(itemElement);
    }
    if (this.columns[0] == null) {
      this.initializeColumns();
    }
    if (Dom.hasClass(itemElement, 'ruler')) {
      if (!this.rulers) {
        this.rulers = [];
      }
      this.rulers.push(itemElement);
    }
    var resizeNode = Dom.getElementsByClassName('resize', 'img', itemElement)[0];
    if (resizeNode && resizeNode != null) {
      if (!resizeNode.id || resizeNode.id == null) {
        Dom.generateId(resizeNode);
      }
    }
    var dd;
    var ddResize;
    if (this.config.dragDropEnabled) {
      dd = new _ColDD.default(itemElement.id, 'columnCont', null, this.columnCount, this);
      var moveHandleNode = Dom.getElementsByClassName('moduleHeader move', 'div', itemElement)[0];
      if (!moveHandleNode.id || moveHandleNode.id == null) {
        Dom.generateId(moveHandleNode);
      }
      dd.setOuterHandleElId(moveHandleNode.id); // todo, search by class
      ddResize = new _ColResize.default(resizeNode.id, 'resize', null, this.columnCount, this);
    }
    // check if the colItem for this element is already created, if not do so.
    var colItem = this.itemMap[itemElement.id];
    if (!colItem || colItem == null) {
      colItem = new _ColItemContainer.default(itemElement.id, colspan, this.getColOffset(itemElement));
      this.itemMap[itemElement.id] = colItem;
    }
    if (this.config.dragDropEnabled) {
      colItem.resizerDiv = resizeNode;
      if (colItem.colDD == null) {
        colItem.colDD = dd;
        colItem.resizeDD = ddResize;
      }
    }
    if (colItem.colspan > 1 && isExternal) {
      /**
       * This means the item is a multi column module by default.
       * By calling handleDefaultMultiColumns() we will reuse the existing method (increaseColspan()) to add spacers.
       */
      colItem.resizeDD.handleDefaultMultiColumns(itemElement);
    } else if (colspan > 1) {
      Dom.setStyle(itemElement, 'position', 'absolute');
      this.mapColspanSpacers(colItem);
    }

    //initialise modules via moduleHandler
    window.fcom.moduleHandler.initModule(itemElement).catch(function () {
      // do nothing on error as an error will be thrown even when it is not necessary to init the module via moduleHandler
    });
  },
  /**
   * check the order of multi column elements (spacers) in the given previous column which is the right one
   * and correct position of given element in it's column (which is the one where it is not clear whether the
   * position is valid)
   *
   */
  handleMultiColItemConstraintsFromPeviousCol: function handleMultiColItemConstraintsFromPeviousCol(elemAtTemporaryPosition, columnDivWithConstraints) {
    var childNodes = Dom.getChildrenBy(columnDivWithConstraints, this.isModuleNode);
    if (childNodes) {
      var multiColElementsAbove = new Array();
      var multiColElementsBelow = new Array();
      var currentlyAbove = true;
      for (var i = 0; i < childNodes.length; i++) {
        var colItem = this.itemMap[childNodes[i].id];
        if (colItem && colItem.colspan && colItem.colspan > 1) {
          if (this.itemMap[elemAtTemporaryPosition.id] === colItem) {
            currentlyAbove = false;
            continue;
          } else if (currentlyAbove) {
            multiColElementsAbove.push(colItem.id);
          } else {
            multiColElementsBelow.push(colItem.id);
          }
        }
      }
      var targetColumnChildNodes = Dom.getChildrenBy(elemAtTemporaryPosition.parentNode, this.isModuleNode);
      currentlyAbove = true; // reuse for second loop

      for (var _i = 0; _i < targetColumnChildNodes.length; _i++) {
        var _colItem = this.itemMap[targetColumnChildNodes[_i].id];
        if (_colItem && _colItem.colspan && _colItem.colspan > 1) {
          if (this.itemMap[elemAtTemporaryPosition.id] === _colItem) {
            currentlyAbove = false;
            continue;
          }
          if (currentlyAbove) {
            if (multiColElementsBelow.indexOf(_colItem.id) > -1) {
              // found a multi column element that should be below!
              elemAtTemporaryPosition.parentNode.insertBefore(elemAtTemporaryPosition, targetColumnChildNodes[_i]); // correct position and return out
              return;
            }
          } else {
            // walking the elements below the one to be checked
            if (multiColElementsAbove.indexOf(_colItem.id) > -1) {
              // found a multi column element that should be above!
              var nextFollowingElement = Dom.getNextSiblingBy(targetColumnChildNodes[_i], this.isModuleNode);
              if (nextFollowingElement) {
                // move behind the wrong element
                elemAtTemporaryPosition.parentNode.insertBefore(elemAtTemporaryPosition, nextFollowingElement); // move the temporary one in between, closest possible
                // no return this time, could be more elements that need to be above
              } else {
                elemAtTemporaryPosition.parentNode.appendChild(elemAtTemporaryPosition);
                return;
              }
            }
          }
        }
      }
    }
  },
  updateItem: function updateItem(itemElementId) {
    // const itemElement = document.getElemetById(itemElementId);
    var colItem = this.itemMap[itemElementId];
    var itemElement = Dom.get(itemElementId);
    var resizeNode = colItem.resizerDiv;
    var dd;
    var ddResize;
    if (this.config.dragDropEnabled) {
      dd = new _ColDD.default(itemElement.id, 'columnCont', null, this.columnCount, this);
      var moveHandleNode = Dom.getElementsByClassName('moduleHeader move', 'div', itemElement)[0];
      if (!moveHandleNode.id || moveHandleNode.id == null) {
        Dom.generateId(moveHandleNode);
      }
      dd.setOuterHandleElId(moveHandleNode.id); // todo, search by class
      ddResize = new _ColResize.default(resizeNode.id, 'resize', null, this.columnCount, this);
    }
    // check if the colItem for this element is already created, if not do so.
    if (this.config.dragDropEnabled) {
      // if (colItem.colDD == null) {
      colItem.colDD = dd;
      colItem.resizeDD = ddResize;
      // }
    }

    var colspan = colItem.colspan;
    if (colspan > 1) {
      var parentElement = Dom.getAncestorByTagName(itemElement, 'td');
      var parentWidth = parseFloat(Dom.getComputedStyle(parentElement, 'width'));
      if (!isNaN(parentWidth)) {
        // Multiply the width by colspan
        var itemElementWidth = parentWidth * colspan;

        // Apply the  width to the itemelement to avoid expanding to the right
        Dom.setStyle(itemElement, 'width', itemElementWidth + 'px');
      }
      Dom.setStyle(itemElement, 'position', 'absolute');
      this.mapColspanSpacers(colItem);
    }

    //initialise modules via moduleHandler
    window.fcom.moduleHandler.initModule(itemElement).catch(function () {
      // do nothing on error as an error will be thrown even when it is not necessary to init the module via moduleHandler
    });
  },
  /*
   * highlight all the rulers in the floating column layout.
   * @param onOff whether to highlight rulers (true) or to remove the highlight (false)
   */
  highlightRulers: function highlightRulers(onOff) {
    if (!this.rulers) {
      return;
    }
    for (var i = 0; i < this.rulers.length; i++) {
      if (onOff === true) {
        Dom.addClass(this.rulers[i], 'highlight');
      } else {
        Dom.removeClass(this.rulers[i], 'highlight');
      }
    }
  },
  /*
   * activate a mask over the drag'n drop layout to avoid interaction between the draged module
   * and mouse listeners on other modules
   * @param onOff whether to activate the mask (true) or to deactivate (false)
   */
  dragMask: function dragMask(onOff) {
    if (this.mask == null) {
      this.mask = document.createElement('div');
      document.body.insertBefore(this.mask, document.body.firstChild);
      Dom.setStyle(this.mask, 'position', 'absolute');
      this.updateDragMask();
    }
    if (onOff) {
      this.updateDragMask();
      Dom.setStyle(this.mask, 'z-index', 9);
      Dom.removeClass(this.mask, 'hideContainer');
    } else {
      Dom.setStyle(this.mask, 'z-index', 0);
      Dom.addClass(this.mask, 'hideContainer');
    }
  },
  /**
   * update the drag mask container dimensions
   */
  updateDragMask: function updateDragMask() {
    var layoutRegion = Dom.getRegion(this.id);
    Dom.setStyle(this.mask, 'height', "".concat(layoutRegion.bottom - layoutRegion.top, "px"));
    Dom.setStyle(this.mask, 'width', "".concat(layoutRegion.right - layoutRegion.left, "px"));
    Dom.setStyle(this.mask, 'z-index', 0);
    Dom.setStyle(this.mask, 'top', "".concat(layoutRegion.top, "px"));
    Dom.setStyle(this.mask, 'left', "".concat(layoutRegion.left, "px"));
  },
  /*
   * with this method external items can be added to the floating column container
   * this is required to drag new elements from the module construction kit over
   * into the page. The external item also have to provide all informations how to get
   * the real items from an ajax call.
   * The argument sourceElement is the element which holds the drag'n drop handler,
   * the previewElement is used as preview when dragging around. Should be some sort of dummy module.
   */
  addExternItem: function addExternItem(sourceElement, previewElement, objectConfig) {
    if (this.columns[0] == null) {
      this.initializeColumns();
    }
    objectConfig.extern = true; // set extern to true

    // set some defaults to the config object
    if (!objectConfig.colspan || objectConfig.colspan == null) {
      objectConfig.colspan = 1;
    }
    if (!objectConfig.height || objectConfig.height == null) {
      objectConfig.height = 200;
    }
    var dd = new _ColDD.default(sourceElement, 'columnCont', objectConfig, this.columnCount, this);
    dd.externPreview = Dom.get(previewElement);
  },
  isColspanSpacer: function isColspanSpacer(elem) {
    return elem && Dom.hasClass(elem, 'colspanSpacer');
  },
  /*
   * send the current state of the layout to the server.
   */
  sendUpdateToServer: function sendUpdateToServer(reloadPage) {
    if (!reloadPage) {
      reloadPage = false;
    }
    var postData = "method=updateFloatingColumnsLayout&viewId=".concat(this.id, "&sequenceNumber=").concat(this.sequenceNumber++);
    var uri = '/view.action';
    // if admin --> call another action
    if (this.config.isAdmin) {
      postData = postData + this.config.adminData;
      uri = '/admin/view/admin.action';
    }
    var callback = {
      success: function success(o) {
        o.argument[0].outOfSync = false; //o.argument.outOfSync ?
        if (o.argument[1]) {
          window.location.reload();
        }
        if (window.viewChangedEvent) {
          window.viewChangedEvent.fire();
        }
      },
      argument: [this, reloadPage],
      silent: true
    };
    for (var i = 0; i < this.columnCount; i++) {
      postData += "&layoutColumnsUpdate=".concat(i, ":").concat(100 / this.columns.length);
      //now iterate over elements in column and append ids.
      var modules = Dom.getChildrenBy(this.columns[i], this.isModuleNode);
      for (var j = 0; j < modules.length; j++) {
        var moduleId = modules[j].id;
        if (moduleId.startsWith(this.id)) {
          moduleId = moduleId.slice(this.id.length + 1, moduleId.length);
        }
        postData += ":".concat(moduleId);
      }
    }
    window.ngpAsyncRequest('POST', uri, callback, postData);
  },
  /*
   * take a module id, remove the underlying element from the dom tree and
   * send a request to the server to remove that module from the view. As long
   * as the ajax request does not return a success response, the flag "out of sync"
   * is set, so that any further update is sending the complete layout and will also remove the module.
   * the confirmDialog argument expects a boolean, when set to true, the user has to click
   * ok, before the module realy gets removed.
   */
  removeModuleFromView: function removeModuleFromView(moduleId, confirmDialog) {
    var moduleDataId = moduleId;
    if (moduleDataId.startsWith(this.id)) {
      moduleDataId = moduleDataId.slice(this.id.length + 1, moduleDataId.length);
    }
    if (confirmDialog === true) {
      Dom.addClass(moduleId, 'inProcess');
      window.ngpConfirm(window.getMessage('module.dialog.removeFromView.text'), {
        title: window.getMessage('module.dialog.removeFromView.title'),
        okButtonText: window.getMessage('module.dialog.removeFromView.button.remove'),
        okHandler: function okHandler(args) {
          args[1].removeModuleFromView(args[0], false);
        },
        cancelHandler: function cancelHandler(args) {
          Dom.removeClass(args[0], 'inProcess');
        },
        handlerArgument: [moduleId, this]
      });
      return;
    }

    // without confirm => remove module:

    var moduleDiv = Dom.get(moduleId);
    if (moduleDiv && moduleDiv != null) {
      window.fcom.moduleHandler.destroyModule(moduleDiv); // destroy all registered lifecycle handlers
      moduleDiv.parentNode.removeChild(moduleDiv);
      var colItem = this.itemMap[moduleId];
      if (colItem.colspan > 1) {
        for (var i = 0; i < colItem.colspanSpacers.length; i++) {
          colItem.colspanSpacers[i].parentNode.removeChild(colItem.colspanSpacers[i]);
        }
        this.itemMap[moduleId] = null;
      }
    }
    this.sendUpdateToServer(false);
    YAHOO.lang.later(50, null, function (floatingColumnLayout) {
      floatingColumnLayout.removeStaticContainerHeight();
      floatingColumnLayout.checkViewportResize(true);
    }, this, false); // has to be delayed so that javascript redrawed in between

    _hooks.default.onModuleRemoved(moduleDiv.getAttribute('data-module-type'));
  },
  /*
   * this function will set a static height to the floating column container div, so that the browser does
   * not remove and add scrollbars within the process of rendering the multi column elements.
   * Somehow when something is changed in the container, the static height should be removed
   * with the removeStaticContainerHeight(), so that there are no scrollbars kept, when they are not needed
   *
   */
  reserveStaticContainerHeight: function reserveStaticContainerHeight() {
    var region = Dom.getRegion(this.id);
    Dom.setStyle(this.id, 'height', "".concat(region.bottom - region.top, "px"));
  },
  /*
   * remove the static height from the container div
   */
  removeStaticContainerHeight: function removeStaticContainerHeight() {
    Dom.setStyle(this.id, 'height', 'auto');
  },
  /*
   * find the column that is closest to the given x coordinate.
   */
  getNearestColumn: function getNearestColumn(x) {
    for (var i = 0, len = this.columns.length; i < len; i++) {
      var region = Dom.getRegion(this.columns[i]);
      if (x > region.right && i + 1 < len) {
        continue;
      }
      return this.columns[i];
    }
  },
  /*
   * find an item that is located in the given column div at the given y coordinate.
   * If the y coordinate is in a gap, the next element is returned
   * If y is larger than the last element's extend or there is no element in that column,
   * null is returned, next element can be just appended at the end.
   */
  getNearestColumnItem: function getNearestColumnItem(columnDiv, y) {
    var childNodes = Dom.getChildrenBy(columnDiv, this.isModuleNode);
    if (!childNodes || childNodes == null || !childNodes.length) {
      return null;
    }
    for (var i = 0; i < childNodes.length; i++) {
      var region = Dom.getRegion(childNodes[i]);
      if (region.bottom < y) {
        // y greater than region => look for next child
        continue;
      }
      return childNodes[i]; // y inside or near above the region => return that child
    }

    return null; // y is larger than the extend of the last element or there are no elements
  },

  /*
   * create a div element, asign it the class css previewPane and append it to the body tag
   */
  preparePreviewPane: function preparePreviewPane() {
    var previewDiv = document.createElement('div');
    Dom.addClass(previewDiv, 'previewPane');
    document.body.insertBefore(previewDiv, document.body.firstChild);
    return previewDiv;
  },
  /*
   * find out how many cols the element with the given width is occupying.
   * Width must be an integer (no css string)
   */
  setColspanFromWidth: function setColspanFromWidth(width) {
    var colWidth = this.columns[0].offsetWidth;
    return parseInt(colWidth / width + 0.5, 10);
  },
  /*
   * find out the column offset of that element. The column offset is the number of columns left of the
   * element's left edge. 0 For an element that is situated in the first column, or the first column itself.
   */
  getColOffset: function getColOffset(element) {
    var leftEdge = Dom.getRegion(element).left;
    for (var i = 0; i < this.columns.length; i++) {
      var colRegion = Dom.getRegion(this.columns[i]);
      if (leftEdge + 20 < colRegion.right) {
        // some offset of 20 to not have issues due to borders/paddings etc
        return i;
      }
    }
  },
  /*
   * take an original element node and an empty copy and try to make the copy look the same as the original.
   * css classes and innerHTML is copied, important style attributes are set to the same value.
   * If absolute is given true, the node will be made absolute positioned and
   * be added to the same parent as the originbal element, to get the same style look
   * in css selectors. For not absolute elements this is not be done, to avoid
   * destroying the layout of the page (It does not matter where an absolute elemet is hung under).
   */
  copyContentAndStyle: function copyContentAndStyle(originalElem, proxyElem, absolute) {
    if (absolute) {
      Dom.setStyle(proxyElem, 'position', 'absolute');
      Dom.setStyle(proxyElem, 'z-index', '10');
      Dom.setStyle(this.proxyElem, 'width', "".concat(originalElem.offsetWidth, "px"));
    }
    var applets = YAHOO.fcom.Dom.getDescendantsBy(originalElem, function (node) {
      return node.tagName.toLowerCase() === 'applet';
    });
    if (applets && applets != null && applets.length > 0) {
      proxyElem.innerHTML = Dom.get('modulePreview').innerHTML;
    } else {
      proxyElem.innerHTML = originalElem.innerHTML; // copy inner html to make the content the same
    }

    Dom.addClass(proxyElem, originalElem.className); // add the required classes for correct css behavior

    var borderStyle = Dom.getStyle(originalElem, 'border');
    if (borderStyle && borderStyle != null) {
      Dom.setStyle(proxyElem, 'border', borderStyle);
    } else {
      Dom.setStyle(proxyElem, 'border', ''); // remove border that YUI sets automatically
    }

    Dom.setStyle(proxyElem, 'visibility', 'visible');
    Dom.setStyle(proxyElem, 'display', '');
  },
  /*
   * walk through all elements in the columns, in the order so that
   * the current element is always the one with the smallest bottom coordinate
   * then call the checkColspanCorrect method on that element
   */
  correctMultiColElements: function correctMultiColElements(wasResize) {
    var colIndices = new Array(this.columnCount); // an array holding the elements in the columns currently worked with
    for (var i = 0; i < this.columnCount; i++) {
      // fill the array with the first elements
      var column = this.columns[i];
      var childNodes = Dom.getChildrenBy(column, this.isModuleNode);
      colIndices[i] = childNodes[0];
    }
    var nextElement = this.findHighestElement(colIndices); // get the element with the smallest bottom coordinate
    while (nextElement != null) {
      this.checkColspanCorrect(nextElement, wasResize); // call the checkColspanCorrect method on the element
      var lastOne = nextElement;
      while (nextElement != null && lastOne === nextElement) {
        nextElement = this.findHighestElement(colIndices); // continue as long as elements left. findHighestElement will return null, when all elements are done
      }
    }
  },

  /*
   * just correct the width and the leftorientation of the element, the top will be arragend in the
   * checkColspanCorrect function
   */
  correctColspanDimensions: function correctColspanDimensions(element, colItem) {
    var leftmostColumn = colItem.colspanSpacers[0].parentNode;
    var rightmostColumn = colItem.colspanSpacers[colItem.colspan - 1].parentNode;
    var leftRegion = Dom.getRegion(leftmostColumn);
    var rightRegion = Dom.getRegion(rightmostColumn);
    var leftEdge = leftRegion.left;
    var rightEdge = rightRegion.right;
    Dom.setStyle(element, 'width', "".concat(rightEdge - leftEdge, "px"));
    // set the x-coordinate to the left edge of the first spacer.
    Dom.setX(element, leftEdge);
    //console.log("positioning "+element.id+" to x-coord. "+leftEdge);
    //console.log("Setting "+element.id+" to width "+(rightEdge - leftEdge));
    window.onElementResize.fire(element, this.resizeTriggerElementId);
  },
  mapColspanSpacers: function mapColspanSpacers(colItem) {
    for (var i = colItem.colspanSpacers.length; i < colItem.colspan; i++) {
      var column = this.columns[colItem.colOffset + i];
      // TODO: spacer seems not to be an element sometimes, why??

      var spacers = Dom.getElementsByClassName('colspanSpacer', 'div', column);
      for (var j = 0; j < spacers.length; j++) {
        if (spacers[j].id.indexOf(colItem.id) === 0) {
          colItem.colspanSpacers[i] = spacers[j];
          this.itemMap[spacers[j].id] = colItem;
          break;
        }
      }
    }
  },
  /*
   * set all invisible spacers for this element to the same size as the element, set all offset margins
   * to zero pixel, find the column where the most space is needed to correct the layout
   * so that no modules overlap.
   */
  checkColspanCorrect: function checkColspanCorrect(element, wasResize) {
    var colItem = this.itemMap[element.id];
    if (colItem == null) {
      return; // does not seem to have a colspan => nothing to correct
    }

    if (colItem.colspan === 1) {
      if (wasResize) {
        window.onElementResize.fire(element);
      }
      return; // does not have a colspan => nothing to correct
    }

    if (colItem.colspan > colItem.colspanSpacers.length) {
      // colspanSpacers not yet mapped => find and map them
      this.mapColspanSpacers(colItem);
    }
    element = Dom.get(colItem.id); // element is the first colspacer => get the real element
    if (wasResize) {
      this.correctColspanDimensions(element, colItem);
    }

    // reset height of all spacers to element's height:
    var elemHeight = element.offsetHeight;
    if (Dom.hasClass(element, 'ruler')) {
      elemHeight = 1;
    }
    for (var i = 0; i < colItem.colspan; i++) {
      Dom.setStyle(colItem.colspanSpacers[i], 'height', "".concat(elemHeight, "px"));
      //console.log("setting "+element.id+" spacer "+ i + " to height. " + elemHeight);
    }

    /* now all elements are arranged directly under their previous siblings.
     * find the lowest to adjust the others at that one */
    var lowestTop = -1;
    var lowestIndex = -1;
    for (var _i2 = 0; _i2 < colItem.colspan; _i2++) {
      var currentRegion = Dom.getRegion(colItem.colspanSpacers[_i2]);
      var currentTop = currentRegion.top;
      if (currentTop > lowestTop) {
        // when this spacer has a lower top than the ones found yet
        lowestTop = currentTop;
        lowestIndex = _i2;
      }
    }
    if (lowestIndex !== -1) {
      // the element must be corrected down, as there is a spacer element with a lower top
      // now arrange all spacers so that they exactly have their bottom at the same level as the element
      for (var _i3 = 0; _i3 < colItem.colspan; _i3++) {
        if (lowestIndex === _i3) {
          continue;
        }
        var newHeight = elemHeight + lowestTop - Dom.getRegion(colItem.colspanSpacers[_i3]).top;
        if (isNaN(newHeight) || newHeight < 1) {
          newHeight = 1;
        }
        Dom.setStyle(colItem.colspanSpacers[_i3], 'height', "".concat(newHeight, "px"));
        //console.log("setting "+element.id+" spacer "+ i + " to height. " + newHeight);
      }

      var elementTop = Dom.getRegion(element).top;
      if (Math.abs(lowestTop - elementTop) > 3) {
        // most of the time the reposition is not needed => check
        //console.log(element.id + " is at y="+ elementTop + "putting to "+lowestTop +" now it is at "+ Dom.getY(element));
        //Dom.setStyle(element, "top", (lowestTop - elementTop) + "px");
        Dom.setY(element, lowestTop);
      }
    }
  },
  /*
   * colIndices is an array that holds module div references. This method will return
   * the one that has the highest bottom and replace the array entry by it's
   * successor.
   */
  findHighestElementBottom: function findHighestElementBottom(colIndices) {
    var currentHighest = -1; // index to remember the minimum
    var currentBottom = 900000; // anything very big :) to compare to
    for (var i = 0; i < colIndices.length; i++) {
      if (colIndices[i] == null) {
        continue; // no element any more in that column, just continue with the other columns
      }
      // ignor colspan spacers, because they are no visible elements
      while (colIndices[i] != null) {
        if (this.isColspanSpacer(colIndices[i]) && !colIndices[i].id.endsWith('sp_0')) {
          colIndices[i] = Dom.getNextSiblingBy(colIndices[i], this.isModuleNode);
        } else {
          // it's not a spacer which's element was already worked on, take this element and break the loop (that is just looking for spacers)
          break;
        }
      }
      var bottom = Dom.getRegion(colIndices[i]).bottom;
      if (bottom < currentBottom) {
        // if the element found has a lower bottom coordinate
        currentHighest = i; // set the index to this elements's one
        currentBottom = bottom; // remember the minimum for the next comparison
      }
    }

    if (currentHighest === -1 || colIndices[currentHighest] == null) {
      // no element found, so return null, that's the termination condition of the loop calling this method
      return null;
    }
    var returnElement = colIndices[currentHighest]; // save the element in some local variable to return it
    colIndices[currentHighest] = Dom.getNextSiblingBy(colIndices[currentHighest], this.isModuleNode); // exchange it by it's successor element
    return returnElement; // return the element found.
  },

  /*
   * colIndices is an array that holds module div references. This method will return
   * the one that has the highest top and replace the array entry by it's
   * successor.
   */
  findHighestElement: function findHighestElement(colIndices) {
    var currentHighest = -1; // index to remember the minimum
    var currentTop = 900000; // anything very big :) to compare to
    for (var i = 0; i < colIndices.length; i++) {
      if (colIndices[i] == null) {
        // no element any more in that column, just continue with the other columns
        continue;
      }
      var top = Dom.getRegion(colIndices[i]).top;
      if (top < currentTop) {
        // if the element found has a lower top coordinate
        currentHighest = i; // set the index to this elements's one
        currentTop = top; // remember the minimum for the next comparison
      }
    }

    if (currentHighest === -1 || colIndices[currentHighest] == null) {
      // no element found, so return null, that's the termination condition of the loop calling this method
      return null;
    }
    var returnElement = colIndices[currentHighest]; // save the element in some local variable to return it
    try {
      if (this.isColspanSpacer(colIndices[currentHighest])) {
        returnElement = Dom.get(this.itemMap[colIndices[currentHighest].id].id);
      }
      colIndices[currentHighest] = Dom.getNextSiblingBy(colIndices[currentHighest], this.isModuleNode); // exchange it by it's successor element
      return returnElement; // return the element found.
    } catch (e) {
      return null;
    }
  },
  /*
   * @return {Boolean} true -> viewport was resized
   */
  checkViewportResize: function checkViewportResize(force, isDelayed, triggerId) {
    this.resizeTriggerElementId = triggerId;
    if (this.nextViewportCheck != null) {
      this.nextViewportCheck.cancel();
    }
    if (!force && !isDelayed) {
      // new incoming calls will disable old waiting ones to decrease number of repaints
      this.nextViewportCheck = YAHOO.lang.later(50, this, 'checkViewportResize', [true, true, triggerId]);
      return true;
    }
    var tempWidth = Dom.getViewportWidth();
    this.screenWidth = Dom.getViewportWidth();
    this.screenHeight = Dom.getViewportHeight();
    this.correctMultiColElements(true);
    if (Math.abs(parseInt(tempWidth, 10) - parseInt(Dom.getViewportWidth(), 10)) > 3) {
      // screen width was changed due to appearance of scrollbars after the rendering e.g.
      this.reserveStaticContainerHeight();
      this.checkViewportResize(true);
      this.removeStaticContainerHeight(); //cannot keep static container height or modules will flow over
    }
    //console.log("checkViewportResize run, w=" + Dom.getViewportWidth() + ", h=" + Dom.getViewportHeight());
    return true;
  },
  shiftSmallestNumbers: function shiftSmallestNumbers(arrayOfArrays) {
    var smallest = 999999; // just any big initial value, we talk about screen coordinates
    var index = -1;
    for (var i = 0; i < arrayOfArrays.length; i++) {
      if (arrayOfArrays[i].length === 0) {
        continue;
      }
      if (arrayOfArrays[i][0] === smallest) {
        arrayOfArrays[i].shift();
      } else if (arrayOfArrays[i][0] < smallest) {
        smallest = arrayOfArrays[i][0];
        index = i;
      }
    }
    if (index === -1) {
      return index;
    }
    return arrayOfArrays[index].shift();
  },
  /*
   * reload the module with the given module id from the server. This is needed e.g. for the top flop lists,
   * which will be out of date when the streaming updates some of the prices.
   */
  reloadModule: function reloadModule() {},
  /*
   * small helper function, that walks through the columns and fills one array with the upper and lower edges of all
   * multi column elements. Normal one column elements are not needed, as they can be filled together in one table cell
   * Another array is filled with references to all elements in all columns, with markers in between for spacer elements.
   * the arrays are given as parameters, and will be filled.
   * @return the y coordinate of the lowest module edge
   */
  buildRowEdges: function buildRowEdges(rowEdges, rowElements) {
    var lowestEdge = -1;
    var highestEdge = 99999;
    for (var i = 0; i < this.columns.length; i++) {
      rowEdges[i] = [];
      rowElements[i] = [];
      var elements = Dom.getChildren(this.columns[i]);
      var module = null;
      for (var j = 0; j < elements.length; j++) {
        module = elements[j];
        if (Dom.hasClass(module, 'moduleContainer') && !Dom.hasClass(module, 'ruler')) {
          var region = Dom.getRegion(module);
          var topEdge = region.top;
          var bottomEdge = region.bottom;
          if (topEdge < highestEdge) {
            highestEdge = topEdge; // remember highest edge also
          }

          if (bottomEdge > lowestEdge) {
            lowestEdge = bottomEdge;
          }
          if (this.itemMap[module.id] && this.itemMap[module.id].colspan > 1) {
            //multi column
            rowElements[i].push('multiColumn');
            rowElements[i].push(module);
            rowElements[i].push("".concat(this.itemMap[module.id].colspan));
            rowEdges[i].push(topEdge);
            rowEdges[i].push(bottomEdge);
          } else {
            rowElements[i].push(module);
          }
        } else if (this.isColspanSpacer(module) && module.id.charAt(module.id.length - 1) !== '0') {
          var rootElement = Dom.get(this.itemMap[module.id].id);
          if (!Dom.hasClass(rootElement, 'ruler')) {
            // skip ruler spacers
            rowElements[i].push('spacer'); // spacer marker is needed to know about the gap
            rowElements[i].push(rootElement); // also remember the root element, to know about the expansion of that element
          }
        }
      }
    }

    rowEdges[0].unshift(highestEdge); // fill in the highest edge at the top of the first column
    return lowestEdge; // return the lower edge of the container
  },

  /*
   * build an array that merges all row edges in the given multi dimensional array into one sorted distinct list
   * the new array is returned then.
   */
  mergeRowEdges: function mergeRowEdges(rowEdges, bottomEdge) {
    var nextSmallest = this.shiftSmallestNumbers(rowEdges);
    var allRowEdges = [];
    while (nextSmallest !== -1) {
      if (allRowEdges.length < 1 || nextSmallest > allRowEdges[allRowEdges.length - 1] + 3) {
        // small differences are ignored
        allRowEdges.push(nextSmallest);
      }
      nextSmallest = this.shiftSmallestNumbers(rowEdges);
    }
    if (bottomEdge > allRowEdges[allRowEdges.length - 1]) {
      // if the bottom edge is not yet in the rowEdges
      allRowEdges.push(bottomEdge); // append it to the end
    }

    return allRowEdges;
  },
  /*
   * create and prepare the table node that is used to build the static table copy into.
   * returns the table node with all needed attributes, classes and also colgroup info.
   */
  createStaticTableNode: function createStaticTableNode() {
    var tableElement = document.createElement('table');
    Dom.setStyle(tableElement, 'width', '100%');
    Dom.setStyle(tableElement, 'table-layout', 'fixed');
    tableElement.setAttribute('cellspacing', '0');
    tableElement.setAttribute('cellpadding', '0');
    tableElement.setAttribute('border', '0');
    tableElement.className = 'container';

    // build colgroup informations
    var colGroup = document.createElement('colgroup');
    tableElement.appendChild(colGroup);
    for (var i = 0; i < this.columns.length; i++) {
      var colElem = document.createElement('col');
      colElem.setAttribute('width', this.columns[i].getAttribute('width'));
      colGroup.appendChild(colElem);
    } // end of colgroup informations
    return tableElement;
  },
  /*
   * helper function to append the current table cell to it's table row, when
   * the rowspan is reached and a row break is needed because of a multi colspan item
   */
  appendTableCell: function appendTableCell(tdAndTrDescriptor, rowspan) {
    tdAndTrDescriptor.cell.setAttribute('rowspan', rowspan);
    tdAndTrDescriptor.row.appendChild(tdAndTrDescriptor.cell);
  },
  /*
   * this function will create a copy of the floating column layout in a static table layout,
   * which is needed e.g. for printout.
   */
  getStaticTableCopy: function getStaticTableCopy() {
    /* first walk all the columns and find out the heights where there need to be tr-tag edges. */
    var rowEdges = []; // two dimensional array with number of columns arrays of edge coordinates.
    var rowElements = []; // two dimensional array with all modules in the page and markers in between, when to start new tr tags
    var containerBottomEdge = this.buildRowEdges(rowEdges, rowElements);
    var rowCounter = []; // array to remember the rowspan already reached in the individual columns
    for (var i = 0; i < this.columns.length; i++) {
      // rowCounter has to have one entry per column
      rowCounter[i] = 0; // initialize with zero, because it's increased, not set, so an initial value is needed.
    }

    /* now there are n arrays with all the upper edges of the column elements.
     * next step is to merge them together to one array:
     */
    var allRowEdges = this.mergeRowEdges(rowEdges, containerBottomEdge);
    var tableNode = this.createStaticTableNode(); // create a table node to append rows and columsn to

    /* now we have all the edges, now we walk through the columns, adding all elements until we find a multi
     * column one. if we have a multicolumn one, we calculate the rowspan of the td above by counting the
     * entries in the edges array.
     */
    var nextRow = document.createElement('tr');
    var currentTrRowspanLevel = 0; // which tr level we are currently in

    while (true) {
      for (var _i4 = 0; _i4 < rowElements.length; _i4++) {
        if (rowCounter[_i4] === allRowEdges.length // bottom of table already reached in that column
        || rowCounter[_i4] > currentTrRowspanLevel) {
          // still content in that column from above
          continue;
        }
        var statusString = '';
        var nextModule = null; // next Module will be null, when no modules available any more
        if (rowElements[_i4].length > 0) {
          // still modules available in this column
          nextModule = rowElements[_i4][0]; // take next module from the top of the array, not yet remove it
        }

        if (YAHOO.lang.isString(nextModule)) {
          // there are some string markers in the list
          statusString = nextModule;
          if (nextModule === 'multiColumn') {
            nextModule = rowElements[_i4][1];
          } else if (nextModule === 'spacer') {
            nextModule = rowElements[_i4][1]; // in fact it's the real module, not the spacer
          }
        }

        if (nextModule != null) {
          // only if a module is still available
          var topIndex = 0;
          var bottomIndex = 0;
          var region = Dom.getRegion(nextModule);
          var topEdge = region.top;
          var bottomEdge = region.bottom;

          // check the edges of that module, if it is already in row or not yet and how many rows it spans.
          for (var j = 0; j < allRowEdges.length; j++) {
            // start with one, first edge is not of interest
            if (topEdge > allRowEdges[j]) {
              topIndex++;
              bottomIndex++;
            } else if (bottomEdge > allRowEdges[j] + 2) {
              // small hack + 2, as the rulers sometimes create negative paddings
              bottomIndex++;
            } else {
              break;
            }
          }
          if (topIndex > currentTrRowspanLevel) {
            // not yet, fill dummy module
            var _currentTd = document.createElement('td');
            //currentTd.innerHTML = "&nbsp;"; empty space was to high in some cases, try without content
            nextRow.appendChild(_currentTd);
            rowCounter[_i4]++;
            continue;
          }
          if (statusString === 'spacer') {
            // spacers do not need a td, they get filled with colspans from columns before
            // also do the rowCounters get increased already by the main element
            rowElements[_i4].shift(); // shift marker string
            rowElements[_i4].shift(); // shift element
            continue;
          }
          var colspan = 1;
          var rowspan = 1;
          var currentTd = document.createElement('td');
          currentTd.setAttribute('valign', 'top');
          currentTd.appendChild(YAHOO.fcom.Dom.cloneNodeWrap(nextModule));
          rowElements[_i4].shift(); // shift away module, (or the status string in multi column case)

          // former algorithm was setting the height to the td here. should work without now
          // Dom.setStyle(currentTd, "height", (bottomEdge - topEdge ) + "px");

          if (statusString === 'multiColumn') {
            rowElements[_i4].shift(); // shift away real module;
            colspan = parseInt(rowElements[_i4].shift(), 10); // shift away the colspan info

            currentTd.setAttribute('colspan', colspan);
            Dom.setStyle(currentTd.firstChild, 'width', '100%');
            Dom.setStyle(currentTd.firstChild, 'position', '');
            Dom.setStyle(currentTd.firstChild, 'top', '0px');
            rowspan = bottomIndex - topIndex;

            // loop following cols and increase rowCounter
            for (var k = 1; k < colspan; k++) {
              rowCounter[_i4 + k] += rowspan;
              rowElements[_i4 + k].shift(); // shift spacer
              rowElements[_i4 + k].shift(); // shift element
            }
          } else {
            // no multi columns module, keep appending single column modules
            while (rowElements[_i4].length > 0 && !YAHOO.lang.isString(rowElements[_i4][0])) {
              // check for single column module
              nextModule = rowElements[_i4][0];
              currentTd.appendChild(YAHOO.fcom.Dom.cloneNodeWrap(nextModule));
              rowElements[_i4].shift(); // shift away module;
            }

            bottomEdge = Dom.getRegion(nextModule).bottom;
            for (var _j = bottomIndex; _j < allRowEdges.length; _j++) {
              if (bottomEdge > allRowEdges[_j] + 2) {
                // small hack + 2, as the rulers sometimes create negative paddings
                bottomIndex++;
              } else {
                break;
              }
            }
            if (!rowElements[_i4].length) {
              // nothing available any more?
              bottomIndex = allRowEdges.length - 1; // rowspan till the end of the table
            }

            rowspan = bottomIndex - topIndex;
          }
          if (rowspan > 1) {
            currentTd.setAttribute('rowspan', rowspan);
          }
          rowCounter[_i4] += rowspan;
          nextRow.appendChild(currentTd);
        } else {
          // module is null => nothing available any more, fill up the rest of the column with a dummy div
          var _dummyDiv = document.createElement('div');
          var dummyHeight = containerBottomEdge - allRowEdges[rowCounter[_i4]];
          _dummyDiv.style.height = "".concat(dummyHeight, "px");
          var _currentTd2 = document.createElement('td');
          _currentTd2.appendChild(_dummyDiv);
          var _rowspan = allRowEdges.length - 1 - rowCounter[_i4]; // fill with rowspan until the end of the table
          if (_rowspan > 1) {
            _currentTd2.setAttribute('rowspan', _rowspan);
          }
          nextRow.appendChild(_currentTd2);
          rowCounter[_i4] = allRowEdges.length - 1;
        }
      }
      if (nextRow.childNodes == null || nextRow.childNodes.length < 1 || currentTrRowspanLevel >= allRowEdges.length) {
        break;
      } else {
        tableNode.appendChild(nextRow);
        nextRow = document.createElement('tr');
        currentTrRowspanLevel++;
      }
    }

    /* ugly workaround for IE, as the full DOM functionality is not available for nodes, created in another window.
     * that's why the string innerHTML is needed to transfer the content. */
    var dummyDiv = document.createElement('div');
    dummyDiv.appendChild(tableNode);
    return dummyDiv;
  }
};
var _default = exports.default = ColumnContainer;

},{"floatingCols/ColDD":55,"floatingCols/ColItemContainer":56,"floatingCols/ColResize":57,"hooks":60}],59:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * @class       : NegativeLogValue
 * @description : Extension for activate the negative logarithmic value
 *                - https://jira.financial.com/browse/NGPII-18970
 * @dependencies: Highcharts
 * @references  : https://api.highcharts.com/highcharts/yAxis.type
 */

var NegativeLogValue = function NegativeLogValue() {
  var H = window.Highcharts;
  H.addEvent(H.Axis, 'afterInit', function () {
    var logarithmic = this.logarithmic;
    if (logarithmic && this.options.allowNegativeLog) {
      // Avoid errors on negative numbers on a log axis
      this.positiveValuesOnly = false;

      // Override the converter functions
      logarithmic.log2lin = function (num) {
        var isNegative = num < 0;
        var adjustedNum = Math.abs(num);
        if (adjustedNum < 10) {
          adjustedNum += (10 - adjustedNum) / 10;
        }
        var result = Math.log(adjustedNum) / Math.LN10;
        return isNegative ? -result : result;
      };
      logarithmic.lin2log = function (num) {
        var isNegative = num < 0;
        var result = Math.pow(10, Math.abs(num));
        if (result < 10) {
          result = 10 * (result - 1) / (10 - 1);
        }
        return isNegative ? -result : result;
      };
    }
  });
};
var _default = exports.default = NegativeLogValue;

},{}],60:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Hooks = exports.default = /*#__PURE__*/function () {
  function Hooks() {
    _classCallCheck(this, Hooks);
  }
  _createClass(Hooks, null, [{
    key: "onModuleAdded",
    value: function onModuleAdded(type) {
      // Matomo Tracking Code: Add new module
      if (window._paq) {
        window._paq.push(['trackEvent', 'Modules', 'Add', type]);
      }
    }
  }, {
    key: "onModuleRemoved",
    value: function onModuleRemoved(type) {
      // Matomo Tracking Code: Add new module
      if (window._paq) {
        window._paq.push(['trackEvent', 'Modules', 'Removed', type]);
      }
    }
  }, {
    key: "onSearchResult",
    value: function onSearchResult(search, results) {
      // Matomo Tracking Code: Search
      if (window._paq) {
        window._paq.push(['trackSiteSearch', search,
        // Category
        'instruments',
        // Result count
        results.length > 0 ? results[0].count : 0]);
      }
    }
  }]);
  return Hooks;
}();

},{}],61:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerMessages = exports.getMessage = exports.addMessage = void 0;
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/** @module messages/messageHandler */

//use an object in window as cache, in order to prevent multiple instances of the cache
window.__messagesCache = window.__messagesCache || {};
var messages = window.__messagesCache;

/**
 * adds a message object with key value pairs for translation
 * @param {Object} msg
 */
var registerMessages = exports.registerMessages = function registerMessages(msg) {
  Object.assign(messages, msg);
};

/**
 * adds a message to the global message cache for translation
 * @param {string} key
 * @param {string} value
 */
var addMessage = exports.addMessage = function addMessage(key, value) {
  messages[key] = value;
};

/**
 * translates a given key and replaces {0}..{n} with the respective replacements
 * @param {string} key
 * @param {...string} replacements
 * @returns {string}
 * @example
 * addMessage('example', 'example {0} of {1}')
 * getMessage('example', '4', 'many');
 * // --> 'example 4 of many'
 * getMessage('example', ['2', '6']);
 * // --> 'example 2 of 6'
 */
var getMessage = exports.getMessage = function getMessage(key) {
  var _ref;
  for (var _len = arguments.length, replacements = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    replacements[_key - 1] = arguments[_key];
  }
  replacements = (_ref = []).concat.apply(_ref, _toConsumableArray(replacements));
  var message = messages[key] || key.split('.').reduce(function (all, a) {
    return a;
  }, '');
  message = message.replace(/\{(\d)\}/g, function (match, id) {
    return replacements[+id] != null ? replacements[+id] : match;
  });
  return message;
};
window.registerMessages = registerMessages;
window.getMessage = getMessage;
window.addMessage = addMessage;

},{}],62:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.detailLink = exports.default = void 0;
var _axios = _interopRequireDefault(require("../../app/utils/axios"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var TOOL_TEMPLATE = document.createElement('template');
var detailLink = exports.detailLink = function detailLink(item, subPage) {
  return "/detail/detailPage.html?".concat(getQueryString(item, subPage));
};
var getQueryString = function getQueryString(item, subPage) {
  var viewName = item.viewName;
  var queryString = "subPage=".concat(subPage, "&").concat(item.symbol || item.id ? "ric=".concat(item.symbol || item.id) : "isin=".concat(item.isin));
  if (viewName) {
    queryString = "".concat(queryString, "&view=").concat(viewName);
  }
  return queryString;
};
var DFA_PARENT_CSS = 'dfa-parent';
var saveSearchHistory = function saveSearchHistory(item) {
  var params = {
    isin: item.isin,
    ric: item.ric || item.symbol || item.id || item.isin
  };
  _axios.default.post('/searchHistory/updateHistory', params).catch(function (error) {
    console.error(error);
  });
};

/*
 * Genrates a direct function access from search result on a single instrument
 * User can directly move to individual sub detail page from the search result.
 */

/*
    constructor for direct function access panel.

    Characteristics of the DFA panel

    The panel appears when the user clicks on a data row.
    Panel appears in the same table as of the search result just one row below the data row which the user had clicked.
    All other rows including paging control panel will be hidden except
        i) Data row which the user had clicked.
        ii) Header row.
    A close button appears on the right most column in the data row which can close the panel

    @param $navigationData {Object} A data JSON which contains all available subpage navigation
            definitions for a given type of instrument.
    @param $node {Object} The node to which the Panel need to be attached which is the reference to data row
                            which the user had clicked.
    @param $item {Object} The data item (JSON) that describes a single record in the search response.
 */
var DirectFunctionAccessPanel = function DirectFunctionAccessPanel($navigationData, $node, $item) {
  this.container = new Container($node);
  this.navData = $navigationData;
  this.item = $item;
};
/*
    Prepare rendering Direct Function Access Panel
 */
DirectFunctionAccessPanel.prototype._preRender = function () {
  this.container.hideIrrelevant();
  this.container.addStyles();
};
/*
    Generate direct access to a single navigation from the given data.

    @param data {Object} A data JSON which contains a single subpage navigation
            definition for a given type of instrument.
 */
DirectFunctionAccessPanel.prototype._generateDFAFromData = function (data) {
  return "\n                    <div class=\"dfa-code\">".concat(data.shortCode, "</div>\n                    <div class=\"dfa-name\">").concat(data.displayName, "</div>\n            ").replace(/[\r\n\t]+/g, "");
};
/*
    Create container for the Panel
 */
DirectFunctionAccessPanel.prototype._createPanelContainer = function () {
  TOOL_TEMPLATE.innerHTML = "<div class=\"search-result-dfa\"></div>";
  return TOOL_TEMPLATE.content.firstChild;
};
/*

    @param data {Object} A data JSON which contains a single subpage navigation
            definition for a given type of instrument.
 */
DirectFunctionAccessPanel.prototype._createSingleDFAContainer = function (data) {
  var _this = this;
  TOOL_TEMPLATE.innerHTML = "<div class=\"dfa-block\"></div>";
  var navContainer = TOOL_TEMPLATE.content.firstChild;
  navContainer.onclick = function (evt) {
    var dataItem = _this._generateDataItem(data, _this.item);
    saveSearchHistory(dataItem);
    DirectFunctionAccessPanel.redirectToFunction(dataItem, data.linkCode);
    evt.stopPropagation();
  };
  return navContainer;
};
/*
    Merge Navigation Data with selected search result data
    this data is used for
    1. detail page link
    2. Saving Search Results

    @param $navData {Object} A data JSON which contains a single subpage navigation
            definition for a given type of instrument.
    @param $item {Object} The data item (JSON) that describes a single record in the search response.
 */
DirectFunctionAccessPanel.prototype._generateDataItem = function ($navData, $instrData) {
  var dataItem = Object.assign({}, $instrData);
  if ($navData.ric) {
    dataItem = Object.assign(dataItem, {
      symbol: $navData.ric
    });
  }
  if ($navData.linkUrl && $navData.linkUrl.includes('&view=')) {
    var queryParams = $navData.linkUrl.split('?')[1];
    var viewName = new URLSearchParams(queryParams).get('view');
    dataItem = Object.assign(dataItem, {
      viewName: viewName
    });
  }
  return dataItem;
};
/*
    Convert the dfa navigation data in to GUI list components.
 */
DirectFunctionAccessPanel.prototype._navDataToDFA = function () {
  var _this2 = this;
  return this.navData.itemList.map(function (data) {
    var singleDFAContainer = _this2._createSingleDFAContainer(data);
    var singleDFA = _this2._generateDFAFromData(data);
    singleDFAContainer.insertAdjacentHTML('beforeend', singleDFA);
    return singleDFAContainer;
  });
};

/*
    Render Direct Function Access Panel
*/
DirectFunctionAccessPanel.prototype.render = function () {
  this._preRender();
  var dfaPanel = this._createPanelContainer();
  var dfaList = this._navDataToDFA();
  dfaList.forEach(function (aDFA) {
    return dfaPanel.appendChild(aDFA);
  });
  var footer = this.createFooter();
  dfaPanel.appendChild(footer);
  this.container.cCell.append(dfaPanel);
};
/*
    Create footer for the Panel
 */
DirectFunctionAccessPanel.prototype.createFooter = function () {
  TOOL_TEMPLATE.innerHTML = "<div class=\"dfa-ft\"><i class=\"far fa-info-circle\"></i><span>".concat(window.getMessage('incrementalsearch.dfa.info'), "</span></div>");
  return TOOL_TEMPLATE.content.firstChild;
};
/*
    check if a panel is already active on the data row
    Active data row has a class 'dfa'
 */
DirectFunctionAccessPanel.isActive = function ($parentRow) {
  return $parentRow.classList.contains(DFA_PARENT_CSS);
};
DirectFunctionAccessPanel.activeStatus = false;

/*
    double-clicking will trigger multiple instances of the panel to be generated
    to solve it a flag style is added on each click and removed on susequent click
     from the row
 */
DirectFunctionAccessPanel.allowClick = function () {
  if (DirectFunctionAccessPanel.activeStatus === false) {
    DirectFunctionAccessPanel.activate();
    return true;
  }
  return false;
};
DirectFunctionAccessPanel.deActivate = function () {
  DirectFunctionAccessPanel.activeStatus = false;
};
DirectFunctionAccessPanel.activate = function () {
  DirectFunctionAccessPanel.activeStatus = true;
};
DirectFunctionAccessPanel.navDataForShortCode = function ($navData, shortCode) {
  return $navData.find(function (n) {
    return n.shortCode === shortCode.toUpperCase();
  }) || {
    linkCode: 'overv',
    shortCode: 'OV'
  };
};
DirectFunctionAccessPanel.redirectToFunction = function ($instrData, functionCode) {
  window.location = "".concat(window.ctx).concat(detailLink($instrData, functionCode));
};
var Container = function Container($parentRow) {
  /* A row in search result table which contains the instrument data, a click on this row will trigger direct function access*/
  this.pRow = $parentRow;
  this.pTable = $parentRow.closest("table");
  this.pTableHeader = Array.from(this.pTable.rows)[0];
  this.pCtrlPane = this.pTable.closest("div").getElementsByClassName("controls")[0];
  this._init();
  this._addPanelCloseButton();
};
/*

 */
Container.prototype._init = function () {
  this.cRow = this.pTable.insertRow(this.pRow.rowIndex + 1);
  this.cCell = this.cRow.insertCell(0);
  this.cCell.colSpan = this.pRow.cells.length;
};
Container.prototype._addPanelCloseButton = function () {
  var _this3 = this;
  this._addRowsAdjustmentForCloseButton();
  TOOL_TEMPLATE.innerHTML = "<div class=\"dfa-close-btn\" title=\"".concat(window.getMessage('txt.button.close.panel'), "\"><i class=\"fal fa-times\"></i></div>");
  var closeBtn = TOOL_TEMPLATE.content.firstChild;
  closeBtn.onclick = function (evt) {
    DirectFunctionAccessPanel.deActivate();
    _this3.reset();
    _this3.detach();
    closeBtn.remove();
    evt.stopPropagation();
  };
  var lastColumnOfParentRow = this.pRow.lastChild;
  /* Add close button to the dfa-ctrl-block div */
  lastColumnOfParentRow.firstChild.append(closeBtn);
};
/*
    Last column of the search result table has isin  & close btn added side by side
    in the following structure
    <div class="dfa-ctrl-block">
        <div class="dfa-isin"></div>
        <div class="dfa-close-btn">X</div>
    </div>
 */
Container.prototype._addRowsAdjustmentForCloseButton = function () {
  this.pRow.classList.add(DFA_PARENT_CSS);
  var lastColumnOfParentRow = this.pRow.lastChild;
  if (!lastColumnOfParentRow.classList.contains('dfa-ctrl')) {
    /*get column data & close btn side by side using style 'flex'*/
    /* put a div around the colum data */
    $(lastColumnOfParentRow).wrapInner("<div class=\"dfa-isin\"></div>");
    /* put a div around the entire column content including close button */
    $(lastColumnOfParentRow).wrapInner("<div class=\"dfa-ctrl-block\"></div>");
  }
  if (!lastColumnOfParentRow.classList.contains('dfa-ctrl')) {
    lastColumnOfParentRow.classList.add('dfa-ctrl');
  }
};
Container.prototype._removeRowsAdjustmentForCloseButton = function () {
  this.pRow.classList.remove(DFA_PARENT_CSS);
};
Container.prototype.isDFAActive = function () {
  return this.pRow.classList.contains(DFA_PARENT_CSS);
};
Container.prototype.hideIrrelevant = function () {
  var _this4 = this;
  Array.from(this.pTable.rows).filter(function (row) {
    return _this4._rowsToHide(row, _this4.cRow.rowIndex);
  }).forEach(function (row) {
    return row.style.display = 'none';
  });
  if (this.pCtrlPane) {
    this.pCtrlPane.style.display = 'none';
  }
};
Container.prototype.addStyles = function () {
  this.cRow.classList.add('dfa');
};
Container.prototype.removeStyles = function () {
  this.cRow.classList.remove('dfa');
};
Container.prototype.reset = function () {
  Array.from(this.pTable.rows).forEach(function (row) {
    return row.style.display = '';
  });
  if (this.pCtrlPane) {
    this.pCtrlPane.style.display = '';
  }
  this._removeRowsAdjustmentForCloseButton();
};
Container.prototype.detach = function () {
  this.cRow.remove();
};
Container.prototype.addCloseButton = function ($closeBtn) {
  this.cRow.lastChild.append($closeBtn);
};
Container.prototype._rowsToHide = function ($row, containerRowIndex) {
  var isHeaderRow = $row.rowIndex === 0;
  var isParentRow = $row.rowIndex === containerRowIndex - 1;
  var isContainerRow = $row.rowIndex === containerRowIndex;
  var toHide = !isHeaderRow && !isParentRow && !isContainerRow;
  return toHide;
};
var _default = exports.default = DirectFunctionAccessPanel;

},{"../../app/utils/axios":1}],63:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _messageHandler = require("fcom/messages/messageHandler");
var _axios = _interopRequireDefault(require("../../app/utils/axios"));
var _ajaxRequest = require("core/Ajax/ajaxRequest");
var _DirectFunctionAccessPanel = _interopRequireDefault(require("fcom/search/DirectFunctionAccessPanel"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var SearchHistory = function SearchHistory(config, searchInput) {
  var container = document.querySelector("#".concat(config.searchHistoryContainerId));
  if (!container) {
    container = document.createElement('div');
    container.id = config.searchHistoryContainerId;
    container.className = 'search-history';
    container.style.display = 'none';
    document.body.appendChild(container);
  }
  container.classList.add('search-history');
  this.createHistoryWindowContents(container, config);
  this.container = container;
  this.containerId = config.searchHistoryContainerId;
  this.searchInput = searchInput; // set associated search input
  this.dfaEnabled = config.enableDFAInSearchHistory;
  this.closeHistoryWindowHandler = null;
  this.config = config;
};
SearchHistory.prototype.createHistoryWindowContents = function (container, config) {
  var showFlags = !window.user.isChinaSpecificUser;
  // clear existing childrens
  container.replaceChildren();
  var titleDiv = document.createElement('div');
  titleDiv.className = 'search-history-title';
  titleDiv.innerText = (0, _messageHandler.getMessage)('searchHistory.title');
  container.appendChild(titleDiv);
  var table = document.createElement('table');
  table.id = "".concat(config.searchHistoryContainerId, "_table");
  table.classList.add('list', 'marktr');
  var tr = document.createElement('tr');
  tr.className = 'search-history-header';
  this.columns = ['description', 'group', 'isin'];
  var colGroup = document.createElement('colgroup');
  table.appendChild(colGroup);
  if (showFlags) {
    var flagCol = document.createElement('col');
    flagCol.style.width = '30px';
    colGroup.appendChild(flagCol);
  }
  var _iterator = _createForOfIteratorHelper(this.columns),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var column = _step.value;
      var col = document.createElement('col');
      var th = document.createElement('th');
      if (column === 'description' && showFlags) {
        th.colSpan = 2;
      }
      colGroup.appendChild(col);
      th.innerText = (0, _messageHandler.getMessage)("incrementalsearch.col.instruments.".concat(column));
      tr.appendChild(th);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  table.appendChild(tr);
  container.appendChild(table);
  this.table = table;
};
SearchHistory.prototype.render = function () {
  var _this = this;
  // need to fetch and render data only if the history window is not already displayed
  // and search input is empty
  if (this.container.style.display === 'none' && this.searchInput.value.length === 0) {
    var self = this;
    this.setContainerStyle();
    _axios.default.get("/searchHistory/getHistory").then(function (response) {
      var data = response.data ? response.data : [];
      _this.setTableData(data);
      var closeSearchHistory = function closeSearchHistory(e) {
        if (!e.target.closest('div.search-history') && e.target !== self.searchInput) {
          document.body.removeEventListener('click', closeSearchHistory);
          self.container.style.display = 'none';
        }
      };
      document.body.addEventListener('click', closeSearchHistory);
      _this.closeHistoryWindowHandler = closeSearchHistory;
    });
  }
};
SearchHistory.prototype.setContainerStyle = function () {
  var containerTop = this.searchInput.getBoundingClientRect().top + this.searchInput.offsetHeight;
  this.container.style.top = "".concat(containerTop, "px");
};
var generateCountryFlag = function generateCountryFlag(country) {
  if (country) {
    return "<span title=\"".concat(window.YAHOO.lang.escapeHTML(country), "\" class=\"country ").concat(window.YAHOO.lang.escapeHTML(country), "\" style=\"width:16px;\"></span>");
  }
  return "<span style=\"width:16px;\"></span>";
};
SearchHistory.prototype.setTableData = function (data) {
  var _this2 = this;
  var showFlags = !window.user.isChinaSpecificUser;
  var self = this;
  this.table.querySelectorAll('tr:not(.search-history-header)').forEach(function (row) {
    return row.remove();
  });
  if (data.length) {
    var _this$table;
    var rows = data.map(function (datum) {
      var tr = document.createElement('tr');
      tr.role = 'button';
      tr.addEventListener('click', function (event) {
        onRowClick(self, datum, event.currentTarget);
      });

      // add flag
      if (showFlags) {
        var td = document.createElement('td');
        td.innerHTML = generateCountryFlag(datum.country);
        tr.appendChild(td);
      }
      var _iterator2 = _createForOfIteratorHelper(_this2.columns),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var column = _step2.value;
          var _td = document.createElement('td');
          _td.textContent = datum[column] ?? '-';
          if (column === 'description') {
            _td.style.textAlign = 'left';
          }
          tr.appendChild(_td);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return tr;
    });
    (_this$table = this.table).append.apply(_this$table, _toConsumableArray(rows));
  } else {
    // add row with empty message
    var tr = document.createElement('tr');
    tr.className = 'noresults';
    var td = document.createElement('td');
    td.colSpan = 3;
    td.innerText = (0, _messageHandler.getMessage)('searchHistory.emptyMessage');
    tr.appendChild(td);
    this.table.appendChild(tr);
  }
  this.container.style.display = 'block';
};
var onRowClick = function onRowClick(self, item, row) {
  if (self.dfaEnabled) {
    (0, _ajaxRequest.ajaxGet)('/api/v1/navigationData/navigationItemList', item).then(function (response) {
      var navData = JSON.parse(response);
      if (!_DirectFunctionAccessPanel.default.isActive(row)) {
        var dfa = new _DirectFunctionAccessPanel.default(navData, row, item);
        dfa.render();
      }
    }).catch(function () {
      var redirectLink = "/detail/detailPage.html?".concat(item.isin ? "isin=".concat(item.isin) : "ric=".concat(item.ric));
      window.location = window.ctx + redirectLink;
    });
  } else if (self.config.searchRicCallback) {
    self.config.searchRicCallback({
      name: item.description,
      ric: item.ric,
      isin: item.isin,
      type: item.type
    });
  } else if (self.config.itemCallback) {
    self.config.itemCallback('instruments', {
      description: item.description,
      id: item.ric,
      isin: item.isin,
      type: item.type
    });
  } else {
    var redirectLink = "/detail/detailPage.html?".concat(item.isin ? "isin=".concat(item.isin) : "ric=".concat(item.ric));
    window.location = window.ctx + redirectLink;
  }
};
var _default = exports.default = SearchHistory;

},{"../../app/utils/axios":1,"core/Ajax/ajaxRequest":48,"fcom/messages/messageHandler":61,"fcom/search/DirectFunctionAccessPanel":62}],64:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ajaxRequest = require("core/Ajax/ajaxRequest");
var _messageHandler = require("fcom/messages/messageHandler");
var _searchTypesEnum = _interopRequireDefault(require("fcom/search/searchTypesEnum"));
var _ThirdLevelTable = _interopRequireDefault(require("fcom/search/ThirdLevelTable"));
var _basicTableControls = _interopRequireDefault(require("fcom/search/basicTableControls"));
var _keyCodes = _interopRequireDefault(require("fcom/util/enums/keyCodes"));
var _DirectFunctionAccessPanel = _interopRequireWildcard(require("fcom/search/DirectFunctionAccessPanel"));
var _axios = _interopRequireDefault(require("../../app/utils/axios"));
var _tableColumnDefinitio;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var tableColumnDefinitions = (_tableColumnDefinitio = {}, _defineProperty(_tableColumnDefinitio, _searchTypesEnum.default.INSTRUMENTS, ['description', 'group', 'isin']), _defineProperty(_tableColumnDefinitio, _searchTypesEnum.default.NEWS, ['headline', 'timestamp']), _defineProperty(_tableColumnDefinitio, _searchTypesEnum.default.WLPF, ['caption', 'type']), _defineProperty(_tableColumnDefinitio, _searchTypesEnum.default.NAV, ['page']), _defineProperty(_tableColumnDefinitio, _searchTypesEnum.default.ISSUER, ['bnd_issuer', 'bnd_issuer_domicile']), _tableColumnDefinitio);
var ELEMENT_ID = {
  SEARCH_INPUT: 1,
  LEFT_PANEL: 2,
  RESULT_TABLE1: 3,
  RESULT_TABLE2: 4,
  PAGINATION_CONTROL: 5,
  RESULT2_BACK: 6,
  GENERIC_BUTTONS: 7
};
var INSTRUMENT_ENUM = {
  BON: "BONDS",
  CER: "CERTIFICATES",
  COM: "COMMODITIES",
  CUR: "CURRENCIES",
  ECI: "ECONOMY",
  FUN: "FUNDS",
  FUT: "FUTURES",
  IND: "INDICES",
  MON: "MONEY_MARKET",
  OPT: "OPTIONS",
  STO: "STOCKS",
  WAR: "WARRANTS",
  CHN: "CHAIN"
};
var pagePathDivider = '&raquo;';
var newsLink = function newsLink(item) {
  return "/news/overview.html#newsId=".concat(item.id);
};
var detailLink = function detailLink(item) {
  return "/detail/detailPage.html?".concat(item.isin ? "isin=".concat(item.isin) : "ric=".concat(item.symbol || item.id));
};
var watchlistLink = function watchlistLink(item) {
  return "/portfolios/watchlists/detail.html?id=".concat(item.id);
};
var portfolioLink = function portfolioLink(item) {
  return "/portfolios/portfolios/portfolio.html?pfid=".concat(item.id);
};
var pageLink = function pageLink(item) {
  return "".concat(item.link);
};
var bondIssuerLink = function bondIssuerLink(item) {
  return "/screener.html?method=bondScreenerResult&purpose=&secTypeGroup=BONDS&issuer=".concat(item.bnd_issuer_code);
};
var directRicLink = function directRicLink(item) {
  return "/detail/detailPage.html?ric=".concat(encodeURIComponent(item.ric));
};
var dfaNavDataRestLink = '/api/v1/navigationData/navigationItemList';
var maxItemsPerPage = 10;
var RIC_PATTTERN = /(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*(?:[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2\uDF00-\uDF09]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDF43-\uDF4F\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F])(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*/;
var FUTURE_RIC_PATTERN = /(?=.*\d)(?=.*[A-Z])(?=.*[\d]$)/;
var SearchResultBox = function SearchResultBox(config) {
  var _this2 = this;
  var searchBox = $("#".concat(config.searchBoxId));
  if (!searchBox.length) {
    searchBox = $('<form/>').attr('id', config.searchBoxId).css('display', 'none');
    $('body').append(searchBox);
  }
  searchBox.addClass('searchbox-container');
  searchBox.toggleClass('ricsearch-enabled', config.searchRic);
  if (config.static) {
    searchBox.addClass('searchbox-static');
  }
  if (config.inPage) {
    searchBox.addClass('searchbox-inPage');
  } else {
    searchBox.removeClass('searchbox-inPage');
  }
  this.config = config || {};
  this.$searchBox = searchBox;
  this.searchTerm = null;
  this.dfaShortCut = null;
  this.searchType = config.searchType || _searchTypesEnum.default.INSTRUMENTS;
  this.searchFilter = config.instrumentTypes;
  this.instrumentTypes = config.instrumentTypes || ['*'];
  this.countInstTypeOnly = config.countInstTypeOnly !== false;
  this.page = 1;
  this.itemsPerPage = maxItemsPerPage;
  this.availableTypes = config.searchType ? [config.searchType] : window.user.searchSpacesAvailable;
  this.timeTracking = [];

  // #. To keep the active left panel item index
  this.activeLeftPanelItem = 0;

  // #. To keep the active result table 1 item index
  this.activeResultTable1Item = 0;

  // #. To keep the active result table 2 item index
  this.activeResultTable2Item = 0;

  // #. To track the result table 1 navigation starts from first row or not
  this.resetRowSelection = false;

  // #. To track the result table 2 navigation starts from first row or not
  this.resetRowSelection2 = false;

  // #. To keep the search input text box
  this.$searchInput = null;

  // #. To keep the search input text box offset position
  this.searchInputOffset = null;

  // #. To keep the search input text box Height
  this.searchInputHeight = null;

  // #. To track if the position of result box top or bottom
  this.showOnTop = false;

  // attach handlers for keyboard navigation
  var keyHandler = function keyHandler(event) {
    var keyCode = event.keyCode;
    if (!_this2.$searchBox || !_this2.isSearchBoxVisible()) {
      return true;
    }
    var propagation = true;
    switch (keyCode) {
      case _keyCodes.default.ESCAPE:
        event.preventDefault();
        _this2.hide();
        if (_this2.config.inPage) {
          _this2.setFocusToSolarSearchInput();
        }
        propagation = false;
        break;
      case _keyCodes.default.ARROW_LEFT:
        propagation = _this2.onArrowLeftPressed(event);
        break;
      case _keyCodes.default.ARROW_RIGHT:
        propagation = _this2.onArrowRightPressed(event);
        break;
      case _keyCodes.default.ARROW_DOWN:
        _this2.onArrowDownPressed(event);
        propagation = false;
        break;
      case _keyCodes.default.ARROW_UP:
        _this2.onArrowUpPressed(event);
        propagation = false;
        break;
      case _keyCodes.default.ENTER:
        _this2.onEnterKeyPressed(event);
        propagation = false;
        break;
      case _keyCodes.default.TAB:
        _this2.onTabKeyPressed(event);
        propagation = true;
        break;
      default:
        propagation = true;
        break;
    }
    return propagation;
  };
  var $panel = this.$searchBox.closest('.panel');
  var $container = $panel.length > 0 ? $panel : this.$searchBox;
  $container.unbind('keydown');
  $container.on('keydown', keyHandler);

  // #. Keep the search input ref
  this.setSearchInputRef();
  window.setTimeout(function () {
    if (!_this2.isSolarSearch()) {
      _this2.setFocusToSearch();
    } else {
      _this2.bindSolarInputKeydown();
      _this2.setRootElementRole();
    }
  }, 100);
};

/**
 * Set search input ref
 */
SearchResultBox.prototype.setSearchInputRef = function () {
  this.$searchInput = this.config.searchInput;
  this.searchInputHeight = this.$searchInput.outerHeight();
  this.searchInputOffset = this.$searchInput.offset();
};

/**
 * Bind keydown event to solar input
 */
SearchResultBox.prototype.bindSolarInputKeydown = function () {
  var _this3 = this;
  // #. Bind the event, if it is not added yet
  if (!this.$searchInput.data('solar-keydown')) {
    this.$searchInput.on('keydown', function (event) {
      _this3.onSolarInputKeydown(event);
    }).data('solar-keydown', true);
  }
};

/**
 * Set search input ref
 */
SearchResultBox.prototype.onSolarInputKeydown = function (event) {
  if (event.keyCode === _keyCodes.default.TAB && this.isSearchBoxVisible()) {
    event.preventDefault();
    event.stopPropagation();
    // #. Handle shift combo
    if (event.shiftKey === true) {
      this.setFocusToSolarLastFocusableElement();
    } else {
      this.setFocusToLeftPanel();
    }
    return false;
  }
};

/**
 * Check whether the search box is visible or not
 * @returns {boolean}
 */
SearchResultBox.prototype.isSearchBoxVisible = function () {
  return this.$searchBox.is(':visible');
};

/**
 * Check the current search is solar search or nor
 * Status based on the visibility of the result form
 * @returns {boolean}
 */
SearchResultBox.prototype.isSolarSearch = function () {
  return $(this.$searchInput).closest('.quickSearch').length > 0 || this.config.inPage === true;
};

/**
 * Returns active element id
 * @returns {numeric}
 */
SearchResultBox.prototype.activeElementId = function () {
  var $element = this.getActiveElement();
  var elementId = -1;
  if ($element.is('#popupSearchPanelInput')) {
    elementId = ELEMENT_ID.SEARCH_INPUT;
  } else if ($element.is('ul.search-list-items') || $element.is('a.keyboard-focus') && $element.parents('ul.search-list-items').length > 0) {
    elementId = ELEMENT_ID.LEFT_PANEL;
  } else if ($element.is('.controls button')) {
    elementId = ELEMENT_ID.PAGINATION_CONTROL;
  } else if ($element.is('.ricsearch table.list') || $element.is('tr.keyboard-focus') && $element.parent().is('.ricsearch table.list')) {
    elementId = ELEMENT_ID.RESULT_TABLE2;
  } else if ($element.is('table.list.marktr') || $element.is('tr.keyboard-focus') && $element.parent().is('table.list.marktr')) {
    elementId = ELEMENT_ID.RESULT_TABLE1;
  } else if ($element.is('span.back')) {
    elementId = ELEMENT_ID.RESULT2_BACK;
  } else if ($element.is('.buttonBar button') || $element.is('button.container-close')) {
    elementId = ELEMENT_ID.GENERIC_BUTTONS;
  }
  return elementId;
};

/**
 * Handle left key press event
 * #1. Focus on result table 1 - move focus to left panel
 * #2. Focus on result table 2 - move focus to result table 1(trigger back button click)
 */
SearchResultBox.prototype.onArrowLeftPressed = function (event) {
  var activeElId = this.activeElementId();
  var propagation = false;
  switch (activeElId) {
    case ELEMENT_ID.RESULT_TABLE1:
      event.preventDefault();
      this.setFocusToLeftPanel();
      break;
    case ELEMENT_ID.RESULT_TABLE2:
      event.preventDefault();
      this.$searchBox.find('.controls .back').trigger('click');
      this.disableResult2TabIndex();
      this.setFocusToResultTable();
      break;
    default:
      propagation = true;
      break;
  }
  return propagation;
};

/**
 * Handle right key press event
 * Focus on left panel - move the focus to result table 1
 */
SearchResultBox.prototype.onArrowRightPressed = function (event) {
  var activeElId = this.activeElementId();
  if (activeElId === ELEMENT_ID.LEFT_PANEL) {
    event.preventDefault();
    this.setFocusToResultTable();
    return false;
  } else {
    return true;
  }
};

/**
 * Handle arrow down key press event
 * Navigate through list/table items
 * Left Panel - list items(li.a)
 */
SearchResultBox.prototype.onArrowDownPressed = function (event) {
  var activeElId = this.activeElementId();
  switch (activeElId) {
    case ELEMENT_ID.SEARCH_INPUT:
      event.preventDefault();
      this.activeLeftPanelItem = 0;
      this.setFocusToLeftPanel();
      break;
    case ELEMENT_ID.LEFT_PANEL:
      event.preventDefault();
      this.handleLeftPanelNavigation(true);
      break;
    case ELEMENT_ID.RESULT_TABLE1:
      event.preventDefault();
      this.handleResultTableNavigation(this.getResultTable1Rows(), true, true);
      break;
    case ELEMENT_ID.RESULT_TABLE2:
      event.preventDefault();
      this.handleResultTableNavigation(this.getResultTable2Rows(), true, false);
      break;
    default:
      break;
  }
};

/**
 * Handle arrow up key press event
 * Navigate through list/table items
 * Left Panel - list items(li.a)
 */
SearchResultBox.prototype.onArrowUpPressed = function (event) {
  var activeElId = this.activeElementId();
  switch (activeElId) {
    case ELEMENT_ID.LEFT_PANEL:
      event.preventDefault();
      this.handleLeftPanelNavigation(false);
      break;
    case ELEMENT_ID.RESULT_TABLE1:
      event.preventDefault();
      this.handleResultTableNavigation(this.getResultTable1Rows(), false, true);
      break;
    case ELEMENT_ID.RESULT_TABLE2:
      event.preventDefault();
      this.handleResultTableNavigation(this.getResultTable2Rows(), false, false);
      break;
    default:
      break;
  }
};

/**
 * Handle arrow down key press event
 * Navigate through list/table items
 */
SearchResultBox.prototype.handleLeftPanelNavigation = function (isArrowDown) {
  // #. Get all list items from the left panel
  var $items = this.$searchBox.find('li a');

  // #. Get next item index
  this.activeLeftPanelItem = isArrowDown ? this.activeLeftPanelItem + 1 : this.activeLeftPanelItem - 1;

  // #. Get next item by index
  var $next = $items[this.activeLeftPanelItem];

  // #. Set first/last item as default, if no items found
  if (!$next) {
    this.activeLeftPanelItem = isArrowDown ? 0 : $items.length - 1;
    $next = $items[this.activeLeftPanelItem];
  }
  this.setRowActive($($next));

  // #. Set focus to the active row for announcing by screenreader
  $($next).attr('tabindex', 0);
  $($next).focus();
};

/**
 * Handle result table navigations
 * Navigate through list/table items
 */
SearchResultBox.prototype.handleResultTableNavigation = function ($rows, isArrowDown, isResultTable1) {
  if (!$rows || $rows && $rows.length === 0) {
    return;
  }

  // #. Local variable declaration
  var index = 0;
  var $next = null;
  var parentClassName = null;
  if (this.activeResultTable1Item === -1) {
    this.activeResultTable1Item = $rows.length - 1;
  }
  if (this.resetRowSelection === true) {
    this.activeResultTable1Item = -1;
    this.resetRowSelection = false;
  }
  if (this.activeResultTable2Item === -1) {
    this.activeResultTable2Item = $rows.length - 1;
  }
  if (this.resetRowSelection2 === true) {
    this.activeResultTable2Item = -1;
    this.resetRowSelection2 = false;
  }

  // #. Get elements bases on the table id
  // #. Update related table item index
  if (isResultTable1 === true) {
    parentClassName = '.mainsearch';
    if (isArrowDown) {
      this.activeResultTable1Item++;
    } else {
      this.activeResultTable1Item--;
    }
    index = this.activeResultTable1Item;
  } else if (!isResultTable1) {
    parentClassName = '.ricsearch';
    if (isArrowDown) {
      this.activeResultTable2Item++;
    } else {
      this.activeResultTable2Item--;
    }
    index = this.activeResultTable2Item;
  }

  // #. Get table controls
  var $prevButton = this.$searchBox.find("".concat(parentClassName, " .controls .previousPage")).not('.disabled');
  var $nextButton = this.$searchBox.find("".concat(parentClassName, " .controls .nextPage")).not('.disabled');
  var $firstButton = this.$searchBox.find("".concat(parentClassName, " .controls .firstPage")).not('.disabled');
  var $lastButton = this.$searchBox.find("".concat(parentClassName, " .controls .lastPage")).not('.disabled');

  // #. Handle last row and first row event
  if (index > $rows.length - 1) {
    // #. Update index
    if (isResultTable1 === true) {
      this.activeResultTable1Item = 0;
    } else {
      this.activeResultTable2Item = 0;
    }

    // #. Trigger pagination controls
    if ($nextButton.length) {
      $nextButton.trigger('click');
    } else if ($firstButton.length) {
      $firstButton.trigger('click');
    }
    return;
  } else if (index < 0) {
    // #. Update index
    if (isResultTable1 === true) {
      this.activeResultTable1Item = -1;
    } else {
      this.activeResultTable2Item = -1;
    }

    // #. Trigger pagination controls
    if ($prevButton.length) {
      $prevButton.trigger('click');
    } else if ($lastButton.length) {
      $lastButton.trigger('click');
    }
    return;
  }

  // #. Get next row
  $next = $rows[index];

  // #. Set updated table item index
  if (isResultTable1 === true) {
    this.activeResultTable1Item = index;
  } else {
    this.activeResultTable2Item = index;
  }

  // #. Set the row as active
  this.setRowActive($($next));

  // #. Set focus to the active row for announcing by screenreader
  $($next).attr('tabindex', 0);
  $($next).focus();
};

/**
 * Set row active - add related css class
 */
SearchResultBox.prototype.setRowActive = function ($element) {
  if (!$element) {
    return;
  }

  // #. Remove tabindex attribute from the old element
  if (this.$searchBox.find('.keyboard-focus').attr('tabindex')) {
    this.$searchBox.find('.keyboard-focus').removeAttr('tabindex');
  }

  // #. Remove active class from the old element
  this.$searchBox.find('.keyboard-focus').removeClass('hover keyboard-focus');

  // #. Set active class to new element
  $element.addClass('hover keyboard-focus');
};

/**
 * Handle Tab key press event
 *
 * @param event
 * @param isShiftKeyPressed
 * @returns {boolean}
 */
SearchResultBox.prototype.onTabKeyPressed = function (event) {
  // #. Check whether the search is solar or not
  var isSolar = this.isSolarSearch();
  var shiftKey = event.shiftKey;

  // #. Handle the solar search
  if (isSolar) {
    this.onSolarTabKeyPressed(event);
    return true;
  }
  var activeElId = this.activeElementId();
  // #. Manage shift tab combination
  if (shiftKey === true) {
    switch (activeElId) {
      case ELEMENT_ID.LEFT_PANEL:
        event.preventDefault();
        this.setFocusToSearch();
        break;
      case ELEMENT_ID.RESULT_TABLE2:
        event.preventDefault();
        this.setFocusToSearch();
        this.$searchBox.find('.controls .back').trigger('click');
        break;
      case ELEMENT_ID.RESULT_TABLE1:
        event.preventDefault();
        this.setFocusToLeftPanel();
        break;
      case ELEMENT_ID.PAGINATION_CONTROL:
        {
          // #. List only visible in the first slide of the panel
          var $list = this.$searchBox.find('ul.search-list-items');
          var $rows = null;
          var $firstButton = this.getFirstPaginationButton();
          if (!$(event.target).is($firstButton)) {
            return true;
          }
          if ($list.is(':visible')) {
            var $table = this.$searchBox.find('.mainsearch table.list.marktr');
            if ($table.length > 0) {
              event.preventDefault();
              $rows = this.getResultTable1Rows();
              this.activeResultTable1Item = $rows.length - 1;
              this.setFocusToResultTable();
            }
          } else {
            event.preventDefault();
            $rows = this.getResultTable2Rows();
            this.activeResultTable2Item = $rows.length - 1;
            this.setFocusToResultTable2();
          }
          break;
        }
      default:
        break;
    }
  } else {
    switch (activeElId) {
      case ELEMENT_ID.SEARCH_INPUT:
        event.preventDefault();
        this.activeResultTable1Item = -1;
        this.setFocusToLeftPanel(true);
        break;
      case ELEMENT_ID.LEFT_PANEL:
        {
          var _$table = this.$searchBox.find('.mainsearch table.list.marktr');
          if (_$table.length > 0) {
            event.preventDefault();
            this.setFocusToResultTable(true, event);
          }
          break;
        }
      case ELEMENT_ID.RESULT_TABLE2:
        event.preventDefault();
        this.$searchBox.find('.controls .back').focus();
        break;
      default:
        break;
    }
  }
};

/**
 * Handle Tab key press event of solar search
 * @param {Event} event
 * @returns {boolean}
 */
SearchResultBox.prototype.onSolarTabKeyPressed = function (event) {
  var _this4 = this;
  var activeElId = this.activeElementId();
  var shiftKey = event.shiftKey;
  var setFocus = function setFocus() {
    event.preventDefault();
    _this4.setFocusToSolarSearchInput();
    return false;
  };

  // #. Handle shift combination
  if (shiftKey) {
    // #. Shift + Tab from level 0 will move the focus to solar search input
    if (activeElId === ELEMENT_ID.LEFT_PANEL) {
      return setFocus();
    }
  } else {
    var $lastElement = this.getLastFocusableElement();
    var res = false;
    switch (activeElId) {
      case ELEMENT_ID.PAGINATION_CONTROL:
        if ($(event.target).is($lastElement)) {
          res = setFocus();
        }
        break;
      case ELEMENT_ID.RESULT_TABLE1:
        if ($($lastElement).is('table')) {
          res = setFocus();
        }
        break;
      case ELEMENT_ID.LEFT_PANEL:
        if ($($lastElement).find('tr.noresults').length > 0) {
          res = setFocus();
        }
        break;
      case ELEMENT_ID.RESULT2_BACK:
        if ($($lastElement).is('span.back')) {
          event.preventDefault();
          this.setFocusToResultTable2();
          res = false;
        }
        break;
      default:
        res = true;
        break;
    }
    return res;
  }
  return true;
};

/**
 * Handle Enter key press event
 *
 * @param event
 * @returns {boolean}
 */
SearchResultBox.prototype.onEnterKeyPressed = function (event) {
  var _this5 = this;
  event.preventDefault();
  var activeElId = this.activeElementId();
  var res = false;

  // 1. Trigger left panel selected item click
  // 2. Result table 1 selected row click
  // 3. Result table 2 selected row click
  // 4. Result table 2 back button click
  // 5. Result table pagination control click
  // 6. Trigger arrow right key event
  switch (activeElId) {
    case ELEMENT_ID.LEFT_PANEL:
      this.activeResultTable1Item = 0;
      // #. Set aria-selected attribute to true
      this.$searchBox.find('li a.hover.keyboard-focus').attr('aria-selected', true).trigger('click');
      break;
    case ELEMENT_ID.RESULT_TABLE1:
      this.resetRowSelection2 = true;
      this.activeResultTable2Item = 0;
      this.$searchBox.find('.mainsearch table.list.marktr').find('tr.keyboard-focus').trigger('click');
      break;
    case ELEMENT_ID.RESULT_TABLE2:
      this.$searchBox.find('.ricsearch table.list.marktr').find('tr.keyboard-focus').trigger('click');
      break;
    case ELEMENT_ID.RESULT2_BACK:
      this.getActiveElement().trigger('click');
      window.setTimeout(function () {
        _this5.setFocusToResultTable();
      }, 300);
      break;
    case ELEMENT_ID.GENERIC_BUTTONS:
    case ELEMENT_ID.PAGINATION_CONTROL:
      this.getActiveElement().click();
      break;
    default:
      this.onArrowRightPressed(event);
      res = false;
      break;
  }
  return res;
};

/**
 * Get all focusable elements in the form
 */
SearchResultBox.prototype.getAllFocusableElements = function () {
  return this.$searchBox.find('button, [href], table.list, input, select, textarea, [tabindex]:not([tabindex="-1"])').not(':disabled').not(':hidden');
};

/**
 * Get last focusable element in the form
 */
SearchResultBox.prototype.getLastFocusableElement = function () {
  var $elements = this.getAllFocusableElements();
  var isResTab2Visible = this.isResultTable2Visible();

  // #. Remove the items under result table 2 when the table is not visible
  if (!isResTab2Visible) {
    for (var i = $elements.length; i >= 0; i--) {
      if ($($elements[i]).closest('.ricsearch').length > 0) {
        $elements.splice(i, 1);
      }
    }
  }
  return $elements[$elements.length - 1];
};

/**
 * Get DOM active element
 */
SearchResultBox.prototype.getActiveElement = function () {
  return $(document.activeElement);
};

/**
 * Get solar search input element
 */
SearchResultBox.prototype.getSolarSearchInput = function () {
  return this.$searchInput || $('.quickSearch input.incrementalSearch');
};

/**
 * Get result table 1 rows collection
 */
SearchResultBox.prototype.getResultTable1Rows = function () {
  return this.$searchBox.find('table tr').not(':first');
};

/**
 * Get first active pagination control button
 */
SearchResultBox.prototype.getFirstPaginationButton = function () {
  return this.$searchBox.find('.controls button:enabled').first();
};

/**
 * Get result table 2 rows collection
 */
SearchResultBox.prototype.getResultTable2Rows = function () {
  return this.$searchBox.find('.ricsearch table tr').not(':first');
};

/**
 * Set focus to solar search input element
 */
SearchResultBox.prototype.setFocusToSolarSearchInput = function () {
  this.getSolarSearchInput().focus();
};

/**
 * Set focus to solar search last focusable element
 */
SearchResultBox.prototype.setFocusToSolarLastFocusableElement = function () {
  this.getLastFocusableElement().focus();
};

/**
 * Set focus to the right panel result table
 */
SearchResultBox.prototype.setFocusToResultTable = function (isTabKey) {
  this.$searchBox.find('.mainsearch table.list.marktr').focus();
  if (!isTabKey) {
    var $rows = this.getResultTable1Rows();
    if (this.activeResultTable1Item === -1) {
      this.activeResultTable1Item = $rows.length - 1;
    }
    this.setRowActive($($rows[this.activeResultTable1Item]));
  } else {
    this.resetRowSelection = true;
  }
};

/**
 * Set focus to the result table 2
 */
SearchResultBox.prototype.setFocusToResultTable2 = function () {
  this.$searchBox.find('.ricsearch table.list.marktr').focus();
  var $rows = this.getResultTable2Rows();
  if (this.activeResultTable2Item === -1) {
    this.activeResultTable2Item = $rows.length - 1;
  }
  this.setRowActive($($rows[this.activeResultTable2Item]));
};

/**
 * Set focus to search input
 * @returns {*|jQuery}
 */
SearchResultBox.prototype.setFocusToSearch = function () {
  this.$searchInput.focus();
};

/**
 * Assign role to the inPage/solar main div
 * Purpose to assign the WCAG attributes
 */
SearchResultBox.prototype.setRootElementRole = function () {
  this.$searchBox.closest('form').attr({
    role: 'application'
  });
};

/**
 * Set focus to search input
 */
SearchResultBox.prototype.setFocusToLeftPanel = function (isTabKey) {
  this.$searchBox.find('ul.search-list-items').focus();
  if (!isTabKey) {
    // #. Get all rows from the left panel
    var $items = this.$searchBox.find('li a');

    // #. Get last selected item
    var $item = $items[this.activeLeftPanelItem];

    // #. Set element as active
    if ($item) {
      this.setRowActive($($item));

      // #. Set focus to the active row for announcing by screenreader
      $($item).attr('tabindex', 0);
      $($item).focus();
    }
  } else {
    this.activeLeftPanelItem = -1;
  }
};

/*
 * Listen the back button click event
 */
SearchResultBox.prototype.onBackButtonClicked = function () {
  var _this6 = this;
  this.$searchBox.find('.controls .back').click(function () {
    _this6.disableResult2TabIndex();
  });
};

/**
 * Check whether the table is visible or not
 * Only visible table has class 'active'
 */
SearchResultBox.prototype.isResultTable2Visible = function () {
  return this.$searchBox.find('.ricsearch.active').length > 0;
};

/**
 * Disable tab index of buttons under result table 2
 */
SearchResultBox.prototype.disableResult2TabIndex = function () {
  var btnAttr = {
    tabindex: -1
  };
  var $ricSearch = this.$searchBox.find('.ricsearch');

  // #. Disable the table focus
  $ricSearch.find('table.list').attr(btnAttr);

  // #. Disable tabindex of the back button
  $ricSearch.find('.controls .back').attr(btnAttr);

  // #. Disable tabindex of pagination controls
  $ricSearch.find('.firstPage,.nextPage,.lastPage,.previousPage').attr(btnAttr);
  $ricSearch.find('.firstPage,.nextPage,.lastPage,.previousPage').attr(btnAttr);

  // #. Remove tab index from table row
  $ricSearch.find('tr.keyboard-focus').removeAttr('tabindex').removeClass('hover keyboard-focus');
};

/**
 * Enable tab index of buttons under result table 2
 */
SearchResultBox.prototype.enableResult2TabIndex = function () {
  var btnAttr = {
    tabindex: 0
  };
  var $ricSearch = this.$searchBox.find('.ricsearch');

  // #. Enable tabindex of the back button
  $ricSearch.find('.controls .back').attr(btnAttr);

  // #. Enable tabindex of pagination controls
  $ricSearch.find('table.list').attr(btnAttr);
};
SearchResultBox.prototype.checkDirectRicHit = function () {
  var _this7 = this;
  var timestamp = Date.now();
  var checkDirectHit = function checkDirectHit() {
    if (_this7.navigationData && _this7.searchTerm && _this7.navigationData[0] && _this7.searchTerm === _this7.navigationData[0].searchTerm[0]) {
      // Navigation data exist and its searchTerm matches with the current searchTerm
      if (_this7.results && _this7.results.length > 0 && !!_this7.results[0][window.themeProperties['incrementalSearch.symbolHitFromIncrementalResponseField']]) {
        var ric = _this7.results[0][window.themeProperties['incrementalSearch.symbolHitFromIncrementalResponseField']];
        var tickerOverride = null;
        if (_this7.results[0]['exchangePlace'] === 'LIP' && _this7.results[0]['type'] === 'FUN') {
          tickerOverride = _this7.results[0]['ticker'];
        }
        if (_this7.config.searchRicCallback) {
          _this7.hide();
          if (_this7.config.searchRicCallbackScope) {
            _this7.config.searchRicCallback.call(_this7.config.searchRicCallbackScope, {
              ric: ric,
              tickerOverride: tickerOverride
            });
          } else {
            _this7.config.searchRicCallback({
              ric: ric,
              tickerOverride: tickerOverride
            });
          }
        } else {
          defaultItemClickCallback(_this7.searchType, {
            ric: ric
          }, _this7);
        }
      } else {
        // check extraserver as fallback when incremental search does not know id
        checkExtraserver();
      }
    } else if (Date.now() < timestamp + 8000) {
      // Requests are still pending
      window.setTimeout(function () {
        checkDirectHit();
      }, 100); // wait some time whether there will be a result
    }
  };

  var checkExtraserver = function checkExtraserver() {
    (0, _ajaxRequest.ajaxGetJson)("/generalSearch.action?method=testStringForInstrumentId&test=".concat(encodeURIComponent(_this7.searchTerm))).then(function (result) {
      var isRic = result.isRic,
        ric = result.ric,
        link = result.link,
        isId = result.isId,
        isISIN = result.isISIN,
        isin = result.isin,
        description = result.description,
        type = result.type;
      // To handle duplicate entries in search history while adding ric (edit module -> search)
      if (link && (!_this7.config.searchRicCallback || isISIN)) {
        var params = {
          ric: ric
        };
        if (isISIN) {
          params.isin = isin;
        }
        // save to search history
        _axios.default.post('/searchHistory/updateHistory', params).catch(function (error) {
          console.error(error);
        });
      }
      if (_this7.dfaShortCut && (isRic || isId || isISIN)) {
        handleDFAShortCut(result, _this7);
        return;
      }
      if (isRic) {
        if (_this7.config.searchRicCallback) {
          _this7.hide();
          if (_this7.config.searchRicCallbackScope) {
            _this7.config.searchRicCallback.call(_this7.config.searchRicCallbackScope, {
              name: description,
              ric: ric,
              isin: isin,
              type: type
            });
          } else {
            _this7.config.searchRicCallback({
              name: description,
              ric: ric,
              isin: isin,
              type: type
            });
          }
        } else {
          defaultItemClickCallback(_this7.searchType, {
            ric: ric
          }, _this7);
        }
      } else if (link && !_this7.config.searchRic) {
        // only when isin is enough
        // TODO: only redirect when there is no specific click handler. e.g. a popup search on a screener should never link to detail page!
        window.redirectTo("/detail/detailPage.html?".concat(link));
        if (!_this7.config.static) {
          _this7.hide();
        }
      } else if (isISIN && _this7.config.searchRic) {// display ric hits for that isin
        // TODO: try to open ric results like if user clicked the isin, but as user
        //       anyhow has then to select a ric, it's not that severe that he must click on the isin also
        //       in the moment (one unnecessary step)
      } else if (!isId && ric && !_this7.config.ignoreUncertainRics) {
        // expect this to be a chain ric or speedguide
        speedGuideRedirect(ric, _this7.dfaShortCut);
      } else if (_this7.config.multipleSymbolInputCallback) {
        // no hits from solr and also not from extraserver, try whether it could be a multi symbol paste
        var rics = _this7.searchTerm.trim().split(/\s*[,;\n\s]\s*/);
        rics = rics.filter(function (v) {
          return v != '';
        }); // remove array positions with only empty strings
        if (rics.length > 1) {
          _this7.hide();
          _this7.config.multipleSymbolInputCallback(rics);
        }
      }
    });
  };
  if (window.themeProperties['incrementalSearch.symbolHitFromIncrementalResponseField']) {
    checkDirectHit();
  } else {
    checkExtraserver();
  }
};
SearchResultBox.prototype.hide = function () {
  this.searchTerm = null;
  this.ajaxPending = false;
  this.searchType = this.config.searchType || _searchTypesEnum.default.INSTRUMENTS;
  this.searchFilter = null;
  this.instrumentTypes = this.config.instrumentTypes || ['*'];
  this.page = 1;
  this.$searchBox.css('display', 'none');
  this.logTimeTracking();
};
SearchResultBox.prototype.show = function () {
  // #. Bind the solar search button keydown event
  if (this.isSolarSearch()) {
    this.onSolarSearchButtonKeydown();
  }
  // TODO: check if this function is even necessary as render() resets this anyway
  this.$searchBox.css('display', 'block');
};
SearchResultBox.prototype.logTimeTracking = function () {
  if (this.timeTracking && this.timeTracking.length) {
    var sum = 0;
    var max = 0;
    var finalSearchTerm = "";
    this.timeTracking.forEach(function (item) {
      sum += item.millis;
      if (item.millis > max) {
        max = item.millis;
      }
      if (item.searchTerm.length > finalSearchTerm.length) {
        finalSearchTerm = item.searchTerm;
      }
    });
    var avg = sum / this.timeTracking.length;
    window.logExecutionTime('incrementalSearch', avg, "".concat(this.timeTracking.length, " search queries for \"").concat(finalSearchTerm, "\", avg ").concat(avg, "ms, max ").concat(max, "ms time to display per query"));
    this.timeTracking = [];
  }
};

/**
 * Key handler for the solar search icon button
 * Tab - key will move the focus to result table list menu
 */
SearchResultBox.prototype.onSolarSearchButtonKeydown = function () {
  var _this8 = this;
  // #. Get the search input
  var $input = this.getSolarSearchInput();

  // #. Get the search icon button
  this.$solarSearchButton = $input.next('button.search');
  var inputID = 'incrementalsearch_results';
  var resultTable = "#".concat(inputID);

  // #. Unbind the keydown event
  this.$solarSearchButton.off('keydown');

  // #. Bind the keydown event
  this.$solarSearchButton.on('keydown', function (event) {
    var isResultVisible = $(resultTable).is(':visible');
    // #. Set focus to item list - level 0 when the result table is visible
    if (event.keyCode === _keyCodes.default.TAB && isResultVisible && !event.shiftKey) {
      event.preventDefault();
      event.stopPropagation();
      _this8.setFocusToLeftPanel();
      return false;
    }
  });
};
SearchResultBox._analyseSearchTerm = function (searchTerm) {
  if (!searchTerm || searchTerm.length < 1) {
    return {
      term: '',
      error: 'empty search string',
      dfaShortCut: null
    };
  } else {
    var serchTermWithDFAShortCut = searchTerm.split('/');
    if (serchTermWithDFAShortCut.length == 1) {
      return {
        term: searchTerm,
        error: '',
        dfaShortCut: null
      };
    } else {
      var vdfaShortCut = serchTermWithDFAShortCut.pop();
      var vterm = serchTermWithDFAShortCut.join('/');
      return {
        term: vterm,
        error: '',
        dfaShortCut: vdfaShortCut
      };
    }
  }
};
SearchResultBox.prototype.setSearchTerm = function (searchTerm, instantSearch) {
  var _this9 = this;
  var searchTermStatus = SearchResultBox._analyseSearchTerm(searchTerm);
  searchTerm = searchTermStatus.term;
  var oldSearchTerm = this.searchTerm;
  this.searchTerm = searchTerm.trim();
  this.page = 1; //reset the page to first page when there is a change in search term
  this.dfaShortCut = searchTermStatus.dfaShortCut == null ? null : searchTermStatus.dfaShortCut.trim();
  if (instantSearch && !this.config.disableInstantSearch) {
    this.itemsPerPage = 1;
    this.checkDirectRicHit();
  } else {
    this.calculateItemsPerPage();
  }
  var isSearchTermValid = this.searchTerm && this.searchTerm.length > 0;
  if (!isSearchTermValid) {
    this.navigationData = [];
  }
  if (!isSearchTermValid || this.searchTerm === oldSearchTerm) {
    // do nothing and return a successful promise
    this.render(); // TODO: full rerender should not be necessary here (currently necessary because render attaches the proper click handlers to hide the overlay)
    return Promise.resolve([]);
  }
  return Promise.all(this.availableTypes.map(this.requestSearchType.bind(this))).then(function (responseList) {
    _this9.ajaxPending = false;
    if (responseList[0] && responseList[0].searchTerm && responseList[0].searchTerm[0] === _this9.searchTerm) {
      _this9.setData(responseList);
      _this9.render();
      _this9.updatePosition();
    }
    _this9.logData(responseList);
    return responseList;
  });
};
SearchResultBox.prototype.requestSearchType = function (type) {
  var offset = (this.page - 1) * this.itemsPerPage;
  var settings = {
    type: type,
    term: this.searchTerm,
    offset: offset,
    limit: this.itemsPerPage,
    filter: this.instrumentTypes[0],
    countInstTypeOnly: this.countInstTypeOnly
  };
  var filter = this.searchFilter ?? this.config.instrumentTypes ?? '*';
  settings.filter = filter;
  if (!this.searchTerm || this.searchTerm.length < 1) {
    return {
      // return an empty list in case of errors
      type: type,
      count: 0,
      result: [],
      facets: [],
      error: 'empty search string'
    };
  }
  if ((window.user.locale === 'ja' || window.user.locale === 'zh') && type === "instruments") {
    // fetch the index based on user locale
    var index = window.user.locale === 'ja' ? 'LMM_ja' : 'LMM_zh';
    var shortenInstrumentTitle = filter === "*" ? "*" : Object.keys(INSTRUMENT_ENUM).find(function (key) {
      return INSTRUMENT_ENUM[key] === filter;
    });
    return this.requestSearchTypeForAsia(index, shortenInstrumentTitle);
  } else {
    this.ajaxPending = true;
    return (0, _ajaxRequest.ajaxGetJson)('/incrementalSearch.action', settings).catch(function (error) {
      return {
        // return an empty list in case of errors
        type: type,
        count: 0,
        result: [],
        facets: [],
        error: error
      };
    });
  }
};
SearchResultBox.prototype.requestSearchTypeForAsia = function (index) {
  var _this10 = this;
  var instrument = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "*";
  return new Promise(function (resolve, reject) {
    // set the payload for api request
    var payload = {
      search: _this10.searchTerm,
      instrumentType: [instrument],
      exchanges: [],
      fids: ["symbol", "type", "country", "currency", "exchangePlace", "displayname", "id"],
      pageSize: _this10.itemsPerPage,
      pageNo: _this10.page - 1,
      boost: {}
    };
    window.dory.ServiceRest.post("/find/globalsearch/".concat(index), payload).then(function (response) {
      var responseData = response.data;
      var modifiedData = {};
      if (responseData.status === "OK") {
        // Modify the data object to the required format
        modifiedData.count = responseData.totalCount;
        modifiedData.result = [];
        modifiedData.searchTerm = [_this10.searchTerm];
        modifiedData.type = "instruments";
        modifiedData.facets = [];
        var partialCounts = responseData.partialCounts;
        var instrumentAvailable = Object.keys(partialCounts);
        // Update facets
        for (var _i = 0, _instrumentAvailable = instrumentAvailable; _i < _instrumentAvailable.length; _i++) {
          var _instrument = _instrumentAvailable[_i];
          var instrumentTitle = INSTRUMENT_ENUM[_instrument];
          modifiedData.facets.push({
            count: partialCounts[_instrument],
            title: window.getMessage("instrumentType.select.".concat(instrumentTitle)),
            value: instrumentTitle
          });
        }
        // Update result array
        modifiedData.result = responseData.data.map(function (data) {
          return {
            country: data.country,
            description: data.displayname,
            type: data.type,
            group: data.type === "CHN" ? INSTRUMENT_ENUM["CHN"] : window.getMessage("instrumentType.select.".concat(INSTRUMENT_ENUM[data.type])),
            isin: data.id !== data.symbol ? data.id : '',
            symbol: data.symbol
          };
        });
      }
      resolve(modifiedData);
    }).catch(function (error) {
      reject({
        type: "instruments",
        count: 0,
        result: [],
        facets: [],
        error: error
      });
    });
  });
};
SearchResultBox.prototype.setPage = function (page) {
  this.page = page;
  this.refresh();
};
SearchResultBox.prototype.refresh = function (resetNavigationIndex) {
  var _this11 = this;
  this.requestSearchType(this.searchType).then(function (results) {
    _this11.setResults(results);
    if (_this11.navigationData[resetNavigationIndex]) {
      _this11.navigationData[resetNavigationIndex] = results;
    }
    _this11.render();
    var $table = _this11.$searchBox.find('.mainsearch table.list.marktr');
    if ($table.is(':visible')) {
      _this11.setFocusToResultTable();
    } else {
      _this11.setFocusToResultTable2();
    }
  });
};
SearchResultBox.prototype.setSearchType = function (type, filter) {
  this.page = 1;
  this.searchType = type;
  this.searchFilter = filter || null;
  var resetNavigationIndex = this.availableTypes.indexOf(type);
  this.refresh(resetNavigationIndex);
};
SearchResultBox.prototype.getTableControls = function () {
  var _this12 = this;
  var pages = Math.ceil(this.totalItems / this.itemsPerPage);
  return (0, _basicTableControls.default)({
    page: this.page,
    pages: pages,
    noLastPage: this.searchType === _searchTypesEnum.default.NEWS,
    first: function first() {
      _this12.setPage(1);
    },
    prev: function prev() {
      _this12.setPage(_this12.page - 1);
    },
    next: function next() {
      _this12.setPage(_this12.page + 1);
    },
    last: function last() {
      _this12.setPage(pages);
    },
    tableCaption: this.getTableCaption()
  });
};
SearchResultBox.prototype.getTableCaption = function () {
  return (0, _messageHandler.getMessage)('incrementalsearch.results');
};
var getCountString = function getCountString(type, count, limit) {
  return type !== 'news' ? count : count > limit ? (0, _messageHandler.getMessage)('incrementalsearch.countplus', limit) : count;
};
var generateCountryFlag = function generateCountryFlag(country) {
  if (country) {
    return "<span title=\"".concat(window.YAHOO.lang.escapeHTML(country), "\" class=\"country ").concat(window.YAHOO.lang.escapeHTML(country), "\" style=\"width:16px;\"></span>");
  }
  return "<span style=\"width:16px;\"></span>";
};
var formatColumnValue = function formatColumnValue(value, columnName, searchType, item) {
  value = value ? value : '';
  switch (columnName) {
    case 'headline':
    case 'description':
    // case 'displayname':
    case 'displaynameLeumi': // For several North American customers.
    case 'bnd_issuer':
    case 'caption':
      return "<span title=\"".concat(window.YAHOO.lang.escapeHTML(value), "\" style=\"text-align: left\">").concat(window.YAHOO.lang.escapeHTML(value), "</span>");
    case 'timestamp':
      return window.YAHOO.fcom.Format.formatDateTime(new window.fcom.date.DateTime().setTimestamp(value), {
        style: 'dateTimeLong'
      });
    case 'page':
      return "<span>".concat(value.map(function (a) {
        return "<span>".concat(window.YAHOO.lang.escapeHTML(a), "</span>");
      }).join("<span class=\"spacer\">".concat(pagePathDivider, "</span>")), "</span>");
    case 'quickQuote':
      return "<span class=\"link quickQuote\" onclick=\"quickQuote('".concat(item.symbol || item.id, "', event)\">Quick Quote</span>");
    case 'bnd_issuer_domicile':
      return "<span title=\"".concat(window.YAHOO.lang.escapeHTML(value), "\" class=\"country ").concat(window.YAHOO.lang.escapeHTML(value), "\" style=\"width:16px;\"></span>");
    case 'country':
      return "<span title=\"".concat(window.YAHOO.lang.escapeHTML(value), "\" class=\"country large ").concat(window.YAHOO.lang.escapeHTML(value), "\" style=\"width:32px;\"></span>");
    default:
      return window.YAHOO.lang.escapeHTML(value);
  }
};
var defaultItemClickCallback = function defaultItemClickCallback(type, item, searchResultBox, evt) {
  var dfaStatus = decideDirectFunctionAccess(type, item, evt);
  switch (dfaStatus.state) {
    case DFA_STATUS.CREATE:
      {
        toDirectFunctionAccess(type, item, dfaStatus.parent);
        break;
      }
    case DFA_STATUS.IRRELEVANT:
      {
        redirectDecision(type, item, searchResultBox);
        break;
      }
  }
};
var handleDFAShortCut = function handleDFAShortCut($searchTermMetaDta, $searchResultBox) {
  (0, _ajaxRequest.ajaxGet)(dfaNavDataRestLink, generateDataItem($searchTermMetaDta)).then(function (response) {
    var navData = JSON.parse(response);
    var navDataForShortCut = _DirectFunctionAccessPanel.default.navDataForShortCode(navData.itemList, $searchResultBox.dfaShortCut);
    if ($searchResultBox.dfaShortCut != navDataForShortCut.shortCode && !(RIC_PATTTERN.test($searchResultBox.searchTerm) || FUTURE_RIC_PATTERN.test($searchResultBox.searchTerm))) {
      speedGuideRedirect($searchResultBox.searchTerm, $searchResultBox.dfaShortCut);
    } else {
      dfaRedirect($searchTermMetaDta, navDataForShortCut);
    }
  }).catch(function (e) {
    console.error(e);
    dfaRedirect($searchTermMetaDta, {
      linkCode: 'overv'
    });
  });
};
/*
    When search term is an ISIN use the RIC from navigation data
    because ric is the safest id for all detail pages.
 */
var dfaRedirect = function dfaRedirect($instrMetaData, $navMetaData) {
  var instrData = {};
  if ($instrMetaData.isISIN) {
    if ($navMetaData.ric) {
      instrData = Object.assign(instrData, {
        isin: $instrMetaData.isin,
        symbol: $navMetaData.ric
      });
    } else {
      instrData = Object.assign(instrData, {
        isin: $instrMetaData.isin
      });
    }
  } else {
    instrData = Object.assign(instrData, {
      isin: $instrMetaData.isin,
      symbol: $instrMetaData.ric
    });
  }
  if ($navMetaData.linkUrl && $navMetaData.linkUrl.includes('&view=')) {
    var queryParams = $navMetaData.linkUrl.split('?')[1];
    var viewName = new URLSearchParams(queryParams).get('view');
    instrData = Object.assign(instrData, {
      viewName: viewName
    });
  }
  _DirectFunctionAccessPanel.default.redirectToFunction(instrData, $navMetaData.linkCode);
};
var DFA_STATUS = {
  CREATE: 'create',
  ACTIVE: 'active',
  IRRELEVANT: 'irrelevant'
};
var decideDirectFunctionAccess = function decideDirectFunctionAccess(type, item, evt) {
  if (type === _searchTypesEnum.default.INSTRUMENTS) {
    if (item.isin || item.id || item.symbol) {
      var dfaParentRow = evt.target.closest("tr");
      if (!_DirectFunctionAccessPanel.default.isActive(dfaParentRow)) {
        return {
          state: DFA_STATUS.CREATE,
          parent: dfaParentRow
        };
      } else {
        return {
          state: DFA_STATUS.ACTIVE,
          parent: dfaParentRow
        };
      }
    }
  }
  return {
    state: DFA_STATUS.IRRELEVANT,
    parent: null
  };
};
var toDirectFunctionAccess = function toDirectFunctionAccess(type, $item, $dfaParentRow) {
  (0, _ajaxRequest.ajaxGet)(dfaNavDataRestLink, generateDataItem($item)).then(function (response) {
    var navData = JSON.parse(response);
    var dfa = new _DirectFunctionAccessPanel.default(navData, $dfaParentRow, $item);
    dfa.render();
  }).catch(function (e) {
    console.error(e);
    redirectDecision(type, item, searchResultBox);
  });
};
var generateDataItem = function generateDataItem($item) {
  return $item.isin ? {
    isin: $item.isin
  } : {
    ric: $item.symbol || $item.id
  };
};
var redirectDecision = function redirectDecision(type, item, searchResultBox) {
  var _SEARCHTYPE$NEWS$SEAR;
  // choose the appropriate function and pass item to get the new target url
  if (item.ric) {
    window.redirectTo(directRicLink(item));
    return;
  }
  window.location = window.ctx + (_SEARCHTYPE$NEWS$SEAR = {}, _defineProperty(_SEARCHTYPE$NEWS$SEAR, _searchTypesEnum.default.NEWS, newsLink), _defineProperty(_SEARCHTYPE$NEWS$SEAR, _searchTypesEnum.default.INSTRUMENTS, detailLink), _defineProperty(_SEARCHTYPE$NEWS$SEAR, _searchTypesEnum.default.WLPF, item.group === 'WL' ? watchlistLink : portfolioLink), _defineProperty(_SEARCHTYPE$NEWS$SEAR, _searchTypesEnum.default.NAV, pageLink), _defineProperty(_SEARCHTYPE$NEWS$SEAR, _searchTypesEnum.default.ISSUER, bondIssuerLink), _SEARCHTYPE$NEWS$SEAR)[type](item);
  if (!searchResultBox.config.static) {
    searchResultBox.hide();
  }
};
var ricSearchItemClickCallback = function ricSearchItemClickCallback(type, item, searchResultBox) {
  var tickerOverride = null;
  if (item.exchangePlace === 'LIP' && item.type === 'FUN') {
    tickerOverride = item.ticker;
  }
  (0, _ajaxRequest.ajaxPostJson)('/generalSearch.action', {
    method: 'handleRicSearch',
    id: item.symbol || item.id,
    isin: item.isin
  }).then(function (response) {
    if (response.result.length <= 1) {
      var ric = item.symbol || item.id;
      if (response.result.length === 1 && response.result[0].ric) {
        ric = response.result[0].ric;
      }
      // use item ric instead of exchange selection
      searchResultBox.hide();
      if (searchResultBox.config.searchRicCallbackScope) {
        searchResultBox.config.searchRicCallback.call(searchResultBox.config.searchRicCallbackScope, {
          ric: ric,
          name: item.description || item.displaynameLeumi,
          tickerOverride: tickerOverride,
          type: item.type
        });
      } else {
        searchResultBox.config.searchRicCallback({
          ric: ric,
          name: item.description || item.displaynameLeumi,
          tickerOverride: tickerOverride,
          type: item.type
        });
      }
      return;
    }
    var $ricSearch = searchResultBox.$searchBox.find('.ricsearch');
    new _ThirdLevelTable.default($ricSearch.get(0), response, {
      itemsPerPage: searchResultBox.itemsPerPage,
      columns: searchResultBox.config.l3Columns,
      clickHandler: function clickHandler() {
        searchResultBox.hide();
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        if (searchResultBox.config.searchRicCallbackScope) {
          var _searchResultBox$conf;
          (_searchResultBox$conf = searchResultBox.config.searchRicCallback).call.apply(_searchResultBox$conf, [searchResultBox.config.searchRicCallbackScope].concat(args));
        } else {
          var _searchResultBox$conf2;
          (_searchResultBox$conf2 = searchResultBox.config).searchRicCallback.apply(_searchResultBox$conf2, args);
        }
      }
    });
    $ricSearch.addClass('active');
    var $mainSearch = searchResultBox.$searchBox.find('.mainsearch');
    $mainSearch.removeClass('active');
    searchResultBox.enableResult2TabIndex();
    searchResultBox.onBackButtonClicked();
    $ricSearch.find('table.list').focus();
  });
};
SearchResultBox.prototype.handleItemClick = function (item, e) {
  var callbackFunction = this.config.itemCallback || (this.config.searchRic ? ricSearchItemClickCallback : defaultItemClickCallback);
  callbackFunction(this.searchType, item, this, e);
};
SearchResultBox.prototype.getNavigationListItem = function (name, count, isActive, clickHandler) {
  var sublist = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  return $('<li/>').toggleClass('active', isActive).append($('<a/>').attr({
    role: 'tab',
    'aria-controls': 'panelMainSearch',
    'aria-selected': isActive,
    tabindex: this.config.isMobile ? 0 : -1
  }).html("<span class=\"name\">".concat(name, "</span> <span class=\"count\">").concat(count, "</span>")).on('click', clickHandler)).append(sublist);
};
SearchResultBox.prototype.render = function () {
  var _this13 = this;
  var showFlags = !window.user.isChinaSpecificUser;
  var _this = this;
  this.navigationData = this.navigationData || [];

  // Create Navigation HTML
  var searchResultNavigation = this.navigationData.map(function (navigationItem) {
    navigationItem.facets = navigationItem.facets || [];
    var getClickHandler = function getClickHandler(facetValue) {
      return function () {
        _this.$searchBox.find('li').removeClass('active');
        if (facetValue === _this.searchFilter) {
          _this.setSearchType(navigationItem.type);
        } else {
          $(this).parent('li').addClass('active');
          $(this).attr('aria-selected', true);
          _this.setSearchType(navigationItem.type, facetValue);
        }
      };
    };
    var name = (0, _messageHandler.getMessage)("incrementalsearch.type.".concat(navigationItem.type));
    var sublist = navigationItem.facets.filter(function (f) {
      return f.count;
    }) // filter out facets without results
    .map(function (facet) {
      return _this13.getNavigationListItem(facet.title, facet.count, _this13.searchFilter === facet.value, getClickHandler(facet.value));
    });
    sublist = sublist.length ? $('<ul/>').append(sublist) : [];
    return _this13.getNavigationListItem(name, getCountString(navigationItem.type, navigationItem.facets.reduce(function (sum, a) {
      return sum + a.count;
    }, 0) || navigationItem.count, _this13.itemsPerPage), !_this13.searchFilter && navigationItem.type === _this13.searchType, getClickHandler(), sublist);
  });

  // Get Table Columns to be displayed
  var tableColumns = Object.assign({}, tableColumnDefinitions, this.config.columns || {})[this.searchType] || [];
  if (!(this.config.columns && this.config.columns[this.searchType]) && this.results && this.results[0] && this.results[0].ticker && this.searchType === _searchTypesEnum.default.INSTRUMENTS) {
    // if a ticker is available it should be used instead of ISIN
    tableColumns = ['description', 'group', 'ticker'];
    if (this.results[0].country) {
      tableColumns.push('country');
    }
  }
  // Create Results HTML if available
  var searchResults = null;
  if (this.results) {
    _DirectFunctionAccessPanel.default.deActivate();
    searchResults = this.results.map(function (resultRow) {
      return $('<tr/>').attr('role', 'button').attr('tabindex', _this13.isMobile ? 0 : -1).append(_this13.searchType === _searchTypesEnum.default.INSTRUMENTS && showFlags ? "<td>".concat(generateCountryFlag(resultRow.country), "</td>") : '').append(tableColumns.map(function (col) {
        return "<td class=\"".concat(col === 'ticker' ? 'trim' : '', "\">").concat(formatColumnValue(resultRow[col], col, _this13.searchType, resultRow), "</td>");
      })).on('click', function (e) {
        if (_DirectFunctionAccessPanel.default.allowClick()) {
          _this13.handleItemClick(resultRow, e);
        }
        e.stopPropagation();
      });
    });
  }
  var $resultTable = $('<table/>').addClass('list').append($('<colgroup/>').append(this.searchType === _searchTypesEnum.default.INSTRUMENTS && showFlags ? $('<col/>').css('width', '30px') : '').append(tableColumns.map(function (colName) {
    return $('<col/>').addClass("col-".concat(colName));
  }))).append($('<tr/>').append(tableColumns.map(function (colName) {
    return $('<th/>').text((0, _messageHandler.getMessage)("incrementalsearch.col.".concat(_this13.searchType, ".").concat(colName))).attr('colSpan', _this13.searchType === _searchTypesEnum.default.INSTRUMENTS && colName === 'description' && showFlags ? 2 : 1);
  })));
  var $ul = $('<ul/>').attr({
    tabindex: 0
  }).addClass('search-list-items').attr('role', 'tablist').append(searchResultNavigation);
  var $mainsearchRightPanel = $('<div/>').append($resultTable);
  if (searchResults && searchResults.length) {
    var $tableCaption = $('<caption/>').text(this.getTableCaption()).addClass('visuallyhidden');
    $resultTable.addClass('marktr').attr('tabindex', 0).prepend($tableCaption).append(searchResults);
    $mainsearchRightPanel.append(this.getTableControls());
  } else {
    $resultTable.append($('<tr/>').addClass('noresults').append($('<td/>').attr('colspan', tableColumns.length).attr({
      'role': 'alert',
      'aria-live': 'polite'
    }).html((0, _messageHandler.getMessage)('incrementalsearch.noresults', (0, _messageHandler.getMessage)("incrementalsearch.type.".concat(this.searchType))))));
  }
  var $results = $('<div/>').addClass('mainsearch active').attr({
    role: 'tabpanel',
    id: 'panelMainSearch'
  }).attr('id', 'panelMainSearch').append($ul).append($mainsearchRightPanel);
  var $combinedResults = $('<div/>').addClass('search-results').append($results).append('<div class="ricsearch"></div>');

  // Add items to DOM
  this.$searchBox.html('').append($combinedResults);
  if (!this.config.static) {
    // Register a body click handler to remove the box
    var clickFunction = function clickFunction(e) {
      if (!$(e.target).parents("#".concat(_this13.config.searchBoxId)).length && !$(e.target).is('[data-incrementalsearch]') && !e.target.isEqualNode(_this13.$searchInput[0])) {
        $('body').unbind('click', clickFunction);
        _this13.hide();
      }
    };
    $('body').on('click', clickFunction.bind(_this));
  }
};

// Position Search Box properly on the screen
SearchResultBox.prototype.updatePosition = function () {
  var enableSmartPositioning = this.config.smartPositioning || false;
  var height = this.$searchBox.outerHeight();
  var position = this.searchInputOffset;
  var top = position.top + this.searchInputHeight;
  if (enableSmartPositioning && this.showOnTop) {
    top = position.top - height - 8;
  }
  this.$searchBox.css({
    top: "".concat(top, "px")
  });
  window.setTimeout(function () {
    window.YAHOO.widget.Overlay.windowResizeEvent.fire();
  });
};
SearchResultBox.prototype.setResults = function (_ref) {
  var result = _ref.result,
    type = _ref.type,
    count = _ref.count,
    error = _ref.error;
  if (error) {
    console.error(error);
  }
  this.results = result;
  this.searchType = type;
  this.totalItems = Math.min(this.itemsPerPage * 100, count); // sets the 'totalItems' based on 'itemsPerPage' to limit the page size to 100
};

SearchResultBox.prototype.setData = function (data) {
  this.navigationData = data;
  // Take the first resultset that has any results, or as fallback select instruments (index 0)
  var returnResult = data.find(function (f) {
    return !!f && f.count;
  });
  this.setResults(returnResult || data[0]);
};
SearchResultBox.prototype.logData = function (data) {
  data.map(function (navigationItem) {
    if (navigationItem && navigationItem.pathString) {
      console.log({
        Solr_search_human_readable: navigationItem.pathString
      });
      console.log("Solr search link: ".concat(encodeURI(navigationItem.pathString)));
    }
  });
};
SearchResultBox.prototype.calculateItemsPerPage = function () {
  this.searchInputOffset = this.$searchInput.offset();
  var searchInputX = this.searchInputOffset.top - $(window).scrollTop();
  this.showOnTop = true;
  var availableHeight = searchInputX;
  if (availableHeight < window.innerHeight - (searchInputX + this.searchInputHeight)) {
    // Top has more space, show results on bottom
    this.showOnTop = false;
    availableHeight = window.innerHeight - searchInputX - this.searchInputHeight;
  }
  var headRowHeight = 44;
  var rowHeight = 45;
  var paginationHeight = 30;
  var searchBoxSpacing = 10;
  var possibleRows = (availableHeight - headRowHeight - paginationHeight - searchBoxSpacing) / rowHeight;
  if (possibleRows > 4 && possibleRows < maxItemsPerPage) {
    this.itemsPerPage = Math.floor(possibleRows);
  }
};
var speedGuideRedirect = function speedGuideRedirect(ric, dfaShortCut) {
  // Convert ric to uppercase only if it's currently in lowercase
  var modifiedRic = ric && ric.toLowerCase() === ric ? ric.toUpperCase() : ric;
  // Convert dfa to uppercase only if it's currently in lowercase
  var modifiedDFA = dfaShortCut && dfaShortCut.toLowerCase() === dfaShortCut ? dfaShortCut.toUpperCase() : dfaShortCut;
  var joinedRic = dfaShortCut ? modifiedRic + '/' + modifiedDFA : ric;
  window.redirectTo("/detail/detailPage.html?ric=".concat(encodeURIComponent(joinedRic)));
};
var _default = exports.default = SearchResultBox;

},{"../../app/utils/axios":1,"core/Ajax/ajaxRequest":48,"fcom/messages/messageHandler":61,"fcom/search/DirectFunctionAccessPanel":62,"fcom/search/ThirdLevelTable":65,"fcom/search/basicTableControls":66,"fcom/search/searchTypesEnum":68,"fcom/util/enums/keyCodes":76}],65:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _messageHandler = require("fcom/messages/messageHandler");
var _basicTableControls = _interopRequireDefault(require("fcom/search/basicTableControls"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var tableFidlets = ['SEGMENT', 'DATA_QUALITY_IMAGE', 'TRADE_PRICE_MARKED', 'CURRENCY_SHORT'];
var TABLE_ACTIONS = {
  FIRST: 0,
  PREVIOUS: 1,
  NEXT: 2,
  LAST: 3
};
var ThirdLevelTable = function ThirdLevelTable(node, data, config) {
  var _this = this;
  var tableFidletsAtm = tableFidlets.slice(0);
  if (data.type === 'FUT') {
    tableFidletsAtm = ['EXPIR_DATE', 'RIC_KEY', 'DATA_QUALITY_IMAGE', 'TRADE_PRICE_MARKED', 'CURRENCY_SHORT'];
  }
  var fidlets = config.columns.length > 0 ? config.columns : window.themeProperties['incrementalSearch.level3Columns'] || tableFidletsAtm;
  this.columns = fidlets.map(function (a) {
    var index = data.fidlets.findIndex(function (f) {
      return f[0] === a;
    });
    return [].concat(_toConsumableArray(data.fidlets[index]), [index]);
  });
  this.rawData = data;
  this.data = data.result.map(function (a) {
    return {
      ric: a.ric,
      isin: a.isin,
      data: _this.columns.map(function (c) {
        return a.data[c[2]];
      }) // find datapoints that are in the columns array
    };
  });

  this.type = data.type;
  if (data.type === 'FUT') {
    this.data.sort(function (a, b) {
      if (a.ric < b.ric) {
        return -1;
      }
      if (a.ric > b.ric) {
        return 1;
      }
      return 0;
    });
  }
  this.node = node;
  this.page = 1;
  this.count = data.count;
  this.itemsPerPage = config.itemsPerPage;
  this.clickHandler = config.clickHandler;
  this.tableAction = null;
  this.render(true);
};
ThirdLevelTable.prototype.getTableControls = function () {
  var _this2 = this;
  var pages = Math.ceil(this.count / this.itemsPerPage);
  var $controls = (0, _basicTableControls.default)({
    page: this.page,
    pages: pages,
    first: function first() {
      _this2.tableAction = TABLE_ACTIONS.FIRST;
      _this2.setPage(1);
    },
    prev: function prev() {
      _this2.tableAction = TABLE_ACTIONS.PREVIOUS;
      _this2.setPage(_this2.page - 1);
    },
    next: function next() {
      _this2.tableAction = TABLE_ACTIONS.NEXT;
      _this2.setPage(_this2.page + 1);
    },
    last: function last() {
      _this2.tableAction = TABLE_ACTIONS.LAST;
      _this2.setPage(pages);
    },
    tableCaption: this.getTableCaption()
  });
  var $backButton = $('<span/>').addClass('back').attr({
    'role': 'button',
    'tabindex': 0
  }).text((0, _messageHandler.getMessage)('incrementalsearch.ricsearch.back')).click(function () {
    return $(_this2.node).removeClass('active').siblings('.mainsearch').addClass('active');
  });
  $controls.prepend($backButton);
  return $controls;
};
ThirdLevelTable.prototype.getTableCaption = function () {
  return (0, _messageHandler.getMessage)('incrementalsearch.results.level');
};
ThirdLevelTable.prototype.setPage = function (page) {
  this.page = page;
  this.render();
};
ThirdLevelTable.prototype.render = function (isOnLoad) {
  var _this3 = this;
  var $activeRow = $('.ricsearch table.list.marktr tr.hover.keyboard-focus');
  var $nextRow = $activeRow.next('tr');
  var $prevRow = $activeRow.prev('tr');
  if ($prevRow.is(':first-child')) {
    $prevRow = [];
  }
  var $table = $('<table/>').addClass('list marktr');
  var $tableCaption = $('<caption/>').text(this.getTableCaption()).addClass('visuallyhidden');
  var offset = (this.page - 1) * this.itemsPerPage;
  var displayResults = this.data.slice(offset, offset + this.itemsPerPage);

  // create header row
  var firstColWidth = '50%';
  if (this.columns.length === 5) {
    firstColWidth = '40%';
  } else if (this.columns.length >= 5) {
    firstColWidth = '30%';
  }
  var colsRow = this.columns.map(function (a, i) {
    return $('<col/>').attr('width', !i ? firstColWidth : 'auto');
  });
  var headerRow = this.columns.map(function (a, i) {
    return $('<th/>').text(a[1]);
  });
  $table.append($('<colgroup/>').append(colsRow));
  $table.append($('<tr/>').append(headerRow));
  $table.append(displayResults.map(function (result) {
    return $('<tr/>').attr('role', 'button').attr('tabindex', _this3.isMobile ? 0 : -1).append(
    // create data row
    result.data.map(function (a) {
      return $('<td/>').html("<span>".concat(a[1], "</span>"));
    })).on('click', function () {
      var dataForCallback = _this3.getDataForCallback(result.ric);
      if (result.isin) {
        dataForCallback.isin = result.isin;
      }
      if (_this3.type) {
        dataForCallback.type = _this3.type;
      }
      _this3.clickHandler(dataForCallback);
    });
  }));
  $table.prepend($tableCaption);
  $(this.node).html('').append($('<div/>').append($table).append(this.getTableControls()));
  $table.attr({
    tabindex: 0
  });

  // #. Set focus to active row
  if (!isOnLoad) {
    if (this.tableAction === TABLE_ACTIONS.NEXT || this.tableAction === TABLE_ACTIONS.FIRST) {
      $table.find('.keyboard-focus').removeClass('hover keyboard-focus');
      this.setRowActive($table, $table.find('tr').not(':first').first());
    } else if (this.tableAction === TABLE_ACTIONS.PREVIOUS || this.tableAction === TABLE_ACTIONS.LAST) {
      var $rows = $table.find('tr').not(':first');
      this.setRowActive($table, $($rows[$rows.length - 1]));
    }
  } else {
    $table.focus();
  }
};
ThirdLevelTable.prototype.getDataForCallback = function (ric) {
  var dataSet = this.rawData.result.find(function (f) {
    return f.ric === ric;
  }).data;
  var nameKeyIndex = this.rawData.fidlets.findIndex(function (f) {
    return f[0] === 'NAME_SHORT_KEY';
  });
  return {
    ric: ric,
    name: dataSet[nameKeyIndex][1]
  };
};
ThirdLevelTable.prototype.setRowActive = function ($table, $row) {
  $table.find('.keyboard-focus').removeClass('hover keyboard-focus');
  $row.addClass('hover keyboard-focus').attr({
    tabindex: 0
  }).focus();
};
var _default = exports.default = ThirdLevelTable;

},{"fcom/messages/messageHandler":61,"fcom/search/basicTableControls":66}],66:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _messageHandler = require("fcom/messages/messageHandler");
/**
 * Simple Method to generate a table control item
 * config param includes current page, total pages, and functions for paginating to first, next, previous and last page
 */
var getBasicTableControls = function getBasicTableControls(_ref) {
  var page = _ref.page,
    pages = _ref.pages,
    first = _ref.first,
    next = _ref.next,
    prev = _ref.prev,
    last = _ref.last,
    noLastPage = _ref.noLastPage,
    tableCaption = _ref.tableCaption;
  var navItem = function navItem(className, disabled, fn) {
    return $('<button/>').addClass('icon').addClass(className + (disabled ? ' disabled' : '')).prop('disabled', disabled ? true : false).attr('title', (0, _messageHandler.getMessage)("tables.tableControls.paging.tooltip.".concat(className))).attr('aria-label', (0, _messageHandler.getMessage)("tables.tableControls.paging.label.".concat(className), tableCaption)).click(function (e) {
      if (!disabled) {
        e.preventDefault();
        e.stopPropagation();
        fn();
      }
      return false;
    });
  };
  var $controls = $('<div/>').addClass('controls');
  var pageInfo = (0, _messageHandler.getMessage)("incrementalsearch.paging.number".concat(noLastPage ? '.simple' : ''), page, pages);
  $controls.append(navItem('firstPage', page === 1, first)).append(navItem('previousPage', page === 1, prev)).append($('<span/>').text(pageInfo)).append(navItem('nextPage', page === pages, next));
  if (!noLastPage) {
    $controls.append(navItem('lastPage', page === pages, last));
  }
  return $controls;
};
var _default = exports.default = getBasicTableControls;

},{"fcom/messages/messageHandler":61}],67:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _SearchResultBox = _interopRequireDefault(require("fcom/search/SearchResultBox"));
var _runFunctionDebounced = _interopRequireDefault(require("fcom/util/functions/runFunctionDebounced"));
var _keyCodes = _interopRequireDefault(require("fcom/util/enums/keyCodes"));
var _hooks = _interopRequireDefault(require("fcom/hooks"));
var _SearchHistory = _interopRequireDefault(require("fcom/search/SearchHistory"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var debounceMilliseconds = 150; // only count keyup events after n milliseconds

var handleSearch = function handleSearch(searchBox, config, searchHistory) {
  return function (_ref) {
    var target = _ref.target,
      keyCode = _ref.keyCode;
    var input = $(target);
    var searchTerm = input.val();
    var pattern = /^[\w,.:=\+\-\/\*#\s]+$/;
    var isValidSearchTerm = pattern.test(searchTerm);
    if (keyCode === _keyCodes.default.ENTER && !isValidSearchTerm) {
      searchBox.show();
      return;
    }
    if (keyCode === _keyCodes.default.ESCAPE) {
      input.attr('value', '');
      searchBox.hide();
      return true;
    }
    if (keyCode === _keyCodes.default.TAB) {
      return true;
    }
    if (!searchTerm) {
      // show search history window as the search input has been cleared
      if (searchHistory) {
        searchHistory.render();
      }
      searchBox.hide();
      // return after creating a new SearchResultBox so it will be cleared from the screen
      return;
    }
    if (searchTerm.length > 0) {
      // Handle multi ric submit using ; or , or \n as seperator
      if (config.multipleSymbolInputCallback) {
        var rics = searchTerm.trim().split(/\s*[,;\n\t\f\r\v]\s*/);
        rics = rics.filter(function (v) {
          return v != '';
        }); // remove array positions with only empty strings
        if (rics.length > 1 && isValidSearchTerm) {
          searchBox.hide();
          if (keyCode === _keyCodes.default.ENTER) {
            config.multipleSymbolInputCallback(rics);
          }
          return;
        }
      }
    }
    var now = Date.now();
    searchBox.setSearchTerm(searchTerm, keyCode === _keyCodes.default.ENTER).then(function (results) {
      if (keyCode !== _keyCodes.default.ENTER && results[0] && results[0]['searchTerm'][0] === searchBox.searchTerm) {
        searchBox.show();
      }
      if (searchTerm.length > 0) {
        _hooks.default.onSearchResult(searchTerm, results);
        var timeTrackingObj = {
          searchTerm: searchTerm
        };
        timeTrackingObj.millis = Date.now() - now;
        searchBox.timeTracking.push(timeTrackingObj);
        $('body').unbind('click', searchHistory.closeHistoryWindowHandler);
        $("#".concat(config.searchHistoryContainerId)).hide();
      }
    });
  };
};
var initSearch = function initSearch(node, config, trigger) {
  config = config || {
    searchBoxId: 'incrementalsearch_results',
    columns: $(node).data('incrementalsearch-columns') || {},
    countInstTypeOnly: false,
    searchHistoryContainerId: 'incrementalsearch_history',
    enableDFAInSearchHistory: true
  };
  config.searchInput = $(node);
  var searchHistoryContainer;
  if (!config.isMobile) {
    searchHistoryContainer = new _SearchHistory.default(config, node);
    $(node).on('focus', function () {
      searchHistoryContainer.render();
    });
  }
  var searchBox = new _SearchResultBox.default(config);
  var handleFunction = (0, _runFunctionDebounced.default)(debounceMilliseconds, handleSearch(searchBox, config, searchHistoryContainer));
  $(node).on('keyup', handleFunction);
  $(node).siblings('button.search').click(function () {
    if ($("#".concat(config.searchBoxId, ":visible")).length > 0) {
      handleFunction({
        target: node,
        keyCode: _keyCodes.default.ENTER
      });
    } else {
      handleFunction({
        target: node
      });
    }
  });
  if (trigger) {
    handleFunction({
      target: node
    });
  }
};
var _default = exports.default = initSearch;

},{"fcom/hooks":60,"fcom/search/SearchHistory":63,"fcom/search/SearchResultBox":64,"fcom/util/enums/keyCodes":76,"fcom/util/functions/runFunctionDebounced":77}],68:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// Enum-like object containing all SearchTypes used by incrementalSearch
var SEARCHTYPE = {
  INSTRUMENTS: 'instruments',
  INSTRUMENT: 'instruments',
  NEWS: 'news',
  WLPF: 'wlpf',
  NAV: 'nav',
  BND_ISSUER: 'bnd_issuer',
  ISSUER: 'bnd_issuer'
};
var _default = exports.default = SEARCHTYPE;

},{}],69:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _StreamingTunnelClient = _interopRequireDefault(require("streaming/tunnel/StreamingTunnelClient"));
var _StreamingService = _interopRequireDefault(require("streaming/StreamingService"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var YAHOO = window.YAHOO;
var AjaxStreaming = function AjaxStreaming() {
  this.calls = 0;
  this.updates = 0;
  this.lastLog = new Date().getTime();
  this.ricFids = [];
  this.unregisterRicFids = [];
  var baseUrl = '/ajax.streaming';
  var sessionId = this.getSessionFromCookie();
  var config = null;
  if (sessionId) {
    config = {};
    config.loginData = sessionId;
    // config.requiredServices = 'Quotes,News';
    if (window.STREAMING_LOGIN_SEQUENCE) {
      config.loginSequence = window.STREAMING_LOGIN_SEQUENCE;
    }
  }
  _StreamingTunnelClient.default.init(baseUrl, config);
  _StreamingTunnelClient.default.addStatusListener(function (statusObject) {
    var that = statusObject.parameters; // get scope back
    if (that.statusListener) {
      statusObject.parameters = that.statusListenerParameters;
      that.statusListener(statusObject);
    }
  }, this);
  this.requestId = _StreamingTunnelClient.default.addStreamingListener('Quotes', this.streamingListenerCallback, this);
};
AjaxStreaming.prototype = {
  needsPolling: function needsPolling() {
    return true;
  },
  needsUnregistration: function needsUnregistration() {
    return true;
  },
  isAvailable: function isAvailable() {
    return true;
  },
  /*
   * register ric fid pairs to be streamed. This function first collects all the ric fid pairs
   * and sends them together before the first update call is done.
   */
  registerRicFidPair: function registerRicFidPair(ric, fid) {
    // this array will be worked within the next call to the requestUpdates function
    this.ricFids.push([ric, fid]);
  },
  /*
   * remove a ric fid pair, when it is not needed any more
   */
  removeRicFidPair: function removeRicFidPair(ric, fid) {
    // this array will be worked within the next call to the requestUpdates function
    this.unregisterRicFids.push([ric, fid]);
  },
  /*
   * temporarily pause the streaming service
   */
  pause: function pause() {
    window.ajaxGet('/ajax.action?method=setStreamingDisabled');
  },
  /*
   * resume a temporarily paused streaming service to run again
   * and return Promise for related follow-up work
   */
  resume: function resume() {
    return window.ajaxGetJson('/ajax.action?method=resumeStreaming').then(function (response) {
      if (response && response.loginSequence) {
        _StreamingTunnelClient.default.setConfig({
          loginSequence: response.loginSequence
        });
        _StreamingTunnelClient.default.resubscribeEverything(); // resubscription is required
      }
    });
  },

  streamingListenerCallback: function streamingListenerCallback(updates, scope) {
    // scope is in fact the current instance of the AjaxStreamingService
    var updatesArray = [];
    if (scope.callbackFunction) {
      updates.forEach(function (update) {
        var ric = update.symbol;
        if (!update.source || update.source !== 'DELAY' && update.source !== 'REALTIME') {
          // no regular update, but rather a system message
          if (scope.loggingListener) {
            scope.loggingListener({
              level: 'warn',
              message: "streaming tunnel sent unexpected update for \"".concat(update.symbol, "\": \"").concat(update.source, "\""),
              parameters: scope.loggingListenerParameters
            });
          }
          // Call each single item callback function
          if (scope.singleItemCallbacks) {
            try {
              scope.singleItemCallbacks.forEach(function (callbackFunction) {
                if (_typeof(callbackFunction) === 'object' && callbackFunction.failure instanceof Function) {
                  callbackFunction.failure(update);
                }
              });
            } catch (e) {
              // make this not break all streaming
              console.error(e);
            }
          }
          if (scope.failureCallbackFunction instanceof Function) {
            scope.failureCallbackFunction(update);
          }
        } else {
          var initialUpdatePerRic = true;
          var _loop = function _loop() {
              if (paramName === 'symbol' || paramName === 'source') {
                return {
                  v: void 0
                };
              }
              var singleUpdate = {};
              singleUpdate.ric = decodeURIComponent(ric);
              singleUpdate.fid = paramName;
              singleUpdate.content = update[paramName];
              if (initialUpdatePerRic) {
                singleUpdate.permission = update.source.toUpperCase().substring(0, 1);
                initialUpdatePerRic = false;
              }
              updatesArray.push(singleUpdate);

              // Remove from previous failure response if exists
              if (_typeof(YAHOO.fcom.Streaming.failureUpdates) === 'object') {
                delete YAHOO.fcom.Streaming.failureUpdates[singleUpdate.ric];
              }

              // Call each single item callback function
              if (scope.singleItemCallbacks) {
                try {
                  scope.singleItemCallbacks.forEach(function (callbackFunction) {
                    if (callbackFunction instanceof Function) {
                      callbackFunction(singleUpdate);
                    } else if (_typeof(callbackFunction) === 'object' && callbackFunction.success instanceof Function) {
                      callbackFunction.success(singleUpdate);
                    }
                  });
                } catch (e) {
                  // make this not break all streaming
                  console.error(e);
                }
              }
            },
            _ret;
          for (var paramName in update) {
            _ret = _loop();
            if (_ret) return _ret.v;
          }
        }
      });
      YAHOO.fcom.Streaming.notifyStatus('running');
      scope.callbackFunction(updatesArray, scope.callbackReference);
    }
  },
  generateSubscriptionRicFidMap: function generateSubscriptionRicFidMap() {
    if (!this.ricFids) {
      return {};
    }
    return this.ricFids.reduce(function (ricFidMap, ricFid) {
      var ric = ricFid[0];
      var fid = ricFid[1];
      ricFidMap[ric] = ricFidMap[ric] || [];
      if (ricFidMap[ric].indexOf(fid) === -1) {
        ricFidMap[ric].push(fid);
      }
      return ricFidMap;
    }, {});
  },
  requestUpdates: function requestUpdates() {
    if (this.unregisterRicFids && this.unregisterRicFids.length) {
      this.subScriptionRicFidMap = this.generateSubscriptionRicFidMap();
      this.unsubscribeRicFidPairs();
    }
    if (this.ricFids && this.ricFids.length) {
      // new rics and fids to subcribe
      this.subscribeRicFidPairs();
    }
    this.subScriptionRicFidMap = null;
    _StreamingTunnelClient.default.connect();
  },
  /*
   * set the callback function that will be called whenever there are updates available.
   * @param callbackFunction
   * @param objectReference
   */
  setCallbackFunction: function setCallbackFunction(callbackFunction, objectReference, failureCallbackFunction) {
    this.callbackFunction = callbackFunction;
    this.callbackReference = objectReference;
    this.failureCallbackFunction = failureCallbackFunction;
  },
  /*
   * add a callback function for single items that will be called whenever there are updates available.
   * @param singleItemCallback
   */
  addSingleItemCallback: function addSingleItemCallback(singleItemCallback) {
    this.singleItemCallbacks = this.singleItemCallbacks || [];
    this.singleItemCallbacks.push(singleItemCallback);
  },
  /*
   * remove a callback function for single items by passing a reference to an existing function
   * @param singleItemCallback
   */
  removeSingleItemCallback: function removeSingleItemCallback(singleItemCallback) {
    this.singleItemCallbacks = this.singleItemCallbacks || [];
    this.singleItemCallbacks.splice(this.singleItemCallbacks.indexOf(singleItemCallback), 1);
  },
  /*
   * these two functions are just an alias for _workSubscriptionArray
   */
  subscribeRicFidPairs: function subscribeRicFidPairs() {
    this._workSubscriptionArray();
  },
  unsubscribeRicFidPairs: function unsubscribeRicFidPairs() {
    this._workSubscriptionArray(true);
  },
  /*
   * this function works on the subscription array and tries to combine several ric, fid calls, when
   * the rics use the same fids. It is used for registering as well as for unregistering
   * @param isUnsubscription boolean, whether this call is unregistering the rics or registering
   */
  _workSubscriptionArray: function _workSubscriptionArray(isUnsubscription) {
    var _this = this;
    var ricFids = isUnsubscription ? this.unregisterRicFids : this.ricFids;
    var sendSubscriptionChanges = isUnsubscription ? _StreamingTunnelClient.default.unsubscribeQuotes.bind(_StreamingTunnelClient.default) : _StreamingTunnelClient.default.subscribeQuotes.bind(_StreamingTunnelClient.default);
    if (isUnsubscription && this.subScriptionRicFidMap) {
      // in case of unsubscription check whether there are symbols that are unregistered but reregistered in the same call (which happens often when tables are reloaded)
      ricFids = ricFids.filter(function (ricFid) {
        var ric = ricFid[0];
        var fid = ricFid[1];
        var fidstoReRegister = _this.subScriptionRicFidMap[ric] || [];
        return fidstoReRegister.indexOf(fid) === -1;
      });
    }

    //helper function
    //TODO: move this somewhere more proper
    var isIdenticalArrays = function isIdenticalArrays(arr1, arr2) {
      if (arr1.length !== arr2.length) {
        return false;
      }
      return !arr1.filter(function (item) {
        return arr2.indexOf(item) === -1;
      }).length;
    };

    //group all the values by ric and fid in order to send a more compact payload
    var groupedValues = ricFids.reduce(function (group, ricFid) {
      var ric = ricFid[0];
      var fid = ricFid[1];

      //add to the bucket grouped by ric
      group.byRic[ric] = group.byRic[ric] || [];
      if (group.byRic[ric].indexOf(fid) === -1) {
        group.byRic[ric].push(fid);
      }

      //add to the bucket grouped by fid
      group.byFid[fid] = group.byFid[fid] || [];
      if (group.byFid[fid].indexOf(ric) === -1) {
        group.byFid[fid].push(ric);
      }
      return group;
    }, {
      byRic: {},
      byFid: {}
    });

    //further compress the list by finding same subsets within the list to send an even more compact payload
    var registerList = Object.keys(groupedValues.byFid).sort(function (a, b) {
      return groupedValues.byFid[a].length - groupedValues.byFid[b].length;
    }).reduce(function (list, fid) {
      var rics = groupedValues.byFid[fid];
      if (list.length && isIdenticalArrays(list[list.length - 1][0], rics)) {
        list[list.length - 1][1].push(fid);
      } else {
        list.push([rics, [fid]]);
      }
      return list;
    }, []);

    //register or unregister all the ric & fid combinations
    registerList.forEach(function (listItem) {
      sendSubscriptionChanges(_this.requestId, listItem[0], listItem[1]);
    });

    //cleanup after the registration is done
    if (isUnsubscription) {
      this.unregisterRicFids = [];
    } else {
      this.ricFids = [];
    }
  },
  /*
   * check whether there is a cookie names 'NGPSESSIONID' and
   * return it's value. If there is no such cookie, null is returned.
   */
  getSessionFromCookie: function getSessionFromCookie() {
    //TODO: write a getCookie('key') helper function to clean this up
    return document.cookie.split(';').map(function (a) {
      return a.trim().split('=');
    }).filter(function (f) {
      return f[0] === 'NGPSESSIONID';
    }).map(function (a) {
      return a[1];
    })[0] || null;
  }
};
YAHOO.augment(AjaxStreaming, _StreamingService.default);
var _default = exports.default = AjaxStreaming;

},{"streaming/StreamingService":71,"streaming/tunnel/StreamingTunnelClient":74}],70:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var StreamingIllustration = /*#__PURE__*/function () {
  function StreamingIllustration() {
    var _this = this;
    _classCallCheck(this, StreamingIllustration);
    this.isIE = window.YAHOO.fcom.Util.detectInternetExplorer(false);
    this.cleanupListHead = null;
    if (this.isIE) {
      var loop = function loop() {
        if (_this.cleanupListHead) {
          var now = Date.now();
          if (_this.cleanupListHead.time <= now) {
            _this.cleanupListHead.value.forEach(function (nodeInfoObj) {
              if (nodeInfoObj.boxNode && nodeInfoObj.boxNode.classList.contains('streamingTouched')) {
                var classList = nodeInfoObj.boxNode.classList;
                classList.remove('streamingTouched');
                classList.remove('streamingUp');
                classList.remove('streamingDown');
                classList.remove('streamingNeutral');
              }
            });
            _this.cleanupListHead = _this.cleanupListHead.next;
          }
        }
        window.requestAnimationFrame(loop);
      };
      window.requestAnimationFrame(loop.bind(this));
    } else {
      document.addEventListener('animationend', function (e) {
        if (e.target && e.target.classList.contains('streamingTouched')) {
          e.target.classList.remove('streamingTouched', 'streamingUp', 'streamingDown', 'streamingNeutral');
        }
      });
    }
  }
  _createClass(StreamingIllustration, [{
    key: "illustrateStreaming",
    value: function illustrateStreaming(newFormatedContent, update, nodeInfoObj) {
      if (newFormatedContent != null) {
        nodeInfoObj.node.innerHTML = newFormatedContent; // set the new content first
      }

      this.highlightStreaming(nodeInfoObj, update);
    }
  }, {
    key: "highlightStreaming",
    value: function highlightStreaming(nodeInfoObj, update) {
      if (update.trend == null) {
        // mark css only if a trend is defined
        return;
      }
      if (!nodeInfoObj.boxNode || nodeInfoObj.boxNode == null) {
        // box node is the next upper node that will get the new background color.
        nodeInfoObj.boxNode = nodeInfoObj.getParentBoxNode(); // remember the box node to save that searching step next time
      }

      if (!nodeInfoObj.boxNode || nodeInfoObj.boxNode == null) {
        // no suitable box node found
        return; // skip this illustration, content is already updated
      }

      var classList = nodeInfoObj.boxNode.classList;
      if (window.STREAMING_ILLUSTRATION_HIGHLIGHT && !classList.contains('streamingTouched')) {
        // only if that node does not have a streaming illustration running already
        if (this.isIE) {
          var now = Date.now() + 2000;
          if (this.cleanupListHead != null) {
            var next = this.cleanupListHead;
            while (next != null) {
              if (now - 100 <= next.time) {
                next.value.push(nodeInfoObj);
                break;
              } else if (next.next == null) {
                next.next = {
                  time: now,
                  value: [nodeInfoObj],
                  next: null
                };
                break;
              }
              next = next.next;
            }
          } else {
            this.cleanupListHead = {
              time: now,
              value: [nodeInfoObj],
              next: null
            };
          }
        }
        classList.add('streamingTouched'); // set this node marked as streaming illustrated currently

        if (update.trend > 0.00001) {
          classList.add('streamingUp');
        } else if (update.trend < -0.00001) {
          classList.add('streamingDown');
        } else {
          classList.add('streamingNeutral');
        }
      }
    }
  }]);
  return StreamingIllustration;
}();
;
var _default = exports.default = StreamingIllustration;

},{}],71:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * Streaming service is a sort of abstract class to be used by streaming
 * implementations. When building a new streaming implementation, the
 * StreamingService must be extended and the given functions have to be implemented.
 * Then call the YAHOO.fcom.Streaming.setStreamingService() function with the streaming service
 * instance. This will trigger the loading of the streaming nodes from the html markup and as soon as the
 * streaming service's isAvailable function is returning true, the rics and fids will be registered
 */
var StreamingService = function StreamingService() {};
var doNothing = function doNothing() {};
StreamingService.prototype = {
  /*
   * register a ric with a fid to get streaming updates for
   */
  registerRicFidPair: doNothing,
  /*
   * temporarily pause the streaming service (should stop all expensive operations)
   * This does not need to be kept persistently, as the javascript streaming
   * will not register any further ric - fid pairs on any subsequent page load, as long as the
   * user keeps the streaming paused.
   */
  pause: doNothing,
  /*
   * resume a temporarily paused streaming service to run again
   * This is only needed and called when the user resumes the streaming
   * on the very same page it was paused. If there was a page load in between,
   * the new fids just get registered, no resume call will be done.
   * This method can return a Promise, in case the action requires a server round trip
   */
  resume: doNothing,
  /*
   * remove a ric fid pair, when it is not needed any more
   * This will be called on body unload for every registered ric fid pair,
   * but only, if the streaming service implementation's
   * needsUnregistration function is returning true.
   */
  removeRicFidPair: doNothing,
  /*
   * remove all registered rics and fids from the streaming with one call
   * if the streaming service implementation is not capable of doing this, this
   * function should return false to indicate that the rics and fids must be
   * unregistered one by one
   * @return true when all rics and fids are removed, false if the streaming service
   *         does not provide this functionality
   */
  removeAllRicFids: doNothing,
  /*
   * boolen function that tells whether the streaming service implementation is
   * fully initialized and ready to register ric fid pairs. If this function returns false,
   * the function is recalled (with a delay) as long until it returns true, than the streaming nodes are registered.
   */
  isAvailable: doNothing,
  /*
   * function to set a listener that will be informed whenever the status of the streaming service
   * changes. A status listener is a function that will be called with a object as single parameters
   * the object has several properties as follows:
   * - status: a string representing the status, being one of "initializing", "error", "ready", "denied", "exceeded"
   * - message: s string specifying the status, e.g. when status is error, this could be the error reason or explanation
   * - parameters: if the second parameter "parameters" was given to the setStatusListener function, the parameters will be given
   *               back with the parameters attribute. If only one parameter is needed it can be given directly, if several are needed
   *               they need to be nested in an attribute object or an array.
   * @param statusListener
   * @param parameters
   * @return
   */
  setStatusListener: function setStatusListener(statusListener, parameters) {
    this.statusListener = statusListener;
    if (parameters != null) {
      this.statusListenerParameters = parameters;
    }
  },
  /*
   * function to set a listener that will be informed whenever the streaming service has something to log.
   * The logging listener can then decide about the current log level and whether the logging should be written
   * and kept or not. Because of performance reasons, in productive mode only failures should be logged,
   * otherwise the logging will quickly increase the memory consumption of the frontend streaming, when the
   * pages are left open for a long time.
   *
   * A logging listener is a function that should take a single parameter. The parameter is an object with
   * a lot of attributes as follows:
   * - level: one out of "info", "warn", "error"
   * - message: s string that should be appended to the logging if the level is high enough
   * - parameters: if the second parameter "parameters" was given to the setLoggingListener function, the parameters will be given
   *               back with the parameters attribute. If only one parameter is needed it can be given directly, if several are needed
   *               they need to be nested in an attribute object or an array.
   * @param loggingListener the logging listener that will be called for logging events
   * @param parameters the parameters that should be given back to the listener, e.g. for scope correction
   * @return
   */
  setLoggingListener: function setLoggingListener(loggingListener, parameters) {
    this.loggingListener = loggingListener;
    if (parameters != null) {
      this.loggingListenerParameters = parameters;
    }
  },
  /*
   * the request updates function will initialize the fetching of updates
   * it is not returning anything itself, but the update handler
   * given in the setCallbackFunction will be called, when updates are available.
   * This function will only be called when the needsPolling function is returning true
   */
  requestUpdates: doNothing,
  /*
   * With this function a callback handler can be passed, that will receive updates when there are
   * some available. The callback function has to accept an array of updates. Update objects are
   * bean-like objects with attributes "ric", "fid", and "content"
   * Content is whatever should be displayed everywhere on the page,
   * where the given fid of the given ric was displayed so far.
   * In addition when the objectReference parameter was given to this funtion, it will be given as second parameter
   * to the callback handler.
   */
  setCallbackFunction: function setCallbackFunction(callbackFunction, objectReference) {
    this.callbackFunction = callbackFunction;
    this.callbackReference = objectReference;
  },
  /*
   * add a callback function for single items that will be called whenever there are updates available.
   * @param singleItemCallback
   */
  addSingleItemCallback: function addSingleItemCallback(singleItemCallback) {
    this.singleItemCallbacks = this.singleItemCallbacks || [];
    this.singleItemCallbacks.push(singleItemCallback);
  },
  /*
   * remove a callback function for single items by passing a reference to an existing function
   * @param singleItemCallback
   */
  removeSingleItemCallback: function removeSingleItemCallback(singleItemCallback) {
    this.singleItemCallbacks = this.singleItemCallbacks || [];
    this.singleItemCallbacks.splice(this.singleItemCallbacks.indexOf(singleItemCallback), 1);
  },
  /*
   * this function returns whether this streaming service needs polling
   * (request the requestUpdates function for updates periodically) or
   * if the callback function will be called automatically
   * whenever there are updates available. If the streaming service
   * supports that and a callback function is given, the requestUpdates function
   * should not be called at all.
   */
  needsPolling: function needsPolling() {
    return false;
  },
  /*
   * with this function the streaming service implementation can tell whether it needs to have all rics
   * unregistered after the page is destroyed. For javascript implementations that does not seem necessary, but
   * applet implementations or server side systems might want to know when the rics are not needed any more, to
   * clean up structures.
   * If this function returns true, the streaming service implementation will get an removeRicFidPair() call
   * for every ric fid pair that was registered, at the very moment it is not needed on the page any more
   * @return whether the ric fid pairs should be unregistered when page is unloaded.
   */
  needsUnregistration: function needsUnregistration() {
    return false;
  }
};
var _default = exports.default = StreamingService;

},{}],72:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _StreamingPayloadBlock = _interopRequireDefault(require("streaming/tunnel/StreamingPayloadBlock"));
var _StreamingTunnelClient = _interopRequireDefault(require("streaming/tunnel/StreamingTunnelClient"));
var _utils = require("streaming/tunnel/utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*
 * streaming tunnel communication packet
 */
var StreamingCommunicationPacket = function StreamingCommunicationPacket(packetNumber, isLastPacket, payloadBlock) {
  this.packetNumber = packetNumber;
  this.isLastPacket = isLastPacket;
  this.payloadBlock = payloadBlock;
  this.timestamp = new Date().getTime();
};
StreamingCommunicationPacket.prototype = {
  /*
   * write out an outgoing communication packet to a post string. The post string
   * will start with 4 character being hard coded "fSTB", which is the packet start marker.
   * Then 16 characters with the packet number, followed by 16 characters
   * with the timestamp when this packet was sent.<br>
   * Next are 8 characters with the number of data area blocks as hexadecimal int.
   * Then per data area block, requestId, data area length and data area parameters string itself follow.
   * The parameters string is an empty space (character 32) separated list of key=value pairs, with the values being
   * urlComponent encoded. At the end there is the packet end marker.
   *
   * This function takes as many blocks from the given array of payload blocks, until the payload exceeds StreamingTunnelClient.maxTransferKB
   * Then the packet is closed, so the caller has to check whether there are still blocks left in the given array.
   */
  toPostString: function toPostString() {
    var returnString = 'fSTB';
    returnString += (0, _utils.writeLong)(this.packetNumber);
    returnString += (0, _utils.writeLong)(this.timestamp);
    if (window.YAHOO.lang.isArray(this.payloadBlock)) {
      // several blocks
      var blocks = '';
      var numberOfBlocks = 0;
      while (blocks.length < 1024 * _StreamingTunnelClient.default.maxTransferKB && this.payloadBlock.length > 0) {
        blocks += this.payloadBlock.shift().toPostString();
        numberOfBlocks++;
      }
      returnString += (0, _utils.writeInt)(numberOfBlocks);
      returnString += blocks;
      if (this.payloadBlock.length > 0) {
        // still payload blocks => packets will follow
        this.isLastPacket = false;
      }
    } else {
      // just one block
      returnString += (0, _utils.writeInt)(1);
      returnString += this.payloadBlock.toPostString();
    }
    if (this.isLastPacket) {
      returnString += 'fSTE';
    } else {
      returnString += 'fSTC';
    }
    return returnString;
  }
};

/*
 * static factory function to return a new communication packet parsed
 * from the given input string.
 */
StreamingCommunicationPacket.parse = function (inputString) {
  var offset = 0;
  var packet = null;
  while (offset < inputString.length) {
    if (!(inputString.charAt(offset) === 'f' && inputString.charAt(offset + 1) === 'S' && inputString.charAt(offset + 2) === 'T' && inputString.charAt(offset + 3) === 'B')) {
      offset++; // maybe some more empty characters between packages? Search string till end.
      continue;
    }
    offset += 4; // continue behind packet start marker
    var packetNumber = (0, _utils.readLong)(inputString, offset);
    offset += 16;
    var timestamp = (0, _utils.readLong)(inputString, offset);
    offset += 16;
    var payloadBlock = null;
    var readAttributes = {
      offset: offset,
      numberOfBlocks: 0
    };
    if (!(inputString.charAt(offset) === 'f' && inputString.charAt(offset + 1) === 'S' && inputString.charAt(offset + 2) === 'T')) {
      // in case of no blocks, block number is not sent
      readAttributes.numberOfBlocks = (0, _utils.readInt)(inputString, offset);
      offset += 8;
      readAttributes.offset = offset;
      payloadBlock = _StreamingPayloadBlock.default.parseOuter(inputString, readAttributes);
      offset = readAttributes.offset; // get the new offset that was corrected by the block's parse function
    }

    var isLastPacket = inputString.charAt(offset + 3) === 'E';
    if (packet != null) {
      // packet already set => several packets
      if (!window.YAHOO.lang.isArray(packet)) {
        var tmpPacket = packet; // keep reference to last packet
        packet = [];
        packet[0] = tmpPacket;
      }
      var nextPacket = new StreamingCommunicationPacket(packetNumber, isLastPacket, payloadBlock);
      nextPacket.timestamp = timestamp;
      packet.push(nextPacket);
    } else {
      packet = new StreamingCommunicationPacket(packetNumber, isLastPacket, payloadBlock);
      packet.timestamp = timestamp;
    }
    offset += 4; // skip packet end marker
  }

  return packet;
};
var _default = exports.default = StreamingCommunicationPacket;

},{"streaming/tunnel/StreamingPayloadBlock":73,"streaming/tunnel/StreamingTunnelClient":74,"streaming/tunnel/utils":75}],73:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _utils = require("streaming/tunnel/utils");
/*
 * streaming tunnel payload block
 */
var StreamingPayloadBlock = function StreamingPayloadBlock(requestId, service, command, params) {
  this.requestId = requestId;
  if (service != null && command != null) {
    // reply blocks will not have service and command
    this.capitalLine = "".concat(service, " ").concat(command);
  }
  this.params = params;
};
StreamingPayloadBlock.prototype = {
  /*
   * write out an outgoing payload block to a post string. The post string
   * will start with 8 characters with the requestId, 8 characters with the length of the
   * parameters string and than the parameters string itself. The parameters string is an
   * empty string (character 32) separated list of key=value pairs, with the values being
   * urlComponent encoded.
   */
  toPostString: function toPostString() {
    var returnString = this.capitalLine;
    for (var name in this.params) {
      if (name != null && this.params[name] != null) {
        returnString += " ".concat(name, "=").concat(encodeURIComponent(this.params[name]));
      }
    }
    var blockLength = returnString.length;
    return (0, _utils.writeInt)(this.requestId) + (0, _utils.writeInt)(blockLength) + returnString;
  },
  /*
   * append a following block to an incomplete block
   */
  appendToIncomplete: function appendToIncomplete(block) {
    this.data += block.data; // append the data to this block's data
    if (block.isComplete === true) {
      this.isComplete = true;
    }
  },
  /*
   * function that takes the data string from the block and interpretes it.
   * Should be called after the appendToIncomplete, when the last block for that
   * block container is received, what is denoted by the isComplete == true flag
   * in that block.
   */
  parseInner: function parseInner() {
    if (this.isComplete) {
      var offset = 0;
      var separatorPos = this.data.indexOf('\n', offset);
      var statusMessage = this.data.substring(offset, separatorPos);
      offset = separatorPos + 1; // read on in next line

      separatorPos = statusMessage.indexOf(' ');
      this.statusCode = parseInt(statusMessage.substring(0, separatorPos), 10);
      this.statusMessage = (0, _utils.decodeUriEncoded)(statusMessage.substring(separatorPos + 1));
      var lastPos = offset; // last position to read keys and values from
      var readingKey = true; // reading key or value currently?
      var currentKey = ''; // store the key while reading the value
      var parameters = {};
      while (offset < this.data.length - 1) {
        // minus one, to skip the trailing line break
        if (readingKey) {
          if (this.data.charAt(offset) === '=') {
            // equal sign between key and value
            currentKey = this.data.substring(lastPos, offset);
            lastPos = offset + 1; // behind equal sign
            readingKey = false;
          }
        } else if (this.data.charAt(offset) === ' ') {
          // space character separating the next key from the current value
          parameters[currentKey] = (0, _utils.decodeUriEncoded)(this.data.substring(lastPos, offset));
          lastPos = offset + 1; // behind space character
          readingKey = true;
        }
        offset++;
      }
      if (readingKey === false) {
        // only if a key was read at all (no parameters is also a valid block)
        parameters[currentKey] = (0, _utils.decodeUriEncoded)(this.data.substring(lastPos, offset));
      }
      this.params = parameters;
    }
  }
};

/*
 * static factory function, that returns a paylaod block or an array of payloadblocks
 * from an input string, reading from the given offset, the number of expected blocks
 * If one of the blocks is not complete, the isComplete attribute of the block is set to false
 * The actual data part is only stored as string and not already interpreted.
 * This interpretation is done in the parseInner function and should be called only
 * after all blocks are received, which is denoted by the last block having the isComplete attribute
 * set to true.
 * Those incomplete blocks should be buffered until a finishing block (isComplete == true) for that request id
 * is found and then they should be parsed all together.
 * @param readAttributes an object with attributes "offset" and "numberOfBlocks" which tell
 * from where to start reading and how many blocks are expected.
 * After the read process, the attributes get updates for the caller to know the further reading position.
 *
 */
StreamingPayloadBlock.parseOuter = function (inputString, readAttributes) {
  var payloadBlock = null;
  if (readAttributes.numberOfBlocks > 1) {
    payloadBlock = [];
  }
  for (var i = 0; i < readAttributes.numberOfBlocks; i++) {
    var requestId = (0, _utils.readInt)(inputString, readAttributes.offset);
    readAttributes.offset += 8;
    var blockSize = (0, _utils.readInt)(inputString, readAttributes.offset);
    readAttributes.offset += 8;
    var isComplete = true;
    if (blockSize < 1) {
      isComplete = false;
      blockSize = blockSize & 0x7FFFFFFF;
    }
    var blockEnd = readAttributes.offset + blockSize;
    if (readAttributes.numberOfBlocks > 1) {
      payloadBlock[i] = new StreamingPayloadBlock(requestId, null, null, null);
      payloadBlock[i].isComplete = isComplete;
      payloadBlock[i].data = inputString.substring(readAttributes.offset, blockEnd);
    } else {
      payloadBlock = new StreamingPayloadBlock(requestId, null, null, null);
      payloadBlock.isComplete = isComplete;
      payloadBlock.data = inputString.substring(readAttributes.offset, blockEnd);
    }
    readAttributes.offset = blockEnd;
  }
  return payloadBlock;
};
var _default = exports.default = StreamingPayloadBlock;

},{"streaming/tunnel/utils":75}],74:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _StreamingPayloadBlock = _interopRequireDefault(require("streaming/tunnel/StreamingPayloadBlock"));
var _StreamingCommunicationPacket = _interopRequireDefault(require("streaming/tunnel/StreamingCommunicationPacket"));
var _utils = require("streaming/tunnel/utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var YAHOO = window.YAHOO;
var CLIENT_ID = 'Ajax'; // client id that is sent with open session queries
var CLIENT_VERSION = '1.0'; // client version that is sent with open session queries

var REQUEST_ID_MIN = -1073741823; // the smallest allowed request id

var StreamingTunnelClient = {
  nextExpectedPacket: 1,
  // the packet number that is expected to be the next packet
  nextPacketToSent: 1,
  // the packet number to be given to the next packet
  highestAckPacket: -1,
  // the highest packet number of acknowledged packets (with none missing in between)
  nextRequestId: 1,
  // next request id
  requiredServices: 'Quotes',
  //
  systemListeners: [],
  // list of all listeners interested in system messages
  streamingListeners: {},
  // map with all streaming listeners, accessable through there request id
  requestIdToService: {},
  // map to lookup the service of a given request id
  streamingListenerParams: {},
  // map with scope parameters to be passed back to the streaming listeners accessable through the request id
  statusListeners: [],
  // list of all added status listeners
  statusListenerParameters: [],
  // list of parameter objects given with status listeners
  sessionInitial: true,
  // state with no valid streaming id. evaluated when reading response blocks
  commandQueue: [],
  // queue of commands to be sent to to the streaming server.
  incompleteBlocks: {},
  // a map with incomplete blocks, stored as attributes with their request id
  subscriptions: {},
  // all current subscriptions in a map of request ids, which contains a map of rics which contains a list of fids. This is necessary to resubscribe them, when tunnel crashes
  subscriptionServices: {},
  // all current services to the subscriptions in a map. Key is the request id, value the name of the service
  updates: {},
  // map with an array per streamingListener to collect updates that come in one row, to pass them to the streaming service all together.
  currentlyWorking: false,
  // a flag whether there is currently a connection handled, to avoid several parallel connections
  maxTransferKB: 320,
  // maximum number of KB per connection roughly (max packet size from client to server and max transfer size from server to client)

  /*
   * initialize the streaming tunnel client with the given
   * connector url and optional parameters as attributes in the
   * config object.
   * known config parameter attributes are:
   * - requiredServices: which services are required by the client (defaults to "Quote,Echo")
   * - loginData: a string with the login data expected by the server component. In the ngp
   *   project this is the ngp session id.
   * - loginSequence: an integer number that identifies the order of login per user,
   *   so that the server side can find out which is the oldest streaming instance.
   *   This helps to limit the active streaming sessions when users open multiple tabs in one browser.
   *   The sequence integer must strictly rise with every new instance of a StreaminTunnbelClient, but
   *   should only change on page reload, to distinguish active from passive pages.
   *
   * The init function does not yet do any connection. As the connections can not be kept open
   * with javascript, first all commands should be queued for execution, then
   * the connect function should be called.
   *
   */
  init: function init(connectorUrl, config) {
    var _this = this;
    if (config) {
      if (config.requiredServices != null) {
        this.requiredServices = config.requiredServices;
      }
      if (config.loginData != null) {
        this.loginData = config.loginData;
      }
      if (config.loginSequence != null) {
        this.loginSequence = config.loginSequence;
      }
    }
    this.connectorUrl = connectorUrl;
    YAHOO.util.Event.addListener(document.body, 'unload', function () {
      _this.cancel();
    }, null);

    // check whether we need to destroy an old connection?
    // in the applet client some queues get resetted also, waiting packets, incomplete packets...
  },

  /*
   * set new config attributes, especially login parameters when they change
   */
  setConfig: function setConfig(config) {
    if (config.loginData != null) {
      this.loginData = config.loginData;
    }
    if (config.loginSequence != null) {
      this.loginSequence = config.loginSequence;
    }
  },
  /*
   * connect to the given connector url.
   */
  connect: function connect() {
    if (!this.currentlyWorking) {
      // take care not to work several times before return
      this.currentlyWorking = true;
      this.handleBackChannel(this.sid);
    }
  },
  /*
   * inform the status listeners about a status and a message about why this status was reached.
   * Supported status codes so far are "initializing", "error" and "ready"
   * @param {} status the status the streaming tunnel reached right now
   * @param {} message a message explaining why the status was reached especially when status is "error"
   */
  informStatus: function informStatus(status, message) {
    var _this2 = this;
    this.statusListeners.forEach(function (statusListener, i) {
      var statusObject = {
        status: status,
        message: message
      };
      if (_this2.statusListenerParameters[i] != null) {
        statusObject.parameters = _this2.statusListenerParameters[i];
      }
      statusListener(statusObject);
    });
  },
  /*
   * handle a back channel connection to the streaming tunnel connector.
   * If sid is not given, a new session is opened.
   */
  handleBackChannel: function handleBackChannel(sid) {
    var params = {};
    var requestBlock = null;
    params.timeout = '500';
    params.maxTransferKB = this.maxTransferKB; // maximum number of KB per connection roughly
    if (sid == null) {
      this.informStatus('initializing', 'Opening new session to the streaming server.');
      this.nextExpectedPacket = 1;
      this.nextPacketToSent = 1;
      this.highestAckPacket = -1;
      this.nextRequestId = 1;
      params.client = CLIENT_ID;
      params.clientversion = CLIENT_VERSION;
      params.compressed = false; // disable compression, http request is compressed anyhow
      if (this.loginData != null) {
        params.logindata = this.loginData;
      }
      if (this.loginSequence != null) {
        params.loginsequence = this.loginSequence;
      }
      params.requiredServices = this.requiredServices;
      this.sessionInitial = true;
      requestBlock = new _StreamingPayloadBlock.default(0, 'system', 'OpenSession', params);
    } else {
      params.sid = sid;
      this.sessionInitial = false;
      params.compressed = false; // disable compression, http request is compressed anyhow
      params.nextPacket = "".concat(this.nextExpectedPacket);
      requestBlock = new _StreamingPayloadBlock.default(0, 'system', 'OpenBackChannel', params);
    }
    //    not to send packets already in first system packet:
    // const systemPacket = new StreamingCommunicationPacket(0, this.commandQueue.length < 1 || this.sessionInitial, requestBlock);
    // to send packets already in first system packet:
    var systemPacket = new _StreamingCommunicationPacket.default(0, this.commandQueue.length < 1, requestBlock);
    var postString = systemPacket.toPostString();
    while (this.commandQueue.length > 0) {
      // blocks to be sent in the command queue
      var packet = new _StreamingCommunicationPacket.default(this.nextPacketToSent++, true, this.commandQueue); // packet constructor will only send so many blocks, until the max packet size is reached.
      postString += packet.toPostString();
    }
    this.currentRequest = window.ajaxPost("".concat(this.connectorUrl).concat(this.connectorUrl.indexOf('?') === -1 ? '?' : '&', "f=").concat((0, _utils.getRandomAppender)()), postString).then(this.handleCallbackSuccess.bind(this)).catch(this.handleCallbackFailure.bind(this));
  },
  /*
   * handle an ajax callback answer from the server side
   * @param {} responseObject the response object as given by the ajax response
   */
  handleCallbackSuccess: function handleCallbackSuccess(response) {
    if (response) {
      var packet = null;
      try {
        packet = _StreamingCommunicationPacket.default.parse(response);
        if (YAHOO.lang.isArray(packet)) {
          for (var i = 0; i < packet.length; i++) {
            this.interpretePacket(packet[i]);
          }
        } else {
          this.interpretePacket(packet);
        }
      } catch (error) {
        // packet seems not to be readable
        this.handleFailure(true);
        this.currentlyWorking = false;
        return;
      }
      for (var listenerId in this.streamingListeners) {
        // iterate over all listeners
        var listener = this.streamingListeners[listenerId];
        if (listener != null && this.updates[listenerId] != null && this.updates[listenerId].length > 0) {
          // updates received
          var listenerParams = this.streamingListenerParams[listenerId];
          listener(this.updates[listenerId], listenerParams);
          this.updates[listenerId] = []; // empty the array
        }
      }

      for (var _listenerId in this.updates) {
        // see whether there are updates left with no listener for
        var unExpectedUpdates = this.updates[_listenerId];
        if (unExpectedUpdates != null && unExpectedUpdates.length > 0) {
          console.warn('Unexpected streamingTunnel streaming updates received, with no responsable listener available. Listener id:', _listenerId.substring(2));
        }
      }
    }
    this.currentlyWorking = false;
  },
  /*
   * if there is still a connection going on, abort it. This is necessary as IE does not
   * abort them automatically so they collect with every page visit and block the
   * browser when it gets more then 5 requests...
   */
  cancel: function cancel() {
    if (this.currentRequest) {
      this.currentRequest.reject('aborted');
    }
  },
  interpretePacket: function interpretePacket(packet) {
    if (packet == null || packet.packetNumber == null) {
      this.handleFailure(true);
      return; // this packet is obviously missing important information, ignor it so far.
    }

    if (packet.packetNumber === this.nextExpectedPacket || packet.packetNumber == 0) {
      // in case of session timeout or similar things, a new system communication is started with a zero packet number
      this.nextExpectedPacket++;
    } else {
      // the packet does not have the expected packet number? packets missing?
      // TODO: rerequest the expected packet! for now we just reopen the whole connection to not make code even more complex
      this.handleFailure(false); // keep it false for now, as we do not exactly know what happened
    }

    if (YAHOO.lang.isArray(packet.payloadBlock)) {
      for (var i = 0; i < packet.payloadBlock.length; i++) {
        this.handleResponseBlock(packet.payloadBlock[i]);
      }
    } else if (packet.payloadBlock != null) {
      // there are also packets without blocks at all
      this.handleResponseBlock(packet.payloadBlock);
    }
  },
  handleResponseBlock: function handleResponseBlock(block) {
    if (block.requestId === 0 && block.isComplete) {
      // system message
      block.parseInner();
      if (this.wasError != null && this.wasError) {
        // there was an error previously, check for ok message
        if (block.statusCode === 0) {
          this.wasError = false;
          this.informStatus('ready', block.statusMessage);
        }
      }
      if (block.params.id != null) {
        this.sid = block.params.id;
        this.sessionInitial = false;
        this.informStatus('ready', "New Streaming session received: ".concat(this.sid));
        // todo: inform system listener
      } else if (block.params.ack != null) {
        this.highestAckPacket = parseInt(block.params.ack, 10);
      } else if (block.statusCode != null && block.statusCode !== 0) {
        // something went wrong
        // other system package
        if (block.statusCode === 82) {
          // streaming session was made invalid, e.g. when tab/window was invisible for longer than 3 minutes, or too much open windows streaming
          this.handleFailure(false); // try a new login first
        } else if (block.statusCode === 81) {
          // login was denied, e.g. because to many parallel windows streaming. Do not try again to avoid session ping pong
          if (YAHOO.fcom.Streaming.streamingService && YAHOO.fcom.Streaming.streamingService.isAvailable()) {
            YAHOO.fcom.Streaming.paused = true;
          }
          this.informStatus('exceeded', block.statusMessage);
        } else {
          this.informStatus('error', "Server sent error message: \"".concat(block.statusMessage, "\""));
          this.handleFailure(true);
        }
      }
    } else {
      // no system package
      var incompleteBlock = this.incompleteBlocks[block.requestId]; // already an incomplete part?
      if (incompleteBlock != null) {
        // there is a first part of that block
        incompleteBlock.appendToIncomplete(block); // append the new block to the old
        if (block.isComplete === true) {
          // block is complete now
          this.incompleteBlocks[block.requestId] = null; // remove from incomplete list
          block = incompleteBlock; // change reference to the first block of that request id
        } else {
          // block still not complete, just quit and wait for the rest
          return;
        }
      } else if (block.isComplete === false) {
        // no incomplete with that request id, but request no complete
        this.incompleteBlocks[block.requestId] = block; // store the incomplete block and stop
        return;
      }

      // this code is only reached when the block is complete and should be interpreted
      block.parseInner(); // now this block can be parsed
      if (block.requestId < 0) {
        // streaming service
        if (block.statusMessage === 'S') {
          // streaming update
          if (this.updates["id".concat(block.requestId)] == null) {
            this.updates["id".concat(block.requestId)] = [];
          }
          this.updates["id".concat(block.requestId)].push(block.params);
        } else if (block.statusMessage.indexOf('OK') === 0) {
          // ack answer, which was already worked on by the expected packet number check
        } else {
          // unexpected packet?
          console.warn('Unexpected streamingTunnel block received with status message:', block.statusMessage);
        }
      } else {
        console.warn('Unexpected streamingTunnel block received with positive request id:', block.requestId);
      }
    }
  },
  handleCallbackFailure: function handleCallbackFailure(error) {
    this.informStatus('error', "HTTP communication to server failed, more details should be available in server logs:\"".concat(error, "\""));
    this.handleFailure(false); // network communication issue, not unexpected. Stuff like that happens.
  },

  /**
   *
   * @param unexpected whether this failure was unexpected and should be logged
   */
  handleFailure: function handleFailure(unexpected) {
    this.sid = null;
    this.wasError = true;
    this.currentlyWorking = false;
    if (unexpected) {
      // only log unexpected failures where it is not 100% understood what happened.
      console.warn('StreamingTunnel reached unexpected state and had to recover from scratch.');
    }
    // TODO: shouldn't the status listeners be informed here?
    this.resubscribeEverything();
  },
  resubscribeEverything: function resubscribeEverything() {
    for (var listenerId in this.streamingListeners) {
      var listener = this.streamingListeners[listenerId];
      if (listener != null) {
        var service = this.requestIdToService[listenerId];
        this.queueForExecution(listenerId.substring(2), service, 'OpenStream', null);
      }
    }
    if (this.subscriptionServices != null) {
      for (var requestId in this.subscriptionServices) {
        if (requestId != null) {
          var _service = this.subscriptionServices[requestId];
          if (_service === 'Quotes') {
            var symbolMap = this.subscriptions[requestId];
            if (symbolMap != null) {
              for (var symbol in symbolMap) {
                var fields = symbolMap[symbol];
                if (fields != null && fields.length > 0) {
                  this.subscribeQuotes(requestId, symbol, fields, true);
                }
              }
            }
          } else {
            //TODO: resubscribe other services
          }
        }
      }
    }
  },
  /*
   * add a status listener that gets called whenever the status of the
   * streaming tunnel changes. Status listeners must be callback functions that take a single argument
   * which is an attribute object with at least the attributes "status", optionally "message" with
   * detailed information to the status and when
   * the parameters object was given to the addStatusListener function, these parameters will
   * be given back as attribute "parameters".
   */
  addStatusListener: function addStatusListener(statusListener, parameters) {
    this.statusListeners.push(statusListener);
    this.statusListenerParameters[this.statusListenerParameters.length] = parameters;
  },
  /*
   * add a streaming listener that gets called each time a streaming update
   * is received. The listener callback should be a function that takes two
   * parameters. The first will be the received updates and the second will be
   * whatever is passed to this function as listenerParams. Thus the callback function
   * can keep references to other objects and classes.
   * Updates are attributes in an object, with the streaming fids as names and
   * the values being the streaming updates, URL encoded. So the result should always be
   * URL decoded before use! All updates come together in one array.
   * @param service the service that this streaming listener want to use
   * @param listenerCallback a function object that expects two parameters and will
   *        be called whenever a streaming update for that service is received
   * @param listenerParams an object or array or null, that will be passed back to the
   *        callback function as it was given.
   * @return a unique request id for that listener whith which it can subscribe for streaming updates
   */
  addStreamingListener: function addStreamingListener(service, listenerCallback, listenerParams) {
    var requestId = this.nextRequestId++;
    requestId *= -1;
    if (requestId <= REQUEST_ID_MIN) {
      // wrap request ids, when they ran too far
      requestId = -1;
      this.nextRequestId = 1;
    }
    this.streamingListeners["id".concat(requestId)] = listenerCallback;
    this.streamingListenerParams["id".concat(requestId)] = listenerParams;
    this.requestIdToService["id".concat(requestId)] = service;
    this.queueForExecution(requestId, service, 'OpenStream', null);
    return requestId;
  },
  /*
   * Subscribe for the Quotes service with a given list of symbols and fields
   * @param requestId the unique request id that the streaming listener got from the registering method
   * @param symbols array of symbols to subscribe or a single string with one symbol
   * @param fields array of fields to be subscribed or a single string with one field
   * @param isResubscription whether this is a resubscription after tunnel crash or not. Callers from outside should not set this parameter,
   *           it's only meant for the streaming tunnel itself to mark a resubscription.
   *
   */
  subscribeQuotes: function subscribeQuotes(requestId, symbols, fields, isResubscription) {
    if (isResubscription !== true) {
      isResubscription = false;
    }
    symbols = [].concat(symbols).filter(function (f) {
      return f.indexOf(' ') === -1;
    });
    fields = [].concat(fields);
    var subscribedRics = this.subscriptions[requestId];
    if (subscribedRics == null) {
      this.subscriptions[requestId] = {};
      subscribedRics = this.subscriptions[requestId];
      this.subscriptionServices[requestId] = 'Quotes';
    }
    var symbolsToUpdate = isResubscription ? symbols : symbols.filter(function (symbol) {
      var currentFields = subscribedRics[symbol] || [];
      var missingFields = fields.filter(function (f) {
        return currentFields.indexOf(f) === -1;
      });
      if (missingFields.length) {
        subscribedRics[symbol] = currentFields.concat(missingFields);
        return true;
      }
      return false;
    });
    if (symbolsToUpdate.length) {
      var parameters = {};
      parameters.items = "".concat(symbolsToUpdate.join(','), ":").concat(fields.join(','));
      parameters.sendImages = 'true';
      this.subscribe('Quotes', requestId, parameters);
    }
  },
  /*
   * Unsubscribe for the Quotes service with a given list of symbols and fields
   * @param requestId the unique request id that the streaming listener got from the registering method
   * @param symbols array of symbols to unsubscribe
   * @param fields array of fields to unsubscribe
   */
  unsubscribeQuotes: function unsubscribeQuotes(requestId, symbols, fields) {
    var subscribedRics = this.subscriptions[requestId];
    if (subscribedRics == null) {
      // does not seem there is anything subscribed, just skip
      return;
    }
    symbols = [].concat(symbols).filter(function (f) {
      return f.indexOf(' ') === -1;
    });
    fields = [].concat(fields);
    var unsubscribeSymbols = symbols.filter(function (symbol) {
      var fieldsSoFar = subscribedRics[symbol];
      if (!fieldsSoFar) {
        return false;
      }
      var remainingFields = fieldsSoFar.filter(function (f) {
        return fields.indexOf(f) === -1;
      });
      if (remainingFields.length) {
        subscribedRics[symbol] = remainingFields;
      } else {
        delete subscribedRics[symbol];
      }
      return true;
    });
    var parameters = {};
    parameters.items = "".concat(unsubscribeSymbols.join(','), ":").concat(fields.join(','));
    this.queueForExecution(requestId, 'Quotes', 'Unsubscribe', parameters);
  },
  /*
   * general subscribe function to a given service with a choosen request id and a parameters string
   * @param {} service the service to subscribe for
   * @param {} requestId the unique request id of the streaming listener subscribing for the given updates
   * @param {} parameters parameter string with the subscription details
   */
  subscribe: function subscribe(service, requestId, parameters) {
    // TODO: store subscriptions to be able to resubscribe in case of failover
    // this.subscriptionServices[requestId] = service;
    // this.subscriptions[requestId] = parameters;
    this.queueForExecution(requestId, service, 'Subscribe', parameters);
  },
  /*
   * queue a command for execution. This command is sent with the next call of
   * handleBackChannel.
   */
  queueForExecution: function queueForExecution(requestId, service, command, parameters) {
    var block = new _StreamingPayloadBlock.default(requestId, service, command, parameters);
    this.commandQueue.push(block);

    // todo: remember the command listener and call it's callback function when answer arrives.
  }
};
var _default = exports.default = StreamingTunnelClient;

},{"streaming/tunnel/StreamingCommunicationPacket":72,"streaming/tunnel/StreamingPayloadBlock":73,"streaming/tunnel/utils":75}],75:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.writeLong = exports.writeInt = exports.readLong = exports.readInt = exports.getRandomAppender = exports.decodeUriEncoded = void 0;
/*
 * lookup function that returns the numerical integer value
 * between 0 and 15 of the character code at the given
 * position in the given string. If doInvert is given boolean true,
 * the inverted value is returned (15 - value)
 */
var valueFromHexCharacter = function valueFromHexCharacter(inputString, pos, doInvert) {
  var character = inputString.charCodeAt(pos);
  var value;
  if (character < 58) {
    // numbers from 0 to 9
    value = character - 48;
  } else if (character < 71) {
    // capital letters
    value = character - 55;
  } else {
    value = character - 87; // lowercase letters
  }

  if (doInvert === true) {
    return 15 - value;
  }
  return value;
};

/*
 * lookup function that returns the char code for building
 * hexadecimal strings from the given integer value between 0 and 15.
 * The char codes are the ones for the lower case a to f letters.
 * If doInvert is given boolean true, the inverted value is used (15 - value)
 */
var hexaCharacterFromValue = function hexaCharacterFromValue(value, doInvert) {
  if (doInvert === true) {
    value = 15 - value;
  }
  if (value < 10) {
    // numbers from 0 to 9
    return String.fromCharCode(value + 48);
  } else {
    return String.fromCharCode(value + 87); // lowercase letters
  }
};

/*
 * returns a string with length 8 containing the hexadecimal representation
 * of the given integer number in big endian format
 */
var writeInt = exports.writeInt = function writeInt(intNumber) {
  var returnString = '';
  for (var i = 7; i > 0; i--) {
    returnString += hexaCharacterFromValue(intNumber >> i * 4 & 0xf);
  }
  returnString += hexaCharacterFromValue(intNumber & 0xf);
  return returnString;
};

/*
 * returns a string with length 16 containing the hexadecimal representation
 * of the given long number, filled with zeros to length 16.
 */
var writeLong = exports.writeLong = function writeLong(longNumber) {
  var isNeg = longNumber < 0;
  if (isNeg) {
    longNumber *= -1;
    longNumber -= 1;
  }
  var returnString = '';
  for (var i = 0; i < 16; i++) {
    returnString = hexaCharacterFromValue(longNumber % 16, isNeg) + returnString;
    longNumber = Math.floor(longNumber / 16 + 0.01);
  }
  return returnString;
};

/*
 * read a 16 character long value in hexadecimal big endian encoding from the
 * given string at the given postion
 */
var readLong = exports.readLong = function readLong(inputString, startFrom) {
  var isNeg = inputString.charCodeAt(startFrom) > 55; // 55 is the char code of the 7. 8 or a-f have greater char codes
  var numberValue = 0;
  for (var i = 0; i < 16; i++) {
    numberValue *= 16;
    numberValue += valueFromHexCharacter(inputString, startFrom++, isNeg);
  }
  if (isNeg) {
    numberValue += 1;
    numberValue *= -1;
  }
  return numberValue;
};

/*
 * read an 8 character long value in hexadecimal big endian encoding from the
 * given string at the given postion
 */
var readInt = exports.readInt = function readInt(inputString, startFrom) {
  var isNeg = inputString.charCodeAt(startFrom) > 55; // 55 is the char code of the 7. 8 or a-f have greater char codes
  var numberValue = 0;
  for (var i = 0; i < 8; i++) {
    numberValue *= 16;
    numberValue += valueFromHexCharacter(inputString, startFrom++, isNeg);
  }
  if (isNeg) {
    numberValue += 1;
    numberValue *= -1;
  }
  return numberValue;
};
var decodeUriEncoded = exports.decodeUriEncoded = function decodeUriEncoded(inputString) {
  if (inputString == null || inputString.length < 1) {
    return inputString;
  }
  var returnString = '';
  for (var i = 0; i < inputString.length; i++) {
    var character = inputString.charCodeAt(i);
    if (character === 43) {
      returnString += ' ';
    } else if (character === 37 && inputString.length > i + 2) {
      // escape sequence with %..
      var asciiValue = parseInt(inputString.substring(i + 1, i + 3), 16);
      if (asciiValue < 9) {
        returnString += ' '; // make an empty space of all ascii characters below 9
        i += 2;
      } else {
        // higher ascii => unescape sequence
        var escapeLength = 3;
        if (asciiValue >= 0xF0) {
          // four byte UTF-8
          escapeLength = 12;
        } else if (asciiValue >= 0xE0) {
          // four byte UTF-8
          escapeLength = 9;
        } else if (asciiValue >= 0xC0) {
          // four byte UTF-8
          escapeLength = 6;
        }
        if (inputString.length >= i + escapeLength) {
          returnString += decodeURIComponent(inputString.substring(i, i + escapeLength));
          i += escapeLength - 1;
        } else {
          // obviously wrong, just append and don't care...
          returnString += inputString.substring(i, i + 3);
          i += 2;
        }
      }
    } else {
      returnString += inputString.charAt(i);
    }
  }
  return returnString;
};

/*
 * returns a random number in a number system using all 26 alphabetic
 * character instead of only 6 as the hexadecimal system does.
 */
var getRandomAppender = exports.getRandomAppender = function getRandomAppender() {
  return parseInt(0xffffff * Math.random(), 10).toString(36);
};

},{}],76:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var KEYCODE = {
  ENTER: 13,
  SPACE: 32,
  ESCAPE: 27,
  ARROW_LEFT: 37,
  ARROW_UP: 38,
  ARROW_RIGHT: 39,
  ARROW_DOWN: 40,
  TAB: 9,
  KeyA: 65,
  KeyD: 68,
  DELETE: 46
};
var _default = exports.default = KEYCODE;

},{}],77:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
 * This functions takes a function fn as input and returns a function that when executed
 * will only run every millis milliseconds
 */
var runFunctionDebounced = function runFunctionDebounced(millis, fn) {
  var timeout = null;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (timeout) {
      window.clearTimeout(timeout);
    }
    timeout = window.setTimeout(function () {
      timeout = null;
      fn.apply(void 0, args);
    }, millis);
  };
};
var _default = exports.default = runFunctionDebounced;

},{}],78:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * @name            : GUID
 * @description     : Generate new GUID and GUID related methods
 */
var GUID = exports.default = /*#__PURE__*/function () {
  function GUID() {
    _classCallCheck(this, GUID);
  }
  _createClass(GUID, null, [{
    key: "generate",
    value:
    /**
     * @method generate
     * @description Static method to generate new GUID
     * @public
     * @static
     */
    function generate() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0;
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
      });
    }
  }]);
  return GUID;
}();

},{}],79:[function(require,module,exports){
module.exports = require('./lib/axios');
},{"./lib/axios":81}],80:[function(require,module,exports){
'use strict';

var utils = require('./../utils');
var settle = require('./../core/settle');
var cookies = require('./../helpers/cookies');
var buildURL = require('./../helpers/buildURL');
var buildFullPath = require('../core/buildFullPath');
var parseHeaders = require('./../helpers/parseHeaders');
var isURLSameOrigin = require('./../helpers/isURLSameOrigin');
var createError = require('../core/createError');

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

},{"../core/buildFullPath":87,"../core/createError":88,"./../core/settle":92,"./../helpers/buildURL":96,"./../helpers/cookies":98,"./../helpers/isURLSameOrigin":101,"./../helpers/parseHeaders":103,"./../utils":106}],81:[function(require,module,exports){
'use strict';

var utils = require('./utils');
var bind = require('./helpers/bind');
var Axios = require('./core/Axios');
var mergeConfig = require('./core/mergeConfig');
var defaults = require('./defaults');

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = require('./cancel/Cancel');
axios.CancelToken = require('./cancel/CancelToken');
axios.isCancel = require('./cancel/isCancel');

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = require('./helpers/spread');

// Expose isAxiosError
axios.isAxiosError = require('./helpers/isAxiosError');

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;

},{"./cancel/Cancel":82,"./cancel/CancelToken":83,"./cancel/isCancel":84,"./core/Axios":85,"./core/mergeConfig":91,"./defaults":94,"./helpers/bind":95,"./helpers/isAxiosError":100,"./helpers/spread":104,"./utils":106}],82:[function(require,module,exports){
'use strict';

/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;

},{}],83:[function(require,module,exports){
'use strict';

var Cancel = require('./Cancel');

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;

},{"./Cancel":82}],84:[function(require,module,exports){
'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

},{}],85:[function(require,module,exports){
'use strict';

var utils = require('./../utils');
var buildURL = require('../helpers/buildURL');
var InterceptorManager = require('./InterceptorManager');
var dispatchRequest = require('./dispatchRequest');
var mergeConfig = require('./mergeConfig');
var validator = require('../helpers/validator');

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      forcedJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      clarifyTimeoutError: validators.transitional(validators.boolean, '1.0.0')
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;

},{"../helpers/buildURL":96,"../helpers/validator":105,"./../utils":106,"./InterceptorManager":86,"./dispatchRequest":89,"./mergeConfig":91}],86:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;

},{"./../utils":106}],87:[function(require,module,exports){
'use strict';

var isAbsoluteURL = require('../helpers/isAbsoluteURL');
var combineURLs = require('../helpers/combineURLs');

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};

},{"../helpers/combineURLs":97,"../helpers/isAbsoluteURL":99}],88:[function(require,module,exports){
'use strict';

var enhanceError = require('./enhanceError');

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};

},{"./enhanceError":90}],89:[function(require,module,exports){
'use strict';

var utils = require('./../utils');
var transformData = require('./transformData');
var isCancel = require('../cancel/isCancel');
var defaults = require('../defaults');

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};

},{"../cancel/isCancel":84,"../defaults":94,"./../utils":106,"./transformData":93}],90:[function(require,module,exports){
'use strict';

/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};

},{}],91:[function(require,module,exports){
'use strict';

var utils = require('../utils');

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, mergeDeepProperties);

  return config;
};

},{"../utils":106}],92:[function(require,module,exports){
'use strict';

var createError = require('./createError');

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};

},{"./createError":88}],93:[function(require,module,exports){
'use strict';

var utils = require('./../utils');
var defaults = require('./../defaults');

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};

},{"./../defaults":94,"./../utils":106}],94:[function(require,module,exports){
(function (process){(function (){
'use strict';

var utils = require('./utils');
var normalizeHeaderName = require('./helpers/normalizeHeaderName');
var enhanceError = require('./core/enhanceError');

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = require('./adapters/xhr');
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = require('./adapters/http');
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

}).call(this)}).call(this,require('_process'))
},{"./adapters/http":80,"./adapters/xhr":80,"./core/enhanceError":90,"./helpers/normalizeHeaderName":102,"./utils":106,"_process":108}],95:[function(require,module,exports){
'use strict';

module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

},{}],96:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

},{"./../utils":106}],97:[function(require,module,exports){
'use strict';

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};

},{}],98:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);

},{"./../utils":106}],99:[function(require,module,exports){
'use strict';

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

},{}],100:[function(require,module,exports){
'use strict';

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};

},{}],101:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);

},{"./../utils":106}],102:[function(require,module,exports){
'use strict';

var utils = require('../utils');

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

},{"../utils":106}],103:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};

},{"./../utils":106}],104:[function(require,module,exports){
'use strict';

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

},{}],105:[function(require,module,exports){
'use strict';

var pkg = require('./../../package.json');

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};
var currentVerArr = pkg.version.split('.');

/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */
function isOlderVersion(version, thanVersion) {
  var pkgVersionArr = thanVersion ? thanVersion.split('.') : currentVerArr;
  var destVer = version.split('.');
  for (var i = 0; i < 3; i++) {
    if (pkgVersionArr[i] > destVer[i]) {
      return true;
    } else if (pkgVersionArr[i] < destVer[i]) {
      return false;
    }
  }
  return false;
}

/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  var isDeprecated = version && isOlderVersion(version);

  function formatMessage(opt, desc) {
    return '[Axios v' + pkg.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed in ' + version));
    }

    if (isDeprecated && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

module.exports = {
  isOlderVersion: isOlderVersion,
  assertOptions: assertOptions,
  validators: validators
};

},{"./../../package.json":107}],106:[function(require,module,exports){
'use strict';

var bind = require('./helpers/bind');

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};

},{"./helpers/bind":95}],107:[function(require,module,exports){
module.exports={
  "name": "axios",
  "version": "0.21.4",
  "description": "Promise based HTTP client for the browser and node.js",
  "main": "index.js",
  "scripts": {
    "test": "grunt test",
    "start": "node ./sandbox/server.js",
    "build": "NODE_ENV=production grunt build",
    "preversion": "npm test",
    "version": "npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json",
    "postversion": "git push && git push --tags",
    "examples": "node ./examples/server.js",
    "coveralls": "cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js",
    "fix": "eslint --fix lib/**/*.js"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/axios/axios.git"
  },
  "keywords": [
    "xhr",
    "http",
    "ajax",
    "promise",
    "node"
  ],
  "author": "Matt Zabriskie",
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/axios/axios/issues"
  },
  "homepage": "https://axios-http.com",
  "devDependencies": {
    "coveralls": "^3.0.0",
    "es6-promise": "^4.2.4",
    "grunt": "^1.3.0",
    "grunt-banner": "^0.6.0",
    "grunt-cli": "^1.2.0",
    "grunt-contrib-clean": "^1.1.0",
    "grunt-contrib-watch": "^1.0.0",
    "grunt-eslint": "^23.0.0",
    "grunt-karma": "^4.0.0",
    "grunt-mocha-test": "^0.13.3",
    "grunt-ts": "^6.0.0-beta.19",
    "grunt-webpack": "^4.0.2",
    "istanbul-instrumenter-loader": "^1.0.0",
    "jasmine-core": "^2.4.1",
    "karma": "^6.3.2",
    "karma-chrome-launcher": "^3.1.0",
    "karma-firefox-launcher": "^2.1.0",
    "karma-jasmine": "^1.1.1",
    "karma-jasmine-ajax": "^0.1.13",
    "karma-safari-launcher": "^1.0.0",
    "karma-sauce-launcher": "^4.3.6",
    "karma-sinon": "^1.0.5",
    "karma-sourcemap-loader": "^0.3.8",
    "karma-webpack": "^4.0.2",
    "load-grunt-tasks": "^3.5.2",
    "minimist": "^1.2.0",
    "mocha": "^8.2.1",
    "sinon": "^4.5.0",
    "terser-webpack-plugin": "^4.2.3",
    "typescript": "^4.0.5",
    "url-search-params": "^0.10.0",
    "webpack": "^4.44.2",
    "webpack-dev-server": "^3.11.0"
  },
  "browser": {
    "./lib/adapters/http.js": "./lib/adapters/xhr.js"
  },
  "jsdelivr": "dist/axios.min.js",
  "unpkg": "dist/axios.min.js",
  "typings": "./index.d.ts",
  "dependencies": {
    "follow-redirects": "^1.14.0"
  },
  "bundlesize": [
    {
      "path": "./dist/axios.min.js",
      "threshold": "5kB"
    }
  ]
}

},{}],108:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}]},{},[54]);
;
!function(t){"object"==typeof module&&module.exports?module.exports=t["default"]=t:"function"==typeof define&&define.amd?define("highcharts/modules/exporting",["highcharts"],function(e){return t(e),t.Highcharts=e,t}):t("undefined"!=typeof Highcharts?Highcharts:undefined)}(function(e){"use strict";e=e?e._modules:{};function t(e,t,n,o){e.hasOwnProperty(t)||(e[t]=o.apply(null,n),"function"==typeof CustomEvent&&window.dispatchEvent(new CustomEvent("HighchartsModuleLoaded",{detail:{path:t,module:e[t]}})))}t(e,"Core/Chart/ChartNavigationComposition.js",[],function(){var e;{var t=e=e||{};t.compose=function(e){return e.navigation||(e.navigation=new n(e)),e};class n{constructor(e){this.updates=[],this.chart=e}addUpdate(e){this.chart.navigation.updates.push(e)}update(t,n){this.updates.forEach(e=>{e.call(this.chart,t,n)})}}t.Additions=n}return e}),t(e,"Extensions/Exporting/ExportingDefaults.js",[e["Core/Globals.js"]],function(e){e=e.isTouchDevice;return{exporting:{allowTableSorting:!0,type:"image/png",url:"https://export.highcharts.com/",pdfFont:{normal:void 0,bold:void 0,bolditalic:void 0,italic:void 0},printMaxWidth:780,scale:2,buttons:{contextButton:{className:"highcharts-contextbutton",menuClassName:"highcharts-contextmenu",symbol:"menu",titleKey:"contextButtonTitle",menuItems:["viewFullscreen","printChart","separator","downloadPNG","downloadJPEG","downloadPDF","downloadSVG"]}},menuItemDefinitions:{viewFullscreen:{textKey:"viewFullscreen",onclick:function(){this.fullscreen&&this.fullscreen.toggle()}},printChart:{textKey:"printChart",onclick:function(){this.print()}},separator:{separator:!0},downloadPNG:{textKey:"downloadPNG",onclick:function(){this.exportChart()}},downloadJPEG:{textKey:"downloadJPEG",onclick:function(){this.exportChart({type:"image/jpeg"})}},downloadPDF:{textKey:"downloadPDF",onclick:function(){this.exportChart({type:"application/pdf"})}},downloadSVG:{textKey:"downloadSVG",onclick:function(){this.exportChart({type:"image/svg+xml"})}}}},lang:{viewFullscreen:"View in full screen",exitFullscreen:"Exit from full screen",printChart:"Print chart",downloadPNG:"Download PNG image",downloadJPEG:"Download JPEG image",downloadPDF:"Download PDF document",downloadSVG:"Download SVG vector image",contextButtonTitle:"Chart context menu"},navigation:{buttonOptions:{symbolSize:14,symbolX:14.5,symbolY:13.5,align:"right",buttonSpacing:3,height:28,verticalAlign:"top",width:28,symbolFill:"#666666",symbolStroke:"#666666",symbolStrokeWidth:3,theme:{padding:5}},menuStyle:{border:"none",borderRadius:"3px",background:"#ffffff",padding:"0.5em"},menuItemStyle:{background:"none",borderRadius:"3px",color:"#333333",padding:"0.5em",fontSize:e?"0.9em":"0.8em",transition:"background 250ms, color 250ms"},menuItemHoverStyle:{background:"#f2f2f2"}}}}),t(e,"Extensions/Exporting/ExportingSymbols.js",[],function(){var e;{var t=e=e||{};const o=[];function n(e,t,n,o){return[["M",e,t+2.5],["L",e+n,t+2.5],["M",e,t+o/2+.5],["L",e+n,t+o/2+.5],["M",e,t+o-1.5],["L",e+n,t+o-1.5]]}e.compose=function(e){-1===o.indexOf(e)&&(o.push(e),(e=e.prototype.symbols).menu=n,e.menuball=function(e,t,n,o){o=o/3-2;let i=[];return i=i.concat(this.circle(n-o,t,o,o),this.circle(n-o,t+o+4,o,o),this.circle(n-o,t+2*(4+o),o,o))}.bind(e))}}return e}),t(e,"Extensions/Exporting/Fullscreen.js",[e["Core/Renderer/HTML/AST.js"],e["Core/Globals.js"],e["Core/Utilities.js"]],function(i,e,t){const n=e["composed"],{addEvent:s,fireEvent:l,pushUnique:o}=t;function r(){this.fullscreen=new a(this)}class a{static compose(e){o(n,this.compose)&&s(e,"beforeRender",r)}constructor(e){this.chart=e,this.isOpen=!1;e=e.renderTo;this.browserProps||("function"==typeof e.requestFullscreen?this.browserProps={fullscreenChange:"fullscreenchange",requestFullscreen:"requestFullscreen",exitFullscreen:"exitFullscreen"}:e.mozRequestFullScreen?this.browserProps={fullscreenChange:"mozfullscreenchange",requestFullscreen:"mozRequestFullScreen",exitFullscreen:"mozCancelFullScreen"}:e.webkitRequestFullScreen?this.browserProps={fullscreenChange:"webkitfullscreenchange",requestFullscreen:"webkitRequestFullScreen",exitFullscreen:"webkitExitFullscreen"}:e.msRequestFullscreen&&(this.browserProps={fullscreenChange:"MSFullscreenChange",requestFullscreen:"msRequestFullscreen",exitFullscreen:"msExitFullscreen"}))}close(){const e=this,t=e.chart,n=t.options.chart;l(t,"fullscreenClose",null,function(){e.isOpen&&e.browserProps&&t.container.ownerDocument instanceof Document&&t.container.ownerDocument[e.browserProps.exitFullscreen](),e.unbindFullscreenEvent&&(e.unbindFullscreenEvent=e.unbindFullscreenEvent()),t.setSize(e.origWidth,e.origHeight,!1),e.origWidth=void 0,e.origHeight=void 0,n.width=e.origWidthOption,n.height=e.origHeightOption,e.origWidthOption=void 0,e.origHeightOption=void 0,e.isOpen=!1,e.setButtonText()})}open(){const o=this,i=o.chart,r=i.options.chart;l(i,"fullscreenOpen",null,function(){if(r&&(o.origWidthOption=r.width,o.origHeightOption=r.height),o.origWidth=i.chartWidth,o.origHeight=i.chartHeight,o.browserProps){const t=s(i.container.ownerDocument,o.browserProps.fullscreenChange,function(){o.isOpen?(o.isOpen=!1,o.close()):(i.setSize(null,null,!1),o.isOpen=!0,o.setButtonText())}),n=s(i,"destroy",t);o.unbindFullscreenEvent=()=>{t(),n()};var e=i.renderTo[o.browserProps.requestFullscreen]();e&&e["catch"](function(){alert("Full screen is not supported inside a frame.")})}})}setButtonText(){var e=this.chart,t=e.exportDivElements,n=e.options.exporting,o=n&&n.buttons&&n.buttons.contextButton.menuItems,e=e.options.lang;n&&n.menuItemDefinitions&&e&&e.exitFullscreen&&e.viewFullscreen&&o&&t&&(o=t[o.indexOf("viewFullscreen")])&&i.setElementHTML(o,this.isOpen?e.exitFullscreen:n.menuItemDefinitions.viewFullscreen.text||e.viewFullscreen)}toggle(){this.isOpen?this.close():this.open()}}return a}),t(e,"Core/HttpUtilities.js",[e["Core/Globals.js"],e["Core/Utilities.js"]],function(e,t){const s=e["win"],{discardElement:l,objectEach:a}=t;const n={ajax:function(n){const e={json:"application/json",xml:"application/xml",text:"text/plain",octet:"application/octet-stream"},o=new XMLHttpRequest;function i(e,t){n.error&&n.error(e,t)}if(!n.url)return!1;o.open((n.type||"get").toUpperCase(),n.url,!0),n.headers&&n.headers["Content-Type"]||o.setRequestHeader("Content-Type",e[n.dataType||"json"]||e.text),a(n.headers,function(e,t){o.setRequestHeader(t,e)}),n.responseType&&(o.responseType=n.responseType),o.onreadystatechange=function(){let e;if(4===o.readyState){if(200===o.status){if("blob"!==n.responseType&&(e=o.responseText,"json"===n.dataType))try{e=JSON.parse(e)}catch(t){if(t instanceof Error)return i(o,t)}return n.success&&n.success(e,o)}i(o,o.responseText)}},n.data&&"string"!=typeof n.data&&(n.data=JSON.stringify(n.data)),o.send(n.data)},getJSON:function(e,t){n.ajax({url:e,success:t,dataType:"json",headers:{"Content-Type":"text/plain"}})},post:function(e,t,n){const o=new s.FormData,{filename:i,type:r}=(a(t,function(e,t){o.append(t,e)}),o.append("b64","true"),t);return s.fetch(e,{method:"POST",body:o,...n}).then(e=>{e.ok&&e.text().then(e=>{var t=document.createElement("a");t.href=`data:${r};base64,`+e,t.download=i,t.click(),l(t)})})}};return n}),t(e,"Extensions/Exporting/Exporting.js",[e["Core/Renderer/HTML/AST.js"],e["Core/Chart/Chart.js"],e["Core/Chart/ChartNavigationComposition.js"],e["Core/Defaults.js"],e["Extensions/Exporting/ExportingDefaults.js"],e["Extensions/Exporting/ExportingSymbols.js"],e["Extensions/Exporting/Fullscreen.js"],e["Core/Globals.js"],e["Core/HttpUtilities.js"],e["Core/Utilities.js"]],function(f,i,e,t,n,o,r,b,s,m){const l=t["defaultOptions"],{composed:a,doc:w,SVG_NS:c,win:E}=b,{addEvent:x,css:C,createElement:y,discardElement:p,extend:v,find:u,fireEvent:S,isObject:T,merge:d,objectEach:h,pick:g,pushUnique:F,removeEvent:O,uniqueKey:k}=m;var M;{var P=M=M||{};const H=[/-/,/^(clipPath|cssText|d|height|width)$/,/^font$/,/[lL]ogical(Width|Height)$/,/^parentRule$/,/^(cssRules|ownerRules)$/,/perspective/,/TapHighlightColor/,/^transition/,/^length$/,/^[0-9]+$/],G=["fill","stroke","strokeLinecap","strokeLinejoin","strokeWidth","textAnchor","x","y"],W=(P.inlineAllowlist=[],["clipPath","defs","desc"]);let i;function N(e){const t=this,n=t.renderer,o=d(t.options.navigation.buttonOptions,e),i=o.onclick,r=o.menuItems,s=o.symbolSize||12;let l;if(t.btnCount||(t.btnCount=0),t.exportDivElements||(t.exportDivElements=[],t.exportSVGElements=[]),!1===o.enabled||!o.theme)return;var a=o.theme;let c;t.styledMode||(a.fill=g(a.fill,"#ffffff"),a.stroke=g(a.stroke,"none")),i?c=function(e){e&&e.stopPropagation(),i.call(t,e)}:r&&(c=function(e){e&&e.stopPropagation(),t.contextMenu(p.menuClassName,r,p.translateX||0,p.translateY||0,p.width||0,p.height||0,p),p.setState(2)}),o.text&&o.symbol?a.paddingLeft=g(a.paddingLeft,30):o.text||v(a,{width:o.width,height:o.height,padding:0}),t.styledMode||(a["stroke-linecap"]="round",a.fill=g(a.fill,"#ffffff"),a.stroke=g(a.stroke,"none"));const p=n.button(o.text,0,0,c,a,void 0,void 0,void 0,void 0,o.useHTML).addClass(e.className).attr({title:g(t.options.lang[o._titleKey||o.titleKey],"")});p.menuClassName=e.menuClassName||"highcharts-menu-"+t.btnCount++,o.symbol&&(l=n.symbol(o.symbol,o.symbolX-s/2,o.symbolY-s/2,s,s,{width:s,height:s}).addClass("highcharts-button-symbol").attr({zIndex:1}).add(p),t.styledMode||l.attr({stroke:o.symbolStroke,fill:o.symbolFill,"stroke-width":o.symbolStrokeWidth||1})),p.add(t.exportingGroup).align(v(o,{width:p.width,x:g(o.x,t.buttonOffset)}),!0,"spacingBox"),t.buttonOffset+=((p.width||0)+o.buttonSpacing)*("right"===o.align?-1:1),t.exportSVGElements.push(p,l)}function j(){var e=this;if(e.printReverseInfo){const{childNodes:t,origDisplay:n,resetParams:o}=e.printReverseInfo;e.moveContainers(e.renderTo),[].forEach.call(t,function(e,t){1===e.nodeType&&(e.style.display=n[t]||"")}),e.isPrinting=!1,o&&e.setSize.apply(e,o),delete e.printReverseInfo,i=void 0,S(e,"afterPrint")}}function I(){const e=this,t=w.body,n=e.options.exporting.printMaxWidth,o={childNodes:t.childNodes,origDisplay:[],resetParams:void 0};e.isPrinting=!0,e.pointer.reset(null,0),S(e,"beforePrint"),n&&e.chartWidth>n&&(o.resetParams=[e.options.chart.width,void 0,!1],e.setSize(n,void 0,!1)),[].forEach.call(o.childNodes,function(e,t){1===e.nodeType&&(o.origDisplay[t]=e.style.display,e.style.display="none")}),e.moveContainers(t),e.printReverseInfo=o}function R(e){var t=e;t.renderExporting(),x(e,"redraw",t.renderExporting),x(e,"destroy",t.destroyExport)}function q(t,e,n,o,i,r,s){const l=this,a=l.options.navigation,c=l.chartWidth,p=l.chartHeight,u="cache-"+t,d=Math.max(i,r);let h,g=l[u];g||(l.exportContextMenu=l[u]=g=y("div",{className:t},{position:"absolute",zIndex:1e3,padding:d+"px",pointerEvents:"auto",...l.renderer.style},l.fixedDiv||l.container),h=y("ul",{className:"highcharts-menu"},l.styledMode?{}:{listStyle:"none",margin:0,padding:0},g),l.styledMode||C(h,v({MozBoxShadow:"3px 3px 10px #888",WebkitBoxShadow:"3px 3px 10px #888",boxShadow:"3px 3px 10px #888"},a.menuStyle)),g.hideMenu=function(){C(g,{display:"none"}),s&&s.setState(0),l.openMenu=!1,C(l.renderTo,{overflow:"hidden"}),C(l.container,{overflow:"hidden"}),m.clearTimeout(g.hideTimer),S(l,"exportMenuHidden")},l.exportEvents.push(x(g,"mouseleave",function(){g.hideTimer=E.setTimeout(g.hideMenu,500)}),x(g,"mouseenter",function(){m.clearTimeout(g.hideTimer)}),x(w,"mouseup",function(e){l.pointer.inClass(e.target,t)||g.hideMenu()}),x(g,"click",function(){l.openMenu&&g.hideMenu()})),e.forEach(function(t){if("string"==typeof t&&(t=l.options.exporting.menuItemDefinitions[t]),T(t,!0)){let e;t.separator?e=y("hr",void 0,void 0,h):("viewData"===t.textKey&&l.isDataTableVisible&&(t.textKey="hideData"),e=y("li",{className:"highcharts-menu-item",onclick:function(e){e&&e.stopPropagation(),g.hideMenu(),"string"!=typeof t&&t.onclick&&t.onclick.apply(l,arguments)}},void 0,h),f.setElementHTML(e,t.text||l.options.lang[t.textKey]),l.styledMode||(e.onmouseover=function(){C(this,a.menuItemHoverStyle)},e.onmouseout=function(){C(this,a.menuItemStyle)},C(e,v({cursor:"pointer"},a.menuItemStyle||{})))),l.exportDivElements.push(e)}}),l.exportDivElements.push(h,g),l.exportMenuWidth=g.offsetWidth,l.exportMenuHeight=g.offsetHeight);e={display:"block"};n+l.exportMenuWidth>c?e.right=c-n-i-d+"px":e.left=n-d+"px",o+r+l.exportMenuHeight>p&&"top"!==s.alignOptions.verticalAlign?e.bottom=p-o-d+"px":e.top=o+r-d+"px",C(g,e),C(l.renderTo,{overflow:""}),C(l.container,{overflow:""}),l.openMenu=!0,S(l,"exportMenuShown")}function L(e){const n=e?e.target:this,o=n.exportSVGElements,i=n.exportDivElements,t=n.exportEvents;let r;o&&(o.forEach((e,t)=>{e&&(e.onclick=e.ontouchstart=null,r="cache-"+e.menuClassName,n[r]&&delete n[r],o[t]=e.destroy())}),o.length=0),n.exportingGroup&&(n.exportingGroup.destroy(),delete n.exportingGroup),i&&(i.forEach(function(e,t){e&&(m.clearTimeout(e.hideTimer),O(e,"mouseleave"),i[t]=e.onmouseout=e.onmouseover=e.ontouchstart=e.onclick=null,p(e))}),i.length=0),t&&(t.forEach(function(e){e()}),t.length=0)}function V(e,t){t=this.getSVGForExport(e,t);e=d(this.options.exporting,e),s.post(e.url,{filename:e.filename?e.filename.replace(/\//g,"-"):this.getFilename(),type:e.type,width:e.width,scale:e.scale,svg:t},e.fetchOptions)}function z(){return this.styledMode&&this.inlineStyles(),this.container.innerHTML}function $(){var e=this.userOptions.title&&this.userOptions.title.text;let t=this.options.exporting.filename;return t?t.replace(/\//g,"-"):t=!(t="string"==typeof e?e.toLowerCase().replace(/<\/?[^>]+(>|$)/g,"").replace(/[\s_]+/g,"-").replace(/[^a-z0-9\-]/g,"").replace(/^[\-]+/g,"").replace(/[\-]+/g,"-").substr(0,24).replace(/[\-]+$/g,""):t)||t.length<5?"chart":t}function K(n){var e=this;let t,o,i=d(e.options,n);i.plotOptions=d(e.userOptions.plotOptions,n&&n.plotOptions),i.time=d(e.userOptions.time,n&&n.time);var r=y("div",null,{position:"absolute",top:"-9999em",width:e.chartWidth+"px",height:e.chartHeight+"px"},w.body),s=e.renderTo.style.width,l=e.renderTo.style.height,s=i.exporting.sourceWidth||i.chart.width||/px$/.test(s)&&parseInt(s,10)||(i.isGantt?800:600),l=i.exporting.sourceHeight||i.chart.height||/px$/.test(l)&&parseInt(l,10)||400;v(i.chart,{animation:!1,renderTo:r,forExport:!0,renderer:"SVGRenderer",width:s,height:l}),i.exporting.enabled=!1,delete i.data,i.series=[],e.series.forEach(function(e){(o=d(e.userOptions,{animation:!1,enableMouseTracking:!1,showCheckbox:!1,visible:e.visible})).isInternal||i.series.push(o)});const a={},c=(e.axes.forEach(function(e){e.userOptions.internalKey||(e.userOptions.internalKey=k()),e.options.isInternal||(a[e.coll]||(a[e.coll]=!0,i[e.coll]=[]),i[e.coll].push(d(e.userOptions,{visible:e.visible})))}),i.colorAxis=e.userOptions.colorAxis,new e.constructor(i,e.callback));return n&&["xAxis","yAxis","series"].forEach(function(e){var t={};n[e]&&(t[e]=n[e],c.update(t))}),e.axes.forEach(function(t){var e=u(c.axes,function(e){return e.options.internalKey===t.userOptions.internalKey}),n=t.getExtremes(),o=n.userMin,n=n.userMax;e&&(void 0!==o&&o!==e.min||void 0!==n&&n!==e.max)&&e.setExtremes(o,n,!0,!1)}),t=c.getChartHTML(),S(this,"getSVG",{chartCopy:c}),t=e.sanitizeSVG(t,i),i=null,c.destroy(),p(r),t}function A(e,t){var n=this.options.exporting;return this.getSVG(d({chart:{borderRadius:0}},n.chartOptions,t,{exporting:{sourceWidth:e&&e.sourceWidth||n.sourceWidth,sourceHeight:e&&e.sourceHeight||n.sourceHeight}}))}function B(){const g=H,f=P.inlineAllowlist,m={};let x;const e=w.createElement("iframe"),y=(C(e,{width:"1px",height:"1px",visibility:"hidden"}),w.body.appendChild(e),e.contentWindow&&e.contentWindow.document);y&&y.body.appendChild(y.createElementNS(c,"svg")),function v(e){const t={};let n,o,i,r,s,l;if(y&&1===e.nodeType&&-1===W.indexOf(e.nodeName)){if(n=E.getComputedStyle(e,null),o="svg"===e.nodeName?{}:E.getComputedStyle(e.parentNode,null),!m[e.nodeName]){x=y.getElementsByTagName("svg")[0],i=y.createElementNS(e.namespaceURI,e.nodeName),x.appendChild(i);var a=E.getComputedStyle(i,null),c={};for(const d in a)"string"!=typeof a[d]||/^[0-9]+$/.test(d)||(c[d]=a[d]);m[e.nodeName]=c,"text"===e.nodeName&&delete m.text.fill,x.removeChild(i)}for(const h in n)if(b.isFirefox||b.isMS||b.isSafari||Object.hasOwnProperty.call(n,h)){u=p=void 0;var p=n[h],u=h;if(r=s=!1,f.length){for(l=f.length;l--&&!s;)s=f[l].test(u);r=!s}for("transform"===u&&"none"===p&&(r=!0),l=g.length;l--&&!r;)r=g[l].test(u)||"function"==typeof p;r||o[u]===p&&"svg"!==e.nodeName||m[e.nodeName][u]===p||(G&&-1===G.indexOf(u)?t[u]=p:p&&e.setAttribute(u.replace(/([A-Z])/g,function(e,t){return"-"+t.toLowerCase()}),p))}C(e,t),"svg"===e.nodeName&&e.setAttribute("stroke-width","1px"),"text"!==e.nodeName&&[].forEach.call(e.children||e.childNodes,v)}}(this.container.querySelector("svg")),x.parentNode.removeChild(x),e.parentNode.removeChild(e)}function U(t){(this.fixedDiv?[this.fixedDiv,this.scrollingContainer]:[this.container]).forEach(function(e){t.appendChild(e)})}function J(){const o=this,n=(e,t,n)=>{o.isDirtyExporting=!0,d(!0,o.options[e],t),g(n,!0)&&o.redraw()};o.exporting={update:function(e,t){n("exporting",e,t)}},e.compose(o).navigation.addUpdate((e,t)=>{n("navigation",e,t)})}function X(){const e=this;e.isPrinting||(i=e,b.isSafari||e.beforePrint(),setTimeout(()=>{E.focus(),E.print(),b.isSafari||setTimeout(()=>{e.afterPrint()},1e3)},1))}function _(){const t=this,e=t.options.exporting,n=e.buttons,o=t.isDirtyExporting||!t.exportSVGElements;t.buttonOffset=0,t.isDirtyExporting&&t.destroyExport(),o&&!1!==e.enabled&&(t.exportEvents=[],t.exportingGroup=t.exportingGroup||t.renderer.g("exporting-group").attr({zIndex:3}).add(),h(n,function(e){t.addButton(e)}),t.isDirtyExporting=!1)}function Y(e,t){var n=e.indexOf("</svg>")+6;let o=e.substr(n);return e=e.substr(0,n),t&&t.exporting&&t.exporting.allowHTML&&o&&(o='<foreignObject x="0" y="0" width="'+t.chart.width+'" height="'+t.chart.height+'"><body xmlns="http://www.w3.org/1999/xhtml">'+o.replace(/(<(?:img|br).*?(?=\>))>/g,"$1 />")+"</body></foreignObject>",e=e.replace("</svg>",o+"</svg>")),e=e.replace(/zIndex="[^"]+"/g,"").replace(/symbolName="[^"]+"/g,"").replace(/jQuery[0-9]+="[^"]+"/g,"").replace(/url\(("|&quot;)(.*?)("|&quot;)\;?\)/g,"url($2)").replace(/url\([^#]+#/g,"url(#").replace(/<svg /,'<svg xmlns:xlink="http://www.w3.org/1999/xlink" ').replace(/ (|NS[0-9]+\:)href=/g," xlink:href=").replace(/\n/," ").replace(/(fill|stroke)="rgba\(([ 0-9]+,[ 0-9]+,[ 0-9]+),([ 0-9\.]+)\)"/g,'$1="rgb($2)" $1-opacity="$3"').replace(/&nbsp;/g," ").replace(/&shy;/g,"­")}P.compose=function D(e,t){o.compose(t),r.compose(e),F(a,D)&&((t=e.prototype).afterPrint=j,t.exportChart=V,t.inlineStyles=B,t.print=X,t.sanitizeSVG=Y,t.getChartHTML=z,t.getSVG=K,t.getSVGForExport=A,t.getFilename=$,t.moveContainers=U,t.beforePrint=I,t.contextMenu=q,t.addButton=N,t.destroyExport=L,t.renderExporting=_,t.callbacks.push(R),x(e,"init",J),b.isSafari&&E.matchMedia("print").addListener(function(e){i&&(e.matches?i.beforePrint():i.afterPrint())}),l.exporting=d(n.exporting,l.exporting),l.lang=d(n.lang,l.lang),l.navigation=d(n.navigation,l.navigation))}}return M}),t(e,"masters/modules/exporting.src.js",[e["Core/Globals.js"],e["Extensions/Exporting/Exporting.js"],e["Core/HttpUtilities.js"]],function(e,t,n){e.HttpUtilities=n,e.ajax=n.ajax,e.getJSON=n.getJSON,e.post=n.post,t.compose(e.Chart,e.Renderer)})});
//# sourceMappingURL=exporting.js.map;
!function(e){"object"==typeof module&&module.exports?module.exports=e["default"]=e:"function"==typeof define&&define.amd?define("highcharts/modules/export-data",["highcharts","highcharts/modules/exporting"],function(t){return e(t),e.Highcharts=t,e}):e("undefined"!=typeof Highcharts?Highcharts:undefined)}(function(t){"use strict";t=t?t._modules:{};function e(t,e,a,o){t.hasOwnProperty(e)||(t[e]=o.apply(null,a),"function"==typeof CustomEvent&&window.dispatchEvent(new CustomEvent("HighchartsModuleLoaded",{detail:{path:e,module:t[e]}})))}e(t,"Extensions/DownloadURL.js",[t["Core/Globals.js"]],function(t){const{isSafari:r,win:s,win:{document:l}}=t,n=s.URL||s.webkitURL||s;function c(t){t=t.replace(/filename=.*;/,"").match(/data:([^;]*)(;base64)?,([0-9A-Za-z+/]+)/);if(t&&3<t.length&&s.atob&&s.ArrayBuffer&&s.Uint8Array&&s.Blob&&n.createObjectURL){var e=s.atob(t[3]),a=new s.ArrayBuffer(e.length),o=new s.Uint8Array(a);for(let t=0;t<o.length;++t)o[t]=e.charCodeAt(t);return n.createObjectURL(new s.Blob([o],{type:t[1]}))}}return{dataURLtoBlob:c,downloadURL:function(t,e){var a=s.navigator,o=l.createElement("a");if("string"==typeof t||t instanceof String||!a.msSaveOrOpenBlob){t=""+t;var n=/Edge\/\d+/.test(a.userAgent),i=r&&"string"==typeof t&&0===t.indexOf("data:application/pdf");if((i||n||2e6<t.length)&&!(t=c(t)||""))throw new Error("Failed to convert to blob");if("undefined"!=typeof o.download)o.href=t,o.download=e,l.body.appendChild(o),o.click(),l.body.removeChild(o);else try{if(!s.open(t,"chart"))throw new Error("Failed to open window")}catch{s.location.href=t}}else a.msSaveOrOpenBlob(t,e)}}}),e(t,"Extensions/ExportData/ExportDataDefaults.js",[],function(){return{exporting:{csv:{annotations:{itemDelimiter:"; ",join:!1},columnHeaderFormatter:null,dateFormat:"%Y-%m-%d %H:%M:%S",decimalPoint:null,itemDelimiter:null,lineDelimiter:"\n"},showTable:!1,useMultiLevelHeaders:!0,useRowspanHeaders:!0,showExportInProgress:!0},lang:{downloadCSV:"Download CSV",downloadXLS:"Download XLS",exportData:{annotationHeader:"Annotations",categoryHeader:"Category",categoryDatetimeHeader:"DateTime"},viewData:"View data table",hideData:"Hide data table",exportInProgress:"Exporting..."}}}),e(t,"Extensions/ExportData/ExportData.js",[t["Core/Renderer/HTML/AST.js"],t["Core/Defaults.js"],t["Extensions/DownloadURL.js"],t["Extensions/ExportData/ExportDataDefaults.js"],t["Core/Globals.js"],t["Core/Series/SeriesRegistry.js"],t["Core/Utilities.js"]],function(n,t,e,o,a,i,r){const{getOptions:s,setOptions:l}=t,c=e["downloadURL"],{composed:d,doc:h,win:p}=a,{series:f,seriesTypes:{arearange:u,gantt:m,map:g,mapbubble:x,treemap:b,xrange:y}}=i,{addEvent:w,defined:C,extend:v,find:L,fireEvent:A,isNumber:R,pick:k,pushUnique:D}=r;function T(t){const e=Boolean(this.options.exporting?.showExportInProgress),a=p.requestAnimationFrame||setTimeout;a(()=>{e&&this.showLoading(this.options.lang.exportInProgress),a(()=>{try{t.call(this)}finally{e&&this.hideLoading()}})})}function E(){T.call(this,()=>{var t=this.getCSV(!0);c(U(t,"text/csv")||"data:text/csv,\ufeff"+encodeURIComponent(t),this.getFilename()+".csv")})}function S(){T.call(this,()=>{var t='<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head>\x3c!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>Ark1</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--\x3e<style>td{border:none;font-family: Calibri, sans-serif;} .number{mso-number-format:"0.00";} .text{ mso-number-format:"@";}</style><meta name=ProgId content=Excel.Sheet><meta charset=UTF-8></head><body>'+this.getTable(!0)+"</body></html>";c(U(t,"application/vnd.ms-excel")||"data:application/vnd.ms-excel;base64,"+(t=t,p.btoa(unescape(encodeURIComponent(t)))),this.getFilename()+".xls")})}function O(t){let n="";const i=this.getDataRows(),e=this.options.exporting.csv,r=k(e.decimalPoint,","!==e.itemDelimiter&&t?1.1.toLocaleString()[1]:"."),s=k(e.itemDelimiter,","===r?";":","),l=e.lineDelimiter;return i.forEach((t,e)=>{let a="",o=t.length;for(;o--;)"number"==typeof(a="string"==typeof(a=t[o])?`"${a}"`:a)&&"."!==r&&(a=a.toString().replace(".",r)),t[o]=a;t.length=i.length?i[0].length:0,n+=t.join(s),e<i.length-1&&(n+=l)}),n}function H(n){const x=this.hasParallelCoordinates,b=this.time,y=this.options.exporting&&this.options.exporting.csv||{},i=this.xAxis,w={},t=[],r=[],s=[],e=this.options.lang,a=e.exportData,l=a.categoryHeader,c=a.categoryDatetimeHeader,v=function(t,e,a){if(y.columnHeaderFormatter){var o=y.columnHeaderFormatter(t,e,a);if(!1!==o)return o}return t?t instanceof f?n?{columnTitle:1<a?e:t.name,topLevelColumnTitle:t.name}:t.name+(1<a?" ("+e+")":""):t.options.title&&t.options.title.text||(t.dateTime?c:l):l},D=function(a,t,o){const n={},i={};return t.forEach(function(t){var e=(a.keyToAxis&&a.keyToAxis[t]||t)+"Axis",e=R(o)?a.chart[e][o]:a[e];n[t]=e&&e.categories||[],i[t]=e&&e.dateTime}),{categoryMap:n,dateTimeValueAxisMap:i}},T=[];let o,d,E,S=0,h,p;for(h in this.series.forEach(function(l){const t=l.options.keys,c=l.xAxis,d=t||(a=c,o=(e=l).pointArrayMap||["y"],e.data.some(t=>"undefined"!=typeof t.y&&t.name)&&a&&!a.categories&&"name"!==e.exportKey?["x",...o]:o),h=d.length,p=!l.requireSorting&&{},u=i.indexOf(c);var e,a,o;let m=D(l,d),f,g;if(!1!==l.options.includeInDataExport&&!l.options.isInternal&&!1!==l.visible){for(L(T,function(t){return t[0]===u})||T.push([u,S]),g=0;g<h;)E=v(l,d[g],d.length),s.push(E.columnTitle||E),n&&r.push(E.topLevelColumnTitle||E),g++;f={chart:l.chart,autoIncrement:l.autoIncrement,options:l.options,pointArrayMap:l.pointArrayMap,index:l.index};l.options.data.forEach(function(t,e){var a={series:f};let o,n,i;x&&(m=D(l,d,e)),l.pointClass.prototype.applyOptions.apply(a,[t]);t=l.data[e]&&l.data[e].name;if(o=(a.x??"")+","+t,g=0,(!c||"name"===l.exportKey||!x&&c&&c.hasNames&&t)&&(o=t),p&&(p[o]&&(o+="|"+e),p[o]=!0),w[o]){var e=o+","+w[o].pointers[l.index],r=o;w[o].pointers[l.index]&&(w[e]||(w[e]=[],w[e].xValues=[],w[e].pointers=[]),o=e),w[r].pointers[l.index]+=1}else{w[o]=[],w[o].xValues=[];var s=[];for(let t=0;t<l.chart.series.length;t++)s[t]=0;w[o].pointers=s,w[o].pointers[l.index]=1}for(w[o].x=a.x,w[o].name=t,w[o].xValues[u]=a.x;g<h;)i=a[n=d[g]],w[o][S+g]=k(m.categoryMap[n][i],m.dateTimeValueAxisMap[n]?b.dateFormat(y.dateFormat,i):null,i),g++}),S+=g}}),w)Object.hasOwnProperty.call(w,h)&&t.push(w[h]);let u,m;for(d=n?[r,s]:[s],S=T.length;S--;)u=T[S][0],m=T[S][1],o=i[u],t.sort(function(t,e){return t.xValues[u]-e.xValues[u]}),p=v(o),d[0].splice(m,0,p),n&&d[1]&&d[1].splice(m,0,p),t.forEach(function(t){let e=t.name;o&&!C(e)&&(e=o.dateTime?(t.x instanceof Date&&(t.x=t.x.getTime()),b.dateFormat(y.dateFormat,t.x)):o.categories?k(o.names[t.x],o.categories[t.x],t.x):t.x),t.splice(m,0,e)});return d=d.concat(t),A(this,"exportData",{dataRows:d}),d}function N(t){const e=t=>{if(!t.tagName||"#text"===t.tagName)return t.textContent||"";const a=t.attributes;let o="<"+t.tagName;return a&&Object.keys(a).forEach(t=>{var e=a[t];o+=` ${t}="${e}"`}),o=(o+=">")+(t.textContent||""),(t.children||[]).forEach(t=>{o+=e(t)}),o+=`</${t.tagName}>`};t=this.getTableAST(t);return e(t)}function V(t){let o=0;var e=[];const p=this.options,r=t?1.1.toLocaleString()[1]:".",u=k(p.exporting.useMultiLevelHeaders,!0),a=this.getDataRows(u),n=u?a.shift():null,i=a.shift(),m=function(t,e){let a=t.length;if(e.length!==a)return!1;for(;a--;)if(t[a]!==e[a])return!1;return!0},f=function(t,e,a,o){let n=k(o,""),i="highcharts-text"+(e?" "+e:"");return"number"==typeof n?(n=n.toString(),","===r&&(n=n.replace(".",r)),i="highcharts-number"):o||(i="highcharts-empty"),{tagName:t,attributes:a=v({"class":i},a),textContent:n}};!1!==p.exporting.tableCaption&&e.push({tagName:"caption",attributes:{"class":"highcharts-table-caption"},textContent:k(p.exporting.tableCaption,p.title.text||"Chart")});for(let t=0,e=a.length;t<e;++t)a[t].length>o&&(o=a[t].length);e.push(function(t,e,a){var o=[];let n=0,i=a||e&&e.length,r,s=0,l;if(u&&t&&e&&!m(t,e)){for(var c,d=[];n<i;++n)(r=t[n])===t[n+1]?++s:s?(d.push(f("th","highcharts-table-topheading",{scope:"col",colspan:s+1},r)),s=0):(r===e[n]?p.exporting.useRowspanHeaders?(l=2,delete e[n]):(l=1,e[n]=""):l=1,c=f("th","highcharts-table-topheading",{scope:"col"},r),1<l&&c.attributes&&(c.attributes.valign="top",c.attributes.rowspan=l),d.push(c));o.push({tagName:"tr",children:d})}if(e){var h=[];for(n=0,i=e.length;n<i;++n)"undefined"!=typeof e[n]&&h.push(f("th",null,{scope:"col"},e[n]));o.push({tagName:"tr",children:h})}return{tagName:"thead",children:o}}(n,i,Math.max(o,i.length)));const s=[];a.forEach(function(e){var a=[];for(let t=0;t<o;t++)a.push(f(t?"td":"th",null,t?{}:{scope:"row"},e[t]));s.push({tagName:"tr",children:a})}),e.push({tagName:"tbody",children:s});t={tree:{tagName:"table",id:"highcharts-data-table-"+this.index,children:e}};return A(this,"aftergetTableAST",t),t.tree}function B(){this.toggleDataTable(!1)}function I(t){var e=(t=k(t,!this.isDataTableVisible))&&!this.dataTableDiv,e=(e&&(this.dataTableDiv=h.createElement("div"),this.dataTableDiv.className="highcharts-data-table",this.renderTo.parentNode.insertBefore(this.dataTableDiv,this.renderTo.nextSibling)),this.dataTableDiv&&(a=(o=this.dataTableDiv.style).display,o.display=t?"block":"none",t?(this.dataTableDiv.innerHTML=n.emptyHTML,new n([this.getTableAST()]).addToDOM(this.dataTableDiv),A(this,"afterViewData",{element:this.dataTableDiv,wasHidden:e||a!==o.display})):A(this,"afterHideData")),this.isDataTableVisible=t,this.exportDivElements),a=this.options.exporting,o=a&&a.buttons&&a.buttons.contextButton.menuItems,t=this.options.lang;a&&a.menuItemDefinitions&&t&&t.viewData&&t.hideData&&o&&e&&(a=e[o.indexOf("viewData")])&&n.setElementHTML(a,this.isDataTableVisible?t.hideData:t.viewData)}function M(){this.toggleDataTable(!0)}function U(t,e){var a,o=p.navigator,n=p.URL||p.webkitURL||p;try{return o.msSaveOrOpenBlob&&p.MSBlobBuilder?((a=new p.MSBlobBuilder).append(t),a.getBlob("image/svg+xml")):n.createObjectURL(new p.Blob(["\ufeff"+t],{type:e}))}catch(i){}}function F(){const n=this,i=n.dataTableDiv,r=(t,e)=>t.children[e].textContent,s=(o,n)=>(t,e)=>{var a;return a=r(n?t:e,o),e=r(n?e:t,o),""===a||""===e||isNaN(a)||isNaN(e)?a.toString().localeCompare(e):a-e};var t;i&&n.options.exporting&&n.options.exporting.allowTableSorting&&(t=i.querySelector("thead tr"))&&t.childNodes.forEach(a=>{const o=a.closest("table");a.addEventListener("click",function(){var t=[...i.querySelectorAll("tr:not(thead tr)")],e=[...a.parentNode.children];t.sort(s(e.indexOf(a),n.ascendingOrderInTable=!n.ascendingOrderInTable)).forEach(t=>{o.appendChild(t)}),e.forEach(e=>{["highcharts-sort-ascending","highcharts-sort-descending"].forEach(t=>{e.classList.contains(t)&&e.classList.remove(t)})}),a.classList.add(n.ascendingOrderInTable?"highcharts-sort-ascending":"highcharts-sort-descending")})})}function P(){this.options&&this.options.exporting&&this.options.exporting.showTable&&!this.options.chart.forExport&&this.viewData()}return{compose:function j(t){var e,a;D(d,j)&&(e=t.prototype,a=s().exporting,w(t,"afterViewData",F),w(t,"render",P),e.downloadCSV=E,e.downloadXLS=S,e.getCSV=O,e.getDataRows=H,e.getTable=N,e.getTableAST=V,e.hideData=B,e.toggleDataTable=I,e.viewData=M,a&&(v(a.menuItemDefinitions,{downloadCSV:{textKey:"downloadCSV",onclick:function(){this.downloadCSV()}},downloadXLS:{textKey:"downloadXLS",onclick:function(){this.downloadXLS()}},viewData:{textKey:"viewData",onclick:function(){T.call(this,this.toggleDataTable)}}}),a.buttons)&&a.buttons.contextButton.menuItems&&a.buttons.contextButton.menuItems.push("separator","downloadCSV","downloadXLS","viewData"),l(o),u&&(u.prototype.keyToAxis={low:"y",high:"y"}),m&&(m.prototype.exportKey="name",m.prototype.keyToAxis={start:"x",end:"x"}),y&&(y.prototype.keyToAxis={x2:"x"}),g&&(g.prototype.exportKey="name"),x&&(x.prototype.exportKey="name"),b)&&(b.prototype.exportKey="name")}}}),e(t,"masters/modules/export-data.src.js",[t["Core/Globals.js"],t["Extensions/DownloadURL.js"],t["Extensions/ExportData/ExportData.js"]],function(t,e,a){t.dataURLtoBlob=e.dataURLtoBlob,t.downloadURL=e.downloadURL,a.compose(t.Chart)})});
//# sourceMappingURL=export-data.js.map;
!function(t){"object"==typeof module&&module.exports?module.exports=t["default"]=t:"function"==typeof define&&define.amd?define("highcharts/modules/accessibility",["highcharts"],function(e){return t(e),t.Highcharts=e,t}):t("undefined"!=typeof Highcharts?Highcharts:undefined)}(function(e){"use strict";e=e?e._modules:{};function t(e,t,i,n){e.hasOwnProperty(t)||(e[t]=n.apply(null,i),"function"==typeof CustomEvent&&window.dispatchEvent(new CustomEvent("HighchartsModuleLoaded",{detail:{path:t,module:e[t]}})))}t(e,"Accessibility/Utils/HTMLUtilities.js",[e["Core/Globals.js"],e["Core/Utilities.js"]],function(e,t){const{doc:n,win:o}=e,i=t["css"],s=o.EventTarget&&new o.EventTarget||"none";function r(e){if("function"==typeof o.MouseEvent)return new o.MouseEvent(e.type,e);if(n.createEvent){var t=n.createEvent("MouseEvent");if(t.initMouseEvent)return t.initMouseEvent(e.type,e.bubbles,e.cancelable,e.view||o,e.detail,e.screenX,e.screenY,e.clientX,e.clientY,e.ctrlKey,e.altKey,e.shiftKey,e.metaKey,e.button,e.relatedTarget),t}return a(e.type)}function a(e,t,i){t=t||{x:0,y:0};if("function"==typeof o.MouseEvent)return new o.MouseEvent(e,{bubbles:!0,cancelable:!0,composed:!0,button:0,buttons:1,relatedTarget:i||s,view:o,detail:"click"===e?1:0,screenX:t.x,screenY:t.y,clientX:t.x,clientY:t.y});if(n.createEvent){i=n.createEvent("MouseEvent");if(i.initMouseEvent)return i.initMouseEvent(e,!0,!0,o,"click"===e?1:0,t.x,t.y,t.x,t.y,!1,!1,!1,!1,0,null),i}return{type:e}}return{addClass:function(e,t){e.classList?e.classList.add(t):e.className.indexOf(t)<0&&(e.className+=" "+t)},cloneMouseEvent:r,cloneTouchEvent:function(e){var t=t=>{var i=[];for(let e=0;e<t.length;++e){var n=t.item(e);n&&i.push(n)}return i};return"function"==typeof o.TouchEvent?(t=new o.TouchEvent(e.type,{touches:t(e.touches),targetTouches:t(e.targetTouches),changedTouches:t(e.changedTouches),ctrlKey:e.ctrlKey,shiftKey:e.shiftKey,altKey:e.altKey,metaKey:e.metaKey,bubbles:e.bubbles,cancelable:e.cancelable,composed:e.composed,detail:e.detail,view:e.view}),e.defaultPrevented&&t.preventDefault()):((t=r(e)).touches=e.touches,t.changedTouches=e.changedTouches,t.targetTouches=e.targetTouches),t},escapeStringForHTML:function(e){return e.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;")},getElement:function(e){return n.getElementById(e)},getFakeMouseEvent:a,getHeadingTagNameForElement:function(e){const i=e=>{e=parseInt(e.slice(1),10);return"h"+Math.min(6,e+1)},n=e=>/H[1-6]/.test(e),o=e=>{var t=(e=>{let t=e;for(;t=t.previousSibling;){var i=t.tagName||"";if(n(i))return i}return""})(e);return t?i(t):(t=e.parentElement)?(e=t.tagName,n(e)?i(e):o(t)):"p"};return o(e)},removeChildNodes:function(e){for(;e.lastChild;)e.removeChild(e.lastChild)},removeClass:function(e,t){e.classList?e.classList.remove(t):e.className=e.className.replace(new RegExp(t,"g"),"")},removeElement:function(e){e&&e.parentNode&&e.parentNode.removeChild(e)},reverseChildNodes:function(e){let t=e.childNodes.length;for(;t--;)e.appendChild(e.childNodes[t])},simulatedEventTarget:s,stripHTMLTagsFromString:function(e,t=!1){return"string"==typeof e?t?e.replace(/<\/?[^>]+(>|$)/g,""):e.replace(/<\/?(?!\s)[^>]+(>|$)/g,""):e},visuallyHideElement:function(e){i(e,{position:"absolute",width:"1px",height:"1px",overflow:"hidden",whiteSpace:"nowrap",clip:"rect(1px, 1px, 1px, 1px)",marginTop:"-3px","-ms-filter":"progid:DXImageTransform.Microsoft.Alpha(Opacity=1)",filter:"alpha(opacity=1)",opacity:.01})}}}),t(e,"Accessibility/A11yI18n.js",[e["Core/Templating.js"],e["Core/Globals.js"],e["Core/Utilities.js"]],function(e,t,i){const a=e["format"],n=t["composed"],{getNestedProperty:p,pick:g,pushUnique:o}=i;var s;function r(e,t,i){var n=[];let o,s,r=0;for(;o=((e,t)=>{var e=e.slice(t||0),i=e.indexOf("{"),n=e.indexOf("}");if(-1<i&&i<n)return{statement:e.substring(i+1,n),begin:t+i+1,end:t+n}})(e,r),(s=e.substring(r,o&&o.begin-1)).length&&n.push({value:s,type:"constant"}),o&&n.push({value:o.statement,type:"statement"}),r=o?o.end+1:r+1,o;);return n.forEach(e=>{"statement"===e.type&&(e.value=function(t,i){var n=t.indexOf("#each("),o=t.indexOf("#plural("),s=t.indexOf("["),r=t.indexOf("]");let a,l;if(-1<n){var c,e=t.slice(n).indexOf(")")+n,h=t.substring(0,n),d=t.substring(e+1),n=t.substring(n+6,e).split(","),e=Number(n[1]);if(l="",a=p(n[0],i)){c=(e=isNaN(e)?a.length:e)<0?a.length+e:Math.min(e,a.length);for(let e=0;e<c;++e)l+=h+a[e]+d}return l.length?l:""}if(-1<o){var n=t.slice(o).indexOf(")")+o,u=t.substring(o+8,n).split(",");switch(Number(p(u[0],i))){case 0:l=g(u[4],u[1]);break;case 1:l=g(u[2],u[1]);break;case 2:l=g(u[3],u[1]);break;default:l=u[1]}return l?(e=l).trim&&e.trim()||e.replace(/^\s+|\s+$/g,""):""}if(-1<s){o=t.substring(0,s),n=Number(t.substring(s+1,r));let e;return a=p(o,i),!isNaN(n)&&a&&(n<0?void 0===(e=a[a.length+n])&&(e=a[0]):void 0===(e=a[n])&&(e=a[a.length-1])),void 0!==e?e:""}return"{"+t+"}"}(e.value,t))}),a(n.reduce((e,t)=>e+t.value,""),t,i)}function l(e,t){var i=e.split(".");let n=this.options.lang,o=0;for(;o<i.length;++o)n=n&&n[i[o]];return"string"==typeof n?r(n,t,this):""}return(e=s=s||{}).compose=function c(e){o(n,c)&&(e.prototype.langFormat=l)},e.i18nFormat=r,s}),t(e,"Accessibility/Utils/ChartUtilities.js",[e["Core/Globals.js"],e["Accessibility/Utils/HTMLUtilities.js"],e["Core/Utilities.js"]],function(e,t,i){const o=e["doc"],n=t["stripHTMLTagsFromString"],{defined:a,find:s,fireEvent:l}=i;function r(e){if(e.points&&e.points.length)return(e=s(e.points,e=>!!e.graphic))&&e.graphic&&e.graphic.element}function c(e){var t=r(e);return t&&t.parentNode||e.graph&&e.graph.element||e.group&&e.group.element}return{fireEventOnWrappedOrUnwrappedElement:function h(e,t){var i=t.type,n=e.hcEvents;o.createEvent&&(e.dispatchEvent||e.fireEvent)?e.dispatchEvent?e.dispatchEvent(t):e.fireEvent(i,t):n&&n[i]?l(e,i,t):e.element&&h(e.element,t)},getChartTitle:function(e){return n(e.options.title.text||e.langFormat("accessibility.defaultChartTitle",{chart:e}),e.renderer.forExport)},getAxisDescription:function(e){return e&&(e.options.accessibility?.description||e.axisTitle?.textStr||e.options.id||(e.categories?"categories":e.dateTime&&"Time")||"values")},getAxisRangeDescription:function(e){var i=e.options||{};if(i.accessibility&&"undefined"!=typeof i.accessibility.rangeDescription)return i.accessibility.rangeDescription;if(e.categories)return n=(i=e).chart,i.dataMax&&i.dataMin?n.langFormat("accessibility.axis.rangeCategories",{chart:n,axis:i,numCategories:i.dataMax-i.dataMin+1}):"";if(!e.dateTime||0!==e.min&&0!==e.dataMin){var t=e;const o=t.chart,s=o.options,r=s&&s.accessibility&&s.accessibility.screenReaderSection.axisRangeDateFormat||"",a={min:t.dataMin||t.min||0,max:t.dataMax||t.max||0},l=function(e){return t.dateTime?o.time.dateFormat(r,a[e]):a[e].toString()};return o.langFormat("accessibility.axis.rangeFromTo",{chart:o,axis:t,rangeFrom:l("min"),rangeTo:l("max")})}{i=e;const c=i.chart,h={},d=i.dataMin||i.min||0,u=i.dataMax||i.max||0;let t="Seconds";h.Seconds=(u-d)/1e3,h.Minutes=h.Seconds/60,h.Hours=h.Minutes/60,h.Days=h.Hours/24,["Minutes","Hours","Days"].forEach(function(e){2<h[e]&&(t=e)});var n=h[t].toFixed("Seconds"!==t&&"Minutes"!==t?1:0);return c.langFormat("accessibility.axis.timeRange"+t,{chart:c,axis:i,range:n.replace(".0","")})}},getPointFromXY:function(e,t,i){let n=e.length,o;for(;n--;)if(o=s(e[n].points||[],function(e){return e.x===t&&e.y===i}))return o},getSeriesFirstPointElement:r,getSeriesFromName:function(e,t){return t?(e.series||[]).filter(function(e){return e.name===t}):e.series},getSeriesA11yElement:c,unhideChartElementFromAT:function d(e,t){t.setAttribute("aria-hidden",!1),t!==e.renderTo&&t.parentNode&&t.parentNode!==o.body&&(Array.prototype.forEach.call(t.parentNode.childNodes,function(e){e.hasAttribute("aria-hidden")||e.setAttribute("aria-hidden",!0)}),d(e,t.parentNode))},hideSeriesFromAT:function(e){(e=c(e))&&e.setAttribute("aria-hidden",!0)},scrollAxisToPoint:function(e){var t,i,n,o,s=e.series.xAxis,r=e.series.yAxis,s=s&&s.scrollbar?s:r;(r=s&&s.scrollbar)&&a(r.to)&&a(r.from)&&(t=r.to-r.from,s=s,e=e,o=a(s.dataMin)&&a(s.dataMax)?(i=s.toPixels(s.dataMin),n=s.toPixels(s.dataMax),o="xAxis"===s.coll?"x":"y",(s.toPixels(e[o]||0)-i)/(n-i)):0,r.updatePosition(o-t/2,o+t/2),l(r,"changed",{from:r.from,to:r.to,trigger:"scrollbar",DOMEvent:null}))}}}),t(e,"Accessibility/Utils/DOMElementProvider.js",[e["Core/Globals.js"],e["Accessibility/Utils/HTMLUtilities.js"]],function(e,t){const i=e["doc"],n=t["removeElement"];class o{constructor(){this.elements=[]}createElement(){var e=i.createElement.apply(i,arguments);return this.elements.push(e),e}destroyCreatedElements(){this.elements.forEach(function(e){n(e)}),this.elements=[]}}return o}),t(e,"Accessibility/Utils/EventProvider.js",[e["Core/Globals.js"],e["Core/Utilities.js"]],function(t,e){const i=e["addEvent"];class n{constructor(){this.eventRemovers=[]}addEvent(){var e=i.apply(t,arguments);return this.eventRemovers.push(e),e}removeAddedEvents(){this.eventRemovers.forEach(e=>e()),this.eventRemovers=[]}}return n}),t(e,"Accessibility/AccessibilityComponent.js",[e["Accessibility/Utils/ChartUtilities.js"],e["Accessibility/Utils/DOMElementProvider.js"],e["Accessibility/Utils/EventProvider.js"],e["Accessibility/Utils/HTMLUtilities.js"],e["Core/Utilities.js"]],function(e,i,n,t,o){const s=e["fireEventOnWrappedOrUnwrappedElement"],r=t["getFakeMouseEvent"];e=o.extend;class a{initBase(e,t){this.chart=e,this.eventProvider=new n,this.domElementProvider=new i,this.proxyProvider=t,this.keyCodes={left:37,right:39,up:38,down:40,enter:13,space:32,esc:27,tab:9,pageUp:33,pageDown:34,end:35,home:36}}addEvent(e,t,i,n){return this.eventProvider.addEvent(e,t,i,n)}createElement(e,t){return this.domElementProvider.createElement(e,t)}fakeClickEvent(e){var t=r("click");s(e,t)}destroyBase(){this.domElementProvider.destroyCreatedElements(),this.eventProvider.removeAddedEvents()}}return e(a.prototype,{init(){},getKeyboardNavigation:function(){},onChartUpdate(){},onChartRender(){},destroy(){}}),a}),t(e,"Accessibility/KeyboardNavigationHandler.js",[e["Core/Utilities.js"]],function(e){const o=e["find"];class t{constructor(e,t){this.chart=e,this.keyCodeMap=t.keyCodeMap||[],this.validate=t.validate,this.init=t.init,this.terminate=t.terminate,this.response={success:1,prev:2,next:3,noHandler:4,fail:5}}run(e){const t=e.which||e.keyCode;let i=this.response.noHandler;var n=o(this.keyCodeMap,function(e){return-1<e[0].indexOf(t)});return n?i=n[1].call(this,t,e):9===t&&(i=this.response[e.shiftKey?"prev":"next"]),i}}return t}),t(e,"Accessibility/Components/ContainerComponent.js",[e["Accessibility/AccessibilityComponent.js"],e["Accessibility/KeyboardNavigationHandler.js"],e["Accessibility/Utils/ChartUtilities.js"],e["Core/Globals.js"],e["Accessibility/Utils/HTMLUtilities.js"]],function(e,i,t,n,o){const{unhideChartElementFromAT:s,getChartTitle:r}=t,a=n["doc"],l=o["stripHTMLTagsFromString"];class c extends e{onChartUpdate(){this.handleSVGTitleElement(),this.setSVGContainerLabel(),this.setGraphicContainerAttrs(),this.setRenderToAttrs(),this.makeCreditsAccessible()}handleSVGTitleElement(){var e,t=this.chart,i="highcharts-title-"+t.index,n=l(t.langFormat("accessibility.svgContainerTitle",{chartTitle:r(t)}));n.length&&((e=this.svgTitleElement=this.svgTitleElement||a.createElementNS("http://www.w3.org/2000/svg","title")).textContent=n,e.id=i,t.renderTo.insertBefore(e,t.renderTo.firstChild))}setSVGContainerLabel(){var e=this.chart,t=e.langFormat("accessibility.svgContainerLabel",{chartTitle:r(e)});e.renderer.box&&t.length&&e.renderer.box.setAttribute("aria-label",t)}setGraphicContainerAttrs(){var e=this.chart,t=e.langFormat("accessibility.graphicContainerLabel",{chartTitle:r(e)});t.length&&e.container.setAttribute("aria-label",t)}setRenderToAttrs(){var e=this.chart,t="disabled"!==e.options.accessibility.landmarkVerbosity,i=e.langFormat("accessibility.chartContainerLabel",{title:r(e),chart:e});i&&(e.renderTo.setAttribute("role",t?"region":"group"),e.renderTo.setAttribute("aria-label",i))}makeCreditsAccessible(){var e=this.chart,t=e.credits;t&&(t.textStr&&t.element.setAttribute("aria-label",e.langFormat("accessibility.credits",{creditsStr:l(t.textStr,e.renderer.forExport)})),s(e,t.element))}getKeyboardNavigation(){const t=this.chart;return new i(t,{keyCodeMap:[],validate:function(){return!0},init:function(){var e=t.accessibility;e&&e.keyboardNavigation.tabindexContainer.focus()}})}destroy(){this.chart.renderTo.setAttribute("aria-hidden",!0)}}return c}),t(e,"Accessibility/FocusBorder.js",[e["Core/Globals.js"],e["Core/Utilities.js"]],function(e,t){const i=e["composed"],{addEvent:n,pick:y,pushUnique:o}=t;var s;{e=s=s||{};const f=["x","y","transform","width","height","r","d","stroke-width"];function r(){var e=this.focusElement,t=this.options.accessibility.keyboardNavigation.focusBorder;e&&(e.removeFocusBorder(),t.enabled)&&e.addFocusBorder(t.margin,{stroke:t.style.color,strokeWidth:t.style.lineWidth,r:t.style.borderRadius})}function a(e,t){var i=this.options.accessibility.keyboardNavigation.focusBorder,t=t||e.element;t&&t.focus&&(t.hcEvents&&t.hcEvents.focusin||n(t,"focusin",function(){}),t.focus(),i.hideBrowserFocusOutline)&&(t.style.outline="none"),this.focusElement&&this.focusElement.removeFocusBorder(),this.focusElement=e,this.renderFocusBorder()}function l(e,t){this.focusBorder&&this.removeFocusBorder();var i=this.getBBox(),n=y(e,3),o=this.parentGroup,s=this.scaleX||o&&o.scaleX,r=this.scaleY||o&&o.scaleY,s=(s?!r:r)?Math.abs(s||r||1):(Math.abs(s||1)+Math.abs(r||1))/2;i.x+=this.translateX||0,i.y+=this.translateY||0;let a=i.x-n,l=i.y-n,c=i.width+2*n,h=i.height+2*n;var d,u,p,g,m,b,r=!!this.text,x=(("text"===this.element.nodeName||r)&&(d=!!this.rotation,u=r?{x:d?1:0,y:0}:function(e){let t=0,i=0;return"middle"===e.attr("text-anchor")?t=i=.5:e.rotation?t=.25:i=.75,{x:t,y:i}}(this),p=+this.attr("x"),g=+this.attr("y"),isNaN(p)||(a=p-i.width*u.x-n),isNaN(g)||(l=g-i.height*u.y-n),r)&&d&&(r=c,c=h,h=r,isNaN(p)||(a=p-i.height*u.x-n),isNaN(g)||(l=g-i.width*u.y-n)),this.focusBorder=this.renderer.rect(a,l,c,h,parseInt((t&&t.r||0).toString(),10)/s).addClass("highcharts-focus-border").attr({zIndex:99}).add(o),this.renderer.styledMode||this.focusBorder.attr({stroke:t&&t.stroke,"stroke-width":(t&&t.strokeWidth||0)/s}),b=[e,t],(m=this).focusBorderUpdateHooks||(m.focusBorderUpdateHooks={},f.forEach(e=>{e+="Setter";const t=m[e]||m._defaultSetter;m.focusBorderUpdateHooks[e]=t,m[e]=function(){var e=t.apply(m,arguments);return m.addFocusBorder.apply(m,b),e}})),this);if(!x.focusBorderDestroyHook){const v=x.destroy;x.destroy=function(){return x.focusBorder&&x.focusBorder.destroy&&x.focusBorder.destroy(),v.apply(x,arguments)},x.focusBorderDestroyHook=v}}function c(){var i,e;(i=this).focusBorderUpdateHooks&&(Object.keys(i.focusBorderUpdateHooks).forEach(e=>{var t=i.focusBorderUpdateHooks[e];t===i._defaultSetter?delete i[e]:i[e]=t}),delete i.focusBorderUpdateHooks),(e=this).focusBorderDestroyHook&&(e.destroy=e.focusBorderDestroyHook,delete e.focusBorderDestroyHook),this.focusBorder&&(this.focusBorder.destroy(),delete this.focusBorder)}e.compose=function h(e,t){o(i,h)&&(e=e.prototype,t=t.prototype,e.renderFocusBorder=r,e.setFocusToElement=a,t.addFocusBorder=l,t.removeFocusBorder=c)}}return s}),t(e,"Accessibility/Utils/Announcer.js",[e["Core/Renderer/HTML/AST.js"],e["Accessibility/Utils/DOMElementProvider.js"],e["Core/Globals.js"],e["Accessibility/Utils/HTMLUtilities.js"],e["Core/Utilities.js"]],function(t,i,e,n,o){const s=e["doc"],{addClass:r,visuallyHideElement:a}=n,l=o["attr"];class c{constructor(e,t){this.chart=e,this.domElementProvider=new i,this.announceRegion=this.addAnnounceRegion(t)}destroy(){this.domElementProvider.destroyCreatedElements()}announce(e){t.setElementHTML(this.announceRegion,e),this.clearAnnouncementRegionTimer&&clearTimeout(this.clearAnnouncementRegionTimer),this.clearAnnouncementRegionTimer=setTimeout(()=>{this.announceRegion.innerHTML=t.emptyHTML,delete this.clearAnnouncementRegionTimer},3e3)}addAnnounceRegion(e){var t=this.chart.announcerContainer||this.createAnnouncerContainer(),i=this.domElementProvider.createElement("div");return l(i,{"aria-hidden":!1,"aria-live":e,"aria-atomic":!0}),this.chart.styledMode?r(i,"highcharts-visually-hidden"):a(i),t.appendChild(i),i}createAnnouncerContainer(){var e=this.chart,t=s.createElement("div");return l(t,{"aria-hidden":!1,"class":"highcharts-announcer-container"}),t.style.position="relative",e.renderTo.insertBefore(t,e.renderTo.firstChild),e.announcerContainer=t}}return c}),t(e,"Accessibility/Components/AnnotationsA11y.js",[e["Accessibility/Utils/HTMLUtilities.js"]],function(e){const{escapeStringForHTML:i,stripHTMLTagsFromString:n}=e;function o(e){return(e.annotations||[]).reduce((e,t)=>e=t.options&&!1!==t.options.visible?e.concat(t.labels):e,[])}function r(e){return e.options&&e.options.accessibility&&e.options.accessibility.description||e.graphic&&e.graphic.text&&e.graphic.text.textStr||""}function s(e){var t=e.options&&e.options.accessibility&&e.options.accessibility.description;if(t)return t;var t=e.chart,i=r(e),n=e.points;var n=n.filter(e=>!!e.graphic).map(e=>{var t=e.accessibility&&e.accessibility.valueDescription||(t=e).graphic&&t.graphic.element&&t.graphic.element.getAttribute("aria-label")||"",e=e&&e.series.name||"";return(e?e+", ":"")+"data point "+t}).filter(e=>!!e),o=n.length,s="accessibility.screenReaderSection.annotations.description"+(1<o?"MultiplePoints":o?"SinglePoint":"NoPoints"),i={annotationText:i,annotation:e,numPoints:o,annotationPoint:n[0],additionalAnnotationPoints:n.slice(1)};return t.langFormat(s,i)}function a(t){return o(t).map(e=>{e=i(n(s(e),t.renderer.forExport));return e?`<li>${e}</li>`:""})}return{getAnnotationsInfoHTML:function(e){var t=e.annotations;return t&&t.length?`<ul style="list-style-type: none">${a(e).join(" ")}</ul>`:""},getAnnotationLabelDescription:s,getAnnotationListItems:a,getPointAnnotationTexts:function(t){var e=o(t.series.chart).filter(e=>-1<e.points.indexOf(t));return e.length?e.map(e=>""+r(e)):[]}}}),t(e,"Accessibility/Components/InfoRegionsComponent.js",[e["Accessibility/A11yI18n.js"],e["Accessibility/AccessibilityComponent.js"],e["Accessibility/Utils/Announcer.js"],e["Accessibility/Components/AnnotationsA11y.js"],e["Core/Renderer/HTML/AST.js"],e["Accessibility/Utils/ChartUtilities.js"],e["Core/Templating.js"],e["Core/Globals.js"],e["Accessibility/Utils/HTMLUtilities.js"],e["Core/Utilities.js"]],function(l,e,i,t,r,n,o,s,a,c){const h=t["getAnnotationsInfoHTML"],{getAxisDescription:d,getAxisRangeDescription:u,getChartTitle:p,unhideChartElementFromAT:g}=n,m=o["format"],b=s["doc"],{addClass:x,getElement:v,getHeadingTagNameForElement:y,stripHTMLTagsFromString:f,visuallyHideElement:A}=a,{attr:w,pick:C}=c;function E(e){return e.replace(/<(\w+)[^>]*?>\s*<\/\1>/g,"")}class T extends e{constructor(){super(...arguments),this.screenReaderSections={}}init(){var e=this.chart;const t=this;this.initRegionsDefinitions(),this.addEvent(e,"aftergetTableAST",function(e){t.onDataTableCreated(e)}),this.addEvent(e,"afterViewData",function(e){e.wasHidden&&(t.dataTableDiv=e.element,setTimeout(function(){t.focusDataTable()},300))}),this.addEvent(e,"afterHideData",function(){t.viewDataTableButton&&t.viewDataTableButton.setAttribute("aria-expanded","false")}),this.announcer=new i(e,"assertive")}initRegionsDefinitions(){const i=this,n=this.chart.options.accessibility;this.screenReaderSections={before:{element:null,buildContent:function(e){var t=n.screenReaderSection.beforeChartFormatter;return t?t(e):i.defaultBeforeChartFormatter(e)},insertIntoDOM:function(e,t){t.renderTo.insertBefore(e,t.renderTo.firstChild)},afterInserted:function(){"undefined"!=typeof i.sonifyButtonId&&i.initSonifyButton(i.sonifyButtonId),"undefined"!=typeof i.dataTableButtonId&&i.initDataTableButton(i.dataTableButtonId)}},after:{element:null,buildContent:function(e){var t=n.screenReaderSection.afterChartFormatter;return t?t(e):i.defaultAfterChartFormatter()},insertIntoDOM:function(e,t){t.renderTo.insertBefore(e,t.container.nextSibling)},afterInserted:function(){i.chart.accessibility&&n.keyboardNavigation.enabled&&i.chart.accessibility.keyboardNavigation.updateExitAnchor()}}}}onChartRender(){const t=this;this.linkedDescriptionElement=this.getLinkedDescriptionElement(),this.setLinkedDescriptionAttrs(),Object.keys(this.screenReaderSections).forEach(function(e){t.updateScreenReaderSection(e)})}getLinkedDescriptionElement(){var e=this.chart.options.accessibility.linkedDescription;if(e)return"string"!=typeof e?e:(e=m(e,this.chart),1===(e=b.querySelectorAll(e)).length?e[0]:void 0)}setLinkedDescriptionAttrs(){var e=this.linkedDescriptionElement;e&&(e.setAttribute("aria-hidden","true"),x(e,"highcharts-linked-description"))}updateScreenReaderSection(e){var t=this.chart,i=this.screenReaderSections[e],n=i.buildContent(t),o=i.element=i.element||this.createElement("div"),s=o.firstChild||this.createElement("div");n?(this.setScreenReaderSectionAttribs(o,e),r.setElementHTML(s,n),o.appendChild(s),i.insertIntoDOM(o,t),t.styledMode?x(s,"highcharts-visually-hidden"):A(s),g(t,s),i.afterInserted&&i.afterInserted()):(o.parentNode&&o.parentNode.removeChild(o),i.element=null)}setScreenReaderSectionAttribs(e,t){var i=this.chart,n=i.langFormat("accessibility.screenReaderSection."+t+"RegionLabel",{chart:i,chartTitle:p(i)}),t=`highcharts-screen-reader-region-${t}-`+i.index;w(e,{id:t,"aria-label":n||void 0}),e.style.position="relative",n&&e.setAttribute("role","all"===i.options.accessibility.landmarkVerbosity?"region":"group")}defaultBeforeChartFormatter(){var e,t,i,n,o,s,r=this.chart,a=r.options.accessibility.screenReaderSection.beforeChartFormat;return a?(o=this.getAxesDescription(),s=r.sonify&&r.options.sonification&&r.options.sonification.enabled,e="highcharts-a11y-sonify-data-btn-"+r.index,t="hc-linkto-highcharts-data-table-"+r.index,i=h(r),n=r.langFormat("accessibility.screenReaderSection.annotations.heading",{chart:r}),o={headingTagName:y(r.renderTo),chartTitle:p(r),typeDescription:this.getTypeDescriptionText(),chartSubtitle:this.getSubtitleText(),chartLongdesc:this.getLongdescText(),xAxisDescription:o.xAxis,yAxisDescription:o.yAxis,playAsSoundButton:s?this.getSonifyButtonText(e):"",viewTableButton:r.getCSV?this.getDataTableButtonText(t):"",annotationsTitle:i?n:"",annotationsList:i},s=l.i18nFormat(a,o,r),this.dataTableButtonId=t,this.sonifyButtonId=e,E(s)):""}defaultAfterChartFormatter(){var e,t=this.chart,i=t.options.accessibility.screenReaderSection.afterChartFormat;return i?(e={endOfChartMarker:this.getEndOfChartMarkerText()},E(l.i18nFormat(i,e,t))):""}getLinkedDescription(){var e=this.linkedDescriptionElement,e=e&&e.innerHTML||"";return f(e,this.chart.renderer.forExport)}getLongdescText(){var e=this.chart.options,t=e.caption,t=t&&t.text,i=this.getLinkedDescription();return e.accessibility.description||i||t||""}getTypeDescriptionText(){var e,t,i,n,o,s,r=this.chart;return r.types?r.options.accessibility.typeDescription||(e=(r=r).types,n=e[0],o=r.series&&r.series[0]||{},s=r.mapView&&r.mapView.geoMap&&r.mapView.geoMap.title,o={numSeries:r.series.length,numPoints:o.points&&o.points.length,chart:r,mapTitle:s},n?"map"===n||"tiledwebmap"===n?(s=r,(n=o).mapTitle?s.langFormat("accessibility.chartTypes.mapTypeDescription",n):s.langFormat("accessibility.chartTypes.unknownMap",n)):1<r.types.length?r.langFormat("accessibility.chartTypes.combinationChart",o):(n=r,s=o,e=(e=e)[0],t=n.langFormat("accessibility.seriesTypeDescriptions."+e,s),i=n.series&&n.series.length<2?"Single":"Multiple",(n.langFormat("accessibility.chartTypes."+e+i,s)||n.langFormat("accessibility.chartTypes.default"+i,s))+(t?" "+t:"")):r.langFormat("accessibility.chartTypes.emptyChart",o)):""}getDataTableButtonText(e){var t=this.chart;return'<button id="'+e+'">'+t.langFormat("accessibility.table.viewAsDataTableButtonText",{chart:t,chartTitle:p(t)})+"</button>"}getSonifyButtonText(e){var t=this.chart;return t.options.sonification&&!1===t.options.sonification.enabled?"":'<button id="'+e+'">'+t.langFormat("accessibility.sonification.playAsSoundButtonText",{chart:t,chartTitle:p(t)})+"</button>"}getSubtitleText(){var e=this.chart.options.subtitle;return f(e&&e.text||"",this.chart.renderer.forExport)}getEndOfChartMarkerText(){var e=this.chart,t=e.langFormat("accessibility.screenReaderSection.endOfChartMarker",{chart:e});return'<div id="'+("highcharts-end-of-chart-marker-"+e.index)+'">'+t+"</div>"}onDataTableCreated(e){var t,i=this.chart;i.options.accessibility.enabled&&(this.viewDataTableButton&&this.viewDataTableButton.setAttribute("aria-expanded","true"),(t=e.tree.attributes||{}).tabindex=-1,t.summary=i.langFormat("accessibility.table.tableSummary",{chart:i}),e.tree.attributes=t)}focusDataTable(){var e=this.dataTableDiv,e=e&&e.getElementsByTagName("table")[0];e&&e.focus&&e.focus()}initSonifyButton(e){const t=this.sonifyButton=v(e),i=this.chart,n=e=>{t&&(t.setAttribute("aria-hidden","true"),t.setAttribute("aria-label","")),e.preventDefault(),e.stopPropagation();e=i.langFormat("accessibility.sonification.playAsSoundClickAnnouncement",{chart:i});this.announcer.announce(e),setTimeout(()=>{t&&(t.removeAttribute("aria-hidden"),t.removeAttribute("aria-label")),i.sonify&&i.sonify()},1e3)};t&&i&&(t.setAttribute("tabindex",-1),t.onclick=function(e){(i.options.accessibility&&i.options.accessibility.screenReaderSection.onPlayAsSoundClick||n).call(this,e,i)})}initDataTableButton(e){const t=this.viewDataTableButton=v(e),i=this.chart,n=e.replace("hc-linkto-","");t&&(w(t,{tabindex:-1,"aria-expanded":!!v(n)}),t.onclick=i.options.accessibility.screenReaderSection.onViewDataTableClick||function(){i.viewData()})}getAxesDescription(){const i=this.chart,e=function(e,t){e=i[e];return 1<e.length||e[0]&&C(e[0].options.accessibility&&e[0].options.accessibility.enabled,t)},t=!!i.types&&i.types.indexOf("map")<0&&i.types.indexOf("treemap")<0&&i.types.indexOf("tilemap")<0,n=!!i.hasCartesianSeries,o=e("xAxis",!i.angular&&n&&t),s=e("yAxis",n&&t),r={};return o&&(r.xAxis=this.getAxisDescriptionText("xAxis")),s&&(r.yAxis=this.getAxisDescriptionText("yAxis")),r}getAxisDescriptionText(e){var t=this.chart,i=t[e];return t.langFormat("accessibility.axis."+e+"Description"+(1<i.length?"Plural":"Singular"),{chart:t,names:i.map(function(e){return d(e)}),ranges:i.map(function(e){return u(e)}),numAxes:i.length})}destroy(){this.announcer&&this.announcer.destroy()}}return T}),t(e,"Accessibility/Components/MenuComponent.js",[e["Core/Chart/Chart.js"],e["Core/Globals.js"],e["Core/Utilities.js"],e["Accessibility/AccessibilityComponent.js"],e["Accessibility/KeyboardNavigationHandler.js"],e["Accessibility/Utils/ChartUtilities.js"],e["Accessibility/Utils/HTMLUtilities.js"]],function(i,e,t,n,o,s,r){const a=e["composed"],{attr:l,pushUnique:c}=t,{getChartTitle:h,unhideChartElementFromAT:d}=s,u=r["getFakeMouseEvent"];function p(e){return e.exportSVGElements&&e.exportSVGElements[0]}class g extends n{init(){const e=this.chart,t=this;this.addEvent(e,"exportMenuShown",function(){t.onMenuShown()}),this.addEvent(e,"exportMenuHidden",function(){t.onMenuHidden()}),this.createProxyGroup()}onMenuHidden(){var e=this.chart.exportContextMenu;e&&e.setAttribute("aria-hidden","true"),this.setExportButtonExpandedState("false")}onMenuShown(){var e=this.chart,t=e.exportContextMenu;t&&(this.addAccessibleContextMenuAttribs(),d(e,t)),this.setExportButtonExpandedState("true")}setExportButtonExpandedState(e){this.exportButtonProxy&&this.exportButtonProxy.innerElement.setAttribute("aria-expanded",e)}onChartRender(){var e=this.chart,t=e.focusElement,i=e.accessibility;this.proxyProvider.clearGroup("chartMenu"),this.proxyMenuButton(),this.exportButtonProxy&&t&&t===e.exportingGroup&&(t.focusBorder?e.setFocusToElement(t,this.exportButtonProxy.innerElement):i&&i.keyboardNavigation.tabindexContainer.focus())}proxyMenuButton(){var e,t,i=this.chart,n=this.proxyProvider,o=p(i);t=(e=i).options.exporting,e=p(e),t&&!1!==t.enabled&&t.accessibility&&t.accessibility.enabled&&e&&e.element&&o&&(this.exportButtonProxy=n.addProxyElement("chartMenu",{click:o},"button",{"aria-label":i.langFormat("accessibility.exporting.menuButtonLabel",{chart:i,chartTitle:h(i)}),"aria-expanded":!1,title:i.options.lang.contextButtonTitle||null}))}createProxyGroup(){this.chart&&this.proxyProvider&&this.proxyProvider.addGroup("chartMenu")}addAccessibleContextMenuAttribs(){var e=this.chart,t=e.exportDivElements;t&&t.length&&(t.forEach(e=>{e&&("LI"!==e.tagName||e.children&&e.children.length?e.setAttribute("aria-hidden","true"):e.setAttribute("tabindex",-1))}),t=t[0]&&t[0].parentNode)&&l(t,{"aria-hidden":void 0,"aria-label":e.langFormat("accessibility.exporting.chartMenuLabel",{chart:e}),role:"list"})}getKeyboardNavigation(){const e=this.keyCodes,i=this.chart,n=this;return new o(i,{keyCodeMap:[[[e.left,e.up],function(){return n.onKbdPrevious(this)}],[[e.right,e.down],function(){return n.onKbdNext(this)}],[[e.enter,e.space],function(){return n.onKbdClick(this)}]],validate:function(){return!!i.exporting&&!1!==i.options.exporting.enabled&&!1!==i.options.exporting.accessibility.enabled},init:function(){var e=n.exportButtonProxy,t=n.chart.exportingGroup;e&&t&&i.setFocusToElement(t,e.innerElement)},terminate:function(){i.hideExportMenu()}})}onKbdPrevious(e){var t=this.chart,i=t.options.accessibility,n=e.response;let o=t.highlightedExportItemIx||0;for(;o--;)if(t.highlightExportItem(o))return n.success;return i.keyboardNavigation.wrapAround?(t.highlightLastExportItem(),n.success):n.prev}onKbdNext(e){var t=this.chart,i=t.options.accessibility,n=e.response;for(let e=(t.highlightedExportItemIx||0)+1;e<t.exportDivElements.length;++e)if(t.highlightExportItem(e))return n.success;return i.keyboardNavigation.wrapAround?(t.highlightExportItem(0),n.success):n.next}onKbdClick(e){var t=this.chart,i=t.exportDivElements[t.highlightedExportItemIx],n=p(t).element;return t.openMenu?this.fakeClickEvent(i):(this.fakeClickEvent(n),t.highlightExportItem(0)),e.response.success}}function m(){var e=p(this);e&&(e=e.element).onclick&&e.onclick(u("click"))}function b(){var e=this,t=e.exportDivElements;t&&e.exportContextMenu&&e.openMenu&&(t.forEach(e=>{e&&"highcharts-menu-item"===e.className&&e.onmouseout&&e.onmouseout(u("mouseout"))}),e.highlightedExportItemIx=0,e.exportContextMenu.hideMenu(),e.container.focus())}function x(e){var t,i=this.exportDivElements&&this.exportDivElements[e],n=this.exportDivElements&&this.exportDivElements[this.highlightedExportItemIx];return!(!i||"LI"!==i.tagName||i.children&&i.children.length||(t=!!(this.renderTo.getElementsByTagName("g")[0]||{}).focus,i.focus&&t&&i.focus(),n&&n.onmouseout&&n.onmouseout(u("mouseout")),i.onmouseover&&i.onmouseover(u("mouseover")),this.highlightedExportItemIx=e,0))}function v(){if(this.exportDivElements){let e=this.exportDivElements.length;for(;e--;)if(this.highlightExportItem(e))return!0}return!1}return(g||(g={})).compose=function y(e){var t;c(a,y)&&((t=i.prototype).hideExportMenu=b,t.highlightExportItem=x,t.highlightLastExportItem=v,t.showExportMenu=m)},g}),t(e,"Accessibility/KeyboardNavigation.js",[e["Core/Globals.js"],e["Accessibility/Components/MenuComponent.js"],e["Core/Utilities.js"],e["Accessibility/Utils/EventProvider.js"],e["Accessibility/Utils/HTMLUtilities.js"]],function(t,i,e,n,o){const{composed:s,doc:r,win:a}=t,{addEvent:l,fireEvent:c,pushUnique:h}=e,{getElement:d,simulatedEventTarget:u}=o;class p{constructor(e,t){this.currentModuleIx=NaN,this.modules=[],this.init(e,t)}init(t,e){const i=this.eventProvider=new n;this.chart=t,this.components=e,this.modules=[],this.currentModuleIx=0,this.update(),i.addEvent(this.tabindexContainer,"keydown",e=>this.onKeydown(e)),i.addEvent(this.tabindexContainer,"focus",e=>this.onFocus(e)),["mouseup","touchend"].forEach(e=>i.addEvent(r,e,e=>this.onMouseUp(e))),["mousedown","touchstart"].forEach(e=>i.addEvent(t.renderTo,e,()=>{this.isClickingChart=!0}))}update(e){const t=this.chart.options.accessibility,i=t&&t.keyboardNavigation,n=this.components;this.updateContainerTabindex(),i&&i.enabled&&e&&e.length?(this.modules=e.reduce(function(e,t){t=n[t].getKeyboardNavigation();return e.concat(t)},[]),this.updateExitAnchor()):(this.modules=[],this.currentModuleIx=0,this.removeExitAnchor())}updateExitAnchor(){var e="highcharts-end-of-chart-marker-"+this.chart.index,e=d(e);this.removeExitAnchor(),e?(this.makeElementAnExitAnchor(e),this.exitAnchor=e):this.createExitAnchor()}move(e){var t=this.modules&&this.modules[this.currentModuleIx],t=(t&&t.terminate&&t.terminate(e),this.chart.focusElement&&this.chart.focusElement.removeFocusBorder(),this.currentModuleIx+=e,this.modules&&this.modules[this.currentModuleIx]);if(t){if(t.validate&&!t.validate())return this.move(e);if(t.init)return t.init(e),!0}return this.currentModuleIx=0,this.exiting=!0,0<e?this.exitAnchor&&this.exitAnchor.focus():this.tabindexContainer.focus(),!1}onFocus(e){var t=this.chart,e=e.relatedTarget&&t.container.contains(e.relatedTarget),t=t.options.accessibility,t=t&&t.keyboardNavigation;!(t&&t.enabled)||this.exiting||this.tabbingInBackwards||this.isClickingChart||e||null!==(t=this.getFirstValidModuleIx())&&(this.currentModuleIx=t,this.modules[t].init(1)),this.keyboardReset=!1,this.exiting=!1}onMouseUp(e){var t;delete this.isClickingChart,this.keyboardReset||e.relatedTarget===u||(t=this.chart,e.target&&t.container.contains(e.target)||((e=this.modules&&this.modules[this.currentModuleIx||0])&&e.terminate&&e.terminate(),this.currentModuleIx=0),t.focusElement&&(t.focusElement.removeFocusBorder(),delete t.focusElement),this.keyboardReset=!0)}onKeydown(e){var e=e||a.event,t=this.modules&&this.modules.length&&this.modules[this.currentModuleIx];let i;var n=e.target;n&&"INPUT"===n.nodeName&&!n.classList.contains("highcharts-a11y-proxy-element")||(this.keyboardReset=!1,this.exiting=!1,t&&((n=t.run(e))===t.response.success?i=!0:n===t.response.prev?i=this.move(-1):n===t.response.next&&(i=this.move(1)),i)&&(e.preventDefault(),e.stopPropagation()))}updateContainerTabindex(){var e=this.chart.options.accessibility,e=e&&e.keyboardNavigation,e=!(e&&!1===e.enabled),t=this.chart,i=t.container;let n;n=t.renderTo.hasAttribute("tabindex")?(i.removeAttribute("tabindex"),t.renderTo):i;i=(this.tabindexContainer=n).getAttribute("tabindex");e&&!i?n.setAttribute("tabindex","0"):e||t.container.removeAttribute("tabindex")}createExitAnchor(){var e=this.chart,t=this.exitAnchor=r.createElement("div");e.renderTo.appendChild(t),this.makeElementAnExitAnchor(t)}makeElementAnExitAnchor(e){var t=this.tabindexContainer.getAttribute("tabindex")||0;e.setAttribute("class","highcharts-exit-anchor"),e.setAttribute("tabindex",t),e.setAttribute("aria-hidden",!1),this.addExitAnchorEventsToEl(e)}removeExitAnchor(){this.exitAnchor&&this.exitAnchor.parentNode&&(this.exitAnchor.parentNode.removeChild(this.exitAnchor),delete this.exitAnchor)}addExitAnchorEventsToEl(e){const i=this.chart,n=this;this.eventProvider.addEvent(e,"focus",function(e){var e=e||a.event,t=!(e.relatedTarget&&i.container.contains(e.relatedTarget)||n.exiting);i.focusElement&&delete i.focusElement,t?(n.tabbingInBackwards=!0,n.tabindexContainer.focus(),delete n.tabbingInBackwards,e.preventDefault(),n.modules&&n.modules.length&&(n.currentModuleIx=n.modules.length-1,(t=n.modules[n.currentModuleIx])&&t.validate&&!t.validate()?n.move(-1):t&&t.init(-1))):n.exiting=!1})}getFirstValidModuleIx(){var t=this.modules.length;for(let e=0;e<t;++e){var i=this.modules[e];if(!i.validate||i.validate())return e}return null}destroy(){this.removeExitAnchor(),this.eventProvider.removeAddedEvents(),this.chart.container.removeAttribute("tabindex")}}function g(){const e=this;c(this,"dismissPopupContent",{},function(){e.tooltip&&e.tooltip.hide(0),e.hideExportMenu()})}function m(e){27===(e.which||e.keyCode)&&t.charts&&t.charts.forEach(e=>{e&&e.dismissPopupContent&&e.dismissPopupContent()})}return(p||(p={})).compose=function b(e){return i.compose(e),h(s,b)&&(e.prototype.dismissPopupContent=g,l(r,"keydown",m)),e},p}),t(e,"Accessibility/Components/LegendComponent.js",[e["Core/Animation/AnimationUtilities.js"],e["Core/Globals.js"],e["Core/Legend/Legend.js"],e["Core/Utilities.js"],e["Accessibility/AccessibilityComponent.js"],e["Accessibility/KeyboardNavigationHandler.js"],e["Accessibility/Utils/ChartUtilities.js"],e["Accessibility/Utils/HTMLUtilities.js"]],function(e,t,i,n,o,s,r,a){const l=e["animObject"],{composed:c,doc:h}=t,{addEvent:d,fireEvent:u,isNumber:p,pick:g,pushUnique:m,syncTimeout:b}=n,x=r["getChartTitle"],{stripHTMLTagsFromString:v,addClass:y,removeClass:f}=a;function A(e){var t=e.legend&&e.legend.allItems,i=e.options.legend.accessibility||{},e=e.colorAxis&&e.colorAxis.some(e=>!e.dataClasses||!e.dataClasses.length);return t&&t.length&&!e&&!1!==i.enabled}function w(e,t){var i=t.legendItem||{};t.setState(e?"hover":"",!0);for(const o of["group","label","symbol"]){var n=i[o],n=n&&n.element||n;n&&u(n,e?"mouseover":"mouseout")}}class C extends o{constructor(){super(...arguments),this.highlightedLegendItemIx=NaN,this.proxyGroup=null}init(){const t=this;this.recreateProxies(),this.addEvent(i,"afterScroll",function(){this.chart===t.chart&&(t.proxyProvider.updateGroupProxyElementPositions("legend"),t.updateLegendItemProxyVisibility(),-1<t.highlightedLegendItemIx)&&this.chart.highlightLegendItem(t.highlightedLegendItemIx)}),this.addEvent(i,"afterPositionItem",function(e){this.chart===t.chart&&this.chart.renderer&&t.updateProxyPositionForItem(e.item)}),this.addEvent(i,"afterRender",function(){this.chart===t.chart&&this.chart.renderer&&t.recreateProxies()&&b(()=>t.proxyProvider.updateGroupProxyElementPositions("legend"),l(g(this.chart.renderer.globalAnimation,!0)).duration)})}updateLegendItemProxyVisibility(){const s=this.chart,r=s.legend;var e=r.allItems||[];const a=r.currentPage||1,l=r.clipHeight||0;let c;e.forEach(t=>{if(t.a11yProxyElement){var i,n=r.pages&&r.pages.length,o=t.a11yProxyElement.element;let e=!1;c=t.legendItem||{},n&&(t=c.pageIx||0,n=c.y||0,i=c.label?Math.round(c.label.getBBox().height):0,e=n+i-r.pages[t]>l||t!==a-1),e?s.styledMode?y(o,"highcharts-a11y-invisible"):o.style.visibility="hidden":(f(o,"highcharts-a11y-invisible"),o.style.visibility="")}})}onChartRender(){A(this.chart)||this.removeProxies()}highlightAdjacentLegendPage(e){var t=this.chart,i=t.legend,n=(i.currentPage||1)+e,e=i.pages||[];if(0<n&&n<=e.length){let e=0;for(const o of i.allItems)((o.legendItem||{}).pageIx||0)+1===n&&t.highlightLegendItem(e)&&(this.highlightedLegendItemIx=e),++e}}updateProxyPositionForItem(e){e.a11yProxyElement&&e.a11yProxyElement.refreshPosition()}recreateProxies(){var e=h.activeElement,t=this.proxyGroup,e=e&&t&&t.contains(e);return this.removeProxies(),!!A(this.chart)&&(this.addLegendProxyGroup(),this.proxyLegendItems(),this.updateLegendItemProxyVisibility(),this.updateLegendTitle(),e&&this.chart.highlightLegendItem(this.highlightedLegendItemIx),!0)}removeProxies(){this.proxyProvider.removeGroup("legend")}updateLegendTitle(){var e=this.chart,t=v((e.legend&&e.legend.options.title&&e.legend.options.title.text||"").replace(/<br ?\/?>/g," "),e.renderer.forExport),t=e.langFormat("accessibility.legend.legendLabel"+(t?"":"NoTitle"),{chart:e,legendTitle:t,chartTitle:x(e)});this.proxyProvider.updateGroupAttrs("legend",{"aria-label":t})}addLegendProxyGroup(){var e="all"===this.chart.options.accessibility.landmarkVerbosity?"region":null;this.proxyGroup=this.proxyProvider.addGroup("legend","ul",{"aria-label":"_placeholder_",role:e})}proxyLegendItems(){const t=this,e=(this.chart.legend||{}).allItems||[];let i;e.forEach(e=>{(i=e.legendItem||{}).label&&i.label.element&&t.proxyLegendItem(e)})}proxyLegendItem(e){var t,i,n=e.legendItem||{};n.label&&n.group&&(t=this.chart.langFormat("accessibility.legend.legendItem",{chart:this.chart,itemName:v(e.name,this.chart.renderer.forExport),item:e}),t={tabindex:-1,"aria-pressed":e.visible,"aria-label":t},i=n.group.div?n.label:n.group,e.a11yProxyElement=this.proxyProvider.addProxyElement("legend",{click:n.label,visual:i.element},"button",t))}getKeyboardNavigation(){const t=this.keyCodes,i=this,e=this.chart;return new s(e,{keyCodeMap:[[[t.left,t.right,t.up,t.down],function(e){return i.onKbdArrowKey(this,e)}],[[t.enter,t.space],function(){return i.onKbdClick(this)}],[[t.pageDown,t.pageUp],function(e){e=e===t.pageDown?1:-1;return i.highlightAdjacentLegendPage(e),this.response.success}]],validate:function(){return i.shouldHaveLegendNavigation()},init:function(){e.highlightLegendItem(0),i.highlightedLegendItemIx=0},terminate:function(){i.highlightedLegendItemIx=-1,e.legend.allItems.forEach(e=>w(!1,e))}})}onKbdArrowKey(e,t){var{keyCodes:{left:i,up:n},highlightedLegendItemIx:o,chart:s}=this,r=s.legend.allItems.length,a=s.options.accessibility.keyboardNavigation.wrapAround,i=t===i||t===n?-1:1;return s.highlightLegendItem(o+i)?this.highlightedLegendItemIx+=i:a&&1<r&&(this.highlightedLegendItemIx=0<i?0:r-1,s.highlightLegendItem(this.highlightedLegendItemIx)),e.response.success}onKbdClick(e){var t=this.chart.legend.allItems[this.highlightedLegendItemIx];return t&&t.a11yProxyElement&&t.a11yProxyElement.click(),e.response.success}shouldHaveLegendNavigation(){var e,t;return!!A(this.chart)&&(t=((e=this.chart).options.legend||{}).accessibility||{},!!(e.legend.display&&t.keyboardNavigation&&t.keyboardNavigation.enabled))}destroy(){this.removeProxies()}}function E(e){var t=this.legend.allItems,i=this.accessibility&&this.accessibility.components.legend.highlightedLegendItemIx,n=t[e],o=n?.legendItem||{};return!!n&&(p(i)&&t[i]&&w(!1,t[i]),i=this.legend,t=e,t=(i.allItems[t].legendItem||{}).pageIx,e=i.currentPage,void 0!==t&&t+1!==e&&i.scroll(1+t-e),t=o.label,e=n.a11yProxyElement&&n.a11yProxyElement.element,t&&t.element&&e&&this.setFocusToElement(t,e),w(!0,n),!0)}function T(e){var t=this.chart.options.accessibility,i=e.item;t.enabled&&i&&i.a11yProxyElement&&i.a11yProxyElement.innerElement.setAttribute("aria-pressed",e.visible?"true":"false")}return(C||(C={})).compose=function M(e,t){m(c,M)&&(e.prototype.highlightLegendItem=E,d(t,"afterColorizeItem",T))},C}),t(e,"Core/Axis/NavigatorAxisComposition.js",[e["Core/Globals.js"],e["Core/Utilities.js"]],function(e,t){const{composed:i,isTouchDevice:a}=e,{addEvent:n,correctFloat:l,defined:c,isNumber:h,pick:d,pushUnique:o}=t;function s(){this.navigatorAxis||(this.navigatorAxis=new u(this))}function r(e){var t=this,i=t.chart,n=i.options,o=n.navigator,s=t.navigatorAxis,r=i.zooming.pinchType,n=n.rangeSelector,i=i.zooming.type;t.isXAxis&&(o&&o.enabled||n&&n.enabled)&&("y"===i?e.zoomed=!1:(!a&&"xy"===i||a&&"xy"===r)&&t.options.range&&(o=s.previousZoom,c(e.newMin)?s.previousZoom=[t.min,t.max]:o&&(e.newMin=o[0],e.newMax=o[1],s.previousZoom=void 0))),"undefined"!=typeof e.zoomed&&e.preventDefault()}class u{static compose(e){o(i,this.compose)&&(e.keepProps.push("navigatorAxis"),n(e,"init",s),n(e,"zoom",r))}constructor(e){this.axis=e}destroy(){this.axis=void 0}toFixedRange(e,t,i,n){var o=this.axis,s=o.chart;let r=d(i,o.translate(e,!0,!o.horiz)),a=d(n,o.translate(t,!0,!o.horiz));e=s&&s.fixedRange,t=(o.pointRange||0)/2;return c(i)||(r=l(r+t)),c(n)||(a=l(a-t)),e&&o.dataMin&&o.dataMax&&(r=a>=o.dataMax?l(o.dataMax-e):r)<=o.dataMin&&(a=l(o.dataMin+e)),{min:r=h(r)&&h(a)?r:a=void 0,max:a}}}return u}),t(e,"Stock/Navigator/NavigatorDefaults.js",[e["Core/Color/Color.js"],e["Core/Series/SeriesRegistry.js"]],function(e,t){e=e.parse,t=t.seriesTypes;return{height:40,margin:25,maskInside:!0,handles:{width:7,height:15,symbols:["navigator-handle","navigator-handle"],enabled:!0,lineWidth:1,backgroundColor:"#f2f2f2",borderColor:"#999999"},maskFill:e("#667aff").setOpacity(.3).get(),outlineColor:"#999999",outlineWidth:1,series:{type:"undefined"==typeof t.areaspline?"line":"areaspline",fillOpacity:.05,lineWidth:1,compare:null,sonification:{enabled:!1},dataGrouping:{approximation:"average",enabled:!0,groupPixelWidth:2,firstAnchor:"firstPoint",anchor:"middle",lastAnchor:"lastPoint",units:[["millisecond",[1,2,5,10,20,25,50,100,200,500]],["second",[1,2,5,10,15,30]],["minute",[1,2,5,10,15,30]],["hour",[1,2,3,4,6,8,12]],["day",[1,2,3,4]],["week",[1,2,3]],["month",[1,3,6]],["year",null]]},dataLabels:{enabled:!1,zIndex:2},id:"highcharts-navigator-series",className:"highcharts-navigator-series",lineColor:null,marker:{enabled:!1},threshold:null},xAxis:{overscroll:0,className:"highcharts-navigator-xaxis",tickLength:0,lineWidth:0,gridLineColor:"#e6e6e6",gridLineWidth:1,tickPixelInterval:200,labels:{align:"left",style:{color:"#000000",fontSize:"0.7em",opacity:.6,textOutline:"2px contrast"},x:3,y:-4},crosshair:!1},yAxis:{className:"highcharts-navigator-yaxis",gridLineWidth:0,startOnTick:!1,endOnTick:!1,minPadding:.1,maxPadding:.1,labels:{enabled:!1},crosshair:!1,title:{text:null},tickLength:0,tickWidth:0}}}),t(e,"Stock/Navigator/NavigatorSymbols.js",[],function(){return{"navigator-handle":function(e,t,i,n,o={}){var i=o.width?o.width/2:i,s=Math.round(i/3)+.5;return[["M",-i-1,.5],["L",i,.5],["L",i,(n=o.height||n)+.5],["L",-i-1,n+.5],["L",-i-1,.5],["M",-s,4],["L",-s,n-3],["M",s-1,4],["L",s-1,n-3]]}}}),t(e,"Stock/Navigator/NavigatorComposition.js",[e["Core/Defaults.js"],e["Core/Globals.js"],e["Core/Axis/NavigatorAxisComposition.js"],e["Stock/Navigator/NavigatorDefaults.js"],e["Stock/Navigator/NavigatorSymbols.js"],e["Core/Renderer/RendererRegistry.js"],e["Core/Utilities.js"]],function(e,t,o,s,r,i,n){const a=e["defaultOptions"],{composed:l,isTouchDevice:c}=t,h=i["getRendererType"],{addEvent:d,extend:u,merge:p,pick:g,pushUnique:m}=n;let b;function x(){this.navigator&&this.navigator.setBaseSeries(null,!1)}function v(){var e,t,i,n,o,s=this.legend,r=this.navigator;r&&(e=s&&s.options,t=r.xAxis,i=r.yAxis,{scrollbarHeight:n,scrollButtonSize:o}=r,this.inverted?(r.left=r.opposite?this.chartWidth-n-r.height:this.spacing[3]+n,r.top=this.plotTop+o):(r.left=g(t.left,this.plotLeft+o),r.top=r.navigatorOptions.top||this.chartHeight-r.height-n-(this.scrollbar?.options.margin||0)-this.spacing[2]-(this.rangeSelector&&this.extraBottomMargin?this.rangeSelector.getHeight():0)-(e&&"bottom"===e.verticalAlign&&"proximate"!==e.layout&&e.enabled&&!e.floating?s.legendHeight+g(e.margin,10):0)-(this.titleOffset?this.titleOffset[2]:0)),t)&&i&&(this.inverted?t.options.left=i.options.left=r.left:t.options.top=i.options.top=r.top,t.setAxisSize(),i.setAxisSize())}function y(e){this.navigator||this.scroller||!this.options.navigator.enabled&&!this.options.scrollbar.enabled||(this.scroller=this.navigator=new b(this),g(e.redraw,!0)&&this.redraw(e.animation))}function f(){var e=this.options;(e.navigator.enabled||e.scrollbar.enabled)&&(this.scroller=this.navigator=new b(this))}function A(){var e=this.options,t=e.navigator,e=e.rangeSelector;if((t&&t.enabled||e&&e.enabled)&&(!c&&"x"===this.zooming.type||c&&"x"===this.zooming.pinchType))return!1}function w(e){var t=e.navigator;t&&e.xAxis[0]&&(e=e.xAxis[0].getExtremes(),t.render(e.min,e.max))}function C(e){var t=e.options.navigator||{},i=e.options.scrollbar||{};this.navigator||this.scroller||!t.enabled&&!i.enabled||(p(!0,this.options.navigator,t),p(!0,this.options.scrollbar,i),delete e.options.navigator,delete e.options.scrollbar)}function E(){this.chart.navigator&&!this.options.isInternal&&this.chart.navigator.setBaseSeries(null,!1)}return{compose:function T(e,t,i,n){o.compose(e),b=i,m(l,T)&&(t.prototype.callbacks.push(w),d(t,"afterAddSeries",x),d(t,"afterSetChartSize",v),d(t,"afterUpdate",y),d(t,"beforeRender",f),d(t,"beforeShowResetZoom",A),d(t,"update",C),d(n,"afterUpdate",E),u(h().prototype.symbols,r),u(a,{navigator:s}))}}}),t(e,"Core/Axis/ScrollbarAxis.js",[e["Core/Globals.js"],e["Core/Utilities.js"]],function(e,t){const n=e["composed"],{addEvent:o,defined:h,pick:s,pushUnique:r}=t;var a;{e=a=a||{};let i;function d(e){var t=s(e.options&&e.options.min,e.min),i=s(e.options&&e.options.max,e.max);return{axisMin:t,axisMax:i,scrollMin:h(e.dataMin)?Math.min(t,e.min,e.dataMin,s(e.threshold,Infinity)):t,scrollMax:h(e.dataMax)?Math.max(i,e.max,e.dataMax,s(e.threshold,-Infinity)):i}}function l(){var e=this.scrollbar,t=e&&!e.options.opposite,t=this.horiz?2:t?3:1;e&&(this.chart.scrollbarsOffsets=[0,0],this.chart.axisOffset[t]+=e.size+(e.options.margin||0))}function c(){const a=this;a.options&&a.options.scrollbar&&a.options.scrollbar.enabled&&(a.options.scrollbar.vertical=!a.horiz,a.options.startOnTick=a.options.endOnTick=!1,a.scrollbar=new i(a.chart.renderer,a.options.scrollbar,a.chart),o(a.scrollbar,"changed",function(e){var{axisMin:t,axisMax:i,scrollMin:n,scrollMax:o}=d(a),o=o-n;let s,r;h(t)&&h(i)&&(r=a.horiz&&!a.reversed||!a.horiz&&a.reversed?(s=n+o*this.to,n+o*this.from):(s=n+o*(1-this.from),n+o*(1-this.to)),this.shouldUpdateExtremes(e.DOMType)?(t="mousemove"!==e.DOMType&&"touchmove"!==e.DOMType&&void 0,a.setExtremes(r,s,!0,t,e)):this.setRange(this.from,this.to))}))}function u(){var t=this,{scrollMin:e,scrollMax:i}=d(t),n=t.scrollbar,o=t.axisTitleMargin+(t.titleOffset||0),s=t.chart.scrollbarsOffsets,r=t.options.margin||0;let a,l,c;if(n&&s){if(t.horiz)t.opposite||(s[1]+=o),n.position(t.left,t.top+t.height+2+s[1]-(t.opposite?r:0),t.width,t.height),t.opposite||(s[1]+=r),a=1;else{t.opposite&&(s[0]+=o);let e;e=n.options.opposite?t.left+t.width+2+s[0]-(t.opposite?0:r):t.opposite?0:r,n.position(e,t.top,t.width,t.height),t.opposite&&(s[0]+=r),a=0}s[a]+=n.size+(n.options.margin||0),isNaN(e)||isNaN(i)||!h(t.min)||!h(t.max)||t.min===t.max?n.setRange(0,1):(l=(t.min-e)/(i-e),c=(t.max-e)/(i-e),t.horiz&&!t.reversed||!t.horiz&&t.reversed?n.setRange(l,c):n.setRange(1-c,1-l))}}e.compose=function p(e,t){r(n,p)&&(i=t,o(e,"afterGetOffset",l),o(e,"afterInit",c),o(e,"afterRender",u))}}return a}),t(e,"Stock/Scrollbar/ScrollbarDefaults.js",[e["Core/Globals.js"]],function(e){var{}=e;return{height:10,barBorderRadius:5,buttonBorderRadius:0,buttonsEnabled:!1,liveRedraw:void 0,margin:void 0,minWidth:6,opposite:!0,step:.2,zIndex:3,barBackgroundColor:"#cccccc",barBorderWidth:0,barBorderColor:"#cccccc",buttonArrowColor:"#333333",buttonBackgroundColor:"#e6e6e6",buttonBorderColor:"#cccccc",buttonBorderWidth:1,rifleColor:"none",trackBackgroundColor:"rgba(255, 255, 255, 0.001)",trackBorderColor:"#cccccc",trackBorderRadius:5,trackBorderWidth:1}}),t(e,"Stock/Scrollbar/Scrollbar.js",[e["Core/Defaults.js"],e["Core/Globals.js"],e["Core/Axis/ScrollbarAxis.js"],e["Stock/Scrollbar/ScrollbarDefaults.js"],e["Core/Utilities.js"]],function(e,a,t,o,i){const s=e["defaultOptions"],{addEvent:l,correctFloat:d,defined:u,destroyObjectProperties:n,fireEvent:r,merge:c,pick:h,removeEvent:p}=i;class g{static compose(e){t.compose(e,g)}static swapXY(e,t){return t&&e.forEach(t=>{var i,n=t.length;for(let e=0;e<n;e+=2)"number"==typeof(i=t[e+1])&&(t[e+1]=t[e+2],t[e+2]=i)}),e}constructor(e,t,i){this._events=[],this.chartX=0,this.chartY=0,this.from=0,this.scrollbarButtons=[],this.scrollbarLeft=0,this.scrollbarStrokeWidth=1,this.scrollbarTop=0,this.size=0,this.to=0,this.trackBorderWidth=1,this.x=0,this.y=0,this.init(e,t,i)}addEvents(){var e=this.options.inverted?[1,0]:[0,1],t=this.scrollbarButtons,i=this.scrollbarGroup.element,n=this.track.element,o=this.mouseDownHandler.bind(this),s=this.mouseMoveHandler.bind(this),r=this.mouseUpHandler.bind(this),e=[[t[e[0]].element,"click",this.buttonToMinClick.bind(this)],[t[e[1]].element,"click",this.buttonToMaxClick.bind(this)],[n,"click",this.trackClick.bind(this)],[i,"mousedown",o],[i.ownerDocument,"mousemove",s],[i.ownerDocument,"mouseup",r]];a.hasTouch&&e.push([i,"touchstart",o],[i.ownerDocument,"touchmove",s],[i.ownerDocument,"touchend",r]),e.forEach(function(e){l.apply(null,e)}),this._events=e}buttonToMaxClick(e){var t=this,i=(t.to-t.from)*h(t.options.step,.2);t.updatePosition(t.from+i,t.to+i),r(t,"changed",{from:t.from,to:t.to,trigger:"scrollbar",DOMEvent:e})}buttonToMinClick(e){var t=this,i=d(t.to-t.from)*h(t.options.step,.2);t.updatePosition(d(t.from-i),d(t.to-i)),r(t,"changed",{from:t.from,to:t.to,trigger:"scrollbar",DOMEvent:e})}cursorToScrollbarPosition(e){var t=this,i=t.options,i=i.minWidth>t.calculatedWidth?i.minWidth:0;return{chartX:(e.chartX-t.x-t.xOffset)/(t.barWidth-i),chartY:(e.chartY-t.y-t.yOffset)/(t.barWidth-i)}}destroy(){const t=this,e=t.chart.scroller;t.removeEvents(),["track","scrollbarRifles","scrollbar","scrollbarGroup","group"].forEach(function(e){t[e]&&t[e].destroy&&(t[e]=t[e].destroy())}),e&&t===e.scrollbar&&(e.scrollbar=null,n(e.scrollbarButtons))}drawScrollbarButton(e){var t=this,i=t.renderer,n=t.scrollbarButtons,o=t.options,s=t.size,r=i.g().add(t.group);n.push(r),o.buttonsEnabled&&(r=i.rect().addClass("highcharts-scrollbar-button").add(r),t.chart.styledMode||r.attr({stroke:o.buttonBorderColor,"stroke-width":o.buttonBorderWidth,fill:o.buttonBackgroundColor}),r.attr(r.crisp({x:-.5,y:-.5,width:s+1,height:s+1,r:o.buttonBorderRadius},r.strokeWidth())),r=i.path(g.swapXY([["M",s/2+(e?-1:1),s/2-3],["L",s/2+(e?-1:1),s/2+3],["L",s/2+(e?2:-2),s/2]],o.vertical)).addClass("highcharts-scrollbar-arrow").add(n[e]),t.chart.styledMode||r.attr({fill:o.buttonArrowColor}))}init(e,t,i){var n=this;n.scrollbarButtons=[],n.renderer=e,n.userOptions=t,n.options=c(o,s.scrollbar,t),n.options.margin=h(n.options.margin,10),n.chart=i,n.size=h(n.options.size,n.options.height),t.enabled&&(n.render(),n.addEvents())}mouseDownHandler(e){var t=this,e=t.chart.pointer.normalize(e),e=t.cursorToScrollbarPosition(e);t.chartX=e.chartX,t.chartY=e.chartY,t.initPositions=[t.from,t.to],t.grabbedCenter=!0}mouseMoveHandler(e){var t=this,i=t.chart.pointer.normalize(e),n=t.options.vertical?"chartY":"chartX",o=t.initPositions||[];!t.grabbedCenter||e.touches&&0===e.touches[0][n]||(i=t.cursorToScrollbarPosition(i)[n]-t[n],t.hasDragged=!0,t.updatePosition(o[0]+i,o[1]+i),t.hasDragged&&r(t,"changed",{from:t.from,to:t.to,trigger:"scrollbar",DOMType:e.type,DOMEvent:e}))}mouseUpHandler(e){var t=this;t.hasDragged&&r(t,"changed",{from:t.from,to:t.to,trigger:"scrollbar",DOMType:e.type,DOMEvent:e}),t.grabbedCenter=t.hasDragged=t.chartX=t.chartY=null}position(e,t,i,n){var o=this,{buttonsEnabled:s,margin:r=0,vertical:a}=o.options,l=o.rendered?"animate":"attr";let c=n,h=0;o.group.show(),o.x=e,o.y=t+this.trackBorderWidth,o.width=i,o.height=n,o.xOffset=c,o.yOffset=h,a?(o.width=o.yOffset=i=h=o.size,o.xOffset=c=0,o.yOffset=h=s?o.size:0,o.barWidth=n-(s?2*i:0),o.x=e+=r):(o.height=n=o.size,o.xOffset=c=s?o.size:0,o.barWidth=i-(s?2*n:0),o.y=o.y+r),o.group[l]({translateX:e,translateY:o.y}),o.track[l]({width:i,height:n}),o.scrollbarButtons[1][l]({translateX:a?0:i-c,translateY:a?n-h:0})}removeEvents(){this._events.forEach(function(e){p.apply(null,e)}),this._events.length=0}render(){var e=this,t=e.renderer,i=e.options,n=e.size,o=e.chart.styledMode,s=t.g("scrollbar").attr({zIndex:i.zIndex}).hide().add(),r=(e.group=s,e.track=t.rect().addClass("highcharts-scrollbar-track").attr({r:i.trackBorderRadius||0,height:n,width:n}).add(s),o||e.track.attr({fill:i.trackBackgroundColor,stroke:i.trackBorderColor,"stroke-width":i.trackBorderWidth}),e.trackBorderWidth=e.track.strokeWidth());e.track.attr({x:-r%2/2,y:-r%2/2}),e.scrollbarGroup=t.g().add(s),e.scrollbar=t.rect().addClass("highcharts-scrollbar-thumb").attr({height:n-r,width:n-r,r:i.barBorderRadius||0}).add(e.scrollbarGroup),e.scrollbarRifles=t.path(g.swapXY([["M",-3,n/4],["L",-3,2*n/3],["M",0,n/4],["L",0,2*n/3],["M",3,n/4],["L",3,2*n/3]],i.vertical)).addClass("highcharts-scrollbar-rifles").add(e.scrollbarGroup),o||(e.scrollbar.attr({fill:i.barBackgroundColor,stroke:i.barBorderColor,"stroke-width":i.barBorderWidth}),e.scrollbarRifles.attr({stroke:i.rifleColor,"stroke-width":1})),e.scrollbarStrokeWidth=e.scrollbar.strokeWidth(),e.scrollbarGroup.translate(-e.scrollbarStrokeWidth%2/2,-e.scrollbarStrokeWidth%2/2),e.drawScrollbarButton(0),e.drawScrollbarButton(1)}setRange(i,n){var o=this,s=o.options,r=s.vertical,a=s.minWidth,l=o.barWidth,c=!this.rendered||this.hasDragged||this.chart.navigator&&this.chart.navigator.hasDragged?"attr":"animate";if(u(l)){var h=l*Math.min(n,1);let e,t;i=Math.max(i,0),e=Math.ceil(l*i),o.calculatedWidth=t=d(h-e),t<a&&(e=(l-a+t)*i,t=a);h=Math.floor(e+o.xOffset+o.yOffset),l=t/2-.5;o.from=i,o.to=n,r?(o.scrollbarGroup[c]({translateY:h}),o.scrollbar[c]({height:t}),o.scrollbarRifles[c]({translateY:l}),o.scrollbarTop=h,o.scrollbarLeft=0):(o.scrollbarGroup[c]({translateX:h}),o.scrollbar[c]({width:t}),o.scrollbarRifles[c]({translateX:l}),o.scrollbarLeft=h,o.scrollbarTop=0),t<=12?o.scrollbarRifles.hide():o.scrollbarRifles.show(),!1===s.showFull&&(i<=0&&1<=n?o.group.hide():o.group.show()),o.rendered=!0}}shouldUpdateExtremes(e){return h(this.options.liveRedraw,a.svg&&!a.isTouchDevice&&!this.chart.boosted)||"mouseup"===e||"touchend"===e||!u(e)}trackClick(e){var t=this,i=t.chart.pointer.normalize(e),n=t.to-t.from,o=t.y+t.scrollbarTop,s=t.x+t.scrollbarLeft;t.options.vertical&&i.chartY>o||!t.options.vertical&&i.chartX>s?t.updatePosition(t.from+n,t.to+n):t.updatePosition(t.from-n,t.to-n),r(t,"changed",{from:t.from,to:t.to,trigger:"scrollbar",DOMEvent:e})}update(e){this.destroy(),this.init(this.chart.renderer,c(!0,this.options,e),this.chart)}updatePosition(e,t){1<t&&(e=d(1-d(t-e)),t=1),e<0&&(t=d(t-e),e=0),this.from=e,this.to=t}}return g.defaultOptions=o,s.scrollbar=c(!0,g.defaultOptions,s.scrollbar),g}),t(e,"Stock/Navigator/Navigator.js",[e["Core/Axis/Axis.js"],e["Core/Defaults.js"],e["Core/Globals.js"],e["Core/Axis/NavigatorAxisComposition.js"],e["Stock/Navigator/NavigatorComposition.js"],e["Stock/Scrollbar/Scrollbar.js"],e["Core/Utilities.js"]],function(m,e,t,b,n,x,i){const p=e["defaultOptions"],{hasTouch:r,isTouchDevice:c}=t,{addEvent:v,clamp:w,correctFloat:C,defined:E,destroyObjectProperties:o,erase:s,extend:g,find:a,fireEvent:T,isArray:y,isNumber:M,merge:f,pick:S,removeEvent:A,splat:k}=i;function P(e,...t){t=[].filter.call(t,M);if(t.length)return Math[e].apply(0,t)}class l{static compose(e,t,i){n.compose(e,t,l,i)}constructor(e){this.scrollbarHeight=0,this.init(e)}drawHandle(e,t,i,n){var o=this,s=o.navigatorOptions.handles.height;o.handles[t][n](i?{translateX:Math.round(o.left+o.height/2),translateY:Math.round(o.top+parseInt(e,10)+.5-s)}:{translateX:Math.round(o.left+parseInt(e,10)),translateY:Math.round(o.top+o.height/2-s/2-1)})}drawOutline(e,t,i,n){var o=this,s=o.navigatorOptions.maskInside,r=o.outline.strokeWidth(),a=r/2,r=r%2/2,l=o.scrollButtonSize,c=o.size,h=o.top,d=o.height,u=h-a,p=h+d;let g=o.left,m,b;i?(m=h+t+r,t=h+e+r,b=[["M",g+d,h-l-r],["L",g+d,m],["L",g,m],["M",g,t],["L",g+d,t],["L",g+d,h+c+l]],s&&b.push(["M",g+d,m-a],["L",g+d,t+a])):(e+=(g-=l)+l-r,t+=g+l-r,b=[["M",g,u],["L",e,u],["L",e,p],["M",t,p],["L",t,u],["L",g+c+2*l,h+a]],s&&b.push(["M",e-a,u],["L",t+a,u])),o.outline[n]({d:b})}drawMasks(e,t,i,n){var o=this,s=o.left,r=o.top,a=o.height;let l,c,h,d;l=i?(h=[s,s,s],d=[r,r+e,r+t],c=[a,a,a],[e,t-e,o.size-t]):(h=[s,s+e,s+t],d=[r,r,r],c=[e,t-e,o.size-t],[a,a,a]),o.shades.forEach((e,t)=>{e[n]({x:h[t],y:d[t],width:c[t],height:l[t]})})}renderElements(){const n=this,o=n.navigatorOptions,e=o.maskInside,s=n.chart,t=s.inverted,r=s.renderer,a={cursor:t?"ns-resize":"ew-resize"},l=n.navigatorGroup=r.g("navigator").attr({zIndex:8,visibility:"hidden"}).add();if([!e,e,!e].forEach((e,t)=>{var i=r.rect().addClass("highcharts-navigator-mask"+(1===t?"-inside":"-outside")).add(l);s.styledMode||(i.attr({fill:e?o.maskFill:"rgba(0,0,0,0)"}),1===t&&i.css(a)),n.shades[t]=i}),n.outline=r.path().addClass("highcharts-navigator-outline").add(l),s.styledMode||n.outline.attr({"stroke-width":o.outlineWidth,stroke:o.outlineColor}),o.handles&&o.handles.enabled){const i=o.handles,{height:c,width:h}=i;[0,1].forEach(e=>{n.handles[e]=r.symbol(i.symbols[e],-h/2-1,0,h,c,i),s.inverted&&n.handles[e].attr({rotation:90,rotationOriginX:Math.floor(-h/2),rotationOriginY:(c+h)/2}),n.handles[e].attr({zIndex:7-e}).addClass("highcharts-navigator-handle highcharts-navigator-handle-"+["left","right"][e]).add(l),s.styledMode||n.handles[e].attr({fill:i.backgroundColor,stroke:i.borderColor,"stroke-width":i.lineWidth}).css(a)})}}update(e){(this.series||[]).forEach(e=>{e.baseSeries&&delete e.baseSeries.navigatorSeries}),this.destroy();var t=this.chart.options;f(!0,t.navigator,e),this.init(this.chart)}render(e,t,i,n){var o=this,s=o.chart,r=o.xAxis,a=r.pointRange||0,l=r.navigatorAxis.fake?s.xAxis[0]:r,c=o.navigatorEnabled,h=o.rendered,d=s.inverted,u=s.xAxis[0].minRange,p=s.xAxis[0].options.maxRange,g=o.scrollButtonSize;let m,b,x,v=o.scrollbarHeight,y,f;if(!this.hasDragged||E(i)){if(e=C(e-a/2),t=C(t+a/2),!M(e)||!M(t)){if(!h)return;i=0,n=S(r.width,l.width)}o.left=S(r.left,s.plotLeft+g+(d?s.plotWidth:0));var s=o.size=y=S(r.len,(d?s.plotHeight:s.plotWidth)-2*g),e=(m=d?v:y+2*g,i=S(i,r.toPixels(e,!0)),n=S(n,r.toPixels(t,!0)),M(i)&&Math.abs(i)!==Infinity||(i=0,n=m),r.toValue(i,!0)),t=r.toValue(n,!0),A=Math.abs(C(t-e)),u=(A<u?this.grabbedLeft?i=r.toPixels(t-u-a,!0):this.grabbedRight&&(n=r.toPixels(e+u+a,!0)):E(p)&&C(A-a)>p&&(this.grabbedLeft?i=r.toPixels(t-p-a,!0):this.grabbedRight&&(n=r.toPixels(e+p+a,!0))),o.zoomedMax=w(Math.max(i,n),0,s),o.zoomedMin=w(o.fixedWidth?o.zoomedMax-o.fixedWidth:Math.min(i,n),0,s),o.range=o.zoomedMax-o.zoomedMin,s=Math.round(o.zoomedMax),Math.round(o.zoomedMin));c&&(o.navigatorGroup.attr({visibility:"inherit"}),f=h&&!o.hasDragged?"animate":"attr",o.drawMasks(u,s,d,f),o.drawOutline(u,s,d,f),o.navigatorOptions.handles.enabled)&&(o.drawHandle(u,0,d,f),o.drawHandle(s,1,d,f)),o.scrollbar&&(d?(x=o.top-g,b=o.left-v+(c||!l.opposite?0:(l.titleOffset||0)+l.axisTitleMargin),v=y+2*g):(x=o.top+(c?o.height:-v),b=o.left-g),o.scrollbar.position(b,x,m,v),o.scrollbar.setRange(o.zoomedMin/(y||1),o.zoomedMax/(y||1))),o.rendered=!0,T(this,"afterRender")}}addMouseEvents(){const t=this,e=t.chart,i=e.container;var n,o,s=[];t.mouseMoveHandler=n=function(e){t.onMouseMove(e)},t.mouseUpHandler=o=function(e){t.onMouseUp(e)},(s=t.getPartsEvents("mousedown")).push(v(e.renderTo,"mousemove",n),v(i.ownerDocument,"mouseup",o)),r&&(s.push(v(e.renderTo,"touchmove",n),v(i.ownerDocument,"touchend",o)),s.concat(t.getPartsEvents("touchstart"))),t.eventsToUnbind=s,t.series&&t.series[0]&&s.push(v(t.series[0].xAxis,"foundExtremes",function(){e.navigator.modifyNavigatorAxisExtremes()}))}getPartsEvents(n){const o=this,s=[];return["shades","handles"].forEach(function(i){o[i].forEach(function(e,t){s.push(v(e.element,n,function(e){o[i+"Mousedown"](e,t)}))})}),s}shadesMousedown(e,t){e=this.chart.pointer.normalize(e);var i=this,n=i.chart,o=i.xAxis,s=i.zoomedMin,r=i.size,a=i.range;let l=i.left,c=e.chartX,h,d,u,p;n.inverted&&(c=e.chartY,l=i.top),1===t?(i.grabbedCenter=c,i.fixedWidth=a,i.dragOffset=c-s):(p=c-l-a/2,0===t?p=Math.max(0,p):2===t&&p+a>=r&&(p=r-a,i.reversedExtremes?(p-=a,d=i.getUnionExtremes().dataMin):h=i.getUnionExtremes().dataMax),p!==s&&(i.fixedWidth=a,u=o.navigatorAxis.toFixedRange(p,p+a,d,h),E(u.min))&&n.xAxis[0].setExtremes(Math.min(u.min,u.max),Math.max(u.min,u.max),!0,null,{trigger:"navigator"}))}handlesMousedown(e,t){e=this.chart.pointer.normalize(e);var e=this,i=e.chart,n=i.xAxis[0],o=e.reversedExtremes;0===t?(e.grabbedLeft=!0,e.otherHandlePos=e.zoomedMax,e.fixedExtreme=o?n.min:n.max):(e.grabbedRight=!0,e.otherHandlePos=e.zoomedMin,e.fixedExtreme=o?n.max:n.min),i.fixedRange=null}onMouseMove(e){const t=this,i=t.chart,n=t.navigatorSize,o=t.range,s=t.dragOffset,r=i.inverted;let a=t.left,l;e.touches&&0===e.touches[0].pageX||(e=i.pointer.normalize(e),l=e.chartX,r&&(a=t.top,l=e.chartY),t.grabbedLeft?(t.hasDragged=!0,t.render(0,0,l-a,t.otherHandlePos)):t.grabbedRight?(t.hasDragged=!0,t.render(0,0,t.otherHandlePos,l-a)):t.grabbedCenter&&(t.hasDragged=!0,l<s?l=s:l>n+s-o&&(l=n+s-o),t.render(0,0,l-s,l-s+o)),t.hasDragged&&t.scrollbar&&S(t.scrollbar.options.liveRedraw,!c&&!this.chart.boosted)&&(e.DOMType=e.type,setTimeout(function(){t.onMouseUp(e)},0)))}onMouseUp(e){var t=this,i=t.chart,n=t.xAxis,o=t.scrollbar,s=e.DOMEvent||e,r=i.inverted,a=t.rendered&&!t.hasDragged?"animate":"attr";let l,c,h,d,u,p;(!t.hasDragged||o&&o.hasDragged)&&"scrollbar"!==e.trigger||(h=t.getUnionExtremes(),t.zoomedMin===t.otherHandlePos?d=t.fixedExtreme:t.zoomedMax===t.otherHandlePos&&(u=t.fixedExtreme),t.zoomedMax===t.size&&(u=t.reversedExtremes?h.dataMin:h.dataMax),0===t.zoomedMin&&(d=t.reversedExtremes?h.dataMax:h.dataMin),p=n.navigatorAxis.toFixedRange(t.zoomedMin,t.zoomedMax,d,u),E(p.min)&&i.xAxis[0].setExtremes(Math.min(p.min,p.max),Math.max(p.min,p.max),!0,!t.hasDragged&&null,{trigger:"navigator",triggerOp:"navigator-drag",DOMEvent:s})),"mousemove"!==e.DOMType&&"touchmove"!==e.DOMType&&(t.grabbedLeft=t.grabbedRight=t.grabbedCenter=t.fixedWidth=t.fixedExtreme=t.otherHandlePos=t.hasDragged=t.dragOffset=null),t.navigatorEnabled&&M(t.zoomedMin)&&M(t.zoomedMax)&&(c=Math.round(t.zoomedMin),l=Math.round(t.zoomedMax),t.shades&&t.drawMasks(c,l,r,a),t.outline&&t.drawOutline(c,l,r,a),t.navigatorOptions.handles.enabled)&&Object.keys(t.handles).length===t.handles.length&&(t.drawHandle(c,0,r,a),t.drawHandle(l,1,r,a))}removeEvents(){this.eventsToUnbind&&(this.eventsToUnbind.forEach(function(e){e()}),this.eventsToUnbind=void 0),this.removeBaseSeriesEvents()}removeBaseSeriesEvents(){var e=this.baseSeries||[];this.navigatorEnabled&&e[0]&&(!1!==this.navigatorOptions.adaptToUpdatedData&&e.forEach(function(e){A(e,"updatedData",this.updatedDataHandler)},this),e[0].xAxis)&&A(e[0].xAxis,"foundExtremes",this.modifyBaseAxisExtremes)}init(r){const e=r.options,t=e.navigator||{},i=t.enabled,n=e.scrollbar||{},o=n.enabled,s=i&&t.height||0,a=o&&n.height||0,l=n.buttonsEnabled&&a||0,c=(this.handles=[],this.shades=[],this.chart=r,this.setBaseSeries(),this.height=s,this.scrollbarHeight=a,this.scrollButtonSize=l,this.scrollbarEnabled=o,this.navigatorEnabled=i,this.navigatorOptions=t,this.scrollbarOptions=n,this.opposite=S(t.opposite,Boolean(!i&&r.inverted)),this),h=c.baseSeries,d=r.xAxis.length,u=r.yAxis.length,p=h&&h[0]&&h[0].xAxis||r.xAxis[0]||{options:{}};var g;r.isDirtyBox=!0,c.navigatorEnabled?(c.xAxis=new m(r,f({breaks:p.options.breaks,ordinal:p.options.ordinal},t.xAxis,{id:"navigator-x-axis",yAxis:"navigator-y-axis",type:"datetime",index:d,isInternal:!0,offset:0,keepOrdinalPadding:!0,startOnTick:!1,endOnTick:!1,minPadding:0,maxPadding:0,zoomEnabled:!1},r.inverted?{offsets:[l,0,-l,0],width:s}:{offsets:[0,-l,0,l],height:s}),"xAxis"),c.yAxis=new m(r,f(t.yAxis,{id:"navigator-y-axis",alignTicks:!1,offset:0,index:u,isInternal:!0,reversed:S(t.yAxis&&t.yAxis.reversed,r.yAxis[0]&&r.yAxis[0].reversed,!1),zoomEnabled:!1},r.inverted?{width:s}:{height:s}),"yAxis"),h||t.series.data?c.updateNavigatorSeries(!1):0===r.series.length&&(c.unbindRedraw=v(r,"beforeRedraw",function(){0<r.series.length&&!c.series&&(c.setBaseSeries(),c.unbindRedraw())})),c.reversedExtremes=r.inverted&&!c.xAxis.reversed||!r.inverted&&c.xAxis.reversed,c.renderElements(),c.addMouseEvents()):(c.xAxis={chart:r,navigatorAxis:{fake:!0},translate:function(e,t){var i=r.xAxis[0],n=i.getExtremes(),o=i.len-2*l,s=P("min",i.options.min,n.dataMin),i=P("max",i.options.max,n.dataMax)-s;return t?e*i/o+s:o*(e-s)/i},toPixels:function(e){return this.translate(e)},toValue:function(e){return this.translate(e,!0)}},c.xAxis.navigatorAxis.axis=c.xAxis,c.xAxis.navigatorAxis.toFixedRange=b.prototype.toFixedRange.bind(c.xAxis.navigatorAxis)),r.options.scrollbar.enabled&&(g=f(r.options.scrollbar,{vertical:r.inverted}),!M(g.margin)&&c.navigatorEnabled&&(g.margin=r.inverted?-3:3),r.scrollbar=c.scrollbar=new x(r.renderer,g,r),v(c.scrollbar,"changed",function(e){var t=c.size,i=t*this.to,t=t*this.from;c.hasDragged=c.scrollbar.hasDragged,c.render(0,0,t,i),this.shouldUpdateExtremes(e.DOMType)&&setTimeout(function(){c.onMouseUp(e)})})),c.addBaseSeriesEvents(),c.addChartEvents()}getUnionExtremes(e){var t=this.chart.xAxis[0],i=this.xAxis,n=i.options,o=t.options;let s;return s=e&&null===t.dataMin?s:{dataMin:S(n&&n.min,P("min",o.min,t.dataMin,i.dataMin,i.min)),dataMax:S(n&&n.max,P("max",o.max,t.dataMax,i.dataMax,i.max))}}setBaseSeries(i,e){const t=this.chart,n=this.baseSeries=[];i=i||t.options&&t.options.navigator.baseSeries||(t.series.length?a(t.series,e=>!e.options.isInternal).index:0),(t.series||[]).forEach((e,t)=>{e.options.isInternal||!e.options.showInNavigator&&(t!==i&&e.options.id!==i||!1===e.options.showInNavigator)||n.push(e)}),this.xAxis&&!this.xAxis.navigatorAxis.fake&&this.updateNavigatorSeries(!0,e)}updateNavigatorSeries(e,n){const o=this,s=o.chart,r=o.baseSeries,a={enableMouseTracking:!1,index:null,linkedTo:null,group:"nav",padXAxis:!1,xAxis:"navigator-x-axis",yAxis:"navigator-y-axis",showInLegend:!1,stacking:void 0,isInternal:!0,states:{inactive:{opacity:1}}},l=o.series=(o.series||[]).filter(e=>{var t=e.baseSeries;return!(r.indexOf(t)<0&&(t&&(A(t,"updatedData",o.updatedDataHandler),delete t.navigatorSeries),e.chart&&e.destroy(),1))});let c,h,d=o.navigatorOptions.series,u;r&&r.length&&r.forEach(e=>{var t=e.navigatorSeries,i=g({color:e.color,visible:e.visible},y(d)?p.navigator.series:d);t&&!1===o.navigatorOptions.adaptToUpdatedData||(a.name="Navigator "+r.length,c=e.options||{},u=c.navigatorOptions||{},i.dataLabels=k(i.dataLabels),(h=f(c,a,i,u)).pointRange=S(i.pointRange,u.pointRange,p.plotOptions[h.type||"line"].pointRange),i=u.data||i.data,o.hasNavigatorData=o.hasNavigatorData||!!i,h.data=i||c.data&&c.data.slice(0),t&&t.options?t.update(h,n):(e.navigatorSeries=s.initSeries(h),e.navigatorSeries.baseSeries=e,l.push(e.navigatorSeries)))}),(!d.data||r&&r.length)&&!y(d)||(o.hasNavigatorData=!1,(d=k(d)).forEach((e,t)=>{a.name="Navigator "+(l.length+1),(h=f(p.navigator.series,{color:s.series[t]&&!s.series[t].options.isInternal&&s.series[t].color||s.options.colors[t]||s.options.colors[0]},a,e)).data=e.data,h.data&&(o.hasNavigatorData=!0,l.push(s.initSeries(h)))})),e&&this.addBaseSeriesEvents()}addBaseSeriesEvents(){const t=this,e=t.baseSeries||[];e[0]&&e[0].xAxis&&e[0].eventsToUnbind.push(v(e[0].xAxis,"foundExtremes",this.modifyBaseAxisExtremes)),e.forEach(e=>{e.eventsToUnbind.push(v(e,"show",function(){this.navigatorSeries&&this.navigatorSeries.setVisible(!0,!1)})),e.eventsToUnbind.push(v(e,"hide",function(){this.navigatorSeries&&this.navigatorSeries.setVisible(!1,!1)})),!1!==this.navigatorOptions.adaptToUpdatedData&&e.xAxis&&e.eventsToUnbind.push(v(e,"updatedData",this.updatedDataHandler)),e.eventsToUnbind.push(v(e,"remove",function(){this.navigatorSeries&&(s(t.series,this.navigatorSeries),E(this.navigatorSeries.options)&&this.navigatorSeries.remove(!1),delete this.navigatorSeries)}))})}getBaseSeriesMin(e){return this.baseSeries.reduce(function(e,t){return Math.min(e,t.xData&&t.xData.length?t.xData[0]:e)},e)}modifyNavigatorAxisExtremes(){var e,t=this.xAxis;"undefined"==typeof t.getExtremes||!(e=this.getUnionExtremes(!0))||e.dataMin===t.min&&e.dataMax===t.max||(t.min=e.dataMin,t.max=e.dataMax)}modifyBaseAxisExtremes(){var e=this,t=e.chart.navigator,i=e.getExtremes(),n=i.min,o=i.max,s=i.dataMin,i=i.dataMax,o=o-n,n=t.stickToMin,r=t.stickToMax,a=S(e.options.overscroll,0),l=t.series&&t.series[0],c=!!e.setExtremes;let h,d;e.eventArgs&&"rangeSelectorButton"===e.eventArgs.trigger||(n&&(d=s,h=d+o),r&&(h=i+a,n||(d=Math.max(s,h-o,t.getBaseSeriesMin(l&&l.xData?l.xData[0]:-Number.MAX_VALUE)))),c&&(n||r)&&M(d)&&(e.min=e.userMin=d,e.max=e.userMax=h)),t.stickToMin=t.stickToMax=null}updatedDataHandler(){var e=this.chart.navigator,t=this.navigatorSeries,i=e.reversedExtremes?0===Math.round(e.zoomedMin):Math.round(e.zoomedMax)>=Math.round(e.size);e.stickToMax=S(this.chart.options.navigator&&this.chart.options.navigator.stickToMax,i),e.stickToMin=e.shouldStickToMin(this,e),t&&!e.hasNavigatorData&&(t.options.pointStart=this.xData[0],t.setData(this.options.data,!1,null,!1))}shouldStickToMin(e,t){var t=t.getBaseSeriesMin(e.xData[0]),e=e.xAxis,i=e.max,n=e.min,e=e.options.range;let o=!0;return o=!(!M(i)||!M(n))&&(e&&0<i-t?i-t<e:n<=t)}addChartEvents(){this.eventsToUnbind||(this.eventsToUnbind=[]),this.eventsToUnbind.push(v(this.chart,"redraw",function(){var e=this.navigator,t=e&&(e.baseSeries&&e.baseSeries[0]&&e.baseSeries[0].xAxis||this.xAxis[0]);t&&e.render(t.min,t.max)}),v(this.chart,"getMargins",function(){let e=this,t=e.navigator,i=t.opposite?"plotTop":"marginBottom";e[i=e.inverted?t.opposite?"marginRight":"plotLeft":i]=(e[i]||0)+(t.navigatorEnabled||!e.inverted?t.height+t.scrollbarHeight:0)+t.navigatorOptions.margin}))}destroy(){this.removeEvents(),this.xAxis&&(s(this.chart.xAxis,this.xAxis),s(this.chart.axes,this.xAxis)),this.yAxis&&(s(this.chart.yAxis,this.yAxis),s(this.chart.axes,this.yAxis)),(this.series||[]).forEach(e=>{e.destroy&&e.destroy()}),["series","xAxis","yAxis","shades","outline","scrollbarTrack","scrollbarRifles","scrollbarGroup","scrollbar","navigatorGroup","rendered"].forEach(e=>{this[e]&&this[e].destroy&&this[e].destroy(),this[e]=null}),[this.handles].forEach(e=>{o(e)})}}return l}),t(e,"Accessibility/Components/NavigatorComponent.js",[e["Accessibility/AccessibilityComponent.js"],e["Accessibility/Utils/Announcer.js"],e["Accessibility/KeyboardNavigationHandler.js"],e["Stock/Navigator/Navigator.js"],e["Core/Animation/AnimationUtilities.js"],e["Core/Templating.js"],e["Core/Utilities.js"],e["Accessibility/Utils/HTMLUtilities.js"],e["Accessibility/Utils/ChartUtilities.js"]],function(e,i,r,n,t,o,s,a,l){const c=t["animObject"],h=o["format"],{clamp:d,pick:u,syncTimeout:p}=s,g=a["getFakeMouseEvent"],{getAxisRangeDescription:m,fireEventOnWrappedOrUnwrappedElement:b}=l;class x extends e{init(){const e=this.chart,t=this;this.announcer=new i(e,"polite"),this.addEvent(n,"afterRender",function(){this.chart===t.chart&&this.chart.renderer&&p(()=>{t.proxyProvider.updateGroupProxyElementPositions("navigator"),t.updateHandleValues()},c(u(this.chart.renderer.globalAnimation,!0)).duration)})}onChartUpdate(){const i=this.chart,e=i.options;if(e.navigator.accessibility?.enabled){var t=e.accessibility.landmarkVerbosity,n=e.lang.accessibility?.navigator.groupLabel;this.proxyProvider.removeGroup("navigator"),this.proxyProvider.addGroup("navigator","div",{role:"all"===t?"region":"group","aria-label":h(n,{chart:i},i)});const o=e.lang.accessibility?.navigator.handleLabel;[0,1].forEach(e=>{var t=this.getHandleByIx(e);t&&(t=this.proxyProvider.addProxyElement("navigator",{click:t},"input",{type:"range","aria-label":h(o,{handleIx:e,chart:i},i)}),this[e?"maxHandleProxy":"minHandleProxy"]=t.innerElement,t.innerElement.style.pointerEvents="none",t.innerElement.oninput=()=>this.updateNavigator())}),this.updateHandleValues()}else this.proxyProvider.removeGroup("navigator")}getNavigatorHandleNavigation(t){const i=this,n=this.chart,o=t?this.maxHandleProxy:this.minHandleProxy,s=this.keyCodes;return new r(n,{keyCodeMap:[[[s.left,s.right,s.up,s.down],function(e){return o&&(e=e===s.left||e===s.up?-1:1,o.value=""+d(parseFloat(o.value)+e,0,100),i.updateNavigator(()=>{var e=i.getHandleByIx(t);e&&n.setFocusToElement(e,o)})),this.response.success}]],init:()=>{n.setFocusToElement(this.getHandleByIx(t),o)},validate:()=>!!(this.getHandleByIx(t)&&o&&n.options.navigator.accessibility?.enabled)})}getKeyboardNavigation(){return[this.getNavigatorHandleNavigation(0),this.getNavigatorHandleNavigation(1)]}destroy(){this.updateNavigatorThrottleTimer&&clearTimeout(this.updateNavigatorThrottleTimer),this.proxyProvider.removeGroup("navigator"),this.announcer&&this.announcer.destroy()}updateHandleValues(){var e,t=this.chart.navigator;t&&this.minHandleProxy&&this.maxHandleProxy&&(e=t.size,this.minHandleProxy.value=""+Math.round(t.zoomedMin/e*100),this.maxHandleProxy.value=""+Math.round(t.zoomedMax/e*100))}getHandleByIx(e){var t=this.chart.navigator;return t&&t.handles&&t.handles[e]}updateNavigator(e){this.updateNavigatorThrottleTimer&&clearTimeout(this.updateNavigatorThrottleTimer),this.updateNavigatorThrottleTimer=setTimeout((e=>{const t=this.chart,n=t.navigator;if(n&&this.minHandleProxy&&this.maxHandleProxy){const o=t.pointer.getChartPosition(),s=parseFloat(this.minHandleProxy.value)/100*n.size,r=parseFloat(this.maxHandleProxy.value)/100*n.size;[[0,"mousedown",n.zoomedMin],[0,"mousemove",s],[0,"mouseup",s],[1,"mousedown",n.zoomedMax],[1,"mousemove",r],[1,"mouseup",r]].forEach(([e,t,i])=>{e=this.getHandleByIx(e)?.element;e&&b(e,g(t,{x:o.left+n.left+i,y:o.top+n.top},e))}),e&&e();var e=t.options.lang.accessibility?.navigator.changeAnnouncement,i=m(t.xAxis[0]);this.announcer.announce(h(e,{axisRangeDescription:i,chart:t},t))}}).bind(this,e),20)}}return x}),t(e,"Accessibility/Components/SeriesComponent/SeriesDescriber.js",[e["Accessibility/Components/AnnotationsA11y.js"],e["Accessibility/Utils/ChartUtilities.js"],e["Core/Templating.js"],e["Accessibility/Utils/HTMLUtilities.js"],e["Core/Utilities.js"]],function(e,t,i,n,o){const a=e["getPointAnnotationTexts"],{getAxisDescription:s,getSeriesFirstPointElement:l,getSeriesA11yElement:c,unhideChartElementFromAT:h}=t,{format:m,numberFormat:r}=i,{reverseChildNodes:d,stripHTMLTagsFromString:u}=n,{find:p,isNumber:g,isString:b,pick:x,defined:v}=o;function y(e){var t=e.series,i=function(e){const t=e.index;return e.series&&e.series.data&&v(t)&&p(e.series.data,function(e){return!!(e&&"undefined"!=typeof e.index&&e.index>t&&e.graphic&&e.graphic.element)})||null}(e),n=i&&i.graphic,t=n?n.parentGroup:t.graph||t.group,i=i?{x:x(e.plotX,i.plotX,0),y:x(e.plotY,i.plotY,0)}:{x:x(e.plotX,0),y:x(e.plotY,0)};i=i,(i=e.series.chart.renderer.rect(i.x,i.y,1,1)).attr({"class":"highcharts-a11y-mock-point",fill:"none",opacity:0,"fill-opacity":0,"stroke-opacity":0});if(t&&t.element)return e.graphic=i,e.hasMockGraphic=!0,i.add(t),t.element.insertBefore(i.element,n?n.element:null),i.element}function f(e){var t=e.chart.options.accessibility.series.pointDescriptionEnabledThreshold;return!!(!1!==t&&e.points&&e.points.length>=+t)}function A(e,t){var e=e.series,i=e.chart,n=i.options.accessibility.point||{},o=e.options.accessibility&&e.options.accessibility.point||{},e=e.tooltipOptions||{},i=i.options.lang;return g(t)?r(t,o.valueDecimals||n.valueDecimals||e.valueDecimals||-1,i.decimalPoint,i.accessibility.thousandsSep||i.thousandsSep):t}function w(e,t){var i=e[t];return e.chart.langFormat("accessibility.series."+t+"Description",{name:s(i),series:e})}function C(e){var t=function(e){var t=e.series,i=t.chart,n=t.options.accessibility&&t.options.accessibility.point||{},o=i.options.accessibility.point||{};if(t=t.xAxis&&t.xAxis.dateTime)return t=t.getXDateFormat(e.x||0,i.options.tooltip.dateTimeLabelFormats),n=n.dateFormatter&&n.dateFormatter(e)||o.dateFormatter&&o.dateFormatter(e)||n.dateFormat||o.dateFormat||t,i.time.dateFormat(n,e.x||0,void 0)}(e),i=(e.series.xAxis||{}).categories&&v(e.category)&&(""+e.category).replace("<br/>"," "),n=v(e.id)&&(""+e.id).indexOf("highcharts-")<0,o="x, "+e.x;return e.name||t||i||(n?e.id:o)}function E(n,e,t){const o=e||"",s=t||"",i=n.series.pointArrayMap;return i.reduce(function(e,t){t=t;var i,t=void 0!==(i=A(n,x(n[t],n.options[t])))?t+": "+o+i+s:i;return t?e+(e.length?", ":"")+t:e},"")}function T(e){var t,i,n,o=e.series,s=o.chart,r=o.options.accessibility,r=r&&r.point&&r.point.valueDescriptionFormat||s.options.accessibility.point.valueDescriptionFormat,o=x(o.xAxis&&o.xAxis.options.accessibility&&o.xAxis.options.accessibility.enabled,!s.angular&&"flowmap"!==o.type),a=o?C(e):"",l={point:e,index:v(e.index)?e.index+1:"",xDescription:a,value:(e=(a=e).series,t=e.chart.options.accessibility.point||{},i=e.chart.options.accessibility&&e.chart.options.accessibility.point||{},l=e.tooltipOptions||{},n=i.valuePrefix||t.valuePrefix||l.valuePrefix||"",i=i.valueSuffix||t.valueSuffix||l.valueSuffix||"",t=A(a,a["undefined"!=typeof a.value?"value":"y"]),a.isNull?e.chart.langFormat("accessibility.series.nullPointValue",{point:a}):e.pointArrayMap?E(a,n,i):n+t+i),separator:o?", ":""};return m(r,l,s)}function M(e){var t,i=e.series,n=1<i.chart.series.length||i.options.name,o=T(e),s=e.options&&e.options.accessibility&&e.options.accessibility.description,s=s?" "+s:"",n=n?" "+i.name+".":"",i=(t=(i=e).series.chart,(r=a(i)).length?t.langFormat("accessibility.series.pointAnnotationsDescription",{point:i,annotations:r}):""),r=i?" "+i:"";return e.accessibility=e.accessibility||{},(e.accessibility.valueDescription=o)+s+n+r}function S(a){i=a.options.accessibility||{};const l=!f(a)&&!i.exposeAsGroupOnly,e=(t=(i=a).chart.options.accessibility.keyboardNavigation.seriesNavigation,!(!i.points||!(i.points.length<+t.pointNavigationEnabledThreshold||!1===t.pointNavigationEnabledThreshold))),c=a.chart.options.accessibility.point.describeNull;var t,i;(l||e)&&a.points.forEach(e=>{var t,i,n,o,s=e.graphic&&e.graphic.element||(t=(r=(s=e).series)&&r.chart,r=r&&r.is("sunburst"),s=s.isNull,t=t&&t.options.accessibility.point.describeNull,s&&!r&&t&&y(e)),r=e.options&&e.options.accessibility&&!1===e.options.accessibility.enabled;s&&((!e.isNull||c)&&(s.setAttribute("tabindex","-1"),a.chart.styledMode||(s.style.outline="none"),l)&&!r?(t=s,i=(e=e).series,n=i.options.accessibility?.point||{},o=i.chart.options.accessibility.point||{},n=u(b(n.descriptionFormat)&&m(n.descriptionFormat,e,i.chart)||n.descriptionFormatter?.(e)||b(o.descriptionFormat)&&m(o.descriptionFormat,e,i.chart)||o.descriptionFormatter?.(e)||M(e),i.chart.renderer.forExport),t.setAttribute("role","img"),t.setAttribute("aria-label",n)):s.setAttribute("aria-hidden",!0))})}function k(t){const i=t.chart,e=i.types||[],n=(g=((p=t).options.accessibility||{}).description)&&p.chart.langFormat("accessibility.series.description",{description:g,series:p})||"",o=function(e){return i[e]&&1<i[e].length&&t[e]},s=t.index+1,r=w(t,"xAxis"),a=w(t,"yAxis"),l={seriesNumber:s,series:t,chart:i},c=1<e.length?"Combination":"",h=i.langFormat("accessibility.series.summary."+t.type+c,l)||i.langFormat("accessibility.series.summary.default"+c,l),d=(o("yAxis")?" "+a+".":"")+(o("xAxis")?" "+r+".":""),u=x(t.options.accessibility&&t.options.accessibility.descriptionFormat,i.options.accessibility.series.descriptionFormat,"");var p,g;return m(u,{seriesDescription:h,authorDescription:n?" "+n:"",axisDescription:d,series:t,chart:i,seriesNumber:s},void 0)}return{defaultPointDescriptionFormatter:M,defaultSeriesDescriptionFormatter:k,describeSeries:function(e){var t,i,n=e.chart,o=l(e),s=c(e),r=n.is3d&&n.is3d();s&&(s.lastChild!==o||r||d(s),S(e),h(n,s),r=(o=e).chart,n=(n=r.options.chart).options3d&&n.options3d.enabled,t=1<r.series.length,r=r.options.accessibility.series.describeSingleSeries,i=(o.options.accessibility||{}).exposeAsGroupOnly,n&&t||!(t||r||i||f(o))?s.removeAttribute("aria-label"):(n=s,r=(t=e).options.accessibility||{},i=t.chart.options.accessibility,o=i.landmarkVerbosity,r.exposeAsGroupOnly?n.setAttribute("role","img"):"all"===o?n.setAttribute("role","region"):n.setAttribute("role","group"),n.setAttribute("tabindex","-1"),t.chart.styledMode||(n.style.outline="none"),n.setAttribute("aria-label",u(i.series.descriptionFormatter&&i.series.descriptionFormatter(t)||k(t),t.chart.renderer.forExport))))}}}),t(e,"Accessibility/Components/SeriesComponent/NewDataAnnouncer.js",[e["Core/Globals.js"],e["Core/Utilities.js"],e["Accessibility/Utils/Announcer.js"],e["Accessibility/Utils/ChartUtilities.js"],e["Accessibility/Utils/EventProvider.js"],e["Accessibility/Components/SeriesComponent/SeriesDescriber.js"]],function(s,e,i,t,n,o){const r=s["composed"],{addEvent:a,defined:l,pushUnique:c}=e,h=t["getChartTitle"],{defaultPointDescriptionFormatter:d,defaultSeriesDescriptionFormatter:u}=o;function p(e){return e.options.accessibility.announceNewData.enabled}class g{constructor(e){this.dirty={allSeries:{}},this.lastAnnouncementTime=0,this.chart=e}init(){var e=this.chart,t=e.options.accessibility.announceNewData.interruptUser?"assertive":"polite";this.lastAnnouncementTime=0,this.dirty={allSeries:{}},this.eventProvider=new n,this.announcer=new i(e,t),this.addEventListeners()}destroy(){this.eventProvider.removeAddedEvents(),this.announcer.destroy()}addEventListeners(){const t=this,e=this.chart,i=this.eventProvider;i.addEvent(e,"afterApplyDrilldown",function(){t.lastAnnouncementTime=0}),i.addEvent(e,"afterAddSeries",function(e){t.onSeriesAdded(e.series)}),i.addEvent(e,"redraw",function(){t.announceDirtyData()})}onSeriesAdded(e){p(this.chart)&&(this.dirty.hasDirty=!0,this.dirty.allSeries[e.name+e.index]=e,this.dirty.newSeries=l(this.dirty.newSeries)?void 0:e)}announceDirtyData(){const e=this.chart,t=this;if(e.options.accessibility.announceNewData&&this.dirty.hasDirty){let e=this.dirty.newPoint;e=e&&(i=e,1===(n=i.series.data.filter(e=>i.x===e.x&&i.y===e.y)).length?n[0]:i),this.queueAnnouncement(Object.keys(this.dirty.allSeries).map(e=>t.dirty.allSeries[e]),this.dirty.newSeries,e),this.dirty={allSeries:{}}}var i,n}queueAnnouncement(e,t,i){var n,o,s=this.chart.options.accessibility.announceNewData;s.enabled&&(o=(n=+new Date)-this.lastAnnouncementTime,s=Math.max(0,s.minAnnounceInterval-o),o=function(e,t){const i=(e||[]).concat(t||[]).reduce((e,t)=>(e[t.name+t.index]=t,e),{});return Object.keys(i).map(e=>i[e])}(this.queuedAnnouncement&&this.queuedAnnouncement.series,e),e=this.buildAnnouncementMessage(o,t,i))&&(this.queuedAnnouncement&&clearTimeout(this.queuedAnnouncementTimer),this.queuedAnnouncement={time:n,message:e,series:o},this.queuedAnnouncementTimer=setTimeout(()=>{this&&this.announcer&&(this.lastAnnouncementTime=+new Date,this.announcer.announce(this.queuedAnnouncement.message),delete this.queuedAnnouncement,delete this.queuedAnnouncementTimer)},s))}buildAnnouncementMessage(e,t,i){var n=this.chart,o=n.options.accessibility.announceNewData;if(o.announcementFormatter){e=o.announcementFormatter(e,t,i);if(!1!==e)return e.length?e:null}o=s.charts&&1<s.charts.length?"Multiple":"Single",e=t?"newSeriesAnnounce"+o:i?"newPointAnnounce"+o:"newDataAnnounce",o=h(n);return n.langFormat("accessibility.announceNewData."+e,{chartTitle:o,seriesDesc:t?u(t):null,pointDesc:i?d(i):null,point:i,series:t})}}function m(e){var t=this.chart,i=this.newDataAnnouncer;i&&i.chart===t&&p(t)&&(i.dirty.newPoint=l(i.dirty.newPoint)?void 0:e.point)}function b(){var e=this.chart,t=this.newDataAnnouncer;t&&t.chart===e&&p(e)&&(t.dirty.hasDirty=!0,t.dirty.allSeries[this.name+this.index]=this)}return(g||(g={})).compose=function x(e){c(r,x)&&(a(e,"addPoint",m),a(e,"updatedData",b))},g}),t(e,"Accessibility/ProxyElement.js",[e["Core/Globals.js"],e["Core/Utilities.js"],e["Accessibility/Utils/EventProvider.js"],e["Accessibility/Utils/ChartUtilities.js"],e["Accessibility/Utils/HTMLUtilities.js"]],function(e,t,r,i,n){const a=e["doc"],{attr:o,css:s,merge:l}=t,c=i["fireEventOnWrappedOrUnwrappedElement"],{cloneMouseEvent:h,cloneTouchEvent:d,getFakeMouseEvent:u,removeElement:p}=n;class g{constructor(e,t,i="button",n,o){this.chart=e,this.target=t,this.eventProvider=new r;var i=this.innerElement=a.createElement(i),s=this.element=n?a.createElement(n):i;e.styledMode||this.hideElementVisually(i),n&&("li"!==n||e.styledMode||(s.style.listStyle="none"),s.appendChild(i),this.element=s),this.updateTarget(t,o)}click(){var e=this.getTargetPosition(),e=(e.x+=e.width/2,e.y+=e.height/2,u("click",e));c(this.target.click,e)}updateTarget(e,t){this.target=e,this.updateCSSClassName();const i=t||{};Object.keys(i).forEach(e=>{null===i[e]&&delete i[e]});t=this.getTargetAttr(e.click,"aria-label");o(this.innerElement,l(t?{"aria-label":t}:{},i)),this.eventProvider.removeAddedEvents(),this.addProxyEventsToElement(this.innerElement,e.click),this.refreshPosition()}refreshPosition(){var e=this.getTargetPosition();s(this.innerElement,{width:(e.width||1)+"px",height:(e.height||1)+"px",left:(Math.round(e.x)||0)+"px",top:(Math.round(e.y)||0)+"px"})}remove(){this.eventProvider.removeAddedEvents(),p(this.element)}updateCSSClassName(){var e=e=>-1<e.indexOf("highcharts-no-tooltip"),t=this.chart.legend,t=t.group&&t.group.div,t=e(t&&t.className||""),e=e(this.getTargetAttr(this.target.click,"class")||"");this.innerElement.className=t||e?"highcharts-a11y-proxy-element highcharts-no-tooltip":"highcharts-a11y-proxy-element"}addProxyEventsToElement(t,n){["click","touchstart","touchend","touchcancel","touchmove","mouseover","mouseenter","mouseleave","mouseout"].forEach(e=>{const i=0===e.indexOf("touch");this.eventProvider.addEvent(t,e,e=>{var t=(i?d:h)(e);n&&c(n,t),e.stopPropagation(),i||e.preventDefault()},{passive:!1})})}hideElementVisually(e){s(e,{borderWidth:0,backgroundColor:"transparent",cursor:"pointer",outline:"none",opacity:.001,filter:"alpha(opacity=1)",zIndex:999,overflow:"hidden",padding:0,margin:0,display:"block",position:"absolute","-ms-filter":"progid:DXImageTransform.Microsoft.Alpha(Opacity=1)"})}getTargetPosition(){var e,t=this.target.click,t=t.element||t,t=this.target.visual||t;return this.chart.renderTo&&t&&t.getBoundingClientRect?(t=t.getBoundingClientRect(),e=this.chart.pointer.getChartPosition(),{x:(t.left-e.left)/e.scaleX,y:(t.top-e.top)/e.scaleY,width:t.right/e.scaleX-t.left/e.scaleX,height:t.bottom/e.scaleY-t.top/e.scaleY}):{x:0,y:0,width:1,height:1}}getTargetAttr(e,t){return(e.element||e).getAttribute(t)}}return g}),t(e,"Accessibility/ProxyProvider.js",[e["Core/Globals.js"],e["Core/Utilities.js"],e["Accessibility/Utils/ChartUtilities.js"],e["Accessibility/Utils/DOMElementProvider.js"],e["Accessibility/Utils/HTMLUtilities.js"],e["Accessibility/ProxyElement.js"]],function(e,t,i,n,o,r){const s=e["doc"],{attr:a,css:l}=t,c=i["unhideChartElementFromAT"],{removeElement:h,removeChildNodes:d}=o;class u{constructor(e){this.chart=e,this.domElementProvider=new n,this.groups={},this.groupOrder=[],this.beforeChartProxyPosContainer=this.createProxyPosContainer("before"),this.afterChartProxyPosContainer=this.createProxyPosContainer("after"),this.update()}addProxyElement(e,t,i="button",n){var o,s=this.groups[e];if(s)return o="ul"===s.type||"ol"===s.type?"li":void 0,t=new r(this.chart,t,i,o,n),s.proxyContainerElement.appendChild(t.element),s.proxyElements.push(t),t;throw new Error("ProxyProvider.addProxyElement: Invalid group key "+e)}addGroup(e,t="div",i){var n=this.groups[e];if(n)return n.groupElement;n=this.domElementProvider.createElement(t);let o;return i&&i.role&&"div"!==t?(o=this.domElementProvider.createElement("div")).appendChild(n):o=n,o.className="highcharts-a11y-proxy-group highcharts-a11y-proxy-group-"+e.replace(/\W/g,"-"),this.groups[e]={proxyContainerElement:n,groupElement:o,type:t,proxyElements:[]},a(o,i||{}),"ul"===t&&n.setAttribute("role","list"),this.afterChartProxyPosContainer.appendChild(o),this.updateGroupOrder(this.groupOrder),o}updateGroupAttrs(e,t){var i=this.groups[e];if(!i)throw new Error("ProxyProvider.updateGroupAttrs: Invalid group key "+e);a(i.groupElement,t)}updateGroupOrder(e){if(this.groupOrder=e.slice(),!this.isDOMOrderGroupOrder()){var t=e.indexOf("series");const i=-1<t?e.slice(0,t):e,n=-1<t?e.slice(t+1):[];t=s.activeElement;["before","after"].forEach(e=>{const t=this["before"===e?"beforeChartProxyPosContainer":"afterChartProxyPosContainer"];e="before"===e?i:n;d(t),e.forEach(e=>{e=this.groups[e];e&&t.appendChild(e.groupElement)})}),(this.beforeChartProxyPosContainer.contains(t)||this.afterChartProxyPosContainer.contains(t))&&t&&t.focus&&t.focus()}}clearGroup(e){var t=this.groups[e];if(!t)throw new Error("ProxyProvider.clearGroup: Invalid group key "+e);d(t.proxyContainerElement)}removeGroup(e){var t=this.groups[e];t&&(h(t.groupElement),delete this.groups[e])}update(){this.updatePosContainerPositions(),this.updateGroupOrder(this.groupOrder),this.updateProxyElementPositions()}updateProxyElementPositions(){Object.keys(this.groups).forEach(this.updateGroupProxyElementPositions.bind(this))}updateGroupProxyElementPositions(e){e=this.groups[e];e&&e.proxyElements.forEach(e=>e.refreshPosition())}destroy(){this.domElementProvider.destroyCreatedElements()}createProxyPosContainer(e){var t=this.domElementProvider.createElement("div");return t.setAttribute("aria-hidden","false"),t.className="highcharts-a11y-proxy-container"+(e?"-"+e:""),l(t,{top:"0",left:"0"}),this.chart.styledMode||(t.style.whiteSpace="nowrap",t.style.position="absolute"),t}getCurrentGroupOrderInDOM(){const o=e=>{var t=Object.keys(this.groups);let i=t.length;for(;i--;){var n=t[i],o=this.groups[n];if(o&&e===o.groupElement)return n}};var e=e=>{var t=[],i=e.children;for(let e=0;e<i.length;++e){var n=o(i[e]);n&&t.push(n)}return t},t=e(this.beforeChartProxyPosContainer),e=e(this.afterChartProxyPosContainer);return t.push("series"),t.concat(e)}isDOMOrderGroupOrder(){var e=this.getCurrentGroupOrderInDOM(),t=this.groupOrder.filter(e=>"series"===e||!!this.groups[e]);let i=e.length;if(i!==t.length)return!1;for(;i--;)if(e[i]!==t[i])return!1;return!0}updatePosContainerPositions(){var e,t=this.chart;t.renderer.forExport||(e=t.renderer.box,t.container.insertBefore(this.afterChartProxyPosContainer,e.nextSibling),t.container.insertBefore(this.beforeChartProxyPosContainer,e),c(this.chart,this.afterChartProxyPosContainer),c(this.chart,this.beforeChartProxyPosContainer))}}return u}),t(e,"Stock/RangeSelector/RangeSelectorDefaults.js",[],function(){return{lang:{rangeSelectorZoom:"Zoom",rangeSelectorFrom:"",rangeSelectorTo:"→"},rangeSelector:{allButtonsEnabled:!1,buttons:void 0,buttonSpacing:5,dropdown:"responsive",enabled:void 0,verticalAlign:"top",buttonTheme:{width:28,height:18,padding:2,zIndex:7},floating:!1,x:0,y:0,height:void 0,inputBoxBorderColor:"none",inputBoxHeight:17,inputBoxWidth:void 0,inputDateFormat:"%e %b %Y",inputDateParser:void 0,inputEditDateFormat:"%Y-%m-%d",inputEnabled:!0,inputPosition:{align:"right",x:0,y:0},inputSpacing:5,selected:void 0,buttonPosition:{align:"left",x:0,y:0},inputStyle:{color:"#334eff",cursor:"pointer",fontSize:"0.8em"},labelStyle:{color:"#666666",fontSize:"0.8em"}}}}),t(e,"Stock/RangeSelector/RangeSelectorComposition.js",[e["Core/Defaults.js"],e["Core/Globals.js"],e["Stock/RangeSelector/RangeSelectorDefaults.js"],e["Core/Utilities.js"]],function(e,t,n,i){const o=e["defaultOptions"],s=t["composed"],{addEvent:a,defined:r,extend:l,find:c,isNumber:h,merge:d,pick:u,pushUnique:p}=i,g=[];let m;function b(){const e=this.range,s=e.type,t=this.max,r=this.chart.time,i=function(e,t){var i="year"===s?"FullYear":"Month",n=new r.Date(e),o=r.get(i,n);return r.set(i,n,o+t),o===r.get(i,n)&&r.set("Date",n,0),n.getTime()-e};let n,o;h(e)?(n=t-e,o=e):e&&(n=t+i(t,-(e.count||1)),this.chart)&&(this.chart.fixedRange=t-n);var a=u(this.dataMin,Number.MIN_VALUE);return(n=h(n)?n:a)<=a&&(n=a,void 0===o&&(o=i(n,e.count)),this.newMax=Math.min(n+o,u(this.dataMax,Number.MAX_VALUE))),h(t)?!h(e)&&e&&e._offsetMin&&(n+=e._offsetMin):n=void 0,n}function x(){this.options.rangeSelector&&this.options.rangeSelector.enabled&&(this.rangeSelector=new m(this))}function v(){var e=this.axes,t=this.rangeSelector;t&&(h(t.deferredYTDClick)&&(t.clickButton(t.deferredYTDClick),delete t.deferredYTDClick),e.forEach(e=>{e.updateNames(),e.setScale()}),this.getAxisMargins(),t.render(),e=t.options.verticalAlign,t.options.floating||("bottom"===e?this.extraBottomMargin=!0:"middle"!==e&&(this.extraTopMargin=!0)))}function y(t){let e,i,n,o;const s=t.rangeSelector,r=()=>{s&&(e=t.xAxis[0].getExtremes(),i=t.legend,o=s&&s.options.verticalAlign,h(e.min)&&s.render(e.min,e.max),i.display)&&"top"===o&&o===i.options.verticalAlign&&(n=d(t.spacingBox),"vertical"===i.options.layout?n.y=t.plotTop:n.y+=s.getHeight(),i.group.placed=!1,i.align(n))};s&&(c(g,e=>e[0]===t)||g.push([t,[a(t.xAxis[0],"afterSetExtremes",function(e){s&&s.render(e.min,e.max)}),a(t,"redraw",r)]]),r())}function f(){for(let e=0,t=g.length;e<t;++e){var i=g[e];if(i[0]===this)return i[1].forEach(e=>e()),void g.splice(e,1)}}function A(){var e=this.rangeSelector;e&&(e=e.getHeight(),this.extraTopMargin&&(this.plotTop+=e),this.extraBottomMargin)&&(this.marginBottom+=e)}function w(){var e=this.rangeSelector;e&&!e.options.floating&&(e.render(),"bottom"===(e=e.options.verticalAlign)?this.extraBottomMargin=!0:"middle"!==e&&(this.extraTopMargin=!0))}function C(e){var e=e.options.rangeSelector,t=this.extraBottomMargin,i=this.extraTopMargin;let n=this.rangeSelector;e&&e.enabled&&!r(n)&&this.options.rangeSelector&&(this.options.rangeSelector.enabled=!0,this.rangeSelector=n=new m(this)),this.extraBottomMargin=!1,this.extraTopMargin=!1,n&&(y(this),e=e&&e.verticalAlign||n.options&&n.options.verticalAlign,n.options.floating||("bottom"===e?this.extraBottomMargin=!0:"middle"!==e&&(this.extraTopMargin=!0)),this.extraBottomMargin===t&&this.extraTopMargin===i||(this.isDirtyBox=!0))}return{compose:function E(e,t,i){m=i,p(s,E)&&(i=t.prototype,e.prototype.minFromRange=b,a(t,"afterGetContainer",x),a(t,"beforeRender",v),a(t,"destroy",f),a(t,"getMargins",A),a(t,"render",w),a(t,"update",C),i.callbacks.push(y),l(o,{rangeSelector:n.rangeSelector}),l(o.lang,n.lang))}}}),t(e,"Stock/RangeSelector/RangeSelector.js",[e["Core/Axis/Axis.js"],e["Core/Defaults.js"],e["Core/Globals.js"],e["Stock/RangeSelector/RangeSelectorComposition.js"],e["Core/Renderer/SVG/SVGElement.js"],e["Core/Utilities.js"]],function(A,e,v,i,n,t){const y=e["defaultOptions"],{addEvent:w,createElement:f,css:C,defined:S,destroyObjectProperties:o,discardElement:s,extend:E,fireEvent:T,isNumber:k,merge:M,objectEach:r,pad:a,pick:P,pInt:l,splat:D}=t;class c{static compose(e,t){i.compose(e,t,c)}constructor(e){this.buttonOptions=c.prototype.defaultButtons,this.initialButtonGroupWidth=0,this.chart=e,this.init(e)}clickButton(e,t){var i=this,n=i.chart,o=i.buttonOptions[e],s=n.xAxis[0],r=n.scroller&&n.scroller.getUnionExtremes()||s||{},a=o.type,l=o.dataGrouping;let c=r.dataMin,h=r.dataMax,d,u=s&&Math.round(Math.min(s.max,P(h,s.max))),p,g=o._range,m,b,x,v,y,f=!0;if(null!==c&&null!==h){if(n.fixedRange=g,i.setSelected(e),l&&(this.forcedDataGrouping=!0,A.prototype.setDataGrouping.call(s||{chart:this.chart},l,!1),this.frozenStates=o.preserveDataGrouping),"month"===a||"year"===a)s?(v={range:o,max:u,chart:n,dataMin:c,dataMax:h},d=s.minFromRange.call(v),k(v.newMax)&&(u=v.newMax),f=!1):g=o;else if(g)d=Math.max(u-g,c),u=Math.min(d+g,h),f=!1;else if("ytd"===a){if(!s)return void(i.deferredYTDClick=e);void 0!==h&&void 0!==c||(c=Number.MAX_VALUE,h=Number.MIN_VALUE,n.series.forEach(e=>{e=e.xData;e&&(c=Math.min(e[0],c),h=Math.max(e[e.length-1],h))}),t=!1),y=i.getYTDExtremes(h,c,n.time.useUTC),d=m=y.min,u=y.max}else"all"===a&&s&&(n.navigator&&n.navigator.baseSeries[0]&&(n.navigator.baseSeries[0].xAxis.options.range=void 0),d=c,u=h);f&&o._offsetMin&&S(d)&&(d+=o._offsetMin),o._offsetMax&&S(u)&&(u+=o._offsetMax),this.dropdown&&(this.dropdown.selectedIndex=e+1),s?s.setExtremes(d,u,P(t,!0),void 0,{trigger:"rangeSelectorButton",rangeSelectorButton:o}):(p=D(n.options.xAxis)[0],x=p.range,p.range=g,b=p.min,p.min=m,w(n,"load",function(){p.range=x,p.min=b})),T(this,"afterBtnClick")}}setSelected(e){this.selected=this.options.selected=e}init(t){const i=this,e=t.options.rangeSelector,n=e.buttons||i.defaultButtons.slice(),o=e.selected,s=function(){var e=i.minInput,t=i.maxInput;e&&e.blur&&T(e,"blur"),t&&t.blur&&T(t,"blur")};i.chart=t,i.options=e,i.buttons=[],i.buttonOptions=n,this.eventsToUnbind=[],this.eventsToUnbind.push(w(t.container,"mousedown",s)),this.eventsToUnbind.push(w(t,"resize",s)),n.forEach(i.computeButtonRange),void 0!==o&&n[o]&&this.clickButton(o,!1),this.eventsToUnbind.push(w(t,"load",function(){t.xAxis&&t.xAxis[0]&&w(t.xAxis[0],"setExtremes",function(e){this.max-this.min!==t.fixedRange&&"rangeSelectorButton"!==e.trigger&&"updatedData"!==e.trigger&&i.forcedDataGrouping&&!i.frozenStates&&this.setDataGrouping(!1,!1)})}))}updateButtonStates(){const p=this,e=this.chart,g=this.dropdown,m=e.xAxis[0],b=Math.round(m.max-m.min),x=!m.hasVisibleSeries,t=e.scroller&&e.scroller.getUnionExtremes()||m,v=t.dataMin,y=t.dataMax,i=p.getYTDExtremes(y,v,e.time.useUTC),f=i.min,A=i.max,w=p.selected,C=p.options.allButtonsEnabled,E=p.buttons;let T=k(w),M=!1;p.buttonOptions.forEach((e,t)=>{var i=e._range,n=e.type,o=e.count||1,s=E[t],e=e._offsetMax-e._offsetMin,r=t===w,a=i>y-v,l=i<m.minRange;let c=0,h=!1,d=!1,u=i===b;r&&a&&(M=!0),("month"===n||"year"===n)&&b+36e5>=864e5*{month:28,year:365}[n]*o-e&&b-36e5<=864e5*{month:31,year:366}[n]*o+e?u=!0:"ytd"===n?(u=A-f+e===b,h=!r):"all"===n&&(u=m.max-m.min>=y-v,d=!r&&T&&u);i=!C&&!(M&&"all"===n)&&(a||l||d||x),o=M&&"all"===n||r&&u||u&&!T&&!h||r&&p.frozenStates;i?c=3:o&&(T=!0,c=2),s.state!==c&&(s.setState(c),g&&(g.options[t+1].disabled=i,2===c)&&(g.selectedIndex=t+1),0===c&&w===t?p.setSelected():(2===c&&!S(w)||M)&&p.setSelected(t))})}computeButtonRange(e){var t=e.type,i=e.count||1,n={millisecond:1,second:1e3,minute:6e4,hour:36e5,day:864e5,week:6048e5};n[t]?e._range=n[t]*i:"month"!==t&&"year"!==t||(e._range=24*{month:30,year:365}[t]*36e5*i),e._offsetMin=P(e.offsetMin,0),e._offsetMax=P(e.offsetMax,0),e._range+=e._offsetMax-e._offsetMin}getInputValue(e){var e="min"===e?this.minInput:this.maxInput,t=this.chart.options.rangeSelector,i=this.chart.time;return e?("text"===e.type&&t.inputDateParser||this.defaultInputDateParser)(e.value,i.useUTC,i):0}setInputValue(t,i){var n=this.options,o=this.chart.time,s="min"===t?this.minInput:this.maxInput,t="min"===t?this.minDateBox:this.maxDateBox;if(s){var r=s.getAttribute("data-hc-time");let e=S(r)?Number(r):void 0;S(i)&&(r=e,S(r)&&s.setAttribute("data-hc-time-previous",r),s.setAttribute("data-hc-time",i),e=i),s.value=o.dateFormat(this.inputTypeFormats[s.type]||n.inputEditDateFormat,e),t&&t.attr({text:o.dateFormat(n.inputDateFormat,e)})}}setInputExtremes(e,t,i){var n,o,e="min"===e?this.minInput:this.maxInput;e&&(n=this.inputTypeFormats[e.type],o=this.chart.time,n)&&(t=o.dateFormat(n,t),e.min!==t&&(e.min=t),t=o.dateFormat(n,i),e.max!==t)&&(e.max=t)}showInput(e){var t,i,n,o,s,r,a="min"===e?this.minDateBox:this.maxDateBox,e="min"===e?this.minInput:this.maxInput;e&&a&&this.inputGroup&&(t="text"===e.type,{translateX:i=0,translateY:n=0}=this.inputGroup,{x:a=0,width:o=0,height:s=0}=a,r=this.options["inputBoxWidth"],C(e,{width:t?o+(r?-2:20)+"px":"auto",height:s-2+"px",border:"2px solid silver"}),t&&r?C(e,{left:i+a+"px",top:n+"px"}):C(e,{left:Math.min(Math.round(a+i-(e.offsetWidth-o)/2),this.chart.chartWidth-e.offsetWidth)+"px",top:n-(e.offsetHeight-s)/2+"px"}))}hideInput(e){e="min"===e?this.minInput:this.maxInput;e&&C(e,{top:"-9999em",border:0,width:"1px",height:"1px"})}defaultInputDateParser(e,t,i){var n;let o=e.split("/").join("-").split(" ").join("T"),s=(-1===o.indexOf("T")&&(o+="T00:00"),t?o+="Z":!v.isSafari||6<(n=o).length&&(n.lastIndexOf("-")===n.length-6||n.lastIndexOf("+")===n.length-6)||(n=new Date(o).getTimezoneOffset()/60,o+=n<=0?`+${a(-n)}:00`:`-${a(n)}:00`),Date.parse(o));return k(s)||(n=e.split("-"),s=Date.UTC(l(n[0]),l(n[1])-1,l(n[2]))),i&&t&&k(s)&&(s+=i.getTimezoneOffset(s)),s}drawInput(r){const{chart:a,div:e,inputGroup:t}=this,l=this,i=a.renderer.style||{},n=a.renderer,o=a.options.rangeSelector,s=y.lang,c="min"===r;function h(){var{maxInput:e,minInput:t}=l,i=a.xAxis[0],n=a.scroller&&a.scroller.getUnionExtremes()||i,o=n.dataMin,n=n.dataMax;let s=l.getInputValue(r);s!==Number(b.getAttribute("data-hc-time-previous"))&&k(s)&&(b.setAttribute("data-hc-time-previous",s),c&&e&&k(o)?s>Number(e.getAttribute("data-hc-time"))?s=void 0:s<o&&(s=o):t&&k(n)&&(s<Number(t.getAttribute("data-hc-time"))?s=void 0:s>n&&(s=n)),void 0!==s)&&i.setExtremes(c?s:i.min,c?i.max:s,void 0,void 0,{trigger:"rangeSelectorInput"})}var d,u,p,g=s[c?"rangeSelectorFrom":"rangeSelectorTo"]||"",g=n.label(g,0).addClass("highcharts-range-label").attr({padding:g?2:0,height:g?o.inputBoxHeight:0}).add(t),m=n.label("",0).addClass("highcharts-range-input").attr({padding:2,width:o.inputBoxWidth,height:o.inputBoxHeight,"text-align":"center"}).on("click",function(){l.showInput(r),l[r+"Input"].focus()});a.styledMode||m.attr({stroke:o.inputBoxBorderColor,"stroke-width":1}),m.add(t);const b=f("input",{name:r,className:"highcharts-range-selector"},void 0,e);b.setAttribute("type",-1!==(d=o.inputDateFormat||"%e %b %Y").indexOf("%L")?"text":(u=["a","A","d","e","w","b","B","m","o","y","Y"].some(e=>-1!==d.indexOf("%"+e)),p=["H","k","I","l","M","S"].some(e=>-1!==d.indexOf("%"+e)),u&&p?"datetime-local":u?"date":p?"time":"text")),a.styledMode||(g.css(M(i,o.labelStyle)),m.css(M({color:"#333333"},i,o.inputStyle)),C(b,E({position:"absolute",border:0,boxShadow:"0 0 15px rgba(0,0,0,0.3)",width:"1px",height:"1px",padding:0,textAlign:"center",fontSize:i.fontSize,fontFamily:i.fontFamily,top:"-9999em"},o.inputStyle))),b.onfocus=()=>{l.showInput(r)};let x=!(b.onblur=()=>{b===v.doc.activeElement&&h(),l.hideInput(r),l.setInputValue(r),b.blur()});return b.onchange=()=>{x||(h(),l.hideInput(r),b.blur())},b.onkeypress=e=>{13===e.keyCode&&h()},b.onkeydown=e=>{x=!0,38!==e.keyCode&&40!==e.keyCode||h()},b.onkeyup=()=>{x=!1},{dateBox:m,input:b,label:g}}getPosition(){var e=this.chart,t=e.options.rangeSelector,e="top"===t.verticalAlign?e.plotTop-e.axisOffset[0]:0;return{buttonTop:e+t.buttonPosition.y,inputTop:e+t.inputPosition.y-10}}getYTDExtremes(e,t,i){var n=this.chart.time,o=new n.Date(e),s=n.get("FullYear",o),i=i?n.Date.UTC(s,0,1):+new n.Date(s,0,1),s=Math.max(t,i),n=o.getTime();return{max:Math.min(e||n,n),min:s}}render(e,t){const i=this.chart,n=i.renderer,o=i.container,s=i.options,r=s.rangeSelector,a=P(s.chart.style&&s.chart.style.zIndex,0)+1,l=r.inputEnabled,c=this.rendered;if(!1!==r.enabled){if(c||(this.group=n.g("range-selector-group").attr({zIndex:7}).add(),this.div=f("div",void 0,{position:"relative",height:0,zIndex:a}),this.buttonOptions.length&&this.renderButtons(),o.parentNode&&o.parentNode.insertBefore(this.div,o),l&&(this.inputGroup=n.g("input-group").add(this.group),h=this.drawInput("min"),this.minDateBox=h.dateBox,this.minLabel=h.label,this.minInput=h.input,h=this.drawInput("max"),this.maxDateBox=h.dateBox,this.maxLabel=h.label,this.maxInput=h.input)),l){this.setInputValue("min",e),this.setInputValue("max",t);var h=i.scroller&&i.scroller.getUnionExtremes()||i.xAxis[0]||{};if(S(h.dataMin)&&S(h.dataMax)&&(e=i.xAxis[0].minRange||0,this.setInputExtremes("min",h.dataMin,Math.min(h.dataMax,this.getInputValue("max"))-e),this.setInputExtremes("max",Math.max(h.dataMin,this.getInputValue("min"))+e,h.dataMax)),this.inputGroup){let i=0;[this.minLabel,this.minDateBox,this.maxLabel,this.maxDateBox].forEach(e=>{var t;e&&(t=e.getBBox()["width"],t)&&(e.attr({x:i}),i+=t+r.inputSpacing)})}}this.alignElements(),this.rendered=!0}}renderButtons(){const{buttons:s,chart:e,options:t}=this;var i=y.lang;const r=e.renderer,a=M(t.buttonTheme),l=a&&a.states,c=a.width||28,h=(delete a.width,delete a.states,this.buttonGroup=r.g("range-selector-buttons").add(this.group),this.dropdown=f("select",void 0,{position:"absolute",width:"1px",height:"1px",padding:0,border:0,top:"-9999em",cursor:"pointer",opacity:1e-4},this.div));w(h,"touchstart",()=>{h.style.fontSize="16px"}),[[v.isMS?"mouseover":"mouseenter"],[v.isMS?"mouseout":"mouseleave"],["change","click"]].forEach(([t,i])=>{w(h,t,()=>{var e=s[this.currentButtonIndex()];e&&T(e.element,i||t)})}),this.zoomText=r.label(i&&i.rangeSelectorZoom||"",0).attr({padding:t.buttonTheme.padding,height:t.buttonTheme.height,paddingLeft:0,paddingRight:0}).add(this.buttonGroup),this.chart.styledMode||(this.zoomText.css(t.labelStyle),a["stroke-width"]=P(a["stroke-width"],0)),f("option",{textContent:this.zoomText.textStr,disabled:!0},void 0,h),this.buttonOptions.forEach((n,o)=>{f("option",{textContent:n.title||n.text},void 0,h),s[o]=r.button(n.text,0,0,e=>{var t=n.events&&n.events.click;let i;!1!==(i=t?t.call(n,e):i)&&this.clickButton(o),this.isActive=!0},a,l&&l.hover,l&&l.select,l&&l.disabled).attr({"text-align":"center",width:c}).add(this.buttonGroup),n.title&&s[o].attr("title",n.title)})}alignElements(){const{buttonGroup:o,buttons:s,chart:r,group:a,inputGroup:l,options:c,zoomText:h}=this;var d=r.options;const i=d.exporting&&!1!==d.exporting.enabled&&d.navigation&&d.navigation.buttonOptions,{buttonPosition:u,inputPosition:p,verticalAlign:g}=c;d=(e,t)=>i&&this.titleCollision(r)&&"top"===g&&"right"===t.align&&t.y-e.getBBox().height-12<(i.y||0)+(i.height||0)+r.spacing[0]?-40:0;let m=r.plotLeft;if(a&&u&&p){let e=u.x-r.spacing[3];if(o){if(this.positionButtons(),!this.initialButtonGroupWidth){let i=0;h&&(i+=h.getBBox().width+5),s.forEach((e,t)=>{i+=e.width||0,t!==s.length-1&&(i+=c.buttonSpacing)}),this.initialButtonGroupWidth=i}m-=r.spacing[3],this.updateButtonStates();var b=d(o,u);this.alignButtonGroup(b),a.placed=o.placed=r.hasLoaded}let t=0;l&&(t=d(l,p),"left"===p.align?e=m:"right"===p.align&&(e=-Math.max(r.axisOffset[1],-t)),l.align({y:p.y,width:l.getBBox().width,align:p.align,x:p.x+e-2},!0,r.spacingBox),l.placed=r.hasLoaded),this.handleCollision(t),a.align({verticalAlign:g},!0,r.spacingBox);b=a.alignAttr.translateY;let i=a.getBBox().height+20,n=0;"bottom"===g&&(d=(d=r.legend&&r.legend.options)&&"bottom"===d.verticalAlign&&d.enabled&&!d.floating?r.legend.legendHeight+P(d.margin,10):0,i=i+d-20,n=b-i-(c.floating?0:c.y)-(r.titleOffset?r.titleOffset[2]:0)-10),"top"===g?(c.floating&&(n=0),r.titleOffset&&r.titleOffset[0]&&(n=r.titleOffset[0]),n+=r.margin[0]-r.spacing[0]||0):"middle"===g&&(p.y===u.y?n=b:(p.y||u.y)&&(p.y<0||u.y<0?n-=Math.min(p.y,u.y):n=b-i)),a.translate(c.x,c.y+Math.floor(n));var{minInput:d,maxInput:b,dropdown:x}=this;c.inputEnabled&&d&&b&&(d.style.marginTop=a.translateY+"px",b.style.marginTop=a.translateY+"px"),x&&(x.style.marginTop=a.translateY+"px")}}alignButtonGroup(e,t){var{chart:i,options:n,buttonGroup:o}=this,n=n["buttonPosition"],s=i.plotLeft-i.spacing[3];let r=n.x-i.spacing[3];"right"===n.align?r+=e-s:"center"===n.align&&(r-=s/2),o&&o.align({y:n.y,width:P(t,this.initialButtonGroupWidth),align:n.align,x:r},!0,i.spacingBox)}positionButtons(){var{buttons:i,chart:e,options:n,zoomText:t}=this,o=e.hasLoaded?"animate":"attr",s=n["buttonPosition"],r=e.plotLeft;let a=r;t&&"hidden"!==t.visibility&&(t[o]({x:P(r+s.x,r)}),a+=s.x+t.getBBox().width+5);for(let e=0,t=this.buttonOptions.length;e<t;++e)"hidden"!==i[e].visibility?(i[e][o]({x:a}),a+=(i[e].width||0)+n.buttonSpacing):i[e][o]({x:r})}handleCollision(o){const{chart:e,buttonGroup:s,inputGroup:r}=this,{buttonPosition:a,dropdown:t,inputPosition:l}=this.options;var i=()=>{let t=0;return this.buttons.forEach(e=>{e=e.getBBox();e.width>t&&(t=e.width)}),t},n=e=>{var t,i,n;return!(!r||!s)&&(t=r.alignAttr.translateX+r.alignOptions.x-o+r.getBBox().x+2,i=r.alignOptions.width,t<(n=s.alignAttr.translateX+s.getBBox().x)+e)&&n<t+i&&a.y<l.y+r.getBBox().height},c=()=>{r&&s&&r.attr({translateX:r.alignAttr.translateX+(e.axisOffset[1]>=-o?0:-o),translateY:r.alignAttr.translateY+s.getBBox().height+10})};if(s){if("always"===t)return this.collapseButtons(o),void(n(i())&&c());"never"===t&&this.expandButtons()}r&&s?l.align===a.align||n(this.initialButtonGroupWidth+20)?"responsive"===t&&(this.collapseButtons(o),!n(i()))||c():"responsive"===t&&this.expandButtons():s&&"responsive"===t&&(this.initialButtonGroupWidth>e.plotWidth?this.collapseButtons(o):this.expandButtons())}collapseButtons(e){const{buttons:n,buttonOptions:t,chart:o,dropdown:s,options:r,zoomText:a}=this;if(!0!==this.isCollapsed){this.isCollapsed=!0;const c=o.userOptions.rangeSelector&&o.userOptions.rangeSelector.buttonTheme||{},h=e=>({text:e?e+" ▾":"▾",width:"auto",paddingLeft:P(r.buttonTheme.paddingLeft,c.padding,8),paddingRight:P(r.buttonTheme.paddingRight,c.padding,8)});a&&a.hide();let i=!1;t.forEach((e,t)=>{t=n[t];2!==t.state?t.hide():(t.show(),t.attr(h(e.text)),i=!0)}),i||(s&&(s.selectedIndex=0),n[0].show(),n[0].attr(h(this.zoomText&&this.zoomText.textStr)));var l=r.buttonPosition["align"];this.positionButtons(),"right"!==l&&"center"!==l||this.alignButtonGroup(e,n[this.currentButtonIndex()].getBBox().width),this.showDropdown()}}expandButtons(){const{buttons:i,buttonOptions:e,options:n,zoomText:t}=this;this.hideDropdown(),!1!==this.isCollapsed&&(this.isCollapsed=!1,t&&t.show(),e.forEach((e,t)=>{t=i[t];t.show(),t.attr({text:e.text,width:n.buttonTheme.width||28,paddingLeft:P(n.buttonTheme.paddingLeft,"unset"),paddingRight:P(n.buttonTheme.paddingRight,"unset")}),t.state<2&&t.setState(0)}),this.positionButtons())}currentButtonIndex(){var e=this["dropdown"];return e&&0<e.selectedIndex?e.selectedIndex-1:0}showDropdown(){var e,{buttonGroup:t,buttons:i,chart:n,dropdown:o}=this;t&&o&&({translateX:t=0,translateY:e=0}=t,i=i[this.currentButtonIndex()].getBBox(),C(o,{left:n.plotLeft+t+"px",top:e+.5+"px",width:i.width+"px",height:i.height+"px"}),this.hasVisibleDropdown=!0)}hideDropdown(){var e=this["dropdown"];e&&(C(e,{top:"-9999em",width:"1px",height:"1px"}),this.hasVisibleDropdown=!1)}getHeight(){var e=this.options,t=this.group,i=e.inputPosition,n=e.buttonPosition,o=e.y,n=n.y,i=i.y;let s=0;if(e.height)return e.height;this.alignElements(),s=t?t.getBBox(!0).height+13+o:0;e=Math.min(i,n);return(i<0&&n<0||0<i&&0<n)&&(s+=Math.abs(e)),s}titleCollision(e){return!(e.options.title.text||e.options.subtitle.text)}update(e){var t=this.chart;M(!0,t.options.rangeSelector,e),this.destroy(),this.init(t),this.render()}destroy(){const i=this,e=i.minInput,t=i.maxInput;i.eventsToUnbind&&(i.eventsToUnbind.forEach(e=>e()),i.eventsToUnbind=void 0),o(i.buttons),e&&(e.onfocus=e.onblur=e.onchange=null),t&&(t.onfocus=t.onblur=t.onchange=null),r(i,function(e,t){e&&"chart"!==t&&(e instanceof n?e.destroy():e instanceof window.HTMLElement&&s(e)),e!==c.prototype[t]&&(i[t]=null)},this)}}return E(c.prototype,{defaultButtons:[{type:"month",count:1,text:"1m",title:"View 1 month"},{type:"month",count:3,text:"3m",title:"View 3 months"},{type:"month",count:6,text:"6m",title:"View 6 months"},{type:"ytd",text:"YTD",title:"View year to date"},{type:"year",count:1,text:"1y",title:"View 1 year"},{type:"all",text:"All",title:"View all"}],inputTypeFormats:{"datetime-local":"%Y-%m-%dT%H:%M:%S",date:"%Y-%m-%d",time:"%H:%M:%S"}}),c}),t(e,"Accessibility/Components/RangeSelectorComponent.js",[e["Accessibility/AccessibilityComponent.js"],e["Accessibility/Utils/Announcer.js"],e["Accessibility/Utils/ChartUtilities.js"],e["Core/Globals.js"],e["Accessibility/KeyboardNavigationHandler.js"],e["Stock/RangeSelector/RangeSelector.js"],e["Core/Utilities.js"]],function(e,t,i,n,o,s,r){const{unhideChartElementFromAT:a,getAxisRangeDescription:l}=i,c=n["composed"],{addEvent:h,attr:d,pushUnique:u}=r;class p extends e{init(){var e=this.chart;this.announcer=new t(e,"polite")}onChartUpdate(){const i=this.chart,n=this,o=i.rangeSelector;o&&(this.updateSelectorVisibility(),this.setDropdownAttrs(),o.buttons&&o.buttons.length&&o.buttons.forEach(e=>{n.setRangeButtonAttrs(e)}),o.maxInput)&&o.minInput&&["minInput","maxInput"].forEach(function(e,t){e=o[e];e&&(a(i,e),n.setRangeInputAttrs(e,"accessibility.rangeSelector."+(t?"max":"min")+"InputLabel"))})}updateSelectorVisibility(){const t=this.chart;var e=t.rangeSelector,i=e&&e.dropdown,n=e&&e.buttons||[];const o=e=>e.setAttribute("aria-hidden",!0);e&&e.hasVisibleDropdown&&i?(a(t,i),n.forEach(e=>o(e.element))):(i&&o(i),n.forEach(e=>a(t,e.element)))}setDropdownAttrs(){var e=this.chart,t=e.rangeSelector&&e.rangeSelector.dropdown;t&&(e=e.langFormat("accessibility.rangeSelector.dropdownLabel",{rangeTitle:e.options.lang.rangeSelectorZoom}),t.setAttribute("aria-label",e),t.setAttribute("tabindex",-1))}setRangeButtonAttrs(e){d(e.element,{tabindex:-1,role:"button"})}setRangeInputAttrs(e,t){var i=this.chart;d(e,{tabindex:-1,"aria-label":i.langFormat(t,{chart:i})})}onButtonNavKbdArrowKey(e,t){var i=e.response,n=this.keyCodes,o=this.chart,s=o.options.accessibility.keyboardNavigation.wrapAround,t=t===n.left||t===n.up?-1:1;return o.highlightRangeSelectorButton(o.highlightedRangeSelectorItemIx+t)?i.success:s?(e.init(t),i.success):i[0<t?"next":"prev"]}onButtonNavKbdClick(e){var e=e.response,t=this.chart;return 3===t.oldRangeSelectorItemState||this.fakeClickEvent(t.rangeSelector.buttons[t.highlightedRangeSelectorItemIx].element),e.success}onAfterBtnClick(){var e=this.chart,t=l(e.xAxis[0]),t=e.langFormat("accessibility.rangeSelector.clickButtonAnnouncement",{chart:e,axisRangeDescription:t});t&&this.announcer.announce(t)}onInputKbdMove(e){var t=this.chart,i=t.rangeSelector,n=t.highlightedInputRangeIx=(t.highlightedInputRangeIx||0)+e,o=1<n||n<0;if(o){if(t.accessibility)return t.accessibility.keyboardNavigation.exiting=!0,t.accessibility.keyboardNavigation.tabindexContainer.focus(),t.accessibility.keyboardNavigation.move(e)}else i&&(o=i[n?"maxDateBox":"minDateBox"],e=i[n?"maxInput":"minInput"],o)&&e&&t.setFocusToElement(o,e);return!0}onInputNavInit(e){const t=this;var i=this.chart,e=0<e?0:1,n=i.rangeSelector,o=n&&n[e?"maxDateBox":"minDateBox"],s=n&&n.minInput,n=n&&n.maxInput,r=e?n:s;if(i.highlightedInputRangeIx=e,o&&s&&n){i.setFocusToElement(o,r),this.removeInputKeydownHandler&&this.removeInputKeydownHandler();e=e=>{(e.which||e.keyCode)===this.keyCodes.tab&&t.onInputKbdMove(e.shiftKey?-1:1)&&(e.preventDefault(),e.stopPropagation())};const a=h(s,"keydown",e),l=h(n,"keydown",e);this.removeInputKeydownHandler=()=>{a(),l()}}}onInputNavTerminate(){var e=this.chart.rangeSelector||{};e.maxInput&&e.hideInput("max"),e.minInput&&e.hideInput("min"),this.removeInputKeydownHandler&&(this.removeInputKeydownHandler(),delete this.removeInputKeydownHandler)}initDropdownNav(){const n=this.chart;var e=n.rangeSelector,t=e&&e.dropdown;e&&t&&(n.setFocusToElement(e.buttonGroup,t),this.removeDropdownKeydownHandler&&this.removeDropdownKeydownHandler(),this.removeDropdownKeydownHandler=h(t,"keydown",e=>{var t=(e.which||e.keyCode)===this.keyCodes.tab,i=n.accessibility;t&&(e.preventDefault(),e.stopPropagation(),i)&&(i.keyboardNavigation.tabindexContainer.focus(),i.keyboardNavigation.move(e.shiftKey?-1:1))}))}getRangeSelectorButtonNavigation(){const i=this.chart;var e=this.keyCodes;const n=this;return new o(i,{keyCodeMap:[[[e.left,e.right,e.up,e.down],function(e){return n.onButtonNavKbdArrowKey(this,e)}],[[e.enter,e.space],function(){return n.onButtonNavKbdClick(this)}]],validate:function(){return!!(i.rangeSelector&&i.rangeSelector.buttons&&i.rangeSelector.buttons.length)},init:function(e){var t=i.rangeSelector;t&&t.hasVisibleDropdown?n.initDropdownNav():t&&(t=t.buttons.length-1,i.highlightRangeSelectorButton(0<e?0:t))},terminate:function(){n.removeDropdownKeydownHandler&&(n.removeDropdownKeydownHandler(),delete n.removeDropdownKeydownHandler)}})}getRangeSelectorInputNavigation(){const t=this.chart,i=this;return new o(t,{keyCodeMap:[],validate:function(){return e=t,Boolean(e.rangeSelector&&e.rangeSelector.inputGroup&&"hidden"!==e.rangeSelector.inputGroup.element.style.visibility&&!1!==e.options.rangeSelector.inputEnabled&&e.rangeSelector.minInput&&e.rangeSelector.maxInput);var e},init:function(e){i.onInputNavInit(e)},terminate:function(){i.onInputNavTerminate()}})}getKeyboardNavigation(){return[this.getRangeSelectorButtonNavigation(),this.getRangeSelectorInputNavigation()]}destroy(){this.removeDropdownKeydownHandler&&this.removeDropdownKeydownHandler(),this.removeInputKeydownHandler&&this.removeInputKeydownHandler(),this.announcer&&this.announcer.destroy()}}function g(e){var t=this.rangeSelector&&this.rangeSelector.buttons||[],i=this.highlightedRangeSelectorItemIx,n=this.rangeSelector&&this.rangeSelector.selected;return void 0!==i&&t[i]&&i!==n&&t[i].setState(this.oldRangeSelectorItemState||0),!!t[this.highlightedRangeSelectorItemIx=e]&&(this.setFocusToElement(t[e].box,t[e].element),e!==n&&(this.oldRangeSelectorItemState=t[e].state,t[e].setState(1)),!0)}function m(){var e=this.chart.accessibility;if(e&&e.components.rangeSelector)return e.components.rangeSelector.onAfterBtnClick()}return(p||(p={})).compose=function b(e,t){u(c,b)&&(e.prototype.highlightRangeSelectorButton=g,h(s,"afterBtnClick",m))},p}),t(e,"Accessibility/Components/SeriesComponent/ForcedMarkers.js",[e["Core/Globals.js"],e["Core/Utilities.js"]],function(e,t){const i=e["composed"],{addEvent:n,merge:s,pushUnique:o}=t;var r;function a(e){s(!0,e,{marker:{enabled:!0,states:{normal:{opacity:0}}}})}function l(e){return e.marker.states&&e.marker.states.normal&&e.marker.states.normal.opacity}function c(e){let t=e.points.length;for(;t--;){var i=e.points[t],n=i.options,o=i.hasForcedA11yMarker;delete i.hasForcedA11yMarker,n.marker&&(o=o&&0===l(n),n.marker.enabled&&!o?(o=n,s(!0,o.marker,{states:{normal:{opacity:l(o)||1}}}),i.hasForcedA11yMarker=!1):!1===n.marker.enabled&&(a(n),i.hasForcedA11yMarker=!0))}}function h(e){return e._hasPointMarkers&&e.points&&e.points.length}function d(){var e=this;e.chart.styledMode&&(e.markerGroup&&e.markerGroup[e.a11yMarkersForced?"addClass":"removeClass"]("highcharts-a11y-markers-hidden"),h(e))&&e.points.forEach(e=>{e.graphic&&(e.graphic[e.hasForcedA11yMarker?"addClass":"removeClass"]("highcharts-a11y-marker-hidden"),e.graphic[!1===e.hasForcedA11yMarker?"addClass":"removeClass"]("highcharts-a11y-marker-visible"))})}function u(e){this.resetA11yMarkerOptions=s(e.options.marker||{},this.userOptions.marker||{})}function p(){var e,t,i,n=this,o=n.options;t=(t=(e=n).chart).options.accessibility.enabled,i=!1!==(e.options.accessibility&&e.options.accessibility.enabled),t&&i&&function(e){var t=e.chart.options.accessibility;return e.points.length<t.series.pointDescriptionEnabledThreshold||!1===t.series.pointDescriptionEnabledThreshold}(e)?(o.marker&&!1===o.marker.enabled&&(n.a11yMarkersForced=!0,a(n.options)),h(n)&&c(n)):n.a11yMarkersForced&&(delete n.a11yMarkersForced,(i=(t=n).resetA11yMarkerOptions)&&(e=i.states&&i.states.normal&&i.states.normal.opacity,t.userOptions&&t.userOptions.marker&&(t.userOptions.marker.enabled=!0),t.update({marker:{enabled:i.enabled,states:{normal:{opacity:e}}}})),delete n.resetA11yMarkerOptions)}return(r||(r={})).compose=function g(e){o(i,g)&&(n(e,"afterSetOptions",u),n(e,"render",p),n(e,"afterRender",d))},r}),t(e,"Accessibility/Components/SeriesComponent/SeriesKeyboardNavigation.js",[e["Core/Series/Point.js"],e["Core/Series/Series.js"],e["Core/Series/SeriesRegistry.js"],e["Core/Globals.js"],e["Core/Utilities.js"],e["Accessibility/KeyboardNavigationHandler.js"],e["Accessibility/Utils/EventProvider.js"],e["Accessibility/Utils/ChartUtilities.js"]],function(t,o,e,i,n,s,r,a){const l=e["seriesTypes"],{composed:c,doc:h}=i,{defined:d,fireEvent:u,pushUnique:p}=n,{getPointFromXY:g,getSeriesFromName:m,scrollAxisToPoint:b}=a;function x(e){var t=e.index,i=e.series.points;let n=i.length;if(i[t]===e)return t;for(;n--;)if(i[n]===e)return n}function v(e){var t=e.chart.options.accessibility.keyboardNavigation.seriesNavigation,i=e.options.accessibility||{},n=i.keyboardNavigation;return n&&!1===n.enabled||!1===i.enabled||!1===e.options.enableMouseTracking||!e.visible||t.pointNavigationEnabledThreshold&&+t.pointNavigationEnabledThreshold<=e.points.length}function y(e){var t=e.series.chart.options.accessibility,i=e.options.accessibility&&!1===e.options.accessibility.enabled;return e.isNull&&t.keyboardNavigation.seriesNavigation.skipNullPoints||!1===e.visible||!1===e.isInside||i||v(e.series)}function f(e){var t=e.series||[],i=t.length;for(let e=0;e<i;++e)if(!v(t[e])){var n=function(e){var t=e.points||[],i=t.length;for(let e=0;e<i;++e)if(!y(t[e]))return t[e];return null}(t[e]);if(n)return n}return null}function A(e){let t=e.series.length,i=!1;for(;t--&&(e.highlightedPoint=e.series[t].points[e.series[t].points.length-1],!(i=e.series[t].highlightNextValidPoint())););return i}function w(e){delete e.highlightedPoint;e=f(e);return e&&e.highlight()}class C{constructor(e,t){this.keyCodes=t,this.chart=e}init(){const i=this,n=this.chart,e=this.eventProvider=new r;e.addEvent(o,"destroy",function(){return i.onSeriesDestroy(this)}),e.addEvent(n,"afterApplyDrilldown",function(){var e;(e=f(e=this))&&e.highlight(!1)}),e.addEvent(n,"drilldown",function(e){var e=e.point,t=e.series;i.lastDrilledDownPoint={x:e.x,y:e.y,seriesName:t?t.name:""}}),e.addEvent(n,"drillupall",function(){setTimeout(function(){i.onDrillupAll()},10)}),e.addEvent(t,"afterSetState",function(){var e=this.graphic&&this.graphic.element,t=h.activeElement,i=t&&t.getAttribute("class"),i=i&&-1<i.indexOf("highcharts-a11y-proxy-element");n.highlightedPoint===this&&t!==e&&!i&&e&&e.focus&&e.focus()})}onDrillupAll(){var e=this.lastDrilledDownPoint,t=this.chart,i=e&&m(t,e.seriesName);let n;n=(n=e&&i&&d(e.x)&&d(e.y)?g(i,e.x,e.y):n)||f(t),t.container&&t.container.focus(),n&&n.highlight&&n.highlight(!1)}getKeyboardNavigationHandler(){const t=this,i=this.keyCodes,n=this.chart,e=n.inverted;return new s(n,{keyCodeMap:[[e?[i.up,i.down]:[i.left,i.right],function(e){return t.onKbdSideways(this,e)}],[e?[i.left,i.right]:[i.up,i.down],function(e){return t.onKbdVertical(this,e)}],[[i.enter,i.space],function(e,t){var i=n.highlightedPoint;return i&&(t.point=i,u(i.series,"click",t),i.firePointEvent("click")),this.response.success}],[[i.home],function(){return w(n),this.response.success}],[[i.end],function(){return A(n),this.response.success}],[[i.pageDown,i.pageUp],function(e){return n.highlightAdjacentSeries(e===i.pageDown),this.response.success}]],init:function(){return t.onHandlerInit(this)},validate:function(){return!!f(n)},terminate:function(){return t.onHandlerTerminate()}})}onKbdSideways(e,t){var i=this.keyCodes,t=t===i.right||t===i.down;return this.attemptHighlightAdjacentPoint(e,t)}onHandlerInit(e){var t=this.chart;return t.options.accessibility.keyboardNavigation.seriesNavigation.rememberPointFocus&&t.highlightedPoint?t.highlightedPoint.highlight():w(t),e.response.success}onKbdVertical(e,t){var i=this.chart,n=this.keyCodes,t=t===n.down||t===n.right,n=i.options.accessibility.keyboardNavigation.seriesNavigation;return n.mode&&"serialize"===n.mode?this.attemptHighlightAdjacentPoint(e,t):(i[i.highlightedPoint&&i.highlightedPoint.series.keyboardMoveVertical?"highlightAdjacentPointVertical":"highlightAdjacentSeries"](t),e.response.success)}onHandlerTerminate(){var e=this.chart,t=e.options.accessibility.keyboardNavigation,i=(e.tooltip&&e.tooltip.hide(0),e.highlightedPoint&&e.highlightedPoint.series);i&&i.onMouseOut&&i.onMouseOut(),e.highlightedPoint&&e.highlightedPoint.onMouseOut&&e.highlightedPoint.onMouseOut(),t.seriesNavigation.rememberPointFocus||delete e.highlightedPoint}attemptHighlightAdjacentPoint(e,t){var i=this.chart,n=i.options.accessibility.keyboardNavigation.wrapAround;return i.highlightAdjacentPoint(t)||n&&(t?w:A)(i)?e.response.success:e.response[t?"next":"prev"]}onSeriesDestroy(e){var t=this.chart;t.highlightedPoint&&t.highlightedPoint.series===e&&(delete t.highlightedPoint,t.focusElement)&&t.focusElement.removeFocusBorder()}destroy(){this.eventProvider.removeAddedEvents()}}function E(e){var t=this,i=t.series,n=t.highlightedPoint,o=n&&x(n)||0,s=n&&n.series.points||[],r=t.series&&t.series[t.series.length-1],r=r&&r.points&&r.points[r.points.length-1];let a,l;if(!i[0]||!i[0].points)return!1;if(n){if(a=i[n.series.index+(e?1:-1)],!(l=!(l=s[o+(e?1:-1)])&&a?a.points[e?0:a.points.length-1]:l))return!1}else l=e?i[0].points[0]:r;return y(l)?(v(a=l.series)?t.highlightedPoint=e?a.points[a.points.length-1]:a.points[0]:t.highlightedPoint=l,t.highlightAdjacentPoint(e)):l.highlight()}function T(o){const s=this.highlightedPoint;let r=Infinity,a;return!(!d(s.plotX)||!d(s.plotY)||(this.series.forEach(n=>{v(n)||n.points.forEach(t=>{if(d(t.plotY)&&d(t.plotX)&&t!==s){let e=t.plotY-s.plotY;var i=Math.abs(t.plotX-s.plotX),i=Math.abs(e)*Math.abs(e)+i*i*4;n.yAxis&&n.yAxis.reversed&&(e*=-1),e<=0&&o||0<=e&&!o||i<5||y(t)||i<r&&(r=i,a=t)}})}),!a))&&a.highlight()}function M(e){var t=this,i=t.highlightedPoint,n=t.series&&t.series[t.series.length-1],o=n&&n.points&&n.points[n.points.length-1];let s,r;return t.highlightedPoint?!!(s=t.series[i.series.index+(e?-1:1)])&&!!(r=function(e,t,i,n){let o=Infinity,s,r,a,l=t.points.length;var c=e=>!(d(e.plotX)&&d(e.plotY));if(!c(e)){for(;l--;)s=t.points[l],c(s)||(a=(e.plotX-s.plotX)*(e.plotX-s.plotX)*(i||1)+(e.plotY-s.plotY)*(e.plotY-s.plotY)*(n||1))<o&&(o=a,r=l);return d(r)?t.points[r]:void 0}}(i,s,4))&&(v(s)?(r.highlight(),t.highlightAdjacentSeries(e)||(i.highlight(),!1)):(r.highlight(),r.series.highlightNextValidPoint())):(s=e?t.series&&t.series[0]:n,!!(r=e?s&&s.points&&s.points[0]:o)&&r.highlight())}function S(e=!0){var t=this.series.chart,i=t.tooltip?.label?.element,e=(!this.isNull&&e?this.onMouseOver():t.tooltip&&t.tooltip.hide(0),b(this),this.graphic&&(t.setFocusToElement(this.graphic),!e)&&t.focusElement&&t.focusElement.removeFocusBorder(),t.highlightedPoint=this,i?.getBoundingClientRect().top);return i&&e&&e<0&&(t=window.scrollY,window.scrollTo({behavior:"smooth",top:t+e})),this}function k(){var t=this.chart.highlightedPoint,t=(t&&t.series)===this?x(t):0,i=this.points,n=i.length;if(i&&n){for(let e=t;e<n;++e)if(!y(i[e]))return i[e].highlight();for(let e=t;0<=e;--e)if(!y(i[e]))return i[e].highlight()}return!1}return(C||(C={})).compose=function P(e,t,i){p(c,P)&&(e=e.prototype,t=t.prototype,i=i.prototype,e.highlightAdjacentPoint=E,e.highlightAdjacentPointVertical=T,e.highlightAdjacentSeries=M,t.highlight=S,i.keyboardMoveVertical=!0,["column","gantt","pie"].forEach(e=>{l[e]&&(l[e].prototype.keyboardMoveVertical=!1)}),i.highlightNextValidPoint=k)},C}),t(e,"Accessibility/Components/SeriesComponent/SeriesComponent.js",[e["Accessibility/AccessibilityComponent.js"],e["Accessibility/Utils/ChartUtilities.js"],e["Accessibility/Components/SeriesComponent/ForcedMarkers.js"],e["Accessibility/Components/SeriesComponent/NewDataAnnouncer.js"],e["Accessibility/Components/SeriesComponent/SeriesDescriber.js"],e["Accessibility/Components/SeriesComponent/SeriesKeyboardNavigation.js"]],function(e,t,n,o,i,s){const r=t["hideSeriesFromAT"],a=i["describeSeries"];class l extends e{static compose(e,t,i){o.compose(i),n.compose(i),s.compose(e,t,i)}init(){this.newDataAnnouncer=new o(this.chart),this.newDataAnnouncer.init(),this.keyboardNavigation=new s(this.chart,this.keyCodes),this.keyboardNavigation.init(),this.hideTooltipFromATWhenShown(),this.hideSeriesLabelsFromATWhenShown()}hideTooltipFromATWhenShown(){const e=this;this.chart.tooltip&&this.addEvent(this.chart.tooltip.constructor,"refresh",function(){this.chart===e.chart&&this.label&&this.label.element&&this.label.element.setAttribute("aria-hidden",!0)})}hideSeriesLabelsFromATWhenShown(){this.addEvent(this.chart,"afterDrawSeriesLabels",function(){this.series.forEach(function(e){e.labelBySeries&&e.labelBySeries.attr("aria-hidden",!0)})})}onChartRender(){this.chart.series.forEach(function(e){(!1!==(e.options.accessibility&&e.options.accessibility.enabled)&&e.visible&&0!==e.data.length?a:r)(e)})}getKeyboardNavigation(){return this.keyboardNavigation.getKeyboardNavigationHandler()}destroy(){this.newDataAnnouncer.destroy(),this.keyboardNavigation.destroy()}}return l}),t(e,"Accessibility/Components/ZoomComponent.js",[e["Accessibility/AccessibilityComponent.js"],e["Accessibility/Utils/ChartUtilities.js"],e["Accessibility/Utils/HTMLUtilities.js"],e["Accessibility/KeyboardNavigationHandler.js"],e["Core/Utilities.js"]],function(e,t,i,r,n){const o=t["unhideChartElementFromAT"],d=i["getFakeMouseEvent"],{attr:s,pick:a}=n;class l extends e{constructor(){super(...arguments),this.focusedMapNavButtonIx=-1}init(){const t=this,i=this.chart;this.proxyProvider.addGroup("zoom","div"),["afterShowResetZoom","afterApplyDrilldown","drillupall"].forEach(e=>{t.addEvent(i,e,function(){t.updateProxyOverlays()})})}onChartUpdate(){const i=this.chart,n=this;i.mapNavigation&&i.mapNavigation.navButtons.forEach((e,t)=>{o(i,e.element),n.setMapNavButtonAttrs(e.element,"accessibility.zoom.mapZoom"+(t?"Out":"In"))})}setMapNavButtonAttrs(e,t){var i=this.chart,t=i.langFormat(t,{chart:i});s(e,{tabindex:-1,role:"button","aria-label":t})}onChartRender(){this.updateProxyOverlays()}updateProxyOverlays(){var e,t=this.chart;this.proxyProvider.clearGroup("zoom"),t.resetZoomButton&&this.createZoomProxyButton(t.resetZoomButton,"resetZoomProxyButton",t.langFormat("accessibility.zoom.resetZoomButton",{chart:t})),t.drillUpButton&&t.breadcrumbs&&t.breadcrumbs.list&&(e=t.breadcrumbs.list[t.breadcrumbs.list.length-1],this.createZoomProxyButton(t.drillUpButton,"drillUpProxyButton",t.langFormat("accessibility.drillUpButton",{chart:t,buttonText:t.breadcrumbs.getButtonText(e)})))}createZoomProxyButton(e,t,i){this[t]=this.proxyProvider.addProxyElement("zoom",{click:e},"button",{"aria-label":i,tabindex:-1})}getMapZoomNavigation(){const e=this.keyCodes,t=this.chart,i=this;return new r(t,{keyCodeMap:[[[e.up,e.down,e.left,e.right],function(e){return i.onMapKbdArrow(this,e)}],[[e.tab],function(e,t){return i.onMapKbdTab(this,t)}],[[e.space,e.enter],function(){return i.onMapKbdClick(this)}]],validate:function(){return!!((e=t).mapView&&e.mapNavigation&&e.mapNavigation.navButtons.length);var e},init:function(e){return i.onMapNavInit(e)}})}onMapKbdArrow(e,t){const i=this.chart,n=this.keyCodes,o=i.container,s=t===n.up||t===n.down,r=t===n.left||t===n.up?1:-1,a=(s?i.plotHeight:i.plotWidth)/10*r,l=10*Math.random(),c={x:o.offsetLeft+i.plotLeft+i.plotWidth/2+l,y:o.offsetTop+i.plotTop+i.plotHeight/2+l},h=s?{x:c.x,y:c.y+a}:{x:c.x+a,y:c.y};return[d("mousedown",c),d("mousemove",h),d("mouseup",h)].forEach(e=>o.dispatchEvent(e)),e.response.success}onMapKbdTab(e,t){var i=this.chart,e=e.response,t=t.shiftKey,n=t&&!this.focusedMapNavButtonIx||!t&&this.focusedMapNavButtonIx;if(i.mapNavigation.navButtons[this.focusedMapNavButtonIx].setState(0),n)return i.mapView&&i.mapView.zoomBy(),e[t?"prev":"next"];this.focusedMapNavButtonIx+=t?-1:1;n=i.mapNavigation.navButtons[this.focusedMapNavButtonIx];return i.setFocusToElement(n.box,n.element),n.setState(2),e.success}onMapKbdClick(e){var t=this.chart.mapNavigation.navButtons[this.focusedMapNavButtonIx].element;return this.fakeClickEvent(t),e.response.success}onMapNavInit(e){var t=this.chart,i=t.mapNavigation.navButtons[0],n=t.mapNavigation.navButtons[1],i=0<e?i:n;t.setFocusToElement(i.box,i.element),i.setState(2),this.focusedMapNavButtonIx=0<e?0:1}simpleButtonNavigation(e,t,i){const n=this.keyCodes,o=this,s=this.chart;return new r(s,{keyCodeMap:[[[n.tab,n.up,n.down,n.left,n.right],function(e,t){t=e===n.tab&&t.shiftKey||e===n.left||e===n.up;return this.response[t?"prev":"next"]}],[[n.space,n.enter],function(){var e=i(this,s);return a(e,this.response.success)}]],validate:function(){return s[e]&&s[e].box&&o[t].innerElement},init:function(){s.setFocusToElement(s[e].box,o[t].innerElement)}})}getKeyboardNavigation(){return[this.simpleButtonNavigation("resetZoomButton","resetZoomProxyButton",function(e,t){t.zoomOut()}),this.simpleButtonNavigation("drillUpButton","drillUpProxyButton",function(e,t){return t.drillUp(),e.response.prev}),this.getMapZoomNavigation()]}}return l}),t(e,"Accessibility/HighContrastMode.js",[e["Core/Globals.js"]],function(e){const{doc:i,isMS:n,win:o}=e;return{isHighContrastModeActive:function(){var e,t=/(Edg)/.test(o.navigator.userAgent);return o.matchMedia&&t?o.matchMedia("(-ms-high-contrast: active)").matches:n&&o.getComputedStyle?((t=i.createElement("div")).style.backgroundImage="url(data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==)",i.body.appendChild(t),e=(t.currentStyle||o.getComputedStyle(t)).backgroundImage,i.body.removeChild(t),"none"===e):o.matchMedia&&o.matchMedia("(forced-colors: active)").matches},setHighContrastTheme:function(e){e.highContrastModeActive=!0;const i=e.options.accessibility.highContrastTheme;e.update(i,!1),e.series.forEach(function(e){const t=i.plotOptions[e.type]||{};e.update({color:t.color||"windowText",colors:[t.color||"windowText"],borderColor:t.borderColor||"window"}),e.points.forEach(function(e){e.options&&e.options.color&&e.update({color:t.color||"windowText",borderColor:t.borderColor||"window"},!1)})}),e.redraw()}}}),t(e,"Accessibility/HighContrastTheme.js",[],function(){return{chart:{backgroundColor:"window"},title:{style:{color:"windowText"}},subtitle:{style:{color:"windowText"}},colorAxis:{minColor:"windowText",maxColor:"windowText",stops:[]},colors:["windowText"],xAxis:{gridLineColor:"windowText",labels:{style:{color:"windowText"}},lineColor:"windowText",minorGridLineColor:"windowText",tickColor:"windowText",title:{style:{color:"windowText"}}},yAxis:{gridLineColor:"windowText",labels:{style:{color:"windowText"}},lineColor:"windowText",minorGridLineColor:"windowText",tickColor:"windowText",title:{style:{color:"windowText"}}},tooltip:{backgroundColor:"window",borderColor:"windowText",style:{color:"windowText"}},plotOptions:{series:{lineColor:"windowText",fillColor:"window",borderColor:"windowText",edgeColor:"windowText",borderWidth:1,dataLabels:{connectorColor:"windowText",color:"windowText",style:{color:"windowText",textOutline:"none"}},marker:{lineColor:"windowText",fillColor:"windowText"}},pie:{color:"window",colors:["window"],borderColor:"windowText",borderWidth:1},boxplot:{fillColor:"window"},candlestick:{lineColor:"windowText",fillColor:"window"},errorbar:{fillColor:"window"}},legend:{backgroundColor:"window",itemStyle:{color:"windowText"},itemHoverStyle:{color:"windowText"},itemHiddenStyle:{color:"#555"},title:{style:{color:"windowText"}}},credits:{style:{color:"windowText"}},drilldown:{activeAxisLabelStyle:{color:"windowText"},activeDataLabelStyle:{color:"windowText"}},navigation:{buttonOptions:{symbolStroke:"windowText",theme:{fill:"window"}}},rangeSelector:{buttonTheme:{fill:"window",stroke:"windowText",style:{color:"windowText"},states:{hover:{fill:"window",stroke:"windowText",style:{color:"windowText"}},select:{fill:"#444",stroke:"windowText",style:{color:"windowText"}}}},inputBoxBorderColor:"windowText",inputStyle:{backgroundColor:"window",color:"windowText"},labelStyle:{color:"windowText"}},navigator:{handles:{backgroundColor:"window",borderColor:"windowText"},outlineColor:"windowText",maskFill:"transparent",series:{color:"windowText",lineColor:"windowText"},xAxis:{gridLineColor:"windowText"}},scrollbar:{barBackgroundColor:"#444",barBorderColor:"windowText",buttonArrowColor:"windowText",buttonBackgroundColor:"window",buttonBorderColor:"windowText",rifleColor:"windowText",trackBackgroundColor:"window",trackBorderColor:"windowText"}}}),t(e,"Accessibility/Options/A11yDefaults.js",[],function(){return{accessibility:{enabled:!0,screenReaderSection:{beforeChartFormat:"<{headingTagName}>{chartTitle}</{headingTagName}><div>{typeDescription}</div><div>{chartSubtitle}</div><div>{chartLongdesc}</div><div>{playAsSoundButton}</div><div>{viewTableButton}</div><div>{xAxisDescription}</div><div>{yAxisDescription}</div><div>{annotationsTitle}{annotationsList}</div>",afterChartFormat:"{endOfChartMarker}",axisRangeDateFormat:"%Y-%m-%d %H:%M:%S"},series:{descriptionFormat:"{seriesDescription}{authorDescription}{axisDescription}",describeSingleSeries:!1,pointDescriptionEnabledThreshold:200},point:{valueDescriptionFormat:"{xDescription}{separator}{value}.",describeNull:!0},landmarkVerbosity:"all",linkedDescription:'*[data-highcharts-chart="{index}"] + .highcharts-description',keyboardNavigation:{enabled:!0,focusBorder:{enabled:!0,hideBrowserFocusOutline:!0,style:{color:"#334eff",lineWidth:2,borderRadius:3},margin:2},order:["series","zoom","rangeSelector","navigator","legend","chartMenu"],wrapAround:!0,seriesNavigation:{skipNullPoints:!0,pointNavigationEnabledThreshold:!1,rememberPointFocus:!1}},announceNewData:{enabled:!1,minAnnounceInterval:5e3,interruptUser:!1}},legend:{accessibility:{enabled:!0,keyboardNavigation:{enabled:!0}}},exporting:{accessibility:{enabled:!0}},navigator:{accessibility:{enabled:!0}}}}),t(e,"Accessibility/Options/LangDefaults.js",[],function(){return{accessibility:{defaultChartTitle:"Chart",chartContainerLabel:"{title}. Highcharts interactive chart.",svgContainerLabel:"Interactive chart",drillUpButton:"{buttonText}",credits:"Chart credits: {creditsStr}",thousandsSep:",",svgContainerTitle:"",graphicContainerLabel:"",screenReaderSection:{beforeRegionLabel:"",afterRegionLabel:"",annotations:{heading:"Chart annotations summary",descriptionSinglePoint:"{annotationText}. Related to {annotationPoint}",descriptionMultiplePoints:"{annotationText}. Related to {annotationPoint}{#each additionalAnnotationPoints}, also related to {this}{/each}",descriptionNoPoints:"{annotationText}"},endOfChartMarker:"End of interactive chart."},sonification:{playAsSoundButtonText:"Play as sound, {chartTitle}",playAsSoundClickAnnouncement:"Play"},legend:{legendLabelNoTitle:"Toggle series visibility, {chartTitle}",legendLabel:"Chart legend: {legendTitle}",legendItem:"Show {itemName}"},zoom:{mapZoomIn:"Zoom chart",mapZoomOut:"Zoom out chart",resetZoomButton:"Reset zoom"},rangeSelector:{dropdownLabel:"{rangeTitle}",minInputLabel:"Select start date.",maxInputLabel:"Select end date.",clickButtonAnnouncement:"Viewing {axisRangeDescription}"},navigator:{handleLabel:"{#eq handleIx 0}Start, percent{else}End, percent{/eq}",groupLabel:"Axis zoom",changeAnnouncement:"{axisRangeDescription}"},table:{viewAsDataTableButtonText:"View as data table, {chartTitle}",tableSummary:"Table representation of chart."},announceNewData:{newDataAnnounce:"Updated data for chart {chartTitle}",newSeriesAnnounceSingle:"New data series: {seriesDesc}",newPointAnnounceSingle:"New data point: {pointDesc}",newSeriesAnnounceMultiple:"New data series in chart {chartTitle}: {seriesDesc}",newPointAnnounceMultiple:"New data point in chart {chartTitle}: {pointDesc}"},seriesTypeDescriptions:{boxplot:"Box plot charts are typically used to display groups of statistical data. Each data point in the chart can have up to 5 values: minimum, lower quartile, median, upper quartile, and maximum.",arearange:"Arearange charts are line charts displaying a range between a lower and higher value for each point.",areasplinerange:"These charts are line charts displaying a range between a lower and higher value for each point.",bubble:"Bubble charts are scatter charts where each data point also has a size value.",columnrange:"Columnrange charts are column charts displaying a range between a lower and higher value for each point.",errorbar:"Errorbar series are used to display the variability of the data.",funnel:"Funnel charts are used to display reduction of data in stages.",pyramid:"Pyramid charts consist of a single pyramid with item heights corresponding to each point value.",waterfall:"A waterfall chart is a column chart where each column contributes towards a total end value."},chartTypes:{emptyChart:"Empty chart",mapTypeDescription:"Map of {mapTitle} with {numSeries} data series.",unknownMap:"Map of unspecified region with {numSeries} data series.",combinationChart:"Combination chart with {numSeries} data series.",defaultSingle:"Chart with {numPoints} data {#eq numPoints 1}point{else}points{/eq}.",defaultMultiple:"Chart with {numSeries} data series.",splineSingle:"Line chart with {numPoints} data {#eq numPoints 1}point{else}points{/eq}.",splineMultiple:"Line chart with {numSeries} lines.",lineSingle:"Line chart with {numPoints} data {#eq numPoints 1}point{else}points{/eq}.",lineMultiple:"Line chart with {numSeries} lines.",columnSingle:"Bar chart with {numPoints} {#eq numPoints 1}bar{else}bars{/eq}.",columnMultiple:"Bar chart with {numSeries} data series.",barSingle:"Bar chart with {numPoints} {#eq numPoints 1}bar{else}bars{/eq}.",barMultiple:"Bar chart with {numSeries} data series.",pieSingle:"Pie chart with {numPoints} {#eq numPoints 1}slice{else}slices{/eq}.",pieMultiple:"Pie chart with {numSeries} pies.",scatterSingle:"Scatter chart with {numPoints} {#eq numPoints 1}point{else}points{/eq}.",scatterMultiple:"Scatter chart with {numSeries} data series.",boxplotSingle:"Boxplot with {numPoints} {#eq numPoints 1}box{else}boxes{/eq}.",boxplotMultiple:"Boxplot with {numSeries} data series.",bubbleSingle:"Bubble chart with {numPoints} {#eq numPoints 1}bubbles{else}bubble{/eq}.",bubbleMultiple:"Bubble chart with {numSeries} data series."},axis:{xAxisDescriptionSingular:"The chart has 1 X axis displaying {names[0]}. {ranges[0]}",xAxisDescriptionPlural:"The chart has {numAxes} X axes displaying {#each names}{#unless @first},{/unless}{#if @last} and{/if} {this}{/each}.",yAxisDescriptionSingular:"The chart has 1 Y axis displaying {names[0]}. {ranges[0]}",yAxisDescriptionPlural:"The chart has {numAxes} Y axes displaying {#each names}{#unless @first},{/unless}{#if @last} and{/if} {this}{/each}.",timeRangeDays:"Data range: {range} days.",timeRangeHours:"Data range: {range} hours.",timeRangeMinutes:"Data range: {range} minutes.",timeRangeSeconds:"Data range: {range} seconds.",rangeFromTo:"Data ranges from {rangeFrom} to {rangeTo}.",rangeCategories:"Data range: {numCategories} categories."},exporting:{chartMenuLabel:"Chart menu",menuButtonLabel:"View chart menu, {chartTitle}"},series:{summary:{"default":"{series.name}, series {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.",defaultCombination:"{series.name}, series {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.",line:"{series.name}, line {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.",lineCombination:"{series.name}, series {seriesNumber} of {chart.series.length}. Line with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.",spline:"{series.name}, line {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.",splineCombination:"{series.name}, series {seriesNumber} of {chart.series.length}. Line with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.",column:"{series.name}, bar series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.",columnCombination:"{series.name}, series {seriesNumber} of {chart.series.length}. Bar series with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.",bar:"{series.name}, bar series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.",barCombination:"{series.name}, series {seriesNumber} of {chart.series.length}. Bar series with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.",pie:"{series.name}, pie {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}slice{else}slices{/eq}.",pieCombination:"{series.name}, series {seriesNumber} of {chart.series.length}. Pie with {series.points.length} {#eq series.points.length 1}slice{else}slices{/eq}.",scatter:"{series.name}, scatter plot {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}point{else}points{/eq}.",scatterCombination:"{series.name}, series {seriesNumber} of {chart.series.length}, scatter plot with {series.points.length} {#eq series.points.length 1}point{else}points{/eq}.",boxplot:"{series.name}, boxplot {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}box{else}boxes{/eq}.",boxplotCombination:"{series.name}, series {seriesNumber} of {chart.series.length}. Boxplot with {series.points.length} {#eq series.points.length 1}box{else}boxes{/eq}.",bubble:"{series.name}, bubble series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}.",bubbleCombination:"{series.name}, series {seriesNumber} of {chart.series.length}. Bubble series with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}.",map:"{series.name}, map {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}area{else}areas{/eq}.",mapCombination:"{series.name}, series {seriesNumber} of {chart.series.length}. Map with {series.points.length} {#eq series.points.length 1}area{else}areas{/eq}.",mapline:"{series.name}, line {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.",maplineCombination:"{series.name}, series {seriesNumber} of {chart.series.length}. Line with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.",mapbubble:"{series.name}, bubble series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}.",mapbubbleCombination:"{series.name}, series {seriesNumber} of {chart.series.length}. Bubble series with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}."},description:"{description}",xAxisDescription:"X axis, {name}",yAxisDescription:"Y axis, {name}",nullPointValue:"No value",pointAnnotationsDescription:"{#each annotations}Annotation: {this}{/each}"}}}}),t(e,"Accessibility/Options/DeprecatedOptions.js",[e["Core/Utilities.js"]],function(e){const{error:l,pick:r}=e;function c(e,t,i){let n=e,o,s=0;for(;s<t.length-1;++s)o=t[s],n=n[o]=r(n[o],{});n[t[t.length-1]]=i}function a(i,n,o,s){function e(e,t){return t.reduce(function(e,t){return e[t]},e)}const r=e(i.options,n),a=e(i.options,o);Object.keys(s).forEach(function(e){var t=r[e];void 0!==t&&(c(a,s[e],t),l(32,!1,i,{[n.join(".")+"."+e]:o.join(".")+"."+s[e].join(".")}))})}return function(e){{var t=e;const o=t.options.chart,s=t.options.accessibility||{};["description","typeDescription"].forEach(function(e){o[e]&&(s[e]=o[e],l(32,!1,t,{["chart."+e]:"use accessibility."+e}))})}var i;if((i=e).axes.forEach(function(e){e=e.options;e&&e.description&&(e.accessibility=e.accessibility||{},e.accessibility.description=e.description,l(32,!1,i,{"axis.description":"use axis.accessibility.description"}))}),e.series){var n=e;const r={description:["accessibility","description"],exposeElementToA11y:["accessibility","exposeAsGroupOnly"],pointDescriptionFormatter:["accessibility","point","descriptionFormatter"],skipKeyboardNavigation:["accessibility","keyboardNavigation","enabled"],"accessibility.pointDescriptionFormatter":["accessibility","point","descriptionFormatter"]};n.series.forEach(function(i){Object.keys(r).forEach(function(e){let t=i.options[e];void 0!==(t="accessibility.pointDescriptionFormatter"===e?i.options.accessibility&&i.options.accessibility.pointDescriptionFormatter:t)&&(c(i.options,r[e],"skipKeyboardNavigation"===e?!t:t),l(32,!1,n,{["series."+e]:"series."+r[e].join(".")}))})})}a(e,["accessibility"],["accessibility"],{pointDateFormat:["point","dateFormat"],pointDateFormatter:["point","dateFormatter"],pointDescriptionFormatter:["point","descriptionFormatter"],pointDescriptionThreshold:["series","pointDescriptionEnabledThreshold"],pointNavigationThreshold:["keyboardNavigation","seriesNavigation","pointNavigationEnabledThreshold"],pointValueDecimals:["point","valueDecimals"],pointValuePrefix:["point","valuePrefix"],pointValueSuffix:["point","valueSuffix"],screenReaderSectionFormatter:["screenReaderSection","beforeChartFormatter"],describeSingleSeries:["series","describeSingleSeries"],seriesDescriptionFormatter:["series","descriptionFormatter"],onTableAnchorClick:["screenReaderSection","onViewDataTableClick"],axisRangeDateFormat:["screenReaderSection","axisRangeDateFormat"]}),a(e,["accessibility","keyboardNavigation"],["accessibility","keyboardNavigation","seriesNavigation"],{skipNullPoints:["skipNullPoints"],mode:["mode"]}),a(e,["lang","accessibility"],["lang","accessibility"],{legendItem:["legend","legendItem"],legendLabel:["legend","legendLabel"],mapZoomIn:["zoom","mapZoomIn"],mapZoomOut:["zoom","mapZoomOut"],resetZoomButton:["zoom","resetZoomButton"],screenReaderRegionLabel:["screenReaderSection","beforeRegionLabel"],rangeSelectorButton:["rangeSelector","buttonText"],rangeSelectorMaxInput:["rangeSelector","maxInputLabel"],rangeSelectorMinInput:["rangeSelector","minInputLabel"],svgContainerEnd:["screenReaderSection","endOfChartMarker"],viewAsDataTable:["table","viewAsDataTableButtonText"],tableSummary:["table","tableSummary"]})}}),t(e,"Accessibility/Accessibility.js",[e["Core/Defaults.js"],e["Core/Globals.js"],e["Core/Utilities.js"],e["Accessibility/Utils/HTMLUtilities.js"],e["Accessibility/A11yI18n.js"],e["Accessibility/Components/ContainerComponent.js"],e["Accessibility/FocusBorder.js"],e["Accessibility/Components/InfoRegionsComponent.js"],e["Accessibility/KeyboardNavigation.js"],e["Accessibility/Components/LegendComponent.js"],e["Accessibility/Components/MenuComponent.js"],e["Accessibility/Components/NavigatorComponent.js"],e["Accessibility/Components/SeriesComponent/NewDataAnnouncer.js"],e["Accessibility/ProxyProvider.js"],e["Accessibility/Components/RangeSelectorComponent.js"],e["Accessibility/Components/SeriesComponent/SeriesComponent.js"],e["Accessibility/Components/ZoomComponent.js"],e["Accessibility/HighContrastMode.js"],e["Accessibility/HighContrastTheme.js"],e["Accessibility/Options/A11yDefaults.js"],e["Accessibility/Options/LangDefaults.js"],e["Accessibility/Options/DeprecatedOptions.js"]],function(e,t,i,n,r,o,a,s,l,c,h,d,u,p,g,m,b,x,v,y,f,A){var w,e=e["defaultOptions"];const{composed:C,doc:E}=t,{addEvent:T,extend:M,fireEvent:S,merge:k,pushUnique:P}=i,D=n["removeElement"];class B{constructor(e){this.init(e)}init(e){this.chart=e,E.addEventListener?(A(e),this.proxyProvider=new p(this.chart),this.initComponents(),this.keyboardNavigation=new l(e,this.components)):(this.zombie=!0,this.components={},e.renderTo.setAttribute("aria-hidden",!0))}initComponents(){const t=this.chart,i=this.proxyProvider;var e=t.options.accessibility;this.components={container:new o,infoRegions:new s,legend:new c,chartMenu:new h,rangeSelector:new g,series:new m,zoom:new b,navigator:new d},e.customComponents&&M(this.components,e.customComponents);const n=this.components;this.getComponentOrder().forEach(function(e){n[e].initBase(t,i),n[e].init()})}getComponentOrder(){var e;return this.components?this.components.series?(e=Object.keys(this.components).filter(e=>"series"!==e),["series"].concat(e)):Object.keys(this.components):[]}update(){const t=this.components,i=this.chart,e=i.options.accessibility;S(i,"beforeA11yUpdate"),i.types=this.getChartTypes();var n=e.keyboardNavigation.order;this.proxyProvider.updateGroupOrder(n),this.getComponentOrder().forEach(function(e){t[e].onChartUpdate(),S(i,"afterA11yComponentUpdate",{name:e,component:t[e]})}),this.keyboardNavigation.update(n),!i.highContrastModeActive&&x.isHighContrastModeActive()&&x.setHighContrastTheme(i),S(i,"afterA11yUpdate",{accessibility:this})}destroy(){var e=this.chart||{};const t=this.components;Object.keys(t).forEach(function(e){t[e].destroy(),t[e].destroyBase()}),this.proxyProvider&&this.proxyProvider.destroy(),e.announcerContainer&&D(e.announcerContainer),this.keyboardNavigation&&this.keyboardNavigation.destroy(),e.renderTo&&e.renderTo.setAttribute("aria-hidden",!0),e.focusElement&&e.focusElement.removeFocusBorder()}getChartTypes(){const t={};return this.chart.series.forEach(function(e){t[e.type]=1}),Object.keys(t)}}function N(){this.accessibility&&this.accessibility.destroy()}function I(){this.a11yDirty&&this.renderTo&&(delete this.a11yDirty,this.updateA11yEnabled());const t=this.accessibility;t&&!t.zombie&&(t.proxyProvider.updateProxyElementPositions(),t.getComponentOrder().forEach(function(e){t.components[e].onChartRender()}))}function j(e){e=e.options.accessibility;e&&(e.customComponents&&(this.options.accessibility.customComponents=e.customComponents,delete e.customComponents),k(!0,this.options.accessibility,e),this.accessibility)&&this.accessibility.destroy&&(this.accessibility.destroy(),delete this.accessibility),this.a11yDirty=!0}function O(){let e=this.accessibility;var t=this.options.accessibility;t&&t.enabled?(e&&!e.zombie||(this.accessibility=e=new w(this),e&&!e.zombie))&&e.update():e?(e.destroy&&e.destroy(),delete this.accessibility):this.renderTo.setAttribute("aria-hidden",!0)}function L(){this.series.chart.accessibility&&(this.series.chart.a11yDirty=!0)}return(w=B=B||{}).i18nFormat=r.i18nFormat,w.compose=function F(t,e,i,n,o,s){l.compose(t),u.compose(n),c.compose(t,e),h.compose(t),m.compose(t,i,n),r.compose(t),a.compose(t,o),s&&g.compose(t,s),P(C,F)&&(t.prototype.updateA11yEnabled=O,T(t,"destroy",N),T(t,"render",I),T(t,"update",j),["addSeries","init"].forEach(e=>{T(t,e,function(){this.a11yDirty=!0})}),["afterApplyDrilldown","drillupall"].forEach(e=>{T(t,e,function(){var e=this.accessibility;e&&!e.zombie&&e.update()})}),T(i,"update",L),["update","updatedData","remove"].forEach(e=>{T(n,e,function(){this.chart.accessibility&&(this.chart.a11yDirty=!0)})}))},k(!0,e,y,{accessibility:{highContrastTheme:v},lang:f}),B}),t(e,"masters/modules/accessibility.src.js",[e["Core/Globals.js"],e["Accessibility/Accessibility.js"],e["Accessibility/AccessibilityComponent.js"],e["Accessibility/Utils/ChartUtilities.js"],e["Accessibility/Utils/HTMLUtilities.js"],e["Accessibility/KeyboardNavigationHandler.js"],e["Accessibility/Components/SeriesComponent/SeriesDescriber.js"]],function(e,t,i,n,o,s,r){e.i18nFormat=t.i18nFormat,e.A11yChartUtilities=n,e.A11yHTMLUtilities=o,e.AccessibilityComponent=i,e.KeyboardNavigationHandler=s,e.SeriesAccessibilityDescriber=r,t.compose(e.Chart,e.Legend,e.Point,e.Series,e.SVGElement,e.RangeSelector)})});
//# sourceMappingURL=accessibility.js.map;
(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var PortfolioDetailMiniChart = /*#__PURE__*/function () {
  function PortfolioDetailMiniChart(moduleId) {
    _classCallCheck(this, PortfolioDetailMiniChart);
    this.chartModule = window.fcom.moduleHandler.initModule(document.getElementById(moduleId));
    this.portfolioId = document.getElementById('portfolioDetailMiniChartContent').dataset.pfid;
    this.initChart();
  }
  _createClass(PortfolioDetailMiniChart, [{
    key: "initChart",
    value: function initChart() {
      var _this = this;
      this.chartModule.then(function (chartContainer) {
        chartContainer.setPortfolioId(_this.portfolioId);
        chartContainer.setPortfolioValueType(2, 'Earnings');
      });
    }
  }]);
  return PortfolioDetailMiniChart;
}();
window.ngpNamespace('fcom.portfolio.portfolioDetailMiniChart');
window.fcom.portfolio.portfolioDetailMiniChart.init = function (moduleId) {
  return new PortfolioDetailMiniChart(moduleId);
};

},{}]},{},[1]);
